
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0737"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0737"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9fhap", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6bb2d4c7963fe6c1$export$ffb0004e005737fa; }, function (v) { return $6bb2d4c7963fe6c1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $6bb2d4c7963fe6c1$export$34b9dba7ce09269b; }, function (v) { return $6bb2d4c7963fe6c1$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $6bb2d4c7963fe6c1$export$25062201e9e25d76; }, function (v) { return $6bb2d4c7963fe6c1$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6bb2d4c7963fe6c1$export$ffb0004e005737fa;
var $6bb2d4c7963fe6c1$export$34b9dba7ce09269b;
var $6bb2d4c7963fe6c1$export$25062201e9e25d76;
"use strict";
var $6bb2d4c7963fe6c1$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6bb2d4c7963fe6c1$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $6bb2d4c7963fe6c1$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $6bb2d4c7963fe6c1$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$6bb2d4c7963fe6c1$export$ffb0004e005737fa = $6bb2d4c7963fe6c1$var$REACT_FRAGMENT_TYPE;
$6bb2d4c7963fe6c1$export$34b9dba7ce09269b = $6bb2d4c7963fe6c1$var$jsxProd;
$6bb2d4c7963fe6c1$export$25062201e9e25d76 = $6bb2d4c7963fe6c1$var$jsxProd;

});

parcelRegister("1zEgY", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $12584cae6930e094$export$882461b6382ed46c; }, function (v) { return $12584cae6930e094$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $12584cae6930e094$export$757ceba2d55c277e; }, function (v) { return $12584cae6930e094$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $12584cae6930e094$export$83d89fbfd8236492; }, function (v) { return $12584cae6930e094$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $12584cae6930e094$export$882461b6382ed46c;
var $12584cae6930e094$export$757ceba2d55c277e;
var $12584cae6930e094$export$83d89fbfd8236492;
"use strict";

var $8IBEr = parcelRequire("8IBEr");

var $lCzvA = parcelRequire("lCzvA");

var $dAQd3 = parcelRequire("dAQd3");
function $12584cae6930e094$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $12584cae6930e094$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $12584cae6930e094$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $12584cae6930e094$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $12584cae6930e094$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $12584cae6930e094$var$assertIsMounted(fiber) {
    if ($12584cae6930e094$var$getNearestMountedFiber(fiber) !== fiber) throw Error($12584cae6930e094$var$formatProdErrorMessage(188));
}
function $12584cae6930e094$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $12584cae6930e094$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($12584cae6930e094$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $12584cae6930e094$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $12584cae6930e094$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($12584cae6930e094$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($12584cae6930e094$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($12584cae6930e094$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($12584cae6930e094$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $12584cae6930e094$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $12584cae6930e094$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $12584cae6930e094$var$assign = Object.assign, $12584cae6930e094$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $12584cae6930e094$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $12584cae6930e094$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $12584cae6930e094$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $12584cae6930e094$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $12584cae6930e094$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $12584cae6930e094$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $12584cae6930e094$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $12584cae6930e094$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $12584cae6930e094$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $12584cae6930e094$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $12584cae6930e094$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $12584cae6930e094$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $12584cae6930e094$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $12584cae6930e094$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $12584cae6930e094$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $12584cae6930e094$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $12584cae6930e094$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$12584cae6930e094$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $12584cae6930e094$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $12584cae6930e094$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $12584cae6930e094$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $12584cae6930e094$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $12584cae6930e094$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $12584cae6930e094$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $12584cae6930e094$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $12584cae6930e094$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $12584cae6930e094$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $12584cae6930e094$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $12584cae6930e094$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $12584cae6930e094$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $12584cae6930e094$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $12584cae6930e094$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $12584cae6930e094$var$getComponentNameFromType(type.type) || "Memo";
        case $12584cae6930e094$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $12584cae6930e094$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $12584cae6930e094$var$isArrayImpl = Array.isArray, $12584cae6930e094$var$ReactSharedInternals = $lCzvA.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $12584cae6930e094$var$ReactDOMSharedInternals = $dAQd3.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $12584cae6930e094$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $12584cae6930e094$var$valueStack = [], $12584cae6930e094$var$index = -1;
function $12584cae6930e094$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $12584cae6930e094$var$pop(cursor) {
    0 > $12584cae6930e094$var$index || (cursor.current = $12584cae6930e094$var$valueStack[$12584cae6930e094$var$index], $12584cae6930e094$var$valueStack[$12584cae6930e094$var$index] = null, $12584cae6930e094$var$index--);
}
function $12584cae6930e094$var$push(cursor, value) {
    $12584cae6930e094$var$index++;
    $12584cae6930e094$var$valueStack[$12584cae6930e094$var$index] = cursor.current;
    cursor.current = value;
}
var $12584cae6930e094$var$contextStackCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$contextFiberStackCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$rootInstanceStackCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$hostTransitionProviderCursor = $12584cae6930e094$var$createCursor(null);
function $12584cae6930e094$var$pushHostContainer(fiber, nextRootInstance) {
    $12584cae6930e094$var$push($12584cae6930e094$var$rootInstanceStackCursor, nextRootInstance);
    $12584cae6930e094$var$push($12584cae6930e094$var$contextFiberStackCursor, fiber);
    $12584cae6930e094$var$push($12584cae6930e094$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $12584cae6930e094$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $12584cae6930e094$var$getOwnHostContext(nextRootInstance), fiber = $12584cae6930e094$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $12584cae6930e094$var$pop($12584cae6930e094$var$contextStackCursor);
    $12584cae6930e094$var$push($12584cae6930e094$var$contextStackCursor, fiber);
}
function $12584cae6930e094$var$popHostContainer() {
    $12584cae6930e094$var$pop($12584cae6930e094$var$contextStackCursor);
    $12584cae6930e094$var$pop($12584cae6930e094$var$contextFiberStackCursor);
    $12584cae6930e094$var$pop($12584cae6930e094$var$rootInstanceStackCursor);
}
function $12584cae6930e094$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $12584cae6930e094$var$push($12584cae6930e094$var$hostTransitionProviderCursor, fiber);
    var context = $12584cae6930e094$var$contextStackCursor.current;
    var JSCompiler_inline_result = $12584cae6930e094$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($12584cae6930e094$var$push($12584cae6930e094$var$contextFiberStackCursor, fiber), $12584cae6930e094$var$push($12584cae6930e094$var$contextStackCursor, JSCompiler_inline_result));
}
function $12584cae6930e094$var$popHostContext(fiber) {
    $12584cae6930e094$var$contextFiberStackCursor.current === fiber && ($12584cae6930e094$var$pop($12584cae6930e094$var$contextStackCursor), $12584cae6930e094$var$pop($12584cae6930e094$var$contextFiberStackCursor));
    $12584cae6930e094$var$hostTransitionProviderCursor.current === fiber && ($12584cae6930e094$var$pop($12584cae6930e094$var$hostTransitionProviderCursor), $12584cae6930e094$var$HostTransitionContext._currentValue = $12584cae6930e094$var$sharedNotPendingObject);
}
var $12584cae6930e094$var$prefix, $12584cae6930e094$var$suffix;
function $12584cae6930e094$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $12584cae6930e094$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $12584cae6930e094$var$prefix = match && match[1] || "";
        $12584cae6930e094$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $12584cae6930e094$var$prefix + name + $12584cae6930e094$var$suffix;
}
var $12584cae6930e094$var$reentry = !1;
function $12584cae6930e094$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $12584cae6930e094$var$reentry) return "";
    $12584cae6930e094$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $12584cae6930e094$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $12584cae6930e094$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $12584cae6930e094$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $12584cae6930e094$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $12584cae6930e094$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $12584cae6930e094$var$describeBuiltInComponentFrame("Suspense Fallback") : $12584cae6930e094$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $12584cae6930e094$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $12584cae6930e094$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $12584cae6930e094$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $12584cae6930e094$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $12584cae6930e094$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $12584cae6930e094$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $12584cae6930e094$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $12584cae6930e094$var$hasOwnProperty = Object.prototype.hasOwnProperty, $12584cae6930e094$var$scheduleCallback$3 = $8IBEr.unstable_scheduleCallback, $12584cae6930e094$var$cancelCallback$1 = $8IBEr.unstable_cancelCallback, $12584cae6930e094$var$shouldYield = $8IBEr.unstable_shouldYield, $12584cae6930e094$var$requestPaint = $8IBEr.unstable_requestPaint, $12584cae6930e094$var$now = $8IBEr.unstable_now, $12584cae6930e094$var$getCurrentPriorityLevel = $8IBEr.unstable_getCurrentPriorityLevel, $12584cae6930e094$var$ImmediatePriority = $8IBEr.unstable_ImmediatePriority, $12584cae6930e094$var$UserBlockingPriority = $8IBEr.unstable_UserBlockingPriority, $12584cae6930e094$var$NormalPriority$1 = $8IBEr.unstable_NormalPriority, $12584cae6930e094$var$LowPriority = $8IBEr.unstable_LowPriority, $12584cae6930e094$var$IdlePriority = $8IBEr.unstable_IdlePriority, $12584cae6930e094$var$log$1 = $8IBEr.log, $12584cae6930e094$var$unstable_setDisableYieldValue = $8IBEr.unstable_setDisableYieldValue, $12584cae6930e094$var$rendererID = null, $12584cae6930e094$var$injectedHook = null;
function $12584cae6930e094$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $12584cae6930e094$var$log$1 && $12584cae6930e094$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($12584cae6930e094$var$injectedHook && "function" === typeof $12584cae6930e094$var$injectedHook.setStrictMode) try {
        $12584cae6930e094$var$injectedHook.setStrictMode($12584cae6930e094$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $12584cae6930e094$var$clz32 = Math.clz32 ? Math.clz32 : $12584cae6930e094$var$clz32Fallback, $12584cae6930e094$var$log = Math.log, $12584cae6930e094$var$LN2 = Math.LN2;
function $12584cae6930e094$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($12584cae6930e094$var$log(x) / $12584cae6930e094$var$LN2 | 0) | 0;
}
var $12584cae6930e094$var$nextTransitionUpdateLane = 256, $12584cae6930e094$var$nextTransitionDeferredLane = 262144, $12584cae6930e094$var$nextRetryLane = 4194304;
function $12584cae6930e094$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $12584cae6930e094$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $12584cae6930e094$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $12584cae6930e094$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $12584cae6930e094$var$claimNextRetryLane() {
    var lane = $12584cae6930e094$var$nextRetryLane;
    $12584cae6930e094$var$nextRetryLane <<= 1;
    0 === ($12584cae6930e094$var$nextRetryLane & 62914560) && ($12584cae6930e094$var$nextRetryLane = 4194304);
    return lane;
}
function $12584cae6930e094$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $12584cae6930e094$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $12584cae6930e094$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $12584cae6930e094$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $12584cae6930e094$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $12584cae6930e094$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $12584cae6930e094$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $12584cae6930e094$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $12584cae6930e094$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $12584cae6930e094$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $12584cae6930e094$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $12584cae6930e094$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $12584cae6930e094$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $12584cae6930e094$var$resolveUpdatePriority() {
    var updatePriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $12584cae6930e094$var$getEventPriority(updatePriority.type);
}
function $12584cae6930e094$var$runWithPriority(priority, fn) {
    var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    try {
        return $12584cae6930e094$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $12584cae6930e094$var$randomKey = Math.random().toString(36).slice(2), $12584cae6930e094$var$internalInstanceKey = "__reactFiber$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalPropsKey = "__reactProps$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalContainerInstanceKey = "__reactContainer$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalEventHandlersKey = "__reactEvents$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalEventHandlerListenersKey = "__reactListeners$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalEventHandlesSetKey = "__reactHandles$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalRootNodeResourcesKey = "__reactResources$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalHoistableMarker = "__reactMarker$" + $12584cae6930e094$var$randomKey;
function $12584cae6930e094$var$detachDeletedInstance(node) {
    delete node[$12584cae6930e094$var$internalInstanceKey];
    delete node[$12584cae6930e094$var$internalPropsKey];
    delete node[$12584cae6930e094$var$internalEventHandlersKey];
    delete node[$12584cae6930e094$var$internalEventHandlerListenersKey];
    delete node[$12584cae6930e094$var$internalEventHandlesSetKey];
}
function $12584cae6930e094$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$12584cae6930e094$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$12584cae6930e094$var$internalContainerInstanceKey] || parentNode[$12584cae6930e094$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $12584cae6930e094$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$12584cae6930e094$var$internalInstanceKey]) return parentNode;
                targetNode = $12584cae6930e094$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $12584cae6930e094$var$getInstanceFromNode(node) {
    if (node = node[$12584cae6930e094$var$internalInstanceKey] || node[$12584cae6930e094$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $12584cae6930e094$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($12584cae6930e094$var$formatProdErrorMessage(33));
}
function $12584cae6930e094$var$getResourcesFromRoot(root) {
    var resources = root[$12584cae6930e094$var$internalRootNodeResourcesKey];
    resources || (resources = root[$12584cae6930e094$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $12584cae6930e094$var$markNodeAsHoistable(node) {
    node[$12584cae6930e094$var$internalHoistableMarker] = !0;
}
var $12584cae6930e094$var$allNativeEvents = new Set(), $12584cae6930e094$var$registrationNameDependencies = {};
function $12584cae6930e094$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $12584cae6930e094$var$registerDirectEvent(registrationName, dependencies);
    $12584cae6930e094$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $12584cae6930e094$var$registerDirectEvent(registrationName, dependencies) {
    $12584cae6930e094$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$12584cae6930e094$var$allNativeEvents.add(dependencies[registrationName]);
}
var $12584cae6930e094$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $12584cae6930e094$var$illegalAttributeNameCache = {}, $12584cae6930e094$var$validatedAttributeNameCache = {};
function $12584cae6930e094$var$isAttributeNameSafe(attributeName) {
    if ($12584cae6930e094$var$hasOwnProperty.call($12584cae6930e094$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($12584cae6930e094$var$hasOwnProperty.call($12584cae6930e094$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($12584cae6930e094$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $12584cae6930e094$var$validatedAttributeNameCache[attributeName] = !0;
    $12584cae6930e094$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $12584cae6930e094$var$setValueForAttribute(node, name, value) {
    if ($12584cae6930e094$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $12584cae6930e094$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $12584cae6930e094$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $12584cae6930e094$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $12584cae6930e094$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $12584cae6930e094$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $12584cae6930e094$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $12584cae6930e094$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $12584cae6930e094$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $12584cae6930e094$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $12584cae6930e094$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $12584cae6930e094$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $12584cae6930e094$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $12584cae6930e094$var$getToStringValue(value);
        } else element.value !== "" + $12584cae6930e094$var$getToStringValue(value) && (element.value = "" + $12584cae6930e094$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $12584cae6930e094$var$setDefaultValue(element, type, $12584cae6930e094$var$getToStringValue(value)) : null != defaultValue ? $12584cae6930e094$var$setDefaultValue(element, type, $12584cae6930e094$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $12584cae6930e094$var$getToStringValue(name) : element.removeAttribute("name");
}
function $12584cae6930e094$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $12584cae6930e094$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $12584cae6930e094$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $12584cae6930e094$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $12584cae6930e094$var$track(element);
}
function $12584cae6930e094$var$setDefaultValue(node, type, value) {
    "number" === type && $12584cae6930e094$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $12584cae6930e094$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $12584cae6930e094$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $12584cae6930e094$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $12584cae6930e094$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $12584cae6930e094$var$getToStringValue(defaultValue) : "";
}
function $12584cae6930e094$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($12584cae6930e094$var$formatProdErrorMessage(92));
            if ($12584cae6930e094$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($12584cae6930e094$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $12584cae6930e094$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $12584cae6930e094$var$track(element);
}
function $12584cae6930e094$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $12584cae6930e094$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $12584cae6930e094$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $12584cae6930e094$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $12584cae6930e094$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($12584cae6930e094$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $12584cae6930e094$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $12584cae6930e094$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $12584cae6930e094$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $12584cae6930e094$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $12584cae6930e094$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $12584cae6930e094$var$sanitizeURL(url) {
    return $12584cae6930e094$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $12584cae6930e094$var$noop$1() {}
var $12584cae6930e094$var$currentReplayingEvent = null;
function $12584cae6930e094$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $12584cae6930e094$var$restoreTarget = null, $12584cae6930e094$var$restoreQueue = null;
function $12584cae6930e094$var$restoreStateOfTarget(target) {
    var internalInstance = $12584cae6930e094$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$12584cae6930e094$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $12584cae6930e094$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$12584cae6930e094$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($12584cae6930e094$var$formatProdErrorMessage(90));
                            $12584cae6930e094$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $12584cae6930e094$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $12584cae6930e094$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $12584cae6930e094$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $12584cae6930e094$var$isInsideEventHandler = !1;
function $12584cae6930e094$var$batchedUpdates$1(fn, a, b) {
    if ($12584cae6930e094$var$isInsideEventHandler) return fn(a, b);
    $12584cae6930e094$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($12584cae6930e094$var$isInsideEventHandler = !1, null !== $12584cae6930e094$var$restoreTarget || null !== $12584cae6930e094$var$restoreQueue) {
            if ($12584cae6930e094$var$flushSyncWork$1(), $12584cae6930e094$var$restoreTarget && (a = $12584cae6930e094$var$restoreTarget, fn = $12584cae6930e094$var$restoreQueue, $12584cae6930e094$var$restoreQueue = $12584cae6930e094$var$restoreTarget = null, $12584cae6930e094$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$12584cae6930e094$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $12584cae6930e094$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$12584cae6930e094$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($12584cae6930e094$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $12584cae6930e094$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $12584cae6930e094$var$passiveBrowserEventsSupported = !1;
if ($12584cae6930e094$var$canUseDOM) try {
    var $12584cae6930e094$var$options = {};
    Object.defineProperty($12584cae6930e094$var$options, "passive", {
        get: function() {
            $12584cae6930e094$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $12584cae6930e094$var$options, $12584cae6930e094$var$options);
    window.removeEventListener("test", $12584cae6930e094$var$options, $12584cae6930e094$var$options);
} catch (e) {
    $12584cae6930e094$var$passiveBrowserEventsSupported = !1;
}
var $12584cae6930e094$var$root = null, $12584cae6930e094$var$startText = null, $12584cae6930e094$var$fallbackText = null;
function $12584cae6930e094$var$getData() {
    if ($12584cae6930e094$var$fallbackText) return $12584cae6930e094$var$fallbackText;
    var start, startValue = $12584cae6930e094$var$startText, startLength = startValue.length, end, endValue = "value" in $12584cae6930e094$var$root ? $12584cae6930e094$var$root.value : $12584cae6930e094$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $12584cae6930e094$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $12584cae6930e094$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $12584cae6930e094$var$functionThatReturnsTrue() {
    return !0;
}
function $12584cae6930e094$var$functionThatReturnsFalse() {
    return !1;
}
function $12584cae6930e094$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $12584cae6930e094$var$functionThatReturnsTrue : $12584cae6930e094$var$functionThatReturnsFalse;
        this.isPropagationStopped = $12584cae6930e094$var$functionThatReturnsFalse;
        return this;
    }
    $12584cae6930e094$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $12584cae6930e094$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $12584cae6930e094$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $12584cae6930e094$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $12584cae6930e094$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $12584cae6930e094$var$SyntheticEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$EventInterface), $12584cae6930e094$var$UIEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    view: 0,
    detail: 0
}), $12584cae6930e094$var$SyntheticUIEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$UIEventInterface), $12584cae6930e094$var$lastMovementX, $12584cae6930e094$var$lastMovementY, $12584cae6930e094$var$lastMouseEvent, $12584cae6930e094$var$MouseEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $12584cae6930e094$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $12584cae6930e094$var$lastMouseEvent && ($12584cae6930e094$var$lastMouseEvent && "mousemove" === event.type ? ($12584cae6930e094$var$lastMovementX = event.screenX - $12584cae6930e094$var$lastMouseEvent.screenX, $12584cae6930e094$var$lastMovementY = event.screenY - $12584cae6930e094$var$lastMouseEvent.screenY) : $12584cae6930e094$var$lastMovementY = $12584cae6930e094$var$lastMovementX = 0, $12584cae6930e094$var$lastMouseEvent = event);
        return $12584cae6930e094$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $12584cae6930e094$var$lastMovementY;
    }
}), $12584cae6930e094$var$SyntheticMouseEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$MouseEventInterface), $12584cae6930e094$var$DragEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$MouseEventInterface, {
    dataTransfer: 0
}), $12584cae6930e094$var$SyntheticDragEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$DragEventInterface), $12584cae6930e094$var$FocusEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$UIEventInterface, {
    relatedTarget: 0
}), $12584cae6930e094$var$SyntheticFocusEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$FocusEventInterface), $12584cae6930e094$var$AnimationEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $12584cae6930e094$var$SyntheticAnimationEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$AnimationEventInterface), $12584cae6930e094$var$ClipboardEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $12584cae6930e094$var$SyntheticClipboardEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$ClipboardEventInterface), $12584cae6930e094$var$CompositionEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    data: 0
}), $12584cae6930e094$var$SyntheticCompositionEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$CompositionEventInterface), $12584cae6930e094$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $12584cae6930e094$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $12584cae6930e094$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $12584cae6930e094$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $12584cae6930e094$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $12584cae6930e094$var$getEventModifierState() {
    return $12584cae6930e094$var$modifierStateGetter;
}
var $12584cae6930e094$var$KeyboardEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $12584cae6930e094$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $12584cae6930e094$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $12584cae6930e094$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $12584cae6930e094$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $12584cae6930e094$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $12584cae6930e094$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $12584cae6930e094$var$SyntheticKeyboardEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$KeyboardEventInterface), $12584cae6930e094$var$PointerEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $12584cae6930e094$var$SyntheticPointerEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$PointerEventInterface), $12584cae6930e094$var$TouchEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $12584cae6930e094$var$getEventModifierState
}), $12584cae6930e094$var$SyntheticTouchEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$TouchEventInterface), $12584cae6930e094$var$TransitionEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $12584cae6930e094$var$SyntheticTransitionEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$TransitionEventInterface), $12584cae6930e094$var$WheelEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $12584cae6930e094$var$SyntheticWheelEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$WheelEventInterface), $12584cae6930e094$var$ToggleEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $12584cae6930e094$var$SyntheticToggleEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$ToggleEventInterface), $12584cae6930e094$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $12584cae6930e094$var$canUseCompositionEvent = $12584cae6930e094$var$canUseDOM && "CompositionEvent" in window, $12584cae6930e094$var$documentMode = null;
$12584cae6930e094$var$canUseDOM && "documentMode" in document && ($12584cae6930e094$var$documentMode = document.documentMode);
var $12584cae6930e094$var$canUseTextInputEvent = $12584cae6930e094$var$canUseDOM && "TextEvent" in window && !$12584cae6930e094$var$documentMode, $12584cae6930e094$var$useFallbackCompositionData = $12584cae6930e094$var$canUseDOM && (!$12584cae6930e094$var$canUseCompositionEvent || $12584cae6930e094$var$documentMode && 8 < $12584cae6930e094$var$documentMode && 11 >= $12584cae6930e094$var$documentMode), $12584cae6930e094$var$SPACEBAR_CHAR = String.fromCharCode(32), $12584cae6930e094$var$hasSpaceKeypress = !1;
function $12584cae6930e094$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $12584cae6930e094$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $12584cae6930e094$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $12584cae6930e094$var$isComposing = !1;
function $12584cae6930e094$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $12584cae6930e094$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $12584cae6930e094$var$hasSpaceKeypress = !0;
            return $12584cae6930e094$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $12584cae6930e094$var$SPACEBAR_CHAR && $12584cae6930e094$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $12584cae6930e094$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($12584cae6930e094$var$isComposing) return "compositionend" === domEventName || !$12584cae6930e094$var$canUseCompositionEvent && $12584cae6930e094$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $12584cae6930e094$var$getData(), $12584cae6930e094$var$fallbackText = $12584cae6930e094$var$startText = $12584cae6930e094$var$root = null, $12584cae6930e094$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $12584cae6930e094$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $12584cae6930e094$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $12584cae6930e094$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$12584cae6930e094$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $12584cae6930e094$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $12584cae6930e094$var$restoreTarget ? $12584cae6930e094$var$restoreQueue ? $12584cae6930e094$var$restoreQueue.push(target) : $12584cae6930e094$var$restoreQueue = [
        target
    ] : $12584cae6930e094$var$restoreTarget = target;
    inst = $12584cae6930e094$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $12584cae6930e094$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $12584cae6930e094$var$activeElement$1 = null, $12584cae6930e094$var$activeElementInst$1 = null;
function $12584cae6930e094$var$runEventInBatch(dispatchQueue) {
    $12584cae6930e094$var$processDispatchQueue(dispatchQueue, 0);
}
function $12584cae6930e094$var$getInstIfValueChanged(targetInst) {
    var targetNode = $12584cae6930e094$var$getNodeFromInstance(targetInst);
    if ($12584cae6930e094$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $12584cae6930e094$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $12584cae6930e094$var$isInputEventSupported = !1;
if ($12584cae6930e094$var$canUseDOM) {
    var $12584cae6930e094$var$JSCompiler_inline_result$jscomp$286;
    if ($12584cae6930e094$var$canUseDOM) {
        var $12584cae6930e094$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$12584cae6930e094$var$isSupported$jscomp$inline_427) {
            var $12584cae6930e094$var$element$jscomp$inline_428 = document.createElement("div");
            $12584cae6930e094$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $12584cae6930e094$var$isSupported$jscomp$inline_427 = "function" === typeof $12584cae6930e094$var$element$jscomp$inline_428.oninput;
        }
        $12584cae6930e094$var$JSCompiler_inline_result$jscomp$286 = $12584cae6930e094$var$isSupported$jscomp$inline_427;
    } else $12584cae6930e094$var$JSCompiler_inline_result$jscomp$286 = !1;
    $12584cae6930e094$var$isInputEventSupported = $12584cae6930e094$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $12584cae6930e094$var$stopWatchingForValueChange() {
    $12584cae6930e094$var$activeElement$1 && ($12584cae6930e094$var$activeElement$1.detachEvent("onpropertychange", $12584cae6930e094$var$handlePropertyChange), $12584cae6930e094$var$activeElementInst$1 = $12584cae6930e094$var$activeElement$1 = null);
}
function $12584cae6930e094$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $12584cae6930e094$var$getInstIfValueChanged($12584cae6930e094$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $12584cae6930e094$var$createAndAccumulateChangeEvent(dispatchQueue, $12584cae6930e094$var$activeElementInst$1, nativeEvent, $12584cae6930e094$var$getEventTarget(nativeEvent));
        $12584cae6930e094$var$batchedUpdates$1($12584cae6930e094$var$runEventInBatch, dispatchQueue);
    }
}
function $12584cae6930e094$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($12584cae6930e094$var$stopWatchingForValueChange(), $12584cae6930e094$var$activeElement$1 = target, $12584cae6930e094$var$activeElementInst$1 = targetInst, $12584cae6930e094$var$activeElement$1.attachEvent("onpropertychange", $12584cae6930e094$var$handlePropertyChange)) : "focusout" === domEventName && $12584cae6930e094$var$stopWatchingForValueChange();
}
function $12584cae6930e094$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $12584cae6930e094$var$getInstIfValueChanged($12584cae6930e094$var$activeElementInst$1);
}
function $12584cae6930e094$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $12584cae6930e094$var$getInstIfValueChanged(targetInst);
}
function $12584cae6930e094$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $12584cae6930e094$var$getInstIfValueChanged(targetInst);
}
function $12584cae6930e094$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $12584cae6930e094$var$objectIs = "function" === typeof Object.is ? Object.is : $12584cae6930e094$var$is;
function $12584cae6930e094$var$shallowEqual(objA, objB) {
    if ($12584cae6930e094$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$12584cae6930e094$var$hasOwnProperty.call(objB, currentKey) || !$12584cae6930e094$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $12584cae6930e094$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $12584cae6930e094$var$getNodeForCharacterOffset(root, offset) {
    var node = $12584cae6930e094$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $12584cae6930e094$var$getLeafNode(node);
    }
}
function $12584cae6930e094$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $12584cae6930e094$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $12584cae6930e094$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $12584cae6930e094$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $12584cae6930e094$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $12584cae6930e094$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $12584cae6930e094$var$skipSelectionChangeEvent = $12584cae6930e094$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $12584cae6930e094$var$activeElement = null, $12584cae6930e094$var$activeElementInst = null, $12584cae6930e094$var$lastSelection = null, $12584cae6930e094$var$mouseDown = !1;
function $12584cae6930e094$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $12584cae6930e094$var$mouseDown || null == $12584cae6930e094$var$activeElement || $12584cae6930e094$var$activeElement !== $12584cae6930e094$var$getActiveElement(doc) || (doc = $12584cae6930e094$var$activeElement, "selectionStart" in doc && $12584cae6930e094$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $12584cae6930e094$var$lastSelection && $12584cae6930e094$var$shallowEqual($12584cae6930e094$var$lastSelection, doc) || ($12584cae6930e094$var$lastSelection = doc, doc = $12584cae6930e094$var$accumulateTwoPhaseListeners($12584cae6930e094$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $12584cae6930e094$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $12584cae6930e094$var$activeElement)));
}
function $12584cae6930e094$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $12584cae6930e094$var$vendorPrefixes = {
    animationend: $12584cae6930e094$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $12584cae6930e094$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $12584cae6930e094$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $12584cae6930e094$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $12584cae6930e094$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $12584cae6930e094$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $12584cae6930e094$var$makePrefixMap("Transition", "TransitionEnd")
}, $12584cae6930e094$var$prefixedEventNames = {}, $12584cae6930e094$var$style = {};
$12584cae6930e094$var$canUseDOM && ($12584cae6930e094$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $12584cae6930e094$var$vendorPrefixes.animationend.animation, delete $12584cae6930e094$var$vendorPrefixes.animationiteration.animation, delete $12584cae6930e094$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $12584cae6930e094$var$vendorPrefixes.transitionend.transition);
function $12584cae6930e094$var$getVendorPrefixedEventName(eventName) {
    if ($12584cae6930e094$var$prefixedEventNames[eventName]) return $12584cae6930e094$var$prefixedEventNames[eventName];
    if (!$12584cae6930e094$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $12584cae6930e094$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $12584cae6930e094$var$style) return $12584cae6930e094$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $12584cae6930e094$var$ANIMATION_END = $12584cae6930e094$var$getVendorPrefixedEventName("animationend"), $12584cae6930e094$var$ANIMATION_ITERATION = $12584cae6930e094$var$getVendorPrefixedEventName("animationiteration"), $12584cae6930e094$var$ANIMATION_START = $12584cae6930e094$var$getVendorPrefixedEventName("animationstart"), $12584cae6930e094$var$TRANSITION_RUN = $12584cae6930e094$var$getVendorPrefixedEventName("transitionrun"), $12584cae6930e094$var$TRANSITION_START = $12584cae6930e094$var$getVendorPrefixedEventName("transitionstart"), $12584cae6930e094$var$TRANSITION_CANCEL = $12584cae6930e094$var$getVendorPrefixedEventName("transitioncancel"), $12584cae6930e094$var$TRANSITION_END = $12584cae6930e094$var$getVendorPrefixedEventName("transitionend"), $12584cae6930e094$var$topLevelEventsToReactNames = new Map(), $12584cae6930e094$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$12584cae6930e094$var$simpleEventPluginEvents.push("scrollEnd");
function $12584cae6930e094$var$registerSimpleEvent(domEventName, reactName) {
    $12584cae6930e094$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $12584cae6930e094$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $12584cae6930e094$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $12584cae6930e094$var$concurrentQueues = [], $12584cae6930e094$var$concurrentQueuesIndex = 0, $12584cae6930e094$var$concurrentlyUpdatedLanes = 0;
function $12584cae6930e094$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $12584cae6930e094$var$concurrentQueuesIndex, i = $12584cae6930e094$var$concurrentlyUpdatedLanes = $12584cae6930e094$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $12584cae6930e094$var$concurrentQueues[i];
        $12584cae6930e094$var$concurrentQueues[i++] = null;
        var queue = $12584cae6930e094$var$concurrentQueues[i];
        $12584cae6930e094$var$concurrentQueues[i++] = null;
        var update = $12584cae6930e094$var$concurrentQueues[i];
        $12584cae6930e094$var$concurrentQueues[i++] = null;
        var lane = $12584cae6930e094$var$concurrentQueues[i];
        $12584cae6930e094$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $12584cae6930e094$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $12584cae6930e094$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $12584cae6930e094$var$concurrentQueues[$12584cae6930e094$var$concurrentQueuesIndex++] = fiber;
    $12584cae6930e094$var$concurrentQueues[$12584cae6930e094$var$concurrentQueuesIndex++] = queue;
    $12584cae6930e094$var$concurrentQueues[$12584cae6930e094$var$concurrentQueuesIndex++] = update;
    $12584cae6930e094$var$concurrentQueues[$12584cae6930e094$var$concurrentQueuesIndex++] = lane;
    $12584cae6930e094$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $12584cae6930e094$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $12584cae6930e094$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $12584cae6930e094$var$getRootForUpdatedFiber(fiber);
}
function $12584cae6930e094$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $12584cae6930e094$var$enqueueUpdate$1(fiber, null, null, lane);
    return $12584cae6930e094$var$getRootForUpdatedFiber(fiber);
}
function $12584cae6930e094$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $12584cae6930e094$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $12584cae6930e094$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $12584cae6930e094$var$nestedUpdateCount) throw $12584cae6930e094$var$nestedUpdateCount = 0, $12584cae6930e094$var$rootWithNestedUpdates = null, Error($12584cae6930e094$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $12584cae6930e094$var$emptyContextObject = {};
function $12584cae6930e094$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $12584cae6930e094$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $12584cae6930e094$var$FiberNode(tag, pendingProps, key, mode);
}
function $12584cae6930e094$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $12584cae6930e094$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $12584cae6930e094$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $12584cae6930e094$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $12584cae6930e094$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $12584cae6930e094$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $12584cae6930e094$var$isHostHoistableType(type, pendingProps, $12584cae6930e094$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $12584cae6930e094$var$REACT_ACTIVITY_TYPE:
            return type = $12584cae6930e094$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $12584cae6930e094$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $12584cae6930e094$var$REACT_FRAGMENT_TYPE:
            return $12584cae6930e094$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $12584cae6930e094$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $12584cae6930e094$var$REACT_PROFILER_TYPE:
            return type = $12584cae6930e094$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $12584cae6930e094$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $12584cae6930e094$var$REACT_SUSPENSE_TYPE:
            return type = $12584cae6930e094$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $12584cae6930e094$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $12584cae6930e094$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $12584cae6930e094$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $12584cae6930e094$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $12584cae6930e094$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $12584cae6930e094$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $12584cae6930e094$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $12584cae6930e094$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $12584cae6930e094$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($12584cae6930e094$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $12584cae6930e094$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $12584cae6930e094$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $12584cae6930e094$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $12584cae6930e094$var$createFiberFromText(content, mode, lanes) {
    content = $12584cae6930e094$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $12584cae6930e094$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $12584cae6930e094$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $12584cae6930e094$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $12584cae6930e094$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $12584cae6930e094$var$CapturedStacks = new WeakMap();
function $12584cae6930e094$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $12584cae6930e094$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $12584cae6930e094$var$getStackByFiberInDevAndProd(source)
        };
        $12584cae6930e094$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $12584cae6930e094$var$getStackByFiberInDevAndProd(source)
    };
}
var $12584cae6930e094$var$forkStack = [], $12584cae6930e094$var$forkStackIndex = 0, $12584cae6930e094$var$treeForkProvider = null, $12584cae6930e094$var$treeForkCount = 0, $12584cae6930e094$var$idStack = [], $12584cae6930e094$var$idStackIndex = 0, $12584cae6930e094$var$treeContextProvider = null, $12584cae6930e094$var$treeContextId = 1, $12584cae6930e094$var$treeContextOverflow = "";
function $12584cae6930e094$var$pushTreeFork(workInProgress, totalChildren) {
    $12584cae6930e094$var$forkStack[$12584cae6930e094$var$forkStackIndex++] = $12584cae6930e094$var$treeForkCount;
    $12584cae6930e094$var$forkStack[$12584cae6930e094$var$forkStackIndex++] = $12584cae6930e094$var$treeForkProvider;
    $12584cae6930e094$var$treeForkProvider = workInProgress;
    $12584cae6930e094$var$treeForkCount = totalChildren;
}
function $12584cae6930e094$var$pushTreeId(workInProgress, totalChildren, index) {
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextId;
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextOverflow;
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextProvider;
    $12584cae6930e094$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $12584cae6930e094$var$treeContextId;
    workInProgress = $12584cae6930e094$var$treeContextOverflow;
    var baseLength = 32 - $12584cae6930e094$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $12584cae6930e094$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $12584cae6930e094$var$treeContextId = 1 << 32 - $12584cae6930e094$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $12584cae6930e094$var$treeContextOverflow = length + workInProgress;
    } else $12584cae6930e094$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $12584cae6930e094$var$treeContextOverflow = workInProgress;
}
function $12584cae6930e094$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($12584cae6930e094$var$pushTreeFork(workInProgress, 1), $12584cae6930e094$var$pushTreeId(workInProgress, 1, 0));
}
function $12584cae6930e094$var$popTreeContext(workInProgress) {
    for(; workInProgress === $12584cae6930e094$var$treeForkProvider;)$12584cae6930e094$var$treeForkProvider = $12584cae6930e094$var$forkStack[--$12584cae6930e094$var$forkStackIndex], $12584cae6930e094$var$forkStack[$12584cae6930e094$var$forkStackIndex] = null, $12584cae6930e094$var$treeForkCount = $12584cae6930e094$var$forkStack[--$12584cae6930e094$var$forkStackIndex], $12584cae6930e094$var$forkStack[$12584cae6930e094$var$forkStackIndex] = null;
    for(; workInProgress === $12584cae6930e094$var$treeContextProvider;)$12584cae6930e094$var$treeContextProvider = $12584cae6930e094$var$idStack[--$12584cae6930e094$var$idStackIndex], $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex] = null, $12584cae6930e094$var$treeContextOverflow = $12584cae6930e094$var$idStack[--$12584cae6930e094$var$idStackIndex], $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex] = null, $12584cae6930e094$var$treeContextId = $12584cae6930e094$var$idStack[--$12584cae6930e094$var$idStackIndex], $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex] = null;
}
function $12584cae6930e094$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextId;
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextOverflow;
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextProvider;
    $12584cae6930e094$var$treeContextId = suspendedContext.id;
    $12584cae6930e094$var$treeContextOverflow = suspendedContext.overflow;
    $12584cae6930e094$var$treeContextProvider = workInProgress;
}
var $12584cae6930e094$var$hydrationParentFiber = null, $12584cae6930e094$var$nextHydratableInstance = null, $12584cae6930e094$var$isHydrating = !1, $12584cae6930e094$var$hydrationErrors = null, $12584cae6930e094$var$rootOrSingletonContext = !1, $12584cae6930e094$var$HydrationMismatchException = Error($12584cae6930e094$var$formatProdErrorMessage(519));
function $12584cae6930e094$var$throwOnHydrationMismatch(fiber) {
    var error = Error($12584cae6930e094$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $12584cae6930e094$var$queueHydrationError($12584cae6930e094$var$createCapturedValueAtFiber(error, fiber));
    throw $12584cae6930e094$var$HydrationMismatchException;
}
function $12584cae6930e094$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$12584cae6930e094$var$internalInstanceKey] = fiber;
    instance[$12584cae6930e094$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $12584cae6930e094$var$listenToNonDelegatedEvent("cancel", instance);
            $12584cae6930e094$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $12584cae6930e094$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $12584cae6930e094$var$mediaEventTypes.length; type++)$12584cae6930e094$var$listenToNonDelegatedEvent($12584cae6930e094$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $12584cae6930e094$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $12584cae6930e094$var$listenToNonDelegatedEvent("error", instance);
            $12584cae6930e094$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $12584cae6930e094$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", instance);
            $12584cae6930e094$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", instance), $12584cae6930e094$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $12584cae6930e094$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($12584cae6930e094$var$listenToNonDelegatedEvent("beforetoggle", instance), $12584cae6930e094$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $12584cae6930e094$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $12584cae6930e094$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $12584cae6930e094$var$noop$1), instance = !0) : instance = !1;
    instance || $12584cae6930e094$var$throwOnHydrationMismatch(fiber, !0);
}
function $12584cae6930e094$var$popToNextHostParent(fiber) {
    for($12584cae6930e094$var$hydrationParentFiber = fiber.return; $12584cae6930e094$var$hydrationParentFiber;)switch($12584cae6930e094$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $12584cae6930e094$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $12584cae6930e094$var$rootOrSingletonContext = !0;
            return;
        default:
            $12584cae6930e094$var$hydrationParentFiber = $12584cae6930e094$var$hydrationParentFiber.return;
    }
}
function $12584cae6930e094$var$popHydrationState(fiber) {
    if (fiber !== $12584cae6930e094$var$hydrationParentFiber) return !1;
    if (!$12584cae6930e094$var$isHydrating) return $12584cae6930e094$var$popToNextHostParent(fiber), $12584cae6930e094$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $12584cae6930e094$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $12584cae6930e094$var$nextHydratableInstance && $12584cae6930e094$var$throwOnHydrationMismatch(fiber);
    $12584cae6930e094$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($12584cae6930e094$var$formatProdErrorMessage(317));
        $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($12584cae6930e094$var$formatProdErrorMessage(317));
        $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $12584cae6930e094$var$nextHydratableInstance, $12584cae6930e094$var$isSingletonScope(fiber.type) ? (fiber = $12584cae6930e094$var$previousHydratableOnEnteringScopedSingleton, $12584cae6930e094$var$previousHydratableOnEnteringScopedSingleton = null, $12584cae6930e094$var$nextHydratableInstance = fiber) : $12584cae6930e094$var$nextHydratableInstance = tag) : $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$hydrationParentFiber ? $12584cae6930e094$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $12584cae6930e094$var$resetHydrationState() {
    $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$hydrationParentFiber = null;
    $12584cae6930e094$var$isHydrating = !1;
}
function $12584cae6930e094$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $12584cae6930e094$var$hydrationErrors;
    null !== queuedErrors && (null === $12584cae6930e094$var$workInProgressRootRecoverableErrors ? $12584cae6930e094$var$workInProgressRootRecoverableErrors = queuedErrors : $12584cae6930e094$var$workInProgressRootRecoverableErrors.push.apply($12584cae6930e094$var$workInProgressRootRecoverableErrors, queuedErrors), $12584cae6930e094$var$hydrationErrors = null);
    return queuedErrors;
}
function $12584cae6930e094$var$queueHydrationError(error) {
    null === $12584cae6930e094$var$hydrationErrors ? $12584cae6930e094$var$hydrationErrors = [
        error
    ] : $12584cae6930e094$var$hydrationErrors.push(error);
}
var $12584cae6930e094$var$valueCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$currentlyRenderingFiber$1 = null, $12584cae6930e094$var$lastContextDependency = null;
function $12584cae6930e094$var$pushProvider(providerFiber, context, nextValue) {
    $12584cae6930e094$var$push($12584cae6930e094$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $12584cae6930e094$var$popProvider(context) {
    context._currentValue = $12584cae6930e094$var$valueCursor.current;
    $12584cae6930e094$var$pop($12584cae6930e094$var$valueCursor);
}
function $12584cae6930e094$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $12584cae6930e094$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $12584cae6930e094$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($12584cae6930e094$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $12584cae6930e094$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($12584cae6930e094$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $12584cae6930e094$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $12584cae6930e094$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($12584cae6930e094$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($12584cae6930e094$var$HostTransitionContext) : current = [
                $12584cae6930e094$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $12584cae6930e094$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $12584cae6930e094$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$12584cae6930e094$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $12584cae6930e094$var$prepareToReadContext(workInProgress) {
    $12584cae6930e094$var$currentlyRenderingFiber$1 = workInProgress;
    $12584cae6930e094$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $12584cae6930e094$var$readContext(context) {
    return $12584cae6930e094$var$readContextForConsumer($12584cae6930e094$var$currentlyRenderingFiber$1, context);
}
function $12584cae6930e094$var$readContextDuringReconciliation(consumer, context) {
    null === $12584cae6930e094$var$currentlyRenderingFiber$1 && $12584cae6930e094$var$prepareToReadContext(consumer);
    return $12584cae6930e094$var$readContextForConsumer(consumer, context);
}
function $12584cae6930e094$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $12584cae6930e094$var$lastContextDependency) {
        if (null === consumer) throw Error($12584cae6930e094$var$formatProdErrorMessage(308));
        $12584cae6930e094$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $12584cae6930e094$var$lastContextDependency = $12584cae6930e094$var$lastContextDependency.next = context;
    return value;
}
var $12584cae6930e094$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $12584cae6930e094$var$scheduleCallback$2 = $8IBEr.unstable_scheduleCallback, $12584cae6930e094$var$NormalPriority = $8IBEr.unstable_NormalPriority, $12584cae6930e094$var$CacheContext = {
    $$typeof: $12584cae6930e094$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $12584cae6930e094$var$createCache() {
    return {
        controller: new $12584cae6930e094$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $12584cae6930e094$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $12584cae6930e094$var$scheduleCallback$2($12584cae6930e094$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $12584cae6930e094$var$currentEntangledListeners = null, $12584cae6930e094$var$currentEntangledPendingCount = 0, $12584cae6930e094$var$currentEntangledLane = 0, $12584cae6930e094$var$currentEntangledActionThenable = null;
function $12584cae6930e094$var$entangleAsyncAction(transition, thenable) {
    if (null === $12584cae6930e094$var$currentEntangledListeners) {
        var entangledListeners = $12584cae6930e094$var$currentEntangledListeners = [];
        $12584cae6930e094$var$currentEntangledPendingCount = 0;
        $12584cae6930e094$var$currentEntangledLane = $12584cae6930e094$var$requestTransitionLane();
        $12584cae6930e094$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $12584cae6930e094$var$currentEntangledPendingCount++;
    thenable.then($12584cae6930e094$var$pingEngtangledActionScope, $12584cae6930e094$var$pingEngtangledActionScope);
    return thenable;
}
function $12584cae6930e094$var$pingEngtangledActionScope() {
    if (0 === --$12584cae6930e094$var$currentEntangledPendingCount && null !== $12584cae6930e094$var$currentEntangledListeners) {
        null !== $12584cae6930e094$var$currentEntangledActionThenable && ($12584cae6930e094$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $12584cae6930e094$var$currentEntangledListeners;
        $12584cae6930e094$var$currentEntangledListeners = null;
        $12584cae6930e094$var$currentEntangledLane = 0;
        $12584cae6930e094$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $12584cae6930e094$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $12584cae6930e094$var$prevOnStartTransitionFinish = $12584cae6930e094$var$ReactSharedInternals.S;
$12584cae6930e094$var$ReactSharedInternals.S = function(transition, returnValue) {
    $12584cae6930e094$var$globalMostRecentTransitionTime = $12584cae6930e094$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $12584cae6930e094$var$entangleAsyncAction(transition, returnValue);
    null !== $12584cae6930e094$var$prevOnStartTransitionFinish && $12584cae6930e094$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $12584cae6930e094$var$resumedCache = $12584cae6930e094$var$createCursor(null);
function $12584cae6930e094$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $12584cae6930e094$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $12584cae6930e094$var$workInProgressRoot.pooledCache;
}
function $12584cae6930e094$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $12584cae6930e094$var$push($12584cae6930e094$var$resumedCache, $12584cae6930e094$var$resumedCache.current) : $12584cae6930e094$var$push($12584cae6930e094$var$resumedCache, prevCachePool.pool);
}
function $12584cae6930e094$var$getSuspendedCache() {
    var cacheFromPool = $12584cae6930e094$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $12584cae6930e094$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $12584cae6930e094$var$SuspenseException = Error($12584cae6930e094$var$formatProdErrorMessage(460)), $12584cae6930e094$var$SuspenseyCommitException = Error($12584cae6930e094$var$formatProdErrorMessage(474)), $12584cae6930e094$var$SuspenseActionException = Error($12584cae6930e094$var$formatProdErrorMessage(542)), $12584cae6930e094$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $12584cae6930e094$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $12584cae6930e094$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($12584cae6930e094$var$noop$1, $12584cae6930e094$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $12584cae6930e094$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($12584cae6930e094$var$noop$1, $12584cae6930e094$var$noop$1);
            else {
                thenableState = $12584cae6930e094$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($12584cae6930e094$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $12584cae6930e094$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $12584cae6930e094$var$suspendedThenable = thenable;
            throw $12584cae6930e094$var$SuspenseException;
    }
}
function $12584cae6930e094$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $12584cae6930e094$var$suspendedThenable = x, $12584cae6930e094$var$SuspenseException;
        throw x;
    }
}
var $12584cae6930e094$var$suspendedThenable = null;
function $12584cae6930e094$var$getSuspendedThenable() {
    if (null === $12584cae6930e094$var$suspendedThenable) throw Error($12584cae6930e094$var$formatProdErrorMessage(459));
    var thenable = $12584cae6930e094$var$suspendedThenable;
    $12584cae6930e094$var$suspendedThenable = null;
    return thenable;
}
function $12584cae6930e094$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $12584cae6930e094$var$SuspenseException || rejectedReason === $12584cae6930e094$var$SuspenseActionException) throw Error($12584cae6930e094$var$formatProdErrorMessage(483));
}
var $12584cae6930e094$var$thenableState$1 = null, $12584cae6930e094$var$thenableIndexCounter$1 = 0;
function $12584cae6930e094$var$unwrapThenable(thenable) {
    var index = $12584cae6930e094$var$thenableIndexCounter$1;
    $12584cae6930e094$var$thenableIndexCounter$1 += 1;
    null === $12584cae6930e094$var$thenableState$1 && ($12584cae6930e094$var$thenableState$1 = []);
    return $12584cae6930e094$var$trackUsedThenable($12584cae6930e094$var$thenableState$1, thenable, index);
}
function $12584cae6930e094$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $12584cae6930e094$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $12584cae6930e094$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($12584cae6930e094$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($12584cae6930e094$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $12584cae6930e094$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $12584cae6930e094$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $12584cae6930e094$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $12584cae6930e094$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $12584cae6930e094$var$REACT_LAZY_TYPE && $12584cae6930e094$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $12584cae6930e094$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $12584cae6930e094$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $12584cae6930e094$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $12584cae6930e094$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $12584cae6930e094$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $12584cae6930e094$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $12584cae6930e094$var$REACT_ELEMENT_TYPE:
                    return lanes = $12584cae6930e094$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $12584cae6930e094$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $12584cae6930e094$var$REACT_PORTAL_TYPE:
                    return newChild = $12584cae6930e094$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $12584cae6930e094$var$REACT_LAZY_TYPE:
                    return newChild = $12584cae6930e094$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($12584cae6930e094$var$isArrayImpl(newChild) || $12584cae6930e094$var$getIteratorFn(newChild)) return newChild = $12584cae6930e094$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $12584cae6930e094$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $12584cae6930e094$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $12584cae6930e094$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $12584cae6930e094$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $12584cae6930e094$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $12584cae6930e094$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $12584cae6930e094$var$REACT_LAZY_TYPE:
                    return newChild = $12584cae6930e094$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($12584cae6930e094$var$isArrayImpl(newChild) || $12584cae6930e094$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $12584cae6930e094$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $12584cae6930e094$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $12584cae6930e094$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $12584cae6930e094$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $12584cae6930e094$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $12584cae6930e094$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $12584cae6930e094$var$REACT_LAZY_TYPE:
                    return newChild = $12584cae6930e094$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($12584cae6930e094$var$isArrayImpl(newChild) || $12584cae6930e094$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $12584cae6930e094$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $12584cae6930e094$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $12584cae6930e094$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $12584cae6930e094$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($12584cae6930e094$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $12584cae6930e094$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $12584cae6930e094$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $12584cae6930e094$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $12584cae6930e094$var$REACT_LAZY_TYPE && $12584cae6930e094$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $12584cae6930e094$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $12584cae6930e094$var$REACT_FRAGMENT_TYPE ? (lanes = $12584cae6930e094$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $12584cae6930e094$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $12584cae6930e094$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $12584cae6930e094$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $12584cae6930e094$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $12584cae6930e094$var$REACT_LAZY_TYPE:
                    return newChild = $12584cae6930e094$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($12584cae6930e094$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($12584cae6930e094$var$getIteratorFn(newChild)) {
                key = $12584cae6930e094$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($12584cae6930e094$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $12584cae6930e094$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $12584cae6930e094$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $12584cae6930e094$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $12584cae6930e094$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $12584cae6930e094$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $12584cae6930e094$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $12584cae6930e094$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $12584cae6930e094$var$SuspenseException || x === $12584cae6930e094$var$SuspenseActionException) throw x;
            var fiber = $12584cae6930e094$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $12584cae6930e094$var$reconcileChildFibers = $12584cae6930e094$var$createChildReconciler(!0), $12584cae6930e094$var$mountChildFibers = $12584cae6930e094$var$createChildReconciler(!1), $12584cae6930e094$var$hasForceUpdate = !1;
function $12584cae6930e094$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $12584cae6930e094$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $12584cae6930e094$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $12584cae6930e094$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($12584cae6930e094$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $12584cae6930e094$var$getRootForUpdatedFiber(fiber);
        $12584cae6930e094$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $12584cae6930e094$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $12584cae6930e094$var$getRootForUpdatedFiber(fiber);
}
function $12584cae6930e094$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $12584cae6930e094$var$markRootEntangled(root, lane);
    }
}
function $12584cae6930e094$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $12584cae6930e094$var$didReadFromEntangledAsyncAction = !1;
function $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($12584cae6930e094$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $12584cae6930e094$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $12584cae6930e094$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $12584cae6930e094$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $12584cae6930e094$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($12584cae6930e094$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $12584cae6930e094$var$currentEntangledLane && ($12584cae6930e094$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $12584cae6930e094$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $12584cae6930e094$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $12584cae6930e094$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $12584cae6930e094$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($12584cae6930e094$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $12584cae6930e094$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$12584cae6930e094$var$callCallback(callbacks[updateQueue], context);
}
var $12584cae6930e094$var$currentTreeHiddenStackCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$prevEntangledRenderLanesCursor = $12584cae6930e094$var$createCursor(0);
function $12584cae6930e094$var$pushHiddenContext(fiber, context) {
    fiber = $12584cae6930e094$var$entangledRenderLanes;
    $12584cae6930e094$var$push($12584cae6930e094$var$prevEntangledRenderLanesCursor, fiber);
    $12584cae6930e094$var$push($12584cae6930e094$var$currentTreeHiddenStackCursor, context);
    $12584cae6930e094$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $12584cae6930e094$var$reuseHiddenContextOnStack() {
    $12584cae6930e094$var$push($12584cae6930e094$var$prevEntangledRenderLanesCursor, $12584cae6930e094$var$entangledRenderLanes);
    $12584cae6930e094$var$push($12584cae6930e094$var$currentTreeHiddenStackCursor, $12584cae6930e094$var$currentTreeHiddenStackCursor.current);
}
function $12584cae6930e094$var$popHiddenContext() {
    $12584cae6930e094$var$entangledRenderLanes = $12584cae6930e094$var$prevEntangledRenderLanesCursor.current;
    $12584cae6930e094$var$pop($12584cae6930e094$var$currentTreeHiddenStackCursor);
    $12584cae6930e094$var$pop($12584cae6930e094$var$prevEntangledRenderLanesCursor);
}
var $12584cae6930e094$var$suspenseHandlerStackCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$shellBoundary = null;
function $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, $12584cae6930e094$var$suspenseStackCursor.current & 1);
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseHandlerStackCursor, handler);
    null === $12584cae6930e094$var$shellBoundary && (null === current || null !== $12584cae6930e094$var$currentTreeHiddenStackCursor.current ? $12584cae6930e094$var$shellBoundary = handler : null !== current.memoizedState && ($12584cae6930e094$var$shellBoundary = handler));
}
function $12584cae6930e094$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, $12584cae6930e094$var$suspenseStackCursor.current);
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseHandlerStackCursor, fiber);
    null === $12584cae6930e094$var$shellBoundary && ($12584cae6930e094$var$shellBoundary = fiber);
}
function $12584cae6930e094$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, $12584cae6930e094$var$suspenseStackCursor.current), $12584cae6930e094$var$push($12584cae6930e094$var$suspenseHandlerStackCursor, fiber), null === $12584cae6930e094$var$shellBoundary && ($12584cae6930e094$var$shellBoundary = fiber)) : $12584cae6930e094$var$reuseSuspenseHandlerOnStack(fiber);
}
function $12584cae6930e094$var$reuseSuspenseHandlerOnStack() {
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, $12584cae6930e094$var$suspenseStackCursor.current);
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseHandlerStackCursor, $12584cae6930e094$var$suspenseHandlerStackCursor.current);
}
function $12584cae6930e094$var$popSuspenseHandler(fiber) {
    $12584cae6930e094$var$pop($12584cae6930e094$var$suspenseHandlerStackCursor);
    $12584cae6930e094$var$shellBoundary === fiber && ($12584cae6930e094$var$shellBoundary = null);
    $12584cae6930e094$var$pop($12584cae6930e094$var$suspenseStackCursor);
}
var $12584cae6930e094$var$suspenseStackCursor = $12584cae6930e094$var$createCursor(0);
function $12584cae6930e094$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $12584cae6930e094$var$isSuspenseInstancePending(state) || $12584cae6930e094$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $12584cae6930e094$var$renderLanes = 0, $12584cae6930e094$var$currentlyRenderingFiber = null, $12584cae6930e094$var$currentHook = null, $12584cae6930e094$var$workInProgressHook = null, $12584cae6930e094$var$didScheduleRenderPhaseUpdate = !1, $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $12584cae6930e094$var$localIdCounter = 0, $12584cae6930e094$var$thenableIndexCounter = 0, $12584cae6930e094$var$thenableState = null, $12584cae6930e094$var$globalClientIdCounter = 0;
function $12584cae6930e094$var$throwInvalidHookError() {
    throw Error($12584cae6930e094$var$formatProdErrorMessage(321));
}
function $12584cae6930e094$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$12584cae6930e094$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $12584cae6930e094$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $12584cae6930e094$var$renderLanes = nextRenderLanes;
    $12584cae6930e094$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $12584cae6930e094$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $12584cae6930e094$var$HooksDispatcherOnMount : $12584cae6930e094$var$HooksDispatcherOnUpdate;
    $12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $12584cae6930e094$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $12584cae6930e094$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $12584cae6930e094$var$finishRenderingHooks(current) {
    $12584cae6930e094$var$ReactSharedInternals.H = $12584cae6930e094$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $12584cae6930e094$var$currentHook && null !== $12584cae6930e094$var$currentHook.next;
    $12584cae6930e094$var$renderLanes = 0;
    $12584cae6930e094$var$workInProgressHook = $12584cae6930e094$var$currentHook = $12584cae6930e094$var$currentlyRenderingFiber = null;
    $12584cae6930e094$var$didScheduleRenderPhaseUpdate = !1;
    $12584cae6930e094$var$thenableIndexCounter = 0;
    $12584cae6930e094$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($12584cae6930e094$var$formatProdErrorMessage(300));
    null === current || $12584cae6930e094$var$didReceiveUpdate || (current = current.dependencies, null !== current && $12584cae6930e094$var$checkIfContextChanged(current) && ($12584cae6930e094$var$didReceiveUpdate = !0));
}
function $12584cae6930e094$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $12584cae6930e094$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass && ($12584cae6930e094$var$thenableState = null);
        $12584cae6930e094$var$thenableIndexCounter = 0;
        $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($12584cae6930e094$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $12584cae6930e094$var$workInProgressHook = $12584cae6930e094$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $12584cae6930e094$var$ReactSharedInternals.H = $12584cae6930e094$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $12584cae6930e094$var$TransitionAwareHostComponent() {
    var dispatcher = $12584cae6930e094$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $12584cae6930e094$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $12584cae6930e094$var$currentHook ? $12584cae6930e094$var$currentHook.memoizedState : null) !== dispatcher && ($12584cae6930e094$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $12584cae6930e094$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $12584cae6930e094$var$localIdCounter;
    $12584cae6930e094$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $12584cae6930e094$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $12584cae6930e094$var$resetHooksOnUnwind(workInProgress) {
    if ($12584cae6930e094$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $12584cae6930e094$var$didScheduleRenderPhaseUpdate = !1;
    }
    $12584cae6930e094$var$renderLanes = 0;
    $12584cae6930e094$var$workInProgressHook = $12584cae6930e094$var$currentHook = $12584cae6930e094$var$currentlyRenderingFiber = null;
    $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $12584cae6930e094$var$thenableIndexCounter = $12584cae6930e094$var$localIdCounter = 0;
    $12584cae6930e094$var$thenableState = null;
}
function $12584cae6930e094$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $12584cae6930e094$var$workInProgressHook ? $12584cae6930e094$var$currentlyRenderingFiber.memoizedState = $12584cae6930e094$var$workInProgressHook = hook : $12584cae6930e094$var$workInProgressHook = $12584cae6930e094$var$workInProgressHook.next = hook;
    return $12584cae6930e094$var$workInProgressHook;
}
function $12584cae6930e094$var$updateWorkInProgressHook() {
    if (null === $12584cae6930e094$var$currentHook) {
        var nextCurrentHook = $12584cae6930e094$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $12584cae6930e094$var$currentHook.next;
    var nextWorkInProgressHook = null === $12584cae6930e094$var$workInProgressHook ? $12584cae6930e094$var$currentlyRenderingFiber.memoizedState : $12584cae6930e094$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $12584cae6930e094$var$workInProgressHook = nextWorkInProgressHook, $12584cae6930e094$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $12584cae6930e094$var$currentlyRenderingFiber.alternate) throw Error($12584cae6930e094$var$formatProdErrorMessage(467));
            throw Error($12584cae6930e094$var$formatProdErrorMessage(310));
        }
        $12584cae6930e094$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $12584cae6930e094$var$currentHook.memoizedState,
            baseState: $12584cae6930e094$var$currentHook.baseState,
            baseQueue: $12584cae6930e094$var$currentHook.baseQueue,
            queue: $12584cae6930e094$var$currentHook.queue,
            next: null
        };
        null === $12584cae6930e094$var$workInProgressHook ? $12584cae6930e094$var$currentlyRenderingFiber.memoizedState = $12584cae6930e094$var$workInProgressHook = nextCurrentHook : $12584cae6930e094$var$workInProgressHook = $12584cae6930e094$var$workInProgressHook.next = nextCurrentHook;
    }
    return $12584cae6930e094$var$workInProgressHook;
}
function $12584cae6930e094$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $12584cae6930e094$var$useThenable(thenable) {
    var index = $12584cae6930e094$var$thenableIndexCounter;
    $12584cae6930e094$var$thenableIndexCounter += 1;
    null === $12584cae6930e094$var$thenableState && ($12584cae6930e094$var$thenableState = []);
    thenable = $12584cae6930e094$var$trackUsedThenable($12584cae6930e094$var$thenableState, thenable, index);
    index = $12584cae6930e094$var$currentlyRenderingFiber;
    null === (null === $12584cae6930e094$var$workInProgressHook ? index.memoizedState : $12584cae6930e094$var$workInProgressHook.next) && (index = index.alternate, $12584cae6930e094$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $12584cae6930e094$var$HooksDispatcherOnMount : $12584cae6930e094$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $12584cae6930e094$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $12584cae6930e094$var$useThenable(usable);
        if (usable.$$typeof === $12584cae6930e094$var$REACT_CONTEXT_TYPE) return $12584cae6930e094$var$readContext(usable);
    }
    throw Error($12584cae6930e094$var$formatProdErrorMessage(438, String(usable)));
}
function $12584cae6930e094$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $12584cae6930e094$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $12584cae6930e094$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $12584cae6930e094$var$createFunctionComponentUpdateQueue(), $12584cae6930e094$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $12584cae6930e094$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $12584cae6930e094$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $12584cae6930e094$var$updateReducer(reducer) {
    var hook = $12584cae6930e094$var$updateWorkInProgressHook();
    return $12584cae6930e094$var$updateReducerImpl(hook, $12584cae6930e094$var$currentHook, reducer);
}
function $12584cae6930e094$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($12584cae6930e094$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($12584cae6930e094$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($12584cae6930e094$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $12584cae6930e094$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($12584cae6930e094$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $12584cae6930e094$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $12584cae6930e094$var$currentlyRenderingFiber.lanes |= revertLane, $12584cae6930e094$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $12584cae6930e094$var$currentlyRenderingFiber.lanes |= updateLane, $12584cae6930e094$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$12584cae6930e094$var$objectIs(pendingQueue, hook.memoizedState) && ($12584cae6930e094$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $12584cae6930e094$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $12584cae6930e094$var$rerenderReducer(reducer) {
    var hook = $12584cae6930e094$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($12584cae6930e094$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $12584cae6930e094$var$objectIs(newState, hook.memoizedState) || ($12584cae6930e094$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $12584cae6930e094$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $12584cae6930e094$var$currentlyRenderingFiber, hook = $12584cae6930e094$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $12584cae6930e094$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($12584cae6930e094$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$12584cae6930e094$var$objectIs(($12584cae6930e094$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $12584cae6930e094$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $12584cae6930e094$var$updateEffect($12584cae6930e094$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $12584cae6930e094$var$workInProgressHook && $12584cae6930e094$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $12584cae6930e094$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $12584cae6930e094$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $12584cae6930e094$var$workInProgressRoot) throw Error($12584cae6930e094$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($12584cae6930e094$var$renderLanes & 127) || $12584cae6930e094$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $12584cae6930e094$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $12584cae6930e094$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $12584cae6930e094$var$createFunctionComponentUpdateQueue(), $12584cae6930e094$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $12584cae6930e094$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $12584cae6930e094$var$checkIfSnapshotChanged(inst) && $12584cae6930e094$var$forceStoreRerender(fiber);
}
function $12584cae6930e094$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $12584cae6930e094$var$checkIfSnapshotChanged(inst) && $12584cae6930e094$var$forceStoreRerender(fiber);
    });
}
function $12584cae6930e094$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$12584cae6930e094$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $12584cae6930e094$var$forceStoreRerender(fiber) {
    var root = $12584cae6930e094$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $12584cae6930e094$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $12584cae6930e094$var$mountStateImpl(initialState) {
    var hook = $12584cae6930e094$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $12584cae6930e094$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $12584cae6930e094$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $12584cae6930e094$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $12584cae6930e094$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $12584cae6930e094$var$updateReducerImpl(hook, $12584cae6930e094$var$currentHook, "function" === typeof reducer ? reducer : $12584cae6930e094$var$basicStateReducer);
}
function $12584cae6930e094$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($12584cae6930e094$var$isRenderPhaseUpdate(fiber)) throw Error($12584cae6930e094$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $12584cae6930e094$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $12584cae6930e094$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $12584cae6930e094$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $12584cae6930e094$var$ReactSharedInternals.T, currentTransition = {};
        $12584cae6930e094$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $12584cae6930e094$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $12584cae6930e094$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $12584cae6930e094$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $12584cae6930e094$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $12584cae6930e094$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $12584cae6930e094$var$onActionError(actionQueue, node, error$66);
    }
}
function $12584cae6930e094$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $12584cae6930e094$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $12584cae6930e094$var$onActionError(actionQueue, node, error);
    }) : $12584cae6930e094$var$onActionSuccess(actionQueue, node, returnValue);
}
function $12584cae6930e094$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $12584cae6930e094$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $12584cae6930e094$var$runActionStateAction(actionQueue, nextState)));
}
function $12584cae6930e094$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $12584cae6930e094$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $12584cae6930e094$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $12584cae6930e094$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $12584cae6930e094$var$mountActionState(action, initialStateProp) {
    if ($12584cae6930e094$var$isHydrating) {
        var ssrFormState = $12584cae6930e094$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $12584cae6930e094$var$currentlyRenderingFiber;
                if ($12584cae6930e094$var$isHydrating) {
                    if ($12584cae6930e094$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $12584cae6930e094$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $12584cae6930e094$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $12584cae6930e094$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $12584cae6930e094$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $12584cae6930e094$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $12584cae6930e094$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $12584cae6930e094$var$dispatchSetState.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $12584cae6930e094$var$mountStateImpl(!1);
    inRootOrSingleton = $12584cae6930e094$var$dispatchOptimisticSetState.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $12584cae6930e094$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $12584cae6930e094$var$dispatchActionState.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $12584cae6930e094$var$updateActionState(action) {
    var stateHook = $12584cae6930e094$var$updateWorkInProgressHook();
    return $12584cae6930e094$var$updateActionStateImpl(stateHook, $12584cae6930e094$var$currentHook, action);
}
function $12584cae6930e094$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $12584cae6930e094$var$updateReducerImpl(stateHook, currentStateHook, $12584cae6930e094$var$actionStateReducer)[0];
    stateHook = $12584cae6930e094$var$updateReducer($12584cae6930e094$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $12584cae6930e094$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $12584cae6930e094$var$SuspenseException) throw $12584cae6930e094$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $12584cae6930e094$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($12584cae6930e094$var$currentlyRenderingFiber.flags |= 2048, $12584cae6930e094$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $12584cae6930e094$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $12584cae6930e094$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $12584cae6930e094$var$rerenderActionState(action) {
    var stateHook = $12584cae6930e094$var$updateWorkInProgressHook(), currentStateHook = $12584cae6930e094$var$currentHook;
    if (null !== currentStateHook) return $12584cae6930e094$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $12584cae6930e094$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $12584cae6930e094$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $12584cae6930e094$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $12584cae6930e094$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $12584cae6930e094$var$createFunctionComponentUpdateQueue(), $12584cae6930e094$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $12584cae6930e094$var$updateRef() {
    return $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
}
function $12584cae6930e094$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $12584cae6930e094$var$mountWorkInProgressHook();
    $12584cae6930e094$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $12584cae6930e094$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $12584cae6930e094$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $12584cae6930e094$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $12584cae6930e094$var$currentHook && null !== deps && $12584cae6930e094$var$areHookInputsEqual(deps, $12584cae6930e094$var$currentHook.memoizedState.deps) ? hook.memoizedState = $12584cae6930e094$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($12584cae6930e094$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $12584cae6930e094$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $12584cae6930e094$var$mountEffect(create, deps) {
    $12584cae6930e094$var$mountEffectImpl(8390656, 8, create, deps);
}
function $12584cae6930e094$var$updateEffect(create, deps) {
    $12584cae6930e094$var$updateEffectImpl(2048, 8, create, deps);
}
function $12584cae6930e094$var$useEffectEventImpl(payload) {
    $12584cae6930e094$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $12584cae6930e094$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $12584cae6930e094$var$createFunctionComponentUpdateQueue(), $12584cae6930e094$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $12584cae6930e094$var$updateEvent(callback) {
    var ref = $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
    $12584cae6930e094$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($12584cae6930e094$var$executionContext & 2)) throw Error($12584cae6930e094$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $12584cae6930e094$var$updateInsertionEffect(create, deps) {
    return $12584cae6930e094$var$updateEffectImpl(4, 2, create, deps);
}
function $12584cae6930e094$var$updateLayoutEffect(create, deps) {
    return $12584cae6930e094$var$updateEffectImpl(4, 4, create, deps);
}
function $12584cae6930e094$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $12584cae6930e094$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $12584cae6930e094$var$updateEffectImpl(4, 4, $12584cae6930e094$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $12584cae6930e094$var$mountDebugValue() {}
function $12584cae6930e094$var$updateCallback(callback, deps) {
    var hook = $12584cae6930e094$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $12584cae6930e094$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $12584cae6930e094$var$updateMemo(nextCreate, deps) {
    var hook = $12584cae6930e094$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $12584cae6930e094$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $12584cae6930e094$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $12584cae6930e094$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $12584cae6930e094$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($12584cae6930e094$var$renderLanes & 1073741824) && 0 === ($12584cae6930e094$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $12584cae6930e094$var$requestDeferredLane();
    $12584cae6930e094$var$currentlyRenderingFiber.lanes |= hook;
    $12584cae6930e094$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $12584cae6930e094$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($12584cae6930e094$var$objectIs(value, prevValue)) return value;
    if (null !== $12584cae6930e094$var$currentTreeHiddenStackCursor.current) return hook = $12584cae6930e094$var$mountDeferredValueImpl(hook, value, initialValue), $12584cae6930e094$var$objectIs(hook, prevValue) || ($12584cae6930e094$var$didReceiveUpdate = !0), hook;
    if (0 === ($12584cae6930e094$var$renderLanes & 42) || 0 !== ($12584cae6930e094$var$renderLanes & 1073741824) && 0 === ($12584cae6930e094$var$workInProgressRootRenderLanes & 261930)) return $12584cae6930e094$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $12584cae6930e094$var$requestDeferredLane();
    $12584cae6930e094$var$currentlyRenderingFiber.lanes |= hook;
    $12584cae6930e094$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $12584cae6930e094$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    $12584cae6930e094$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $12584cae6930e094$var$ReactSharedInternals.T, currentTransition = {};
    $12584cae6930e094$var$ReactSharedInternals.T = currentTransition;
    $12584cae6930e094$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $12584cae6930e094$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $12584cae6930e094$var$chainThenableValue(returnValue, finishedState);
            $12584cae6930e094$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $12584cae6930e094$var$requestUpdateLane(fiber));
        } else $12584cae6930e094$var$dispatchSetStateInternal(fiber, queue, finishedState, $12584cae6930e094$var$requestUpdateLane(fiber));
    } catch (error) {
        $12584cae6930e094$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $12584cae6930e094$var$requestUpdateLane());
    } finally{
        $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $12584cae6930e094$var$ReactSharedInternals.T = prevTransition;
    }
}
function $12584cae6930e094$var$noop() {}
function $12584cae6930e094$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($12584cae6930e094$var$formatProdErrorMessage(476));
    var queue = $12584cae6930e094$var$ensureFormComponentIsStateful(formFiber).queue;
    $12584cae6930e094$var$startTransition(formFiber, queue, pendingState, $12584cae6930e094$var$sharedNotPendingObject, null === action ? $12584cae6930e094$var$noop : function() {
        $12584cae6930e094$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $12584cae6930e094$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $12584cae6930e094$var$sharedNotPendingObject,
        baseState: $12584cae6930e094$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $12584cae6930e094$var$basicStateReducer,
            lastRenderedState: $12584cae6930e094$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $12584cae6930e094$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $12584cae6930e094$var$requestFormReset$1(formFiber) {
    var stateHook = $12584cae6930e094$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $12584cae6930e094$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $12584cae6930e094$var$requestUpdateLane());
}
function $12584cae6930e094$var$useHostTransitionStatus() {
    return $12584cae6930e094$var$readContext($12584cae6930e094$var$HostTransitionContext);
}
function $12584cae6930e094$var$updateId() {
    return $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
}
function $12584cae6930e094$var$updateRefresh() {
    return $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
}
function $12584cae6930e094$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $12584cae6930e094$var$requestUpdateLane();
                fiber = $12584cae6930e094$var$createUpdate(lane);
                var root$69 = $12584cae6930e094$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($12584cae6930e094$var$scheduleUpdateOnFiber(root$69, provider, lane), $12584cae6930e094$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $12584cae6930e094$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $12584cae6930e094$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $12584cae6930e094$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $12584cae6930e094$var$isRenderPhaseUpdate(fiber) ? $12584cae6930e094$var$enqueueRenderPhaseUpdate(queue, action) : (action = $12584cae6930e094$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($12584cae6930e094$var$scheduleUpdateOnFiber(action, fiber, lane), $12584cae6930e094$var$entangleTransitionUpdate(action, queue, lane)));
}
function $12584cae6930e094$var$dispatchSetState(fiber, queue, action) {
    var lane = $12584cae6930e094$var$requestUpdateLane();
    $12584cae6930e094$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $12584cae6930e094$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($12584cae6930e094$var$isRenderPhaseUpdate(fiber)) $12584cae6930e094$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($12584cae6930e094$var$objectIs(eagerState, currentState)) return $12584cae6930e094$var$enqueueUpdate$1(fiber, queue, update, 0), null === $12584cae6930e094$var$workInProgressRoot && $12584cae6930e094$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $12584cae6930e094$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $12584cae6930e094$var$scheduleUpdateOnFiber(action, fiber, lane), $12584cae6930e094$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $12584cae6930e094$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $12584cae6930e094$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($12584cae6930e094$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($12584cae6930e094$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $12584cae6930e094$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $12584cae6930e094$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $12584cae6930e094$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $12584cae6930e094$var$currentlyRenderingFiber || null !== alternate && alternate === $12584cae6930e094$var$currentlyRenderingFiber;
}
function $12584cae6930e094$var$enqueueRenderPhaseUpdate(queue, update) {
    $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass = $12584cae6930e094$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $12584cae6930e094$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $12584cae6930e094$var$markRootEntangled(root, lane);
    }
}
var $12584cae6930e094$var$ContextOnlyDispatcher = {
    readContext: $12584cae6930e094$var$readContext,
    use: $12584cae6930e094$var$use,
    useCallback: $12584cae6930e094$var$throwInvalidHookError,
    useContext: $12584cae6930e094$var$throwInvalidHookError,
    useEffect: $12584cae6930e094$var$throwInvalidHookError,
    useImperativeHandle: $12584cae6930e094$var$throwInvalidHookError,
    useLayoutEffect: $12584cae6930e094$var$throwInvalidHookError,
    useInsertionEffect: $12584cae6930e094$var$throwInvalidHookError,
    useMemo: $12584cae6930e094$var$throwInvalidHookError,
    useReducer: $12584cae6930e094$var$throwInvalidHookError,
    useRef: $12584cae6930e094$var$throwInvalidHookError,
    useState: $12584cae6930e094$var$throwInvalidHookError,
    useDebugValue: $12584cae6930e094$var$throwInvalidHookError,
    useDeferredValue: $12584cae6930e094$var$throwInvalidHookError,
    useTransition: $12584cae6930e094$var$throwInvalidHookError,
    useSyncExternalStore: $12584cae6930e094$var$throwInvalidHookError,
    useId: $12584cae6930e094$var$throwInvalidHookError,
    useHostTransitionStatus: $12584cae6930e094$var$throwInvalidHookError,
    useFormState: $12584cae6930e094$var$throwInvalidHookError,
    useActionState: $12584cae6930e094$var$throwInvalidHookError,
    useOptimistic: $12584cae6930e094$var$throwInvalidHookError,
    useMemoCache: $12584cae6930e094$var$throwInvalidHookError,
    useCacheRefresh: $12584cae6930e094$var$throwInvalidHookError
};
$12584cae6930e094$var$ContextOnlyDispatcher.useEffectEvent = $12584cae6930e094$var$throwInvalidHookError;
var $12584cae6930e094$var$HooksDispatcherOnMount = {
    readContext: $12584cae6930e094$var$readContext,
    use: $12584cae6930e094$var$use,
    useCallback: function(callback, deps) {
        $12584cae6930e094$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $12584cae6930e094$var$readContext,
    useEffect: $12584cae6930e094$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $12584cae6930e094$var$mountEffectImpl(4194308, 4, $12584cae6930e094$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $12584cae6930e094$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $12584cae6930e094$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $12584cae6930e094$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $12584cae6930e094$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $12584cae6930e094$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $12584cae6930e094$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $12584cae6930e094$var$dispatchReducerAction.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $12584cae6930e094$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $12584cae6930e094$var$dispatchSetState.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $12584cae6930e094$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook();
        return $12584cae6930e094$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $12584cae6930e094$var$mountStateImpl(!1);
        stateHook = $12584cae6930e094$var$startTransition.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $12584cae6930e094$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $12584cae6930e094$var$currentlyRenderingFiber, hook = $12584cae6930e094$var$mountWorkInProgressHook();
        if ($12584cae6930e094$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($12584cae6930e094$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $12584cae6930e094$var$workInProgressRoot) throw Error($12584cae6930e094$var$formatProdErrorMessage(349));
            0 !== ($12584cae6930e094$var$workInProgressRootRenderLanes & 127) || $12584cae6930e094$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $12584cae6930e094$var$mountEffect($12584cae6930e094$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $12584cae6930e094$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $12584cae6930e094$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook(), identifierPrefix = $12584cae6930e094$var$workInProgressRoot.identifierPrefix;
        if ($12584cae6930e094$var$isHydrating) {
            var JSCompiler_inline_result = $12584cae6930e094$var$treeContextOverflow;
            var idWithLeadingBit = $12584cae6930e094$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $12584cae6930e094$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $12584cae6930e094$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $12584cae6930e094$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $12584cae6930e094$var$useHostTransitionStatus,
    useFormState: $12584cae6930e094$var$mountActionState,
    useActionState: $12584cae6930e094$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $12584cae6930e094$var$dispatchOptimisticSetState.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $12584cae6930e094$var$useMemoCache,
    useCacheRefresh: function() {
        return $12584cae6930e094$var$mountWorkInProgressHook().memoizedState = $12584cae6930e094$var$refreshCache.bind(null, $12584cae6930e094$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($12584cae6930e094$var$executionContext & 2)) throw Error($12584cae6930e094$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $12584cae6930e094$var$HooksDispatcherOnUpdate = {
    readContext: $12584cae6930e094$var$readContext,
    use: $12584cae6930e094$var$use,
    useCallback: $12584cae6930e094$var$updateCallback,
    useContext: $12584cae6930e094$var$readContext,
    useEffect: $12584cae6930e094$var$updateEffect,
    useImperativeHandle: $12584cae6930e094$var$updateImperativeHandle,
    useInsertionEffect: $12584cae6930e094$var$updateInsertionEffect,
    useLayoutEffect: $12584cae6930e094$var$updateLayoutEffect,
    useMemo: $12584cae6930e094$var$updateMemo,
    useReducer: $12584cae6930e094$var$updateReducer,
    useRef: $12584cae6930e094$var$updateRef,
    useState: function() {
        return $12584cae6930e094$var$updateReducer($12584cae6930e094$var$basicStateReducer);
    },
    useDebugValue: $12584cae6930e094$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $12584cae6930e094$var$updateWorkInProgressHook();
        return $12584cae6930e094$var$updateDeferredValueImpl(hook, $12584cae6930e094$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $12584cae6930e094$var$updateReducer($12584cae6930e094$var$basicStateReducer)[0], start = $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $12584cae6930e094$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $12584cae6930e094$var$updateSyncExternalStore,
    useId: $12584cae6930e094$var$updateId,
    useHostTransitionStatus: $12584cae6930e094$var$useHostTransitionStatus,
    useFormState: $12584cae6930e094$var$updateActionState,
    useActionState: $12584cae6930e094$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $12584cae6930e094$var$updateWorkInProgressHook();
        return $12584cae6930e094$var$updateOptimisticImpl(hook, $12584cae6930e094$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $12584cae6930e094$var$useMemoCache,
    useCacheRefresh: $12584cae6930e094$var$updateRefresh
};
$12584cae6930e094$var$HooksDispatcherOnUpdate.useEffectEvent = $12584cae6930e094$var$updateEvent;
var $12584cae6930e094$var$HooksDispatcherOnRerender = {
    readContext: $12584cae6930e094$var$readContext,
    use: $12584cae6930e094$var$use,
    useCallback: $12584cae6930e094$var$updateCallback,
    useContext: $12584cae6930e094$var$readContext,
    useEffect: $12584cae6930e094$var$updateEffect,
    useImperativeHandle: $12584cae6930e094$var$updateImperativeHandle,
    useInsertionEffect: $12584cae6930e094$var$updateInsertionEffect,
    useLayoutEffect: $12584cae6930e094$var$updateLayoutEffect,
    useMemo: $12584cae6930e094$var$updateMemo,
    useReducer: $12584cae6930e094$var$rerenderReducer,
    useRef: $12584cae6930e094$var$updateRef,
    useState: function() {
        return $12584cae6930e094$var$rerenderReducer($12584cae6930e094$var$basicStateReducer);
    },
    useDebugValue: $12584cae6930e094$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $12584cae6930e094$var$updateWorkInProgressHook();
        return null === $12584cae6930e094$var$currentHook ? $12584cae6930e094$var$mountDeferredValueImpl(hook, value, initialValue) : $12584cae6930e094$var$updateDeferredValueImpl(hook, $12584cae6930e094$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $12584cae6930e094$var$rerenderReducer($12584cae6930e094$var$basicStateReducer)[0], start = $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $12584cae6930e094$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $12584cae6930e094$var$updateSyncExternalStore,
    useId: $12584cae6930e094$var$updateId,
    useHostTransitionStatus: $12584cae6930e094$var$useHostTransitionStatus,
    useFormState: $12584cae6930e094$var$rerenderActionState,
    useActionState: $12584cae6930e094$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $12584cae6930e094$var$updateWorkInProgressHook();
        if (null !== $12584cae6930e094$var$currentHook) return $12584cae6930e094$var$updateOptimisticImpl(hook, $12584cae6930e094$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $12584cae6930e094$var$useMemoCache,
    useCacheRefresh: $12584cae6930e094$var$updateRefresh
};
$12584cae6930e094$var$HooksDispatcherOnRerender.useEffectEvent = $12584cae6930e094$var$updateEvent;
function $12584cae6930e094$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $12584cae6930e094$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $12584cae6930e094$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $12584cae6930e094$var$requestUpdateLane(), update = $12584cae6930e094$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $12584cae6930e094$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($12584cae6930e094$var$scheduleUpdateOnFiber(payload, inst, lane), $12584cae6930e094$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $12584cae6930e094$var$requestUpdateLane(), update = $12584cae6930e094$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $12584cae6930e094$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($12584cae6930e094$var$scheduleUpdateOnFiber(payload, inst, lane), $12584cae6930e094$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $12584cae6930e094$var$requestUpdateLane(), update = $12584cae6930e094$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $12584cae6930e094$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($12584cae6930e094$var$scheduleUpdateOnFiber(callback, inst, lane), $12584cae6930e094$var$entangleTransitions(callback, inst, lane));
    }
};
function $12584cae6930e094$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$12584cae6930e094$var$shallowEqual(oldProps, newProps) || !$12584cae6930e094$var$shallowEqual(oldState, newState) : !0;
}
function $12584cae6930e094$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $12584cae6930e094$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $12584cae6930e094$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $12584cae6930e094$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $12584cae6930e094$var$defaultOnUncaughtError(error) {
    $12584cae6930e094$var$reportGlobalError(error);
}
function $12584cae6930e094$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $12584cae6930e094$var$defaultOnRecoverableError(error) {
    $12584cae6930e094$var$reportGlobalError(error);
}
function $12584cae6930e094$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $12584cae6930e094$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $12584cae6930e094$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $12584cae6930e094$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $12584cae6930e094$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $12584cae6930e094$var$createClassErrorUpdate(lane) {
    lane = $12584cae6930e094$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $12584cae6930e094$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $12584cae6930e094$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $12584cae6930e094$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed ? $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $12584cae6930e094$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $12584cae6930e094$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $12584cae6930e094$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $12584cae6930e094$var$shellBoundary ? $12584cae6930e094$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $12584cae6930e094$var$workInProgressRootExitStatus && ($12584cae6930e094$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $12584cae6930e094$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $12584cae6930e094$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $12584cae6930e094$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $12584cae6930e094$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($12584cae6930e094$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $12584cae6930e094$var$attachPingListener(root, value, rootRenderLanes);
        $12584cae6930e094$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($12584cae6930e094$var$isHydrating) return returnFiber = $12584cae6930e094$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $12584cae6930e094$var$HydrationMismatchException && (root = Error($12584cae6930e094$var$formatProdErrorMessage(422), {
        cause: value
    }), $12584cae6930e094$var$queueHydrationError($12584cae6930e094$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $12584cae6930e094$var$HydrationMismatchException && (returnFiber = Error($12584cae6930e094$var$formatProdErrorMessage(423), {
        cause: value
    }), $12584cae6930e094$var$queueHydrationError($12584cae6930e094$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $12584cae6930e094$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $12584cae6930e094$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $12584cae6930e094$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $12584cae6930e094$var$workInProgressRootExitStatus && ($12584cae6930e094$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($12584cae6930e094$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $12584cae6930e094$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $12584cae6930e094$var$workInProgressRootConcurrentErrors ? $12584cae6930e094$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $12584cae6930e094$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $12584cae6930e094$var$workInProgressRootExitStatus && ($12584cae6930e094$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $12584cae6930e094$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $12584cae6930e094$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $12584cae6930e094$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed || !$12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $12584cae6930e094$var$createClassErrorUpdate(rootRenderLanes), $12584cae6930e094$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $12584cae6930e094$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $12584cae6930e094$var$SelectiveHydrationException = Error($12584cae6930e094$var$formatProdErrorMessage(461)), $12584cae6930e094$var$didReceiveUpdate = !1;
function $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $12584cae6930e094$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $12584cae6930e094$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $12584cae6930e094$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $12584cae6930e094$var$prepareToReadContext(workInProgress);
    nextProps = $12584cae6930e094$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $12584cae6930e094$var$checkDidRenderIdHook();
    if (null !== current && !$12584cae6930e094$var$didReceiveUpdate) return $12584cae6930e094$var$bailoutHooks(current, workInProgress, renderLanes), $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $12584cae6930e094$var$isHydrating && key && $12584cae6930e094$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $12584cae6930e094$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$12584cae6930e094$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $12584cae6930e094$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $12584cae6930e094$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$12584cae6930e094$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $12584cae6930e094$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $12584cae6930e094$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $12584cae6930e094$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($12584cae6930e094$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($12584cae6930e094$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $12584cae6930e094$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($12584cae6930e094$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $12584cae6930e094$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $12584cae6930e094$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $12584cae6930e094$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $12584cae6930e094$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $12584cae6930e094$var$pushHiddenContext(workInProgress, prevState) : $12584cae6930e094$var$reuseHiddenContextOnStack(), $12584cae6930e094$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $12584cae6930e094$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($12584cae6930e094$var$pushTransition(workInProgress, prevState.cachePool), $12584cae6930e094$var$pushHiddenContext(workInProgress, prevState), $12584cae6930e094$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $12584cae6930e094$var$pushTransition(workInProgress, null), $12584cae6930e094$var$reuseHiddenContextOnStack(), $12584cae6930e094$var$reuseSuspenseHandlerOnStack(workInProgress));
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $12584cae6930e094$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $12584cae6930e094$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $12584cae6930e094$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $12584cae6930e094$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $12584cae6930e094$var$pushTransition(workInProgress, null);
    $12584cae6930e094$var$reuseHiddenContextOnStack();
    $12584cae6930e094$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $12584cae6930e094$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $12584cae6930e094$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $12584cae6930e094$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $12584cae6930e094$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $12584cae6930e094$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $12584cae6930e094$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $12584cae6930e094$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($12584cae6930e094$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $12584cae6930e094$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $12584cae6930e094$var$bailoutOffscreenComponent(null, current);
            $12584cae6930e094$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $12584cae6930e094$var$nextHydratableInstance) ? (current = $12584cae6930e094$var$canHydrateHydrationBoundary(current, $12584cae6930e094$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $12584cae6930e094$var$treeContextProvider ? {
                    id: $12584cae6930e094$var$treeContextId,
                    overflow: $12584cae6930e094$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $12584cae6930e094$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $12584cae6930e094$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $12584cae6930e094$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $12584cae6930e094$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $12584cae6930e094$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($12584cae6930e094$var$formatProdErrorMessage(558));
        } else if ($12584cae6930e094$var$didReceiveUpdate || $12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $12584cae6930e094$var$didReceiveUpdate || didSuspend) {
            nextProps = $12584cae6930e094$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $12584cae6930e094$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $12584cae6930e094$var$enqueueConcurrentRenderForLane(current, dehydrated), $12584cae6930e094$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $12584cae6930e094$var$SelectiveHydrationException;
            $12584cae6930e094$var$renderDidSuspendDelayIfPossible();
            workInProgress = $12584cae6930e094$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(dehydrated.nextSibling), $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$isHydrating = !0, $12584cae6930e094$var$hydrationErrors = null, $12584cae6930e094$var$rootOrSingletonContext = !1, null !== current && $12584cae6930e094$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $12584cae6930e094$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $12584cae6930e094$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $12584cae6930e094$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($12584cae6930e094$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $12584cae6930e094$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $12584cae6930e094$var$prepareToReadContext(workInProgress);
    Component = $12584cae6930e094$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $12584cae6930e094$var$checkDidRenderIdHook();
    if (null !== current && !$12584cae6930e094$var$didReceiveUpdate) return $12584cae6930e094$var$bailoutHooks(current, workInProgress, renderLanes), $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $12584cae6930e094$var$isHydrating && nextProps && $12584cae6930e094$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $12584cae6930e094$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $12584cae6930e094$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $12584cae6930e094$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $12584cae6930e094$var$finishRenderingHooks(current);
    Component = $12584cae6930e094$var$checkDidRenderIdHook();
    if (null !== current && !$12584cae6930e094$var$didReceiveUpdate) return $12584cae6930e094$var$bailoutHooks(current, workInProgress, renderLanes), $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $12584cae6930e094$var$isHydrating && Component && $12584cae6930e094$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $12584cae6930e094$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $12584cae6930e094$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $12584cae6930e094$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $12584cae6930e094$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $12584cae6930e094$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $12584cae6930e094$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $12584cae6930e094$var$readContext(contextType) : $12584cae6930e094$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($12584cae6930e094$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $12584cae6930e094$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $12584cae6930e094$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $12584cae6930e094$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $12584cae6930e094$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $12584cae6930e094$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $12584cae6930e094$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $12584cae6930e094$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $12584cae6930e094$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $12584cae6930e094$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($12584cae6930e094$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $12584cae6930e094$var$hasForceUpdate || $12584cae6930e094$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $12584cae6930e094$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $12584cae6930e094$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $12584cae6930e094$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $12584cae6930e094$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $12584cae6930e094$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $12584cae6930e094$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $12584cae6930e094$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $12584cae6930e094$var$hasForceUpdate || null !== current && null !== current.dependencies && $12584cae6930e094$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($12584cae6930e094$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $12584cae6930e094$var$hasForceUpdate || $12584cae6930e094$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $12584cae6930e094$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $12584cae6930e094$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $12584cae6930e094$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $12584cae6930e094$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $12584cae6930e094$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $12584cae6930e094$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $12584cae6930e094$var$resetHydrationState();
    workInProgress.flags |= 256;
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $12584cae6930e094$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $12584cae6930e094$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $12584cae6930e094$var$getSuspendedCache()
    };
}
function $12584cae6930e094$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $12584cae6930e094$var$workInProgressDeferredLane);
    return current;
}
function $12584cae6930e094$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($12584cae6930e094$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($12584cae6930e094$var$isHydrating) {
            showFallback ? $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $12584cae6930e094$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $12584cae6930e094$var$nextHydratableInstance) ? (current = $12584cae6930e094$var$canHydrateHydrationBoundary(current, $12584cae6930e094$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $12584cae6930e094$var$treeContextProvider ? {
                    id: $12584cae6930e094$var$treeContextId,
                    overflow: $12584cae6930e094$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $12584cae6930e094$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $12584cae6930e094$var$throwOnHydrationMismatch(workInProgress);
            $12584cae6930e094$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $12584cae6930e094$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $12584cae6930e094$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $12584cae6930e094$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $12584cae6930e094$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $12584cae6930e094$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $12584cae6930e094$var$SUSPENDED_MARKER, $12584cae6930e094$var$bailoutOffscreenComponent(null, nextProps);
        $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $12584cae6930e094$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $12584cae6930e094$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($12584cae6930e094$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($12584cae6930e094$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $12584cae6930e094$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $12584cae6930e094$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $12584cae6930e094$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $12584cae6930e094$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $12584cae6930e094$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $12584cae6930e094$var$SUSPENDED_MARKER, workInProgress = $12584cae6930e094$var$bailoutOffscreenComponent(null, nextProps));
        else if ($12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress), $12584cae6930e094$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($12584cae6930e094$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $12584cae6930e094$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $12584cae6930e094$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($12584cae6930e094$var$didReceiveUpdate || $12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $12584cae6930e094$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $12584cae6930e094$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $12584cae6930e094$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $12584cae6930e094$var$enqueueConcurrentRenderForLane(current, nextProps), $12584cae6930e094$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $12584cae6930e094$var$SelectiveHydrationException;
            $12584cae6930e094$var$isSuspenseInstancePending(nextPrimaryChildren) || $12584cae6930e094$var$renderDidSuspendDelayIfPossible();
            workInProgress = $12584cae6930e094$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $12584cae6930e094$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(nextPrimaryChildren.nextSibling), $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$isHydrating = !0, $12584cae6930e094$var$hydrationErrors = null, $12584cae6930e094$var$rootOrSingletonContext = !1, null !== current && $12584cae6930e094$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $12584cae6930e094$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $12584cae6930e094$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $12584cae6930e094$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $12584cae6930e094$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $12584cae6930e094$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $12584cae6930e094$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $12584cae6930e094$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $12584cae6930e094$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $12584cae6930e094$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $12584cae6930e094$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $12584cae6930e094$var$SUSPENDED_MARKER, $12584cae6930e094$var$bailoutOffscreenComponent(current.child, nextProps);
    $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $12584cae6930e094$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $12584cae6930e094$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $12584cae6930e094$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $12584cae6930e094$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $12584cae6930e094$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $12584cae6930e094$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $12584cae6930e094$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $12584cae6930e094$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $12584cae6930e094$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $12584cae6930e094$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $12584cae6930e094$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $12584cae6930e094$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $12584cae6930e094$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, suspenseContext);
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $12584cae6930e094$var$isHydrating ? $12584cae6930e094$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $12584cae6930e094$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $12584cae6930e094$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $12584cae6930e094$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $12584cae6930e094$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $12584cae6930e094$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $12584cae6930e094$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $12584cae6930e094$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $12584cae6930e094$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($12584cae6930e094$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $12584cae6930e094$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $12584cae6930e094$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $12584cae6930e094$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $12584cae6930e094$var$checkIfContextChanged(current) ? !0 : !1;
}
function $12584cae6930e094$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $12584cae6930e094$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, current.memoizedState.cache);
            $12584cae6930e094$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $12584cae6930e094$var$pushHostContext(workInProgress);
            break;
        case 4:
            $12584cae6930e094$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $12584cae6930e094$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $12584cae6930e094$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $12584cae6930e094$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $12584cae6930e094$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, $12584cae6930e094$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $12584cae6930e094$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, current.memoizedState.cache);
    }
    return $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $12584cae6930e094$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $12584cae6930e094$var$didReceiveUpdate = !0;
        else {
            if (!$12584cae6930e094$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $12584cae6930e094$var$didReceiveUpdate = !1, $12584cae6930e094$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $12584cae6930e094$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $12584cae6930e094$var$didReceiveUpdate = !1, $12584cae6930e094$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $12584cae6930e094$var$pushTreeId(workInProgress, $12584cae6930e094$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $12584cae6930e094$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $12584cae6930e094$var$shouldConstruct(current) ? (props = $12584cae6930e094$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $12584cae6930e094$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $12584cae6930e094$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $12584cae6930e094$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $12584cae6930e094$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $12584cae6930e094$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $12584cae6930e094$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $12584cae6930e094$var$getComponentNameFromType(current) || current;
                    throw Error($12584cae6930e094$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $12584cae6930e094$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $12584cae6930e094$var$resolveClassComponentProps(props, workInProgress.pendingProps), $12584cae6930e094$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $12584cae6930e094$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($12584cae6930e094$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $12584cae6930e094$var$cloneUpdateQueue(current, workInProgress);
                $12584cae6930e094$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, props);
                props !== prevState.cache && $12584cae6930e094$var$propagateContextChanges(workInProgress, [
                    $12584cae6930e094$var$CacheContext
                ], renderLanes, !0);
                $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $12584cae6930e094$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $12584cae6930e094$var$createCapturedValueAtFiber(Error($12584cae6930e094$var$formatProdErrorMessage(424)), workInProgress);
                        $12584cae6930e094$var$queueHydrationError($$typeof);
                        workInProgress = $12584cae6930e094$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(current.firstChild);
                        $12584cae6930e094$var$hydrationParentFiber = workInProgress;
                        $12584cae6930e094$var$isHydrating = !0;
                        $12584cae6930e094$var$hydrationErrors = null;
                        $12584cae6930e094$var$rootOrSingletonContext = !0;
                        renderLanes = $12584cae6930e094$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $12584cae6930e094$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $12584cae6930e094$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $12584cae6930e094$var$markRef(current, workInProgress), null === current ? (renderLanes = $12584cae6930e094$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $12584cae6930e094$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $12584cae6930e094$var$getOwnerDocumentFromRootContainer($12584cae6930e094$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$12584cae6930e094$var$internalInstanceKey] = workInProgress, props[$12584cae6930e094$var$internalPropsKey] = current, $12584cae6930e094$var$setInitialProperties(props, renderLanes, current), $12584cae6930e094$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $12584cae6930e094$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $12584cae6930e094$var$pushHostContext(workInProgress), null === current && $12584cae6930e094$var$isHydrating && (props = workInProgress.stateNode = $12584cae6930e094$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $12584cae6930e094$var$rootInstanceStackCursor.current), $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$rootOrSingletonContext = !0, $$typeof = $12584cae6930e094$var$nextHydratableInstance, $12584cae6930e094$var$isSingletonScope(workInProgress.type) ? ($12584cae6930e094$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(props.firstChild)) : $12584cae6930e094$var$nextHydratableInstance = $$typeof), $12584cae6930e094$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $12584cae6930e094$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $12584cae6930e094$var$isHydrating) {
                if ($$typeof = props = $12584cae6930e094$var$nextHydratableInstance) props = $12584cae6930e094$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $12584cae6930e094$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(props.firstChild), $12584cae6930e094$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $12584cae6930e094$var$throwOnHydrationMismatch(workInProgress);
            }
            $12584cae6930e094$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $12584cae6930e094$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $12584cae6930e094$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $12584cae6930e094$var$renderWithHooks(current, workInProgress, $12584cae6930e094$var$TransitionAwareHostComponent, null, null, renderLanes), $12584cae6930e094$var$HostTransitionContext._currentValue = $$typeof);
            $12584cae6930e094$var$markRef(current, workInProgress);
            $12584cae6930e094$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $12584cae6930e094$var$isHydrating) {
                if (current = renderLanes = $12584cae6930e094$var$nextHydratableInstance) renderLanes = $12584cae6930e094$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $12584cae6930e094$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $12584cae6930e094$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $12584cae6930e094$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $12584cae6930e094$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $12584cae6930e094$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $12584cae6930e094$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $12584cae6930e094$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $12584cae6930e094$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $12584cae6930e094$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $12584cae6930e094$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $12584cae6930e094$var$pushProvider(workInProgress, workInProgress.type, props.value), $12584cae6930e094$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $12584cae6930e094$var$prepareToReadContext(workInProgress), $$typeof = $12584cae6930e094$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $12584cae6930e094$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $12584cae6930e094$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $12584cae6930e094$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $12584cae6930e094$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $12584cae6930e094$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $12584cae6930e094$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $12584cae6930e094$var$prepareToReadContext(workInProgress), props = $12584cae6930e094$var$readContext($12584cae6930e094$var$CacheContext), null === current ? ($$typeof = $12584cae6930e094$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $12584cae6930e094$var$workInProgressRoot, prevState = $12584cae6930e094$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $12584cae6930e094$var$initializeUpdateQueue(workInProgress), $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($12584cae6930e094$var$cloneUpdateQueue(current, workInProgress), $12584cae6930e094$var$processUpdateQueue(workInProgress, null, null, renderLanes), $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, props)) : (props = prevState.cache, $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, props), props !== $$typeof.cache && $12584cae6930e094$var$propagateContextChanges(workInProgress, [
                $12584cae6930e094$var$CacheContext
            ], renderLanes, !0))), $12584cae6930e094$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($12584cae6930e094$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $12584cae6930e094$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $12584cae6930e094$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($12584cae6930e094$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $12584cae6930e094$var$suspendedThenable = $12584cae6930e094$var$noopSuspenseyCommitThenable, $12584cae6930e094$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $12584cae6930e094$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$12584cae6930e094$var$preloadResource(resource)) {
        if ($12584cae6930e094$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $12584cae6930e094$var$suspendedThenable = $12584cae6930e094$var$noopSuspenseyCommitThenable, $12584cae6930e094$var$SuspenseyCommitException;
    }
}
function $12584cae6930e094$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $12584cae6930e094$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $12584cae6930e094$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $12584cae6930e094$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$12584cae6930e094$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $12584cae6930e094$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $12584cae6930e094$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $12584cae6930e094$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $12584cae6930e094$var$bubbleProperties(workInProgress), null;
        case 1:
            return $12584cae6930e094$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext);
            $12584cae6930e094$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $12584cae6930e094$var$popHydrationState(workInProgress) ? $12584cae6930e094$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $12584cae6930e094$var$upgradeHydrationErrorsToRecoverable());
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($12584cae6930e094$var$markUpdate(workInProgress), null !== nextResource ? ($12584cae6930e094$var$bubbleProperties(workInProgress), $12584cae6930e094$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($12584cae6930e094$var$bubbleProperties(workInProgress), $12584cae6930e094$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($12584cae6930e094$var$markUpdate(workInProgress), $12584cae6930e094$var$bubbleProperties(workInProgress), $12584cae6930e094$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($12584cae6930e094$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $12584cae6930e094$var$markUpdate(workInProgress), $12584cae6930e094$var$bubbleProperties(workInProgress), $12584cae6930e094$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $12584cae6930e094$var$popHostContext(workInProgress);
            renderLanes = $12584cae6930e094$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $12584cae6930e094$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($12584cae6930e094$var$formatProdErrorMessage(166));
                    $12584cae6930e094$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $12584cae6930e094$var$contextStackCursor.current;
                $12584cae6930e094$var$popHydrationState(workInProgress) ? $12584cae6930e094$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $12584cae6930e094$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $12584cae6930e094$var$markUpdate(workInProgress));
            }
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $12584cae6930e094$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $12584cae6930e094$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($12584cae6930e094$var$formatProdErrorMessage(166));
                    $12584cae6930e094$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $12584cae6930e094$var$contextStackCursor.current;
                if ($12584cae6930e094$var$popHydrationState(workInProgress)) $12584cae6930e094$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $12584cae6930e094$var$getOwnerDocumentFromRootContainer($12584cae6930e094$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$12584cae6930e094$var$internalInstanceKey] = workInProgress;
                    nextResource[$12584cae6930e094$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($12584cae6930e094$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $12584cae6930e094$var$markUpdate(workInProgress);
                }
            }
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            $12584cae6930e094$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $12584cae6930e094$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($12584cae6930e094$var$formatProdErrorMessage(166));
                current = $12584cae6930e094$var$rootInstanceStackCursor.current;
                if ($12584cae6930e094$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $12584cae6930e094$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$12584cae6930e094$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $12584cae6930e094$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $12584cae6930e094$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $12584cae6930e094$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$12584cae6930e094$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $12584cae6930e094$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($12584cae6930e094$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($12584cae6930e094$var$formatProdErrorMessage(557));
                        current[$12584cae6930e094$var$internalInstanceKey] = workInProgress;
                    } else $12584cae6930e094$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $12584cae6930e094$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $12584cae6930e094$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $12584cae6930e094$var$popSuspenseHandler(workInProgress), workInProgress;
                    $12584cae6930e094$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($12584cae6930e094$var$formatProdErrorMessage(558));
            }
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $12584cae6930e094$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($12584cae6930e094$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($12584cae6930e094$var$formatProdErrorMessage(317));
                        type[$12584cae6930e094$var$internalInstanceKey] = workInProgress;
                    } else $12584cae6930e094$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $12584cae6930e094$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $12584cae6930e094$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $12584cae6930e094$var$popSuspenseHandler(workInProgress), workInProgress;
                    $12584cae6930e094$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $12584cae6930e094$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $12584cae6930e094$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $12584cae6930e094$var$popHostContainer(), null === current && $12584cae6930e094$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $12584cae6930e094$var$bubbleProperties(workInProgress), null;
        case 10:
            return $12584cae6930e094$var$popProvider(workInProgress.type), $12584cae6930e094$var$bubbleProperties(workInProgress), null;
        case 19:
            $12584cae6930e094$var$pop($12584cae6930e094$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $12584cae6930e094$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $12584cae6930e094$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $12584cae6930e094$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $12584cae6930e094$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $12584cae6930e094$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $12584cae6930e094$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$12584cae6930e094$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, $12584cae6930e094$var$suspenseStackCursor.current & 1 | 2);
                            $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $12584cae6930e094$var$now() > $12584cae6930e094$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $12584cae6930e094$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $12584cae6930e094$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $12584cae6930e094$var$scheduleRetryEffect(workInProgress, current), $12584cae6930e094$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$12584cae6930e094$var$isHydrating) return $12584cae6930e094$var$bubbleProperties(workInProgress), null;
                    } else 2 * $12584cae6930e094$var$now() - newProps.renderingStartTime > $12584cae6930e094$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $12584cae6930e094$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $12584cae6930e094$var$now(), current.sibling = null, renderLanes = $12584cae6930e094$var$suspenseStackCursor.current, $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $12584cae6930e094$var$popSuspenseHandler(workInProgress), $12584cae6930e094$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($12584cae6930e094$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $12584cae6930e094$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $12584cae6930e094$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $12584cae6930e094$var$pop($12584cae6930e094$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext), $12584cae6930e094$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($12584cae6930e094$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $12584cae6930e094$var$unwindWork(current, workInProgress) {
    $12584cae6930e094$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext), $12584cae6930e094$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $12584cae6930e094$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $12584cae6930e094$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($12584cae6930e094$var$formatProdErrorMessage(340));
                $12584cae6930e094$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $12584cae6930e094$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($12584cae6930e094$var$formatProdErrorMessage(340));
                $12584cae6930e094$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $12584cae6930e094$var$pop($12584cae6930e094$var$suspenseStackCursor), null;
        case 4:
            return $12584cae6930e094$var$popHostContainer(), null;
        case 10:
            return $12584cae6930e094$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $12584cae6930e094$var$popSuspenseHandler(workInProgress), $12584cae6930e094$var$popHiddenContext(), null !== current && $12584cae6930e094$var$pop($12584cae6930e094$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $12584cae6930e094$var$unwindInterruptedWork(current, interruptedWork) {
    $12584cae6930e094$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext);
            $12584cae6930e094$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $12584cae6930e094$var$popHostContext(interruptedWork);
            break;
        case 4:
            $12584cae6930e094$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $12584cae6930e094$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $12584cae6930e094$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $12584cae6930e094$var$pop($12584cae6930e094$var$suspenseStackCursor);
            break;
        case 10:
            $12584cae6930e094$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $12584cae6930e094$var$popSuspenseHandler(interruptedWork);
            $12584cae6930e094$var$popHiddenContext();
            null !== current && $12584cae6930e094$var$pop($12584cae6930e094$var$resumedCache);
            break;
        case 24:
            $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext);
    }
}
function $12584cae6930e094$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $12584cae6930e094$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $12584cae6930e094$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $12584cae6930e094$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $12584cae6930e094$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $12584cae6930e094$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $12584cae6930e094$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $12584cae6930e094$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $12584cae6930e094$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $12584cae6930e094$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $12584cae6930e094$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $12584cae6930e094$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $12584cae6930e094$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $12584cae6930e094$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$12584cae6930e094$var$internalPropsKey] = newProps;
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $12584cae6930e094$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $12584cae6930e094$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $12584cae6930e094$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $12584cae6930e094$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $12584cae6930e094$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $12584cae6930e094$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $12584cae6930e094$var$noop$1));
    else if (4 !== tag && (27 === tag && $12584cae6930e094$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($12584cae6930e094$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$12584cae6930e094$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $12584cae6930e094$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $12584cae6930e094$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($12584cae6930e094$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$12584cae6930e094$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $12584cae6930e094$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $12584cae6930e094$var$setInitialProperties(singleton, type, props);
        singleton[$12584cae6930e094$var$internalInstanceKey] = finishedWork;
        singleton[$12584cae6930e094$var$internalPropsKey] = props;
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $12584cae6930e094$var$offscreenSubtreeIsHidden = !1, $12584cae6930e094$var$offscreenSubtreeWasHidden = !1, $12584cae6930e094$var$needsFormReset = !1, $12584cae6930e094$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $12584cae6930e094$var$nextEffect = null;
function $12584cae6930e094$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $12584cae6930e094$var$eventsEnabled = $12584cae6930e094$var$_enabled;
    root = $12584cae6930e094$var$getActiveElementDeep(root);
    if ($12584cae6930e094$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $12584cae6930e094$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $12584cae6930e094$var$_enabled = !1;
    for($12584cae6930e094$var$nextEffect = firstChild; null !== $12584cae6930e094$var$nextEffect;)if (firstChild = $12584cae6930e094$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $12584cae6930e094$var$nextEffect = root;
    else for(; null !== $12584cae6930e094$var$nextEffect;){
        firstChild = $12584cae6930e094$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $12584cae6930e094$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $12584cae6930e094$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $12584cae6930e094$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $12584cae6930e094$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($12584cae6930e094$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $12584cae6930e094$var$nextEffect = root;
            break;
        }
        $12584cae6930e094$var$nextEffect = firstChild.return;
    }
}
function $12584cae6930e094$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $12584cae6930e094$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $12584cae6930e094$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $12584cae6930e094$var$commitClassCallbacks(finishedWork);
            flags & 512 && $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $12584cae6930e094$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $12584cae6930e094$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $12584cae6930e094$var$commitHostMount(finishedWork);
            flags & 512 && $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $12584cae6930e094$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $12584cae6930e094$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $12584cae6930e094$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $12584cae6930e094$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $12584cae6930e094$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $12584cae6930e094$var$offscreenSubtreeWasHidden;
                prevProps = $12584cae6930e094$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $12584cae6930e094$var$offscreenSubtreeWasHidden;
                $12584cae6930e094$var$offscreenSubtreeIsHidden = flags;
                ($12584cae6930e094$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $12584cae6930e094$var$offscreenSubtreeIsHidden = prevProps;
                $12584cae6930e094$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $12584cae6930e094$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $12584cae6930e094$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $12584cae6930e094$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $12584cae6930e094$var$hostParent = null, $12584cae6930e094$var$hostParentIsContainer = !1;
function $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$12584cae6930e094$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $12584cae6930e094$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($12584cae6930e094$var$injectedHook && "function" === typeof $12584cae6930e094$var$injectedHook.onCommitFiberUnmount) try {
        $12584cae6930e094$var$injectedHook.onCommitFiberUnmount($12584cae6930e094$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $12584cae6930e094$var$offscreenSubtreeWasHidden || $12584cae6930e094$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $12584cae6930e094$var$offscreenSubtreeWasHidden || $12584cae6930e094$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $12584cae6930e094$var$hostParent, prevHostParentIsContainer = $12584cae6930e094$var$hostParentIsContainer;
            $12584cae6930e094$var$isSingletonScope(deletedFiber.type) && ($12584cae6930e094$var$hostParent = deletedFiber.stateNode, $12584cae6930e094$var$hostParentIsContainer = !1);
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $12584cae6930e094$var$releaseSingletonInstance(deletedFiber.stateNode);
            $12584cae6930e094$var$hostParent = prevHostParent;
            $12584cae6930e094$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $12584cae6930e094$var$offscreenSubtreeWasHidden || $12584cae6930e094$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $12584cae6930e094$var$hostParent;
            prevHostParentIsContainer = $12584cae6930e094$var$hostParentIsContainer;
            $12584cae6930e094$var$hostParent = null;
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $12584cae6930e094$var$hostParent = prevHostParent;
            $12584cae6930e094$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $12584cae6930e094$var$hostParent) {
                if ($12584cae6930e094$var$hostParentIsContainer) try {
                    (9 === $12584cae6930e094$var$hostParent.nodeType ? $12584cae6930e094$var$hostParent.body : "HTML" === $12584cae6930e094$var$hostParent.nodeName ? $12584cae6930e094$var$hostParent.ownerDocument.body : $12584cae6930e094$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $12584cae6930e094$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $12584cae6930e094$var$hostParent && ($12584cae6930e094$var$hostParentIsContainer ? (finishedRoot = $12584cae6930e094$var$hostParent, $12584cae6930e094$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $12584cae6930e094$var$retryIfBlockedOn(finishedRoot)) : $12584cae6930e094$var$clearHydrationBoundary($12584cae6930e094$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $12584cae6930e094$var$hostParent;
            prevHostParentIsContainer = $12584cae6930e094$var$hostParentIsContainer;
            $12584cae6930e094$var$hostParent = deletedFiber.stateNode.containerInfo;
            $12584cae6930e094$var$hostParentIsContainer = !0;
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $12584cae6930e094$var$hostParent = prevHostParent;
            $12584cae6930e094$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $12584cae6930e094$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $12584cae6930e094$var$offscreenSubtreeWasHidden || $12584cae6930e094$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $12584cae6930e094$var$offscreenSubtreeWasHidden || ($12584cae6930e094$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $12584cae6930e094$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $12584cae6930e094$var$offscreenSubtreeWasHidden = (prevHostParent = $12584cae6930e094$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $12584cae6930e094$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $12584cae6930e094$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $12584cae6930e094$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $12584cae6930e094$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $12584cae6930e094$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $12584cae6930e094$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $12584cae6930e094$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $12584cae6930e094$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($12584cae6930e094$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $12584cae6930e094$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $12584cae6930e094$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $12584cae6930e094$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $12584cae6930e094$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($12584cae6930e094$var$isSingletonScope(parent.type)) {
                        $12584cae6930e094$var$hostParent = parent.stateNode;
                        $12584cae6930e094$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $12584cae6930e094$var$hostParent = parent.stateNode;
                    $12584cae6930e094$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $12584cae6930e094$var$hostParent = parent.stateNode.containerInfo;
                    $12584cae6930e094$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $12584cae6930e094$var$hostParent) throw Error($12584cae6930e094$var$formatProdErrorMessage(160));
        $12584cae6930e094$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $12584cae6930e094$var$hostParent = null;
        $12584cae6930e094$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $12584cae6930e094$var$currentHoistableRoot = null;
function $12584cae6930e094$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($12584cae6930e094$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $12584cae6930e094$var$commitHookEffectListMount(3, finishedWork), $12584cae6930e094$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($12584cae6930e094$var$offscreenSubtreeWasHidden || null === current || $12584cae6930e094$var$safelyDetachRef(current, current.return));
            flags & 64 && $12584cae6930e094$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $12584cae6930e094$var$currentHoistableRoot;
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($12584cae6930e094$var$offscreenSubtreeWasHidden || null === current || $12584cae6930e094$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$12584cae6930e094$var$internalHoistableMarker] || currentResource[$12584cae6930e094$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $12584cae6930e094$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$12584cae6930e094$var$internalInstanceKey] = finishedWork;
                                        $12584cae6930e094$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $12584cae6930e094$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $12584cae6930e094$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $12584cae6930e094$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $12584cae6930e094$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($12584cae6930e094$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$12584cae6930e094$var$internalInstanceKey] = finishedWork;
                                $12584cae6930e094$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $12584cae6930e094$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $12584cae6930e094$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $12584cae6930e094$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $12584cae6930e094$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $12584cae6930e094$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($12584cae6930e094$var$offscreenSubtreeWasHidden || null === current || $12584cae6930e094$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $12584cae6930e094$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($12584cae6930e094$var$offscreenSubtreeWasHidden || null === current || $12584cae6930e094$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $12584cae6930e094$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $12584cae6930e094$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($12584cae6930e094$var$needsFormReset = !0);
            break;
        case 6:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($12584cae6930e094$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $12584cae6930e094$var$tagCaches = null;
            hoistableRoot = $12584cae6930e094$var$currentHoistableRoot;
            $12584cae6930e094$var$currentHoistableRoot = $12584cae6930e094$var$getHoistableRoot(root.containerInfo);
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$currentHoistableRoot = hoistableRoot;
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $12584cae6930e094$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $12584cae6930e094$var$needsFormReset && ($12584cae6930e094$var$needsFormReset = !1, $12584cae6930e094$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $12584cae6930e094$var$currentHoistableRoot;
            $12584cae6930e094$var$currentHoistableRoot = $12584cae6930e094$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            $12584cae6930e094$var$currentHoistableRoot = flags;
            break;
        case 12:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $12584cae6930e094$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($12584cae6930e094$var$globalMostRecentFallbackTime = $12584cae6930e094$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $12584cae6930e094$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $12584cae6930e094$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $12584cae6930e094$var$offscreenSubtreeWasHidden;
            $12584cae6930e094$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $12584cae6930e094$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $12584cae6930e094$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $12584cae6930e094$var$offscreenSubtreeIsHidden || $12584cae6930e094$var$offscreenSubtreeWasHidden || $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $12584cae6930e094$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $12584cae6930e094$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $12584cae6930e094$var$hideOrUnhideDehydratedBoundary(instance, !0) : $12584cae6930e094$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $12584cae6930e094$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $12584cae6930e094$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $12584cae6930e094$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork), $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
    }
}
function $12584cae6930e094$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($12584cae6930e094$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($12584cae6930e094$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $12584cae6930e094$var$getHostSibling(finishedWork);
                    $12584cae6930e094$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($12584cae6930e094$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $12584cae6930e094$var$getHostSibling(finishedWork);
                    $12584cae6930e094$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $12584cae6930e094$var$getHostSibling(finishedWork);
                    $12584cae6930e094$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($12584cae6930e094$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $12584cae6930e094$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $12584cae6930e094$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $12584cae6930e094$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $12584cae6930e094$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $12584cae6930e094$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $12584cae6930e094$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $12584cae6930e094$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $12584cae6930e094$var$safelyDetachRef(finishedWork, finishedWork.return);
                $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $12584cae6930e094$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$12584cae6930e094$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $12584cae6930e094$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $12584cae6930e094$var$commitClassCallbacks(finishedWork);
                $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $12584cae6930e094$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $12584cae6930e094$var$commitHostMount(finishedWork);
                $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $12584cae6930e094$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $12584cae6930e094$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $12584cae6930e094$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $12584cae6930e094$var$releaseCache(previousCache));
}
function $12584cae6930e094$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $12584cae6930e094$var$releaseCache(current));
}
function $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $12584cae6930e094$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $12584cae6930e094$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $12584cae6930e094$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $12584cae6930e094$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $12584cae6930e094$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $12584cae6930e094$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $12584cae6930e094$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $12584cae6930e094$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $12584cae6930e094$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $12584cae6930e094$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $12584cae6930e094$var$suspenseyCommitFlag = 8192;
function $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $12584cae6930e094$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $12584cae6930e094$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $12584cae6930e094$var$suspenseyCommitFlag && null !== fiber.memoizedState && $12584cae6930e094$var$suspendResource(suspendedState, $12584cae6930e094$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $12584cae6930e094$var$currentHoistableRoot;
            $12584cae6930e094$var$currentHoistableRoot = $12584cae6930e094$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $12584cae6930e094$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $12584cae6930e094$var$suspenseyCommitFlag, $12584cae6930e094$var$suspenseyCommitFlag = 16777216, $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $12584cae6930e094$var$suspenseyCommitFlag = previousHoistableRoot) : $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $12584cae6930e094$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $12584cae6930e094$var$nextEffect = childToDelete;
            $12584cae6930e094$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $12584cae6930e094$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $12584cae6930e094$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $12584cae6930e094$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $12584cae6930e094$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $12584cae6930e094$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $12584cae6930e094$var$nextEffect = childToDelete;
            $12584cae6930e094$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $12584cae6930e094$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $12584cae6930e094$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $12584cae6930e094$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $12584cae6930e094$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $12584cae6930e094$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $12584cae6930e094$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $12584cae6930e094$var$nextEffect;){
        var fiber = $12584cae6930e094$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $12584cae6930e094$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $12584cae6930e094$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $12584cae6930e094$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $12584cae6930e094$var$nextEffect;){
            cache = $12584cae6930e094$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $12584cae6930e094$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $12584cae6930e094$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $12584cae6930e094$var$nextEffect = sibling;
                break a;
            }
            $12584cae6930e094$var$nextEffect = returnFiber;
        }
    }
}
var $12584cae6930e094$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $12584cae6930e094$var$readContext($12584cae6930e094$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $12584cae6930e094$var$readContext($12584cae6930e094$var$CacheContext).controller.signal;
    }
}, $12584cae6930e094$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $12584cae6930e094$var$executionContext = 0, $12584cae6930e094$var$workInProgressRoot = null, $12584cae6930e094$var$workInProgress = null, $12584cae6930e094$var$workInProgressRootRenderLanes = 0, $12584cae6930e094$var$workInProgressSuspendedReason = 0, $12584cae6930e094$var$workInProgressThrownValue = null, $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings = !1, $12584cae6930e094$var$workInProgressRootIsPrerendering = !1, $12584cae6930e094$var$workInProgressRootDidAttachPingListener = !1, $12584cae6930e094$var$entangledRenderLanes = 0, $12584cae6930e094$var$workInProgressRootExitStatus = 0, $12584cae6930e094$var$workInProgressRootSkippedLanes = 0, $12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes = 0, $12584cae6930e094$var$workInProgressRootPingedLanes = 0, $12584cae6930e094$var$workInProgressDeferredLane = 0, $12584cae6930e094$var$workInProgressSuspendedRetryLanes = 0, $12584cae6930e094$var$workInProgressRootConcurrentErrors = null, $12584cae6930e094$var$workInProgressRootRecoverableErrors = null, $12584cae6930e094$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $12584cae6930e094$var$globalMostRecentFallbackTime = 0, $12584cae6930e094$var$globalMostRecentTransitionTime = 0, $12584cae6930e094$var$workInProgressRootRenderTargetTime = Infinity, $12584cae6930e094$var$workInProgressTransitions = null, $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed = null, $12584cae6930e094$var$pendingEffectsStatus = 0, $12584cae6930e094$var$pendingEffectsRoot = null, $12584cae6930e094$var$pendingFinishedWork = null, $12584cae6930e094$var$pendingEffectsLanes = 0, $12584cae6930e094$var$pendingEffectsRemainingLanes = 0, $12584cae6930e094$var$pendingPassiveTransitions = null, $12584cae6930e094$var$pendingRecoverableErrors = null, $12584cae6930e094$var$nestedUpdateCount = 0, $12584cae6930e094$var$rootWithNestedUpdates = null;
function $12584cae6930e094$var$requestUpdateLane() {
    return 0 !== ($12584cae6930e094$var$executionContext & 2) && 0 !== $12584cae6930e094$var$workInProgressRootRenderLanes ? $12584cae6930e094$var$workInProgressRootRenderLanes & -$12584cae6930e094$var$workInProgressRootRenderLanes : null !== $12584cae6930e094$var$ReactSharedInternals.T ? $12584cae6930e094$var$requestTransitionLane() : $12584cae6930e094$var$resolveUpdatePriority();
}
function $12584cae6930e094$var$requestDeferredLane() {
    if (0 === $12584cae6930e094$var$workInProgressDeferredLane) {
        if (0 === ($12584cae6930e094$var$workInProgressRootRenderLanes & 536870912) || $12584cae6930e094$var$isHydrating) {
            var lane = $12584cae6930e094$var$nextTransitionDeferredLane;
            $12584cae6930e094$var$nextTransitionDeferredLane <<= 1;
            0 === ($12584cae6930e094$var$nextTransitionDeferredLane & 3932160) && ($12584cae6930e094$var$nextTransitionDeferredLane = 262144);
            $12584cae6930e094$var$workInProgressDeferredLane = lane;
        } else $12584cae6930e094$var$workInProgressDeferredLane = 536870912;
    }
    lane = $12584cae6930e094$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $12584cae6930e094$var$workInProgressDeferredLane;
}
function $12584cae6930e094$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $12584cae6930e094$var$workInProgressRoot && (2 === $12584cae6930e094$var$workInProgressSuspendedReason || 9 === $12584cae6930e094$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $12584cae6930e094$var$prepareFreshStack(root, 0), $12584cae6930e094$var$markRootSuspended(root, $12584cae6930e094$var$workInProgressRootRenderLanes, $12584cae6930e094$var$workInProgressDeferredLane, !1);
    $12584cae6930e094$var$markRootUpdated$1(root, lane);
    if (0 === ($12584cae6930e094$var$executionContext & 2) || root !== $12584cae6930e094$var$workInProgressRoot) root === $12584cae6930e094$var$workInProgressRoot && (0 === ($12584cae6930e094$var$executionContext & 2) && ($12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $12584cae6930e094$var$workInProgressRootExitStatus && $12584cae6930e094$var$markRootSuspended(root, $12584cae6930e094$var$workInProgressRootRenderLanes, $12584cae6930e094$var$workInProgressDeferredLane, !1)), $12584cae6930e094$var$ensureRootIsScheduled(root);
}
function $12584cae6930e094$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($12584cae6930e094$var$executionContext & 6)) throw Error($12584cae6930e094$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $12584cae6930e094$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $12584cae6930e094$var$renderRootConcurrent(root$jscomp$0, lanes) : $12584cae6930e094$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $12584cae6930e094$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $12584cae6930e094$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$12584cae6930e094$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $12584cae6930e094$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $12584cae6930e094$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($12584cae6930e094$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $12584cae6930e094$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($12584cae6930e094$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $12584cae6930e094$var$workInProgressRootRecoverableErrors;
                            $12584cae6930e094$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $12584cae6930e094$var$workInProgressRootRecoverableErrors ? $12584cae6930e094$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $12584cae6930e094$var$workInProgressRootRecoverableErrors.push.apply($12584cae6930e094$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $12584cae6930e094$var$prepareFreshStack(root$jscomp$0, 0);
                $12584cae6930e094$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($12584cae6930e094$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $12584cae6930e094$var$markRootSuspended(shouldTimeSlice, lanes, $12584cae6930e094$var$workInProgressDeferredLane, !$12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $12584cae6930e094$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($12584cae6930e094$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $12584cae6930e094$var$globalMostRecentFallbackTime + 300 - $12584cae6930e094$var$now(), 10 < exitStatus)) {
                    $12584cae6930e094$var$markRootSuspended(shouldTimeSlice, lanes, $12584cae6930e094$var$workInProgressDeferredLane, !$12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $12584cae6930e094$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $12584cae6930e094$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $12584cae6930e094$var$scheduleTimeout($12584cae6930e094$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $12584cae6930e094$var$workInProgressRootRecoverableErrors, $12584cae6930e094$var$workInProgressTransitions, $12584cae6930e094$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $12584cae6930e094$var$workInProgressDeferredLane, $12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes, $12584cae6930e094$var$workInProgressSuspendedRetryLanes, $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $12584cae6930e094$var$commitRootWhenReady(shouldTimeSlice, forceSync, $12584cae6930e094$var$workInProgressRootRecoverableErrors, $12584cae6930e094$var$workInProgressTransitions, $12584cae6930e094$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $12584cae6930e094$var$workInProgressDeferredLane, $12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes, $12584cae6930e094$var$workInProgressSuspendedRetryLanes, $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $12584cae6930e094$var$ensureRootIsScheduled(root$jscomp$0);
}
function $12584cae6930e094$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $12584cae6930e094$var$noop$1
        };
        $12584cae6930e094$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $12584cae6930e094$var$globalMostRecentFallbackTime - $12584cae6930e094$var$now() : (lanes & 4194048) === lanes ? $12584cae6930e094$var$globalMostRecentTransitionTime - $12584cae6930e094$var$now() : 0;
        timeoutOffset = $12584cae6930e094$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $12584cae6930e094$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($12584cae6930e094$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $12584cae6930e094$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $12584cae6930e094$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $12584cae6930e094$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$12584cae6930e094$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $12584cae6930e094$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$12584cae6930e094$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $12584cae6930e094$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $12584cae6930e094$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $12584cae6930e094$var$flushSyncWork$1() {
    return 0 === ($12584cae6930e094$var$executionContext & 6) ? ($12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $12584cae6930e094$var$resetWorkInProgressStack() {
    if (null !== $12584cae6930e094$var$workInProgress) {
        if (0 === $12584cae6930e094$var$workInProgressSuspendedReason) var interruptedWork = $12584cae6930e094$var$workInProgress.return;
        else interruptedWork = $12584cae6930e094$var$workInProgress, $12584cae6930e094$var$lastContextDependency = $12584cae6930e094$var$currentlyRenderingFiber$1 = null, $12584cae6930e094$var$resetHooksOnUnwind(interruptedWork), $12584cae6930e094$var$thenableState$1 = null, $12584cae6930e094$var$thenableIndexCounter$1 = 0, interruptedWork = $12584cae6930e094$var$workInProgress;
        for(; null !== interruptedWork;)$12584cae6930e094$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $12584cae6930e094$var$workInProgress = null;
    }
}
function $12584cae6930e094$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $12584cae6930e094$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $12584cae6930e094$var$pendingEffectsLanes = 0;
    $12584cae6930e094$var$resetWorkInProgressStack();
    $12584cae6930e094$var$workInProgressRoot = root;
    $12584cae6930e094$var$workInProgress = timeoutHandle = $12584cae6930e094$var$createWorkInProgress(root.current, null);
    $12584cae6930e094$var$workInProgressRootRenderLanes = lanes;
    $12584cae6930e094$var$workInProgressSuspendedReason = 0;
    $12584cae6930e094$var$workInProgressThrownValue = null;
    $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $12584cae6930e094$var$workInProgressRootIsPrerendering = $12584cae6930e094$var$checkIfRootIsPrerendering(root, lanes);
    $12584cae6930e094$var$workInProgressRootDidAttachPingListener = !1;
    $12584cae6930e094$var$workInProgressSuspendedRetryLanes = $12584cae6930e094$var$workInProgressDeferredLane = $12584cae6930e094$var$workInProgressRootPingedLanes = $12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes = $12584cae6930e094$var$workInProgressRootSkippedLanes = $12584cae6930e094$var$workInProgressRootExitStatus = 0;
    $12584cae6930e094$var$workInProgressRootRecoverableErrors = $12584cae6930e094$var$workInProgressRootConcurrentErrors = null;
    $12584cae6930e094$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $12584cae6930e094$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $12584cae6930e094$var$entangledRenderLanes = lanes;
    $12584cae6930e094$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $12584cae6930e094$var$handleThrow(root, thrownValue) {
    $12584cae6930e094$var$currentlyRenderingFiber = null;
    $12584cae6930e094$var$ReactSharedInternals.H = $12584cae6930e094$var$ContextOnlyDispatcher;
    thrownValue === $12584cae6930e094$var$SuspenseException || thrownValue === $12584cae6930e094$var$SuspenseActionException ? (thrownValue = $12584cae6930e094$var$getSuspendedThenable(), $12584cae6930e094$var$workInProgressSuspendedReason = 3) : thrownValue === $12584cae6930e094$var$SuspenseyCommitException ? (thrownValue = $12584cae6930e094$var$getSuspendedThenable(), $12584cae6930e094$var$workInProgressSuspendedReason = 4) : $12584cae6930e094$var$workInProgressSuspendedReason = thrownValue === $12584cae6930e094$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $12584cae6930e094$var$workInProgressThrownValue = thrownValue;
    null === $12584cae6930e094$var$workInProgress && ($12584cae6930e094$var$workInProgressRootExitStatus = 1, $12584cae6930e094$var$logUncaughtError(root, $12584cae6930e094$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $12584cae6930e094$var$shouldRemainOnPreviousScreen() {
    var handler = $12584cae6930e094$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($12584cae6930e094$var$workInProgressRootRenderLanes & 4194048) === $12584cae6930e094$var$workInProgressRootRenderLanes ? null === $12584cae6930e094$var$shellBoundary ? !0 : !1 : ($12584cae6930e094$var$workInProgressRootRenderLanes & 62914560) === $12584cae6930e094$var$workInProgressRootRenderLanes || 0 !== ($12584cae6930e094$var$workInProgressRootRenderLanes & 536870912) ? handler === $12584cae6930e094$var$shellBoundary : !1;
}
function $12584cae6930e094$var$pushDispatcher() {
    var prevDispatcher = $12584cae6930e094$var$ReactSharedInternals.H;
    $12584cae6930e094$var$ReactSharedInternals.H = $12584cae6930e094$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $12584cae6930e094$var$ContextOnlyDispatcher : prevDispatcher;
}
function $12584cae6930e094$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $12584cae6930e094$var$ReactSharedInternals.A;
    $12584cae6930e094$var$ReactSharedInternals.A = $12584cae6930e094$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $12584cae6930e094$var$renderDidSuspendDelayIfPossible() {
    $12584cae6930e094$var$workInProgressRootExitStatus = 4;
    $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings || ($12584cae6930e094$var$workInProgressRootRenderLanes & 4194048) !== $12584cae6930e094$var$workInProgressRootRenderLanes && null !== $12584cae6930e094$var$suspenseHandlerStackCursor.current || ($12584cae6930e094$var$workInProgressRootIsPrerendering = !0);
    0 === ($12584cae6930e094$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $12584cae6930e094$var$workInProgressRoot || $12584cae6930e094$var$markRootSuspended($12584cae6930e094$var$workInProgressRoot, $12584cae6930e094$var$workInProgressRootRenderLanes, $12584cae6930e094$var$workInProgressDeferredLane, !1);
}
function $12584cae6930e094$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $12584cae6930e094$var$executionContext;
    $12584cae6930e094$var$executionContext |= 2;
    var prevDispatcher = $12584cae6930e094$var$pushDispatcher(), prevAsyncDispatcher = $12584cae6930e094$var$pushAsyncDispatcher();
    if ($12584cae6930e094$var$workInProgressRoot !== root || $12584cae6930e094$var$workInProgressRootRenderLanes !== lanes) $12584cae6930e094$var$workInProgressTransitions = null, $12584cae6930e094$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $12584cae6930e094$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $12584cae6930e094$var$workInProgressSuspendedReason && null !== $12584cae6930e094$var$workInProgress) {
            var unitOfWork = $12584cae6930e094$var$workInProgress, thrownValue = $12584cae6930e094$var$workInProgressThrownValue;
            switch($12584cae6930e094$var$workInProgressSuspendedReason){
                case 8:
                    $12584cae6930e094$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $12584cae6930e094$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $12584cae6930e094$var$workInProgressSuspendedReason;
                    $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                    $12584cae6930e094$var$workInProgressThrownValue = null;
                    $12584cae6930e094$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $12584cae6930e094$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $12584cae6930e094$var$workInProgressSuspendedReason, $12584cae6930e094$var$workInProgressSuspendedReason = 0, $12584cae6930e094$var$workInProgressThrownValue = null, $12584cae6930e094$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $12584cae6930e094$var$workLoopSync();
        exitStatus = $12584cae6930e094$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $12584cae6930e094$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $12584cae6930e094$var$lastContextDependency = $12584cae6930e094$var$currentlyRenderingFiber$1 = null;
    $12584cae6930e094$var$executionContext = prevExecutionContext;
    $12584cae6930e094$var$ReactSharedInternals.H = prevDispatcher;
    $12584cae6930e094$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $12584cae6930e094$var$workInProgress && ($12584cae6930e094$var$workInProgressRoot = null, $12584cae6930e094$var$workInProgressRootRenderLanes = 0, $12584cae6930e094$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $12584cae6930e094$var$workLoopSync() {
    for(; null !== $12584cae6930e094$var$workInProgress;)$12584cae6930e094$var$performUnitOfWork($12584cae6930e094$var$workInProgress);
}
function $12584cae6930e094$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $12584cae6930e094$var$executionContext;
    $12584cae6930e094$var$executionContext |= 2;
    var prevDispatcher = $12584cae6930e094$var$pushDispatcher(), prevAsyncDispatcher = $12584cae6930e094$var$pushAsyncDispatcher();
    $12584cae6930e094$var$workInProgressRoot !== root || $12584cae6930e094$var$workInProgressRootRenderLanes !== lanes ? ($12584cae6930e094$var$workInProgressTransitions = null, $12584cae6930e094$var$workInProgressRootRenderTargetTime = $12584cae6930e094$var$now() + 500, $12584cae6930e094$var$prepareFreshStack(root, lanes)) : $12584cae6930e094$var$workInProgressRootIsPrerendering = $12584cae6930e094$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $12584cae6930e094$var$workInProgressSuspendedReason && null !== $12584cae6930e094$var$workInProgress) {
            lanes = $12584cae6930e094$var$workInProgress;
            var thrownValue = $12584cae6930e094$var$workInProgressThrownValue;
            b: switch($12584cae6930e094$var$workInProgressSuspendedReason){
                case 1:
                    $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                    $12584cae6930e094$var$workInProgressThrownValue = null;
                    $12584cae6930e094$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($12584cae6930e094$var$isThenableResolved(thrownValue)) {
                        $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                        $12584cae6930e094$var$workInProgressThrownValue = null;
                        $12584cae6930e094$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $12584cae6930e094$var$workInProgressSuspendedReason && 9 !== $12584cae6930e094$var$workInProgressSuspendedReason || $12584cae6930e094$var$workInProgressRoot !== root || ($12584cae6930e094$var$workInProgressSuspendedReason = 7);
                        $12584cae6930e094$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $12584cae6930e094$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $12584cae6930e094$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $12584cae6930e094$var$isThenableResolved(thrownValue) ? ($12584cae6930e094$var$workInProgressSuspendedReason = 0, $12584cae6930e094$var$workInProgressThrownValue = null, $12584cae6930e094$var$replaySuspendedUnitOfWork(lanes)) : ($12584cae6930e094$var$workInProgressSuspendedReason = 0, $12584cae6930e094$var$workInProgressThrownValue = null, $12584cae6930e094$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($12584cae6930e094$var$workInProgress.tag){
                        case 26:
                            resource = $12584cae6930e094$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $12584cae6930e094$var$workInProgress;
                            if (resource ? $12584cae6930e094$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                                $12584cae6930e094$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $12584cae6930e094$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($12584cae6930e094$var$workInProgress = returnFiber, $12584cae6930e094$var$completeUnitOfWork(returnFiber)) : $12584cae6930e094$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                    $12584cae6930e094$var$workInProgressThrownValue = null;
                    $12584cae6930e094$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                    $12584cae6930e094$var$workInProgressThrownValue = null;
                    $12584cae6930e094$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $12584cae6930e094$var$resetWorkInProgressStack();
                    $12584cae6930e094$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($12584cae6930e094$var$formatProdErrorMessage(462));
            }
        }
        $12584cae6930e094$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $12584cae6930e094$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $12584cae6930e094$var$lastContextDependency = $12584cae6930e094$var$currentlyRenderingFiber$1 = null;
    $12584cae6930e094$var$ReactSharedInternals.H = prevDispatcher;
    $12584cae6930e094$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $12584cae6930e094$var$executionContext = prevExecutionContext;
    if (null !== $12584cae6930e094$var$workInProgress) return 0;
    $12584cae6930e094$var$workInProgressRoot = null;
    $12584cae6930e094$var$workInProgressRootRenderLanes = 0;
    $12584cae6930e094$var$finishQueueingConcurrentUpdates();
    return $12584cae6930e094$var$workInProgressRootExitStatus;
}
function $12584cae6930e094$var$workLoopConcurrentByScheduler() {
    for(; null !== $12584cae6930e094$var$workInProgress && !$12584cae6930e094$var$shouldYield();)$12584cae6930e094$var$performUnitOfWork($12584cae6930e094$var$workInProgress);
}
function $12584cae6930e094$var$performUnitOfWork(unitOfWork) {
    var next = $12584cae6930e094$var$beginWork(unitOfWork.alternate, unitOfWork, $12584cae6930e094$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $12584cae6930e094$var$completeUnitOfWork(unitOfWork) : $12584cae6930e094$var$workInProgress = next;
}
function $12584cae6930e094$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $12584cae6930e094$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $12584cae6930e094$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $12584cae6930e094$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $12584cae6930e094$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $12584cae6930e094$var$resetHooksOnUnwind(next);
        default:
            $12584cae6930e094$var$unwindInterruptedWork(current, next), next = $12584cae6930e094$var$workInProgress = $12584cae6930e094$var$resetWorkInProgress(next, $12584cae6930e094$var$entangledRenderLanes), next = $12584cae6930e094$var$beginWork(current, next, $12584cae6930e094$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $12584cae6930e094$var$completeUnitOfWork(unitOfWork) : $12584cae6930e094$var$workInProgress = next;
}
function $12584cae6930e094$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $12584cae6930e094$var$lastContextDependency = $12584cae6930e094$var$currentlyRenderingFiber$1 = null;
    $12584cae6930e094$var$resetHooksOnUnwind(unitOfWork);
    $12584cae6930e094$var$thenableState$1 = null;
    $12584cae6930e094$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($12584cae6930e094$var$throwException(root, returnFiber, unitOfWork, thrownValue, $12584cae6930e094$var$workInProgressRootRenderLanes)) {
            $12584cae6930e094$var$workInProgressRootExitStatus = 1;
            $12584cae6930e094$var$logUncaughtError(root, $12584cae6930e094$var$createCapturedValueAtFiber(thrownValue, root.current));
            $12584cae6930e094$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $12584cae6930e094$var$workInProgress = returnFiber, error;
        $12584cae6930e094$var$workInProgressRootExitStatus = 1;
        $12584cae6930e094$var$logUncaughtError(root, $12584cae6930e094$var$createCapturedValueAtFiber(thrownValue, root.current));
        $12584cae6930e094$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($12584cae6930e094$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($12584cae6930e094$var$workInProgressRootIsPrerendering || 0 !== ($12584cae6930e094$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $12584cae6930e094$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $12584cae6930e094$var$unwindUnitOfWork(unitOfWork, root);
    } else $12584cae6930e094$var$completeUnitOfWork(unitOfWork);
}
function $12584cae6930e094$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $12584cae6930e094$var$unwindUnitOfWork(completedWork, $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $12584cae6930e094$var$completeWork(completedWork.alternate, completedWork, $12584cae6930e094$var$entangledRenderLanes);
        if (null !== next) {
            $12584cae6930e094$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $12584cae6930e094$var$workInProgress = completedWork;
            return;
        }
        $12584cae6930e094$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $12584cae6930e094$var$workInProgressRootExitStatus && ($12584cae6930e094$var$workInProgressRootExitStatus = 5);
}
function $12584cae6930e094$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $12584cae6930e094$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $12584cae6930e094$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $12584cae6930e094$var$workInProgress = unitOfWork;
            return;
        }
        $12584cae6930e094$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $12584cae6930e094$var$workInProgressRootExitStatus = 6;
    $12584cae6930e094$var$workInProgress = null;
}
function $12584cae6930e094$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $12584cae6930e094$var$flushPendingEffects();
    while (0 !== $12584cae6930e094$var$pendingEffectsStatus);
    if (0 !== ($12584cae6930e094$var$executionContext & 6)) throw Error($12584cae6930e094$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($12584cae6930e094$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $12584cae6930e094$var$concurrentlyUpdatedLanes;
        $12584cae6930e094$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $12584cae6930e094$var$workInProgressRoot && ($12584cae6930e094$var$workInProgress = $12584cae6930e094$var$workInProgressRoot = null, $12584cae6930e094$var$workInProgressRootRenderLanes = 0);
        $12584cae6930e094$var$pendingFinishedWork = finishedWork;
        $12584cae6930e094$var$pendingEffectsRoot = root;
        $12584cae6930e094$var$pendingEffectsLanes = lanes;
        $12584cae6930e094$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $12584cae6930e094$var$pendingPassiveTransitions = transitions;
        $12584cae6930e094$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $12584cae6930e094$var$scheduleCallback$1($12584cae6930e094$var$NormalPriority$1, function() {
            $12584cae6930e094$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $12584cae6930e094$var$ReactSharedInternals.T;
            $12584cae6930e094$var$ReactSharedInternals.T = null;
            transitions = $12584cae6930e094$var$ReactDOMSharedInternals.p;
            $12584cae6930e094$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $12584cae6930e094$var$executionContext;
            $12584cae6930e094$var$executionContext |= 4;
            try {
                $12584cae6930e094$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $12584cae6930e094$var$executionContext = spawnedLane, $12584cae6930e094$var$ReactDOMSharedInternals.p = transitions, $12584cae6930e094$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $12584cae6930e094$var$pendingEffectsStatus = 1;
        $12584cae6930e094$var$flushMutationEffects();
        $12584cae6930e094$var$flushLayoutEffects();
        $12584cae6930e094$var$flushSpawnedWork();
    }
}
function $12584cae6930e094$var$flushMutationEffects() {
    if (1 === $12584cae6930e094$var$pendingEffectsStatus) {
        $12584cae6930e094$var$pendingEffectsStatus = 0;
        var root = $12584cae6930e094$var$pendingEffectsRoot, finishedWork = $12584cae6930e094$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $12584cae6930e094$var$ReactSharedInternals.T;
            $12584cae6930e094$var$ReactSharedInternals.T = null;
            var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
            $12584cae6930e094$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $12584cae6930e094$var$executionContext;
            $12584cae6930e094$var$executionContext |= 4;
            try {
                $12584cae6930e094$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $12584cae6930e094$var$selectionInformation, curFocusedElem = $12584cae6930e094$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $12584cae6930e094$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $12584cae6930e094$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $12584cae6930e094$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $12584cae6930e094$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $12584cae6930e094$var$_enabled = !!$12584cae6930e094$var$eventsEnabled;
                $12584cae6930e094$var$selectionInformation = $12584cae6930e094$var$eventsEnabled = null;
            } finally{
                $12584cae6930e094$var$executionContext = prevExecutionContext, $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, $12584cae6930e094$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $12584cae6930e094$var$pendingEffectsStatus = 2;
    }
}
function $12584cae6930e094$var$flushLayoutEffects() {
    if (2 === $12584cae6930e094$var$pendingEffectsStatus) {
        $12584cae6930e094$var$pendingEffectsStatus = 0;
        var root = $12584cae6930e094$var$pendingEffectsRoot, finishedWork = $12584cae6930e094$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $12584cae6930e094$var$ReactSharedInternals.T;
            $12584cae6930e094$var$ReactSharedInternals.T = null;
            var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
            $12584cae6930e094$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $12584cae6930e094$var$executionContext;
            $12584cae6930e094$var$executionContext |= 4;
            try {
                $12584cae6930e094$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $12584cae6930e094$var$executionContext = prevExecutionContext, $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, $12584cae6930e094$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $12584cae6930e094$var$pendingEffectsStatus = 3;
    }
}
function $12584cae6930e094$var$flushSpawnedWork() {
    if (4 === $12584cae6930e094$var$pendingEffectsStatus || 3 === $12584cae6930e094$var$pendingEffectsStatus) {
        $12584cae6930e094$var$pendingEffectsStatus = 0;
        $12584cae6930e094$var$requestPaint();
        var root = $12584cae6930e094$var$pendingEffectsRoot, finishedWork = $12584cae6930e094$var$pendingFinishedWork, lanes = $12584cae6930e094$var$pendingEffectsLanes, recoverableErrors = $12584cae6930e094$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $12584cae6930e094$var$pendingEffectsStatus = 5 : ($12584cae6930e094$var$pendingEffectsStatus = 0, $12584cae6930e094$var$pendingFinishedWork = $12584cae6930e094$var$pendingEffectsRoot = null, $12584cae6930e094$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $12584cae6930e094$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($12584cae6930e094$var$injectedHook && "function" === typeof $12584cae6930e094$var$injectedHook.onCommitFiberRoot) try {
            $12584cae6930e094$var$injectedHook.onCommitFiberRoot($12584cae6930e094$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $12584cae6930e094$var$ReactSharedInternals.T;
            remainingLanes = $12584cae6930e094$var$ReactDOMSharedInternals.p;
            $12584cae6930e094$var$ReactDOMSharedInternals.p = 2;
            $12584cae6930e094$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $12584cae6930e094$var$ReactSharedInternals.T = finishedWork, $12584cae6930e094$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($12584cae6930e094$var$pendingEffectsLanes & 3) && $12584cae6930e094$var$flushPendingEffects();
        $12584cae6930e094$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $12584cae6930e094$var$rootWithNestedUpdates ? $12584cae6930e094$var$nestedUpdateCount++ : ($12584cae6930e094$var$nestedUpdateCount = 0, $12584cae6930e094$var$rootWithNestedUpdates = root) : $12584cae6930e094$var$nestedUpdateCount = 0;
        $12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $12584cae6930e094$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $12584cae6930e094$var$releaseCache(remainingLanes)));
}
function $12584cae6930e094$var$flushPendingEffects() {
    $12584cae6930e094$var$flushMutationEffects();
    $12584cae6930e094$var$flushLayoutEffects();
    $12584cae6930e094$var$flushSpawnedWork();
    return $12584cae6930e094$var$flushPassiveEffects();
}
function $12584cae6930e094$var$flushPassiveEffects() {
    if (5 !== $12584cae6930e094$var$pendingEffectsStatus) return !1;
    var root = $12584cae6930e094$var$pendingEffectsRoot, remainingLanes = $12584cae6930e094$var$pendingEffectsRemainingLanes;
    $12584cae6930e094$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $12584cae6930e094$var$lanesToEventPriority($12584cae6930e094$var$pendingEffectsLanes), prevTransition = $12584cae6930e094$var$ReactSharedInternals.T, previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    try {
        $12584cae6930e094$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $12584cae6930e094$var$ReactSharedInternals.T = null;
        renderPriority = $12584cae6930e094$var$pendingPassiveTransitions;
        $12584cae6930e094$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $12584cae6930e094$var$pendingEffectsRoot, lanes = $12584cae6930e094$var$pendingEffectsLanes;
        $12584cae6930e094$var$pendingEffectsStatus = 0;
        $12584cae6930e094$var$pendingFinishedWork = $12584cae6930e094$var$pendingEffectsRoot = null;
        $12584cae6930e094$var$pendingEffectsLanes = 0;
        if (0 !== ($12584cae6930e094$var$executionContext & 6)) throw Error($12584cae6930e094$var$formatProdErrorMessage(331));
        var prevExecutionContext = $12584cae6930e094$var$executionContext;
        $12584cae6930e094$var$executionContext |= 4;
        $12584cae6930e094$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $12584cae6930e094$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $12584cae6930e094$var$executionContext = prevExecutionContext;
        $12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($12584cae6930e094$var$injectedHook && "function" === typeof $12584cae6930e094$var$injectedHook.onPostCommitFiberRoot) try {
            $12584cae6930e094$var$injectedHook.onPostCommitFiberRoot($12584cae6930e094$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, $12584cae6930e094$var$ReactSharedInternals.T = prevTransition, $12584cae6930e094$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $12584cae6930e094$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $12584cae6930e094$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $12584cae6930e094$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $12584cae6930e094$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($12584cae6930e094$var$markRootUpdated$1(rootFiber, 2), $12584cae6930e094$var$ensureRootIsScheduled(rootFiber));
}
function $12584cae6930e094$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $12584cae6930e094$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $12584cae6930e094$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed || !$12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $12584cae6930e094$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $12584cae6930e094$var$createClassErrorUpdate(2);
                instance = $12584cae6930e094$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($12584cae6930e094$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $12584cae6930e094$var$markRootUpdated$1(instance, 2), $12584cae6930e094$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $12584cae6930e094$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $12584cae6930e094$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($12584cae6930e094$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $12584cae6930e094$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $12584cae6930e094$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $12584cae6930e094$var$workInProgressRoot === root && ($12584cae6930e094$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $12584cae6930e094$var$workInProgressRootExitStatus || 3 === $12584cae6930e094$var$workInProgressRootExitStatus && ($12584cae6930e094$var$workInProgressRootRenderLanes & 62914560) === $12584cae6930e094$var$workInProgressRootRenderLanes && 300 > $12584cae6930e094$var$now() - $12584cae6930e094$var$globalMostRecentFallbackTime ? 0 === ($12584cae6930e094$var$executionContext & 2) && $12584cae6930e094$var$prepareFreshStack(root, 0) : $12584cae6930e094$var$workInProgressRootPingedLanes |= pingedLanes, $12584cae6930e094$var$workInProgressSuspendedRetryLanes === $12584cae6930e094$var$workInProgressRootRenderLanes && ($12584cae6930e094$var$workInProgressSuspendedRetryLanes = 0));
    $12584cae6930e094$var$ensureRootIsScheduled(root);
}
function $12584cae6930e094$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $12584cae6930e094$var$claimNextRetryLane());
    boundaryFiber = $12584cae6930e094$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($12584cae6930e094$var$markRootUpdated$1(boundaryFiber, retryLane), $12584cae6930e094$var$ensureRootIsScheduled(boundaryFiber));
}
function $12584cae6930e094$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $12584cae6930e094$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $12584cae6930e094$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($12584cae6930e094$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $12584cae6930e094$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $12584cae6930e094$var$scheduleCallback$1(priorityLevel, callback) {
    return $12584cae6930e094$var$scheduleCallback$3(priorityLevel, callback);
}
var $12584cae6930e094$var$firstScheduledRoot = null, $12584cae6930e094$var$lastScheduledRoot = null, $12584cae6930e094$var$didScheduleMicrotask = !1, $12584cae6930e094$var$mightHavePendingSyncWork = !1, $12584cae6930e094$var$isFlushingWork = !1, $12584cae6930e094$var$currentEventTransitionLane = 0;
function $12584cae6930e094$var$ensureRootIsScheduled(root) {
    root !== $12584cae6930e094$var$lastScheduledRoot && null === root.next && (null === $12584cae6930e094$var$lastScheduledRoot ? $12584cae6930e094$var$firstScheduledRoot = $12584cae6930e094$var$lastScheduledRoot = root : $12584cae6930e094$var$lastScheduledRoot = $12584cae6930e094$var$lastScheduledRoot.next = root);
    $12584cae6930e094$var$mightHavePendingSyncWork = !0;
    $12584cae6930e094$var$didScheduleMicrotask || ($12584cae6930e094$var$didScheduleMicrotask = !0, $12584cae6930e094$var$scheduleImmediateRootScheduleTask());
}
function $12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$12584cae6930e094$var$isFlushingWork && $12584cae6930e094$var$mightHavePendingSyncWork) {
        $12584cae6930e094$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $12584cae6930e094$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $12584cae6930e094$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $12584cae6930e094$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $12584cae6930e094$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $12584cae6930e094$var$getNextLanes(root$170, root$170 === $12584cae6930e094$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $12584cae6930e094$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $12584cae6930e094$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $12584cae6930e094$var$isFlushingWork = !1;
    }
}
function $12584cae6930e094$var$processRootScheduleInImmediateTask() {
    $12584cae6930e094$var$processRootScheduleInMicrotask();
}
function $12584cae6930e094$var$processRootScheduleInMicrotask() {
    $12584cae6930e094$var$mightHavePendingSyncWork = $12584cae6930e094$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $12584cae6930e094$var$currentEventTransitionLane && $12584cae6930e094$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $12584cae6930e094$var$currentEventTransitionLane);
    for(var currentTime = $12584cae6930e094$var$now(), prev = null, root = $12584cae6930e094$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $12584cae6930e094$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $12584cae6930e094$var$firstScheduledRoot = next : prev.next = next, null === next && ($12584cae6930e094$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $12584cae6930e094$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $12584cae6930e094$var$pendingEffectsStatus && 5 !== $12584cae6930e094$var$pendingEffectsStatus || $12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $12584cae6930e094$var$currentEventTransitionLane && ($12584cae6930e094$var$currentEventTransitionLane = 0);
}
function $12584cae6930e094$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $12584cae6930e094$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $12584cae6930e094$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $12584cae6930e094$var$workInProgressRoot;
    suspendedLanes = $12584cae6930e094$var$workInProgressRootRenderLanes;
    suspendedLanes = $12584cae6930e094$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $12584cae6930e094$var$workInProgressSuspendedReason || 9 === $12584cae6930e094$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $12584cae6930e094$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $12584cae6930e094$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $12584cae6930e094$var$cancelCallback$1(pingedLanes);
        switch($12584cae6930e094$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $12584cae6930e094$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $12584cae6930e094$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $12584cae6930e094$var$IdlePriority;
                break;
            default:
                suspendedLanes = $12584cae6930e094$var$NormalPriority$1;
        }
        pingedLanes = $12584cae6930e094$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $12584cae6930e094$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $12584cae6930e094$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $12584cae6930e094$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $12584cae6930e094$var$pendingEffectsStatus && 5 !== $12584cae6930e094$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($12584cae6930e094$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $12584cae6930e094$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $12584cae6930e094$var$getNextLanes(root, root === $12584cae6930e094$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $12584cae6930e094$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $12584cae6930e094$var$scheduleTaskForRootDuringMicrotask(root, $12584cae6930e094$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $12584cae6930e094$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $12584cae6930e094$var$performSyncWorkOnRoot(root, lanes) {
    if ($12584cae6930e094$var$flushPendingEffects()) return null;
    $12584cae6930e094$var$performWorkOnRoot(root, lanes, !0);
}
function $12584cae6930e094$var$scheduleImmediateRootScheduleTask() {
    $12584cae6930e094$var$scheduleMicrotask(function() {
        0 !== ($12584cae6930e094$var$executionContext & 6) ? $12584cae6930e094$var$scheduleCallback$3($12584cae6930e094$var$ImmediatePriority, $12584cae6930e094$var$processRootScheduleInImmediateTask) : $12584cae6930e094$var$processRootScheduleInMicrotask();
    });
}
function $12584cae6930e094$var$requestTransitionLane() {
    if (0 === $12584cae6930e094$var$currentEventTransitionLane) {
        var actionScopeLane = $12584cae6930e094$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $12584cae6930e094$var$nextTransitionUpdateLane, $12584cae6930e094$var$nextTransitionUpdateLane <<= 1, 0 === ($12584cae6930e094$var$nextTransitionUpdateLane & 261888) && ($12584cae6930e094$var$nextTransitionUpdateLane = 256));
        $12584cae6930e094$var$currentEventTransitionLane = actionScopeLane;
    }
    return $12584cae6930e094$var$currentEventTransitionLane;
}
function $12584cae6930e094$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $12584cae6930e094$var$sanitizeURL("" + actionProp);
}
function $12584cae6930e094$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $12584cae6930e094$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $12584cae6930e094$var$coerceFormActionProp((nativeEventTarget[$12584cae6930e094$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$12584cae6930e094$var$internalPropsKey] || null) ? $12584cae6930e094$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $12584cae6930e094$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $12584cae6930e094$var$currentEventTransitionLane) {
                                var formData = submitter ? $12584cae6930e094$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $12584cae6930e094$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $12584cae6930e094$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $12584cae6930e094$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $12584cae6930e094$var$i$jscomp$inline_1577 = 0; $12584cae6930e094$var$i$jscomp$inline_1577 < $12584cae6930e094$var$simpleEventPluginEvents.length; $12584cae6930e094$var$i$jscomp$inline_1577++){
    var $12584cae6930e094$var$eventName$jscomp$inline_1578 = $12584cae6930e094$var$simpleEventPluginEvents[$12584cae6930e094$var$i$jscomp$inline_1577], $12584cae6930e094$var$domEventName$jscomp$inline_1579 = $12584cae6930e094$var$eventName$jscomp$inline_1578.toLowerCase(), $12584cae6930e094$var$capitalizedEvent$jscomp$inline_1580 = $12584cae6930e094$var$eventName$jscomp$inline_1578[0].toUpperCase() + $12584cae6930e094$var$eventName$jscomp$inline_1578.slice(1);
    $12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$domEventName$jscomp$inline_1579, "on" + $12584cae6930e094$var$capitalizedEvent$jscomp$inline_1580);
}
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$ANIMATION_END, "onAnimationEnd");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$ANIMATION_ITERATION, "onAnimationIteration");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$ANIMATION_START, "onAnimationStart");
$12584cae6930e094$var$registerSimpleEvent("dblclick", "onDoubleClick");
$12584cae6930e094$var$registerSimpleEvent("focusin", "onFocus");
$12584cae6930e094$var$registerSimpleEvent("focusout", "onBlur");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$TRANSITION_RUN, "onTransitionRun");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$TRANSITION_START, "onTransitionStart");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$TRANSITION_CANCEL, "onTransitionCancel");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$TRANSITION_END, "onTransitionEnd");
$12584cae6930e094$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$12584cae6930e094$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$12584cae6930e094$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$12584cae6930e094$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$12584cae6930e094$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$12584cae6930e094$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$12584cae6930e094$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$12584cae6930e094$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$12584cae6930e094$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$12584cae6930e094$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $12584cae6930e094$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $12584cae6930e094$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($12584cae6930e094$var$mediaEventTypes));
function $12584cae6930e094$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $12584cae6930e094$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $12584cae6930e094$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $12584cae6930e094$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$12584cae6930e094$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$12584cae6930e094$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($12584cae6930e094$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $12584cae6930e094$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $12584cae6930e094$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $12584cae6930e094$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $12584cae6930e094$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$12584cae6930e094$var$listeningMarker]) {
        rootContainerElement[$12584cae6930e094$var$listeningMarker] = !0;
        $12584cae6930e094$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($12584cae6930e094$var$nonDelegatedEvents.has(domEventName) || $12584cae6930e094$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $12584cae6930e094$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$12584cae6930e094$var$listeningMarker] || (ownerDocument[$12584cae6930e094$var$listeningMarker] = !0, $12584cae6930e094$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $12584cae6930e094$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($12584cae6930e094$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $12584cae6930e094$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $12584cae6930e094$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $12584cae6930e094$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$12584cae6930e094$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $12584cae6930e094$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $12584cae6930e094$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $12584cae6930e094$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $12584cae6930e094$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $12584cae6930e094$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $12584cae6930e094$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $12584cae6930e094$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticTouchEvent;
                        break;
                    case $12584cae6930e094$var$ANIMATION_END:
                    case $12584cae6930e094$var$ANIMATION_ITERATION:
                    case $12584cae6930e094$var$ANIMATION_START:
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticAnimationEvent;
                        break;
                    case $12584cae6930e094$var$TRANSITION_END:
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $12584cae6930e094$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($12584cae6930e094$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $12584cae6930e094$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($12584cae6930e094$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$12584cae6930e094$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $12584cae6930e094$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $12584cae6930e094$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $12584cae6930e094$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $12584cae6930e094$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $12584cae6930e094$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $12584cae6930e094$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $12584cae6930e094$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $12584cae6930e094$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $12584cae6930e094$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $12584cae6930e094$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $12584cae6930e094$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $12584cae6930e094$var$getTargetInstForChangeEvent;
                else if ($12584cae6930e094$var$isTextInputElement(reactName)) {
                    if ($12584cae6930e094$var$isInputEventSupported) getTargetInstFunc = $12584cae6930e094$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $12584cae6930e094$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $12584cae6930e094$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $12584cae6930e094$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $12584cae6930e094$var$getTargetInstForChangeEvent) : getTargetInstFunc = $12584cae6930e094$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $12584cae6930e094$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $12584cae6930e094$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $12584cae6930e094$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($12584cae6930e094$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $12584cae6930e094$var$activeElement = handleEventFunc, $12584cae6930e094$var$activeElementInst = targetInst, $12584cae6930e094$var$lastSelection = null;
                    break;
                case "focusout":
                    $12584cae6930e094$var$lastSelection = $12584cae6930e094$var$activeElementInst = $12584cae6930e094$var$activeElement = null;
                    break;
                case "mousedown":
                    $12584cae6930e094$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $12584cae6930e094$var$mouseDown = !1;
                    $12584cae6930e094$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($12584cae6930e094$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $12584cae6930e094$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($12584cae6930e094$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $12584cae6930e094$var$isComposing ? $12584cae6930e094$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($12584cae6930e094$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($12584cae6930e094$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $12584cae6930e094$var$isComposing && (fallbackData = $12584cae6930e094$var$getData()) : ($12584cae6930e094$var$root = nativeEventTarget, $12584cae6930e094$var$startText = "value" in $12584cae6930e094$var$root ? $12584cae6930e094$var$root.value : $12584cae6930e094$var$root.textContent, $12584cae6930e094$var$isComposing = !0)), handleEventFunc = $12584cae6930e094$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $12584cae6930e094$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $12584cae6930e094$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $12584cae6930e094$var$canUseTextInputEvent ? $12584cae6930e094$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $12584cae6930e094$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $12584cae6930e094$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $12584cae6930e094$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $12584cae6930e094$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $12584cae6930e094$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $12584cae6930e094$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $12584cae6930e094$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $12584cae6930e094$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($12584cae6930e094$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $12584cae6930e094$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($12584cae6930e094$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $12584cae6930e094$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $12584cae6930e094$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $12584cae6930e094$var$getListener(target, registrationName), null != stateNode && listeners.unshift($12584cae6930e094$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $12584cae6930e094$var$getListener(target, registrationName), null != stateNode && listeners.push($12584cae6930e094$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $12584cae6930e094$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $12584cae6930e094$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $12584cae6930e094$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($12584cae6930e094$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($12584cae6930e094$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $12584cae6930e094$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $12584cae6930e094$var$normalizeMarkupForTextOrAttribute(clientText);
    return $12584cae6930e094$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $12584cae6930e094$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $12584cae6930e094$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $12584cae6930e094$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $12584cae6930e094$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $12584cae6930e094$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $12584cae6930e094$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $12584cae6930e094$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $12584cae6930e094$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $12584cae6930e094$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $12584cae6930e094$var$setProp(domElement, tag, "name", props.name, props, null), $12584cae6930e094$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $12584cae6930e094$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $12584cae6930e094$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($12584cae6930e094$var$setProp(domElement, tag, "encType", props.encType, props, null), $12584cae6930e094$var$setProp(domElement, tag, "method", props.method, props, null), $12584cae6930e094$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $12584cae6930e094$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $12584cae6930e094$var$noop$1);
            break;
        case "onScroll":
            null != value && $12584cae6930e094$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $12584cae6930e094$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($12584cae6930e094$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($12584cae6930e094$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $12584cae6930e094$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $12584cae6930e094$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("toggle", domElement);
            $12584cae6930e094$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $12584cae6930e094$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $12584cae6930e094$var$aliases.get(key) || key, $12584cae6930e094$var$setValueForAttribute(domElement, key, value);
    }
}
function $12584cae6930e094$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $12584cae6930e094$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($12584cae6930e094$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($12584cae6930e094$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $12584cae6930e094$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $12584cae6930e094$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $12584cae6930e094$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $12584cae6930e094$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $12584cae6930e094$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$12584cae6930e094$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$12584cae6930e094$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $12584cae6930e094$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $12584cae6930e094$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $12584cae6930e094$var$listenToNonDelegatedEvent("error", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($12584cae6930e094$var$formatProdErrorMessage(137, tag));
                    default:
                        $12584cae6930e094$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $12584cae6930e094$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $12584cae6930e094$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($12584cae6930e094$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $12584cae6930e094$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $12584cae6930e094$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $12584cae6930e094$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $12584cae6930e094$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($12584cae6930e094$var$formatProdErrorMessage(91));
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $12584cae6930e094$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $12584cae6930e094$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("toggle", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("cancel", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $12584cae6930e094$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $12584cae6930e094$var$mediaEventTypes.length; hasSrc++)$12584cae6930e094$var$listenToNonDelegatedEvent($12584cae6930e094$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $12584cae6930e094$var$listenToNonDelegatedEvent("error", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $12584cae6930e094$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $12584cae6930e094$var$listenToNonDelegatedEvent("error", domElement), $12584cae6930e094$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($12584cae6930e094$var$formatProdErrorMessage(137, tag));
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($12584cae6930e094$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $12584cae6930e094$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $12584cae6930e094$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $12584cae6930e094$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $12584cae6930e094$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($12584cae6930e094$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $12584cae6930e094$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $12584cae6930e094$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $12584cae6930e094$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $12584cae6930e094$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $12584cae6930e094$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $12584cae6930e094$var$updateOptions(domElement, !!lastProps, tag, !0) : $12584cae6930e094$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($12584cae6930e094$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $12584cae6930e094$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $12584cae6930e094$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $12584cae6930e094$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($12584cae6930e094$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($12584cae6930e094$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $12584cae6930e094$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $12584cae6930e094$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $12584cae6930e094$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $12584cae6930e094$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $12584cae6930e094$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $12584cae6930e094$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $12584cae6930e094$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $12584cae6930e094$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $12584cae6930e094$var$eventsEnabled = null, $12584cae6930e094$var$selectionInformation = null;
function $12584cae6930e094$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $12584cae6930e094$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $12584cae6930e094$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $12584cae6930e094$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $12584cae6930e094$var$currentPopstateTransitionEvent = null;
function $12584cae6930e094$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $12584cae6930e094$var$currentPopstateTransitionEvent) return !1;
        $12584cae6930e094$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $12584cae6930e094$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $12584cae6930e094$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $12584cae6930e094$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $12584cae6930e094$var$localPromise = "function" === typeof Promise ? Promise : void 0, $12584cae6930e094$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $12584cae6930e094$var$localPromise ? function(callback) {
    return $12584cae6930e094$var$localPromise.resolve(null).then(callback).catch($12584cae6930e094$var$handleErrorInNextTick);
} : $12584cae6930e094$var$scheduleTimeout;
function $12584cae6930e094$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $12584cae6930e094$var$isSingletonScope(type) {
    return "head" === type;
}
function $12584cae6930e094$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $12584cae6930e094$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $12584cae6930e094$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $12584cae6930e094$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$12584cae6930e094$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $12584cae6930e094$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $12584cae6930e094$var$retryIfBlockedOn(hydrationInstance);
}
function $12584cae6930e094$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $12584cae6930e094$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $12584cae6930e094$var$clearContainerSparingly(node);
                $12584cae6930e094$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $12584cae6930e094$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$12584cae6930e094$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $12584cae6930e094$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $12584cae6930e094$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $12584cae6930e094$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $12584cae6930e094$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $12584cae6930e094$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $12584cae6930e094$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $12584cae6930e094$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $12584cae6930e094$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $12584cae6930e094$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $12584cae6930e094$var$previousHydratableOnEnteringScopedSingleton = null;
function $12584cae6930e094$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $12584cae6930e094$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $12584cae6930e094$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $12584cae6930e094$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $12584cae6930e094$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($12584cae6930e094$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($12584cae6930e094$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($12584cae6930e094$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($12584cae6930e094$var$formatProdErrorMessage(451));
    }
}
function $12584cae6930e094$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $12584cae6930e094$var$detachDeletedInstance(instance);
}
var $12584cae6930e094$var$preloadPropsMap = new Map(), $12584cae6930e094$var$preconnectsSet = new Set();
function $12584cae6930e094$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $12584cae6930e094$var$previousDispatcher = $12584cae6930e094$var$ReactDOMSharedInternals.d;
$12584cae6930e094$var$ReactDOMSharedInternals.d = {
    f: $12584cae6930e094$var$flushSyncWork,
    r: $12584cae6930e094$var$requestFormReset,
    D: $12584cae6930e094$var$prefetchDNS,
    C: $12584cae6930e094$var$preconnect,
    L: $12584cae6930e094$var$preload,
    m: $12584cae6930e094$var$preloadModule,
    X: $12584cae6930e094$var$preinitScript,
    S: $12584cae6930e094$var$preinitStyle,
    M: $12584cae6930e094$var$preinitModuleScript
};
function $12584cae6930e094$var$flushSyncWork() {
    var previousWasRendering = $12584cae6930e094$var$previousDispatcher.f(), wasRendering = $12584cae6930e094$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $12584cae6930e094$var$requestFormReset(form) {
    var formInst = $12584cae6930e094$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $12584cae6930e094$var$requestFormReset$1(formInst) : $12584cae6930e094$var$previousDispatcher.r(form);
}
var $12584cae6930e094$var$globalDocument = "undefined" === typeof document ? null : document;
function $12584cae6930e094$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $12584cae6930e094$var$preconnectsSet.has(limitedEscapedHref) || ($12584cae6930e094$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $12584cae6930e094$var$setInitialProperties(href, "link", rel), $12584cae6930e094$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $12584cae6930e094$var$prefetchDNS(href) {
    $12584cae6930e094$var$previousDispatcher.D(href);
    $12584cae6930e094$var$preconnectAs("dns-prefetch", href, null);
}
function $12584cae6930e094$var$preconnect(href, crossOrigin) {
    $12584cae6930e094$var$previousDispatcher.C(href, crossOrigin);
    $12584cae6930e094$var$preconnectAs("preconnect", href, crossOrigin);
}
function $12584cae6930e094$var$preload(href, as, options) {
    $12584cae6930e094$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $12584cae6930e094$var$getStyleKey(href);
                break;
            case "script":
                key = $12584cae6930e094$var$getScriptKey(href);
        }
        $12584cae6930e094$var$preloadPropsMap.has(key) || (href = $12584cae6930e094$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $12584cae6930e094$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($12584cae6930e094$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($12584cae6930e094$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $12584cae6930e094$var$setInitialProperties(as, "link", href), $12584cae6930e094$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $12584cae6930e094$var$preloadModule(href, options) {
    $12584cae6930e094$var$previousDispatcher.m(href, options);
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $12584cae6930e094$var$getScriptKey(href);
        }
        if (!$12584cae6930e094$var$preloadPropsMap.has(key) && (href = $12584cae6930e094$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $12584cae6930e094$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($12584cae6930e094$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $12584cae6930e094$var$setInitialProperties(as, "link", href);
            $12584cae6930e094$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $12584cae6930e094$var$preinitStyle(href, precedence, options) {
    $12584cae6930e094$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $12584cae6930e094$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $12584cae6930e094$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($12584cae6930e094$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $12584cae6930e094$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $12584cae6930e094$var$preloadPropsMap.get(key)) && $12584cae6930e094$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $12584cae6930e094$var$markNodeAsHoistable(link);
                $12584cae6930e094$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $12584cae6930e094$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $12584cae6930e094$var$preinitScript(src, options) {
    $12584cae6930e094$var$previousDispatcher.X(src, options);
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $12584cae6930e094$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $12584cae6930e094$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($12584cae6930e094$var$getScriptSelectorFromKey(key)), resource || (src = $12584cae6930e094$var$assign({
            src: src,
            async: !0
        }, options), (options = $12584cae6930e094$var$preloadPropsMap.get(key)) && $12584cae6930e094$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $12584cae6930e094$var$markNodeAsHoistable(resource), $12584cae6930e094$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $12584cae6930e094$var$preinitModuleScript(src, options) {
    $12584cae6930e094$var$previousDispatcher.M(src, options);
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $12584cae6930e094$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $12584cae6930e094$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($12584cae6930e094$var$getScriptSelectorFromKey(key)), resource || (src = $12584cae6930e094$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $12584cae6930e094$var$preloadPropsMap.get(key)) && $12584cae6930e094$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $12584cae6930e094$var$markNodeAsHoistable(resource), $12584cae6930e094$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $12584cae6930e094$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $12584cae6930e094$var$rootInstanceStackCursor.current) ? $12584cae6930e094$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($12584cae6930e094$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $12584cae6930e094$var$getStyleKey(pendingProps.href), pendingProps = $12584cae6930e094$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $12584cae6930e094$var$getStyleKey(pendingProps.href);
                var styles$243 = $12584cae6930e094$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($12584cae6930e094$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $12584cae6930e094$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $12584cae6930e094$var$preloadPropsMap.set(type, pendingProps), styles$243 || $12584cae6930e094$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($12584cae6930e094$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($12584cae6930e094$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $12584cae6930e094$var$getScriptKey(pendingProps), pendingProps = $12584cae6930e094$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($12584cae6930e094$var$formatProdErrorMessage(444, type));
    }
}
function $12584cae6930e094$var$getStyleKey(href) {
    return 'href="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $12584cae6930e094$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $12584cae6930e094$var$stylesheetPropsFromRawProps(rawProps) {
    return $12584cae6930e094$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $12584cae6930e094$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $12584cae6930e094$var$setInitialProperties(key, "link", preloadProps), $12584cae6930e094$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $12584cae6930e094$var$getScriptKey(src) {
    return '[src="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $12584cae6930e094$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $12584cae6930e094$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $12584cae6930e094$var$markNodeAsHoistable(instance), instance;
            var styleProps = $12584cae6930e094$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $12584cae6930e094$var$markNodeAsHoistable(instance);
            $12584cae6930e094$var$setInitialProperties(instance, "style", styleProps);
            $12584cae6930e094$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $12584cae6930e094$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($12584cae6930e094$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $12584cae6930e094$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $12584cae6930e094$var$stylesheetPropsFromRawProps(props);
            (styleProps = $12584cae6930e094$var$preloadPropsMap.get(styleProps)) && $12584cae6930e094$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $12584cae6930e094$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $12584cae6930e094$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $12584cae6930e094$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $12584cae6930e094$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($12584cae6930e094$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $12584cae6930e094$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $12584cae6930e094$var$preloadPropsMap.get(instance$249)) instance = $12584cae6930e094$var$assign({}, props), $12584cae6930e094$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $12584cae6930e094$var$markNodeAsHoistable(styleProps);
            $12584cae6930e094$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($12584cae6930e094$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $12584cae6930e094$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $12584cae6930e094$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $12584cae6930e094$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $12584cae6930e094$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $12584cae6930e094$var$tagCaches = null;
function $12584cae6930e094$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $12584cae6930e094$var$tagCaches) {
        var cache = new Map();
        var caches = $12584cae6930e094$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $12584cae6930e094$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$12584cae6930e094$var$internalHoistableMarker] || node[$12584cae6930e094$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $12584cae6930e094$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $12584cae6930e094$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $12584cae6930e094$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $12584cae6930e094$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $12584cae6930e094$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($12584cae6930e094$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $12584cae6930e094$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $12584cae6930e094$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $12584cae6930e094$var$stylesheetPropsFromRawProps(props);
            (key = $12584cae6930e094$var$preloadPropsMap.get(key)) && $12584cae6930e094$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $12584cae6930e094$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $12584cae6930e094$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $12584cae6930e094$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $12584cae6930e094$var$estimatedBytesWithinLimit = 0;
function $12584cae6930e094$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $12584cae6930e094$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $12584cae6930e094$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $12584cae6930e094$var$estimatedBytesWithinLimit && ($12584cae6930e094$var$estimatedBytesWithinLimit = 62500 * $12584cae6930e094$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $12584cae6930e094$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $12584cae6930e094$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $12584cae6930e094$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $12584cae6930e094$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $12584cae6930e094$var$precedencesByRoot = null;
function $12584cae6930e094$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $12584cae6930e094$var$precedencesByRoot = new Map(), resources.forEach($12584cae6930e094$var$insertStylesheetIntoRoot, state), $12584cae6930e094$var$precedencesByRoot = null, $12584cae6930e094$var$onUnsuspend.call(state));
}
function $12584cae6930e094$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $12584cae6930e094$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $12584cae6930e094$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $12584cae6930e094$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $12584cae6930e094$var$HostTransitionContext = {
    $$typeof: $12584cae6930e094$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $12584cae6930e094$var$sharedNotPendingObject,
    _currentValue2: $12584cae6930e094$var$sharedNotPendingObject,
    _threadCount: 0
};
function $12584cae6930e094$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $12584cae6930e094$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $12584cae6930e094$var$createLaneMap(0);
    this.hiddenUpdates = $12584cae6930e094$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $12584cae6930e094$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $12584cae6930e094$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $12584cae6930e094$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $12584cae6930e094$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $12584cae6930e094$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $12584cae6930e094$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $12584cae6930e094$var$emptyContextObject;
    parentComponent = $12584cae6930e094$var$emptyContextObject;
    return parentComponent;
}
function $12584cae6930e094$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $12584cae6930e094$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $12584cae6930e094$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $12584cae6930e094$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($12584cae6930e094$var$scheduleUpdateOnFiber(element, rootFiber, lane), $12584cae6930e094$var$entangleTransitions(element, rootFiber, lane));
}
function $12584cae6930e094$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $12584cae6930e094$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $12584cae6930e094$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $12584cae6930e094$var$markRetryLaneImpl(fiber, retryLane);
}
function $12584cae6930e094$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $12584cae6930e094$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $12584cae6930e094$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $12584cae6930e094$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $12584cae6930e094$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $12584cae6930e094$var$requestUpdateLane();
        lane = $12584cae6930e094$var$getBumpedLaneForHydrationByLane(lane);
        var root = $12584cae6930e094$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $12584cae6930e094$var$scheduleUpdateOnFiber(root, fiber, lane);
        $12584cae6930e094$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $12584cae6930e094$var$_enabled = !0;
function $12584cae6930e094$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $12584cae6930e094$var$ReactSharedInternals.T;
    $12584cae6930e094$var$ReactSharedInternals.T = null;
    var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    try {
        $12584cae6930e094$var$ReactDOMSharedInternals.p = 2, $12584cae6930e094$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, $12584cae6930e094$var$ReactSharedInternals.T = prevTransition;
    }
}
function $12584cae6930e094$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $12584cae6930e094$var$ReactSharedInternals.T;
    $12584cae6930e094$var$ReactSharedInternals.T = null;
    var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    try {
        $12584cae6930e094$var$ReactDOMSharedInternals.p = 8, $12584cae6930e094$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, $12584cae6930e094$var$ReactSharedInternals.T = prevTransition;
    }
}
function $12584cae6930e094$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($12584cae6930e094$var$_enabled) {
        var blockedOn = $12584cae6930e094$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $12584cae6930e094$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $12584cae6930e094$var$return_targetInst, targetContainer), $12584cae6930e094$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($12584cae6930e094$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($12584cae6930e094$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $12584cae6930e094$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $12584cae6930e094$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $12584cae6930e094$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $12584cae6930e094$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $12584cae6930e094$var$ensureRootIsScheduled(fiber);
                                0 === ($12584cae6930e094$var$executionContext & 6) && ($12584cae6930e094$var$workInProgressRootRenderTargetTime = $12584cae6930e094$var$now() + 500, $12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $12584cae6930e094$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $12584cae6930e094$var$scheduleUpdateOnFiber(root, fiber, 2), $12584cae6930e094$var$flushSyncWork$1(), $12584cae6930e094$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $12584cae6930e094$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $12584cae6930e094$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $12584cae6930e094$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $12584cae6930e094$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $12584cae6930e094$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $12584cae6930e094$var$getEventTarget(nativeEvent);
    return $12584cae6930e094$var$findInstanceBlockingTarget(nativeEvent);
}
var $12584cae6930e094$var$return_targetInst = null;
function $12584cae6930e094$var$findInstanceBlockingTarget(targetNode) {
    $12584cae6930e094$var$return_targetInst = null;
    targetNode = $12584cae6930e094$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $12584cae6930e094$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $12584cae6930e094$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $12584cae6930e094$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $12584cae6930e094$var$return_targetInst = targetNode;
    return null;
}
function $12584cae6930e094$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($12584cae6930e094$var$getCurrentPriorityLevel()){
                case $12584cae6930e094$var$ImmediatePriority:
                    return 2;
                case $12584cae6930e094$var$UserBlockingPriority:
                    return 8;
                case $12584cae6930e094$var$NormalPriority$1:
                case $12584cae6930e094$var$LowPriority:
                    return 32;
                case $12584cae6930e094$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $12584cae6930e094$var$hasScheduledReplayAttempt = !1, $12584cae6930e094$var$queuedFocus = null, $12584cae6930e094$var$queuedDrag = null, $12584cae6930e094$var$queuedMouse = null, $12584cae6930e094$var$queuedPointers = new Map(), $12584cae6930e094$var$queuedPointerCaptures = new Map(), $12584cae6930e094$var$queuedExplicitHydrationTargets = [], $12584cae6930e094$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $12584cae6930e094$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $12584cae6930e094$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $12584cae6930e094$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $12584cae6930e094$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $12584cae6930e094$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $12584cae6930e094$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $12584cae6930e094$var$getInstanceFromNode(blockedOn), null !== blockedOn && $12584cae6930e094$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $12584cae6930e094$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $12584cae6930e094$var$queuedFocus = $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent($12584cae6930e094$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $12584cae6930e094$var$queuedDrag = $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent($12584cae6930e094$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $12584cae6930e094$var$queuedMouse = $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent($12584cae6930e094$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $12584cae6930e094$var$queuedPointers.set(pointerId, $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent($12584cae6930e094$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $12584cae6930e094$var$queuedPointerCaptures.set(pointerId, $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent($12584cae6930e094$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $12584cae6930e094$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $12584cae6930e094$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $12584cae6930e094$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $12584cae6930e094$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $12584cae6930e094$var$runWithPriority(queuedTarget.priority, function() {
                        $12584cae6930e094$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $12584cae6930e094$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $12584cae6930e094$var$runWithPriority(queuedTarget.priority, function() {
                        $12584cae6930e094$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $12584cae6930e094$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $12584cae6930e094$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $12584cae6930e094$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $12584cae6930e094$var$currentReplayingEvent = null;
        } else return targetContainers = $12584cae6930e094$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $12584cae6930e094$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $12584cae6930e094$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $12584cae6930e094$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $12584cae6930e094$var$replayUnblockedEvents() {
    $12584cae6930e094$var$hasScheduledReplayAttempt = !1;
    null !== $12584cae6930e094$var$queuedFocus && $12584cae6930e094$var$attemptReplayContinuousQueuedEvent($12584cae6930e094$var$queuedFocus) && ($12584cae6930e094$var$queuedFocus = null);
    null !== $12584cae6930e094$var$queuedDrag && $12584cae6930e094$var$attemptReplayContinuousQueuedEvent($12584cae6930e094$var$queuedDrag) && ($12584cae6930e094$var$queuedDrag = null);
    null !== $12584cae6930e094$var$queuedMouse && $12584cae6930e094$var$attemptReplayContinuousQueuedEvent($12584cae6930e094$var$queuedMouse) && ($12584cae6930e094$var$queuedMouse = null);
    $12584cae6930e094$var$queuedPointers.forEach($12584cae6930e094$var$attemptReplayContinuousQueuedEventInMap);
    $12584cae6930e094$var$queuedPointerCaptures.forEach($12584cae6930e094$var$attemptReplayContinuousQueuedEventInMap);
}
function $12584cae6930e094$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $12584cae6930e094$var$hasScheduledReplayAttempt || ($12584cae6930e094$var$hasScheduledReplayAttempt = !0, $8IBEr.unstable_scheduleCallback($8IBEr.unstable_NormalPriority, $12584cae6930e094$var$replayUnblockedEvents)));
}
var $12584cae6930e094$var$lastScheduledReplayQueue = null;
function $12584cae6930e094$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $12584cae6930e094$var$lastScheduledReplayQueue !== formReplayingQueue && ($12584cae6930e094$var$lastScheduledReplayQueue = formReplayingQueue, $8IBEr.unstable_scheduleCallback($8IBEr.unstable_NormalPriority, function() {
        $12584cae6930e094$var$lastScheduledReplayQueue === formReplayingQueue && ($12584cae6930e094$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $12584cae6930e094$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $12584cae6930e094$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $12584cae6930e094$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $12584cae6930e094$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $12584cae6930e094$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $12584cae6930e094$var$queuedFocus && $12584cae6930e094$var$scheduleCallbackIfUnblocked($12584cae6930e094$var$queuedFocus, unblocked);
    null !== $12584cae6930e094$var$queuedDrag && $12584cae6930e094$var$scheduleCallbackIfUnblocked($12584cae6930e094$var$queuedDrag, unblocked);
    null !== $12584cae6930e094$var$queuedMouse && $12584cae6930e094$var$scheduleCallbackIfUnblocked($12584cae6930e094$var$queuedMouse, unblocked);
    $12584cae6930e094$var$queuedPointers.forEach(unblock);
    $12584cae6930e094$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $12584cae6930e094$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $12584cae6930e094$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $12584cae6930e094$var$queuedExplicitHydrationTargets.length && (i = $12584cae6930e094$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$12584cae6930e094$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $12584cae6930e094$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$12584cae6930e094$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $12584cae6930e094$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$12584cae6930e094$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $12584cae6930e094$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $12584cae6930e094$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $12584cae6930e094$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $12584cae6930e094$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$12584cae6930e094$var$ReactDOMHydrationRoot.prototype.render = $12584cae6930e094$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($12584cae6930e094$var$formatProdErrorMessage(409));
    var current = root.current, lane = $12584cae6930e094$var$requestUpdateLane();
    $12584cae6930e094$var$updateContainerImpl(current, lane, children, root, null, null);
};
$12584cae6930e094$var$ReactDOMHydrationRoot.prototype.unmount = $12584cae6930e094$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $12584cae6930e094$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $12584cae6930e094$var$flushSyncWork$1();
        container[$12584cae6930e094$var$internalContainerInstanceKey] = null;
    }
};
function $12584cae6930e094$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$12584cae6930e094$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $12584cae6930e094$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $12584cae6930e094$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $12584cae6930e094$var$queuedExplicitHydrationTargets[i].priority; i++);
        $12584cae6930e094$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $12584cae6930e094$var$attemptExplicitHydrationTarget(target);
    }
};
var $12584cae6930e094$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $lCzvA.version;
if ("19.2.8" !== $12584cae6930e094$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($12584cae6930e094$var$formatProdErrorMessage(527, $12584cae6930e094$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$12584cae6930e094$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($12584cae6930e094$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($12584cae6930e094$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $12584cae6930e094$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $12584cae6930e094$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $12584cae6930e094$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $12584cae6930e094$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $12584cae6930e094$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$12584cae6930e094$var$hook$jscomp$inline_2348.isDisabled && $12584cae6930e094$var$hook$jscomp$inline_2348.supportsFiber) try {
        $12584cae6930e094$var$rendererID = $12584cae6930e094$var$hook$jscomp$inline_2348.inject($12584cae6930e094$var$internals$jscomp$inline_2347), $12584cae6930e094$var$injectedHook = $12584cae6930e094$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$12584cae6930e094$export$882461b6382ed46c = function(container, options) {
    if (!$12584cae6930e094$var$isValidContainer(container)) throw Error($12584cae6930e094$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $12584cae6930e094$var$defaultOnUncaughtError, onCaughtError = $12584cae6930e094$var$defaultOnCaughtError, onRecoverableError = $12584cae6930e094$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $12584cae6930e094$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $12584cae6930e094$var$defaultOnDefaultTransitionIndicator);
    container[$12584cae6930e094$var$internalContainerInstanceKey] = options.current;
    $12584cae6930e094$var$listenToAllSupportedEvents(container);
    return new $12584cae6930e094$var$ReactDOMRoot(options);
};
$12584cae6930e094$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$12584cae6930e094$var$isValidContainer(container)) throw Error($12584cae6930e094$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $12584cae6930e094$var$defaultOnUncaughtError, onCaughtError = $12584cae6930e094$var$defaultOnCaughtError, onRecoverableError = $12584cae6930e094$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $12584cae6930e094$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $12584cae6930e094$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $12584cae6930e094$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $12584cae6930e094$var$requestUpdateLane();
    isStrictMode = $12584cae6930e094$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $12584cae6930e094$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $12584cae6930e094$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $12584cae6930e094$var$markRootUpdated$1(initialChildren, options);
    $12584cae6930e094$var$ensureRootIsScheduled(initialChildren);
    container[$12584cae6930e094$var$internalContainerInstanceKey] = initialChildren.current;
    $12584cae6930e094$var$listenToAllSupportedEvents(container);
    return new $12584cae6930e094$var$ReactDOMHydrationRoot(initialChildren);
};
$12584cae6930e094$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("8IBEr", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9aKQb"));

});
parcelRegister("9aKQb", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6ad961cdcd5ceea2$export$c4744153514ff05d; }, function (v) { return $6ad961cdcd5ceea2$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6ad961cdcd5ceea2$export$3e506c1ccc9cc1a7; }, function (v) { return $6ad961cdcd5ceea2$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6ad961cdcd5ceea2$export$e26fe2ed2fa76875; }, function (v) { return $6ad961cdcd5ceea2$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6ad961cdcd5ceea2$export$502329bbf4b505b1; }, function (v) { return $6ad961cdcd5ceea2$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6ad961cdcd5ceea2$export$6e3807111c4874c4; }, function (v) { return $6ad961cdcd5ceea2$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6ad961cdcd5ceea2$export$c27134553091fb3a; }, function (v) { return $6ad961cdcd5ceea2$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6ad961cdcd5ceea2$export$33ee1acdc04fd2a2; }, function (v) { return $6ad961cdcd5ceea2$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6ad961cdcd5ceea2$export$b00a404bbd5edef2; }, function (v) { return $6ad961cdcd5ceea2$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6ad961cdcd5ceea2$export$d66a1c1c77bd778b; }, function (v) { return $6ad961cdcd5ceea2$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6ad961cdcd5ceea2$export$d3dfb8e4810cb555; }, function (v) { return $6ad961cdcd5ceea2$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6ad961cdcd5ceea2$export$72fdf0e06517287b; }, function (v) { return $6ad961cdcd5ceea2$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6ad961cdcd5ceea2$export$816d2913ae6b83b1; }, function (v) { return $6ad961cdcd5ceea2$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6ad961cdcd5ceea2$export$61bcfe829111a1d0; }, function (v) { return $6ad961cdcd5ceea2$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6ad961cdcd5ceea2$export$7ee8c9beb337bc3f; }, function (v) { return $6ad961cdcd5ceea2$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6ad961cdcd5ceea2$export$b5836b71941fa3ed; }, function (v) { return $6ad961cdcd5ceea2$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6ad961cdcd5ceea2$export$cf845f2c119da08a; }, function (v) { return $6ad961cdcd5ceea2$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6ad961cdcd5ceea2$export$c4744153514ff05d;
var $6ad961cdcd5ceea2$export$3e506c1ccc9cc1a7;
var $6ad961cdcd5ceea2$export$e26fe2ed2fa76875;
var $6ad961cdcd5ceea2$export$502329bbf4b505b1;
var $6ad961cdcd5ceea2$export$6e3807111c4874c4;
var $6ad961cdcd5ceea2$export$c27134553091fb3a;
var $6ad961cdcd5ceea2$export$33ee1acdc04fd2a2;
var $6ad961cdcd5ceea2$export$b00a404bbd5edef2;
var $6ad961cdcd5ceea2$export$d66a1c1c77bd778b;
var $6ad961cdcd5ceea2$export$d3dfb8e4810cb555;
var $6ad961cdcd5ceea2$export$72fdf0e06517287b;
var $6ad961cdcd5ceea2$export$816d2913ae6b83b1;
var $6ad961cdcd5ceea2$export$61bcfe829111a1d0;
var $6ad961cdcd5ceea2$export$7ee8c9beb337bc3f;
var $6ad961cdcd5ceea2$export$b5836b71941fa3ed;
var $6ad961cdcd5ceea2$export$cf845f2c119da08a;
"use strict";
function $6ad961cdcd5ceea2$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $6ad961cdcd5ceea2$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $6ad961cdcd5ceea2$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $6ad961cdcd5ceea2$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $6ad961cdcd5ceea2$var$compare(left, last)) rightIndex < length && 0 > $6ad961cdcd5ceea2$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $6ad961cdcd5ceea2$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $6ad961cdcd5ceea2$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$6ad961cdcd5ceea2$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6ad961cdcd5ceea2$var$localPerformance = performance;
    $6ad961cdcd5ceea2$export$c4744153514ff05d = function() {
        return $6ad961cdcd5ceea2$var$localPerformance.now();
    };
} else {
    var $6ad961cdcd5ceea2$var$localDate = Date, $6ad961cdcd5ceea2$var$initialTime = $6ad961cdcd5ceea2$var$localDate.now();
    $6ad961cdcd5ceea2$export$c4744153514ff05d = function() {
        return $6ad961cdcd5ceea2$var$localDate.now() - $6ad961cdcd5ceea2$var$initialTime;
    };
}
var $6ad961cdcd5ceea2$var$taskQueue = [], $6ad961cdcd5ceea2$var$timerQueue = [], $6ad961cdcd5ceea2$var$taskIdCounter = 1, $6ad961cdcd5ceea2$var$currentTask = null, $6ad961cdcd5ceea2$var$currentPriorityLevel = 3, $6ad961cdcd5ceea2$var$isPerformingWork = !1, $6ad961cdcd5ceea2$var$isHostCallbackScheduled = !1, $6ad961cdcd5ceea2$var$isHostTimeoutScheduled = !1, $6ad961cdcd5ceea2$var$needsPaint = !1, $6ad961cdcd5ceea2$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $6ad961cdcd5ceea2$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $6ad961cdcd5ceea2$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $6ad961cdcd5ceea2$var$advanceTimers(currentTime) {
    for(var timer = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$timerQueue); null !== timer;){
        if (null === timer.callback) $6ad961cdcd5ceea2$var$pop($6ad961cdcd5ceea2$var$timerQueue);
        else if (timer.startTime <= currentTime) $6ad961cdcd5ceea2$var$pop($6ad961cdcd5ceea2$var$timerQueue), timer.sortIndex = timer.expirationTime, $6ad961cdcd5ceea2$var$push($6ad961cdcd5ceea2$var$taskQueue, timer);
        else break;
        timer = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$timerQueue);
    }
}
function $6ad961cdcd5ceea2$var$handleTimeout(currentTime) {
    $6ad961cdcd5ceea2$var$isHostTimeoutScheduled = !1;
    $6ad961cdcd5ceea2$var$advanceTimers(currentTime);
    if (!$6ad961cdcd5ceea2$var$isHostCallbackScheduled) {
        if (null !== $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$taskQueue)) $6ad961cdcd5ceea2$var$isHostCallbackScheduled = !0, $6ad961cdcd5ceea2$var$isMessageLoopRunning || ($6ad961cdcd5ceea2$var$isMessageLoopRunning = !0, $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$timerQueue);
            null !== firstTimer && $6ad961cdcd5ceea2$var$requestHostTimeout($6ad961cdcd5ceea2$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $6ad961cdcd5ceea2$var$isMessageLoopRunning = !1, $6ad961cdcd5ceea2$var$taskTimeoutID = -1, $6ad961cdcd5ceea2$var$frameInterval = 5, $6ad961cdcd5ceea2$var$startTime = -1;
function $6ad961cdcd5ceea2$var$shouldYieldToHost() {
    return $6ad961cdcd5ceea2$var$needsPaint ? !0 : $6ad961cdcd5ceea2$export$c4744153514ff05d() - $6ad961cdcd5ceea2$var$startTime < $6ad961cdcd5ceea2$var$frameInterval ? !1 : !0;
}
function $6ad961cdcd5ceea2$var$performWorkUntilDeadline() {
    $6ad961cdcd5ceea2$var$needsPaint = !1;
    if ($6ad961cdcd5ceea2$var$isMessageLoopRunning) {
        var currentTime = $6ad961cdcd5ceea2$export$c4744153514ff05d();
        $6ad961cdcd5ceea2$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $6ad961cdcd5ceea2$var$isHostCallbackScheduled = !1;
                $6ad961cdcd5ceea2$var$isHostTimeoutScheduled && ($6ad961cdcd5ceea2$var$isHostTimeoutScheduled = !1, $6ad961cdcd5ceea2$var$localClearTimeout($6ad961cdcd5ceea2$var$taskTimeoutID), $6ad961cdcd5ceea2$var$taskTimeoutID = -1);
                $6ad961cdcd5ceea2$var$isPerformingWork = !0;
                var previousPriorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
                try {
                    b: {
                        $6ad961cdcd5ceea2$var$advanceTimers(currentTime);
                        for($6ad961cdcd5ceea2$var$currentTask = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$taskQueue); null !== $6ad961cdcd5ceea2$var$currentTask && !($6ad961cdcd5ceea2$var$currentTask.expirationTime > currentTime && $6ad961cdcd5ceea2$var$shouldYieldToHost());){
                            var callback = $6ad961cdcd5ceea2$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $6ad961cdcd5ceea2$var$currentTask.callback = null;
                                $6ad961cdcd5ceea2$var$currentPriorityLevel = $6ad961cdcd5ceea2$var$currentTask.priorityLevel;
                                var continuationCallback = callback($6ad961cdcd5ceea2$var$currentTask.expirationTime <= currentTime);
                                currentTime = $6ad961cdcd5ceea2$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $6ad961cdcd5ceea2$var$currentTask.callback = continuationCallback;
                                    $6ad961cdcd5ceea2$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $6ad961cdcd5ceea2$var$currentTask === $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$taskQueue) && $6ad961cdcd5ceea2$var$pop($6ad961cdcd5ceea2$var$taskQueue);
                                $6ad961cdcd5ceea2$var$advanceTimers(currentTime);
                            } else $6ad961cdcd5ceea2$var$pop($6ad961cdcd5ceea2$var$taskQueue);
                            $6ad961cdcd5ceea2$var$currentTask = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$taskQueue);
                        }
                        if (null !== $6ad961cdcd5ceea2$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$timerQueue);
                            null !== firstTimer && $6ad961cdcd5ceea2$var$requestHostTimeout($6ad961cdcd5ceea2$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $6ad961cdcd5ceea2$var$currentTask = null, $6ad961cdcd5ceea2$var$currentPriorityLevel = previousPriorityLevel, $6ad961cdcd5ceea2$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline() : $6ad961cdcd5ceea2$var$isMessageLoopRunning = !1;
        }
    }
}
var $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $6ad961cdcd5ceea2$var$localSetImmediate) $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline = function() {
    $6ad961cdcd5ceea2$var$localSetImmediate($6ad961cdcd5ceea2$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6ad961cdcd5ceea2$var$channel = new MessageChannel(), $6ad961cdcd5ceea2$var$port = $6ad961cdcd5ceea2$var$channel.port2;
    $6ad961cdcd5ceea2$var$channel.port1.onmessage = $6ad961cdcd5ceea2$var$performWorkUntilDeadline;
    $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline = function() {
        $6ad961cdcd5ceea2$var$port.postMessage(null);
    };
} else $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline = function() {
    $6ad961cdcd5ceea2$var$localSetTimeout($6ad961cdcd5ceea2$var$performWorkUntilDeadline, 0);
};
function $6ad961cdcd5ceea2$var$requestHostTimeout(callback, ms) {
    $6ad961cdcd5ceea2$var$taskTimeoutID = $6ad961cdcd5ceea2$var$localSetTimeout(function() {
        callback($6ad961cdcd5ceea2$export$c4744153514ff05d());
    }, ms);
}
$6ad961cdcd5ceea2$export$3e506c1ccc9cc1a7 = 5;
$6ad961cdcd5ceea2$export$e26fe2ed2fa76875 = 1;
$6ad961cdcd5ceea2$export$502329bbf4b505b1 = 4;
$6ad961cdcd5ceea2$export$6e3807111c4874c4 = 3;
$6ad961cdcd5ceea2$export$c27134553091fb3a = null;
$6ad961cdcd5ceea2$export$33ee1acdc04fd2a2 = 2;
$6ad961cdcd5ceea2$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$6ad961cdcd5ceea2$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6ad961cdcd5ceea2$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$6ad961cdcd5ceea2$export$d3dfb8e4810cb555 = function() {
    return $6ad961cdcd5ceea2$var$currentPriorityLevel;
};
$6ad961cdcd5ceea2$export$72fdf0e06517287b = function(eventHandler) {
    switch($6ad961cdcd5ceea2$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
    $6ad961cdcd5ceea2$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ad961cdcd5ceea2$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ad961cdcd5ceea2$export$816d2913ae6b83b1 = function() {
    $6ad961cdcd5ceea2$var$needsPaint = !0;
};
$6ad961cdcd5ceea2$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
    $6ad961cdcd5ceea2$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ad961cdcd5ceea2$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ad961cdcd5ceea2$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $6ad961cdcd5ceea2$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $6ad961cdcd5ceea2$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $6ad961cdcd5ceea2$var$push($6ad961cdcd5ceea2$var$timerQueue, priorityLevel), null === $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$taskQueue) && priorityLevel === $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$timerQueue) && ($6ad961cdcd5ceea2$var$isHostTimeoutScheduled ? ($6ad961cdcd5ceea2$var$localClearTimeout($6ad961cdcd5ceea2$var$taskTimeoutID), $6ad961cdcd5ceea2$var$taskTimeoutID = -1) : $6ad961cdcd5ceea2$var$isHostTimeoutScheduled = !0, $6ad961cdcd5ceea2$var$requestHostTimeout($6ad961cdcd5ceea2$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $6ad961cdcd5ceea2$var$push($6ad961cdcd5ceea2$var$taskQueue, priorityLevel), $6ad961cdcd5ceea2$var$isHostCallbackScheduled || $6ad961cdcd5ceea2$var$isPerformingWork || ($6ad961cdcd5ceea2$var$isHostCallbackScheduled = !0, $6ad961cdcd5ceea2$var$isMessageLoopRunning || ($6ad961cdcd5ceea2$var$isMessageLoopRunning = !0, $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$6ad961cdcd5ceea2$export$b5836b71941fa3ed = $6ad961cdcd5ceea2$var$shouldYieldToHost;
$6ad961cdcd5ceea2$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
        $6ad961cdcd5ceea2$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $6ad961cdcd5ceea2$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("lCzvA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5D7th"));

});
parcelRegister("5D7th", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $419663ed77570ca3$export$9c16c1426311996d; }, function (v) { return $419663ed77570ca3$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $419663ed77570ca3$export$dca3b0875bd9a954; }, function (v) { return $419663ed77570ca3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $419663ed77570ca3$export$16fa2f45be04daa8; }, function (v) { return $419663ed77570ca3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $419663ed77570ca3$export$ffb0004e005737fa; }, function (v) { return $419663ed77570ca3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $419663ed77570ca3$export$e2c29f18771995cb; }, function (v) { return $419663ed77570ca3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $419663ed77570ca3$export$221d75b3f55bb0bd; }, function (v) { return $419663ed77570ca3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $419663ed77570ca3$export$5f8d39834fd61797; }, function (v) { return $419663ed77570ca3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $419663ed77570ca3$export$74bf444e3cd11ea5; }, function (v) { return $419663ed77570ca3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $419663ed77570ca3$export$1ced07cd6b1985ce; }, function (v) { return $419663ed77570ca3$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $419663ed77570ca3$export$abd8e32b826d7ea7; }, function (v) { return $419663ed77570ca3$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $419663ed77570ca3$export$69a3209f1a06c04d; }, function (v) { return $419663ed77570ca3$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $419663ed77570ca3$export$8c538325882c7eec; }, function (v) { return $419663ed77570ca3$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $419663ed77570ca3$export$e530037191fcd5d7; }, function (v) { return $419663ed77570ca3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $419663ed77570ca3$export$fd42f52fd3ae1109; }, function (v) { return $419663ed77570ca3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $419663ed77570ca3$export$c8a8987d4410bf2d; }, function (v) { return $419663ed77570ca3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $419663ed77570ca3$export$7d1e3a5e95ceca43; }, function (v) { return $419663ed77570ca3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $419663ed77570ca3$export$257a8862b851cb5b; }, function (v) { return $419663ed77570ca3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $419663ed77570ca3$export$a8257692ac88316c; }, function (v) { return $419663ed77570ca3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $419663ed77570ca3$export$488013bae63b21da; }, function (v) { return $419663ed77570ca3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $419663ed77570ca3$export$7c73462e0d25e514; }, function (v) { return $419663ed77570ca3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $419663ed77570ca3$export$7568632d0d33d16d; }, function (v) { return $419663ed77570ca3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $419663ed77570ca3$export$f93f40ac0ca7e3a8; }, function (v) { return $419663ed77570ca3$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $419663ed77570ca3$export$1f96ae73734a86cc; }, function (v) { return $419663ed77570ca3$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $419663ed77570ca3$export$9a47ced3238df325; }, function (v) { return $419663ed77570ca3$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $419663ed77570ca3$export$35808ee640e87ca7; }, function (v) { return $419663ed77570ca3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $419663ed77570ca3$export$fae74005e78b1a27; }, function (v) { return $419663ed77570ca3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $419663ed77570ca3$export$dc8fbce3eb94dc1e; }, function (v) { return $419663ed77570ca3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $419663ed77570ca3$export$6a7bc4e911dc01cf; }, function (v) { return $419663ed77570ca3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $419663ed77570ca3$export$6d9c69b0de29b591; }, function (v) { return $419663ed77570ca3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $419663ed77570ca3$export$7f54fc3180508a52; }, function (v) { return $419663ed77570ca3$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $419663ed77570ca3$export$f680877a34711e37; }, function (v) { return $419663ed77570ca3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $419663ed77570ca3$export$d5a552a76deda3c2; }, function (v) { return $419663ed77570ca3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $419663ed77570ca3$export$aaabe4eda9ed9969; }, function (v) { return $419663ed77570ca3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $419663ed77570ca3$export$e5c5a5f917a5871c; }, function (v) { return $419663ed77570ca3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $419663ed77570ca3$export$1538c33de8887b59; }, function (v) { return $419663ed77570ca3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $419663ed77570ca3$export$fca7f784ae7a249a; }, function (v) { return $419663ed77570ca3$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $419663ed77570ca3$export$13e3392192263954; }, function (v) { return $419663ed77570ca3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $419663ed77570ca3$export$b8f5890fc79d6aca; }, function (v) { return $419663ed77570ca3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $419663ed77570ca3$export$60241385465d0a34; }, function (v) { return $419663ed77570ca3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $419663ed77570ca3$export$306c0aa65ff9ec16; }, function (v) { return $419663ed77570ca3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $419663ed77570ca3$export$7b286972b8d8ccbf; }, function (v) { return $419663ed77570ca3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $419663ed77570ca3$export$83d89fbfd8236492; }, function (v) { return $419663ed77570ca3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $419663ed77570ca3$export$9c16c1426311996d;
var $419663ed77570ca3$export$dca3b0875bd9a954;
var $419663ed77570ca3$export$16fa2f45be04daa8;
var $419663ed77570ca3$export$ffb0004e005737fa;
var $419663ed77570ca3$export$e2c29f18771995cb;
var $419663ed77570ca3$export$221d75b3f55bb0bd;
var $419663ed77570ca3$export$5f8d39834fd61797;
var $419663ed77570ca3$export$74bf444e3cd11ea5;
var $419663ed77570ca3$export$1ced07cd6b1985ce;
var $419663ed77570ca3$export$abd8e32b826d7ea7;
var $419663ed77570ca3$export$69a3209f1a06c04d;
var $419663ed77570ca3$export$8c538325882c7eec;
var $419663ed77570ca3$export$e530037191fcd5d7;
var $419663ed77570ca3$export$fd42f52fd3ae1109;
var $419663ed77570ca3$export$c8a8987d4410bf2d;
var $419663ed77570ca3$export$7d1e3a5e95ceca43;
var $419663ed77570ca3$export$257a8862b851cb5b;
var $419663ed77570ca3$export$a8257692ac88316c;
var $419663ed77570ca3$export$488013bae63b21da;
var $419663ed77570ca3$export$7c73462e0d25e514;
var $419663ed77570ca3$export$7568632d0d33d16d;
var $419663ed77570ca3$export$f93f40ac0ca7e3a8;
var $419663ed77570ca3$export$1f96ae73734a86cc;
var $419663ed77570ca3$export$9a47ced3238df325;
var $419663ed77570ca3$export$35808ee640e87ca7;
var $419663ed77570ca3$export$fae74005e78b1a27;
var $419663ed77570ca3$export$dc8fbce3eb94dc1e;
var $419663ed77570ca3$export$6a7bc4e911dc01cf;
var $419663ed77570ca3$export$6d9c69b0de29b591;
var $419663ed77570ca3$export$7f54fc3180508a52;
var $419663ed77570ca3$export$f680877a34711e37;
var $419663ed77570ca3$export$d5a552a76deda3c2;
var $419663ed77570ca3$export$aaabe4eda9ed9969;
var $419663ed77570ca3$export$e5c5a5f917a5871c;
var $419663ed77570ca3$export$1538c33de8887b59;
var $419663ed77570ca3$export$fca7f784ae7a249a;
var $419663ed77570ca3$export$13e3392192263954;
var $419663ed77570ca3$export$b8f5890fc79d6aca;
var $419663ed77570ca3$export$60241385465d0a34;
var $419663ed77570ca3$export$306c0aa65ff9ec16;
var $419663ed77570ca3$export$7b286972b8d8ccbf;
var $419663ed77570ca3$export$83d89fbfd8236492;
"use strict";
var $419663ed77570ca3$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $419663ed77570ca3$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $419663ed77570ca3$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $419663ed77570ca3$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $419663ed77570ca3$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $419663ed77570ca3$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $419663ed77570ca3$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $419663ed77570ca3$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $419663ed77570ca3$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $419663ed77570ca3$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $419663ed77570ca3$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $419663ed77570ca3$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $419663ed77570ca3$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $419663ed77570ca3$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $419663ed77570ca3$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$419663ed77570ca3$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $419663ed77570ca3$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $419663ed77570ca3$var$assign = Object.assign, $419663ed77570ca3$var$emptyObject = {};
function $419663ed77570ca3$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $419663ed77570ca3$var$emptyObject;
    this.updater = updater || $419663ed77570ca3$var$ReactNoopUpdateQueue;
}
$419663ed77570ca3$var$Component.prototype.isReactComponent = {};
$419663ed77570ca3$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$419663ed77570ca3$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $419663ed77570ca3$var$ComponentDummy() {}
$419663ed77570ca3$var$ComponentDummy.prototype = $419663ed77570ca3$var$Component.prototype;
function $419663ed77570ca3$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $419663ed77570ca3$var$emptyObject;
    this.updater = updater || $419663ed77570ca3$var$ReactNoopUpdateQueue;
}
var $419663ed77570ca3$var$pureComponentPrototype = $419663ed77570ca3$var$PureComponent.prototype = new $419663ed77570ca3$var$ComponentDummy();
$419663ed77570ca3$var$pureComponentPrototype.constructor = $419663ed77570ca3$var$PureComponent;
$419663ed77570ca3$var$assign($419663ed77570ca3$var$pureComponentPrototype, $419663ed77570ca3$var$Component.prototype);
$419663ed77570ca3$var$pureComponentPrototype.isPureReactComponent = !0;
var $419663ed77570ca3$var$isArrayImpl = Array.isArray;
function $419663ed77570ca3$var$noop() {}
var $419663ed77570ca3$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $419663ed77570ca3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $419663ed77570ca3$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $419663ed77570ca3$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $419663ed77570ca3$var$cloneAndReplaceKey(oldElement, newKey) {
    return $419663ed77570ca3$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $419663ed77570ca3$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $419663ed77570ca3$var$REACT_ELEMENT_TYPE;
}
function $419663ed77570ca3$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $419663ed77570ca3$var$userProvidedKeyEscapeRegex = /\/+/g;
function $419663ed77570ca3$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $419663ed77570ca3$var$escape("" + element.key) : index.toString(36);
}
function $419663ed77570ca3$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($419663ed77570ca3$var$noop, $419663ed77570ca3$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $419663ed77570ca3$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $419663ed77570ca3$var$REACT_ELEMENT_TYPE:
                case $419663ed77570ca3$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $419663ed77570ca3$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $419663ed77570ca3$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $419663ed77570ca3$var$getElementKey(children, 0) : nameSoFar, $419663ed77570ca3$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($419663ed77570ca3$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $419663ed77570ca3$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($419663ed77570ca3$var$isValidElement(callback) && (callback = $419663ed77570ca3$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($419663ed77570ca3$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($419663ed77570ca3$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $419663ed77570ca3$var$getElementKey(nameSoFar, i), invokeCallback += $419663ed77570ca3$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $419663ed77570ca3$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $419663ed77570ca3$var$getElementKey(nameSoFar, i++), invokeCallback += $419663ed77570ca3$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $419663ed77570ca3$var$mapIntoArray($419663ed77570ca3$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $419663ed77570ca3$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $419663ed77570ca3$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $419663ed77570ca3$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $419663ed77570ca3$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $419663ed77570ca3$var$Children = {
    map: $419663ed77570ca3$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $419663ed77570ca3$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $419663ed77570ca3$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $419663ed77570ca3$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$419663ed77570ca3$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$419663ed77570ca3$export$9c16c1426311996d = $419663ed77570ca3$var$REACT_ACTIVITY_TYPE;
$419663ed77570ca3$export$dca3b0875bd9a954 = $419663ed77570ca3$var$Children;
$419663ed77570ca3$export$16fa2f45be04daa8 = $419663ed77570ca3$var$Component;
$419663ed77570ca3$export$ffb0004e005737fa = $419663ed77570ca3$var$REACT_FRAGMENT_TYPE;
$419663ed77570ca3$export$e2c29f18771995cb = $419663ed77570ca3$var$REACT_PROFILER_TYPE;
$419663ed77570ca3$export$221d75b3f55bb0bd = $419663ed77570ca3$var$PureComponent;
$419663ed77570ca3$export$5f8d39834fd61797 = $419663ed77570ca3$var$REACT_STRICT_MODE_TYPE;
$419663ed77570ca3$export$74bf444e3cd11ea5 = $419663ed77570ca3$var$REACT_SUSPENSE_TYPE;
$419663ed77570ca3$export$1ced07cd6b1985ce = $419663ed77570ca3$var$ReactSharedInternals;
$419663ed77570ca3$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $419663ed77570ca3$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$419663ed77570ca3$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$419663ed77570ca3$export$8c538325882c7eec = function() {
    return null;
};
$419663ed77570ca3$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $419663ed77570ca3$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$419663ed77570ca3$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $419663ed77570ca3$var$ReactElement(element.type, key, props);
};
$419663ed77570ca3$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $419663ed77570ca3$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $419663ed77570ca3$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$419663ed77570ca3$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$419663ed77570ca3$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $419663ed77570ca3$var$ReactElement(type, key, props);
};
$419663ed77570ca3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$419663ed77570ca3$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $419663ed77570ca3$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$419663ed77570ca3$export$a8257692ac88316c = $419663ed77570ca3$var$isValidElement;
$419663ed77570ca3$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $419663ed77570ca3$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $419663ed77570ca3$var$lazyInitializer
    };
};
$419663ed77570ca3$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $419663ed77570ca3$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$419663ed77570ca3$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $419663ed77570ca3$var$ReactSharedInternals.T, currentTransition = {};
    $419663ed77570ca3$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $419663ed77570ca3$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($419663ed77570ca3$var$noop, $419663ed77570ca3$var$reportGlobalError);
    } catch (error) {
        $419663ed77570ca3$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $419663ed77570ca3$var$ReactSharedInternals.T = prevTransition;
    }
};
$419663ed77570ca3$export$f93f40ac0ca7e3a8 = function() {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useCacheRefresh();
};
$419663ed77570ca3$export$1f96ae73734a86cc = function(usable) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.use(usable);
};
$419663ed77570ca3$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$419663ed77570ca3$export$35808ee640e87ca7 = function(callback, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$419663ed77570ca3$export$fae74005e78b1a27 = function(Context) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useContext(Context);
};
$419663ed77570ca3$export$dc8fbce3eb94dc1e = function() {};
$419663ed77570ca3$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$419663ed77570ca3$export$6d9c69b0de29b591 = function(create, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useEffect(create, deps);
};
$419663ed77570ca3$export$7f54fc3180508a52 = function(callback) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$419663ed77570ca3$export$f680877a34711e37 = function() {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useId();
};
$419663ed77570ca3$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$419663ed77570ca3$export$aaabe4eda9ed9969 = function(create, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$419663ed77570ca3$export$e5c5a5f917a5871c = function(create, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$419663ed77570ca3$export$1538c33de8887b59 = function(create, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useMemo(create, deps);
};
$419663ed77570ca3$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$419663ed77570ca3$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$419663ed77570ca3$export$b8f5890fc79d6aca = function(initialValue) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useRef(initialValue);
};
$419663ed77570ca3$export$60241385465d0a34 = function(initialState) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useState(initialState);
};
$419663ed77570ca3$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$419663ed77570ca3$export$7b286972b8d8ccbf = function() {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useTransition();
};
$419663ed77570ca3$export$83d89fbfd8236492 = "19.2.8";

});


parcelRegister("dAQd3", function(module, exports) {
'use strict';
function $9e5722dfb1623841$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9e5722dfb1623841$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9e5722dfb1623841$var$checkDCE();

module.exports = (parcelRequire("f7UAs"));

});
parcelRegister("f7UAs", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $b033677176f3968b$export$69ce8ef3fe5cead0; }, function (v) { return $b033677176f3968b$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $b033677176f3968b$export$d39a5bbd09211389; }, function (v) { return $b033677176f3968b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b033677176f3968b$export$cd75ccfd720a3cd4; }, function (v) { return $b033677176f3968b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $b033677176f3968b$export$a0816fa17a9e79be; }, function (v) { return $b033677176f3968b$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $b033677176f3968b$export$7292efcadded39f3; }, function (v) { return $b033677176f3968b$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $b033677176f3968b$export$da407abadb9b8f86; }, function (v) { return $b033677176f3968b$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $b033677176f3968b$export$314cfea32580671c; }, function (v) { return $b033677176f3968b$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $b033677176f3968b$export$513ccb98c53b8039; }, function (v) { return $b033677176f3968b$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $b033677176f3968b$export$dbca993bc2d264a; }, function (v) { return $b033677176f3968b$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $b033677176f3968b$export$4797a8006f0655d0; }, function (v) { return $b033677176f3968b$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b033677176f3968b$export$c78a37762a8d58e1; }, function (v) { return $b033677176f3968b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $b033677176f3968b$export$606f11b2eb45ecc6; }, function (v) { return $b033677176f3968b$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $b033677176f3968b$export$f7e8a0bf92324b1e; }, function (v) { return $b033677176f3968b$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $b033677176f3968b$export$83d89fbfd8236492; }, function (v) { return $b033677176f3968b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b033677176f3968b$export$69ce8ef3fe5cead0;
var $b033677176f3968b$export$d39a5bbd09211389;
var $b033677176f3968b$export$cd75ccfd720a3cd4;
var $b033677176f3968b$export$a0816fa17a9e79be;
var $b033677176f3968b$export$7292efcadded39f3;
var $b033677176f3968b$export$da407abadb9b8f86;
var $b033677176f3968b$export$314cfea32580671c;
var $b033677176f3968b$export$513ccb98c53b8039;
var $b033677176f3968b$export$dbca993bc2d264a;
var $b033677176f3968b$export$4797a8006f0655d0;
var $b033677176f3968b$export$c78a37762a8d58e1;
var $b033677176f3968b$export$606f11b2eb45ecc6;
var $b033677176f3968b$export$f7e8a0bf92324b1e;
var $b033677176f3968b$export$83d89fbfd8236492;
"use strict";

var $lCzvA = parcelRequire("lCzvA");
function $b033677176f3968b$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $b033677176f3968b$var$noop() {}
var $b033677176f3968b$var$Internals = {
    d: {
        f: $b033677176f3968b$var$noop,
        r: function() {
            throw Error($b033677176f3968b$var$formatProdErrorMessage(522));
        },
        D: $b033677176f3968b$var$noop,
        C: $b033677176f3968b$var$noop,
        L: $b033677176f3968b$var$noop,
        m: $b033677176f3968b$var$noop,
        X: $b033677176f3968b$var$noop,
        S: $b033677176f3968b$var$noop,
        M: $b033677176f3968b$var$noop
    },
    p: 0,
    findDOMNode: null
}, $b033677176f3968b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $b033677176f3968b$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b033677176f3968b$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $b033677176f3968b$var$ReactSharedInternals = $lCzvA.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $b033677176f3968b$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$b033677176f3968b$export$69ce8ef3fe5cead0 = $b033677176f3968b$var$Internals;
$b033677176f3968b$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($b033677176f3968b$var$formatProdErrorMessage(299));
    return $b033677176f3968b$var$createPortal$1(children, container, null, key);
};
$b033677176f3968b$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $b033677176f3968b$var$ReactSharedInternals.T, previousUpdatePriority = $b033677176f3968b$var$Internals.p;
    try {
        if ($b033677176f3968b$var$ReactSharedInternals.T = null, $b033677176f3968b$var$Internals.p = 2, fn) return fn();
    } finally{
        $b033677176f3968b$var$ReactSharedInternals.T = previousTransition, $b033677176f3968b$var$Internals.p = previousUpdatePriority, $b033677176f3968b$var$Internals.d.f();
    }
};
$b033677176f3968b$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $b033677176f3968b$var$Internals.d.C(href, options));
};
$b033677176f3968b$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $b033677176f3968b$var$Internals.d.D(href);
};
$b033677176f3968b$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $b033677176f3968b$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $b033677176f3968b$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $b033677176f3968b$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$b033677176f3968b$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $b033677176f3968b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $b033677176f3968b$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $b033677176f3968b$var$Internals.d.M(href);
    }
};
$b033677176f3968b$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $b033677176f3968b$var$getCrossOriginStringAs(as, options.crossOrigin);
        $b033677176f3968b$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$b033677176f3968b$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $b033677176f3968b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $b033677176f3968b$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $b033677176f3968b$var$Internals.d.m(href);
    }
};
$b033677176f3968b$export$4797a8006f0655d0 = function(form) {
    $b033677176f3968b$var$Internals.d.r(form);
};
$b033677176f3968b$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$b033677176f3968b$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $b033677176f3968b$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$b033677176f3968b$export$f7e8a0bf92324b1e = function() {
    return $b033677176f3968b$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$b033677176f3968b$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("8XozM", function(module, exports) {

var $5mCTm = parcelRequire("5mCTm");

var $6ezXE = parcelRequire("6ezXE");

var $i3Cjc = parcelRequire("i3Cjc");

var $iHsN0 = parcelRequire("iHsN0");

var $boDuC = parcelRequire("boDuC");

var $bzzgL = parcelRequire("bzzgL");

var $k27Xk = parcelRequire("k27Xk");
function $6856e5be6308a5f6$var$_regeneratorRuntime() {
    "use strict";
    var r = $6ezXE(), e = r.m($6856e5be6308a5f6$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $k27Xk(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $6856e5be6308a5f6$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $5mCTm(r, e);
            },
            AsyncIterator: $boDuC,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $iHsN0 : $i3Cjc)(a(r), e, t, o, u);
            },
            keys: $bzzgL,
            values: $k27Xk
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $6856e5be6308a5f6$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5mCTm", function(module, exports) {
function $3e7d2cf162d9f9ae$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $3e7d2cf162d9f9ae$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6ezXE", function(module, exports) {

var $hjE1z = parcelRequire("hjE1z");
function $489ff2053b33302e$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $hjE1z(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($hjE1z(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $hjE1z(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $hjE1z(u, "constructor", GeneratorFunctionPrototype), $hjE1z(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $hjE1z(GeneratorFunctionPrototype, o, "GeneratorFunction"), $hjE1z(u), $hjE1z(u, o, "Generator"), $hjE1z(u, n, function() {
        return this;
    }), $hjE1z(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $489ff2053b33302e$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $489ff2053b33302e$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hjE1z", function(module, exports) {
function $c9b34209c1065408$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $c9b34209c1065408$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $c9b34209c1065408$var$_regeneratorDefine(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c9b34209c1065408$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $c9b34209c1065408$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("i3Cjc", function(module, exports) {

var $iHsN0 = parcelRequire("iHsN0");
function $d256391e793aea22$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $iHsN0(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $d256391e793aea22$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iHsN0", function(module, exports) {

var $6ezXE = parcelRequire("6ezXE");

var $boDuC = parcelRequire("boDuC");
function $d9d2931a87432eac$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $boDuC($6ezXE().w(r, e, t, o), n || Promise);
}
module.exports = $d9d2931a87432eac$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("boDuC", function(module, exports) {

var $5mCTm = parcelRequire("5mCTm");

var $hjE1z = parcelRequire("hjE1z");
function $84c092104ab589d0$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $5mCTm ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($hjE1z($84c092104ab589d0$var$AsyncIterator.prototype), $hjE1z($84c092104ab589d0$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $hjE1z(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $84c092104ab589d0$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bzzgL", function(module, exports) {
function $86ce525afad2afe6$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $86ce525afad2afe6$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("k27Xk", function(module, exports) {

var $8zDbG = parcelRequire("8zDbG");
var $e95a2a687c19b73a$var$_typeof = $8zDbG.default;
function $e95a2a687c19b73a$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($e95a2a687c19b73a$var$_typeof(e) + " is not iterable");
}
module.exports = $e95a2a687c19b73a$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8zDbG", function(module, exports) {
function $63dffd6b14b7fff5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $63dffd6b14b7fff5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $63dffd6b14b7fff5$var$_typeof(o);
}
module.exports = $63dffd6b14b7fff5$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fYDAD", function(module, exports) {
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.41", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HONOR = "Honor", HUAWEI = "Huawei", LENOVO = "Lenovo", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPERA = "Opera", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Maxthon"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI" + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "360"
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1Browser"
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1" + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /\b(links) \(([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        OnePlus: [
                            "304",
                            "403",
                            "203"
                        ],
                        "*": OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    "Nokia"
                ]
            ],
            [
                /(pixel (c|tablet))\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "TCL"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        tablet: [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Energizer"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Cat"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Smartfren"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nothing"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    "LibWeb"
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Touch"
                ],
                VERSION
            ],
            [
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("1AISF", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $1cUPA = parcelRequire("1cUPA");
function $128bf7979c1e77e7$var$emptyFunction() {}
function $128bf7979c1e77e7$var$emptyFunctionWithReset() {}
$128bf7979c1e77e7$var$emptyFunctionWithReset.resetWarningCache = $128bf7979c1e77e7$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $1cUPA) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $128bf7979c1e77e7$var$emptyFunctionWithReset,
        resetWarningCache: $128bf7979c1e77e7$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("1cUPA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $0e12fede87db0066$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $0e12fede87db0066$var$ReactPropTypesSecret;

});


parcelRegister("8ujjx", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $62e01b762dcde2de$export$2b8d127b894957b9; }, function (v) { return $62e01b762dcde2de$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $62e01b762dcde2de$export$cea3a54a6425200c; }, function (v) { return $62e01b762dcde2de$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $62e01b762dcde2de$export$a7c73072b1a182ae; }, function (v) { return $62e01b762dcde2de$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $62e01b762dcde2de$export$9f27bc3417b4524d; }, function (v) { return $62e01b762dcde2de$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $62e01b762dcde2de$export$db77ccec0bb4ccac; }, function (v) { return $62e01b762dcde2de$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $62e01b762dcde2de$export$8392c0c9d3dcbd35; }, function (v) { return $62e01b762dcde2de$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $62e01b762dcde2de$export$ffb0004e005737fa; }, function (v) { return $62e01b762dcde2de$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $62e01b762dcde2de$export$b624eff549462981; }, function (v) { return $62e01b762dcde2de$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $62e01b762dcde2de$export$7897aa7841a5380c; }, function (v) { return $62e01b762dcde2de$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $62e01b762dcde2de$export$602eac185826482c; }, function (v) { return $62e01b762dcde2de$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $62e01b762dcde2de$export$e2c29f18771995cb; }, function (v) { return $62e01b762dcde2de$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $62e01b762dcde2de$export$5f8d39834fd61797; }, function (v) { return $62e01b762dcde2de$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $62e01b762dcde2de$export$74bf444e3cd11ea5; }, function (v) { return $62e01b762dcde2de$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $62e01b762dcde2de$export$92387174baf9b227; }, function (v) { return $62e01b762dcde2de$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $62e01b762dcde2de$export$ec112efeb987d9c6; }, function (v) { return $62e01b762dcde2de$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $62e01b762dcde2de$export$b706b080d889d2c9; }, function (v) { return $62e01b762dcde2de$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $62e01b762dcde2de$export$5be5a87408f70ddc; }, function (v) { return $62e01b762dcde2de$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $62e01b762dcde2de$export$45a5e7f76e0caa8d; }, function (v) { return $62e01b762dcde2de$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $62e01b762dcde2de$export$455c2e768291efa6; }, function (v) { return $62e01b762dcde2de$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $62e01b762dcde2de$export$9522e17588c12572; }, function (v) { return $62e01b762dcde2de$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $62e01b762dcde2de$export$2110ac352bb060b9; }, function (v) { return $62e01b762dcde2de$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $62e01b762dcde2de$export$56885ab8b9c456ab; }, function (v) { return $62e01b762dcde2de$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $62e01b762dcde2de$export$d927fcb6adf8f9de; }, function (v) { return $62e01b762dcde2de$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $62e01b762dcde2de$export$b82d16f27459e05a; }, function (v) { return $62e01b762dcde2de$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $62e01b762dcde2de$export$522c17b4f5e123e8; }, function (v) { return $62e01b762dcde2de$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $62e01b762dcde2de$export$1aabd8a0274ecfd6; }, function (v) { return $62e01b762dcde2de$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $62e01b762dcde2de$export$9b621391a187a31a; }, function (v) { return $62e01b762dcde2de$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $62e01b762dcde2de$export$f5bbd400c2f4426f; }, function (v) { return $62e01b762dcde2de$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $62e01b762dcde2de$export$2b8d127b894957b9;
var $62e01b762dcde2de$export$cea3a54a6425200c;
var $62e01b762dcde2de$export$a7c73072b1a182ae;
var $62e01b762dcde2de$export$9f27bc3417b4524d;
var $62e01b762dcde2de$export$db77ccec0bb4ccac;
var $62e01b762dcde2de$export$8392c0c9d3dcbd35;
var $62e01b762dcde2de$export$ffb0004e005737fa;
var $62e01b762dcde2de$export$b624eff549462981;
var $62e01b762dcde2de$export$7897aa7841a5380c;
var $62e01b762dcde2de$export$602eac185826482c;
var $62e01b762dcde2de$export$e2c29f18771995cb;
var $62e01b762dcde2de$export$5f8d39834fd61797;
var $62e01b762dcde2de$export$74bf444e3cd11ea5;
var $62e01b762dcde2de$export$92387174baf9b227;
var $62e01b762dcde2de$export$ec112efeb987d9c6;
var $62e01b762dcde2de$export$b706b080d889d2c9;
var $62e01b762dcde2de$export$5be5a87408f70ddc;
var $62e01b762dcde2de$export$45a5e7f76e0caa8d;
var $62e01b762dcde2de$export$455c2e768291efa6;
var $62e01b762dcde2de$export$9522e17588c12572;
var $62e01b762dcde2de$export$2110ac352bb060b9;
var $62e01b762dcde2de$export$56885ab8b9c456ab;
var $62e01b762dcde2de$export$d927fcb6adf8f9de;
var $62e01b762dcde2de$export$b82d16f27459e05a;
var $62e01b762dcde2de$export$522c17b4f5e123e8;
var $62e01b762dcde2de$export$1aabd8a0274ecfd6;
var $62e01b762dcde2de$export$9b621391a187a31a;
var $62e01b762dcde2de$export$f5bbd400c2f4426f;
'use strict';
var $62e01b762dcde2de$var$b = "function" === typeof Symbol && Symbol.for, $62e01b762dcde2de$var$c = $62e01b762dcde2de$var$b ? Symbol.for("react.element") : 60103, $62e01b762dcde2de$var$d = $62e01b762dcde2de$var$b ? Symbol.for("react.portal") : 60106, $62e01b762dcde2de$var$e = $62e01b762dcde2de$var$b ? Symbol.for("react.fragment") : 60107, $62e01b762dcde2de$var$f = $62e01b762dcde2de$var$b ? Symbol.for("react.strict_mode") : 60108, $62e01b762dcde2de$var$g = $62e01b762dcde2de$var$b ? Symbol.for("react.profiler") : 60114, $62e01b762dcde2de$var$h = $62e01b762dcde2de$var$b ? Symbol.for("react.provider") : 60109, $62e01b762dcde2de$var$k = $62e01b762dcde2de$var$b ? Symbol.for("react.context") : 60110, $62e01b762dcde2de$var$l = $62e01b762dcde2de$var$b ? Symbol.for("react.async_mode") : 60111, $62e01b762dcde2de$var$m = $62e01b762dcde2de$var$b ? Symbol.for("react.concurrent_mode") : 60111, $62e01b762dcde2de$var$n = $62e01b762dcde2de$var$b ? Symbol.for("react.forward_ref") : 60112, $62e01b762dcde2de$var$p = $62e01b762dcde2de$var$b ? Symbol.for("react.suspense") : 60113, $62e01b762dcde2de$var$q = $62e01b762dcde2de$var$b ? Symbol.for("react.suspense_list") : 60120, $62e01b762dcde2de$var$r = $62e01b762dcde2de$var$b ? Symbol.for("react.memo") : 60115, $62e01b762dcde2de$var$t = $62e01b762dcde2de$var$b ? Symbol.for("react.lazy") : 60116, $62e01b762dcde2de$var$v = $62e01b762dcde2de$var$b ? Symbol.for("react.block") : 60121, $62e01b762dcde2de$var$w = $62e01b762dcde2de$var$b ? Symbol.for("react.fundamental") : 60117, $62e01b762dcde2de$var$x = $62e01b762dcde2de$var$b ? Symbol.for("react.responder") : 60118, $62e01b762dcde2de$var$y = $62e01b762dcde2de$var$b ? Symbol.for("react.scope") : 60119;
function $62e01b762dcde2de$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $62e01b762dcde2de$var$c:
                switch(a = a.type, a){
                    case $62e01b762dcde2de$var$l:
                    case $62e01b762dcde2de$var$m:
                    case $62e01b762dcde2de$var$e:
                    case $62e01b762dcde2de$var$g:
                    case $62e01b762dcde2de$var$f:
                    case $62e01b762dcde2de$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $62e01b762dcde2de$var$k:
                            case $62e01b762dcde2de$var$n:
                            case $62e01b762dcde2de$var$t:
                            case $62e01b762dcde2de$var$r:
                            case $62e01b762dcde2de$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $62e01b762dcde2de$var$d:
                return u;
        }
    }
}
function $62e01b762dcde2de$var$A(a) {
    return $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$m;
}
$62e01b762dcde2de$export$2b8d127b894957b9 = $62e01b762dcde2de$var$l;
$62e01b762dcde2de$export$cea3a54a6425200c = $62e01b762dcde2de$var$m;
$62e01b762dcde2de$export$a7c73072b1a182ae = $62e01b762dcde2de$var$k;
$62e01b762dcde2de$export$9f27bc3417b4524d = $62e01b762dcde2de$var$h;
$62e01b762dcde2de$export$db77ccec0bb4ccac = $62e01b762dcde2de$var$c;
$62e01b762dcde2de$export$8392c0c9d3dcbd35 = $62e01b762dcde2de$var$n;
$62e01b762dcde2de$export$ffb0004e005737fa = $62e01b762dcde2de$var$e;
$62e01b762dcde2de$export$b624eff549462981 = $62e01b762dcde2de$var$t;
$62e01b762dcde2de$export$7897aa7841a5380c = $62e01b762dcde2de$var$r;
$62e01b762dcde2de$export$602eac185826482c = $62e01b762dcde2de$var$d;
$62e01b762dcde2de$export$e2c29f18771995cb = $62e01b762dcde2de$var$g;
$62e01b762dcde2de$export$5f8d39834fd61797 = $62e01b762dcde2de$var$f;
$62e01b762dcde2de$export$74bf444e3cd11ea5 = $62e01b762dcde2de$var$p;
$62e01b762dcde2de$export$92387174baf9b227 = function(a) {
    return $62e01b762dcde2de$var$A(a) || $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$l;
};
$62e01b762dcde2de$export$ec112efeb987d9c6 = $62e01b762dcde2de$var$A;
$62e01b762dcde2de$export$b706b080d889d2c9 = function(a) {
    return $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$k;
};
$62e01b762dcde2de$export$5be5a87408f70ddc = function(a) {
    return $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$h;
};
$62e01b762dcde2de$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $62e01b762dcde2de$var$c;
};
$62e01b762dcde2de$export$455c2e768291efa6 = function(a) {
    return $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$n;
};
$62e01b762dcde2de$export$9522e17588c12572 = function(a) {
    return $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$e;
};
$62e01b762dcde2de$export$2110ac352bb060b9 = function(a) {
    return $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$t;
};
$62e01b762dcde2de$export$56885ab8b9c456ab = function(a) {
    return $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$r;
};
$62e01b762dcde2de$export$d927fcb6adf8f9de = function(a) {
    return $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$d;
};
$62e01b762dcde2de$export$b82d16f27459e05a = function(a) {
    return $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$g;
};
$62e01b762dcde2de$export$522c17b4f5e123e8 = function(a) {
    return $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$f;
};
$62e01b762dcde2de$export$1aabd8a0274ecfd6 = function(a) {
    return $62e01b762dcde2de$var$z(a) === $62e01b762dcde2de$var$p;
};
$62e01b762dcde2de$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $62e01b762dcde2de$var$e || a === $62e01b762dcde2de$var$m || a === $62e01b762dcde2de$var$g || a === $62e01b762dcde2de$var$f || a === $62e01b762dcde2de$var$p || a === $62e01b762dcde2de$var$q || "object" === typeof a && null !== a && (a.$$typeof === $62e01b762dcde2de$var$t || a.$$typeof === $62e01b762dcde2de$var$r || a.$$typeof === $62e01b762dcde2de$var$h || a.$$typeof === $62e01b762dcde2de$var$k || a.$$typeof === $62e01b762dcde2de$var$n || a.$$typeof === $62e01b762dcde2de$var$w || a.$$typeof === $62e01b762dcde2de$var$x || a.$$typeof === $62e01b762dcde2de$var$y || a.$$typeof === $62e01b762dcde2de$var$v);
};
$62e01b762dcde2de$export$f5bbd400c2f4426f = $62e01b762dcde2de$var$z;

});

parcelRegister("3Z4cM", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $2e6a54a800d2117a$export$a7c73072b1a182ae; }, function (v) { return $2e6a54a800d2117a$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2e6a54a800d2117a$export$9f27bc3417b4524d; }, function (v) { return $2e6a54a800d2117a$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2e6a54a800d2117a$export$db77ccec0bb4ccac; }, function (v) { return $2e6a54a800d2117a$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2e6a54a800d2117a$export$8392c0c9d3dcbd35; }, function (v) { return $2e6a54a800d2117a$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2e6a54a800d2117a$export$ffb0004e005737fa; }, function (v) { return $2e6a54a800d2117a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2e6a54a800d2117a$export$b624eff549462981; }, function (v) { return $2e6a54a800d2117a$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2e6a54a800d2117a$export$7897aa7841a5380c; }, function (v) { return $2e6a54a800d2117a$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2e6a54a800d2117a$export$602eac185826482c; }, function (v) { return $2e6a54a800d2117a$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2e6a54a800d2117a$export$e2c29f18771995cb; }, function (v) { return $2e6a54a800d2117a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2e6a54a800d2117a$export$5f8d39834fd61797; }, function (v) { return $2e6a54a800d2117a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2e6a54a800d2117a$export$74bf444e3cd11ea5; }, function (v) { return $2e6a54a800d2117a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $2e6a54a800d2117a$export$998bcd577473dd93; }, function (v) { return $2e6a54a800d2117a$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2e6a54a800d2117a$export$b706b080d889d2c9; }, function (v) { return $2e6a54a800d2117a$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2e6a54a800d2117a$export$5be5a87408f70ddc; }, function (v) { return $2e6a54a800d2117a$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2e6a54a800d2117a$export$45a5e7f76e0caa8d; }, function (v) { return $2e6a54a800d2117a$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2e6a54a800d2117a$export$455c2e768291efa6; }, function (v) { return $2e6a54a800d2117a$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2e6a54a800d2117a$export$9522e17588c12572; }, function (v) { return $2e6a54a800d2117a$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2e6a54a800d2117a$export$2110ac352bb060b9; }, function (v) { return $2e6a54a800d2117a$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2e6a54a800d2117a$export$56885ab8b9c456ab; }, function (v) { return $2e6a54a800d2117a$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2e6a54a800d2117a$export$d927fcb6adf8f9de; }, function (v) { return $2e6a54a800d2117a$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2e6a54a800d2117a$export$b82d16f27459e05a; }, function (v) { return $2e6a54a800d2117a$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2e6a54a800d2117a$export$522c17b4f5e123e8; }, function (v) { return $2e6a54a800d2117a$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2e6a54a800d2117a$export$1aabd8a0274ecfd6; }, function (v) { return $2e6a54a800d2117a$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $2e6a54a800d2117a$export$3d6c20d97e46b957; }, function (v) { return $2e6a54a800d2117a$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2e6a54a800d2117a$export$9b621391a187a31a; }, function (v) { return $2e6a54a800d2117a$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2e6a54a800d2117a$export$f5bbd400c2f4426f; }, function (v) { return $2e6a54a800d2117a$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2e6a54a800d2117a$export$a7c73072b1a182ae;
var $2e6a54a800d2117a$export$9f27bc3417b4524d;
var $2e6a54a800d2117a$export$db77ccec0bb4ccac;
var $2e6a54a800d2117a$export$8392c0c9d3dcbd35;
var $2e6a54a800d2117a$export$ffb0004e005737fa;
var $2e6a54a800d2117a$export$b624eff549462981;
var $2e6a54a800d2117a$export$7897aa7841a5380c;
var $2e6a54a800d2117a$export$602eac185826482c;
var $2e6a54a800d2117a$export$e2c29f18771995cb;
var $2e6a54a800d2117a$export$5f8d39834fd61797;
var $2e6a54a800d2117a$export$74bf444e3cd11ea5;
var $2e6a54a800d2117a$export$998bcd577473dd93;
var $2e6a54a800d2117a$export$b706b080d889d2c9;
var $2e6a54a800d2117a$export$5be5a87408f70ddc;
var $2e6a54a800d2117a$export$45a5e7f76e0caa8d;
var $2e6a54a800d2117a$export$455c2e768291efa6;
var $2e6a54a800d2117a$export$9522e17588c12572;
var $2e6a54a800d2117a$export$2110ac352bb060b9;
var $2e6a54a800d2117a$export$56885ab8b9c456ab;
var $2e6a54a800d2117a$export$d927fcb6adf8f9de;
var $2e6a54a800d2117a$export$b82d16f27459e05a;
var $2e6a54a800d2117a$export$522c17b4f5e123e8;
var $2e6a54a800d2117a$export$1aabd8a0274ecfd6;
var $2e6a54a800d2117a$export$3d6c20d97e46b957;
var $2e6a54a800d2117a$export$9b621391a187a31a;
var $2e6a54a800d2117a$export$f5bbd400c2f4426f;
"use strict";
var $2e6a54a800d2117a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $2e6a54a800d2117a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $2e6a54a800d2117a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $2e6a54a800d2117a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $2e6a54a800d2117a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $2e6a54a800d2117a$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $2e6a54a800d2117a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $2e6a54a800d2117a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $2e6a54a800d2117a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $2e6a54a800d2117a$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $2e6a54a800d2117a$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $2e6a54a800d2117a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $2e6a54a800d2117a$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $2e6a54a800d2117a$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $2e6a54a800d2117a$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $2e6a54a800d2117a$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $2e6a54a800d2117a$var$REACT_FRAGMENT_TYPE:
                    case $2e6a54a800d2117a$var$REACT_PROFILER_TYPE:
                    case $2e6a54a800d2117a$var$REACT_STRICT_MODE_TYPE:
                    case $2e6a54a800d2117a$var$REACT_SUSPENSE_TYPE:
                    case $2e6a54a800d2117a$var$REACT_SUSPENSE_LIST_TYPE:
                    case $2e6a54a800d2117a$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $2e6a54a800d2117a$var$REACT_CONTEXT_TYPE:
                            case $2e6a54a800d2117a$var$REACT_FORWARD_REF_TYPE:
                            case $2e6a54a800d2117a$var$REACT_LAZY_TYPE:
                            case $2e6a54a800d2117a$var$REACT_MEMO_TYPE:
                                return object;
                            case $2e6a54a800d2117a$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $2e6a54a800d2117a$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$2e6a54a800d2117a$export$a7c73072b1a182ae = $2e6a54a800d2117a$var$REACT_CONSUMER_TYPE;
$2e6a54a800d2117a$export$9f27bc3417b4524d = $2e6a54a800d2117a$var$REACT_CONTEXT_TYPE;
$2e6a54a800d2117a$export$db77ccec0bb4ccac = $2e6a54a800d2117a$var$REACT_ELEMENT_TYPE;
$2e6a54a800d2117a$export$8392c0c9d3dcbd35 = $2e6a54a800d2117a$var$REACT_FORWARD_REF_TYPE;
$2e6a54a800d2117a$export$ffb0004e005737fa = $2e6a54a800d2117a$var$REACT_FRAGMENT_TYPE;
$2e6a54a800d2117a$export$b624eff549462981 = $2e6a54a800d2117a$var$REACT_LAZY_TYPE;
$2e6a54a800d2117a$export$7897aa7841a5380c = $2e6a54a800d2117a$var$REACT_MEMO_TYPE;
$2e6a54a800d2117a$export$602eac185826482c = $2e6a54a800d2117a$var$REACT_PORTAL_TYPE;
$2e6a54a800d2117a$export$e2c29f18771995cb = $2e6a54a800d2117a$var$REACT_PROFILER_TYPE;
$2e6a54a800d2117a$export$5f8d39834fd61797 = $2e6a54a800d2117a$var$REACT_STRICT_MODE_TYPE;
$2e6a54a800d2117a$export$74bf444e3cd11ea5 = $2e6a54a800d2117a$var$REACT_SUSPENSE_TYPE;
$2e6a54a800d2117a$export$998bcd577473dd93 = $2e6a54a800d2117a$var$REACT_SUSPENSE_LIST_TYPE;
$2e6a54a800d2117a$export$b706b080d889d2c9 = function(object) {
    return $2e6a54a800d2117a$var$typeOf(object) === $2e6a54a800d2117a$var$REACT_CONSUMER_TYPE;
};
$2e6a54a800d2117a$export$5be5a87408f70ddc = function(object) {
    return $2e6a54a800d2117a$var$typeOf(object) === $2e6a54a800d2117a$var$REACT_CONTEXT_TYPE;
};
$2e6a54a800d2117a$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $2e6a54a800d2117a$var$REACT_ELEMENT_TYPE;
};
$2e6a54a800d2117a$export$455c2e768291efa6 = function(object) {
    return $2e6a54a800d2117a$var$typeOf(object) === $2e6a54a800d2117a$var$REACT_FORWARD_REF_TYPE;
};
$2e6a54a800d2117a$export$9522e17588c12572 = function(object) {
    return $2e6a54a800d2117a$var$typeOf(object) === $2e6a54a800d2117a$var$REACT_FRAGMENT_TYPE;
};
$2e6a54a800d2117a$export$2110ac352bb060b9 = function(object) {
    return $2e6a54a800d2117a$var$typeOf(object) === $2e6a54a800d2117a$var$REACT_LAZY_TYPE;
};
$2e6a54a800d2117a$export$56885ab8b9c456ab = function(object) {
    return $2e6a54a800d2117a$var$typeOf(object) === $2e6a54a800d2117a$var$REACT_MEMO_TYPE;
};
$2e6a54a800d2117a$export$d927fcb6adf8f9de = function(object) {
    return $2e6a54a800d2117a$var$typeOf(object) === $2e6a54a800d2117a$var$REACT_PORTAL_TYPE;
};
$2e6a54a800d2117a$export$b82d16f27459e05a = function(object) {
    return $2e6a54a800d2117a$var$typeOf(object) === $2e6a54a800d2117a$var$REACT_PROFILER_TYPE;
};
$2e6a54a800d2117a$export$522c17b4f5e123e8 = function(object) {
    return $2e6a54a800d2117a$var$typeOf(object) === $2e6a54a800d2117a$var$REACT_STRICT_MODE_TYPE;
};
$2e6a54a800d2117a$export$1aabd8a0274ecfd6 = function(object) {
    return $2e6a54a800d2117a$var$typeOf(object) === $2e6a54a800d2117a$var$REACT_SUSPENSE_TYPE;
};
$2e6a54a800d2117a$export$3d6c20d97e46b957 = function(object) {
    return $2e6a54a800d2117a$var$typeOf(object) === $2e6a54a800d2117a$var$REACT_SUSPENSE_LIST_TYPE;
};
$2e6a54a800d2117a$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $2e6a54a800d2117a$var$REACT_FRAGMENT_TYPE || type === $2e6a54a800d2117a$var$REACT_PROFILER_TYPE || type === $2e6a54a800d2117a$var$REACT_STRICT_MODE_TYPE || type === $2e6a54a800d2117a$var$REACT_SUSPENSE_TYPE || type === $2e6a54a800d2117a$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $2e6a54a800d2117a$var$REACT_LAZY_TYPE || type.$$typeof === $2e6a54a800d2117a$var$REACT_MEMO_TYPE || type.$$typeof === $2e6a54a800d2117a$var$REACT_CONTEXT_TYPE || type.$$typeof === $2e6a54a800d2117a$var$REACT_CONSUMER_TYPE || type.$$typeof === $2e6a54a800d2117a$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $2e6a54a800d2117a$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$2e6a54a800d2117a$export$f5bbd400c2f4426f = $2e6a54a800d2117a$var$typeOf;

});

parcelRegister("gNaVO", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $c399b3afb19c5543$export$306c0aa65ff9ec16; }, function (v) { return $c399b3afb19c5543$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c399b3afb19c5543$export$306c0aa65ff9ec16;
"use strict";

var $lCzvA = parcelRequire("lCzvA");
function $c399b3afb19c5543$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c399b3afb19c5543$var$objectIs = "function" === typeof Object.is ? Object.is : $c399b3afb19c5543$var$is, $c399b3afb19c5543$var$useState = $lCzvA.useState, $c399b3afb19c5543$var$useEffect = $lCzvA.useEffect, $c399b3afb19c5543$var$useLayoutEffect = $lCzvA.useLayoutEffect, $c399b3afb19c5543$var$useDebugValue = $lCzvA.useDebugValue;
function $c399b3afb19c5543$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c399b3afb19c5543$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c399b3afb19c5543$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c399b3afb19c5543$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c399b3afb19c5543$var$useEffect(function() {
        $c399b3afb19c5543$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c399b3afb19c5543$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c399b3afb19c5543$var$useDebugValue(value);
    return value;
}
function $c399b3afb19c5543$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c399b3afb19c5543$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c399b3afb19c5543$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c399b3afb19c5543$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c399b3afb19c5543$var$useSyncExternalStore$1 : $c399b3afb19c5543$var$useSyncExternalStore$2;
$c399b3afb19c5543$export$306c0aa65ff9ec16 = void 0 !== $lCzvA.useSyncExternalStore ? $lCzvA.useSyncExternalStore : $c399b3afb19c5543$var$shim;

});

var $1e1ba35c5b9fc4c3$exports = {};
'use strict';

$1e1ba35c5b9fc4c3$exports = (parcelRequire("9fhap"));


var $2aa82faa573d5f31$exports = {};
'use strict';
function $2aa82faa573d5f31$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2aa82faa573d5f31$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2aa82faa573d5f31$var$checkDCE();

$2aa82faa573d5f31$exports = (parcelRequire("1zEgY"));




/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $9b648ee8ee511cda$exports = {};
function $9b648ee8ee511cda$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $9b648ee8ee511cda$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $9b648ee8ee511cda$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $9b648ee8ee511cda$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
$9b648ee8ee511cda$exports = $9b648ee8ee511cda$var$_asyncToGenerator, $9b648ee8ee511cda$exports.__esModule = true, $9b648ee8ee511cda$exports["default"] = $9b648ee8ee511cda$exports;


var $a40c7345b1900589$exports = {};
var $717b5174247e0002$exports = {};
function $717b5174247e0002$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$717b5174247e0002$exports = $717b5174247e0002$var$_arrayWithHoles, $717b5174247e0002$exports.__esModule = true, $717b5174247e0002$exports["default"] = $717b5174247e0002$exports;


var $487c53deb44cf9d9$exports = {};
function $487c53deb44cf9d9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$487c53deb44cf9d9$exports = $487c53deb44cf9d9$var$_iterableToArrayLimit, $487c53deb44cf9d9$exports.__esModule = true, $487c53deb44cf9d9$exports["default"] = $487c53deb44cf9d9$exports;


var $037e4cdf4e37636e$exports = {};
var $46d7d3a33877ea91$exports = {};
function $46d7d3a33877ea91$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$46d7d3a33877ea91$exports = $46d7d3a33877ea91$var$_arrayLikeToArray, $46d7d3a33877ea91$exports.__esModule = true, $46d7d3a33877ea91$exports["default"] = $46d7d3a33877ea91$exports;


function $037e4cdf4e37636e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $46d7d3a33877ea91$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $46d7d3a33877ea91$exports(r, a) : void 0;
    }
}
$037e4cdf4e37636e$exports = $037e4cdf4e37636e$var$_unsupportedIterableToArray, $037e4cdf4e37636e$exports.__esModule = true, $037e4cdf4e37636e$exports["default"] = $037e4cdf4e37636e$exports;


var $f00965904d21c4f5$exports = {};
function $f00965904d21c4f5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$f00965904d21c4f5$exports = $f00965904d21c4f5$var$_nonIterableRest, $f00965904d21c4f5$exports.__esModule = true, $f00965904d21c4f5$exports["default"] = $f00965904d21c4f5$exports;


function $a40c7345b1900589$var$_slicedToArray(r, e) {
    return $717b5174247e0002$exports(r) || $487c53deb44cf9d9$exports(r, e) || $037e4cdf4e37636e$exports(r, e) || $f00965904d21c4f5$exports();
}
$a40c7345b1900589$exports = $a40c7345b1900589$var$_slicedToArray, $a40c7345b1900589$exports.__esModule = true, $a40c7345b1900589$exports["default"] = $a40c7345b1900589$exports;


var $a0061d920c204c4d$exports = {};
// TODO(Babel 8): Remove this file.

var $a0061d920c204c4d$var$runtime = (parcelRequire("8XozM"))();
$a0061d920c204c4d$exports = $a0061d920c204c4d$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $a0061d920c204c4d$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a0061d920c204c4d$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a0061d920c204c4d$var$runtime);
}



var $lCzvA = parcelRequire("lCzvA");
var $dbbfea4bd9ff1bad$exports = {};
/*! For license information please see default.js.LICENSE.txt */ var $375d8335527bcde6$exports = {};
// shim for using process in browser
var $375d8335527bcde6$var$process = $375d8335527bcde6$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $375d8335527bcde6$var$cachedSetTimeout;
var $375d8335527bcde6$var$cachedClearTimeout;
function $375d8335527bcde6$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $375d8335527bcde6$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $375d8335527bcde6$var$cachedSetTimeout = setTimeout;
        else $375d8335527bcde6$var$cachedSetTimeout = $375d8335527bcde6$var$defaultSetTimout;
    } catch (e) {
        $375d8335527bcde6$var$cachedSetTimeout = $375d8335527bcde6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $375d8335527bcde6$var$cachedClearTimeout = clearTimeout;
        else $375d8335527bcde6$var$cachedClearTimeout = $375d8335527bcde6$var$defaultClearTimeout;
    } catch (e) {
        $375d8335527bcde6$var$cachedClearTimeout = $375d8335527bcde6$var$defaultClearTimeout;
    }
})();
function $375d8335527bcde6$var$runTimeout(fun) {
    if ($375d8335527bcde6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($375d8335527bcde6$var$cachedSetTimeout === $375d8335527bcde6$var$defaultSetTimout || !$375d8335527bcde6$var$cachedSetTimeout) && setTimeout) {
        $375d8335527bcde6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $375d8335527bcde6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $375d8335527bcde6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $375d8335527bcde6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $375d8335527bcde6$var$runClearTimeout(marker) {
    if ($375d8335527bcde6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($375d8335527bcde6$var$cachedClearTimeout === $375d8335527bcde6$var$defaultClearTimeout || !$375d8335527bcde6$var$cachedClearTimeout) && clearTimeout) {
        $375d8335527bcde6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $375d8335527bcde6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $375d8335527bcde6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $375d8335527bcde6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $375d8335527bcde6$var$queue = [];
var $375d8335527bcde6$var$draining = false;
var $375d8335527bcde6$var$currentQueue;
var $375d8335527bcde6$var$queueIndex = -1;
function $375d8335527bcde6$var$cleanUpNextTick() {
    if (!$375d8335527bcde6$var$draining || !$375d8335527bcde6$var$currentQueue) return;
    $375d8335527bcde6$var$draining = false;
    if ($375d8335527bcde6$var$currentQueue.length) $375d8335527bcde6$var$queue = $375d8335527bcde6$var$currentQueue.concat($375d8335527bcde6$var$queue);
    else $375d8335527bcde6$var$queueIndex = -1;
    if ($375d8335527bcde6$var$queue.length) $375d8335527bcde6$var$drainQueue();
}
function $375d8335527bcde6$var$drainQueue() {
    if ($375d8335527bcde6$var$draining) return;
    var timeout = $375d8335527bcde6$var$runTimeout($375d8335527bcde6$var$cleanUpNextTick);
    $375d8335527bcde6$var$draining = true;
    var len = $375d8335527bcde6$var$queue.length;
    while(len){
        $375d8335527bcde6$var$currentQueue = $375d8335527bcde6$var$queue;
        $375d8335527bcde6$var$queue = [];
        while(++$375d8335527bcde6$var$queueIndex < len)if ($375d8335527bcde6$var$currentQueue) $375d8335527bcde6$var$currentQueue[$375d8335527bcde6$var$queueIndex].run();
        $375d8335527bcde6$var$queueIndex = -1;
        len = $375d8335527bcde6$var$queue.length;
    }
    $375d8335527bcde6$var$currentQueue = null;
    $375d8335527bcde6$var$draining = false;
    $375d8335527bcde6$var$runClearTimeout(timeout);
}
$375d8335527bcde6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $375d8335527bcde6$var$queue.push(new $375d8335527bcde6$var$Item(fun, args));
    if ($375d8335527bcde6$var$queue.length === 1 && !$375d8335527bcde6$var$draining) $375d8335527bcde6$var$runTimeout($375d8335527bcde6$var$drainQueue);
};
// v8 likes predictible objects
function $375d8335527bcde6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$375d8335527bcde6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$375d8335527bcde6$var$process.title = 'browser';
$375d8335527bcde6$var$process.browser = true;
$375d8335527bcde6$var$process.env = {};
$375d8335527bcde6$var$process.argv = [];
$375d8335527bcde6$var$process.version = ''; // empty string to avoid regexp issues
$375d8335527bcde6$var$process.versions = {};
function $375d8335527bcde6$var$noop() {}
$375d8335527bcde6$var$process.on = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.addListener = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.once = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.off = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.removeListener = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.removeAllListeners = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.emit = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.prependListener = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.prependOnceListener = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.listeners = function(name) {
    return [];
};
$375d8335527bcde6$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$375d8335527bcde6$var$process.cwd = function() {
    return '/';
};
$375d8335527bcde6$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$375d8335527bcde6$var$process.umask = function() {
    return 0;
};


!function(e1, t) {
    $dbbfea4bd9ff1bad$exports = t();
}(self, function() {
    return function() {
        var e1 = {
            9748: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return Z;
                    }
                });
                var r = n(5385), o = n(9123), i = n(1971);
                function a(e1, t) {
                    var n = {};
                    return Object.assign(n, t), !n.stateToken && e1.stateToken && (n.stateToken = e1.stateToken), n;
                }
                function u(e1, t) {
                    return t = a(e1, t), (0, r.v_)(e1, e1.getIssuerOrigin() + "/api/v1/authn", t, {
                        withCredentials: !0
                    });
                }
                function c(e1) {
                    return !!f(e1);
                }
                function s(e1, t, n, o, i) {
                    return i = Object.assign({
                        withCredentials: !0
                    }, i), (0, r.v_)(e1, n, o, i).then(function(e1) {
                        return t.createTransaction(e1);
                    });
                }
                function f(e1) {
                    return e1.options.storageUtil.storage.get(i.STATE_TOKEN_KEY_NAME);
                }
                var l = n(3144), p = n(5671), d = n(4942), h = n(3193), v = n(4771), y = n(6718);
                function g(e1, t, n, i, u, c) {
                    if (Array.isArray(u)) return function(r, a) {
                        if (!r) throw new o.Z("Must provide a link name");
                        var s = (0, h.sE)(u, {
                            name: r
                        });
                        if (!s) throw new o.Z("No link found for that name");
                        return g(e1, t, n, i, s, c)(a);
                    };
                    if (u.hints && u.hints.allow && 1 === u.hints.allow.length) switch(u.hints.allow[0]){
                        case "GET":
                            return function() {
                                return (0, r.U2)(e1, u.href, {
                                    withCredentials: !0
                                });
                            };
                        case "POST":
                            return function(r) {
                                c && c.isPolling && (c.isPolling = !1);
                                var f = a(n, r);
                                "MFA_ENROLL" !== n.status && "FACTOR_ENROLL" !== n.status || Object.assign(f, {
                                    factorType: i.factorType,
                                    provider: i.provider
                                });
                                var l = {}, p = f.autoPush;
                                if (void 0 !== p) {
                                    if ("function" == typeof p) try {
                                        l.autoPush = !!p();
                                    } catch (e1) {
                                        return Promise.reject(new o.Z("AutoPush resulted in an error."));
                                    }
                                    else null !== p && (l.autoPush = !!p);
                                    f = (0, h.CE)(f, "autoPush");
                                }
                                var d = f.rememberDevice;
                                if (void 0 !== d) {
                                    if ("function" == typeof d) try {
                                        l.rememberDevice = !!d();
                                    } catch (e1) {
                                        return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                                    }
                                    else null !== d && (l.rememberDevice = !!d);
                                    f = (0, h.CE)(f, "rememberDevice");
                                } else f.profile && void 0 !== f.profile.updatePhone && (f.profile.updatePhone && (l.updatePhone = !0), f.profile = (0, h.CE)(f.profile, "updatePhone"));
                                var v = u.href + (0, y.UK)(l);
                                return s(e1, t, v, f);
                            };
                    }
                }
                var m = n(8750), b = n(6573);
                function k(e1, t, n) {
                    return function(u) {
                        var c, s, f, l;
                        (0, v.hj)(u) ? c = u : (0, v.Kn)(u) && (c = u.delay, s = u.rememberDevice, f = u.autoPush, l = u.transactionCallBack), c || 0 === c || (c = i.DEFAULT_POLLING_DELAY);
                        var p = (0, h.Rg)(t, "next", "poll");
                        n.isPolling = !0;
                        var d = 0;
                        return (function i() {
                            return n.isPolling ? (function() {
                                var n = {};
                                if ("function" == typeof f) try {
                                    n.autoPush = !!f();
                                } catch (e1) {
                                    return Promise.reject(new o.Z("AutoPush resulted in an error."));
                                }
                                else null != f && (n.autoPush = !!f);
                                if ("function" == typeof s) try {
                                    n.rememberDevice = !!s();
                                } catch (e1) {
                                    return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                                }
                                else null != s && (n.rememberDevice = !!s);
                                var i = p.href + (0, y.UK)(n);
                                return (0, r.v_)(e1, i, function(e1) {
                                    return a(e1);
                                }(t), {
                                    saveAuthnState: !1,
                                    withCredentials: !0,
                                    pollingIntent: !0
                                });
                            })().then(function(t) {
                                if (d = 0, t.factorResult && "WAITING" === t.factorResult) {
                                    if (!n.isPolling) throw new b.Z;
                                    return "function" == typeof l && l(t), (0, m.gw)(c).then(i);
                                }
                                return n.isPolling = !1, e1.tx.createTransaction(t);
                            }).catch(function(e1) {
                                if (e1.xhr && (0 === e1.xhr.status || 429 === e1.xhr.status) && d <= 4) {
                                    var t = 1e3 * Math.pow(2, d);
                                    return d++, (0, m.gw)(t).then(i);
                                }
                                throw e1;
                            }) : Promise.reject(new b.Z);
                        })().catch(function(e1) {
                            throw n.isPolling = !1, e1;
                        });
                    };
                }
                function w(e1, t, n, r, o) {
                    if (r = r || n, r = (0, h.d9)(r), Array.isArray(r)) {
                        for(var i = [], a = 0, u = r.length; a < u; a++)i.push(w(e1, t, n, r[a], o));
                        return i;
                    }
                    var c = r._embedded || {};
                    for(var s in c)Object.prototype.hasOwnProperty.call(c, s) && ((0, v.Kn)(c[s]) || Array.isArray(c[s])) && (c[s] = w(e1, t, n, c[s], o));
                    var f = function(e1, t, n, r, o) {
                        var i = {};
                        for(var a in r._links)if (Object.prototype.hasOwnProperty.call(r._links, a)) {
                            var u = r._links[a];
                            if ("next" === a && (a = u.name), u.type) i[a] = u;
                            else if ("poll" === a) i.poll = k(e1, n, o);
                            else {
                                var c = g(e1, t, n, r, u, o);
                                c && (i[a] = c);
                            }
                        }
                        return i;
                    }(e1, t, n, r, o);
                    return Object.assign(c, f), r = (0, h.CE)(r, "_embedded", "_links"), Object.assign(r, c), r;
                }
                var O = (0, l.Z)(function e1(t, n) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    (0, p.Z)(this, e1), (0, d.Z)(this, "next", void 0), (0, d.Z)(this, "cancel", void 0), (0, d.Z)(this, "skip", void 0), (0, d.Z)(this, "unlock", void 0), (0, d.Z)(this, "changePassword", void 0), (0, d.Z)(this, "resetPassword", void 0), (0, d.Z)(this, "answer", void 0), (0, d.Z)(this, "recovery", void 0), (0, d.Z)(this, "verify", void 0), (0, d.Z)(this, "resend", void 0), (0, d.Z)(this, "activate", void 0), (0, d.Z)(this, "poll", void 0), (0, d.Z)(this, "prev", void 0), (0, d.Z)(this, "data", void 0), (0, d.Z)(this, "stateToken", void 0), (0, d.Z)(this, "sessionToken", void 0), (0, d.Z)(this, "status", void 0), (0, d.Z)(this, "user", void 0), (0, d.Z)(this, "factor", void 0), (0, d.Z)(this, "factors", void 0), (0, d.Z)(this, "policy", void 0), (0, d.Z)(this, "scopes", void 0), (0, d.Z)(this, "target", void 0), (0, d.Z)(this, "authentication", void 0), this.data = void 0, this.status = void 0, r && (this.data = r, Object.assign(this, w(t, n, r, r, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== r.status || r._links || (this.cancel = function() {
                        return Promise.resolve(n.createTransaction());
                    }));
                });
                function Z(e1) {
                    var t = {
                        status: u.bind(null, e1),
                        resume: function(n) {
                            return function(e1, t, n) {
                                if (!n || !n.stateToken) {
                                    var r = f(e1);
                                    if (!r) return Promise.reject(new o.Z("No transaction to resume"));
                                    n = {
                                        stateToken: r
                                    };
                                }
                                return u(e1, n).then(function(e1) {
                                    return t.createTransaction(e1);
                                });
                            }(e1, t, n);
                        },
                        exists: c.bind(null, e1),
                        introspect: function(n) {
                            return function(e1, t, n) {
                                if (!n || !n.stateToken) {
                                    var i = f(e1);
                                    if (!i) return Promise.reject(new o.Z("No transaction to evaluate"));
                                    n = {
                                        stateToken: i
                                    };
                                }
                                return (function(e1, t) {
                                    return t = a(e1, t), (0, r.v_)(e1, e1.getIssuerOrigin() + "/api/v1/authn/introspect", t, {
                                        withCredentials: !0
                                    });
                                })(e1, n).then(function(e1) {
                                    return t.createTransaction(e1);
                                });
                            }(e1, t, n);
                        },
                        createTransaction: function(n) {
                            return new O(e1, t, n);
                        },
                        postToTransaction: function(n, r, o) {
                            return s(e1, t, n, r, o);
                        }
                    };
                    return t;
                }
            },
            3398: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return r.b;
                    },
                    t: function() {
                        return o.t;
                    }
                });
                var r = n(9748), o = n(3164);
            },
            3164: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    t: function() {
                        return m;
                    }
                });
                var r = n(4925), o = n(5861), i = n(5671), a = n(3144), u = n(7326), c = n(136), s = n(2963), f = n(1120), l = n(4942), p = n(4687), d = n.n(p), h = n(3193), v = n(8719), y = n(9748), g = [
                    "multiOptionalFactorEnroll"
                ];
                function m(e1) {
                    return function(e1) {
                        (0, c.Z)(k, e1);
                        var t, n, p, m, b = (p = k, m = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, f.Z)(p);
                            if (m) {
                                var n = (0, f.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, s.Z)(this, e1);
                        });
                        function k() {
                            var e1;
                            (0, i.Z)(this, k);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = b.call.apply(b, [
                                this
                            ].concat(n)), (0, l.Z)((0, u.Z)(e1), "tx", void 0), (0, l.Z)((0, u.Z)(e1), "authn", void 0), (0, l.Z)((0, u.Z)(e1), "fingerprint", void 0), e1.authn = e1.tx = (0, y.b)((0, u.Z)(e1)), e1.fingerprint = v.Z.bind(null, (0, u.Z)(e1)), e1;
                        }
                        return (0, a.Z)(k, [
                            {
                                key: "signIn",
                                value: (n = (0, o.Z)(d().mark(function e1(t) {
                                    var n, r = this;
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = (0, h.d9)(t || {}), n = function(e1) {
                                                    return delete t.sendFingerprint, r.tx.postToTransaction("/api/v1/authn", t, e1);
                                                }, t.sendFingerprint) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return", n());
                                            case 4:
                                                return e1.abrupt("return", this.fingerprint().then(function(e1) {
                                                    return n({
                                                        headers: {
                                                            "X-Device-Fingerprint": e1
                                                        }
                                                    });
                                                }));
                                            case 5:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "signInWithCredentials",
                                value: (t = (0, o.Z)(d().mark(function e1(t) {
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.abrupt("return", this.signIn(t));
                                            case 1:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return t.apply(this, arguments);
                                })
                            },
                            {
                                key: "forgotPassword",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/password", e1);
                                }
                            },
                            {
                                key: "unlockAccount",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/unlock", e1);
                                }
                            },
                            {
                                key: "verifyRecoveryToken",
                                value: function(e1) {
                                    var t = e1.multiOptionalFactorEnroll, n = (0, r.Z)(e1, g);
                                    return t && (n.options = {
                                        multiOptionalFactorEnroll: t
                                    }), this.tx.postToTransaction("/api/v1/authn/recovery/token", n);
                                }
                            }
                        ]), k;
                    }(e1);
                }
            },
            9893: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942), a = n(3193), u = n(415), c = n(1971), s = n(4279), f = n.n(s);
                function l(e1) {
                    var t = (0, r.Z)(function t() {
                        (0, o.Z)(this, t), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "emitter", void 0), (0, i.Z)(this, "features", void 0);
                        var n = new e1(arguments.length && (arguments.length <= 0 ? void 0 : arguments[0]) || {});
                        this.options = (0, a.YY)(n), this.emitter = new (f()), this.features = u;
                    });
                    return (0, i.Z)(t, "features", u), (0, i.Z)(t, "constants", c), t.features = t.prototype.features = u, Object.assign(t, {
                        constants: c
                    }), t;
                }
            },
            3306: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return o.X;
                    },
                    a: function() {
                        return r.a;
                    }
                });
                var r = n(9893), o = n(5093);
            },
            5093: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return a;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942);
                function a() {
                    return (0, r.Z)(function e1(t) {
                        (0, o.Z)(this, e1), (0, i.Z)(this, "devMode", void 0), this.devMode = !!t.devMode;
                    });
                }
            },
            4858: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = arguments[t];
                        for(var r in n)e1[r] = n[r];
                    }
                    return e1;
                }
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var o = function e1(t, n) {
                    function o(e1, o, i) {
                        if ("undefined" != typeof document) {
                            "number" == typeof (i = r({}, n, i)).expires && (i.expires = new Date(Date.now() + 864e5 * i.expires)), i.expires && (i.expires = i.expires.toUTCString()), e1 = encodeURIComponent(e1).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
                            var a = "";
                            for(var u in i)i[u] && (a += "; " + u, !0 !== i[u] && (a += "=" + i[u].split(";")[0]));
                            return document.cookie = e1 + "=" + t.write(o, e1) + a;
                        }
                    }
                    return Object.create({
                        set: o,
                        get: function(e1) {
                            if ("undefined" != typeof document && (!arguments.length || e1)) {
                                for(var n = document.cookie ? document.cookie.split("; ") : [], r = {}, o = 0; o < n.length; o++){
                                    var i = n[o].split("="), a = i.slice(1).join("=");
                                    try {
                                        var u = decodeURIComponent(i[0]);
                                        if (r[u] = t.read(a, u), e1 === u) break;
                                    } catch (e1) {}
                                }
                                return e1 ? r[e1] : r;
                            }
                        },
                        remove: function(e1, t) {
                            o(e1, "", r({}, t, {
                                expires: -1
                            }));
                        },
                        withAttributes: function(t) {
                            return e1(this.converter, r({}, this.attributes, t));
                        },
                        withConverter: function(t) {
                            return e1(r({}, this.converter, t), this.attributes);
                        }
                    }, {
                        attributes: {
                            value: Object.freeze(n)
                        },
                        converter: {
                            value: Object.freeze(t)
                        }
                    });
                }({
                    read: function(e1) {
                        return '"' === e1[0] && (e1 = e1.slice(1, -1)), e1.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
                    },
                    write: function(e1) {
                        return encodeURIComponent(e1).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
                    }
                }, {
                    path: "/"
                }), i = o, a = n(9123), u = n(146), c = n(415), s = {
                    browserHasLocalStorage: function() {
                        try {
                            var e1 = this.getLocalStorage();
                            return this.testStorage(e1);
                        } catch (e1) {
                            return !1;
                        }
                    },
                    browserHasSessionStorage: function() {
                        try {
                            var e1 = this.getSessionStorage();
                            return this.testStorage(e1);
                        } catch (e1) {
                            return !1;
                        }
                    },
                    testStorageType: function(e1) {
                        var t = !1;
                        switch(e1){
                            case "sessionStorage":
                                t = this.browserHasSessionStorage();
                                break;
                            case "localStorage":
                                t = this.browserHasLocalStorage();
                                break;
                            case "cookie":
                            case "memory":
                                t = !0;
                                break;
                            default:
                                t = !1;
                        }
                        return t;
                    },
                    getStorageByType: function(e1, t) {
                        var n;
                        switch(e1){
                            case "sessionStorage":
                                n = this.getSessionStorage();
                                break;
                            case "localStorage":
                                n = this.getLocalStorage();
                                break;
                            case "cookie":
                                n = this.getCookieStorage(t);
                                break;
                            case "memory":
                                n = this.getInMemoryStorage();
                                break;
                            default:
                                throw new a.Z("Unrecognized storage option: ".concat(e1));
                        }
                        return n;
                    },
                    findStorageType: function(e1) {
                        var t, n;
                        return t = (e1 = e1.slice()).shift(), (n = e1.length ? e1[0] : null) ? this.testStorageType(t) ? t : ((0, u.ZK)("This browser doesn't support ".concat(t, ". Switching to ").concat(n, ".")), this.findStorageType(e1)) : t;
                    },
                    getLocalStorage: function() {
                        return (0, c.isIE11OrLess)() && !window.onstorage && (window.onstorage = function() {}), localStorage;
                    },
                    getSessionStorage: function() {
                        return sessionStorage;
                    },
                    getCookieStorage: function(e1) {
                        var t = this, n = e1.secure, r = e1.sameSite, o = e1.sessionCookie;
                        if (void 0 === n || void 0 === r) throw new a.Z('getCookieStorage: "secure" and "sameSite" options must be provided');
                        var i = {
                            getItem: this.storage.get,
                            setItem: function(e1, i) {
                                var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "2200-01-01T00:00:00.000Z";
                                a = o ? null : a, t.storage.set(e1, i, a, {
                                    secure: n,
                                    sameSite: r
                                });
                            },
                            removeItem: function(e1) {
                                t.storage.delete(e1);
                            }
                        };
                        return e1.useSeparateCookies ? {
                            getItem: function(e1) {
                                var t = i.getItem(), n = {};
                                return Object.keys(t).forEach(function(r) {
                                    0 === r.indexOf(e1) && (n[r.replace("".concat(e1, "_"), "")] = JSON.parse(t[r]));
                                }), JSON.stringify(n);
                            },
                            setItem: function(e1, t) {
                                var n = JSON.parse(this.getItem(e1));
                                t = JSON.parse(t), Object.keys(t).forEach(function(r) {
                                    var o = e1 + "_" + r, a = JSON.stringify(t[r]);
                                    i.setItem(o, a), delete n[r];
                                }), Object.keys(n).forEach(function(t) {
                                    i.removeItem(e1 + "_" + t);
                                });
                            },
                            removeItem: function(e1) {
                                var t = JSON.parse(this.getItem(e1));
                                Object.keys(t).forEach(function(t) {
                                    i.removeItem(e1 + "_" + t);
                                });
                            }
                        } : i;
                    },
                    inMemoryStore: {},
                    getInMemoryStorage: function() {
                        var e1 = this;
                        return {
                            getItem: function(t) {
                                return e1.inMemoryStore[t];
                            },
                            setItem: function(t, n) {
                                e1.inMemoryStore[t] = n;
                            }
                        };
                    },
                    testStorage: function(e1) {
                        var t = "okta-test-storage";
                        try {
                            return e1.setItem(t, t), e1.removeItem(t), !0;
                        } catch (e1) {
                            return !1;
                        }
                    },
                    storage: {
                        set: function(e1, t, n, r) {
                            var o = r.sameSite, u = r.secure;
                            if (void 0 === u || void 0 === o) throw new a.Z('storage.set: "secure" and "sameSite" options must be provided');
                            var c = {
                                path: r.path || "/",
                                secure: u,
                                sameSite: o
                            };
                            return Date.parse(n) && (c.expires = new Date(n)), i.set(e1, t, c), this.get(e1);
                        },
                        get: function(e1) {
                            return arguments.length ? i.get(e1) : i.get();
                        },
                        delete: function(e1) {
                            return i.remove(e1, {
                                path: "/"
                            });
                        }
                    }
                }, f = s;
            },
            8719: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return u;
                    }
                });
                var r = n(9123), o = n(415), i = n(4970), a = function(e1, t) {
                    return t.source === e1.contentWindow;
                };
                function u(e1, t) {
                    var n;
                    if (!(0, o.isFingerprintSupported)()) return Promise.reject(new r.Z("Fingerprinting is not supported on this device"));
                    var u, c, s, f = null !== (n = null == t ? void 0 : t.container) && void 0 !== n ? n : document.body;
                    return new Promise(function(n, o) {
                        (c = document.createElement("iframe")).style.display = "none", s = function(t) {
                            if (a(c, t) && t && t.data && t.origin === e1.getIssuerOrigin()) {
                                var i, u, s;
                                try {
                                    i = JSON.parse(t.data);
                                } catch (e1) {
                                    return;
                                }
                                if (i) return "FingerprintAvailable" === i.type ? n(i.fingerprint) : "FingerprintServiceReady" !== i.type ? o(new r.Z("No data")) : void (null === (u = c) || void 0 === u || null === (s = u.contentWindow) || void 0 === s || s.postMessage(JSON.stringify({
                                    type: "GetFingerprint"
                                }), t.origin));
                            }
                        }, (0, i.NH)(window, "message", s), c.src = e1.getIssuerOrigin() + "/auth/services/devicefingerprint", f.appendChild(c), u = setTimeout(function() {
                            o(new r.Z("Fingerprinting timed out"));
                        }, (null == t ? void 0 : t.timeout) || 15e3);
                    }).finally(function() {
                        var e1;
                        clearTimeout(u), (0, i.ys)(window, "message", s), f.contains(c) && (null === (e1 = c.parentElement) || void 0 === e1 || e1.removeChild(c));
                    });
                }
            },
            1971: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    ACCESS_TOKEN_STORAGE_KEY: function() {
                        return v;
                    },
                    CACHE_STORAGE_NAME: function() {
                        return s;
                    },
                    DEFAULT_CACHE_DURATION: function() {
                        return u;
                    },
                    DEFAULT_CODE_CHALLENGE_METHOD: function() {
                        return w;
                    },
                    DEFAULT_MAX_CLOCK_SKEW: function() {
                        return a;
                    },
                    DEFAULT_POLLING_DELAY: function() {
                        return o;
                    },
                    IDX_API_VERSION: function() {
                        return O;
                    },
                    IDX_RESPONSE_STORAGE_NAME: function() {
                        return h;
                    },
                    ID_TOKEN_STORAGE_KEY: function() {
                        return y;
                    },
                    IOS_MAX_RETRY_COUNT: function() {
                        return i;
                    },
                    MAX_VERIFIER_LENGTH: function() {
                        return k;
                    },
                    MIN_VERIFIER_LENGTH: function() {
                        return b;
                    },
                    ORIGINAL_URI_STORAGE_NAME: function() {
                        return d;
                    },
                    PKCE_STORAGE_NAME: function() {
                        return f;
                    },
                    REFERRER_PATH_STORAGE_KEY: function() {
                        return m;
                    },
                    REFRESH_TOKEN_STORAGE_KEY: function() {
                        return g;
                    },
                    SHARED_TRANSACTION_STORAGE_NAME: function() {
                        return p;
                    },
                    STATE_TOKEN_KEY_NAME: function() {
                        return r;
                    },
                    TOKEN_STORAGE_NAME: function() {
                        return c;
                    },
                    TRANSACTION_STORAGE_NAME: function() {
                        return l;
                    }
                });
                var r = "oktaStateToken", o = 500, i = 3, a = 300, u = 86400, c = "okta-token-storage", s = "okta-cache-storage", f = "okta-pkce-storage", l = "okta-transaction-storage", p = "okta-shared-transaction-storage", d = "okta-original-uri-storage", h = "okta-idx-response-storage", v = "accessToken", y = "idToken", g = "refreshToken", m = "referrerPath", b = 43, k = 128, w = "S256", O = "1.0.0";
            },
            1018: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return k;
                    },
                    a: function() {
                        return g;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(4942), u = n(4687), c = n.n(u), s = n(3615), f = n.n(s), l = n(9123), p = n(7088), d = n(3548), h = n(146);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, a.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var g = null, m = {
                    updateAuthStatePromise: null,
                    canceledTimes: 0
                }, b = "authStateChange", k = function() {
                    function e1(t) {
                        var n = this;
                        if ((0, o.Z)(this, e1), (0, a.Z)(this, "_sdk", void 0), (0, a.Z)(this, "_pending", void 0), (0, a.Z)(this, "_authState", void 0), (0, a.Z)(this, "_prevAuthState", void 0), (0, a.Z)(this, "_logOptions", void 0), (0, a.Z)(this, "_transformQueue", void 0), !t.emitter) throw new l.Z("Emitter should be initialized before AuthStateManager");
                        this._sdk = t, this._pending = y({}, m), this._authState = g, this._logOptions = {}, this._prevAuthState = null, this._transformQueue = new d.b({
                            quiet: !0
                        }), t.tokenManager.on(p.O3, function(e1, t) {
                            n._setLogOptions({
                                event: p.O3,
                                key: e1,
                                token: t
                            }), n.updateAuthState();
                        }), t.tokenManager.on(p.FT, function(e1, t) {
                            n._setLogOptions({
                                event: p.FT,
                                key: e1,
                                token: t
                            }), n.updateAuthState();
                        });
                    }
                    var t;
                    return (0, i.Z)(e1, [
                        {
                            key: "_setLogOptions",
                            value: function(e1) {
                                this._logOptions = e1;
                            }
                        },
                        {
                            key: "getAuthState",
                            value: function() {
                                return this._authState;
                            }
                        },
                        {
                            key: "getPreviousAuthState",
                            value: function() {
                                return this._prevAuthState;
                            }
                        },
                        {
                            key: "updateAuthState",
                            value: (t = (0, r.Z)(c().mark(function e1() {
                                var t, n, r, o, i, a, u, s = this;
                                return c().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (t = this._sdk.options, n = t.transformAuthState, r = t.devMode, o = function(e1) {
                                                var t = s._logOptions, n = t.event, r = t.key, o = t.token;
                                                (0, h.dr)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n, " Status:").concat(e1)), (0, h.dr)().log(r, o), (0, h.dr)().log("Current authState", s._authState), (0, h.dr)().groupEnd(), s._logOptions = {};
                                            }, i = function(e1) {
                                                var t, n;
                                                n = e1, (t = s._authState) && t.isAuthenticated === n.isAuthenticated && JSON.stringify(t.idToken) === JSON.stringify(n.idToken) && JSON.stringify(t.accessToken) === JSON.stringify(n.accessToken) && t.error === n.error ? r && o("unchanged") : (s._prevAuthState = s._authState, s._authState = e1, s._sdk.emitter.emit(b, y({}, e1)), r && o("emitted"));
                                            }, a = function e1(t) {
                                                return s._pending.updateAuthStatePromise.then(function() {
                                                    var n = s._pending.updateAuthStatePromise;
                                                    return n && n !== t ? e1(n) : s.getAuthState();
                                                });
                                            }, !this._pending.updateAuthStatePromise) {
                                                e1.next = 11;
                                                break;
                                            }
                                            if (!(this._pending.canceledTimes >= 10)) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return r && o("terminated"), e1.abrupt("return", a(this._pending.updateAuthStatePromise));
                                        case 10:
                                            this._pending.updateAuthStatePromise.cancel();
                                        case 11:
                                            return u = new (f())(function(e1, t, a) {
                                                a.shouldReject = !1, a(function() {
                                                    s._pending.updateAuthStatePromise = null, s._pending.canceledTimes = s._pending.canceledTimes + 1, r && o("canceled");
                                                });
                                                var c = function(t) {
                                                    u.isCanceled ? e1() : (i(t), e1(), s._pending = y({}, m));
                                                };
                                                s._sdk.isAuthenticated().then(function() {
                                                    if (u.isCanceled) e1();
                                                    else {
                                                        var t = s._sdk.tokenManager.getTokensSync(), r = t.accessToken, o = t.idToken, i = t.refreshToken, a = {
                                                            accessToken: r,
                                                            idToken: o,
                                                            refreshToken: i,
                                                            isAuthenticated: !(!r || !o)
                                                        };
                                                        (n ? s._transformQueue.push(n, null, s._sdk, a) : Promise.resolve(a)).then(function(e1) {
                                                            return c(e1);
                                                        }).catch(function(e1) {
                                                            return c({
                                                                accessToken: r,
                                                                idToken: o,
                                                                refreshToken: i,
                                                                isAuthenticated: !1,
                                                                error: e1
                                                            });
                                                        });
                                                    }
                                                });
                                            }), this._pending.updateAuthStatePromise = u, e1.abrupt("return", a(u));
                                        case 14:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "subscribe",
                            value: function(e1) {
                                this._sdk.emitter.on(b, e1);
                            }
                        },
                        {
                            key: "unsubscribe",
                            value: function(e1) {
                                this._sdk.emitter.off(b, e1);
                            }
                        }
                    ]), e1;
                }();
            },
            9046: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return ge;
                    }
                });
                var r = n(885), o = n(2982), i = n(5861), a = n(5671), u = n(3144), c = n(4942), s = n(4687), f = n.n(s);
                Promise.resolve(!1);
                var l = Promise.resolve(!0), p = Promise.resolve();
                function d(e1, t) {
                    return e1 || (e1 = 0), new Promise(function(n) {
                        return setTimeout(function() {
                            return n(t);
                        }, e1);
                    });
                }
                function h() {
                    return Math.random().toString(36).substring(2);
                }
                var v = 0, y = 0;
                function g() {
                    var e1 = (new Date).getTime();
                    return e1 === v ? 1e3 * e1 + ++y : (v = e1, y = 0, 1e3 * e1);
                }
                var m = {
                    create: function(e1) {
                        var t = {
                            messagesCallback: null,
                            bc: new BroadcastChannel(e1),
                            subFns: []
                        };
                        return t.bc.onmessage = function(e1) {
                            t.messagesCallback && t.messagesCallback(e1.data);
                        }, t;
                    },
                    close: function(e1) {
                        e1.bc.close(), e1.subFns = [];
                    },
                    onMessage: function(e1, t) {
                        e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        try {
                            return e1.bc.postMessage(t, !1), p;
                        } catch (e1) {
                            return Promise.reject(e1);
                        }
                    },
                    canBeUsed: function() {
                        if ("undefined" == typeof window && "undefined" == typeof self || "function" != typeof BroadcastChannel) return !1;
                        if (BroadcastChannel._pubkey) throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");
                        return !0;
                    },
                    type: "native",
                    averageResponseTime: function() {
                        return 150;
                    },
                    microSeconds: g
                }, b = function() {
                    function e1(e1) {
                        this.ttl = e1, this.map = new Map, this._to = !1;
                    }
                    return e1.prototype.has = function(e1) {
                        return this.map.has(e1);
                    }, e1.prototype.add = function(e1) {
                        var t = this;
                        this.map.set(e1, k()), this._to || (this._to = !0, setTimeout(function() {
                            t._to = !1, function(e1) {
                                for(var t = k() - e1.ttl, n = e1.map[Symbol.iterator]();;){
                                    var r = n.next().value;
                                    if (!r) return;
                                    var o = r[0];
                                    if (!(r[1] < t)) return;
                                    e1.map.delete(o);
                                }
                            }(t);
                        }, 0));
                    }, e1.prototype.clear = function() {
                        this.map.clear();
                    }, e1;
                }();
                function k() {
                    return (new Date).getTime();
                }
                function w() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = JSON.parse(JSON.stringify(e1));
                    return void 0 === t.webWorkerSupport && (t.webWorkerSupport = !0), t.idb || (t.idb = {}), t.idb.ttl || (t.idb.ttl = 45e3), t.idb.fallbackInterval || (t.idb.fallbackInterval = 150), e1.idb && "function" == typeof e1.idb.onclose && (t.idb.onclose = e1.idb.onclose), t.localstorage || (t.localstorage = {}), t.localstorage.removeTimeout || (t.localstorage.removeTimeout = 6e4), e1.methods && (t.methods = e1.methods), t.node || (t.node = {}), t.node.ttl || (t.node.ttl = 12e4), t.node.maxParallelWrites || (t.node.maxParallelWrites = 2048), void 0 === t.node.useFastPath && (t.node.useFastPath = !0), t;
                }
                var O = "messages", Z = {
                    durability: "relaxed"
                };
                function T() {
                    if ("undefined" != typeof indexedDB) return indexedDB;
                    if ("undefined" != typeof window) {
                        if (void 0 !== window.mozIndexedDB) return window.mozIndexedDB;
                        if (void 0 !== window.webkitIndexedDB) return window.webkitIndexedDB;
                        if (void 0 !== window.msIndexedDB) return window.msIndexedDB;
                    }
                    return !1;
                }
                function E(e1) {
                    e1.commit && e1.commit();
                }
                function P(e1) {
                    e1.closed || S(e1).then(function() {
                        return d(e1.options.idb.fallbackInterval);
                    }).then(function() {
                        return P(e1);
                    });
                }
                function S(e1) {
                    return e1.closed ? p : e1.messagesCallback ? (function(e1, t) {
                        var n = e1.transaction(O, "readonly", Z), r = n.objectStore(O), o = [], i = IDBKeyRange.bound(t + 1, 1 / 0);
                        if (r.getAll) {
                            var a = r.getAll(i);
                            return new Promise(function(e1, t) {
                                a.onerror = function(e1) {
                                    return t(e1);
                                }, a.onsuccess = function(t) {
                                    e1(t.target.result);
                                };
                            });
                        }
                        return new Promise(function(e1, a) {
                            var u = function() {
                                try {
                                    return i = IDBKeyRange.bound(t + 1, 1 / 0), r.openCursor(i);
                                } catch (e1) {
                                    return r.openCursor();
                                }
                            }();
                            u.onerror = function(e1) {
                                return a(e1);
                            }, u.onsuccess = function(r) {
                                var i = r.target.result;
                                i ? i.value.id < t + 1 ? i.continue(t + 1) : (o.push(i.value), i.continue()) : (E(n), e1(o));
                            };
                        });
                    })(e1.db, e1.lastCursorId).then(function(t) {
                        var n = t.filter(function(e1) {
                            return !!e1;
                        }).map(function(t) {
                            return t.id > e1.lastCursorId && (e1.lastCursorId = t.id), t;
                        }).filter(function(t) {
                            return function(e1, t) {
                                return !(e1.uuid === t.uuid || t.eMIs.has(e1.id) || e1.data.time < t.messagesCallbackTime);
                            }(t, e1);
                        }).sort(function(e1, t) {
                            return e1.time - t.time;
                        });
                        return n.forEach(function(t) {
                            e1.messagesCallback && (e1.eMIs.add(t.id), e1.messagesCallback(t.data));
                        }), p;
                    }) : p;
                }
                var x = {
                    create: function(e1, t) {
                        return t = w(t), (function(e1) {
                            var t = "pubkey.broadcast-channel-0-" + e1, n = T().open(t);
                            return n.onupgradeneeded = function(e1) {
                                e1.target.result.createObjectStore(O, {
                                    keyPath: "id",
                                    autoIncrement: !0
                                });
                            }, new Promise(function(e1, t) {
                                n.onerror = function(e1) {
                                    return t(e1);
                                }, n.onsuccess = function() {
                                    e1(n.result);
                                };
                            });
                        })(e1).then(function(n) {
                            var r = {
                                closed: !1,
                                lastCursorId: 0,
                                channelName: e1,
                                options: t,
                                uuid: h(),
                                eMIs: new b(2 * t.idb.ttl),
                                writeBlockPromise: p,
                                messagesCallback: null,
                                readQueuePromises: [],
                                db: n
                            };
                            return n.onclose = function() {
                                r.closed = !0, t.idb.onclose && t.idb.onclose();
                            }, P(r), r;
                        });
                    },
                    close: function(e1) {
                        e1.closed = !0, e1.db.close();
                    },
                    onMessage: function(e1, t, n) {
                        e1.messagesCallbackTime = n, e1.messagesCallback = t, S(e1);
                    },
                    postMessage: function(e1, t) {
                        return e1.writeBlockPromise = e1.writeBlockPromise.then(function() {
                            return function(e1, t, n) {
                                var r = {
                                    uuid: t,
                                    time: (new Date).getTime(),
                                    data: n
                                }, o = e1.transaction([
                                    O
                                ], "readwrite", Z);
                                return new Promise(function(e1, t) {
                                    o.oncomplete = function() {
                                        return e1();
                                    }, o.onerror = function(e1) {
                                        return t(e1);
                                    }, o.objectStore(O).add(r), E(o);
                                });
                            }(e1.db, e1.uuid, t);
                        }).then(function() {
                            0 === Math.floor(11 * Math.random() + 0) && function(e1) {
                                var t, n, r, o, i, a;
                                return (t = e1.db, n = e1.options.idb.ttl, r = (new Date).getTime() - n, o = t.transaction(O, "readonly", Z), i = o.objectStore(O), a = [], new Promise(function(e1) {
                                    i.openCursor().onsuccess = function(t) {
                                        var n = t.target.result;
                                        if (n) {
                                            var i = n.value;
                                            i.time < r ? (a.push(i), n.continue()) : (E(o), e1(a));
                                        } else e1(a);
                                    };
                                })).then(function(t) {
                                    return function(e1, t) {
                                        if (e1.closed) return Promise.resolve([]);
                                        var n = e1.db.transaction(O, "readwrite", Z).objectStore(O);
                                        return Promise.all(t.map(function(e1) {
                                            var t = n.delete(e1);
                                            return new Promise(function(e1) {
                                                t.onsuccess = function() {
                                                    return e1();
                                                };
                                            });
                                        }));
                                    }(e1, t.map(function(e1) {
                                        return e1.id;
                                    }));
                                });
                            }(e1);
                        }), e1.writeBlockPromise;
                    },
                    canBeUsed: function() {
                        return !!T();
                    },
                    type: "idb",
                    averageResponseTime: function(e1) {
                        return 2 * e1.idb.fallbackInterval;
                    },
                    microSeconds: g
                };
                function A() {
                    var e1;
                    if ("undefined" == typeof window) return null;
                    try {
                        e1 = window.localStorage, e1 = window["ie8-eventlistener/storage"] || window.localStorage;
                    } catch (e1) {}
                    return e1;
                }
                function R(e1) {
                    return "pubkey.broadcastChannel-" + e1;
                }
                function _() {
                    var e1 = A();
                    if (!e1) return !1;
                    try {
                        var t = "__broadcastchannel_check";
                        e1.setItem(t, "works"), e1.removeItem(t);
                    } catch (e1) {
                        return !1;
                    }
                    return !0;
                }
                var j = {
                    create: function(e1, t) {
                        if (t = w(t), !_()) throw new Error("BroadcastChannel: localstorage cannot be used");
                        var n = h(), r = new b(t.localstorage.removeTimeout), o = {
                            channelName: e1,
                            uuid: n,
                            eMIs: r
                        };
                        return o.listener = function(e1, t) {
                            var i = R(e1), a = function(e1) {
                                var t;
                                e1.key === i && (t = JSON.parse(e1.newValue), o.messagesCallback && t.uuid !== n && t.token && !r.has(t.token) && (t.data.time && t.data.time < o.messagesCallbackTime || (r.add(t.token), o.messagesCallback(t.data))));
                            };
                            return window.addEventListener("storage", a), a;
                        }(e1), o;
                    },
                    close: function(e1) {
                        var t;
                        t = e1.listener, window.removeEventListener("storage", t);
                    },
                    onMessage: function(e1, t, n) {
                        e1.messagesCallbackTime = n, e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        return new Promise(function(n) {
                            d().then(function() {
                                var r = R(e1.channelName), o = {
                                    token: h(),
                                    time: (new Date).getTime(),
                                    data: t,
                                    uuid: e1.uuid
                                }, i = JSON.stringify(o);
                                A().setItem(r, i);
                                var a = document.createEvent("Event");
                                a.initEvent("storage", !0, !0), a.key = r, a.newValue = i, window.dispatchEvent(a), n();
                            });
                        });
                    },
                    canBeUsed: _,
                    type: "localstorage",
                    averageResponseTime: function() {
                        var e1 = navigator.userAgent.toLowerCase();
                        return e1.includes("safari") && !e1.includes("chrome") ? 240 : 120;
                    },
                    microSeconds: g
                }, C = g, I = new Set, D = {
                    create: function(e1) {
                        var t = {
                            name: e1,
                            messagesCallback: null
                        };
                        return I.add(t), t;
                    },
                    close: function(e1) {
                        I.delete(e1);
                    },
                    onMessage: function(e1, t) {
                        e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        return new Promise(function(n) {
                            return setTimeout(function() {
                                Array.from(I).filter(function(t) {
                                    return t.name === e1.name;
                                }).filter(function(t) {
                                    return t !== e1;
                                }).filter(function(e1) {
                                    return !!e1.messagesCallback;
                                }).forEach(function(e1) {
                                    return e1.messagesCallback(t);
                                }), n();
                            }, 5);
                        });
                    },
                    canBeUsed: function() {
                        return !0;
                    },
                    type: "simulate",
                    averageResponseTime: function() {
                        return 5;
                    },
                    microSeconds: C
                }, M = [
                    m,
                    x,
                    j
                ], N = new Set, U = 0, L = function(e1, t) {
                    var n, r, o;
                    this.id = U++, N.add(this), this.name = e1, this.options = w(t), this.method = function(e1) {
                        var t = [].concat(e1.methods, M).filter(Boolean);
                        if (e1.type) {
                            if ("simulate" === e1.type) return D;
                            var n = t.find(function(t) {
                                return t.type === e1.type;
                            });
                            if (n) return n;
                            throw new Error("method-type " + e1.type + " not found");
                        }
                        e1.webWorkerSupport || (t = t.filter(function(e1) {
                            return "idb" !== e1.type;
                        }));
                        var r = t.find(function(e1) {
                            return e1.canBeUsed();
                        });
                        if (r) return r;
                        throw new Error("No usable method found in " + JSON.stringify(M.map(function(e1) {
                            return e1.type;
                        })));
                    }(this.options), this._iL = !1, this._onML = null, this._addEL = {
                        message: [],
                        internal: []
                    }, this._uMP = new Set, this._befC = [], this._prepP = null, (o = r = (n = this).method.create(n.name, n.options)) && "function" == typeof o.then ? (n._prepP = r, r.then(function(e1) {
                        n._state = e1;
                    })) : n._state = r;
                };
                function H(e1, t, n) {
                    var r = {
                        time: e1.method.microSeconds(),
                        type: t,
                        data: n
                    };
                    return (e1._prepP ? e1._prepP : p).then(function() {
                        var t = e1.method.postMessage(e1._state, r);
                        return e1._uMP.add(t), t.catch().then(function() {
                            return e1._uMP.delete(t);
                        }), t;
                    });
                }
                function B(e1) {
                    return e1._addEL.message.length > 0 || e1._addEL.internal.length > 0;
                }
                function K(e1, t, n) {
                    e1._addEL[t].push(n), function(e1) {
                        if (!e1._iL && B(e1)) {
                            var t = function(t) {
                                e1._addEL[t.type].forEach(function(e1) {
                                    var n = e1.time - 1e5;
                                    t.time >= n && e1.fn(t.data);
                                });
                            }, n = e1.method.microSeconds();
                            e1._prepP ? e1._prepP.then(function() {
                                e1._iL = !0, e1.method.onMessage(e1._state, t, n);
                            }) : (e1._iL = !0, e1.method.onMessage(e1._state, t, n));
                        }
                    }(e1);
                }
                function F(e1, t, n) {
                    e1._addEL[t] = e1._addEL[t].filter(function(e1) {
                        return e1 !== n;
                    }), function(e1) {
                        if (e1._iL && !B(e1)) {
                            e1._iL = !1;
                            var t = e1.method.microSeconds();
                            e1.method.onMessage(e1._state, null, t);
                        }
                    }(e1);
                }
                L._pubkey = !0, L.prototype = {
                    postMessage: function(e1) {
                        if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + JSON.stringify(e1));
                        return H(this, "message", e1);
                    },
                    postInternal: function(e1) {
                        return H(this, "internal", e1);
                    },
                    set onmessage (e){
                        var t1 = {
                            time: this.method.microSeconds(),
                            fn: e
                        };
                        F(this, "message", this._onML), e && "function" == typeof e ? (this._onML = t1, K(this, "message", t1)) : this._onML = null;
                    },
                    addEventListener: function(e1, t) {
                        K(this, e1, {
                            time: this.method.microSeconds(),
                            fn: t
                        });
                    },
                    removeEventListener: function(e1, t) {
                        F(this, e1, this._addEL[e1].find(function(e1) {
                            return e1.fn === t;
                        }));
                    },
                    close: function() {
                        var e1 = this;
                        if (!this.closed) {
                            N.delete(this), this.closed = !0;
                            var t = this._prepP ? this._prepP : p;
                            return this._onML = null, this._addEL.message = [], t.then(function() {
                                return Promise.all(Array.from(e1._uMP));
                            }).then(function() {
                                return Promise.all(e1._befC.map(function(e1) {
                                    return e1();
                                }));
                            }).then(function() {
                                return e1.method.close(e1._state);
                            });
                        }
                    },
                    get type () {
                        return this.method.type;
                    },
                    get isClosed () {
                        return this.closed;
                    }
                };
                var G = "[object process]" === Object.prototype.toString.call(0) ? function(e1) {
                    $375d8335527bcde6$exports.on("exit", function() {
                        return e1();
                    }), $375d8335527bcde6$exports.on("beforeExit", function() {
                        return e1().then(function() {
                            return $375d8335527bcde6$exports.exit();
                        });
                    }), $375d8335527bcde6$exports.on("SIGINT", function() {
                        return e1().then(function() {
                            return $375d8335527bcde6$exports.exit();
                        });
                    }), $375d8335527bcde6$exports.on("uncaughtException", function(t) {
                        return e1().then(function() {
                            console.trace(t), $375d8335527bcde6$exports.exit(101);
                        });
                    });
                } : function(e1) {
                    if ("function" == typeof WorkerGlobalScope && self instanceof WorkerGlobalScope) {
                        var t = self.close.bind(self);
                        self.close = function() {
                            return e1(), t();
                        };
                    } else {
                        if ("function" != typeof window.addEventListener) return;
                        window.addEventListener("beforeunload", function() {
                            e1();
                        }, !0), window.addEventListener("unload", function() {
                            e1();
                        }, !0);
                    }
                }, V = new Set, q = !1;
                function W() {
                    var e1 = [];
                    return V.forEach(function(t) {
                        e1.push(t()), V.delete(t);
                    }), Promise.all(e1);
                }
                function Y(e1, t) {
                    var n = {
                        context: "leader",
                        action: t,
                        token: e1.token
                    };
                    return e1.broadcastChannel.postInternal(n);
                }
                function z(e1) {
                    e1.isLeader = !0, e1._hasLeader = !0;
                    var t = function(e1) {
                        if (q || (q = !0, G(W)), "function" != typeof e1) throw new Error("Listener is no function");
                        return V.add(e1), {
                            remove: function() {
                                return V.delete(e1);
                            },
                            run: function() {
                                return V.delete(e1), e1();
                            }
                        };
                    }(function() {
                        return e1.die();
                    });
                    e1._unl.push(t);
                    var n = function(t) {
                        "leader" === t.context && "apply" === t.action && Y(e1, "tell"), "leader" !== t.context || "tell" !== t.action || e1._dpLC || (e1._dpLC = !0, e1._dpL(), Y(e1, "tell"));
                    };
                    return e1.broadcastChannel.addEventListener("internal", n), e1._lstns.push(n), Y(e1, "tell");
                }
                var Q = function(e1, t) {
                    var n = this;
                    this.broadcastChannel = e1, e1._befC.push(function() {
                        return n.die();
                    }), this._options = t, this.isLeader = !1, this.isDead = !1, this.token = h(), this._lstns = [], this._unl = [], this._dpL = function() {}, this._dpLC = !1, this._wKMC = {}, this.lN = "pubkey-bc||" + e1.method.type + "||" + e1.name;
                };
                Q.prototype = {
                    hasLeader: function() {
                        var e1 = this;
                        return navigator.locks.query().then(function(t) {
                            var n = t.held ? t.held.filter(function(t) {
                                return t.name === e1.lN;
                            }) : [];
                            return !!(n && n.length > 0);
                        });
                    },
                    awaitLeadership: function() {
                        var e1 = this;
                        if (!this._wLMP) {
                            this._wKMC.c = new AbortController;
                            var t = new Promise(function(t, n) {
                                e1._wKMC.res = t, e1._wKMC.rej = n;
                            });
                            this._wLMP = new Promise(function(n) {
                                navigator.locks.request(e1.lN, {
                                    signal: e1._wKMC.c.signal
                                }, function() {
                                    return e1._wKMC.c = void 0, z(e1), n(), t;
                                }).catch(function() {});
                            });
                        }
                        return this._wLMP;
                    },
                    set onduplicate (e){},
                    die: function() {
                        var e1 = this;
                        return this._lstns.forEach(function(t) {
                            return e1.broadcastChannel.removeEventListener("internal", t);
                        }), this._lstns = [], this._unl.forEach(function(e1) {
                            return e1.remove();
                        }), this._unl = [], this.isLeader && (this.isLeader = !1), this.isDead = !0, this._wKMC.res && this._wKMC.res(), this._wKMC.c && this._wKMC.c.abort("LeaderElectionWebLock.die() called"), Y(this, "death");
                    }
                };
                var X = function(e1, t) {
                    var n = this;
                    this.broadcastChannel = e1, this._options = t, this.isLeader = !1, this._hasLeader = !1, this.isDead = !1, this.token = h(), this._aplQ = p, this._aplQC = 0, this._unl = [], this._lstns = [], this._dpL = function() {}, this._dpLC = !1;
                    var r = function(e1) {
                        "leader" === e1.context && ("death" === e1.action && (n._hasLeader = !1), "tell" === e1.action && (n._hasLeader = !0));
                    };
                    this.broadcastChannel.addEventListener("internal", r), this._lstns.push(r);
                };
                function J(e1, t) {
                    if (e1._leaderElector) throw new Error("BroadcastChannel already has a leader-elector");
                    t = function(e1, t) {
                        return e1 || (e1 = {}), (e1 = JSON.parse(JSON.stringify(e1))).fallbackInterval || (e1.fallbackInterval = 3e3), e1.responseTime || (e1.responseTime = t.method.averageResponseTime(t.options)), e1;
                    }(t, e1);
                    var n = "undefined" != typeof navigator && void 0 !== navigator.locks && "function" == typeof navigator.locks.request ? new Q(e1, t) : new X(e1, t);
                    return e1._befC.push(function() {
                        return n.die();
                    }), e1._leaderElector = n, n;
                }
                X.prototype = {
                    hasLeader: function() {
                        return Promise.resolve(this._hasLeader);
                    },
                    applyOnce: function(e1) {
                        var t = this;
                        return this.isLeader ? d(0, !0) : this.isDead ? d(0, !1) : this._aplQC > 1 ? this._aplQ : (this._aplQC = this._aplQC + 1, this._aplQ = this._aplQ.then(function() {
                            return function() {
                                if (t.isLeader) return l;
                                var n, r = !1, o = new Promise(function(e1) {
                                    n = function() {
                                        r = !0, e1();
                                    };
                                }), i = function(e1) {
                                    "leader" === e1.context && e1.token != t.token && ("apply" === e1.action && e1.token > t.token && n(), "tell" === e1.action && (n(), t._hasLeader = !0));
                                };
                                t.broadcastChannel.addEventListener("internal", i);
                                var a = e1 ? 4 * t._options.responseTime : t._options.responseTime;
                                return Y(t, "apply").then(function() {
                                    return Promise.race([
                                        d(a),
                                        o.then(function() {
                                            return Promise.reject(new Error);
                                        })
                                    ]);
                                }).then(function() {
                                    return Y(t, "apply");
                                }).then(function() {
                                    return Promise.race([
                                        d(a),
                                        o.then(function() {
                                            return Promise.reject(new Error);
                                        })
                                    ]);
                                }).catch(function() {}).then(function() {
                                    return t.broadcastChannel.removeEventListener("internal", i), !r && z(t).then(function() {
                                        return !0;
                                    });
                                });
                            }();
                        }).then(function() {
                            t._aplQC = t._aplQC - 1;
                        }), this._aplQ.then(function() {
                            return t.isLeader;
                        }));
                    },
                    awaitLeadership: function() {
                        var e1;
                        return this._aLP || (this._aLP = (e1 = this).isLeader ? p : new Promise(function(t) {
                            var n = !1;
                            function r() {
                                n || (n = !0, e1.broadcastChannel.removeEventListener("internal", o), t(!0));
                            }
                            e1.applyOnce().then(function() {
                                e1.isLeader && r();
                            }), function t() {
                                return d(e1._options.fallbackInterval).then(function() {
                                    if (!e1.isDead && !n) return e1.isLeader ? void r() : e1.applyOnce(!0).then(function() {
                                        e1.isLeader ? r() : t();
                                    });
                                });
                            }();
                            var o = function(t) {
                                "leader" === t.context && "death" === t.action && (e1._hasLeader = !1, e1.applyOnce().then(function() {
                                    e1.isLeader && r();
                                }));
                            };
                            e1.broadcastChannel.addEventListener("internal", o), e1._lstns.push(o);
                        })), this._aLP;
                    },
                    set onduplicate (e){
                        this._dpL = e;
                    },
                    die: function() {
                        var e1 = this;
                        return this._lstns.forEach(function(t) {
                            return e1.broadcastChannel.removeEventListener("internal", t);
                        }), this._lstns = [], this._unl.forEach(function(e1) {
                            return e1.remove();
                        }), this._unl = [], this.isLeader && (this._hasLeader = !1, this.isLeader = !1), this.isDead = !0, Y(this, "death");
                    }
                };
                var $ = n(415), ee = function() {
                    function e1() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "elector", void 0), (0, c.Z)(this, "started", !1), this.options = t, this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this), this.onLeader = this.onLeader.bind(this);
                    }
                    var t, n, r;
                    return (0, u.Z)(e1, [
                        {
                            key: "onLeaderDuplicate",
                            value: function() {}
                        },
                        {
                            key: "onLeader",
                            value: (r = (0, i.Z)(f().mark(function e1() {
                                var t, n;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.next = 2, null === (t = (n = this.options).onLeader) || void 0 === t ? void 0 : t.call(n);
                                        case 2:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return r.apply(this, arguments);
                            })
                        },
                        {
                            key: "isLeader",
                            value: function() {
                                var e1;
                                return !(null === (e1 = this.elector) || void 0 === e1 || !e1.isLeader);
                            }
                        },
                        {
                            key: "hasLeader",
                            value: function() {
                                var e1;
                                return !(null === (e1 = this.elector) || void 0 === e1 || !e1.hasLeader);
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && (t = this.options.electionChannelName, this.channel = new L(t), this.elector = J(this.channel), this.elector.onduplicate = this.onLeaderDuplicate, this.elector.awaitLeadership().then(this.onLeader), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 11;
                                                break;
                                            }
                                            if (!this.elector) {
                                                e1.next = 5;
                                                break;
                                            }
                                            return e1.next = 4, this.elector.die();
                                        case 4:
                                            this.elector = void 0;
                                        case 5:
                                            if (!this.channel) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return this.channel.postInternal = function() {
                                                return Promise.resolve();
                                            }, e1.next = 9, this.channel.close();
                                        case 9:
                                            this.channel = void 0;
                                        case 10:
                                            this.started = !1;
                                        case 11:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return (0, $.isBrowser)() && !this.started;
                            }
                        }
                    ]), e1;
                }(), te = n(9123), ne = n(6488), re = n(7088), oe = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "renewTimeQueue", void 0), (0, c.Z)(this, "started", !1), this.tokenManager = t, this.options = n, this.renewTimeQueue = [], this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "shouldThrottleRenew",
                            value: function() {
                                var e1 = !1;
                                if (this.renewTimeQueue.push(Date.now()), this.renewTimeQueue.length >= 10) {
                                    var t = this.renewTimeQueue.shift();
                                    e1 = this.renewTimeQueue[this.renewTimeQueue.length - 1] - t < 3e4;
                                }
                                return e1;
                            }
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !!this.options.syncStorage && (0, $.isBrowser)();
                            }
                        },
                        {
                            key: "processExpiredTokens",
                            value: function() {
                                var e1 = this, t = this.tokenManager.getStorage().getStorage();
                                Object.keys(t).forEach(function(n) {
                                    var r = t[n];
                                    !(0, ne.z9)(r) && e1.tokenManager.hasExpired(r) && e1.onTokenExpiredHandler(n);
                                });
                            }
                        },
                        {
                            key: "onTokenExpiredHandler",
                            value: function(e1) {
                                if (this.options.autoRenew) {
                                    if (this.shouldThrottleRenew()) {
                                        var t = new te.Z("Too many token renew requests");
                                        this.tokenManager.emitError(t);
                                    } else this.tokenManager.renew(e1).catch(function() {});
                                } else this.options.autoRemove && this.tokenManager.remove(e1);
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return !(!this.options.autoRenew && !this.options.autoRemove || this.started);
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && (this.tokenManager.on(re.$Y, this.onTokenExpiredHandler), this.tokenManager.isStarted() && this.processExpiredTokens(), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.started && (this.tokenManager.off(re.$Y, this.onTokenExpiredHandler), this.renewTimeQueue = [], this.started = !1);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        }
                    ]), e1;
                }(), ie = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "started", !1), (0, c.Z)(this, "enablePostMessage", !0), this.tokenManager = t, this.options = n, this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this), this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this), this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this), this.onSetStorageHandler = this.onSetStorageHandler.bind(this), this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return !!this.options.syncStorage && (0, $.isBrowser)() && !this.started;
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (this.canStart()) {
                                                e1.next = 2;
                                                break;
                                            }
                                            return e1.abrupt("return");
                                        case 2:
                                            t = this.options.syncChannelName, e1.prev = 3, this.channel = new L(t), e1.next = 10;
                                            break;
                                        case 7:
                                            throw e1.prev = 7, e1.t0 = e1.catch(3), new te.Z("SyncStorageService is not supported in current browser.");
                                        case 10:
                                            this.tokenManager.on(re.O3, this.onTokenAddedHandler), this.tokenManager.on(re.FT, this.onTokenRemovedHandler), this.tokenManager.on(re.E, this.onTokenRenewedHandler), this.tokenManager.on(re.zr, this.onSetStorageHandler), this.channel.addEventListener("message", this.onSyncMessageHandler), this.started = !0;
                                        case 16:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        3,
                                        7
                                    ]
                                ]);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                var t, n;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return this.tokenManager.off(re.O3, this.onTokenAddedHandler), this.tokenManager.off(re.FT, this.onTokenRemovedHandler), this.tokenManager.off(re.E, this.onTokenRenewedHandler), this.tokenManager.off(re.zr, this.onSetStorageHandler), null === (t = this.channel) || void 0 === t || t.removeEventListener("message", this.onSyncMessageHandler), e1.next = 8, null === (n = this.channel) || void 0 === n ? void 0 : n.close();
                                        case 8:
                                            this.channel = void 0, this.started = !1;
                                        case 10:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "onTokenAddedHandler",
                            value: function(e1, t) {
                                var n;
                                this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                                    type: re.O3,
                                    key: e1,
                                    token: t
                                }));
                            }
                        },
                        {
                            key: "onTokenRemovedHandler",
                            value: function(e1, t) {
                                var n;
                                this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                                    type: re.FT,
                                    key: e1,
                                    token: t
                                }));
                            }
                        },
                        {
                            key: "onTokenRenewedHandler",
                            value: function(e1, t, n) {
                                var r;
                                this.enablePostMessage && (null === (r = this.channel) || void 0 === r || r.postMessage({
                                    type: re.E,
                                    key: e1,
                                    token: t,
                                    oldToken: n
                                }));
                            }
                        },
                        {
                            key: "onSetStorageHandler",
                            value: function(e1) {
                                var t;
                                null === (t = this.channel) || void 0 === t || t.postMessage({
                                    type: re.zr,
                                    storage: e1
                                });
                            }
                        },
                        {
                            key: "onSyncMessageHandler",
                            value: function(e1) {
                                switch(this.enablePostMessage = !1, e1.type){
                                    case re.zr:
                                        this.tokenManager.getStorage().setStorage(e1.storage);
                                        break;
                                    case re.O3:
                                        this.tokenManager.emitAdded(e1.key, e1.token), this.tokenManager.setExpireEventTimeout(e1.key, e1.token);
                                        break;
                                    case re.FT:
                                        this.tokenManager.clearExpireEventTimeout(e1.key), this.tokenManager.emitRemoved(e1.key, e1.token);
                                        break;
                                    case re.E:
                                        this.tokenManager.emitRenewed(e1.key, e1.token, e1.oldToken);
                                }
                                this.enablePostMessage = !0;
                            }
                        }
                    ]), e1;
                }(), ae = function() {
                    return Math.floor(Date.now() / 1e3);
                }, ue = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "started", !1), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "lastHidden", -1), (0, c.Z)(this, "onPageVisbilityChange", void 0), this.tokenManager = t, this.options = n, this.onPageVisbilityChange = this._onPageVisbilityChange.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "_onPageVisbilityChange",
                            value: function() {
                                if (document.hidden) this.lastHidden = ae();
                                else if (this.lastHidden > 0 && ae() - this.lastHidden >= this.options.tabInactivityDuration) {
                                    var e1 = this.tokenManager.getTokensSync(), t = e1.accessToken, n = e1.idToken;
                                    if (t && this.tokenManager.hasExpired(t)) {
                                        var r = this.tokenManager.getStorageKeyByType("accessToken");
                                        this.tokenManager.renew(r).catch(function() {});
                                    } else if (n && this.tokenManager.hasExpired(n)) {
                                        var o = this.tokenManager.getStorageKeyByType("idToken");
                                        this.tokenManager.renew(o).catch(function() {});
                                    }
                                }
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && document && (document.addEventListener("visibilitychange", this.onPageVisbilityChange), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            document && (document.removeEventListener("visibilitychange", this.onPageVisbilityChange), this.started = !1);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return (0, $.isBrowser)() && !!this.options.autoRenew && !!this.options.renewOnTabActivation && !this.started;
                            }
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        }
                    ]), e1;
                }(), ce = n(3193);
                function se(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function fe(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? se(Object(n), !0).forEach(function(t) {
                            (0, c.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : se(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function le(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return pe(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? pe(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function pe(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var de = "autoRenew", he = "syncStorage", ve = "leaderElection", ye = "renewOnTabActivation", ge = function() {
                    function e1(t) {
                        var n = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "sdk", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "services", void 0), (0, c.Z)(this, "started", void 0), this.sdk = t, this.onLeader = this.onLeader.bind(this);
                        var o = t.tokenManager.getOptions(), i = o.autoRenew, u = o.autoRemove, s = o.syncStorage;
                        r.electionChannelName = r.electionChannelName || r.broadcastChannelName, this.options = Object.assign({}, e1.defaultOptions, {
                            autoRenew: i,
                            autoRemove: u,
                            syncStorage: s
                        }, {
                            electionChannelName: "".concat(t.options.clientId, "-election"),
                            syncChannelName: "".concat(t.options.clientId, "-sync")
                        }, (0, ce.YY)(r)), this.started = !1, this.services = new Map, e1.knownServices.forEach(function(e1) {
                            var t = n.createService(e1);
                            t && n.services.set(e1, t);
                        });
                    }
                    var t, n, s, l, p;
                    return (0, u.Z)(e1, [
                        {
                            key: "onLeader",
                            value: (p = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 3;
                                                break;
                                            }
                                            return e1.next = 3, this.startServices();
                                        case 3:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return p.apply(this, arguments);
                            })
                        },
                        {
                            key: "isLeader",
                            value: function() {
                                var e1;
                                return null === (e1 = this.getService(ve)) || void 0 === e1 ? void 0 : e1.isLeader();
                            }
                        },
                        {
                            key: "isLeaderRequired",
                            value: function() {
                                return (0, o.Z)(this.services.values()).some(function(e1) {
                                    return e1.canStart() && e1.requiresLeadership();
                                });
                            }
                        },
                        {
                            key: "start",
                            value: (l = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 2;
                                                break;
                                            }
                                            return e1.abrupt("return");
                                        case 2:
                                            return e1.next = 4, this.startServices();
                                        case 4:
                                            this.started = !0;
                                        case 5:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return l.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (s = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.next = 2, this.stopServices();
                                        case 2:
                                            this.started = !1;
                                        case 3:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return s.apply(this, arguments);
                            })
                        },
                        {
                            key: "getService",
                            value: function(e1) {
                                return this.services.get(e1);
                            }
                        },
                        {
                            key: "startServices",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t, n, o, i, a;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            t = le(this.services.entries()), e1.prev = 1, t.s();
                                        case 3:
                                            if ((n = t.n()).done) {
                                                e1.next = 10;
                                                break;
                                            }
                                            if (o = (0, r.Z)(n.value, 2), i = o[0], a = o[1], !this.canStartService(i, a)) {
                                                e1.next = 8;
                                                break;
                                            }
                                            return e1.next = 8, a.start();
                                        case 8:
                                            e1.next = 3;
                                            break;
                                        case 10:
                                            e1.next = 15;
                                            break;
                                        case 12:
                                            e1.prev = 12, e1.t0 = e1.catch(1), t.e(e1.t0);
                                        case 15:
                                            return e1.prev = 15, t.f(), e1.finish(15);
                                        case 18:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        1,
                                        12,
                                        15,
                                        18
                                    ]
                                ]);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stopServices",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                var t, n, r;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            t = le(this.services.values()), e1.prev = 1, t.s();
                                        case 3:
                                            if ((n = t.n()).done) {
                                                e1.next = 9;
                                                break;
                                            }
                                            return r = n.value, e1.next = 7, r.stop();
                                        case 7:
                                            e1.next = 3;
                                            break;
                                        case 9:
                                            e1.next = 14;
                                            break;
                                        case 11:
                                            e1.prev = 11, e1.t0 = e1.catch(1), t.e(e1.t0);
                                        case 14:
                                            return e1.prev = 14, t.f(), e1.finish(14);
                                        case 17:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        1,
                                        11,
                                        14,
                                        17
                                    ]
                                ]);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "canStartService",
                            value: function(e1, t) {
                                var n = t.canStart() && !t.isStarted();
                                return e1 === ve ? n && (n = this.isLeaderRequired()) : t.requiresLeadership() && n && (n = this.isLeader()), n;
                            }
                        },
                        {
                            key: "createService",
                            value: function(e1) {
                                var t, n = this.sdk.tokenManager;
                                switch(e1){
                                    case ve:
                                        t = new ee(fe(fe({}, this.options), {}, {
                                            onLeader: this.onLeader
                                        }));
                                        break;
                                    case de:
                                        t = new oe(n, fe({}, this.options));
                                        break;
                                    case he:
                                        t = new ie(n, fe({}, this.options));
                                        break;
                                    case ye:
                                        t = new ue(n, fe({}, this.options));
                                        break;
                                    default:
                                        throw new Error("Unknown service ".concat(e1));
                                }
                                return t;
                            }
                        }
                    ]), e1;
                }();
                (0, c.Z)(ge, "knownServices", [
                    de,
                    he,
                    ve,
                    ye
                ]), (0, c.Z)(ge, "defaultOptions", {
                    autoRenew: !0,
                    autoRemove: !0,
                    syncStorage: !0,
                    renewOnTabActivation: !0,
                    tabInactivityDuration: 1800
                });
            },
            6599: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return r.W;
                    }
                });
                var r = n(9046);
            },
            1578: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    K: function() {
                        return s;
                    }
                });
                var r = n(9893), o = n(265), i = n(279), a = n(2724), u = n(8386), c = n(3980);
                function s(e1, t, n) {
                    var s = (0, r.a)(t), f = (0, o.H)(s, e1), l = (0, i.A)(f), p = (0, c.Z)(l), d = (0, a.J)(p, n);
                    return (0, u.i)(d);
                }
            },
            3961: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    AuthStateManager: function() {
                        return r.E;
                    },
                    INITIAL_AUTH_STATE: function() {
                        return r.a;
                    },
                    ServiceManager: function() {
                        return l.W;
                    },
                    createCoreOptionsConstructor: function() {
                        return o.n;
                    },
                    createCoreStorageManager: function() {
                        return u.a;
                    },
                    createOktaAuthCore: function() {
                        return i.K;
                    },
                    mixinCore: function() {
                        return a.i;
                    }
                });
                var r = n(1018), o = n(9133), i = n(1578), a = n(8386), u = n(2647), c = n(8553), s = {};
                for(var f in c)[
                    "default",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "createCoreOptionsConstructor",
                    "createOktaAuthCore",
                    "mixinCore",
                    "createCoreStorageManager"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                n.d(t, s);
                var l = n(6599);
            },
            8386: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    i: function() {
                        return g;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(5372), h = n(1018), v = n(9046), y = n(9123);
                function g(e1) {
                    return function(e1) {
                        (0, u.Z)(w, e1);
                        var t, n, l, g, m, b, k = (m = w, b = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, s.Z)(m);
                            if (b) {
                                var n = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function w() {
                            var e1;
                            (0, o.Z)(this, w);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = k.call.apply(k, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "authStateManager", void 0), (0, f.Z)((0, a.Z)(e1), "serviceManager", void 0), e1.authStateManager = new h.E((0, a.Z)(e1)), e1.serviceManager = new v.W((0, a.Z)(e1), e1.options.services), e1;
                        }
                        return (0, i.Z)(w, [
                            {
                                key: "start",
                                value: (g = (0, r.Z)(p().mark(function e1() {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.serviceManager.start();
                                            case 2:
                                                if (this.tokenManager.start(), this.token.isLoginRedirect()) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                return e1.next = 6, this.authStateManager.updateAuthState();
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return g.apply(this, arguments);
                                })
                            },
                            {
                                key: "stop",
                                value: (l = (0, r.Z)(p().mark(function e1() {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return this.tokenManager.stop(), e1.next = 3, this.serviceManager.stop();
                                            case 3:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return l.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleRedirect",
                                value: (n = (0, r.Z)(p().mark(function e1(t) {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.handleLoginRedirect(void 0, t);
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleLoginRedirect",
                                value: (t = (0, r.Z)(p().mark(function e1(t, n) {
                                    var r, o, i;
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (r = this.options.state, !t) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                this.tokenManager.setTokens(t), n = n || this.getOriginalUri(this.options.state), e1.next = 25;
                                                break;
                                            case 6:
                                                if (!this.isLoginRedirect()) {
                                                    e1.next = 24;
                                                    break;
                                                }
                                                return e1.prev = 7, e1.next = 10, (0, d.Tp)(this, {});
                                            case 10:
                                                return o = e1.sent, r = o.state, n = n || this.getOriginalUri(r), e1.next = 15, this.storeTokensFromRedirect();
                                            case 15:
                                                e1.next = 22;
                                                break;
                                            case 17:
                                                return e1.prev = 17, e1.t0 = e1.catch(7), e1.next = 21, this.authStateManager.updateAuthState();
                                            case 21:
                                                throw e1.t0;
                                            case 22:
                                                e1.next = 25;
                                                break;
                                            case 24:
                                                return e1.abrupt("return");
                                            case 25:
                                                return e1.next = 27, this.authStateManager.updateAuthState();
                                            case 27:
                                                if (this.removeOriginalUri(r), !(i = this.options.restoreOriginalUri)) {
                                                    e1.next = 34;
                                                    break;
                                                }
                                                return e1.next = 32, i(this, n);
                                            case 32:
                                                e1.next = 35;
                                                break;
                                            case 34:
                                                n && window.location.replace(n);
                                            case 35:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            7,
                                            17
                                        ]
                                    ]);
                                })), function(e1, n) {
                                    return t.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleIDPPopupRedirect",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.location.href, t = (0, d.Tp)(this, {
                                        responseMode: "query",
                                        url: e1
                                    });
                                    if (!t.state) throw new y.Z("Unable to parse auth code params");
                                    var n = new BroadcastChannel("popup-callback:".concat(t.state));
                                    n.postMessage(t), n.close();
                                }
                            }
                        ]), w;
                    }(e1);
                }
            },
            9133: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9453);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "services", void 0), (0, s.Z)((0, i.Z)(t), "transformAuthState", void 0), t.services = e1.services, t.transformAuthState = e1.transformAuthState, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.m)());
                }
            },
            2647: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return o;
                    }
                });
                var r = n(2333);
                function o() {
                    return (0, r.a)();
                }
            },
            5675: function() {},
            8553: function(e1, t, n) {
                "use strict";
                n.r(t);
                var r = n(5675), o = {};
                for(var i in r)"default" !== i && (o[i] = (function(e1) {
                    return r[e1];
                }).bind(0, i));
                n.d(t, o);
            },
            7987: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Df: function() {
                        return u;
                    },
                    EL: function() {
                        return f;
                    },
                    NL: function() {
                        return i;
                    },
                    Wy: function() {
                        return c;
                    },
                    aR: function() {
                        return a;
                    },
                    dX: function() {
                        return l;
                    },
                    k8: function() {
                        return s;
                    },
                    kQ: function() {
                        return p;
                    }
                });
                var r = n(9123), o = n(7594);
                function i(e1) {
                    return a((0, o.r3)(e1));
                }
                function a(e1) {
                    return e1.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
                }
                function u(e1) {
                    return e1.replace(/-/g, "+").replace(/_/g, "/");
                }
                function c(e1) {
                    var t = u(e1);
                    switch(t.length % 4){
                        case 0:
                            break;
                        case 2:
                            t += "==";
                            break;
                        case 3:
                            t += "=";
                            break;
                        default:
                            throw new r.Z("Not a valid Base64Url");
                    }
                    var n = (0, o.ty)(t);
                    try {
                        return decodeURIComponent(escape(n));
                    } catch (e1) {
                        return n;
                    }
                }
                function s(e1) {
                    for(var t = new Uint8Array(e1.length), n = 0; n < e1.length; n++)t[n] = e1.charCodeAt(n);
                    return t;
                }
                function f(e1) {
                    return (0, o.ty)(u(e1));
                }
                function l(e1) {
                    return Uint8Array.from(f(e1), function(e1) {
                        return e1.charCodeAt(0);
                    });
                }
                function p(e1) {
                    return (0, o.r3)(new Uint8Array(e1).reduce(function(e1, t) {
                        return e1 + String.fromCharCode(t);
                    }, ""));
                }
            },
            7594: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    KP: function() {
                        return i;
                    },
                    r3: function() {
                        return o;
                    },
                    ty: function() {
                        return r;
                    }
                });
                var r = function(e1) {
                    return atob(e1);
                }, o = function(e1) {
                    return btoa(e1);
                }, i = "undefined" == typeof crypto ? null : crypto;
            },
            9718: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    atob: function() {
                        return s.ty;
                    },
                    base64ToBase64Url: function() {
                        return r.aR;
                    },
                    base64UrlDecode: function() {
                        return r.EL;
                    },
                    base64UrlToBase64: function() {
                        return r.Df;
                    },
                    base64UrlToBuffer: function() {
                        return r.dX;
                    },
                    base64UrlToString: function() {
                        return r.Wy;
                    },
                    btoa: function() {
                        return s.r3;
                    },
                    bufferToBase64Url: function() {
                        return r.kQ;
                    },
                    getOidcHash: function() {
                        return o.X;
                    },
                    stringToBase64Url: function() {
                        return r.NL;
                    },
                    stringToBuffer: function() {
                        return r.k8;
                    },
                    verifyToken: function() {
                        return c.W;
                    },
                    webcrypto: function() {
                        return s.KP;
                    }
                });
                var r = n(7987), o = n(5698), i = n(6332), a = {};
                for(var u in i)[
                    "default",
                    "base64ToBase64Url",
                    "base64UrlDecode",
                    "base64UrlToBase64",
                    "base64UrlToBuffer",
                    "base64UrlToString",
                    "bufferToBase64Url",
                    "stringToBase64Url",
                    "stringToBuffer",
                    "getOidcHash"
                ].indexOf(u) < 0 && (a[u] = (function(e1) {
                    return i[e1];
                }).bind(0, u));
                n.d(t, a);
                var c = n(3154), s = n(1);
            },
            5698: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return i;
                    }
                });
                var r = n(7987), o = n(7594);
                function i(e1) {
                    var t = (new TextEncoder).encode(e1);
                    return o.KP.subtle.digest("SHA-256", t).then(function(e1) {
                        var t = new Uint8Array(e1).slice(0, 16), n = String.fromCharCode.apply(null, t);
                        return (0, r.NL)(n);
                    });
                }
            },
            6332: function() {},
            3154: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return a;
                    }
                });
                var r = n(3193), o = n(7987), i = n(7594);
                function a(e1, t) {
                    t = (0, r.d9)(t);
                    var n = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: {
                            name: "SHA-256"
                        }
                    };
                    return delete t.use, i.KP.subtle.importKey("jwk", t, n, !0, [
                        "verify"
                    ]).then(function(t) {
                        var r = e1.split("."), a = (0, o.k8)(r[0] + "." + r[1]), u = (0, o.EL)(r[2]), c = (0, o.k8)(u);
                        return i.KP.subtle.verify(n, t, c, a);
                    });
                }
            },
            1: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    KP: function() {
                        return r.KP;
                    },
                    r3: function() {
                        return r.r3;
                    },
                    ty: function() {
                        return r.ty;
                    }
                });
                var r = n(7594);
            },
            3983: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t, n) {
                        var r;
                        (0, o.Z)(this, l);
                        var a = e1.errorSummary;
                        return r = f.call(this, a), (0, s.Z)((0, i.Z)(r), "errorSummary", void 0), (0, s.Z)((0, i.Z)(r), "errorCode", void 0), (0, s.Z)((0, i.Z)(r), "errorLink", void 0), (0, s.Z)((0, i.Z)(r), "errorId", void 0), (0, s.Z)((0, i.Z)(r), "errorCauses", void 0), (0, s.Z)((0, i.Z)(r), "xhr", void 0), (0, s.Z)((0, i.Z)(r), "meta", void 0), r.name = "AuthApiError", r.errorSummary = e1.errorSummary, r.errorCode = e1.errorCode, r.errorLink = e1.errorLink, r.errorId = e1.errorId, r.errorCauses = e1.errorCauses, t && (r.xhr = t), n && (r.meta = n), r;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            6573: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return c;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120);
                var c = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.call(this, "The poll was stopped by the sdk");
                    }
                    return (0, r.Z)(s);
                }(n(6245).Z);
            },
            9123: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, o.Z)(this, l), n = f.call(this, e1), (0, s.Z)((0, i.Z)(n), "errorSummary", void 0), (0, s.Z)((0, i.Z)(n), "errorCode", void 0), (0, s.Z)((0, i.Z)(n), "errorLink", void 0), (0, s.Z)((0, i.Z)(n), "errorId", void 0), (0, s.Z)((0, i.Z)(n), "errorCauses", void 0), (0, s.Z)((0, i.Z)(n), "xhr", void 0), n.name = "AuthSdkError", n.errorCode = "INTERNAL", n.errorSummary = e1, n.errorLink = "INTERNAL", n.errorId = "INTERNAL", n.errorCauses = [], t && (n.xhr = t), n;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            6245: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return p;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(9611);
                function f() {
                    try {
                        var e1 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e1) {}
                    return (f = function() {
                        return !!e1;
                    })();
                }
                function l(e1) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return l = function(e1) {
                        if (null === e1 || !function(e1) {
                            try {
                                return -1 !== Function.toString.call(e1).indexOf("[native code]");
                            } catch (t) {
                                return "function" == typeof e1;
                            }
                        }(e1)) return e1;
                        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e1)) return t.get(e1);
                            t.set(e1, n);
                        }
                        function n() {
                            return function(e1, t, n) {
                                if (f()) return Reflect.construct.apply(null, arguments);
                                var r = [
                                    null
                                ];
                                r.push.apply(r, t);
                                var o = new (e1.bind.apply(e1, r));
                                return n && (0, s.Z)(o, n.prototype), o;
                            }(e1, arguments, (0, c.Z)(this).constructor);
                        }
                        return n.prototype = Object.create(e1.prototype, {
                            constructor: {
                                value: n,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), (0, s.Z)(n, e1);
                    }, l(e1);
                }
                var p = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f(e1) {
                        var t;
                        return (0, o.Z)(this, f), t = s.call(this, e1), Object.setPrototypeOf((0, i.Z)(t), (this instanceof f ? this.constructor : void 0).prototype), t;
                    }
                    return (0, r.Z)(f);
                }(l(Error));
            },
            2886: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t, n) {
                        var r;
                        return (0, o.Z)(this, l), r = f.call(this, t), (0, s.Z)((0, i.Z)(r), "errorCode", void 0), (0, s.Z)((0, i.Z)(r), "errorSummary", void 0), (0, s.Z)((0, i.Z)(r), "error", void 0), (0, s.Z)((0, i.Z)(r), "error_description", void 0), (0, s.Z)((0, i.Z)(r), "resp", null), r.name = "OAuthError", r.errorCode = e1, r.errorSummary = t, r.error = e1, r.error_description = t, n && (r.resp = n), r;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            3114: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(6245), l = n(4771);
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p(e1, t, n) {
                        var o, a;
                        return (0, r.Z)(this, p), a = f.call(this, null !== (o = t.error) && void 0 !== o ? o : p.UNKNOWN_ERROR), (0, s.Z)((0, i.Z)(a), "scheme", void 0), (0, s.Z)((0, i.Z)(a), "parameters", void 0), (0, s.Z)((0, i.Z)(a), "name", "WWWAuthError"), (0, s.Z)((0, i.Z)(a), "resp", null), a.scheme = e1, a.parameters = t, n && (a.resp = n), a;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "error",
                            get: function() {
                                return this.parameters.error;
                            }
                        },
                        {
                            key: "errorCode",
                            get: function() {
                                return this.error;
                            }
                        },
                        {
                            key: "error_description",
                            get: function() {
                                return this.parameters.error_description;
                            }
                        },
                        {
                            key: "errorDescription",
                            get: function() {
                                return this.error_description;
                            }
                        },
                        {
                            key: "errorSummary",
                            get: function() {
                                return this.errorDescription;
                            }
                        },
                        {
                            key: "realm",
                            get: function() {
                                return this.parameters.realm;
                            }
                        }
                    ], [
                        {
                            key: "parseHeader",
                            value: function(e1) {
                                if (!e1) return null;
                                for(var t, n = /(?:,|, )?([a-zA-Z0-9!#$%&'*+\-.^_`|~]+)=(?:"([a-zA-Z0-9!#$%&'*+\-.,^_`|~ /:]+)"|([a-zA-Z0-9!#$%&'*+\-.^_`|~/:]+))/g, r = e1.indexOf(" "), o = e1.slice(0, r), i = e1.slice(r + 1), a = {}; null !== (t = n.exec(i));){
                                    var u;
                                    a[t[1]] = null !== (u = t[2]) && void 0 !== u ? u : t[3];
                                }
                                return new p(o, a);
                            }
                        },
                        {
                            key: "getWWWAuthenticateHeader",
                            value: function() {
                                var e1, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                return (0, l.mf)(null == t ? void 0 : t.get) ? t.get("WWW-Authenticate") : null !== (e1 = t["www-authenticate"]) && void 0 !== e1 ? e1 : t["WWW-Authenticate"];
                            }
                        }
                    ]), p;
                }(f.Z);
                (0, s.Z)(p, "UNKNOWN_ERROR", "UNKNOWN_WWW_AUTH_ERROR");
            },
            5728: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    AuthApiError: function() {
                        return r.Z;
                    },
                    AuthPollStopError: function() {
                        return o.Z;
                    },
                    AuthSdkError: function() {
                        return i.Z;
                    },
                    OAuthError: function() {
                        return a.Z;
                    },
                    WWWAuthError: function() {
                        return u.Z;
                    },
                    isAuthApiError: function() {
                        return l;
                    },
                    isOAuthError: function() {
                        return p;
                    },
                    isWWWAuthError: function() {
                        return d;
                    }
                });
                var r = n(3983), o = n(6573), i = n(9123), a = n(2886), u = n(3114), c = n(1243), s = {};
                for(var f in c)[
                    "default",
                    "isAuthApiError",
                    "isOAuthError",
                    "isWWWAuthError",
                    "AuthApiError",
                    "AuthPollStopError",
                    "AuthSdkError",
                    "OAuthError",
                    "WWWAuthError"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                function l(e1) {
                    return e1 instanceof r.Z;
                }
                function p(e1) {
                    return e1 instanceof a.Z;
                }
                function d(e1) {
                    return e1 instanceof u.Z;
                }
                n.d(t, s);
            },
            1243: function() {},
            6736: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    ACCESS_TOKEN_STORAGE_KEY: function() {
                        return i.ACCESS_TOKEN_STORAGE_KEY;
                    },
                    BaseStorageManager: function() {
                        return d.W8;
                    },
                    CACHE_STORAGE_NAME: function() {
                        return i.CACHE_STORAGE_NAME;
                    },
                    DEFAULT_CACHE_DURATION: function() {
                        return i.DEFAULT_CACHE_DURATION;
                    },
                    DEFAULT_CODE_CHALLENGE_METHOD: function() {
                        return i.DEFAULT_CODE_CHALLENGE_METHOD;
                    },
                    DEFAULT_MAX_CLOCK_SKEW: function() {
                        return i.DEFAULT_MAX_CLOCK_SKEW;
                    },
                    DEFAULT_POLLING_DELAY: function() {
                        return i.DEFAULT_POLLING_DELAY;
                    },
                    IDX_API_VERSION: function() {
                        return i.IDX_API_VERSION;
                    },
                    IDX_RESPONSE_STORAGE_NAME: function() {
                        return i.IDX_RESPONSE_STORAGE_NAME;
                    },
                    ID_TOKEN_STORAGE_KEY: function() {
                        return i.ID_TOKEN_STORAGE_KEY;
                    },
                    IOS_MAX_RETRY_COUNT: function() {
                        return i.IOS_MAX_RETRY_COUNT;
                    },
                    MAX_VERIFIER_LENGTH: function() {
                        return i.MAX_VERIFIER_LENGTH;
                    },
                    MIN_VERIFIER_LENGTH: function() {
                        return i.MIN_VERIFIER_LENGTH;
                    },
                    ORIGINAL_URI_STORAGE_NAME: function() {
                        return i.ORIGINAL_URI_STORAGE_NAME;
                    },
                    OktaUserAgent: function() {
                        return f.ed;
                    },
                    PKCE_STORAGE_NAME: function() {
                        return i.PKCE_STORAGE_NAME;
                    },
                    PromiseQueue: function() {
                        return h.bo;
                    },
                    REFERRER_PATH_STORAGE_KEY: function() {
                        return i.REFERRER_PATH_STORAGE_KEY;
                    },
                    REFRESH_TOKEN_STORAGE_KEY: function() {
                        return i.REFRESH_TOKEN_STORAGE_KEY;
                    },
                    SHARED_TRANSACTION_STORAGE_NAME: function() {
                        return i.SHARED_TRANSACTION_STORAGE_NAME;
                    },
                    STATE_TOKEN_KEY_NAME: function() {
                        return i.STATE_TOKEN_KEY_NAME;
                    },
                    SavedObject: function() {
                        return d._e;
                    },
                    TOKEN_STORAGE_NAME: function() {
                        return i.TOKEN_STORAGE_NAME;
                    },
                    TRANSACTION_STORAGE_NAME: function() {
                        return i.TRANSACTION_STORAGE_NAME;
                    },
                    bind: function() {
                        return h.ak;
                    },
                    clone: function() {
                        return h.d9;
                    },
                    closeSession: function() {
                        return p.RJ;
                    },
                    createBaseOptionsConstructor: function() {
                        return o.X;
                    },
                    createHttpOptionsConstructor: function() {
                        return f.ZM;
                    },
                    createOktaAuthBase: function() {
                        return o.a;
                    },
                    createSessionApi: function() {
                        return p.MG;
                    },
                    createStorageOptionsConstructor: function() {
                        return d.Tp;
                    },
                    crypto: function() {
                        return r;
                    },
                    delay: function() {
                        return h.gw;
                    },
                    deprecate: function() {
                        return h.Rn;
                    },
                    deprecateWrap: function() {
                        return h.VA;
                    },
                    extend: function() {
                        return h.l7;
                    },
                    find: function() {
                        return h.sE;
                    },
                    genRandomString: function() {
                        return h.uh;
                    },
                    get: function() {
                        return f.U2;
                    },
                    getConsole: function() {
                        return h.dr;
                    },
                    getLink: function() {
                        return h.Rg;
                    },
                    getNativeConsole: function() {
                        return h.sW;
                    },
                    getSession: function() {
                        return p.Gg;
                    },
                    httpRequest: function() {
                        return f.c3;
                    },
                    isAbsoluteUrl: function() {
                        return h.sD;
                    },
                    isFunction: function() {
                        return h.mf;
                    },
                    isNumber: function() {
                        return h.hj;
                    },
                    isObject: function() {
                        return h.Kn;
                    },
                    isPromise: function() {
                        return h.tI;
                    },
                    isString: function() {
                        return h.HD;
                    },
                    isoToUTCString: function() {
                        return h.ng;
                    },
                    logServerSideMemoryStorageWarning: function() {
                        return d.Vp;
                    },
                    mixinHttp: function() {
                        return f.Am;
                    },
                    mixinSession: function() {
                        return p.Zg;
                    },
                    mixinStorage: function() {
                        return d.Ho;
                    },
                    omit: function() {
                        return h.CE;
                    },
                    post: function() {
                        return f.v_;
                    },
                    refreshSession: function() {
                        return p.dx;
                    },
                    removeNils: function() {
                        return h.YY;
                    },
                    removeTrailingSlash: function() {
                        return h.Qj;
                    },
                    sessionExists: function() {
                        return p.sH;
                    },
                    setCookieAndRedirect: function() {
                        return p.OT;
                    },
                    setRequestHeader: function() {
                        return f.rn;
                    },
                    split2: function() {
                        return h.YQ;
                    },
                    toAbsoluteUrl: function() {
                        return h.BY;
                    },
                    toQueryString: function() {
                        return h.UK;
                    },
                    toRelativeUrl: function() {
                        return h.QN;
                    },
                    warn: function() {
                        return h.ZK;
                    }
                });
                var r = n(9718), o = n(3306), i = n(1971), a = n(3961), u = {};
                for(var c in a)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "IOS_MAX_RETRY_COUNT",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return a[e1];
                }).bind(0, c));
                n.d(t, u);
                var s = n(5728);
                for(var c in u = {}, s)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "IOS_MAX_RETRY_COUNT",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "ServiceManager",
                    "createCoreOptionsConstructor",
                    "createCoreStorageManager",
                    "createOktaAuthCore",
                    "mixinCore"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return s[e1];
                }).bind(0, c));
                n.d(t, u);
                var f = n(4777), l = n(9443);
                for(var c in u = {}, l)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "IOS_MAX_RETRY_COUNT",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "ServiceManager",
                    "createCoreOptionsConstructor",
                    "createCoreStorageManager",
                    "createOktaAuthCore",
                    "mixinCore",
                    "AuthApiError",
                    "AuthPollStopError",
                    "AuthSdkError",
                    "OAuthError",
                    "WWWAuthError",
                    "isAuthApiError",
                    "isOAuthError",
                    "isWWWAuthError",
                    "OktaUserAgent",
                    "createHttpOptionsConstructor",
                    "get",
                    "httpRequest",
                    "mixinHttp",
                    "post",
                    "setRequestHeader"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return l[e1];
                }).bind(0, c));
                n.d(t, u);
                var p = n(8041), d = n(9927), h = n(305);
            },
            415: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    getUserAgent: function() {
                        return u;
                    },
                    hasTextEncoder: function() {
                        return p;
                    },
                    isBrowser: function() {
                        return i;
                    },
                    isDPoPSupported: function() {
                        return y;
                    },
                    isFingerprintSupported: function() {
                        return c;
                    },
                    isHTTPS: function() {
                        return h;
                    },
                    isIE11OrLess: function() {
                        return a;
                    },
                    isIOS: function() {
                        return g;
                    },
                    isLocalhost: function() {
                        return v;
                    },
                    isPKCESupported: function() {
                        return d;
                    },
                    isPopupPostMessageSupported: function() {
                        return s;
                    },
                    isTokenVerifySupported: function() {
                        return l;
                    }
                });
                var r = n(7594), o = /windows phone|iemobile|wpdesktop/i;
                function i() {
                    return "undefined" != typeof document && "undefined" != typeof window;
                }
                function a() {
                    if (!i()) return !1;
                    var e1 = document.documentMode;
                    return !!e1 && e1 <= 11;
                }
                function u() {
                    return navigator.userAgent;
                }
                function c() {
                    var e1 = u();
                    return e1 && !o.test(e1);
                }
                function s() {
                    if (!i()) return !1;
                    var e1 = document.documentMode, t = e1 && e1 < 10;
                    return void 0 !== window.postMessage && !t;
                }
                function f() {
                    return void 0 !== r.KP && null !== r.KP && void 0 !== r.KP.subtle && "undefined" != typeof Uint8Array;
                }
                function l() {
                    return f();
                }
                function p() {
                    return "undefined" != typeof TextEncoder;
                }
                function d() {
                    return l() && p();
                }
                function h() {
                    return !!i() && "https:" === window.location.protocol;
                }
                function v() {
                    return i() && "localhost" === window.location.hostname;
                }
                function y() {
                    return !a() && void 0 !== window.indexedDB && p() && f();
                }
                function g() {
                    return i() && "undefined" != typeof navigator && void 0 !== navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                }
            },
            287: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    e: function() {
                        return u;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(415), u = function() {
                    function e1() {
                        (0, r.Z)(this, e1), (0, i.Z)(this, "environments", void 0), this.environments = [
                            "okta-auth-js/".concat("7.14.5")
                        ], this.maybeAddNodeEnvironment();
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "addEnvironment",
                            value: function(e1) {
                                this.environments.push(e1);
                            }
                        },
                        {
                            key: "getHttpHeader",
                            value: function() {
                                return {
                                    "X-Okta-User-Agent-Extended": this.environments.join(" ")
                                };
                            }
                        },
                        {
                            key: "getVersion",
                            value: function() {
                                return "7.14.5";
                            }
                        },
                        {
                            key: "maybeAddNodeEnvironment",
                            value: function() {
                                if (!(0, a.isBrowser)() && $375d8335527bcde6$exports && $375d8335527bcde6$exports.versions) {
                                    var e1 = $375d8335527bcde6$exports.versions.node;
                                    this.environments.push("nodejs/".concat(e1));
                                }
                            }
                        }
                    ]), e1;
                }();
            },
            2281: function(e1, t, n) {
                "use strict";
                function r(e1, t, n) {
                    e1.options.headers = e1.options.headers || {}, e1.options.headers[t] = n;
                }
                n.d(t, {
                    r: function() {
                        return r;
                    }
                });
            },
            4777: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Am: function() {
                        return a.A;
                    },
                    U2: function() {
                        return i.U2;
                    },
                    ZM: function() {
                        return u.Z;
                    },
                    c3: function() {
                        return i.c3;
                    },
                    ed: function() {
                        return o.e;
                    },
                    rn: function() {
                        return r.r;
                    },
                    v_: function() {
                        return i.v_;
                    }
                });
                var r = n(2281), o = n(287), i = n(5385), a = n(279), u = n(8817);
            },
            279: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    A: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(287), l = n(2281), p = n(6718), d = n(5385);
                function h(e1) {
                    return function(e1) {
                        (0, a.Z)(v, e1);
                        var t, n, h = (t = v, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function v() {
                            var e1;
                            (0, r.Z)(this, v);
                            for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                            return e1 = h.call.apply(h, [
                                this
                            ].concat(n)), (0, s.Z)((0, i.Z)(e1), "_oktaUserAgent", void 0), (0, s.Z)((0, i.Z)(e1), "http", void 0), e1._oktaUserAgent = new f.e, e1.http = {
                                setRequestHeader: l.r.bind(null, (0, i.Z)(e1))
                            }, e1;
                        }
                        return (0, o.Z)(v, [
                            {
                                key: "setHeaders",
                                value: function(e1) {
                                    this.options.headers = Object.assign({}, this.options.headers, e1);
                                }
                            },
                            {
                                key: "getIssuerOrigin",
                                value: function() {
                                    return this.options.issuer.split("/oauth2/")[0];
                                }
                            },
                            {
                                key: "webfinger",
                                value: function(e1) {
                                    var t = "/.well-known/webfinger" + (0, p.UK)(e1);
                                    return (0, d.U2)(this, t, {
                                        headers: {
                                            Accept: "application/jrd+json"
                                        }
                                    });
                                }
                            }
                        ]), v;
                    }(e1);
                }
            },
            8817: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return m;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(3849), l = n(885), p = n(1002), d = n(4098), h = n.n(d);
                function v(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var y = /application\/\w*\+?json/, g = function(e1, t, r) {
                    var o = r.data, i = r.headers || {}, a = i["Content-Type"] || i["content-type"] || "";
                    o && "string" != typeof o && (y.test(a) ? o = JSON.stringify(o) : "application/x-www-form-urlencoded" === a && (o = Object.entries(o).map(function(e1) {
                        var t = (0, l.Z)(e1, 2), n = t[0], r = t[1];
                        return "".concat(n, "=").concat(encodeURIComponent(r));
                    }).join("&")));
                    var u = (n.g.fetch || h())(t, {
                        method: e1,
                        headers: r.headers,
                        body: o,
                        credentials: r.withCredentials ? "include" : "omit"
                    });
                    return u.finally || (u = Promise.resolve(u)), u.then(function(e1) {
                        var t = !e1.ok, n = e1.status;
                        return (function(e1) {
                            return e1.headers.get("Content-Type") && e1.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? e1.json().catch(function(e1) {
                                return {
                                    error: e1,
                                    errorSummary: "Could not parse server response"
                                };
                            }) : e1.text();
                        })(e1).then(function(t) {
                            return function(e1, t, n) {
                                var r, o = "object" === (0, p.Z)(t), i = {}, a = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return v(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? v(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }(n.headers.entries());
                                try {
                                    for(a.s(); !(r = a.n()).done;){
                                        var u = r.value;
                                        i[u[0]] = u[1];
                                    }
                                } catch (e1) {
                                    a.e(e1);
                                } finally{
                                    a.f();
                                }
                                var c = {
                                    responseText: o ? JSON.stringify(t) : t,
                                    status: e1,
                                    headers: i
                                };
                                return o && (c.responseType = "json", c.responseJSON = t), c;
                            }(n, t, e1);
                        }).then(function(e1) {
                            var n;
                            if (t || null !== (n = e1.responseJSON) && void 0 !== n && n.error) throw e1;
                            return e1;
                        });
                    });
                };
                function m() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "transformErrorXHR", void 0), (0, s.Z)((0, i.Z)(t), "headers", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestClient", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestInterceptors", void 0), (0, s.Z)((0, i.Z)(t), "pollDelay", void 0), t.issuer = e1.issuer, t.transformErrorXHR = e1.transformErrorXHR, t.headers = e1.headers, t.httpRequestClient = e1.httpRequestClient || g, t.httpRequestInterceptors = e1.httpRequestInterceptors, t.pollDelay = e1.pollDelay, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.T)());
                }
            },
            5385: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U2: function() {
                        return k;
                    },
                    c3: function() {
                        return b;
                    },
                    v_: function() {
                        return w;
                    }
                });
                var r = n(1002), o = n(4942), i = n(4771), a = n(3193), u = n(6718), c = n(1971), s = n(3983), f = n(3114), l = n(2886), p = n(415);
                function d(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var y, g = 0;
                (0, p.isBrowser)() && (g = Date.now(), y = function() {
                    document.hidden || (g = Date.now());
                }, document.addEventListener("visibilitychange", y));
                var m = function(e1, t) {
                    var n, r, o, u;
                    if (t instanceof Error) return new s.Z({
                        errorSummary: t.message
                    });
                    var c, p = t, d = {};
                    if (p.responseText && (0, i.HD)(p.responseText)) try {
                        d = JSON.parse(p.responseText);
                    } catch (e1) {
                        d = {
                            errorSummary: "Unknown error"
                        };
                    }
                    p.status >= 500 && (d.errorSummary = "Unknown error"), e1.options.transformErrorXHR && (p = e1.options.transformErrorXHR((0, a.d9)(p)));
                    var h = null !== (n = f.Z.getWWWAuthenticateHeader(null === (r = p) || void 0 === r ? void 0 : r.headers)) && void 0 !== n ? n : "";
                    if (c = d.error && d.error_description ? new l.Z(d.error, d.error_description, p) : new s.Z(d, p, {
                        wwwAuthHeader: h
                    }), h && (null === (o = p) || void 0 === o ? void 0 : o.status) >= 400 && (null === (u = p) || void 0 === u ? void 0 : u.status) < 500) {
                        var y = f.Z.parseHeader(h);
                        if (403 === p.status && "insufficient_authentication_context" === (null == y ? void 0 : y.error)) {
                            var g = y.parameters, m = g.max_age, b = g.acr_values;
                            c = new s.Z({
                                errorSummary: y.error,
                                errorCauses: [
                                    {
                                        errorSummary: y.errorDescription
                                    }
                                ]
                            }, p, v({
                                max_age: +m
                            }, b && {
                                acr_values: b
                            }));
                        } else "DPoP" === (null == y ? void 0 : y.scheme) && (c = y);
                    }
                    return c;
                };
                function b(e1, t) {
                    var n;
                    if (t = t || {}, e1.options.httpRequestInterceptors) {
                        var o, u = function(e1, t) {
                            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                            if (!n) {
                                if (Array.isArray(e1) || (n = function(e1, t) {
                                    if (e1) {
                                        if ("string" == typeof e1) return d(e1, t);
                                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? d(e1, t) : void 0;
                                    }
                                }(e1)) || t && e1 && "number" == typeof e1.length) {
                                    n && (e1 = n);
                                    var r = 0, o = function() {};
                                    return {
                                        s: o,
                                        n: function() {
                                            return r >= e1.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: e1[r++]
                                            };
                                        },
                                        e: function(e1) {
                                            throw e1;
                                        },
                                        f: o
                                    };
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }
                            var i, a = !0, u = !1;
                            return {
                                s: function() {
                                    n = n.call(e1);
                                },
                                n: function() {
                                    var e1 = n.next();
                                    return a = e1.done, e1;
                                },
                                e: function(e1) {
                                    u = !0, i = e1;
                                },
                                f: function() {
                                    try {
                                        a || null == n.return || n.return();
                                    } finally{
                                        if (u) throw i;
                                    }
                                }
                            };
                        }(e1.options.httpRequestInterceptors);
                        try {
                            for(u.s(); !(o = u.n()).done;)(0, o.value)(t);
                        } catch (P) {
                            u.e(P);
                        } finally{
                            u.f();
                        }
                    }
                    var s = t.url, f = t.method, l = t.args, h = t.saveAuthnState, y = t.accessToken, b = !0 === t.withCredentials, k = e1.options.storageUtil.storage, w = e1.storageManager.getHttpCache(e1.options.cookies), O = t.pollingIntent, Z = null !== (n = e1.options.pollDelay) && void 0 !== n ? n : 0;
                    if (t.cacheResponse) {
                        var T = w.getStorage()[s];
                        if (T && Date.now() / 1e3 < T.expiresAt) return Promise.resolve(T.response);
                    }
                    var E = v({
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }, e1._oktaUserAgent.getHttpHeader());
                    Object.assign(E, e1.options.headers, t.headers), E = (0, a.YY)(E), y && (0, i.HD)(y) && (E.Authorization = "Bearer " + y);
                    var P, S, x, A = {
                        headers: E,
                        data: l || void 0,
                        withCredentials: b
                    };
                    if (O && (0, p.isBrowser)() && Z > 0) {
                        var R, _, j, C = 0;
                        _ = function() {
                            var e1 = Date.now() - g;
                            return e1 < Z ? new Promise(function(t) {
                                return setTimeout(function() {
                                    document.hidden ? t(R()) : t();
                                }, Z - e1);
                            }) : Promise.resolve();
                        }, R = function() {
                            var e1;
                            return document.hidden ? new Promise(function(t) {
                                e1 = function() {
                                    document.hidden || (document.removeEventListener("visibilitychange", e1), t(_()));
                                }, document.addEventListener("visibilitychange", e1);
                            }) : _();
                        };
                        var I = function() {
                            return e1.options.httpRequestClient(f, s, A).catch(function(e1) {
                                if ("Load failed" === (null == e1 ? void 0 : e1.message) && C < c.IOS_MAX_RETRY_COUNT) return C++, j();
                                throw e1;
                            });
                        };
                        x = (j = function() {
                            return R().then(I);
                        })();
                    } else x = e1.options.httpRequestClient(f, s, A);
                    return x.then(function(n) {
                        return (S = n.responseText) && (0, i.HD)(S) && (S = JSON.parse(S)) && "object" === (0, r.Z)(S) && !S.headers && (Array.isArray(S) ? S.forEach(function(e1) {
                            e1.headers = n.headers;
                        }) : S.headers = n.headers), h && (S.stateToken || k.delete(c.STATE_TOKEN_KEY_NAME)), S && S.stateToken && S.expiresAt && k.set(c.STATE_TOKEN_KEY_NAME, S.stateToken, S.expiresAt, e1.options.cookies), S && t.cacheResponse && w.updateStorage(s, {
                            expiresAt: Math.floor(Date.now() / 1e3) + c.DEFAULT_CACHE_DURATION,
                            response: S
                        }), S;
                    }).catch(function(t) {
                        throw "E0000011" === (P = m(e1, t)).errorCode && k.delete(c.STATE_TOKEN_KEY_NAME), P;
                    });
                }
                function k(e1, t, n) {
                    var r = {
                        url: t = (0, u.sD)(t) ? t : e1.getIssuerOrigin() + t,
                        method: "GET"
                    };
                    return Object.assign(r, n), b(e1, r);
                }
                function w(e1, t, n, r) {
                    var o = {
                        url: t = (0, u.sD)(t) ? t : e1.getIssuerOrigin() + t,
                        method: "POST",
                        args: n,
                        saveAuthnState: !0
                    };
                    return Object.assign(o, r), b(e1, o);
                }
            },
            3334: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    v: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(1646), f = n(480);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, s = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            return (0, r.Z)(this, l), s.call(this, e1);
                        }
                        return (0, o.Z)(l, [
                            {
                                key: "clear",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    (0, i.Z)((0, c.Z)(l.prototype), "clear", this).call(this, e1), !1 !== e1.clearIdxResponse && this.clearIdxResponse();
                                }
                            },
                            {
                                key: "saveIdxResponse",
                                value: function(e1) {
                                    if (this.saveLastResponse) {
                                        var t = this.storageManager.getIdxResponseStorage();
                                        t && t.setStorage(e1);
                                    }
                                }
                            },
                            {
                                key: "loadIdxResponse",
                                value: function(e1) {
                                    if (!this.saveLastResponse) return null;
                                    var t = this.storageManager.getIdxResponseStorage();
                                    if (!t) return null;
                                    var n = t.getStorage();
                                    if (!n || !(0, f.P)(n.rawIdxResponse)) return null;
                                    if (e1) {
                                        var r = e1.stateHandle, o = e1.interactionHandle;
                                        if (!e1.useGenericRemediator && r && n.stateHandle !== r) return null;
                                        if (o && n.interactionHandle !== o) return null;
                                    }
                                    return n;
                                }
                            },
                            {
                                key: "clearIdxResponse",
                                value: function() {
                                    if (this.saveLastResponse) {
                                        var e1 = this.storageManager.getIdxResponseStorage();
                                        null == e1 || e1.clearStorage();
                                    }
                                }
                            }
                        ]), l;
                    }((0, s.P)());
                }
            },
            1286: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(7595), c = n(3377);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, o.Z)(a().mark(function e1(t) {
                        var n, r = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return (n = r.length > 1 && void 0 !== r[1] ? r[1] : {}).password && !n.authenticator && (n.authenticator = u.pc.OKTA_PASSWORD), e1.abrupt("return", (0, c.K)(t, f(f({}, n), {}, {
                                        flow: "authenticate"
                                    })));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            7644: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _: function() {
                        return a;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942), a = (0, r.Z)(function e1(t) {
                    (0, o.Z)(this, e1), (0, i.Z)(this, "meta", void 0), this.meta = t;
                });
            },
            9582: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5671), i = n(3144), a = n(136), u = n(2963), c = n(1120);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var l = function(e1) {
                    (0, a.Z)(s, e1);
                    var t, n, r = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), r.apply(this, arguments);
                    }
                    return (0, i.Z)(s, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                return !!(e1.credentials || e1.password || e1.passcode);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.password, r = e1.passcode, o = e1.revokeSessions;
                                if (t || n || r) return t || {
                                    passcode: r || n,
                                    revokeSessions: o
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function(e1) {
                                var t, n, r = [
                                    f(f({}, null === (t = e1.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                                        name: "password",
                                        type: "string",
                                        required: e1.required
                                    })
                                ];
                                return (null === (n = e1.form) || void 0 === n ? void 0 : n.value.find(function(e1) {
                                    return "revokeSessions" === e1.name;
                                })) && r.push({
                                    name: "revokeSessions",
                                    type: "boolean",
                                    label: "Sign me out of all other devices",
                                    required: !1
                                }), r;
                            }
                        }
                    ]), s;
                }(n(7644)._);
            },
            9344: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    LL: function() {
                        return i;
                    },
                    PN: function() {
                        return a;
                    },
                    h_: function() {
                        return u;
                    }
                });
                var r = n(7595);
                function o(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function i(e1) {
                    var t;
                    if ((0, r.H)(e1)) t = e1;
                    else {
                        if ("string" != typeof e1) throw new Error("Invalid format for authenticator");
                        t = {
                            key: e1
                        };
                    }
                    return t;
                }
                function a(e1, t) {
                    return !!(e1 && t && (e1.id && t.id ? e1.id === t.id : e1.key && t.key && e1.key === t.key));
                }
                function u(e1, t) {
                    var n, r, i = function(e1, t) {
                        var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (!n) {
                            if (Array.isArray(e1) || (n = function(e1, t) {
                                if (e1) {
                                    if ("string" == typeof e1) return o(e1, t);
                                    var n = Object.prototype.toString.call(e1).slice(8, -1);
                                    return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(e1, t) : void 0;
                                }
                            }(e1)) || t && e1 && "number" == typeof e1.length) {
                                n && (e1 = n);
                                var r = 0, i = function() {};
                                return {
                                    s: i,
                                    n: function() {
                                        return r >= e1.length ? {
                                            done: !0
                                        } : {
                                            done: !1,
                                            value: e1[r++]
                                        };
                                    },
                                    e: function(e1) {
                                        throw e1;
                                    },
                                    f: i
                                };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var a, u = !0, c = !1;
                        return {
                            s: function() {
                                n = n.call(e1);
                            },
                            n: function() {
                                var e1 = n.next();
                                return u = e1.done, e1;
                            },
                            e: function(e1) {
                                c = !0, a = e1;
                            },
                            f: function() {
                                try {
                                    u || null == n.return || n.return();
                                } finally{
                                    if (c) throw a;
                                }
                            }
                        };
                    }(e1);
                    try {
                        var a = function() {
                            var e1 = r.value;
                            if (n = t.find(function(t) {
                                var n = t.relatesTo;
                                return n.key && n.key === e1.key;
                            })) return "break";
                        };
                        for(i.s(); !(r = i.n()).done && "break" !== a(););
                    } catch (e1) {
                        i.e(e1);
                    } finally{
                        i.f();
                    }
                    return n;
                }
            },
            9192: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(7738);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return (p = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = t.transactionManager.load(), o = (0, c.s)(t, r.flow), e1.abrupt("return", (0, u.K)(t, f(f(f({}, n), o), {}, {
                                        actions: [
                                            "cancel"
                                        ]
                                    })));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            7985: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    GA: function() {
                        return g;
                    },
                    Jn: function() {
                        return b;
                    },
                    gc: function() {
                        return y;
                    },
                    mo: function() {
                        return m;
                    }
                });
                var r = n(5861), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(6245), h = n(1969);
                var v = function(e1) {
                    (0, u.Z)(l, e1);
                    var t, n, r = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, i.Z)(this, l), n = r.call(this, "Enter the OTP code in the originating client: ".concat(t)), (0, f.Z)((0, a.Z)(n), "state", void 0), (0, f.Z)((0, a.Z)(n), "otp", void 0), n.name = "EmailVerifyCallbackError", n.state = e1, n.otp = t, n;
                    }
                    return (0, o.Z)(l);
                }(d.Z);
                function y(e1) {
                    return "EmailVerifyCallbackError" === e1.name;
                }
                function g(e1) {
                    return /(otp=)/i.test(e1) && /(state=)/i.test(e1);
                }
                function m(e1) {
                    return (0, h.v)(e1);
                }
                function b(e1, t) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, r.Z)(p().mark(function e1(t, n) {
                        var r, o, i;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!g(n)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    if (r = m(n), o = r.state, i = r.otp, !t.idx.canProceed({
                                        state: o
                                    })) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 5, t.idx.proceed({
                                        state: o,
                                        otp: i
                                    });
                                case 5:
                                    return e1.abrupt("return", e1.sent);
                                case 8:
                                    throw new v(o, i);
                                case 9:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2144: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return i;
                    }
                });
                var r = n(1578), o = n(8137);
                function i(e1, t, n) {
                    var i = (0, r.K)(e1, t, n);
                    return (0, o.B)(i);
                }
            },
            8717: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    F: function() {
                        return F;
                    }
                });
                var r = {};
                n.r(r), n.d(r, {
                    AuthenticatorEnrollmentData: function() {
                        return U.q;
                    },
                    AuthenticatorVerificationData: function() {
                        return N.q;
                    },
                    ChallengeAuthenticator: function() {
                        return E.J;
                    },
                    ChallengePoll: function() {
                        return P.U;
                    },
                    EnrollAuthenticator: function() {
                        return w.q;
                    },
                    EnrollPoll: function() {
                        return O.T;
                    },
                    EnrollProfile: function() {
                        return x.w;
                    },
                    EnrollmentChannelData: function() {
                        return T.t;
                    },
                    GenericRemediator: function() {
                        return H.P;
                    },
                    Identify: function() {
                        return A.h;
                    },
                    ReEnrollAuthenticator: function() {
                        return R.j;
                    },
                    ReEnrollAuthenticatorWarning: function() {
                        return _.i;
                    },
                    RedirectIdp: function() {
                        return j.O;
                    },
                    Remediator: function() {
                        return k.n;
                    },
                    ResetAuthenticator: function() {
                        return S.G;
                    },
                    SelectAuthenticatorAuthenticate: function() {
                        return C.X;
                    },
                    SelectAuthenticatorEnroll: function() {
                        return I.j;
                    },
                    SelectAuthenticatorUnlockAccount: function() {
                        return D.G;
                    },
                    SelectEnrollProfile: function() {
                        return M.j;
                    },
                    SelectEnrollmentChannel: function() {
                        return Z.V;
                    },
                    Skip: function() {
                        return L.h;
                    }
                });
                var o = n(8221), i = n(9912), a = n(1286), u = n(9192), c = n(7985), s = n(5021), f = n(5923), l = n(6131), p = n(2660), d = n(9310), h = n(2845), v = n(9214), y = n(8826), g = n(2473), m = n(2620), b = n(8277), k = n(3118), w = n(3857), O = n(2288), Z = n(3403), T = n(3679), E = n(4560), P = n(1104), S = n(1019), x = n(7522), A = n(8628), R = n(9024), _ = n(8107), j = n(8490), C = n(7311), I = n(9865), D = n(5272), M = n(4713), N = n(5278), U = n(2541), L = n(8443), H = n(9732), B = n(7738), K = n(5031);
                function F(e1) {
                    (0, K.TC)({
                        remediators: r,
                        getFlowSpecification: B.s
                    });
                    var t = g.Y.bind(null, e1);
                    return {
                        interact: l.E.bind(null, e1),
                        introspect: p.L.bind(null, e1),
                        makeIdxResponse: f._T.bind(null, e1),
                        authenticate: a.Y.bind(null, e1),
                        register: y.z.bind(null, e1),
                        start: t,
                        startTransaction: t,
                        poll: d.$.bind(null, e1),
                        proceed: h.x.bind(null, e1),
                        cancel: u.a.bind(null, e1),
                        recoverPassword: v.M.bind(null, e1),
                        handleInteractionCodeRedirect: s.X.bind(null, e1),
                        isInteractionRequired: o.wc.bind(null, e1),
                        isInteractionRequiredError: i.Cf,
                        handleEmailVerifyCallback: c.Jn.bind(null, e1),
                        isEmailVerifyCallback: c.GA,
                        parseEmailVerifyCallback: c.mo,
                        isEmailVerifyCallbackError: c.gc,
                        getSavedTransactionMeta: m.uN.bind(null, e1),
                        createTransactionMeta: m.Xc.bind(null, e1),
                        getTransactionMeta: m.Co.bind(null, e1),
                        saveTransactionMeta: m.r0.bind(null, e1),
                        clearTransactionMeta: m.Jm.bind(null, e1),
                        isTransactionMetaValid: m.Wf,
                        setFlow: function(t) {
                            e1.options.flow = t;
                        },
                        getFlow: function() {
                            return e1.options.flow;
                        },
                        canProceed: h.C.bind(null, e1),
                        unlockAccount: b.l.bind(null, e1)
                    };
                }
            },
            7738: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    s: function() {
                        return P;
                    }
                });
                var r = n(8628), o = n(7311), i = n(9865), a = n(2541), u = n(5278), c = n(3857), s = n(4560), f = n(1104), l = n(9024), p = n(8107), d = n(2288), h = n(3403), v = n(3679), y = n(8490), g = n(8443), m = {
                    identify: r.h,
                    "select-authenticator-authenticate": o.X,
                    "select-authenticator-enroll": i.j,
                    "authenticator-enrollment-data": a.q,
                    "authenticator-verification-data": u.q,
                    "enroll-authenticator": c.q,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    "reenroll-authenticator": l.j,
                    "reenroll-authenticator-warning": p.i,
                    "enroll-poll": d.T,
                    "select-enrollment-channel": h.V,
                    "enrollment-channel-data": v.t,
                    "redirect-idp": y.O,
                    skip: g.h
                }, b = n(1019), k = {
                    identify: r.h,
                    "identify-recovery": r.h,
                    "select-authenticator-authenticate": o.X,
                    "select-authenticator-enroll": i.j,
                    "challenge-authenticator": s.J,
                    "authenticator-verification-data": u.q,
                    "authenticator-enrollment-data": a.q,
                    "reset-authenticator": b.G,
                    "reenroll-authenticator": l.j,
                    "reenroll-authenticator-warning": p.i,
                    "enroll-poll": d.T
                }, w = n(4713), O = n(7522), Z = {
                    "select-enroll-profile": w.j,
                    "enroll-profile": O.w,
                    "authenticator-enrollment-data": a.q,
                    "select-authenticator-enroll": i.j,
                    "select-authenticator-authenticate": o.X,
                    "enroll-poll": d.T,
                    "select-enrollment-channel": h.V,
                    "enrollment-channel-data": v.t,
                    "enroll-authenticator": c.q,
                    "authenticator-verification-data": u.q,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    skip: g.h
                }, T = n(5272), E = {
                    identify: r.h,
                    "select-authenticator-unlock-account": T.G,
                    "select-authenticator-authenticate": o.X,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    "authenticator-verification-data": u.q,
                    "reenroll-authenticator-warning": p.i
                };
                function P(e1) {
                    var t, n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default", o = !0;
                    switch(r){
                        case "register":
                        case "signup":
                        case "enrollProfile":
                            t = Z, o = !1;
                            break;
                        case "recoverPassword":
                        case "resetPassword":
                            t = k, n = [
                                "currentAuthenticator-recover",
                                "currentAuthenticatorEnrollment-recover"
                            ], o = !1;
                            break;
                        case "unlockAccount":
                            t = E, o = !1, n = [
                                "unlock-account"
                            ];
                            break;
                        default:
                            t = m;
                    }
                    return {
                        flow: r,
                        remediators: t,
                        actions: n,
                        withCredentials: o
                    };
                }
            },
            5021: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return c;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(2886);
                function c(e1, t) {
                    return s.apply(this, arguments);
                }
                function s() {
                    return (s = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, c, s, f, l, p, d, h, v;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = t.transactionManager.load()) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new a.Z("No transaction data was found in storage");
                                case 3:
                                    if (o = r.codeVerifier, c = r.state, s = new URL(n), f = s.searchParams, l = f.get("state"), p = f.get("interaction_code"), !(d = f.get("error"))) {
                                        e1.next = 10;
                                        break;
                                    }
                                    throw new u.Z(d, f.get("error_description"));
                                case 10:
                                    if (l === c) {
                                        e1.next = 12;
                                        break;
                                    }
                                    throw new a.Z("State in redirect uri does not match with transaction state");
                                case 12:
                                    if (p) {
                                        e1.next = 14;
                                        break;
                                    }
                                    throw new a.Z("Unable to parse interaction_code from the url");
                                case 14:
                                    return e1.next = 16, t.token.exchangeCodeForTokens({
                                        interactionCode: p,
                                        codeVerifier: o
                                    });
                                case 16:
                                    h = e1.sent, v = h.tokens, t.tokenManager.setTokens(v);
                                case 19:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            5923: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _T: function() {
                        return U;
                    },
                    A0: function() {
                        return N;
                    }
                });
                var r = n(1971), o = n(5861), i = n(2982), a = n(4687), u = n.n(a), c = n(885), s = n(4942), f = n(4925), l = n(1002), p = n(5385);
                function d(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return h(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? h(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function h(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var v = function(e1) {
                    return !1 !== e1.mutable;
                }, y = function(e1) {
                    var t = {}, n = [], r = {};
                    if (!e1.value) return n.push(e1), {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                    var o, i = d(e1.value);
                    try {
                        for(i.s(); !(o = i.n()).done;){
                            var a, u, c = o.value;
                            v(c) ? (n.push(c), null !== (a = c.value) && void 0 !== a && a && (t[c.name] = c.value)) : r[c.name] = null !== (u = c.value) && void 0 !== u ? u : "";
                        }
                    } catch (e1) {
                        i.e(e1);
                    } finally{
                        i.f();
                    }
                    return {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                }, g = n(3983);
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = function(e1, t) {
                    var n = t.actionDefinition, r = t.defaultParamsForAction, i = void 0 === r ? {} : r, a = t.immutableParamsForAction, c = void 0 === a ? {} : a, s = t.toPersist, f = void 0 === s ? {} : s, l = n.href;
                    return (0, o.Z)(u().mark(function t() {
                        var r, o, a, s, d, h, v, y, m, k, w, O = arguments;
                        return u().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return r = O.length > 0 && void 0 !== O[0] ? O[0] : {}, o = {
                                        "Content-Type": "application/json",
                                        Accept: n.accepts || "application/ion+json"
                                    }, a = JSON.stringify(b(b(b({}, i), r), c)), t.prev = 3, h = {
                                        url: l,
                                        method: n.method,
                                        headers: o,
                                        args: a,
                                        withCredentials: null === (s = null == f ? void 0 : f.withCredentials) || void 0 === s || s
                                    }, ("poll" === n.name || (null === (d = n.name) || void 0 === d ? void 0 : d.endsWith("-poll"))) && (h.pollingIntent = !0), t.next = 9, (0, p.c3)(e1, h);
                                case 9:
                                    return v = t.sent, t.abrupt("return", e1.idx.makeIdxResponse(b({}, v), f, !0));
                                case 13:
                                    if (t.prev = 13, t.t0 = t.catch(3), t.t0 instanceof g.Z && null !== t.t0 && void 0 !== t.t0 && t.t0.xhr) {
                                        t.next = 17;
                                        break;
                                    }
                                    throw t.t0;
                                case 17:
                                    return y = t.t0.xhr, m = y.responseJSON || JSON.parse(y.responseText), k = y.headers["WWW-Authenticate"] || y.headers["www-authenticate"], w = e1.idx.makeIdxResponse(b({}, m), f, !1), 401 === y.status && 'Oktadevicejwt realm="Okta Device"' === k && (w.stepUp = !0), t.abrupt("return", w);
                                case 23:
                                case "end":
                                    return t.stop();
                            }
                        }, t, null, [
                            [
                                3,
                                13
                            ]
                        ]);
                    }));
                }, w = function(e1, t, n) {
                    var r = k, o = function(e1) {
                        var t, n = [], r = {}, o = {}, i = d(e1 = Array.isArray(e1) ? e1 : [
                            e1
                        ]);
                        try {
                            for(i.s(); !(t = i.n()).done;){
                                var a = t.value, u = y(a), c = u.defaultParamsForAction, s = u.neededParamsForAction, f = u.immutableParamsForAction;
                                n.push(s), r[a.name] = c, o[a.name] = f;
                            }
                        } catch (e1) {
                            i.e(e1);
                        } finally{
                            i.f();
                        }
                        return {
                            defaultParams: r,
                            neededParams: n,
                            immutableParams: o
                        };
                    }(t), i = o.defaultParams, a = o.neededParams, u = o.immutableParams, c = r(e1, {
                        actionDefinition: t,
                        defaultParamsForAction: i[t.name],
                        immutableParamsForAction: u[t.name],
                        toPersist: n
                    });
                    return c.neededParams = a, c;
                };
                function O(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function Z(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? O(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : O(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var T = n(136), E = n(9611);
                function P() {
                    P = function(e1, t) {
                        return new n(e1, void 0, t);
                    };
                    var e1 = RegExp.prototype, t = new WeakMap;
                    function n(e1, r, o) {
                        var i = new RegExp(e1, r);
                        return t.set(i, o || t.get(e1)), (0, E.Z)(i, n.prototype);
                    }
                    function r(e1, n) {
                        var r = t.get(n);
                        return Object.keys(r).reduce(function(t, n) {
                            var o = r[n];
                            if ("number" == typeof o) t[n] = e1[o];
                            else {
                                for(var i = 0; void 0 === e1[o[i]] && i + 1 < o.length;)i++;
                                t[n] = e1[o[i]];
                            }
                            return t;
                        }, Object.create(null));
                    }
                    return (0, T.Z)(n, RegExp), n.prototype.exec = function(t) {
                        var n = e1.exec.call(this, t);
                        return n && (n.groups = r(n, this)), n;
                    }, n.prototype[Symbol.replace] = function(n, o) {
                        if ("string" == typeof o) {
                            var i = t.get(this);
                            return e1[Symbol.replace].call(this, n, o.replace(/\$<([^>]+)>/g, function(e1, t) {
                                return "$" + i[t];
                            }));
                        }
                        if ("function" == typeof o) {
                            var a = this;
                            return e1[Symbol.replace].call(this, n, function() {
                                var e1 = arguments;
                                return "object" != (0, l.Z)(e1[e1.length - 1]) && (e1 = [].slice.call(e1)).push(r(e1, a)), o.apply(this, e1);
                            });
                        }
                        return e1[Symbol.replace].call(this, n, o);
                    }, P.apply(this, arguments);
                }
                var S = P(/\$?(\w+)|(?:\[(\d+)\])/g, {
                    step: 1,
                    index: 2
                }), x = n(9123), A = [
                    "value",
                    "type"
                ];
                function R(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function _(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? R(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var j = {
                    remediation: !0,
                    context: !0
                }, C = function e1(t, n) {
                    Object.keys(n).forEach(function(r) {
                        if ("relatesTo" === r) {
                            var o = Array.isArray(n[r]) ? n[r][0] : n[r];
                            if ("string" == typeof o) {
                                var i = function(e1) {
                                    for(var t, n = e1.path, r = e1.json, o = []; null !== (t = S.exec(n));){
                                        var i, a, u, c, s, f = null !== (i = null === (a = t) || void 0 === a || null === (u = a.groups) || void 0 === u ? void 0 : u.step) && void 0 !== i ? i : null === (c = t) || void 0 === c || null === (s = c.groups) || void 0 === s ? void 0 : s.index;
                                        f && o.push(f);
                                    }
                                    if (!(o.length < 1)) {
                                        for(var p = o.pop(), d = r, h = 0, v = o; h < v.length; h++){
                                            var y = v[h];
                                            if (Object.prototype.hasOwnProperty.call(d, y)) {
                                                if ("object" !== (0, l.Z)(d[y])) return;
                                                d = d[y];
                                            }
                                        }
                                        return d[p];
                                    }
                                }({
                                    path: o,
                                    json: t
                                });
                                if (i) return void (n[r] = i);
                                throw new x.Z("Cannot resolve relatesTo: ".concat(o));
                            }
                        }
                        Array.isArray(n[r]) && n[r].forEach(function(n) {
                            return e1(t, n);
                        });
                    });
                }, I = function(e1, t) {
                    var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = (null === (n = t.remediation) || void 0 === n ? void 0 : n.value) || [];
                    o.forEach(function(e1) {
                        var n;
                        if ("launch-authenticator" !== e1.name || "authenticatorChallenge" !== (null == e1 || null === (n = e1.relatesTo) || void 0 === n ? void 0 : n[0]) || null != t && t.authenticatorChallenge) return C(t, e1);
                        delete e1.relatesTo;
                    });
                    var i = o.map(function(t) {
                        return function(e1, t, n) {
                            if (t.rel) {
                                var r = function(e1, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                                    return t.reduce(function(t, r) {
                                        return Z(Z({}, t), {}, (0, s.Z)({}, r.name, w(e1, r, n)));
                                    }, {});
                                }(e1, [
                                    t
                                ], n), o = r[t.name];
                                return _(_({}, t), {}, {
                                    action: o
                                });
                            }
                            return t;
                        }(e1, t, r);
                    }), a = function(e1, t) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = {}, o = {};
                        return Object.keys(t).filter(function(e1) {
                            return !j[e1];
                        }).forEach(function(i) {
                            if ("object" === (0, l.Z)(t[i]) && t[i]) {
                                if (t[i].rel) r[t[i].name] = w(e1, t[i], n);
                                else {
                                    var a = t[i], u = a.value, s = a.type, p = (0, f.Z)(a, A);
                                    o[i] = _({
                                        type: s
                                    }, p), "object" === s ? (o[i].value = {}, Object.entries(u).forEach(function(t) {
                                        var a = (0, c.Z)(t, 2), u = a[0], s = a[1];
                                        s.rel ? r["".concat(i, "-").concat(u.name || u)] = w(e1, s, n) : o[i].value[u] = s;
                                    })) : o[i].value = u;
                                }
                            } else o[i] = t[i];
                        }), {
                            context: o,
                            actions: r
                        };
                    }(e1, t, r);
                    return {
                        remediations: i,
                        context: a.context,
                        actions: a.actions
                    };
                }, D = {
                    makeIdxState: function(e1, t, n, r) {
                        var a, c, s, f, l = t, p = I(e1, t, n), d = p.remediations, h = p.context, v = p.actions, y = (0, i.Z)(d), g = (f = (0, o.Z)(u().mark(function e1(t) {
                            var n, r, o = arguments;
                            return u().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = d.find(function(e1) {
                                            return e1.name === t;
                                        })) {
                                            e1.next = 4;
                                            break;
                                        }
                                        return e1.abrupt("return", Promise.reject("Unknown remediation choice: [".concat(t, "]")));
                                    case 4:
                                        if ("function" == typeof r.action) {
                                            e1.next = 7;
                                            break;
                                        }
                                        return e1.abrupt("return", Promise.reject("Current remediation cannot make form submit action: [".concat(t, "]")));
                                    case 7:
                                        return e1.abrupt("return", r.action(n));
                                    case 8:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        })), function(e1) {
                            return f.apply(this, arguments);
                        });
                        return {
                            proceed: g,
                            neededToProceed: y,
                            actions: v,
                            context: h,
                            rawIdxState: l,
                            interactionCode: null === (a = l.successWithInteractionCode) || void 0 === a || null === (c = a.value) || void 0 === c || null === (s = c.find(function(e1) {
                                return "interaction_code" === e1.name;
                            })) || void 0 === s ? void 0 : s.value,
                            toPersist: n,
                            requestDidSucceed: r
                        };
                    }
                }, M = function(e1) {
                    switch(e1){
                        case "1.0.0":
                            return D;
                        case void 0:
                        case null:
                            throw new Error("Api version is required");
                        default:
                            throw new Error("Unknown api version: ".concat(e1, ".  Use an exact semver version."));
                    }
                };
                function N(e1) {
                    if (!e1) throw new Error("version is required");
                    if ((null != e1 ? e1 : "").replace(/[^0-9a-zA-Z._-]/, "") !== e1 || !e1) throw new Error("invalid version supplied - version is required and uses semver syntax");
                    M(e1);
                }
                function U(e1, t, n, o) {
                    var i, a = null !== (i = null == t ? void 0 : t.version) && void 0 !== i ? i : r.IDX_API_VERSION;
                    return N(a), (0, M(a).makeIdxState)(e1, t, n, o);
                }
            },
            9999: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    pc: function() {
                        return K.pc;
                    },
                    Fw: function() {
                        return K.Fw;
                    },
                    Qd: function() {
                        return K.Qd;
                    },
                    YR: function() {
                        return r.Y;
                    },
                    Ch: function() {
                        return s.C;
                    },
                    al: function() {
                        return o.a;
                    },
                    Jm: function() {
                        return v.Jm;
                    },
                    F4: function() {
                        return y.F;
                    },
                    SL: function() {
                        return H.S;
                    },
                    aT: function() {
                        return B.a;
                    },
                    vK: function() {
                        return F.v;
                    },
                    UB: function() {
                        return U;
                    },
                    Yn: function() {
                        return g.Y;
                    },
                    Xc: function() {
                        return v.Xc;
                    },
                    uN: function() {
                        return v.uN;
                    },
                    Co: function() {
                        return v.Co;
                    },
                    Jn: function() {
                        return i.Jn;
                    },
                    Xx: function() {
                        return p.X;
                    },
                    $0: function() {
                        return v.$0;
                    },
                    EW: function() {
                        return a.E;
                    },
                    L8: function() {
                        return u.L;
                    },
                    H: function() {
                        return K.H;
                    },
                    GA: function() {
                        return i.GA;
                    },
                    gc: function() {
                        return i.gc;
                    },
                    Wf: function() {
                        return v.Wf;
                    },
                    bl: function() {
                        return v.bl;
                    },
                    UC: function() {
                        return v.UC;
                    },
                    B_: function() {
                        return L.B;
                    },
                    mo: function() {
                        return i.mo;
                    },
                    $l: function() {
                        return c.$;
                    },
                    xc: function() {
                        return s.x;
                    },
                    M4: function() {
                        return l.M;
                    },
                    z2: function() {
                        return f.z;
                    },
                    r0: function() {
                        return v.r0;
                    },
                    Yr: function() {
                        return d.Y;
                    },
                    le: function() {
                        return h.l;
                    }
                });
                var r = n(1286), o = n(9192), i = n(7985), a = n(6131), u = n(2660), c = n(9310), s = n(2845), f = n(8826), l = n(9214), p = n(5021), d = n(2473), h = n(8277), v = n(2620), y = n(8717), g = n(2144), m = n(3144), b = n(5671), k = n(7326), w = n(136), O = n(2963), Z = n(1120), T = n(4942), E = n(5923), P = n(8719), S = n(8716);
                function x(e1) {
                    var t;
                    return t = function(e1) {
                        (0, w.Z)(o, e1);
                        var t, n, r = (t = o, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, Z.Z)(t);
                            if (n) {
                                var o = (0, Z.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, O.Z)(this, e1);
                        });
                        function o() {
                            var e1, t, n;
                            (0, b.Z)(this, o);
                            for(var i = arguments.length, a = new Array(i), u = 0; u < i; u++)a[u] = arguments[u];
                            return e1 = r.call.apply(r, [
                                this
                            ].concat(a)), (0, T.Z)((0, k.Z)(e1), "idx", void 0), (0, T.Z)((0, k.Z)(e1), "fingerprint", void 0), e1.idx = (t = (0, k.Z)(e1), n = d.Y.bind(null, t), {
                                makeIdxResponse: E._T.bind(null, t),
                                start: n,
                                startTransaction: n,
                                proceed: s.x.bind(null, t),
                                canProceed: s.C.bind(null, t),
                                getSavedTransactionMeta: v.uN.bind(null, t),
                                createTransactionMeta: v.Xc.bind(null, t),
                                getTransactionMeta: v.Co.bind(null, t),
                                saveTransactionMeta: v.r0.bind(null, t),
                                clearTransactionMeta: v.Jm.bind(null, t),
                                isTransactionMetaValid: v.Wf
                            }), e1.fingerprint = P.Z.bind(null, (0, k.Z)(e1)), e1;
                        }
                        return (0, m.Z)(o);
                    }(e1), (0, T.Z)(t, "webauthn", S), t;
                }
                var A = n(9893), R = n(265), _ = n(279), j = n(3980), C = n(1237), I = n(8707), D = n(6898), M = n(8221);
                function N(e1, t) {
                    return function(e1) {
                        (0, w.Z)(i, e1);
                        var n, r, o = (n = i, r = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, Z.Z)(n);
                            if (r) {
                                var o = (0, Z.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, o);
                            } else e1 = t.apply(this, arguments);
                            return (0, O.Z)(this, e1);
                        });
                        function i() {
                            var e1, n;
                            (0, b.Z)(this, i);
                            for(var r = arguments.length, a = new Array(r), u = 0; u < r; u++)a[u] = arguments[u];
                            return e1 = o.call.apply(o, [
                                this
                            ].concat(a)), (0, T.Z)((0, k.Z)(e1), "token", void 0), (0, T.Z)((0, k.Z)(e1), "transactionManager", void 0), e1.transactionManager = new t(Object.assign({
                                storageManager: e1.storageManager
                            }, e1.options.transactionManager)), e1.token = (n = (0, k.Z)(e1), {
                                prepareTokenParams: D.wu.bind(null, n),
                                exchangeCodeForTokens: I.r.bind(null, n),
                                decode: C.T
                            }), e1;
                        }
                        return (0, m.Z)(i, [
                            {
                                key: "isLoginRedirect",
                                value: function() {
                                    return (0, M.gM)(this);
                                }
                            },
                            {
                                key: "isPKCE",
                                value: function() {
                                    return !!this.options.pkce;
                                }
                            },
                            {
                                key: "hasResponseType",
                                value: function(e1) {
                                    return (0, M.wV)(e1, this.options);
                                }
                            },
                            {
                                key: "isAuthorizationCodeFlow",
                                value: function() {
                                    return this.hasResponseType("code");
                                }
                            }
                        ]), i;
                    }(e1);
                }
                function U(e1, t, n) {
                    var r = (0, A.a)(t), o = (0, R.H)(r, e1), i = (0, _.A)(o);
                    return x(N((0, j.Z)(i), n));
                }
                var L = n(8137), H = n(4602), B = n(4143), K = n(7595), F = n(3334);
            },
            6131: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(2620), c = n(7599), s = n(3193), f = n(5385);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function d(e1) {
                    return {
                        meta: e1,
                        interactionHandle: e1.interactionHandle,
                        state: e1.state
                    };
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, l, h, v, y, g, m, b, k, w, O, Z, T, E, P, S, x, A, R, _, j, C, I = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = I.length > 1 && void 0 !== I[1] ? I[1] : {}, o = (0, s.YY)(o), i = (0, u.uN)(t, o), null === (n = i) || void 0 === n || !n.interactionHandle) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", d(i));
                                case 5:
                                    return e1.next = 7, (0, u.Xc)(t, p(p({}, i), o));
                                case 7:
                                    return i = e1.sent, l = (0, c.zf)(t), v = (h = i).clientId, y = h.redirectUri, g = h.state, m = h.scopes, b = h.withCredentials, k = h.codeChallenge, w = h.codeChallengeMethod, O = h.activationToken, Z = h.recoveryToken, T = h.maxAge, E = h.acrValues, P = h.nonce, S = o.clientSecret || t.options.clientSecret, b = null === (r = b) || void 0 === r || r, x = "".concat(l, "/v1/interact"), A = p(p(p(p(p(p({
                                        client_id: v,
                                        scope: m.join(" "),
                                        redirect_uri: y,
                                        code_challenge: k,
                                        code_challenge_method: w,
                                        state: g
                                    }, O && {
                                        activation_token: O
                                    }), Z && {
                                        recovery_token: Z
                                    }), S && {
                                        client_secret: S
                                    }), T && {
                                        max_age: T
                                    }), E && {
                                        acr_values: E
                                    }), P && {
                                        nonce: P
                                    }), R = {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                    }, e1.next = 17, (0, f.c3)(t, {
                                        method: "POST",
                                        url: x,
                                        headers: R,
                                        withCredentials: b,
                                        args: A
                                    });
                                case 17:
                                    return _ = e1.sent, j = _.interaction_handle, C = p(p({}, i), {}, {
                                        interactionHandle: j,
                                        withCredentials: b,
                                        state: g,
                                        scopes: m,
                                        recoveryToken: Z,
                                        activationToken: O
                                    }), (0, u.r0)(t, C), e1.abrupt("return", d(C));
                                case 22:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            2660: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    L: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(5923), u = n(480), c = n(7599), s = n(1971), f = n(5385), l = n(5728);
                function p(e1) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return d = (0, r.Z)(i().mark(function e1(t) {
                        var n, r, o, p, d, h, v, y, g, m, b, k, w, O, Z = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = Z.length > 1 && void 0 !== Z[1] ? Z[1] : {}, (p = t.transactionManager.loadIdxResponse(n)) && (r = p.rawIdxResponse, o = p.requestDidSucceed), r) {
                                        e1.next = 27;
                                        break;
                                    }
                                    return h = n.version || s.IDX_API_VERSION, v = (0, c.Xp)(t), y = n.interactionHandle, g = n.stateHandle, m = null === (d = n.withCredentials) || void 0 === d || d, e1.prev = 8, o = !0, (0, a.A0)(h), b = "".concat(v, "/idp/idx/introspect"), k = g ? {
                                        stateToken: g
                                    } : {
                                        interactionHandle: y
                                    }, w = {
                                        "Content-Type": "application/ion+json; okta-version=".concat(h),
                                        Accept: "application/ion+json; okta-version=".concat(h)
                                    }, e1.next = 16, (0, f.c3)(t, {
                                        method: "POST",
                                        url: b,
                                        headers: w,
                                        withCredentials: m,
                                        args: k
                                    });
                                case 16:
                                    r = e1.sent, e1.next = 27;
                                    break;
                                case 19:
                                    if (e1.prev = 19, e1.t0 = e1.catch(8), !((0, l.isAuthApiError)(e1.t0) && e1.t0.xhr && (0, u.P)(e1.t0.xhr.responseJSON))) {
                                        e1.next = 26;
                                        break;
                                    }
                                    r = e1.t0.xhr.responseJSON, o = !1, e1.next = 27;
                                    break;
                                case 26:
                                    throw e1.t0;
                                case 27:
                                    return O = n.withCredentials, e1.abrupt("return", (0, a._T)(t, r, {
                                        withCredentials: O
                                    }, o));
                                case 29:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                8,
                                19
                            ]
                        ]);
                    })), d.apply(this, arguments);
                }
            },
            8137: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    B: function() {
                        return d;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(8717), l = n(8719), p = n(8716);
                function d(e1) {
                    var t;
                    return t = function(e1) {
                        (0, a.Z)(d, e1);
                        var t, n, p = (t = d, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function d() {
                            var e1;
                            (0, o.Z)(this, d);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = p.call.apply(p, [
                                this
                            ].concat(n)), (0, s.Z)((0, i.Z)(e1), "idx", void 0), (0, s.Z)((0, i.Z)(e1), "fingerprint", void 0), e1.idx = (0, f.F)((0, i.Z)(e1)), e1.fingerprint = l.Z.bind(null, (0, i.Z)(e1)), e1;
                        }
                        return (0, r.Z)(d);
                    }(e1), (0, s.Z)(t, "webauthn", p), t;
                }
            },
            4602: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    S: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9133);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "flow", void 0), (0, s.Z)((0, i.Z)(t), "activationToken", void 0), (0, s.Z)((0, i.Z)(t), "recoveryToken", void 0), (0, s.Z)((0, i.Z)(t), "idx", void 0), t.flow = e1.flow, t.activationToken = e1.activationToken, t.recoveryToken = e1.recoveryToken, t.idx = e1.idx, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.n)());
                }
            },
            9310: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return s;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(2845), u = n(2620), c = n(146);
                function s(e1) {
                    return f.apply(this, arguments);
                }
                function f() {
                    return f = (0, r.Z)(i().mark(function e1(t) {
                        var n, o, f, l, p, d, h, v = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return f = (o = v.length > 1 && void 0 !== v[1] ? v[1] : {}).withCredentials, l = o.exchangeCodeForTokens, e1.next = 4, (0, a.x)(t, {
                                        startPolling: !0,
                                        withCredentials: f,
                                        exchangeCodeForTokens: l
                                    });
                                case 4:
                                    if (p = e1.sent, d = (0, u.uN)(t), null != (h = null == d || null === (n = d.remediations) || void 0 === n ? void 0 : n.find(function(e1) {
                                        return e1.includes("poll");
                                    })) && h.length || (0, c.ZK)("No polling remediations available at the current IDX flow stage"), !Number.isInteger(o.refresh)) {
                                        e1.next = 10;
                                        break;
                                    }
                                    return e1.abrupt("return", new Promise(function(e1, n) {
                                        setTimeout((0, r.Z)(i().mark(function r() {
                                            var o, a, u;
                                            return i().wrap(function(r) {
                                                for(;;)switch(r.prev = r.next){
                                                    case 0:
                                                        try {
                                                            u = null === (o = p.nextStep) || void 0 === o || null === (a = o.poll) || void 0 === a ? void 0 : a.refresh, e1(u ? s(t, {
                                                                refresh: u
                                                            }) : p);
                                                        } catch (e1) {
                                                            n(e1);
                                                        }
                                                    case 1:
                                                    case "end":
                                                        return r.stop();
                                                }
                                            }, r);
                                        })), o.refresh);
                                    }));
                                case 10:
                                    return e1.abrupt("return", p);
                                case 11:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), f.apply(this, arguments);
                }
            },
            2845: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    C: function() {
                        return p;
                    },
                    x: function() {
                        return d;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(9123);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function p(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return !(!(0, c.uN)(e1, t) && !t.stateHandle);
                }
                function d(e1) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return h = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, f = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (p(t, n = f.length > 1 && void 0 !== f[1] ? f[1] : {})) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new s.Z("Unable to proceed: saved transaction could not be loaded");
                                case 3:
                                    return r = n.flow, o = n.state, r || (i = (0, c.uN)(t, {
                                        state: o
                                    }), r = null == i ? void 0 : i.flow), e1.abrupt("return", (0, u.K)(t, l(l({}, n), {}, {
                                        flow: r
                                    })));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), h.apply(this, arguments);
                }
            },
            9214: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(7738);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, c.s)(t, "recoverPassword"), e1.abrupt("return", (0, u.K)(t, f(f({}, n), r)));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            8826: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    z: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(2473), f = n(9123), l = n(7595);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = i.length > 1 && void 0 !== i[1] ? i[1] : {}, (0, c.$0)(t)) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 4, (0, s.Y)(t, d(d({}, n), {}, {
                                        flow: "register",
                                        autoRemediate: !1
                                    }));
                                case 4:
                                    if (r = e1.sent, o = r.enabledFeatures, n.activationToken || !o || o.includes(l.Fw.REGISTRATION)) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new f.Z("Registration is not supported based on your current org configuration.");
                                case 8:
                                    return e1.abrupt("return", (0, u.K)(t, d(d({}, n), {}, {
                                        flow: "register"
                                    })));
                                case 9:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            2541: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(4794), l = n(6064);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var h = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f() {
                        return (0, r.Z)(this, f), s.apply(this, arguments);
                    }
                    return (0, o.Z)(f, [
                        {
                            key: "mapAuthenticator",
                            value: function() {
                                var e1 = this.getAuthenticatorData();
                                return {
                                    id: (0, l.zg)(this.remediation).form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value,
                                    methodType: e1.methodType,
                                    phoneNumber: e1.phoneNumber
                                };
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function(e1) {
                                return [
                                    {
                                        name: "methodType",
                                        type: "string"
                                    },
                                    {
                                        name: "phoneNumber",
                                        label: "Phone Number",
                                        type: "string"
                                    }
                                ].map(function(t) {
                                    return d(d({}, e1.form.value.find(function(e1) {
                                        return e1.name === t.name;
                                    })), t);
                                });
                            }
                        },
                        {
                            key: "mapAuthenticatorDataFromValues",
                            value: function(e1) {
                                e1 = (0, i.Z)((0, c.Z)(f.prototype), "mapAuthenticatorDataFromValues", this).call(this, e1);
                                var t = this.values.phoneNumber;
                                if (e1 || t) return d(d({}, e1 && e1), t && {
                                    phoneNumber: t
                                });
                            }
                        }
                    ]), f;
                }(f.a);
                (0, s.Z)(h, "remediationName", "authenticator-enrollment-data");
            },
            5278: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(5671), i = n(3144), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d() {
                        return (0, o.Z)(this, d), l.apply(this, arguments);
                    }
                    return (0, i.Z)(d, [
                        {
                            key: "mapAuthenticator",
                            value: function() {
                                return this.getAuthenticatorData();
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function() {
                                var e1 = this.getAuthenticatorFromRemediation(), t = e1.form.value.find(function(e1) {
                                    return "methodType" === e1.name;
                                });
                                return t && t.options ? {
                                    name: "methodType",
                                    type: "string",
                                    required: !0,
                                    options: t.options
                                } : (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return this.values = (0, a.Z)((0, s.Z)(d.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function(e1) {
                                    return "authenticator" !== e1;
                                }).reduce(function(t, n) {
                                    return p(p({}, t), {}, (0, f.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), d;
                }(n(4794).a);
                (0, f.Z)(d, "remediationName", "authenticator-verification-data");
            },
            4794: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return y;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(7595), d = n(9344);
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var y = function(e1) {
                    (0, u.Z)(h, e1);
                    var t, n, l = (t = h, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function h(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return (0, r.Z)(this, h), t = l.call(this, e1, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = t.getAuthenticator(), t.formatAuthenticatorData(), t;
                    }
                    return (0, o.Z)(h, [
                        {
                            key: "formatAuthenticatorData",
                            value: function() {
                                var e1 = this;
                                if (this.getAuthenticatorData()) this.values.authenticatorsData = this.values.authenticatorsData.map(function(t) {
                                    return (0, d.PN)(e1.authenticator, t) ? e1.mapAuthenticatorDataFromValues(t) : t;
                                });
                                else {
                                    var t = this.mapAuthenticatorDataFromValues();
                                    t && this.values.authenticatorsData.push(t);
                                }
                            }
                        },
                        {
                            key: "getAuthenticatorData",
                            value: function() {
                                var e1 = this;
                                return this.values.authenticatorsData.find(function(t) {
                                    return (0, d.PN)(e1.authenticator, t);
                                });
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                var e1 = this;
                                return this.values.authenticatorsData.some(function(t) {
                                    return (0, d.PN)(e1.authenticator, t);
                                });
                            }
                        },
                        {
                            key: "mapAuthenticatorDataFromValues",
                            value: function(e1) {
                                var t = this.values, n = t.methodType, r = t.authenticator;
                                !n && (0, p.H)(r) && (n = null == r ? void 0 : r.methodType);
                                var o = this.authenticator, i = v(v({
                                    id: o.id,
                                    enrollmentId: o.enrollmentId
                                }, e1 && e1), n && {
                                    methodType: n
                                });
                                return i.methodType ? i : null;
                            }
                        },
                        {
                            key: "getAuthenticatorFromRemediation",
                            value: function() {
                                return this.remediation.value.find(function(e1) {
                                    return "authenticator" === e1.name;
                                });
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, a.Z)((0, s.Z)(h.prototype), "getValuesAfterProceed", this).call(this);
                                var t = this.values.authenticatorsData.filter(function(t) {
                                    return !0 !== (0, d.PN)(e1.authenticator, t);
                                });
                                return v(v({}, this.values), {}, {
                                    authenticatorsData: t
                                });
                            }
                        }
                    ]), h;
                }(l.n);
            },
            3118: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(1002), i = n(5671), a = n(3144), u = n(4942), c = n(6064), s = n(9344);
                function f(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, u.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        (0, i.Z)(this, e1), (0, u.Z)(this, "remediation", void 0), (0, u.Z)(this, "values", void 0), (0, u.Z)(this, "options", void 0), (0, u.Z)(this, "map", void 0), this.values = p({}, n), this.options = p({}, r), this.formatAuthenticators(), this.remediation = t;
                    }
                    return (0, a.Z)(e1, [
                        {
                            key: "formatAuthenticators",
                            value: function() {
                                if (this.values.authenticators = this.values.authenticators || [], this.values.authenticators = this.values.authenticators.map(function(e1) {
                                    return (0, s.LL)(e1);
                                }), this.values.authenticator) {
                                    var e1 = (0, s.LL)(this.values.authenticator);
                                    this.values.authenticators.some(function(t) {
                                        return (0, s.PN)(e1, t);
                                    }) || this.values.authenticators.push(e1);
                                }
                                this.values.authenticatorsData = this.values.authenticators.reduce(function(e1, t) {
                                    return "object" === (0, o.Z)(t) && Object.keys(t).length > 1 && e1.push(t), e1;
                                }, this.values.authenticatorsData || []);
                            }
                        },
                        {
                            key: "getName",
                            value: function() {
                                return this.remediation.name;
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function(e1) {
                                var t = this;
                                return !(0, c.QG)(this.remediation).find(function(e1) {
                                    return !t.hasData(e1);
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function(e1) {
                                var t = this;
                                if (!e1) {
                                    var n = (0, c.ix)(this.remediation).reduce(function(e1, n) {
                                        return e1[n] = t.getData(n), e1;
                                    }, {});
                                    return n;
                                }
                                if ("function" == typeof this["map".concat((0, c.Qs)(e1))]) {
                                    var r = this["map".concat((0, c.Qs)(e1))](this.remediation.value.find(function(t) {
                                        return t.name === e1;
                                    }));
                                    if (r) return r;
                                }
                                if (this.map && this.map[e1]) for(var o = this.map[e1], i = 0; i < o.length; i++){
                                    var a = this.values[o[i]];
                                    if (a) return a;
                                }
                                return this.values[e1];
                            }
                        },
                        {
                            key: "hasData",
                            value: function(e1) {
                                return !!this.getData(e1);
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = this.getName(), r = this.getInputs(), o = this.getAuthenticator(), i = null == o ? void 0 : o.type;
                                return p(p({
                                    name: n,
                                    inputs: r
                                }, i && {
                                    type: i
                                }), o && {
                                    authenticator: o
                                });
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                var e1 = this, t = [];
                                return (this.remediation.value || []).forEach(function(n) {
                                    var r, o = n.name, i = n.type, a = n.visible, u = n.messages;
                                    if (!1 !== a) {
                                        if ("function" == typeof e1["getInput".concat((0, c.Qs)(o))]) r = e1["getInput".concat((0, c.Qs)(o))](n);
                                        else if ("object" !== i) {
                                            var s, f = (e1.map ? e1.map[o] : null) || [];
                                            s = 1 === f.length ? f[0] : f.find(function(t) {
                                                return Object.keys(e1.values).includes(t);
                                            }), s && (r = p(p({}, n), {}, {
                                                name: s
                                            }));
                                        }
                                        r || (r = n), Array.isArray(r) ? r.forEach(function(e1) {
                                            return t.push(e1);
                                        }) : (u && (r.messages = u), t.push(r));
                                    }
                                }), t;
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1, t = this.remediation.value || [], n = this.getInputs(), o = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return f(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? f(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }([].concat((0, r.Z)(t), (0, r.Z)(n)));
                                try {
                                    for(o.s(); !(e1 = o.n()).done;){
                                        var i = e1.value;
                                        delete this.values[i.name];
                                    }
                                } catch (e1) {
                                    o.e(e1);
                                } finally{
                                    o.f();
                                }
                                return this.values;
                            }
                        },
                        {
                            key: "getAuthenticator",
                            value: function() {
                                var e1, t, n = null === (e1 = this.remediation.relatesTo) || void 0 === e1 ? void 0 : e1.value;
                                if (n) {
                                    var r = (0, c.zg)(this.remediation);
                                    if (!r) return n;
                                    var o = r.form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value, i = null === (t = r.form.value.find(function(e1) {
                                        return "enrollmentId" === e1.name;
                                    })) || void 0 === t ? void 0 : t.value;
                                    return p(p({}, n), {}, {
                                        id: o,
                                        enrollmentId: i
                                    });
                                }
                            }
                        }
                    ], [
                        {
                            key: "getMessages",
                            value: function(e1) {
                                var t, n;
                                if (e1.value) return null === (t = e1.value[0]) || void 0 === t || null === (n = t.form) || void 0 === n ? void 0 : n.value.reduce(function(e1, t) {
                                    return t.messages && (e1 = [].concat((0, r.Z)(e1), (0, r.Z)(t.messages.value))), e1;
                                }, []);
                            }
                        }
                    ]), e1;
                }();
                (0, u.Z)(d, "remediationName", void 0);
            },
            9164: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return m;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(6064), d = n(7595), h = n(9344);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var m = function(e1) {
                    (0, u.Z)(v, e1);
                    var t, n, l = (t = v, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function v() {
                        var e1;
                        (0, r.Z)(this, v);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = l.call.apply(l, [
                            this
                        ].concat(n)), (0, f.Z)((0, i.Z)(e1), "selectedAuthenticator", void 0), (0, f.Z)((0, i.Z)(e1), "selectedOption", void 0), e1;
                    }
                    return (0, o.Z)(v, [
                        {
                            key: "findMatchedOption",
                            value: function(e1, t) {
                                var n, r, o = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return g(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? g(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }(e1);
                                try {
                                    var i = function() {
                                        var e1 = r.value;
                                        if (n = t.find(function(t) {
                                            var n = t.relatesTo;
                                            return n.key && n.key === e1.key;
                                        })) return "break";
                                    };
                                    for(o.s(); !(r = o.n()).done && "break" !== i(););
                                } catch (e1) {
                                    o.e(e1);
                                } finally{
                                    o.f();
                                }
                                return n;
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function(e1) {
                                var t = this.values, n = t.authenticators, r = t.authenticator, o = (0, p.zg)(this.remediation).options;
                                if (!n || !n.length) return !1;
                                if ((0, d.H)(r) && r.id) return !0;
                                var i = this.findMatchedOption(n, o);
                                if (i) {
                                    var a, u, c = (null == e1 ? void 0 : e1.currentAuthenticator) && (null == e1 ? void 0 : e1.currentAuthenticator.value.id) === (null === (a = i.relatesTo) || void 0 === a ? void 0 : a.id), s = (null == e1 ? void 0 : e1.currentAuthenticatorEnrollment) && (null == e1 ? void 0 : e1.currentAuthenticatorEnrollment.value.id) === (null === (u = i.relatesTo) || void 0 === u ? void 0 : u.id);
                                    return !c && !s;
                                }
                                return !1;
                            }
                        },
                        {
                            key: "mapAuthenticator",
                            value: function(e1) {
                                var t = this.values, n = t.authenticators, r = t.authenticator;
                                if ((0, d.H)(r) && r.id) return this.selectedAuthenticator = r, r;
                                var o = e1.options, i = (0, h.h_)(n, o);
                                return this.selectedAuthenticator = i.relatesTo, this.selectedOption = i, {
                                    id: null == i ? void 0 : i.value.form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value
                                };
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function(e1) {
                                return {
                                    name: "authenticator",
                                    type: "string",
                                    options: e1.options.map(function(e1) {
                                        return {
                                            label: e1.label,
                                            value: e1.relatesTo.key
                                        };
                                    })
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, a.Z)((0, s.Z)(v.prototype), "getValuesAfterProceed", this).call(this);
                                var t = this.values.authenticators.filter(function(t) {
                                    return !0 !== (0, h.PN)(t, e1.selectedAuthenticator);
                                });
                                return y(y({}, this.values), {}, {
                                    authenticators: t
                                });
                            }
                        }
                    ]), v;
                }(l.n);
            },
            9883: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Q: function() {
                        return P;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(7644);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var v = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                return !!(e1.credentials || e1.verificationCode || e1.otp);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.verificationCode, r = e1.otp;
                                if (t || n || r) return t || {
                                    passcode: n || r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function(e1) {
                                var t;
                                return h(h({}, null === (t = e1.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                                    name: "verificationCode",
                                    type: "string",
                                    required: e1.required
                                });
                            }
                        }
                    ]), a;
                }(p._);
                var y = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.verificationCode;
                                if (t) return {
                                    totp: t
                                };
                            }
                        }
                    ]), a;
                }(v), g = n(9582);
                var m = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials;
                                if (t && t.questionKey && t.answer) return !0;
                                var n = e1.questionKey, r = e1.question, o = e1.answer;
                                return !(!n || !o) || !(!r || !o);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.questionKey, n = e1.question, r = e1.answer;
                                if (r && (t || n)) return {
                                    questionKey: n ? "custom" : t,
                                    question: n,
                                    answer: r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "questionKey",
                                        type: "string",
                                        required: !0
                                    },
                                    {
                                        name: "question",
                                        type: "string",
                                        label: "Create a security question"
                                    },
                                    {
                                        name: "answer",
                                        type: "string",
                                        label: "Answer",
                                        required: !0
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var b = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials;
                                return !(!t || !t.answer) || !!e1.answer;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.answer;
                                if (t) return {
                                    questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
                                    answer: t
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "answer",
                                        type: "string",
                                        label: "Answer",
                                        required: !0
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                function k(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                var w = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials || e1, n = t.clientData, r = t.attestation;
                                return !(!n || !r);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.clientData, r = e1.attestation, o = e1.transports;
                                if (t || n || r) return t || function(e1) {
                                    for(var t = 1; t < arguments.length; t++){
                                        var n = null != arguments[t] ? arguments[t] : {};
                                        t % 2 ? k(Object(n), !0).forEach(function(t) {
                                            (0, f.Z)(e1, t, n[t]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : k(Object(n)).forEach(function(t) {
                                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                                        });
                                    }
                                    return e1;
                                }({
                                    clientData: n,
                                    attestation: r
                                }, o && {
                                    transports: o
                                });
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "clientData",
                                        type: "string",
                                        required: !0,
                                        visible: !1,
                                        label: "Client Data"
                                    },
                                    {
                                        name: "attestation",
                                        type: "string",
                                        required: !0,
                                        visible: !1,
                                        label: "Attestation"
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var O = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials || e1, n = t.clientData, r = t.authenticatorData, o = t.signatureData;
                                return !!(n && r && o);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.authenticatorData, r = e1.clientData, o = e1.signatureData;
                                if (t || n || r || o) return t || {
                                    authenticatorData: n,
                                    clientData: r,
                                    signatureData: o
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "authenticatorData",
                                        type: "string",
                                        label: "Authenticator Data",
                                        required: !0,
                                        visible: !1
                                    },
                                    {
                                        name: "clientData",
                                        type: "string",
                                        label: "Client Data",
                                        required: !0,
                                        visible: !1
                                    },
                                    {
                                        name: "signatureData",
                                        type: "string",
                                        label: "Signature Data",
                                        required: !0,
                                        visible: !1
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._), Z = n(7595);
                function T(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function E(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? T(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : T(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var P = function(e1) {
                    (0, u.Z)(p, e1);
                    var t, n, l = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function p(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return (0, r.Z)(this, p), t = l.call(this, e1, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = function(e1) {
                            var t, n, r = e1.relatesTo, o = (null == r ? void 0 : r.value) || {};
                            switch(o.key){
                                case Z.pc.OKTA_PASSWORD:
                                    return new g.a(o);
                                case Z.pc.SECURITY_QUESTION:
                                    return null !== (t = o.contextualData) && void 0 !== t && t.enrolledQuestion ? new b(o) : new m(o);
                                case Z.pc.OKTA_VERIFY:
                                    return new y(o);
                                case Z.pc.WEBAUTHN:
                                    return null !== (n = o.contextualData) && void 0 !== n && n.challengeData ? new O(o) : new w(o);
                                default:
                                    return new v(o);
                            }
                        }(e1), t;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n, r = (0, a.Z)((0, s.Z)(p.prototype), "getNextStep", this).call(this, e1, t), o = null == t || null === (n = t.authenticatorEnrollments) || void 0 === n ? void 0 : n.value;
                                return E(E({}, r), {}, {
                                    authenticatorEnrollments: o
                                });
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                return this.authenticator.canVerify(this.values);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                return this.authenticator.mapCredentials(this.values);
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return this.authenticator.getInputs(e1);
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return this.values = (0, a.Z)((0, s.Z)(p.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function(e1) {
                                    return "credentials" !== e1;
                                }).reduce(function(t, n) {
                                    return E(E({}, t), {}, (0, f.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(l.n);
            },
            4560: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    J: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "challenge-authenticator");
            },
            1104: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.startPolling || "challenge-poll" === this.options.step;
                            }
                        }
                    ]), s;
                }(n(2288).T);
                (0, c.Z)(s, "remediationName", "challenge-poll");
            },
            3857: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "enroll-authenticator");
            },
            2288: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.startPolling || "enroll-poll" === this.options.step;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = this.getAuthenticator();
                                return !r && null != t && t.currentAuthenticator && (r = t.currentAuthenticator.value), l(l({}, n), {}, {
                                    authenticator: r,
                                    poll: {
                                        required: !0,
                                        refresh: this.remediation.refresh
                                    }
                                });
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return Object.keys(this.values).filter(function(e1) {
                                    return "startPolling" !== e1;
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "enroll-poll");
            },
            7522: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    w: function() {
                        return v;
                    }
                });
                var r = n(2982), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(9582);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var v = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        return (0, o.Z)(this, d), t = l.call(this, e1, n, r), (0, f.Z)((0, a.Z)(t), "authenticator", null), t.getCredentialsFromRemediation() && (t.authenticator = t.authenticator = new p.a({})), t;
                    }
                    return (0, i.Z)(d, [
                        {
                            key: "canRemediate",
                            value: function() {
                                if (this.authenticator && !this.authenticator.canVerify(this.values)) return !1;
                                var e1 = this.getData().userProfile;
                                return !!e1 && this.remediation.value.find(function(e1) {
                                    return "userProfile" === e1.name;
                                }).form.value.reduce(function(t, n) {
                                    return n.required && (t = t && !!e1[n.name]), t;
                                }, !0);
                            }
                        },
                        {
                            key: "getCredentialsFromRemediation",
                            value: function() {
                                return this.remediation.value.find(function(e1) {
                                    return "credentials" === e1.name;
                                });
                            }
                        },
                        {
                            key: "mapUserProfile",
                            value: function(e1) {
                                var t = this, n = e1.form.value.map(function(e1) {
                                    return e1.name;
                                }).reduce(function(e1, n) {
                                    return t.values[n] ? h(h({}, e1), {}, (0, f.Z)({}, n, t.values[n])) : e1;
                                }, {});
                                if (0 !== Object.keys(n).length) return n;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.authenticator && this.authenticator.mapCredentials(this.values);
                                if (e1) return e1;
                            }
                        },
                        {
                            key: "getInputUserProfile",
                            value: function(e1) {
                                return (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getErrorMessages",
                            value: function(e1) {
                                return e1.value[0].form.value.reduce(function(e1, t) {
                                    return t.messages && e1.push(t.messages.value[0].message), e1;
                                }, []);
                            }
                        }
                    ]), d;
                }(l.n);
                (0, f.Z)(v, "remediationName", "enroll-profile");
            },
            3679: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    t: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "getInputEmail",
                            value: function() {
                                return [
                                    {
                                        name: "email",
                                        type: "string",
                                        required: !0,
                                        label: "Email"
                                    }
                                ];
                            }
                        },
                        {
                            key: "getInputPhoneNumber",
                            value: function() {
                                return [
                                    {
                                        name: "phoneNumber",
                                        type: "string",
                                        required: !0,
                                        label: "Phone Number"
                                    }
                                ];
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                return Boolean(this.values.email || this.values.phoneNumber);
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = t.currentAuthenticator.value;
                                return l(l({}, n), {}, {
                                    authenticator: r
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                return {
                                    stateHandle: this.values.stateHandle,
                                    email: this.values.email,
                                    phoneNumber: this.values.phoneNumber
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return Object.keys(this.values).filter(function(e1) {
                                    return ![
                                        "email",
                                        "phoneNumber"
                                    ].includes(e1);
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "enrollment-channel-data");
            },
            9732: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return k;
                    }
                });
                var r = n(5861), o = n(4942), i = n(4925), a = n(5671), u = n(3144), c = n(136), s = n(2963), f = n(1120), l = n(4687), p = n.n(l), d = n(3118), h = n(1002), v = n(885);
                function y(e1) {
                    if (Array.isArray(e1)) return e1.map(function(e1) {
                        return "string" == typeof e1 || "number" == typeof e1 || "boolean" == typeof e1 ? e1 : y(e1);
                    });
                    for(var t = {}, n = 0, r = Object.entries(e1); n < r.length; n++){
                        var o = (0, v.Z)(r[n], 2), i = o[0], a = o[1];
                        if (null != a) {
                            if ("object" === (0, h.Z)(a)) {
                                var u = Object.keys(a);
                                if ([
                                    "value",
                                    "form"
                                ].includes(i) && 1 === u.length && [
                                    "value",
                                    "form"
                                ].includes(u[0])) {
                                    var c = y(a);
                                    Object.entries(c).forEach(function(e1) {
                                        var n = (0, v.Z)(e1, 2), r = n[0], o = n[1];
                                        t[r] = o;
                                    });
                                } else t[i] = y(a);
                            } else t[i] = a;
                        }
                    }
                    return t;
                }
                var g = [
                    "href",
                    "method",
                    "rel",
                    "accepts",
                    "produces",
                    "value",
                    "action"
                ];
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = function(e1) {
                    (0, c.Z)(l, e1);
                    var t, n, o = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, f.Z)(t);
                        if (n) {
                            var o = (0, f.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, s.Z)(this, e1);
                    });
                    function l() {
                        return (0, a.Z)(this, l), o.apply(this, arguments);
                    }
                    return (0, u.Z)(l, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !("function" != typeof this.remediation.action || "poll" !== this.remediation.name && !this.remediation.name.endsWith("-poll") && !this.options.step);
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                var e1 = this;
                                return this.getInputs().reduce(function(t, n) {
                                    var r = n.name;
                                    return t[r] = e1.values[r], t;
                                }, {});
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n, o = this.getName(), a = this.getInputs(), u = this.remediation, c = (u.href, u.method, u.rel, u.accepts, u.produces, u.value, u.action), s = (0, i.Z)(u, g);
                                return c ? b(b(b({}, s), !!a.length && {
                                    inputs: a
                                }), {}, {
                                    action: (n = (0, r.Z)(p().mark(function t(n) {
                                        return p().wrap(function(t) {
                                            for(;;)switch(t.prev = t.next){
                                                case 0:
                                                    return t.abrupt("return", e1.idx.proceed(b({
                                                        step: o
                                                    }, n)));
                                                case 1:
                                                case "end":
                                                    return t.stop();
                                            }
                                        }, t);
                                    })), function(e1) {
                                        return n.apply(this, arguments);
                                    })
                                }) : b({}, this.remediation);
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return (this.remediation.value || []).filter(function(e1) {
                                    return "stateHandle" !== e1.name;
                                }).map(y).map(function(e1) {
                                    return e1.type = e1.type || "string", e1;
                                });
                            }
                        }
                    ]), l;
                }(d.n);
            },
            8628: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    h: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        var e1;
                        (0, r.Z)(this, p);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = f.call.apply(f, [
                            this
                        ].concat(n)), (0, s.Z)((0, i.Z)(e1), "map", {
                            identifier: [
                                "username"
                            ]
                        }), e1;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.getData().identifier;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.values, t = e1.credentials, n = e1.password;
                                if (t || n) return t || {
                                    passcode: n
                                };
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return l(l({}, e1.form.value[0]), {}, {
                                    name: "password",
                                    required: e1.required
                                });
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "identify");
            },
            9024: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, c.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var l = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.values.newPassword;
                                if (e1) return {
                                    passcode: e1
                                };
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                var t = "password" === this.getAuthenticator().type ? "newPassword" : "verificationCode";
                                return f(f({}, e1.form.value[0]), {}, {
                                    name: t
                                });
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(l, "remediationName", "reenroll-authenticator");
            },
            8107: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    i: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9024).j);
                (0, c.Z)(s, "remediationName", "reenroll-authenticator-warning");
            },
            8490: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    O: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function() {
                                var e1 = this.remediation;
                                return {
                                    name: e1.name,
                                    type: e1.type,
                                    idp: e1.idp,
                                    href: e1.href
                                };
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "redirect-idp");
            },
            1019: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "reset-authenticator");
            },
            7311: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(3144), i = n(5671), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9164), l = n(6064), p = n(7595);
                var d = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f(e1) {
                        var t, n, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        (0, i.Z)(this, f);
                        var u = "recoverPassword" === (n = s.call(this, e1, o, a)).options.flow;
                        return (null === (t = (0, l.zg)(e1).options) || void 0 === t ? void 0 : t.some(function(e1) {
                            var t = e1.relatesTo;
                            return (null == t ? void 0 : t.key) === p.pc.OKTA_PASSWORD;
                        })) && (u || n.values.password) && (n.values.authenticators = [].concat((0, r.Z)(n.values.authenticators || []), [
                            {
                                key: p.pc.OKTA_PASSWORD
                            }
                        ])), n;
                    }
                    return (0, o.Z)(f);
                }(f.n);
                (0, s.Z)(d, "remediationName", "select-authenticator-authenticate");
            },
            9865: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9164).n);
                (0, c.Z)(s, "remediationName", "select-authenticator-enroll");
            },
            5272: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G: function() {
                        return d;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d() {
                        var e1;
                        (0, r.Z)(this, d);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = l.call.apply(l, [
                            this
                        ].concat(n)), (0, f.Z)((0, i.Z)(e1), "authenticator", void 0), (0, f.Z)((0, i.Z)(e1), "map", {
                            identifier: [
                                "username"
                            ]
                        }), e1;
                    }
                    return (0, o.Z)(d, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.getData("identifier") && (0, a.Z)((0, s.Z)(d.prototype), "canRemediate", this).call(this);
                            }
                        },
                        {
                            key: "mapAuthenticator",
                            value: function(e1) {
                                var t, n, r, o = (0, a.Z)((0, s.Z)(d.prototype), "mapAuthenticator", this).call(this, e1), i = null === (t = this.selectedOption) || void 0 === t ? void 0 : t.value.form.value.find(function(e1) {
                                    return "methodType" === e1.name;
                                }), u = this.values.methodType || (null == i ? void 0 : i.value) || (null == i || null === (n = i.options) || void 0 === n || null === (r = n[0]) || void 0 === r ? void 0 : r.value);
                                return u ? p(p({}, o), {}, {
                                    methodType: u
                                }) : o;
                            }
                        },
                        {
                            key: "getInputUsername",
                            value: function() {
                                return {
                                    name: "username",
                                    type: "string"
                                };
                            }
                        }
                    ]), d;
                }(n(9164).n);
                (0, f.Z)(d, "remediationName", "select-authenticator-unlock-account");
            },
            4713: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !0;
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "select-enroll-profile");
            },
            3403: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    V: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                if (this.values.channel) return !0;
                                if (this.values.authenticator) {
                                    var e1 = this.values.authenticator, t = e1.id, n = e1.channel;
                                    if (t && n) return !0;
                                }
                                return !1;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = t.currentAuthenticator.value;
                                return l(l({}, n), {}, {
                                    authenticator: r
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                var e1;
                                return {
                                    authenticator: {
                                        id: this.remediation.value[0].value.form.value[0].value,
                                        channel: (null === (e1 = this.values.authenticator) || void 0 === e1 ? void 0 : e1.channel) || this.values.channel
                                    },
                                    stateHandle: this.values.stateHandle
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, i.Z)((0, c.Z)(p.prototype), "getValuesAfterProceed", this).call(this), delete this.values.authenticators;
                                var t = this.values.channel ? "channel" : "authenticator";
                                return Object.keys(this.values).filter(function(e1) {
                                    return e1 !== t;
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "select-enrollment-channel");
            },
            8443: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    h: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.skip || "skip" === this.options.step;
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "skip");
            },
            6064: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t;
                    return null === (t = e1.value) || void 0 === t ? void 0 : t.map(function(e1) {
                        return e1.name;
                    });
                }
                function o(e1) {
                    var t;
                    return null === (t = e1.value) || void 0 === t ? void 0 : t.reduce(function(e1, t) {
                        return t.required && e1.push(t.name), e1;
                    }, []);
                }
                function i(e1) {
                    return e1.charAt(0).toUpperCase() + e1.substring(1);
                }
                function a(e1) {
                    return e1.value.find(function(e1) {
                        return "authenticator" === e1.name;
                    });
                }
                n.d(t, {
                    QG: function() {
                        return o;
                    },
                    Qs: function() {
                        return i;
                    },
                    ix: function() {
                        return r;
                    },
                    zg: function() {
                        return a;
                    }
                });
            },
            3377: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    K: function() {
                        return M;
                    }
                });
                var r = n(5861), o = n(4942), i = n(4687), a = n.n(i), u = n(6131), c = n(2660), s = n(1002), f = n(2982), l = n(9123), p = n(5031);
                function d(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return h(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? h(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function h(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    return Object.keys(t.actions).find(function(t) {
                        return !!e1.resend && t.includes("-resend");
                    });
                }
                function m(e1) {
                    return y(y({}, e1), {}, {
                        resend: void 0
                    });
                }
                function b(e1, t) {
                    var n = e1.actions || [];
                    return n = n.filter(function(e1) {
                        return "string" == typeof e1 ? e1 !== t : e1.name !== t;
                    }), y(y({}, e1), {}, {
                        actions: n
                    });
                }
                function k(e1, t, n, r) {
                    return w.apply(this, arguments);
                }
                function w() {
                    return (w = (0, r.Z)(a().mark(function e1(t, n, r, o) {
                        var i, u, c, h, v, w, O, Z, T, E, P, S, x, A, R, _, j, C;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (u = (i = n).neededToProceed, c = i.interactionCode, h = o.flow, !c) {
                                        e1.next = 4;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 4:
                                    if (v = (0, p.l6)(n, r, o), w = g(r, n), O = o.actions || [], !(Z = [].concat((0, f.Z)(O), (0, f.Z)(w && [
                                        w
                                    ] || [])))) {
                                        e1.next = 28;
                                        break;
                                    }
                                    T = d(Z), e1.prev = 10, P = a().mark(function e1() {
                                        var i, c, s, f;
                                        return a().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (i = E.value, c = {}, "string" != typeof i && (c = i.params || {}, i = i.name), s = m(r), f = b(o, i), "function" != typeof n.actions[i]) {
                                                        e1.next = 14;
                                                        break;
                                                    }
                                                    return e1.next = 8, n.actions[i](c);
                                                case 8:
                                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                                        e1.next = 11;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: (0, p.Tc)(t, n, o)
                                                    });
                                                case 11:
                                                    if ("cancel" !== i) {
                                                        e1.next = 13;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: {
                                                            idxResponse: n,
                                                            canceled: !0
                                                        }
                                                    });
                                                case 13:
                                                    return e1.abrupt("return", {
                                                        v: k(t, n, s, f)
                                                    });
                                                case 14:
                                                    if (!u.find(function(e1) {
                                                        return e1.name === i;
                                                    })) {
                                                        e1.next = 22;
                                                        break;
                                                    }
                                                    return e1.next = 18, n.proceed(i, c);
                                                case 18:
                                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                                        e1.next = 21;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: (0, p.Tc)(t, n, o)
                                                    });
                                                case 21:
                                                    return e1.abrupt("return", {
                                                        v: k(t, n, r, f)
                                                    });
                                                case 22:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }), T.s();
                                case 13:
                                    if ((E = T.n()).done) {
                                        e1.next = 20;
                                        break;
                                    }
                                    return e1.delegateYield(P(), "t0", 15);
                                case 15:
                                    if (S = e1.t0, "object" !== (0, s.Z)(S)) {
                                        e1.next = 18;
                                        break;
                                    }
                                    return e1.abrupt("return", S.v);
                                case 18:
                                    e1.next = 13;
                                    break;
                                case 20:
                                    e1.next = 25;
                                    break;
                                case 22:
                                    e1.prev = 22, e1.t1 = e1.catch(10), T.e(e1.t1);
                                case 25:
                                    return e1.prev = 25, T.f(), e1.finish(25);
                                case 28:
                                    if (!(x = (0, p.xn)(n))) {
                                        e1.next = 31;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n,
                                        terminal: x
                                    });
                                case 31:
                                    if (v) {
                                        e1.next = 43;
                                        break;
                                    }
                                    if (!o.step) {
                                        e1.next = 40;
                                        break;
                                    }
                                    return r = (0, p.Ax)(n, o.step, r), e1.next = 36, n.proceed(o.step, r);
                                case 36:
                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                        e1.next = 39;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, p.Tc)(t, n, o));
                                case 39:
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 40:
                                    if ("default" !== h) {
                                        e1.next = 42;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 42:
                                    throw new l.Z("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(u.reduce(function(e1, t) {
                                        return e1 ? e1 + " ," + t.name : t.name;
                                    }, ""), "]\n    "));
                                case 43:
                                    if (v.canRemediate()) {
                                        e1.next = 46;
                                        break;
                                    }
                                    return A = (0, p.TR)(t, v, n), e1.abrupt("return", {
                                        idxResponse: n,
                                        nextStep: A
                                    });
                                case 46:
                                    return R = v.getName(), _ = v.getData(), e1.next = 50, n.proceed(R, _);
                                case 50:
                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                        e1.next = 53;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, p.Tc)(t, n, o));
                                case 53:
                                    if (r = v.getValuesAfterProceed(), !(o = y(y({}, o), {}, {
                                        step: void 0
                                    })).useGenericRemediator || n.interactionCode || (0, p.xn)(n)) {
                                        e1.next = 59;
                                        break;
                                    }
                                    return j = (0, p.l6)(n, r, o), C = (0, p.TR)(t, j, n), e1.abrupt("return", {
                                        idxResponse: n,
                                        nextStep: C
                                    });
                                case 59:
                                    return e1.abrupt("return", k(t, n, r, o));
                                case 60:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                10,
                                22,
                                25,
                                28
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                var O = n(7595), Z = n(2620);
                function T(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function E(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? T(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : T(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function P(e1) {
                    var t = E({}, e1);
                    return [
                        "flow",
                        "remediators",
                        "actions",
                        "withCredentials",
                        "step",
                        "useGenericRemediator",
                        "exchangeCodeForTokens"
                    ].forEach(function(e1) {
                        delete t[e1];
                    }), t;
                }
                function S(e1, t) {
                    var n, r, o = t.options, i = o = E(E({}, e1.options.idx), o), a = i.flow, u = i.withCredentials, c = i.remediators, s = i.actions, f = O.Qd.PENDING;
                    a = a || (null === (n = (r = e1.idx).getFlow) || void 0 === n ? void 0 : n.call(r)) || "default";
                    var l, d;
                    null === (l = (d = e1.idx).setFlow) || void 0 === l || l.call(d, a);
                    var h = (0, p.sH)(e1, a);
                    u = void 0 !== u ? u : h.withCredentials, c = c || h.remediators, s = s || h.actions;
                    return E(E({}, t), {}, {
                        options: E(E({}, o), {}, {
                            flow: a,
                            withCredentials: u,
                            remediators: c,
                            actions: s
                        }),
                        status: f
                    });
                }
                function x(e1, t) {
                    return A.apply(this, arguments);
                }
                function A() {
                    return (A = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, s, f, l, p, d, h, v, y, g, m, b, k, w, O;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.options, o = r.stateHandle, i = r.withCredentials, s = r.version, f = r.state, l = r.scopes, p = r.recoveryToken, d = r.activationToken, h = r.maxAge, v = r.acrValues, y = r.nonce, g = r.useGenericRemediator, b = (0, Z.uN)(t, {
                                        state: f,
                                        recoveryToken: p,
                                        activationToken: d
                                    }), !o) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.next = 6, (0, c.L)(t, {
                                        withCredentials: i,
                                        version: s,
                                        stateHandle: o,
                                        useGenericRemediator: g
                                    });
                                case 6:
                                    m = e1.sent, e1.next = 20;
                                    break;
                                case 9:
                                    if (w = null === (k = b) || void 0 === k ? void 0 : k.interactionHandle) {
                                        e1.next = 17;
                                        break;
                                    }
                                    return t.transactionManager.clear(), e1.next = 14, (0, u.E)(t, {
                                        withCredentials: i,
                                        state: f,
                                        scopes: l,
                                        activationToken: d,
                                        recoveryToken: p,
                                        maxAge: h,
                                        acrValues: v,
                                        nonce: y
                                    });
                                case 14:
                                    O = e1.sent, w = O.interactionHandle, b = O.meta;
                                case 17:
                                    return e1.next = 19, (0, c.L)(t, {
                                        withCredentials: i,
                                        version: s,
                                        interactionHandle: w,
                                        useGenericRemediator: g
                                    });
                                case 19:
                                    m = e1.sent;
                                case 20:
                                    return e1.abrupt("return", E(E({}, n), {}, {
                                        idxResponse: m,
                                        meta: b
                                    }));
                                case 21:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function R(e1, t) {
                    return _.apply(this, arguments);
                }
                function _() {
                    return (_ = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, p, d, h, v, y;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.idxResponse, o = n.options, i = n.values, u = o.autoRemediate, c = o.remediators, s = o.actions, f = o.flow, l = o.step, p = o.useGenericRemediator, !1 !== u && (c || s || l)) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 5:
                                    return i = E(E({}, i), {}, {
                                        stateHandle: r.rawIdxState.stateHandle
                                    }), e1.next = 8, k(t, r, i, {
                                        remediators: c,
                                        actions: s,
                                        flow: f,
                                        step: l,
                                        useGenericRemediator: p
                                    });
                                case 8:
                                    return d = e1.sent, h = d.idxResponse, v = d.nextStep, y = d.canceled, r = h, e1.abrupt("return", E(E({}, n), {}, {
                                        idxResponse: r,
                                        nextStep: v,
                                        canceled: y
                                    }));
                                case 14:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function j(e1, t) {
                    return C.apply(this, arguments);
                }
                function C() {
                    return (C = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, p, d, h;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = n.meta, o = n.idxResponse, i = o.interactionCode, c = (u = r).clientId, s = u.codeVerifier, f = u.ignoreSignature, l = u.redirectUri, p = u.urls, d = u.scopes, e1.next = 5, t.token.exchangeCodeForTokens({
                                        interactionCode: i,
                                        clientId: c,
                                        codeVerifier: s,
                                        ignoreSignature: f,
                                        redirectUri: l,
                                        scopes: d
                                    }, p);
                                case 5:
                                    return h = e1.sent, e1.abrupt("return", h.tokens);
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function I(e1, t) {
                    return D.apply(this, arguments);
                }
                function D() {
                    return (D = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, d, h, v, y, g, m, b, k;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.options, o = n.idxResponse, i = n.canceled, u = n.status, c = r.exchangeCodeForTokens, s = !1, f = !1, l = !0, o && (s = !(!o.requestDidSucceed && !o.stepUp), v = (0, p.KM)(o), y = (0, p.kw)(t, o, r.useGenericRemediator), g = (0, p.lx)(o, r), m = (0, p.xn)(o)), !m) {
                                        e1.next = 15;
                                        break;
                                    }
                                    u = O.Qd.TERMINAL, b = Object.keys(o.actions).length > 0, k = !!g.find(function(e1) {
                                        return "ERROR" === e1.class;
                                    }), b || k || !0 !== o.requestDidSucceed ? s = !!b : f = !0, l = !1, e1.next = 32;
                                    break;
                                case 15:
                                    if (!i) {
                                        e1.next = 20;
                                        break;
                                    }
                                    u = O.Qd.CANCELED, f = !0, e1.next = 32;
                                    break;
                                case 20:
                                    if (null == o || !o.interactionCode) {
                                        e1.next = 32;
                                        break;
                                    }
                                    if (d = o.interactionCode, !1 !== c) {
                                        e1.next = 27;
                                        break;
                                    }
                                    u = O.Qd.SUCCESS, f = !1, e1.next = 32;
                                    break;
                                case 27:
                                    return e1.next = 29, j(t, n);
                                case 29:
                                    h = e1.sent, u = O.Qd.SUCCESS, f = !0;
                                case 32:
                                    return e1.abrupt("return", E(E({}, n), {}, {
                                        status: u,
                                        interactionCode: d,
                                        tokens: h,
                                        shouldSaveResponse: s,
                                        shouldClearTransaction: f,
                                        clearSharedStorage: l,
                                        enabledFeatures: v,
                                        availableSteps: y,
                                        messages: g,
                                        terminal: m
                                    }));
                                case 33:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function M(e1) {
                    return N.apply(this, arguments);
                }
                function N() {
                    return N = (0, r.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, c, s, f, l, p, d, h, v, y, g, m, b, k, w, O, T, A, _, j, C, D, M, N, U = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = {
                                        options: n = U.length > 1 && void 0 !== U[1] ? U[1] : {},
                                        values: P(n)
                                    }, r = S(t, r), e1.next = 5, x(t, r);
                                case 5:
                                    return r = e1.sent, e1.next = 8, R(t, r);
                                case 8:
                                    return r = e1.sent, e1.next = 11, I(t, r);
                                case 11:
                                    return r = e1.sent, i = (o = r).idxResponse, u = o.meta, c = o.shouldSaveResponse, s = o.shouldClearTransaction, f = o.clearSharedStorage, l = o.status, p = o.enabledFeatures, d = o.availableSteps, h = o.tokens, v = o.nextStep, y = o.messages, g = o.error, m = o.interactionCode, s ? t.transactionManager.clear({
                                        clearSharedStorage: f
                                    }) : ((0, Z.r0)(t, E({}, u)), c && (w = (k = i).rawIdxState, O = k.requestDidSucceed, t.transactionManager.saveIdxResponse({
                                        rawIdxResponse: w,
                                        requestDidSucceed: O,
                                        stateHandle: null === (b = i.context) || void 0 === b ? void 0 : b.stateHandle,
                                        interactionHandle: null == u ? void 0 : u.interactionHandle
                                    }))), A = (T = i || {}).actions, _ = T.context, j = T.neededToProceed, C = T.proceed, D = T.rawIdxState, M = T.requestDidSucceed, N = T.stepUp, e1.abrupt("return", E(E(E(E(E(E(E(E(E({
                                        status: l
                                    }, u && {
                                        meta: u
                                    }), p && {
                                        enabledFeatures: p
                                    }), d && {
                                        availableSteps: d
                                    }), h && {
                                        tokens: h
                                    }), v && {
                                        nextStep: v
                                    }), y && y.length && {
                                        messages: y
                                    }), g && {
                                        error: g
                                    }), N && {
                                        stepUp: N
                                    }), {}, {
                                        interactionCode: m,
                                        actions: A,
                                        context: _,
                                        neededToProceed: j,
                                        proceed: C,
                                        rawIdxState: D,
                                        requestDidSucceed: M
                                    }));
                                case 16:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), N.apply(this, arguments);
                }
            },
            2473: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return f;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377);
                function c(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function s(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function f(e1) {
                    return l.apply(this, arguments);
                }
                function l() {
                    return l = (0, o.Z)(a().mark(function e1(t) {
                        var n, r = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = r.length > 1 && void 0 !== r[1] ? r[1] : {}, t.transactionManager.clear(), e1.abrupt("return", (0, u.K)(t, s({
                                        exchangeCodeForTokens: !1
                                    }, n)));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), l.apply(this, arguments);
                }
            },
            4143: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(5763), s = n(1971), f = n(2647), l = n(415), p = n(146), d = n(9123);
                function h() {
                    return function(e1) {
                        (0, i.Z)(h, e1);
                        var t, n, f = (t = h, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, u.Z)(t);
                            if (n) {
                                var o = (0, u.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, a.Z)(this, e1);
                        });
                        function h(e1, t, n) {
                            return (0, r.Z)(this, h), f.call(this, e1, t, n);
                        }
                        return (0, o.Z)(h, [
                            {
                                key: "getIdxResponseStorage",
                                value: function(e1) {
                                    var t;
                                    if ((0, l.isBrowser)()) try {
                                        t = this.storageUtil.getStorageByType("memory", e1);
                                    } catch (e1) {
                                        (0, p.ZK)("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic");
                                    }
                                    else {
                                        var n = this.getTransactionStorage(e1);
                                        n && (t = {
                                            getItem: function(e1) {
                                                var t = n.getStorage();
                                                return t && t[e1] ? t[e1] : null;
                                            },
                                            setItem: function(e1, t) {
                                                var r = n.getStorage();
                                                if (!r) throw new d.Z("Transaction has been cleared, failed to save idxState");
                                                r[e1] = t, n.setStorage(r);
                                            },
                                            removeItem: function(e1) {
                                                var t = n.getStorage();
                                                t && (delete t[e1], n.setStorage(t));
                                            }
                                        });
                                    }
                                    return t ? new c._(t, s.IDX_RESPONSE_STORAGE_NAME) : null;
                                }
                            }
                        ]), h;
                    }((0, f.a)());
                }
            },
            2620: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $0: function() {
                        return h;
                    },
                    Co: function() {
                        return y;
                    },
                    Jm: function() {
                        return b;
                    },
                    UC: function() {
                        return O;
                    },
                    Wf: function() {
                        return k;
                    },
                    Xc: function() {
                        return p;
                    },
                    bl: function() {
                        return w;
                    },
                    r0: function() {
                        return m;
                    },
                    uN: function() {
                        return v;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3193), c = n(146), s = n(2865);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function p(e1) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return d = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, c, f, p, d, h, v, y, g, m, b, k, w, O = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = O.length > 1 && void 0 !== O[1] ? O[1] : {}, e1.next = 3, t.token.prepareTokenParams(n);
                                case 3:
                                    return r = e1.sent, o = (0, s.H)(t, r), i = l(l({}, t.options), n), u = i.flow, c = void 0 === u ? "default" : u, f = i.withCredentials, p = void 0 === f || f, d = i.activationToken, h = void 0 === d ? void 0 : d, v = i.recoveryToken, y = void 0 === v ? void 0 : v, g = i.maxAge, m = void 0 === g ? void 0 : g, b = i.acrValues, k = void 0 === b ? void 0 : b, w = l(l({}, o), {}, {
                                        flow: c,
                                        withCredentials: p,
                                        activationToken: h,
                                        recoveryToken: y,
                                        maxAge: m,
                                        acrValues: k
                                    }), e1.abrupt("return", w);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), d.apply(this, arguments);
                }
                function h(e1, t) {
                    var n = v(e1, t);
                    return !(null == n || !n.interactionHandle);
                }
                function v(e1, t) {
                    var n;
                    t = (0, u.YY)(t), t = l(l({}, e1.options), t);
                    try {
                        n = e1.transactionManager.load(t);
                    } catch (e1) {}
                    if (n) return k(n, t) ? n : void (0, c.ZK)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");
                }
                function y(e1, t) {
                    return g.apply(this, arguments);
                }
                function g() {
                    return (g = (0, o.Z)(a().mark(function e1(t, n) {
                        var r;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = (0, u.YY)(n), n = l(l({}, t.options), n), !(r = v(t, n))) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", r);
                                case 5:
                                    return e1.abrupt("return", p(t, n));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function m(e1, t) {
                    e1.transactionManager.save(t, {
                        muteWarning: !0
                    });
                }
                function b(e1) {
                    e1.transactionManager.clear();
                }
                function k(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return !1 !== O(e1, t, [
                        "issuer",
                        "clientId",
                        "redirectUri",
                        "state",
                        "codeChallenge",
                        "codeChallengeMethod",
                        "activationToken",
                        "recoveryToken"
                    ]) && !1 !== w(e1, t.flow);
                }
                function w(e1, t) {
                    return !(t && "default" !== t && "proceed" !== t) || t === e1.flow;
                }
                function O(e1, t, n) {
                    return !n.some(function(n) {
                        var r = t[n];
                        if (r && r !== e1[n]) return !0;
                    });
                }
            },
            7595: function(e1, t, n) {
                "use strict";
                var r, o, i;
                function a(e1) {
                    return e1 && (e1.key || e1.id);
                }
                n.d(t, {
                    Fw: function() {
                        return i;
                    },
                    H: function() {
                        return a;
                    },
                    Qd: function() {
                        return r;
                    },
                    pc: function() {
                        return o;
                    }
                }), function(e1) {
                    e1.SUCCESS = "SUCCESS", e1.PENDING = "PENDING", e1.FAILURE = "FAILURE", e1.TERMINAL = "TERMINAL", e1.CANCELED = "CANCELED";
                }(r || (r = {})), function(e1) {
                    e1.OKTA_PASSWORD = "okta_password", e1.OKTA_EMAIL = "okta_email", e1.PHONE_NUMBER = "phone_number", e1.GOOGLE_AUTHENTICATOR = "google_otp", e1.SECURITY_QUESTION = "security_question", e1.OKTA_VERIFY = "okta_verify", e1.WEBAUTHN = "webauthn";
                }(o || (o = {})), function(e1) {
                    e1.PASSWORD_RECOVERY = "recover-password", e1.REGISTRATION = "enroll-profile", e1.SOCIAL_IDP = "redirect-idp", e1.ACCOUNT_UNLOCK = "unlock-account";
                }(i || (i = {}));
            },
            480: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return e1 && e1.version;
                }
                n.d(t, {
                    P: function() {
                        return r;
                    }
                });
            },
            8277: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    l: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(2473), f = n(9123), l = n(7595);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if ((n = i.length > 1 && void 0 !== i[1] ? i[1] : {}).flow = "unlockAccount", (0, c.$0)(t)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.next = 5, (0, s.Y)(t, d(d({}, n), {}, {
                                        autoRemediate: !1
                                    }));
                                case 5:
                                    if (r = e1.sent, !(o = r.enabledFeatures) || o.includes(l.Fw.ACCOUNT_UNLOCK)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new f.Z("Self Service Account Unlock is not supported based on your current org configuration.");
                                case 9:
                                    return e1.abrupt("return", (0, u.K)(t, d({}, n)));
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            5031: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Ax: function() {
                        return S;
                    },
                    KM: function() {
                        return E;
                    },
                    TC: function() {
                        return k;
                    },
                    TR: function() {
                        return R;
                    },
                    Tc: function() {
                        return _;
                    },
                    kw: function() {
                        return P;
                    },
                    l6: function() {
                        return A;
                    },
                    lx: function() {
                        return T;
                    },
                    sH: function() {
                        return w;
                    },
                    xn: function() {
                        return O;
                    }
                });
                var r = n(4942), o = n(4925), i = n(5861), a = n(885), u = n(2982), c = n(4687), s = n.n(c), f = n(8750), l = n(146), p = n(9732), d = n(7595), h = [
                    "href",
                    "method",
                    "rel",
                    "accepts",
                    "produces"
                ];
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return m(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? m(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function m(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var b = {
                    remediators: {},
                    getFlowSpecification: function(e1) {
                        return {
                            remediators: {}
                        };
                    }
                };
                function k(e1) {
                    Object.assign(b, e1);
                }
                function w(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default";
                    return b.getFlowSpecification(e1, t);
                }
                function O(e1) {
                    var t = e1.neededToProceed, n = e1.interactionCode;
                    return !t.length && !n;
                }
                function Z(e1) {
                    if (e1 && Array.isArray(e1)) return e1.reduce(function(e1, t) {
                        if (t.messages && (e1 = [].concat((0, u.Z)(e1), (0, u.Z)(t.messages.value))), t.form) {
                            var n = Z(t.form.value) || [];
                            e1 = [].concat((0, u.Z)(e1), (0, u.Z)(n));
                        }
                        if (t.options) {
                            var r = [];
                            t.options.forEach(function(e1) {
                                e1.value && "string" != typeof e1.value && (r = [].concat((0, u.Z)(r), [
                                    e1.value
                                ]));
                            });
                            var o = Z(r) || [];
                            e1 = [].concat((0, u.Z)(e1), (0, u.Z)(o));
                        }
                        return e1;
                    }, []);
                }
                function T(e1, t) {
                    var n, r = [], o = e1.rawIdxState, i = e1.neededToProceed, a = null === (n = o.messages) || void 0 === n ? void 0 : n.value.map(function(e1) {
                        return e1;
                    });
                    if (a && (r = [].concat((0, u.Z)(r), (0, u.Z)(a))), !t.useGenericRemediator) {
                        var c, s = g(i);
                        try {
                            for(s.s(); !(c = s.n()).done;){
                                var f = Z(c.value.value);
                                f && (r = [].concat((0, u.Z)(r), (0, u.Z)(f)));
                            }
                        } catch (e1) {
                            s.e(e1);
                        } finally{
                            s.f();
                        }
                    }
                    var l = {};
                    return r.reduce(function(e1, t) {
                        var n, r = null === (n = t.i18n) || void 0 === n ? void 0 : n.key;
                        return r && l[r] && t.message === l[r].message ? e1 : (l[r] = t, e1 = [].concat((0, u.Z)(e1), [
                            t
                        ]));
                    }, []);
                }
                function E(e1) {
                    var t = [], n = e1.actions, r = e1.neededToProceed;
                    return n["currentAuthenticator-recover"] && t.push(d.Fw.PASSWORD_RECOVERY), r.some(function(e1) {
                        return "select-enroll-profile" === e1.name;
                    }) && t.push(d.Fw.REGISTRATION), r.some(function(e1) {
                        return "redirect-idp" === e1.name;
                    }) && t.push(d.Fw.SOCIAL_IDP), r.some(function(e1) {
                        return "unlock-account" === e1.name;
                    }) && t.push(d.Fw.ACCOUNT_UNLOCK), t;
                }
                function P(e1, t, n) {
                    var r, u = [], c = Object.values(b.remediators).reduce(function(e1, t) {
                        return t.remediationName && (e1[t.remediationName] = t), e1;
                    }, {}), l = g(t.neededToProceed);
                    try {
                        for(l.s(); !(r = l.n()).done;){
                            var p = r.value, d = x(p, {
                                useGenericRemediator: n,
                                remediators: c
                            });
                            if (d) {
                                var v = new d(p);
                                u.push(v.getNextStep(e1, t.context));
                            }
                        }
                    } catch (e1) {
                        l.e(e1);
                    } finally{
                        l.f();
                    }
                    for(var m = function() {
                        var n, r = (0, a.Z)(w[k], 1)[0], c = {
                            name: r,
                            action: (n = (0, i.Z)(s().mark(function t(n) {
                                return s().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return t.abrupt("return", e1.idx.proceed({
                                                actions: [
                                                    {
                                                        name: r,
                                                        params: n
                                                    }
                                                ]
                                            }));
                                        case 1:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            })), function(e1) {
                                return n.apply(this, arguments);
                            })
                        };
                        if (r.startsWith("currentAuthenticator")) {
                            var l, p = (0, f.YQ)(r, "-"), d = (0, a.Z)(p, 2), v = d[0], g = d[1], m = t.rawIdxState[v].value[g], b = (m.href, m.method, m.rel, m.accepts, m.produces, (0, o.Z)(m, h)), O = null === (l = m.value) || void 0 === l ? void 0 : l.filter(function(e1) {
                                return "stateHandle" !== e1.name;
                            });
                            c = y(y(y({}, b), O && {
                                value: O
                            }), c);
                        }
                        u.push(c);
                    }, k = 0, w = Object.entries(t.actions || {}); k < w.length; k++)m();
                    return u;
                }
                function S(e1, t, n) {
                    var r = (e1.neededToProceed || []).find(function(e1) {
                        return e1.name === t;
                    });
                    return r ? r.value.reduce(function(e1, t) {
                        var r = t.name, o = t.value;
                        return e1[r] = "stateHandle" === r ? o : n[r], e1;
                    }, {}) : ((0, l.ZK)('filterValuesForRemediation: "'.concat(t, '" did not match any remediations')), n);
                }
                function x(e1, t) {
                    var n = t.useGenericRemediator, r = t.remediators;
                    if (e1) return n ? p.P : r[e1.name];
                }
                function A(e1, t, n) {
                    var r, o = n.remediators, i = n.useGenericRemediator, a = e1.neededToProceed, u = e1.context;
                    if (!n.step) {
                        var c = [];
                        if (i) c.push(new p.P(a[0], t, n));
                        else {
                            var s, f = g(a);
                            try {
                                for(f.s(); !(s = f.n()).done;){
                                    var d = s.value;
                                    if (Object.keys(o).includes(d.name)) {
                                        if ((r = new (x(d, n))(d, t, n)).canRemediate(u)) return r;
                                        c.push(r);
                                    }
                                }
                            } catch (e1) {
                                f.e(e1);
                            } finally{
                                f.f();
                            }
                        }
                        return c[0];
                    }
                    var h = a.find(function(e1) {
                        return e1.name === n.step;
                    });
                    if (h) {
                        var v = x(h, n);
                        return v ? new v(h, t, n) : void 0;
                    }
                    (0, l.ZK)('step "'.concat(n.step, '" did not match any remediations'));
                }
                function R(e1, t, n) {
                    var r = t.getNextStep(e1, n.context), o = function(e1) {
                        return e1.neededToProceed.some(function(e1) {
                            return "skip" === e1.name;
                        });
                    }(n), i = function(e1) {
                        return Object.keys(e1.actions).some(function(e1) {
                            return e1.includes("resend");
                        });
                    }(n);
                    return y(y(y({}, r), o && {
                        canSkip: o
                    }), i && {
                        canResend: i
                    });
                }
                function _(e1, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = O(t), o = T(t, n);
                    if (r) return {
                        idxResponse: t,
                        terminal: r,
                        messages: o
                    };
                    var i = A(t, {}, n), a = i && R(e1, i, t);
                    return y({
                        idxResponse: t,
                        messages: o
                    }, a && {
                        nextStep: a
                    });
                }
            },
            8716: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    buildCredentialCreationOptions: function() {
                        return s;
                    },
                    buildCredentialRequestOptions: function() {
                        return f;
                    },
                    getAssertion: function() {
                        return p;
                    },
                    getAttestation: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(7987);
                function i(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function a(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var u = function(e1) {
                    var t = e1;
                    if ("string" == typeof t) try {
                        t = t.split(",");
                    } catch (e1) {
                        return;
                    }
                    return Array.isArray(t) ? t : void 0;
                }, c = function() {
                    var e1 = [];
                    return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).forEach(function(t) {
                        if ("webauthn" === t.key) {
                            var n, r, i = {
                                type: "public-key",
                                id: (0, o.dX)(t.credentialId)
                            }, a = null !== (n = u(t.transports)) && void 0 !== n ? n : u(null === (r = t.profile) || void 0 === r ? void 0 : r.transports);
                            a && (i.transports = a), e1.push(i);
                        }
                    }), e1;
                }, s = function(e1, t) {
                    return {
                        publicKey: a({
                            rp: e1.rp,
                            user: {
                                id: (0, o.dX)(e1.user.id),
                                name: e1.user.name,
                                displayName: e1.user.displayName
                            },
                            challenge: (0, o.dX)(e1.challenge),
                            pubKeyCredParams: e1.pubKeyCredParams,
                            attestation: e1.attestation,
                            authenticatorSelection: e1.authenticatorSelection,
                            excludeCredentials: c(t)
                        }, e1.hints && {
                            hints: e1.hints
                        })
                    };
                }, f = function(e1, t) {
                    return {
                        publicKey: a(a({
                            challenge: (0, o.dX)(e1.challenge),
                            userVerification: e1.userVerification,
                            allowCredentials: c(t)
                        }, e1.rpId && {
                            rpId: e1.rpId
                        }), e1.hints && {
                            hints: e1.hints
                        })
                    };
                }, l = function(e1) {
                    var t = e1.response, n = e1.id, r = (0, o.kQ)(t.clientDataJSON), i = (0, o.kQ)(t.attestationObject), a = t.getTransports, u = {
                        id: n,
                        clientData: r,
                        attestation: i
                    };
                    return "function" == typeof a && (u.transports = JSON.stringify(a.call(t))), u;
                }, p = function(e1) {
                    var t = e1.response;
                    return {
                        id: e1.id,
                        clientData: (0, o.kQ)(t.clientDataJSON),
                        authenticatorData: (0, o.kQ)(t.authenticatorData),
                        signatureData: (0, o.kQ)(t.signature)
                    };
                };
            },
            9108: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    addEmail: function() {
                        return B;
                    },
                    addPhone: function() {
                        return z;
                    },
                    deleteEmail: function() {
                        return K;
                    },
                    deletePassword: function() {
                        return oe;
                    },
                    deletePhone: function() {
                        return Q;
                    },
                    enrollPassword: function() {
                        return ne;
                    },
                    getEmail: function() {
                        return H;
                    },
                    getEmailChallenge: function() {
                        return G;
                    },
                    getEmails: function() {
                        return L;
                    },
                    getPassword: function() {
                        return te;
                    },
                    getPhone: function() {
                        return Y;
                    },
                    getPhones: function() {
                        return W;
                    },
                    getProfile: function() {
                        return A;
                    },
                    getProfileSchema: function() {
                        return _;
                    },
                    sendEmailChallenge: function() {
                        return F;
                    },
                    sendPhoneChallenge: function() {
                        return X;
                    },
                    updatePassword: function() {
                        return re;
                    },
                    updateProfile: function() {
                        return R;
                    },
                    verifyEmailChallenge: function() {
                        return V;
                    },
                    verifyPhoneChallenge: function() {
                        return J;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(4942), u = n(1002), c = n(4925), s = n(3144), f = n(5671), l = [
                    "headers"
                ], p = (0, s.Z)(function e1(t, n) {
                    var r = this;
                    (0, f.Z)(this, e1), (0, a.Z)(this, "headers", void 0);
                    var o = n.res, i = o.headers, u = (0, c.Z)(o, l);
                    i && (this.headers = i), Object.keys(u).forEach(function(e1) {
                        "_links" !== e1 && (r[e1] = u[e1]);
                    });
                }), d = n(5385), h = n(9123);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, a.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return m = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c, s, f, l, v, g, m, b, k, w, O, Z, T = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = T.length > 2 && void 0 !== T[2] ? T[2] : p, o = t.tokenManager.getTokensSync(), a = o.accessToken, u = n.accessToken || a, c = t.getIssuerOrigin(), s = n.url, f = n.method, l = n.payload, v = s.startsWith(c) ? s : "".concat(c).concat(s), u) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new h.Z("AccessToken is required to request MyAccount API endpoints.");
                                case 8:
                                    if (g = u, m = y({
                                        headers: {
                                            Accept: "*/*;okta-version=1.0.0"
                                        },
                                        url: v,
                                        method: f
                                    }, l && {
                                        args: l
                                    }), !t.options.dpop) {
                                        e1.next = 22;
                                        break;
                                    }
                                    if ("string" != typeof g) {
                                        e1.next = 13;
                                        break;
                                    }
                                    throw new h.Z("AccessToken object must be provided when using dpop");
                                case 13:
                                    return e1.next = 15, t.getDPoPAuthorizationHeaders({
                                        method: f,
                                        url: v,
                                        accessToken: g
                                    });
                                case 15:
                                    b = e1.sent, k = b.Authorization, w = b.Dpop, m.headers.Authorization = k, m.headers.Dpop = w, e1.next = 24;
                                    break;
                                case 22:
                                    g = "string" == typeof g ? g : g.accessToken, m.accessToken = g;
                                case 24:
                                    return e1.next = 26, (0, d.c3)(t, m);
                                case 26:
                                    return O = e1.sent, Z = Array.isArray(O) ? O.map(function(e1) {
                                        return new r(t, {
                                            res: e1,
                                            accessToken: g
                                        });
                                    }) : new r(t, {
                                        res: O,
                                        accessToken: g
                                    }), e1.abrupt("return", Z);
                                case 29:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), m.apply(this, arguments);
                }
                function b(e1) {
                    for(var t = e1.oktaAuth, n = e1.accessToken, o = e1.methodName, a = e1.links, c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p, s = function() {
                        var e1, u = l[f];
                        if (u.toLowerCase() === o) {
                            var s = a.self;
                            return {
                                v: (e1 = (0, r.Z)(i().mark(function e1(r) {
                                    return i().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.abrupt("return", g(t, {
                                                    accessToken: n,
                                                    url: s.href,
                                                    method: u,
                                                    payload: r
                                                }, c));
                                            case 1:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                })), function(t) {
                                    return e1.apply(this, arguments);
                                })
                            };
                        }
                    }, f = 0, l = [
                        "GET",
                        "POST",
                        "PUT",
                        "DELETE"
                    ]; f < l.length; f++){
                        var d = s();
                        if ("object" === (0, u.Z)(d)) return d.v;
                    }
                    var v, y = a[o];
                    if (!y) throw new h.Z("No link is found with methodName: ".concat(o));
                    return v = (0, r.Z)(i().mark(function e1(r) {
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.abrupt("return", g(t, {
                                        accessToken: n,
                                        url: y.href,
                                        method: y.hints.allow[0],
                                        payload: r
                                    }, c));
                                case 1:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), function(e1) {
                        return v.apply(this, arguments);
                    };
                }
                var k = n(7326), w = n(136), O = n(2963), Z = n(1120);
                var T = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "createdAt", void 0), (0, a.Z)((0, k.Z)(n), "modifiedAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0);
                        var i = t.res, u = i.createdAt, c = i.modifiedAt, s = i.profile;
                        return n.createdAt = u, n.modifiedAt = c, n.profile = s, n;
                    }
                    return (0, s.Z)(o);
                }(p);
                var E, P, S, x = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        return (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "properties", void 0), n.properties = t.res.properties, n;
                    }
                    return (0, s.Z)(o);
                }(p), A = (E = (0, r.Z)(i().mark(function e1(t, n) {
                    var r;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return e1.next = 2, g(t, {
                                    url: "/idp/myaccount/profile",
                                    method: "GET",
                                    accessToken: null == n ? void 0 : n.accessToken
                                }, T);
                            case 2:
                                return r = e1.sent, e1.abrupt("return", r);
                            case 4:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return E.apply(this, arguments);
                }), R = (P = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).payload, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/profile",
                                    method: "PUT",
                                    payload: o,
                                    accessToken: a
                                }, T);
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return P.apply(this, arguments);
                }), _ = (S = (0, r.Z)(i().mark(function e1(t, n) {
                    var r;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return e1.next = 2, g(t, {
                                    url: "/idp/myaccount/profile/schema",
                                    method: "GET",
                                    accessToken: null == n ? void 0 : n.accessToken
                                }, x);
                            case 2:
                                return r = e1.sent, e1.abrupt("return", r);
                            case 4:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return S.apply(this, arguments);
                });
                var j = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "expiresAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0);
                        var i = t.res, u = i.id, c = i.profile, s = i.expiresAt, l = i.status;
                        return n.id = u, n.expiresAt = s, n.profile = c, n.status = l, n;
                    }
                    return (0, s.Z)(o);
                }(p);
                var C = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "expiresAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "poll", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c = t.accessToken, s = t.res, l = s.id, p = s.expiresAt, d = s.profile, h = s.status, v = s._links;
                        return n.id = l, n.expiresAt = p, n.profile = d, n.status = h, n.poll = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: c,
                                            methodName: "poll",
                                            links: v
                                        }, j), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.verify = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: c,
                                                methodName: "verify",
                                                links: v
                                            }, u), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }(), n;
                    }
                    return (0, s.Z)(u);
                }(p);
                var I, D, M, N, U = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "roles", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0), (0, a.Z)((0, k.Z)(n), "challenge", void 0), (0, a.Z)((0, k.Z)(n), "poll", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c, s = t.accessToken, l = t.res, p = l.id, d = l.profile, h = l.roles, v = l.status, y = l._links;
                        return n.id = p, n.profile = d, n.roles = h, n.status = v, n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "get",
                                            links: y
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "delete",
                                            links: y
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.challenge = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "challenge",
                                            links: y
                                        }, C), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), y.poll && (n.poll = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "poll",
                                            links: y
                                        }, j), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }))), y.verify && (n.verify = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "verify",
                                            links: y
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        })), n;
                    }
                    return (0, s.Z)(u);
                }(p), L = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/emails",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, U);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), H = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/emails/".concat(o),
                                        method: "GET",
                                        accessToken: a
                                    }, U);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), B = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/emails",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, U);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), K = (I = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o),
                                    method: "DELETE",
                                    accessToken: a
                                });
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return I.apply(this, arguments);
                }), F = (D = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge"),
                                    method: "POST",
                                    accessToken: a
                                }, C);
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return D.apply(this, arguments);
                }), G = (M = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u, c;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).emailId, a = r.challengeId, u = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(a),
                                    method: "POST",
                                    accessToken: u
                                }, C);
                            case 3:
                                return c = e1.sent, e1.abrupt("return", c);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return M.apply(this, arguments);
                }), V = (N = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u, c, s;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).emailId, a = r.challengeId, u = r.payload, c = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(a, "/verify"),
                                    method: "POST",
                                    payload: u,
                                    accessToken: c
                                });
                            case 3:
                                return s = e1.sent, e1.abrupt("return", s);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return N.apply(this, arguments);
                });
                var q = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0), (0, a.Z)((0, k.Z)(n), "challenge", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c, s = t.res, l = t.accessToken, p = s.id, d = s.profile, h = s.status, v = s._links;
                        return n.id = p, n.profile = d, n.status = h, n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "get",
                                            links: v
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "delete",
                                            links: v
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.challenge = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "challenge",
                                            links: v
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        }), v.verify && (n.verify = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: l,
                                                methodName: "verify",
                                                links: v
                                            }), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }()), n;
                    }
                    return (0, s.Z)(u);
                }(p), W = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/phones",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, q);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), Y = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.id, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(a),
                                        method: "GET",
                                        accessToken: o
                                    }, q);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), z = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, q);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), Q = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(o),
                                        method: "DELETE",
                                        accessToken: a
                                    });
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), X = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.id, u = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(a, "/challenge"),
                                        method: "POST",
                                        payload: u,
                                        accessToken: o
                                    });
                                case 3:
                                    return c = e1.sent, e1.abrupt("return", c);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), J = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.payload, u = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(o, "/verify"),
                                        method: "POST",
                                        payload: a,
                                        accessToken: u
                                    });
                                case 3:
                                    return c = e1.sent, e1.abrupt("return", c);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), $ = n(8008);
                var ee = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "created", void 0), (0, a.Z)((0, k.Z)(n), "lastUpdated", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "enroll", void 0), (0, a.Z)((0, k.Z)(n), "update", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0);
                        var c, s = t.res, l = t.accessToken, p = s.id, d = s.status, h = s.created, v = s.lastUpdated, y = s._links;
                        return n.id = p, n.status = d, n.created = h, n.lastUpdated = v, n.status == $.Fn.NOT_ENROLLED ? n.enroll = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: l,
                                                methodName: "enroll",
                                                links: y
                                            }, u), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }() : (n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "get",
                                            links: y
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.update = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "put",
                                            links: y
                                        }, u), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        }), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "delete",
                                            links: y
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }))), n;
                    }
                    return (0, s.Z)(u);
                }(p), te = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, ee);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), ne = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, ee);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), re = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "PUT",
                                        payload: a,
                                        accessToken: o
                                    }, ee);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), oe = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "DELETE",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    });
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }();
            },
            1132: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    aw: function() {
                        return u.aw;
                    },
                    Fn: function() {
                        return u.Fn;
                    },
                    qb: function() {
                        return u.qb;
                    },
                    no: function() {
                        return r.addEmail;
                    },
                    Z1: function() {
                        return r.addPhone;
                    },
                    Xc: function() {
                        return a;
                    },
                    nd: function() {
                        return r.deleteEmail;
                    },
                    QN: function() {
                        return r.deletePassword;
                    },
                    qj: function() {
                        return r.deletePhone;
                    },
                    xg: function() {
                        return r.enrollPassword;
                    },
                    OD: function() {
                        return r.getEmail;
                    },
                    hG: function() {
                        return r.getEmailChallenge;
                    },
                    G5: function() {
                        return r.getEmails;
                    },
                    Ij: function() {
                        return r.getPassword;
                    },
                    u_: function() {
                        return r.getPhone;
                    },
                    Po: function() {
                        return r.getPhones;
                    },
                    Ai: function() {
                        return r.getProfile;
                    },
                    aF: function() {
                        return r.getProfileSchema;
                    },
                    HT: function() {
                        return i.H;
                    },
                    ME: function() {
                        return r.sendEmailChallenge;
                    },
                    dv: function() {
                        return r.sendPhoneChallenge;
                    },
                    gQ: function() {
                        return r.updatePassword;
                    },
                    ck: function() {
                        return r.updateProfile;
                    },
                    T8: function() {
                        return r.verifyEmailChallenge;
                    },
                    Lo: function() {
                        return r.verifyPhoneChallenge;
                    }
                });
                var r = n(9108), o = n(1578), i = n(6794);
                function a(e1, t, n) {
                    var r = (0, o.K)(e1, t, n);
                    return (0, i.H)(r);
                }
                var u = n(8008);
            },
            6794: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return p;
                    }
                });
                var r = n(885), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(9108);
                function p(e1) {
                    return function(e1) {
                        (0, u.Z)(d, e1);
                        var t, n, p = (t = d, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, s.Z)(t);
                            if (n) {
                                var o = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function d() {
                            var e1;
                            (0, i.Z)(this, d);
                            for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                            return e1 = p.call.apply(p, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "myaccount", void 0), e1.myaccount = Object.entries(l).filter(function(e1) {
                                return "default" !== (0, r.Z)(e1, 1)[0];
                            }).reduce(function(t, n) {
                                var o = (0, r.Z)(n, 2), i = o[0], u = o[1];
                                return t[i] = u.bind(null, (0, a.Z)(e1)), t;
                            }, {}), e1;
                        }
                        return (0, o.Z)(d);
                    }(e1);
                }
            },
            8008: function(e1, t, n) {
                "use strict";
                var r, o, i;
                n.d(t, {
                    Fn: function() {
                        return i;
                    },
                    aw: function() {
                        return r;
                    },
                    qb: function() {
                        return o;
                    }
                }), function(e1) {
                    e1.PRIMARY = "PRIMARY", e1.SECONDARY = "SECONDARY";
                }(r || (r = {})), function(e1) {
                    e1.VERIFIED = "VERIFIED", e1.UNVERIFIED = "UNVERIFIED";
                }(o || (o = {})), function(e1) {
                    e1.NOT_ENROLLED = "NOT_ENROLLED", e1.ACTIVE = "ACTIVE";
                }(i || (i = {}));
            },
            2427: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return w;
                    }
                });
                var r = n(5861), o = n(1002), i = n(5671), a = n(3144), u = n(4942), c = n(4687), s = n.n(c), f = n(3193), l = n(9123), p = n(2482), d = n(415), h = function() {
                    function e1(t) {
                        (0, i.Z)(this, e1), (0, u.Z)(this, "localOffset", void 0), this.localOffset = parseInt(t || 0);
                    }
                    return (0, a.Z)(e1, [
                        {
                            key: "now",
                            value: function() {
                                return (Date.now() + this.localOffset) / 1e3;
                            }
                        }
                    ], [
                        {
                            key: "create",
                            value: function() {
                                return new e1(0);
                            }
                        }
                    ]), e1;
                }(), v = n(7088), y = n(6488), g = n(1971);
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, u.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = {
                    autoRenew: !0,
                    autoRemove: !0,
                    syncStorage: !0,
                    clearPendingRemoveTokens: !0,
                    storage: void 0,
                    expireEarlySeconds: 30,
                    storageKey: g.TOKEN_STORAGE_NAME
                }, w = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        if ((0, i.Z)(this, e1), (0, u.Z)(this, "sdk", void 0), (0, u.Z)(this, "clock", void 0), (0, u.Z)(this, "emitter", void 0), (0, u.Z)(this, "storage", void 0), (0, u.Z)(this, "state", void 0), (0, u.Z)(this, "options", void 0), this.sdk = t, this.emitter = t.emitter, !this.emitter) throw new l.Z("Emitter should be initialized before TokenManager");
                        n = Object.assign({}, k, (0, f.YY)(n)), (0, d.isLocalhost)() || (n.expireEarlySeconds = k.expireEarlySeconds), this.options = n;
                        var r = (0, f.YY)({
                            storageKey: n.storageKey,
                            secure: n.secure
                        });
                        "object" === (0, o.Z)(n.storage) ? r.storageProvider = n.storage : n.storage && (r.storageType = n.storage), this.storage = t.storageManager.getTokenStorage(b(b({}, r), {}, {
                            useSeparateCookies: !0
                        })), this.clock = h.create(), this.state = {
                            expireTimeouts: {},
                            renewPromise: null
                        };
                    }
                    var t, n, c;
                    return (0, a.Z)(e1, [
                        {
                            key: "on",
                            value: function(e1, t, n) {
                                n ? this.emitter.on(e1, t, n) : this.emitter.on(e1, t);
                            }
                        },
                        {
                            key: "off",
                            value: function(e1, t) {
                                t ? this.emitter.off(e1, t) : this.emitter.off(e1);
                            }
                        },
                        {
                            key: "start",
                            value: function() {
                                this.options.clearPendingRemoveTokens && this.clearPendingRemoveTokens(), this.setExpireEventTimeoutAll(), this.state.started = !0;
                            }
                        },
                        {
                            key: "stop",
                            value: function() {
                                this.clearExpireEventTimeoutAll(), this.state.started = !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return !!this.state.started;
                            }
                        },
                        {
                            key: "getOptions",
                            value: function() {
                                return (0, f.d9)(this.options);
                            }
                        },
                        {
                            key: "getExpireTime",
                            value: function(e1) {
                                var t = this.options.expireEarlySeconds || 0;
                                return e1.expiresAt - t;
                            }
                        },
                        {
                            key: "hasExpired",
                            value: function(e1) {
                                return this.getExpireTime(e1) <= this.clock.now();
                            }
                        },
                        {
                            key: "emitExpired",
                            value: function(e1, t) {
                                this.emitter.emit(v.$Y, e1, t);
                            }
                        },
                        {
                            key: "emitRenewed",
                            value: function(e1, t, n) {
                                this.emitter.emit(v.E, e1, t, n);
                            }
                        },
                        {
                            key: "emitAdded",
                            value: function(e1, t) {
                                this.emitter.emit(v.O3, e1, t);
                            }
                        },
                        {
                            key: "emitRemoved",
                            value: function(e1, t) {
                                this.emitter.emit(v.FT, e1, t);
                            }
                        },
                        {
                            key: "emitError",
                            value: function(e1) {
                                this.emitter.emit(v.$I, e1);
                            }
                        },
                        {
                            key: "clearExpireEventTimeout",
                            value: function(e1) {
                                clearTimeout(this.state.expireTimeouts[e1]), delete this.state.expireTimeouts[e1], this.state.renewPromise = null;
                            }
                        },
                        {
                            key: "clearExpireEventTimeoutAll",
                            value: function() {
                                var e1 = this.state.expireTimeouts;
                                for(var t in e1)Object.prototype.hasOwnProperty.call(e1, t) && this.clearExpireEventTimeout(t);
                            }
                        },
                        {
                            key: "setExpireEventTimeout",
                            value: function(e1, t) {
                                var n = this;
                                if (!(0, y.z9)(t)) {
                                    var r = this.getExpireTime(t), o = 1e3 * Math.max(r - this.clock.now(), 0);
                                    this.clearExpireEventTimeout(e1);
                                    var i = setTimeout(function() {
                                        n.emitExpired(e1, t);
                                    }, o);
                                    this.state.expireTimeouts[e1] = i;
                                }
                            }
                        },
                        {
                            key: "setExpireEventTimeoutAll",
                            value: function() {
                                var e1 = this.storage.getStorage();
                                for(var t in e1)if (Object.prototype.hasOwnProperty.call(e1, t)) {
                                    var n = e1[t];
                                    this.setExpireEventTimeout(t, n);
                                }
                            }
                        },
                        {
                            key: "resetExpireEventTimeoutAll",
                            value: function() {
                                this.clearExpireEventTimeoutAll(), this.setExpireEventTimeoutAll();
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t) {
                                var n = this.storage.getStorage();
                                (0, p.R)(t), n[e1] = t, this.storage.setStorage(n), this.emitSetStorageEvent(), this.emitAdded(e1, t), this.setExpireEventTimeout(e1, t);
                            }
                        },
                        {
                            key: "getSync",
                            value: function(e1) {
                                return this.storage.getStorage()[e1];
                            }
                        },
                        {
                            key: "get",
                            value: (c = (0, r.Z)(s().mark(function e1(t) {
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", this.getSync(t));
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function(e1) {
                                return c.apply(this, arguments);
                            })
                        },
                        {
                            key: "getTokensSync",
                            value: function() {
                                var e1 = {}, t = this.storage.getStorage();
                                return Object.keys(t).forEach(function(n) {
                                    var r = t[n];
                                    (0, y.hv)(r) ? e1.accessToken = r : (0, y.sI)(r) ? e1.idToken = r : (0, y.z9)(r) && (e1.refreshToken = r);
                                }), e1;
                            }
                        },
                        {
                            key: "getTokens",
                            value: (n = (0, r.Z)(s().mark(function e1() {
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", this.getTokensSync());
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "getStorageKeyByType",
                            value: function(e1) {
                                var t = this.storage.getStorage();
                                return Object.keys(t).filter(function(n) {
                                    var r = t[n];
                                    return (0, y.hv)(r) && "accessToken" === e1 || (0, y.sI)(r) && "idToken" === e1 || (0, y.z9)(r) && "refreshToken" === e1;
                                })[0];
                            }
                        },
                        {
                            key: "getTokenType",
                            value: function(e1) {
                                if ((0, y.hv)(e1)) return "accessToken";
                                if ((0, y.sI)(e1)) return "idToken";
                                if ((0, y.z9)(e1)) return "refreshToken";
                                throw new l.Z("Unknown token type");
                            }
                        },
                        {
                            key: "emitSetStorageEvent",
                            value: function() {
                                if ((0, d.isIE11OrLess)()) {
                                    var e1 = this.storage.getStorage();
                                    this.emitter.emit(v.zr, e1);
                                }
                            }
                        },
                        {
                            key: "getStorage",
                            value: function() {
                                return this.storage;
                            }
                        },
                        {
                            key: "setTokens",
                            value: function(e1, t, n, r) {
                                var o = this, i = function(e1, i) {
                                    var a = o.getTokenType(i);
                                    "accessToken" === a ? t && t(e1, i) : "idToken" === a ? n && n(e1, i) : "refreshToken" === a && r && r(e1, i);
                                }, a = function(e1, t) {
                                    o.emitAdded(e1, t), o.setExpireEventTimeout(e1, t), i(e1, t);
                                }, u = function(e1, t) {
                                    o.clearExpireEventTimeout(e1), o.emitRemoved(e1, t), i(e1, t);
                                }, c = [
                                    "idToken",
                                    "accessToken",
                                    "refreshToken"
                                ], s = this.getTokensSync();
                                c.forEach(function(t) {
                                    var n = e1[t];
                                    n && (0, p.R)(n, t);
                                });
                                var f = c.reduce(function(t, n) {
                                    var r = e1[n];
                                    return r && (t[o.getStorageKeyByType(n) || n] = r), t;
                                }, {});
                                this.storage.setStorage(f), this.emitSetStorageEvent(), c.forEach(function(t) {
                                    var n, r, c, f = e1[t], l = s[t], p = o.getStorageKeyByType(t) || t;
                                    f && l ? (u(p, l), a(p, f), n = p, r = f, c = l, o.emitRenewed(n, r, c), o.clearExpireEventTimeout(n), o.setExpireEventTimeout(n, r), i(n, r)) : f ? a(p, f) : l && u(p, l);
                                });
                            }
                        },
                        {
                            key: "remove",
                            value: function(e1) {
                                this.clearExpireEventTimeout(e1);
                                var t = this.storage.getStorage(), n = t[e1];
                                delete t[e1], this.storage.setStorage(t), this.emitSetStorageEvent(), this.emitRemoved(e1, n);
                            }
                        },
                        {
                            key: "renewToken",
                            value: (t = (0, r.Z)(s().mark(function e1(t) {
                                var n;
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", null === (n = this.sdk.token) || void 0 === n ? void 0 : n.renew(t));
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function(e1) {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "validateToken",
                            value: function(e1) {
                                return (0, p.R)(e1);
                            }
                        },
                        {
                            key: "renew",
                            value: function(e1) {
                                var t = this;
                                if (this.state.renewPromise) return this.state.renewPromise;
                                try {
                                    var n = this.getSync(e1), r = void 0 !== n;
                                    if (!n && "accessToken" === e1) {
                                        var o = this.getStorageKeyByType("refreshToken");
                                        r = void 0 !== this.getSync(o);
                                    }
                                    if (!r) throw new l.Z("The tokenManager has no token for the key: " + e1);
                                } catch (e1) {
                                    return this.emitError(e1), Promise.reject(e1);
                                }
                                return this.clearExpireEventTimeout(e1), this.state.renewPromise = this.sdk.token.renewTokens().then(function(r) {
                                    if (t.setTokens(r), !n && "accessToken" === e1) {
                                        var o = r.accessToken;
                                        return t.emitRenewed(e1, o, null), o;
                                    }
                                    return r[t.getTokenType(n)];
                                }).catch(function(n) {
                                    throw t.remove(e1), n.tokenKey = e1, t.emitError(n), n;
                                }).finally(function() {
                                    t.state.renewPromise = null;
                                });
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                var e1 = this, t = this.getTokensSync();
                                this.clearExpireEventTimeoutAll(), this.storage.clearStorage(), this.emitSetStorageEvent(), Object.keys(t).forEach(function(n) {
                                    e1.emitRemoved(n, t[n]);
                                });
                            }
                        },
                        {
                            key: "clearPendingRemoveTokens",
                            value: function() {
                                var e1 = this, t = this.storage.getStorage(), n = {};
                                Object.keys(t).forEach(function(e1) {
                                    t[e1].pendingRemove && (n[e1] = t[e1], delete t[e1]);
                                }), this.storage.setStorage(t), this.emitSetStorageEvent(), Object.keys(n).forEach(function(t) {
                                    e1.clearExpireEventTimeout(t), e1.emitRemoved(t, n[t]);
                                });
                            }
                        },
                        {
                            key: "updateRefreshToken",
                            value: function(e1) {
                                var t = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY, n = this.storage.getStorage();
                                (0, p.R)(e1), n[t] = e1, this.storage.setStorage(n), this.emitSetStorageEvent();
                            }
                        },
                        {
                            key: "removeRefreshToken",
                            value: function() {
                                var e1 = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY;
                                this.remove(e1);
                            }
                        },
                        {
                            key: "addPendingRemoveFlags",
                            value: function() {
                                var e1 = this.getTokensSync();
                                Object.keys(e1).forEach(function(t) {
                                    e1[t].pendingRemove = !0;
                                }), this.setTokens(e1);
                            }
                        }
                    ]), e1;
                }();
            },
            1646: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(4319), u = n(146), c = 18e5;
                function s() {
                    return function() {
                        function e1(t) {
                            (0, r.Z)(this, e1), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "storageManager", void 0), (0, i.Z)(this, "enableSharedStorage", void 0), (0, i.Z)(this, "saveLastResponse", void 0), this.storageManager = t.storageManager, this.enableSharedStorage = !1 !== t.enableSharedStorage, this.saveLastResponse = !1 !== t.saveLastResponse, this.options = t;
                        }
                        return (0, o.Z)(e1, [
                            {
                                key: "clear",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = this.storageManager.getTransactionStorage(), n = t.getStorage();
                                    if (t.clearStorage(), this.enableSharedStorage && !1 !== e1.clearSharedStorage) {
                                        var r = e1.state || (null == n ? void 0 : n.state);
                                        r && function(e1, t) {
                                            var n = e1.getSharedTansactionStorage(), r = n.getStorage();
                                            delete r[t], n.setStorage(r);
                                        }(this.storageManager, r);
                                    }
                                }
                            },
                            {
                                key: "save",
                                value: function(e1) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = this.storageManager.getTransactionStorage(), r = n.getStorage();
                                    (0, a.mH)(r) && !t.muteWarning && (0, u.ZK)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."), n.setStorage(e1), this.enableSharedStorage && e1.state && function(e1, t, n) {
                                        var r = e1.getSharedTansactionStorage(), o = r.getStorage();
                                        o[t] = {
                                            dateCreated: Date.now(),
                                            transaction: n
                                        }, r.setStorage(o);
                                    }(this.storageManager, e1.state, e1);
                                }
                            },
                            {
                                key: "exists",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    try {
                                        return !!this.load(e1);
                                    } catch (e1) {
                                        return !1;
                                    }
                                }
                            },
                            {
                                key: "load",
                                value: function() {
                                    var e1, t, n, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    return this.enableSharedStorage && r.state && (t = this.storageManager.getSharedTansactionStorage(), n = t.getStorage(), Object.keys(n).forEach(function(e1) {
                                        var t = n[e1];
                                        Date.now() - t.dateCreated > c && delete n[e1];
                                    }), t.setStorage(n), e1 = function(e1, t) {
                                        var n = e1.getSharedTansactionStorage().getStorage()[t];
                                        return n && n.transaction && (0, a.mH)(n.transaction) ? n.transaction : null;
                                    }(this.storageManager, r.state), (0, a.mH)(e1)) ? e1 : (e1 = this.storageManager.getTransactionStorage().getStorage(), (0, a.mH)(e1) ? e1 : null);
                                }
                            }
                        ]), e1;
                    }();
                }
            },
            1237: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return i;
                    }
                });
                var r = n(9123), o = n(7987);
                function i(e1) {
                    var t, n = e1.split(".");
                    try {
                        t = {
                            header: JSON.parse((0, o.Wy)(n[0])),
                            payload: JSON.parse((0, o.Wy)(n[1])),
                            signature: n[2]
                        };
                    } catch (e1) {
                        throw new r.Z("Malformed token");
                    }
                    return t;
                }
            },
            7659: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    SO: function() {
                        return d;
                    },
                    V7: function() {
                        return A;
                    },
                    aW: function() {
                        return D;
                    },
                    ao: function() {
                        return C;
                    },
                    cE: function() {
                        return N;
                    },
                    lk: function() {
                        return E;
                    },
                    sd: function() {
                        return S;
                    },
                    vX: function() {
                        return _;
                    }
                });
                var r = n(2982), o = n(5861), i = n(4687), a = n.n(i), u = n(7987), c = n(7594), s = n(5728), f = n(9123), l = "OktaAuthJs", p = "DPoPKeys";
                function d(e1) {
                    return ((0, s.isOAuthError)(e1) || (0, s.isWWWAuthError)(e1)) && "use_dpop_nonce" === e1.errorCode;
                }
                function h(e1, t, n) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return (v = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i, s;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (0, u.NL)(JSON.stringify(t)), i = (0, u.NL)(JSON.stringify(n)), e1.next = 4, c.KP.subtle.sign({
                                        name: r.algorithm.name
                                    }, r, (0, u.k8)("".concat(o, ".").concat(i)));
                                case 4:
                                    return s = e1.sent, e1.abrupt("return", "".concat(o, ".").concat(i, ".").concat((0, u.aR)((0, u.kQ)(s))));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function y() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 32;
                    return (0, r.Z)(c.KP.getRandomValues(new Uint8Array(e1))).map(function(e1) {
                        return e1.toString(16);
                    }).join("");
                }
                function g() {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1() {
                        var t;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return t = {
                                        name: "RSASSA-PKCS1-v1_5",
                                        hash: "SHA-256",
                                        modulusLength: 2048,
                                        publicExponent: new Uint8Array([
                                            1,
                                            0,
                                            1
                                        ])
                                    }, e1.abrupt("return", c.KP.subtle.generateKey(t, !1, [
                                        "sign",
                                        "verify"
                                    ]));
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, o.Z)(a().mark(function e1(t) {
                        var n, r;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = (new TextEncoder).encode(t), e1.next = 3, c.KP.subtle.digest("SHA-256", n);
                                case 3:
                                    return r = e1.sent, e1.abrupt("return", (0, c.r3)(String.fromCharCode.apply(null, new Uint8Array(r))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function w(e1) {
                    return O.apply(this, arguments);
                }
                function O() {
                    return O = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    for(n = u.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)r[o - 1] = u[o];
                                    return e1.next = 3, new Promise(function(e1, t) {
                                        try {
                                            var n = window.indexedDB.open(l, 1);
                                            n.onerror = function() {
                                                t(n.error);
                                            }, n.onupgradeneeded = function() {
                                                n.result.createObjectStore(p);
                                            }, n.onsuccess = function() {
                                                var r = n.result, o = r.transaction(p, "readwrite");
                                                o.onerror = function() {
                                                    t(o.error);
                                                };
                                                var i = o.objectStore(p);
                                                e1(i), o.oncomplete = function() {
                                                    r.close();
                                                };
                                            };
                                        } catch (e1) {
                                            t(e1);
                                        }
                                    });
                                case 3:
                                    return i = e1.sent, e1.abrupt("return", new Promise(function(e1, n) {
                                        var o = i[t].apply(i, r);
                                        o.onsuccess = function() {
                                            e1(o);
                                        }, o.onerror = function() {
                                            n(o.error);
                                        };
                                    }));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), O.apply(this, arguments);
                }
                function Z(e1, t) {
                    return T.apply(this, arguments);
                }
                function T() {
                    return (T = (0, o.Z)(a().mark(function e1(t, n) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("add", n, t);
                                case 2:
                                    return e1.abrupt("return", n);
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function E(e1) {
                    return P.apply(this, arguments);
                }
                function P() {
                    return (P = (0, o.Z)(a().mark(function e1(t) {
                        var n;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!t) {
                                        e1.next = 6;
                                        break;
                                    }
                                    return e1.next = 3, w("get", t);
                                case 3:
                                    if (!(n = e1.sent).result) {
                                        e1.next = 6;
                                        break;
                                    }
                                    return e1.abrupt("return", n.result);
                                case 6:
                                    throw new f.Z("Unable to locate dpop key pair required for refresh".concat(t ? " (".concat(t, ")") : ""));
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function S(e1) {
                    return x.apply(this, arguments);
                }
                function x() {
                    return (x = (0, o.Z)(a().mark(function e1(t) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("delete", t);
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function A() {
                    return R.apply(this, arguments);
                }
                function R() {
                    return (R = (0, o.Z)(a().mark(function e1() {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("clear");
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function _() {
                    return j.apply(this, arguments);
                }
                function j() {
                    return (j = (0, o.Z)(a().mark(function e1() {
                        var t, n;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return t = y(4), e1.next = 3, g();
                                case 3:
                                    return n = e1.sent, e1.next = 6, Z(t, n);
                                case 6:
                                    return e1.abrupt("return", {
                                        keyPair: n,
                                        keyPairId: t
                                    });
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function C(e1, t) {
                    return I.apply(this, arguments);
                }
                function I() {
                    return (I = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = !1, i = n.accessToken, u = n.refreshToken, "access" === t && i && "DPoP" === i.tokenType && !u && (o = !0), "refresh" === t && u && !i && (o = !0), c = null !== (r = null == i ? void 0 : i.dpopPairId) && void 0 !== r ? r : null == u ? void 0 : u.dpopPairId, !o || !c) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 8, S(c);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function D(e1) {
                    return M.apply(this, arguments);
                }
                function M() {
                    return (M = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, s, f, l, p, d, v, g, m, k;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = t.keyPair, r = t.url, o = t.method, i = t.nonce, u = t.accessToken, e1.next = 3, c.KP.subtle.exportKey("jwk", n.publicKey);
                                case 3:
                                    if (s = e1.sent, f = s.kty, l = s.crv, p = s.e, d = s.n, v = s.x, g = s.y, m = {
                                        alg: "RS256",
                                        typ: "dpop+jwt",
                                        jwk: {
                                            kty: f,
                                            crv: l,
                                            e: p,
                                            n: d,
                                            x: v,
                                            y: g
                                        }
                                    }, k = {
                                        htm: o,
                                        htu: r,
                                        iat: Math.floor(Date.now() / 1e3),
                                        jti: y()
                                    }, i && (k.nonce = i), !u) {
                                        e1.next = 17;
                                        break;
                                    }
                                    return e1.next = 16, b(u);
                                case 16:
                                    k.ath = e1.sent;
                                case 17:
                                    return e1.abrupt("return", h(m, k, n.privateKey));
                                case 18:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function N(e1) {
                    return U.apply(this, arguments);
                }
                function U() {
                    return (U = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = t.keyPair, r = t.url, o = t.method, i = t.nonce, u = {
                                        keyPair: n,
                                        url: r,
                                        method: o
                                    }, i && (u.nonce = i), e1.abrupt("return", D(u));
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2206: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return l;
                    },
                    _: function() {
                        return f;
                    }
                });
                var r = n(4942), o = n(4771), i = n(3193), a = n(6718), u = n(9123);
                function c(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function s(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function f(e1) {
                    if (!e1.clientId) throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");
                    if ((0, o.HD)(e1.responseType) && -1 !== e1.responseType.indexOf(" ")) throw new u.Z("Multiple OAuth responseTypes must be defined as an array");
                    var t = {
                        client_id: e1.clientId,
                        code_challenge: e1.codeChallenge,
                        code_challenge_method: e1.codeChallengeMethod,
                        display: e1.display,
                        idp: e1.idp,
                        idp_scope: e1.idpScope,
                        login_hint: e1.loginHint,
                        max_age: e1.maxAge,
                        nonce: e1.nonce,
                        prompt: e1.prompt,
                        redirect_uri: e1.redirectUri,
                        response_mode: e1.responseMode,
                        response_type: e1.responseType,
                        sessionToken: e1.sessionToken,
                        state: e1.state,
                        acr_values: e1.acrValues,
                        enroll_amr_values: e1.enrollAmrValues
                    };
                    if (t = (0, i.YY)(t), [
                        "idp_scope",
                        "response_type",
                        "enroll_amr_values"
                    ].forEach(function(e1) {
                        Array.isArray(t[e1]) && (t[e1] = t[e1].join(" "));
                    }), -1 !== e1.responseType.indexOf("id_token") && -1 === e1.scopes.indexOf("openid")) throw new u.Z("openid scope must be specified in the scopes argument when requesting an id_token");
                    return e1.scopes && (t.scope = e1.scopes.join(" ")), t;
                }
                function l(e1) {
                    var t = f(e1);
                    return (0, a.UK)(s(s({}, t), e1.extraParams && s({}, e1.extraParams)));
                }
            },
            2642: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Dp: function() {
                        return o.D;
                    },
                    ES: function() {
                        return i.E;
                    },
                    R0: function() {
                        return r.R;
                    },
                    _6: function() {
                        return r._;
                    },
                    km: function() {
                        return i.k;
                    },
                    ti: function() {
                        return o.t;
                    }
                });
                var r = n(2206), o = n(9231), i = n(52);
            },
            9231: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    D: function() {
                        return b;
                    },
                    t: function() {
                        return g;
                    }
                });
                var r = n(885), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(3983), s = n(3193), f = n(6718), l = n(5385), p = n(7659);
                function d(e1) {
                    if (!e1.clientId) throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");
                    if (!e1.redirectUri) throw new u.Z("The redirectUri passed to /authorize must also be passed to /token");
                    if (!e1.authorizationCode && !e1.interactionCode) throw new u.Z("An authorization code (returned from /authorize) must be passed to /token");
                    if (!e1.codeVerifier) throw new u.Z('The "codeVerifier" (generated and saved by your app) must be passed to /token');
                }
                function h(e1, t) {
                    var n = (0, s.YY)({
                        client_id: t.clientId,
                        redirect_uri: t.redirectUri,
                        grant_type: t.interactionCode ? "interaction_code" : "authorization_code",
                        code_verifier: t.codeVerifier
                    });
                    t.interactionCode ? n.interaction_code = t.interactionCode : t.authorizationCode && (n.code = t.authorizationCode);
                    var r = e1.options.clientSecret;
                    return r && (n.client_secret = r), (0, f.UK)(n).slice(1);
                }
                function v(e1, t) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, s, f, d, h, y, g, m, b;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.url, o = n.data, i = n.nonce, s = n.dpopKeyPair, f = "POST", d = {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                    }, !t.options.dpop) {
                                        e1.next = 10;
                                        break;
                                    }
                                    if (s) {
                                        e1.next = 6;
                                        break;
                                    }
                                    throw new u.Z("DPoP is configured but no key pair was provided");
                                case 6:
                                    return e1.next = 8, (0, p.cE)({
                                        url: r,
                                        method: f,
                                        nonce: i,
                                        keyPair: s
                                    });
                                case 8:
                                    h = e1.sent, d.DPoP = h;
                                case 10:
                                    return e1.prev = 10, e1.next = 13, (0, l.c3)(t, {
                                        url: r,
                                        method: f,
                                        args: o,
                                        headers: d
                                    });
                                case 13:
                                    return y = e1.sent, e1.abrupt("return", y);
                                case 17:
                                    if (e1.prev = 17, e1.t0 = e1.catch(10), !(0, p.SO)(e1.t0) || i) {
                                        e1.next = 24;
                                        break;
                                    }
                                    if (m = null === (g = e1.t0.resp) || void 0 === g ? void 0 : g.headers["dpop-nonce"]) {
                                        e1.next = 23;
                                        break;
                                    }
                                    throw new c.Z({
                                        errorSummary: "No `dpop-nonce` header found when required"
                                    }, null !== (b = e1.t0.resp) && void 0 !== b ? b : void 0);
                                case 23:
                                    return e1.abrupt("return", v(t, {
                                        url: r,
                                        data: o,
                                        dpopKeyPair: s,
                                        nonce: m
                                    }));
                                case 24:
                                    throw e1.t0;
                                case 25:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                10,
                                17
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                function g(e1, t, n) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return d(n), o = h(t, n), i = {
                                        url: r.tokenUrl,
                                        data: o,
                                        dpopKeyPair: null == n ? void 0 : n.dpopKeyPair
                                    }, e1.abrupt("return", v(t, i));
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1, t, n) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, o.Z)(a().mark(function e1(t, n, o) {
                        var i, u, c;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return i = Object.entries({
                                        client_id: n.clientId,
                                        grant_type: "refresh_token",
                                        scope: o.scopes.join(" "),
                                        refresh_token: o.refreshToken
                                    }).map(function(e1) {
                                        var t = (0, r.Z)(e1, 2), n = t[0], o = t[1];
                                        return n + "=" + encodeURIComponent(o);
                                    }).join("&"), u = o.tokenUrl, n.extraParams && Object.keys(n.extraParams).length >= 1 && (u += (0, f.UK)(n.extraParams)), c = {
                                        url: u,
                                        data: i,
                                        dpopKeyPair: null == n ? void 0 : n.dpopKeyPair
                                    }, e1.abrupt("return", v(t, c));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            52: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return a;
                    },
                    k: function() {
                        return u;
                    }
                });
                var r = n(5385), o = n(3193), i = n(9123);
                function a(e1, t) {
                    var n = t || e1.options.issuer;
                    return (0, r.U2)(e1, n + "/.well-known/openid-configuration", {
                        cacheResponse: !0
                    });
                }
                function u(e1, t, n) {
                    var u = e1.storageManager.getHttpCache(e1.options.cookies);
                    return a(e1, t).then(function(t) {
                        var a = t.jwks_uri, c = u.getStorage()[a];
                        if (c && Date.now() / 1e3 < c.expiresAt) {
                            var s = (0, o.sE)(c.response.keys, {
                                kid: n
                            });
                            if (s) return s;
                        }
                        return u.clearStorage(a), (0, r.U2)(e1, a, {
                            cacheResponse: !0
                        }).then(function(e1) {
                            var t = (0, o.sE)(e1.keys, {
                                kid: n
                            });
                            if (t) return t;
                            throw new i.Z("The key id, " + n + ", was not found in the server's keys");
                        });
                    });
                }
            },
            8707: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    r: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(7599), u = n(7756), c = n(3193), s = n(9231), f = n(8676), l = n(7659);
                function p(e1, t, n) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, p, d, h, v, y, g, m, b, k, w, O, Z, T, E, P, S, x, A, R, _, j;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = r || (0, a.Fc)(t, n), n = Object.assign({}, (0, u.D)(t), (0, c.d9)(n)), p = (o = n).authorizationCode, d = o.interactionCode, h = o.codeVerifier, v = o.clientId, y = o.redirectUri, g = o.scopes, m = o.ignoreSignature, b = o.state, k = o.acrValues, w = o.dpop, O = o.dpopPairId, Z = o.extraParams, T = {
                                        clientId: v,
                                        redirectUri: y,
                                        authorizationCode: p,
                                        interactionCode: d,
                                        codeVerifier: h,
                                        dpop: w
                                    }, E = [
                                        "token"
                                    ], -1 !== g.indexOf("openid") && E.push("id_token"), P = {
                                        clientId: v,
                                        redirectUri: y,
                                        scopes: g,
                                        responseType: E,
                                        ignoreSignature: m,
                                        acrValues: k,
                                        extraParams: Z
                                    }, e1.prev = 7, !w) {
                                        e1.next = 26;
                                        break;
                                    }
                                    if (!O) {
                                        e1.next = 18;
                                        break;
                                    }
                                    return e1.next = 12, (0, l.lk)(O);
                                case 12:
                                    S = e1.sent, T.dpopKeyPair = S, P.dpop = w, P.dpopPairId = O, e1.next = 26;
                                    break;
                                case 18:
                                    return e1.next = 20, (0, l.vX)();
                                case 20:
                                    x = e1.sent, A = x.keyPair, R = x.keyPairId, T.dpopKeyPair = A, P.dpop = w, P.dpopPairId = R;
                                case 26:
                                    return e1.next = 28, (0, s.t)(t, T, r);
                                case 28:
                                    return _ = e1.sent, e1.next = 31, (0, f.s)(t, P, _, r);
                                case 31:
                                    return (j = e1.sent).code = p, j.state = b, e1.abrupt("return", j);
                                case 35:
                                    return e1.prev = 35, t.transactionManager.clear(), e1.finish(35);
                                case 38:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                7,
                                ,
                                35,
                                38
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
            },
            5324: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return E;
                    },
                    o: function() {
                        return T;
                    }
                });
                var r = n(3548), o = n(1237), i = n(8707), a = n(6844), u = n(7625), c = n(9770), s = n(6803), f = n(5372), l = n(2476), p = n(6268), d = n(781), h = n(6466), v = n(8113), y = n(6898), g = n(8221), m = n(1260), b = n(3193), k = n(6757), w = n(8080), O = n(2206);
                function Z(e1, t) {
                    t = (0, b.d9)(t) || {};
                    var n = (0, k.U)(e1, t), r = (0, w.A)(e1, n), o = r.urls.authorizeUrl + (0, O.R)(n);
                    e1.transactionManager.save(r), e1.options.setLocation ? e1.options.setLocation(o) : window.location.assign(o);
                }
                function T(e1, t) {
                    var n = function(e1) {
                        return r.b.prototype.push.bind(t, e1, null);
                    }, b = n(s.H.bind(null, e1)), k = n(f.ko.bind(null, e1)), w = Object.assign(k, {
                        _getHistory: function() {
                            return window.history;
                        },
                        _getLocation: function() {
                            return window.location;
                        },
                        _getDocument: function() {
                            return window.document;
                        }
                    }), O = {
                        prepareTokenParams: y.wu.bind(null, e1),
                        exchangeCodeForTokens: i.r.bind(null, e1),
                        getWithoutPrompt: u.y.bind(null, e1),
                        getWithPopup: c.d.bind(null, e1),
                        getWithIDPPopup: c.y.bind(null, e1),
                        getWithRedirect: b,
                        parseFromUrl: w,
                        decode: o.T,
                        revoke: h.P.bind(null, e1),
                        renew: l.$.bind(null, e1),
                        renewTokensWithRefresh: d.R.bind(null, e1),
                        renewTokens: p.I.bind(null, e1),
                        getUserInfo: function(t, n) {
                            return (0, a.b)(e1, t, n);
                        },
                        verify: m.W.bind(null, e1),
                        isLoginRedirect: g.gM.bind(null, e1),
                        introspect: v.j.bind(null, e1)
                    };
                    return [
                        "getWithoutPrompt",
                        "getWithPopup",
                        "revoke",
                        "renew",
                        "renewTokensWithRefresh",
                        "renewTokens"
                    ].forEach(function(e1) {
                        O[e1] = n(O[e1]);
                    }), O;
                }
                function E(e1) {
                    return {
                        authorize: {
                            enrollAuthenticator: Z.bind(null, e1)
                        }
                    };
                }
            },
            231: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $V: function() {
                        return r.$;
                    },
                    zr: function() {
                        return s;
                    },
                    o5: function() {
                        return r.o;
                    }
                });
                var r = n(5324), o = n(9893), i = n(265), a = n(3980), u = n(279), c = n(2724);
                function s(e1, t, n) {
                    var r = (0, o.a)(t), s = (0, i.H)(r, e1), f = (0, u.A)(s), l = (0, a.Z)(f);
                    return (0, c.J)(l, n);
                }
            },
            3253: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    L: function() {
                        return s;
                    }
                });
                var r = n(7599), o = n(4970), i = n(9123), a = n(6898), u = n(2206), c = n(8676);
                function s(e1, t) {
                    if (arguments.length > 2) return Promise.reject(new i.Z('As of version 3.0, "getToken" takes only a single set of options'));
                    var n = (t = t || {}).popupWindow;
                    return t.popupWindow = void 0, (0, a.wu)(e1, t).then(function(a) {
                        var s, f;
                        switch(t.sessionToken ? Object.assign(a, {
                            prompt: "none",
                            responseMode: "okta_post_message",
                            display: null
                        }) : t.idp && Object.assign(a, {
                            display: "popup"
                        }), f = (0, r.Fc)(e1, a), s = (t.codeVerifier ? f.tokenUrl : f.authorizeUrl) + (0, u.R)(a), a.sessionToken || null === a.display ? "IFRAME" : "popup" === a.display ? t.idpPopup ? "IDP_POPUP" : "POPUP" : "IMPLICIT"){
                            case "IFRAME":
                                var l = (0, o.iC)(e1, t.timeout, a.state), p = (0, o.Rl)(s);
                                return l.then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                }).finally(function() {
                                    var e1;
                                    document.body.contains(p) && (null === (e1 = p.parentElement) || void 0 === e1 || e1.removeChild(p));
                                });
                            case "POPUP":
                                var d;
                                if ("okta_post_message" === a.responseMode) {
                                    if (!e1.features.isPopupPostMessageSupported()) throw new i.Z("This browser doesn't have full postMessage support");
                                    d = (0, o.iC)(e1, t.timeout, a.state);
                                }
                                return n && n.location.assign(s), new Promise(function(e1, t) {
                                    var r = setInterval(function() {
                                        n && !n.closed || (clearInterval(r), t(new i.Z("Unable to parse OAuth flow response")));
                                    }, 100);
                                    d.then(function(t) {
                                        clearInterval(r), e1(t);
                                    }).catch(function(e1) {
                                        clearInterval(r), t(e1);
                                    });
                                }).then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                }).finally(function() {
                                    n && !n.closed && n.close();
                                });
                            case "IDP_POPUP":
                                var h = (0, o.It)(e1, t.timeout, t.channel, a.state);
                                if (!n) throw new i.Z("Unable to open popup window");
                                return n.location.assign(s), h.then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                });
                            default:
                                throw new i.Z("The full page redirect flow is not supported");
                        }
                    });
                }
            },
            6844: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return v;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(3114), s = n(2886), f = n(3983), l = n(5385), p = n(6488);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function v(e1, t, n) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n) {
                                        e1.next = 4;
                                        break;
                                    }
                                    return e1.next = 3, t.tokenManager.getTokens();
                                case 3:
                                    n = e1.sent.accessToken;
                                case 4:
                                    if (r) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 7, t.tokenManager.getTokens();
                                case 7:
                                    r = e1.sent.idToken;
                                case 8:
                                    if (n && (0, p.hv)(n)) {
                                        e1.next = 10;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an access token object")));
                                case 10:
                                    if (r && (0, p.sI)(r)) {
                                        e1.next = 12;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an ID token object")));
                                case 12:
                                    if (o = {
                                        url: n.userinfoUrl,
                                        method: "GET",
                                        accessToken: n.accessToken
                                    }, !t.options.dpop) {
                                        e1.next = 19;
                                        break;
                                    }
                                    return e1.next = 16, t.getDPoPAuthorizationHeaders(h(h({}, o), {}, {
                                        accessToken: n
                                    }));
                                case 16:
                                    i = e1.sent, o.headers = i, delete o.accessToken;
                                case 19:
                                    return e1.abrupt("return", (0, l.c3)(t, o).then(function(e1) {
                                        return e1.sub === r.claims.sub ? e1 : Promise.reject(new u.Z("getUserInfo request was rejected due to token mismatch"));
                                    }).catch(function(e1) {
                                        if (e1 instanceof c.Z && !t.options.dpop) {
                                            var n = e1.error, r = e1.errorDescription;
                                            throw new s.Z(n, r);
                                        }
                                        if (!t.options.dpop) {
                                            var o, i = e1;
                                            if (e1 instanceof f.Z && null != e1 && null !== (o = e1.meta) && void 0 !== o && o.wwwAuthHeader && (i = c.Z.parseHeader(e1.meta.wwwAuthHeader)), i instanceof c.Z) {
                                                var a = i, u = a.error, l = a.errorDescription;
                                                throw new s.Z(u, l);
                                            }
                                        }
                                        throw e1;
                                    }));
                                case 20:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            9770: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    d: function() {
                        return f;
                    },
                    y: function() {
                        return l;
                    }
                });
                var r = n(4925), o = n(9123), i = n(3193), a = n(3253), u = n(4970), c = n(7599), s = [
                    "initialPath"
                ];
                function f(e1, t) {
                    if (arguments.length > 2) return Promise.reject(new o.Z('As of version 3.0, "getWithPopup" takes only a single set of options'));
                    var n = t, c = n.initialPath, f = (0, r.Z)(n, s), l = (0, u.pU)(null != c ? c : "/", f);
                    return t = (0, i.d9)(f) || {}, Object.assign(f, {
                        display: "popup",
                        responseMode: "okta_post_message",
                        popupWindow: l
                    }), (0, a.L)(e1, f);
                }
                function l(e1, t) {
                    try {
                        if (!BroadcastChannel) throw new o.Z("Modern browser with `BroadcastChannel` support is required to use this method");
                        if (!t.redirectUri) throw new o.Z("`redirectUri` is a required param for `getWithIDPPopup`");
                        t.state || (t.state = (0, c.aV)());
                        var n, r = (0, u.pU)("/", t), s = new BroadcastChannel("popup-callback:".concat(t.state));
                        return t = (0, i.d9)(t) || {}, Object.assign(t, {
                            display: "popup",
                            responseMode: "query",
                            popupWindow: r,
                            idpPopup: !0,
                            channel: s
                        }), {
                            promise: new Promise(function(r, o) {
                                return n = o, (0, a.L)(e1, t).then(function(e1) {
                                    return r(e1);
                                }).catch(function(e1) {
                                    return o(e1);
                                });
                            }),
                            cancel: function() {
                                s.close(), n(new o.Z("Popup flow canceled"));
                            }
                        };
                    } catch (e1) {
                        return {
                            promise: Promise.reject(e1),
                            cancel: function() {}
                        };
                    }
                }
            },
            6803: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return l;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(3193), c = n(6898), s = n(2865), f = n(2206);
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, l, p = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!(p.length > 2)) {
                                        e1.next = 2;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new a.Z('As of version 3.0, "getWithRedirect" takes only a single set of options')));
                                case 2:
                                    return n = (0, u.d9)(n) || {}, e1.next = 5, (0, c.wu)(t, n);
                                case 5:
                                    r = e1.sent, o = (0, s.H)(t, r), l = o.urls.authorizeUrl + (0, f.R)(r), t.transactionManager.save(o), t.options.setLocation ? t.options.setLocation(l) : window.location.assign(l);
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            7625: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    y: function() {
                        return a;
                    }
                });
                var r = n(9123), o = n(3193), i = n(3253);
                function a(e1, t) {
                    return arguments.length > 2 ? Promise.reject(new r.Z('As of version 3.0, "getWithoutPrompt" takes only a single set of options')) : (t = (0, o.d9)(t) || {}, Object.assign(t, {
                        prompt: "none",
                        responseMode: "okta_post_message",
                        display: null
                    }), (0, i.L)(e1, t));
                }
            },
            8676: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    s: function() {
                        return d;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(3193), u = n(7599), c = n(2886), s = n(9123), f = n(1260), l = n(7756);
                function p(e1, t) {
                    if (e1.error && e1.error_description) throw new c.Z(e1.error, e1.error_description);
                    if (e1.state !== t.state) throw new s.Z("OAuth flow response state doesn't match request state");
                }
                function d(e1, t, n, r) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return (h = (0, r.Z)(i().mark(function e1(t, n, r, o) {
                        var c, d, h, v, y, g, m, b, k, w, O, Z, T, E, P, S, x;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (c = !1 !== t.options.pkce, n = n || (0, l.D)(t), p(r, n), !c || !r.code && !r.interaction_code) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", t.token.exchangeCodeForTokens(Object.assign({}, n, {
                                        authorizationCode: r.code,
                                        interactionCode: r.interaction_code
                                    }), o));
                                case 5:
                                    if (o = o || (0, u.Fc)(t, n), d = n.responseType || [], Array.isArray(d) || "none" === d || (d = [
                                        d
                                    ]), h = r.scope ? r.scope.split(" ") : (0, a.d9)(n.scopes), v = n.clientId || t.options.clientId, !n.dpop) {
                                        e1.next = 14;
                                        break;
                                    }
                                    if ((null !== (y = null === (g = t.options) || void 0 === g ? void 0 : g.dpopOptions) && void 0 !== y ? y : {
                                        allowBearerTokens: !1
                                    }).allowBearerTokens || "DPoP" === r.token_type) {
                                        e1.next = 14;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: DPoP was configured but "token_type" was not DPoP');
                                case 14:
                                    if (m = {}, b = r.expires_in, k = r.token_type, w = r.access_token, O = r.id_token, Z = r.refresh_token, T = Math.floor(Date.now() / 1e3), w && (E = t.token.decode(w), m.accessToken = {
                                        accessToken: w,
                                        claims: E.payload,
                                        expiresAt: Number(b) + T,
                                        tokenType: k,
                                        scopes: h,
                                        authorizeUrl: o.authorizeUrl,
                                        userinfoUrl: o.userinfoUrl
                                    }, n.dpopPairId && (m.accessToken.dpopPairId = n.dpopPairId), n.extraParams && (m.accessToken.extraParams = n.extraParams)), Z && (m.refreshToken = {
                                        refreshToken: Z,
                                        expiresAt: Number(b) + T,
                                        scopes: h,
                                        tokenUrl: o.tokenUrl,
                                        authorizeUrl: o.authorizeUrl,
                                        issuer: o.issuer
                                    }, n.dpopPairId && (m.refreshToken.dpopPairId = n.dpopPairId), n.extraParams && (m.refreshToken.extraParams = n.extraParams)), !O) {
                                        e1.next = 32;
                                        break;
                                    }
                                    return P = t.token.decode(O), S = {
                                        idToken: O,
                                        claims: P.payload,
                                        expiresAt: P.payload.exp - P.payload.iat + T,
                                        scopes: h,
                                        authorizeUrl: o.authorizeUrl,
                                        issuer: o.issuer,
                                        clientId: v
                                    }, n.extraParams && (S.extraParams = n.extraParams), x = {
                                        clientId: v,
                                        issuer: o.issuer,
                                        nonce: n.nonce,
                                        accessToken: w,
                                        acrValues: n.acrValues
                                    }, void 0 !== n.ignoreSignature && (x.ignoreSignature = n.ignoreSignature), e1.next = 31, (0, f.W)(t, S, x);
                                case 31:
                                    m.idToken = S;
                                case 32:
                                    if (-1 === d.indexOf("token") || m.accessToken) {
                                        e1.next = 34;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
                                case 34:
                                    if (-1 === d.indexOf("id_token") || m.idToken) {
                                        e1.next = 36;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
                                case 36:
                                    return e1.abrupt("return", {
                                        tokens: m,
                                        state: r.state,
                                        code: r.code,
                                        responseType: d
                                    });
                                case 37:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            9443: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    TokenManager: function() {
                        return l.M;
                    },
                    addIDPPopupLisenter: function() {
                        return d.It;
                    },
                    addListener: function() {
                        return d.NH;
                    },
                    addPostMessageListener: function() {
                        return d.iC;
                    },
                    assertPKCESupport: function() {
                        return d.vz;
                    },
                    buildAuthorizeParams: function() {
                        return a.R0;
                    },
                    convertTokenParamsToOAuthParams: function() {
                        return a._6;
                    },
                    createEndpoints: function() {
                        return r.$V;
                    },
                    createEnrollAuthenticatorMeta: function() {
                        return d.AW;
                    },
                    createOAuthMeta: function() {
                        return d.H;
                    },
                    createOAuthOptionsConstructor: function() {
                        return u.m;
                    },
                    createOAuthStorageManager: function() {
                        return i.a;
                    },
                    createOktaAuthOAuth: function() {
                        return r.zr;
                    },
                    createTokenAPI: function() {
                        return r.o5;
                    },
                    createTransactionManager: function() {
                        return p.P;
                    },
                    decodeToken: function() {
                        return h.T;
                    },
                    exchangeCodeForTokens: function() {
                        return O.r;
                    },
                    generateNonce: function() {
                        return d.PY;
                    },
                    generateState: function() {
                        return d.aV;
                    },
                    getDefaultEnrollAuthenticatorParams: function() {
                        return d.cE;
                    },
                    getDefaultTokenParams: function() {
                        return d.Dx;
                    },
                    getHashOrSearch: function() {
                        return d.O2;
                    },
                    getKey: function() {
                        return a.km;
                    },
                    getOAuthBaseUrl: function() {
                        return d.zf;
                    },
                    getOAuthDomain: function() {
                        return d.Xp;
                    },
                    getOAuthUrls: function() {
                        return d.Fc;
                    },
                    getToken: function() {
                        return Z.L;
                    },
                    getUserInfo: function() {
                        return k.b;
                    },
                    getWellKnown: function() {
                        return a.ES;
                    },
                    getWithIDPPopup: function() {
                        return E.y;
                    },
                    getWithPopup: function() {
                        return E.d;
                    },
                    getWithRedirect: function() {
                        return P.H;
                    },
                    getWithoutPrompt: function() {
                        return T.y;
                    },
                    handleOAuthResponse: function() {
                        return w.s;
                    },
                    hasAuthorizationCode: function() {
                        return d.ZP;
                    },
                    hasErrorInUrl: function() {
                        return d.hg;
                    },
                    hasInteractionCode: function() {
                        return d.d_;
                    },
                    hasResponseType: function() {
                        return d.wV;
                    },
                    hasTokensInHash: function() {
                        return d.kU;
                    },
                    isAuthorizationCodeError: function() {
                        return d.tC;
                    },
                    isCodeFlow: function() {
                        return d.Ik;
                    },
                    isInteractionRequired: function() {
                        return d.wc;
                    },
                    isInteractionRequiredError: function() {
                        return d.Cf;
                    },
                    isLoginRedirect: function() {
                        return d.gM;
                    },
                    isRedirectUri: function() {
                        return d.Qs;
                    },
                    isRefreshTokenError: function() {
                        return d.Yo;
                    },
                    isRefreshTokenInvalidError: function() {
                        return d.$E;
                    },
                    isSameRefreshToken: function() {
                        return d.q0;
                    },
                    loadFrame: function() {
                        return d.Rl;
                    },
                    loadPopup: function() {
                        return d.pU;
                    },
                    mixinOAuth: function() {
                        return o.J;
                    },
                    oidcIntrospect: function() {
                        return x.j;
                    },
                    parseFromUrl: function() {
                        return S.ko;
                    },
                    pkce: function() {
                        return d.U5;
                    },
                    postRefreshToken: function() {
                        return a.Dp;
                    },
                    postToTokenEndpoint: function() {
                        return a.ti;
                    },
                    prepareEnrollAuthenticatorParams: function() {
                        return d.Uc;
                    },
                    preparePKCE: function() {
                        return d.mi;
                    },
                    prepareTokenParams: function() {
                        return d.wu;
                    },
                    removeListener: function() {
                        return d.ys;
                    },
                    renewToken: function() {
                        return y.$;
                    },
                    renewTokens: function() {
                        return m.I;
                    },
                    renewTokensWithRefresh: function() {
                        return g.R;
                    },
                    revokeToken: function() {
                        return v.P;
                    },
                    urlParamsToObject: function() {
                        return d.vL;
                    },
                    validateClaims: function() {
                        return d.pj;
                    },
                    validateCodeChallengeMethod: function() {
                        return d.br;
                    },
                    validateToken: function() {
                        return d.Rp;
                    },
                    verifyToken: function() {
                        return b.W;
                    }
                });
                var r = n(231), o = n(2724), i = n(2333), a = n(2642), u = n(3775), c = n(8927), s = {};
                for(var f in c)[
                    "default",
                    "decodeToken",
                    "revokeToken",
                    "renewToken",
                    "renewTokensWithRefresh",
                    "renewTokens",
                    "verifyToken",
                    "getUserInfo",
                    "handleOAuthResponse",
                    "exchangeCodeForTokens",
                    "getToken",
                    "getWithoutPrompt",
                    "getWithPopup",
                    "getWithIDPPopup",
                    "getWithRedirect",
                    "parseFromUrl",
                    "oidcIntrospect",
                    "createEndpoints",
                    "createOktaAuthOAuth",
                    "createTokenAPI",
                    "mixinOAuth",
                    "createOAuthStorageManager",
                    "buildAuthorizeParams",
                    "convertTokenParamsToOAuthParams",
                    "getKey",
                    "getWellKnown",
                    "postRefreshToken",
                    "postToTokenEndpoint",
                    "createOAuthOptionsConstructor"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                n.d(t, s);
                var l = n(2427), p = n(1646), d = n(8785), h = n(1237), v = n(6466), y = n(2476), g = n(781), m = n(6268), b = n(1260), k = n(6844), w = n(8676), O = n(8707), Z = n(3253), T = n(7625), E = n(9770), P = n(6803), S = n(5372), x = n(8113);
            },
            8113: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return d;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(52), c = n(5385), s = n(6718), f = n(7594), l = n(6488), p = {
                    accessToken: "access_token",
                    idToken: "id_token",
                    refreshToken: "refresh_token"
                };
                function d(e1, t, n) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return (h = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, d, h, v, y, g, m, b, k, w;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (d = t.options.clientId, h = t.options.clientSecret, r || (r = t.tokenManager.getTokens()[n]), r) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new a.Z("unable to find ".concat(n, " in storage or fn params"));
                                case 5:
                                    if (o = (o = n !== l.T6.ACCESS ? null === (v = r) || void 0 === v ? void 0 : v.issuer : null === (y = r) || void 0 === y || null === (g = y.claims) || void 0 === g ? void 0 : g.iss) || t.options.issuer, d) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new a.Z("A clientId must be specified in the OktaAuth constructor to introspect a token");
                                case 9:
                                    if (o) {
                                        e1.next = 11;
                                        break;
                                    }
                                    throw new a.Z("Unable to find issuer");
                                case 11:
                                    return e1.next = 13, (0, u.E)(t, o);
                                case 13:
                                    return m = e1.sent, b = m.introspection_endpoint, k = h ? (0, f.r3)("".concat(d, ":").concat(h)) : (0, f.r3)(d), w = (0, s.UK)({
                                        token_type_hint: p[n],
                                        token: r[n]
                                    }).slice(1), e1.abrupt("return", (0, c.v_)(t, b, w, {
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded",
                                            Authorization: "Basic " + k
                                        }
                                    }));
                                case 18:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2724: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    J: function() {
                        return j;
                    }
                });
                var r = n(4925), o = n(5861), i = n(5671), a = n(3144), u = n(7326), c = n(1752), s = n(136), f = n(2963), l = n(1120), p = n(4942), d = n(4687), h = n.n(d), v = n(5385), y = n(3548), g = n(4771), m = n(9718), b = n(3611), k = n(5324), w = n(2427), O = n(8221), Z = n(7599), T = n(7659), E = n(9123), P = n(3114), S = n(1971), x = n(4858);
                var A = [
                    "originalUri"
                ];
                function R(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function _(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? R(Object(n), !0).forEach(function(t) {
                            (0, p.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function j(e1, t) {
                    var n, d = function(e1) {
                        (0, s.Z)(o, e1);
                        var t, n, r = (t = o, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, l.Z)(t);
                            if (n) {
                                var o = (0, l.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, f.Z)(this, e1);
                        });
                        function o() {
                            return (0, i.Z)(this, o), r.apply(this, arguments);
                        }
                        return (0, a.Z)(o, [
                            {
                                key: "setOriginalUri",
                                value: function(e1, t) {
                                    x.Z.getSessionStorage().setItem(S.REFERRER_PATH_STORAGE_KEY, e1), (t = t || this.options.state) && this.storageManager.getOriginalUriStorage().setItem(t, e1);
                                }
                            },
                            {
                                key: "getOriginalUri",
                                value: function(e1) {
                                    if (e1 = e1 || this.options.state) {
                                        var t = this.storageManager.getOriginalUriStorage().getItem(e1);
                                        if (t) return t;
                                    }
                                    var n = x.Z.getSessionStorage();
                                    return n && n.getItem(S.REFERRER_PATH_STORAGE_KEY) || void 0;
                                }
                            },
                            {
                                key: "removeOriginalUri",
                                value: function(e1) {
                                    if (x.Z.getSessionStorage().removeItem(S.REFERRER_PATH_STORAGE_KEY), e1 = e1 || this.options.state) {
                                        var t = this.storageManager.getOriginalUriStorage();
                                        t.removeItem && t.removeItem(e1);
                                    }
                                }
                            }
                        ]), o;
                    }(e1);
                    return n = function(e1) {
                        (0, s.Z)(H, e1);
                        var n, d, m, S, x, R, j, C, I, D, M, N, U, L = (N = H, U = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, l.Z)(N);
                            if (U) {
                                var n = (0, l.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, f.Z)(this, e1);
                        });
                        function H() {
                            var e1;
                            (0, i.Z)(this, H);
                            for(var n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                            return e1 = L.call.apply(L, [
                                this
                            ].concat(r)), (0, p.Z)((0, u.Z)(e1), "token", void 0), (0, p.Z)((0, u.Z)(e1), "tokenManager", void 0), (0, p.Z)((0, u.Z)(e1), "transactionManager", void 0), (0, p.Z)((0, u.Z)(e1), "pkce", void 0), (0, p.Z)((0, u.Z)(e1), "endpoints", void 0), (0, p.Z)((0, u.Z)(e1), "_pending", void 0), (0, p.Z)((0, u.Z)(e1), "_tokenQueue", void 0), e1.transactionManager = new t(Object.assign({
                                storageManager: e1.storageManager
                            }, e1.options.transactionManager)), e1.pkce = {
                                DEFAULT_CODE_CHALLENGE_METHOD: b.Z.DEFAULT_CODE_CHALLENGE_METHOD,
                                generateVerifier: b.Z.generateVerifier,
                                computeChallenge: b.Z.computeChallenge
                            }, e1._pending = {
                                handleLogin: !1
                            }, e1._tokenQueue = new y.b, e1.token = (0, k.o)((0, u.Z)(e1), e1._tokenQueue), e1.tokenManager = new w.M((0, u.Z)(e1), e1.options.tokenManager), e1.endpoints = (0, k.$)((0, u.Z)(e1)), e1;
                        }
                        return (0, a.Z)(H, [
                            {
                                key: "clearStorage",
                                value: function() {
                                    (0, c.Z)((0, l.Z)(H.prototype), "clearStorage", this).call(this), this.tokenManager.clear();
                                }
                            },
                            {
                                key: "isAuthenticated",
                                value: (M = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i, a, u, c, s, f, l = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = l.length > 0 && void 0 !== l[0] ? l[0] : {}, n = this.tokenManager.getOptions(), r = n.autoRenew, o = n.autoRemove, i = t.onExpiredToken ? "renew" === t.onExpiredToken : r, a = t.onExpiredToken ? "remove" === t.onExpiredToken : o, u = this.tokenManager.getTokensSync(), !(c = u.accessToken) || !this.tokenManager.hasExpired(c)) {
                                                    e1.next = 19;
                                                    break;
                                                }
                                                if (c = void 0, !i) {
                                                    e1.next = 18;
                                                    break;
                                                }
                                                return e1.prev = 8, e1.next = 11, this.tokenManager.renew("accessToken");
                                            case 11:
                                                c = e1.sent, e1.next = 16;
                                                break;
                                            case 14:
                                                e1.prev = 14, e1.t0 = e1.catch(8);
                                            case 16:
                                                e1.next = 19;
                                                break;
                                            case 18:
                                                a && this.tokenManager.remove("accessToken");
                                            case 19:
                                                if (s = this.tokenManager.getTokensSync(), !(f = s.idToken) || !this.tokenManager.hasExpired(f)) {
                                                    e1.next = 34;
                                                    break;
                                                }
                                                if (f = void 0, !i) {
                                                    e1.next = 33;
                                                    break;
                                                }
                                                return e1.prev = 23, e1.next = 26, this.tokenManager.renew("idToken");
                                            case 26:
                                                f = e1.sent, e1.next = 31;
                                                break;
                                            case 29:
                                                e1.prev = 29, e1.t1 = e1.catch(23);
                                            case 31:
                                                e1.next = 34;
                                                break;
                                            case 33:
                                                a && this.tokenManager.remove("idToken");
                                            case 34:
                                                return e1.abrupt("return", !(!c || !f));
                                            case 35:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            8,
                                            14
                                        ],
                                        [
                                            23,
                                            29
                                        ]
                                    ]);
                                })), function() {
                                    return M.apply(this, arguments);
                                })
                            },
                            {
                                key: "signInWithRedirect",
                                value: (D = (0, o.Z)(h().mark(function e1() {
                                    var t, n, o, i, a = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (n = (t = a.length > 0 && void 0 !== a[0] ? a[0] : {}).originalUri, o = (0, r.Z)(t, A), !this._pending.handleLogin) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return");
                                            case 4:
                                                return this._pending.handleLogin = !0, e1.prev = 5, n && this.setOriginalUri(n), i = Object.assign({
                                                    scopes: this.options.scopes || [
                                                        "openid",
                                                        "email",
                                                        "profile"
                                                    ]
                                                }, o), e1.next = 10, this.token.getWithRedirect(i);
                                            case 10:
                                                return e1.prev = 10, this._pending.handleLogin = !1, e1.finish(10);
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            5,
                                            ,
                                            10,
                                            13
                                        ]
                                    ]);
                                })), function() {
                                    return D.apply(this, arguments);
                                })
                            },
                            {
                                key: "getUser",
                                value: (I = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return t = this.tokenManager.getTokensSync(), n = t.idToken, r = t.accessToken, e1.abrupt("return", this.token.getUserInfo(r, n));
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return I.apply(this, arguments);
                                })
                            },
                            {
                                key: "getIdToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().idToken;
                                    return e1 ? e1.idToken : void 0;
                                }
                            },
                            {
                                key: "getAccessToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().accessToken;
                                    return e1 ? e1.accessToken : void 0;
                                }
                            },
                            {
                                key: "getRefreshToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().refreshToken;
                                    return e1 ? e1.refreshToken : void 0;
                                }
                            },
                            {
                                key: "getOrRenewAccessToken",
                                value: (C = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = this.tokenManager.getTokensSync(), !(n = t.accessToken) || this.tokenManager.hasExpired(n)) {
                                                    e1.next = 3;
                                                    break;
                                                }
                                                return e1.abrupt("return", n.accessToken);
                                            case 3:
                                                return e1.prev = 3, o = this.tokenManager.getStorageKeyByType("accessToken"), e1.next = 7, this.tokenManager.renew(null != o ? o : "accessToken");
                                            case 7:
                                                return i = e1.sent, e1.abrupt("return", null !== (r = null == i ? void 0 : i.accessToken) && void 0 !== r ? r : null);
                                            case 11:
                                                return e1.prev = 11, e1.t0 = e1.catch(3), this.emitter.emit("error", e1.t0), e1.abrupt("return", null);
                                            case 15:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            3,
                                            11
                                        ]
                                    ]);
                                })), function() {
                                    return C.apply(this, arguments);
                                })
                            },
                            {
                                key: "storeTokensFromRedirect",
                                value: (j = (0, o.Z)(h().mark(function e1() {
                                    var t, n;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.token.parseFromUrl();
                                            case 2:
                                                t = e1.sent, n = t.tokens, "none" !== t.responseType && this.tokenManager.setTokens(n);
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return j.apply(this, arguments);
                                })
                            },
                            {
                                key: "isLoginRedirect",
                                value: function() {
                                    return (0, O.gM)(this);
                                }
                            },
                            {
                                key: "isPKCE",
                                value: function() {
                                    return !!this.options.pkce;
                                }
                            },
                            {
                                key: "hasResponseType",
                                value: function(e1) {
                                    return (0, O.wV)(e1, this.options);
                                }
                            },
                            {
                                key: "isAuthorizationCodeFlow",
                                value: function() {
                                    return this.hasResponseType("code");
                                }
                            },
                            {
                                key: "invokeApiMethod",
                                value: (R = (0, o.Z)(h().mark(function e1(t) {
                                    var n;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t.accessToken) {
                                                    e1.next = 5;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                n = e1.sent.accessToken, t.accessToken = null == n ? void 0 : n.accessToken;
                                            case 5:
                                                return e1.abrupt("return", (0, v.c3)(this, t));
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return R.apply(this, arguments);
                                })
                            },
                            {
                                key: "revokeAccessToken",
                                value: (x = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                if (n = e1.sent, t = n.accessToken, r = this.tokenManager.getStorageKeyByType("accessToken"), this.tokenManager.remove(r), !this.options.dpop) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.ao)("access", n);
                                            case 10:
                                                if (t) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.abrupt("return", Promise.resolve(null));
                                            case 12:
                                                return e1.abrupt("return", this.token.revoke(t));
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return x.apply(this, arguments);
                                })
                            },
                            {
                                key: "revokeRefreshToken",
                                value: (S = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                if (n = e1.sent, t = n.refreshToken, r = this.tokenManager.getStorageKeyByType("refreshToken"), this.tokenManager.remove(r), !this.options.dpop) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.ao)("refresh", n);
                                            case 10:
                                                if (t) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.abrupt("return", Promise.resolve(null));
                                            case 12:
                                                return e1.abrupt("return", this.token.revoke(t));
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return S.apply(this, arguments);
                                })
                            },
                            {
                                key: "getSignOutRedirectUrl",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e1.idToken, n = e1.postLogoutRedirectUri, r = e1.state;
                                    if (t || (t = this.tokenManager.getTokensSync().idToken), !t) return "";
                                    void 0 === n && (n = this.options.postLogoutRedirectUri);
                                    var o = (0, Z.Fc)(this).logoutUrl, i = t.idToken, a = o + "?id_token_hint=" + encodeURIComponent(i);
                                    return n && (a += "&post_logout_redirect_uri=" + encodeURIComponent(n)), r && (a += "&state=" + encodeURIComponent(r)), a;
                                }
                            },
                            {
                                key: "signOut",
                                value: (m = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r, o, i, a, u, c, s, f, l, p, d, v, y, g, m;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = Object.assign({}, t), a = window.location.origin, u = window.location.href, c = null === t.postLogoutRedirectUri ? null : t.postLogoutRedirectUri || this.options.postLogoutRedirectUri || a, s = null === (n = t) || void 0 === n ? void 0 : n.state, f = t.accessToken, l = t.refreshToken, p = !1 !== t.revokeAccessToken, (d = !1 !== t.revokeRefreshToken) && void 0 === l && (l = this.tokenManager.getTokensSync().refreshToken), p && void 0 === f && (f = this.tokenManager.getTokensSync().accessToken), t.idToken || (t.idToken = this.tokenManager.getTokensSync().idToken), !d || !l) {
                                                    e1.next = 15;
                                                    break;
                                                }
                                                return e1.next = 15, this.revokeRefreshToken(l);
                                            case 15:
                                                if (!p || !f) {
                                                    e1.next = 18;
                                                    break;
                                                }
                                                return e1.next = 18, this.revokeAccessToken(f);
                                            case 18:
                                                if (v = null !== (r = null === (o = f) || void 0 === o ? void 0 : o.dpopPairId) && void 0 !== r ? r : null === (i = l) || void 0 === i ? void 0 : i.dpopPairId, !this.options.dpop || !v) {
                                                    e1.next = 22;
                                                    break;
                                                }
                                                return e1.next = 22, (0, T.sd)(v);
                                            case 22:
                                                if (y = this.getSignOutRedirectUrl(_(_({}, t), {}, {
                                                    postLogoutRedirectUri: c
                                                }))) {
                                                    e1.next = 33;
                                                    break;
                                                }
                                                return e1.next = 26, this.closeSession();
                                            case 26:
                                                return g = e1.sent, m = new URL(c || a), s && m.searchParams.append("state", s), c === u ? window.location.href = m.href : window.location.assign(m.href), e1.abrupt("return", g);
                                            case 33:
                                                return t.clearTokensBeforeRedirect ? this.tokenManager.clear() : this.tokenManager.addPendingRemoveFlags(), window.location.assign(y), e1.abrupt("return", !0);
                                            case 36:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return m.apply(this, arguments);
                                })
                            },
                            {
                                key: "getDPoPAuthorizationHeaders",
                                value: (d = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r, o, i;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (this.options.dpop) {
                                                    e1.next = 2;
                                                    break;
                                                }
                                                throw new E.Z("DPoP is not configured for this client instance");
                                            case 2:
                                                if ((r = t.accessToken) || (r = this.tokenManager.getTokensSync().accessToken), r) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                throw new E.Z("AccessToken is required to generate a DPoP Proof");
                                            case 6:
                                                return e1.next = 8, (0, T.lk)(null === (n = r) || void 0 === n ? void 0 : n.dpopPairId);
                                            case 8:
                                                return o = e1.sent, e1.next = 11, (0, T.aW)(_(_({}, t), {}, {
                                                    keyPair: o,
                                                    accessToken: r.accessToken
                                                }));
                                            case 11:
                                                return i = e1.sent, e1.abrupt("return", {
                                                    Authorization: "DPoP ".concat(r.accessToken),
                                                    Dpop: i
                                                });
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return d.apply(this, arguments);
                                })
                            },
                            {
                                key: "clearDPoPStorage",
                                value: (n = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (!(i.length > 0 && void 0 !== i[0] && i[0])) {
                                                    e1.next = 3;
                                                    break;
                                                }
                                                return e1.abrupt("return", (0, T.V7)());
                                            case 3:
                                                return e1.next = 5, this.tokenManager.getTokens();
                                            case 5:
                                                if (r = e1.sent, !(o = (null === (t = r.accessToken) || void 0 === t ? void 0 : t.dpopPairId) || (null === (n = r.refreshToken) || void 0 === n ? void 0 : n.dpopPairId))) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.sd)(o);
                                            case 10:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "parseUseDPoPNonceError",
                                value: function(e1) {
                                    var t = P.Z.getWWWAuthenticateHeader(e1), n = P.Z.parseHeader(null != t ? t : "");
                                    if ((0, T.SO)(n)) {
                                        var r, o, i = null;
                                        return (0, g.mf)(null == e1 ? void 0 : e1.get) && (i = e1.get("DPoP-Nonce")), null !== (r = null !== (o = i) && void 0 !== o ? o : e1["dpop-nonce"]) && void 0 !== r ? r : e1["DPoP-Nonce"];
                                    }
                                    return null;
                                }
                            }
                        ]), H;
                    }(d), (0, p.Z)(n, "crypto", m), n;
                }
            },
            9453: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    m: function() {
                        return m;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(1971), l = n(6718), p = n(415), d = n(8817), h = !0, v = n(9123);
                function y(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function g(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? y(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function m() {
                    return function(e1) {
                        (0, a.Z)(y, e1);
                        var t, n, d = (t = y, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function y(e1) {
                            var t;
                            return (0, o.Z)(this, y), t = d.call(this, e1), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "authorizeUrl", void 0), (0, s.Z)((0, i.Z)(t), "userinfoUrl", void 0), (0, s.Z)((0, i.Z)(t), "tokenUrl", void 0), (0, s.Z)((0, i.Z)(t), "revokeUrl", void 0), (0, s.Z)((0, i.Z)(t), "logoutUrl", void 0), (0, s.Z)((0, i.Z)(t), "pkce", void 0), (0, s.Z)((0, i.Z)(t), "clientId", void 0), (0, s.Z)((0, i.Z)(t), "redirectUri", void 0), (0, s.Z)((0, i.Z)(t), "responseType", void 0), (0, s.Z)((0, i.Z)(t), "responseMode", void 0), (0, s.Z)((0, i.Z)(t), "state", void 0), (0, s.Z)((0, i.Z)(t), "scopes", void 0), (0, s.Z)((0, i.Z)(t), "ignoreSignature", void 0), (0, s.Z)((0, i.Z)(t), "codeChallenge", void 0), (0, s.Z)((0, i.Z)(t), "codeChallengeMethod", void 0), (0, s.Z)((0, i.Z)(t), "acrValues", void 0), (0, s.Z)((0, i.Z)(t), "maxAge", void 0), (0, s.Z)((0, i.Z)(t), "dpop", void 0), (0, s.Z)((0, i.Z)(t), "dpopOptions", void 0), (0, s.Z)((0, i.Z)(t), "tokenManager", void 0), (0, s.Z)((0, i.Z)(t), "postLogoutRedirectUri", void 0), (0, s.Z)((0, i.Z)(t), "restoreOriginalUri", void 0), (0, s.Z)((0, i.Z)(t), "transactionManager", void 0), (0, s.Z)((0, i.Z)(t), "clientSecret", void 0), (0, s.Z)((0, i.Z)(t), "setLocation", void 0), (0, s.Z)((0, i.Z)(t), "ignoreLifetime", void 0), (0, s.Z)((0, i.Z)(t), "maxClockSkew", void 0), function(e1) {
                                var t = (e1 = e1 || {}).scopes;
                                if (t && !Array.isArray(t)) throw new v.Z('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');
                                var n = e1.issuer;
                                if (!n) throw new v.Z('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                                if (!new RegExp("^http?s?://.+").test(n)) throw new v.Z('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                                if (-1 !== n.indexOf("-admin.okta")) throw new v.Z('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
                            }(e1), t.issuer = (0, l.Qj)(e1.issuer), t.tokenUrl = (0, l.Qj)(e1.tokenUrl), t.authorizeUrl = (0, l.Qj)(e1.authorizeUrl), t.userinfoUrl = (0, l.Qj)(e1.userinfoUrl), t.revokeUrl = (0, l.Qj)(e1.revokeUrl), t.logoutUrl = (0, l.Qj)(e1.logoutUrl), t.pkce = !1 !== e1.pkce, t.clientId = e1.clientId, t.redirectUri = e1.redirectUri, (0, p.isBrowser)() && (t.redirectUri = (0, l.BY)(e1.redirectUri, window.location.origin)), t.responseType = e1.responseType, t.responseMode = e1.responseMode, t.state = e1.state, t.scopes = e1.scopes, t.ignoreSignature = !!e1.ignoreSignature, t.codeChallenge = e1.codeChallenge, t.codeChallengeMethod = e1.codeChallengeMethod, t.acrValues = e1.acrValues, t.maxAge = e1.maxAge, t.dpop = !0 === e1.dpop, t.dpopOptions = g({
                                allowBearerTokens: !1
                            }, e1.dpopOptions), t.tokenManager = e1.tokenManager, t.postLogoutRedirectUri = e1.postLogoutRedirectUri, t.restoreOriginalUri = e1.restoreOriginalUri, t.transactionManager = g({
                                enableSharedStorage: h
                            }, e1.transactionManager), t.clientSecret = e1.clientSecret, t.setLocation = e1.setLocation, t.ignoreLifetime = !!e1.ignoreLifetime, e1.maxClockSkew || 0 === e1.maxClockSkew ? t.maxClockSkew = e1.maxClockSkew : t.maxClockSkew = f.DEFAULT_MAX_CLOCK_SKEW, t;
                        }
                        return (0, r.Z)(y);
                    }((0, d.Z)());
                }
            },
            3775: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    m: function() {
                        return r.m;
                    }
                });
                var r = n(9453);
            },
            5372: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Tp: function() {
                        return p;
                    },
                    ko: function() {
                        return h;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(1969), c = n(9912), s = n(4771), f = n(8676);
                function l(e1) {
                    var t = e1.options.pkce ? "query" : "fragment";
                    return e1.options.responseMode || t;
                }
                function p(e1, t) {
                    t = t || {}, (0, s.HD)(t) && (t = {
                        url: t
                    });
                    var n, r = t.url, o = t.responseMode || l(e1), i = e1.token.parseFromUrl._getLocation();
                    if (!(n = "query" === o ? r ? r.substring(r.indexOf("?")) : i.search : r ? r.substring(r.indexOf("#")) : i.hash)) throw new a.Z("Unable to parse a token from the url");
                    return (0, u.v)(n);
                }
                function d(e1, t) {
                    "query" === (t.responseMode || l(e1)) ? function(e1) {
                        var t = e1.token.parseFromUrl._getHistory(), n = e1.token.parseFromUrl._getDocument(), r = e1.token.parseFromUrl._getLocation();
                        t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
                    }(e1) : function(e1) {
                        var t = e1.token.parseFromUrl._getHistory(), n = e1.token.parseFromUrl._getDocument(), r = e1.token.parseFromUrl._getLocation();
                        t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
                    }(e1);
                }
                function h(e1, t) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return (v = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, u, l;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = n || {}, (0, s.HD)(n) && (n = {
                                        url: n
                                    }), r = p(t, n), o = r.state, u = t.transactionManager.load({
                                        state: o
                                    })) {
                                        e1.next = 9;
                                        break;
                                    }
                                    if (!t.options.pkce) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new a.Z("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.", void 0);
                                case 8:
                                    throw new a.Z("Unable to retrieve OAuth redirect params from storage");
                                case 9:
                                    return l = u.urls, delete u.urls, n.url || d(t, n), e1.abrupt("return", (0, f.s)(t, u, r, l).catch(function(e1) {
                                        throw (0, c.Cf)(e1) || t.transactionManager.clear({
                                            state: o
                                        }), e1;
                                    }).then(function(e1) {
                                        return t.transactionManager.clear({
                                            state: o
                                        }), e1;
                                    }));
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2476: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(6488), c = n(7625), s = n(781);
                function f() {
                    throw new a.Z("Renew must be passed a token with an array of scopes and an accessToken or idToken");
                }
                function l(e1, t) {
                    return (0, u.sI)(e1) ? t.idToken : (0, u.hv)(e1) ? t.accessToken : void f();
                }
                function p(e1, t) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, p, d, h, v, y, g;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if ((0, u.sI)(n) || (0, u.hv)(n) || f(), !(r = t.tokenManager.getTokensSync()).refreshToken) {
                                        e1.next = 7;
                                        break;
                                    }
                                    return e1.next = 5, (0, s.R)(t, {
                                        scopes: n.scopes
                                    }, r.refreshToken);
                                case 5:
                                    return r = e1.sent, e1.abrupt("return", l(n, r));
                                case 7:
                                    return o = t.options.pkce ? "code" : (0, u.hv)(n) ? "token" : "id_token", p = (a = n).scopes, d = a.authorizeUrl, h = a.userinfoUrl, v = a.issuer, y = a.dpopPairId, g = a.extraParams, e1.abrupt("return", (0, c.y)(t, {
                                        responseType: o,
                                        scopes: p,
                                        authorizeUrl: d,
                                        userinfoUrl: h,
                                        issuer: v,
                                        dpopPairId: y,
                                        extraParams: g
                                    }).then(function(e1) {
                                        return l(n, e1.tokens);
                                    }));
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            6268: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    I: function() {
                        return f;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(7625), c = n(781), s = n(7756);
                function f(e1, t) {
                    return l.apply(this, arguments);
                }
                function l() {
                    return (l = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, f, l, p, d, h, v, y, g, m, b, k;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!(f = null !== (r = null === (o = n) || void 0 === o ? void 0 : o.tokens) && void 0 !== r ? r : t.tokenManager.getTokensSync()).refreshToken) {
                                        e1.next = 3;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, c.R)(t, n || {}, f.refreshToken));
                                case 3:
                                    if (f.accessToken || f.idToken) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new a.Z("renewTokens() was called but there is no existing token");
                                case 5:
                                    if (l = f.accessToken || {}, p = f.idToken || {}, d = l.scopes || p.scopes) {
                                        e1.next = 10;
                                        break;
                                    }
                                    throw new a.Z("renewTokens: invalid tokens: could not read scopes");
                                case 10:
                                    if (h = l.authorizeUrl || p.authorizeUrl) {
                                        e1.next = 13;
                                        break;
                                    }
                                    throw new a.Z("renewTokens: invalid tokens: could not read authorizeUrl");
                                case 13:
                                    return v = l.userinfoUrl || t.options.userinfoUrl, y = p.issuer || t.options.issuer, g = null == l ? void 0 : l.dpopPairId, m = (null == l ? void 0 : l.extraParams) || (null == p ? void 0 : p.extraParams), n = Object.assign({
                                        scopes: d,
                                        authorizeUrl: h,
                                        userinfoUrl: v,
                                        issuer: y,
                                        dpopPairId: g,
                                        extraParams: m
                                    }, n), t.options.pkce ? n.responseType = "code" : (b = (0, s.D)(t), k = b.responseType, n.responseType = k), e1.abrupt("return", (0, u.y)(t, n).then(function(e1) {
                                        return e1.tokens;
                                    }));
                                case 20:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            781: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return y;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(7599), s = n(6635), f = n(8676), l = n(9231), p = n(7659), d = n(9912);
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function y(e1, t, n) {
                    return g.apply(this, arguments);
                }
                function g() {
                    return (g = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i, h, y, g, m, b, k, w, O, Z;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = t.options, i = o.clientId, h = o.dpop, i) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new u.Z("A clientId must be specified in the OktaAuth constructor to renew tokens");
                                case 3:
                                    if (e1.prev = 3, y = Object.assign({}, n, {
                                        clientId: i
                                    }), r.extraParams && (y.extraParams = r.extraParams), g = v({}, y), !h) {
                                        e1.next = 14;
                                        break;
                                    }
                                    return e1.next = 10, (0, p.lk)(null == r ? void 0 : r.dpopPairId);
                                case 10:
                                    m = e1.sent, g.dpopKeyPair = m, y.dpop = h, y.dpopPairId = r.dpopPairId;
                                case 14:
                                    return e1.next = 16, (0, l.D)(t, g, r);
                                case 16:
                                    return b = e1.sent, k = (0, c.Fc)(t, n), e1.next = 20, (0, f.s)(t, y, b, k);
                                case 20:
                                    return w = e1.sent, O = w.tokens, (Z = O.refreshToken) && !(0, s.q)(Z, r) && t.tokenManager.updateRefreshToken(Z), e1.abrupt("return", O);
                                case 27:
                                    throw e1.prev = 27, e1.t0 = e1.catch(3), (0, d.$E)(e1.t0) && t.tokenManager.removeRefreshToken(), e1.t0;
                                case 31:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                3,
                                27
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
            },
            6466: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return l;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(5385), u = n(6718), c = n(7599), s = n(7594), f = n(9123);
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return (p = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, l, p, d, h, v;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = "", o = "", n && (r = n.accessToken, o = n.refreshToken), r || o) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new f.Z("A valid access or refresh token object is required");
                                case 5:
                                    if (l = t.options.clientId, p = t.options.clientSecret, l) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new f.Z("A clientId must be specified in the OktaAuth constructor to revoke a token");
                                case 9:
                                    return d = (0, c.Fc)(t).revokeUrl, h = (0, u.UK)({
                                        token_type_hint: o ? "refresh_token" : "access_token",
                                        token: o || r
                                    }).slice(1), v = p ? (0, s.r3)("".concat(l, ":").concat(p)) : (0, s.r3)(l), e1.abrupt("return", (0, a.v_)(t, d, h, {
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded",
                                            Authorization: "Basic " + v
                                        }
                                    }));
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2333: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(5437), s = n(5763), f = n(1971);
                function l() {
                    return function(e1) {
                        (0, i.Z)(p, e1);
                        var t, n, l = (t = p, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, u.Z)(t);
                            if (n) {
                                var o = (0, u.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, a.Z)(this, e1);
                        });
                        function p(e1, t, n) {
                            return (0, r.Z)(this, p), l.call(this, e1, t, n);
                        }
                        return (0, o.Z)(p, [
                            {
                                key: "getTransactionStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("transaction", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.TRANSACTION_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            },
                            {
                                key: "getSharedTansactionStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("shared-transaction", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.SHARED_TRANSACTION_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            },
                            {
                                key: "getOriginalUriStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("original-uri", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.ORIGINAL_URI_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            }
                        ]), p;
                    }(c.W);
                }
            },
            6488: function(e1, t, n) {
                "use strict";
                var r;
                function o(e1) {
                    return !!(e1 && (e1.accessToken || e1.idToken || e1.refreshToken) && Array.isArray(e1.scopes));
                }
                function i(e1) {
                    return e1 && e1.accessToken;
                }
                function a(e1) {
                    return e1 && e1.idToken;
                }
                function u(e1) {
                    return e1 && e1.refreshToken;
                }
                n.d(t, {
                    T6: function() {
                        return r;
                    },
                    hD: function() {
                        return o;
                    },
                    hv: function() {
                        return i;
                    },
                    sI: function() {
                        return a;
                    },
                    z9: function() {
                        return u;
                    }
                }), function(e1) {
                    e1.ACCESS = "accessToken", e1.ID = "idToken", e1.REFRESH = "refreshToken";
                }(r || (r = {}));
            },
            7088: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $I: function() {
                        return u;
                    },
                    $Y: function() {
                        return r;
                    },
                    E: function() {
                        return o;
                    },
                    FT: function() {
                        return a;
                    },
                    O3: function() {
                        return i;
                    },
                    zr: function() {
                        return c;
                    }
                });
                var r = "expired", o = "renewed", i = "added", a = "removed", u = "error", c = "set_storage";
            },
            4319: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G5: function() {
                        return i;
                    },
                    ZT: function() {
                        return a;
                    },
                    mH: function() {
                        return s;
                    },
                    rZ: function() {
                        return c;
                    },
                    sG: function() {
                        return u;
                    }
                });
                var r = n(1002);
                function o(e1) {
                    return !(!e1 || "object" !== (0, r.Z)(e1) || 0 === Object.values(e1).length);
                }
                function i(e1) {
                    return !(!o(e1) || !e1.redirectUri && !e1.responseType);
                }
                function a(e1) {
                    return !!i(e1) && !!e1.codeVerifier;
                }
                function u(e1) {
                    return !!a(e1) && !!e1.interactionHandle;
                }
                function c(e1) {
                    return !!o(e1) && void 0 === Object.values(e1).find(function(e1) {
                        return "string" != typeof e1;
                    });
                }
                function s(e1) {
                    return !(!i(e1) && !c(e1));
                }
            },
            7615: function() {},
            8927: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    EVENT_ADDED: function() {
                        return u.O3;
                    },
                    EVENT_ERROR: function() {
                        return u.$I;
                    },
                    EVENT_EXPIRED: function() {
                        return u.$Y;
                    },
                    EVENT_REMOVED: function() {
                        return u.FT;
                    },
                    EVENT_RENEWED: function() {
                        return u.E;
                    },
                    EVENT_SET_STORAGE: function() {
                        return u.zr;
                    },
                    TokenKind: function() {
                        return a.T6;
                    },
                    isAccessToken: function() {
                        return a.hv;
                    },
                    isCustomAuthTransactionMeta: function() {
                        return c.rZ;
                    },
                    isIDToken: function() {
                        return a.sI;
                    },
                    isIdxTransactionMeta: function() {
                        return c.sG;
                    },
                    isOAuthTransactionMeta: function() {
                        return c.G5;
                    },
                    isPKCETransactionMeta: function() {
                        return c.ZT;
                    },
                    isRefreshToken: function() {
                        return a.z9;
                    },
                    isToken: function() {
                        return a.hD;
                    },
                    isTransactionMeta: function() {
                        return c.mH;
                    }
                });
                var r = n(9263), o = {};
                for(var i in r)"default" !== i && (o[i] = (function(e1) {
                    return r[e1];
                }).bind(0, i));
                n.d(t, o);
                var a = n(6488), u = n(7088), c = n(4319), s = n(7615);
                for(var i in o = {}, s)[
                    "default",
                    "TokenKind",
                    "isAccessToken",
                    "isIDToken",
                    "isRefreshToken",
                    "isToken",
                    "EVENT_ADDED",
                    "EVENT_ERROR",
                    "EVENT_EXPIRED",
                    "EVENT_REMOVED",
                    "EVENT_RENEWED",
                    "EVENT_SET_STORAGE",
                    "isCustomAuthTransactionMeta",
                    "isIdxTransactionMeta",
                    "isOAuthTransactionMeta",
                    "isPKCETransactionMeta",
                    "isTransactionMeta"
                ].indexOf(i) < 0 && (o[i] = (function(e1) {
                    return s[e1];
                }).bind(0, i));
                n.d(t, o);
            },
            9263: function() {},
            4970: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    It: function() {
                        return d;
                    },
                    NH: function() {
                        return c;
                    },
                    Rl: function() {
                        return f;
                    },
                    iC: function() {
                        return p;
                    },
                    pU: function() {
                        return l;
                    },
                    ys: function() {
                        return s;
                    }
                });
                var r = n(4942), o = n(1002), i = n(9123);
                function a(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                var u = 12e4;
                function c(e1, t, n) {
                    e1.addEventListener ? e1.addEventListener(t, n) : e1.attachEvent("on" + t, n);
                }
                function s(e1, t, n) {
                    e1.removeEventListener ? e1.removeEventListener(t, n) : e1.detachEvent("on" + t, n);
                }
                function f(e1) {
                    var t = document.createElement("iframe");
                    return t.style.display = "none", t.src = e1, document.body.appendChild(t);
                }
                function l(e1, t) {
                    var n = t.popupTitle || "External Identity Provider User Authentication";
                    return window.open(e1, n, "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600");
                }
                function p(e1, t, n) {
                    var r, o;
                    return new Promise(function(a, s) {
                        r = function(t) {
                            if (t.data && t.data.state === n) return t.origin !== e1.getIssuerOrigin() ? s(new i.Z("The request does not match client configuration")) : void a(t.data);
                        }, c(window, "message", r), o = setTimeout(function() {
                            s(new i.Z("OAuth flow timed out"));
                        }, t || u);
                    }).finally(function() {
                        clearTimeout(o), s(window, "message", r);
                    });
                }
                function d(e1, t, n, c) {
                    var s, f = new Promise(function(e1, f) {
                        n.onmessage = function(t) {
                            if (t.isTrusted && t.data) return "object" === (0, o.Z)(t.data) && c === t.data.state ? e1(function(e1) {
                                for(var t = 1; t < arguments.length; t++){
                                    var n = null != arguments[t] ? arguments[t] : {};
                                    t % 2 ? a(Object(n), !0).forEach(function(t) {
                                        (0, r.Z)(e1, t, n[t]);
                                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function(t) {
                                        Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                                    });
                                }
                                return e1;
                            }({}, t.data)) : void f(new i.Z("Unable to complete auth code exchange"));
                        }, s = setTimeout(function() {
                            f(new i.Z("OAuth flow timed out"));
                        }, t || u);
                    });
                    return f.finally(function() {
                        clearTimeout(s), n.close();
                    });
                }
            },
            5078: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    c: function() {
                        return a;
                    }
                });
                var r = n(7599), o = n(415), i = n(3193);
                function a(e1) {
                    var t = e1.options, n = t.clientId, a = t.redirectUri, u = t.responseMode, c = t.state, s = (0, o.isBrowser)() ? window.location.href : void 0;
                    return (0, i.YY)({
                        clientId: n,
                        redirectUri: a || s,
                        responseMode: u,
                        state: c || (0, r.aV)(),
                        responseType: "none",
                        prompt: "enroll_authenticator"
                    });
                }
            },
            7756: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    D: function() {
                        return a;
                    }
                });
                var r = n(7599), o = n(415), i = n(3193);
                function a(e1) {
                    var t = e1.options, n = t.pkce, a = t.clientId, u = t.redirectUri, c = t.responseType, s = t.responseMode, f = t.scopes, l = t.acrValues, p = t.maxAge, d = t.state, h = t.ignoreSignature, v = t.dpop, y = (0, o.isBrowser)() ? window.location.href : void 0;
                    return (0, i.YY)({
                        pkce: n,
                        clientId: a,
                        redirectUri: u || y,
                        responseType: c || [
                            "token",
                            "id_token"
                        ],
                        responseMode: s,
                        state: d || (0, r.aV)(),
                        nonce: (0, r.NH)(),
                        scopes: f || [
                            "openid",
                            "email"
                        ],
                        acrValues: l,
                        maxAge: p,
                        ignoreSignature: h,
                        dpop: v
                    });
                }
            },
            8080: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    A: function() {
                        return o;
                    }
                });
                var r = n(7599);
                function o(e1, t) {
                    return {
                        issuer: e1.options.issuer,
                        urls: (0, r.Fc)(e1, t),
                        clientId: t.clientId,
                        redirectUri: t.redirectUri,
                        responseType: t.responseType,
                        responseMode: t.responseMode,
                        state: t.state,
                        acrValues: t.acrValues,
                        enrollAmrValues: t.enrollAmrValues
                    };
                }
            },
            9912: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $E: function() {
                        return a;
                    },
                    Cf: function() {
                        return o;
                    },
                    tC: function() {
                        return i;
                    }
                });
                var r = n(5728);
                function o(e1) {
                    return "OAuthError" === e1.name && "interaction_required" === e1.errorCode;
                }
                function i(e1, t) {
                    if ("AuthApiError" !== t.name) return !1;
                    var n = t.xhr, r = null == n ? void 0 : n.responseJSON;
                    return e1.options.pkce && "invalid_grant" === (null == r ? void 0 : r.error);
                }
                function a(e1) {
                    return (0, r.isOAuthError)(e1) && "invalid_grant" === e1.errorCode && "The refresh token is invalid or expired." === e1.errorSummary;
                }
            },
            8785: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $E: function() {
                        return a.$E;
                    },
                    AW: function() {
                        return f.A;
                    },
                    Cf: function() {
                        return a.Cf;
                    },
                    Dx: function() {
                        return o.D;
                    },
                    Fc: function() {
                        return c.Fc;
                    },
                    H: function() {
                        return s.H;
                    },
                    Ik: function() {
                        return u.Ik;
                    },
                    It: function() {
                        return r.It;
                    },
                    NH: function() {
                        return r.NH;
                    },
                    O2: function() {
                        return u.O2;
                    },
                    PY: function() {
                        return c.NH;
                    },
                    Qs: function() {
                        return u.Qs;
                    },
                    Rl: function() {
                        return r.Rl;
                    },
                    Rp: function() {
                        return g.R;
                    },
                    U5: function() {
                        return l.Z;
                    },
                    Uc: function() {
                        return d.U;
                    },
                    Xp: function() {
                        return c.Xp;
                    },
                    Yo: function() {
                        return h.Y;
                    },
                    ZP: function() {
                        return u.ZP;
                    },
                    aV: function() {
                        return c.aV;
                    },
                    br: function() {
                        return p.br;
                    },
                    cE: function() {
                        return i.c;
                    },
                    d_: function() {
                        return u.d_;
                    },
                    gM: function() {
                        return u.gM;
                    },
                    hg: function() {
                        return u.hg;
                    },
                    iC: function() {
                        return r.iC;
                    },
                    kU: function() {
                        return u.kU;
                    },
                    mi: function() {
                        return p.mi;
                    },
                    pU: function() {
                        return r.pU;
                    },
                    pj: function() {
                        return y.p;
                    },
                    q0: function() {
                        return h.q;
                    },
                    tC: function() {
                        return a.tC;
                    },
                    vL: function() {
                        return v.v;
                    },
                    vz: function() {
                        return p.vz;
                    },
                    wV: function() {
                        return u.wV;
                    },
                    wc: function() {
                        return u.wc;
                    },
                    wu: function() {
                        return p.wu;
                    },
                    ys: function() {
                        return r.ys;
                    },
                    zf: function() {
                        return c.zf;
                    }
                });
                var r = n(4970), o = n(7756), i = n(5078), a = n(9912), u = n(8221), c = n(7599), s = n(2865), f = n(8080), l = n(3611), p = n(6898), d = n(6757), h = n(6635), v = n(1969), y = n(6003), g = n(2482);
            },
            8221: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return /[?&#](id|access)_token=/.test(e1);
                }
                function o(e1) {
                    return /[?&#]code=/.test(e1);
                }
                function i(e1) {
                    return /[?&#]interaction_code=/.test(e1);
                }
                function a(e1) {
                    return /[?&#]error=/.test(e1) || /[?&#]error_description/.test(e1);
                }
                function u(e1, t) {
                    var n = t.options;
                    return !(!e1 || !n.redirectUri) && 0 === e1.indexOf(n.redirectUri);
                }
                function c(e1) {
                    return e1.pkce || "code" === e1.responseType || "query" === e1.responseMode;
                }
                function s(e1, t) {
                    return Array.isArray(t.responseType) && t.responseType.length ? t.responseType.indexOf(e1) >= 0 : t.responseType === e1;
                }
                function f(e1) {
                    return c(e1) && "fragment" !== e1.responseMode ? window.location.search : window.location.hash;
                }
                function l(e1) {
                    if (!u(window.location.href, e1)) return !1;
                    var t = c(e1.options), n = f(e1.options);
                    return !!a(n) || (t ? o(n) || i(n) : r(window.location.hash));
                }
                function p(e1, t) {
                    if (!t) {
                        if (!l(e1)) return !1;
                        t = f(e1.options);
                    }
                    return /(error=interaction_required)/i.test(t);
                }
                n.d(t, {
                    Ik: function() {
                        return c;
                    },
                    O2: function() {
                        return f;
                    },
                    Qs: function() {
                        return u;
                    },
                    ZP: function() {
                        return o;
                    },
                    d_: function() {
                        return i;
                    },
                    gM: function() {
                        return l;
                    },
                    hg: function() {
                        return a;
                    },
                    kU: function() {
                        return r;
                    },
                    wV: function() {
                        return s;
                    },
                    wc: function() {
                        return p;
                    }
                });
            },
            7599: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Fc: function() {
                        return l;
                    },
                    NH: function() {
                        return u;
                    },
                    Xp: function() {
                        return f;
                    },
                    aV: function() {
                        return a;
                    },
                    zf: function() {
                        return s;
                    }
                });
                var r = n(8750), o = n(6718), i = n(9123);
                function a() {
                    return (0, r.uh)(64);
                }
                function u() {
                    return (0, r.uh)(64);
                }
                function c(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return (0, o.Qj)(t.issuer) || e1.options.issuer;
                }
                function s(e1) {
                    var t = c(e1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
                    return t.indexOf("/oauth2") > 0 ? t : t + "/oauth2";
                }
                function f(e1) {
                    return c(e1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).split("/oauth2")[0];
                }
                function l(e1, t) {
                    if (arguments.length > 2) throw new i.Z('As of version 3.0, "getOAuthUrls" takes only a single set of options');
                    t = t || {};
                    var n = (0, o.Qj)(t.authorizeUrl) || e1.options.authorizeUrl, r = c(e1, t), a = (0, o.Qj)(t.userinfoUrl) || e1.options.userinfoUrl, u = (0, o.Qj)(t.tokenUrl) || e1.options.tokenUrl, f = (0, o.Qj)(t.logoutUrl) || e1.options.logoutUrl, l = (0, o.Qj)(t.revokeUrl) || e1.options.revokeUrl, p = s(e1, t);
                    return {
                        issuer: r,
                        authorizeUrl: n = n || p + "/v1/authorize",
                        userinfoUrl: a = a || p + "/v1/userinfo",
                        tokenUrl: u = u || p + "/v1/token",
                        revokeUrl: l = l || p + "/v1/revoke",
                        logoutUrl: f = f || p + "/v1/logout"
                    };
                }
            },
            2865: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return u;
                    }
                });
                var r = n(4942), o = n(7599);
                function i(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function a(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function u(e1, t) {
                    var n = {
                        issuer: e1.options.issuer,
                        urls: (0, o.Fc)(e1, t),
                        clientId: t.clientId,
                        redirectUri: t.redirectUri,
                        responseType: t.responseType,
                        responseMode: t.responseMode,
                        scopes: t.scopes,
                        state: t.state,
                        nonce: t.nonce,
                        ignoreSignature: t.ignoreSignature,
                        acrValues: t.acrValues,
                        extraParams: t.extraParams
                    };
                    return !1 === t.pkce ? n : a(a({}, n), {}, {
                        codeVerifier: t.codeVerifier,
                        codeChallengeMethod: t.codeChallengeMethod,
                        codeChallenge: t.codeChallenge
                    });
                }
            },
            3611: function(e1, t, n) {
                "use strict";
                var r = n(7594), o = n(7987), i = n(1971);
                function a(e1) {
                    return ("0" + e1.toString(16)).substr(-2);
                }
                t.Z = {
                    DEFAULT_CODE_CHALLENGE_METHOD: i.DEFAULT_CODE_CHALLENGE_METHOD,
                    generateVerifier: function(e1) {
                        var t, n, o = e1 || "";
                        return o.length < i.MIN_VERIFIER_LENGTH && (o += (t = i.MIN_VERIFIER_LENGTH - o.length, n = new Uint8Array(Math.ceil(t / 2)), r.KP.getRandomValues(n), Array.from(n, a).join("").slice(0, t))), encodeURIComponent(o).slice(0, i.MAX_VERIFIER_LENGTH);
                    },
                    computeChallenge: function(e1) {
                        var t = (new TextEncoder).encode(e1);
                        return r.KP.subtle.digest("SHA-256", t).then(function(e1) {
                            var t = String.fromCharCode.apply(null, new Uint8Array(e1));
                            return (0, o.NL)(t);
                        });
                    }
                };
            },
            6757: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U: function() {
                        return c;
                    }
                });
                var r = n(4942), o = n(9123), i = n(5078);
                function a(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function u(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? a(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function c(e1, t) {
                    return function(e1) {
                        if (!(e1 = u(u({}, e1), {}, {
                            responseType: "none",
                            prompt: "enroll_authenticator",
                            maxAge: 0
                        })).enrollAmrValues) throw new o.Z("enroll_amr_values must be specified");
                        if (!e1.acrValues) throw new o.Z("acr_values must be specified");
                        return delete e1.scopes, delete e1.nonce, e1;
                    }(u(u({}, (0, i.c)(e1)), t));
                }
            },
            6898: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    br: function() {
                        return v;
                    },
                    mi: function() {
                        return g;
                    },
                    vz: function() {
                        return h;
                    },
                    wu: function() {
                        return b;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(52), c = n(9123), s = n(7756), f = n(1971), l = n(3611);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    if (!e1.features.isPKCESupported()) {
                        var t = "PKCE requires a modern browser with encryption support running in a secure context.";
                        throw e1.features.isHTTPS() || (t += "\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."), e1.features.hasTextEncoder() || (t += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'), new c.Z(t);
                    }
                }
                function v(e1, t) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = n || t.options.codeChallengeMethod || f.DEFAULT_CODE_CHALLENGE_METHOD, e1.next = 3, (0, u.E)(t);
                                case 3:
                                    if (-1 !== (e1.sent.code_challenge_methods_supported || []).indexOf(n)) {
                                        e1.next = 7;
                                        break;
                                    }
                                    throw new c.Z("Invalid code_challenge_method");
                                case 7:
                                    return e1.abrupt("return", n);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function g(e1, t) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = (r = n).codeVerifier, i = r.codeChallenge, u = r.codeChallengeMethod, i = i || t.options.codeChallenge) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return h(t), o = o || l.Z.generateVerifier(), e1.next = 7, l.Z.computeChallenge(o);
                                case 7:
                                    i = e1.sent;
                                case 8:
                                    return e1.next = 10, v(t, u);
                                case 10:
                                    return u = e1.sent, n = d(d({}, n), {}, {
                                        responseType: "code",
                                        codeVerifier: o,
                                        codeChallenge: i,
                                        codeChallengeMethod: u
                                    }), e1.abrupt("return", n);
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return k = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, s.D)(t), !(n = d(d({}, r), n)).dpop || t.features.isDPoPSupported()) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new c.Z("DPoP has been configured, but is not supported by browser");
                                case 5:
                                    if (!1 !== n.pkce) {
                                        e1.next = 7;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 7:
                                    return e1.abrupt("return", g(t, n));
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), k.apply(this, arguments);
                }
            },
            6635: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return i;
                    },
                    q: function() {
                        return o;
                    }
                });
                var r = n(5728);
                function o(e1, t) {
                    return e1.refreshToken === t.refreshToken;
                }
                function i(e1) {
                    return !(!(0, r.isAuthApiError)(e1) || !e1.xhr || !e1.xhr.responseJSON || "invalid_grant" !== e1.xhr.responseJSON.error);
                }
            },
            1969: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t = /\+/g, n = /([^&=]+)=?([^&]*)/g, r = e1 || "";
                    "#" === r.charAt(0) && "/" === r.charAt(1) && (r = r.substring(2)), "#" !== r.charAt(0) && "?" !== r.charAt(0) || (r = r.substring(1));
                    for(var o, i = {}; o = n.exec(r);){
                        var a = o[1], u = o[2];
                        i[a] = "id_token" === a || "access_token" === a || "code" === a ? u : decodeURIComponent(u.replace(t, " "));
                    }
                    return i;
                }
                n.d(t, {
                    v: function() {
                        return r;
                    }
                });
            },
            6003: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    p: function() {
                        return o;
                    }
                });
                var r = n(9123);
                function o(e1, t, n) {
                    var o = n.clientId, i = n.issuer, a = n.nonce, u = n.acrValues;
                    if (!t || !i || !o) throw new r.Z("The jwt, iss, and aud arguments are all required");
                    if (a && t.nonce !== a) throw new r.Z("OAuth flow response nonce doesn't match request nonce");
                    var c = Math.floor(Date.now() / 1e3);
                    if (t.iss !== i) throw new r.Z("The issuer [" + t.iss + "] does not match [" + i + "]");
                    if (Array.isArray(t.aud) && t.aud.indexOf(o) < 0 || !Array.isArray(t.aud) && t.aud !== o) throw new r.Z("The audience [" + t.aud + "] does not match [" + o + "]");
                    if (u && t.acr !== u) throw new r.Z("The acr [" + t.acr + "] does not match acr_values [" + u + "]");
                    if (t.iat > t.exp) throw new r.Z("The JWT expired before it was issued");
                    if (!e1.options.ignoreLifetime) {
                        if (c - e1.options.maxClockSkew > t.exp) throw new r.Z("The JWT expired and is no longer valid");
                        if (t.iat > c + e1.options.maxClockSkew) throw new r.Z("The JWT was issued in the future");
                    }
                }
            },
            2482: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return i;
                    }
                });
                var r = n(9123), o = n(6488);
                function i(e1, t) {
                    if (!(0, o.sI)(e1) && !(0, o.hv)(e1) && !(0, o.z9)(e1)) throw new r.Z("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");
                    if ("accessToken" === t && !(0, o.hv)(e1)) throw new r.Z("invalid accessToken");
                    if ("idToken" === t && !(0, o.sI)(e1)) throw new r.Z("invalid idToken");
                    if ("refreshToken" === t && !(0, o.z9)(e1)) throw new r.Z("invalid refreshToken");
                }
            },
            1260: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(52), u = n(6003), c = n(9123), s = n(1237), f = n(3154), l = n(5698);
                function p(e1, t, n) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, p, d, h, v, y;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n && n.idToken) {
                                        e1.next = 2;
                                        break;
                                    }
                                    throw new c.Z("Only idTokens may be verified");
                                case 2:
                                    return o = (0, s.T)(n.idToken), p = (null == r ? void 0 : r.issuer) || t.options.issuer, e1.next = 6, (0, a.E)(t, p);
                                case 6:
                                    if (d = e1.sent, h = d.issuer, v = Object.assign({
                                        clientId: t.options.clientId,
                                        ignoreSignature: t.options.ignoreSignature
                                    }, r, {
                                        issuer: h
                                    }), (0, u.p)(t, o.payload, v), 1 != v.ignoreSignature && t.features.isTokenVerifySupported()) {
                                        e1.next = 12;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 12:
                                    return e1.next = 14, (0, a.k)(t, n.issuer, o.header.kid);
                                case 14:
                                    return y = e1.sent, e1.next = 17, f.W(n.idToken, y);
                                case 17:
                                    if (e1.sent) {
                                        e1.next = 20;
                                        break;
                                    }
                                    throw new c.Z("The token signature is not valid");
                                case 20:
                                    if (!(r && r.accessToken && n.claims.at_hash)) {
                                        e1.next = 26;
                                        break;
                                    }
                                    return e1.next = 23, l.X(r.accessToken);
                                case 23:
                                    if (e1.sent === n.claims.at_hash) {
                                        e1.next = 26;
                                        break;
                                    }
                                    throw new c.Z("Token hash verification failed");
                                case 26:
                                    return e1.abrupt("return", n);
                                case 27:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            3719: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Gg: function() {
                        return u;
                    },
                    OT: function() {
                        return f;
                    },
                    RJ: function() {
                        return c;
                    },
                    dx: function() {
                        return s;
                    },
                    sH: function() {
                        return a;
                    }
                });
                var r = n(3193), o = n(6718), i = n(5385);
                function a(e1) {
                    return e1.session.get().then(function(e1) {
                        return "ACTIVE" === e1.status;
                    }).catch(function() {
                        return !1;
                    });
                }
                function u(e1) {
                    return (0, i.U2)(e1, "/api/v1/sessions/me", {
                        withCredentials: !0
                    }).then(function(t) {
                        var n = (0, r.CE)(t, "_links");
                        return n.refresh = function() {
                            return (0, i.v_)(e1, (0, r.Rg)(t, "refresh").href, {}, {
                                withCredentials: !0
                            });
                        }, n.user = function() {
                            return (0, i.U2)(e1, (0, r.Rg)(t, "user").href, {
                                withCredentials: !0
                            });
                        }, n;
                    }).catch(function() {
                        return {
                            status: "INACTIVE"
                        };
                    });
                }
                function c(e1) {
                    return (0, i.c3)(e1, {
                        url: e1.getIssuerOrigin() + "/api/v1/sessions/me",
                        method: "DELETE",
                        withCredentials: !0
                    });
                }
                function s(e1) {
                    return (0, i.v_)(e1, "/api/v1/sessions/me/lifecycle/refresh", {}, {
                        withCredentials: !0
                    });
                }
                function f(e1, t, n) {
                    n = n || window.location.href, window.location.assign(e1.getIssuerOrigin() + "/login/sessionCookieRedirect" + (0, o.UK)({
                        checkAccountSetupComplete: !0,
                        token: t,
                        redirectUrl: n
                    }));
                }
            },
            2815: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return o;
                    }
                });
                var r = n(3719);
                function o(e1) {
                    return {
                        close: r.RJ.bind(null, e1),
                        exists: r.sH.bind(null, e1),
                        get: r.Gg.bind(null, e1),
                        refresh: r.dx.bind(null, e1),
                        setCookieAndRedirect: r.OT.bind(null, e1)
                    };
                }
            },
            8041: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Gg: function() {
                        return r.Gg;
                    },
                    MG: function() {
                        return o.M;
                    },
                    OT: function() {
                        return r.OT;
                    },
                    RJ: function() {
                        return r.RJ;
                    },
                    Zg: function() {
                        return i.Z;
                    },
                    dx: function() {
                        return r.dx;
                    },
                    sH: function() {
                        return r.sH;
                    }
                });
                var r = n(3719), o = n(2815), i = n(3980);
            },
            3980: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return h;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(2815);
                function h(e1) {
                    return function(e1) {
                        (0, u.Z)(h, e1);
                        var t, n, l = (t = h, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, s.Z)(t);
                            if (n) {
                                var o = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function h() {
                            var e1;
                            (0, o.Z)(this, h);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = l.call.apply(l, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "session", void 0), e1.session = (0, d.M)((0, a.Z)(e1)), e1;
                        }
                        return (0, i.Z)(h, [
                            {
                                key: "closeSession",
                                value: function() {
                                    var e1 = this;
                                    return this.session.close().then((0, r.Z)(p().mark(function t() {
                                        return p().wrap(function(t) {
                                            for(;;)switch(t.prev = t.next){
                                                case 0:
                                                    return e1.clearStorage(), t.abrupt("return", !0);
                                                case 2:
                                                case "end":
                                                    return t.stop();
                                            }
                                        }, t);
                                    }))).catch(function(e1) {
                                        if ("AuthApiError" === e1.name && "E0000007" === e1.errorCode) return !1;
                                        throw e1;
                                    });
                                }
                            }
                        ]), h;
                    }(e1);
                }
            },
            5437: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    V: function() {
                        return f;
                    },
                    W: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(1971), u = n(5763), c = n(415), s = n(146);
                function f(e1) {
                    (0, c.isBrowser)() || e1.storageProvider || e1.storageKey || (0, s.ZK)("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.");
                }
                var l = function() {
                    function e1(t, n, o) {
                        (0, r.Z)(this, e1), (0, i.Z)(this, "storageManagerOptions", void 0), (0, i.Z)(this, "cookieOptions", void 0), (0, i.Z)(this, "storageUtil", void 0), this.storageManagerOptions = t, this.cookieOptions = n, this.storageUtil = o;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "getOptionsForSection",
                            value: function(e1, t) {
                                return Object.assign({}, this.storageManagerOptions[e1], t);
                            }
                        },
                        {
                            key: "getStorage",
                            value: function(e1) {
                                if ((e1 = Object.assign({}, this.cookieOptions, e1)).storageProvider) return e1.storageProvider;
                                var t = e1, n = t.storageType, r = t.storageTypes;
                                if ("sessionStorage" === n && (e1.sessionCookie = !0), n && r) {
                                    var o = r.indexOf(n);
                                    o >= 0 && (r = r.slice(o), n = void 0);
                                }
                                return n || (n = this.storageUtil.findStorageType(r)), this.storageUtil.getStorageByType(n, e1);
                            }
                        },
                        {
                            key: "getTokenStorage",
                            value: function(e1) {
                                f(e1 = this.getOptionsForSection("token", e1));
                                var t = this.getStorage(e1), n = e1.storageKey || a.TOKEN_STORAGE_NAME;
                                return new u._(t, n);
                            }
                        },
                        {
                            key: "getHttpCache",
                            value: function(e1) {
                                e1 = this.getOptionsForSection("cache", e1);
                                var t = this.getStorage(e1), n = e1.storageKey || a.CACHE_STORAGE_NAME;
                                return new u._(t, n);
                            }
                        }
                    ]), e1;
                }();
            },
            5763: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _: function() {
                        return u;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(9123), u = function() {
                    function e1(t, n) {
                        if ((0, r.Z)(this, e1), (0, i.Z)(this, "storageProvider", void 0), (0, i.Z)(this, "storageName", void 0), !t) throw new a.Z('"storage" is required');
                        if ("string" != typeof n || !n.length) throw new a.Z('"storageName" is required');
                        this.storageName = n, this.storageProvider = t;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "getItem",
                            value: function(e1) {
                                return this.getStorage()[e1];
                            }
                        },
                        {
                            key: "setItem",
                            value: function(e1, t) {
                                return this.updateStorage(e1, t);
                            }
                        },
                        {
                            key: "removeItem",
                            value: function(e1) {
                                return this.clearStorage(e1);
                            }
                        },
                        {
                            key: "getStorage",
                            value: function() {
                                var e1 = this.storageProvider.getItem(this.storageName);
                                e1 = e1 || "{}";
                                try {
                                    return JSON.parse(e1);
                                } catch (e1) {
                                    throw new a.Z("Unable to parse storage string: " + this.storageName);
                                }
                            }
                        },
                        {
                            key: "setStorage",
                            value: function(e1) {
                                try {
                                    var t = e1 ? JSON.stringify(e1) : "{}";
                                    this.storageProvider.setItem(this.storageName, t);
                                } catch (e1) {
                                    throw new a.Z("Unable to set storage: " + this.storageName);
                                }
                            }
                        },
                        {
                            key: "clearStorage",
                            value: function(e1) {
                                if (e1) {
                                    var t = this.getStorage();
                                    delete t[e1], this.setStorage(t);
                                } else this.storageProvider.removeItem ? this.storageProvider.removeItem(this.storageName) : this.setStorage();
                            }
                        },
                        {
                            key: "updateStorage",
                            value: function(e1, t) {
                                var n = this.getStorage();
                                n[e1] = t, this.setStorage(n);
                            }
                        }
                    ]), e1;
                }();
            },
            9927: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Ho: function() {
                        return i.H;
                    },
                    Tp: function() {
                        return r.T;
                    },
                    Vp: function() {
                        return o.V;
                    },
                    W8: function() {
                        return o.W;
                    },
                    _e: function() {
                        return a._;
                    }
                });
                var r = n(3849), o = n(5437), i = n(265), a = n(5763);
            },
            265: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return f;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    return function(e1) {
                        (0, a.Z)(p, e1);
                        var n, f, l = (n = p, f = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, c.Z)(n);
                            if (f) {
                                var r = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, r);
                            } else e1 = t.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function p() {
                            var e1;
                            (0, r.Z)(this, p);
                            for(var n = arguments.length, o = new Array(n), a = 0; a < n; a++)o[a] = arguments[a];
                            e1 = l.call.apply(l, [
                                this
                            ].concat(o)), (0, s.Z)((0, i.Z)(e1), "storageManager", void 0);
                            var u = e1.options, c = u.storageManager, f = u.cookies, d = u.storageUtil;
                            return e1.storageManager = new t(c, f, d), e1;
                        }
                        return (0, o.Z)(p, [
                            {
                                key: "clearStorage",
                                value: function() {}
                            }
                        ]), p;
                    }(e1);
                }
            },
            3849: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return g;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(5093), l = n(146), p = n(4858), d = {
                    token: {
                        storageTypes: [
                            "localStorage",
                            "sessionStorage",
                            "cookie"
                        ]
                    },
                    cache: {
                        storageTypes: [
                            "localStorage",
                            "sessionStorage",
                            "cookie"
                        ]
                    },
                    transaction: {
                        storageTypes: [
                            "sessionStorage",
                            "localStorage",
                            "cookie"
                        ]
                    },
                    "shared-transaction": {
                        storageTypes: [
                            "localStorage"
                        ]
                    },
                    "original-uri": {
                        storageTypes: [
                            "localStorage"
                        ]
                    }
                }, h = n(415);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g() {
                    return function(e1) {
                        (0, a.Z)(v, e1);
                        var t, n, f = (t = v, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function v(e1) {
                            var t;
                            return (0, o.Z)(this, v), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "cookies", void 0), (0, s.Z)((0, i.Z)(t), "storageUtil", void 0), (0, s.Z)((0, i.Z)(t), "storageManager", void 0), t.cookies = function() {
                                var e1 = arguments.length > 1 ? arguments[1] : void 0, t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).cookies || {};
                                return void 0 === t.secure && (t.secure = e1), void 0 === t.sameSite && (t.sameSite = t.secure ? "none" : "lax"), t.secure && !e1 && ((0, l.ZK)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'), t.secure = !1), "none" !== t.sameSite || t.secure || (t.sameSite = "lax"), t;
                            }(e1, (0, h.isHTTPS)()), t.storageUtil = e1.storageUtil || Object.assign({}, p.Z, {
                                inMemoryStore: {}
                            }), t.storageManager = y(y({}, d), e1.storageManager), t;
                        }
                        return (0, r.Z)(v);
                    }((0, f.X)());
                }
            },
            3548: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return c;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(4771), u = n(146), c = function() {
                    function e1() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                            quiet: !1
                        };
                        (0, r.Z)(this, e1), (0, i.Z)(this, "queue", void 0), (0, i.Z)(this, "running", void 0), (0, i.Z)(this, "options", void 0), this.queue = [], this.running = !1, this.options = t;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "push",
                            value: function(e1, t) {
                                for(var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)o[i - 2] = arguments[i];
                                return new Promise(function(r, i) {
                                    n.queue.length > 0 && !1 !== n.options.quiet && (0, u.ZK)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes."), n.queue.push({
                                        method: e1,
                                        thisObject: t,
                                        args: o,
                                        resolve: r,
                                        reject: i
                                    }), n.run();
                                });
                            }
                        },
                        {
                            key: "run",
                            value: function() {
                                var e1 = this;
                                if (!this.running && 0 !== this.queue.length) {
                                    this.running = !0;
                                    var t = this.queue.shift(), n = t.method.apply(t.thisObject, t.args);
                                    (0, a.tI)(n) ? n.then(t.resolve, t.reject).finally(function() {
                                        e1.running = !1, e1.run();
                                    }) : (t.resolve(n), this.running = !1, this.run());
                                }
                            }
                        }
                    ]), e1;
                }();
            },
            146: function(e1, t, n) {
                "use strict";
                function r() {
                    return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
                }
                function o() {
                    var e1 = r();
                    return e1 && e1.log ? e1 : {
                        log: function() {},
                        warn: function() {},
                        group: function() {},
                        groupEnd: function() {}
                    };
                }
                function i(e1) {
                    o().warn("[okta-auth-sdk] WARN: " + e1);
                }
                function a(e1) {
                    o().warn("[okta-auth-sdk] DEPRECATION: " + e1);
                }
                function u(e1, t) {
                    return function() {
                        return a(e1), t.apply(null, arguments);
                    };
                }
                n.d(t, {
                    Rn: function() {
                        return a;
                    },
                    VA: function() {
                        return u;
                    },
                    ZK: function() {
                        return i;
                    },
                    dr: function() {
                        return o;
                    },
                    sW: function() {
                        return r;
                    }
                });
            },
            305: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    BY: function() {
                        return c.BY;
                    },
                    CE: function() {
                        return i.CE;
                    },
                    HD: function() {
                        return u.HD;
                    },
                    Kn: function() {
                        return u.Kn;
                    },
                    QN: function() {
                        return c.QN;
                    },
                    Qj: function() {
                        return c.Qj;
                    },
                    Rg: function() {
                        return i.Rg;
                    },
                    Rn: function() {
                        return r.Rn;
                    },
                    UK: function() {
                        return c.UK;
                    },
                    VA: function() {
                        return r.VA;
                    },
                    YQ: function() {
                        return o.YQ;
                    },
                    YY: function() {
                        return i.YY;
                    },
                    ZK: function() {
                        return r.ZK;
                    },
                    ak: function() {
                        return i.ak;
                    },
                    bo: function() {
                        return a.b;
                    },
                    d9: function() {
                        return i.d9;
                    },
                    dr: function() {
                        return r.dr;
                    },
                    gw: function() {
                        return o.gw;
                    },
                    hj: function() {
                        return u.hj;
                    },
                    l7: function() {
                        return i.l7;
                    },
                    mf: function() {
                        return u.mf;
                    },
                    ng: function() {
                        return o.ng;
                    },
                    sD: function() {
                        return c.sD;
                    },
                    sE: function() {
                        return i.sE;
                    },
                    sW: function() {
                        return r.sW;
                    },
                    tI: function() {
                        return u.tI;
                    },
                    uh: function() {
                        return o.uh;
                    }
                });
                var r = n(146), o = n(8750), i = n(3193), a = n(3548), u = n(4771), c = n(6718);
            },
            8750: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t = e1.match(/\d+/g), n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    return new Date(n).toUTCString();
                }
                function o(e1) {
                    for(var t = "", n = 0; n < e1; ++n)t += "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[Math.floor(61 * Math.random())];
                    return t;
                }
                function i(e1) {
                    return new Promise(function(t) {
                        setTimeout(t, e1);
                    });
                }
                function a(e1, t) {
                    var n = e1.split(t);
                    return [
                        n[0],
                        n.splice(1, n.length).join(t)
                    ];
                }
                n.d(t, {
                    YQ: function() {
                        return a;
                    },
                    gw: function() {
                        return i;
                    },
                    ng: function() {
                        return r;
                    },
                    uh: function() {
                        return o;
                    }
                });
            },
            3193: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    var n = Array.prototype.slice.call(arguments, 2);
                    return function() {
                        var r = Array.prototype.slice.call(arguments);
                        return r = n.concat(r), e1.apply(t, r);
                    };
                }
                function o() {
                    var e1 = arguments[0];
                    return [].slice.call(arguments, 1).forEach(function(t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e1[n] = t[n]);
                    }), e1;
                }
                function i(e1) {
                    var t = {};
                    for(var n in e1)if (Object.prototype.hasOwnProperty.call(e1, n)) {
                        var r = e1[n];
                        null != r && (t[n] = r);
                    }
                    return t;
                }
                function a(e1) {
                    if (e1) {
                        var t = JSON.stringify(e1);
                        if (t) return JSON.parse(t);
                    }
                    return e1;
                }
                function u(e1) {
                    for(var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)r[o - 1] = arguments[o];
                    for(var i in e1)Object.prototype.hasOwnProperty.call(e1, i) && -1 == r.indexOf(i) && (t[i] = e1[i]);
                    return a(t);
                }
                function c(e1, t) {
                    for(var n = e1.length; n--;){
                        var r = e1[n], o = !0;
                        for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
                            o = !1;
                            break;
                        }
                        if (o) return r;
                    }
                }
                function s(e1, t, n) {
                    if (e1 && e1._links) {
                        var r = a(e1._links[t]);
                        return r && r.name && n ? r.name === n ? r : void 0 : r;
                    }
                }
                n.d(t, {
                    CE: function() {
                        return u;
                    },
                    Rg: function() {
                        return s;
                    },
                    YY: function() {
                        return i;
                    },
                    ak: function() {
                        return r;
                    },
                    d9: function() {
                        return a;
                    },
                    l7: function() {
                        return o;
                    },
                    sE: function() {
                        return c;
                    }
                });
            },
            4771: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return "[object String]" === Object.prototype.toString.call(e1);
                }
                function o(e1) {
                    return "[object Object]" === Object.prototype.toString.call(e1);
                }
                function i(e1) {
                    return "[object Number]" === Object.prototype.toString.call(e1);
                }
                function a(e1) {
                    return !!e1 && "[object Function]" === ({}).toString.call(e1);
                }
                function u(e1) {
                    return e1 && e1.finally && "function" == typeof e1.finally;
                }
                n.d(t, {
                    HD: function() {
                        return r;
                    },
                    Kn: function() {
                        return o;
                    },
                    hj: function() {
                        return i;
                    },
                    mf: function() {
                        return a;
                    },
                    tI: function() {
                        return u;
                    }
                });
            },
            6718: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return /^[a-z][a-z0-9+.-]*:/i.test(e1);
                }
                function o() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                    return r(e1) ? e1 : (t = u(t), "/" === e1[0] ? "".concat(t).concat(e1) : "".concat(t, "/").concat(e1));
                }
                function i() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                    return r(e1) && (e1 = e1.substring(t.length)), "/" === e1[0] ? e1 : "/".concat(e1);
                }
                function a(e1) {
                    var t = [];
                    if (null !== e1) for(var n in e1)Object.prototype.hasOwnProperty.call(e1, n) && void 0 !== e1[n] && null !== e1[n] && t.push(n + "=" + encodeURIComponent(e1[n]));
                    return t.length ? "?" + t.join("&") : "";
                }
                function u(e1) {
                    if (e1) {
                        var t = e1.replace(/^\s+|\s+$/gm, "");
                        return t.replace(/\/+$/, "");
                    }
                }
                n.d(t, {
                    BY: function() {
                        return o;
                    },
                    QN: function() {
                        return i;
                    },
                    Qj: function() {
                        return u;
                    },
                    UK: function() {
                        return a;
                    },
                    sD: function() {
                        return r;
                    }
                });
            },
            3615: function(e1, t, n) {
                "use strict";
                var r = n(6690), o = n(9728), i = n(1655), a = n(4993), u = n(3808);
                function c(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var s = function(e1) {
                    i(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = u(t);
                        if (n) {
                            var o = u(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return a(this, e1);
                    });
                    function s(e1) {
                        var t;
                        return r(this, s), (t = c.call(this, e1 || "Promise was canceled")).name = "CancelError", t;
                    }
                    return o(s, [
                        {
                            key: "isCanceled",
                            get: function() {
                                return !0;
                            }
                        }
                    ]), s;
                }(n(3496)(Error)), f = function() {
                    function e1(t) {
                        var n = this;
                        r(this, e1), this._cancelHandlers = [], this._isPending = !0, this._isCanceled = !1, this._rejectOnCancel = !0, this._promise = new Promise(function(e1, r) {
                            n._reject = r;
                            var o = function(e1) {
                                if (!n._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");
                                n._cancelHandlers.push(e1);
                            };
                            return Object.defineProperties(o, {
                                shouldReject: {
                                    get: function() {
                                        return n._rejectOnCancel;
                                    },
                                    set: function(e1) {
                                        n._rejectOnCancel = e1;
                                    }
                                }
                            }), t(function(t) {
                                n._isCanceled && o.shouldReject || (n._isPending = !1, e1(t));
                            }, function(e1) {
                                n._isPending = !1, r(e1);
                            }, o);
                        });
                    }
                    return o(e1, [
                        {
                            key: "then",
                            value: function(e1, t) {
                                return this._promise.then(e1, t);
                            }
                        },
                        {
                            key: "catch",
                            value: function(e1) {
                                return this._promise.catch(e1);
                            }
                        },
                        {
                            key: "finally",
                            value: function(e1) {
                                return this._promise.finally(e1);
                            }
                        },
                        {
                            key: "cancel",
                            value: function(e1) {
                                if (this._isPending && !this._isCanceled) {
                                    if (this._isCanceled = !0, this._cancelHandlers.length > 0) try {
                                        var t, n = function(e1, t) {
                                            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                            if (!n) {
                                                if (Array.isArray(e1) || (n = function(e1, t) {
                                                    if (e1) {
                                                        if ("string" == typeof e1) return c(e1, t);
                                                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? c(e1, t) : void 0;
                                                    }
                                                }(e1)) || t && e1 && "number" == typeof e1.length) {
                                                    n && (e1 = n);
                                                    var r = 0, o = function() {};
                                                    return {
                                                        s: o,
                                                        n: function() {
                                                            return r >= e1.length ? {
                                                                done: !0
                                                            } : {
                                                                done: !1,
                                                                value: e1[r++]
                                                            };
                                                        },
                                                        e: function(e1) {
                                                            throw e1;
                                                        },
                                                        f: o
                                                    };
                                                }
                                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            }
                                            var i, a = !0, u = !1;
                                            return {
                                                s: function() {
                                                    n = n.call(e1);
                                                },
                                                n: function() {
                                                    var e1 = n.next();
                                                    return a = e1.done, e1;
                                                },
                                                e: function(e1) {
                                                    u = !0, i = e1;
                                                },
                                                f: function() {
                                                    try {
                                                        a || null == n.return || n.return();
                                                    } finally{
                                                        if (u) throw i;
                                                    }
                                                }
                                            };
                                        }(this._cancelHandlers);
                                        try {
                                            for(n.s(); !(t = n.n()).done;)(0, t.value)();
                                        } catch (e1) {
                                            n.e(e1);
                                        } finally{
                                            n.f();
                                        }
                                    } catch (e1) {
                                        return void this._reject(e1);
                                    }
                                    this._rejectOnCancel && this._reject(new s(e1));
                                }
                            }
                        },
                        {
                            key: "isCanceled",
                            get: function() {
                                return this._isCanceled;
                            }
                        }
                    ], [
                        {
                            key: "fn",
                            value: function(t) {
                                return function() {
                                    for(var n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                                    return new e1(function(e1, n, o) {
                                        r.push(o), t.apply(void 0, r).then(e1, n);
                                    });
                                };
                            }
                        }
                    ]), e1;
                }();
                Object.setPrototypeOf(f.prototype, Promise.prototype), e1.exports = f, e1.exports.CancelError = s;
            },
            4098: function(e1, t) {
                var n = "undefined" != typeof self ? self : this, r = function() {
                    function e1() {
                        this.fetch = !1, this.DOMException = n.DOMException;
                    }
                    return e1.prototype = n, new e1;
                }();
                !function(e1) {
                    !function(t) {
                        var n = {
                            searchParams: "URLSearchParams" in e1,
                            iterable: "Symbol" in e1 && "iterator" in Symbol,
                            blob: "FileReader" in e1 && "Blob" in e1 && function() {
                                try {
                                    return new Blob, !0;
                                } catch (e1) {
                                    return !1;
                                }
                            }(),
                            formData: "FormData" in e1,
                            arrayBuffer: "ArrayBuffer" in e1
                        };
                        if (n.arrayBuffer) var r = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]"
                        ], o = ArrayBuffer.isView || function(e1) {
                            return e1 && r.indexOf(Object.prototype.toString.call(e1)) > -1;
                        };
                        function i(e1) {
                            if ("string" != typeof e1 && (e1 = String(e1)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e1)) throw new TypeError("Invalid character in header field name");
                            return e1.toLowerCase();
                        }
                        function a(e1) {
                            return "string" != typeof e1 && (e1 = String(e1)), e1;
                        }
                        function u(e1) {
                            var t = {
                                next: function() {
                                    var t = e1.shift();
                                    return {
                                        done: void 0 === t,
                                        value: t
                                    };
                                }
                            };
                            return n.iterable && (t[Symbol.iterator] = function() {
                                return t;
                            }), t;
                        }
                        function c(e1) {
                            this.map = {}, e1 instanceof c ? e1.forEach(function(e1, t) {
                                this.append(t, e1);
                            }, this) : Array.isArray(e1) ? e1.forEach(function(e1) {
                                this.append(e1[0], e1[1]);
                            }, this) : e1 && Object.getOwnPropertyNames(e1).forEach(function(t) {
                                this.append(t, e1[t]);
                            }, this);
                        }
                        function s(e1) {
                            if (e1.bodyUsed) return Promise.reject(new TypeError("Already read"));
                            e1.bodyUsed = !0;
                        }
                        function f(e1) {
                            return new Promise(function(t, n) {
                                e1.onload = function() {
                                    t(e1.result);
                                }, e1.onerror = function() {
                                    n(e1.error);
                                };
                            });
                        }
                        function l(e1) {
                            var t = new FileReader, n = f(t);
                            return t.readAsArrayBuffer(e1), n;
                        }
                        function p(e1) {
                            if (e1.slice) return e1.slice(0);
                            var t = new Uint8Array(e1.byteLength);
                            return t.set(new Uint8Array(e1)), t.buffer;
                        }
                        function d() {
                            return this.bodyUsed = !1, this._initBody = function(e1) {
                                var t;
                                this._bodyInit = e1, e1 ? "string" == typeof e1 ? this._bodyText = e1 : n.blob && Blob.prototype.isPrototypeOf(e1) ? this._bodyBlob = e1 : n.formData && FormData.prototype.isPrototypeOf(e1) ? this._bodyFormData = e1 : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e1) ? this._bodyText = e1.toString() : n.arrayBuffer && n.blob && (t = e1) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = p(e1.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ])) : n.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e1) || o(e1)) ? this._bodyArrayBuffer = p(e1) : this._bodyText = e1 = Object.prototype.toString.call(e1) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e1 ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e1) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                            }, n.blob && (this.blob = function() {
                                var e1 = s(this);
                                if (e1) return e1;
                                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                    this._bodyArrayBuffer
                                ]));
                                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                return Promise.resolve(new Blob([
                                    this._bodyText
                                ]));
                            }, this.arrayBuffer = function() {
                                return this._bodyArrayBuffer ? s(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(l);
                            }), this.text = function() {
                                var e1, t, n, r = s(this);
                                if (r) return r;
                                if (this._bodyBlob) return e1 = this._bodyBlob, n = f(t = new FileReader), t.readAsText(e1), n;
                                if (this._bodyArrayBuffer) return Promise.resolve(function(e1) {
                                    for(var t = new Uint8Array(e1), n = new Array(t.length), r = 0; r < t.length; r++)n[r] = String.fromCharCode(t[r]);
                                    return n.join("");
                                }(this._bodyArrayBuffer));
                                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                return Promise.resolve(this._bodyText);
                            }, n.formData && (this.formData = function() {
                                return this.text().then(y);
                            }), this.json = function() {
                                return this.text().then(JSON.parse);
                            }, this;
                        }
                        c.prototype.append = function(e1, t) {
                            e1 = i(e1), t = a(t);
                            var n = this.map[e1];
                            this.map[e1] = n ? n + ", " + t : t;
                        }, c.prototype.delete = function(e1) {
                            delete this.map[i(e1)];
                        }, c.prototype.get = function(e1) {
                            return e1 = i(e1), this.has(e1) ? this.map[e1] : null;
                        }, c.prototype.has = function(e1) {
                            return this.map.hasOwnProperty(i(e1));
                        }, c.prototype.set = function(e1, t) {
                            this.map[i(e1)] = a(t);
                        }, c.prototype.forEach = function(e1, t) {
                            for(var n in this.map)this.map.hasOwnProperty(n) && e1.call(t, this.map[n], n, this);
                        }, c.prototype.keys = function() {
                            var e1 = [];
                            return this.forEach(function(t, n) {
                                e1.push(n);
                            }), u(e1);
                        }, c.prototype.values = function() {
                            var e1 = [];
                            return this.forEach(function(t) {
                                e1.push(t);
                            }), u(e1);
                        }, c.prototype.entries = function() {
                            var e1 = [];
                            return this.forEach(function(t, n) {
                                e1.push([
                                    n,
                                    t
                                ]);
                            }), u(e1);
                        }, n.iterable && (c.prototype[Symbol.iterator] = c.prototype.entries);
                        var h = [
                            "DELETE",
                            "GET",
                            "HEAD",
                            "OPTIONS",
                            "POST",
                            "PUT"
                        ];
                        function v(e1, t) {
                            var n, r, o = (t = t || {}).body;
                            if (e1 instanceof v) {
                                if (e1.bodyUsed) throw new TypeError("Already read");
                                this.url = e1.url, this.credentials = e1.credentials, t.headers || (this.headers = new c(e1.headers)), this.method = e1.method, this.mode = e1.mode, this.signal = e1.signal, o || null == e1._bodyInit || (o = e1._bodyInit, e1.bodyUsed = !0);
                            } else this.url = String(e1);
                            if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new c(t.headers)), this.method = (r = (n = t.method || this.method || "GET").toUpperCase(), h.indexOf(r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                            this._initBody(o);
                        }
                        function y(e1) {
                            var t = new FormData;
                            return e1.trim().split("&").forEach(function(e1) {
                                if (e1) {
                                    var n = e1.split("="), r = n.shift().replace(/\+/g, " "), o = n.join("=").replace(/\+/g, " ");
                                    t.append(decodeURIComponent(r), decodeURIComponent(o));
                                }
                            }), t;
                        }
                        function g(e1, t) {
                            t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new c(t.headers), this.url = t.url || "", this._initBody(e1);
                        }
                        v.prototype.clone = function() {
                            return new v(this, {
                                body: this._bodyInit
                            });
                        }, d.call(v.prototype), d.call(g.prototype), g.prototype.clone = function() {
                            return new g(this._bodyInit, {
                                status: this.status,
                                statusText: this.statusText,
                                headers: new c(this.headers),
                                url: this.url
                            });
                        }, g.error = function() {
                            var e1 = new g(null, {
                                status: 0,
                                statusText: ""
                            });
                            return e1.type = "error", e1;
                        };
                        var m = [
                            301,
                            302,
                            303,
                            307,
                            308
                        ];
                        g.redirect = function(e1, t) {
                            if (-1 === m.indexOf(t)) throw new RangeError("Invalid status code");
                            return new g(null, {
                                status: t,
                                headers: {
                                    location: e1
                                }
                            });
                        }, t.DOMException = e1.DOMException;
                        try {
                            new t.DOMException;
                        } catch (e1) {
                            t.DOMException = function(e1, t) {
                                this.message = e1, this.name = t;
                                var n = Error(e1);
                                this.stack = n.stack;
                            }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
                        }
                        function b(e1, r) {
                            return new Promise(function(o, i) {
                                var a = new v(e1, r);
                                if (a.signal && a.signal.aborted) return i(new t.DOMException("Aborted", "AbortError"));
                                var u = new XMLHttpRequest;
                                function s() {
                                    u.abort();
                                }
                                u.onload = function() {
                                    var e1, t, n = {
                                        status: u.status,
                                        statusText: u.statusText,
                                        headers: (e1 = u.getAllResponseHeaders() || "", t = new c, e1.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e1) {
                                            var n = e1.split(":"), r = n.shift().trim();
                                            if (r) {
                                                var o = n.join(":").trim();
                                                t.append(r, o);
                                            }
                                        }), t)
                                    };
                                    n.url = "responseURL" in u ? u.responseURL : n.headers.get("X-Request-URL");
                                    var r = "response" in u ? u.response : u.responseText;
                                    o(new g(r, n));
                                }, u.onerror = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.ontimeout = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.onabort = function() {
                                    i(new t.DOMException("Aborted", "AbortError"));
                                }, u.open(a.method, a.url, !0), "include" === a.credentials ? u.withCredentials = !0 : "omit" === a.credentials && (u.withCredentials = !1), "responseType" in u && n.blob && (u.responseType = "blob"), a.headers.forEach(function(e1, t) {
                                    u.setRequestHeader(t, e1);
                                }), a.signal && (a.signal.addEventListener("abort", s), u.onreadystatechange = function() {
                                    4 === u.readyState && a.signal.removeEventListener("abort", s);
                                }), u.send(void 0 === a._bodyInit ? null : a._bodyInit);
                            });
                        }
                        b.polyfill = !0, e1.fetch || (e1.fetch = b, e1.Headers = c, e1.Request = v, e1.Response = g), t.Headers = c, t.Request = v, t.Response = g, t.fetch = b, Object.defineProperty(t, "__esModule", {
                            value: !0
                        });
                    }({});
                }(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
                var o = r;
                (t = o.fetch).default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e1.exports = t;
            },
            4279: function(e1) {
                function t() {}
                t.prototype = {
                    on: function(e1, t, n) {
                        var r = this.e || (this.e = {});
                        return (r[e1] || (r[e1] = [])).push({
                            fn: t,
                            ctx: n
                        }), this;
                    },
                    once: function(e1, t, n) {
                        var r = this;
                        function o() {
                            r.off(e1, o), t.apply(n, arguments);
                        }
                        return o._ = t, this.on(e1, o, n);
                    },
                    emit: function(e1) {
                        for(var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e1] || []).slice(), r = 0, o = n.length; r < o; r++)n[r].fn.apply(n[r].ctx, t);
                        return this;
                    },
                    off: function(e1, t) {
                        var n = this.e || (this.e = {}), r = n[e1], o = [];
                        if (r && t) for(var i = 0, a = r.length; i < a; i++)r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
                        return o.length ? n[e1] = o : delete n[e1], this;
                    }
                }, e1.exports = t;
            },
            6115: function(e1) {
                e1.exports = function(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6690: function(e1) {
                e1.exports = function(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3515: function(e1, t, n) {
                var r = n(9617), o = n(6015);
                e1.exports = function(e1, t, n) {
                    if (r()) return Reflect.construct.apply(null, arguments);
                    var i = [
                        null
                    ];
                    i.push.apply(i, t);
                    var a = new (e1.bind.apply(e1, i));
                    return n && o(a, n.prototype), a;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            9728: function(e1, t, n) {
                var r = n(4062);
                function o(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var o = t[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, r(o.key), o);
                    }
                }
                e1.exports = function(e1, t, n) {
                    return t && o(e1.prototype, t), n && o(e1, n), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3808: function(e1) {
                function t(n) {
                    return e1.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            1655: function(e1, t, n) {
                var r = n(6015);
                e1.exports = function(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), t && r(e1, t);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6035: function(e1) {
                e1.exports = function(e1) {
                    try {
                        return -1 !== Function.toString.call(e1).indexOf("[native code]");
                    } catch (t) {
                        return "function" == typeof e1;
                    }
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            9617: function(e1) {
                function t() {
                    try {
                        var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (n) {}
                    return (e1.exports = t = function() {
                        return !!n;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports)();
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4993: function(e1, t, n) {
                var r = n(8698).default, o = n(6115);
                e1.exports = function(e1, t) {
                    if (t && ("object" == r(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return o(e1);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            7061: function(e1, t, n) {
                var r = n(8698).default;
                function o() {
                    "use strict";
                    e1.exports = o = function() {
                        return n;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
                    var t, n = {}, i = Object.prototype, a = i.hasOwnProperty, u = Object.defineProperty || function(e1, t, n) {
                        e1[t] = n.value;
                    }, c = "function" == typeof Symbol ? Symbol : {}, s = c.iterator || "@@iterator", f = c.asyncIterator || "@@asyncIterator", l = c.toStringTag || "@@toStringTag";
                    function p(e1, t, n) {
                        return Object.defineProperty(e1, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        p({}, "");
                    } catch (t) {
                        p = function(e1, t, n) {
                            return e1[t] = n;
                        };
                    }
                    function d(e1, t, n, r) {
                        var o = t && t.prototype instanceof k ? t : k, i = Object.create(o.prototype), a = new C(r || []);
                        return u(i, "_invoke", {
                            value: A(e1, n, a)
                        }), i;
                    }
                    function h(e1, t, n) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, n)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    n.wrap = d;
                    var v = "suspendedStart", y = "suspendedYield", g = "executing", m = "completed", b = {};
                    function k() {}
                    function w() {}
                    function O() {}
                    var Z = {};
                    p(Z, s, function() {
                        return this;
                    });
                    var T = Object.getPrototypeOf, E = T && T(T(I([])));
                    E && E !== i && a.call(E, s) && (Z = E);
                    var P = O.prototype = k.prototype = Object.create(Z);
                    function S(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            p(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function x(e1, t) {
                        function n(o, i, u, c) {
                            var s = h(e1[o], e1, i);
                            if ("throw" !== s.type) {
                                var f = s.arg, l = f.value;
                                return l && "object" == r(l) && a.call(l, "__await") ? t.resolve(l.__await).then(function(e1) {
                                    n("next", e1, u, c);
                                }, function(e1) {
                                    n("throw", e1, u, c);
                                }) : t.resolve(l).then(function(e1) {
                                    f.value = e1, u(f);
                                }, function(e1) {
                                    return n("throw", e1, u, c);
                                });
                            }
                            c(s.arg);
                        }
                        var o;
                        u(this, "_invoke", {
                            value: function(e1, r) {
                                function i() {
                                    return new t(function(t, o) {
                                        n(e1, r, t, o);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function A(e1, n, r) {
                        var o = v;
                        return function(i, a) {
                            if (o === g) throw Error("Generator is already running");
                            if (o === m) {
                                if ("throw" === i) throw a;
                                return {
                                    value: t,
                                    done: !0
                                };
                            }
                            for(r.method = i, r.arg = a;;){
                                var u = r.delegate;
                                if (u) {
                                    var c = R(u, r);
                                    if (c) {
                                        if (c === b) continue;
                                        return c;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if (o === v) throw o = m, r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                o = g;
                                var s = h(e1, n, r);
                                if ("normal" === s.type) {
                                    if (o = r.done ? m : y, s.arg === b) continue;
                                    return {
                                        value: s.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === s.type && (o = m, r.method = "throw", r.arg = s.arg);
                            }
                        };
                    }
                    function R(e1, n) {
                        var r = n.method, o = e1.iterator[r];
                        if (o === t) return n.delegate = null, "throw" === r && e1.iterator.return && (n.method = "return", n.arg = t, R(e1, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), b;
                        var i = h(o, e1.iterator, n.arg);
                        if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, b;
                        var a = i.arg;
                        return a ? a.done ? (n[e1.resultName] = a.value, n.next = e1.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, b) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, b);
                    }
                    function _(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function j(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function C(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(_, this), this.reset(!0);
                    }
                    function I(e1) {
                        if (e1 || "" === e1) {
                            var n = e1[s];
                            if (n) return n.call(e1);
                            if ("function" == typeof e1.next) return e1;
                            if (!isNaN(e1.length)) {
                                var o = -1, i = function n() {
                                    for(; ++o < e1.length;)if (a.call(e1, o)) return n.value = e1[o], n.done = !1, n;
                                    return n.value = t, n.done = !0, n;
                                };
                                return i.next = i;
                            }
                        }
                        throw new TypeError(r(e1) + " is not iterable");
                    }
                    return w.prototype = O, u(P, "constructor", {
                        value: O,
                        configurable: !0
                    }), u(O, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = p(O, l, "GeneratorFunction"), n.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, n.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, O) : (e1.__proto__ = O, p(e1, l, "GeneratorFunction")), e1.prototype = Object.create(P), e1;
                    }, n.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, S(x.prototype), p(x.prototype, f, function() {
                        return this;
                    }), n.AsyncIterator = x, n.async = function(e1, t, r, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new x(d(e1, t, r, o), i);
                        return n.isGeneratorFunction(t) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, S(P), p(P, l, "Generator"), p(P, s, function() {
                        return this;
                    }), p(P, "toString", function() {
                        return "[object Generator]";
                    }), n.keys = function(e1) {
                        var t = Object(e1), n = [];
                        for(var r in t)n.push(r);
                        return n.reverse(), function e1() {
                            for(; n.length;){
                                var r = n.pop();
                                if (r in t) return e1.value = r, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, n.values = I, C.prototype = {
                        constructor: C,
                        reset: function(e1) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(j), !e1) for(var n in this)"t" === n.charAt(0) && a.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(e1) {
                            if (this.done) throw e1;
                            var n = this;
                            function r(r, o) {
                                return u.type = "throw", u.arg = e1, n.next = r, o && (n.method = "next", n.arg = t), !!o;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var i = this.tryEntries[o], u = i.completion;
                                if ("root" === i.tryLoc) return r("end");
                                if (i.tryLoc <= this.prev) {
                                    var c = a.call(i, "catchLoc"), s = a.call(i, "finallyLoc");
                                    if (c && s) {
                                        if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                                        if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                                    } else if (c) {
                                        if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                                    } else {
                                        if (!s) throw Error("try statement without catch or finally");
                                        if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var r = this.tryEntries[n];
                                if (r.tryLoc <= this.prev && a.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                                    var o = r;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var i = o ? o.completion : {};
                            return i.type = e1, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, b) : this.complete(i);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), b;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.finallyLoc === e1) return this.complete(n.completion, n.afterLoc), j(n), b;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.tryLoc === e1) {
                                    var r = n.completion;
                                    if ("throw" === r.type) {
                                        var o = r.arg;
                                        j(n);
                                    }
                                    return o;
                                }
                            }
                            throw Error("illegal catch attempt");
                        },
                        delegateYield: function(e1, n, r) {
                            return this.delegate = {
                                iterator: I(e1),
                                resultName: n,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = t), b;
                        }
                    }, n;
                }
                e1.exports = o, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6015: function(e1) {
                function t(n, r) {
                    return e1.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n, r);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            5036: function(e1, t, n) {
                var r = n(8698).default;
                e1.exports = function(e1, t) {
                    if ("object" != r(e1) || !e1) return e1;
                    var n = e1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var o = n.call(e1, t || "default");
                        if ("object" != r(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === t ? String : Number)(e1);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4062: function(e1, t, n) {
                var r = n(8698).default, o = n(5036);
                e1.exports = function(e1) {
                    var t = o(e1, "string");
                    return "symbol" == r(t) ? t : t + "";
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            8698: function(e1) {
                function t(n) {
                    return e1.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3496: function(e1, t, n) {
                var r = n(3808), o = n(6015), i = n(6035), a = n(3515);
                function u(t) {
                    var n = "function" == typeof Map ? new Map : void 0;
                    return e1.exports = u = function(e1) {
                        if (null === e1 || !i(e1)) return e1;
                        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== n) {
                            if (n.has(e1)) return n.get(e1);
                            n.set(e1, t);
                        }
                        function t() {
                            return a(e1, arguments, r(this).constructor);
                        }
                        return t.prototype = Object.create(e1.prototype, {
                            constructor: {
                                value: t,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), o(t, e1);
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, u(t);
                }
                e1.exports = u, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4687: function(e1, t, n) {
                var r = n(7061)();
                e1.exports = r;
                try {
                    regeneratorRuntime = r;
                } catch (e1) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = r : Function("r", "regeneratorRuntime = r")(r);
                }
            },
            907: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            7326: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            5861: function(e1, t, n) {
                "use strict";
                function r(e1, t, n, r, o, i, a) {
                    try {
                        var u = e1[i](a), c = u.value;
                    } catch (e1) {
                        return void n(e1);
                    }
                    u.done ? t(c) : Promise.resolve(c).then(r, o);
                }
                function o(e1) {
                    return function() {
                        var t = this, n = arguments;
                        return new Promise(function(o, i) {
                            var a = e1.apply(t, n);
                            function u(e1) {
                                r(a, o, i, u, c, "next", e1);
                            }
                            function c(e1) {
                                r(a, o, i, u, c, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
            },
            5671: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            3144: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(9142);
                function o(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var o = t[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, (0, r.Z)(o.key), o);
                    }
                }
                function i(e1, t, n) {
                    return t && o(e1.prototype, t), n && o(e1, n), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
            },
            4942: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(9142);
                function o(e1, t, n) {
                    return (t = (0, r.Z)(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = n, e1;
                }
            },
            1752: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(1120);
                function o() {
                    return o = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e1, t, n) {
                        var o = function(e1, t) {
                            for(; !({}).hasOwnProperty.call(e1, t) && null !== (e1 = (0, r.Z)(e1)););
                            return e1;
                        }(e1, t);
                        if (o) {
                            var i = Object.getOwnPropertyDescriptor(o, t);
                            return i.get ? i.get.call(arguments.length < 3 ? e1 : n) : i.value;
                        }
                    }, o.apply(null, arguments);
                }
            },
            1120: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, r(e1);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            136: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(9611);
                function o(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), t && (0, r.Z)(e1, t);
                }
            },
            4925: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    if (null == e1) return {};
                    var n, r, o = function(e1, t) {
                        if (null == e1) return {};
                        var n = {};
                        for(var r in e1)if (({}).hasOwnProperty.call(e1, r)) {
                            if (-1 !== t.indexOf(r)) continue;
                            n[r] = e1[r];
                        }
                        return n;
                    }(e1, t);
                    if (Object.getOwnPropertySymbols) {
                        var i = Object.getOwnPropertySymbols(e1);
                        for(r = 0; r < i.length; r++)n = i[r], -1 === t.indexOf(n) && ({}).propertyIsEnumerable.call(e1, n) && (o[n] = e1[n]);
                    }
                    return o;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            2963: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(1002), o = n(7326);
                function i(e1, t) {
                    if (t && ("object" == (0, r.Z)(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return (0, o.Z)(e1);
                }
            },
            9611: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    return r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, r(e1, t);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            885: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(181);
                function o(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var n = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != n) {
                            var r, o, i, a, u = [], c = !0, s = !1;
                            try {
                                if (i = (n = n.call(e1)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    c = !1;
                                } else for(; !(c = (r = i.call(n)).done) && (u.push(r.value), u.length !== t); c = !0);
                            } catch (e1) {
                                s = !0, o = e1;
                            } finally{
                                try {
                                    if (!c && null != n.return && (a = n.return(), Object(a) !== a)) return;
                                } finally{
                                    if (s) throw o;
                                }
                            }
                            return u;
                        }
                    }(e1, t) || (0, r.Z)(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
            },
            2982: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(907), o = n(181);
                function i(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) return (0, r.Z)(e1);
                    }(e1) || function(e1) {
                        if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                    }(e1) || (0, o.Z)(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
            },
            9142: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(1002);
                function o(e1) {
                    var t = function(e1, t) {
                        if ("object" != (0, r.Z)(e1) || !e1) return e1;
                        var n = e1[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var o = n.call(e1, "string");
                            if ("object" != (0, r.Z)(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == (0, r.Z)(t) ? t : t + "";
                }
            },
            1002: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, r(e1);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            181: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(907);
                function o(e1, t) {
                    if (e1) {
                        if ("string" == typeof e1) return (0, r.Z)(e1, t);
                        var n = ({}).toString.call(e1).slice(8, -1);
                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? (0, r.Z)(e1, t) : void 0;
                    }
                }
            }
        }, t = {};
        function n(r) {
            var o = t[r];
            if (void 0 !== o) return o.exports;
            var i = t[r] = {
                exports: {}
            };
            return e1[r].call(i.exports, i, i.exports, n), i.exports;
        }
        n.n = function(e1) {
            var t = e1 && e1.__esModule ? function() {
                return e1.default;
            } : function() {
                return e1;
            };
            return n.d(t, {
                a: t
            }), t;
        }, n.d = function(e1, t) {
            for(var r in t)n.o(t, r) && !n.o(e1, r) && Object.defineProperty(e1, r, {
                enumerable: !0,
                get: t[r]
            });
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e1) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = function(e1, t) {
            return Object.prototype.hasOwnProperty.call(e1, t);
        }, n.r = function(e1) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e1, "__esModule", {
                value: !0
            });
        };
        var r = {};
        return function() {
            "use strict";
            n.r(r), n.d(r, {
                AuthenticatorKey: function() {
                    return y.pc;
                },
                EmailRole: function() {
                    return g.aw;
                },
                IdxFeature: function() {
                    return y.Fw;
                },
                IdxStatus: function() {
                    return y.Qd;
                },
                OktaAuth: function() {
                    return T;
                },
                PasswordStatus: function() {
                    return g.Fn;
                },
                Status: function() {
                    return g.qb;
                },
                addEmail: function() {
                    return g.no;
                },
                addPhone: function() {
                    return g.Z1;
                },
                authenticate: function() {
                    return y.YR;
                },
                canProceed: function() {
                    return y.Ch;
                },
                cancel: function() {
                    return y.al;
                },
                clearTransactionMeta: function() {
                    return y.Jm;
                },
                createAuthnTransactionAPI: function() {
                    return m.b;
                },
                createIdxAPI: function() {
                    return y.F4;
                },
                createIdxOptionsConstructor: function() {
                    return y.SL;
                },
                createIdxStorageManager: function() {
                    return y.aT;
                },
                createIdxTransactionManager: function() {
                    return y.vK;
                },
                createMinimalOktaAuthIdx: function() {
                    return y.UB;
                },
                createOktaAuthIdx: function() {
                    return y.Yn;
                },
                createOktaAuthMyAccount: function() {
                    return g.Xc;
                },
                createTransactionMeta: function() {
                    return y.Xc;
                },
                deleteEmail: function() {
                    return g.nd;
                },
                deletePassword: function() {
                    return g.QN;
                },
                deletePhone: function() {
                    return g.qj;
                },
                enrollPassword: function() {
                    return g.xg;
                },
                getEmail: function() {
                    return g.OD;
                },
                getEmailChallenge: function() {
                    return g.hG;
                },
                getEmails: function() {
                    return g.G5;
                },
                getPassword: function() {
                    return g.Ij;
                },
                getPhone: function() {
                    return g.u_;
                },
                getPhones: function() {
                    return g.Po;
                },
                getProfile: function() {
                    return g.Ai;
                },
                getProfileSchema: function() {
                    return g.aF;
                },
                getSavedTransactionMeta: function() {
                    return y.uN;
                },
                getTransactionMeta: function() {
                    return y.Co;
                },
                handleEmailVerifyCallback: function() {
                    return y.Jn;
                },
                handleInteractionCodeRedirect: function() {
                    return y.Xx;
                },
                hasSavedInteractionHandle: function() {
                    return y.$0;
                },
                interact: function() {
                    return y.EW;
                },
                introspect: function() {
                    return y.L8;
                },
                isAuthenticator: function() {
                    return y.H;
                },
                isEmailVerifyCallback: function() {
                    return y.GA;
                },
                isEmailVerifyCallbackError: function() {
                    return y.gc;
                },
                isTransactionMetaValid: function() {
                    return y.Wf;
                },
                isTransactionMetaValidForFlow: function() {
                    return y.bl;
                },
                isTransactionMetaValidForOptions: function() {
                    return y.UC;
                },
                mixinAuthn: function() {
                    return m.t;
                },
                mixinIdx: function() {
                    return y.B_;
                },
                mixinMyAccount: function() {
                    return g.HT;
                },
                parseEmailVerifyCallback: function() {
                    return y.mo;
                },
                poll: function() {
                    return y.$l;
                },
                proceed: function() {
                    return y.xc;
                },
                recoverPassword: function() {
                    return y.M4;
                },
                register: function() {
                    return y.z2;
                },
                saveTransactionMeta: function() {
                    return y.r0;
                },
                sendEmailChallenge: function() {
                    return g.ME;
                },
                sendPhoneChallenge: function() {
                    return g.dv;
                },
                startTransaction: function() {
                    return y.Yr;
                },
                unlockAccount: function() {
                    return y.le;
                },
                updatePassword: function() {
                    return g.gQ;
                },
                updateProfile: function() {
                    return g.ck;
                },
                verifyEmailChallenge: function() {
                    return g.T8;
                },
                verifyPhoneChallenge: function() {
                    return g.Lo;
                }
            });
            var e1 = n(3144), t = n(5671), o = n(136), i = n(2963), a = n(1120), u = n(4602), c = n(4143), s = n(3334), f = n(2144), l = n(6794), p = n(3164), d = n(6736), h = {};
            for(var v in d)[
                "default",
                "OktaAuth"
            ].indexOf(v) < 0 && (h[v] = (function(e1) {
                return d[e1];
            }).bind(0, v));
            n.d(r, h);
            var y = n(9999), g = n(1132), m = n(3398);
            var b = (0, u.S)(), k = (0, c.a)(), w = (0, s.v)(), O = (0, f.Y)(k, b, w), Z = (0, l.H)(O), T = function(n) {
                (0, o.Z)(s, n);
                var r, u, c = (r = s, u = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e1) {
                        return !1;
                    }
                }(), function() {
                    var e1, t = (0, a.Z)(r);
                    if (u) {
                        var n = (0, a.Z)(this).constructor;
                        e1 = Reflect.construct(t, arguments, n);
                    } else e1 = t.apply(this, arguments);
                    return (0, i.Z)(this, e1);
                });
                function s(e1) {
                    return (0, t.Z)(this, s), c.call(this, e1);
                }
                return (0, e1.Z)(s);
            }((0, p.t)(Z));
            r.default = T;
        }(), r;
    }();
});


function $36c46bc4813033e5$export$2e2bcd8739ae039(v1, v2) {
    // validate input and split into segments
    const n1 = $36c46bc4813033e5$var$validateAndParse(v1);
    const n2 = $36c46bc4813033e5$var$validateAndParse(v2);
    // pop off the patch
    const p1 = n1.pop();
    const p2 = n2.pop();
    // validate numbers
    const r = $36c46bc4813033e5$var$compareSegments(n1, n2);
    if (r !== 0) return r;
    // validate pre-release
    if (p1 && p2) return $36c46bc4813033e5$var$compareSegments(p1.split('.'), p2.split('.'));
    else if (p1 || p2) return p1 ? -1 : 1;
    return 0;
}
const $36c46bc4813033e5$export$a22775fa5e2eebd9 = (v)=>typeof v === 'string' && /^[v\d]/.test(v) && $36c46bc4813033e5$var$semver.test(v);
const $36c46bc4813033e5$export$398604a469f7de9a = (v1, v2, operator)=>{
    // validate input operator
    $36c46bc4813033e5$var$assertValidOperator(operator);
    // since result of compareVersions can only be -1 or 0 or 1
    // a simple map can be used to replace switch
    const res = $36c46bc4813033e5$export$2e2bcd8739ae039(v1, v2);
    return $36c46bc4813033e5$var$operatorResMap[operator].includes(res);
};
const $36c46bc4813033e5$export$b8fab89fe6d5d7da = (v, r)=>{
    // if no range operator then "="
    const m = r.match(/^([<>=~^]+)/);
    const op = m ? m[1] : '=';
    // if gt/lt/eq then operator compare
    if (op !== '^' && op !== '~') return $36c46bc4813033e5$export$398604a469f7de9a(v, r, op);
    // else range of either "~" or "^" is assumed
    const [v1, v2, v3] = $36c46bc4813033e5$var$validateAndParse(v);
    const [r1, r2, r3] = $36c46bc4813033e5$var$validateAndParse(r);
    if ($36c46bc4813033e5$var$compareStrings(v1, r1) !== 0) return false;
    if (op === '^') return $36c46bc4813033e5$var$compareSegments([
        v2,
        v3
    ], [
        r2,
        r3
    ]) >= 0;
    if ($36c46bc4813033e5$var$compareStrings(v2, r2) !== 0) return false;
    return $36c46bc4813033e5$var$compareStrings(v3, r3) >= 0;
};
// export CJS style for parity
$36c46bc4813033e5$export$2e2bcd8739ae039.validate = $36c46bc4813033e5$export$a22775fa5e2eebd9;
$36c46bc4813033e5$export$2e2bcd8739ae039.compare = $36c46bc4813033e5$export$398604a469f7de9a;
$36c46bc4813033e5$export$2e2bcd8739ae039.satisfies = $36c46bc4813033e5$export$b8fab89fe6d5d7da;
const $36c46bc4813033e5$var$semver = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;
const $36c46bc4813033e5$var$validateAndParse = (v)=>{
    if (typeof v !== 'string') throw new TypeError('Invalid argument expected string');
    const match = v.match($36c46bc4813033e5$var$semver);
    if (!match) throw new Error(`Invalid argument not valid semver ('${v}' received)`);
    match.shift();
    return match;
};
const $36c46bc4813033e5$var$isWildcard = (s)=>s === '*' || s === 'x' || s === 'X';
const $36c46bc4813033e5$var$tryParse = (v)=>{
    const n = parseInt(v, 10);
    return isNaN(n) ? v : n;
};
const $36c46bc4813033e5$var$forceType = (a, b)=>typeof a !== typeof b ? [
        String(a),
        String(b)
    ] : [
        a,
        b
    ];
const $36c46bc4813033e5$var$compareStrings = (a, b)=>{
    if ($36c46bc4813033e5$var$isWildcard(a) || $36c46bc4813033e5$var$isWildcard(b)) return 0;
    const [ap, bp] = $36c46bc4813033e5$var$forceType($36c46bc4813033e5$var$tryParse(a), $36c46bc4813033e5$var$tryParse(b));
    if (ap > bp) return 1;
    if (ap < bp) return -1;
    return 0;
};
const $36c46bc4813033e5$var$compareSegments = (a, b)=>{
    for(let i = 0; i < Math.max(a.length, b.length); i++){
        const r = $36c46bc4813033e5$var$compareStrings(a[i] || 0, b[i] || 0);
        if (r !== 0) return r;
    }
    return 0;
};
const $36c46bc4813033e5$var$operatorResMap = {
    '>': [
        1
    ],
    '>=': [
        0,
        1
    ],
    '=': [
        0
    ],
    '<=': [
        -1,
        0
    ],
    '<': [
        -1
    ]
};
const $36c46bc4813033e5$var$allowedOperators = Object.keys($36c46bc4813033e5$var$operatorResMap);
const $36c46bc4813033e5$var$assertValidOperator = (op)=>{
    if (typeof op !== 'string') throw new TypeError(`Invalid operator type, expected string but got ${typeof op}`);
    if ($36c46bc4813033e5$var$allowedOperators.indexOf(op) === -1) throw new Error(`Invalid operator, expected one of ${$36c46bc4813033e5$var$allowedOperators.join('|')}`);
};


var $68b2af567466e5f1$exports = {};
var $7c7210d14f5768af$exports = {};

var $8zDbG = parcelRequire("8zDbG");
var $7c7210d14f5768af$var$_typeof = $8zDbG.default;
var $7380b025e7664bc2$exports = {};

var $8zDbG = parcelRequire("8zDbG");
var $7380b025e7664bc2$var$_typeof = $8zDbG.default;
function $7380b025e7664bc2$var$toPrimitive(t, r) {
    if ("object" != $7380b025e7664bc2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7380b025e7664bc2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$7380b025e7664bc2$exports = $7380b025e7664bc2$var$toPrimitive, $7380b025e7664bc2$exports.__esModule = true, $7380b025e7664bc2$exports["default"] = $7380b025e7664bc2$exports;


function $7c7210d14f5768af$var$toPropertyKey(t) {
    var i = $7380b025e7664bc2$exports(t, "string");
    return "symbol" == $7c7210d14f5768af$var$_typeof(i) ? i : i + "";
}
$7c7210d14f5768af$exports = $7c7210d14f5768af$var$toPropertyKey, $7c7210d14f5768af$exports.__esModule = true, $7c7210d14f5768af$exports["default"] = $7c7210d14f5768af$exports;


function $68b2af567466e5f1$var$_defineProperty(e, r, t) {
    return (r = $7c7210d14f5768af$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$68b2af567466e5f1$exports = $68b2af567466e5f1$var$_defineProperty, $68b2af567466e5f1$exports.__esModule = true, $68b2af567466e5f1$exports["default"] = $68b2af567466e5f1$exports;


var $1d0a4d1f203265da$exports = {};
var $66afabd262fa652d$exports = {};
function $66afabd262fa652d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$66afabd262fa652d$exports = $66afabd262fa652d$var$_objectWithoutPropertiesLoose, $66afabd262fa652d$exports.__esModule = true, $66afabd262fa652d$exports["default"] = $66afabd262fa652d$exports;


function $1d0a4d1f203265da$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $66afabd262fa652d$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$1d0a4d1f203265da$exports = $1d0a4d1f203265da$var$_objectWithoutProperties, $1d0a4d1f203265da$exports.__esModule = true, $1d0a4d1f203265da$exports["default"] = $1d0a4d1f203265da$exports;


var $c3aca08c2a74646e$exports = {};

$parcel$export($c3aca08c2a74646e$exports, "createSearchParams", function () { return $c3aca08c2a74646e$export$a2e4e2dcc7b1f22f; });
$parcel$export($c3aca08c2a74646e$exports, "createBrowserRouter", function () { return $c3aca08c2a74646e$export$1f3f55432a00e06d; });
$parcel$export($c3aca08c2a74646e$exports, "createHashRouter", function () { return $c3aca08c2a74646e$export$1ba7ed8a3a7b3765; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_ViewTransitionContext", function () { return $c3aca08c2a74646e$export$7ad602f0e94e62d1; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_FetchersContext", function () { return $c3aca08c2a74646e$export$148fd98d095596d4; });
$parcel$export($c3aca08c2a74646e$exports, "RouterProvider", function () { return $c3aca08c2a74646e$export$323e4fc2fa4753fb; });
$parcel$export($c3aca08c2a74646e$exports, "BrowserRouter", function () { return $c3aca08c2a74646e$export$9ba4e89fdfa1fc54; });
$parcel$export($c3aca08c2a74646e$exports, "HashRouter", function () { return $c3aca08c2a74646e$export$7221d69dcfc8e36b; });
$parcel$export($c3aca08c2a74646e$exports, "unstable_HistoryRouter", function () { return $c3aca08c2a74646e$export$eefb0c834599897e; });
$parcel$export($c3aca08c2a74646e$exports, "Link", function () { return $c3aca08c2a74646e$export$a6c7ac8248d6e38a; });
$parcel$export($c3aca08c2a74646e$exports, "useLinkClickHandler", function () { return $c3aca08c2a74646e$export$67621102c14d847; });
$parcel$export($c3aca08c2a74646e$exports, "NavLink", function () { return $c3aca08c2a74646e$export$b0d92dbee9b5b60d; });
$parcel$export($c3aca08c2a74646e$exports, "useViewTransitionState", function () { return $c3aca08c2a74646e$export$e262bd1977bea848; });
$parcel$export($c3aca08c2a74646e$exports, "Form", function () { return $c3aca08c2a74646e$export$a7fed597f4b8afd8; });
$parcel$export($c3aca08c2a74646e$exports, "useSubmit", function () { return $c3aca08c2a74646e$export$47c85c6e3a081d3; });
$parcel$export($c3aca08c2a74646e$exports, "useFormAction", function () { return $c3aca08c2a74646e$export$89a6bd6db0d97c56; });
$parcel$export($c3aca08c2a74646e$exports, "ScrollRestoration", function () { return $c3aca08c2a74646e$export$11aac1aab828f1fa; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_useScrollRestoration", function () { return $c3aca08c2a74646e$export$25057cfe5591e3e9; });
$parcel$export($c3aca08c2a74646e$exports, "useSearchParams", function () { return $c3aca08c2a74646e$export$f1a78c17382fe22a; });
$parcel$export($c3aca08c2a74646e$exports, "useFetcher", function () { return $c3aca08c2a74646e$export$5b0d2d9a9921565a; });
$parcel$export($c3aca08c2a74646e$exports, "useFetchers", function () { return $c3aca08c2a74646e$export$fa996778a3a31087; });
$parcel$export($c3aca08c2a74646e$exports, "useBeforeUnload", function () { return $c3aca08c2a74646e$export$c0a586b329cae57d; });
$parcel$export($c3aca08c2a74646e$exports, "unstable_usePrompt", function () { return $c3aca08c2a74646e$export$39f4eb3dbd812741; });
$parcel$export($c3aca08c2a74646e$exports, "AbortedDeferredError", function () { return $a0511682ed8967d7$export$42a99a7a4bc0e76a; });
$parcel$export($c3aca08c2a74646e$exports, "Await", function () { return $ebc812b73151cba1$export$6ddabde395c8c576; });
$parcel$export($c3aca08c2a74646e$exports, "MemoryRouter", function () { return $ebc812b73151cba1$export$ae46f04cfaffe093; });
$parcel$export($c3aca08c2a74646e$exports, "Navigate", function () { return $ebc812b73151cba1$export$444b3ab0cb9aec40; });
$parcel$export($c3aca08c2a74646e$exports, "NavigationType", function () { return $a0511682ed8967d7$export$e19cd5f9376f8cee; });
$parcel$export($c3aca08c2a74646e$exports, "Outlet", function () { return $ebc812b73151cba1$export$910ae8079b2c2852; });
$parcel$export($c3aca08c2a74646e$exports, "Route", function () { return $ebc812b73151cba1$export$e7b0ac011bb776c6; });
$parcel$export($c3aca08c2a74646e$exports, "Router", function () { return $ebc812b73151cba1$export$55185c17a0fcbe46; });
$parcel$export($c3aca08c2a74646e$exports, "Routes", function () { return $ebc812b73151cba1$export$3565eb3d00ca5a74; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_DataRouterContext", function () { return $ebc812b73151cba1$export$3add0d5dce533e2e; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_DataRouterStateContext", function () { return $ebc812b73151cba1$export$145dfa71566a64dc; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_LocationContext", function () { return $ebc812b73151cba1$export$c7914228fb69b0f5; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_NavigationContext", function () { return $ebc812b73151cba1$export$26749e8557646306; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_RouteContext", function () { return $ebc812b73151cba1$export$9072aa6dd1f93057; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_useRouteId", function () { return $ebc812b73151cba1$export$5fc8298006ad9e58; });
$parcel$export($c3aca08c2a74646e$exports, "createMemoryRouter", function () { return $ebc812b73151cba1$export$f30f7e456d254e83; });
$parcel$export($c3aca08c2a74646e$exports, "createPath", function () { return $a0511682ed8967d7$export$fe53371bee54353d; });
$parcel$export($c3aca08c2a74646e$exports, "createRoutesFromChildren", function () { return $ebc812b73151cba1$export$16da398f5434bdec; });
$parcel$export($c3aca08c2a74646e$exports, "createRoutesFromElements", function () { return $ebc812b73151cba1$export$16da398f5434bdec; });
$parcel$export($c3aca08c2a74646e$exports, "defer", function () { return $a0511682ed8967d7$export$260e5c0943f31606; });
$parcel$export($c3aca08c2a74646e$exports, "generatePath", function () { return $a0511682ed8967d7$export$82476f982757e71e; });
$parcel$export($c3aca08c2a74646e$exports, "isRouteErrorResponse", function () { return $a0511682ed8967d7$export$972111febbeef05b; });
$parcel$export($c3aca08c2a74646e$exports, "json", function () { return $a0511682ed8967d7$export$7b419323e6ed4f31; });
$parcel$export($c3aca08c2a74646e$exports, "matchPath", function () { return $a0511682ed8967d7$export$81336c211d5ff295; });
$parcel$export($c3aca08c2a74646e$exports, "matchRoutes", function () { return $a0511682ed8967d7$export$2708184779ceb39d; });
$parcel$export($c3aca08c2a74646e$exports, "parsePath", function () { return $a0511682ed8967d7$export$8ccf933b0513f8d0; });
$parcel$export($c3aca08c2a74646e$exports, "redirect", function () { return $a0511682ed8967d7$export$89e12c5b50f7529d; });
$parcel$export($c3aca08c2a74646e$exports, "redirectDocument", function () { return $a0511682ed8967d7$export$a6cd19cd1951a23c; });
$parcel$export($c3aca08c2a74646e$exports, "renderMatches", function () { return $ebc812b73151cba1$export$daf73786167a7f72; });
$parcel$export($c3aca08c2a74646e$exports, "replace", function () { return $a0511682ed8967d7$export$77ad94ebf1c2b9ed; });
$parcel$export($c3aca08c2a74646e$exports, "resolvePath", function () { return $a0511682ed8967d7$export$b09f2ff0bbcb43c7; });
$parcel$export($c3aca08c2a74646e$exports, "useActionData", function () { return $ebc812b73151cba1$export$fdc00f3f26066d5e; });
$parcel$export($c3aca08c2a74646e$exports, "useAsyncError", function () { return $ebc812b73151cba1$export$17f53340677d5831; });
$parcel$export($c3aca08c2a74646e$exports, "useAsyncValue", function () { return $ebc812b73151cba1$export$78a72ddb39bdd145; });
$parcel$export($c3aca08c2a74646e$exports, "useBlocker", function () { return $ebc812b73151cba1$export$b273b3273281a049; });
$parcel$export($c3aca08c2a74646e$exports, "useHref", function () { return $ebc812b73151cba1$export$b66bb29c5006f12f; });
$parcel$export($c3aca08c2a74646e$exports, "useInRouterContext", function () { return $ebc812b73151cba1$export$9c954a9d03d32f4a; });
$parcel$export($c3aca08c2a74646e$exports, "useLoaderData", function () { return $ebc812b73151cba1$export$1448a5050d252c4d; });
$parcel$export($c3aca08c2a74646e$exports, "useLocation", function () { return $ebc812b73151cba1$export$45d76561a5302f2b; });
$parcel$export($c3aca08c2a74646e$exports, "useMatch", function () { return $ebc812b73151cba1$export$6c330e8992e8a295; });
$parcel$export($c3aca08c2a74646e$exports, "useMatches", function () { return $ebc812b73151cba1$export$2378eb7f5ff86053; });
$parcel$export($c3aca08c2a74646e$exports, "useNavigate", function () { return $ebc812b73151cba1$export$9770f232ac06a008; });
$parcel$export($c3aca08c2a74646e$exports, "useNavigation", function () { return $ebc812b73151cba1$export$d0fd4b7106de2769; });
$parcel$export($c3aca08c2a74646e$exports, "useNavigationType", function () { return $ebc812b73151cba1$export$1b3f31771c5d07c; });
$parcel$export($c3aca08c2a74646e$exports, "useOutlet", function () { return $ebc812b73151cba1$export$a3be3530d8e40d0b; });
$parcel$export($c3aca08c2a74646e$exports, "useOutletContext", function () { return $ebc812b73151cba1$export$4138103a3ae699cc; });
$parcel$export($c3aca08c2a74646e$exports, "useParams", function () { return $ebc812b73151cba1$export$99eaa27ddbbb95ef; });
$parcel$export($c3aca08c2a74646e$exports, "useResolvedPath", function () { return $ebc812b73151cba1$export$e75d2a2d1b3c245b; });
$parcel$export($c3aca08c2a74646e$exports, "useRevalidator", function () { return $ebc812b73151cba1$export$600dc272ed516c15; });
$parcel$export($c3aca08c2a74646e$exports, "useRouteError", function () { return $ebc812b73151cba1$export$ed527bf60f6e05f2; });
$parcel$export($c3aca08c2a74646e$exports, "useRouteLoaderData", function () { return $ebc812b73151cba1$export$fd5d37484eab868d; });
$parcel$export($c3aca08c2a74646e$exports, "useRoutes", function () { return $ebc812b73151cba1$export$5d3fca4a98652595; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_ErrorResponseImpl", function () { return $a0511682ed8967d7$export$6c6580e81da25755; });
/**
 * React Router DOM v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lCzvA = parcelRequire("lCzvA");

var $dAQd3 = parcelRequire("dAQd3");
/**
 * React Router v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lCzvA = parcelRequire("lCzvA");
/**
 * @remix-run/router v1.23.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $a0511682ed8967d7$var$_extends() {
    return $a0511682ed8967d7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a0511682ed8967d7$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $a0511682ed8967d7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($a0511682ed8967d7$export$e19cd5f9376f8cee || ($a0511682ed8967d7$export$e19cd5f9376f8cee = {}));
const $a0511682ed8967d7$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $a0511682ed8967d7$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $a0511682ed8967d7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $a0511682ed8967d7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $a0511682ed8967d7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $a0511682ed8967d7$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $a0511682ed8967d7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $a0511682ed8967d7$export$fe53371bee54353d(to);
    }
    return $a0511682ed8967d7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $a0511682ed8967d7$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $a0511682ed8967d7$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $a0511682ed8967d7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $a0511682ed8967d7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $a0511682ed8967d7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $a0511682ed8967d7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $a0511682ed8967d7$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $a0511682ed8967d7$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $a0511682ed8967d7$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $a0511682ed8967d7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $a0511682ed8967d7$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $a0511682ed8967d7$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $a0511682ed8967d7$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $a0511682ed8967d7$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $a0511682ed8967d7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $a0511682ed8967d7$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($a0511682ed8967d7$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Push;
        let location = $a0511682ed8967d7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $a0511682ed8967d7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace;
        let location = $a0511682ed8967d7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $a0511682ed8967d7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $a0511682ed8967d7$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $a0511682ed8967d7$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($a0511682ed8967d7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($a0511682ed8967d7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $a0511682ed8967d7$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($a0511682ed8967d7$var$ResultType || ($a0511682ed8967d7$var$ResultType = {}));
const $a0511682ed8967d7$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $a0511682ed8967d7$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $a0511682ed8967d7$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $a0511682ed8967d7$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $a0511682ed8967d7$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($a0511682ed8967d7$var$isIndexRoute(route)) {
            let indexRoute = $a0511682ed8967d7$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $a0511682ed8967d7$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $a0511682ed8967d7$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $a0511682ed8967d7$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $a0511682ed8967d7$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $a0511682ed8967d7$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $a0511682ed8967d7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $a0511682ed8967d7$var$flattenRoutes(routes);
    $a0511682ed8967d7$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $a0511682ed8967d7$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $a0511682ed8967d7$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $a0511682ed8967d7$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $a0511682ed8967d7$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $a0511682ed8967d7$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $a0511682ed8967d7$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $a0511682ed8967d7$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $a0511682ed8967d7$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $a0511682ed8967d7$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $a0511682ed8967d7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $a0511682ed8967d7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $a0511682ed8967d7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $a0511682ed8967d7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $a0511682ed8967d7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $a0511682ed8967d7$var$paramRe = /^:[\w-]+$/;
const $a0511682ed8967d7$var$dynamicSegmentValue = 3;
const $a0511682ed8967d7$var$indexRouteValue = 2;
const $a0511682ed8967d7$var$emptySegmentValue = 1;
const $a0511682ed8967d7$var$staticSegmentValue = 10;
const $a0511682ed8967d7$var$splatPenalty = -2;
const $a0511682ed8967d7$var$isSplat = (s)=>s === "*";
function $a0511682ed8967d7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($a0511682ed8967d7$var$isSplat)) initialScore += $a0511682ed8967d7$var$splatPenalty;
    if (index) initialScore += $a0511682ed8967d7$var$indexRouteValue;
    return segments.filter((s)=>!$a0511682ed8967d7$var$isSplat(s)).reduce((score, segment)=>score + ($a0511682ed8967d7$var$paramRe.test(segment) ? $a0511682ed8967d7$var$dynamicSegmentValue : segment === "" ? $a0511682ed8967d7$var$emptySegmentValue : $a0511682ed8967d7$var$staticSegmentValue), initialScore);
}
function $a0511682ed8967d7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $a0511682ed8967d7$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $a0511682ed8967d7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $a0511682ed8967d7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $a0511682ed8967d7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $a0511682ed8967d7$export$a5c6d149b50c1d86($a0511682ed8967d7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $a0511682ed8967d7$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $a0511682ed8967d7$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $a0511682ed8967d7$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $a0511682ed8967d7$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $a0511682ed8967d7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $a0511682ed8967d7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $a0511682ed8967d7$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $a0511682ed8967d7$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $a0511682ed8967d7$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $a0511682ed8967d7$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $a0511682ed8967d7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $a0511682ed8967d7$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $a0511682ed8967d7$var$isAbsoluteUrl = (url)=>$a0511682ed8967d7$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $a0511682ed8967d7$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($a0511682ed8967d7$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = $a0511682ed8967d7$var$removeDoubleSlashes(toPathname);
                $a0511682ed8967d7$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $a0511682ed8967d7$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $a0511682ed8967d7$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $a0511682ed8967d7$var$normalizeSearch(search),
        hash: $a0511682ed8967d7$var$normalizeHash(hash)
    };
}
function $a0511682ed8967d7$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $a0511682ed8967d7$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $a0511682ed8967d7$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $a0511682ed8967d7$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $a0511682ed8967d7$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $a0511682ed8967d7$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $a0511682ed8967d7$export$8ccf933b0513f8d0(toArg);
    else {
        to = $a0511682ed8967d7$var$_extends({}, toArg);
        $a0511682ed8967d7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $a0511682ed8967d7$var$getInvalidPathError("?", "pathname", "search", to));
        $a0511682ed8967d7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $a0511682ed8967d7$var$getInvalidPathError("#", "pathname", "hash", to));
        $a0511682ed8967d7$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $a0511682ed8967d7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $a0511682ed8967d7$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $a0511682ed8967d7$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $a0511682ed8967d7$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $a0511682ed8967d7$export$86d9a7913e44197e = (paths)=>$a0511682ed8967d7$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $a0511682ed8967d7$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $a0511682ed8967d7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $a0511682ed8967d7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $a0511682ed8967d7$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $a0511682ed8967d7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $a0511682ed8967d7$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $a0511682ed8967d7$export$4051a07651545597(data, init) {
    return new $a0511682ed8967d7$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $a0511682ed8967d7$export$42a99a7a4bc0e76a extends Error {
}
class $a0511682ed8967d7$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $a0511682ed8967d7$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $a0511682ed8967d7$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $a0511682ed8967d7$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $a0511682ed8967d7$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $a0511682ed8967d7$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $a0511682ed8967d7$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $a0511682ed8967d7$var$unwrapTrackedPromise(value) {
    if (!$a0511682ed8967d7$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $a0511682ed8967d7$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $a0511682ed8967d7$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a0511682ed8967d7$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $a0511682ed8967d7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a0511682ed8967d7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $a0511682ed8967d7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a0511682ed8967d7$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $a0511682ed8967d7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $a0511682ed8967d7$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $a0511682ed8967d7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $a0511682ed8967d7$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $a0511682ed8967d7$var$validMutationMethods = new Set($a0511682ed8967d7$var$validMutationMethodsArr);
const $a0511682ed8967d7$var$validRequestMethodsArr = [
    "get",
    ...$a0511682ed8967d7$var$validMutationMethodsArr
];
const $a0511682ed8967d7$var$validRequestMethods = new Set($a0511682ed8967d7$var$validRequestMethodsArr);
const $a0511682ed8967d7$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $a0511682ed8967d7$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $a0511682ed8967d7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a0511682ed8967d7$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a0511682ed8967d7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $a0511682ed8967d7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $a0511682ed8967d7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $a0511682ed8967d7$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $a0511682ed8967d7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $a0511682ed8967d7$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a0511682ed8967d7$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $a0511682ed8967d7$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $a0511682ed8967d7$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $a0511682ed8967d7$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $a0511682ed8967d7$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $a0511682ed8967d7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $a0511682ed8967d7$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$a0511682ed8967d7$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$a0511682ed8967d7$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $a0511682ed8967d7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $a0511682ed8967d7$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $a0511682ed8967d7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $a0511682ed8967d7$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$a0511682ed8967d7$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($a0511682ed8967d7$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $a0511682ed8967d7$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $a0511682ed8967d7$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $a0511682ed8967d7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $a0511682ed8967d7$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $a0511682ed8967d7$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $a0511682ed8967d7$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($a0511682ed8967d7$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $a0511682ed8967d7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $a0511682ed8967d7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $a0511682ed8967d7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $a0511682ed8967d7$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $a0511682ed8967d7$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $a0511682ed8967d7$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $a0511682ed8967d7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $a0511682ed8967d7$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $a0511682ed8967d7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $a0511682ed8967d7$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $a0511682ed8967d7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $a0511682ed8967d7$var$findNearestBoundary(matches).route.id,
            {
                type: $a0511682ed8967d7$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $a0511682ed8967d7$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($a0511682ed8967d7$var$isErrorResult(result) && $a0511682ed8967d7$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $a0511682ed8967d7$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $a0511682ed8967d7$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $a0511682ed8967d7$var$_extends({
            matches: updatedMatches || matches
        }, $a0511682ed8967d7$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $a0511682ed8967d7$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a0511682ed8967d7$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $a0511682ed8967d7$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $a0511682ed8967d7$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $a0511682ed8967d7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $a0511682ed8967d7$var$ResultType.error,
            error: $a0511682ed8967d7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($a0511682ed8967d7$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $a0511682ed8967d7$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($a0511682ed8967d7$var$isDeferredResult(result)) throw $a0511682ed8967d7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($a0511682ed8967d7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a0511682ed8967d7$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $a0511682ed8967d7$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $a0511682ed8967d7$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($a0511682ed8967d7$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a0511682ed8967d7$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $a0511682ed8967d7$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $a0511682ed8967d7$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $a0511682ed8967d7$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $a0511682ed8967d7$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $a0511682ed8967d7$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a0511682ed8967d7$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $a0511682ed8967d7$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $a0511682ed8967d7$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$a0511682ed8967d7$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $a0511682ed8967d7$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $a0511682ed8967d7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $a0511682ed8967d7$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $a0511682ed8967d7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $a0511682ed8967d7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $a0511682ed8967d7$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $a0511682ed8967d7$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $a0511682ed8967d7$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a0511682ed8967d7$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a0511682ed8967d7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a0511682ed8967d7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $a0511682ed8967d7$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($a0511682ed8967d7$var$isRedirectResult(actionResult) || $a0511682ed8967d7$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $a0511682ed8967d7$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($a0511682ed8967d7$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $a0511682ed8967d7$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $a0511682ed8967d7$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($a0511682ed8967d7$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($a0511682ed8967d7$var$isDeferredResult(actionResult)) throw $a0511682ed8967d7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $a0511682ed8967d7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $a0511682ed8967d7$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $a0511682ed8967d7$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $a0511682ed8967d7$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $a0511682ed8967d7$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $a0511682ed8967d7$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $a0511682ed8967d7$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $a0511682ed8967d7$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a0511682ed8967d7$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $a0511682ed8967d7$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $a0511682ed8967d7$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $a0511682ed8967d7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a0511682ed8967d7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a0511682ed8967d7$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a0511682ed8967d7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $a0511682ed8967d7$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($a0511682ed8967d7$var$isDeferredResult(result)) result = await $a0511682ed8967d7$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $a0511682ed8967d7$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($a0511682ed8967d7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $a0511682ed8967d7$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($a0511682ed8967d7$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $a0511682ed8967d7$export$3e9cee6b33872309(!$a0511682ed8967d7$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $a0511682ed8967d7$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $a0511682ed8967d7$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $a0511682ed8967d7$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $a0511682ed8967d7$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($a0511682ed8967d7$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $a0511682ed8967d7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace : $a0511682ed8967d7$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $a0511682ed8967d7$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($a0511682ed8967d7$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $a0511682ed8967d7$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $a0511682ed8967d7$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $a0511682ed8967d7$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $a0511682ed8967d7$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $a0511682ed8967d7$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($a0511682ed8967d7$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $a0511682ed8967d7$var$ResultType.redirect,
                response: $a0511682ed8967d7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $a0511682ed8967d7$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $a0511682ed8967d7$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $a0511682ed8967d7$var$ResultType.error,
                    error: $a0511682ed8967d7$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $a0511682ed8967d7$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $a0511682ed8967d7$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $a0511682ed8967d7$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $a0511682ed8967d7$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $a0511682ed8967d7$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $a0511682ed8967d7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $a0511682ed8967d7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $a0511682ed8967d7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $a0511682ed8967d7$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $a0511682ed8967d7$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $a0511682ed8967d7$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $a0511682ed8967d7$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $a0511682ed8967d7$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $a0511682ed8967d7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$a0511682ed8967d7$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $a0511682ed8967d7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $a0511682ed8967d7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $a0511682ed8967d7$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $a0511682ed8967d7$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $a0511682ed8967d7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $a0511682ed8967d7$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $a0511682ed8967d7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $a0511682ed8967d7$export$4d0306f8f6a4585b = Symbol("deferred");
function $a0511682ed8967d7$export$3336b097a6fbc59a(routes, opts) {
    $a0511682ed8967d7$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a0511682ed8967d7$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $a0511682ed8967d7$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $a0511682ed8967d7$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a0511682ed8967d7$var$createLocation("", $a0511682ed8967d7$export$fe53371bee54353d(url), null, "default");
        let matches = $a0511682ed8967d7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a0511682ed8967d7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $a0511682ed8967d7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $a0511682ed8967d7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $a0511682ed8967d7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a0511682ed8967d7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($a0511682ed8967d7$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $a0511682ed8967d7$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a0511682ed8967d7$var$createLocation("", $a0511682ed8967d7$export$fe53371bee54353d(url), null, "default");
        let matches = $a0511682ed8967d7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a0511682ed8967d7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $a0511682ed8967d7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $a0511682ed8967d7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $a0511682ed8967d7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $a0511682ed8967d7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $a0511682ed8967d7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($a0511682ed8967d7$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$a0511682ed8967d7$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $a0511682ed8967d7$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($a0511682ed8967d7$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $a0511682ed8967d7$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $a0511682ed8967d7$var$isResponse(result) ? result : $a0511682ed8967d7$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($a0511682ed8967d7$var$isDataStrategyResult(e) && $a0511682ed8967d7$var$isResponse(e.result)) {
                if (e.type === $a0511682ed8967d7$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($a0511682ed8967d7$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $a0511682ed8967d7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a0511682ed8967d7$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $a0511682ed8967d7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($a0511682ed8967d7$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($a0511682ed8967d7$var$isDeferredResult(result)) {
            let error = $a0511682ed8967d7$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a0511682ed8967d7$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($a0511682ed8967d7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($a0511682ed8967d7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $a0511682ed8967d7$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $a0511682ed8967d7$var$_extends({}, context, {
                statusCode: $a0511682ed8967d7$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $a0511682ed8967d7$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $a0511682ed8967d7$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $a0511682ed8967d7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? $a0511682ed8967d7$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $a0511682ed8967d7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $a0511682ed8967d7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $a0511682ed8967d7$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $a0511682ed8967d7$var$callDataStrategyImpl(dataStrategy || $a0511682ed8967d7$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($a0511682ed8967d7$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $a0511682ed8967d7$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($a0511682ed8967d7$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $a0511682ed8967d7$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $a0511682ed8967d7$export$fec11da027c70692(routes, context, error) {
    let newContext = $a0511682ed8967d7$var$_extends({}, context, {
        statusCode: $a0511682ed8967d7$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $a0511682ed8967d7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $a0511682ed8967d7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $a0511682ed8967d7$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $a0511682ed8967d7$export$cae722b0cc860f13(to ? to : ".", $a0511682ed8967d7$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $a0511682ed8967d7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $a0511682ed8967d7$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $a0511682ed8967d7$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $a0511682ed8967d7$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $a0511682ed8967d7$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$a0511682ed8967d7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$a0511682ed8967d7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $a0511682ed8967d7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $a0511682ed8967d7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $a0511682ed8967d7$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$a0511682ed8967d7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$a0511682ed8967d7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $a0511682ed8967d7$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $a0511682ed8967d7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $a0511682ed8967d7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $a0511682ed8967d7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $a0511682ed8967d7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($a0511682ed8967d7$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $a0511682ed8967d7$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $a0511682ed8967d7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $a0511682ed8967d7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $a0511682ed8967d7$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $a0511682ed8967d7$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $a0511682ed8967d7$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $a0511682ed8967d7$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $a0511682ed8967d7$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($a0511682ed8967d7$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $a0511682ed8967d7$var$shouldRevalidateLoader(match, $a0511682ed8967d7$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $a0511682ed8967d7$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $a0511682ed8967d7$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $a0511682ed8967d7$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $a0511682ed8967d7$var$shouldRevalidateLoader(fetcherMatch, $a0511682ed8967d7$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $a0511682ed8967d7$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $a0511682ed8967d7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $a0511682ed8967d7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $a0511682ed8967d7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $a0511682ed8967d7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $a0511682ed8967d7$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$a0511682ed8967d7$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $a0511682ed8967d7$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $a0511682ed8967d7$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$a0511682ed8967d7$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $a0511682ed8967d7$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $a0511682ed8967d7$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $a0511682ed8967d7$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$a0511682ed8967d7$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $a0511682ed8967d7$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $a0511682ed8967d7$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $a0511682ed8967d7$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $a0511682ed8967d7$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $a0511682ed8967d7$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $a0511682ed8967d7$var$ResultType.data,
                result: undefined
            });
        };
        return $a0511682ed8967d7$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $a0511682ed8967d7$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $a0511682ed8967d7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $a0511682ed8967d7$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $a0511682ed8967d7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $a0511682ed8967d7$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $a0511682ed8967d7$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $a0511682ed8967d7$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($a0511682ed8967d7$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $a0511682ed8967d7$var$ResultType.error,
                error: e
            };
        }
        if (type === $a0511682ed8967d7$var$ResultType.error) return {
            type: $a0511682ed8967d7$var$ResultType.error,
            error: new $a0511682ed8967d7$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $a0511682ed8967d7$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $a0511682ed8967d7$var$ResultType.error) {
        if ($a0511682ed8967d7$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $a0511682ed8967d7$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $a0511682ed8967d7$var$ResultType.error,
                error: new $a0511682ed8967d7$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $a0511682ed8967d7$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $a0511682ed8967d7$var$ResultType.error,
            error: result,
            statusCode: $a0511682ed8967d7$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($a0511682ed8967d7$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $a0511682ed8967d7$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($a0511682ed8967d7$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $a0511682ed8967d7$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $a0511682ed8967d7$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $a0511682ed8967d7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $a0511682ed8967d7$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$a0511682ed8967d7$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $a0511682ed8967d7$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $a0511682ed8967d7$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($a0511682ed8967d7$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $a0511682ed8967d7$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $a0511682ed8967d7$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $a0511682ed8967d7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($a0511682ed8967d7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $a0511682ed8967d7$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $a0511682ed8967d7$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $a0511682ed8967d7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $a0511682ed8967d7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $a0511682ed8967d7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $a0511682ed8967d7$export$3e9cee6b33872309(!$a0511682ed8967d7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($a0511682ed8967d7$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $a0511682ed8967d7$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $a0511682ed8967d7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($a0511682ed8967d7$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $a0511682ed8967d7$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $a0511682ed8967d7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $a0511682ed8967d7$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($a0511682ed8967d7$var$isErrorResult(result)) {
            let boundaryMatch = $a0511682ed8967d7$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $a0511682ed8967d7$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($a0511682ed8967d7$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $a0511682ed8967d7$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($a0511682ed8967d7$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $a0511682ed8967d7$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $a0511682ed8967d7$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $a0511682ed8967d7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $a0511682ed8967d7$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $a0511682ed8967d7$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $a0511682ed8967d7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $a0511682ed8967d7$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $a0511682ed8967d7$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $a0511682ed8967d7$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $a0511682ed8967d7$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($a0511682ed8967d7$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $a0511682ed8967d7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(path) : path;
    return $a0511682ed8967d7$export$fe53371bee54353d($a0511682ed8967d7$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $a0511682ed8967d7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $a0511682ed8967d7$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $a0511682ed8967d7$var$ResultType.data || result.type === $a0511682ed8967d7$var$ResultType.error);
}
function $a0511682ed8967d7$var$isRedirectDataStrategyResultResult(result) {
    return $a0511682ed8967d7$var$isResponse(result.result) && $a0511682ed8967d7$var$redirectStatusCodes.has(result.result.status);
}
function $a0511682ed8967d7$var$isDeferredResult(result) {
    return result.type === $a0511682ed8967d7$var$ResultType.deferred;
}
function $a0511682ed8967d7$var$isErrorResult(result) {
    return result.type === $a0511682ed8967d7$var$ResultType.error;
}
function $a0511682ed8967d7$var$isRedirectResult(result) {
    return (result && result.type) === $a0511682ed8967d7$var$ResultType.redirect;
}
function $a0511682ed8967d7$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $a0511682ed8967d7$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $a0511682ed8967d7$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $a0511682ed8967d7$var$isRedirectResponse(result) {
    if (!$a0511682ed8967d7$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $a0511682ed8967d7$var$isValidMethod(method) {
    return $a0511682ed8967d7$var$validRequestMethods.has(method.toLowerCase());
}
function $a0511682ed8967d7$var$isMutationMethod(method) {
    return $a0511682ed8967d7$var$validMutationMethods.has(method.toLowerCase());
}
async function $a0511682ed8967d7$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$a0511682ed8967d7$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($a0511682ed8967d7$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $a0511682ed8967d7$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $a0511682ed8967d7$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($a0511682ed8967d7$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $a0511682ed8967d7$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $a0511682ed8967d7$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $a0511682ed8967d7$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $a0511682ed8967d7$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $a0511682ed8967d7$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $a0511682ed8967d7$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $a0511682ed8967d7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $a0511682ed8967d7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $a0511682ed8967d7$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $a0511682ed8967d7$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $a0511682ed8967d7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $a0511682ed8967d7$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $a0511682ed8967d7$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $a0511682ed8967d7$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $a0511682ed8967d7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $a0511682ed8967d7$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $a0511682ed8967d7$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($a0511682ed8967d7$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $a0511682ed8967d7$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($a0511682ed8967d7$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $a0511682ed8967d7$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $ebc812b73151cba1$var$_extends() {
    return $ebc812b73151cba1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ebc812b73151cba1$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $ebc812b73151cba1$export$3add0d5dce533e2e = /*#__PURE__*/ $lCzvA.createContext(null);
const $ebc812b73151cba1$export$145dfa71566a64dc = /*#__PURE__*/ $lCzvA.createContext(null);
const $ebc812b73151cba1$var$AwaitContext = /*#__PURE__*/ $lCzvA.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $ebc812b73151cba1$export$26749e8557646306 = /*#__PURE__*/ $lCzvA.createContext(null);
const $ebc812b73151cba1$export$c7914228fb69b0f5 = /*#__PURE__*/ $lCzvA.createContext(null);
const $ebc812b73151cba1$export$9072aa6dd1f93057 = /*#__PURE__*/ $lCzvA.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $ebc812b73151cba1$var$RouteErrorContext = /*#__PURE__*/ $lCzvA.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $ebc812b73151cba1$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $ebc812b73151cba1$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $a0511682ed8967d7$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $ebc812b73151cba1$export$9c954a9d03d32f4a() {
    return $lCzvA.useContext($ebc812b73151cba1$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $ebc812b73151cba1$export$45d76561a5302f2b() {
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return $lCzvA.useContext($ebc812b73151cba1$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $ebc812b73151cba1$export$1b3f31771c5d07c() {
    return $lCzvA.useContext($ebc812b73151cba1$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $ebc812b73151cba1$export$6c330e8992e8a295(pattern) {
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $ebc812b73151cba1$export$45d76561a5302f2b();
    return $lCzvA.useMemo(()=>(0, $a0511682ed8967d7$export$81336c211d5ff295)(pattern, (0, $a0511682ed8967d7$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $ebc812b73151cba1$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $ebc812b73151cba1$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $lCzvA.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $ebc812b73151cba1$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $ebc812b73151cba1$var$useNavigateStable() : $ebc812b73151cba1$var$useNavigateUnstable();
}
function $ebc812b73151cba1$var$useNavigateUnstable() {
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let dataRouterContext = $lCzvA.useContext($ebc812b73151cba1$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306);
    let { matches: matches } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $ebc812b73151cba1$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a0511682ed8967d7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $lCzvA.useRef(false);
    $ebc812b73151cba1$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lCzvA.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $a0511682ed8967d7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a0511682ed8967d7$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $ebc812b73151cba1$var$OutletContext = /*#__PURE__*/ $lCzvA.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $ebc812b73151cba1$export$4138103a3ae699cc() {
    return $lCzvA.useContext($ebc812b73151cba1$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $ebc812b73151cba1$export$a3be3530d8e40d0b(context) {
    let outlet = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $ebc812b73151cba1$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $ebc812b73151cba1$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306);
    let { matches: matches } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $ebc812b73151cba1$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a0511682ed8967d7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $lCzvA.useMemo(()=>(0, $a0511682ed8967d7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $ebc812b73151cba1$export$5d3fca4a98652595(routes, locationArg) {
    return $ebc812b73151cba1$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $ebc812b73151cba1$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306);
    let { matches: parentMatches } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $ebc812b73151cba1$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $a0511682ed8967d7$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $a0511682ed8967d7$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $ebc812b73151cba1$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $a0511682ed8967d7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $a0511682ed8967d7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $ebc812b73151cba1$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $a0511682ed8967d7$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $ebc812b73151cba1$var$DefaultErrorComponent() {
    let error = $ebc812b73151cba1$export$ed527bf60f6e05f2();
    let message = (0, $a0511682ed8967d7$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $lCzvA.createElement($lCzvA.Fragment, null, /*#__PURE__*/ $lCzvA.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $lCzvA.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $lCzvA.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $ebc812b73151cba1$var$defaultErrorElement = /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$DefaultErrorComponent, null);
class $ebc812b73151cba1$var$RenderErrorBoundary extends $lCzvA.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $ebc812b73151cba1$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $lCzvA.useContext($ebc812b73151cba1$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $ebc812b73151cba1$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $ebc812b73151cba1$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $ebc812b73151cba1$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $lCzvA.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $ebc812b73151cba1$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($ebc812b73151cba1$var$DataRouterHook || {});
var $ebc812b73151cba1$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($ebc812b73151cba1$var$DataRouterStateHook || {});
function $ebc812b73151cba1$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $ebc812b73151cba1$var$useDataRouterContext(hookName) {
    let ctx = $lCzvA.useContext($ebc812b73151cba1$export$3add0d5dce533e2e);
    !ctx && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $ebc812b73151cba1$var$useDataRouterState(hookName) {
    let state = $lCzvA.useContext($ebc812b73151cba1$export$145dfa71566a64dc);
    !state && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return state;
}
function $ebc812b73151cba1$var$useRouteContext(hookName) {
    let route = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    !route && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $ebc812b73151cba1$var$useCurrentRouteId(hookName) {
    let route = $ebc812b73151cba1$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $ebc812b73151cba1$export$5fc8298006ad9e58() {
    return $ebc812b73151cba1$var$useCurrentRouteId($ebc812b73151cba1$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $ebc812b73151cba1$export$d0fd4b7106de2769() {
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $ebc812b73151cba1$export$600dc272ed516c15() {
    let dataRouterContext = $ebc812b73151cba1$var$useDataRouterContext($ebc812b73151cba1$var$DataRouterHook.UseRevalidator);
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseRevalidator);
    return $lCzvA.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $ebc812b73151cba1$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseMatches);
    return $lCzvA.useMemo(()=>matches.map((m)=>(0, $a0511682ed8967d7$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $ebc812b73151cba1$export$1448a5050d252c4d() {
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseLoaderData);
    let routeId = $ebc812b73151cba1$var$useCurrentRouteId($ebc812b73151cba1$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $ebc812b73151cba1$export$fd5d37484eab868d(routeId) {
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $ebc812b73151cba1$export$fdc00f3f26066d5e() {
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseActionData);
    let routeId = $ebc812b73151cba1$var$useCurrentRouteId($ebc812b73151cba1$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $ebc812b73151cba1$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $lCzvA.useContext($ebc812b73151cba1$var$RouteErrorContext);
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseRouteError);
    let routeId = $ebc812b73151cba1$var$useCurrentRouteId($ebc812b73151cba1$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $ebc812b73151cba1$export$78a72ddb39bdd145() {
    let value = $lCzvA.useContext($ebc812b73151cba1$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $ebc812b73151cba1$export$17f53340677d5831() {
    let value = $lCzvA.useContext($ebc812b73151cba1$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $ebc812b73151cba1$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $ebc812b73151cba1$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $ebc812b73151cba1$var$useDataRouterContext($ebc812b73151cba1$var$DataRouterHook.UseBlocker);
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $lCzvA.useState("");
    let blockerFunction = $lCzvA.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $ebc812b73151cba1$var$_extends({}, currentLocation, {
                pathname: (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $ebc812b73151cba1$var$_extends({}, nextLocation, {
                pathname: (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $lCzvA.useEffect(()=>{
        let key = String(++$ebc812b73151cba1$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $lCzvA.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $a0511682ed8967d7$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $ebc812b73151cba1$var$useNavigateStable() {
    let { router: router } = $ebc812b73151cba1$var$useDataRouterContext($ebc812b73151cba1$var$DataRouterHook.UseNavigateStable);
    let id = $ebc812b73151cba1$var$useCurrentRouteId($ebc812b73151cba1$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $lCzvA.useRef(false);
    $ebc812b73151cba1$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lCzvA.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $ebc812b73151cba1$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $ebc812b73151cba1$var$alreadyWarned$1 = {};
function $ebc812b73151cba1$var$warningOnce(key, cond, message) {
    if (!cond && !$ebc812b73151cba1$var$alreadyWarned$1[key]) $ebc812b73151cba1$var$alreadyWarned$1[key] = true;
}
const $ebc812b73151cba1$var$alreadyWarned = {};
function $ebc812b73151cba1$var$warnOnce(key, message) {}
const $ebc812b73151cba1$var$logDeprecation = (flag, msg, link)=>$ebc812b73151cba1$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $ebc812b73151cba1$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $ebc812b73151cba1$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $ebc812b73151cba1$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $ebc812b73151cba1$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $ebc812b73151cba1$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $ebc812b73151cba1$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $ebc812b73151cba1$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $ebc812b73151cba1$var$START_TRANSITION = "startTransition";
const $ebc812b73151cba1$var$startTransitionImpl = $lCzvA[$ebc812b73151cba1$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $ebc812b73151cba1$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $lCzvA.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lCzvA.useCallback((newState)=>{
        if (v7_startTransition && $ebc812b73151cba1$var$startTransitionImpl) $ebc812b73151cba1$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lCzvA.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $lCzvA.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $lCzvA.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lCzvA.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $lCzvA.useEffect(()=>$ebc812b73151cba1$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lCzvA.createElement($lCzvA.Fragment, null, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $ebc812b73151cba1$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $ebc812b73151cba1$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $ebc812b73151cba1$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $lCzvA.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a0511682ed8967d7$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lCzvA.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lCzvA.useCallback((newState)=>{
        v7_startTransition && $ebc812b73151cba1$var$startTransitionImpl ? $ebc812b73151cba1$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lCzvA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lCzvA.useEffect(()=>$ebc812b73151cba1$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $ebc812b73151cba1$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306);
    let { matches: matches } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $ebc812b73151cba1$export$45d76561a5302f2b();
    let navigate = $ebc812b73151cba1$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $a0511682ed8967d7$export$cae722b0cc860f13)(to, (0, $a0511682ed8967d7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $lCzvA.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $ebc812b73151cba1$export$910ae8079b2c2852(props) {
    return $ebc812b73151cba1$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $ebc812b73151cba1$export$e7b0ac011bb776c6(_props) {
    (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $ebc812b73151cba1$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $a0511682ed8967d7$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $lCzvA.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $ebc812b73151cba1$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $a0511682ed8967d7$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $lCzvA.useMemo(()=>{
        let trailingPathname = (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $ebc812b73151cba1$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $ebc812b73151cba1$export$5d3fca4a98652595($ebc812b73151cba1$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $ebc812b73151cba1$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$ResolveAwait, null, children));
}
var $ebc812b73151cba1$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($ebc812b73151cba1$var$AwaitRenderStatus || {});
const $ebc812b73151cba1$var$neverSettledPromise = new Promise(()=>{});
class $ebc812b73151cba1$var$AwaitErrorBoundary extends $lCzvA.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $ebc812b73151cba1$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $ebc812b73151cba1$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $ebc812b73151cba1$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $ebc812b73151cba1$var$AwaitRenderStatus.error : "_data" in promise ? $ebc812b73151cba1$var$AwaitRenderStatus.success : $ebc812b73151cba1$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $ebc812b73151cba1$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $ebc812b73151cba1$var$AwaitRenderStatus.error && promise._error instanceof (0, $a0511682ed8967d7$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $ebc812b73151cba1$var$neverSettledPromise;
        if (status === $ebc812b73151cba1$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $ebc812b73151cba1$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $ebc812b73151cba1$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $ebc812b73151cba1$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $ebc812b73151cba1$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $lCzvA.createElement($lCzvA.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $ebc812b73151cba1$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $lCzvA.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $lCzvA.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $lCzvA.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $ebc812b73151cba1$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $ebc812b73151cba1$export$e7b0ac011bb776c6) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $ebc812b73151cba1$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $ebc812b73151cba1$export$daf73786167a7f72(matches) {
    return $ebc812b73151cba1$var$_renderMatches(matches);
}
function $ebc812b73151cba1$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $lCzvA.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $lCzvA.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $lCzvA.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $ebc812b73151cba1$export$f30f7e456d254e83(routes, opts) {
    return (0, $a0511682ed8967d7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ebc812b73151cba1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a0511682ed8967d7$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $ebc812b73151cba1$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $c3aca08c2a74646e$var$_extends() {
    return $c3aca08c2a74646e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c3aca08c2a74646e$var$_extends.apply(null, arguments);
}
function $c3aca08c2a74646e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $c3aca08c2a74646e$var$defaultMethod = "get";
const $c3aca08c2a74646e$var$defaultEncType = "application/x-www-form-urlencoded";
function $c3aca08c2a74646e$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c3aca08c2a74646e$var$isButtonElement(object) {
    return $c3aca08c2a74646e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c3aca08c2a74646e$var$isFormElement(object) {
    return $c3aca08c2a74646e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c3aca08c2a74646e$var$isInputElement(object) {
    return $c3aca08c2a74646e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c3aca08c2a74646e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c3aca08c2a74646e$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c3aca08c2a74646e$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $c3aca08c2a74646e$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c3aca08c2a74646e$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c3aca08c2a74646e$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $c3aca08c2a74646e$var$_formDataSupportsSubmitter = null;
function $c3aca08c2a74646e$var$isFormDataSubmitterSupported() {
    if ($c3aca08c2a74646e$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c3aca08c2a74646e$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c3aca08c2a74646e$var$_formDataSupportsSubmitter = true;
    }
    return $c3aca08c2a74646e$var$_formDataSupportsSubmitter;
}
const $c3aca08c2a74646e$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c3aca08c2a74646e$var$getFormEncType(encType) {
    if (encType != null && !$c3aca08c2a74646e$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $c3aca08c2a74646e$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c3aca08c2a74646e$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $c3aca08c2a74646e$var$defaultMethod;
        encType = $c3aca08c2a74646e$var$getFormEncType(target.getAttribute("enctype")) || $c3aca08c2a74646e$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c3aca08c2a74646e$var$isButtonElement(target) || $c3aca08c2a74646e$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c3aca08c2a74646e$var$defaultMethod;
        encType = $c3aca08c2a74646e$var$getFormEncType(target.getAttribute("formenctype")) || $c3aca08c2a74646e$var$getFormEncType(form.getAttribute("enctype")) || $c3aca08c2a74646e$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$c3aca08c2a74646e$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c3aca08c2a74646e$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $c3aca08c2a74646e$var$defaultMethod;
        action = null;
        encType = $c3aca08c2a74646e$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $c3aca08c2a74646e$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $c3aca08c2a74646e$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $c3aca08c2a74646e$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $c3aca08c2a74646e$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $c3aca08c2a74646e$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $c3aca08c2a74646e$export$1f3f55432a00e06d(routes, opts) {
    return (0, $a0511682ed8967d7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c3aca08c2a74646e$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a0511682ed8967d7$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c3aca08c2a74646e$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $ebc812b73151cba1$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c3aca08c2a74646e$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $a0511682ed8967d7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c3aca08c2a74646e$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a0511682ed8967d7$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c3aca08c2a74646e$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $ebc812b73151cba1$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c3aca08c2a74646e$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $c3aca08c2a74646e$var$_extends({}, state, {
        errors: $c3aca08c2a74646e$var$deserializeErrors(state.errors)
    });
    return state;
}
function $c3aca08c2a74646e$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $a0511682ed8967d7$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $c3aca08c2a74646e$export$7ad602f0e94e62d1 = /*#__PURE__*/ $lCzvA.createContext({
    isTransitioning: false
});
const $c3aca08c2a74646e$export$148fd98d095596d4 = /*#__PURE__*/ $lCzvA.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c3aca08c2a74646e$var$START_TRANSITION = "startTransition";
const $c3aca08c2a74646e$var$startTransitionImpl = $lCzvA[$c3aca08c2a74646e$var$START_TRANSITION];
const $c3aca08c2a74646e$var$FLUSH_SYNC = "flushSync";
const $c3aca08c2a74646e$var$flushSyncImpl = $dAQd3[$c3aca08c2a74646e$var$FLUSH_SYNC];
const $c3aca08c2a74646e$var$USE_ID = "useId";
const $c3aca08c2a74646e$var$useIdImpl = $lCzvA[$c3aca08c2a74646e$var$USE_ID];
function $c3aca08c2a74646e$var$startTransitionSafe(cb) {
    if ($c3aca08c2a74646e$var$startTransitionImpl) $c3aca08c2a74646e$var$startTransitionImpl(cb);
    else cb();
}
function $c3aca08c2a74646e$var$flushSyncSafe(cb) {
    if ($c3aca08c2a74646e$var$flushSyncImpl) $c3aca08c2a74646e$var$flushSyncImpl(cb);
    else cb();
}
class $c3aca08c2a74646e$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $c3aca08c2a74646e$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $lCzvA.useState(router.state);
    let [pendingState, setPendingState] = $lCzvA.useState();
    let [vtContext, setVtContext] = $lCzvA.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $lCzvA.useState();
    let [transition, setTransition] = $lCzvA.useState();
    let [interruption, setInterruption] = $lCzvA.useState();
    let fetcherData = $lCzvA.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $lCzvA.useCallback((cb)=>{
        if (v7_startTransition) $c3aca08c2a74646e$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $lCzvA.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $c3aca08c2a74646e$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $c3aca08c2a74646e$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $c3aca08c2a74646e$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $c3aca08c2a74646e$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $c3aca08c2a74646e$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lCzvA.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $lCzvA.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $c3aca08c2a74646e$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $lCzvA.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $lCzvA.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $lCzvA.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $lCzvA.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $lCzvA.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lCzvA.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $lCzvA.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $lCzvA.useEffect(()=>(0, $ebc812b73151cba1$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lCzvA.createElement($lCzvA.Fragment, null, /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $c3aca08c2a74646e$var$MemoizedDataRoutes = /*#__PURE__*/ $lCzvA.memo($c3aca08c2a74646e$var$DataRoutes);
function $c3aca08c2a74646e$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $ebc812b73151cba1$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $c3aca08c2a74646e$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $lCzvA.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a0511682ed8967d7$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lCzvA.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lCzvA.useCallback((newState)=>{
        v7_startTransition && $c3aca08c2a74646e$var$startTransitionImpl ? $c3aca08c2a74646e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lCzvA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lCzvA.useEffect(()=>(0, $ebc812b73151cba1$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $c3aca08c2a74646e$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $lCzvA.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a0511682ed8967d7$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lCzvA.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lCzvA.useCallback((newState)=>{
        v7_startTransition && $c3aca08c2a74646e$var$startTransitionImpl ? $c3aca08c2a74646e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lCzvA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lCzvA.useEffect(()=>(0, $ebc812b73151cba1$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $c3aca08c2a74646e$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $lCzvA.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lCzvA.useCallback((newState)=>{
        v7_startTransition && $c3aca08c2a74646e$var$startTransitionImpl ? $c3aca08c2a74646e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lCzvA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lCzvA.useEffect(()=>(0, $ebc812b73151cba1$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $c3aca08c2a74646e$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $c3aca08c2a74646e$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $c3aca08c2a74646e$export$a6c7ac8248d6e38a = /*#__PURE__*/ $lCzvA.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $c3aca08c2a74646e$var$_objectWithoutPropertiesLoose(_ref7, $c3aca08c2a74646e$var$_excluded);
    let { basename: basename } = $lCzvA.useContext((0, $ebc812b73151cba1$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $c3aca08c2a74646e$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($c3aca08c2a74646e$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $ebc812b73151cba1$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $c3aca08c2a74646e$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $lCzvA.createElement("a", $c3aca08c2a74646e$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $c3aca08c2a74646e$export$b0d92dbee9b5b60d = /*#__PURE__*/ $lCzvA.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $c3aca08c2a74646e$var$_objectWithoutPropertiesLoose(_ref8, $c3aca08c2a74646e$var$_excluded2);
    let path = (0, $ebc812b73151cba1$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    let routerState = $lCzvA.useContext((0, $ebc812b73151cba1$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $lCzvA.useContext((0, $ebc812b73151cba1$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c3aca08c2a74646e$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$export$a6c7ac8248d6e38a, $c3aca08c2a74646e$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $c3aca08c2a74646e$export$a7fed597f4b8afd8 = /*#__PURE__*/ $lCzvA.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $c3aca08c2a74646e$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $c3aca08c2a74646e$var$_objectWithoutPropertiesLoose(_ref9, $c3aca08c2a74646e$var$_excluded3);
    let submit = $c3aca08c2a74646e$export$47c85c6e3a081d3();
    let formAction = $c3aca08c2a74646e$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $lCzvA.createElement("form", $c3aca08c2a74646e$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $c3aca08c2a74646e$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $c3aca08c2a74646e$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $c3aca08c2a74646e$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($c3aca08c2a74646e$var$DataRouterHook || ($c3aca08c2a74646e$var$DataRouterHook = {}));
var $c3aca08c2a74646e$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($c3aca08c2a74646e$var$DataRouterStateHook || ($c3aca08c2a74646e$var$DataRouterStateHook = {}));
// Internal hooks
function $c3aca08c2a74646e$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $c3aca08c2a74646e$var$useDataRouterContext(hookName) {
    let ctx = $lCzvA.useContext((0, $ebc812b73151cba1$export$3add0d5dce533e2e));
    !ctx && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $c3aca08c2a74646e$var$useDataRouterState(hookName) {
    let state = $lCzvA.useContext((0, $ebc812b73151cba1$export$145dfa71566a64dc));
    !state && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $c3aca08c2a74646e$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    let location = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    let path = (0, $ebc812b73151cba1$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $lCzvA.useCallback((event)=>{
        if ($c3aca08c2a74646e$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $a0511682ed8967d7$export$fe53371bee54353d)(location) === (0, $a0511682ed8967d7$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $c3aca08c2a74646e$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $lCzvA.useRef($c3aca08c2a74646e$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $lCzvA.useRef(false);
    let location = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    let searchParams = $lCzvA.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c3aca08c2a74646e$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    let setSearchParams = $lCzvA.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c3aca08c2a74646e$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $c3aca08c2a74646e$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $c3aca08c2a74646e$var$fetcherId = 0;
let $c3aca08c2a74646e$var$getUniqueFetcherId = ()=>"__" + String(++$c3aca08c2a74646e$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $c3aca08c2a74646e$export$47c85c6e3a081d3() {
    let { router: router } = $c3aca08c2a74646e$var$useDataRouterContext($c3aca08c2a74646e$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $lCzvA.useContext((0, $ebc812b73151cba1$export$26749e8557646306));
    let currentRouteId = (0, $ebc812b73151cba1$export$5fc8298006ad9e58)();
    return $lCzvA.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c3aca08c2a74646e$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c3aca08c2a74646e$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $c3aca08c2a74646e$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $c3aca08c2a74646e$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $lCzvA.useContext((0, $ebc812b73151cba1$export$26749e8557646306));
    let routeContext = $lCzvA.useContext((0, $ebc812b73151cba1$export$9072aa6dd1f93057));
    !routeContext && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $c3aca08c2a74646e$var$_extends({}, (0, $ebc812b73151cba1$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a0511682ed8967d7$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $a0511682ed8967d7$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $c3aca08c2a74646e$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $c3aca08c2a74646e$var$useDataRouterContext($c3aca08c2a74646e$var$DataRouterHook.UseFetcher);
    let state = $c3aca08c2a74646e$var$useDataRouterState($c3aca08c2a74646e$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $lCzvA.useContext($c3aca08c2a74646e$export$148fd98d095596d4);
    let route = $lCzvA.useContext((0, $ebc812b73151cba1$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    !route && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $c3aca08c2a74646e$var$useIdImpl ? $c3aca08c2a74646e$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $lCzvA.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($c3aca08c2a74646e$var$getUniqueFetcherId());
    // Registration/cleanup
    $lCzvA.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $lCzvA.useCallback((href, opts)=>{
        !routeId && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $c3aca08c2a74646e$export$47c85c6e3a081d3();
    let submit = $lCzvA.useCallback((target, opts)=>{
        submitImpl(target, $c3aca08c2a74646e$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $lCzvA.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $lCzvA.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$export$a7fed597f4b8afd8, $c3aca08c2a74646e$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $a0511682ed8967d7$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $lCzvA.useMemo(()=>$c3aca08c2a74646e$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $c3aca08c2a74646e$export$fa996778a3a31087() {
    let state = $c3aca08c2a74646e$var$useDataRouterState($c3aca08c2a74646e$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $c3aca08c2a74646e$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $c3aca08c2a74646e$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $c3aca08c2a74646e$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $c3aca08c2a74646e$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $c3aca08c2a74646e$var$useDataRouterContext($c3aca08c2a74646e$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c3aca08c2a74646e$var$useDataRouterState($c3aca08c2a74646e$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $lCzvA.useContext((0, $ebc812b73151cba1$export$26749e8557646306));
    let location = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    let matches = (0, $ebc812b73151cba1$export$2378eb7f5ff86053)();
    let navigation = (0, $ebc812b73151cba1$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $lCzvA.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $c3aca08c2a74646e$var$usePageHide($lCzvA.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $c3aca08c2a74646e$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c3aca08c2a74646e$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c3aca08c2a74646e$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lCzvA.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c3aca08c2a74646e$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c3aca08c2a74646e$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lCzvA.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($c3aca08c2a74646e$var$_extends({}, location, {
                    pathname: (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($c3aca08c2a74646e$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lCzvA.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c3aca08c2a74646e$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $lCzvA.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c3aca08c2a74646e$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $lCzvA.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $c3aca08c2a74646e$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $ebc812b73151cba1$export$b273b3273281a049)(when);
    $lCzvA.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $lCzvA.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $c3aca08c2a74646e$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $lCzvA.useContext($c3aca08c2a74646e$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let { basename: basename } = $c3aca08c2a74646e$var$useDataRouterContext($c3aca08c2a74646e$var$DataRouterHook.useViewTransitionState);
    let path = (0, $ebc812b73151cba1$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $a0511682ed8967d7$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $a0511682ed8967d7$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $954b04773eb0508c$export$df9a5fb346e7c0bb = /*#__PURE__*/ $lCzvA.createContext(null);
var $954b04773eb0508c$export$2ae4a19e09ca9a00 = function useOktaAuth() {
    return $lCzvA.useContext($954b04773eb0508c$export$df9a5fb346e7c0bb);
};
var $954b04773eb0508c$var$OktaError = function OktaError(_ref) {
    var error = _ref.error;
    if (error.name && error.message) return /*#__PURE__*/ $lCzvA.createElement("p", null, error.name, ": ", error.message);
    return /*#__PURE__*/ $lCzvA.createElement("p", null, "Error: ", error.toString());
};
var $954b04773eb0508c$export$9fb697de7778c436 = function Security(_ref) {
    var oktaAuth = _ref.oktaAuth, restoreOriginalUri = _ref.restoreOriginalUri, onAuthRequired = _ref.onAuthRequired, children = _ref.children;
    var _React$useState = $lCzvA.useState(function() {
        if (!oktaAuth) return null;
        return oktaAuth.authStateManager.getAuthState();
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($a40c7345b1900589$exports)))(_React$useState, 2), authState = _React$useState2[0], setAuthState = _React$useState2[1];
    $lCzvA.useEffect(function() {
        if (!oktaAuth || !restoreOriginalUri) return;
        if (oktaAuth.options.restoreOriginalUri) console.warn('Two custom restoreOriginalUri callbacks are detected. The one from the OktaAuth configuration will be overridden by the provided restoreOriginalUri prop from the Security component.');
        oktaAuth.options.restoreOriginalUri = /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9b648ee8ee511cda$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a0061d920c204c4d$exports))).mark(function _callee(oktaAuth, originalUri) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($a0061d920c204c4d$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            return _context.abrupt("return", restoreOriginalUri(oktaAuth, originalUri));
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2) {
                return _ref2.apply(this, arguments);
            };
        }();
    }, []);
    $lCzvA.useEffect(function() {
        if (!oktaAuth) return;
        if (oktaAuth._oktaUserAgent) oktaAuth._oktaUserAgent.addEnvironment("@okta/okta-react".concat("/", "6.11.0"));
        else console.warn('_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .');
        var currentAuthState = oktaAuth.authStateManager.getAuthState();
        if (currentAuthState !== authState) setAuthState(currentAuthState);
        var handler = function handler(authState) {
            setAuthState(authState);
        };
        oktaAuth.authStateManager.subscribe(handler);
        oktaAuth.start();
        return function() {
            oktaAuth.authStateManager.unsubscribe(handler);
        };
    }, [
        oktaAuth
    ]);
    var oktaContextValue = $lCzvA.useMemo(function() {
        return {
            oktaAuth: oktaAuth,
            authState: authState,
            _onAuthRequired: onAuthRequired
        };
    }, [
        oktaAuth,
        authState,
        onAuthRequired
    ]);
    if (!oktaAuth) {
        var err = new (0, $dbbfea4bd9ff1bad$exports.AuthSdkError)('No oktaAuth instance passed to Security Component.');
        return /*#__PURE__*/ $lCzvA.createElement($954b04773eb0508c$var$OktaError, {
            error: err
        });
    }
    if (!restoreOriginalUri) {
        var _err = new (0, $dbbfea4bd9ff1bad$exports.AuthSdkError)('No restoreOriginalUri callback passed to Security Component.');
        return /*#__PURE__*/ $lCzvA.createElement($954b04773eb0508c$var$OktaError, {
            error: _err
        });
    }
    if (!oktaAuth._oktaUserAgent) console.warn('_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .');
    else {
        var isAuthJsSupported = (0, $36c46bc4813033e5$export$398604a469f7de9a)(oktaAuth._oktaUserAgent.getVersion(), "5.3.1", '>=');
        if (!isAuthJsSupported) {
            var _err2 = new (0, $dbbfea4bd9ff1bad$exports.AuthSdkError)("\n        Passed in oktaAuth is not compatible with the SDK,\n        minimum supported okta-auth-js version is ".concat("5.3.1", ".\n      "));
            return /*#__PURE__*/ $lCzvA.createElement($954b04773eb0508c$var$OktaError, {
                error: _err2
            });
        }
    }
    return /*#__PURE__*/ $lCzvA.createElement($954b04773eb0508c$export$df9a5fb346e7c0bb.Provider, {
        value: oktaContextValue
    }, children);
};
function $954b04773eb0508c$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $954b04773eb0508c$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $954b04773eb0508c$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($68b2af567466e5f1$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $954b04773eb0508c$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $954b04773eb0508c$export$683729e5315f529b = function withOktaAuth(ComponentToWrap) {
    var WrappedComponent = function WrappedComponent(props) {
        var oktaAuthProps = $954b04773eb0508c$export$2ae4a19e09ca9a00();
        return /*#__PURE__*/ $lCzvA.createElement(ComponentToWrap, $954b04773eb0508c$var$_objectSpread$1($954b04773eb0508c$var$_objectSpread$1({}, oktaAuthProps), props));
    };
    WrappedComponent.displayName = 'withOktaAuth_' + (ComponentToWrap.displayName || ComponentToWrap.name);
    return WrappedComponent;
};
var $954b04773eb0508c$var$handledRedirect = false;
var $954b04773eb0508c$export$8f938467209eea73 = function LoginCallback(_ref) {
    var errorComponent = _ref.errorComponent, _ref$loadingElement = _ref.loadingElement, loadingElement = _ref$loadingElement === void 0 ? null : _ref$loadingElement, onAuthResume = _ref.onAuthResume;
    var _useOktaAuth = $954b04773eb0508c$export$2ae4a19e09ca9a00(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState;
    var _React$useState = $lCzvA.useState(null), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($a40c7345b1900589$exports)))(_React$useState, 2), callbackError = _React$useState2[0], setCallbackError = _React$useState2[1];
    var ErrorReporter = errorComponent || $954b04773eb0508c$var$OktaError;
    $lCzvA.useEffect(function() {
        var isInteractionRequired = oktaAuth.idx.isInteractionRequired || oktaAuth.isInteractionRequired.bind(oktaAuth);
        if (onAuthResume && isInteractionRequired()) {
            onAuthResume();
            return;
        }
        if (!$954b04773eb0508c$var$handledRedirect) {
            oktaAuth.handleLoginRedirect()["catch"](function(e) {
                setCallbackError(e);
            });
            $954b04773eb0508c$var$handledRedirect = true;
        }
    }, [
        oktaAuth
    ]);
    var authError = authState === null || authState === void 0 ? void 0 : authState.error;
    var displayError = callbackError || authError;
    if (displayError) return /*#__PURE__*/ $lCzvA.createElement(ErrorReporter, {
        error: displayError
    });
    return loadingElement;
};
var $954b04773eb0508c$var$_excluded = [
    "onAuthRequired",
    "errorComponent"
];
function $954b04773eb0508c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $954b04773eb0508c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $954b04773eb0508c$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($68b2af567466e5f1$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $954b04773eb0508c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $954b04773eb0508c$var$useMatch;
if ('useRouteMatch' in $c3aca08c2a74646e$exports) $954b04773eb0508c$var$useMatch = $c3aca08c2a74646e$exports['useRouteMatch' in $c3aca08c2a74646e$exports ? 'useRouteMatch' : ''];
else $954b04773eb0508c$var$useMatch = function useMatch() {
    throw new (0, $dbbfea4bd9ff1bad$exports.AuthSdkError)('Unsupported: SecureRoute only works with react-router-dom v5 or any router library with compatible APIs. See examples under the "samples" folder for how to implement your own custom SecureRoute Component.');
};
var $954b04773eb0508c$export$d93cdd50e579241c = function SecureRoute(_ref) {
    var onAuthRequired = _ref.onAuthRequired, errorComponent = _ref.errorComponent, routeProps = (0, (/*@__PURE__*/$parcel$interopDefault($1d0a4d1f203265da$exports)))(_ref, $954b04773eb0508c$var$_excluded);
    var _useOktaAuth = $954b04773eb0508c$export$2ae4a19e09ca9a00(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState, _onAuthRequired = _useOktaAuth._onAuthRequired;
    var match = $954b04773eb0508c$var$useMatch(routeProps);
    var pendingLogin = $lCzvA.useRef(false);
    var _React$useState = $lCzvA.useState(null), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($a40c7345b1900589$exports)))(_React$useState, 2), handleLoginError = _React$useState2[0], setHandleLoginError = _React$useState2[1];
    var ErrorReporter = errorComponent || $954b04773eb0508c$var$OktaError;
    $lCzvA.useEffect(function() {
        var handleLogin = /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9b648ee8ee511cda$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a0061d920c204c4d$exports))).mark(function _callee() {
                var originalUri, onAuthRequiredFn;
                return (0, (/*@__PURE__*/$parcel$interopDefault($a0061d920c204c4d$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!pendingLogin.current) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            pendingLogin.current = true;
                            originalUri = (0, $dbbfea4bd9ff1bad$exports.toRelativeUrl)(window.location.href, window.location.origin);
                            oktaAuth.setOriginalUri(originalUri);
                            onAuthRequiredFn = onAuthRequired || _onAuthRequired;
                            if (!onAuthRequiredFn) {
                                _context.next = 11;
                                break;
                            }
                            _context.next = 9;
                            return onAuthRequiredFn(oktaAuth);
                        case 9:
                            _context.next = 13;
                            break;
                        case 11:
                            _context.next = 13;
                            return oktaAuth.signInWithRedirect();
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function handleLogin() {
                return _ref2.apply(this, arguments);
            };
        }();
        if (!match) return;
        if (!authState) return;
        if (authState.isAuthenticated) {
            pendingLogin.current = false;
            return;
        }
        if (!authState.isAuthenticated) handleLogin()["catch"](function(err) {
            setHandleLoginError(err);
        });
    }, [
        authState,
        oktaAuth,
        match,
        onAuthRequired,
        _onAuthRequired
    ]);
    if (handleLoginError) return /*#__PURE__*/ $lCzvA.createElement(ErrorReporter, {
        error: handleLoginError
    });
    if (!authState || !authState.isAuthenticated) return null;
    return /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$exports.Route, $954b04773eb0508c$var$_objectSpread({}, routeProps));
};




var $d6a3b9b6cdd1d7b7$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $d6a3b9b6cdd1d7b7$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $d6a3b9b6cdd1d7b7$var$__typeError("Cannot " + msg);
var $d6a3b9b6cdd1d7b7$export$18a094aefa070634 = (obj, member, getter)=>($d6a3b9b6cdd1d7b7$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $d6a3b9b6cdd1d7b7$export$addf369becd23283 = (obj, member, value1)=>member.has(obj) ? $d6a3b9b6cdd1d7b7$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
var $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4 = (obj, member, value1, setter)=>($d6a3b9b6cdd1d7b7$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value1) : member.set(obj, value1), value1);
var $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20 = (obj, member, method)=>($d6a3b9b6cdd1d7b7$var$__accessCheck(obj, member, "access private method"), method);
var $d6a3b9b6cdd1d7b7$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $d6a3b9b6cdd1d7b7$export$18a094aefa070634(obj, member, getter);
        }
    });




// src/timeoutManager.ts
var $081f0087b1e470a7$export$d235812f9125bf47 = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $081f0087b1e470a7$var$_provider, $081f0087b1e470a7$var$_providerCalled;
var $081f0087b1e470a7$export$6336d90323f0ab52 = class {
    constructor(){
        // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
        // type at app boot; and if we leave that type, then any new timer provider
        // would need to support the default provider's concrete timer ID, which is
        // infeasible across environments.
        //
        // We settle for type safety for the TimeoutProvider type, and accept that
        // this class is unsafe internally to allow for extension.
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $081f0087b1e470a7$var$_provider, $081f0087b1e470a7$export$d235812f9125bf47);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $081f0087b1e470a7$var$_providerCalled, false);
    }
    setTimeoutProvider(provider) {
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $081f0087b1e470a7$var$_provider, provider);
    }
    setTimeout(callback, delay) {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $081f0087b1e470a7$var$_provider).setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $081f0087b1e470a7$var$_provider).clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $081f0087b1e470a7$var$_provider).setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $081f0087b1e470a7$var$_provider).clearInterval(intervalId);
    }
};
$081f0087b1e470a7$var$_provider = new WeakMap();
$081f0087b1e470a7$var$_providerCalled = new WeakMap();
var $081f0087b1e470a7$export$94a2700736e69372 = new $081f0087b1e470a7$export$6336d90323f0ab52();
function $081f0087b1e470a7$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}


var $f0d6b6465c83f494$export$7c76da44185e6090 = (0, $081f0087b1e470a7$export$5086591e51e32a18);
function $f0d6b6465c83f494$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $f0d6b6465c83f494$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $f0d6b6465c83f494$export$520687f44db6e1ab = $f0d6b6465c83f494$export$316a8efd03cd1458();









var $9f9f0025923da73f$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $9f9f0025923da73f$export$8793edee2d425525() {}
function $9f9f0025923da73f$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $9f9f0025923da73f$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $9f9f0025923da73f$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $9f9f0025923da73f$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $9f9f0025923da73f$export$d7ee3961208f79c1(option, query) {
    return typeof option === "function" ? option(query) : option;
}
function $9f9f0025923da73f$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $9f9f0025923da73f$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$9f9f0025923da73f$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $9f9f0025923da73f$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($9f9f0025923da73f$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $9f9f0025923da73f$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$9f9f0025923da73f$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $9f9f0025923da73f$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $9f9f0025923da73f$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $9f9f0025923da73f$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$9f9f0025923da73f$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $9f9f0025923da73f$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (Array.isArray(a) && Array.isArray(b)) {
            for(let i = 0; i < b.length; i++){
                if (!$9f9f0025923da73f$export$2f07189bb9fa26a7(a[i], b[i])) return false;
            }
            return true;
        }
        const bKeys = Object.keys(b);
        for (const key of bKeys){
            if (!$9f9f0025923da73f$export$2f07189bb9fa26a7(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}
var $9f9f0025923da73f$var$hasOwn = Object.prototype.hasOwnProperty;
function $9f9f0025923da73f$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $9f9f0025923da73f$export$7a8558113332b71e(a) && $9f9f0025923da73f$export$7a8558113332b71e(b);
    if (!array && !($9f9f0025923da73f$export$53b83ca8eaab0383(a) && $9f9f0025923da73f$export$53b83ca8eaab0383(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $9f9f0025923da73f$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $9f9f0025923da73f$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function $9f9f0025923da73f$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $9f9f0025923da73f$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $9f9f0025923da73f$export$53b83ca8eaab0383(o) {
    if (!$9f9f0025923da73f$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$9f9f0025923da73f$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $9f9f0025923da73f$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $9f9f0025923da73f$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $081f0087b1e470a7$export$94a2700736e69372).setTimeout(resolve, timeout);
    });
}
function $9f9f0025923da73f$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $9f9f0025923da73f$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $9f9f0025923da73f$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $9f9f0025923da73f$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $9f9f0025923da73f$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $9f9f0025923da73f$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol();
function $9f9f0025923da73f$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $9f9f0025923da73f$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $9f9f0025923da73f$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
function $9f9f0025923da73f$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ?? (signal = getSignal());
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}


var $bd362d0e3cb143ba$export$2d935f1a9c9d3f3e = /* @__PURE__ */ (()=>{
    let isServerFn = ()=>(0, $9f9f0025923da73f$export$6acf61af03e62db);
    return {
        /**
     * Returns whether the current runtime should be treated as a server environment.
     */ isServer () {
            return isServerFn();
        },
        /**
     * Overrides the server check globally.
     */ setIsServer (isServerValue) {
            isServerFn = isServerValue;
        }
    };
})();



var $3e6f247ffa858a13$var$_gcTimeout;
var $3e6f247ffa858a13$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $3e6f247ffa858a13$var$_gcTimeout);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $9f9f0025923da73f$export$e539f754e934e270)(this.gcTime)) (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $3e6f247ffa858a13$var$_gcTimeout, (0, $081f0087b1e470a7$export$94a2700736e69372).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $bd362d0e3cb143ba$export$2d935f1a9c9d3f3e).isServer() ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $3e6f247ffa858a13$var$_gcTimeout) !== void 0) {
            (0, $081f0087b1e470a7$export$94a2700736e69372).clearTimeout((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $3e6f247ffa858a13$var$_gcTimeout));
            (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $3e6f247ffa858a13$var$_gcTimeout, void 0);
        }
    }
};
$3e6f247ffa858a13$var$_gcTimeout = new WeakMap();





// src/subscribable.ts
var $fa7f8e88baa31e37$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};


var $a86282ed95c1f11c$var$_focused, $a86282ed95c1f11c$var$_cleanup, $a86282ed95c1f11c$var$_setup;
var $a86282ed95c1f11c$export$86f1af424b2ca4de = class extends (0, $fa7f8e88baa31e37$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $a86282ed95c1f11c$var$_focused);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $a86282ed95c1f11c$var$_cleanup);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $a86282ed95c1f11c$var$_setup);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $a86282ed95c1f11c$var$_setup, (onFocus)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $a86282ed95c1f11c$var$_cleanup)) this.setEventListener((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $a86282ed95c1f11c$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $a86282ed95c1f11c$var$_cleanup)) == null || _a.call(this);
            (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $a86282ed95c1f11c$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $a86282ed95c1f11c$var$_setup, setup);
        (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $a86282ed95c1f11c$var$_cleanup)) == null || _a.call(this);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $a86282ed95c1f11c$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $a86282ed95c1f11c$var$_focused) !== focused;
        if (changed) {
            (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $a86282ed95c1f11c$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $a86282ed95c1f11c$var$_focused) === "boolean") return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $a86282ed95c1f11c$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$a86282ed95c1f11c$var$_focused = new WeakMap();
$a86282ed95c1f11c$var$_cleanup = new WeakMap();
$a86282ed95c1f11c$var$_setup = new WeakMap();
var $a86282ed95c1f11c$export$6bf54661be5b02cf = new $a86282ed95c1f11c$export$86f1af424b2ca4de();




var $7899ca234c848a08$var$_online, $7899ca234c848a08$var$_cleanup, $7899ca234c848a08$var$_setup;
var $7899ca234c848a08$export$58774fb55d5ff7fc = class extends (0, $fa7f8e88baa31e37$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $7899ca234c848a08$var$_online, true);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $7899ca234c848a08$var$_cleanup);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $7899ca234c848a08$var$_setup);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $7899ca234c848a08$var$_setup, (onOnline)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $7899ca234c848a08$var$_cleanup)) this.setEventListener((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $7899ca234c848a08$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $7899ca234c848a08$var$_cleanup)) == null || _a.call(this);
            (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $7899ca234c848a08$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $7899ca234c848a08$var$_setup, setup);
        (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $7899ca234c848a08$var$_cleanup)) == null || _a.call(this);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $7899ca234c848a08$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $7899ca234c848a08$var$_online) !== online;
        if (changed) {
            (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $7899ca234c848a08$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $7899ca234c848a08$var$_online);
    }
};
$7899ca234c848a08$var$_online = new WeakMap();
$7899ca234c848a08$var$_cleanup = new WeakMap();
$7899ca234c848a08$var$_setup = new WeakMap();
var $7899ca234c848a08$export$b113e788b2dd3fdc = new $7899ca234c848a08$export$58774fb55d5ff7fc();




function $520a224bc020dbc5$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $520a224bc020dbc5$export$216296c47a9d1275(promise) {
    var _a;
    let data;
    (_a = promise.then((result)=>{
        data = result;
        return result;
    }, (0, $9f9f0025923da73f$export$8793edee2d425525))) == null || _a.catch((0, $9f9f0025923da73f$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}




function $a244555a5f244948$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $a244555a5f244948$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $7899ca234c848a08$export$b113e788b2dd3fdc).isOnline() : true;
}
var $a244555a5f244948$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $a244555a5f244948$export$986cc6445c1d323(value) {
    return value instanceof $a244555a5f244948$export$a8430ed4188f35a9;
}
function $a244555a5f244948$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $520a224bc020dbc5$export$d54630db02a12b72)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved()) {
            const error = new $a244555a5f244948$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            (_a = config.onCancel) == null || _a.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $a86282ed95c1f11c$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $7899ca234c848a08$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$a244555a5f244948$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved()) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $bd362d0e3cb143ba$export$2d935f1a9c9d3f3e).isServer() ? 0 : 3);
            const retryDelay = config.retryDelay ?? $a244555a5f244948$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $9f9f0025923da73f$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}


var $d767dfc79a020d69$var$_client, $d767dfc79a020d69$var$_observers, $d767dfc79a020d69$var$_mutationCache, $d767dfc79a020d69$var$_retryer, $d767dfc79a020d69$var$_Mutation_instances, $d767dfc79a020d69$var$dispatch_fn;
var $d767dfc79a020d69$export$17b8b19c814bcf56 = class extends (0, $3e6f247ffa858a13$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $d767dfc79a020d69$var$_Mutation_instances);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $d767dfc79a020d69$var$_client);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $d767dfc79a020d69$var$_observers);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $d767dfc79a020d69$var$_mutationCache);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $d767dfc79a020d69$var$_retryer);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $d767dfc79a020d69$var$_client, config.client);
        this.mutationId = config.mutationId;
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $d767dfc79a020d69$var$_mutationCache, config.mutationCache);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $d767dfc79a020d69$var$_observers, []);
        this.state = config.state || $d767dfc79a020d69$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_observers).includes(observer)) {
            (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $d767dfc79a020d69$var$_observers, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
        const onContinue = ()=>{
            (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d767dfc79a020d69$var$_Mutation_instances, $d767dfc79a020d69$var$dispatch_fn).call(this, {
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_client),
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $d767dfc79a020d69$var$_retryer, (0, $a244555a5f244948$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d767dfc79a020d69$var$_Mutation_instances, $d767dfc79a020d69$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d767dfc79a020d69$var$_Mutation_instances, $d767dfc79a020d69$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_retryer).canStart();
        try {
            if (restored) onContinue();
            else {
                (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d767dfc79a020d69$var$_Mutation_instances, $d767dfc79a020d69$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).config.onMutate) await (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).config.onMutate(variables, this, mutationFnContext);
                const context = await ((_b = (_a = this.options).onMutate) == null ? void 0 : _b.call(_a, variables, mutationFnContext));
                if (context !== this.state.context) (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d767dfc79a020d69$var$_Mutation_instances, $d767dfc79a020d69$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_retryer).start();
            await ((_d = (_c = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).config).onSuccess) == null ? void 0 : _d.call(_c, data, variables, this.state.context, this, mutationFnContext));
            await ((_f = (_e = this.options).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, mutationFnContext));
            await ((_h = (_g = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).config).onSettled) == null ? void 0 : _h.call(_g, data, null, this.state.variables, this.state.context, this, mutationFnContext));
            await ((_j = (_i = this.options).onSettled) == null ? void 0 : _j.call(_i, data, null, variables, this.state.context, mutationFnContext));
            (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d767dfc79a020d69$var$_Mutation_instances, $d767dfc79a020d69$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_l = (_k = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).config).onError) == null ? void 0 : _l.call(_k, error, variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await ((_n = (_m = this.options).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await ((_p = (_o = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).config).onSettled) == null ? void 0 : _p.call(_o, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await ((_r = (_q = this.options).onSettled) == null ? void 0 : _r.call(_q, void 0, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d767dfc79a020d69$var$_Mutation_instances, $d767dfc79a020d69$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            throw error;
        } finally{
            (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).runNext(this);
        }
    }
};
$d767dfc79a020d69$var$_client = new WeakMap();
$d767dfc79a020d69$var$_observers = new WeakMap();
$d767dfc79a020d69$var$_mutationCache = new WeakMap();
$d767dfc79a020d69$var$_retryer = new WeakMap();
$d767dfc79a020d69$var$_Mutation_instances = new WeakSet();
$d767dfc79a020d69$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d767dfc79a020d69$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $d767dfc79a020d69$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $154bcf165b6632e7$var$_mutations, $154bcf165b6632e7$var$_scopes, $154bcf165b6632e7$var$_mutationId;
var $154bcf165b6632e7$export$1fcfd9a244434844 = class extends (0, $fa7f8e88baa31e37$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $154bcf165b6632e7$var$_mutations);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $154bcf165b6632e7$var$_scopes);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $154bcf165b6632e7$var$_mutationId);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $154bcf165b6632e7$var$_mutations, /* @__PURE__ */ new Set());
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $154bcf165b6632e7$var$_scopes, /* @__PURE__ */ new Map());
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $154bcf165b6632e7$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $d767dfc79a020d69$export$17b8b19c814bcf56)({
            client: client,
            mutationCache: this,
            mutationId: ++(0, $d6a3b9b6cdd1d7b7$export$b1fe7cbb4502036b)(this, $154bcf165b6632e7$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_mutations).add(mutation);
        const scope = $154bcf165b6632e7$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_scopes).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_scopes).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_mutations).delete(mutation)) {
            const scope = $154bcf165b6632e7$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_scopes).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_scopes).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $154bcf165b6632e7$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_scopes).get(scope);
            const firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        var _a;
        const scope = $154bcf165b6632e7$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_scopes).get(scope)) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
            (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_mutations).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_mutations).clear();
            (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_scopes).clear();
        });
    }
    getAll() {
        return Array.from((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $154bcf165b6632e7$var$_mutations));
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $9f9f0025923da73f$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $9f9f0025923da73f$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $9f9f0025923da73f$export$8793edee2d425525)))));
    }
};
$154bcf165b6632e7$var$_mutations = new WeakMap();
$154bcf165b6632e7$var$_scopes = new WeakMap();
$154bcf165b6632e7$var$_mutationId = new WeakMap();
function $154bcf165b6632e7$var$scopeFor(mutation) {
    var _a;
    return (_a = mutation.options.scope) == null ? void 0 : _a.id;
}










function $ff75de0927390bf3$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $9f9f0025923da73f$export$83f813cd1f8a4973)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $9f9f0025923da73f$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject(context.signal.reason);
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $9f9f0025923da73f$export$8c6246b73dd61f4a) : (0, $9f9f0025923da73f$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $ff75de0927390bf3$var$getPreviousPageParam : $ff75de0927390bf3$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $ff75de0927390bf3$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $ff75de0927390bf3$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $ff75de0927390bf3$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $ff75de0927390bf3$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $ff75de0927390bf3$var$getNextPageParam(options, data) != null;
}
function $ff75de0927390bf3$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $ff75de0927390bf3$var$getPreviousPageParam(options, data) != null;
}


var $5570f8492452f3c7$var$_queryType, $5570f8492452f3c7$var$_initialState, $5570f8492452f3c7$var$_revertState, $5570f8492452f3c7$var$_cache, $5570f8492452f3c7$var$_client, $5570f8492452f3c7$var$_retryer, $5570f8492452f3c7$var$_defaultOptions, $5570f8492452f3c7$var$_abortSignalConsumed, $5570f8492452f3c7$var$_Query_instances, $5570f8492452f3c7$var$isInitialPausedFetch_fn, $5570f8492452f3c7$var$dispatch_fn;
var $5570f8492452f3c7$export$62297b13309008b2 = class extends (0, $3e6f247ffa858a13$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $5570f8492452f3c7$var$_Query_instances);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $5570f8492452f3c7$var$_queryType);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $5570f8492452f3c7$var$_initialState);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $5570f8492452f3c7$var$_revertState);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $5570f8492452f3c7$var$_cache);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $5570f8492452f3c7$var$_client);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $5570f8492452f3c7$var$_retryer);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $5570f8492452f3c7$var$_defaultOptions);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $5570f8492452f3c7$var$_abortSignalConsumed);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_abortSignalConsumed, false);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_client, config.client);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_cache, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_client).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_initialState, $5570f8492452f3c7$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get queryType() {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_queryType);
    }
    get promise() {
        var _a;
        return (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_defaultOptions),
            ...options
        };
        if (options == null ? void 0 : options._type) (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_queryType, options._type);
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $5570f8492452f3c7$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($5570f8492452f3c7$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_initialState, defaultState);
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $9f9f0025923da73f$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $5570f8492452f3c7$var$_Query_instances, $5570f8492452f3c7$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state) {
        (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $5570f8492452f3c7$var$_Query_instances, $5570f8492452f3c7$var$dispatch_fn).call(this, {
            type: "setState",
            state: state
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $9f9f0025923da73f$export$8793edee2d425525)).catch((0, $9f9f0025923da73f$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    get resetState() {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_initialState);
    }
    reset() {
        this.destroy();
        this.setState(this.resetState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $9f9f0025923da73f$export$d7ee3961208f79c1)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $9f9f0025923da73f$export$1aa5a89531b7670d) || !this.isFetched();
    }
    isFetched() {
        return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $9f9f0025923da73f$export$cb3145f011bda3ac)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $9f9f0025923da73f$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer)) {
                    if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_abortSignalConsumed) || (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $5570f8492452f3c7$var$_Query_instances, $5570f8492452f3c7$var$isInitialPausedFetch_fn).call(this)) (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $5570f8492452f3c7$var$_Query_instances, $5570f8492452f3c7$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        if (this.state.fetchStatus !== "idle" && // If the promise in the retryer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        ((_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer)) == null ? void 0 : _a.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer)) {
                (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer).continueRetry();
                return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $9f9f0025923da73f$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_client),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_client),
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        const behavior = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_queryType) === "infinite" ? (0, $ff75de0927390bf3$export$84470d1367601e8d)(this.options.pages) : this.options.behavior;
        behavior == null || behavior.onFetch(context, this);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $5570f8492452f3c7$var$_Query_instances, $5570f8492452f3c7$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_retryer, (0, $a244555a5f244948$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $a244555a5f244948$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_revertState),
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $5570f8492452f3c7$var$_Query_instances, $5570f8492452f3c7$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $5570f8492452f3c7$var$_Query_instances, $5570f8492452f3c7$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $5570f8492452f3c7$var$_Query_instances, $5570f8492452f3c7$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            const data = await (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer).start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_e = (_d = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_cache).config).onSuccess) == null || _e.call(_d, data, this);
            (_g = (_f = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_cache).config).onSettled) == null || _g.call(_f, data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $a244555a5f244948$export$a8430ed4188f35a9)) {
                if (error.silent) return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_retryer).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $5570f8492452f3c7$var$_Query_instances, $5570f8492452f3c7$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            (_i = (_h = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_cache).config).onError) == null || _i.call(_h, error, this);
            (_k = (_j = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_cache).config).onSettled) == null || _k.call(_j, this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
};
$5570f8492452f3c7$var$_queryType = new WeakMap();
$5570f8492452f3c7$var$_initialState = new WeakMap();
$5570f8492452f3c7$var$_revertState = new WeakMap();
$5570f8492452f3c7$var$_cache = new WeakMap();
$5570f8492452f3c7$var$_client = new WeakMap();
$5570f8492452f3c7$var$_retryer = new WeakMap();
$5570f8492452f3c7$var$_defaultOptions = new WeakMap();
$5570f8492452f3c7$var$_abortSignalConsumed = new WeakMap();
$5570f8492452f3c7$var$_Query_instances = new WeakSet();
$5570f8492452f3c7$var$isInitialPausedFetch_fn = function() {
    return this.state.fetchStatus === "paused" && this.state.status === "pending";
};
$5570f8492452f3c7$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$5570f8492452f3c7$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                const newState = {
                    ...state,
                    ...$5570f8492452f3c7$var$successState(action.data, action.dataUpdatedAt),
                    dataUpdateCount: state.dataUpdateCount + 1,
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
                (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $5570f8492452f3c7$var$_revertState, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error",
                    // flag existing data as invalidated if we get a background error
                    // note that "no data" always means stale so we can set unconditionally here
                    isInvalidated: true
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $5570f8492452f3c7$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $5570f8492452f3c7$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $a244555a5f244948$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $5570f8492452f3c7$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function $5570f8492452f3c7$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $506bf7d9ee50a8df$var$_queries;
var $506bf7d9ee50a8df$export$5dde0cd941da8468 = class extends (0, $fa7f8e88baa31e37$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $506bf7d9ee50a8df$var$_queries);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $506bf7d9ee50a8df$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $9f9f0025923da73f$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $5570f8492452f3c7$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $506bf7d9ee50a8df$var$_queries).has(query.queryHash)) {
            (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $506bf7d9ee50a8df$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $506bf7d9ee50a8df$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $506bf7d9ee50a8df$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $506bf7d9ee50a8df$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $506bf7d9ee50a8df$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $9f9f0025923da73f$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $9f9f0025923da73f$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$506bf7d9ee50a8df$var$_queries = new WeakMap();








var $86b52fa644445c39$var$_queryCache, $86b52fa644445c39$var$_mutationCache, $86b52fa644445c39$var$_defaultOptions, $86b52fa644445c39$var$_queryDefaults, $86b52fa644445c39$var$_mutationDefaults, $86b52fa644445c39$var$_mountCount, $86b52fa644445c39$var$_unsubscribeFocus, $86b52fa644445c39$var$_unsubscribeOnline;
var $86b52fa644445c39$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $86b52fa644445c39$var$_queryCache);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $86b52fa644445c39$var$_mutationCache);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $86b52fa644445c39$var$_defaultOptions);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $86b52fa644445c39$var$_queryDefaults);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $86b52fa644445c39$var$_mutationDefaults);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $86b52fa644445c39$var$_mountCount);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $86b52fa644445c39$var$_unsubscribeFocus);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $86b52fa644445c39$var$_unsubscribeOnline);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $86b52fa644445c39$var$_queryCache, config.queryCache || new (0, $506bf7d9ee50a8df$export$5dde0cd941da8468)());
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $86b52fa644445c39$var$_mutationCache, config.mutationCache || new (0, $154bcf165b6632e7$export$1fcfd9a244434844)());
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $86b52fa644445c39$var$_defaultOptions, config.defaultOptions || {});
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $86b52fa644445c39$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $86b52fa644445c39$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $86b52fa644445c39$var$_mountCount, 0);
    }
    mount() {
        (0, $d6a3b9b6cdd1d7b7$export$b1fe7cbb4502036b)(this, $86b52fa644445c39$var$_mountCount)._++;
        if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_mountCount) !== 1) return;
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $86b52fa644445c39$var$_unsubscribeFocus, (0, $a86282ed95c1f11c$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).onFocus();
            }
        }));
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $86b52fa644445c39$var$_unsubscribeOnline, (0, $7899ca234c848a08$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $d6a3b9b6cdd1d7b7$export$b1fe7cbb4502036b)(this, $86b52fa644445c39$var$_mountCount)._--;
        if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_mountCount) !== 0) return;
        (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $86b52fa644445c39$var$_unsubscribeFocus, void 0);
        (_b = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $86b52fa644445c39$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $9f9f0025923da73f$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $9f9f0025923da73f$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache);
        (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache);
        return (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $9f9f0025923da73f$export$8793edee2d425525)).catch((0, $9f9f0025923da73f$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
            (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters == null ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $9f9f0025923da73f$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $9f9f0025923da73f$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $9f9f0025923da73f$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $9f9f0025923da73f$export$8793edee2d425525)).catch((0, $9f9f0025923da73f$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options._type = "infinite";
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $9f9f0025923da73f$export$8793edee2d425525)).catch((0, $9f9f0025923da73f$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options._type = "infinite";
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $7899ca234c848a08$export$b113e788b2dd3fdc).isOnline()) return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache);
    }
    getMutationCache() {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $86b52fa644445c39$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryDefaults).set((0, $9f9f0025923da73f$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $9f9f0025923da73f$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_mutationDefaults).set((0, $9f9f0025923da73f$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_mutationDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $9f9f0025923da73f$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $9f9f0025923da73f$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $9f9f0025923da73f$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_queryCache).clear();
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $86b52fa644445c39$var$_mutationCache).clear();
    }
};
$86b52fa644445c39$var$_queryCache = new WeakMap();
$86b52fa644445c39$var$_mutationCache = new WeakMap();
$86b52fa644445c39$var$_defaultOptions = new WeakMap();
$86b52fa644445c39$var$_queryDefaults = new WeakMap();
$86b52fa644445c39$var$_mutationDefaults = new WeakMap();
$86b52fa644445c39$var$_mountCount = new WeakMap();
$86b52fa644445c39$var$_unsubscribeFocus = new WeakMap();
$86b52fa644445c39$var$_unsubscribeOnline = new WeakMap();


var $lCzvA = parcelRequire("lCzvA");

"use client";
var $427d8fa9df978c82$export$da112d31b0149f31 = $lCzvA.createContext(void 0);
var $427d8fa9df978c82$export$22e77b9572c4fded = (queryClient)=>{
    const client = $lCzvA.useContext($427d8fa9df978c82$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $427d8fa9df978c82$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $lCzvA.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($427d8fa9df978c82$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};




"use client";
var $3cb117183d17b3f1$export$fd1469cb3147d866 = function() {
    return null;
};
var $3cb117183d17b3f1$export$6d64409a8b475869 = function() {
    return null;
};




var $lCzvA = parcelRequire("lCzvA");

'use strict';
function $3ccc379494ab7e95$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $cc9b6df81a5bcca0$var$toString } = Object.prototype;
const { getPrototypeOf: $cc9b6df81a5bcca0$var$getPrototypeOf } = Object;
const { iterator: $cc9b6df81a5bcca0$var$iterator, toStringTag: $cc9b6df81a5bcca0$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $cc9b6df81a5bcca0$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $cc9b6df81a5bcca0$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($cc9b6df81a5bcca0$var$hasOwnProperty(obj, prop)) return true;
        obj = $cc9b6df81a5bcca0$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $cc9b6df81a5bcca0$var$getSafeProp = (obj, prop)=>obj != null && $cc9b6df81a5bcca0$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $cc9b6df81a5bcca0$var$kindOf = ((cache)=>(thing)=>{
        const str = $cc9b6df81a5bcca0$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $cc9b6df81a5bcca0$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$cc9b6df81a5bcca0$var$kindOf(thing) === type;
};
const $cc9b6df81a5bcca0$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $cc9b6df81a5bcca0$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $cc9b6df81a5bcca0$var$isUndefined = $cc9b6df81a5bcca0$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $cc9b6df81a5bcca0$var$isBuffer(val) {
    return val !== null && !$cc9b6df81a5bcca0$var$isUndefined(val) && val.constructor !== null && !$cc9b6df81a5bcca0$var$isUndefined(val.constructor) && $cc9b6df81a5bcca0$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $cc9b6df81a5bcca0$var$isArrayBuffer = $cc9b6df81a5bcca0$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $cc9b6df81a5bcca0$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $cc9b6df81a5bcca0$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $cc9b6df81a5bcca0$var$isString = $cc9b6df81a5bcca0$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $cc9b6df81a5bcca0$var$isFunction = $cc9b6df81a5bcca0$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $cc9b6df81a5bcca0$var$isNumber = $cc9b6df81a5bcca0$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $cc9b6df81a5bcca0$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $cc9b6df81a5bcca0$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $cc9b6df81a5bcca0$var$isPlainObject = (val)=>{
    if (!$cc9b6df81a5bcca0$var$isObject(val)) return false;
    const prototype = $cc9b6df81a5bcca0$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $cc9b6df81a5bcca0$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$cc9b6df81a5bcca0$var$hasOwnInPrototypeChain(val, $cc9b6df81a5bcca0$var$toStringTag) && !$cc9b6df81a5bcca0$var$hasOwnInPrototypeChain(val, $cc9b6df81a5bcca0$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $cc9b6df81a5bcca0$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$cc9b6df81a5bcca0$var$isObject(val) || $cc9b6df81a5bcca0$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $cc9b6df81a5bcca0$var$isDate = $cc9b6df81a5bcca0$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $cc9b6df81a5bcca0$var$isFile = $cc9b6df81a5bcca0$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $cc9b6df81a5bcca0$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $cc9b6df81a5bcca0$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $cc9b6df81a5bcca0$var$isBlob = $cc9b6df81a5bcca0$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $cc9b6df81a5bcca0$var$isFileList = $cc9b6df81a5bcca0$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $cc9b6df81a5bcca0$var$isStream = (val)=>$cc9b6df81a5bcca0$var$isObject(val) && $cc9b6df81a5bcca0$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $cc9b6df81a5bcca0$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $cc9b6df81a5bcca0$var$G = $cc9b6df81a5bcca0$var$getGlobal();
const $cc9b6df81a5bcca0$var$FormDataCtor = typeof $cc9b6df81a5bcca0$var$G.FormData !== 'undefined' ? $cc9b6df81a5bcca0$var$G.FormData : undefined;
const $cc9b6df81a5bcca0$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($cc9b6df81a5bcca0$var$FormDataCtor && thing instanceof $cc9b6df81a5bcca0$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $cc9b6df81a5bcca0$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$cc9b6df81a5bcca0$var$isFunction(thing.append)) return false;
    const kind = $cc9b6df81a5bcca0$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $cc9b6df81a5bcca0$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $cc9b6df81a5bcca0$var$isURLSearchParams = $cc9b6df81a5bcca0$var$kindOfTest('URLSearchParams');
const [$cc9b6df81a5bcca0$var$isReadableStream, $cc9b6df81a5bcca0$var$isRequest, $cc9b6df81a5bcca0$var$isResponse, $cc9b6df81a5bcca0$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($cc9b6df81a5bcca0$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $cc9b6df81a5bcca0$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $cc9b6df81a5bcca0$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($cc9b6df81a5bcca0$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($cc9b6df81a5bcca0$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $cc9b6df81a5bcca0$var$findKey(obj, key) {
    if ($cc9b6df81a5bcca0$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $cc9b6df81a5bcca0$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $cc9b6df81a5bcca0$var$isContextDefined = (context)=>!$cc9b6df81a5bcca0$var$isUndefined(context) && context !== $cc9b6df81a5bcca0$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $cc9b6df81a5bcca0$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $cc9b6df81a5bcca0$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $cc9b6df81a5bcca0$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $cc9b6df81a5bcca0$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($cc9b6df81a5bcca0$var$isPlainObject(existing) && $cc9b6df81a5bcca0$var$isPlainObject(val)) result[targetKey] = $cc9b6df81a5bcca0$var$merge(existing, val);
        else if ($cc9b6df81a5bcca0$var$isPlainObject(val)) result[targetKey] = $cc9b6df81a5bcca0$var$merge({}, val);
        else if ($cc9b6df81a5bcca0$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$cc9b6df81a5bcca0$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $cc9b6df81a5bcca0$var$isBuffer(source)) continue;
        $cc9b6df81a5bcca0$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $cc9b6df81a5bcca0$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($cc9b6df81a5bcca0$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $cc9b6df81a5bcca0$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $cc9b6df81a5bcca0$var$forEach(b, (val, key)=>{
        if (thisArg && $cc9b6df81a5bcca0$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $3ccc379494ab7e95$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $cc9b6df81a5bcca0$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $cc9b6df81a5bcca0$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $cc9b6df81a5bcca0$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $cc9b6df81a5bcca0$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $cc9b6df81a5bcca0$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $cc9b6df81a5bcca0$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($cc9b6df81a5bcca0$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$cc9b6df81a5bcca0$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $cc9b6df81a5bcca0$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $cc9b6df81a5bcca0$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $cc9b6df81a5bcca0$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$cc9b6df81a5bcca0$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $cc9b6df81a5bcca0$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $cc9b6df81a5bcca0$var$isHTMLForm = $cc9b6df81a5bcca0$var$kindOfTest('HTMLFormElement');
const $cc9b6df81a5bcca0$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $cc9b6df81a5bcca0$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $cc9b6df81a5bcca0$var$isRegExp = $cc9b6df81a5bcca0$var$kindOfTest('RegExp');
const $cc9b6df81a5bcca0$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $cc9b6df81a5bcca0$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $cc9b6df81a5bcca0$var$freezeMethods = (obj)=>{
    $cc9b6df81a5bcca0$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($cc9b6df81a5bcca0$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$cc9b6df81a5bcca0$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $cc9b6df81a5bcca0$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $cc9b6df81a5bcca0$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $cc9b6df81a5bcca0$var$noop = ()=>{};
const $cc9b6df81a5bcca0$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $cc9b6df81a5bcca0$var$isSpecCompliantForm(thing) {
    return !!(thing && $cc9b6df81a5bcca0$var$isFunction(thing.append) && thing[$cc9b6df81a5bcca0$var$toStringTag] === 'FormData' && thing[$cc9b6df81a5bcca0$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $cc9b6df81a5bcca0$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($cc9b6df81a5bcca0$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($cc9b6df81a5bcca0$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $cc9b6df81a5bcca0$var$isArray(source) ? [] : {};
                $cc9b6df81a5bcca0$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$cc9b6df81a5bcca0$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $cc9b6df81a5bcca0$var$isAsyncFn = $cc9b6df81a5bcca0$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $cc9b6df81a5bcca0$var$isThenable = (thing)=>thing && ($cc9b6df81a5bcca0$var$isObject(thing) || $cc9b6df81a5bcca0$var$isFunction(thing)) && $cc9b6df81a5bcca0$var$isFunction(thing.then) && $cc9b6df81a5bcca0$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $cc9b6df81a5bcca0$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $cc9b6df81a5bcca0$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $cc9b6df81a5bcca0$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $cc9b6df81a5bcca0$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $cc9b6df81a5bcca0$var$isFunction($cc9b6df81a5bcca0$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $cc9b6df81a5bcca0$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($cc9b6df81a5bcca0$var$_global) : $cc9b6df81a5bcca0$var$_setImmediate;
// *********************
const $cc9b6df81a5bcca0$var$isIterable = (thing)=>thing != null && $cc9b6df81a5bcca0$var$isFunction(thing[$cc9b6df81a5bcca0$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $cc9b6df81a5bcca0$var$isSafeIterable = (thing)=>thing != null && $cc9b6df81a5bcca0$var$hasOwnInPrototypeChain(thing, $cc9b6df81a5bcca0$var$iterator) && $cc9b6df81a5bcca0$var$isIterable(thing);
var $cc9b6df81a5bcca0$export$2e2bcd8739ae039 = {
    isArray: $cc9b6df81a5bcca0$var$isArray,
    isArrayBuffer: $cc9b6df81a5bcca0$var$isArrayBuffer,
    isBuffer: $cc9b6df81a5bcca0$var$isBuffer,
    isFormData: $cc9b6df81a5bcca0$var$isFormData,
    isArrayBufferView: $cc9b6df81a5bcca0$var$isArrayBufferView,
    isString: $cc9b6df81a5bcca0$var$isString,
    isNumber: $cc9b6df81a5bcca0$var$isNumber,
    isBoolean: $cc9b6df81a5bcca0$var$isBoolean,
    isObject: $cc9b6df81a5bcca0$var$isObject,
    isPlainObject: $cc9b6df81a5bcca0$var$isPlainObject,
    isEmptyObject: $cc9b6df81a5bcca0$var$isEmptyObject,
    isReadableStream: $cc9b6df81a5bcca0$var$isReadableStream,
    isRequest: $cc9b6df81a5bcca0$var$isRequest,
    isResponse: $cc9b6df81a5bcca0$var$isResponse,
    isHeaders: $cc9b6df81a5bcca0$var$isHeaders,
    isUndefined: $cc9b6df81a5bcca0$var$isUndefined,
    isDate: $cc9b6df81a5bcca0$var$isDate,
    isFile: $cc9b6df81a5bcca0$var$isFile,
    isReactNativeBlob: $cc9b6df81a5bcca0$var$isReactNativeBlob,
    isReactNative: $cc9b6df81a5bcca0$var$isReactNative,
    isBlob: $cc9b6df81a5bcca0$var$isBlob,
    isRegExp: $cc9b6df81a5bcca0$var$isRegExp,
    isFunction: $cc9b6df81a5bcca0$var$isFunction,
    isStream: $cc9b6df81a5bcca0$var$isStream,
    isURLSearchParams: $cc9b6df81a5bcca0$var$isURLSearchParams,
    isTypedArray: $cc9b6df81a5bcca0$var$isTypedArray,
    isFileList: $cc9b6df81a5bcca0$var$isFileList,
    forEach: $cc9b6df81a5bcca0$var$forEach,
    merge: $cc9b6df81a5bcca0$var$merge,
    extend: $cc9b6df81a5bcca0$var$extend,
    trim: $cc9b6df81a5bcca0$var$trim,
    stripBOM: $cc9b6df81a5bcca0$var$stripBOM,
    inherits: $cc9b6df81a5bcca0$var$inherits,
    toFlatObject: $cc9b6df81a5bcca0$var$toFlatObject,
    kindOf: $cc9b6df81a5bcca0$var$kindOf,
    kindOfTest: $cc9b6df81a5bcca0$var$kindOfTest,
    endsWith: $cc9b6df81a5bcca0$var$endsWith,
    toArray: $cc9b6df81a5bcca0$var$toArray,
    forEachEntry: $cc9b6df81a5bcca0$var$forEachEntry,
    matchAll: $cc9b6df81a5bcca0$var$matchAll,
    isHTMLForm: $cc9b6df81a5bcca0$var$isHTMLForm,
    hasOwnProperty: $cc9b6df81a5bcca0$var$hasOwnProperty,
    hasOwnProp: $cc9b6df81a5bcca0$var$hasOwnProperty,
    hasOwnInPrototypeChain: $cc9b6df81a5bcca0$var$hasOwnInPrototypeChain,
    getSafeProp: $cc9b6df81a5bcca0$var$getSafeProp,
    reduceDescriptors: $cc9b6df81a5bcca0$var$reduceDescriptors,
    freezeMethods: $cc9b6df81a5bcca0$var$freezeMethods,
    toObjectSet: $cc9b6df81a5bcca0$var$toObjectSet,
    toCamelCase: $cc9b6df81a5bcca0$var$toCamelCase,
    noop: $cc9b6df81a5bcca0$var$noop,
    toFiniteNumber: $cc9b6df81a5bcca0$var$toFiniteNumber,
    findKey: $cc9b6df81a5bcca0$var$findKey,
    global: $cc9b6df81a5bcca0$var$_global,
    isContextDefined: $cc9b6df81a5bcca0$var$isContextDefined,
    isSpecCompliantForm: $cc9b6df81a5bcca0$var$isSpecCompliantForm,
    toJSONObject: $cc9b6df81a5bcca0$var$toJSONObject,
    isAsyncFn: $cc9b6df81a5bcca0$var$isAsyncFn,
    isThenable: $cc9b6df81a5bcca0$var$isThenable,
    setImmediate: $cc9b6df81a5bcca0$var$_setImmediate,
    asap: $cc9b6df81a5bcca0$var$asap,
    isIterable: $cc9b6df81a5bcca0$var$isIterable,
    isSafeIterable: $cc9b6df81a5bcca0$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $7dba6bd413000088$var$ignoreDuplicateOf = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $7dba6bd413000088$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $7dba6bd413000088$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $48c52709e59c85c1$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $48c52709e59c85c1$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $48c52709e59c85c1$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $48c52709e59c85c1$var$sanitizeValue(value, invalidChars) {
    if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$48c52709e59c85c1$var$sanitizeValue(item, invalidChars));
    return $48c52709e59c85c1$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $48c52709e59c85c1$export$9e344cffce061a22 = (value)=>$48c52709e59c85c1$var$sanitizeValue(value, $48c52709e59c85c1$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $48c52709e59c85c1$export$59dd66c2a12d8f62 = (value)=>$48c52709e59c85c1$var$sanitizeValue(value, $48c52709e59c85c1$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $48c52709e59c85c1$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $48c52709e59c85c1$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $7ecbbd2104c556ea$var$$internals = Symbol('internals');
function $7ecbbd2104c556ea$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $7ecbbd2104c556ea$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(value) ? value.map($7ecbbd2104c556ea$var$normalizeValue) : (0, $48c52709e59c85c1$export$9e344cffce061a22)(String(value));
}
function $7ecbbd2104c556ea$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $7ecbbd2104c556ea$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $7ecbbd2104c556ea$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $7ecbbd2104c556ea$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $7ecbbd2104c556ea$var$buildAccessors(obj, header) {
    const accessorName = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $7ecbbd2104c556ea$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $7ecbbd2104c556ea$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $7ecbbd2104c556ea$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$7ecbbd2104c556ea$var$isValidHeaderName(header)) setHeaders((0, $7dba6bd413000088$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isObject(header) && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $7ecbbd2104c556ea$var$normalizeHeader(header);
        if (header) {
            const key = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $7ecbbd2104c556ea$var$parseTokens(value);
                if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $7ecbbd2104c556ea$var$normalizeHeader(header);
        if (header) {
            const key = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $7ecbbd2104c556ea$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $7ecbbd2104c556ea$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $7ecbbd2104c556ea$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $7ecbbd2104c556ea$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $7ecbbd2104c556ea$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $7ecbbd2104c556ea$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $7ecbbd2104c556ea$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$7ecbbd2104c556ea$var$$internals] = this[$7ecbbd2104c556ea$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $7ecbbd2104c556ea$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $7ecbbd2104c556ea$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$7ecbbd2104c556ea$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).reduceDescriptors($7ecbbd2104c556ea$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).freezeMethods($7ecbbd2104c556ea$var$AxiosHeaders);
var $7ecbbd2104c556ea$export$2e2bcd8739ae039 = $7ecbbd2104c556ea$var$AxiosHeaders;


'use strict';
const $f2d810dca70b8250$var$REDACTED = '[REDACTED ****]';
function $f2d810dca70b8250$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $f2d810dca70b8250$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isPlainObject(source) && $f2d810dca70b8250$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $f2d810dca70b8250$var$REDACTED : visit(value);
                if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $f2d810dca70b8250$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $f2d810dca70b8250$var$AxiosError(error.message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $f2d810dca70b8250$var$redactConfig(config, redactKeys) : (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$f2d810dca70b8250$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$f2d810dca70b8250$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$f2d810dca70b8250$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$f2d810dca70b8250$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$f2d810dca70b8250$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$f2d810dca70b8250$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$f2d810dca70b8250$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$f2d810dca70b8250$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$f2d810dca70b8250$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$f2d810dca70b8250$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$f2d810dca70b8250$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$f2d810dca70b8250$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$f2d810dca70b8250$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$f2d810dca70b8250$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $f2d810dca70b8250$export$2e2bcd8739ae039 = $f2d810dca70b8250$var$AxiosError;


// eslint-disable-next-line strict
var $d8e16a456141c1a9$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $ff73c632120015f2$export$a143d493d941bafc;
var $ff73c632120015f2$export$e4cf37d7f6fb9e0a;
var $ff73c632120015f2$export$f99ded8fe4b79145;
var $ff73c632120015f2$export$599f31c3813fae4d;
'use strict';
var $5affb3b615aee99e$export$a48f0734ac7c2329;
var $5affb3b615aee99e$export$d622b2ad8d90c771;
var $5affb3b615aee99e$export$6100ba28696e12de;
'use strict';
$5affb3b615aee99e$export$a48f0734ac7c2329 = $5affb3b615aee99e$var$byteLength;
$5affb3b615aee99e$export$d622b2ad8d90c771 = $5affb3b615aee99e$var$toByteArray;
$5affb3b615aee99e$export$6100ba28696e12de = $5affb3b615aee99e$var$fromByteArray;
var $5affb3b615aee99e$var$lookup = [];
var $5affb3b615aee99e$var$revLookup = [];
var $5affb3b615aee99e$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $5affb3b615aee99e$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $5affb3b615aee99e$var$i = 0, $5affb3b615aee99e$var$len = $5affb3b615aee99e$var$code.length; $5affb3b615aee99e$var$i < $5affb3b615aee99e$var$len; ++$5affb3b615aee99e$var$i){
    $5affb3b615aee99e$var$lookup[$5affb3b615aee99e$var$i] = $5affb3b615aee99e$var$code[$5affb3b615aee99e$var$i];
    $5affb3b615aee99e$var$revLookup[$5affb3b615aee99e$var$code.charCodeAt($5affb3b615aee99e$var$i)] = $5affb3b615aee99e$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5affb3b615aee99e$var$revLookup['-'.charCodeAt(0)] = 62;
$5affb3b615aee99e$var$revLookup['_'.charCodeAt(0)] = 63;
function $5affb3b615aee99e$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5affb3b615aee99e$var$byteLength(b64) {
    var lens = $5affb3b615aee99e$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5affb3b615aee99e$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5affb3b615aee99e$var$toByteArray(b64) {
    var tmp;
    var lens = $5affb3b615aee99e$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5affb3b615aee99e$var$Arr($5affb3b615aee99e$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5affb3b615aee99e$var$revLookup[b64.charCodeAt(i)] << 18 | $5affb3b615aee99e$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5affb3b615aee99e$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5affb3b615aee99e$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5affb3b615aee99e$var$revLookup[b64.charCodeAt(i)] << 2 | $5affb3b615aee99e$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5affb3b615aee99e$var$revLookup[b64.charCodeAt(i)] << 10 | $5affb3b615aee99e$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5affb3b615aee99e$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5affb3b615aee99e$var$tripletToBase64(num) {
    return $5affb3b615aee99e$var$lookup[num >> 18 & 0x3F] + $5affb3b615aee99e$var$lookup[num >> 12 & 0x3F] + $5affb3b615aee99e$var$lookup[num >> 6 & 0x3F] + $5affb3b615aee99e$var$lookup[num & 0x3F];
}
function $5affb3b615aee99e$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5affb3b615aee99e$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $5affb3b615aee99e$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5affb3b615aee99e$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5affb3b615aee99e$var$lookup[tmp >> 2] + $5affb3b615aee99e$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5affb3b615aee99e$var$lookup[tmp >> 10] + $5affb3b615aee99e$var$lookup[tmp >> 4 & 0x3F] + $5affb3b615aee99e$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $74866ed2048d47b8$export$aafa59e2e03f2942;
var $74866ed2048d47b8$export$68d8715fc104d294;
$74866ed2048d47b8$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$74866ed2048d47b8$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $ff73c632120015f2$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$ff73c632120015f2$export$a143d493d941bafc = $ff73c632120015f2$var$Buffer;
$ff73c632120015f2$export$e4cf37d7f6fb9e0a = $ff73c632120015f2$var$SlowBuffer;
$ff73c632120015f2$export$f99ded8fe4b79145 = 50;
const $ff73c632120015f2$var$K_MAX_LENGTH = 0x7fffffff;
$ff73c632120015f2$export$599f31c3813fae4d = $ff73c632120015f2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $ff73c632120015f2$var$Buffer.TYPED_ARRAY_SUPPORT = $ff73c632120015f2$var$typedArraySupport();
if (!$ff73c632120015f2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $ff73c632120015f2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($ff73c632120015f2$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$ff73c632120015f2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($ff73c632120015f2$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$ff73c632120015f2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $ff73c632120015f2$var$createBuffer(length) {
    if (length > $ff73c632120015f2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $ff73c632120015f2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $ff73c632120015f2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $ff73c632120015f2$var$allocUnsafe(arg);
    }
    return $ff73c632120015f2$var$from(arg, encodingOrOffset, length);
}
$ff73c632120015f2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $ff73c632120015f2$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $ff73c632120015f2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $ff73c632120015f2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($ff73c632120015f2$var$isInstance(value, ArrayBuffer) || value && $ff73c632120015f2$var$isInstance(value.buffer, ArrayBuffer)) return $ff73c632120015f2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($ff73c632120015f2$var$isInstance(value, SharedArrayBuffer) || value && $ff73c632120015f2$var$isInstance(value.buffer, SharedArrayBuffer))) return $ff73c632120015f2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $ff73c632120015f2$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $ff73c632120015f2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $ff73c632120015f2$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $ff73c632120015f2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $ff73c632120015f2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($ff73c632120015f2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($ff73c632120015f2$var$Buffer, Uint8Array);
function $ff73c632120015f2$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $ff73c632120015f2$var$alloc(size, fill, encoding) {
    $ff73c632120015f2$var$assertSize(size);
    if (size <= 0) return $ff73c632120015f2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $ff73c632120015f2$var$createBuffer(size).fill(fill, encoding) : $ff73c632120015f2$var$createBuffer(size).fill(fill);
    return $ff73c632120015f2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $ff73c632120015f2$var$Buffer.alloc = function(size, fill, encoding) {
    return $ff73c632120015f2$var$alloc(size, fill, encoding);
};
function $ff73c632120015f2$var$allocUnsafe(size) {
    $ff73c632120015f2$var$assertSize(size);
    return $ff73c632120015f2$var$createBuffer(size < 0 ? 0 : $ff73c632120015f2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $ff73c632120015f2$var$Buffer.allocUnsafe = function(size) {
    return $ff73c632120015f2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $ff73c632120015f2$var$Buffer.allocUnsafeSlow = function(size) {
    return $ff73c632120015f2$var$allocUnsafe(size);
};
function $ff73c632120015f2$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$ff73c632120015f2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $ff73c632120015f2$var$byteLength(string, encoding) | 0;
    let buf = $ff73c632120015f2$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $ff73c632120015f2$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $ff73c632120015f2$var$checked(array.length) | 0;
    const buf = $ff73c632120015f2$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $ff73c632120015f2$var$fromArrayView(arrayView) {
    if ($ff73c632120015f2$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $ff73c632120015f2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $ff73c632120015f2$var$fromArrayLike(arrayView);
}
function $ff73c632120015f2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $ff73c632120015f2$var$Buffer.prototype);
    return buf;
}
function $ff73c632120015f2$var$fromObject(obj) {
    if ($ff73c632120015f2$var$Buffer.isBuffer(obj)) {
        const len = $ff73c632120015f2$var$checked(obj.length) | 0;
        const buf = $ff73c632120015f2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $ff73c632120015f2$var$numberIsNaN(obj.length)) return $ff73c632120015f2$var$createBuffer(0);
        return $ff73c632120015f2$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $ff73c632120015f2$var$fromArrayLike(obj.data);
}
function $ff73c632120015f2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $ff73c632120015f2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $ff73c632120015f2$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $ff73c632120015f2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $ff73c632120015f2$var$Buffer.alloc(+length);
}
$ff73c632120015f2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $ff73c632120015f2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$ff73c632120015f2$var$Buffer.compare = function compare(a, b) {
    if ($ff73c632120015f2$var$isInstance(a, Uint8Array)) a = $ff73c632120015f2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($ff73c632120015f2$var$isInstance(b, Uint8Array)) b = $ff73c632120015f2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$ff73c632120015f2$var$Buffer.isBuffer(a) || !$ff73c632120015f2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$ff73c632120015f2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$ff73c632120015f2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $ff73c632120015f2$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $ff73c632120015f2$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($ff73c632120015f2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$ff73c632120015f2$var$Buffer.isBuffer(buf)) buf = $ff73c632120015f2$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$ff73c632120015f2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $ff73c632120015f2$var$byteLength(string, encoding) {
    if ($ff73c632120015f2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $ff73c632120015f2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $ff73c632120015f2$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $ff73c632120015f2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $ff73c632120015f2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$ff73c632120015f2$var$Buffer.byteLength = $ff73c632120015f2$var$byteLength;
function $ff73c632120015f2$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $ff73c632120015f2$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $ff73c632120015f2$var$utf8Slice(this, start, end);
        case 'ascii':
            return $ff73c632120015f2$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $ff73c632120015f2$var$latin1Slice(this, start, end);
        case 'base64':
            return $ff73c632120015f2$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ff73c632120015f2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$ff73c632120015f2$var$Buffer.prototype._isBuffer = true;
function $ff73c632120015f2$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$ff73c632120015f2$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$ff73c632120015f2$var$swap(this, i, i + 1);
    return this;
};
$ff73c632120015f2$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $ff73c632120015f2$var$swap(this, i, i + 3);
        $ff73c632120015f2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$ff73c632120015f2$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $ff73c632120015f2$var$swap(this, i, i + 7);
        $ff73c632120015f2$var$swap(this, i + 1, i + 6);
        $ff73c632120015f2$var$swap(this, i + 2, i + 5);
        $ff73c632120015f2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$ff73c632120015f2$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $ff73c632120015f2$var$utf8Slice(this, 0, length);
    return $ff73c632120015f2$var$slowToString.apply(this, arguments);
};
$ff73c632120015f2$var$Buffer.prototype.toLocaleString = $ff73c632120015f2$var$Buffer.prototype.toString;
$ff73c632120015f2$var$Buffer.prototype.equals = function equals(b) {
    if (!$ff73c632120015f2$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $ff73c632120015f2$var$Buffer.compare(this, b) === 0;
};
$ff73c632120015f2$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $ff73c632120015f2$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($ff73c632120015f2$var$customInspectSymbol) $ff73c632120015f2$var$Buffer.prototype[$ff73c632120015f2$var$customInspectSymbol] = $ff73c632120015f2$var$Buffer.prototype.inspect;
$ff73c632120015f2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($ff73c632120015f2$var$isInstance(target, Uint8Array)) target = $ff73c632120015f2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$ff73c632120015f2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $ff73c632120015f2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($ff73c632120015f2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $ff73c632120015f2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($ff73c632120015f2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $ff73c632120015f2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $ff73c632120015f2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $ff73c632120015f2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$ff73c632120015f2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$ff73c632120015f2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $ff73c632120015f2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$ff73c632120015f2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $ff73c632120015f2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $ff73c632120015f2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($ff73c632120015f2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $ff73c632120015f2$var$utf8Write(buf, string, offset, length) {
    return $ff73c632120015f2$var$blitBuffer($ff73c632120015f2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $ff73c632120015f2$var$asciiWrite(buf, string, offset, length) {
    return $ff73c632120015f2$var$blitBuffer($ff73c632120015f2$var$asciiToBytes(string), buf, offset, length);
}
function $ff73c632120015f2$var$base64Write(buf, string, offset, length) {
    return $ff73c632120015f2$var$blitBuffer($ff73c632120015f2$var$base64ToBytes(string), buf, offset, length);
}
function $ff73c632120015f2$var$ucs2Write(buf, string, offset, length) {
    return $ff73c632120015f2$var$blitBuffer($ff73c632120015f2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$ff73c632120015f2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $ff73c632120015f2$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $ff73c632120015f2$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $ff73c632120015f2$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $ff73c632120015f2$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ff73c632120015f2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$ff73c632120015f2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $ff73c632120015f2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5affb3b615aee99e$export$6100ba28696e12de(buf);
    else return $5affb3b615aee99e$export$6100ba28696e12de(buf.slice(start, end));
}
function $ff73c632120015f2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $ff73c632120015f2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $ff73c632120015f2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $ff73c632120015f2$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $ff73c632120015f2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $ff73c632120015f2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $ff73c632120015f2$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $ff73c632120015f2$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $ff73c632120015f2$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $ff73c632120015f2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $ff73c632120015f2$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$ff73c632120015f2$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $ff73c632120015f2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $ff73c632120015f2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$ff73c632120015f2$var$Buffer.prototype.readUintLE = $ff73c632120015f2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$ff73c632120015f2$var$Buffer.prototype.readUintBE = $ff73c632120015f2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$ff73c632120015f2$var$Buffer.prototype.readUint8 = $ff73c632120015f2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$ff73c632120015f2$var$Buffer.prototype.readUint16LE = $ff73c632120015f2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$ff73c632120015f2$var$Buffer.prototype.readUint16BE = $ff73c632120015f2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$ff73c632120015f2$var$Buffer.prototype.readUint32LE = $ff73c632120015f2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$ff73c632120015f2$var$Buffer.prototype.readUint32BE = $ff73c632120015f2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$ff73c632120015f2$var$Buffer.prototype.readBigUInt64LE = $ff73c632120015f2$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $ff73c632120015f2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ff73c632120015f2$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$ff73c632120015f2$var$Buffer.prototype.readBigUInt64BE = $ff73c632120015f2$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $ff73c632120015f2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ff73c632120015f2$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$ff73c632120015f2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ff73c632120015f2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ff73c632120015f2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$ff73c632120015f2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ff73c632120015f2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ff73c632120015f2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$ff73c632120015f2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$ff73c632120015f2$var$Buffer.prototype.readBigInt64LE = $ff73c632120015f2$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $ff73c632120015f2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ff73c632120015f2$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$ff73c632120015f2$var$Buffer.prototype.readBigInt64BE = $ff73c632120015f2$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $ff73c632120015f2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ff73c632120015f2$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$ff73c632120015f2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 4, this.length);
    return $74866ed2048d47b8$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$ff73c632120015f2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 4, this.length);
    return $74866ed2048d47b8$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$ff73c632120015f2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 8, this.length);
    return $74866ed2048d47b8$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$ff73c632120015f2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkOffset(offset, 8, this.length);
    return $74866ed2048d47b8$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $ff73c632120015f2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$ff73c632120015f2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$ff73c632120015f2$var$Buffer.prototype.writeUintLE = $ff73c632120015f2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ff73c632120015f2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ff73c632120015f2$var$Buffer.prototype.writeUintBE = $ff73c632120015f2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ff73c632120015f2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ff73c632120015f2$var$Buffer.prototype.writeUint8 = $ff73c632120015f2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$ff73c632120015f2$var$Buffer.prototype.writeUint16LE = $ff73c632120015f2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ff73c632120015f2$var$Buffer.prototype.writeUint16BE = $ff73c632120015f2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ff73c632120015f2$var$Buffer.prototype.writeUint32LE = $ff73c632120015f2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$ff73c632120015f2$var$Buffer.prototype.writeUint32BE = $ff73c632120015f2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $ff73c632120015f2$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $ff73c632120015f2$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $ff73c632120015f2$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $ff73c632120015f2$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$ff73c632120015f2$var$Buffer.prototype.writeBigUInt64LE = $ff73c632120015f2$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $ff73c632120015f2$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ff73c632120015f2$var$Buffer.prototype.writeBigUInt64BE = $ff73c632120015f2$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $ff73c632120015f2$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ff73c632120015f2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ff73c632120015f2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ff73c632120015f2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ff73c632120015f2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ff73c632120015f2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$ff73c632120015f2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ff73c632120015f2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ff73c632120015f2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$ff73c632120015f2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$ff73c632120015f2$var$Buffer.prototype.writeBigInt64LE = $ff73c632120015f2$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $ff73c632120015f2$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$ff73c632120015f2$var$Buffer.prototype.writeBigInt64BE = $ff73c632120015f2$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $ff73c632120015f2$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $ff73c632120015f2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $ff73c632120015f2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $74866ed2048d47b8$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$ff73c632120015f2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $ff73c632120015f2$var$writeFloat(this, value, offset, true, noAssert);
};
$ff73c632120015f2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $ff73c632120015f2$var$writeFloat(this, value, offset, false, noAssert);
};
function $ff73c632120015f2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ff73c632120015f2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $74866ed2048d47b8$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$ff73c632120015f2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $ff73c632120015f2$var$writeDouble(this, value, offset, true, noAssert);
};
$ff73c632120015f2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $ff73c632120015f2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$ff73c632120015f2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$ff73c632120015f2$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$ff73c632120015f2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$ff73c632120015f2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $ff73c632120015f2$var$Buffer.isBuffer(val) ? val : $ff73c632120015f2$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $ff73c632120015f2$var$errors = {};
function $ff73c632120015f2$var$E(sym, getMessage, Base) {
    $ff73c632120015f2$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$ff73c632120015f2$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$ff73c632120015f2$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$ff73c632120015f2$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $ff73c632120015f2$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $ff73c632120015f2$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $ff73c632120015f2$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $ff73c632120015f2$var$checkBounds(buf, offset, byteLength) {
    $ff73c632120015f2$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $ff73c632120015f2$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $ff73c632120015f2$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $ff73c632120015f2$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $ff73c632120015f2$var$checkBounds(buf, offset, byteLength);
}
function $ff73c632120015f2$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $ff73c632120015f2$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $ff73c632120015f2$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $ff73c632120015f2$var$validateNumber(value, type);
        throw new $ff73c632120015f2$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $ff73c632120015f2$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $ff73c632120015f2$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $ff73c632120015f2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $ff73c632120015f2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($ff73c632120015f2$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $ff73c632120015f2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $ff73c632120015f2$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $ff73c632120015f2$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $ff73c632120015f2$var$base64ToBytes(str) {
    return $5affb3b615aee99e$export$d622b2ad8d90c771($ff73c632120015f2$var$base64clean(str));
}
function $ff73c632120015f2$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $ff73c632120015f2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $ff73c632120015f2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $ff73c632120015f2$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $ff73c632120015f2$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $ff73c632120015f2$var$BufferBigIntNotDefined : fn;
}
function $ff73c632120015f2$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $a81f0df205d0963c$require$Buffer = $ff73c632120015f2$export$a143d493d941bafc;
'use strict';
const $a81f0df205d0963c$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $a81f0df205d0963c$var$isVisitable(thing) {
    return (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $a81f0df205d0963c$var$removeBrackets(key) {
    return (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $a81f0df205d0963c$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $a81f0df205d0963c$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $a81f0df205d0963c$var$isFlatArray(arr) {
    return (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(arr) && !arr.some($a81f0df205d0963c$var$isVisitable);
}
const $a81f0df205d0963c$var$predicates = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).toFlatObject((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $a81f0df205d0963c$var$toFormData(obj, formData, options) {
    if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $d8e16a456141c1a9$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? $a81f0df205d0963c$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if (typeof $a81f0df205d0963c$require$Buffer !== 'undefined') return $a81f0df205d0963c$require$Buffer.from(value);
            throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isReactNative(formData) && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($a81f0df205d0963c$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(value) && $a81f0df205d0963c$var$isFlatArray(value) || ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFileList(value) || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $a81f0df205d0963c$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $a81f0df205d0963c$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($a81f0df205d0963c$var$isVisitable(value)) return true;
        formData.append($a81f0df205d0963c$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($a81f0df205d0963c$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $a81f0df205d0963c$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $a81f0df205d0963c$export$2e2bcd8739ae039 = $a81f0df205d0963c$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $66e0818006c8c018$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $66e0818006c8c018$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $a81f0df205d0963c$export$2e2bcd8739ae039)(params, this, options);
}
const $66e0818006c8c018$var$prototype = $66e0818006c8c018$var$AxiosURLSearchParams.prototype;
$66e0818006c8c018$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$66e0818006c8c018$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $66e0818006c8c018$var$encode) : $66e0818006c8c018$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $66e0818006c8c018$export$2e2bcd8739ae039 = $66e0818006c8c018$var$AxiosURLSearchParams;


'use strict';
function $1c478eae0a112daf$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $1c478eae0a112daf$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $1c478eae0a112daf$export$c564cdbbe6da493;
    const serializeFn = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $66e0818006c8c018$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $24d9cc54f1904614$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $24d9cc54f1904614$export$2e2bcd8739ae039 = $24d9cc54f1904614$var$InterceptorManager;





'use strict';
var $23c030dd1e0e01c4$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $7911019f87ec8ce5$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $66e0818006c8c018$export$2e2bcd8739ae039);


'use strict';
var $a3d0c61ba03aeb9a$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $a28bfa5eb97c438f$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $20fd75e12301b2a5$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $7911019f87ec8ce5$export$2e2bcd8739ae039,
        FormData: $a3d0c61ba03aeb9a$export$2e2bcd8739ae039,
        Blob: $a28bfa5eb97c438f$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $c39ca4772efc7447$exports = {};

$parcel$export($c39ca4772efc7447$exports, "hasBrowserEnv", function () { return $c39ca4772efc7447$export$c4996c4b7b93b0bf; });
$parcel$export($c39ca4772efc7447$exports, "navigator", function () { return $c39ca4772efc7447$export$ec7c8efa7f5790ae; });
$parcel$export($c39ca4772efc7447$exports, "hasStandardBrowserEnv", function () { return $c39ca4772efc7447$export$c0bcc9250309d66; });
$parcel$export($c39ca4772efc7447$exports, "hasStandardBrowserWebWorkerEnv", function () { return $c39ca4772efc7447$export$c81692cf5af97dac; });
$parcel$export($c39ca4772efc7447$exports, "origin", function () { return $c39ca4772efc7447$export$f710a83a91838a36; });
const $c39ca4772efc7447$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $c39ca4772efc7447$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $c39ca4772efc7447$export$c0bcc9250309d66 = $c39ca4772efc7447$export$c4996c4b7b93b0bf && (!$c39ca4772efc7447$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($c39ca4772efc7447$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $c39ca4772efc7447$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $c39ca4772efc7447$export$f710a83a91838a36 = $c39ca4772efc7447$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $07b3a3ba1e154988$export$2e2bcd8739ae039 = {
    ...$c39ca4772efc7447$exports,
    ...(0, $20fd75e12301b2a5$export$2e2bcd8739ae039)
};


'use strict';
function $790ed3fac4d9cd52$export$2e2bcd8739ae039(data, options) {
    return (0, $a81f0df205d0963c$export$2e2bcd8739ae039)(data, new (0, $07b3a3ba1e154988$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $07b3a3ba1e154988$export$2e2bcd8739ae039).isNode && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $f716fc7d78e49037$var$MAX_DEPTH = (0, $a81f0df205d0963c$export$659081b45d03227d);
function $f716fc7d78e49037$var$throwIfDepthExceeded(index) {
    if (index > $f716fc7d78e49037$var$MAX_DEPTH) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $f716fc7d78e49037$var$MAX_DEPTH, (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $f716fc7d78e49037$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    const path = [];
    const pattern = /\w+|\[(\w*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $f716fc7d78e49037$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $f716fc7d78e49037$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $f716fc7d78e49037$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $f716fc7d78e49037$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $f716fc7d78e49037$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFormData(formData) && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($f716fc7d78e49037$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $f716fc7d78e49037$export$2e2bcd8739ae039 = $f716fc7d78e49037$var$formDataToJSON;


'use strict';
const $c47c3de1de7d9d20$var$own = (obj, key)=>obj != null && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $c47c3de1de7d9d20$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $c47c3de1de7d9d20$var$defaults = {
    transitional: (0, $23c030dd1e0e01c4$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $f716fc7d78e49037$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isBuffer(data) || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isStream(data) || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFile(data) || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isBlob(data) || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $c47c3de1de7d9d20$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $790ed3fac4d9cd52$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $c47c3de1de7d9d20$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $a81f0df205d0963c$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $c47c3de1de7d9d20$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $c47c3de1de7d9d20$var$own(this, 'transitional') || $c47c3de1de7d9d20$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $c47c3de1de7d9d20$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isResponse(data) || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $c47c3de1de7d9d20$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $f2d810dca70b8250$export$2e2bcd8739ae039).from(e, (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $c47c3de1de7d9d20$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $07b3a3ba1e154988$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $07b3a3ba1e154988$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $c47c3de1de7d9d20$var$defaults.headers[method] = {};
});
var $c47c3de1de7d9d20$export$2e2bcd8739ae039 = $c47c3de1de7d9d20$var$defaults;



'use strict';
function $2655262722674cb9$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $c47c3de1de7d9d20$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $69db484605351264$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $c984cca974fcbf53$var$CanceledError extends (0, $f2d810dca70b8250$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $c984cca974fcbf53$export$2e2bcd8739ae039 = $c984cca974fcbf53$var$CanceledError;







'use strict';
function $273fea214edee96c$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $c9ea0f95955a2040$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $3b668f02bcf8fa96$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $3b668f02bcf8fa96$export$2e2bcd8739ae039 = $3b668f02bcf8fa96$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $4ee92844a821b0dc$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $4ee92844a821b0dc$export$2e2bcd8739ae039 = $4ee92844a821b0dc$var$throttle;



const $e808c4a66d71a854$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $3b668f02bcf8fa96$export$2e2bcd8739ae039)(50, 250);
    return (0, $4ee92844a821b0dc$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $e808c4a66d71a854$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $e808c4a66d71a854$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).asap(()=>fn(...args));






var $deb159330fa4e5d7$export$2e2bcd8739ae039 = (0, $07b3a3ba1e154988$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $07b3a3ba1e154988$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $07b3a3ba1e154988$export$2e2bcd8739ae039).origin), (0, $07b3a3ba1e154988$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $07b3a3ba1e154988$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $32875839662db5f0$export$2e2bcd8739ae039 = (0, $07b3a3ba1e154988$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $77f4131d7bb77154$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $d75a970a635dd504$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
const $102d862a0b8ae760$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $102d862a0b8ae760$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $102d862a0b8ae760$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $102d862a0b8ae760$var$normalizeURLForProtocolCheck(url) {
    return $102d862a0b8ae760$var$stripLeadingC0ControlOrSpace(url).replace($102d862a0b8ae760$var$httpProtocolControlCharacters, '');
}
function $102d862a0b8ae760$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string' && $102d862a0b8ae760$var$malformedHttpProtocol.test($102d862a0b8ae760$var$normalizeURLForProtocolCheck(url))) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('Invalid URL: missing "//" after protocol', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
}
function $102d862a0b8ae760$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $102d862a0b8ae760$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $77f4131d7bb77154$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $102d862a0b8ae760$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $d75a970a635dd504$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $e87f5b5a55a977b5$var$headersToObject = (thing)=>thing instanceof (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $e87f5b5a55a977b5$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isPlainObject(target) && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($e87f5b5a55a977b5$var$headersToObject(a), $e87f5b5a55a977b5$var$headersToObject(b), prop, true)
    };
    (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}




const $09d888cc20681c8e$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $09d888cc20681c8e$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($09d888cc20681c8e$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $09d888cc20681c8e$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $09d888cc20681c8e$var$resolveConfig(config) {
    const newConfig = (0, $e87f5b5a55a977b5$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $1c478eae0a112daf$export$2e2bcd8739ae039)((0, $102d862a0b8ae760$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $09d888cc20681c8e$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $f2d810dca70b8250$export$2e2bcd8739ae039).from(e, (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $07b3a3ba1e154988$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $07b3a3ba1e154988$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $09d888cc20681c8e$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $07b3a3ba1e154988$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $deb159330fa4e5d7$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $32875839662db5f0$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $09d888cc20681c8e$export$2e2bcd8739ae039 = $09d888cc20681c8e$var$resolveConfig;



const $2ba4c77bf4efc04b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $2ba4c77bf4efc04b$export$2e2bcd8739ae039 = $2ba4c77bf4efc04b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $09d888cc20681c8e$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $273fea214edee96c$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('Request aborted', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)(msg, (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $23c030dd1e0e01c4$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ETIMEDOUT : (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach((0, $48c52709e59c85c1$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $e808c4a66d71a854$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $e808c4a66d71a854$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $c984cca974fcbf53$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $c9ea0f95955a2040$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $07b3a3ba1e154988$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $6af91f21904b256a$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $f2d810dca70b8250$export$2e2bcd8739ae039) ? err : new (0, $c984cca974fcbf53$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort, {
            once: true
        }));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $6af91f21904b256a$export$2e2bcd8739ae039 = $6af91f21904b256a$var$composeSignals;


const $69298a0a54a4976e$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $69298a0a54a4976e$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $69298a0a54a4976e$var$readStream(iterable))yield* $69298a0a54a4976e$export$71b051935044bd5d(chunk, chunkSize);
};
const $69298a0a54a4976e$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $69298a0a54a4976e$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $69298a0a54a4976e$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: compute the exact percent-decoded UTF-8 byte length.
 *
 * @param {string} url
 * @returns {number}
 */ const $e111cb6630a42c0a$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $e111cb6630a42c0a$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $e111cb6630a42c0a$var$isHexDigit(str.charCodeAt(i + 1)) && $e111cb6630a42c0a$var$isHexDigit(str.charCodeAt(i + 2));
function $e111cb6630a42c0a$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = $e111cb6630a42c0a$var$isHexDigit(a) && $e111cb6630a42c0a$var$isHexDigit(b);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $e111cb6630a42c0a$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $bd60fc77e8105729$export$a4ad2735b021c132 = "1.18.1";



const $d0172c2ed6a26c88$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $d0172c2ed6a26c88$var$isFunction } = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $d0172c2ed6a26c88$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $d0172c2ed6a26c88$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $d0172c2ed6a26c88$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $d0172c2ed6a26c88$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $d0172c2ed6a26c88$var$factory = (env)=>{
    const globalObject = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).global !== undefined && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).global !== null ? (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $d0172c2ed6a26c88$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $d0172c2ed6a26c88$var$isFunction(Request);
    const isResponseSupported = $d0172c2ed6a26c88$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $d0172c2ed6a26c88$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $d0172c2ed6a26c88$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $07b3a3ba1e154988$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $d0172c2ed6a26c88$var$test(()=>(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $07b3a3ba1e154988$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $09d888cc20681c8e$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $6af91f21904b256a$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($d0172c2ed6a26c88$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $07b3a3ba1e154988$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $d0172c2ed6a26c88$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $d0172c2ed6a26c88$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($d0172c2ed6a26c88$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $e111cb6630a42c0a$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isReadableStream(data) || (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $69298a0a54a4976e$export$b0119225647bd83)(stream, $d0172c2ed6a26c88$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $e808c4a66d71a854$export$d9fadd12586c18d6)(requestContentLength, (0, $e808c4a66d71a854$export$c1b28109d46c3592)((0, $e808c4a66d71a854$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $bd60fc77e8105729$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $48c52709e59c85c1$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $e808c4a66d71a854$export$d9fadd12586c18d6)(responseContentLength, (0, $e808c4a66d71a854$export$c1b28109d46c3592)((0, $e808c4a66d71a854$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $69298a0a54a4976e$export$b0119225647bd83)(response.body, $d0172c2ed6a26c88$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $273fea214edee96c$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $f2d810dca70b8250$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $f2d810dca70b8250$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('Network Error', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $f2d810dca70b8250$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $d0172c2ed6a26c88$var$seedCache = new Map();
const $d0172c2ed6a26c88$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $d0172c2ed6a26c88$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $d0172c2ed6a26c88$var$factory(env));
        map = target;
    }
    return target;
};
const $d0172c2ed6a26c88$var$adapter = $d0172c2ed6a26c88$export$3105c6651375d4fa();
var $d0172c2ed6a26c88$export$2e2bcd8739ae039 = $d0172c2ed6a26c88$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $32df8ff33e7eb06a$var$knownAdapters = {
    http: (0, $d8e16a456141c1a9$export$2e2bcd8739ae039),
    xhr: (0, $2ba4c77bf4efc04b$export$2e2bcd8739ae039),
    fetch: {
        get: $d0172c2ed6a26c88$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach($32df8ff33e7eb06a$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $32df8ff33e7eb06a$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $32df8ff33e7eb06a$var$isResolvedHandle = (adapter)=>(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $32df8ff33e7eb06a$var$getAdapter(adapters, config) {
    adapters = (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$32df8ff33e7eb06a$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $32df8ff33e7eb06a$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($32df8ff33e7eb06a$var$renderReason).join('\n') : ' ' + $32df8ff33e7eb06a$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $32df8ff33e7eb06a$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $32df8ff33e7eb06a$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $32df8ff33e7eb06a$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $941dd37219549526$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $c984cca974fcbf53$export$2e2bcd8739ae039)(null, config);
}
function $941dd37219549526$export$2e2bcd8739ae039(config) {
    $941dd37219549526$var$throwIfCancellationRequested(config);
    config.headers = (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $2655262722674cb9$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $32df8ff33e7eb06a$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $c47c3de1de7d9d20$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $941dd37219549526$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $2655262722674cb9$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $69db484605351264$export$2e2bcd8739ae039)(reason)) {
            $941dd37219549526$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $2655262722674cb9$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $113f01841375e2be$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $113f01841375e2be$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $113f01841375e2be$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $113f01841375e2be$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $bd60fc77e8105729$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$113f01841375e2be$var$deprecatedWarnings[opt]) {
            $113f01841375e2be$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$113f01841375e2be$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $113f01841375e2be$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('options must be an object', (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $f2d810dca70b8250$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $f2d810dca70b8250$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $113f01841375e2be$export$2e2bcd8739ae039 = {
    assertOptions: $113f01841375e2be$var$assertOptions,
    validators: $113f01841375e2be$var$validators
};




'use strict';
const $761961a6ceb03e3c$var$validators = (0, $113f01841375e2be$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $761961a6ceb03e3c$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $24d9cc54f1904614$export$2e2bcd8739ae039)(),
            response: new (0, $24d9cc54f1904614$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $e87f5b5a55a977b5$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $113f01841375e2be$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $761961a6ceb03e3c$var$validators.transitional($761961a6ceb03e3c$var$validators.boolean),
            forcedJSONParsing: $761961a6ceb03e3c$var$validators.transitional($761961a6ceb03e3c$var$validators.boolean),
            clarifyTimeoutError: $761961a6ceb03e3c$var$validators.transitional($761961a6ceb03e3c$var$validators.boolean),
            legacyInterceptorReqResOrdering: $761961a6ceb03e3c$var$validators.transitional($761961a6ceb03e3c$var$validators.boolean),
            advertiseZstdAcceptEncoding: $761961a6ceb03e3c$var$validators.transitional($761961a6ceb03e3c$var$validators.boolean),
            validateStatusUndefinedResolves: $761961a6ceb03e3c$var$validators.transitional($761961a6ceb03e3c$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $113f01841375e2be$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $761961a6ceb03e3c$var$validators.function,
                serialize: $761961a6ceb03e3c$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $113f01841375e2be$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $761961a6ceb03e3c$var$validators.spelling('baseURL'),
            withXsrfToken: $761961a6ceb03e3c$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $23c030dd1e0e01c4$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $941dd37219549526$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $941dd37219549526$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $e87f5b5a55a977b5$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $102d862a0b8ae760$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $1c478eae0a112daf$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $761961a6ceb03e3c$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $e87f5b5a55a977b5$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $e87f5b5a55a977b5$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $761961a6ceb03e3c$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $761961a6ceb03e3c$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $761961a6ceb03e3c$export$2e2bcd8739ae039 = $761961a6ceb03e3c$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $2b611a55e4e69810$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $c984cca974fcbf53$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $2b611a55e4e69810$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $2b611a55e4e69810$export$2e2bcd8739ae039 = $2b611a55e4e69810$var$CancelToken;






'use strict';
function $2cfbd6d65b5a0b89$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $aae7d5cc58516248$export$2e2bcd8739ae039(payload) {
    return (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $58f4f8404507bd91$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($58f4f8404507bd91$var$HttpStatusCode).forEach(([key, value])=>{
    $58f4f8404507bd91$var$HttpStatusCode[value] = key;
});
var $58f4f8404507bd91$export$2e2bcd8739ae039 = $58f4f8404507bd91$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $516d2fa8766bddb7$var$createInstance(defaultConfig) {
    const context = new (0, $761961a6ceb03e3c$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $3ccc379494ab7e95$export$2e2bcd8739ae039)((0, $761961a6ceb03e3c$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).extend(instance, (0, $761961a6ceb03e3c$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $516d2fa8766bddb7$var$createInstance((0, $e87f5b5a55a977b5$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $516d2fa8766bddb7$var$axios = $516d2fa8766bddb7$var$createInstance((0, $c47c3de1de7d9d20$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$516d2fa8766bddb7$var$axios.Axios = (0, $761961a6ceb03e3c$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$516d2fa8766bddb7$var$axios.CanceledError = (0, $c984cca974fcbf53$export$2e2bcd8739ae039);
$516d2fa8766bddb7$var$axios.CancelToken = (0, $2b611a55e4e69810$export$2e2bcd8739ae039);
$516d2fa8766bddb7$var$axios.isCancel = (0, $69db484605351264$export$2e2bcd8739ae039);
$516d2fa8766bddb7$var$axios.VERSION = (0, $bd60fc77e8105729$export$a4ad2735b021c132);
$516d2fa8766bddb7$var$axios.toFormData = (0, $a81f0df205d0963c$export$2e2bcd8739ae039);
// Expose AxiosError class
$516d2fa8766bddb7$var$axios.AxiosError = (0, $f2d810dca70b8250$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$516d2fa8766bddb7$var$axios.Cancel = $516d2fa8766bddb7$var$axios.CanceledError;
// Expose all/spread
$516d2fa8766bddb7$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$516d2fa8766bddb7$var$axios.spread = (0, $2cfbd6d65b5a0b89$export$2e2bcd8739ae039);
// Expose isAxiosError
$516d2fa8766bddb7$var$axios.isAxiosError = (0, $aae7d5cc58516248$export$2e2bcd8739ae039);
// Expose mergeConfig
$516d2fa8766bddb7$var$axios.mergeConfig = (0, $e87f5b5a55a977b5$export$2e2bcd8739ae039);
$516d2fa8766bddb7$var$axios.AxiosHeaders = (0, $7ecbbd2104c556ea$export$2e2bcd8739ae039);
$516d2fa8766bddb7$var$axios.formToJSON = (thing)=>(0, $f716fc7d78e49037$export$2e2bcd8739ae039)((0, $cc9b6df81a5bcca0$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$516d2fa8766bddb7$var$axios.getAdapter = (0, $32df8ff33e7eb06a$export$2e2bcd8739ae039).getAdapter;
$516d2fa8766bddb7$var$axios.HttpStatusCode = (0, $58f4f8404507bd91$export$2e2bcd8739ae039);
$516d2fa8766bddb7$var$axios.default = $516d2fa8766bddb7$var$axios;
var // this module should only have a default export
$516d2fa8766bddb7$export$2e2bcd8739ae039 = $516d2fa8766bddb7$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $99c2f0d5f6964526$export$1c00760e9e5a4e95, AxiosError: $99c2f0d5f6964526$export$c1fbed17c2f6a328, CanceledError: $99c2f0d5f6964526$export$1ab0c6b20d94fa14, isCancel: $99c2f0d5f6964526$export$3b22524397b493c6, CancelToken: $99c2f0d5f6964526$export$fd08e3cb425f0d61, VERSION: $99c2f0d5f6964526$export$a4ad2735b021c132, all: $99c2f0d5f6964526$export$84bf76cd7afc7469, Cancel: $99c2f0d5f6964526$export$848c9b7ead0df967, isAxiosError: $99c2f0d5f6964526$export$fbafdbe06a5b5a9a, spread: $99c2f0d5f6964526$export$3ae0fd4797ed47c8, toFormData: $99c2f0d5f6964526$export$10ae0d317ea97f8b, AxiosHeaders: $99c2f0d5f6964526$export$4e7d6ff0f3e6520, HttpStatusCode: $99c2f0d5f6964526$export$a972f69c851492b3, formToJSON: $99c2f0d5f6964526$export$86d7c59254d6a2c9, getAdapter: $99c2f0d5f6964526$export$17ddc20a97d669e2, mergeConfig: $99c2f0d5f6964526$export$7ec1ebcfa9d8bd6a, create: $99c2f0d5f6964526$export$185802fd694ee1f5 } = (0, $516d2fa8766bddb7$export$2e2bcd8739ae039);


const $9ea86658f9a44394$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $9ea86658f9a44394$export$2e2bcd8739ae039 = {
    randomUUID: $9ea86658f9a44394$var$randomUUID
};


let $8afe8ff2999bbe0d$var$getRandomValues;
const $8afe8ff2999bbe0d$var$rnds8 = new Uint8Array(16);
function $8afe8ff2999bbe0d$export$2e2bcd8739ae039() {
    if (!$8afe8ff2999bbe0d$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $8afe8ff2999bbe0d$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $8afe8ff2999bbe0d$var$getRandomValues($8afe8ff2999bbe0d$var$rnds8);
}


var $1e205a2ce57e04a9$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $f3a91da0f2bca09a$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $1e205a2ce57e04a9$export$2e2bcd8739ae039).test(uuid);
}
var $f3a91da0f2bca09a$export$2e2bcd8739ae039 = $f3a91da0f2bca09a$var$validate;


const $7b5afe7daeab4de0$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$7b5afe7daeab4de0$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $7b5afe7daeab4de0$export$8fb373d660548968(arr, offset = 0) {
    return ($7b5afe7daeab4de0$var$byteToHex[arr[offset + 0]] + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 1]] + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 2]] + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 3]] + '-' + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 4]] + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 5]] + '-' + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 6]] + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 7]] + '-' + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 8]] + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 9]] + '-' + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 10]] + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 11]] + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 12]] + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 13]] + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 14]] + $7b5afe7daeab4de0$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $7b5afe7daeab4de0$var$stringify(arr, offset = 0) {
    const uuid = $7b5afe7daeab4de0$export$8fb373d660548968(arr, offset);
    if (!(0, $f3a91da0f2bca09a$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $7b5afe7daeab4de0$export$2e2bcd8739ae039 = $7b5afe7daeab4de0$var$stringify;


function $0053dfc342ff7082$var$v4(options, buf, offset) {
    if ((0, $9ea86658f9a44394$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $9ea86658f9a44394$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $8afe8ff2999bbe0d$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $7b5afe7daeab4de0$export$8fb373d660548968)(rnds);
}
var $0053dfc342ff7082$export$2e2bcd8739ae039 = $0053dfc342ff7082$var$v4;



var $05178355e113e06d$require$Buffer = $ff73c632120015f2$export$a143d493d941bafc;
// When you add a new API here, be sure to also add it to the packages/cosmos-node/src/api/APIWrappers.js file,
// as well as export it from packages/cosmos-core/src/index.ts
/**
 * This file acts as a barrel file for exporting all the API classes in this directory.
 * It also exports a function that instantiates all the APIs with the given access token, base URL, and axios configuration.
 * The reasoning instantiateAllAPIs lives at this level is to dodge a circular dependency issue.
 */ const $05178355e113e06d$var$$c2e8b7da11e86d9d$export$136c859b6f4206bb = (config)=>{
    // Add a unique correlation ID to each request for tracing
    // eslint-disable-next-line no-param-reassign -- This is one of the only times we allow param reassignment
    config.headers['x-correlation-id'] = (0, $0053dfc342ff7082$export$2e2bcd8739ae039)();
    return config;
};
const $05178355e113e06d$export$456995facc43eda = ({ accessToken: accessToken, baseURL: baseURL = '', axiosConfig: axiosConfig = {}, axiosRequestInterceptorFn: axiosRequestInterceptorFn = $05178355e113e06d$var$$c2e8b7da11e86d9d$export$136c859b6f4206bb })=>{
    const defaultOptions = {
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    };
    const options = {
        ...defaultOptions,
        ...axiosConfig,
        headers: {
            ...defaultOptions.headers,
            ...axiosConfig.headers
        }
    };
    const instance = (0, $516d2fa8766bddb7$export$2e2bcd8739ae039).create(options);
    instance.interceptors.request.use(axiosRequestInterceptorFn);
    return instance;
};
const $05178355e113e06d$export$b037c60947c9fb6c = (query)=>{
    // Handle null/undefined query
    if (!query || typeof query !== 'string') return '';
    // Find the first opening brace after the query declaration
    const queryBodyStart = query.indexOf('{') + 1;
    // Extract the content after the opening brace
    const queryBody = query.slice(queryBodyStart);
    // Find the first field name by looking for the first non-whitespace characters
    // until we hit a delimiter (space, newline, opening paren, or opening brace)
    const fieldMatch = queryBody.match(/^\s*([a-zA-Z_][a-zA-Z0-9_]*)/u);
    if (fieldMatch) return fieldMatch[1];
    // Fallback to empty string if no field name is found
    return '';
};
const $05178355e113e06d$export$8646bc51ffd8a727 = (baseURL)=>{
    if (!baseURL) return 'no base url provided';
    const subdomain = baseURL.split('.')[0];
    if (subdomain.includes('dev')) return 'https://dev-graphql.pella.com/graphql';
    if (subdomain.includes('qa')) return 'https://qa-graphql.pella.com/graphql';
    return 'https://prod-graphql.pella.com/graphql';
};
/**
 * Base class for Pella APIs.
 * Stores access token and configures axios instance with default headers.
 * Comes with a few helper methods for handling responses.
 */ class $05178355e113e06d$var$$c2d1d220888f3065$var$BaseAPI {
    /**
   * Base constructor. To override, call super() with the config object.
   * Alternatively, overwrite individual properties after calling super().
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        /**
     * Axios instance for REST endpoints.
     * @type {import('axios').AxiosInstance}
     */ this._api = $05178355e113e06d$export$456995facc43eda(config);
        /**
     * Axios instance for GraphQL requests.
     * @type {import('axios').AxiosInstance}
     */ this._graphApi = $05178355e113e06d$export$456995facc43eda({
            ...config,
            baseURL: $05178355e113e06d$export$8646bc51ffd8a727(config.baseURL)
        });
        /**
     * Access token for Okta.
     * @type {import('../../types').APIConfig['accessToken']}
     */ this._accessToken = config.accessToken;
        /**
     * The name of the application.
     * @type {import('../../types').APIConfig['appName']}
     */ this._appName = config.appName;
    }
    /**
   * Performs a graphQL request. Parses the response, throwing errors if present.
   * @param {string} query GraphQL query
   * @param {object} [variables] GraphQL variables
   * @returns {Promise<any>} GraphQL response data
   */ _graphqlRequest = async (query, variables)=>{
        const queryName = $05178355e113e06d$export$b037c60947c9fb6c(query);
        try {
            const response = await this._graphApi.post('', {
                query: query,
                variables: variables
            });
            if (response.data.errors) throw new Error(response.data.errors[0].message);
            return response.data.data[queryName];
        } catch (error) {
            // Try to extract a useful error message from the response
            // This handles Axios, GraphQL, and JS error formats
            const errorMessage = error.response?.data?.errors?.[0]?.message || error.response?.data?.message;
            if (errorMessage) throw new Error(errorMessage);
            throw error;
        }
    };
    /**
   * Simple GET response handler that returns an empty array if the response is falsey.
   * @param {string} url
   * @returns {Promise<any[]>}
   */ _responseOrEmptyArray = async (url)=>{
        /**
     * @type {import('axios').AxiosResponse<import('@pella/types').Generics.APIResponse>}
     */ const { data: data } = await this._api.get(url);
        return data?.response || [];
    };
    /**
   * Simple request handler for REST APIs that throws errors on non-success statuses.
   * Returns the full data object on 200-204 status codes. Use this for paginated responses.
   * @param {string} url
   * @param {'get' | 'post' | 'put' | 'delete'} [method] HTTP method
   * @param {{[key:string]: any}} [body] Request body
   * @returns {Promise<any>}
   */ async _statusCheckedRequestFullResponse(url, method = 'get', body) {
        /**
     * @type {import('axios').AxiosResponse<import('@pella/types').Generics.APIResponse>}
     */ const { data: data } = method === 'get' ? await this._api.get(url) : await this._api[method](url, body);
        if (Number(data.status) < 200 || Number(data.status) > 204) throw new Error(data.message);
        return data;
    }
    /**
   * Simple request handler for REST APIs that throws errors on non-success statuses.
   * Returns data.response on 200-204 status codes.
   * @param {string} url
   * @param {'get' | 'post' | 'put' | 'delete'} [method] HTTP method
   * @param {{[key:string]: any}} [body] Request body
   * @returns {Promise<any>}
   */ async _statusCheckedRequest(url, method = 'get', body) {
        const data = await this._statusCheckedRequestFullResponse(url, method, body);
        return data?.response || null;
    }
    /**
   * Builds the query string for the given key and value.
   * @param {string} key
   * @param {string | number | boolean} value
   */ _buildQueryStringFromKeyValues = (key, value)=>{
        if (typeof value === 'boolean') return `${key}=${value}`;
        return value ? `${key}=${value}` : '';
    };
    /**
   * Builds the query string for the given object.
   * Joins the key value pairs with an ampersand.
   * Intended for use after a ? in a URL.
   * @param {Record<string, any>} obj
   */ _buildQueryString = (obj)=>Object.keys(obj).map((key)=>this._buildQueryStringFromKeyValues(key, obj[key])).filter(Boolean).join('&');
}
var $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 = $05178355e113e06d$var$$c2d1d220888f3065$var$BaseAPI;
const $05178355e113e06d$var$$b31f661968cd519b$export$52bfb5f40547c76a = `
    query GetWorkingDayShipDates($input: GetWorkingDayShipDatesInput!) {
        getWorkingDayShipDates(input: $input)
    }
`;
const $05178355e113e06d$var$$b31f661968cd519b$export$6721d29cad25994d = `
    query GetWorkingDayShipDatesV2($input: GetWorkingDayShipDatesInput!) {
        getWorkingDayShipDatesV2(input: $input)
    }
`;
const $05178355e113e06d$var$$b31f661968cd519b$export$da75000cc497ac25 = `
    mutation CreateEscalationEvent($input: CreateEscalationEventInput!) {
        createEscalationEvent(input: $input) {
            message
        }
    }
`;
/**
 * API for iPath related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$08b9e564a113c8d8$var$Ipath extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/ipath/`
        });
    }
    /**
   * Retrieves DOW shipping information for the given account number and ship from org ID.
   * @param {import('@pella/types').iPathAPI.GetDOWCalendarInput} variables
   * @returns {Promise<import('@pella/types').iPathAPI.GetDOWCalendarResponse[]>}
   */ getDowShippingInfo({ accountnumber: accountnumber, shipfromorgid: shipfromorgid }) {
        return this._statusCheckedRequest(`v1/dow?accountnumber=${accountnumber}&shipfromorgid=${shipfromorgid}`);
    }
    /**
   * Retrieves DOW shipping information for the given account number and ship from org ID (V2).
   * @param {import('@pella/types').iPathAPI.GetDOWCalendarInput} variables
   * @returns {Promise<import('@pella/types').iPathAPI.GetDOWCalendarResponseV2[]>}
   */ getDowShippingInfoV2({ accountnumber: accountnumber, shipfromorgid: shipfromorgid }) {
        return this._statusCheckedRequest(`v2/dow?accountnumber=${accountnumber}&shipfromorgid=${shipfromorgid}`);
    }
    /**
   * Retrieves the list of plants.
   * @returns {Promise<import('@pella/types').iPathAPI.GetPlantsResponse[]>}
   */ getPlants() {
        return this._statusCheckedRequest('v1/lov/plants');
    }
    /**
   * Retrieves the list of plants (V2).
   * @returns {Promise<import('@pella/types').iPathAPI.GetPlantsResponseV2[]>}
   */ getPlantsV2() {
        return this._statusCheckedRequest('v2/lov/plants');
    }
    /**
   * Retrieves the list of Assy Lines.
   * @param {string} OrgCode
   * @returns {Promise<import('@pella/types').iPathAPI.GetPlantAssemblyLinesResponse[]>}
   */ getAssyLines(OrgCode) {
        return this._statusCheckedRequest(`v1/lov/plants/${OrgCode}/assylines`);
    }
    /**
   * Retrieves the list of Assy Lines (V2).
   * @param {string} OrgCode
   * @returns {Promise<import('@pella/types').iPathAPI.GetPlantAssemblyLinesResponseV2[]>}
   */ getAssyLinesV2(OrgCode) {
        return this._statusCheckedRequest(`v2/lov/plants/${OrgCode}/assylines`);
    }
    /**
   * Retrieves the list of Categories.
   * @returns {Promise<import('@pella/types').iPathAPI.GetReasonCategoriesResponse[]>}
   */ getCategories() {
        return this._statusCheckedRequest('v1/reason-codes/categories');
    }
    /**
   * Retrieves the list of Categories (V2).
   * @returns {Promise<import('@pella/types').iPathAPI.GetReasonCategoriesResponseV2[]>}
   */ getCategoriesV2() {
        return this._statusCheckedRequest('v2/reason-codes/categories');
    }
    /**
   * Retrieves the list of Reasons.
   * @returns {Promise<import('@pella/types').iPathAPI.GetReasonCodesResponse[]>}
   */ getReasons() {
        return this._statusCheckedRequest('v1/reason-codes');
    }
    /**
   * Retrieves the list of Reasons (V2).
   * @returns {Promise<import('@pella/types').iPathAPI.GetReasonCodesResponseV2[]>}
   */ getReasonsV2() {
        return this._statusCheckedRequest('v2/reason-codes');
    }
    /**
   * Retrieves the list of Note Types.
   * @returns {Promise<import('@pella/types').iPathAPI.GetNoteTypesResponse[]>}
   */ getNoteTypes() {
        return this._statusCheckedRequest('v1/note-types');
    }
    /**
   * Retrieves the list of Note Types (V2).
   * @returns {Promise<import('@pella/types').iPathAPI.GetNoteTypesResponseV2[]>}
   */ getNoteTypesV2() {
        return this._statusCheckedRequest('v2/note-types');
    }
    /**
   * Adds note to an orderline
   * @param {import('@pella/types').iPathAPI.InsertNoteInput[]} variables
   * @returns {Promise<import('@pella/types').iPathAPI.InsertNoteResponse[]>}
   */ addNote(variables) {
        return this._statusCheckedRequest('v1/orders/notes', 'post', variables);
    }
    /**
   * Adds note to an orderline (V2)
   * @param {import('@pella/types').iPathAPI.InsertNoteInputV2[]} variables
   * @returns {Promise<import('@pella/types').iPathAPI.InsertNoteResponseV2[]>}
   */ addNoteV2(variables) {
        return this._statusCheckedRequest('v2/orders/notes', 'post', variables);
    }
    /**
   * Retrieves the list of orders/lines for the given search criteria.
   * @param {import('@pella/types').iPathAPI.GetOrderLinesInput} params
   * @returns {Promise<import('@pella/types').Generics.PaginatedAPIResponse<import('@pella/types').iPathAPI.GetOrderLinesResponse[]>>}
   */ getOrders(params) {
        // Set default values for the query string
        const defaults = {
            returnlines: 'Y',
            returndetails: 'N'
        };
        // Merge the default values with the given variables
        const obj = {
            ...defaults,
            ...params
        };
        const queryStringURL = this._buildQueryString(obj);
        return this._statusCheckedRequestFullResponse(`v1/lines/search?${queryStringURL}`);
    }
    /**
   * Retrieves the list of orders/lines for the given search criteria.
   * @param {import('@pella/types').iPathAPI.GetOrderLinesInputV2} params
   * @returns {Promise<import('@pella/types').iPathAPI.V2PaginatedResponse<import('@pella/types').iPathAPI.GetOrderLinesResponseV2[]>>}
   */ getOrdersV2(params) {
        // Set default values for the query string
        const defaults = {
            returnlines: 'Y',
            returndetails: 'N'
        };
        // Merge the default values with the given variables
        const obj = {
            ...defaults,
            ...params
        };
        const queryStringURL = this._buildQueryString(obj);
        return this._statusCheckedRequestFullResponse(`v2/lines/search?${queryStringURL}`);
    }
    /**
   * Retrieves the tracking information for the given order line.
   * @param {import('@pella/types').iPathAPI.GetOrderLineTrackingInput} variables
   * @returns {Promise<import('@pella/types').iPathAPI.GetOrderLineTrackingResponse[]>}
   */ getLinesTracking(variables) {
        const queryStringURL = this._buildQueryString(variables);
        return this._statusCheckedRequest(`v1/lines/tracking?${queryStringURL}`);
    }
    /**
   * Retrieves the tracking information for the given order line (V2).
   * @deprecated Use `DataLake.getIpathHistoricalChangeEventsByOrderLineId` instead.
   *   The v2 REST endpoint is backed by the legacy `orderLineEvent` /
   *   `orderHeaderEvent` tables, which are being retired per IOQD-4959.
   * @param {import('@pella/types').iPathAPI.GetOrderLineTrackingInputV2} variables
   * @returns {Promise<import('@pella/types').iPathAPI.GetOrderLineTrackingResponseV2[]>}
   */ getLinesTrackingV2(variables) {
        const queryStringURL = this._buildQueryString(variables);
        return this._statusCheckedRequest(`v2/lines/tracking?${queryStringURL}`);
    }
    /**
   * Adds reason note(s) to the order line.
   * @param {import('@pella/types').iPathAPI.InsertReasonsInput[]} reasons
   * @returns {Promise<import('@pella/types').iPathAPI.InsertReasonsResponse[]>}
   */ addReasons(reasons) {
        return this._statusCheckedRequest('v1/orders/reasons', 'post', reasons);
    }
    /**
   * Adds reason note(s) to the order line (V2).
   * @param {import('@pella/types').iPathAPI.InsertReasonsInputV2[]} reasons
   * @returns {Promise<import('@pella/types').iPathAPI.InsertReasonsResponseV2[]>}
   */ addReasonsV2(reasons) {
        return this._statusCheckedRequest('v2/orders/reasons', 'post', reasons);
    }
    /**
   * Retrieves the next X available ship dates for the given date.
   * Excludes weekends and holidays from the list.
   * @param {import('@pella/types').iPathAPI.GetWorkingDayShipDatesInput} variables
   * @returns {Promise<import('@pella/types').iPathAPI.GetWorkingDayShipDatesResponse>}
   */ getWorkingDayShipDates(variables) {
        return this._graphqlRequest($05178355e113e06d$var$$b31f661968cd519b$export$52bfb5f40547c76a, {
            input: variables
        });
    }
    /**
   * Retrieves the next X available ship dates for the given date (V2).
   * Excludes weekends and holidays from the list.
   * @param {import('@pella/types').iPathAPI.GetWorkingDayShipDatesInput} variables
   * @returns {Promise<import('@pella/types').iPathAPI.GetWorkingDayShipDatesResponseV2>}
   */ getWorkingDayShipDatesV2(variables) {
        return this._graphqlRequest($05178355e113e06d$var$$b31f661968cd519b$export$6721d29cad25994d, {
            input: variables
        });
    }
    /**
   * Creates an escalation event + note for each provided orderlineskey.
   * @param {import('@pella/types').iPathAPI.CreateEscalationEventInput} variables
   * @returns {Promise<import('@pella/types').iPathAPI.CreateEscalationEventResponse>}
   */ createEscalationEvent(variables) {
        return this._graphqlRequest($05178355e113e06d$var$$b31f661968cd519b$export$da75000cc497ac25, {
            input: variables
        });
    }
    /**
   * Updates the order value thresholds for the given plants.
   * @param {import('@pella/types').iPathAPI.UpdateOrderValueThresholdInput[]} variables
   * @returns {Promise<import('@pella/types').iPathAPI.UpdateOrderValueThresholdResponse>}
   */ updateOrderValueThresholds(variables) {
        return this._statusCheckedRequest('v1/order-value-thresholds', 'put', variables);
    }
    /**
   * Updates the order value thresholds for the given plants (V2).
   * @param {import('@pella/types').iPathAPI.UpdateOrderValueThresholdInputV2[]} variables
   * @returns {Promise<import('@pella/types').iPathAPI.UpdateOrderValueThresholdResponseV2>}
   */ updateOrderValueThresholdsV2(variables) {
        return this._statusCheckedRequest('v2/order-value-thresholds', 'put', variables);
    }
    /**
   * Retrieves the list of plant's and their dollar value thresholds.
   * @returns {Promise<import('@pella/types').iPathAPI.GetOrderValueThresholdResponse>}
   */ getOrderValueThresholds() {
        return this._statusCheckedRequest('v1/order-value-thresholds');
    }
    /**
   * Retrieves the list of plant's and their dollar value thresholds (V2).
   * @returns {Promise<import('@pella/types').iPathAPI.GetOrderValueThresholdResponseV2>}
   */ getOrderValueThresholdsV2() {
        return this._statusCheckedRequest('v2/order-value-thresholds');
    }
}
var $05178355e113e06d$export$ef8db0afbc868c87 = $05178355e113e06d$var$$08b9e564a113c8d8$var$Ipath;
/**
 * API for team member related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$be033363e362d8c5$var$TeamMember extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/teammembers/v2/`
        });
        /**
     * Axios instance for public team member endpoints.
     * @type {import('axios').AxiosInstance}
     */ this._publicApi = $05178355e113e06d$export$456995facc43eda({
            ...config,
            baseURL: `${config.baseURL}/teammembers/public/v2/`
        });
    }
    /**
   * Retrieves team member profile picture, converts to base64.
   * @param {import('@pella/types').TeamMembersAPI.GetTeamMemberPhotoByUserIdInput['userId']} userid OIM login of the team member.
   * @returns {Promise<import('@pella/types').TeamMembersAPI.GetTeamMemberPhotoResponse | null>} - A base64 encoded string of the image or null if the user does not have an image.
   */ async getTeamMemberImage(userid) {
        const { data: data } = await this._api.get(`members/member/${userid}/image`, {
            responseType: 'arraybuffer'
        });
        // If the image byteLength is less than 5k, it typically means the user does not have an image.
        // return null in this case to avoid a broken image.
        if (data.byteLength < 5000) return null;
        const base64img = $05178355e113e06d$require$Buffer.from(data).toString('base64');
        return `data:image/png;base64,${base64img}`;
    }
    /**
   * Retrieves team member information by OIM login.
   * @param {import('@pella/types').TeamMembersAPI.GetTeamMemberByUserIdInput['userId']} userid OIM login of the team member.
   * @returns {Promise<import('@pella/types').TeamMembersAPI.GetTeamMemberResponse>}
   */ async getTeamMemberByUserId(userid) {
        const { data: data } = await this._api.get(`members/member/${userid}`);
        return data;
    }
    /**
   * Retrieves team member information by badge number.
   * @param {import('@pella/types').TeamMembersAPI.GetTeamMemberByBadgeNumberInput['badgeNumber']} badgeNumber 6-digit badge number of the team member.
   * @returns {Promise<import('@pella/types').TeamMembersAPI.GetTeamMemberResponse>}
   */ async getTeamMemberByBadgeNumber(badgeNumber) {
        const { data: data } = await this._publicApi.get(`members/member/badge/${badgeNumber}`);
        return data;
    }
    /**
   * Retrieves team members by search criteria.
   * @param {import('@pella/types').TeamMembersAPI.GetTeamMemberBySearchCriteriaInput[]} variables
   * @param {import('@pella/types').TeamMembersAPI.EmploymentStatusSearch} [status]
   * @returns {Promise<import('@pella/types').TeamMembersAPI.GetTeamMemberBySearchCriteriaResponse>}
   */ async getTeamMembersBySearchCriteria(variables, status = 'ACTIVE') {
        const { data: data } = await this._api.post(`members?status=${status}`, variables);
        return data.members;
    }
    /**
   * Returns the entitlements of a team member.
   * @param {import('@pella/types').TeamMembersAPI.GetTeamMemberEntitlementsInput} userid
   * @returns {Promise<import('@pella/types').TeamMembersAPI.GetTeamMemberEntitlementsResponse>}
   */ async getTeamMemberEntitlements(userid) {
        const { data: data } = await this._api.get(`entitlements/${userid}`);
        return data;
    }
}
var $05178355e113e06d$export$d02f9bf4b03d1554 = $05178355e113e06d$var$$be033363e362d8c5$var$TeamMember;
/**
 * API for application user related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$d238c4412b965151$var$ApplUser extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/appl-user/v2/`
        });
    }
    /**
   * Retrieves team member entitlement (roles) for current application.
   * @param {import('../../types').UserId} userId Pella AD username
   * @returns {Promise<string[]>} A string array of application roles.
   */ getTeamMemberApplicationRoles(userId) {
        return this._responseOrEmptyArray(`appl/${this._appName}/users/${userId}/roles`);
    }
    /**
   * Retrieves team member application preferences.
   * @param {import('../../types').UserId} userId Pella AD username
   * @returns {Promise<Record<string, any> | null>} Object of application preferences or null if none exist.
   */ getTeamMemberAppPreferences(userId) {
        return this._statusCheckedRequest(`appl/${this._appName}/users/${userId}/preferences`);
    }
    /**
   * Add team member application preferences.
   * @param {import('../../types').UserId} userId Pella AD username
   * @param {Record<string, any>} inputs json object to add.
   * @returns {Promise<{}>} Always returns an empty object on success.
   */ addTeamMemberAppPreferences(userId, inputs) {
        return this._statusCheckedRequest(`appl/${this._appName}/users/${userId}/preferences`, 'post', inputs);
    }
    /**
   * Get Application Features
   * @param {import('../../types').AppName} param
   * @returns {Promise<import('@pella/types').ApplUserAPI.GetAppFeaturesOutput>} Array of application features.
   */ getAppFeatures(param) {
        return this._statusCheckedRequest(`appl/${param}/features`);
    }
    /**
   * Get Application Roles
   * @param {import('../../types').AppName} appName
   * @returns {Promise<import('@pella/types').ApplUserAPI.GetAppRolesOutput>} Array of application roles.
   */ getAppRoles(appName) {
        return this._statusCheckedRequest(`appl/${appName}/roles?enabled=Y`);
    }
}
var $05178355e113e06d$export$ec5c01f21e3cc6b7 = $05178355e113e06d$var$$d238c4412b965151$var$ApplUser;
/**
 * API for application analytics related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$53bb852b7d96d875$var$AppAnalytics extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/app-analytics/public/v1/`
        });
    }
    /**
   * Add an analytics event to for the application.
   * @param {{userName: string, applicationPage: string, eventDescription: string, plant: string, eventType: string, platform: string}} record
   * @returns {Promise<import('@pella/types').AppAnalyticsAPI.AddEventResponse>}
   */ addEvent = ({ userName: userName, applicationPage: applicationPage, eventDescription: eventDescription, plant: plant, eventType: eventType, platform: platform })=>{
        /**
     * @type {import('@pella/types').AppAnalyticsAPI.AddEventInput}
     */ const body = {
            application_name: this._appName,
            event: eventType,
            user_name: userName || 'UNKNOWN',
            application_page: applicationPage,
            plant: plant,
            platform: platform,
            event_description: eventDescription
        };
        return this._statusCheckedRequest('events', 'post', body);
    };
}
var $05178355e113e06d$export$6362543a8c1dec50 = $05178355e113e06d$var$$53bb852b7d96d875$var$AppAnalytics;
/**
 * API for team member data related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$939185b36b1b4ce5$var$TeamMemberData extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        const { accessToken: accessToken, baseURL: baseURL, axiosConfig: axiosConfig } = config;
        super({
            ...config,
            baseURL: `${baseURL}/team-member-data/v1/`
        });
        /**
     * Axios instance for public endpoints.
     * @type {import('axios').AxiosInstance}
     */ this._publicApi = $05178355e113e06d$export$456995facc43eda({
            accessToken: accessToken,
            baseURL: `${baseURL}/team-member-data/public/v1/`,
            axiosConfig: axiosConfig
        });
    }
    /**
   * Simple request handler for REST APIs that throws errors on non-success statuses.
   * Returns data.response on 200-204 status codes.
   * @param {string} url
   * @param {'get' | 'post' | 'put' | 'delete'} [method] HTTP method
   * @param {{[key:string]: any}} [body] Request body
   * @returns {Promise<any>}
   */ async _statusCheckedRequestPublic(url, method = 'get', body) {
        /**
     * @type {import('axios').AxiosResponse<import('@pella/types').Generics.APIResponse>}
     */ const { data: data } = method === 'get' ? await this._publicApi.get(url) : await this._publicApi[method](url, body);
        if (Number(data.status) < 200 || Number(data.status) > 204) throw new Error(data.message);
        return data.response;
    }
    /**
   * Retrieves available sites
   * @param {import('@pella/types').TeamMemberDataAPI.GetAvailableSitesInput} variables - site is active or not
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetAvailableSitesOutput[] | null>} - List of available sites
   */ getAvailableSites({ active: active }) {
        return this._statusCheckedRequest(`auctions/sites?active=${active}`);
    }
    /**
   * Retrives Auction Calendars Summary
   * @param {import('@pella/types').TeamMemberDataAPI.GetAuctionCalendarsSummaryInput} variables - siteCode, active, current, closed
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetAuctionCalendarsSummaryOutput[] |null>} - List of Auction Calendars Summary
   */ getAuctionCalendarsSummary({ siteCode: siteCode, active: active, current: current, closed: closed }) {
        const obj = {
            active: active,
            current: current,
            closed: closed
        };
        const queryStringURL = this._buildQueryString(obj);
        return this._statusCheckedRequest(`auctions/${siteCode}/calendar-summary-list?${queryStringURL}`);
    }
    /**
   * Retrives Auction Calendars Details
   * @param {import('@pella/types').TeamMemberDataAPI.GetAuctionCalendarsDetailsInput} variables - auctionId
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetAuctionCalendarsDetailOutput[] |null>} - List of Auction Calendar Details
   */ getAuctionCalendarsDetail({ auctionId: auctionId }) {
        return this._statusCheckedRequest(`auctions/${auctionId}/calendar-detail`);
    }
    /**
   * Retrives Auction Data
   * @param {import('@pella/types').TeamMemberDataAPI.GetAuctionDataInput} variables - auctionId
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetAuctionDataOutput[] |null>} - List of Auction Data
   */ getAuctionData({ auctionId: auctionId }) {
        return this._statusCheckedRequest(`auctions/${auctionId}/auction`);
    }
    /**
   * Retrieves the list of sites.
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetAllSitesOutput[]>}
   */ getAllSites() {
        return this._statusCheckedRequestPublic('sites');
    }
    /**
   * Retrieves a site by site code.
   * @param {string} siteCode
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetSiteBySiteCodeOutput | undefined>}
   */ async getSiteBySiteCode(siteCode) {
        const result = await this._statusCheckedRequestPublic(`sites/${siteCode}`);
        return result[0];
    }
    /**
   * Retrieves the list of active sites.
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.SuggestionsSite[]>}
   */ getSuggestionsActiveSites() {
        return this._statusCheckedRequest('suggestions/siteinfo/sites');
    }
    /**
   * Retrieves additional site information
   * @param {import('@pella/types').TeamMemberDataAPI.GetSuggestionsSiteInfoInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetSuggestionsSiteInfoOutput[]>}
   */ getSuggestionsSiteInfo({ site: site, subSite: subSite, attribute: attribute }) {
        const queryObj = {
            subSite: subSite,
            attribute: attribute
        };
        const queryString = this._buildQueryString(queryObj);
        return this._statusCheckedRequestPublic(`suggestions/siteinfo/${site}?${queryString}`);
    }
    /**
   * Creates a new suggestion.
   * @param {import('@pella/types').TeamMemberDataAPI.CreateSuggestionInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.CreateSuggestionOutput['response']>}
   */ createSuggestion(variables) {
        return this._statusCheckedRequestPublic('suggestions', 'post', variables);
    }
    /**
   * Creates and sends an email to the given recipient.
   * @param {import('@pella/types').TeamMemberDataAPI.CreateEmailNotificationInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.CreateEmailNotificationOutput>} literally just an empty array on success. Double check the type from pella/types, it's funky.
   */ createEmailNotification(variables) {
        return this._statusCheckedRequestPublic('notification', 'post', variables);
    }
    /**
   * Retrieves suggestions created by given AD username.
   * @param {import('@pella/types').TeamMemberDataAPI.GetSuggestionsByUserInput} user
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetSuggestionsByUserOutput[]>}
   */ getSuggestionsByUser(user) {
        return this._statusCheckedRequestPublic(`suggestions?user=${user}`);
    }
    /**
   * Retrieve notes for given suggestion ID.
   * @param {import('@pella/types').TeamMemberDataAPI.GetNotesBySuggestionIdInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetNotesBySuggestionIdOutput[]>}
   */ getNotesBySuggestionId(variables) {
        const queryString = this._buildQueryString(variables);
        return this._statusCheckedRequestPublic(`suggestions/notes?${queryString}`);
    }
    /**
   * Retrieves thrive linked actions for a suggestion.
   * @param {import('@pella/types').TeamMemberDataAPI.GetThriveLinkedActionsInput} suggestionId
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetThriveLinkedActionsOutput[]>}
   */ getThriveLinkedActions(suggestionId) {
        return this._statusCheckedRequest(`suggestions/${suggestionId}/linkedActions`);
    }
    /**
   * Creates a thrive linked action for a suggestion.
   * @param {import('@pella/types').TeamMemberDataAPI.CreateThriveLinkedActionInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.CreateThriveLinkedActionOutput>}
   */ createThriveLinkedAction(variables) {
        return this._statusCheckedRequest('linked-actions', 'post', variables);
    }
    /**
   * Gets suggestions by search criteria
   * @param {import('@pella/types').TeamMemberDataAPI.GetSuggestionsInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetSuggestionsOutput[]>}
   */ getSuggestions(variables) {
        const queryString = this._buildQueryString(variables);
        return this._statusCheckedRequest(`suggestions?${queryString}`);
    }
    /**
   * Updates a suggestion.
   * @param {import('@pella/types').TeamMemberDataAPI.UpdateSuggestionInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.UpdateSuggestionOutput['Message']>}
   */ async updateSuggestion(variables) {
        /**
     * @type {[import('@pella/types').TeamMemberDataAPI.UpdateSuggestionOutput]}
     */ const result = await this._statusCheckedRequest('suggestions', 'put', variables);
        return result[0].Message;
    }
    /**
   * Creates a new note for a given suggestion id.
   * @param {import('@pella/types').TeamMemberDataAPI.CreateSuggestionNoteInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.CreateSuggestionNoteOutput>}
   */ createSuggestionNote(variables) {
        return this._statusCheckedRequest('suggestions/notes', 'post', variables);
    }
    /**
   * Fetches managers for given site and optional subSite.
   * @param {import('@pella/types').TeamMemberDataAPI.GetManagersBySiteInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetManagersBySiteOutput[]>}
   */ getManagersBySite({ site: site, subSite: subSite = '' }) {
        return this._statusCheckedRequest(`suggestions/managers/${site}?subSite=${subSite}`);
    }
    /**
   * Creates a new site info attribute.
   * Attribute examples: 'subSite', 'location', 'resource', 'category'
   * @param {import('@pella/types').TeamMemberDataAPI.Site['siteName']} site
   * @param {import('@pella/types').TeamMemberDataAPI.CreateSiteInfoInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.CreateSiteInfoOutput['Message']>}
   */ async createSiteInfo(site, variables) {
        const result = await this._statusCheckedRequest(`suggestions/siteinfo/${site}`, 'post', variables);
        if (result[0].Message !== 'Completed') throw new Error(`Failed to create site info attribute: ${result[0].Message}`);
        return result[0].Message;
    }
    /**
   * Deletes a site info attribute.
   * @param {import('@pella/types').TeamMemberDataAPI.Site['siteName']} site
   * @param {import('@pella/types').TeamMemberDataAPI.DeleteSiteInfoInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.DeleteSiteInfoOutput>}
   */ deleteSiteInfo(site, { subsite: subsite, attribute: attribute, value1: value1 }) {
        // I wanted to use _buildQueryString here, but the API NEEDS empty strings to be passed as empty strings, not removed lol.
        return this._statusCheckedRequest(`suggestions/siteinfo/${site}?attribute=${attribute}&value1=${value1}&subsite=${subsite}`, 'delete');
    }
    /**
   * Retrieves metrics for given site and optional subSite.
   * @param {import('@pella/types').TeamMemberDataAPI.GetMetricsInput} variables
   * @returns {Promise<import('@pella/types').TeamMemberDataAPI.GetMetricsOutput>}
   */ getMetrics({ site: site, subSite: subSite, type: type, startDate: startDate, endDate: endDate }) {
        // I wanted to use _buildQueryString here, but the API NEEDS empty strings to be passed as empty strings, not removed lol.
        return this._statusCheckedRequest(`suggestions/metrics?site=${site}&subSite=${subSite}&type=${type}&startDate=${startDate}&endDate=${endDate}`);
    }
}
var $05178355e113e06d$export$c591ab8a928c34e7 = $05178355e113e06d$var$$939185b36b1b4ce5$var$TeamMemberData;
const $05178355e113e06d$var$$40914e9fdaa17615$var$imageShape = `
    {
        id
        timestamp
        image {
            url
        }
        metadata {
            serialNumber
            lineNumber
            schedule
            parentSchedule
        }
    }
`;
const $05178355e113e06d$var$$40914e9fdaa17615$export$2193108d4a0f2563 = `
    query GetVisionImageById($id: String!) {
        getVisionImageById(id: $id) ${$05178355e113e06d$var$$40914e9fdaa17615$var$imageShape}
    }
`;
const $05178355e113e06d$var$$40914e9fdaa17615$export$faafdf944ed38b34 = `
    query GetVisionImagesBySerialNumber($serialNumber: String!) {
        getVisionImagesBySerialNumber(serialNumber: $serialNumber) ${$05178355e113e06d$var$$40914e9fdaa17615$var$imageShape}
    }
`;
const $05178355e113e06d$var$$40914e9fdaa17615$export$b08ac518e217b180 = `
    mutation CreateVisionImage($input: CreateVisionImageInput!) {
        createVisionImage(input: $input) ${$05178355e113e06d$var$$40914e9fdaa17615$var$imageShape}
    }
`;
const $05178355e113e06d$var$$40914e9fdaa17615$export$57adaaea667c987b = `
    query GetVisionImagesBySearchCriteria($input: GetVisionImagesBySearchCriteriaInput!) {
        getVisionImagesBySearchCriteria(input: $input) {
            id
            image {
                url
            }
            metadata {
                serialNumber
                schedule
                parentSchedule
            }
        }
    }
`;
/**
 * API for Image related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$983075c2a12cf0af$var$Image extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/image/v1/`
        });
    }
    /**
   * Retrieves Vision Image by ID.
   * @param {import('@pella/types').ImageAPI.GetVisionImageByIdInput['id']} id
   * @returns {Promise<import('@pella/types').ImageAPI.GetVisionImageByIdResponse>}
   */ getVisionImageById(id) {
        return this._graphqlRequest($05178355e113e06d$var$$40914e9fdaa17615$export$2193108d4a0f2563, {
            id: id
        });
    }
    /**
   * Retrieves Vision Images by Serial Number.
   * @param {import('@pella/types').ImageAPI.GetVisionImagesBySerialNumberInput['serialNumber']} serialNumber
   * @returns {Promise<import('@pella/types').ImageAPI.GetVisionImagesBySerialNumberResponse[]>}
   */ getVisionImagesBySerialNumber(serialNumber) {
        return this._graphqlRequest($05178355e113e06d$var$$40914e9fdaa17615$export$faafdf944ed38b34, {
            serialNumber: serialNumber
        });
    }
    /**
   * Creates Vision Image.
   * @param {import('@pella/types').ImageAPI.CreateVisionImageInput} input
   * @returns {Promise<import('@pella/types').ImageAPI.CreateVisionImageResponse>}
   */ createVisionImage(input) {
        return this._graphqlRequest($05178355e113e06d$var$$40914e9fdaa17615$export$b08ac518e217b180, {
            input: input
        });
    }
    /**
   * Searches for Vision Images based on various criteria.
   * @param {import('@pella/types').ImageAPI.GetVisionImagesBySearchCriteriaInput} input
   * @returns {Promise<import('@pella/types').ImageAPI.GetVisionImagesBySearchCriteriaResponse[]>}
   */ getVisionImagesBySearchCriteria(input) {
        return this._graphqlRequest($05178355e113e06d$var$$40914e9fdaa17615$export$57adaaea667c987b, {
            input: input
        });
    }
}
var $05178355e113e06d$export$3e431a229df88919 = $05178355e113e06d$var$$983075c2a12cf0af$var$Image;
/**
 * API for Logscale endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$c4eef40eced35c89$var$Logger extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/logger/v1/`
        });
        /** @type {import('../../types').DeviceContext | undefined} */ this._deviceContext = config.deviceContext;
    }
    /**
   * Logs a message to the logger service.
   * @param {import('@pella/types').LoggerAPI.Level} level The log level.
   * @param {import('@pella/types').LoggerAPI.Message} message The log message.
   * @param {import('@pella/types').LoggerAPI.Data} [data] Additional data to log.
   * @returns {Promise<import('@pella/types').LoggerAPI.Response>} The response from the logger service.
   * @throws {import('axios').AxiosError} If the request fails.
   */ async #logWrapper(level, message, data = null) {
        const formattedData = data instanceof Error ? {
            ...this._deviceContext,
            message: data.message,
            stack: data.stack
        } : {
            ...this._deviceContext,
            data: data
        };
        const { data: response } = await this._api.post('', {
            level: level,
            source: this._appName,
            message: message,
            data: formattedData
        });
        return response.status === 'ok';
    }
    /**
   * Logs an 'info' message to the logger service.
   * @param {import('@pella/types').LoggerAPI.Message} message The log message.
   * @param {import('@pella/types').LoggerAPI.Data} [data] Additional data to log.
   * @returns {Promise<import('@pella/types').LoggerAPI.Response>} The response from the logger service.
   */ log(message, data) {
        return this.#logWrapper('log', message, data);
    }
    /**
   * Logs a 'debug' message to the logger service.
   * @param {import('@pella/types').LoggerAPI.Message} message The log message.
   * @param {import('@pella/types').LoggerAPI.Data} [data] Additional data to log.
   * @returns {Promise<import('@pella/types').LoggerAPI.Response>} The response from the logger service.
   */ debug(message, data) {
        return this.#logWrapper('debug', message, data);
    }
    /**
   * Logs an 'info' message to the logger service.
   * @param {import('@pella/types').LoggerAPI.Message} message The log message.
   * @param {import('@pella/types').LoggerAPI.Data} [data] Additional data to log.
   * @returns {Promise<import('@pella/types').LoggerAPI.Response>} The response from the logger service.
   */ info(message, data) {
        return this.#logWrapper('info', message, data);
    }
    /**
   * Logs a 'warn' message to the logger service.
   * @param {import('@pella/types').LoggerAPI.Message} message The log message.
   * @param {import('@pella/types').LoggerAPI.Data} [data] Additional data to log.
   * @returns {Promise<import('@pella/types').LoggerAPI.Response>} The response from the logger service.
   */ warn(message, data) {
        return this.#logWrapper('warn', message, data);
    }
    /**
   * Logs an 'error' message to the logger service.
   * @param {import('@pella/types').LoggerAPI.Message} message The log message.
   * @param {import('@pella/types').LoggerAPI.ErrorData} data Additional data to log.
   * @returns {Promise<import('@pella/types').LoggerAPI.Response>} The response from the logger service.
   */ error(message, data) {
        return this.#logWrapper('error', message, data);
    }
}
var $05178355e113e06d$export$efa9a398d6368992 = $05178355e113e06d$var$$c4eef40eced35c89$var$Logger;
/**
 * API for Thrive maintenance related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$4e5577cf657703ad$var$Thrive extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/thrive/v3/`
        });
    }
    /**
   * Create a new work order.
   * @param {import('@pella/types').ThriveAPI.CreateWorkOrderInput} variables
   * @returns {Promise<import('@pella/types').ThriveAPI.CreateWorkOrderResponse>}
   */ createWorkOrder(variables) {
        return this._statusCheckedRequest(`projects`, 'post', variables);
    }
    /**
   * Adds a project assignment for an employee.
   * @param {import('@pella/types').ThriveAPI.AddProjectAssignmentInput} variables
   * @returns {Promise<import('@pella/types').ThriveAPI.AddProjectAssignmentResponse>}
   */ addProjectAssignment(variables) {
        return this._statusCheckedRequest(`assignments`, 'post', variables);
    }
    /**
   * Retrieves a list of employees by employeeId.
   * @param {import('@pella/types').ThriveAPI.GetEmployeeByIdInput} employeeId
   * @returns {Promise<import('@pella/types').ThriveAPI.GetEmployeeByIdResponse>}
   */ async getEmployeeById(employeeId) {
        const result = await this._statusCheckedRequest(`employees/${employeeId}/employees`);
        if (!result.length) throw new Error(`No Thrive employee found with ID: ${employeeId}`);
        return result[0];
    }
    /**
   * Retrieves a list of Employees by siteId and employeeId.
   * @param {import('@pella/types').ThriveAPI.GetEmployeesInput} variables
   * @returns {Promise<import('@pella/types').ThriveAPI.GetEmployeesResponse>}
   */ getEmployees({ siteId: siteId, employeeId: employeeId }) {
        return this._statusCheckedRequest(`sites/${siteId}/employees?employee_id=${employeeId}`);
    }
    /**
   * Retrieves a list of sites by optional employeeId.
   * @param {import('@pella/types').ThriveAPI.GetSitesInput} [employeeId]
   * @returns {Promise<import('@pella/types').ThriveAPI.GetSitesResponse>}
   */ getSites(employeeId) {
        const urlAdd = employeeId ? `?employee_id=${employeeId}` : '';
        return this._statusCheckedRequest(`sites${urlAdd}`);
    }
    /**
   * Retrieves a list of departments by siteId.
   * @param {import('@pella/types').ThriveAPI.GetDepartmentsInput} siteId
   * @returns {Promise<import('@pella/types').ThriveAPI.GetDepartmentsResponse>}
   */ getDepartments(siteId) {
        return this._statusCheckedRequest(`sites/${siteId}/departments`);
    }
    /**
   * Retrieves a list of equipment by siteId.
   * @param {import('@pella/types').ThriveAPI.GetEquipmentInput} siteId
   * @returns {Promise<import('@pella/types').ThriveAPI.GetEquipmentResponse>}
   */ getEquipment(siteId) {
        return this._statusCheckedRequest(`sites/${siteId}/equipment`);
    }
    /**
   * Retrieves a list of locations by siteId and departmentId.
   * @param {import('@pella/types').ThriveAPI.GetLocationsInput} variables
   * @returns {Promise<import('@pella/types').ThriveAPI.GetLocationsResponse>}
   */ getLocations({ siteId: siteId, departmentId: departmentId }) {
        return this._statusCheckedRequest(`sites/${siteId}/locations?department_id=${departmentId}`);
    }
    /**
   * Retrieves available categories by siteId.
   * @param {import('@pella/types').ThriveAPI.GetCategoriesInput} siteId
   * @returns {Promise<import('@pella/types').ThriveAPI.GetCategoriesResponse>}
   */ getCategories(siteId) {
        return this._statusCheckedRequest(`sites/${siteId}/categories`);
    }
    /**
   * Retrieves available sub-categories.
   * @returns {Promise<import('@pella/types').ThriveAPI.GetSubCategoriesResponse>}
   */ getSubCategories() {
        return this._statusCheckedRequest(`sub-categories?table_name=PROJECTMT`);
    }
    /**
   * Retrieves available projects.
   * @param {import('@pella/types').ThriveAPI.GetProjectsInput} jsonInput - JSON string input for filtering projects
   * @returns {Promise<import('@pella/types').ThriveAPI.GetProjectsResponse>}
   */ getProjects(jsonInput) {
        return this._statusCheckedRequest(`projects?json_input=${JSON.stringify(jsonInput)}`);
    }
    /**
   * Retrieves spare parts.
   * @param {import('@pella/types').ThriveAPI.GetSparePartsInput} jsonInput - JSON string input for filtering spare parts
   * @returns {Promise<import('@pella/types').ThriveAPI.GetSparePartsResponse>}
   */ getSpareParts(jsonInput) {
        return this._statusCheckedRequest(`spare-parts?json_input=${JSON.stringify(jsonInput)}`);
    }
}
var $05178355e113e06d$export$d2ff27f49bec379 = $05178355e113e06d$var$$4e5577cf657703ad$var$Thrive;
const $05178355e113e06d$var$$a3aca21da02567d4$var$setoffFields = `
    {
        id
        scheduleNumber
        regionId
        region
        status
        reasonType
        reasonName
        reasonId
        parentScheduleNumber
        topScheduleNumber
        orderNumber
        customerPo
        orgId
        organizationCode
        lineNumber
        lineId
        lineCode
        bucket
        slot
        bingo
        scheduledCompletionDate
        scheduleShipDate
        isRapid
        isDVA
        locationId
        location
        locationAisle
        locationSlot
        comments
        stationId
        station
        creationDate
        createdBy
        lastUpdatedDate
        lastUpdatedBy
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$d0924a5c46ca939b = `
    query GetSetoffs($input: GetSetoffsInput!) {
        getSetoffs(input: $input) ${$05178355e113e06d$var$$a3aca21da02567d4$var$setoffFields}
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$974002e2ee772f0b = `
    query GetSetoffById($id: String) {
        getSetoffById(id: $id) ${$05178355e113e06d$var$$a3aca21da02567d4$var$setoffFields}
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$db00ec13268f4e58 = `
    mutation CreateSetoff($input: CreateSetoffInput!) {
        createSetoff(input: $input) ${$05178355e113e06d$var$$a3aca21da02567d4$var$setoffFields}
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$15817d0549ebb2d3 = `
    mutation UpdateSetoff($input: UpdateSetoffsInput!) {
        updateSetoff(input: $input) ${$05178355e113e06d$var$$a3aca21da02567d4$var$setoffFields}
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$5b113266cad3b078 = `
    query GetAreaReasons($areaId: Int!) {
        getAreaReasons(areaId: $areaId) {
            id
            areaId
            type
            name
            creationDate
            createdBy
            lastUpdatedDate
            lastUpdatedBy
        }
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$b4a8755ab077cef1 = `
    query GetRegionReasons($input: GetRegionReasonsInput!) {
        getRegionReasons(input: $input) {
            id
            regionId
            areaReasonId
            type
            name
            createdBy
            creationDate
            lastUpdatedBy
            lastUpdatedDate
        }
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$52fd360e94d8e978 = `
    mutation CreateAreaReason($input: CreateAreaReasonInput!) {
        createAreaReason(input: $input) {
            id
            areaId
            type
            name
            creationDate
            createdBy
            lastUpdatedDate
            lastUpdatedBy
        }
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$b039ab84a43c912 = `
  mutation DeleteAreaReason($id: String!) {
    deleteAreaReason(id: $id) {
      id
      areaId
      type
      name
      creationDate
      createdBy
      lastUpdatedDate
      lastUpdatedBy
    }
  }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$49168ac358490802 = `
  mutation UpdateAreaReason($input: UpdateAreaReasonInput!) {
    updateAreaReason(input: $input) {
        id
        areaId
        type
        name
        creationDate
        createdBy
        lastUpdatedDate
        lastUpdatedBy
      }
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$91d3168c912dbb77 = `
    mutation CreateRegionReason($input: CreateRegionReasonInput!) {
        createRegionReason(input: $input) {
        id
        regionId
        areaReasonId
        createdBy
        creationDate
        lastUpdatedBy
        lastUpdatedDate
      }
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$67fe3026d4c8b764 = `
    mutation DeleteRegionReason($id: String!) {
        deleteRegionReason(id: $id) {
        id
        regionId
        areaReasonId
      }
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$5a7dbc77898e2aed = `
    query GetRegionPartGroups($regionId: Int!) {
    getRegionPartGroups(regionId: $regionId) {
      id
      regionId
      partGroup
      createdBy
      creationDate
      lastUpdatedBy
      lastUpdatedDate
      }
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$10a2038f17cfe316 = `
    mutation CreateRegionPartGroup($input: CreateRegionPartGroupInput!) {
        createRegionPartGroup(input: $input) {
        id
        regionId
        partGroup
        createdBy
        creationDate
        lastUpdatedBy
        lastUpdatedDate
        }
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$90d85977c7fd02ca = `
    mutation DeleteRegionPartGroup($id: String!) {
        deleteRegionPartGroup(id: $id) {
            id
            regionId
            partGroup
            createdBy
            creationDate
            lastUpdatedBy
            lastUpdatedDate
        }
    }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$67c56cc515504a96 = `
  mutation CreateSetoffReorderLink($input: CreateSetoffReorderLinkInput!) {
    createSetoffReorderLink(input: $input) {
      setoffId
      reorderTransactionId
      creationDate
      createdBy
      lastUpdatedDate
      lastUpdatedBy
    }
  }
`;
const $05178355e113e06d$var$$a3aca21da02567d4$export$797a52a9c5957f78 = `
  query GetSetoffReorderLinks($input: GetSetoffReorderLinksInput!) {
    getSetoffReorderLinks(input: $input) {
      setoffId
      reorderTransactionId
      creationDate
      createdBy
      lastUpdatedDate
      lastUpdatedBy
    }
  }
`;
/**
 * API for Setoff related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$d7e2b3f9da7e968c$var$Setoff extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/setoff/graphql/`
        });
        this._graphApi = $05178355e113e06d$export$456995facc43eda({
            ...config,
            baseURL: `${config.baseURL}/setoff/graphql`
        });
    }
    /**
   * Retrieves setoffs based on the provided input variables.
   * @param {import('@pella/types').SetoffAPI.GetSetoffInput} variables
   * @returns {Promise<import('@pella/types').SetoffAPI.GetSetoffsOutput>}
   */ getSetoffs(variables) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$d0924a5c46ca939b, {
            input: variables
        });
    }
    /**
   * Retrieves a setoff by its unique identifier.
   * @param {import('@pella/types').SetoffAPI.GetSetoffByIdInput} id
   * @returns {Promise<import('@pella/types').SetoffAPI.GetSetoffByIdOutput>}
   */ getSetoffById(id) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$974002e2ee772f0b, {
            id: id
        });
    }
    /**
   * Creates a new setoff with the provided input variables.
   * @param {import('@pella/types').SetoffAPI.CreateSetoffInput} input
   * @returns {Promise<import('@pella/types').SetoffAPI.CreateSetoffOutput>}
   */ createSetoff(input) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$db00ec13268f4e58, {
            input: input
        });
    }
    /**
   * Updates an existing setoff with the provided input variables.
   * @param {import('@pella/types').SetoffAPI.UpdateSetoffInput} input
   * @returns {Promise<import('@pella/types').SetoffAPI.UpdateSetoffOutput>}
   */ updateSetoff(input) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$15817d0549ebb2d3, {
            input: input
        });
    }
    /**
   * gets area reasons for setoffs
   * @param {import('@pella/types').SetoffAPI.GetAreaReasonsInput} areaId
   * @returns {Promise<import('@pella/types').SetoffAPI.GetAreaReasonsOutput>}
   */ getAreaReasons(areaId) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$5b113266cad3b078, {
            areaId: areaId
        });
    }
    /**
   * creates an area reason for setoffs
   * @param {import('@pella/types').SetoffAPI.CreateAreaReasonInput} input
   * @returns {Promise<import('@pella/types').SetoffAPI.CreateAreaReasonOutput>}
   */ createAreaReason(input) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$52fd360e94d8e978, {
            input: input
        });
    }
    /**
   * Deletes an area reason by its unique identifier.
   * @param {import('@pella/types').SetoffAPI.DeleteAreaReasonInput} id
   * @returns {Promise<import('@pella/types').SetoffAPI.DeleteAreaReasonOutput>}
   */ deleteAreaReason(id) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$b039ab84a43c912, {
            id: id
        });
    }
    /**
   * Updates an area reason by its unique identifier.
   * @param {import('@pella/types').SetoffAPI.UpdateAreaReasonInput} input
   * @returns {Promise<import('@pella/types').SetoffAPI.UpdateAreaReasonOutput>}
   */ updateAreaReason(input) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$49168ac358490802, {
            input: input
        });
    }
    /**
   * Gets region reasons for setoffs.
   * @param {import('@pella/types').SetoffAPI.GetRegionReasonsInput} input
   * @returns {Promise<import('@pella/types').SetoffAPI.GetRegionReasonsOutput>}
   */ getRegionReasons(input) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$b4a8755ab077cef1, {
            input: input
        });
    }
    /**
   * Creates a new region reason with the provided input variables.
   * @param {import('@pella/types').SetoffAPI.CreateRegionReasonInput} input
   * @returns {Promise<import('@pella/types').SetoffAPI.CreateRegionReasonOutput>}
   */ createRegionReason(input) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$91d3168c912dbb77, {
            input: input
        });
    }
    /**
   * Deletes a region reason by its unique identifier.
   * @param {import('@pella/types').SetoffAPI.DeleteRegionReasonInput} id
   * @returns {Promise<import('@pella/types').SetoffAPI.DeleteRegionReasonOutput>}
   */ deleteRegionReason(id) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$67fe3026d4c8b764, {
            id: id
        });
    }
    /**
   * Gets region part groups for setoffs.
   * @param {import('@pella/types').SetoffAPI.GetRegionPartGroupsInput} regionId
   * @returns {Promise<import('@pella/types').SetoffAPI.GetRegionPartGroupsOutput>}
   */ getRegionPartGroups(regionId) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$5a7dbc77898e2aed, {
            regionId: regionId
        });
    }
    /**
   * Creates a new region part group with the provided input variables.
   * @param {import('@pella/types').SetoffAPI.CreateRegionPartGroupInput} input
   * @returns {Promise<import('@pella/types').SetoffAPI.CreateRegionPartGroupOutput>}
   */ createRegionPartGroup(input) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$10a2038f17cfe316, {
            input: input
        });
    }
    /**
   * Deletes a region part group by its unique identifier.
   * @param {import('@pella/types').SetoffAPI.DeleteRegionPartGroupInput} id
   * @returns {Promise<import('@pella/types').SetoffAPI.DeleteRegionPartGroupOutput>}
   */ deleteRegionPartGroup(id) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$90d85977c7fd02ca, {
            id: id
        });
    }
    /**
   * Creates a new setoff reorder link with the provided input variables.
   * @param {import('@pella/types').SetoffAPI.CreateSetoffReorderLinkInput} input
   * @returns {Promise<import('@pella/types').SetoffAPI.CreateSetoffReorderLinkOutput>}
   */ createSetoffReorderLink(input) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$67c56cc515504a96, {
            input: input
        });
    }
    /**
   * Retrieves setoff reorder links based on the provided input variables.
   * @param {import('@pella/types').SetoffAPI.GetSetoffReorderLinksInput} input
   * @returns {Promise<import('@pella/types').SetoffAPI.GetSetoffReorderLinksOutput>}
   */ getSetoffReorderLinks(input) {
        return this._graphqlRequest($05178355e113e06d$var$$a3aca21da02567d4$export$797a52a9c5957f78, {
            input: input
        });
    }
}
var $05178355e113e06d$export$663cb28d065d5c7f = $05178355e113e06d$var$$d7e2b3f9da7e968c$var$Setoff;
const $05178355e113e06d$var$$d77a94d0b4f9ddf5$export$b35313f82c09ced7 = `
    query GetEbsOrganizations {
        getEbsOrganizations {
            organizationId
            organizationCode
            description
        }
    }`;
/**
 * API for ebs related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$14943ff811f941da$var$Ebs extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types/index.js').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/ebs-api/graphql/`
        });
        this._graphApi = $05178355e113e06d$export$456995facc43eda({
            ...config,
            baseURL: `${config.baseURL}/ebs-api/graphql`
        });
    }
    /**
   * Fetches the organizations from EBS.
   * @returns {Promise<import('@pella/types').EbsAPI.Organization[]>}
   */ getOrganizations() {
        return this._graphqlRequest($05178355e113e06d$var$$d77a94d0b4f9ddf5$export$b35313f82c09ced7);
    }
}
var $05178355e113e06d$export$9373a4b389b77402 = $05178355e113e06d$var$$14943ff811f941da$var$Ebs;
const $05178355e113e06d$var$$1fa31ae66847a300$var$regionFields = `
    {
        regionId
        region
        reorderStationId
        reorderStation
        areaId
        area
        reasonRequired
        completionGroup
        locationRequired
        linkExistingReorders
        defaultSetoffStatus
        creationDate
        createdBy
        lastUpdatedDate
        lastUpdatedBy
        lastUpdateLogin
        locations {
            locationId
            location
            sequenceNumber
            checkDigit1
            checkDigit2
            checkDigit3
            aisle
            slot
            maxPerPick
            creationDate
            createdBy
            lastUpdatedDate
            lastUpdatedBy
            lastUpdateLogin
        }
    }
`;
const $05178355e113e06d$var$$1fa31ae66847a300$export$640c0f43e53c19b5 = `
    query GetSetoffRegions($organizationId: Int, $regionId: Int, $regionIds: [Int]) {
        getSetoffRegions(organizationId: $organizationId, regionId: $regionId, regionIds: $regionIds) ${$05178355e113e06d$var$$1fa31ae66847a300$var$regionFields}
    }
`;
const $05178355e113e06d$var$$1fa31ae66847a300$export$b4ae6491b3c265d4 = `
    query GetSetoffOrgs {
        getSetoffOrgs {
            areaId
            siteId
            ptsSiteId
            ptsPlantId
            organizationId
            organizationCode
            organizationName
        }
    }
`;
const $05178355e113e06d$var$$1fa31ae66847a300$export$1fa41aaaff8525ae = `
    query GetPreferredSetoffRegion($reorderStationId: Int!) {
        getPreferredSetoffRegion(reorderStationId: $reorderStationId) {
        setoffRegionId
        setoffRegionName
        reorderStationId
        reorderStationName
        reorderStationDescription
        allowSkips
        manualAuto
        referenceRegionId
        createdBy
        creationDate
        }
    }`;
const $05178355e113e06d$var$$1fa31ae66847a300$export$2a660dbd83a52649 = `
    mutation PostPreferredSetoffRegion($input: PreferredSetoffRegionInput!) {
        postPreferredSetoffRegion(input: $input) {
            lastRowid
            rowsAffected
        }
    }`;
const $05178355e113e06d$var$$1fa31ae66847a300$export$47e003be7be809e4 = `
    mutation DeletePreferredSetoffRegion($input: PreferredSetoffRegionInput!) {
        deletePreferredSetoffRegion(input: $input) {
            lastRowid
            rowsAffected
        }
    }`;
const $05178355e113e06d$var$$1fa31ae66847a300$export$f71d28df6cbd1315 = `
    query GetSetoffScheduleInfo($scheduleNumber: String!) {
        getSetoffScheduleInfo(scheduleNumber: $scheduleNumber) {
            scheduleNumber
            parentScheduleNumber
            topScheduleNumber
            orderNumber
            customerPo
            organizationId
            organizationCode
            lineNumber
            lineId
            lineCode
            bucket
            slot
            bingo
            scheduledCompletionDate
            scheduleShipDate
            isRapid
            isDVA
        }
      }
    `;
const $05178355e113e06d$var$$1fa31ae66847a300$export$73876eb9d65eecb2 = `
    query GetSetoffRegionAttributes($regionId: Int!, $scheduleNumber: String!) {
        getSetoffRegionAttributes(regionId: $regionId, scheduleNumber: $scheduleNumber) {
            name
            value
        }
    }
`;
const $05178355e113e06d$var$$1fa31ae66847a300$export$3f018cd44edea69d = `
query GetPartsDescription($partNumber: String!) {
    getPartsDescription(input: { partNumber: $partNumber }) {
        description
    }
 
}
`;
const $05178355e113e06d$var$$1fa31ae66847a300$export$2cbdab89b71c32c0 = `
query GetLumberLocationByItem($itemNumber: String!) {
    getLumberLocationByItem(input: { itemNumber: $itemNumber }) {
        item
        location
    }
}
`;
const $05178355e113e06d$var$$1fa31ae66847a300$export$dff4439b3ecfed74 = `query GetDieAndDescription($organizationId: Int!, $item: String!) {
    getDieAndDescription(input: { organizationId: $organizationId, item: $item }) {
        item
        die
        description
    }
}
`;
const $05178355e113e06d$var$$1fa31ae66847a300$export$dd1f7680b94d697a = `query GetLumberItemInfoBySchedule($scheduleNumber: String!) {
    getLumberItemInfoBySchedule(input: { scheduleNumber: $scheduleNumber }) {
        aQty
        aItem
        location
        finalFamily
        panSize
        scheduleNumber
    }
}
`;
const $05178355e113e06d$var$$1fa31ae66847a300$export$759931a1eb518d50 = `query GetPutDownMillLookupByItem($item: String!) {
    getPutDownMillLookupByItem(input: { item: $item }) {
        lotNumber
        lotDate
        qOH
    }
}
`;
/**
 * API for mfg ebs-mfg related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$46a14fcd80abd849$var$EbsMfg extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/ebs-mfg/graphql/`
        });
        this._graphApi = $05178355e113e06d$export$456995facc43eda({
            ...config,
            baseURL: `${config.baseURL}/ebs-mfg/graphql`
        });
    }
    /**
   * Retrieves setoff region based on the provided region ID.
   * @param {import('@pella/types').EbsMfgAPI.GetSetoffRegionsInput} variables
   * @returns {Promise<import('@pella/types').EbsMfgAPI.GetSetoffRegionsOutput>}
   */ getSetoffRegions(variables) {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$640c0f43e53c19b5, variables);
    }
    /**
   * Gets all valid orgs for setoffs
   * @returns {Promise<import('@pella/types').EbsMfgAPI.GetSetoffOrgsOutput[]>}
   */ getSetoffOrgs() {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$b4ae6491b3c265d4);
    }
    /**
   * Retrieves the preferred setoff region for a given reorder station ID.
   * @param {import('@pella/types').EbsMfgAPI.GetPreferredSetoffRegionInput} reorderStationId
   * @returns {Promise<import('@pella/types').EbsMfgAPI.GetPreferredSetoffRegionOutput>}
   */ getPreferredSetoffRegion(reorderStationId) {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$1fa41aaaff8525ae, {
            reorderStationId: reorderStationId
        });
    }
    /**
   * Creates the preferred setoff region for a reorder station.
   * @param {import('@pella/types').EbsMfgAPI.MutatePreferredSetoffRegionInput} input
   * @returns {Promise<import('@pella/types').EbsMfgAPI.MutatePreferredSetoffRegionOutput>}
   */ createPreferredSetoffRegion(input) {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$2a660dbd83a52649, {
            input: input
        });
    }
    /**
   * Deletes the preferred setoff region for a reorder station.
   * @param {import('@pella/types').EbsMfgAPI.MutatePreferredSetoffRegionInput} input
   * @returns {Promise<import('@pella/types').EbsMfgAPI.MutatePreferredSetoffRegionOutput>}
   */ deletePreferredSetoffRegion(input) {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$47e003be7be809e4, {
            input: input
        });
    }
    /**
   * Fetches setoff schedule information based on the provided schedule number.
   * @param {import('@pella/types').EbsMfgAPI.GetSetoffScheduleInfoInput} scheduleNumber
   * @returns {Promise<import('@pella/types').EbsMfgAPI.GetSetoffScheduleInfoOutput>}
   */ getSetoffScheduleInfo(scheduleNumber) {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$f71d28df6cbd1315, {
            scheduleNumber: scheduleNumber
        });
    }
    /**
   * Retrieves setoff region attributes for a given region and schedule.
   * @param {import('@pella/types').EbsMfgAPI.GetSetoffRegionAttributesInput} variables
   * @returns {Promise<import('@pella/types').EbsMfgAPI.GetSetoffRegionAttributesOutput>}
   */ getSetoffRegionAttributes(variables) {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$73876eb9d65eecb2, variables);
    }
    /**
   * Retrieves the description for a given part number.
   * @param {import('@pella/types').EbsMfgAPI.GetPartsDescriptionInput} variables
   * @returns {Promise<import('@pella/types').EbsMfgAPI.GetPartsDescriptionOutput>}
   */ getPartsDescription(variables) {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$3f018cd44edea69d, variables);
    }
    /**
   * Retrieves the lumber location for a given item number.
   * @param {import('@pella/types').EbsMfgAPI.GetLumberLocationByItemInput} variables
   * @returns {Promise<import('@pella/types').EbsMfgAPI.GetLumberLocationByItemOutput>}
   */ getLumberLocationByItem(variables) {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$2cbdab89b71c32c0, variables);
    }
    /**
   * Retrieves the die and description for a given item and organization ID.
   * @param {import('@pella/types').EbsMfgAPI.GetDieAndDescriptionInput} variables
   * @returns {Promise<import('@pella/types').EbsMfgAPI.GetDieAndDescriptionOutput>}
   */ getDieAndDescription(variables) {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$dff4439b3ecfed74, variables);
    }
    /**
   * Retrieves lumber item information based on the provided schedule number.
   * @param {import('@pella/types').EbsMfgAPI.LumberItemInfoByScheduleInput} variables
   * @returns {Promise<import('@pella/types').EbsMfgAPI.LumberItemInfoByScheduleOutput>}
   */ getLumberItemInfoBySchedule(variables) {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$dd1f7680b94d697a, variables);
    }
    /**
   * Retrieves the put down mill lookup information for a given item.
   * @param {import('@pella/types').EbsMfgAPI.PutDownMillLookupInput} variables
   * @returns {Promise<import('@pella/types').EbsMfgAPI.PutDownMillLookupOutput>}
   */ getPutDownMillLookupByItem(variables) {
        return this._graphqlRequest($05178355e113e06d$var$$1fa31ae66847a300$export$759931a1eb518d50, variables);
    }
}
var $05178355e113e06d$export$a9cf63cc251308b2 = $05178355e113e06d$var$$46a14fcd80abd849$var$EbsMfg;
/**
 * API for org management related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$29f230f0b5f1e3a5$var$OrgManagement extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/org-management/v2`
        });
    }
    /**
   * Retrieves all sites.
   * @returns {Promise<import('@pella/types').OrgManagementAPI.SiteOutput>} Array of site objects.
   */ getSites() {
        return this._statusCheckedRequest(`/sites`);
    }
    /**
   * Post a new site
   * @param {import('@pella/types').OrgManagementAPI.SiteInput} site The site object to create.
   * @returns {Promise<import('@pella/types').OrgManagementAPI.CreateUpdateSiteOutput>} The created site object.
   */ createSite(site) {
        return this._statusCheckedRequest(`/sites`, 'post', site);
    }
    /**
   * Update an existing site
   * @param {import('@pella/types').OrgManagementAPI.SiteInput} site The site object to update.
   * @param {import('@pella/types').OrgManagementAPI.SiteId} siteId The ID of the site to update.
   * @returns {Promise<import('@pella/types').OrgManagementAPI.CreateUpdateSiteOutput>} The updated site object.
   */ updateSite(site, siteId) {
        return this._statusCheckedRequest(`/sites/${siteId}`, 'put', site);
    }
    /**
   * Delete a site
   * @param {import('@pella/types').OrgManagementAPI.SiteId} siteId
   * @returns {Promise<import('@pella/types').OrgManagementAPI.CreateUpdateSiteOutput>} An empty object on success.
   */ deleteSite(siteId) {
        return this._statusCheckedRequest(`/sites/${siteId}`, 'delete');
    }
    /**
   * Retrieves all areas for a given site.
   * @param {number} siteId The ID of the site.
   * @returns {Promise<import('@pella/types').OrgManagementAPI.AreaOutput>} Array of area objects.
   */ getAreas(siteId) {
        return this._statusCheckedRequest(`/sites/${siteId}/areas`);
    }
    /**
   * create an area for a given site
   * @param {import('@pella/types').OrgManagementAPI.AreaInput} area The Area object to create
   * @returns {Promise<import('@pella/types').OrgManagementAPI.CreateUpdateAreaOutput>} The created area object.
   */ createArea(area) {
        return this._statusCheckedRequest(`/areas`, 'post', area);
    }
    /**
   * update an area for a given site
   * @param {import('@pella/types').OrgManagementAPI.AreaInput} area The Area object to update
   * @param {import('@pella/types').OrgManagementAPI.AreaId} areaId The ID of the area to update
   * @returns {Promise<import('@pella/types').OrgManagementAPI.CreateUpdateAreaOutput>} The updated area object.
   */ updateArea(area, areaId) {
        return this._statusCheckedRequest(`/areas/${areaId}`, 'put', area);
    }
    /**
   * delete an area by its unique identifier.
   * @param {import('@pella/types').OrgManagementAPI.AreaId} areaId The ID of the area to delete
   * @returns {Promise<import('@pella/types').OrgManagementAPI.CreateUpdateAreaOutput>} An empty object on success.
   */ deleteArea(areaId) {
        return this._statusCheckedRequest(`/areas/${areaId}`, 'delete');
    }
    /**
   * Retrieves all process areas.
   * @returns {Promise<import('@pella/types').OrgManagementAPI.ProcessAreaOutput>} Array of process area objects.
   */ getProcessAreas() {
        return this._statusCheckedRequest(`/areas/process`);
    }
    /**
   * Retrieves all organizations
   * @param {import('@pella/types').OrgManagementAPI.GetOrganizationsInput} variables
   * @returns {Promise<import('@pella/types').OrgManagementAPI.GetOrganizationsOutput>} Array of department objects.
   */ getOrganizations(variables = {}) {
        const queryStringURL = this._buildQueryString(variables);
        return this._statusCheckedRequest(`organizations?${queryStringURL}`);
    }
    /**
   * Retrieves all Organization Inventory Locations
   * @param {import('@pella/types').OrgManagementAPI.GetOrgSubInvLocsInput} variables
   * @returns {Promise<import('@pella/types').OrgManagementAPI.GetOrgSubInvLocsIOutput>}
   */ getOrgSubInvLocs({ orgid: orgid }) {
        return this._statusCheckedRequest(`organizations/${orgid}/subinventories`);
    }
    /**
   * Retrieves lines for an organization.
   * @param {number} orgId - Oracle Organization ID
   * @param {boolean} [release] - Whether to get lines that are ready to release
   * @returns {Promise<Pella.OrgManagementAPI.GetLinesOutput>}
   */ getLines(orgId, release) {
        const params = new URLSearchParams(release ? {
            linetype: 'READY TO RELEASE'
        } : {
            schedules: 'Y'
        });
        return this._statusCheckedRequest(`organizations/${orgId}/lines?${params.toString()}`);
    }
    /**
   * Retrieves operations for a line within an organization.
   * @param {number} orgId - Oracle Organization ID
   * @param {number} lineId - Oracle Line ID
   * @returns {Promise<Pella.OrgManagementAPI.GetOperationsOutput>}
   */ getOperations(orgId, lineId) {
        return this._statusCheckedRequest(`organizations/${orgId}/lines/${lineId}/operations?travelers=Y`);
    }
    /**
   * Retrieves locators for a given organization subinventory and inventory item.
   * @param {import('@pella/types').OrgManagementAPI.GetLocatorsInput} params
   * @returns {Promise<import('@pella/types').OrgManagementAPI.GetLocatorsOutput>}
   */ getLocators({ orgId: orgId, subinventoryCode: subinventoryCode, inventoryItemId: inventoryItemId }) {
        return this._statusCheckedRequest(`organizations/${orgId}/subinventories/${subinventoryCode}/locators?itemid=${inventoryItemId}`);
    }
}
var $05178355e113e06d$export$7819a5a96316d51d = $05178355e113e06d$var$$29f230f0b5f1e3a5$var$OrgManagement;
/**
 * API for InvMgmt related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$575afba37475e9e8$var$InvMgmt extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/inv-mgmt/v2/`
        });
    }
    /**
   * Retrieves a list of cost center distributions by cost center.
   * @param {import('@pella/types').InvMgmtAPI.GetCostCenterDistributionInput}  costCenter
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetCostCenterDistributionResponse>}
   */ async getCostCenterDistribution(costCenter) {
        const result = await this._statusCheckedRequest(`costcenters/${costCenter}`);
        if (!result.length) throw new Error(`No Distributions found for Cost Center: ${costCenter}`);
        return result;
    }
    /**
   * Retrieves a list of Divisions .
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetDivisionsResponse>}
   */ async getDivisions() {
        const result = await this._statusCheckedRequest(`divs`);
        if (!result.length) throw new Error(`No Distributions found`);
        return result;
    }
    /**
   * Retrieves a list of Sub Inv Locations by Division.
   * @param {import('@pella/types').InvMgmtAPI.GetSubInvLocationsInput} division
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetSubInvLocationsResponse>}
   */ async getSubInvLocations({ division: division }) {
        const result = await this._statusCheckedRequest(`divs/${division}/locs`);
        if (!result.length) throw new Error(`No Sub Inv Locations found for Division: ${division}`);
        return result;
    }
    /**
   * Retrieves a list of Cost Centers by Division and Location.
   * @param {import('@pella/types').InvMgmtAPI.GetCostCentersInput} inputs
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetCostCentersResponse>}
   */ async getCostCenters({ division: division, location: location }) {
        const result = await this._statusCheckedRequest(`divs/${division}/locs/${location}/ccs`);
        if (!result.length) throw new Error(`No Cost Centers found for Division: ${division} and Location: ${location}`);
        return result;
    }
    /**
   * Retrieves a list of Account by Division and Location and Cost Center.
   * @param {import('@pella/types').InvMgmtAPI.GetAccountsInput} inputs
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetAccountsResponse>}
   */ async getAccounts({ division: division, location: location, costCenter: costCenter }) {
        const result = await this._statusCheckedRequest(`divs/${division}/locs/${location}/ccs/${costCenter}/accts`);
        if (!result.length) throw new Error(`No Accounts found for Division: ${division} and Location: ${location} and Cost Center: ${costCenter}`);
        return result;
    }
    /**
   * Retrieves a list of Segments by Division and Location and Cost Center and Account
   * @param {import('@pella/types').InvMgmtAPI.GetSegmentsInput} inputs
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetSegmentsResponse>}
   */ async getSegments({ division: division, location: location, costCenter: costCenter, account: account }) {
        const result = await this._statusCheckedRequest(`divs/${division}/locs/${location}/ccs/${costCenter}/accts/${account}/segs`);
        if (!result.length) throw new Error(`No Segments found for Division: ${division} and Location: ${location} and Cost Center: ${costCenter} and Account: ${account}`);
        return result;
    }
    /**
   * Retrieves a list of Inter Comps by Division and Location and Cost Center and Account and segment.
   * @param {import('@pella/types').InvMgmtAPI.GetInterCompsInput} inputs
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetInterCompsResponse>}
   */ async getInterComp({ division: division, location: location, costCenter: costCenter, account: account, segment: segment }) {
        const result = await this._statusCheckedRequest(`divs/${division}/locs/${location}/ccs/${costCenter}/accts/${account}/segs/${segment}/intercomps`);
        if (!result.length) throw new Error(`No Inter Comps found for Division: ${division} and Location: ${location}
     and Cost Center: ${costCenter} and Account: ${account} and Segment: ${segment}`);
        return result;
    }
    /**
   * Retrieves all Organization Inventory Locations
   * @param {import('@pella/types').InvMgmtAPI.GetOrgInvLocationsInput} variables
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetOrgInvLocationsResponse>}
   */ getOrgInvLocations(variables = {}) {
        const queryStringURL = this._buildQueryString(variables);
        return this._statusCheckedRequest(`organizations/invlocations?${queryStringURL}`);
    }
    /**
   * Retrieves all items matching the item number and/or description provided.
   * If both item number and description are provided, results will match both criteria.
   * @param {import('@pella/types').InvMgmtAPI.GetInvItemKeyValuesInput["orgId"]} orgId
   * @param {import('@pella/types').InvMgmtAPI.GetInvItemKeyValuesInput["queryStrings"]} [queryStrings] - Optional item number to filter results.
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetInvItemKeyValuesResponse>}
   */ getInvItemKeyValues(orgId, queryStrings) {
        if (typeof queryStrings === 'object') {
            const queryStringURL = this._buildQueryString(queryStrings);
            return this._statusCheckedRequest(`organizations/${orgId}/items?${queryStringURL}`);
        }
        return this._statusCheckedRequest(`organizations/${orgId}/items`);
    }
    /**
   * Retrieves detailed information for a specific inventory item by its ID.
   * @param {import('@pella/types').InvMgmtAPI.GetInvItemDetailsInput} variables
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetInvItemDetailsResponse>}
   */ getInvItemDetails(variables) {
        const url = `organizations/${variables.orgId}/items/${variables.itemId}`;
        return this._statusCheckedRequest(url);
    }
    /**
   * Create new Move Order Issue
   * @param {import('@pella/types').InvMgmtAPI.CreateMoveOrderInput} variables
   * @returns {Promise<import('@pella/types').InvMgmtAPI.CreateMoveOrderResponse>}
   */ createMoveOrderIssue(variables) {
        return this._statusCheckedRequest(`organizations/${variables.orgId}/moveorders`, 'post', variables.body);
    }
    /**
   * Get Transcation Dispositions From Inventory Management organizationId (plantId)
   * @param {import('@pella/types').InvMgmtAPI.organizationId} organizationId
   * @returns {Promise<import('@pella/types').InvMgmtAPI.Disposition[]|null>}
   */ getDispositionsByOrganizationId(organizationId) {
        return this._statusCheckedRequest(`organizations/${organizationId}/transactions/dispositions`);
    }
    /**
   * Retrieves subinventory quantity on hand (QOH) data for a given organization and item.
   * Optionally filters by subinventoryCode if provided.
   * @param {import('@pella/types').InvMgmtAPI.GetSubinventoryQOHByOrgAndItemInput} variables
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetSubinventoryQOHByOrgAndItemResponse>}
   */ getSubinventoryQOHByOrgAndItem({ orgId: orgId, itemId: itemId, subinventoryCode: subinventoryCode }) {
        const params = {
            itemid: itemId
        };
        if (subinventoryCode) params.subinv = subinventoryCode;
        const queryStringURL = this._buildQueryString(params);
        return this._statusCheckedRequest(`organizations/${orgId}/qoh?${queryStringURL}`);
    }
    /**
   * Create organization transaction
   * @param {import('@pella/types').InvMgmtAPI.OrgTransactionInput} variables
   * @returns {Promise<import('@pella/types').InvMgmtAPI.OrgTransactionResponse[] | null>}
   */ createOrgTransaction(variables) {
        return this._statusCheckedRequest(`organizations/${variables.orgId}/transactions`, 'post', variables.body);
    }
    /**
   * Retrieves subinventory quantity on hand (QOH) data for a given organization and item for if QOH = Y or N
   * @param {import('@pella/types').InvMgmtAPI.GetSubinventoryQOHByOrgAndItemInput} variables
   * @returns {Promise<import('@pella/types').InvMgmtAPI.GetSubinventoryQOHByOrgAndItemResponse>}
   */ getSubinventoryQOHByOrgAndItemWithQOHFlag({ orgId: orgId, itemId: itemId, qoh: qoh }) {
        const params = {
            qoh: qoh
        };
        const queryStringURL = this._buildQueryString(params);
        return this._statusCheckedRequest(`organizations/${orgId}/items/${itemId}/subinventories?${queryStringURL}`);
    }
}
var $05178355e113e06d$export$7ea2f2d2998545fc = $05178355e113e06d$var$$575afba37475e9e8$var$InvMgmt;
const $05178355e113e06d$var$$0e6d9f99fa4d889c$export$1e17895db46c019c = `
    query GetCheckFilterRules($checkFilterRules: [CheckFilterRulesInput!]!) {
        getCheckFilterRules(checkFilterRules: $checkFilterRules) {
            scheduleNumber
            slot
            xferEpcSlot
            xferEpc
            processId
            userName
            status
        }
    }`;
const $05178355e113e06d$var$$0e6d9f99fa4d889c$export$e8712baab05c8604 = `
    query GetEpcRemovalEventData($input: getEpcRemovalEventDataInput!) {
        getEpcRemovalEventData(input: $input) {
            epcGroup
            epcSubGroup
            scheduleNumber
            epc
        }
    }`;
const $05178355e113e06d$var$$0e6d9f99fa4d889c$export$17f021fe4aa5db15 = `
    mutation UnassignEpc($input: UnassignEpcInput!) {
        unassignEpc(input: $input)
    }
`;
/**
 * API for RFID related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$e87e143283a080c5$var$RfidAPI extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/rfid/graphql/`
        });
        this._graphApi = $05178355e113e06d$export$456995facc43eda({
            ...config,
            baseURL: `${config.baseURL}/rfid/graphql`
        });
    }
    /**
   * Runs a filter rule check against the provided input.
   * @param {import('@pella/types').RfidAPI.QueryGetCheckFilterRulesInput[]} checkFilterRules
   * @returns {Promise<import('@pella/types').RfidAPI.QueryGetCheckFilterRulesOutput[]>}
   */ getCheckFilterRules(checkFilterRules) {
        return this._graphqlRequest($05178355e113e06d$var$$0e6d9f99fa4d889c$export$1e17895db46c019c, {
            checkFilterRules: checkFilterRules
        });
    }
    /**
   * Fetches EPC removal event data.
   * @param {import('@pella/types').RfidAPI.GetEpcRemovalDataInput} input
   * @returns {Promise<import('@pella/types').RfidAPI.GetEpcRemovalDataOutput>}
   */ getEpcRemovalEventData(input) {
        return this._graphqlRequest($05178355e113e06d$var$$0e6d9f99fa4d889c$export$e8712baab05c8604, {
            input: input
        });
    }
    /**
   * Unassigns an EPC.
   * @param {import('@pella/types').RfidAPI.UnassignEpcInput} input
   * @returns {Promise<import('@pella/types').RfidAPI.UnassignEpcOutput>}
   */ unassignEpc(input) {
        return this._graphqlRequest($05178355e113e06d$var$$0e6d9f99fa4d889c$export$17f021fe4aa5db15, {
            input: input
        });
    }
}
var $05178355e113e06d$export$e5d44a4194605db9 = $05178355e113e06d$var$$e87e143283a080c5$var$RfidAPI;
/**
 * API for VoiceFlex-related endpoints.
 * Provides methods to interact with VoiceFlex functionality, such as retrieving picking regions.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$d7cc66b4c8c24010$var$VoiceFlex extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/voice-flex/v1/`
        });
    }
    /**
   * Retrieves picking regions for a given area + app combination.
   * @param {import('@pella/types').VoiceFlexAPI.GetPickingRegionsInput} variables
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.GetPickingRegionsOutput>}
   */ getPickingRegions(variables) {
        const queryStringURL = this._buildQueryString(variables);
        return this._statusCheckedRequest(`picking/regions?${queryStringURL}`);
    }
    /**
   * Creates a new picking region.
   * @param {import('@pella/types').VoiceFlexAPI.CreatePickingRegionInput} region The region data to create.
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.CrudOpPickingRegionOutput>}
   */ createPickingRegion(region) {
        return this._statusCheckedRequest('picking/regions', 'post', region);
    }
    /**
   * Updates an existing picking region.
   * @param {number} regionId The ID of the region to update.
   * @param {import('@pella/types').VoiceFlexAPI.UpdatePickingRegionInput} region The updated region data.
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.CrudOpPickingRegionOutput>}
   */ updatePickingRegion(regionId, region) {
        return this._statusCheckedRequest(`picking/regions/${regionId}`, 'put', region);
    }
    /**
   * Deletes a picking region.
   * @param {number} regionId The ID of the region to delete.
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.CrudOpPickingRegionOutput>}
   */ deletePickingRegion(regionId) {
        return this._statusCheckedRequest(`picking/regions/${regionId}`, 'delete');
    }
    /**
   * Gets region attributes by its unique identifier.
   * @param {import('@pella/types').VoiceFlexAPI.GetRegionAttributesInput} regionId
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.GetRegionAttributesOutput>}
   */ getRegionAttributesById(regionId) {
        return this._statusCheckedRequest(`picking/regions/${regionId}/queue-attrs`);
    }
    /**
   * Creates region attributes for a specific region.
   * @param {import('@pella/types').VoiceFlexAPI.CreateRegionAttributeInput} values
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.CrudOpRegionAttributesOutput>}
   */ createRegionAttribute(values) {
        return this._statusCheckedRequest(`picking/regions/${values.regionId}/queue-attrs`, 'post', values);
    }
    /**
   * Updates a specific region attribute.
   * @param {import('@pella/types').VoiceFlexAPI.UpdateRegionAttributeInput}  values
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.CrudOpRegionAttributesOutput>}
   */ updateRegionAttribute(values) {
        return this._statusCheckedRequest(`picking/regions/${values.regionId}/queue-attrs/${values.id}`, 'put', values);
    }
    /**
   * Deletes a specific region attribute.
   * @param {number} regionId
   * @param {number} attributeId
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.CrudOpRegionAttributesOutput>}
   */ deleteRegionAttribute(regionId, attributeId) {
        return this._statusCheckedRequest(`picking/regions/${regionId}/queue-attrs/${attributeId}`, 'delete');
    }
    /**
   * gets picking region locations by regionId
   * @param {import('@pella/types').VoiceFlexAPI.GetPickingRegionLocationsInput} GetPickingRegionLocationsInput
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.GetPickingRegionLocationsOutput>}
   */ getPickingRegionLocations({ regionId: regionId, locationTypeId: locationTypeId }) {
        return this._statusCheckedRequest(`picking/regions/${regionId}/locations?locationTypeId=${locationTypeId}`);
    }
    /**
   * Creates a new picking region location.
   * @param {import('@pella/types').VoiceFlexAPI.CreatePickingRegionLocationsInput} values
   * @param {import('@pella/types').VoiceFlexAPI.CreatePickingRegionLocationParams} [params]
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.CreatePickingRegionLocationOutput>}
   */ createPickingRegionLocation(values, params = {}) {
        const queryStringUrl = this._buildQueryString(params);
        return this._statusCheckedRequest(`picking/regions/${values.regionId}/locations?${queryStringUrl}`, 'post', values.body);
    }
    /**
   * Updates an existing picking location.
   * @param {import('@pella/types').VoiceFlexAPI.UpdatePickingLocationInput} values
   * @param {import('@pella/types').VoiceFlexAPI.UpdatePickingLocationParams} [params]
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.CrudOpPickingRegionLocationOutput>}
   */ updatePickingLocation(values, params) {
        const queryParams = params ?? {
            enforceUniqueLoc: true
        };
        const queryStringUrl = this._buildQueryString(queryParams);
        return this._statusCheckedRequest(`picking/locations/${values.locationId}?${queryStringUrl}`, 'put', values);
    }
    /**
   * Deletes a picking region location.
   * @param {import('@pella/types').VoiceFlexAPI.DeletePickingLocationInput} locationId The ID of the location to delete.
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.CrudOpPickingRegionLocationOutput>}
   */ deletePickingLocation(locationId) {
        return this._statusCheckedRequest(`picking/locations/${locationId}`, 'delete');
    }
    /**
   * Imports setoff region locations, with option to replace existing locations.
   * @param {import('@pella/types').VoiceFlexAPI.ImportSetoffRegionLocationsInput} values
   * @returns {Promise<import('@pella/types').VoiceFlexAPI.ImportSetoffRegionLocationsOutput>}
   */ importSetoffRegionLocations({ regionId: regionId, replace: replace, userName: userName, locations: locations }) {
        return this._statusCheckedRequest(`picking/regions/${regionId}/location-types/4/import?replace=${replace ? 'Y' : 'N'}&username=${userName}`, 'post', locations);
    }
}
var $05178355e113e06d$export$a2df4d2c392ae654 = $05178355e113e06d$var$$d7cc66b4c8c24010$var$VoiceFlex;
/**
 * API for reorder related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$05fd9280c4cc57bd$var$Reorder extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/reorder-mgmt/v2/`
        });
    }
    /**
   * get reorder orgs
   * @returns {Promise<import('@pella/types').ReorderAPI.GetReorderOrgsOutput>} Array of organization objects.
   */ getReorderOrgs() {
        return this._statusCheckedRequest('proc/reorders/organizations');
    }
    /**
   * Get the stations for a specific organization.
   * @param {number} orgId The ID of the organization.
   * @returns {Promise<import('@pella/types').ReorderAPI.StationOutput>} Array of station objects.
   */ getOrgStations(orgId) {
        return this._statusCheckedRequest(`reorders/${orgId}/stations`);
    }
    /**
   * Get the part groups for a specific organization.
   * @param {import('@pella/types').ReorderAPI.GetPartGroupsInput} orgId
   * @returns {Promise<import('@pella/types').ReorderAPI.PartGroupOutput>} Array of part group objects.
   */ getPartGroups(orgId) {
        return this._statusCheckedRequest(`partgroups?orgid=${orgId}`);
    }
    /**
   * Gets station selected method
   * @param {import('@pella/types').ReorderAPI.GenericOrgStationInput} params input
   * @returns {Promise<import('@pella/types').ReorderAPI.SelectionMethodOutput>} selection method
   */ getStationSelectionMethod(params) {
        return this._statusCheckedRequest(`reorders/${params.orgId}/stations/${params.stationId}/search-criteria`);
    }
    /**
   * Get reorder material types
   * @returns {Promise<import('@pella/types').ReorderAPI.ReorderMaterialTypesOutput>} material types
   */ getReorderMaterialTypes() {
        return this._statusCheckedRequest(`reorders/lookups?type=REORDER_MATERIAL_TYPE`);
    }
    /**
   * Gets reasons by reorder station
   * @param {import('@pella/types').ReorderAPI.GenericOrgStationInput} params input
   * @returns {Promise<import('@pella/types').ReorderAPI.ReorderStationReasonsOutput>} reasons
   */ getReasonsByReorderStation(params) {
        return this._statusCheckedRequest(`reorders/${params.orgId}/stations/reasons?reorderstationid=${params.stationId}`);
    }
    /**
   * Gets part information for reorder.
   * @param {import('@pella/types').ReorderAPI.GetReorderPartInfoInput} body input
   * @returns {Promise<import('@pella/types').ReorderAPI.ReorderPartInfoOutput>} part info
   */ async getReorderPartsInformation(body) {
        return await this._statusCheckedRequest(`proc/reorders/parts`, 'post', body);
    }
    /**
   * Posts a reorder request.
   * @param {import('@pella/types').ReorderAPI.PostReorder} body input
   * @returns {Promise<import('@pella/types').ReorderAPI.PostReorderOutput>} reorder result
   */ postReorder(body) {
        return this._statusCheckedRequest(`proc/reorders/reorder`, 'post', body);
    }
    /**
   * Updates the status of a reorder.
   * @param {import('@pella/types').ReorderAPI.UpdateReorderStatus} body
   * @returns {Promise<import('@pella/types').ReorderAPI.UpdateReorderStatusOutput>} status update response
   */ updateReorderStatus(body) {
        return this._statusCheckedRequest(`proc/queues/reorders/progress`, 'post', body);
    }
    /**
   * Create a setoff.
   * @param {number} regionId - Oracle region ID
   * @param {Pella.ReorderAPI.PostSetoffInput} body - Setoff data
   * @returns {Promise<Pella.ReorderAPI.PostSetoffOutput>}
   */ postSetoff(regionId, body) {
        return this._statusCheckedRequest(`proc/setoffs?regionId=${regionId}`, 'post', body);
    }
    /**
   * Update a setoff.
   * @param {Pella.ReorderAPI.UpdateSetoffInput} body - Setoff data
   * @returns {Promise<Pella.ReorderAPI.UpdateSetoffOutput>}
   */ updateSetoff(body) {
        return this._statusCheckedRequest('proc/setoffs', 'put', body);
    }
    /**
   * Get setoff reasons for an organization.
   * @param {number} orgId - Oracle Organization ID
   * @returns {Promise<Pella.ReorderAPI.GetSetoffReasonsOutput>}
   */ getSetoffReasons(orgId) {
        return this._statusCheckedRequest(`proc/setoffs/${orgId}/reasons`);
    }
    /**
   * Get reorder statuses.
   * @returns {Promise<Pella.ReorderAPI.GetReorderStatusesOutput>}
   */ getReorderStatuses() {
        return this._statusCheckedRequest('statuses');
    }
}
var $05178355e113e06d$export$335fca4219867448 = $05178355e113e06d$var$$05fd9280c4cc57bd$var$Reorder;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$defaultOutput = `
    id
    createdBy
    creationDate
    lastUpdatedBy
    lastUpdatedDate
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$plantOutput = `
    active
    description
    organizationId
    wmsOrgCode
    ${$05178355e113e06d$var$$bf8fa41307301ef0$var$defaultOutput}
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$locationOutput = `
    active
    description
    issueToLine
    ${$05178355e113e06d$var$$bf8fa41307301ef0$var$defaultOutput}
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$resourceQueueOutput = `
    queueId
    resourceId
    queueStatus
    active
    createdBy
    creationDate
    lastUpdatedBy
    lastUpdatedDate
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$queueOutput = `
    description
    queueType
    active
    ${$05178355e113e06d$var$$bf8fa41307301ef0$var$defaultOutput}
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$resourceOutput = `
    active
    description
    ${$05178355e113e06d$var$$bf8fa41307301ef0$var$defaultOutput}
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$resourceNestedOutput = `
    resourceQueues {
        ${$05178355e113e06d$var$$bf8fa41307301ef0$var$resourceQueueOutput}
        queue {${$05178355e113e06d$var$$bf8fa41307301ef0$var$queueOutput}}
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$queueNestedOutput = `
    resourceQueues {
        ${$05178355e113e06d$var$$bf8fa41307301ef0$var$resourceQueueOutput}
        resource {${$05178355e113e06d$var$$bf8fa41307301ef0$var$resourceOutput}}
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$selectionListOutput = `
    description
    ${$05178355e113e06d$var$$bf8fa41307301ef0$var$defaultOutput}
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$actionOutput = `
    description
    message
    isDefault
    active
    sequence
    actionPrompt
    showComment
    showDynamicInput
    showQuantity
    showSelectionList
    selectionListId1
    selectionListId2
    actionQuery
    transactionId
    dockSelectionListId
    dispositionId
    completionId
    queue {
        ${$05178355e113e06d$var$$bf8fa41307301ef0$var$queueOutput}
        }
    ${$05178355e113e06d$var$$bf8fa41307301ef0$var$defaultOutput}
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$fullActionOutput = `
    description
    message
    isDefault
    active
    sequence
    actionPrompt
    showComment
    showDynamicInput
    showQuantity
    showSelectionList
    selectionListId1
    selectionListId2
    actionQuery
    transactionId
    dockSelectionListId
    dispositionId
    completionId
    queue {
        ${$05178355e113e06d$var$$bf8fa41307301ef0$var$queueOutput}
        plant {
            ${$05178355e113e06d$var$$bf8fa41307301ef0$var$plantOutput}
        }
    }
    ${$05178355e113e06d$var$$bf8fa41307301ef0$var$defaultOutput}
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$dispositionOutput = `
    dispositionId
    organizationId
    description
    distributionAccount
    segment1
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$inventoryItemOutput = `
    inventoryItemId
    item
    description
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$subinventoryCodeOutput = `
    ${$05178355e113e06d$var$$bf8fa41307301ef0$var$inventoryItemOutput}
    subinventoryCode
    qoh
    primaryUomCode
    unitOfIssueCode
    unitOfIssueQoh
    lotNumber
    locatorId
    organizationId
    locator
    inventoryCreation
    fixedlotMultiplier
    transactionUomCode
    unitOfIssueFixedLot
    locatorTypeId
    locatorType
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$subinventoryInfoOutput = `
    ${$05178355e113e06d$var$$bf8fa41307301ef0$var$inventoryItemOutput}
    lotNumber
    locatorId
    organizationId
    locator
    subinventoryCode
    qoh
    inventoryCreation
    fixedlotMultiplier
    primaryUomCode
    unitOfIssueCode
    transactionUomCode
    unitOfIssueQoh
    unitOfIssueFixedLot
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$var$locatorOutput = `
    subinventoryCode
    organizationId
    description
    locatorTypeId
    locatorType
    locator
    locatorId
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$7c436fc00b92749c = `
    query ProductionRequestQuery($input: PlantFilterInput) {
        productionRequestQuery {
            getPlants(input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$plantOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$cb56085b680c80cc = `
    mutation ProductionRequestMutation($input: PlantInput!) {
        productionRequestMutation {
            createPlant(input: $input)
            {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$plantOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$d38e7bedad8ba854 = `
    mutation ProductionRequestMutation($id: String!, $input: PlantUpdateInput!) {
        productionRequestMutation {
            updatePlantById(id: $id, input: $input)
            {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$plantOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$bfd0829ecbf2571b = `
    mutation ProductionRequestMutation($id: String!) {
        productionRequestMutation {
            deletePlantById(id: $id)
            {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$plantOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$eedb7e02ee7bf6f1 = `
    query ProductionRequestQuery($id: String!, $input: LocationFilterInput) {
        productionRequestQuery {
            getLocationsByPlantId(id: $id, input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$locationOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$7a74adab7788e176 = `
    mutation ProductionRequestMutation($input: LocationInput!) {
        productionRequestMutation {
            createLocation(input: $input)
            {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$locationOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$2da81f7a794ce29c = `
    mutation ProductionRequestMutation($id: String!, $input: LocationUpdateInput!) {
        productionRequestMutation {
            updateLocationById(id: $id, input: $input)
            {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$locationOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$56498980334e5e17 = `
    mutation ProductionRequestMutation($id: String!) {
        productionRequestMutation {
            deleteLocationById(id: $id)
            {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$locationOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$9668c7b1c4b0bde5 = `
    query ProductionRequestQuery($id: String!) {
        productionRequestQuery {
            getActionById(id: $id) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$fullActionOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$294afff4d05a780f = `
    query ProductionRequestQuery($id: String!, $input: ActionFilterInput) {
        productionRequestQuery {
            getActionsByLocationId(id: $id, input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$fullActionOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$1e3cc19894c9a077 = `
    mutation ProductionRequestMutation($input: ActionInput!) {
        productionRequestMutation {
            createAction(input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$actionOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$ae9af387e3795699 = `
    mutation ProductionRequestMutation($id: String!, $input: ActionUpdateInput!) {
        productionRequestMutation {
            updateActionById(id: $id, input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$actionOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$a55b376525dafa61 = `
    mutation ProductionRequestMutation($id: String!) {
        productionRequestMutation {
            deleteActionById(id: $id) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$actionOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$222445e7eaf045cf = `
    query ProductionRequestQuery($input: ResourceQueueFilterInput) {
        productionRequestQuery {
            getResourceQueues(input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$resourceQueueOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$a72b1f1f6bf32de4 = `
    mutation ProductionRequestMutation($input: ResourceQueueInput!) {
        productionRequestMutation {
            createResourceQueue(input: $input)
            {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$resourceQueueOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$4b25348078212247 = `
    mutation ProductionRequestMutation($queueId: String!, $resourceId: String!, $input: ResourceQueueUpdateInput!) {
        productionRequestMutation {
            updateResourceQueueById(queueId: $queueId, resourceId: $resourceId, input: $input)
            {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$resourceQueueOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$cfa2296baa855b43 = `
    mutation ProductionRequestMutation($queueId: String!, $resourceId: String!) {
        productionRequestMutation {
            deleteResourceQueueById(queueId: $queueId, resourceId: $resourceId)
            {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$resourceQueueOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$e5006adcc1104d38 = (resourceQueues)=>`
    query ProductionRequestQuery($id: String!, $input: ResourceFilterInput) {
        productionRequestQuery {
            getResourcesByPlantId(id: $id, input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$resourceOutput}
                ${resourceQueues ? $05178355e113e06d$var$$bf8fa41307301ef0$var$resourceNestedOutput : ''}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$75e87487c4426da0 = `
    mutation ProductionRequestMutation($input: ResourceInput!) {
        productionRequestMutation {
            createResource(input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$resourceOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$550edb159def8483 = `
    mutation ProductionRequestMutation($id: String!, $input: ResourceUpdateInput!) {
        productionRequestMutation {
            updateResourceById(id: $id, input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$resourceOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$ed75e592b8dd06f4 = `
    mutation ProductionRequestMutation($id: String!) {
        productionRequestMutation {
            deleteResourceById(id: $id) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$resourceOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$503f4170d488bde6 = (resourceQueues)=>`
    query ProductionRequestQuery($id: String!, $input: QueueFilterInput) {
        productionRequestQuery {
            getQueuesByPlantId(id: $id, input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$queueOutput}
                ${resourceQueues ? $05178355e113e06d$var$$bf8fa41307301ef0$var$queueNestedOutput : ''}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$72f860c1a63ccc01 = `
    mutation ProductionRequestMutation($input: QueueInput!) {
        productionRequestMutation {
            createQueue(input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$queueOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$2ea684bc920267b5 = `
    mutation ProductionRequestMutation($id: String!, $input: QueueUpdateInput!) {
        productionRequestMutation {
            updateQueueById(id: $id, input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$queueOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$91e253817f1cc738 = `
    mutation ProductionRequestMutation($id: String!) {
        productionRequestMutation {
            deleteQueueById(id: $id) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$queueOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$9374babbd6510da = `
    query ProductionRequestQuery($resourceId: String!) {
        productionRequestQuery {
            getQueuesByResourceId(resourceId: $resourceId)
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$bf3da21f9dd562c9 = `
    query ProductionRequestQuery($id: String!) {
        productionRequestQuery {
            getSelectionListsByPlantId(id: $id) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$selectionListOutput}
                values {
                    ${$05178355e113e06d$var$$bf8fa41307301ef0$var$selectionListOutput}
                }
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$ef3ae3b11f367d50 = `
    query ProductionRequestQuery($id: String!) {
        productionRequestQuery {
            getSelectionListById(id: $id) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$selectionListOutput}
                values {
                    ${$05178355e113e06d$var$$bf8fa41307301ef0$var$selectionListOutput}
                }
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$e142e7848761cbca = `
    mutation ProductionRequestMutation($input: SelectionListInput!) {
        productionRequestMutation {
            createSelectionList(input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$selectionListOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$e8f20faa4376bb2a = `
    mutation ProductionRequestMutation($id: String!, $input: SelectionListUpdateInput!) {
        productionRequestMutation {
            updateSelectionListById(id: $id, input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$selectionListOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$93915f0eaade271b = `
    mutation ProductionRequestMutation($id: String!) {
        productionRequestMutation {
            deleteSelectionListById(id: $id) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$selectionListOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$639205f81eb3e807 = `
    mutation ProductionRequestMutation($input: SelectionListValueInput!) {
        productionRequestMutation {
            createSelectionListValue(input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$selectionListOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$179b57041cc69158 = `
    mutation ProductionRequestMutation($id: String!, $input: SelectionListValueUpdateInput!) {
        productionRequestMutation {
            updateSelectionListValueById(id: $id, input: $input) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$selectionListOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$67f12cdf9842540c = `
    mutation ProductionRequestMutation($id: String!) {
        productionRequestMutation {
            deleteSelectionListValueById(id: $id) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$selectionListOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$a48f632e9775347d = `
    query ProductionRequestQuery($resourceId: String!, $status: String) {
        productionRequestQuery {
            getRequestsByResourceId(resourceId: $resourceId, status: $status)
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$cc73d6a9d6873216 = `
    query ProductionRequestQuery($resourceId: String!) {
        productionRequestQuery {
            getCompletedRequestsByResourceId(resourceId: $resourceId)
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$d97f41c42902ae92 = `
    query ProductionRequestQuery($locationId: String!) {
        productionRequestQuery {
            getRequestsByLocationIdByStatus(locationId: $locationId)
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$4c4dd4c269fab3d1 = `
    query ProductionRequestQuery($locationId: String!) {
        productionRequestQuery {
            getCompletedRequestsByLocationIdByStatus(locationId: $locationId)
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$4b6ed651dad8f830 = `
    mutation ProductionRequestMutation($input: RequestInput!) {
        productionRequestMutation {
            createRequest(input: $input)
            {
                comment
                requestQty
                dynamicInput
                dynamicInputResult
                requestorId
                status
                dropDownListVal1
                dropDownListVal2
                invTransactionId
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$defaultOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$8cf045a075e94921 = `
    mutation ProductionRequestMutation($id: String!, $input: RequestUpdateInput!) {
        productionRequestMutation {
            updateRequestById(id: $id, input: $input)
            {
                id
                status
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$fbd96d968c62a03d = `
    query ProductionRequestQuery($id: String!) {
        productionRequestQuery {
            getDispositionsByPlantId(id: $id) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$dispositionOutput}
            }
        }
    }
`;
// Trailer To Dock - Queries and Mutations
const $05178355e113e06d$var$$bf8fa41307301ef0$var$carrierOutput = `
    carrierId
    scacCode
    freightCode
    carrierName
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$9a576156f94a2f4a = `
    query ProductionRequestQuery {
        productionRequestQuery {
            getCarrierList {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$carrierOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$911401472cac21a4 = `
    mutation ProductionRequestMutation($input: TrailerToDockTransactionInput!) {
        productionRequestMutation {
            createTrailerToDockTransaction(input: $input)
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$30b0d94351c6d277 = `
    query ProductionRequestQuery($organizationId: Int!, $item: String!) {
        productionRequestQuery {
            getInventoryItemIdByPlant(organizationId: $organizationId, item: $item)
            {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$inventoryItemOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$3e3b22237c0c486f = `
    query ProductionRequestQuery($organizationId: Int!, $inventoryItemId: Int!, $qoh: quantityOnHandFilter) {
        productionRequestQuery {
            getSubinventoryCodesByPlant(organizationId: $organizationId, inventoryItemId: $inventoryItemId, qoh: $qoh)
            {
                 ${$05178355e113e06d$var$$bf8fa41307301ef0$var$subinventoryCodeOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$d04f700d8aafbb1f = `
    query ProductionRequestQuery($organizationId: Int!, $inventoryItemId: Int!, $subinventoryCode: String!) {
        productionRequestQuery {
            getSubinventoryInfoByPlant(organizationId: $organizationId, inventoryItemId: $inventoryItemId, subinventoryCode: $subinventoryCode) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$subinventoryInfoOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$c21ec318a2e3155e = `
    query ProductionRequestQuery($organizationId: Int!, $subinventoryCode: String!, $inventoryItemId: Int!) {
        productionRequestQuery {
            getLocators(organizationId: $organizationId, subinventoryCode: $subinventoryCode, inventoryItemId: $inventoryItemId) {
                ${$05178355e113e06d$var$$bf8fa41307301ef0$var$locatorOutput}
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$2cbdab89b71c32c0 = `
    query ProductionRequestQuery($itemNumber: String!) {
        productionRequestQuery {
            getLumberLocationByItem(itemNumber: $itemNumber) {
                item
                location
            }
        }
    }
`;
const $05178355e113e06d$var$$bf8fa41307301ef0$export$3c54c95294d2f3a7 = `
    mutation ProductionRequestMutation($input: CreateInvMgmtTransactionInput!) {
        productionRequestMutation {
            createInvMgmtTransaction(input: $input) {
                itemId
                transactionHeaderId
                sourceLineId
                transactionUom
                TransactionQuantity
                transactionInterfaceId
                errorCode
            }
        }
    }
`;
/**
 * API for Production Request related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$b75f7c3f616b0313$var$ProductionRequest extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        const { baseURL: baseURL } = config;
        super({
            ...config,
            baseURL: `${baseURL}/production-request/graphql/`
        });
        this._graphApi = $05178355e113e06d$export$456995facc43eda({
            ...config,
            baseURL: `${baseURL}/production-request/graphql`
        });
    }
    /**
   * Gets all valid plants for production requests
   * @param {Pella.ProductionRequestAPI.GetPlantsInput} [input]
   * @returns {Promise<Pella.ProductionRequestAPI.GetPlantsOutput>}
   */ async getPlants(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$7c436fc00b92749c, {
            input: input
        });
        return response.getPlants;
    }
    /**
   * Creates a new plant
   * @param {Pella.ProductionRequestAPI.CreatePlantInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.Plant>}
   */ async createPlant(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$cb56085b680c80cc, {
            input: input
        });
        return response.createPlant;
    }
    /**
   * Updates an existing plant
   * @param {Pella.ProductionRequestAPI.Plant['id']} id Plant ID
   * @param {Pella.ProductionRequestAPI.UpdatePlantInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.Plant>}
   */ async updatePlant(id, input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$d38e7bedad8ba854, {
            id: id,
            input: input
        });
        return response.updatePlantById;
    }
    /**
   * Deletes an existing plant
   * @param {Pella.ProductionRequestAPI.Plant['id']} id Plant ID
   * @returns {Promise<Pella.ProductionRequestAPI.Plant>}
   */ async deletePlant(id) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$bfd0829ecbf2571b, {
            id: id
        });
        return response.deletePlantById;
    }
    /**
   * Gets locations for a specific plant
   * @param {string} id Plant ID
   * @param {Pella.ProductionRequestAPI.GetLocationsByPlantInput} [input]
   * @returns {Promise<Pella.ProductionRequestAPI.GetLocationsByPlantOutput>}
   */ async getLocationsByPlant(id, input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$eedb7e02ee7bf6f1, {
            id: id,
            input: input
        });
        return response.getLocationsByPlantId;
    }
    /**
   * Creates a new location
   * @param {Pella.ProductionRequestAPI.CreateLocationInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.Location>}
   */ async createLocation(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$7a74adab7788e176, {
            input: input
        });
        return response.createLocation;
    }
    /**
   * Updates an existing location
   * @param {Pella.ProductionRequestAPI.Location['id']} id Location ID
   * @param {Pella.ProductionRequestAPI.UpdateLocationInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.Location>}
   */ async updateLocation(id, input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$2da81f7a794ce29c, {
            id: id,
            input: input
        });
        return response.updateLocationById;
    }
    /**
   * Deletes an existing location
   * @param {Pella.ProductionRequestAPI.Location['id']} id Location ID
   * @returns {Promise<Pella.ProductionRequestAPI.Location>}
   */ async deleteLocation(id) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$56498980334e5e17, {
            id: id
        });
        return response.deleteLocationById;
    }
    /**
   * Gets an action by ID
   * @param {string} id Action ID
   * @returns {Promise<Pella.ProductionRequestAPI.Action>}
   */ async getActionById(id) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$9668c7b1c4b0bde5, {
            id: id
        });
        return response.getActionById;
    }
    /**
   * Gets actions for a specific location
   * @param {string} id Location ID
   * @param {Pella.ProductionRequestAPI.GetActionsByLocationInput} [input]
   * @returns {Promise<Pella.ProductionRequestAPI.GetActionsByLocationOutput>}
   */ async getActionsByLocation(id, input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$294afff4d05a780f, {
            id: id,
            input: input
        });
        return response.getActionsByLocationId;
    }
    /**
   * creates an action for a specific plant
   * @param {Pella.ProductionRequestAPI.CreateUpdateActionInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.Action>}
   */ async createAction(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$1e3cc19894c9a077, {
            input: input
        });
        return response.createAction;
    }
    /**
   * updates an existing action
   * @param {Pella.ProductionRequestAPI.Action['id']} id Action ID
   * @param {Pella.ProductionRequestAPI.CreateUpdateActionInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.Action>}
   */ async updateAction(id, input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$ae9af387e3795699, {
            id: id,
            input: input
        });
        return response.updateActionById;
    }
    /**
   * Deletes an action
   * @param {Pella.ProductionRequestAPI.Action['id']} id Action ID
   * @returns {Promise<Pella.ProductionRequestAPI.Action>}
   */ async deleteAction(id) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$a55b376525dafa61, {
            id: id
        });
        return response.deleteActionById;
    }
    /**
   * Gets resources for a specific plant with optional inclusion of resourceQueues
   * @param {Pella.ProductionRequestAPI.Plant['id']} id Plant ID
   * @param {boolean} [resourceQueues=false] Whether to include resourceQueues in the response
   * @param {Pella.ProductionRequestAPI.GetResourcesInput} [input={}]
   * @returns {Promise<Pella.ProductionRequestAPI.GetResourcesByPlantOutput>}
   */ async getResourcesByPlant(id, resourceQueues = false, input = {}) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$e5006adcc1104d38(resourceQueues), {
            id: id,
            input: input
        });
        return response.getResourcesByPlantId;
    }
    /**
   * Creates a new resource
   * @param {Pella.ProductionRequestAPI.CreateResourceInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.Resource>}
   */ async createResource(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$75e87487c4426da0, {
            input: input
        });
        return response.createResource;
    }
    /**
   * Updates an existing resource
   * @param {Pella.ProductionRequestAPI.Resource['id']} id Resource ID
   * @param {Pella.ProductionRequestAPI.UpdateResourceInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.Resource>}
   */ async updateResource(id, input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$550edb159def8483, {
            id: id,
            input: input
        });
        return response.updateResourceById;
    }
    /**
   * Deletes an existing resource
   * @param {Pella.ProductionRequestAPI.Resource['id']} id Resource ID
   * @returns {Promise<Pella.ProductionRequestAPI.Resource>}
   */ async deleteResource(id) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$ed75e592b8dd06f4, {
            id: id
        });
        return response.deleteResourceById;
    }
    /**
   * Gets queues for a specific plant
   * @param {Pella.ProductionRequestAPI.Plant['id']} id Plant ID
   * @param {boolean} [resourceQueues=false] Whether to include resourceQueues in the response
   * @param {Pella.ProductionRequestAPI.GetQueuesByPlantInput} [input={}]
   * @returns {Promise<Pella.ProductionRequestAPI.GetQueuesByPlantOutput>}
   */ async getQueuesByPlant(id, resourceQueues = false, input = {}) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$503f4170d488bde6(resourceQueues), {
            id: id,
            input: input
        });
        return response.getQueuesByPlantId;
    }
    /**
   * Creates a new queue
   * @param {Pella.ProductionRequestAPI.CreateQueueInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.Queue>}
   */ async createQueue(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$72f860c1a63ccc01, {
            input: input
        });
        return response.createQueue;
    }
    /**
   * Updates an existing queue
   * @param {Pella.ProductionRequestAPI.Queue['id']} id Queue ID
   * @param {Pella.ProductionRequestAPI.UpdateQueueInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.Queue>}
   */ async updateQueue(id, input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$2ea684bc920267b5, {
            id: id,
            input: input
        });
        return response.updateQueueById;
    }
    /**
   * Deletes an existing queue
   * @param {Pella.ProductionRequestAPI.Queue['id']} id Queue ID
   * @returns {Promise<Pella.ProductionRequestAPI.Queue>}
   */ async deleteQueue(id) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$91e253817f1cc738, {
            id: id
        });
        return response.deleteQueueById;
    }
    /**
   * Gets resource queue associations.
   * Retrieves the relationship between resources and queues, not just queues.
   * @param {Pella.ProductionRequestAPI.GetResourcesQueuesInput} [input]
   * @returns {Promise<Pella.ProductionRequestAPI.GetResourcesQueuesOutput>}
   */ async getResourceQueues(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$222445e7eaf045cf, {
            input: input
        });
        return response.getResourceQueues;
    }
    /**
   * Gets status grouped requests for the specified resource
   * @param {Pella.ProductionRequestAPI.Resource['id']} resourceId Resource ID
   * @param {Pella.ProductionRequestAPI.GetRequestsByResourceInput['status']} [status] Status filter
   * @returns {Promise<Pella.ProductionRequestAPI.GetRequestsOutput>}
   */ async getRequestsByResource(resourceId, status) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$a48f632e9775347d, {
            resourceId: resourceId,
            status: status
        });
        return response.getRequestsByResourceId;
    }
    /**
   * Gets completed requests within 3 days for the specified resource
   * @param {Pella.ProductionRequestAPI.Resource['id']} resourceId Resource ID
   * @returns {Promise<Pella.ProductionRequestAPI.GetCompletedRequestsOutput>}
   */ async getCompletedRequestsByResource(resourceId) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$cc73d6a9d6873216, {
            resourceId: resourceId
        });
        return response.getCompletedRequestsByResourceId;
    }
    /**
   * Gets status grouped requests for the specified location
   * @param {Pella.ProductionRequestAPI.Location['id']} locationId Location ID
   * @returns {Promise<Pella.ProductionRequestAPI.GetRequestsOutput>}
   */ async getRequestsByLocation(locationId) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$d97f41c42902ae92, {
            locationId: locationId
        });
        return response.getRequestsByLocationIdByStatus;
    }
    /**
   * Gets completed requests within 3 days for the specified location
   * @param {Pella.ProductionRequestAPI.Location['id']} locationId Location ID
   * @returns {Promise<Pella.ProductionRequestAPI.GetCompletedRequestsOutput>}
   */ async getCompletedRequestsByLocation(locationId) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$4c4dd4c269fab3d1, {
            locationId: locationId
        });
        return response.getCompletedRequestsByLocationIdByStatus;
    }
    /**
   * Gets queues for the specified resource
   * @param {Pella.ProductionRequestAPI.Resource['id']} resourceId Resource ID
   * @returns {Promise<Pella.ProductionRequestAPI.GetQueuesByResourceOutput>}
   */ async getQueuesByResource(resourceId) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$9374babbd6510da, {
            resourceId: resourceId
        });
        return response.getQueuesByResourceId;
    }
    /**
   * Creates a production request
   * @param {Pella.ProductionRequestAPI.CreateRequestInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.CreateRequestOutput>}
   */ async createRequest(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$4b6ed651dad8f830, {
            input: input
        });
        return response.createRequest;
    }
    /**
   * Updates a production request by ID
   * @param {Pella.ProductionRequestAPI.Request['id']} id Request ID
   * @param {Pella.ProductionRequestAPI.UpdateRequestInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.UpdateRequestOutput>}
   */ async updateRequest(id, input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$8cf045a075e94921, {
            id: id,
            input: input
        });
        return response.updateRequestById;
    }
    /**
   * Creates a resource queue association
   * @param {Pella.ProductionRequestAPI.CreateResourceQueueInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.ResourceQueueMutationOutput>}
   */ async createResourceQueue(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$a72b1f1f6bf32de4, {
            input: input
        });
        return response.createResourceQueue;
    }
    /**
   * Updates a resource queue association
   * @param {Pella.ProductionRequestAPI.Queue['id']} queueId
   * @param {Pella.ProductionRequestAPI.Resource['id']} resourceId
   * @param {Pella.ProductionRequestAPI.UpdateResourceQueueInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.ResourceQueueMutationOutput>}
   */ async updateResourceQueue(queueId, resourceId, input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$4b25348078212247, {
            queueId: queueId,
            resourceId: resourceId,
            input: input
        });
        return response.updateResourceQueueById;
    }
    /**
   * Deletes a resource queue association
   * @param {Pella.ProductionRequestAPI.DeleteResourceQueueInput} variables
   * @returns {Promise<Pella.ProductionRequestAPI.ResourceQueueMutationOutput>}
   */ async deleteResourceQueue(variables) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$cfa2296baa855b43, variables);
        return response.deleteResourceQueueById;
    }
    /**
   * Gets selection lists for a specific plant
   * @param {Pella.ProductionRequestAPI.Plant['id']} id Plant ID
   * @returns {Promise<Pella.ProductionRequestAPI.SelectionList[]>}
   */ async getSelectionListsByPlant(id) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$bf3da21f9dd562c9, {
            id: id
        });
        return response.getSelectionListsByPlantId;
    }
    /**
   * Get a selection list by ID
   * @param {Pella.ProductionRequestAPI.SelectionList['id']} id Selection List ID
   * @returns {Promise<Pella.ProductionRequestAPI.SelectionList>}
   */ async getSelectionListById(id) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$ef3ae3b11f367d50, {
            id: id
        });
        return response.getSelectionListById;
    }
    /**
   * Creates a new selection list
   * @param {Pella.ProductionRequestAPI.CreateSelectionListInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.SelectionList>}
   */ async createSelectionList(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$e142e7848761cbca, {
            input: input
        });
        return response.createSelectionList;
    }
    /**
   * Updates an existing selection list
   * @param {Pella.ProductionRequestAPI.SelectionList['id']} id Selection List ID
   * @param {Pella.ProductionRequestAPI.UpdateSelectionListInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.SelectionList>}
   */ async updateSelectionList(id, input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$e8f20faa4376bb2a, {
            id: id,
            input: input
        });
        return response.updateSelectionListById;
    }
    /**
   * Deletes an existing selection list
   * @param {Pella.ProductionRequestAPI.SelectionList['id']} id Selection List ID
   * @returns {Promise<Pella.ProductionRequestAPI.SelectionList>}
   */ async deleteSelectionList(id) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$93915f0eaade271b, {
            id: id
        });
        return response.deleteSelectionListById;
    }
    /**
   * Creates a value within a selection list
   * @param {Pella.ProductionRequestAPI.CreateSelectionListValueInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.SelectionList>}
   */ async createSelectionListValue(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$639205f81eb3e807, {
            input: input
        });
        return response.createSelectionListValue;
    }
    /**
   * Updates an existing selection list value
   * @param {Pella.ProductionRequestAPI.SelectionList['id']} id Selection List ID
   * @param {Pella.ProductionRequestAPI.UpdateSelectionListInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.SelectionList>}
   */ async updateSelectionListValue(id, input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$179b57041cc69158, {
            id: id,
            input: input
        });
        return response.updateSelectionListValueById;
    }
    /**
   * Deletes an existing selection list value
   * @param {Pella.ProductionRequestAPI.SelectionList['id']} id Selection List ID
   * @returns {Promise<Pella.ProductionRequestAPI.SelectionList>}
   */ async deleteSelectionListValue(id) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$67f12cdf9842540c, {
            id: id
        });
        return response.deleteSelectionListValueById;
    }
    /**
   * Gets the list of carriers from WMS via the production request service
   * @returns {Promise<Pella.ProductionRequestAPI.GetCarrierListOutput>}
   */ async getCarrierList() {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$9a576156f94a2f4a);
        return response.getCarrierList;
    }
    /**
   * Creates a Trailer To Dock transaction in WMS via the production request service
   * @param {Pella.ProductionRequestAPI.CreateTrailerToDockTransactionInput} input
   * @returns {Promise<string>}
   */ async createTrailerToDockTransaction(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$911401472cac21a4, {
            input: input
        });
        return response.createTrailerToDockTransaction;
    }
    /**
   * single source of truth for transaction types for prod request
   * @returns {Pella.ProductionRequestAPI.TransactionTypesOutput}
   */ getTransactionTypes() {
        const transactionTypes = [
            {
                id: 'TRAILER_TO_DOCK',
                description: 'Trailer to Dock'
            },
            {
                id: 'SUB_INVENTORY_TRANSFER',
                description: 'Sub Inventory Transfer'
            },
            {
                id: 'DIRECT_ORG_TRANSFER',
                description: 'Direct Org Transfer'
            },
            {
                id: 'ISSUE_TO_LINE',
                description: 'Issue to Line'
            }
        ];
        return transactionTypes;
    }
    /**
   * Get dispositions by plantId
   * @param {string} id Plant ID
   * @returns {Promise<Pella.ProductionRequestAPI.GetDispositionsByPlantIdOutput>}
   */ async getDispositionsByPlantId(id) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$fbd96d968c62a03d, {
            id: id
        });
        return response.getDispositionsByPlantId;
    }
    /**
   * Get inventory item id by plant
   * @param {Pella.ProductionRequestAPI.GetInventoryItemIdByPlantInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.GetInventoryItemIdByPlantOutput[]>}
   */ async getInventoryItemIdByPlant({ organizationId: organizationId, item: item }) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$30b0d94351c6d277, {
            organizationId: organizationId,
            item: item
        });
        return response.getInventoryItemIdByPlant;
    }
    /**
   * Get subinventory codes by plant
   * @param {Pella.ProductionRequestAPI.GetSubinventoryCodesByPlantInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.GetSubinventoryCodesByPlantOutput[]>}
   */ async getSubinventoryCodesByPlant(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$3e3b22237c0c486f, input);
        return response.getSubinventoryCodesByPlant;
    }
    /**
   * get subinventory info by org inventory item and subinventory code
   * @param {Pella.ProductionRequestAPI.GetSubinventoryInfoByPlantInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.GetSubinventoryInfoByPlantOutput[]>}
   */ async getSubinventoryInfoByPlant(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$d04f700d8aafbb1f, {
            organizationId: input.organizationId,
            inventoryItemId: input.inventoryItemId,
            subinventoryCode: input.subinventoryCode
        });
        return response.getSubinventoryInfoByPlant;
    }
    /**
   * Get locators by organization, subinventory code, and inventory item
   * @param {Pella.ProductionRequestAPI.GetLocatorsInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.GetLocatorsOutput>}
   */ async getLocators(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$c21ec318a2e3155e, {
            organizationId: input.organizationId,
            subinventoryCode: input.subinventoryCode,
            inventoryItemId: input.inventoryItemId
        });
        return response.getLocators;
    }
    /**
   * Retrieves the lumber location for a given item number.
   * @param {Pella.ProductionRequestAPI.GetLumberLocationByItemInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.GetLumberLocationByItemOutput>}
   */ async getLumberLocationByItem(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$2cbdab89b71c32c0, {
            itemNumber: input.itemNumber
        });
        return response.getLumberLocationByItem;
    }
    /**
   * Create inventory mgmt transaction
   * @param {Pella.ProductionRequestAPI.CreateInvMgmtTransactionInput} input
   * @returns {Promise<Pella.ProductionRequestAPI.CreateInvMgmtTransactionOutput>}
   */ async createInvMgmtTransaction(input) {
        const response = await this._graphqlRequest($05178355e113e06d$var$$bf8fa41307301ef0$export$3c54c95294d2f3a7, {
            input: input
        });
        return response.createInvMgmtTransaction;
    }
}
var $05178355e113e06d$export$71724e294857d2c8 = $05178355e113e06d$var$$b75f7c3f616b0313$var$ProductionRequest;
/**
 * API for IoT Message Queue related endpoints.
 * Provides methods to submit Kafka messages to the iot-msg-queue service.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$85ed1147352e11fd$var$IotMsgQueue extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/iot-msg-queue/v3/kafka/`
        });
    }
    /**
   * Posts a message to Kafka via the iot-msg-queue service.
   * @param {import('@pella/types').IotMsgQueueAPI.SendMessageInput} params - Parameters for posting the message
   * @returns {Promise<import('@pella/types').IotMsgQueueAPI.SendMessageResponse>}
   */ sendMessage({ topic: topic, key: key, headers: headers, value: value, entity: entity }) {
        const body = {
            topic: topic,
            key: key,
            value: value
        };
        // Only include headers if provided
        if (headers !== undefined) body.headers = headers;
        // Only include entity if provided
        if (entity !== undefined) body.entity = entity;
        return this._statusCheckedRequest('message', 'post', body);
    }
    /**
   * Posts a socket message to Kafka via the iot-msg-queue service.
   * @param {import('@pella/types').IotMsgQueueAPI.SendSocketInput} params - Parameters for posting the socket message
   * @returns {Promise<import('@pella/types').IotMsgQueueAPI.SendSocketResponse>}
   */ sendSocket({ socket: socket, event: event, data: data }) {
        return this._statusCheckedRequest('socket', 'post', {
            socket: socket,
            event: event,
            data: data
        });
    }
}
var $05178355e113e06d$export$c8622ddcdf78b8e = $05178355e113e06d$var$$85ed1147352e11fd$var$IotMsgQueue;
/**
 * API for manufacturing utilities related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$51b8c55a095f9165$var$MfgUtils extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/mfg-utils/public/v1/`
        });
    }
    /**
   * posts a notification
   * @param {import('@pella/types').MfgUtilsAPI.NotificationInput} body
   * @returns {Promise<import('@pella/types').MfgUtilsAPI.NotificationOutput>} notification response
   */ postNotification = (body)=>this._statusCheckedRequest('notification', 'post', body);
}
var $05178355e113e06d$export$3084edaf00709acc = $05178355e113e06d$var$$51b8c55a095f9165$var$MfgUtils;
/**
 * API for WMS related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$ba1426b15b007a17$var$Wms extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/wms/v1/`
        });
    }
    /**
   * Fetches carriers from WMS.
   * @returns {Promise<import('@pella/types').WmsAPI.Carrier[]>}
   */ async getCarriers() {
        const { data: data } = await this._api.get('dock-audit/carriers');
        return data.response;
    }
    /**
   * Creates a trailerToDock Transaction in WMS
   * @param {import('@pella/types').WmsAPI.TrailerToDockTransaction} transactionData - The data for the trailer to dock transaction.
   * @returns {Promise<'Success'>} The message from the WMS response.
   */ async createTrailerToDockTransaction(transactionData) {
        const { data: _data } = await this._api.post('dock-audit/dock-trailers', transactionData);
        // normalize the keys to lowercase the first letter only
        const data = Object.fromEntries(Object.entries(_data).map(([k, v])=>[
                `${k.charAt(0).toLowerCase()}${k.slice(1)}`,
                v
            ]));
        if (Number(data.status) < 200 || Number(data.status) > 204) throw new Error(data.message);
        return data.message;
    }
}
var $05178355e113e06d$export$b70f49b452c4df9b = $05178355e113e06d$var$$ba1426b15b007a17$var$Wms;
/**
 * API for Sub Assembly related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$2d20932a0bf960a3$var$SubAssembly extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/pella-schedule/`
        });
    }
    /**
   * Create a new Sub Assembly report.
   * @param {number} orgId - Oracle Organization ID
   * @param {Pella.SubAssemblyAPI.CreateSubAssemblyInput} body - Report data
   * @returns {Promise<Pella.SubAssemblyAPI.CreateSubAssemblyOutput>}
   */ createSubAssembly(orgId, body) {
        return this._statusCheckedRequest(`v2/unb/?orgId=${orgId}`, 'post', body);
    }
    /**
   * Update a Sub Assembly report.
   * @param {string} id - Sub Assembly report ID
   * @param {Pella.SubAssemblyAPI.UpdateSubAssemblyInput} body - Report data
   * @returns {Promise<Pella.SubAssemblyAPI.UpdateSubAssemblyOutput>}
   */ updateSubAssembly(id, body) {
        return this._statusCheckedRequest(`v2/unb/${id}`, 'put', body);
    }
    /**
   * Delete a Sub Assembly report.
   * @param {string} id - Sub Assembly report ID
   * @returns {Promise<Pella.SubAssemblyAPI.DeleteSubAssemblyOutput>}
   */ deleteSubAssembly(id) {
        return this._statusCheckedRequest(`v2/unb/${id}`, 'delete');
    }
    /**
   * Get summary data for a Sub Assembly report.
   * @param {string} id - Sub Assembly report ID
   * @param {string} [process] - Process name
   * @param {Pella.SubAssemblyAPI.ScheduleFilterInput} [body] - Additional input parameters
   * @returns {Promise<Pella.SubAssemblyAPI.GetSummaryOutput>}
   */ getSummary(id, process, body) {
        return this._statusCheckedRequest(`v2/unb/${id}/schedules/summary${process ? `?process=${process}` : ''}`, 'post', body);
    }
    /**
   * Get paginated schedules for a Sub Assembly report.
   * @param {string} id - Sub Assembly report ID
   * @param {number} offset - Offset for pagination
   * @param {number} limit - Limit for pagination
   * @param {Pella.SubAssemblyAPI.GetSelectionInput} body - Additional input parameters
   * @returns {Promise<Pella.SubAssemblyAPI.GetSelectionOutput>}
   */ getSelection(id, offset, limit, body) {
        return this._statusCheckedRequest(`v3/unb/${id}/schedules?offset=${offset}&limit=${limit}`, 'post', body);
    }
    /**
   * Get details for a given schedule.
   * @param {string} id - Sub Assembly report ID
   * @param {string} schedule - Schedule Number
   * @param {Pella.SubAssemblyAPI.GetDetailsInput} [options] - Additional input parameters
   * @returns {Promise<Pella.SubAssemblyAPI.GetDetailsOutput>}
   */ getDetails(id, schedule, { publicAccess: publicAccess, section: section, expanded: expanded } = {}) {
        const basePath = `${publicAccess ? 'public/' : ''}v2/unb/${id}/schedules/${schedule}/detail`;
        const queryParams = this._buildQueryString({
            // Preserve existing behavior: only include expanded when truthy, as "true"
            expanded: expanded ? 'true' : undefined,
            section: section
        });
        return this._statusCheckedRequest(`${basePath}${queryParams ? `?${queryParams}` : ''}`);
    }
    /**
   * Get children for a given schedule and level.
   * @param {string} id - Sub Assembly report ID
   * @param {string} schedule - Schedule ID
   * @param {string} level - How many levels deep to get children
   * @param {Pella.SubAssemblyAPI.GetChildrenInput} body - Additional input parameters
   * @returns {Promise<Pella.SubAssemblyAPI.GetChildrenOutput>}
   */ getChildren(id, schedule, level, body) {
        return this._statusCheckedRequest(`v3/unb/${id}/schedules/${schedule}?level=${level}`, 'post', body);
    }
    /**
   * Export schedules for a Sub Assembly report.
   * @param {string} id - Sub Assembly report ID
   * @param {Pella.SubAssemblyAPI.ExportSchedulesInput} body - Additional input parameters
   * @param {Pella.SubAssemblyAPI.ExportType} type - Type of export, defines the columns
   * @returns {Promise<Pella.SubAssemblyAPI.ExportSchedulesOutput>}
   */ exportSchedules(id, body, type) {
        return this._statusCheckedRequest(`v3/unb/${id}/schedules/export?type=${type}`, 'post', body);
    }
    /**
   * Get headers for export.
   * @param {string} id - Sub Assembly report ID
   * @param {Pella.SubAssemblyAPI.ExportType} type - Type of export, defines the columns
   * @returns {Promise<Pella.SubAssemblyAPI.GetExportHeadersOutput>}
   */ getExportHeaders(id, type) {
        return this._statusCheckedRequest(`v3/unb/${id}/schedules/export/headers?type=${type}`);
    }
    /**
   * Post a comment on a schedule.
   * @param {Pella.SubAssemblyAPI.PostCommentInput} body - Comment data
   * @returns {Promise<Pella.SubAssemblyAPI.PostCommentOutput>}
   */ postComment(body) {
        return this._statusCheckedRequest('v3/unb/schedules/comments', 'post', body);
    }
    /**
   * Get Sub Assembly reports for an organization.
   * @param {number} orgId - Oracle Organization ID
   * @param {Pella.SubAssemblyAPI.ReportType} [type] - Type of report
   * @param {boolean} [publicAccess] - Public access flag
   * @returns {Promise<Pella.SubAssemblyAPI.GetReportsByOrgOutput>}
   */ getReportsByOrg(orgId, type, publicAccess) {
        return this._statusCheckedRequest(`${publicAccess ? 'public/' : ''}v2/unb/?orgId=${orgId}&type=${type || ''}`);
    }
    /**
   * Copy a Sub Assembly report.
   * @param {string} id - Sub Assembly report ID
   * @param {Pella.SubAssemblyAPI.CopyReportInput} body - Copy options
   * @returns {Promise<Pella.SubAssemblyAPI.CopyReportOutput>}
   */ copyReport(id, body) {
        return this._statusCheckedRequest(`v2/unb/${id}/copy`, 'post', body);
    }
    /**
   * Get filter setup help.
   * @param {string} type - Filter help type
   * @param {Pella.SubAssemblyAPI.GetSetupInputHintsInput} [body] - Additional input parameters (only used when type === 'hints')
   * @returns {Promise<Pella.SubAssemblyAPI.GetSetupInputDescriptionsOutput>}
   */ getSetupInputDescriptions(type, body) {
        return this._statusCheckedRequest(`v2/unb/setup/input/${type}`, type === 'hints' ? 'post' : 'get', type === 'hints' ? body : undefined);
    }
    /**
   * Get attribute types for a given organization.
   * @param {number} orgId - Oracle Organization ID
   * @returns {Promise<Pella.SubAssemblyAPI.GetAttributeTypesOutput>}
   */ getAttributeTypes(orgId) {
        return this._statusCheckedRequest(`v3/unb/organizations/${orgId}/attributes/types`);
    }
    /**
   * Get values for a given attribute.
   * @param {number} orgId - Oracle Organization ID
   * @param {string} type - Attribute type
   * @param {string} attribute - Attribute name
   * @param {Pella.SubAssemblyAPI.GetAttributeValuesInput} body - Additional input parameters
   * @returns {Promise<Pella.SubAssemblyAPI.GetAttributeValuesOutput>}
   */ getAttributeValues(orgId, type, attribute, body) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/attributes/values?type=${type}&attribute=${attribute}`, 'post', body);
    }
    /**
   * Get line setup data.
   * @param {number} orgId - Oracle Organization ID
   * @param {string} lineId - Oracle Line ID
   * @returns {Promise<Pella.SubAssemblyAPI.GetOrgAttrReadyLineOutput>}
   */ getOrgAttrReadyLine(orgId, lineId) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/lines/${lineId}`);
    }
    /**
   * Create a new line rule.
   * @param {number} orgId - Oracle Organization ID
   * @param {string} lineId - Oracle Line ID
   * @param {Pella.SubAssemblyAPI.PostLineRulesInput} body - Additional input parameters
   * @returns {Promise<Pella.SubAssemblyAPI.PostLineRulesOutput>}
   */ postLineRules(orgId, lineId, body) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/lines/${lineId}`, 'post', body);
    }
    /**
   * Execute a custom action.
   * @param {string} id - Sub Assembly report ID
   * @param {number} limit - Limit for pagination
   * @param {Pella.SubAssemblyAPI.ExecuteActionInput} body - Additional input parameters
   * @returns {Promise<Pella.SubAssemblyAPI.ExecuteActionOutput>}
   */ executeAction(id, limit, body) {
        return this._statusCheckedRequest(`v2/unb/${id}/schedules/action?limit=${limit}`, 'post', body);
    }
    /**
   * Get releases for a Sub Assembly report by status.
   * @param {string} id - Sub Assembly report ID
   * @param {string} status - Status of the release
   * @returns {Promise<Pella.SubAssemblyAPI.GetReleasesByStatusOutput>}
   */ getReleasesByStatus(id, status) {
        return this._statusCheckedRequest(`v2/unb/${id}/schedules/release?status=${status}`);
    }
    /**
   * Delete Sub Assembly releases.
   * @param {string} id - Sub Assembly report ID
   * @param {Pella.SubAssemblyAPI.DeleteReleasesInput} body - Additional input parameters
   * @returns {Promise<Pella.SubAssemblyAPI.DeleteReleasesOutput>}
   */ deleteReleases(id, body) {
        return this._statusCheckedRequest(`v2/unb/${id}/schedules/release/deletereleases`, 'post', body);
    }
    /**
   * Get the history of a Sub Assembly release.
   * @param {string} id - Sub Assembly report ID
   * @param {string} releaseId - Release ID
   * @returns {Promise<Pella.SubAssemblyAPI.GetReleaseHistoryOutput>}
   */ getReleaseHistory(id, releaseId) {
        return this._statusCheckedRequest(`v2/unb/${id}/schedules/release/history/${releaseId}`);
    }
    /**
   * Restore a Sub Assembly release.
   * @param {string} id - Sub Assembly report ID
   * @param {Pella.SubAssemblyAPI.RestoreReleaseInput} body - Additional input parameters
   * @returns {Promise<Pella.SubAssemblyAPI.RestoreReleaseOutput>}
   */ restoreRelease(id, body) {
        return this._statusCheckedRequest(`v2/unb/${id}/schedules/release/history/restore`, 'post', body);
    }
    /**
   * Get report groups for an organization.
   * @param {number} orgId - Oracle Organization ID
   * @returns {Promise<Pella.SubAssemblyAPI.GetReportGroupsOutput>}
   */ getReportGroups(orgId) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/report-groups`);
    }
    /**
   * Create a new report group.
   * @param {number} orgId - Oracle Organization ID
   * @param {Pella.SubAssemblyAPI.CreateReportGroupInput} body - Group data
   * @returns {Promise<Pella.SubAssemblyAPI.CreateReportGroupOutput>}
   */ createReportGroup(orgId, body) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/report-groups`, 'post', body);
    }
    /**
   * Update a report group.
   * @param {number} orgId - Oracle Organization ID
   * @param {Pella.SubAssemblyAPI.UpdateReportGroupInput} body - Group data
   * @returns {Promise<Pella.SubAssemblyAPI.UpdateReportGroupOutput>}
   */ updateReportGroup(orgId, body) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/report-groups`, 'put', body);
    }
    /**
   * Delete a report group.
   * @param {number} orgId - Oracle Organization ID
   * @param {string} name - Group name
   * @returns {Promise<Pella.SubAssemblyAPI.DeleteReportGroupOutput>}
   */ deleteReportGroup(orgId, name) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/report-groups?groupName=${name}`, 'delete');
    }
    /**
   * Get organization custom attributes.
   * @param {number} orgId - Oracle Organization ID
   * @returns {Promise<Pella.SubAssemblyAPI.GetCustomAttributesOutput>}
   */ getCustomAttributes(orgId) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/attributes`);
    }
    /**
   * Add a new custom attribute.
   * @param {number} orgId - Oracle Organization ID
   * @param {Pella.SubAssemblyAPI.AddCustomAttributeInput} body - Attribute data
   * @returns {Promise<Pella.SubAssemblyAPI.AddCustomAttributeOutput>}
   */ addCustomAttribute(orgId, body) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/attributes`, 'post', body);
    }
    /**
   * Update a custom attribute.
   * @param {number} orgId - Oracle Organization ID
   * @param {string} id - Attribute ID
   * @param {Pella.SubAssemblyAPI.UpdateCustomAttributeInput} body - Attribute data
   * @returns {Promise<Pella.SubAssemblyAPI.UpdateCustomAttributeOutput>}
   */ updateCustomAttribute(orgId, id, body) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/attributes/${id}`, 'put', body);
    }
    /**
   * Delete a custom attribute.
   * @param {number} orgId - Oracle Organization ID
   * @param {string} id - Attribute ID
   * @returns {Promise<Pella.SubAssemblyAPI.DeleteCustomAttributeOutput>}
   */ deleteCustomAttribute(orgId, id) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/attributes/${id}`, 'delete');
    }
    /**
   * Get custom statuses for an organization.
   * @param {number} orgId - Oracle Organization ID
   * @returns {Promise<Pella.SubAssemblyAPI.GetStatusesOutput>}
   */ getStatuses(orgId) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/status`);
    }
    /**
   * Add a new custom status.
   * @param {number} orgId - Oracle Organization ID
   * @param {Pella.SubAssemblyAPI.CreateStatusInput} body - Status data
   * @returns {Promise<Pella.SubAssemblyAPI.CreateStatusOutput>}
   */ createStatus(orgId, body) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/status`, 'post', body);
    }
    /**
   * Update a custom status.
   * @param {number} orgId - Oracle Organization ID
   * @param {Pella.SubAssemblyAPI.UpdateStatusInput} body - Status data
   * @returns {Promise<Pella.SubAssemblyAPI.UpdateStatusOutput>}
   */ updateStatus(orgId, body) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/status`, 'put', body);
    }
    /**
   * Delete a custom status.
   * @param {number} orgId - Oracle Organization ID
   * @param {string} id - Status ID
   * @returns {Promise<Pella.SubAssemblyAPI.DeleteStatusOutput>}
   */ deleteStatus(orgId, id) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/status?_id=${id}`, 'delete');
    }
    /**
   * Get Bucket Groups for an organization.
   * @param {number} orgId - Oracle Organization ID
   * @returns {Promise<Pella.SubAssemblyAPI.GetBucketGroupsOutput>}
   */ getBucketGroups(orgId) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/bucket-groups`);
    }
    /**
   * Create a new Bucket Group.
   * @param {number} orgId - Oracle Organization ID
   * @param {Pella.SubAssemblyAPI.CreateBucketGroupInput} body - Group data
   * @returns {Promise<Pella.SubAssemblyAPI.CreateBucketGroupOutput>}
   */ createBucketGroup(orgId, body) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/bucket-groups`, 'post', body);
    }
    /**
   * Update a Bucket Group.
   * @param {number} orgId - Oracle Organization ID
   * @param {Pella.SubAssemblyAPI.UpdateBucketGroupInput} body - Group data
   * @returns {Promise<Pella.SubAssemblyAPI.UpdateBucketGroupOutput>}
   */ updateBucketGroup(orgId, body) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/bucket-groups`, 'put', body);
    }
    /**
   * Delete a Bucket Group.
   * @param {number} orgId - Oracle Organization ID
   * @param {string} id - Group ID
   * @returns {Promise<Pella.SubAssemblyAPI.DeleteBucketGroupOutput>}
   */ deleteBucketGroup(orgId, id) {
        return this._statusCheckedRequest(`v2/unb/organizations/${orgId}/bucket-groups?_id=${id}`, 'delete');
    }
    /**
   * Get schedules from a prebuilt report.
   * @param {string} id - Sub Assembly report ID
   * @param {number} offset - Offset for pagination
   * @param {number} limit - Limit for pagination
   * @param {Pella.SubAssemblyAPI.GetCustomReportInput} body - Additional input parameters
   * @param {boolean} [publicAccess] - Public access flag
   * @returns {Promise<Pella.SubAssemblyAPI.GetCustomReportOutput>}
   */ getCustomReport(id, offset, limit, body, publicAccess) {
        return this._statusCheckedRequest(`${publicAccess ? 'public/' : ''}v2/unb/${id}/prebuilt?offset=${offset}&limit=${limit}`, 'post', body);
    }
    /**
   * Get default badge settings.
   * @returns {Promise<Pella.SubAssemblyAPI.GetBadgeDefaultsOutput>}
   */ getBadgeDefaults() {
        return this._statusCheckedRequest('v2/unb/setup/badges');
    }
    /**
   * Check for rule updates on a line.
   * @param {number} lineId - Oracle Line ID
   * @returns {Promise<Pella.SubAssemblyAPI.GetRuleUpdatesOutput>}
   */ getRuleUpdates(lineId) {
        return this._statusCheckedRequest(`v2/unb/organizations/rules?lineId=${lineId}&active=true`);
    }
    /**
   * Run a TSQL query against Mongo.
   * @param {Pella.SubAssemblyAPI.SqlQueryInput} body - Additional input parameters
   * @returns {Promise<Pella.SubAssemblyAPI.SqlQueryOutput>}
   */ sqlQuery(body) {
        return this._statusCheckedRequest('v2/unb/setup/input/sql', 'post', body);
    }
}
var $05178355e113e06d$export$7653c09775ed54a2 = $05178355e113e06d$var$$2d20932a0bf960a3$var$SubAssembly;
/**
 * API for data download related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$b3704755c78328f4$var$DataDownload extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/data-download/`
        });
    }
    /**
   * Get download reports.
   * @returns {Promise<Pella.DataDownloadAPI.GetDownloadReportsOutput>}
   */ getDownloadReports() {
        return this._statusCheckedRequest('v2/reports');
    }
    /**
   * Get machines by organization ID.
   * @param {number} orgId - Organization ID
   * @returns {Promise<Pella.DataDownloadAPI.GetMachinesByOrgOutput>}
   */ getMachinesByOrg(orgId) {
        return this._statusCheckedRequest(`v2/machines?org_id=${orgId}`);
    }
}
var $05178355e113e06d$export$b7d695dd824ac980 = $05178355e113e06d$var$$b3704755c78328f4$var$DataDownload;
/**
 * API for manufacturing rules related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$523ea9489286459f$var$MfgRules extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/mfg-rules/`
        });
    }
    /**
   * Get rules for an organization.
   * @param {Pella.MfgRulesAPI.GetRulesInput} params - Parameters for getting rules
   * @returns {Promise<Pella.MfgRulesAPI.GetRulesOutput>}
   */ getRules({ process: process = 'TRAVELLER', orgId: orgId, type: type }) {
        const queryStringURL = this._buildQueryString({
            process: process,
            type: type,
            orgid: orgId
        });
        return this._statusCheckedRequest(`v2/rules?${queryStringURL}`);
    }
    /**
   * Get code snippets for an application.
   * @param {string} [process='SUB_ASSEMBLY'] - Process type (default: 'SUB_ASSEMBLY')
   * @returns {Promise<Pella.MfgRulesAPI.GetCodeSnippetsOutput>}
   */ getCodeSnippets(process = 'SUB_ASSEMBLY') {
        const queryStringURL = this._buildQueryString({
            process: process
        });
        return this._statusCheckedRequest(`v2/codesnippets?${queryStringURL}`);
    }
}
var $05178355e113e06d$export$f2c82820b5d5fbca = $05178355e113e06d$var$$523ea9489286459f$var$MfgRules;
/**
 * API for operations report services related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$2995bfc0883c038b$var$OpsReportServices extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/ops-report-services/`
        });
    }
    /**
   * Get Oracle travelers.
   * @param {Pella.OpsReportServicesAPI.GetTravelersInput} variables - Query parameters
   * @returns {Promise<Pella.OpsReportServicesAPI.GetTravelersOutput>}
   */ getTravelers(variables) {
        const queryStringURL = this._buildQueryString(variables);
        return this._statusCheckedRequest(`v1/travelers?${queryStringURL}`);
    }
    /**
   * Get Oracle printers.
   * @returns {Promise<Pella.OpsReportServicesAPI.GetPrintersOutput>}
   */ getPrinters() {
        return this._statusCheckedRequest('v1/printers');
    }
    /**
   * Get Oracle interface types.
   * @returns {Promise<Pella.OpsReportServicesAPI.GetInterfaceTypesOutput>}
   */ getInterfaceTypes() {
        return this._statusCheckedRequest('v1/value-sets?validationType=I&name=PEL_ACCY_ROLL_INTERFACE');
    }
}
var $05178355e113e06d$export$74822590bc20bb = $05178355e113e06d$var$$2995bfc0883c038b$var$OpsReportServices;
/**
 * API for RFID v1 REST related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$534585f09b854ff4$var$RfidV1 extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Constructor
   * @param {import('../../types').APIConfig} config
   */ constructor(config){
        super({
            ...config,
            baseURL: `${config.baseURL}/rfid/v1/`
        });
    }
    /**
   * Get cart groups.
   * @param {number} siteId - Site ID
   * @param {number} areaId - Area ID
   * @returns {Promise<Pella.RfidV1API.GetCartGroupsOutput>}
   */ getCartGroups(siteId, areaId) {
        return this._statusCheckedRequest(`groups?siteid=${siteId}&areaid=${areaId}`);
    }
    /**
   * Get cart subgroups.
   * @param {number} groupId - Cart group ID
   * @param {number} siteId - Site ID
   * @returns {Promise<Pella.RfidV1API.GetCartSubGroupsOutput>}
   */ getCartSubGroups(groupId, siteId) {
        return this._statusCheckedRequest(`groups/${groupId}/subgroups?siteid=${siteId}`);
    }
    /**
   * Get cart info by EPC.
   * @param {string} epc - EPC or alias
   * @returns {Promise<Pella.RfidV1API.GetCartInfoOutput>}
   */ getCartInfo(epc) {
        return this._statusCheckedRequest(`tags?epctypeid=2&epc=${epc}`);
    }
    /**
   * Assign schedules to a cart.
   * @param {string} tag - EPC value
   * @param {'Y'|'N'} actions - Determines if group actions should be executed
   * @param {Pella.RfidV1API.AssignToCartInput[]} body - Request body
   * @returns {Promise<Pella.RfidV1API.AssignToCartOutput>}
   */ assignToCart(tag, actions, body) {
        return this._statusCheckedRequest(`tags/${tag}/proc/assign?cycle=Y&filters=Y&actions=${actions}`, 'post', body);
    }
}
var $05178355e113e06d$export$8ed68dd588c248b2 = $05178355e113e06d$var$$534585f09b854ff4$var$RfidV1;
// ── Shared Output Fragments ──────────────────────────────────────────────────
const $05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput = `
    id
    createdBy
    creationDate
    lastUpdatedBy
    lastUpdatedDate
`;
const $05178355e113e06d$var$$cdb72321fb58675b$var$areaOutput = `
    areaCode
    orgAreaId
    orgSiteId
    areaName
    siteName
    ${$05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput}
`;
const $05178355e113e06d$var$$cdb72321fb58675b$var$specDefinitionOutput = `
    scope
    areaId
    name
    description
    notes
    processNumber
    processName
    operationDescription
    machineDeviceTools
    printNumber
    characteristic
    characteristicType
    importance
    potentialFailure
    resultsOfFailure
    version
    productProcessSpecification
    toleranceUpper
    toleranceLower
    evaluationMeasurementTechnique
    sampleSize
    frequencyType
    frequencyInterval
    frequencyCount
    controlMethod
    reactionPlan
    isActive
    area { ${$05178355e113e06d$var$$cdb72321fb58675b$var$areaOutput} }
    ${$05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput}
`;
const $05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileWindowOutput = `
    shiftProfileId
    parentWindowId
    name
    dayOfWeek
    startTime
    endTime
    sortOrder
    children {
        shiftProfileId
        parentWindowId
        name
        dayOfWeek
        startTime
        endTime
        sortOrder
        children {
            shiftProfileId
            parentWindowId
            name
            dayOfWeek
            startTime
            endTime
            sortOrder
            ${$05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput}
        }
        ${$05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput}
    }
    ${$05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput}
`;
const $05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileOutput = `
    areaId
    name
    description
    timeZone
    effectiveFrom
    effectiveUntil
    windows { ${$05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileWindowOutput} }
    area { ${$05178355e113e06d$var$$cdb72321fb58675b$var$areaOutput} }
    ${$05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput}
`;
const $05178355e113e06d$var$$cdb72321fb58675b$var$specOutput = `
    controlPlanId
    specDefinitionId
    sortOrder
    processNumber
    processName
    operationDescription
    machineDeviceTools
    printNumber
    characteristic
    characteristicType
    importance
    potentialFailure
    resultsOfFailure
    version
    productProcessSpecification
    toleranceUpper
    toleranceLower
    toleranceRaw
    evaluationMeasurementTechnique
    sampleSize
    frequencyType
    frequencyInterval
    frequencyCount
    shiftProfileId
    secondaryFrequencyType
    secondaryFrequencyInterval
    secondaryFrequencyCount
    secondarySampleSize
    conditions
    sampleSizeFrequencyRaw
    codeRaw
    controlMethod
    controlMethodRaw
    reactionPlan
    reactionPlanRaw
    shiftProfile { ${$05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileOutput} }
    specDefinition { ${$05178355e113e06d$var$$cdb72321fb58675b$var$specDefinitionOutput} }
    ${$05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput}
`;
const $05178355e113e06d$var$$cdb72321fb58675b$var$controlPlanOutput = `
    areaId
    planNumber
    planNumberDept
    planNumberSeq
    productDescription
    productionArea
    status
    revisionNumber
    revisionDate
    area { ${$05178355e113e06d$var$$cdb72321fb58675b$var$areaOutput} }
    specs { ${$05178355e113e06d$var$$cdb72321fb58675b$var$specOutput} }
    ${$05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput}
`;
const $05178355e113e06d$var$$cdb72321fb58675b$var$cascadeAffectedSpecOutput = `
    specId
    controlPlanId
    planNumber
    areaName
    currentValue
    proposedValue
    excluded
    exclusionJustification
`;
const $05178355e113e06d$var$$cdb72321fb58675b$var$definitionCascadeOutput = `
    specDefinitionId
    specDefinition { ${$05178355e113e06d$var$$cdb72321fb58675b$var$specDefinitionOutput} }
    proposedChanges
    status
    affectedSpecCount
    affectedSpecs { ${$05178355e113e06d$var$$cdb72321fb58675b$var$cascadeAffectedSpecOutput} }
    excludedSpecIds
    appliedAt
    rejectedAt
    ${$05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput}
`;
const $05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileValidationOutput = `
    valid
    shiftGaps {
        dayOfWeek
        start
        end
    }
    periodGaps {
        parentWindowId
        parentName
        dayOfWeek
        start
        end
    }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$af26b533538d3bcc = `
  query QcGetAllAreas {
    qcGetAllAreas {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$areaOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$94358260ceeef1bc = `
  query QcGetAreaById($id: ID!) {
    qcGetAreaById(id: $id) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$areaOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$bac1e8fb385bcb74 = `
  mutation QcCreateArea($input: QcCreateAreaInput!) {
    qcCreateArea(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$areaOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$c3b87a2a55ebc775 = `
  mutation QcUpdateArea($input: QcUpdateAreaInput!) {
    qcUpdateArea(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$areaOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$ebeac39201768940 = `
  mutation QcDeleteArea($id: ID!) {
    qcDeleteArea(id: $id)
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$var$controlPlanSummaryOutput = `
    areaId
    planNumber
    planNumberDept
    planNumberSeq
    productDescription
    productionArea
    status
    revisionNumber
    revisionDate
    specs {
        id
        frequencyType
        sampleSize
    }
    area { ${$05178355e113e06d$var$$cdb72321fb58675b$var$areaOutput} }
    ${$05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput}
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$11e8e4b9f54e50d6 = `
  query QcGetAllControlPlans($status: QcControlPlanStatus, $areaId: ID) {
    qcGetAllControlPlans(status: $status, areaId: $areaId) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$controlPlanSummaryOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$9e08f525e26f556e = `
  query QcGetControlPlanById($id: ID!) {
    qcGetControlPlanById(id: $id) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$controlPlanOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$783f0501ebe45965 = `
  query QcGetAllControlPlans($status: QcControlPlanStatus, $areaId: ID) {
    qcGetAllControlPlans(status: $status, areaId: $areaId) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$controlPlanOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$19dc3e69591f37b0 = `
  mutation QcCreateControlPlan($input: QcCreateControlPlanInput!) {
    qcCreateControlPlan(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$controlPlanOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$d3c68320a574536e = `
  mutation QcUpdateControlPlan($input: QcUpdateControlPlanInput!) {
    qcUpdateControlPlan(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$controlPlanOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$f60af3ccfee63217 = `
  mutation QcDeleteControlPlan($id: ID!) {
    qcDeleteControlPlan(id: $id)
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$dcb06518671d82ed = `
  query QcGetSpecById($id: ID!) {
    qcGetSpecById(id: $id) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$specOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$9386d0c93b5b1b73 = `
  query QcGetSpecsByControlPlanId($controlPlanId: ID!) {
    qcGetSpecsByControlPlanId(controlPlanId: $controlPlanId) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$specOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$8b9b92ce861997dc = `
  mutation QcCreateSpec($input: QcCreateSpecInput!) {
    qcCreateSpec(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$specOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$787b64e6de27e6a5 = `
  mutation QcUpdateSpec($input: QcUpdateSpecInput!) {
    qcUpdateSpec(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$specOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$82f2541849d885b5 = `
  mutation QcDeleteSpec($id: ID!) {
    qcDeleteSpec(id: $id)
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$f75e341e57b175a9 = `
  query QcGetSpecDefinitionById($id: ID!) {
    qcGetSpecDefinitionById(id: $id) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$specDefinitionOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$c849eb2c294e8a06 = `
  query QcGetAllSpecDefinitions($scope: QcSpecDefinitionScope, $areaId: ID) {
    qcGetAllSpecDefinitions(scope: $scope, areaId: $areaId) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$specDefinitionOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$488d111903c6badc = `
  mutation QcCreateSpecDefinition($input: QcCreateSpecDefinitionInput!) {
    qcCreateSpecDefinition(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$specDefinitionOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$fd43415e299fcdd6 = `
  mutation QcUpdateSpecDefinition($input: QcUpdateSpecDefinitionInput!) {
    qcUpdateSpecDefinition(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$specDefinitionOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$fa13b5a0784424ff = `
  mutation QcDeleteSpecDefinition($id: ID!) {
    qcDeleteSpecDefinition(id: $id)
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$303184d3c14e8a46 = `
  mutation QcPromoteSpecDefinition($input: QcPromoteSpecDefinitionInput!) {
    qcPromoteSpecDefinition(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$specDefinitionOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$9f79afd88c1fb3d8 = `
  query QcGetShiftProfileById($id: ID!) {
    qcGetShiftProfileById(id: $id) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$d255455927e07fed = `
  query QcGetShiftProfilesByAreaId($areaId: ID!) {
    qcGetShiftProfilesByAreaId(areaId: $areaId) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$b10c3a0d7fd0dda5 = `
  query QcValidateShiftProfile($id: ID!) {
    qcValidateShiftProfile(id: $id) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileValidationOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$3821d9dffe80d394 = `
  mutation QcCreateShiftProfile($input: QcCreateShiftProfileInput!) {
    qcCreateShiftProfile(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$929ada8bc108cfd8 = `
  mutation QcUpdateShiftProfile($input: QcUpdateShiftProfileInput!) {
    qcUpdateShiftProfile(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$7c581d2298acfb9d = `
  mutation QcDeleteShiftProfile($id: ID!) {
    qcDeleteShiftProfile(id: $id)
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$440fff0da19bfd24 = `
  mutation QcCreateShiftProfileWindow($input: QcCreateShiftProfileWindowInput!) {
    qcCreateShiftProfileWindow(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileWindowOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$c300425fc57528c2 = `
  mutation QcUpdateShiftProfileWindow($input: QcUpdateShiftProfileWindowInput!) {
    qcUpdateShiftProfileWindow(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$shiftProfileWindowOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$fe81ba9a242f7bde = `
  mutation QcDeleteShiftProfileWindow($id: ID!) {
    qcDeleteShiftProfileWindow(id: $id)
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$d37af7ef0bf195c8 = `
  query QcGetDefinitionCascadesByDefinitionId($specDefinitionId: ID!) {
    qcGetDefinitionCascadesByDefinitionId(specDefinitionId: $specDefinitionId) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$definitionCascadeOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$25ed4c81ca117e21 = `
  query QcGetAllDefinitionCascades($status: QcDefinitionCascadeStatus) {
    qcGetAllDefinitionCascades(status: $status) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$definitionCascadeOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$11a2eb1fc0852bc1 = `
  mutation QcCreateDefinitionCascade($input: QcCreateDefinitionCascadeInput!) {
    qcCreateDefinitionCascade(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$definitionCascadeOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$ab8244d42d610ef8 = `
  mutation QcApplyDefinitionCascade($id: ID!) {
    qcApplyDefinitionCascade(id: $id) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$definitionCascadeOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$cb63f3fe7d352d8 = `
  mutation QcRejectDefinitionCascade($id: ID!) {
    qcRejectDefinitionCascade(id: $id) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$definitionCascadeOutput}
    }
  }
`;
// ── Attribute Registry Queries & Mutations ──────────────────────────────────
const $05178355e113e06d$var$$cdb72321fb58675b$var$attributeRegistryOutput = `
    name
    dataType
    description
    isCategorical
    exampleValues
    isRequired
    unitOfMeasure
    source
    ${$05178355e113e06d$var$$cdb72321fb58675b$var$defaultOutput}
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$686b2148cafdfad8 = `
  query QcGetAttributeRegistry {
    qcGetAttributeRegistry {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$attributeRegistryOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$dad439c2eb7e549f = `
  query QcGetAttributeRegistryById($id: ID!) {
    qcGetAttributeRegistryById(id: $id) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$attributeRegistryOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$c8b5d5b42efd78a8 = `
  mutation QcCreateAttributeRegistry($input: QcCreateAttributeRegistryInput!) {
    qcCreateAttributeRegistry(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$attributeRegistryOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$333e25f8c24de5e9 = `
  mutation QcUpdateAttributeRegistry($input: QcUpdateAttributeRegistryInput!) {
    qcUpdateAttributeRegistry(input: $input) {
      ${$05178355e113e06d$var$$cdb72321fb58675b$var$attributeRegistryOutput}
    }
  }
`;
const $05178355e113e06d$var$$cdb72321fb58675b$export$4604cc2239308f70 = `
  mutation QcDeleteAttributeRegistry($id: ID!) {
    qcDeleteAttributeRegistry(id: $id)
  }
`;
/**
 * API for Quality Control related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$74954bb50772085f$var$QualityControl extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    // ── Area ─────────────────────────────────────────────────────────────────
    /**
   * Gets all areas
   * @returns {Promise<Pella.QualityControlAPI.Area[]>}
   */ async getAllAreas() {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$af26b533538d3bcc);
    }
    /**
   * Gets an area by ID
   * @param {string} id Area ID
   * @returns {Promise<Pella.QualityControlAPI.Area | null>}
   */ async getAreaById(id) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$94358260ceeef1bc, {
            id: id
        });
    }
    /**
   * Creates a new area
   * @param {Pella.QualityControlAPI.CreateAreaInput} input
   * @returns {Promise<Pella.QualityControlAPI.Area>}
   */ async createArea(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$bac1e8fb385bcb74, {
            input: input
        });
    }
    /**
   * Updates an existing area
   * @param {Pella.QualityControlAPI.UpdateAreaInput} input
   * @returns {Promise<Pella.QualityControlAPI.Area>}
   */ async updateArea(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$c3b87a2a55ebc775, {
            input: input
        });
    }
    /**
   * Deletes an area
   * @param {{id: string}} input
   * @returns {Promise<boolean>}
   */ async deleteArea(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$ebeac39201768940, input);
    }
    // ── Control Plan ─────────────────────────────────────────────────────────
    /**
   * Gets a control plan by ID
   * @param {string} id Control Plan ID
   * @returns {Promise<Pella.QualityControlAPI.ControlPlan | null>}
   */ async getControlPlanById(id) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$9e08f525e26f556e, {
            id: id
        });
    }
    /**
   * Gets all control plans with optional filters
   * @param {Pella.QualityControlAPI.ControlPlanStatus} [status] Status filter
   * @param {string} [areaId] Area ID filter
   * @param {{ expanded?: boolean }} [options] Options — set expanded to true for full spec detail
   * @returns {Promise<Pella.QualityControlAPI.ControlPlan[]>}
   */ async getAllControlPlans(status, areaId, { expanded: expanded } = {}) {
        const query = expanded ? $05178355e113e06d$var$$cdb72321fb58675b$export$783f0501ebe45965 : $05178355e113e06d$var$$cdb72321fb58675b$export$11e8e4b9f54e50d6;
        return await this._graphqlRequest(query, {
            status: status,
            areaId: areaId
        });
    }
    /**
   * Creates a new control plan
   * @param {Pella.QualityControlAPI.CreateControlPlanInput} input
   * @returns {Promise<Pella.QualityControlAPI.ControlPlan>}
   */ async createControlPlan(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$19dc3e69591f37b0, {
            input: input
        });
    }
    /**
   * Updates an existing control plan
   * @param {Pella.QualityControlAPI.UpdateControlPlanInput} input
   * @returns {Promise<Pella.QualityControlAPI.ControlPlan>}
   */ async updateControlPlan(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$d3c68320a574536e, {
            input: input
        });
    }
    /**
   * Deletes a control plan
   * @param {{id: string}} input
   * @returns {Promise<boolean>}
   */ async deleteControlPlan(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$f60af3ccfee63217, input);
    }
    // ── Spec ─────────────────────────────────────────────────────────────────
    /**
   * Gets a spec by ID
   * @param {string} id Spec ID
   * @returns {Promise<Pella.QualityControlAPI.Spec | null>}
   */ async getSpecById(id) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$dcb06518671d82ed, {
            id: id
        });
    }
    /**
   * Gets all specs for a control plan
   * @param {string} controlPlanId Control Plan ID
   * @returns {Promise<Pella.QualityControlAPI.Spec[]>}
   */ async getSpecsByControlPlanId(controlPlanId) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$9386d0c93b5b1b73, {
            controlPlanId: controlPlanId
        });
    }
    /**
   * Creates a new spec
   * @param {Pella.QualityControlAPI.CreateSpecInput} input
   * @returns {Promise<Pella.QualityControlAPI.Spec>}
   */ async createSpec(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$8b9b92ce861997dc, {
            input: input
        });
    }
    /**
   * Updates an existing spec
   * @param {Pella.QualityControlAPI.UpdateSpecInput} input
   * @returns {Promise<Pella.QualityControlAPI.Spec>}
   */ async updateSpec(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$787b64e6de27e6a5, {
            input: input
        });
    }
    /**
   * Deletes a spec
   * @param {{id: string}} input
   * @returns {Promise<boolean>}
   */ async deleteSpec(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$82f2541849d885b5, input);
    }
    // ── Spec Definition ──────────────────────────────────────────────────────
    /**
   * Gets a spec definition by ID
   * @param {string} id Spec Definition ID
   * @returns {Promise<Pella.QualityControlAPI.SpecDefinition | null>}
   */ async getSpecDefinitionById(id) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$f75e341e57b175a9, {
            id: id
        });
    }
    /**
   * Gets all spec definitions with optional filters
   * @param {Pella.QualityControlAPI.SpecDefinitionScope} [scope] Scope filter
   * @param {string} [areaId] Area ID filter
   * @returns {Promise<Pella.QualityControlAPI.SpecDefinition[]>}
   */ async getAllSpecDefinitions(scope, areaId) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$c849eb2c294e8a06, {
            scope: scope,
            areaId: areaId
        });
    }
    /**
   * Creates a new spec definition
   * @param {Pella.QualityControlAPI.CreateSpecDefinitionInput} input
   * @returns {Promise<Pella.QualityControlAPI.SpecDefinition>}
   */ async createSpecDefinition(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$488d111903c6badc, {
            input: input
        });
    }
    /**
   * Updates an existing spec definition
   * @param {Pella.QualityControlAPI.UpdateSpecDefinitionInput} input
   * @returns {Promise<Pella.QualityControlAPI.SpecDefinition>}
   */ async updateSpecDefinition(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$fd43415e299fcdd6, {
            input: input
        });
    }
    /**
   * Deletes a spec definition
   * @param {{id: string}} input
   * @returns {Promise<boolean>}
   */ async deleteSpecDefinition(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$fa13b5a0784424ff, input);
    }
    /**
   * Promotes a local spec definition to corporate scope
   * @param {Pella.QualityControlAPI.PromoteSpecDefinitionInput} input
   * @returns {Promise<Pella.QualityControlAPI.SpecDefinition>}
   */ async promoteSpecDefinition(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$303184d3c14e8a46, {
            input: input
        });
    }
    // ── Shift Profile ────────────────────────────────────────────────────────
    /**
   * Gets a shift profile by ID
   * @param {string} id Shift Profile ID
   * @returns {Promise<Pella.QualityControlAPI.ShiftProfile | null>}
   */ async getShiftProfileById(id) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$9f79afd88c1fb3d8, {
            id: id
        });
    }
    /**
   * Gets shift profiles for an area
   * @param {string} areaId Area ID
   * @returns {Promise<Pella.QualityControlAPI.ShiftProfile[]>}
   */ async getShiftProfilesByAreaId(areaId) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$d255455927e07fed, {
            areaId: areaId
        });
    }
    /**
   * Validates a shift profile for coverage gaps
   * @param {string} id Shift Profile ID
   * @returns {Promise<Pella.QualityControlAPI.ShiftProfileValidation>}
   */ async validateShiftProfile(id) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$b10c3a0d7fd0dda5, {
            id: id
        });
    }
    /**
   * Creates a new shift profile
   * @param {Pella.QualityControlAPI.CreateShiftProfileInput} input
   * @returns {Promise<Pella.QualityControlAPI.ShiftProfile>}
   */ async createShiftProfile(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$3821d9dffe80d394, {
            input: input
        });
    }
    /**
   * Updates an existing shift profile
   * @param {Pella.QualityControlAPI.UpdateShiftProfileInput} input
   * @returns {Promise<Pella.QualityControlAPI.ShiftProfile>}
   */ async updateShiftProfile(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$929ada8bc108cfd8, {
            input: input
        });
    }
    /**
   * Deletes a shift profile
   * @param {{id: string}} input
   * @returns {Promise<boolean>}
   */ async deleteShiftProfile(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$7c581d2298acfb9d, input);
    }
    /**
   * Creates a new shift profile window
   * @param {Pella.QualityControlAPI.CreateShiftProfileWindowInput} input
   * @returns {Promise<Pella.QualityControlAPI.ShiftProfileWindow>}
   */ async createShiftProfileWindow(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$440fff0da19bfd24, {
            input: input
        });
    }
    /**
   * Updates an existing shift profile window
   * @param {Pella.QualityControlAPI.UpdateShiftProfileWindowInput} input
   * @returns {Promise<Pella.QualityControlAPI.ShiftProfileWindow>}
   */ async updateShiftProfileWindow(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$c300425fc57528c2, {
            input: input
        });
    }
    /**
   * Deletes a shift profile window
   * @param {{id: string}} input
   * @returns {Promise<boolean>}
   */ async deleteShiftProfileWindow(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$fe81ba9a242f7bde, input);
    }
    // ── Definition Cascade ───────────────────────────────────────────────────
    /**
   * Gets definition cascades for a spec definition
   * @param {string} specDefinitionId Spec Definition ID
   * @returns {Promise<Pella.QualityControlAPI.DefinitionCascade[]>}
   */ async getDefinitionCascadesByDefinitionId(specDefinitionId) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$d37af7ef0bf195c8, {
            specDefinitionId: specDefinitionId
        });
    }
    /**
   * Gets all definition cascades with optional status filter
   * @param {Pella.QualityControlAPI.DefinitionCascadeStatus} [status] Status filter
   * @returns {Promise<Pella.QualityControlAPI.DefinitionCascade[]>}
   */ async getAllDefinitionCascades(status) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$25ed4c81ca117e21, {
            status: status
        });
    }
    /**
   * Creates a new definition cascade
   * @param {Pella.QualityControlAPI.CreateDefinitionCascadeInput} input
   * @returns {Promise<Pella.QualityControlAPI.DefinitionCascade>}
   */ async createDefinitionCascade(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$11a2eb1fc0852bc1, {
            input: input
        });
    }
    /**
   * Applies a definition cascade
   * @param {{id: string}} input
   * @returns {Promise<Pella.QualityControlAPI.DefinitionCascade>}
   */ async applyDefinitionCascade(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$ab8244d42d610ef8, input);
    }
    /**
   * Rejects a definition cascade
   * @param {{id: string}} input
   * @returns {Promise<Pella.QualityControlAPI.DefinitionCascade>}
   */ async rejectDefinitionCascade(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$cb63f3fe7d352d8, input);
    }
    // ── Attribute Registry ──────────────────────────────────────────────────
    /**
   * Gets all attribute registry entries
   * @returns {Promise<Pella.QualityControlAPI.AttributeRegistry[]>}
   */ async getAttributeRegistry() {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$686b2148cafdfad8);
    }
    /**
   * Gets an attribute registry entry by ID
   * @param {string} id Attribute Registry ID
   * @returns {Promise<Pella.QualityControlAPI.AttributeRegistry | null>}
   */ async getAttributeRegistryById(id) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$dad439c2eb7e549f, {
            id: id
        });
    }
    /**
   * Creates a new attribute registry entry
   * @param {Pella.QualityControlAPI.CreateAttributeRegistryInput} input
   * @returns {Promise<Pella.QualityControlAPI.AttributeRegistry>}
   */ async createAttributeRegistry(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$c8b5d5b42efd78a8, {
            input: input
        });
    }
    /**
   * Updates an existing attribute registry entry
   * @param {Pella.QualityControlAPI.UpdateAttributeRegistryInput} input
   * @returns {Promise<Pella.QualityControlAPI.AttributeRegistry>}
   */ async updateAttributeRegistry(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$333e25f8c24de5e9, {
            input: input
        });
    }
    /**
   * Deletes an attribute registry entry
   * @param {{id: string}} input
   * @returns {Promise<boolean>}
   */ async deleteAttributeRegistry(input) {
        return await this._graphqlRequest($05178355e113e06d$var$$cdb72321fb58675b$export$4604cc2239308f70, input);
    }
}
var $05178355e113e06d$export$62779a2360e6357d = $05178355e113e06d$var$$74954bb50772085f$var$QualityControl;
const $05178355e113e06d$var$$cd7387ef930e5146$export$33745b839c2ccc5a = `
  mutation createConversation($input: CreateConversationInput!) {
    createConversation(input: $input) {
      id
      problemDescription
    }
  }
`;
const $05178355e113e06d$var$$cd7387ef930e5146$export$9cd47489e5818acc = `
  mutation createWorkOrderTracking($input: CreateWorkOrderTrackingInput!) {
    createWorkOrderTracking(input: $input) {
      id
      success
    }
  }
`;
const $05178355e113e06d$var$$cd7387ef930e5146$export$29a6b1d592154f95 = `
  query maintenanceFollowUpQuestions($input: MaintenanceFollowUpQuestionsInput!) {
    maintenanceFollowUpQuestions(input: $input) {
      questions {
        id
        text
      }
    }
  }
`;
const $05178355e113e06d$var$$cd7387ef930e5146$export$7bad06189afb132f = `
  query workOrderSummary($input: WorkOrderSummaryInput!) {
    workOrderSummary(input: $input) {
      conversationId
      problemDescription
      summaryText
      relatedWorkOrders {
        workOrderNumber
        equipmentType
        equipmentNumber
        problem
        solution
        completionDate
        location
        reasonForOutage
        reasonForOutageDetail
      }
      relatedMachineHistory {
        workOrderNumber
        equipmentType
        equipmentNumber
        problem
        solution
        completionDate
        location
        reasonForOutage
        reasonForOutageDetail
      }
    }
  }
`;
const $05178355e113e06d$var$$cd7387ef930e5146$export$377b852d8c0b1a9e = `
  query translation($input: [TranslationInput!]!) {
    translation(input: $input) {
      text
    }
  }
`;
/**
 * API for Maintenance Copilot related endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$f7958507c5713884$var$MaintenanceCopilot extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Creates a new maintenance copilot conversation.
   * @param {import('@pella/types').MaintenanceCopilotAPI.CreateConversationInput} input
   * @returns {Promise<import('@pella/types').MaintenanceCopilotAPI.CreateConversationResponse>}
   */ createConversation(input) {
        return this._graphqlRequest($05178355e113e06d$var$$cd7387ef930e5146$export$33745b839c2ccc5a, {
            input: input
        });
    }
    /**
   * Creates a work order tracking record.
   * @param {import('@pella/types').MaintenanceCopilotAPI.CreateWorkOrderTrackingInput} input
   * @returns {Promise<import('@pella/types').MaintenanceCopilotAPI.CreateWorkOrderTrackingResponse>}
   */ createWorkOrderTracking(input) {
        return this._graphqlRequest($05178355e113e06d$var$$cd7387ef930e5146$export$9cd47489e5818acc, {
            input: input
        });
    }
    /**
   * Fetches AI-generated follow-up diagnostic questions for a conversation.
   * @param {import('@pella/types').MaintenanceCopilotAPI.MaintenanceFollowUpQuestionsInput} input
   * @returns {Promise<import('@pella/types').MaintenanceCopilotAPI.FollowUpQuestionsResponse>}
   */ getMaintenanceFollowUpQuestions(input) {
        return this._graphqlRequest($05178355e113e06d$var$$cd7387ef930e5146$export$29a6b1d592154f95, {
            input: input
        });
    }
    /**
   * Fetches an AI-generated work order summary.
   * @param {import('@pella/types').MaintenanceCopilotAPI.WorkOrderSummaryInput} input
   * @returns {Promise<import('@pella/types').MaintenanceCopilotAPI.WorkOrderSummaryResponse>}
   */ getWorkOrderSummary(input) {
        return this._graphqlRequest($05178355e113e06d$var$$cd7387ef930e5146$export$7bad06189afb132f, {
            input: input
        });
    }
    /**
   * Translates an array of text inputs.
   * @param {import('@pella/types').MaintenanceCopilotAPI.TranslationInput[]} input
   * @returns {Promise<import('@pella/types').MaintenanceCopilotAPI.TranslationResponse>}
   */ getTranslation(input) {
        return this._graphqlRequest($05178355e113e06d$var$$cd7387ef930e5146$export$377b852d8c0b1a9e, {
            input: input
        });
    }
}
var $05178355e113e06d$export$a27ca38169ef71fd = $05178355e113e06d$var$$f7958507c5713884$var$MaintenanceCopilot;
const $05178355e113e06d$var$$11f6c152fd57e14a$var$AUCTION_CALENDAR_DETAIL_FIELDS = `
  auctionId
  displayName
  siteCode
  minimumBid
  auctionLocation
  auctionEndDate
  removeByDate
  auctionStatus
  creationDate
  lastUpdatedDate
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$var$AUCTION_CALENDAR_SUMMARY_FIELDS = `
  auctionId
  displayName
  auctionStatus
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$var$AUCTION_LISTING_FIELDS = `
  auctionItemId
  auctionCalendarId
  itemReferenceId
  itemDescription
  itemType
  minimumBid
  createdDate
  lastUpdatedDate
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$var$BID_ITEM_FIELDS = `
  bidId
  auctionListingItemId
  employeeId
  userPrincipalName
  employeeName
  bidAmount
  isHighestBid
  creationDate
  lastUpdatedDate
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$75662ca4f17d5632 = `
  query auctionCalendarDetail($auctionId: ID!) {
    auctionCalendarDetail(auctionId: $auctionId) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$AUCTION_CALENDAR_DETAIL_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$c309df7a01b32e66 = `
  query auctionCalendarsSummary($siteCode: String, $status: [AuctionStatus!]) {
    auctionCalendarsSummary(siteCode: $siteCode, status: $status) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$AUCTION_CALENDAR_SUMMARY_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$3f4e4c05f1a326c2 = `
  query auctionListing($auctionItemId: ID!) {
    auctionListing(auctionItemId: $auctionItemId) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$AUCTION_LISTING_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$c5164883d149a48a = `
  query auctionListings($auctionCalendarId: ID, $auctionItemId: ID) {
    auctionListings(auctionCalendarId: $auctionCalendarId, auctionItemId: $auctionItemId) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$AUCTION_LISTING_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$ecebcb1473b80b6b = `
  query bidItem($bidId: ID!) {
    bidItem(bidId: $bidId) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$BID_ITEM_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$cff508d72a069289 = `
  query bidItems($auctionListingItemId: ID, $employeeId: String) {
    bidItems(auctionListingItemId: $auctionListingItemId, employeeId: $employeeId) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$BID_ITEM_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$d1bbe2354ea2baac = `
  mutation createAuctionCalendar(
    $siteCode: String!
    $minimumBid: Float
    $auctionLocation: String!
    $auctionEndDate: DateTime!
    $removeByDate: DateTime!
  ) {
    createAuctionCalendar(
      siteCode: $siteCode
      minimumBid: $minimumBid
      auctionLocation: $auctionLocation
      auctionEndDate: $auctionEndDate
      removeByDate: $removeByDate
    ) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$AUCTION_CALENDAR_DETAIL_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$994957299b5d74e1 = `
  mutation updateAuctionCalendar(
    $auctionId: ID!
    $siteCode: String
    $minimumBid: Float
    $auctionLocation: String
    $auctionEndDate: DateTime
    $removeByDate: DateTime
    $auctionStatus: AuctionStatus
  ) {
    updateAuctionCalendar(
      auctionId: $auctionId
      siteCode: $siteCode
      minimumBid: $minimumBid
      auctionLocation: $auctionLocation
      auctionEndDate: $auctionEndDate
      removeByDate: $removeByDate
      auctionStatus: $auctionStatus
    ) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$AUCTION_CALENDAR_DETAIL_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$9a590713e1cc9461 = `
  mutation deleteAuctionCalendar($auctionId: ID!) {
    deleteAuctionCalendar(auctionId: $auctionId)
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$5de80fa6999d88c4 = `
  mutation createAuctionListing(
    $auctionCalendarId: ID!
    $itemReferenceId: Int!
    $itemDescription: String!
    $itemType: Int!
    $minimumBid: Float
    $createdDate: DateTime
  ) {
    createAuctionListing(
      auctionCalendarId: $auctionCalendarId
      itemReferenceId: $itemReferenceId
      itemDescription: $itemDescription
      itemType: $itemType
      minimumBid: $minimumBid
      createdDate: $createdDate
    ) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$AUCTION_LISTING_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$b5f48b7414e4ccdd = `
  mutation updateAuctionListing(
    $auctionItemId: ID!
    $auctionCalendarId: ID
    $itemReferenceId: Int
    $itemDescription: String
    $itemType: Int
    $minimumBid: Float
    $createdDate: DateTime
    $lastUpdatedDate: DateTime
  ) {
    updateAuctionListing(
      auctionItemId: $auctionItemId
      auctionCalendarId: $auctionCalendarId
      itemReferenceId: $itemReferenceId
      itemDescription: $itemDescription
      itemType: $itemType
      minimumBid: $minimumBid
      createdDate: $createdDate
      lastUpdatedDate: $lastUpdatedDate
    ) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$AUCTION_LISTING_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$db9c2644ed1a3dbc = `
  mutation deleteAuctionListing($auctionItemId: ID!) {
    deleteAuctionListing(auctionItemId: $auctionItemId)
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$ab7bc5fa91a14817 = `
  mutation createBidItem(
    $auctionListingItemId: ID!
    $employeeId: String!
    $userPrincipalName: String!
    $employeeName: String!
    $bidAmount: Float!
    $isHighestBid: Boolean
  ) {
    createBidItem(
      auctionListingItemId: $auctionListingItemId
      employeeId: $employeeId
      userPrincipalName: $userPrincipalName
      employeeName: $employeeName
      bidAmount: $bidAmount
      isHighestBid: $isHighestBid
    ) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$BID_ITEM_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$169daaffe5f7c807 = `
  mutation updateBidItem(
    $bidId: ID!
    $auctionListingItemId: ID
    $employeeId: String
    $userPrincipalName: String
    $employeeName: String
    $bidAmount: Float
    $isHighestBid: Boolean
  ) {
    updateBidItem(
      bidId: $bidId
      auctionListingItemId: $auctionListingItemId
      employeeId: $employeeId
      userPrincipalName: $userPrincipalName
      employeeName: $employeeName
      bidAmount: $bidAmount
      isHighestBid: $isHighestBid
    ) {
      ${$05178355e113e06d$var$$11f6c152fd57e14a$var$BID_ITEM_FIELDS}
    }
  }
`;
const $05178355e113e06d$var$$11f6c152fd57e14a$export$49550411c9fdabe3 = `
  mutation deleteBidItem($bidId: ID!) {
    deleteBidItem(bidId: $bidId)
  }
`;
/**
 * API for Employee Auction endpoints (auction calendars, listings, and bids).
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$a6b69f477e1604b6$var$EmployeeAuction extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Gets detailed auction calendar information by auction ID.
   * @param {import('@pella/types').EmployeeAuctionAPI.AuctionCalendarDetail['auctionId']} auctionId
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.AuctionCalendarDetail | null>}
   */ getAuctionCalendarDetail(auctionId) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$75662ca4f17d5632, {
            auctionId: auctionId
        });
    }
    /**
   * Gets summary of auction calendars with optional filters.
   * @param {import('@pella/types').EmployeeAuctionAPI.AuctionCalendarsSummaryFilters} [filters]
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.AuctionCalendarSummary[]>}
   */ getAuctionCalendarsSummary(filters = {}) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$c309df7a01b32e66, filters);
    }
    /**
   * Gets a specific auction listing by ID.
   * @param {import('@pella/types').EmployeeAuctionAPI.AuctionListing['auctionItemId']} auctionItemId
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.AuctionListing | null>}
   */ getAuctionListing(auctionItemId) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$3f4e4c05f1a326c2, {
            auctionItemId: auctionItemId
        });
    }
    /**
   * Gets auction listings with optional filters.
   * @param {import('@pella/types').EmployeeAuctionAPI.AuctionListingsFilters} [filters]
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.AuctionListing[]>}
   */ getAuctionListings(filters = {}) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$c5164883d149a48a, filters);
    }
    /**
   * Gets a specific bid by ID.
   * @param {import('@pella/types').EmployeeAuctionAPI.BidItem['bidId']} bidId
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.BidItem | null>}
   */ getBidItem(bidId) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$ecebcb1473b80b6b, {
            bidId: bidId
        });
    }
    /**
   * Gets bids with optional filters.
   * @param {import('@pella/types').EmployeeAuctionAPI.BidItemsFilters} [filters]
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.BidItem[]>}
   */ getBidItems(filters = {}) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$cff508d72a069289, filters);
    }
    /**
   * Creates a new auction calendar (always starts in DRAFT).
   * @param {import('@pella/types').EmployeeAuctionAPI.CreateAuctionCalendarInput} input
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.AuctionCalendarDetail>}
   */ createAuctionCalendar(input) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$d1bbe2354ea2baac, input);
    }
    /**
   * Updates an existing auction calendar. Status transitions must follow DRAFT → ACTIVE → CLOSED.
   * @param {import('@pella/types').EmployeeAuctionAPI.UpdateAuctionCalendarInput} input
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.AuctionCalendarDetail>}
   */ updateAuctionCalendar(input) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$994957299b5d74e1, input);
    }
    /**
   * Hard-deletes an auction calendar (cascades to listings and bids).
   * @param {import('@pella/types').EmployeeAuctionAPI.AuctionCalendarDetail['auctionId']} auctionId
   * @returns {Promise<boolean>}
   */ deleteAuctionCalendar(auctionId) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$9a590713e1cc9461, {
            auctionId: auctionId
        });
    }
    /**
   * Creates a new auction listing. Parent calendar must be DRAFT.
   * @param {import('@pella/types').EmployeeAuctionAPI.CreateAuctionListingInput} input
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.AuctionListing>}
   */ createAuctionListing(input) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$5de80fa6999d88c4, input);
    }
    /**
   * Updates an existing auction listing. Parent calendar must be DRAFT.
   * @param {import('@pella/types').EmployeeAuctionAPI.UpdateAuctionListingInput} input
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.AuctionListing>}
   */ updateAuctionListing(input) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$b5f48b7414e4ccdd, input);
    }
    /**
   * Hard-deletes an auction listing. Parent calendar must be DRAFT.
   * @param {import('@pella/types').EmployeeAuctionAPI.AuctionListing['auctionItemId']} auctionItemId
   * @returns {Promise<boolean>}
   */ deleteAuctionListing(auctionItemId) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$db9c2644ed1a3dbc, {
            auctionItemId: auctionItemId
        });
    }
    /**
   * Creates a new bid. Parent calendar must be ACTIVE.
   * @param {import('@pella/types').EmployeeAuctionAPI.CreateBidItemInput} input
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.BidItem>}
   */ createBidItem(input) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$ab7bc5fa91a14817, input);
    }
    /**
   * Updates an existing bid. Parent calendar must be ACTIVE.
   * @param {import('@pella/types').EmployeeAuctionAPI.UpdateBidItemInput} input
   * @returns {Promise<import('@pella/types').EmployeeAuctionAPI.BidItem>}
   */ updateBidItem(input) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$169daaffe5f7c807, input);
    }
    /**
   * Hard-deletes a bid. Parent calendar must be ACTIVE.
   * @param {import('@pella/types').EmployeeAuctionAPI.BidItem['bidId']} bidId
   * @returns {Promise<boolean>}
   */ deleteBidItem(bidId) {
        return this._graphqlRequest($05178355e113e06d$var$$11f6c152fd57e14a$export$49550411c9fdabe3, {
            bidId: bidId
        });
    }
}
var $05178355e113e06d$export$92508104caf886bd = $05178355e113e06d$var$$a6b69f477e1604b6$var$EmployeeAuction;
const $05178355e113e06d$var$$e2aee1231f832a5f$var$IPATH_HISTORICAL_CHANGE_EVENT_FIELDS = `
  sourceType
  sourceValue
  eventName
  eventValue
  eventSource
  eventId
  createdBy
  creationDateTime
`;
const $05178355e113e06d$var$$e2aee1231f832a5f$export$a8689891855d87fb = `
  query IpathHistoricalChangeEventsByOrderLineId($orderLineId: String!, $packageId: String) {
    ipathHistoricalChangeEventsByOrderLineId(orderLineId: $orderLineId, packageId: $packageId) {
      ${$05178355e113e06d$var$$e2aee1231f832a5f$var$IPATH_HISTORICAL_CHANGE_EVENT_FIELDS}
    }
  }
`;
/**
 * API for Pella Data Lake GraphQL endpoints.
 * @augments BaseAPI
 */ class $05178355e113e06d$var$$67c2f48f559f8188$var$DataLake extends $05178355e113e06d$var$$c2d1d220888f3065$export$2e2bcd8739ae039 {
    /**
   * Gets the historical change-event stream for an iPath order line,
   * optionally scoped to a single package under the line.
   * @param {import('@pella/types').DataLakeAPI.GetIpathHistoricalChangeEventsByOrderLineIdInput} input
   * @returns {Promise<import('@pella/types').DataLakeAPI.IpathHistoricalChangeEvent[]>}
   */ getIpathHistoricalChangeEventsByOrderLineId({ orderLineId: orderLineId, packageId: packageId }) {
        return this._graphqlRequest($05178355e113e06d$var$$e2aee1231f832a5f$export$a8689891855d87fb, {
            orderLineId: orderLineId,
            packageId: packageId
        });
    }
}
var $05178355e113e06d$export$daf1f92eb2c49658 = $05178355e113e06d$var$$67c2f48f559f8188$var$DataLake;
/**
 * Instantiates all API classes with the given access token, base URL, and axios configuration.
 * @param {import('../types').APIConfig} config
 */ const $05178355e113e06d$export$4fafdaea5622967e = (config)=>({
        iPath: new $05178355e113e06d$export$ef8db0afbc868c87(config),
        teamMember: new $05178355e113e06d$export$d02f9bf4b03d1554(config),
        applUser: new $05178355e113e06d$export$ec5c01f21e3cc6b7(config),
        appAnalytics: new $05178355e113e06d$export$6362543a8c1dec50(config),
        teamMemberData: new $05178355e113e06d$export$c591ab8a928c34e7(config),
        image: new $05178355e113e06d$export$3e431a229df88919(config),
        logger: new $05178355e113e06d$export$efa9a398d6368992(config),
        thrive: new $05178355e113e06d$export$d2ff27f49bec379(config),
        setoff: new $05178355e113e06d$export$663cb28d065d5c7f(config),
        ebs: new $05178355e113e06d$export$9373a4b389b77402(config),
        ebsMfg: new $05178355e113e06d$export$a9cf63cc251308b2(config),
        orgManagement: new $05178355e113e06d$export$7819a5a96316d51d(config),
        invMgmt: new $05178355e113e06d$export$7ea2f2d2998545fc(config),
        rfid: new $05178355e113e06d$export$e5d44a4194605db9(config),
        voiceFlex: new $05178355e113e06d$export$a2df4d2c392ae654(config),
        reorder: new $05178355e113e06d$export$335fca4219867448(config),
        productionRequest: new $05178355e113e06d$export$71724e294857d2c8(config),
        iotMsgQueue: new $05178355e113e06d$export$c8622ddcdf78b8e(config),
        mfgUtils: new $05178355e113e06d$export$3084edaf00709acc(config),
        wms: new $05178355e113e06d$export$b70f49b452c4df9b(config),
        subAssembly: new $05178355e113e06d$export$7653c09775ed54a2(config),
        dataDownload: new $05178355e113e06d$export$b7d695dd824ac980(config),
        mfgRules: new $05178355e113e06d$export$f2c82820b5d5fbca(config),
        opsReportServices: new $05178355e113e06d$export$74822590bc20bb(config),
        rfidV1: new $05178355e113e06d$export$8ed68dd588c248b2(config),
        qualityControl: new $05178355e113e06d$export$62779a2360e6357d(config),
        maintenanceCopilot: new $05178355e113e06d$export$a27ca38169ef71fd(config),
        employeeAuction: new $05178355e113e06d$export$92508104caf886bd(config),
        dataLake: new $05178355e113e06d$export$daf1f92eb2c49658(config)
    });
var $05178355e113e06d$var$$6f2927fe175a5e3f$exports = {};


const $1dff1e305d0081d2$var$$95f3b7d3b653e196$export$d5b46b9543631699 = {
    api: (0, $05178355e113e06d$export$4fafdaea5622967e)({
        appName: '',
        baseURL: '',
        accessToken: ''
    }),
    apiReady: false,
    selectedEBSInstance: '',
    setSelectedEBSInstance: ()=>{
    // intentionally empty
    }
};
const $1dff1e305d0081d2$var$$95f3b7d3b653e196$export$e9e34775259af03f = (0, $lCzvA.createContext)($1dff1e305d0081d2$var$$95f3b7d3b653e196$export$d5b46b9543631699);
const $1dff1e305d0081d2$export$67a65489846e51f3 = ()=>(0, $lCzvA.useContext)($1dff1e305d0081d2$var$$95f3b7d3b653e196$export$e9e34775259af03f);
/**
 * Get the name of the EBS instance based on the API URL.
 * @param {import('@pella/cosmos-core').BaseURL} url The URL of the API.
 * @returns {string} The name of the EBS instance.
 */ const $1dff1e305d0081d2$var$$9009937d58d9c1b2$export$df958c45c9ae5e6 = (url)=>{
    if (url.includes('apidev')) return 'EBSDEV3';
    if (url.includes('apiqa')) return 'EBSQA';
    return 'EBSPROD';
};
/**
 * The API provider, allows children to access the API context via the useAPI hook.
 * @param {import('react').PropsWithChildren<Pick<import('@pella/cosmos-core').APIConfig, 'appName' | 'baseURL' |'axiosConfig'>>} props
 */ const $1dff1e305d0081d2$var$$b0a30535fbe73f2a$var$APIProvider = ({ appName: appName, baseURL: baseURL, axiosConfig: axiosConfig, children: children })=>{
    const [selectedEBSInstance, setSelectedEBSInstance] = (0, $lCzvA.useState)($1dff1e305d0081d2$var$$9009937d58d9c1b2$export$df958c45c9ae5e6(baseURL));
    const [api, setAPI] = (0, $lCzvA.useState)((0, $05178355e113e06d$export$4fafdaea5622967e)({
        appName: appName,
        baseURL: baseURL,
        accessToken: '',
        axiosConfig: {
            ...axiosConfig,
            headers: {
                ...axiosConfig?.headers,
                'x-db-instances': JSON.stringify({
                    ebsInstance: selectedEBSInstance
                })
            }
        }
    }));
    const [apiReady, setAPIReady] = (0, $lCzvA.useState)($1dff1e305d0081d2$var$$95f3b7d3b653e196$export$d5b46b9543631699.apiReady);
    const { authState: authState, oktaAuth: oktaAuth } = (0, $954b04773eb0508c$export$2ae4a19e09ca9a00)();
    const accessToken = authState?.accessToken?.accessToken;
    (0, $lCzvA.useEffect)(()=>{
        const validateToken = async ()=>{
            if (document.visibilityState === 'hidden') setAPIReady(false);
            if (document.visibilityState === 'visible') {
                const newToken = await oktaAuth.getOrRenewAccessToken();
                if (newToken === accessToken) setAPIReady(true);
            }
        };
        document.addEventListener('visibilitychange', validateToken);
        return ()=>{
            document.removeEventListener('visibilitychange', validateToken);
        };
    }, [
        oktaAuth,
        accessToken
    ]);
    (0, $lCzvA.useEffect)(()=>{
        if (accessToken) {
            const combinedAPIs = (0, $05178355e113e06d$export$4fafdaea5622967e)({
                appName: appName,
                baseURL: baseURL,
                accessToken: accessToken,
                axiosConfig: {
                    ...axiosConfig,
                    headers: {
                        ...axiosConfig?.headers,
                        'x-db-instances': JSON.stringify({
                            ebsInstance: selectedEBSInstance
                        })
                    }
                }
            });
            setAPI(combinedAPIs);
            setAPIReady(true);
        }
    }, [
        accessToken,
        appName,
        baseURL,
        axiosConfig,
        selectedEBSInstance
    ]);
    /**
   * Memoize the context value to prevent unnecessary re-renders.
   */ const value = (0, $lCzvA.useMemo)(()=>({
            api: api,
            apiReady: apiReady,
            selectedEBSInstance: selectedEBSInstance,
            setSelectedEBSInstance: setSelectedEBSInstance
        }), [
        api,
        apiReady,
        selectedEBSInstance
    ]);
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($1dff1e305d0081d2$var$$95f3b7d3b653e196$export$e9e34775259af03f.Provider, {
        value: value,
        children: children
    });
};
var $1dff1e305d0081d2$export$434374b2a40d237 = $1dff1e305d0081d2$var$$b0a30535fbe73f2a$var$APIProvider;




var $lCzvA = parcelRequire("lCzvA");
var $c9d6d3563c261b0e$export$74c1f679d38d82e5;
(function(Html5QrcodeSupportedFormats) {
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["QR_CODE"] = 0] = "QR_CODE";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["AZTEC"] = 1] = "AZTEC";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODABAR"] = 2] = "CODABAR";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_39"] = 3] = "CODE_39";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_93"] = 4] = "CODE_93";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_128"] = 5] = "CODE_128";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["DATA_MATRIX"] = 6] = "DATA_MATRIX";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["MAXICODE"] = 7] = "MAXICODE";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["ITF"] = 8] = "ITF";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["EAN_13"] = 9] = "EAN_13";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["EAN_8"] = 10] = "EAN_8";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["PDF_417"] = 11] = "PDF_417";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["RSS_14"] = 12] = "RSS_14";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_A"] = 14] = "UPC_A";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_E"] = 15] = "UPC_E";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
})($c9d6d3563c261b0e$export$74c1f679d38d82e5 || ($c9d6d3563c261b0e$export$74c1f679d38d82e5 = {}));
var $c9d6d3563c261b0e$var$html5QrcodeSupportedFormatsTextMap = new Map([
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.QR_CODE,
        "QR_CODE"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.AZTEC,
        "AZTEC"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.CODABAR,
        "CODABAR"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.CODE_39,
        "CODE_39"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.CODE_93,
        "CODE_93"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.CODE_128,
        "CODE_128"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.DATA_MATRIX,
        "DATA_MATRIX"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.MAXICODE,
        "MAXICODE"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.ITF,
        "ITF"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.EAN_13,
        "EAN_13"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.EAN_8,
        "EAN_8"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.PDF_417,
        "PDF_417"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.RSS_14,
        "RSS_14"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.RSS_EXPANDED,
        "RSS_EXPANDED"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.UPC_A,
        "UPC_A"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.UPC_E,
        "UPC_E"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.UPC_EAN_EXTENSION,
        "UPC_EAN_EXTENSION"
    ]
]);
var $c9d6d3563c261b0e$export$ca79648743730e34;
(function(DecodedTextType) {
    DecodedTextType[DecodedTextType["UNKNOWN"] = 0] = "UNKNOWN";
    DecodedTextType[DecodedTextType["URL"] = 1] = "URL";
})($c9d6d3563c261b0e$export$ca79648743730e34 || ($c9d6d3563c261b0e$export$ca79648743730e34 = {}));
function $c9d6d3563c261b0e$export$f672fe1751f545ca(format) {
    return Object.values($c9d6d3563c261b0e$export$74c1f679d38d82e5).includes(format);
}
var $c9d6d3563c261b0e$export$13ed3042ed099f6a;
(function(Html5QrcodeScanType) {
    Html5QrcodeScanType[Html5QrcodeScanType["SCAN_TYPE_CAMERA"] = 0] = "SCAN_TYPE_CAMERA";
    Html5QrcodeScanType[Html5QrcodeScanType["SCAN_TYPE_FILE"] = 1] = "SCAN_TYPE_FILE";
})($c9d6d3563c261b0e$export$13ed3042ed099f6a || ($c9d6d3563c261b0e$export$13ed3042ed099f6a = {}));
var $c9d6d3563c261b0e$export$a4dae9b55d173e6d = function() {
    function Html5QrcodeConstants() {}
    Html5QrcodeConstants.GITHUB_PROJECT_URL = "https://github.com/mebjas/html5-qrcode";
    Html5QrcodeConstants.SCAN_DEFAULT_FPS = 2;
    Html5QrcodeConstants.DEFAULT_DISABLE_FLIP = false;
    Html5QrcodeConstants.DEFAULT_REMEMBER_LAST_CAMERA_USED = true;
    Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE = [
        $c9d6d3563c261b0e$export$13ed3042ed099f6a.SCAN_TYPE_CAMERA,
        $c9d6d3563c261b0e$export$13ed3042ed099f6a.SCAN_TYPE_FILE
    ];
    return Html5QrcodeConstants;
}();
var $c9d6d3563c261b0e$export$96706046d68ee585 = function() {
    function QrcodeResultFormat(format, formatName) {
        this.format = format;
        this.formatName = formatName;
    }
    QrcodeResultFormat.prototype.toString = function() {
        return this.formatName;
    };
    QrcodeResultFormat.create = function(format) {
        if (!$c9d6d3563c261b0e$var$html5QrcodeSupportedFormatsTextMap.has(format)) throw "".concat(format, " not in html5QrcodeSupportedFormatsTextMap");
        return new QrcodeResultFormat(format, $c9d6d3563c261b0e$var$html5QrcodeSupportedFormatsTextMap.get(format));
    };
    return QrcodeResultFormat;
}();
var $c9d6d3563c261b0e$export$ca258a9dba899828 = function() {
    function Html5QrcodeResultFactory() {}
    Html5QrcodeResultFactory.createFromText = function(decodedText) {
        var qrcodeResult = {
            text: decodedText
        };
        return {
            decodedText: decodedText,
            result: qrcodeResult
        };
    };
    Html5QrcodeResultFactory.createFromQrcodeResult = function(qrcodeResult) {
        return {
            decodedText: qrcodeResult.text,
            result: qrcodeResult
        };
    };
    return Html5QrcodeResultFactory;
}();
var $c9d6d3563c261b0e$export$ce0f3ff7a292bc54;
(function(Html5QrcodeErrorTypes) {
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["UNKWOWN_ERROR"] = 0] = "UNKWOWN_ERROR";
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["IMPLEMENTATION_ERROR"] = 1] = "IMPLEMENTATION_ERROR";
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["NO_CODE_FOUND_ERROR"] = 2] = "NO_CODE_FOUND_ERROR";
})($c9d6d3563c261b0e$export$ce0f3ff7a292bc54 || ($c9d6d3563c261b0e$export$ce0f3ff7a292bc54 = {}));
var $c9d6d3563c261b0e$export$dac571266bd01cf5 = function() {
    function Html5QrcodeErrorFactory() {}
    Html5QrcodeErrorFactory.createFrom = function(error) {
        return {
            errorMessage: error,
            type: $c9d6d3563c261b0e$export$ce0f3ff7a292bc54.UNKWOWN_ERROR
        };
    };
    return Html5QrcodeErrorFactory;
}();
var $c9d6d3563c261b0e$export$1952c0907ffae0f2 = function() {
    function BaseLoggger(verbose) {
        this.verbose = verbose;
    }
    BaseLoggger.prototype.log = function(message) {
        if (this.verbose) console.log(message);
    };
    BaseLoggger.prototype.warn = function(message) {
        if (this.verbose) console.warn(message);
    };
    BaseLoggger.prototype.logError = function(message, isExperimental) {
        if (this.verbose || isExperimental === true) console.error(message);
    };
    BaseLoggger.prototype.logErrors = function(errors) {
        if (errors.length === 0) throw "Logger#logError called without arguments";
        if (this.verbose) console.error(errors);
    };
    return BaseLoggger;
}();
function $c9d6d3563c261b0e$export$bedb7023a7733221(obj) {
    return typeof obj === "undefined" || obj === null;
}
function $c9d6d3563c261b0e$export$e0b576e7a74416cd(value, minValue, maxValue) {
    if (value > maxValue) return maxValue;
    if (value < minValue) return minValue;
    return value;
}


var $ff5e69b322275082$export$b5652ef085dee87f = function() {
    function Html5QrcodeStrings() {}
    Html5QrcodeStrings.codeParseError = function(exception) {
        return "QR code parse error, error = ".concat(exception);
    };
    Html5QrcodeStrings.errorGettingUserMedia = function(error) {
        return "Error getting userMedia, error = ".concat(error);
    };
    Html5QrcodeStrings.onlyDeviceSupportedError = function() {
        return "The device doesn't support navigator.mediaDevices , only supported cameraIdOrConfig in this case is deviceId parameter (string).";
    };
    Html5QrcodeStrings.cameraStreamingNotSupported = function() {
        return "Camera streaming not supported by the browser.";
    };
    Html5QrcodeStrings.unableToQuerySupportedDevices = function() {
        return "Unable to query supported devices, unknown error.";
    };
    Html5QrcodeStrings.insecureContextCameraQueryError = function() {
        return "Camera access is only supported in secure context like https or localhost.";
    };
    Html5QrcodeStrings.scannerPaused = function() {
        return "Scanner paused";
    };
    return Html5QrcodeStrings;
}();
var $ff5e69b322275082$export$b9cab5abdb16545c = function() {
    function Html5QrcodeScannerStrings() {}
    Html5QrcodeScannerStrings.scanningStatus = function() {
        return "Scanning";
    };
    Html5QrcodeScannerStrings.idleStatus = function() {
        return "Idle";
    };
    Html5QrcodeScannerStrings.errorStatus = function() {
        return "Error";
    };
    Html5QrcodeScannerStrings.permissionStatus = function() {
        return "Permission";
    };
    Html5QrcodeScannerStrings.noCameraFoundErrorStatus = function() {
        return "No Cameras";
    };
    Html5QrcodeScannerStrings.lastMatch = function(decodedText) {
        return "Last Match: ".concat(decodedText);
    };
    Html5QrcodeScannerStrings.codeScannerTitle = function() {
        return "Code Scanner";
    };
    Html5QrcodeScannerStrings.cameraPermissionTitle = function() {
        return "Request Camera Permissions";
    };
    Html5QrcodeScannerStrings.cameraPermissionRequesting = function() {
        return "Requesting camera permissions...";
    };
    Html5QrcodeScannerStrings.noCameraFound = function() {
        return "No camera found";
    };
    Html5QrcodeScannerStrings.scanButtonStopScanningText = function() {
        return "Stop Scanning";
    };
    Html5QrcodeScannerStrings.scanButtonStartScanningText = function() {
        return "Start Scanning";
    };
    Html5QrcodeScannerStrings.torchOnButton = function() {
        return "Switch On Torch";
    };
    Html5QrcodeScannerStrings.torchOffButton = function() {
        return "Switch Off Torch";
    };
    Html5QrcodeScannerStrings.torchOnFailedMessage = function() {
        return "Failed to turn on torch";
    };
    Html5QrcodeScannerStrings.torchOffFailedMessage = function() {
        return "Failed to turn off torch";
    };
    Html5QrcodeScannerStrings.scanButtonScanningStarting = function() {
        return "Launching Camera...";
    };
    Html5QrcodeScannerStrings.textIfCameraScanSelected = function() {
        return "Scan an Image File";
    };
    Html5QrcodeScannerStrings.textIfFileScanSelected = function() {
        return "Scan using camera directly";
    };
    Html5QrcodeScannerStrings.selectCamera = function() {
        return "Select Camera";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseImage = function() {
        return "Choose Image";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseAnother = function() {
        return "Choose Another";
    };
    Html5QrcodeScannerStrings.fileSelectionNoImageSelected = function() {
        return "No image choosen";
    };
    Html5QrcodeScannerStrings.anonymousCameraPrefix = function() {
        return "Anonymous Camera";
    };
    Html5QrcodeScannerStrings.dragAndDropMessage = function() {
        return "Or drop an image to scan";
    };
    Html5QrcodeScannerStrings.dragAndDropMessageOnlyImages = function() {
        return "Or drop an image to scan (other files not supported)";
    };
    Html5QrcodeScannerStrings.zoom = function() {
        return "zoom";
    };
    Html5QrcodeScannerStrings.loadingImage = function() {
        return "Loading image...";
    };
    Html5QrcodeScannerStrings.cameraScanAltText = function() {
        return "Camera based scan";
    };
    Html5QrcodeScannerStrings.fileScanAltText = function() {
        return "Fule based scan";
    };
    return Html5QrcodeScannerStrings;
}();
var $ff5e69b322275082$export$ef6635d54d6a0486 = function() {
    function LibraryInfoStrings() {}
    LibraryInfoStrings.poweredBy = function() {
        return "Powered by ";
    };
    LibraryInfoStrings.reportIssues = function() {
        return "Report issues";
    };
    return LibraryInfoStrings;
}();


var $307853ab41d6a77a$export$62a0507decb17869 = function() {
    function VideoConstraintsUtil() {}
    VideoConstraintsUtil.isMediaStreamConstraintsValid = function(videoConstraints, logger) {
        if (typeof videoConstraints !== "object") {
            var typeofVideoConstraints = typeof videoConstraints;
            logger.logError("videoConstraints should be of type object, the " + "object passed is of type ".concat(typeofVideoConstraints, "."), true);
            return false;
        }
        var bannedKeys = [
            "autoGainControl",
            "channelCount",
            "echoCancellation",
            "latency",
            "noiseSuppression",
            "sampleRate",
            "sampleSize",
            "volume"
        ];
        var bannedkeysSet = new Set(bannedKeys);
        var keysInVideoConstraints = Object.keys(videoConstraints);
        for(var _i = 0, keysInVideoConstraints_1 = keysInVideoConstraints; _i < keysInVideoConstraints_1.length; _i++){
            var key = keysInVideoConstraints_1[_i];
            if (bannedkeysSet.has(key)) {
                logger.logError("".concat(key, " is not supported videoConstaints."), true);
                return false;
            }
        }
        return true;
    };
    return VideoConstraintsUtil;
}();


var $56054c647abd5197$exports = {};
(function(global1, factory) {
    factory($56054c647abd5197$exports);
})($56054c647abd5197$exports, function(exports1) {
    'use strict';
    function isNullOrUndefined(obj) {
        return obj === null || obj === undefined;
    }
    /*
     * Copyright 2008 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /* global Reflect, Promise */ var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    function __extends(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    function fixProto(target, prototype) {
        var setPrototypeOf = Object.setPrototypeOf;
        setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
    }
    function fixStack(target, fn) {
        if (fn === void 0) fn = target.constructor;
        var captureStackTrace = Error.captureStackTrace;
        captureStackTrace && captureStackTrace(target, fn);
    }
    var CustomError = function(_super) {
        __extends(CustomError, _super);
        function CustomError(message) {
            var _newTarget = this.constructor;
            var _this = _super.call(this, message) || this;
            Object.defineProperty(_this, 'name', {
                value: _newTarget.name,
                enumerable: false
            });
            fixProto(_this, _newTarget.prototype);
            fixStack(_this);
            return _this;
        }
        return CustomError;
    }(Error);
    /**
     * Custom Error class of type Exception.
     */ class Exception extends CustomError {
        /**
         * Allows Exception to be constructed directly
         * with some message and prototype definition.
         */ constructor(message){
            super(message);
            this.message = message;
        }
        getKind() {
            const ex = this.constructor;
            return ex.kind;
        }
    }
    /**
     * It's typed as string so it can be extended and overriden.
     */ Exception.kind = 'Exception';
    /**
     * Custom Error class of type Exception.
     */ class ArgumentException extends Exception {
    }
    ArgumentException.kind = 'ArgumentException';
    /**
     * Custom Error class of type Exception.
     */ class IllegalArgumentException extends Exception {
    }
    IllegalArgumentException.kind = 'IllegalArgumentException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ class BinaryBitmap {
        constructor(binarizer){
            this.binarizer = binarizer;
            if (binarizer === null) throw new IllegalArgumentException('Binarizer must be non-null.');
        }
        /**
         * @return The width of the bitmap.
         */ getWidth() {
            return this.binarizer.getWidth();
        }
        /**
         * @return The height of the bitmap.
         */ getHeight() {
            return this.binarizer.getHeight();
        }
        /**
         * Converts one row of luminance data to 1 bit data. May actually do the conversion, or return
         * cached data. Callers should assume this method is expensive and call it as seldom as possible.
         * This method is intended for decoding 1D barcodes and may choose to apply sharpening.
         *
         * @param y The row to fetch, which must be in [0, bitmap height)
         * @param row An optional preallocated array. If null or too small, it will be ignored.
         *            If used, the Binarizer will call BitArray.clear(). Always use the returned object.
         * @return The array of bits for this row (true means black).
         * @throws NotFoundException if row can't be binarized
         */ getBlackRow(y /*int*/ , row) {
            return this.binarizer.getBlackRow(y, row);
        }
        /**
         * Converts a 2D array of luminance data to 1 bit. As above, assume this method is expensive
         * and do not call it repeatedly. This method is intended for decoding 2D barcodes and may or
         * may not apply sharpening. Therefore, a row from this matrix may not be identical to one
         * fetched using getBlackRow(), so don't mix and match between them.
         *
         * @return The 2D array of bits for the image (true means black).
         * @throws NotFoundException if image can't be binarized to make a matrix
         */ getBlackMatrix() {
            // The matrix is created on demand the first time it is requested, then cached. There are two
            // reasons for this:
            // 1. This work will never be done if the caller only installs 1D Reader objects, or if a
            //    1D Reader finds a barcode before the 2D Readers run.
            // 2. This work will only be done once even if the caller installs multiple 2D Readers.
            if (this.matrix === null || this.matrix === undefined) this.matrix = this.binarizer.getBlackMatrix();
            return this.matrix;
        }
        /**
         * @return Whether this bitmap can be cropped.
         */ isCropSupported() {
            return this.binarizer.getLuminanceSource().isCropSupported();
        }
        /**
         * Returns a new object with cropped image data. Implementations may keep a reference to the
         * original data rather than a copy. Only callable if isCropSupported() is true.
         *
         * @param left The left coordinate, which must be in [0,getWidth())
         * @param top The top coordinate, which must be in [0,getHeight())
         * @param width The width of the rectangle to crop.
         * @param height The height of the rectangle to crop.
         * @return A cropped version of this object.
         */ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            const newSource = this.binarizer.getLuminanceSource().crop(left, top, width, height);
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /**
         * @return Whether this bitmap supports counter-clockwise rotation.
         */ isRotateSupported() {
            return this.binarizer.getLuminanceSource().isRotateSupported();
        }
        /**
         * Returns a new object with rotated image data by 90 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise() {
            const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise();
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /**
         * Returns a new object with rotated image data by 45 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise45() {
            const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /*@Override*/ toString() {
            try {
                return this.getBlackMatrix().toString();
            } catch (e /*: NotFoundException*/ ) {
                return '';
            }
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class ChecksumException extends Exception {
        static getChecksumInstance() {
            return new ChecksumException();
        }
    }
    ChecksumException.kind = 'ChecksumException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This class hierarchy provides a set of methods to convert luminance data to 1 bit data.
     * It allows the algorithm to vary polymorphically, for example allowing a very expensive
     * thresholding technique for servers and a fast one for mobile. It also permits the implementation
     * to vary, e.g. a JNI version for Android and a Java fallback version for other platforms.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class Binarizer {
        constructor(source){
            this.source = source;
        }
        getLuminanceSource() {
            return this.source;
        }
        getWidth() {
            return this.source.getWidth();
        }
        getHeight() {
            return this.source.getHeight();
        }
    }
    class System {
        // public static void arraycopy(Object src, int srcPos, Object dest, int destPos, int length)
        /**
         * Makes a copy of a array.
         */ static arraycopy(src, srcPos, dest, destPos, length) {
            // TODO: better use split or set?
            while(length--)dest[destPos++] = src[srcPos++];
        }
        /**
         * Returns the current time in milliseconds.
         */ static currentTimeMillis() {
            return Date.now();
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class IndexOutOfBoundsException extends Exception {
    }
    IndexOutOfBoundsException.kind = 'IndexOutOfBoundsException';
    /**
     * Custom Error class of type Exception.
     */ class ArrayIndexOutOfBoundsException extends IndexOutOfBoundsException {
        constructor(index, message){
            super(message);
            this.index = index;
            this.message = message;
        }
    }
    ArrayIndexOutOfBoundsException.kind = 'ArrayIndexOutOfBoundsException';
    class Arrays {
        /**
         * Assigns the specified int value to each element of the specified array
         * of ints.
         *
         * @param a the array to be filled
         * @param val the value to be stored in all elements of the array
         */ static fill(a, val) {
            for(let i = 0, len = a.length; i < len; i++)a[i] = val;
        }
        /**
         * Assigns the specified int value to each element of the specified
         * range of the specified array of ints.  The range to be filled
         * extends from index {@code fromIndex}, inclusive, to index
         * {@code toIndex}, exclusive.  (If {@code fromIndex==toIndex}, the
         * range to be filled is empty.)
         *
         * @param a the array to be filled
         * @param fromIndex the index of the first element (inclusive) to be
         *        filled with the specified value
         * @param toIndex the index of the last element (exclusive) to be
         *        filled with the specified value
         * @param val the value to be stored in all elements of the array
         * @throws IllegalArgumentException if {@code fromIndex > toIndex}
         * @throws ArrayIndexOutOfBoundsException if {@code fromIndex < 0} or
         *         {@code toIndex > a.length}
         */ static fillWithin(a, fromIndex, toIndex, val) {
            Arrays.rangeCheck(a.length, fromIndex, toIndex);
            for(let i = fromIndex; i < toIndex; i++)a[i] = val;
        }
        /**
         * Checks that {@code fromIndex} and {@code toIndex} are in
         * the range and throws an exception if they aren't.
         */ static rangeCheck(arrayLength, fromIndex, toIndex) {
            if (fromIndex > toIndex) throw new IllegalArgumentException('fromIndex(' + fromIndex + ') > toIndex(' + toIndex + ')');
            if (fromIndex < 0) throw new ArrayIndexOutOfBoundsException(fromIndex);
            if (toIndex > arrayLength) throw new ArrayIndexOutOfBoundsException(toIndex);
        }
        static asList(...args) {
            return args;
        }
        static create(rows, cols, value) {
            let arr = Array.from({
                length: rows
            });
            return arr.map((x)=>Array.from({
                    length: cols
                }).fill(value));
        }
        static createInt32Array(rows, cols, value) {
            let arr = Array.from({
                length: rows
            });
            return arr.map((x)=>Int32Array.from({
                    length: cols
                }).fill(value));
        }
        static equals(first, second) {
            if (!first) return false;
            if (!second) return false;
            if (!first.length) return false;
            if (!second.length) return false;
            if (first.length !== second.length) return false;
            for(let i = 0, length = first.length; i < length; i++){
                if (first[i] !== second[i]) return false;
            }
            return true;
        }
        static hashCode(a) {
            if (a === null) return 0;
            let result = 1;
            for (const element of a)result = 31 * result + element;
            return result;
        }
        static fillUint8Array(a, value) {
            for(let i = 0; i !== a.length; i++)a[i] = value;
        }
        static copyOf(original, newLength) {
            return original.slice(0, newLength);
        }
        static copyOfUint8Array(original, newLength) {
            if (original.length <= newLength) {
                const newArray = new Uint8Array(newLength);
                newArray.set(original);
                return newArray;
            }
            return original.slice(0, newLength);
        }
        static copyOfRange(original, from, to) {
            const newLength = to - from;
            const copy = new Int32Array(newLength);
            System.arraycopy(original, from, copy, 0, newLength);
            return copy;
        }
        /*
        * Returns the index of of the element in a sorted array or (-n-1) where n is the insertion point
        * for the new element.
        * Parameters:
        *     ar - A sorted array
        *     el - An element to search for
        *     comparator - A comparator function. The function takes two arguments: (a, b) and returns:
        *        a negative number  if a is less than b;
        *        0 if a is equal to b;
        *        a positive number of a is greater than b.
        * The array may contain duplicate elements. If there are more than one equal elements in the array,
        * the returned value can be the index of any one of the equal elements.
        *
        * http://jsfiddle.net/aryzhov/pkfst550/
        */ static binarySearch(ar, el, comparator) {
            if (undefined === comparator) comparator = Arrays.numberComparator;
            let m = 0;
            let n = ar.length - 1;
            while(m <= n){
                const k = n + m >> 1;
                const cmp = comparator(el, ar[k]);
                if (cmp > 0) m = k + 1;
                else if (cmp < 0) n = k - 1;
                else return k;
            }
            return -m - 1;
        }
        static numberComparator(a, b) {
            return a - b;
        }
    }
    /**
     * Ponyfill for Java's Integer class.
     */ class Integer {
        static numberOfTrailingZeros(i) {
            let y;
            if (i === 0) return 32;
            let n = 31;
            y = i << 16;
            if (y !== 0) {
                n -= 16;
                i = y;
            }
            y = i << 8;
            if (y !== 0) {
                n -= 8;
                i = y;
            }
            y = i << 4;
            if (y !== 0) {
                n -= 4;
                i = y;
            }
            y = i << 2;
            if (y !== 0) {
                n -= 2;
                i = y;
            }
            return n - (i << 1 >>> 31);
        }
        static numberOfLeadingZeros(i) {
            // HD, Figure 5-6
            if (i === 0) return 32;
            let n = 1;
            if (i >>> 16 === 0) {
                n += 16;
                i <<= 16;
            }
            if (i >>> 24 === 0) {
                n += 8;
                i <<= 8;
            }
            if (i >>> 28 === 0) {
                n += 4;
                i <<= 4;
            }
            if (i >>> 30 === 0) {
                n += 2;
                i <<= 2;
            }
            n -= i >>> 31;
            return n;
        }
        static toHexString(i) {
            return i.toString(16);
        }
        static toBinaryString(intNumber) {
            return String(parseInt(String(intNumber), 2));
        }
        // Returns the number of one-bits in the two's complement binary representation of the specified int value. This function is sometimes referred to as the population count.
        // Returns:
        // the number of one-bits in the two's complement binary representation of the specified int value.
        static bitCount(i) {
            // HD, Figure 5-2
            i = i - (i >>> 1 & 0x55555555);
            i = (i & 0x33333333) + (i >>> 2 & 0x33333333);
            i = i + (i >>> 4) & 0x0f0f0f0f;
            i = i + (i >>> 8);
            i = i + (i >>> 16);
            return i & 0x3f;
        }
        static truncDivision(dividend, divisor) {
            return Math.trunc(dividend / divisor);
        }
        /**
         * Converts A string to an integer.
         * @param s A string to convert into a number.
         * @param radix A value between 2 and 36 that specifies the base of the number in numString. If this argument is not supplied, strings with a prefix of '0x' are considered hexadecimal. All other strings are considered decimal.
         */ static parseInt(num, radix) {
            return parseInt(num, radix);
        }
    }
    Integer.MIN_VALUE_32_BITS = -2147483648;
    Integer.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    /**
     * <p>A simple, fast array of bits, represented compactly by an array of ints internally.</p>
     *
     * @author Sean Owen
     */ class BitArray {
        // For testing only
        constructor(size /*int*/ , bits){
            if (undefined === size) {
                this.size = 0;
                this.bits = new Int32Array(1);
            } else {
                this.size = size;
                if (undefined === bits || null === bits) this.bits = BitArray.makeArray(size);
                else this.bits = bits;
            }
        }
        getSize() {
            return this.size;
        }
        getSizeInBytes() {
            return Math.floor((this.size + 7) / 8);
        }
        ensureCapacity(size /*int*/ ) {
            if (size > this.bits.length * 32) {
                const newBits = BitArray.makeArray(size);
                System.arraycopy(this.bits, 0, newBits, 0, this.bits.length);
                this.bits = newBits;
            }
        }
        /**
         * @param i bit to get
         * @return true iff bit i is set
         */ get(i /*int*/ ) {
            return (this.bits[Math.floor(i / 32)] & 1 << (i & 0x1F)) !== 0;
        }
        /**
         * Sets bit i.
         *
         * @param i bit to set
         */ set(i /*int*/ ) {
            this.bits[Math.floor(i / 32)] |= 1 << (i & 0x1F);
        }
        /**
         * Flips bit i.
         *
         * @param i bit to set
         */ flip(i /*int*/ ) {
            this.bits[Math.floor(i / 32)] ^= 1 << (i & 0x1F);
        }
        /**
         * @param from first bit to check
         * @return index of first bit that is set, starting from the given index, or size if none are set
         *  at or beyond this given index
         * @see #getNextUnset(int)
         */ getNextSet(from /*int*/ ) {
            const size = this.size;
            if (from >= size) return size;
            const bits = this.bits;
            let bitsOffset = Math.floor(from / 32);
            let currentBits = bits[bitsOffset];
            // mask off lesser bits first
            currentBits &= ~((1 << (from & 0x1F)) - 1);
            const length = bits.length;
            while(currentBits === 0){
                if (++bitsOffset === length) return size;
                currentBits = bits[bitsOffset];
            }
            const result = bitsOffset * 32 + Integer.numberOfTrailingZeros(currentBits);
            return result > size ? size : result;
        }
        /**
         * @param from index to start looking for unset bit
         * @return index of next unset bit, or {@code size} if none are unset until the end
         * @see #getNextSet(int)
         */ getNextUnset(from /*int*/ ) {
            const size = this.size;
            if (from >= size) return size;
            const bits = this.bits;
            let bitsOffset = Math.floor(from / 32);
            let currentBits = ~bits[bitsOffset];
            // mask off lesser bits first
            currentBits &= ~((1 << (from & 0x1F)) - 1);
            const length = bits.length;
            while(currentBits === 0){
                if (++bitsOffset === length) return size;
                currentBits = ~bits[bitsOffset];
            }
            const result = bitsOffset * 32 + Integer.numberOfTrailingZeros(currentBits);
            return result > size ? size : result;
        }
        /**
         * Sets a block of 32 bits, starting at bit i.
         *
         * @param i first bit to set
         * @param newBits the new value of the next 32 bits. Note again that the least-significant bit
         * corresponds to bit i, the next-least-significant to i+1, and so on.
         */ setBulk(i /*int*/ , newBits /*int*/ ) {
            this.bits[Math.floor(i / 32)] = newBits;
        }
        /**
         * Sets a range of bits.
         *
         * @param start start of range, inclusive.
         * @param end end of range, exclusive
         */ setRange(start /*int*/ , end /*int*/ ) {
            if (end < start || start < 0 || end > this.size) throw new IllegalArgumentException();
            if (end === start) return;
            end--; // will be easier to treat this as the last actually set bit -- inclusive
            const firstInt = Math.floor(start / 32);
            const lastInt = Math.floor(end / 32);
            const bits = this.bits;
            for(let i = firstInt; i <= lastInt; i++){
                const firstBit = i > firstInt ? 0 : start & 0x1F;
                const lastBit = i < lastInt ? 31 : end & 0x1F;
                // Ones from firstBit to lastBit, inclusive
                const mask = (2 << lastBit) - (1 << firstBit);
                bits[i] |= mask;
            }
        }
        /**
         * Clears all bits (sets to false).
         */ clear() {
            const max = this.bits.length;
            const bits = this.bits;
            for(let i = 0; i < max; i++)bits[i] = 0;
        }
        /**
         * Efficient method to check if a range of bits is set, or not set.
         *
         * @param start start of range, inclusive.
         * @param end end of range, exclusive
         * @param value if true, checks that bits in range are set, otherwise checks that they are not set
         * 
         * @return true iff all bits are set or not set in range, according to value argument
         * @throws IllegalArgumentException if end is less than start or the range is not contained in the array
         */ isRange(start /*int*/ , end /*int*/ , value) {
            if (end < start || start < 0 || end > this.size) throw new IllegalArgumentException();
            if (end === start) return true; // empty range matches
            end--; // will be easier to treat this as the last actually set bit -- inclusive
            const firstInt = Math.floor(start / 32);
            const lastInt = Math.floor(end / 32);
            const bits = this.bits;
            for(let i = firstInt; i <= lastInt; i++){
                const firstBit = i > firstInt ? 0 : start & 0x1F;
                const lastBit = i < lastInt ? 31 : end & 0x1F;
                // Ones from firstBit to lastBit, inclusive
                const mask = (2 << lastBit) - (1 << firstBit) & 0xFFFFFFFF;
                // TYPESCRIPTPORT: & 0xFFFFFFFF added to discard anything after 32 bits, as ES has 53 bits
                // Return false if we're looking for 1s and the masked bits[i] isn't all 1s (is: that,
                // equals the mask, or we're looking for 0s and the masked portion is not all 0s
                if ((bits[i] & mask) !== (value ? mask : 0)) return false;
            }
            return true;
        }
        appendBit(bit) {
            this.ensureCapacity(this.size + 1);
            if (bit) this.bits[Math.floor(this.size / 32)] |= 1 << (this.size & 0x1F);
            this.size++;
        }
        /**
         * Appends the least-significant bits, from value, in order from most-significant to
         * least-significant. For example, appending 6 bits from 0x000001E will append the bits
         * 0, 1, 1, 1, 1, 0 in that order.
         *
         * @param value {@code int} containing bits to append
         * @param numBits bits from value to append
         */ appendBits(value /*int*/ , numBits /*int*/ ) {
            if (numBits < 0 || numBits > 32) throw new IllegalArgumentException('Num bits must be between 0 and 32');
            this.ensureCapacity(this.size + numBits);
            // const appendBit = this.appendBit;
            for(let numBitsLeft = numBits; numBitsLeft > 0; numBitsLeft--)this.appendBit((value >> numBitsLeft - 1 & 0x01) === 1);
        }
        appendBitArray(other) {
            const otherSize = other.size;
            this.ensureCapacity(this.size + otherSize);
            // const appendBit = this.appendBit;
            for(let i = 0; i < otherSize; i++)this.appendBit(other.get(i));
        }
        xor(other) {
            if (this.size !== other.size) throw new IllegalArgumentException('Sizes don\'t match');
            const bits = this.bits;
            for(let i = 0, length = bits.length; i < length; i++)// The last int could be incomplete (i.e. not have 32 bits in
            // it) but there is no problem since 0 XOR 0 == 0.
            bits[i] ^= other.bits[i];
        }
        /**
         *
         * @param bitOffset first bit to start writing
         * @param array array to write into. Bytes are written most-significant byte first. This is the opposite
         *  of the internal representation, which is exposed by {@link #getBitArray()}
         * @param offset position in array to start writing
         * @param numBytes how many bytes to write
         */ toBytes(bitOffset /*int*/ , array, offset /*int*/ , numBytes /*int*/ ) {
            for(let i = 0; i < numBytes; i++){
                let theByte = 0;
                for(let j = 0; j < 8; j++){
                    if (this.get(bitOffset)) theByte |= 1 << 7 - j;
                    bitOffset++;
                }
                array[offset + i] = /*(byte)*/ theByte;
            }
        }
        /**
         * @return underlying array of ints. The first element holds the first 32 bits, and the least
         *         significant bit is bit 0.
         */ getBitArray() {
            return this.bits;
        }
        /**
         * Reverses all bits in the array.
         */ reverse() {
            const newBits = new Int32Array(this.bits.length);
            // reverse all int's first
            const len = Math.floor((this.size - 1) / 32);
            const oldBitsLen = len + 1;
            const bits = this.bits;
            for(let i = 0; i < oldBitsLen; i++){
                let x = bits[i];
                x = x >> 1 & 0x55555555 | (x & 0x55555555) << 1;
                x = x >> 2 & 0x33333333 | (x & 0x33333333) << 2;
                x = x >> 4 & 0x0f0f0f0f | (x & 0x0f0f0f0f) << 4;
                x = x >> 8 & 0x00ff00ff | (x & 0x00ff00ff) << 8;
                x = x >> 16 & 0x0000ffff | (x & 0x0000ffff) << 16;
                newBits[len - i] = /*(int)*/ x;
            }
            // now correct the int's if the bit size isn't a multiple of 32
            if (this.size !== oldBitsLen * 32) {
                const leftOffset = oldBitsLen * 32 - this.size;
                let currentInt = newBits[0] >>> leftOffset;
                for(let i = 1; i < oldBitsLen; i++){
                    const nextInt = newBits[i];
                    currentInt |= nextInt << 32 - leftOffset;
                    newBits[i - 1] = currentInt;
                    currentInt = nextInt >>> leftOffset;
                }
                newBits[oldBitsLen - 1] = currentInt;
            }
            this.bits = newBits;
        }
        static makeArray(size /*int*/ ) {
            return new Int32Array(Math.floor((size + 31) / 32));
        }
        /*@Override*/ equals(o) {
            if (!(o instanceof BitArray)) return false;
            const other = o;
            return this.size === other.size && Arrays.equals(this.bits, other.bits);
        }
        /*@Override*/ hashCode() {
            return 31 * this.size + Arrays.hashCode(this.bits);
        }
        /*@Override*/ toString() {
            let result = '';
            for(let i = 0, size = this.size; i < size; i++){
                if ((i & 0x07) === 0) result += ' ';
                result += this.get(i) ? 'X' : '.';
            }
            return result;
        }
        /*@Override*/ clone() {
            return new BitArray(this.size, this.bits.slice());
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * Encapsulates a type of hint that a caller may pass to a barcode reader to help it
     * more quickly or accurately decode it. It is up to implementations to decide what,
     * if anything, to do with the information that is supplied.
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     * @see Reader#decode(BinaryBitmap,java.util.Map)
     */ var DecodeHintType;
    (function(DecodeHintType) {
        /**
         * Unspecified, application-specific hint. Maps to an unspecified {@link Object}.
         */ DecodeHintType[DecodeHintType["OTHER"] = 0] = "OTHER"; /*(Object.class)*/ 
        /**
         * Image is a pure monochrome image of a barcode. Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["PURE_BARCODE"] = 1] = "PURE_BARCODE"; /*(Void.class)*/ 
        /**
         * Image is known to be of one of a few possible formats.
         * Maps to a {@link List} of {@link BarcodeFormat}s.
         */ DecodeHintType[DecodeHintType["POSSIBLE_FORMATS"] = 2] = "POSSIBLE_FORMATS"; /*(List.class)*/ 
        /**
         * Spend more time to try to find a barcode; optimize for accuracy, not speed.
         * Doesn't matter what it maps to; use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["TRY_HARDER"] = 3] = "TRY_HARDER"; /*(Void.class)*/ 
        /**
         * Specifies what character encoding to use when decoding, where applicable (type String)
         */ DecodeHintType[DecodeHintType["CHARACTER_SET"] = 4] = "CHARACTER_SET"; /*(String.class)*/ 
        /**
         * Allowed lengths of encoded data -- reject anything else. Maps to an {@code Int32Array}.
         */ DecodeHintType[DecodeHintType["ALLOWED_LENGTHS"] = 5] = "ALLOWED_LENGTHS"; /*(Int32Array.class)*/ 
        /**
         * Assume Code 39 codes employ a check digit. Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["ASSUME_CODE_39_CHECK_DIGIT"] = 6] = "ASSUME_CODE_39_CHECK_DIGIT"; /*(Void.class)*/ 
        /**
         * Assume the barcode is being processed as a GS1 barcode, and modify behavior as needed.
         * For example this affects FNC1 handling for Code 128 (aka GS1-128). Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["ASSUME_GS1"] = 7] = "ASSUME_GS1"; /*(Void.class)*/ 
        /**
         * If true, return the start and end digits in a Codabar barcode instead of stripping them. They
         * are alpha, whereas the rest are numeric. By default, they are stripped, but this causes them
         * to not be. Doesn't matter what it maps to; use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["RETURN_CODABAR_START_END"] = 8] = "RETURN_CODABAR_START_END"; /*(Void.class)*/ 
        /**
         * The caller needs to be notified via callback when a possible {@link ResultPoint}
         * is found. Maps to a {@link ResultPointCallback}.
         */ DecodeHintType[DecodeHintType["NEED_RESULT_POINT_CALLBACK"] = 9] = "NEED_RESULT_POINT_CALLBACK"; /*(ResultPointCallback.class)*/ 
        /**
         * Allowed extension lengths for EAN or UPC barcodes. Other formats will ignore this.
         * Maps to an {@code Int32Array} of the allowed extension lengths, for example [2], [5], or [2, 5].
         * If it is optional to have an extension, do not set this hint. If this is set,
         * and a UPC or EAN barcode is found but an extension is not, then no result will be returned
         * at all.
         */ DecodeHintType[DecodeHintType["ALLOWED_EAN_EXTENSIONS"] = 10] = "ALLOWED_EAN_EXTENSIONS"; /*(Int32Array.class)*/ 
    // End of enumeration values.
    /**
         * Data type the hint is expecting.
         * Among the possible values the {@link Void} stands out as being used for
         * hints that do not expect a value to be supplied (flag hints). Such hints
         * will possibly have their value ignored, or replaced by a
         * {@link Boolean#TRUE}. Hint suppliers should probably use
         * {@link Boolean#TRUE} as directed by the actual hint documentation.
         */ // private valueType: Class<?>
    // DecodeHintType(valueType: Class<?>) {
    //   this.valueType = valueType
    // }
    // public getValueType(): Class<?> {
    //   return valueType
    // }
    })(DecodeHintType || (DecodeHintType = {}));
    var DecodeHintType$1 = DecodeHintType;
    /**
     * Custom Error class of type Exception.
     */ class FormatException extends Exception {
        static getFormatInstance() {
            return new FormatException();
        }
    }
    FormatException.kind = 'FormatException';
    /*import java.util.HashMap;*/ /*import java.util.Map;*/ var CharacterSetValueIdentifiers;
    (function(CharacterSetValueIdentifiers) {
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp437"] = 0] = "Cp437";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_1"] = 1] = "ISO8859_1";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_2"] = 2] = "ISO8859_2";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_3"] = 3] = "ISO8859_3";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_4"] = 4] = "ISO8859_4";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_5"] = 5] = "ISO8859_5";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_6"] = 6] = "ISO8859_6";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_7"] = 7] = "ISO8859_7";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_8"] = 8] = "ISO8859_8";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_9"] = 9] = "ISO8859_9";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_10"] = 10] = "ISO8859_10";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_11"] = 11] = "ISO8859_11";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_13"] = 12] = "ISO8859_13";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_14"] = 13] = "ISO8859_14";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_15"] = 14] = "ISO8859_15";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_16"] = 15] = "ISO8859_16";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["SJIS"] = 16] = "SJIS";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1250"] = 17] = "Cp1250";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1251"] = 18] = "Cp1251";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1252"] = 19] = "Cp1252";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1256"] = 20] = "Cp1256";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UnicodeBigUnmarked"] = 21] = "UnicodeBigUnmarked";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UTF8"] = 22] = "UTF8";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ASCII"] = 23] = "ASCII";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Big5"] = 24] = "Big5";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["GB18030"] = 25] = "GB18030";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["EUC_KR"] = 26] = "EUC_KR";
    })(CharacterSetValueIdentifiers || (CharacterSetValueIdentifiers = {}));
    /**
     * Encapsulates a Character Set ECI, according to "Extended Channel Interpretations" 5.3.1.1
     * of ISO 18004.
     *
     * @author Sean Owen
     */ class CharacterSetECI {
        constructor(valueIdentifier, valuesParam, name, ...otherEncodingNames){
            this.valueIdentifier = valueIdentifier;
            this.name = name;
            if (typeof valuesParam === 'number') this.values = Int32Array.from([
                valuesParam
            ]);
            else this.values = valuesParam;
            this.otherEncodingNames = otherEncodingNames;
            CharacterSetECI.VALUE_IDENTIFIER_TO_ECI.set(valueIdentifier, this);
            CharacterSetECI.NAME_TO_ECI.set(name, this);
            const values = this.values;
            for(let i = 0, length = values.length; i !== length; i++){
                const v = values[i];
                CharacterSetECI.VALUES_TO_ECI.set(v, this);
            }
            for (const otherName of otherEncodingNames)CharacterSetECI.NAME_TO_ECI.set(otherName, this);
        }
        // CharacterSetECI(value: number /*int*/) {
        //   this(new Int32Array {value})
        // }
        // CharacterSetECI(value: number /*int*/, String... otherEncodingNames) {
        //   this.values = new Int32Array {value}
        //   this.otherEncodingNames = otherEncodingNames
        // }
        // CharacterSetECI(values: Int32Array, String... otherEncodingNames) {
        //   this.values = values
        //   this.otherEncodingNames = otherEncodingNames
        // }
        getValueIdentifier() {
            return this.valueIdentifier;
        }
        getName() {
            return this.name;
        }
        getValue() {
            return this.values[0];
        }
        /**
         * @param value character set ECI value
         * @return {@code CharacterSetECI} representing ECI of given value, or null if it is legal but
         *   unsupported
         * @throws FormatException if ECI value is invalid
         */ static getCharacterSetECIByValue(value /*int*/ ) {
            if (value < 0 || value >= 900) throw new FormatException('incorect value');
            const characterSet = CharacterSetECI.VALUES_TO_ECI.get(value);
            if (undefined === characterSet) throw new FormatException('incorect value');
            return characterSet;
        }
        /**
         * @param name character set ECI encoding name
         * @return CharacterSetECI representing ECI for character encoding, or null if it is legal
         *   but unsupported
         */ static getCharacterSetECIByName(name) {
            const characterSet = CharacterSetECI.NAME_TO_ECI.get(name);
            if (undefined === characterSet) throw new FormatException('incorect value');
            return characterSet;
        }
        equals(o) {
            if (!(o instanceof CharacterSetECI)) return false;
            const other = o;
            return this.getName() === other.getName();
        }
    }
    CharacterSetECI.VALUE_IDENTIFIER_TO_ECI = new Map();
    CharacterSetECI.VALUES_TO_ECI = new Map();
    CharacterSetECI.NAME_TO_ECI = new Map();
    // Enum name is a Java encoding valid for java.lang and java.io
    // TYPESCRIPTPORT: changed the main label for ISO as the TextEncoder did not recognized them in the form from java
    // (eg ISO8859_1 must be ISO88591 or ISO8859-1 or ISO-8859-1)
    // later on: well, except 16 wich does not work with ISO885916 so used ISO-8859-1 form for default
    CharacterSetECI.Cp437 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp437, Int32Array.from([
        0,
        2
    ]), 'Cp437');
    CharacterSetECI.ISO8859_1 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_1, Int32Array.from([
        1,
        3
    ]), 'ISO-8859-1', 'ISO88591', 'ISO8859_1');
    CharacterSetECI.ISO8859_2 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_2, 4, 'ISO-8859-2', 'ISO88592', 'ISO8859_2');
    CharacterSetECI.ISO8859_3 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_3, 5, 'ISO-8859-3', 'ISO88593', 'ISO8859_3');
    CharacterSetECI.ISO8859_4 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_4, 6, 'ISO-8859-4', 'ISO88594', 'ISO8859_4');
    CharacterSetECI.ISO8859_5 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_5, 7, 'ISO-8859-5', 'ISO88595', 'ISO8859_5');
    CharacterSetECI.ISO8859_6 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_6, 8, 'ISO-8859-6', 'ISO88596', 'ISO8859_6');
    CharacterSetECI.ISO8859_7 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_7, 9, 'ISO-8859-7', 'ISO88597', 'ISO8859_7');
    CharacterSetECI.ISO8859_8 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_8, 10, 'ISO-8859-8', 'ISO88598', 'ISO8859_8');
    CharacterSetECI.ISO8859_9 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_9, 11, 'ISO-8859-9', 'ISO88599', 'ISO8859_9');
    CharacterSetECI.ISO8859_10 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_10, 12, 'ISO-8859-10', 'ISO885910', 'ISO8859_10');
    CharacterSetECI.ISO8859_11 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_11, 13, 'ISO-8859-11', 'ISO885911', 'ISO8859_11');
    CharacterSetECI.ISO8859_13 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_13, 15, 'ISO-8859-13', 'ISO885913', 'ISO8859_13');
    CharacterSetECI.ISO8859_14 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_14, 16, 'ISO-8859-14', 'ISO885914', 'ISO8859_14');
    CharacterSetECI.ISO8859_15 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_15, 17, 'ISO-8859-15', 'ISO885915', 'ISO8859_15');
    CharacterSetECI.ISO8859_16 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_16, 18, 'ISO-8859-16', 'ISO885916', 'ISO8859_16');
    CharacterSetECI.SJIS = new CharacterSetECI(CharacterSetValueIdentifiers.SJIS, 20, 'SJIS', 'Shift_JIS');
    CharacterSetECI.Cp1250 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1250, 21, 'Cp1250', 'windows-1250');
    CharacterSetECI.Cp1251 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1251, 22, 'Cp1251', 'windows-1251');
    CharacterSetECI.Cp1252 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1252, 23, 'Cp1252', 'windows-1252');
    CharacterSetECI.Cp1256 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1256, 24, 'Cp1256', 'windows-1256');
    CharacterSetECI.UnicodeBigUnmarked = new CharacterSetECI(CharacterSetValueIdentifiers.UnicodeBigUnmarked, 25, 'UnicodeBigUnmarked', 'UTF-16BE', 'UnicodeBig');
    CharacterSetECI.UTF8 = new CharacterSetECI(CharacterSetValueIdentifiers.UTF8, 26, 'UTF8', 'UTF-8');
    CharacterSetECI.ASCII = new CharacterSetECI(CharacterSetValueIdentifiers.ASCII, Int32Array.from([
        27,
        170
    ]), 'ASCII', 'US-ASCII');
    CharacterSetECI.Big5 = new CharacterSetECI(CharacterSetValueIdentifiers.Big5, 28, 'Big5');
    CharacterSetECI.GB18030 = new CharacterSetECI(CharacterSetValueIdentifiers.GB18030, 29, 'GB18030', 'GB2312', 'EUC_CN', 'GBK');
    CharacterSetECI.EUC_KR = new CharacterSetECI(CharacterSetValueIdentifiers.EUC_KR, 30, 'EUC_KR', 'EUC-KR');
    /**
     * Custom Error class of type Exception.
     */ class UnsupportedOperationException extends Exception {
    }
    UnsupportedOperationException.kind = 'UnsupportedOperationException';
    /**
     * Responsible for en/decoding strings.
     */ class StringEncoding {
        /**
         * Decodes some Uint8Array to a string format.
         */ static decode(bytes, encoding) {
            const encodingName = this.encodingName(encoding);
            if (this.customDecoder) return this.customDecoder(bytes, encodingName);
            // Increases browser support.
            if (typeof TextDecoder === 'undefined' || this.shouldDecodeOnFallback(encodingName)) return this.decodeFallback(bytes, encodingName);
            return new TextDecoder(encodingName).decode(bytes);
        }
        /**
         * Checks if the decoding method should use the fallback for decoding
         * once Node TextDecoder doesn't support all encoding formats.
         *
         * @param encodingName
         */ static shouldDecodeOnFallback(encodingName) {
            return !StringEncoding.isBrowser() && encodingName === 'ISO-8859-1';
        }
        /**
         * Encodes some string into a Uint8Array.
         */ static encode(s, encoding) {
            const encodingName = this.encodingName(encoding);
            if (this.customEncoder) return this.customEncoder(s, encodingName);
            // Increases browser support.
            if (typeof TextEncoder === 'undefined') return this.encodeFallback(s);
            // TextEncoder only encodes to UTF8 by default as specified by encoding.spec.whatwg.org
            return new TextEncoder().encode(s);
        }
        static isBrowser() {
            return typeof window !== 'undefined' && ({}).toString.call(window) === '[object Window]';
        }
        /**
         * Returns the string value from some encoding character set.
         */ static encodingName(encoding) {
            return typeof encoding === 'string' ? encoding : encoding.getName();
        }
        /**
         * Returns character set from some encoding character set.
         */ static encodingCharacterSet(encoding) {
            if (encoding instanceof CharacterSetECI) return encoding;
            return CharacterSetECI.getCharacterSetECIByName(encoding);
        }
        /**
         * Runs a fallback for the native decoding funcion.
         */ static decodeFallback(bytes, encoding) {
            const characterSet = this.encodingCharacterSet(encoding);
            if (StringEncoding.isDecodeFallbackSupported(characterSet)) {
                let s = '';
                for(let i = 0, length = bytes.length; i < length; i++){
                    let h = bytes[i].toString(16);
                    if (h.length < 2) h = '0' + h;
                    s += '%' + h;
                }
                return decodeURIComponent(s);
            }
            if (characterSet.equals(CharacterSetECI.UnicodeBigUnmarked)) return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
            throw new UnsupportedOperationException(`Encoding ${this.encodingName(encoding)} not supported by fallback.`);
        }
        static isDecodeFallbackSupported(characterSet) {
            return characterSet.equals(CharacterSetECI.UTF8) || characterSet.equals(CharacterSetECI.ISO8859_1) || characterSet.equals(CharacterSetECI.ASCII);
        }
        /**
         * Runs a fallback for the native encoding funcion.
         *
         * @see https://stackoverflow.com/a/17192845/4367683
         */ static encodeFallback(s) {
            const encodedURIstring = btoa(unescape(encodeURIComponent(s)));
            const charList = encodedURIstring.split('');
            const uintArray = [];
            for(let i = 0; i < charList.length; i++)uintArray.push(charList[i].charCodeAt(0));
            return new Uint8Array(uintArray);
        }
    }
    /*
     * Copyright (C) 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * Common string-related functions.
     *
     * @author Sean Owen
     * @author Alex Dupre
     */ class StringUtils {
        // SHIFT_JIS.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING) ||
        // EUC_JP.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING);
        static castAsNonUtf8Char(code, encoding = null) {
            // ISO 8859-1 is the Java default as UTF-8 is JavaScripts
            // you can see this method as a Java version of String.fromCharCode
            const e = encoding ? encoding.getName() : this.ISO88591;
            // use passed format (fromCharCode will return UTF8 encoding)
            return StringEncoding.decode(new Uint8Array([
                code
            ]), e);
        }
        /**
         * @param bytes bytes encoding a string, whose encoding should be guessed
         * @param hints decode hints if applicable
         * @return name of guessed encoding; at the moment will only guess one of:
         *  {@link #SHIFT_JIS}, {@link #UTF8}, {@link #ISO88591}, or the platform
         *  default encoding if none of these can possibly be correct
         */ static guessEncoding(bytes, hints) {
            if (hints !== null && hints !== undefined && undefined !== hints.get(DecodeHintType$1.CHARACTER_SET)) return hints.get(DecodeHintType$1.CHARACTER_SET).toString();
            // For now, merely tries to distinguish ISO-8859-1, UTF-8 and Shift_JIS,
            // which should be by far the most common encodings.
            const length = bytes.length;
            let canBeISO88591 = true;
            let canBeShiftJIS = true;
            let canBeUTF8 = true;
            let utf8BytesLeft = 0;
            // int utf8LowChars = 0
            let utf2BytesChars = 0;
            let utf3BytesChars = 0;
            let utf4BytesChars = 0;
            let sjisBytesLeft = 0;
            // int sjisLowChars = 0
            let sjisKatakanaChars = 0;
            // int sjisDoubleBytesChars = 0
            let sjisCurKatakanaWordLength = 0;
            let sjisCurDoubleBytesWordLength = 0;
            let sjisMaxKatakanaWordLength = 0;
            let sjisMaxDoubleBytesWordLength = 0;
            // int isoLowChars = 0
            // int isoHighChars = 0
            let isoHighOther = 0;
            const utf8bom = bytes.length > 3 && bytes[0] === /*(byte) */ 0xEF && bytes[1] === /*(byte) */ 0xBB && bytes[2] === /*(byte) */ 0xBF;
            for(let i = 0; i < length && (canBeISO88591 || canBeShiftJIS || canBeUTF8); i++){
                const value = bytes[i] & 0xFF;
                // UTF-8 stuff
                if (canBeUTF8) {
                    if (utf8BytesLeft > 0) {
                        if ((value & 0x80) === 0) canBeUTF8 = false;
                        else utf8BytesLeft--;
                    } else if ((value & 0x80) !== 0) {
                        if ((value & 0x40) === 0) canBeUTF8 = false;
                        else {
                            utf8BytesLeft++;
                            if ((value & 0x20) === 0) utf2BytesChars++;
                            else {
                                utf8BytesLeft++;
                                if ((value & 0x10) === 0) utf3BytesChars++;
                                else {
                                    utf8BytesLeft++;
                                    if ((value & 0x08) === 0) utf4BytesChars++;
                                    else canBeUTF8 = false;
                                }
                            }
                        }
                    } // else {
                // utf8LowChars++
                // }
                }
                // ISO-8859-1 stuff
                if (canBeISO88591) {
                    if (value > 0x7F && value < 0xA0) canBeISO88591 = false;
                    else if (value > 0x9F) {
                        if (value < 0xC0 || value === 0xD7 || value === 0xF7) isoHighOther++;
                         // else {
                    } // else {
                // isoLowChars++
                // }
                }
                // Shift_JIS stuff
                if (canBeShiftJIS) {
                    if (sjisBytesLeft > 0) {
                        if (value < 0x40 || value === 0x7F || value > 0xFC) canBeShiftJIS = false;
                        else sjisBytesLeft--;
                    } else if (value === 0x80 || value === 0xA0 || value > 0xEF) canBeShiftJIS = false;
                    else if (value > 0xA0 && value < 0xE0) {
                        sjisKatakanaChars++;
                        sjisCurDoubleBytesWordLength = 0;
                        sjisCurKatakanaWordLength++;
                        if (sjisCurKatakanaWordLength > sjisMaxKatakanaWordLength) sjisMaxKatakanaWordLength = sjisCurKatakanaWordLength;
                    } else if (value > 0x7F) {
                        sjisBytesLeft++;
                        // sjisDoubleBytesChars++
                        sjisCurKatakanaWordLength = 0;
                        sjisCurDoubleBytesWordLength++;
                        if (sjisCurDoubleBytesWordLength > sjisMaxDoubleBytesWordLength) sjisMaxDoubleBytesWordLength = sjisCurDoubleBytesWordLength;
                    } else {
                        // sjisLowChars++
                        sjisCurKatakanaWordLength = 0;
                        sjisCurDoubleBytesWordLength = 0;
                    }
                }
            }
            if (canBeUTF8 && utf8BytesLeft > 0) canBeUTF8 = false;
            if (canBeShiftJIS && sjisBytesLeft > 0) canBeShiftJIS = false;
            // Easy -- if there is BOM or at least 1 valid not-single byte character (and no evidence it can't be UTF-8), done
            if (canBeUTF8 && (utf8bom || utf2BytesChars + utf3BytesChars + utf4BytesChars > 0)) return StringUtils.UTF8;
            // Easy -- if assuming Shift_JIS or at least 3 valid consecutive not-ascii characters (and no evidence it can't be), done
            if (canBeShiftJIS && (StringUtils.ASSUME_SHIFT_JIS || sjisMaxKatakanaWordLength >= 3 || sjisMaxDoubleBytesWordLength >= 3)) return StringUtils.SHIFT_JIS;
            // Distinguishing Shift_JIS and ISO-8859-1 can be a little tough for short words. The crude heuristic is:
            // - If we saw
            //   - only two consecutive katakana chars in the whole text, or
            //   - at least 10% of bytes that could be "upper" not-alphanumeric Latin1,
            // - then we conclude Shift_JIS, else ISO-8859-1
            if (canBeISO88591 && canBeShiftJIS) return sjisMaxKatakanaWordLength === 2 && sjisKatakanaChars === 2 || isoHighOther * 10 >= length ? StringUtils.SHIFT_JIS : StringUtils.ISO88591;
            // Otherwise, try in order ISO-8859-1, Shift JIS, UTF-8 and fall back to default platform encoding
            if (canBeISO88591) return StringUtils.ISO88591;
            if (canBeShiftJIS) return StringUtils.SHIFT_JIS;
            if (canBeUTF8) return StringUtils.UTF8;
            // Otherwise, we take a wild guess with platform encoding
            return StringUtils.PLATFORM_DEFAULT_ENCODING;
        }
        /**
         *
         * @see https://stackoverflow.com/a/13439711/4367683
         *
         * @param append The new string to append.
         * @param args Argumets values to be formated.
         */ static format(append, ...args) {
            let i = -1;
            function callback(exp, p0, p1, p2, p3, p4) {
                if (exp === '%%') return '%';
                if (args[++i] === undefined) return undefined;
                exp = p2 ? parseInt(p2.substr(1)) : undefined;
                let base = p3 ? parseInt(p3.substr(1)) : undefined;
                let val;
                switch(p4){
                    case 's':
                        val = args[i];
                        break;
                    case 'c':
                        val = args[i][0];
                        break;
                    case 'f':
                        val = parseFloat(args[i]).toFixed(exp);
                        break;
                    case 'p':
                        val = parseFloat(args[i]).toPrecision(exp);
                        break;
                    case 'e':
                        val = parseFloat(args[i]).toExponential(exp);
                        break;
                    case 'x':
                        val = parseInt(args[i]).toString(base ? base : 16);
                        break;
                    case 'd':
                        val = parseFloat(parseInt(args[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                        break;
                }
                val = typeof val === 'object' ? JSON.stringify(val) : (+val).toString(base);
                let size = parseInt(p1); /* padding size */ 
                let ch = p1 && p1[0] + '' === '0' ? '0' : ' '; /* isnull? */ 
                while(val.length < size)val = p0 !== undefined ? val + ch : ch + val; /* isminus? */ 
                return val;
            }
            let regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
            return append.replace(regex, callback);
        }
        /**
         *
         */ static getBytes(str, encoding) {
            return StringEncoding.encode(str, encoding);
        }
        /**
         * Returns the charcode at the specified index or at index zero.
         */ static getCharCode(str, index = 0) {
            return str.charCodeAt(index);
        }
        /**
         * Returns char for given charcode
         */ static getCharAt(charCode) {
            return String.fromCharCode(charCode);
        }
    }
    StringUtils.SHIFT_JIS = CharacterSetECI.SJIS.getName(); // "SJIS"
    StringUtils.GB2312 = 'GB2312';
    StringUtils.ISO88591 = CharacterSetECI.ISO8859_1.getName(); // "ISO8859_1"
    StringUtils.EUC_JP = 'EUC_JP';
    StringUtils.UTF8 = CharacterSetECI.UTF8.getName(); // "UTF8"
    StringUtils.PLATFORM_DEFAULT_ENCODING = StringUtils.UTF8; // "UTF8"//Charset.defaultCharset().name()
    StringUtils.ASSUME_SHIFT_JIS = false;
    class StringBuilder {
        constructor(value = ''){
            this.value = value;
        }
        enableDecoding(encoding) {
            this.encoding = encoding;
            return this;
        }
        append(s) {
            if (typeof s === 'string') this.value += s.toString();
            else if (this.encoding) // use passed format (fromCharCode will return UTF8 encoding)
            this.value += StringUtils.castAsNonUtf8Char(s, this.encoding);
            else // correctly converts from UTF-8, but not other encodings
            this.value += String.fromCharCode(s);
            return this;
        }
        appendChars(str, offset, len) {
            for(let i = offset; offset < offset + len; i++)this.append(str[i]);
            return this;
        }
        length() {
            return this.value.length;
        }
        charAt(n) {
            return this.value.charAt(n);
        }
        deleteCharAt(n) {
            this.value = this.value.substr(0, n) + this.value.substring(n + 1);
        }
        setCharAt(n, c) {
            this.value = this.value.substr(0, n) + c + this.value.substr(n + 1);
        }
        substring(start, end) {
            return this.value.substring(start, end);
        }
        /**
         * @note helper method for RSS Expanded
         */ setLengthToZero() {
            this.value = '';
        }
        toString() {
            return this.value;
        }
        insert(n, c) {
            this.value = this.value.substr(0, n) + c + this.value.substr(n + c.length);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Represents a 2D matrix of bits. In function arguments below, and throughout the common
     * module, x is the column position, and y is the row position. The ordering is always x, y.
     * The origin is at the top-left.</p>
     *
     * <p>Internally the bits are represented in a 1-D array of 32-bit ints. However, each row begins
     * with a new int. This is done intentionally so that we can copy out a row into a BitArray very
     * efficiently.</p>
     *
     * <p>The ordering of bits is row-major. Within each int, the least significant bits are used first,
     * meaning they represent lower x values. This is compatible with BitArray's implementation.</p>
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     */ class BitMatrix {
        /**
         * Creates an empty square {@link BitMatrix}.
         *
         * @param dimension height and width
         */ // public constructor(dimension: number /*int*/) {
        //   this(dimension, dimension)
        // }
        /**
         * Creates an empty {@link BitMatrix}.
         *
         * @param width bit matrix width
         * @param height bit matrix height
         */ // public constructor(width: number /*int*/, height: number /*int*/) {
        //   if (width < 1 || height < 1) {
        //     throw new IllegalArgumentException("Both dimensions must be greater than 0")
        //   }
        //   this.width = width
        //   this.height = height
        //   this.rowSize = (width + 31) / 32
        //   bits = new int[rowSize * height];
        // }
        constructor(width /*int*/ , height /*int*/ , rowSize /*int*/ , bits){
            this.width = width;
            this.height = height;
            this.rowSize = rowSize;
            this.bits = bits;
            if (undefined === height || null === height) height = width;
            this.height = height;
            if (width < 1 || height < 1) throw new IllegalArgumentException('Both dimensions must be greater than 0');
            if (undefined === rowSize || null === rowSize) rowSize = Math.floor((width + 31) / 32);
            this.rowSize = rowSize;
            if (undefined === bits || null === bits) this.bits = new Int32Array(this.rowSize * this.height);
        }
        /**
         * Interprets a 2D array of booleans as a {@link BitMatrix}, where "true" means an "on" bit.
         *
         * @function parse
         * @param image bits of the image, as a row-major 2D array. Elements are arrays representing rows
         * @return {@link BitMatrix} representation of image
         */ static parseFromBooleanArray(image) {
            const height = image.length;
            const width = image[0].length;
            const bits = new BitMatrix(width, height);
            for(let i = 0; i < height; i++){
                const imageI = image[i];
                for(let j = 0; j < width; j++)if (imageI[j]) bits.set(j, i);
            }
            return bits;
        }
        /**
         *
         * @function parse
         * @param stringRepresentation
         * @param setString
         * @param unsetString
         */ static parseFromString(stringRepresentation, setString, unsetString) {
            if (stringRepresentation === null) throw new IllegalArgumentException('stringRepresentation cannot be null');
            const bits = new Array(stringRepresentation.length);
            let bitsPos = 0;
            let rowStartPos = 0;
            let rowLength = -1;
            let nRows = 0;
            let pos = 0;
            while(pos < stringRepresentation.length){
                if (stringRepresentation.charAt(pos) === '\n' || stringRepresentation.charAt(pos) === '\r') {
                    if (bitsPos > rowStartPos) {
                        if (rowLength === -1) rowLength = bitsPos - rowStartPos;
                        else if (bitsPos - rowStartPos !== rowLength) throw new IllegalArgumentException('row lengths do not match');
                        rowStartPos = bitsPos;
                        nRows++;
                    }
                    pos++;
                } else if (stringRepresentation.substring(pos, pos + setString.length) === setString) {
                    pos += setString.length;
                    bits[bitsPos] = true;
                    bitsPos++;
                } else if (stringRepresentation.substring(pos, pos + unsetString.length) === unsetString) {
                    pos += unsetString.length;
                    bits[bitsPos] = false;
                    bitsPos++;
                } else throw new IllegalArgumentException('illegal character encountered: ' + stringRepresentation.substring(pos));
            }
            // no EOL at end?
            if (bitsPos > rowStartPos) {
                if (rowLength === -1) rowLength = bitsPos - rowStartPos;
                else if (bitsPos - rowStartPos !== rowLength) throw new IllegalArgumentException('row lengths do not match');
                nRows++;
            }
            const matrix = new BitMatrix(rowLength, nRows);
            for(let i = 0; i < bitsPos; i++)if (bits[i]) matrix.set(Math.floor(i % rowLength), Math.floor(i / rowLength));
            return matrix;
        }
        /**
         * <p>Gets the requested bit, where true means black.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         * @return value of given bit in matrix
         */ get(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            return (this.bits[offset] >>> (x & 0x1f) & 1) !== 0;
        }
        /**
         * <p>Sets the given bit to true.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         */ set(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] |= 1 << (x & 0x1f) & 0xFFFFFFFF;
        }
        unset(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] &= ~(1 << (x & 0x1f) & 0xFFFFFFFF);
        }
        /**
         * <p>Flips the given bit.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         */ flip(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] ^= 1 << (x & 0x1f) & 0xFFFFFFFF;
        }
        /**
         * Exclusive-or (XOR): Flip the bit in this {@code BitMatrix} if the corresponding
         * mask bit is set.
         *
         * @param mask XOR mask
         */ xor(mask) {
            if (this.width !== mask.getWidth() || this.height !== mask.getHeight() || this.rowSize !== mask.getRowSize()) throw new IllegalArgumentException('input matrix dimensions do not match');
            const rowArray = new BitArray(Math.floor(this.width / 32) + 1);
            const rowSize = this.rowSize;
            const bits = this.bits;
            for(let y = 0, height = this.height; y < height; y++){
                const offset = y * rowSize;
                const row = mask.getRow(y, rowArray).getBitArray();
                for(let x = 0; x < rowSize; x++)bits[offset + x] ^= row[x];
            }
        }
        /**
         * Clears all bits (sets to false).
         */ clear() {
            const bits = this.bits;
            const max = bits.length;
            for(let i = 0; i < max; i++)bits[i] = 0;
        }
        /**
         * <p>Sets a square region of the bit matrix to true.</p>
         *
         * @param left The horizontal position to begin at (inclusive)
         * @param top The vertical position to begin at (inclusive)
         * @param width The width of the region
         * @param height The height of the region
         */ setRegion(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            if (top < 0 || left < 0) throw new IllegalArgumentException('Left and top must be nonnegative');
            if (height < 1 || width < 1) throw new IllegalArgumentException('Height and width must be at least 1');
            const right = left + width;
            const bottom = top + height;
            if (bottom > this.height || right > this.width) throw new IllegalArgumentException('The region must fit inside the matrix');
            const rowSize = this.rowSize;
            const bits = this.bits;
            for(let y = top; y < bottom; y++){
                const offset = y * rowSize;
                for(let x = left; x < right; x++)bits[offset + Math.floor(x / 32)] |= 1 << (x & 0x1f) & 0xFFFFFFFF;
            }
        }
        /**
         * A fast method to retrieve one row of data from the matrix as a BitArray.
         *
         * @param y The row to retrieve
         * @param row An optional caller-allocated BitArray, will be allocated if null or too small
         * @return The resulting BitArray - this reference should always be used even when passing
         *         your own row
         */ getRow(y /*int*/ , row) {
            if (row === null || row === undefined || row.getSize() < this.width) row = new BitArray(this.width);
            else row.clear();
            const rowSize = this.rowSize;
            const bits = this.bits;
            const offset = y * rowSize;
            for(let x = 0; x < rowSize; x++)row.setBulk(x * 32, bits[offset + x]);
            return row;
        }
        /**
         * @param y row to set
         * @param row {@link BitArray} to copy from
         */ setRow(y /*int*/ , row) {
            System.arraycopy(row.getBitArray(), 0, this.bits, y * this.rowSize, this.rowSize);
        }
        /**
         * Modifies this {@code BitMatrix} to represent the same but rotated 180 degrees
         */ rotate180() {
            const width = this.getWidth();
            const height = this.getHeight();
            let topRow = new BitArray(width);
            let bottomRow = new BitArray(width);
            for(let i = 0, length = Math.floor((height + 1) / 2); i < length; i++){
                topRow = this.getRow(i, topRow);
                bottomRow = this.getRow(height - 1 - i, bottomRow);
                topRow.reverse();
                bottomRow.reverse();
                this.setRow(i, bottomRow);
                this.setRow(height - 1 - i, topRow);
            }
        }
        /**
         * This is useful in detecting the enclosing rectangle of a 'pure' barcode.
         *
         * @return {@code left,top,width,height} enclosing rectangle of all 1 bits, or null if it is all white
         */ getEnclosingRectangle() {
            const width = this.width;
            const height = this.height;
            const rowSize = this.rowSize;
            const bits = this.bits;
            let left = width;
            let top = height;
            let right = -1;
            let bottom = -1;
            for(let y = 0; y < height; y++)for(let x32 = 0; x32 < rowSize; x32++){
                const theBits = bits[y * rowSize + x32];
                if (theBits !== 0) {
                    if (y < top) top = y;
                    if (y > bottom) bottom = y;
                    if (x32 * 32 < left) {
                        let bit = 0;
                        while((theBits << 31 - bit & 0xFFFFFFFF) === 0)bit++;
                        if (x32 * 32 + bit < left) left = x32 * 32 + bit;
                    }
                    if (x32 * 32 + 31 > right) {
                        let bit = 31;
                        while(theBits >>> bit === 0)bit--;
                        if (x32 * 32 + bit > right) right = x32 * 32 + bit;
                    }
                }
            }
            if (right < left || bottom < top) return null;
            return Int32Array.from([
                left,
                top,
                right - left + 1,
                bottom - top + 1
            ]);
        }
        /**
         * This is useful in detecting a corner of a 'pure' barcode.
         *
         * @return {@code x,y} coordinate of top-left-most 1 bit, or null if it is all white
         */ getTopLeftOnBit() {
            const rowSize = this.rowSize;
            const bits = this.bits;
            let bitsOffset = 0;
            while(bitsOffset < bits.length && bits[bitsOffset] === 0)bitsOffset++;
            if (bitsOffset === bits.length) return null;
            const y = bitsOffset / rowSize;
            let x = bitsOffset % rowSize * 32;
            const theBits = bits[bitsOffset];
            let bit = 0;
            while((theBits << 31 - bit & 0xFFFFFFFF) === 0)bit++;
            x += bit;
            return Int32Array.from([
                x,
                y
            ]);
        }
        getBottomRightOnBit() {
            const rowSize = this.rowSize;
            const bits = this.bits;
            let bitsOffset = bits.length - 1;
            while(bitsOffset >= 0 && bits[bitsOffset] === 0)bitsOffset--;
            if (bitsOffset < 0) return null;
            const y = Math.floor(bitsOffset / rowSize);
            let x = Math.floor(bitsOffset % rowSize) * 32;
            const theBits = bits[bitsOffset];
            let bit = 31;
            while(theBits >>> bit === 0)bit--;
            x += bit;
            return Int32Array.from([
                x,
                y
            ]);
        }
        /**
         * @return The width of the matrix
         */ getWidth() {
            return this.width;
        }
        /**
         * @return The height of the matrix
         */ getHeight() {
            return this.height;
        }
        /**
         * @return The row size of the matrix
         */ getRowSize() {
            return this.rowSize;
        }
        /*@Override*/ equals(o) {
            if (!(o instanceof BitMatrix)) return false;
            const other = o;
            return this.width === other.width && this.height === other.height && this.rowSize === other.rowSize && Arrays.equals(this.bits, other.bits);
        }
        /*@Override*/ hashCode() {
            let hash = this.width;
            hash = 31 * hash + this.width;
            hash = 31 * hash + this.height;
            hash = 31 * hash + this.rowSize;
            hash = 31 * hash + Arrays.hashCode(this.bits);
            return hash;
        }
        /**
         * @return string representation using "X" for set and " " for unset bits
         */ /*@Override*/ // public toString(): string {
        //   return toString(": "X, "  ")
        // }
        /**
         * @param setString representation of a set bit
         * @param unsetString representation of an unset bit
         * @return string representation of entire matrix utilizing given strings
         */ // public toString(setString: string = "X ", unsetString: string = "  "): string {
        //   return this.buildToString(setString, unsetString, "\n")
        // }
        /**
         * @param setString representation of a set bit
         * @param unsetString representation of an unset bit
         * @param lineSeparator newline character in string representation
         * @return string representation of entire matrix utilizing given strings and line separator
         * @deprecated call {@link #toString(String,String)} only, which uses \n line separator always
         */ // @Deprecated
        toString(setString = 'X ', unsetString = '  ', lineSeparator = '\n') {
            return this.buildToString(setString, unsetString, lineSeparator);
        }
        buildToString(setString, unsetString, lineSeparator) {
            let result = new StringBuilder();
            // result.append(lineSeparator);
            for(let y = 0, height = this.height; y < height; y++){
                for(let x = 0, width = this.width; x < width; x++)result.append(this.get(x, y) ? setString : unsetString);
                result.append(lineSeparator);
            }
            return result.toString();
        }
        /*@Override*/ clone() {
            return new BitMatrix(this.width, this.height, this.rowSize, this.bits.slice());
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class NotFoundException extends Exception {
        static getNotFoundInstance() {
            return new NotFoundException();
        }
    }
    NotFoundException.kind = 'NotFoundException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This Binarizer implementation uses the old ZXing global histogram approach. It is suitable
     * for low-end mobile devices which don't have enough CPU or memory to use a local thresholding
     * algorithm. However, because it picks a global black point, it cannot handle difficult shadows
     * and gradients.
     *
     * Faster mobile devices and all desktop applications should probably use HybridBinarizer instead.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     */ class GlobalHistogramBinarizer extends Binarizer {
        constructor(source){
            super(source);
            this.luminances = GlobalHistogramBinarizer.EMPTY;
            this.buckets = new Int32Array(GlobalHistogramBinarizer.LUMINANCE_BUCKETS);
        }
        // Applies simple sharpening to the row data to improve performance of the 1D Readers.
        /*@Override*/ getBlackRow(y /*int*/ , row) {
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            if (row === undefined || row === null || row.getSize() < width) row = new BitArray(width);
            else row.clear();
            this.initArrays(width);
            const localLuminances = source.getRow(y, this.luminances);
            const localBuckets = this.buckets;
            for(let x = 0; x < width; x++)localBuckets[(localLuminances[x] & 0xff) >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
            const blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
            if (width < 3) {
                // Special case for very small images
                for(let x = 0; x < width; x++)if ((localLuminances[x] & 0xff) < blackPoint) row.set(x);
            } else {
                let left = localLuminances[0] & 0xff;
                let center = localLuminances[1] & 0xff;
                for(let x = 1; x < width - 1; x++){
                    const right = localLuminances[x + 1] & 0xff;
                    // A simple -1 4 -1 box filter with a weight of 2.
                    if ((center * 4 - left - right) / 2 < blackPoint) row.set(x);
                    left = center;
                    center = right;
                }
            }
            return row;
        }
        // Does not sharpen the data, as this call is intended to only be used by 2D Readers.
        /*@Override*/ getBlackMatrix() {
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            const height = source.getHeight();
            const matrix = new BitMatrix(width, height);
            // Quickly calculates the histogram by sampling four rows from the image. This proved to be
            // more robust on the blackbox tests than sampling a diagonal as we used to do.
            this.initArrays(width);
            const localBuckets = this.buckets;
            for(let y = 1; y < 5; y++){
                const row = Math.floor(height * y / 5);
                const localLuminances = source.getRow(row, this.luminances);
                const right = Math.floor(width * 4 / 5);
                for(let x = Math.floor(width / 5); x < right; x++){
                    const pixel = localLuminances[x] & 0xff;
                    localBuckets[pixel >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
                }
            }
            const blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
            // We delay reading the entire image luminance until the black point estimation succeeds.
            // Although we end up reading four rows twice, it is consistent with our motto of
            // "fail quickly" which is necessary for continuous scanning.
            const localLuminances = source.getMatrix();
            for(let y = 0; y < height; y++){
                const offset = y * width;
                for(let x = 0; x < width; x++){
                    const pixel = localLuminances[offset + x] & 0xff;
                    if (pixel < blackPoint) matrix.set(x, y);
                }
            }
            return matrix;
        }
        /*@Override*/ createBinarizer(source) {
            return new GlobalHistogramBinarizer(source);
        }
        initArrays(luminanceSize /*int*/ ) {
            if (this.luminances.length < luminanceSize) this.luminances = new Uint8ClampedArray(luminanceSize);
            const buckets = this.buckets;
            for(let x = 0; x < GlobalHistogramBinarizer.LUMINANCE_BUCKETS; x++)buckets[x] = 0;
        }
        static estimateBlackPoint(buckets) {
            // Find the tallest peak in the histogram.
            const numBuckets = buckets.length;
            let maxBucketCount = 0;
            let firstPeak = 0;
            let firstPeakSize = 0;
            for(let x = 0; x < numBuckets; x++){
                if (buckets[x] > firstPeakSize) {
                    firstPeak = x;
                    firstPeakSize = buckets[x];
                }
                if (buckets[x] > maxBucketCount) maxBucketCount = buckets[x];
            }
            // Find the second-tallest peak which is somewhat far from the tallest peak.
            let secondPeak = 0;
            let secondPeakScore = 0;
            for(let x = 0; x < numBuckets; x++){
                const distanceToBiggest = x - firstPeak;
                // Encourage more distant second peaks by multiplying by square of distance.
                const score = buckets[x] * distanceToBiggest * distanceToBiggest;
                if (score > secondPeakScore) {
                    secondPeak = x;
                    secondPeakScore = score;
                }
            }
            // Make sure firstPeak corresponds to the black peak.
            if (firstPeak > secondPeak) {
                const temp = firstPeak;
                firstPeak = secondPeak;
                secondPeak = temp;
            }
            // If there is too little contrast in the image to pick a meaningful black point, throw rather
            // than waste time trying to decode the image, and risk false positives.
            if (secondPeak - firstPeak <= numBuckets / 16) throw new NotFoundException();
            // Find a valley between them that is low and closer to the white peak.
            let bestValley = secondPeak - 1;
            let bestValleyScore = -1;
            for(let x = secondPeak - 1; x > firstPeak; x--){
                const fromFirst = x - firstPeak;
                const score = fromFirst * fromFirst * (secondPeak - x) * (maxBucketCount - buckets[x]);
                if (score > bestValleyScore) {
                    bestValley = x;
                    bestValleyScore = score;
                }
            }
            return bestValley << GlobalHistogramBinarizer.LUMINANCE_SHIFT;
        }
    }
    GlobalHistogramBinarizer.LUMINANCE_BITS = 5;
    GlobalHistogramBinarizer.LUMINANCE_SHIFT = 8 - GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.LUMINANCE_BUCKETS = 1 << GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.EMPTY = Uint8ClampedArray.from([
        0
    ]);
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This class implements a local thresholding algorithm, which while slower than the
     * GlobalHistogramBinarizer, is fairly efficient for what it does. It is designed for
     * high frequency images of barcodes with black data on white backgrounds. For this application,
     * it does a much better job than a global blackpoint with severe shadows and gradients.
     * However it tends to produce artifacts on lower frequency images and is therefore not
     * a good general purpose binarizer for uses outside ZXing.
     *
     * This class extends GlobalHistogramBinarizer, using the older histogram approach for 1D readers,
     * and the newer local approach for 2D readers. 1D decoding using a per-row histogram is already
     * inherently local, and only fails for horizontal gradients. We can revisit that problem later,
     * but for now it was not a win to use local blocks for 1D.
     *
     * This Binarizer is the default for the unit tests and the recommended class for library users.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class HybridBinarizer extends GlobalHistogramBinarizer {
        constructor(source){
            super(source);
            this.matrix = null;
        }
        /**
         * Calculates the final BitMatrix once for all requests. This could be called once from the
         * constructor instead, but there are some advantages to doing it lazily, such as making
         * profiling easier, and not doing heavy lifting when callers don't expect it.
         */ /*@Override*/ getBlackMatrix() {
            if (this.matrix !== null) return this.matrix;
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            const height = source.getHeight();
            if (width >= HybridBinarizer.MINIMUM_DIMENSION && height >= HybridBinarizer.MINIMUM_DIMENSION) {
                const luminances = source.getMatrix();
                let subWidth = width >> HybridBinarizer.BLOCK_SIZE_POWER;
                if ((width & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) subWidth++;
                let subHeight = height >> HybridBinarizer.BLOCK_SIZE_POWER;
                if ((height & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) subHeight++;
                const blackPoints = HybridBinarizer.calculateBlackPoints(luminances, subWidth, subHeight, width, height);
                const newMatrix = new BitMatrix(width, height);
                HybridBinarizer.calculateThresholdForBlock(luminances, subWidth, subHeight, width, height, blackPoints, newMatrix);
                this.matrix = newMatrix;
            } else // If the image is too small, fall back to the global histogram approach.
            this.matrix = super.getBlackMatrix();
            return this.matrix;
        }
        /*@Override*/ createBinarizer(source) {
            return new HybridBinarizer(source);
        }
        /**
         * For each block in the image, calculate the average black point using a 5x5 grid
         * of the blocks around it. Also handles the corner cases (fractional blocks are computed based
         * on the last pixels in the row/column which are also used in the previous block).
         */ static calculateThresholdForBlock(luminances, subWidth /*int*/ , subHeight /*int*/ , width /*int*/ , height /*int*/ , blackPoints, matrix) {
            const maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
            const maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
            for(let y = 0; y < subHeight; y++){
                let yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
                if (yoffset > maxYOffset) yoffset = maxYOffset;
                const top = HybridBinarizer.cap(y, 2, subHeight - 3);
                for(let x = 0; x < subWidth; x++){
                    let xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                    if (xoffset > maxXOffset) xoffset = maxXOffset;
                    const left = HybridBinarizer.cap(x, 2, subWidth - 3);
                    let sum = 0;
                    for(let z = -2; z <= 2; z++){
                        const blackRow = blackPoints[top + z];
                        sum += blackRow[left - 2] + blackRow[left - 1] + blackRow[left] + blackRow[left + 1] + blackRow[left + 2];
                    }
                    const average = sum / 25;
                    HybridBinarizer.thresholdBlock(luminances, xoffset, yoffset, average, width, matrix);
                }
            }
        }
        static cap(value /*int*/ , min /*int*/ , max /*int*/ ) {
            return value < min ? min : value > max ? max : value;
        }
        /**
         * Applies a single threshold to a block of pixels.
         */ static thresholdBlock(luminances, xoffset /*int*/ , yoffset /*int*/ , threshold /*int*/ , stride /*int*/ , matrix) {
            for(let y = 0, offset = yoffset * stride + xoffset; y < HybridBinarizer.BLOCK_SIZE; y++, offset += stride){
                for(let x = 0; x < HybridBinarizer.BLOCK_SIZE; x++)// Comparison needs to be <= so that black == 0 pixels are black even if the threshold is 0.
                if ((luminances[offset + x] & 0xFF) <= threshold) matrix.set(xoffset + x, yoffset + y);
            }
        }
        /**
         * Calculates a single black point for each block of pixels and saves it away.
         * See the following thread for a discussion of this algorithm:
         *  http://groups.google.com/group/zxing/browse_thread/thread/d06efa2c35a7ddc0
         */ static calculateBlackPoints(luminances, subWidth /*int*/ , subHeight /*int*/ , width /*int*/ , height /*int*/ ) {
            const maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
            const maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
            // tslint:disable-next-line:whitespace
            const blackPoints = new Array(subHeight); // subWidth
            for(let y = 0; y < subHeight; y++){
                blackPoints[y] = new Int32Array(subWidth);
                let yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
                if (yoffset > maxYOffset) yoffset = maxYOffset;
                for(let x = 0; x < subWidth; x++){
                    let xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                    if (xoffset > maxXOffset) xoffset = maxXOffset;
                    let sum = 0;
                    let min = 0xFF;
                    let max = 0;
                    for(let yy = 0, offset = yoffset * width + xoffset; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width){
                        for(let xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++){
                            const pixel = luminances[offset + xx] & 0xFF;
                            sum += pixel;
                            // still looking for good contrast
                            if (pixel < min) min = pixel;
                            if (pixel > max) max = pixel;
                        }
                        // short-circuit min/max tests once dynamic range is met
                        if (max - min > HybridBinarizer.MIN_DYNAMIC_RANGE) {
                            // finish the rest of the rows quickly
                            for(yy++, offset += width; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width)for(let xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++)sum += luminances[offset + xx] & 0xFF;
                        }
                    }
                    // The default estimate is the average of the values in the block.
                    let average = sum >> HybridBinarizer.BLOCK_SIZE_POWER * 2;
                    if (max - min <= HybridBinarizer.MIN_DYNAMIC_RANGE) {
                        // If variation within the block is low, assume this is a block with only light or only
                        // dark pixels. In that case we do not want to use the average, as it would divide this
                        // low contrast area into black and white pixels, essentially creating data out of noise.
                        //
                        // The default assumption is that the block is light/background. Since no estimate for
                        // the level of dark pixels exists locally, use half the min for the block.
                        average = min / 2;
                        if (y > 0 && x > 0) {
                            // Correct the "white background" assumption for blocks that have neighbors by comparing
                            // the pixels in this block to the previously calculated black points. This is based on
                            // the fact that dark barcode symbology is always surrounded by some amount of light
                            // background for which reasonable black point estimates were made. The bp estimated at
                            // the boundaries is used for the interior.
                            // The (min < bp) is arbitrary but works better than other heuristics that were tried.
                            const averageNeighborBlackPoint = (blackPoints[y - 1][x] + 2 * blackPoints[y][x - 1] + blackPoints[y - 1][x - 1]) / 4;
                            if (min < averageNeighborBlackPoint) average = averageNeighborBlackPoint;
                        }
                    }
                    blackPoints[y][x] = average;
                }
            }
            return blackPoints;
        }
    }
    // This class uses 5x5 blocks to compute local luminance, where each block is 8x8 pixels.
    // So this is the smallest dimension in each axis we can accept.
    HybridBinarizer.BLOCK_SIZE_POWER = 3;
    HybridBinarizer.BLOCK_SIZE = 1 << HybridBinarizer.BLOCK_SIZE_POWER; // ...0100...00
    HybridBinarizer.BLOCK_SIZE_MASK = HybridBinarizer.BLOCK_SIZE - 1; // ...0011...11
    HybridBinarizer.MINIMUM_DIMENSION = HybridBinarizer.BLOCK_SIZE * 5;
    HybridBinarizer.MIN_DYNAMIC_RANGE = 24;
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * The purpose of this class hierarchy is to abstract different bitmap implementations across
     * platforms into a standard interface for requesting greyscale luminance values. The interface
     * only provides immutable methods; therefore crop and rotation create copies. This is to ensure
     * that one Reader does not modify the original luminance source and leave it in an unknown state
     * for other Readers in the chain.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class LuminanceSource {
        constructor(width /*int*/ , height /*int*/ ){
            this.width = width;
            this.height = height;
        }
        /**
         * @return The width of the bitmap.
         */ getWidth() {
            return this.width;
        }
        /**
         * @return The height of the bitmap.
         */ getHeight() {
            return this.height;
        }
        /**
         * @return Whether this subclass supports cropping.
         */ isCropSupported() {
            return false;
        }
        /**
         * Returns a new object with cropped image data. Implementations may keep a reference to the
         * original data rather than a copy. Only callable if isCropSupported() is true.
         *
         * @param left The left coordinate, which must be in [0,getWidth())
         * @param top The top coordinate, which must be in [0,getHeight())
         * @param width The width of the rectangle to crop.
         * @param height The height of the rectangle to crop.
         * @return A cropped version of this object.
         */ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            throw new UnsupportedOperationException('This luminance source does not support cropping.');
        }
        /**
         * @return Whether this subclass supports counter-clockwise rotation.
         */ isRotateSupported() {
            return false;
        }
        /**
         * Returns a new object with rotated image data by 90 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise() {
            throw new UnsupportedOperationException('This luminance source does not support rotation by 90 degrees.');
        }
        /**
         * Returns a new object with rotated image data by 45 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise45() {
            throw new UnsupportedOperationException('This luminance source does not support rotation by 45 degrees.');
        }
        /*@Override*/ toString() {
            const row = new Uint8ClampedArray(this.width);
            let result = new StringBuilder();
            for(let y = 0; y < this.height; y++){
                const sourceRow = this.getRow(y, row);
                for(let x = 0; x < this.width; x++){
                    const luminance = sourceRow[x] & 0xFF;
                    let c;
                    if (luminance < 0x40) c = '#';
                    else if (luminance < 0x80) c = '+';
                    else if (luminance < 0xC0) c = '.';
                    else c = ' ';
                    result.append(c);
                }
                result.append('\n');
            }
            return result.toString();
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * A wrapper implementation of {@link LuminanceSource} which inverts the luminances it returns -- black becomes
     * white and vice versa, and each value becomes (255-value).
     *
     * @author Sean Owen
     */ class InvertedLuminanceSource extends LuminanceSource {
        constructor(delegate){
            super(delegate.getWidth(), delegate.getHeight());
            this.delegate = delegate;
        }
        /*@Override*/ getRow(y /*int*/ , row) {
            const sourceRow = this.delegate.getRow(y, row);
            const width = this.getWidth();
            for(let i = 0; i < width; i++)sourceRow[i] = /*(byte)*/ 255 - (sourceRow[i] & 0xFF);
            return sourceRow;
        }
        /*@Override*/ getMatrix() {
            const matrix = this.delegate.getMatrix();
            const length = this.getWidth() * this.getHeight();
            const invertedMatrix = new Uint8ClampedArray(length);
            for(let i = 0; i < length; i++)invertedMatrix[i] = /*(byte)*/ 255 - (matrix[i] & 0xFF);
            return invertedMatrix;
        }
        /*@Override*/ isCropSupported() {
            return this.delegate.isCropSupported();
        }
        /*@Override*/ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            return new InvertedLuminanceSource(this.delegate.crop(left, top, width, height));
        }
        /*@Override*/ isRotateSupported() {
            return this.delegate.isRotateSupported();
        }
        /**
         * @return original delegate {@link LuminanceSource} since invert undoes itself
         */ /*@Override*/ invert() {
            return this.delegate;
        }
        /*@Override*/ rotateCounterClockwise() {
            return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise());
        }
        /*@Override*/ rotateCounterClockwise45() {
            return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise45());
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     */ class HTMLCanvasElementLuminanceSource extends LuminanceSource {
        constructor(canvas){
            super(canvas.width, canvas.height);
            this.canvas = canvas;
            this.tempCanvasElement = null;
            this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(canvas);
        }
        static makeBufferFromCanvasImageData(canvas) {
            const imageData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
            return HTMLCanvasElementLuminanceSource.toGrayscaleBuffer(imageData.data, canvas.width, canvas.height);
        }
        static toGrayscaleBuffer(imageBuffer, width, height) {
            const grayscaleBuffer = new Uint8ClampedArray(width * height);
            for(let i = 0, j = 0, length = imageBuffer.length; i < length; i += 4, j++){
                let gray;
                const alpha = imageBuffer[i + 3];
                // The color of fully-transparent pixels is irrelevant. They are often, technically, fully-transparent
                // black (0 alpha, and then 0 RGB). They are often used, of course as the "white" area in a
                // barcode image. Force any such pixel to be white:
                if (alpha === 0) gray = 0xFF;
                else {
                    const pixelR = imageBuffer[i];
                    const pixelG = imageBuffer[i + 1];
                    const pixelB = imageBuffer[i + 2];
                    // .299R + 0.587G + 0.114B (YUV/YIQ for PAL and NTSC),
                    // (306*R) >> 10 is approximately equal to R*0.299, and so on.
                    // 0x200 >> 10 is 0.5, it implements rounding.
                    gray = 306 * pixelR + 601 * pixelG + 117 * pixelB + 0x200 >> 10;
                }
                grayscaleBuffer[j] = gray;
            }
            return grayscaleBuffer;
        }
        getRow(y /*int*/ , row) {
            if (y < 0 || y >= this.getHeight()) throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            const width = this.getWidth();
            const start = y * width;
            if (row === null) row = this.buffer.slice(start, start + width);
            else {
                if (row.length < width) row = new Uint8ClampedArray(width);
                // The underlying raster of image consists of bytes with the luminance values
                // TODO: can avoid set/slice?
                row.set(this.buffer.slice(start, start + width));
            }
            return row;
        }
        getMatrix() {
            return this.buffer;
        }
        isCropSupported() {
            return true;
        }
        crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            super.crop(left, top, width, height);
            return this;
        }
        /**
         * This is always true, since the image is a gray-scale image.
         *
         * @return true
         */ isRotateSupported() {
            return true;
        }
        rotateCounterClockwise() {
            this.rotate(-90);
            return this;
        }
        rotateCounterClockwise45() {
            this.rotate(-45);
            return this;
        }
        getTempCanvasElement() {
            if (null === this.tempCanvasElement) {
                const tempCanvasElement = this.canvas.ownerDocument.createElement('canvas');
                tempCanvasElement.width = this.canvas.width;
                tempCanvasElement.height = this.canvas.height;
                this.tempCanvasElement = tempCanvasElement;
            }
            return this.tempCanvasElement;
        }
        rotate(angle) {
            const tempCanvasElement = this.getTempCanvasElement();
            const tempContext = tempCanvasElement.getContext('2d');
            const angleRadians = angle * HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS;
            // Calculate and set new dimensions for temp canvas
            const width = this.canvas.width;
            const height = this.canvas.height;
            const newWidth = Math.ceil(Math.abs(Math.cos(angleRadians)) * width + Math.abs(Math.sin(angleRadians)) * height);
            const newHeight = Math.ceil(Math.abs(Math.sin(angleRadians)) * width + Math.abs(Math.cos(angleRadians)) * height);
            tempCanvasElement.width = newWidth;
            tempCanvasElement.height = newHeight;
            // Draw at center of temp canvas to prevent clipping of image data
            tempContext.translate(newWidth / 2, newHeight / 2);
            tempContext.rotate(angleRadians);
            tempContext.drawImage(this.canvas, width / -2, height / -2);
            this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(tempCanvasElement);
            return this;
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }
    HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS = Math.PI / 180;
    /**
     * @deprecated Moving to @zxing/browser
     *
     * Video input device metadata containing the id and label of the device if available.
     */ class VideoInputDevice {
        /**
         * Creates an instance of VideoInputDevice.
         *
         * @param {string} deviceId the video input device id
         * @param {string} label the label of the device if available
         */ constructor(deviceId, label, groupId){
            this.deviceId = deviceId;
            this.label = label;
            /** @inheritdoc */ this.kind = 'videoinput';
            this.groupId = groupId || undefined;
        }
        /** @inheritdoc */ toJSON() {
            return {
                kind: this.kind,
                groupId: this.groupId,
                deviceId: this.deviceId,
                label: this.label
            };
        }
    }
    var __awaiter = (globalThis || $parcel$global || self || window || undefined) && (globalThis || $parcel$global || self || window || undefined).__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    /**
     * @deprecated Moving to @zxing/browser
     *
     * Base class for browser code reader.
     */ class BrowserCodeReader {
        /**
         * Creates an instance of BrowserCodeReader.
         * @param {Reader} reader The reader instance to decode the barcode
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent successful decode tries
         *
         * @memberOf BrowserCodeReader
         */ constructor(reader, timeBetweenScansMillis = 500, _hints){
            this.reader = reader;
            this.timeBetweenScansMillis = timeBetweenScansMillis;
            this._hints = _hints;
            /**
             * This will break the loop.
             */ this._stopContinuousDecode = false;
            /**
             * This will break the loop.
             */ this._stopAsyncDecode = false;
            /**
             * Delay time between decode attempts made by the scanner.
             */ this._timeBetweenDecodingAttempts = 0;
        }
        /**
         * If navigator is present.
         */ get hasNavigator() {
            return typeof navigator !== 'undefined';
        }
        /**
         * If mediaDevices under navigator is supported.
         */ get isMediaDevicesSuported() {
            return this.hasNavigator && !!navigator.mediaDevices;
        }
        /**
         * If enumerateDevices under navigator is supported.
         */ get canEnumerateDevices() {
            return !!(this.isMediaDevicesSuported && navigator.mediaDevices.enumerateDevices);
        }
        /** Time between two decoding tries in milli seconds. */ get timeBetweenDecodingAttempts() {
            return this._timeBetweenDecodingAttempts;
        }
        /**
         * Change the time span the decoder waits between two decoding tries.
         *
         * @param {number} millis Time between two decoding tries in milli seconds.
         */ set timeBetweenDecodingAttempts(millis) {
            this._timeBetweenDecodingAttempts = millis < 0 ? 0 : millis;
        }
        /**
         * Sets the hints.
         */ set hints(hints) {
            this._hints = hints || null;
        }
        /**
         * Sets the hints.
         */ get hints() {
            return this._hints;
        }
        /**
         * Lists all the available video input devices.
         */ listVideoInputDevices() {
            return __awaiter(this, void 0, void 0, function*() {
                if (!this.hasNavigator) throw new Error('Can\'t enumerate devices, navigator is not present.');
                if (!this.canEnumerateDevices) throw new Error('Can\'t enumerate devices, method not supported.');
                const devices = yield navigator.mediaDevices.enumerateDevices();
                const videoDevices = [];
                for (const device of devices){
                    const kind = device.kind === 'video' ? 'videoinput' : device.kind;
                    if (kind !== 'videoinput') continue;
                    const deviceId = device.deviceId || device.id;
                    const label = device.label || `Video device ${videoDevices.length + 1}`;
                    const groupId = device.groupId;
                    const videoDevice = {
                        deviceId: deviceId,
                        label: label,
                        kind: kind,
                        groupId: groupId
                    };
                    videoDevices.push(videoDevice);
                }
                return videoDevices;
            });
        }
        /**
         * Obtain the list of available devices with type 'videoinput'.
         *
         * @returns {Promise<VideoInputDevice[]>} an array of available video input devices
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `listVideoInputDevices` instead.
         */ getVideoInputDevices() {
            return __awaiter(this, void 0, void 0, function*() {
                const devices = yield this.listVideoInputDevices();
                return devices.map((d)=>new VideoInputDevice(d.deviceId, d.label));
            });
        }
        /**
         * Let's you find a device using it's Id.
         */ findDeviceById(deviceId) {
            return __awaiter(this, void 0, void 0, function*() {
                const devices = yield this.listVideoInputDevices();
                if (!devices) return null;
                return devices.find((x)=>x.deviceId === deviceId);
            });
        }
        /**
         * Decodes the barcode from the device specified by deviceId while showing the video in the specified video element.
         *
         * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `decodeOnceFromVideoDevice` instead.
         */ decodeFromInputVideoDevice(deviceId, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                return yield this.decodeOnceFromVideoDevice(deviceId, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from the device specified by deviceId while showing the video in the specified video element.
         *
         * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeOnceFromVideoDevice(deviceId, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                this.reset();
                let videoConstraints;
                if (!deviceId) videoConstraints = {
                    facingMode: 'environment'
                };
                else videoConstraints = {
                    deviceId: {
                        exact: deviceId
                    }
                };
                const constraints = {
                    video: videoConstraints
                };
                return yield this.decodeOnceFromConstraints(constraints, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param constraints the media stream constraints to get s valid media stream to decode from
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeOnceFromConstraints(constraints, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                const stream = yield navigator.mediaDevices.getUserMedia(constraints);
                return yield this.decodeOnceFromStream(stream, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeOnceFromStream(stream, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                this.reset();
                const video = yield this.attachStreamToVideo(stream, videoSource);
                const result = yield this.decodeOnce(video);
                return result;
            });
        }
        /**
         * Continuously decodes the barcode from the device specified by device while showing the video in the specified video element.
         *
         * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<void>}
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `decodeFromVideoDevice` instead.
         */ decodeFromInputVideoDeviceContinuously(deviceId, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                return yield this.decodeFromVideoDevice(deviceId, videoSource, callbackFn);
            });
        }
        /**
         * Continuously tries to decode the barcode from the device specified by device while showing the video in the specified video element.
         *
         * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<void>}
         *
         * @memberOf BrowserCodeReader
         */ decodeFromVideoDevice(deviceId, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                let videoConstraints;
                if (!deviceId) videoConstraints = {
                    facingMode: 'environment'
                };
                else videoConstraints = {
                    deviceId: {
                        exact: deviceId
                    }
                };
                const constraints = {
                    video: videoConstraints
                };
                return yield this.decodeFromConstraints(constraints, videoSource, callbackFn);
            });
        }
        /**
         * Continuously tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromConstraints(constraints, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                const stream = yield navigator.mediaDevices.getUserMedia(constraints);
                return yield this.decodeFromStream(stream, videoSource, callbackFn);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromStream(stream, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                this.reset();
                const video = yield this.attachStreamToVideo(stream, videoSource);
                return yield this.decodeContinuously(video, callbackFn);
            });
        }
        /**
         * Breaks the decoding loop.
         */ stopAsyncDecode() {
            this._stopAsyncDecode = true;
        }
        /**
         * Breaks the decoding loop.
         */ stopContinuousDecode() {
            this._stopContinuousDecode = true;
        }
        /**
         * Sets the new stream and request a new decoding-with-delay.
         *
         * @param stream The stream to be shown in the video element.
         * @param decodeFn A callback for the decode method.
         */ attachStreamToVideo(stream, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                const videoElement = this.prepareVideoElement(videoSource);
                this.addVideoSource(videoElement, stream);
                this.videoElement = videoElement;
                this.stream = stream;
                yield this.playVideoOnLoadAsync(videoElement);
                return videoElement;
            });
        }
        /**
         *
         * @param videoElement
         */ playVideoOnLoadAsync(videoElement) {
            return new Promise((resolve, reject)=>this.playVideoOnLoad(videoElement, ()=>resolve()));
        }
        /**
         * Binds listeners and callbacks to the videoElement.
         *
         * @param element
         * @param callbackFn
         */ playVideoOnLoad(element, callbackFn) {
            this.videoEndedListener = ()=>this.stopStreams();
            this.videoCanPlayListener = ()=>this.tryPlayVideo(element);
            element.addEventListener('ended', this.videoEndedListener);
            element.addEventListener('canplay', this.videoCanPlayListener);
            element.addEventListener('playing', callbackFn);
            // if canplay was already fired, we won't know when to play, so just give it a try
            this.tryPlayVideo(element);
        }
        /**
         * Checks if the given video element is currently playing.
         */ isVideoPlaying(video) {
            return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
        }
        /**
         * Just tries to play the video and logs any errors.
         * The play call is only made is the video is not already playing.
         */ tryPlayVideo(videoElement) {
            return __awaiter(this, void 0, void 0, function*() {
                if (this.isVideoPlaying(videoElement)) {
                    console.warn('Trying to play video that is already playing.');
                    return;
                }
                try {
                    yield videoElement.play();
                } catch (_a) {
                    console.warn('It was not possible to play the video.');
                }
            });
        }
        /**
         * Searches and validates a media element.
         */ getMediaElement(mediaElementId, type) {
            const mediaElement = document.getElementById(mediaElementId);
            if (!mediaElement) throw new ArgumentException(`element with id '${mediaElementId}' not found`);
            if (mediaElement.nodeName.toLowerCase() !== type.toLowerCase()) throw new ArgumentException(`element with id '${mediaElementId}' must be an ${type} element`);
            return mediaElement;
        }
        /**
         * Decodes the barcode from an image.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromImage(source, url) {
            if (!source && !url) throw new ArgumentException('either imageElement with a src set or an url must be provided');
            if (url && !source) return this.decodeFromImageUrl(url);
            return this.decodeFromImageElement(source);
        }
        /**
         * Decodes the barcode from a video.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromVideo(source, url) {
            if (!source && !url) throw new ArgumentException('Either an element with a src set or an URL must be provided');
            if (url && !source) return this.decodeFromVideoUrl(url);
            return this.decodeFromVideoElement(source);
        }
        /**
         * Decodes continuously the barcode from a video.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         *
         * @experimental
         */ decodeFromVideoContinuously(source, url, callbackFn) {
            if (undefined === source && undefined === url) throw new ArgumentException('Either an element with a src set or an URL must be provided');
            if (url && !source) return this.decodeFromVideoUrlContinuously(url, callbackFn);
            return this.decodeFromVideoElementContinuously(source, callbackFn);
        }
        /**
         * Decodes something from an image HTML element.
         */ decodeFromImageElement(source) {
            if (!source) throw new ArgumentException('An image element must be provided.');
            this.reset();
            const element = this.prepareImageElement(source);
            this.imageElement = element;
            let task;
            if (this.isImageLoaded(element)) task = this.decodeOnce(element, false, true);
            else task = this._decodeOnLoadImage(element);
            return task;
        }
        /**
         * Decodes something from an image HTML element.
         */ decodeFromVideoElement(source) {
            const element = this._decodeFromVideoElementSetup(source);
            return this._decodeOnLoadVideo(element);
        }
        /**
         * Decodes something from an image HTML element.
         */ decodeFromVideoElementContinuously(source, callbackFn) {
            const element = this._decodeFromVideoElementSetup(source);
            return this._decodeOnLoadVideoContinuously(element, callbackFn);
        }
        /**
         * Sets up the video source so it can be decoded when loaded.
         *
         * @param source The video source element.
         */ _decodeFromVideoElementSetup(source) {
            if (!source) throw new ArgumentException('A video element must be provided.');
            this.reset();
            const element = this.prepareVideoElement(source);
            // defines the video element before starts decoding
            this.videoElement = element;
            return element;
        }
        /**
         * Decodes an image from a URL.
         */ decodeFromImageUrl(url) {
            if (!url) throw new ArgumentException('An URL must be provided.');
            this.reset();
            const element = this.prepareImageElement();
            this.imageElement = element;
            const decodeTask = this._decodeOnLoadImage(element);
            element.src = url;
            return decodeTask;
        }
        /**
         * Decodes an image from a URL.
         */ decodeFromVideoUrl(url) {
            if (!url) throw new ArgumentException('An URL must be provided.');
            this.reset();
            // creates a new element
            const element = this.prepareVideoElement();
            const decodeTask = this.decodeFromVideoElement(element);
            element.src = url;
            return decodeTask;
        }
        /**
         * Decodes an image from a URL.
         *
         * @experimental
         */ decodeFromVideoUrlContinuously(url, callbackFn) {
            if (!url) throw new ArgumentException('An URL must be provided.');
            this.reset();
            // creates a new element
            const element = this.prepareVideoElement();
            const decodeTask = this.decodeFromVideoElementContinuously(element, callbackFn);
            element.src = url;
            return decodeTask;
        }
        _decodeOnLoadImage(element) {
            return new Promise((resolve, reject)=>{
                this.imageLoadedListener = ()=>this.decodeOnce(element, false, true).then(resolve, reject);
                element.addEventListener('load', this.imageLoadedListener);
            });
        }
        _decodeOnLoadVideo(videoElement) {
            return __awaiter(this, void 0, void 0, function*() {
                // plays the video
                yield this.playVideoOnLoadAsync(videoElement);
                // starts decoding after played the video
                return yield this.decodeOnce(videoElement);
            });
        }
        _decodeOnLoadVideoContinuously(videoElement, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                // plays the video
                yield this.playVideoOnLoadAsync(videoElement);
                // starts decoding after played the video
                this.decodeContinuously(videoElement, callbackFn);
            });
        }
        isImageLoaded(img) {
            // During the onload event, IE correctly identifies any images that
            // weren’t downloaded as not complete. Others should too. Gecko-based
            // browsers act like NS4 in that they report this incorrectly.
            if (!img.complete) return false;
            // However, they do have two very useful properties: naturalWidth and
            // naturalHeight. These give the true size of the image. If it failed
            // to load, either of these should be zero.
            if (img.naturalWidth === 0) return false;
            // No other way of checking: assume it’s ok.
            return true;
        }
        prepareImageElement(imageSource) {
            let imageElement;
            if (typeof imageSource === 'undefined') {
                imageElement = document.createElement('img');
                imageElement.width = 200;
                imageElement.height = 200;
            }
            if (typeof imageSource === 'string') imageElement = this.getMediaElement(imageSource, 'img');
            if (imageSource instanceof HTMLImageElement) imageElement = imageSource;
            return imageElement;
        }
        /**
         * Sets a HTMLVideoElement for scanning or creates a new one.
         *
         * @param videoSource The HTMLVideoElement to be set.
         */ prepareVideoElement(videoSource) {
            let videoElement;
            if (!videoSource && typeof document !== 'undefined') {
                videoElement = document.createElement('video');
                videoElement.width = 200;
                videoElement.height = 200;
            }
            if (typeof videoSource === 'string') videoElement = this.getMediaElement(videoSource, 'video');
            if (videoSource instanceof HTMLVideoElement) videoElement = videoSource;
            // Needed for iOS 11
            videoElement.setAttribute('autoplay', 'true');
            videoElement.setAttribute('muted', 'true');
            videoElement.setAttribute('playsinline', 'true');
            return videoElement;
        }
        /**
         * Tries to decode from the video input until it finds some value.
         */ decodeOnce(element, retryIfNotFound = true, retryIfChecksumOrFormatError = true) {
            this._stopAsyncDecode = false;
            const loop = (resolve, reject)=>{
                if (this._stopAsyncDecode) {
                    reject(new NotFoundException('Video stream has ended before any code could be detected.'));
                    this._stopAsyncDecode = undefined;
                    return;
                }
                try {
                    const result = this.decode(element);
                    resolve(result);
                } catch (e) {
                    const ifNotFound = retryIfNotFound && e instanceof NotFoundException;
                    const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
                    const ifChecksumOrFormat = isChecksumOrFormatError && retryIfChecksumOrFormatError;
                    if (ifNotFound || ifChecksumOrFormat) // trying again
                    return setTimeout(loop, this._timeBetweenDecodingAttempts, resolve, reject);
                    reject(e);
                }
            };
            return new Promise((resolve, reject)=>loop(resolve, reject));
        }
        /**
         * Continuously decodes from video input.
         */ decodeContinuously(element, callbackFn) {
            this._stopContinuousDecode = false;
            const loop = ()=>{
                if (this._stopContinuousDecode) {
                    this._stopContinuousDecode = undefined;
                    return;
                }
                try {
                    const result = this.decode(element);
                    callbackFn(result, null);
                    setTimeout(loop, this.timeBetweenScansMillis);
                } catch (e) {
                    callbackFn(null, e);
                    const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
                    const isNotFound = e instanceof NotFoundException;
                    if (isChecksumOrFormatError || isNotFound) // trying again
                    setTimeout(loop, this._timeBetweenDecodingAttempts);
                }
            };
            loop();
        }
        /**
         * Gets the BinaryBitmap for ya! (and decodes it)
         */ decode(element) {
            // get binary bitmap for decode function
            const binaryBitmap = this.createBinaryBitmap(element);
            return this.decodeBitmap(binaryBitmap);
        }
        /**
         * Returns true if media element is indeed a {@link HtmlVideoElement}.
         */ _isHTMLVideoElement(mediaElement) {
            const potentialVideo = mediaElement;
            return potentialVideo.videoWidth !== 0;
        }
        /**
         * Overwriting this allows you to manipulate the next frame in anyway
         * you want before decode.
         */ drawFrameOnCanvas(srcElement, dimensions, canvasElementContext) {
            if (!dimensions) dimensions = {
                sx: 0,
                sy: 0,
                sWidth: srcElement.videoWidth,
                sHeight: srcElement.videoHeight,
                dx: 0,
                dy: 0,
                dWidth: srcElement.videoWidth,
                dHeight: srcElement.videoHeight
            };
            if (!canvasElementContext) canvasElementContext = this.captureCanvasContext;
            canvasElementContext.drawImage(srcElement, dimensions.sx, dimensions.sy, dimensions.sWidth, dimensions.sHeight, dimensions.dx, dimensions.dy, dimensions.dWidth, dimensions.dHeight);
        }
        /**
         * Ovewriting this allows you to manipulate the snapshot image in anyway
         *  you want before decode.
         */ drawImageOnCanvas(srcElement, dimensions, canvasElementContext = this.captureCanvasContext) {
            if (!dimensions) dimensions = {
                sx: 0,
                sy: 0,
                sWidth: srcElement.naturalWidth,
                sHeight: srcElement.naturalHeight,
                dx: 0,
                dy: 0,
                dWidth: srcElement.naturalWidth,
                dHeight: srcElement.naturalHeight
            };
            if (!canvasElementContext) canvasElementContext = this.captureCanvasContext;
            canvasElementContext.drawImage(srcElement, dimensions.sx, dimensions.sy, dimensions.sWidth, dimensions.sHeight, dimensions.dx, dimensions.dy, dimensions.dWidth, dimensions.dHeight);
        }
        /**
         * Creates a binaryBitmap based in some image source.
         *
         * @param mediaElement HTML element containing drawable image source.
         */ createBinaryBitmap(mediaElement) {
            const ctx = this.getCaptureCanvasContext(mediaElement);
            if (this._isHTMLVideoElement(mediaElement)) this.drawFrameOnCanvas(mediaElement);
            else this.drawImageOnCanvas(mediaElement);
            const canvas = this.getCaptureCanvas(mediaElement);
            const luminanceSource = new HTMLCanvasElementLuminanceSource(canvas);
            const hybridBinarizer = new HybridBinarizer(luminanceSource);
            return new BinaryBitmap(hybridBinarizer);
        }
        getCaptureCanvasContext(mediaElement) {
            if (!this.captureCanvasContext) {
                const elem = this.getCaptureCanvas(mediaElement);
                const ctx = elem.getContext('2d');
                this.captureCanvasContext = ctx;
            }
            return this.captureCanvasContext;
        }
        getCaptureCanvas(mediaElement) {
            if (!this.captureCanvas) {
                const elem = this.createCaptureCanvas(mediaElement);
                this.captureCanvas = elem;
            }
            return this.captureCanvas;
        }
        /**
         * Call the encapsulated readers decode
         */ decodeBitmap(binaryBitmap) {
            return this.reader.decode(binaryBitmap, this._hints);
        }
        /**
         * 🖌 Prepares the canvas for capture and scan frames.
         */ createCaptureCanvas(mediaElement) {
            if (typeof document === 'undefined') {
                this._destroyCaptureCanvas();
                return null;
            }
            const canvasElement = document.createElement('canvas');
            let width;
            let height;
            if (typeof mediaElement !== 'undefined') {
                if (mediaElement instanceof HTMLVideoElement) {
                    width = mediaElement.videoWidth;
                    height = mediaElement.videoHeight;
                } else if (mediaElement instanceof HTMLImageElement) {
                    width = mediaElement.naturalWidth || mediaElement.width;
                    height = mediaElement.naturalHeight || mediaElement.height;
                }
            }
            canvasElement.style.width = width + 'px';
            canvasElement.style.height = height + 'px';
            canvasElement.width = width;
            canvasElement.height = height;
            return canvasElement;
        }
        /**
         * Stops the continuous scan and cleans the stream.
         */ stopStreams() {
            if (this.stream) {
                this.stream.getVideoTracks().forEach((t)=>t.stop());
                this.stream = undefined;
            }
            if (this._stopAsyncDecode === false) this.stopAsyncDecode();
            if (this._stopContinuousDecode === false) this.stopContinuousDecode();
        }
        /**
         * Resets the code reader to the initial state. Cancels any ongoing barcode scanning from video or camera.
         *
         * @memberOf BrowserCodeReader
         */ reset() {
            // stops the camera, preview and scan 🔴
            this.stopStreams();
            // clean and forget about HTML elements
            this._destroyVideoElement();
            this._destroyImageElement();
            this._destroyCaptureCanvas();
        }
        _destroyVideoElement() {
            if (!this.videoElement) return;
            // first gives freedon to the element 🕊
            if (typeof this.videoEndedListener !== 'undefined') this.videoElement.removeEventListener('ended', this.videoEndedListener);
            if (typeof this.videoPlayingEventListener !== 'undefined') this.videoElement.removeEventListener('playing', this.videoPlayingEventListener);
            if (typeof this.videoCanPlayListener !== 'undefined') this.videoElement.removeEventListener('loadedmetadata', this.videoCanPlayListener);
            // then forgets about that element 😢
            this.cleanVideoSource(this.videoElement);
            this.videoElement = undefined;
        }
        _destroyImageElement() {
            if (!this.imageElement) return;
            // first gives freedon to the element 🕊
            if (undefined !== this.imageLoadedListener) this.imageElement.removeEventListener('load', this.imageLoadedListener);
            // then forget about that element 😢
            this.imageElement.src = undefined;
            this.imageElement.removeAttribute('src');
            this.imageElement = undefined;
        }
        /**
         * Cleans canvas references 🖌
         */ _destroyCaptureCanvas() {
            // then forget about that element 😢
            this.captureCanvasContext = undefined;
            this.captureCanvas = undefined;
        }
        /**
         * Defines what the videoElement src will be.
         *
         * @param videoElement
         * @param stream
         */ addVideoSource(videoElement, stream) {
            // Older browsers may not have `srcObject`
            try {
                // @note Throws Exception if interrupted by a new loaded request
                videoElement.srcObject = stream;
            } catch (err) {
                // @note Avoid using this in new browsers, as it is going away.
                videoElement.src = URL.createObjectURL(stream);
            }
        }
        /**
         * Unbinds a HTML video src property.
         *
         * @param videoElement
         */ cleanVideoSource(videoElement) {
            try {
                videoElement.srcObject = null;
            } catch (err) {
                videoElement.src = '';
            }
            this.videoElement.removeAttribute('src');
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates the result of decoding a barcode within an image.</p>
     *
     * @author Sean Owen
     */ class Result {
        // public constructor(private text: string,
        //               Uint8Array rawBytes,
        //               ResultPoconst resultPoints: Int32Array,
        //               BarcodeFormat format) {
        //   this(text, rawBytes, resultPoints, format, System.currentTimeMillis())
        // }
        // public constructor(text: string,
        //               Uint8Array rawBytes,
        //               ResultPoconst resultPoints: Int32Array,
        //               BarcodeFormat format,
        //               long timestamp) {
        //   this(text, rawBytes, rawBytes == null ? 0 : 8 * rawBytes.length,
        //        resultPoints, format, timestamp)
        // }
        constructor(text, rawBytes, numBits = rawBytes == null ? 0 : 8 * rawBytes.length, resultPoints, format, timestamp = System.currentTimeMillis()){
            this.text = text;
            this.rawBytes = rawBytes;
            this.numBits = numBits;
            this.resultPoints = resultPoints;
            this.format = format;
            this.timestamp = timestamp;
            this.text = text;
            this.rawBytes = rawBytes;
            if (undefined === numBits || null === numBits) this.numBits = rawBytes === null || rawBytes === undefined ? 0 : 8 * rawBytes.length;
            else this.numBits = numBits;
            this.resultPoints = resultPoints;
            this.format = format;
            this.resultMetadata = null;
            if (undefined === timestamp || null === timestamp) this.timestamp = System.currentTimeMillis();
            else this.timestamp = timestamp;
        }
        /**
         * @return raw text encoded by the barcode
         */ getText() {
            return this.text;
        }
        /**
         * @return raw bytes encoded by the barcode, if applicable, otherwise {@code null}
         */ getRawBytes() {
            return this.rawBytes;
        }
        /**
         * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
         * @since 3.3.0
         */ getNumBits() {
            return this.numBits;
        }
        /**
         * @return points related to the barcode in the image. These are typically points
         *         identifying finder patterns or the corners of the barcode. The exact meaning is
         *         specific to the type of barcode that was decoded.
         */ getResultPoints() {
            return this.resultPoints;
        }
        /**
         * @return {@link BarcodeFormat} representing the format of the barcode that was decoded
         */ getBarcodeFormat() {
            return this.format;
        }
        /**
         * @return {@link Map} mapping {@link ResultMetadataType} keys to values. May be
         *   {@code null}. This contains optional metadata about what was detected about the barcode,
         *   like orientation.
         */ getResultMetadata() {
            return this.resultMetadata;
        }
        putMetadata(type, value) {
            if (this.resultMetadata === null) this.resultMetadata = new Map();
            this.resultMetadata.set(type, value);
        }
        putAllMetadata(metadata) {
            if (metadata !== null) {
                if (this.resultMetadata === null) this.resultMetadata = metadata;
                else this.resultMetadata = new Map(metadata);
            }
        }
        addResultPoints(newPoints) {
            const oldPoints = this.resultPoints;
            if (oldPoints === null) this.resultPoints = newPoints;
            else if (newPoints !== null && newPoints.length > 0) {
                const allPoints = new Array(oldPoints.length + newPoints.length);
                System.arraycopy(oldPoints, 0, allPoints, 0, oldPoints.length);
                System.arraycopy(newPoints, 0, allPoints, oldPoints.length, newPoints.length);
                this.resultPoints = allPoints;
            }
        }
        getTimestamp() {
            return this.timestamp;
        }
        /*@Override*/ toString() {
            return this.text;
        }
    }
    /*
     * Direct port to TypeScript of ZXing by Adrian Toșcă
     */ /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * Enumerates barcode formats known to this package. Please keep alphabetized.
     *
     * @author Sean Owen
     */ var BarcodeFormat;
    (function(BarcodeFormat) {
        /** Aztec 2D barcode format. */ BarcodeFormat[BarcodeFormat["AZTEC"] = 0] = "AZTEC";
        /** CODABAR 1D format. */ BarcodeFormat[BarcodeFormat["CODABAR"] = 1] = "CODABAR";
        /** Code 39 1D format. */ BarcodeFormat[BarcodeFormat["CODE_39"] = 2] = "CODE_39";
        /** Code 93 1D format. */ BarcodeFormat[BarcodeFormat["CODE_93"] = 3] = "CODE_93";
        /** Code 128 1D format. */ BarcodeFormat[BarcodeFormat["CODE_128"] = 4] = "CODE_128";
        /** Data Matrix 2D barcode format. */ BarcodeFormat[BarcodeFormat["DATA_MATRIX"] = 5] = "DATA_MATRIX";
        /** EAN-8 1D format. */ BarcodeFormat[BarcodeFormat["EAN_8"] = 6] = "EAN_8";
        /** EAN-13 1D format. */ BarcodeFormat[BarcodeFormat["EAN_13"] = 7] = "EAN_13";
        /** ITF (Interleaved Two of Five) 1D format. */ BarcodeFormat[BarcodeFormat["ITF"] = 8] = "ITF";
        /** MaxiCode 2D barcode format. */ BarcodeFormat[BarcodeFormat["MAXICODE"] = 9] = "MAXICODE";
        /** PDF417 format. */ BarcodeFormat[BarcodeFormat["PDF_417"] = 10] = "PDF_417";
        /** QR Code 2D barcode format. */ BarcodeFormat[BarcodeFormat["QR_CODE"] = 11] = "QR_CODE";
        /** RSS 14 */ BarcodeFormat[BarcodeFormat["RSS_14"] = 12] = "RSS_14";
        /** RSS EXPANDED */ BarcodeFormat[BarcodeFormat["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
        /** UPC-A 1D format. */ BarcodeFormat[BarcodeFormat["UPC_A"] = 14] = "UPC_A";
        /** UPC-E 1D format. */ BarcodeFormat[BarcodeFormat["UPC_E"] = 15] = "UPC_E";
        /** UPC/EAN extension format. Not a stand-alone format. */ BarcodeFormat[BarcodeFormat["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
    })(BarcodeFormat || (BarcodeFormat = {}));
    var BarcodeFormat$1 = BarcodeFormat;
    /*namespace com.google.zxing {*/ /**
     * Represents some type of metadata about the result of the decoding that the decoder
     * wishes to communicate back to the caller.
     *
     * @author Sean Owen
     */ var ResultMetadataType;
    (function(ResultMetadataType) {
        /**
         * Unspecified, application-specific metadata. Maps to an unspecified {@link Object}.
         */ ResultMetadataType[ResultMetadataType["OTHER"] = 0] = "OTHER";
        /**
         * Denotes the likely approximate orientation of the barcode in the image. This value
         * is given as degrees rotated clockwise from the normal, upright orientation.
         * For example a 1D barcode which was found by reading top-to-bottom would be
         * said to have orientation "90". This key maps to an {@link Integer} whose
         * value is in the range [0,360).
         */ ResultMetadataType[ResultMetadataType["ORIENTATION"] = 1] = "ORIENTATION";
        /**
         * <p>2D barcode formats typically encode text, but allow for a sort of 'byte mode'
         * which is sometimes used to encode binary data. While {@link Result} makes available
         * the complete raw bytes in the barcode for these formats, it does not offer the bytes
         * from the byte segments alone.</p>
         *
         * <p>This maps to a {@link java.util.List} of byte arrays corresponding to the
         * raw bytes in the byte segments in the barcode, in order.</p>
         */ ResultMetadataType[ResultMetadataType["BYTE_SEGMENTS"] = 2] = "BYTE_SEGMENTS";
        /**
         * Error correction level used, if applicable. The value type depends on the
         * format, but is typically a String.
         */ ResultMetadataType[ResultMetadataType["ERROR_CORRECTION_LEVEL"] = 3] = "ERROR_CORRECTION_LEVEL";
        /**
         * For some periodicals, indicates the issue number as an {@link Integer}.
         */ ResultMetadataType[ResultMetadataType["ISSUE_NUMBER"] = 4] = "ISSUE_NUMBER";
        /**
         * For some products, indicates the suggested retail price in the barcode as a
         * formatted {@link String}.
         */ ResultMetadataType[ResultMetadataType["SUGGESTED_PRICE"] = 5] = "SUGGESTED_PRICE";
        /**
         * For some products, the possible country of manufacture as a {@link String} denoting the
         * ISO country code. Some map to multiple possible countries, like "US/CA".
         */ ResultMetadataType[ResultMetadataType["POSSIBLE_COUNTRY"] = 6] = "POSSIBLE_COUNTRY";
        /**
         * For some products, the extension text
         */ ResultMetadataType[ResultMetadataType["UPC_EAN_EXTENSION"] = 7] = "UPC_EAN_EXTENSION";
        /**
         * PDF417-specific metadata
         */ ResultMetadataType[ResultMetadataType["PDF417_EXTRA_METADATA"] = 8] = "PDF417_EXTRA_METADATA";
        /**
         * If the code format supports structured append and the current scanned code is part of one then the
         * sequence number is given with it.
         */ ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_SEQUENCE"] = 9] = "STRUCTURED_APPEND_SEQUENCE";
        /**
         * If the code format supports structured append and the current scanned code is part of one then the
         * parity is given with it.
         */ ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_PARITY"] = 10] = "STRUCTURED_APPEND_PARITY";
    })(ResultMetadataType || (ResultMetadataType = {}));
    var ResultMetadataType$1 = ResultMetadataType;
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing.common {*/ /*import java.util.List;*/ /**
     * <p>Encapsulates the result of decoding a matrix of bits. This typically
     * applies to 2D barcode formats. For now it contains the raw bytes obtained,
     * as well as a String interpretation of those bytes, if applicable.</p>
     *
     * @author Sean Owen
     */ class DecoderResult {
        // public constructor(rawBytes: Uint8Array,
        //                      text: string,
        //                      List<Uint8Array> byteSegments,
        //                      String ecLevel) {
        //   this(rawBytes, text, byteSegments, ecLevel, -1, -1)
        // }
        constructor(rawBytes, text, byteSegments, ecLevel, structuredAppendSequenceNumber = -1, structuredAppendParity = -1){
            this.rawBytes = rawBytes;
            this.text = text;
            this.byteSegments = byteSegments;
            this.ecLevel = ecLevel;
            this.structuredAppendSequenceNumber = structuredAppendSequenceNumber;
            this.structuredAppendParity = structuredAppendParity;
            this.numBits = rawBytes === undefined || rawBytes === null ? 0 : 8 * rawBytes.length;
        }
        /**
         * @return raw bytes representing the result, or {@code null} if not applicable
         */ getRawBytes() {
            return this.rawBytes;
        }
        /**
         * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
         * @since 3.3.0
         */ getNumBits() {
            return this.numBits;
        }
        /**
         * @param numBits overrides the number of bits that are valid in {@link #getRawBytes()}
         * @since 3.3.0
         */ setNumBits(numBits /*int*/ ) {
            this.numBits = numBits;
        }
        /**
         * @return text representation of the result
         */ getText() {
            return this.text;
        }
        /**
         * @return list of byte segments in the result, or {@code null} if not applicable
         */ getByteSegments() {
            return this.byteSegments;
        }
        /**
         * @return name of error correction level used, or {@code null} if not applicable
         */ getECLevel() {
            return this.ecLevel;
        }
        /**
         * @return number of errors corrected, or {@code null} if not applicable
         */ getErrorsCorrected() {
            return this.errorsCorrected;
        }
        setErrorsCorrected(errorsCorrected /*Integer*/ ) {
            this.errorsCorrected = errorsCorrected;
        }
        /**
         * @return number of erasures corrected, or {@code null} if not applicable
         */ getErasures() {
            return this.erasures;
        }
        setErasures(erasures /*Integer*/ ) {
            this.erasures = erasures;
        }
        /**
         * @return arbitrary additional metadata
         */ getOther() {
            return this.other;
        }
        setOther(other) {
            this.other = other;
        }
        hasStructuredAppend() {
            return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
        }
        getStructuredAppendParity() {
            return this.structuredAppendParity;
        }
        getStructuredAppendSequenceNumber() {
            return this.structuredAppendSequenceNumber;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>This class contains utility methods for performing mathematical operations over
     * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
     *
     * <p>Throughout this package, elements of the GF are represented as an {@code int}
     * for convenience and speed (but at the cost of memory).
     * </p>
     *
     * @author Sean Owen
     * @author David Olivier
     */ class AbstractGenericGF {
        /**
         * @return 2 to the power of a in GF(size)
         */ exp(a) {
            return this.expTable[a];
        }
        /**
         * @return base 2 log of a in GF(size)
         */ log(a /*int*/ ) {
            if (a === 0) throw new IllegalArgumentException();
            return this.logTable[a];
        }
        /**
         * Implements both addition and subtraction -- they are the same in GF(size).
         *
         * @return sum/difference of a and b
         */ static addOrSubtract(a /*int*/ , b /*int*/ ) {
            return a ^ b;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Represents a polynomial whose coefficients are elements of a GF.
     * Instances of this class are immutable.</p>
     *
     * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
     * port of his C++ Reed-Solomon implementation.</p>
     *
     * @author Sean Owen
     */ class GenericGFPoly {
        /**
         * @param field the {@link GenericGF} instance representing the field to use
         * to perform computations
         * @param coefficients coefficients as ints representing elements of GF(size), arranged
         * from most significant (highest-power term) coefficient to least significant
         * @throws IllegalArgumentException if argument is null or empty,
         * or if leading coefficient is 0 and this is not a
         * constant polynomial (that is, it is not the monomial "0")
         */ constructor(field, coefficients){
            if (coefficients.length === 0) throw new IllegalArgumentException();
            this.field = field;
            const coefficientsLength = coefficients.length;
            if (coefficientsLength > 1 && coefficients[0] === 0) {
                // Leading term must be non-zero for anything except the constant polynomial "0"
                let firstNonZero = 1;
                while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
                if (firstNonZero === coefficientsLength) this.coefficients = Int32Array.from([
                    0
                ]);
                else {
                    this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                    System.arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
                }
            } else this.coefficients = coefficients;
        }
        getCoefficients() {
            return this.coefficients;
        }
        /**
         * @return degree of this polynomial
         */ getDegree() {
            return this.coefficients.length - 1;
        }
        /**
         * @return true iff this polynomial is the monomial "0"
         */ isZero() {
            return this.coefficients[0] === 0;
        }
        /**
         * @return coefficient of x^degree term in this polynomial
         */ getCoefficient(degree /*int*/ ) {
            return this.coefficients[this.coefficients.length - 1 - degree];
        }
        /**
         * @return evaluation of this polynomial at a given point
         */ evaluateAt(a /*int*/ ) {
            if (a === 0) // Just return the x^0 coefficient
            return this.getCoefficient(0);
            const coefficients = this.coefficients;
            let result;
            if (a === 1) {
                // Just the sum of the coefficients
                result = 0;
                for(let i = 0, length = coefficients.length; i !== length; i++){
                    const coefficient = coefficients[i];
                    result = AbstractGenericGF.addOrSubtract(result, coefficient);
                }
                return result;
            }
            result = coefficients[0];
            const size = coefficients.length;
            const field = this.field;
            for(let i = 1; i < size; i++)result = AbstractGenericGF.addOrSubtract(field.multiply(a, result), coefficients[i]);
            return result;
        }
        addOrSubtract(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            if (this.isZero()) return other;
            if (other.isZero()) return this;
            let smallerCoefficients = this.coefficients;
            let largerCoefficients = other.coefficients;
            if (smallerCoefficients.length > largerCoefficients.length) {
                const temp = smallerCoefficients;
                smallerCoefficients = largerCoefficients;
                largerCoefficients = temp;
            }
            let sumDiff = new Int32Array(largerCoefficients.length);
            const lengthDiff = largerCoefficients.length - smallerCoefficients.length;
            // Copy high-order terms only found in higher-degree polynomial's coefficients
            System.arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
            for(let i = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = AbstractGenericGF.addOrSubtract(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
            return new GenericGFPoly(this.field, sumDiff);
        }
        multiply(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            if (this.isZero() || other.isZero()) return this.field.getZero();
            const aCoefficients = this.coefficients;
            const aLength = aCoefficients.length;
            const bCoefficients = other.coefficients;
            const bLength = bCoefficients.length;
            const product = new Int32Array(aLength + bLength - 1);
            const field = this.field;
            for(let i = 0; i < aLength; i++){
                const aCoeff = aCoefficients[i];
                for(let j = 0; j < bLength; j++)product[i + j] = AbstractGenericGF.addOrSubtract(product[i + j], field.multiply(aCoeff, bCoefficients[j]));
            }
            return new GenericGFPoly(field, product);
        }
        multiplyScalar(scalar /*int*/ ) {
            if (scalar === 0) return this.field.getZero();
            if (scalar === 1) return this;
            const size = this.coefficients.length;
            const field = this.field;
            const product = new Int32Array(size);
            const coefficients = this.coefficients;
            for(let i = 0; i < size; i++)product[i] = field.multiply(coefficients[i], scalar);
            return new GenericGFPoly(field, product);
        }
        multiplyByMonomial(degree /*int*/ , coefficient /*int*/ ) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return this.field.getZero();
            const coefficients = this.coefficients;
            const size = coefficients.length;
            const product = new Int32Array(size + degree);
            const field = this.field;
            for(let i = 0; i < size; i++)product[i] = field.multiply(coefficients[i], coefficient);
            return new GenericGFPoly(field, product);
        }
        divide(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            if (other.isZero()) throw new IllegalArgumentException('Divide by 0');
            const field = this.field;
            let quotient = field.getZero();
            let remainder = this;
            const denominatorLeadingTerm = other.getCoefficient(other.getDegree());
            const inverseDenominatorLeadingTerm = field.inverse(denominatorLeadingTerm);
            while(remainder.getDegree() >= other.getDegree() && !remainder.isZero()){
                const degreeDifference = remainder.getDegree() - other.getDegree();
                const scale = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
                const term = other.multiplyByMonomial(degreeDifference, scale);
                const iterationQuotient = field.buildMonomial(degreeDifference, scale);
                quotient = quotient.addOrSubtract(iterationQuotient);
                remainder = remainder.addOrSubtract(term);
            }
            return [
                quotient,
                remainder
            ];
        }
        /*@Override*/ toString() {
            let result = '';
            for(let degree = this.getDegree(); degree >= 0; degree--){
                let coefficient = this.getCoefficient(degree);
                if (coefficient !== 0) {
                    if (coefficient < 0) {
                        result += ' - ';
                        coefficient = -coefficient;
                    } else if (result.length > 0) result += ' + ';
                    if (degree === 0 || coefficient !== 1) {
                        const alphaPower = this.field.log(coefficient);
                        if (alphaPower === 0) result += '1';
                        else if (alphaPower === 1) result += 'a';
                        else {
                            result += 'a^';
                            result += alphaPower;
                        }
                    }
                    if (degree !== 0) {
                        if (degree === 1) result += 'x';
                        else {
                            result += 'x^';
                            result += degree;
                        }
                    }
                }
            }
            return result;
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class ArithmeticException extends Exception {
    }
    ArithmeticException.kind = 'ArithmeticException';
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>This class contains utility methods for performing mathematical operations over
     * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
     *
     * <p>Throughout this package, elements of the GF are represented as an {@code int}
     * for convenience and speed (but at the cost of memory).
     * </p>
     *
     * @author Sean Owen
     * @author David Olivier
     */ class GenericGF extends AbstractGenericGF {
        /**
         * Create a representation of GF(size) using the given primitive polynomial.
         *
         * @param primitive irreducible polynomial whose coefficients are represented by
         *  the bits of an int, where the least-significant bit represents the constant
         *  coefficient
         * @param size the size of the field
         * @param b the factor b in the generator polynomial can be 0- or 1-based
         *  (g(x) = (x+a^b)(x+a^(b+1))...(x+a^(b+2t-1))).
         *  In most cases it should be 1, but for QR code it is 0.
         */ constructor(primitive /*int*/ , size /*int*/ , generatorBase /*int*/ ){
            super();
            this.primitive = primitive;
            this.size = size;
            this.generatorBase = generatorBase;
            const expTable = new Int32Array(size);
            let x = 1;
            for(let i = 0; i < size; i++){
                expTable[i] = x;
                x *= 2; // we're assuming the generator alpha is 2
                if (x >= size) {
                    x ^= primitive;
                    x &= size - 1;
                }
            }
            this.expTable = expTable;
            const logTable = new Int32Array(size);
            for(let i = 0; i < size - 1; i++)logTable[expTable[i]] = i;
            this.logTable = logTable;
            // logTable[0] == 0 but this should never be used
            this.zero = new GenericGFPoly(this, Int32Array.from([
                0
            ]));
            this.one = new GenericGFPoly(this, Int32Array.from([
                1
            ]));
        }
        getZero() {
            return this.zero;
        }
        getOne() {
            return this.one;
        }
        /**
         * @return the monomial representing coefficient * x^degree
         */ buildMonomial(degree /*int*/ , coefficient /*int*/ ) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return this.zero;
            const coefficients = new Int32Array(degree + 1);
            coefficients[0] = coefficient;
            return new GenericGFPoly(this, coefficients);
        }
        /**
         * @return multiplicative inverse of a
         */ inverse(a /*int*/ ) {
            if (a === 0) throw new ArithmeticException();
            return this.expTable[this.size - this.logTable[a] - 1];
        }
        /**
         * @return product of a and b in GF(size)
         */ multiply(a /*int*/ , b /*int*/ ) {
            if (a === 0 || b === 0) return 0;
            return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
        }
        getSize() {
            return this.size;
        }
        getGeneratorBase() {
            return this.generatorBase;
        }
        /*@Override*/ toString() {
            return 'GF(0x' + Integer.toHexString(this.primitive) + ',' + this.size + ')';
        }
        equals(o) {
            return o === this;
        }
    }
    GenericGF.AZTEC_DATA_12 = new GenericGF(0x1069, 4096, 1); // x^12 + x^6 + x^5 + x^3 + 1
    GenericGF.AZTEC_DATA_10 = new GenericGF(0x409, 1024, 1); // x^10 + x^3 + 1
    GenericGF.AZTEC_DATA_6 = new GenericGF(0x43, 64, 1); // x^6 + x + 1
    GenericGF.AZTEC_PARAM = new GenericGF(0x13, 16, 1); // x^4 + x + 1
    GenericGF.QR_CODE_FIELD_256 = new GenericGF(0x011d, 256, 0); // x^8 + x^4 + x^3 + x^2 + 1
    GenericGF.DATA_MATRIX_FIELD_256 = new GenericGF(0x012d, 256, 1); // x^8 + x^5 + x^3 + x^2 + 1
    GenericGF.AZTEC_DATA_8 = GenericGF.DATA_MATRIX_FIELD_256;
    GenericGF.MAXICODE_FIELD_64 = GenericGF.AZTEC_DATA_6;
    /**
     * Custom Error class of type Exception.
     */ class ReedSolomonException extends Exception {
    }
    ReedSolomonException.kind = 'ReedSolomonException';
    /**
     * Custom Error class of type Exception.
     */ class IllegalStateException extends Exception {
    }
    IllegalStateException.kind = 'IllegalStateException';
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Implements Reed-Solomon decoding, as the name implies.</p>
     *
     * <p>The algorithm will not be explained here, but the following references were helpful
     * in creating this implementation:</p>
     *
     * <ul>
     * <li>Bruce Maggs.
     * <a href="http://www.cs.cmu.edu/afs/cs.cmu.edu/project/pscico-guyb/realworld/www/rs_decode.ps">
     * "Decoding Reed-Solomon Codes"</a> (see discussion of Forney's Formula)</li>
     * <li>J.I. Hall. <a href="www.mth.msu.edu/~jhall/classes/codenotes/GRS.pdf">
     * "Chapter 5. Generalized Reed-Solomon Codes"</a>
     * (see discussion of Euclidean algorithm)</li>
     * </ul>
     *
     * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
     * port of his C++ Reed-Solomon implementation.</p>
     *
     * @author Sean Owen
     * @author William Rucklidge
     * @author sanfordsquires
     */ class ReedSolomonDecoder {
        constructor(field){
            this.field = field;
        }
        /**
         * <p>Decodes given set of received codewords, which include both data and error-correction
         * codewords. Really, this means it uses Reed-Solomon to detect and correct errors, in-place,
         * in the input.</p>
         *
         * @param received data and error-correction codewords
         * @param twoS number of error-correction codewords available
         * @throws ReedSolomonException if decoding fails for any reason
         */ decode(received, twoS /*int*/ ) {
            const field = this.field;
            const poly = new GenericGFPoly(field, received);
            const syndromeCoefficients = new Int32Array(twoS);
            let noError = true;
            for(let i = 0; i < twoS; i++){
                const evalResult = poly.evaluateAt(field.exp(i + field.getGeneratorBase()));
                syndromeCoefficients[syndromeCoefficients.length - 1 - i] = evalResult;
                if (evalResult !== 0) noError = false;
            }
            if (noError) return;
            const syndrome = new GenericGFPoly(field, syndromeCoefficients);
            const sigmaOmega = this.runEuclideanAlgorithm(field.buildMonomial(twoS, 1), syndrome, twoS);
            const sigma = sigmaOmega[0];
            const omega = sigmaOmega[1];
            const errorLocations = this.findErrorLocations(sigma);
            const errorMagnitudes = this.findErrorMagnitudes(omega, errorLocations);
            for(let i = 0; i < errorLocations.length; i++){
                const position = received.length - 1 - field.log(errorLocations[i]);
                if (position < 0) throw new ReedSolomonException('Bad error location');
                received[position] = GenericGF.addOrSubtract(received[position], errorMagnitudes[i]);
            }
        }
        runEuclideanAlgorithm(a, b, R /*int*/ ) {
            // Assume a's degree is >= b's
            if (a.getDegree() < b.getDegree()) {
                const temp = a;
                a = b;
                b = temp;
            }
            const field = this.field;
            let rLast = a;
            let r = b;
            let tLast = field.getZero();
            let t = field.getOne();
            // Run Euclidean algorithm until r's degree is less than R/2
            while(r.getDegree() >= (R / 2 | 0)){
                let rLastLast = rLast;
                let tLastLast = tLast;
                rLast = r;
                tLast = t;
                // Divide rLastLast by rLast, with quotient in q and remainder in r
                if (rLast.isZero()) // Oops, Euclidean algorithm already terminated?
                throw new ReedSolomonException('r_{i-1} was zero');
                r = rLastLast;
                let q = field.getZero();
                const denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
                const dltInverse = field.inverse(denominatorLeadingTerm);
                while(r.getDegree() >= rLast.getDegree() && !r.isZero()){
                    const degreeDiff = r.getDegree() - rLast.getDegree();
                    const scale = field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                    q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
                    r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
                }
                t = q.multiply(tLast).addOrSubtract(tLastLast);
                if (r.getDegree() >= rLast.getDegree()) throw new IllegalStateException('Division algorithm failed to reduce polynomial?');
            }
            const sigmaTildeAtZero = t.getCoefficient(0);
            if (sigmaTildeAtZero === 0) throw new ReedSolomonException('sigmaTilde(0) was zero');
            const inverse = field.inverse(sigmaTildeAtZero);
            const sigma = t.multiplyScalar(inverse);
            const omega = r.multiplyScalar(inverse);
            return [
                sigma,
                omega
            ];
        }
        findErrorLocations(errorLocator) {
            // This is a direct application of Chien's search
            const numErrors = errorLocator.getDegree();
            if (numErrors === 1) return Int32Array.from([
                errorLocator.getCoefficient(1)
            ]);
            const result = new Int32Array(numErrors);
            let e = 0;
            const field = this.field;
            for(let i = 1; i < field.getSize() && e < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
                result[e] = field.inverse(i);
                e++;
            }
            if (e !== numErrors) throw new ReedSolomonException('Error locator degree does not match number of roots');
            return result;
        }
        findErrorMagnitudes(errorEvaluator, errorLocations) {
            // This is directly applying Forney's Formula
            const s = errorLocations.length;
            const result = new Int32Array(s);
            const field = this.field;
            for(let i = 0; i < s; i++){
                const xiInverse = field.inverse(errorLocations[i]);
                let denominator = 1;
                for(let j = 0; j < s; j++)if (i !== j) {
                    // denominator = field.multiply(denominator,
                    //    GenericGF.addOrSubtract(1, field.multiply(errorLocations[j], xiInverse)))
                    // Above should work but fails on some Apple and Linux JDKs due to a Hotspot bug.
                    // Below is a funny-looking workaround from Steven Parkes
                    const term = field.multiply(errorLocations[j], xiInverse);
                    const termPlus1 = (term & 0x1) === 0 ? term | 1 : term & -2;
                    denominator = field.multiply(denominator, termPlus1);
                }
                result[i] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
                if (field.getGeneratorBase() !== 0) result[i] = field.multiply(result[i], xiInverse);
            }
            return result;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.Arrays;
    var Table;
    (function(Table) {
        Table[Table["UPPER"] = 0] = "UPPER";
        Table[Table["LOWER"] = 1] = "LOWER";
        Table[Table["MIXED"] = 2] = "MIXED";
        Table[Table["DIGIT"] = 3] = "DIGIT";
        Table[Table["PUNCT"] = 4] = "PUNCT";
        Table[Table["BINARY"] = 5] = "BINARY";
    })(Table || (Table = {}));
    /**
     * <p>The main class which implements Aztec Code decoding -- as opposed to locating and extracting
     * the Aztec Code from an image.</p>
     *
     * @author David Olivier
     */ class Decoder {
        decode(detectorResult) {
            this.ddata = detectorResult;
            let matrix = detectorResult.getBits();
            let rawbits = this.extractBits(matrix);
            let correctedBits = this.correctBits(rawbits);
            let rawBytes = Decoder.convertBoolArrayToByteArray(correctedBits);
            let result = Decoder.getEncodedData(correctedBits);
            let decoderResult = new DecoderResult(rawBytes, result, null, null);
            decoderResult.setNumBits(correctedBits.length);
            return decoderResult;
        }
        // This method is used for testing the high-level encoder
        static highLevelDecode(correctedBits) {
            return this.getEncodedData(correctedBits);
        }
        /**
         * Gets the string encoded in the aztec code bits
         *
         * @return the decoded string
         */ static getEncodedData(correctedBits) {
            let endIndex = correctedBits.length;
            let latchTable = Table.UPPER; // table most recently latched to
            let shiftTable = Table.UPPER; // table to use for the next read
            let result = '';
            let index = 0;
            while(index < endIndex)if (shiftTable === Table.BINARY) {
                if (endIndex - index < 5) break;
                let length = Decoder.readCode(correctedBits, index, 5);
                index += 5;
                if (length === 0) {
                    if (endIndex - index < 11) break;
                    length = Decoder.readCode(correctedBits, index, 11) + 31;
                    index += 11;
                }
                for(let charCount = 0; charCount < length; charCount++){
                    if (endIndex - index < 8) {
                        index = endIndex; // Force outer loop to exit
                        break;
                    }
                    const code = Decoder.readCode(correctedBits, index, 8);
                    result += /*(char)*/ StringUtils.castAsNonUtf8Char(code);
                    index += 8;
                }
                // Go back to whatever mode we had been in
                shiftTable = latchTable;
            } else {
                let size = shiftTable === Table.DIGIT ? 4 : 5;
                if (endIndex - index < size) break;
                let code = Decoder.readCode(correctedBits, index, size);
                index += size;
                let str = Decoder.getCharacter(shiftTable, code);
                if (str.startsWith('CTRL_')) {
                    // Table changes
                    // ISO/IEC 24778:2008 prescribes ending a shift sequence in the mode from which it was invoked.
                    // That's including when that mode is a shift.
                    // Our test case dlusbs.png for issue #642 exercises that.
                    latchTable = shiftTable; // Latch the current mode, so as to return to Upper after U/S B/S
                    shiftTable = Decoder.getTable(str.charAt(5));
                    if (str.charAt(6) === 'L') latchTable = shiftTable;
                } else {
                    result += str;
                    // Go back to whatever mode we had been in
                    shiftTable = latchTable;
                }
            }
            return result;
        }
        /**
         * gets the table corresponding to the char passed
         */ static getTable(t) {
            switch(t){
                case 'L':
                    return Table.LOWER;
                case 'P':
                    return Table.PUNCT;
                case 'M':
                    return Table.MIXED;
                case 'D':
                    return Table.DIGIT;
                case 'B':
                    return Table.BINARY;
                case 'U':
                default:
                    return Table.UPPER;
            }
        }
        /**
         * Gets the character (or string) corresponding to the passed code in the given table
         *
         * @param table the table used
         * @param code the code of the character
         */ static getCharacter(table, code) {
            switch(table){
                case Table.UPPER:
                    return Decoder.UPPER_TABLE[code];
                case Table.LOWER:
                    return Decoder.LOWER_TABLE[code];
                case Table.MIXED:
                    return Decoder.MIXED_TABLE[code];
                case Table.PUNCT:
                    return Decoder.PUNCT_TABLE[code];
                case Table.DIGIT:
                    return Decoder.DIGIT_TABLE[code];
                default:
                    // Should not reach here.
                    throw new IllegalStateException('Bad table');
            }
        }
        /**
         * <p>Performs RS error correction on an array of bits.</p>
         *
         * @return the corrected array
         * @throws FormatException if the input contains too many errors
         */ correctBits(rawbits) {
            let gf;
            let codewordSize;
            if (this.ddata.getNbLayers() <= 2) {
                codewordSize = 6;
                gf = GenericGF.AZTEC_DATA_6;
            } else if (this.ddata.getNbLayers() <= 8) {
                codewordSize = 8;
                gf = GenericGF.AZTEC_DATA_8;
            } else if (this.ddata.getNbLayers() <= 22) {
                codewordSize = 10;
                gf = GenericGF.AZTEC_DATA_10;
            } else {
                codewordSize = 12;
                gf = GenericGF.AZTEC_DATA_12;
            }
            let numDataCodewords = this.ddata.getNbDatablocks();
            let numCodewords = rawbits.length / codewordSize;
            if (numCodewords < numDataCodewords) throw new FormatException();
            let offset = rawbits.length % codewordSize;
            let dataWords = new Int32Array(numCodewords);
            for(let i = 0; i < numCodewords; i++, offset += codewordSize)dataWords[i] = Decoder.readCode(rawbits, offset, codewordSize);
            try {
                let rsDecoder = new ReedSolomonDecoder(gf);
                rsDecoder.decode(dataWords, numCodewords - numDataCodewords);
            } catch (ex) {
                throw new FormatException(ex);
            }
            // Now perform the unstuffing operation.
            // First, count how many bits are going to be thrown out as stuffing
            let mask = (1 << codewordSize) - 1;
            let stuffedBits = 0;
            for(let i = 0; i < numDataCodewords; i++){
                let dataWord = dataWords[i];
                if (dataWord === 0 || dataWord === mask) throw new FormatException();
                else if (dataWord === 1 || dataWord === mask - 1) stuffedBits++;
            }
            // Now, actually unpack the bits and remove the stuffing
            let correctedBits = new Array(numDataCodewords * codewordSize - stuffedBits);
            let index = 0;
            for(let i = 0; i < numDataCodewords; i++){
                let dataWord = dataWords[i];
                if (dataWord === 1 || dataWord === mask - 1) {
                    // next codewordSize-1 bits are all zeros or all ones
                    correctedBits.fill(dataWord > 1, index, index + codewordSize - 1);
                    // Arrays.fill(correctedBits, index, index + codewordSize - 1, dataWord > 1);
                    index += codewordSize - 1;
                } else for(let bit = codewordSize - 1; bit >= 0; --bit)correctedBits[index++] = (dataWord & 1 << bit) !== 0;
            }
            return correctedBits;
        }
        /**
         * Gets the array of bits from an Aztec Code matrix
         *
         * @return the array of bits
         */ extractBits(matrix) {
            let compact = this.ddata.isCompact();
            let layers = this.ddata.getNbLayers();
            let baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
            let alignmentMap = new Int32Array(baseMatrixSize);
            let rawbits = new Array(this.totalBitsInLayer(layers, compact));
            if (compact) for(let i = 0; i < alignmentMap.length; i++)alignmentMap[i] = i;
            else {
                let matrixSize = baseMatrixSize + 1 + 2 * Integer.truncDivision(Integer.truncDivision(baseMatrixSize, 2) - 1, 15);
                let origCenter = baseMatrixSize / 2;
                let center = Integer.truncDivision(matrixSize, 2);
                for(let i = 0; i < origCenter; i++){
                    let newOffset = i + Integer.truncDivision(i, 15);
                    alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                    alignmentMap[origCenter + i] = center + newOffset + 1;
                }
            }
            for(let i = 0, rowOffset = 0; i < layers; i++){
                let rowSize = (layers - i) * 4 + (compact ? 9 : 12);
                // The top-left most point of this layer is <low, low> (not including alignment lines)
                let low = i * 2;
                // The bottom-right most point of this layer is <high, high> (not including alignment lines)
                let high = baseMatrixSize - 1 - low;
                // We pull bits from the two 2 x rowSize columns and two rowSize x 2 rows
                for(let j = 0; j < rowSize; j++){
                    let columnOffset = j * 2;
                    for(let k = 0; k < 2; k++){
                        // left column
                        rawbits[rowOffset + columnOffset + k] = matrix.get(alignmentMap[low + k], alignmentMap[low + j]);
                        // bottom row
                        rawbits[rowOffset + 2 * rowSize + columnOffset + k] = matrix.get(alignmentMap[low + j], alignmentMap[high - k]);
                        // right column
                        rawbits[rowOffset + 4 * rowSize + columnOffset + k] = matrix.get(alignmentMap[high - k], alignmentMap[high - j]);
                        // top row
                        rawbits[rowOffset + 6 * rowSize + columnOffset + k] = matrix.get(alignmentMap[high - j], alignmentMap[low + k]);
                    }
                }
                rowOffset += rowSize * 8;
            }
            return rawbits;
        }
        /**
         * Reads a code of given length and at given index in an array of bits
         */ static readCode(rawbits, startIndex, length) {
            let res = 0;
            for(let i = startIndex; i < startIndex + length; i++){
                res <<= 1;
                if (rawbits[i]) res |= 0x01;
            }
            return res;
        }
        /**
         * Reads a code of length 8 in an array of bits, padding with zeros
         */ static readByte(rawbits, startIndex) {
            let n = rawbits.length - startIndex;
            if (n >= 8) return Decoder.readCode(rawbits, startIndex, 8);
            return Decoder.readCode(rawbits, startIndex, n) << 8 - n;
        }
        /**
         * Packs a bit array into bytes, most significant bit first
         */ static convertBoolArrayToByteArray(boolArr) {
            let byteArr = new Uint8Array((boolArr.length + 7) / 8);
            for(let i = 0; i < byteArr.length; i++)byteArr[i] = Decoder.readByte(boolArr, 8 * i);
            return byteArr;
        }
        totalBitsInLayer(layers, compact) {
            return ((compact ? 88 : 112) + 16 * layers) * layers;
        }
    }
    Decoder.UPPER_TABLE = [
        'CTRL_PS',
        ' ',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'CTRL_LL',
        'CTRL_ML',
        'CTRL_DL',
        'CTRL_BS'
    ];
    Decoder.LOWER_TABLE = [
        'CTRL_PS',
        ' ',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'CTRL_US',
        'CTRL_ML',
        'CTRL_DL',
        'CTRL_BS'
    ];
    Decoder.MIXED_TABLE = [
        // Module parse failed: Octal literal in strict mode (50:29)
        // so number string were scaped
        'CTRL_PS',
        ' ',
        '\\1',
        '\\2',
        '\\3',
        '\\4',
        '\\5',
        '\\6',
        '\\7',
        '\b',
        '\t',
        '\n',
        '\\13',
        '\f',
        '\r',
        '\\33',
        '\\34',
        '\\35',
        '\\36',
        '\\37',
        '@',
        '\\',
        '^',
        '_',
        '`',
        '|',
        '~',
        '\\177',
        'CTRL_LL',
        'CTRL_UL',
        'CTRL_PL',
        'CTRL_BS'
    ];
    Decoder.PUNCT_TABLE = [
        '',
        '\r',
        '\r\n',
        '. ',
        ', ',
        ': ',
        '!',
        '"',
        '#',
        '$',
        '%',
        '&',
        '\'',
        '(',
        ')',
        '*',
        '+',
        ',',
        '-',
        '.',
        '/',
        ':',
        ';',
        '<',
        '=',
        '>',
        '?',
        '[',
        ']',
        '{',
        '}',
        'CTRL_UL'
    ];
    Decoder.DIGIT_TABLE = [
        'CTRL_PS',
        ' ',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        ',',
        '.',
        'CTRL_UL',
        'CTRL_US'
    ];
    /*
     * Copyright 2012 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing.common.detector {*/ /**
     * General math-related and numeric utility functions.
     */ class MathUtils {
        constructor(){}
        /**
         * Ends up being a bit faster than {@link Math#round(float)}. This merely rounds its
         * argument to the nearest int, where x.5 rounds up to x+1. Semantics of this shortcut
         * differ slightly from {@link Math#round(float)} in that half rounds down for negative
         * values. -2.5 rounds to -3, not -2. For purposes here it makes no difference.
         *
         * @param d real value to round
         * @return nearest {@code int}
         */ static round(d /*float*/ ) {
            if (d <= Number.MIN_SAFE_INTEGER) return Number.MIN_SAFE_INTEGER;
            if (d >= Number.MAX_SAFE_INTEGER) return Number.MAX_SAFE_INTEGER;
            return /*(int) */ d + (d < 0.0 ? -0.5 : 0.5) | 0;
        }
        // TYPESCRIPTPORT: maybe remove round method and call directly Math.round, it looks like it doesn't make sense for js
        /**
         * @param aX point A x coordinate
         * @param aY point A y coordinate
         * @param bX point B x coordinate
         * @param bY point B y coordinate
         * @return Euclidean distance between points A and B
         */ static distance(aX /*float|int*/ , aY /*float|int*/ , bX /*float|int*/ , bY /*float|int*/ ) {
            const xDiff = aX - bX;
            const yDiff = aY - bY;
            return /*(float) */ Math.sqrt(xDiff * xDiff + yDiff * yDiff);
        }
        /**
         * @param aX point A x coordinate
         * @param aY point A y coordinate
         * @param bX point B x coordinate
         * @param bY point B y coordinate
         * @return Euclidean distance between points A and B
         */ // public static distance(aX: number /*int*/, aY: number /*int*/, bX: number /*int*/, bY: number /*int*/): float {
        //   const xDiff = aX - bX
        //   const yDiff = aY - bY
        //   return (float) Math.sqrt(xDiff * xDiff + yDiff * yDiff);
        // }
        /**
         * @param array values to sum
         * @return sum of values in array
         */ static sum(array) {
            let count = 0;
            for(let i = 0, length = array.length; i !== length; i++){
                const a = array[i];
                count += a;
            }
            return count;
        }
    }
    /**
     * Ponyfill for Java's Float class.
     */ class Float {
        /**
         * SincTS has no difference between int and float, there's all numbers,
         * this is used only to polyfill Java code.
         */ static floatToIntBits(f) {
            return f;
        }
    }
    /**
     * The float max value in JS is the number max value.
     */ Float.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a point of interest in an image containing a barcode. Typically, this
     * would be the location of a finder pattern or the corner of the barcode, for example.</p>
     *
     * @author Sean Owen
     */ class ResultPoint {
        constructor(x, y){
            this.x = x;
            this.y = y;
        }
        getX() {
            return this.x;
        }
        getY() {
            return this.y;
        }
        /*@Override*/ equals(other) {
            if (other instanceof ResultPoint) {
                const otherPoint = other;
                return this.x === otherPoint.x && this.y === otherPoint.y;
            }
            return false;
        }
        /*@Override*/ hashCode() {
            return 31 * Float.floatToIntBits(this.x) + Float.floatToIntBits(this.y);
        }
        /*@Override*/ toString() {
            return '(' + this.x + ',' + this.y + ')';
        }
        /**
         * Orders an array of three ResultPoints in an order [A,B,C] such that AB is less than AC
         * and BC is less than AC, and the angle between BC and BA is less than 180 degrees.
         *
         * @param patterns array of three {@code ResultPoint} to order
         */ static orderBestPatterns(patterns) {
            // Find distances between pattern centers
            const zeroOneDistance = this.distance(patterns[0], patterns[1]);
            const oneTwoDistance = this.distance(patterns[1], patterns[2]);
            const zeroTwoDistance = this.distance(patterns[0], patterns[2]);
            let pointA;
            let pointB;
            let pointC;
            // Assume one closest to other two is B; A and C will just be guesses at first
            if (oneTwoDistance >= zeroOneDistance && oneTwoDistance >= zeroTwoDistance) {
                pointB = patterns[0];
                pointA = patterns[1];
                pointC = patterns[2];
            } else if (zeroTwoDistance >= oneTwoDistance && zeroTwoDistance >= zeroOneDistance) {
                pointB = patterns[1];
                pointA = patterns[0];
                pointC = patterns[2];
            } else {
                pointB = patterns[2];
                pointA = patterns[0];
                pointC = patterns[1];
            }
            // Use cross product to figure out whether A and C are correct or flipped.
            // This asks whether BC x BA has a positive z component, which is the arrangement
            // we want for A, B, C. If it's negative, then we've got it flipped around and
            // should swap A and C.
            if (this.crossProductZ(pointA, pointB, pointC) < 0.0) {
                const temp = pointA;
                pointA = pointC;
                pointC = temp;
            }
            patterns[0] = pointA;
            patterns[1] = pointB;
            patterns[2] = pointC;
        }
        /**
         * @param pattern1 first pattern
         * @param pattern2 second pattern
         * @return distance between two points
         */ static distance(pattern1, pattern2) {
            return MathUtils.distance(pattern1.x, pattern1.y, pattern2.x, pattern2.y);
        }
        /**
         * Returns the z component of the cross product between vectors BC and BA.
         */ static crossProductZ(pointA, pointB, pointC) {
            const bX = pointB.x;
            const bY = pointB.y;
            return (pointC.x - bX) * (pointA.y - bY) - (pointC.y - bY) * (pointA.x - bX);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates the result of detecting a barcode in an image. This includes the raw
     * matrix of black/white pixels corresponding to the barcode, and possibly points of interest
     * in the image, like the location of finder patterns or corners of the barcode in the image.</p>
     *
     * @author Sean Owen
     */ class DetectorResult {
        constructor(bits, points){
            this.bits = bits;
            this.points = points;
        }
        getBits() {
            return this.bits;
        }
        getPoints() {
            return this.points;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Extends {@link DetectorResult} with more information specific to the Aztec format,
     * like the number of layers and whether it's compact.</p>
     *
     * @author Sean Owen
     */ class AztecDetectorResult extends DetectorResult {
        constructor(bits, points, compact, nbDatablocks, nbLayers){
            super(bits, points);
            this.compact = compact;
            this.nbDatablocks = nbDatablocks;
            this.nbLayers = nbLayers;
        }
        getNbLayers() {
            return this.nbLayers;
        }
        getNbDatablocks() {
            return this.nbDatablocks;
        }
        isCompact() {
            return this.compact;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>
     * Detects a candidate barcode-like rectangular region within an image. It
     * starts around the center of the image, increases the size of the candidate
     * region until it finds a white rectangular region. By keeping track of the
     * last black points it encountered, it determines the corners of the barcode.
     * </p>
     *
     * @author David Olivier
     */ class WhiteRectangleDetector {
        // public constructor(private image: BitMatrix) /*throws NotFoundException*/ {
        //   this(image, INIT_SIZE, image.getWidth() / 2, image.getHeight() / 2)
        // }
        /**
         * @param image barcode image to find a rectangle in
         * @param initSize initial size of search area around center
         * @param x x position of search center
         * @param y y position of search center
         * @throws NotFoundException if image is too small to accommodate {@code initSize}
         */ constructor(image, initSize /*int*/ , x /*int*/ , y /*int*/ ){
            this.image = image;
            this.height = image.getHeight();
            this.width = image.getWidth();
            if (undefined === initSize || null === initSize) initSize = WhiteRectangleDetector.INIT_SIZE;
            if (undefined === x || null === x) x = image.getWidth() / 2 | 0;
            if (undefined === y || null === y) y = image.getHeight() / 2 | 0;
            const halfsize = initSize / 2 | 0;
            this.leftInit = x - halfsize;
            this.rightInit = x + halfsize;
            this.upInit = y - halfsize;
            this.downInit = y + halfsize;
            if (this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) throw new NotFoundException();
        }
        /**
         * <p>
         * Detects a candidate barcode-like rectangular region within an image. It
         * starts around the center of the image, increases the size of the candidate
         * region until it finds a white rectangular region.
         * </p>
         *
         * @return {@link ResultPoint}[] describing the corners of the rectangular
         *         region. The first and last points are opposed on the diagonal, as
         *         are the second and third. The first point will be the topmost
         *         point and the last, the bottommost. The second point will be
         *         leftmost and the third, the rightmost
         * @throws NotFoundException if no Data Matrix Code can be found
         */ detect() {
            let left = this.leftInit;
            let right = this.rightInit;
            let up = this.upInit;
            let down = this.downInit;
            let sizeExceeded = false;
            let aBlackPointFoundOnBorder = true;
            let atLeastOneBlackPointFoundOnBorder = false;
            let atLeastOneBlackPointFoundOnRight = false;
            let atLeastOneBlackPointFoundOnBottom = false;
            let atLeastOneBlackPointFoundOnLeft = false;
            let atLeastOneBlackPointFoundOnTop = false;
            const width = this.width;
            const height = this.height;
            while(aBlackPointFoundOnBorder){
                aBlackPointFoundOnBorder = false;
                // .....
                // .   |
                // .....
                let rightBorderNotWhite = true;
                while((rightBorderNotWhite || !atLeastOneBlackPointFoundOnRight) && right < width){
                    rightBorderNotWhite = this.containsBlackPoint(up, down, right, false);
                    if (rightBorderNotWhite) {
                        right++;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnRight = true;
                    } else if (!atLeastOneBlackPointFoundOnRight) right++;
                }
                if (right >= width) {
                    sizeExceeded = true;
                    break;
                }
                // .....
                // .   .
                // .___.
                let bottomBorderNotWhite = true;
                while((bottomBorderNotWhite || !atLeastOneBlackPointFoundOnBottom) && down < height){
                    bottomBorderNotWhite = this.containsBlackPoint(left, right, down, true);
                    if (bottomBorderNotWhite) {
                        down++;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnBottom = true;
                    } else if (!atLeastOneBlackPointFoundOnBottom) down++;
                }
                if (down >= height) {
                    sizeExceeded = true;
                    break;
                }
                // .....
                // |   .
                // .....
                let leftBorderNotWhite = true;
                while((leftBorderNotWhite || !atLeastOneBlackPointFoundOnLeft) && left >= 0){
                    leftBorderNotWhite = this.containsBlackPoint(up, down, left, false);
                    if (leftBorderNotWhite) {
                        left--;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnLeft = true;
                    } else if (!atLeastOneBlackPointFoundOnLeft) left--;
                }
                if (left < 0) {
                    sizeExceeded = true;
                    break;
                }
                // .___.
                // .   .
                // .....
                let topBorderNotWhite = true;
                while((topBorderNotWhite || !atLeastOneBlackPointFoundOnTop) && up >= 0){
                    topBorderNotWhite = this.containsBlackPoint(left, right, up, true);
                    if (topBorderNotWhite) {
                        up--;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnTop = true;
                    } else if (!atLeastOneBlackPointFoundOnTop) up--;
                }
                if (up < 0) {
                    sizeExceeded = true;
                    break;
                }
                if (aBlackPointFoundOnBorder) atLeastOneBlackPointFoundOnBorder = true;
            }
            if (!sizeExceeded && atLeastOneBlackPointFoundOnBorder) {
                const maxSize = right - left;
                let z = null;
                for(let i = 1; z === null && i < maxSize; i++)z = this.getBlackPointOnSegment(left, down - i, left + i, down);
                if (z == null) throw new NotFoundException();
                let t = null;
                // go down right
                for(let i = 1; t === null && i < maxSize; i++)t = this.getBlackPointOnSegment(left, up + i, left + i, up);
                if (t == null) throw new NotFoundException();
                let x = null;
                // go down left
                for(let i = 1; x === null && i < maxSize; i++)x = this.getBlackPointOnSegment(right, up + i, right - i, up);
                if (x == null) throw new NotFoundException();
                let y = null;
                // go up left
                for(let i = 1; y === null && i < maxSize; i++)y = this.getBlackPointOnSegment(right, down - i, right - i, down);
                if (y == null) throw new NotFoundException();
                return this.centerEdges(y, z, x, t);
            } else throw new NotFoundException();
        }
        getBlackPointOnSegment(aX /*float*/ , aY /*float*/ , bX /*float*/ , bY /*float*/ ) {
            const dist = MathUtils.round(MathUtils.distance(aX, aY, bX, bY));
            const xStep = (bX - aX) / dist;
            const yStep = (bY - aY) / dist;
            const image = this.image;
            for(let i = 0; i < dist; i++){
                const x = MathUtils.round(aX + i * xStep);
                const y = MathUtils.round(aY + i * yStep);
                if (image.get(x, y)) return new ResultPoint(x, y);
            }
            return null;
        }
        /**
         * recenters the points of a constant distance towards the center
         *
         * @param y bottom most point
         * @param z left most point
         * @param x right most point
         * @param t top most point
         * @return {@link ResultPoint}[] describing the corners of the rectangular
         *         region. The first and last points are opposed on the diagonal, as
         *         are the second and third. The first point will be the topmost
         *         point and the last, the bottommost. The second point will be
         *         leftmost and the third, the rightmost
         */ centerEdges(y, z, x, t) {
            //
            //       t            t
            //  z                      x
            //        x    OR    z
            //   y                    y
            //
            const yi = y.getX();
            const yj = y.getY();
            const zi = z.getX();
            const zj = z.getY();
            const xi = x.getX();
            const xj = x.getY();
            const ti = t.getX();
            const tj = t.getY();
            const CORR = WhiteRectangleDetector.CORR;
            if (yi < this.width / 2.0) return [
                new ResultPoint(ti - CORR, tj + CORR),
                new ResultPoint(zi + CORR, zj + CORR),
                new ResultPoint(xi - CORR, xj - CORR),
                new ResultPoint(yi + CORR, yj - CORR)
            ];
            else return [
                new ResultPoint(ti + CORR, tj + CORR),
                new ResultPoint(zi + CORR, zj - CORR),
                new ResultPoint(xi - CORR, xj + CORR),
                new ResultPoint(yi - CORR, yj - CORR)
            ];
        }
        /**
         * Determines whether a segment contains a black point
         *
         * @param a          min value of the scanned coordinate
         * @param b          max value of the scanned coordinate
         * @param fixed      value of fixed coordinate
         * @param horizontal set to true if scan must be horizontal, false if vertical
         * @return true if a black point has been found, else false.
         */ containsBlackPoint(a /*int*/ , b /*int*/ , fixed /*int*/ , horizontal) {
            const image = this.image;
            if (horizontal) for(let x = a; x <= b; x++){
                if (image.get(x, fixed)) return true;
            }
            else for(let y = a; y <= b; y++){
                if (image.get(fixed, y)) return true;
            }
            return false;
        }
    }
    WhiteRectangleDetector.INIT_SIZE = 10;
    WhiteRectangleDetector.CORR = 1;
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * Implementations of this class can, given locations of finder patterns for a QR code in an
     * image, sample the right points in the image to reconstruct the QR code, accounting for
     * perspective distortion. It is abstracted since it is relatively expensive and should be allowed
     * to take advantage of platform-specific optimized implementations, like Sun's Java Advanced
     * Imaging library, but which may not be available in other environments such as J2ME, and vice
     * versa.
     *
     * The implementation used can be controlled by calling {@link #setGridSampler(GridSampler)}
     * with an instance of a class which implements this interface.
     *
     * @author Sean Owen
     */ class GridSampler {
        /**
         * <p>Checks a set of points that have been transformed to sample points on an image against
         * the image's dimensions to see if the point are even within the image.</p>
         *
         * <p>This method will actually "nudge" the endpoints back onto the image if they are found to be
         * barely (less than 1 pixel) off the image. This accounts for imperfect detection of finder
         * patterns in an image where the QR Code runs all the way to the image border.</p>
         *
         * <p>For efficiency, the method will check points from either end of the line until one is found
         * to be within the image. Because the set of points are assumed to be linear, this is valid.</p>
         *
         * @param image image into which the points should map
         * @param points actual points in x1,y1,...,xn,yn form
         * @throws NotFoundException if an endpoint is lies outside the image boundaries
         */ static checkAndNudgePoints(image, points) {
            const width = image.getWidth();
            const height = image.getHeight();
            // Check and nudge points from start until we see some that are OK:
            let nudged = true;
            for(let offset = 0; offset < points.length && nudged; offset += 2){
                const x = Math.floor(points[offset]);
                const y = Math.floor(points[offset + 1]);
                if (x < -1 || x > width || y < -1 || y > height) throw new NotFoundException();
                nudged = false;
                if (x === -1) {
                    points[offset] = 0.0;
                    nudged = true;
                } else if (x === width) {
                    points[offset] = width - 1;
                    nudged = true;
                }
                if (y === -1) {
                    points[offset + 1] = 0.0;
                    nudged = true;
                } else if (y === height) {
                    points[offset + 1] = height - 1;
                    nudged = true;
                }
            }
            // Check and nudge points from end:
            nudged = true;
            for(let offset = points.length - 2; offset >= 0 && nudged; offset -= 2){
                const x = Math.floor(points[offset]);
                const y = Math.floor(points[offset + 1]);
                if (x < -1 || x > width || y < -1 || y > height) throw new NotFoundException();
                nudged = false;
                if (x === -1) {
                    points[offset] = 0.0;
                    nudged = true;
                } else if (x === width) {
                    points[offset] = width - 1;
                    nudged = true;
                }
                if (y === -1) {
                    points[offset + 1] = 0.0;
                    nudged = true;
                } else if (y === height) {
                    points[offset + 1] = height - 1;
                    nudged = true;
                }
            }
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing.common {*/ /**
     * <p>This class implements a perspective transform in two dimensions. Given four source and four
     * destination points, it will compute the transformation implied between them. The code is based
     * directly upon section 3.4.2 of George Wolberg's "Digital Image Warping"; see pages 54-56.</p>
     *
     * @author Sean Owen
     */ class PerspectiveTransform {
        constructor(a11 /*float*/ , a21 /*float*/ , a31 /*float*/ , a12 /*float*/ , a22 /*float*/ , a32 /*float*/ , a13 /*float*/ , a23 /*float*/ , a33 /*float*/ ){
            this.a11 = a11;
            this.a21 = a21;
            this.a31 = a31;
            this.a12 = a12;
            this.a22 = a22;
            this.a32 = a32;
            this.a13 = a13;
            this.a23 = a23;
            this.a33 = a33;
        }
        static quadrilateralToQuadrilateral(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ , x0p /*float*/ , y0p /*float*/ , x1p /*float*/ , y1p /*float*/ , x2p /*float*/ , y2p /*float*/ , x3p /*float*/ , y3p /*float*/ ) {
            const qToS = PerspectiveTransform.quadrilateralToSquare(x0, y0, x1, y1, x2, y2, x3, y3);
            const sToQ = PerspectiveTransform.squareToQuadrilateral(x0p, y0p, x1p, y1p, x2p, y2p, x3p, y3p);
            return sToQ.times(qToS);
        }
        transformPoints(points) {
            const max = points.length;
            const a11 = this.a11;
            const a12 = this.a12;
            const a13 = this.a13;
            const a21 = this.a21;
            const a22 = this.a22;
            const a23 = this.a23;
            const a31 = this.a31;
            const a32 = this.a32;
            const a33 = this.a33;
            for(let i = 0; i < max; i += 2){
                const x = points[i];
                const y = points[i + 1];
                const denominator = a13 * x + a23 * y + a33;
                points[i] = (a11 * x + a21 * y + a31) / denominator;
                points[i + 1] = (a12 * x + a22 * y + a32) / denominator;
            }
        }
        transformPointsWithValues(xValues, yValues) {
            const a11 = this.a11;
            const a12 = this.a12;
            const a13 = this.a13;
            const a21 = this.a21;
            const a22 = this.a22;
            const a23 = this.a23;
            const a31 = this.a31;
            const a32 = this.a32;
            const a33 = this.a33;
            const n = xValues.length;
            for(let i = 0; i < n; i++){
                const x = xValues[i];
                const y = yValues[i];
                const denominator = a13 * x + a23 * y + a33;
                xValues[i] = (a11 * x + a21 * y + a31) / denominator;
                yValues[i] = (a12 * x + a22 * y + a32) / denominator;
            }
        }
        static squareToQuadrilateral(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ ) {
            const dx3 = x0 - x1 + x2 - x3;
            const dy3 = y0 - y1 + y2 - y3;
            if (dx3 === 0.0 && dy3 === 0.0) // Affine
            return new PerspectiveTransform(x1 - x0, x2 - x1, x0, y1 - y0, y2 - y1, y0, 0.0, 0.0, 1.0);
            else {
                const dx1 = x1 - x2;
                const dx2 = x3 - x2;
                const dy1 = y1 - y2;
                const dy2 = y3 - y2;
                const denominator = dx1 * dy2 - dx2 * dy1;
                const a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
                const a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
                return new PerspectiveTransform(x1 - x0 + a13 * x1, x3 - x0 + a23 * x3, x0, y1 - y0 + a13 * y1, y3 - y0 + a23 * y3, y0, a13, a23, 1.0);
            }
        }
        static quadrilateralToSquare(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ ) {
            // Here, the adjoint serves as the inverse:
            return PerspectiveTransform.squareToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3).buildAdjoint();
        }
        buildAdjoint() {
            // Adjoint is the transpose of the cofactor matrix:
            return new PerspectiveTransform(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
        }
        times(other) {
            return new PerspectiveTransform(this.a11 * other.a11 + this.a21 * other.a12 + this.a31 * other.a13, this.a11 * other.a21 + this.a21 * other.a22 + this.a31 * other.a23, this.a11 * other.a31 + this.a21 * other.a32 + this.a31 * other.a33, this.a12 * other.a11 + this.a22 * other.a12 + this.a32 * other.a13, this.a12 * other.a21 + this.a22 * other.a22 + this.a32 * other.a23, this.a12 * other.a31 + this.a22 * other.a32 + this.a32 * other.a33, this.a13 * other.a11 + this.a23 * other.a12 + this.a33 * other.a13, this.a13 * other.a21 + this.a23 * other.a22 + this.a33 * other.a23, this.a13 * other.a31 + this.a23 * other.a32 + this.a33 * other.a33);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Sean Owen
     */ class DefaultGridSampler extends GridSampler {
        /*@Override*/ sampleGrid(image, dimensionX /*int*/ , dimensionY /*int*/ , p1ToX /*float*/ , p1ToY /*float*/ , p2ToX /*float*/ , p2ToY /*float*/ , p3ToX /*float*/ , p3ToY /*float*/ , p4ToX /*float*/ , p4ToY /*float*/ , p1FromX /*float*/ , p1FromY /*float*/ , p2FromX /*float*/ , p2FromY /*float*/ , p3FromX /*float*/ , p3FromY /*float*/ , p4FromX /*float*/ , p4FromY /*float*/ ) {
            const transform = PerspectiveTransform.quadrilateralToQuadrilateral(p1ToX, p1ToY, p2ToX, p2ToY, p3ToX, p3ToY, p4ToX, p4ToY, p1FromX, p1FromY, p2FromX, p2FromY, p3FromX, p3FromY, p4FromX, p4FromY);
            return this.sampleGridWithTransform(image, dimensionX, dimensionY, transform);
        }
        /*@Override*/ sampleGridWithTransform(image, dimensionX /*int*/ , dimensionY /*int*/ , transform) {
            if (dimensionX <= 0 || dimensionY <= 0) throw new NotFoundException();
            const bits = new BitMatrix(dimensionX, dimensionY);
            const points = new Float32Array(2 * dimensionX);
            for(let y = 0; y < dimensionY; y++){
                const max = points.length;
                const iValue = y + 0.5;
                for(let x = 0; x < max; x += 2){
                    points[x] = x / 2 + 0.5;
                    points[x + 1] = iValue;
                }
                transform.transformPoints(points);
                // Quick check to see if points transformed to something inside the image
                // sufficient to check the endpoints
                GridSampler.checkAndNudgePoints(image, points);
                try {
                    for(let x = 0; x < max; x += 2)if (image.get(Math.floor(points[x]), Math.floor(points[x + 1]))) // Black(-ish) pixel
                    bits.set(x / 2, y);
                } catch (aioobe /*: ArrayIndexOutOfBoundsException*/ ) {
                    // This feels wrong, but, sometimes if the finder patterns are misidentified, the resulting
                    // transform gets "twisted" such that it maps a straight line of points to a set of points
                    // whose endpoints are in bounds, but others are not. There is probably some mathematical
                    // way to detect this about the transformation that I don't know yet.
                    // This results in an ugly runtime exception despite our clever checks above -- can't have
                    // that. We could check each point's coordinates but that feels duplicative. We settle for
                    // catching and wrapping ArrayIndexOutOfBoundsException.
                    throw new NotFoundException();
                }
            }
            return bits;
        }
    }
    class GridSamplerInstance {
        /**
         * Sets the implementation of GridSampler used by the library. One global
         * instance is stored, which may sound problematic. But, the implementation provided
         * ought to be appropriate for the entire platform, and all uses of this library
         * in the whole lifetime of the JVM. For instance, an Android activity can swap in
         * an implementation that takes advantage of native platform libraries.
         *
         * @param newGridSampler The platform-specific object to install.
         */ static setGridSampler(newGridSampler) {
            GridSamplerInstance.gridSampler = newGridSampler;
        }
        /**
         * @return the current implementation of GridSampler
         */ static getInstance() {
            return GridSamplerInstance.gridSampler;
        }
    }
    GridSamplerInstance.gridSampler = new DefaultGridSampler();
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ class Point {
        constructor(x, y){
            this.x = x;
            this.y = y;
        }
        toResultPoint() {
            return new ResultPoint(this.getX(), this.getY());
        }
        getX() {
            return this.x;
        }
        getY() {
            return this.y;
        }
    }
    /**
     * Encapsulates logic that can detect an Aztec Code in an image, even if the Aztec Code
     * is rotated or skewed, or partially obscured.
     *
     * @author David Olivier
     * @author Frank Yellin
     */ class Detector {
        constructor(image){
            this.EXPECTED_CORNER_BITS = new Int32Array([
                0xee0,
                0x1dc,
                0x83b,
                0x707
            ]);
            this.image = image;
        }
        detect() {
            return this.detectMirror(false);
        }
        /**
         * Detects an Aztec Code in an image.
         *
         * @param isMirror if true, image is a mirror-image of original
         * @return {@link AztecDetectorResult} encapsulating results of detecting an Aztec Code
         * @throws NotFoundException if no Aztec Code can be found
         */ detectMirror(isMirror) {
            // 1. Get the center of the aztec matrix
            let pCenter = this.getMatrixCenter();
            // 2. Get the center points of the four diagonal points just outside the bull's eye
            //  [topRight, bottomRight, bottomLeft, topLeft]
            let bullsEyeCorners = this.getBullsEyeCorners(pCenter);
            if (isMirror) {
                let temp = bullsEyeCorners[0];
                bullsEyeCorners[0] = bullsEyeCorners[2];
                bullsEyeCorners[2] = temp;
            }
            // 3. Get the size of the matrix and other parameters from the bull's eye
            this.extractParameters(bullsEyeCorners);
            // 4. Sample the grid
            let bits = this.sampleGrid(this.image, bullsEyeCorners[this.shift % 4], bullsEyeCorners[(this.shift + 1) % 4], bullsEyeCorners[(this.shift + 2) % 4], bullsEyeCorners[(this.shift + 3) % 4]);
            // 5. Get the corners of the matrix.
            let corners = this.getMatrixCornerPoints(bullsEyeCorners);
            return new AztecDetectorResult(bits, corners, this.compact, this.nbDataBlocks, this.nbLayers);
        }
        /**
         * Extracts the number of data layers and data blocks from the layer around the bull's eye.
         *
         * @param bullsEyeCorners the array of bull's eye corners
         * @throws NotFoundException in case of too many errors or invalid parameters
         */ extractParameters(bullsEyeCorners) {
            if (!this.isValidPoint(bullsEyeCorners[0]) || !this.isValidPoint(bullsEyeCorners[1]) || !this.isValidPoint(bullsEyeCorners[2]) || !this.isValidPoint(bullsEyeCorners[3])) throw new NotFoundException();
            let length = 2 * this.nbCenterLayers;
            // Get the bits around the bull's eye
            let sides = new Int32Array([
                this.sampleLine(bullsEyeCorners[0], bullsEyeCorners[1], length),
                this.sampleLine(bullsEyeCorners[1], bullsEyeCorners[2], length),
                this.sampleLine(bullsEyeCorners[2], bullsEyeCorners[3], length),
                this.sampleLine(bullsEyeCorners[3], bullsEyeCorners[0], length) // Top
            ]);
            // bullsEyeCorners[shift] is the corner of the bulls'eye that has three
            // orientation marks.
            // sides[shift] is the row/column that goes from the corner with three
            // orientation marks to the corner with two.
            this.shift = this.getRotation(sides, length);
            // Flatten the parameter bits into a single 28- or 40-bit long
            let parameterData = 0;
            for(let i = 0; i < 4; i++){
                let side = sides[(this.shift + i) % 4];
                if (this.compact) {
                    // Each side of the form ..XXXXXXX. where Xs are parameter data
                    parameterData <<= 7;
                    parameterData += side >> 1 & 0x7F;
                } else {
                    // Each side of the form ..XXXXX.XXXXX. where Xs are parameter data
                    parameterData <<= 10;
                    parameterData += (side >> 2 & 992) + (side >> 1 & 0x1F);
                }
            }
            // Corrects parameter data using RS.  Returns just the data portion
            // without the error correction.
            let correctedData = this.getCorrectedParameterData(parameterData, this.compact);
            if (this.compact) {
                // 8 bits:  2 bits layers and 6 bits data blocks
                this.nbLayers = (correctedData >> 6) + 1;
                this.nbDataBlocks = (correctedData & 0x3F) + 1;
            } else {
                // 16 bits:  5 bits layers and 11 bits data blocks
                this.nbLayers = (correctedData >> 11) + 1;
                this.nbDataBlocks = (correctedData & 0x7FF) + 1;
            }
        }
        getRotation(sides, length) {
            // In a normal pattern, we expect to See
            //   **    .*             D       A
            //   *      *
            //
            //   .      *
            //   ..    ..             C       B
            //
            // Grab the 3 bits from each of the sides the form the locator pattern and concatenate
            // into a 12-bit integer.  Start with the bit at A
            let cornerBits = 0;
            sides.forEach((side, idx, arr)=>{
                // XX......X where X's are orientation marks
                let t = (side >> length - 2 << 1) + (side & 1);
                cornerBits = (cornerBits << 3) + t;
            });
            // for (var side in sides) {
            //     // XX......X where X's are orientation marks
            //     var t = ((side >> (length - 2)) << 1) + (side & 1);
            //     cornerBits = (cornerBits << 3) + t;
            // }
            // Mov the bottom bit to the top, so that the three bits of the locator pattern at A are
            // together.  cornerBits is now:
            //  3 orientation bits at A || 3 orientation bits at B || ... || 3 orientation bits at D
            cornerBits = ((cornerBits & 1) << 11) + (cornerBits >> 1);
            // The result shift indicates which element of BullsEyeCorners[] goes into the top-left
            // corner. Since the four rotation values have a Hamming distance of 8, we
            // can easily tolerate two errors.
            for(let shift = 0; shift < 4; shift++){
                if (Integer.bitCount(cornerBits ^ this.EXPECTED_CORNER_BITS[shift]) <= 2) return shift;
            }
            throw new NotFoundException();
        }
        /**
         * Corrects the parameter bits using Reed-Solomon algorithm.
         *
         * @param parameterData parameter bits
         * @param compact true if this is a compact Aztec code
         * @throws NotFoundException if the array contains too many errors
         */ getCorrectedParameterData(parameterData, compact) {
            let numCodewords;
            let numDataCodewords;
            if (compact) {
                numCodewords = 7;
                numDataCodewords = 2;
            } else {
                numCodewords = 10;
                numDataCodewords = 4;
            }
            let numECCodewords = numCodewords - numDataCodewords;
            let parameterWords = new Int32Array(numCodewords);
            for(let i = numCodewords - 1; i >= 0; --i){
                parameterWords[i] = parameterData & 0xF;
                parameterData >>= 4;
            }
            try {
                let rsDecoder = new ReedSolomonDecoder(GenericGF.AZTEC_PARAM);
                rsDecoder.decode(parameterWords, numECCodewords);
            } catch (ignored) {
                throw new NotFoundException();
            }
            // Toss the error correction.  Just return the data as an integer
            let result = 0;
            for(let i = 0; i < numDataCodewords; i++)result = (result << 4) + parameterWords[i];
            return result;
        }
        /**
         * Finds the corners of a bull-eye centered on the passed point.
         * This returns the centers of the diagonal points just outside the bull's eye
         * Returns [topRight, bottomRight, bottomLeft, topLeft]
         *
         * @param pCenter Center point
         * @return The corners of the bull-eye
         * @throws NotFoundException If no valid bull-eye can be found
         */ getBullsEyeCorners(pCenter) {
            let pina = pCenter;
            let pinb = pCenter;
            let pinc = pCenter;
            let pind = pCenter;
            let color = true;
            for(this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++){
                let pouta = this.getFirstDifferent(pina, color, 1, -1);
                let poutb = this.getFirstDifferent(pinb, color, 1, 1);
                let poutc = this.getFirstDifferent(pinc, color, -1, 1);
                let poutd = this.getFirstDifferent(pind, color, -1, -1);
                // d      a
                //
                // c      b
                if (this.nbCenterLayers > 2) {
                    let q = this.distancePoint(poutd, pouta) * this.nbCenterLayers / (this.distancePoint(pind, pina) * (this.nbCenterLayers + 2));
                    if (q < 0.75 || q > 1.25 || !this.isWhiteOrBlackRectangle(pouta, poutb, poutc, poutd)) break;
                }
                pina = pouta;
                pinb = poutb;
                pinc = poutc;
                pind = poutd;
                color = !color;
            }
            if (this.nbCenterLayers !== 5 && this.nbCenterLayers !== 7) throw new NotFoundException();
            this.compact = this.nbCenterLayers === 5;
            // Expand the square by .5 pixel in each direction so that we're on the border
            // between the white square and the black square
            let pinax = new ResultPoint(pina.getX() + 0.5, pina.getY() - 0.5);
            let pinbx = new ResultPoint(pinb.getX() + 0.5, pinb.getY() + 0.5);
            let pincx = new ResultPoint(pinc.getX() - 0.5, pinc.getY() + 0.5);
            let pindx = new ResultPoint(pind.getX() - 0.5, pind.getY() - 0.5);
            // Expand the square so that its corners are the centers of the points
            // just outside the bull's eye.
            return this.expandSquare([
                pinax,
                pinbx,
                pincx,
                pindx
            ], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
        }
        /**
         * Finds a candidate center point of an Aztec code from an image
         *
         * @return the center point
         */ getMatrixCenter() {
            let pointA;
            let pointB;
            let pointC;
            let pointD;
            // Get a white rectangle that can be the border of the matrix in center bull's eye or
            try {
                let cornerPoints = new WhiteRectangleDetector(this.image).detect();
                pointA = cornerPoints[0];
                pointB = cornerPoints[1];
                pointC = cornerPoints[2];
                pointD = cornerPoints[3];
            } catch (e) {
                // This exception can be in case the initial rectangle is white
                // In that case, surely in the bull's eye, we try to expand the rectangle.
                let cx = this.image.getWidth() / 2;
                let cy = this.image.getHeight() / 2;
                pointA = this.getFirstDifferent(new Point(cx + 7, cy - 7), false, 1, -1).toResultPoint();
                pointB = this.getFirstDifferent(new Point(cx + 7, cy + 7), false, 1, 1).toResultPoint();
                pointC = this.getFirstDifferent(new Point(cx - 7, cy + 7), false, -1, 1).toResultPoint();
                pointD = this.getFirstDifferent(new Point(cx - 7, cy - 7), false, -1, -1).toResultPoint();
            }
            // Compute the center of the rectangle
            let cx = MathUtils.round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
            let cy = MathUtils.round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
            // Redetermine the white rectangle starting from previously computed center.
            // This will ensure that we end up with a white rectangle in center bull's eye
            // in order to compute a more accurate center.
            try {
                let cornerPoints = new WhiteRectangleDetector(this.image, 15, cx, cy).detect();
                pointA = cornerPoints[0];
                pointB = cornerPoints[1];
                pointC = cornerPoints[2];
                pointD = cornerPoints[3];
            } catch (e) {
                // This exception can be in case the initial rectangle is white
                // In that case we try to expand the rectangle.
                pointA = this.getFirstDifferent(new Point(cx + 7, cy - 7), false, 1, -1).toResultPoint();
                pointB = this.getFirstDifferent(new Point(cx + 7, cy + 7), false, 1, 1).toResultPoint();
                pointC = this.getFirstDifferent(new Point(cx - 7, cy + 7), false, -1, 1).toResultPoint();
                pointD = this.getFirstDifferent(new Point(cx - 7, cy - 7), false, -1, -1).toResultPoint();
            }
            // Recompute the center of the rectangle
            cx = MathUtils.round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
            cy = MathUtils.round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
            return new Point(cx, cy);
        }
        /**
         * Gets the Aztec code corners from the bull's eye corners and the parameters.
         *
         * @param bullsEyeCorners the array of bull's eye corners
         * @return the array of aztec code corners
         */ getMatrixCornerPoints(bullsEyeCorners) {
            return this.expandSquare(bullsEyeCorners, 2 * this.nbCenterLayers, this.getDimension());
        }
        /**
         * Creates a BitMatrix by sampling the provided image.
         * topLeft, topRight, bottomRight, and bottomLeft are the centers of the squares on the
         * diagonal just outside the bull's eye.
         */ sampleGrid(image, topLeft, topRight, bottomRight, bottomLeft) {
            let sampler = GridSamplerInstance.getInstance();
            let dimension = this.getDimension();
            let low = dimension / 2 - this.nbCenterLayers;
            let high = dimension / 2 + this.nbCenterLayers;
            return sampler.sampleGrid(image, dimension, dimension, low, low, high, low, high, high, low, high, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
        }
        /**
         * Samples a line.
         *
         * @param p1   start point (inclusive)
         * @param p2   end point (exclusive)
         * @param size number of bits
         * @return the array of bits as an int (first bit is high-order bit of result)
         */ sampleLine(p1, p2, size) {
            let result = 0;
            let d = this.distanceResultPoint(p1, p2);
            let moduleSize = d / size;
            let px = p1.getX();
            let py = p1.getY();
            let dx = moduleSize * (p2.getX() - p1.getX()) / d;
            let dy = moduleSize * (p2.getY() - p1.getY()) / d;
            for(let i = 0; i < size; i++)if (this.image.get(MathUtils.round(px + i * dx), MathUtils.round(py + i * dy))) result |= 1 << size - i - 1;
            return result;
        }
        /**
         * @return true if the border of the rectangle passed in parameter is compound of white points only
         *         or black points only
         */ isWhiteOrBlackRectangle(p1, p2, p3, p4) {
            let corr = 3;
            p1 = new Point(p1.getX() - corr, p1.getY() + corr);
            p2 = new Point(p2.getX() - corr, p2.getY() - corr);
            p3 = new Point(p3.getX() + corr, p3.getY() - corr);
            p4 = new Point(p4.getX() + corr, p4.getY() + corr);
            let cInit = this.getColor(p4, p1);
            if (cInit === 0) return false;
            let c = this.getColor(p1, p2);
            if (c !== cInit) return false;
            c = this.getColor(p2, p3);
            if (c !== cInit) return false;
            c = this.getColor(p3, p4);
            return c === cInit;
        }
        /**
         * Gets the color of a segment
         *
         * @return 1 if segment more than 90% black, -1 if segment is more than 90% white, 0 else
         */ getColor(p1, p2) {
            let d = this.distancePoint(p1, p2);
            let dx = (p2.getX() - p1.getX()) / d;
            let dy = (p2.getY() - p1.getY()) / d;
            let error = 0;
            let px = p1.getX();
            let py = p1.getY();
            let colorModel = this.image.get(p1.getX(), p1.getY());
            let iMax = Math.ceil(d);
            for(let i = 0; i < iMax; i++){
                px += dx;
                py += dy;
                if (this.image.get(MathUtils.round(px), MathUtils.round(py)) !== colorModel) error++;
            }
            let errRatio = error / d;
            if (errRatio > 0.1 && errRatio < 0.9) return 0;
            return errRatio <= 0.1 === colorModel ? 1 : -1;
        }
        /**
         * Gets the coordinate of the first point with a different color in the given direction
         */ getFirstDifferent(init, color, dx, dy) {
            let x = init.getX() + dx;
            let y = init.getY() + dy;
            while(this.isValid(x, y) && this.image.get(x, y) === color){
                x += dx;
                y += dy;
            }
            x -= dx;
            y -= dy;
            while(this.isValid(x, y) && this.image.get(x, y) === color)x += dx;
            x -= dx;
            while(this.isValid(x, y) && this.image.get(x, y) === color)y += dy;
            y -= dy;
            return new Point(x, y);
        }
        /**
         * Expand the square represented by the corner points by pushing out equally in all directions
         *
         * @param cornerPoints the corners of the square, which has the bull's eye at its center
         * @param oldSide the original length of the side of the square in the target bit matrix
         * @param newSide the new length of the size of the square in the target bit matrix
         * @return the corners of the expanded square
         */ expandSquare(cornerPoints, oldSide, newSide) {
            let ratio = newSide / (2.0 * oldSide);
            let dx = cornerPoints[0].getX() - cornerPoints[2].getX();
            let dy = cornerPoints[0].getY() - cornerPoints[2].getY();
            let centerx = (cornerPoints[0].getX() + cornerPoints[2].getX()) / 2.0;
            let centery = (cornerPoints[0].getY() + cornerPoints[2].getY()) / 2.0;
            let result0 = new ResultPoint(centerx + ratio * dx, centery + ratio * dy);
            let result2 = new ResultPoint(centerx - ratio * dx, centery - ratio * dy);
            dx = cornerPoints[1].getX() - cornerPoints[3].getX();
            dy = cornerPoints[1].getY() - cornerPoints[3].getY();
            centerx = (cornerPoints[1].getX() + cornerPoints[3].getX()) / 2.0;
            centery = (cornerPoints[1].getY() + cornerPoints[3].getY()) / 2.0;
            let result1 = new ResultPoint(centerx + ratio * dx, centery + ratio * dy);
            let result3 = new ResultPoint(centerx - ratio * dx, centery - ratio * dy);
            let results = [
                result0,
                result1,
                result2,
                result3
            ];
            return results;
        }
        isValid(x, y) {
            return x >= 0 && x < this.image.getWidth() && y > 0 && y < this.image.getHeight();
        }
        isValidPoint(point) {
            let x = MathUtils.round(point.getX());
            let y = MathUtils.round(point.getY());
            return this.isValid(x, y);
        }
        distancePoint(a, b) {
            return MathUtils.distance(a.getX(), a.getY(), b.getX(), b.getY());
        }
        distanceResultPoint(a, b) {
            return MathUtils.distance(a.getX(), a.getY(), b.getX(), b.getY());
        }
        getDimension() {
            if (this.compact) return 4 * this.nbLayers + 11;
            if (this.nbLayers <= 4) return 4 * this.nbLayers + 15;
            return 4 * this.nbLayers + 2 * (Integer.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.List;
    // import java.util.Map;
    /**
     * This implementation can detect and decode Aztec codes in an image.
     *
     * @author David Olivier
     */ class AztecReader {
        /**
         * Locates and decodes a Data Matrix code in an image.
         *
         * @return a String representing the content encoded by the Data Matrix code
         * @throws NotFoundException if a Data Matrix code cannot be found
         * @throws FormatException if a Data Matrix code cannot be decoded
         */ decode(image, hints = null) {
            let exception = null;
            let detector = new Detector(image.getBlackMatrix());
            let points = null;
            let decoderResult = null;
            try {
                let detectorResult = detector.detectMirror(false);
                points = detectorResult.getPoints();
                this.reportFoundResultPoints(hints, points);
                decoderResult = new Decoder().decode(detectorResult);
            } catch (e) {
                exception = e;
            }
            if (decoderResult == null) try {
                let detectorResult = detector.detectMirror(true);
                points = detectorResult.getPoints();
                this.reportFoundResultPoints(hints, points);
                decoderResult = new Decoder().decode(detectorResult);
            } catch (e) {
                if (exception != null) throw exception;
                throw e;
            }
            let result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), decoderResult.getNumBits(), points, BarcodeFormat$1.AZTEC, System.currentTimeMillis());
            let byteSegments = decoderResult.getByteSegments();
            if (byteSegments != null) result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            let ecLevel = decoderResult.getECLevel();
            if (ecLevel != null) result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            return result;
        }
        reportFoundResultPoints(hints, points) {
            if (hints != null) {
                let rpcb = hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                if (rpcb != null) points.forEach((point, idx, arr)=>{
                    rpcb.foundPossibleResultPoint(point);
                });
            }
        }
        // @Override
        reset() {
        // do nothing
        }
    }
    /**
     * Aztec Code reader to use from browser.
     *
     * @class BrowserAztecCodeReader
     * @extends {BrowserCodeReader}
     */ class BrowserAztecCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserAztecCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         *
         * @memberOf BrowserAztecCodeReader
         */ constructor(timeBetweenScansMillis = 500){
            super(new AztecReader(), timeBetweenScansMillis);
        }
    }
    /**
     * Encapsulates functionality and implementation that is common to all families
     * of one-dimensional barcodes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     */ class OneDReader {
        /*
        @Override
        public Result decode(BinaryBitmap image) throws NotFoundException, FormatException {
          return decode(image, null);
        }
        */ // Note that we don't try rotation without the try harder flag, even if rotation was supported.
        // @Override
        decode(image, hints) {
            try {
                return this.doDecode(image, hints);
            } catch (nfe) {
                const tryHarder = hints && hints.get(DecodeHintType$1.TRY_HARDER) === true;
                if (tryHarder && image.isRotateSupported()) {
                    const rotatedImage = image.rotateCounterClockwise();
                    const result = this.doDecode(rotatedImage, hints);
                    // Record that we found it rotated 90 degrees CCW / 270 degrees CW
                    const metadata = result.getResultMetadata();
                    let orientation = 270;
                    if (metadata !== null && metadata.get(ResultMetadataType$1.ORIENTATION) === true) // But if we found it reversed in doDecode(), add in that result here:
                    orientation = orientation + metadata.get(ResultMetadataType$1.ORIENTATION) % 360;
                    result.putMetadata(ResultMetadataType$1.ORIENTATION, orientation);
                    // Update result points
                    const points = result.getResultPoints();
                    if (points !== null) {
                        const height = rotatedImage.getHeight();
                        for(let i = 0; i < points.length; i++)points[i] = new ResultPoint(height - points[i].getY() - 1, points[i].getX());
                    }
                    return result;
                } else throw new NotFoundException();
            }
        }
        // @Override
        reset() {
        // do nothing
        }
        /**
         * We're going to examine rows from the middle outward, searching alternately above and below the
         * middle, and farther out each time. rowStep is the number of rows between each successive
         * attempt above and below the middle. So we'd scan row middle, then middle - rowStep, then
         * middle + rowStep, then middle - (2 * rowStep), etc.
         * rowStep is bigger as the image is taller, but is always at least 1. We've somewhat arbitrarily
         * decided that moving up and down by about 1/16 of the image is pretty good; we try more of the
         * image if "trying harder".
         *
         * @param image The image to decode
         * @param hints Any hints that were requested
         * @return The contents of the decoded barcode
         * @throws NotFoundException Any spontaneous errors which occur
         */ doDecode(image, hints) {
            const width = image.getWidth();
            const height = image.getHeight();
            let row = new BitArray(width);
            const tryHarder = hints && hints.get(DecodeHintType$1.TRY_HARDER) === true;
            const rowStep = Math.max(1, height >> (tryHarder ? 8 : 5));
            let maxLines;
            if (tryHarder) maxLines = height; // Look at the whole image, not just the center
            else maxLines = 15; // 15 rows spaced 1/32 apart is roughly the middle half of the image
            const middle = Math.trunc(height / 2);
            for(let x = 0; x < maxLines; x++){
                // Scanning from the middle out. Determine which row we're looking at next:
                const rowStepsAboveOrBelow = Math.trunc((x + 1) / 2);
                const isAbove = (x & 0x01) === 0; // i.e. is x even?
                const rowNumber = middle + rowStep * (isAbove ? rowStepsAboveOrBelow : -rowStepsAboveOrBelow);
                if (rowNumber < 0 || rowNumber >= height) break;
                // Estimate black point for this row and load it:
                try {
                    row = image.getBlackRow(rowNumber, row);
                } catch (ignored) {
                    continue;
                }
                // While we have the image data in a BitArray, it's fairly cheap to reverse it in place to
                // handle decoding upside down barcodes.
                for(let attempt = 0; attempt < 2; attempt++){
                    if (attempt === 1) {
                        row.reverse(); // reverse the row and continue
                        // This means we will only ever draw result points *once* in the life of this method
                        // since we want to avoid drawing the wrong points after flipping the row, and,
                        // don't want to clutter with noise from every single row scan -- just the scans
                        // that start on the center line.
                        if (hints && hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK) === true) {
                            const newHints = new Map();
                            hints.forEach((hint, key)=>newHints.set(key, hint));
                            newHints.delete(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                            hints = newHints;
                        }
                    }
                    try {
                        // Look for a barcode
                        const result = this.decodeRow(rowNumber, row, hints);
                        // We found our barcode
                        if (attempt === 1) {
                            // But it was upside down, so note that
                            result.putMetadata(ResultMetadataType$1.ORIENTATION, 180);
                            // And remember to flip the result points horizontally.
                            const points = result.getResultPoints();
                            if (points !== null) {
                                points[0] = new ResultPoint(width - points[0].getX() - 1, points[0].getY());
                                points[1] = new ResultPoint(width - points[1].getX() - 1, points[1].getY());
                            }
                        }
                        return result;
                    } catch (re) {
                    // continue -- just couldn't decode this row
                    }
                }
            }
            throw new NotFoundException();
        }
        /**
         * Records the size of successive runs of white and black pixels in a row, starting at a given point.
         * The values are recorded in the given array, and the number of runs recorded is equal to the size
         * of the array. If the row starts on a white pixel at the given start point, then the first count
         * recorded is the run of white pixels starting from that point; likewise it is the count of a run
         * of black pixels if the row begin on a black pixels at that point.
         *
         * @param row row to count from
         * @param start offset into row to start at
         * @param counters array into which to record counts
         * @throws NotFoundException if counters cannot be filled entirely from row before running out
         *  of pixels
         */ static recordPattern(row, start, counters) {
            const numCounters = counters.length;
            for(let index = 0; index < numCounters; index++)counters[index] = 0;
            const end = row.getSize();
            if (start >= end) throw new NotFoundException();
            let isWhite = !row.get(start);
            let counterPosition = 0;
            let i = start;
            while(i < end){
                if (row.get(i) !== isWhite) counters[counterPosition]++;
                else {
                    if (++counterPosition === numCounters) break;
                    else {
                        counters[counterPosition] = 1;
                        isWhite = !isWhite;
                    }
                }
                i++;
            }
            // If we read fully the last section of pixels and filled up our counters -- or filled
            // the last counter but ran off the side of the image, OK. Otherwise, a problem.
            if (!(counterPosition === numCounters || counterPosition === numCounters - 1 && i === end)) throw new NotFoundException();
        }
        static recordPatternInReverse(row, start, counters) {
            // This could be more efficient I guess
            let numTransitionsLeft = counters.length;
            let last = row.get(start);
            while(start > 0 && numTransitionsLeft >= 0)if (row.get(--start) !== last) {
                numTransitionsLeft--;
                last = !last;
            }
            if (numTransitionsLeft >= 0) throw new NotFoundException();
            OneDReader.recordPattern(row, start + 1, counters);
        }
        /**
         * Determines how closely a set of observed counts of runs of black/white values matches a given
         * target pattern. This is reported as the ratio of the total variance from the expected pattern
         * proportions across all pattern elements, to the length of the pattern.
         *
         * @param counters observed counters
         * @param pattern expected pattern
         * @param maxIndividualVariance The most any counter can differ before we give up
         * @return ratio of total variance between counters and pattern compared to total pattern size
         */ static patternMatchVariance(counters, pattern, maxIndividualVariance) {
            const numCounters = counters.length;
            let total = 0;
            let patternLength = 0;
            for(let i = 0; i < numCounters; i++){
                total += counters[i];
                patternLength += pattern[i];
            }
            if (total < patternLength) // If we don't even have one pixel per unit of bar width, assume this is too small
            // to reliably match, so fail:
            return Number.POSITIVE_INFINITY;
            const unitBarWidth = total / patternLength;
            maxIndividualVariance *= unitBarWidth;
            let totalVariance = 0.0;
            for(let x = 0; x < numCounters; x++){
                const counter = counters[x];
                const scaledPattern = pattern[x] * unitBarWidth;
                const variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
                if (variance > maxIndividualVariance) return Number.POSITIVE_INFINITY;
                totalVariance += variance;
            }
            return totalVariance / total;
        }
    }
    /**
     * <p>Decodes Code 128 barcodes.</p>
     *
     * @author Sean Owen
     */ class Code128Reader extends OneDReader {
        static findStartPattern(row) {
            const width = row.getSize();
            const rowOffset = row.getNextSet(0);
            let counterPosition = 0;
            let counters = Int32Array.from([
                0,
                0,
                0,
                0,
                0,
                0
            ]);
            let patternStart = rowOffset;
            let isWhite = false;
            const patternLength = 6;
            for(let i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    let bestVariance = Code128Reader.MAX_AVG_VARIANCE;
                    let bestMatch = -1;
                    for(let startCode = Code128Reader.CODE_START_A; startCode <= Code128Reader.CODE_START_C; startCode++){
                        const variance = OneDReader.patternMatchVariance(counters, Code128Reader.CODE_PATTERNS[startCode], Code128Reader.MAX_INDIVIDUAL_VARIANCE);
                        if (variance < bestVariance) {
                            bestVariance = variance;
                            bestMatch = startCode;
                        }
                    }
                    // Look for whitespace before start pattern, >= 50% of width of start pattern
                    if (bestMatch >= 0 && row.isRange(Math.max(0, patternStart - (i - patternStart) / 2), patternStart, false)) return Int32Array.from([
                        patternStart,
                        i,
                        bestMatch
                    ]);
                    patternStart += counters[0] + counters[1];
                    counters = counters.slice(2, counters.length - 1);
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        static decodeCode(row, counters, rowOffset) {
            OneDReader.recordPattern(row, rowOffset, counters);
            let bestVariance = Code128Reader.MAX_AVG_VARIANCE; // worst variance we'll accept
            let bestMatch = -1;
            for(let d = 0; d < Code128Reader.CODE_PATTERNS.length; d++){
                const pattern = Code128Reader.CODE_PATTERNS[d];
                const variance = this.patternMatchVariance(counters, pattern, Code128Reader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = d;
                }
            }
            // TODO We're overlooking the fact that the STOP pattern has 7 values, not 6.
            if (bestMatch >= 0) return bestMatch;
            else throw new NotFoundException();
        }
        decodeRow(rowNumber, row, hints) {
            const convertFNC1 = hints && hints.get(DecodeHintType$1.ASSUME_GS1) === true;
            const startPatternInfo = Code128Reader.findStartPattern(row);
            const startCode = startPatternInfo[2];
            let currentRawCodesIndex = 0;
            const rawCodes = new Uint8Array(20);
            rawCodes[currentRawCodesIndex++] = startCode;
            let codeSet;
            switch(startCode){
                case Code128Reader.CODE_START_A:
                    codeSet = Code128Reader.CODE_CODE_A;
                    break;
                case Code128Reader.CODE_START_B:
                    codeSet = Code128Reader.CODE_CODE_B;
                    break;
                case Code128Reader.CODE_START_C:
                    codeSet = Code128Reader.CODE_CODE_C;
                    break;
                default:
                    throw new FormatException();
            }
            let done = false;
            let isNextShifted = false;
            let result = '';
            let lastStart = startPatternInfo[0];
            let nextStart = startPatternInfo[1];
            const counters = Int32Array.from([
                0,
                0,
                0,
                0,
                0,
                0
            ]);
            let lastCode = 0;
            let code = 0;
            let checksumTotal = startCode;
            let multiplier = 0;
            let lastCharacterWasPrintable = true;
            let upperMode = false;
            let shiftUpperMode = false;
            while(!done){
                const unshift = isNextShifted;
                isNextShifted = false;
                // Save off last code
                lastCode = code;
                // Decode another code from image
                code = Code128Reader.decodeCode(row, counters, nextStart);
                rawCodes[currentRawCodesIndex++] = code;
                // Remember whether the last code was printable or not (excluding CODE_STOP)
                if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = true;
                // Add to checksum computation (if not CODE_STOP of course)
                if (code !== Code128Reader.CODE_STOP) {
                    multiplier++;
                    checksumTotal += multiplier * code;
                }
                // Advance to where the next code will to start
                lastStart = nextStart;
                nextStart += counters.reduce((previous, current)=>previous + current, 0);
                // Take care of illegal start codes
                switch(code){
                    case Code128Reader.CODE_START_A:
                    case Code128Reader.CODE_START_B:
                    case Code128Reader.CODE_START_C:
                        throw new FormatException();
                }
                switch(codeSet){
                    case Code128Reader.CODE_CODE_A:
                        if (code < 64) {
                            if (shiftUpperMode === upperMode) result += String.fromCharCode(' '.charCodeAt(0) + code);
                            else result += String.fromCharCode(' '.charCodeAt(0) + code + 128);
                            shiftUpperMode = false;
                        } else if (code < 96) {
                            if (shiftUpperMode === upperMode) result += String.fromCharCode(code - 64);
                            else result += String.fromCharCode(code + 64);
                            shiftUpperMode = false;
                        } else {
                            // Don't let CODE_STOP, which always appears, affect whether whether we think the last
                            // code was printable or not.
                            if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                            switch(code){
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                        // is FNC1 then this is GS1-128. We add the symbology identifier.
                                        result += ']C1';
                                        else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                        result += String.fromCharCode(29);
                                    }
                                    break;
                                case Code128Reader.CODE_FNC_2:
                                case Code128Reader.CODE_FNC_3:
                                    break;
                                case Code128Reader.CODE_FNC_4_A:
                                    if (!upperMode && shiftUpperMode) {
                                        upperMode = true;
                                        shiftUpperMode = false;
                                    } else if (upperMode && shiftUpperMode) {
                                        upperMode = false;
                                        shiftUpperMode = false;
                                    } else shiftUpperMode = true;
                                    break;
                                case Code128Reader.CODE_SHIFT:
                                    isNextShifted = true;
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_CODE_B:
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_CODE_C:
                                    codeSet = Code128Reader.CODE_CODE_C;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                    case Code128Reader.CODE_CODE_B:
                        if (code < 96) {
                            if (shiftUpperMode === upperMode) result += String.fromCharCode(' '.charCodeAt(0) + code);
                            else result += String.fromCharCode(' '.charCodeAt(0) + code + 128);
                            shiftUpperMode = false;
                        } else {
                            if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                            switch(code){
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                        // is FNC1 then this is GS1-128. We add the symbology identifier.
                                        result += ']C1';
                                        else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                        result += String.fromCharCode(29);
                                    }
                                    break;
                                case Code128Reader.CODE_FNC_2:
                                case Code128Reader.CODE_FNC_3:
                                    break;
                                case Code128Reader.CODE_FNC_4_B:
                                    if (!upperMode && shiftUpperMode) {
                                        upperMode = true;
                                        shiftUpperMode = false;
                                    } else if (upperMode && shiftUpperMode) {
                                        upperMode = false;
                                        shiftUpperMode = false;
                                    } else shiftUpperMode = true;
                                    break;
                                case Code128Reader.CODE_SHIFT:
                                    isNextShifted = true;
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_A:
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_C:
                                    codeSet = Code128Reader.CODE_CODE_C;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                    case Code128Reader.CODE_CODE_C:
                        if (code < 100) {
                            if (code < 10) result += '0';
                            result += code;
                        } else {
                            if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                            switch(code){
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                        // is FNC1 then this is GS1-128. We add the symbology identifier.
                                        result += ']C1';
                                        else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                        result += String.fromCharCode(29);
                                    }
                                    break;
                                case Code128Reader.CODE_CODE_A:
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_B:
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                }
                // Unshift back to another code set if we were shifted
                if (unshift) codeSet = codeSet === Code128Reader.CODE_CODE_A ? Code128Reader.CODE_CODE_B : Code128Reader.CODE_CODE_A;
            }
            const lastPatternSize = nextStart - lastStart;
            // Check for ample whitespace following pattern, but, to do this we first need to remember that
            // we fudged decoding CODE_STOP since it actually has 7 bars, not 6. There is a black bar left
            // to read off. Would be slightly better to properly read. Here we just skip it:
            nextStart = row.getNextUnset(nextStart);
            if (!row.isRange(nextStart, Math.min(row.getSize(), nextStart + (nextStart - lastStart) / 2), false)) throw new NotFoundException();
            // Pull out from sum the value of the penultimate check code
            checksumTotal -= multiplier * lastCode;
            // lastCode is the checksum then:
            if (checksumTotal % 103 !== lastCode) throw new ChecksumException();
            // Need to pull out the check digits from string
            const resultLength = result.length;
            if (resultLength === 0) // false positive
            throw new NotFoundException();
            // Only bother if the result had at least one character, and if the checksum digit happened to
            // be a printable character. If it was just interpreted as a control code, nothing to remove.
            if (resultLength > 0 && lastCharacterWasPrintable) {
                if (codeSet === Code128Reader.CODE_CODE_C) result = result.substring(0, resultLength - 2);
                else result = result.substring(0, resultLength - 1);
            }
            const left = (startPatternInfo[1] + startPatternInfo[0]) / 2.0;
            const right = lastStart + lastPatternSize / 2.0;
            const rawCodesSize = rawCodes.length;
            const rawBytes = new Uint8Array(rawCodesSize);
            for(let i = 0; i < rawCodesSize; i++)rawBytes[i] = rawCodes[i];
            const points = [
                new ResultPoint(left, rowNumber),
                new ResultPoint(right, rowNumber)
            ];
            return new Result(result, rawBytes, 0, points, BarcodeFormat$1.CODE_128, new Date().getTime());
        }
    }
    Code128Reader.CODE_PATTERNS = [
        Int32Array.from([
            2,
            1,
            2,
            2,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            2,
            3
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3,
            2,
            2
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            1,
            3
        ]),
        Int32Array.from([
            1,
            2,
            2,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            2,
            2,
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            2,
            3,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            2,
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            3,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            2,
            3
        ]),
        Int32Array.from([
            2,
            1,
            2,
            3,
            2,
            1
        ]),
        Int32Array.from([
            2,
            3,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            3,
            3
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            3,
            3,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            3,
            1,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            4,
            3,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2,
            4
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2,
            4
        ]),
        Int32Array.from([
            1,
            2,
            1,
            4,
            2,
            1
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            1,
            4
        ]),
        Int32Array.from([
            1,
            1,
            2,
            4,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            2,
            2,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            4,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            4,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            4,
            1,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            2,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            4,
            1
        ]),
        Int32Array.from([
            2,
            1,
            4,
            1,
            2,
            1
        ]),
        Int32Array.from([
            4,
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            4,
            3
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            4,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            1,
            4,
            3,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            4,
            1,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            4,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1,
            4
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            3,
            2
        ]),
        Int32Array.from([
            2,
            3,
            3,
            1,
            1,
            1,
            2
        ])
    ];
    Code128Reader.MAX_AVG_VARIANCE = 0.25;
    Code128Reader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    Code128Reader.CODE_SHIFT = 98;
    Code128Reader.CODE_CODE_C = 99;
    Code128Reader.CODE_CODE_B = 100;
    Code128Reader.CODE_CODE_A = 101;
    Code128Reader.CODE_FNC_1 = 102;
    Code128Reader.CODE_FNC_2 = 97;
    Code128Reader.CODE_FNC_3 = 96;
    Code128Reader.CODE_FNC_4_A = 101;
    Code128Reader.CODE_FNC_4_B = 100;
    Code128Reader.CODE_START_A = 103;
    Code128Reader.CODE_START_B = 104;
    Code128Reader.CODE_START_C = 105;
    Code128Reader.CODE_STOP = 106;
    /**
     * <p>Decodes Code 39 barcodes. Supports "Full ASCII Code 39" if USE_CODE_39_EXTENDED_MODE is set.</p>
     *
     * @author Sean Owen
     * @see Code93Reader
     */ class Code39Reader extends OneDReader {
        /**
         * Creates a reader that assumes all encoded data is data, and does not treat the final
         * character as a check digit. It will not decoded "extended Code 39" sequences.
         */ // public Code39Reader() {
        //   this(false);
        // }
        /**
         * Creates a reader that can be configured to check the last character as a check digit.
         * It will not decoded "extended Code 39" sequences.
         *
         * @param usingCheckDigit if true, treat the last data character as a check digit, not
         * data, and verify that the checksum passes.
         */ // public Code39Reader(boolean usingCheckDigit) {
        //   this(usingCheckDigit, false);
        // }
        /**
         * Creates a reader that can be configured to check the last character as a check digit,
         * or optionally attempt to decode "extended Code 39" sequences that are used to encode
         * the full ASCII character set.
         *
         * @param usingCheckDigit if true, treat the last data character as a check digit, not
         * data, and verify that the checksum passes.
         * @param extendedMode if true, will attempt to decode extended Code 39 sequences in the
         * text.
         */ constructor(usingCheckDigit = false, extendedMode = false){
            super();
            this.usingCheckDigit = usingCheckDigit;
            this.extendedMode = extendedMode;
            this.decodeRowResult = '';
            this.counters = new Int32Array(9);
        }
        decodeRow(rowNumber, row, hints) {
            let theCounters = this.counters;
            theCounters.fill(0);
            this.decodeRowResult = '';
            let start = Code39Reader.findAsteriskPattern(row, theCounters);
            // Read off white space
            let nextStart = row.getNextSet(start[1]);
            let end = row.getSize();
            let decodedChar;
            let lastStart;
            do {
                Code39Reader.recordPattern(row, nextStart, theCounters);
                let pattern = Code39Reader.toNarrowWidePattern(theCounters);
                if (pattern < 0) throw new NotFoundException();
                decodedChar = Code39Reader.patternToChar(pattern);
                this.decodeRowResult += decodedChar;
                lastStart = nextStart;
                for (let counter of theCounters)nextStart += counter;
                // Read off white space
                nextStart = row.getNextSet(nextStart);
            }while (decodedChar !== '*');
            this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1); // remove asterisk
            // Look for whitespace after pattern:
            let lastPatternSize = 0;
            for (let counter of theCounters)lastPatternSize += counter;
            let whiteSpaceAfterEnd = nextStart - lastStart - lastPatternSize;
            // If 50% of last pattern size, following last pattern, is not whitespace, fail
            // (but if it's whitespace to the very end of the image, that's OK)
            if (nextStart !== end && whiteSpaceAfterEnd * 2 < lastPatternSize) throw new NotFoundException();
            if (this.usingCheckDigit) {
                let max = this.decodeRowResult.length - 1;
                let total = 0;
                for(let i = 0; i < max; i++)total += Code39Reader.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(i));
                if (this.decodeRowResult.charAt(max) !== Code39Reader.ALPHABET_STRING.charAt(total % 43)) throw new ChecksumException();
                this.decodeRowResult = this.decodeRowResult.substring(0, max);
            }
            if (this.decodeRowResult.length === 0) // false positive
            throw new NotFoundException();
            let resultString;
            if (this.extendedMode) resultString = Code39Reader.decodeExtended(this.decodeRowResult);
            else resultString = this.decodeRowResult;
            let left = (start[1] + start[0]) / 2.0;
            let right = lastStart + lastPatternSize / 2.0;
            return new Result(resultString, null, 0, [
                new ResultPoint(left, rowNumber),
                new ResultPoint(right, rowNumber)
            ], BarcodeFormat$1.CODE_39, new Date().getTime());
        }
        static findAsteriskPattern(row, counters) {
            let width = row.getSize();
            let rowOffset = row.getNextSet(0);
            let counterPosition = 0;
            let patternStart = rowOffset;
            let isWhite = false;
            let patternLength = counters.length;
            for(let i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    // Look for whitespace before start pattern, >= 50% of width of start pattern
                    if (this.toNarrowWidePattern(counters) === Code39Reader.ASTERISK_ENCODING && row.isRange(Math.max(0, patternStart - Math.floor((i - patternStart) / 2)), patternStart, false)) return [
                        patternStart,
                        i
                    ];
                    patternStart += counters[0] + counters[1];
                    counters.copyWithin(0, 2, 2 + counterPosition - 1);
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        // For efficiency, returns -1 on failure. Not throwing here saved as many as 700 exceptions
        // per image when using some of our blackbox images.
        static toNarrowWidePattern(counters) {
            let numCounters = counters.length;
            let maxNarrowCounter = 0;
            let wideCounters;
            do {
                let minCounter = 0x7fffffff;
                for (let counter of counters)if (counter < minCounter && counter > maxNarrowCounter) minCounter = counter;
                maxNarrowCounter = minCounter;
                wideCounters = 0;
                let totalWideCountersWidth = 0;
                let pattern = 0;
                for(let i = 0; i < numCounters; i++){
                    let counter = counters[i];
                    if (counter > maxNarrowCounter) {
                        pattern |= 1 << numCounters - 1 - i;
                        wideCounters++;
                        totalWideCountersWidth += counter;
                    }
                }
                if (wideCounters === 3) {
                    // Found 3 wide counters, but are they close enough in width?
                    // We can perform a cheap, conservative check to see if any individual
                    // counter is more than 1.5 times the average:
                    for(let i = 0; i < numCounters && wideCounters > 0; i++){
                        let counter = counters[i];
                        if (counter > maxNarrowCounter) {
                            wideCounters--;
                            // totalWideCountersWidth = 3 * average, so this checks if counter >= 3/2 * average
                            if (counter * 2 >= totalWideCountersWidth) return -1;
                        }
                    }
                    return pattern;
                }
            }while (wideCounters > 3);
            return -1;
        }
        static patternToChar(pattern) {
            for(let i = 0; i < Code39Reader.CHARACTER_ENCODINGS.length; i++){
                if (Code39Reader.CHARACTER_ENCODINGS[i] === pattern) return Code39Reader.ALPHABET_STRING.charAt(i);
            }
            if (pattern === Code39Reader.ASTERISK_ENCODING) return '*';
            throw new NotFoundException();
        }
        static decodeExtended(encoded) {
            let length = encoded.length;
            let decoded = '';
            for(let i = 0; i < length; i++){
                let c = encoded.charAt(i);
                if (c === '+' || c === '$' || c === '%' || c === '/') {
                    let next = encoded.charAt(i + 1);
                    let decodedChar = '\0';
                    switch(c){
                        case '+':
                            // +A to +Z map to a to z
                            if (next >= 'A' && next <= 'Z') decodedChar = String.fromCharCode(next.charCodeAt(0) + 32);
                            else throw new FormatException();
                            break;
                        case '$':
                            // $A to $Z map to control codes SH to SB
                            if (next >= 'A' && next <= 'Z') decodedChar = String.fromCharCode(next.charCodeAt(0) - 64);
                            else throw new FormatException();
                            break;
                        case '%':
                            // %A to %E map to control codes ESC to US
                            if (next >= 'A' && next <= 'E') decodedChar = String.fromCharCode(next.charCodeAt(0) - 38);
                            else if (next >= 'F' && next <= 'J') decodedChar = String.fromCharCode(next.charCodeAt(0) - 11);
                            else if (next >= 'K' && next <= 'O') decodedChar = String.fromCharCode(next.charCodeAt(0) + 16);
                            else if (next >= 'P' && next <= 'T') decodedChar = String.fromCharCode(next.charCodeAt(0) + 43);
                            else if (next === 'U') decodedChar = '\0';
                            else if (next === 'V') decodedChar = '@';
                            else if (next === 'W') decodedChar = '`';
                            else if (next === 'X' || next === 'Y' || next === 'Z') decodedChar = '\x7f';
                            else throw new FormatException();
                            break;
                        case '/':
                            // /A to /O map to ! to , and /Z maps to :
                            if (next >= 'A' && next <= 'O') decodedChar = String.fromCharCode(next.charCodeAt(0) - 32);
                            else if (next === 'Z') decodedChar = ':';
                            else throw new FormatException();
                            break;
                    }
                    decoded += decodedChar;
                    // bump up i again since we read two characters
                    i++;
                } else decoded += c;
            }
            return decoded;
        }
    }
    Code39Reader.ALPHABET_STRING = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%';
    /**
     * These represent the encodings of characters, as patterns of wide and narrow bars.
     * The 9 least-significant bits of each int correspond to the pattern of wide and narrow,
     * with 1s representing "wide" and 0s representing narrow.
     */ Code39Reader.CHARACTER_ENCODINGS = [
        0x034,
        0x121,
        0x061,
        0x160,
        0x031,
        0x130,
        0x070,
        0x025,
        0x124,
        0x064,
        0x109,
        0x049,
        0x148,
        0x019,
        0x118,
        0x058,
        0x00D,
        0x10C,
        0x04C,
        0x01C,
        0x103,
        0x043,
        0x142,
        0x013,
        0x112,
        0x052,
        0x007,
        0x106,
        0x046,
        0x016,
        0x181,
        0x0C1,
        0x1C0,
        0x091,
        0x190,
        0x0D0,
        0x085,
        0x184,
        0x0C4,
        0x0A8,
        0x0A2,
        0x08A,
        0x02A // /-%
    ];
    Code39Reader.ASTERISK_ENCODING = 0x094;
    /**
     * <p>Decodes ITF barcodes.</p>
     *
     * @author Tjieco
     */ class ITFReader extends OneDReader {
        constructor(){
            // private static W = 3; // Pixel width of a 3x wide line
            // private static w = 2; // Pixel width of a 2x wide line
            // private static N = 1; // Pixed width of a narrow line
            super(...arguments);
            // Stores the actual narrow line width of the image being decoded.
            this.narrowLineWidth = -1;
        }
        // See ITFWriter.PATTERNS
        /*
      
        /!**
         * Patterns of Wide / Narrow lines to indicate each digit
         *!/
        */ decodeRow(rowNumber, row, hints) {
            // Find out where the Middle section (payload) starts & ends
            let startRange = this.decodeStart(row);
            let endRange = this.decodeEnd(row);
            let result = new StringBuilder();
            ITFReader.decodeMiddle(row, startRange[1], endRange[0], result);
            let resultString = result.toString();
            let allowedLengths = null;
            if (hints != null) allowedLengths = hints.get(DecodeHintType$1.ALLOWED_LENGTHS);
            if (allowedLengths == null) allowedLengths = ITFReader.DEFAULT_ALLOWED_LENGTHS;
            // To avoid false positives with 2D barcodes (and other patterns), make
            // an assumption that the decoded string must be a 'standard' length if it's short
            let length = resultString.length;
            let lengthOK = false;
            let maxAllowedLength = 0;
            for (let value of allowedLengths){
                if (length === value) {
                    lengthOK = true;
                    break;
                }
                if (value > maxAllowedLength) maxAllowedLength = value;
            }
            if (!lengthOK && length > maxAllowedLength) lengthOK = true;
            if (!lengthOK) throw new FormatException();
            const points = [
                new ResultPoint(startRange[1], rowNumber),
                new ResultPoint(endRange[0], rowNumber)
            ];
            let resultReturn = new Result(resultString, null, 0, points, BarcodeFormat$1.ITF, new Date().getTime());
            return resultReturn;
        }
        /*
        /!**
         * @param row          row of black/white values to search
         * @param payloadStart offset of start pattern
         * @param resultString {@link StringBuilder} to append decoded chars to
         * @throws NotFoundException if decoding could not complete successfully
         *!/*/ static decodeMiddle(row, payloadStart, payloadEnd, resultString) {
            // Digits are interleaved in pairs - 5 black lines for one digit, and the
            // 5
            // interleaved white lines for the second digit.
            // Therefore, need to scan 10 lines and then
            // split these into two arrays
            let counterDigitPair = new Int32Array(10); // 10
            let counterBlack = new Int32Array(5); // 5
            let counterWhite = new Int32Array(5); // 5
            counterDigitPair.fill(0);
            counterBlack.fill(0);
            counterWhite.fill(0);
            while(payloadStart < payloadEnd){
                // Get 10 runs of black/white.
                OneDReader.recordPattern(row, payloadStart, counterDigitPair);
                // Split them into each array
                for(let k = 0; k < 5; k++){
                    let twoK = 2 * k;
                    counterBlack[k] = counterDigitPair[twoK];
                    counterWhite[k] = counterDigitPair[twoK + 1];
                }
                let bestMatch = ITFReader.decodeDigit(counterBlack);
                resultString.append(bestMatch.toString());
                bestMatch = this.decodeDigit(counterWhite);
                resultString.append(bestMatch.toString());
                counterDigitPair.forEach(function(counterDigit) {
                    payloadStart += counterDigit;
                });
            }
        }
        /*/!**
         * Identify where the start of the middle / payload section starts.
         *
         * @param row row of black/white values to search
         * @return Array, containing index of start of 'start block' and end of
         *         'start block'
         *!/*/ decodeStart(row) {
            let endStart = ITFReader.skipWhiteSpace(row);
            let startPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.START_PATTERN);
            // Determine the width of a narrow line in pixels. We can do this by
            // getting the width of the start pattern and dividing by 4 because its
            // made up of 4 narrow lines.
            this.narrowLineWidth = (startPattern[1] - startPattern[0]) / 4;
            this.validateQuietZone(row, startPattern[0]);
            return startPattern;
        }
        /*/!**
         * The start & end patterns must be pre/post fixed by a quiet zone. This
         * zone must be at least 10 times the width of a narrow line.  Scan back until
         * we either get to the start of the barcode or match the necessary number of
         * quiet zone pixels.
         *
         * Note: Its assumed the row is reversed when using this method to find
         * quiet zone after the end pattern.
         *
         * ref: http://www.barcode-1.net/i25code.html
         *
         * @param row bit array representing the scanned barcode.
         * @param startPattern index into row of the start or end pattern.
         * @throws NotFoundException if the quiet zone cannot be found
         *!/*/ validateQuietZone(row, startPattern) {
            let quietCount = this.narrowLineWidth * 10; // expect to find this many pixels of quiet zone
            // if there are not so many pixel at all let's try as many as possible
            quietCount = quietCount < startPattern ? quietCount : startPattern;
            for(let i = startPattern - 1; quietCount > 0 && i >= 0; i--){
                if (row.get(i)) break;
                quietCount--;
            }
            if (quietCount !== 0) // Unable to find the necessary number of quiet zone pixels.
            throw new NotFoundException();
        }
        /*
        /!**
         * Skip all whitespace until we get to the first black line.
         *
         * @param row row of black/white values to search
         * @return index of the first black line.
         * @throws NotFoundException Throws exception if no black lines are found in the row
         *!/*/ static skipWhiteSpace(row) {
            const width = row.getSize();
            const endStart = row.getNextSet(0);
            if (endStart === width) throw new NotFoundException();
            return endStart;
        }
        /*/!**
         * Identify where the end of the middle / payload section ends.
         *
         * @param row row of black/white values to search
         * @return Array, containing index of start of 'end block' and end of 'end
         *         block'
         *!/*/ decodeEnd(row) {
            // For convenience, reverse the row and then
            // search from 'the start' for the end block
            row.reverse();
            try {
                let endStart = ITFReader.skipWhiteSpace(row);
                let endPattern;
                try {
                    endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[0]);
                } catch (error) {
                    if (error instanceof NotFoundException) endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[1]);
                }
                // The start & end patterns must be pre/post fixed by a quiet zone. This
                // zone must be at least 10 times the width of a narrow line.
                // ref: http://www.barcode-1.net/i25code.html
                this.validateQuietZone(row, endPattern[0]);
                // Now recalculate the indices of where the 'endblock' starts & stops to
                // accommodate
                // the reversed nature of the search
                let temp = endPattern[0];
                endPattern[0] = row.getSize() - endPattern[1];
                endPattern[1] = row.getSize() - temp;
                return endPattern;
            } finally{
                // Put the row back the right way.
                row.reverse();
            }
        }
        /*
        /!**
         * @param row       row of black/white values to search
         * @param rowOffset position to start search
         * @param pattern   pattern of counts of number of black and white pixels that are
         *                  being searched for as a pattern
         * @return start/end horizontal offset of guard pattern, as an array of two
         *         ints
         * @throws NotFoundException if pattern is not found
         *!/*/ static findGuardPattern(row, rowOffset, pattern) {
            let patternLength = pattern.length;
            let counters = new Int32Array(patternLength);
            let width = row.getSize();
            let isWhite = false;
            let counterPosition = 0;
            let patternStart = rowOffset;
            counters.fill(0);
            for(let x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    if (OneDReader.patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE) < ITFReader.MAX_AVG_VARIANCE) return [
                        patternStart,
                        x
                    ];
                    patternStart += counters[0] + counters[1];
                    System.arraycopy(counters, 2, counters, 0, counterPosition - 1);
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        /*/!**
         * Attempts to decode a sequence of ITF black/white lines into single
         * digit.
         *
         * @param counters the counts of runs of observed black/white/black/... values
         * @return The decoded digit
         * @throws NotFoundException if digit cannot be decoded
         *!/*/ static decodeDigit(counters) {
            let bestVariance = ITFReader.MAX_AVG_VARIANCE; // worst variance we'll accept
            let bestMatch = -1;
            let max = ITFReader.PATTERNS.length;
            for(let i = 0; i < max; i++){
                let pattern = ITFReader.PATTERNS[i];
                let variance = OneDReader.patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = i;
                } else if (variance === bestVariance) // if we find a second 'best match' with the same variance, we can not reliably report to have a suitable match
                bestMatch = -1;
            }
            if (bestMatch >= 0) return bestMatch % 10;
            else throw new NotFoundException();
        }
    }
    ITFReader.PATTERNS = [
        Int32Array.from([
            1,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            1
        ]) // 9
    ];
    ITFReader.MAX_AVG_VARIANCE = 0.38;
    ITFReader.MAX_INDIVIDUAL_VARIANCE = 0.5;
    /* /!** Valid ITF lengths. Anything longer than the largest value is also allowed. *!/*/ ITFReader.DEFAULT_ALLOWED_LENGTHS = [
        6,
        8,
        10,
        12,
        14
    ];
    /*/!**
     * Start/end guard pattern.
     *
     * Note: The end pattern is reversed because the row is reversed before
     * searching for the END_PATTERN
     *!/*/ ITFReader.START_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1
    ]);
    ITFReader.END_PATTERN_REVERSED = [
        Int32Array.from([
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            3
        ]) // 3x
    ];
    /**
     * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
     * of one-dimensional barcodes.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */ class AbstractUPCEANReader extends OneDReader {
        constructor(){
            super(...arguments);
            this.decodeRowStringBuffer = '';
        }
        static findStartGuardPattern(row) {
            let foundStart = false;
            let startRange;
            let nextStart = 0;
            let counters = Int32Array.from([
                0,
                0,
                0
            ]);
            while(!foundStart){
                counters = Int32Array.from([
                    0,
                    0,
                    0
                ]);
                startRange = AbstractUPCEANReader.findGuardPattern(row, nextStart, false, this.START_END_PATTERN, counters);
                let start = startRange[0];
                nextStart = startRange[1];
                let quietStart = start - (nextStart - start);
                if (quietStart >= 0) foundStart = row.isRange(quietStart, start, false);
            }
            return startRange;
        }
        static checkChecksum(s) {
            return AbstractUPCEANReader.checkStandardUPCEANChecksum(s);
        }
        static checkStandardUPCEANChecksum(s) {
            let length = s.length;
            if (length === 0) return false;
            let check = parseInt(s.charAt(length - 1), 10);
            return AbstractUPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
        }
        static getStandardUPCEANChecksum(s) {
            let length = s.length;
            let sum = 0;
            for(let i = length - 1; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            sum *= 3;
            for(let i = length - 2; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            return (1000 - sum) % 10;
        }
        static decodeEnd(row, endStart) {
            return AbstractUPCEANReader.findGuardPattern(row, endStart, false, AbstractUPCEANReader.START_END_PATTERN, new Int32Array(AbstractUPCEANReader.START_END_PATTERN.length).fill(0));
        }
        /**
         * @throws NotFoundException
         */ static findGuardPatternWithoutCounters(row, rowOffset, whiteFirst, pattern) {
            return this.findGuardPattern(row, rowOffset, whiteFirst, pattern, new Int32Array(pattern.length));
        }
        /**
         * @param row row of black/white values to search
         * @param rowOffset position to start search
         * @param whiteFirst if true, indicates that the pattern specifies white/black/white/...
         * pixel counts, otherwise, it is interpreted as black/white/black/...
         * @param pattern pattern of counts of number of black and white pixels that are being
         * searched for as a pattern
         * @param counters array of counters, as long as pattern, to re-use
         * @return start/end horizontal offset of guard pattern, as an array of two ints
         * @throws NotFoundException if pattern is not found
         */ static findGuardPattern(row, rowOffset, whiteFirst, pattern, counters) {
            let width = row.getSize();
            rowOffset = whiteFirst ? row.getNextUnset(rowOffset) : row.getNextSet(rowOffset);
            let counterPosition = 0;
            let patternStart = rowOffset;
            let patternLength = pattern.length;
            let isWhite = whiteFirst;
            for(let x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    if (OneDReader.patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE) < AbstractUPCEANReader.MAX_AVG_VARIANCE) return Int32Array.from([
                        patternStart,
                        x
                    ]);
                    patternStart += counters[0] + counters[1];
                    let slice = counters.slice(2, counters.length - 1);
                    for(let i = 0; i < counterPosition - 1; i++)counters[i] = slice[i];
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        static decodeDigit(row, counters, rowOffset, patterns) {
            this.recordPattern(row, rowOffset, counters);
            let bestVariance = this.MAX_AVG_VARIANCE;
            let bestMatch = -1;
            let max = patterns.length;
            for(let i = 0; i < max; i++){
                let pattern = patterns[i];
                let variance = OneDReader.patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = i;
                }
            }
            if (bestMatch >= 0) return bestMatch;
            else throw new NotFoundException();
        }
    }
    // These two values are critical for determining how permissive the decoding will be.
    // We've arrived at these values through a lot of trial and error. Setting them any higher
    // lets false positives creep in quickly.
    AbstractUPCEANReader.MAX_AVG_VARIANCE = 0.48;
    AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    /**
     * Start/end guard pattern.
     */ AbstractUPCEANReader.START_END_PATTERN = Int32Array.from([
        1,
        1,
        1
    ]);
    /**
     * Pattern marking the middle of a UPC/EAN pattern, separating the two halves.
     */ AbstractUPCEANReader.MIDDLE_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1
    ]);
    /**
     * end guard pattern.
     */ AbstractUPCEANReader.END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]);
    /**
     * "Odd", or "L" patterns used to encode UPC/EAN digits.
     */ AbstractUPCEANReader.L_PATTERNS = [
        Int32Array.from([
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2
        ])
    ];
    /**
     * @see UPCEANExtension2Support
     */ class UPCEANExtension5Support {
        constructor(){
            this.CHECK_DIGIT_ENCODINGS = [
                0x18,
                0x14,
                0x12,
                0x11,
                0x0C,
                0x06,
                0x03,
                0x0A,
                0x09,
                0x05
            ];
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
            this.decodeRowStringBuffer = '';
        }
        decodeRow(rowNumber, row, extensionStartRange) {
            let result = this.decodeRowStringBuffer;
            let end = this.decodeMiddle(row, extensionStartRange, result);
            let resultString = result.toString();
            let extensionData = UPCEANExtension5Support.parseExtensionString(resultString);
            let resultPoints = [
                new ResultPoint((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
                new ResultPoint(end, rowNumber)
            ];
            let extensionResult = new Result(resultString, null, 0, resultPoints, BarcodeFormat$1.UPC_EAN_EXTENSION, new Date().getTime());
            if (extensionData != null) extensionResult.putAllMetadata(extensionData);
            return extensionResult;
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for(let x = 0; x < 5 && rowOffset < end; x++){
                let bestMatch = AbstractUPCEANReader.decodeDigit(row, counters, rowOffset, AbstractUPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) lgPatternFound |= 1 << 4 - x;
                if (x !== 4) {
                    // Read off separator if not last
                    rowOffset = row.getNextSet(rowOffset);
                    rowOffset = row.getNextUnset(rowOffset);
                }
            }
            if (resultString.length !== 5) throw new NotFoundException();
            let checkDigit = this.determineCheckDigit(lgPatternFound);
            if (UPCEANExtension5Support.extensionChecksum(resultString.toString()) !== checkDigit) throw new NotFoundException();
            return rowOffset;
        }
        static extensionChecksum(s) {
            let length = s.length;
            let sum = 0;
            for(let i = length - 2; i >= 0; i -= 2)sum += s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
            sum *= 3;
            for(let i = length - 1; i >= 0; i -= 2)sum += s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
            sum *= 3;
            return sum % 10;
        }
        determineCheckDigit(lgPatternFound) {
            for(let d = 0; d < 10; d++){
                if (lgPatternFound === this.CHECK_DIGIT_ENCODINGS[d]) return d;
            }
            throw new NotFoundException();
        }
        static parseExtensionString(raw) {
            if (raw.length !== 5) return null;
            let value = UPCEANExtension5Support.parseExtension5String(raw);
            if (value == null) return null;
            return new Map([
                [
                    ResultMetadataType$1.SUGGESTED_PRICE,
                    value
                ]
            ]);
        }
        static parseExtension5String(raw) {
            let currency;
            switch(raw.charAt(0)){
                case '0':
                    currency = "\xa3";
                    break;
                case '5':
                    currency = '$';
                    break;
                case '9':
                    // Reference: http://www.jollytech.com
                    switch(raw){
                        case '90000':
                            // No suggested retail price
                            return null;
                        case '99991':
                            // Complementary
                            return '0.00';
                        case '99990':
                            return 'Used';
                    }
                    // Otherwise... unknown currency?
                    currency = '';
                    break;
                default:
                    currency = '';
                    break;
            }
            let rawAmount = parseInt(raw.substring(1));
            let unitsString = (rawAmount / 100).toString();
            let hundredths = rawAmount % 100;
            let hundredthsString = hundredths < 10 ? '0' + hundredths : hundredths.toString(); // fixme
            return currency + unitsString + '.' + hundredthsString;
        }
    }
    /**
     * @see UPCEANExtension5Support
     */ class UPCEANExtension2Support {
        constructor(){
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
            this.decodeRowStringBuffer = '';
        }
        decodeRow(rowNumber, row, extensionStartRange) {
            let result = this.decodeRowStringBuffer;
            let end = this.decodeMiddle(row, extensionStartRange, result);
            let resultString = result.toString();
            let extensionData = UPCEANExtension2Support.parseExtensionString(resultString);
            let resultPoints = [
                new ResultPoint((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
                new ResultPoint(end, rowNumber)
            ];
            let extensionResult = new Result(resultString, null, 0, resultPoints, BarcodeFormat$1.UPC_EAN_EXTENSION, new Date().getTime());
            if (extensionData != null) extensionResult.putAllMetadata(extensionData);
            return extensionResult;
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let checkParity = 0;
            for(let x = 0; x < 2 && rowOffset < end; x++){
                let bestMatch = AbstractUPCEANReader.decodeDigit(row, counters, rowOffset, AbstractUPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) checkParity |= 1 << 1 - x;
                if (x !== 1) {
                    // Read off separator if not last
                    rowOffset = row.getNextSet(rowOffset);
                    rowOffset = row.getNextUnset(rowOffset);
                }
            }
            if (resultString.length !== 2) throw new NotFoundException();
            if (parseInt(resultString.toString()) % 4 !== checkParity) throw new NotFoundException();
            return rowOffset;
        }
        static parseExtensionString(raw) {
            if (raw.length !== 2) return null;
            return new Map([
                [
                    ResultMetadataType$1.ISSUE_NUMBER,
                    parseInt(raw)
                ]
            ]);
        }
    }
    class UPCEANExtensionSupport {
        static decodeRow(rowNumber, row, rowOffset) {
            let extensionStartRange = AbstractUPCEANReader.findGuardPattern(row, rowOffset, false, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
            try {
                // return null;
                let fiveSupport = new UPCEANExtension5Support();
                return fiveSupport.decodeRow(rowNumber, row, extensionStartRange);
            } catch (err) {
                // return null;
                let twoSupport = new UPCEANExtension2Support();
                return twoSupport.decodeRow(rowNumber, row, extensionStartRange);
            }
        }
    }
    UPCEANExtensionSupport.EXTENSION_START_PATTERN = Int32Array.from([
        1,
        1,
        2
    ]);
    /**
     * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
     * of one-dimensional barcodes.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */ class UPCEANReader extends AbstractUPCEANReader {
        constructor(){
            super();
            this.decodeRowStringBuffer = '';
            UPCEANReader.L_AND_G_PATTERNS = UPCEANReader.L_PATTERNS.map((arr)=>Int32Array.from(arr));
            for(let i = 10; i < 20; i++){
                let widths = UPCEANReader.L_PATTERNS[i - 10];
                let reversedWidths = new Int32Array(widths.length);
                for(let j = 0; j < widths.length; j++)reversedWidths[j] = widths[widths.length - j - 1];
                UPCEANReader.L_AND_G_PATTERNS[i] = reversedWidths;
            }
        }
        decodeRow(rowNumber, row, hints) {
            let startGuardRange = UPCEANReader.findStartGuardPattern(row);
            let resultPointCallback = hints == null ? null : hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint((startGuardRange[0] + startGuardRange[1]) / 2.0, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            let budello = this.decodeMiddle(row, startGuardRange, this.decodeRowStringBuffer);
            let endStart = budello.rowOffset;
            let result = budello.resultString;
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint(endStart, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            let endRange = this.decodeEnd(row, endStart);
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint((endRange[0] + endRange[1]) / 2.0, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            // Make sure there is a quiet zone at least as big as the end pattern after the barcode. The
            // spec might want more whitespace, but in practice this is the maximum we can count on.
            let end = endRange[1];
            let quietEnd = end + (end - endRange[0]);
            if (quietEnd >= row.getSize() || !row.isRange(end, quietEnd, false)) throw new NotFoundException();
            let resultString = result.toString();
            // UPC/EAN should never be less than 8 chars anyway
            if (resultString.length < 8) throw new FormatException();
            if (!UPCEANReader.checkChecksum(resultString)) throw new ChecksumException();
            let left = (startGuardRange[1] + startGuardRange[0]) / 2.0;
            let right = (endRange[1] + endRange[0]) / 2.0;
            let format = this.getBarcodeFormat();
            let resultPoint = [
                new ResultPoint(left, rowNumber),
                new ResultPoint(right, rowNumber)
            ];
            let decodeResult = new Result(resultString, null, 0, resultPoint, format, new Date().getTime());
            let extensionLength = 0;
            try {
                let extensionResult = UPCEANExtensionSupport.decodeRow(rowNumber, row, endRange[1]);
                decodeResult.putMetadata(ResultMetadataType$1.UPC_EAN_EXTENSION, extensionResult.getText());
                decodeResult.putAllMetadata(extensionResult.getResultMetadata());
                decodeResult.addResultPoints(extensionResult.getResultPoints());
                extensionLength = extensionResult.getText().length;
            } catch (ignoreError) {}
            let allowedExtensions = hints == null ? null : hints.get(DecodeHintType$1.ALLOWED_EAN_EXTENSIONS);
            if (allowedExtensions != null) {
                let valid = false;
                for(let length in allowedExtensions)if (extensionLength.toString() === length) {
                    valid = true;
                    break;
                }
                if (!valid) throw new NotFoundException();
            }
            return decodeResult;
        }
        decodeEnd(row, endStart) {
            return UPCEANReader.findGuardPattern(row, endStart, false, UPCEANReader.START_END_PATTERN, new Int32Array(UPCEANReader.START_END_PATTERN.length).fill(0));
        }
        static checkChecksum(s) {
            return UPCEANReader.checkStandardUPCEANChecksum(s);
        }
        static checkStandardUPCEANChecksum(s) {
            let length = s.length;
            if (length === 0) return false;
            let check = parseInt(s.charAt(length - 1), 10);
            return UPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
        }
        static getStandardUPCEANChecksum(s) {
            let length = s.length;
            let sum = 0;
            for(let i = length - 1; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            sum *= 3;
            for(let i = length - 2; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            return (1000 - sum) % 10;
        }
    }
    /**
     * <p>Implements decoding of the EAN-13 format.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */ class EAN13Reader extends UPCEANReader {
        constructor(){
            super();
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for(let x = 0; x < 6 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) lgPatternFound |= 1 << 5 - x;
            }
            resultString = EAN13Reader.determineFirstDigit(resultString, lgPatternFound);
            let middleRange = UPCEANReader.findGuardPattern(row, rowOffset, true, UPCEANReader.MIDDLE_PATTERN, new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0));
            rowOffset = middleRange[1];
            for(let x = 0; x < 6 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch);
                for (let counter of counters)rowOffset += counter;
            }
            return {
                rowOffset: rowOffset,
                resultString: resultString
            };
        }
        getBarcodeFormat() {
            return BarcodeFormat$1.EAN_13;
        }
        static determineFirstDigit(resultString, lgPatternFound) {
            for(let d = 0; d < 10; d++)if (lgPatternFound === this.FIRST_DIGIT_ENCODINGS[d]) {
                resultString = String.fromCharCode('0'.charCodeAt(0) + d) + resultString;
                return resultString;
            }
            throw new NotFoundException();
        }
    }
    EAN13Reader.FIRST_DIGIT_ENCODINGS = [
        0x00,
        0x0B,
        0x0D,
        0xE,
        0x13,
        0x19,
        0x1C,
        0x15,
        0x16,
        0x1A
    ];
    /**
     * <p>Implements decoding of the EAN-8 format.</p>
     *
     * @author Sean Owen
     */ class EAN8Reader extends UPCEANReader {
        constructor(){
            super();
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
        }
        decodeMiddle(row, startRange, resultString) {
            const counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            for(let x = 0; x < 4 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch);
                for (let counter of counters)rowOffset += counter;
            }
            let middleRange = UPCEANReader.findGuardPattern(row, rowOffset, true, UPCEANReader.MIDDLE_PATTERN, new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0));
            rowOffset = middleRange[1];
            for(let x = 0; x < 4 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch);
                for (let counter of counters)rowOffset += counter;
            }
            return {
                rowOffset: rowOffset,
                resultString: resultString
            };
        }
        getBarcodeFormat() {
            return BarcodeFormat$1.EAN_8;
        }
    }
    /**
     * Encapsulates functionality and implementation that is common to all families
     * of one-dimensional barcodes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author sam2332 (Sam Rudloff)
     *
     * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCAReader.java
     *
     * @experimental
     */ class UPCAReader extends UPCEANReader {
        constructor(){
            super(...arguments);
            this.ean13Reader = new EAN13Reader();
        }
        // @Override
        getBarcodeFormat() {
            return BarcodeFormat$1.UPC_A;
        }
        // Note that we don't try rotation without the try harder flag, even if rotation was supported.
        // @Override
        decode(image, hints) {
            return this.maybeReturnResult(this.ean13Reader.decode(image));
        }
        // @Override
        decodeRow(rowNumber, row, hints) {
            return this.maybeReturnResult(this.ean13Reader.decodeRow(rowNumber, row, hints));
        }
        // @Override
        decodeMiddle(row, startRange, resultString) {
            return this.ean13Reader.decodeMiddle(row, startRange, resultString);
        }
        maybeReturnResult(result) {
            let text = result.getText();
            if (text.charAt(0) === '0') {
                let upcaResult = new Result(text.substring(1), null, null, result.getResultPoints(), BarcodeFormat$1.UPC_A);
                if (result.getResultMetadata() != null) upcaResult.putAllMetadata(result.getResultMetadata());
                return upcaResult;
            } else throw new NotFoundException();
        }
        reset() {
            this.ean13Reader.reset();
        }
    }
    /**
     * <p>Implements decoding of the UPC-E format.</p>
     * <p><a href="http://www.barcodeisland.com/upce.phtml">This</a> is a great reference for
     * UPC-E information.</p>
     *
     * @author Sean Owen
     *
     * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCEReader.java
     *
     * @experimental
     */ /* final */ class UPCEReader extends UPCEANReader {
        constructor(){
            super();
            this.decodeMiddleCounters = new Int32Array(4);
        }
        /**
         * @throws NotFoundException
         */ // @Override
        decodeMiddle(row, startRange, result) {
            const counters = this.decodeMiddleCounters.map((x)=>x);
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            const end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for(let x = 0; x < 6 && rowOffset < end; x++){
                const bestMatch = UPCEReader.decodeDigit(row, counters, rowOffset, UPCEReader.L_AND_G_PATTERNS);
                result += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) lgPatternFound |= 1 << 5 - x;
            }
            let resultString = UPCEReader.determineNumSysAndCheckDigit(result, lgPatternFound);
            return {
                rowOffset: rowOffset,
                resultString: resultString
            };
        }
        /**
         * @throws NotFoundException
         */ // @Override
        decodeEnd(row, endStart) {
            return UPCEReader.findGuardPatternWithoutCounters(row, endStart, true, UPCEReader.MIDDLE_END_PATTERN);
        }
        /**
         * @throws FormatException
         */ // @Override
        checkChecksum(s) {
            return UPCEANReader.checkChecksum(UPCEReader.convertUPCEtoUPCA(s));
        }
        /**
         * @throws NotFoundException
         */ static determineNumSysAndCheckDigit(resultString, lgPatternFound) {
            for(let numSys = 0; numSys <= 1; numSys++){
                for(let d = 0; d < 10; d++)if (lgPatternFound === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[numSys][d]) {
                    let prefix = String.fromCharCode('0'.charCodeAt(0) + numSys);
                    let suffix = String.fromCharCode('0'.charCodeAt(0) + d);
                    return prefix + resultString + suffix;
                }
            }
            throw NotFoundException.getNotFoundInstance();
        }
        // @Override
        getBarcodeFormat() {
            return BarcodeFormat$1.UPC_E;
        }
        /**
         * Expands a UPC-E value back into its full, equivalent UPC-A code value.
         *
         * @param upce UPC-E code as string of digits
         * @return equivalent UPC-A code as string of digits
         */ static convertUPCEtoUPCA(upce) {
            // the following line is equivalent to upce.getChars(1, 7, upceChars, 0);
            const upceChars = upce.slice(1, 7).split('').map((x)=>x.charCodeAt(0));
            const result = new StringBuilder();
            result.append(upce.charAt(0));
            let lastChar = upceChars[5];
            switch(lastChar){
                case 0:
                case 1:
                case 2:
                    result.appendChars(upceChars, 0, 2);
                    result.append(lastChar);
                    result.append('0000');
                    result.appendChars(upceChars, 2, 3);
                    break;
                case 3:
                    result.appendChars(upceChars, 0, 3);
                    result.append('00000');
                    result.appendChars(upceChars, 3, 2);
                    break;
                case 4:
                    result.appendChars(upceChars, 0, 4);
                    result.append('00000');
                    result.append(upceChars[4]);
                    break;
                default:
                    result.appendChars(upceChars, 0, 5);
                    result.append('0000');
                    result.append(lastChar);
                    break;
            }
            // Only append check digit in conversion if supplied
            if (upce.length >= 8) result.append(upce.charAt(7));
            return result.toString();
        }
    }
    /**
     * The pattern that marks the middle, and end, of a UPC-E pattern.
     * There is no "second half" to a UPC-E barcode.
     */ UPCEReader.MIDDLE_END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]);
    // For an UPC-E barcode, the final digit is represented by the parities used
    // to encode the middle six digits, according to the table below.
    //
    //                Parity of next 6 digits
    //    Digit   0     1     2     3     4     5
    //       0    Even   Even  Even Odd  Odd   Odd
    //       1    Even   Even  Odd  Even Odd   Odd
    //       2    Even   Even  Odd  Odd  Even  Odd
    //       3    Even   Even  Odd  Odd  Odd   Even
    //       4    Even   Odd   Even Even Odd   Odd
    //       5    Even   Odd   Odd  Even Even  Odd
    //       6    Even   Odd   Odd  Odd  Even  Even
    //       7    Even   Odd   Even Odd  Even  Odd
    //       8    Even   Odd   Even Odd  Odd   Even
    //       9    Even   Odd   Odd  Even Odd   Even
    //
    // The encoding is represented by the following array, which is a bit pattern
    // using Odd = 0 and Even = 1. For example, 5 is represented by:
    //
    //              Odd Even Even Odd Odd Even
    // in binary:
    //                0    1    1   0   0    1   == 0x19
    //
    /**
     * See {@link #L_AND_G_PATTERNS}; these values similarly represent patterns of
     * even-odd parity encodings of digits that imply both the number system (0 or 1)
     * used, and the check digit.
     */ UPCEReader.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
        Int32Array.from([
            0x38,
            0x34,
            0x32,
            0x31,
            0x2C,
            0x26,
            0x23,
            0x2A,
            0x29,
            0x25
        ]),
        Int32Array.from([
            0x07,
            0x0B,
            0x0D,
            0x0E,
            0x13,
            0x19,
            0x1C,
            0x15,
            0x16,
            0x1A
        ])
    ];
    /**
     * <p>A reader that can read all available UPC/EAN formats. If a caller wants to try to
     * read all such formats, it is most efficient to use this implementation rather than invoke
     * individual readers.</p>
     *
     * @author Sean Owen
     */ class MultiFormatUPCEANReader extends OneDReader {
        constructor(hints){
            super();
            let possibleFormats = hints == null ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            let readers = [];
            if (!isNullOrUndefined(possibleFormats)) {
                if (possibleFormats.indexOf(BarcodeFormat$1.EAN_13) > -1) readers.push(new EAN13Reader());
                if (possibleFormats.indexOf(BarcodeFormat$1.UPC_A) > -1) readers.push(new UPCAReader());
                if (possibleFormats.indexOf(BarcodeFormat$1.EAN_8) > -1) readers.push(new EAN8Reader());
                if (possibleFormats.indexOf(BarcodeFormat$1.UPC_E) > -1) readers.push(new UPCEReader());
            } else {
                // No hints provided.
                readers.push(new EAN13Reader());
                readers.push(new UPCAReader());
                readers.push(new EAN8Reader());
                readers.push(new UPCEReader());
            }
            this.readers = readers;
        }
        decodeRow(rowNumber, row, hints) {
            for (let reader of this.readers)try {
                // const result: Result = reader.decodeRow(rowNumber, row, startGuardPattern, hints);
                const result = reader.decodeRow(rowNumber, row, hints);
                // Special case: a 12-digit code encoded in UPC-A is identical to a "0"
                // followed by those 12 digits encoded as EAN-13. Each will recognize such a code,
                // UPC-A as a 12-digit string and EAN-13 as a 13-digit string starting with "0".
                // Individually these are correct and their readers will both read such a code
                // and correctly call it EAN-13, or UPC-A, respectively.
                //
                // In this case, if we've been looking for both types, we'd like to call it
                // a UPC-A code. But for efficiency we only run the EAN-13 decoder to also read
                // UPC-A. So we special case it here, and convert an EAN-13 result to a UPC-A
                // result if appropriate.
                //
                // But, don't return UPC-A if UPC-A was not a requested format!
                const ean13MayBeUPCA = result.getBarcodeFormat() === BarcodeFormat$1.EAN_13 && result.getText().charAt(0) === '0';
                // @SuppressWarnings("unchecked")
                const possibleFormats = hints == null ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
                const canReturnUPCA = possibleFormats == null || possibleFormats.includes(BarcodeFormat$1.UPC_A);
                if (ean13MayBeUPCA && canReturnUPCA) {
                    const rawBytes = result.getRawBytes();
                    // Transfer the metadata across
                    const resultUPCA = new Result(result.getText().substring(1), rawBytes, rawBytes ? rawBytes.length : null, result.getResultPoints(), BarcodeFormat$1.UPC_A);
                    resultUPCA.putAllMetadata(result.getResultMetadata());
                    return resultUPCA;
                }
                return result;
            } catch (err) {
            // continue;
            }
            throw new NotFoundException();
        }
        reset() {
            for (let reader of this.readers)reader.reset();
        }
    }
    // import Integer from '../../util/Integer';
    // import Float from '../../util/Float';
    class AbstractRSSReader extends OneDReader {
        constructor(){
            super();
            this.decodeFinderCounters = new Int32Array(4);
            this.dataCharacterCounters = new Int32Array(8);
            this.oddRoundingErrors = new Array(4);
            this.evenRoundingErrors = new Array(4);
            this.oddCounts = new Array(this.dataCharacterCounters.length / 2);
            this.evenCounts = new Array(this.dataCharacterCounters.length / 2);
        }
        getDecodeFinderCounters() {
            return this.decodeFinderCounters;
        }
        getDataCharacterCounters() {
            return this.dataCharacterCounters;
        }
        getOddRoundingErrors() {
            return this.oddRoundingErrors;
        }
        getEvenRoundingErrors() {
            return this.evenRoundingErrors;
        }
        getOddCounts() {
            return this.oddCounts;
        }
        getEvenCounts() {
            return this.evenCounts;
        }
        parseFinderValue(counters, finderPatterns) {
            for(let value = 0; value < finderPatterns.length; value++){
                if (OneDReader.patternMatchVariance(counters, finderPatterns[value], AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE) < AbstractRSSReader.MAX_AVG_VARIANCE) return value;
            }
            throw new NotFoundException();
        }
        /**
         * @param array values to sum
         * @return sum of values
         * @deprecated call {@link MathUtils#sum(int[])}
         */ static count(array) {
            return MathUtils.sum(new Int32Array(array));
        }
        static increment(array, errors) {
            let index = 0;
            let biggestError = errors[0];
            for(let i = 1; i < array.length; i++)if (errors[i] > biggestError) {
                biggestError = errors[i];
                index = i;
            }
            array[index]++;
        }
        static decrement(array, errors) {
            let index = 0;
            let biggestError = errors[0];
            for(let i = 1; i < array.length; i++)if (errors[i] < biggestError) {
                biggestError = errors[i];
                index = i;
            }
            array[index]--;
        }
        static isFinderPattern(counters) {
            let firstTwoSum = counters[0] + counters[1];
            let sum = firstTwoSum + counters[2] + counters[3];
            let ratio = firstTwoSum / sum;
            if (ratio >= AbstractRSSReader.MIN_FINDER_PATTERN_RATIO && ratio <= AbstractRSSReader.MAX_FINDER_PATTERN_RATIO) {
                // passes ratio test in spec, but see if the counts are unreasonable
                let minCounter = Number.MAX_SAFE_INTEGER;
                let maxCounter = Number.MIN_SAFE_INTEGER;
                for (let counter of counters){
                    if (counter > maxCounter) maxCounter = counter;
                    if (counter < minCounter) minCounter = counter;
                }
                return maxCounter < 10 * minCounter;
            }
            return false;
        }
    }
    AbstractRSSReader.MAX_AVG_VARIANCE = 0.2;
    AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE = 0.45;
    AbstractRSSReader.MIN_FINDER_PATTERN_RATIO = 9.5 / 12.0;
    AbstractRSSReader.MAX_FINDER_PATTERN_RATIO = 12.5 / 14.0;
    class DataCharacter {
        constructor(value, checksumPortion){
            this.value = value;
            this.checksumPortion = checksumPortion;
        }
        getValue() {
            return this.value;
        }
        getChecksumPortion() {
            return this.checksumPortion;
        }
        toString() {
            return this.value + '(' + this.checksumPortion + ')';
        }
        equals(o) {
            if (!(o instanceof DataCharacter)) return false;
            const that = o;
            return this.value === that.value && this.checksumPortion === that.checksumPortion;
        }
        hashCode() {
            return this.value ^ this.checksumPortion;
        }
    }
    class FinderPattern {
        constructor(value, startEnd, start, end, rowNumber){
            this.value = value;
            this.startEnd = startEnd;
            this.value = value;
            this.startEnd = startEnd;
            this.resultPoints = new Array();
            this.resultPoints.push(new ResultPoint(start, rowNumber));
            this.resultPoints.push(new ResultPoint(end, rowNumber));
        }
        getValue() {
            return this.value;
        }
        getStartEnd() {
            return this.startEnd;
        }
        getResultPoints() {
            return this.resultPoints;
        }
        equals(o) {
            if (!(o instanceof FinderPattern)) return false;
            const that = o;
            return this.value === that.value;
        }
        hashCode() {
            return this.value;
        }
    }
    /**
     * RSS util functions.
     */ class RSSUtils {
        constructor(){}
        static getRSSvalue(widths, maxWidth, noNarrow) {
            let n = 0;
            for (let width of widths)n += width;
            let val = 0;
            let narrowMask = 0;
            let elements = widths.length;
            for(let bar = 0; bar < elements - 1; bar++){
                let elmWidth;
                for(elmWidth = 1, narrowMask |= 1 << bar; elmWidth < widths[bar]; elmWidth++, narrowMask &= ~(1 << bar)){
                    let subVal = RSSUtils.combins(n - elmWidth - 1, elements - bar - 2);
                    if (noNarrow && narrowMask === 0 && n - elmWidth - (elements - bar - 1) >= elements - bar - 1) subVal -= RSSUtils.combins(n - elmWidth - (elements - bar), elements - bar - 2);
                    if (elements - bar - 1 > 1) {
                        let lessVal = 0;
                        for(let mxwElement = n - elmWidth - (elements - bar - 2); mxwElement > maxWidth; mxwElement--)lessVal += RSSUtils.combins(n - elmWidth - mxwElement - 1, elements - bar - 3);
                        subVal -= lessVal * (elements - 1 - bar);
                    } else if (n - elmWidth > maxWidth) subVal--;
                    val += subVal;
                }
                n -= elmWidth;
            }
            return val;
        }
        static combins(n, r) {
            let maxDenom;
            let minDenom;
            if (n - r > r) {
                minDenom = r;
                maxDenom = n - r;
            } else {
                minDenom = n - r;
                maxDenom = r;
            }
            let val = 1;
            let j = 1;
            for(let i = n; i > maxDenom; i--){
                val *= i;
                if (j <= minDenom) {
                    val /= j;
                    j++;
                }
            }
            while(j <= minDenom){
                val /= j;
                j++;
            }
            return val;
        }
    }
    class BitArrayBuilder {
        static buildBitArray(pairs) {
            let charNumber = pairs.length * 2 - 1;
            if (pairs[pairs.length - 1].getRightChar() == null) charNumber -= 1;
            let size = 12 * charNumber;
            let binary = new BitArray(size);
            let accPos = 0;
            let firstPair = pairs[0];
            let firstValue = firstPair.getRightChar().getValue();
            for(let i = 11; i >= 0; --i){
                if ((firstValue & 1 << i) != 0) binary.set(accPos);
                accPos++;
            }
            for(let i = 1; i < pairs.length; ++i){
                let currentPair = pairs[i];
                let leftValue = currentPair.getLeftChar().getValue();
                for(let j = 11; j >= 0; --j){
                    if ((leftValue & 1 << j) != 0) binary.set(accPos);
                    accPos++;
                }
                if (currentPair.getRightChar() != null) {
                    let rightValue = currentPair.getRightChar().getValue();
                    for(let j = 11; j >= 0; --j){
                        if ((rightValue & 1 << j) != 0) binary.set(accPos);
                        accPos++;
                    }
                }
            }
            return binary;
        }
    }
    class BlockParsedResult {
        constructor(finished, decodedInformation){
            if (decodedInformation) this.decodedInformation = null;
            else {
                this.finished = finished;
                this.decodedInformation = decodedInformation;
            }
        }
        getDecodedInformation() {
            return this.decodedInformation;
        }
        isFinished() {
            return this.finished;
        }
    }
    class DecodedObject {
        constructor(newPosition){
            this.newPosition = newPosition;
        }
        getNewPosition() {
            return this.newPosition;
        }
    }
    class DecodedChar extends DecodedObject {
        constructor(newPosition, value){
            super(newPosition);
            this.value = value;
        }
        getValue() {
            return this.value;
        }
        isFNC1() {
            return this.value === DecodedChar.FNC1;
        }
    }
    DecodedChar.FNC1 = '$';
    class DecodedInformation extends DecodedObject {
        constructor(newPosition, newString, remainingValue){
            super(newPosition);
            if (remainingValue) {
                this.remaining = true;
                this.remainingValue = this.remainingValue;
            } else {
                this.remaining = false;
                this.remainingValue = 0;
            }
            this.newString = newString;
        }
        getNewString() {
            return this.newString;
        }
        isRemaining() {
            return this.remaining;
        }
        getRemainingValue() {
            return this.remainingValue;
        }
    }
    class DecodedNumeric extends DecodedObject {
        constructor(newPosition, firstDigit, secondDigit){
            super(newPosition);
            if (firstDigit < 0 || firstDigit > 10 || secondDigit < 0 || secondDigit > 10) throw new FormatException();
            this.firstDigit = firstDigit;
            this.secondDigit = secondDigit;
        }
        getFirstDigit() {
            return this.firstDigit;
        }
        getSecondDigit() {
            return this.secondDigit;
        }
        getValue() {
            return this.firstDigit * 10 + this.secondDigit;
        }
        isFirstDigitFNC1() {
            return this.firstDigit === DecodedNumeric.FNC1;
        }
        isSecondDigitFNC1() {
            return this.secondDigit === DecodedNumeric.FNC1;
        }
        isAnyFNC1() {
            return this.firstDigit === DecodedNumeric.FNC1 || this.secondDigit === DecodedNumeric.FNC1;
        }
    }
    DecodedNumeric.FNC1 = 10;
    class FieldParser {
        constructor(){}
        static parseFieldsInGeneralPurpose(rawInformation) {
            if (!rawInformation) return null;
            // Processing 2-digit AIs
            if (rawInformation.length < 2) throw new NotFoundException();
            let firstTwoDigits = rawInformation.substring(0, 2);
            for (let dataLength of FieldParser.TWO_DIGIT_DATA_LENGTH)if (dataLength[0] === firstTwoDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(2, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(2, dataLength[1], rawInformation);
            }
            if (rawInformation.length < 3) throw new NotFoundException();
            let firstThreeDigits = rawInformation.substring(0, 3);
            for (let dataLength of FieldParser.THREE_DIGIT_DATA_LENGTH)if (dataLength[0] === firstThreeDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(3, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(3, dataLength[1], rawInformation);
            }
            for (let dataLength of FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH)if (dataLength[0] === firstThreeDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
            }
            if (rawInformation.length < 4) throw new NotFoundException();
            let firstFourDigits = rawInformation.substring(0, 4);
            for (let dataLength of FieldParser.FOUR_DIGIT_DATA_LENGTH)if (dataLength[0] === firstFourDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
            }
            throw new NotFoundException();
        }
        static processFixedAI(aiSize, fieldSize, rawInformation) {
            if (rawInformation.length < aiSize) throw new NotFoundException();
            let ai = rawInformation.substring(0, aiSize);
            if (rawInformation.length < aiSize + fieldSize) throw new NotFoundException();
            let field = rawInformation.substring(aiSize, aiSize + fieldSize);
            let remaining = rawInformation.substring(aiSize + fieldSize);
            let result = '(' + ai + ')' + field;
            let parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
            return parsedAI == null ? result : result + parsedAI;
        }
        static processVariableAI(aiSize, variableFieldSize, rawInformation) {
            let ai = rawInformation.substring(0, aiSize);
            let maxSize;
            if (rawInformation.length < aiSize + variableFieldSize) maxSize = rawInformation.length;
            else maxSize = aiSize + variableFieldSize;
            let field = rawInformation.substring(aiSize, maxSize);
            let remaining = rawInformation.substring(maxSize);
            let result = '(' + ai + ')' + field;
            let parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
            return parsedAI == null ? result : result + parsedAI;
        }
    }
    FieldParser.VARIABLE_LENGTH = [];
    FieldParser.TWO_DIGIT_DATA_LENGTH = [
        [
            '00',
            18
        ],
        [
            '01',
            14
        ],
        [
            '02',
            14
        ],
        [
            '10',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '11',
            6
        ],
        [
            '12',
            6
        ],
        [
            '13',
            6
        ],
        [
            '15',
            6
        ],
        [
            '17',
            6
        ],
        [
            '20',
            2
        ],
        [
            '21',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '22',
            FieldParser.VARIABLE_LENGTH,
            29
        ],
        [
            '30',
            FieldParser.VARIABLE_LENGTH,
            8
        ],
        [
            '37',
            FieldParser.VARIABLE_LENGTH,
            8
        ],
        // internal company codes
        [
            '90',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '91',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '92',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '93',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '94',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '95',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '96',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '97',
            FieldParser.VARIABLE_LENGTH,
            3
        ],
        [
            '98',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '99',
            FieldParser.VARIABLE_LENGTH,
            30
        ]
    ];
    FieldParser.THREE_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            '240',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '241',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '242',
            FieldParser.VARIABLE_LENGTH,
            6
        ],
        [
            '250',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '251',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '253',
            FieldParser.VARIABLE_LENGTH,
            17
        ],
        [
            '254',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '400',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '401',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '402',
            17
        ],
        [
            '403',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '410',
            13
        ],
        [
            '411',
            13
        ],
        [
            '412',
            13
        ],
        [
            '413',
            13
        ],
        [
            '414',
            13
        ],
        [
            '420',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '421',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '422',
            3
        ],
        [
            '423',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '424',
            3
        ],
        [
            '425',
            3
        ],
        [
            '426',
            3
        ]
    ];
    FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            '310',
            6
        ],
        [
            '311',
            6
        ],
        [
            '312',
            6
        ],
        [
            '313',
            6
        ],
        [
            '314',
            6
        ],
        [
            '315',
            6
        ],
        [
            '316',
            6
        ],
        [
            '320',
            6
        ],
        [
            '321',
            6
        ],
        [
            '322',
            6
        ],
        [
            '323',
            6
        ],
        [
            '324',
            6
        ],
        [
            '325',
            6
        ],
        [
            '326',
            6
        ],
        [
            '327',
            6
        ],
        [
            '328',
            6
        ],
        [
            '329',
            6
        ],
        [
            '330',
            6
        ],
        [
            '331',
            6
        ],
        [
            '332',
            6
        ],
        [
            '333',
            6
        ],
        [
            '334',
            6
        ],
        [
            '335',
            6
        ],
        [
            '336',
            6
        ],
        [
            '340',
            6
        ],
        [
            '341',
            6
        ],
        [
            '342',
            6
        ],
        [
            '343',
            6
        ],
        [
            '344',
            6
        ],
        [
            '345',
            6
        ],
        [
            '346',
            6
        ],
        [
            '347',
            6
        ],
        [
            '348',
            6
        ],
        [
            '349',
            6
        ],
        [
            '350',
            6
        ],
        [
            '351',
            6
        ],
        [
            '352',
            6
        ],
        [
            '353',
            6
        ],
        [
            '354',
            6
        ],
        [
            '355',
            6
        ],
        [
            '356',
            6
        ],
        [
            '357',
            6
        ],
        [
            '360',
            6
        ],
        [
            '361',
            6
        ],
        [
            '362',
            6
        ],
        [
            '363',
            6
        ],
        [
            '364',
            6
        ],
        [
            '365',
            6
        ],
        [
            '366',
            6
        ],
        [
            '367',
            6
        ],
        [
            '368',
            6
        ],
        [
            '369',
            6
        ],
        [
            '390',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '391',
            FieldParser.VARIABLE_LENGTH,
            18
        ],
        [
            '392',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '393',
            FieldParser.VARIABLE_LENGTH,
            18
        ],
        [
            '703',
            FieldParser.VARIABLE_LENGTH,
            30
        ]
    ];
    FieldParser.FOUR_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            '7001',
            13
        ],
        [
            '7002',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '7003',
            10
        ],
        [
            '8001',
            14
        ],
        [
            '8002',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '8003',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '8004',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '8005',
            6
        ],
        [
            '8006',
            18
        ],
        [
            '8007',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '8008',
            FieldParser.VARIABLE_LENGTH,
            12
        ],
        [
            '8018',
            18
        ],
        [
            '8020',
            FieldParser.VARIABLE_LENGTH,
            25
        ],
        [
            '8100',
            6
        ],
        [
            '8101',
            10
        ],
        [
            '8102',
            2
        ],
        [
            '8110',
            FieldParser.VARIABLE_LENGTH,
            70
        ],
        [
            '8200',
            FieldParser.VARIABLE_LENGTH,
            70
        ]
    ];
    class GeneralAppIdDecoder {
        constructor(information){
            this.buffer = new StringBuilder();
            this.information = information;
        }
        decodeAllCodes(buff, initialPosition) {
            let currentPosition = initialPosition;
            let remaining = null;
            do {
                let info = this.decodeGeneralPurposeField(currentPosition, remaining);
                let parsedFields = FieldParser.parseFieldsInGeneralPurpose(info.getNewString());
                if (parsedFields != null) buff.append(parsedFields);
                if (info.isRemaining()) remaining = '' + info.getRemainingValue();
                else remaining = null;
                if (currentPosition === info.getNewPosition()) break;
                currentPosition = info.getNewPosition();
            }while (true);
            return buff.toString();
        }
        isStillNumeric(pos) {
            // It's numeric if it still has 7 positions
            // and one of the first 4 bits is "1".
            if (pos + 7 > this.information.getSize()) return pos + 4 <= this.information.getSize();
            for(let i = pos; i < pos + 3; ++i){
                if (this.information.get(i)) return true;
            }
            return this.information.get(pos + 3);
        }
        decodeNumeric(pos) {
            if (pos + 7 > this.information.getSize()) {
                let numeric = this.extractNumericValueFromBitArray(pos, 4);
                if (numeric === 0) return new DecodedNumeric(this.information.getSize(), DecodedNumeric.FNC1, DecodedNumeric.FNC1);
                return new DecodedNumeric(this.information.getSize(), numeric - 1, DecodedNumeric.FNC1);
            }
            let numeric = this.extractNumericValueFromBitArray(pos, 7);
            let digit1 = (numeric - 8) / 11;
            let digit2 = (numeric - 8) % 11;
            return new DecodedNumeric(pos + 7, digit1, digit2);
        }
        extractNumericValueFromBitArray(pos, bits) {
            return GeneralAppIdDecoder.extractNumericValueFromBitArray(this.information, pos, bits);
        }
        static extractNumericValueFromBitArray(information, pos, bits) {
            let value = 0;
            for(let i = 0; i < bits; ++i)if (information.get(pos + i)) value |= 1 << bits - i - 1;
            return value;
        }
        decodeGeneralPurposeField(pos, remaining) {
            // this.buffer.setLength(0);
            this.buffer.setLengthToZero();
            if (remaining != null) this.buffer.append(remaining);
            this.current.setPosition(pos);
            let lastDecoded = this.parseBlocks();
            if (lastDecoded != null && lastDecoded.isRemaining()) return new DecodedInformation(this.current.getPosition(), this.buffer.toString(), lastDecoded.getRemainingValue());
            return new DecodedInformation(this.current.getPosition(), this.buffer.toString());
        }
        parseBlocks() {
            let isFinished;
            let result;
            do {
                let initialPosition = this.current.getPosition();
                if (this.current.isAlpha()) {
                    result = this.parseAlphaBlock();
                    isFinished = result.isFinished();
                } else if (this.current.isIsoIec646()) {
                    result = this.parseIsoIec646Block();
                    isFinished = result.isFinished();
                } else {
                    result = this.parseNumericBlock();
                    isFinished = result.isFinished();
                }
                let positionChanged = initialPosition !== this.current.getPosition();
                if (!positionChanged && !isFinished) break;
            }while (!isFinished);
            return result.getDecodedInformation();
        }
        parseNumericBlock() {
            while(this.isStillNumeric(this.current.getPosition())){
                let numeric = this.decodeNumeric(this.current.getPosition());
                this.current.setPosition(numeric.getNewPosition());
                if (numeric.isFirstDigitFNC1()) {
                    let information;
                    if (numeric.isSecondDigitFNC1()) information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    else information = new DecodedInformation(this.current.getPosition(), this.buffer.toString(), numeric.getSecondDigit());
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(numeric.getFirstDigit());
                if (numeric.isSecondDigitFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(numeric.getSecondDigit());
            }
            if (this.isNumericToAlphaNumericLatch(this.current.getPosition())) {
                this.current.setAlpha();
                this.current.incrementPosition(4);
            }
            return new BlockParsedResult(false);
        }
        parseIsoIec646Block() {
            while(this.isStillIsoIec646(this.current.getPosition())){
                let iso = this.decodeIsoIec646(this.current.getPosition());
                this.current.setPosition(iso.getNewPosition());
                if (iso.isFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(iso.getValue());
            }
            if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
                this.current.incrementPosition(3);
                this.current.setNumeric();
            } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
                if (this.current.getPosition() + 5 < this.information.getSize()) this.current.incrementPosition(5);
                else this.current.setPosition(this.information.getSize());
                this.current.setAlpha();
            }
            return new BlockParsedResult(false);
        }
        parseAlphaBlock() {
            while(this.isStillAlpha(this.current.getPosition())){
                let alpha = this.decodeAlphanumeric(this.current.getPosition());
                this.current.setPosition(alpha.getNewPosition());
                if (alpha.isFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information); // end of the char block
                }
                this.buffer.append(alpha.getValue());
            }
            if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
                this.current.incrementPosition(3);
                this.current.setNumeric();
            } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
                if (this.current.getPosition() + 5 < this.information.getSize()) this.current.incrementPosition(5);
                else this.current.setPosition(this.information.getSize());
                this.current.setIsoIec646();
            }
            return new BlockParsedResult(false);
        }
        isStillIsoIec646(pos) {
            if (pos + 5 > this.information.getSize()) return false;
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue >= 5 && fiveBitValue < 16) return true;
            if (pos + 7 > this.information.getSize()) return false;
            let sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
            if (sevenBitValue >= 64 && sevenBitValue < 116) return true;
            if (pos + 8 > this.information.getSize()) return false;
            let eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
            return eightBitValue >= 232 && eightBitValue < 253;
        }
        decodeIsoIec646(pos) {
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue === 15) return new DecodedChar(pos + 5, DecodedChar.FNC1);
            if (fiveBitValue >= 5 && fiveBitValue < 15) return new DecodedChar(pos + 5, '0' + (fiveBitValue - 5));
            let sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
            if (sevenBitValue >= 64 && sevenBitValue < 90) return new DecodedChar(pos + 7, '' + (sevenBitValue + 1));
            if (sevenBitValue >= 90 && sevenBitValue < 116) return new DecodedChar(pos + 7, '' + (sevenBitValue + 7));
            let eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
            let c;
            switch(eightBitValue){
                case 232:
                    c = '!';
                    break;
                case 233:
                    c = '"';
                    break;
                case 234:
                    c = '%';
                    break;
                case 235:
                    c = '&';
                    break;
                case 236:
                    c = '\'';
                    break;
                case 237:
                    c = '(';
                    break;
                case 238:
                    c = ')';
                    break;
                case 239:
                    c = '*';
                    break;
                case 240:
                    c = '+';
                    break;
                case 241:
                    c = ',';
                    break;
                case 242:
                    c = '-';
                    break;
                case 243:
                    c = '.';
                    break;
                case 244:
                    c = '/';
                    break;
                case 245:
                    c = ':';
                    break;
                case 246:
                    c = ';';
                    break;
                case 247:
                    c = '<';
                    break;
                case 248:
                    c = '=';
                    break;
                case 249:
                    c = '>';
                    break;
                case 250:
                    c = '?';
                    break;
                case 251:
                    c = '_';
                    break;
                case 252:
                    c = ' ';
                    break;
                default:
                    throw new FormatException();
            }
            return new DecodedChar(pos + 8, c);
        }
        isStillAlpha(pos) {
            if (pos + 5 > this.information.getSize()) return false;
            // We now check if it's a valid 5-bit value (0..9 and FNC1)
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue >= 5 && fiveBitValue < 16) return true;
            if (pos + 6 > this.information.getSize()) return false;
            let sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
            return sixBitValue >= 16 && sixBitValue < 63; // 63 not included
        }
        decodeAlphanumeric(pos) {
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue === 15) return new DecodedChar(pos + 5, DecodedChar.FNC1);
            if (fiveBitValue >= 5 && fiveBitValue < 15) return new DecodedChar(pos + 5, '0' + (fiveBitValue - 5));
            let sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
            if (sixBitValue >= 32 && sixBitValue < 58) return new DecodedChar(pos + 6, '' + (sixBitValue + 33));
            let c;
            switch(sixBitValue){
                case 58:
                    c = '*';
                    break;
                case 59:
                    c = ',';
                    break;
                case 60:
                    c = '-';
                    break;
                case 61:
                    c = '.';
                    break;
                case 62:
                    c = '/';
                    break;
                default:
                    throw new IllegalStateException('Decoding invalid alphanumeric value: ' + sixBitValue);
            }
            return new DecodedChar(pos + 6, c);
        }
        isAlphaTo646ToAlphaLatch(pos) {
            if (pos + 1 > this.information.getSize()) return false;
            for(let i = 0; i < 5 && i + pos < this.information.getSize(); ++i){
                if (i === 2) {
                    if (!this.information.get(pos + 2)) return false;
                } else if (this.information.get(pos + i)) return false;
            }
            return true;
        }
        isAlphaOr646ToNumericLatch(pos) {
            // Next is alphanumeric if there are 3 positions and they are all zeros
            if (pos + 3 > this.information.getSize()) return false;
            for(let i = pos; i < pos + 3; ++i){
                if (this.information.get(i)) return false;
            }
            return true;
        }
        isNumericToAlphaNumericLatch(pos) {
            // Next is alphanumeric if there are 4 positions and they are all zeros, or
            // if there is a subset of this just before the end of the symbol
            if (pos + 1 > this.information.getSize()) return false;
            for(let i = 0; i < 4 && i + pos < this.information.getSize(); ++i){
                if (this.information.get(pos + i)) return false;
            }
            return true;
        }
    }
    class AbstractExpandedDecoder {
        constructor(information){
            this.information = information;
            this.generalDecoder = new GeneralAppIdDecoder(information);
        }
        getInformation() {
            return this.information;
        }
        getGeneralDecoder() {
            return this.generalDecoder;
        }
    }
    class AI01decoder extends AbstractExpandedDecoder {
        constructor(information){
            super(information);
        }
        encodeCompressedGtin(buf, currentPos) {
            buf.append('(01)');
            let initialPosition = buf.length();
            buf.append('9');
            this.encodeCompressedGtinWithoutAI(buf, currentPos, initialPosition);
        }
        encodeCompressedGtinWithoutAI(buf, currentPos, initialBufferPosition) {
            for(let i = 0; i < 4; ++i){
                let currentBlock = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos + 10 * i, 10);
                if (currentBlock / 100 === 0) buf.append('0');
                if (currentBlock / 10 === 0) buf.append('0');
                buf.append(currentBlock);
            }
            AI01decoder.appendCheckDigit(buf, initialBufferPosition);
        }
        static appendCheckDigit(buf, currentPos) {
            let checkDigit = 0;
            for(let i = 0; i < 13; i++){
                // let digit = buf.charAt(i + currentPos) - '0';
                // To be checked
                let digit = buf.charAt(i + currentPos).charCodeAt(0) - '0'.charCodeAt(0);
                checkDigit += (i & 0x01) === 0 ? 3 * digit : digit;
            }
            checkDigit = 10 - checkDigit % 10;
            if (checkDigit === 10) checkDigit = 0;
            buf.append(checkDigit);
        }
    }
    AI01decoder.GTIN_SIZE = 40;
    class AI01AndOtherAIs extends AI01decoder {
        // the second one is the encodation method, and the other two are for the variable length
        constructor(information){
            super(information);
        }
        parseInformation() {
            let buff = new StringBuilder();
            buff.append('(01)');
            let initialGtinPosition = buff.length();
            let firstGtinDigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01AndOtherAIs.HEADER_SIZE, 4);
            buff.append(firstGtinDigit);
            this.encodeCompressedGtinWithoutAI(buff, AI01AndOtherAIs.HEADER_SIZE + 4, initialGtinPosition);
            return this.getGeneralDecoder().decodeAllCodes(buff, AI01AndOtherAIs.HEADER_SIZE + 44);
        }
    }
    AI01AndOtherAIs.HEADER_SIZE = 4; // first bit encodes the linkage flag,
    class AnyAIDecoder extends AbstractExpandedDecoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            let buf = new StringBuilder();
            return this.getGeneralDecoder().decodeAllCodes(buf, AnyAIDecoder.HEADER_SIZE);
        }
    }
    AnyAIDecoder.HEADER_SIZE = 5;
    class AI01weightDecoder extends AI01decoder {
        constructor(information){
            super(information);
        }
        encodeCompressedWeight(buf, currentPos, weightSize) {
            let originalWeightNumeric = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, weightSize);
            this.addWeightCode(buf, originalWeightNumeric);
            let weightNumeric = this.checkWeight(originalWeightNumeric);
            let currentDivisor = 100000;
            for(let i = 0; i < 5; ++i){
                if (weightNumeric / currentDivisor === 0) buf.append('0');
                currentDivisor /= 10;
            }
            buf.append(weightNumeric);
        }
    }
    class AI013x0xDecoder extends AI01weightDecoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() != AI013x0xDecoder.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE + AI013x0xDecoder.WEIGHT_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI013x0xDecoder.HEADER_SIZE);
            this.encodeCompressedWeight(buf, AI013x0xDecoder.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE, AI013x0xDecoder.WEIGHT_SIZE);
            return buf.toString();
        }
    }
    AI013x0xDecoder.HEADER_SIZE = 5;
    AI013x0xDecoder.WEIGHT_SIZE = 15;
    class AI013103decoder extends AI013x0xDecoder {
        constructor(information){
            super(information);
        }
        addWeightCode(buf, weight) {
            buf.append('(3103)');
        }
        checkWeight(weight) {
            return weight;
        }
    }
    class AI01320xDecoder extends AI013x0xDecoder {
        constructor(information){
            super(information);
        }
        addWeightCode(buf, weight) {
            if (weight < 10000) buf.append('(3202)');
            else buf.append('(3203)');
        }
        checkWeight(weight) {
            if (weight < 10000) return weight;
            return weight - 10000;
        }
    }
    class AI01392xDecoder extends AI01decoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() < AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI01392xDecoder.HEADER_SIZE);
            let lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE, AI01392xDecoder.LAST_DIGIT_SIZE);
            buf.append('(392');
            buf.append(lastAIdigit);
            buf.append(')');
            let decodedInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01392xDecoder.LAST_DIGIT_SIZE, null);
            buf.append(decodedInformation.getNewString());
            return buf.toString();
        }
    }
    AI01392xDecoder.HEADER_SIZE = 8;
    AI01392xDecoder.LAST_DIGIT_SIZE = 2;
    class AI01393xDecoder extends AI01decoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() < AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI01393xDecoder.HEADER_SIZE);
            let lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE, AI01393xDecoder.LAST_DIGIT_SIZE);
            buf.append('(393');
            buf.append(lastAIdigit);
            buf.append(')');
            let firstThreeDigits = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE, AI01393xDecoder.FIRST_THREE_DIGITS_SIZE);
            if (firstThreeDigits / 100 == 0) buf.append('0');
            if (firstThreeDigits / 10 == 0) buf.append('0');
            buf.append(firstThreeDigits);
            let generalInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE + AI01393xDecoder.FIRST_THREE_DIGITS_SIZE, null);
            buf.append(generalInformation.getNewString());
            return buf.toString();
        }
    }
    AI01393xDecoder.HEADER_SIZE = 8;
    AI01393xDecoder.LAST_DIGIT_SIZE = 2;
    AI01393xDecoder.FIRST_THREE_DIGITS_SIZE = 10;
    class AI013x0x1xDecoder extends AI01weightDecoder {
        constructor(information, firstAIdigits, dateCode){
            super(information);
            this.dateCode = dateCode;
            this.firstAIdigits = firstAIdigits;
        }
        parseInformation() {
            if (this.getInformation().getSize() != AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE + AI013x0x1xDecoder.DATE_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI013x0x1xDecoder.HEADER_SIZE);
            this.encodeCompressedWeight(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE, AI013x0x1xDecoder.WEIGHT_SIZE);
            this.encodeCompressedDate(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE);
            return buf.toString();
        }
        encodeCompressedDate(buf, currentPos) {
            let numericDate = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, AI013x0x1xDecoder.DATE_SIZE);
            if (numericDate == 38400) return;
            buf.append('(');
            buf.append(this.dateCode);
            buf.append(')');
            let day = numericDate % 32;
            numericDate /= 32;
            let month = numericDate % 12 + 1;
            numericDate /= 12;
            let year = numericDate;
            if (year / 10 == 0) buf.append('0');
            buf.append(year);
            if (month / 10 == 0) buf.append('0');
            buf.append(month);
            if (day / 10 == 0) buf.append('0');
            buf.append(day);
        }
        addWeightCode(buf, weight) {
            buf.append('(');
            buf.append(this.firstAIdigits);
            buf.append(weight / 100000);
            buf.append(')');
        }
        checkWeight(weight) {
            return weight % 100000;
        }
    }
    AI013x0x1xDecoder.HEADER_SIZE = 8;
    AI013x0x1xDecoder.WEIGHT_SIZE = 20;
    AI013x0x1xDecoder.DATE_SIZE = 16;
    function createDecoder(information) {
        try {
            if (information.get(1)) return new AI01AndOtherAIs(information);
            if (!information.get(2)) return new AnyAIDecoder(information);
            let fourBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 4);
            switch(fourBitEncodationMethod){
                case 4:
                    return new AI013103decoder(information);
                case 5:
                    return new AI01320xDecoder(information);
            }
            let fiveBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 5);
            switch(fiveBitEncodationMethod){
                case 12:
                    return new AI01392xDecoder(information);
                case 13:
                    return new AI01393xDecoder(information);
            }
            let sevenBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 7);
            switch(sevenBitEncodationMethod){
                case 56:
                    return new AI013x0x1xDecoder(information, '310', '11');
                case 57:
                    return new AI013x0x1xDecoder(information, '320', '11');
                case 58:
                    return new AI013x0x1xDecoder(information, '310', '13');
                case 59:
                    return new AI013x0x1xDecoder(information, '320', '13');
                case 60:
                    return new AI013x0x1xDecoder(information, '310', '15');
                case 61:
                    return new AI013x0x1xDecoder(information, '320', '15');
                case 62:
                    return new AI013x0x1xDecoder(information, '310', '17');
                case 63:
                    return new AI013x0x1xDecoder(information, '320', '17');
            }
        } catch (e) {
            console.log(e);
            throw new IllegalStateException('unknown decoder: ' + information);
        }
    }
    class ExpandedPair {
        constructor(leftChar, rightChar, finderPatter, mayBeLast){
            this.leftchar = leftChar;
            this.rightchar = rightChar;
            this.finderpattern = finderPatter;
            this.maybeLast = mayBeLast;
        }
        mayBeLast() {
            return this.maybeLast;
        }
        getLeftChar() {
            return this.leftchar;
        }
        getRightChar() {
            return this.rightchar;
        }
        getFinderPattern() {
            return this.finderpattern;
        }
        mustBeLast() {
            return this.rightchar == null;
        }
        toString() {
            return '[ ' + this.leftchar + ', ' + this.rightchar + ' : ' + (this.finderpattern == null ? 'null' : this.finderpattern.getValue()) + ' ]';
        }
        static equals(o1, o2) {
            if (!(o1 instanceof ExpandedPair)) return false;
            return ExpandedPair.equalsOrNull(o1.leftchar, o2.leftchar) && ExpandedPair.equalsOrNull(o1.rightchar, o2.rightchar) && ExpandedPair.equalsOrNull(o1.finderpattern, o2.finderpattern);
        }
        static equalsOrNull(o1, o2) {
            return o1 === null ? o2 === null : ExpandedPair.equals(o1, o2);
        }
        hashCode() {
            // return ExpandedPair.hashNotNull(leftChar) ^ hashNotNull(rightChar) ^ hashNotNull(finderPattern);
            let value = this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
            return value;
        }
    }
    class ExpandedRow {
        constructor(pairs, rowNumber, wasReversed){
            this.pairs = pairs;
            this.rowNumber = rowNumber;
            this.wasReversed = wasReversed;
        }
        getPairs() {
            return this.pairs;
        }
        getRowNumber() {
            return this.rowNumber;
        }
        isReversed() {
            return this.wasReversed;
        }
        // check implementation
        isEquivalent(otherPairs) {
            return this.checkEqualitity(this, otherPairs);
        }
        // @Override
        toString() {
            return '{ ' + this.pairs + ' }';
        }
        /**
         * Two rows are equal if they contain the same pairs in the same order.
         */ // @Override
        // check implementation
        equals(o1, o2) {
            if (!(o1 instanceof ExpandedRow)) return false;
            return this.checkEqualitity(o1, o2) && o1.wasReversed === o2.wasReversed;
        }
        checkEqualitity(pair1, pair2) {
            if (!pair1 || !pair2) return;
            let result;
            pair1.forEach((e1, i)=>{
                pair2.forEach((e2)=>{
                    if (e1.getLeftChar().getValue() === e2.getLeftChar().getValue() && e1.getRightChar().getValue() === e2.getRightChar().getValue() && e1.getFinderPatter().getValue() === e2.getFinderPatter().getValue()) result = true;
                });
            });
            return result;
        }
    }
    // import java.util.ArrayList;
    // import java.util.Iterator;
    // import java.util.List;
    // import java.util.Map;
    // import java.util.Collections;
    class RSSExpandedReader extends AbstractRSSReader {
        constructor(verbose){
            super(...arguments);
            this.pairs = new Array(RSSExpandedReader.MAX_PAIRS);
            this.rows = new Array();
            this.startEnd = [
                2
            ];
            this.verbose = verbose === true;
        }
        decodeRow(rowNumber, row, hints) {
            // Rows can start with even pattern in case in prev rows there where odd number of patters.
            // So lets try twice
            // this.pairs.clear();
            this.pairs.length = 0;
            this.startFromEven = false;
            try {
                return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
            } catch (e) {
                // OK
                if (this.verbose) console.log(e);
            }
            this.pairs.length = 0;
            this.startFromEven = true;
            return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
        }
        reset() {
            this.pairs.length = 0;
            this.rows.length = 0;
        }
        // Not private for testing
        decodeRow2pairs(rowNumber, row) {
            let done = false;
            while(!done)try {
                this.pairs.push(this.retrieveNextPair(row, this.pairs, rowNumber));
            } catch (error) {
                if (error instanceof NotFoundException) {
                    if (!this.pairs.length) throw new NotFoundException();
                    // exit this loop when retrieveNextPair() fails and throws
                    done = true;
                }
            }
            // TODO: verify sequence of finder patterns as in checkPairSequence()
            if (this.checkChecksum()) return this.pairs;
            let tryStackedDecode;
            if (this.rows.length) tryStackedDecode = true;
            else tryStackedDecode = false;
            // let tryStackedDecode = !this.rows.isEmpty();
            this.storeRow(rowNumber, false); // TODO: deal with reversed rows
            if (tryStackedDecode) {
                // When the image is 180-rotated, then rows are sorted in wrong direction.
                // Try twice with both the directions.
                let ps = this.checkRowsBoolean(false);
                if (ps != null) return ps;
                ps = this.checkRowsBoolean(true);
                if (ps != null) return ps;
            }
            throw new NotFoundException();
        }
        // Need to Verify
        checkRowsBoolean(reverse) {
            // Limit number of rows we are checking
            // We use recursive algorithm with pure complexity and don't want it to take forever
            // Stacked barcode can have up to 11 rows, so 25 seems reasonable enough
            if (this.rows.length > 25) {
                this.rows.length = 0; // We will never have a chance to get result, so clear it
                return null;
            }
            this.pairs.length = 0;
            if (reverse) this.rows = this.rows.reverse();
            let ps = null;
            try {
                ps = this.checkRows(new Array(), 0);
            } catch (e) {
                // OK
                if (this.verbose) console.log(e);
            }
            if (reverse) this.rows = this.rows.reverse();
            return ps;
        }
        // Try to construct a valid rows sequence
        // Recursion is used to implement backtracking
        checkRows(collectedRows, currentRow) {
            for(let i = currentRow; i < this.rows.length; i++){
                let row = this.rows[i];
                this.pairs.length = 0;
                for (let collectedRow of collectedRows)this.pairs.push(collectedRow.getPairs());
                this.pairs.push(row.getPairs());
                if (!RSSExpandedReader.isValidSequence(this.pairs)) continue;
                if (this.checkChecksum()) return this.pairs;
                let rs = new Array(collectedRows);
                rs.push(row);
                try {
                    // Recursion: try to add more rows
                    return this.checkRows(rs, i + 1);
                } catch (e) {
                    // We failed, try the next candidate
                    if (this.verbose) console.log(e);
                }
            }
            throw new NotFoundException();
        }
        // Whether the pairs form a valid find pattern sequence,
        // either complete or a prefix
        static isValidSequence(pairs) {
            for (let sequence of RSSExpandedReader.FINDER_PATTERN_SEQUENCES){
                if (pairs.length > sequence.length) continue;
                let stop = true;
                for(let j = 0; j < pairs.length; j++)if (pairs[j].getFinderPattern().getValue() != sequence[j]) {
                    stop = false;
                    break;
                }
                if (stop) return true;
            }
            return false;
        }
        storeRow(rowNumber, wasReversed) {
            // Discard if duplicate above or below; otherwise insert in order by row number.
            let insertPos = 0;
            let prevIsSame = false;
            let nextIsSame = false;
            while(insertPos < this.rows.length){
                let erow = this.rows[insertPos];
                if (erow.getRowNumber() > rowNumber) {
                    nextIsSame = erow.isEquivalent(this.pairs);
                    break;
                }
                prevIsSame = erow.isEquivalent(this.pairs);
                insertPos++;
            }
            if (nextIsSame || prevIsSame) return;
            // When the row was partially decoded (e.g. 2 pairs found instead of 3),
            // it will prevent us from detecting the barcode.
            // Try to merge partial rows
            // Check whether the row is part of an allready detected row
            if (RSSExpandedReader.isPartialRow(this.pairs, this.rows)) return;
            this.rows.push(insertPos, new ExpandedRow(this.pairs, rowNumber, wasReversed));
            this.removePartialRows(this.pairs, this.rows);
        }
        // Remove all the rows that contains only specified pairs
        removePartialRows(pairs, rows) {
            // for (Iterator<ExpandedRow> iterator = rows.iterator(); iterator.hasNext();) {
            //   ExpandedRow r = iterator.next();
            //   if (r.getPairs().size() == pairs.size()) {
            //     continue;
            //   }
            //   boolean allFound = true;
            //   for (ExpandedPair p : r.getPairs()) {
            //     boolean found = false;
            //     for (ExpandedPair pp : pairs) {
            //       if (p.equals(pp)) {
            //         found = true;
            //         break;
            //       }
            //     }
            //     if (!found) {
            //       allFound = false;
            //       break;
            //     }
            //   }
            //   if (allFound) {
            //     // 'pairs' contains all the pairs from the row 'r'
            //     iterator.remove();
            //   }
            // }
            for (let row of rows){
                if (row.getPairs().length === pairs.length) continue;
                for (let p of row.getPairs())for (let pp of pairs){
                    if (ExpandedPair.equals(p, pp)) break;
                }
            }
        }
        // Returns true when one of the rows already contains all the pairs
        static isPartialRow(pairs, rows) {
            for (let r of rows){
                let allFound = true;
                for (let p of pairs){
                    let found = false;
                    for (let pp of r.getPairs())if (p.equals(pp)) {
                        found = true;
                        break;
                    }
                    if (!found) {
                        allFound = false;
                        break;
                    }
                }
                if (allFound) // the row 'r' contain all the pairs from 'pairs'
                return true;
            }
            return false;
        }
        // Only used for unit testing
        getRows() {
            return this.rows;
        }
        // Not private for unit testing
        static constructResult(pairs) {
            let binary = BitArrayBuilder.buildBitArray(pairs);
            let decoder = createDecoder(binary);
            let resultingString = decoder.parseInformation();
            let firstPoints = pairs[0].getFinderPattern().getResultPoints();
            let lastPoints = pairs[pairs.length - 1].getFinderPattern().getResultPoints();
            let points = [
                firstPoints[0],
                firstPoints[1],
                lastPoints[0],
                lastPoints[1]
            ];
            return new Result(resultingString, null, null, points, BarcodeFormat$1.RSS_EXPANDED, null);
        }
        checkChecksum() {
            let firstPair = this.pairs.get(0);
            let checkCharacter = firstPair.getLeftChar();
            let firstCharacter = firstPair.getRightChar();
            if (firstCharacter == null) return false;
            let checksum = firstCharacter.getChecksumPortion();
            let s = 2;
            for(let i = 1; i < this.pairs.size(); ++i){
                let currentPair = this.pairs.get(i);
                checksum += currentPair.getLeftChar().getChecksumPortion();
                s++;
                let currentRightChar = currentPair.getRightChar();
                if (currentRightChar != null) {
                    checksum += currentRightChar.getChecksumPortion();
                    s++;
                }
            }
            checksum %= 211;
            let checkCharacterValue = 211 * (s - 4) + checksum;
            return checkCharacterValue == checkCharacter.getValue();
        }
        static getNextSecondBar(row, initialPos) {
            let currentPos;
            if (row.get(initialPos)) {
                currentPos = row.getNextUnset(initialPos);
                currentPos = row.getNextSet(currentPos);
            } else {
                currentPos = row.getNextSet(initialPos);
                currentPos = row.getNextUnset(currentPos);
            }
            return currentPos;
        }
        // not private for testing
        retrieveNextPair(row, previousPairs, rowNumber) {
            let isOddPattern = previousPairs.length % 2 == 0;
            if (this.startFromEven) isOddPattern = !isOddPattern;
            let pattern;
            let keepFinding = true;
            let forcedOffset = -1;
            do {
                this.findNextPair(row, previousPairs, forcedOffset);
                pattern = this.parseFoundFinderPattern(row, rowNumber, isOddPattern);
                if (pattern == null) forcedOffset = RSSExpandedReader.getNextSecondBar(row, this.startEnd[0]);
                else keepFinding = false;
            }while (keepFinding);
            // When stacked symbol is split over multiple rows, there's no way to guess if this pair can be last or not.
            // boolean mayBeLast = checkPairSequence(previousPairs, pattern);
            let leftChar = this.decodeDataCharacter(row, pattern, isOddPattern, true);
            if (!this.isEmptyPair(previousPairs) && previousPairs[previousPairs.length - 1].mustBeLast()) throw new NotFoundException();
            let rightChar;
            try {
                rightChar = this.decodeDataCharacter(row, pattern, isOddPattern, false);
            } catch (e) {
                rightChar = null;
                if (this.verbose) console.log(e);
            }
            return new ExpandedPair(leftChar, rightChar, pattern, true);
        }
        isEmptyPair(pairs) {
            if (pairs.length === 0) return true;
            return false;
        }
        findNextPair(row, previousPairs, forcedOffset) {
            let counters = this.getDecodeFinderCounters();
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let width = row.getSize();
            let rowOffset;
            if (forcedOffset >= 0) rowOffset = forcedOffset;
            else if (this.isEmptyPair(previousPairs)) rowOffset = 0;
            else {
                let lastPair = previousPairs[previousPairs.length - 1];
                rowOffset = lastPair.getFinderPattern().getStartEnd()[1];
            }
            let searchingEvenPair = previousPairs.length % 2 != 0;
            if (this.startFromEven) searchingEvenPair = !searchingEvenPair;
            let isWhite = false;
            while(rowOffset < width){
                isWhite = !row.get(rowOffset);
                if (!isWhite) break;
                rowOffset++;
            }
            let counterPosition = 0;
            let patternStart = rowOffset;
            for(let x = rowOffset; x < width; x++)if (row.get(x) != isWhite) counters[counterPosition]++;
            else {
                if (counterPosition == 3) {
                    if (searchingEvenPair) RSSExpandedReader.reverseCounters(counters);
                    if (RSSExpandedReader.isFinderPattern(counters)) {
                        this.startEnd[0] = patternStart;
                        this.startEnd[1] = x;
                        return;
                    }
                    if (searchingEvenPair) RSSExpandedReader.reverseCounters(counters);
                    patternStart += counters[0] + counters[1];
                    counters[0] = counters[2];
                    counters[1] = counters[3];
                    counters[2] = 0;
                    counters[3] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        static reverseCounters(counters) {
            let length = counters.length;
            for(let i = 0; i < length / 2; ++i){
                let tmp = counters[i];
                counters[i] = counters[length - i - 1];
                counters[length - i - 1] = tmp;
            }
        }
        parseFoundFinderPattern(row, rowNumber, oddPattern) {
            // Actually we found elements 2-5.
            let firstCounter;
            let start;
            let end;
            if (oddPattern) {
                // If pattern number is odd, we need to locate element 1 *before* the current block.
                let firstElementStart = this.startEnd[0] - 1;
                // Locate element 1
                while(firstElementStart >= 0 && !row.get(firstElementStart))firstElementStart--;
                firstElementStart++;
                firstCounter = this.startEnd[0] - firstElementStart;
                start = firstElementStart;
                end = this.startEnd[1];
            } else {
                // If pattern number is even, the pattern is reversed, so we need to locate element 1 *after* the current block.
                start = this.startEnd[0];
                end = row.getNextUnset(this.startEnd[1] + 1);
                firstCounter = end - this.startEnd[1];
            }
            // Make 'counters' hold 1-4
            let counters = this.getDecodeFinderCounters();
            System.arraycopy(counters, 0, counters, 1, counters.length - 1);
            counters[0] = firstCounter;
            let value;
            try {
                value = this.parseFinderValue(counters, RSSExpandedReader.FINDER_PATTERNS);
            } catch (e) {
                return null;
            }
            // return new FinderPattern(value, new int[] { start, end }, start, end, rowNumber});
            return new FinderPattern(value, [
                start,
                end
            ], start, end, rowNumber);
        }
        decodeDataCharacter(row, pattern, isOddPattern, leftChar) {
            let counters = this.getDataCharacterCounters();
            for(let x = 0; x < counters.length; x++)counters[x] = 0;
            if (leftChar) RSSExpandedReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
            else {
                RSSExpandedReader.recordPattern(row, pattern.getStartEnd()[1], counters);
                // reverse it
                for(let i = 0, j = counters.length - 1; i < j; i++, j--){
                    let temp = counters[i];
                    counters[i] = counters[j];
                    counters[j] = temp;
                }
            } // counters[] has the pixels of the module
            let numModules = 17; // left and right data characters have all the same length
            let elementWidth = MathUtils.sum(new Int32Array(counters)) / numModules;
            // Sanity check: element width for pattern and the character should match
            let expectedElementWidth = (pattern.getStartEnd()[1] - pattern.getStartEnd()[0]) / 15.0;
            if (Math.abs(elementWidth - expectedElementWidth) / expectedElementWidth > 0.3) throw new NotFoundException();
            let oddCounts = this.getOddCounts();
            let evenCounts = this.getEvenCounts();
            let oddRoundingErrors = this.getOddRoundingErrors();
            let evenRoundingErrors = this.getEvenRoundingErrors();
            for(let i = 0; i < counters.length; i++){
                let value = 1.0 * counters[i] / elementWidth;
                let count = value + 0.5; // Round
                if (count < 1) {
                    if (value < 0.3) throw new NotFoundException();
                    count = 1;
                } else if (count > 8) {
                    if (value > 8.7) throw new NotFoundException();
                    count = 8;
                }
                let offset = i / 2;
                if ((i & 0x01) == 0) {
                    oddCounts[offset] = count;
                    oddRoundingErrors[offset] = value - count;
                } else {
                    evenCounts[offset] = count;
                    evenRoundingErrors[offset] = value - count;
                }
            }
            this.adjustOddEvenCounts(numModules);
            let weightRowNumber = 4 * pattern.getValue() + (isOddPattern ? 0 : 2) + (leftChar ? 0 : 1) - 1;
            let oddSum = 0;
            let oddChecksumPortion = 0;
            for(let i = oddCounts.length - 1; i >= 0; i--){
                if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
                    let weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i];
                    oddChecksumPortion += oddCounts[i] * weight;
                }
                oddSum += oddCounts[i];
            }
            let evenChecksumPortion = 0;
            // int evenSum = 0;
            for(let i = evenCounts.length - 1; i >= 0; i--)if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
                let weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i + 1];
                evenChecksumPortion += evenCounts[i] * weight;
            }
            let checksumPortion = oddChecksumPortion + evenChecksumPortion;
            if ((oddSum & 0x01) != 0 || oddSum > 13 || oddSum < 4) throw new NotFoundException();
            let group = (13 - oddSum) / 2;
            let oddWidest = RSSExpandedReader.SYMBOL_WIDEST[group];
            let evenWidest = 9 - oddWidest;
            let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, true);
            let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, false);
            let tEven = RSSExpandedReader.EVEN_TOTAL_SUBSET[group];
            let gSum = RSSExpandedReader.GSUM[group];
            let value = vOdd * tEven + vEven + gSum;
            return new DataCharacter(value, checksumPortion);
        }
        static isNotA1left(pattern, isOddPattern, leftChar) {
            // A1: pattern.getValue is 0 (A), and it's an oddPattern, and it is a left char
            return !(pattern.getValue() == 0 && isOddPattern && leftChar);
        }
        adjustOddEvenCounts(numModules) {
            let oddSum = MathUtils.sum(new Int32Array(this.getOddCounts()));
            let evenSum = MathUtils.sum(new Int32Array(this.getEvenCounts()));
            let incrementOdd = false;
            let decrementOdd = false;
            if (oddSum > 13) decrementOdd = true;
            else if (oddSum < 4) incrementOdd = true;
            let incrementEven = false;
            let decrementEven = false;
            if (evenSum > 13) decrementEven = true;
            else if (evenSum < 4) incrementEven = true;
            let mismatch = oddSum + evenSum - numModules;
            let oddParityBad = (oddSum & 0x01) == 1;
            let evenParityBad = (evenSum & 0x01) == 0;
            if (mismatch == 1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    decrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    decrementEven = true;
                }
            } else if (mismatch == -1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    incrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    incrementEven = true;
                }
            } else if (mismatch == 0) {
                if (oddParityBad) {
                    if (!evenParityBad) throw new NotFoundException();
                    // Both bad
                    if (oddSum < evenSum) {
                        incrementOdd = true;
                        decrementEven = true;
                    } else {
                        decrementOdd = true;
                        incrementEven = true;
                    }
                } else {
                    if (evenParityBad) throw new NotFoundException();
                // Nothing to do!
                }
            } else throw new NotFoundException();
            if (incrementOdd) {
                if (decrementOdd) throw new NotFoundException();
                RSSExpandedReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
            }
            if (decrementOdd) RSSExpandedReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
            if (incrementEven) {
                if (decrementEven) throw new NotFoundException();
                RSSExpandedReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
            }
            if (decrementEven) RSSExpandedReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
        }
    }
    RSSExpandedReader.SYMBOL_WIDEST = [
        7,
        5,
        4,
        3,
        1
    ];
    RSSExpandedReader.EVEN_TOTAL_SUBSET = [
        4,
        20,
        52,
        104,
        204
    ];
    RSSExpandedReader.GSUM = [
        0,
        348,
        1388,
        2948,
        3988
    ];
    RSSExpandedReader.FINDER_PATTERNS = [
        Int32Array.from([
            1,
            8,
            4,
            1
        ]),
        Int32Array.from([
            3,
            6,
            4,
            1
        ]),
        Int32Array.from([
            3,
            4,
            6,
            1
        ]),
        Int32Array.from([
            3,
            2,
            8,
            1
        ]),
        Int32Array.from([
            2,
            6,
            5,
            1
        ]),
        Int32Array.from([
            2,
            2,
            9,
            1
        ]) // F
    ];
    RSSExpandedReader.WEIGHTS = [
        [
            1,
            3,
            9,
            27,
            81,
            32,
            96,
            77
        ],
        [
            20,
            60,
            180,
            118,
            143,
            7,
            21,
            63
        ],
        [
            189,
            145,
            13,
            39,
            117,
            140,
            209,
            205
        ],
        [
            193,
            157,
            49,
            147,
            19,
            57,
            171,
            91
        ],
        [
            62,
            186,
            136,
            197,
            169,
            85,
            44,
            132
        ],
        [
            185,
            133,
            188,
            142,
            4,
            12,
            36,
            108
        ],
        [
            113,
            128,
            173,
            97,
            80,
            29,
            87,
            50
        ],
        [
            150,
            28,
            84,
            41,
            123,
            158,
            52,
            156
        ],
        [
            46,
            138,
            203,
            187,
            139,
            206,
            196,
            166
        ],
        [
            76,
            17,
            51,
            153,
            37,
            111,
            122,
            155
        ],
        [
            43,
            129,
            176,
            106,
            107,
            110,
            119,
            146
        ],
        [
            16,
            48,
            144,
            10,
            30,
            90,
            59,
            177
        ],
        [
            109,
            116,
            137,
            200,
            178,
            112,
            125,
            164
        ],
        [
            70,
            210,
            208,
            202,
            184,
            130,
            179,
            115
        ],
        [
            134,
            191,
            151,
            31,
            93,
            68,
            204,
            190
        ],
        [
            148,
            22,
            66,
            198,
            172,
            94,
            71,
            2
        ],
        [
            6,
            18,
            54,
            162,
            64,
            192,
            154,
            40
        ],
        [
            120,
            149,
            25,
            75,
            14,
            42,
            126,
            167
        ],
        [
            79,
            26,
            78,
            23,
            69,
            207,
            199,
            175
        ],
        [
            103,
            98,
            83,
            38,
            114,
            131,
            182,
            124
        ],
        [
            161,
            61,
            183,
            127,
            170,
            88,
            53,
            159
        ],
        [
            55,
            165,
            73,
            8,
            24,
            72,
            5,
            15
        ],
        [
            45,
            135,
            194,
            160,
            58,
            174,
            100,
            89
        ]
    ];
    RSSExpandedReader.FINDER_PAT_A = 0;
    RSSExpandedReader.FINDER_PAT_B = 1;
    RSSExpandedReader.FINDER_PAT_C = 2;
    RSSExpandedReader.FINDER_PAT_D = 3;
    RSSExpandedReader.FINDER_PAT_E = 4;
    RSSExpandedReader.FINDER_PAT_F = 5;
    RSSExpandedReader.FINDER_PATTERN_SEQUENCES = [
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_C
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_E
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ]
    ];
    RSSExpandedReader.MAX_PAIRS = 11;
    class Pair extends DataCharacter {
        constructor(value, checksumPortion, finderPattern){
            super(value, checksumPortion);
            this.count = 0;
            this.finderPattern = finderPattern;
        }
        getFinderPattern() {
            return this.finderPattern;
        }
        getCount() {
            return this.count;
        }
        incrementCount() {
            this.count++;
        }
    }
    class RSS14Reader extends AbstractRSSReader {
        constructor(){
            super(...arguments);
            this.possibleLeftPairs = [];
            this.possibleRightPairs = [];
        }
        decodeRow(rowNumber, row, hints) {
            const leftPair = this.decodePair(row, false, rowNumber, hints);
            RSS14Reader.addOrTally(this.possibleLeftPairs, leftPair);
            row.reverse();
            let rightPair = this.decodePair(row, true, rowNumber, hints);
            RSS14Reader.addOrTally(this.possibleRightPairs, rightPair);
            row.reverse();
            for (let left of this.possibleLeftPairs){
                if (left.getCount() > 1) for (let right of this.possibleRightPairs){
                    if (right.getCount() > 1 && RSS14Reader.checkChecksum(left, right)) return RSS14Reader.constructResult(left, right);
                }
            }
            throw new NotFoundException();
        }
        static addOrTally(possiblePairs, pair) {
            if (pair == null) return;
            let found = false;
            for (let other of possiblePairs)if (other.getValue() === pair.getValue()) {
                other.incrementCount();
                found = true;
                break;
            }
            if (!found) possiblePairs.push(pair);
        }
        reset() {
            this.possibleLeftPairs.length = 0;
            this.possibleRightPairs.length = 0;
        }
        static constructResult(leftPair, rightPair) {
            let symbolValue = 4537077 * leftPair.getValue() + rightPair.getValue();
            let text = new String(symbolValue).toString();
            let buffer = new StringBuilder();
            for(let i = 13 - text.length; i > 0; i--)buffer.append('0');
            buffer.append(text);
            let checkDigit = 0;
            for(let i = 0; i < 13; i++){
                let digit = buffer.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                checkDigit += (i & 0x01) === 0 ? 3 * digit : digit;
            }
            checkDigit = 10 - checkDigit % 10;
            if (checkDigit === 10) checkDigit = 0;
            buffer.append(checkDigit.toString());
            let leftPoints = leftPair.getFinderPattern().getResultPoints();
            let rightPoints = rightPair.getFinderPattern().getResultPoints();
            return new Result(buffer.toString(), null, 0, [
                leftPoints[0],
                leftPoints[1],
                rightPoints[0],
                rightPoints[1]
            ], BarcodeFormat$1.RSS_14, new Date().getTime());
        }
        static checkChecksum(leftPair, rightPair) {
            let checkValue = (leftPair.getChecksumPortion() + 16 * rightPair.getChecksumPortion()) % 79;
            let targetCheckValue = 9 * leftPair.getFinderPattern().getValue() + rightPair.getFinderPattern().getValue();
            if (targetCheckValue > 72) targetCheckValue--;
            if (targetCheckValue > 8) targetCheckValue--;
            return checkValue === targetCheckValue;
        }
        decodePair(row, right, rowNumber, hints) {
            try {
                let startEnd = this.findFinderPattern(row, right);
                let pattern = this.parseFoundFinderPattern(row, rowNumber, right, startEnd);
                let resultPointCallback = hints == null ? null : hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                if (resultPointCallback != null) {
                    let center = (startEnd[0] + startEnd[1]) / 2.0;
                    if (right) // row is actually reversed
                    center = row.getSize() - 1 - center;
                    resultPointCallback.foundPossibleResultPoint(new ResultPoint(center, rowNumber));
                }
                let outside = this.decodeDataCharacter(row, pattern, true);
                let inside = this.decodeDataCharacter(row, pattern, false);
                return new Pair(1597 * outside.getValue() + inside.getValue(), outside.getChecksumPortion() + 4 * inside.getChecksumPortion(), pattern);
            } catch (err) {
                return null;
            }
        }
        decodeDataCharacter(row, pattern, outsideChar) {
            let counters = this.getDataCharacterCounters();
            for(let x = 0; x < counters.length; x++)counters[x] = 0;
            if (outsideChar) OneDReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
            else {
                OneDReader.recordPattern(row, pattern.getStartEnd()[1] + 1, counters);
                // reverse it
                for(let i = 0, j = counters.length - 1; i < j; i++, j--){
                    let temp = counters[i];
                    counters[i] = counters[j];
                    counters[j] = temp;
                }
            }
            let numModules = outsideChar ? 16 : 15;
            let elementWidth = MathUtils.sum(new Int32Array(counters)) / numModules;
            let oddCounts = this.getOddCounts();
            let evenCounts = this.getEvenCounts();
            let oddRoundingErrors = this.getOddRoundingErrors();
            let evenRoundingErrors = this.getEvenRoundingErrors();
            for(let i = 0; i < counters.length; i++){
                let value = counters[i] / elementWidth;
                let count = Math.floor(value + 0.5);
                if (count < 1) count = 1;
                else if (count > 8) count = 8;
                let offset = Math.floor(i / 2);
                if ((i & 0x01) === 0) {
                    oddCounts[offset] = count;
                    oddRoundingErrors[offset] = value - count;
                } else {
                    evenCounts[offset] = count;
                    evenRoundingErrors[offset] = value - count;
                }
            }
            this.adjustOddEvenCounts(outsideChar, numModules);
            let oddSum = 0;
            let oddChecksumPortion = 0;
            for(let i = oddCounts.length - 1; i >= 0; i--){
                oddChecksumPortion *= 9;
                oddChecksumPortion += oddCounts[i];
                oddSum += oddCounts[i];
            }
            let evenChecksumPortion = 0;
            let evenSum = 0;
            for(let i = evenCounts.length - 1; i >= 0; i--){
                evenChecksumPortion *= 9;
                evenChecksumPortion += evenCounts[i];
                evenSum += evenCounts[i];
            }
            let checksumPortion = oddChecksumPortion + 3 * evenChecksumPortion;
            if (outsideChar) {
                if ((oddSum & 0x01) !== 0 || oddSum > 12 || oddSum < 4) throw new NotFoundException();
                let group = (12 - oddSum) / 2;
                let oddWidest = RSS14Reader.OUTSIDE_ODD_WIDEST[group];
                let evenWidest = 9 - oddWidest;
                let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, false);
                let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, true);
                let tEven = RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET[group];
                let gSum = RSS14Reader.OUTSIDE_GSUM[group];
                return new DataCharacter(vOdd * tEven + vEven + gSum, checksumPortion);
            } else {
                if ((evenSum & 0x01) !== 0 || evenSum > 10 || evenSum < 4) throw new NotFoundException();
                let group = (10 - evenSum) / 2;
                let oddWidest = RSS14Reader.INSIDE_ODD_WIDEST[group];
                let evenWidest = 9 - oddWidest;
                let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, true);
                let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, false);
                let tOdd = RSS14Reader.INSIDE_ODD_TOTAL_SUBSET[group];
                let gSum = RSS14Reader.INSIDE_GSUM[group];
                return new DataCharacter(vEven * tOdd + vOdd + gSum, checksumPortion);
            }
        }
        findFinderPattern(row, rightFinderPattern) {
            let counters = this.getDecodeFinderCounters();
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let width = row.getSize();
            let isWhite = false;
            let rowOffset = 0;
            while(rowOffset < width){
                isWhite = !row.get(rowOffset);
                if (rightFinderPattern === isWhite) break;
                rowOffset++;
            }
            let counterPosition = 0;
            let patternStart = rowOffset;
            for(let x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === 3) {
                    if (AbstractRSSReader.isFinderPattern(counters)) return [
                        patternStart,
                        x
                    ];
                    patternStart += counters[0] + counters[1];
                    counters[0] = counters[2];
                    counters[1] = counters[3];
                    counters[2] = 0;
                    counters[3] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        parseFoundFinderPattern(row, rowNumber, right, startEnd) {
            // Actually we found elements 2-5
            let firstIsBlack = row.get(startEnd[0]);
            let firstElementStart = startEnd[0] - 1;
            // Locate element 1
            while(firstElementStart >= 0 && firstIsBlack !== row.get(firstElementStart))firstElementStart--;
            firstElementStart++;
            const firstCounter = startEnd[0] - firstElementStart;
            // Make 'counters' hold 1-4
            const counters = this.getDecodeFinderCounters();
            const copy = new Int32Array(counters.length);
            System.arraycopy(counters, 0, copy, 1, counters.length - 1);
            copy[0] = firstCounter;
            const value = this.parseFinderValue(copy, RSS14Reader.FINDER_PATTERNS);
            let start = firstElementStart;
            let end = startEnd[1];
            if (right) {
                // row is actually reversed
                start = row.getSize() - 1 - start;
                end = row.getSize() - 1 - end;
            }
            return new FinderPattern(value, [
                firstElementStart,
                startEnd[1]
            ], start, end, rowNumber);
        }
        adjustOddEvenCounts(outsideChar, numModules) {
            let oddSum = MathUtils.sum(new Int32Array(this.getOddCounts()));
            let evenSum = MathUtils.sum(new Int32Array(this.getEvenCounts()));
            let incrementOdd = false;
            let decrementOdd = false;
            let incrementEven = false;
            let decrementEven = false;
            if (outsideChar) {
                if (oddSum > 12) decrementOdd = true;
                else if (oddSum < 4) incrementOdd = true;
                if (evenSum > 12) decrementEven = true;
                else if (evenSum < 4) incrementEven = true;
            } else {
                if (oddSum > 11) decrementOdd = true;
                else if (oddSum < 5) incrementOdd = true;
                if (evenSum > 10) decrementEven = true;
                else if (evenSum < 4) incrementEven = true;
            }
            let mismatch = oddSum + evenSum - numModules;
            let oddParityBad = (oddSum & 0x01) === (outsideChar ? 1 : 0);
            let evenParityBad = (evenSum & 0x01) === 1;
            if (mismatch === 1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    decrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    decrementEven = true;
                }
            } else if (mismatch === -1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    incrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    incrementEven = true;
                }
            } else if (mismatch === 0) {
                if (oddParityBad) {
                    if (!evenParityBad) throw new NotFoundException();
                    // Both bad
                    if (oddSum < evenSum) {
                        incrementOdd = true;
                        decrementEven = true;
                    } else {
                        decrementOdd = true;
                        incrementEven = true;
                    }
                } else {
                    if (evenParityBad) throw new NotFoundException();
                // Nothing to do!
                }
            } else throw new NotFoundException();
            if (incrementOdd) {
                if (decrementOdd) throw new NotFoundException();
                AbstractRSSReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
            }
            if (decrementOdd) AbstractRSSReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
            if (incrementEven) {
                if (decrementEven) throw new NotFoundException();
                AbstractRSSReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
            }
            if (decrementEven) AbstractRSSReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
        }
    }
    RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET = [
        1,
        10,
        34,
        70,
        126
    ];
    RSS14Reader.INSIDE_ODD_TOTAL_SUBSET = [
        4,
        20,
        48,
        81
    ];
    RSS14Reader.OUTSIDE_GSUM = [
        0,
        161,
        961,
        2015,
        2715
    ];
    RSS14Reader.INSIDE_GSUM = [
        0,
        336,
        1036,
        1516
    ];
    RSS14Reader.OUTSIDE_ODD_WIDEST = [
        8,
        6,
        4,
        3,
        1
    ];
    RSS14Reader.INSIDE_ODD_WIDEST = [
        2,
        4,
        6,
        8
    ];
    RSS14Reader.FINDER_PATTERNS = [
        Int32Array.from([
            3,
            8,
            2,
            1
        ]),
        Int32Array.from([
            3,
            5,
            5,
            1
        ]),
        Int32Array.from([
            3,
            3,
            7,
            1
        ]),
        Int32Array.from([
            3,
            1,
            9,
            1
        ]),
        Int32Array.from([
            2,
            7,
            4,
            1
        ]),
        Int32Array.from([
            2,
            5,
            6,
            1
        ]),
        Int32Array.from([
            2,
            3,
            8,
            1
        ]),
        Int32Array.from([
            1,
            5,
            7,
            1
        ]),
        Int32Array.from([
            1,
            3,
            9,
            1
        ])
    ];
    /**
     * @author Daniel Switkin <dswitkin@google.com>
     * @author Sean Owen
     */ class MultiFormatOneDReader extends OneDReader {
        constructor(hints, verbose){
            super();
            this.readers = [];
            this.verbose = verbose === true;
            const possibleFormats = !hints ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            const useCode39CheckDigit = hints && hints.get(DecodeHintType$1.ASSUME_CODE_39_CHECK_DIGIT) !== undefined;
            if (possibleFormats) {
                if (possibleFormats.includes(BarcodeFormat$1.EAN_13) || possibleFormats.includes(BarcodeFormat$1.UPC_A) || possibleFormats.includes(BarcodeFormat$1.EAN_8) || possibleFormats.includes(BarcodeFormat$1.UPC_E)) this.readers.push(new MultiFormatUPCEANReader(hints));
                if (possibleFormats.includes(BarcodeFormat$1.CODE_39)) this.readers.push(new Code39Reader(useCode39CheckDigit));
                // if (possibleFormats.includes(BarcodeFormat.CODE_93)) {
                //    this.readers.push(new Code93Reader());
                // }
                if (possibleFormats.includes(BarcodeFormat$1.CODE_128)) this.readers.push(new Code128Reader());
                if (possibleFormats.includes(BarcodeFormat$1.ITF)) this.readers.push(new ITFReader());
                // if (possibleFormats.includes(BarcodeFormat.CODABAR)) {
                //    this.readers.push(new CodaBarReader());
                // }
                if (possibleFormats.includes(BarcodeFormat$1.RSS_14)) this.readers.push(new RSS14Reader());
                if (possibleFormats.includes(BarcodeFormat$1.RSS_EXPANDED)) this.readers.push(new RSSExpandedReader(this.verbose));
            } else {
                // Case when no hints were provided -> add all.
                this.readers.push(new MultiFormatUPCEANReader(hints));
                this.readers.push(new Code39Reader());
                // this.readers.push(new CodaBarReader());
                // this.readers.push(new Code93Reader());
                this.readers.push(new MultiFormatUPCEANReader(hints));
                this.readers.push(new Code128Reader());
                this.readers.push(new ITFReader());
                this.readers.push(new RSS14Reader());
                this.readers.push(new RSSExpandedReader(this.verbose));
            }
        }
        // @Override
        decodeRow(rowNumber, row, hints) {
            for(let i = 0; i < this.readers.length; i++)try {
                return this.readers[i].decodeRow(rowNumber, row, hints);
            } catch (re) {
            // continue
            }
            throw new NotFoundException();
        }
        // @Override
        reset() {
            this.readers.forEach((reader)=>reader.reset());
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     *
     * Barcode reader reader to use from browser.
     */ class BrowserBarcodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserBarcodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         * @param {Map<DecodeHintType, any>} hints
         */ constructor(timeBetweenScansMillis = 500, hints){
            super(new MultiFormatOneDReader(hints), timeBetweenScansMillis, hints);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
     * use blocks of differing sizes within one version, so, this encapsulates the parameters for
     * each set of blocks. It also holds the number of error-correction codewords per block since it
     * will be the same across all blocks within one version.</p>
     */ class ECBlocks {
        constructor(ecCodewords, ecBlocks1, ecBlocks2){
            this.ecCodewords = ecCodewords;
            this.ecBlocks = [
                ecBlocks1
            ];
            ecBlocks2 && this.ecBlocks.push(ecBlocks2);
        }
        getECCodewords() {
            return this.ecCodewords;
        }
        getECBlocks() {
            return this.ecBlocks;
        }
    }
    /**
     * <p>Encapsulates the parameters for one error-correction block in one symbol version.
     * This includes the number of data codewords, and the number of times a block with these
     * parameters is used consecutively in the Data Matrix code version's format.</p>
     */ class ECB {
        constructor(count, dataCodewords){
            this.count = count;
            this.dataCodewords = dataCodewords;
        }
        getCount() {
            return this.count;
        }
        getDataCodewords() {
            return this.dataCodewords;
        }
    }
    /**
     * The Version object encapsulates attributes about a particular
     * size Data Matrix Code.
     *
     * @author bbrown@google.com (Brian Brown)
     */ class Version {
        constructor(versionNumber, symbolSizeRows, symbolSizeColumns, dataRegionSizeRows, dataRegionSizeColumns, ecBlocks){
            this.versionNumber = versionNumber;
            this.symbolSizeRows = symbolSizeRows;
            this.symbolSizeColumns = symbolSizeColumns;
            this.dataRegionSizeRows = dataRegionSizeRows;
            this.dataRegionSizeColumns = dataRegionSizeColumns;
            this.ecBlocks = ecBlocks;
            // Calculate the total number of codewords
            let total = 0;
            const ecCodewords = ecBlocks.getECCodewords();
            const ecbArray = ecBlocks.getECBlocks();
            for (let ecBlock of ecbArray)total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            this.totalCodewords = total;
        }
        getVersionNumber() {
            return this.versionNumber;
        }
        getSymbolSizeRows() {
            return this.symbolSizeRows;
        }
        getSymbolSizeColumns() {
            return this.symbolSizeColumns;
        }
        getDataRegionSizeRows() {
            return this.dataRegionSizeRows;
        }
        getDataRegionSizeColumns() {
            return this.dataRegionSizeColumns;
        }
        getTotalCodewords() {
            return this.totalCodewords;
        }
        getECBlocks() {
            return this.ecBlocks;
        }
        /**
         * <p>Deduces version information from Data Matrix dimensions.</p>
         *
         * @param numRows Number of rows in modules
         * @param numColumns Number of columns in modules
         * @return Version for a Data Matrix Code of those dimensions
         * @throws FormatException if dimensions do correspond to a valid Data Matrix size
         */ static getVersionForDimensions(numRows, numColumns) {
            if ((numRows & 0x01) !== 0 || (numColumns & 0x01) !== 0) throw new FormatException();
            for (let version of Version.VERSIONS){
                if (version.symbolSizeRows === numRows && version.symbolSizeColumns === numColumns) return version;
            }
            throw new FormatException();
        }
        //  @Override
        toString() {
            return '' + this.versionNumber;
        }
        /**
         * See ISO 16022:2006 5.5.1 Table 7
         */ static buildVersions() {
            return [
                new Version(1, 10, 10, 8, 8, new ECBlocks(5, new ECB(1, 3))),
                new Version(2, 12, 12, 10, 10, new ECBlocks(7, new ECB(1, 5))),
                new Version(3, 14, 14, 12, 12, new ECBlocks(10, new ECB(1, 8))),
                new Version(4, 16, 16, 14, 14, new ECBlocks(12, new ECB(1, 12))),
                new Version(5, 18, 18, 16, 16, new ECBlocks(14, new ECB(1, 18))),
                new Version(6, 20, 20, 18, 18, new ECBlocks(18, new ECB(1, 22))),
                new Version(7, 22, 22, 20, 20, new ECBlocks(20, new ECB(1, 30))),
                new Version(8, 24, 24, 22, 22, new ECBlocks(24, new ECB(1, 36))),
                new Version(9, 26, 26, 24, 24, new ECBlocks(28, new ECB(1, 44))),
                new Version(10, 32, 32, 14, 14, new ECBlocks(36, new ECB(1, 62))),
                new Version(11, 36, 36, 16, 16, new ECBlocks(42, new ECB(1, 86))),
                new Version(12, 40, 40, 18, 18, new ECBlocks(48, new ECB(1, 114))),
                new Version(13, 44, 44, 20, 20, new ECBlocks(56, new ECB(1, 144))),
                new Version(14, 48, 48, 22, 22, new ECBlocks(68, new ECB(1, 174))),
                new Version(15, 52, 52, 24, 24, new ECBlocks(42, new ECB(2, 102))),
                new Version(16, 64, 64, 14, 14, new ECBlocks(56, new ECB(2, 140))),
                new Version(17, 72, 72, 16, 16, new ECBlocks(36, new ECB(4, 92))),
                new Version(18, 80, 80, 18, 18, new ECBlocks(48, new ECB(4, 114))),
                new Version(19, 88, 88, 20, 20, new ECBlocks(56, new ECB(4, 144))),
                new Version(20, 96, 96, 22, 22, new ECBlocks(68, new ECB(4, 174))),
                new Version(21, 104, 104, 24, 24, new ECBlocks(56, new ECB(6, 136))),
                new Version(22, 120, 120, 18, 18, new ECBlocks(68, new ECB(6, 175))),
                new Version(23, 132, 132, 20, 20, new ECBlocks(62, new ECB(8, 163))),
                new Version(24, 144, 144, 22, 22, new ECBlocks(62, new ECB(8, 156), new ECB(2, 155))),
                new Version(25, 8, 18, 6, 16, new ECBlocks(7, new ECB(1, 5))),
                new Version(26, 8, 32, 6, 14, new ECBlocks(11, new ECB(1, 10))),
                new Version(27, 12, 26, 10, 24, new ECBlocks(14, new ECB(1, 16))),
                new Version(28, 12, 36, 10, 16, new ECBlocks(18, new ECB(1, 22))),
                new Version(29, 16, 36, 14, 16, new ECBlocks(24, new ECB(1, 32))),
                new Version(30, 16, 48, 14, 22, new ECBlocks(28, new ECB(1, 49)))
            ];
        }
    }
    Version.VERSIONS = Version.buildVersions();
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author bbrown@google.com (Brian Brown)
     */ class BitMatrixParser {
        /**
         * @param bitMatrix {@link BitMatrix} to parse
         * @throws FormatException if dimension is < 8 or > 144 or not 0 mod 2
         */ constructor(bitMatrix){
            const dimension = bitMatrix.getHeight();
            if (dimension < 8 || dimension > 144 || (dimension & 0x01) !== 0) throw new FormatException();
            this.version = BitMatrixParser.readVersion(bitMatrix);
            this.mappingBitMatrix = this.extractDataRegion(bitMatrix);
            this.readMappingMatrix = new BitMatrix(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
        }
        getVersion() {
            return this.version;
        }
        /**
         * <p>Creates the version object based on the dimension of the original bit matrix from
         * the datamatrix code.</p>
         *
         * <p>See ISO 16022:2006 Table 7 - ECC 200 symbol attributes</p>
         *
         * @param bitMatrix Original {@link BitMatrix} including alignment patterns
         * @return {@link Version} encapsulating the Data Matrix Code's "version"
         * @throws FormatException if the dimensions of the mapping matrix are not valid
         * Data Matrix dimensions.
         */ static readVersion(bitMatrix) {
            const numRows = bitMatrix.getHeight();
            const numColumns = bitMatrix.getWidth();
            return Version.getVersionForDimensions(numRows, numColumns);
        }
        /**
         * <p>Reads the bits in the {@link BitMatrix} representing the mapping matrix (No alignment patterns)
         * in the correct order in order to reconstitute the codewords bytes contained within the
         * Data Matrix Code.</p>
         *
         * @return bytes encoded within the Data Matrix Code
         * @throws FormatException if the exact number of bytes expected is not read
         */ readCodewords() {
            const result = new Int8Array(this.version.getTotalCodewords());
            let resultOffset = 0;
            let row = 4;
            let column = 0;
            const numRows = this.mappingBitMatrix.getHeight();
            const numColumns = this.mappingBitMatrix.getWidth();
            let corner1Read = false;
            let corner2Read = false;
            let corner3Read = false;
            let corner4Read = false;
            // Read all of the codewords
            do {
                // Check the four corner cases
                if (row === numRows && column === 0 && !corner1Read) {
                    result[resultOffset++] = this.readCorner1(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner1Read = true;
                } else if (row === numRows - 2 && column === 0 && (numColumns & 0x03) !== 0 && !corner2Read) {
                    result[resultOffset++] = this.readCorner2(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner2Read = true;
                } else if (row === numRows + 4 && column === 2 && (numColumns & 0x07) === 0 && !corner3Read) {
                    result[resultOffset++] = this.readCorner3(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner3Read = true;
                } else if (row === numRows - 2 && column === 0 && (numColumns & 0x07) === 4 && !corner4Read) {
                    result[resultOffset++] = this.readCorner4(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner4Read = true;
                } else {
                    // Sweep upward diagonally to the right
                    do {
                        if (row < numRows && column >= 0 && !this.readMappingMatrix.get(column, row)) result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                        row -= 2;
                        column += 2;
                    }while (row >= 0 && column < numColumns);
                    row += 1;
                    column += 3;
                    // Sweep downward diagonally to the left
                    do {
                        if (row >= 0 && column < numColumns && !this.readMappingMatrix.get(column, row)) result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                        row += 2;
                        column -= 2;
                    }while (row < numRows && column >= 0);
                    row += 3;
                    column += 1;
                }
            }while (row < numRows || column < numColumns);
            if (resultOffset !== this.version.getTotalCodewords()) throw new FormatException();
            return result;
        }
        /**
         * <p>Reads a bit of the mapping matrix accounting for boundary wrapping.</p>
         *
         * @param row Row to read in the mapping matrix
         * @param column Column to read in the mapping matrix
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return value of the given bit in the mapping matrix
         */ readModule(row, column, numRows, numColumns) {
            // Adjust the row and column indices based on boundary wrapping
            if (row < 0) {
                row += numRows;
                column += 4 - (numRows + 4 & 0x07);
            }
            if (column < 0) {
                column += numColumns;
                row += 4 - (numColumns + 4 & 0x07);
            }
            this.readMappingMatrix.set(column, row);
            return this.mappingBitMatrix.get(column, row);
        }
        /**
         * <p>Reads the 8 bits of the standard Utah-shaped pattern.</p>
         *
         * <p>See ISO 16022:2006, 5.8.1 Figure 6</p>
         *
         * @param row Current row in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
         * @param column Current column in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the utah shape
         */ readUtah(row, column, numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(row - 2, column - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 2, column - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 1, column - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 1, column - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 1, column, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row, column - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row, column - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row, column, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 1.</p>
         *
         * <p>See ISO 16022:2006, Figure F.3</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 1
         */ readCorner1(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(2, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(3, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 2.</p>
         *
         * <p>See ISO 16022:2006, Figure F.4</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 2
         */ readCorner2(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 3, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 2, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 4, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 3, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 3.</p>
         *
         * <p>See ISO 16022:2006, Figure F.5</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 3
         */ readCorner3(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 3, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 3, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 4.</p>
         *
         * <p>See ISO 16022:2006, Figure F.6</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 4
         */ readCorner4(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 3, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 2, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(2, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(3, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Extracts the data region from a {@link BitMatrix} that contains
         * alignment patterns.</p>
         *
         * @param bitMatrix Original {@link BitMatrix} with alignment patterns
         * @return BitMatrix that has the alignment patterns removed
         */ extractDataRegion(bitMatrix) {
            const symbolSizeRows = this.version.getSymbolSizeRows();
            const symbolSizeColumns = this.version.getSymbolSizeColumns();
            if (bitMatrix.getHeight() !== symbolSizeRows) throw new IllegalArgumentException('Dimension of bitMatrix must match the version size');
            const dataRegionSizeRows = this.version.getDataRegionSizeRows();
            const dataRegionSizeColumns = this.version.getDataRegionSizeColumns();
            const numDataRegionsRow = symbolSizeRows / dataRegionSizeRows | 0;
            const numDataRegionsColumn = symbolSizeColumns / dataRegionSizeColumns | 0;
            const sizeDataRegionRow = numDataRegionsRow * dataRegionSizeRows;
            const sizeDataRegionColumn = numDataRegionsColumn * dataRegionSizeColumns;
            const bitMatrixWithoutAlignment = new BitMatrix(sizeDataRegionColumn, sizeDataRegionRow);
            for(let dataRegionRow = 0; dataRegionRow < numDataRegionsRow; ++dataRegionRow){
                const dataRegionRowOffset = dataRegionRow * dataRegionSizeRows;
                for(let dataRegionColumn = 0; dataRegionColumn < numDataRegionsColumn; ++dataRegionColumn){
                    const dataRegionColumnOffset = dataRegionColumn * dataRegionSizeColumns;
                    for(let i = 0; i < dataRegionSizeRows; ++i){
                        const readRowOffset = dataRegionRow * (dataRegionSizeRows + 2) + 1 + i;
                        const writeRowOffset = dataRegionRowOffset + i;
                        for(let j = 0; j < dataRegionSizeColumns; ++j){
                            const readColumnOffset = dataRegionColumn * (dataRegionSizeColumns + 2) + 1 + j;
                            if (bitMatrix.get(readColumnOffset, readRowOffset)) {
                                const writeColumnOffset = dataRegionColumnOffset + j;
                                bitMatrixWithoutAlignment.set(writeColumnOffset, writeRowOffset);
                            }
                        }
                    }
                }
            }
            return bitMatrixWithoutAlignment;
        }
    }
    /**
     * <p>Encapsulates a block of data within a Data Matrix Code. Data Matrix Codes may split their data into
     * multiple blocks, each of which is a unit of data and error-correction codewords. Each
     * is represented by an instance of this class.</p>
     *
     * @author bbrown@google.com (Brian Brown)
     */ class DataBlock {
        constructor(numDataCodewords, codewords){
            this.numDataCodewords = numDataCodewords;
            this.codewords = codewords;
        }
        /**
         * <p>When Data Matrix Codes use multiple data blocks, they actually interleave the bytes of each of them.
         * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
         * method will separate the data into original blocks.</p>
         *
         * @param rawCodewords bytes as read directly from the Data Matrix Code
         * @param version version of the Data Matrix Code
         * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
         *         Data Matrix Code
         */ static getDataBlocks(rawCodewords, version) {
            // Figure out the number and size of data blocks used by this version
            const ecBlocks = version.getECBlocks();
            // First count the total number of data blocks
            let totalBlocks = 0;
            const ecBlockArray = ecBlocks.getECBlocks();
            for (let ecBlock of ecBlockArray)totalBlocks += ecBlock.getCount();
            // Now establish DataBlocks of the appropriate size and number of data codewords
            const result = new Array(totalBlocks);
            let numResultBlocks = 0;
            for (let ecBlock of ecBlockArray)for(let i = 0; i < ecBlock.getCount(); i++){
                const numDataCodewords = ecBlock.getDataCodewords();
                const numBlockCodewords = ecBlocks.getECCodewords() + numDataCodewords;
                result[numResultBlocks++] = new DataBlock(numDataCodewords, new Uint8Array(numBlockCodewords));
            }
            // All blocks have the same amount of data, except that the last n
            // (where n may be 0) have 1 less byte. Figure out where these start.
            // TODO(bbrown): There is only one case where there is a difference for Data Matrix for size 144
            const longerBlocksTotalCodewords = result[0].codewords.length;
            // int shorterBlocksTotalCodewords = longerBlocksTotalCodewords - 1;
            const longerBlocksNumDataCodewords = longerBlocksTotalCodewords - ecBlocks.getECCodewords();
            const shorterBlocksNumDataCodewords = longerBlocksNumDataCodewords - 1;
            // The last elements of result may be 1 element shorter for 144 matrix
            // first fill out as many elements as all of them have minus 1
            let rawCodewordsOffset = 0;
            for(let i = 0; i < shorterBlocksNumDataCodewords; i++)for(let j = 0; j < numResultBlocks; j++)result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
            // Fill out the last data block in the longer ones
            const specialVersion = version.getVersionNumber() === 24;
            const numLongerBlocks = specialVersion ? 8 : numResultBlocks;
            for(let j = 0; j < numLongerBlocks; j++)result[j].codewords[longerBlocksNumDataCodewords - 1] = rawCodewords[rawCodewordsOffset++];
            // Now add in error correction blocks
            const max = result[0].codewords.length;
            for(let i = longerBlocksNumDataCodewords; i < max; i++)for(let j = 0; j < numResultBlocks; j++){
                const jOffset = specialVersion ? (j + 8) % numResultBlocks : j;
                const iOffset = specialVersion && jOffset > 7 ? i - 1 : i;
                result[jOffset].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
            }
            if (rawCodewordsOffset !== rawCodewords.length) throw new IllegalArgumentException();
            return result;
        }
        getNumDataCodewords() {
            return this.numDataCodewords;
        }
        getCodewords() {
            return this.codewords;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>This provides an easy abstraction to read bits at a time from a sequence of bytes, where the
     * number of bits read is not often a multiple of 8.</p>
     *
     * <p>This class is thread-safe but not reentrant -- unless the caller modifies the bytes array
     * it passed in, in which case all bets are off.</p>
     *
     * @author Sean Owen
     */ class BitSource {
        /**
         * @param bytes bytes from which this will read bits. Bits will be read from the first byte first.
         * Bits are read within a byte from most-significant to least-significant bit.
         */ constructor(bytes){
            this.bytes = bytes;
            this.byteOffset = 0;
            this.bitOffset = 0;
        }
        /**
         * @return index of next bit in current byte which would be read by the next call to {@link #readBits(int)}.
         */ getBitOffset() {
            return this.bitOffset;
        }
        /**
         * @return index of next byte in input byte array which would be read by the next call to {@link #readBits(int)}.
         */ getByteOffset() {
            return this.byteOffset;
        }
        /**
         * @param numBits number of bits to read
         * @return int representing the bits read. The bits will appear as the least-significant
         *         bits of the int
         * @throws IllegalArgumentException if numBits isn't in [1,32] or more than is available
         */ readBits(numBits /*int*/ ) {
            if (numBits < 1 || numBits > 32 || numBits > this.available()) throw new IllegalArgumentException('' + numBits);
            let result = 0;
            let bitOffset = this.bitOffset;
            let byteOffset = this.byteOffset;
            const bytes = this.bytes;
            // First, read remainder from current byte
            if (bitOffset > 0) {
                const bitsLeft = 8 - bitOffset;
                const toRead = numBits < bitsLeft ? numBits : bitsLeft;
                const bitsToNotRead = bitsLeft - toRead;
                const mask = 0xFF >> 8 - toRead << bitsToNotRead;
                result = (bytes[byteOffset] & mask) >> bitsToNotRead;
                numBits -= toRead;
                bitOffset += toRead;
                if (bitOffset === 8) {
                    bitOffset = 0;
                    byteOffset++;
                }
            }
            // Next read whole bytes
            if (numBits > 0) {
                while(numBits >= 8){
                    result = result << 8 | bytes[byteOffset] & 0xFF;
                    byteOffset++;
                    numBits -= 8;
                }
                // Finally read a partial byte
                if (numBits > 0) {
                    const bitsToNotRead = 8 - numBits;
                    const mask = 0xFF >> bitsToNotRead << bitsToNotRead;
                    result = result << numBits | (bytes[byteOffset] & mask) >> bitsToNotRead;
                    bitOffset += numBits;
                }
            }
            this.bitOffset = bitOffset;
            this.byteOffset = byteOffset;
            return result;
        }
        /**
         * @return number of bits that can be read successfully
         */ available() {
            return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
        }
    }
    var Mode;
    (function(Mode) {
        Mode[Mode["PAD_ENCODE"] = 0] = "PAD_ENCODE";
        Mode[Mode["ASCII_ENCODE"] = 1] = "ASCII_ENCODE";
        Mode[Mode["C40_ENCODE"] = 2] = "C40_ENCODE";
        Mode[Mode["TEXT_ENCODE"] = 3] = "TEXT_ENCODE";
        Mode[Mode["ANSIX12_ENCODE"] = 4] = "ANSIX12_ENCODE";
        Mode[Mode["EDIFACT_ENCODE"] = 5] = "EDIFACT_ENCODE";
        Mode[Mode["BASE256_ENCODE"] = 6] = "BASE256_ENCODE";
    })(Mode || (Mode = {}));
    /**
     * <p>Data Matrix Codes can encode text as bits in one of several modes, and can use multiple modes
     * in one Data Matrix Code. This class decodes the bits back into text.</p>
     *
     * <p>See ISO 16022:2006, 5.2.1 - 5.2.9.2</p>
     *
     * @author bbrown@google.com (Brian Brown)
     * @author Sean Owen
     */ class DecodedBitStreamParser {
        static decode(bytes) {
            const bits = new BitSource(bytes);
            const result = new StringBuilder();
            const resultTrailer = new StringBuilder();
            const byteSegments = new Array();
            let mode = Mode.ASCII_ENCODE;
            do if (mode === Mode.ASCII_ENCODE) mode = this.decodeAsciiSegment(bits, result, resultTrailer);
            else {
                switch(mode){
                    case Mode.C40_ENCODE:
                        this.decodeC40Segment(bits, result);
                        break;
                    case Mode.TEXT_ENCODE:
                        this.decodeTextSegment(bits, result);
                        break;
                    case Mode.ANSIX12_ENCODE:
                        this.decodeAnsiX12Segment(bits, result);
                        break;
                    case Mode.EDIFACT_ENCODE:
                        this.decodeEdifactSegment(bits, result);
                        break;
                    case Mode.BASE256_ENCODE:
                        this.decodeBase256Segment(bits, result, byteSegments);
                        break;
                    default:
                        throw new FormatException();
                }
                mode = Mode.ASCII_ENCODE;
            }
            while (mode !== Mode.PAD_ENCODE && bits.available() > 0);
            if (resultTrailer.length() > 0) result.append(resultTrailer.toString());
            return new DecoderResult(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, null);
        }
        /**
         * See ISO 16022:2006, 5.2.3 and Annex C, Table C.2
         */ static decodeAsciiSegment(bits, result, resultTrailer) {
            let upperShift = false;
            do {
                let oneByte = bits.readBits(8);
                if (oneByte === 0) throw new FormatException();
                else if (oneByte <= 128) {
                    if (upperShift) oneByte += 128;
                    result.append(String.fromCharCode(oneByte - 1));
                    return Mode.ASCII_ENCODE;
                } else if (oneByte === 129) return Mode.PAD_ENCODE;
                else if (oneByte <= 229) {
                    const value = oneByte - 130;
                    if (value < 10) result.append('0');
                    result.append('' + value);
                } else switch(oneByte){
                    case 230:
                        return Mode.C40_ENCODE;
                    case 231:
                        return Mode.BASE256_ENCODE;
                    case 232:
                        result.append(String.fromCharCode(29)); // translate as ASCII 29
                        break;
                    case 233:
                    case 234:
                        break;
                    case 235:
                        upperShift = true;
                        break;
                    case 236:
                        result.append('[)>\u001E05\u001D');
                        resultTrailer.insert(0, '\u001E\u0004');
                        break;
                    case 237:
                        result.append('[)>\u001E06\u001D');
                        resultTrailer.insert(0, '\u001E\u0004');
                        break;
                    case 238:
                        return Mode.ANSIX12_ENCODE;
                    case 239:
                        return Mode.TEXT_ENCODE;
                    case 240:
                        return Mode.EDIFACT_ENCODE;
                    case 241:
                        break;
                    default:
                        // Not to be used in ASCII encodation
                        // but work around encoders that end with 254, latch back to ASCII
                        if (oneByte !== 254 || bits.available() !== 0) throw new FormatException();
                        break;
                }
            }while (bits.available() > 0);
            return Mode.ASCII_ENCODE;
        }
        /**
         * See ISO 16022:2006, 5.2.5 and Annex C, Table C.1
         */ static decodeC40Segment(bits, result) {
            // Three C40 values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            // TODO(bbrown): The Upper Shift with C40 doesn't work in the 4 value scenario all the time
            let upperShift = false;
            const cValues = [];
            let shift = 0;
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) return;
                const firstByte = bits.readBits(8);
                if (firstByte === 254) return;
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for(let i = 0; i < 3; i++){
                    const cValue = cValues[i];
                    switch(shift){
                        case 0:
                            if (cValue < 3) shift = cValue + 1;
                            else if (cValue < this.C40_BASIC_SET_CHARS.length) {
                                const c40char = this.C40_BASIC_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(c40char);
                            } else throw new FormatException();
                            break;
                        case 1:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 128));
                                upperShift = false;
                            } else result.append(String.fromCharCode(cValue));
                            shift = 0;
                            break;
                        case 2:
                            if (cValue < this.C40_SHIFT2_SET_CHARS.length) {
                                const c40char = this.C40_SHIFT2_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(c40char);
                            } else switch(cValue){
                                case 27:
                                    result.append(String.fromCharCode(29)); // translate as ASCII 29
                                    break;
                                case 30:
                                    upperShift = true;
                                    break;
                                default:
                                    throw new FormatException();
                            }
                            shift = 0;
                            break;
                        case 3:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 224));
                                upperShift = false;
                            } else result.append(String.fromCharCode(cValue + 96));
                            shift = 0;
                            break;
                        default:
                            throw new FormatException();
                    }
                }
            }while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.6 and Annex C, Table C.2
         */ static decodeTextSegment(bits, result) {
            // Three Text values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            // TODO(bbrown): The Upper Shift with Text doesn't work in the 4 value scenario all the time
            let upperShift = false;
            let cValues = [];
            let shift = 0;
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) return;
                const firstByte = bits.readBits(8);
                if (firstByte === 254) return;
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for(let i = 0; i < 3; i++){
                    const cValue = cValues[i];
                    switch(shift){
                        case 0:
                            if (cValue < 3) shift = cValue + 1;
                            else if (cValue < this.TEXT_BASIC_SET_CHARS.length) {
                                const textChar = this.TEXT_BASIC_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(textChar);
                            } else throw new FormatException();
                            break;
                        case 1:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 128));
                                upperShift = false;
                            } else result.append(String.fromCharCode(cValue));
                            shift = 0;
                            break;
                        case 2:
                            // Shift 2 for Text is the same encoding as C40
                            if (cValue < this.TEXT_SHIFT2_SET_CHARS.length) {
                                const textChar = this.TEXT_SHIFT2_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(textChar);
                            } else switch(cValue){
                                case 27:
                                    result.append(String.fromCharCode(29)); // translate as ASCII 29
                                    break;
                                case 30:
                                    upperShift = true;
                                    break;
                                default:
                                    throw new FormatException();
                            }
                            shift = 0;
                            break;
                        case 3:
                            if (cValue < this.TEXT_SHIFT3_SET_CHARS.length) {
                                const textChar = this.TEXT_SHIFT3_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(textChar);
                                shift = 0;
                            } else throw new FormatException();
                            break;
                        default:
                            throw new FormatException();
                    }
                }
            }while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.7
         */ static decodeAnsiX12Segment(bits, result) {
            // Three ANSI X12 values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            const cValues = [];
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) return;
                const firstByte = bits.readBits(8);
                if (firstByte === 254) return;
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for(let i = 0; i < 3; i++){
                    const cValue = cValues[i];
                    switch(cValue){
                        case 0:
                            result.append('\r');
                            break;
                        case 1:
                            result.append('*');
                            break;
                        case 2:
                            result.append('>');
                            break;
                        case 3:
                            result.append(' ');
                            break;
                        default:
                            if (cValue < 14) result.append(String.fromCharCode(cValue + 44));
                            else if (cValue < 40) result.append(String.fromCharCode(cValue + 51));
                            else throw new FormatException();
                            break;
                    }
                }
            }while (bits.available() > 0);
        }
        static parseTwoBytes(firstByte, secondByte, result) {
            let fullBitValue = (firstByte << 8) + secondByte - 1;
            let temp = Math.floor(fullBitValue / 1600);
            result[0] = temp;
            fullBitValue -= temp * 1600;
            temp = Math.floor(fullBitValue / 40);
            result[1] = temp;
            result[2] = fullBitValue - temp * 40;
        }
        /**
         * See ISO 16022:2006, 5.2.8 and Annex C Table C.3
         */ static decodeEdifactSegment(bits, result) {
            do {
                // If there is only two or less bytes left then it will be encoded as ASCII
                if (bits.available() <= 16) return;
                for(let i = 0; i < 4; i++){
                    let edifactValue = bits.readBits(6);
                    // Check for the unlatch character
                    if (edifactValue === 0x1F) {
                        // Read rest of byte, which should be 0, and stop
                        const bitsLeft = 8 - bits.getBitOffset();
                        if (bitsLeft !== 8) bits.readBits(bitsLeft);
                        return;
                    }
                    if ((edifactValue & 0x20) === 0) edifactValue |= 0x40; // Add a leading 01 to the 6 bit binary value
                    result.append(String.fromCharCode(edifactValue));
                }
            }while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.9 and Annex B, B.2
         */ static decodeBase256Segment(bits, result, byteSegments) {
            // Figure out how long the Base 256 Segment is.
            let codewordPosition = 1 + bits.getByteOffset(); // position is 1-indexed
            const d1 = this.unrandomize255State(bits.readBits(8), codewordPosition++);
            let count;
            if (d1 === 0) count = bits.available() / 8 | 0;
            else if (d1 < 250) count = d1;
            else count = 250 * (d1 - 249) + this.unrandomize255State(bits.readBits(8), codewordPosition++);
            // We're seeing NegativeArraySizeException errors from users.
            if (count < 0) throw new FormatException();
            const bytes = new Uint8Array(count);
            for(let i = 0; i < count; i++){
                // Have seen this particular error in the wild, such as at
                // http://www.bcgen.com/demo/IDAutomationStreamingDataMatrix.aspx?MODE=3&D=Fred&PFMT=3&PT=F&X=0.3&O=0&LM=0.2
                if (bits.available() < 8) throw new FormatException();
                bytes[i] = this.unrandomize255State(bits.readBits(8), codewordPosition++);
            }
            byteSegments.push(bytes);
            try {
                result.append(StringEncoding.decode(bytes, StringUtils.ISO88591));
            } catch (uee) {
                throw new IllegalStateException('Platform does not support required encoding: ' + uee.message);
            }
        }
        /**
         * See ISO 16022:2006, Annex B, B.2
         */ static unrandomize255State(randomizedBase256Codeword, base256CodewordPosition) {
            const pseudoRandomNumber = 149 * base256CodewordPosition % 255 + 1;
            const tempVariable = randomizedBase256Codeword - pseudoRandomNumber;
            return tempVariable >= 0 ? tempVariable : tempVariable + 256;
        }
    }
    /**
     * See ISO 16022:2006, Annex C Table C.1
     * The C40 Basic Character Set (*'s used for placeholders for the shift values)
     */ DecodedBitStreamParser.C40_BASIC_SET_CHARS = [
        '*',
        '*',
        '*',
        ' ',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
    ];
    DecodedBitStreamParser.C40_SHIFT2_SET_CHARS = [
        '!',
        '"',
        '#',
        '$',
        '%',
        '&',
        '\'',
        '(',
        ')',
        '*',
        '+',
        ',',
        '-',
        '.',
        '/',
        ':',
        ';',
        '<',
        '=',
        '>',
        '?',
        '@',
        '[',
        '\\',
        ']',
        '^',
        '_'
    ];
    /**
     * See ISO 16022:2006, Annex C Table C.2
     * The Text Basic Character Set (*'s used for placeholders for the shift values)
     */ DecodedBitStreamParser.TEXT_BASIC_SET_CHARS = [
        '*',
        '*',
        '*',
        ' ',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z'
    ];
    // Shift 2 for Text is the same encoding as C40
    DecodedBitStreamParser.TEXT_SHIFT2_SET_CHARS = DecodedBitStreamParser.C40_SHIFT2_SET_CHARS;
    DecodedBitStreamParser.TEXT_SHIFT3_SET_CHARS = [
        '`',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        '{',
        '|',
        '}',
        '~',
        String.fromCharCode(127)
    ];
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>The main class which implements Data Matrix Code decoding -- as opposed to locating and extracting
     * the Data Matrix Code from an image.</p>
     *
     * @author bbrown@google.com (Brian Brown)
     */ class Decoder$1 {
        constructor(){
            this.rsDecoder = new ReedSolomonDecoder(GenericGF.DATA_MATRIX_FIELD_256);
        }
        /**
         * <p>Decodes a Data Matrix Code represented as a {@link BitMatrix}. A 1 or "true" is taken
         * to mean a black module.</p>
         *
         * @param bits booleans representing white/black Data Matrix Code modules
         * @return text and bytes encoded within the Data Matrix Code
         * @throws FormatException if the Data Matrix Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ decode(bits) {
            // Construct a parser and read version, error-correction level
            const parser = new BitMatrixParser(bits);
            const version = parser.getVersion();
            // Read codewords
            const codewords = parser.readCodewords();
            // Separate into data blocks
            const dataBlocks = DataBlock.getDataBlocks(codewords, version);
            // Count total number of data bytes
            let totalBytes = 0;
            for (let db of dataBlocks)totalBytes += db.getNumDataCodewords();
            const resultBytes = new Uint8Array(totalBytes);
            const dataBlocksCount = dataBlocks.length;
            // Error-correct and copy data blocks together into a stream of bytes
            for(let j = 0; j < dataBlocksCount; j++){
                const dataBlock = dataBlocks[j];
                const codewordBytes = dataBlock.getCodewords();
                const numDataCodewords = dataBlock.getNumDataCodewords();
                this.correctErrors(codewordBytes, numDataCodewords);
                for(let i = 0; i < numDataCodewords; i++)// De-interlace data blocks.
                resultBytes[i * dataBlocksCount + j] = codewordBytes[i];
            }
            // Decode the contents of that stream of bytes
            return DecodedBitStreamParser.decode(resultBytes);
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place using Reed-Solomon error correction.</p>
         *
         * @param codewordBytes data and error correction codewords
         * @param numDataCodewords number of codewords that are data bytes
         * @throws ChecksumException if error correction fails
         */ correctErrors(codewordBytes, numDataCodewords) {
            // const numCodewords = codewordBytes.length;
            // First read into an array of ints
            const codewordsInts = new Int32Array(codewordBytes);
            // for (let i = 0; i < numCodewords; i++) {
            //   codewordsInts[i] = codewordBytes[i] & 0xFF;
            // }
            try {
                this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
            } catch (ignored /* ReedSolomonException */ ) {
                throw new ChecksumException();
            }
            // Copy back into array of bytes -- only need to worry about the bytes that were data
            // We don't care about errors in the error-correction codewords
            for(let i = 0; i < numDataCodewords; i++)codewordBytes[i] = codewordsInts[i];
        }
    }
    /**
     * <p>Encapsulates logic that can detect a Data Matrix Code in an image, even if the Data Matrix Code
     * is rotated or skewed, or partially obscured.</p>
     *
     * @author Sean Owen
     */ class Detector$1 {
        constructor(image){
            this.image = image;
            this.rectangleDetector = new WhiteRectangleDetector(this.image);
        }
        /**
         * <p>Detects a Data Matrix Code in an image.</p>
         *
         * @return {@link DetectorResult} encapsulating results of detecting a Data Matrix Code
         * @throws NotFoundException if no Data Matrix Code can be found
         */ detect() {
            const cornerPoints = this.rectangleDetector.detect();
            let points = this.detectSolid1(cornerPoints);
            points = this.detectSolid2(points);
            points[3] = this.correctTopRight(points);
            if (!points[3]) throw new NotFoundException();
            points = this.shiftToModuleCenter(points);
            const topLeft = points[0];
            const bottomLeft = points[1];
            const bottomRight = points[2];
            const topRight = points[3];
            let dimensionTop = this.transitionsBetween(topLeft, topRight) + 1;
            let dimensionRight = this.transitionsBetween(bottomRight, topRight) + 1;
            if ((dimensionTop & 0x01) === 1) dimensionTop += 1;
            if ((dimensionRight & 0x01) === 1) dimensionRight += 1;
            if (4 * dimensionTop < 7 * dimensionRight && 4 * dimensionRight < 7 * dimensionTop) // The matrix is square
            dimensionTop = dimensionRight = Math.max(dimensionTop, dimensionRight);
            let bits = Detector$1.sampleGrid(this.image, topLeft, bottomLeft, bottomRight, topRight, dimensionTop, dimensionRight);
            return new DetectorResult(bits, [
                topLeft,
                bottomLeft,
                bottomRight,
                topRight
            ]);
        }
        static shiftPoint(point, to, div) {
            let x = (to.getX() - point.getX()) / (div + 1);
            let y = (to.getY() - point.getY()) / (div + 1);
            return new ResultPoint(point.getX() + x, point.getY() + y);
        }
        static moveAway(point, fromX, fromY) {
            let x = point.getX();
            let y = point.getY();
            if (x < fromX) x -= 1;
            else x += 1;
            if (y < fromY) y -= 1;
            else y += 1;
            return new ResultPoint(x, y);
        }
        /**
         * Detect a solid side which has minimum transition.
         */ detectSolid1(cornerPoints) {
            // 0  2
            // 1  3
            let pointA = cornerPoints[0];
            let pointB = cornerPoints[1];
            let pointC = cornerPoints[3];
            let pointD = cornerPoints[2];
            let trAB = this.transitionsBetween(pointA, pointB);
            let trBC = this.transitionsBetween(pointB, pointC);
            let trCD = this.transitionsBetween(pointC, pointD);
            let trDA = this.transitionsBetween(pointD, pointA);
            // 0..3
            // :  :
            // 1--2
            let min = trAB;
            let points = [
                pointD,
                pointA,
                pointB,
                pointC
            ];
            if (min > trBC) {
                min = trBC;
                points[0] = pointA;
                points[1] = pointB;
                points[2] = pointC;
                points[3] = pointD;
            }
            if (min > trCD) {
                min = trCD;
                points[0] = pointB;
                points[1] = pointC;
                points[2] = pointD;
                points[3] = pointA;
            }
            if (min > trDA) {
                points[0] = pointC;
                points[1] = pointD;
                points[2] = pointA;
                points[3] = pointB;
            }
            return points;
        }
        /**
         * Detect a second solid side next to first solid side.
         */ detectSolid2(points) {
            // A..D
            // :  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // Transition detection on the edge is not stable.
            // To safely detect, shift the points to the module center.
            let tr = this.transitionsBetween(pointA, pointD);
            let pointBs = Detector$1.shiftPoint(pointB, pointC, (tr + 1) * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, (tr + 1) * 4);
            let trBA = this.transitionsBetween(pointBs, pointA);
            let trCD = this.transitionsBetween(pointCs, pointD);
            // 0..3
            // |  :
            // 1--2
            if (trBA < trCD) {
                // solid sides: A-B-C
                points[0] = pointA;
                points[1] = pointB;
                points[2] = pointC;
                points[3] = pointD;
            } else {
                // solid sides: B-C-D
                points[0] = pointB;
                points[1] = pointC;
                points[2] = pointD;
                points[3] = pointA;
            }
            return points;
        }
        /**
         * Calculates the corner position of the white top right module.
         */ correctTopRight(points) {
            // A..D
            // |  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // shift points for safe transition detection.
            let trTop = this.transitionsBetween(pointA, pointD);
            let trRight = this.transitionsBetween(pointB, pointD);
            let pointAs = Detector$1.shiftPoint(pointA, pointB, (trRight + 1) * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, (trTop + 1) * 4);
            trTop = this.transitionsBetween(pointAs, pointD);
            trRight = this.transitionsBetween(pointCs, pointD);
            let candidate1 = new ResultPoint(pointD.getX() + (pointC.getX() - pointB.getX()) / (trTop + 1), pointD.getY() + (pointC.getY() - pointB.getY()) / (trTop + 1));
            let candidate2 = new ResultPoint(pointD.getX() + (pointA.getX() - pointB.getX()) / (trRight + 1), pointD.getY() + (pointA.getY() - pointB.getY()) / (trRight + 1));
            if (!this.isValid(candidate1)) {
                if (this.isValid(candidate2)) return candidate2;
                return null;
            }
            if (!this.isValid(candidate2)) return candidate1;
            let sumc1 = this.transitionsBetween(pointAs, candidate1) + this.transitionsBetween(pointCs, candidate1);
            let sumc2 = this.transitionsBetween(pointAs, candidate2) + this.transitionsBetween(pointCs, candidate2);
            if (sumc1 > sumc2) return candidate1;
            else return candidate2;
        }
        /**
         * Shift the edge points to the module center.
         */ shiftToModuleCenter(points) {
            // A..D
            // |  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // calculate pseudo dimensions
            let dimH = this.transitionsBetween(pointA, pointD) + 1;
            let dimV = this.transitionsBetween(pointC, pointD) + 1;
            // shift points for safe dimension detection
            let pointAs = Detector$1.shiftPoint(pointA, pointB, dimV * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, dimH * 4);
            //  calculate more precise dimensions
            dimH = this.transitionsBetween(pointAs, pointD) + 1;
            dimV = this.transitionsBetween(pointCs, pointD) + 1;
            if ((dimH & 0x01) === 1) dimH += 1;
            if ((dimV & 0x01) === 1) dimV += 1;
            // WhiteRectangleDetector returns points inside of the rectangle.
            // I want points on the edges.
            let centerX = (pointA.getX() + pointB.getX() + pointC.getX() + pointD.getX()) / 4;
            let centerY = (pointA.getY() + pointB.getY() + pointC.getY() + pointD.getY()) / 4;
            pointA = Detector$1.moveAway(pointA, centerX, centerY);
            pointB = Detector$1.moveAway(pointB, centerX, centerY);
            pointC = Detector$1.moveAway(pointC, centerX, centerY);
            pointD = Detector$1.moveAway(pointD, centerX, centerY);
            let pointBs;
            let pointDs;
            // shift points to the center of each modules
            pointAs = Detector$1.shiftPoint(pointA, pointB, dimV * 4);
            pointAs = Detector$1.shiftPoint(pointAs, pointD, dimH * 4);
            pointBs = Detector$1.shiftPoint(pointB, pointA, dimV * 4);
            pointBs = Detector$1.shiftPoint(pointBs, pointC, dimH * 4);
            pointCs = Detector$1.shiftPoint(pointC, pointD, dimV * 4);
            pointCs = Detector$1.shiftPoint(pointCs, pointB, dimH * 4);
            pointDs = Detector$1.shiftPoint(pointD, pointC, dimV * 4);
            pointDs = Detector$1.shiftPoint(pointDs, pointA, dimH * 4);
            return [
                pointAs,
                pointBs,
                pointCs,
                pointDs
            ];
        }
        isValid(p) {
            return p.getX() >= 0 && p.getX() < this.image.getWidth() && p.getY() > 0 && p.getY() < this.image.getHeight();
        }
        static sampleGrid(image, topLeft, bottomLeft, bottomRight, topRight, dimensionX, dimensionY) {
            const sampler = GridSamplerInstance.getInstance();
            return sampler.sampleGrid(image, dimensionX, dimensionY, 0.5, 0.5, dimensionX - 0.5, 0.5, dimensionX - 0.5, dimensionY - 0.5, 0.5, dimensionY - 0.5, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
        }
        /**
         * Counts the number of black/white transitions between two points, using something like Bresenham's algorithm.
         */ transitionsBetween(from, to) {
            // See QR Code Detector, sizeOfBlackWhiteBlackRun()
            let fromX = Math.trunc(from.getX());
            let fromY = Math.trunc(from.getY());
            let toX = Math.trunc(to.getX());
            let toY = Math.trunc(to.getY());
            let steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
            if (steep) {
                let temp = fromX;
                fromX = fromY;
                fromY = temp;
                temp = toX;
                toX = toY;
                toY = temp;
            }
            let dx = Math.abs(toX - fromX);
            let dy = Math.abs(toY - fromY);
            let error = -dx / 2;
            let ystep = fromY < toY ? 1 : -1;
            let xstep = fromX < toX ? 1 : -1;
            let transitions = 0;
            let inBlack = this.image.get(steep ? fromY : fromX, steep ? fromX : fromY);
            for(let x = fromX, y = fromY; x !== toX; x += xstep){
                let isBlack = this.image.get(steep ? y : x, steep ? x : y);
                if (isBlack !== inBlack) {
                    transitions++;
                    inBlack = isBlack;
                }
                error += dy;
                if (error > 0) {
                    if (y === toY) break;
                    y += ystep;
                    error -= dx;
                }
            }
            return transitions;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This implementation can detect and decode Data Matrix codes in an image.
     *
     * @author bbrown@google.com (Brian Brown)
     */ class DataMatrixReader {
        constructor(){
            this.decoder = new Decoder$1();
        }
        /**
         * Locates and decodes a Data Matrix code in an image.
         *
         * @return a String representing the content encoded by the Data Matrix code
         * @throws NotFoundException if a Data Matrix code cannot be found
         * @throws FormatException if a Data Matrix code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ // @Override
        // public Result decode(BinaryBitmap image) throws NotFoundException, ChecksumException, FormatException {
        //   return decode(image, null);
        // }
        // @Override
        decode(image, hints = null) {
            let decoderResult;
            let points;
            if (hints != null && hints.has(DecodeHintType$1.PURE_BARCODE)) {
                const bits = DataMatrixReader.extractPureBits(image.getBlackMatrix());
                decoderResult = this.decoder.decode(bits);
                points = DataMatrixReader.NO_POINTS;
            } else {
                const detectorResult = new Detector$1(image.getBlackMatrix()).detect();
                decoderResult = this.decoder.decode(detectorResult.getBits());
                points = detectorResult.getPoints();
            }
            const rawBytes = decoderResult.getRawBytes();
            const result = new Result(decoderResult.getText(), rawBytes, 8 * rawBytes.length, points, BarcodeFormat$1.DATA_MATRIX, System.currentTimeMillis());
            const byteSegments = decoderResult.getByteSegments();
            if (byteSegments != null) result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            const ecLevel = decoderResult.getECLevel();
            if (ecLevel != null) result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            return result;
        }
        // @Override
        reset() {
        // do nothing
        }
        /**
         * This method detects a code in a "pure" image -- that is, pure monochrome image
         * which contains only an unrotated, unskewed, image of a code, with some white border
         * around it. This is a specialized method that works exceptionally fast in this special
         * case.
         *
         * @see com.google.zxing.qrcode.QRCodeReader#extractPureBits(BitMatrix)
         */ static extractPureBits(image) {
            const leftTopBlack = image.getTopLeftOnBit();
            const rightBottomBlack = image.getBottomRightOnBit();
            if (leftTopBlack == null || rightBottomBlack == null) throw new NotFoundException();
            const moduleSize = this.moduleSize(leftTopBlack, image);
            let top = leftTopBlack[1];
            const bottom = rightBottomBlack[1];
            let left = leftTopBlack[0];
            const right = rightBottomBlack[0];
            const matrixWidth = (right - left + 1) / moduleSize;
            const matrixHeight = (bottom - top + 1) / moduleSize;
            if (matrixWidth <= 0 || matrixHeight <= 0) throw new NotFoundException();
            // Push in the "border" by half the module width so that we start
            // sampling in the middle of the module. Just in case the image is a
            // little off, this will help recover.
            const nudge = moduleSize / 2;
            top += nudge;
            left += nudge;
            // Now just read off the bits
            const bits = new BitMatrix(matrixWidth, matrixHeight);
            for(let y = 0; y < matrixHeight; y++){
                const iOffset = top + y * moduleSize;
                for(let x = 0; x < matrixWidth; x++)if (image.get(left + x * moduleSize, iOffset)) bits.set(x, y);
            }
            return bits;
        }
        static moduleSize(leftTopBlack, image) {
            const width = image.getWidth();
            let x = leftTopBlack[0];
            const y = leftTopBlack[1];
            while(x < width && image.get(x, y))x++;
            if (x === width) throw new NotFoundException();
            const moduleSize = x - leftTopBlack[0];
            if (moduleSize === 0) throw new NotFoundException();
            return moduleSize;
        }
    }
    DataMatrixReader.NO_POINTS = [];
    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */ class BrowserDatamatrixCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserQRCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */ constructor(timeBetweenScansMillis = 500){
            super(new DataMatrixReader(), timeBetweenScansMillis);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ var ErrorCorrectionLevelValues;
    (function(ErrorCorrectionLevelValues) {
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["L"] = 0] = "L";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["M"] = 1] = "M";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["Q"] = 2] = "Q";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["H"] = 3] = "H";
    })(ErrorCorrectionLevelValues || (ErrorCorrectionLevelValues = {}));
    /**
     * <p>See ISO 18004:2006, 6.5.1. This enum encapsulates the four error correction levels
     * defined by the QR code standard.</p>
     *
     * @author Sean Owen
     */ class ErrorCorrectionLevel {
        constructor(value, stringValue, bits /*int*/ ){
            this.value = value;
            this.stringValue = stringValue;
            this.bits = bits;
            ErrorCorrectionLevel.FOR_BITS.set(bits, this);
            ErrorCorrectionLevel.FOR_VALUE.set(value, this);
        }
        getValue() {
            return this.value;
        }
        getBits() {
            return this.bits;
        }
        static fromString(s) {
            switch(s){
                case 'L':
                    return ErrorCorrectionLevel.L;
                case 'M':
                    return ErrorCorrectionLevel.M;
                case 'Q':
                    return ErrorCorrectionLevel.Q;
                case 'H':
                    return ErrorCorrectionLevel.H;
                default:
                    throw new ArgumentException(s + 'not available');
            }
        }
        toString() {
            return this.stringValue;
        }
        equals(o) {
            if (!(o instanceof ErrorCorrectionLevel)) return false;
            const other = o;
            return this.value === other.value;
        }
        /**
         * @param bits int containing the two bits encoding a QR Code's error correction level
         * @return ErrorCorrectionLevel representing the encoded error correction level
         */ static forBits(bits /*int*/ ) {
            if (bits < 0 || bits >= ErrorCorrectionLevel.FOR_BITS.size) throw new IllegalArgumentException();
            return ErrorCorrectionLevel.FOR_BITS.get(bits);
        }
    }
    ErrorCorrectionLevel.FOR_BITS = new Map();
    ErrorCorrectionLevel.FOR_VALUE = new Map();
    /** L = ~7% correction */ ErrorCorrectionLevel.L = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.L, 'L', 0x01);
    /** M = ~15% correction */ ErrorCorrectionLevel.M = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.M, 'M', 0x00);
    /** Q = ~25% correction */ ErrorCorrectionLevel.Q = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.Q, 'Q', 0x03);
    /** H = ~30% correction */ ErrorCorrectionLevel.H = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.H, 'H', 0x02);
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a QR Code's format information, including the data mask used and
     * error correction level.</p>
     *
     * @author Sean Owen
     * @see DataMask
     * @see ErrorCorrectionLevel
     */ class FormatInformation {
        constructor(formatInfo /*int*/ ){
            // Bits 3,4
            this.errorCorrectionLevel = ErrorCorrectionLevel.forBits(formatInfo >> 3 & 0x03);
            // Bottom 3 bits
            this.dataMask = /*(byte) */ formatInfo & 0x07;
        }
        static numBitsDiffering(a /*int*/ , b /*int*/ ) {
            return Integer.bitCount(a ^ b);
        }
        /**
         * @param maskedFormatInfo1 format info indicator, with mask still applied
         * @param maskedFormatInfo2 second copy of same info; both are checked at the same time
         *  to establish best match
         * @return information about the format it specifies, or {@code null}
         *  if doesn't seem to match any known pattern
         */ static decodeFormatInformation(maskedFormatInfo1 /*int*/ , maskedFormatInfo2 /*int*/ ) {
            const formatInfo = FormatInformation.doDecodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2);
            if (formatInfo !== null) return formatInfo;
            // Should return null, but, some QR codes apparently
            // do not mask this info. Try again by actually masking the pattern
            // first
            return FormatInformation.doDecodeFormatInformation(maskedFormatInfo1 ^ FormatInformation.FORMAT_INFO_MASK_QR, maskedFormatInfo2 ^ FormatInformation.FORMAT_INFO_MASK_QR);
        }
        static doDecodeFormatInformation(maskedFormatInfo1 /*int*/ , maskedFormatInfo2 /*int*/ ) {
            // Find the int in FORMAT_INFO_DECODE_LOOKUP with fewest bits differing
            let bestDifference = Number.MAX_SAFE_INTEGER;
            let bestFormatInfo = 0;
            for (const decodeInfo of FormatInformation.FORMAT_INFO_DECODE_LOOKUP){
                const targetInfo = decodeInfo[0];
                if (targetInfo === maskedFormatInfo1 || targetInfo === maskedFormatInfo2) // Found an exact match
                return new FormatInformation(decodeInfo[1]);
                let bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo1, targetInfo);
                if (bitsDifference < bestDifference) {
                    bestFormatInfo = decodeInfo[1];
                    bestDifference = bitsDifference;
                }
                if (maskedFormatInfo1 !== maskedFormatInfo2) {
                    // also try the other option
                    bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo2, targetInfo);
                    if (bitsDifference < bestDifference) {
                        bestFormatInfo = decodeInfo[1];
                        bestDifference = bitsDifference;
                    }
                }
            }
            // Hamming distance of the 32 masked codes is 7, by construction, so <= 3 bits
            // differing means we found a match
            if (bestDifference <= 3) return new FormatInformation(bestFormatInfo);
            return null;
        }
        getErrorCorrectionLevel() {
            return this.errorCorrectionLevel;
        }
        getDataMask() {
            return this.dataMask;
        }
        /*@Override*/ hashCode() {
            return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
        }
        /*@Override*/ equals(o) {
            if (!(o instanceof FormatInformation)) return false;
            const other = o;
            return this.errorCorrectionLevel === other.errorCorrectionLevel && this.dataMask === other.dataMask;
        }
    }
    FormatInformation.FORMAT_INFO_MASK_QR = 0x5412;
    /**
     * See ISO 18004:2006, Annex C, Table C.1
     */ FormatInformation.FORMAT_INFO_DECODE_LOOKUP = [
        Int32Array.from([
            0x5412,
            0x00
        ]),
        Int32Array.from([
            0x5125,
            0x01
        ]),
        Int32Array.from([
            0x5E7C,
            0x02
        ]),
        Int32Array.from([
            0x5B4B,
            0x03
        ]),
        Int32Array.from([
            0x45F9,
            0x04
        ]),
        Int32Array.from([
            0x40CE,
            0x05
        ]),
        Int32Array.from([
            0x4F97,
            0x06
        ]),
        Int32Array.from([
            0x4AA0,
            0x07
        ]),
        Int32Array.from([
            0x77C4,
            0x08
        ]),
        Int32Array.from([
            0x72F3,
            0x09
        ]),
        Int32Array.from([
            0x7DAA,
            0x0A
        ]),
        Int32Array.from([
            0x789D,
            0x0B
        ]),
        Int32Array.from([
            0x662F,
            0x0C
        ]),
        Int32Array.from([
            0x6318,
            0x0D
        ]),
        Int32Array.from([
            0x6C41,
            0x0E
        ]),
        Int32Array.from([
            0x6976,
            0x0F
        ]),
        Int32Array.from([
            0x1689,
            0x10
        ]),
        Int32Array.from([
            0x13BE,
            0x11
        ]),
        Int32Array.from([
            0x1CE7,
            0x12
        ]),
        Int32Array.from([
            0x19D0,
            0x13
        ]),
        Int32Array.from([
            0x0762,
            0x14
        ]),
        Int32Array.from([
            0x0255,
            0x15
        ]),
        Int32Array.from([
            0x0D0C,
            0x16
        ]),
        Int32Array.from([
            0x083B,
            0x17
        ]),
        Int32Array.from([
            0x355F,
            0x18
        ]),
        Int32Array.from([
            0x3068,
            0x19
        ]),
        Int32Array.from([
            0x3F31,
            0x1A
        ]),
        Int32Array.from([
            0x3A06,
            0x1B
        ]),
        Int32Array.from([
            0x24B4,
            0x1C
        ]),
        Int32Array.from([
            0x2183,
            0x1D
        ]),
        Int32Array.from([
            0x2EDA,
            0x1E
        ]),
        Int32Array.from([
            0x2BED,
            0x1F
        ])
    ];
    /**
     * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
     * use blocks of differing sizes within one version, so, this encapsulates the parameters for
     * each set of blocks. It also holds the number of error-correction codewords per block since it
     * will be the same across all blocks within one version.</p>
     */ class ECBlocks$1 {
        constructor(ecCodewordsPerBlock /*int*/ , ...ecBlocks){
            this.ecCodewordsPerBlock = ecCodewordsPerBlock;
            this.ecBlocks = ecBlocks;
        }
        getECCodewordsPerBlock() {
            return this.ecCodewordsPerBlock;
        }
        getNumBlocks() {
            let total = 0;
            const ecBlocks = this.ecBlocks;
            for (const ecBlock of ecBlocks)total += ecBlock.getCount();
            return total;
        }
        getTotalECCodewords() {
            return this.ecCodewordsPerBlock * this.getNumBlocks();
        }
        getECBlocks() {
            return this.ecBlocks;
        }
    }
    /**
     * <p>Encapsulates the parameters for one error-correction block in one symbol version.
     * This includes the number of data codewords, and the number of times a block with these
     * parameters is used consecutively in the QR code version's format.</p>
     */ class ECB$1 {
        constructor(count /*int*/ , dataCodewords /*int*/ ){
            this.count = count;
            this.dataCodewords = dataCodewords;
        }
        getCount() {
            return this.count;
        }
        getDataCodewords() {
            return this.dataCodewords;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * See ISO 18004:2006 Annex D
     *
     * @author Sean Owen
     */ class Version$1 {
        constructor(versionNumber /*int*/ , alignmentPatternCenters, ...ecBlocks){
            this.versionNumber = versionNumber;
            this.alignmentPatternCenters = alignmentPatternCenters;
            this.ecBlocks = ecBlocks;
            let total = 0;
            const ecCodewords = ecBlocks[0].getECCodewordsPerBlock();
            const ecbArray = ecBlocks[0].getECBlocks();
            for (const ecBlock of ecbArray)total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            this.totalCodewords = total;
        }
        getVersionNumber() {
            return this.versionNumber;
        }
        getAlignmentPatternCenters() {
            return this.alignmentPatternCenters;
        }
        getTotalCodewords() {
            return this.totalCodewords;
        }
        getDimensionForVersion() {
            return 17 + 4 * this.versionNumber;
        }
        getECBlocksForLevel(ecLevel) {
            return this.ecBlocks[ecLevel.getValue()];
        // TYPESCRIPTPORT: original was using ordinal, and using the order of levels as defined in ErrorCorrectionLevel enum (LMQH)
        // I will use the direct value from ErrorCorrectionLevelValues enum which in typescript goes to a number
        }
        /**
         * <p>Deduces version information purely from QR Code dimensions.</p>
         *
         * @param dimension dimension in modules
         * @return Version for a QR Code of that dimension
         * @throws FormatException if dimension is not 1 mod 4
         */ static getProvisionalVersionForDimension(dimension /*int*/ ) {
            if (dimension % 4 !== 1) throw new FormatException();
            try {
                return this.getVersionForNumber((dimension - 17) / 4);
            } catch (ignored /*: IllegalArgumentException*/ ) {
                throw new FormatException();
            }
        }
        static getVersionForNumber(versionNumber /*int*/ ) {
            if (versionNumber < 1 || versionNumber > 40) throw new IllegalArgumentException();
            return Version$1.VERSIONS[versionNumber - 1];
        }
        static decodeVersionInformation(versionBits /*int*/ ) {
            let bestDifference = Number.MAX_SAFE_INTEGER;
            let bestVersion = 0;
            for(let i = 0; i < Version$1.VERSION_DECODE_INFO.length; i++){
                const targetVersion = Version$1.VERSION_DECODE_INFO[i];
                // Do the version info bits match exactly? done.
                if (targetVersion === versionBits) return Version$1.getVersionForNumber(i + 7);
                // Otherwise see if this is the closest to a real version info bit string
                // we have seen so far
                const bitsDifference = FormatInformation.numBitsDiffering(versionBits, targetVersion);
                if (bitsDifference < bestDifference) {
                    bestVersion = i + 7;
                    bestDifference = bitsDifference;
                }
            }
            // We can tolerate up to 3 bits of error since no two version info codewords will
            // differ in less than 8 bits.
            if (bestDifference <= 3) return Version$1.getVersionForNumber(bestVersion);
            // If we didn't find a close enough match, fail
            return null;
        }
        /**
         * See ISO 18004:2006 Annex E
         */ buildFunctionPattern() {
            const dimension = this.getDimensionForVersion();
            const bitMatrix = new BitMatrix(dimension);
            // Top left finder pattern + separator + format
            bitMatrix.setRegion(0, 0, 9, 9);
            // Top right finder pattern + separator + format
            bitMatrix.setRegion(dimension - 8, 0, 8, 9);
            // Bottom left finder pattern + separator + format
            bitMatrix.setRegion(0, dimension - 8, 9, 8);
            // Alignment patterns
            const max = this.alignmentPatternCenters.length;
            for(let x = 0; x < max; x++){
                const i = this.alignmentPatternCenters[x] - 2;
                for(let y = 0; y < max; y++){
                    if (x === 0 && (y === 0 || y === max - 1) || x === max - 1 && y === 0) continue;
                    bitMatrix.setRegion(this.alignmentPatternCenters[y] - 2, i, 5, 5);
                }
            }
            // Vertical timing pattern
            bitMatrix.setRegion(6, 9, 1, dimension - 17);
            // Horizontal timing pattern
            bitMatrix.setRegion(9, 6, dimension - 17, 1);
            if (this.versionNumber > 6) {
                // Version info, top right
                bitMatrix.setRegion(dimension - 11, 0, 3, 6);
                // Version info, bottom left
                bitMatrix.setRegion(0, dimension - 11, 6, 3);
            }
            return bitMatrix;
        }
        /*@Override*/ toString() {
            return '' + this.versionNumber;
        }
    }
    /**
       * See ISO 18004:2006 Annex D.
       * Element i represents the raw version bits that specify version i + 7
       */ Version$1.VERSION_DECODE_INFO = Int32Array.from([
        0x07C94,
        0x085BC,
        0x09A99,
        0x0A4D3,
        0x0BBF6,
        0x0C762,
        0x0D847,
        0x0E60D,
        0x0F928,
        0x10B78,
        0x1145D,
        0x12A17,
        0x13532,
        0x149A6,
        0x15683,
        0x168C9,
        0x177EC,
        0x18EC4,
        0x191E1,
        0x1AFAB,
        0x1B08E,
        0x1CC1A,
        0x1D33F,
        0x1ED75,
        0x1F250,
        0x209D5,
        0x216F0,
        0x228BA,
        0x2379F,
        0x24B0B,
        0x2542E,
        0x26A64,
        0x27541,
        0x28C69
    ]);
    /**
       * See ISO 18004:2006 6.5.1 Table 9
       */ Version$1.VERSIONS = [
        new Version$1(1, new Int32Array(0), new ECBlocks$1(7, new ECB$1(1, 19)), new ECBlocks$1(10, new ECB$1(1, 16)), new ECBlocks$1(13, new ECB$1(1, 13)), new ECBlocks$1(17, new ECB$1(1, 9))),
        new Version$1(2, Int32Array.from([
            6,
            18
        ]), new ECBlocks$1(10, new ECB$1(1, 34)), new ECBlocks$1(16, new ECB$1(1, 28)), new ECBlocks$1(22, new ECB$1(1, 22)), new ECBlocks$1(28, new ECB$1(1, 16))),
        new Version$1(3, Int32Array.from([
            6,
            22
        ]), new ECBlocks$1(15, new ECB$1(1, 55)), new ECBlocks$1(26, new ECB$1(1, 44)), new ECBlocks$1(18, new ECB$1(2, 17)), new ECBlocks$1(22, new ECB$1(2, 13))),
        new Version$1(4, Int32Array.from([
            6,
            26
        ]), new ECBlocks$1(20, new ECB$1(1, 80)), new ECBlocks$1(18, new ECB$1(2, 32)), new ECBlocks$1(26, new ECB$1(2, 24)), new ECBlocks$1(16, new ECB$1(4, 9))),
        new Version$1(5, Int32Array.from([
            6,
            30
        ]), new ECBlocks$1(26, new ECB$1(1, 108)), new ECBlocks$1(24, new ECB$1(2, 43)), new ECBlocks$1(18, new ECB$1(2, 15), new ECB$1(2, 16)), new ECBlocks$1(22, new ECB$1(2, 11), new ECB$1(2, 12))),
        new Version$1(6, Int32Array.from([
            6,
            34
        ]), new ECBlocks$1(18, new ECB$1(2, 68)), new ECBlocks$1(16, new ECB$1(4, 27)), new ECBlocks$1(24, new ECB$1(4, 19)), new ECBlocks$1(28, new ECB$1(4, 15))),
        new Version$1(7, Int32Array.from([
            6,
            22,
            38
        ]), new ECBlocks$1(20, new ECB$1(2, 78)), new ECBlocks$1(18, new ECB$1(4, 31)), new ECBlocks$1(18, new ECB$1(2, 14), new ECB$1(4, 15)), new ECBlocks$1(26, new ECB$1(4, 13), new ECB$1(1, 14))),
        new Version$1(8, Int32Array.from([
            6,
            24,
            42
        ]), new ECBlocks$1(24, new ECB$1(2, 97)), new ECBlocks$1(22, new ECB$1(2, 38), new ECB$1(2, 39)), new ECBlocks$1(22, new ECB$1(4, 18), new ECB$1(2, 19)), new ECBlocks$1(26, new ECB$1(4, 14), new ECB$1(2, 15))),
        new Version$1(9, Int32Array.from([
            6,
            26,
            46
        ]), new ECBlocks$1(30, new ECB$1(2, 116)), new ECBlocks$1(22, new ECB$1(3, 36), new ECB$1(2, 37)), new ECBlocks$1(20, new ECB$1(4, 16), new ECB$1(4, 17)), new ECBlocks$1(24, new ECB$1(4, 12), new ECB$1(4, 13))),
        new Version$1(10, Int32Array.from([
            6,
            28,
            50
        ]), new ECBlocks$1(18, new ECB$1(2, 68), new ECB$1(2, 69)), new ECBlocks$1(26, new ECB$1(4, 43), new ECB$1(1, 44)), new ECBlocks$1(24, new ECB$1(6, 19), new ECB$1(2, 20)), new ECBlocks$1(28, new ECB$1(6, 15), new ECB$1(2, 16))),
        new Version$1(11, Int32Array.from([
            6,
            30,
            54
        ]), new ECBlocks$1(20, new ECB$1(4, 81)), new ECBlocks$1(30, new ECB$1(1, 50), new ECB$1(4, 51)), new ECBlocks$1(28, new ECB$1(4, 22), new ECB$1(4, 23)), new ECBlocks$1(24, new ECB$1(3, 12), new ECB$1(8, 13))),
        new Version$1(12, Int32Array.from([
            6,
            32,
            58
        ]), new ECBlocks$1(24, new ECB$1(2, 92), new ECB$1(2, 93)), new ECBlocks$1(22, new ECB$1(6, 36), new ECB$1(2, 37)), new ECBlocks$1(26, new ECB$1(4, 20), new ECB$1(6, 21)), new ECBlocks$1(28, new ECB$1(7, 14), new ECB$1(4, 15))),
        new Version$1(13, Int32Array.from([
            6,
            34,
            62
        ]), new ECBlocks$1(26, new ECB$1(4, 107)), new ECBlocks$1(22, new ECB$1(8, 37), new ECB$1(1, 38)), new ECBlocks$1(24, new ECB$1(8, 20), new ECB$1(4, 21)), new ECBlocks$1(22, new ECB$1(12, 11), new ECB$1(4, 12))),
        new Version$1(14, Int32Array.from([
            6,
            26,
            46,
            66
        ]), new ECBlocks$1(30, new ECB$1(3, 115), new ECB$1(1, 116)), new ECBlocks$1(24, new ECB$1(4, 40), new ECB$1(5, 41)), new ECBlocks$1(20, new ECB$1(11, 16), new ECB$1(5, 17)), new ECBlocks$1(24, new ECB$1(11, 12), new ECB$1(5, 13))),
        new Version$1(15, Int32Array.from([
            6,
            26,
            48,
            70
        ]), new ECBlocks$1(22, new ECB$1(5, 87), new ECB$1(1, 88)), new ECBlocks$1(24, new ECB$1(5, 41), new ECB$1(5, 42)), new ECBlocks$1(30, new ECB$1(5, 24), new ECB$1(7, 25)), new ECBlocks$1(24, new ECB$1(11, 12), new ECB$1(7, 13))),
        new Version$1(16, Int32Array.from([
            6,
            26,
            50,
            74
        ]), new ECBlocks$1(24, new ECB$1(5, 98), new ECB$1(1, 99)), new ECBlocks$1(28, new ECB$1(7, 45), new ECB$1(3, 46)), new ECBlocks$1(24, new ECB$1(15, 19), new ECB$1(2, 20)), new ECBlocks$1(30, new ECB$1(3, 15), new ECB$1(13, 16))),
        new Version$1(17, Int32Array.from([
            6,
            30,
            54,
            78
        ]), new ECBlocks$1(28, new ECB$1(1, 107), new ECB$1(5, 108)), new ECBlocks$1(28, new ECB$1(10, 46), new ECB$1(1, 47)), new ECBlocks$1(28, new ECB$1(1, 22), new ECB$1(15, 23)), new ECBlocks$1(28, new ECB$1(2, 14), new ECB$1(17, 15))),
        new Version$1(18, Int32Array.from([
            6,
            30,
            56,
            82
        ]), new ECBlocks$1(30, new ECB$1(5, 120), new ECB$1(1, 121)), new ECBlocks$1(26, new ECB$1(9, 43), new ECB$1(4, 44)), new ECBlocks$1(28, new ECB$1(17, 22), new ECB$1(1, 23)), new ECBlocks$1(28, new ECB$1(2, 14), new ECB$1(19, 15))),
        new Version$1(19, Int32Array.from([
            6,
            30,
            58,
            86
        ]), new ECBlocks$1(28, new ECB$1(3, 113), new ECB$1(4, 114)), new ECBlocks$1(26, new ECB$1(3, 44), new ECB$1(11, 45)), new ECBlocks$1(26, new ECB$1(17, 21), new ECB$1(4, 22)), new ECBlocks$1(26, new ECB$1(9, 13), new ECB$1(16, 14))),
        new Version$1(20, Int32Array.from([
            6,
            34,
            62,
            90
        ]), new ECBlocks$1(28, new ECB$1(3, 107), new ECB$1(5, 108)), new ECBlocks$1(26, new ECB$1(3, 41), new ECB$1(13, 42)), new ECBlocks$1(30, new ECB$1(15, 24), new ECB$1(5, 25)), new ECBlocks$1(28, new ECB$1(15, 15), new ECB$1(10, 16))),
        new Version$1(21, Int32Array.from([
            6,
            28,
            50,
            72,
            94
        ]), new ECBlocks$1(28, new ECB$1(4, 116), new ECB$1(4, 117)), new ECBlocks$1(26, new ECB$1(17, 42)), new ECBlocks$1(28, new ECB$1(17, 22), new ECB$1(6, 23)), new ECBlocks$1(30, new ECB$1(19, 16), new ECB$1(6, 17))),
        new Version$1(22, Int32Array.from([
            6,
            26,
            50,
            74,
            98
        ]), new ECBlocks$1(28, new ECB$1(2, 111), new ECB$1(7, 112)), new ECBlocks$1(28, new ECB$1(17, 46)), new ECBlocks$1(30, new ECB$1(7, 24), new ECB$1(16, 25)), new ECBlocks$1(24, new ECB$1(34, 13))),
        new Version$1(23, Int32Array.from([
            6,
            30,
            54,
            78,
            102
        ]), new ECBlocks$1(30, new ECB$1(4, 121), new ECB$1(5, 122)), new ECBlocks$1(28, new ECB$1(4, 47), new ECB$1(14, 48)), new ECBlocks$1(30, new ECB$1(11, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(16, 15), new ECB$1(14, 16))),
        new Version$1(24, Int32Array.from([
            6,
            28,
            54,
            80,
            106
        ]), new ECBlocks$1(30, new ECB$1(6, 117), new ECB$1(4, 118)), new ECBlocks$1(28, new ECB$1(6, 45), new ECB$1(14, 46)), new ECBlocks$1(30, new ECB$1(11, 24), new ECB$1(16, 25)), new ECBlocks$1(30, new ECB$1(30, 16), new ECB$1(2, 17))),
        new Version$1(25, Int32Array.from([
            6,
            32,
            58,
            84,
            110
        ]), new ECBlocks$1(26, new ECB$1(8, 106), new ECB$1(4, 107)), new ECBlocks$1(28, new ECB$1(8, 47), new ECB$1(13, 48)), new ECBlocks$1(30, new ECB$1(7, 24), new ECB$1(22, 25)), new ECBlocks$1(30, new ECB$1(22, 15), new ECB$1(13, 16))),
        new Version$1(26, Int32Array.from([
            6,
            30,
            58,
            86,
            114
        ]), new ECBlocks$1(28, new ECB$1(10, 114), new ECB$1(2, 115)), new ECBlocks$1(28, new ECB$1(19, 46), new ECB$1(4, 47)), new ECBlocks$1(28, new ECB$1(28, 22), new ECB$1(6, 23)), new ECBlocks$1(30, new ECB$1(33, 16), new ECB$1(4, 17))),
        new Version$1(27, Int32Array.from([
            6,
            34,
            62,
            90,
            118
        ]), new ECBlocks$1(30, new ECB$1(8, 122), new ECB$1(4, 123)), new ECBlocks$1(28, new ECB$1(22, 45), new ECB$1(3, 46)), new ECBlocks$1(30, new ECB$1(8, 23), new ECB$1(26, 24)), new ECBlocks$1(30, new ECB$1(12, 15), new ECB$1(28, 16))),
        new Version$1(28, Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122
        ]), new ECBlocks$1(30, new ECB$1(3, 117), new ECB$1(10, 118)), new ECBlocks$1(28, new ECB$1(3, 45), new ECB$1(23, 46)), new ECBlocks$1(30, new ECB$1(4, 24), new ECB$1(31, 25)), new ECBlocks$1(30, new ECB$1(11, 15), new ECB$1(31, 16))),
        new Version$1(29, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126
        ]), new ECBlocks$1(30, new ECB$1(7, 116), new ECB$1(7, 117)), new ECBlocks$1(28, new ECB$1(21, 45), new ECB$1(7, 46)), new ECBlocks$1(30, new ECB$1(1, 23), new ECB$1(37, 24)), new ECBlocks$1(30, new ECB$1(19, 15), new ECB$1(26, 16))),
        new Version$1(30, Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130
        ]), new ECBlocks$1(30, new ECB$1(5, 115), new ECB$1(10, 116)), new ECBlocks$1(28, new ECB$1(19, 47), new ECB$1(10, 48)), new ECBlocks$1(30, new ECB$1(15, 24), new ECB$1(25, 25)), new ECBlocks$1(30, new ECB$1(23, 15), new ECB$1(25, 16))),
        new Version$1(31, Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134
        ]), new ECBlocks$1(30, new ECB$1(13, 115), new ECB$1(3, 116)), new ECBlocks$1(28, new ECB$1(2, 46), new ECB$1(29, 47)), new ECBlocks$1(30, new ECB$1(42, 24), new ECB$1(1, 25)), new ECBlocks$1(30, new ECB$1(23, 15), new ECB$1(28, 16))),
        new Version$1(32, Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138
        ]), new ECBlocks$1(30, new ECB$1(17, 115)), new ECBlocks$1(28, new ECB$1(10, 46), new ECB$1(23, 47)), new ECBlocks$1(30, new ECB$1(10, 24), new ECB$1(35, 25)), new ECBlocks$1(30, new ECB$1(19, 15), new ECB$1(35, 16))),
        new Version$1(33, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142
        ]), new ECBlocks$1(30, new ECB$1(17, 115), new ECB$1(1, 116)), new ECBlocks$1(28, new ECB$1(14, 46), new ECB$1(21, 47)), new ECBlocks$1(30, new ECB$1(29, 24), new ECB$1(19, 25)), new ECBlocks$1(30, new ECB$1(11, 15), new ECB$1(46, 16))),
        new Version$1(34, Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146
        ]), new ECBlocks$1(30, new ECB$1(13, 115), new ECB$1(6, 116)), new ECBlocks$1(28, new ECB$1(14, 46), new ECB$1(23, 47)), new ECBlocks$1(30, new ECB$1(44, 24), new ECB$1(7, 25)), new ECBlocks$1(30, new ECB$1(59, 16), new ECB$1(1, 17))),
        new Version$1(35, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]), new ECBlocks$1(30, new ECB$1(12, 121), new ECB$1(7, 122)), new ECBlocks$1(28, new ECB$1(12, 47), new ECB$1(26, 48)), new ECBlocks$1(30, new ECB$1(39, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(22, 15), new ECB$1(41, 16))),
        new Version$1(36, Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]), new ECBlocks$1(30, new ECB$1(6, 121), new ECB$1(14, 122)), new ECBlocks$1(28, new ECB$1(6, 47), new ECB$1(34, 48)), new ECBlocks$1(30, new ECB$1(46, 24), new ECB$1(10, 25)), new ECBlocks$1(30, new ECB$1(2, 15), new ECB$1(64, 16))),
        new Version$1(37, Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]), new ECBlocks$1(30, new ECB$1(17, 122), new ECB$1(4, 123)), new ECBlocks$1(28, new ECB$1(29, 46), new ECB$1(14, 47)), new ECBlocks$1(30, new ECB$1(49, 24), new ECB$1(10, 25)), new ECBlocks$1(30, new ECB$1(24, 15), new ECB$1(46, 16))),
        new Version$1(38, Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]), new ECBlocks$1(30, new ECB$1(4, 122), new ECB$1(18, 123)), new ECBlocks$1(28, new ECB$1(13, 46), new ECB$1(32, 47)), new ECBlocks$1(30, new ECB$1(48, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(42, 15), new ECB$1(32, 16))),
        new Version$1(39, Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]), new ECBlocks$1(30, new ECB$1(20, 117), new ECB$1(4, 118)), new ECBlocks$1(28, new ECB$1(40, 47), new ECB$1(7, 48)), new ECBlocks$1(30, new ECB$1(43, 24), new ECB$1(22, 25)), new ECBlocks$1(30, new ECB$1(10, 15), new ECB$1(67, 16))),
        new Version$1(40, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]), new ECBlocks$1(30, new ECB$1(19, 118), new ECB$1(6, 119)), new ECBlocks$1(28, new ECB$1(18, 47), new ECB$1(31, 48)), new ECBlocks$1(30, new ECB$1(34, 24), new ECB$1(34, 25)), new ECBlocks$1(30, new ECB$1(20, 15), new ECB$1(61, 16)))
    ];
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ var DataMaskValues;
    (function(DataMaskValues) {
        DataMaskValues[DataMaskValues["DATA_MASK_000"] = 0] = "DATA_MASK_000";
        DataMaskValues[DataMaskValues["DATA_MASK_001"] = 1] = "DATA_MASK_001";
        DataMaskValues[DataMaskValues["DATA_MASK_010"] = 2] = "DATA_MASK_010";
        DataMaskValues[DataMaskValues["DATA_MASK_011"] = 3] = "DATA_MASK_011";
        DataMaskValues[DataMaskValues["DATA_MASK_100"] = 4] = "DATA_MASK_100";
        DataMaskValues[DataMaskValues["DATA_MASK_101"] = 5] = "DATA_MASK_101";
        DataMaskValues[DataMaskValues["DATA_MASK_110"] = 6] = "DATA_MASK_110";
        DataMaskValues[DataMaskValues["DATA_MASK_111"] = 7] = "DATA_MASK_111";
    })(DataMaskValues || (DataMaskValues = {}));
    /**
     * <p>Encapsulates data masks for the data bits in a QR code, per ISO 18004:2006 6.8. Implementations
     * of this class can un-mask a raw BitMatrix. For simplicity, they will unmask the entire BitMatrix,
     * including areas used for finder patterns, timing patterns, etc. These areas should be unused
     * after the point they are unmasked anyway.</p>
     *
     * <p>Note that the diagram in section 6.8.1 is misleading since it indicates that i is column position
     * and j is row position. In fact, as the text says, i is row position and j is column position.</p>
     *
     * @author Sean Owen
     */ class DataMask {
        // See ISO 18004:2006 6.8.1
        constructor(value, isMasked){
            this.value = value;
            this.isMasked = isMasked;
        }
        // End of enum constants.
        /**
         * <p>Implementations of this method reverse the data masking process applied to a QR Code and
         * make its bits ready to read.</p>
         *
         * @param bits representation of QR Code bits
         * @param dimension dimension of QR Code, represented by bits, being unmasked
         */ unmaskBitMatrix(bits, dimension /*int*/ ) {
            for(let i = 0; i < dimension; i++){
                for(let j = 0; j < dimension; j++)if (this.isMasked(i, j)) bits.flip(j, i);
            }
        }
    }
    DataMask.values = new Map([
        /**
         * 000: mask bits for which (x + y) mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_000,
            new DataMask(DataMaskValues.DATA_MASK_000, (i /*int*/ , j /*int*/ )=>{
                return (i + j & 0x01) === 0;
            })
        ],
        /**
         * 001: mask bits for which x mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_001,
            new DataMask(DataMaskValues.DATA_MASK_001, (i /*int*/ , j /*int*/ )=>{
                return (i & 0x01) === 0;
            })
        ],
        /**
         * 010: mask bits for which y mod 3 == 0
         */ [
            DataMaskValues.DATA_MASK_010,
            new DataMask(DataMaskValues.DATA_MASK_010, (i /*int*/ , j /*int*/ )=>{
                return j % 3 === 0;
            })
        ],
        /**
         * 011: mask bits for which (x + y) mod 3 == 0
         */ [
            DataMaskValues.DATA_MASK_011,
            new DataMask(DataMaskValues.DATA_MASK_011, (i /*int*/ , j /*int*/ )=>{
                return (i + j) % 3 === 0;
            })
        ],
        /**
         * 100: mask bits for which (x/2 + y/3) mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_100,
            new DataMask(DataMaskValues.DATA_MASK_100, (i /*int*/ , j /*int*/ )=>{
                return (Math.floor(i / 2) + Math.floor(j / 3) & 0x01) === 0;
            })
        ],
        /**
         * 101: mask bits for which xy mod 2 + xy mod 3 == 0
         * equivalently, such that xy mod 6 == 0
         */ [
            DataMaskValues.DATA_MASK_101,
            new DataMask(DataMaskValues.DATA_MASK_101, (i /*int*/ , j /*int*/ )=>{
                return i * j % 6 === 0;
            })
        ],
        /**
         * 110: mask bits for which (xy mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that xy mod 6 < 3
         */ [
            DataMaskValues.DATA_MASK_110,
            new DataMask(DataMaskValues.DATA_MASK_110, (i /*int*/ , j /*int*/ )=>{
                return i * j % 6 < 3;
            })
        ],
        /**
         * 111: mask bits for which ((x+y)mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that (x + y + xy mod 3) mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_111,
            new DataMask(DataMaskValues.DATA_MASK_111, (i /*int*/ , j /*int*/ )=>{
                return (i + j + i * j % 3 & 0x01) === 0;
            })
        ]
    ]);
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Sean Owen
     */ class BitMatrixParser$1 {
        /**
         * @param bitMatrix {@link BitMatrix} to parse
         * @throws FormatException if dimension is not >= 21 and 1 mod 4
         */ constructor(bitMatrix){
            const dimension = bitMatrix.getHeight();
            if (dimension < 21 || (dimension & 0x03) !== 1) throw new FormatException();
            this.bitMatrix = bitMatrix;
        }
        /**
         * <p>Reads format information from one of its two locations within the QR Code.</p>
         *
         * @return {@link FormatInformation} encapsulating the QR Code's format info
         * @throws FormatException if both format information locations cannot be parsed as
         * the valid encoding of format information
         */ readFormatInformation() {
            if (this.parsedFormatInfo !== null && this.parsedFormatInfo !== undefined) return this.parsedFormatInfo;
            // Read top-left format info bits
            let formatInfoBits1 = 0;
            for(let i = 0; i < 6; i++)formatInfoBits1 = this.copyBit(i, 8, formatInfoBits1);
            // .. and skip a bit in the timing pattern ...
            formatInfoBits1 = this.copyBit(7, 8, formatInfoBits1);
            formatInfoBits1 = this.copyBit(8, 8, formatInfoBits1);
            formatInfoBits1 = this.copyBit(8, 7, formatInfoBits1);
            // .. and skip a bit in the timing pattern ...
            for(let j = 5; j >= 0; j--)formatInfoBits1 = this.copyBit(8, j, formatInfoBits1);
            // Read the top-right/bottom-left pattern too
            const dimension = this.bitMatrix.getHeight();
            let formatInfoBits2 = 0;
            const jMin = dimension - 7;
            for(let j = dimension - 1; j >= jMin; j--)formatInfoBits2 = this.copyBit(8, j, formatInfoBits2);
            for(let i = dimension - 8; i < dimension; i++)formatInfoBits2 = this.copyBit(i, 8, formatInfoBits2);
            this.parsedFormatInfo = FormatInformation.decodeFormatInformation(formatInfoBits1, formatInfoBits2);
            if (this.parsedFormatInfo !== null) return this.parsedFormatInfo;
            throw new FormatException();
        }
        /**
         * <p>Reads version information from one of its two locations within the QR Code.</p>
         *
         * @return {@link Version} encapsulating the QR Code's version
         * @throws FormatException if both version information locations cannot be parsed as
         * the valid encoding of version information
         */ readVersion() {
            if (this.parsedVersion !== null && this.parsedVersion !== undefined) return this.parsedVersion;
            const dimension = this.bitMatrix.getHeight();
            const provisionalVersion = Math.floor((dimension - 17) / 4);
            if (provisionalVersion <= 6) return Version$1.getVersionForNumber(provisionalVersion);
            // Read top-right version info: 3 wide by 6 tall
            let versionBits = 0;
            const ijMin = dimension - 11;
            for(let j = 5; j >= 0; j--)for(let i = dimension - 9; i >= ijMin; i--)versionBits = this.copyBit(i, j, versionBits);
            let theParsedVersion = Version$1.decodeVersionInformation(versionBits);
            if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
                this.parsedVersion = theParsedVersion;
                return theParsedVersion;
            }
            // Hmm, failed. Try bottom left: 6 wide by 3 tall
            versionBits = 0;
            for(let i = 5; i >= 0; i--)for(let j = dimension - 9; j >= ijMin; j--)versionBits = this.copyBit(i, j, versionBits);
            theParsedVersion = Version$1.decodeVersionInformation(versionBits);
            if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
                this.parsedVersion = theParsedVersion;
                return theParsedVersion;
            }
            throw new FormatException();
        }
        copyBit(i /*int*/ , j /*int*/ , versionBits /*int*/ ) {
            const bit = this.isMirror ? this.bitMatrix.get(j, i) : this.bitMatrix.get(i, j);
            return bit ? versionBits << 1 | 0x1 : versionBits << 1;
        }
        /**
         * <p>Reads the bits in the {@link BitMatrix} representing the finder pattern in the
         * correct order in order to reconstruct the codewords bytes contained within the
         * QR Code.</p>
         *
         * @return bytes encoded within the QR Code
         * @throws FormatException if the exact number of bytes expected is not read
         */ readCodewords() {
            const formatInfo = this.readFormatInformation();
            const version = this.readVersion();
            // Get the data mask for the format used in this QR Code. This will exclude
            // some bits from reading as we wind through the bit matrix.
            const dataMask = DataMask.values.get(formatInfo.getDataMask());
            const dimension = this.bitMatrix.getHeight();
            dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
            const functionPattern = version.buildFunctionPattern();
            let readingUp = true;
            const result = new Uint8Array(version.getTotalCodewords());
            let resultOffset = 0;
            let currentByte = 0;
            let bitsRead = 0;
            // Read columns in pairs, from right to left
            for(let j = dimension - 1; j > 0; j -= 2){
                if (j === 6) // Skip whole column with vertical alignment pattern
                // saves time and makes the other code proceed more cleanly
                j--;
                // Read alternatingly from bottom to top then top to bottom
                for(let count = 0; count < dimension; count++){
                    const i = readingUp ? dimension - 1 - count : count;
                    for(let col = 0; col < 2; col++)// Ignore bits covered by the function pattern
                    if (!functionPattern.get(j - col, i)) {
                        // Read a bit
                        bitsRead++;
                        currentByte <<= 1;
                        if (this.bitMatrix.get(j - col, i)) currentByte |= 1;
                        // If we've made a whole byte, save it off
                        if (bitsRead === 8) {
                            result[resultOffset++] = /*(byte) */ currentByte;
                            bitsRead = 0;
                            currentByte = 0;
                        }
                    }
                }
                readingUp = !readingUp; // readingUp ^= true; // readingUp = !readingUp; // switch directions
            }
            if (resultOffset !== version.getTotalCodewords()) throw new FormatException();
            return result;
        }
        /**
         * Revert the mask removal done while reading the code words. The bit matrix should revert to its original state.
         */ remask() {
            if (this.parsedFormatInfo === null) return; // We have no format information, and have no data mask
            const dataMask = DataMask.values[this.parsedFormatInfo.getDataMask()];
            const dimension = this.bitMatrix.getHeight();
            dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
        }
        /**
         * Prepare the parser for a mirrored operation.
         * This flag has effect only on the {@link #readFormatInformation()} and the
         * {@link #readVersion()}. Before proceeding with {@link #readCodewords()} the
         * {@link #mirror()} method should be called.
         *
         * @param mirror Whether to read version and format information mirrored.
         */ setMirror(isMirror) {
            this.parsedVersion = null;
            this.parsedFormatInfo = null;
            this.isMirror = isMirror;
        }
        /** Mirror the bit matrix in order to attempt a second reading. */ mirror() {
            const bitMatrix = this.bitMatrix;
            for(let x = 0, width = bitMatrix.getWidth(); x < width; x++){
                for(let y = x + 1, height = bitMatrix.getHeight(); y < height; y++)if (bitMatrix.get(x, y) !== bitMatrix.get(y, x)) {
                    bitMatrix.flip(y, x);
                    bitMatrix.flip(x, y);
                }
            }
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a block of data within a QR Code. QR Codes may split their data into
     * multiple blocks, each of which is a unit of data and error-correction codewords. Each
     * is represented by an instance of this class.</p>
     *
     * @author Sean Owen
     */ class DataBlock$1 {
        constructor(numDataCodewords /*int*/ , codewords){
            this.numDataCodewords = numDataCodewords;
            this.codewords = codewords;
        }
        /**
         * <p>When QR Codes use multiple data blocks, they are actually interleaved.
         * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
         * method will separate the data into original blocks.</p>
         *
         * @param rawCodewords bytes as read directly from the QR Code
         * @param version version of the QR Code
         * @param ecLevel error-correction level of the QR Code
         * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
         *         QR Code
         */ static getDataBlocks(rawCodewords, version, ecLevel) {
            if (rawCodewords.length !== version.getTotalCodewords()) throw new IllegalArgumentException();
            // Figure out the number and size of data blocks used by this version and
            // error correction level
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            // First count the total number of data blocks
            let totalBlocks = 0;
            const ecBlockArray = ecBlocks.getECBlocks();
            for (const ecBlock of ecBlockArray)totalBlocks += ecBlock.getCount();
            // Now establish DataBlocks of the appropriate size and number of data codewords
            const result = new Array(totalBlocks);
            let numResultBlocks = 0;
            for (const ecBlock of ecBlockArray)for(let i = 0; i < ecBlock.getCount(); i++){
                const numDataCodewords = ecBlock.getDataCodewords();
                const numBlockCodewords = ecBlocks.getECCodewordsPerBlock() + numDataCodewords;
                result[numResultBlocks++] = new DataBlock$1(numDataCodewords, new Uint8Array(numBlockCodewords));
            }
            // All blocks have the same amount of data, except that the last n
            // (where n may be 0) have 1 more byte. Figure out where these start.
            const shorterBlocksTotalCodewords = result[0].codewords.length;
            let longerBlocksStartAt = result.length - 1;
            // TYPESCRIPTPORT: check length is correct here
            while(longerBlocksStartAt >= 0){
                const numCodewords = result[longerBlocksStartAt].codewords.length;
                if (numCodewords === shorterBlocksTotalCodewords) break;
                longerBlocksStartAt--;
            }
            longerBlocksStartAt++;
            const shorterBlocksNumDataCodewords = shorterBlocksTotalCodewords - ecBlocks.getECCodewordsPerBlock();
            // The last elements of result may be 1 element longer
            // first fill out as many elements as all of them have
            let rawCodewordsOffset = 0;
            for(let i = 0; i < shorterBlocksNumDataCodewords; i++)for(let j = 0; j < numResultBlocks; j++)result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
            // Fill out the last data block in the longer ones
            for(let j = longerBlocksStartAt; j < numResultBlocks; j++)result[j].codewords[shorterBlocksNumDataCodewords] = rawCodewords[rawCodewordsOffset++];
            // Now add in error correction blocks
            const max = result[0].codewords.length;
            for(let i = shorterBlocksNumDataCodewords; i < max; i++)for(let j = 0; j < numResultBlocks; j++){
                const iOffset = j < longerBlocksStartAt ? i : i + 1;
                result[j].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
            }
            return result;
        }
        getNumDataCodewords() {
            return this.numDataCodewords;
        }
        getCodewords() {
            return this.codewords;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ var ModeValues;
    (function(ModeValues) {
        ModeValues[ModeValues["TERMINATOR"] = 0] = "TERMINATOR";
        ModeValues[ModeValues["NUMERIC"] = 1] = "NUMERIC";
        ModeValues[ModeValues["ALPHANUMERIC"] = 2] = "ALPHANUMERIC";
        ModeValues[ModeValues["STRUCTURED_APPEND"] = 3] = "STRUCTURED_APPEND";
        ModeValues[ModeValues["BYTE"] = 4] = "BYTE";
        ModeValues[ModeValues["ECI"] = 5] = "ECI";
        ModeValues[ModeValues["KANJI"] = 6] = "KANJI";
        ModeValues[ModeValues["FNC1_FIRST_POSITION"] = 7] = "FNC1_FIRST_POSITION";
        ModeValues[ModeValues["FNC1_SECOND_POSITION"] = 8] = "FNC1_SECOND_POSITION";
        /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */ ModeValues[ModeValues["HANZI"] = 9] = "HANZI";
    })(ModeValues || (ModeValues = {}));
    /**
     * <p>See ISO 18004:2006, 6.4.1, Tables 2 and 3. This enum encapsulates the various modes in which
     * data can be encoded to bits in the QR code standard.</p>
     *
     * @author Sean Owen
     */ class Mode$1 {
        constructor(value, stringValue, characterCountBitsForVersions, bits /*int*/ ){
            this.value = value;
            this.stringValue = stringValue;
            this.characterCountBitsForVersions = characterCountBitsForVersions;
            this.bits = bits;
            Mode$1.FOR_BITS.set(bits, this);
            Mode$1.FOR_VALUE.set(value, this);
        }
        /**
         * @param bits four bits encoding a QR Code data mode
         * @return Mode encoded by these bits
         * @throws IllegalArgumentException if bits do not correspond to a known mode
         */ static forBits(bits /*int*/ ) {
            const mode = Mode$1.FOR_BITS.get(bits);
            if (undefined === mode) throw new IllegalArgumentException();
            return mode;
        }
        /**
         * @param version version in question
         * @return number of bits used, in this QR Code symbol {@link Version}, to encode the
         *         count of characters that will follow encoded in this Mode
         */ getCharacterCountBits(version) {
            const versionNumber = version.getVersionNumber();
            let offset;
            if (versionNumber <= 9) offset = 0;
            else if (versionNumber <= 26) offset = 1;
            else offset = 2;
            return this.characterCountBitsForVersions[offset];
        }
        getValue() {
            return this.value;
        }
        getBits() {
            return this.bits;
        }
        equals(o) {
            if (!(o instanceof Mode$1)) return false;
            const other = o;
            return this.value === other.value;
        }
        toString() {
            return this.stringValue;
        }
    }
    Mode$1.FOR_BITS = new Map();
    Mode$1.FOR_VALUE = new Map();
    Mode$1.TERMINATOR = new Mode$1(ModeValues.TERMINATOR, 'TERMINATOR', Int32Array.from([
        0,
        0,
        0
    ]), 0x00); // Not really a mode...
    Mode$1.NUMERIC = new Mode$1(ModeValues.NUMERIC, 'NUMERIC', Int32Array.from([
        10,
        12,
        14
    ]), 0x01);
    Mode$1.ALPHANUMERIC = new Mode$1(ModeValues.ALPHANUMERIC, 'ALPHANUMERIC', Int32Array.from([
        9,
        11,
        13
    ]), 0x02);
    Mode$1.STRUCTURED_APPEND = new Mode$1(ModeValues.STRUCTURED_APPEND, 'STRUCTURED_APPEND', Int32Array.from([
        0,
        0,
        0
    ]), 0x03); // Not supported
    Mode$1.BYTE = new Mode$1(ModeValues.BYTE, 'BYTE', Int32Array.from([
        8,
        16,
        16
    ]), 0x04);
    Mode$1.ECI = new Mode$1(ModeValues.ECI, 'ECI', Int32Array.from([
        0,
        0,
        0
    ]), 0x07); // character counts don't apply
    Mode$1.KANJI = new Mode$1(ModeValues.KANJI, 'KANJI', Int32Array.from([
        8,
        10,
        12
    ]), 0x08);
    Mode$1.FNC1_FIRST_POSITION = new Mode$1(ModeValues.FNC1_FIRST_POSITION, 'FNC1_FIRST_POSITION', Int32Array.from([
        0,
        0,
        0
    ]), 0x05);
    Mode$1.FNC1_SECOND_POSITION = new Mode$1(ModeValues.FNC1_SECOND_POSITION, 'FNC1_SECOND_POSITION', Int32Array.from([
        0,
        0,
        0
    ]), 0x09);
    /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */ Mode$1.HANZI = new Mode$1(ModeValues.HANZI, 'HANZI', Int32Array.from([
        8,
        10,
        12
    ]), 0x0D);
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.io.UnsupportedEncodingException;*/ /*import java.util.ArrayList;*/ /*import java.util.Collection;*/ /*import java.util.List;*/ /*import java.util.Map;*/ /**
     * <p>QR Codes can encode text as bits in one of several modes, and can use multiple modes
     * in one QR Code. This class decodes the bits back into text.</p>
     *
     * <p>See ISO 18004:2006, 6.4.3 - 6.4.7</p>
     *
     * @author Sean Owen
     */ class DecodedBitStreamParser$1 {
        static decode(bytes, version, ecLevel, hints) {
            const bits = new BitSource(bytes);
            let result = new StringBuilder();
            const byteSegments = new Array(); // 1
            // TYPESCRIPTPORT: I do not use constructor with size 1 as in original Java means capacity and the array length is checked below
            let symbolSequence = -1;
            let parityData = -1;
            try {
                let currentCharacterSetECI = null;
                let fc1InEffect = false;
                let mode;
                do {
                    // While still another segment to read...
                    if (bits.available() < 4) // OK, assume we're done. Really, a TERMINATOR mode should have been recorded here
                    mode = Mode$1.TERMINATOR;
                    else {
                        const modeBits = bits.readBits(4);
                        mode = Mode$1.forBits(modeBits); // mode is encoded by 4 bits
                    }
                    switch(mode){
                        case Mode$1.TERMINATOR:
                            break;
                        case Mode$1.FNC1_FIRST_POSITION:
                        case Mode$1.FNC1_SECOND_POSITION:
                            // We do little with FNC1 except alter the parsed result a bit according to the spec
                            fc1InEffect = true;
                            break;
                        case Mode$1.STRUCTURED_APPEND:
                            if (bits.available() < 16) throw new FormatException();
                            // sequence number and parity is added later to the result metadata
                            // Read next 8 bits (symbol sequence #) and 8 bits (data: parity), then continue
                            symbolSequence = bits.readBits(8);
                            parityData = bits.readBits(8);
                            break;
                        case Mode$1.ECI:
                            // Count doesn't apply to ECI
                            const value = DecodedBitStreamParser$1.parseECIValue(bits);
                            currentCharacterSetECI = CharacterSetECI.getCharacterSetECIByValue(value);
                            if (currentCharacterSetECI === null) throw new FormatException();
                            break;
                        case Mode$1.HANZI:
                            // First handle Hanzi mode which does not start with character count
                            // Chinese mode contains a sub set indicator right after mode indicator
                            const subset = bits.readBits(4);
                            const countHanzi = bits.readBits(mode.getCharacterCountBits(version));
                            if (subset === DecodedBitStreamParser$1.GB2312_SUBSET) DecodedBitStreamParser$1.decodeHanziSegment(bits, result, countHanzi);
                            break;
                        default:
                            // "Normal" QR code modes:
                            // How many characters will follow, encoded in this mode?
                            const count = bits.readBits(mode.getCharacterCountBits(version));
                            switch(mode){
                                case Mode$1.NUMERIC:
                                    DecodedBitStreamParser$1.decodeNumericSegment(bits, result, count);
                                    break;
                                case Mode$1.ALPHANUMERIC:
                                    DecodedBitStreamParser$1.decodeAlphanumericSegment(bits, result, count, fc1InEffect);
                                    break;
                                case Mode$1.BYTE:
                                    DecodedBitStreamParser$1.decodeByteSegment(bits, result, count, currentCharacterSetECI, byteSegments, hints);
                                    break;
                                case Mode$1.KANJI:
                                    DecodedBitStreamParser$1.decodeKanjiSegment(bits, result, count);
                                    break;
                                default:
                                    throw new FormatException();
                            }
                            break;
                    }
                }while (mode !== Mode$1.TERMINATOR);
            } catch (iae /*: IllegalArgumentException*/ ) {
                // from readBits() calls
                throw new FormatException();
            }
            return new DecoderResult(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, ecLevel === null ? null : ecLevel.toString(), symbolSequence, parityData);
        }
        /**
         * See specification GBT 18284-2000
         */ static decodeHanziSegment(bits, result, count /*int*/ ) {
            // Don't crash trying to read more bits than we have available.
            if (count * 13 > bits.available()) throw new FormatException();
            // Each character will require 2 bytes. Read the characters as 2-byte pairs
            // and decode as GB2312 afterwards
            const buffer = new Uint8Array(2 * count);
            let offset = 0;
            while(count > 0){
                // Each 13 bits encodes a 2-byte character
                const twoBytes = bits.readBits(13);
                let assembledTwoBytes = twoBytes / 0x060 << 8 & 0xFFFFFFFF | twoBytes % 0x060;
                if (assembledTwoBytes < 0x003BF) // In the 0xA1A1 to 0xAAFE range
                assembledTwoBytes += 0x0A1A1;
                else // In the 0xB0A1 to 0xFAFE range
                assembledTwoBytes += 0x0A6A1;
                buffer[offset] = /*(byte) */ assembledTwoBytes >> 8 & 0xFF;
                buffer[offset + 1] = /*(byte) */ assembledTwoBytes & 0xFF;
                offset += 2;
                count--;
            }
            try {
                result.append(StringEncoding.decode(buffer, StringUtils.GB2312));
            // TYPESCRIPTPORT: TODO: implement GB2312 decode. StringView from MDN could be a starting point
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                throw new FormatException(ignored);
            }
        }
        static decodeKanjiSegment(bits, result, count /*int*/ ) {
            // Don't crash trying to read more bits than we have available.
            if (count * 13 > bits.available()) throw new FormatException();
            // Each character will require 2 bytes. Read the characters as 2-byte pairs
            // and decode as Shift_JIS afterwards
            const buffer = new Uint8Array(2 * count);
            let offset = 0;
            while(count > 0){
                // Each 13 bits encodes a 2-byte character
                const twoBytes = bits.readBits(13);
                let assembledTwoBytes = twoBytes / 0x0C0 << 8 & 0xFFFFFFFF | twoBytes % 0x0C0;
                if (assembledTwoBytes < 0x01F00) // In the 0x8140 to 0x9FFC range
                assembledTwoBytes += 0x08140;
                else // In the 0xE040 to 0xEBBF range
                assembledTwoBytes += 0x0C140;
                buffer[offset] = /*(byte) */ assembledTwoBytes >> 8;
                buffer[offset + 1] = /*(byte) */ assembledTwoBytes;
                offset += 2;
                count--;
            }
            // Shift_JIS may not be supported in some environments:
            try {
                result.append(StringEncoding.decode(buffer, StringUtils.SHIFT_JIS));
            // TYPESCRIPTPORT: TODO: implement SHIFT_JIS decode. StringView from MDN could be a starting point
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                throw new FormatException(ignored);
            }
        }
        static decodeByteSegment(bits, result, count /*int*/ , currentCharacterSetECI, byteSegments, hints) {
            // Don't crash trying to read more bits than we have available.
            if (8 * count > bits.available()) throw new FormatException();
            const readBytes = new Uint8Array(count);
            for(let i = 0; i < count; i++)readBytes[i] = /*(byte) */ bits.readBits(8);
            let encoding;
            if (currentCharacterSetECI === null) // The spec isn't clear on this mode; see
            // section 6.4.5: t does not say which encoding to assuming
            // upon decoding. I have seen ISO-8859-1 used as well as
            // Shift_JIS -- without anything like an ECI designator to
            // give a hint.
            encoding = StringUtils.guessEncoding(readBytes, hints);
            else encoding = currentCharacterSetECI.getName();
            try {
                result.append(StringEncoding.decode(readBytes, encoding));
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                throw new FormatException(ignored);
            }
            byteSegments.push(readBytes);
        }
        static toAlphaNumericChar(value /*int*/ ) {
            if (value >= DecodedBitStreamParser$1.ALPHANUMERIC_CHARS.length) throw new FormatException();
            return DecodedBitStreamParser$1.ALPHANUMERIC_CHARS[value];
        }
        static decodeAlphanumericSegment(bits, result, count /*int*/ , fc1InEffect) {
            // Read two characters at a time
            const start = result.length();
            while(count > 1){
                if (bits.available() < 11) throw new FormatException();
                const nextTwoCharsBits = bits.readBits(11);
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(nextTwoCharsBits / 45)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(nextTwoCharsBits % 45));
                count -= 2;
            }
            if (count === 1) {
                // special case: one character left
                if (bits.available() < 6) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(bits.readBits(6)));
            }
            // See section 6.4.8.1, 6.4.8.2
            if (fc1InEffect) {
                // We need to massage the result a bit if in an FNC1 mode:
                for(let i = start; i < result.length(); i++)if (result.charAt(i) === '%') {
                    if (i < result.length() - 1 && result.charAt(i + 1) === '%') // %% is rendered as %
                    result.deleteCharAt(i + 1);
                    else // In alpha mode, % should be converted to FNC1 separator 0x1D
                    result.setCharAt(i, String.fromCharCode(0x1D));
                }
            }
        }
        static decodeNumericSegment(bits, result, count /*int*/ ) {
            // Read three digits at a time
            while(count >= 3){
                // Each 10 bits encodes three digits
                if (bits.available() < 10) throw new FormatException();
                const threeDigitsBits = bits.readBits(10);
                if (threeDigitsBits >= 1000) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(threeDigitsBits / 100)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(threeDigitsBits / 10) % 10));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(threeDigitsBits % 10));
                count -= 3;
            }
            if (count === 2) {
                // Two digits left over to read, encoded in 7 bits
                if (bits.available() < 7) throw new FormatException();
                const twoDigitsBits = bits.readBits(7);
                if (twoDigitsBits >= 100) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(twoDigitsBits / 10)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(twoDigitsBits % 10));
            } else if (count === 1) {
                // One digit left over to read
                if (bits.available() < 4) throw new FormatException();
                const digitBits = bits.readBits(4);
                if (digitBits >= 10) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(digitBits));
            }
        }
        static parseECIValue(bits) {
            const firstByte = bits.readBits(8);
            if ((firstByte & 0x80) === 0) // just one byte
            return firstByte & 0x7F;
            if ((firstByte & 0xC0) === 0x80) {
                // two bytes
                const secondByte = bits.readBits(8);
                return (firstByte & 0x3F) << 8 & 0xFFFFFFFF | secondByte;
            }
            if ((firstByte & 0xE0) === 0xC0) {
                // three bytes
                const secondThirdBytes = bits.readBits(16);
                return (firstByte & 0x1F) << 16 & 0xFFFFFFFF | secondThirdBytes;
            }
            throw new FormatException();
        }
    }
    /**
     * See ISO 18004:2006, 6.4.4 Table 5
     */ DecodedBitStreamParser$1.ALPHANUMERIC_CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:';
    DecodedBitStreamParser$1.GB2312_SUBSET = 1;
    // function Uint8ArrayToString(a: Uint8Array): string {
    //     const CHUNK_SZ = 0x8000;
    //     const c = new StringBuilder();
    //     for (let i = 0, length = a.length; i < length; i += CHUNK_SZ) {
    //         c.append(String.fromCharCode.apply(null, a.subarray(i, i + CHUNK_SZ)));
    //     }
    //     return c.toString();
    // }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * Meta-data container for QR Code decoding. Instances of this class may be used to convey information back to the
     * decoding caller. Callers are expected to process this.
     *
     * @see com.google.zxing.common.DecoderResult#getOther()
     */ class QRCodeDecoderMetaData {
        constructor(mirrored){
            this.mirrored = mirrored;
        }
        /**
         * @return true if the QR Code was mirrored.
         */ isMirrored() {
            return this.mirrored;
        }
        /**
         * Apply the result points' order correction due to mirroring.
         *
         * @param points Array of points to apply mirror correction to.
         */ applyMirroredCorrection(points) {
            if (!this.mirrored || points === null || points.length < 3) return;
            const bottomLeft = points[0];
            points[0] = points[2];
            points[2] = bottomLeft;
        // No need to 'fix' top-left and alignment pattern.
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.Map;*/ /**
     * <p>The main class which implements QR Code decoding -- as opposed to locating and extracting
     * the QR Code from an image.</p>
     *
     * @author Sean Owen
     */ class Decoder$2 {
        constructor(){
            this.rsDecoder = new ReedSolomonDecoder(GenericGF.QR_CODE_FIELD_256);
        }
        // public decode(image: boolean[][]): DecoderResult /*throws ChecksumException, FormatException*/ {
        //   return decode(image, null)
        // }
        /**
         * <p>Convenience method that can decode a QR Code represented as a 2D array of booleans.
         * "true" is taken to mean a black module.</p>
         *
         * @param image booleans representing white/black QR Code modules
         * @param hints decoding hints that should be used to influence decoding
         * @return text and bytes encoded within the QR Code
         * @throws FormatException if the QR Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ decodeBooleanArray(image, hints) {
            return this.decodeBitMatrix(BitMatrix.parseFromBooleanArray(image), hints);
        }
        // public decodeBitMatrix(bits: BitMatrix): DecoderResult /*throws ChecksumException, FormatException*/ {
        //   return decode(bits, null)
        // }
        /**
         * <p>Decodes a QR Code represented as a {@link BitMatrix}. A 1 or "true" is taken to mean a black module.</p>
         *
         * @param bits booleans representing white/black QR Code modules
         * @param hints decoding hints that should be used to influence decoding
         * @return text and bytes encoded within the QR Code
         * @throws FormatException if the QR Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ decodeBitMatrix(bits, hints) {
            // Construct a parser and read version, error-correction level
            const parser = new BitMatrixParser$1(bits);
            let ex = null;
            try {
                return this.decodeBitMatrixParser(parser, hints);
            } catch (e /*: FormatException, ChecksumException*/ ) {
                ex = e;
            }
            try {
                // Revert the bit matrix
                parser.remask();
                // Will be attempting a mirrored reading of the version and format info.
                parser.setMirror(true);
                // Preemptively read the version.
                parser.readVersion();
                // Preemptively read the format information.
                parser.readFormatInformation();
                /*
                 * Since we're here, this means we have successfully detected some kind
                 * of version and format information when mirrored. This is a good sign,
                 * that the QR code may be mirrored, and we should try once more with a
                 * mirrored content.
                 */ // Prepare for a mirrored reading.
                parser.mirror();
                const result = this.decodeBitMatrixParser(parser, hints);
                // Success! Notify the caller that the code was mirrored.
                result.setOther(new QRCodeDecoderMetaData(true));
                return result;
            } catch (e /*FormatException | ChecksumException*/ ) {
                // Throw the exception from the original reading
                if (ex !== null) throw ex;
                throw e;
            }
        }
        decodeBitMatrixParser(parser, hints) {
            const version = parser.readVersion();
            const ecLevel = parser.readFormatInformation().getErrorCorrectionLevel();
            // Read codewords
            const codewords = parser.readCodewords();
            // Separate into data blocks
            const dataBlocks = DataBlock$1.getDataBlocks(codewords, version, ecLevel);
            // Count total number of data bytes
            let totalBytes = 0;
            for (const dataBlock of dataBlocks)totalBytes += dataBlock.getNumDataCodewords();
            const resultBytes = new Uint8Array(totalBytes);
            let resultOffset = 0;
            // Error-correct and copy data blocks together into a stream of bytes
            for (const dataBlock of dataBlocks){
                const codewordBytes = dataBlock.getCodewords();
                const numDataCodewords = dataBlock.getNumDataCodewords();
                this.correctErrors(codewordBytes, numDataCodewords);
                for(let i = 0; i < numDataCodewords; i++)resultBytes[resultOffset++] = codewordBytes[i];
            }
            // Decode the contents of that stream of bytes
            return DecodedBitStreamParser$1.decode(resultBytes, version, ecLevel, hints);
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place using Reed-Solomon error correction.</p>
         *
         * @param codewordBytes data and error correction codewords
         * @param numDataCodewords number of codewords that are data bytes
         * @throws ChecksumException if error correction fails
         */ correctErrors(codewordBytes, numDataCodewords /*int*/ ) {
            // const numCodewords = codewordBytes.length;
            // First read into an array of ints
            const codewordsInts = new Int32Array(codewordBytes);
            // TYPESCRIPTPORT: not realy necessary to transform to ints? could redesign everything to work with unsigned bytes?
            // const codewordsInts = new Int32Array(numCodewords)
            // for (let i = 0; i < numCodewords; i++) {
            //   codewordsInts[i] = codewordBytes[i] & 0xFF
            // }
            try {
                this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
            } catch (ignored /*: ReedSolomonException*/ ) {
                throw new ChecksumException();
            }
            // Copy back into array of bytes -- only need to worry about the bytes that were data
            // We don't care about errors in the error-correction codewords
            for(let i = 0; i < numDataCodewords; i++)codewordBytes[i] = /*(byte) */ codewordsInts[i];
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates an alignment pattern, which are the smaller square patterns found in
     * all but the simplest QR Codes.</p>
     *
     * @author Sean Owen
     */ class AlignmentPattern extends ResultPoint {
        constructor(posX /*float*/ , posY /*float*/ , estimatedModuleSize /*float*/ ){
            super(posX, posY);
            this.estimatedModuleSize = estimatedModuleSize;
        }
        /**
         * <p>Determines if this alignment pattern "about equals" an alignment pattern at the stated
         * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
         */ aboutEquals(moduleSize /*float*/ , i /*float*/ , j /*float*/ ) {
            if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
                const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
                return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
            }
            return false;
        }
        /**
         * Combines this object's current estimate of a finder pattern position and module size
         * with a new estimate. It returns a new {@code FinderPattern} containing an average of the two.
         */ combineEstimate(i /*float*/ , j /*float*/ , newModuleSize /*float*/ ) {
            const combinedX = (this.getX() + j) / 2.0;
            const combinedY = (this.getY() + i) / 2.0;
            const combinedModuleSize = (this.estimatedModuleSize + newModuleSize) / 2.0;
            return new AlignmentPattern(combinedX, combinedY, combinedModuleSize);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.ArrayList;*/ /*import java.util.List;*/ /**
     * <p>This class attempts to find alignment patterns in a QR Code. Alignment patterns look like finder
     * patterns but are smaller and appear at regular intervals throughout the image.</p>
     *
     * <p>At the moment this only looks for the bottom-right alignment pattern.</p>
     *
     * <p>This is mostly a simplified copy of {@link FinderPatternFinder}. It is copied,
     * pasted and stripped down here for maximum performance but does unfortunately duplicate
     * some code.</p>
     *
     * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.</p>
     *
     * @author Sean Owen
     */ class AlignmentPatternFinder {
        /**
         * <p>Creates a finder that will look in a portion of the whole image.</p>
         *
         * @param image image to search
         * @param startX left column from which to start searching
         * @param startY top row from which to start searching
         * @param width width of region to search
         * @param height height of region to search
         * @param moduleSize estimated module size so far
         */ constructor(image, startX /*int*/ , startY /*int*/ , width /*int*/ , height /*int*/ , moduleSize /*float*/ , resultPointCallback){
            this.image = image;
            this.startX = startX;
            this.startY = startY;
            this.width = width;
            this.height = height;
            this.moduleSize = moduleSize;
            this.resultPointCallback = resultPointCallback;
            this.possibleCenters = []; // new Array<any>(5))
            // TYPESCRIPTPORT: array initialization without size as the length is checked below
            this.crossCheckStateCount = new Int32Array(3);
        }
        /**
         * <p>This method attempts to find the bottom-right alignment pattern in the image. It is a bit messy since
         * it's pretty performance-critical and so is written to be fast foremost.</p>
         *
         * @return {@link AlignmentPattern} if found
         * @throws NotFoundException if not found
         */ find() {
            const startX = this.startX;
            const height = this.height;
            const width = this.width;
            const maxJ = startX + width;
            const middleI = this.startY + height / 2;
            // We are looking for black/white/black modules in 1:1:1 ratio
            // this tracks the number of black/white/black modules seen so far
            const stateCount = new Int32Array(3);
            const image = this.image;
            for(let iGen = 0; iGen < height; iGen++){
                // Search from middle outwards
                const i = middleI + ((iGen & 0x01) === 0 ? Math.floor((iGen + 1) / 2) : -Math.floor((iGen + 1) / 2));
                stateCount[0] = 0;
                stateCount[1] = 0;
                stateCount[2] = 0;
                let j = startX;
                // Burn off leading white pixels before anything else; if we start in the middle of
                // a white run, it doesn't make sense to count its length, since we don't know if the
                // white run continued to the left of the start point
                while(j < maxJ && !image.get(j, i))j++;
                let currentState = 0;
                while(j < maxJ){
                    if (image.get(j, i)) {
                        // Black pixel
                        if (currentState === 1) stateCount[1]++;
                        else if (currentState === 2) {
                            if (this.foundPatternCross(stateCount)) {
                                const confirmed = this.handlePossibleCenter(stateCount, i, j);
                                if (confirmed !== null) return confirmed;
                            }
                            stateCount[0] = stateCount[2];
                            stateCount[1] = 1;
                            stateCount[2] = 0;
                            currentState = 1;
                        } else stateCount[++currentState]++;
                    } else {
                        if (currentState === 1) currentState++;
                        stateCount[currentState]++;
                    }
                    j++;
                }
                if (this.foundPatternCross(stateCount)) {
                    const confirmed = this.handlePossibleCenter(stateCount, i, maxJ);
                    if (confirmed !== null) return confirmed;
                }
            }
            // Hmm, nothing we saw was observed and confirmed twice. If we had
            // any guess at all, return it.
            if (this.possibleCenters.length !== 0) return this.possibleCenters[0];
            throw new NotFoundException();
        }
        /**
         * Given a count of black/white/black pixels just seen and an end position,
         * figures the location of the center of this black/white/black run.
         */ static centerFromEnd(stateCount, end /*int*/ ) {
            return end - stateCount[2] - stateCount[1] / 2.0;
        }
        /**
         * @param stateCount count of black/white/black pixels just read
         * @return true iff the proportions of the counts is close enough to the 1/1/1 ratios
         *         used by alignment patterns to be considered a match
         */ foundPatternCross(stateCount) {
            const moduleSize = this.moduleSize;
            const maxVariance = moduleSize / 2.0;
            for(let i = 0; i < 3; i++){
                if (Math.abs(moduleSize - stateCount[i]) >= maxVariance) return false;
            }
            return true;
        }
        /**
         * <p>After a horizontal scan finds a potential alignment pattern, this method
         * "cross-checks" by scanning down vertically through the center of the possible
         * alignment pattern to see if the same proportion is detected.</p>
         *
         * @param startI row where an alignment pattern was detected
         * @param centerJ center of the section that appears to cross an alignment pattern
         * @param maxCount maximum reasonable number of modules that should be
         * observed in any reading state, based on the results of the horizontal scan
         * @return vertical center of alignment pattern, or {@link Float#NaN} if not found
         */ crossCheckVertical(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const image = this.image;
            const maxI = image.getHeight();
            const stateCount = this.crossCheckStateCount;
            stateCount[0] = 0;
            stateCount[1] = 0;
            stateCount[2] = 0;
            // Start counting up from center
            let i = startI;
            while(i >= 0 && image.get(centerJ, i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i--;
            }
            // If already too many modules in this state or ran off the edge:
            if (i < 0 || stateCount[1] > maxCount) return NaN;
            while(i >= 0 && !image.get(centerJ, i) && stateCount[0] <= maxCount){
                stateCount[0]++;
                i--;
            }
            if (stateCount[0] > maxCount) return NaN;
            // Now also count down from center
            i = startI + 1;
            while(i < maxI && image.get(centerJ, i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i++;
            }
            if (i === maxI || stateCount[1] > maxCount) return NaN;
            while(i < maxI && !image.get(centerJ, i) && stateCount[2] <= maxCount){
                stateCount[2]++;
                i++;
            }
            if (stateCount[2] > maxCount) return NaN;
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) return NaN;
            return this.foundPatternCross(stateCount) ? AlignmentPatternFinder.centerFromEnd(stateCount, i) : NaN;
        }
        /**
         * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
         * cross check with a vertical scan, and if successful, will see if this pattern had been
         * found on a previous horizontal scan. If so, we consider it confirmed and conclude we have
         * found the alignment pattern.</p>
         *
         * @param stateCount reading state module counts from horizontal scan
         * @param i row where alignment pattern may be found
         * @param j end of possible alignment pattern in row
         * @return {@link AlignmentPattern} if we have found the same pattern twice, or null if not
         */ handlePossibleCenter(stateCount, i /*int*/ , j /*int*/ ) {
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
            const centerJ = AlignmentPatternFinder.centerFromEnd(stateCount, j);
            const centerI = this.crossCheckVertical(i, /*(int) */ centerJ, 2 * stateCount[1], stateCountTotal);
            if (!isNaN(centerI)) {
                const estimatedModuleSize = (stateCount[0] + stateCount[1] + stateCount[2]) / 3.0;
                for (const center of this.possibleCenters){
                    // Look for about the same center and module size:
                    if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) return center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                }
                // Hadn't found this before; save it
                const point = new AlignmentPattern(centerJ, centerI, estimatedModuleSize);
                this.possibleCenters.push(point);
                if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) this.resultPointCallback.foundPossibleResultPoint(point);
            }
            return null;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a finder pattern, which are the three square patterns found in
     * the corners of QR Codes. It also encapsulates a count of similar finder patterns,
     * as a convenience to the finder's bookkeeping.</p>
     *
     * @author Sean Owen
     */ class FinderPattern$1 extends ResultPoint {
        // FinderPattern(posX: number/*float*/, posY: number/*float*/, estimatedModuleSize: number/*float*/) {
        //   this(posX, posY, estimatedModuleSize, 1)
        // }
        constructor(posX /*float*/ , posY /*float*/ , estimatedModuleSize /*float*/ , count /*int*/ ){
            super(posX, posY);
            this.estimatedModuleSize = estimatedModuleSize;
            this.count = count;
            if (undefined === count) this.count = 1;
        }
        getEstimatedModuleSize() {
            return this.estimatedModuleSize;
        }
        getCount() {
            return this.count;
        }
        /*
        void incrementCount() {
          this.count++
        }
         */ /**
         * <p>Determines if this finder pattern "about equals" a finder pattern at the stated
         * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
         */ aboutEquals(moduleSize /*float*/ , i /*float*/ , j /*float*/ ) {
            if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
                const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
                return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
            }
            return false;
        }
        /**
         * Combines this object's current estimate of a finder pattern position and module size
         * with a new estimate. It returns a new {@code FinderPattern} containing a weighted average
         * based on count.
         */ combineEstimate(i /*float*/ , j /*float*/ , newModuleSize /*float*/ ) {
            const combinedCount = this.count + 1;
            const combinedX = (this.count * this.getX() + j) / combinedCount;
            const combinedY = (this.count * this.getY() + i) / combinedCount;
            const combinedModuleSize = (this.count * this.estimatedModuleSize + newModuleSize) / combinedCount;
            return new FinderPattern$1(combinedX, combinedY, combinedModuleSize, combinedCount);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates information about finder patterns in an image, including the location of
     * the three finder patterns, and their estimated module size.</p>
     *
     * @author Sean Owen
     */ class FinderPatternInfo {
        constructor(patternCenters){
            this.bottomLeft = patternCenters[0];
            this.topLeft = patternCenters[1];
            this.topRight = patternCenters[2];
        }
        getBottomLeft() {
            return this.bottomLeft;
        }
        getTopLeft() {
            return this.topLeft;
        }
        getTopRight() {
            return this.topRight;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.io.Serializable;*/ /*import java.util.ArrayList;*/ /*import java.util.Collections;*/ /*import java.util.Comparator;*/ /*import java.util.List;*/ /*import java.util.Map;*/ /**
     * <p>This class attempts to find finder patterns in a QR Code. Finder patterns are the square
     * markers at three corners of a QR Code.</p>
     *
     * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.
     *
     * @author Sean Owen
     */ class FinderPatternFinder {
        /**
         * <p>Creates a finder that will search the image for three finder patterns.</p>
         *
         * @param image image to search
         */ // public constructor(image: BitMatrix) {
        //   this(image, null)
        // }
        constructor(image, resultPointCallback){
            this.image = image;
            this.resultPointCallback = resultPointCallback;
            this.possibleCenters = [];
            this.crossCheckStateCount = new Int32Array(5);
            this.resultPointCallback = resultPointCallback;
        }
        getImage() {
            return this.image;
        }
        getPossibleCenters() {
            return this.possibleCenters;
        }
        find(hints) {
            const tryHarder = hints !== null && hints !== undefined && undefined !== hints.get(DecodeHintType$1.TRY_HARDER);
            const pureBarcode = hints !== null && hints !== undefined && undefined !== hints.get(DecodeHintType$1.PURE_BARCODE);
            const image = this.image;
            const maxI = image.getHeight();
            const maxJ = image.getWidth();
            // We are looking for black/white/black/white/black modules in
            // 1:1:3:1:1 ratio; this tracks the number of such modules seen so far
            // Let's assume that the maximum version QR Code we support takes up 1/4 the height of the
            // image, and then account for the center being 3 modules in size. This gives the smallest
            // number of pixels the center could be, so skip this often. When trying harder, look for all
            // QR versions regardless of how dense they are.
            let iSkip = Math.floor(3 * maxI / (4 * FinderPatternFinder.MAX_MODULES));
            if (iSkip < FinderPatternFinder.MIN_SKIP || tryHarder) iSkip = FinderPatternFinder.MIN_SKIP;
            let done = false;
            const stateCount = new Int32Array(5);
            for(let i = iSkip - 1; i < maxI && !done; i += iSkip){
                // Get a row of black/white values
                stateCount[0] = 0;
                stateCount[1] = 0;
                stateCount[2] = 0;
                stateCount[3] = 0;
                stateCount[4] = 0;
                let currentState = 0;
                for(let j = 0; j < maxJ; j++){
                    if (image.get(j, i)) {
                        // Black pixel
                        if ((currentState & 1) === 1) currentState++;
                        stateCount[currentState]++;
                    } else if ((currentState & 1) === 0) {
                        if (currentState === 4) {
                            if (FinderPatternFinder.foundPatternCross(stateCount)) {
                                const confirmed = this.handlePossibleCenter(stateCount, i, j, pureBarcode);
                                if (confirmed === true) {
                                    // Start examining every other line. Checking each line turned out to be too
                                    // expensive and didn't improve performance.
                                    iSkip = 2;
                                    if (this.hasSkipped === true) done = this.haveMultiplyConfirmedCenters();
                                    else {
                                        const rowSkip = this.findRowSkip();
                                        if (rowSkip > stateCount[2]) {
                                            // Skip rows between row of lower confirmed center
                                            // and top of presumed third confirmed center
                                            // but back up a bit to get a full chance of detecting
                                            // it, entire width of center of finder pattern
                                            // Skip by rowSkip, but back off by stateCount[2] (size of last center
                                            // of pattern we saw) to be conservative, and also back off by iSkip which
                                            // is about to be re-added
                                            i += rowSkip - stateCount[2] - iSkip;
                                            j = maxJ - 1;
                                        }
                                    }
                                } else {
                                    stateCount[0] = stateCount[2];
                                    stateCount[1] = stateCount[3];
                                    stateCount[2] = stateCount[4];
                                    stateCount[3] = 1;
                                    stateCount[4] = 0;
                                    currentState = 3;
                                    continue;
                                }
                                // Clear state to start looking again
                                currentState = 0;
                                stateCount[0] = 0;
                                stateCount[1] = 0;
                                stateCount[2] = 0;
                                stateCount[3] = 0;
                                stateCount[4] = 0;
                            } else {
                                stateCount[0] = stateCount[2];
                                stateCount[1] = stateCount[3];
                                stateCount[2] = stateCount[4];
                                stateCount[3] = 1;
                                stateCount[4] = 0;
                                currentState = 3;
                            }
                        } else stateCount[++currentState]++;
                    } else stateCount[currentState]++;
                }
                if (FinderPatternFinder.foundPatternCross(stateCount)) {
                    const confirmed = this.handlePossibleCenter(stateCount, i, maxJ, pureBarcode);
                    if (confirmed === true) {
                        iSkip = stateCount[0];
                        if (this.hasSkipped) // Found a third one
                        done = this.haveMultiplyConfirmedCenters();
                    }
                }
            }
            const patternInfo = this.selectBestPatterns();
            ResultPoint.orderBestPatterns(patternInfo);
            return new FinderPatternInfo(patternInfo);
        }
        /**
         * Given a count of black/white/black/white/black pixels just seen and an end position,
         * figures the location of the center of this run.
         */ static centerFromEnd(stateCount, end /*int*/ ) {
            return end - stateCount[4] - stateCount[3] - stateCount[2] / 2.0;
        }
        /**
         * @param stateCount count of black/white/black/white/black pixels just read
         * @return true iff the proportions of the counts is close enough to the 1/1/3/1/1 ratios
         *         used by finder patterns to be considered a match
         */ static foundPatternCross(stateCount) {
            let totalModuleSize = 0;
            for(let i = 0; i < 5; i++){
                const count = stateCount[i];
                if (count === 0) return false;
                totalModuleSize += count;
            }
            if (totalModuleSize < 7) return false;
            const moduleSize = totalModuleSize / 7.0;
            const maxVariance = moduleSize / 2.0;
            // Allow less than 50% variance from 1-1-3-1-1 proportions
            return Math.abs(moduleSize - stateCount[0]) < maxVariance && Math.abs(moduleSize - stateCount[1]) < maxVariance && Math.abs(3.0 * moduleSize - stateCount[2]) < 3 * maxVariance && Math.abs(moduleSize - stateCount[3]) < maxVariance && Math.abs(moduleSize - stateCount[4]) < maxVariance;
        }
        getCrossCheckStateCount() {
            const crossCheckStateCount = this.crossCheckStateCount;
            crossCheckStateCount[0] = 0;
            crossCheckStateCount[1] = 0;
            crossCheckStateCount[2] = 0;
            crossCheckStateCount[3] = 0;
            crossCheckStateCount[4] = 0;
            return crossCheckStateCount;
        }
        /**
         * After a vertical and horizontal scan finds a potential finder pattern, this method
         * "cross-cross-cross-checks" by scanning down diagonally through the center of the possible
         * finder pattern to see if the same proportion is detected.
         *
         * @param startI row where a finder pattern was detected
         * @param centerJ center of the section that appears to cross a finder pattern
         * @param maxCount maximum reasonable number of modules that should be
         *  observed in any reading state, based on the results of the horizontal scan
         * @param originalStateCountTotal The original state count total.
         * @return true if proportions are withing expected limits
         */ crossCheckDiagonal(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const stateCount = this.getCrossCheckStateCount();
            // Start counting up, left from center finding black center mass
            let i = 0;
            const image = this.image;
            while(startI >= i && centerJ >= i && image.get(centerJ - i, startI - i)){
                stateCount[2]++;
                i++;
            }
            if (startI < i || centerJ < i) return false;
            // Continue up, left finding white space
            while(startI >= i && centerJ >= i && !image.get(centerJ - i, startI - i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i++;
            }
            // If already too many modules in this state or ran off the edge:
            if (startI < i || centerJ < i || stateCount[1] > maxCount) return false;
            // Continue up, left finding black border
            while(startI >= i && centerJ >= i && image.get(centerJ - i, startI - i) && stateCount[0] <= maxCount){
                stateCount[0]++;
                i++;
            }
            if (stateCount[0] > maxCount) return false;
            const maxI = image.getHeight();
            const maxJ = image.getWidth();
            // Now also count down, right from center
            i = 1;
            while(startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i)){
                stateCount[2]++;
                i++;
            }
            // Ran off the edge?
            if (startI + i >= maxI || centerJ + i >= maxJ) return false;
            while(startI + i < maxI && centerJ + i < maxJ && !image.get(centerJ + i, startI + i) && stateCount[3] < maxCount){
                stateCount[3]++;
                i++;
            }
            if (startI + i >= maxI || centerJ + i >= maxJ || stateCount[3] >= maxCount) return false;
            while(startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i) && stateCount[4] < maxCount){
                stateCount[4]++;
                i++;
            }
            if (stateCount[4] >= maxCount) return false;
            // If we found a finder-pattern-like section, but its size is more than 100% different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            return Math.abs(stateCountTotal - originalStateCountTotal) < 2 * originalStateCountTotal && FinderPatternFinder.foundPatternCross(stateCount);
        }
        /**
         * <p>After a horizontal scan finds a potential finder pattern, this method
         * "cross-checks" by scanning down vertically through the center of the possible
         * finder pattern to see if the same proportion is detected.</p>
         *
         * @param startI row where a finder pattern was detected
         * @param centerJ center of the section that appears to cross a finder pattern
         * @param maxCount maximum reasonable number of modules that should be
         * observed in any reading state, based on the results of the horizontal scan
         * @return vertical center of finder pattern, or {@link Float#NaN} if not found
         */ crossCheckVertical(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const image = this.image;
            const maxI = image.getHeight();
            const stateCount = this.getCrossCheckStateCount();
            // Start counting up from center
            let i = startI;
            while(i >= 0 && image.get(centerJ, i)){
                stateCount[2]++;
                i--;
            }
            if (i < 0) return NaN;
            while(i >= 0 && !image.get(centerJ, i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i--;
            }
            // If already too many modules in this state or ran off the edge:
            if (i < 0 || stateCount[1] > maxCount) return NaN;
            while(i >= 0 && image.get(centerJ, i) && stateCount[0] <= maxCount){
                stateCount[0]++;
                i--;
            }
            if (stateCount[0] > maxCount) return NaN;
            // Now also count down from center
            i = startI + 1;
            while(i < maxI && image.get(centerJ, i)){
                stateCount[2]++;
                i++;
            }
            if (i === maxI) return NaN;
            while(i < maxI && !image.get(centerJ, i) && stateCount[3] < maxCount){
                stateCount[3]++;
                i++;
            }
            if (i === maxI || stateCount[3] >= maxCount) return NaN;
            while(i < maxI && image.get(centerJ, i) && stateCount[4] < maxCount){
                stateCount[4]++;
                i++;
            }
            if (stateCount[4] >= maxCount) return NaN;
            // If we found a finder-pattern-like section, but its size is more than 40% different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) return NaN;
            return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, i) : NaN;
        }
        /**
         * <p>Like {@link #crossCheckVertical(int, int, int, int)}, and in fact is basically identical,
         * except it reads horizontally instead of vertically. This is used to cross-cross
         * check a vertical cross check and locate the real center of the alignment pattern.</p>
         */ crossCheckHorizontal(startJ /*int*/ , centerI /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const image = this.image;
            const maxJ = image.getWidth();
            const stateCount = this.getCrossCheckStateCount();
            let j = startJ;
            while(j >= 0 && image.get(j, centerI)){
                stateCount[2]++;
                j--;
            }
            if (j < 0) return NaN;
            while(j >= 0 && !image.get(j, centerI) && stateCount[1] <= maxCount){
                stateCount[1]++;
                j--;
            }
            if (j < 0 || stateCount[1] > maxCount) return NaN;
            while(j >= 0 && image.get(j, centerI) && stateCount[0] <= maxCount){
                stateCount[0]++;
                j--;
            }
            if (stateCount[0] > maxCount) return NaN;
            j = startJ + 1;
            while(j < maxJ && image.get(j, centerI)){
                stateCount[2]++;
                j++;
            }
            if (j === maxJ) return NaN;
            while(j < maxJ && !image.get(j, centerI) && stateCount[3] < maxCount){
                stateCount[3]++;
                j++;
            }
            if (j === maxJ || stateCount[3] >= maxCount) return NaN;
            while(j < maxJ && image.get(j, centerI) && stateCount[4] < maxCount){
                stateCount[4]++;
                j++;
            }
            if (stateCount[4] >= maxCount) return NaN;
            // If we found a finder-pattern-like section, but its size is significantly different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= originalStateCountTotal) return NaN;
            return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, j) : NaN;
        }
        /**
         * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
         * cross check with a vertical scan, and if successful, will, ah, cross-cross-check
         * with another horizontal scan. This is needed primarily to locate the real horizontal
         * center of the pattern in cases of extreme skew.
         * And then we cross-cross-cross check with another diagonal scan.</p>
         *
         * <p>If that succeeds the finder pattern location is added to a list that tracks
         * the number of times each location has been nearly-matched as a finder pattern.
         * Each additional find is more evidence that the location is in fact a finder
         * pattern center
         *
         * @param stateCount reading state module counts from horizontal scan
         * @param i row where finder pattern may be found
         * @param j end of possible finder pattern in row
         * @param pureBarcode true if in "pure barcode" mode
         * @return true if a finder pattern candidate was found this time
         */ handlePossibleCenter(stateCount, i /*int*/ , j /*int*/ , pureBarcode) {
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            let centerJ = FinderPatternFinder.centerFromEnd(stateCount, j);
            let centerI = this.crossCheckVertical(i, /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal);
            if (!isNaN(centerI)) {
                // Re-cross check
                centerJ = this.crossCheckHorizontal(/*(int) */ Math.floor(centerJ), /*(int) */ Math.floor(centerI), stateCount[2], stateCountTotal);
                if (!isNaN(centerJ) && (!pureBarcode || this.crossCheckDiagonal(/*(int) */ Math.floor(centerI), /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal))) {
                    const estimatedModuleSize = stateCountTotal / 7.0;
                    let found = false;
                    const possibleCenters = this.possibleCenters;
                    for(let index = 0, length = possibleCenters.length; index < length; index++){
                        const center = possibleCenters[index];
                        // Look for about the same center and module size:
                        if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) {
                            possibleCenters[index] = center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        const point = new FinderPattern$1(centerJ, centerI, estimatedModuleSize);
                        possibleCenters.push(point);
                        if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) this.resultPointCallback.foundPossibleResultPoint(point);
                    }
                    return true;
                }
            }
            return false;
        }
        /**
         * @return number of rows we could safely skip during scanning, based on the first
         *         two finder patterns that have been located. In some cases their position will
         *         allow us to infer that the third pattern must lie below a certain point farther
         *         down in the image.
         */ findRowSkip() {
            const max = this.possibleCenters.length;
            if (max <= 1) return 0;
            let firstConfirmedCenter = null;
            for (const center of this.possibleCenters)if (center.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                if (firstConfirmedCenter == null) firstConfirmedCenter = center;
                else {
                    // We have two confirmed centers
                    // How far down can we skip before resuming looking for the next
                    // pattern? In the worst case, only the difference between the
                    // difference in the x / y coordinates of the two centers.
                    // This is the case where you find top left last.
                    this.hasSkipped = true;
                    return /*(int) */ Math.floor((Math.abs(firstConfirmedCenter.getX() - center.getX()) - Math.abs(firstConfirmedCenter.getY() - center.getY())) / 2);
                }
            }
            return 0;
        }
        /**
         * @return true iff we have found at least 3 finder patterns that have been detected
         *         at least {@link #CENTER_QUORUM} times each, and, the estimated module size of the
         *         candidates is "pretty similar"
         */ haveMultiplyConfirmedCenters() {
            let confirmedCount = 0;
            let totalModuleSize = 0.0;
            const max = this.possibleCenters.length;
            for (const pattern of this.possibleCenters)if (pattern.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                confirmedCount++;
                totalModuleSize += pattern.getEstimatedModuleSize();
            }
            if (confirmedCount < 3) return false;
            // OK, we have at least 3 confirmed centers, but, it's possible that one is a "false positive"
            // and that we need to keep looking. We detect this by asking if the estimated module sizes
            // vary too much. We arbitrarily say that when the total deviation from average exceeds
            // 5% of the total module size estimates, it's too much.
            const average = totalModuleSize / max;
            let totalDeviation = 0.0;
            for (const pattern of this.possibleCenters)totalDeviation += Math.abs(pattern.getEstimatedModuleSize() - average);
            return totalDeviation <= 0.05 * totalModuleSize;
        }
        /**
         * @return the 3 best {@link FinderPattern}s from our list of candidates. The "best" are
         *         those that have been detected at least {@link #CENTER_QUORUM} times, and whose module
         *         size differs from the average among those patterns the least
         * @throws NotFoundException if 3 such finder patterns do not exist
         */ selectBestPatterns() {
            const startSize = this.possibleCenters.length;
            if (startSize < 3) // Couldn't find enough finder patterns
            throw new NotFoundException();
            const possibleCenters = this.possibleCenters;
            let average;
            // Filter outlier possibilities whose module size is too different
            if (startSize > 3) {
                // But we can only afford to do so if we have at least 4 possibilities to choose from
                let totalModuleSize = 0.0;
                let square = 0.0;
                for (const center of this.possibleCenters){
                    const size = center.getEstimatedModuleSize();
                    totalModuleSize += size;
                    square += size * size;
                }
                average = totalModuleSize / startSize;
                let stdDev = Math.sqrt(square / startSize - average * average);
                possibleCenters.sort(/**
                 * <p>Orders by furthest from average</p>
                 */ // FurthestFromAverageComparator implements Comparator<FinderPattern>
                (center1, center2)=>{
                    const dA = Math.abs(center2.getEstimatedModuleSize() - average);
                    const dB = Math.abs(center1.getEstimatedModuleSize() - average);
                    return dA < dB ? -1 : dA > dB ? 1 : 0;
                });
                const limit = Math.max(0.2 * average, stdDev);
                for(let i = 0; i < possibleCenters.length && possibleCenters.length > 3; i++){
                    const pattern = possibleCenters[i];
                    if (Math.abs(pattern.getEstimatedModuleSize() - average) > limit) {
                        possibleCenters.splice(i, 1);
                        i--;
                    }
                }
            }
            if (possibleCenters.length > 3) {
                // Throw away all but those first size candidate points we found.
                let totalModuleSize = 0.0;
                for (const possibleCenter of possibleCenters)totalModuleSize += possibleCenter.getEstimatedModuleSize();
                average = totalModuleSize / possibleCenters.length;
                possibleCenters.sort(/**
                 * <p>Orders by {@link FinderPattern#getCount()}, descending.</p>
                 */ // CenterComparator implements Comparator<FinderPattern>
                (center1, center2)=>{
                    if (center2.getCount() === center1.getCount()) {
                        const dA = Math.abs(center2.getEstimatedModuleSize() - average);
                        const dB = Math.abs(center1.getEstimatedModuleSize() - average);
                        return dA < dB ? 1 : dA > dB ? -1 : 0;
                    } else return center2.getCount() - center1.getCount();
                });
                possibleCenters.splice(3); // this is not realy necessary as we only return first 3 anyway
            }
            return [
                possibleCenters[0],
                possibleCenters[1],
                possibleCenters[2]
            ];
        }
    }
    FinderPatternFinder.CENTER_QUORUM = 2;
    FinderPatternFinder.MIN_SKIP = 3; // 1 pixel/module times 3 modules/center
    FinderPatternFinder.MAX_MODULES = 57; // support up to version 10 for mobile clients
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.Map;*/ /**
     * <p>Encapsulates logic that can detect a QR Code in an image, even if the QR Code
     * is rotated or skewed, or partially obscured.</p>
     *
     * @author Sean Owen
     */ class Detector$2 {
        constructor(image){
            this.image = image;
        }
        getImage() {
            return this.image;
        }
        getResultPointCallback() {
            return this.resultPointCallback;
        }
        /**
         * <p>Detects a QR Code in an image.</p>
         *
         * @return {@link DetectorResult} encapsulating results of detecting a QR Code
         * @throws NotFoundException if QR Code cannot be found
         * @throws FormatException if a QR Code cannot be decoded
         */ // public detect(): DetectorResult /*throws NotFoundException, FormatException*/ {
        //   return detect(null)
        // }
        /**
         * <p>Detects a QR Code in an image.</p>
         *
         * @param hints optional hints to detector
         * @return {@link DetectorResult} encapsulating results of detecting a QR Code
         * @throws NotFoundException if QR Code cannot be found
         * @throws FormatException if a QR Code cannot be decoded
         */ detect(hints) {
            this.resultPointCallback = hints === null || hints === undefined ? null : /*(ResultPointCallback) */ hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
            const finder = new FinderPatternFinder(this.image, this.resultPointCallback);
            const info = finder.find(hints);
            return this.processFinderPatternInfo(info);
        }
        processFinderPatternInfo(info) {
            const topLeft = info.getTopLeft();
            const topRight = info.getTopRight();
            const bottomLeft = info.getBottomLeft();
            const moduleSize = this.calculateModuleSize(topLeft, topRight, bottomLeft);
            if (moduleSize < 1.0) throw new NotFoundException('No pattern found in proccess finder.');
            const dimension = Detector$2.computeDimension(topLeft, topRight, bottomLeft, moduleSize);
            const provisionalVersion = Version$1.getProvisionalVersionForDimension(dimension);
            const modulesBetweenFPCenters = provisionalVersion.getDimensionForVersion() - 7;
            let alignmentPattern = null;
            // Anything above version 1 has an alignment pattern
            if (provisionalVersion.getAlignmentPatternCenters().length > 0) {
                // Guess where a "bottom right" finder pattern would have been
                const bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
                const bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
                // Estimate that alignment pattern is closer by 3 modules
                // from "bottom right" to known top left location
                const correctionToTopLeft = 1.0 - 3.0 / modulesBetweenFPCenters;
                const estAlignmentX = /*(int) */ Math.floor(topLeft.getX() + correctionToTopLeft * (bottomRightX - topLeft.getX()));
                const estAlignmentY = /*(int) */ Math.floor(topLeft.getY() + correctionToTopLeft * (bottomRightY - topLeft.getY()));
                // Kind of arbitrary -- expand search radius before giving up
                for(let i = 4; i <= 16; i <<= 1)try {
                    alignmentPattern = this.findAlignmentInRegion(moduleSize, estAlignmentX, estAlignmentY, i);
                    break;
                } catch (re /*NotFoundException*/ ) {
                    if (!(re instanceof NotFoundException)) throw re;
                // try next round
                }
            // If we didn't find alignment pattern... well try anyway without it
            }
            const transform = Detector$2.createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension);
            const bits = Detector$2.sampleGrid(this.image, transform, dimension);
            let points;
            if (alignmentPattern === null) points = [
                bottomLeft,
                topLeft,
                topRight
            ];
            else points = [
                bottomLeft,
                topLeft,
                topRight,
                alignmentPattern
            ];
            return new DetectorResult(bits, points);
        }
        static createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension /*int*/ ) {
            const dimMinusThree = dimension - 3.5;
            let bottomRightX; /*float*/ 
            let bottomRightY; /*float*/ 
            let sourceBottomRightX; /*float*/ 
            let sourceBottomRightY; /*float*/ 
            if (alignmentPattern !== null) {
                bottomRightX = alignmentPattern.getX();
                bottomRightY = alignmentPattern.getY();
                sourceBottomRightX = dimMinusThree - 3.0;
                sourceBottomRightY = sourceBottomRightX;
            } else {
                // Don't have an alignment pattern, just make up the bottom-right point
                bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
                bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
                sourceBottomRightX = dimMinusThree;
                sourceBottomRightY = dimMinusThree;
            }
            return PerspectiveTransform.quadrilateralToQuadrilateral(3.5, 3.5, dimMinusThree, 3.5, sourceBottomRightX, sourceBottomRightY, 3.5, dimMinusThree, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRightX, bottomRightY, bottomLeft.getX(), bottomLeft.getY());
        }
        static sampleGrid(image, transform, dimension /*int*/ ) {
            const sampler = GridSamplerInstance.getInstance();
            return sampler.sampleGridWithTransform(image, dimension, dimension, transform);
        }
        /**
         * <p>Computes the dimension (number of modules on a size) of the QR Code based on the position
         * of the finder patterns and estimated module size.</p>
         */ static computeDimension(topLeft, topRight, bottomLeft, moduleSize /*float*/ ) {
            const tltrCentersDimension = MathUtils.round(ResultPoint.distance(topLeft, topRight) / moduleSize);
            const tlblCentersDimension = MathUtils.round(ResultPoint.distance(topLeft, bottomLeft) / moduleSize);
            let dimension = Math.floor((tltrCentersDimension + tlblCentersDimension) / 2) + 7;
            switch(dimension & 0x03){
                case 0:
                    dimension++;
                    break;
                // 1? do nothing
                case 2:
                    dimension--;
                    break;
                case 3:
                    throw new NotFoundException('Dimensions could be not found.');
            }
            return dimension;
        }
        /**
         * <p>Computes an average estimated module size based on estimated derived from the positions
         * of the three finder patterns.</p>
         *
         * @param topLeft detected top-left finder pattern center
         * @param topRight detected top-right finder pattern center
         * @param bottomLeft detected bottom-left finder pattern center
         * @return estimated module size
         */ calculateModuleSize(topLeft, topRight, bottomLeft) {
            // Take the average
            return (this.calculateModuleSizeOneWay(topLeft, topRight) + this.calculateModuleSizeOneWay(topLeft, bottomLeft)) / 2.0;
        }
        /**
         * <p>Estimates module size based on two finder patterns -- it uses
         * {@link #sizeOfBlackWhiteBlackRunBothWays(int, int, int, int)} to figure the
         * width of each, measuring along the axis between their centers.</p>
         */ calculateModuleSizeOneWay(pattern, otherPattern) {
            const moduleSizeEst1 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(pattern.getX()), /*(int) */ Math.floor(pattern.getY()), /*(int) */ Math.floor(otherPattern.getX()), /*(int) */ Math.floor(otherPattern.getY()));
            const moduleSizeEst2 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(otherPattern.getX()), /*(int) */ Math.floor(otherPattern.getY()), /*(int) */ Math.floor(pattern.getX()), /*(int) */ Math.floor(pattern.getY()));
            if (isNaN(moduleSizeEst1)) return moduleSizeEst2 / 7.0;
            if (isNaN(moduleSizeEst2)) return moduleSizeEst1 / 7.0;
            // Average them, and divide by 7 since we've counted the width of 3 black modules,
            // and 1 white and 1 black module on either side. Ergo, divide sum by 14.
            return (moduleSizeEst1 + moduleSizeEst2) / 14.0;
        }
        /**
         * See {@link #sizeOfBlackWhiteBlackRun(int, int, int, int)}; computes the total width of
         * a finder pattern by looking for a black-white-black run from the center in the direction
         * of another point (another finder pattern center), and in the opposite direction too.
         */ sizeOfBlackWhiteBlackRunBothWays(fromX /*int*/ , fromY /*int*/ , toX /*int*/ , toY /*int*/ ) {
            let result = this.sizeOfBlackWhiteBlackRun(fromX, fromY, toX, toY);
            // Now count other way -- don't run off image though of course
            let scale = 1.0;
            let otherToX = fromX - (toX - fromX);
            if (otherToX < 0) {
                scale = fromX / /*(float) */ (fromX - otherToX);
                otherToX = 0;
            } else if (otherToX >= this.image.getWidth()) {
                scale = (this.image.getWidth() - 1 - fromX) / /*(float) */ (otherToX - fromX);
                otherToX = this.image.getWidth() - 1;
            }
            let otherToY = /*(int) */ Math.floor(fromY - (toY - fromY) * scale);
            scale = 1.0;
            if (otherToY < 0) {
                scale = fromY / /*(float) */ (fromY - otherToY);
                otherToY = 0;
            } else if (otherToY >= this.image.getHeight()) {
                scale = (this.image.getHeight() - 1 - fromY) / /*(float) */ (otherToY - fromY);
                otherToY = this.image.getHeight() - 1;
            }
            otherToX = /*(int) */ Math.floor(fromX + (otherToX - fromX) * scale);
            result += this.sizeOfBlackWhiteBlackRun(fromX, fromY, otherToX, otherToY);
            // Middle pixel is double-counted this way; subtract 1
            return result - 1.0;
        }
        /**
         * <p>This method traces a line from a point in the image, in the direction towards another point.
         * It begins in a black region, and keeps going until it finds white, then black, then white again.
         * It reports the distance from the start to this point.</p>
         *
         * <p>This is used when figuring out how wide a finder pattern is, when the finder pattern
         * may be skewed or rotated.</p>
         */ sizeOfBlackWhiteBlackRun(fromX /*int*/ , fromY /*int*/ , toX /*int*/ , toY /*int*/ ) {
            // Mild variant of Bresenham's algorithm
            // see http://en.wikipedia.org/wiki/Bresenham's_line_algorithm
            const steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
            if (steep) {
                let temp = fromX;
                fromX = fromY;
                fromY = temp;
                temp = toX;
                toX = toY;
                toY = temp;
            }
            const dx = Math.abs(toX - fromX);
            const dy = Math.abs(toY - fromY);
            let error = -dx / 2;
            const xstep = fromX < toX ? 1 : -1;
            const ystep = fromY < toY ? 1 : -1;
            // In black pixels, looking for white, first or second time.
            let state = 0;
            // Loop up until x == toX, but not beyond
            const xLimit = toX + xstep;
            for(let x = fromX, y = fromY; x !== xLimit; x += xstep){
                const realX = steep ? y : x;
                const realY = steep ? x : y;
                // Does current pixel mean we have moved white to black or vice versa?
                // Scanning black in state 0,2 and white in state 1, so if we find the wrong
                // color, advance to next state or end if we are in state 2 already
                if (state === 1 === this.image.get(realX, realY)) {
                    if (state === 2) return MathUtils.distance(x, y, fromX, fromY);
                    state++;
                }
                error += dy;
                if (error > 0) {
                    if (y === toY) break;
                    y += ystep;
                    error -= dx;
                }
            }
            // Found black-white-black; give the benefit of the doubt that the next pixel outside the image
            // is "white" so this last point at (toX+xStep,toY) is the right ending. This is really a
            // small approximation; (toX+xStep,toY+yStep) might be really correct. Ignore this.
            if (state === 2) return MathUtils.distance(toX + xstep, toY, fromX, fromY);
            // else we didn't find even black-white-black; no estimate is really possible
            return NaN;
        }
        /**
         * <p>Attempts to locate an alignment pattern in a limited region of the image, which is
         * guessed to contain it. This method uses {@link AlignmentPattern}.</p>
         *
         * @param overallEstModuleSize estimated module size so far
         * @param estAlignmentX x coordinate of center of area probably containing alignment pattern
         * @param estAlignmentY y coordinate of above
         * @param allowanceFactor number of pixels in all directions to search from the center
         * @return {@link AlignmentPattern} if found, or null otherwise
         * @throws NotFoundException if an unexpected error occurs during detection
         */ findAlignmentInRegion(overallEstModuleSize /*float*/ , estAlignmentX /*int*/ , estAlignmentY /*int*/ , allowanceFactor /*float*/ ) {
            // Look for an alignment pattern (3 modules in size) around where it
            // should be
            const allowance = /*(int) */ Math.floor(allowanceFactor * overallEstModuleSize);
            const alignmentAreaLeftX = Math.max(0, estAlignmentX - allowance);
            const alignmentAreaRightX = Math.min(this.image.getWidth() - 1, estAlignmentX + allowance);
            if (alignmentAreaRightX - alignmentAreaLeftX < overallEstModuleSize * 3) throw new NotFoundException('Alignment top exceeds estimated module size.');
            const alignmentAreaTopY = Math.max(0, estAlignmentY - allowance);
            const alignmentAreaBottomY = Math.min(this.image.getHeight() - 1, estAlignmentY + allowance);
            if (alignmentAreaBottomY - alignmentAreaTopY < overallEstModuleSize * 3) throw new NotFoundException('Alignment bottom exceeds estimated module size.');
            const alignmentFinder = new AlignmentPatternFinder(this.image, alignmentAreaLeftX, alignmentAreaTopY, alignmentAreaRightX - alignmentAreaLeftX, alignmentAreaBottomY - alignmentAreaTopY, overallEstModuleSize, this.resultPointCallback);
            return alignmentFinder.find();
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.List;*/ /*import java.util.Map;*/ /**
     * This implementation can detect and decode QR Codes in an image.
     *
     * @author Sean Owen
     */ class QRCodeReader {
        constructor(){
            this.decoder = new Decoder$2();
        }
        getDecoder() {
            return this.decoder;
        }
        /**
         * Locates and decodes a QR code in an image.
         *
         * @return a representing: string the content encoded by the QR code
         * @throws NotFoundException if a QR code cannot be found
         * @throws FormatException if a QR code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ /*@Override*/ // public decode(image: BinaryBitmap): Result /*throws NotFoundException, ChecksumException, FormatException */ {
        //   return this.decode(image, null)
        // }
        /*@Override*/ decode(image, hints) {
            let decoderResult;
            let points;
            if (hints !== undefined && hints !== null && undefined !== hints.get(DecodeHintType$1.PURE_BARCODE)) {
                const bits = QRCodeReader.extractPureBits(image.getBlackMatrix());
                decoderResult = this.decoder.decodeBitMatrix(bits, hints);
                points = QRCodeReader.NO_POINTS;
            } else {
                const detectorResult = new Detector$2(image.getBlackMatrix()).detect(hints);
                decoderResult = this.decoder.decodeBitMatrix(detectorResult.getBits(), hints);
                points = detectorResult.getPoints();
            }
            // If the code was mirrored: swap the bottom-left and the top-right points.
            if (decoderResult.getOther() instanceof QRCodeDecoderMetaData) decoderResult.getOther().applyMirroredCorrection(points);
            const result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, BarcodeFormat$1.QR_CODE, undefined);
            const byteSegments = decoderResult.getByteSegments();
            if (byteSegments !== null) result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            const ecLevel = decoderResult.getECLevel();
            if (ecLevel !== null) result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            if (decoderResult.hasStructuredAppend()) {
                result.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_SEQUENCE, decoderResult.getStructuredAppendSequenceNumber());
                result.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_PARITY, decoderResult.getStructuredAppendParity());
            }
            return result;
        }
        /*@Override*/ reset() {
        // do nothing
        }
        /**
         * This method detects a code in a "pure" image -- that is, pure monochrome image
         * which contains only an unrotated, unskewed, image of a code, with some white border
         * around it. This is a specialized method that works exceptionally fast in this special
         * case.
         *
         * @see com.google.zxing.datamatrix.DataMatrixReader#extractPureBits(BitMatrix)
         */ static extractPureBits(image) {
            const leftTopBlack = image.getTopLeftOnBit();
            const rightBottomBlack = image.getBottomRightOnBit();
            if (leftTopBlack === null || rightBottomBlack === null) throw new NotFoundException();
            const moduleSize = this.moduleSize(leftTopBlack, image);
            let top = leftTopBlack[1];
            let bottom = rightBottomBlack[1];
            let left = leftTopBlack[0];
            let right = rightBottomBlack[0];
            // Sanity check!
            if (left >= right || top >= bottom) throw new NotFoundException();
            if (bottom - top !== right - left) {
                // Special case, where bottom-right module wasn't black so we found something else in the last row
                // Assume it's a square, so use height as the width
                right = left + (bottom - top);
                if (right >= image.getWidth()) // Abort if that would not make sense -- off image
                throw new NotFoundException();
            }
            const matrixWidth = Math.round((right - left + 1) / moduleSize);
            const matrixHeight = Math.round((bottom - top + 1) / moduleSize);
            if (matrixWidth <= 0 || matrixHeight <= 0) throw new NotFoundException();
            if (matrixHeight !== matrixWidth) // Only possibly decode square regions
            throw new NotFoundException();
            // Push in the "border" by half the module width so that we start
            // sampling in the middle of the module. Just in case the image is a
            // little off, this will help recover.
            const nudge = /*(int) */ Math.floor(moduleSize / 2.0);
            top += nudge;
            left += nudge;
            // But careful that this does not sample off the edge
            // "right" is the farthest-right valid pixel location -- right+1 is not necessarily
            // This is positive by how much the inner x loop below would be too large
            const nudgedTooFarRight = left + /*(int) */ Math.floor((matrixWidth - 1) * moduleSize) - right;
            if (nudgedTooFarRight > 0) {
                if (nudgedTooFarRight > nudge) // Neither way fits; abort
                throw new NotFoundException();
                left -= nudgedTooFarRight;
            }
            // See logic above
            const nudgedTooFarDown = top + /*(int) */ Math.floor((matrixHeight - 1) * moduleSize) - bottom;
            if (nudgedTooFarDown > 0) {
                if (nudgedTooFarDown > nudge) // Neither way fits; abort
                throw new NotFoundException();
                top -= nudgedTooFarDown;
            }
            // Now just read off the bits
            const bits = new BitMatrix(matrixWidth, matrixHeight);
            for(let y = 0; y < matrixHeight; y++){
                const iOffset = top + /*(int) */ Math.floor(y * moduleSize);
                for(let x = 0; x < matrixWidth; x++)if (image.get(left + /*(int) */ Math.floor(x * moduleSize), iOffset)) bits.set(x, y);
            }
            return bits;
        }
        static moduleSize(leftTopBlack, image) {
            const height = image.getHeight();
            const width = image.getWidth();
            let x = leftTopBlack[0];
            let y = leftTopBlack[1];
            let inBlack = true;
            let transitions = 0;
            while(x < width && y < height){
                if (inBlack !== image.get(x, y)) {
                    if (++transitions === 5) break;
                    inBlack = !inBlack;
                }
                x++;
                y++;
            }
            if (x === width || y === height) throw new NotFoundException();
            return (x - leftTopBlack[0]) / 7.0;
        }
    }
    QRCodeReader.NO_POINTS = new Array();
    /*
    * Copyright 2009 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author Guenther Grau
     */ /*public final*/ class PDF417Common {
        PDF417Common() {}
        /**
         * @param moduleBitCount values to sum
         * @return sum of values
         * @deprecated call {@link MathUtils#sum(int[])}
         */ // @Deprecated
        static getBitCountSum(moduleBitCount) {
            return MathUtils.sum(moduleBitCount);
        }
        static toIntArray(list) {
            if (list == null || !list.length) return PDF417Common.EMPTY_INT_ARRAY;
            const result = new Int32Array(list.length);
            let i = 0;
            for (const integer of list)result[i++] = integer;
            return result;
        }
        /**
         * @param symbol encoded symbol to translate to a codeword
         * @return the codeword corresponding to the symbol.
         */ static getCodeword(symbol /*int*/ ) {
            const i = Arrays.binarySearch(PDF417Common.SYMBOL_TABLE, symbol & 0x3FFFF);
            if (i < 0) return -1;
            return (PDF417Common.CODEWORD_TABLE[i] - 1) % PDF417Common.NUMBER_OF_CODEWORDS;
        }
    }
    PDF417Common.NUMBER_OF_CODEWORDS = 929;
    // Maximum Codewords (Data + Error).
    PDF417Common.MAX_CODEWORDS_IN_BARCODE = PDF417Common.NUMBER_OF_CODEWORDS - 1;
    PDF417Common.MIN_ROWS_IN_BARCODE = 3;
    PDF417Common.MAX_ROWS_IN_BARCODE = 90;
    // One left row indication column + max 30 data columns + one right row indicator column
    // public static /*final*/ MAX_CODEWORDS_IN_ROW: /*int*/ number = 32;
    PDF417Common.MODULES_IN_CODEWORD = 17;
    PDF417Common.MODULES_IN_STOP_PATTERN = 18;
    PDF417Common.BARS_IN_MODULE = 8;
    PDF417Common.EMPTY_INT_ARRAY = new Int32Array([]);
    /**
     * The sorted table of all possible symbols. Extracted from the PDF417
     * specification. The index of a symbol in this table corresponds to the
     * index into the codeword table.
     */ PDF417Common.SYMBOL_TABLE = Int32Array.from([
        0x1025e,
        0x1027a,
        0x1029e,
        0x102bc,
        0x102f2,
        0x102f4,
        0x1032e,
        0x1034e,
        0x1035c,
        0x10396,
        0x103a6,
        0x103ac,
        0x10422,
        0x10428,
        0x10436,
        0x10442,
        0x10444,
        0x10448,
        0x10450,
        0x1045e,
        0x10466,
        0x1046c,
        0x1047a,
        0x10482,
        0x1049e,
        0x104a0,
        0x104bc,
        0x104c6,
        0x104d8,
        0x104ee,
        0x104f2,
        0x104f4,
        0x10504,
        0x10508,
        0x10510,
        0x1051e,
        0x10520,
        0x1053c,
        0x10540,
        0x10578,
        0x10586,
        0x1058c,
        0x10598,
        0x105b0,
        0x105be,
        0x105ce,
        0x105dc,
        0x105e2,
        0x105e4,
        0x105e8,
        0x105f6,
        0x1062e,
        0x1064e,
        0x1065c,
        0x1068e,
        0x1069c,
        0x106b8,
        0x106de,
        0x106fa,
        0x10716,
        0x10726,
        0x1072c,
        0x10746,
        0x1074c,
        0x10758,
        0x1076e,
        0x10792,
        0x10794,
        0x107a2,
        0x107a4,
        0x107a8,
        0x107b6,
        0x10822,
        0x10828,
        0x10842,
        0x10848,
        0x10850,
        0x1085e,
        0x10866,
        0x1086c,
        0x1087a,
        0x10882,
        0x10884,
        0x10890,
        0x1089e,
        0x108a0,
        0x108bc,
        0x108c6,
        0x108cc,
        0x108d8,
        0x108ee,
        0x108f2,
        0x108f4,
        0x10902,
        0x10908,
        0x1091e,
        0x10920,
        0x1093c,
        0x10940,
        0x10978,
        0x10986,
        0x10998,
        0x109b0,
        0x109be,
        0x109ce,
        0x109dc,
        0x109e2,
        0x109e4,
        0x109e8,
        0x109f6,
        0x10a08,
        0x10a10,
        0x10a1e,
        0x10a20,
        0x10a3c,
        0x10a40,
        0x10a78,
        0x10af0,
        0x10b06,
        0x10b0c,
        0x10b18,
        0x10b30,
        0x10b3e,
        0x10b60,
        0x10b7c,
        0x10b8e,
        0x10b9c,
        0x10bb8,
        0x10bc2,
        0x10bc4,
        0x10bc8,
        0x10bd0,
        0x10bde,
        0x10be6,
        0x10bec,
        0x10c2e,
        0x10c4e,
        0x10c5c,
        0x10c62,
        0x10c64,
        0x10c68,
        0x10c76,
        0x10c8e,
        0x10c9c,
        0x10cb8,
        0x10cc2,
        0x10cc4,
        0x10cc8,
        0x10cd0,
        0x10cde,
        0x10ce6,
        0x10cec,
        0x10cfa,
        0x10d0e,
        0x10d1c,
        0x10d38,
        0x10d70,
        0x10d7e,
        0x10d82,
        0x10d84,
        0x10d88,
        0x10d90,
        0x10d9e,
        0x10da0,
        0x10dbc,
        0x10dc6,
        0x10dcc,
        0x10dd8,
        0x10dee,
        0x10df2,
        0x10df4,
        0x10e16,
        0x10e26,
        0x10e2c,
        0x10e46,
        0x10e58,
        0x10e6e,
        0x10e86,
        0x10e8c,
        0x10e98,
        0x10eb0,
        0x10ebe,
        0x10ece,
        0x10edc,
        0x10f0a,
        0x10f12,
        0x10f14,
        0x10f22,
        0x10f28,
        0x10f36,
        0x10f42,
        0x10f44,
        0x10f48,
        0x10f50,
        0x10f5e,
        0x10f66,
        0x10f6c,
        0x10fb2,
        0x10fb4,
        0x11022,
        0x11028,
        0x11042,
        0x11048,
        0x11050,
        0x1105e,
        0x1107a,
        0x11082,
        0x11084,
        0x11090,
        0x1109e,
        0x110a0,
        0x110bc,
        0x110c6,
        0x110cc,
        0x110d8,
        0x110ee,
        0x110f2,
        0x110f4,
        0x11102,
        0x1111e,
        0x11120,
        0x1113c,
        0x11140,
        0x11178,
        0x11186,
        0x11198,
        0x111b0,
        0x111be,
        0x111ce,
        0x111dc,
        0x111e2,
        0x111e4,
        0x111e8,
        0x111f6,
        0x11208,
        0x1121e,
        0x11220,
        0x11278,
        0x112f0,
        0x1130c,
        0x11330,
        0x1133e,
        0x11360,
        0x1137c,
        0x1138e,
        0x1139c,
        0x113b8,
        0x113c2,
        0x113c8,
        0x113d0,
        0x113de,
        0x113e6,
        0x113ec,
        0x11408,
        0x11410,
        0x1141e,
        0x11420,
        0x1143c,
        0x11440,
        0x11478,
        0x114f0,
        0x115e0,
        0x1160c,
        0x11618,
        0x11630,
        0x1163e,
        0x11660,
        0x1167c,
        0x116c0,
        0x116f8,
        0x1171c,
        0x11738,
        0x11770,
        0x1177e,
        0x11782,
        0x11784,
        0x11788,
        0x11790,
        0x1179e,
        0x117a0,
        0x117bc,
        0x117c6,
        0x117cc,
        0x117d8,
        0x117ee,
        0x1182e,
        0x11834,
        0x1184e,
        0x1185c,
        0x11862,
        0x11864,
        0x11868,
        0x11876,
        0x1188e,
        0x1189c,
        0x118b8,
        0x118c2,
        0x118c8,
        0x118d0,
        0x118de,
        0x118e6,
        0x118ec,
        0x118fa,
        0x1190e,
        0x1191c,
        0x11938,
        0x11970,
        0x1197e,
        0x11982,
        0x11984,
        0x11990,
        0x1199e,
        0x119a0,
        0x119bc,
        0x119c6,
        0x119cc,
        0x119d8,
        0x119ee,
        0x119f2,
        0x119f4,
        0x11a0e,
        0x11a1c,
        0x11a38,
        0x11a70,
        0x11a7e,
        0x11ae0,
        0x11afc,
        0x11b08,
        0x11b10,
        0x11b1e,
        0x11b20,
        0x11b3c,
        0x11b40,
        0x11b78,
        0x11b8c,
        0x11b98,
        0x11bb0,
        0x11bbe,
        0x11bce,
        0x11bdc,
        0x11be2,
        0x11be4,
        0x11be8,
        0x11bf6,
        0x11c16,
        0x11c26,
        0x11c2c,
        0x11c46,
        0x11c4c,
        0x11c58,
        0x11c6e,
        0x11c86,
        0x11c98,
        0x11cb0,
        0x11cbe,
        0x11cce,
        0x11cdc,
        0x11ce2,
        0x11ce4,
        0x11ce8,
        0x11cf6,
        0x11d06,
        0x11d0c,
        0x11d18,
        0x11d30,
        0x11d3e,
        0x11d60,
        0x11d7c,
        0x11d8e,
        0x11d9c,
        0x11db8,
        0x11dc4,
        0x11dc8,
        0x11dd0,
        0x11dde,
        0x11de6,
        0x11dec,
        0x11dfa,
        0x11e0a,
        0x11e12,
        0x11e14,
        0x11e22,
        0x11e24,
        0x11e28,
        0x11e36,
        0x11e42,
        0x11e44,
        0x11e50,
        0x11e5e,
        0x11e66,
        0x11e6c,
        0x11e82,
        0x11e84,
        0x11e88,
        0x11e90,
        0x11e9e,
        0x11ea0,
        0x11ebc,
        0x11ec6,
        0x11ecc,
        0x11ed8,
        0x11eee,
        0x11f1a,
        0x11f2e,
        0x11f32,
        0x11f34,
        0x11f4e,
        0x11f5c,
        0x11f62,
        0x11f64,
        0x11f68,
        0x11f76,
        0x12048,
        0x1205e,
        0x12082,
        0x12084,
        0x12090,
        0x1209e,
        0x120a0,
        0x120bc,
        0x120d8,
        0x120f2,
        0x120f4,
        0x12108,
        0x1211e,
        0x12120,
        0x1213c,
        0x12140,
        0x12178,
        0x12186,
        0x12198,
        0x121b0,
        0x121be,
        0x121e2,
        0x121e4,
        0x121e8,
        0x121f6,
        0x12204,
        0x12210,
        0x1221e,
        0x12220,
        0x12278,
        0x122f0,
        0x12306,
        0x1230c,
        0x12330,
        0x1233e,
        0x12360,
        0x1237c,
        0x1238e,
        0x1239c,
        0x123b8,
        0x123c2,
        0x123c8,
        0x123d0,
        0x123e6,
        0x123ec,
        0x1241e,
        0x12420,
        0x1243c,
        0x124f0,
        0x125e0,
        0x12618,
        0x1263e,
        0x12660,
        0x1267c,
        0x126c0,
        0x126f8,
        0x12738,
        0x12770,
        0x1277e,
        0x12782,
        0x12784,
        0x12790,
        0x1279e,
        0x127a0,
        0x127bc,
        0x127c6,
        0x127cc,
        0x127d8,
        0x127ee,
        0x12820,
        0x1283c,
        0x12840,
        0x12878,
        0x128f0,
        0x129e0,
        0x12bc0,
        0x12c18,
        0x12c30,
        0x12c3e,
        0x12c60,
        0x12c7c,
        0x12cc0,
        0x12cf8,
        0x12df0,
        0x12e1c,
        0x12e38,
        0x12e70,
        0x12e7e,
        0x12ee0,
        0x12efc,
        0x12f04,
        0x12f08,
        0x12f10,
        0x12f20,
        0x12f3c,
        0x12f40,
        0x12f78,
        0x12f86,
        0x12f8c,
        0x12f98,
        0x12fb0,
        0x12fbe,
        0x12fce,
        0x12fdc,
        0x1302e,
        0x1304e,
        0x1305c,
        0x13062,
        0x13068,
        0x1308e,
        0x1309c,
        0x130b8,
        0x130c2,
        0x130c8,
        0x130d0,
        0x130de,
        0x130ec,
        0x130fa,
        0x1310e,
        0x13138,
        0x13170,
        0x1317e,
        0x13182,
        0x13184,
        0x13190,
        0x1319e,
        0x131a0,
        0x131bc,
        0x131c6,
        0x131cc,
        0x131d8,
        0x131f2,
        0x131f4,
        0x1320e,
        0x1321c,
        0x13270,
        0x1327e,
        0x132e0,
        0x132fc,
        0x13308,
        0x1331e,
        0x13320,
        0x1333c,
        0x13340,
        0x13378,
        0x13386,
        0x13398,
        0x133b0,
        0x133be,
        0x133ce,
        0x133dc,
        0x133e2,
        0x133e4,
        0x133e8,
        0x133f6,
        0x1340e,
        0x1341c,
        0x13438,
        0x13470,
        0x1347e,
        0x134e0,
        0x134fc,
        0x135c0,
        0x135f8,
        0x13608,
        0x13610,
        0x1361e,
        0x13620,
        0x1363c,
        0x13640,
        0x13678,
        0x136f0,
        0x1370c,
        0x13718,
        0x13730,
        0x1373e,
        0x13760,
        0x1377c,
        0x1379c,
        0x137b8,
        0x137c2,
        0x137c4,
        0x137c8,
        0x137d0,
        0x137de,
        0x137e6,
        0x137ec,
        0x13816,
        0x13826,
        0x1382c,
        0x13846,
        0x1384c,
        0x13858,
        0x1386e,
        0x13874,
        0x13886,
        0x13898,
        0x138b0,
        0x138be,
        0x138ce,
        0x138dc,
        0x138e2,
        0x138e4,
        0x138e8,
        0x13906,
        0x1390c,
        0x13930,
        0x1393e,
        0x13960,
        0x1397c,
        0x1398e,
        0x1399c,
        0x139b8,
        0x139c8,
        0x139d0,
        0x139de,
        0x139e6,
        0x139ec,
        0x139fa,
        0x13a06,
        0x13a0c,
        0x13a18,
        0x13a30,
        0x13a3e,
        0x13a60,
        0x13a7c,
        0x13ac0,
        0x13af8,
        0x13b0e,
        0x13b1c,
        0x13b38,
        0x13b70,
        0x13b7e,
        0x13b88,
        0x13b90,
        0x13b9e,
        0x13ba0,
        0x13bbc,
        0x13bcc,
        0x13bd8,
        0x13bee,
        0x13bf2,
        0x13bf4,
        0x13c12,
        0x13c14,
        0x13c22,
        0x13c24,
        0x13c28,
        0x13c36,
        0x13c42,
        0x13c48,
        0x13c50,
        0x13c5e,
        0x13c66,
        0x13c6c,
        0x13c82,
        0x13c84,
        0x13c90,
        0x13c9e,
        0x13ca0,
        0x13cbc,
        0x13cc6,
        0x13ccc,
        0x13cd8,
        0x13cee,
        0x13d02,
        0x13d04,
        0x13d08,
        0x13d10,
        0x13d1e,
        0x13d20,
        0x13d3c,
        0x13d40,
        0x13d78,
        0x13d86,
        0x13d8c,
        0x13d98,
        0x13db0,
        0x13dbe,
        0x13dce,
        0x13ddc,
        0x13de4,
        0x13de8,
        0x13df6,
        0x13e1a,
        0x13e2e,
        0x13e32,
        0x13e34,
        0x13e4e,
        0x13e5c,
        0x13e62,
        0x13e64,
        0x13e68,
        0x13e76,
        0x13e8e,
        0x13e9c,
        0x13eb8,
        0x13ec2,
        0x13ec4,
        0x13ec8,
        0x13ed0,
        0x13ede,
        0x13ee6,
        0x13eec,
        0x13f26,
        0x13f2c,
        0x13f3a,
        0x13f46,
        0x13f4c,
        0x13f58,
        0x13f6e,
        0x13f72,
        0x13f74,
        0x14082,
        0x1409e,
        0x140a0,
        0x140bc,
        0x14104,
        0x14108,
        0x14110,
        0x1411e,
        0x14120,
        0x1413c,
        0x14140,
        0x14178,
        0x1418c,
        0x14198,
        0x141b0,
        0x141be,
        0x141e2,
        0x141e4,
        0x141e8,
        0x14208,
        0x14210,
        0x1421e,
        0x14220,
        0x1423c,
        0x14240,
        0x14278,
        0x142f0,
        0x14306,
        0x1430c,
        0x14318,
        0x14330,
        0x1433e,
        0x14360,
        0x1437c,
        0x1438e,
        0x143c2,
        0x143c4,
        0x143c8,
        0x143d0,
        0x143e6,
        0x143ec,
        0x14408,
        0x14410,
        0x1441e,
        0x14420,
        0x1443c,
        0x14440,
        0x14478,
        0x144f0,
        0x145e0,
        0x1460c,
        0x14618,
        0x14630,
        0x1463e,
        0x14660,
        0x1467c,
        0x146c0,
        0x146f8,
        0x1471c,
        0x14738,
        0x14770,
        0x1477e,
        0x14782,
        0x14784,
        0x14788,
        0x14790,
        0x147a0,
        0x147bc,
        0x147c6,
        0x147cc,
        0x147d8,
        0x147ee,
        0x14810,
        0x14820,
        0x1483c,
        0x14840,
        0x14878,
        0x148f0,
        0x149e0,
        0x14bc0,
        0x14c30,
        0x14c3e,
        0x14c60,
        0x14c7c,
        0x14cc0,
        0x14cf8,
        0x14df0,
        0x14e38,
        0x14e70,
        0x14e7e,
        0x14ee0,
        0x14efc,
        0x14f04,
        0x14f08,
        0x14f10,
        0x14f1e,
        0x14f20,
        0x14f3c,
        0x14f40,
        0x14f78,
        0x14f86,
        0x14f8c,
        0x14f98,
        0x14fb0,
        0x14fce,
        0x14fdc,
        0x15020,
        0x15040,
        0x15078,
        0x150f0,
        0x151e0,
        0x153c0,
        0x15860,
        0x1587c,
        0x158c0,
        0x158f8,
        0x159f0,
        0x15be0,
        0x15c70,
        0x15c7e,
        0x15ce0,
        0x15cfc,
        0x15dc0,
        0x15df8,
        0x15e08,
        0x15e10,
        0x15e20,
        0x15e40,
        0x15e78,
        0x15ef0,
        0x15f0c,
        0x15f18,
        0x15f30,
        0x15f60,
        0x15f7c,
        0x15f8e,
        0x15f9c,
        0x15fb8,
        0x1604e,
        0x1605c,
        0x1608e,
        0x1609c,
        0x160b8,
        0x160c2,
        0x160c4,
        0x160c8,
        0x160de,
        0x1610e,
        0x1611c,
        0x16138,
        0x16170,
        0x1617e,
        0x16184,
        0x16188,
        0x16190,
        0x1619e,
        0x161a0,
        0x161bc,
        0x161c6,
        0x161cc,
        0x161d8,
        0x161f2,
        0x161f4,
        0x1620e,
        0x1621c,
        0x16238,
        0x16270,
        0x1627e,
        0x162e0,
        0x162fc,
        0x16304,
        0x16308,
        0x16310,
        0x1631e,
        0x16320,
        0x1633c,
        0x16340,
        0x16378,
        0x16386,
        0x1638c,
        0x16398,
        0x163b0,
        0x163be,
        0x163ce,
        0x163dc,
        0x163e2,
        0x163e4,
        0x163e8,
        0x163f6,
        0x1640e,
        0x1641c,
        0x16438,
        0x16470,
        0x1647e,
        0x164e0,
        0x164fc,
        0x165c0,
        0x165f8,
        0x16610,
        0x1661e,
        0x16620,
        0x1663c,
        0x16640,
        0x16678,
        0x166f0,
        0x16718,
        0x16730,
        0x1673e,
        0x16760,
        0x1677c,
        0x1678e,
        0x1679c,
        0x167b8,
        0x167c2,
        0x167c4,
        0x167c8,
        0x167d0,
        0x167de,
        0x167e6,
        0x167ec,
        0x1681c,
        0x16838,
        0x16870,
        0x168e0,
        0x168fc,
        0x169c0,
        0x169f8,
        0x16bf0,
        0x16c10,
        0x16c1e,
        0x16c20,
        0x16c3c,
        0x16c40,
        0x16c78,
        0x16cf0,
        0x16de0,
        0x16e18,
        0x16e30,
        0x16e3e,
        0x16e60,
        0x16e7c,
        0x16ec0,
        0x16ef8,
        0x16f1c,
        0x16f38,
        0x16f70,
        0x16f7e,
        0x16f84,
        0x16f88,
        0x16f90,
        0x16f9e,
        0x16fa0,
        0x16fbc,
        0x16fc6,
        0x16fcc,
        0x16fd8,
        0x17026,
        0x1702c,
        0x17046,
        0x1704c,
        0x17058,
        0x1706e,
        0x17086,
        0x1708c,
        0x17098,
        0x170b0,
        0x170be,
        0x170ce,
        0x170dc,
        0x170e8,
        0x17106,
        0x1710c,
        0x17118,
        0x17130,
        0x1713e,
        0x17160,
        0x1717c,
        0x1718e,
        0x1719c,
        0x171b8,
        0x171c2,
        0x171c4,
        0x171c8,
        0x171d0,
        0x171de,
        0x171e6,
        0x171ec,
        0x171fa,
        0x17206,
        0x1720c,
        0x17218,
        0x17230,
        0x1723e,
        0x17260,
        0x1727c,
        0x172c0,
        0x172f8,
        0x1730e,
        0x1731c,
        0x17338,
        0x17370,
        0x1737e,
        0x17388,
        0x17390,
        0x1739e,
        0x173a0,
        0x173bc,
        0x173cc,
        0x173d8,
        0x173ee,
        0x173f2,
        0x173f4,
        0x1740c,
        0x17418,
        0x17430,
        0x1743e,
        0x17460,
        0x1747c,
        0x174c0,
        0x174f8,
        0x175f0,
        0x1760e,
        0x1761c,
        0x17638,
        0x17670,
        0x1767e,
        0x176e0,
        0x176fc,
        0x17708,
        0x17710,
        0x1771e,
        0x17720,
        0x1773c,
        0x17740,
        0x17778,
        0x17798,
        0x177b0,
        0x177be,
        0x177dc,
        0x177e2,
        0x177e4,
        0x177e8,
        0x17822,
        0x17824,
        0x17828,
        0x17836,
        0x17842,
        0x17844,
        0x17848,
        0x17850,
        0x1785e,
        0x17866,
        0x1786c,
        0x17882,
        0x17884,
        0x17888,
        0x17890,
        0x1789e,
        0x178a0,
        0x178bc,
        0x178c6,
        0x178cc,
        0x178d8,
        0x178ee,
        0x178f2,
        0x178f4,
        0x17902,
        0x17904,
        0x17908,
        0x17910,
        0x1791e,
        0x17920,
        0x1793c,
        0x17940,
        0x17978,
        0x17986,
        0x1798c,
        0x17998,
        0x179b0,
        0x179be,
        0x179ce,
        0x179dc,
        0x179e2,
        0x179e4,
        0x179e8,
        0x179f6,
        0x17a04,
        0x17a08,
        0x17a10,
        0x17a1e,
        0x17a20,
        0x17a3c,
        0x17a40,
        0x17a78,
        0x17af0,
        0x17b06,
        0x17b0c,
        0x17b18,
        0x17b30,
        0x17b3e,
        0x17b60,
        0x17b7c,
        0x17b8e,
        0x17b9c,
        0x17bb8,
        0x17bc4,
        0x17bc8,
        0x17bd0,
        0x17bde,
        0x17be6,
        0x17bec,
        0x17c2e,
        0x17c32,
        0x17c34,
        0x17c4e,
        0x17c5c,
        0x17c62,
        0x17c64,
        0x17c68,
        0x17c76,
        0x17c8e,
        0x17c9c,
        0x17cb8,
        0x17cc2,
        0x17cc4,
        0x17cc8,
        0x17cd0,
        0x17cde,
        0x17ce6,
        0x17cec,
        0x17d0e,
        0x17d1c,
        0x17d38,
        0x17d70,
        0x17d82,
        0x17d84,
        0x17d88,
        0x17d90,
        0x17d9e,
        0x17da0,
        0x17dbc,
        0x17dc6,
        0x17dcc,
        0x17dd8,
        0x17dee,
        0x17e26,
        0x17e2c,
        0x17e3a,
        0x17e46,
        0x17e4c,
        0x17e58,
        0x17e6e,
        0x17e72,
        0x17e74,
        0x17e86,
        0x17e8c,
        0x17e98,
        0x17eb0,
        0x17ece,
        0x17edc,
        0x17ee2,
        0x17ee4,
        0x17ee8,
        0x17ef6,
        0x1813a,
        0x18172,
        0x18174,
        0x18216,
        0x18226,
        0x1823a,
        0x1824c,
        0x18258,
        0x1826e,
        0x18272,
        0x18274,
        0x18298,
        0x182be,
        0x182e2,
        0x182e4,
        0x182e8,
        0x182f6,
        0x1835e,
        0x1837a,
        0x183ae,
        0x183d6,
        0x18416,
        0x18426,
        0x1842c,
        0x1843a,
        0x18446,
        0x18458,
        0x1846e,
        0x18472,
        0x18474,
        0x18486,
        0x184b0,
        0x184be,
        0x184ce,
        0x184dc,
        0x184e2,
        0x184e4,
        0x184e8,
        0x184f6,
        0x18506,
        0x1850c,
        0x18518,
        0x18530,
        0x1853e,
        0x18560,
        0x1857c,
        0x1858e,
        0x1859c,
        0x185b8,
        0x185c2,
        0x185c4,
        0x185c8,
        0x185d0,
        0x185de,
        0x185e6,
        0x185ec,
        0x185fa,
        0x18612,
        0x18614,
        0x18622,
        0x18628,
        0x18636,
        0x18642,
        0x18650,
        0x1865e,
        0x1867a,
        0x18682,
        0x18684,
        0x18688,
        0x18690,
        0x1869e,
        0x186a0,
        0x186bc,
        0x186c6,
        0x186cc,
        0x186d8,
        0x186ee,
        0x186f2,
        0x186f4,
        0x1872e,
        0x1874e,
        0x1875c,
        0x18796,
        0x187a6,
        0x187ac,
        0x187d2,
        0x187d4,
        0x18826,
        0x1882c,
        0x1883a,
        0x18846,
        0x1884c,
        0x18858,
        0x1886e,
        0x18872,
        0x18874,
        0x18886,
        0x18898,
        0x188b0,
        0x188be,
        0x188ce,
        0x188dc,
        0x188e2,
        0x188e4,
        0x188e8,
        0x188f6,
        0x1890c,
        0x18930,
        0x1893e,
        0x18960,
        0x1897c,
        0x1898e,
        0x189b8,
        0x189c2,
        0x189c8,
        0x189d0,
        0x189de,
        0x189e6,
        0x189ec,
        0x189fa,
        0x18a18,
        0x18a30,
        0x18a3e,
        0x18a60,
        0x18a7c,
        0x18ac0,
        0x18af8,
        0x18b1c,
        0x18b38,
        0x18b70,
        0x18b7e,
        0x18b82,
        0x18b84,
        0x18b88,
        0x18b90,
        0x18b9e,
        0x18ba0,
        0x18bbc,
        0x18bc6,
        0x18bcc,
        0x18bd8,
        0x18bee,
        0x18bf2,
        0x18bf4,
        0x18c22,
        0x18c24,
        0x18c28,
        0x18c36,
        0x18c42,
        0x18c48,
        0x18c50,
        0x18c5e,
        0x18c66,
        0x18c7a,
        0x18c82,
        0x18c84,
        0x18c90,
        0x18c9e,
        0x18ca0,
        0x18cbc,
        0x18ccc,
        0x18cf2,
        0x18cf4,
        0x18d04,
        0x18d08,
        0x18d10,
        0x18d1e,
        0x18d20,
        0x18d3c,
        0x18d40,
        0x18d78,
        0x18d86,
        0x18d98,
        0x18dce,
        0x18de2,
        0x18de4,
        0x18de8,
        0x18e2e,
        0x18e32,
        0x18e34,
        0x18e4e,
        0x18e5c,
        0x18e62,
        0x18e64,
        0x18e68,
        0x18e8e,
        0x18e9c,
        0x18eb8,
        0x18ec2,
        0x18ec4,
        0x18ec8,
        0x18ed0,
        0x18efa,
        0x18f16,
        0x18f26,
        0x18f2c,
        0x18f46,
        0x18f4c,
        0x18f58,
        0x18f6e,
        0x18f8a,
        0x18f92,
        0x18f94,
        0x18fa2,
        0x18fa4,
        0x18fa8,
        0x18fb6,
        0x1902c,
        0x1903a,
        0x19046,
        0x1904c,
        0x19058,
        0x19072,
        0x19074,
        0x19086,
        0x19098,
        0x190b0,
        0x190be,
        0x190ce,
        0x190dc,
        0x190e2,
        0x190e8,
        0x190f6,
        0x19106,
        0x1910c,
        0x19130,
        0x1913e,
        0x19160,
        0x1917c,
        0x1918e,
        0x1919c,
        0x191b8,
        0x191c2,
        0x191c8,
        0x191d0,
        0x191de,
        0x191e6,
        0x191ec,
        0x191fa,
        0x19218,
        0x1923e,
        0x19260,
        0x1927c,
        0x192c0,
        0x192f8,
        0x19338,
        0x19370,
        0x1937e,
        0x19382,
        0x19384,
        0x19390,
        0x1939e,
        0x193a0,
        0x193bc,
        0x193c6,
        0x193cc,
        0x193d8,
        0x193ee,
        0x193f2,
        0x193f4,
        0x19430,
        0x1943e,
        0x19460,
        0x1947c,
        0x194c0,
        0x194f8,
        0x195f0,
        0x19638,
        0x19670,
        0x1967e,
        0x196e0,
        0x196fc,
        0x19702,
        0x19704,
        0x19708,
        0x19710,
        0x19720,
        0x1973c,
        0x19740,
        0x19778,
        0x19786,
        0x1978c,
        0x19798,
        0x197b0,
        0x197be,
        0x197ce,
        0x197dc,
        0x197e2,
        0x197e4,
        0x197e8,
        0x19822,
        0x19824,
        0x19842,
        0x19848,
        0x19850,
        0x1985e,
        0x19866,
        0x1987a,
        0x19882,
        0x19884,
        0x19890,
        0x1989e,
        0x198a0,
        0x198bc,
        0x198cc,
        0x198f2,
        0x198f4,
        0x19902,
        0x19908,
        0x1991e,
        0x19920,
        0x1993c,
        0x19940,
        0x19978,
        0x19986,
        0x19998,
        0x199ce,
        0x199e2,
        0x199e4,
        0x199e8,
        0x19a08,
        0x19a10,
        0x19a1e,
        0x19a20,
        0x19a3c,
        0x19a40,
        0x19a78,
        0x19af0,
        0x19b18,
        0x19b3e,
        0x19b60,
        0x19b9c,
        0x19bc2,
        0x19bc4,
        0x19bc8,
        0x19bd0,
        0x19be6,
        0x19c2e,
        0x19c34,
        0x19c4e,
        0x19c5c,
        0x19c62,
        0x19c64,
        0x19c68,
        0x19c8e,
        0x19c9c,
        0x19cb8,
        0x19cc2,
        0x19cc8,
        0x19cd0,
        0x19ce6,
        0x19cfa,
        0x19d0e,
        0x19d1c,
        0x19d38,
        0x19d70,
        0x19d7e,
        0x19d82,
        0x19d84,
        0x19d88,
        0x19d90,
        0x19da0,
        0x19dcc,
        0x19df2,
        0x19df4,
        0x19e16,
        0x19e26,
        0x19e2c,
        0x19e46,
        0x19e4c,
        0x19e58,
        0x19e74,
        0x19e86,
        0x19e8c,
        0x19e98,
        0x19eb0,
        0x19ebe,
        0x19ece,
        0x19ee2,
        0x19ee4,
        0x19ee8,
        0x19f0a,
        0x19f12,
        0x19f14,
        0x19f22,
        0x19f24,
        0x19f28,
        0x19f42,
        0x19f44,
        0x19f48,
        0x19f50,
        0x19f5e,
        0x19f6c,
        0x19f9a,
        0x19fae,
        0x19fb2,
        0x19fb4,
        0x1a046,
        0x1a04c,
        0x1a072,
        0x1a074,
        0x1a086,
        0x1a08c,
        0x1a098,
        0x1a0b0,
        0x1a0be,
        0x1a0e2,
        0x1a0e4,
        0x1a0e8,
        0x1a0f6,
        0x1a106,
        0x1a10c,
        0x1a118,
        0x1a130,
        0x1a13e,
        0x1a160,
        0x1a17c,
        0x1a18e,
        0x1a19c,
        0x1a1b8,
        0x1a1c2,
        0x1a1c4,
        0x1a1c8,
        0x1a1d0,
        0x1a1de,
        0x1a1e6,
        0x1a1ec,
        0x1a218,
        0x1a230,
        0x1a23e,
        0x1a260,
        0x1a27c,
        0x1a2c0,
        0x1a2f8,
        0x1a31c,
        0x1a338,
        0x1a370,
        0x1a37e,
        0x1a382,
        0x1a384,
        0x1a388,
        0x1a390,
        0x1a39e,
        0x1a3a0,
        0x1a3bc,
        0x1a3c6,
        0x1a3cc,
        0x1a3d8,
        0x1a3ee,
        0x1a3f2,
        0x1a3f4,
        0x1a418,
        0x1a430,
        0x1a43e,
        0x1a460,
        0x1a47c,
        0x1a4c0,
        0x1a4f8,
        0x1a5f0,
        0x1a61c,
        0x1a638,
        0x1a670,
        0x1a67e,
        0x1a6e0,
        0x1a6fc,
        0x1a702,
        0x1a704,
        0x1a708,
        0x1a710,
        0x1a71e,
        0x1a720,
        0x1a73c,
        0x1a740,
        0x1a778,
        0x1a786,
        0x1a78c,
        0x1a798,
        0x1a7b0,
        0x1a7be,
        0x1a7ce,
        0x1a7dc,
        0x1a7e2,
        0x1a7e4,
        0x1a7e8,
        0x1a830,
        0x1a860,
        0x1a87c,
        0x1a8c0,
        0x1a8f8,
        0x1a9f0,
        0x1abe0,
        0x1ac70,
        0x1ac7e,
        0x1ace0,
        0x1acfc,
        0x1adc0,
        0x1adf8,
        0x1ae04,
        0x1ae08,
        0x1ae10,
        0x1ae20,
        0x1ae3c,
        0x1ae40,
        0x1ae78,
        0x1aef0,
        0x1af06,
        0x1af0c,
        0x1af18,
        0x1af30,
        0x1af3e,
        0x1af60,
        0x1af7c,
        0x1af8e,
        0x1af9c,
        0x1afb8,
        0x1afc4,
        0x1afc8,
        0x1afd0,
        0x1afde,
        0x1b042,
        0x1b05e,
        0x1b07a,
        0x1b082,
        0x1b084,
        0x1b088,
        0x1b090,
        0x1b09e,
        0x1b0a0,
        0x1b0bc,
        0x1b0cc,
        0x1b0f2,
        0x1b0f4,
        0x1b102,
        0x1b104,
        0x1b108,
        0x1b110,
        0x1b11e,
        0x1b120,
        0x1b13c,
        0x1b140,
        0x1b178,
        0x1b186,
        0x1b198,
        0x1b1ce,
        0x1b1e2,
        0x1b1e4,
        0x1b1e8,
        0x1b204,
        0x1b208,
        0x1b210,
        0x1b21e,
        0x1b220,
        0x1b23c,
        0x1b240,
        0x1b278,
        0x1b2f0,
        0x1b30c,
        0x1b33e,
        0x1b360,
        0x1b39c,
        0x1b3c2,
        0x1b3c4,
        0x1b3c8,
        0x1b3d0,
        0x1b3e6,
        0x1b410,
        0x1b41e,
        0x1b420,
        0x1b43c,
        0x1b440,
        0x1b478,
        0x1b4f0,
        0x1b5e0,
        0x1b618,
        0x1b660,
        0x1b67c,
        0x1b6c0,
        0x1b738,
        0x1b782,
        0x1b784,
        0x1b788,
        0x1b790,
        0x1b79e,
        0x1b7a0,
        0x1b7cc,
        0x1b82e,
        0x1b84e,
        0x1b85c,
        0x1b88e,
        0x1b89c,
        0x1b8b8,
        0x1b8c2,
        0x1b8c4,
        0x1b8c8,
        0x1b8d0,
        0x1b8e6,
        0x1b8fa,
        0x1b90e,
        0x1b91c,
        0x1b938,
        0x1b970,
        0x1b97e,
        0x1b982,
        0x1b984,
        0x1b988,
        0x1b990,
        0x1b99e,
        0x1b9a0,
        0x1b9cc,
        0x1b9f2,
        0x1b9f4,
        0x1ba0e,
        0x1ba1c,
        0x1ba38,
        0x1ba70,
        0x1ba7e,
        0x1bae0,
        0x1bafc,
        0x1bb08,
        0x1bb10,
        0x1bb20,
        0x1bb3c,
        0x1bb40,
        0x1bb98,
        0x1bbce,
        0x1bbe2,
        0x1bbe4,
        0x1bbe8,
        0x1bc16,
        0x1bc26,
        0x1bc2c,
        0x1bc46,
        0x1bc4c,
        0x1bc58,
        0x1bc72,
        0x1bc74,
        0x1bc86,
        0x1bc8c,
        0x1bc98,
        0x1bcb0,
        0x1bcbe,
        0x1bcce,
        0x1bce2,
        0x1bce4,
        0x1bce8,
        0x1bd06,
        0x1bd0c,
        0x1bd18,
        0x1bd30,
        0x1bd3e,
        0x1bd60,
        0x1bd7c,
        0x1bd9c,
        0x1bdc2,
        0x1bdc4,
        0x1bdc8,
        0x1bdd0,
        0x1bde6,
        0x1bdfa,
        0x1be12,
        0x1be14,
        0x1be22,
        0x1be24,
        0x1be28,
        0x1be42,
        0x1be44,
        0x1be48,
        0x1be50,
        0x1be5e,
        0x1be66,
        0x1be82,
        0x1be84,
        0x1be88,
        0x1be90,
        0x1be9e,
        0x1bea0,
        0x1bebc,
        0x1becc,
        0x1bef4,
        0x1bf1a,
        0x1bf2e,
        0x1bf32,
        0x1bf34,
        0x1bf4e,
        0x1bf5c,
        0x1bf62,
        0x1bf64,
        0x1bf68,
        0x1c09a,
        0x1c0b2,
        0x1c0b4,
        0x1c11a,
        0x1c132,
        0x1c134,
        0x1c162,
        0x1c164,
        0x1c168,
        0x1c176,
        0x1c1ba,
        0x1c21a,
        0x1c232,
        0x1c234,
        0x1c24e,
        0x1c25c,
        0x1c262,
        0x1c264,
        0x1c268,
        0x1c276,
        0x1c28e,
        0x1c2c2,
        0x1c2c4,
        0x1c2c8,
        0x1c2d0,
        0x1c2de,
        0x1c2e6,
        0x1c2ec,
        0x1c2fa,
        0x1c316,
        0x1c326,
        0x1c33a,
        0x1c346,
        0x1c34c,
        0x1c372,
        0x1c374,
        0x1c41a,
        0x1c42e,
        0x1c432,
        0x1c434,
        0x1c44e,
        0x1c45c,
        0x1c462,
        0x1c464,
        0x1c468,
        0x1c476,
        0x1c48e,
        0x1c49c,
        0x1c4b8,
        0x1c4c2,
        0x1c4c8,
        0x1c4d0,
        0x1c4de,
        0x1c4e6,
        0x1c4ec,
        0x1c4fa,
        0x1c51c,
        0x1c538,
        0x1c570,
        0x1c57e,
        0x1c582,
        0x1c584,
        0x1c588,
        0x1c590,
        0x1c59e,
        0x1c5a0,
        0x1c5bc,
        0x1c5c6,
        0x1c5cc,
        0x1c5d8,
        0x1c5ee,
        0x1c5f2,
        0x1c5f4,
        0x1c616,
        0x1c626,
        0x1c62c,
        0x1c63a,
        0x1c646,
        0x1c64c,
        0x1c658,
        0x1c66e,
        0x1c672,
        0x1c674,
        0x1c686,
        0x1c68c,
        0x1c698,
        0x1c6b0,
        0x1c6be,
        0x1c6ce,
        0x1c6dc,
        0x1c6e2,
        0x1c6e4,
        0x1c6e8,
        0x1c712,
        0x1c714,
        0x1c722,
        0x1c728,
        0x1c736,
        0x1c742,
        0x1c744,
        0x1c748,
        0x1c750,
        0x1c75e,
        0x1c766,
        0x1c76c,
        0x1c77a,
        0x1c7ae,
        0x1c7d6,
        0x1c7ea,
        0x1c81a,
        0x1c82e,
        0x1c832,
        0x1c834,
        0x1c84e,
        0x1c85c,
        0x1c862,
        0x1c864,
        0x1c868,
        0x1c876,
        0x1c88e,
        0x1c89c,
        0x1c8b8,
        0x1c8c2,
        0x1c8c8,
        0x1c8d0,
        0x1c8de,
        0x1c8e6,
        0x1c8ec,
        0x1c8fa,
        0x1c90e,
        0x1c938,
        0x1c970,
        0x1c97e,
        0x1c982,
        0x1c984,
        0x1c990,
        0x1c99e,
        0x1c9a0,
        0x1c9bc,
        0x1c9c6,
        0x1c9cc,
        0x1c9d8,
        0x1c9ee,
        0x1c9f2,
        0x1c9f4,
        0x1ca38,
        0x1ca70,
        0x1ca7e,
        0x1cae0,
        0x1cafc,
        0x1cb02,
        0x1cb04,
        0x1cb08,
        0x1cb10,
        0x1cb20,
        0x1cb3c,
        0x1cb40,
        0x1cb78,
        0x1cb86,
        0x1cb8c,
        0x1cb98,
        0x1cbb0,
        0x1cbbe,
        0x1cbce,
        0x1cbdc,
        0x1cbe2,
        0x1cbe4,
        0x1cbe8,
        0x1cbf6,
        0x1cc16,
        0x1cc26,
        0x1cc2c,
        0x1cc3a,
        0x1cc46,
        0x1cc58,
        0x1cc72,
        0x1cc74,
        0x1cc86,
        0x1ccb0,
        0x1ccbe,
        0x1ccce,
        0x1cce2,
        0x1cce4,
        0x1cce8,
        0x1cd06,
        0x1cd0c,
        0x1cd18,
        0x1cd30,
        0x1cd3e,
        0x1cd60,
        0x1cd7c,
        0x1cd9c,
        0x1cdc2,
        0x1cdc4,
        0x1cdc8,
        0x1cdd0,
        0x1cdde,
        0x1cde6,
        0x1cdfa,
        0x1ce22,
        0x1ce28,
        0x1ce42,
        0x1ce50,
        0x1ce5e,
        0x1ce66,
        0x1ce7a,
        0x1ce82,
        0x1ce84,
        0x1ce88,
        0x1ce90,
        0x1ce9e,
        0x1cea0,
        0x1cebc,
        0x1cecc,
        0x1cef2,
        0x1cef4,
        0x1cf2e,
        0x1cf32,
        0x1cf34,
        0x1cf4e,
        0x1cf5c,
        0x1cf62,
        0x1cf64,
        0x1cf68,
        0x1cf96,
        0x1cfa6,
        0x1cfac,
        0x1cfca,
        0x1cfd2,
        0x1cfd4,
        0x1d02e,
        0x1d032,
        0x1d034,
        0x1d04e,
        0x1d05c,
        0x1d062,
        0x1d064,
        0x1d068,
        0x1d076,
        0x1d08e,
        0x1d09c,
        0x1d0b8,
        0x1d0c2,
        0x1d0c4,
        0x1d0c8,
        0x1d0d0,
        0x1d0de,
        0x1d0e6,
        0x1d0ec,
        0x1d0fa,
        0x1d11c,
        0x1d138,
        0x1d170,
        0x1d17e,
        0x1d182,
        0x1d184,
        0x1d188,
        0x1d190,
        0x1d19e,
        0x1d1a0,
        0x1d1bc,
        0x1d1c6,
        0x1d1cc,
        0x1d1d8,
        0x1d1ee,
        0x1d1f2,
        0x1d1f4,
        0x1d21c,
        0x1d238,
        0x1d270,
        0x1d27e,
        0x1d2e0,
        0x1d2fc,
        0x1d302,
        0x1d304,
        0x1d308,
        0x1d310,
        0x1d31e,
        0x1d320,
        0x1d33c,
        0x1d340,
        0x1d378,
        0x1d386,
        0x1d38c,
        0x1d398,
        0x1d3b0,
        0x1d3be,
        0x1d3ce,
        0x1d3dc,
        0x1d3e2,
        0x1d3e4,
        0x1d3e8,
        0x1d3f6,
        0x1d470,
        0x1d47e,
        0x1d4e0,
        0x1d4fc,
        0x1d5c0,
        0x1d5f8,
        0x1d604,
        0x1d608,
        0x1d610,
        0x1d620,
        0x1d640,
        0x1d678,
        0x1d6f0,
        0x1d706,
        0x1d70c,
        0x1d718,
        0x1d730,
        0x1d73e,
        0x1d760,
        0x1d77c,
        0x1d78e,
        0x1d79c,
        0x1d7b8,
        0x1d7c2,
        0x1d7c4,
        0x1d7c8,
        0x1d7d0,
        0x1d7de,
        0x1d7e6,
        0x1d7ec,
        0x1d826,
        0x1d82c,
        0x1d83a,
        0x1d846,
        0x1d84c,
        0x1d858,
        0x1d872,
        0x1d874,
        0x1d886,
        0x1d88c,
        0x1d898,
        0x1d8b0,
        0x1d8be,
        0x1d8ce,
        0x1d8e2,
        0x1d8e4,
        0x1d8e8,
        0x1d8f6,
        0x1d90c,
        0x1d918,
        0x1d930,
        0x1d93e,
        0x1d960,
        0x1d97c,
        0x1d99c,
        0x1d9c2,
        0x1d9c4,
        0x1d9c8,
        0x1d9d0,
        0x1d9e6,
        0x1d9fa,
        0x1da0c,
        0x1da18,
        0x1da30,
        0x1da3e,
        0x1da60,
        0x1da7c,
        0x1dac0,
        0x1daf8,
        0x1db38,
        0x1db82,
        0x1db84,
        0x1db88,
        0x1db90,
        0x1db9e,
        0x1dba0,
        0x1dbcc,
        0x1dbf2,
        0x1dbf4,
        0x1dc22,
        0x1dc42,
        0x1dc44,
        0x1dc48,
        0x1dc50,
        0x1dc5e,
        0x1dc66,
        0x1dc7a,
        0x1dc82,
        0x1dc84,
        0x1dc88,
        0x1dc90,
        0x1dc9e,
        0x1dca0,
        0x1dcbc,
        0x1dccc,
        0x1dcf2,
        0x1dcf4,
        0x1dd04,
        0x1dd08,
        0x1dd10,
        0x1dd1e,
        0x1dd20,
        0x1dd3c,
        0x1dd40,
        0x1dd78,
        0x1dd86,
        0x1dd98,
        0x1ddce,
        0x1dde2,
        0x1dde4,
        0x1dde8,
        0x1de2e,
        0x1de32,
        0x1de34,
        0x1de4e,
        0x1de5c,
        0x1de62,
        0x1de64,
        0x1de68,
        0x1de8e,
        0x1de9c,
        0x1deb8,
        0x1dec2,
        0x1dec4,
        0x1dec8,
        0x1ded0,
        0x1dee6,
        0x1defa,
        0x1df16,
        0x1df26,
        0x1df2c,
        0x1df46,
        0x1df4c,
        0x1df58,
        0x1df72,
        0x1df74,
        0x1df8a,
        0x1df92,
        0x1df94,
        0x1dfa2,
        0x1dfa4,
        0x1dfa8,
        0x1e08a,
        0x1e092,
        0x1e094,
        0x1e0a2,
        0x1e0a4,
        0x1e0a8,
        0x1e0b6,
        0x1e0da,
        0x1e10a,
        0x1e112,
        0x1e114,
        0x1e122,
        0x1e124,
        0x1e128,
        0x1e136,
        0x1e142,
        0x1e144,
        0x1e148,
        0x1e150,
        0x1e166,
        0x1e16c,
        0x1e17a,
        0x1e19a,
        0x1e1b2,
        0x1e1b4,
        0x1e20a,
        0x1e212,
        0x1e214,
        0x1e222,
        0x1e224,
        0x1e228,
        0x1e236,
        0x1e242,
        0x1e248,
        0x1e250,
        0x1e25e,
        0x1e266,
        0x1e26c,
        0x1e27a,
        0x1e282,
        0x1e284,
        0x1e288,
        0x1e290,
        0x1e2a0,
        0x1e2bc,
        0x1e2c6,
        0x1e2cc,
        0x1e2d8,
        0x1e2ee,
        0x1e2f2,
        0x1e2f4,
        0x1e31a,
        0x1e332,
        0x1e334,
        0x1e35c,
        0x1e362,
        0x1e364,
        0x1e368,
        0x1e3ba,
        0x1e40a,
        0x1e412,
        0x1e414,
        0x1e422,
        0x1e428,
        0x1e436,
        0x1e442,
        0x1e448,
        0x1e450,
        0x1e45e,
        0x1e466,
        0x1e46c,
        0x1e47a,
        0x1e482,
        0x1e484,
        0x1e490,
        0x1e49e,
        0x1e4a0,
        0x1e4bc,
        0x1e4c6,
        0x1e4cc,
        0x1e4d8,
        0x1e4ee,
        0x1e4f2,
        0x1e4f4,
        0x1e502,
        0x1e504,
        0x1e508,
        0x1e510,
        0x1e51e,
        0x1e520,
        0x1e53c,
        0x1e540,
        0x1e578,
        0x1e586,
        0x1e58c,
        0x1e598,
        0x1e5b0,
        0x1e5be,
        0x1e5ce,
        0x1e5dc,
        0x1e5e2,
        0x1e5e4,
        0x1e5e8,
        0x1e5f6,
        0x1e61a,
        0x1e62e,
        0x1e632,
        0x1e634,
        0x1e64e,
        0x1e65c,
        0x1e662,
        0x1e668,
        0x1e68e,
        0x1e69c,
        0x1e6b8,
        0x1e6c2,
        0x1e6c4,
        0x1e6c8,
        0x1e6d0,
        0x1e6e6,
        0x1e6fa,
        0x1e716,
        0x1e726,
        0x1e72c,
        0x1e73a,
        0x1e746,
        0x1e74c,
        0x1e758,
        0x1e772,
        0x1e774,
        0x1e792,
        0x1e794,
        0x1e7a2,
        0x1e7a4,
        0x1e7a8,
        0x1e7b6,
        0x1e812,
        0x1e814,
        0x1e822,
        0x1e824,
        0x1e828,
        0x1e836,
        0x1e842,
        0x1e844,
        0x1e848,
        0x1e850,
        0x1e85e,
        0x1e866,
        0x1e86c,
        0x1e87a,
        0x1e882,
        0x1e884,
        0x1e888,
        0x1e890,
        0x1e89e,
        0x1e8a0,
        0x1e8bc,
        0x1e8c6,
        0x1e8cc,
        0x1e8d8,
        0x1e8ee,
        0x1e8f2,
        0x1e8f4,
        0x1e902,
        0x1e904,
        0x1e908,
        0x1e910,
        0x1e920,
        0x1e93c,
        0x1e940,
        0x1e978,
        0x1e986,
        0x1e98c,
        0x1e998,
        0x1e9b0,
        0x1e9be,
        0x1e9ce,
        0x1e9dc,
        0x1e9e2,
        0x1e9e4,
        0x1e9e8,
        0x1e9f6,
        0x1ea04,
        0x1ea08,
        0x1ea10,
        0x1ea20,
        0x1ea40,
        0x1ea78,
        0x1eaf0,
        0x1eb06,
        0x1eb0c,
        0x1eb18,
        0x1eb30,
        0x1eb3e,
        0x1eb60,
        0x1eb7c,
        0x1eb8e,
        0x1eb9c,
        0x1ebb8,
        0x1ebc2,
        0x1ebc4,
        0x1ebc8,
        0x1ebd0,
        0x1ebde,
        0x1ebe6,
        0x1ebec,
        0x1ec1a,
        0x1ec2e,
        0x1ec32,
        0x1ec34,
        0x1ec4e,
        0x1ec5c,
        0x1ec62,
        0x1ec64,
        0x1ec68,
        0x1ec8e,
        0x1ec9c,
        0x1ecb8,
        0x1ecc2,
        0x1ecc4,
        0x1ecc8,
        0x1ecd0,
        0x1ece6,
        0x1ecfa,
        0x1ed0e,
        0x1ed1c,
        0x1ed38,
        0x1ed70,
        0x1ed7e,
        0x1ed82,
        0x1ed84,
        0x1ed88,
        0x1ed90,
        0x1ed9e,
        0x1eda0,
        0x1edcc,
        0x1edf2,
        0x1edf4,
        0x1ee16,
        0x1ee26,
        0x1ee2c,
        0x1ee3a,
        0x1ee46,
        0x1ee4c,
        0x1ee58,
        0x1ee6e,
        0x1ee72,
        0x1ee74,
        0x1ee86,
        0x1ee8c,
        0x1ee98,
        0x1eeb0,
        0x1eebe,
        0x1eece,
        0x1eedc,
        0x1eee2,
        0x1eee4,
        0x1eee8,
        0x1ef12,
        0x1ef22,
        0x1ef24,
        0x1ef28,
        0x1ef36,
        0x1ef42,
        0x1ef44,
        0x1ef48,
        0x1ef50,
        0x1ef5e,
        0x1ef66,
        0x1ef6c,
        0x1ef7a,
        0x1efae,
        0x1efb2,
        0x1efb4,
        0x1efd6,
        0x1f096,
        0x1f0a6,
        0x1f0ac,
        0x1f0ba,
        0x1f0ca,
        0x1f0d2,
        0x1f0d4,
        0x1f116,
        0x1f126,
        0x1f12c,
        0x1f13a,
        0x1f146,
        0x1f14c,
        0x1f158,
        0x1f16e,
        0x1f172,
        0x1f174,
        0x1f18a,
        0x1f192,
        0x1f194,
        0x1f1a2,
        0x1f1a4,
        0x1f1a8,
        0x1f1da,
        0x1f216,
        0x1f226,
        0x1f22c,
        0x1f23a,
        0x1f246,
        0x1f258,
        0x1f26e,
        0x1f272,
        0x1f274,
        0x1f286,
        0x1f28c,
        0x1f298,
        0x1f2b0,
        0x1f2be,
        0x1f2ce,
        0x1f2dc,
        0x1f2e2,
        0x1f2e4,
        0x1f2e8,
        0x1f2f6,
        0x1f30a,
        0x1f312,
        0x1f314,
        0x1f322,
        0x1f328,
        0x1f342,
        0x1f344,
        0x1f348,
        0x1f350,
        0x1f35e,
        0x1f366,
        0x1f37a,
        0x1f39a,
        0x1f3ae,
        0x1f3b2,
        0x1f3b4,
        0x1f416,
        0x1f426,
        0x1f42c,
        0x1f43a,
        0x1f446,
        0x1f44c,
        0x1f458,
        0x1f46e,
        0x1f472,
        0x1f474,
        0x1f486,
        0x1f48c,
        0x1f498,
        0x1f4b0,
        0x1f4be,
        0x1f4ce,
        0x1f4dc,
        0x1f4e2,
        0x1f4e4,
        0x1f4e8,
        0x1f4f6,
        0x1f506,
        0x1f50c,
        0x1f518,
        0x1f530,
        0x1f53e,
        0x1f560,
        0x1f57c,
        0x1f58e,
        0x1f59c,
        0x1f5b8,
        0x1f5c2,
        0x1f5c4,
        0x1f5c8,
        0x1f5d0,
        0x1f5de,
        0x1f5e6,
        0x1f5ec,
        0x1f5fa,
        0x1f60a,
        0x1f612,
        0x1f614,
        0x1f622,
        0x1f624,
        0x1f628,
        0x1f636,
        0x1f642,
        0x1f644,
        0x1f648,
        0x1f650,
        0x1f65e,
        0x1f666,
        0x1f67a,
        0x1f682,
        0x1f684,
        0x1f688,
        0x1f690,
        0x1f69e,
        0x1f6a0,
        0x1f6bc,
        0x1f6cc,
        0x1f6f2,
        0x1f6f4,
        0x1f71a,
        0x1f72e,
        0x1f732,
        0x1f734,
        0x1f74e,
        0x1f75c,
        0x1f762,
        0x1f764,
        0x1f768,
        0x1f776,
        0x1f796,
        0x1f7a6,
        0x1f7ac,
        0x1f7ba,
        0x1f7d2,
        0x1f7d4,
        0x1f89a,
        0x1f8ae,
        0x1f8b2,
        0x1f8b4,
        0x1f8d6,
        0x1f8ea,
        0x1f91a,
        0x1f92e,
        0x1f932,
        0x1f934,
        0x1f94e,
        0x1f95c,
        0x1f962,
        0x1f964,
        0x1f968,
        0x1f976,
        0x1f996,
        0x1f9a6,
        0x1f9ac,
        0x1f9ba,
        0x1f9ca,
        0x1f9d2,
        0x1f9d4,
        0x1fa1a,
        0x1fa2e,
        0x1fa32,
        0x1fa34,
        0x1fa4e,
        0x1fa5c,
        0x1fa62,
        0x1fa64,
        0x1fa68,
        0x1fa76,
        0x1fa8e,
        0x1fa9c,
        0x1fab8,
        0x1fac2,
        0x1fac4,
        0x1fac8,
        0x1fad0,
        0x1fade,
        0x1fae6,
        0x1faec,
        0x1fb16,
        0x1fb26,
        0x1fb2c,
        0x1fb3a,
        0x1fb46,
        0x1fb4c,
        0x1fb58,
        0x1fb6e,
        0x1fb72,
        0x1fb74,
        0x1fb8a,
        0x1fb92,
        0x1fb94,
        0x1fba2,
        0x1fba4,
        0x1fba8,
        0x1fbb6,
        0x1fbda
    ]);
    /**
     * This table contains to codewords for all symbols.
     */ PDF417Common.CODEWORD_TABLE = Int32Array.from([
        2627,
        1819,
        2622,
        2621,
        1813,
        1812,
        2729,
        2724,
        2723,
        2779,
        2774,
        2773,
        902,
        896,
        908,
        868,
        865,
        861,
        859,
        2511,
        873,
        871,
        1780,
        835,
        2493,
        825,
        2491,
        842,
        837,
        844,
        1764,
        1762,
        811,
        810,
        809,
        2483,
        807,
        2482,
        806,
        2480,
        815,
        814,
        813,
        812,
        2484,
        817,
        816,
        1745,
        1744,
        1742,
        1746,
        2655,
        2637,
        2635,
        2626,
        2625,
        2623,
        2628,
        1820,
        2752,
        2739,
        2737,
        2728,
        2727,
        2725,
        2730,
        2785,
        2783,
        2778,
        2777,
        2775,
        2780,
        787,
        781,
        747,
        739,
        736,
        2413,
        754,
        752,
        1719,
        692,
        689,
        681,
        2371,
        678,
        2369,
        700,
        697,
        694,
        703,
        1688,
        1686,
        642,
        638,
        2343,
        631,
        2341,
        627,
        2338,
        651,
        646,
        643,
        2345,
        654,
        652,
        1652,
        1650,
        1647,
        1654,
        601,
        599,
        2322,
        596,
        2321,
        594,
        2319,
        2317,
        611,
        610,
        608,
        606,
        2324,
        603,
        2323,
        615,
        614,
        612,
        1617,
        1616,
        1614,
        1612,
        616,
        1619,
        1618,
        2575,
        2538,
        2536,
        905,
        901,
        898,
        909,
        2509,
        2507,
        2504,
        870,
        867,
        864,
        860,
        2512,
        875,
        872,
        1781,
        2490,
        2489,
        2487,
        2485,
        1748,
        836,
        834,
        832,
        830,
        2494,
        827,
        2492,
        843,
        841,
        839,
        845,
        1765,
        1763,
        2701,
        2676,
        2674,
        2653,
        2648,
        2656,
        2634,
        2633,
        2631,
        2629,
        1821,
        2638,
        2636,
        2770,
        2763,
        2761,
        2750,
        2745,
        2753,
        2736,
        2735,
        2733,
        2731,
        1848,
        2740,
        2738,
        2786,
        2784,
        591,
        588,
        576,
        569,
        566,
        2296,
        1590,
        537,
        534,
        526,
        2276,
        522,
        2274,
        545,
        542,
        539,
        548,
        1572,
        1570,
        481,
        2245,
        466,
        2242,
        462,
        2239,
        492,
        485,
        482,
        2249,
        496,
        494,
        1534,
        1531,
        1528,
        1538,
        413,
        2196,
        406,
        2191,
        2188,
        425,
        419,
        2202,
        415,
        2199,
        432,
        430,
        427,
        1472,
        1467,
        1464,
        433,
        1476,
        1474,
        368,
        367,
        2160,
        365,
        2159,
        362,
        2157,
        2155,
        2152,
        378,
        377,
        375,
        2166,
        372,
        2165,
        369,
        2162,
        383,
        381,
        379,
        2168,
        1419,
        1418,
        1416,
        1414,
        385,
        1411,
        384,
        1423,
        1422,
        1420,
        1424,
        2461,
        802,
        2441,
        2439,
        790,
        786,
        783,
        794,
        2409,
        2406,
        2403,
        750,
        742,
        738,
        2414,
        756,
        753,
        1720,
        2367,
        2365,
        2362,
        2359,
        1663,
        693,
        691,
        684,
        2373,
        680,
        2370,
        702,
        699,
        696,
        704,
        1690,
        1687,
        2337,
        2336,
        2334,
        2332,
        1624,
        2329,
        1622,
        640,
        637,
        2344,
        634,
        2342,
        630,
        2340,
        650,
        648,
        645,
        2346,
        655,
        653,
        1653,
        1651,
        1649,
        1655,
        2612,
        2597,
        2595,
        2571,
        2568,
        2565,
        2576,
        2534,
        2529,
        2526,
        1787,
        2540,
        2537,
        907,
        904,
        900,
        910,
        2503,
        2502,
        2500,
        2498,
        1768,
        2495,
        1767,
        2510,
        2508,
        2506,
        869,
        866,
        863,
        2513,
        876,
        874,
        1782,
        2720,
        2713,
        2711,
        2697,
        2694,
        2691,
        2702,
        2672,
        2670,
        2664,
        1828,
        2678,
        2675,
        2647,
        2646,
        2644,
        2642,
        1823,
        2639,
        1822,
        2654,
        2652,
        2650,
        2657,
        2771,
        1855,
        2765,
        2762,
        1850,
        1849,
        2751,
        2749,
        2747,
        2754,
        353,
        2148,
        344,
        342,
        336,
        2142,
        332,
        2140,
        345,
        1375,
        1373,
        306,
        2130,
        299,
        2128,
        295,
        2125,
        319,
        314,
        311,
        2132,
        1354,
        1352,
        1349,
        1356,
        262,
        257,
        2101,
        253,
        2096,
        2093,
        274,
        273,
        267,
        2107,
        263,
        2104,
        280,
        278,
        275,
        1316,
        1311,
        1308,
        1320,
        1318,
        2052,
        202,
        2050,
        2044,
        2040,
        219,
        2063,
        212,
        2060,
        208,
        2055,
        224,
        221,
        2066,
        1260,
        1258,
        1252,
        231,
        1248,
        229,
        1266,
        1264,
        1261,
        1268,
        155,
        1998,
        153,
        1996,
        1994,
        1991,
        1988,
        165,
        164,
        2007,
        162,
        2006,
        159,
        2003,
        2000,
        172,
        171,
        169,
        2012,
        166,
        2010,
        1186,
        1184,
        1182,
        1179,
        175,
        1176,
        173,
        1192,
        1191,
        1189,
        1187,
        176,
        1194,
        1193,
        2313,
        2307,
        2305,
        592,
        589,
        2294,
        2292,
        2289,
        578,
        572,
        568,
        2297,
        580,
        1591,
        2272,
        2267,
        2264,
        1547,
        538,
        536,
        529,
        2278,
        525,
        2275,
        547,
        544,
        541,
        1574,
        1571,
        2237,
        2235,
        2229,
        1493,
        2225,
        1489,
        478,
        2247,
        470,
        2244,
        465,
        2241,
        493,
        488,
        484,
        2250,
        498,
        495,
        1536,
        1533,
        1530,
        1539,
        2187,
        2186,
        2184,
        2182,
        1432,
        2179,
        1430,
        2176,
        1427,
        414,
        412,
        2197,
        409,
        2195,
        405,
        2193,
        2190,
        426,
        424,
        421,
        2203,
        418,
        2201,
        431,
        429,
        1473,
        1471,
        1469,
        1466,
        434,
        1477,
        1475,
        2478,
        2472,
        2470,
        2459,
        2457,
        2454,
        2462,
        803,
        2437,
        2432,
        2429,
        1726,
        2443,
        2440,
        792,
        789,
        785,
        2401,
        2399,
        2393,
        1702,
        2389,
        1699,
        2411,
        2408,
        2405,
        745,
        741,
        2415,
        758,
        755,
        1721,
        2358,
        2357,
        2355,
        2353,
        1661,
        2350,
        1660,
        2347,
        1657,
        2368,
        2366,
        2364,
        2361,
        1666,
        690,
        687,
        2374,
        683,
        2372,
        701,
        698,
        705,
        1691,
        1689,
        2619,
        2617,
        2610,
        2608,
        2605,
        2613,
        2593,
        2588,
        2585,
        1803,
        2599,
        2596,
        2563,
        2561,
        2555,
        1797,
        2551,
        1795,
        2573,
        2570,
        2567,
        2577,
        2525,
        2524,
        2522,
        2520,
        1786,
        2517,
        1785,
        2514,
        1783,
        2535,
        2533,
        2531,
        2528,
        1788,
        2541,
        2539,
        906,
        903,
        911,
        2721,
        1844,
        2715,
        2712,
        1838,
        1836,
        2699,
        2696,
        2693,
        2703,
        1827,
        1826,
        1824,
        2673,
        2671,
        2669,
        2666,
        1829,
        2679,
        2677,
        1858,
        1857,
        2772,
        1854,
        1853,
        1851,
        1856,
        2766,
        2764,
        143,
        1987,
        139,
        1986,
        135,
        133,
        131,
        1984,
        128,
        1983,
        125,
        1981,
        138,
        137,
        136,
        1985,
        1133,
        1132,
        1130,
        112,
        110,
        1974,
        107,
        1973,
        104,
        1971,
        1969,
        122,
        121,
        119,
        117,
        1977,
        114,
        1976,
        124,
        1115,
        1114,
        1112,
        1110,
        1117,
        1116,
        84,
        83,
        1953,
        81,
        1952,
        78,
        1950,
        1948,
        1945,
        94,
        93,
        91,
        1959,
        88,
        1958,
        85,
        1955,
        99,
        97,
        95,
        1961,
        1086,
        1085,
        1083,
        1081,
        1078,
        100,
        1090,
        1089,
        1087,
        1091,
        49,
        47,
        1917,
        44,
        1915,
        1913,
        1910,
        1907,
        59,
        1926,
        56,
        1925,
        53,
        1922,
        1919,
        66,
        64,
        1931,
        61,
        1929,
        1042,
        1040,
        1038,
        71,
        1035,
        70,
        1032,
        68,
        1048,
        1047,
        1045,
        1043,
        1050,
        1049,
        12,
        10,
        1869,
        1867,
        1864,
        1861,
        21,
        1880,
        19,
        1877,
        1874,
        1871,
        28,
        1888,
        25,
        1886,
        22,
        1883,
        982,
        980,
        977,
        974,
        32,
        30,
        991,
        989,
        987,
        984,
        34,
        995,
        994,
        992,
        2151,
        2150,
        2147,
        2146,
        2144,
        356,
        355,
        354,
        2149,
        2139,
        2138,
        2136,
        2134,
        1359,
        343,
        341,
        338,
        2143,
        335,
        2141,
        348,
        347,
        346,
        1376,
        1374,
        2124,
        2123,
        2121,
        2119,
        1326,
        2116,
        1324,
        310,
        308,
        305,
        2131,
        302,
        2129,
        298,
        2127,
        320,
        318,
        316,
        313,
        2133,
        322,
        321,
        1355,
        1353,
        1351,
        1357,
        2092,
        2091,
        2089,
        2087,
        1276,
        2084,
        1274,
        2081,
        1271,
        259,
        2102,
        256,
        2100,
        252,
        2098,
        2095,
        272,
        269,
        2108,
        266,
        2106,
        281,
        279,
        277,
        1317,
        1315,
        1313,
        1310,
        282,
        1321,
        1319,
        2039,
        2037,
        2035,
        2032,
        1203,
        2029,
        1200,
        1197,
        207,
        2053,
        205,
        2051,
        201,
        2049,
        2046,
        2043,
        220,
        218,
        2064,
        215,
        2062,
        211,
        2059,
        228,
        226,
        223,
        2069,
        1259,
        1257,
        1254,
        232,
        1251,
        230,
        1267,
        1265,
        1263,
        2316,
        2315,
        2312,
        2311,
        2309,
        2314,
        2304,
        2303,
        2301,
        2299,
        1593,
        2308,
        2306,
        590,
        2288,
        2287,
        2285,
        2283,
        1578,
        2280,
        1577,
        2295,
        2293,
        2291,
        579,
        577,
        574,
        571,
        2298,
        582,
        581,
        1592,
        2263,
        2262,
        2260,
        2258,
        1545,
        2255,
        1544,
        2252,
        1541,
        2273,
        2271,
        2269,
        2266,
        1550,
        535,
        532,
        2279,
        528,
        2277,
        546,
        543,
        549,
        1575,
        1573,
        2224,
        2222,
        2220,
        1486,
        2217,
        1485,
        2214,
        1482,
        1479,
        2238,
        2236,
        2234,
        2231,
        1496,
        2228,
        1492,
        480,
        477,
        2248,
        473,
        2246,
        469,
        2243,
        490,
        487,
        2251,
        497,
        1537,
        1535,
        1532,
        2477,
        2476,
        2474,
        2479,
        2469,
        2468,
        2466,
        2464,
        1730,
        2473,
        2471,
        2453,
        2452,
        2450,
        2448,
        1729,
        2445,
        1728,
        2460,
        2458,
        2456,
        2463,
        805,
        804,
        2428,
        2427,
        2425,
        2423,
        1725,
        2420,
        1724,
        2417,
        1722,
        2438,
        2436,
        2434,
        2431,
        1727,
        2444,
        2442,
        793,
        791,
        788,
        795,
        2388,
        2386,
        2384,
        1697,
        2381,
        1696,
        2378,
        1694,
        1692,
        2402,
        2400,
        2398,
        2395,
        1703,
        2392,
        1701,
        2412,
        2410,
        2407,
        751,
        748,
        744,
        2416,
        759,
        757,
        1807,
        2620,
        2618,
        1806,
        1805,
        2611,
        2609,
        2607,
        2614,
        1802,
        1801,
        1799,
        2594,
        2592,
        2590,
        2587,
        1804,
        2600,
        2598,
        1794,
        1793,
        1791,
        1789,
        2564,
        2562,
        2560,
        2557,
        1798,
        2554,
        1796,
        2574,
        2572,
        2569,
        2578,
        1847,
        1846,
        2722,
        1843,
        1842,
        1840,
        1845,
        2716,
        2714,
        1835,
        1834,
        1832,
        1830,
        1839,
        1837,
        2700,
        2698,
        2695,
        2704,
        1817,
        1811,
        1810,
        897,
        862,
        1777,
        829,
        826,
        838,
        1760,
        1758,
        808,
        2481,
        1741,
        1740,
        1738,
        1743,
        2624,
        1818,
        2726,
        2776,
        782,
        740,
        737,
        1715,
        686,
        679,
        695,
        1682,
        1680,
        639,
        628,
        2339,
        647,
        644,
        1645,
        1643,
        1640,
        1648,
        602,
        600,
        597,
        595,
        2320,
        593,
        2318,
        609,
        607,
        604,
        1611,
        1610,
        1608,
        1606,
        613,
        1615,
        1613,
        2328,
        926,
        924,
        892,
        886,
        899,
        857,
        850,
        2505,
        1778,
        824,
        823,
        821,
        819,
        2488,
        818,
        2486,
        833,
        831,
        828,
        840,
        1761,
        1759,
        2649,
        2632,
        2630,
        2746,
        2734,
        2732,
        2782,
        2781,
        570,
        567,
        1587,
        531,
        527,
        523,
        540,
        1566,
        1564,
        476,
        467,
        463,
        2240,
        486,
        483,
        1524,
        1521,
        1518,
        1529,
        411,
        403,
        2192,
        399,
        2189,
        423,
        416,
        1462,
        1457,
        1454,
        428,
        1468,
        1465,
        2210,
        366,
        363,
        2158,
        360,
        2156,
        357,
        2153,
        376,
        373,
        370,
        2163,
        1410,
        1409,
        1407,
        1405,
        382,
        1402,
        380,
        1417,
        1415,
        1412,
        1421,
        2175,
        2174,
        777,
        774,
        771,
        784,
        732,
        725,
        722,
        2404,
        743,
        1716,
        676,
        674,
        668,
        2363,
        665,
        2360,
        685,
        1684,
        1681,
        626,
        624,
        622,
        2335,
        620,
        2333,
        617,
        2330,
        641,
        635,
        649,
        1646,
        1644,
        1642,
        2566,
        928,
        925,
        2530,
        2527,
        894,
        891,
        888,
        2501,
        2499,
        2496,
        858,
        856,
        854,
        851,
        1779,
        2692,
        2668,
        2665,
        2645,
        2643,
        2640,
        2651,
        2768,
        2759,
        2757,
        2744,
        2743,
        2741,
        2748,
        352,
        1382,
        340,
        337,
        333,
        1371,
        1369,
        307,
        300,
        296,
        2126,
        315,
        312,
        1347,
        1342,
        1350,
        261,
        258,
        250,
        2097,
        246,
        2094,
        271,
        268,
        264,
        1306,
        1301,
        1298,
        276,
        1312,
        1309,
        2115,
        203,
        2048,
        195,
        2045,
        191,
        2041,
        213,
        209,
        2056,
        1246,
        1244,
        1238,
        225,
        1234,
        222,
        1256,
        1253,
        1249,
        1262,
        2080,
        2079,
        154,
        1997,
        150,
        1995,
        147,
        1992,
        1989,
        163,
        160,
        2004,
        156,
        2001,
        1175,
        1174,
        1172,
        1170,
        1167,
        170,
        1164,
        167,
        1185,
        1183,
        1180,
        1177,
        174,
        1190,
        1188,
        2025,
        2024,
        2022,
        587,
        586,
        564,
        559,
        556,
        2290,
        573,
        1588,
        520,
        518,
        512,
        2268,
        508,
        2265,
        530,
        1568,
        1565,
        461,
        457,
        2233,
        450,
        2230,
        446,
        2226,
        479,
        471,
        489,
        1526,
        1523,
        1520,
        397,
        395,
        2185,
        392,
        2183,
        389,
        2180,
        2177,
        410,
        2194,
        402,
        422,
        1463,
        1461,
        1459,
        1456,
        1470,
        2455,
        799,
        2433,
        2430,
        779,
        776,
        773,
        2397,
        2394,
        2390,
        734,
        728,
        724,
        746,
        1717,
        2356,
        2354,
        2351,
        2348,
        1658,
        677,
        675,
        673,
        670,
        667,
        688,
        1685,
        1683,
        2606,
        2589,
        2586,
        2559,
        2556,
        2552,
        927,
        2523,
        2521,
        2518,
        2515,
        1784,
        2532,
        895,
        893,
        890,
        2718,
        2709,
        2707,
        2689,
        2687,
        2684,
        2663,
        2662,
        2660,
        2658,
        1825,
        2667,
        2769,
        1852,
        2760,
        2758,
        142,
        141,
        1139,
        1138,
        134,
        132,
        129,
        126,
        1982,
        1129,
        1128,
        1126,
        1131,
        113,
        111,
        108,
        105,
        1972,
        101,
        1970,
        120,
        118,
        115,
        1109,
        1108,
        1106,
        1104,
        123,
        1113,
        1111,
        82,
        79,
        1951,
        75,
        1949,
        72,
        1946,
        92,
        89,
        86,
        1956,
        1077,
        1076,
        1074,
        1072,
        98,
        1069,
        96,
        1084,
        1082,
        1079,
        1088,
        1968,
        1967,
        48,
        45,
        1916,
        42,
        1914,
        39,
        1911,
        1908,
        60,
        57,
        54,
        1923,
        50,
        1920,
        1031,
        1030,
        1028,
        1026,
        67,
        1023,
        65,
        1020,
        62,
        1041,
        1039,
        1036,
        1033,
        69,
        1046,
        1044,
        1944,
        1943,
        1941,
        11,
        9,
        1868,
        7,
        1865,
        1862,
        1859,
        20,
        1878,
        16,
        1875,
        13,
        1872,
        970,
        968,
        966,
        963,
        29,
        960,
        26,
        23,
        983,
        981,
        978,
        975,
        33,
        971,
        31,
        990,
        988,
        985,
        1906,
        1904,
        1902,
        993,
        351,
        2145,
        1383,
        331,
        330,
        328,
        326,
        2137,
        323,
        2135,
        339,
        1372,
        1370,
        294,
        293,
        291,
        289,
        2122,
        286,
        2120,
        283,
        2117,
        309,
        303,
        317,
        1348,
        1346,
        1344,
        245,
        244,
        242,
        2090,
        239,
        2088,
        236,
        2085,
        2082,
        260,
        2099,
        249,
        270,
        1307,
        1305,
        1303,
        1300,
        1314,
        189,
        2038,
        186,
        2036,
        183,
        2033,
        2030,
        2026,
        206,
        198,
        2047,
        194,
        216,
        1247,
        1245,
        1243,
        1240,
        227,
        1237,
        1255,
        2310,
        2302,
        2300,
        2286,
        2284,
        2281,
        565,
        563,
        561,
        558,
        575,
        1589,
        2261,
        2259,
        2256,
        2253,
        1542,
        521,
        519,
        517,
        514,
        2270,
        511,
        533,
        1569,
        1567,
        2223,
        2221,
        2218,
        2215,
        1483,
        2211,
        1480,
        459,
        456,
        453,
        2232,
        449,
        474,
        491,
        1527,
        1525,
        1522,
        2475,
        2467,
        2465,
        2451,
        2449,
        2446,
        801,
        800,
        2426,
        2424,
        2421,
        2418,
        1723,
        2435,
        780,
        778,
        775,
        2387,
        2385,
        2382,
        2379,
        1695,
        2375,
        1693,
        2396,
        735,
        733,
        730,
        727,
        749,
        1718,
        2616,
        2615,
        2604,
        2603,
        2601,
        2584,
        2583,
        2581,
        2579,
        1800,
        2591,
        2550,
        2549,
        2547,
        2545,
        1792,
        2542,
        1790,
        2558,
        929,
        2719,
        1841,
        2710,
        2708,
        1833,
        1831,
        2690,
        2688,
        2686,
        1815,
        1809,
        1808,
        1774,
        1756,
        1754,
        1737,
        1736,
        1734,
        1739,
        1816,
        1711,
        1676,
        1674,
        633,
        629,
        1638,
        1636,
        1633,
        1641,
        598,
        1605,
        1604,
        1602,
        1600,
        605,
        1609,
        1607,
        2327,
        887,
        853,
        1775,
        822,
        820,
        1757,
        1755,
        1584,
        524,
        1560,
        1558,
        468,
        464,
        1514,
        1511,
        1508,
        1519,
        408,
        404,
        400,
        1452,
        1447,
        1444,
        417,
        1458,
        1455,
        2208,
        364,
        361,
        358,
        2154,
        1401,
        1400,
        1398,
        1396,
        374,
        1393,
        371,
        1408,
        1406,
        1403,
        1413,
        2173,
        2172,
        772,
        726,
        723,
        1712,
        672,
        669,
        666,
        682,
        1678,
        1675,
        625,
        623,
        621,
        618,
        2331,
        636,
        632,
        1639,
        1637,
        1635,
        920,
        918,
        884,
        880,
        889,
        849,
        848,
        847,
        846,
        2497,
        855,
        852,
        1776,
        2641,
        2742,
        2787,
        1380,
        334,
        1367,
        1365,
        301,
        297,
        1340,
        1338,
        1335,
        1343,
        255,
        251,
        247,
        1296,
        1291,
        1288,
        265,
        1302,
        1299,
        2113,
        204,
        196,
        192,
        2042,
        1232,
        1230,
        1224,
        214,
        1220,
        210,
        1242,
        1239,
        1235,
        1250,
        2077,
        2075,
        151,
        148,
        1993,
        144,
        1990,
        1163,
        1162,
        1160,
        1158,
        1155,
        161,
        1152,
        157,
        1173,
        1171,
        1168,
        1165,
        168,
        1181,
        1178,
        2021,
        2020,
        2018,
        2023,
        585,
        560,
        557,
        1585,
        516,
        509,
        1562,
        1559,
        458,
        447,
        2227,
        472,
        1516,
        1513,
        1510,
        398,
        396,
        393,
        390,
        2181,
        386,
        2178,
        407,
        1453,
        1451,
        1449,
        1446,
        420,
        1460,
        2209,
        769,
        764,
        720,
        712,
        2391,
        729,
        1713,
        664,
        663,
        661,
        659,
        2352,
        656,
        2349,
        671,
        1679,
        1677,
        2553,
        922,
        919,
        2519,
        2516,
        885,
        883,
        881,
        2685,
        2661,
        2659,
        2767,
        2756,
        2755,
        140,
        1137,
        1136,
        130,
        127,
        1125,
        1124,
        1122,
        1127,
        109,
        106,
        102,
        1103,
        1102,
        1100,
        1098,
        116,
        1107,
        1105,
        1980,
        80,
        76,
        73,
        1947,
        1068,
        1067,
        1065,
        1063,
        90,
        1060,
        87,
        1075,
        1073,
        1070,
        1080,
        1966,
        1965,
        46,
        43,
        40,
        1912,
        36,
        1909,
        1019,
        1018,
        1016,
        1014,
        58,
        1011,
        55,
        1008,
        51,
        1029,
        1027,
        1024,
        1021,
        63,
        1037,
        1034,
        1940,
        1939,
        1937,
        1942,
        8,
        1866,
        4,
        1863,
        1,
        1860,
        956,
        954,
        952,
        949,
        946,
        17,
        14,
        969,
        967,
        964,
        961,
        27,
        957,
        24,
        979,
        976,
        972,
        1901,
        1900,
        1898,
        1896,
        986,
        1905,
        1903,
        350,
        349,
        1381,
        329,
        327,
        324,
        1368,
        1366,
        292,
        290,
        287,
        284,
        2118,
        304,
        1341,
        1339,
        1337,
        1345,
        243,
        240,
        237,
        2086,
        233,
        2083,
        254,
        1297,
        1295,
        1293,
        1290,
        1304,
        2114,
        190,
        187,
        184,
        2034,
        180,
        2031,
        177,
        2027,
        199,
        1233,
        1231,
        1229,
        1226,
        217,
        1223,
        1241,
        2078,
        2076,
        584,
        555,
        554,
        552,
        550,
        2282,
        562,
        1586,
        507,
        506,
        504,
        502,
        2257,
        499,
        2254,
        515,
        1563,
        1561,
        445,
        443,
        441,
        2219,
        438,
        2216,
        435,
        2212,
        460,
        454,
        475,
        1517,
        1515,
        1512,
        2447,
        798,
        797,
        2422,
        2419,
        770,
        768,
        766,
        2383,
        2380,
        2376,
        721,
        719,
        717,
        714,
        731,
        1714,
        2602,
        2582,
        2580,
        2548,
        2546,
        2543,
        923,
        921,
        2717,
        2706,
        2705,
        2683,
        2682,
        2680,
        1771,
        1752,
        1750,
        1733,
        1732,
        1731,
        1735,
        1814,
        1707,
        1670,
        1668,
        1631,
        1629,
        1626,
        1634,
        1599,
        1598,
        1596,
        1594,
        1603,
        1601,
        2326,
        1772,
        1753,
        1751,
        1581,
        1554,
        1552,
        1504,
        1501,
        1498,
        1509,
        1442,
        1437,
        1434,
        401,
        1448,
        1445,
        2206,
        1392,
        1391,
        1389,
        1387,
        1384,
        359,
        1399,
        1397,
        1394,
        1404,
        2171,
        2170,
        1708,
        1672,
        1669,
        619,
        1632,
        1630,
        1628,
        1773,
        1378,
        1363,
        1361,
        1333,
        1328,
        1336,
        1286,
        1281,
        1278,
        248,
        1292,
        1289,
        2111,
        1218,
        1216,
        1210,
        197,
        1206,
        193,
        1228,
        1225,
        1221,
        1236,
        2073,
        2071,
        1151,
        1150,
        1148,
        1146,
        152,
        1143,
        149,
        1140,
        145,
        1161,
        1159,
        1156,
        1153,
        158,
        1169,
        1166,
        2017,
        2016,
        2014,
        2019,
        1582,
        510,
        1556,
        1553,
        452,
        448,
        1506,
        1500,
        394,
        391,
        387,
        1443,
        1441,
        1439,
        1436,
        1450,
        2207,
        765,
        716,
        713,
        1709,
        662,
        660,
        657,
        1673,
        1671,
        916,
        914,
        879,
        878,
        877,
        882,
        1135,
        1134,
        1121,
        1120,
        1118,
        1123,
        1097,
        1096,
        1094,
        1092,
        103,
        1101,
        1099,
        1979,
        1059,
        1058,
        1056,
        1054,
        77,
        1051,
        74,
        1066,
        1064,
        1061,
        1071,
        1964,
        1963,
        1007,
        1006,
        1004,
        1002,
        999,
        41,
        996,
        37,
        1017,
        1015,
        1012,
        1009,
        52,
        1025,
        1022,
        1936,
        1935,
        1933,
        1938,
        942,
        940,
        938,
        935,
        932,
        5,
        2,
        955,
        953,
        950,
        947,
        18,
        943,
        15,
        965,
        962,
        958,
        1895,
        1894,
        1892,
        1890,
        973,
        1899,
        1897,
        1379,
        325,
        1364,
        1362,
        288,
        285,
        1334,
        1332,
        1330,
        241,
        238,
        234,
        1287,
        1285,
        1283,
        1280,
        1294,
        2112,
        188,
        185,
        181,
        178,
        2028,
        1219,
        1217,
        1215,
        1212,
        200,
        1209,
        1227,
        2074,
        2072,
        583,
        553,
        551,
        1583,
        505,
        503,
        500,
        513,
        1557,
        1555,
        444,
        442,
        439,
        436,
        2213,
        455,
        451,
        1507,
        1505,
        1502,
        796,
        763,
        762,
        760,
        767,
        711,
        710,
        708,
        706,
        2377,
        718,
        715,
        1710,
        2544,
        917,
        915,
        2681,
        1627,
        1597,
        1595,
        2325,
        1769,
        1749,
        1747,
        1499,
        1438,
        1435,
        2204,
        1390,
        1388,
        1385,
        1395,
        2169,
        2167,
        1704,
        1665,
        1662,
        1625,
        1623,
        1620,
        1770,
        1329,
        1282,
        1279,
        2109,
        1214,
        1207,
        1222,
        2068,
        2065,
        1149,
        1147,
        1144,
        1141,
        146,
        1157,
        1154,
        2013,
        2011,
        2008,
        2015,
        1579,
        1549,
        1546,
        1495,
        1487,
        1433,
        1431,
        1428,
        1425,
        388,
        1440,
        2205,
        1705,
        658,
        1667,
        1664,
        1119,
        1095,
        1093,
        1978,
        1057,
        1055,
        1052,
        1062,
        1962,
        1960,
        1005,
        1003,
        1000,
        997,
        38,
        1013,
        1010,
        1932,
        1930,
        1927,
        1934,
        941,
        939,
        936,
        933,
        6,
        930,
        3,
        951,
        948,
        944,
        1889,
        1887,
        1884,
        1881,
        959,
        1893,
        1891,
        35,
        1377,
        1360,
        1358,
        1327,
        1325,
        1322,
        1331,
        1277,
        1275,
        1272,
        1269,
        235,
        1284,
        2110,
        1205,
        1204,
        1201,
        1198,
        182,
        1195,
        179,
        1213,
        2070,
        2067,
        1580,
        501,
        1551,
        1548,
        440,
        437,
        1497,
        1494,
        1490,
        1503,
        761,
        709,
        707,
        1706,
        913,
        912,
        2198,
        1386,
        2164,
        2161,
        1621,
        1766,
        2103,
        1208,
        2058,
        2054,
        1145,
        1142,
        2005,
        2002,
        1999,
        2009,
        1488,
        1429,
        1426,
        2200,
        1698,
        1659,
        1656,
        1975,
        1053,
        1957,
        1954,
        1001,
        998,
        1924,
        1921,
        1918,
        1928,
        937,
        934,
        931,
        1879,
        1876,
        1873,
        1870,
        945,
        1885,
        1882,
        1323,
        1273,
        1270,
        2105,
        1202,
        1199,
        1196,
        1211,
        2061,
        2057,
        1576,
        1543,
        1540,
        1484,
        1481,
        1478,
        1491,
        1700
    ]);
    /*
    * Copyright 2007 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ // import java.util.List;
    /**
     * @author Guenther Grau
     */ /*public final*/ class PDF417DetectorResult {
        constructor(bits, points){
            this.bits = bits;
            this.points = points;
        }
        getBits() {
            return this.bits;
        }
        getPoints() {
            return this.points;
        }
    }
    /*
    * Copyright 2009 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ // import java.util.ArrayList;
    // import java.util.Arrays;
    // import java.util.List;
    // import java.util.Map;
    /**
     * <p>Encapsulates logic that can detect a PDF417 Code in an image, even if the
     * PDF417 Code is rotated or skewed, or partially obscured.</p>
     *
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Guenther Grau
     */ /*public*/ /*final*/ class Detector$3 {
        /**
         * <p>Detects a PDF417 Code in an image. Only checks 0 and 180 degree rotations.</p>
         *
         * @param image barcode image to decode
         * @param hints optional hints to detector
         * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
         * be found and returned
         * @return {@link PDF417DetectorResult} encapsulating results of detecting a PDF417 code
         * @throws NotFoundException if no PDF417 Code can be found
         */ static detectMultiple(image, hints, multiple) {
            // TODO detection improvement, tryHarder could try several different luminance thresholds/blackpoints or even
            // different binarizers
            // boolean tryHarder = hints != null && hints.containsKey(DecodeHintType.TRY_HARDER);
            let bitMatrix = image.getBlackMatrix();
            let barcodeCoordinates = Detector$3.detect(multiple, bitMatrix);
            if (!barcodeCoordinates.length) {
                bitMatrix = bitMatrix.clone();
                bitMatrix.rotate180();
                barcodeCoordinates = Detector$3.detect(multiple, bitMatrix);
            }
            return new PDF417DetectorResult(bitMatrix, barcodeCoordinates);
        }
        /**
         * Detects PDF417 codes in an image. Only checks 0 degree rotation
         * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
         * be found and returned
         * @param bitMatrix bit matrix to detect barcodes in
         * @return List of ResultPoint arrays containing the coordinates of found barcodes
         */ static detect(multiple, bitMatrix) {
            const barcodeCoordinates = new Array();
            let row = 0;
            let column = 0;
            let foundBarcodeInRow = false;
            while(row < bitMatrix.getHeight()){
                const vertices = Detector$3.findVertices(bitMatrix, row, column);
                if (vertices[0] == null && vertices[3] == null) {
                    if (!foundBarcodeInRow) break;
                    // we didn't find a barcode starting at the given column and row. Try again from the first column and slightly
                    // below the lowest barcode we found so far.
                    foundBarcodeInRow = false;
                    column = 0;
                    for (const barcodeCoordinate of barcodeCoordinates){
                        if (barcodeCoordinate[1] != null) row = Math.trunc(Math.max(row, barcodeCoordinate[1].getY()));
                        if (barcodeCoordinate[3] != null) row = Math.max(row, Math.trunc(barcodeCoordinate[3].getY()));
                    }
                    row += Detector$3.ROW_STEP;
                    continue;
                }
                foundBarcodeInRow = true;
                barcodeCoordinates.push(vertices);
                if (!multiple) break;
                // if we didn't find a right row indicator column, then continue the search for the next barcode after the
                // start pattern of the barcode just found.
                if (vertices[2] != null) {
                    column = Math.trunc(vertices[2].getX());
                    row = Math.trunc(vertices[2].getY());
                } else {
                    column = Math.trunc(vertices[4].getX());
                    row = Math.trunc(vertices[4].getY());
                }
            }
            return barcodeCoordinates;
        }
        /**
         * Locate the vertices and the codewords area of a black blob using the Start
         * and Stop patterns as locators.
         *
         * @param matrix the scanned barcode image.
         * @return an array containing the vertices:
         *           vertices[0] x, y top left barcode
         *           vertices[1] x, y bottom left barcode
         *           vertices[2] x, y top right barcode
         *           vertices[3] x, y bottom right barcode
         *           vertices[4] x, y top left codeword area
         *           vertices[5] x, y bottom left codeword area
         *           vertices[6] x, y top right codeword area
         *           vertices[7] x, y bottom right codeword area
         */ static findVertices(matrix, startRow, startColumn) {
            const height = matrix.getHeight();
            const width = matrix.getWidth();
            // const result = new ResultPoint[8];
            const result = new Array(8);
            Detector$3.copyToResult(result, Detector$3.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector$3.START_PATTERN), Detector$3.INDEXES_START_PATTERN);
            if (result[4] != null) {
                startColumn = Math.trunc(result[4].getX());
                startRow = Math.trunc(result[4].getY());
            }
            Detector$3.copyToResult(result, Detector$3.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector$3.STOP_PATTERN), Detector$3.INDEXES_STOP_PATTERN);
            return result;
        }
        static copyToResult(result, tmpResult, destinationIndexes) {
            for(let i = 0; i < destinationIndexes.length; i++)result[destinationIndexes[i]] = tmpResult[i];
        }
        static findRowsWithPattern(matrix, height, width, startRow, startColumn, pattern) {
            // const result = new ResultPoint[4];
            const result = new Array(4);
            let found = false;
            const counters = new Int32Array(pattern.length);
            for(; startRow < height; startRow += Detector$3.ROW_STEP){
                let loc = Detector$3.findGuardPattern(matrix, startColumn, startRow, width, false, pattern, counters);
                if (loc != null) {
                    while(startRow > 0){
                        const previousRowLoc = Detector$3.findGuardPattern(matrix, startColumn, --startRow, width, false, pattern, counters);
                        if (previousRowLoc != null) loc = previousRowLoc;
                        else {
                            startRow++;
                            break;
                        }
                    }
                    result[0] = new ResultPoint(loc[0], startRow);
                    result[1] = new ResultPoint(loc[1], startRow);
                    found = true;
                    break;
                }
            }
            let stopRow = startRow + 1;
            // Last row of the current symbol that contains pattern
            if (found) {
                let skippedRowCount = 0;
                let previousRowLoc = Int32Array.from([
                    Math.trunc(result[0].getX()),
                    Math.trunc(result[1].getX())
                ]);
                for(; stopRow < height; stopRow++){
                    const loc = Detector$3.findGuardPattern(matrix, previousRowLoc[0], stopRow, width, false, pattern, counters);
                    // a found pattern is only considered to belong to the same barcode if the start and end positions
                    // don't differ too much. Pattern drift should be not bigger than two for consecutive rows. With
                    // a higher number of skipped rows drift could be larger. To keep it simple for now, we allow a slightly
                    // larger drift and don't check for skipped rows.
                    if (loc != null && Math.abs(previousRowLoc[0] - loc[0]) < Detector$3.MAX_PATTERN_DRIFT && Math.abs(previousRowLoc[1] - loc[1]) < Detector$3.MAX_PATTERN_DRIFT) {
                        previousRowLoc = loc;
                        skippedRowCount = 0;
                    } else {
                        if (skippedRowCount > Detector$3.SKIPPED_ROW_COUNT_MAX) break;
                        else skippedRowCount++;
                    }
                }
                stopRow -= skippedRowCount + 1;
                result[2] = new ResultPoint(previousRowLoc[0], stopRow);
                result[3] = new ResultPoint(previousRowLoc[1], stopRow);
            }
            if (stopRow - startRow < Detector$3.BARCODE_MIN_HEIGHT) Arrays.fill(result, null);
            return result;
        }
        /**
         * @param matrix row of black/white values to search
         * @param column x position to start search
         * @param row y position to start search
         * @param width the number of pixels to search on this row
         * @param pattern pattern of counts of number of black and white pixels that are
         *                 being searched for as a pattern
         * @param counters array of counters, as long as pattern, to re-use
         * @return start/end horizontal offset of guard pattern, as an array of two ints.
         */ static findGuardPattern(matrix, column, row, width, whiteFirst, pattern, counters) {
            Arrays.fillWithin(counters, 0, counters.length, 0);
            let patternStart = column;
            let pixelDrift = 0;
            // if there are black pixels left of the current pixel shift to the left, but only for MAX_PIXEL_DRIFT pixels
            while(matrix.get(patternStart, row) && patternStart > 0 && pixelDrift++ < Detector$3.MAX_PIXEL_DRIFT)patternStart--;
            let x = patternStart;
            let counterPosition = 0;
            let patternLength = pattern.length;
            for(let isWhite = whiteFirst; x < width; x++){
                let pixel = matrix.get(x, row);
                if (pixel !== isWhite) counters[counterPosition]++;
                else {
                    if (counterPosition === patternLength - 1) {
                        if (Detector$3.patternMatchVariance(counters, pattern, Detector$3.MAX_INDIVIDUAL_VARIANCE) < Detector$3.MAX_AVG_VARIANCE) return new Int32Array([
                            patternStart,
                            x
                        ]);
                        patternStart += counters[0] + counters[1];
                        System.arraycopy(counters, 2, counters, 0, counterPosition - 1);
                        counters[counterPosition - 1] = 0;
                        counters[counterPosition] = 0;
                        counterPosition--;
                    } else counterPosition++;
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            if (counterPosition === patternLength - 1 && Detector$3.patternMatchVariance(counters, pattern, Detector$3.MAX_INDIVIDUAL_VARIANCE) < Detector$3.MAX_AVG_VARIANCE) return new Int32Array([
                patternStart,
                x - 1
            ]);
            return null;
        }
        /**
         * Determines how closely a set of observed counts of runs of black/white
         * values matches a given target pattern. This is reported as the ratio of
         * the total variance from the expected pattern proportions across all
         * pattern elements, to the length of the pattern.
         *
         * @param counters observed counters
         * @param pattern expected pattern
         * @param maxIndividualVariance The most any counter can differ before we give up
         * @return ratio of total variance between counters and pattern compared to total pattern size
         */ static patternMatchVariance(counters, pattern, maxIndividualVariance) {
            let numCounters = counters.length;
            let total = 0;
            let patternLength = 0;
            for(let i = 0; i < numCounters; i++){
                total += counters[i];
                patternLength += pattern[i];
            }
            if (total < patternLength) // If we don't even have one pixel per unit of bar width, assume this
            // is too small to reliably match, so fail:
            return /*Float.POSITIVE_INFINITY*/ Infinity;
            // We're going to fake floating-point math in integers. We just need to use more bits.
            // Scale up patternLength so that intermediate values below like scaledCounter will have
            // more "significant digits".
            let unitBarWidth = total / patternLength;
            maxIndividualVariance *= unitBarWidth;
            let totalVariance = 0.0;
            for(let x = 0; x < numCounters; x++){
                let counter = counters[x];
                let scaledPattern = pattern[x] * unitBarWidth;
                let variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
                if (variance > maxIndividualVariance) return /*Float.POSITIVE_INFINITY*/ Infinity;
                totalVariance += variance;
            }
            return totalVariance / total;
        }
    }
    Detector$3.INDEXES_START_PATTERN = Int32Array.from([
        0,
        4,
        1,
        5
    ]);
    Detector$3.INDEXES_STOP_PATTERN = Int32Array.from([
        6,
        2,
        7,
        3
    ]);
    Detector$3.MAX_AVG_VARIANCE = 0.42;
    Detector$3.MAX_INDIVIDUAL_VARIANCE = 0.8;
    // B S B S B S B S Bar/Space pattern
    // 11111111 0 1 0 1 0 1 000
    Detector$3.START_PATTERN = Int32Array.from([
        8,
        1,
        1,
        1,
        1,
        1,
        1,
        3
    ]);
    // 1111111 0 1 000 1 0 1 00 1
    Detector$3.STOP_PATTERN = Int32Array.from([
        7,
        1,
        1,
        3,
        1,
        1,
        1,
        2,
        1
    ]);
    Detector$3.MAX_PIXEL_DRIFT = 3;
    Detector$3.MAX_PATTERN_DRIFT = 5;
    // if we set the value too low, then we don't detect the correct height of the bar if the start patterns are damaged.
    // if we set the value too high, then we might detect the start pattern from a neighbor barcode.
    Detector$3.SKIPPED_ROW_COUNT_MAX = 25;
    // A PDF471 barcode should have at least 3 rows, with each row being >= 3 times the module width. Therefore it should be at least
    // 9 pixels tall. To be conservative, we use about half the size to ensure we don't miss it.
    Detector$3.ROW_STEP = 5;
    Detector$3.BARCODE_MIN_HEIGHT = 10;
    /*
    * Copyright 2012 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.GenericGFPoly
     */ /*final*/ class ModulusPoly {
        constructor(field, coefficients){
            if (coefficients.length === 0) throw new IllegalArgumentException();
            this.field = field;
            let coefficientsLength = /*int*/ coefficients.length;
            if (coefficientsLength > 1 && coefficients[0] === 0) {
                // Leading term must be non-zero for anything except the constant polynomial "0"
                let firstNonZero = /*int*/ 1;
                while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
                if (firstNonZero === coefficientsLength) this.coefficients = new Int32Array([
                    0
                ]);
                else {
                    this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                    System.arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
                }
            } else this.coefficients = coefficients;
        }
        getCoefficients() {
            return this.coefficients;
        }
        /**
         * @return degree of this polynomial
         */ getDegree() {
            return this.coefficients.length - 1;
        }
        /**
         * @return true iff this polynomial is the monomial "0"
         */ isZero() {
            return this.coefficients[0] === 0;
        }
        /**
         * @return coefficient of x^degree term in this polynomial
         */ getCoefficient(degree) {
            return this.coefficients[this.coefficients.length - 1 - degree];
        }
        /**
         * @return evaluation of this polynomial at a given point
         */ evaluateAt(a) {
            if (a === 0) // Just return the x^0 coefficient
            return this.getCoefficient(0);
            if (a === 1) {
                // Just the sum of the coefficients
                let sum = /*int*/ 0;
                for (let coefficient /*int*/  of this.coefficients)sum = this.field.add(sum, coefficient);
                return sum;
            }
            let result = /*int*/ this.coefficients[0];
            let size = /*int*/ this.coefficients.length;
            for(let i /*int*/  = 1; i < size; i++)result = this.field.add(this.field.multiply(a, result), this.coefficients[i]);
            return result;
        }
        add(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            if (this.isZero()) return other;
            if (other.isZero()) return this;
            let smallerCoefficients = this.coefficients;
            let largerCoefficients = other.coefficients;
            if (smallerCoefficients.length > largerCoefficients.length) {
                let temp = smallerCoefficients;
                smallerCoefficients = largerCoefficients;
                largerCoefficients = temp;
            }
            let sumDiff = new Int32Array(largerCoefficients.length);
            let lengthDiff = /*int*/ largerCoefficients.length - smallerCoefficients.length;
            // Copy high-order terms only found in higher-degree polynomial's coefficients
            System.arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
            for(let i /*int*/  = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = this.field.add(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
            return new ModulusPoly(this.field, sumDiff);
        }
        subtract(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            if (other.isZero()) return this;
            return this.add(other.negative());
        }
        multiply(other) {
            if (other instanceof ModulusPoly) return this.multiplyOther(other);
            return this.multiplyScalar(other);
        }
        multiplyOther(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            if (this.isZero() || other.isZero()) // return this.field.getZero();
            return new ModulusPoly(this.field, new Int32Array([
                0
            ]));
            let aCoefficients = this.coefficients;
            let aLength = /*int*/ aCoefficients.length;
            let bCoefficients = other.coefficients;
            let bLength = /*int*/ bCoefficients.length;
            let product = new Int32Array(aLength + bLength - 1);
            for(let i /*int*/  = 0; i < aLength; i++){
                let aCoeff = /*int*/ aCoefficients[i];
                for(let j /*int*/  = 0; j < bLength; j++)product[i + j] = this.field.add(product[i + j], this.field.multiply(aCoeff, bCoefficients[j]));
            }
            return new ModulusPoly(this.field, product);
        }
        negative() {
            let size = /*int*/ this.coefficients.length;
            let negativeCoefficients = new Int32Array(size);
            for(let i /*int*/  = 0; i < size; i++)negativeCoefficients[i] = this.field.subtract(0, this.coefficients[i]);
            return new ModulusPoly(this.field, negativeCoefficients);
        }
        multiplyScalar(scalar) {
            if (scalar === 0) return new ModulusPoly(this.field, new Int32Array([
                0
            ]));
            if (scalar === 1) return this;
            let size = /*int*/ this.coefficients.length;
            let product = new Int32Array(size);
            for(let i /*int*/  = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], scalar);
            return new ModulusPoly(this.field, product);
        }
        multiplyByMonomial(degree, coefficient) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return new ModulusPoly(this.field, new Int32Array([
                0
            ]));
            let size = /*int*/ this.coefficients.length;
            let product = new Int32Array(size + degree);
            for(let i /*int*/  = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], coefficient);
            return new ModulusPoly(this.field, product);
        }
        /*
        ModulusPoly[] divide(other: ModulusPoly) {
          if (!field.equals(other.field)) {
            throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
          }
          if (other.isZero()) {
            throw new IllegalArgumentException("Divide by 0");
          }
      
          let quotient: ModulusPoly = field.getZero();
          let remainder: ModulusPoly = this;
      
          let denominatorLeadingTerm: /*int/ number = other.getCoefficient(other.getDegree());
          let inverseDenominatorLeadingTerm: /*int/ number = field.inverse(denominatorLeadingTerm);
      
          while (remainder.getDegree() >= other.getDegree() && !remainder.isZero()) {
            let degreeDifference: /*int/ number = remainder.getDegree() - other.getDegree();
            let scale: /*int/ number = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
            let term: ModulusPoly = other.multiplyByMonomial(degreeDifference, scale);
            let iterationQuotient: ModulusPoly = field.buildMonomial(degreeDifference, scale);
            quotient = quotient.add(iterationQuotient);
            remainder = remainder.subtract(term);
          }
      
          return new ModulusPoly[] { quotient, remainder };
        }
        */ // @Override
        toString() {
            let result = new StringBuilder(); // dynamic string size in JS
            for(let degree /*int*/  = this.getDegree(); degree >= 0; degree--){
                let coefficient = /*int*/ this.getCoefficient(degree);
                if (coefficient !== 0) {
                    if (coefficient < 0) {
                        result.append(' - ');
                        coefficient = -coefficient;
                    } else if (result.length() > 0) result.append(' + ');
                    if (degree === 0 || coefficient !== 1) result.append(coefficient);
                    if (degree !== 0) {
                        if (degree === 1) result.append('x');
                        else {
                            result.append('x^');
                            result.append(degree);
                        }
                    }
                }
            }
            return result.toString();
        }
    }
    class ModulusBase {
        add(a, b) {
            return (a + b) % this.modulus;
        }
        subtract(a, b) {
            return (this.modulus + a - b) % this.modulus;
        }
        exp(a) {
            return this.expTable[a];
        }
        log(a) {
            if (a === 0) throw new IllegalArgumentException();
            return this.logTable[a];
        }
        inverse(a) {
            if (a === 0) throw new ArithmeticException();
            return this.expTable[this.modulus - this.logTable[a] - 1];
        }
        multiply(a, b) {
            if (a === 0 || b === 0) return 0;
            return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.modulus - 1)];
        }
        getSize() {
            return this.modulus;
        }
        equals(o) {
            return o === this;
        }
    }
    /*
     * Copyright 2012 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>A field based on powers of a generator integer, modulo some modulus.</p>
     *
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.GenericGF
     */ /*public final*/ class ModulusGF extends ModulusBase {
        // private /*final*/ modulus: /*int*/ number;
        constructor(modulus, generator){
            super();
            this.modulus = modulus;
            this.expTable = new Int32Array(modulus);
            this.logTable = new Int32Array(modulus);
            let x = /*int*/ 1;
            for(let i /*int*/  = 0; i < modulus; i++){
                this.expTable[i] = x;
                x = x * generator % modulus;
            }
            for(let i /*int*/  = 0; i < modulus - 1; i++)this.logTable[this.expTable[i]] = i;
            // logTable[0] == 0 but this should never be used
            this.zero = new ModulusPoly(this, new Int32Array([
                0
            ]));
            this.one = new ModulusPoly(this, new Int32Array([
                1
            ]));
        }
        getZero() {
            return this.zero;
        }
        getOne() {
            return this.one;
        }
        buildMonomial(degree, coefficient) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return this.zero;
            let coefficients = new Int32Array(degree + 1);
            coefficients[0] = coefficient;
            return new ModulusPoly(this, coefficients);
        }
    }
    ModulusGF.PDF417_GF = new ModulusGF(PDF417Common.NUMBER_OF_CODEWORDS, 3);
    /*
    * Copyright 2012 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * <p>PDF417 error correction implementation.</p>
     *
     * <p>This <a href="http://en.wikipedia.org/wiki/Reed%E2%80%93Solomon_error_correction#Example">example</a>
     * is quite useful in understanding the algorithm.</p>
     *
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.ReedSolomonDecoder
     */ /*public final*/ class ErrorCorrection {
        constructor(){
            this.field = ModulusGF.PDF417_GF;
        }
        /**
         * @param received received codewords
         * @param numECCodewords number of those codewords used for EC
         * @param erasures location of erasures
         * @return number of errors
         * @throws ChecksumException if errors cannot be corrected, maybe because of too many errors
         */ decode(received, numECCodewords, erasures) {
            let poly = new ModulusPoly(this.field, received);
            let S = new Int32Array(numECCodewords);
            let error = false;
            for(let i /*int*/  = numECCodewords; i > 0; i--){
                let evaluation = poly.evaluateAt(this.field.exp(i));
                S[numECCodewords - i] = evaluation;
                if (evaluation !== 0) error = true;
            }
            if (!error) return 0;
            let knownErrors = this.field.getOne();
            if (erasures != null) for (const erasure of erasures){
                let b = this.field.exp(received.length - 1 - erasure);
                // Add (1 - bx) term:
                let term = new ModulusPoly(this.field, new Int32Array([
                    this.field.subtract(0, b),
                    1
                ]));
                knownErrors = knownErrors.multiply(term);
            }
            let syndrome = new ModulusPoly(this.field, S);
            // syndrome = syndrome.multiply(knownErrors);
            let sigmaOmega = this.runEuclideanAlgorithm(this.field.buildMonomial(numECCodewords, 1), syndrome, numECCodewords);
            let sigma = sigmaOmega[0];
            let omega = sigmaOmega[1];
            // sigma = sigma.multiply(knownErrors);
            let errorLocations = this.findErrorLocations(sigma);
            let errorMagnitudes = this.findErrorMagnitudes(omega, sigma, errorLocations);
            for(let i /*int*/  = 0; i < errorLocations.length; i++){
                let position = received.length - 1 - this.field.log(errorLocations[i]);
                if (position < 0) throw ChecksumException.getChecksumInstance();
                received[position] = this.field.subtract(received[position], errorMagnitudes[i]);
            }
            return errorLocations.length;
        }
        /**
         *
         * @param ModulusPoly
         * @param a
         * @param ModulusPoly
         * @param b
         * @param int
         * @param R
         * @throws ChecksumException
         */ runEuclideanAlgorithm(a, b, R) {
            // Assume a's degree is >= b's
            if (a.getDegree() < b.getDegree()) {
                let temp = a;
                a = b;
                b = temp;
            }
            let rLast = a;
            let r = b;
            let tLast = this.field.getZero();
            let t = this.field.getOne();
            // Run Euclidean algorithm until r's degree is less than R/2
            while(r.getDegree() >= Math.round(R / 2)){
                let rLastLast = rLast;
                let tLastLast = tLast;
                rLast = r;
                tLast = t;
                // Divide rLastLast by rLast, with quotient in q and remainder in r
                if (rLast.isZero()) // Oops, Euclidean algorithm already terminated?
                throw ChecksumException.getChecksumInstance();
                r = rLastLast;
                let q = this.field.getZero();
                let denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
                let dltInverse = this.field.inverse(denominatorLeadingTerm);
                while(r.getDegree() >= rLast.getDegree() && !r.isZero()){
                    let degreeDiff = r.getDegree() - rLast.getDegree();
                    let scale = this.field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                    q = q.add(this.field.buildMonomial(degreeDiff, scale));
                    r = r.subtract(rLast.multiplyByMonomial(degreeDiff, scale));
                }
                t = q.multiply(tLast).subtract(tLastLast).negative();
            }
            let sigmaTildeAtZero = t.getCoefficient(0);
            if (sigmaTildeAtZero === 0) throw ChecksumException.getChecksumInstance();
            let inverse = this.field.inverse(sigmaTildeAtZero);
            let sigma = t.multiply(inverse);
            let omega = r.multiply(inverse);
            return [
                sigma,
                omega
            ];
        }
        /**
         *
         * @param errorLocator
         * @throws ChecksumException
         */ findErrorLocations(errorLocator) {
            // This is a direct application of Chien's search
            let numErrors = errorLocator.getDegree();
            let result = new Int32Array(numErrors);
            let e = 0;
            for(let i /*int*/  = 1; i < this.field.getSize() && e < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
                result[e] = this.field.inverse(i);
                e++;
            }
            if (e !== numErrors) throw ChecksumException.getChecksumInstance();
            return result;
        }
        findErrorMagnitudes(errorEvaluator, errorLocator, errorLocations) {
            let errorLocatorDegree = errorLocator.getDegree();
            let formalDerivativeCoefficients = new Int32Array(errorLocatorDegree);
            for(let i /*int*/  = 1; i <= errorLocatorDegree; i++)formalDerivativeCoefficients[errorLocatorDegree - i] = this.field.multiply(i, errorLocator.getCoefficient(i));
            let formalDerivative = new ModulusPoly(this.field, formalDerivativeCoefficients);
            // This is directly applying Forney's Formula
            let s = errorLocations.length;
            let result = new Int32Array(s);
            for(let i /*int*/  = 0; i < s; i++){
                let xiInverse = this.field.inverse(errorLocations[i]);
                let numerator = this.field.subtract(0, errorEvaluator.evaluateAt(xiInverse));
                let denominator = this.field.inverse(formalDerivative.evaluateAt(xiInverse));
                result[i] = this.field.multiply(numerator, denominator);
            }
            return result;
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author Guenther Grau
     */ /*final*/ class BoundingBox {
        constructor(image, topLeft, bottomLeft, topRight, bottomRight){
            if (image instanceof BoundingBox) this.constructor_2(image);
            else this.constructor_1(image, topLeft, bottomLeft, topRight, bottomRight);
        }
        /**
         *
         * @param image
         * @param topLeft
         * @param bottomLeft
         * @param topRight
         * @param bottomRight
         *
         * @throws NotFoundException
         */ constructor_1(image, topLeft, bottomLeft, topRight, bottomRight) {
            const leftUnspecified = topLeft == null || bottomLeft == null;
            const rightUnspecified = topRight == null || bottomRight == null;
            if (leftUnspecified && rightUnspecified) throw new NotFoundException();
            if (leftUnspecified) {
                topLeft = new ResultPoint(0, topRight.getY());
                bottomLeft = new ResultPoint(0, bottomRight.getY());
            } else if (rightUnspecified) {
                topRight = new ResultPoint(image.getWidth() - 1, topLeft.getY());
                bottomRight = new ResultPoint(image.getWidth() - 1, bottomLeft.getY());
            }
            this.image = image;
            this.topLeft = topLeft;
            this.bottomLeft = bottomLeft;
            this.topRight = topRight;
            this.bottomRight = bottomRight;
            this.minX = Math.trunc(Math.min(topLeft.getX(), bottomLeft.getX()));
            this.maxX = Math.trunc(Math.max(topRight.getX(), bottomRight.getX()));
            this.minY = Math.trunc(Math.min(topLeft.getY(), topRight.getY()));
            this.maxY = Math.trunc(Math.max(bottomLeft.getY(), bottomRight.getY()));
        }
        constructor_2(boundingBox) {
            this.image = boundingBox.image;
            this.topLeft = boundingBox.getTopLeft();
            this.bottomLeft = boundingBox.getBottomLeft();
            this.topRight = boundingBox.getTopRight();
            this.bottomRight = boundingBox.getBottomRight();
            this.minX = boundingBox.getMinX();
            this.maxX = boundingBox.getMaxX();
            this.minY = boundingBox.getMinY();
            this.maxY = boundingBox.getMaxY();
        }
        /**
         * @throws NotFoundException
         */ static merge(leftBox, rightBox) {
            if (leftBox == null) return rightBox;
            if (rightBox == null) return leftBox;
            return new BoundingBox(leftBox.image, leftBox.topLeft, leftBox.bottomLeft, rightBox.topRight, rightBox.bottomRight);
        }
        /**
         * @throws NotFoundException
         */ addMissingRows(missingStartRows, missingEndRows, isLeft) {
            let newTopLeft = this.topLeft;
            let newBottomLeft = this.bottomLeft;
            let newTopRight = this.topRight;
            let newBottomRight = this.bottomRight;
            if (missingStartRows > 0) {
                let top = isLeft ? this.topLeft : this.topRight;
                let newMinY = Math.trunc(top.getY() - missingStartRows);
                if (newMinY < 0) newMinY = 0;
                let newTop = new ResultPoint(top.getX(), newMinY);
                if (isLeft) newTopLeft = newTop;
                else newTopRight = newTop;
            }
            if (missingEndRows > 0) {
                let bottom = isLeft ? this.bottomLeft : this.bottomRight;
                let newMaxY = Math.trunc(bottom.getY() + missingEndRows);
                if (newMaxY >= this.image.getHeight()) newMaxY = this.image.getHeight() - 1;
                let newBottom = new ResultPoint(bottom.getX(), newMaxY);
                if (isLeft) newBottomLeft = newBottom;
                else newBottomRight = newBottom;
            }
            return new BoundingBox(this.image, newTopLeft, newBottomLeft, newTopRight, newBottomRight);
        }
        getMinX() {
            return this.minX;
        }
        getMaxX() {
            return this.maxX;
        }
        getMinY() {
            return this.minY;
        }
        getMaxY() {
            return this.maxY;
        }
        getTopLeft() {
            return this.topLeft;
        }
        getTopRight() {
            return this.topRight;
        }
        getBottomLeft() {
            return this.bottomLeft;
        }
        getBottomRight() {
            return this.bottomRight;
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.pdf417.decoder;
    /**
     * @author Guenther Grau
     */ /*final*/ class BarcodeMetadata {
        constructor(columnCount, rowCountUpperPart, rowCountLowerPart, errorCorrectionLevel){
            this.columnCount = columnCount;
            this.errorCorrectionLevel = errorCorrectionLevel;
            this.rowCountUpperPart = rowCountUpperPart;
            this.rowCountLowerPart = rowCountLowerPart;
            this.rowCount = rowCountUpperPart + rowCountLowerPart;
        }
        getColumnCount() {
            return this.columnCount;
        }
        getErrorCorrectionLevel() {
            return this.errorCorrectionLevel;
        }
        getRowCount() {
            return this.rowCount;
        }
        getRowCountUpperPart() {
            return this.rowCountUpperPart;
        }
        getRowCountLowerPart() {
            return this.rowCountLowerPart;
        }
    }
    /**
     * Java Formatter class polyfill that works in the JS way.
     */ class Formatter {
        constructor(){
            this.buffer = '';
        }
        /**
         *
         * @see https://stackoverflow.com/a/13439711/4367683
         *
         * @param str
         * @param arr
         */ static form(str, arr) {
            let i = -1;
            function callback(exp, p0, p1, p2, p3, p4) {
                if (exp === '%%') return '%';
                if (arr[++i] === undefined) return undefined;
                exp = p2 ? parseInt(p2.substr(1)) : undefined;
                let base = p3 ? parseInt(p3.substr(1)) : undefined;
                let val;
                switch(p4){
                    case 's':
                        val = arr[i];
                        break;
                    case 'c':
                        val = arr[i][0];
                        break;
                    case 'f':
                        val = parseFloat(arr[i]).toFixed(exp);
                        break;
                    case 'p':
                        val = parseFloat(arr[i]).toPrecision(exp);
                        break;
                    case 'e':
                        val = parseFloat(arr[i]).toExponential(exp);
                        break;
                    case 'x':
                        val = parseInt(arr[i]).toString(base ? base : 16);
                        break;
                    case 'd':
                        val = parseFloat(parseInt(arr[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                        break;
                }
                val = typeof val === 'object' ? JSON.stringify(val) : (+val).toString(base);
                let size = parseInt(p1); /* padding size */ 
                let ch = p1 && p1[0] + '' === '0' ? '0' : ' '; /* isnull? */ 
                while(val.length < size)val = p0 !== undefined ? val + ch : ch + val; /* isminus? */ 
                return val;
            }
            let regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
            return str.replace(regex, callback);
        }
        /**
         *
         * @param append The new string to append.
         * @param args Argumets values to be formated.
         */ format(append, ...args) {
            this.buffer += Formatter.form(append, args);
        }
        /**
         * Returns the Formatter string value.
         */ toString() {
            return this.buffer;
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Guenther Grau
     */ class DetectionResultColumn {
        constructor(boundingBox){
            this.boundingBox = new BoundingBox(boundingBox);
            // this.codewords = new Codeword[boundingBox.getMaxY() - boundingBox.getMinY() + 1];
            this.codewords = new Array(boundingBox.getMaxY() - boundingBox.getMinY() + 1);
        }
        /*final*/ getCodewordNearby(imageRow) {
            let codeword = this.getCodeword(imageRow);
            if (codeword != null) return codeword;
            for(let i = 1; i < DetectionResultColumn.MAX_NEARBY_DISTANCE; i++){
                let nearImageRow = this.imageRowToCodewordIndex(imageRow) - i;
                if (nearImageRow >= 0) {
                    codeword = this.codewords[nearImageRow];
                    if (codeword != null) return codeword;
                }
                nearImageRow = this.imageRowToCodewordIndex(imageRow) + i;
                if (nearImageRow < this.codewords.length) {
                    codeword = this.codewords[nearImageRow];
                    if (codeword != null) return codeword;
                }
            }
            return null;
        }
        /*final int*/ imageRowToCodewordIndex(imageRow) {
            return imageRow - this.boundingBox.getMinY();
        }
        /*final void*/ setCodeword(imageRow, codeword) {
            this.codewords[this.imageRowToCodewordIndex(imageRow)] = codeword;
        }
        /*final*/ getCodeword(imageRow) {
            return this.codewords[this.imageRowToCodewordIndex(imageRow)];
        }
        /*final*/ getBoundingBox() {
            return this.boundingBox;
        }
        /*final*/ getCodewords() {
            return this.codewords;
        }
        // @Override
        toString() {
            const formatter = new Formatter();
            let row = 0;
            for (const codeword of this.codewords){
                if (codeword == null) {
                    formatter.format('%3d:    |   %n', row++);
                    continue;
                }
                formatter.format('%3d: %3d|%3d%n', row++, codeword.getRowNumber(), codeword.getValue());
            }
            return formatter.toString();
        }
    }
    DetectionResultColumn.MAX_NEARBY_DISTANCE = 5;
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.ArrayList;
    // import java.util.Collection;
    // import java.util.HashMap;
    // import java.util.Map;
    // import java.util.Map.Entry;
    /**
     * @author Guenther Grau
     */ /*final*/ class BarcodeValue {
        constructor(){
            this.values = new Map();
        }
        /**
         * Add an occurrence of a value
         */ setValue(value) {
            value = Math.trunc(value);
            let confidence = this.values.get(value);
            if (confidence == null) confidence = 0;
            confidence++;
            this.values.set(value, confidence);
        }
        /**
         * Determines the maximum occurrence of a set value and returns all values which were set with this occurrence.
         * @return an array of int, containing the values with the highest occurrence, or null, if no value was set
         */ getValue() {
            let maxConfidence = -1;
            let result = new Array();
            for (const [key, value] of this.values.entries()){
                const entry = {
                    getKey: ()=>key,
                    getValue: ()=>value
                };
                if (entry.getValue() > maxConfidence) {
                    maxConfidence = entry.getValue();
                    result = [];
                    result.push(entry.getKey());
                } else if (entry.getValue() === maxConfidence) result.push(entry.getKey());
            }
            return PDF417Common.toIntArray(result);
        }
        getConfidence(value) {
            return this.values.get(value);
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Guenther Grau
     */ /*final*/ class DetectionResultRowIndicatorColumn extends DetectionResultColumn {
        constructor(boundingBox, isLeft){
            super(boundingBox);
            this._isLeft = isLeft;
        }
        setRowNumbers() {
            for (let codeword /*Codeword*/  of this.getCodewords())if (codeword != null) codeword.setRowNumberAsRowIndicatorColumn();
        }
        // TODO implement properly
        // TODO maybe we should add missing codewords to store the correct row number to make
        // finding row numbers for other columns easier
        // use row height count to make detection of invalid row numbers more reliable
        adjustCompleteIndicatorColumnRowNumbers(barcodeMetadata) {
            let codewords = this.getCodewords();
            this.setRowNumbers();
            this.removeIncorrectCodewords(codewords, barcodeMetadata);
            let boundingBox = this.getBoundingBox();
            let top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
            let bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
            let firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
            let lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
            // We need to be careful using the average row height. Barcode could be skewed so that we have smaller and
            // taller rows
            // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
            let barcodeRow = -1;
            let maxRowHeight = 1;
            let currentRowHeight = 0;
            for(let codewordsRow /*int*/  = firstRow; codewordsRow < lastRow; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let codeword = codewords[codewordsRow];
                //      float expectedRowNumber = (codewordsRow - firstRow) / averageRowHeight;
                //      if (Math.abs(codeword.getRowNumber() - expectedRowNumber) > 2) {
                //        SimpleLog.log(LEVEL.WARNING,
                //            "Removing codeword, rowNumberSkew too high, codeword[" + codewordsRow + "]: Expected Row: " +
                //                expectedRowNumber + ", RealRow: " + codeword.getRowNumber() + ", value: " + codeword.getValue());
                //        codewords[codewordsRow] = null;
                //      }
                let rowDifference = codeword.getRowNumber() - barcodeRow;
                // TODO improve handling with case where first row indicator doesn't start with 0
                if (rowDifference === 0) currentRowHeight++;
                else if (rowDifference === 1) {
                    maxRowHeight = Math.max(maxRowHeight, currentRowHeight);
                    currentRowHeight = 1;
                    barcodeRow = codeword.getRowNumber();
                } else if (rowDifference < 0 || codeword.getRowNumber() >= barcodeMetadata.getRowCount() || rowDifference > codewordsRow) codewords[codewordsRow] = null;
                else {
                    let checkedRows;
                    if (maxRowHeight > 2) checkedRows = (maxRowHeight - 2) * rowDifference;
                    else checkedRows = rowDifference;
                    let closePreviousCodewordFound = checkedRows >= codewordsRow;
                    for(let i /*int*/  = 1; i <= checkedRows && !closePreviousCodewordFound; i++)// there must be (height * rowDifference) number of codewords missing. For now we assume height = 1.
                    // This should hopefully get rid of most problems already.
                    closePreviousCodewordFound = codewords[codewordsRow - i] != null;
                    if (closePreviousCodewordFound) codewords[codewordsRow] = null;
                    else {
                        barcodeRow = codeword.getRowNumber();
                        currentRowHeight = 1;
                    }
                }
            }
        // return (int) (averageRowHeight + 0.5);
        }
        getRowHeights() {
            let barcodeMetadata = this.getBarcodeMetadata();
            if (barcodeMetadata == null) return null;
            this.adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata);
            let result = new Int32Array(barcodeMetadata.getRowCount());
            for (let codeword /*Codeword*/  of this.getCodewords())if (codeword != null) {
                let rowNumber = codeword.getRowNumber();
                if (rowNumber >= result.length) continue;
                result[rowNumber]++;
            } // else throw exception?
            return result;
        }
        // TODO maybe we should add missing codewords to store the correct row number to make
        // finding row numbers for other columns easier
        // use row height count to make detection of invalid row numbers more reliable
        adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata) {
            let boundingBox = this.getBoundingBox();
            let top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
            let bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
            let firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
            let lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
            // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
            let codewords = this.getCodewords();
            let barcodeRow = -1;
            for(let codewordsRow /*int*/  = firstRow; codewordsRow < lastRow; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let codeword = codewords[codewordsRow];
                codeword.setRowNumberAsRowIndicatorColumn();
                let rowDifference = codeword.getRowNumber() - barcodeRow;
                // TODO improve handling with case where first row indicator doesn't start with 0
                if (rowDifference === 0) ;
                else if (rowDifference === 1) barcodeRow = codeword.getRowNumber();
                else if (codeword.getRowNumber() >= barcodeMetadata.getRowCount()) codewords[codewordsRow] = null;
                else barcodeRow = codeword.getRowNumber();
            }
        // return (int) (averageRowHeight + 0.5);
        }
        getBarcodeMetadata() {
            let codewords = this.getCodewords();
            let barcodeColumnCount = new BarcodeValue();
            let barcodeRowCountUpperPart = new BarcodeValue();
            let barcodeRowCountLowerPart = new BarcodeValue();
            let barcodeECLevel = new BarcodeValue();
            for (let codeword /*Codeword*/  of codewords){
                if (codeword == null) continue;
                codeword.setRowNumberAsRowIndicatorColumn();
                let rowIndicatorValue = codeword.getValue() % 30;
                let codewordRowNumber = codeword.getRowNumber();
                if (!this._isLeft) codewordRowNumber += 2;
                switch(codewordRowNumber % 3){
                    case 0:
                        barcodeRowCountUpperPart.setValue(rowIndicatorValue * 3 + 1);
                        break;
                    case 1:
                        barcodeECLevel.setValue(rowIndicatorValue / 3);
                        barcodeRowCountLowerPart.setValue(rowIndicatorValue % 3);
                        break;
                    case 2:
                        barcodeColumnCount.setValue(rowIndicatorValue + 1);
                        break;
                }
            }
            // Maybe we should check if we have ambiguous values?
            if (barcodeColumnCount.getValue().length === 0 || barcodeRowCountUpperPart.getValue().length === 0 || barcodeRowCountLowerPart.getValue().length === 0 || barcodeECLevel.getValue().length === 0 || barcodeColumnCount.getValue()[0] < 1 || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] < PDF417Common.MIN_ROWS_IN_BARCODE || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] > PDF417Common.MAX_ROWS_IN_BARCODE) return null;
            let barcodeMetadata = new BarcodeMetadata(barcodeColumnCount.getValue()[0], barcodeRowCountUpperPart.getValue()[0], barcodeRowCountLowerPart.getValue()[0], barcodeECLevel.getValue()[0]);
            this.removeIncorrectCodewords(codewords, barcodeMetadata);
            return barcodeMetadata;
        }
        removeIncorrectCodewords(codewords, barcodeMetadata) {
            // Remove codewords which do not match the metadata
            // TODO Maybe we should keep the incorrect codewords for the start and end positions?
            for(let codewordRow /*int*/  = 0; codewordRow < codewords.length; codewordRow++){
                let codeword = codewords[codewordRow];
                if (codewords[codewordRow] == null) continue;
                let rowIndicatorValue = codeword.getValue() % 30;
                let codewordRowNumber = codeword.getRowNumber();
                if (codewordRowNumber > barcodeMetadata.getRowCount()) {
                    codewords[codewordRow] = null;
                    continue;
                }
                if (!this._isLeft) codewordRowNumber += 2;
                switch(codewordRowNumber % 3){
                    case 0:
                        if (rowIndicatorValue * 3 + 1 !== barcodeMetadata.getRowCountUpperPart()) codewords[codewordRow] = null;
                        break;
                    case 1:
                        if (Math.trunc(rowIndicatorValue / 3) !== barcodeMetadata.getErrorCorrectionLevel() || rowIndicatorValue % 3 !== barcodeMetadata.getRowCountLowerPart()) codewords[codewordRow] = null;
                        break;
                    case 2:
                        if (rowIndicatorValue + 1 !== barcodeMetadata.getColumnCount()) codewords[codewordRow] = null;
                        break;
                }
            }
        }
        isLeft() {
            return this._isLeft;
        }
        // @Override
        toString() {
            return 'IsLeft: ' + this._isLeft + '\n' + super.toString();
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Guenther Grau
     */ /*final*/ class DetectionResult {
        constructor(barcodeMetadata, boundingBox){
            /*final*/ this.ADJUST_ROW_NUMBER_SKIP = 2;
            this.barcodeMetadata = barcodeMetadata;
            this.barcodeColumnCount = barcodeMetadata.getColumnCount();
            this.boundingBox = boundingBox;
            // this.detectionResultColumns = new DetectionResultColumn[this.barcodeColumnCount + 2];
            this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
        }
        getDetectionResultColumns() {
            this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]);
            this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
            let unadjustedCodewordCount = PDF417Common.MAX_CODEWORDS_IN_BARCODE;
            let previousUnadjustedCount;
            do {
                previousUnadjustedCount = unadjustedCodewordCount;
                unadjustedCodewordCount = this.adjustRowNumbersAndGetCount();
            }while (unadjustedCodewordCount > 0 && unadjustedCodewordCount < previousUnadjustedCount);
            return this.detectionResultColumns;
        }
        adjustIndicatorColumnRowNumbers(detectionResultColumn) {
            if (detectionResultColumn != null) detectionResultColumn.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
        }
        // TODO ensure that no detected codewords with unknown row number are left
        // we should be able to estimate the row height and use it as a hint for the row number
        // we should also fill the rows top to bottom and bottom to top
        /**
         * @return number of codewords which don't have a valid row number. Note that the count is not accurate as codewords
         * will be counted several times. It just serves as an indicator to see when we can stop adjusting row numbers
         */ adjustRowNumbersAndGetCount() {
            let unadjustedCount = this.adjustRowNumbersByRow();
            if (unadjustedCount === 0) return 0;
            for(let barcodeColumn /*int*/  = 1; barcodeColumn < this.barcodeColumnCount + 1; barcodeColumn++){
                let codewords = this.detectionResultColumns[barcodeColumn].getCodewords();
                for(let codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
                    if (codewords[codewordsRow] == null) continue;
                    if (!codewords[codewordsRow].hasValidRowNumber()) this.adjustRowNumbers(barcodeColumn, codewordsRow, codewords);
                }
            }
            return unadjustedCount;
        }
        adjustRowNumbersByRow() {
            this.adjustRowNumbersFromBothRI();
            // TODO we should only do full row adjustments if row numbers of left and right row indicator column match.
            // Maybe it's even better to calculated the height (rows: d) and divide it by the number of barcode
            // rows. This, together with the LRI and RRI row numbers should allow us to get a good estimate where a row
            // number starts and ends.
            let unadjustedCount = this.adjustRowNumbersFromLRI();
            return unadjustedCount + this.adjustRowNumbersFromRRI();
        }
        adjustRowNumbersFromBothRI() {
            if (this.detectionResultColumns[0] == null || this.detectionResultColumns[this.barcodeColumnCount + 1] == null) return;
            let LRIcodewords = this.detectionResultColumns[0].getCodewords();
            let RRIcodewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
            for(let codewordsRow /*int*/  = 0; codewordsRow < LRIcodewords.length; codewordsRow++){
                if (LRIcodewords[codewordsRow] != null && RRIcodewords[codewordsRow] != null && LRIcodewords[codewordsRow].getRowNumber() === RRIcodewords[codewordsRow].getRowNumber()) for(let barcodeColumn /*int*/  = 1; barcodeColumn <= this.barcodeColumnCount; barcodeColumn++){
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword == null) continue;
                    codeword.setRowNumber(LRIcodewords[codewordsRow].getRowNumber());
                    if (!codeword.hasValidRowNumber()) this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow] = null;
                }
            }
        }
        adjustRowNumbersFromRRI() {
            if (this.detectionResultColumns[this.barcodeColumnCount + 1] == null) return 0;
            let unadjustedCount = 0;
            let codewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
            for(let codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
                let invalidRowCounts = 0;
                for(let barcodeColumn /*int*/  = this.barcodeColumnCount + 1; barcodeColumn > 0 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn--){
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword != null) {
                        invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                        if (!codeword.hasValidRowNumber()) unadjustedCount++;
                    }
                }
            }
            return unadjustedCount;
        }
        adjustRowNumbersFromLRI() {
            if (this.detectionResultColumns[0] == null) return 0;
            let unadjustedCount = 0;
            let codewords = this.detectionResultColumns[0].getCodewords();
            for(let codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
                let invalidRowCounts = 0;
                for(let barcodeColumn /*int*/  = 1; barcodeColumn < this.barcodeColumnCount + 1 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn++){
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword != null) {
                        invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                        if (!codeword.hasValidRowNumber()) unadjustedCount++;
                    }
                }
            }
            return unadjustedCount;
        }
        static adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword) {
            if (codeword == null) return invalidRowCounts;
            if (!codeword.hasValidRowNumber()) {
                if (codeword.isValidRowNumber(rowIndicatorRowNumber)) {
                    codeword.setRowNumber(rowIndicatorRowNumber);
                    invalidRowCounts = 0;
                } else ++invalidRowCounts;
            }
            return invalidRowCounts;
        }
        adjustRowNumbers(barcodeColumn, codewordsRow, codewords) {
            if (!this.detectionResultColumns[barcodeColumn - 1]) return;
            let codeword = codewords[codewordsRow];
            let previousColumnCodewords = this.detectionResultColumns[barcodeColumn - 1].getCodewords();
            let nextColumnCodewords = previousColumnCodewords;
            if (this.detectionResultColumns[barcodeColumn + 1] != null) nextColumnCodewords = this.detectionResultColumns[barcodeColumn + 1].getCodewords();
            // let otherCodewords: Codeword[] = new Codeword[14];
            let otherCodewords = new Array(14);
            otherCodewords[2] = previousColumnCodewords[codewordsRow];
            otherCodewords[3] = nextColumnCodewords[codewordsRow];
            if (codewordsRow > 0) {
                otherCodewords[0] = codewords[codewordsRow - 1];
                otherCodewords[4] = previousColumnCodewords[codewordsRow - 1];
                otherCodewords[5] = nextColumnCodewords[codewordsRow - 1];
            }
            if (codewordsRow > 1) {
                otherCodewords[8] = codewords[codewordsRow - 2];
                otherCodewords[10] = previousColumnCodewords[codewordsRow - 2];
                otherCodewords[11] = nextColumnCodewords[codewordsRow - 2];
            }
            if (codewordsRow < codewords.length - 1) {
                otherCodewords[1] = codewords[codewordsRow + 1];
                otherCodewords[6] = previousColumnCodewords[codewordsRow + 1];
                otherCodewords[7] = nextColumnCodewords[codewordsRow + 1];
            }
            if (codewordsRow < codewords.length - 2) {
                otherCodewords[9] = codewords[codewordsRow + 2];
                otherCodewords[12] = previousColumnCodewords[codewordsRow + 2];
                otherCodewords[13] = nextColumnCodewords[codewordsRow + 2];
            }
            for (let otherCodeword of otherCodewords){
                if (DetectionResult.adjustRowNumber(codeword, otherCodeword)) return;
            }
        }
        /**
         * @return true, if row number was adjusted, false otherwise
         */ static adjustRowNumber(codeword, otherCodeword) {
            if (otherCodeword == null) return false;
            if (otherCodeword.hasValidRowNumber() && otherCodeword.getBucket() === codeword.getBucket()) {
                codeword.setRowNumber(otherCodeword.getRowNumber());
                return true;
            }
            return false;
        }
        getBarcodeColumnCount() {
            return this.barcodeColumnCount;
        }
        getBarcodeRowCount() {
            return this.barcodeMetadata.getRowCount();
        }
        getBarcodeECLevel() {
            return this.barcodeMetadata.getErrorCorrectionLevel();
        }
        setBoundingBox(boundingBox) {
            this.boundingBox = boundingBox;
        }
        getBoundingBox() {
            return this.boundingBox;
        }
        setDetectionResultColumn(barcodeColumn, detectionResultColumn) {
            this.detectionResultColumns[barcodeColumn] = detectionResultColumn;
        }
        getDetectionResultColumn(barcodeColumn) {
            return this.detectionResultColumns[barcodeColumn];
        }
        // @Override
        toString() {
            let rowIndicatorColumn = this.detectionResultColumns[0];
            if (rowIndicatorColumn == null) rowIndicatorColumn = this.detectionResultColumns[this.barcodeColumnCount + 1];
            // try (
            let formatter = new Formatter();
            // ) {
            for(let codewordsRow /*int*/  = 0; codewordsRow < rowIndicatorColumn.getCodewords().length; codewordsRow++){
                formatter.format('CW %3d:', codewordsRow);
                for(let barcodeColumn /*int*/  = 0; barcodeColumn < this.barcodeColumnCount + 2; barcodeColumn++){
                    if (this.detectionResultColumns[barcodeColumn] == null) {
                        formatter.format('    |   ');
                        continue;
                    }
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword == null) {
                        formatter.format('    |   ');
                        continue;
                    }
                    formatter.format(' %3d|%3d', codeword.getRowNumber(), codeword.getValue());
                }
                formatter.format('%n');
            }
            return formatter.toString();
        // }
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.pdf417.decoder;
    /**
     * @author Guenther Grau
     */ /*final*/ class Codeword {
        constructor(startX, endX, bucket, value){
            this.rowNumber = Codeword.BARCODE_ROW_UNKNOWN;
            this.startX = Math.trunc(startX);
            this.endX = Math.trunc(endX);
            this.bucket = Math.trunc(bucket);
            this.value = Math.trunc(value);
        }
        hasValidRowNumber() {
            return this.isValidRowNumber(this.rowNumber);
        }
        isValidRowNumber(rowNumber) {
            return rowNumber !== Codeword.BARCODE_ROW_UNKNOWN && this.bucket === rowNumber % 3 * 3;
        }
        setRowNumberAsRowIndicatorColumn() {
            this.rowNumber = Math.trunc(Math.trunc(this.value / 30) * 3 + Math.trunc(this.bucket / 3));
        }
        getWidth() {
            return this.endX - this.startX;
        }
        getStartX() {
            return this.startX;
        }
        getEndX() {
            return this.endX;
        }
        getBucket() {
            return this.bucket;
        }
        getValue() {
            return this.value;
        }
        getRowNumber() {
            return this.rowNumber;
        }
        setRowNumber(rowNumber) {
            this.rowNumber = rowNumber;
        }
        //   @Override
        toString() {
            return this.rowNumber + '|' + this.value;
        }
    }
    Codeword.BARCODE_ROW_UNKNOWN = -1;
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author Guenther Grau
     * @author creatale GmbH (christoph.schulz@creatale.de)
     */ /*final*/ class PDF417CodewordDecoder {
        /* @note
         * this action have to be performed before first use of class
         * - static constructor
         * working with 32bit float (based from Java logic)
        */ static initialize() {
            // Pre-computes the symbol ratio table.
            for(/*int*/ let i = 0; i < PDF417Common.SYMBOL_TABLE.length; i++){
                let currentSymbol = PDF417Common.SYMBOL_TABLE[i];
                let currentBit = currentSymbol & 0x1;
                for(/*int*/ let j = 0; j < PDF417Common.BARS_IN_MODULE; j++){
                    let size = 0.0;
                    while((currentSymbol & 0x1) === currentBit){
                        size += 1.0;
                        currentSymbol >>= 1;
                    }
                    currentBit = currentSymbol & 0x1;
                    if (!PDF417CodewordDecoder.RATIOS_TABLE[i]) PDF417CodewordDecoder.RATIOS_TABLE[i] = new Array(PDF417Common.BARS_IN_MODULE);
                    PDF417CodewordDecoder.RATIOS_TABLE[i][PDF417Common.BARS_IN_MODULE - j - 1] = Math.fround(size / PDF417Common.MODULES_IN_CODEWORD);
                }
            }
            this.bSymbolTableReady = true;
        }
        static getDecodedValue(moduleBitCount) {
            let decodedValue = PDF417CodewordDecoder.getDecodedCodewordValue(PDF417CodewordDecoder.sampleBitCounts(moduleBitCount));
            if (decodedValue !== -1) return decodedValue;
            return PDF417CodewordDecoder.getClosestDecodedValue(moduleBitCount);
        }
        static sampleBitCounts(moduleBitCount) {
            let bitCountSum = MathUtils.sum(moduleBitCount);
            let result = new Int32Array(PDF417Common.BARS_IN_MODULE);
            let bitCountIndex = 0;
            let sumPreviousBits = 0;
            for(/*int*/ let i = 0; i < PDF417Common.MODULES_IN_CODEWORD; i++){
                let sampleIndex = bitCountSum / (2 * PDF417Common.MODULES_IN_CODEWORD) + i * bitCountSum / PDF417Common.MODULES_IN_CODEWORD;
                if (sumPreviousBits + moduleBitCount[bitCountIndex] <= sampleIndex) {
                    sumPreviousBits += moduleBitCount[bitCountIndex];
                    bitCountIndex++;
                }
                result[bitCountIndex]++;
            }
            return result;
        }
        static getDecodedCodewordValue(moduleBitCount) {
            let decodedValue = PDF417CodewordDecoder.getBitValue(moduleBitCount);
            return PDF417Common.getCodeword(decodedValue) === -1 ? -1 : decodedValue;
        }
        static getBitValue(moduleBitCount) {
            let result = /*long*/ 0;
            for(let /*int*/ i = 0; i < moduleBitCount.length; i++)for(/*int*/ let bit = 0; bit < moduleBitCount[i]; bit++)result = result << 1 | (i % 2 === 0 ? 1 : 0);
            return Math.trunc(result);
        }
        // working with 32bit float (as in Java)
        static getClosestDecodedValue(moduleBitCount) {
            let bitCountSum = MathUtils.sum(moduleBitCount);
            let bitCountRatios = new Array(PDF417Common.BARS_IN_MODULE);
            if (bitCountSum > 1) for(let /*int*/ i = 0; i < bitCountRatios.length; i++)bitCountRatios[i] = Math.fround(moduleBitCount[i] / bitCountSum);
            let bestMatchError = Float.MAX_VALUE;
            let bestMatch = -1;
            if (!this.bSymbolTableReady) PDF417CodewordDecoder.initialize();
            for(/*int*/ let j = 0; j < PDF417CodewordDecoder.RATIOS_TABLE.length; j++){
                let error = 0.0;
                let ratioTableRow = PDF417CodewordDecoder.RATIOS_TABLE[j];
                for(/*int*/ let k = 0; k < PDF417Common.BARS_IN_MODULE; k++){
                    let diff = Math.fround(ratioTableRow[k] - bitCountRatios[k]);
                    error += Math.fround(diff * diff);
                    if (error >= bestMatchError) break;
                }
                if (error < bestMatchError) {
                    bestMatchError = error;
                    bestMatch = PDF417Common.SYMBOL_TABLE[j];
                }
            }
            return bestMatch;
        }
    }
    // flag that the table is ready for use
    PDF417CodewordDecoder.bSymbolTableReady = false;
    PDF417CodewordDecoder.RATIOS_TABLE = new Array(PDF417Common.SYMBOL_TABLE.length).map((x)=>x = new Array(PDF417Common.BARS_IN_MODULE));
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.pdf417;
    /**
     * @author Guenther Grau
     */ /*public final*/ class PDF417ResultMetadata {
        constructor(){
            this.segmentCount = -1;
            this.fileSize = -1;
            this.timestamp = -1;
            this.checksum = -1;
        }
        /**
         * The Segment ID represents the segment of the whole file distributed over different symbols.
         *
         * @return File segment index
         */ getSegmentIndex() {
            return this.segmentIndex;
        }
        setSegmentIndex(segmentIndex) {
            this.segmentIndex = segmentIndex;
        }
        /**
         * Is the same for each related PDF417 symbol
         *
         * @return File ID
         */ getFileId() {
            return this.fileId;
        }
        setFileId(fileId) {
            this.fileId = fileId;
        }
        /**
         * @return always null
         * @deprecated use dedicated already parsed fields
         */ //   @Deprecated
        getOptionalData() {
            return this.optionalData;
        }
        /**
         * @param optionalData old optional data format as int array
         * @deprecated parse and use new fields
         */ //   @Deprecated
        setOptionalData(optionalData) {
            this.optionalData = optionalData;
        }
        /**
         * @return true if it is the last segment
         */ isLastSegment() {
            return this.lastSegment;
        }
        setLastSegment(lastSegment) {
            this.lastSegment = lastSegment;
        }
        /**
         * @return count of segments, -1 if not set
         */ getSegmentCount() {
            return this.segmentCount;
        }
        setSegmentCount(segmentCount /*int*/ ) {
            this.segmentCount = segmentCount;
        }
        getSender() {
            return this.sender || null;
        }
        setSender(sender) {
            this.sender = sender;
        }
        getAddressee() {
            return this.addressee || null;
        }
        setAddressee(addressee) {
            this.addressee = addressee;
        }
        /**
         * Filename of the encoded file
         *
         * @return filename
         */ getFileName() {
            return this.fileName;
        }
        setFileName(fileName) {
            this.fileName = fileName;
        }
        /**
         * filesize in bytes of the encoded file
         *
         * @return filesize in bytes, -1 if not set
         */ getFileSize() {
            return this.fileSize;
        }
        setFileSize(fileSize /*long*/ ) {
            this.fileSize = fileSize;
        }
        /**
         * 16-bit CRC checksum using CCITT-16
         *
         * @return crc checksum, -1 if not set
         */ getChecksum() {
            return this.checksum;
        }
        setChecksum(checksum /*int*/ ) {
            this.checksum = checksum;
        }
        /**
         * unix epock timestamp, elapsed seconds since 1970-01-01
         *
         * @return elapsed seconds, -1 if not set
         */ getTimestamp() {
            return this.timestamp;
        }
        setTimestamp(timestamp /*long*/ ) {
            this.timestamp = timestamp;
        }
    }
    /**
     * Ponyfill for Java's Long class.
     */ class Long {
        /**
         * Parses a string to a number, since JS has no really Int64.
         *
         * @param num Numeric string.
         * @param radix Destination radix.
         */ static parseLong(num, radix) {
            return parseInt(num, radix);
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class NullPointerException extends Exception {
    }
    NullPointerException.kind = 'NullPointerException';
    /*
     * Copyright (c) 1994, 2004, Oracle and/or its affiliates. All rights reserved.
     * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
     *
     * This code is free software; you can redistribute it and/or modify it
     * under the terms of the GNU General Public License version 2 only, as
     * published by the Free Software Foundation.  Oracle designates this
     * particular file as subject to the "Classpath" exception as provided
     * by Oracle in the LICENSE file that accompanied this code.
     *
     * This code is distributed in the hope that it will be useful, but WITHOUT
     * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
     * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
     * version 2 for more details (a copy is included in the LICENSE file that
     * accompanied this code).
     *
     * You should have received a copy of the GNU General Public License version
     * 2 along with this work; if not, write to the Free Software Foundation,
     * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
     *
     * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
     * or visit www.oracle.com if you need additional information or have any
     * questions.
     */ // package java.io;
    /**
     * This abstract class is the superclass of all classes representing
     * an output stream of bytes. An output stream accepts output bytes
     * and sends them to some sink.
     * <p>
     * Applications that need to define a subclass of
     * <code>OutputStream</code> must always provide at least a method
     * that writes one byte of output.
     *
     * @author  Arthur van Hoff
     * @see     java.io.BufferedOutputStream
     * @see     java.io.ByteArrayOutputStream
     * @see     java.io.DataOutputStream
     * @see     java.io.FilterOutputStream
     * @see     java.io.InputStream
     * @see     java.io.OutputStream#write(int)
     * @since   JDK1.0
     */ /*public*/ class OutputStream {
        /**
         * Writes <code>b.length</code> bytes from the specified byte array
         * to this output stream. The general contract for <code>write(b)</code>
         * is that it should have exactly the same effect as the call
         * <code>write(b, 0, b.length)</code>.
         *
         * @param      b   the data.
         * @exception  IOException  if an I/O error occurs.
         * @see        java.io.OutputStream#write(byte[], int, int)
         */ writeBytes(b) {
            this.writeBytesOffset(b, 0, b.length);
        }
        /**
         * Writes <code>len</code> bytes from the specified byte array
         * starting at offset <code>off</code> to this output stream.
         * The general contract for <code>write(b, off, len)</code> is that
         * some of the bytes in the array <code>b</code> are written to the
         * output stream in order; element <code>b[off]</code> is the first
         * byte written and <code>b[off+len-1]</code> is the last byte written
         * by this operation.
         * <p>
         * The <code>write</code> method of <code>OutputStream</code> calls
         * the write method of one argument on each of the bytes to be
         * written out. Subclasses are encouraged to override this method and
         * provide a more efficient implementation.
         * <p>
         * If <code>b</code> is <code>null</code>, a
         * <code>NullPointerException</code> is thrown.
         * <p>
         * If <code>off</code> is negative, or <code>len</code> is negative, or
         * <code>off+len</code> is greater than the length of the array
         * <code>b</code>, then an <tt>IndexOutOfBoundsException</tt> is thrown.
         *
         * @param      b     the data.
         * @param      off   the start offset in the data.
         * @param      len   the number of bytes to write.
         * @exception  IOException  if an I/O error occurs. In particular,
         *             an <code>IOException</code> is thrown if the output
         *             stream is closed.
         */ writeBytesOffset(b, off, len) {
            if (b == null) throw new NullPointerException();
            else if (off < 0 || off > b.length || len < 0 || off + len > b.length || off + len < 0) throw new IndexOutOfBoundsException();
            else if (len === 0) return;
            for(let i = 0; i < len; i++)this.write(b[off + i]);
        }
        /**
         * Flushes this output stream and forces any buffered output bytes
         * to be written out. The general contract of <code>flush</code> is
         * that calling it is an indication that, if any bytes previously
         * written have been buffered by the implementation of the output
         * stream, such bytes should immediately be written to their
         * intended destination.
         * <p>
         * If the intended destination of this stream is an abstraction provided by
         * the underlying operating system, for example a file, then flushing the
         * stream guarantees only that bytes previously written to the stream are
         * passed to the operating system for writing; it does not guarantee that
         * they are actually written to a physical device such as a disk drive.
         * <p>
         * The <code>flush</code> method of <code>OutputStream</code> does nothing.
         *
         * @exception  IOException  if an I/O error occurs.
         */ flush() {}
        /**
         * Closes this output stream and releases any system resources
         * associated with this stream. The general contract of <code>close</code>
         * is that it closes the output stream. A closed stream cannot perform
         * output operations and cannot be reopened.
         * <p>
         * The <code>close</code> method of <code>OutputStream</code> does nothing.
         *
         * @exception  IOException  if an I/O error occurs.
         */ close() {}
    }
    /**
     * Custom Error class of type Exception.
     */ class OutOfMemoryError extends Exception {
    }
    /*
     * Copyright (c) 1994, 2010, Oracle and/or its affiliates. All rights reserved.
     * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
     *
     * This code is free software; you can redistribute it and/or modify it
     * under the terms of the GNU General Public License version 2 only, as
     * published by the Free Software Foundation.  Oracle designates this
     * particular file as subject to the "Classpath" exception as provided
     * by Oracle in the LICENSE file that accompanied this code.
     *
     * This code is distributed in the hope that it will be useful, but WITHOUT
     * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
     * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
     * version 2 for more details (a copy is included in the LICENSE file that
     * accompanied this code).
     *
     * You should have received a copy of the GNU General Public License version
     * 2 along with this work; if not, write to the Free Software Foundation,
     * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
     *
     * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
     * or visit www.oracle.com if you need additional information or have any
     * questions.
     */ /**
     * This class implements an output stream in which the data is
     * written into a byte array. The buffer automatically grows as data
     * is written to it.
     * The data can be retrieved using <code>toByteArray()</code> and
     * <code>toString()</code>.
     * <p>
     * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
     * this class can be called after the stream has been closed without
     * generating an <tt>IOException</tt>.
     *
     * @author  Arthur van Hoff
     * @since   JDK1.0
     */ /*public*/ class ByteArrayOutputStream extends OutputStream {
        /**
         * Creates a new byte array output stream. The buffer capacity is
         * initially 32 bytes, though its size increases if necessary.
         */ // public constructor() {
        //     this(32);
        // }
        /**
         * Creates a new byte array output stream, with a buffer capacity of
         * the specified size, in bytes.
         *
         * @param   size   the initial size.
         * @exception  IllegalArgumentException if size is negative.
         */ constructor(size = 32){
            super();
            /**
             * The number of valid bytes in the buffer.
             */ this.count = 0;
            if (size < 0) throw new IllegalArgumentException('Negative initial size: ' + size);
            this.buf = new Uint8Array(size);
        }
        /**
         * Increases the capacity if necessary to ensure that it can hold
         * at least the number of elements specified by the minimum
         * capacity argument.
         *
         * @param minCapacity the desired minimum capacity
         * @throws OutOfMemoryError if {@code minCapacity < 0}.  This is
         * interpreted as a request for the unsatisfiably large capacity
         * {@code (long) Integer.MAX_VALUE + (minCapacity - Integer.MAX_VALUE)}.
         */ ensureCapacity(minCapacity) {
            // overflow-conscious code
            if (minCapacity - this.buf.length > 0) this.grow(minCapacity);
        }
        /**
         * Increases the capacity to ensure that it can hold at least the
         * number of elements specified by the minimum capacity argument.
         *
         * @param minCapacity the desired minimum capacity
         */ grow(minCapacity) {
            // overflow-conscious code
            let oldCapacity = this.buf.length;
            let newCapacity = oldCapacity << 1;
            if (newCapacity - minCapacity < 0) newCapacity = minCapacity;
            if (newCapacity < 0) {
                if (minCapacity < 0) throw new OutOfMemoryError();
                newCapacity = Integer.MAX_VALUE;
            }
            this.buf = Arrays.copyOfUint8Array(this.buf, newCapacity);
        }
        /**
         * Writes the specified byte to this byte array output stream.
         *
         * @param   b   the byte to be written.
         */ write(b) {
            this.ensureCapacity(this.count + 1);
            this.buf[this.count] = /*(byte)*/ b;
            this.count += 1;
        }
        /**
         * Writes <code>len</code> bytes from the specified byte array
         * starting at offset <code>off</code> to this byte array output stream.
         *
         * @param   b     the data.
         * @param   off   the start offset in the data.
         * @param   len   the number of bytes to write.
         */ writeBytesOffset(b, off, len) {
            if (off < 0 || off > b.length || len < 0 || off + len - b.length > 0) throw new IndexOutOfBoundsException();
            this.ensureCapacity(this.count + len);
            System.arraycopy(b, off, this.buf, this.count, len);
            this.count += len;
        }
        /**
         * Writes the complete contents of this byte array output stream to
         * the specified output stream argument, as if by calling the output
         * stream's write method using <code>out.write(buf, 0, count)</code>.
         *
         * @param      out   the output stream to which to write the data.
         * @exception  IOException  if an I/O error occurs.
         */ writeTo(out) {
            out.writeBytesOffset(this.buf, 0, this.count);
        }
        /**
         * Resets the <code>count</code> field of this byte array output
         * stream to zero, so that all currently accumulated output in the
         * output stream is discarded. The output stream can be used again,
         * reusing the already allocated buffer space.
         *
         * @see     java.io.ByteArrayInputStream#count
         */ reset() {
            this.count = 0;
        }
        /**
         * Creates a newly allocated byte array. Its size is the current
         * size of this output stream and the valid contents of the buffer
         * have been copied into it.
         *
         * @return  the current contents of this output stream, as a byte array.
         * @see     java.io.ByteArrayOutputStream#size()
         */ toByteArray() {
            return Arrays.copyOfUint8Array(this.buf, this.count);
        }
        /**
         * Returns the current size of the buffer.
         *
         * @return  the value of the <code>count</code> field, which is the number
         *          of valid bytes in this output stream.
         * @see     java.io.ByteArrayOutputStream#count
         */ size() {
            return this.count;
        }
        toString(param) {
            if (!param) return this.toString_void();
            if (typeof param === 'string') return this.toString_string(param);
            return this.toString_number(param);
        }
        /**
         * Converts the buffer's contents into a string decoding bytes using the
         * platform's default character set. The length of the new <tt>String</tt>
         * is a function of the character set, and hence may not be equal to the
         * size of the buffer.
         *
         * <p> This method always replaces malformed-input and unmappable-character
         * sequences with the default replacement string for the platform's
         * default character set. The {@linkplain java.nio.charset.CharsetDecoder}
         * class should be used when more control over the decoding process is
         * required.
         *
         * @return String decoded from the buffer's contents.
         * @since  JDK1.1
         */ toString_void() {
            return new String(this.buf /*, 0, this.count*/ ).toString();
        }
        /**
         * Converts the buffer's contents into a string by decoding the bytes using
         * the specified {@link java.nio.charset.Charset charsetName}. The length of
         * the new <tt>String</tt> is a function of the charset, and hence may not be
         * equal to the length of the byte array.
         *
         * <p> This method always replaces malformed-input and unmappable-character
         * sequences with this charset's default replacement string. The {@link
         * java.nio.charset.CharsetDecoder} class should be used when more control
         * over the decoding process is required.
         *
         * @param  charsetName  the name of a supported
         *              {@linkplain java.nio.charset.Charset </code>charset<code>}
         * @return String decoded from the buffer's contents.
         * @exception  UnsupportedEncodingException
         *             If the named charset is not supported
         * @since   JDK1.1
         */ toString_string(charsetName) {
            return new String(this.buf /*, 0, this.count, charsetName*/ ).toString();
        }
        /**
         * Creates a newly allocated string. Its size is the current size of
         * the output stream and the valid contents of the buffer have been
         * copied into it. Each character <i>c</i> in the resulting string is
         * constructed from the corresponding element <i>b</i> in the byte
         * array such that:
         * <blockquote><pre>
         *     c == (char)(((hibyte &amp; 0xff) &lt;&lt; 8) | (b &amp; 0xff))
         * </pre></blockquote>
         *
         * @deprecated This method does not properly convert bytes into characters.
         * As of JDK&nbsp;1.1, the preferred way to do this is via the
         * <code>toString(String enc)</code> method, which takes an encoding-name
         * argument, or the <code>toString()</code> method, which uses the
         * platform's default character encoding.
         *
         * @param      hibyte    the high byte of each resulting Unicode character.
         * @return     the current contents of the output stream, as a string.
         * @see        java.io.ByteArrayOutputStream#size()
         * @see        java.io.ByteArrayOutputStream#toString(String)
         * @see        java.io.ByteArrayOutputStream#toString()
         */ // @Deprecated
        toString_number(hibyte) {
            return new String(this.buf /*, hibyte, 0, this.count*/ ).toString();
        }
        /**
         * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
         * this class can be called after the stream has been closed without
         * generating an <tt>IOException</tt>.
         * <p>
         *
         * @throws IOException
         */ close() {}
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*private*/ var Mode$2;
    (function(Mode) {
        Mode[Mode["ALPHA"] = 0] = "ALPHA";
        Mode[Mode["LOWER"] = 1] = "LOWER";
        Mode[Mode["MIXED"] = 2] = "MIXED";
        Mode[Mode["PUNCT"] = 3] = "PUNCT";
        Mode[Mode["ALPHA_SHIFT"] = 4] = "ALPHA_SHIFT";
        Mode[Mode["PUNCT_SHIFT"] = 5] = "PUNCT_SHIFT";
    })(Mode$2 || (Mode$2 = {}));
    /**
     * Indirectly access the global BigInt constructor, it
     * allows browsers that doesn't support BigInt to run
     * the library without breaking due to "undefined BigInt"
     * errors.
     */ function getBigIntConstructor() {
        if (typeof window !== 'undefined') return window['BigInt'] || null;
        if (typeof $parcel$global !== 'undefined') return $parcel$global['BigInt'] || null;
        if (typeof self !== 'undefined') return self['BigInt'] || null;
        throw new Error('Can\'t search globals for BigInt!');
    }
    /**
     * Used to store the BigInt constructor.
     */ let BigInteger;
    /**
     * This function creates a bigint value. It allows browsers
     * that doesn't support BigInt to run the rest of the library
     * by not directly accessing the BigInt constructor.
     */ function createBigInt(num) {
        if (typeof BigInteger === 'undefined') BigInteger = getBigIntConstructor();
        if (BigInteger === null) throw new Error('BigInt is not supported!');
        return BigInteger(num);
    }
    function getEXP900() {
        // in Java - array with length = 16
        let EXP900 = [];
        EXP900[0] = createBigInt(1);
        let nineHundred = createBigInt(900);
        EXP900[1] = nineHundred;
        // in Java - array with length = 16
        for(let i /*int*/  = 2; i < 16; i++)EXP900[i] = EXP900[i - 1] * nineHundred;
        return EXP900;
    }
    /**
     * <p>This class contains the methods for decoding the PDF417 codewords.</p>
     *
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author Guenther Grau
     */ /*final*/ class DecodedBitStreamParser$2 {
        //   private DecodedBitStreamParser() {
        // }
        /**
         *
         * @param codewords
         * @param ecLevel
         *
         * @throws FormatException
         */ static decode(codewords, ecLevel) {
            // pass encoding to result (will be used for decode symbols in byte mode)
            let result = new StringBuilder('');
            // let encoding: Charset = StandardCharsets.ISO_8859_1;
            let encoding = CharacterSetECI.ISO8859_1;
            /**
             * @note the next command is specific from this TypeScript library
             * because TS can't properly cast some values to char and
             * convert it to string later correctly due to encoding
             * differences from Java version. As reported here:
             * https://github.com/zxing-js/library/pull/264/files#r382831593
             */ result.enableDecoding(encoding);
            // Get compaction mode
            let codeIndex = 1;
            let code = codewords[codeIndex++];
            let resultMetadata = new PDF417ResultMetadata();
            while(codeIndex < codewords[0]){
                switch(code){
                    case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                        codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                        codeIndex = DecodedBitStreamParser$2.byteCompaction(code, codewords, encoding, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                        result.append(/*(char)*/ codewords[codeIndex++]);
                        break;
                    case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                        codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.ECI_CHARSET:
                        let charsetECI = CharacterSetECI.getCharacterSetECIByValue(codewords[codeIndex++]);
                        break;
                    case DecodedBitStreamParser$2.ECI_GENERAL_PURPOSE:
                        // Can't do anything with generic ECI; skip its 2 characters
                        codeIndex += 2;
                        break;
                    case DecodedBitStreamParser$2.ECI_USER_DEFINED:
                        // Can't do anything with user ECI; skip its 1 character
                        codeIndex++;
                        break;
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        codeIndex = DecodedBitStreamParser$2.decodeMacroBlock(codewords, codeIndex, resultMetadata);
                        break;
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                        // Should not see these outside a macro block
                        throw new FormatException();
                    default:
                        // Default to text compaction. During testing numerous barcodes
                        // appeared to be missing the starting mode. In these cases defaulting
                        // to text compaction seems to work.
                        codeIndex--;
                        codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, result);
                        break;
                }
                if (codeIndex < codewords.length) code = codewords[codeIndex++];
                else throw FormatException.getFormatInstance();
            }
            if (result.length() === 0) throw FormatException.getFormatInstance();
            let decoderResult = new DecoderResult(null, result.toString(), null, ecLevel);
            decoderResult.setOther(resultMetadata);
            return decoderResult;
        }
        /**
         *
         * @param int
         * @param param1
         * @param codewords
         * @param int
         * @param codeIndex
         * @param PDF417ResultMetadata
         * @param resultMetadata
         *
         * @throws FormatException
         */ // @SuppressWarnings("deprecation")
        static decodeMacroBlock(codewords, codeIndex, resultMetadata) {
            if (codeIndex + DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS > codewords[0]) // we must have at least two bytes left for the segment index
            throw FormatException.getFormatInstance();
            let segmentIndexArray = new Int32Array(DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS);
            for(let i /*int*/  = 0; i < DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS; i++, codeIndex++)segmentIndexArray[i] = codewords[codeIndex];
            resultMetadata.setSegmentIndex(Integer.parseInt(DecodedBitStreamParser$2.decodeBase900toBase10(segmentIndexArray, DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS)));
            let fileId = new StringBuilder();
            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, fileId);
            resultMetadata.setFileId(fileId.toString());
            let optionalFieldsStart = -1;
            if (codewords[codeIndex] === DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD) optionalFieldsStart = codeIndex + 1;
            while(codeIndex < codewords[0])switch(codewords[codeIndex]){
                case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    codeIndex++;
                    switch(codewords[codeIndex]){
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                            let fileName = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, fileName);
                            resultMetadata.setFileName(fileName.toString());
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                            let sender = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, sender);
                            resultMetadata.setSender(sender.toString());
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                            let addressee = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, addressee);
                            resultMetadata.setAddressee(addressee.toString());
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                            let segmentCount = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, segmentCount);
                            resultMetadata.setSegmentCount(Integer.parseInt(segmentCount.toString()));
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                            let timestamp = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, timestamp);
                            resultMetadata.setTimestamp(Long.parseLong(timestamp.toString()));
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                            let checksum = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, checksum);
                            resultMetadata.setChecksum(Integer.parseInt(checksum.toString()));
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                            let fileSize = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, fileSize);
                            resultMetadata.setFileSize(Long.parseLong(fileSize.toString()));
                            break;
                        default:
                            throw FormatException.getFormatInstance();
                    }
                    break;
                case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                    codeIndex++;
                    resultMetadata.setLastSegment(true);
                    break;
                default:
                    throw FormatException.getFormatInstance();
            }
            // copy optional fields to additional options
            if (optionalFieldsStart !== -1) {
                let optionalFieldsLength = codeIndex - optionalFieldsStart;
                if (resultMetadata.isLastSegment()) // do not include terminator
                optionalFieldsLength--;
                resultMetadata.setOptionalData(Arrays.copyOfRange(codewords, optionalFieldsStart, optionalFieldsStart + optionalFieldsLength));
            }
            return codeIndex;
        }
        /**
         * Text Compaction mode (see 5.4.1.5) permits all printable ASCII characters to be
         * encoded, i.e. values 32 - 126 inclusive in accordance with ISO/IEC 646 (IRV), as
         * well as selected control characters.
         *
         * @param codewords The array of codewords (data + error)
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         */ static textCompaction(codewords, codeIndex, result) {
            // 2 character per codeword
            let textCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
            // Used to hold the byte compaction value if there is a mode shift
            let byteCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
            let index = 0;
            let end = false;
            while(codeIndex < codewords[0] && !end){
                let code = codewords[codeIndex++];
                if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                    textCompactionData[index] = code / 30;
                    textCompactionData[index + 1] = code % 30;
                    index += 2;
                } else switch(code){
                    case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                        // reinitialize text compaction mode to alpha sub mode
                        textCompactionData[index++] = DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH;
                        break;
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                    case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                        codeIndex--;
                        end = true;
                        break;
                    case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                        // The Mode Shift codeword 913 shall cause a temporary
                        // switch from Text Compaction mode to Byte Compaction mode.
                        // This switch shall be in effect for only the next codeword,
                        // after which the mode shall revert to the prevailing sub-mode
                        // of the Text Compaction mode. Codeword 913 is only available
                        // in Text Compaction mode; its use is described in 5.4.2.4.
                        textCompactionData[index] = DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE;
                        code = codewords[codeIndex++];
                        byteCompactionData[index] = code;
                        index++;
                        break;
                }
            }
            DecodedBitStreamParser$2.decodeTextCompaction(textCompactionData, byteCompactionData, index, result);
            return codeIndex;
        }
        /**
         * The Text Compaction mode includes all the printable ASCII characters
         * (i.e. values from 32 to 126) and three ASCII control characters: HT or tab
         * (9: e), LF or line feed (10: e), and CR or carriage
         * return (13: e). The Text Compaction mode also includes various latch
         * and shift characters which are used exclusively within the mode. The Text
         * Compaction mode encodes up to 2 characters per codeword. The compaction rules
         * for converting data into PDF417 codewords are defined in 5.4.2.2. The sub-mode
         * switches are defined in 5.4.2.3.
         *
         * @param textCompactionData The text compaction data.
         * @param byteCompactionData The byte compaction data if there
         *                           was a mode shift.
         * @param length             The size of the text compaction and byte compaction data.
         * @param result             The decoded data is appended to the result.
         */ static decodeTextCompaction(textCompactionData, byteCompactionData, length, result) {
            // Beginning from an initial state of the Alpha sub-mode
            // The default compaction mode for PDF417 in effect at the start of each symbol shall always be Text
            // Compaction mode Alpha sub-mode (alphabetic: uppercase). A latch codeword from another mode to the Text
            // Compaction mode shall always switch to the Text Compaction Alpha sub-mode.
            let subMode = Mode$2.ALPHA;
            let priorToShiftMode = Mode$2.ALPHA;
            let i = 0;
            while(i < length){
                let subModeCh = textCompactionData[i];
                let ch = /*char*/ '';
                switch(subMode){
                    case Mode$2.ALPHA:
                        // Alpha (alphabetic: uppercase)
                        if (subModeCh < 26) // Upper case Alpha Character
                        // Note: 65 = 'A' ASCII -> there is byte code of symbol
                        ch = /*(char)('A' + subModeCh) */ String.fromCharCode(65 + subModeCh);
                        else switch(subModeCh){
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.LL:
                                subMode = Mode$2.LOWER;
                                break;
                            case DecodedBitStreamParser$2.ML:
                                subMode = Mode$2.MIXED;
                                break;
                            case DecodedBitStreamParser$2.PS:
                                // Shift to punctuation
                                priorToShiftMode = subMode;
                                subMode = Mode$2.PUNCT_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.LOWER:
                        // Lower (alphabetic: lowercase)
                        if (subModeCh < 26) ch = /*(char)('a' + subModeCh)*/ String.fromCharCode(97 + subModeCh);
                        else switch(subModeCh){
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.AS:
                                // Shift to alpha
                                priorToShiftMode = subMode;
                                subMode = Mode$2.ALPHA_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.ML:
                                subMode = Mode$2.MIXED;
                                break;
                            case DecodedBitStreamParser$2.PS:
                                // Shift to punctuation
                                priorToShiftMode = subMode;
                                subMode = Mode$2.PUNCT_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                // TODO Does this need to use the current character encoding? See other occurrences below
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.MIXED:
                        // Mixed (punctuation: e)
                        if (subModeCh < DecodedBitStreamParser$2.PL) ch = DecodedBitStreamParser$2.MIXED_CHARS[subModeCh];
                        else switch(subModeCh){
                            case DecodedBitStreamParser$2.PL:
                                subMode = Mode$2.PUNCT;
                                break;
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.LL:
                                subMode = Mode$2.LOWER;
                                break;
                            case DecodedBitStreamParser$2.AL:
                                subMode = Mode$2.ALPHA;
                                break;
                            case DecodedBitStreamParser$2.PS:
                                // Shift to punctuation
                                priorToShiftMode = subMode;
                                subMode = Mode$2.PUNCT_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.PUNCT:
                        // Punctuation
                        if (subModeCh < DecodedBitStreamParser$2.PAL) ch = DecodedBitStreamParser$2.PUNCT_CHARS[subModeCh];
                        else switch(subModeCh){
                            case DecodedBitStreamParser$2.PAL:
                                subMode = Mode$2.ALPHA;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.ALPHA_SHIFT:
                        // Restore sub-mode
                        subMode = priorToShiftMode;
                        if (subModeCh < 26) ch = /*(char)('A' + subModeCh)*/ String.fromCharCode(65 + subModeCh);
                        else switch(subModeCh){
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.PUNCT_SHIFT:
                        // Restore sub-mode
                        subMode = priorToShiftMode;
                        if (subModeCh < DecodedBitStreamParser$2.PAL) ch = DecodedBitStreamParser$2.PUNCT_CHARS[subModeCh];
                        else switch(subModeCh){
                            case DecodedBitStreamParser$2.PAL:
                                subMode = Mode$2.ALPHA;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                // PS before Shift-to-Byte is used as a padding character,
                                // see 5.4.2.4 of the specification
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                }
                // if (ch !== 0) {
                if (ch !== '') // Append decoded character to result
                result.append(ch);
                i++;
            }
        }
        /**
         * Byte Compaction mode (see 5.4.3) permits all 256 possible 8-bit byte values to be encoded.
         * This includes all ASCII characters value 0 to 127 inclusive and provides for international
         * character set support.
         *
         * @param mode      The byte compaction mode i.e. 901 or 924
         * @param codewords The array of codewords (data + error)
         * @param encoding  Currently active character encoding
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         */ static byteCompaction(mode, codewords, encoding, codeIndex, result) {
            let decodedBytes = new ByteArrayOutputStream();
            let count = 0;
            let value = /*long*/ 0;
            let end = false;
            switch(mode){
                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    // Total number of Byte Compaction characters to be encoded
                    // is not a multiple of 6
                    let byteCompactedCodewords = new Int32Array(6);
                    let nextCode = codewords[codeIndex++];
                    while(codeIndex < codewords[0] && !end){
                        byteCompactedCodewords[count++] = nextCode;
                        // Base 900
                        value = 900 * value + nextCode;
                        nextCode = codewords[codeIndex++];
                        // perhaps it should be ok to check only nextCode >= TEXT_COMPACTION_MODE_LATCH
                        switch(nextCode){
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                            case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                                codeIndex--;
                                end = true;
                                break;
                            default:
                                if (count % 5 === 0 && count > 0) {
                                    // Decode every 5 codewords
                                    // Convert to Base 256
                                    for(let j /*int*/  = 0; j < 6; ++j)/* @note
                                         * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                                         * So the next bitwise operation could not be done with simple numbers
                                         */ decodedBytes.write(/*(byte)*/ Number(createBigInt(value) >> createBigInt(8 * (5 - j))));
                                    value = 0;
                                    count = 0;
                                }
                                break;
                        }
                    }
                    // if the end of all codewords is reached the last codeword needs to be added
                    if (codeIndex === codewords[0] && nextCode < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) byteCompactedCodewords[count++] = nextCode;
                    // If Byte Compaction mode is invoked with codeword 901,
                    // the last group of codewords is interpreted directly
                    // as one byte per codeword, without compaction.
                    for(let i /*int*/  = 0; i < count; i++)decodedBytes.write(/*(byte)*/ byteCompactedCodewords[i]);
                    break;
                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                    // Total number of Byte Compaction characters to be encoded
                    // is an integer multiple of 6
                    while(codeIndex < codewords[0] && !end){
                        let code = codewords[codeIndex++];
                        if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                            count++;
                            // Base 900
                            value = 900 * value + code;
                        } else switch(code){
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                            case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                                codeIndex--;
                                end = true;
                                break;
                        }
                        if (count % 5 === 0 && count > 0) {
                            // Decode every 5 codewords
                            // Convert to Base 256
                            /* @note
                             * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                             * So the next bitwise operation could not be done with simple numbers
                            */ for(let j /*int*/  = 0; j < 6; ++j)decodedBytes.write(/*(byte)*/ Number(createBigInt(value) >> createBigInt(8 * (5 - j))));
                            value = 0;
                            count = 0;
                        }
                    }
                    break;
            }
            result.append(StringEncoding.decode(decodedBytes.toByteArray(), encoding));
            return codeIndex;
        }
        /**
         * Numeric Compaction mode (see 5.4.4) permits efficient encoding of numeric data strings.
         *
         * @param codewords The array of codewords (data + error)
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         *
         * @throws FormatException
         */ static numericCompaction(codewords, codeIndex /*int*/ , result) {
            let count = 0;
            let end = false;
            let numericCodewords = new Int32Array(DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS);
            while(codeIndex < codewords[0] && !end){
                let code = codewords[codeIndex++];
                if (codeIndex === codewords[0]) end = true;
                if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                    numericCodewords[count] = code;
                    count++;
                } else switch(code){
                    case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                        codeIndex--;
                        end = true;
                        break;
                }
                if ((count % DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS === 0 || code === DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH || end) && count > 0) {
                    // Re-invoking Numeric Compaction mode (by using codeword 902
                    // while in Numeric Compaction mode) serves  to terminate the
                    // current Numeric Compaction mode grouping as described in 5.4.4.2,
                    // and then to start a new one grouping.
                    result.append(DecodedBitStreamParser$2.decodeBase900toBase10(numericCodewords, count));
                    count = 0;
                }
            }
            return codeIndex;
        }
        /**
         * Convert a list of Numeric Compacted codewords from Base 900 to Base 10.
         *
         * @param codewords The array of codewords
         * @param count     The number of codewords
         * @return The decoded string representing the Numeric data.
         *
         * EXAMPLE
         * Encode the fifteen digit numeric string 000213298174000
         * Prefix the numeric string with a 1 and set the initial value of
         * t = 1 000 213 298 174 000
         * Calculate codeword 0
         * d0 = 1 000 213 298 174 000 mod 900 = 200
         *
         * t = 1 000 213 298 174 000 div 900 = 1 111 348 109 082
         * Calculate codeword 1
         * d1 = 1 111 348 109 082 mod 900 = 282
         *
         * t = 1 111 348 109 082 div 900 = 1 234 831 232
         * Calculate codeword 2
         * d2 = 1 234 831 232 mod 900 = 632
         *
         * t = 1 234 831 232 div 900 = 1 372 034
         * Calculate codeword 3
         * d3 = 1 372 034 mod 900 = 434
         *
         * t = 1 372 034 div 900 = 1 524
         * Calculate codeword 4
         * d4 = 1 524 mod 900 = 624
         *
         * t = 1 524 div 900 = 1
         * Calculate codeword 5
         * d5 = 1 mod 900 = 1
         * t = 1 div 900 = 0
         * Codeword sequence is: 1, 624, 434, 632, 282, 200
         *
         * Decode the above codewords involves
         *   1 x 900 power of 5 + 624 x 900 power of 4 + 434 x 900 power of 3 +
         * 632 x 900 power of 2 + 282 x 900 power of 1 + 200 x 900 power of 0 = 1000213298174000
         *
         * Remove leading 1 =>  Result is 000213298174000
         *
         * @throws FormatException
         */ static decodeBase900toBase10(codewords, count) {
            let result = createBigInt(0);
            for(let i /*int*/  = 0; i < count; i++)result += DecodedBitStreamParser$2.EXP900[count - i - 1] * createBigInt(codewords[i]);
            let resultString = result.toString();
            if (resultString.charAt(0) !== '1') throw new FormatException();
            return resultString.substring(1);
        }
    }
    DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH = 900;
    DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH = 901;
    DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH = 902;
    DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6 = 924;
    DecodedBitStreamParser$2.ECI_USER_DEFINED = 925;
    DecodedBitStreamParser$2.ECI_GENERAL_PURPOSE = 926;
    DecodedBitStreamParser$2.ECI_CHARSET = 927;
    DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928;
    DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923;
    DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR = 922;
    DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913;
    DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS = 15;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6;
    DecodedBitStreamParser$2.PL = 25;
    DecodedBitStreamParser$2.LL = 27;
    DecodedBitStreamParser$2.AS = 27;
    DecodedBitStreamParser$2.ML = 28;
    DecodedBitStreamParser$2.AL = 28;
    DecodedBitStreamParser$2.PS = 29;
    DecodedBitStreamParser$2.PAL = 29;
    DecodedBitStreamParser$2.PUNCT_CHARS = ';<>@[\\]_`~!\r\t,:\n-.$/"|*()?{}\'';
    DecodedBitStreamParser$2.MIXED_CHARS = '0123456789&\r\t,:#-.$/+%*=^';
    /**
     * Table containing values for the exponent of 900.
     * This is used in the numeric compaction decode algorithm.
     */ DecodedBitStreamParser$2.EXP900 = getBigIntConstructor() ? getEXP900() : [];
    DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS = 2;
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ // import java.util.ArrayList;
    // import java.util.Collection;
    // import java.util.Formatter;
    // import java.util.List;
    /**
     * @author Guenther Grau
     */ /*public final*/ class PDF417ScanningDecoder {
        constructor(){}
        /**
         * @TODO don't pass in minCodewordWidth and maxCodewordWidth, pass in barcode columns for start and stop pattern
         *
         * columns. That way width can be deducted from the pattern column.
         * This approach also allows to detect more details about the barcode, e.g. if a bar type (white or black) is wider
         * than it should be. This can happen if the scanner used a bad blackpoint.
         *
         * @param BitMatrix
         * @param image
         * @param ResultPoint
         * @param imageTopLeft
         * @param ResultPoint
         * @param imageBottomLeft
         * @param ResultPoint
         * @param imageTopRight
         * @param ResultPoint
         * @param imageBottomRight
         * @param int
         * @param minCodewordWidth
         * @param int
         * @param maxCodewordWidth
         *
         * @throws NotFoundException
         * @throws FormatException
         * @throws ChecksumException
         */ static decode(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight, minCodewordWidth, maxCodewordWidth) {
            let boundingBox = new BoundingBox(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight);
            let leftRowIndicatorColumn = null;
            let rightRowIndicatorColumn = null;
            let detectionResult;
            for(let firstPass /*boolean*/  = true;; firstPass = false){
                if (imageTopLeft != null) leftRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopLeft, true, minCodewordWidth, maxCodewordWidth);
                if (imageTopRight != null) rightRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopRight, false, minCodewordWidth, maxCodewordWidth);
                detectionResult = PDF417ScanningDecoder.merge(leftRowIndicatorColumn, rightRowIndicatorColumn);
                if (detectionResult == null) throw NotFoundException.getNotFoundInstance();
                let resultBox = detectionResult.getBoundingBox();
                if (firstPass && resultBox != null && (resultBox.getMinY() < boundingBox.getMinY() || resultBox.getMaxY() > boundingBox.getMaxY())) boundingBox = resultBox;
                else break;
            }
            detectionResult.setBoundingBox(boundingBox);
            let maxBarcodeColumn = detectionResult.getBarcodeColumnCount() + 1;
            detectionResult.setDetectionResultColumn(0, leftRowIndicatorColumn);
            detectionResult.setDetectionResultColumn(maxBarcodeColumn, rightRowIndicatorColumn);
            let leftToRight = leftRowIndicatorColumn != null;
            for(let barcodeColumnCount /*int*/  = 1; barcodeColumnCount <= maxBarcodeColumn; barcodeColumnCount++){
                let barcodeColumn = leftToRight ? barcodeColumnCount : maxBarcodeColumn - barcodeColumnCount;
                if (detectionResult.getDetectionResultColumn(barcodeColumn) !== /* null */ undefined) continue;
                let detectionResultColumn;
                if (barcodeColumn === 0 || barcodeColumn === maxBarcodeColumn) detectionResultColumn = new DetectionResultRowIndicatorColumn(boundingBox, barcodeColumn === 0);
                else detectionResultColumn = new DetectionResultColumn(boundingBox);
                detectionResult.setDetectionResultColumn(barcodeColumn, detectionResultColumn);
                let startColumn = -1;
                let previousStartColumn = startColumn;
                // TODO start at a row for which we know the start position, then detect upwards and downwards from there.
                for(let imageRow /*int*/  = boundingBox.getMinY(); imageRow <= boundingBox.getMaxY(); imageRow++){
                    startColumn = PDF417ScanningDecoder.getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight);
                    if (startColumn < 0 || startColumn > boundingBox.getMaxX()) {
                        if (previousStartColumn === -1) continue;
                        startColumn = previousStartColumn;
                    }
                    let codeword = PDF417ScanningDecoder.detectCodeword(image, boundingBox.getMinX(), boundingBox.getMaxX(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                    if (codeword != null) {
                        detectionResultColumn.setCodeword(imageRow, codeword);
                        previousStartColumn = startColumn;
                        minCodewordWidth = Math.min(minCodewordWidth, codeword.getWidth());
                        maxCodewordWidth = Math.max(maxCodewordWidth, codeword.getWidth());
                    }
                }
            }
            return PDF417ScanningDecoder.createDecoderResult(detectionResult);
        }
        /**
         *
         * @param leftRowIndicatorColumn
         * @param rightRowIndicatorColumn
         *
         * @throws NotFoundException
         */ static merge(leftRowIndicatorColumn, rightRowIndicatorColumn) {
            if (leftRowIndicatorColumn == null && rightRowIndicatorColumn == null) return null;
            let barcodeMetadata = PDF417ScanningDecoder.getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn);
            if (barcodeMetadata == null) return null;
            let boundingBox = BoundingBox.merge(PDF417ScanningDecoder.adjustBoundingBox(leftRowIndicatorColumn), PDF417ScanningDecoder.adjustBoundingBox(rightRowIndicatorColumn));
            return new DetectionResult(barcodeMetadata, boundingBox);
        }
        /**
         *
         * @param rowIndicatorColumn
         *
         * @throws NotFoundException
         */ static adjustBoundingBox(rowIndicatorColumn) {
            if (rowIndicatorColumn == null) return null;
            let rowHeights = rowIndicatorColumn.getRowHeights();
            if (rowHeights == null) return null;
            let maxRowHeight = PDF417ScanningDecoder.getMax(rowHeights);
            let missingStartRows = 0;
            for (let rowHeight /*int*/  of rowHeights){
                missingStartRows += maxRowHeight - rowHeight;
                if (rowHeight > 0) break;
            }
            let codewords = rowIndicatorColumn.getCodewords();
            for(let row /*int*/  = 0; missingStartRows > 0 && codewords[row] == null; row++)missingStartRows--;
            let missingEndRows = 0;
            for(let row /*int*/  = rowHeights.length - 1; row >= 0; row--){
                missingEndRows += maxRowHeight - rowHeights[row];
                if (rowHeights[row] > 0) break;
            }
            for(let row /*int*/  = codewords.length - 1; missingEndRows > 0 && codewords[row] == null; row--)missingEndRows--;
            return rowIndicatorColumn.getBoundingBox().addMissingRows(missingStartRows, missingEndRows, rowIndicatorColumn.isLeft());
        }
        static getMax(values) {
            let maxValue = -1;
            for (let value /*int*/  of values)maxValue = Math.max(maxValue, value);
            return maxValue;
        }
        static getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn) {
            let leftBarcodeMetadata;
            if (leftRowIndicatorColumn == null || (leftBarcodeMetadata = leftRowIndicatorColumn.getBarcodeMetadata()) == null) return rightRowIndicatorColumn == null ? null : rightRowIndicatorColumn.getBarcodeMetadata();
            let rightBarcodeMetadata;
            if (rightRowIndicatorColumn == null || (rightBarcodeMetadata = rightRowIndicatorColumn.getBarcodeMetadata()) == null) return leftBarcodeMetadata;
            if (leftBarcodeMetadata.getColumnCount() !== rightBarcodeMetadata.getColumnCount() && leftBarcodeMetadata.getErrorCorrectionLevel() !== rightBarcodeMetadata.getErrorCorrectionLevel() && leftBarcodeMetadata.getRowCount() !== rightBarcodeMetadata.getRowCount()) return null;
            return leftBarcodeMetadata;
        }
        static getRowIndicatorColumn(image, boundingBox, startPoint, leftToRight, minCodewordWidth, maxCodewordWidth) {
            let rowIndicatorColumn = new DetectionResultRowIndicatorColumn(boundingBox, leftToRight);
            for(let i /*int*/  = 0; i < 2; i++){
                let increment = i === 0 ? 1 : -1;
                let startColumn = Math.trunc(Math.trunc(startPoint.getX()));
                for(let imageRow /*int*/  = Math.trunc(Math.trunc(startPoint.getY())); imageRow <= boundingBox.getMaxY() && imageRow >= boundingBox.getMinY(); imageRow += increment){
                    let codeword = PDF417ScanningDecoder.detectCodeword(image, 0, image.getWidth(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                    if (codeword != null) {
                        rowIndicatorColumn.setCodeword(imageRow, codeword);
                        if (leftToRight) startColumn = codeword.getStartX();
                        else startColumn = codeword.getEndX();
                    }
                }
            }
            return rowIndicatorColumn;
        }
        /**
         *
         * @param detectionResult
         * @param BarcodeValue
         * @param param2
         * @param param3
         * @param barcodeMatrix
         *
         * @throws NotFoundException
         */ static adjustCodewordCount(detectionResult, barcodeMatrix) {
            let barcodeMatrix01 = barcodeMatrix[0][1];
            let numberOfCodewords = barcodeMatrix01.getValue();
            let calculatedNumberOfCodewords = detectionResult.getBarcodeColumnCount() * detectionResult.getBarcodeRowCount() - PDF417ScanningDecoder.getNumberOfECCodeWords(detectionResult.getBarcodeECLevel());
            if (numberOfCodewords.length === 0) {
                if (calculatedNumberOfCodewords < 1 || calculatedNumberOfCodewords > PDF417Common.MAX_CODEWORDS_IN_BARCODE) throw NotFoundException.getNotFoundInstance();
                barcodeMatrix01.setValue(calculatedNumberOfCodewords);
            } else if (numberOfCodewords[0] !== calculatedNumberOfCodewords) // The calculated one is more reliable as it is derived from the row indicator columns
            barcodeMatrix01.setValue(calculatedNumberOfCodewords);
        }
        /**
         *
         * @param detectionResult
         *
         * @throws FormatException
         * @throws ChecksumException
         * @throws NotFoundException
         */ static createDecoderResult(detectionResult) {
            let barcodeMatrix = PDF417ScanningDecoder.createBarcodeMatrix(detectionResult);
            PDF417ScanningDecoder.adjustCodewordCount(detectionResult, barcodeMatrix);
            let erasures /*Collection<Integer>*/  = new Array();
            let codewords = new Int32Array(detectionResult.getBarcodeRowCount() * detectionResult.getBarcodeColumnCount());
            let ambiguousIndexValuesList = /*List<int[]>*/ [];
            let ambiguousIndexesList = /*Collection<Integer>*/ new Array();
            for(let row /*int*/  = 0; row < detectionResult.getBarcodeRowCount(); row++)for(let column /*int*/  = 0; column < detectionResult.getBarcodeColumnCount(); column++){
                let values = barcodeMatrix[row][column + 1].getValue();
                let codewordIndex = row * detectionResult.getBarcodeColumnCount() + column;
                if (values.length === 0) erasures.push(codewordIndex);
                else if (values.length === 1) codewords[codewordIndex] = values[0];
                else {
                    ambiguousIndexesList.push(codewordIndex);
                    ambiguousIndexValuesList.push(values);
                }
            }
            let ambiguousIndexValues = new Array(ambiguousIndexValuesList.length);
            for(let i /*int*/  = 0; i < ambiguousIndexValues.length; i++)ambiguousIndexValues[i] = ambiguousIndexValuesList[i];
            return PDF417ScanningDecoder.createDecoderResultFromAmbiguousValues(detectionResult.getBarcodeECLevel(), codewords, PDF417Common.toIntArray(erasures), PDF417Common.toIntArray(ambiguousIndexesList), ambiguousIndexValues);
        }
        /**
         * This method deals with the fact, that the decoding process doesn't always yield a single most likely value. The
         * current error correction implementation doesn't deal with erasures very well, so it's better to provide a value
         * for these ambiguous codewords instead of treating it as an erasure. The problem is that we don't know which of
         * the ambiguous values to choose. We try decode using the first value, and if that fails, we use another of the
         * ambiguous values and try to decode again. This usually only happens on very hard to read and decode barcodes,
         * so decoding the normal barcodes is not affected by this.
         *
         * @param erasureArray contains the indexes of erasures
         * @param ambiguousIndexes array with the indexes that have more than one most likely value
         * @param ambiguousIndexValues two dimensional array that contains the ambiguous values. The first dimension must
         * be the same length as the ambiguousIndexes array
         *
         * @throws FormatException
         * @throws ChecksumException
         */ static createDecoderResultFromAmbiguousValues(ecLevel, codewords, erasureArray, ambiguousIndexes, ambiguousIndexValues) {
            let ambiguousIndexCount = new Int32Array(ambiguousIndexes.length);
            let tries = 100;
            while(tries-- > 0){
                for(let i /*int*/  = 0; i < ambiguousIndexCount.length; i++)codewords[ambiguousIndexes[i]] = ambiguousIndexValues[i][ambiguousIndexCount[i]];
                try {
                    return PDF417ScanningDecoder.decodeCodewords(codewords, ecLevel, erasureArray);
                } catch (err) {
                    let ignored = err instanceof ChecksumException;
                    if (!ignored) throw err;
                }
                if (ambiguousIndexCount.length === 0) throw ChecksumException.getChecksumInstance();
                for(let i /*int*/  = 0; i < ambiguousIndexCount.length; i++)if (ambiguousIndexCount[i] < ambiguousIndexValues[i].length - 1) {
                    ambiguousIndexCount[i]++;
                    break;
                } else {
                    ambiguousIndexCount[i] = 0;
                    if (i === ambiguousIndexCount.length - 1) throw ChecksumException.getChecksumInstance();
                }
            }
            throw ChecksumException.getChecksumInstance();
        }
        static createBarcodeMatrix(detectionResult) {
            // let barcodeMatrix: BarcodeValue[][] =
            // new BarcodeValue[detectionResult.getBarcodeRowCount()][detectionResult.getBarcodeColumnCount() + 2];
            let barcodeMatrix = Array.from({
                length: detectionResult.getBarcodeRowCount()
            }, ()=>new Array(detectionResult.getBarcodeColumnCount() + 2));
            for(let row /*int*/  = 0; row < barcodeMatrix.length; row++)for(let column /*int*/  = 0; column < barcodeMatrix[row].length; column++)barcodeMatrix[row][column] = new BarcodeValue();
            let column = 0;
            for (let detectionResultColumn /*DetectionResultColumn*/  of detectionResult.getDetectionResultColumns()){
                if (detectionResultColumn != null) {
                    for (let codeword /*Codeword*/  of detectionResultColumn.getCodewords())if (codeword != null) {
                        let rowNumber = codeword.getRowNumber();
                        if (rowNumber >= 0) {
                            if (rowNumber >= barcodeMatrix.length) continue;
                            barcodeMatrix[rowNumber][column].setValue(codeword.getValue());
                        }
                    }
                }
                column++;
            }
            return barcodeMatrix;
        }
        static isValidBarcodeColumn(detectionResult, barcodeColumn) {
            return barcodeColumn >= 0 && barcodeColumn <= detectionResult.getBarcodeColumnCount() + 1;
        }
        static getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight) {
            let offset = leftToRight ? 1 : -1;
            let codeword = null;
            if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodeword(imageRow);
            if (codeword != null) return leftToRight ? codeword.getEndX() : codeword.getStartX();
            codeword = detectionResult.getDetectionResultColumn(barcodeColumn).getCodewordNearby(imageRow);
            if (codeword != null) return leftToRight ? codeword.getStartX() : codeword.getEndX();
            if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodewordNearby(imageRow);
            if (codeword != null) return leftToRight ? codeword.getEndX() : codeword.getStartX();
            let skippedColumns = 0;
            while(PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)){
                barcodeColumn -= offset;
                for (let previousRowCodeword /*Codeword*/  of detectionResult.getDetectionResultColumn(barcodeColumn).getCodewords()){
                    if (previousRowCodeword != null) return (leftToRight ? previousRowCodeword.getEndX() : previousRowCodeword.getStartX()) + offset * skippedColumns * (previousRowCodeword.getEndX() - previousRowCodeword.getStartX());
                }
                skippedColumns++;
            }
            return leftToRight ? detectionResult.getBoundingBox().getMinX() : detectionResult.getBoundingBox().getMaxX();
        }
        static detectCodeword(image, minColumn, maxColumn, leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth) {
            startColumn = PDF417ScanningDecoder.adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
            // we usually know fairly exact now how long a codeword is. We should provide minimum and maximum expected length
            // and try to adjust the read pixels, e.g. remove single pixel errors or try to cut off exceeding pixels.
            // min and maxCodewordWidth should not be used as they are calculated for the whole barcode an can be inaccurate
            // for the current position
            let moduleBitCount = PDF417ScanningDecoder.getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
            if (moduleBitCount == null) return null;
            let endColumn;
            let codewordBitCount = MathUtils.sum(moduleBitCount);
            if (leftToRight) endColumn = startColumn + codewordBitCount;
            else {
                for(let i /*int*/  = 0; i < moduleBitCount.length / 2; i++){
                    let tmpCount = moduleBitCount[i];
                    moduleBitCount[i] = moduleBitCount[moduleBitCount.length - 1 - i];
                    moduleBitCount[moduleBitCount.length - 1 - i] = tmpCount;
                }
                endColumn = startColumn;
                startColumn = endColumn - codewordBitCount;
            }
            // TODO implement check for width and correction of black and white bars
            // use start (and maybe stop pattern) to determine if black bars are wider than white bars. If so, adjust.
            // should probably done only for codewords with a lot more than 17 bits.
            // The following fixes 10-1.png, which has wide black bars and small white bars
            //    for (let i /*int*/ = 0; i < moduleBitCount.length; i++) {
            //      if (i % 2 === 0) {
            //        moduleBitCount[i]--;
            //      } else {
            //        moduleBitCount[i]++;
            //      }
            //    }
            // We could also use the width of surrounding codewords for more accurate results, but this seems
            // sufficient for now
            if (!PDF417ScanningDecoder.checkCodewordSkew(codewordBitCount, minCodewordWidth, maxCodewordWidth)) // We could try to use the startX and endX position of the codeword in the same column in the previous row,
            // create the bit count from it and normalize it to 8. This would help with single pixel errors.
            return null;
            let decodedValue = PDF417CodewordDecoder.getDecodedValue(moduleBitCount);
            let codeword = PDF417Common.getCodeword(decodedValue);
            if (codeword === -1) return null;
            return new Codeword(startColumn, endColumn, PDF417ScanningDecoder.getCodewordBucketNumber(decodedValue), codeword);
        }
        static getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow) {
            let imageColumn = startColumn;
            let moduleBitCount = new Int32Array(8);
            let moduleNumber = 0;
            let increment = leftToRight ? 1 : -1;
            let previousPixelValue = leftToRight;
            while((leftToRight ? imageColumn < maxColumn : imageColumn >= minColumn) && moduleNumber < moduleBitCount.length)if (image.get(imageColumn, imageRow) === previousPixelValue) {
                moduleBitCount[moduleNumber]++;
                imageColumn += increment;
            } else {
                moduleNumber++;
                previousPixelValue = !previousPixelValue;
            }
            if (moduleNumber === moduleBitCount.length || imageColumn === (leftToRight ? maxColumn : minColumn) && moduleNumber === moduleBitCount.length - 1) return moduleBitCount;
            return null;
        }
        static getNumberOfECCodeWords(barcodeECLevel) {
            return 2 << barcodeECLevel;
        }
        static adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, codewordStartColumn, imageRow) {
            let correctedStartColumn = codewordStartColumn;
            let increment = leftToRight ? -1 : 1;
            // there should be no black pixels before the start column. If there are, then we need to start earlier.
            for(let i /*int*/  = 0; i < 2; i++){
                while((leftToRight ? correctedStartColumn >= minColumn : correctedStartColumn < maxColumn) && leftToRight === image.get(correctedStartColumn, imageRow)){
                    if (Math.abs(codewordStartColumn - correctedStartColumn) > PDF417ScanningDecoder.CODEWORD_SKEW_SIZE) return codewordStartColumn;
                    correctedStartColumn += increment;
                }
                increment = -increment;
                leftToRight = !leftToRight;
            }
            return correctedStartColumn;
        }
        static checkCodewordSkew(codewordSize, minCodewordWidth, maxCodewordWidth) {
            return minCodewordWidth - PDF417ScanningDecoder.CODEWORD_SKEW_SIZE <= codewordSize && codewordSize <= maxCodewordWidth + PDF417ScanningDecoder.CODEWORD_SKEW_SIZE;
        }
        /**
         * @throws FormatException,
         * @throws ChecksumException
         */ static decodeCodewords(codewords, ecLevel, erasures) {
            if (codewords.length === 0) throw FormatException.getFormatInstance();
            let numECCodewords = 1 << ecLevel + 1;
            let correctedErrorsCount = PDF417ScanningDecoder.correctErrors(codewords, erasures, numECCodewords);
            PDF417ScanningDecoder.verifyCodewordCount(codewords, numECCodewords);
            // Decode the codewords
            let decoderResult = DecodedBitStreamParser$2.decode(codewords, '' + ecLevel);
            decoderResult.setErrorsCorrected(correctedErrorsCount);
            decoderResult.setErasures(erasures.length);
            return decoderResult;
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place.</p>
         *
         * @param codewords   data and error correction codewords
         * @param erasures positions of any known erasures
         * @param numECCodewords number of error correction codewords that are available in codewords
         * @throws ChecksumException if error correction fails
         */ static correctErrors(codewords, erasures, numECCodewords) {
            if (erasures != null && erasures.length > numECCodewords / 2 + PDF417ScanningDecoder.MAX_ERRORS || numECCodewords < 0 || numECCodewords > PDF417ScanningDecoder.MAX_EC_CODEWORDS) // Too many errors or EC Codewords is corrupted
            throw ChecksumException.getChecksumInstance();
            return PDF417ScanningDecoder.errorCorrection.decode(codewords, numECCodewords, erasures);
        }
        /**
         * Verify that all is OK with the codeword array.
         * @throws FormatException
         */ static verifyCodewordCount(codewords, numECCodewords) {
            if (codewords.length < 4) // Codeword array size should be at least 4 allowing for
            // Count CW, At least one Data CW, Error Correction CW, Error Correction CW
            throw FormatException.getFormatInstance();
            // The first codeword, the Symbol Length Descriptor, shall always encode the total number of data
            // codewords in the symbol, including the Symbol Length Descriptor itself, data codewords and pad
            // codewords, but excluding the number of error correction codewords.
            let numberOfCodewords = codewords[0];
            if (numberOfCodewords > codewords.length) throw FormatException.getFormatInstance();
            if (numberOfCodewords === 0) {
                // Reset to the length of the array - 8 (Allow for at least level 3 Error Correction (8 Error Codewords)
                if (numECCodewords < codewords.length) codewords[0] = codewords.length - numECCodewords;
                else throw FormatException.getFormatInstance();
            }
        }
        static getBitCountForCodeword(codeword) {
            let result = new Int32Array(8);
            let previousValue = 0;
            let i = result.length - 1;
            while(true){
                if ((codeword & 0x1) !== previousValue) {
                    previousValue = codeword & 0x1;
                    i--;
                    if (i < 0) break;
                }
                result[i]++;
                codeword >>= 1;
            }
            return result;
        }
        static getCodewordBucketNumber(codeword) {
            if (codeword instanceof Int32Array) return this.getCodewordBucketNumber_Int32Array(codeword);
            return this.getCodewordBucketNumber_number(codeword);
        }
        static getCodewordBucketNumber_number(codeword) {
            return PDF417ScanningDecoder.getCodewordBucketNumber(PDF417ScanningDecoder.getBitCountForCodeword(codeword));
        }
        static getCodewordBucketNumber_Int32Array(moduleBitCount) {
            return (moduleBitCount[0] - moduleBitCount[2] + moduleBitCount[4] - moduleBitCount[6] + 9) % 9;
        }
        static toString(barcodeMatrix) {
            let formatter = new Formatter();
            // try (let formatter = new Formatter()) {
            for(let row /*int*/  = 0; row < barcodeMatrix.length; row++){
                formatter.format('Row %2d: ', row);
                for(let column /*int*/  = 0; column < barcodeMatrix[row].length; column++){
                    let barcodeValue = barcodeMatrix[row][column];
                    if (barcodeValue.getValue().length === 0) formatter.format('        ', null);
                    else formatter.format('%4d(%2d)', barcodeValue.getValue()[0], barcodeValue.getConfidence(barcodeValue.getValue()[0]));
                }
                formatter.format('%n');
            }
            return formatter.toString();
        // }
        }
    }
    /*final*/ PDF417ScanningDecoder.CODEWORD_SKEW_SIZE = 2;
    /*final*/ PDF417ScanningDecoder.MAX_ERRORS = 3;
    /*final*/ PDF417ScanningDecoder.MAX_EC_CODEWORDS = 512;
    /*final*/ PDF417ScanningDecoder.errorCorrection = new ErrorCorrection();
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.ArrayList;
    // import java.util.List;
    // import java.util.Map;
    /**
     * This implementation can detect and decode PDF417 codes in an image.
     *
     * @author Guenther Grau
     */ /*public final*/ class PDF417Reader {
        // private static /*final Result[]*/ EMPTY_RESULT_ARRAY: Result[] = new Result([0]);
        /**
         * Locates and decodes a PDF417 code in an image.
         *
         * @return a String representing the content encoded by the PDF417 code
         * @throws NotFoundException if a PDF417 code cannot be found,
         * @throws FormatException if a PDF417 cannot be decoded
         * @throws ChecksumException
         */ // @Override
        decode(image, hints = null) {
            let result = PDF417Reader.decode(image, hints, false);
            if (result == null || result.length === 0 || result[0] == null) throw NotFoundException.getNotFoundInstance();
            return result[0];
        }
        /**
         *
         * @param BinaryBitmap
         * @param image
         * @throws NotFoundException
         */ //   @Override
        decodeMultiple(image, hints = null) {
            try {
                return PDF417Reader.decode(image, hints, true);
            } catch (ignored) {
                if (ignored instanceof FormatException || ignored instanceof ChecksumException) throw NotFoundException.getNotFoundInstance();
                throw ignored;
            }
        }
        /**
         *
         * @param image
         * @param hints
         * @param multiple
         *
         * @throws NotFoundException
         * @throws FormatExceptionß
         * @throws ChecksumException
         */ static decode(image, hints, multiple) {
            const results = new Array();
            const detectorResult = Detector$3.detectMultiple(image, hints, multiple);
            for (const points of detectorResult.getPoints()){
                const decoderResult = PDF417ScanningDecoder.decode(detectorResult.getBits(), points[4], points[5], points[6], points[7], PDF417Reader.getMinCodewordWidth(points), PDF417Reader.getMaxCodewordWidth(points));
                const result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, BarcodeFormat$1.PDF_417);
                result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, decoderResult.getECLevel());
                const pdf417ResultMetadata = decoderResult.getOther();
                if (pdf417ResultMetadata != null) result.putMetadata(ResultMetadataType$1.PDF417_EXTRA_METADATA, pdf417ResultMetadata);
                results.push(result);
            }
            return results.map((x)=>x);
        }
        static getMaxWidth(p1, p2) {
            if (p1 == null || p2 == null) return 0;
            return Math.trunc(Math.abs(p1.getX() - p2.getX()));
        }
        static getMinWidth(p1, p2) {
            if (p1 == null || p2 == null) return Integer.MAX_VALUE;
            return Math.trunc(Math.abs(p1.getX() - p2.getX()));
        }
        static getMaxCodewordWidth(p) {
            return Math.floor(Math.max(Math.max(PDF417Reader.getMaxWidth(p[0], p[4]), PDF417Reader.getMaxWidth(p[6], p[2]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN), Math.max(PDF417Reader.getMaxWidth(p[1], p[5]), PDF417Reader.getMaxWidth(p[7], p[3]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN)));
        }
        static getMinCodewordWidth(p) {
            return Math.floor(Math.min(Math.min(PDF417Reader.getMinWidth(p[0], p[4]), PDF417Reader.getMinWidth(p[6], p[2]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN), Math.min(PDF417Reader.getMinWidth(p[1], p[5]), PDF417Reader.getMinWidth(p[7], p[3]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN)));
        }
        // @Override
        reset() {
        // nothing needs to be reset
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class ReaderException extends Exception {
    }
    ReaderException.kind = 'ReaderException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * MultiFormatReader is a convenience class and the main entry point into the library for most uses.
     * By default it attempts to decode all barcode formats that the library supports. Optionally, you
     * can provide a hints object to request different behavior, for example only decoding QR codes.
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     */ class MultiFormatReader {
        /**
         * Creates an instance of this class
         * 
         * @param {Boolean} verbose if 'true' logs will be dumped to console, otherwise hidden.
         * @param hints The hints to use, clearing the previous state.
         */ constructor(verbose, hints){
            this.verbose = verbose === true;
            if (hints) this.setHints(hints);
        }
        /**
         * This version of decode honors the intent of Reader.decode(BinaryBitmap) in that it
         * passes null as a hint to the decoders. However, that makes it inefficient to call repeatedly.
         * Use setHints() followed by decodeWithState() for continuous scan applications.
         *
         * @param image The pixel data to decode
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */ /*@Override*/ // public decode(image: BinaryBitmap): Result {
        //   setHints(null)
        //   return decodeInternal(image)
        // }
        /**
         * Decode an image using the hints provided. Does not honor existing state.
         *
         * @param image The pixel data to decode
         * @param hints The hints to use, clearing the previous state.
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */ /*@Override*/ decode(image, hints) {
            if (hints) this.setHints(hints);
            return this.decodeInternal(image);
        }
        /**
         * Decode an image using the state set up by calling setHints() previously. Continuous scan
         * clients will get a <b>large</b> speed increase by using this instead of decode().
         *
         * @param image The pixel data to decode
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */ decodeWithState(image) {
            // Make sure to set up the default state so we don't crash
            if (this.readers === null || this.readers === undefined) this.setHints(null);
            return this.decodeInternal(image);
        }
        /**
         * This method adds state to the MultiFormatReader. By setting the hints once, subsequent calls
         * to decodeWithState(image) can reuse the same set of readers without reallocating memory. This
         * is important for performance in continuous scan clients.
         *
         * @param hints The set of hints to use for subsequent calls to decode(image)
         */ setHints(hints) {
            this.hints = hints;
            const tryHarder = !isNullOrUndefined(hints) && hints.get(DecodeHintType$1.TRY_HARDER) === true;
            const formats = isNullOrUndefined(hints) ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            const readers = new Array();
            if (!isNullOrUndefined(formats)) {
                const addOneDReader = formats.some((f)=>{
                    return f === BarcodeFormat$1.UPC_A || f === BarcodeFormat$1.UPC_E || f === BarcodeFormat$1.EAN_13 || f === BarcodeFormat$1.EAN_8 || f === BarcodeFormat$1.CODABAR || f === BarcodeFormat$1.CODE_39 || f === BarcodeFormat$1.CODE_93 || f === BarcodeFormat$1.CODE_128 || f === BarcodeFormat$1.ITF || f === BarcodeFormat$1.RSS_14 || f === BarcodeFormat$1.RSS_EXPANDED;
                });
                // Put 1D readers upfront in "normal" mode
                if (addOneDReader && !tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
                if (formats.includes(BarcodeFormat$1.QR_CODE)) readers.push(new QRCodeReader());
                if (formats.includes(BarcodeFormat$1.DATA_MATRIX)) readers.push(new DataMatrixReader());
                if (formats.includes(BarcodeFormat$1.AZTEC)) readers.push(new AztecReader());
                if (formats.includes(BarcodeFormat$1.PDF_417)) readers.push(new PDF417Reader());
                // if (formats.includes(BarcodeFormat.MAXICODE)) {
                //    readers.push(new MaxiCodeReader())
                // }
                // At end in "try harder" mode
                if (addOneDReader && tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
            }
            if (readers.length === 0) {
                if (!tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
                readers.push(new QRCodeReader());
                readers.push(new DataMatrixReader());
                readers.push(new AztecReader());
                readers.push(new PDF417Reader());
                // readers.push(new MaxiCodeReader())
                if (tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
            }
            this.readers = readers; // .toArray(new Reader[readers.size()])
        }
        /*@Override*/ reset() {
            if (this.readers !== null) for (const reader of this.readers)reader.reset();
        }
        /**
         * @throws NotFoundException
         */ decodeInternal(image) {
            if (this.readers === null) throw new ReaderException('No readers where selected, nothing can be read.');
            for (const reader of this.readers)// Trying to decode with ${reader} reader.
            try {
                return reader.decode(image, this.hints);
            } catch (ex) {
                if (ex instanceof ReaderException) continue;
            // Bad Exception.
            }
            throw new NotFoundException('No MultiFormat Readers were able to detect the code.');
        }
    }
    class BrowserMultiFormatReader extends BrowserCodeReader {
        constructor(hints = null, timeBetweenScansMillis = 500){
            const reader = new MultiFormatReader();
            reader.setHints(hints);
            super(reader, timeBetweenScansMillis);
        }
        /**
         * Overwrite decodeBitmap to call decodeWithState, which will pay
         * attention to the hints set in the constructor function
         */ decodeBitmap(binaryBitmap) {
            return this.reader.decodeWithState(binaryBitmap);
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */ class BrowserPDF417Reader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserPDF417Reader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */ constructor(timeBetweenScansMillis = 500){
            super(new PDF417Reader(), timeBetweenScansMillis);
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */ class BrowserQRCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserQRCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */ constructor(timeBetweenScansMillis = 500){
            super(new QRCodeReader(), timeBetweenScansMillis);
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * These are a set of hints that you may pass to Writers to specify their behavior.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ var EncodeHintType;
    (function(EncodeHintType) {
        /**
         * Specifies what degree of error correction to use, for example in QR Codes.
         * Type depends on the encoder. For example for QR codes it's type
         * {@link com.google.zxing.qrcode.decoder.ErrorCorrectionLevel ErrorCorrectionLevel}.
         * For Aztec it is of type {@link Integer}, representing the minimal percentage of error correction words.
         * For PDF417 it is of type {@link Integer}, valid values being 0 to 8.
         * In all cases, it can also be a {@link String} representation of the desired value as well.
         * Note: an Aztec symbol should have a minimum of 25% EC words.
         */ EncodeHintType[EncodeHintType["ERROR_CORRECTION"] = 0] = "ERROR_CORRECTION";
        /**
         * Specifies what character encoding to use where applicable (type {@link String})
         */ EncodeHintType[EncodeHintType["CHARACTER_SET"] = 1] = "CHARACTER_SET";
        /**
         * Specifies the matrix shape for Data Matrix (type {@link com.google.zxing.datamatrix.encoder.SymbolShapeHint})
         */ EncodeHintType[EncodeHintType["DATA_MATRIX_SHAPE"] = 2] = "DATA_MATRIX_SHAPE";
        /**
         * Specifies a minimum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
         *
         * @deprecated use width/height params in
         * {@link com.google.zxing.datamatrix.DataMatrixWriter#encode(String, BarcodeFormat, int, int)}
         */ /*@Deprecated*/ EncodeHintType[EncodeHintType["MIN_SIZE"] = 3] = "MIN_SIZE";
        /**
         * Specifies a maximum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
         *
         * @deprecated without replacement
         */ /*@Deprecated*/ EncodeHintType[EncodeHintType["MAX_SIZE"] = 4] = "MAX_SIZE";
        /**
         * Specifies margin, in pixels, to use when generating the barcode. The meaning can vary
         * by format; for example it controls margin before and after the barcode horizontally for
         * most 1D formats. (Type {@link Integer}, or {@link String} representation of the integer value).
         */ EncodeHintType[EncodeHintType["MARGIN"] = 5] = "MARGIN";
        /**
         * Specifies whether to use compact mode for PDF417 (type {@link Boolean}, or "true" or "false"
         * {@link String} value).
         */ EncodeHintType[EncodeHintType["PDF417_COMPACT"] = 6] = "PDF417_COMPACT";
        /**
         * Specifies what compaction mode to use for PDF417 (type
         * {@link com.google.zxing.pdf417.encoder.Compaction Compaction} or {@link String} value of one of its
         * enum values).
         */ EncodeHintType[EncodeHintType["PDF417_COMPACTION"] = 7] = "PDF417_COMPACTION";
        /**
         * Specifies the minimum and maximum number of rows and columns for PDF417 (type
         * {@link com.google.zxing.pdf417.encoder.Dimensions Dimensions}).
         */ EncodeHintType[EncodeHintType["PDF417_DIMENSIONS"] = 8] = "PDF417_DIMENSIONS";
        /**
         * Specifies the required number of layers for an Aztec code.
         * A negative number (-1, -2, -3, -4) specifies a compact Aztec code.
         * 0 indicates to use the minimum number of layers (the default).
         * A positive number (1, 2, .. 32) specifies a normal (non-compact) Aztec code.
         * (Type {@link Integer}, or {@link String} representation of the integer value).
         */ EncodeHintType[EncodeHintType["AZTEC_LAYERS"] = 9] = "AZTEC_LAYERS";
        /**
         * Specifies the exact version of QR code to be encoded.
         * (Type {@link Integer}, or {@link String} representation of the integer value).
         */ EncodeHintType[EncodeHintType["QR_VERSION"] = 10] = "QR_VERSION";
    })(EncodeHintType || (EncodeHintType = {}));
    var EncodeHintType$1 = EncodeHintType;
    /**
     * <p>Implements Reed-Solomon encoding, as the name implies.</p>
     *
     * @author Sean Owen
     * @author William Rucklidge
     */ class ReedSolomonEncoder {
        /**
         * A reed solomon error-correcting encoding constructor is created by
         * passing as Galois Field with of size equal to the number of code
         * words (symbols) in the alphabet (the number of values in each
         * element of arrays that are encoded/decoded).
         * @param field A galois field with a number of elements equal to the size
         * of the alphabet of symbols to encode.
         */ constructor(field){
            this.field = field;
            this.cachedGenerators = [];
            this.cachedGenerators.push(new GenericGFPoly(field, Int32Array.from([
                1
            ])));
        }
        buildGenerator(degree /*int*/ ) {
            const cachedGenerators = this.cachedGenerators;
            if (degree >= cachedGenerators.length) {
                let lastGenerator = cachedGenerators[cachedGenerators.length - 1];
                const field = this.field;
                for(let d = cachedGenerators.length; d <= degree; d++){
                    const nextGenerator = lastGenerator.multiply(new GenericGFPoly(field, Int32Array.from([
                        1,
                        field.exp(d - 1 + field.getGeneratorBase())
                    ])));
                    cachedGenerators.push(nextGenerator);
                    lastGenerator = nextGenerator;
                }
            }
            return cachedGenerators[degree];
        }
        /**
         * <p>Encode a sequence of code words (symbols) using Reed-Solomon to allow decoders
         * to detect and correct errors that may have been introduced when the resulting
         * data is stored or transmitted.</p>
         *
         * @param toEncode array used for both and output. Caller initializes the array with
         * the code words (symbols) to be encoded followed by empty elements allocated to make
         * space for error-correction code words in the encoded output. The array contains
         * the encdoded output when encode returns. Code words are encoded as numbers from
         * 0 to n-1, where n is the number of possible code words (symbols), as determined
         * by the size of the Galois Field passed in the constructor of this object.
         * @param ecBytes the number of elements reserved in the array (first parameter)
         * to store error-correction code words. Thus, the number of code words (symbols)
         * to encode in the first parameter is thus toEncode.length - ecBytes.
         * Note, the use of "bytes" in the name of this parameter is misleading, as there may
         * be more or fewer than 256 symbols being encoded, as determined by the number of
         * elements in the Galois Field passed as a constructor to this object.
         * @throws IllegalArgumentException thrown in response to validation errros.
         */ encode(toEncode, ecBytes /*int*/ ) {
            if (ecBytes === 0) throw new IllegalArgumentException('No error correction bytes');
            const dataBytes = toEncode.length - ecBytes;
            if (dataBytes <= 0) throw new IllegalArgumentException('No data bytes provided');
            const generator = this.buildGenerator(ecBytes);
            const infoCoefficients = new Int32Array(dataBytes);
            System.arraycopy(toEncode, 0, infoCoefficients, 0, dataBytes);
            let info = new GenericGFPoly(this.field, infoCoefficients);
            info = info.multiplyByMonomial(ecBytes, 1);
            const remainder = info.divide(generator)[1];
            const coefficients = remainder.getCoefficients();
            const numZeroCoefficients = ecBytes - coefficients.length;
            for(let i = 0; i < numZeroCoefficients; i++)toEncode[dataBytes + i] = 0;
            System.arraycopy(coefficients, 0, toEncode, dataBytes + numZeroCoefficients, coefficients.length);
        }
    }
    /**
     * @author Satoru Takabayashi
     * @author Daniel Switkin
     * @author Sean Owen
     */ class MaskUtil {
        constructor(){
        // do nothing
        }
        /**
         * Apply mask penalty rule 1 and return the penalty. Find repetitive cells with the same color and
         * give penalty to them. Example: 00000 or 11111.
         */ static applyMaskPenaltyRule1(matrix) {
            return MaskUtil.applyMaskPenaltyRule1Internal(matrix, true) + MaskUtil.applyMaskPenaltyRule1Internal(matrix, false);
        }
        /**
         * Apply mask penalty rule 2 and return the penalty. Find 2x2 blocks with the same color and give
         * penalty to them. This is actually equivalent to the spec's rule, which is to find MxN blocks and give a
         * penalty proportional to (M-1)x(N-1), because this is the number of 2x2 blocks inside such a block.
         */ static applyMaskPenaltyRule2(matrix) {
            let penalty = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for(let y = 0; y < height - 1; y++){
                const arrayY = array[y];
                for(let x = 0; x < width - 1; x++){
                    const value = arrayY[x];
                    if (value === arrayY[x + 1] && value === array[y + 1][x] && value === array[y + 1][x + 1]) penalty++;
                }
            }
            return MaskUtil.N2 * penalty;
        }
        /**
         * Apply mask penalty rule 3 and return the penalty. Find consecutive runs of 1:1:3:1:1:4
         * starting with black, or 4:1:1:3:1:1 starting with white, and give penalty to them.  If we
         * find patterns like 000010111010000, we give penalty once.
         */ static applyMaskPenaltyRule3(matrix) {
            let numPenalties = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
                const arrayY = array[y]; // We can at least optimize this access
                if (x + 6 < width && arrayY[x] === 1 && arrayY[x + 1] === 0 && arrayY[x + 2] === 1 && arrayY[x + 3] === 1 && arrayY[x + 4] === 1 && arrayY[x + 5] === 0 && arrayY[x + 6] === 1 && (MaskUtil.isWhiteHorizontal(arrayY, x - 4, x) || MaskUtil.isWhiteHorizontal(arrayY, x + 7, x + 11))) numPenalties++;
                if (y + 6 < height && array[y][x] === 1 && array[y + 1][x] === 0 && array[y + 2][x] === 1 && array[y + 3][x] === 1 && array[y + 4][x] === 1 && array[y + 5][x] === 0 && array[y + 6][x] === 1 && (MaskUtil.isWhiteVertical(array, x, y - 4, y) || MaskUtil.isWhiteVertical(array, x, y + 7, y + 11))) numPenalties++;
            }
            return numPenalties * MaskUtil.N3;
        }
        static isWhiteHorizontal(rowArray, from /*int*/ , to /*int*/ ) {
            from = Math.max(from, 0);
            to = Math.min(to, rowArray.length);
            for(let i = from; i < to; i++){
                if (rowArray[i] === 1) return false;
            }
            return true;
        }
        static isWhiteVertical(array, col /*int*/ , from /*int*/ , to /*int*/ ) {
            from = Math.max(from, 0);
            to = Math.min(to, array.length);
            for(let i = from; i < to; i++){
                if (array[i][col] === 1) return false;
            }
            return true;
        }
        /**
         * Apply mask penalty rule 4 and return the penalty. Calculate the ratio of dark cells and give
         * penalty if the ratio is far from 50%. It gives 10 penalty for 5% distance.
         */ static applyMaskPenaltyRule4(matrix) {
            let numDarkCells = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for(let y = 0; y < height; y++){
                const arrayY = array[y];
                for(let x = 0; x < width; x++)if (arrayY[x] === 1) numDarkCells++;
            }
            const numTotalCells = matrix.getHeight() * matrix.getWidth();
            const fivePercentVariances = Math.floor(Math.abs(numDarkCells * 2 - numTotalCells) * 10 / numTotalCells);
            return fivePercentVariances * MaskUtil.N4;
        }
        /**
         * Return the mask bit for "getMaskPattern" at "x" and "y". See 8.8 of JISX0510:2004 for mask
         * pattern conditions.
         */ static getDataMaskBit(maskPattern /*int*/ , x /*int*/ , y /*int*/ ) {
            let intermediate; /*int*/ 
            let temp; /*int*/ 
            switch(maskPattern){
                case 0:
                    intermediate = y + x & 0x1;
                    break;
                case 1:
                    intermediate = y & 0x1;
                    break;
                case 2:
                    intermediate = x % 3;
                    break;
                case 3:
                    intermediate = (y + x) % 3;
                    break;
                case 4:
                    intermediate = Math.floor(y / 2) + Math.floor(x / 3) & 0x1;
                    break;
                case 5:
                    temp = y * x;
                    intermediate = (temp & 0x1) + temp % 3;
                    break;
                case 6:
                    temp = y * x;
                    intermediate = (temp & 0x1) + temp % 3 & 0x1;
                    break;
                case 7:
                    temp = y * x;
                    intermediate = temp % 3 + (y + x & 0x1) & 0x1;
                    break;
                default:
                    throw new IllegalArgumentException('Invalid mask pattern: ' + maskPattern);
            }
            return intermediate === 0;
        }
        /**
         * Helper function for applyMaskPenaltyRule1. We need this for doing this calculation in both
         * vertical and horizontal orders respectively.
         */ static applyMaskPenaltyRule1Internal(matrix, isHorizontal) {
            let penalty = 0;
            const iLimit = isHorizontal ? matrix.getHeight() : matrix.getWidth();
            const jLimit = isHorizontal ? matrix.getWidth() : matrix.getHeight();
            const array = matrix.getArray();
            for(let i = 0; i < iLimit; i++){
                let numSameBitCells = 0;
                let prevBit = -1;
                for(let j = 0; j < jLimit; j++){
                    const bit = isHorizontal ? array[i][j] : array[j][i];
                    if (bit === prevBit) numSameBitCells++;
                    else {
                        if (numSameBitCells >= 5) penalty += MaskUtil.N1 + (numSameBitCells - 5);
                        numSameBitCells = 1; // Include the cell itself.
                        prevBit = bit;
                    }
                }
                if (numSameBitCells >= 5) penalty += MaskUtil.N1 + (numSameBitCells - 5);
            }
            return penalty;
        }
    }
    // Penalty weights from section 6.8.2.1
    MaskUtil.N1 = 3;
    MaskUtil.N2 = 3;
    MaskUtil.N3 = 40;
    MaskUtil.N4 = 10;
    /**
     * JAVAPORT: The original code was a 2D array of ints, but since it only ever gets assigned
     * -1, 0, and 1, I'm going to use less memory and go with bytes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class ByteMatrix {
        constructor(width /*int*/ , height /*int*/ ){
            this.width = width;
            this.height = height;
            const bytes = new Array(height); // [height][width]
            for(let i = 0; i !== height; i++)bytes[i] = new Uint8Array(width);
            this.bytes = bytes;
        }
        getHeight() {
            return this.height;
        }
        getWidth() {
            return this.width;
        }
        get(x /*int*/ , y /*int*/ ) {
            return this.bytes[y][x];
        }
        /**
         * @return an internal representation as bytes, in row-major order. array[y][x] represents point (x,y)
         */ getArray() {
            return this.bytes;
        }
        // TYPESCRIPTPORT: preffer to let two methods instead of override to avoid type comparison inside
        setNumber(x /*int*/ , y /*int*/ , value /*byte|int*/ ) {
            this.bytes[y][x] = value;
        }
        // public set(x: number /*int*/, y: number /*int*/, value: number /*int*/): void {
        //   bytes[y][x] = (byte) value
        // }
        setBoolean(x /*int*/ , y /*int*/ , value) {
            this.bytes[y][x] = /*(byte) */ value ? 1 : 0;
        }
        clear(value /*byte*/ ) {
            for (const aByte of this.bytes)Arrays.fill(aByte, value);
        }
        equals(o) {
            if (!(o instanceof ByteMatrix)) return false;
            const other = o;
            if (this.width !== other.width) return false;
            if (this.height !== other.height) return false;
            for(let y = 0, height = this.height; y < height; ++y){
                const bytesY = this.bytes[y];
                const otherBytesY = other.bytes[y];
                for(let x = 0, width = this.width; x < width; ++x){
                    if (bytesY[x] !== otherBytesY[x]) return false;
                }
            }
            return true;
        }
        /*@Override*/ toString() {
            const result = new StringBuilder(); // (2 * width * height + 2)
            for(let y = 0, height = this.height; y < height; ++y){
                const bytesY = this.bytes[y];
                for(let x = 0, width = this.width; x < width; ++x)switch(bytesY[x]){
                    case 0:
                        result.append(' 0');
                        break;
                    case 1:
                        result.append(' 1');
                        break;
                    default:
                        result.append('  ');
                        break;
                }
                result.append('\n');
            }
            return result.toString();
        }
    }
    /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */ class QRCode {
        constructor(){
            this.maskPattern = -1;
        }
        getMode() {
            return this.mode;
        }
        getECLevel() {
            return this.ecLevel;
        }
        getVersion() {
            return this.version;
        }
        getMaskPattern() {
            return this.maskPattern;
        }
        getMatrix() {
            return this.matrix;
        }
        /*@Override*/ toString() {
            const result = new StringBuilder(); // (200)
            result.append('<<\n');
            result.append(' mode: ');
            result.append(this.mode ? this.mode.toString() : 'null');
            result.append('\n ecLevel: ');
            result.append(this.ecLevel ? this.ecLevel.toString() : 'null');
            result.append('\n version: ');
            result.append(this.version ? this.version.toString() : 'null');
            result.append('\n maskPattern: ');
            result.append(this.maskPattern.toString());
            if (this.matrix) {
                result.append('\n matrix:\n');
                result.append(this.matrix.toString());
            } else result.append('\n matrix: null\n');
            result.append('>>\n');
            return result.toString();
        }
        setMode(value) {
            this.mode = value;
        }
        setECLevel(value) {
            this.ecLevel = value;
        }
        setVersion(version) {
            this.version = version;
        }
        setMaskPattern(value /*int*/ ) {
            this.maskPattern = value;
        }
        setMatrix(value) {
            this.matrix = value;
        }
        // Check if "mask_pattern" is valid.
        static isValidMaskPattern(maskPattern /*int*/ ) {
            return maskPattern >= 0 && maskPattern < QRCode.NUM_MASK_PATTERNS;
        }
    }
    QRCode.NUM_MASK_PATTERNS = 8;
    /**
     * Custom Error class of type Exception.
     */ class WriterException extends Exception {
    }
    WriterException.kind = 'WriterException';
    /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */ class MatrixUtil {
        constructor(){
        // do nothing
        }
        // Set all cells to -1 (TYPESCRIPTPORT: 255).  -1 (TYPESCRIPTPORT: 255) means that the cell is empty (not set yet).
        //
        // JAVAPORT: We shouldn't need to do this at all. The code should be rewritten to begin encoding
        // with the ByteMatrix initialized all to zero.
        static clearMatrix(matrix) {
            // TYPESCRIPTPORT: we use UintArray se changed here from -1 to 255
            matrix.clear(/*(byte) */ /*-1*/ 255);
        }
        // Build 2D matrix of QR Code from "dataBits" with "ecLevel", "version" and "getMaskPattern". On
        // success, store the result in "matrix" and return true.
        static buildMatrix(dataBits, ecLevel, version, maskPattern /*int*/ , matrix) {
            MatrixUtil.clearMatrix(matrix);
            MatrixUtil.embedBasicPatterns(version, matrix);
            // Type information appear with any version.
            MatrixUtil.embedTypeInfo(ecLevel, maskPattern, matrix);
            // Version info appear if version >= 7.
            MatrixUtil.maybeEmbedVersionInfo(version, matrix);
            // Data should be embedded at end.
            MatrixUtil.embedDataBits(dataBits, maskPattern, matrix);
        }
        // Embed basic patterns. On success, modify the matrix and return true.
        // The basic patterns are:
        // - Position detection patterns
        // - Timing patterns
        // - Dark dot at the left bottom corner
        // - Position adjustment patterns, if need be
        static embedBasicPatterns(version, matrix) {
            // Let's get started with embedding big squares at corners.
            MatrixUtil.embedPositionDetectionPatternsAndSeparators(matrix);
            // Then, embed the dark dot at the left bottom corner.
            MatrixUtil.embedDarkDotAtLeftBottomCorner(matrix);
            // Position adjustment patterns appear if version >= 2.
            MatrixUtil.maybeEmbedPositionAdjustmentPatterns(version, matrix);
            // Timing patterns should be embedded after position adj. patterns.
            MatrixUtil.embedTimingPatterns(matrix);
        }
        // Embed type information. On success, modify the matrix.
        static embedTypeInfo(ecLevel, maskPattern /*int*/ , matrix) {
            const typeInfoBits = new BitArray();
            MatrixUtil.makeTypeInfoBits(ecLevel, maskPattern, typeInfoBits);
            for(let i = 0, size = typeInfoBits.getSize(); i < size; ++i){
                // Place bits in LSB to MSB order.  LSB (least significant bit) is the last value in
                // "typeInfoBits".
                const bit = typeInfoBits.get(typeInfoBits.getSize() - 1 - i);
                // Type info bits at the left top corner. See 8.9 of JISX0510:2004 (p.46).
                const coordinates = MatrixUtil.TYPE_INFO_COORDINATES[i];
                const x1 = coordinates[0];
                const y1 = coordinates[1];
                matrix.setBoolean(x1, y1, bit);
                if (i < 8) {
                    // Right top corner.
                    const x2 = matrix.getWidth() - i - 1;
                    const y2 = 8;
                    matrix.setBoolean(x2, y2, bit);
                } else {
                    // Left bottom corner.
                    const x2 = 8;
                    const y2 = matrix.getHeight() - 7 + (i - 8);
                    matrix.setBoolean(x2, y2, bit);
                }
            }
        }
        // Embed version information if need be. On success, modify the matrix and return true.
        // See 8.10 of JISX0510:2004 (p.47) for how to embed version information.
        static maybeEmbedVersionInfo(version, matrix) {
            if (version.getVersionNumber() < 7) return; // Don't need version info.
            const versionInfoBits = new BitArray();
            MatrixUtil.makeVersionInfoBits(version, versionInfoBits);
            let bitIndex = 17; // It will decrease from 17 to 0.
            for(let i = 0; i < 6; ++i)for(let j = 0; j < 3; ++j){
                // Place bits in LSB (least significant bit) to MSB order.
                const bit = versionInfoBits.get(bitIndex);
                bitIndex--;
                // Left bottom corner.
                matrix.setBoolean(i, matrix.getHeight() - 11 + j, bit);
                // Right bottom corner.
                matrix.setBoolean(matrix.getHeight() - 11 + j, i, bit);
            }
        }
        // Embed "dataBits" using "getMaskPattern". On success, modify the matrix and return true.
        // For debugging purposes, it skips masking process if "getMaskPattern" is -1(TYPESCRIPTPORT: 255).
        // See 8.7 of JISX0510:2004 (p.38) for how to embed data bits.
        static embedDataBits(dataBits, maskPattern /*int*/ , matrix) {
            let bitIndex = 0;
            let direction = -1;
            // Start from the right bottom cell.
            let x = matrix.getWidth() - 1;
            let y = matrix.getHeight() - 1;
            while(x > 0){
                // Skip the vertical timing pattern.
                if (x === 6) x -= 1;
                while(y >= 0 && y < matrix.getHeight()){
                    for(let i = 0; i < 2; ++i){
                        const xx = x - i;
                        // Skip the cell if it's not empty.
                        if (!MatrixUtil.isEmpty(matrix.get(xx, y))) continue;
                        let bit;
                        if (bitIndex < dataBits.getSize()) {
                            bit = dataBits.get(bitIndex);
                            ++bitIndex;
                        } else // Padding bit. If there is no bit left, we'll fill the left cells with 0, as described
                        // in 8.4.9 of JISX0510:2004 (p. 24).
                        bit = false;
                        // Skip masking if mask_pattern is -1 (TYPESCRIPTPORT: 255).
                        if (maskPattern !== 255 && MaskUtil.getDataMaskBit(maskPattern, xx, y)) bit = !bit;
                        matrix.setBoolean(xx, y, bit);
                    }
                    y += direction;
                }
                direction = -direction; // Reverse the direction.
                y += direction;
                x -= 2; // Move to the left.
            }
            // All bits should be consumed.
            if (bitIndex !== dataBits.getSize()) throw new WriterException('Not all bits consumed: ' + bitIndex + '/' + dataBits.getSize());
        }
        // Return the position of the most significant bit set (one: to) in the "value". The most
        // significant bit is position 32. If there is no bit set, return 0. Examples:
        // - findMSBSet(0) => 0
        // - findMSBSet(1) => 1
        // - findMSBSet(255) => 8
        static findMSBSet(value /*int*/ ) {
            return 32 - Integer.numberOfLeadingZeros(value);
        }
        // Calculate BCH (Bose-Chaudhuri-Hocquenghem) code for "value" using polynomial "poly". The BCH
        // code is used for encoding type information and version information.
        // Example: Calculation of version information of 7.
        // f(x) is created from 7.
        //   - 7 = 000111 in 6 bits
        //   - f(x) = x^2 + x^1 + x^0
        // g(x) is given by the standard (p. 67)
        //   - g(x) = x^12 + x^11 + x^10 + x^9 + x^8 + x^5 + x^2 + 1
        // Multiply f(x) by x^(18 - 6)
        //   - f'(x) = f(x) * x^(18 - 6)
        //   - f'(x) = x^14 + x^13 + x^12
        // Calculate the remainder of f'(x) / g(x)
        //         x^2
        //         __________________________________________________
        //   g(x) )x^14 + x^13 + x^12
        //         x^14 + x^13 + x^12 + x^11 + x^10 + x^7 + x^4 + x^2
        //         --------------------------------------------------
        //                              x^11 + x^10 + x^7 + x^4 + x^2
        //
        // The remainder is x^11 + x^10 + x^7 + x^4 + x^2
        // Encode it in binary: 110010010100
        // The return value is 0xc94 (1100 1001 0100)
        //
        // Since all coefficients in the polynomials are 1 or 0, we can do the calculation by bit
        // operations. We don't care if coefficients are positive or negative.
        static calculateBCHCode(value /*int*/ , poly /*int*/ ) {
            if (poly === 0) throw new IllegalArgumentException('0 polynomial');
            // If poly is "1 1111 0010 0101" (version info poly), msbSetInPoly is 13. We'll subtract 1
            // from 13 to make it 12.
            const msbSetInPoly = MatrixUtil.findMSBSet(poly);
            value <<= msbSetInPoly - 1;
            // Do the division business using exclusive-or operations.
            while(MatrixUtil.findMSBSet(value) >= msbSetInPoly)value ^= poly << MatrixUtil.findMSBSet(value) - msbSetInPoly;
            // Now the "value" is the remainder (i.e. the BCH code)
            return value;
        }
        // Make bit vector of type information. On success, store the result in "bits" and return true.
        // Encode error correction level and mask pattern. See 8.9 of
        // JISX0510:2004 (p.45) for details.
        static makeTypeInfoBits(ecLevel, maskPattern /*int*/ , bits) {
            if (!QRCode.isValidMaskPattern(maskPattern)) throw new WriterException('Invalid mask pattern');
            const typeInfo = ecLevel.getBits() << 3 | maskPattern;
            bits.appendBits(typeInfo, 5);
            const bchCode = MatrixUtil.calculateBCHCode(typeInfo, MatrixUtil.TYPE_INFO_POLY);
            bits.appendBits(bchCode, 10);
            const maskBits = new BitArray();
            maskBits.appendBits(MatrixUtil.TYPE_INFO_MASK_PATTERN, 15);
            bits.xor(maskBits);
            if (bits.getSize() !== 15) throw new WriterException('should not happen but we got: ' + bits.getSize());
        }
        // Make bit vector of version information. On success, store the result in "bits" and return true.
        // See 8.10 of JISX0510:2004 (p.45) for details.
        static makeVersionInfoBits(version, bits) {
            bits.appendBits(version.getVersionNumber(), 6);
            const bchCode = MatrixUtil.calculateBCHCode(version.getVersionNumber(), MatrixUtil.VERSION_INFO_POLY);
            bits.appendBits(bchCode, 12);
            if (bits.getSize() !== 18) throw new WriterException('should not happen but we got: ' + bits.getSize());
        }
        // Check if "value" is empty.
        static isEmpty(value /*int*/ ) {
            return value === 255; // -1
        }
        static embedTimingPatterns(matrix) {
            // -8 is for skipping position detection patterns (7: size), and two horizontal/vertical
            // separation patterns (1: size). Thus, 8 = 7 + 1.
            for(let i = 8; i < matrix.getWidth() - 8; ++i){
                const bit = (i + 1) % 2;
                // Horizontal line.
                if (MatrixUtil.isEmpty(matrix.get(i, 6))) matrix.setNumber(i, 6, bit);
                // Vertical line.
                if (MatrixUtil.isEmpty(matrix.get(6, i))) matrix.setNumber(6, i, bit);
            }
        }
        // Embed the lonely dark dot at left bottom corner. JISX0510:2004 (p.46)
        static embedDarkDotAtLeftBottomCorner(matrix) {
            if (matrix.get(8, matrix.getHeight() - 8) === 0) throw new WriterException();
            matrix.setNumber(8, matrix.getHeight() - 8, 1);
        }
        static embedHorizontalSeparationPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let x = 0; x < 8; ++x){
                if (!MatrixUtil.isEmpty(matrix.get(xStart + x, yStart))) throw new WriterException();
                matrix.setNumber(xStart + x, yStart, 0);
            }
        }
        static embedVerticalSeparationPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let y = 0; y < 7; ++y){
                if (!MatrixUtil.isEmpty(matrix.get(xStart, yStart + y))) throw new WriterException();
                matrix.setNumber(xStart, yStart + y, 0);
            }
        }
        static embedPositionAdjustmentPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let y = 0; y < 5; ++y){
                const patternY = MatrixUtil.POSITION_ADJUSTMENT_PATTERN[y];
                for(let x = 0; x < 5; ++x)matrix.setNumber(xStart + x, yStart + y, patternY[x]);
            }
        }
        static embedPositionDetectionPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let y = 0; y < 7; ++y){
                const patternY = MatrixUtil.POSITION_DETECTION_PATTERN[y];
                for(let x = 0; x < 7; ++x)matrix.setNumber(xStart + x, yStart + y, patternY[x]);
            }
        }
        // Embed position detection patterns and surrounding vertical/horizontal separators.
        static embedPositionDetectionPatternsAndSeparators(matrix) {
            // Embed three big squares at corners.
            const pdpWidth = MatrixUtil.POSITION_DETECTION_PATTERN[0].length;
            // Left top corner.
            MatrixUtil.embedPositionDetectionPattern(0, 0, matrix);
            // Right top corner.
            MatrixUtil.embedPositionDetectionPattern(matrix.getWidth() - pdpWidth, 0, matrix);
            // Left bottom corner.
            MatrixUtil.embedPositionDetectionPattern(0, matrix.getWidth() - pdpWidth, matrix);
            // Embed horizontal separation patterns around the squares.
            const hspWidth = 8;
            // Left top corner.
            MatrixUtil.embedHorizontalSeparationPattern(0, hspWidth - 1, matrix);
            // Right top corner.
            MatrixUtil.embedHorizontalSeparationPattern(matrix.getWidth() - hspWidth, hspWidth - 1, matrix);
            // Left bottom corner.
            MatrixUtil.embedHorizontalSeparationPattern(0, matrix.getWidth() - hspWidth, matrix);
            // Embed vertical separation patterns around the squares.
            const vspSize = 7;
            // Left top corner.
            MatrixUtil.embedVerticalSeparationPattern(vspSize, 0, matrix);
            // Right top corner.
            MatrixUtil.embedVerticalSeparationPattern(matrix.getHeight() - vspSize - 1, 0, matrix);
            // Left bottom corner.
            MatrixUtil.embedVerticalSeparationPattern(vspSize, matrix.getHeight() - vspSize, matrix);
        }
        // Embed position adjustment patterns if need be.
        static maybeEmbedPositionAdjustmentPatterns(version, matrix) {
            if (version.getVersionNumber() < 2) return;
            const index = version.getVersionNumber() - 1;
            const coordinates = MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[index];
            for(let i = 0, length = coordinates.length; i !== length; i++){
                const y = coordinates[i];
                if (y >= 0) for(let j = 0; j !== length; j++){
                    const x = coordinates[j];
                    if (x >= 0 && MatrixUtil.isEmpty(matrix.get(x, y))) // If the cell is unset, we embed the position adjustment pattern here.
                    // -2 is necessary since the x/y coordinates point to the center of the pattern, not the
                    // left top corner.
                    MatrixUtil.embedPositionAdjustmentPattern(x - 2, y - 2, matrix);
                }
            }
        }
    }
    MatrixUtil.POSITION_DETECTION_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ])
    ]);
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ])
    ]);
    // From Appendix E. Table 1, JIS0510X:2004 (71: p). The table was double-checked by komatsu.
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
        Int32Array.from([
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            18,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            38,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            24,
            42,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            66,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            48,
            70,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            72,
            94,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ]);
    // Type info cells at the left top corner.
    MatrixUtil.TYPE_INFO_COORDINATES = Array.from([
        Int32Array.from([
            8,
            0
        ]),
        Int32Array.from([
            8,
            1
        ]),
        Int32Array.from([
            8,
            2
        ]),
        Int32Array.from([
            8,
            3
        ]),
        Int32Array.from([
            8,
            4
        ]),
        Int32Array.from([
            8,
            5
        ]),
        Int32Array.from([
            8,
            7
        ]),
        Int32Array.from([
            8,
            8
        ]),
        Int32Array.from([
            7,
            8
        ]),
        Int32Array.from([
            5,
            8
        ]),
        Int32Array.from([
            4,
            8
        ]),
        Int32Array.from([
            3,
            8
        ]),
        Int32Array.from([
            2,
            8
        ]),
        Int32Array.from([
            1,
            8
        ]),
        Int32Array.from([
            0,
            8
        ])
    ]);
    // From Appendix D in JISX0510:2004 (p. 67)
    MatrixUtil.VERSION_INFO_POLY = 0x1f25; // 1 1111 0010 0101
    // From Appendix C in JISX0510:2004 (p.65).
    MatrixUtil.TYPE_INFO_POLY = 0x537;
    MatrixUtil.TYPE_INFO_MASK_PATTERN = 0x5412;
    /*namespace com.google.zxing.qrcode.encoder {*/ class BlockPair {
        constructor(dataBytes, errorCorrectionBytes){
            this.dataBytes = dataBytes;
            this.errorCorrectionBytes = errorCorrectionBytes;
        }
        getDataBytes() {
            return this.dataBytes;
        }
        getErrorCorrectionBytes() {
            return this.errorCorrectionBytes;
        }
    }
    /*import java.io.UnsupportedEncodingException;*/ /*import java.util.ArrayList;*/ /*import java.util.Collection;*/ /*import java.util.Map;*/ /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */ class Encoder {
        // TYPESCRIPTPORT: changed to UTF8, the default for js
        constructor(){}
        // The mask penalty calculation is complicated.  See Table 21 of JISX0510:2004 (p.45) for details.
        // Basically it applies four rules and summate all penalties.
        static calculateMaskPenalty(matrix) {
            return MaskUtil.applyMaskPenaltyRule1(matrix) + MaskUtil.applyMaskPenaltyRule2(matrix) + MaskUtil.applyMaskPenaltyRule3(matrix) + MaskUtil.applyMaskPenaltyRule4(matrix);
        }
        /**
         * @param content text to encode
         * @param ecLevel error correction level to use
         * @return {@link QRCode} representing the encoded QR code
         * @throws WriterException if encoding can't succeed, because of for example invalid content
         *   or configuration
         */ // public static encode(content: string, ecLevel: ErrorCorrectionLevel): QRCode /*throws WriterException*/ {
        //   return encode(content, ecLevel, null)
        // }
        static encode(content, ecLevel, hints = null) {
            // Determine what character encoding has been specified by the caller, if any
            let encoding = Encoder.DEFAULT_BYTE_MODE_ENCODING;
            const hasEncodingHint = hints !== null && undefined !== hints.get(EncodeHintType$1.CHARACTER_SET);
            if (hasEncodingHint) encoding = hints.get(EncodeHintType$1.CHARACTER_SET).toString();
            // Pick an encoding mode appropriate for the content. Note that this will not attempt to use
            // multiple modes / segments even if that were more efficient. Twould be nice.
            const mode = this.chooseMode(content, encoding);
            // This will store the header information, like mode and
            // length, as well as "header" segments like an ECI segment.
            const headerBits = new BitArray();
            // Append ECI segment if applicable
            if (mode === Mode$1.BYTE && (hasEncodingHint || Encoder.DEFAULT_BYTE_MODE_ENCODING !== encoding)) {
                const eci = CharacterSetECI.getCharacterSetECIByName(encoding);
                if (eci !== undefined) this.appendECI(eci, headerBits);
            }
            // (With ECI in place,) Write the mode marker
            this.appendModeInfo(mode, headerBits);
            // Collect data within the main segment, separately, to count its size if needed. Don't add it to
            // main payload yet.
            const dataBits = new BitArray();
            this.appendBytes(content, mode, dataBits, encoding);
            let version;
            if (hints !== null && undefined !== hints.get(EncodeHintType$1.QR_VERSION)) {
                const versionNumber = Number.parseInt(hints.get(EncodeHintType$1.QR_VERSION).toString(), 10);
                version = Version$1.getVersionForNumber(versionNumber);
                const bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, version);
                if (!this.willFit(bitsNeeded, version, ecLevel)) throw new WriterException('Data too big for requested version');
            } else version = this.recommendVersion(ecLevel, mode, headerBits, dataBits);
            const headerAndDataBits = new BitArray();
            headerAndDataBits.appendBitArray(headerBits);
            // Find "length" of main segment and write it
            const numLetters = mode === Mode$1.BYTE ? dataBits.getSizeInBytes() : content.length;
            this.appendLengthInfo(numLetters, version, mode, headerAndDataBits);
            // Put data together into the overall payload
            headerAndDataBits.appendBitArray(dataBits);
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            const numDataBytes = version.getTotalCodewords() - ecBlocks.getTotalECCodewords();
            // Terminate the bits properly.
            this.terminateBits(numDataBytes, headerAndDataBits);
            // Interleave data bits with error correction code.
            const finalBits = this.interleaveWithECBytes(headerAndDataBits, version.getTotalCodewords(), numDataBytes, ecBlocks.getNumBlocks());
            const qrCode = new QRCode();
            qrCode.setECLevel(ecLevel);
            qrCode.setMode(mode);
            qrCode.setVersion(version);
            //  Choose the mask pattern and set to "qrCode".
            const dimension = version.getDimensionForVersion();
            const matrix = new ByteMatrix(dimension, dimension);
            const maskPattern = this.chooseMaskPattern(finalBits, ecLevel, version, matrix);
            qrCode.setMaskPattern(maskPattern);
            // Build the matrix and set it to "qrCode".
            MatrixUtil.buildMatrix(finalBits, ecLevel, version, maskPattern, matrix);
            qrCode.setMatrix(matrix);
            return qrCode;
        }
        /**
         * Decides the smallest version of QR code that will contain all of the provided data.
         *
         * @throws WriterException if the data cannot fit in any version
         */ static recommendVersion(ecLevel, mode, headerBits, dataBits) {
            // Hard part: need to know version to know how many bits length takes. But need to know how many
            // bits it takes to know version. First we take a guess at version by assuming version will be
            // the minimum, 1:
            const provisionalBitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, Version$1.getVersionForNumber(1));
            const provisionalVersion = this.chooseVersion(provisionalBitsNeeded, ecLevel);
            // Use that guess to calculate the right version. I am still not sure this works in 100% of cases.
            const bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, provisionalVersion);
            return this.chooseVersion(bitsNeeded, ecLevel);
        }
        static calculateBitsNeeded(mode, headerBits, dataBits, version) {
            return headerBits.getSize() + mode.getCharacterCountBits(version) + dataBits.getSize();
        }
        /**
         * @return the code point of the table used in alphanumeric mode or
         *  -1 if there is no corresponding code in the table.
         */ static getAlphanumericCode(code /*int*/ ) {
            if (code < Encoder.ALPHANUMERIC_TABLE.length) return Encoder.ALPHANUMERIC_TABLE[code];
            return -1;
        }
        // public static chooseMode(content: string): Mode {
        //   return chooseMode(content, null);
        // }
        /**
         * Choose the best mode by examining the content. Note that 'encoding' is used as a hint;
         * if it is Shift_JIS, and the input is only double-byte Kanji, then we return {@link Mode#KANJI}.
         */ static chooseMode(content, encoding = null) {
            if (CharacterSetECI.SJIS.getName() === encoding && this.isOnlyDoubleByteKanji(content)) // Choose Kanji mode if all input are double-byte characters
            return Mode$1.KANJI;
            let hasNumeric = false;
            let hasAlphanumeric = false;
            for(let i = 0, length = content.length; i < length; ++i){
                const c = content.charAt(i);
                if (Encoder.isDigit(c)) hasNumeric = true;
                else if (this.getAlphanumericCode(c.charCodeAt(0)) !== -1) hasAlphanumeric = true;
                else return Mode$1.BYTE;
            }
            if (hasAlphanumeric) return Mode$1.ALPHANUMERIC;
            if (hasNumeric) return Mode$1.NUMERIC;
            return Mode$1.BYTE;
        }
        static isOnlyDoubleByteKanji(content) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, CharacterSetECI.SJIS); // content.getBytes("Shift_JIS"))
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                return false;
            }
            const length = bytes.length;
            if (length % 2 !== 0) return false;
            for(let i = 0; i < length; i += 2){
                const byte1 = bytes[i] & 0xFF;
                if ((byte1 < 0x81 || byte1 > 0x9F) && (byte1 < 0xE0 || byte1 > 0xEB)) return false;
            }
            return true;
        }
        static chooseMaskPattern(bits, ecLevel, version, matrix) {
            let minPenalty = Number.MAX_SAFE_INTEGER; // Lower penalty is better.
            let bestMaskPattern = -1;
            // We try all mask patterns to choose the best one.
            for(let maskPattern = 0; maskPattern < QRCode.NUM_MASK_PATTERNS; maskPattern++){
                MatrixUtil.buildMatrix(bits, ecLevel, version, maskPattern, matrix);
                let penalty = this.calculateMaskPenalty(matrix);
                if (penalty < minPenalty) {
                    minPenalty = penalty;
                    bestMaskPattern = maskPattern;
                }
            }
            return bestMaskPattern;
        }
        static chooseVersion(numInputBits /*int*/ , ecLevel) {
            for(let versionNum = 1; versionNum <= 40; versionNum++){
                const version = Version$1.getVersionForNumber(versionNum);
                if (Encoder.willFit(numInputBits, version, ecLevel)) return version;
            }
            throw new WriterException('Data too big');
        }
        /**
         * @return true if the number of input bits will fit in a code with the specified version and
         * error correction level.
         */ static willFit(numInputBits /*int*/ , version, ecLevel) {
            // In the following comments, we use numbers of Version 7-H.
            // numBytes = 196
            const numBytes = version.getTotalCodewords();
            // getNumECBytes = 130
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            const numEcBytes = ecBlocks.getTotalECCodewords();
            // getNumDataBytes = 196 - 130 = 66
            const numDataBytes = numBytes - numEcBytes;
            const totalInputBytes = (numInputBits + 7) / 8;
            return numDataBytes >= totalInputBytes;
        }
        /**
         * Terminate bits as described in 8.4.8 and 8.4.9 of JISX0510:2004 (p.24).
         */ static terminateBits(numDataBytes /*int*/ , bits) {
            const capacity = numDataBytes * 8;
            if (bits.getSize() > capacity) throw new WriterException('data bits cannot fit in the QR Code' + bits.getSize() + ' > ' + capacity);
            for(let i = 0; i < 4 && bits.getSize() < capacity; ++i)bits.appendBit(false);
            // Append termination bits. See 8.4.8 of JISX0510:2004 (p.24) for details.
            // If the last byte isn't 8-bit aligned, we'll add padding bits.
            const numBitsInLastByte = bits.getSize() & 0x07;
            if (numBitsInLastByte > 0) for(let i = numBitsInLastByte; i < 8; i++)bits.appendBit(false);
            // If we have more space, we'll fill the space with padding patterns defined in 8.4.9 (p.24).
            const numPaddingBytes = numDataBytes - bits.getSizeInBytes();
            for(let i = 0; i < numPaddingBytes; ++i)bits.appendBits((i & 0x01) === 0 ? 0xEC : 0x11, 8);
            if (bits.getSize() !== capacity) throw new WriterException('Bits size does not equal capacity');
        }
        /**
         * Get number of data bytes and number of error correction bytes for block id "blockID". Store
         * the result in "numDataBytesInBlock", and "numECBytesInBlock". See table 12 in 8.5.1 of
         * JISX0510:2004 (p.30)
         */ static getNumDataBytesAndNumECBytesForBlockID(numTotalBytes /*int*/ , numDataBytes /*int*/ , numRSBlocks /*int*/ , blockID /*int*/ , numDataBytesInBlock, numECBytesInBlock) {
            if (blockID >= numRSBlocks) throw new WriterException('Block ID too large');
            // numRsBlocksInGroup2 = 196 % 5 = 1
            const numRsBlocksInGroup2 = numTotalBytes % numRSBlocks;
            // numRsBlocksInGroup1 = 5 - 1 = 4
            const numRsBlocksInGroup1 = numRSBlocks - numRsBlocksInGroup2;
            // numTotalBytesInGroup1 = 196 / 5 = 39
            const numTotalBytesInGroup1 = Math.floor(numTotalBytes / numRSBlocks);
            // numTotalBytesInGroup2 = 39 + 1 = 40
            const numTotalBytesInGroup2 = numTotalBytesInGroup1 + 1;
            // numDataBytesInGroup1 = 66 / 5 = 13
            const numDataBytesInGroup1 = Math.floor(numDataBytes / numRSBlocks);
            // numDataBytesInGroup2 = 13 + 1 = 14
            const numDataBytesInGroup2 = numDataBytesInGroup1 + 1;
            // numEcBytesInGroup1 = 39 - 13 = 26
            const numEcBytesInGroup1 = numTotalBytesInGroup1 - numDataBytesInGroup1;
            // numEcBytesInGroup2 = 40 - 14 = 26
            const numEcBytesInGroup2 = numTotalBytesInGroup2 - numDataBytesInGroup2;
            // Sanity checks.
            // 26 = 26
            if (numEcBytesInGroup1 !== numEcBytesInGroup2) throw new WriterException('EC bytes mismatch');
            // 5 = 4 + 1.
            if (numRSBlocks !== numRsBlocksInGroup1 + numRsBlocksInGroup2) throw new WriterException('RS blocks mismatch');
            // 196 = (13 + 26) * 4 + (14 + 26) * 1
            if (numTotalBytes !== (numDataBytesInGroup1 + numEcBytesInGroup1) * numRsBlocksInGroup1 + (numDataBytesInGroup2 + numEcBytesInGroup2) * numRsBlocksInGroup2) throw new WriterException('Total bytes mismatch');
            if (blockID < numRsBlocksInGroup1) {
                numDataBytesInBlock[0] = numDataBytesInGroup1;
                numECBytesInBlock[0] = numEcBytesInGroup1;
            } else {
                numDataBytesInBlock[0] = numDataBytesInGroup2;
                numECBytesInBlock[0] = numEcBytesInGroup2;
            }
        }
        /**
         * Interleave "bits" with corresponding error correction bytes. On success, store the result in
         * "result". The interleave rule is complicated. See 8.6 of JISX0510:2004 (p.37) for details.
         */ static interleaveWithECBytes(bits, numTotalBytes /*int*/ , numDataBytes /*int*/ , numRSBlocks /*int*/ ) {
            // "bits" must have "getNumDataBytes" bytes of data.
            if (bits.getSizeInBytes() !== numDataBytes) throw new WriterException('Number of bits and data bytes does not match');
            // Step 1.  Divide data bytes into blocks and generate error correction bytes for them. We'll
            // store the divided data bytes blocks and error correction bytes blocks into "blocks".
            let dataBytesOffset = 0;
            let maxNumDataBytes = 0;
            let maxNumEcBytes = 0;
            // Since, we know the number of reedsolmon blocks, we can initialize the vector with the number.
            const blocks = new Array(); // new Array<BlockPair>(numRSBlocks)
            for(let i = 0; i < numRSBlocks; ++i){
                const numDataBytesInBlock = new Int32Array(1);
                const numEcBytesInBlock = new Int32Array(1);
                Encoder.getNumDataBytesAndNumECBytesForBlockID(numTotalBytes, numDataBytes, numRSBlocks, i, numDataBytesInBlock, numEcBytesInBlock);
                const size = numDataBytesInBlock[0];
                const dataBytes = new Uint8Array(size);
                bits.toBytes(8 * dataBytesOffset, dataBytes, 0, size);
                const ecBytes = Encoder.generateECBytes(dataBytes, numEcBytesInBlock[0]);
                blocks.push(new BlockPair(dataBytes, ecBytes));
                maxNumDataBytes = Math.max(maxNumDataBytes, size);
                maxNumEcBytes = Math.max(maxNumEcBytes, ecBytes.length);
                dataBytesOffset += numDataBytesInBlock[0];
            }
            if (numDataBytes !== dataBytesOffset) throw new WriterException('Data bytes does not match offset');
            const result = new BitArray();
            // First, place data blocks.
            for(let i = 0; i < maxNumDataBytes; ++i)for (const block of blocks){
                const dataBytes = block.getDataBytes();
                if (i < dataBytes.length) result.appendBits(dataBytes[i], 8);
            }
            // Then, place error correction blocks.
            for(let i = 0; i < maxNumEcBytes; ++i)for (const block of blocks){
                const ecBytes = block.getErrorCorrectionBytes();
                if (i < ecBytes.length) result.appendBits(ecBytes[i], 8);
            }
            if (numTotalBytes !== result.getSizeInBytes()) throw new WriterException('Interleaving error: ' + numTotalBytes + ' and ' + result.getSizeInBytes() + ' differ.');
            return result;
        }
        static generateECBytes(dataBytes, numEcBytesInBlock /*int*/ ) {
            const numDataBytes = dataBytes.length;
            const toEncode = new Int32Array(numDataBytes + numEcBytesInBlock); // int[numDataBytes + numEcBytesInBlock]
            for(let i = 0; i < numDataBytes; i++)toEncode[i] = dataBytes[i] & 0xFF;
            new ReedSolomonEncoder(GenericGF.QR_CODE_FIELD_256).encode(toEncode, numEcBytesInBlock);
            const ecBytes = new Uint8Array(numEcBytesInBlock);
            for(let i = 0; i < numEcBytesInBlock; i++)ecBytes[i] = /*(byte) */ toEncode[numDataBytes + i];
            return ecBytes;
        }
        /**
         * Append mode info. On success, store the result in "bits".
         */ static appendModeInfo(mode, bits) {
            bits.appendBits(mode.getBits(), 4);
        }
        /**
         * Append length info. On success, store the result in "bits".
         */ static appendLengthInfo(numLetters /*int*/ , version, mode, bits) {
            const numBits = mode.getCharacterCountBits(version);
            if (numLetters >= 1 << numBits) throw new WriterException(numLetters + ' is bigger than ' + ((1 << numBits) - 1));
            bits.appendBits(numLetters, numBits);
        }
        /**
         * Append "bytes" in "mode" mode (encoding) into "bits". On success, store the result in "bits".
         */ static appendBytes(content, mode, bits, encoding) {
            switch(mode){
                case Mode$1.NUMERIC:
                    Encoder.appendNumericBytes(content, bits);
                    break;
                case Mode$1.ALPHANUMERIC:
                    Encoder.appendAlphanumericBytes(content, bits);
                    break;
                case Mode$1.BYTE:
                    Encoder.append8BitBytes(content, bits, encoding);
                    break;
                case Mode$1.KANJI:
                    Encoder.appendKanjiBytes(content, bits);
                    break;
                default:
                    throw new WriterException('Invalid mode: ' + mode);
            }
        }
        static getDigit(singleCharacter) {
            return singleCharacter.charCodeAt(0) - 48;
        }
        static isDigit(singleCharacter) {
            const cn = Encoder.getDigit(singleCharacter);
            return cn >= 0 && cn <= 9;
        }
        static appendNumericBytes(content, bits) {
            const length = content.length;
            let i = 0;
            while(i < length){
                const num1 = Encoder.getDigit(content.charAt(i));
                if (i + 2 < length) {
                    // Encode three numeric letters in ten bits.
                    const num2 = Encoder.getDigit(content.charAt(i + 1));
                    const num3 = Encoder.getDigit(content.charAt(i + 2));
                    bits.appendBits(num1 * 100 + num2 * 10 + num3, 10);
                    i += 3;
                } else if (i + 1 < length) {
                    // Encode two numeric letters in seven bits.
                    const num2 = Encoder.getDigit(content.charAt(i + 1));
                    bits.appendBits(num1 * 10 + num2, 7);
                    i += 2;
                } else {
                    // Encode one numeric letter in four bits.
                    bits.appendBits(num1, 4);
                    i++;
                }
            }
        }
        static appendAlphanumericBytes(content, bits) {
            const length = content.length;
            let i = 0;
            while(i < length){
                const code1 = Encoder.getAlphanumericCode(content.charCodeAt(i));
                if (code1 === -1) throw new WriterException();
                if (i + 1 < length) {
                    const code2 = Encoder.getAlphanumericCode(content.charCodeAt(i + 1));
                    if (code2 === -1) throw new WriterException();
                    // Encode two alphanumeric letters in 11 bits.
                    bits.appendBits(code1 * 45 + code2, 11);
                    i += 2;
                } else {
                    // Encode one alphanumeric letter in six bits.
                    bits.appendBits(code1, 6);
                    i++;
                }
            }
        }
        static append8BitBytes(content, bits, encoding) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, encoding);
            } catch (uee /*: UnsupportedEncodingException*/ ) {
                throw new WriterException(uee);
            }
            for(let i = 0, length = bytes.length; i !== length; i++){
                const b = bytes[i];
                bits.appendBits(b, 8);
            }
        }
        /**
         * @throws WriterException
         */ static appendKanjiBytes(content, bits) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, CharacterSetECI.SJIS);
            } catch (uee /*: UnsupportedEncodingException*/ ) {
                throw new WriterException(uee);
            }
            const length = bytes.length;
            for(let i = 0; i < length; i += 2){
                const byte1 = bytes[i] & 0xFF;
                const byte2 = bytes[i + 1] & 0xFF;
                const code = byte1 << 8 & 0xFFFFFFFF | byte2;
                let subtracted = -1;
                if (code >= 0x8140 && code <= 0x9ffc) subtracted = code - 0x8140;
                else if (code >= 0xe040 && code <= 0xebbf) subtracted = code - 0xc140;
                if (subtracted === -1) throw new WriterException('Invalid byte sequence');
                const encoded = (subtracted >> 8) * 0xc0 + (subtracted & 0xff);
                bits.appendBits(encoded, 13);
            }
        }
        static appendECI(eci, bits) {
            bits.appendBits(Mode$1.ECI.getBits(), 4);
            // This is correct for values up to 127, which is all we need now.
            bits.appendBits(eci.getValue(), 8);
        }
    }
    // The original table is defined in the table 5 of JISX0510:2004 (p.19).
    Encoder.ALPHANUMERIC_TABLE = Int32Array.from([
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        36,
        -1,
        -1,
        -1,
        37,
        38,
        -1,
        -1,
        -1,
        -1,
        39,
        40,
        -1,
        41,
        42,
        43,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        44,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        -1,
        -1,
        -1,
        -1,
        -1
    ]);
    Encoder.DEFAULT_BYTE_MODE_ENCODING = CharacterSetECI.UTF8.getName(); // "ISO-8859-1"
    /**
     * @deprecated Moving to @zxing/browser
     */ class BrowserQRCodeSvgWriter {
        /**
         * Writes and renders a QRCode SVG element.
         *
         * @param contents
         * @param width
         * @param height
         * @param hints
         */ write(contents, width, height, hints = null) {
            if (contents.length === 0) throw new IllegalArgumentException('Found empty contents');
            // if (format != BarcodeFormat.QR_CODE) {
            //   throw new IllegalArgumentException("Can only encode QR_CODE, but got " + format)
            // }
            if (width < 0 || height < 0) throw new IllegalArgumentException('Requested dimensions are too small: ' + width + 'x' + height);
            let errorCorrectionLevel = ErrorCorrectionLevel.L;
            let quietZone = BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE;
            if (hints !== null) {
                if (undefined !== hints.get(EncodeHintType$1.ERROR_CORRECTION)) errorCorrectionLevel = ErrorCorrectionLevel.fromString(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                if (undefined !== hints.get(EncodeHintType$1.MARGIN)) quietZone = Number.parseInt(hints.get(EncodeHintType$1.MARGIN).toString(), 10);
            }
            const code = Encoder.encode(contents, errorCorrectionLevel, hints);
            return this.renderResult(code, width, height, quietZone);
        }
        /**
         * Renders the result and then appends it to the DOM.
         */ writeToDom(containerElement, contents, width, height, hints = null) {
            if (typeof containerElement === 'string') containerElement = document.querySelector(containerElement);
            const svgElement = this.write(contents, width, height, hints);
            if (containerElement) containerElement.appendChild(svgElement);
        }
        /**
         * Note that the input matrix uses 0 == white, 1 == black.
         * The output matrix uses 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
         */ renderResult(code, width /*int*/ , height /*int*/ , quietZone /*int*/ ) {
            const input = code.getMatrix();
            if (input === null) throw new IllegalStateException();
            const inputWidth = input.getWidth();
            const inputHeight = input.getHeight();
            const qrWidth = inputWidth + quietZone * 2;
            const qrHeight = inputHeight + quietZone * 2;
            const outputWidth = Math.max(width, qrWidth);
            const outputHeight = Math.max(height, qrHeight);
            const multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
            // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
            // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
            // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
            // handle all the padding from 100x100 (the actual QR) up to 200x160.
            const leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
            const topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
            const svgElement = this.createSVGElement(outputWidth, outputHeight);
            for(let inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
                // Write the contents of this row of the barcode
                for(let inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY) === 1) {
                    const svgRectElement = this.createSvgRectElement(outputX, outputY, multiple, multiple);
                    svgElement.appendChild(svgRectElement);
                }
            }
            return svgElement;
        }
        /**
         * Creates a SVG element.
         *
         * @param w SVG's width attribute
         * @param h SVG's height attribute
         */ createSVGElement(w, h) {
            const svgElement = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, 'svg');
            svgElement.setAttributeNS(null, 'height', w.toString());
            svgElement.setAttributeNS(null, 'width', h.toString());
            return svgElement;
        }
        /**
         * Creates a SVG rect element.
         *
         * @param x Element's x coordinate
         * @param y Element's y coordinate
         * @param w Element's width attribute
         * @param h Element's height attribute
         */ createSvgRectElement(x, y, w, h) {
            const rect = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, 'rect');
            rect.setAttributeNS(null, 'x', x.toString());
            rect.setAttributeNS(null, 'y', y.toString());
            rect.setAttributeNS(null, 'height', w.toString());
            rect.setAttributeNS(null, 'width', h.toString());
            rect.setAttributeNS(null, 'fill', '#000000');
            return rect;
        }
    }
    BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE = 4;
    /**
     * SVG markup NameSpace
     */ BrowserQRCodeSvgWriter.SVG_NS = 'http://www.w3.org/2000/svg';
    /*import java.util.Map;*/ /**
     * This object renders a QR Code as a BitMatrix 2D array of greyscale values.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class QRCodeWriter {
        /*@Override*/ // public encode(contents: string, format: BarcodeFormat, width: number /*int*/, height: number /*int*/): BitMatrix
        //     /*throws WriterException */ {
        //   return encode(contents, format, width, height, null)
        // }
        /*@Override*/ encode(contents, format, width /*int*/ , height /*int*/ , hints) {
            if (contents.length === 0) throw new IllegalArgumentException('Found empty contents');
            if (format !== BarcodeFormat$1.QR_CODE) throw new IllegalArgumentException('Can only encode QR_CODE, but got ' + format);
            if (width < 0 || height < 0) throw new IllegalArgumentException(`Requested dimensions are too small: ${width}x${height}`);
            let errorCorrectionLevel = ErrorCorrectionLevel.L;
            let quietZone = QRCodeWriter.QUIET_ZONE_SIZE;
            if (hints !== null) {
                if (undefined !== hints.get(EncodeHintType$1.ERROR_CORRECTION)) errorCorrectionLevel = ErrorCorrectionLevel.fromString(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                if (undefined !== hints.get(EncodeHintType$1.MARGIN)) quietZone = Number.parseInt(hints.get(EncodeHintType$1.MARGIN).toString(), 10);
            }
            const code = Encoder.encode(contents, errorCorrectionLevel, hints);
            return QRCodeWriter.renderResult(code, width, height, quietZone);
        }
        // Note that the input matrix uses 0 == white, 1 == black, while the output matrix uses
        // 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
        static renderResult(code, width /*int*/ , height /*int*/ , quietZone /*int*/ ) {
            const input = code.getMatrix();
            if (input === null) throw new IllegalStateException();
            const inputWidth = input.getWidth();
            const inputHeight = input.getHeight();
            const qrWidth = inputWidth + quietZone * 2;
            const qrHeight = inputHeight + quietZone * 2;
            const outputWidth = Math.max(width, qrWidth);
            const outputHeight = Math.max(height, qrHeight);
            const multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
            // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
            // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
            // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
            // handle all the padding from 100x100 (the actual QR) up to 200x160.
            const leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
            const topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
            const output = new BitMatrix(outputWidth, outputHeight);
            for(let inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
                // Write the contents of this row of the barcode
                for(let inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY) === 1) output.setRegion(outputX, outputY, multiple, multiple);
            }
            return output;
        }
    }
    QRCodeWriter.QUIET_ZONE_SIZE = 4;
    /*import java.util.Map;*/ /**
     * This is a factory class which finds the appropriate Writer subclass for the BarcodeFormat
     * requested and encodes the barcode with the supplied contents.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class MultiFormatWriter {
        /*@Override*/ // public encode(contents: string,
        //                         format: BarcodeFormat,
        //                         width: number /*int*/,
        //                         height: number /*int*/): BitMatrix /*throws WriterException */ {
        //   return encode(contents, format, width, height, null)
        // }
        /*@Override*/ encode(contents, format, width /*int*/ , height /*int*/ , hints) {
            let writer;
            switch(format){
                // case BarcodeFormat.EAN_8:
                //   writer = new EAN8Writer()
                //   break
                // case BarcodeFormat.UPC_E:
                //   writer = new UPCEWriter()
                //   break
                // case BarcodeFormat.EAN_13:
                //   writer = new EAN13Writer()
                //   break
                // case BarcodeFormat.UPC_A:
                //   writer = new UPCAWriter()
                //   break
                case BarcodeFormat$1.QR_CODE:
                    writer = new QRCodeWriter();
                    break;
                // case BarcodeFormat.CODE_39:
                //   writer = new Code39Writer()
                //   break
                // case BarcodeFormat.CODE_93:
                //   writer = new Code93Writer()
                //   break
                // case BarcodeFormat.CODE_128:
                //   writer = new Code128Writer()
                //   break
                // case BarcodeFormat.ITF:
                //   writer = new ITFWriter()
                //   break
                // case BarcodeFormat.PDF_417:
                //   writer = new PDF417Writer()
                //   break
                // case BarcodeFormat.CODABAR:
                //   writer = new CodaBarWriter()
                //   break
                // case BarcodeFormat.DATA_MATRIX:
                //   writer = new DataMatrixWriter()
                //   break
                // case BarcodeFormat.AZTEC:
                //   writer = new AztecWriter()
                //   break
                default:
                    throw new IllegalArgumentException('No encoder available for format ' + format);
            }
            return writer.encode(contents, format, width, height, hints);
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This object extends LuminanceSource around an array of YUV data returned from the camera driver,
     * with the option to crop to a rectangle within the full data. This can be used to exclude
     * superfluous pixels around the perimeter and speed up decoding.
     *
     * It works for any pixel format where the Y channel is planar and appears first, including
     * YCbCr_420_SP and YCbCr_422_SP.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class PlanarYUVLuminanceSource extends LuminanceSource {
        constructor(yuvData, dataWidth /*int*/ , dataHeight /*int*/ , left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ , reverseHorizontal){
            super(width, height);
            this.yuvData = yuvData;
            this.dataWidth = dataWidth;
            this.dataHeight = dataHeight;
            this.left = left;
            this.top = top;
            if (left + width > dataWidth || top + height > dataHeight) throw new IllegalArgumentException('Crop rectangle does not fit within image data.');
            if (reverseHorizontal) this.reverseHorizontal(width, height);
        }
        /*@Override*/ getRow(y /*int*/ , row) {
            if (y < 0 || y >= this.getHeight()) throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            const width = this.getWidth();
            if (row === null || row === undefined || row.length < width) row = new Uint8ClampedArray(width);
            const offset = (y + this.top) * this.dataWidth + this.left;
            System.arraycopy(this.yuvData, offset, row, 0, width);
            return row;
        }
        /*@Override*/ getMatrix() {
            const width = this.getWidth();
            const height = this.getHeight();
            // If the caller asks for the entire underlying image, save the copy and give them the
            // original data. The docs specifically warn that result.length must be ignored.
            if (width === this.dataWidth && height === this.dataHeight) return this.yuvData;
            const area = width * height;
            const matrix = new Uint8ClampedArray(area);
            let inputOffset = this.top * this.dataWidth + this.left;
            // If the width matches the full width of the underlying data, perform a single copy.
            if (width === this.dataWidth) {
                System.arraycopy(this.yuvData, inputOffset, matrix, 0, area);
                return matrix;
            }
            // Otherwise copy one cropped row at a time.
            for(let y = 0; y < height; y++){
                const outputOffset = y * width;
                System.arraycopy(this.yuvData, inputOffset, matrix, outputOffset, width);
                inputOffset += this.dataWidth;
            }
            return matrix;
        }
        /*@Override*/ isCropSupported() {
            return true;
        }
        /*@Override*/ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            return new PlanarYUVLuminanceSource(this.yuvData, this.dataWidth, this.dataHeight, this.left + left, this.top + top, width, height, false);
        }
        renderThumbnail() {
            const width = this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            const height = this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            const pixels = new Int32Array(width * height);
            const yuv = this.yuvData;
            let inputOffset = this.top * this.dataWidth + this.left;
            for(let y = 0; y < height; y++){
                const outputOffset = y * width;
                for(let x = 0; x < width; x++){
                    const grey = yuv[inputOffset + x * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR] & 0xff;
                    pixels[outputOffset + x] = 0xFF000000 | grey * 0x00010101;
                }
                inputOffset += this.dataWidth * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            }
            return pixels;
        }
        /**
         * @return width of image from {@link #renderThumbnail()}
         */ getThumbnailWidth() {
            return this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        }
        /**
         * @return height of image from {@link #renderThumbnail()}
         */ getThumbnailHeight() {
            return this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        }
        reverseHorizontal(width /*int*/ , height /*int*/ ) {
            const yuvData = this.yuvData;
            for(let y = 0, rowStart = this.top * this.dataWidth + this.left; y < height; y++, rowStart += this.dataWidth){
                const middle = rowStart + width / 2;
                for(let x1 = rowStart, x2 = rowStart + width - 1; x1 < middle; x1++, x2--){
                    const temp = yuvData[x1];
                    yuvData[x1] = yuvData[x2];
                    yuvData[x2] = temp;
                }
            }
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }
    PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR = 2;
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This class is used to help decode images from files which arrive as RGB data from
     * an ARGB pixel array. It does not support rotation.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Betaminos
     */ class RGBLuminanceSource extends LuminanceSource {
        constructor(luminances, width /*int*/ , height /*int*/ , dataWidth /*int*/ , dataHeight /*int*/ , left /*int*/ , top /*int*/ ){
            super(width, height);
            this.dataWidth = dataWidth;
            this.dataHeight = dataHeight;
            this.left = left;
            this.top = top;
            if (luminances.BYTES_PER_ELEMENT === 4) {
                const size = width * height;
                const luminancesUint8Array = new Uint8ClampedArray(size);
                for(let offset = 0; offset < size; offset++){
                    const pixel = luminances[offset];
                    const r = pixel >> 16 & 0xff; // red
                    const g2 = pixel >> 7 & 0x1fe; // 2 * green
                    const b = pixel & 0xff; // blue
                    // Calculate green-favouring average cheaply
                    luminancesUint8Array[offset] = (r + g2 + b) / 4 & 0xFF;
                }
                this.luminances = luminancesUint8Array;
            } else this.luminances = luminances;
            if (undefined === dataWidth) this.dataWidth = width;
            if (undefined === dataHeight) this.dataHeight = height;
            if (undefined === left) this.left = 0;
            if (undefined === top) this.top = 0;
            if (this.left + width > this.dataWidth || this.top + height > this.dataHeight) throw new IllegalArgumentException('Crop rectangle does not fit within image data.');
        }
        /*@Override*/ getRow(y /*int*/ , row) {
            if (y < 0 || y >= this.getHeight()) throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            const width = this.getWidth();
            if (row === null || row === undefined || row.length < width) row = new Uint8ClampedArray(width);
            const offset = (y + this.top) * this.dataWidth + this.left;
            System.arraycopy(this.luminances, offset, row, 0, width);
            return row;
        }
        /*@Override*/ getMatrix() {
            const width = this.getWidth();
            const height = this.getHeight();
            // If the caller asks for the entire underlying image, save the copy and give them the
            // original data. The docs specifically warn that result.length must be ignored.
            if (width === this.dataWidth && height === this.dataHeight) return this.luminances;
            const area = width * height;
            const matrix = new Uint8ClampedArray(area);
            let inputOffset = this.top * this.dataWidth + this.left;
            // If the width matches the full width of the underlying data, perform a single copy.
            if (width === this.dataWidth) {
                System.arraycopy(this.luminances, inputOffset, matrix, 0, area);
                return matrix;
            }
            // Otherwise copy one cropped row at a time.
            for(let y = 0; y < height; y++){
                const outputOffset = y * width;
                System.arraycopy(this.luminances, inputOffset, matrix, outputOffset, width);
                inputOffset += this.dataWidth;
            }
            return matrix;
        }
        /*@Override*/ isCropSupported() {
            return true;
        }
        /*@Override*/ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            return new RGBLuminanceSource(this.luminances, width, height, this.dataWidth, this.dataHeight, this.left + left, this.top + top);
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }
    /**
     * Just to make a shortcut between Java code and TS code.
     */ class Charset extends CharacterSetECI {
        static forName(name) {
            return this.getCharacterSetECIByName(name);
        }
    }
    /**
     * Just to make a shortcut between Java code and TS code.
     */ class StandardCharsets {
    }
    StandardCharsets.ISO_8859_1 = CharacterSetECI.ISO8859_1;
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * Aztec 2D code representation
     *
     * @author Rustam Abdullaev
     */ /*public final*/ class AztecCode {
        /**
         * @return {@code true} if compact instead of full mode
         */ isCompact() {
            return this.compact;
        }
        setCompact(compact) {
            this.compact = compact;
        }
        /**
         * @return size in pixels (width and height)
         */ getSize() {
            return this.size;
        }
        setSize(size) {
            this.size = size;
        }
        /**
         * @return number of levels
         */ getLayers() {
            return this.layers;
        }
        setLayers(layers) {
            this.layers = layers;
        }
        /**
         * @return number of data codewords
         */ getCodeWords() {
            return this.codeWords;
        }
        setCodeWords(codeWords) {
            this.codeWords = codeWords;
        }
        /**
         * @return the symbol image
         */ getMatrix() {
            return this.matrix;
        }
        setMatrix(matrix) {
            this.matrix = matrix;
        }
    }
    class Collections {
        /**
         * The singletonList(T) method is used to return an immutable list containing only the specified object.
         */ static singletonList(item) {
            return [
                item
            ];
        }
        /**
         * The min(Collection<? extends T>, Comparator<? super T>) method is used to return the minimum element of the given collection, according to the order induced by the specified comparator.
         */ static min(collection, comparator) {
            return collection.sort(comparator)[0];
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ class Token {
        constructor(previous){
            this.previous = previous;
        }
        getPrevious() {
            return this.previous;
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /*final*/ class SimpleToken extends Token {
        constructor(previous, value, bitCount){
            super(previous);
            this.value = value;
            this.bitCount = bitCount;
        }
        /**
         * @Override
         */ appendTo(bitArray, text) {
            bitArray.appendBits(this.value, this.bitCount);
        }
        add(value, bitCount) {
            return new SimpleToken(this, value, bitCount);
        }
        addBinaryShift(start, byteCount) {
            // no-op can't binary shift a simple token
            console.warn('addBinaryShift on SimpleToken, this simply returns a copy of this token');
            return new SimpleToken(this, start, byteCount);
        }
        /**
         * @Override
         */ toString() {
            let value = this.value & (1 << this.bitCount) - 1;
            value |= 1 << this.bitCount;
            return '<' + Integer.toBinaryString(value | 1 << this.bitCount).substring(1) + '>';
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /*final*/ class BinaryShiftToken extends SimpleToken {
        constructor(previous, binaryShiftStart, binaryShiftByteCount){
            super(previous, 0, 0);
            this.binaryShiftStart = binaryShiftStart;
            this.binaryShiftByteCount = binaryShiftByteCount;
        }
        /**
         * @Override
         */ appendTo(bitArray, text) {
            for(let i = 0; i < this.binaryShiftByteCount; i++){
                if (i === 0 || i === 31 && this.binaryShiftByteCount <= 62) {
                    // We need a header before the first character, and before
                    // character 31 when the total byte code is <= 62
                    bitArray.appendBits(31, 5); // BINARY_SHIFT
                    if (this.binaryShiftByteCount > 62) bitArray.appendBits(this.binaryShiftByteCount - 31, 16);
                    else if (i === 0) // 1 <= binaryShiftByteCode <= 62
                    bitArray.appendBits(Math.min(this.binaryShiftByteCount, 31), 5);
                    else // 32 <= binaryShiftCount <= 62 and i == 31
                    bitArray.appendBits(this.binaryShiftByteCount - 31, 5);
                }
                bitArray.appendBits(text[this.binaryShiftStart + i], 8);
            }
        }
        addBinaryShift(start, byteCount) {
            // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
            return new BinaryShiftToken(this, start, byteCount);
        }
        /**
         * @Override
         */ toString() {
            return '<' + this.binaryShiftStart + '::' + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + '>';
        }
    }
    function addBinaryShift(token, start, byteCount) {
        // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
        return new BinaryShiftToken(token, start, byteCount);
    }
    function add(token, value, bitCount) {
        return new SimpleToken(token, value, bitCount);
    }
    const /*final*/ MODE_NAMES = [
        'UPPER',
        'LOWER',
        'DIGIT',
        'MIXED',
        'PUNCT'
    ];
    const /*final*/ MODE_UPPER = 0; // 5 bits
    const /*final*/ MODE_LOWER = 1; // 5 bits
    const /*final*/ MODE_DIGIT = 2; // 4 bits
    const /*final*/ MODE_MIXED = 3; // 5 bits
    const /*final*/ MODE_PUNCT = 4; // 5 bits
    const EMPTY_TOKEN = new SimpleToken(null, 0, 0);
    // The Latch Table shows, for each pair of Modes, the optimal method for
    // getting from one mode to another.  In the worst possible case, this can
    // be up to 14 bits.  In the best possible case, we are already there!
    // The high half-word of each entry gives the number of bits.
    // The low half-word of each entry are the actual bits necessary to change
    const LATCH_TABLE = [
        Int32Array.from([
            0,
            327708,
            327710,
            327709,
            656318 // UPPER -> MIXED -> PUNCT
        ]),
        Int32Array.from([
            590318,
            0,
            327710,
            327709,
            656318 // LOWER -> MIXED -> PUNCT
        ]),
        Int32Array.from([
            262158,
            590300,
            0,
            590301,
            932798
        ]),
        Int32Array.from([
            327709,
            327708,
            656318,
            0,
            327710 // MIXED -> PUNCT
        ]),
        Int32Array.from([
            327711,
            656380,
            656382,
            656381,
            0
        ])
    ];
    function static_SHIFT_TABLE(SHIFT_TABLE) {
        for (let table /*Int32Array*/  of SHIFT_TABLE)Arrays.fill(table, -1);
        SHIFT_TABLE[MODE_UPPER][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_LOWER][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_LOWER][MODE_UPPER] = 28;
        SHIFT_TABLE[MODE_MIXED][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_DIGIT][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_DIGIT][MODE_UPPER] = 15;
        return SHIFT_TABLE;
    }
    const /*final*/ SHIFT_TABLE = static_SHIFT_TABLE(Arrays.createInt32Array(6, 6)); // mode shift codes, per table
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * State represents all information about a sequence necessary to generate the current output.
     * Note that a state is immutable.
     */ /*final*/ class State {
        constructor(token, mode, binaryBytes, bitCount){
            this.token = token;
            this.mode = mode;
            this.binaryShiftByteCount = binaryBytes;
            this.bitCount = bitCount;
        // Make sure we match the token
        // int binaryShiftBitCount = (binaryShiftByteCount * 8) +
        //    (binaryShiftByteCount === 0 ? 0 :
        //     binaryShiftByteCount <= 31 ? 10 :
        //     binaryShiftByteCount <= 62 ? 20 : 21);
        // assert this.bitCount === token.getTotalBitCount() + binaryShiftBitCount;
        }
        getMode() {
            return this.mode;
        }
        getToken() {
            return this.token;
        }
        getBinaryShiftByteCount() {
            return this.binaryShiftByteCount;
        }
        getBitCount() {
            return this.bitCount;
        }
        // Create a new state representing this state with a latch to a (not
        // necessary different) mode, and then a code.
        latchAndAppend(mode, value) {
            // assert binaryShiftByteCount === 0;
            let bitCount = this.bitCount;
            let token = this.token;
            if (mode !== this.mode) {
                let latch = LATCH_TABLE[this.mode][mode];
                token = add(token, latch & 0xffff, latch >> 16);
                bitCount += latch >> 16;
            }
            let latchModeBitCount = mode === MODE_DIGIT ? 4 : 5;
            token = add(token, value, latchModeBitCount);
            return new State(token, mode, 0, bitCount + latchModeBitCount);
        }
        // Create a new state representing this state, with a temporary shift
        // to a different mode to output a single value.
        shiftAndAppend(mode, value) {
            // assert binaryShiftByteCount === 0 && this.mode !== mode;
            let token = this.token;
            let thisModeBitCount = this.mode === MODE_DIGIT ? 4 : 5;
            // Shifts exist only to UPPER and PUNCT, both with tokens size 5.
            token = add(token, SHIFT_TABLE[this.mode][mode], thisModeBitCount);
            token = add(token, value, 5);
            return new State(token, this.mode, 0, this.bitCount + thisModeBitCount + 5);
        }
        // Create a new state representing this state, but an additional character
        // output in Binary Shift mode.
        addBinaryShiftChar(index) {
            let token = this.token;
            let mode = this.mode;
            let bitCount = this.bitCount;
            if (this.mode === MODE_PUNCT || this.mode === MODE_DIGIT) {
                // assert binaryShiftByteCount === 0;
                let latch = LATCH_TABLE[mode][MODE_UPPER];
                token = add(token, latch & 0xffff, latch >> 16);
                bitCount += latch >> 16;
                mode = MODE_UPPER;
            }
            let deltaBitCount = this.binaryShiftByteCount === 0 || this.binaryShiftByteCount === 31 ? 18 : this.binaryShiftByteCount === 62 ? 9 : 8;
            let result = new State(token, mode, this.binaryShiftByteCount + 1, bitCount + deltaBitCount);
            if (result.binaryShiftByteCount === 2078) // The string is as long as it's allowed to be.  We should end it.
            result = result.endBinaryShift(index + 1);
            return result;
        }
        // Create the state identical to this one, but we are no longer in
        // Binary Shift mode.
        endBinaryShift(index) {
            if (this.binaryShiftByteCount === 0) return this;
            let token = this.token;
            token = addBinaryShift(token, index - this.binaryShiftByteCount, this.binaryShiftByteCount);
            // assert token.getTotalBitCount() === this.bitCount;
            return new State(token, this.mode, 0, this.bitCount);
        }
        // Returns true if "this" state is better (equal: or) to be in than "that"
        // state under all possible circumstances.
        isBetterThanOrEqualTo(other) {
            let newModeBitCount = this.bitCount + (LATCH_TABLE[this.mode][other.mode] >> 16);
            if (this.binaryShiftByteCount < other.binaryShiftByteCount) // add additional B/S encoding cost of other, if any
            newModeBitCount += State.calculateBinaryShiftCost(other) - State.calculateBinaryShiftCost(this);
            else if (this.binaryShiftByteCount > other.binaryShiftByteCount && other.binaryShiftByteCount > 0) // maximum possible additional cost (it: h)
            newModeBitCount += 10;
            return newModeBitCount <= other.bitCount;
        }
        toBitArray(text) {
            // Reverse the tokens, so that they are in the order that they should
            // be output
            let symbols = [];
            for(let token = this.endBinaryShift(text.length).token; token !== null; token = token.getPrevious())symbols.unshift(token);
            let bitArray = new BitArray();
            // Add each token to the result.
            for (const symbol of symbols)symbol.appendTo(bitArray, text);
            // assert bitArray.getSize() === this.bitCount;
            return bitArray;
        }
        /**
         * @Override
         */ toString() {
            return StringUtils.format('%s bits=%d bytes=%d', MODE_NAMES[this.mode], this.bitCount, this.binaryShiftByteCount);
        }
        static calculateBinaryShiftCost(state) {
            if (state.binaryShiftByteCount > 62) return 21; // B/S with extended length
            if (state.binaryShiftByteCount > 31) return 20; // two B/S
            if (state.binaryShiftByteCount > 0) return 10; // one B/S
            return 0;
        }
    }
    State.INITIAL_STATE = new State(EMPTY_TOKEN, MODE_UPPER, 0, 0);
    function static_CHAR_MAP(CHAR_MAP) {
        const spaceCharCode = StringUtils.getCharCode(' ');
        const pointCharCode = StringUtils.getCharCode('.');
        const commaCharCode = StringUtils.getCharCode(',');
        CHAR_MAP[MODE_UPPER][spaceCharCode] = 1;
        const zUpperCharCode = StringUtils.getCharCode('Z');
        const aUpperCharCode = StringUtils.getCharCode('A');
        for(let c = aUpperCharCode; c <= zUpperCharCode; c++)CHAR_MAP[MODE_UPPER][c] = c - aUpperCharCode + 2;
        CHAR_MAP[MODE_LOWER][spaceCharCode] = 1;
        const zLowerCharCode = StringUtils.getCharCode('z');
        const aLowerCharCode = StringUtils.getCharCode('a');
        for(let c = aLowerCharCode; c <= zLowerCharCode; c++)CHAR_MAP[MODE_LOWER][c] = c - aLowerCharCode + 2;
        CHAR_MAP[MODE_DIGIT][spaceCharCode] = 1;
        const nineCharCode = StringUtils.getCharCode('9');
        const zeroCharCode = StringUtils.getCharCode('0');
        for(let c = zeroCharCode; c <= nineCharCode; c++)CHAR_MAP[MODE_DIGIT][c] = c - zeroCharCode + 2;
        CHAR_MAP[MODE_DIGIT][commaCharCode] = 12;
        CHAR_MAP[MODE_DIGIT][pointCharCode] = 13;
        const mixedTable = [
            '\x00',
            ' ',
            '\x01',
            '\x02',
            '\x03',
            '\x04',
            '\x05',
            '\x06',
            '\x07',
            '\b',
            '\t',
            '\n',
            '\x0b',
            '\f',
            '\r',
            '\x1b',
            '\x1c',
            '\x1d',
            '\x1e',
            '\x1f',
            '@',
            '\\',
            '^',
            '_',
            '`',
            '|',
            '~',
            '\x7f'
        ];
        for(let i = 0; i < mixedTable.length; i++)CHAR_MAP[MODE_MIXED][StringUtils.getCharCode(mixedTable[i])] = i;
        const punctTable = [
            '\x00',
            '\r',
            '\x00',
            '\x00',
            '\x00',
            '\x00',
            '!',
            '\'',
            '#',
            '$',
            '%',
            '&',
            '\'',
            '(',
            ')',
            '*',
            '+',
            ',',
            '-',
            '.',
            '/',
            ':',
            ';',
            '<',
            '=',
            '>',
            '?',
            '[',
            ']',
            '{',
            '}'
        ];
        for(let i = 0; i < punctTable.length; i++)if (StringUtils.getCharCode(punctTable[i]) > 0) CHAR_MAP[MODE_PUNCT][StringUtils.getCharCode(punctTable[i])] = i;
        return CHAR_MAP;
    }
    const CHAR_MAP = static_CHAR_MAP(Arrays.createInt32Array(5, 256));
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This produces nearly optimal encodings of text into the first-level of
     * encoding used by Aztec code.
     *
     * It uses a dynamic algorithm.  For each prefix of the string, it determines
     * a set of encodings that could lead to this prefix.  We repeatedly add a
     * character and generate a new set of optimal encodings until we have read
     * through the entire input.
     *
     * @author Frank Yellin
     * @author Rustam Abdullaev
     */ /*public final*/ class HighLevelEncoder {
        constructor(text){
            this.text = text;
        }
        /**
         * @return text represented by this encoder encoded as a {@link BitArray}
         */ encode() {
            const spaceCharCode = StringUtils.getCharCode(' ');
            const lineBreakCharCode = StringUtils.getCharCode('\n');
            let states = Collections.singletonList(State.INITIAL_STATE);
            for(let index = 0; index < this.text.length; index++){
                let pairCode;
                let nextChar = index + 1 < this.text.length ? this.text[index + 1] : 0;
                switch(this.text[index]){
                    case StringUtils.getCharCode('\r'):
                        pairCode = nextChar === lineBreakCharCode ? 2 : 0;
                        break;
                    case StringUtils.getCharCode('.'):
                        pairCode = nextChar === spaceCharCode ? 3 : 0;
                        break;
                    case StringUtils.getCharCode(','):
                        pairCode = nextChar === spaceCharCode ? 4 : 0;
                        break;
                    case StringUtils.getCharCode(':'):
                        pairCode = nextChar === spaceCharCode ? 5 : 0;
                        break;
                    default:
                        pairCode = 0;
                }
                if (pairCode > 0) {
                    // We have one of the four special PUNCT pairs.  Treat them specially.
                    // Get a new set of states for the two new characters.
                    states = HighLevelEncoder.updateStateListForPair(states, index, pairCode);
                    index++;
                } else // Get a new set of states for the new character.
                states = this.updateStateListForChar(states, index);
            }
            // We are left with a set of states.  Find the shortest one.
            const minState = Collections.min(states, (a, b)=>{
                return a.getBitCount() - b.getBitCount();
            });
            // Convert it to a bit array, and return.
            return minState.toBitArray(this.text);
        }
        // We update a set of states for a new character by updating each state
        // for the new character, merging the results, and then removing the
        // non-optimal states.
        updateStateListForChar(states, index) {
            const result = [];
            for (let state /*State*/  of states)this.updateStateForChar(state, index, result);
            return HighLevelEncoder.simplifyStates(result);
        }
        // Return a set of states that represent the possible ways of updating this
        // state for the next character.  The resulting set of states are added to
        // the "result" list.
        updateStateForChar(state, index, result) {
            let ch = this.text[index] & 0xff;
            let charInCurrentTable = CHAR_MAP[state.getMode()][ch] > 0;
            let stateNoBinary = null;
            for(let mode /*int*/  = 0; mode <= MODE_PUNCT; mode++){
                let charInMode = CHAR_MAP[mode][ch];
                if (charInMode > 0) {
                    if (stateNoBinary == null) // Only create stateNoBinary the first time it's required.
                    stateNoBinary = state.endBinaryShift(index);
                    // Try generating the character by latching to its mode
                    if (!charInCurrentTable || mode === state.getMode() || mode === MODE_DIGIT) {
                        // If the character is in the current table, we don't want to latch to
                        // any other mode except possibly digit (which uses only 4 bits).  Any
                        // other latch would be equally successful *after* this character, and
                        // so wouldn't save any bits.
                        const latchState = stateNoBinary.latchAndAppend(mode, charInMode);
                        result.push(latchState);
                    }
                    // Try generating the character by switching to its mode.
                    if (!charInCurrentTable && SHIFT_TABLE[state.getMode()][mode] >= 0) {
                        // It never makes sense to temporarily shift to another mode if the
                        // character exists in the current mode.  That can never save bits.
                        const shiftState = stateNoBinary.shiftAndAppend(mode, charInMode);
                        result.push(shiftState);
                    }
                }
            }
            if (state.getBinaryShiftByteCount() > 0 || CHAR_MAP[state.getMode()][ch] === 0) {
                // It's never worthwhile to go into binary shift mode if you're not already
                // in binary shift mode, and the character exists in your current mode.
                // That can never save bits over just outputting the char in the current mode.
                let binaryState = state.addBinaryShiftChar(index);
                result.push(binaryState);
            }
        }
        static updateStateListForPair(states, index, pairCode) {
            const result = [];
            for (let state /*State*/  of states)this.updateStateForPair(state, index, pairCode, result);
            return this.simplifyStates(result);
        }
        static updateStateForPair(state, index, pairCode, result) {
            let stateNoBinary = state.endBinaryShift(index);
            // Possibility 1.  Latch to C.MODE_PUNCT, and then append this code
            result.push(stateNoBinary.latchAndAppend(MODE_PUNCT, pairCode));
            if (state.getMode() !== MODE_PUNCT) // Possibility 2.  Shift to C.MODE_PUNCT, and then append this code.
            // Every state except C.MODE_PUNCT (handled above) can shift
            result.push(stateNoBinary.shiftAndAppend(MODE_PUNCT, pairCode));
            if (pairCode === 3 || pairCode === 4) {
                // both characters are in DIGITS.  Sometimes better to just add two digits
                let digitState = stateNoBinary.latchAndAppend(MODE_DIGIT, 16 - pairCode) // period or comma in DIGIT
                .latchAndAppend(MODE_DIGIT, 1); // space in DIGIT
                result.push(digitState);
            }
            if (state.getBinaryShiftByteCount() > 0) {
                // It only makes sense to do the characters as binary if we're already
                // in binary mode.
                let binaryState = state.addBinaryShiftChar(index).addBinaryShiftChar(index + 1);
                result.push(binaryState);
            }
        }
        static simplifyStates(states) {
            let result = [];
            for (const newState of states){
                let add = true;
                for (const oldState of result){
                    if (oldState.isBetterThanOrEqualTo(newState)) {
                        add = false;
                        break;
                    }
                    if (newState.isBetterThanOrEqualTo(oldState)) // iterator.remove();
                    result = result.filter((x)=>x !== oldState); // remove old state
                }
                if (add) result.push(newState);
            }
            return result;
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.aztec.encoder;
    // import com.google.zxing.common.BitArray;
    // import com.google.zxing.common.BitMatrix;
    // import com.google.zxing.common.reedsolomon.GenericGF;
    // import com.google.zxing.common.reedsolomon.ReedSolomonEncoder;
    /**
     * Generates Aztec 2D barcodes.
     *
     * @author Rustam Abdullaev
     */ /*public final*/ class Encoder$1 {
        constructor(){}
        /**
         * Encodes the given binary content as an Aztec symbol
         *
         * @param data input data string
         * @return Aztec symbol matrix with metadata
         */ static encodeBytes(data) {
            return Encoder$1.encode(data, Encoder$1.DEFAULT_EC_PERCENT, Encoder$1.DEFAULT_AZTEC_LAYERS);
        }
        /**
         * Encodes the given binary content as an Aztec symbol
         *
         * @param data input data string
         * @param minECCPercent minimal percentage of error check words (According to ISO/IEC 24778:2008,
         *                      a minimum of 23% + 3 words is recommended)
         * @param userSpecifiedLayers if non-zero, a user-specified value for the number of layers
         * @return Aztec symbol matrix with metadata
         */ static encode(data, minECCPercent, userSpecifiedLayers) {
            // High-level encode
            let bits = new HighLevelEncoder(data).encode();
            // stuff bits and choose symbol size
            let eccBits = Integer.truncDivision(bits.getSize() * minECCPercent, 100) + 11;
            let totalSizeBits = bits.getSize() + eccBits;
            let compact;
            let layers;
            let totalBitsInLayer;
            let wordSize;
            let stuffedBits;
            if (userSpecifiedLayers !== Encoder$1.DEFAULT_AZTEC_LAYERS) {
                compact = userSpecifiedLayers < 0;
                layers = Math.abs(userSpecifiedLayers);
                if (layers > (compact ? Encoder$1.MAX_NB_BITS_COMPACT : Encoder$1.MAX_NB_BITS)) throw new IllegalArgumentException(StringUtils.format('Illegal value %s for layers', userSpecifiedLayers));
                totalBitsInLayer = Encoder$1.totalBitsInLayer(layers, compact);
                wordSize = Encoder$1.WORD_SIZE[layers];
                let usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
                stuffedBits = Encoder$1.stuffBits(bits, wordSize);
                if (stuffedBits.getSize() + eccBits > usableBitsInLayers) throw new IllegalArgumentException('Data to large for user specified layer');
                if (compact && stuffedBits.getSize() > wordSize * 64) // Compact format only allows 64 data words, though C4 can hold more words than that
                throw new IllegalArgumentException('Data to large for user specified layer');
            } else {
                wordSize = 0;
                stuffedBits = null;
                // We look at the possible table sizes in the order Compact1, Compact2, Compact3,
                // Compact4, Normal4,...  Normal(i) for i < 4 isn't typically used since Compact(i+1)
                // is the same size, but has more data.
                for(let i /*int*/  = 0;; i++){
                    if (i > Encoder$1.MAX_NB_BITS) throw new IllegalArgumentException('Data too large for an Aztec code');
                    compact = i <= 3;
                    layers = compact ? i + 1 : i;
                    totalBitsInLayer = Encoder$1.totalBitsInLayer(layers, compact);
                    if (totalSizeBits > totalBitsInLayer) continue;
                    // [Re]stuff the bits if this is the first opportunity, or if the
                    // wordSize has changed
                    if (stuffedBits == null || wordSize !== Encoder$1.WORD_SIZE[layers]) {
                        wordSize = Encoder$1.WORD_SIZE[layers];
                        stuffedBits = Encoder$1.stuffBits(bits, wordSize);
                    }
                    let usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
                    if (compact && stuffedBits.getSize() > wordSize * 64) continue;
                    if (stuffedBits.getSize() + eccBits <= usableBitsInLayers) break;
                }
            }
            let messageBits = Encoder$1.generateCheckWords(stuffedBits, totalBitsInLayer, wordSize);
            // generate mode message
            let messageSizeInWords = stuffedBits.getSize() / wordSize;
            let modeMessage = Encoder$1.generateModeMessage(compact, layers, messageSizeInWords);
            // allocate symbol
            let baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
            let alignmentMap = new Int32Array(baseMatrixSize);
            let matrixSize;
            if (compact) {
                // no alignment marks in compact mode, alignmentMap is a no-op
                matrixSize = baseMatrixSize;
                for(let i /*int*/  = 0; i < alignmentMap.length; i++)alignmentMap[i] = i;
            } else {
                matrixSize = baseMatrixSize + 1 + 2 * Integer.truncDivision(Integer.truncDivision(baseMatrixSize, 2) - 1, 15);
                let origCenter = Integer.truncDivision(baseMatrixSize, 2);
                let center = Integer.truncDivision(matrixSize, 2);
                for(let i /*int*/  = 0; i < origCenter; i++){
                    let newOffset = i + Integer.truncDivision(i, 15);
                    alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                    alignmentMap[origCenter + i] = center + newOffset + 1;
                }
            }
            let matrix = new BitMatrix(matrixSize);
            // draw data bits
            for(let i /*int*/  = 0, rowOffset = 0; i < layers; i++){
                let rowSize = (layers - i) * 4 + (compact ? 9 : 12);
                for(let j /*int*/  = 0; j < rowSize; j++){
                    let columnOffset = j * 2;
                    for(let k /*int*/  = 0; k < 2; k++){
                        if (messageBits.get(rowOffset + columnOffset + k)) matrix.set(alignmentMap[i * 2 + k], alignmentMap[i * 2 + j]);
                        if (messageBits.get(rowOffset + rowSize * 2 + columnOffset + k)) matrix.set(alignmentMap[i * 2 + j], alignmentMap[baseMatrixSize - 1 - i * 2 - k]);
                        if (messageBits.get(rowOffset + rowSize * 4 + columnOffset + k)) matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - k], alignmentMap[baseMatrixSize - 1 - i * 2 - j]);
                        if (messageBits.get(rowOffset + rowSize * 6 + columnOffset + k)) matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - j], alignmentMap[i * 2 + k]);
                    }
                }
                rowOffset += rowSize * 8;
            }
            // draw mode message
            Encoder$1.drawModeMessage(matrix, compact, matrixSize, modeMessage);
            // draw alignment marks
            if (compact) Encoder$1.drawBullsEye(matrix, Integer.truncDivision(matrixSize, 2), 5);
            else {
                Encoder$1.drawBullsEye(matrix, Integer.truncDivision(matrixSize, 2), 7);
                for(let i /*int*/  = 0, j = 0; i < Integer.truncDivision(baseMatrixSize, 2) - 1; i += 15, j += 16)for(let k /*int*/  = Integer.truncDivision(matrixSize, 2) & 1; k < matrixSize; k += 2){
                    matrix.set(Integer.truncDivision(matrixSize, 2) - j, k);
                    matrix.set(Integer.truncDivision(matrixSize, 2) + j, k);
                    matrix.set(k, Integer.truncDivision(matrixSize, 2) - j);
                    matrix.set(k, Integer.truncDivision(matrixSize, 2) + j);
                }
            }
            let aztec = new AztecCode();
            aztec.setCompact(compact);
            aztec.setSize(matrixSize);
            aztec.setLayers(layers);
            aztec.setCodeWords(messageSizeInWords);
            aztec.setMatrix(matrix);
            return aztec;
        }
        static drawBullsEye(matrix, center, size) {
            for(let i /*int*/  = 0; i < size; i += 2)for(let j /*int*/  = center - i; j <= center + i; j++){
                matrix.set(j, center - i);
                matrix.set(j, center + i);
                matrix.set(center - i, j);
                matrix.set(center + i, j);
            }
            matrix.set(center - size, center - size);
            matrix.set(center - size + 1, center - size);
            matrix.set(center - size, center - size + 1);
            matrix.set(center + size, center - size);
            matrix.set(center + size, center - size + 1);
            matrix.set(center + size, center + size - 1);
        }
        static generateModeMessage(compact, layers, messageSizeInWords) {
            let modeMessage = new BitArray();
            if (compact) {
                modeMessage.appendBits(layers - 1, 2);
                modeMessage.appendBits(messageSizeInWords - 1, 6);
                modeMessage = Encoder$1.generateCheckWords(modeMessage, 28, 4);
            } else {
                modeMessage.appendBits(layers - 1, 5);
                modeMessage.appendBits(messageSizeInWords - 1, 11);
                modeMessage = Encoder$1.generateCheckWords(modeMessage, 40, 4);
            }
            return modeMessage;
        }
        static drawModeMessage(matrix, compact, matrixSize, modeMessage) {
            let center = Integer.truncDivision(matrixSize, 2);
            if (compact) for(let i /*int*/  = 0; i < 7; i++){
                let offset = center - 3 + i;
                if (modeMessage.get(i)) matrix.set(offset, center - 5);
                if (modeMessage.get(i + 7)) matrix.set(center + 5, offset);
                if (modeMessage.get(20 - i)) matrix.set(offset, center + 5);
                if (modeMessage.get(27 - i)) matrix.set(center - 5, offset);
            }
            else for(let i /*int*/  = 0; i < 10; i++){
                let offset = center - 5 + i + Integer.truncDivision(i, 5);
                if (modeMessage.get(i)) matrix.set(offset, center - 7);
                if (modeMessage.get(i + 10)) matrix.set(center + 7, offset);
                if (modeMessage.get(29 - i)) matrix.set(offset, center + 7);
                if (modeMessage.get(39 - i)) matrix.set(center - 7, offset);
            }
        }
        static generateCheckWords(bitArray, totalBits, wordSize) {
            // bitArray is guaranteed to be a multiple of the wordSize, so no padding needed
            let messageSizeInWords = bitArray.getSize() / wordSize;
            let rs = new ReedSolomonEncoder(Encoder$1.getGF(wordSize));
            let totalWords = Integer.truncDivision(totalBits, wordSize);
            let messageWords = Encoder$1.bitsToWords(bitArray, wordSize, totalWords);
            rs.encode(messageWords, totalWords - messageSizeInWords);
            let startPad = totalBits % wordSize;
            let messageBits = new BitArray();
            messageBits.appendBits(0, startPad);
            for (const messageWord /*: int*/  of Array.from(messageWords))messageBits.appendBits(messageWord, wordSize);
            return messageBits;
        }
        static bitsToWords(stuffedBits, wordSize, totalWords) {
            let message = new Int32Array(totalWords);
            let i;
            let n;
            for(i = 0, n = stuffedBits.getSize() / wordSize; i < n; i++){
                let value = 0;
                for(let j /*int*/  = 0; j < wordSize; j++)value |= stuffedBits.get(i * wordSize + j) ? 1 << wordSize - j - 1 : 0;
                message[i] = value;
            }
            return message;
        }
        static getGF(wordSize) {
            switch(wordSize){
                case 4:
                    return GenericGF.AZTEC_PARAM;
                case 6:
                    return GenericGF.AZTEC_DATA_6;
                case 8:
                    return GenericGF.AZTEC_DATA_8;
                case 10:
                    return GenericGF.AZTEC_DATA_10;
                case 12:
                    return GenericGF.AZTEC_DATA_12;
                default:
                    throw new IllegalArgumentException('Unsupported word size ' + wordSize);
            }
        }
        static stuffBits(bits, wordSize) {
            let out = new BitArray();
            let n = bits.getSize();
            let mask = (1 << wordSize) - 2;
            for(let i /*int*/  = 0; i < n; i += wordSize){
                let word = 0;
                for(let j /*int*/  = 0; j < wordSize; j++)if (i + j >= n || bits.get(i + j)) word |= 1 << wordSize - 1 - j;
                if ((word & mask) === mask) {
                    out.appendBits(word & mask, wordSize);
                    i--;
                } else if ((word & mask) === 0) {
                    out.appendBits(word | 1, wordSize);
                    i--;
                } else out.appendBits(word, wordSize);
            }
            return out;
        }
        static totalBitsInLayer(layers, compact) {
            return ((compact ? 88 : 112) + 16 * layers) * layers;
        }
    }
    Encoder$1.DEFAULT_EC_PERCENT = 33; // default minimal percentage of error check words
    Encoder$1.DEFAULT_AZTEC_LAYERS = 0;
    Encoder$1.MAX_NB_BITS = 32;
    Encoder$1.MAX_NB_BITS_COMPACT = 4;
    Encoder$1.WORD_SIZE = Int32Array.from([
        4,
        6,
        6,
        8,
        8,
        8,
        8,
        8,
        8,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12
    ]);
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * Renders an Aztec code as a {@link BitMatrix}.
     */ /*public final*/ class AztecWriter {
        // @Override
        encode(contents, format, width, height) {
            return this.encodeWithHints(contents, format, width, height, null);
        }
        // @Override
        encodeWithHints(contents, format, width, height, hints) {
            let charset = StandardCharsets.ISO_8859_1;
            let eccPercent = Encoder$1.DEFAULT_EC_PERCENT;
            let layers = Encoder$1.DEFAULT_AZTEC_LAYERS;
            if (hints != null) {
                if (hints.has(EncodeHintType$1.CHARACTER_SET)) charset = Charset.forName(hints.get(EncodeHintType$1.CHARACTER_SET).toString());
                if (hints.has(EncodeHintType$1.ERROR_CORRECTION)) eccPercent = Integer.parseInt(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                if (hints.has(EncodeHintType$1.AZTEC_LAYERS)) layers = Integer.parseInt(hints.get(EncodeHintType$1.AZTEC_LAYERS).toString());
            }
            return AztecWriter.encodeLayers(contents, format, width, height, charset, eccPercent, layers);
        }
        static encodeLayers(contents, format, width, height, charset, eccPercent, layers) {
            if (format !== BarcodeFormat$1.AZTEC) throw new IllegalArgumentException('Can only encode AZTEC, but got ' + format);
            let aztec = Encoder$1.encode(StringUtils.getBytes(contents, charset), eccPercent, layers);
            return AztecWriter.renderResult(aztec, width, height);
        }
        static renderResult(code, width, height) {
            let input = code.getMatrix();
            if (input == null) throw new IllegalStateException();
            let inputWidth = input.getWidth();
            let inputHeight = input.getHeight();
            let outputWidth = Math.max(width, inputWidth);
            let outputHeight = Math.max(height, inputHeight);
            let multiple = Math.min(outputWidth / inputWidth, outputHeight / inputHeight);
            let leftPadding = (outputWidth - inputWidth * multiple) / 2;
            let topPadding = (outputHeight - inputHeight * multiple) / 2;
            let output = new BitMatrix(outputWidth, outputHeight);
            for(let inputY /*int*/  = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
                // Write the contents of this row of the barcode
                for(let inputX /*int*/  = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY)) output.setRegion(outputX, outputY, multiple, multiple);
            }
            return output;
        }
    }
    exports1.AbstractExpandedDecoder = AbstractExpandedDecoder;
    exports1.ArgumentException = ArgumentException;
    exports1.ArithmeticException = ArithmeticException;
    exports1.AztecCode = AztecCode;
    exports1.AztecCodeReader = AztecReader;
    exports1.AztecCodeWriter = AztecWriter;
    exports1.AztecDecoder = Decoder;
    exports1.AztecDetector = Detector;
    exports1.AztecDetectorResult = AztecDetectorResult;
    exports1.AztecEncoder = Encoder$1;
    exports1.AztecHighLevelEncoder = HighLevelEncoder;
    exports1.AztecPoint = Point;
    exports1.BarcodeFormat = BarcodeFormat$1;
    exports1.Binarizer = Binarizer;
    exports1.BinaryBitmap = BinaryBitmap;
    exports1.BitArray = BitArray;
    exports1.BitMatrix = BitMatrix;
    exports1.BitSource = BitSource;
    exports1.BrowserAztecCodeReader = BrowserAztecCodeReader;
    exports1.BrowserBarcodeReader = BrowserBarcodeReader;
    exports1.BrowserCodeReader = BrowserCodeReader;
    exports1.BrowserDatamatrixCodeReader = BrowserDatamatrixCodeReader;
    exports1.BrowserMultiFormatReader = BrowserMultiFormatReader;
    exports1.BrowserPDF417Reader = BrowserPDF417Reader;
    exports1.BrowserQRCodeReader = BrowserQRCodeReader;
    exports1.BrowserQRCodeSvgWriter = BrowserQRCodeSvgWriter;
    exports1.CharacterSetECI = CharacterSetECI;
    exports1.ChecksumException = ChecksumException;
    exports1.Code128Reader = Code128Reader;
    exports1.Code39Reader = Code39Reader;
    exports1.DataMatrixDecodedBitStreamParser = DecodedBitStreamParser;
    exports1.DataMatrixReader = DataMatrixReader;
    exports1.DecodeHintType = DecodeHintType$1;
    exports1.DecoderResult = DecoderResult;
    exports1.DefaultGridSampler = DefaultGridSampler;
    exports1.DetectorResult = DetectorResult;
    exports1.EAN13Reader = EAN13Reader;
    exports1.EncodeHintType = EncodeHintType$1;
    exports1.Exception = Exception;
    exports1.FormatException = FormatException;
    exports1.GenericGF = GenericGF;
    exports1.GenericGFPoly = GenericGFPoly;
    exports1.GlobalHistogramBinarizer = GlobalHistogramBinarizer;
    exports1.GridSampler = GridSampler;
    exports1.GridSamplerInstance = GridSamplerInstance;
    exports1.HTMLCanvasElementLuminanceSource = HTMLCanvasElementLuminanceSource;
    exports1.HybridBinarizer = HybridBinarizer;
    exports1.ITFReader = ITFReader;
    exports1.IllegalArgumentException = IllegalArgumentException;
    exports1.IllegalStateException = IllegalStateException;
    exports1.InvertedLuminanceSource = InvertedLuminanceSource;
    exports1.LuminanceSource = LuminanceSource;
    exports1.MathUtils = MathUtils;
    exports1.MultiFormatOneDReader = MultiFormatOneDReader;
    exports1.MultiFormatReader = MultiFormatReader;
    exports1.MultiFormatWriter = MultiFormatWriter;
    exports1.NotFoundException = NotFoundException;
    exports1.OneDReader = OneDReader;
    exports1.PDF417DecodedBitStreamParser = DecodedBitStreamParser$2;
    exports1.PDF417DecoderErrorCorrection = ErrorCorrection;
    exports1.PDF417Reader = PDF417Reader;
    exports1.PDF417ResultMetadata = PDF417ResultMetadata;
    exports1.PerspectiveTransform = PerspectiveTransform;
    exports1.PlanarYUVLuminanceSource = PlanarYUVLuminanceSource;
    exports1.QRCodeByteMatrix = ByteMatrix;
    exports1.QRCodeDataMask = DataMask;
    exports1.QRCodeDecodedBitStreamParser = DecodedBitStreamParser$1;
    exports1.QRCodeDecoderErrorCorrectionLevel = ErrorCorrectionLevel;
    exports1.QRCodeDecoderFormatInformation = FormatInformation;
    exports1.QRCodeEncoder = Encoder;
    exports1.QRCodeEncoderQRCode = QRCode;
    exports1.QRCodeMaskUtil = MaskUtil;
    exports1.QRCodeMatrixUtil = MatrixUtil;
    exports1.QRCodeMode = Mode$1;
    exports1.QRCodeReader = QRCodeReader;
    exports1.QRCodeVersion = Version$1;
    exports1.QRCodeWriter = QRCodeWriter;
    exports1.RGBLuminanceSource = RGBLuminanceSource;
    exports1.RSS14Reader = RSS14Reader;
    exports1.RSSExpandedReader = RSSExpandedReader;
    exports1.ReaderException = ReaderException;
    exports1.ReedSolomonDecoder = ReedSolomonDecoder;
    exports1.ReedSolomonEncoder = ReedSolomonEncoder;
    exports1.ReedSolomonException = ReedSolomonException;
    exports1.Result = Result;
    exports1.ResultMetadataType = ResultMetadataType$1;
    exports1.ResultPoint = ResultPoint;
    exports1.StringUtils = StringUtils;
    exports1.UnsupportedOperationException = UnsupportedOperationException;
    exports1.VideoInputDevice = VideoInputDevice;
    exports1.WhiteRectangleDetector = WhiteRectangleDetector;
    exports1.WriterException = WriterException;
    exports1.ZXingArrays = Arrays;
    exports1.ZXingCharset = Charset;
    exports1.ZXingInteger = Integer;
    exports1.ZXingStandardCharsets = StandardCharsets;
    exports1.ZXingStringBuilder = StringBuilder;
    exports1.ZXingStringEncoding = StringEncoding;
    exports1.ZXingSystem = System;
    exports1.createAbstractExpandedDecoder = createDecoder;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});



var $2f1ec72091fbd6cf$export$12d67355bcc453ab = function() {
    function ZXingHtml5QrcodeDecoder(requestedFormats, verbose, logger) {
        this.formatMap = new Map([
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).QR_CODE,
                $56054c647abd5197$exports.BarcodeFormat.QR_CODE
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).AZTEC,
                $56054c647abd5197$exports.BarcodeFormat.AZTEC
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODABAR,
                $56054c647abd5197$exports.BarcodeFormat.CODABAR
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_39,
                $56054c647abd5197$exports.BarcodeFormat.CODE_39
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_93,
                $56054c647abd5197$exports.BarcodeFormat.CODE_93
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_128,
                $56054c647abd5197$exports.BarcodeFormat.CODE_128
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).DATA_MATRIX,
                $56054c647abd5197$exports.BarcodeFormat.DATA_MATRIX
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).MAXICODE,
                $56054c647abd5197$exports.BarcodeFormat.MAXICODE
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).ITF,
                $56054c647abd5197$exports.BarcodeFormat.ITF
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_13,
                $56054c647abd5197$exports.BarcodeFormat.EAN_13
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_8,
                $56054c647abd5197$exports.BarcodeFormat.EAN_8
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).PDF_417,
                $56054c647abd5197$exports.BarcodeFormat.PDF_417
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_14,
                $56054c647abd5197$exports.BarcodeFormat.RSS_14
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_EXPANDED,
                $56054c647abd5197$exports.BarcodeFormat.RSS_EXPANDED
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_A,
                $56054c647abd5197$exports.BarcodeFormat.UPC_A
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_E,
                $56054c647abd5197$exports.BarcodeFormat.UPC_E
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_EAN_EXTENSION,
                $56054c647abd5197$exports.BarcodeFormat.UPC_EAN_EXTENSION
            ]
        ]);
        this.reverseFormatMap = this.createReverseFormatMap();
        if (!$56054c647abd5197$exports) throw "Use html5qrcode.min.js without edit, ZXing not found.";
        this.verbose = verbose;
        this.logger = logger;
        var formats = this.createZXingFormats(requestedFormats);
        var hints = new Map();
        hints.set($56054c647abd5197$exports.DecodeHintType.POSSIBLE_FORMATS, formats);
        hints.set($56054c647abd5197$exports.DecodeHintType.TRY_HARDER, false);
        this.hints = hints;
    }
    ZXingHtml5QrcodeDecoder.prototype.decodeAsync = function(canvas) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            try {
                resolve(_this.decode(canvas));
            } catch (error) {
                reject(error);
            }
        });
    };
    ZXingHtml5QrcodeDecoder.prototype.decode = function(canvas) {
        var zxingDecoder = new $56054c647abd5197$exports.MultiFormatReader(this.verbose, this.hints);
        var luminanceSource = new $56054c647abd5197$exports.HTMLCanvasElementLuminanceSource(canvas);
        var binaryBitmap = new $56054c647abd5197$exports.BinaryBitmap(new $56054c647abd5197$exports.HybridBinarizer(luminanceSource));
        var result = zxingDecoder.decode(binaryBitmap);
        return {
            text: result.text,
            format: (0, $c9d6d3563c261b0e$export$96706046d68ee585).create(this.toHtml5QrcodeSupportedFormats(result.format)),
            debugData: this.createDebugData()
        };
    };
    ZXingHtml5QrcodeDecoder.prototype.createReverseFormatMap = function() {
        var result = new Map();
        this.formatMap.forEach(function(value, key, _) {
            result.set(value, key);
        });
        return result;
    };
    ZXingHtml5QrcodeDecoder.prototype.toHtml5QrcodeSupportedFormats = function(zxingFormat) {
        if (!this.reverseFormatMap.has(zxingFormat)) throw "reverseFormatMap doesn't have ".concat(zxingFormat);
        return this.reverseFormatMap.get(zxingFormat);
    };
    ZXingHtml5QrcodeDecoder.prototype.createZXingFormats = function(requestedFormats) {
        var zxingFormats = [];
        for(var _i = 0, requestedFormats_1 = requestedFormats; _i < requestedFormats_1.length; _i++){
            var requestedFormat = requestedFormats_1[_i];
            if (this.formatMap.has(requestedFormat)) zxingFormats.push(this.formatMap.get(requestedFormat));
            else this.logger.logError("".concat(requestedFormat, " is not supported by") + "ZXingHtml5QrcodeShim");
        }
        return zxingFormats;
    };
    ZXingHtml5QrcodeDecoder.prototype.createDebugData = function() {
        return {
            decoderName: "zxing-js"
        };
    };
    return ZXingHtml5QrcodeDecoder;
}();



var $d03d3b448ea1788a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d03d3b448ea1788a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d03d3b448ea1788a$export$199d29c1710b56b6 = function() {
    function BarcodeDetectorDelegate(requestedFormats, verbose, logger) {
        this.formatMap = new Map([
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).QR_CODE,
                "qr_code"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).AZTEC,
                "aztec"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODABAR,
                "codabar"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_39,
                "code_39"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_93,
                "code_93"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_128,
                "code_128"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).DATA_MATRIX,
                "data_matrix"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).ITF,
                "itf"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_13,
                "ean_13"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_8,
                "ean_8"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).PDF_417,
                "pdf417"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_A,
                "upc_a"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_E,
                "upc_e"
            ]
        ]);
        this.reverseFormatMap = this.createReverseFormatMap();
        if (!BarcodeDetectorDelegate.isSupported()) throw "Use html5qrcode.min.js without edit, Use BarcodeDetectorDelegate only if it isSupported();";
        this.verbose = verbose;
        this.logger = logger;
        var formats = this.createBarcodeDetectorFormats(requestedFormats);
        this.detector = new BarcodeDetector(formats);
        if (!this.detector) throw "BarcodeDetector detector not supported";
    }
    BarcodeDetectorDelegate.isSupported = function() {
        if (!("BarcodeDetector" in window)) return false;
        var dummyDetector = new BarcodeDetector({
            formats: [
                "qr_code"
            ]
        });
        return typeof dummyDetector !== "undefined";
    };
    BarcodeDetectorDelegate.prototype.decodeAsync = function(canvas) {
        return $d03d3b448ea1788a$var$__awaiter(this, void 0, void 0, function() {
            var barcodes, largestBarcode;
            return $d03d3b448ea1788a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.detector.detect(canvas)
                        ];
                    case 1:
                        barcodes = _a.sent();
                        if (!barcodes || barcodes.length === 0) throw "No barcode or QR code detected.";
                        largestBarcode = this.selectLargestBarcode(barcodes);
                        return [
                            2,
                            {
                                text: largestBarcode.rawValue,
                                format: (0, $c9d6d3563c261b0e$export$96706046d68ee585).create(this.toHtml5QrcodeSupportedFormats(largestBarcode.format)),
                                debugData: this.createDebugData()
                            }
                        ];
                }
            });
        });
    };
    BarcodeDetectorDelegate.prototype.selectLargestBarcode = function(barcodes) {
        var largestBarcode = null;
        var maxArea = 0;
        for(var _i = 0, barcodes_1 = barcodes; _i < barcodes_1.length; _i++){
            var barcode = barcodes_1[_i];
            var area = barcode.boundingBox.width * barcode.boundingBox.height;
            if (area > maxArea) {
                maxArea = area;
                largestBarcode = barcode;
            }
        }
        if (!largestBarcode) throw "No largest barcode found";
        return largestBarcode;
    };
    BarcodeDetectorDelegate.prototype.createBarcodeDetectorFormats = function(requestedFormats) {
        var formats = [];
        for(var _i = 0, requestedFormats_1 = requestedFormats; _i < requestedFormats_1.length; _i++){
            var requestedFormat = requestedFormats_1[_i];
            if (this.formatMap.has(requestedFormat)) formats.push(this.formatMap.get(requestedFormat));
            else this.logger.warn("".concat(requestedFormat, " is not supported by") + "BarcodeDetectorDelegate");
        }
        return {
            formats: formats
        };
    };
    BarcodeDetectorDelegate.prototype.toHtml5QrcodeSupportedFormats = function(barcodeDetectorFormat) {
        if (!this.reverseFormatMap.has(barcodeDetectorFormat)) throw "reverseFormatMap doesn't have ".concat(barcodeDetectorFormat);
        return this.reverseFormatMap.get(barcodeDetectorFormat);
    };
    BarcodeDetectorDelegate.prototype.createReverseFormatMap = function() {
        var result = new Map();
        this.formatMap.forEach(function(value, key, _) {
            result.set(value, key);
        });
        return result;
    };
    BarcodeDetectorDelegate.prototype.createDebugData = function() {
        return {
            decoderName: "BarcodeDetector"
        };
    };
    return BarcodeDetectorDelegate;
}();


var $d1d209d110c6a902$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d1d209d110c6a902$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d1d209d110c6a902$export$e24b14a4b30c7022 = function() {
    function Html5QrcodeShim(requestedFormats, useBarCodeDetectorIfSupported, verbose, logger) {
        this.EXECUTIONS_TO_REPORT_PERFORMANCE = 100;
        this.executions = 0;
        this.executionResults = [];
        this.wasPrimaryDecoderUsedInLastDecode = false;
        this.verbose = verbose;
        if (useBarCodeDetectorIfSupported && (0, $d03d3b448ea1788a$export$199d29c1710b56b6).isSupported()) {
            this.primaryDecoder = new (0, $d03d3b448ea1788a$export$199d29c1710b56b6)(requestedFormats, verbose, logger);
            this.secondaryDecoder = new (0, $2f1ec72091fbd6cf$export$12d67355bcc453ab)(requestedFormats, verbose, logger);
        } else this.primaryDecoder = new (0, $2f1ec72091fbd6cf$export$12d67355bcc453ab)(requestedFormats, verbose, logger);
    }
    Html5QrcodeShim.prototype.decodeAsync = function(canvas) {
        return $d1d209d110c6a902$var$__awaiter(this, void 0, void 0, function() {
            var startTime;
            return $d1d209d110c6a902$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        startTime = performance.now();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            this.getDecoder().decodeAsync(canvas)
                        ];
                    case 2:
                        return [
                            2,
                            _a.sent()
                        ];
                    case 3:
                        this.possiblyLogPerformance(startTime);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    Html5QrcodeShim.prototype.decodeRobustlyAsync = function(canvas) {
        return $d1d209d110c6a902$var$__awaiter(this, void 0, void 0, function() {
            var startTime, error_1;
            return $d1d209d110c6a902$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        startTime = performance.now();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            this.primaryDecoder.decodeAsync(canvas)
                        ];
                    case 2:
                        return [
                            2,
                            _a.sent()
                        ];
                    case 3:
                        error_1 = _a.sent();
                        if (this.secondaryDecoder) return [
                            2,
                            this.secondaryDecoder.decodeAsync(canvas)
                        ];
                        throw error_1;
                    case 4:
                        this.possiblyLogPerformance(startTime);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    };
    Html5QrcodeShim.prototype.getDecoder = function() {
        if (!this.secondaryDecoder) return this.primaryDecoder;
        if (this.wasPrimaryDecoderUsedInLastDecode === false) {
            this.wasPrimaryDecoderUsedInLastDecode = true;
            return this.primaryDecoder;
        }
        this.wasPrimaryDecoderUsedInLastDecode = false;
        return this.secondaryDecoder;
    };
    Html5QrcodeShim.prototype.possiblyLogPerformance = function(startTime) {
        if (!this.verbose) return;
        var executionTime = performance.now() - startTime;
        this.executionResults.push(executionTime);
        this.executions++;
        this.possiblyFlushPerformanceReport();
    };
    Html5QrcodeShim.prototype.possiblyFlushPerformanceReport = function() {
        if (this.executions < this.EXECUTIONS_TO_REPORT_PERFORMANCE) return;
        var sum = 0;
        for(var _i = 0, _a = this.executionResults; _i < _a.length; _i++){
            var executionTime = _a[_i];
            sum += executionTime;
        }
        var mean = sum / this.executionResults.length;
        console.log("".concat(mean, " ms for ").concat(this.executionResults.length, " last runs."));
        this.executions = 0;
        this.executionResults = [];
    };
    return Html5QrcodeShim;
}();


var $1fd7f3bbb3f9820e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1fd7f3bbb3f9820e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1fd7f3bbb3f9820e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1fd7f3bbb3f9820e$var$AbstractCameraCapability = function() {
    function AbstractCameraCapability(name, track) {
        this.name = name;
        this.track = track;
    }
    AbstractCameraCapability.prototype.isSupported = function() {
        if (!this.track.getCapabilities) return false;
        return this.name in this.track.getCapabilities();
    };
    AbstractCameraCapability.prototype.apply = function(value) {
        var constraint = {};
        constraint[this.name] = value;
        var constraints = {
            advanced: [
                constraint
            ]
        };
        return this.track.applyConstraints(constraints);
    };
    AbstractCameraCapability.prototype.value = function() {
        var settings = this.track.getSettings();
        if (this.name in settings) {
            var settingValue = settings[this.name];
            return settingValue;
        }
        return null;
    };
    return AbstractCameraCapability;
}();
var $1fd7f3bbb3f9820e$var$AbstractRangeCameraCapability = function(_super) {
    $1fd7f3bbb3f9820e$var$__extends(AbstractRangeCameraCapability, _super);
    function AbstractRangeCameraCapability(name, track) {
        return _super.call(this, name, track) || this;
    }
    AbstractRangeCameraCapability.prototype.min = function() {
        return this.getCapabilities().min;
    };
    AbstractRangeCameraCapability.prototype.max = function() {
        return this.getCapabilities().max;
    };
    AbstractRangeCameraCapability.prototype.step = function() {
        return this.getCapabilities().step;
    };
    AbstractRangeCameraCapability.prototype.apply = function(value) {
        var constraint = {};
        constraint[this.name] = value;
        var constraints = {
            advanced: [
                constraint
            ]
        };
        return this.track.applyConstraints(constraints);
    };
    AbstractRangeCameraCapability.prototype.getCapabilities = function() {
        this.failIfNotSupported();
        var capabilities = this.track.getCapabilities();
        var capability = capabilities[this.name];
        return {
            min: capability.min,
            max: capability.max,
            step: capability.step
        };
    };
    AbstractRangeCameraCapability.prototype.failIfNotSupported = function() {
        if (!this.isSupported()) throw new Error("".concat(this.name, " capability not supported"));
    };
    return AbstractRangeCameraCapability;
}($1fd7f3bbb3f9820e$var$AbstractCameraCapability);
var $1fd7f3bbb3f9820e$var$ZoomFeatureImpl = function(_super) {
    $1fd7f3bbb3f9820e$var$__extends(ZoomFeatureImpl, _super);
    function ZoomFeatureImpl(track) {
        return _super.call(this, "zoom", track) || this;
    }
    return ZoomFeatureImpl;
}($1fd7f3bbb3f9820e$var$AbstractRangeCameraCapability);
var $1fd7f3bbb3f9820e$var$TorchFeatureImpl = function(_super) {
    $1fd7f3bbb3f9820e$var$__extends(TorchFeatureImpl, _super);
    function TorchFeatureImpl(track) {
        return _super.call(this, "torch", track) || this;
    }
    return TorchFeatureImpl;
}($1fd7f3bbb3f9820e$var$AbstractCameraCapability);
var $1fd7f3bbb3f9820e$var$CameraCapabilitiesImpl = function() {
    function CameraCapabilitiesImpl(track) {
        this.track = track;
    }
    CameraCapabilitiesImpl.prototype.zoomFeature = function() {
        return new $1fd7f3bbb3f9820e$var$ZoomFeatureImpl(this.track);
    };
    CameraCapabilitiesImpl.prototype.torchFeature = function() {
        return new $1fd7f3bbb3f9820e$var$TorchFeatureImpl(this.track);
    };
    return CameraCapabilitiesImpl;
}();
var $1fd7f3bbb3f9820e$var$RenderedCameraImpl = function() {
    function RenderedCameraImpl(parentElement, mediaStream, callbacks) {
        this.isClosed = false;
        this.parentElement = parentElement;
        this.mediaStream = mediaStream;
        this.callbacks = callbacks;
        this.surface = this.createVideoElement(this.parentElement.clientWidth);
        parentElement.append(this.surface);
    }
    RenderedCameraImpl.prototype.createVideoElement = function(width) {
        var videoElement = document.createElement("video");
        videoElement.style.width = "".concat(width, "px");
        videoElement.style.display = "block";
        videoElement.muted = true;
        videoElement.setAttribute("muted", "true");
        videoElement.playsInline = true;
        return videoElement;
    };
    RenderedCameraImpl.prototype.setupSurface = function() {
        var _this = this;
        this.surface.onabort = function() {
            throw "RenderedCameraImpl video surface onabort() called";
        };
        this.surface.onerror = function() {
            throw "RenderedCameraImpl video surface onerror() called";
        };
        var onVideoStart = function() {
            var videoWidth = _this.surface.clientWidth;
            var videoHeight = _this.surface.clientHeight;
            _this.callbacks.onRenderSurfaceReady(videoWidth, videoHeight);
            _this.surface.removeEventListener("playing", onVideoStart);
        };
        this.surface.addEventListener("playing", onVideoStart);
        this.surface.srcObject = this.mediaStream;
        this.surface.play();
    };
    RenderedCameraImpl.create = function(parentElement, mediaStream, options, callbacks) {
        return $1fd7f3bbb3f9820e$var$__awaiter(this, void 0, void 0, function() {
            var renderedCamera, aspectRatioConstraint;
            return $1fd7f3bbb3f9820e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        renderedCamera = new RenderedCameraImpl(parentElement, mediaStream, callbacks);
                        if (!options.aspectRatio) return [
                            3,
                            2
                        ];
                        aspectRatioConstraint = {
                            aspectRatio: options.aspectRatio
                        };
                        return [
                            4,
                            renderedCamera.getFirstTrackOrFail().applyConstraints(aspectRatioConstraint)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        renderedCamera.setupSurface();
                        return [
                            2,
                            renderedCamera
                        ];
                }
            });
        });
    };
    RenderedCameraImpl.prototype.failIfClosed = function() {
        if (this.isClosed) throw "The RenderedCamera has already been closed.";
    };
    RenderedCameraImpl.prototype.getFirstTrackOrFail = function() {
        this.failIfClosed();
        if (this.mediaStream.getVideoTracks().length === 0) throw "No video tracks found";
        return this.mediaStream.getVideoTracks()[0];
    };
    RenderedCameraImpl.prototype.pause = function() {
        this.failIfClosed();
        this.surface.pause();
    };
    RenderedCameraImpl.prototype.resume = function(onResumeCallback) {
        this.failIfClosed();
        var $this = this;
        var onVideoResume = function() {
            setTimeout(onResumeCallback, 200);
            $this.surface.removeEventListener("playing", onVideoResume);
        };
        this.surface.addEventListener("playing", onVideoResume);
        this.surface.play();
    };
    RenderedCameraImpl.prototype.isPaused = function() {
        this.failIfClosed();
        return this.surface.paused;
    };
    RenderedCameraImpl.prototype.getSurface = function() {
        this.failIfClosed();
        return this.surface;
    };
    RenderedCameraImpl.prototype.getRunningTrackCapabilities = function() {
        return this.getFirstTrackOrFail().getCapabilities();
    };
    RenderedCameraImpl.prototype.getRunningTrackSettings = function() {
        return this.getFirstTrackOrFail().getSettings();
    };
    RenderedCameraImpl.prototype.applyVideoConstraints = function(constraints) {
        return $1fd7f3bbb3f9820e$var$__awaiter(this, void 0, void 0, function() {
            return $1fd7f3bbb3f9820e$var$__generator(this, function(_a) {
                if ("aspectRatio" in constraints) throw "Changing 'aspectRatio' in run-time is not yet supported.";
                return [
                    2,
                    this.getFirstTrackOrFail().applyConstraints(constraints)
                ];
            });
        });
    };
    RenderedCameraImpl.prototype.close = function() {
        if (this.isClosed) return Promise.resolve();
        var $this = this;
        return new Promise(function(resolve, _) {
            var tracks = $this.mediaStream.getVideoTracks();
            var tracksToClose = tracks.length;
            var tracksClosed = 0;
            $this.mediaStream.getVideoTracks().forEach(function(videoTrack) {
                $this.mediaStream.removeTrack(videoTrack);
                videoTrack.stop();
                ++tracksClosed;
                if (tracksClosed >= tracksToClose) {
                    $this.isClosed = true;
                    $this.parentElement.removeChild($this.surface);
                    resolve();
                }
            });
        });
    };
    RenderedCameraImpl.prototype.getCapabilities = function() {
        return new $1fd7f3bbb3f9820e$var$CameraCapabilitiesImpl(this.getFirstTrackOrFail());
    };
    return RenderedCameraImpl;
}();
var $1fd7f3bbb3f9820e$export$628cc91c21cd86e4 = function() {
    function CameraImpl(mediaStream) {
        this.mediaStream = mediaStream;
    }
    CameraImpl.prototype.render = function(parentElement, options, callbacks) {
        return $1fd7f3bbb3f9820e$var$__awaiter(this, void 0, void 0, function() {
            return $1fd7f3bbb3f9820e$var$__generator(this, function(_a) {
                return [
                    2,
                    $1fd7f3bbb3f9820e$var$RenderedCameraImpl.create(parentElement, this.mediaStream, options, callbacks)
                ];
            });
        });
    };
    CameraImpl.create = function(videoConstraints) {
        return $1fd7f3bbb3f9820e$var$__awaiter(this, void 0, void 0, function() {
            var constraints, mediaStream;
            return $1fd7f3bbb3f9820e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!navigator.mediaDevices) throw "navigator.mediaDevices not supported";
                        constraints = {
                            audio: false,
                            video: videoConstraints
                        };
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(constraints)
                        ];
                    case 1:
                        mediaStream = _a.sent();
                        return [
                            2,
                            new CameraImpl(mediaStream)
                        ];
                }
            });
        });
    };
    return CameraImpl;
}();


var $2c606578af028c16$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2c606578af028c16$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2c606578af028c16$export$2fe5dfd38a5788bd = function() {
    function CameraFactory() {}
    CameraFactory.failIfNotSupported = function() {
        return $2c606578af028c16$var$__awaiter(this, void 0, void 0, function() {
            return $2c606578af028c16$var$__generator(this, function(_a) {
                if (!navigator.mediaDevices) throw "navigator.mediaDevices not supported";
                return [
                    2,
                    new CameraFactory()
                ];
            });
        });
    };
    CameraFactory.prototype.create = function(videoConstraints) {
        return $2c606578af028c16$var$__awaiter(this, void 0, void 0, function() {
            return $2c606578af028c16$var$__generator(this, function(_a) {
                return [
                    2,
                    (0, $1fd7f3bbb3f9820e$export$628cc91c21cd86e4).create(videoConstraints)
                ];
            });
        });
    };
    return CameraFactory;
}();



var $f9cf3c975d1c5e2e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f9cf3c975d1c5e2e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f9cf3c975d1c5e2e$export$3cb69280b8b5ed56 = function() {
    function CameraRetriever() {}
    CameraRetriever.retrieve = function() {
        if (navigator.mediaDevices) return CameraRetriever.getCamerasFromMediaDevices();
        var mst = MediaStreamTrack;
        if (MediaStreamTrack && mst.getSources) return CameraRetriever.getCamerasFromMediaStreamTrack();
        return CameraRetriever.rejectWithError();
    };
    CameraRetriever.rejectWithError = function() {
        var errorMessage = (0, $ff5e69b322275082$export$b5652ef085dee87f).unableToQuerySupportedDevices();
        if (!CameraRetriever.isHttpsOrLocalhost()) errorMessage = (0, $ff5e69b322275082$export$b5652ef085dee87f).insecureContextCameraQueryError();
        return Promise.reject(errorMessage);
    };
    CameraRetriever.isHttpsOrLocalhost = function() {
        if (location.protocol === "https:") return true;
        var host = location.host.split(":")[0];
        return host === "127.0.0.1" || host === "localhost";
    };
    CameraRetriever.getCamerasFromMediaDevices = function() {
        return $f9cf3c975d1c5e2e$var$__awaiter(this, void 0, void 0, function() {
            var closeActiveStreams, mediaStream, devices, results, _i, devices_1, device;
            return $f9cf3c975d1c5e2e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        closeActiveStreams = function(stream) {
                            var tracks = stream.getVideoTracks();
                            for(var _i = 0, tracks_1 = tracks; _i < tracks_1.length; _i++){
                                var track = tracks_1[_i];
                                track.enabled = false;
                                track.stop();
                                stream.removeTrack(track);
                            }
                        };
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia({
                                audio: false,
                                video: true
                            })
                        ];
                    case 1:
                        mediaStream = _a.sent();
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 2:
                        devices = _a.sent();
                        results = [];
                        for(_i = 0, devices_1 = devices; _i < devices_1.length; _i++){
                            device = devices_1[_i];
                            if (device.kind === "videoinput") results.push({
                                id: device.deviceId,
                                label: device.label
                            });
                        }
                        closeActiveStreams(mediaStream);
                        return [
                            2,
                            results
                        ];
                }
            });
        });
    };
    CameraRetriever.getCamerasFromMediaStreamTrack = function() {
        return new Promise(function(resolve, _) {
            var callback = function(sourceInfos) {
                var results = [];
                for(var _i = 0, sourceInfos_1 = sourceInfos; _i < sourceInfos_1.length; _i++){
                    var sourceInfo = sourceInfos_1[_i];
                    if (sourceInfo.kind === "video") results.push({
                        id: sourceInfo.id,
                        label: sourceInfo.label
                    });
                }
                resolve(results);
            };
            var mst = MediaStreamTrack;
            mst.getSources(callback);
        });
    };
    return CameraRetriever;
}();


var $82bbb6140bb56c40$export$c90f317190d585a3;
(function(Html5QrcodeScannerState) {
    Html5QrcodeScannerState[Html5QrcodeScannerState["UNKNOWN"] = 0] = "UNKNOWN";
    Html5QrcodeScannerState[Html5QrcodeScannerState["NOT_STARTED"] = 1] = "NOT_STARTED";
    Html5QrcodeScannerState[Html5QrcodeScannerState["SCANNING"] = 2] = "SCANNING";
    Html5QrcodeScannerState[Html5QrcodeScannerState["PAUSED"] = 3] = "PAUSED";
})($82bbb6140bb56c40$export$c90f317190d585a3 || ($82bbb6140bb56c40$export$c90f317190d585a3 = {}));
var $82bbb6140bb56c40$var$StateManagerImpl = function() {
    function StateManagerImpl() {
        this.state = $82bbb6140bb56c40$export$c90f317190d585a3.NOT_STARTED;
        this.onGoingTransactionNewState = $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN;
    }
    StateManagerImpl.prototype.directTransition = function(newState) {
        this.failIfTransitionOngoing();
        this.validateTransition(newState);
        this.state = newState;
    };
    StateManagerImpl.prototype.startTransition = function(newState) {
        this.failIfTransitionOngoing();
        this.validateTransition(newState);
        this.onGoingTransactionNewState = newState;
        return this;
    };
    StateManagerImpl.prototype.execute = function() {
        if (this.onGoingTransactionNewState === $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN) throw "Transaction is already cancelled, cannot execute().";
        var tempNewState = this.onGoingTransactionNewState;
        this.onGoingTransactionNewState = $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN;
        this.directTransition(tempNewState);
    };
    StateManagerImpl.prototype.cancel = function() {
        if (this.onGoingTransactionNewState === $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN) throw "Transaction is already cancelled, cannot cancel().";
        this.onGoingTransactionNewState = $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN;
    };
    StateManagerImpl.prototype.getState = function() {
        return this.state;
    };
    StateManagerImpl.prototype.failIfTransitionOngoing = function() {
        if (this.onGoingTransactionNewState !== $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN) throw "Cannot transition to a new state, already under transition";
    };
    StateManagerImpl.prototype.validateTransition = function(newState) {
        switch(this.state){
            case $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN:
                throw "Transition from unknown is not allowed";
            case $82bbb6140bb56c40$export$c90f317190d585a3.NOT_STARTED:
                this.failIfNewStateIs(newState, [
                    $82bbb6140bb56c40$export$c90f317190d585a3.PAUSED
                ]);
                break;
            case $82bbb6140bb56c40$export$c90f317190d585a3.SCANNING:
                break;
            case $82bbb6140bb56c40$export$c90f317190d585a3.PAUSED:
                break;
        }
    };
    StateManagerImpl.prototype.failIfNewStateIs = function(newState, disallowedStatesToTransition) {
        for(var _i = 0, disallowedStatesToTransition_1 = disallowedStatesToTransition; _i < disallowedStatesToTransition_1.length; _i++){
            var disallowedState = disallowedStatesToTransition_1[_i];
            if (newState === disallowedState) throw "Cannot transition from ".concat(this.state, " to ").concat(newState);
        }
    };
    return StateManagerImpl;
}();
var $82bbb6140bb56c40$export$999aa14d48ead8a4 = function() {
    function StateManagerProxy(stateManager) {
        this.stateManager = stateManager;
    }
    StateManagerProxy.prototype.startTransition = function(newState) {
        return this.stateManager.startTransition(newState);
    };
    StateManagerProxy.prototype.directTransition = function(newState) {
        this.stateManager.directTransition(newState);
    };
    StateManagerProxy.prototype.getState = function() {
        return this.stateManager.getState();
    };
    StateManagerProxy.prototype.canScanFile = function() {
        return this.stateManager.getState() === $82bbb6140bb56c40$export$c90f317190d585a3.NOT_STARTED;
    };
    StateManagerProxy.prototype.isScanning = function() {
        return this.stateManager.getState() !== $82bbb6140bb56c40$export$c90f317190d585a3.NOT_STARTED;
    };
    StateManagerProxy.prototype.isStrictlyScanning = function() {
        return this.stateManager.getState() === $82bbb6140bb56c40$export$c90f317190d585a3.SCANNING;
    };
    StateManagerProxy.prototype.isPaused = function() {
        return this.stateManager.getState() === $82bbb6140bb56c40$export$c90f317190d585a3.PAUSED;
    };
    return StateManagerProxy;
}();
var $82bbb6140bb56c40$export$9379d7cc304330e9 = function() {
    function StateManagerFactory() {}
    StateManagerFactory.create = function() {
        return new $82bbb6140bb56c40$export$999aa14d48ead8a4(new $82bbb6140bb56c40$var$StateManagerImpl());
    };
    return StateManagerFactory;
}();


var $9eb3c467bce0942e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9eb3c467bce0942e$var$Constants = function(_super) {
    $9eb3c467bce0942e$var$__extends(Constants, _super);
    function Constants() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Constants.DEFAULT_WIDTH = 300;
    Constants.DEFAULT_WIDTH_OFFSET = 2;
    Constants.FILE_SCAN_MIN_HEIGHT = 300;
    Constants.FILE_SCAN_HIDDEN_CANVAS_PADDING = 100;
    Constants.MIN_QR_BOX_SIZE = 50;
    Constants.SHADED_LEFT = 1;
    Constants.SHADED_RIGHT = 2;
    Constants.SHADED_TOP = 3;
    Constants.SHADED_BOTTOM = 4;
    Constants.SHADED_REGION_ELEMENT_ID = "qr-shaded-region";
    Constants.VERBOSE = false;
    Constants.BORDER_SHADER_DEFAULT_COLOR = "#ffffff";
    Constants.BORDER_SHADER_MATCH_COLOR = "rgb(90, 193, 56)";
    return Constants;
}((0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d));
var $9eb3c467bce0942e$var$InternalHtml5QrcodeConfig = function() {
    function InternalHtml5QrcodeConfig(config, logger) {
        this.logger = logger;
        this.fps = $9eb3c467bce0942e$var$Constants.SCAN_DEFAULT_FPS;
        if (!config) this.disableFlip = $9eb3c467bce0942e$var$Constants.DEFAULT_DISABLE_FLIP;
        else {
            if (config.fps) this.fps = config.fps;
            this.disableFlip = config.disableFlip === true;
            this.qrbox = config.qrbox;
            this.aspectRatio = config.aspectRatio;
            this.videoConstraints = config.videoConstraints;
        }
    }
    InternalHtml5QrcodeConfig.prototype.isMediaStreamConstraintsValid = function() {
        if (!this.videoConstraints) {
            this.logger.logError("Empty videoConstraints", true);
            return false;
        }
        return (0, $307853ab41d6a77a$export$62a0507decb17869).isMediaStreamConstraintsValid(this.videoConstraints, this.logger);
    };
    InternalHtml5QrcodeConfig.prototype.isShadedBoxEnabled = function() {
        return !(0, $c9d6d3563c261b0e$export$bedb7023a7733221)(this.qrbox);
    };
    InternalHtml5QrcodeConfig.create = function(config, logger) {
        return new InternalHtml5QrcodeConfig(config, logger);
    };
    return InternalHtml5QrcodeConfig;
}();
var $9eb3c467bce0942e$export$e14ced7bffd8eb7a = function() {
    function Html5Qrcode(elementId, configOrVerbosityFlag) {
        this.element = null;
        this.canvasElement = null;
        this.scannerPausedUiElement = null;
        this.hasBorderShaders = null;
        this.borderShaders = null;
        this.qrMatch = null;
        this.renderedCamera = null;
        this.qrRegion = null;
        this.context = null;
        this.lastScanImageFile = null;
        this.isScanning = false;
        if (!document.getElementById(elementId)) throw "HTML Element with id=".concat(elementId, " not found");
        this.elementId = elementId;
        this.verbose = false;
        var experimentalFeatureConfig;
        var configObject;
        if (typeof configOrVerbosityFlag == "boolean") this.verbose = configOrVerbosityFlag === true;
        else if (configOrVerbosityFlag) {
            configObject = configOrVerbosityFlag;
            this.verbose = configObject.verbose === true;
            experimentalFeatureConfig = configObject.experimentalFeatures;
        }
        this.logger = new (0, $c9d6d3563c261b0e$export$1952c0907ffae0f2)(this.verbose);
        this.qrcode = new (0, $d1d209d110c6a902$export$e24b14a4b30c7022)(this.getSupportedFormats(configOrVerbosityFlag), this.getUseBarCodeDetectorIfSupported(configObject), this.verbose, this.logger);
        this.foreverScanTimeout;
        this.shouldScan = true;
        this.stateManagerProxy = (0, $82bbb6140bb56c40$export$9379d7cc304330e9).create();
    }
    Html5Qrcode.prototype.start = function(cameraIdOrConfig, configuration, qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (!cameraIdOrConfig) throw "cameraIdOrConfig is required";
        if (!qrCodeSuccessCallback || typeof qrCodeSuccessCallback != "function") throw "qrCodeSuccessCallback is required and should be a function.";
        var qrCodeErrorCallbackInternal;
        if (qrCodeErrorCallback) qrCodeErrorCallbackInternal = qrCodeErrorCallback;
        else qrCodeErrorCallbackInternal = this.verbose ? this.logger.log : function() {};
        var internalConfig = $9eb3c467bce0942e$var$InternalHtml5QrcodeConfig.create(configuration, this.logger);
        this.clearElement();
        var videoConstraintsAvailableAndValid = false;
        if (internalConfig.videoConstraints) {
            if (!internalConfig.isMediaStreamConstraintsValid()) this.logger.logError("'videoConstraints' is not valid 'MediaStreamConstraints, it will be ignored.'", true);
            else videoConstraintsAvailableAndValid = true;
        }
        var areVideoConstraintsEnabled = videoConstraintsAvailableAndValid;
        var element = document.getElementById(this.elementId);
        var rootElementWidth = element.clientWidth ? element.clientWidth : $9eb3c467bce0942e$var$Constants.DEFAULT_WIDTH;
        element.style.position = "relative";
        this.shouldScan = true;
        this.element = element;
        var $this = this;
        var toScanningStateChangeTransaction = this.stateManagerProxy.startTransition((0, $82bbb6140bb56c40$export$c90f317190d585a3).SCANNING);
        return new Promise(function(resolve, reject) {
            var videoConstraints = areVideoConstraintsEnabled ? internalConfig.videoConstraints : $this.createVideoConstraints(cameraIdOrConfig);
            if (!videoConstraints) {
                toScanningStateChangeTransaction.cancel();
                reject("videoConstraints should be defined");
                return;
            }
            var cameraRenderingOptions = {};
            if (!areVideoConstraintsEnabled || internalConfig.aspectRatio) cameraRenderingOptions.aspectRatio = internalConfig.aspectRatio;
            var renderingCallbacks = {
                onRenderSurfaceReady: function(viewfinderWidth, viewfinderHeight) {
                    $this.setupUi(viewfinderWidth, viewfinderHeight, internalConfig);
                    $this.isScanning = true;
                    $this.foreverScan(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallbackInternal);
                }
            };
            (0, $2c606578af028c16$export$2fe5dfd38a5788bd).failIfNotSupported().then(function(factory) {
                factory.create(videoConstraints).then(function(camera) {
                    return camera.render(_this.element, cameraRenderingOptions, renderingCallbacks).then(function(renderedCamera) {
                        $this.renderedCamera = renderedCamera;
                        toScanningStateChangeTransaction.execute();
                        resolve(null);
                    }).catch(function(error) {
                        toScanningStateChangeTransaction.cancel();
                        reject(error);
                    });
                }).catch(function(error) {
                    toScanningStateChangeTransaction.cancel();
                    reject((0, $ff5e69b322275082$export$b5652ef085dee87f).errorGettingUserMedia(error));
                });
            }).catch(function(_) {
                toScanningStateChangeTransaction.cancel();
                reject((0, $ff5e69b322275082$export$b5652ef085dee87f).cameraStreamingNotSupported());
            });
        });
    };
    Html5Qrcode.prototype.pause = function(shouldPauseVideo) {
        if (!this.stateManagerProxy.isStrictlyScanning()) throw "Cannot pause, scanner is not scanning.";
        this.stateManagerProxy.directTransition((0, $82bbb6140bb56c40$export$c90f317190d585a3).PAUSED);
        this.showPausedState();
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(shouldPauseVideo) || shouldPauseVideo !== true) shouldPauseVideo = false;
        if (shouldPauseVideo && this.renderedCamera) this.renderedCamera.pause();
    };
    Html5Qrcode.prototype.resume = function() {
        if (!this.stateManagerProxy.isPaused()) throw "Cannot result, scanner is not paused.";
        if (!this.renderedCamera) throw "renderedCamera doesn't exist while trying resume()";
        var $this = this;
        var transitionToScanning = function() {
            $this.stateManagerProxy.directTransition((0, $82bbb6140bb56c40$export$c90f317190d585a3).SCANNING);
            $this.hidePausedState();
        };
        if (!this.renderedCamera.isPaused()) {
            transitionToScanning();
            return;
        }
        this.renderedCamera.resume(function() {
            transitionToScanning();
        });
    };
    Html5Qrcode.prototype.getState = function() {
        return this.stateManagerProxy.getState();
    };
    Html5Qrcode.prototype.stop = function() {
        var _this = this;
        if (!this.stateManagerProxy.isScanning()) throw "Cannot stop, scanner is not running or paused.";
        var toStoppedStateTransaction = this.stateManagerProxy.startTransition((0, $82bbb6140bb56c40$export$c90f317190d585a3).NOT_STARTED);
        this.shouldScan = false;
        if (this.foreverScanTimeout) clearTimeout(this.foreverScanTimeout);
        var removeQrRegion = function() {
            if (!_this.element) return;
            var childElement = document.getElementById($9eb3c467bce0942e$var$Constants.SHADED_REGION_ELEMENT_ID);
            if (childElement) _this.element.removeChild(childElement);
        };
        var $this = this;
        return this.renderedCamera.close().then(function() {
            $this.renderedCamera = null;
            if ($this.element) {
                $this.element.removeChild($this.canvasElement);
                $this.canvasElement = null;
            }
            removeQrRegion();
            if ($this.qrRegion) $this.qrRegion = null;
            if ($this.context) $this.context = null;
            toStoppedStateTransaction.execute();
            $this.hidePausedState();
            $this.isScanning = false;
            return Promise.resolve();
        });
    };
    Html5Qrcode.prototype.scanFile = function(imageFile, showImage) {
        return this.scanFileV2(imageFile, showImage).then(function(html5qrcodeResult) {
            return html5qrcodeResult.decodedText;
        });
    };
    Html5Qrcode.prototype.scanFileV2 = function(imageFile, showImage) {
        var _this = this;
        if (!imageFile || !(imageFile instanceof File)) throw "imageFile argument is mandatory and should be instance of File. Use 'event.target.files[0]'.";
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(showImage)) showImage = true;
        if (!this.stateManagerProxy.canScanFile()) throw "Cannot start file scan - ongoing camera scan";
        return new Promise(function(resolve, reject) {
            _this.possiblyCloseLastScanImageFile();
            _this.clearElement();
            _this.lastScanImageFile = URL.createObjectURL(imageFile);
            var inputImage = new Image;
            inputImage.onload = function() {
                var imageWidth = inputImage.width;
                var imageHeight = inputImage.height;
                var element = document.getElementById(_this.elementId);
                var containerWidth = element.clientWidth ? element.clientWidth : $9eb3c467bce0942e$var$Constants.DEFAULT_WIDTH;
                var containerHeight = Math.max(element.clientHeight ? element.clientHeight : imageHeight, $9eb3c467bce0942e$var$Constants.FILE_SCAN_MIN_HEIGHT);
                var config = _this.computeCanvasDrawConfig(imageWidth, imageHeight, containerWidth, containerHeight);
                if (showImage) {
                    var visibleCanvas = _this.createCanvasElement(containerWidth, containerHeight, "qr-canvas-visible");
                    visibleCanvas.style.display = "inline-block";
                    element.appendChild(visibleCanvas);
                    var context_1 = visibleCanvas.getContext("2d");
                    if (!context_1) throw "Unable to get 2d context from canvas";
                    context_1.canvas.width = containerWidth;
                    context_1.canvas.height = containerHeight;
                    context_1.drawImage(inputImage, 0, 0, imageWidth, imageHeight, config.x, config.y, config.width, config.height);
                }
                var padding = $9eb3c467bce0942e$var$Constants.FILE_SCAN_HIDDEN_CANVAS_PADDING;
                var hiddenImageWidth = Math.max(inputImage.width, config.width);
                var hiddenImageHeight = Math.max(inputImage.height, config.height);
                var hiddenCanvasWidth = hiddenImageWidth + 2 * padding;
                var hiddenCanvasHeight = hiddenImageHeight + 2 * padding;
                var hiddenCanvas = _this.createCanvasElement(hiddenCanvasWidth, hiddenCanvasHeight);
                element.appendChild(hiddenCanvas);
                var context = hiddenCanvas.getContext("2d");
                if (!context) throw "Unable to get 2d context from canvas";
                context.canvas.width = hiddenCanvasWidth;
                context.canvas.height = hiddenCanvasHeight;
                context.drawImage(inputImage, 0, 0, imageWidth, imageHeight, padding, padding, hiddenImageWidth, hiddenImageHeight);
                try {
                    _this.qrcode.decodeRobustlyAsync(hiddenCanvas).then(function(result) {
                        resolve((0, $c9d6d3563c261b0e$export$ca258a9dba899828).createFromQrcodeResult(result));
                    }).catch(reject);
                } catch (exception) {
                    reject("QR code parse error, error = ".concat(exception));
                }
            };
            inputImage.onerror = reject;
            inputImage.onabort = reject;
            inputImage.onstalled = reject;
            inputImage.onsuspend = reject;
            inputImage.src = URL.createObjectURL(imageFile);
        });
    };
    Html5Qrcode.prototype.clear = function() {
        this.clearElement();
    };
    Html5Qrcode.getCameras = function() {
        return (0, $f9cf3c975d1c5e2e$export$3cb69280b8b5ed56).retrieve();
    };
    Html5Qrcode.prototype.getRunningTrackCapabilities = function() {
        return this.getRenderedCameraOrFail().getRunningTrackCapabilities();
    };
    Html5Qrcode.prototype.getRunningTrackSettings = function() {
        return this.getRenderedCameraOrFail().getRunningTrackSettings();
    };
    Html5Qrcode.prototype.getRunningTrackCameraCapabilities = function() {
        return this.getRenderedCameraOrFail().getCapabilities();
    };
    Html5Qrcode.prototype.applyVideoConstraints = function(videoConstaints) {
        if (!videoConstaints) throw "videoConstaints is required argument.";
        else if (!(0, $307853ab41d6a77a$export$62a0507decb17869).isMediaStreamConstraintsValid(videoConstaints, this.logger)) throw "invalid videoConstaints passed, check logs for more details";
        return this.getRenderedCameraOrFail().applyVideoConstraints(videoConstaints);
    };
    Html5Qrcode.prototype.getRenderedCameraOrFail = function() {
        if (this.renderedCamera == null) throw "Scanning is not in running state, call this API only when QR code scanning using camera is in running state.";
        return this.renderedCamera;
    };
    Html5Qrcode.prototype.getSupportedFormats = function(configOrVerbosityFlag) {
        var allFormats = [
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).QR_CODE,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).AZTEC,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODABAR,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_39,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_93,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_128,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).DATA_MATRIX,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).MAXICODE,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).ITF,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_13,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_8,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).PDF_417,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_14,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_EXPANDED,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_A,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_E,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_EAN_EXTENSION
        ];
        if (!configOrVerbosityFlag || typeof configOrVerbosityFlag == "boolean") return allFormats;
        if (!configOrVerbosityFlag.formatsToSupport) return allFormats;
        if (!Array.isArray(configOrVerbosityFlag.formatsToSupport)) throw "configOrVerbosityFlag.formatsToSupport should be undefined or an array.";
        if (configOrVerbosityFlag.formatsToSupport.length === 0) throw "Atleast 1 formatsToSupport is needed.";
        var supportedFormats = [];
        for(var _i = 0, _a = configOrVerbosityFlag.formatsToSupport; _i < _a.length; _i++){
            var format = _a[_i];
            if ((0, $c9d6d3563c261b0e$export$f672fe1751f545ca)(format)) supportedFormats.push(format);
            else this.logger.warn("Invalid format: ".concat(format, " passed in config, ignoring."));
        }
        if (supportedFormats.length === 0) throw "None of formatsToSupport match supported values.";
        return supportedFormats;
    };
    Html5Qrcode.prototype.getUseBarCodeDetectorIfSupported = function(config) {
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(config)) return true;
        if (!(0, $c9d6d3563c261b0e$export$bedb7023a7733221)(config.useBarCodeDetectorIfSupported)) return config.useBarCodeDetectorIfSupported !== false;
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(config.experimentalFeatures)) return true;
        var experimentalFeatures = config.experimentalFeatures;
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(experimentalFeatures.useBarCodeDetectorIfSupported)) return true;
        return experimentalFeatures.useBarCodeDetectorIfSupported !== false;
    };
    Html5Qrcode.prototype.validateQrboxSize = function(viewfinderWidth, viewfinderHeight, internalConfig) {
        var _this = this;
        var qrboxSize = internalConfig.qrbox;
        this.validateQrboxConfig(qrboxSize);
        var qrDimensions = this.toQrdimensions(viewfinderWidth, viewfinderHeight, qrboxSize);
        var validateMinSize = function(size) {
            if (size < $9eb3c467bce0942e$var$Constants.MIN_QR_BOX_SIZE) throw "minimum size of 'config.qrbox' dimension value is" + " ".concat($9eb3c467bce0942e$var$Constants.MIN_QR_BOX_SIZE, "px.");
        };
        var correctWidthBasedOnRootElementSize = function(configWidth) {
            if (configWidth > viewfinderWidth) {
                _this.logger.warn("`qrbox.width` or `qrbox` is larger than the width of the root element. The width will be truncated to the width of root element.");
                configWidth = viewfinderWidth;
            }
            return configWidth;
        };
        validateMinSize(qrDimensions.width);
        validateMinSize(qrDimensions.height);
        qrDimensions.width = correctWidthBasedOnRootElementSize(qrDimensions.width);
    };
    Html5Qrcode.prototype.validateQrboxConfig = function(qrboxSize) {
        if (typeof qrboxSize === "number") return;
        if (typeof qrboxSize === "function") return;
        if (qrboxSize.width === undefined || qrboxSize.height === undefined) throw "Invalid instance of QrDimensions passed for 'config.qrbox'. Both 'width' and 'height' should be set.";
    };
    Html5Qrcode.prototype.toQrdimensions = function(viewfinderWidth, viewfinderHeight, qrboxSize) {
        if (typeof qrboxSize === "number") return {
            width: qrboxSize,
            height: qrboxSize
        };
        else if (typeof qrboxSize === "function") try {
            return qrboxSize(viewfinderWidth, viewfinderHeight);
        } catch (error) {
            throw new Error("qrbox config was passed as a function but it failed with unknown error" + error);
        }
        return qrboxSize;
    };
    Html5Qrcode.prototype.setupUi = function(viewfinderWidth, viewfinderHeight, internalConfig) {
        if (internalConfig.isShadedBoxEnabled()) this.validateQrboxSize(viewfinderWidth, viewfinderHeight, internalConfig);
        var qrboxSize = (0, $c9d6d3563c261b0e$export$bedb7023a7733221)(internalConfig.qrbox) ? {
            width: viewfinderWidth,
            height: viewfinderHeight
        } : internalConfig.qrbox;
        this.validateQrboxConfig(qrboxSize);
        var qrDimensions = this.toQrdimensions(viewfinderWidth, viewfinderHeight, qrboxSize);
        if (qrDimensions.height > viewfinderHeight) this.logger.warn("[Html5Qrcode] config.qrbox has height that isgreater than the height of the video stream. Shading will be ignored");
        var shouldShadingBeApplied = internalConfig.isShadedBoxEnabled() && qrDimensions.height <= viewfinderHeight;
        var defaultQrRegion = {
            x: 0,
            y: 0,
            width: viewfinderWidth,
            height: viewfinderHeight
        };
        var qrRegion = shouldShadingBeApplied ? this.getShadedRegionBounds(viewfinderWidth, viewfinderHeight, qrDimensions) : defaultQrRegion;
        var canvasElement = this.createCanvasElement(qrRegion.width, qrRegion.height);
        var contextAttributes = {
            willReadFrequently: true
        };
        var context = canvasElement.getContext("2d", contextAttributes);
        context.canvas.width = qrRegion.width;
        context.canvas.height = qrRegion.height;
        this.element.append(canvasElement);
        if (shouldShadingBeApplied) this.possiblyInsertShadingElement(this.element, viewfinderWidth, viewfinderHeight, qrDimensions);
        this.createScannerPausedUiElement(this.element);
        this.qrRegion = qrRegion;
        this.context = context;
        this.canvasElement = canvasElement;
    };
    Html5Qrcode.prototype.createScannerPausedUiElement = function(rootElement) {
        var scannerPausedUiElement = document.createElement("div");
        scannerPausedUiElement.innerText = (0, $ff5e69b322275082$export$b5652ef085dee87f).scannerPaused();
        scannerPausedUiElement.style.display = "none";
        scannerPausedUiElement.style.position = "absolute";
        scannerPausedUiElement.style.top = "0px";
        scannerPausedUiElement.style.zIndex = "1";
        scannerPausedUiElement.style.background = "rgba(9, 9, 9, 0.46)";
        scannerPausedUiElement.style.color = "#FFECEC";
        scannerPausedUiElement.style.textAlign = "center";
        scannerPausedUiElement.style.width = "100%";
        rootElement.appendChild(scannerPausedUiElement);
        this.scannerPausedUiElement = scannerPausedUiElement;
    };
    Html5Qrcode.prototype.scanContext = function(qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (this.stateManagerProxy.isPaused()) return Promise.resolve(false);
        return this.qrcode.decodeAsync(this.canvasElement).then(function(result) {
            qrCodeSuccessCallback(result.text, (0, $c9d6d3563c261b0e$export$ca258a9dba899828).createFromQrcodeResult(result));
            _this.possiblyUpdateShaders(true);
            return true;
        }).catch(function(error) {
            _this.possiblyUpdateShaders(false);
            var errorMessage = (0, $ff5e69b322275082$export$b5652ef085dee87f).codeParseError(error);
            qrCodeErrorCallback(errorMessage, (0, $c9d6d3563c261b0e$export$dac571266bd01cf5).createFrom(errorMessage));
            return false;
        });
    };
    Html5Qrcode.prototype.foreverScan = function(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (!this.shouldScan) return;
        if (!this.renderedCamera) return;
        var videoElement = this.renderedCamera.getSurface();
        var widthRatio = videoElement.videoWidth / videoElement.clientWidth;
        var heightRatio = videoElement.videoHeight / videoElement.clientHeight;
        if (!this.qrRegion) throw "qrRegion undefined when localMediaStream is ready.";
        var sWidthOffset = this.qrRegion.width * widthRatio;
        var sHeightOffset = this.qrRegion.height * heightRatio;
        var sxOffset = this.qrRegion.x * widthRatio;
        var syOffset = this.qrRegion.y * heightRatio;
        this.context.drawImage(videoElement, sxOffset, syOffset, sWidthOffset, sHeightOffset, 0, 0, this.qrRegion.width, this.qrRegion.height);
        var triggerNextScan = function() {
            _this.foreverScanTimeout = setTimeout(function() {
                _this.foreverScan(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallback);
            }, _this.getTimeoutFps(internalConfig.fps));
        };
        this.scanContext(qrCodeSuccessCallback, qrCodeErrorCallback).then(function(isSuccessfull) {
            if (!isSuccessfull && internalConfig.disableFlip !== true) {
                _this.context.translate(_this.context.canvas.width, 0);
                _this.context.scale(-1, 1);
                _this.scanContext(qrCodeSuccessCallback, qrCodeErrorCallback).finally(function() {
                    triggerNextScan();
                });
            } else triggerNextScan();
        }).catch(function(error) {
            _this.logger.logError("Error happend while scanning context", error);
            triggerNextScan();
        });
    };
    Html5Qrcode.prototype.createVideoConstraints = function(cameraIdOrConfig) {
        if (typeof cameraIdOrConfig == "string") return {
            deviceId: {
                exact: cameraIdOrConfig
            }
        };
        else if (typeof cameraIdOrConfig == "object") {
            var facingModeKey = "facingMode";
            var deviceIdKey = "deviceId";
            var allowedFacingModeValues_1 = {
                "user": true,
                "environment": true
            };
            var exactKey = "exact";
            var isValidFacingModeValue = function(value) {
                if (value in allowedFacingModeValues_1) return true;
                else throw "config has invalid 'facingMode' value = " + "'".concat(value, "'");
            };
            var keys = Object.keys(cameraIdOrConfig);
            if (keys.length !== 1) throw "'cameraIdOrConfig' object should have exactly 1 key," + " if passed as an object, found ".concat(keys.length, " keys");
            var key = Object.keys(cameraIdOrConfig)[0];
            if (key !== facingModeKey && key !== deviceIdKey) throw "Only '".concat(facingModeKey, "' and '").concat(deviceIdKey, "' ") + " are supported for 'cameraIdOrConfig'";
            if (key === facingModeKey) {
                var facingMode = cameraIdOrConfig.facingMode;
                if (typeof facingMode == "string") {
                    if (isValidFacingModeValue(facingMode)) return {
                        facingMode: facingMode
                    };
                } else if (typeof facingMode == "object") {
                    if (exactKey in facingMode) {
                        if (isValidFacingModeValue(facingMode["".concat(exactKey)])) return {
                            facingMode: {
                                exact: facingMode["".concat(exactKey)]
                            }
                        };
                    } else throw "'facingMode' should be string or object with" + " ".concat(exactKey, " as key.");
                } else {
                    var type_1 = typeof facingMode;
                    throw "Invalid type of 'facingMode' = ".concat(type_1);
                }
            } else {
                var deviceId = cameraIdOrConfig.deviceId;
                if (typeof deviceId == "string") return {
                    deviceId: deviceId
                };
                else if (typeof deviceId == "object") {
                    if (exactKey in deviceId) return {
                        deviceId: {
                            exact: deviceId["".concat(exactKey)]
                        }
                    };
                    else throw "'deviceId' should be string or object with" + " ".concat(exactKey, " as key.");
                } else {
                    var type_2 = typeof deviceId;
                    throw "Invalid type of 'deviceId' = ".concat(type_2);
                }
            }
        }
        var type = typeof cameraIdOrConfig;
        throw "Invalid type of 'cameraIdOrConfig' = ".concat(type);
    };
    Html5Qrcode.prototype.computeCanvasDrawConfig = function(imageWidth, imageHeight, containerWidth, containerHeight) {
        if (imageWidth <= containerWidth && imageHeight <= containerHeight) {
            var xoffset = (containerWidth - imageWidth) / 2;
            var yoffset = (containerHeight - imageHeight) / 2;
            return {
                x: xoffset,
                y: yoffset,
                width: imageWidth,
                height: imageHeight
            };
        } else {
            var formerImageWidth = imageWidth;
            var formerImageHeight = imageHeight;
            if (imageWidth > containerWidth) {
                imageHeight = containerWidth / imageWidth * imageHeight;
                imageWidth = containerWidth;
            }
            if (imageHeight > containerHeight) {
                imageWidth = containerHeight / imageHeight * imageWidth;
                imageHeight = containerHeight;
            }
            this.logger.log("Image downsampled from " + "".concat(formerImageWidth, "X").concat(formerImageHeight) + " to ".concat(imageWidth, "X").concat(imageHeight, "."));
            return this.computeCanvasDrawConfig(imageWidth, imageHeight, containerWidth, containerHeight);
        }
    };
    Html5Qrcode.prototype.clearElement = function() {
        if (this.stateManagerProxy.isScanning()) throw "Cannot clear while scan is ongoing, close it first.";
        var element = document.getElementById(this.elementId);
        if (element) element.innerHTML = "";
    };
    Html5Qrcode.prototype.possiblyUpdateShaders = function(qrMatch) {
        if (this.qrMatch === qrMatch) return;
        if (this.hasBorderShaders && this.borderShaders && this.borderShaders.length) this.borderShaders.forEach(function(shader) {
            shader.style.backgroundColor = qrMatch ? $9eb3c467bce0942e$var$Constants.BORDER_SHADER_MATCH_COLOR : $9eb3c467bce0942e$var$Constants.BORDER_SHADER_DEFAULT_COLOR;
        });
        this.qrMatch = qrMatch;
    };
    Html5Qrcode.prototype.possiblyCloseLastScanImageFile = function() {
        if (this.lastScanImageFile) {
            URL.revokeObjectURL(this.lastScanImageFile);
            this.lastScanImageFile = null;
        }
    };
    Html5Qrcode.prototype.createCanvasElement = function(width, height, customId) {
        var canvasWidth = width;
        var canvasHeight = height;
        var canvasElement = document.createElement("canvas");
        canvasElement.style.width = "".concat(canvasWidth, "px");
        canvasElement.style.height = "".concat(canvasHeight, "px");
        canvasElement.style.display = "none";
        canvasElement.id = (0, $c9d6d3563c261b0e$export$bedb7023a7733221)(customId) ? "qr-canvas" : customId;
        return canvasElement;
    };
    Html5Qrcode.prototype.getShadedRegionBounds = function(width, height, qrboxSize) {
        if (qrboxSize.width > width || qrboxSize.height > height) throw "'config.qrbox' dimensions should not be greater than the dimensions of the root HTML element.";
        return {
            x: (width - qrboxSize.width) / 2,
            y: (height - qrboxSize.height) / 2,
            width: qrboxSize.width,
            height: qrboxSize.height
        };
    };
    Html5Qrcode.prototype.possiblyInsertShadingElement = function(element, width, height, qrboxSize) {
        if (width - qrboxSize.width < 1 || height - qrboxSize.height < 1) return;
        var shadingElement = document.createElement("div");
        shadingElement.style.position = "absolute";
        var rightLeftBorderSize = (width - qrboxSize.width) / 2;
        var topBottomBorderSize = (height - qrboxSize.height) / 2;
        shadingElement.style.borderLeft = "".concat(rightLeftBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderRight = "".concat(rightLeftBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderTop = "".concat(topBottomBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderBottom = "".concat(topBottomBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.boxSizing = "border-box";
        shadingElement.style.top = "0px";
        shadingElement.style.bottom = "0px";
        shadingElement.style.left = "0px";
        shadingElement.style.right = "0px";
        shadingElement.id = "".concat($9eb3c467bce0942e$var$Constants.SHADED_REGION_ELEMENT_ID);
        if (width - qrboxSize.width < 11 || height - qrboxSize.height < 11) this.hasBorderShaders = false;
        else {
            var smallSize = 5;
            var largeSize = 40;
            this.insertShaderBorders(shadingElement, largeSize, smallSize, -smallSize, null, 0, true);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, -smallSize, null, 0, false);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, null, -smallSize, 0, true);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, null, -smallSize, 0, false);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, -smallSize, null, -smallSize, true);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, null, -smallSize, -smallSize, true);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, -smallSize, null, -smallSize, false);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, null, -smallSize, -smallSize, false);
            this.hasBorderShaders = true;
        }
        element.append(shadingElement);
    };
    Html5Qrcode.prototype.insertShaderBorders = function(shaderElem, width, height, top, bottom, side, isLeft) {
        var elem = document.createElement("div");
        elem.style.position = "absolute";
        elem.style.backgroundColor = $9eb3c467bce0942e$var$Constants.BORDER_SHADER_DEFAULT_COLOR;
        elem.style.width = "".concat(width, "px");
        elem.style.height = "".concat(height, "px");
        if (top !== null) elem.style.top = "".concat(top, "px");
        if (bottom !== null) elem.style.bottom = "".concat(bottom, "px");
        if (isLeft) elem.style.left = "".concat(side, "px");
        else elem.style.right = "".concat(side, "px");
        if (!this.borderShaders) this.borderShaders = [];
        this.borderShaders.push(elem);
        shaderElem.appendChild(elem);
    };
    Html5Qrcode.prototype.showPausedState = function() {
        if (!this.scannerPausedUiElement) throw "[internal error] scanner paused UI element not found";
        this.scannerPausedUiElement.style.display = "block";
    };
    Html5Qrcode.prototype.hidePausedState = function() {
        if (!this.scannerPausedUiElement) throw "[internal error] scanner paused UI element not found";
        this.scannerPausedUiElement.style.display = "none";
    };
    Html5Qrcode.prototype.getTimeoutFps = function(fps) {
        return 1000 / fps;
    };
    return Html5Qrcode;
}();





var $701d751907918eac$var$SVG_XML_PREFIX = "data:image/svg+xml;base64,";
var $701d751907918eac$export$be7b9b11efa99dbc = $701d751907918eac$var$SVG_XML_PREFIX + "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";
var $701d751907918eac$export$c97cd35b47589f30 = $701d751907918eac$var$SVG_XML_PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1OS4wMTggNTkuMDE4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1OS4wMTggNTkuMDE4IiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJtNTguNzQxIDU0LjgwOS01Ljk2OS02LjI0NGExMC43NCAxMC43NCAwIDAgMCAyLjgyLTcuMjVjMC01Ljk1My00Ljg0My0xMC43OTYtMTAuNzk2LTEwLjc5NlMzNCAzNS4zNjEgMzQgNDEuMzE0IDM4Ljg0MyA1Mi4xMSA0NC43OTYgNTIuMTFjMi40NDEgMCA0LjY4OC0uODI0IDYuNDk5LTIuMTk2bDYuMDAxIDYuMjc3YS45OTguOTk4IDAgMCAwIDEuNDE0LjAzMiAxIDEgMCAwIDAgLjAzMS0xLjQxNHpNMzYgNDEuMzE0YzAtNC44NSAzLjk0Ni04Ljc5NiA4Ljc5Ni04Ljc5NnM4Ljc5NiAzLjk0NiA4Ljc5NiA4Ljc5Ni0zLjk0NiA4Ljc5Ni04Ljc5NiA4Ljc5NlMzNiA0Ni4xNjQgMzYgNDEuMzE0ek0xMC40MzEgMTYuMDg4YzAgMy4wNyAyLjQ5OCA1LjU2OCA1LjU2OSA1LjU2OHM1LjU2OS0yLjQ5OCA1LjU2OS01LjU2OGMwLTMuMDcxLTIuNDk4LTUuNTY5LTUuNTY5LTUuNTY5cy01LjU2OSAyLjQ5OC01LjU2OSA1LjU2OXptOS4xMzggMGMwIDEuOTY4LTEuNjAyIDMuNTY4LTMuNTY5IDMuNTY4cy0zLjU2OS0xLjYwMS0zLjU2OS0zLjU2OCAxLjYwMi0zLjU2OSAzLjU2OS0zLjU2OSAzLjU2OSAxLjYwMSAzLjU2OSAzLjU2OXoiLz48cGF0aCBkPSJtMzAuODgyIDI4Ljk4NyA5LjE4LTEwLjA1NCAxMS4yNjIgMTAuMzIzYTEgMSAwIDAgMCAxLjM1MS0xLjQ3NWwtMTItMTFhMSAxIDAgMCAwLTEuNDE0LjA2M2wtOS43OTQgMTAuNzI3LTQuNzQzLTQuNzQzYTEuMDAzIDEuMDAzIDAgMCAwLTEuMzY4LS4wNDRMNi4zMzkgMzcuNzY4YTEgMSAwIDEgMCAxLjMyMiAxLjUwMWwxNi4zMTMtMTQuMzYyIDcuMzE5IDcuMzE4YS45OTkuOTk5IDAgMSAwIDEuNDE0LTEuNDE0bC0xLjgyNS0xLjgyNHoiLz48cGF0aCBkPSJNMzAgNDYuNTE4SDJ2LTQyaDU0djI4YTEgMSAwIDEgMCAyIDB2LTI5YTEgMSAwIDAgMC0xLTFIMWExIDEgMCAwIDAtMSAxdjQ0YTEgMSAwIDAgMCAxIDFoMjlhMSAxIDAgMSAwIDAtMnoiLz48L3N2Zz4=";
var $701d751907918eac$export$c5538664401ceea = $701d751907918eac$var$SVG_XML_PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NjAgNDYwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NjAgNDYwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNMjMwIDBDMTAyLjk3NSAwIDAgMTAyLjk3NSAwIDIzMHMxMDIuOTc1IDIzMCAyMzAgMjMwIDIzMC0xMDIuOTc0IDIzMC0yMzBTMzU3LjAyNSAwIDIzMCAwem0zOC4zMzMgMzc3LjM2YzAgOC42NzYtNy4wMzQgMTUuNzEtMTUuNzEgMTUuNzFoLTQzLjEwMWMtOC42NzYgMC0xNS43MS03LjAzNC0xNS43MS0xNS43MVYyMDIuNDc3YzAtOC42NzYgNy4wMzMtMTUuNzEgMTUuNzEtMTUuNzFoNDMuMTAxYzguNjc2IDAgMTUuNzEgNy4wMzMgMTUuNzEgMTUuNzFWMzc3LjM2ek0yMzAgMTU3Yy0yMS41MzkgMC0zOS0xNy40NjEtMzktMzlzMTcuNDYxLTM5IDM5LTM5IDM5IDE3LjQ2MSAzOSAzOS0xNy40NjEgMzktMzkgMzl6Ii8+PC9zdmc+";
var $701d751907918eac$export$a9695a750cdd2270 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAQgAAAEIBarqQRAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAE1SURBVDiNfdI7S0NBEAXgLya1otFgpbYSbISAgpXYi6CmiH9KCAiChaVga6OiWPgfRDQ+0itaGVNosXtluWwcuMzePfM4M3sq8lbHBubwg1dc4m1E/J/N4ghDPOIsfk/4xiEao5KX0McFljN4C9d4QTPXuY99jP3DsIoDPGM6BY5i5yI5R7O4q+ImFkJY2DCh3cAH2klyB+9J1xUMMAG7eCh1a+Mr+k48b5diXrFVwwLuS+BJ9MfR7+G0FHOHhTHhnXNWS87VDF4pcnfQK4Ep7XScNLmPTZgURNKKYENYWDpzW1BhscS1WHS8CDgURFJQrWcoF3c13KKbgg1BYQfy8xZWEzTTw1QZbAoKu8FqJnktdu5hcVSHmchiILzzuaDQvjBzV2m8yohCE1jHfPx/xhU+y4G/D75ELlRJsSYAAAAASUVORK5CYII=";


var $569f6d15e38e44d3$var$PersistedDataFactory = function() {
    function PersistedDataFactory() {}
    PersistedDataFactory.createDefault = function() {
        return {
            hasPermission: false,
            lastUsedCameraId: null
        };
    };
    return PersistedDataFactory;
}();
var $569f6d15e38e44d3$export$f4f7158604555024 = function() {
    function PersistedDataManager() {
        this.data = $569f6d15e38e44d3$var$PersistedDataFactory.createDefault();
        var data = localStorage.getItem(PersistedDataManager.LOCAL_STORAGE_KEY);
        if (!data) this.reset();
        else this.data = JSON.parse(data);
    }
    PersistedDataManager.prototype.hasCameraPermissions = function() {
        return this.data.hasPermission;
    };
    PersistedDataManager.prototype.getLastUsedCameraId = function() {
        return this.data.lastUsedCameraId;
    };
    PersistedDataManager.prototype.setHasPermission = function(hasPermission) {
        this.data.hasPermission = hasPermission;
        this.flush();
    };
    PersistedDataManager.prototype.setLastUsedCameraId = function(lastUsedCameraId) {
        this.data.lastUsedCameraId = lastUsedCameraId;
        this.flush();
    };
    PersistedDataManager.prototype.resetLastUsedCameraId = function() {
        this.data.lastUsedCameraId = null;
        this.flush();
    };
    PersistedDataManager.prototype.reset = function() {
        this.data = $569f6d15e38e44d3$var$PersistedDataFactory.createDefault();
        this.flush();
    };
    PersistedDataManager.prototype.flush = function() {
        localStorage.setItem(PersistedDataManager.LOCAL_STORAGE_KEY, JSON.stringify(this.data));
    };
    PersistedDataManager.LOCAL_STORAGE_KEY = "HTML5_QRCODE_DATA";
    return PersistedDataManager;
}();




var $97aa7730745cc7b4$var$LibraryInfoDiv = function() {
    function LibraryInfoDiv() {
        this.infoDiv = document.createElement("div");
    }
    LibraryInfoDiv.prototype.renderInto = function(parent) {
        this.infoDiv.style.position = "absolute";
        this.infoDiv.style.top = "10px";
        this.infoDiv.style.right = "10px";
        this.infoDiv.style.zIndex = "2";
        this.infoDiv.style.display = "none";
        this.infoDiv.style.padding = "5pt";
        this.infoDiv.style.border = "1px solid #171717";
        this.infoDiv.style.fontSize = "10pt";
        this.infoDiv.style.background = "rgb(0 0 0 / 69%)";
        this.infoDiv.style.borderRadius = "5px";
        this.infoDiv.style.textAlign = "center";
        this.infoDiv.style.fontWeight = "400";
        this.infoDiv.style.color = "white";
        this.infoDiv.innerText = (0, $ff5e69b322275082$export$ef6635d54d6a0486).poweredBy();
        var projectLink = document.createElement("a");
        projectLink.innerText = "ScanApp";
        projectLink.href = "https://scanapp.org";
        projectLink.target = "new";
        projectLink.style.color = "white";
        this.infoDiv.appendChild(projectLink);
        var breakElemFirst = document.createElement("br");
        var breakElemSecond = document.createElement("br");
        this.infoDiv.appendChild(breakElemFirst);
        this.infoDiv.appendChild(breakElemSecond);
        var reportIssueLink = document.createElement("a");
        reportIssueLink.innerText = (0, $ff5e69b322275082$export$ef6635d54d6a0486).reportIssues();
        reportIssueLink.href = "https://github.com/mebjas/html5-qrcode/issues";
        reportIssueLink.target = "new";
        reportIssueLink.style.color = "white";
        this.infoDiv.appendChild(reportIssueLink);
        parent.appendChild(this.infoDiv);
    };
    LibraryInfoDiv.prototype.show = function() {
        this.infoDiv.style.display = "block";
    };
    LibraryInfoDiv.prototype.hide = function() {
        this.infoDiv.style.display = "none";
    };
    return LibraryInfoDiv;
}();
var $97aa7730745cc7b4$var$LibraryInfoIcon = function() {
    function LibraryInfoIcon(onTapIn, onTapOut) {
        this.isShowingInfoIcon = true;
        this.onTapIn = onTapIn;
        this.onTapOut = onTapOut;
        this.infoIcon = document.createElement("img");
    }
    LibraryInfoIcon.prototype.renderInto = function(parent) {
        var _this = this;
        this.infoIcon.alt = "Info icon";
        this.infoIcon.src = (0, $701d751907918eac$export$c5538664401ceea);
        this.infoIcon.style.position = "absolute";
        this.infoIcon.style.top = "4px";
        this.infoIcon.style.right = "4px";
        this.infoIcon.style.opacity = "0.6";
        this.infoIcon.style.cursor = "pointer";
        this.infoIcon.style.zIndex = "2";
        this.infoIcon.style.width = "16px";
        this.infoIcon.style.height = "16px";
        this.infoIcon.onmouseover = function(_) {
            return _this.onHoverIn();
        };
        this.infoIcon.onmouseout = function(_) {
            return _this.onHoverOut();
        };
        this.infoIcon.onclick = function(_) {
            return _this.onClick();
        };
        parent.appendChild(this.infoIcon);
    };
    LibraryInfoIcon.prototype.onHoverIn = function() {
        if (this.isShowingInfoIcon) this.infoIcon.style.opacity = "1";
    };
    LibraryInfoIcon.prototype.onHoverOut = function() {
        if (this.isShowingInfoIcon) this.infoIcon.style.opacity = "0.6";
    };
    LibraryInfoIcon.prototype.onClick = function() {
        if (this.isShowingInfoIcon) {
            this.isShowingInfoIcon = false;
            this.onTapIn();
            this.infoIcon.src = (0, $701d751907918eac$export$a9695a750cdd2270);
            this.infoIcon.style.opacity = "1";
        } else {
            this.isShowingInfoIcon = true;
            this.onTapOut();
            this.infoIcon.src = (0, $701d751907918eac$export$c5538664401ceea);
            this.infoIcon.style.opacity = "0.6";
        }
    };
    return LibraryInfoIcon;
}();
var $97aa7730745cc7b4$export$a2d0fe6d33028e31 = function() {
    function LibraryInfoContainer() {
        var _this = this;
        this.infoDiv = new $97aa7730745cc7b4$var$LibraryInfoDiv();
        this.infoIcon = new $97aa7730745cc7b4$var$LibraryInfoIcon(function() {
            _this.infoDiv.show();
        }, function() {
            _this.infoDiv.hide();
        });
    }
    LibraryInfoContainer.prototype.renderInto = function(parent) {
        this.infoDiv.renderInto(parent);
        this.infoIcon.renderInto(parent);
    };
    return LibraryInfoContainer;
}();


var $a7838855c7abaae7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a7838855c7abaae7$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $a7838855c7abaae7$export$693eae80963d557e = function() {
    function CameraPermissions() {}
    CameraPermissions.hasPermissions = function() {
        return $a7838855c7abaae7$var$__awaiter(this, void 0, void 0, function() {
            var devices, _i, devices_1, device;
            return $a7838855c7abaae7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        devices = _a.sent();
                        for(_i = 0, devices_1 = devices; _i < devices_1.length; _i++){
                            device = devices_1[_i];
                            if (device.kind === "videoinput" && device.label) return [
                                2,
                                true
                            ];
                        }
                        return [
                            2,
                            false
                        ];
                }
            });
        });
    };
    return CameraPermissions;
}();



var $f71efc754e4e9dc7$export$528d36479c095a59 = function() {
    function ScanTypeSelector(supportedScanTypes) {
        this.supportedScanTypes = this.validateAndReturnScanTypes(supportedScanTypes);
    }
    ScanTypeSelector.prototype.getDefaultScanType = function() {
        return this.supportedScanTypes[0];
    };
    ScanTypeSelector.prototype.hasMoreThanOneScanType = function() {
        return this.supportedScanTypes.length > 1;
    };
    ScanTypeSelector.prototype.isCameraScanRequired = function() {
        for(var _i = 0, _a = this.supportedScanTypes; _i < _a.length; _i++){
            var scanType = _a[_i];
            if (ScanTypeSelector.isCameraScanType(scanType)) return true;
        }
        return false;
    };
    ScanTypeSelector.isCameraScanType = function(scanType) {
        return scanType === (0, $c9d6d3563c261b0e$export$13ed3042ed099f6a).SCAN_TYPE_CAMERA;
    };
    ScanTypeSelector.isFileScanType = function(scanType) {
        return scanType === (0, $c9d6d3563c261b0e$export$13ed3042ed099f6a).SCAN_TYPE_FILE;
    };
    ScanTypeSelector.prototype.validateAndReturnScanTypes = function(supportedScanTypes) {
        if (!supportedScanTypes || supportedScanTypes.length === 0) return (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_SUPPORTED_SCAN_TYPE;
        var maxExpectedValues = (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_SUPPORTED_SCAN_TYPE.length;
        if (supportedScanTypes.length > maxExpectedValues) throw "Max ".concat(maxExpectedValues, " values expected for ") + "supportedScanTypes";
        for(var _i = 0, supportedScanTypes_1 = supportedScanTypes; _i < supportedScanTypes_1.length; _i++){
            var scanType = supportedScanTypes_1[_i];
            if (!(0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_SUPPORTED_SCAN_TYPE.includes(scanType)) throw "Unsupported scan type ".concat(scanType);
        }
        return supportedScanTypes;
    };
    return ScanTypeSelector;
}();



var $e012aa67914a9f32$export$5263f2f87e9ad375 = function() {
    function PublicUiElementIdAndClasses() {}
    PublicUiElementIdAndClasses.ALL_ELEMENT_CLASS = "html5-qrcode-element";
    PublicUiElementIdAndClasses.CAMERA_PERMISSION_BUTTON_ID = "html5-qrcode-button-camera-permission";
    PublicUiElementIdAndClasses.CAMERA_START_BUTTON_ID = "html5-qrcode-button-camera-start";
    PublicUiElementIdAndClasses.CAMERA_STOP_BUTTON_ID = "html5-qrcode-button-camera-stop";
    PublicUiElementIdAndClasses.TORCH_BUTTON_ID = "html5-qrcode-button-torch";
    PublicUiElementIdAndClasses.CAMERA_SELECTION_SELECT_ID = "html5-qrcode-select-camera";
    PublicUiElementIdAndClasses.FILE_SELECTION_BUTTON_ID = "html5-qrcode-button-file-selection";
    PublicUiElementIdAndClasses.ZOOM_SLIDER_ID = "html5-qrcode-input-range-zoom";
    PublicUiElementIdAndClasses.SCAN_TYPE_CHANGE_ANCHOR_ID = "html5-qrcode-anchor-scan-type-change";
    PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_ON = "html5-qrcode-button-torch-on";
    PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_OFF = "html5-qrcode-button-torch-off";
    return PublicUiElementIdAndClasses;
}();
var $e012aa67914a9f32$export$6a3443a184593c5 = function() {
    function BaseUiElementFactory() {}
    BaseUiElementFactory.createElement = function(elementType, elementId) {
        var element = document.createElement(elementType);
        element.id = elementId;
        element.classList.add($e012aa67914a9f32$export$5263f2f87e9ad375.ALL_ELEMENT_CLASS);
        if (elementType === "button") element.setAttribute("type", "button");
        return element;
    };
    return BaseUiElementFactory;
}();


var $44f49b3cb4096e16$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $44f49b3cb4096e16$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $44f49b3cb4096e16$var$TorchController = function() {
    function TorchController(torchCapability, buttonController, onTorchActionFailureCallback) {
        this.isTorchOn = false;
        this.torchCapability = torchCapability;
        this.buttonController = buttonController;
        this.onTorchActionFailureCallback = onTorchActionFailureCallback;
    }
    TorchController.prototype.isTorchEnabled = function() {
        return this.isTorchOn;
    };
    TorchController.prototype.flipState = function() {
        return $44f49b3cb4096e16$var$__awaiter(this, void 0, void 0, function() {
            var isTorchOnExpected, error_1;
            return $44f49b3cb4096e16$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.buttonController.disable();
                        isTorchOnExpected = !this.isTorchOn;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            this.torchCapability.apply(isTorchOnExpected)
                        ];
                    case 2:
                        _a.sent();
                        this.updateUiBasedOnLatestSettings(this.torchCapability.value(), isTorchOnExpected);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        this.propagateFailure(isTorchOnExpected, error_1);
                        this.buttonController.enable();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    TorchController.prototype.updateUiBasedOnLatestSettings = function(isTorchOn, isTorchOnExpected) {
        if (isTorchOn === isTorchOnExpected) {
            this.buttonController.setText(isTorchOnExpected ? (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOffButton() : (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOnButton());
            this.isTorchOn = isTorchOnExpected;
        } else this.propagateFailure(isTorchOnExpected);
        this.buttonController.enable();
    };
    TorchController.prototype.propagateFailure = function(isTorchOnExpected, error) {
        var errorMessage = isTorchOnExpected ? (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOnFailedMessage() : (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOffFailedMessage();
        if (error) errorMessage += "; Error = " + error;
        this.onTorchActionFailureCallback(errorMessage);
    };
    TorchController.prototype.reset = function() {
        this.isTorchOn = false;
    };
    return TorchController;
}();
var $44f49b3cb4096e16$export$11856eebe9d443c6 = function() {
    function TorchButton(torchCapability, onTorchActionFailureCallback) {
        this.onTorchActionFailureCallback = onTorchActionFailureCallback;
        this.torchButton = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("button", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).TORCH_BUTTON_ID);
        this.torchController = new $44f49b3cb4096e16$var$TorchController(torchCapability, this, onTorchActionFailureCallback);
    }
    TorchButton.prototype.render = function(parentElement, torchButtonOptions) {
        var _this = this;
        this.torchButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOnButton();
        this.torchButton.style.display = torchButtonOptions.display;
        this.torchButton.style.marginLeft = torchButtonOptions.marginLeft;
        var $this = this;
        this.torchButton.addEventListener("click", function(_) {
            return $44f49b3cb4096e16$var$__awaiter(_this, void 0, void 0, function() {
                return $44f49b3cb4096e16$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                $this.torchController.flipState()
                            ];
                        case 1:
                            _a.sent();
                            if ($this.torchController.isTorchEnabled()) {
                                $this.torchButton.classList.remove((0, $e012aa67914a9f32$export$5263f2f87e9ad375).TORCH_BUTTON_CLASS_TORCH_OFF);
                                $this.torchButton.classList.add((0, $e012aa67914a9f32$export$5263f2f87e9ad375).TORCH_BUTTON_CLASS_TORCH_ON);
                            } else {
                                $this.torchButton.classList.remove((0, $e012aa67914a9f32$export$5263f2f87e9ad375).TORCH_BUTTON_CLASS_TORCH_ON);
                                $this.torchButton.classList.add((0, $e012aa67914a9f32$export$5263f2f87e9ad375).TORCH_BUTTON_CLASS_TORCH_OFF);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        });
        parentElement.appendChild(this.torchButton);
    };
    TorchButton.prototype.updateTorchCapability = function(torchCapability) {
        this.torchController = new $44f49b3cb4096e16$var$TorchController(torchCapability, this, this.onTorchActionFailureCallback);
    };
    TorchButton.prototype.getTorchButton = function() {
        return this.torchButton;
    };
    TorchButton.prototype.hide = function() {
        this.torchButton.style.display = "none";
    };
    TorchButton.prototype.show = function() {
        this.torchButton.style.display = "inline-block";
    };
    TorchButton.prototype.disable = function() {
        this.torchButton.disabled = true;
    };
    TorchButton.prototype.enable = function() {
        this.torchButton.disabled = false;
    };
    TorchButton.prototype.setText = function(text) {
        this.torchButton.innerText = text;
    };
    TorchButton.prototype.reset = function() {
        this.torchButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOnButton();
        this.torchController.reset();
    };
    TorchButton.create = function(parentElement, torchCapability, torchButtonOptions, onTorchActionFailureCallback) {
        var button = new TorchButton(torchCapability, onTorchActionFailureCallback);
        button.render(parentElement, torchButtonOptions);
        return button;
    };
    return TorchButton;
}();




var $16862ce938b2b921$export$bb6f0d5a8973d33 = function() {
    function FileSelectionUi(parentElement, showOnRender, onFileSelected) {
        this.fileBasedScanRegion = this.createFileBasedScanRegion();
        this.fileBasedScanRegion.style.display = showOnRender ? "block" : "none";
        parentElement.appendChild(this.fileBasedScanRegion);
        var fileScanLabel = document.createElement("label");
        fileScanLabel.setAttribute("for", this.getFileScanInputId());
        fileScanLabel.style.display = "inline-block";
        this.fileBasedScanRegion.appendChild(fileScanLabel);
        this.fileSelectionButton = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("button", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).FILE_SELECTION_BUTTON_ID);
        this.setInitialValueToButton();
        this.fileSelectionButton.addEventListener("click", function(_) {
            fileScanLabel.click();
        });
        fileScanLabel.append(this.fileSelectionButton);
        this.fileScanInput = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("input", this.getFileScanInputId());
        this.fileScanInput.type = "file";
        this.fileScanInput.accept = "image/*";
        this.fileScanInput.style.display = "none";
        fileScanLabel.appendChild(this.fileScanInput);
        var $this = this;
        this.fileScanInput.addEventListener("change", function(e) {
            if (e == null || e.target == null) return;
            var target = e.target;
            if (target.files && target.files.length === 0) return;
            var fileList = target.files;
            var file = fileList[0];
            var fileName = file.name;
            $this.setImageNameToButton(fileName);
            onFileSelected(file);
        });
        var dragAndDropMessage = this.createDragAndDropMessage();
        this.fileBasedScanRegion.appendChild(dragAndDropMessage);
        this.fileBasedScanRegion.addEventListener("dragenter", function(event) {
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionActiveBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("dragleave", function(event) {
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionDefaultBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("dragover", function(event) {
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionActiveBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("drop", function(event) {
            event.stopPropagation();
            event.preventDefault();
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionDefaultBorder();
            var dataTransfer = event.dataTransfer;
            if (dataTransfer) {
                var files = dataTransfer.files;
                if (!files || files.length === 0) return;
                var isAnyFileImage = false;
                for(var i = 0; i < files.length; ++i){
                    var file = files.item(i);
                    if (!file) continue;
                    var imageType = /image.*/;
                    if (!file.type.match(imageType)) continue;
                    isAnyFileImage = true;
                    var fileName = file.name;
                    $this.setImageNameToButton(fileName);
                    onFileSelected(file);
                    dragAndDropMessage.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).dragAndDropMessage();
                    break;
                }
                if (!isAnyFileImage) dragAndDropMessage.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).dragAndDropMessageOnlyImages();
            }
        });
    }
    FileSelectionUi.prototype.hide = function() {
        this.fileBasedScanRegion.style.display = "none";
        this.fileScanInput.disabled = true;
    };
    FileSelectionUi.prototype.show = function() {
        this.fileBasedScanRegion.style.display = "block";
        this.fileScanInput.disabled = false;
    };
    FileSelectionUi.prototype.isShowing = function() {
        return this.fileBasedScanRegion.style.display === "block";
    };
    FileSelectionUi.prototype.resetValue = function() {
        this.fileScanInput.value = "";
        this.setInitialValueToButton();
    };
    FileSelectionUi.prototype.createFileBasedScanRegion = function() {
        var fileBasedScanRegion = document.createElement("div");
        fileBasedScanRegion.style.textAlign = "center";
        fileBasedScanRegion.style.margin = "auto";
        fileBasedScanRegion.style.width = "80%";
        fileBasedScanRegion.style.maxWidth = "600px";
        fileBasedScanRegion.style.border = this.fileBasedScanRegionDefaultBorder();
        fileBasedScanRegion.style.padding = "10px";
        fileBasedScanRegion.style.marginBottom = "10px";
        return fileBasedScanRegion;
    };
    FileSelectionUi.prototype.fileBasedScanRegionDefaultBorder = function() {
        return "6px dashed #ebebeb";
    };
    FileSelectionUi.prototype.fileBasedScanRegionActiveBorder = function() {
        return "6px dashed rgb(153 151 151)";
    };
    FileSelectionUi.prototype.createDragAndDropMessage = function() {
        var dragAndDropMessage = document.createElement("div");
        dragAndDropMessage.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).dragAndDropMessage();
        dragAndDropMessage.style.fontWeight = "400";
        return dragAndDropMessage;
    };
    FileSelectionUi.prototype.setImageNameToButton = function(imageFileName) {
        var MAX_CHARS = 20;
        if (imageFileName.length > MAX_CHARS) {
            var start8Chars = imageFileName.substring(0, 8);
            var length_1 = imageFileName.length;
            var last8Chars = imageFileName.substring(length_1 - 8, length_1);
            imageFileName = "".concat(start8Chars, "....").concat(last8Chars);
        }
        var newText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).fileSelectionChooseAnother() + " - " + imageFileName;
        this.fileSelectionButton.innerText = newText;
    };
    FileSelectionUi.prototype.setInitialValueToButton = function() {
        var initialText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).fileSelectionChooseImage() + " - " + (0, $ff5e69b322275082$export$b9cab5abdb16545c).fileSelectionNoImageSelected();
        this.fileSelectionButton.innerText = initialText;
    };
    FileSelectionUi.prototype.getFileScanInputId = function() {
        return "html5-qrcode-private-filescan-input";
    };
    FileSelectionUi.create = function(parentElement, showOnRender, onFileSelected) {
        var button = new FileSelectionUi(parentElement, showOnRender, onFileSelected);
        return button;
    };
    return FileSelectionUi;
}();





var $4bec6eb7b41a1616$export$86c8efd5b3ebd03e = function() {
    function CameraSelectionUi(cameras) {
        this.selectElement = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("select", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).CAMERA_SELECTION_SELECT_ID);
        this.cameras = cameras;
        this.options = [];
    }
    CameraSelectionUi.prototype.render = function(parentElement) {
        var cameraSelectionContainer = document.createElement("span");
        cameraSelectionContainer.style.marginRight = "10px";
        var numCameras = this.cameras.length;
        if (numCameras === 0) throw new Error("No cameras found");
        if (numCameras === 1) cameraSelectionContainer.style.display = "none";
        else {
            var selectCameraString = (0, $ff5e69b322275082$export$b9cab5abdb16545c).selectCamera();
            cameraSelectionContainer.innerText = "".concat(selectCameraString, " (").concat(this.cameras.length, ")  ");
        }
        var anonymousCameraId = 1;
        for(var _i = 0, _a = this.cameras; _i < _a.length; _i++){
            var camera = _a[_i];
            var value = camera.id;
            var name_1 = camera.label == null ? value : camera.label;
            if (!name_1 || name_1 === "") name_1 = [
                (0, $ff5e69b322275082$export$b9cab5abdb16545c).anonymousCameraPrefix(),
                anonymousCameraId++
            ].join(" ");
            var option = document.createElement("option");
            option.value = value;
            option.innerText = name_1;
            this.options.push(option);
            this.selectElement.appendChild(option);
        }
        cameraSelectionContainer.appendChild(this.selectElement);
        parentElement.appendChild(cameraSelectionContainer);
    };
    CameraSelectionUi.prototype.disable = function() {
        this.selectElement.disabled = true;
    };
    CameraSelectionUi.prototype.isDisabled = function() {
        return this.selectElement.disabled === true;
    };
    CameraSelectionUi.prototype.enable = function() {
        this.selectElement.disabled = false;
    };
    CameraSelectionUi.prototype.getValue = function() {
        return this.selectElement.value;
    };
    CameraSelectionUi.prototype.hasValue = function(value) {
        for(var _i = 0, _a = this.options; _i < _a.length; _i++){
            var option = _a[_i];
            if (option.value === value) return true;
        }
        return false;
    };
    CameraSelectionUi.prototype.setValue = function(value) {
        if (!this.hasValue(value)) throw new Error("".concat(value, " is not present in the camera list."));
        this.selectElement.value = value;
    };
    CameraSelectionUi.prototype.hasSingleItem = function() {
        return this.cameras.length === 1;
    };
    CameraSelectionUi.prototype.numCameras = function() {
        return this.cameras.length;
    };
    CameraSelectionUi.create = function(parentElement, cameras) {
        var cameraSelectUi = new CameraSelectionUi(cameras);
        cameraSelectUi.render(parentElement);
        return cameraSelectUi;
    };
    return CameraSelectionUi;
}();




var $73da427dd62fd8db$export$2e993d10f166e456 = function() {
    function CameraZoomUi() {
        this.onChangeCallback = null;
        this.zoomElementContainer = document.createElement("div");
        this.rangeInput = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("input", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).ZOOM_SLIDER_ID);
        this.rangeInput.type = "range";
        this.rangeText = document.createElement("span");
        this.rangeInput.min = "1";
        this.rangeInput.max = "5";
        this.rangeInput.value = "1";
        this.rangeInput.step = "0.1";
    }
    CameraZoomUi.prototype.render = function(parentElement, renderOnCreate) {
        this.zoomElementContainer.style.display = renderOnCreate ? "block" : "none";
        this.zoomElementContainer.style.padding = "5px 10px";
        this.zoomElementContainer.style.textAlign = "center";
        parentElement.appendChild(this.zoomElementContainer);
        this.rangeInput.style.display = "inline-block";
        this.rangeInput.style.width = "50%";
        this.rangeInput.style.height = "5px";
        this.rangeInput.style.background = "#d3d3d3";
        this.rangeInput.style.outline = "none";
        this.rangeInput.style.opacity = "0.7";
        var zoomString = (0, $ff5e69b322275082$export$b9cab5abdb16545c).zoom();
        this.rangeText.innerText = "".concat(this.rangeInput.value, "x ").concat(zoomString);
        this.rangeText.style.marginRight = "10px";
        var $this = this;
        this.rangeInput.addEventListener("input", function() {
            return $this.onValueChange();
        });
        this.rangeInput.addEventListener("change", function() {
            return $this.onValueChange();
        });
        this.zoomElementContainer.appendChild(this.rangeInput);
        this.zoomElementContainer.appendChild(this.rangeText);
    };
    CameraZoomUi.prototype.onValueChange = function() {
        var zoomString = (0, $ff5e69b322275082$export$b9cab5abdb16545c).zoom();
        this.rangeText.innerText = "".concat(this.rangeInput.value, "x ").concat(zoomString);
        if (this.onChangeCallback) this.onChangeCallback(parseFloat(this.rangeInput.value));
    };
    CameraZoomUi.prototype.setValues = function(minValue, maxValue, defaultValue, step) {
        this.rangeInput.min = minValue.toString();
        this.rangeInput.max = maxValue.toString();
        this.rangeInput.step = step.toString();
        this.rangeInput.value = defaultValue.toString();
        this.onValueChange();
    };
    CameraZoomUi.prototype.show = function() {
        this.zoomElementContainer.style.display = "block";
    };
    CameraZoomUi.prototype.hide = function() {
        this.zoomElementContainer.style.display = "none";
    };
    CameraZoomUi.prototype.setOnCameraZoomValueChangeCallback = function(onChangeCallback) {
        this.onChangeCallback = onChangeCallback;
    };
    CameraZoomUi.prototype.removeOnCameraZoomValueChangeCallback = function() {
        this.onChangeCallback = null;
    };
    CameraZoomUi.create = function(parentElement, renderOnCreate) {
        var cameraZoomUi = new CameraZoomUi();
        cameraZoomUi.render(parentElement, renderOnCreate);
        return cameraZoomUi;
    };
    return CameraZoomUi;
}();


var $3479451dbf27e703$var$Html5QrcodeScannerStatus;
(function(Html5QrcodeScannerStatus) {
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_DEFAULT"] = 0] = "STATUS_DEFAULT";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_SUCCESS"] = 1] = "STATUS_SUCCESS";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_WARNING"] = 2] = "STATUS_WARNING";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_REQUESTING_PERMISSION"] = 3] = "STATUS_REQUESTING_PERMISSION";
})($3479451dbf27e703$var$Html5QrcodeScannerStatus || ($3479451dbf27e703$var$Html5QrcodeScannerStatus = {}));
function $3479451dbf27e703$var$toHtml5QrcodeCameraScanConfig(config) {
    return {
        fps: config.fps,
        qrbox: config.qrbox,
        aspectRatio: config.aspectRatio,
        disableFlip: config.disableFlip,
        videoConstraints: config.videoConstraints
    };
}
function $3479451dbf27e703$var$toHtml5QrcodeFullConfig(config, verbose) {
    return {
        formatsToSupport: config.formatsToSupport,
        useBarCodeDetectorIfSupported: config.useBarCodeDetectorIfSupported,
        experimentalFeatures: config.experimentalFeatures,
        verbose: verbose
    };
}
var $3479451dbf27e703$export$bc9b6fcc47abf610 = function() {
    function Html5QrcodeScanner(elementId, config, verbose) {
        this.lastMatchFound = null;
        this.cameraScanImage = null;
        this.fileScanImage = null;
        this.fileSelectionUi = null;
        this.elementId = elementId;
        this.config = this.createConfig(config);
        this.verbose = verbose === true;
        if (!document.getElementById(elementId)) throw "HTML Element with id=".concat(elementId, " not found");
        this.scanTypeSelector = new (0, $f71efc754e4e9dc7$export$528d36479c095a59)(this.config.supportedScanTypes);
        this.currentScanType = this.scanTypeSelector.getDefaultScanType();
        this.sectionSwapAllowed = true;
        this.logger = new (0, $c9d6d3563c261b0e$export$1952c0907ffae0f2)(this.verbose);
        this.persistedDataManager = new (0, $569f6d15e38e44d3$export$f4f7158604555024)();
        if (config.rememberLastUsedCamera !== true) this.persistedDataManager.reset();
    }
    Html5QrcodeScanner.prototype.render = function(qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        this.lastMatchFound = null;
        this.qrCodeSuccessCallback = function(decodedText, result) {
            if (qrCodeSuccessCallback) qrCodeSuccessCallback(decodedText, result);
            else {
                if (_this.lastMatchFound === decodedText) return;
                _this.lastMatchFound = decodedText;
                _this.setHeaderMessage((0, $ff5e69b322275082$export$b9cab5abdb16545c).lastMatch(decodedText), $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_SUCCESS);
            }
        };
        this.qrCodeErrorCallback = function(errorMessage, error) {
            if (qrCodeErrorCallback) qrCodeErrorCallback(errorMessage, error);
        };
        var container = document.getElementById(this.elementId);
        if (!container) throw "HTML Element with id=".concat(this.elementId, " not found");
        container.innerHTML = "";
        this.createBasicLayout(container);
        this.html5Qrcode = new (0, $9eb3c467bce0942e$export$e14ced7bffd8eb7a)(this.getScanRegionId(), $3479451dbf27e703$var$toHtml5QrcodeFullConfig(this.config, this.verbose));
    };
    Html5QrcodeScanner.prototype.pause = function(shouldPauseVideo) {
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(shouldPauseVideo) || shouldPauseVideo !== true) shouldPauseVideo = false;
        this.getHtml5QrcodeOrFail().pause(shouldPauseVideo);
    };
    Html5QrcodeScanner.prototype.resume = function() {
        this.getHtml5QrcodeOrFail().resume();
    };
    Html5QrcodeScanner.prototype.getState = function() {
        return this.getHtml5QrcodeOrFail().getState();
    };
    Html5QrcodeScanner.prototype.clear = function() {
        var _this = this;
        var emptyHtmlContainer = function() {
            var mainContainer = document.getElementById(_this.elementId);
            if (mainContainer) {
                mainContainer.innerHTML = "";
                _this.resetBasicLayout(mainContainer);
            }
        };
        if (this.html5Qrcode) return new Promise(function(resolve, reject) {
            if (!_this.html5Qrcode) {
                resolve();
                return;
            }
            if (_this.html5Qrcode.isScanning) _this.html5Qrcode.stop().then(function(_) {
                if (!_this.html5Qrcode) {
                    resolve();
                    return;
                }
                _this.html5Qrcode.clear();
                emptyHtmlContainer();
                resolve();
            }).catch(function(error) {
                if (_this.verbose) _this.logger.logError("Unable to stop qrcode scanner", error);
                reject(error);
            });
            else {
                _this.html5Qrcode.clear();
                emptyHtmlContainer();
                resolve();
            }
        });
        return Promise.resolve();
    };
    Html5QrcodeScanner.prototype.getRunningTrackCapabilities = function() {
        return this.getHtml5QrcodeOrFail().getRunningTrackCapabilities();
    };
    Html5QrcodeScanner.prototype.getRunningTrackSettings = function() {
        return this.getHtml5QrcodeOrFail().getRunningTrackSettings();
    };
    Html5QrcodeScanner.prototype.applyVideoConstraints = function(videoConstaints) {
        return this.getHtml5QrcodeOrFail().applyVideoConstraints(videoConstaints);
    };
    Html5QrcodeScanner.prototype.getHtml5QrcodeOrFail = function() {
        if (!this.html5Qrcode) throw "Code scanner not initialized.";
        return this.html5Qrcode;
    };
    Html5QrcodeScanner.prototype.createConfig = function(config) {
        if (config) {
            if (!config.fps) config.fps = (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).SCAN_DEFAULT_FPS;
            if (config.rememberLastUsedCamera !== !(0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_REMEMBER_LAST_CAMERA_USED) config.rememberLastUsedCamera = (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_REMEMBER_LAST_CAMERA_USED;
            if (!config.supportedScanTypes) config.supportedScanTypes = (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_SUPPORTED_SCAN_TYPE;
            return config;
        }
        return {
            fps: (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).SCAN_DEFAULT_FPS,
            rememberLastUsedCamera: (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_REMEMBER_LAST_CAMERA_USED,
            supportedScanTypes: (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_SUPPORTED_SCAN_TYPE
        };
    };
    Html5QrcodeScanner.prototype.createBasicLayout = function(parent) {
        parent.style.position = "relative";
        parent.style.padding = "0px";
        parent.style.border = "1px solid silver";
        this.createHeader(parent);
        var qrCodeScanRegion = document.createElement("div");
        var scanRegionId = this.getScanRegionId();
        qrCodeScanRegion.id = scanRegionId;
        qrCodeScanRegion.style.width = "100%";
        qrCodeScanRegion.style.minHeight = "100px";
        qrCodeScanRegion.style.textAlign = "center";
        parent.appendChild(qrCodeScanRegion);
        if ((0, $f71efc754e4e9dc7$export$528d36479c095a59).isCameraScanType(this.currentScanType)) this.insertCameraScanImageToScanRegion();
        else this.insertFileScanImageToScanRegion();
        var qrCodeDashboard = document.createElement("div");
        var dashboardId = this.getDashboardId();
        qrCodeDashboard.id = dashboardId;
        qrCodeDashboard.style.width = "100%";
        parent.appendChild(qrCodeDashboard);
        this.setupInitialDashboard(qrCodeDashboard);
    };
    Html5QrcodeScanner.prototype.resetBasicLayout = function(mainContainer) {
        mainContainer.style.border = "none";
    };
    Html5QrcodeScanner.prototype.setupInitialDashboard = function(dashboard) {
        this.createSection(dashboard);
        this.createSectionControlPanel();
        if (this.scanTypeSelector.hasMoreThanOneScanType()) this.createSectionSwap();
    };
    Html5QrcodeScanner.prototype.createHeader = function(dashboard) {
        var header = document.createElement("div");
        header.style.textAlign = "left";
        header.style.margin = "0px";
        dashboard.appendChild(header);
        var libraryInfo = new (0, $97aa7730745cc7b4$export$a2d0fe6d33028e31)();
        libraryInfo.renderInto(header);
        var headerMessageContainer = document.createElement("div");
        headerMessageContainer.id = this.getHeaderMessageContainerId();
        headerMessageContainer.style.display = "none";
        headerMessageContainer.style.textAlign = "center";
        headerMessageContainer.style.fontSize = "14px";
        headerMessageContainer.style.padding = "2px 10px";
        headerMessageContainer.style.margin = "4px";
        headerMessageContainer.style.borderTop = "1px solid #f6f6f6";
        header.appendChild(headerMessageContainer);
    };
    Html5QrcodeScanner.prototype.createSection = function(dashboard) {
        var section = document.createElement("div");
        section.id = this.getDashboardSectionId();
        section.style.width = "100%";
        section.style.padding = "10px 0px 10px 0px";
        section.style.textAlign = "left";
        dashboard.appendChild(section);
    };
    Html5QrcodeScanner.prototype.createCameraListUi = function(scpCameraScanRegion, requestPermissionContainer, requestPermissionButton) {
        var $this = this;
        $this.showHideScanTypeSwapLink(false);
        $this.setHeaderMessage((0, $ff5e69b322275082$export$b9cab5abdb16545c).cameraPermissionRequesting());
        var createPermissionButtonIfNotExists = function() {
            if (!requestPermissionButton) $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
        };
        (0, $9eb3c467bce0942e$export$e14ced7bffd8eb7a).getCameras().then(function(cameras) {
            $this.persistedDataManager.setHasPermission(true);
            $this.showHideScanTypeSwapLink(true);
            $this.resetHeaderMessage();
            if (cameras && cameras.length > 0) {
                scpCameraScanRegion.removeChild(requestPermissionContainer);
                $this.renderCameraSelection(cameras);
            } else {
                $this.setHeaderMessage((0, $ff5e69b322275082$export$b9cab5abdb16545c).noCameraFound(), $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
                createPermissionButtonIfNotExists();
            }
        }).catch(function(error) {
            $this.persistedDataManager.setHasPermission(false);
            if (requestPermissionButton) requestPermissionButton.disabled = false;
            else createPermissionButtonIfNotExists();
            $this.setHeaderMessage(error, $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            $this.showHideScanTypeSwapLink(true);
        });
    };
    Html5QrcodeScanner.prototype.createPermissionButton = function(scpCameraScanRegion, requestPermissionContainer) {
        var $this = this;
        var requestPermissionButton = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("button", this.getCameraPermissionButtonId());
        requestPermissionButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).cameraPermissionTitle();
        requestPermissionButton.addEventListener("click", function() {
            requestPermissionButton.disabled = true;
            $this.createCameraListUi(scpCameraScanRegion, requestPermissionContainer, requestPermissionButton);
        });
        requestPermissionContainer.appendChild(requestPermissionButton);
    };
    Html5QrcodeScanner.prototype.createPermissionsUi = function(scpCameraScanRegion, requestPermissionContainer) {
        var $this = this;
        if ((0, $f71efc754e4e9dc7$export$528d36479c095a59).isCameraScanType(this.currentScanType) && this.persistedDataManager.hasCameraPermissions()) {
            (0, $a7838855c7abaae7$export$693eae80963d557e).hasPermissions().then(function(hasPermissions) {
                if (hasPermissions) $this.createCameraListUi(scpCameraScanRegion, requestPermissionContainer);
                else {
                    $this.persistedDataManager.setHasPermission(false);
                    $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
                }
            }).catch(function(_) {
                $this.persistedDataManager.setHasPermission(false);
                $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
            });
            return;
        }
        this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
    };
    Html5QrcodeScanner.prototype.createSectionControlPanel = function() {
        var section = document.getElementById(this.getDashboardSectionId());
        var sectionControlPanel = document.createElement("div");
        section.appendChild(sectionControlPanel);
        var scpCameraScanRegion = document.createElement("div");
        scpCameraScanRegion.id = this.getDashboardSectionCameraScanRegionId();
        scpCameraScanRegion.style.display = (0, $f71efc754e4e9dc7$export$528d36479c095a59).isCameraScanType(this.currentScanType) ? "block" : "none";
        sectionControlPanel.appendChild(scpCameraScanRegion);
        var requestPermissionContainer = document.createElement("div");
        requestPermissionContainer.style.textAlign = "center";
        scpCameraScanRegion.appendChild(requestPermissionContainer);
        if (this.scanTypeSelector.isCameraScanRequired()) this.createPermissionsUi(scpCameraScanRegion, requestPermissionContainer);
        this.renderFileScanUi(sectionControlPanel);
    };
    Html5QrcodeScanner.prototype.renderFileScanUi = function(parent) {
        var showOnRender = (0, $f71efc754e4e9dc7$export$528d36479c095a59).isFileScanType(this.currentScanType);
        var $this = this;
        var onFileSelected = function(file) {
            if (!$this.html5Qrcode) throw "html5Qrcode not defined";
            if (!(0, $f71efc754e4e9dc7$export$528d36479c095a59).isFileScanType($this.currentScanType)) return;
            $this.setHeaderMessage((0, $ff5e69b322275082$export$b9cab5abdb16545c).loadingImage());
            $this.html5Qrcode.scanFileV2(file, true).then(function(html5qrcodeResult) {
                $this.resetHeaderMessage();
                $this.qrCodeSuccessCallback(html5qrcodeResult.decodedText, html5qrcodeResult);
            }).catch(function(error) {
                $this.setHeaderMessage(error, $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
                $this.qrCodeErrorCallback(error, (0, $c9d6d3563c261b0e$export$dac571266bd01cf5).createFrom(error));
            });
        };
        this.fileSelectionUi = (0, $16862ce938b2b921$export$bb6f0d5a8973d33).create(parent, showOnRender, onFileSelected);
    };
    Html5QrcodeScanner.prototype.renderCameraSelection = function(cameras) {
        var _this = this;
        var $this = this;
        var scpCameraScanRegion = document.getElementById(this.getDashboardSectionCameraScanRegionId());
        scpCameraScanRegion.style.textAlign = "center";
        var cameraZoomUi = (0, $73da427dd62fd8db$export$2e993d10f166e456).create(scpCameraScanRegion, false);
        var renderCameraZoomUiIfSupported = function(cameraCapabilities) {
            var zoomCapability = cameraCapabilities.zoomFeature();
            if (!zoomCapability.isSupported()) return;
            cameraZoomUi.setOnCameraZoomValueChangeCallback(function(zoomValue) {
                zoomCapability.apply(zoomValue);
            });
            var defaultZoom = 1;
            if (_this.config.defaultZoomValueIfSupported) defaultZoom = _this.config.defaultZoomValueIfSupported;
            defaultZoom = (0, $c9d6d3563c261b0e$export$e0b576e7a74416cd)(defaultZoom, zoomCapability.min(), zoomCapability.max());
            cameraZoomUi.setValues(zoomCapability.min(), zoomCapability.max(), defaultZoom, zoomCapability.step());
            cameraZoomUi.show();
        };
        var cameraSelectUi = (0, $4bec6eb7b41a1616$export$86c8efd5b3ebd03e).create(scpCameraScanRegion, cameras);
        var cameraActionContainer = document.createElement("span");
        var cameraActionStartButton = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("button", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).CAMERA_START_BUTTON_ID);
        cameraActionStartButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).scanButtonStartScanningText();
        cameraActionContainer.appendChild(cameraActionStartButton);
        var cameraActionStopButton = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("button", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).CAMERA_STOP_BUTTON_ID);
        cameraActionStopButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).scanButtonStopScanningText();
        cameraActionStopButton.style.display = "none";
        cameraActionStopButton.disabled = true;
        cameraActionContainer.appendChild(cameraActionStopButton);
        var torchButton;
        var createAndShowTorchButtonIfSupported = function(cameraCapabilities) {
            if (!cameraCapabilities.torchFeature().isSupported()) {
                if (torchButton) torchButton.hide();
                return;
            }
            if (!torchButton) torchButton = (0, $44f49b3cb4096e16$export$11856eebe9d443c6).create(cameraActionContainer, cameraCapabilities.torchFeature(), {
                display: "none",
                marginLeft: "5px"
            }, function(errorMessage) {
                $this.setHeaderMessage(errorMessage, $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            });
            else torchButton.updateTorchCapability(cameraCapabilities.torchFeature());
            torchButton.show();
        };
        scpCameraScanRegion.appendChild(cameraActionContainer);
        var resetCameraActionStartButton = function(shouldShow) {
            if (!shouldShow) cameraActionStartButton.style.display = "none";
            cameraActionStartButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).scanButtonStartScanningText();
            cameraActionStartButton.style.opacity = "1";
            cameraActionStartButton.disabled = false;
            if (shouldShow) cameraActionStartButton.style.display = "inline-block";
        };
        cameraActionStartButton.addEventListener("click", function(_) {
            cameraActionStartButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).scanButtonScanningStarting();
            cameraSelectUi.disable();
            cameraActionStartButton.disabled = true;
            cameraActionStartButton.style.opacity = "0.5";
            if (_this.scanTypeSelector.hasMoreThanOneScanType()) $this.showHideScanTypeSwapLink(false);
            $this.resetHeaderMessage();
            var cameraId = cameraSelectUi.getValue();
            $this.persistedDataManager.setLastUsedCameraId(cameraId);
            $this.html5Qrcode.start(cameraId, $3479451dbf27e703$var$toHtml5QrcodeCameraScanConfig($this.config), $this.qrCodeSuccessCallback, $this.qrCodeErrorCallback).then(function(_) {
                cameraActionStopButton.disabled = false;
                cameraActionStopButton.style.display = "inline-block";
                resetCameraActionStartButton(false);
                var cameraCapabilities = $this.html5Qrcode.getRunningTrackCameraCapabilities();
                if (_this.config.showTorchButtonIfSupported === true) createAndShowTorchButtonIfSupported(cameraCapabilities);
                if (_this.config.showZoomSliderIfSupported === true) renderCameraZoomUiIfSupported(cameraCapabilities);
            }).catch(function(error) {
                $this.showHideScanTypeSwapLink(true);
                cameraSelectUi.enable();
                resetCameraActionStartButton(true);
                $this.setHeaderMessage(error, $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            });
        });
        if (cameraSelectUi.hasSingleItem()) cameraActionStartButton.click();
        cameraActionStopButton.addEventListener("click", function(_) {
            if (!$this.html5Qrcode) throw "html5Qrcode not defined";
            cameraActionStopButton.disabled = true;
            $this.html5Qrcode.stop().then(function(_) {
                if (_this.scanTypeSelector.hasMoreThanOneScanType()) $this.showHideScanTypeSwapLink(true);
                cameraSelectUi.enable();
                cameraActionStartButton.disabled = false;
                cameraActionStopButton.style.display = "none";
                cameraActionStartButton.style.display = "inline-block";
                if (torchButton) {
                    torchButton.reset();
                    torchButton.hide();
                }
                cameraZoomUi.removeOnCameraZoomValueChangeCallback();
                cameraZoomUi.hide();
                $this.insertCameraScanImageToScanRegion();
            }).catch(function(error) {
                cameraActionStopButton.disabled = false;
                $this.setHeaderMessage(error, $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            });
        });
        if ($this.persistedDataManager.getLastUsedCameraId()) {
            var cameraId = $this.persistedDataManager.getLastUsedCameraId();
            if (cameraSelectUi.hasValue(cameraId)) {
                cameraSelectUi.setValue(cameraId);
                cameraActionStartButton.click();
            } else $this.persistedDataManager.resetLastUsedCameraId();
        }
    };
    Html5QrcodeScanner.prototype.createSectionSwap = function() {
        var $this = this;
        var TEXT_IF_CAMERA_SCAN_SELECTED = (0, $ff5e69b322275082$export$b9cab5abdb16545c).textIfCameraScanSelected();
        var TEXT_IF_FILE_SCAN_SELECTED = (0, $ff5e69b322275082$export$b9cab5abdb16545c).textIfFileScanSelected();
        var section = document.getElementById(this.getDashboardSectionId());
        var switchContainer = document.createElement("div");
        switchContainer.style.textAlign = "center";
        var switchScanTypeLink = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("span", this.getDashboardSectionSwapLinkId());
        switchScanTypeLink.style.textDecoration = "underline";
        switchScanTypeLink.style.cursor = "pointer";
        switchScanTypeLink.innerText = (0, $f71efc754e4e9dc7$export$528d36479c095a59).isCameraScanType(this.currentScanType) ? TEXT_IF_CAMERA_SCAN_SELECTED : TEXT_IF_FILE_SCAN_SELECTED;
        switchScanTypeLink.addEventListener("click", function() {
            if (!$this.sectionSwapAllowed) {
                if ($this.verbose) $this.logger.logError("Section swap called when not allowed");
                return;
            }
            $this.resetHeaderMessage();
            $this.fileSelectionUi.resetValue();
            $this.sectionSwapAllowed = false;
            if ((0, $f71efc754e4e9dc7$export$528d36479c095a59).isCameraScanType($this.currentScanType)) {
                $this.clearScanRegion();
                $this.getCameraScanRegion().style.display = "none";
                $this.fileSelectionUi.show();
                switchScanTypeLink.innerText = TEXT_IF_FILE_SCAN_SELECTED;
                $this.currentScanType = (0, $c9d6d3563c261b0e$export$13ed3042ed099f6a).SCAN_TYPE_FILE;
                $this.insertFileScanImageToScanRegion();
            } else {
                $this.clearScanRegion();
                $this.getCameraScanRegion().style.display = "block";
                $this.fileSelectionUi.hide();
                switchScanTypeLink.innerText = TEXT_IF_CAMERA_SCAN_SELECTED;
                $this.currentScanType = (0, $c9d6d3563c261b0e$export$13ed3042ed099f6a).SCAN_TYPE_CAMERA;
                $this.insertCameraScanImageToScanRegion();
                $this.startCameraScanIfPermissionExistsOnSwap();
            }
            $this.sectionSwapAllowed = true;
        });
        switchContainer.appendChild(switchScanTypeLink);
        section.appendChild(switchContainer);
    };
    Html5QrcodeScanner.prototype.startCameraScanIfPermissionExistsOnSwap = function() {
        var _this = this;
        var $this = this;
        if (this.persistedDataManager.hasCameraPermissions()) {
            (0, $a7838855c7abaae7$export$693eae80963d557e).hasPermissions().then(function(hasPermissions) {
                if (hasPermissions) {
                    var permissionButton = document.getElementById($this.getCameraPermissionButtonId());
                    if (!permissionButton) {
                        _this.logger.logError("Permission button not found, fail;");
                        throw "Permission button not found";
                    }
                    permissionButton.click();
                } else $this.persistedDataManager.setHasPermission(false);
            }).catch(function(_) {
                $this.persistedDataManager.setHasPermission(false);
            });
            return;
        }
    };
    Html5QrcodeScanner.prototype.resetHeaderMessage = function() {
        var messageDiv = document.getElementById(this.getHeaderMessageContainerId());
        messageDiv.style.display = "none";
    };
    Html5QrcodeScanner.prototype.setHeaderMessage = function(messageText, scannerStatus) {
        if (!scannerStatus) scannerStatus = $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_DEFAULT;
        var messageDiv = this.getHeaderMessageDiv();
        messageDiv.innerText = messageText;
        messageDiv.style.display = "block";
        switch(scannerStatus){
            case $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_SUCCESS:
                messageDiv.style.background = "rgba(106, 175, 80, 0.26)";
                messageDiv.style.color = "#477735";
                break;
            case $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING:
                messageDiv.style.background = "rgba(203, 36, 49, 0.14)";
                messageDiv.style.color = "#cb2431";
                break;
            case $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_DEFAULT:
            default:
                messageDiv.style.background = "rgba(0, 0, 0, 0)";
                messageDiv.style.color = "rgb(17, 17, 17)";
                break;
        }
    };
    Html5QrcodeScanner.prototype.showHideScanTypeSwapLink = function(shouldDisplay) {
        if (this.scanTypeSelector.hasMoreThanOneScanType()) {
            if (shouldDisplay !== true) shouldDisplay = false;
            this.sectionSwapAllowed = shouldDisplay;
            this.getDashboardSectionSwapLink().style.display = shouldDisplay ? "inline-block" : "none";
        }
    };
    Html5QrcodeScanner.prototype.insertCameraScanImageToScanRegion = function() {
        var $this = this;
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        if (this.cameraScanImage) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild(this.cameraScanImage);
            return;
        }
        this.cameraScanImage = new Image;
        this.cameraScanImage.onload = function(_) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild($this.cameraScanImage);
        };
        this.cameraScanImage.width = 64;
        this.cameraScanImage.style.opacity = "0.8";
        this.cameraScanImage.src = (0, $701d751907918eac$export$be7b9b11efa99dbc);
        this.cameraScanImage.alt = (0, $ff5e69b322275082$export$b9cab5abdb16545c).cameraScanAltText();
    };
    Html5QrcodeScanner.prototype.insertFileScanImageToScanRegion = function() {
        var $this = this;
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        if (this.fileScanImage) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild(this.fileScanImage);
            return;
        }
        this.fileScanImage = new Image;
        this.fileScanImage.onload = function(_) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild($this.fileScanImage);
        };
        this.fileScanImage.width = 64;
        this.fileScanImage.style.opacity = "0.8";
        this.fileScanImage.src = (0, $701d751907918eac$export$c97cd35b47589f30);
        this.fileScanImage.alt = (0, $ff5e69b322275082$export$b9cab5abdb16545c).fileScanAltText();
    };
    Html5QrcodeScanner.prototype.clearScanRegion = function() {
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        qrCodeScanRegion.innerHTML = "";
    };
    Html5QrcodeScanner.prototype.getDashboardSectionId = function() {
        return "".concat(this.elementId, "__dashboard_section");
    };
    Html5QrcodeScanner.prototype.getDashboardSectionCameraScanRegionId = function() {
        return "".concat(this.elementId, "__dashboard_section_csr");
    };
    Html5QrcodeScanner.prototype.getDashboardSectionSwapLinkId = function() {
        return (0, $e012aa67914a9f32$export$5263f2f87e9ad375).SCAN_TYPE_CHANGE_ANCHOR_ID;
    };
    Html5QrcodeScanner.prototype.getScanRegionId = function() {
        return "".concat(this.elementId, "__scan_region");
    };
    Html5QrcodeScanner.prototype.getDashboardId = function() {
        return "".concat(this.elementId, "__dashboard");
    };
    Html5QrcodeScanner.prototype.getHeaderMessageContainerId = function() {
        return "".concat(this.elementId, "__header_message");
    };
    Html5QrcodeScanner.prototype.getCameraPermissionButtonId = function() {
        return (0, $e012aa67914a9f32$export$5263f2f87e9ad375).CAMERA_PERMISSION_BUTTON_ID;
    };
    Html5QrcodeScanner.prototype.getCameraScanRegion = function() {
        return document.getElementById(this.getDashboardSectionCameraScanRegionId());
    };
    Html5QrcodeScanner.prototype.getDashboardSectionSwapLink = function() {
        return document.getElementById(this.getDashboardSectionSwapLinkId());
    };
    Html5QrcodeScanner.prototype.getHeaderMessageDiv = function() {
        return document.getElementById(this.getHeaderMessageContainerId());
    };
    return Html5QrcodeScanner;
}();









var $lCzvA = parcelRequire("lCzvA");
function $8269bd5b276bbb74$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $9d3b363be4fdb0ac$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $9d3b363be4fdb0ac$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $8269bd5b276bbb74$export$2e2bcd8739ae039)(function(prop) {
    return $9d3b363be4fdb0ac$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $lCzvA = parcelRequire("lCzvA");
var $97db0618d63b43de$export$71ad59f2e432cfe8 = "-ms-";
var $97db0618d63b43de$export$2c0f367103c8d01c = "-moz-";
var $97db0618d63b43de$export$39dfd62a25e0fe93 = "-webkit-";
var $97db0618d63b43de$export$a29989082612d0d9 = "comm";
var $97db0618d63b43de$export$aa3a2e812ca8570d = "rule";
var $97db0618d63b43de$export$527d108ccf083c2b = "decl";
var $97db0618d63b43de$export$d3d35020fa5b54f0 = "@page";
var $97db0618d63b43de$export$500415a86c544f73 = "@media";
var $97db0618d63b43de$export$a763edbf796b780a = "@import";
var $97db0618d63b43de$export$2790aeb8b4e5c826 = "@charset";
var $97db0618d63b43de$export$1cc683e23b84b133 = "@viewport";
var $97db0618d63b43de$export$9447a5efea57e862 = "@supports";
var $97db0618d63b43de$export$ef011b4e114b1fba = "@document";
var $97db0618d63b43de$export$6aad947bda0f3f46 = "@namespace";
var $97db0618d63b43de$export$b44a8529a35fcb60 = "@keyframes";
var $97db0618d63b43de$export$2c16de31893252e6 = "@font-face";
var $97db0618d63b43de$export$3d846dd52e150c6f = "@counter-style";
var $97db0618d63b43de$export$22314bfbb57653fe = "@font-feature-values";
var $97db0618d63b43de$export$d773506282b3cfe6 = "@layer";
var $97db0618d63b43de$export$1c5a554c78c0cd12 = "@scope";
var $97db0618d63b43de$export$2335f513bbd82c6d = Math.abs;
var $97db0618d63b43de$export$6788812c4e6611e6 = String.fromCharCode;
var $97db0618d63b43de$export$e6e34fd1f2686227 = Object.assign;
function $97db0618d63b43de$export$d6af199866bfb566(e, r) {
    return $97db0618d63b43de$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $97db0618d63b43de$export$a9db5e087081082d(e, 0)) << 2 ^ $97db0618d63b43de$export$a9db5e087081082d(e, 1)) << 2 ^ $97db0618d63b43de$export$a9db5e087081082d(e, 2)) << 2 ^ $97db0618d63b43de$export$a9db5e087081082d(e, 3) : 0;
}
function $97db0618d63b43de$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $97db0618d63b43de$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $97db0618d63b43de$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $97db0618d63b43de$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $97db0618d63b43de$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $97db0618d63b43de$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $97db0618d63b43de$export$36776f635604f274(e) {
    return e.length;
}
function $97db0618d63b43de$export$f9084667e487ed46(e) {
    return e.length;
}
function $97db0618d63b43de$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $97db0618d63b43de$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $97db0618d63b43de$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$97db0618d63b43de$export$4659b591c19bdf3d(e, r);
    });
}
var $97db0618d63b43de$export$53f1d5ea8de3d7c = 1;
var $97db0618d63b43de$export$4e0c71f277ca26b3 = 1;
var $97db0618d63b43de$export$f24224f1c91d8156 = 0;
var $97db0618d63b43de$export$5880b8b5730aff45 = 0;
var $97db0618d63b43de$export$c0306caf338ac095 = 0;
var $97db0618d63b43de$export$30a86d91af8ff6e6 = "";
function $97db0618d63b43de$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $97db0618d63b43de$export$53f1d5ea8de3d7c,
        column: $97db0618d63b43de$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $97db0618d63b43de$export$784d13d8ee351f07(e, r) {
    return $97db0618d63b43de$export$e6e34fd1f2686227($97db0618d63b43de$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $97db0618d63b43de$export$590e8b2c435046d9(e) {
    while(e.root)e = $97db0618d63b43de$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $97db0618d63b43de$export$10d8903dec122b9d(e, e.siblings);
}
function $97db0618d63b43de$export$eba6f6f03b0a92e7() {
    return $97db0618d63b43de$export$c0306caf338ac095;
}
function $97db0618d63b43de$export$232faf9add678146() {
    $97db0618d63b43de$export$c0306caf338ac095 = $97db0618d63b43de$export$5880b8b5730aff45 > 0 ? $97db0618d63b43de$export$a9db5e087081082d($97db0618d63b43de$export$30a86d91af8ff6e6, --$97db0618d63b43de$export$5880b8b5730aff45) : 0;
    if ($97db0618d63b43de$export$4e0c71f277ca26b3--, $97db0618d63b43de$export$c0306caf338ac095 === 10) $97db0618d63b43de$export$4e0c71f277ca26b3 = 1, $97db0618d63b43de$export$53f1d5ea8de3d7c--;
    return $97db0618d63b43de$export$c0306caf338ac095;
}
function $97db0618d63b43de$export$48cfd1e771a65c4f() {
    $97db0618d63b43de$export$c0306caf338ac095 = $97db0618d63b43de$export$5880b8b5730aff45 < $97db0618d63b43de$export$f24224f1c91d8156 ? $97db0618d63b43de$export$a9db5e087081082d($97db0618d63b43de$export$30a86d91af8ff6e6, $97db0618d63b43de$export$5880b8b5730aff45++) : 0;
    if ($97db0618d63b43de$export$4e0c71f277ca26b3++, $97db0618d63b43de$export$c0306caf338ac095 === 10) $97db0618d63b43de$export$4e0c71f277ca26b3 = 1, $97db0618d63b43de$export$53f1d5ea8de3d7c++;
    return $97db0618d63b43de$export$c0306caf338ac095;
}
function $97db0618d63b43de$export$4d3fb11e950abb9e() {
    return $97db0618d63b43de$export$a9db5e087081082d($97db0618d63b43de$export$30a86d91af8ff6e6, $97db0618d63b43de$export$5880b8b5730aff45);
}
function $97db0618d63b43de$export$e88cb2efb12ae807() {
    return $97db0618d63b43de$export$5880b8b5730aff45;
}
function $97db0618d63b43de$export$58adb3bec8346d0f(e, r) {
    return $97db0618d63b43de$export$2f35ab04d2335697($97db0618d63b43de$export$30a86d91af8ff6e6, e, r);
}
function $97db0618d63b43de$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $97db0618d63b43de$export$2de70f21292aac9e(e) {
    return $97db0618d63b43de$export$53f1d5ea8de3d7c = $97db0618d63b43de$export$4e0c71f277ca26b3 = 1, $97db0618d63b43de$export$f24224f1c91d8156 = $97db0618d63b43de$export$36776f635604f274($97db0618d63b43de$export$30a86d91af8ff6e6 = e), $97db0618d63b43de$export$5880b8b5730aff45 = 0, [];
}
function $97db0618d63b43de$export$45918ac1574455b1(e) {
    return $97db0618d63b43de$export$30a86d91af8ff6e6 = "", e;
}
function $97db0618d63b43de$export$410ac95b9ec204b8(e) {
    return $97db0618d63b43de$export$87c2784dc9fc4ab($97db0618d63b43de$export$58adb3bec8346d0f($97db0618d63b43de$export$5880b8b5730aff45 - 1, $97db0618d63b43de$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $97db0618d63b43de$export$660b2ee2d4fb4eff(e) {
    return $97db0618d63b43de$export$45918ac1574455b1($97db0618d63b43de$export$5f8c09e3ae6f64e1($97db0618d63b43de$export$2de70f21292aac9e(e)));
}
function $97db0618d63b43de$export$7af1228ff777d175(e) {
    while($97db0618d63b43de$export$c0306caf338ac095 = $97db0618d63b43de$export$4d3fb11e950abb9e())if ($97db0618d63b43de$export$c0306caf338ac095 < 33) $97db0618d63b43de$export$48cfd1e771a65c4f();
    else break;
    return $97db0618d63b43de$export$9e1725a4cfeada27(e) > 2 || $97db0618d63b43de$export$9e1725a4cfeada27($97db0618d63b43de$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $97db0618d63b43de$export$5f8c09e3ae6f64e1(e) {
    while($97db0618d63b43de$export$48cfd1e771a65c4f())switch($97db0618d63b43de$export$9e1725a4cfeada27($97db0618d63b43de$export$c0306caf338ac095)){
        case 0:
            $97db0618d63b43de$export$10d8903dec122b9d($97db0618d63b43de$export$c2ab62c7bf24634($97db0618d63b43de$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $97db0618d63b43de$export$10d8903dec122b9d($97db0618d63b43de$export$410ac95b9ec204b8($97db0618d63b43de$export$c0306caf338ac095), e);
            break;
        default:
            $97db0618d63b43de$export$10d8903dec122b9d($97db0618d63b43de$export$6788812c4e6611e6($97db0618d63b43de$export$c0306caf338ac095), e);
    }
    return e;
}
function $97db0618d63b43de$export$955ba06d119e085e(e, r) {
    while(--r && $97db0618d63b43de$export$48cfd1e771a65c4f())if ($97db0618d63b43de$export$c0306caf338ac095 < 48 || $97db0618d63b43de$export$c0306caf338ac095 > 102 || $97db0618d63b43de$export$c0306caf338ac095 > 57 && $97db0618d63b43de$export$c0306caf338ac095 < 65 || $97db0618d63b43de$export$c0306caf338ac095 > 70 && $97db0618d63b43de$export$c0306caf338ac095 < 97) break;
    return $97db0618d63b43de$export$58adb3bec8346d0f(e, $97db0618d63b43de$export$e88cb2efb12ae807() + (r < 6 && $97db0618d63b43de$export$4d3fb11e950abb9e() == 32 && $97db0618d63b43de$export$48cfd1e771a65c4f() == 32));
}
function $97db0618d63b43de$export$c889f2fcc19dbf12(e) {
    while($97db0618d63b43de$export$48cfd1e771a65c4f())switch($97db0618d63b43de$export$c0306caf338ac095){
        case e:
            return $97db0618d63b43de$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $97db0618d63b43de$export$c889f2fcc19dbf12($97db0618d63b43de$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $97db0618d63b43de$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $97db0618d63b43de$export$48cfd1e771a65c4f();
            break;
    }
    return $97db0618d63b43de$export$5880b8b5730aff45;
}
function $97db0618d63b43de$export$4254d4e2b3745c4c(e, r) {
    while($97db0618d63b43de$export$48cfd1e771a65c4f())if (e + $97db0618d63b43de$export$c0306caf338ac095 === 57) break;
    else if (e + $97db0618d63b43de$export$c0306caf338ac095 === 84 && $97db0618d63b43de$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $97db0618d63b43de$export$58adb3bec8346d0f(r, $97db0618d63b43de$export$5880b8b5730aff45 - 1) + "*" + $97db0618d63b43de$export$6788812c4e6611e6(e === 47 ? e : $97db0618d63b43de$export$48cfd1e771a65c4f());
}
function $97db0618d63b43de$export$c2ab62c7bf24634(e) {
    while(!$97db0618d63b43de$export$9e1725a4cfeada27($97db0618d63b43de$export$4d3fb11e950abb9e()))$97db0618d63b43de$export$48cfd1e771a65c4f();
    return $97db0618d63b43de$export$58adb3bec8346d0f(e, $97db0618d63b43de$export$5880b8b5730aff45);
}
function $97db0618d63b43de$export$ef7acd7185315e22(e) {
    return $97db0618d63b43de$export$45918ac1574455b1($97db0618d63b43de$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $97db0618d63b43de$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $97db0618d63b43de$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = n;
    var y = s;
    var j = c;
    var z = k;
    while(w)switch(b = g, g = $97db0618d63b43de$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $97db0618d63b43de$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($97db0618d63b43de$export$f8e21b1e77979a08(z += $97db0618d63b43de$export$77ad94ebf1c2b9ed($97db0618d63b43de$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $97db0618d63b43de$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $97db0618d63b43de$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $97db0618d63b43de$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $97db0618d63b43de$export$955ba06d119e085e($97db0618d63b43de$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($97db0618d63b43de$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $97db0618d63b43de$export$10d8903dec122b9d($97db0618d63b43de$export$4a34f930e789283c($97db0618d63b43de$export$4254d4e2b3745c4c($97db0618d63b43de$export$48cfd1e771a65c4f(), $97db0618d63b43de$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($97db0618d63b43de$export$9e1725a4cfeada27(b || 1) == 5 || $97db0618d63b43de$export$9e1725a4cfeada27($97db0618d63b43de$export$4d3fb11e950abb9e() || 1) == 5) && $97db0618d63b43de$export$36776f635604f274(z) && $97db0618d63b43de$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $97db0618d63b43de$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $97db0618d63b43de$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($97db0618d63b43de$export$36776f635604f274(z) - l || h === 0 && b === 47)) $97db0618d63b43de$export$10d8903dec122b9d(v > 32 ? $97db0618d63b43de$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $97db0618d63b43de$export$f8483753829ec8f3($97db0618d63b43de$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $97db0618d63b43de$export$10d8903dec122b9d(j = $97db0618d63b43de$export$3307ffa7023ede1e(z, r, a, f, o, n, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $97db0618d63b43de$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($97db0618d63b43de$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($97db0618d63b43de$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $97db0618d63b43de$export$98e6a39c04603d36(e, j, j, c && $97db0618d63b43de$export$10d8903dec122b9d($97db0618d63b43de$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, k, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $97db0618d63b43de$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $97db0618d63b43de$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $97db0618d63b43de$export$232faf9add678146() == 125) continue;
            }
            switch(z += $97db0618d63b43de$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($97db0618d63b43de$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($97db0618d63b43de$export$4d3fb11e950abb9e() === 45) z += $97db0618d63b43de$export$410ac95b9ec204b8($97db0618d63b43de$export$48cfd1e771a65c4f());
                    p = $97db0618d63b43de$export$4d3fb11e950abb9e(), o = l = $97db0618d63b43de$export$36776f635604f274(k = z += $97db0618d63b43de$export$c2ab62c7bf24634($97db0618d63b43de$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $97db0618d63b43de$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $97db0618d63b43de$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $97db0618d63b43de$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, g = 0; w < c; ++w)for(var k = 0, m = $97db0618d63b43de$export$2f35ab04d2335697(e, v + 1, v = $97db0618d63b43de$export$2335f513bbd82c6d(d = u[w])), x = e; k < h; ++k)if (x = $97db0618d63b43de$export$87c2784dc9fc4ab(d > 0 ? b[k] + " " + m : $97db0618d63b43de$export$77ad94ebf1c2b9ed(m, /&\f/g, b[k]))) f[g++] = x;
    return $97db0618d63b43de$export$35059013cd4a06db(e, r, a, s === 0 ? $97db0618d63b43de$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $97db0618d63b43de$export$4a34f930e789283c(e, r, a, n) {
    return $97db0618d63b43de$export$35059013cd4a06db(e, r, a, $97db0618d63b43de$export$a29989082612d0d9, $97db0618d63b43de$export$6788812c4e6611e6($97db0618d63b43de$export$eba6f6f03b0a92e7()), $97db0618d63b43de$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $97db0618d63b43de$export$f8483753829ec8f3(e, r, a, c, n) {
    return $97db0618d63b43de$export$35059013cd4a06db(e, r, a, $97db0618d63b43de$export$527d108ccf083c2b, $97db0618d63b43de$export$2f35ab04d2335697(e, 0, c), $97db0618d63b43de$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $97db0618d63b43de$export$82e9f45cca5ba907(c, n, s) {
    switch($97db0618d63b43de$export$d6af199866bfb566(c, n)){
        case 5103:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $97db0618d63b43de$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$2c0f367103c8d01c + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($97db0618d63b43de$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $97db0618d63b43de$export$39dfd62a25e0fe93 + "box-$1$2" + $97db0618d63b43de$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + "flex-item-" + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$97db0618d63b43de$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $97db0618d63b43de$export$71ad59f2e432cfe8 + "grid-row-" + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + "flex-line-pack" + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + "box-" + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, "-grow", "") + $97db0618d63b43de$export$39dfd62a25e0fe93 + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $97db0618d63b43de$export$39dfd62a25e0fe93 + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $97db0618d63b43de$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $97db0618d63b43de$export$77ad94ebf1c2b9ed($97db0618d63b43de$export$77ad94ebf1c2b9ed($97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $97db0618d63b43de$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $97db0618d63b43de$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $97db0618d63b43de$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $97db0618d63b43de$export$77ad94ebf1c2b9ed($97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $97db0618d63b43de$export$39dfd62a25e0fe93 + "box-pack:$3" + $97db0618d63b43de$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $97db0618d63b43de$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$97db0618d63b43de$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $97db0618d63b43de$export$71ad59f2e432cfe8 + "grid-column-align" + $97db0618d63b43de$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $97db0618d63b43de$export$71ad59f2e432cfe8 + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $97db0618d63b43de$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$97db0618d63b43de$export$f8e21b1e77979a08(c + (s = s[n].value), "span", 0) ? c : $97db0618d63b43de$export$71ad59f2e432cfe8 + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $97db0618d63b43de$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$97db0618d63b43de$export$f8e21b1e77979a08(s, "span", 0) ? $97db0618d63b43de$export$4659b591c19bdf3d(s, /\d+/) : +$97db0618d63b43de$export$4659b591c19bdf3d(s, /\d+/) - +$97db0618d63b43de$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $97db0618d63b43de$export$71ad59f2e432cfe8 + $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $97db0618d63b43de$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $97db0618d63b43de$export$71ad59f2e432cfe8 + $97db0618d63b43de$export$77ad94ebf1c2b9ed($97db0618d63b43de$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $97db0618d63b43de$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($97db0618d63b43de$export$36776f635604f274(c) - 1 - n > 6) switch($97db0618d63b43de$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($97db0618d63b43de$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $97db0618d63b43de$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $97db0618d63b43de$export$2c0f367103c8d01c + ($97db0618d63b43de$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$97db0618d63b43de$export$f8e21b1e77979a08(c, "stretch", 0) ? $97db0618d63b43de$export$82e9f45cca5ba907($97db0618d63b43de$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $97db0618d63b43de$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $97db0618d63b43de$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($97db0618d63b43de$export$a9db5e087081082d(c, n + 6) === 121) return $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, ":", ":" + $97db0618d63b43de$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($97db0618d63b43de$export$a9db5e087081082d(c, $97db0618d63b43de$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $97db0618d63b43de$export$39dfd62a25e0fe93 + ($97db0618d63b43de$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $97db0618d63b43de$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $97db0618d63b43de$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, ":", ":" + $97db0618d63b43de$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $97db0618d63b43de$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $97db0618d63b43de$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $97db0618d63b43de$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $97db0618d63b43de$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $97db0618d63b43de$export$a763edbf796b780a:
        case $97db0618d63b43de$export$6aad947bda0f3f46:
        case $97db0618d63b43de$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $97db0618d63b43de$export$a29989082612d0d9:
            return "";
        case $97db0618d63b43de$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $97db0618d63b43de$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $97db0618d63b43de$export$aa3a2e812ca8570d:
            if (!$97db0618d63b43de$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $97db0618d63b43de$export$36776f635604f274(a = $97db0618d63b43de$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $97db0618d63b43de$export$5a7767152ae0305f(e) {
    var r = $97db0618d63b43de$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $97db0618d63b43de$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $97db0618d63b43de$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $97db0618d63b43de$export$527d108ccf083c2b:
                c.return = $97db0618d63b43de$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $97db0618d63b43de$export$b44a8529a35fcb60:
                return $97db0618d63b43de$export$dfdc1655ccc5b9cb([
                    $97db0618d63b43de$export$784d13d8ee351f07(c, {
                        value: $97db0618d63b43de$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $97db0618d63b43de$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $97db0618d63b43de$export$aa3a2e812ca8570d:
                if (c.length) return $97db0618d63b43de$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($97db0618d63b43de$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $97db0618d63b43de$export$590e8b2c435046d9($97db0618d63b43de$export$784d13d8ee351f07(c, {
                                props: [
                                    $97db0618d63b43de$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $97db0618d63b43de$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $97db0618d63b43de$export$590e8b2c435046d9($97db0618d63b43de$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $97db0618d63b43de$export$e6e34fd1f2686227(c, {
                                props: $97db0618d63b43de$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $97db0618d63b43de$export$590e8b2c435046d9($97db0618d63b43de$export$784d13d8ee351f07(c, {
                                props: [
                                    $97db0618d63b43de$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $97db0618d63b43de$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $97db0618d63b43de$export$590e8b2c435046d9($97db0618d63b43de$export$784d13d8ee351f07(c, {
                                props: [
                                    $97db0618d63b43de$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $97db0618d63b43de$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $97db0618d63b43de$export$590e8b2c435046d9($97db0618d63b43de$export$784d13d8ee351f07(c, {
                                props: [
                                    $97db0618d63b43de$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $97db0618d63b43de$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $97db0618d63b43de$export$590e8b2c435046d9($97db0618d63b43de$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $97db0618d63b43de$export$e6e34fd1f2686227(c, {
                                props: $97db0618d63b43de$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $97db0618d63b43de$export$76a88f7de6507443(e) {
    switch(e.type){
        case $97db0618d63b43de$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $97db0618d63b43de$export$1be1fc439b849fdf($97db0618d63b43de$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($97db0618d63b43de$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $97db0618d63b43de$export$2f35ab04d2335697(r, 1, $97db0618d63b43de$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $97db0618d63b43de$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $97db0618d63b43de$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $97db0618d63b43de$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $f655ac91f53a7a3c$var$r, $f655ac91f53a7a3c$var$i;
const $f655ac91f53a7a3c$var$c = "data-styled", $f655ac91f53a7a3c$var$a = "active", $f655ac91f53a7a3c$var$l = "data-styled-version", $f655ac91f53a7a3c$export$83d89fbfd8236492 = "6.4.4", $f655ac91f53a7a3c$var$h = "/*!sc*/\n", $f655ac91f53a7a3c$var$d = "undefined" != typeof window && "undefined" != typeof document;
function $f655ac91f53a7a3c$var$p(e) {}
const $f655ac91f53a7a3c$var$f = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : null !== ($f655ac91f53a7a3c$var$i = null !== ($f655ac91f53a7a3c$var$r = $f655ac91f53a7a3c$var$p("REACT_APP_SC_DISABLE_SPEEDY")) && void 0 !== $f655ac91f53a7a3c$var$r ? $f655ac91f53a7a3c$var$r : $f655ac91f53a7a3c$var$p("SC_DISABLE_SPEEDY")) && void 0 !== $f655ac91f53a7a3c$var$i ? $f655ac91f53a7a3c$var$i : false), $f655ac91f53a7a3c$var$m = "sc-keyframes-", $f655ac91f53a7a3c$var$y = {}, $f655ac91f53a7a3c$var$g = {};
function $f655ac91f53a7a3c$var$v(e, ...t) {
    return new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${e} for more information.${t.length > 0 ? ` Args: ${t.join(", ")}` : ""}`);
}
const $f655ac91f53a7a3c$var$S = 1073741824;
let $f655ac91f53a7a3c$var$b = new Map, $f655ac91f53a7a3c$var$w = new Map, $f655ac91f53a7a3c$var$N = 1;
const $f655ac91f53a7a3c$var$C = (e)=>{
    if ($f655ac91f53a7a3c$var$b.has(e)) return $f655ac91f53a7a3c$var$b.get(e);
    for(; $f655ac91f53a7a3c$var$w.has($f655ac91f53a7a3c$var$N);)$f655ac91f53a7a3c$var$N++;
    const t = $f655ac91f53a7a3c$var$N++;
    return $f655ac91f53a7a3c$var$b.set(e, t), $f655ac91f53a7a3c$var$w.set(t, e), t;
}, $f655ac91f53a7a3c$var$O = (e)=>$f655ac91f53a7a3c$var$w.get(e), $f655ac91f53a7a3c$var$E = (e, t)=>{
    $f655ac91f53a7a3c$var$N = t + 1, $f655ac91f53a7a3c$var$b.set(e, t), $f655ac91f53a7a3c$var$w.set(t, e);
}, $f655ac91f53a7a3c$var$A = /invalid hook call/i, $f655ac91f53a7a3c$var$P = new Set, $f655ac91f53a7a3c$var$_ = (e, n)=>{
    var t, n1, e1;
}, $f655ac91f53a7a3c$var$I = Object.freeze([]), $f655ac91f53a7a3c$var$$ = Object.freeze({});
function $f655ac91f53a7a3c$var$R(e, t, n = $f655ac91f53a7a3c$var$$) {
    return e.theme !== n.theme && e.theme || t || n.theme;
}
const $f655ac91f53a7a3c$var$j = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f655ac91f53a7a3c$var$x = /(^-|-$)/g;
function $f655ac91f53a7a3c$var$T(e) {
    return e.replace($f655ac91f53a7a3c$var$j, "-").replace($f655ac91f53a7a3c$var$x, "");
}
const $f655ac91f53a7a3c$var$k = /(a)(d)/gi, $f655ac91f53a7a3c$var$D = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97));
function $f655ac91f53a7a3c$var$V(e) {
    let t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f655ac91f53a7a3c$var$D(t % 52) + n;
    return ($f655ac91f53a7a3c$var$D(t % 52) + n).replace($f655ac91f53a7a3c$var$k, "$1-$2");
}
const $f655ac91f53a7a3c$var$M = 5381, $f655ac91f53a7a3c$var$G = (e, t)=>{
    let n = t.length;
    for(; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f655ac91f53a7a3c$var$F = (e)=>$f655ac91f53a7a3c$var$G($f655ac91f53a7a3c$var$M, e);
function $f655ac91f53a7a3c$var$z(e) {
    return $f655ac91f53a7a3c$var$V($f655ac91f53a7a3c$var$F(e) >>> 0);
}
function $f655ac91f53a7a3c$var$W(e) {
    return e.displayName || e.name || "Component";
}
function $f655ac91f53a7a3c$var$L(e) {
    return "string" == typeof e && true;
}
function $f655ac91f53a7a3c$var$B(e) {
    return $f655ac91f53a7a3c$var$L(e) ? `styled.${e}` : `Styled(${$f655ac91f53a7a3c$var$W(e)})`;
}
const $f655ac91f53a7a3c$var$q = Symbol.for("react.memo"), $f655ac91f53a7a3c$var$H = Symbol.for("react.forward_ref"), $f655ac91f53a7a3c$var$Y = {
    contextType: !0,
    defaultProps: !0,
    displayName: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    propTypes: !0,
    type: !0
}, $f655ac91f53a7a3c$var$U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f655ac91f53a7a3c$var$J = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f655ac91f53a7a3c$var$X = {
    [$f655ac91f53a7a3c$var$H]: {
        $$typeof: !0,
        render: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0
    },
    [$f655ac91f53a7a3c$var$q]: $f655ac91f53a7a3c$var$J
};
function $f655ac91f53a7a3c$var$K(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f655ac91f53a7a3c$var$q ? $f655ac91f53a7a3c$var$J : "$$typeof" in e ? $f655ac91f53a7a3c$var$X[e.$$typeof] : $f655ac91f53a7a3c$var$Y;
}
const $f655ac91f53a7a3c$var$Q = Object.defineProperty, $f655ac91f53a7a3c$var$Z = Object.getOwnPropertyNames, $f655ac91f53a7a3c$var$ee = Object.getOwnPropertySymbols, $f655ac91f53a7a3c$var$te = Object.getOwnPropertyDescriptor, $f655ac91f53a7a3c$var$ne = Object.getPrototypeOf, $f655ac91f53a7a3c$var$oe = Object.prototype;
function $f655ac91f53a7a3c$var$se(e, t, n) {
    if ("string" != typeof t) {
        const o = $f655ac91f53a7a3c$var$ne(t);
        o && o !== $f655ac91f53a7a3c$var$oe && $f655ac91f53a7a3c$var$se(e, o, n);
        const s = $f655ac91f53a7a3c$var$Z(t).concat($f655ac91f53a7a3c$var$ee(t)), r = $f655ac91f53a7a3c$var$K(e), i = $f655ac91f53a7a3c$var$K(t);
        for(let o = 0; o < s.length; ++o){
            const c = s[o];
            if (!(c in $f655ac91f53a7a3c$var$U || n && n[c] || i && c in i || r && c in r)) {
                const n = $f655ac91f53a7a3c$var$te(t, c);
                try {
                    $f655ac91f53a7a3c$var$Q(e, c, n);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f655ac91f53a7a3c$var$re(e) {
    return "function" == typeof e;
}
const $f655ac91f53a7a3c$var$ie = Symbol.for("react.forward_ref");
function $f655ac91f53a7a3c$export$7ba318d8d2f06c76(e) {
    return null != e && ("object" == typeof e || "function" == typeof e) && e.$$typeof === $f655ac91f53a7a3c$var$ie && "styledComponentId" in e;
}
function $f655ac91f53a7a3c$var$ae(e, t) {
    return e && t ? e + " " + t : e || t || "";
}
function $f655ac91f53a7a3c$var$le(e, t) {
    return e.join(t || "");
}
function $f655ac91f53a7a3c$var$ue(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f655ac91f53a7a3c$var$he(e, t, n = !1) {
    if (!n && !$f655ac91f53a7a3c$var$ue(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(let n = 0; n < t.length; n++)e[n] = $f655ac91f53a7a3c$var$he(e[n], t[n]);
    else if ($f655ac91f53a7a3c$var$ue(t)) for(const n in t)e[n] = $f655ac91f53a7a3c$var$he(e[n], t[n]);
    return e;
}
function $f655ac91f53a7a3c$var$de(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
const $f655ac91f53a7a3c$var$pe = class {
    constructor(e){
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e, this._cGroup = 0, this._cIndex = 0;
    }
    indexOfGroup(e) {
        if (e === this._cGroup) return this._cIndex;
        let t = this._cIndex;
        if (e > this._cGroup) for(let n = this._cGroup; n < e; n++)t += this.groupSizes[n];
        else for(let n = this._cGroup - 1; n >= e; n--)t -= this.groupSizes[n];
        return this._cGroup = e, this._cIndex = t, t;
    }
    insertRules(e, t) {
        if (e >= this.groupSizes.length) {
            const t = this.groupSizes, n = t.length;
            let o = n;
            for(; e >= o;)if (o <<= 1, o < 0) throw $f655ac91f53a7a3c$var$v(16, `${e}`);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(t), this.length = o;
            for(let e = n; e < o; e++)this.groupSizes[e] = 0;
        }
        let n = this.indexOfGroup(e + 1), o = 0;
        for(let s = 0, r = t.length; s < r; s++)this.tag.insertRule(n, t[s]) && (this.groupSizes[e]++, n++, o++);
        o > 0 && this._cGroup > e && (this._cIndex += o);
    }
    clearGroup(e) {
        if (e < this.length) {
            const t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(let e = n; e < o; e++)this.tag.deleteRule(n);
            t > 0 && this._cGroup > e && (this._cIndex -= t);
        }
    }
    getGroup(e) {
        let t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        const n = this.groupSizes[e], o = this.indexOfGroup(e), s = o + n;
        for(let e = o; e < s; e++)t += this.tag.getRule(e) + $f655ac91f53a7a3c$var$h;
        return t;
    }
}, $f655ac91f53a7a3c$var$fe = `style[${$f655ac91f53a7a3c$var$c}][${$f655ac91f53a7a3c$var$l}="${$f655ac91f53a7a3c$export$83d89fbfd8236492}"]`, $f655ac91f53a7a3c$var$me = new RegExp(`^${$f655ac91f53a7a3c$var$c}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), $f655ac91f53a7a3c$var$ye = (e)=>"undefined" != typeof ShadowRoot && e instanceof ShadowRoot || "host" in e && 11 === e.nodeType, $f655ac91f53a7a3c$var$ge = (e)=>{
    if (!e) return document;
    if ($f655ac91f53a7a3c$var$ye(e)) return e;
    if ("getRootNode" in e) {
        const t = e.getRootNode();
        if ($f655ac91f53a7a3c$var$ye(t)) return t;
    }
    return document;
}, $f655ac91f53a7a3c$var$ve = (e, t, n)=>{
    const o = n.split(",");
    let s;
    for(let n = 0, r = o.length; n < r; n++)(s = o[n]) && e.registerName(t, s);
}, $f655ac91f53a7a3c$var$Se = (e, t)=>{
    var n;
    const o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($f655ac91f53a7a3c$var$h), s = [];
    for(let t = 0, n = o.length; t < n; t++){
        const n = o[t].trim();
        if (!n) continue;
        const r = n.match($f655ac91f53a7a3c$var$me);
        if (r) {
            const t = 0 | parseInt(r[1], 10), n = r[2];
            0 !== t && ($f655ac91f53a7a3c$var$E(n, t), $f655ac91f53a7a3c$var$ve(e, n, r[3]), e.getTag().insertRules(t, s)), s.length = 0;
        } else s.push(n);
    }
}, $f655ac91f53a7a3c$var$be = (e)=>{
    const t = $f655ac91f53a7a3c$var$ge(e.options.target).querySelectorAll($f655ac91f53a7a3c$var$fe);
    for(let n = 0, o = t.length; n < o; n++){
        const o = t[n];
        o && o.getAttribute($f655ac91f53a7a3c$var$c) !== $f655ac91f53a7a3c$var$a && ($f655ac91f53a7a3c$var$Se(e, o), o.parentNode && o.parentNode.removeChild(o));
    }
};
let $f655ac91f53a7a3c$var$we = !1;
function $f655ac91f53a7a3c$var$Ne() {
    if (!1 !== $f655ac91f53a7a3c$var$we) return $f655ac91f53a7a3c$var$we;
    if ("undefined" != typeof document) {
        const e = document.head.querySelector('meta[property="csp-nonce"]');
        if (e) return $f655ac91f53a7a3c$var$we = e.nonce || e.getAttribute("content") || void 0;
        const t = document.head.querySelector('meta[name="sc-nonce"]');
        if (t) return $f655ac91f53a7a3c$var$we = t.getAttribute("content") || void 0;
    }
    return $f655ac91f53a7a3c$var$we = "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0;
}
const $f655ac91f53a7a3c$var$Ce = (e, t)=>{
    const n = document.head, o = e || n, s = document.createElement("style"), r = ((e)=>{
        const t = Array.from(e.querySelectorAll(`style[${$f655ac91f53a7a3c$var$c}]`));
        return t[t.length - 1];
    })(o), i = void 0 !== r ? r.nextSibling : null;
    s.setAttribute($f655ac91f53a7a3c$var$c, $f655ac91f53a7a3c$var$a), s.setAttribute($f655ac91f53a7a3c$var$l, $f655ac91f53a7a3c$export$83d89fbfd8236492);
    const h = t || $f655ac91f53a7a3c$var$Ne();
    return h && s.setAttribute("nonce", h), o.insertBefore(s, i), s;
}, $f655ac91f53a7a3c$var$Oe = class {
    constructor(e, t){
        this.element = $f655ac91f53a7a3c$var$Ce(e, t), this.element.appendChild(document.createTextNode("")), this.sheet = ((e)=>{
            var t;
            if (e.sheet) return e.sheet;
            const n = null !== (t = e.getRootNode().styleSheets) && void 0 !== t ? t : document.styleSheets;
            for(let t = 0, o = n.length; t < o; t++){
                const o = n[t];
                if (o.ownerNode === e) return o;
            }
            throw $f655ac91f53a7a3c$var$v(17);
        })(this.element), this.length = 0;
    }
    insertRule(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }
    deleteRule(e) {
        this.sheet.deleteRule(e), this.length--;
    }
    getRule(e) {
        const t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }
}, $f655ac91f53a7a3c$var$Ee = class {
    constructor(e, t){
        this.element = $f655ac91f53a7a3c$var$Ce(e, t), this.nodes = this.element.childNodes, this.length = 0;
    }
    insertRule(e, t) {
        if (e <= this.length && e >= 0) {
            const n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }
    deleteRule(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }
    getRule(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }
};
let $f655ac91f53a7a3c$var$Ae = $f655ac91f53a7a3c$var$d;
const $f655ac91f53a7a3c$var$Pe = {
    isServer: !$f655ac91f53a7a3c$var$d,
    useCSSOMInjection: !$f655ac91f53a7a3c$var$f
};
class $f655ac91f53a7a3c$var$_e {
    static registerId(e) {
        return $f655ac91f53a7a3c$var$C(e);
    }
    constructor(e = $f655ac91f53a7a3c$var$$, t = {}, n){
        this.options = Object.assign(Object.assign({}, $f655ac91f53a7a3c$var$Pe), e), this.gs = t, this.keyframeIds = new Set, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f655ac91f53a7a3c$var$d && $f655ac91f53a7a3c$var$Ae && ($f655ac91f53a7a3c$var$Ae = !1, $f655ac91f53a7a3c$var$be(this)), $f655ac91f53a7a3c$var$de(this, ()=>((e)=>{
                const t = e.getTag(), { length: n } = t;
                let o = "";
                for(let s = 0; s < n; s++){
                    const n = $f655ac91f53a7a3c$var$O(s);
                    if (void 0 === n) continue;
                    const r = e.names.get(n);
                    if (void 0 === r || !r.size) continue;
                    const i = t.getGroup(s);
                    if (0 === i.length) continue;
                    const a = $f655ac91f53a7a3c$var$c + ".g" + s + '[id="' + n + '"]';
                    let l = "";
                    for (const e of r)e.length > 0 && (l += e + ",");
                    o += i + a + '{content:"' + l + '"}' + $f655ac91f53a7a3c$var$h;
                }
                return o;
            })(this));
    }
    rehydrate() {
        !this.server && $f655ac91f53a7a3c$var$d && $f655ac91f53a7a3c$var$be(this);
    }
    reconstructWithOptions(e, t = !0) {
        const n = new $f655ac91f53a7a3c$var$_e(Object.assign(Object.assign({}, this.options), e), this.gs, t && this.names || void 0);
        return n.keyframeIds = new Set(this.keyframeIds), !this.server && $f655ac91f53a7a3c$var$d && e.target !== this.options.target && $f655ac91f53a7a3c$var$ge(this.options.target) !== $f655ac91f53a7a3c$var$ge(e.target) && $f655ac91f53a7a3c$var$be(n), n;
    }
    allocateGSInstance(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }
    getTag() {
        var e;
        return this.tag || (this.tag = (e = (({ useCSSOMInjection: e, target: t, nonce: n })=>e ? new $f655ac91f53a7a3c$var$Oe(t, n) : new $f655ac91f53a7a3c$var$Ee(t, n))(this.options), new $f655ac91f53a7a3c$var$pe(e)));
    }
    hasNameForId(e, t) {
        var n, o;
        return null !== (o = null === (n = this.names.get(e)) || void 0 === n ? void 0 : n.has(t)) && void 0 !== o && o;
    }
    registerName(e, t) {
        $f655ac91f53a7a3c$var$C(e), e.startsWith($f655ac91f53a7a3c$var$m) && this.keyframeIds.add(e);
        const n = this.names.get(e);
        n ? n.add(t) : this.names.set(e, new Set([
            t
        ]));
    }
    insertRules(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f655ac91f53a7a3c$var$C(e), n);
    }
    clearNames(e) {
        this.names.has(e) && this.names.get(e).clear();
    }
    clearRules(e) {
        this.getTag().clearGroup($f655ac91f53a7a3c$var$C(e)), this.clearNames(e);
    }
    clearTag() {
        this.tag = void 0;
    }
}
const $f655ac91f53a7a3c$var$Ie = new WeakSet, $f655ac91f53a7a3c$var$$e = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexShrink: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
function $f655ac91f53a7a3c$var$Re(e, t) {
    return null == t || "boolean" == typeof t || "" === t ? "" : "number" != typeof t || 0 === t || e in $f655ac91f53a7a3c$var$$e || e.startsWith("--") ? String(t).trim() : t + "px";
}
const $f655ac91f53a7a3c$var$je = 47;
function $f655ac91f53a7a3c$var$xe(e) {
    if (45 === e.charCodeAt(0) && 45 === e.charCodeAt(1)) return e;
    let t = "";
    for(let n = 0; n < e.length; n++){
        const o = e.charCodeAt(n);
        t += o >= 65 && o <= 90 ? "-" + String.fromCharCode(o + 32) : e[n];
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
const $f655ac91f53a7a3c$var$Te = Symbol.for("sc-keyframes");
function $f655ac91f53a7a3c$var$ke(e) {
    return "object" == typeof e && null !== e && $f655ac91f53a7a3c$var$Te in e;
}
function $f655ac91f53a7a3c$var$De(e) {
    return $f655ac91f53a7a3c$var$re(e) && !(e.prototype && e.prototype.isReactComponent);
}
const $f655ac91f53a7a3c$var$Ve = (e)=>null == e || !1 === e || "" === e, $f655ac91f53a7a3c$var$Me = Symbol.for("react.client.reference");
function $f655ac91f53a7a3c$var$Ge(e) {
    return e.$$typeof === $f655ac91f53a7a3c$var$Me;
}
function $f655ac91f53a7a3c$var$Fe(e) {
    const t = e.$$id, n = (t && t.includes("#") ? t.split("#").pop() : t) || e.name || "unknown";
    console.warn(`Interpolating a client component (${n}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function $f655ac91f53a7a3c$var$ze(e, t) {
    for(const n in e){
        const o = e[n];
        e.hasOwnProperty(n) && !$f655ac91f53a7a3c$var$Ve(o) && (Array.isArray(o) && $f655ac91f53a7a3c$var$Ie.has(o) || $f655ac91f53a7a3c$var$re(o) ? t.push($f655ac91f53a7a3c$var$xe(n) + ":", o, ";") : $f655ac91f53a7a3c$var$ue(o) ? (t.push(n + " {"), $f655ac91f53a7a3c$var$ze(o, t), t.push("}")) : t.push($f655ac91f53a7a3c$var$xe(n) + ": " + $f655ac91f53a7a3c$var$Re(n, o) + ";"));
    }
}
function $f655ac91f53a7a3c$var$We(e, t, n, o, s = []) {
    if ($f655ac91f53a7a3c$var$Ve(e)) return s;
    const r = typeof e;
    if ("string" === r) return s.push(e), s;
    if ("function" === r) {
        if ($f655ac91f53a7a3c$var$Ge(e)) return s;
        if ($f655ac91f53a7a3c$var$De(e) && t) {
            const r = e(t);
            return $f655ac91f53a7a3c$var$We(r, t, n, o, s);
        }
        return s.push(e), s;
    }
    if (Array.isArray(e)) {
        for(let r = 0; r < e.length; r++)$f655ac91f53a7a3c$var$We(e[r], t, n, o, s);
        return s;
    }
    return $f655ac91f53a7a3c$export$7ba318d8d2f06c76(e) ? (s.push(`.${e.styledComponentId}`), s) : $f655ac91f53a7a3c$var$ke(e) ? (n ? (e.inject(n, o), s.push(e.getName(o))) : s.push(e), s) : $f655ac91f53a7a3c$var$Ge(e) ? s : $f655ac91f53a7a3c$var$ue(e) ? e.toString !== Object.prototype.toString ? (s.push(e.toString()), s) : ($f655ac91f53a7a3c$var$ze(e, s), s) : (s.push(e.toString()), s);
}
const $f655ac91f53a7a3c$var$Le = $f655ac91f53a7a3c$var$F($f655ac91f53a7a3c$export$83d89fbfd8236492);
class $f655ac91f53a7a3c$var$Be {
    constructor(e, t, n){
        this.rules = e, this.componentId = t, this.baseHash = $f655ac91f53a7a3c$var$G($f655ac91f53a7a3c$var$Le, t), this.baseStyle = n, $f655ac91f53a7a3c$var$_e.registerId(t);
    }
    generateAndInjectStyles(e, t, n) {
        let o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        {
            let s = "";
            for(let o = 0; o < this.rules.length; o++){
                const r = this.rules[o];
                if ("string" == typeof r) s += r;
                else if (r) {
                    if ($f655ac91f53a7a3c$var$De(r)) {
                        const o = r(e);
                        "string" == typeof o ? s += o : null != o && !1 !== o && (s += $f655ac91f53a7a3c$var$le($f655ac91f53a7a3c$var$We(o, e, t, n)));
                    } else s += $f655ac91f53a7a3c$var$le($f655ac91f53a7a3c$var$We(r, e, t, n));
                }
            }
            if (s) {
                this.dynamicNameCache || (this.dynamicNameCache = new Map);
                const e = n.hash ? n.hash + s : s;
                let r = this.dynamicNameCache.get(e);
                if (!r) {
                    if (r = $f655ac91f53a7a3c$var$V($f655ac91f53a7a3c$var$G($f655ac91f53a7a3c$var$G(this.baseHash, n.hash), s) >>> 0), this.dynamicNameCache.size >= 200) {
                        const e = this.dynamicNameCache.keys().next().value;
                        void 0 !== e && this.dynamicNameCache.delete(e);
                    }
                    this.dynamicNameCache.set(e, r);
                }
                if (!t.hasNameForId(this.componentId, r)) {
                    const e = n(s, "." + r, void 0, this.componentId);
                    t.insertRules(this.componentId, r, e);
                }
                o = $f655ac91f53a7a3c$var$ae(o, r);
            }
        }
        return o;
    }
}
const $f655ac91f53a7a3c$var$qe = /&/g;
function $f655ac91f53a7a3c$var$He(e, t) {
    let n = 0;
    for(; --t >= 0 && 92 === e.charCodeAt(t);)n++;
    return !(1 & ~n);
}
function $f655ac91f53a7a3c$var$Ye(e) {
    const t = e.length;
    let n = "", o = 0, s = 0, r = 0, i = !1, c = !1;
    for(let a = 0; a < t; a++){
        const l = e.charCodeAt(a);
        if (0 !== r || i || l !== $f655ac91f53a7a3c$var$je || 42 !== e.charCodeAt(a + 1)) {
            if (i) 42 === l && e.charCodeAt(a + 1) === $f655ac91f53a7a3c$var$je && (i = !1, a++);
            else if (34 !== l && 39 !== l || $f655ac91f53a7a3c$var$He(e, a)) {
                if (0 === r) {
                    if (123 === l) s++;
                    else if (125 === l) {
                        if (s--, s < 0) {
                            c = !0;
                            let n = a + 1;
                            for(; n < t;){
                                const t = e.charCodeAt(n);
                                if (59 === t || 10 === t) break;
                                n++;
                            }
                            n < t && 59 === e.charCodeAt(n) && n++, s = 0, a = n - 1, o = n;
                            continue;
                        }
                        0 === s && (n += e.substring(o, a + 1), o = a + 1);
                    } else 59 === l && 0 === s && (n += e.substring(o, a + 1), o = a + 1);
                }
            } else 0 === r ? r = l : r === l && (r = 0);
        } else i = !0, a++;
    }
    return c || 0 !== s || 0 !== r ? (o < t && 0 === s && 0 === r && (n += e.substring(o)), n) : e;
}
function $f655ac91f53a7a3c$var$Ue(e, t) {
    const n = t + " ", o = "," + n;
    for(let s = 0; s < e.length; s++){
        const r = e[s];
        if ("rule" === r.type) {
            r.value = (n + r.value).replaceAll(",", o);
            const e = r.props, t = [];
            for(let o = 0; o < e.length; o++)t[o] = n + e[o];
            r.props = t;
        }
        Array.isArray(r.children) && "@keyframes" !== r.type && $f655ac91f53a7a3c$var$Ue(r.children, t);
    }
    return e;
}
function $f655ac91f53a7a3c$var$Je({ options: e = $f655ac91f53a7a3c$var$$, plugins: t = $f655ac91f53a7a3c$var$I } = $f655ac91f53a7a3c$var$$) {
    let n, s, r;
    const i = (e, t, o)=>o.startsWith(s) && o.endsWith(s) && o.replaceAll(s, "").length > 0 ? `.${n}` : e, c = t.slice();
    c.push((e)=>{
        e.type === $97db0618d63b43de$export$aa3a2e812ca8570d && e.value.includes("&") && (r || (r = new RegExp(`\\${s}\\b`, "g")), e.props[0] = e.props[0].replace($f655ac91f53a7a3c$var$qe, s).replace(r, i));
    }), e.prefix && c.push($97db0618d63b43de$export$e08c7d021b829b7a), c.push($97db0618d63b43de$export$fac44ee5b035f737);
    let a = [];
    const l = $97db0618d63b43de$export$5a7767152ae0305f(c.concat($97db0618d63b43de$export$38bcb760f1d4871c((e)=>a.push(e)))), u = (t, i = "", c = "", u = "&")=>{
        n = u, s = i, r = void 0;
        const h = function(e) {
            const t = -1 !== e.indexOf("//"), n = -1 !== e.indexOf("}");
            if (!t && !n) return e;
            if (!t) return $f655ac91f53a7a3c$var$Ye(e);
            const o = e.length;
            let s = "", r = 0, i = 0, c = 0, a = 0, l = 0, u = !1;
            for(; i < o;){
                const t = e.charCodeAt(i);
                if (34 !== t && 39 !== t || $f655ac91f53a7a3c$var$He(e, i)) {
                    if (0 === c) {
                        if (t === $f655ac91f53a7a3c$var$je && i + 1 < o && 42 === e.charCodeAt(i + 1)) {
                            for(i += 2; i + 1 < o && (42 !== e.charCodeAt(i) || e.charCodeAt(i + 1) !== $f655ac91f53a7a3c$var$je);)i++;
                            i += 2;
                        } else if (40 !== t) {
                            if (41 !== t) {
                                if (a > 0) i++;
                                else if (42 === t && i + 1 < o && e.charCodeAt(i + 1) === $f655ac91f53a7a3c$var$je) s += e.substring(r, i), i += 2, r = i, u = !0;
                                else if (t === $f655ac91f53a7a3c$var$je && i + 1 < o && e.charCodeAt(i + 1) === $f655ac91f53a7a3c$var$je) {
                                    for(s += e.substring(r, i); i < o && 10 !== e.charCodeAt(i);)i++;
                                    r = i, u = !0;
                                } else 123 === t ? l++ : 125 === t && l--, i++;
                            } else a > 0 && a--, i++;
                        } else a++, i++;
                    } else i++;
                } else 0 === c ? c = t : c === t && (c = 0), i++;
            }
            return u ? (r < o && (s += e.substring(r)), 0 === l ? s : $f655ac91f53a7a3c$var$Ye(s)) : 0 === l ? e : $f655ac91f53a7a3c$var$Ye(e);
        }(t);
        let d = $97db0618d63b43de$export$ef7acd7185315e22(c || i ? c + " " + i + " { " + h + " }" : h);
        return e.namespace && (d = $f655ac91f53a7a3c$var$Ue(d, e.namespace)), a = [], $97db0618d63b43de$export$dfdc1655ccc5b9cb(d, l), a;
    }, h = e;
    let d = $f655ac91f53a7a3c$var$M;
    for(let e = 0; e < t.length; e++)t[e].name || $f655ac91f53a7a3c$var$v(15), d = $f655ac91f53a7a3c$var$G(d, t[e].name);
    return (null == h ? void 0 : h.namespace) && (d = $f655ac91f53a7a3c$var$G(d, h.namespace)), (null == h ? void 0 : h.prefix) && (d = $f655ac91f53a7a3c$var$G(d, "p")), u.hash = d !== $f655ac91f53a7a3c$var$M ? d.toString() : "", u;
}
const $f655ac91f53a7a3c$var$Xe = new $f655ac91f53a7a3c$var$_e, $f655ac91f53a7a3c$var$Ke = $f655ac91f53a7a3c$var$Je(), $f655ac91f53a7a3c$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f655ac91f53a7a3c$var$Xe,
    stylis: $f655ac91f53a7a3c$var$Ke,
    stylisPlugins: void 0
}), $f655ac91f53a7a3c$export$91317688fc694efa = $f655ac91f53a7a3c$export$8c190ef828af4c86.Consumer;
function $f655ac91f53a7a3c$var$et() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$8c190ef828af4c86);
}
function $f655ac91f53a7a3c$export$a473771da2f0ff7c(e) {
    var n;
    const o = $f655ac91f53a7a3c$var$et(), { styleSheet: s } = o, r = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>{
        let t = s;
        return e.sheet ? t = e.sheet : e.target ? t = t.reconstructWithOptions(void 0 !== e.nonce ? {
            target: e.target,
            nonce: e.nonce
        } : {
            target: e.target
        }, !1) : void 0 !== e.nonce && (t = t.reconstructWithOptions({
            nonce: e.nonce
        })), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.nonce,
        e.sheet,
        e.target,
        s
    ]), i = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>{
        var t;
        return void 0 === e.stylisPlugins && void 0 === e.namespace && void 0 === e.enableVendorPrefixes ? o.stylis : $f655ac91f53a7a3c$var$Je({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: null !== (t = e.stylisPlugins) && void 0 !== t ? t : o.stylisPlugins
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        e.stylisPlugins,
        o.stylis,
        o.stylisPlugins
    ]), c = "shouldForwardProp" in e ? e.shouldForwardProp : o.shouldForwardProp, a = null !== (n = e.stylisPlugins) && void 0 !== n ? n : o.stylisPlugins, l = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>({
            shouldForwardProp: c,
            styleSheet: r,
            stylis: i,
            stylisPlugins: a
        }), [
        c,
        r,
        i,
        a
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($f655ac91f53a7a3c$export$8c190ef828af4c86.Provider, {
        value: l
    }, e.children);
}
const $f655ac91f53a7a3c$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createContext(void 0), $f655ac91f53a7a3c$export$b631efc24e9d5e2f = $f655ac91f53a7a3c$export$2c657da244d00bd6.Consumer;
function $f655ac91f53a7a3c$export$93d4e7f90805808f() {
    const e = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$2c657da244d00bd6);
    if (!e) throw $f655ac91f53a7a3c$var$v(18);
    return e;
}
function $f655ac91f53a7a3c$export$d8964aec282183a3(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$2c657da244d00bd6), o = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>(function(e, t) {
            if (!e) throw $f655ac91f53a7a3c$var$v(14);
            if ($f655ac91f53a7a3c$var$re(e)) {
                const n = e(t);
                return n;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f655ac91f53a7a3c$var$v(8);
            return t ? Object.assign(Object.assign({}, t), e) : e;
        })(e.theme, n), [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($f655ac91f53a7a3c$export$2c657da244d00bd6.Provider, {
        value: o
    }, e.children) : null;
}
const $f655ac91f53a7a3c$var$it = Object.prototype.hasOwnProperty, $f655ac91f53a7a3c$var$ct = {};
function $f655ac91f53a7a3c$var$at(e, t) {
    const n = "string" != typeof e ? "sc" : $f655ac91f53a7a3c$var$T(e);
    $f655ac91f53a7a3c$var$ct[n] = ($f655ac91f53a7a3c$var$ct[n] || 0) + 1;
    const o = n + "-" + $f655ac91f53a7a3c$var$z($f655ac91f53a7a3c$export$83d89fbfd8236492 + n + $f655ac91f53a7a3c$var$ct[n]);
    return t ? t + "-" + o : o;
}
let $f655ac91f53a7a3c$var$lt;
function $f655ac91f53a7a3c$var$ut(o, s, r) {
    const i = $f655ac91f53a7a3c$export$7ba318d8d2f06c76(o), c = o, a = !$f655ac91f53a7a3c$var$L(o), { attrs: l = $f655ac91f53a7a3c$var$I, componentId: u = $f655ac91f53a7a3c$var$at(s.displayName, s.parentComponentId), displayName: h = $f655ac91f53a7a3c$var$B(o) } = s, d = s.displayName && s.componentId ? $f655ac91f53a7a3c$var$T(s.displayName) + "-" + s.componentId : s.componentId || u, p = i && c.attrs ? c.attrs.concat(l).filter(Boolean) : l;
    let { shouldForwardProp: f } = s;
    if (i && c.shouldForwardProp) {
        const e = c.shouldForwardProp;
        if (s.shouldForwardProp) {
            const t = s.shouldForwardProp;
            f = (n, o)=>e(n, o) && t(n, o);
        } else f = e;
    }
    const m = new $f655ac91f53a7a3c$var$Be(r, d, i ? c.componentStyle : void 0);
    function y(o, s) {
        return function(o, s, r) {
            const { attrs: i, componentStyle: c, defaultProps: a, foldedComponentIds: l, styledComponentId: u, target: h } = o, d = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$2c657da244d00bd6), p = $f655ac91f53a7a3c$var$et(), f = o.shouldForwardProp || p.shouldForwardProp;
            const m = $f655ac91f53a7a3c$var$R(s, d, a) || $f655ac91f53a7a3c$var$$;
            let y, g;
            {
                const e = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null), n = e.current;
                if (null !== n && n[1] === m && n[2] === p.styleSheet && n[3] === p.stylis && n[7] === c && function(e, t, n) {
                    const o = e, s = t;
                    let r = 0;
                    for(const e in s)if ($f655ac91f53a7a3c$var$it.call(s, e) && (r++, o[e] !== s[e])) return !1;
                    return r === n;
                }(n[0], s, n[4])) y = n[5], g = n[6];
                else {
                    y = function(e, t, n) {
                        const o = Object.assign(Object.assign({}, t), {
                            className: void 0,
                            theme: n
                        }), s = e.length > 1;
                        for(let n = 0; n < e.length; n++){
                            const r = e[n], i = $f655ac91f53a7a3c$var$re(r) ? r(s ? Object.assign({}, o) : o) : r;
                            for(const e in i)"className" === e ? o.className = $f655ac91f53a7a3c$var$ae(o.className, i[e]) : "style" === e ? o.style = Object.assign(Object.assign({}, o.style), i[e]) : e in t && void 0 === t[e] || (o[e] = i[e]);
                        }
                        return "className" in t && "string" == typeof t.className && (o.className = $f655ac91f53a7a3c$var$ae(o.className, t.className)), o;
                    }(i, s, m), g = function(e, n, o, s) {
                        const r = e.generateAndInjectStyles(n, o, s);
                        return r;
                    }(c, y, p.styleSheet, p.stylis);
                    let n = 0;
                    for(const e in s)$f655ac91f53a7a3c$var$it.call(s, e) && n++;
                    e.current = [
                        s,
                        m,
                        p.styleSheet,
                        p.stylis,
                        n,
                        y,
                        g,
                        c
                    ];
                }
            }
            const v = y.as || h, S = function(t, n, o, s) {
                const r = {};
                for(const i in t)void 0 === t[i] || "$" === i[0] || "as" === i || "theme" === i && t.theme === o || ("forwardedAs" === i ? r.as = t.forwardedAs : s && !s(i, n) || (r[i] = t[i], s));
                return r;
            }(y, v, m, f);
            let b = $f655ac91f53a7a3c$var$ae(l, u);
            return g && (b += " " + g), y.className && (b += " " + y.className), S[$f655ac91f53a7a3c$var$L(v) && v.includes("-") ? "class" : "className"] = b, r && (S.ref = r), (0, $lCzvA.createElement)(v, S);
        }(g, o, s);
    }
    y.displayName = h;
    let g = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).forwardRef(y);
    return g.attrs = p, g.componentStyle = m, g.displayName = h, g.shouldForwardProp = f, g.foldedComponentIds = i ? $f655ac91f53a7a3c$var$ae(c.foldedComponentIds, c.styledComponentId) : "", g.styledComponentId = d, g.target = i ? c.target : o, Object.defineProperty(g, "defaultProps", {
        get () {
            return this._foldedDefaultProps;
        },
        set (e) {
            this._foldedDefaultProps = i ? function(e, ...t) {
                for (const n of t)$f655ac91f53a7a3c$var$he(e, n, !0);
                return e;
            }({}, c.defaultProps, e) : e;
        }
    }), $f655ac91f53a7a3c$var$de(g, ()=>`.${g.styledComponentId}`), a && $f655ac91f53a7a3c$var$se(g, o, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), g;
}
var $f655ac91f53a7a3c$var$ht = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "button",
    "br",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "menu",
    "meter",
    "nav",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "search",
    "section",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tspan",
    "use"
]);
function $f655ac91f53a7a3c$var$dt(e, t) {
    const n = [
        e[0]
    ];
    for(let o = 0, s = t.length; o < s; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
const $f655ac91f53a7a3c$var$pt = (e)=>($f655ac91f53a7a3c$var$Ie.add(e), e);
function $f655ac91f53a7a3c$export$dbf350e5966cf602(e, ...t) {
    if ($f655ac91f53a7a3c$var$re(e) || $f655ac91f53a7a3c$var$ue(e)) return $f655ac91f53a7a3c$var$pt($f655ac91f53a7a3c$var$We($f655ac91f53a7a3c$var$dt($f655ac91f53a7a3c$var$I, [
        e,
        ...t
    ])));
    const n = e;
    return 0 === t.length && 1 === n.length && "string" == typeof n[0] ? $f655ac91f53a7a3c$var$We(n) : $f655ac91f53a7a3c$var$pt($f655ac91f53a7a3c$var$We($f655ac91f53a7a3c$var$dt(n, t)));
}
function $f655ac91f53a7a3c$var$mt(e, t, n = $f655ac91f53a7a3c$var$$) {
    if (!t) throw $f655ac91f53a7a3c$var$v(1, t);
    const o = (o, ...s)=>e(t, n, $f655ac91f53a7a3c$export$dbf350e5966cf602(o, ...s));
    return o.attrs = (o)=>$f655ac91f53a7a3c$var$mt(e, t, Object.assign(Object.assign({}, n), {
            attrs: Array.prototype.concat(n.attrs, o).filter(Boolean)
        })), o.withConfig = (o)=>$f655ac91f53a7a3c$var$mt(e, t, Object.assign(Object.assign({}, n), o)), o;
}
const $f655ac91f53a7a3c$var$yt = (e)=>$f655ac91f53a7a3c$var$mt($f655ac91f53a7a3c$var$ut, e), $f655ac91f53a7a3c$export$2e2bcd8739ae039 = $f655ac91f53a7a3c$var$yt;
$f655ac91f53a7a3c$var$ht.forEach((e)=>{
    $f655ac91f53a7a3c$export$2e2bcd8739ae039[e] = $f655ac91f53a7a3c$var$yt(e);
});
class $f655ac91f53a7a3c$var$vt {
    constructor(e, t){
        this.instanceRules = new Map, this.rules = e, this.componentId = t, this.isStatic = function(e) {
            for(let t = 0; t < e.length; t += 1){
                const n = e[t];
                if ($f655ac91f53a7a3c$var$re(n) && !$f655ac91f53a7a3c$export$7ba318d8d2f06c76(n)) return !1;
            }
            return !0;
        }(e), $f655ac91f53a7a3c$var$_e.registerId(this.componentId);
    }
    removeStyles(e, t) {
        this.instanceRules.delete(e), this.rebuildGroup(t);
    }
    renderStyles(e, t, n, o) {
        const s = this.componentId;
        if (this.isStatic) {
            if (n.hasNameForId(s, s + e)) this.instanceRules.has(e) || this.computeRules(e, t, n, o);
            else {
                const r = this.computeRules(e, t, n, o);
                n.insertRules(s, r.name, r.rules);
            }
            return;
        }
        const r = this.instanceRules.get(e);
        if (this.computeRules(e, t, n, o), !n.server && r) {
            const t = r.rules, n = this.instanceRules.get(e).rules;
            if (t.length === n.length) {
                let e = !0;
                for(let o = 0; o < t.length; o++)if (t[o] !== n[o]) {
                    e = !1;
                    break;
                }
                if (e) return;
            }
        }
        this.rebuildGroup(n);
    }
    computeRules(e, t, n, o) {
        const s = $f655ac91f53a7a3c$var$le($f655ac91f53a7a3c$var$We(this.rules, t, n, o)), r = {
            name: this.componentId + e,
            rules: o(s, "")
        };
        return this.instanceRules.set(e, r), r;
    }
    rebuildGroup(e) {
        const t = this.componentId;
        e.clearRules(t);
        for (const n of this.instanceRules.values())e.insertRules(t, n.name, n.rules);
    }
}
function $f655ac91f53a7a3c$export$f0f03736edb61697(e, ...n) {
    const o = $f655ac91f53a7a3c$export$dbf350e5966cf602(e, ...n), s = `sc-global-${$f655ac91f53a7a3c$var$z(JSON.stringify(o))}`, r = new $f655ac91f53a7a3c$var$vt(o, s);
    const i = (e)=>{
        const n = $f655ac91f53a7a3c$var$et(), i = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$2c657da244d00bd6);
        let a;
        {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
            null === e.current && (e.current = n.styleSheet.allocateGSInstance(s)), a = e.current;
        }
        n.styleSheet.server && c(a, e, n.styleSheet, i, n.stylis);
        {
            const o = r.isStatic ? [
                a,
                n.styleSheet,
                r
            ] : [
                a,
                e,
                n.styleSheet,
                i,
                n.stylis,
                r
            ], l = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(r);
            (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useLayoutEffect(()=>{
                n.styleSheet.server || (l.current !== r && (n.styleSheet.clearRules(s), l.current = r), c(a, e, n.styleSheet, i, n.stylis));
            }, o), (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useLayoutEffect(()=>()=>{
                    n.styleSheet.server || r.removeStyles(a, n.styleSheet);
                }, [
                a,
                n.styleSheet,
                r
            ]);
        }
        return n.styleSheet.server && r.instanceRules.delete(a), null;
    };
    function c(e, t, n, o, s) {
        if (r.isStatic) r.renderStyles(e, $f655ac91f53a7a3c$var$y, n, s);
        else {
            const c = Object.assign(Object.assign({}, t), {
                theme: $f655ac91f53a7a3c$var$R(t, o, i.defaultProps)
            });
            r.renderStyles(e, c, n, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).memo(i);
}
function $f655ac91f53a7a3c$var$bt(e, t, n, o, s) {
    for(const r in e){
        const i = e[r], c = s ? s + "-" + r : r;
        if ("object" == typeof i && null !== i) {
            const e = {};
            $f655ac91f53a7a3c$var$bt(i, t, e, o, c), n[r] = e;
        } else n[r] = o(c, i, r);
    }
}
function $f655ac91f53a7a3c$var$wt(e, t, n, o) {
    let s = "";
    for(const r in e){
        const i = e[r], c = t[r], a = o ? o + "-" + r : r;
        "object" == typeof i && null !== i ? "object" == typeof c && null !== c && (s += $f655ac91f53a7a3c$var$wt(i, c, n, a)) : void 0 !== c && "function" != typeof c && (s += "--" + n + a + ":" + c + ";");
    }
    return s;
}
function $f655ac91f53a7a3c$export$25d302a5b900a763(e, t) {
    var n, o;
    const s = (null !== (n = null == t ? void 0 : t.prefix) && void 0 !== n ? n : "sc") + "-", r = null !== (o = null == t ? void 0 : t.selector) && void 0 !== o ? o : ":root", i = function(e, t) {
        const n = {};
        return $f655ac91f53a7a3c$var$bt(e, t, n, (e)=>"--" + t + e), n;
    }(e, s), c = function(e, t) {
        const n = {};
        return $f655ac91f53a7a3c$var$bt(e, t, n, (e, n)=>{
            return "var(--" + t + e + ", " + n + ")";
        }), n;
    }(e, s), a = $f655ac91f53a7a3c$export$f0f03736edb61697`
    ${r} {
      ${(t)=>$f655ac91f53a7a3c$var$wt(e, t.theme, s)}
    }
  `;
    return Object.assign(c, {
        GlobalStyle: a,
        raw: e,
        vars: i,
        resolve (t) {
            if (!$f655ac91f53a7a3c$var$d) throw new Error("createTheme.resolve() is client-only");
            const n = null != t ? t : document.documentElement;
            return function(e, t, n) {
                const o = {};
                return $f655ac91f53a7a3c$var$bt(e, t, o, (e, o)=>n.getPropertyValue("--" + t + e).trim() || o), o;
            }(e, s, getComputedStyle(n));
        }
    });
}
var $f655ac91f53a7a3c$var$Ct;
class $f655ac91f53a7a3c$var$Ot {
    constructor(e, t){
        this[$f655ac91f53a7a3c$var$Ct] = !0, this.inject = (e, t = $f655ac91f53a7a3c$var$Ke)=>{
            const n = this.getName(t);
            if (!e.hasNameForId(this.id, n)) {
                const o = t(this.rules, n, "@keyframes");
                e.insertRules(this.id, n, o);
            }
        }, this.name = e, this.id = $f655ac91f53a7a3c$var$m + e, this.rules = t, $f655ac91f53a7a3c$var$C(this.id), $f655ac91f53a7a3c$var$de(this, ()=>{
            throw $f655ac91f53a7a3c$var$v(12, String(this.name));
        });
    }
    getName(e = $f655ac91f53a7a3c$var$Ke) {
        return e.hash ? this.name + $f655ac91f53a7a3c$var$V(+e.hash >>> 0) : this.name;
    }
}
function $f655ac91f53a7a3c$export$d25ddfdf17c3ad3e(e, ...t) {
    const n = $f655ac91f53a7a3c$var$le($f655ac91f53a7a3c$export$dbf350e5966cf602(e, ...t)), o = $f655ac91f53a7a3c$var$z(n);
    return new $f655ac91f53a7a3c$var$Ot(o, n);
}
function $f655ac91f53a7a3c$export$e8748c6a27b910dc(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).forwardRef((n, o)=>{
        const s = $f655ac91f53a7a3c$var$R(n, (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement(e, Object.assign(Object.assign({}, n), {
            theme: s,
            ref: o
        }));
    });
    return n.displayName = `WithTheme(${$f655ac91f53a7a3c$var$W(e)})`, $f655ac91f53a7a3c$var$se(n, e);
}
$f655ac91f53a7a3c$var$Ct = $f655ac91f53a7a3c$var$Te;
class $f655ac91f53a7a3c$export$ae8c7d15c8b89a20 {
    constructor({ nonce: e } = {}){
        this._emitSheetCSS = ()=>{
            const e = this.instance.toString();
            if (!e) return "";
            const t = this.instance.options.nonce || $f655ac91f53a7a3c$var$Ne();
            return `<style ${$f655ac91f53a7a3c$var$le([
                t && `nonce="${t}"`,
                `${$f655ac91f53a7a3c$var$c}="true"`,
                `${$f655ac91f53a7a3c$var$l}="${$f655ac91f53a7a3c$export$83d89fbfd8236492}"`
            ].filter(Boolean), " ")}>${e}</style>`;
        }, this.getStyleTags = ()=>{
            if (this.sealed) throw $f655ac91f53a7a3c$var$v(2);
            return this._emitSheetCSS();
        }, this.getStyleElement = ()=>{
            if (this.sealed) throw $f655ac91f53a7a3c$var$v(2);
            const e = this.instance.toString();
            if (!e) return [];
            const n = {
                [$f655ac91f53a7a3c$var$c]: "",
                [$f655ac91f53a7a3c$var$l]: $f655ac91f53a7a3c$export$83d89fbfd8236492,
                dangerouslySetInnerHTML: {
                    __html: e
                }
            }, o = this.instance.options.nonce || $f655ac91f53a7a3c$var$Ne();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("style", Object.assign({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = ()=>{
            this.sealed = !0;
        }, this.instance = new $f655ac91f53a7a3c$var$_e({
            isServer: !0,
            nonce: e
        }), this.sealed = !1;
    }
    collectStyles(e) {
        if (this.sealed) throw $f655ac91f53a7a3c$var$v(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($f655ac91f53a7a3c$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }
    interleaveWithNodeStream(e) {
        throw $f655ac91f53a7a3c$var$v(3);
    }
}
const $f655ac91f53a7a3c$export$5c87cfe6c475f500 = {
    StyleSheet: $f655ac91f53a7a3c$var$_e,
    mainSheet: $f655ac91f53a7a3c$var$Xe
};
const $f655ac91f53a7a3c$var$It = `__sc-${$f655ac91f53a7a3c$var$c}__`;
const $f655ac91f53a7a3c$var$$t = /:(?:(first)-child|(last)-child|(only)-child|(nth-child)\(([^()]+)\)|(nth-last-child)\(([^()]+)\))/g, $f655ac91f53a7a3c$var$Rt = `:not(style[${$f655ac91f53a7a3c$var$c}])`, $f655ac91f53a7a3c$var$jt = `style[${$f655ac91f53a7a3c$var$c}]`;
function $f655ac91f53a7a3c$var$xt(e) {
    return -1 === e.indexOf("-child") ? e : ($f655ac91f53a7a3c$var$$t.lastIndex = 0, e.replace($f655ac91f53a7a3c$var$$t, (e, t, n, o, s, r, i, c)=>t ? `:nth-child(1 of ${$f655ac91f53a7a3c$var$Rt})` : n ? `:nth-last-child(1 of ${$f655ac91f53a7a3c$var$Rt})` : o ? `:nth-child(1 of ${$f655ac91f53a7a3c$var$Rt}):nth-last-child(1 of ${$f655ac91f53a7a3c$var$Rt})` : s ? -1 !== r.indexOf(" of ") ? e : `:nth-child(${r} of ${$f655ac91f53a7a3c$var$Rt})` : -1 !== c.indexOf(" of ") ? e : `:nth-last-child(${c} of ${$f655ac91f53a7a3c$var$Rt})`));
}
function $f655ac91f53a7a3c$var$Tt(e, t) {
    if (-1 === e.indexOf("+")) return;
    let n = 0, o = 0;
    for(let s = 0; s < e.length; s++){
        const r = e.charCodeAt(s);
        if (40 === r) n++;
        else if (41 === r) n--;
        else if (91 === r) o++;
        else if (93 === r) o--;
        else if (43 === r && 0 === n && 0 === o && !$f655ac91f53a7a3c$var$He(e, s)) {
            const n = e.substring(0, s), o = e.substring(s + 1);
            t.push(n + "+" + $f655ac91f53a7a3c$var$jt + "+" + o), t.push(n + "+" + $f655ac91f53a7a3c$var$jt + "+" + $f655ac91f53a7a3c$var$jt + "+" + o);
        }
    }
}
function $f655ac91f53a7a3c$export$337461d98bd2ad54(e) {
    if (e.type === (0, $97db0618d63b43de$export$aa3a2e812ca8570d)) {
        const t = e.props, n = [];
        for(let e = 0; e < t.length; e++){
            const o = $f655ac91f53a7a3c$var$xt(t[e]);
            n.push(o), $f655ac91f53a7a3c$var$Tt(o, n);
        }
        e.props = n;
    }
}


// Such export is called Tree Shaking. It allows to import only the components
// that are needed while webpack will remove the rest of the code from the bundle.
const $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c = "#4fa94d";
const $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "progressbar"
};
const $6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56 = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).div`
  display: ${(props)=>props.$visible ? "flex" : "none"};
`;
const $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c = "http://www.w3.org/2000/svg";
const $6bfaf8085a30c9b5$export$153755f98d9861de = ({ height: height = "100", width: width = "100", color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "audio-loading", wrapperStyle: wrapperStyle = {}, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            height: `${height}`,
            width: `${width}`,
            fill: color,
            viewBox: "0 0 55 80",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "audio-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("title", {
                    children: "Audio Visualization"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("desc", {
                    children: "Animated representation of audio data"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                    transform: "matrix(1 0 0 -1 0 80)",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            width: "10",
                            height: "20",
                            rx: "3",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "4.3s",
                                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "15",
                            width: "10",
                            height: "80",
                            rx: "3",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "30",
                            width: "10",
                            height: "50",
                            rx: "3",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "1.4s",
                                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "45",
                            width: "10",
                            height: "30",
                            rx: "3",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$68949ad0373623af = ({ height: height = 100, width: width = 100, radius: radius = 5, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "ball-triangle-loading", wrapperClass: wrapperClass, wrapperStyle: wrapperStyle, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: {
            ...wrapperStyle
        },
        $visible: visible,
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            height: height,
            width: width,
            stroke: color,
            viewBox: "0 0 57 57",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "ball-triangle-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("title", {
                    children: "Ball Triangle"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("desc", {
                    children: "Animated representation of three balls"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        transform: "translate(1 1)",
                        strokeWidth: "2",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                                cx: "5",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;5;50;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "5;27;49;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                                cx: "27",
                                cy: "5",
                                r: radius,
                                children: [
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "5",
                                        to: "5",
                                        values: "5;50;50;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "27",
                                        to: "27",
                                        values: "27;49;5;27",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                                cx: "49",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;50;5;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        from: "49",
                                        to: "49",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "49;5;27;49",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$fbc7d6f7dd821b47 = ({ height: height = 80, width: width = 80, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "bars-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            fill: color,
            viewBox: "0 0 135 140",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "bars-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                    x: "30",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                    x: "60",
                    width: "15",
                    height: "140",
                    rx: "6",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                    x: "90",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                    x: "120",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$765808835a2dc0a2 = ({ height: height = 80, width: width = 80, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "circles-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 135 135",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "circles-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("title", {
                    children: "circles-loading"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("desc", {
                    children: "Animated representation of circles"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "-360 67 67",
                        dur: "2.5s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "360 67 67",
                        dur: "8s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$17c11650828d97e = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, barColor: barColor, ariaLabel: ariaLabel = "circles-with-bar-loading" })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        "data-testid": "circles-with-bar-wrapper",
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            version: "1.1",
            id: "L1",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            height: `${height}`,
            width: `${width}`,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "circles-with-bar-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("title", {
                    children: "circles-with-bar-loading"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("desc", {
                    children: "Animated representation of circles with bar"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${outerCircleColor || color}`,
                    strokeWidth: "6",
                    strokeMiterlimit: "15",
                    strokeDasharray: "14.2472,14.2472",
                    cx: "50",
                    cy: "50",
                    r: "47",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${innerCircleColor || color}`,
                    strokeWidth: "1",
                    strokeMiterlimit: "10",
                    strokeDasharray: "10,10",
                    cx: "50",
                    cy: "50",
                    r: "39",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                    fill: `${barColor || color}`,
                    "data-testid": "circles-with-bar-svg-bar",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "30",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "40",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "50",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "60",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.4"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "70",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.5"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$export$ef2184bd89960b14 = ({ height: height = 80, width: width = 80, radius: radius = 12.5, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "grid-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 105 105",
            fill: color,
            "data-testid": "grid-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "100ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "300ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "600ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "800ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "400ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "700ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "500ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "200ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$2da2f0c7403af3ce = ({ height: height = 80, width: width = 80, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "hearts-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 140 64",
            xmlns: "http://www.w3.org/2000/svg",
            fill: color,
            "data-testid": "hearts-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0.7s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len = 242.776657104492;
const $6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$time = 1.6;
const $6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$anim = (0, $f655ac91f53a7a3c$export$d25ddfdf17c3ad3e)`
12.5% {
  stroke-dasharray: ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.14}px, ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.11}px;
}
43.75% {
  stroke-dasharray: ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.35}px, ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.35}px;
}
100% {
  stroke-dasharray: ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.99}px;
}
`;
const $6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$Path = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).path`
  stroke-dasharray: ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len};
  stroke-dashoffset: 0;
  animation: ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$anim} ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$time}s linear infinite;
`;
const $6bfaf8085a30c9b5$export$8009d4483dfda42 = ({ color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "200" })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: `${width}`,
        height: `${Number(width) * 0.5}`,
        viewBox: `0 0 ${width} ${Number(100)}`,
        "data-testid": "infinity-spin",
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$Path, {
                "data-testid": "infinity-spin-path-1",
                stroke: color,
                fill: "none",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                "data-testid": "infinity-spin-path-2",
                opacity: "0.07",
                fill: "none",
                stroke: color,
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$d2101d81f63866ab = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "line-wave-loading", firstLineColor: firstLineColor, middleLineColor: middleLineColor, lastLineColor: lastLineColor })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 0 0",
            xmlSpace: "preserve",
            "data-testid": "line-wave-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                    x: "20",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: firstLineColor || color,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                    x: "30",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: middleLineColor || color,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.2s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                    x: "40",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: lastLineColor || color,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.4s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$export$64ea884904791f4 = ({ height: height = 90, width: width = 80, radius: radius = 12.5, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "mutating-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            id: "goo-loader",
            width: width,
            height: height,
            "data-testid": "mutating-dots-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("filter", {
                    id: "fancy-goo",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("feGaussianBlur", {
                            in: "SourceGraphic",
                            stdDeviation: "6",
                            result: "blur"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("feColorMatrix", {
                            in: "blur",
                            mode: "matrix",
                            values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
                            result: "goo"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("feComposite", {
                            in: "SourceGraphic",
                            in2: "goo",
                            operator: "atop"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                    filter: "url(#fancy-goo)",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                            id: "mainAnim",
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            from: "0 50 50",
                            to: "359 50 50",
                            dur: "1.2s",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "40",
                            r: radius,
                            fill: color,
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                id: "cAnim1",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0;cAnim1.end+0.2s",
                                calcMode: "spline",
                                values: "40;20;40",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "60",
                            r: radius,
                            fill: secondaryColor,
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                id: "cAnim2",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0.4s;cAnim2.end+0.2s",
                                calcMode: "spline",
                                values: "60;80;60",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        })
                    ]
                })
            ]
        })
    });
/**
 * The radius of the circle
 * The Loader size is set with the width and height of the SVG
 * @type {number}
 */ const $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$RADIUS = 20;
/**
 * Compute Path depending on circle radius
 * The structure with radius 20 is "M20 0c0-9.94-8.06-20-20-20"
 * @param radius of the circle radius default 20
 * @returns {string}
 */ const $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$getPath = (radius)=>{
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
/**
 * Compute the size of the view box depending on the radius and Stroke-Width
 * @param strokeWidth Stroke-Width of the full circle
 * @param secondaryStrokeWidth Stroke-Width of the 1/4 circle
 * @param radius radius of the circle
 * @returns {string}
 */ const $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$getViewBoxSize = (strokeWidth, secondaryStrokeWidth, radius)=>{
    const maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    const startingPoint = -radius - maxStrokeWidth / 2 + 1;
    const endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
const $6bfaf8085a30c9b5$export$67ad50c48ca3ede4 = ({ height: height = 80, width: width = 80, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "oval-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true, strokeWidth: strokeWidth = 2, strokeWidthSecondary: strokeWidthSecondary })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$RADIUS),
            xmlns: "http://www.w3.org/2000/svg",
            stroke: color,
            "data-testid": "oval-svg",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                    transform: "translate(1 1)",
                    strokeWidth: Number(strokeWidthSecondary || strokeWidth),
                    "data-testid": "oval-secondary-group",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                            strokeOpacity: ".5",
                            cx: "0",
                            cy: "0",
                            r: $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$RADIUS,
                            stroke: secondaryColor,
                            strokeWidth: strokeWidth
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                            d: $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$getPath($6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$RADIUS),
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                from: "0 0 0",
                                to: "360 0 0",
                                dur: "1s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
const $6bfaf8085a30c9b5$export$83d2259ec538613b = ({ height: height = 80, width: width = 80, radius: radius = 1, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "puff-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 44 44",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "puff-svg",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                strokeWidth: "2",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        })
    });
const $6bfaf8085a30c9b5$export$8e22e563e5362f75 = ({ radius: radius = 45, strokeWidth: strokeWidth = 5, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor, ariaLabel: ariaLabel = "revolving-dot-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            version: "1.1",
            width: `calc(${radius} * 2.5)`,
            height: `calc(${radius} * 2.5)`,
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            "data-testid": "revolving-dot-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    fill: "none",
                    stroke: secondaryColor || color,
                    strokeWidth: strokeWidth,
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} * 1.28)`,
                    r: radius,
                    style: {
                        opacity: 0.5
                    }
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    fill: color,
                    stroke: color,
                    strokeWidth: "3",
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} / 3.5)`,
                    r: `calc(${radius} / 5)`,
                    style: {
                        transformOrigin: "50% 50%"
                    },
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0",
                        to: "360",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$fdd9e2f491a77de7 = ({ height: height = 80, width: width = 80, radius: radius = 6, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "rings-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 45 45",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "rings-svg",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(1 1)",
                strokeWidth: "2",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "1.5s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "stroke-opacity",
                                begin: "1.5s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "stroke-width",
                                begin: "1.5s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "3s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "3s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "strokeWidth",
                                begin: "3s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                        cx: "22",
                        cy: "22",
                        r: Number(radius) + 2,
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "r",
                            begin: "0s",
                            dur: "1.5s",
                            values: "6;1;2;3;4;5;6",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    });
const $6bfaf8085a30c9b5$export$bb511942ded86554 = ({ wrapperClass: wrapperClass = "", color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, height: height = 100, width: width = 100, strokeWidth: strokeWidth = 4, ariaLabel: ariaLabel = "rotating-square-loading", wrapperStyle: wrapperStyle = {}, visible: visible = true })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            version: "1.1",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            height: `${height}`,
            width: `${width}`,
            "data-testid": "rotating-square-svg",
            xmlSpace: "preserve",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: strokeWidth,
                    x: "25",
                    y: "25",
                    width: "50",
                    height: "50",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "0.5s",
                        from: "0 50 50",
                        to: "180 50 50",
                        type: "rotate",
                        id: "strokeBox",
                        attributeType: "XML",
                        begin: "rectBox.end"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                    x: "27",
                    y: "27",
                    fill: color,
                    width: "46",
                    height: "50",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "height",
                        dur: "1.3s",
                        attributeType: "XML",
                        from: "50",
                        to: "0",
                        id: "rectBox",
                        fill: "freeze",
                        begin: "0s;strokeBox.end"
                    })
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$var$$5819da83a926266a$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
const $6bfaf8085a30c9b5$var$$5819da83a926266a$var$spin = (0, $f655ac91f53a7a3c$export$d25ddfdf17c3ad3e)`
to {
   transform: rotate(360deg);
 }
`;
const $6bfaf8085a30c9b5$var$$5819da83a926266a$var$Svg = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).svg`
  animation: ${$6bfaf8085a30c9b5$var$$5819da83a926266a$var$spin} 0.75s steps(12, end) infinite;
  animation-duration: 0.75s;
`;
const $6bfaf8085a30c9b5$var$$5819da83a926266a$var$Polyline = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).polyline`
  stroke-width: ${(props)=>props.width}px;
  stroke-linecap: round;

  &:nth-child(12n + 0) {
    stroke-opacity: 0.08;
  }

  &:nth-child(12n + 1) {
    stroke-opacity: 0.17;
  }

  &:nth-child(12n + 2) {
    stroke-opacity: 0.25;
  }

  &:nth-child(12n + 3) {
    stroke-opacity: 0.33;
  }

  &:nth-child(12n + 4) {
    stroke-opacity: 0.42;
  }

  &:nth-child(12n + 5) {
    stroke-opacity: 0.5;
  }

  &:nth-child(12n + 6) {
    stroke-opacity: 0.58;
  }

  &:nth-child(12n + 7) {
    stroke-opacity: 0.66;
  }

  &:nth-child(12n + 8) {
    stroke-opacity: 0.75;
  }

  &:nth-child(12n + 9) {
    stroke-opacity: 0.83;
  }

  &:nth-child(12n + 11) {
    stroke-opacity: 0.92;
  }
`;
const $6bfaf8085a30c9b5$export$d20df8773b6b77b5 = ({ strokeColor: strokeColor = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, strokeWidth: strokeWidth = "5", animationDuration: animationDuration = "0.75", width: width = "96", visible: visible = true, ariaLabel: ariaLabel = "rotating-lines-loading" })=>{
    const lines = (0, $lCzvA.useCallback)(()=>$6bfaf8085a30c9b5$var$$5819da83a926266a$var$POINTS.map((point)=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$5819da83a926266a$var$Polyline, {
                points: "24,12 24,4",
                width: strokeWidth,
                transform: `rotate(${point}, 24, 24)`
            }, point)), [
        strokeWidth
    ]);
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$5819da83a926266a$var$Svg, {
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: lines()
    });
};
const $6bfaf8085a30c9b5$export$f8e5ae7506d65b32 = ({ height: height = 80, width: width = 80, strokeWidth: strokeWidth = 2, radius: radius = 1, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "tail-spin-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    const strokeWidthNum = parseInt(String(strokeWidth));
    const viewBoxValue = strokeWidthNum + 36;
    const halfStrokeWidth = strokeWidthNum / 2;
    const processedRadius = halfStrokeWidth + parseInt(String(radius)) - 1;
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: `0 0 ${viewBoxValue} ${viewBoxValue}`,
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "tail-spin-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("defs", {
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("linearGradient", {
                        x1: "8.042%",
                        y1: "0%",
                        x2: "65.682%",
                        y2: "23.865%",
                        id: "a",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: "0",
                                offset: "0%"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: ".631",
                                offset: "63.146%"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("stop", {
                                stopColor: color,
                                offset: "100%"
                            })
                        ]
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        transform: `translate(${halfStrokeWidth} ${halfStrokeWidth})`,
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                d: "M36 18c0-9.94-8.06-18-18-18",
                                id: "Oval-2",
                                stroke: color,
                                strokeWidth: strokeWidth,
                                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                                fill: "#fff",
                                cx: "36",
                                cy: "18",
                                r: processedRadius,
                                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$export$e21573137ccb7f5d = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-circles-loading", outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, middleCircleColor: middleCircleColor })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "three-circles-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    fill: outerCircleColor || color,
                    d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    fill: middleCircleColor || color,
                    d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "1s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    fill: innerCircleColor || color,
                    d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$export$4bf83b24a11cff0b = ({ height: height = 80, width: width = 80, radius: radius = 9, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 120 30",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "three-dots-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                    cx: "15",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                    cx: "60",
                    cy: "15",
                    r: radius,
                    attributeName: "fill-opacity",
                    from: "1",
                    to: "0.3",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "9",
                            to: "9",
                            begin: "0s",
                            dur: "0.8s",
                            values: "9;15;9",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "0.5",
                            to: "0.5",
                            begin: "0s",
                            dur: "0.8s",
                            values: ".5;1;.5",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                    cx: "105",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES = "-3 -4 39 39";
const $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$POLYGON_POINTS = "16,0 32,32 0,32";
/** Styles */ const $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$dash = (0, $f655ac91f53a7a3c$export$d25ddfdf17c3ad3e)`
to {
   stroke-dashoffset: 136;
 }
`;
const $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$Polygon = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).polygon`
  stroke-dasharray: 17;
  animation: ${$6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$dash} 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;
`;
const $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$SVG = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).svg`
  transform-origin: 50% 65%;
`;
const $6bfaf8085a30c9b5$export$5a465592bfe74b48 = ({ height: height = 80, width: width = 80, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "triangle-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: `${wrapperClass}`,
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$SVG, {
            id: "triangle",
            width: width,
            height: height,
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES,
            "data-testid": "triangle-svg",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$Polygon, {
                fill: "transparent",
                stroke: color,
                strokeWidth: "1",
                points: $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$POLYGON_POINTS
            })
        })
    });
};
const $6bfaf8085a30c9b5$export$4c68f1a79f88778c = ({ height: height = 80, width: width = 80, radius: radius = 48, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "watch-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            version: "1.1",
            id: "L2",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "watch-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    cx: "50",
                    cy: "50",
                    r: radius
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "85",
                    y2: "50.5",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "49.5",
                    y2: "74",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "15s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$1ed1943372cc63a9 = ({ color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "100", visible: visible = true })=>{
    return visible ? (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-1",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-2",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    }) : null;
};
const $6bfaf8085a30c9b5$export$d25f4198d7ad6c78 = ({ visible: visible = true, height: height = "80", width: width = "80", ariaLabel: ariaLabel = "vortex-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461",
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
        height: height,
        width: width,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                transform: "scale(0.7)",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        transform: "rotate(137.831 50 50)",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                repeatCount: "indefinite",
                                values: "360 50 50;0 50 50",
                                keyTimes: "0;1",
                                dur: "1",
                                keySplines: "0.5 0.5 0.5 0.5",
                                calcMode: "spline"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[0],
                                d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[1],
                                d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[2],
                                d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[3],
                                d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[4],
                                d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[5],
                                d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $6bfaf8085a30c9b5$export$f64f16a115ce395d = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "rotating-triangle-loading", colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
            transform: "translate(50,42)",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                transform: "scale(0.8)",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                    transform: "translate(-50,-50)",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("polygon", {
                            points: "72.5,50 50,11 27.5,50 50,50",
                            fill: colors[0],
                            transform: "rotate(186 50 38.5)",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 50 38.5;360 50 38.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("polygon", {
                            points: "5,89 50,89 27.5,50",
                            fill: colors[1],
                            transform: "rotate(186 27.5 77.5)",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 27.5 77.5;360 27.5 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("polygon", {
                            points: "72.5,50 50,89 95,89",
                            fill: colors[2],
                            transform: "rotate(186 72.2417 77.5)",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 72.5 77.5;360 72 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $6bfaf8085a30c9b5$export$d7b12c4107be0d61 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "radio-loading", colors: colors = [
    $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c
] })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                cx: "28",
                cy: "75",
                r: "11",
                fill: colors[0],
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                d: "M28 47A28 28 0 0 1 56 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[1],
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.1s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                d: "M28 25A50 50 0 0 1 78 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[2],
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.2s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$c17561cb55d4db30 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "progress-bar-loading", borderColor: borderColor = "#F4442E", barColor: barColor = "#51E5FF" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("defs", {
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("clipPath", {
                    x: "0",
                    y: "0",
                    width: "100",
                    height: "100",
                    id: "lds-progress-cpid-5009611b8a418",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                        x: "0",
                        y: "0",
                        width: "66.6667",
                        height: "100",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "width",
                                calcMode: "linear",
                                values: "0;100;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "x",
                                calcMode: "linear",
                                values: "0;0;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                fill: "none",
                strokeWidth: "2.7928",
                d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
                stroke: borderColor
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
                fill: barColor,
                clipPath: "url(#lds-progress-cpid-5009611b8a418)"
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$bdf537af43a20db5 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "magnifying-glass-loading", glassColor: glassColor = "#c0efff", color: color = "#e15b64" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                transform: "scale(0.82)",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        transform: "translate(16.3636 -20)",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "translate",
                                calcMode: "linear",
                                values: "-20 -20;20 -20;0 20;-20 -20",
                                keyTimes: "0;0.33;0.66;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
                                fill: glassColor
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
                                fill: color
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $6bfaf8085a30c9b5$export$8e3fad5cade57efa = ({ width: width = "80", height: height = "80", backgroundColor: backgroundColor = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ballColors: ballColors = [
    "#fc636b",
    "#6a67ce",
    "#ffb900"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "fidget-spinner-loader", visible: visible = true })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
            transform: "rotate(6 50 50)",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                    transform: "translate(50 50)",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                        transform: "scale(0.9)",
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                            transform: "translate(-50 -58)",
                            children: [
                                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                    d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
                                    fill: ballColors[0]
                                }),
                                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                    d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
                                    fill: ballColors[1]
                                }),
                                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                                    cx: "50",
                                    cy: "27",
                                    r: "7.4",
                                    fill: ballColors[2]
                                }),
                                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                    d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
                                    fill: backgroundColor
                                })
                            ]
                        })
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$export$bee07fdc425df572 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "dna-loading" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "60.6229",
                r: "3.41988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "0s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "39.3771",
                r: "2.58012",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "68.1552",
                r: "3.17988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "31.8448",
                r: "2.82012",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "69.3634",
                r: "2.93988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "30.6366",
                r: "3.06012",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "65.3666",
                r: "2.69988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "34.6334",
                r: "3.30012",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "53.8474",
                r: "2.45988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "46.1526",
                r: "3.54012",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "39.3771",
                r: "2.58012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "60.6229",
                r: "3.41988",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.5s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "31.8448",
                r: "2.82012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "68.1552",
                r: "3.17988",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.7s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "30.6366",
                r: "3.06012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "69.3634",
                r: "2.93988",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.9s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "34.6334",
                r: "3.30012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "65.3666",
                r: "2.69988",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.1s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "46.1526",
                r: "3.54012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "53.8474",
                r: "2.45988",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.3s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$f93420b62a5bdffa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "discuss-loading", colors: colors = [
    "#ff727d",
    "#ff727d"
] })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                fill: "none",
                d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
                strokeWidth: "5",
                stroke: colors[0]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                strokeLinecap: "round",
                r: "20",
                strokeWidth: "5",
                stroke: colors[1],
                strokeDasharray: "31.41592653589793 31.41592653589793",
                transform: "rotate(96 50 50)",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$dc036a5afb9ca26f = ({ visible: visible = true, width: width = "80", height: height = "80", colors: colors = [
    "#e15b64",
    "#f47e60",
    "#f8b26a",
    "#abbd81",
    "#849b87"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "color-ring-loading" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("defs", {
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("mask", {
                    id: "ldio-4offds5dlws-mask",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        r: "26",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeDasharray: "122.52211349000194 40.840704496667314",
                        strokeWidth: "9",
                        transform: "rotate(198.018 50 50)",
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            values: "0 50 50;360 50 50",
                            keyTimes: "0;1",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                mask: "url(#ldio-4offds5dlws-mask)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                        x: "14.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[0],
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.8s"
                        })
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                        x: "28.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[1],
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.6s"
                        })
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                        x: "42.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[2],
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.4s"
                        })
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                        x: "56.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[3],
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.2s"
                        })
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                        x: "70.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[4],
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "0s"
                        })
                    })
                ]
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$4d299b491347818a = ({ visible: visible = true, width: width = "80", height: height = "80", backgroundColor: backgroundColor = "#ff6d00", color: color = "#fff", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "comment-loading" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
                fill: backgroundColor
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                cx: "30",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                cx: "50",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.2;0.4;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                cx: "70",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.4;0.6;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$2ba1b65b747a57aa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "blocks-loading" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("title", {
                children: "Blocks"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("desc", {
                children: "Animated representation of blocks"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "17",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "40",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.125s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "63",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.25s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "17",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.875s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "63",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.375s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "17",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.75s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "40",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.625s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "63",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.5s",
                    calcMode: "discrete"
                })
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$f3c41beb83007357 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "hourglass-loading", colors: colors = [
    "#306cce",
    "#72a1ed"
] })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 350 350",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "hourglass-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                values: "0; 0; -30; 360; 360",
                keyTimes: "0; 0.40; 0.55; 0.65; 1",
                dur: "3s",
                begin: "0s",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                        fill: colors[0],
                        stroke: colors[0],
                        d: "M324.658,20.572v-2.938C324.658,7.935,316.724,0,307.025,0H40.313c-9.699,0-17.635,7.935-17.635,17.634v2.938     c0,9.699,7.935,17.634,17.635,17.634h6.814c3.5,0,3.223,3.267,3.223,4.937c0,19.588,8.031,42.231,14.186,56.698     c12.344,29.012,40.447,52.813,63.516,69.619c4.211,3.068,3.201,5.916,0.756,7.875c-22.375,17.924-51.793,40.832-64.271,70.16     c-6.059,14.239-13.934,36.4-14.18,55.772c-0.025,1.987,0.771,5.862-3.979,5.862h-6.064c-9.699,0-17.635,7.936-17.635,17.634v2.94     c0,9.698,7.935,17.634,17.635,17.634h266.713c9.699,0,17.633-7.936,17.633-17.634v-2.94c0-9.698-7.934-17.634-17.633-17.634     h-3.816c-7,0-6.326-5.241-6.254-7.958c0.488-18.094-4.832-38.673-12.617-54.135c-17.318-34.389-44.629-56.261-61.449-68.915     c-3.65-2.745-4.018-6.143,0-8.906c17.342-11.929,44.131-34.526,61.449-68.916c8.289-16.464,13.785-38.732,12.447-57.621     c-0.105-1.514-0.211-4.472,3.758-4.472h6.482C316.725,38.206,324.658,30.272,324.658,20.572z M270.271,93.216     c-16.113,31.998-41.967,54.881-64.455,68.67c-1.354,0.831-3.936,2.881-3.936,8.602v6.838c0,6.066,2.752,7.397,4.199,8.286     c22.486,13.806,48.143,36.636,64.191,68.508c7.414,14.727,11.266,32.532,10.885,46.702c-0.078,2.947,1.053,8.308-6.613,8.308     H72.627c-6.75,0-6.475-3.37-6.459-5.213c0.117-12.895,4.563-30.757,12.859-50.255c14.404-33.854,44.629-54.988,64.75-67.577     c0.896-0.561,2.629-1.567,2.629-6.922v-10.236c0-5.534-2.656-7.688-4.057-8.57c-20.098-12.688-49.256-33.618-63.322-66.681     c-8.383-19.702-12.834-37.732-12.861-50.657c-0.002-1.694,0.211-4.812,3.961-4.812h206.582c4.168,0,4.127,3.15,4.264,4.829     C282.156,57.681,278.307,77.257,270.271,93.216z"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M169.541,196.2l-68.748,86.03c-2.27,2.842-1.152,5.166,2.484,5.166h140.781c3.637,0,4.756-2.324,2.484-5.166     l-68.746-86.03C175.525,193.358,171.811,193.358,169.541,196.2z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "0; 0; 1; 1; 0; 0",
                                keyTimes: "0; 0.1; 0.4; 0.6; 0.61; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M168.986,156.219c2.576,2.568,6.789,2.568,9.363,0l34.576-34.489c2.574-2.568,1.707-4.67-1.932-4.67H136.34     c-3.637,0-4.506,2.102-1.932,4.67L168.986,156.219z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "1; 1; 0; 0; 1; 1",
                                keyTimes: "0; 0.1; 0.4; 0.65; 0.66; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $dAQd3 = parcelRequire("dAQd3");
function $78b54bd991d76db4$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $78b54bd991d76db4$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
const $78b54bd991d76db4$var$$953deebe48519221$export$3a0af973ab9abfb3 = ()=>{
// Intentionally empty
};
const $78b54bd991d76db4$var$$953deebe48519221$export$b2229c0522132a74 = (cameras)=>{
    // Get previous camera selection
    const storage = localStorage.getItem('camera_selection');
    /**
   * @type {import('../types').Camera | null}
   */ const previousSelection = storage ? JSON.parse(storage) : null;
    // If previous camera is still available, use it
    if (previousSelection && cameras.some(({ id: id })=>id === previousSelection.id)) return previousSelection;
    // Look for a back camera
    const backCamera = cameras.find(({ label: label })=>label.toLowerCase().includes('back'));
    // Default, first camera found
    const defaultCamera = cameras[0];
    return backCamera || defaultCamera;
};
const $78b54bd991d76db4$var$$953deebe48519221$export$f2c4ef2d1f0c2e1d = async ()=>{
    const devices = await (0, $9eb3c467bce0942e$export$e14ced7bffd8eb7a).getCameras();
    if (!devices.length) throw new Error('No cameras found');
    return devices;
};
const $78b54bd991d76db4$var$$8f4a7e327cfc31fa$export$3554c92511f9ea7a = {
    startCamera: $78b54bd991d76db4$var$$953deebe48519221$export$3a0af973ab9abfb3
};
const $78b54bd991d76db4$var$$8f4a7e327cfc31fa$export$9dc4ea39af0daa49 = (0, $lCzvA.createContext)($78b54bd991d76db4$var$$8f4a7e327cfc31fa$export$3554c92511f9ea7a);
const $78b54bd991d76db4$export$91d88843bfb219ae = ()=>(0, $lCzvA.useContext)($78b54bd991d76db4$var$$8f4a7e327cfc31fa$export$9dc4ea39af0daa49);
const $78b54bd991d76db4$var$$7aede9e186d82185$export$6a5e58c31158ca8 = 'start_camera';
const $78b54bd991d76db4$var$$7aede9e186d82185$export$e8cea1d59b0c9f14 = 'set_camera_open';
const $78b54bd991d76db4$var$$7aede9e186d82185$export$18cb8552e15b3d06 = 'set_html5_qr_code';
const $78b54bd991d76db4$var$$7aede9e186d82185$export$6910e11b01a25b49 = 'set_selected_camera';
const $78b54bd991d76db4$var$$7aede9e186d82185$export$89dec1050c5f188a = 'set_cameras';
const $78b54bd991d76db4$var$$377ebf84863e9293$export$dbd874037937496d = {
    onScan: $78b54bd991d76db4$var$$953deebe48519221$export$3a0af973ab9abfb3,
    onClose: $78b54bd991d76db4$var$$953deebe48519221$export$3a0af973ab9abfb3,
    isOpen: false,
    cameras: [],
    selectedCamera: undefined,
    html5QrCode: undefined
};
const $78b54bd991d76db4$var$$377ebf84863e9293$export$32a09064dc2bfed6 = (state, action)=>{
    switch(action.type){
        case $78b54bd991d76db4$var$$7aede9e186d82185$export$e8cea1d59b0c9f14:
            return {
                ...state,
                isOpen: Boolean(action.payload)
            };
        case $78b54bd991d76db4$var$$7aede9e186d82185$export$6a5e58c31158ca8:
            return {
                ...state,
                isOpen: true,
                onScan: action.payload.onScan,
                onClose: action.payload.onClose
            };
        case $78b54bd991d76db4$var$$7aede9e186d82185$export$18cb8552e15b3d06:
            return {
                ...state,
                html5QrCode: action.payload
            };
        case $78b54bd991d76db4$var$$7aede9e186d82185$export$6910e11b01a25b49:
            return {
                ...state,
                selectedCamera: action.payload
            };
        case $78b54bd991d76db4$var$$7aede9e186d82185$export$89dec1050c5f188a:
            return {
                ...state,
                cameras: action.payload
            };
        default:
            return state;
    }
};
const $78b54bd991d76db4$var$$97a6ca42802421f7$export$9f4e0787ee8eb98b = {
    state: $78b54bd991d76db4$var$$377ebf84863e9293$export$dbd874037937496d,
    dispatch: $78b54bd991d76db4$var$$953deebe48519221$export$3a0af973ab9abfb3
};
const $78b54bd991d76db4$var$$97a6ca42802421f7$export$d056f9c7816498b6 = (0, $lCzvA.createContext)($78b54bd991d76db4$var$$97a6ca42802421f7$export$9f4e0787ee8eb98b);
const $78b54bd991d76db4$var$$97a6ca42802421f7$export$64721b56a8912ad6 = ()=>(0, $lCzvA.useContext)($78b54bd991d76db4$var$$97a6ca42802421f7$export$d056f9c7816498b6);
var $78b54bd991d76db4$var$$d3f756ffb036b967$exports = {};
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "backdrop", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$48e901322468f6d5;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$48e901322468f6d5 = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "children", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$bacb5cc5a11aef16;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$bacb5cc5a11aef16 = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "close", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$8360e631d277ea4d;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$8360e631d277ea4d = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "content", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$a7db06668cad9adb;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$a7db06668cad9adb = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "fadeIn", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$82e6205b15e6c637;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$82e6205b15e6c637 = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "fadeOut", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$c091916f1530334c;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$c091916f1530334c = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "header", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$38e42c68cf43b5d4;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$38e42c68cf43b5d4 = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "slideIn", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$d08c54023c399c9c;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$d08c54023c399c9c = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "slideOut", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$388d063d19975bb;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$388d063d19975bb = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "title", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$fb184b623420d9be;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$fb184b623420d9be = v;
});
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$48e901322468f6d5;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$bacb5cc5a11aef16;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$8360e631d277ea4d;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$a7db06668cad9adb;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$82e6205b15e6c637;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$c091916f1530334c;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$38e42c68cf43b5d4;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$d08c54023c399c9c;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$388d063d19975bb;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$fb184b623420d9be;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$48e901322468f6d5 = `fHv5Ia_backdrop`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$bacb5cc5a11aef16 = `fHv5Ia_children`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$8360e631d277ea4d = `fHv5Ia_close`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$a7db06668cad9adb = `fHv5Ia_content`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$82e6205b15e6c637 = `fHv5Ia_fadeIn`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$82e6205b15e6c637;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$c091916f1530334c = `fHv5Ia_fadeOut`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$c091916f1530334c;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$38e42c68cf43b5d4 = `fHv5Ia_header`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$d08c54023c399c9c = `fHv5Ia_slideIn`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$d08c54023c399c9c;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$388d063d19975bb = `fHv5Ia_slideOut`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$388d063d19975bb;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$fb184b623420d9be = `fHv5Ia_title`;
const $78b54bd991d76db4$var$$c6c818cf84aec1f2$export$2b77a92f1a5ad772 = ({ isOpen: isOpen, onClose: onClose, title: title, children: children })=>{
    const [modal, setModal] = (0, $lCzvA.useState)(null);
    const [animations, setAnimations] = (0, $lCzvA.useState)({
        backdrop: '',
        content: ''
    });
    const closeModal = ()=>{
        setAnimations({
            backdrop: 'fadeOut',
            content: 'slideOut'
        });
        setTimeout(()=>{
            onClose();
        }, 350);
    };
    (0, $lCzvA.useEffect)(()=>{
        setAnimations({
            backdrop: 'fadeIn',
            content: 'slideIn'
        });
    }, [
        isOpen
    ]);
    (0, $lCzvA.useEffect)(()=>{
        /** @type {any} */ let portalRoot = document.getElementById('portal') || null;
        if (!portalRoot) {
            portalRoot = document.createElement('div');
            portalRoot.setAttribute('id', 'portal');
            document.body.append(portalRoot);
        }
        /** @type {any} */ const modalDiv = document.createElement('div');
        portalRoot?.append(modalDiv);
        setModal(modalDiv);
        return ()=>{
            portalRoot?.remove(modalDiv);
        };
    }, []);
    if (!modal || !isOpen) return (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {});
    return (0, $dAQd3.createPortal)((0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: `${/*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).backdrop} ${/*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports)[animations.backdrop]}`,
        "data-testid": "modal",
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
            className: `${/*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).content} ${/*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports)[animations.content]}`,
            "data-testid": "modal_content",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: /*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).header,
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            className: /*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).title,
                            children: title
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                            type: "button",
                            className: /*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).close,
                            onClick: closeModal,
                            "data-testid": "modal_close",
                            children: "\u2716"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    className: /*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).children,
                    children: children
                })
            ]
        })
    }), modal);
};
var $78b54bd991d76db4$var$$cc3b2135a65ce9e0$export$2e6c959c16ff56b8;
$78b54bd991d76db4$var$$cc3b2135a65ce9e0$export$2e6c959c16ff56b8 = `YSQfda_select`;
/**
 * Renders a list of cameras for user selection.
 */ const $78b54bd991d76db4$var$$e0259d13009c7fbb$var$CameraSelection = ()=>{
    const { state: { cameras: cameras, selectedCamera: selectedCamera }, dispatch: dispatch } = $78b54bd991d76db4$var$$97a6ca42802421f7$export$64721b56a8912ad6();
    /**
   * Updates + stores the selected camera.
   * @param {import('react').ChangeEvent<HTMLSelectElement>} e
   */ const changeCamera = (e)=>{
        const { value: value } = e.target;
        const camera = cameras.find((cam)=>cam.id === value);
        dispatch({
            type: $78b54bd991d76db4$var$$7aede9e186d82185$export$6910e11b01a25b49,
            payload: camera
        });
        localStorage.setItem('camera_selection', JSON.stringify(camera));
    };
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("label", {
                htmlFor: "cameras",
                children: "Select Camera"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("select", {
                id: "cameras",
                "data-testid": "camera-select",
                className: $78b54bd991d76db4$var$$cc3b2135a65ce9e0$export$2e6c959c16ff56b8,
                onChange: changeCamera,
                value: selectedCamera?.id,
                children: cameras.map(({ id: id, label: label })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                        value: id,
                        children: label
                    }, id))
            })
        ]
    });
};
var $78b54bd991d76db4$var$$e0259d13009c7fbb$export$2e2bcd8739ae039 = $78b54bd991d76db4$var$$e0259d13009c7fbb$var$CameraSelection;
const $78b54bd991d76db4$var$$73ba6d2475d77f64$export$5a60a0f10cd7c33f = [
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).QR_CODE,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).AZTEC,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODABAR,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_39,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_93,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_128,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).DATA_MATRIX,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).MAXICODE,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).ITF,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_13,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_8,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).PDF_417,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_14,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_EXPANDED,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_A,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_E,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_EAN_EXTENSION
];
const $78b54bd991d76db4$var$$73ba6d2475d77f64$export$70cb25e13c857175 = 'reader';
const $78b54bd991d76db4$var$$73ba6d2475d77f64$export$d7405538098bc787 = {
    fps: 20
};
var $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$9d7c7e61b1dce3b0;
var $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$c7ab36ff55199b03;
var $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$8f981dffec84ba52;
var $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f1a76e4a6085c675;
var $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f4c5de44377d2946;
$78b54bd991d76db4$var$$fed7c2b9e91f1421$export$9d7c7e61b1dce3b0 = `rnn3Ia_camera`;
$78b54bd991d76db4$var$$fed7c2b9e91f1421$export$c7ab36ff55199b03 = `rnn3Ia_cameraContainer`;
$78b54bd991d76db4$var$$fed7c2b9e91f1421$export$8f981dffec84ba52 = `rnn3Ia_contentContainer`;
$78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f1a76e4a6085c675 = `rnn3Ia_errorText`;
$78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f4c5de44377d2946 = `rnn3Ia_loader`;
const $78b54bd991d76db4$var$$5d243954a669ce26$export$d74867e90f5dd357 = ()=>{
    const { state: { onScan: onScan, onClose: onClose, isOpen: isOpen, html5QrCode: html5QrCode, cameras: cameras, selectedCamera: selectedCamera }, dispatch: dispatch } = $78b54bd991d76db4$var$$97a6ca42802421f7$export$64721b56a8912ad6();
    const [cameraError, setCameraError] = (0, $lCzvA.useState)(/** @type {string | null} */ null);
    const [loading, setLoading] = (0, $lCzvA.useState)(true);
    /**
   * Stops the camera and scanner.
   */ const stopScanning = (0, $lCzvA.useCallback)(async ()=>{
        try {
            const scanningState = html5QrCode?.getState();
            // Stop the scanner if it's running
            if (scanningState === (0, $82bbb6140bb56c40$export$c90f317190d585a3).SCANNING) await html5QrCode?.stop();
        } catch (error) {
            setCameraError(error.toString());
        }
    }, [
        html5QrCode
    ]);
    /**
   * Starts scanning with the selected camera.
   */ const startScanning = (0, $lCzvA.useCallback)(async ()=>{
        /**
     * Callback when a QR/Bar code is successfully scanned.
     * @type {import('html5-qrcode').QrcodeSuccessCallback}
     */ const scanSuccess = async (decodedText)=>{
            onScan(decodedText.trim());
            try {
                await html5QrCode?.stop();
            } catch (error) {
                setCameraError(error.toString());
            }
        };
        await html5QrCode?.start(String(selectedCamera?.id), $78b54bd991d76db4$var$$73ba6d2475d77f64$export$d7405538098bc787, scanSuccess, undefined);
    }, [
        onScan,
        html5QrCode,
        selectedCamera?.id
    ]);
    /**
   * Stops any running camera and initializes the new selected camera.
   */ const handleCameraChange = (0, $lCzvA.useCallback)(async ()=>{
        if (!selectedCamera || !isOpen) return;
        try {
            await stopScanning();
            await startScanning();
        } catch (error) {
            setCameraError(error.toString());
        } finally{
            setLoading(false);
        }
    }, [
        isOpen,
        selectedCamera,
        startScanning,
        stopScanning
    ]);
    (0, $lCzvA.useEffect)(()=>{
        handleCameraChange();
    }, [
        handleCameraChange
    ]);
    /**
   * Stops any running camera and closes the scanner.
   */ const handleUserClosed = async ()=>{
        await stopScanning();
        onClose();
    };
    (0, $lCzvA.useEffect)(()=>{
        if (isOpen) {
            setLoading(true);
            if (!html5QrCode) dispatch({
                type: $78b54bd991d76db4$var$$7aede9e186d82185$export$18cb8552e15b3d06,
                payload: new (0, $9eb3c467bce0942e$export$e14ced7bffd8eb7a)($78b54bd991d76db4$var$$73ba6d2475d77f64$export$70cb25e13c857175, {
                    formatsToSupport: $78b54bd991d76db4$var$$73ba6d2475d77f64$export$5a60a0f10cd7c33f,
                    verbose: false
                })
            });
        } else setCameraError(null);
        return ()=>{
            stopScanning();
        };
    }, [
        isOpen,
        html5QrCode,
        dispatch,
        stopScanning
    ]);
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($78b54bd991d76db4$var$$c6c818cf84aec1f2$export$2b77a92f1a5ad772, {
        "data-testid": "div-modal",
        isOpen: isOpen,
        onClose: handleUserClosed,
        title: "Scan Barcode",
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
            className: $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$8f981dffec84ba52,
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$c7ab36ff55199b03,
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            id: $78b54bd991d76db4$var$$73ba6d2475d77f64$export$70cb25e13c857175,
                            className: $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$9d7c7e61b1dce3b0
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $6bfaf8085a30c9b5$export$4bf83b24a11cff0b), {
                            visible: loading,
                            height: "50",
                            width: "50",
                            color: "#FFDE00",
                            radius: "9",
                            ariaLabel: "three-dots-loading",
                            wrapperClass: $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f4c5de44377d2946
                        })
                    ]
                }),
                cameraError && (0, $1e1ba35c5b9fc4c3$exports.jsxs)("p", {
                    className: $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f1a76e4a6085c675,
                    children: [
                        "Error: ",
                        cameraError
                    ]
                }),
                Boolean(cameras.length) && selectedCamera && (0, $1e1ba35c5b9fc4c3$exports.jsx)($78b54bd991d76db4$var$$e0259d13009c7fbb$export$2e2bcd8739ae039, {})
            ]
        })
    });
};
const $78b54bd991d76db4$export$52bd0fb4a235289d = ({ children: children })=>{
    const [state, dispatch] = (0, $lCzvA.useReducer)($78b54bd991d76db4$var$$377ebf84863e9293$export$32a09064dc2bfed6, $78b54bd991d76db4$var$$377ebf84863e9293$export$dbd874037937496d);
    const { cameras: cameras } = state;
    /**
   * Fetches the available cameras.
   * Sets the selected camera to back camera if available, otherwise the first camera found.
   */ const getCameras = (0, $lCzvA.useCallback)(async ()=>{
        if (cameras.length) return;
        // get available cameras and set the initial camera
        const devices = await $78b54bd991d76db4$var$$953deebe48519221$export$f2c4ef2d1f0c2e1d();
        const initialCamera = $78b54bd991d76db4$var$$953deebe48519221$export$b2229c0522132a74(devices);
        dispatch({
            type: $78b54bd991d76db4$var$$7aede9e186d82185$export$89dec1050c5f188a,
            payload: devices
        });
        dispatch({
            type: $78b54bd991d76db4$var$$7aede9e186d82185$export$6910e11b01a25b49,
            payload: initialCamera
        });
    }, [
        dispatch,
        cameras.length
    ]);
    /**
   * Exposes the startCamera function to the user.
   */ const startCamera = (0, $lCzvA.useCallback)(/**
     * Starts the camera with combined actions.
     * @type {import('../../types').StartCamera}
     */ (onUserScan, onUserClose)=>{
        /**
       * Combines the user's scan with the internal actions
       * @type {import('../../types').OnScan}
       */ const onScan = (result)=>{
            onUserScan(result);
            dispatch({
                type: $78b54bd991d76db4$var$$7aede9e186d82185$export$e8cea1d59b0c9f14,
                payload: false
            });
        };
        /**
       * Combines the user's close with the internal actions
       */ const onClose = ()=>{
            if (onUserClose) onUserClose();
            dispatch({
                type: $78b54bd991d76db4$var$$7aede9e186d82185$export$e8cea1d59b0c9f14,
                payload: false
            });
        };
        // Trigger camera fetching logic
        getCameras();
        dispatch({
            type: $78b54bd991d76db4$var$$7aede9e186d82185$export$6a5e58c31158ca8,
            payload: {
                onScan: onScan,
                onClose: onClose
            }
        });
    }, [
        dispatch,
        getCameras
    ]);
    // ExternalValues are the ones that are exposed to the user
    // InternalValues are the ones that are strictly to be used internally
    const externalValue = (0, $lCzvA.useMemo)(()=>({
            startCamera: startCamera
        }), [
        startCamera
    ]);
    const internalValue = (0, $lCzvA.useMemo)(()=>({
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)($78b54bd991d76db4$var$$8f4a7e327cfc31fa$export$9dc4ea39af0daa49.Provider, {
        value: externalValue,
        children: [
            children,
            (0, $1e1ba35c5b9fc4c3$exports.jsx)($78b54bd991d76db4$var$$97a6ca42802421f7$export$d056f9c7816498b6.Provider, {
                value: internalValue,
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($78b54bd991d76db4$var$$5d243954a669ce26$export$d74867e90f5dd357, {})
            })
        ]
    });
};


//#region node_modules/tailwind-merge/dist/bundle-mjs.mjs
var $12b9f2ef36f8b3b2$var$e = (e, t)=>{
    let n = Array(e.length + t.length);
    for(let t = 0; t < e.length; t++)n[t] = e[t];
    for(let r = 0; r < t.length; r++)n[e.length + r] = t[r];
    return n;
}, $12b9f2ef36f8b3b2$var$t = (e, t)=>({
        classGroupId: e,
        validator: t
    }), $12b9f2ef36f8b3b2$var$n = (e = /* @__PURE__ */ new Map(), t = null, n)=>({
        nextPart: e,
        validators: t,
        classGroupId: n
    }), $12b9f2ef36f8b3b2$var$r = "-", $12b9f2ef36f8b3b2$var$i = [], $12b9f2ef36f8b3b2$var$a = "arbitrary..", $12b9f2ef36f8b3b2$var$o = (t)=>{
    let n = $12b9f2ef36f8b3b2$var$l(t), { conflictingClassGroups: a, conflictingClassGroupModifiers: o } = t;
    return {
        getClassGroupId: (e)=>{
            if (e.startsWith("[") && e.endsWith("]")) return $12b9f2ef36f8b3b2$var$c(e);
            let t = e.split($12b9f2ef36f8b3b2$var$r);
            return $12b9f2ef36f8b3b2$var$s(t, +(t[0] === "" && t.length > 1), n);
        },
        getConflictingClassGroupIds: (t, n)=>{
            if (n) {
                let n = o[t], r = a[t];
                return n ? r ? $12b9f2ef36f8b3b2$var$e(r, n) : n : r || $12b9f2ef36f8b3b2$var$i;
            }
            return a[t] || $12b9f2ef36f8b3b2$var$i;
        }
    };
}, $12b9f2ef36f8b3b2$var$s = (e, t, n)=>{
    if (e.length - t === 0) return n.classGroupId;
    let i = e[t], a = n.nextPart.get(i);
    if (a) {
        let n = $12b9f2ef36f8b3b2$var$s(e, t + 1, a);
        if (n) return n;
    }
    let o = n.validators;
    if (o === null) return;
    let c = t === 0 ? e.join($12b9f2ef36f8b3b2$var$r) : e.slice(t).join($12b9f2ef36f8b3b2$var$r), l = o.length;
    for(let e = 0; e < l; e++){
        let t = o[e];
        if (t.validator(c)) return t.classGroupId;
    }
}, $12b9f2ef36f8b3b2$var$c = (e)=>e.slice(1, -1).indexOf(":") === -1 ? void 0 : (()=>{
        let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
        return r ? $12b9f2ef36f8b3b2$var$a + r : void 0;
    })(), $12b9f2ef36f8b3b2$var$l = (e)=>{
    let { theme: t, classGroups: n } = e;
    return $12b9f2ef36f8b3b2$var$ee(n, t);
}, $12b9f2ef36f8b3b2$var$ee = (e, t)=>{
    let r = $12b9f2ef36f8b3b2$var$n();
    for(let n in e){
        let i = e[n];
        $12b9f2ef36f8b3b2$var$u(i, r, n, t);
    }
    return r;
}, $12b9f2ef36f8b3b2$var$u = (e, t, n, r)=>{
    let i = e.length;
    for(let a = 0; a < i; a++){
        let i = e[a];
        $12b9f2ef36f8b3b2$var$te(i, t, n, r);
    }
}, $12b9f2ef36f8b3b2$var$te = (e, t, n, r)=>{
    if (typeof e == "string") {
        $12b9f2ef36f8b3b2$var$d(e, t, n);
        return;
    }
    if (typeof e == "function") {
        $12b9f2ef36f8b3b2$var$f(e, t, n, r);
        return;
    }
    $12b9f2ef36f8b3b2$var$p(e, t, n, r);
}, $12b9f2ef36f8b3b2$var$d = (e, t, n)=>{
    let r = e === "" ? t : $12b9f2ef36f8b3b2$var$m(t, e);
    r.classGroupId = n;
}, $12b9f2ef36f8b3b2$var$f = (e, n, r, i)=>{
    if ($12b9f2ef36f8b3b2$var$h(e)) {
        $12b9f2ef36f8b3b2$var$u(e(i), n, r, i);
        return;
    }
    n.validators === null && (n.validators = []), n.validators.push($12b9f2ef36f8b3b2$var$t(r, e));
}, $12b9f2ef36f8b3b2$var$p = (e, t, n, r)=>{
    let i = Object.entries(e), a = i.length;
    for(let e = 0; e < a; e++){
        let [a, o] = i[e];
        $12b9f2ef36f8b3b2$var$u(o, $12b9f2ef36f8b3b2$var$m(t, a), n, r);
    }
}, $12b9f2ef36f8b3b2$var$m = (e, t)=>{
    let i = e, a = t.split($12b9f2ef36f8b3b2$var$r), o = a.length;
    for(let e = 0; e < o; e++){
        let t = a[e], r = i.nextPart.get(t);
        r || (r = $12b9f2ef36f8b3b2$var$n(), i.nextPart.set(t, r)), i = r;
    }
    return i;
}, $12b9f2ef36f8b3b2$var$h = (e)=>"isThemeGetter" in e && e.isThemeGetter === !0, $12b9f2ef36f8b3b2$var$ne = (e)=>{
    if (e < 1) return {
        get: ()=>void 0,
        set: ()=>{}
    };
    let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a)=>{
        n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
    };
    return {
        get (e) {
            let t = n[e];
            if (t !== void 0) return t;
            if ((t = r[e]) !== void 0) return i(e, t), t;
        },
        set (e, t) {
            e in n ? n[e] = t : i(e, t);
        }
    };
}, $12b9f2ef36f8b3b2$var$g = "!", $12b9f2ef36f8b3b2$var$_ = ":", $12b9f2ef36f8b3b2$var$v = [], $12b9f2ef36f8b3b2$var$y = (e, t, n, r, i)=>({
        modifiers: e,
        hasImportantModifier: t,
        baseClassName: n,
        maybePostfixModifierPosition: r,
        isExternal: i
    }), $12b9f2ef36f8b3b2$var$b = (e)=>{
    let { prefix: t, experimentalParseClassName: n } = e, r = (e)=>{
        let t = [], n = 0, r = 0, i = 0, a, o = e.length;
        for(let s = 0; s < o; s++){
            let o = e[s];
            if (n === 0 && r === 0) {
                if (o === $12b9f2ef36f8b3b2$var$_) {
                    t.push(e.slice(i, s)), i = s + 1;
                    continue;
                }
                if (o === "/") {
                    a = s;
                    continue;
                }
            }
            o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
        }
        let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
        s.endsWith($12b9f2ef36f8b3b2$var$g) ? (c = s.slice(0, -1), l = !0) : s.startsWith($12b9f2ef36f8b3b2$var$g) && (c = s.slice(1), l = !0);
        let ee = a && a > i ? a - i : void 0;
        return $12b9f2ef36f8b3b2$var$y(t, l, c, ee);
    };
    if (t) {
        let e = t + $12b9f2ef36f8b3b2$var$_, n = r;
        r = (t)=>t.startsWith(e) ? n(t.slice(e.length)) : $12b9f2ef36f8b3b2$var$y($12b9f2ef36f8b3b2$var$v, !1, t, void 0, !0);
    }
    if (n) {
        let e = r;
        r = (t)=>n({
                className: t,
                parseClassName: e
            });
    }
    return r;
}, $12b9f2ef36f8b3b2$var$x = (e)=>{
    let t = /* @__PURE__ */ new Map();
    return e.orderSensitiveModifiers.forEach((e, n)=>{
        t.set(e, 1e6 + n);
    }), (e)=>{
        let n = [], r = [];
        for(let i = 0; i < e.length; i++){
            let a = e[i], o = a[0] === "[", s = t.has(a);
            o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
        }
        return r.length > 0 && (r.sort(), n.push(...r)), n;
    };
}, $12b9f2ef36f8b3b2$var$S = (e)=>({
        cache: $12b9f2ef36f8b3b2$var$ne(e.cacheSize),
        parseClassName: $12b9f2ef36f8b3b2$var$b(e),
        sortModifiers: $12b9f2ef36f8b3b2$var$x(e),
        postfixLookupClassGroupIds: $12b9f2ef36f8b3b2$var$re(e),
        ...$12b9f2ef36f8b3b2$var$o(e)
    }), $12b9f2ef36f8b3b2$var$re = (e)=>{
    let t = Object.create(null), n = e.postfixLookupClassGroups;
    if (n) for(let e = 0; e < n.length; e++)t[n[e]] = !0;
    return t;
}, $12b9f2ef36f8b3b2$var$ie = /\s+/, $12b9f2ef36f8b3b2$var$C = (e, t)=>{
    let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split($12b9f2ef36f8b3b2$var$ie), l = "";
    for(let e = c.length - 1; e >= 0; --e){
        let t = c[e], { isExternal: ee, modifiers: u, hasImportantModifier: te, baseClassName: d, maybePostfixModifierPosition: f } = n(t);
        if (ee) {
            l = t + (l.length > 0 ? " " + l : l);
            continue;
        }
        let p = !!f, m;
        if (p) {
            m = r(d.substring(0, f));
            let e = m && o[m] ? r(d) : void 0;
            e && e !== m && (m = e, p = !1);
        } else m = r(d);
        if (!m) {
            if (!p) {
                l = t + (l.length > 0 ? " " + l : l);
                continue;
            }
            if (m = r(d), !m) {
                l = t + (l.length > 0 ? " " + l : l);
                continue;
            }
            p = !1;
        }
        let h = u.length === 0 ? "" : u.length === 1 ? u[0] : a(u).join(":"), ne = te ? h + $12b9f2ef36f8b3b2$var$g : h, _ = ne + m;
        if (s.indexOf(_) > -1) continue;
        s.push(_);
        let v = i(m, p);
        for(let e = 0; e < v.length; ++e){
            let t = v[e];
            s.push(ne + t);
        }
        l = t + (l.length > 0 ? " " + l : l);
    }
    return l;
}, $12b9f2ef36f8b3b2$export$a8bbfb445e1f163f = (...e)=>{
    let t = 0, n, r, i = "";
    for(; t < e.length;)(n = e[t++]) && (r = $12b9f2ef36f8b3b2$var$T(n)) && (i && (i += " "), i += r);
    return i;
}, $12b9f2ef36f8b3b2$var$T = (e)=>{
    if (typeof e == "string") return e;
    let t, n = "";
    for(let r = 0; r < e.length; r++)e[r] && (t = $12b9f2ef36f8b3b2$var$T(e[r])) && (n && (n += " "), n += t);
    return n;
}, $12b9f2ef36f8b3b2$export$ea2d4fba4d1bd27f = (e, ...t)=>{
    let n, r, i, a, o = (o)=>(n = $12b9f2ef36f8b3b2$var$S(t.reduce((e, t)=>t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e)=>{
        let t = r(e);
        if (t) return t;
        let a = $12b9f2ef36f8b3b2$var$C(e, n);
        return i(e, a), a;
    };
    return a = o, (...e)=>a($12b9f2ef36f8b3b2$export$a8bbfb445e1f163f(...e));
}, $12b9f2ef36f8b3b2$var$D = [], $12b9f2ef36f8b3b2$export$e176af7b8eefe933 = (e)=>{
    let t = (t)=>t[e] || $12b9f2ef36f8b3b2$var$D;
    return t.isThemeGetter = !0, t;
}, $12b9f2ef36f8b3b2$var$k = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, $12b9f2ef36f8b3b2$var$A = /^\((?:(\w[\w-]*):)?(.+)\)$/i, $12b9f2ef36f8b3b2$var$j = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, $12b9f2ef36f8b3b2$var$M = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, $12b9f2ef36f8b3b2$var$ae = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, $12b9f2ef36f8b3b2$var$oe = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, $12b9f2ef36f8b3b2$var$se = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, $12b9f2ef36f8b3b2$var$N = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, $12b9f2ef36f8b3b2$var$P = (e)=>$12b9f2ef36f8b3b2$var$j.test(e), $12b9f2ef36f8b3b2$var$F = (e)=>!!e && !Number.isNaN(Number(e)), $12b9f2ef36f8b3b2$var$I = (e)=>!!e && Number.isInteger(Number(e)), $12b9f2ef36f8b3b2$var$ce = (e)=>e.endsWith("%") && $12b9f2ef36f8b3b2$var$F(e.slice(0, -1)), $12b9f2ef36f8b3b2$var$L = (e)=>$12b9f2ef36f8b3b2$var$M.test(e), $12b9f2ef36f8b3b2$var$le = ()=>!0, $12b9f2ef36f8b3b2$var$R = (e)=>$12b9f2ef36f8b3b2$var$ae.test(e) && !$12b9f2ef36f8b3b2$var$oe.test(e), $12b9f2ef36f8b3b2$var$z = ()=>!1, $12b9f2ef36f8b3b2$var$B = (e)=>$12b9f2ef36f8b3b2$var$se.test(e), $12b9f2ef36f8b3b2$var$ue = (e)=>$12b9f2ef36f8b3b2$var$N.test(e), $12b9f2ef36f8b3b2$var$de = (e)=>!$12b9f2ef36f8b3b2$var$V(e) && !$12b9f2ef36f8b3b2$var$W(e), $12b9f2ef36f8b3b2$var$fe = (e)=>e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), $12b9f2ef36f8b3b2$var$pe = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$Z, $12b9f2ef36f8b3b2$var$z), $12b9f2ef36f8b3b2$var$V = (e)=>$12b9f2ef36f8b3b2$var$k.test(e), $12b9f2ef36f8b3b2$var$H = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$Q, $12b9f2ef36f8b3b2$var$R), $12b9f2ef36f8b3b2$var$me = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$we, $12b9f2ef36f8b3b2$var$F), $12b9f2ef36f8b3b2$var$he = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$Ee, $12b9f2ef36f8b3b2$var$le), $12b9f2ef36f8b3b2$var$ge = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$Te, $12b9f2ef36f8b3b2$var$z), $12b9f2ef36f8b3b2$var$_e = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$Y, $12b9f2ef36f8b3b2$var$z), $12b9f2ef36f8b3b2$var$ve = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$X, $12b9f2ef36f8b3b2$var$ue), $12b9f2ef36f8b3b2$var$U = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$De, $12b9f2ef36f8b3b2$var$B), $12b9f2ef36f8b3b2$var$W = (e)=>$12b9f2ef36f8b3b2$var$A.test(e), $12b9f2ef36f8b3b2$var$G = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$Q), $12b9f2ef36f8b3b2$var$ye = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$Te), $12b9f2ef36f8b3b2$var$be = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$Y), $12b9f2ef36f8b3b2$var$xe = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$Z), $12b9f2ef36f8b3b2$var$Se = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$X), $12b9f2ef36f8b3b2$var$K = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$De, !0), $12b9f2ef36f8b3b2$var$Ce = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$Ee, !0), $12b9f2ef36f8b3b2$var$q = (e, t, n)=>{
    let r = $12b9f2ef36f8b3b2$var$k.exec(e);
    return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, $12b9f2ef36f8b3b2$var$J = (e, t, n = !1)=>{
    let r = $12b9f2ef36f8b3b2$var$A.exec(e);
    return r ? r[1] ? t(r[1]) : n : !1;
}, $12b9f2ef36f8b3b2$var$Y = (e)=>e === "position" || e === "percentage", $12b9f2ef36f8b3b2$var$X = (e)=>e === "image" || e === "url", $12b9f2ef36f8b3b2$var$Z = (e)=>e === "length" || e === "size" || e === "bg-size", $12b9f2ef36f8b3b2$var$Q = (e)=>e === "length", $12b9f2ef36f8b3b2$var$we = (e)=>e === "number", $12b9f2ef36f8b3b2$var$Te = (e)=>e === "family-name", $12b9f2ef36f8b3b2$var$Ee = (e)=>e === "number" || e === "weight", $12b9f2ef36f8b3b2$var$De = (e)=>e === "shadow", $12b9f2ef36f8b3b2$export$ed30944e0fe6ae5c = ()=>{
    let e = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("color"), t = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("font"), n = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("text"), r = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("font-weight"), i = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("tracking"), a = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("leading"), o = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("breakpoint"), s = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("container"), c = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("spacing"), l = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("radius"), ee = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("shadow"), u = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("inset-shadow"), te = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("text-shadow"), d = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("drop-shadow"), f = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("blur"), p = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("perspective"), m = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("aspect"), h = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("ease"), ne = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("animate"), g = ()=>[
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ], _ = ()=>[
            "center",
            "top",
            "bottom",
            "left",
            "right",
            "top-left",
            "left-top",
            "top-right",
            "right-top",
            "bottom-right",
            "right-bottom",
            "bottom-left",
            "left-bottom"
        ], v = ()=>[
            ..._(),
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], y = ()=>[
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ], b = ()=>[
            "auto",
            "contain",
            "none"
        ], x = ()=>[
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V,
            c
        ], S = ()=>[
            $12b9f2ef36f8b3b2$var$P,
            "full",
            "auto",
            ...x()
        ], re = ()=>[
            $12b9f2ef36f8b3b2$var$I,
            "none",
            "subgrid",
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], ie = ()=>[
            "auto",
            {
                span: [
                    "full",
                    $12b9f2ef36f8b3b2$var$I,
                    $12b9f2ef36f8b3b2$var$W,
                    $12b9f2ef36f8b3b2$var$V
                ]
            },
            $12b9f2ef36f8b3b2$var$I,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], C = ()=>[
            $12b9f2ef36f8b3b2$var$I,
            "auto",
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], w = ()=>[
            "auto",
            "min",
            "max",
            "fr",
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], T = ()=>[
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch",
            "baseline",
            "center-safe",
            "end-safe"
        ], E = ()=>[
            "start",
            "end",
            "center",
            "stretch",
            "center-safe",
            "end-safe"
        ], D = ()=>[
            "auto",
            ...x()
        ], k = ()=>[
            $12b9f2ef36f8b3b2$var$P,
            "auto",
            "full",
            "dvw",
            "dvh",
            "lvw",
            "lvh",
            "svw",
            "svh",
            "min",
            "max",
            "fit",
            ...x()
        ], A = ()=>[
            $12b9f2ef36f8b3b2$var$P,
            "screen",
            "full",
            "dvw",
            "lvw",
            "svw",
            "min",
            "max",
            "fit",
            ...x()
        ], j = ()=>[
            $12b9f2ef36f8b3b2$var$P,
            "screen",
            "full",
            "lh",
            "dvh",
            "lvh",
            "svh",
            "min",
            "max",
            "fit",
            ...x()
        ], M = ()=>[
            e,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], ae = ()=>[
            ..._(),
            $12b9f2ef36f8b3b2$var$be,
            $12b9f2ef36f8b3b2$var$_e,
            {
                position: [
                    $12b9f2ef36f8b3b2$var$W,
                    $12b9f2ef36f8b3b2$var$V
                ]
            }
        ], oe = ()=>[
            "no-repeat",
            {
                repeat: [
                    "",
                    "x",
                    "y",
                    "space",
                    "round"
                ]
            }
        ], se = ()=>[
            "auto",
            "cover",
            "contain",
            $12b9f2ef36f8b3b2$var$xe,
            $12b9f2ef36f8b3b2$var$pe,
            {
                size: [
                    $12b9f2ef36f8b3b2$var$W,
                    $12b9f2ef36f8b3b2$var$V
                ]
            }
        ], N = ()=>[
            $12b9f2ef36f8b3b2$var$ce,
            $12b9f2ef36f8b3b2$var$G,
            $12b9f2ef36f8b3b2$var$H
        ], R = ()=>[
            "",
            "none",
            "full",
            l,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], z = ()=>[
            "",
            $12b9f2ef36f8b3b2$var$F,
            $12b9f2ef36f8b3b2$var$G,
            $12b9f2ef36f8b3b2$var$H
        ], B = ()=>[
            "solid",
            "dashed",
            "dotted",
            "double"
        ], ue = ()=>[
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
        ], q = ()=>[
            $12b9f2ef36f8b3b2$var$F,
            $12b9f2ef36f8b3b2$var$ce,
            $12b9f2ef36f8b3b2$var$be,
            $12b9f2ef36f8b3b2$var$_e
        ], J = ()=>[
            "",
            "none",
            f,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], Y = ()=>[
            "none",
            $12b9f2ef36f8b3b2$var$F,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], X = ()=>[
            "none",
            $12b9f2ef36f8b3b2$var$F,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], Z = ()=>[
            $12b9f2ef36f8b3b2$var$F,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], Q = ()=>[
            $12b9f2ef36f8b3b2$var$P,
            "full",
            ...x()
        ];
    return {
        cacheSize: 500,
        theme: {
            animate: [
                "spin",
                "ping",
                "pulse",
                "bounce"
            ],
            aspect: [
                "video"
            ],
            blur: [
                $12b9f2ef36f8b3b2$var$L
            ],
            breakpoint: [
                $12b9f2ef36f8b3b2$var$L
            ],
            color: [
                $12b9f2ef36f8b3b2$var$le
            ],
            container: [
                $12b9f2ef36f8b3b2$var$L
            ],
            "drop-shadow": [
                $12b9f2ef36f8b3b2$var$L
            ],
            ease: [
                "in",
                "out",
                "in-out"
            ],
            font: [
                $12b9f2ef36f8b3b2$var$de
            ],
            "font-weight": [
                "thin",
                "extralight",
                "light",
                "normal",
                "medium",
                "semibold",
                "bold",
                "extrabold",
                "black"
            ],
            "inset-shadow": [
                $12b9f2ef36f8b3b2$var$L
            ],
            leading: [
                "none",
                "tight",
                "snug",
                "normal",
                "relaxed",
                "loose"
            ],
            perspective: [
                "dramatic",
                "near",
                "normal",
                "midrange",
                "distant",
                "none"
            ],
            radius: [
                $12b9f2ef36f8b3b2$var$L
            ],
            shadow: [
                $12b9f2ef36f8b3b2$var$L
            ],
            spacing: [
                "px",
                $12b9f2ef36f8b3b2$var$F
            ],
            text: [
                $12b9f2ef36f8b3b2$var$L
            ],
            "text-shadow": [
                $12b9f2ef36f8b3b2$var$L
            ],
            tracking: [
                "tighter",
                "tight",
                "normal",
                "wide",
                "wider",
                "widest"
            ]
        },
        classGroups: {
            aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        $12b9f2ef36f8b3b2$var$P,
                        $12b9f2ef36f8b3b2$var$V,
                        $12b9f2ef36f8b3b2$var$W,
                        m
                    ]
                }
            ],
            container: [
                "container"
            ],
            "container-type": [
                {
                    "@container": [
                        "",
                        "normal",
                        "size",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "container-named": [
                $12b9f2ef36f8b3b2$var$fe
            ],
            columns: [
                {
                    columns: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$V,
                        $12b9f2ef36f8b3b2$var$W,
                        s
                    ]
                }
            ],
            "break-after": [
                {
                    "break-after": g()
                }
            ],
            "break-before": [
                {
                    "break-before": g()
                }
            ],
            "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            sr: [
                "sr-only",
                "not-sr-only"
            ],
            float: [
                {
                    float: [
                        "right",
                        "left",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            isolation: [
                "isolate",
                "isolation-auto"
            ],
            "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            "object-position": [
                {
                    object: v()
                }
            ],
            overflow: [
                {
                    overflow: y()
                }
            ],
            "overflow-x": [
                {
                    "overflow-x": y()
                }
            ],
            "overflow-y": [
                {
                    "overflow-y": y()
                }
            ],
            overscroll: [
                {
                    overscroll: b()
                }
            ],
            "overscroll-x": [
                {
                    "overscroll-x": b()
                }
            ],
            "overscroll-y": [
                {
                    "overscroll-y": b()
                }
            ],
            position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            inset: [
                {
                    inset: S()
                }
            ],
            "inset-x": [
                {
                    "inset-x": S()
                }
            ],
            "inset-y": [
                {
                    "inset-y": S()
                }
            ],
            start: [
                {
                    "inset-s": S(),
                    start: S()
                }
            ],
            end: [
                {
                    "inset-e": S(),
                    end: S()
                }
            ],
            "inset-bs": [
                {
                    "inset-bs": S()
                }
            ],
            "inset-be": [
                {
                    "inset-be": S()
                }
            ],
            top: [
                {
                    top: S()
                }
            ],
            right: [
                {
                    right: S()
                }
            ],
            bottom: [
                {
                    bottom: S()
                }
            ],
            left: [
                {
                    left: S()
                }
            ],
            visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            z: [
                {
                    z: [
                        $12b9f2ef36f8b3b2$var$I,
                        "auto",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            basis: [
                {
                    basis: [
                        $12b9f2ef36f8b3b2$var$P,
                        "full",
                        "auto",
                        s,
                        ...x()
                    ]
                }
            ],
            "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            "flex-wrap": [
                {
                    flex: [
                        "nowrap",
                        "wrap",
                        "wrap-reverse"
                    ]
                }
            ],
            flex: [
                {
                    flex: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$P,
                        "auto",
                        "initial",
                        "none",
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            grow: [
                {
                    grow: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            shrink: [
                {
                    shrink: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            order: [
                {
                    order: [
                        $12b9f2ef36f8b3b2$var$I,
                        "first",
                        "last",
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "grid-cols": [
                {
                    "grid-cols": re()
                }
            ],
            "col-start-end": [
                {
                    col: ie()
                }
            ],
            "col-start": [
                {
                    "col-start": C()
                }
            ],
            "col-end": [
                {
                    "col-end": C()
                }
            ],
            "grid-rows": [
                {
                    "grid-rows": re()
                }
            ],
            "row-start-end": [
                {
                    row: ie()
                }
            ],
            "row-start": [
                {
                    "row-start": C()
                }
            ],
            "row-end": [
                {
                    "row-end": C()
                }
            ],
            "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            "auto-cols": [
                {
                    "auto-cols": w()
                }
            ],
            "auto-rows": [
                {
                    "auto-rows": w()
                }
            ],
            gap: [
                {
                    gap: x()
                }
            ],
            "gap-x": [
                {
                    "gap-x": x()
                }
            ],
            "gap-y": [
                {
                    "gap-y": x()
                }
            ],
            "justify-content": [
                {
                    justify: [
                        ...T(),
                        "normal"
                    ]
                }
            ],
            "justify-items": [
                {
                    "justify-items": [
                        ...E(),
                        "normal"
                    ]
                }
            ],
            "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        ...E()
                    ]
                }
            ],
            "align-content": [
                {
                    content: [
                        "normal",
                        ...T()
                    ]
                }
            ],
            "align-items": [
                {
                    items: [
                        ...E(),
                        {
                            baseline: [
                                "",
                                "last"
                            ]
                        }
                    ]
                }
            ],
            "align-self": [
                {
                    self: [
                        "auto",
                        ...E(),
                        {
                            baseline: [
                                "",
                                "last"
                            ]
                        }
                    ]
                }
            ],
            "place-content": [
                {
                    "place-content": T()
                }
            ],
            "place-items": [
                {
                    "place-items": [
                        ...E(),
                        "baseline"
                    ]
                }
            ],
            "place-self": [
                {
                    "place-self": [
                        "auto",
                        ...E()
                    ]
                }
            ],
            p: [
                {
                    p: x()
                }
            ],
            px: [
                {
                    px: x()
                }
            ],
            py: [
                {
                    py: x()
                }
            ],
            ps: [
                {
                    ps: x()
                }
            ],
            pe: [
                {
                    pe: x()
                }
            ],
            pbs: [
                {
                    pbs: x()
                }
            ],
            pbe: [
                {
                    pbe: x()
                }
            ],
            pt: [
                {
                    pt: x()
                }
            ],
            pr: [
                {
                    pr: x()
                }
            ],
            pb: [
                {
                    pb: x()
                }
            ],
            pl: [
                {
                    pl: x()
                }
            ],
            m: [
                {
                    m: D()
                }
            ],
            mx: [
                {
                    mx: D()
                }
            ],
            my: [
                {
                    my: D()
                }
            ],
            ms: [
                {
                    ms: D()
                }
            ],
            me: [
                {
                    me: D()
                }
            ],
            mbs: [
                {
                    mbs: D()
                }
            ],
            mbe: [
                {
                    mbe: D()
                }
            ],
            mt: [
                {
                    mt: D()
                }
            ],
            mr: [
                {
                    mr: D()
                }
            ],
            mb: [
                {
                    mb: D()
                }
            ],
            ml: [
                {
                    ml: D()
                }
            ],
            "space-x": [
                {
                    "space-x": x()
                }
            ],
            "space-x-reverse": [
                "space-x-reverse"
            ],
            "space-y": [
                {
                    "space-y": x()
                }
            ],
            "space-y-reverse": [
                "space-y-reverse"
            ],
            size: [
                {
                    size: k()
                }
            ],
            "inline-size": [
                {
                    inline: [
                        "auto",
                        ...A()
                    ]
                }
            ],
            "min-inline-size": [
                {
                    "min-inline": [
                        "auto",
                        ...A()
                    ]
                }
            ],
            "max-inline-size": [
                {
                    "max-inline": [
                        "none",
                        ...A()
                    ]
                }
            ],
            "block-size": [
                {
                    block: [
                        "auto",
                        ...j()
                    ]
                }
            ],
            "min-block-size": [
                {
                    "min-block": [
                        "auto",
                        ...j()
                    ]
                }
            ],
            "max-block-size": [
                {
                    "max-block": [
                        "none",
                        ...j()
                    ]
                }
            ],
            w: [
                {
                    w: [
                        s,
                        "screen",
                        ...k()
                    ]
                }
            ],
            "min-w": [
                {
                    "min-w": [
                        s,
                        "screen",
                        "none",
                        ...k()
                    ]
                }
            ],
            "max-w": [
                {
                    "max-w": [
                        s,
                        "screen",
                        "none",
                        "prose",
                        {
                            screen: [
                                o
                            ]
                        },
                        ...k()
                    ]
                }
            ],
            h: [
                {
                    h: [
                        "screen",
                        "lh",
                        ...k()
                    ]
                }
            ],
            "min-h": [
                {
                    "min-h": [
                        "screen",
                        "lh",
                        "none",
                        ...k()
                    ]
                }
            ],
            "max-h": [
                {
                    "max-h": [
                        "screen",
                        "lh",
                        ...k()
                    ]
                }
            ],
            "font-size": [
                {
                    text: [
                        "base",
                        n,
                        $12b9f2ef36f8b3b2$var$G,
                        $12b9f2ef36f8b3b2$var$H
                    ]
                }
            ],
            "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            "font-style": [
                "italic",
                "not-italic"
            ],
            "font-weight": [
                {
                    font: [
                        r,
                        $12b9f2ef36f8b3b2$var$Ce,
                        $12b9f2ef36f8b3b2$var$he
                    ]
                }
            ],
            "font-stretch": [
                {
                    "font-stretch": [
                        "ultra-condensed",
                        "extra-condensed",
                        "condensed",
                        "semi-condensed",
                        "normal",
                        "semi-expanded",
                        "expanded",
                        "extra-expanded",
                        "ultra-expanded",
                        $12b9f2ef36f8b3b2$var$ce,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "font-family": [
                {
                    font: [
                        $12b9f2ef36f8b3b2$var$ye,
                        $12b9f2ef36f8b3b2$var$ge,
                        t
                    ]
                }
            ],
            "font-features": [
                {
                    "font-features": [
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "fvn-normal": [
                "normal-nums"
            ],
            "fvn-ordinal": [
                "ordinal"
            ],
            "fvn-slashed-zero": [
                "slashed-zero"
            ],
            "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractions"
            ],
            tracking: [
                {
                    tracking: [
                        i,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "line-clamp": [
                {
                    "line-clamp": [
                        $12b9f2ef36f8b3b2$var$F,
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$me
                    ]
                }
            ],
            leading: [
                {
                    leading: [
                        a,
                        ...x()
                    ]
                }
            ],
            "list-image": [
                {
                    "list-image": [
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            "list-style-type": [
                {
                    list: [
                        "disc",
                        "decimal",
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            "placeholder-color": [
                {
                    placeholder: M()
                }
            ],
            "text-color": [
                {
                    text: M()
                }
            ],
            "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            "text-decoration-style": [
                {
                    decoration: [
                        ...B(),
                        "wavy"
                    ]
                }
            ],
            "text-decoration-thickness": [
                {
                    decoration: [
                        $12b9f2ef36f8b3b2$var$F,
                        "from-font",
                        "auto",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$H
                    ]
                }
            ],
            "text-decoration-color": [
                {
                    decoration: M()
                }
            ],
            "underline-offset": [
                {
                    "underline-offset": [
                        $12b9f2ef36f8b3b2$var$F,
                        "auto",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            "text-wrap": [
                {
                    text: [
                        "wrap",
                        "nowrap",
                        "balance",
                        "pretty"
                    ]
                }
            ],
            indent: [
                {
                    indent: x()
                }
            ],
            "tab-size": [
                {
                    tab: [
                        $12b9f2ef36f8b3b2$var$I,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            break: [
                {
                    break: [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            wrap: [
                {
                    wrap: [
                        "break-word",
                        "anywhere",
                        "normal"
                    ]
                }
            ],
            hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            content: [
                {
                    content: [
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            "bg-position": [
                {
                    bg: ae()
                }
            ],
            "bg-repeat": [
                {
                    bg: oe()
                }
            ],
            "bg-size": [
                {
                    bg: se()
                }
            ],
            "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            linear: [
                                {
                                    to: [
                                        "t",
                                        "tr",
                                        "r",
                                        "br",
                                        "b",
                                        "bl",
                                        "l",
                                        "tl"
                                    ]
                                },
                                $12b9f2ef36f8b3b2$var$I,
                                $12b9f2ef36f8b3b2$var$W,
                                $12b9f2ef36f8b3b2$var$V
                            ],
                            radial: [
                                "",
                                $12b9f2ef36f8b3b2$var$W,
                                $12b9f2ef36f8b3b2$var$V
                            ],
                            conic: [
                                $12b9f2ef36f8b3b2$var$I,
                                $12b9f2ef36f8b3b2$var$W,
                                $12b9f2ef36f8b3b2$var$V
                            ]
                        },
                        $12b9f2ef36f8b3b2$var$Se,
                        $12b9f2ef36f8b3b2$var$ve
                    ]
                }
            ],
            "bg-color": [
                {
                    bg: M()
                }
            ],
            "gradient-from-pos": [
                {
                    from: N()
                }
            ],
            "gradient-via-pos": [
                {
                    via: N()
                }
            ],
            "gradient-to-pos": [
                {
                    to: N()
                }
            ],
            "gradient-from": [
                {
                    from: M()
                }
            ],
            "gradient-via": [
                {
                    via: M()
                }
            ],
            "gradient-to": [
                {
                    to: M()
                }
            ],
            rounded: [
                {
                    rounded: R()
                }
            ],
            "rounded-s": [
                {
                    "rounded-s": R()
                }
            ],
            "rounded-e": [
                {
                    "rounded-e": R()
                }
            ],
            "rounded-t": [
                {
                    "rounded-t": R()
                }
            ],
            "rounded-r": [
                {
                    "rounded-r": R()
                }
            ],
            "rounded-b": [
                {
                    "rounded-b": R()
                }
            ],
            "rounded-l": [
                {
                    "rounded-l": R()
                }
            ],
            "rounded-ss": [
                {
                    "rounded-ss": R()
                }
            ],
            "rounded-se": [
                {
                    "rounded-se": R()
                }
            ],
            "rounded-ee": [
                {
                    "rounded-ee": R()
                }
            ],
            "rounded-es": [
                {
                    "rounded-es": R()
                }
            ],
            "rounded-tl": [
                {
                    "rounded-tl": R()
                }
            ],
            "rounded-tr": [
                {
                    "rounded-tr": R()
                }
            ],
            "rounded-br": [
                {
                    "rounded-br": R()
                }
            ],
            "rounded-bl": [
                {
                    "rounded-bl": R()
                }
            ],
            "border-w": [
                {
                    border: z()
                }
            ],
            "border-w-x": [
                {
                    "border-x": z()
                }
            ],
            "border-w-y": [
                {
                    "border-y": z()
                }
            ],
            "border-w-s": [
                {
                    "border-s": z()
                }
            ],
            "border-w-e": [
                {
                    "border-e": z()
                }
            ],
            "border-w-bs": [
                {
                    "border-bs": z()
                }
            ],
            "border-w-be": [
                {
                    "border-be": z()
                }
            ],
            "border-w-t": [
                {
                    "border-t": z()
                }
            ],
            "border-w-r": [
                {
                    "border-r": z()
                }
            ],
            "border-w-b": [
                {
                    "border-b": z()
                }
            ],
            "border-w-l": [
                {
                    "border-l": z()
                }
            ],
            "divide-x": [
                {
                    "divide-x": z()
                }
            ],
            "divide-x-reverse": [
                "divide-x-reverse"
            ],
            "divide-y": [
                {
                    "divide-y": z()
                }
            ],
            "divide-y-reverse": [
                "divide-y-reverse"
            ],
            "border-style": [
                {
                    border: [
                        ...B(),
                        "hidden",
                        "none"
                    ]
                }
            ],
            "divide-style": [
                {
                    divide: [
                        ...B(),
                        "hidden",
                        "none"
                    ]
                }
            ],
            "border-color": [
                {
                    border: M()
                }
            ],
            "border-color-x": [
                {
                    "border-x": M()
                }
            ],
            "border-color-y": [
                {
                    "border-y": M()
                }
            ],
            "border-color-s": [
                {
                    "border-s": M()
                }
            ],
            "border-color-e": [
                {
                    "border-e": M()
                }
            ],
            "border-color-bs": [
                {
                    "border-bs": M()
                }
            ],
            "border-color-be": [
                {
                    "border-be": M()
                }
            ],
            "border-color-t": [
                {
                    "border-t": M()
                }
            ],
            "border-color-r": [
                {
                    "border-r": M()
                }
            ],
            "border-color-b": [
                {
                    "border-b": M()
                }
            ],
            "border-color-l": [
                {
                    "border-l": M()
                }
            ],
            "divide-color": [
                {
                    divide: M()
                }
            ],
            "outline-style": [
                {
                    outline: [
                        ...B(),
                        "none",
                        "hidden"
                    ]
                }
            ],
            "outline-offset": [
                {
                    "outline-offset": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "outline-w": [
                {
                    outline: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$G,
                        $12b9f2ef36f8b3b2$var$H
                    ]
                }
            ],
            "outline-color": [
                {
                    outline: M()
                }
            ],
            shadow: [
                {
                    shadow: [
                        "",
                        "none",
                        ee,
                        $12b9f2ef36f8b3b2$var$K,
                        $12b9f2ef36f8b3b2$var$U
                    ]
                }
            ],
            "shadow-color": [
                {
                    shadow: M()
                }
            ],
            "inset-shadow": [
                {
                    "inset-shadow": [
                        "none",
                        u,
                        $12b9f2ef36f8b3b2$var$K,
                        $12b9f2ef36f8b3b2$var$U
                    ]
                }
            ],
            "inset-shadow-color": [
                {
                    "inset-shadow": M()
                }
            ],
            "ring-w": [
                {
                    ring: z()
                }
            ],
            "ring-w-inset": [
                "ring-inset"
            ],
            "ring-color": [
                {
                    ring: M()
                }
            ],
            "ring-offset-w": [
                {
                    "ring-offset": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$H
                    ]
                }
            ],
            "ring-offset-color": [
                {
                    "ring-offset": M()
                }
            ],
            "inset-ring-w": [
                {
                    "inset-ring": z()
                }
            ],
            "inset-ring-color": [
                {
                    "inset-ring": M()
                }
            ],
            "text-shadow": [
                {
                    "text-shadow": [
                        "none",
                        te,
                        $12b9f2ef36f8b3b2$var$K,
                        $12b9f2ef36f8b3b2$var$U
                    ]
                }
            ],
            "text-shadow-color": [
                {
                    "text-shadow": M()
                }
            ],
            opacity: [
                {
                    opacity: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "mix-blend": [
                {
                    "mix-blend": [
                        ...ue(),
                        "plus-darker",
                        "plus-lighter"
                    ]
                }
            ],
            "bg-blend": [
                {
                    "bg-blend": ue()
                }
            ],
            "mask-clip": [
                {
                    "mask-clip": [
                        "border",
                        "padding",
                        "content",
                        "fill",
                        "stroke",
                        "view"
                    ]
                },
                "mask-no-clip"
            ],
            "mask-composite": [
                {
                    mask: [
                        "add",
                        "subtract",
                        "intersect",
                        "exclude"
                    ]
                }
            ],
            "mask-image-linear-pos": [
                {
                    "mask-linear": [
                        $12b9f2ef36f8b3b2$var$F
                    ]
                }
            ],
            "mask-image-linear-from-pos": [
                {
                    "mask-linear-from": q()
                }
            ],
            "mask-image-linear-to-pos": [
                {
                    "mask-linear-to": q()
                }
            ],
            "mask-image-linear-from-color": [
                {
                    "mask-linear-from": M()
                }
            ],
            "mask-image-linear-to-color": [
                {
                    "mask-linear-to": M()
                }
            ],
            "mask-image-t-from-pos": [
                {
                    "mask-t-from": q()
                }
            ],
            "mask-image-t-to-pos": [
                {
                    "mask-t-to": q()
                }
            ],
            "mask-image-t-from-color": [
                {
                    "mask-t-from": M()
                }
            ],
            "mask-image-t-to-color": [
                {
                    "mask-t-to": M()
                }
            ],
            "mask-image-r-from-pos": [
                {
                    "mask-r-from": q()
                }
            ],
            "mask-image-r-to-pos": [
                {
                    "mask-r-to": q()
                }
            ],
            "mask-image-r-from-color": [
                {
                    "mask-r-from": M()
                }
            ],
            "mask-image-r-to-color": [
                {
                    "mask-r-to": M()
                }
            ],
            "mask-image-b-from-pos": [
                {
                    "mask-b-from": q()
                }
            ],
            "mask-image-b-to-pos": [
                {
                    "mask-b-to": q()
                }
            ],
            "mask-image-b-from-color": [
                {
                    "mask-b-from": M()
                }
            ],
            "mask-image-b-to-color": [
                {
                    "mask-b-to": M()
                }
            ],
            "mask-image-l-from-pos": [
                {
                    "mask-l-from": q()
                }
            ],
            "mask-image-l-to-pos": [
                {
                    "mask-l-to": q()
                }
            ],
            "mask-image-l-from-color": [
                {
                    "mask-l-from": M()
                }
            ],
            "mask-image-l-to-color": [
                {
                    "mask-l-to": M()
                }
            ],
            "mask-image-x-from-pos": [
                {
                    "mask-x-from": q()
                }
            ],
            "mask-image-x-to-pos": [
                {
                    "mask-x-to": q()
                }
            ],
            "mask-image-x-from-color": [
                {
                    "mask-x-from": M()
                }
            ],
            "mask-image-x-to-color": [
                {
                    "mask-x-to": M()
                }
            ],
            "mask-image-y-from-pos": [
                {
                    "mask-y-from": q()
                }
            ],
            "mask-image-y-to-pos": [
                {
                    "mask-y-to": q()
                }
            ],
            "mask-image-y-from-color": [
                {
                    "mask-y-from": M()
                }
            ],
            "mask-image-y-to-color": [
                {
                    "mask-y-to": M()
                }
            ],
            "mask-image-radial": [
                {
                    "mask-radial": [
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "mask-image-radial-from-pos": [
                {
                    "mask-radial-from": q()
                }
            ],
            "mask-image-radial-to-pos": [
                {
                    "mask-radial-to": q()
                }
            ],
            "mask-image-radial-from-color": [
                {
                    "mask-radial-from": M()
                }
            ],
            "mask-image-radial-to-color": [
                {
                    "mask-radial-to": M()
                }
            ],
            "mask-image-radial-shape": [
                {
                    "mask-radial": [
                        "circle",
                        "ellipse"
                    ]
                }
            ],
            "mask-image-radial-size": [
                {
                    "mask-radial": [
                        {
                            closest: [
                                "side",
                                "corner"
                            ],
                            farthest: [
                                "side",
                                "corner"
                            ]
                        }
                    ]
                }
            ],
            "mask-image-radial-pos": [
                {
                    "mask-radial-at": _()
                }
            ],
            "mask-image-conic-pos": [
                {
                    "mask-conic": [
                        $12b9f2ef36f8b3b2$var$F
                    ]
                }
            ],
            "mask-image-conic-from-pos": [
                {
                    "mask-conic-from": q()
                }
            ],
            "mask-image-conic-to-pos": [
                {
                    "mask-conic-to": q()
                }
            ],
            "mask-image-conic-from-color": [
                {
                    "mask-conic-from": M()
                }
            ],
            "mask-image-conic-to-color": [
                {
                    "mask-conic-to": M()
                }
            ],
            "mask-mode": [
                {
                    mask: [
                        "alpha",
                        "luminance",
                        "match"
                    ]
                }
            ],
            "mask-origin": [
                {
                    "mask-origin": [
                        "border",
                        "padding",
                        "content",
                        "fill",
                        "stroke",
                        "view"
                    ]
                }
            ],
            "mask-position": [
                {
                    mask: ae()
                }
            ],
            "mask-repeat": [
                {
                    mask: oe()
                }
            ],
            "mask-size": [
                {
                    mask: se()
                }
            ],
            "mask-type": [
                {
                    "mask-type": [
                        "alpha",
                        "luminance"
                    ]
                }
            ],
            "mask-image": [
                {
                    mask: [
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            filter: [
                {
                    filter: [
                        "",
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            blur: [
                {
                    blur: J()
                }
            ],
            brightness: [
                {
                    brightness: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            contrast: [
                {
                    contrast: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        d,
                        $12b9f2ef36f8b3b2$var$K,
                        $12b9f2ef36f8b3b2$var$U
                    ]
                }
            ],
            "drop-shadow-color": [
                {
                    "drop-shadow": M()
                }
            ],
            grayscale: [
                {
                    grayscale: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "hue-rotate": [
                {
                    "hue-rotate": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            invert: [
                {
                    invert: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            saturate: [
                {
                    saturate: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            sepia: [
                {
                    sepia: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-blur": [
                {
                    "backdrop-blur": J()
                }
            ],
            "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-invert": [
                {
                    "backdrop-invert": [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            "border-spacing": [
                {
                    "border-spacing": x()
                }
            ],
            "border-spacing-x": [
                {
                    "border-spacing-x": x()
                }
            ],
            "border-spacing-y": [
                {
                    "border-spacing-y": x()
                }
            ],
            "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            transition: [
                {
                    transition: [
                        "",
                        "all",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "transition-behavior": [
                {
                    transition: [
                        "normal",
                        "discrete"
                    ]
                }
            ],
            duration: [
                {
                    duration: [
                        $12b9f2ef36f8b3b2$var$F,
                        "initial",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            ease: [
                {
                    ease: [
                        "linear",
                        "initial",
                        h,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            delay: [
                {
                    delay: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            animate: [
                {
                    animate: [
                        "none",
                        ne,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            backface: [
                {
                    backface: [
                        "hidden",
                        "visible"
                    ]
                }
            ],
            perspective: [
                {
                    perspective: [
                        p,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "perspective-origin": [
                {
                    "perspective-origin": v()
                }
            ],
            rotate: [
                {
                    rotate: Y()
                }
            ],
            "rotate-x": [
                {
                    "rotate-x": Y()
                }
            ],
            "rotate-y": [
                {
                    "rotate-y": Y()
                }
            ],
            "rotate-z": [
                {
                    "rotate-z": Y()
                }
            ],
            scale: [
                {
                    scale: X()
                }
            ],
            "scale-x": [
                {
                    "scale-x": X()
                }
            ],
            "scale-y": [
                {
                    "scale-y": X()
                }
            ],
            "scale-z": [
                {
                    "scale-z": X()
                }
            ],
            "scale-3d": [
                "scale-3d"
            ],
            skew: [
                {
                    skew: Z()
                }
            ],
            "skew-x": [
                {
                    "skew-x": Z()
                }
            ],
            "skew-y": [
                {
                    "skew-y": Z()
                }
            ],
            transform: [
                {
                    transform: [
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V,
                        "",
                        "none",
                        "gpu",
                        "cpu"
                    ]
                }
            ],
            "transform-origin": [
                {
                    origin: v()
                }
            ],
            "transform-style": [
                {
                    transform: [
                        "3d",
                        "flat"
                    ]
                }
            ],
            translate: [
                {
                    translate: Q()
                }
            ],
            "translate-x": [
                {
                    "translate-x": Q()
                }
            ],
            "translate-y": [
                {
                    "translate-y": Q()
                }
            ],
            "translate-z": [
                {
                    "translate-z": Q()
                }
            ],
            "translate-none": [
                "translate-none"
            ],
            zoom: [
                {
                    zoom: [
                        $12b9f2ef36f8b3b2$var$I,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            accent: [
                {
                    accent: M()
                }
            ],
            appearance: [
                {
                    appearance: [
                        "none",
                        "auto"
                    ]
                }
            ],
            "caret-color": [
                {
                    caret: M()
                }
            ],
            "color-scheme": [
                {
                    scheme: [
                        "normal",
                        "dark",
                        "light",
                        "light-dark",
                        "only-dark",
                        "only-light"
                    ]
                }
            ],
            cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "field-sizing": [
                {
                    "field-sizing": [
                        "fixed",
                        "content"
                    ]
                }
            ],
            "pointer-events": [
                {
                    "pointer-events": [
                        "auto",
                        "none"
                    ]
                }
            ],
            resize: [
                {
                    resize: [
                        "none",
                        "",
                        "y",
                        "x"
                    ]
                }
            ],
            "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            "scrollbar-thumb-color": [
                {
                    "scrollbar-thumb": M()
                }
            ],
            "scrollbar-track-color": [
                {
                    "scrollbar-track": M()
                }
            ],
            "scrollbar-gutter": [
                {
                    "scrollbar-gutter": [
                        "auto",
                        "stable",
                        "both"
                    ]
                }
            ],
            "scrollbar-w": [
                {
                    scrollbar: [
                        "auto",
                        "thin",
                        "none"
                    ]
                }
            ],
            "scroll-m": [
                {
                    "scroll-m": x()
                }
            ],
            "scroll-mx": [
                {
                    "scroll-mx": x()
                }
            ],
            "scroll-my": [
                {
                    "scroll-my": x()
                }
            ],
            "scroll-ms": [
                {
                    "scroll-ms": x()
                }
            ],
            "scroll-me": [
                {
                    "scroll-me": x()
                }
            ],
            "scroll-mbs": [
                {
                    "scroll-mbs": x()
                }
            ],
            "scroll-mbe": [
                {
                    "scroll-mbe": x()
                }
            ],
            "scroll-mt": [
                {
                    "scroll-mt": x()
                }
            ],
            "scroll-mr": [
                {
                    "scroll-mr": x()
                }
            ],
            "scroll-mb": [
                {
                    "scroll-mb": x()
                }
            ],
            "scroll-ml": [
                {
                    "scroll-ml": x()
                }
            ],
            "scroll-p": [
                {
                    "scroll-p": x()
                }
            ],
            "scroll-px": [
                {
                    "scroll-px": x()
                }
            ],
            "scroll-py": [
                {
                    "scroll-py": x()
                }
            ],
            "scroll-ps": [
                {
                    "scroll-ps": x()
                }
            ],
            "scroll-pe": [
                {
                    "scroll-pe": x()
                }
            ],
            "scroll-pbs": [
                {
                    "scroll-pbs": x()
                }
            ],
            "scroll-pbe": [
                {
                    "scroll-pbe": x()
                }
            ],
            "scroll-pt": [
                {
                    "scroll-pt": x()
                }
            ],
            "scroll-pr": [
                {
                    "scroll-pr": x()
                }
            ],
            "scroll-pb": [
                {
                    "scroll-pb": x()
                }
            ],
            "scroll-pl": [
                {
                    "scroll-pl": x()
                }
            ],
            "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "manipulation"
                    ]
                }
            ],
            "touch-x": [
                {
                    "touch-pan": [
                        "x",
                        "left",
                        "right"
                    ]
                }
            ],
            "touch-y": [
                {
                    "touch-pan": [
                        "y",
                        "up",
                        "down"
                    ]
                }
            ],
            "touch-pz": [
                "touch-pinch-zoom"
            ],
            select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            fill: [
                {
                    fill: [
                        "none",
                        ...M()
                    ]
                }
            ],
            "stroke-w": [
                {
                    stroke: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$G,
                        $12b9f2ef36f8b3b2$var$H,
                        $12b9f2ef36f8b3b2$var$me
                    ]
                }
            ],
            stroke: [
                {
                    stroke: [
                        "none",
                        ...M()
                    ]
                }
            ],
            "forced-color-adjust": [
                {
                    "forced-color-adjust": [
                        "auto",
                        "none"
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            "container-named": [
                "container-type"
            ],
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "inset-bs",
                "inset-be",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pbs",
                "pbe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mbs",
                "mbe",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            size: [
                "w",
                "h"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            "line-clamp": [
                "display",
                "overflow"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-x",
                "border-w-y",
                "border-w-s",
                "border-w-e",
                "border-w-bs",
                "border-w-be",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-x",
                "border-color-y",
                "border-color-s",
                "border-color-e",
                "border-color-bs",
                "border-color-be",
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            translate: [
                "translate-x",
                "translate-y",
                "translate-none"
            ],
            "translate-none": [
                "translate",
                "translate-x",
                "translate-y",
                "translate-z"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mbs",
                "scroll-mbe",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pbs",
                "scroll-pbe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ],
            touch: [
                "touch-x",
                "touch-y",
                "touch-pz"
            ],
            "touch-x": [
                "touch"
            ],
            "touch-y": [
                "touch"
            ],
            "touch-pz": [
                "touch"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        },
        postfixLookupClassGroups: [
            "container-type"
        ],
        orderSensitiveModifiers: [
            "*",
            "**",
            "after",
            "backdrop",
            "before",
            "details-content",
            "file",
            "first-letter",
            "first-line",
            "marker",
            "placeholder",
            "selection"
        ]
    };
}, $12b9f2ef36f8b3b2$export$5d86b86a654a7039 = (e, { cacheSize: t, prefix: n, experimentalParseClassName: r, extend: i = {}, override: a = {} })=>($12b9f2ef36f8b3b2$var$$(e, "cacheSize", t), $12b9f2ef36f8b3b2$var$$(e, "prefix", n), $12b9f2ef36f8b3b2$var$$(e, "experimentalParseClassName", r), $12b9f2ef36f8b3b2$var$Ae(e.theme, a.theme), $12b9f2ef36f8b3b2$var$Ae(e.classGroups, a.classGroups), $12b9f2ef36f8b3b2$var$Ae(e.conflictingClassGroups, a.conflictingClassGroups), $12b9f2ef36f8b3b2$var$Ae(e.conflictingClassGroupModifiers, a.conflictingClassGroupModifiers), $12b9f2ef36f8b3b2$var$$(e, "postfixLookupClassGroups", a.postfixLookupClassGroups), $12b9f2ef36f8b3b2$var$$(e, "orderSensitiveModifiers", a.orderSensitiveModifiers), $12b9f2ef36f8b3b2$var$je(e.theme, i.theme), $12b9f2ef36f8b3b2$var$je(e.classGroups, i.classGroups), $12b9f2ef36f8b3b2$var$je(e.conflictingClassGroups, i.conflictingClassGroups), $12b9f2ef36f8b3b2$var$je(e.conflictingClassGroupModifiers, i.conflictingClassGroupModifiers), $12b9f2ef36f8b3b2$var$Me(e, i, "postfixLookupClassGroups"), $12b9f2ef36f8b3b2$var$Me(e, i, "orderSensitiveModifiers"), e), $12b9f2ef36f8b3b2$var$$ = (e, t, n)=>{
    n !== void 0 && (e[t] = n);
}, $12b9f2ef36f8b3b2$var$Ae = (e, t)=>{
    if (t) for(let n in t)$12b9f2ef36f8b3b2$var$$(e, n, t[n]);
}, $12b9f2ef36f8b3b2$var$je = (e, t)=>{
    if (t) for(let n in t)$12b9f2ef36f8b3b2$var$Me(e, t, n);
}, $12b9f2ef36f8b3b2$var$Me = (e, t, n)=>{
    let r = t[n];
    r !== void 0 && (e[n] = e[n] ? e[n].concat(r) : r);
}, $12b9f2ef36f8b3b2$export$c8d8406b6cd2243e = (e, ...t)=>typeof e == "function" ? $12b9f2ef36f8b3b2$export$ea2d4fba4d1bd27f($12b9f2ef36f8b3b2$export$ed30944e0fe6ae5c, e, ...t) : $12b9f2ef36f8b3b2$export$ea2d4fba4d1bd27f(()=>$12b9f2ef36f8b3b2$export$5d86b86a654a7039($12b9f2ef36f8b3b2$export$ed30944e0fe6ae5c(), e), ...t);


//#region src/utilities/index.jsx
var $feeb2945a0885102$var$t = (0, $12b9f2ef36f8b3b2$export$c8d8406b6cd2243e)({
    extend: {
        classGroups: {
            "font-size": [
                {
                    text: [
                        "body-2",
                        "caption",
                        "detail",
                        "detail-tiny",
                        "detail-bold",
                        "button",
                        "h1",
                        "h2",
                        "h3",
                        "title",
                        "title-2",
                        "title-3",
                        "title-4",
                        "display",
                        "display-2",
                        "22px",
                        "26px",
                        "28px",
                        "32px",
                        "42px"
                    ]
                }
            ],
            tracking: [
                {
                    tracking: [
                        "0.25px",
                        "0.5px",
                        "1px",
                        "1.5px",
                        "2px",
                        "3px"
                    ]
                }
            ],
            "text-color": [
                {
                    text: [
                        "required"
                    ]
                }
            ]
        }
    }
}), $feeb2945a0885102$export$ce4ab0c55987d1ff = (e)=>$feeb2945a0885102$var$t(Object.entries(e).filter(([, e])=>e).map(([e])=>e).join(" ")), $feeb2945a0885102$export$c1e6bbdae3888da5 = ({ fontUrl: e } = {})=>{
    if (e && ![
        ...document.querySelectorAll("link[rel=\"stylesheet\"]")
    ].some((t)=>t.getAttribute("href") === e)) {
        let t = document.createElement("link");
        t.rel = "stylesheet", t.href = e, document.head.append(t);
    }
    let t = null, n = ()=>{
        t && clearInterval(t);
    };
    t = setInterval(()=>{
        let e;
        try {
            e = document.fonts.check("12px \"Material Symbols Outlined\"");
        } catch  {
            n();
            return;
        }
        e && (document.body.classList.remove("hide-icons"), n());
    }, 100);
}, $feeb2945a0885102$export$d27b4a339eee114a = (e)=>e.type.startsWith("image/") ? URL.createObjectURL(e) : null;





var $lCzvA = parcelRequire("lCzvA");

var $05a027417612e40b$export$2e2bcd8739ae039 = (0, $lCzvA.memo)(({ name: t, size: i = 24, fill: a = 0, weight: o = 300, className: s, ...c })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-Icon block! material-symbols-outlined": !0,
            [s]: s
        }),
        style: (0, $lCzvA.useMemo)(()=>({
                fontVariationSettings: `'FILL' ${a}, 'wght' ${o}, 'GRAD' 0, 'opsz' 48`,
                fontSize: i,
                width: i,
                height: i,
                lineHeight: 1,
                overflow: "hidden"
            }), [
            a,
            o,
            i
        ]),
        "aria-hidden": "true",
        "data-testid": "sash-icon",
        ...c,
        children: t
    }));
$05a027417612e40b$export$2e2bcd8739ae039.displayName = "Icon";



var $lCzvA = parcelRequire("lCzvA");
"use client";
//#region src/hooks/useToggle/index.jsx
var $49d3c8472e20c2b5$export$cbe85ee05b554577 = (n = !1)=>{
    let [r, i] = (0, $lCzvA.useState)(n);
    return [
        r,
        (0, $lCzvA.useCallback)(()=>i((e)=>!e), [])
    ];
};



"use client";
//#region src/components/Alert/index.jsx
var $71efe153e5175f41$var$a = {
    error: "emergency_home",
    default: "lightbulb",
    info: "info",
    warning: "warning",
    success: "check_circle"
}, $71efe153e5175f41$export$2e2bcd8739ae039 = ({ type: o = "success", message: s, className: c, showClose: l, children: u, onClose: d, iconClass: f, contentClass: p, messageClass: m, inline: h, customIcon: g, ..._ })=>{
    let [v, y] = (0, $49d3c8472e20c2b5$export$cbe85ee05b554577)(!0), b = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Alert relative [&_a]:text-inherit [&_a]:underline [&_a]:hover:no-underline [&_a]:hover:text-inherit gap-x-2": !0,
        "flex py-3 px-4 rounded border border-l-4": !h,
        "inline-flex": h,
        "text-red-700": o === "error",
        "text-blue-800": o === "info",
        "text-amber-800": o === "warning",
        "text-green-800": o === "success",
        "text-black": o === "default",
        "border-red-700 bg-red-100": o === "error" && !h,
        "border-blue-700 bg-blue-100": o === "info" && !h,
        "border-amber-700 bg-amber-100": o === "warning" && !h,
        "border-green-700 bg-green-100": (!o || o === "success") && !h,
        "bg-white border-neutral-900": o === "default" && !h,
        [c]: c
    }), x = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "block leading-none!": !0,
        "text-red-700": o === "error",
        "text-blue-700": o === "info",
        "text-amber-700": o === "warning",
        "text-green-700": o === "success",
        "text-black": o === "default",
        [f]: f
    }), S = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-AlertContent flex-1 [&_p:last-child]:m-0": !0,
        "pt-px text-base": !h,
        "pt-0.5 text-sm": h,
        [p]: p
    }), C = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-AlertMessage font-semibold": !0,
        "mb-2.5": u,
        [m]: m
    }), w = ()=>{
        y(), typeof d == "function" && d();
    };
    return v ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: b,
        role: "alert",
        "aria-atomic": "true",
        "aria-live": "assertive",
        ..._,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: "sash-AlertIcon flex-none leading-none",
                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                    name: g || $71efe153e5175f41$var$a[o],
                    className: x,
                    weight: 600
                })
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: S,
                children: [
                    s && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: C,
                        children: s
                    }),
                    u && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: "text-inherit [&_ul]:m-0 [&_ul]:pl-5",
                        children: u
                    })
                ]
            }),
            l && !h && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                type: "button",
                className: "flex cursor-pointer hover:text-black",
                "aria-label": "Close",
                onClick: w,
                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                    name: "close",
                    className: "text-neutral-750",
                    weight: 600
                })
            })
        ]
    }) : null;
};




"use client";
//#region src/components/Toast/index.jsx
var $673b1c81cc441170$var$i = (e, t)=>{
    if (e) {
        let n = document.querySelector(`#${CSS.escape(e)}`);
        n && (n.classList.add("opacity-0", "transition-opacity", "duration-500"), setTimeout(()=>{
            let e = n.parentElement;
            n.remove(), t && t(), e && !e.children.length && e.remove();
        }, 400));
    } else for (let e of document.querySelectorAll("[id^=\"toast-\"]"))e.remove();
}, $673b1c81cc441170$var$a = ({ root: a, duration: o = 6, onDismiss: s, position: c = "bottom-center", ...l })=>{
    let u, d, f, p = `toast-${c}`, m = document.querySelector(`#${CSS.escape(p)}`);
    m ? d = m : (d = document.createElement("div"), d.id = p, document.body.append(d));
    let h = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Toast fixed flex flex-col items-center justify-center max-w-(--breakpoint-sm) select-none z-9999 gap-2.5": !0,
        "top-5 left-5": c === "top-left",
        "top-5 left-1/2 -translate-x-1/2": c === "top-center",
        "top-5 right-5": c === "top-right",
        "bottom-5 left-5": c === "bottom-left",
        "bottom-5 left-1/2 -translate-x-1/2": c === "bottom-center",
        "bottom-5 right-5": c === "bottom-right"
    });
    if (d.className = h, a?.render) u = a;
    else {
        let e = `toast-item-${Math.random().toString().split(".")[1]}`;
        f = document.createElement("div"), f.id = e, d.append(f), u = (0, $2aa82faa573d5f31$exports.createRoot)(f), u.toastId = e;
    }
    let g = u.toastId;
    o && setTimeout(()=>$673b1c81cc441170$var$i(g, s), o * 1e3);
    let _ = ()=>$673b1c81cc441170$var$i(g, s);
    return u.render(/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $71efe153e5175f41$export$2e2bcd8739ae039), {
        ...l,
        className: "rounded-xs",
        onClose: _,
        showClose: !0
    })), u;
}, $673b1c81cc441170$export$2e2bcd8739ae039 = {
    success: (e, t)=>$673b1c81cc441170$var$a({
            ...t,
            message: e,
            type: "success"
        }),
    error: (e, t)=>$673b1c81cc441170$var$a({
            ...t,
            message: e,
            type: "error"
        }),
    info: (e, t)=>$673b1c81cc441170$var$a({
            ...t,
            message: e,
            type: "info"
        }),
    warning: (e, t)=>$673b1c81cc441170$var$a({
            ...t,
            message: e,
            type: "warning"
        }),
    generic: (e, t)=>$673b1c81cc441170$var$a({
            ...t,
            message: e,
            type: "default"
        }),
    loading: (e = "Loading ...", t = {})=>$673b1c81cc441170$var$a({
            ...t,
            duration: 0,
            message: e,
            type: "default",
            customIcon: "progress_activity",
            iconClass: "animate-spin"
        }),
    dismiss: (e)=>$673b1c81cc441170$var$i(e?.toastId)
};


// Note: This file is used to export all components from the components folder
// Turn on the commented out lines once you have components to export


var $lCzvA = parcelRequire("lCzvA");


"use client";
function $fd8439d87c9b5264$export$625b2ff71316bcd3(filters, queryClient) {
    const client = (0, $427d8fa9df978c82$export$22e77b9572c4fded)(queryClient);
    const queryCache = client.getQueryCache();
    return $lCzvA.useSyncExternalStore($lCzvA.useCallback((onStoreChange)=>queryCache.subscribe((0, $f0d6b6465c83f494$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        queryCache
    ]), ()=>client.isFetching(filters), ()=>client.isFetching(filters));
}





var $lCzvA = parcelRequire("lCzvA");




//#region src/components/List/index.jsx
var $c169cb583646f905$export$2e2bcd8739ae039 = ({ type: n = "ul", bullets: r, inside: i, layout: a, children: o, className: s, ...c })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(n, {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-List": !0,
            "m-0 p-0 list-none": r === "none",
            "list-disc": r === "disc" || !r && n === "ul",
            "list-decimal": r === "decimal" || !r && n === "ol",
            "list-inside": i,
            "flex flex-wrap *:flex-1": a === "fluid",
            "flex flex-wrap *:flex-initial": a === "inline",
            [s]: s
        }),
        ...c,
        children: o
    });



var $lCzvA = parcelRequire("lCzvA");

//#region src/components/Breadcrumbs/index.jsx
var $e7e807be55d7b93f$export$2e2bcd8739ae039 = ({ pages: c, current: l, homeIcon: u = "other_houses", divider: d = "/", renderLinksAs: f = "a", className: p, children: m, enableTo: h, ...g })=>{
    let _ = f, v = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Breadcrumbs text-black whitespace-nowrap overflow-auto py-2": !0,
        [p]: p
    }), y = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "font-normal underline hover:no-underline": !0
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: v,
        "data-testid": "sash-breadcrumbs",
        ...g,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c169cb583646f905$export$2e2bcd8739ae039), {
            bullets: "none",
            layout: "inline",
            className: "flex-nowrap items-center overflow-x-auto overflow-y-hidden leading-none",
            children: [
                u && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                    children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(_, {
                        href: h ? null : "/",
                        to: h ? "/" : null,
                        className: "block no-underline",
                        children: [
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                name: u,
                                className: "block leading-none!"
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Home"
                            })
                        ]
                    })
                }),
                Array.isArray(c) && c.map((e, t)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $lCzvA.Fragment), {
                        children: [
                            (u || !u && t !== 0) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                                className: "mx-1.5",
                                children: d
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                                children: e.url ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(_, {
                                    "data-testid": "breadcrumbs-link",
                                    href: h ? null : e.url,
                                    to: h ? e.url : null,
                                    className: y,
                                    children: e.title
                                }) : e.title
                            })
                        ]
                    }, t)),
                (0, $lCzvA.Children).toArray(m).map((e, t)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $lCzvA.Fragment), {
                        children: [
                            (u || !u && t !== 0) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                                className: "mx-1.5",
                                children: d
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                                children: e
                            })
                        ]
                    }, t)),
                l && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                            className: "mx-1.5",
                            children: d
                        }),
                        /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                            children: l
                        })
                    ]
                })
            ]
        })
    });
};




var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/Button/index.jsx
var $8f4a1c407cb4821b$export$2e2bcd8739ae039 = (0, $lCzvA.memo)((0, $lCzvA.forwardRef)(({ href: n, type: r = "button", color: s = "primary", wide: c = !1, renderAs: l = "a", className: u, iconLeft: d, iconRight: f, children: p, darkMode: m, loading: h = !1, ...g }, _)=>{
    let v = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Button rounded-xs border gap-x-2 py-3 text-base inline-flex items-center justify-center w-full font-semibold tracking-xs text-center cursor-pointer no-underline disabled:pointer-events-none disabled:border-neutral": !0,
        "disabled:bg-neutral-50 disabled:text-neutral-600": !m,
        "focus-visible:shadow-[inset_0_0_0_2px_#fff] disabled:bg-neutral-700 disabled:text-neutral-200": m,
        "px-4": p,
        "px-3": !p,
        "sash-Button--primary bg-black text-white border-black active:bg-neutral-800 active:border-neutral-800 hover:bg-neutral-650 hover:border-neutral-650 focus-visible:bg-neutral-650 focus-visible:border-neutral-650": s === "primary" && !m,
        "sash-Button--primary-dark bg-white border-white text-neutral-750 active:bg-neutral-300 active:border-neutral-300 active:text-black hover:bg-neutral-100 hover:border-neutral-100 hover:text-black focus-visible:bg-neutral-100 focus-visible:border-neutral-100 focus-visible:text-black": s === "primary" && m,
        "sash-Button--secondary text-neutral-700 border-neutral-700 active:text-neutral-900 active:border-neutral-900 active:bg-transparent hover:bg-yellow-100 hover:border-black hover:text-black focus-visible:bg-yellow-100 focus-visible:border-black focus-visible:text-black": s === "secondary" && !m,
        "sash-Button--secondary-dark border-white text-white active:border-neutral-50 active:text-neutral-50 active:bg-transparent hover:bg-neutral-750 hover:border-neutral-200 hover:text-neutral-200 focus-visible:border-neutral-200 focus-visible:bg-neutral-750 focus-visible:text-neutral-200": s === "secondary" && m,
        "sash-Button--tertiary border-transparent text-neutral-850 active:bg-transparent active:text-neutral-750 active:border-neutral hover:bg-black-05 hover:border-transparent hover:text-black focus-visible:bg-black-05 focus-visible:border-transparent focus-visible:text-black": s === "tertiary" && !m,
        "sash-Button--tertiary-dark border-transparent text-neutral-100 active:border-neutral active:text-neutral-50 hover:bg-[rgba(255,255,255,0.06)] hover:text-white focus-visible:bg-[rgba(255,255,255,0.06)] focus-visible:text-white": s === "tertiary" && m,
        "sash-Button--conversion bg-conversion text-neutral-800 border-neutral-800 active:bg-conversion-active active:border-black active:text-black hover:bg-conversion-hover hover:border-black hover:text-black focus-visible:bg-conversion-hover focus-visible:border-black focus-visible:text-black": s === "conversion",
        "sm:w-auto": !c,
        [u]: u
    }), y = /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            h ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: "progress_activity",
                className: "animate-spin"
            }) : d && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: d
            }),
            p,
            !h && f && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: f
            })
        ]
    }), b = l;
    return n || g.to ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(b, {
        href: n || void 0,
        to: g.to || void 0,
        className: v,
        "data-color": s,
        "data-mode": m ? "dark" : "light",
        disabled: h || g.disabled,
        "aria-busy": h || void 0,
        ref: _,
        ...g,
        children: y
    }) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
        type: r,
        className: v,
        "data-color": s,
        "data-mode": m ? "dark" : "light",
        disabled: h || g.disabled,
        "aria-busy": h || void 0,
        ref: _,
        ...g,
        children: y
    });
}));
$8f4a1c407cb4821b$export$2e2bcd8739ae039.displayName = "Button";


typeof window < "u" && window.document && window.document.createElement;
function $9456f9398283d0f7$export$b9ecd428b558ff10(e1, t, { checkForDefaultPrevented: n = !0 } = {}) {
    return function(r) {
        if (e1?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
    };
}



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/@radix-ui/react-compose-refs/dist/index.mjs
function $c4d50d88a15d3346$var$t(e, t) {
    if (typeof e == "function") return e(t);
    e != null && (e.current = t);
}
function $c4d50d88a15d3346$export$43e446d32b3d21af(...e) {
    return (n)=>{
        let r = !1, i = e.map((e)=>{
            let i = $c4d50d88a15d3346$var$t(e, n);
            return !r && typeof i == "function" && (r = !0), i;
        });
        if (r) return ()=>{
            for(let n = 0; n < i.length; n++){
                let r = i[n];
                typeof r == "function" ? r() : $c4d50d88a15d3346$var$t(e[n], null);
            }
        };
    };
}
function $c4d50d88a15d3346$export$c7b2cbe3552a0d05(...t) {
    return $lCzvA.useCallback($c4d50d88a15d3346$export$43e446d32b3d21af(...t), t);
}



var $lCzvA = parcelRequire("lCzvA");

//#region node_modules/@radix-ui/react-context/dist/index.mjs
function $0641488beac2d3c3$export$50c7b4e9d9f19c1(n1, i = []) {
    let a = [];
    function o(r, i) {
        let o = $lCzvA.createContext(i);
        o.displayName = r + "Context";
        let s = a.length;
        a = [
            ...a,
            i
        ];
        let c = (r)=>{
            let { scope: i, children: a, ...c } = r, l = i?.[n1]?.[s] || o, u = $lCzvA.useMemo(()=>c, Object.values(c));
            return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(l.Provider, {
                value: u,
                children: a
            });
        };
        c.displayName = r + "Provider";
        function l(t, a, c = {}) {
            let { optional: l1 = !1 } = c, u = a?.[n1]?.[s] || o, d = $lCzvA.useContext(u);
            if (d) return d;
            if (i !== void 0) return i;
            if (!l1) throw Error(`\`${t}\` must be used within \`${r}\``);
        }
        return [
            c,
            l
        ];
    }
    let s = ()=>{
        let t = a.map((t)=>$lCzvA.createContext(t));
        return function(r) {
            let i = r?.[n1] || t;
            return $lCzvA.useMemo(()=>({
                    [`__scope${n1}`]: {
                        ...r,
                        [n1]: i
                    }
                }), [
                r,
                i
            ]);
        };
    };
    return s.scopeName = n1, [
        o,
        $0641488beac2d3c3$var$r(s, ...i)
    ];
}
function $0641488beac2d3c3$var$r(...t) {
    let n = t[0];
    if (t.length === 1) return n;
    let r1 = ()=>{
        let r = t.map((e)=>({
                useScope: e(),
                scopeName: e.scopeName
            }));
        return function(t) {
            let i = r.reduce((e, { useScope: n, scopeName: r })=>{
                let i = n(t)[`__scope${r}`];
                return {
                    ...e,
                    ...i
                };
            }, {});
            return $lCzvA.useMemo(()=>({
                    [`__scope${n.scopeName}`]: i
                }), [
                i
            ]);
        };
    };
    return r1.scopeName = n.scopeName, r1;
}



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var $62d8013ac651591c$export$e5c5a5f917a5871c = globalThis?.document ? $lCzvA.useLayoutEffect : ()=>{};



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/@radix-ui/react-id/dist/index.mjs
var $2505f25f517c82fa$var$n = $lCzvA.useId || (()=>void 0), $2505f25f517c82fa$var$r = 0;
function $2505f25f517c82fa$export$f680877a34711e37(i) {
    let [a, o] = $lCzvA.useState($2505f25f517c82fa$var$n());
    return (0, $62d8013ac651591c$export$e5c5a5f917a5871c)(()=>{
        i || o((e)=>e ?? String($2505f25f517c82fa$var$r++));
    }, [
        i
    ]), i || (a ? `radix-${a}` : "");
}




var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var $0d3099c8ce39feb9$var$n = $lCzvA.useInsertionEffect || (0, $62d8013ac651591c$export$e5c5a5f917a5871c);
function $0d3099c8ce39feb9$export$6f32135080cb4c3({ prop: e, defaultProp: n, onChange: r = ()=>{}, caller: o }) {
    let [s, c, l] = $0d3099c8ce39feb9$var$i({
        defaultProp: n,
        onChange: r
    }), u = e !== void 0, d = u ? e : s;
    {
        let n = $lCzvA.useRef(e !== void 0);
        $lCzvA.useEffect(()=>{
            let e = n.current;
            e !== u && console.warn(`${o} is changing from ${e ? "controlled" : "uncontrolled"} to ${u ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`), n.current = u;
        }, [
            u,
            o
        ]);
    }
    return [
        d,
        $lCzvA.useCallback((t)=>{
            if (u) {
                let n = $0d3099c8ce39feb9$var$a(t) ? t(e) : t;
                n !== e && l.current?.(n);
            } else c(t);
        }, [
            u,
            e,
            c,
            l
        ])
    ];
}
function $0d3099c8ce39feb9$var$i({ defaultProp: e, onChange: r }) {
    let [i, a] = $lCzvA.useState(e), o = $lCzvA.useRef(i), s = $lCzvA.useRef(r);
    return $0d3099c8ce39feb9$var$n(()=>{
        s.current = r;
    }, [
        r
    ]), $lCzvA.useEffect(()=>{
        o.current !== i && (s.current?.(i), o.current = i);
    }, [
        i,
        o
    ]), [
        i,
        a,
        s
    ];
}
function $0d3099c8ce39feb9$var$a(e) {
    return typeof e == "function";
}




var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/@radix-ui/react-slot/dist/index.mjs
// @__NO_SIDE_EFFECTS__
function $09f52881d5dae1cd$export$e88b45bda5c13eb9(n) {
    let r = $lCzvA.forwardRef((r, i)=>{
        let { children: l, ...d } = r, h = null, g = !1, _ = [];
        $09f52881d5dae1cd$var$u(l) && typeof $09f52881d5dae1cd$var$m == "function" && (l = $09f52881d5dae1cd$var$m(l._payload)), $lCzvA.Children.forEach(l, (e)=>{
            if ($09f52881d5dae1cd$var$c(e)) {
                g = !0;
                let t = e, n = "child" in t.props ? t.props.child : t.props.children;
                $09f52881d5dae1cd$var$u(n) && typeof $09f52881d5dae1cd$var$m == "function" && (n = $09f52881d5dae1cd$var$m(n._payload)), h = $09f52881d5dae1cd$var$a(t, n), _.push(h?.props?.children);
            } else _.push(e);
        }), h ? h = $lCzvA.cloneElement(h, void 0, _) : !g && $lCzvA.Children.count(l) === 1 && $lCzvA.isValidElement(l) && (h = l);
        let v = h ? $09f52881d5dae1cd$var$s(h) : void 0, y = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(i, v);
        if (!h) {
            if (l || l === 0) throw Error(g ? $09f52881d5dae1cd$var$p(n) : $09f52881d5dae1cd$var$f(n));
            return l;
        }
        let b = $09f52881d5dae1cd$var$o(d, h.props ?? {});
        return h.type !== $lCzvA.Fragment && (b.ref = i ? y : v), $lCzvA.cloneElement(h, b);
    });
    return r.displayName = `${n}.Slot`, r;
}
var $09f52881d5dae1cd$var$r = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $09f52881d5dae1cd$export$bf68c29d8281d0f7(e) {
    let t = (e)=>"child" in e ? e.children(e.child) : e.children;
    return t.displayName = `${e}.Slottable`, t.__radixId = $09f52881d5dae1cd$var$r, t;
}
var $09f52881d5dae1cd$var$a = (e, n)=>{
    if ("child" in e.props) {
        let n = e.props.child;
        return $lCzvA.isValidElement(n) ? $lCzvA.cloneElement(n, void 0, e.props.children(n.props.children)) : null;
    }
    return $lCzvA.isValidElement(n) ? n : null;
};
function $09f52881d5dae1cd$var$o(e, t) {
    let n = {
        ...t
    };
    for(let r in t){
        let i = e[r], a = t[r];
        /^on[A-Z]/.test(r) ? i && a ? n[r] = (...e)=>{
            let t = a(...e);
            return i(...e), t;
        } : i && (n[r] = i) : r === "style" ? n[r] = {
            ...i,
            ...a
        } : r === "className" && (n[r] = [
            i,
            a
        ].filter(Boolean).join(" "));
    }
    return {
        ...e,
        ...n
    };
}
function $09f52881d5dae1cd$var$s(e) {
    let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
    return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function $09f52881d5dae1cd$var$c(e) {
    return $lCzvA.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === $09f52881d5dae1cd$var$r;
}
var $09f52881d5dae1cd$var$l = Symbol.for("react.lazy");
function $09f52881d5dae1cd$var$u(e) {
    return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === $09f52881d5dae1cd$var$l && "_payload" in e && $09f52881d5dae1cd$var$d(e._payload);
}
function $09f52881d5dae1cd$var$d(e) {
    return typeof e == "object" && !!e && "then" in e;
}
var $09f52881d5dae1cd$var$f = (e)=>`${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, $09f52881d5dae1cd$var$p = (e)=>`${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, $09f52881d5dae1cd$var$m = $lCzvA.use;




var $lCzvA = parcelRequire("lCzvA");


var $dAQd3 = parcelRequire("dAQd3");
//#region node_modules/@radix-ui/react-primitive/dist/index.mjs
var $3fe2937b6970d85d$export$250ffa63cdc0d034 = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
].reduce((r, i)=>{
    let a = (0, $09f52881d5dae1cd$export$e88b45bda5c13eb9)(`Primitive.${i}`), o = $lCzvA.forwardRef((e, t)=>{
        let { asChild: r, ...o } = e, s = r ? a : i;
        return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(s, {
            ...o,
            ref: t
        });
    });
    return o.displayName = `Primitive.${i}`, {
        ...r,
        [i]: o
    };
}, {});
function $3fe2937b6970d85d$export$6d1a0317bde7de7f(e, t) {
    e && $dAQd3.flushSync(()=>e.dispatchEvent(t));
}






var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
function $334703f027012d3d$export$25bec8c6f54ee79a(t) {
    let n = $lCzvA.useRef(t);
    return $lCzvA.useEffect(()=>{
        n.current = t;
    }), $lCzvA.useMemo(()=>(...e)=>n.current?.(...e), []);
}



var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var $fb04d4ce1fe91315$var$s = "DismissableLayer", $fb04d4ce1fe91315$var$c = "dismissableLayer.update", $fb04d4ce1fe91315$var$l = "dismissableLayer.pointerDownOutside", $fb04d4ce1fe91315$var$u = "dismissableLayer.focusOutside", $fb04d4ce1fe91315$var$d, $fb04d4ce1fe91315$var$f = $lCzvA.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set(),
    dismissableSurfaces: /* @__PURE__ */ new Set()
}), $fb04d4ce1fe91315$export$177fb62ff3ec1f22 = $lCzvA.forwardRef((r, s)=>{
    let { disableOutsidePointerEvents: l = !1, deferPointerDownOutside: u = !1, onEscapeKeyDown: p, onPointerDownOutside: m, onFocusOutside: h, onInteractOutside: g, onDismiss: _, ...x } = r, S = $lCzvA.useContext($fb04d4ce1fe91315$var$f), [C, w] = $lCzvA.useState(null), T = C?.ownerDocument ?? globalThis?.document, [, E] = $lCzvA.useState({}), D = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(s, w), O = Array.from(S.layers), [k] = [
        ...S.layersWithOutsidePointerEventsDisabled
    ].slice(-1), A = k ? O.indexOf(k) : -1, j = C ? O.indexOf(C) : -1, M = S.layersWithOutsidePointerEventsDisabled.size > 0, N = j >= A, P = $lCzvA.useRef(!1), F = $fb04d4ce1fe91315$var$v((e)=>{
        m?.(e), g?.(e), e.defaultPrevented || _?.();
    }, {
        ownerDocument: T,
        deferPointerDownOutside: u,
        isDeferredPointerDownOutsideRef: P,
        dismissableSurfaces: S.dismissableSurfaces,
        shouldHandlePointerDownOutside: $lCzvA.useCallback((e)=>{
            if (!(e instanceof Node)) return !1;
            let t = [
                ...S.branches
            ].some((t)=>t.contains(e));
            return N && !t;
        }, [
            S.branches,
            N
        ])
    }), I = $fb04d4ce1fe91315$var$y((e)=>{
        if (u && P.current) return;
        let t = e.target;
        [
            ...S.branches
        ].some((e)=>e.contains(t)) || (h?.(e), g?.(e), e.defaultPrevented || _?.());
    }, T), L = C ? j === O.length - 1 : !1, R = (0, $334703f027012d3d$export$25bec8c6f54ee79a)((e)=>{
        e.key === "Escape" && (p?.(e), !e.defaultPrevented && _ && (e.preventDefault(), _()));
    });
    return $lCzvA.useEffect(()=>{
        if (L) return T.addEventListener("keydown", R, {
            capture: !0
        }), ()=>T.removeEventListener("keydown", R, {
                capture: !0
            });
    }, [
        T,
        L,
        R
    ]), $lCzvA.useEffect(()=>{
        if (C) return l && (S.layersWithOutsidePointerEventsDisabled.size === 0 && ($fb04d4ce1fe91315$var$d = T.body.style.pointerEvents, T.body.style.pointerEvents = "none"), S.layersWithOutsidePointerEventsDisabled.add(C)), S.layers.add(C), $fb04d4ce1fe91315$var$b(), ()=>{
            l && (S.layersWithOutsidePointerEventsDisabled.delete(C), S.layersWithOutsidePointerEventsDisabled.size === 0 && (T.body.style.pointerEvents = $fb04d4ce1fe91315$var$d));
        };
    }, [
        C,
        T,
        l,
        S
    ]), $lCzvA.useEffect(()=>()=>{
            C && (S.layers.delete(C), S.layersWithOutsidePointerEventsDisabled.delete(C), $fb04d4ce1fe91315$var$b());
        }, [
        C,
        S
    ]), $lCzvA.useEffect(()=>{
        let e = ()=>E({});
        return document.addEventListener($fb04d4ce1fe91315$var$c, e), ()=>document.removeEventListener($fb04d4ce1fe91315$var$c, e);
    }, []), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).div, {
        ...x,
        ref: D,
        style: {
            pointerEvents: M ? N ? "auto" : "none" : void 0,
            ...r.style
        },
        onFocusCapture: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(r.onFocusCapture, I.onFocusCapture),
        onBlurCapture: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(r.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(r.onPointerDownCapture, F.onPointerDownCapture)
    });
});
$fb04d4ce1fe91315$export$177fb62ff3ec1f22.displayName = $fb04d4ce1fe91315$var$s;
var $fb04d4ce1fe91315$var$m = "DismissableLayerBranch", $fb04d4ce1fe91315$export$4d5eb2109db14228 = $lCzvA.forwardRef((e, r)=>{
    let i = $lCzvA.useContext($fb04d4ce1fe91315$var$f), s = $lCzvA.useRef(null), c = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(r, s);
    return $lCzvA.useEffect(()=>{
        let e = s.current;
        if (e) return i.branches.add(e), ()=>{
            i.branches.delete(e);
        };
    }, [
        i.branches
    ]), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).div, {
        ...e,
        ref: c
    });
});
$fb04d4ce1fe91315$export$4d5eb2109db14228.displayName = $fb04d4ce1fe91315$var$m;
function $fb04d4ce1fe91315$export$210785236bdfcb27() {
    let e = $lCzvA.useContext($fb04d4ce1fe91315$var$f), [t, n] = $lCzvA.useState(null);
    return $lCzvA.useEffect(()=>{
        if (t) return e.dismissableSurfaces.add(t), ()=>{
            e.dismissableSurfaces.delete(t);
        };
    }, [
        t,
        e.dismissableSurfaces
    ]), n;
}
var $fb04d4ce1fe91315$var$_ = ()=>!0;
function $fb04d4ce1fe91315$var$v(e, t) {
    let { ownerDocument: n = globalThis?.document, deferPointerDownOutside: r = !1, isDeferredPointerDownOutsideRef: o, dismissableSurfaces: s, shouldHandlePointerDownOutside: c = $fb04d4ce1fe91315$var$_ } = t, u = (0, $334703f027012d3d$export$25bec8c6f54ee79a)(e), d = $lCzvA.useRef(!1), f = $lCzvA.useRef(!1), p = $lCzvA.useRef(/* @__PURE__ */ new Map()), m = $lCzvA.useRef(()=>{});
    return $lCzvA.useEffect(()=>{
        function e() {
            f.current = !1, o.current = !1, p.current.clear();
        }
        function t() {
            return Array.from(p.current.values()).some(Boolean);
        }
        function i(e) {
            if (!f.current) return;
            let t = e.target;
            t instanceof Node && [
                ...s
            ].some((e)=>e.contains(t)) || p.current.set(e.type, !0), e.type === "click" && window.setTimeout(()=>{
                f.current && m.current();
            }, 0);
        }
        function a(e) {
            f.current && p.current.set(e.type, !1);
        }
        let h = (i)=>{
            if (i.target && !d.current) {
                let a = function() {
                    n.removeEventListener("click", m.current);
                    let r = t();
                    e(), r || $fb04d4ce1fe91315$var$x($fb04d4ce1fe91315$var$l, u, s, {
                        discrete: !0
                    });
                };
                if (!c(i.target)) {
                    n.removeEventListener("click", m.current), e(), d.current = !1;
                    return;
                }
                let s = {
                    originalEvent: i
                };
                f.current = !0, o.current = r && i.button === 0, p.current.clear(), !r || i.button !== 0 ? a() : (n.removeEventListener("click", m.current), m.current = a, n.addEventListener("click", m.current, {
                    once: !0
                }));
            } else n.removeEventListener("click", m.current), e();
            d.current = !1;
        }, g = [
            "pointerup",
            "mousedown",
            "mouseup",
            "touchstart",
            "touchend",
            "click"
        ];
        for (let e of g)n.addEventListener(e, i, !0), n.addEventListener(e, a);
        let _ = window.setTimeout(()=>{
            n.addEventListener("pointerdown", h);
        }, 0);
        return ()=>{
            window.clearTimeout(_), n.removeEventListener("pointerdown", h), n.removeEventListener("click", m.current);
            for (let e of g)n.removeEventListener(e, i, !0), n.removeEventListener(e, a);
        };
    }, [
        n,
        u,
        r,
        o,
        s,
        c
    ]), {
        onPointerDownCapture: ()=>d.current = !0
    };
}
function $fb04d4ce1fe91315$var$y(e, t = globalThis?.document) {
    let n = (0, $334703f027012d3d$export$25bec8c6f54ee79a)(e), r = $lCzvA.useRef(!1);
    return $lCzvA.useEffect(()=>{
        let e = (e)=>{
            e.target && !r.current && $fb04d4ce1fe91315$var$x($fb04d4ce1fe91315$var$u, n, {
                originalEvent: e
            }, {
                discrete: !1
            });
        };
        return t.addEventListener("focusin", e), ()=>t.removeEventListener("focusin", e);
    }, [
        t,
        n
    ]), {
        onFocusCapture: ()=>r.current = !0,
        onBlurCapture: ()=>r.current = !1
    };
}
function $fb04d4ce1fe91315$var$b() {
    let e = new CustomEvent($fb04d4ce1fe91315$var$c);
    document.dispatchEvent(e);
}
function $fb04d4ce1fe91315$var$x(e, t, n, { discrete: i }) {
    let a = n.originalEvent.target, o = new CustomEvent(e, {
        bubbles: !1,
        cancelable: !0,
        detail: n
    });
    t && a.addEventListener(e, t, {
        once: !0
    }), i ? (0, $3fe2937b6970d85d$export$6d1a0317bde7de7f)(a, o) : a.dispatchEvent(o);
}






var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var $a89c400092b04111$var$a = "focusScope.autoFocusOnMount", $a89c400092b04111$var$o = "focusScope.autoFocusOnUnmount", $a89c400092b04111$var$s = {
    bubbles: !1,
    cancelable: !0
}, $a89c400092b04111$var$c = "FocusScope", $a89c400092b04111$export$20e40289641fbbb6 = $lCzvA.forwardRef((c, l)=>{
    let { loop: p = !1, trapped: m = !1, onMountAutoFocus: h, onUnmountAutoFocus: v, ...y } = c, [x, S] = $lCzvA.useState(null), C = (0, $334703f027012d3d$export$25bec8c6f54ee79a)(h), w = (0, $334703f027012d3d$export$25bec8c6f54ee79a)(v), T = $lCzvA.useRef(null), E = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(l, S), D = $lCzvA.useRef({
        paused: !1,
        pause () {
            this.paused = !0;
        },
        resume () {
            this.paused = !1;
        }
    }).current;
    $lCzvA.useEffect(()=>{
        if (m) {
            let e = function(e) {
                if (D.paused || !x) return;
                let t = e.target;
                x.contains(t) ? T.current = t : $a89c400092b04111$var$g(T.current, {
                    select: !0
                });
            }, t = function(e) {
                if (D.paused || !x) return;
                let t = e.relatedTarget;
                t !== null && (x.contains(t) || $a89c400092b04111$var$g(T.current, {
                    select: !0
                }));
            }, n = function(e) {
                if (document.activeElement === document.body) for (let t of e)t.removedNodes.length > 0 && $a89c400092b04111$var$g(x);
            };
            document.addEventListener("focusin", e), document.addEventListener("focusout", t);
            let r = new MutationObserver(n);
            return x && r.observe(x, {
                childList: !0,
                subtree: !0
            }), ()=>{
                document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
            };
        }
    }, [
        m,
        x,
        D.paused
    ]), $lCzvA.useEffect(()=>{
        if (x) {
            $a89c400092b04111$var$_.add(D);
            let e = document.activeElement;
            if (!x.contains(e)) {
                let t = new CustomEvent($a89c400092b04111$var$a, $a89c400092b04111$var$s);
                x.addEventListener($a89c400092b04111$var$a, C), x.dispatchEvent(t), t.defaultPrevented || ($a89c400092b04111$var$u($a89c400092b04111$var$b($a89c400092b04111$var$f(x)), {
                    select: !0
                }), document.activeElement === e && $a89c400092b04111$var$g(x));
            }
            return ()=>{
                x.removeEventListener($a89c400092b04111$var$a, C), setTimeout(()=>{
                    let t = new CustomEvent($a89c400092b04111$var$o, $a89c400092b04111$var$s);
                    x.addEventListener($a89c400092b04111$var$o, w), x.dispatchEvent(t), t.defaultPrevented || $a89c400092b04111$var$g(e ?? document.body, {
                        select: !0
                    }), x.removeEventListener($a89c400092b04111$var$o, w), $a89c400092b04111$var$_.remove(D);
                }, 0);
            };
        }
    }, [
        x,
        C,
        w,
        D
    ]);
    let O = $lCzvA.useCallback((e)=>{
        if (!p && !m || D.paused) return;
        let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, n = document.activeElement;
        if (t && n) {
            let t = e.currentTarget, [r, i] = $a89c400092b04111$var$d(t);
            r && i ? !e.shiftKey && n === i ? (e.preventDefault(), p && $a89c400092b04111$var$g(r, {
                select: !0
            })) : e.shiftKey && n === r && (e.preventDefault(), p && $a89c400092b04111$var$g(i, {
                select: !0
            })) : n === t && e.preventDefault();
        }
    }, [
        p,
        m,
        D.paused
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...y,
        ref: E,
        onKeyDown: O
    });
});
$a89c400092b04111$export$20e40289641fbbb6.displayName = $a89c400092b04111$var$c;
function $a89c400092b04111$var$u(e, { select: t = !1 } = {}) {
    let n = document.activeElement;
    for (let r of e)if ($a89c400092b04111$var$g(r, {
        select: t
    }), document.activeElement !== n) return;
}
function $a89c400092b04111$var$d(e) {
    let t = $a89c400092b04111$var$f(e);
    return [
        $a89c400092b04111$var$p(t, e),
        $a89c400092b04111$var$p(t.reverse(), e)
    ];
}
function $a89c400092b04111$var$f(e) {
    let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (e)=>{
            let t = e.tagName === "INPUT" && e.type === "hidden";
            return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    for(; n.nextNode();)t.push(n.currentNode);
    return t;
}
function $a89c400092b04111$var$p(e, t) {
    let n = typeof t.checkVisibility == "function" && t.checkVisibility({
        checkVisibilityCSS: !0
    });
    for (let r of e)if (!(n ? !r.checkVisibility({
        checkVisibilityCSS: !0
    }) : $a89c400092b04111$var$m(r, {
        upTo: t
    }))) return r;
}
function $a89c400092b04111$var$m(e, { upTo: t }) {
    if (getComputedStyle(e).visibility === "hidden") return !0;
    for(; e;){
        if (t !== void 0 && e === t) return !1;
        if (getComputedStyle(e).display === "none") return !0;
        e = e.parentElement;
    }
    return !1;
}
function $a89c400092b04111$var$h(e) {
    return e instanceof HTMLInputElement && "select" in e;
}
function $a89c400092b04111$var$g(e, { select: t = !1 } = {}) {
    if (e && e.focus) {
        let n = document.activeElement;
        e.focus({
            preventScroll: !0
        }), e !== n && $a89c400092b04111$var$h(e) && t && e.select();
    }
}
var $a89c400092b04111$var$_ = $a89c400092b04111$var$v();
function $a89c400092b04111$var$v() {
    let e = [];
    return {
        add (t) {
            let n = e[0];
            t !== n && n?.pause(), e = $a89c400092b04111$var$y(e, t), e.unshift(t);
        },
        remove (t) {
            e = $a89c400092b04111$var$y(e, t), e[0]?.resume();
        }
    };
}
function $a89c400092b04111$var$y(e, t) {
    let n = [
        ...e
    ], r = n.indexOf(t);
    return r !== -1 && n.splice(r, 1), n;
}
function $a89c400092b04111$var$b(e) {
    return e.filter((e)=>e.tagName !== "A");
}





var $lCzvA = parcelRequire("lCzvA");


var $dAQd3 = parcelRequire("dAQd3");
"use client";
//#region node_modules/@radix-ui/react-portal/dist/index.mjs
var $9bc4a16530321c60$var$a = "Portal", $9bc4a16530321c60$export$602eac185826482c = $lCzvA.forwardRef((a, o)=>{
    let { container: s, ...c } = a, [l, u] = $lCzvA.useState(!1);
    (0, $62d8013ac651591c$export$e5c5a5f917a5871c)(()=>u(!0), []);
    let d = s || l && globalThis?.document?.body;
    return d ? $dAQd3.createPortal(/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).div, {
        ...c,
        ref: o
    }), d) : null;
});
$9bc4a16530321c60$export$602eac185826482c.displayName = $9bc4a16530321c60$var$a;




var $lCzvA = parcelRequire("lCzvA");
"use client";
//#region node_modules/@radix-ui/react-presence/dist/index.mjs
function $0682faac15a06e68$var$n(e, n) {
    return $lCzvA.useReducer((e, t)=>n[e][t] ?? e, e);
}
var $0682faac15a06e68$export$99c2b779aa4e8b8b = (e)=>{
    let { present: n, children: r } = e, a = $0682faac15a06e68$var$i(n), s = typeof r == "function" ? r({
        present: a.isPresent
    }) : $lCzvA.Children.only(r), l = $0682faac15a06e68$var$o(a.ref, $0682faac15a06e68$var$c(s));
    return typeof r == "function" || a.isPresent ? $lCzvA.cloneElement(s, {
        ref: l
    }) : null;
};
$0682faac15a06e68$export$99c2b779aa4e8b8b.displayName = "Presence";
function $0682faac15a06e68$var$i(r) {
    let [i, a] = $lCzvA.useState(), o = $lCzvA.useRef(null), c = $lCzvA.useRef(r), l = $lCzvA.useRef("none"), u = $lCzvA.useRef(void 0), [d, f] = $0682faac15a06e68$var$n(r ? "mounted" : "unmounted", {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    return $lCzvA.useEffect(()=>{
        d === "mounted" ? (l.current = u.current ?? $0682faac15a06e68$var$s(o.current), u.current = void 0) : l.current = "none";
    }, [
        d
    ]), (0, $62d8013ac651591c$export$e5c5a5f917a5871c)(()=>{
        let e = o.current, t = c.current;
        if (t !== r) {
            let n = l.current, i = $0682faac15a06e68$var$s(e);
            r ? (u.current = i, f("MOUNT")) : i === "none" || e?.display === "none" ? f("UNMOUNT") : f(t && n !== i ? "ANIMATION_OUT" : "UNMOUNT"), c.current = r;
        }
    }, [
        r,
        f
    ]), (0, $62d8013ac651591c$export$e5c5a5f917a5871c)(()=>{
        if (i) {
            let e, t = i.ownerDocument.defaultView ?? window, n = (n)=>{
                let r = $0682faac15a06e68$var$s(o.current).includes(CSS.escape(n.animationName));
                if (n.target === i && r && (f("ANIMATION_END"), !c.current)) {
                    let n = i.style.animationFillMode;
                    i.style.animationFillMode = "forwards", e = t.setTimeout(()=>{
                        i.style.animationFillMode === "forwards" && (i.style.animationFillMode = n);
                    });
                }
            }, r = (e)=>{
                e.target === i && (l.current = $0682faac15a06e68$var$s(o.current));
            };
            return i.addEventListener("animationstart", r), i.addEventListener("animationcancel", n), i.addEventListener("animationend", n), ()=>{
                t.clearTimeout(e), i.removeEventListener("animationstart", r), i.removeEventListener("animationcancel", n), i.removeEventListener("animationend", n);
            };
        } else f("ANIMATION_END");
    }, [
        i,
        f
    ]), {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(d),
        ref: $lCzvA.useCallback((e)=>{
            if (e) {
                let t = getComputedStyle(e);
                o.current = t, u.current = $0682faac15a06e68$var$s(t);
            } else o.current = null;
            a(e);
        }, [])
    };
}
function $0682faac15a06e68$var$a(e, t) {
    if (typeof e == "function") return e(t);
    e != null && (e.current = t);
}
function $0682faac15a06e68$var$o(...e) {
    let n = $lCzvA.useRef(e);
    return n.current = e, $lCzvA.useCallback((e)=>{
        let t = n.current, r = !1, i = t.map((t)=>{
            let n = $0682faac15a06e68$var$a(t, e);
            return !r && typeof n == "function" && (r = !0), n;
        });
        if (r) return ()=>{
            for(let e = 0; e < i.length; e++){
                let n = i[e];
                typeof n == "function" ? n() : $0682faac15a06e68$var$a(t[e], null);
            }
        };
    }, []);
}
function $0682faac15a06e68$var$s(e) {
    return e?.animationName || "none";
}
function $0682faac15a06e68$var$c(e) {
    let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
    return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}



var $lCzvA = parcelRequire("lCzvA");
"use client";
//#region node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var $2e5466663c5a0617$var$t = 0, $2e5466663c5a0617$var$n = null;
function $2e5466663c5a0617$export$b7ece24a22aeda8c() {
    $lCzvA.useEffect(()=>{
        $2e5466663c5a0617$var$n ||= {
            start: $2e5466663c5a0617$var$i(),
            end: $2e5466663c5a0617$var$i()
        };
        let { start: e, end: r } = $2e5466663c5a0617$var$n;
        return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== r && document.body.insertAdjacentElement("beforeend", r), $2e5466663c5a0617$var$t++, ()=>{
            $2e5466663c5a0617$var$t === 1 && ($2e5466663c5a0617$var$n?.start.remove(), $2e5466663c5a0617$var$n?.end.remove(), $2e5466663c5a0617$var$n = null), $2e5466663c5a0617$var$t = Math.max(0, $2e5466663c5a0617$var$t - 1);
        };
    }, []);
}
function $2e5466663c5a0617$var$i() {
    let e = document.createElement("span");
    return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}


//#region node_modules/tslib/tslib.es6.mjs
var $b53fa7852c176027$export$18ce0697a983be9b = function() {
    return $b53fa7852c176027$export$18ce0697a983be9b = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var i in t = arguments[n], t)Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e;
    }, $b53fa7852c176027$export$18ce0697a983be9b.apply(this, arguments);
};
function $b53fa7852c176027$export$3c9a16f847548506(e, t) {
    var n = {};
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (e != null && typeof Object.getOwnPropertySymbols == "function") for(var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
    return n;
}
function $b53fa7852c176027$export$1216008129fb82ed(e, t, n) {
    if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
    return e.concat(a || Array.prototype.slice.call(t));
}



//#region node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var $402f408775529f44$export$1da7500147d4bc3 = "right-scroll-bar-position", $402f408775529f44$export$898e37bbd2a0ae4e = "width-before-scroll-bar", $402f408775529f44$export$bb813dfbbc432abc = "with-scroll-bars-hidden", $402f408775529f44$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";


//#region node_modules/use-callback-ref/dist/es2015/assignRef.js
function $292a2c2b667c5004$export$d734136a7b018efe(e, t) {
    return typeof e == "function" ? e(t) : e && (e.current = t), e;
}



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/use-callback-ref/dist/es2015/useRef.js
function $273a55e5659e1c2b$export$25bec8c6f54ee79a(t, n) {
    var r = (0, $lCzvA.useState)(function() {
        return {
            value: t,
            callback: n,
            facade: {
                get current () {
                    return r.value;
                },
                set current (e){
                    var t1 = r.value;
                    t1 !== e && (r.value = e, r.callback(e, t1));
                }
            }
        };
    })[0];
    return r.callback = n, r.facade;
}



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var $bfadfad6833327f0$var$r = typeof window < "u" ? $lCzvA.useLayoutEffect : $lCzvA.useEffect, $bfadfad6833327f0$var$i = /* @__PURE__ */ new WeakMap();
function $bfadfad6833327f0$export$74665b213cb5c4cf(n, a) {
    var o = (0, $273a55e5659e1c2b$export$25bec8c6f54ee79a)(a || null, function(t) {
        return n.forEach(function(n) {
            return (0, $292a2c2b667c5004$export$d734136a7b018efe)(n, t);
        });
    });
    return $bfadfad6833327f0$var$r(function() {
        var t = $bfadfad6833327f0$var$i.get(o);
        if (t) {
            var r = new Set(t), a = new Set(n), s = o.current;
            r.forEach(function(t) {
                a.has(t) || (0, $292a2c2b667c5004$export$d734136a7b018efe)(t, null);
            }), a.forEach(function(t) {
                r.has(t) || (0, $292a2c2b667c5004$export$d734136a7b018efe)(t, s);
            });
        }
        $bfadfad6833327f0$var$i.set(o, n);
    }, [
        n
    ]), o;
}



//#region node_modules/use-sidecar/dist/es2015/medium.js
function $148d6d4eea7770ed$var$t(e) {
    return e;
}
function $148d6d4eea7770ed$var$n(e, n) {
    n === void 0 && (n = $148d6d4eea7770ed$var$t);
    var r = [], i = !1;
    return {
        read: function() {
            if (i) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            return r.length ? r[r.length - 1] : e;
        },
        useMedium: function(e) {
            var t = n(e, i);
            return r.push(t), function() {
                r = r.filter(function(e) {
                    return e !== t;
                });
            };
        },
        assignSyncMedium: function(e) {
            for(i = !0; r.length;){
                var t = r;
                r = [], t.forEach(e);
            }
            r = {
                push: function(t) {
                    return e(t);
                },
                filter: function() {
                    return r;
                }
            };
        },
        assignMedium: function(e) {
            i = !0;
            var t = [];
            if (r.length) {
                var n = r;
                r = [], n.forEach(e), t = r;
            }
            var a = function() {
                var n = t;
                t = [], n.forEach(e);
            }, o = function() {
                return Promise.resolve().then(a);
            };
            o(), r = {
                push: function(e) {
                    t.push(e), o();
                },
                filter: function(e) {
                    return t = t.filter(e), r;
                }
            };
        }
    };
}
function $148d6d4eea7770ed$export$e13ec7dd7a14088d(t) {
    t === void 0 && (t = {});
    var r = $148d6d4eea7770ed$var$n(null);
    return r.options = (0, $b53fa7852c176027$export$18ce0697a983be9b)({
        async: !0,
        ssr: !1
    }, t), r;
}


//#region node_modules/react-remove-scroll/dist/es2015/medium.js
var $f0e42c8d942983c2$export$e27363444bedfeac = (0, $148d6d4eea7770ed$export$e13ec7dd7a14088d)();



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/react-remove-scroll/dist/es2015/UI.js
var $1eecb515e4ef1b49$var$s = function() {}, $1eecb515e4ef1b49$export$22940b497e769dee = $lCzvA.forwardRef(function(n, r) {
    var c = $lCzvA.useRef(null), l = $lCzvA.useState({
        onScrollCapture: $1eecb515e4ef1b49$var$s,
        onWheelCapture: $1eecb515e4ef1b49$var$s,
        onTouchMoveCapture: $1eecb515e4ef1b49$var$s
    }), u = l[0], d = l[1], f = n.forwardProps, p = n.children, m = n.className, h = n.removeScrollBar, g = n.enabled, _ = n.shards, v = n.sideCar, y = n.noRelative, b = n.noIsolation, x = n.inert, S = n.allowPinchZoom, C = n.as, w = C === void 0 ? "div" : C, T = n.gapMode, E = (0, $b53fa7852c176027$export$3c9a16f847548506)(n, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]), D = v, O = (0, $bfadfad6833327f0$export$74665b213cb5c4cf)([
        c,
        r
    ]), k = (0, $b53fa7852c176027$export$18ce0697a983be9b)((0, $b53fa7852c176027$export$18ce0697a983be9b)({}, E), u);
    return $lCzvA.createElement($lCzvA.Fragment, null, g && $lCzvA.createElement(D, {
        sideCar: (0, $f0e42c8d942983c2$export$e27363444bedfeac),
        removeScrollBar: h,
        shards: _,
        noRelative: y,
        noIsolation: b,
        inert: x,
        setCallbacks: d,
        allowPinchZoom: !!S,
        lockRef: c,
        gapMode: T
    }), f ? $lCzvA.cloneElement($lCzvA.Children.only(p), (0, $b53fa7852c176027$export$18ce0697a983be9b)((0, $b53fa7852c176027$export$18ce0697a983be9b)({}, k), {
        ref: O
    })) : $lCzvA.createElement(w, (0, $b53fa7852c176027$export$18ce0697a983be9b)({}, k, {
        className: m,
        ref: O
    }), p));
});
$1eecb515e4ef1b49$export$22940b497e769dee.defaultProps = {
    enabled: !0,
    removeScrollBar: !0,
    inert: !1
}, $1eecb515e4ef1b49$export$22940b497e769dee.classNames = {
    fullWidth: (0, $402f408775529f44$export$898e37bbd2a0ae4e),
    zeroRight: (0, $402f408775529f44$export$1da7500147d4bc3)
};




var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/use-sidecar/dist/es2015/exports.js
var $2a7d6011b9cec26d$var$r = function(r) {
    var i = r.sideCar, a = (0, $b53fa7852c176027$export$3c9a16f847548506)(r, [
        "sideCar"
    ]);
    if (!i) throw Error("Sidecar: please provide `sideCar` property to import the right car");
    var o = i.read();
    if (!o) throw Error("Sidecar medium not found");
    return $lCzvA.createElement(o, (0, $b53fa7852c176027$export$18ce0697a983be9b)({}, a));
};
$2a7d6011b9cec26d$var$r.isSideCarExport = !0;
function $2a7d6011b9cec26d$export$6cacc8fb0a9b94ce(e, t) {
    return e.useMedium(t), $2a7d6011b9cec26d$var$r;
}




//#region node_modules/get-nonce/dist/es2015/index.js
var $1861bf941f8fffed$var$e, $1861bf941f8fffed$export$2b85b721e524d74b = function() {
    if ($1861bf941f8fffed$var$e) return $1861bf941f8fffed$var$e;
    if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};


//#region node_modules/react-style-singleton/dist/es2015/singleton.js
function $55cb225b2901d91f$var$t() {
    if (!document) return null;
    var t = document.createElement("style");
    t.type = "text/css";
    var n = (0, $1861bf941f8fffed$export$2b85b721e524d74b)();
    return n && t.setAttribute("nonce", n), t;
}
function $55cb225b2901d91f$var$n(e, t) {
    e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function $55cb225b2901d91f$var$r(e) {
    (document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var $55cb225b2901d91f$export$7c74eec858d5d226 = function() {
    var e = 0, i = null;
    return {
        add: function(a) {
            e == 0 && (i = $55cb225b2901d91f$var$t()) && ($55cb225b2901d91f$var$n(i, a), $55cb225b2901d91f$var$r(i)), e++;
        },
        remove: function() {
            e--, !e && i && (i.parentNode && i.parentNode.removeChild(i), i = null);
        }
    };
};



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/react-style-singleton/dist/es2015/hook.js
var $b284f890a42cdd2e$export$7d7b35c2d250e94c = function() {
    var n = (0, $55cb225b2901d91f$export$7c74eec858d5d226)();
    return function(e, r) {
        $lCzvA.useEffect(function() {
            return n.add(e), function() {
                n.remove();
            };
        }, [
            e && r
        ]);
    };
};


//#region node_modules/react-style-singleton/dist/es2015/component.js
var $22950b7fa78ecb99$export$c1248ee86ba532c8 = function() {
    var t = (0, $b284f890a42cdd2e$export$7d7b35c2d250e94c)();
    return function(e) {
        var n = e.styles, r = e.dynamic;
        return t(n, r), null;
    };
};






//#region node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var $c03449f8fcb7c51a$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
}, $c03449f8fcb7c51a$var$t = function(e) {
    return parseInt(e || "", 10) || 0;
}, $c03449f8fcb7c51a$var$n = function(e) {
    var n = window.getComputedStyle(document.body), r = n[e === "padding" ? "paddingLeft" : "marginLeft"], i = n[e === "padding" ? "paddingTop" : "marginTop"], a = n[e === "padding" ? "paddingRight" : "marginRight"];
    return [
        $c03449f8fcb7c51a$var$t(r),
        $c03449f8fcb7c51a$var$t(i),
        $c03449f8fcb7c51a$var$t(a)
    ];
}, $c03449f8fcb7c51a$export$75f2ca8f029c77f4 = function(t) {
    if (t === void 0 && (t = "margin"), typeof window > "u") return $c03449f8fcb7c51a$export$efed13b5d0ca3386;
    var r = $c03449f8fcb7c51a$var$n(t), i = document.documentElement.clientWidth, a = window.innerWidth;
    return {
        left: r[0],
        top: r[1],
        right: r[2],
        gap: Math.max(0, a - i + r[2] - r[0])
    };
};



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/react-remove-scroll-bar/dist/es2015/component.js
var $7b5178d700d25044$var$s = (0, $22950b7fa78ecb99$export$c1248ee86ba532c8)(), $7b5178d700d25044$export$65254d5f26cb9564 = "data-scroll-locked", $7b5178d700d25044$var$l = function(i, a, o, s) {
    var l = i.left, u = i.top, d = i.right, f = i.gap;
    return o === void 0 && (o = "margin"), `
  .${0, $402f408775529f44$export$bb813dfbbc432abc} {
   overflow: hidden ${s};
   padding-right: ${f}px ${s};
  }
  body[${$7b5178d700d25044$export$65254d5f26cb9564}] {
    overflow: hidden ${s};
    overscroll-behavior: contain;
    ${[
        a && `position: relative ${s};`,
        o === "margin" && `
    padding-left: ${l}px;
    padding-top: ${u}px;
    padding-right: ${d}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${f}px ${s};
    `,
        o === "padding" && `padding-right: ${f}px ${s};`
    ].filter(Boolean).join("")}
  }
  
  .${0, $402f408775529f44$export$1da7500147d4bc3} {
    right: ${f}px ${s};
  }
  
  .${0, $402f408775529f44$export$898e37bbd2a0ae4e} {
    margin-right: ${f}px ${s};
  }
  
  .${0, $402f408775529f44$export$1da7500147d4bc3} .${0, $402f408775529f44$export$1da7500147d4bc3} {
    right: 0 ${s};
  }
  
  .${0, $402f408775529f44$export$898e37bbd2a0ae4e} .${0, $402f408775529f44$export$898e37bbd2a0ae4e} {
    margin-right: 0 ${s};
  }
  
  body[${$7b5178d700d25044$export$65254d5f26cb9564}] {
    ${0, $402f408775529f44$export$63d0edf80fea83b1}: ${f}px;
  }
`;
}, $7b5178d700d25044$var$u = function() {
    var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
    return isFinite(e) ? e : 0;
}, $7b5178d700d25044$export$a1939b1f9f9b02dc = function() {
    $lCzvA.useEffect(function() {
        return document.body.setAttribute($7b5178d700d25044$export$65254d5f26cb9564, ($7b5178d700d25044$var$u() + 1).toString()), function() {
            var e = $7b5178d700d25044$var$u() - 1;
            e <= 0 ? document.body.removeAttribute($7b5178d700d25044$export$65254d5f26cb9564) : document.body.setAttribute($7b5178d700d25044$export$65254d5f26cb9564, e.toString());
        };
    }, []);
}, $7b5178d700d25044$export$9aa43b459c5ae9b9 = function(e) {
    var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
    $7b5178d700d25044$export$a1939b1f9f9b02dc();
    var c = $lCzvA.useMemo(function() {
        return (0, $c03449f8fcb7c51a$export$75f2ca8f029c77f4)(i);
    }, [
        i
    ]);
    return $lCzvA.createElement($7b5178d700d25044$var$s, {
        styles: $7b5178d700d25044$var$l(c, !t, i, n ? "" : "!important")
    });
};



//#region node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var $e2bdfe51c3a420cd$var$e = !1;
if (typeof window < "u") try {
    var $e2bdfe51c3a420cd$var$t = Object.defineProperty({}, "passive", {
        get: function() {
            return $e2bdfe51c3a420cd$var$e = !0, !0;
        }
    });
    window.addEventListener("test", $e2bdfe51c3a420cd$var$t, $e2bdfe51c3a420cd$var$t), window.removeEventListener("test", $e2bdfe51c3a420cd$var$t, $e2bdfe51c3a420cd$var$t);
} catch  {
    $e2bdfe51c3a420cd$var$e = !1;
}
var $e2bdfe51c3a420cd$export$10a6e88623fa9454 = $e2bdfe51c3a420cd$var$e ? {
    passive: !1
} : !1;


//#region node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var $e95c026dfb060a17$var$e = function(e) {
    return e.tagName === "TEXTAREA";
}, $e95c026dfb060a17$var$t = function(t, n) {
    if (!(t instanceof Element)) return !1;
    var r = window.getComputedStyle(t);
    return r[n] !== "hidden" && !(r.overflowY === r.overflowX && !$e95c026dfb060a17$var$e(t) && r[n] === "visible");
}, $e95c026dfb060a17$var$n = function(e) {
    return $e95c026dfb060a17$var$t(e, "overflowY");
}, $e95c026dfb060a17$var$r = function(e) {
    return $e95c026dfb060a17$var$t(e, "overflowX");
}, $e95c026dfb060a17$export$9ec64480cae49817 = function(e, t) {
    var n = t.ownerDocument, r = t;
    do {
        if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), $e95c026dfb060a17$var$s(e, r)) {
            var i = $e95c026dfb060a17$var$c(e, r);
            if (i[1] > i[2]) return !0;
        }
        r = r.parentNode;
    }while (r && r !== n.body);
    return !1;
}, $e95c026dfb060a17$var$a = function(e) {
    return [
        e.scrollTop,
        e.scrollHeight,
        e.clientHeight
    ];
}, $e95c026dfb060a17$var$o = function(e) {
    return [
        e.scrollLeft,
        e.scrollWidth,
        e.clientWidth
    ];
}, $e95c026dfb060a17$var$s = function(e, t) {
    return e === "v" ? $e95c026dfb060a17$var$n(t) : $e95c026dfb060a17$var$r(t);
}, $e95c026dfb060a17$var$c = function(e, t) {
    return e === "v" ? $e95c026dfb060a17$var$a(t) : $e95c026dfb060a17$var$o(t);
}, $e95c026dfb060a17$var$l = function(e, t) {
    return e === "h" && t === "rtl" ? -1 : 1;
}, $e95c026dfb060a17$export$dde0441bd4a6ded8 = function(e, t, n, r, i) {
    var a = $e95c026dfb060a17$var$l(e, window.getComputedStyle(t).direction), o = a * r, u = n.target, d = t.contains(u), f = !1, p = o > 0, m = 0, h = 0;
    do {
        if (!u) break;
        var g = $e95c026dfb060a17$var$c(e, u), _ = g[0], v = g[1] - g[2] - a * _;
        (_ || v) && $e95c026dfb060a17$var$s(e, u) && (m += v, h += _);
        var y = u.parentNode;
        u = y && y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? y.host : y;
    }while (!d && u !== document.body || d && (t.contains(u) || t === u));
    return (p && (i && Math.abs(m) < 1 || !i && o > m) || !p && (i && Math.abs(h) < 1 || !i && -o > h)) && (f = !0), f;
};



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/react-remove-scroll/dist/es2015/SideEffect.js
var $a85852b3f3ff950e$export$6e085704a79f4f56 = function(e) {
    return "changedTouches" in e ? [
        e.changedTouches[0].clientX,
        e.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
}, $a85852b3f3ff950e$export$39efaa2ca254a28d = function(e) {
    return [
        e.deltaX,
        e.deltaY
    ];
}, $a85852b3f3ff950e$var$l = function(e) {
    return e && "current" in e ? e.current : e;
}, $a85852b3f3ff950e$var$u = function(e, t) {
    return e[0] === t[0] && e[1] === t[1];
}, $a85852b3f3ff950e$var$d = function(e) {
    return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, $a85852b3f3ff950e$var$f = 0, $a85852b3f3ff950e$var$p = [];
function $a85852b3f3ff950e$export$a09dbff87b5da2d(m) {
    var g = $lCzvA.useRef([]), _ = $lCzvA.useRef([
        0,
        0
    ]), v = $lCzvA.useRef(), y = $lCzvA.useState($a85852b3f3ff950e$var$f++)[0], b = $lCzvA.useState((0, $22950b7fa78ecb99$export$c1248ee86ba532c8))[0], x = $lCzvA.useRef(m);
    $lCzvA.useEffect(function() {
        x.current = m;
    }, [
        m
    ]), $lCzvA.useEffect(function() {
        if (m.inert) {
            document.body.classList.add(`block-interactivity-${y}`);
            var t = (0, $b53fa7852c176027$export$1216008129fb82ed)([
                m.lockRef.current
            ], (m.shards || []).map($a85852b3f3ff950e$var$l), !0).filter(Boolean);
            return t.forEach(function(e) {
                return e.classList.add(`allow-interactivity-${y}`);
            }), function() {
                document.body.classList.remove(`block-interactivity-${y}`), t.forEach(function(e) {
                    return e.classList.remove(`allow-interactivity-${y}`);
                });
            };
        }
    }, [
        m.inert,
        m.lockRef.current,
        m.shards
    ]);
    var S = $lCzvA.useCallback(function(e, t) {
        if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !x.current.allowPinchZoom;
        var n = $a85852b3f3ff950e$export$6e085704a79f4f56(e), r = _.current, o = "deltaX" in e ? e.deltaX : r[0] - n[0], c = "deltaY" in e ? e.deltaY : r[1] - n[1], l, u = e.target, d = Math.abs(o) > Math.abs(c) ? "h" : "v";
        if ("touches" in e && d === "h" && u.type === "range") return !1;
        var f = window.getSelection(), p = f && f.anchorNode;
        if (p && (p === u || p.contains(u))) return !1;
        var m = (0, $e95c026dfb060a17$export$9ec64480cae49817)(d, u);
        if (!m) return !0;
        if (m ? l = d : (l = d === "v" ? "h" : "v", m = (0, $e95c026dfb060a17$export$9ec64480cae49817)(d, u)), !m) return !1;
        if (!v.current && "changedTouches" in e && (o || c) && (v.current = l), !l) return !0;
        var h = v.current || l;
        return (0, $e95c026dfb060a17$export$dde0441bd4a6ded8)(h, t, e, h === "h" ? o : c, !0);
    }, []), C = $lCzvA.useCallback(function(e) {
        var t = e;
        if (!(!$a85852b3f3ff950e$var$p.length || $a85852b3f3ff950e$var$p[$a85852b3f3ff950e$var$p.length - 1] !== b)) {
            var n = "deltaY" in t ? $a85852b3f3ff950e$export$39efaa2ca254a28d(t) : $a85852b3f3ff950e$export$6e085704a79f4f56(t), r = g.current.filter(function(e) {
                return e.name === t.type && (e.target === t.target || t.target === e.shadowParent) && $a85852b3f3ff950e$var$u(e.delta, n);
            })[0];
            if (r && r.should) {
                t.cancelable && t.preventDefault();
                return;
            }
            if (!r) {
                var i = (x.current.shards || []).map($a85852b3f3ff950e$var$l).filter(Boolean).filter(function(e) {
                    return e.contains(t.target);
                });
                (i.length > 0 ? S(t, i[0]) : !x.current.noIsolation) && t.cancelable && t.preventDefault();
            }
        }
    }, []), w = $lCzvA.useCallback(function(e, t, n, r) {
        var i = {
            name: e,
            delta: t,
            target: n,
            should: r,
            shadowParent: $a85852b3f3ff950e$var$h(n)
        };
        g.current.push(i), setTimeout(function() {
            g.current = g.current.filter(function(e) {
                return e !== i;
            });
        }, 1);
    }, []), T = $lCzvA.useCallback(function(e) {
        _.current = $a85852b3f3ff950e$export$6e085704a79f4f56(e), v.current = void 0;
    }, []), E = $lCzvA.useCallback(function(e) {
        w(e.type, $a85852b3f3ff950e$export$39efaa2ca254a28d(e), e.target, S(e, m.lockRef.current));
    }, []), D = $lCzvA.useCallback(function(e) {
        w(e.type, $a85852b3f3ff950e$export$6e085704a79f4f56(e), e.target, S(e, m.lockRef.current));
    }, []);
    $lCzvA.useEffect(function() {
        return $a85852b3f3ff950e$var$p.push(b), m.setCallbacks({
            onScrollCapture: E,
            onWheelCapture: E,
            onTouchMoveCapture: D
        }), document.addEventListener("wheel", C, (0, $e2bdfe51c3a420cd$export$10a6e88623fa9454)), document.addEventListener("touchmove", C, (0, $e2bdfe51c3a420cd$export$10a6e88623fa9454)), document.addEventListener("touchstart", T, (0, $e2bdfe51c3a420cd$export$10a6e88623fa9454)), function() {
            $a85852b3f3ff950e$var$p = $a85852b3f3ff950e$var$p.filter(function(e) {
                return e !== b;
            }), document.removeEventListener("wheel", C, (0, $e2bdfe51c3a420cd$export$10a6e88623fa9454)), document.removeEventListener("touchmove", C, (0, $e2bdfe51c3a420cd$export$10a6e88623fa9454)), document.removeEventListener("touchstart", T, (0, $e2bdfe51c3a420cd$export$10a6e88623fa9454));
        };
    }, []);
    var O = m.removeScrollBar, k = m.inert;
    return $lCzvA.createElement($lCzvA.Fragment, null, k ? $lCzvA.createElement(b, {
        styles: $a85852b3f3ff950e$var$d(y)
    }) : null, O ? $lCzvA.createElement((0, $7b5178d700d25044$export$9aa43b459c5ae9b9), {
        noRelative: m.noRelative,
        gapMode: m.gapMode
    }) : null);
}
function $a85852b3f3ff950e$var$h(e) {
    for(var t = null; e !== null;)e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
    return t;
}


//#region node_modules/react-remove-scroll/dist/es2015/sidecar.js
var $bb118670a4ce15db$export$2e2bcd8739ae039 = (0, $2a7d6011b9cec26d$export$6cacc8fb0a9b94ce)((0, $f0e42c8d942983c2$export$e27363444bedfeac), (0, $a85852b3f3ff950e$export$a09dbff87b5da2d));



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/react-remove-scroll/dist/es2015/Combination.js
var $0a8b5b0a247b3b3f$export$2e2bcd8739ae039 = $lCzvA.forwardRef(function(i, a) {
    return $lCzvA.createElement((0, $1eecb515e4ef1b49$export$22940b497e769dee), (0, $b53fa7852c176027$export$18ce0697a983be9b)({}, i, {
        ref: a,
        sideCar: (0, $bb118670a4ce15db$export$2e2bcd8739ae039)
    }));
});
$0a8b5b0a247b3b3f$export$2e2bcd8739ae039.classNames = (0, $1eecb515e4ef1b49$export$22940b497e769dee).classNames;


//#region node_modules/aria-hidden/dist/es2015/index.js
var $ff254d9dfc477fd4$var$e = function(e) {
    return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, $ff254d9dfc477fd4$var$t = /* @__PURE__ */ new WeakMap(), $ff254d9dfc477fd4$var$n = /* @__PURE__ */ new WeakMap(), $ff254d9dfc477fd4$var$r = {}, $ff254d9dfc477fd4$var$i = 0, $ff254d9dfc477fd4$var$a = function(e) {
    return e && (e.host || $ff254d9dfc477fd4$var$a(e.parentNode));
}, $ff254d9dfc477fd4$var$o = function(e, t) {
    return t.map(function(t) {
        if (e.contains(t)) return t;
        var n = $ff254d9dfc477fd4$var$a(t);
        return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
    }).filter(function(e) {
        return !!e;
    });
}, $ff254d9dfc477fd4$var$s = function(e, a, s, c) {
    var l = $ff254d9dfc477fd4$var$o(a, Array.isArray(e) ? e : [
        e
    ]);
    $ff254d9dfc477fd4$var$r[s] || ($ff254d9dfc477fd4$var$r[s] = /* @__PURE__ */ new WeakMap());
    var u = $ff254d9dfc477fd4$var$r[s], d = [], f = /* @__PURE__ */ new Set(), p = new Set(l), m = function(e) {
        !e || f.has(e) || (f.add(e), m(e.parentNode));
    };
    l.forEach(m);
    var h = function(e) {
        !e || p.has(e) || Array.prototype.forEach.call(e.children, function(e) {
            if (f.has(e)) h(e);
            else try {
                var r = e.getAttribute(c), i = r !== null && r !== "false", a = ($ff254d9dfc477fd4$var$t.get(e) || 0) + 1, o = (u.get(e) || 0) + 1;
                $ff254d9dfc477fd4$var$t.set(e, a), u.set(e, o), d.push(e), a === 1 && i && $ff254d9dfc477fd4$var$n.set(e, !0), o === 1 && e.setAttribute(s, "true"), i || e.setAttribute(c, "true");
            } catch (t) {
                console.error("aria-hidden: cannot operate on ", e, t);
            }
        });
    };
    return h(a), f.clear(), $ff254d9dfc477fd4$var$i++, function() {
        d.forEach(function(e) {
            var r = $ff254d9dfc477fd4$var$t.get(e) - 1, i = u.get(e) - 1;
            $ff254d9dfc477fd4$var$t.set(e, r), u.set(e, i), r || ($ff254d9dfc477fd4$var$n.has(e) || e.removeAttribute(c), $ff254d9dfc477fd4$var$n.delete(e)), i || e.removeAttribute(s);
        }), $ff254d9dfc477fd4$var$i--, $ff254d9dfc477fd4$var$i || ($ff254d9dfc477fd4$var$t = /* @__PURE__ */ new WeakMap(), $ff254d9dfc477fd4$var$t = /* @__PURE__ */ new WeakMap(), $ff254d9dfc477fd4$var$n = /* @__PURE__ */ new WeakMap(), $ff254d9dfc477fd4$var$r = {});
    };
}, $ff254d9dfc477fd4$export$6e33d16126ed003c = function(t, n, r) {
    r === void 0 && (r = "data-aria-hidden");
    var i = Array.from(Array.isArray(t) ? t : [
        t
    ]), a = n || $ff254d9dfc477fd4$var$e(t);
    return a ? (i.push.apply(i, Array.from(a.querySelectorAll("[aria-live], script"))), $ff254d9dfc477fd4$var$s(i, a, r, "aria-hidden")) : function() {
        return null;
    };
};







//#region node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var $ce406aabc9c91c42$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
], $ce406aabc9c91c42$export$96ec731ed4dcb222 = Math.min, $ce406aabc9c91c42$export$8960430cfd85939f = Math.max, $ce406aabc9c91c42$export$2077e0241d6afd3c = Math.round, $ce406aabc9c91c42$export$a3fe094919f356fd = Math.floor, $ce406aabc9c91c42$export$a397704b5e280835 = (e)=>({
        x: e,
        y: e
    }), $ce406aabc9c91c42$var$o = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $ce406aabc9c91c42$export$7d15b64cf5a3a4c4(e, r, i) {
    return $ce406aabc9c91c42$export$8960430cfd85939f(e, $ce406aabc9c91c42$export$96ec731ed4dcb222(r, i));
}
function $ce406aabc9c91c42$export$fef61f332f2c0afc(e, t) {
    return typeof e == "function" ? e(t) : e;
}
function $ce406aabc9c91c42$export$3c915306cb7fc97a(e) {
    return e.split("-")[0];
}
function $ce406aabc9c91c42$export$f0989780f32bfcda(e) {
    return e.split("-")[1];
}
function $ce406aabc9c91c42$export$8a000a963141ac32(e) {
    return e === "x" ? "y" : "x";
}
function $ce406aabc9c91c42$export$320bd9d53520c68a(e) {
    return e === "y" ? "height" : "width";
}
function $ce406aabc9c91c42$export$f28e8f882010718a(e) {
    let t = e[0];
    return t === "t" || t === "b" ? "y" : "x";
}
function $ce406aabc9c91c42$export$2b57e0052a6d6d4c(e) {
    return $ce406aabc9c91c42$export$8a000a963141ac32($ce406aabc9c91c42$export$f28e8f882010718a(e));
}
function $ce406aabc9c91c42$export$be42861551f17911(e, t, n) {
    n === void 0 && (n = !1);
    let r = $ce406aabc9c91c42$export$f0989780f32bfcda(e), i = $ce406aabc9c91c42$export$2b57e0052a6d6d4c(e), a = $ce406aabc9c91c42$export$320bd9d53520c68a(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
    return t.reference[a] > t.floating[a] && (o = $ce406aabc9c91c42$export$9c5e28bad23365fa(o)), [
        o,
        $ce406aabc9c91c42$export$9c5e28bad23365fa(o)
    ];
}
function $ce406aabc9c91c42$export$496432a3699e50b1(e) {
    let t = $ce406aabc9c91c42$export$9c5e28bad23365fa(e);
    return [
        $ce406aabc9c91c42$export$2b182c584985588b(e),
        t,
        $ce406aabc9c91c42$export$2b182c584985588b(t)
    ];
}
function $ce406aabc9c91c42$export$2b182c584985588b(e) {
    return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var $ce406aabc9c91c42$var$v = [
    "left",
    "right"
], $ce406aabc9c91c42$var$y = [
    "right",
    "left"
], $ce406aabc9c91c42$var$b = [
    "top",
    "bottom"
], $ce406aabc9c91c42$var$x = [
    "bottom",
    "top"
];
function $ce406aabc9c91c42$var$S(e, t, n) {
    switch(e){
        case "top":
        case "bottom":
            return n ? t ? $ce406aabc9c91c42$var$y : $ce406aabc9c91c42$var$v : t ? $ce406aabc9c91c42$var$v : $ce406aabc9c91c42$var$y;
        case "left":
        case "right":
            return t ? $ce406aabc9c91c42$var$b : $ce406aabc9c91c42$var$x;
        default:
            return [];
    }
}
function $ce406aabc9c91c42$export$a9b6fb18fd92c3ec(e, t, n, r) {
    let i = $ce406aabc9c91c42$export$f0989780f32bfcda(e), a = $ce406aabc9c91c42$var$S($ce406aabc9c91c42$export$3c915306cb7fc97a(e), n === "start", r);
    return i && (a = a.map((e)=>e + "-" + i), t && (a = a.concat(a.map($ce406aabc9c91c42$export$2b182c584985588b)))), a;
}
function $ce406aabc9c91c42$export$9c5e28bad23365fa(e) {
    let t = $ce406aabc9c91c42$export$3c915306cb7fc97a(e);
    return $ce406aabc9c91c42$var$o[t] + e.slice(t.length);
}
function $ce406aabc9c91c42$export$1c66dbf1a9e34223(e) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...e
    };
}
function $ce406aabc9c91c42$export$598c291c29bc2e71(e) {
    return typeof e == "number" ? {
        top: e,
        right: e,
        bottom: e,
        left: e
    } : $ce406aabc9c91c42$export$1c66dbf1a9e34223(e);
}
function $ce406aabc9c91c42$export$ee05aea0aeecbad4(e) {
    let { x: t, y: n, width: r, height: i } = e;
    return {
        width: r,
        height: i,
        top: n,
        left: t,
        right: t + r,
        bottom: n + i,
        x: t,
        y: n
    };
}



//#region node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function $a2b5c08367d68411$var$_(e, t, i) {
    let { reference: o, floating: s } = e, c = (0, $ce406aabc9c91c42$export$f28e8f882010718a)(t), l = (0, $ce406aabc9c91c42$export$2b57e0052a6d6d4c)(t), u = (0, $ce406aabc9c91c42$export$320bd9d53520c68a)(l), p = (0, $ce406aabc9c91c42$export$3c915306cb7fc97a)(t), m = c === "y", h = o.x + o.width / 2 - s.width / 2, g = o.y + o.height / 2 - s.height / 2, _ = o[u] / 2 - s[u] / 2, v;
    switch(p){
        case "top":
            v = {
                x: h,
                y: o.y - s.height
            };
            break;
        case "bottom":
            v = {
                x: h,
                y: o.y + o.height
            };
            break;
        case "right":
            v = {
                x: o.x + o.width,
                y: g
            };
            break;
        case "left":
            v = {
                x: o.x - s.width,
                y: g
            };
            break;
        default:
            v = {
                x: o.x,
                y: o.y
            };
    }
    switch((0, $ce406aabc9c91c42$export$f0989780f32bfcda)(t)){
        case "start":
            v[l] -= _ * (i && m ? -1 : 1);
            break;
        case "end":
            v[l] += _ * (i && m ? -1 : 1);
            break;
    }
    return v;
}
async function $a2b5c08367d68411$export$37b6bde19b108ecc(e, n) {
    n === void 0 && (n = {});
    let { x: r, y: i, platform: a, rects: o, elements: s, strategy: c } = e, { boundary: l = "clippingAncestors", rootBoundary: d = "viewport", elementContext: f = "floating", altBoundary: p = !1, padding: m = 0 } = (0, $ce406aabc9c91c42$export$fef61f332f2c0afc)(n, e), g = (0, $ce406aabc9c91c42$export$598c291c29bc2e71)(m), _ = s[p ? f === "floating" ? "reference" : "floating" : f], v = (0, $ce406aabc9c91c42$export$ee05aea0aeecbad4)(await a.getClippingRect({
        element: await (a.isElement == null ? void 0 : a.isElement(_)) ?? !0 ? _ : _.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
        boundary: l,
        rootBoundary: d,
        strategy: c
    })), y = f === "floating" ? {
        x: r,
        y: i,
        width: o.floating.width,
        height: o.floating.height
    } : o.reference, b = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), x = await (a.isElement == null ? void 0 : a.isElement(b)) && await (a.getScale == null ? void 0 : a.getScale(b)) || {
        x: 1,
        y: 1
    }, S = (0, $ce406aabc9c91c42$export$ee05aea0aeecbad4)(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: s,
        rect: y,
        offsetParent: b,
        strategy: c
    }) : y);
    return {
        top: (v.top - S.top + g.top) / x.y,
        bottom: (S.bottom - v.bottom + g.bottom) / x.y,
        left: (v.left - S.left + g.left) / x.x,
        right: (S.right - v.right + g.right) / x.x
    };
}
var $a2b5c08367d68411$var$y = 50, $a2b5c08367d68411$export$48a53dcb22e581d0 = async (e, t, n)=>{
    let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
        ...o,
        detectOverflow: $a2b5c08367d68411$export$37b6bde19b108ecc
    }, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
        reference: e,
        floating: t,
        strategy: i
    }), { x: u, y: d } = $a2b5c08367d68411$var$_(l, r, c), f = r, p = 0, m = {};
    for(let n = 0; n < a.length; n++){
        let h = a[n];
        if (!h) continue;
        let { name: g, fn: v } = h, { x: b, y: x, data: S, reset: C } = await v({
            x: u,
            y: d,
            initialPlacement: r,
            placement: f,
            strategy: i,
            middlewareData: m,
            rects: l,
            platform: s,
            elements: {
                reference: e,
                floating: t
            }
        });
        u = b ?? u, d = x ?? d, m[g] = {
            ...m[g],
            ...S
        }, C && p < $a2b5c08367d68411$var$y && (p++, typeof C == "object" && (C.placement && (f = C.placement), C.rects && (l = C.rects === !0 ? await o.getElementRects({
            reference: e,
            floating: t,
            strategy: i
        }) : C.rects), { x: u, y: d } = $a2b5c08367d68411$var$_(l, f, c)), n = -1);
    }
    return {
        x: u,
        y: d,
        placement: f,
        strategy: i,
        middlewareData: m
    };
}, $a2b5c08367d68411$export$f2120bbfa5450bd2 = (i)=>({
        name: "arrow",
        options: i,
        async fn (o) {
            let { x: s, y: c, placement: l, rects: d, platform: f, elements: p, middlewareData: h } = o, { element: g, padding: _ = 0 } = (0, $ce406aabc9c91c42$export$fef61f332f2c0afc)(i, o) || {};
            if (g == null) return {};
            let v = (0, $ce406aabc9c91c42$export$598c291c29bc2e71)(_), y = {
                x: s,
                y: c
            }, b = (0, $ce406aabc9c91c42$export$2b57e0052a6d6d4c)(l), x = (0, $ce406aabc9c91c42$export$320bd9d53520c68a)(b), S = await f.getDimensions(g), C = b === "y", w = C ? "top" : "left", T = C ? "bottom" : "right", E = C ? "clientHeight" : "clientWidth", D = d.reference[x] + d.reference[b] - y[b] - d.floating[x], O = y[b] - d.reference[b], k = await (f.getOffsetParent == null ? void 0 : f.getOffsetParent(g)), A = k ? k[E] : 0;
            (!A || !await (f.isElement == null ? void 0 : f.isElement(k))) && (A = p.floating[E] || d.floating[x]);
            let j = D / 2 - O / 2, M = A / 2 - S[x] / 2 - 1, N = (0, $ce406aabc9c91c42$export$96ec731ed4dcb222)(v[w], M), P = (0, $ce406aabc9c91c42$export$96ec731ed4dcb222)(v[T], M), F = N, I = A - S[x] - P, L = A / 2 - S[x] / 2 + j, R = (0, $ce406aabc9c91c42$export$7d15b64cf5a3a4c4)(F, L, I), z = !h.arrow && (0, $ce406aabc9c91c42$export$f0989780f32bfcda)(l) != null && L !== R && d.reference[x] / 2 - (L < F ? N : P) - S[x] / 2 < 0, B = z ? L < F ? L - F : L - I : 0;
            return {
                [b]: y[b] + B,
                data: {
                    [b]: R,
                    centerOffset: L - R - B,
                    ...z && {
                        alignmentOffset: B
                    }
                },
                reset: z
            };
        }
    }), $a2b5c08367d68411$export$8a83211c878a3f1f = function(e) {
    return e === void 0 && (e = {}), {
        name: "flip",
        options: e,
        async fn (n) {
            var r;
            let { placement: a, middlewareData: s, rects: u, initialPlacement: p, platform: m, elements: h } = n, { mainAxis: g = !0, crossAxis: _ = !0, fallbackPlacements: v, fallbackStrategy: y = "bestFit", fallbackAxisSideDirection: b = "none", flipAlignment: x = !0, ...S } = (0, $ce406aabc9c91c42$export$fef61f332f2c0afc)(e, n);
            if ((r = s.arrow) != null && r.alignmentOffset) return {};
            let C = (0, $ce406aabc9c91c42$export$3c915306cb7fc97a)(a), w = (0, $ce406aabc9c91c42$export$f28e8f882010718a)(p), T = (0, $ce406aabc9c91c42$export$3c915306cb7fc97a)(p) === p, E = await (m.isRTL == null ? void 0 : m.isRTL(h.floating)), D = v || (T || !x ? [
                (0, $ce406aabc9c91c42$export$9c5e28bad23365fa)(p)
            ] : (0, $ce406aabc9c91c42$export$496432a3699e50b1)(p)), O = b !== "none";
            !v && O && D.push(...(0, $ce406aabc9c91c42$export$a9b6fb18fd92c3ec)(p, x, b, E));
            let k = [
                p,
                ...D
            ], A = await m.detectOverflow(n, S), j = [], M = s.flip?.overflows || [];
            if (g && j.push(A[C]), _) {
                let e = (0, $ce406aabc9c91c42$export$be42861551f17911)(a, u, E);
                j.push(A[e[0]], A[e[1]]);
            }
            if (M = [
                ...M,
                {
                    placement: a,
                    overflows: j
                }
            ], !j.every((e)=>e <= 0)) {
                let e = (s.flip?.index || 0) + 1, t = k[e];
                if (t && (!(_ === "alignment" && w !== (0, $ce406aabc9c91c42$export$f28e8f882010718a)(t)) || M.every((e)=>(0, $ce406aabc9c91c42$export$f28e8f882010718a)(e.placement) !== w || e.overflows[0] > 0))) return {
                    data: {
                        index: e,
                        overflows: M
                    },
                    reset: {
                        placement: t
                    }
                };
                let n = M.filter((e)=>e.overflows[0] <= 0).sort((e, t)=>e.overflows[1] - t.overflows[1])[0]?.placement;
                if (!n) switch(y){
                    case "bestFit":
                        {
                            let e = M.filter((e)=>{
                                if (O) {
                                    let t = (0, $ce406aabc9c91c42$export$f28e8f882010718a)(e.placement);
                                    return t === w || t === "y";
                                }
                                return !0;
                            }).map((e)=>[
                                    e.placement,
                                    e.overflows.filter((e)=>e > 0).reduce((e, t)=>e + t, 0)
                                ]).sort((e, t)=>e[1] - t[1])[0]?.[0];
                            e && (n = e);
                            break;
                        }
                    case "initialPlacement":
                        n = p;
                        break;
                }
                if (a !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $a2b5c08367d68411$var$C(e, t) {
    return {
        top: e.top - t.height,
        right: e.right - t.width,
        bottom: e.bottom - t.height,
        left: e.left - t.width
    };
}
function $a2b5c08367d68411$var$w(e) {
    return (0, $ce406aabc9c91c42$export$832b6fa47fa053d2).some((t)=>e[t] >= 0);
}
var $a2b5c08367d68411$export$fe8985bb6374093c = function(e) {
    return e === void 0 && (e = {}), {
        name: "hide",
        options: e,
        async fn (n) {
            let { rects: r, platform: i } = n, { strategy: a = "referenceHidden", ...o } = (0, $ce406aabc9c91c42$export$fef61f332f2c0afc)(e, n);
            switch(a){
                case "referenceHidden":
                    {
                        let e = $a2b5c08367d68411$var$C(await i.detectOverflow(n, {
                            ...o,
                            elementContext: "reference"
                        }), r.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: e,
                                referenceHidden: $a2b5c08367d68411$var$w(e)
                            }
                        };
                    }
                case "escaped":
                    {
                        let e = $a2b5c08367d68411$var$C(await i.detectOverflow(n, {
                            ...o,
                            altBoundary: !0
                        }), r.floating);
                        return {
                            data: {
                                escapedOffsets: e,
                                escaped: $a2b5c08367d68411$var$w(e)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
}, $a2b5c08367d68411$var$E = /*#__PURE__*/ new Set([
    "left",
    "top"
]);
async function $a2b5c08367d68411$var$D(e, r) {
    let { placement: i, platform: a, elements: o } = e, s = await (a.isRTL == null ? void 0 : a.isRTL(o.floating)), c = (0, $ce406aabc9c91c42$export$3c915306cb7fc97a)(i), l = (0, $ce406aabc9c91c42$export$f0989780f32bfcda)(i), u = (0, $ce406aabc9c91c42$export$f28e8f882010718a)(i) === "y", p = $a2b5c08367d68411$var$E.has(c) ? -1 : 1, m = s && u ? -1 : 1, h = (0, $ce406aabc9c91c42$export$fef61f332f2c0afc)(r, e), { mainAxis: g, crossAxis: _, alignmentAxis: v } = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: h.mainAxis || 0,
        crossAxis: h.crossAxis || 0,
        alignmentAxis: h.alignmentAxis
    };
    return l && typeof v == "number" && (_ = l === "end" ? v * -1 : v), u ? {
        x: _ * m,
        y: g * p
    } : {
        x: g * p,
        y: _ * m
    };
}
var $a2b5c08367d68411$export$cc800923e997bb8 = function(e) {
    return e === void 0 && (e = 0), {
        name: "offset",
        options: e,
        async fn (t) {
            var n;
            let { x: r, y: i, placement: a, middlewareData: o } = t, s = await $a2b5c08367d68411$var$D(t, e);
            return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
                x: r + s.x,
                y: i + s.y,
                data: {
                    ...s,
                    placement: a
                }
            };
        }
    };
}, $a2b5c08367d68411$export$fba63a578e423eb = function(n) {
    return n === void 0 && (n = {}), {
        name: "shift",
        options: n,
        async fn (r) {
            let { x: i, y: a, placement: o, platform: c } = r, { mainAxis: l = !0, crossAxis: u = !1, limiter: p = {
                fn: (e)=>{
                    let { x: t, y: n } = e;
                    return {
                        x: t,
                        y: n
                    };
                }
            }, ...m } = (0, $ce406aabc9c91c42$export$fef61f332f2c0afc)(n, r), h = {
                x: i,
                y: a
            }, g = await c.detectOverflow(r, m), _ = (0, $ce406aabc9c91c42$export$f28e8f882010718a)((0, $ce406aabc9c91c42$export$3c915306cb7fc97a)(o)), v = (0, $ce406aabc9c91c42$export$8a000a963141ac32)(_), y = h[v], b = h[_];
            if (l) {
                let t = v === "y" ? "top" : "left", n = v === "y" ? "bottom" : "right", r = y + g[t], i = y - g[n];
                y = (0, $ce406aabc9c91c42$export$7d15b64cf5a3a4c4)(r, y, i);
            }
            if (u) {
                let t = _ === "y" ? "top" : "left", n = _ === "y" ? "bottom" : "right", r = b + g[t], i = b - g[n];
                b = (0, $ce406aabc9c91c42$export$7d15b64cf5a3a4c4)(r, b, i);
            }
            let x = p.fn({
                ...r,
                [v]: y,
                [_]: b
            });
            return {
                ...x,
                data: {
                    x: x.x - i,
                    y: x.y - a,
                    enabled: {
                        [v]: l,
                        [_]: u
                    }
                }
            };
        }
    };
}, $a2b5c08367d68411$export$7bf07e38f3dc4b69 = function(e) {
    return e === void 0 && (e = {}), {
        options: e,
        fn (n) {
            let { x: r, y: i, placement: a, rects: o, middlewareData: c } = n, { offset: l = 0, mainAxis: u = !0, crossAxis: p = !0 } = (0, $ce406aabc9c91c42$export$fef61f332f2c0afc)(e, n), m = {
                x: r,
                y: i
            }, h = (0, $ce406aabc9c91c42$export$f28e8f882010718a)(a), g = (0, $ce406aabc9c91c42$export$8a000a963141ac32)(h), _ = m[g], v = m[h], y = (0, $ce406aabc9c91c42$export$fef61f332f2c0afc)(l, n), b = typeof y == "number" ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (u) {
                let e = g === "y" ? "height" : "width", t = o.reference[g] - o.floating[e] + b.mainAxis, n = o.reference[g] + o.reference[e] - b.mainAxis;
                _ < t ? _ = t : _ > n && (_ = n);
            }
            if (p) {
                let e = g === "y" ? "width" : "height", t = $a2b5c08367d68411$var$E.has((0, $ce406aabc9c91c42$export$3c915306cb7fc97a)(a)), n = o.reference[h] - o.floating[e] + (t && c.offset?.[h] || 0) + (t ? 0 : b.crossAxis), r = o.reference[h] + o.reference[e] + (t ? 0 : c.offset?.[h] || 0) - (t ? b.crossAxis : 0);
                v < n ? v = n : v > r && (v = r);
            }
            return {
                [g]: _,
                [h]: v
            };
        }
    };
}, $a2b5c08367d68411$export$346677f925de839c = function(e) {
    return e === void 0 && (e = {}), {
        name: "size",
        options: e,
        async fn (r) {
            var i, a;
            let { placement: o, rects: s, platform: c, elements: l } = r, { apply: u = ()=>{}, ...h } = (0, $ce406aabc9c91c42$export$fef61f332f2c0afc)(e, r), g = await c.detectOverflow(r, h), _ = (0, $ce406aabc9c91c42$export$3c915306cb7fc97a)(o), v = (0, $ce406aabc9c91c42$export$f0989780f32bfcda)(o), y = (0, $ce406aabc9c91c42$export$f28e8f882010718a)(o) === "y", { width: b, height: x } = s.floating, S, C;
            _ === "top" || _ === "bottom" ? (S = _, C = v === (await (c.isRTL == null ? void 0 : c.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (C = _, S = v === "end" ? "top" : "bottom");
            let w = x - g.top - g.bottom, T = b - g.left - g.right, E = (0, $ce406aabc9c91c42$export$96ec731ed4dcb222)(x - g[S], w), D = (0, $ce406aabc9c91c42$export$96ec731ed4dcb222)(b - g[C], T), O = !r.middlewareData.shift, k = E, A = D;
            if ((i = r.middlewareData.shift) != null && i.enabled.x && (A = T), (a = r.middlewareData.shift) != null && a.enabled.y && (k = w), O && !v) {
                let e = (0, $ce406aabc9c91c42$export$8960430cfd85939f)(g.left, 0), t = (0, $ce406aabc9c91c42$export$8960430cfd85939f)(g.right, 0), n = (0, $ce406aabc9c91c42$export$8960430cfd85939f)(g.top, 0), r = (0, $ce406aabc9c91c42$export$8960430cfd85939f)(g.bottom, 0);
                y ? A = b - 2 * (e !== 0 || t !== 0 ? e + t : (0, $ce406aabc9c91c42$export$8960430cfd85939f)(g.left, g.right)) : k = x - 2 * (n !== 0 || r !== 0 ? n + r : (0, $ce406aabc9c91c42$export$8960430cfd85939f)(g.top, g.bottom));
            }
            await u({
                ...r,
                availableWidth: A,
                availableHeight: k
            });
            let j = await c.getDimensions(l.floating);
            return b !== j.width || x !== j.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};


//#region node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function $200bb32c06d44e06$var$e() {
    return typeof window < "u";
}
function $200bb32c06d44e06$export$651544f548703224(e) {
    return $200bb32c06d44e06$export$8ee0fc9ee280b4ee(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function $200bb32c06d44e06$export$38b2d434cce3ea22(e) {
    var t;
    return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function $200bb32c06d44e06$export$e495491855dc5418(e) {
    return (($200bb32c06d44e06$export$8ee0fc9ee280b4ee(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function $200bb32c06d44e06$export$8ee0fc9ee280b4ee(t) {
    return $200bb32c06d44e06$var$e() ? t instanceof Node || t instanceof $200bb32c06d44e06$export$38b2d434cce3ea22(t).Node : !1;
}
function $200bb32c06d44e06$export$45a5e7f76e0caa8d(t) {
    return $200bb32c06d44e06$var$e() ? t instanceof Element || t instanceof $200bb32c06d44e06$export$38b2d434cce3ea22(t).Element : !1;
}
function $200bb32c06d44e06$export$1b3bfaa9684536aa(t) {
    return $200bb32c06d44e06$var$e() ? t instanceof HTMLElement || t instanceof $200bb32c06d44e06$export$38b2d434cce3ea22(t).HTMLElement : !1;
}
function $200bb32c06d44e06$export$af51f0f06c0f328a(t) {
    return !$200bb32c06d44e06$var$e() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof $200bb32c06d44e06$export$38b2d434cce3ea22(t).ShadowRoot;
}
function $200bb32c06d44e06$export$989e911fa9af580a(e) {
    let { overflow: t, overflowX: n, overflowY: r, display: i } = $200bb32c06d44e06$export$3735103072e4a80(e);
    return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function $200bb32c06d44e06$export$71535ffaa902797f(e) {
    return /^(table|td|th)$/.test($200bb32c06d44e06$export$651544f548703224(e));
}
function $200bb32c06d44e06$export$89e651af02346cd4(e) {
    try {
        if (e.matches(":popover-open")) return !0;
    } catch  {}
    try {
        return e.matches(":modal");
    } catch  {
        return !1;
    }
}
var $200bb32c06d44e06$var$d = /transform|translate|scale|rotate|perspective|filter/, $200bb32c06d44e06$var$f = /paint|layout|strict|content/, $200bb32c06d44e06$var$p = (e)=>!!e && e !== "none", $200bb32c06d44e06$var$m;
function $200bb32c06d44e06$export$d6c4e8150c35fed1(e) {
    let t = $200bb32c06d44e06$export$45a5e7f76e0caa8d(e) ? $200bb32c06d44e06$export$3735103072e4a80(e) : e;
    return $200bb32c06d44e06$var$p(t.transform) || $200bb32c06d44e06$var$p(t.translate) || $200bb32c06d44e06$var$p(t.scale) || $200bb32c06d44e06$var$p(t.rotate) || $200bb32c06d44e06$var$p(t.perspective) || !$200bb32c06d44e06$export$78551043582a6a98() && ($200bb32c06d44e06$var$p(t.backdropFilter) || $200bb32c06d44e06$var$p(t.filter)) || $200bb32c06d44e06$var$d.test(t.willChange || "") || $200bb32c06d44e06$var$f.test(t.contain || "");
}
function $200bb32c06d44e06$export$940d8225183e1404(e) {
    let t = $200bb32c06d44e06$export$4e12058fc4d51d56(e);
    for(; $200bb32c06d44e06$export$1b3bfaa9684536aa(t) && !$200bb32c06d44e06$export$d1162fb0b6d4cd51(t);){
        if ($200bb32c06d44e06$export$d6c4e8150c35fed1(t)) return t;
        if ($200bb32c06d44e06$export$89e651af02346cd4(t)) return null;
        t = $200bb32c06d44e06$export$4e12058fc4d51d56(t);
    }
    return null;
}
function $200bb32c06d44e06$export$78551043582a6a98() {
    return $200bb32c06d44e06$var$m ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), $200bb32c06d44e06$var$m;
}
function $200bb32c06d44e06$export$d1162fb0b6d4cd51(e) {
    return /^(html|body|#document)$/.test($200bb32c06d44e06$export$651544f548703224(e));
}
function $200bb32c06d44e06$export$3735103072e4a80(e) {
    return $200bb32c06d44e06$export$38b2d434cce3ea22(e).getComputedStyle(e);
}
function $200bb32c06d44e06$export$dc8fc79fa2800137(e) {
    return $200bb32c06d44e06$export$45a5e7f76e0caa8d(e) ? {
        scrollLeft: e.scrollLeft,
        scrollTop: e.scrollTop
    } : {
        scrollLeft: e.scrollX,
        scrollTop: e.scrollY
    };
}
function $200bb32c06d44e06$export$4e12058fc4d51d56(e) {
    if ($200bb32c06d44e06$export$651544f548703224(e) === "html") return e;
    let n = e.assignedSlot || e.parentNode || $200bb32c06d44e06$export$af51f0f06c0f328a(e) && e.host || $200bb32c06d44e06$export$e495491855dc5418(e);
    return $200bb32c06d44e06$export$af51f0f06c0f328a(n) ? n.host : n;
}
function $200bb32c06d44e06$export$7cd01a57c8ca906c(e) {
    let t = $200bb32c06d44e06$export$4e12058fc4d51d56(e);
    return $200bb32c06d44e06$export$d1162fb0b6d4cd51(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : $200bb32c06d44e06$export$1b3bfaa9684536aa(t) && $200bb32c06d44e06$export$989e911fa9af580a(t) ? t : $200bb32c06d44e06$export$7cd01a57c8ca906c(t);
}
function $200bb32c06d44e06$export$3b57c1601291186b(e, t, r) {
    t === void 0 && (t = []), r === void 0 && (r = !0);
    let i = $200bb32c06d44e06$export$7cd01a57c8ca906c(e), a = i === e.ownerDocument?.body, o = $200bb32c06d44e06$export$38b2d434cce3ea22(i);
    if (a) {
        let e = $200bb32c06d44e06$export$7bf1f8740e3e34af(o);
        return t.concat(o, o.visualViewport || [], $200bb32c06d44e06$export$989e911fa9af580a(i) ? i : [], e && r ? $200bb32c06d44e06$export$3b57c1601291186b(e) : []);
    } else return t.concat(i, $200bb32c06d44e06$export$3b57c1601291186b(i, [], r));
}
function $200bb32c06d44e06$export$7bf1f8740e3e34af(e) {
    return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}


//#region node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function $764a54598a6d272a$var$A(e) {
    let t = (0, $200bb32c06d44e06$export$3735103072e4a80)(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = (0, $200bb32c06d44e06$export$1b3bfaa9684536aa)(e), o = i ? e.offsetWidth : n, s = i ? e.offsetHeight : r, c = (0, $ce406aabc9c91c42$export$2077e0241d6afd3c)(n) !== o || (0, $ce406aabc9c91c42$export$2077e0241d6afd3c)(r) !== s;
    return c && (n = o, r = s), {
        width: n,
        height: r,
        $: c
    };
}
function $764a54598a6d272a$var$j(e) {
    return (0, $200bb32c06d44e06$export$45a5e7f76e0caa8d)(e) ? e : e.contextElement;
}
function $764a54598a6d272a$var$M(t) {
    let n = $764a54598a6d272a$var$j(t);
    if (!(0, $200bb32c06d44e06$export$1b3bfaa9684536aa)(n)) return (0, $ce406aabc9c91c42$export$a397704b5e280835)(1);
    let r = n.getBoundingClientRect(), { width: i, height: o, $: s } = $764a54598a6d272a$var$A(n), c = (s ? (0, $ce406aabc9c91c42$export$2077e0241d6afd3c)(r.width) : r.width) / i, l = (s ? (0, $ce406aabc9c91c42$export$2077e0241d6afd3c)(r.height) : r.height) / o;
    return (!c || !Number.isFinite(c)) && (c = 1), (!l || !Number.isFinite(l)) && (l = 1), {
        x: c,
        y: l
    };
}
var $764a54598a6d272a$var$N = /*#__PURE__*/ (0, $ce406aabc9c91c42$export$a397704b5e280835)(0);
function $764a54598a6d272a$var$P(e) {
    let t = (0, $200bb32c06d44e06$export$38b2d434cce3ea22)(e);
    return !(0, $200bb32c06d44e06$export$78551043582a6a98)() || !t.visualViewport ? $764a54598a6d272a$var$N : {
        x: t.visualViewport.offsetLeft,
        y: t.visualViewport.offsetTop
    };
}
function $764a54598a6d272a$var$F(e, t, n) {
    return t === void 0 && (t = !1), !n || t && n !== (0, $200bb32c06d44e06$export$38b2d434cce3ea22)(e) ? !1 : t;
}
function $764a54598a6d272a$var$I(t, n, r, a) {
    n === void 0 && (n = !1), r === void 0 && (r = !1);
    let o = t.getBoundingClientRect(), s = $764a54598a6d272a$var$j(t), c = (0, $ce406aabc9c91c42$export$a397704b5e280835)(1);
    n && (a ? (0, $200bb32c06d44e06$export$45a5e7f76e0caa8d)(a) && (c = $764a54598a6d272a$var$M(a)) : c = $764a54598a6d272a$var$M(t));
    let l = $764a54598a6d272a$var$F(s, r, a) ? $764a54598a6d272a$var$P(s) : (0, $ce406aabc9c91c42$export$a397704b5e280835)(0), u = (o.left + l.x) / c.x, d = (o.top + l.y) / c.y, f = o.width / c.x, p = o.height / c.y;
    if (s) {
        let e = (0, $200bb32c06d44e06$export$38b2d434cce3ea22)(s), t = a && (0, $200bb32c06d44e06$export$45a5e7f76e0caa8d)(a) ? (0, $200bb32c06d44e06$export$38b2d434cce3ea22)(a) : a, n = e, r = (0, $200bb32c06d44e06$export$7bf1f8740e3e34af)(n);
        for(; r && a && t !== n;){
            let e = $764a54598a6d272a$var$M(r), t = r.getBoundingClientRect(), i = (0, $200bb32c06d44e06$export$3735103072e4a80)(r), a = t.left + (r.clientLeft + parseFloat(i.paddingLeft)) * e.x, o = t.top + (r.clientTop + parseFloat(i.paddingTop)) * e.y;
            u *= e.x, d *= e.y, f *= e.x, p *= e.y, u += a, d += o, n = (0, $200bb32c06d44e06$export$38b2d434cce3ea22)(r), r = (0, $200bb32c06d44e06$export$7bf1f8740e3e34af)(n);
        }
    }
    return (0, $ce406aabc9c91c42$export$ee05aea0aeecbad4)({
        width: f,
        height: p,
        x: u,
        y: d
    });
}
function $764a54598a6d272a$var$L(e, t) {
    let n = (0, $200bb32c06d44e06$export$dc8fc79fa2800137)(e).scrollLeft;
    return t ? t.left + n : $764a54598a6d272a$var$I((0, $200bb32c06d44e06$export$e495491855dc5418)(e)).left + n;
}
function $764a54598a6d272a$var$R(e, t) {
    let n = e.getBoundingClientRect();
    return {
        x: n.left + t.scrollLeft - $764a54598a6d272a$var$L(e, n),
        y: n.top + t.scrollTop
    };
}
function $764a54598a6d272a$var$te(t) {
    let { elements: n, rect: r, offsetParent: i, strategy: a } = t, o = a === "fixed", s = (0, $200bb32c06d44e06$export$e495491855dc5418)(i), c = n ? (0, $200bb32c06d44e06$export$89e651af02346cd4)(n.floating) : !1;
    if (i === s || c && o) return r;
    let l = {
        scrollLeft: 0,
        scrollTop: 0
    }, u = (0, $ce406aabc9c91c42$export$a397704b5e280835)(1), d = (0, $ce406aabc9c91c42$export$a397704b5e280835)(0), f = (0, $200bb32c06d44e06$export$1b3bfaa9684536aa)(i);
    if ((f || !f && !o) && (((0, $200bb32c06d44e06$export$651544f548703224)(i) !== "body" || (0, $200bb32c06d44e06$export$989e911fa9af580a)(s)) && (l = (0, $200bb32c06d44e06$export$dc8fc79fa2800137)(i)), f)) {
        let e = $764a54598a6d272a$var$I(i);
        u = $764a54598a6d272a$var$M(i), d.x = e.x + i.clientLeft, d.y = e.y + i.clientTop;
    }
    let p = s && !f && !o ? $764a54598a6d272a$var$R(s, l) : (0, $ce406aabc9c91c42$export$a397704b5e280835)(0);
    return {
        width: r.width * u.x,
        height: r.height * u.y,
        x: r.x * u.x - l.scrollLeft * u.x + d.x + p.x,
        y: r.y * u.y - l.scrollTop * u.y + d.y + p.y
    };
}
function $764a54598a6d272a$var$z(e) {
    return Array.from(e.getClientRects());
}
function $764a54598a6d272a$var$B(e) {
    let t = (0, $200bb32c06d44e06$export$e495491855dc5418)(e), r = (0, $200bb32c06d44e06$export$dc8fc79fa2800137)(e), i = e.ownerDocument.body, a = (0, $ce406aabc9c91c42$export$8960430cfd85939f)(t.scrollWidth, t.clientWidth, i.scrollWidth, i.clientWidth), o = (0, $ce406aabc9c91c42$export$8960430cfd85939f)(t.scrollHeight, t.clientHeight, i.scrollHeight, i.clientHeight), s = -r.scrollLeft + $764a54598a6d272a$var$L(e), c = -r.scrollTop;
    return (0, $200bb32c06d44e06$export$3735103072e4a80)(i).direction === "rtl" && (s += (0, $ce406aabc9c91c42$export$8960430cfd85939f)(t.clientWidth, i.clientWidth) - a), {
        width: a,
        height: o,
        x: s,
        y: c
    };
}
var $764a54598a6d272a$var$V = 25;
function $764a54598a6d272a$var$ne(e, t) {
    let n = (0, $200bb32c06d44e06$export$38b2d434cce3ea22)(e), r = (0, $200bb32c06d44e06$export$e495491855dc5418)(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
    if (i) {
        a = i.width, o = i.height;
        let e = (0, $200bb32c06d44e06$export$78551043582a6a98)();
        (!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
    }
    let l = $764a54598a6d272a$var$L(r);
    if (l <= 0) {
        let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
        o <= $764a54598a6d272a$var$V && (a -= o);
    } else l <= $764a54598a6d272a$var$V && (a += l);
    return {
        width: a,
        height: o,
        x: s,
        y: c
    };
}
function $764a54598a6d272a$var$re(t, n) {
    let r = $764a54598a6d272a$var$I(t, !0, n === "fixed"), i = r.top + t.clientTop, a = r.left + t.clientLeft, o = (0, $200bb32c06d44e06$export$1b3bfaa9684536aa)(t) ? $764a54598a6d272a$var$M(t) : (0, $ce406aabc9c91c42$export$a397704b5e280835)(1);
    return {
        width: t.clientWidth * o.x,
        height: t.clientHeight * o.y,
        x: a * o.x,
        y: i * o.y
    };
}
function $764a54598a6d272a$var$H(e, t, n) {
    let r;
    if (t === "viewport") r = $764a54598a6d272a$var$ne(e, n);
    else if (t === "document") r = $764a54598a6d272a$var$B((0, $200bb32c06d44e06$export$e495491855dc5418)(e));
    else if ((0, $200bb32c06d44e06$export$45a5e7f76e0caa8d)(t)) r = $764a54598a6d272a$var$re(t, n);
    else {
        let n = $764a54598a6d272a$var$P(e);
        r = {
            x: t.x - n.x,
            y: t.y - n.y,
            width: t.width,
            height: t.height
        };
    }
    return (0, $ce406aabc9c91c42$export$ee05aea0aeecbad4)(r);
}
function $764a54598a6d272a$var$U(e, t) {
    let n = (0, $200bb32c06d44e06$export$4e12058fc4d51d56)(e);
    return n === t || !(0, $200bb32c06d44e06$export$45a5e7f76e0caa8d)(n) || (0, $200bb32c06d44e06$export$d1162fb0b6d4cd51)(n) ? !1 : (0, $200bb32c06d44e06$export$3735103072e4a80)(n).position === "fixed" || $764a54598a6d272a$var$U(n, t);
}
function $764a54598a6d272a$var$W(e, t) {
    let n = t.get(e);
    if (n) return n;
    let r = (0, $200bb32c06d44e06$export$3b57c1601291186b)(e, [], !1).filter((e)=>(0, $200bb32c06d44e06$export$45a5e7f76e0caa8d)(e) && (0, $200bb32c06d44e06$export$651544f548703224)(e) !== "body"), i = null, a = (0, $200bb32c06d44e06$export$3735103072e4a80)(e).position === "fixed", o = a ? (0, $200bb32c06d44e06$export$4e12058fc4d51d56)(e) : e;
    for(; (0, $200bb32c06d44e06$export$45a5e7f76e0caa8d)(o) && !(0, $200bb32c06d44e06$export$d1162fb0b6d4cd51)(o);){
        let t = (0, $200bb32c06d44e06$export$3735103072e4a80)(o), n = (0, $200bb32c06d44e06$export$d6c4e8150c35fed1)(o);
        !n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && (i.position === "absolute" || i.position === "fixed") || (0, $200bb32c06d44e06$export$989e911fa9af580a)(o) && !n && $764a54598a6d272a$var$U(e, o)) ? r = r.filter((e)=>e !== o) : i = t, o = (0, $200bb32c06d44e06$export$4e12058fc4d51d56)(o);
    }
    return t.set(e, r), r;
}
function $764a54598a6d272a$var$G(e) {
    let { element: t, boundary: i, rootBoundary: a, strategy: o } = e, s = [
        ...i === "clippingAncestors" ? (0, $200bb32c06d44e06$export$89e651af02346cd4)(t) ? [] : $764a54598a6d272a$var$W(t, this._c) : [].concat(i),
        a
    ], c = $764a54598a6d272a$var$H(t, s[0], o), l = c.top, u = c.right, d = c.bottom, f = c.left;
    for(let e = 1; e < s.length; e++){
        let i = $764a54598a6d272a$var$H(t, s[e], o);
        l = (0, $ce406aabc9c91c42$export$8960430cfd85939f)(i.top, l), u = (0, $ce406aabc9c91c42$export$96ec731ed4dcb222)(i.right, u), d = (0, $ce406aabc9c91c42$export$96ec731ed4dcb222)(i.bottom, d), f = (0, $ce406aabc9c91c42$export$8960430cfd85939f)(i.left, f);
    }
    return {
        width: u - f,
        height: d - l,
        x: f,
        y: l
    };
}
function $764a54598a6d272a$var$K(e) {
    let { width: t, height: n } = $764a54598a6d272a$var$A(e);
    return {
        width: t,
        height: n
    };
}
function $764a54598a6d272a$var$q(t, n, r) {
    let i = (0, $200bb32c06d44e06$export$1b3bfaa9684536aa)(n), a = (0, $200bb32c06d44e06$export$e495491855dc5418)(n), o = r === "fixed", s = $764a54598a6d272a$var$I(t, !0, o, n), c = {
        scrollLeft: 0,
        scrollTop: 0
    }, l = (0, $ce406aabc9c91c42$export$a397704b5e280835)(0);
    function u() {
        l.x = $764a54598a6d272a$var$L(a);
    }
    if (i || !i && !o) {
        if (((0, $200bb32c06d44e06$export$651544f548703224)(n) !== "body" || (0, $200bb32c06d44e06$export$989e911fa9af580a)(a)) && (c = (0, $200bb32c06d44e06$export$dc8fc79fa2800137)(n)), i) {
            let e = $764a54598a6d272a$var$I(n, !0, o, n);
            l.x = e.x + n.clientLeft, l.y = e.y + n.clientTop;
        } else a && u();
    }
    o && !i && a && u();
    let d = a && !i && !o ? $764a54598a6d272a$var$R(a, c) : (0, $ce406aabc9c91c42$export$a397704b5e280835)(0);
    return {
        x: s.left + c.scrollLeft - l.x - d.x,
        y: s.top + c.scrollTop - l.y - d.y,
        width: s.width,
        height: s.height
    };
}
function $764a54598a6d272a$var$J(e) {
    return (0, $200bb32c06d44e06$export$3735103072e4a80)(e).position === "static";
}
function $764a54598a6d272a$var$Y(e, t) {
    if (!(0, $200bb32c06d44e06$export$1b3bfaa9684536aa)(e) || (0, $200bb32c06d44e06$export$3735103072e4a80)(e).position === "fixed") return null;
    if (t) return t(e);
    let n = e.offsetParent;
    return (0, $200bb32c06d44e06$export$e495491855dc5418)(e) === n && (n = n.ownerDocument.body), n;
}
function $764a54598a6d272a$var$X(e, t) {
    let n = (0, $200bb32c06d44e06$export$38b2d434cce3ea22)(e);
    if ((0, $200bb32c06d44e06$export$89e651af02346cd4)(e)) return n;
    if (!(0, $200bb32c06d44e06$export$1b3bfaa9684536aa)(e)) {
        let t = (0, $200bb32c06d44e06$export$4e12058fc4d51d56)(e);
        for(; t && !(0, $200bb32c06d44e06$export$d1162fb0b6d4cd51)(t);){
            if ((0, $200bb32c06d44e06$export$45a5e7f76e0caa8d)(t) && !$764a54598a6d272a$var$J(t)) return t;
            t = (0, $200bb32c06d44e06$export$4e12058fc4d51d56)(t);
        }
        return n;
    }
    let r = $764a54598a6d272a$var$Y(e, t);
    for(; r && (0, $200bb32c06d44e06$export$71535ffaa902797f)(r) && $764a54598a6d272a$var$J(r);)r = $764a54598a6d272a$var$Y(r, t);
    return r && (0, $200bb32c06d44e06$export$d1162fb0b6d4cd51)(r) && $764a54598a6d272a$var$J(r) && !(0, $200bb32c06d44e06$export$d6c4e8150c35fed1)(r) ? n : r || (0, $200bb32c06d44e06$export$940d8225183e1404)(e) || n;
}
var $764a54598a6d272a$var$ie = async function(e) {
    let t = this.getOffsetParent || $764a54598a6d272a$var$X, n = this.getDimensions, r = await n(e.floating);
    return {
        reference: $764a54598a6d272a$var$q(e.reference, await t(e.floating), e.strategy),
        floating: {
            x: 0,
            y: 0,
            width: r.width,
            height: r.height
        }
    };
};
function $764a54598a6d272a$var$ae(e) {
    return (0, $200bb32c06d44e06$export$3735103072e4a80)(e).direction === "rtl";
}
var $764a54598a6d272a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $764a54598a6d272a$var$te,
    getDocumentElement: (0, $200bb32c06d44e06$export$e495491855dc5418),
    getClippingRect: $764a54598a6d272a$var$G,
    getOffsetParent: $764a54598a6d272a$var$X,
    getElementRects: $764a54598a6d272a$var$ie,
    getClientRects: $764a54598a6d272a$var$z,
    getDimensions: $764a54598a6d272a$var$K,
    getScale: $764a54598a6d272a$var$M,
    isElement: (0, $200bb32c06d44e06$export$45a5e7f76e0caa8d),
    isRTL: $764a54598a6d272a$var$ae
};
function $764a54598a6d272a$var$Q(e, t) {
    return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function $764a54598a6d272a$var$oe(e, i) {
    let a = null, o, s = (0, $200bb32c06d44e06$export$e495491855dc5418)(e);
    function c() {
        var e;
        clearTimeout(o), (e = a) == null || e.disconnect(), a = null;
    }
    function l(u, d) {
        u === void 0 && (u = !1), d === void 0 && (d = 1), c();
        let f = e.getBoundingClientRect(), { left: p, top: m, width: h, height: g } = f;
        if (u || i(), !h || !g) return;
        let _ = (0, $ce406aabc9c91c42$export$a3fe094919f356fd)(m), v = (0, $ce406aabc9c91c42$export$a3fe094919f356fd)(s.clientWidth - (p + h)), y = (0, $ce406aabc9c91c42$export$a3fe094919f356fd)(s.clientHeight - (m + g)), b = (0, $ce406aabc9c91c42$export$a3fe094919f356fd)(p), x = {
            rootMargin: -_ + "px " + -v + "px " + -y + "px " + -b + "px",
            threshold: (0, $ce406aabc9c91c42$export$8960430cfd85939f)(0, (0, $ce406aabc9c91c42$export$96ec731ed4dcb222)(1, d)) || 1
        }, S = !0;
        function C(t) {
            let n = t[0].intersectionRatio;
            if (n !== d) {
                if (!S) return l();
                n ? l(!1, n) : o = setTimeout(()=>{
                    l(!1, 1e-7);
                }, 1e3);
            }
            n === 1 && !$764a54598a6d272a$var$Q(f, e.getBoundingClientRect()) && l(), S = !1;
        }
        try {
            a = new IntersectionObserver(C, {
                ...x,
                root: s.ownerDocument
            });
        } catch  {
            a = new IntersectionObserver(C, x);
        }
        a.observe(e);
    }
    return l(!0), c;
}
function $764a54598a6d272a$export$deee3a793edee05f(e, t, n, r) {
    r === void 0 && (r = {});
    let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = $764a54598a6d272a$var$j(e), u = i || a ? [
        ...l ? (0, $200bb32c06d44e06$export$3b57c1601291186b)(l) : [],
        ...t ? (0, $200bb32c06d44e06$export$3b57c1601291186b)(t) : []
    ] : [];
    u.forEach((e)=>{
        i && e.addEventListener("scroll", n, {
            passive: !0
        }), a && e.addEventListener("resize", n);
    });
    let d = l && s ? $764a54598a6d272a$var$oe(l, n) : null, f = -1, p = null;
    o && (p = new ResizeObserver((e)=>{
        let [r] = e;
        r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(()=>{
            var e;
            (e = p) == null || e.observe(t);
        })), n();
    }), l && !c && p.observe(l), t && p.observe(t));
    let m, h = c ? $764a54598a6d272a$var$I(e) : null;
    c && g();
    function g() {
        let t = $764a54598a6d272a$var$I(e);
        h && !$764a54598a6d272a$var$Q(h, t) && n(), h = t, m = requestAnimationFrame(g);
    }
    return n(), ()=>{
        var e;
        u.forEach((e)=>{
            i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
        }), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
    };
}
var $764a54598a6d272a$export$cc800923e997bb8 = (0, $a2b5c08367d68411$export$cc800923e997bb8), $764a54598a6d272a$export$fba63a578e423eb = (0, $a2b5c08367d68411$export$fba63a578e423eb), $764a54598a6d272a$export$8a83211c878a3f1f = (0, $a2b5c08367d68411$export$8a83211c878a3f1f), $764a54598a6d272a$export$346677f925de839c = (0, $a2b5c08367d68411$export$346677f925de839c), $764a54598a6d272a$export$fe8985bb6374093c = (0, $a2b5c08367d68411$export$fe8985bb6374093c), $764a54598a6d272a$export$f2120bbfa5450bd2 = (0, $a2b5c08367d68411$export$f2120bbfa5450bd2), $764a54598a6d272a$export$7bf07e38f3dc4b69 = (0, $a2b5c08367d68411$export$7bf07e38f3dc4b69), $764a54598a6d272a$export$48a53dcb22e581d0 = (e, t, n)=>{
    let r = /* @__PURE__ */ new Map(), i = {
        platform: $764a54598a6d272a$export$722a64dea1b767dc,
        ...n
    }, a = {
        ...i.platform,
        _c: r
    };
    return (0, $a2b5c08367d68411$export$48a53dcb22e581d0)(e, t, {
        ...i,
        platform: a
    });
};





var $lCzvA = parcelRequire("lCzvA");

var $dAQd3 = parcelRequire("dAQd3");
//#region node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var $3beeeb0829704948$var$f = typeof document < "u" ? (0, $lCzvA.useLayoutEffect) : function() {};
function $3beeeb0829704948$var$p(e, t) {
    if (e === t) return !0;
    if (typeof e != typeof t) return !1;
    if (typeof e == "function" && e.toString() === t.toString()) return !0;
    let n, r, i;
    if (e && t && typeof e == "object") {
        if (Array.isArray(e)) {
            if (n = e.length, n !== t.length) return !1;
            for(r = n; r-- !== 0;)if (!$3beeeb0829704948$var$p(e[r], t[r])) return !1;
            return !0;
        }
        if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
        for(r = n; r-- !== 0;)if (!({}).hasOwnProperty.call(t, i[r])) return !1;
        for(r = n; r-- !== 0;){
            let n = i[r];
            if (!(n === "_owner" && e.$$typeof) && !$3beeeb0829704948$var$p(e[n], t[n])) return !1;
        }
        return !0;
    }
    return e !== e && t !== t;
}
function $3beeeb0829704948$var$m(e) {
    return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function $3beeeb0829704948$var$h(e, t) {
    let n = $3beeeb0829704948$var$m(e);
    return Math.round(t * n) / n;
}
function $3beeeb0829704948$var$g(e) {
    let t = $lCzvA.useRef(e);
    return $3beeeb0829704948$var$f(()=>{
        t.current = e;
    }), t;
}
function $3beeeb0829704948$export$4e02a5c1d08bac65(e) {
    e === void 0 && (e = {});
    let { placement: t = "bottom", strategy: r = "absolute", middleware: i = [], platform: a, elements: { reference: o, floating: s } = {}, transform: c = !0, whileElementsMounted: u, open: _ } = e, [v, y] = $lCzvA.useState({
        x: 0,
        y: 0,
        strategy: r,
        placement: t,
        middlewareData: {},
        isPositioned: !1
    }), [b, x] = $lCzvA.useState(i);
    $3beeeb0829704948$var$p(b, i) || x(i);
    let [S, C] = $lCzvA.useState(null), [w, T] = $lCzvA.useState(null), E = $lCzvA.useCallback((e)=>{
        e !== A.current && (A.current = e, C(e));
    }, []), D = $lCzvA.useCallback((e)=>{
        e !== j.current && (j.current = e, T(e));
    }, []), O = o || S, k = s || w, A = $lCzvA.useRef(null), j = $lCzvA.useRef(null), M = $lCzvA.useRef(v), N = u != null, P = $3beeeb0829704948$var$g(u), F = $3beeeb0829704948$var$g(a), I = $3beeeb0829704948$var$g(_), L = $lCzvA.useCallback(()=>{
        if (!A.current || !j.current) return;
        let e = {
            placement: t,
            strategy: r,
            middleware: b
        };
        F.current && (e.platform = F.current), (0, $764a54598a6d272a$export$48a53dcb22e581d0)(A.current, j.current, e).then((e)=>{
            let t = {
                ...e,
                isPositioned: I.current !== !1
            };
            R.current && !$3beeeb0829704948$var$p(M.current, t) && (M.current = t, $dAQd3.flushSync(()=>{
                y(t);
            }));
        });
    }, [
        b,
        t,
        r,
        F,
        I
    ]);
    $3beeeb0829704948$var$f(()=>{
        _ === !1 && M.current.isPositioned && (M.current.isPositioned = !1, y((e)=>({
                ...e,
                isPositioned: !1
            })));
    }, [
        _
    ]);
    let R = $lCzvA.useRef(!1);
    $3beeeb0829704948$var$f(()=>(R.current = !0, ()=>{
            R.current = !1;
        }), []), $3beeeb0829704948$var$f(()=>{
        if (O && (A.current = O), k && (j.current = k), O && k) {
            if (P.current) return P.current(O, k, L);
            L();
        }
    }, [
        O,
        k,
        L,
        P,
        N
    ]);
    let z = $lCzvA.useMemo(()=>({
            reference: A,
            floating: j,
            setReference: E,
            setFloating: D
        }), [
        E,
        D
    ]), B = $lCzvA.useMemo(()=>({
            reference: O,
            floating: k
        }), [
        O,
        k
    ]), V = $lCzvA.useMemo(()=>{
        let e = {
            position: r,
            left: 0,
            top: 0
        };
        if (!B.floating) return e;
        let t = $3beeeb0829704948$var$h(B.floating, v.x), n = $3beeeb0829704948$var$h(B.floating, v.y);
        return c ? {
            ...e,
            transform: "translate(" + t + "px, " + n + "px)",
            ...$3beeeb0829704948$var$m(B.floating) >= 1.5 && {
                willChange: "transform"
            }
        } : {
            position: r,
            left: t,
            top: n
        };
    }, [
        r,
        c,
        B.floating,
        v.x,
        v.y
    ]);
    return $lCzvA.useMemo(()=>({
            ...v,
            update: L,
            refs: z,
            elements: B,
            floatingStyles: V
        }), [
        v,
        L,
        z,
        B,
        V
    ]);
}
var $3beeeb0829704948$var$v = (t)=>{
    function n(e) {
        return ({}).hasOwnProperty.call(e, "current");
    }
    return {
        name: "arrow",
        options: t,
        fn (r) {
            let { element: i, padding: a } = typeof t == "function" ? t(r) : t;
            return i && n(i) ? i.current == null ? {} : (0, $764a54598a6d272a$export$f2120bbfa5450bd2)({
                element: i.current,
                padding: a
            }).fn(r) : i ? (0, $764a54598a6d272a$export$f2120bbfa5450bd2)({
                element: i,
                padding: a
            }).fn(r) : {};
        }
    };
}, $3beeeb0829704948$export$cc800923e997bb8 = (e, t)=>{
    let n = (0, $764a54598a6d272a$export$cc800923e997bb8)(e);
    return {
        name: n.name,
        fn: n.fn,
        options: [
            e,
            t
        ]
    };
}, $3beeeb0829704948$export$fba63a578e423eb = (e, t)=>{
    let n = (0, $764a54598a6d272a$export$fba63a578e423eb)(e);
    return {
        name: n.name,
        fn: n.fn,
        options: [
            e,
            t
        ]
    };
}, $3beeeb0829704948$export$7bf07e38f3dc4b69 = (e, t)=>({
        fn: (0, $764a54598a6d272a$export$7bf07e38f3dc4b69)(e).fn,
        options: [
            e,
            t
        ]
    }), $3beeeb0829704948$export$8a83211c878a3f1f = (e, t)=>{
    let n = (0, $764a54598a6d272a$export$8a83211c878a3f1f)(e);
    return {
        name: n.name,
        fn: n.fn,
        options: [
            e,
            t
        ]
    };
}, $3beeeb0829704948$export$346677f925de839c = (e, t)=>{
    let n = (0, $764a54598a6d272a$export$346677f925de839c)(e);
    return {
        name: n.name,
        fn: n.fn,
        options: [
            e,
            t
        ]
    };
}, $3beeeb0829704948$export$fe8985bb6374093c = (e, t)=>{
    let n = (0, $764a54598a6d272a$export$fe8985bb6374093c)(e);
    return {
        name: n.name,
        fn: n.fn,
        options: [
            e,
            t
        ]
    };
}, $3beeeb0829704948$export$f2120bbfa5450bd2 = (e, t)=>{
    let n = $3beeeb0829704948$var$v(e);
    return {
        name: n.name,
        fn: n.fn,
        options: [
            e,
            t
        ]
    };
};




var $lCzvA = parcelRequire("lCzvA");

//#region node_modules/@radix-ui/react-arrow/dist/index.mjs
var $7091b911c1082c1e$var$r = "Arrow", $7091b911c1082c1e$export$21b07c8f274aebd5 = $lCzvA.forwardRef((t, r)=>{
    let { children: i, width: a = 10, height: o = 5, ...s } = t;
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).svg, {
        ...s,
        ref: r,
        width: a,
        height: o,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: t.asChild ? i : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$7091b911c1082c1e$export$21b07c8f274aebd5.displayName = $7091b911c1082c1e$var$r;
var $7091b911c1082c1e$export$be92b6f5f03c0fe9 = $7091b911c1082c1e$export$21b07c8f274aebd5;




var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/@radix-ui/react-use-size/dist/index.mjs
function $2d05e7cbfdedef9f$export$1ab7ae714698c4b8(n) {
    let [r, i] = $lCzvA.useState(void 0);
    return (0, $62d8013ac651591c$export$e5c5a5f917a5871c)(()=>{
        if (n) {
            i({
                width: n.offsetWidth,
                height: n.offsetHeight
            });
            let e = new ResizeObserver((e)=>{
                if (!Array.isArray(e) || !e.length) return;
                let t = e[0], r, a;
                if ("borderBoxSize" in t) {
                    let e = t.borderBoxSize, n = Array.isArray(e) ? e[0] : e;
                    r = n.inlineSize, a = n.blockSize;
                } else r = n.offsetWidth, a = n.offsetHeight;
                i({
                    width: r,
                    height: a
                });
            });
            return e.observe(n, {
                box: "border-box"
            }), ()=>e.unobserve(n);
        } else i(void 0);
    }, [
        n
    ]), r;
}



var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region node_modules/@radix-ui/react-popper/dist/index.mjs
var $672ed53bf52c8f1f$var$_ = "Popper", [$672ed53bf52c8f1f$var$v, $672ed53bf52c8f1f$export$722aac194ae923] = (0, $0641488beac2d3c3$export$50c7b4e9d9f19c1)($672ed53bf52c8f1f$var$_), [$672ed53bf52c8f1f$var$b, $672ed53bf52c8f1f$var$x] = $672ed53bf52c8f1f$var$v($672ed53bf52c8f1f$var$_), $672ed53bf52c8f1f$export$badac9ada3a0bdf9 = (e)=>{
    let { __scopePopper: t, children: n } = e, [r, i] = $lCzvA.useState(null), [a, o] = $lCzvA.useState(void 0);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($672ed53bf52c8f1f$var$b, {
        scope: t,
        anchor: r,
        onAnchorChange: i,
        placementState: a,
        setPlacementState: o,
        children: n
    });
};
$672ed53bf52c8f1f$export$badac9ada3a0bdf9.displayName = $672ed53bf52c8f1f$var$_;
var $672ed53bf52c8f1f$var$C = "PopperAnchor", $672ed53bf52c8f1f$export$ecd4e1ccab6ed6d = $lCzvA.forwardRef((t, n)=>{
    let { __scopePopper: i, virtualRef: a, ...o } = t, s = $672ed53bf52c8f1f$var$x($672ed53bf52c8f1f$var$C, i), c = $lCzvA.useRef(null), l = s.onAnchorChange, u = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(n, $lCzvA.useCallback((e)=>{
        c.current = e, e && l(e);
    }, [
        l
    ])), d = $lCzvA.useRef(null);
    $lCzvA.useEffect(()=>{
        if (!a) return;
        let e = d.current;
        d.current = a.current, e !== d.current && l(d.current);
    });
    let f = s.placementState && $672ed53bf52c8f1f$var$M(s.placementState), p = f?.[0], m = f?.[1];
    return a ? null : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).div, {
        "data-radix-popper-side": p,
        "data-radix-popper-align": m,
        ...o,
        ref: u
    });
});
$672ed53bf52c8f1f$export$ecd4e1ccab6ed6d.displayName = $672ed53bf52c8f1f$var$C;
var $672ed53bf52c8f1f$var$T = "PopperContent", [$672ed53bf52c8f1f$var$te, $672ed53bf52c8f1f$var$E] = $672ed53bf52c8f1f$var$v($672ed53bf52c8f1f$var$T), $672ed53bf52c8f1f$export$bc4ae5855d3c4fc = $lCzvA.forwardRef((t, m)=>{
    let { __scopePopper: _, side: v = "bottom", sideOffset: y = 0, align: b = "center", alignOffset: S = 0, arrowPadding: C = 0, avoidCollisions: w = !0, collisionBoundary: E = [], collisionPadding: D = 0, sticky: O = "partial", hideWhenDetached: k = !1, updatePositionStrategy: A = "optimized", onPlaced: N, ...P } = t, F = $672ed53bf52c8f1f$var$x($672ed53bf52c8f1f$var$T, _), [I, L] = $lCzvA.useState(null), R = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(m, L), [z, B] = $lCzvA.useState(null), V = (0, $2d05e7cbfdedef9f$export$1ab7ae714698c4b8)(z), re = V?.width ?? 0, H = V?.height ?? 0, ie = v + (b === "center" ? "" : "-" + b), ae = typeof D == "number" ? D : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...D
    }, U = Array.isArray(E) ? E : [
        E
    ], W = U.length > 0, G = {
        padding: ae,
        boundary: U.filter($672ed53bf52c8f1f$var$j),
        altBoundary: W
    }, { refs: oe, floatingStyles: K, placement: q, isPositioned: J, middlewareData: Y } = (0, $3beeeb0829704948$export$4e02a5c1d08bac65)({
        strategy: "fixed",
        placement: ie,
        whileElementsMounted: (...e)=>(0, $764a54598a6d272a$export$deee3a793edee05f)(...e, {
                animationFrame: A === "always"
            }),
        elements: {
            reference: F.anchor
        },
        middleware: [
            (0, $3beeeb0829704948$export$cc800923e997bb8)({
                mainAxis: y + H,
                alignmentAxis: S
            }),
            w && (0, $3beeeb0829704948$export$fba63a578e423eb)({
                mainAxis: !0,
                crossAxis: !1,
                limiter: O === "partial" ? (0, $3beeeb0829704948$export$7bf07e38f3dc4b69)() : void 0,
                ...G
            }),
            w && (0, $3beeeb0829704948$export$8a83211c878a3f1f)({
                ...G
            }),
            (0, $3beeeb0829704948$export$346677f925de839c)({
                ...G,
                apply: ({ elements: e, rects: t, availableWidth: n, availableHeight: r })=>{
                    let { width: i, height: a } = t.reference, o = e.floating.style;
                    o.setProperty("--radix-popper-available-width", `${n}px`), o.setProperty("--radix-popper-available-height", `${r}px`), o.setProperty("--radix-popper-anchor-width", `${i}px`), o.setProperty("--radix-popper-anchor-height", `${a}px`);
                }
            }),
            z && (0, $3beeeb0829704948$export$f2120bbfa5450bd2)({
                element: z,
                padding: C
            }),
            $672ed53bf52c8f1f$var$ne({
                arrowWidth: re,
                arrowHeight: H
            }),
            k && (0, $3beeeb0829704948$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...G,
                boundary: W ? G.boundary : void 0
            })
        ]
    }), X = F.setPlacementState;
    (0, $62d8013ac651591c$export$e5c5a5f917a5871c)(()=>(X(q), ()=>{
            X(void 0);
        }), [
        q,
        X
    ]);
    let [Z, Q] = $672ed53bf52c8f1f$var$M(q), $ = (0, $334703f027012d3d$export$25bec8c6f54ee79a)(N);
    (0, $62d8013ac651591c$export$e5c5a5f917a5871c)(()=>{
        J && $?.();
    }, [
        J,
        $
    ]);
    let se = Y.arrow?.x, ce = Y.arrow?.y, le = Y.arrow?.centerOffset !== 0, [ue, de] = $lCzvA.useState();
    return (0, $62d8013ac651591c$export$e5c5a5f917a5871c)(()=>{
        I && de(window.getComputedStyle(I).zIndex);
    }, [
        I
    ]), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        ref: oe.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...K,
            transform: J ? K.transform : "translate(0, -200%)",
            minWidth: "max-content",
            zIndex: ue,
            "--radix-popper-transform-origin": [
                Y.transformOrigin?.x,
                Y.transformOrigin?.y
            ].join(" "),
            ...Y.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: t.dir,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($672ed53bf52c8f1f$var$te, {
            scope: _,
            placedSide: Z,
            placedAlign: Q,
            onArrowChange: B,
            arrowX: se,
            arrowY: ce,
            shouldHideArrow: le,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).div, {
                "data-side": Z,
                "data-align": Q,
                ...P,
                ref: R,
                style: {
                    ...P.style,
                    animation: J ? void 0 : "none"
                }
            })
        })
    });
});
$672ed53bf52c8f1f$export$bc4ae5855d3c4fc.displayName = $672ed53bf52c8f1f$var$T;
var $672ed53bf52c8f1f$var$O = "PopperArrow", $672ed53bf52c8f1f$var$k = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
}, $672ed53bf52c8f1f$export$79d62cd4e10a3fd0 = $lCzvA.forwardRef(function(e, t) {
    let { __scopePopper: n, ...r } = e, i = $672ed53bf52c8f1f$var$E($672ed53bf52c8f1f$var$O, n), a = $672ed53bf52c8f1f$var$k[i.placedSide];
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        ref: i.onArrowChange,
        style: {
            position: "absolute",
            left: i.arrowX,
            top: i.arrowY,
            [a]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[i.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: "rotate(180deg)",
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[i.placedSide],
            visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7091b911c1082c1e$export$be92b6f5f03c0fe9), {
            ...r,
            ref: t,
            style: {
                ...r.style,
                display: "block"
            }
        })
    });
});
$672ed53bf52c8f1f$export$79d62cd4e10a3fd0.displayName = $672ed53bf52c8f1f$var$O;
function $672ed53bf52c8f1f$var$j(e) {
    return e !== null;
}
var $672ed53bf52c8f1f$var$ne = (e)=>({
        name: "transformOrigin",
        options: e,
        fn (t) {
            let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = $672ed53bf52c8f1f$var$M(n), u = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
            return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), {
                data: {
                    x: p,
                    y: m
                }
            };
        }
    });
function $672ed53bf52c8f1f$var$M(e) {
    let [t, n = "center"] = e.split("-");
    return [
        t,
        n
    ];
}
var $672ed53bf52c8f1f$export$be92b6f5f03c0fe9 = $672ed53bf52c8f1f$export$badac9ada3a0bdf9, $672ed53bf52c8f1f$export$b688253958b8dfe7 = $672ed53bf52c8f1f$export$ecd4e1ccab6ed6d, $672ed53bf52c8f1f$export$7c6e2c02157bb7d2 = $672ed53bf52c8f1f$export$bc4ae5855d3c4fc, $672ed53bf52c8f1f$export$21b07c8f274aebd5 = $672ed53bf52c8f1f$export$79d62cd4e10a3fd0;



var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region node_modules/@radix-ui/react-popover/dist/index.mjs
var $6cfb341d3b8594ed$var$x = "Popover", [$6cfb341d3b8594ed$var$S, $6cfb341d3b8594ed$var$C] = (0, $0641488beac2d3c3$export$50c7b4e9d9f19c1)($6cfb341d3b8594ed$var$x, [
    (0, $672ed53bf52c8f1f$export$722aac194ae923)
]), $6cfb341d3b8594ed$var$w = (0, $672ed53bf52c8f1f$export$722aac194ae923)(), [$6cfb341d3b8594ed$var$T, $6cfb341d3b8594ed$var$E] = $6cfb341d3b8594ed$var$S($6cfb341d3b8594ed$var$x), $6cfb341d3b8594ed$export$5b6b19405a83ff9d = (e)=>{
    let { __scopePopover: t, children: n, open: a, defaultOpen: o, onOpenChange: s, modal: c = !1 } = e, l = $6cfb341d3b8594ed$var$w(t), u = $lCzvA.useRef(null), [d, f] = $lCzvA.useState(!1), [p, m] = (0, $0d3099c8ce39feb9$export$6f32135080cb4c3)({
        prop: a,
        defaultProp: o ?? !1,
        onChange: s,
        caller: $6cfb341d3b8594ed$var$x
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $672ed53bf52c8f1f$export$be92b6f5f03c0fe9), {
        ...l,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6cfb341d3b8594ed$var$T, {
            scope: t,
            contentId: (0, $2505f25f517c82fa$export$f680877a34711e37)(),
            triggerRef: u,
            open: p,
            onOpenChange: m,
            onOpenToggle: $lCzvA.useCallback(()=>m((e)=>!e), [
                m
            ]),
            hasCustomAnchor: d,
            onCustomAnchorAdd: $lCzvA.useCallback(()=>f(!0), []),
            onCustomAnchorRemove: $lCzvA.useCallback(()=>f(!1), []),
            modal: c,
            children: n
        })
    });
};
$6cfb341d3b8594ed$export$5b6b19405a83ff9d.displayName = $6cfb341d3b8594ed$var$x;
var $6cfb341d3b8594ed$var$O = "PopoverAnchor", $6cfb341d3b8594ed$export$96e5381f42521a79 = $lCzvA.forwardRef((e, t)=>{
    let { __scopePopover: n, ...r } = e, i = $6cfb341d3b8594ed$var$E($6cfb341d3b8594ed$var$O, n), a = $6cfb341d3b8594ed$var$w(n), { onCustomAnchorAdd: o, onCustomAnchorRemove: s } = i;
    return $lCzvA.useEffect(()=>(o(), ()=>s()), [
        o,
        s
    ]), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $672ed53bf52c8f1f$export$b688253958b8dfe7), {
        ...a,
        ...r,
        ref: t
    });
});
$6cfb341d3b8594ed$export$96e5381f42521a79.displayName = $6cfb341d3b8594ed$var$O;
var $6cfb341d3b8594ed$var$A = "PopoverTrigger", $6cfb341d3b8594ed$export$7dacb05d26466c3 = $lCzvA.forwardRef((n, r)=>{
    let { __scopePopover: i, ...a } = n, s = $6cfb341d3b8594ed$var$E($6cfb341d3b8594ed$var$A, i), c = $6cfb341d3b8594ed$var$w(i), l = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(r, s.triggerRef), u = /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": s.open,
        "aria-controls": s.open ? s.contentId : void 0,
        "data-state": $6cfb341d3b8594ed$var$K(s.open),
        ...a,
        ref: l,
        onClick: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onClick, s.onOpenToggle)
    });
    return s.hasCustomAnchor ? u : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $672ed53bf52c8f1f$export$b688253958b8dfe7), {
        asChild: !0,
        ...c,
        children: u
    });
});
$6cfb341d3b8594ed$export$7dacb05d26466c3.displayName = $6cfb341d3b8594ed$var$A;
var $6cfb341d3b8594ed$var$M = "PopoverPortal", [$6cfb341d3b8594ed$var$N, $6cfb341d3b8594ed$var$P] = $6cfb341d3b8594ed$var$S($6cfb341d3b8594ed$var$M, {
    forceMount: void 0
}), $6cfb341d3b8594ed$export$dd679ffb4362d2d4 = (e)=>{
    let { __scopePopover: t, forceMount: n, children: r, container: i } = e, a = $6cfb341d3b8594ed$var$E($6cfb341d3b8594ed$var$M, t);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6cfb341d3b8594ed$var$N, {
        scope: t,
        forceMount: n,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0682faac15a06e68$export$99c2b779aa4e8b8b), {
            present: n || a.open,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9bc4a16530321c60$export$602eac185826482c), {
                asChild: !0,
                container: i,
                children: r
            })
        })
    });
};
$6cfb341d3b8594ed$export$dd679ffb4362d2d4.displayName = $6cfb341d3b8594ed$var$M;
var $6cfb341d3b8594ed$var$I = "PopoverContent", $6cfb341d3b8594ed$export$d7e1f420b25549ff = $lCzvA.forwardRef((e, t)=>{
    let n = $6cfb341d3b8594ed$var$P($6cfb341d3b8594ed$var$I, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, a = $6cfb341d3b8594ed$var$E($6cfb341d3b8594ed$var$I, e.__scopePopover);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0682faac15a06e68$export$99c2b779aa4e8b8b), {
        present: r || a.open,
        children: a.modal ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6cfb341d3b8594ed$var$z, {
            ...i,
            ref: t
        }) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6cfb341d3b8594ed$var$B, {
            ...i,
            ref: t
        })
    });
});
$6cfb341d3b8594ed$export$d7e1f420b25549ff.displayName = $6cfb341d3b8594ed$var$I;
var $6cfb341d3b8594ed$var$R = (0, $09f52881d5dae1cd$export$e88b45bda5c13eb9)("PopoverContent.RemoveScroll"), $6cfb341d3b8594ed$var$z = $lCzvA.forwardRef((n, r)=>{
    let i = $6cfb341d3b8594ed$var$E($6cfb341d3b8594ed$var$I, n.__scopePopover), a = $lCzvA.useRef(null), o = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(r, a), s = $lCzvA.useRef(!1);
    return $lCzvA.useEffect(()=>{
        let e = a.current;
        if (e) return (0, $ff254d9dfc477fd4$export$6e33d16126ed003c)(e);
    }, []), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0a8b5b0a247b3b3f$export$2e2bcd8739ae039), {
        as: $6cfb341d3b8594ed$var$R,
        allowPinchZoom: !0,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6cfb341d3b8594ed$var$V, {
            ...n,
            ref: o,
            trapFocus: i.open,
            disableOutsidePointerEvents: !0,
            onCloseAutoFocus: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onCloseAutoFocus, (e)=>{
                e.preventDefault(), s.current || i.triggerRef.current?.focus();
            }),
            onPointerDownOutside: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onPointerDownOutside, (e)=>{
                let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
                s.current = r;
            }, {
                checkForDefaultPrevented: !1
            }),
            onFocusOutside: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onFocusOutside, (e)=>e.preventDefault(), {
                checkForDefaultPrevented: !1
            })
        })
    });
}), $6cfb341d3b8594ed$var$B = $lCzvA.forwardRef((e, t)=>{
    let n = $6cfb341d3b8594ed$var$E($6cfb341d3b8594ed$var$I, e.__scopePopover), r = $lCzvA.useRef(!1), i = $lCzvA.useRef(!1);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6cfb341d3b8594ed$var$V, {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (t)=>{
            e.onCloseAutoFocus?.(t), t.defaultPrevented || (r.current || n.triggerRef.current?.focus(), t.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (t)=>{
            e.onInteractOutside?.(t), t.defaultPrevented || (r.current = !0, t.detail.originalEvent.type === "pointerdown" && (i.current = !0));
            let a = t.target;
            n.triggerRef.current?.contains(a) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && i.current && t.preventDefault();
        }
    });
}), $6cfb341d3b8594ed$var$V = $lCzvA.forwardRef((e, t)=>{
    let { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, disableOutsidePointerEvents: o, onEscapeKeyDown: l, onPointerDownOutside: u, onFocusOutside: f, onInteractOutside: p, ...m } = e, h = $6cfb341d3b8594ed$var$E($6cfb341d3b8594ed$var$I, n), _ = $6cfb341d3b8594ed$var$w(n);
    return (0, $2e5466663c5a0617$export$b7ece24a22aeda8c)(), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a89c400092b04111$export$20e40289641fbbb6), {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: i,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fb04d4ce1fe91315$export$177fb62ff3ec1f22), {
            asChild: !0,
            disableOutsidePointerEvents: o,
            onInteractOutside: p,
            onEscapeKeyDown: l,
            onPointerDownOutside: u,
            onFocusOutside: f,
            onDismiss: ()=>h.onOpenChange(!1),
            deferPointerDownOutside: !0,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $672ed53bf52c8f1f$export$7c6e2c02157bb7d2), {
                "data-state": $6cfb341d3b8594ed$var$K(h.open),
                role: "dialog",
                id: h.contentId,
                ..._,
                ...m,
                ref: t,
                style: {
                    ...m.style,
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
            })
        })
    });
}), $6cfb341d3b8594ed$var$H = "PopoverClose", $6cfb341d3b8594ed$export$d6ac43ebaa40d53e = $lCzvA.forwardRef((t, n)=>{
    let { __scopePopover: r, ...i } = t, a = $6cfb341d3b8594ed$var$E($6cfb341d3b8594ed$var$H, r);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).button, {
        type: "button",
        ...i,
        ref: n,
        onClick: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(t.onClick, ()=>a.onOpenChange(!1))
    });
});
$6cfb341d3b8594ed$export$d6ac43ebaa40d53e.displayName = $6cfb341d3b8594ed$var$H;
var $6cfb341d3b8594ed$var$W = "PopoverArrow", $6cfb341d3b8594ed$export$3152841115e061b2 = $lCzvA.forwardRef((e, t)=>{
    let { __scopePopover: n, ...r } = e;
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $672ed53bf52c8f1f$export$21b07c8f274aebd5), {
        ...$6cfb341d3b8594ed$var$w(n),
        ...r,
        ref: t
    });
});
$6cfb341d3b8594ed$export$3152841115e061b2.displayName = $6cfb341d3b8594ed$var$W;
function $6cfb341d3b8594ed$var$K(e) {
    return e ? "open" : "closed";
}
var $6cfb341d3b8594ed$export$be92b6f5f03c0fe9 = $6cfb341d3b8594ed$export$5b6b19405a83ff9d, $6cfb341d3b8594ed$export$41fb9f06171c75f4 = $6cfb341d3b8594ed$export$7dacb05d26466c3, $6cfb341d3b8594ed$export$7c6e2c02157bb7d2 = $6cfb341d3b8594ed$export$d7e1f420b25549ff, $6cfb341d3b8594ed$export$f39c2d165cd861fe = $6cfb341d3b8594ed$export$d6ac43ebaa40d53e, $6cfb341d3b8594ed$export$21b07c8f274aebd5 = $6cfb341d3b8594ed$export$3152841115e061b2;



var $lCzvA = parcelRequire("lCzvA");


var $dAQd3 = parcelRequire("dAQd3");
"use client";
//#region src/components/Dropdown/index.jsx
var $4894604720ca08c8$export$2e2bcd8739ae039 = ({ children: o, className: s, defaultOpen: c, onOpenChange: l, backdrop: u, backdropClass: d })=>{
    let [f, p] = (0, $lCzvA.useState)(c), m = typeof l == "function", h = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Dropdown relative w-fit *:data-radix-popper-content-wrapper:absolute!": !0,
        "z-2": f,
        [s]: s
    }), g = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-DropdownBackdrop fixed left-0 top-0 bg-black/40 w-screen h-screen backdrop-blur-lg": !0,
        [d]: d
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: h,
        "data-testid": "sash-dropdown",
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $6cfb341d3b8594ed$export$be92b6f5f03c0fe9), {
            defaultOpen: m ? void 0 : c,
            open: m ? c : void 0,
            onOpenChange: (e)=>{
                m ? l(e) : p(e);
            },
            children: [
                o,
                f && u && (0, $dAQd3.createPortal)(/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    className: g,
                    "data-testid": "sash-dropdown-backdrop"
                }), document.body)
            ]
        })
    });
};




"use client";
//#region src/components/Dropdown/Content/index.jsx
var $833f5a446a1fbfcc$export$2e2bcd8739ae039 = ({ position: r = "bottom", align: i = "center", className: a, offset: o = 10, onOutsideClick: s, children: c, ...l })=>{
    let u = typeof s == "function";
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $6cfb341d3b8594ed$export$7c6e2c02157bb7d2), {
        "data-testid": "sash-dropdown-content",
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-DropdownContent border border-neutral-200 bg-white p-3 w-max hidden data-[state=open]:block": !0,
            [a]: a
        }),
        align: i,
        side: r,
        sideOffset: o,
        onInteractOutside: u ? s : void 0,
        id: void 0,
        forceMount: !0,
        ...l,
        children: c
    });
};
$833f5a446a1fbfcc$export$2e2bcd8739ae039.displayName = "DropdownContent";




"use client";
//#region src/components/Dropdown/Item/index.jsx
var $e007c3baa5a03cf7$export$2e2bcd8739ae039 = ({ children: r, className: i })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-Dropdown-Item": !0,
            [i]: i
        }),
        "data-testid": "sash-dropdown-item",
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $6cfb341d3b8594ed$export$f39c2d165cd861fe), {
            asChild: !0,
            children: r
        })
    });
$e007c3baa5a03cf7$export$2e2bcd8739ae039.displayName = "DropdownItem";




"use client";
//#region src/components/Dropdown/Trigger/index.jsx
var $159cb66f654a3a1c$export$2e2bcd8739ae039 = ({ children: r, className: i, ...a })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $6cfb341d3b8594ed$export$41fb9f06171c75f4), {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-DropdownTrigger peer relative flex flex-wrap items-center cursor-pointer": !0,
            [i]: i
        }),
        "aria-controls": void 0,
        ...a,
        children: r
    });
$159cb66f654a3a1c$export$2e2bcd8739ae039.displayName = "DropdownTrigger";




const $5c547e463b0eaf3f$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$5c547e463b0eaf3f$export$c169aefb7330cccb["open"] = "0";
$5c547e463b0eaf3f$export$c169aefb7330cccb["close"] = "1";
$5c547e463b0eaf3f$export$c169aefb7330cccb["ping"] = "2";
$5c547e463b0eaf3f$export$c169aefb7330cccb["pong"] = "3";
$5c547e463b0eaf3f$export$c169aefb7330cccb["message"] = "4";
$5c547e463b0eaf3f$export$c169aefb7330cccb["upgrade"] = "5";
$5c547e463b0eaf3f$export$c169aefb7330cccb["noop"] = "6";
const $5c547e463b0eaf3f$export$47791e8004edd485 = Object.create(null);
Object.keys($5c547e463b0eaf3f$export$c169aefb7330cccb).forEach((key)=>{
    $5c547e463b0eaf3f$export$47791e8004edd485[$5c547e463b0eaf3f$export$c169aefb7330cccb[key]] = key;
});
const $5c547e463b0eaf3f$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $c4185107dd03fd6c$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $c4185107dd03fd6c$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $c4185107dd03fd6c$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $c4185107dd03fd6c$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($c4185107dd03fd6c$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $c4185107dd03fd6c$var$encodeBlobAsBase64(data, callback);
    } else if ($c4185107dd03fd6c$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $c4185107dd03fd6c$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $c4185107dd03fd6c$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $5c547e463b0eaf3f$export$c169aefb7330cccb)[type] + (data || ""));
};
const $c4185107dd03fd6c$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $c4185107dd03fd6c$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $c4185107dd03fd6c$var$TEXT_ENCODER;
function $c4185107dd03fd6c$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($c4185107dd03fd6c$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($c4185107dd03fd6c$var$toArray).then(callback);
    else if ($c4185107dd03fd6c$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $c4185107dd03fd6c$var$isView(packet.data))) return callback($c4185107dd03fd6c$var$toArray(packet.data));
    $c4185107dd03fd6c$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$c4185107dd03fd6c$var$TEXT_ENCODER) $c4185107dd03fd6c$var$TEXT_ENCODER = new TextEncoder();
        callback($c4185107dd03fd6c$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $055abc405ec012c0$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $055abc405ec012c0$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $055abc405ec012c0$var$chars.length; i++)$055abc405ec012c0$var$lookup[$055abc405ec012c0$var$chars.charCodeAt(i)] = i;
const $055abc405ec012c0$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $055abc405ec012c0$var$chars[bytes[i] >> 2];
        base64 += $055abc405ec012c0$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $055abc405ec012c0$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $055abc405ec012c0$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $055abc405ec012c0$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $055abc405ec012c0$var$lookup[base64.charCodeAt(i)];
        encoded2 = $055abc405ec012c0$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $055abc405ec012c0$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $055abc405ec012c0$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $a981052c378bb34e$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a981052c378bb34e$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a981052c378bb34e$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a981052c378bb34e$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $5c547e463b0eaf3f$export$47791e8004edd485)[type];
    if (!packetType) return 0, $5c547e463b0eaf3f$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $5c547e463b0eaf3f$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $5c547e463b0eaf3f$export$47791e8004edd485)[type]
    };
};
const $a981052c378bb34e$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a981052c378bb34e$var$withNativeArrayBuffer) {
        const decoded = (0, $055abc405ec012c0$export$2f872c0f2117be69)(data);
        return $a981052c378bb34e$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a981052c378bb34e$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $a98a630babe996ba$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $a98a630babe996ba$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $c4185107dd03fd6c$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($a98a630babe996ba$var$SEPARATOR));
        });
    });
};
const $a98a630babe996ba$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($a98a630babe996ba$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $a981052c378bb34e$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $a98a630babe996ba$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $c4185107dd03fd6c$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $a98a630babe996ba$var$TEXT_DECODER;
function $a98a630babe996ba$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $a98a630babe996ba$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $a98a630babe996ba$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$a98a630babe996ba$var$TEXT_DECODER) $a98a630babe996ba$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($a98a630babe996ba$var$totalLength(chunks) < 1) break;
                    const header = $a98a630babe996ba$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($a98a630babe996ba$var$totalLength(chunks) < 2) break;
                    const headerArray = $a98a630babe996ba$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($a98a630babe996ba$var$totalLength(chunks) < 8) break;
                    const headerArray = $a98a630babe996ba$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $5c547e463b0eaf3f$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($a98a630babe996ba$var$totalLength(chunks) < expectedLength) break;
                    const data = $a98a630babe996ba$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $a981052c378bb34e$export$4647901878f33f31)(isBinary ? data : $a98a630babe996ba$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $5c547e463b0eaf3f$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $a98a630babe996ba$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $b1d057b86753ac91$export$4293555f241ae35a(obj) {
    if (obj) return $b1d057b86753ac91$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $b1d057b86753ac91$var$mixin(obj) {
    for(var key in $b1d057b86753ac91$export$4293555f241ae35a.prototype)obj[key] = $b1d057b86753ac91$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.on = $b1d057b86753ac91$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.off = $b1d057b86753ac91$export$4293555f241ae35a.prototype.removeListener = $b1d057b86753ac91$export$4293555f241ae35a.prototype.removeAllListeners = $b1d057b86753ac91$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$b1d057b86753ac91$export$4293555f241ae35a.prototype.emitReserved = $b1d057b86753ac91$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $78dda435b49a09da$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $78dda435b49a09da$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $78dda435b49a09da$export$790dcbc41e2d75d5 = "arraybuffer";
function $78dda435b49a09da$export$19413efcf2fac759() {}


function $6ef350ea0a0dd88d$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $6ef350ea0a0dd88d$var$NATIVE_SET_TIMEOUT = (0, $78dda435b49a09da$export$394f9358f6231289).setTimeout;
const $6ef350ea0a0dd88d$var$NATIVE_CLEAR_TIMEOUT = (0, $78dda435b49a09da$export$394f9358f6231289).clearTimeout;
function $6ef350ea0a0dd88d$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $6ef350ea0a0dd88d$var$NATIVE_SET_TIMEOUT.bind((0, $78dda435b49a09da$export$394f9358f6231289));
        obj.clearTimeoutFn = $6ef350ea0a0dd88d$var$NATIVE_CLEAR_TIMEOUT.bind((0, $78dda435b49a09da$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $78dda435b49a09da$export$394f9358f6231289).setTimeout.bind((0, $78dda435b49a09da$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $78dda435b49a09da$export$394f9358f6231289).clearTimeout.bind((0, $78dda435b49a09da$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $6ef350ea0a0dd88d$var$BASE64_OVERHEAD = 1.33;
function $6ef350ea0a0dd88d$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $6ef350ea0a0dd88d$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $6ef350ea0a0dd88d$var$BASE64_OVERHEAD);
}
function $6ef350ea0a0dd88d$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $6ef350ea0a0dd88d$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $7913ae70c2a27fe9$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $7913ae70c2a27fe9$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $3503e5787a975d0b$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $3503e5787a975d0b$export$86495b081fef8e52 extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $6ef350ea0a0dd88d$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $3503e5787a975d0b$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $a981052c378bb34e$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $7913ae70c2a27fe9$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}




class $0b63fa11be6fda61$export$265ee5eefd4c309b extends (0, $3503e5787a975d0b$export$86495b081fef8e52) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $a98a630babe996ba$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $a98a630babe996ba$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $6ef350ea0a0dd88d$export$7fa8378418b4411e)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}





// imported from https://github.com/component/has-cors
let $d9c50c7ee579c975$var$value = false;
try {
    $d9c50c7ee579c975$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $d9c50c7ee579c975$export$5235bbd4a1ef06e = $d9c50c7ee579c975$var$value;


function $b2c670152e349ccd$var$empty() {}
class $b2c670152e349ccd$export$c959f2344155d309 extends (0, $0b63fa11be6fda61$export$265ee5eefd4c309b) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data - data to send.
     * @param {Function} fn - called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $b2c670152e349ccd$export$7fa6c5b6f8193917 extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $6ef350ea0a0dd88d$export$2f67576668b97183)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $6ef350ea0a0dd88d$export$357523c63a2253b9)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $b2c670152e349ccd$export$7fa6c5b6f8193917.requestsCount++;
            $b2c670152e349ccd$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $b2c670152e349ccd$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $b2c670152e349ccd$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$b2c670152e349ccd$export$7fa6c5b6f8193917.requestsCount = 0;
$b2c670152e349ccd$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $b2c670152e349ccd$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $78dda435b49a09da$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $b2c670152e349ccd$var$unloadHandler, false);
    }
}
function $b2c670152e349ccd$var$unloadHandler() {
    for(let i in $b2c670152e349ccd$export$7fa6c5b6f8193917.requests)if ($b2c670152e349ccd$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $b2c670152e349ccd$export$7fa6c5b6f8193917.requests[i].abort();
}
const $b2c670152e349ccd$var$hasXHR2 = function() {
    const xhr = $b2c670152e349ccd$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $b2c670152e349ccd$export$a2d42eb087c10497 extends $b2c670152e349ccd$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $b2c670152e349ccd$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $b2c670152e349ccd$export$7fa6c5b6f8193917($b2c670152e349ccd$var$newRequest, this.uri(), opts);
    }
}
function $b2c670152e349ccd$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $d9c50c7ee579c975$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $78dda435b49a09da$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}






// detect ReactNative environment
const $b532a5eecc323955$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $b532a5eecc323955$export$570bf71d2367e261 extends (0, $3503e5787a975d0b$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $b532a5eecc323955$var$isReactNative ? {} : (0, $6ef350ea0a0dd88d$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $c4185107dd03fd6c$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $78dda435b49a09da$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $6ef350ea0a0dd88d$export$7fa8378418b4411e)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $b532a5eecc323955$var$WebSocketCtor = (0, $78dda435b49a09da$export$394f9358f6231289).WebSocket || (0, $78dda435b49a09da$export$394f9358f6231289).MozWebSocket;
class $b532a5eecc323955$export$911baa0677ac404c extends $b532a5eecc323955$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$b532a5eecc323955$var$isReactNative ? protocols ? new $b532a5eecc323955$var$WebSocketCtor(uri, protocols) : new $b532a5eecc323955$var$WebSocketCtor(uri) : new $b532a5eecc323955$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}





class $9d7e081a924f8047$export$961c930859384407 extends (0, $3503e5787a975d0b$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $a98a630babe996ba$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $a98a630babe996ba$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $78dda435b49a09da$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}


const $035b186fd9c2fe37$export$46dec00755c1153b = {
    websocket: (0, $b532a5eecc323955$export$911baa0677ac404c),
    webtransport: (0, $9d7e081a924f8047$export$961c930859384407),
    polling: (0, $b2c670152e349ccd$export$a2d42eb087c10497)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $b73383f3220dcbef$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $b73383f3220dcbef$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $b73383f3220dcbef$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $b73383f3220dcbef$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$b73383f3220dcbef$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $b73383f3220dcbef$var$pathNames(uri, uri['path']);
    uri.queryKey = $b73383f3220dcbef$var$queryKey(uri, uri['query']);
    return uri;
}
function $b73383f3220dcbef$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $b73383f3220dcbef$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





const $5579d473e93c2027$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $5579d473e93c2027$var$OFFLINE_EVENT_LISTENERS = [];
if ($5579d473e93c2027$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $5579d473e93c2027$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $5579d473e93c2027$export$3874118029a0ee0d extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $78dda435b49a09da$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $b73383f3220dcbef$export$98e6a39c04603d36)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $b73383f3220dcbef$export$98e6a39c04603d36)(opts.host).host;
        (0, $6ef350ea0a0dd88d$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $7913ae70c2a27fe9$export$2f872c0f2117be69)(this.opts.query);
        if ($5579d473e93c2027$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $5579d473e93c2027$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $78dda435b49a09da$export$19413efcf2fac759)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $a98a630babe996ba$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $5579d473e93c2027$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $5579d473e93c2027$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $6ef350ea0a0dd88d$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $78dda435b49a09da$export$bdd553fddd433dcb)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type - packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $5579d473e93c2027$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($5579d473e93c2027$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $5579d473e93c2027$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $5579d473e93c2027$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$5579d473e93c2027$export$3874118029a0ee0d.protocol = (0, $a98a630babe996ba$export$a51d6b395ff4c65a);
class $5579d473e93c2027$export$cc521fcb1004e85c extends $5579d473e93c2027$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $5579d473e93c2027$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $5579d473e93c2027$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $5579d473e93c2027$export$4798917dbf149b79 extends $5579d473e93c2027$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const isOptionsOnly = typeof uri === "object";
        const o = isOptionsOnly ? {
            ...uri
        } : {
            ...opts
        };
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $035b186fd9c2fe37$export$46dec00755c1153b)[transportName]).filter((t)=>!!t);
        super(isOptionsOnly ? o : uri, o);
    }
}








class $b0af27e4230a6249$export$1e7deca84b429035 extends (0, $0b63fa11be6fda61$export$265ee5eefd4c309b) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}







const $796b9ddb5a14eb25$export$a51d6b395ff4c65a = (0, $5579d473e93c2027$export$4798917dbf149b79).protocol;


function $3c201f22ef1fa1a0$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $b73383f3220dcbef$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $f35899b1336bcd3d$exports = {};

$parcel$export($f35899b1336bcd3d$exports, "protocol", function () { return $f35899b1336bcd3d$export$a51d6b395ff4c65a; });
$parcel$export($f35899b1336bcd3d$exports, "PacketType", function () { return $f35899b1336bcd3d$export$84d4095e16c6fc19; });
$parcel$export($f35899b1336bcd3d$exports, "Encoder", function () { return $f35899b1336bcd3d$export$a50aceb0e02a00aa; });
$parcel$export($f35899b1336bcd3d$exports, "Decoder", function () { return $f35899b1336bcd3d$export$f9de6ca0bc043724; });
$parcel$export($f35899b1336bcd3d$exports, "isPacketValid", function () { return $f35899b1336bcd3d$export$1a38ed17dcb5458e; });

const $4ae21e6667dc763d$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $4ae21e6667dc763d$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $4ae21e6667dc763d$var$toString = Object.prototype.toString;
const $4ae21e6667dc763d$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $4ae21e6667dc763d$var$toString.call(Blob) === "[object BlobConstructor]";
const $4ae21e6667dc763d$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $4ae21e6667dc763d$var$toString.call(File) === "[object FileConstructor]";
function $4ae21e6667dc763d$export$37488ff1135b1696(obj) {
    return $4ae21e6667dc763d$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $4ae21e6667dc763d$var$isView(obj)) || $4ae21e6667dc763d$var$withNativeBlob && obj instanceof Blob || $4ae21e6667dc763d$var$withNativeFile && obj instanceof File;
}
function $4ae21e6667dc763d$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($4ae21e6667dc763d$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($4ae21e6667dc763d$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $4ae21e6667dc763d$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $4ae21e6667dc763d$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $9fcc2125db60224f$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $9fcc2125db60224f$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $9fcc2125db60224f$var$_deconstructPacket(data, buffers, toJSON) {
    if (!data) return data;
    if ((0, $4ae21e6667dc763d$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $9fcc2125db60224f$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        if (data.toJSON && typeof data.toJSON === "function" && !toJSON) return $9fcc2125db60224f$var$_deconstructPacket(data.toJSON(), buffers, true);
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $9fcc2125db60224f$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $9fcc2125db60224f$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $9fcc2125db60224f$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $9fcc2125db60224f$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $9fcc2125db60224f$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $9fcc2125db60224f$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $f35899b1336bcd3d$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $f35899b1336bcd3d$export$a51d6b395ff4c65a = 5;
var $f35899b1336bcd3d$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($f35899b1336bcd3d$export$84d4095e16c6fc19 || ($f35899b1336bcd3d$export$84d4095e16c6fc19 = {}));
class $f35899b1336bcd3d$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.EVENT || obj.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.ACK) {
            if ((0, $4ae21e6667dc763d$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.EVENT ? $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_EVENT : $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $9fcc2125db60224f$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
class $f35899b1336bcd3d$export$f9de6ca0bc043724 extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    /**
     * Decoder constructor
     */ constructor(opts){
        super();
        this.opts = Object.assign({
            reviver: undefined,
            maxAttachments: 10
        }, typeof opts === "function" ? {
            reviver: opts
        } : opts);
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $f35899b1336bcd3d$export$84d4095e16c6fc19.EVENT : $f35899b1336bcd3d$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $f35899b1336bcd3d$var$BinaryReconstructor(packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $4ae21e6667dc763d$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($f35899b1336bcd3d$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            const n = Number(buf);
            if (!$f35899b1336bcd3d$var$isInteger(n) || n < 1) throw new Error("Illegal attachments");
            else if (n > this.opts.maxAttachments) throw new Error("too many attachments");
            p.attachments = n;
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($f35899b1336bcd3d$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.opts.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.CONNECT:
                return $f35899b1336bcd3d$var$isObject(payload);
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $f35899b1336bcd3d$var$isObject(payload);
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.EVENT:
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $f35899b1336bcd3d$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.ACK:
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $f35899b1336bcd3d$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $9fcc2125db60224f$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}
function $f35899b1336bcd3d$var$isNamespaceValid(nsp) {
    return typeof nsp === "string";
}
// see https://caniuse.com/mdn-javascript_builtins_number_isinteger
const $f35899b1336bcd3d$var$isInteger = Number.isInteger || function(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
function $f35899b1336bcd3d$var$isAckIdValid(id) {
    return id === undefined || $f35899b1336bcd3d$var$isInteger(id);
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $f35899b1336bcd3d$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
function $f35899b1336bcd3d$var$isDataValid(type, payload) {
    switch(type){
        case $f35899b1336bcd3d$export$84d4095e16c6fc19.CONNECT:
            return payload === undefined || $f35899b1336bcd3d$var$isObject(payload);
        case $f35899b1336bcd3d$export$84d4095e16c6fc19.DISCONNECT:
            return payload === undefined;
        case $f35899b1336bcd3d$export$84d4095e16c6fc19.EVENT:
            return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $f35899b1336bcd3d$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
        case $f35899b1336bcd3d$export$84d4095e16c6fc19.ACK:
            return Array.isArray(payload);
        case $f35899b1336bcd3d$export$84d4095e16c6fc19.CONNECT_ERROR:
            return typeof payload === "string" || $f35899b1336bcd3d$var$isObject(payload);
        default:
            return false;
    }
}
function $f35899b1336bcd3d$export$1a38ed17dcb5458e(packet) {
    return $f35899b1336bcd3d$var$isNamespaceValid(packet.nsp) && $f35899b1336bcd3d$var$isAckIdValid(packet.id) && $f35899b1336bcd3d$var$isDataValid(packet.type, packet.data);
}


function $7ef62b04f1ea5e9b$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $9063e16d38b294db$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $9063e16d38b294db$export$4798917dbf149b79 extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($9063e16d38b294db$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            this._queue[0];
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).EVENT:
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).ACK:
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this._drainQueue(true);
        this.emitReserved("connect");
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $4d06434d3f654aec$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $4d06434d3f654aec$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $4d06434d3f654aec$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $4d06434d3f654aec$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $4d06434d3f654aec$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $4d06434d3f654aec$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $37c89cd8a39fabd4$export$d0d38e7dec7a1a61 extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $6ef350ea0a0dd88d$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $4d06434d3f654aec$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $f35899b1336bcd3d$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $5579d473e93c2027$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $78dda435b49a09da$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $9063e16d38b294db$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}





/**
 * Managers cache.
 */ const $b2faa63fcd6137f7$var$cache = {};
function $b2faa63fcd6137f7$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $3c201f22ef1fa1a0$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $b2faa63fcd6137f7$var$cache[id] && path in $b2faa63fcd6137f7$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $37c89cd8a39fabd4$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$b2faa63fcd6137f7$var$cache[id]) $b2faa63fcd6137f7$var$cache[id] = new (0, $37c89cd8a39fabd4$export$d0d38e7dec7a1a61)(source, opts);
        io = $b2faa63fcd6137f7$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($b2faa63fcd6137f7$export$841407ceb083bd74, {
    Manager: $37c89cd8a39fabd4$export$d0d38e7dec7a1a61,
    Socket: $9063e16d38b294db$export$4798917dbf149b79,
    io: $b2faa63fcd6137f7$export$841407ceb083bd74,
    connect: $b2faa63fcd6137f7$export$841407ceb083bd74
});



var $lCzvA = parcelRequire("lCzvA");





var $d34581d01d8d1029$var$_client, $d34581d01d8d1029$var$_currentResult, $d34581d01d8d1029$var$_currentMutation, $d34581d01d8d1029$var$_mutateOptions, $d34581d01d8d1029$var$_MutationObserver_instances, $d34581d01d8d1029$var$updateResult_fn, $d34581d01d8d1029$var$notify_fn;
var $d34581d01d8d1029$export$d3c1860ee66f291a = class extends (0, $fa7f8e88baa31e37$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $d34581d01d8d1029$var$_MutationObserver_instances);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $d34581d01d8d1029$var$_client);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $d34581d01d8d1029$var$_currentResult);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $d34581d01d8d1029$var$_currentMutation);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $d34581d01d8d1029$var$_mutateOptions);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $d34581d01d8d1029$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d34581d01d8d1029$var$_MutationObserver_instances, $d34581d01d8d1029$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_client).defaultMutationOptions(options);
        if (!(0, $9f9f0025923da73f$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $9f9f0025923da73f$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $9f9f0025923da73f$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d34581d01d8d1029$var$_MutationObserver_instances, $d34581d01d8d1029$var$updateResult_fn).call(this);
        (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d34581d01d8d1029$var$_MutationObserver_instances, $d34581d01d8d1029$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $d34581d01d8d1029$var$_currentMutation, void 0);
        (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d34581d01d8d1029$var$_MutationObserver_instances, $d34581d01d8d1029$var$updateResult_fn).call(this);
        (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $d34581d01d8d1029$var$_MutationObserver_instances, $d34581d01d8d1029$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $d34581d01d8d1029$var$_mutateOptions, options);
        (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $d34581d01d8d1029$var$_currentMutation, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_client).getMutationCache().build((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_client), this.options));
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentMutation).addObserver(this);
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentMutation).execute(variables);
    }
};
$d34581d01d8d1029$var$_client = new WeakMap();
$d34581d01d8d1029$var$_currentResult = new WeakMap();
$d34581d01d8d1029$var$_currentMutation = new WeakMap();
$d34581d01d8d1029$var$_mutateOptions = new WeakMap();
$d34581d01d8d1029$var$_MutationObserver_instances = new WeakSet();
$d34581d01d8d1029$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $d767dfc79a020d69$export$a1659b54bac3252a)();
    (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $d34581d01d8d1029$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$d34581d01d8d1029$var$notify_fn = function(action) {
    (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentResult).variables;
            const onMutateResult = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentResult).context;
            const context = {
                client: (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_client),
                meta: this.options.meta,
                mutationKey: this.options.mutationKey
            };
            if ((action == null ? void 0 : action.type) === "success") {
                try {
                    (_b = (_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
                try {
                    (_d = (_c = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
            } else if ((action == null ? void 0 : action.type) === "error") {
                try {
                    (_f = (_e = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
                try {
                    (_h = (_g = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $d34581d01d8d1029$var$_currentResult));
        });
    });
};



"use client";
function $957614eff0380312$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $427d8fa9df978c82$export$22e77b9572c4fded)(queryClient);
    const [observer] = $lCzvA.useState(()=>new (0, $d34581d01d8d1029$export$d3c1860ee66f291a)(client, options));
    $lCzvA.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $lCzvA.useSyncExternalStore($lCzvA.useCallback((onStoreChange)=>observer.subscribe((0, $f0d6b6465c83f494$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $lCzvA.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $9f9f0025923da73f$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $9f9f0025923da73f$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}










var $9e4c83e0ecae4ba0$var$_client, $9e4c83e0ecae4ba0$var$_currentQuery, $9e4c83e0ecae4ba0$var$_currentQueryInitialState, $9e4c83e0ecae4ba0$var$_currentResult, $9e4c83e0ecae4ba0$var$_currentResultState, $9e4c83e0ecae4ba0$var$_currentResultOptions, $9e4c83e0ecae4ba0$var$_currentThenable, $9e4c83e0ecae4ba0$var$_selectError, $9e4c83e0ecae4ba0$var$_selectFn, $9e4c83e0ecae4ba0$var$_selectResult, $9e4c83e0ecae4ba0$var$_lastQueryWithDefinedData, $9e4c83e0ecae4ba0$var$_staleTimeoutId, $9e4c83e0ecae4ba0$var$_refetchIntervalId, $9e4c83e0ecae4ba0$var$_currentRefetchInterval, $9e4c83e0ecae4ba0$var$_trackedProps, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$executeFetch_fn, $9e4c83e0ecae4ba0$var$updateStaleTimeout_fn, $9e4c83e0ecae4ba0$var$computeRefetchInterval_fn, $9e4c83e0ecae4ba0$var$updateRefetchInterval_fn, $9e4c83e0ecae4ba0$var$updateTimers_fn, $9e4c83e0ecae4ba0$var$clearStaleTimeout_fn, $9e4c83e0ecae4ba0$var$clearRefetchInterval_fn, $9e4c83e0ecae4ba0$var$updateQuery_fn, $9e4c83e0ecae4ba0$var$notify_fn;
var $9e4c83e0ecae4ba0$export$a06cf8c0066f0d4c = class extends (0, $fa7f8e88baa31e37$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_client);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_currentQuery);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_currentQueryInitialState);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_currentResult);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_currentResultState);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_currentResultOptions);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_currentThenable);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_selectError);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_selectFn);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_selectResult);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_lastQueryWithDefinedData);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_staleTimeoutId);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_refetchIntervalId);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_currentRefetchInterval);
        (0, $d6a3b9b6cdd1d7b7$export$addf369becd23283)(this, $9e4c83e0ecae4ba0$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_client, client);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_selectError, null);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_currentThenable, (0, $520a224bc020dbc5$export$d54630db02a12b72)());
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery).addObserver(this);
            if ($9e4c83e0ecae4ba0$var$shouldFetchOnMount((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery), this.options)) (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $9e4c83e0ecae4ba0$var$shouldFetchOn((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $9e4c83e0ecae4ba0$var$shouldFetchOn((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$clearStaleTimeout_fn).call(this);
        (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$clearRefetchInterval_fn).call(this);
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery).removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery);
        this.options = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $9f9f0025923da73f$export$d7ee3961208f79c1)(this.options.enabled, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$updateQuery_fn).call(this);
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $9f9f0025923da73f$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $9e4c83e0ecae4ba0$var$shouldFetchOptionally((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$executeFetch_fn).call(this);
        this.updateResult();
        if (mounted && ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery) !== prevQuery || (0, $9f9f0025923da73f$export$d7ee3961208f79c1)(this.options.enabled, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery)) !== (0, $9f9f0025923da73f$export$d7ee3961208f79c1)(prevOptions.enabled, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery)) || (0, $9f9f0025923da73f$export$cb3145f011bda3ac)(this.options.staleTime, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery)) !== (0, $9f9f0025923da73f$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery)))) (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery) !== prevQuery || (0, $9f9f0025923da73f$export$d7ee3961208f79c1)(this.options.enabled, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery)) !== (0, $9f9f0025923da73f$export$d7ee3961208f79c1)(prevOptions.enabled, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery)) || nextRefetchInterval !== (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentRefetchInterval))) (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_client).getQueryCache().build((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_client), options);
        const result = this.createResult(query, options);
        if ($9e4c83e0ecae4ba0$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_currentResult, result);
            (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_currentResultOptions, this.options);
            (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_currentResultState, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked == null || onPropTracked(key);
                if (key === "promise") {
                    this.trackProp("data");
                    if (!this.options.experimental_prefetchInRender && (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentThenable).status === "pending") (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                }
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_client).defaultQueryOptions(options);
        const query = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_client).getQueryCache().build((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResult);
        const prevResultState = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResultState);
        const prevResultOptions = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $9e4c83e0ecae4ba0$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $9e4c83e0ecae4ba0$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $5570f8492452f3c7$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_lastQueryWithDefinedData)) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $9f9f0025923da73f$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_selectFn)) data = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_selectResult);
            else try {
                (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_selectFn, options.select);
                data = options.select(data);
                data = (0, $9f9f0025923da73f$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_selectResult, data);
                (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_selectError, null);
            } catch (selectError) {
                (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_selectError, selectError);
            }
        }
        if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_selectError)) {
            error = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_selectError);
            data = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: query.isFetched(),
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $9e4c83e0ecae4ba0$var$isStale(query, options),
            refetch: this.refetch,
            promise: (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentThenable),
            isEnabled: (0, $9f9f0025923da73f$export$d7ee3961208f79c1)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const hasResultData = nextResult.data !== void 0;
            const isErrorWithoutData = nextResult.status === "error" && !hasResultData;
            const finalizeThenableIfPossible = (thenable)=>{
                if (isErrorWithoutData) thenable.reject(nextResult.error);
                else if (hasResultData) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_currentThenable, nextResult.promise = (0, $520a224bc020dbc5$export$d54630db02a12b72)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (isErrorWithoutData || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (!isErrorWithoutData || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResult);
        const nextResult = this.createResult((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery), this.options);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_currentResultState, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery).state);
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_currentResultOptions, this.options);
        if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResultState).data !== void 0) (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_lastQueryWithDefinedData, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery));
        if ((0, $9f9f0025923da73f$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_currentResult, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$notify_fn).call(this, {
            listeners: shouldNotifyListeners()
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$updateTimers_fn).call(this);
    }
};
$9e4c83e0ecae4ba0$var$_client = new WeakMap();
$9e4c83e0ecae4ba0$var$_currentQuery = new WeakMap();
$9e4c83e0ecae4ba0$var$_currentQueryInitialState = new WeakMap();
$9e4c83e0ecae4ba0$var$_currentResult = new WeakMap();
$9e4c83e0ecae4ba0$var$_currentResultState = new WeakMap();
$9e4c83e0ecae4ba0$var$_currentResultOptions = new WeakMap();
$9e4c83e0ecae4ba0$var$_currentThenable = new WeakMap();
$9e4c83e0ecae4ba0$var$_selectError = new WeakMap();
$9e4c83e0ecae4ba0$var$_selectFn = new WeakMap();
$9e4c83e0ecae4ba0$var$_selectResult = new WeakMap();
$9e4c83e0ecae4ba0$var$_lastQueryWithDefinedData = new WeakMap();
$9e4c83e0ecae4ba0$var$_staleTimeoutId = new WeakMap();
$9e4c83e0ecae4ba0$var$_refetchIntervalId = new WeakMap();
$9e4c83e0ecae4ba0$var$_currentRefetchInterval = new WeakMap();
$9e4c83e0ecae4ba0$var$_trackedProps = new WeakMap();
$9e4c83e0ecae4ba0$var$_QueryObserver_instances = new WeakSet();
$9e4c83e0ecae4ba0$var$executeFetch_fn = function(fetchOptions) {
    (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$updateQuery_fn).call(this);
    let promise = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $9f9f0025923da73f$export$8793edee2d425525));
    return promise;
};
$9e4c83e0ecae4ba0$var$updateStaleTimeout_fn = function() {
    (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $9f9f0025923da73f$export$cb3145f011bda3ac)(this.options.staleTime, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery));
    if ((0, $bd362d0e3cb143ba$export$2d935f1a9c9d3f3e).isServer() || (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResult).isStale || !(0, $9f9f0025923da73f$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $9f9f0025923da73f$export$811b83d62bcf47f0)((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_staleTimeoutId, (0, $081f0087b1e470a7$export$94a2700736e69372).setTimeout(()=>{
        if (!(0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$9e4c83e0ecae4ba0$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$9e4c83e0ecae4ba0$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$clearRefetchInterval_fn).call(this);
    (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_currentRefetchInterval, nextInterval);
    if ((0, $bd362d0e3cb143ba$export$2d935f1a9c9d3f3e).isServer() || (0, $9f9f0025923da73f$export$d7ee3961208f79c1)(this.options.enabled, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery)) === false || !(0, $9f9f0025923da73f$export$e539f754e934e270)((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentRefetchInterval)) || (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentRefetchInterval) === 0) return;
    (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_refetchIntervalId, (0, $081f0087b1e470a7$export$94a2700736e69372).setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $a86282ed95c1f11c$export$6bf54661be5b02cf).isFocused()) (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$executeFetch_fn).call(this);
    }, (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentRefetchInterval)));
};
$9e4c83e0ecae4ba0$var$updateTimers_fn = function() {
    (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$updateStaleTimeout_fn).call(this);
    (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$updateRefetchInterval_fn).call(this, (0, $d6a3b9b6cdd1d7b7$export$fa92d15b718fce20)(this, $9e4c83e0ecae4ba0$var$_QueryObserver_instances, $9e4c83e0ecae4ba0$var$computeRefetchInterval_fn).call(this));
};
$9e4c83e0ecae4ba0$var$clearStaleTimeout_fn = function() {
    if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_staleTimeoutId) !== void 0) {
        (0, $081f0087b1e470a7$export$94a2700736e69372).clearTimeout((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_staleTimeoutId));
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_staleTimeoutId, void 0);
    }
};
$9e4c83e0ecae4ba0$var$clearRefetchInterval_fn = function() {
    if ((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_refetchIntervalId) !== void 0) {
        (0, $081f0087b1e470a7$export$94a2700736e69372).clearInterval((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_refetchIntervalId));
        (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_refetchIntervalId, void 0);
    }
};
$9e4c83e0ecae4ba0$var$updateQuery_fn = function() {
    const query = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_client).getQueryCache().build((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_client), this.options);
    if (query === (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery)) return;
    const prevQuery = (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery);
    (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_currentQuery, query);
    (0, $d6a3b9b6cdd1d7b7$export$42432efe6614d3b4)(this, $9e4c83e0ecae4ba0$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$9e4c83e0ecae4ba0$var$notify_fn = function(notifyOptions) {
    (0, $f0d6b6465c83f494$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentResult));
        });
        (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_client).getQueryCache().notify({
            query: (0, $d6a3b9b6cdd1d7b7$export$18a094aefa070634)(this, $9e4c83e0ecae4ba0$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $9e4c83e0ecae4ba0$var$shouldLoadOnMount(query, options) {
    return (0, $9f9f0025923da73f$export$d7ee3961208f79c1)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && (0, $9f9f0025923da73f$export$d7ee3961208f79c1)(options.retryOnMount, query) === false);
}
function $9e4c83e0ecae4ba0$var$shouldFetchOnMount(query, options) {
    return $9e4c83e0ecae4ba0$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $9e4c83e0ecae4ba0$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $9e4c83e0ecae4ba0$var$shouldFetchOn(query, options, field) {
    if ((0, $9f9f0025923da73f$export$d7ee3961208f79c1)(options.enabled, query) !== false && (0, $9f9f0025923da73f$export$cb3145f011bda3ac)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $9e4c83e0ecae4ba0$var$isStale(query, options);
    }
    return false;
}
function $9e4c83e0ecae4ba0$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $9f9f0025923da73f$export$d7ee3961208f79c1)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $9e4c83e0ecae4ba0$var$isStale(query, options);
}
function $9e4c83e0ecae4ba0$var$isStale(query, options) {
    return (0, $9f9f0025923da73f$export$d7ee3961208f79c1)(options.enabled, query) !== false && query.isStaleByTime((0, $9f9f0025923da73f$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $9e4c83e0ecae4ba0$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $9f9f0025923da73f$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $lCzvA = parcelRequire("lCzvA");



var $lCzvA = parcelRequire("lCzvA");

"use client";
function $902f99d3c8f9f343$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $902f99d3c8f9f343$var$QueryErrorResetBoundaryContext = $lCzvA.createContext($902f99d3c8f9f343$var$createValue());
var $902f99d3c8f9f343$export$50dfac555130cafd = ()=>$lCzvA.useContext($902f99d3c8f9f343$var$QueryErrorResetBoundaryContext);
var $902f99d3c8f9f343$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $lCzvA.useState(()=>$902f99d3c8f9f343$var$createValue());
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($902f99d3c8f9f343$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $lCzvA = parcelRequire("lCzvA");

"use client";
var $98a9219e14eff01c$export$ae8adb3de3d77633 = (options, errorResetBoundary, query)=>{
    const throwOnError = (query == null ? void 0 : query.state.error) && typeof options.throwOnError === "function" ? (0, $9f9f0025923da73f$export$2072f68e6c3507cf)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || options.experimental_prefetchInRender || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $98a9219e14eff01c$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $lCzvA.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $98a9219e14eff01c$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $9f9f0025923da73f$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $lCzvA = parcelRequire("lCzvA");
"use client";
var $a50a545e3526d4c8$var$IsRestoringContext = $lCzvA.createContext(false);
var $a50a545e3526d4c8$export$4da0178d6b5f553 = ()=>$lCzvA.useContext($a50a545e3526d4c8$var$IsRestoringContext);
var $a50a545e3526d4c8$export$593807d4e94f9621 = $a50a545e3526d4c8$var$IsRestoringContext.Provider;


// src/suspense.ts
var $5a1991e6e65bd423$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $5a1991e6e65bd423$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var $5a1991e6e65bd423$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $5a1991e6e65bd423$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $5a1991e6e65bd423$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $ff75232565ca0ad8$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d;
    const isRestoring = (0, $a50a545e3526d4c8$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $902f99d3c8f9f343$export$50dfac555130cafd)();
    const client = (0, $427d8fa9df978c82$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    const subscribed = options.subscribed !== false;
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : subscribed ? "optimistic" : void 0;
    (0, $5a1991e6e65bd423$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $98a9219e14eff01c$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary, query);
    (0, $98a9219e14eff01c$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $lCzvA.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && subscribed;
    $lCzvA.useSyncExternalStore($lCzvA.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $f0d6b6465c83f494$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $9f9f0025923da73f$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $lCzvA.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $5a1991e6e65bd423$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $5a1991e6e65bd423$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $98a9219e14eff01c$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $bd362d0e3cb143ba$export$2d935f1a9c9d3f3e).isServer() && (0, $5a1991e6e65bd423$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $5a1991e6e65bd423$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        query == null ? void 0 : query.promise;
        promise == null || promise.catch((0, $9f9f0025923da73f$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $4237593f4ee1eaed$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $ff75232565ca0ad8$export$fff0865807e996c5)(options, (0, $9e4c83e0ecae4ba0$export$a06cf8c0066f0d4c), queryClient);
}


var $ec4affac0c13709c$exports = {};
'use strict';
Object.defineProperty($ec4affac0c13709c$exports, '__esModule', {
    value: true
});
function $ec4affac0c13709c$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $lCzvA = parcelRequire("lCzvA");
var $ec4affac0c13709c$var$React__default = $ec4affac0c13709c$var$_interopDefault($lCzvA);

var $fYDAD = parcelRequire("fYDAD");
var $ec4affac0c13709c$var$ClientUAInstance = new $fYDAD();
var $ec4affac0c13709c$var$browser = $ec4affac0c13709c$var$ClientUAInstance.getBrowser();
var $ec4affac0c13709c$var$cpu = $ec4affac0c13709c$var$ClientUAInstance.getCPU();
var $ec4affac0c13709c$var$device = $ec4affac0c13709c$var$ClientUAInstance.getDevice();
var $ec4affac0c13709c$var$engine = $ec4affac0c13709c$var$ClientUAInstance.getEngine();
var $ec4affac0c13709c$var$os = $ec4affac0c13709c$var$ClientUAInstance.getOS();
var $ec4affac0c13709c$var$ua = $ec4affac0c13709c$var$ClientUAInstance.getUA();
var $ec4affac0c13709c$var$setUa = function setUa(userAgentString) {
    return $ec4affac0c13709c$var$ClientUAInstance.setUA(userAgentString);
};
var $ec4affac0c13709c$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error('No userAgent string was provided');
        return;
    }
    var UserAgentInstance = new $fYDAD(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $ec4affac0c13709c$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $ec4affac0c13709c$var$ClientUAInstance,
    browser: $ec4affac0c13709c$var$browser,
    cpu: $ec4affac0c13709c$var$cpu,
    device: $ec4affac0c13709c$var$device,
    engine: $ec4affac0c13709c$var$engine,
    os: $ec4affac0c13709c$var$os,
    ua: $ec4affac0c13709c$var$ua,
    setUa: $ec4affac0c13709c$var$setUa,
    parseUserAgent: $ec4affac0c13709c$var$parseUserAgent
});
function $ec4affac0c13709c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ec4affac0c13709c$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ec4affac0c13709c$var$ownKeys(Object(source), true).forEach(function(key) {
            $ec4affac0c13709c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ec4affac0c13709c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ec4affac0c13709c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ec4affac0c13709c$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $ec4affac0c13709c$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ec4affac0c13709c$var$_typeof(obj);
}
function $ec4affac0c13709c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ec4affac0c13709c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ec4affac0c13709c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ec4affac0c13709c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ec4affac0c13709c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ec4affac0c13709c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ec4affac0c13709c$var$_extends() {
    $ec4affac0c13709c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ec4affac0c13709c$var$_extends.apply(this, arguments);
}
function $ec4affac0c13709c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ec4affac0c13709c$var$_setPrototypeOf(subClass, superClass);
}
function $ec4affac0c13709c$var$_getPrototypeOf(o) {
    $ec4affac0c13709c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ec4affac0c13709c$var$_getPrototypeOf(o);
}
function $ec4affac0c13709c$var$_setPrototypeOf(o, p) {
    $ec4affac0c13709c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ec4affac0c13709c$var$_setPrototypeOf(o, p);
}
function $ec4affac0c13709c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ec4affac0c13709c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ec4affac0c13709c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ec4affac0c13709c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ec4affac0c13709c$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ec4affac0c13709c$var$_assertThisInitialized(self);
}
function $ec4affac0c13709c$var$_slicedToArray(arr, i) {
    return $ec4affac0c13709c$var$_arrayWithHoles(arr) || $ec4affac0c13709c$var$_iterableToArrayLimit(arr, i) || $ec4affac0c13709c$var$_unsupportedIterableToArray(arr, i) || $ec4affac0c13709c$var$_nonIterableRest();
}
function $ec4affac0c13709c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ec4affac0c13709c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ec4affac0c13709c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ec4affac0c13709c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ec4affac0c13709c$var$_arrayLikeToArray(o, minLen);
}
function $ec4affac0c13709c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ec4affac0c13709c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $ec4affac0c13709c$var$DeviceTypes = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Embedded: 'embedded',
    Browser: undefined
};
var $ec4affac0c13709c$var$BrowserTypes = {
    Chrome: 'Chrome',
    Firefox: 'Firefox',
    Opera: 'Opera',
    Yandex: 'Yandex',
    Safari: 'Safari',
    InternetExplorer: 'Internet Explorer',
    Edge: 'Edge',
    Chromium: 'Chromium',
    Ie: 'IE',
    MobileSafari: 'Mobile Safari',
    EdgeChromium: 'Edge Chromium',
    MIUI: 'MIUI Browser',
    SamsungBrowser: 'Samsung Browser'
};
var $ec4affac0c13709c$var$OsTypes = {
    IOS: 'iOS',
    Android: 'Android',
    WindowsPhone: 'Windows Phone',
    Windows: 'Windows',
    MAC_OS: 'Mac OS'
};
var $ec4affac0c13709c$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $ec4affac0c13709c$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $ec4affac0c13709c$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $ec4affac0c13709c$var$InitialDeviceTypes;
    }
};
var $ec4affac0c13709c$var$setUserAgent = function setUserAgent(userAgent) {
    return $ec4affac0c13709c$var$setUa(userAgent);
};
var $ec4affac0c13709c$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
};
var $ec4affac0c13709c$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $ec4affac0c13709c$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $ec4affac0c13709c$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $ec4affac0c13709c$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $ec4affac0c13709c$var$setDefaults(browser.major),
        browserFullVersion: $ec4affac0c13709c$var$setDefaults(browser.version),
        browserName: $ec4affac0c13709c$var$setDefaults(browser.name),
        engineName: $ec4affac0c13709c$var$setDefaults(engine.name),
        engineVersion: $ec4affac0c13709c$var$setDefaults(engine.version),
        osName: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        userAgent: $ec4affac0c13709c$var$setDefaults(ua)
    };
};
var $ec4affac0c13709c$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $ec4affac0c13709c$var$_objectSpread2({}, type, {
        vendor: $ec4affac0c13709c$var$setDefaults(device.vendor),
        model: $ec4affac0c13709c$var$setDefaults(device.model),
        os: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        ua: $ec4affac0c13709c$var$setDefaults(ua)
    });
};
var $ec4affac0c13709c$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $ec4affac0c13709c$var$setDefaults(engine.name),
        engineVersion: $ec4affac0c13709c$var$setDefaults(engine.version),
        osName: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        userAgent: $ec4affac0c13709c$var$setDefaults(ua)
    };
};
var $ec4affac0c13709c$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $ec4affac0c13709c$var$setDefaults(engine.name),
        engineVersion: $ec4affac0c13709c$var$setDefaults(engine.version),
        osName: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        userAgent: $ec4affac0c13709c$var$setDefaults(ua)
    };
};
var $ec4affac0c13709c$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $ec4affac0c13709c$var$setDefaults(engine.name),
        engineVersion: $ec4affac0c13709c$var$setDefaults(engine.version),
        osName: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        userAgent: $ec4affac0c13709c$var$setDefaults(ua)
    };
};
var $ec4affac0c13709c$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $ec4affac0c13709c$var$setDefaults(device.vendor),
        model: $ec4affac0c13709c$var$setDefaults(device.model),
        engineName: $ec4affac0c13709c$var$setDefaults(engine.name),
        engineVersion: $ec4affac0c13709c$var$setDefaults(engine.version),
        osName: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        userAgent: $ec4affac0c13709c$var$setDefaults(ua)
    };
};
function $ec4affac0c13709c$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $ec4affac0c13709c$var$parseUserAgent(userAgent) : $ec4affac0c13709c$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $ec4affac0c13709c$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $ec4affac0c13709c$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $ec4affac0c13709c$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $ec4affac0c13709c$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $ec4affac0c13709c$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $ec4affac0c13709c$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $ec4affac0c13709c$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $ec4affac0c13709c$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $ec4affac0c13709c$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Mobile;
};
var $ec4affac0c13709c$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Tablet;
};
var $ec4affac0c13709c$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Mobile || type === $ec4affac0c13709c$var$DeviceTypes.Tablet;
};
var $ec4affac0c13709c$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.SmartTv;
};
var $ec4affac0c13709c$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Browser;
};
var $ec4affac0c13709c$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Wearable;
};
var $ec4affac0c13709c$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Console;
};
var $ec4affac0c13709c$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Embedded;
};
var $ec4affac0c13709c$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $ec4affac0c13709c$var$setDefaults(vendor);
};
var $ec4affac0c13709c$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $ec4affac0c13709c$var$setDefaults(model);
};
var $ec4affac0c13709c$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $ec4affac0c13709c$var$setDefaults(type, 'browser');
}; // os types
var $ec4affac0c13709c$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $ec4affac0c13709c$var$OsTypes.Android;
};
var $ec4affac0c13709c$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $ec4affac0c13709c$var$OsTypes.Windows;
};
var $ec4affac0c13709c$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $ec4affac0c13709c$var$OsTypes.MAC_OS;
};
var $ec4affac0c13709c$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $ec4affac0c13709c$var$OsTypes.WindowsPhone;
};
var $ec4affac0c13709c$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $ec4affac0c13709c$var$OsTypes.IOS;
};
var $ec4affac0c13709c$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $ec4affac0c13709c$var$setDefaults(version);
};
var $ec4affac0c13709c$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $ec4affac0c13709c$var$setDefaults(name);
}; // browser types
var $ec4affac0c13709c$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Chrome;
};
var $ec4affac0c13709c$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Firefox;
};
var $ec4affac0c13709c$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Chromium;
};
var $ec4affac0c13709c$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Edge;
};
var $ec4affac0c13709c$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Yandex;
};
var $ec4affac0c13709c$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Safari || name === $ec4affac0c13709c$var$BrowserTypes.MobileSafari;
};
var $ec4affac0c13709c$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.MobileSafari;
};
var $ec4affac0c13709c$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Opera;
};
var $ec4affac0c13709c$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.InternetExplorer || name === $ec4affac0c13709c$var$BrowserTypes.Ie;
};
var $ec4affac0c13709c$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.MIUI;
};
var $ec4affac0c13709c$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.SamsungBrowser;
};
var $ec4affac0c13709c$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $ec4affac0c13709c$var$setDefaults(version);
};
var $ec4affac0c13709c$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $ec4affac0c13709c$var$setDefaults(major);
};
var $ec4affac0c13709c$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $ec4affac0c13709c$var$setDefaults(name);
}; // engine types
var $ec4affac0c13709c$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $ec4affac0c13709c$var$setDefaults(name);
};
var $ec4affac0c13709c$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $ec4affac0c13709c$var$setDefaults(version);
};
var $ec4affac0c13709c$var$isElectronType = function isElectronType() {
    var nav = $ec4affac0c13709c$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var $ec4affac0c13709c$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var $ec4affac0c13709c$var$getIOS13 = function getIOS13() {
    var nav = $ec4affac0c13709c$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $ec4affac0c13709c$var$getIPad13 = function getIPad13() {
    return $ec4affac0c13709c$var$isIOS13Check('iPad');
};
var $ec4affac0c13709c$var$getIphone13 = function getIphone13() {
    return $ec4affac0c13709c$var$isIOS13Check('iPhone');
};
var $ec4affac0c13709c$var$getIPod13 = function getIPod13() {
    return $ec4affac0c13709c$var$isIOS13Check('iPod');
};
var $ec4affac0c13709c$var$getUseragent = function getUseragent(userAg) {
    return $ec4affac0c13709c$var$setDefaults(userAg);
};
function $ec4affac0c13709c$var$buildSelectorsObject(options) {
    var _ref = options ? options : $ec4affac0c13709c$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $ec4affac0c13709c$var$isSmartTVType(device),
        isConsole: $ec4affac0c13709c$var$isConsoleType(device),
        isWearable: $ec4affac0c13709c$var$isWearableType(device),
        isEmbedded: $ec4affac0c13709c$var$isEmbeddedType(device),
        isMobileSafari: $ec4affac0c13709c$var$isMobileSafariType(browser) || $ec4affac0c13709c$var$getIPad13(),
        isChromium: $ec4affac0c13709c$var$isChromiumType(browser),
        isMobile: $ec4affac0c13709c$var$isMobileAndTabletType(device) || $ec4affac0c13709c$var$getIPad13(),
        isMobileOnly: $ec4affac0c13709c$var$isMobileType(device),
        isTablet: $ec4affac0c13709c$var$isTabletType(device) || $ec4affac0c13709c$var$getIPad13(),
        isBrowser: $ec4affac0c13709c$var$isBrowserType(device),
        isDesktop: $ec4affac0c13709c$var$isBrowserType(device),
        isAndroid: $ec4affac0c13709c$var$isAndroidType(os),
        isWinPhone: $ec4affac0c13709c$var$isWinPhoneType(os),
        isIOS: $ec4affac0c13709c$var$isIOSType(os) || $ec4affac0c13709c$var$getIPad13(),
        isChrome: $ec4affac0c13709c$var$isChromeType(browser),
        isFirefox: $ec4affac0c13709c$var$isFirefoxType(browser),
        isSafari: $ec4affac0c13709c$var$isSafariType(browser),
        isOpera: $ec4affac0c13709c$var$isOperaType(browser),
        isIE: $ec4affac0c13709c$var$isIEType(browser),
        osVersion: $ec4affac0c13709c$var$getOsVersion(os),
        osName: $ec4affac0c13709c$var$getOsName(os),
        fullBrowserVersion: $ec4affac0c13709c$var$getBrowserFullVersion(browser),
        browserVersion: $ec4affac0c13709c$var$getBrowserVersion(browser),
        browserName: $ec4affac0c13709c$var$getBrowserName(browser),
        mobileVendor: $ec4affac0c13709c$var$getMobileVendor(device),
        mobileModel: $ec4affac0c13709c$var$getMobileModel(device),
        engineName: $ec4affac0c13709c$var$getEngineName(engine),
        engineVersion: $ec4affac0c13709c$var$getEngineVersion(engine),
        getUA: $ec4affac0c13709c$var$getUseragent(ua),
        isEdge: $ec4affac0c13709c$var$isEdgeType(browser) || $ec4affac0c13709c$var$isEdgeChromiumType(ua),
        isYandex: $ec4affac0c13709c$var$isYandexType(browser),
        deviceType: $ec4affac0c13709c$var$getDeviceType(device),
        isIOS13: $ec4affac0c13709c$var$getIOS13(),
        isIPad13: $ec4affac0c13709c$var$getIPad13(),
        isIPhone13: $ec4affac0c13709c$var$getIphone13(),
        isIPod13: $ec4affac0c13709c$var$getIPod13(),
        isElectron: $ec4affac0c13709c$var$isElectronType(),
        isEdgeChromium: $ec4affac0c13709c$var$isEdgeChromiumType(ua),
        isLegacyEdge: $ec4affac0c13709c$var$isEdgeType(browser) && !$ec4affac0c13709c$var$isEdgeChromiumType(ua),
        isWindows: $ec4affac0c13709c$var$isWindowsType(os),
        isMacOs: $ec4affac0c13709c$var$isMacOsType(os),
        isMIUI: $ec4affac0c13709c$var$isMIUIType(browser),
        isSamsungBrowser: $ec4affac0c13709c$var$isSamsungBrowserType(browser)
    };
}
var $ec4affac0c13709c$var$isSmartTV = $ec4affac0c13709c$var$isSmartTVType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isConsole = $ec4affac0c13709c$var$isConsoleType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isWearable = $ec4affac0c13709c$var$isWearableType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isEmbedded = $ec4affac0c13709c$var$isEmbeddedType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isMobileSafari = $ec4affac0c13709c$var$isMobileSafariType($ec4affac0c13709c$var$browser) || $ec4affac0c13709c$var$getIPad13();
var $ec4affac0c13709c$var$isChromium = $ec4affac0c13709c$var$isChromiumType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isMobile = $ec4affac0c13709c$var$isMobileAndTabletType($ec4affac0c13709c$var$device) || $ec4affac0c13709c$var$getIPad13();
var $ec4affac0c13709c$var$isMobileOnly = $ec4affac0c13709c$var$isMobileType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isTablet = $ec4affac0c13709c$var$isTabletType($ec4affac0c13709c$var$device) || $ec4affac0c13709c$var$getIPad13();
var $ec4affac0c13709c$var$isBrowser = $ec4affac0c13709c$var$isBrowserType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isDesktop = $ec4affac0c13709c$var$isBrowserType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isAndroid = $ec4affac0c13709c$var$isAndroidType($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$isWinPhone = $ec4affac0c13709c$var$isWinPhoneType($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$isIOS = $ec4affac0c13709c$var$isIOSType($ec4affac0c13709c$var$os) || $ec4affac0c13709c$var$getIPad13();
var $ec4affac0c13709c$var$isChrome = $ec4affac0c13709c$var$isChromeType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isFirefox = $ec4affac0c13709c$var$isFirefoxType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isSafari = $ec4affac0c13709c$var$isSafariType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isOpera = $ec4affac0c13709c$var$isOperaType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isIE = $ec4affac0c13709c$var$isIEType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$osVersion = $ec4affac0c13709c$var$getOsVersion($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$osName = $ec4affac0c13709c$var$getOsName($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$fullBrowserVersion = $ec4affac0c13709c$var$getBrowserFullVersion($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$browserVersion = $ec4affac0c13709c$var$getBrowserVersion($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$browserName = $ec4affac0c13709c$var$getBrowserName($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$mobileVendor = $ec4affac0c13709c$var$getMobileVendor($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$mobileModel = $ec4affac0c13709c$var$getMobileModel($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$engineName = $ec4affac0c13709c$var$getEngineName($ec4affac0c13709c$var$engine);
var $ec4affac0c13709c$var$engineVersion = $ec4affac0c13709c$var$getEngineVersion($ec4affac0c13709c$var$engine);
var $ec4affac0c13709c$var$getUA = $ec4affac0c13709c$var$getUseragent($ec4affac0c13709c$var$ua);
var $ec4affac0c13709c$var$isEdge = $ec4affac0c13709c$var$isEdgeType($ec4affac0c13709c$var$browser) || $ec4affac0c13709c$var$isEdgeChromiumType($ec4affac0c13709c$var$ua);
var $ec4affac0c13709c$var$isYandex = $ec4affac0c13709c$var$isYandexType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$deviceType = $ec4affac0c13709c$var$getDeviceType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isIOS13 = $ec4affac0c13709c$var$getIOS13();
var $ec4affac0c13709c$var$isIPad13 = $ec4affac0c13709c$var$getIPad13();
var $ec4affac0c13709c$var$isIPhone13 = $ec4affac0c13709c$var$getIphone13();
var $ec4affac0c13709c$var$isIPod13 = $ec4affac0c13709c$var$getIPod13();
var $ec4affac0c13709c$var$isElectron = $ec4affac0c13709c$var$isElectronType();
var $ec4affac0c13709c$var$isEdgeChromium = $ec4affac0c13709c$var$isEdgeChromiumType($ec4affac0c13709c$var$ua);
var $ec4affac0c13709c$var$isLegacyEdge = $ec4affac0c13709c$var$isEdgeType($ec4affac0c13709c$var$browser) && !$ec4affac0c13709c$var$isEdgeChromiumType($ec4affac0c13709c$var$ua);
var $ec4affac0c13709c$var$isWindows = $ec4affac0c13709c$var$isWindowsType($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$isMacOs = $ec4affac0c13709c$var$isMacOsType($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$isMIUI = $ec4affac0c13709c$var$isMIUIType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isSamsungBrowser = $ec4affac0c13709c$var$isSamsungBrowserType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== 'string') {
        console.error('No valid user agent string was provided');
        return;
    }
    var _UAHelper$parseUserAg = $ec4affac0c13709c$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $ec4affac0c13709c$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $ec4affac0c13709c$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isAndroid ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isBrowser ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isIE ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isIOS ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isMobile ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isTablet ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isWinPhone ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $ec4affac0c13709c$var$isMobileOnly ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isSmartTV ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isConsole ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isWearable ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
function $ec4affac0c13709c$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $ec4affac0c13709c$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $ec4affac0c13709c$var$_classCallCheck(this, _class);
            _this = $ec4affac0c13709c$var$_possibleConstructorReturn(this, $ec4affac0c13709c$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($ec4affac0c13709c$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($ec4affac0c13709c$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($ec4affac0c13709c$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $ec4affac0c13709c$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $ec4affac0c13709c$var$_typeof(window)) !== undefined && $ec4affac0c13709c$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $ec4affac0c13709c$var$React__default.createElement(WrappedComponent, $ec4affac0c13709c$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($ec4affac0c13709c$var$React__default.Component);
}
function $ec4affac0c13709c$var$useMobileOrientation() {
    var _useState = $lCzvA.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
    }), _useState2 = $ec4affac0c13709c$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $lCzvA.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $lCzvA.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $ec4affac0c13709c$var$_typeof(window)) !== undefined && $ec4affac0c13709c$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $ec4affac0c13709c$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $ec4affac0c13709c$var$parseUserAgent(hookUserAgent);
}
function $ec4affac0c13709c$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $ec4affac0c13709c$var$useDeviceData(hookUserAgent);
    var selectors = $ec4affac0c13709c$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$ec4affac0c13709c$exports.AndroidView = $ec4affac0c13709c$var$AndroidView;
$ec4affac0c13709c$exports.BrowserTypes = $ec4affac0c13709c$var$BrowserTypes;
$ec4affac0c13709c$exports.BrowserView = $ec4affac0c13709c$var$BrowserView;
$ec4affac0c13709c$exports.ConsoleView = $ec4affac0c13709c$var$ConsoleView;
$ec4affac0c13709c$exports.CustomView = $ec4affac0c13709c$var$CustomView;
$ec4affac0c13709c$exports.IEView = $ec4affac0c13709c$var$IEView;
$ec4affac0c13709c$exports.IOSView = $ec4affac0c13709c$var$IOSView;
$ec4affac0c13709c$exports.MobileOnlyView = $ec4affac0c13709c$var$MobileOnlyView;
$ec4affac0c13709c$exports.MobileView = $ec4affac0c13709c$var$MobileView;
$ec4affac0c13709c$exports.OsTypes = $ec4affac0c13709c$var$OsTypes;
$ec4affac0c13709c$exports.SmartTVView = $ec4affac0c13709c$var$SmartTVView;
$ec4affac0c13709c$exports.TabletView = $ec4affac0c13709c$var$TabletView;
$ec4affac0c13709c$exports.WearableView = $ec4affac0c13709c$var$WearableView;
$ec4affac0c13709c$exports.WinPhoneView = $ec4affac0c13709c$var$WinPhoneView;
$ec4affac0c13709c$exports.browserName = $ec4affac0c13709c$var$browserName;
$ec4affac0c13709c$exports.browserVersion = $ec4affac0c13709c$var$browserVersion;
$ec4affac0c13709c$exports.deviceDetect = $ec4affac0c13709c$var$deviceDetect;
$ec4affac0c13709c$exports.deviceType = $ec4affac0c13709c$var$deviceType;
$ec4affac0c13709c$exports.engineName = $ec4affac0c13709c$var$engineName;
$ec4affac0c13709c$exports.engineVersion = $ec4affac0c13709c$var$engineVersion;
$ec4affac0c13709c$exports.fullBrowserVersion = $ec4affac0c13709c$var$fullBrowserVersion;
$ec4affac0c13709c$exports.getSelectorsByUserAgent = $ec4affac0c13709c$var$getSelectorsByUserAgent;
$ec4affac0c13709c$exports.getUA = $ec4affac0c13709c$var$getUA;
$ec4affac0c13709c$exports.isAndroid = $ec4affac0c13709c$var$isAndroid;
$ec4affac0c13709c$exports.isBrowser = $ec4affac0c13709c$var$isBrowser;
$ec4affac0c13709c$exports.isChrome = $ec4affac0c13709c$var$isChrome;
$ec4affac0c13709c$exports.isChromium = $ec4affac0c13709c$var$isChromium;
$ec4affac0c13709c$exports.isConsole = $ec4affac0c13709c$var$isConsole;
$ec4affac0c13709c$exports.isDesktop = $ec4affac0c13709c$var$isDesktop;
$ec4affac0c13709c$exports.isEdge = $ec4affac0c13709c$var$isEdge;
$ec4affac0c13709c$exports.isEdgeChromium = $ec4affac0c13709c$var$isEdgeChromium;
$ec4affac0c13709c$exports.isElectron = $ec4affac0c13709c$var$isElectron;
$ec4affac0c13709c$exports.isEmbedded = $ec4affac0c13709c$var$isEmbedded;
$ec4affac0c13709c$exports.isFirefox = $ec4affac0c13709c$var$isFirefox;
$ec4affac0c13709c$exports.isIE = $ec4affac0c13709c$var$isIE;
$ec4affac0c13709c$exports.isIOS = $ec4affac0c13709c$var$isIOS;
$ec4affac0c13709c$exports.isIOS13 = $ec4affac0c13709c$var$isIOS13;
$ec4affac0c13709c$exports.isIPad13 = $ec4affac0c13709c$var$isIPad13;
$ec4affac0c13709c$exports.isIPhone13 = $ec4affac0c13709c$var$isIPhone13;
$ec4affac0c13709c$exports.isIPod13 = $ec4affac0c13709c$var$isIPod13;
$ec4affac0c13709c$exports.isLegacyEdge = $ec4affac0c13709c$var$isLegacyEdge;
$ec4affac0c13709c$exports.isMIUI = $ec4affac0c13709c$var$isMIUI;
$ec4affac0c13709c$exports.isMacOs = $ec4affac0c13709c$var$isMacOs;
$ec4affac0c13709c$exports.isMobile = $ec4affac0c13709c$var$isMobile;
$ec4affac0c13709c$exports.isMobileOnly = $ec4affac0c13709c$var$isMobileOnly;
$ec4affac0c13709c$exports.isMobileSafari = $ec4affac0c13709c$var$isMobileSafari;
$ec4affac0c13709c$exports.isOpera = $ec4affac0c13709c$var$isOpera;
$ec4affac0c13709c$exports.isSafari = $ec4affac0c13709c$var$isSafari;
$ec4affac0c13709c$exports.isSamsungBrowser = $ec4affac0c13709c$var$isSamsungBrowser;
$ec4affac0c13709c$exports.isSmartTV = $ec4affac0c13709c$var$isSmartTV;
$ec4affac0c13709c$exports.isTablet = $ec4affac0c13709c$var$isTablet;
$ec4affac0c13709c$exports.isWearable = $ec4affac0c13709c$var$isWearable;
$ec4affac0c13709c$exports.isWinPhone = $ec4affac0c13709c$var$isWinPhone;
$ec4affac0c13709c$exports.isWindows = $ec4affac0c13709c$var$isWindows;
$ec4affac0c13709c$exports.isYandex = $ec4affac0c13709c$var$isYandex;
$ec4affac0c13709c$exports.mobileModel = $ec4affac0c13709c$var$mobileModel;
$ec4affac0c13709c$exports.mobileVendor = $ec4affac0c13709c$var$mobileVendor;
$ec4affac0c13709c$exports.osName = $ec4affac0c13709c$var$osName;
$ec4affac0c13709c$exports.osVersion = $ec4affac0c13709c$var$osVersion;
$ec4affac0c13709c$exports.parseUserAgent = $ec4affac0c13709c$var$parseUserAgent;
$ec4affac0c13709c$exports.setUserAgent = $ec4affac0c13709c$var$setUserAgent;
$ec4affac0c13709c$exports.useDeviceData = $ec4affac0c13709c$var$useDeviceData;
$ec4affac0c13709c$exports.useDeviceSelectors = $ec4affac0c13709c$var$useDeviceSelectors;
$ec4affac0c13709c$exports.useMobileOrientation = $ec4affac0c13709c$var$useMobileOrientation;
$ec4affac0c13709c$exports.withOrientationChange = $ec4affac0c13709c$var$withOrientationChange;





const $c5f28fecad6357c0$var$$6640c5b9dcb6755e$export$347205015dbba8b5 = {
    sidenavOpen: false,
    toggleSidenavOpen: ()=>{
    // intentionally empty
    },
    activeDropdown: undefined,
    /**
   * Sets the active dropdown to the given path.
   * @param {string | undefined} _path
   */ setActiveDropdown: (_path)=>{
    // intentionally empty
    },
    sidenavRoutes: []
};
const $c5f28fecad6357c0$var$$6640c5b9dcb6755e$export$88c6527e391e3444 = (0, $lCzvA.createContext)($c5f28fecad6357c0$var$$6640c5b9dcb6755e$export$347205015dbba8b5);
const $c5f28fecad6357c0$var$$6640c5b9dcb6755e$export$7609013132585565 = ()=>(0, $lCzvA.useContext)($c5f28fecad6357c0$var$$6640c5b9dcb6755e$export$88c6527e391e3444);
/**
 * Recursively filters out the routes that have {hidden} set to true.
 * Handles nested children.
 * @param {import('../types').Route} routeParam
 */ const $c5f28fecad6357c0$var$$f99f0c98fc1c38a1$export$6ec03f543a042a5d = (routeParam)=>{
    let route = routeParam;
    // If the route has {hideInSideNav} set to true, don't render it.
    if (route.hidden) return null;
    // If the route has children, recursively filter them.
    if (route.childRoutes) route = {
        ...route,
        // @ts-ignore ts(2322) - Type 'null' is not assignable to type 'Route'.
        // This is a limitation of TypeScript not being able to infer that the
        // filter function will never return null. This can be fixed by using
        // a type guard, but that would require actually using .ts files.
        childRoutes: route.childRoutes.map((childRoute)=>$c5f28fecad6357c0$var$$f99f0c98fc1c38a1$export$6ec03f543a042a5d(childRoute)).filter(Boolean)
    };
    return route;
};
const $c5f28fecad6357c0$var$$f99f0c98fc1c38a1$export$7d7d743cf9c223f7 = (routeParam, roles)=>{
    let route = routeParam;
    // If the user is an administrator, return the route.
    if (roles.includes('ADMINISTRATOR')) return route;
    // If the role requirements are not met, return null.
    if (route.roles && !roles.some((role)=>route.roles?.includes(role))) return null;
    // If the route has children, recursively filter them.
    if (route.childRoutes) route = {
        ...route,
        // @ts-ignore ts(2322) - Type 'null' is not assignable to type 'Route'.
        childRoutes: route.childRoutes.map((childRoute)=>$c5f28fecad6357c0$var$$f99f0c98fc1c38a1$export$7d7d743cf9c223f7(childRoute, roles)).filter(Boolean)
    };
    return route;
};
var $c5f28fecad6357c0$var$$4b2dcca34f8ac8c9$export$34e0f9847d4c02dd;
var $c5f28fecad6357c0$var$$4b2dcca34f8ac8c9$export$6e25be3fd94633e2;
$c5f28fecad6357c0$var$$4b2dcca34f8ac8c9$export$34e0f9847d4c02dd = `uczouW_container`;
$c5f28fecad6357c0$var$$4b2dcca34f8ac8c9$export$6e25be3fd94633e2 = `uczouW_containerNoRoutes`;
const $c5f28fecad6357c0$var$$8682e44449a848fc$export$58448433d512296d = ()=>{
    const { authState: authState, oktaAuth: oktaAuth } = (0, $954b04773eb0508c$export$2ae4a19e09ca9a00)();
    const isAuthenticated = Boolean(authState?.isAuthenticated);
    const authIcon = isAuthenticated ? 'logout' : 'login';
    const authText = isAuthenticated ? 'Log Out' : 'Log In';
    const handleLogin = ()=>oktaAuth.signInWithRedirect();
    const handleLogout = ()=>oktaAuth.signOut();
    const authFunction = authState?.isAuthenticated ? handleLogout : handleLogin;
    return {
        authIcon: authIcon,
        authText: authText,
        handleLogin: handleLogin,
        handleLogout: handleLogout,
        authFunction: authFunction,
        isAuthenticated: isAuthenticated
    };
};
const $c5f28fecad6357c0$var$$409efd23ecc21742$export$362a618bd975540c = {
    routes: []
};
const $c5f28fecad6357c0$var$$409efd23ecc21742$export$964282a2c3979546 = (0, $lCzvA.createContext)($c5f28fecad6357c0$var$$409efd23ecc21742$export$362a618bd975540c);
const $c5f28fecad6357c0$var$$409efd23ecc21742$export$c50e37a2f0a2b064 = ()=>(0, $lCzvA.useContext)($c5f28fecad6357c0$var$$409efd23ecc21742$export$964282a2c3979546);
const $c5f28fecad6357c0$var$$e4f257f8a9378458$export$b8c6b00c62e5613a = {
    socket: undefined,
    socketReady: false
};
const $c5f28fecad6357c0$var$$e4f257f8a9378458$export$86edbdc9a1e29ae8 = (0, $lCzvA.createContext)($c5f28fecad6357c0$var$$e4f257f8a9378458$export$b8c6b00c62e5613a);
const $c5f28fecad6357c0$var$$e4f257f8a9378458$export$48f6bde144501da0 = ()=>(0, $lCzvA.useContext)($c5f28fecad6357c0$var$$e4f257f8a9378458$export$86edbdc9a1e29ae8);
/**
 * Provides socket.io connection context to children.
 * If socketNamespace is a valid string, creates and manages a socket connection.
 * Otherwise, renders children with default (disconnected) context.
 * @param {object} props
 * @param {string} [props.socketNamespace] The socket.io namespace to connect to.
 * @param {import('react').ReactNode} props.children
 */ const $c5f28fecad6357c0$var$$cd7edee6e81cb6cf$var$SocketProvider = ({ socketNamespace: socketNamespace, children: children })=>{
    const isEnabled = typeof socketNamespace === 'string' && socketNamespace.length;
    const [socket] = (0, $lCzvA.useState)(()=>{
        if (!isEnabled) return undefined;
        return (0, $b2faa63fcd6137f7$export$841407ceb083bd74)(`${window.REACT_APP_API_URL}/${socketNamespace}`, {
            path: '/kf-mfg-socket/public/v1/socket',
            secure: true,
            rejectUnauthorized: false,
            autoConnect: false
        });
    });
    const [socketReady, setSocketReady] = (0, $lCzvA.useState)(false);
    (0, $lCzvA.useEffect)(()=>{
        if (!socket) return undefined;
        const onConnect = ()=>setSocketReady(true);
        const onDisconnect = ()=>setSocketReady(false);
        socket.on('connect', onConnect);
        socket.on('disconnect', onDisconnect);
        socket.connect();
        return ()=>{
            socket.off('connect', onConnect);
            socket.off('disconnect', onDisconnect);
            socket.disconnect();
        };
    }, [
        socket
    ]);
    const value = (0, $lCzvA.useMemo)(()=>({
            socket: socket,
            socketReady: socketReady
        }), [
        socket,
        socketReady
    ]);
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$e4f257f8a9378458$export$86edbdc9a1e29ae8.Provider, {
        value: value,
        children: children
    });
};
var $c5f28fecad6357c0$var$$cd7edee6e81cb6cf$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$cd7edee6e81cb6cf$var$SocketProvider;
const $c5f28fecad6357c0$export$5e02738099599d87 = ()=>{
    const { pathname: pathname } = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    const { routes: routes } = $c5f28fecad6357c0$var$$409efd23ecc21742$export$c50e37a2f0a2b064();
    const findRoute = (0, $lCzvA.useCallback)(/**
     * Find route by path string, only 1 level deep.
     * @param {string} path - path string to search for.
     * @param {import('../../types').Route[]} routesArr - Array of routes to search for the path.
     */ (path, routesArr = routes)=>routesArr.find((route)=>route.path === path), [
        routes
    ]);
    /**
   * Build a UI friendly path string array from the current route.
   */ const buildUIPath = (0, $lCzvA.useCallback)(()=>{
        // Split the path by '/' and remove empty strings
        const pathArr = pathname === '/' ? [
            '/'
        ] : pathname.split('/').filter(Boolean);
        /**
     * @type {import('../../types').HeirarchyRoute[]}
     */ const heirachyArr = [];
        // Build out route path heirachy one path string at a time
        for (const path of pathArr){
            const parentRoute = heirachyArr.at(-1);
            const thisRoute = findRoute(path, parentRoute?.childRoutes);
            if (thisRoute) {
                const fullPath = parentRoute ? `${parentRoute.fullPath}/${thisRoute.path}` : thisRoute.path;
                /**
         * @type {import('../../types').HeirarchyRoute}
         */ const newHeirarchyRoute = {
                    ...thisRoute,
                    fullPath: fullPath,
                    url: thisRoute.element ? fullPath : ''
                };
                heirachyArr.push(newHeirarchyRoute);
            }
        }
        // Clean up the data for the UI
        const pathRoutes = heirachyArr.map(({ url: url, path: path, isPublic: isPublic, roles: roles, title: title, hideLayout: hideLayout, hideSideNav: hideSideNav })=>({
                title: title || path,
                url: url,
                isPublic: isPublic,
                roles: roles,
                hideLayout: hideLayout,
                hideSideNav: hideSideNav
            }));
        /**
     * @type {typeof pathRoutes[number]}
     * If there is no route, return a default route (Home).
     * This can happen if user is utilizing our built in default route (/) which is not defined in the routes array.
     * Would not happen if user provides a custom home route.
     * Tracking this built-in default route is important for analytics purposes.
     * @see src/hooks/useAppAnalytics usage of currentRoute
     */ const currentRoute = pathRoutes.at(-1) || {
            title: 'Home',
            url: '/',
            isPublic: false,
            roles: [],
            hideLayout: false,
            hideSideNav: false
        };
        return {
            pathRoutes: pathRoutes,
            currentRoute: currentRoute,
            pathname: pathname
        };
    }, [
        pathname,
        findRoute
    ]);
    return (0, $lCzvA.useMemo)(()=>buildUIPath(), [
        buildUIPath
    ]);
};
const $c5f28fecad6357c0$var$$dfca0f8c30d896fb$export$9a2c3bcaa912c766 = {
    TEAM_MEMBER_IMG: 'teamMemberImage',
    TEAM_MEMBER_APPLICATION_ROLES: 'teamMemberApplicationRoles',
    TEAM_MEMBER_APP_PREFERENCES: 'teamMemberAppPreferences'
};
const $c5f28fecad6357c0$var$$dfca0f8c30d896fb$export$12ba4a87a63f35f7 = {
    PAGE_VIEW: {
        eventType: 'page_view',
        eventDescription: 'User visited a page'
    },
    EXTERNAL_LINK_CLICK: {
        eventType: 'external_link_click',
        eventDescription: 'User clicked an external link'
    }
};
/**
 * @type {import('@okta/okta-auth-js').CustomUserClaims}
 */ const $c5f28fecad6357c0$var$$23e41bc6114e351b$var$emptyClaimsUser = {
    department: '',
    email: '',
    // eslint-disable-next-line camelcase
    location_code: '',
    manager: '',
    // eslint-disable-next-line camelcase
    manager_id: '',
    name: 'User, Unknown',
    userid: '',
    title: ''
};
/**
 * @type {string[]}
 */ const $c5f28fecad6357c0$var$$23e41bc6114e351b$var$defaultRoles = [];
const $c5f28fecad6357c0$export$23bbbc4533528f03 = ()=>{
    const { authState: authState } = (0, $954b04773eb0508c$export$2ae4a19e09ca9a00)();
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { department: department, email: email, location_code: location_code, manager: manager, manager_id: manager_id, name: name, preferred_first_name: preferred_first_name, userid: userid, title: title } = authState?.idToken?.claims || $c5f28fecad6357c0$var$$23e41bc6114e351b$var$emptyClaimsUser;
    const queriesEnabled = Boolean(apiReady && userid);
    const { data: picture } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            $c5f28fecad6357c0$var$$dfca0f8c30d896fb$export$9a2c3bcaa912c766.TEAM_MEMBER_IMG,
            userid
        ],
        queryFn: ()=>api.teamMember.getTeamMemberImage(String(userid)),
        enabled: queriesEnabled,
        staleTime: Number.POSITIVE_INFINITY
    });
    const { data: roles = $c5f28fecad6357c0$var$$23e41bc6114e351b$var$defaultRoles, isLoading: rolesLoading } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            $c5f28fecad6357c0$var$$dfca0f8c30d896fb$export$9a2c3bcaa912c766.TEAM_MEMBER_APPLICATION_ROLES,
            userid
        ],
        queryFn: ()=>api.applUser.getTeamMemberApplicationRoles(String(userid)),
        enabled: queriesEnabled,
        staleTime: Number.POSITIVE_INFINITY
    });
    const { data: appPreferences } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            $c5f28fecad6357c0$var$$dfca0f8c30d896fb$export$9a2c3bcaa912c766.TEAM_MEMBER_APP_PREFERENCES,
            userid
        ],
        queryFn: ()=>api.applUser.getTeamMemberAppPreferences(String(userid)),
        enabled: queriesEnabled,
        staleTime: 300000
    });
    return {
        picture: picture,
        department: String(department),
        email: String(email),
        locationCode: String(location_code),
        manager: String(manager),
        managerId: String(manager_id),
        name: String(name),
        preferredFirstName: String(preferred_first_name),
        userid: String(userid),
        title: String(title),
        roles: roles,
        rolesLoading: rolesLoading,
        authStateLoaded: Boolean(authState),
        isAuthenticated: Boolean(authState?.isAuthenticated),
        appPreferences: appPreferences
    };
};
const $c5f28fecad6357c0$export$a73557fc91ecfe2 = ()=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { userid: userid, locationCode: locationCode } = $c5f28fecad6357c0$export$23bbbc4533528f03();
    const { currentRoute: currentRoute } = $c5f28fecad6357c0$export$5e02738099599d87();
    /**
   * Mutation function to add an application analytic record.
   */ return (0, $957614eff0380312$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call the addEvent api.
     * @param {{eventType: string, eventDescription: string}} params
     */ mutationFn: ({ eventType: eventType, eventDescription: eventDescription })=>{
            const currentRouteIsPublic = currentRoute?.isPublic;
            // Build the platform string from device information
            const formFactor = (0, $ec4affac0c13709c$exports.isMobile) ? 'MOBILE' : 'DESKTOP';
            const platform = `[ ${formFactor} ][ ${(0, $ec4affac0c13709c$exports.osName).toUpperCase()} ][ ${(0, $ec4affac0c13709c$exports.browserName).toUpperCase()} ]`;
            const params = {
                applicationPage: currentRoute?.title || 'UNKNOWN',
                eventType: eventType,
                eventDescription: eventDescription,
                plant: locationCode,
                userName: userid || (currentRouteIsPublic ? 'NOT AUTHENTICATED' : 'UNKNOWN'),
                platform: platform
            };
            return api.appAnalytics.addEvent(params);
        },
        onError: (error)=>{
            // eslint-disable-next-line no-console
            console.error('error in Add AppAnalytics', error);
        }
    });
};
const $c5f28fecad6357c0$export$cb4e378d7d3467ee = ({ event: event, enabled: enabled = true })=>{
    const { socket: socket, socketReady: socketReady } = $c5f28fecad6357c0$var$$e4f257f8a9378458$export$48f6bde144501da0();
    const [data, setData] = (0, $lCzvA.useState)(/** @type {Record<string, unknown> | undefined} */ undefined);
    const handleEvent = (0, $lCzvA.useCallback)(/**
     * Handles the socket event and updates the data state.
     * @param {Record<string, unknown>} value - The data received from the socket event.
     */ (value)=>{
        setData(value);
    }, []);
    (0, $lCzvA.useEffect)(()=>{
        if (!socket || !socketReady || !event || !enabled) return undefined;
        socket.on(event, handleEvent);
        return ()=>{
            socket.off(event, handleEvent);
        };
    }, [
        socket,
        socketReady,
        event,
        enabled,
        handleEvent
    ]);
    return {
        data: data,
        setData: setData
    };
};
/**
 * Recursively flattens children routes into a single array.
 * @param {import('../../types').Route} route
 * @param {string} [parentPath=''] The parent path to prepend to the route path.
 * @returns {import('../../types').Route[]}
 */ const $c5f28fecad6357c0$var$$ece692ff97c10051$var$flattenChildren = (route, parentPath = '')=>{
    const fullPath = `${parentPath}/${route.path}`;
    // If the route has no children, it is a leaf node. It should be included in the array.
    if (!route.childRoutes) return [
        {
            ...route,
            path: fullPath
        }
    ];
    // If the route has an element, it is a branch node. It should be included in the array along with its children.
    if (route.element) return [
        {
            ...route,
            path: fullPath
        },
        ...route.childRoutes.flatMap((child)=>$c5f28fecad6357c0$var$$ece692ff97c10051$var$flattenChildren(child, fullPath))
    ];
    // If the route has no element, it is a branch node. It should be excluded from the array, but its children should be included.
    return route.childRoutes.flatMap((child)=>$c5f28fecad6357c0$var$$ece692ff97c10051$var$flattenChildren(child, fullPath));
};
/**
 * The default home page provided by layout.
 */ const $c5f28fecad6357c0$var$$ece692ff97c10051$var$HomePage = ()=>{
    const { routes: routes } = $c5f28fecad6357c0$var$$409efd23ecc21742$export$c50e37a2f0a2b064();
    const { roles: roles, rolesLoading: rolesLoading } = $c5f28fecad6357c0$export$23bbbc4533528f03();
    /**
   * Flattens children routes into a single array.
   * Filters out the routes that should be hidden from the home page.
   */ const homePageRoutes = (0, $lCzvA.useMemo)(()=>{
        /**
     * Filters out the routes that user doesnt have roles to access.
     * @type {import('../../types').Route[]}
     */ // @ts-ignore
        const _filteredRoutes = routes.map((route)=>$c5f28fecad6357c0$var$$f99f0c98fc1c38a1$export$7d7d743cf9c223f7(route, roles)).filter(Boolean);
        const flattenedRoutes = _filteredRoutes.flatMap((route)=>$c5f28fecad6357c0$var$$ece692ff97c10051$var$flattenChildren(route)).filter(Boolean);
        return flattenedRoutes.filter((route)=>route.element && !route.hidden);
    }, [
        routes,
        roles
    ]);
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $c5f28fecad6357c0$var$$4b2dcca34f8ac8c9$export$34e0f9847d4c02dd,
                children: homePageRoutes.map((route)=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$76f1b322c75ded20$export$2e2bcd8739ae039, {
                        ...route
                    }, route.title))
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $c5f28fecad6357c0$var$$4b2dcca34f8ac8c9$export$6e25be3fd94633e2,
                children: !rolesLoading && homePageRoutes.length === 0 && (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                            children: "It appears you may not have a valid role to access this application"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                            children: "Please validate that you have correct access"
                        })
                    ]
                })
            })
        ]
    });
};
var $c5f28fecad6357c0$var$$ece692ff97c10051$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$ece692ff97c10051$var$HomePage;
/**
 * The sidenav provider, allowing children to access the sidenav context via the useSidenavContext hook.
 * @param {import('react').PropsWithChildren} props
 */ const $c5f28fecad6357c0$var$$ef344258ec351cf2$var$SidenavProvider = ({ children: children })=>{
    const { pathname: pathname } = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    const { roles: roles } = $c5f28fecad6357c0$export$23bbbc4533528f03();
    const { routes: routes } = $c5f28fecad6357c0$var$$409efd23ecc21742$export$c50e37a2f0a2b064();
    const [state, setState] = (0, $lCzvA.useState)($c5f28fecad6357c0$var$$6640c5b9dcb6755e$export$347205015dbba8b5);
    const { sidenavOpen: sidenavOpen, activeDropdown: activeDropdown, sidenavRoutes: sidenavRoutes } = state;
    /**
   * Filters out the routes that have {hideInSideNav} set to true.
   * Must map rather than filter because of multi-dimensional nested children arrays.
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax#copying_an_array
   * @type {import('../../../types').Route[]}
   */ // @ts-ignore ts(2322) - Type 'null' is not assignable to type 'Route'.
    // This is a limitation of TypeScript not being able to infer that the
    // filter function will never return null. This can be fixed by using
    // a type guard, but that would require actually using .ts files.
    // Filter out routes that should not be in the sidenav based on hideInSideNav property
    const filteredRoutes = (0, $lCzvA.useMemo)(()=>routes.map((route)=>$c5f28fecad6357c0$var$$f99f0c98fc1c38a1$export$6ec03f543a042a5d(route)).filter(Boolean), [
        routes
    ]);
    (0, $lCzvA.useEffect)(()=>{
        setState((prevState)=>({
                ...prevState,
                sidenavOpen: false
            }));
    }, [
        pathname
    ]);
    (0, $lCzvA.useEffect)(()=>{
        /**
     * @type {import('../../../types').Route[]}
     */ // @ts-ignore ts(2322) - Type 'null' is not assignable to type 'Route'.
        // Same reason as above.
        const filteredByRoles = filteredRoutes.map((route)=>$c5f28fecad6357c0$var$$f99f0c98fc1c38a1$export$7d7d743cf9c223f7(route, roles)).filter(Boolean);
        // Ensure there is a home route in the sidenav
        const hasHomeRoute = filteredByRoles.some((route)=>route.path === '/');
        if (!hasHomeRoute) filteredByRoles.unshift({
            path: '/',
            title: 'Home',
            icon: 'home',
            element: (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$ece692ff97c10051$export$2e2bcd8739ae039, {})
        });
        setState((prevState)=>({
                ...prevState,
                sidenavRoutes: filteredByRoles
            }));
    }, [
        roles,
        routes,
        filteredRoutes
    ]);
    // Memoize the context value to prevent unnecessary re-renders
    const value = (0, $lCzvA.useMemo)(()=>({
            sidenavOpen: sidenavOpen,
            toggleSidenavOpen: ()=>setState((prevState)=>({
                        ...prevState,
                        sidenavOpen: !prevState.sidenavOpen
                    })),
            activeDropdown: activeDropdown,
            /**
       * Sets the active dropdown to the given path.
       * @param {string | undefined} path
       */ setActiveDropdown: (path)=>setState((prevState)=>({
                        ...prevState,
                        activeDropdown: path
                    })),
            sidenavRoutes: sidenavRoutes
        }), [
        sidenavOpen,
        activeDropdown,
        sidenavRoutes
    ]);
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$6640c5b9dcb6755e$export$88c6527e391e3444.Provider, {
        value: value,
        children: children
    });
};
var $c5f28fecad6357c0$var$$ef344258ec351cf2$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$ef344258ec351cf2$var$SidenavProvider;
var $c5f28fecad6357c0$var$$d90bb3fef97547c7$export$34e0f9847d4c02dd;
var $c5f28fecad6357c0$var$$d90bb3fef97547c7$export$acf4eaf431084f78;
var $c5f28fecad6357c0$var$$d90bb3fef97547c7$export$6f093cfa640b7166;
$c5f28fecad6357c0$var$$d90bb3fef97547c7$export$34e0f9847d4c02dd = `dj3CMW_container`;
$c5f28fecad6357c0$var$$d90bb3fef97547c7$export$acf4eaf431084f78 = `dj3CMW_iconContainer`;
$c5f28fecad6357c0$var$$d90bb3fef97547c7$export$6f093cfa640b7166 = `dj3CMW_text`;
/**
 * @typedef {object} TextIconProps
 * @property {string} [iconName] - MUI icon ligature name
 * @property {number} [iconSize=16] - Default 16. px size for icon.
 * @property {React.ReactNode} children - child nodes to wrap
 */ /**
 * A row-wrapper container that positions an icon to the left, with children to the right.
 * @param {TextIconProps} props
 */ const $c5f28fecad6357c0$var$$5766928fa569f3b4$var$TextIcon = ({ iconName: iconName, iconSize: iconSize = 16, children: children, ...rest })=>(0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $c5f28fecad6357c0$var$$d90bb3fef97547c7$export$34e0f9847d4c02dd,
        ...rest,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $c5f28fecad6357c0$var$$d90bb3fef97547c7$export$acf4eaf431084f78,
                children: iconName && (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                    name: iconName,
                    size: iconSize
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                className: $c5f28fecad6357c0$var$$d90bb3fef97547c7$export$6f093cfa640b7166,
                children: children
            })
        ]
    });
var $c5f28fecad6357c0$var$$5766928fa569f3b4$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$5766928fa569f3b4$var$TextIcon;
var $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$2ba01fb71ed41cb6;
var $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$5d76df0e81c36183;
var $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$34e0f9847d4c02dd;
var $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$e8c9778bf415dd08;
var $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$81207e5cc4186890;
var $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$b7f029de53087ca2;
var $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$c1c6080c1441a104;
var $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$a47f41fecbf7bfcc;
$c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$2ba01fb71ed41cb6 = `_28rRGW_button`;
$c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$5d76df0e81c36183 = `_28rRGW_childrenContainer`;
$c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$34e0f9847d4c02dd = `_28rRGW_container`;
$c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$e8c9778bf415dd08 = `_28rRGW_divider`;
$c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$81207e5cc4186890 = `_28rRGW_dropdown`;
$c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$b7f029de53087ca2 = `_28rRGW_dropdownIcon`;
$c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$c1c6080c1441a104 = `_28rRGW_dropdownIconOpen`;
$c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$a47f41fecbf7bfcc = `_28rRGW_dropdownOpen`;
/**
 * @typedef {object} DropdownProps - Props for Dropdown component
 * @property {string} text - Text to display
 * @property {string} [iconName='team_dashboard'] - Default: 'team_dashboard'. Icon name
 * @property {string} routePath - Full path of the route
 */ /**
 * Dropdown component that wraps hidden content.
 * Hidden content is displayed when dropdown is clicked.
 * Supports an icon and text.
 * @param {import('react').PropsWithChildren<DropdownProps>} props
 */ const $c5f28fecad6357c0$var$$7b3b09841a4391a7$var$SidenavDropdown = ({ text: text, iconName: iconName = 'team_dashboard', routePath: routePath, children: children })=>{
    const { activeDropdown: activeDropdown, setActiveDropdown: setActiveDropdown } = $c5f28fecad6357c0$var$$6640c5b9dcb6755e$export$7609013132585565();
    const open = activeDropdown === routePath;
    /**
   * When a dropdown is clicked, set path as active dropdown in context.
   * If the dropdown is already active, clear it.
   */ const onClick = ()=>{
        const newVal = open ? undefined : routePath;
        setActiveDropdown(newVal);
    };
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$34e0f9847d4c02dd,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("button", {
                className: $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$2ba01fb71ed41cb6,
                type: "button",
                onClick: onClick,
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$5766928fa569f3b4$export$2e2bcd8739ae039, {
                        iconName: iconName,
                        children: text
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                        name: "expand_more",
                        size: 21,
                        className: open ? $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$c1c6080c1441a104 : $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$b7f029de53087ca2
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                "data-testid": open ? 'dropdownOpen' : 'dropdownClosed',
                className: `${$c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$81207e5cc4186890} ${open ? $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$a47f41fecbf7bfcc : ''}`,
                children: [
                    children,
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $c5f28fecad6357c0$var$$cf3d46b03d8aa881$export$e8c9778bf415dd08
                    })
                ]
            })
        ]
    });
};
var $c5f28fecad6357c0$var$$7b3b09841a4391a7$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$7b3b09841a4391a7$var$SidenavDropdown;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$22fde7aa351e938b;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$4e0c71f277ca26b3;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$34e0f9847d4c02dd;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$7d47ec3dc429821;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$6e48116756bfbfc3;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$38d41b86f3739d51;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$9c30223ca0a664fb;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$ef604ebebea21dcf;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$85a4852851e7ae5c;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$713432bc5438cae7;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$c4ad544f827d0ad8;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$5fa476d9806ed52d;
var $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$1f72232f9dfffa53;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$22fde7aa351e938b = `_AkADq_activeLink`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$4e0c71f277ca26b3 = `_AkADq_column`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$34e0f9847d4c02dd = `_AkADq_container`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$7d47ec3dc429821 = `_AkADq_containerOpen`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$6e48116756bfbfc3 = `_AkADq_grandchildContainer`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$38d41b86f3739d51 = `_AkADq_grandchildText`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$9c30223ca0a664fb = `_AkADq_link`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$ef604ebebea21dcf = `_AkADq_logoSection`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$85a4852851e7ae5c = `_AkADq_routesSection`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$713432bc5438cae7 = `_AkADq_sidenavBackdrop`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$c4ad544f827d0ad8 = `_AkADq_sidenavBackdropOpen`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$5fa476d9806ed52d = `_AkADq_sidenavContainer`;
$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$1f72232f9dfffa53 = `_AkADq_sidenavOpen`;
/**
 * Build the route tree recursively.
 * @param {import('../../../types').ExtendedRouteType} props
 */ const $c5f28fecad6357c0$var$$ab980e0d5e37a2aa$var$RouteNodes = ({ element: element, link: link, childRoutes: childRoutes, path: path, title: title, icon: icon, parentPath: parentPath = '' })=>{
    const { mutate: addAppAnalyticsEvent } = $c5f28fecad6357c0$export$a73557fc91ecfe2();
    /**
   * Unique compounded path for each route
   */ const to = `${parentPath}${path}`;
    // If the route has a title, use it. Otherwise, use the path.
    const text = title || path;
    /**
   * If the route has children, it is a parent node.
   */ if (childRoutes) return (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        "data-testid": "parentNode",
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$7b3b09841a4391a7$export$2e2bcd8739ae039, {
            text: text,
            iconName: icon,
            routePath: path,
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                "data-testid": "collapse",
                className: $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$4e0c71f277ca26b3,
                children: childRoutes.map((child)=>{
                    const grandchildren = child.childRoutes;
                    /**
               * If the child has grandchildren, render them instead using child as section header.
               */ if (grandchildren) return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$6e48116756bfbfc3,
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                className: $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$38d41b86f3739d51,
                                children: child.title
                            }),
                            grandchildren.map((grandchild)=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$ab980e0d5e37a2aa$var$RouteNodes, {
                                    ...grandchild,
                                    parentPath: `${to}/${child.path}/`
                                }, to + grandchild.path))
                        ]
                    }, to + child.path);
                    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$ab980e0d5e37a2aa$var$RouteNodes, {
                        ...child,
                        parentPath: `${to}/`
                    }, to + child.path);
                })
            })
        })
    });
    /**
   * If the route has an element and no children, it is a leaf node.
   */ if (element) return (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        "data-testid": "childNode",
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c3aca08c2a74646e$export$b0d92dbee9b5b60d), {
            to: to,
            className: ({ isActive: isActive })=>`${$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$9c30223ca0a664fb} ${isActive ? $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$22fde7aa351e938b : ''}`,
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$5766928fa569f3b4$export$2e2bcd8739ae039, {
                iconName: icon,
                iconSize: 18,
                children: text
            })
        })
    });
    /**
   * If the route has a link, it is an external link
   */ if (link) {
        /**
     * Log external link clicks from the sidenav to app analytics.
     * @param {React.MouseEvent<HTMLAnchorElement>} event
     */ const onClick = ({ currentTarget: { href: href } })=>{
            addAppAnalyticsEvent({
                ...$c5f28fecad6357c0$var$$dfca0f8c30d896fb$export$12ba4a87a63f35f7.EXTERNAL_LINK_CLICK,
                eventDescription: href
            });
        };
        return (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
            "data-testid": "childNode",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("a", {
                href: link,
                target: "_blank",
                rel: "noreferrer",
                onClick: onClick,
                className: $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$9c30223ca0a664fb,
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$5766928fa569f3b4$export$2e2bcd8739ae039, {
                    iconName: icon,
                    iconSize: 18,
                    children: text
                })
            })
        });
    }
    /**
   * If the route has no element and no children, it is an invalid route.
   */ return null;
};
var $c5f28fecad6357c0$var$$ab980e0d5e37a2aa$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$ab980e0d5e37a2aa$var$RouteNodes;
const $c5f28fecad6357c0$var$$03d53e29217eff93$var$SvgPellaLogoBlack = (props)=>(0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 69,
        height: 40,
        fill: "none",
        ...props,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                fill: "url(#pella_logo_black_svg__a)",
                d: "M0 0h69v40H0z"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("defs", {
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("pattern", {
                        id: "pella_logo_black_svg__a",
                        width: 1,
                        height: 1,
                        patternContentUnits: "objectBoundingBox",
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("use", {
                            xlinkHref: "#pella_logo_black_svg__b",
                            transform: "matrix(.00296 0 0 .0051 -.003 0)"
                        })
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("image", {
                        xlinkHref: "data:image/png;base64,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",
                        id: "pella_logo_black_svg__b",
                        width: 340,
                        height: 196
                    })
                ]
            })
        ]
    });
var $c5f28fecad6357c0$var$$03d53e29217eff93$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$03d53e29217eff93$var$SvgPellaLogoBlack;
/**
 * The sidenav containing avatar, routes, and sign in/out.
 */ const $c5f28fecad6357c0$var$$0a05b7f3cb4b1a25$var$Sidenav = ()=>{
    const { sidenavOpen: sidenavOpen, toggleSidenavOpen: toggleSidenavOpen, sidenavRoutes: sidenavRoutes } = $c5f28fecad6357c0$var$$6640c5b9dcb6755e$export$7609013132585565();
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: `${$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$34e0f9847d4c02dd} ${sidenavOpen ? $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$7d47ec3dc429821 : ''}`,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                "data-testid": sidenavOpen ? 'sidenavOpen' : 'sidenavClosed',
                className: `${$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$5fa476d9806ed52d} ${sidenavOpen ? $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$1f72232f9dfffa53 : ''}`,
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$ef604ebebea21dcf,
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$03d53e29217eff93$export$2e2bcd8739ae039, {}),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                                type: "button",
                                onClick: toggleSidenavOpen,
                                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                    name: "close",
                                    size: 30
                                })
                            })
                        ]
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$85a4852851e7ae5c,
                        children: sidenavRoutes.map((route)=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$ab980e0d5e37a2aa$export$2e2bcd8739ae039, {
                                ...route
                            }, route.title))
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                "data-testid": "sidenavOverlay",
                className: `${$c5f28fecad6357c0$var$$c7d4c4af360ee256$export$713432bc5438cae7} ${sidenavOpen ? $c5f28fecad6357c0$var$$c7d4c4af360ee256$export$c4ad544f827d0ad8 : ''}`,
                onClick: toggleSidenavOpen,
                onKeyDown: toggleSidenavOpen,
                role: "button",
                tabIndex: 0
            })
        ]
    });
};
var $c5f28fecad6357c0$var$$0a05b7f3cb4b1a25$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$0a05b7f3cb4b1a25$var$Sidenav;
var $c5f28fecad6357c0$var$$70d7cb19ce747502$export$34e0f9847d4c02dd;
var $c5f28fecad6357c0$var$$70d7cb19ce747502$export$a8ecead220dd38a6;
var $c5f28fecad6357c0$var$$70d7cb19ce747502$export$4cb887bfde2d34ca;
$c5f28fecad6357c0$var$$70d7cb19ce747502$export$34e0f9847d4c02dd = `hv0fSq_container`;
$c5f28fecad6357c0$var$$70d7cb19ce747502$export$a8ecead220dd38a6 = `hv0fSq_message`;
$c5f28fecad6357c0$var$$70d7cb19ce747502$export$4cb887bfde2d34ca = `hv0fSq_route`;
const $c5f28fecad6357c0$var$$e91c3dd47e04db32$var$defaultAuthError = {
    routeName: 'this page',
    message: "But it's all good"
};
/**
 * @typedef {object} Props
 * @property {object} [authError]
 * @property {string} [authError.routeName] Default: `this page`. The name of the route that the user is locked out of.
 * @property {string} [authError.message] Default: `But it's all good`. The message to display to the user.
 */ /**
 * Roles Error page that will be displayed anytime a routes roles does not include users roles.
 * @param {Props} props
 */ const $c5f28fecad6357c0$var$$e91c3dd47e04db32$var$RolesErrorPage = ({ authError: authError = $c5f28fecad6357c0$var$$e91c3dd47e04db32$var$defaultAuthError })=>{
    const navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    const goBack = ()=>navigate(-1);
    const goHome = ()=>navigate('/');
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $c5f28fecad6357c0$var$$70d7cb19ce747502$export$34e0f9847d4c02dd,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("p", {
                className: $c5f28fecad6357c0$var$$70d7cb19ce747502$export$4cb887bfde2d34ca,
                children: [
                    "It appears you do not have access to ",
                    authError.routeName,
                    " "
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                className: $c5f28fecad6357c0$var$$70d7cb19ce747502$export$a8ecead220dd38a6,
                children: authError.message
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        onClick: goBack,
                        children: "Go Back"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        onClick: goHome,
                        children: "Go to Home Page"
                    })
                ]
            })
        ]
    });
};
var $c5f28fecad6357c0$var$$e91c3dd47e04db32$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$e91c3dd47e04db32$var$RolesErrorPage;
var $c5f28fecad6357c0$var$$421e9be82a267e2e$export$34e0f9847d4c02dd;
$c5f28fecad6357c0$var$$421e9be82a267e2e$export$34e0f9847d4c02dd = `iO5Dca_container`;
/**
 * Error boundary page that will be displayed anytime a route is not found.
 * Determines if the route is locked out by roles and displays the RolesErrorPage if so.
 * Otherwise displays a 404 page.
 */ const $c5f28fecad6357c0$var$$530b1499e78d2b69$var$ErrorBoundaryPage = ()=>{
    const { pathRoutes: pathRoutes } = $c5f28fecad6357c0$export$5e02738099599d87();
    /**
   * Check if the current route is locked out by roles.
   */ const thisRoute = pathRoutes.at(-1);
    /**
   * If the route is locked out, display the RolesErrorPage.
   */ if (thisRoute) {
        const { roles: roles, title: title } = thisRoute;
        return (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$e91c3dd47e04db32$export$2e2bcd8739ae039, {
            authError: {
                routeName: title,
                message: `Role missing: ${roles?.join(', ')}`
            }
        });
    }
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $c5f28fecad6357c0$var$$421e9be82a267e2e$export$34e0f9847d4c02dd,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                children: "404 - Not found"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                children: "Couldn't find what you were looking for..."
            })
        ]
    });
};
var $c5f28fecad6357c0$var$$530b1499e78d2b69$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$530b1499e78d2b69$var$ErrorBoundaryPage;
/**
 * A redirect page after a user is successfully signed out of Okta.
 * Perform custom post-logout logic here. Redirects to home page afterwards.
 */ const $c5f28fecad6357c0$var$$0daa93c28671c388$var$LogoutPage = ()=>{
    const navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    (0, $lCzvA.useEffect)(()=>{
        navigate('/');
    }, [
        navigate
    ]);
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$export$669f6ea7d267feaf, {
        show: true
    });
};
var $c5f28fecad6357c0$var$$0daa93c28671c388$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$0daa93c28671c388$var$LogoutPage;
/**
 * Boilerplate authentication check component for React Router v6.
 * @see https://github.com/okta/okta-react/blob/master/samples/routing/react-router-dom-v6/src/components/SecureRoute.tsx
 */ const $c5f28fecad6357c0$var$$87080d36b441c745$var$RequiredAuth = ()=>{
    const { oktaAuth: oktaAuth, authState: authState } = (0, $954b04773eb0508c$export$2ae4a19e09ca9a00)();
    (0, $lCzvA.useEffect)(()=>{
        if (authState?.isAuthenticated === false) {
            const originalUri = (0, $dbbfea4bd9ff1bad$exports.toRelativeUrl)(window.location.href, window.location.origin);
            oktaAuth.setOriginalUri(originalUri);
            oktaAuth.signInWithRedirect();
        }
    }, [
        oktaAuth,
        authState?.isAuthenticated
    ]);
    /**
   * While authenticating, display a loading component.
   */ if (!authState || !authState?.isAuthenticated) return (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$export$669f6ea7d267feaf, {
        show: true
    });
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$910ae8079b2c2852), {});
};
var $c5f28fecad6357c0$var$$87080d36b441c745$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$87080d36b441c745$var$RequiredAuth;
/**
 * Recursively render routes and their children.
 * Applies the RequiredAuth component to routes that are secure.
 * @param {import('../types').Route} route
 * @param {string} key unique key for the route, full path
 */ const $c5f28fecad6357c0$var$$f2201d086a703f7f$var$renderRoutesRecursive = (route, key)=>{
    const Wrapper = route.isPublic ? (0, $ebc812b73151cba1$export$910ae8079b2c2852) : $c5f28fecad6357c0$var$$87080d36b441c745$export$2e2bcd8739ae039;
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
        path: route.path,
        element: (0, $1e1ba35c5b9fc4c3$exports.jsx)(Wrapper, {}),
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                ...route,
                path: ""
            }),
            route.childRoutes?.map((child)=>{
                const combinedKey = `${key}/${child.path}`;
                return $c5f28fecad6357c0$var$$f2201d086a703f7f$var$renderRoutesRecursive(child, combinedKey);
            })
        ]
    }, key);
};
/**
 * Recursively renders list of routes for the app.
 * Also handles static routes that are not accessible from the sidenav.
 * @param {object} props
 * @param {string} [props.invalidRedirect] The path to redirect to if the route is invalid.
 */ const $c5f28fecad6357c0$var$$f2201d086a703f7f$var$AppRoutes = ({ invalidRedirect: invalidRedirect })=>{
    const { roles: roles } = $c5f28fecad6357c0$export$23bbbc4533528f03();
    const { routes: routes } = $c5f28fecad6357c0$var$$409efd23ecc21742$export$c50e37a2f0a2b064();
    const appRoutes = (0, $lCzvA.useMemo)(()=>{
        /**
     * Filters out the routes that user doesnt have roles to access.
     * @type {import('../types').Route[]}
     */ // @ts-ignore
        const _filteredRoutes = routes.map((route)=>$c5f28fecad6357c0$var$$f99f0c98fc1c38a1$export$7d7d743cf9c223f7(route, roles)).filter(Boolean);
        return _filteredRoutes.map((route)=>$c5f28fecad6357c0$var$$f2201d086a703f7f$var$renderRoutesRecursive(route, route.path));
    }, [
        roles,
        routes
    ]);
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $ebc812b73151cba1$export$3565eb3d00ca5a74), {
        children: [
            appRoutes,
            (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                path: "/",
                element: (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$87080d36b441c745$export$2e2bcd8739ae039, {}),
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                    path: "",
                    element: (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$ece692ff97c10051$export$2e2bcd8739ae039, {})
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                path: "login/callback",
                element: (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $954b04773eb0508c$export$8f938467209eea73), {
                    loadingElement: (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$export$669f6ea7d267feaf, {})
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                path: "logout",
                element: (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$0daa93c28671c388$export$2e2bcd8739ae039, {})
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                path: "*",
                element: invalidRedirect ? (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$444b3ab0cb9aec40), {
                    to: invalidRedirect,
                    replace: true
                }) : (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$530b1499e78d2b69$export$2e2bcd8739ae039, {})
            })
        ]
    });
};
var $c5f28fecad6357c0$var$$f2201d086a703f7f$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$f2201d086a703f7f$var$AppRoutes;
var $c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$2ba01fb71ed41cb6;
var $c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$b754701a9d58f57b;
var $c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$80e4b313e5e6b30d;
var $c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$fb184b623420d9be;
$c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$2ba01fb71ed41cb6 = `_4HuoIq_button`;
$c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$b754701a9d58f57b = `_4HuoIq_gappedRow`;
$c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$80e4b313e5e6b30d = `_4HuoIq_nav`;
$c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$fb184b623420d9be = `_4HuoIq_title`;
var $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$b45efa1d9adeecb0;
var $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$345c5736c8054f22;
var $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$2ba01fb71ed41cb6;
var $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$e8c9778bf415dd08;
var $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$82a129a7016c8ea8;
var $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$7061c75fc5af8b7e;
var $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$5e1be761f603d585;
$c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$b45efa1d9adeecb0 = `XOWa2q_accountDropdown`;
$c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$345c5736c8054f22 = `XOWa2q_avatar`;
$c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$2ba01fb71ed41cb6 = `XOWa2q_button`;
$c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$e8c9778bf415dd08 = `XOWa2q_divider`;
$c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$82a129a7016c8ea8 = `XOWa2q_initials`;
$c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$7061c75fc5af8b7e = `XOWa2q_item`;
$c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$5e1be761f603d585 = `XOWa2q_username`;
/**
 * AvatarInitials component to display user initials.
 * @param {object} props - Component props.
 * @param {boolean} [props.showUsername] - Boolean to show the username instead of initials.
 * @returns {JSX.Element} The AvatarInitials component.
 */ const $c5f28fecad6357c0$var$$0223f06f862caa53$var$AvatarInitials = ({ showUsername: showUsername })=>{
    const { authState: authState } = (0, $954b04773eb0508c$export$2ae4a19e09ca9a00)();
    const [lastName, firstName] = authState?.idToken?.claims?.name?.split(', ') || [
        'User',
        'Unknown'
    ];
    const username = authState?.idToken?.claims?.preferred_username?.split('@')?.[0] || 'Unknown';
    if (showUsername) return (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$5e1be761f603d585,
        "data-testid": "avatar-username",
        children: username?.toUpperCase()
    });
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: `${$c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$345c5736c8054f22} ${$c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$82a129a7016c8ea8}`,
        "data-testid": "avatar-initials",
        children: [
            firstName?.charAt(0),
            lastName?.charAt(0)
        ]
    });
};
var $c5f28fecad6357c0$var$$0223f06f862caa53$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$0223f06f862caa53$var$AvatarInitials;
/**
 * @typedef {object} AvatarCircleProps
 * @property {import('../../../types').AvatarOption[]} [avatarOptions] Additional avatar dropdown options.
 * @property {boolean} [showUsername] If true, shows the username in the avatar.
 */ /**
 * Avatar circle with Dropdown content.
 * @param {AvatarCircleProps & Pick<import('../../../types').User, "picture">} props
 */ const $c5f28fecad6357c0$var$$46a061444e7a57ae$var$AvatarCircle = ({ avatarOptions: avatarOptions = [], showUsername: showUsername })=>{
    const { authText: authText, authIcon: authIcon, authFunction: authFunction, isAuthenticated: isAuthenticated } = $c5f28fecad6357c0$var$$8682e44449a848fc$export$58448433d512296d();
    const { picture: picture } = $c5f28fecad6357c0$export$23bbbc4533528f03();
    const dropdownItems = [
        ...avatarOptions,
        {
            text: 'Report Issue',
            icon: 'report',
            href: 'https://pellaprod.service-now.com/sp?id=sc_inc_manufacturing',
            isLink: true
        },
        {
            text: 'Suggest Enhancement',
            icon: 'lightbulb',
            href: 'https://pellaprod.service-now.com/sp?id=sc_cat_item&sys_id=053d45b1873ef550cbfda8e73cbb3545&sysparm_category=053d45b1873ef550cbfda8e73cbb3545',
            isLink: true
        },
        {
            text: authText,
            icon: authIcon,
            onClick: authFunction
        }
    ];
    /**
   * Determines which avatar to render based on the user's authentication status and profile picture.
   */ const renderAvatar = (0, $lCzvA.useCallback)(()=>{
        if (picture && !showUsername) return (0, $1e1ba35c5b9fc4c3$exports.jsx)("img", {
            src: picture,
            alt: "user-profile",
            className: $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$345c5736c8054f22
        });
        if (isAuthenticated) return (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$0223f06f862caa53$export$2e2bcd8739ae039, {
            showUsername: showUsername
        });
        return (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
            name: "account_circle",
            size: 38,
            className: $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$2ba01fb71ed41cb6
        });
    }, [
        isAuthenticated,
        picture,
        showUsername
    ]);
    const avatar = (0, $lCzvA.useMemo)(()=>renderAvatar(), [
        renderAvatar
    ]);
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4894604720ca08c8$export$2e2bcd8739ae039), {
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $159cb66f654a3a1c$export$2e2bcd8739ae039), {
                children: avatar
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $833f5a446a1fbfcc$export$2e2bcd8739ae039), {
                className: $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$b45efa1d9adeecb0,
                children: dropdownItems.map(({ text: text, icon: icon, onClick: onClick, isLink: isLink, href: href }, index)=>{
                    const lastChild = index === dropdownItems.length - 1;
                    const Element = isLink ? 'a' : 'button';
                    const elementProps = isLink ? {
                        href: href,
                        target: '_blank',
                        rel: 'noreferrer'
                    } : {
                        onClick: onClick
                    };
                    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $lCzvA.Fragment), {
                        children: [
                            lastChild && (0, $1e1ba35c5b9fc4c3$exports.jsx)("hr", {
                                className: $c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$e8c9778bf415dd08
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e007c3baa5a03cf7$export$2e2bcd8739ae039), {
                                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)(Element, {
                                    className: `${$c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$2ba01fb71ed41cb6} ${$c5f28fecad6357c0$var$$0bcb88fcd00abc9c$export$7061c75fc5af8b7e}`,
                                    type: "button",
                                    ...elementProps,
                                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$5766928fa569f3b4$export$2e2bcd8739ae039, {
                                        iconName: icon,
                                        iconSize: 20,
                                        children: text
                                    })
                                })
                            })
                        ]
                    }, text + icon);
                })
            })
        ]
    });
};
var $c5f28fecad6357c0$var$$46a061444e7a57ae$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$46a061444e7a57ae$var$AvatarCircle;
/**
 * @typedef {object} NavbarProps
 * @property {string} appName The name of the application.
 * @property {import('../../types').AvatarOption[]} [avatarOptions] Additional avatar dropdown options.
 * @property {boolean} [hideSideNav] If true, hides the side navigation Icon.
 * @property {boolean} [showUsername] If true, shows the username in the avatar.
 */ /**
 * Navbar component.
 * @param {NavbarProps} props
 */ const $c5f28fecad6357c0$var$$11740ebce2951373$var$Navbar = ({ appName: appName, avatarOptions: avatarOptions, hideSideNav: hideSideNav, showUsername: showUsername })=>{
    const { toggleSidenavOpen: toggleSidenavOpen } = $c5f28fecad6357c0$var$$6640c5b9dcb6755e$export$7609013132585565();
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("nav", {
        className: $c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$80e4b313e5e6b30d,
        "data-testid": "navbar",
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$b754701a9d58f57b,
                children: [
                    !hideSideNav && (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                        className: $c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$2ba01fb71ed41cb6,
                        type: "button",
                        onClick: toggleSidenavOpen,
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                            name: "menu",
                            size: 38
                        })
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                        className: $c5f28fecad6357c0$var$$0da26ab6a6a42fce$export$fb184b623420d9be,
                        children: appName
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$46a061444e7a57ae$export$2e2bcd8739ae039, {
                avatarOptions: avatarOptions,
                showUsername: showUsername
            })
        ]
    });
};
var $c5f28fecad6357c0$var$$11740ebce2951373$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$11740ebce2951373$var$Navbar;
var $c5f28fecad6357c0$var$$60fa2842d7e5249d$export$515d2155aaad79e4;
var $c5f28fecad6357c0$var$$60fa2842d7e5249d$export$569f555150919005;
var $c5f28fecad6357c0$var$$60fa2842d7e5249d$export$34e0f9847d4c02dd;
$c5f28fecad6357c0$var$$60fa2842d7e5249d$export$515d2155aaad79e4 = `_5l06ia_breadcrumbs`;
$c5f28fecad6357c0$var$$60fa2842d7e5249d$export$569f555150919005 = `_5l06ia_childContainer`;
$c5f28fecad6357c0$var$$60fa2842d7e5249d$export$34e0f9847d4c02dd = `_5l06ia_container`;
/**
 * @typedef {object} LayoutProps
 * @property {string} appName The name of the application.
 * @property {import('../../types').Route[]} routes The routes for the application.
 * @property {import('../../types').AvatarOption[]} [avatarOptions] Additional avatar dropdown options. Log in/out is handled automatically.
 * @property {boolean} [hideBreadcrumbs] If true, hides the breadcrumbs component.
 * @property {string} [invalidRedirect] The path to use for invalid routes.
 * @property {boolean} [showUsername] If true, shows the username in the avatar.
 * @property {string} [socketNamespace] Optional socket.io namespace. When provided, enables socket connectivity.
 */ /**
 * The default layout structured with top+side nav, breadcrumbs, authentication, and routing.
 * @param {LayoutProps} props
 * @example
 * ```jsx
 *
 * const App = () => {
 *  return (
 *   <BrowserRouter>
 *    <Security>
 *      <QueryClientProvider client={queryClient}>
 *        <APIProvider appName={Constants.AppName} baseURL={window.REACT_APP_API_URL}>
 *          <Layout
 *            appName='Harness'
 *            routes={routes}
 *            avatarOptions={[{ text: 'Something', icon: 'home', onClick: () => console.log('woah') }]}
 *          />;
 *        </APIProvider>
 *     </QueryClientProvider>
 *    </Security>
 *   </BrowserRouter>
 * )
 * };
 *
 * ```
 */ const $c5f28fecad6357c0$var$$53395c7c004e6847$var$Layout = ({ routes: routes, socketNamespace: socketNamespace, ...rest })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$409efd23ecc21742$export$964282a2c3979546.Provider, {
        value: {
            routes: routes
        },
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$cd7edee6e81cb6cf$export$2e2bcd8739ae039, {
            socketNamespace: socketNamespace,
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$53395c7c004e6847$var$WrappedLayout, {
                ...rest
            })
        })
    });
/**
 * Layout internals wrapped in context provider.
 * Setup this way so our hooks used at this layer have access to the layout context.
 * @param {Omit<LayoutProps, 'routes'>} props
 */ const $c5f28fecad6357c0$var$$53395c7c004e6847$var$WrappedLayout = ({ appName: appName, avatarOptions: avatarOptions = [], hideBreadcrumbs: hideBreadcrumbs, invalidRedirect: invalidRedirect, showUsername: showUsername })=>{
    const { pathRoutes: pathRoutes, currentRoute: currentRoute } = $c5f28fecad6357c0$export$5e02738099599d87();
    const { mutate: addAppAnalyticsEvent } = $c5f28fecad6357c0$export$a73557fc91ecfe2();
    (0, $lCzvA.useEffect)(()=>{
        addAppAnalyticsEvent($c5f28fecad6357c0$var$$dfca0f8c30d896fb$export$12ba4a87a63f35f7.PAGE_VIEW);
    }, [
        currentRoute,
        addAppAnalyticsEvent
    ]);
    (0, $lCzvA.useEffect)(()=>{
        const newTitle = currentRoute.url === '/' ? appName : `${appName} | ${currentRoute.title}`;
        document.title = newTitle;
    }, [
        appName,
        currentRoute
    ]);
    // Get all routes except the current route.
    // The breadcrumb component expects current route to provided separately to disable navigation functionality.
    const pages = [
        ...pathRoutes
    ].slice(0, -1);
    // If the current route is not the home page, display the current route title in the breadcrumbs + page title.
    const pageDisplayTitle = currentRoute.title !== 'Home' ? currentRoute.title : undefined;
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $c5f28fecad6357c0$var$$60fa2842d7e5249d$export$34e0f9847d4c02dd,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$ef344258ec351cf2$export$2e2bcd8739ae039, {
                children: !currentRoute?.hideLayout && (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$11740ebce2951373$export$2e2bcd8739ae039, {
                            appName: appName,
                            avatarOptions: avatarOptions,
                            hideSideNav: currentRoute?.hideSideNav,
                            showUsername: showUsername
                        }),
                        !currentRoute?.hideSideNav && (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$0a05b7f3cb4b1a25$export$2e2bcd8739ae039, {})
                    ]
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                id: "scrollable-area",
                className: $c5f28fecad6357c0$var$$60fa2842d7e5249d$export$569f555150919005,
                children: [
                    !hideBreadcrumbs && !currentRoute?.hideLayout && (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e7e807be55d7b93f$export$2e2bcd8739ae039), {
                        renderLinksAs: (0, $c3aca08c2a74646e$export$a6c7ac8248d6e38a),
                        enableTo: true,
                        pages: pages,
                        current: pageDisplayTitle,
                        className: $c5f28fecad6357c0$var$$60fa2842d7e5249d$export$515d2155aaad79e4,
                        "data-testid": "breadcrumbs"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)($c5f28fecad6357c0$var$$f2201d086a703f7f$export$2e2bcd8739ae039, {
                        invalidRedirect: invalidRedirect
                    })
                ]
            })
        ]
    });
};
var $c5f28fecad6357c0$export$c84671f46d6a1ca = (0, $lCzvA.memo)($c5f28fecad6357c0$var$$53395c7c004e6847$var$Layout);
var $c5f28fecad6357c0$var$$b06d3b931e69593a$export$34e0f9847d4c02dd;
$c5f28fecad6357c0$var$$b06d3b931e69593a$export$34e0f9847d4c02dd = `ZMO6Uq_container`;
/**
 * @typedef {object} LoadingProps
 * @property {boolean} [show] Default: false.  Whether or not to show the loading component.
 * @property {string} [text] Default: 'LOADING...' - The text to display beneath the loading animation.
 */ /**
 * Styled loading component with a loading animation and text.
 * @param {LoadingProps} props
 * @example
 * ```jsx
 * <Loading show={someAPILoading} text="Can also override the text, default is 'LOADING...'" />
 * ```
 */ const $c5f28fecad6357c0$var$$acd5d53d8c1e5581$var$Loading = ({ show: show = false, text: text = 'LOADING...' })=>{
    if (!show) return null;
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $c5f28fecad6357c0$var$$b06d3b931e69593a$export$34e0f9847d4c02dd,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $6bfaf8085a30c9b5$export$4bf83b24a11cff0b), {
                height: "75",
                width: "100",
                radius: "9",
                color: "white",
                ariaLabel: "three-dots-loading",
                visible: true
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                children: text
            })
        ]
    });
};
var $c5f28fecad6357c0$export$669f6ea7d267feaf = $c5f28fecad6357c0$var$$acd5d53d8c1e5581$var$Loading;
var $c5f28fecad6357c0$var$$47b6de9f5d7bd429$export$34e0f9847d4c02dd;
var $c5f28fecad6357c0$var$$47b6de9f5d7bd429$export$acf4eaf431084f78;
$c5f28fecad6357c0$var$$47b6de9f5d7bd429$export$34e0f9847d4c02dd = `ST_BDq_container`;
$c5f28fecad6357c0$var$$47b6de9f5d7bd429$export$acf4eaf431084f78 = `ST_BDq_iconContainer`;
/**
 * @typedef {object} NavTileProps
 * @property {string} [icon] Icon ligature
 * @property {string | undefined} [title] Text beneath icon circle
 * @property {string} path Path to navigate to
 */ /**
 * Styled Rectangle component that features an icon, title, and a link to another page.
 * @param {NavTileProps} props
 */ const $c5f28fecad6357c0$var$$76f1b322c75ded20$var$NavTile = ({ icon: icon = 'question_mark', title: title, path: path })=>(0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c3aca08c2a74646e$export$a6c7ac8248d6e38a), {
        to: path,
        className: $c5f28fecad6357c0$var$$47b6de9f5d7bd429$export$34e0f9847d4c02dd,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $c5f28fecad6357c0$var$$47b6de9f5d7bd429$export$acf4eaf431084f78,
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                    name: icon,
                    size: 24
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                children: title
            })
        ]
    });
var $c5f28fecad6357c0$var$$76f1b322c75ded20$export$2e2bcd8739ae039 = $c5f28fecad6357c0$var$$76f1b322c75ded20$var$NavTile;


/**
 * A global loading indicator that shows when any react-query queries are fetching.
 * @returns {import("react").ReactElement | null}
 */ const $88478e1cba2f5c35$var$GlobalLoading = ()=>{
    const isFetching = (0, $fd8439d87c9b5264$export$625b2ff71316bcd3)();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c5f28fecad6357c0$export$669f6ea7d267feaf), {
        show: Boolean(isFetching)
    });
};
var $88478e1cba2f5c35$export$2e2bcd8739ae039 = $88478e1cba2f5c35$var$GlobalLoading;





var $3d368239c49400cd$exports = {};

$parcel$export($3d368239c49400cd$exports, "button", function () { return $3d368239c49400cd$export$2ba01fb71ed41cb6; }, function (v) { return $3d368239c49400cd$export$2ba01fb71ed41cb6 = v; });
$parcel$export($3d368239c49400cd$exports, "selected", function () { return $3d368239c49400cd$export$d90250155de6d7e7; }, function (v) { return $3d368239c49400cd$export$d90250155de6d7e7 = v; });
var $3d368239c49400cd$export$2ba01fb71ed41cb6;
var $3d368239c49400cd$export$d90250155de6d7e7;
$3d368239c49400cd$export$2ba01fb71ed41cb6 = `UAJfCa_button`;
$3d368239c49400cd$export$d90250155de6d7e7 = `UAJfCa_selected`;


/**
 * The toggle-like button component for selecting yes/no answers.
 * @param {object} props - The component props
 * @param {string} props.label - The label of the button such as Yes or No
 * @param {boolean} props.isSelected - Whether the current button is selected
 * @param {() => void} props.onSelectAnswer - Callback when the button is clicked
 * @returns {import("react").ReactElement} Answer button component
 */ const $b385ad19d681861e$var$AnswerButton = ({ label: label, isSelected: isSelected, onSelectAnswer: onSelectAnswer })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
        onClick: onSelectAnswer,
        "data-testid": "answerButton",
        type: "button",
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($3d368239c49400cd$exports))).button} ${isSelected ? (0, (/*@__PURE__*/$parcel$interopDefault($3d368239c49400cd$exports))).selected : ''}`,
        children: label
    });
var $b385ad19d681861e$export$2e2bcd8739ae039 = $b385ad19d681861e$var$AnswerButton;
























var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region node_modules/@radix-ui/react-dialog/dist/index.mjs
var $7c802bd2b31dc149$var$v = "Dialog", [$7c802bd2b31dc149$var$y, $7c802bd2b31dc149$var$b] = (0, $0641488beac2d3c3$export$50c7b4e9d9f19c1)($7c802bd2b31dc149$var$v), [$7c802bd2b31dc149$var$x, $7c802bd2b31dc149$var$S] = $7c802bd2b31dc149$var$y($7c802bd2b31dc149$var$v), $7c802bd2b31dc149$export$3ddf2d174ce01153 = (e)=>{
    let { __scopeDialog: t, children: n, open: a, defaultOpen: o, onOpenChange: s, modal: c = !0 } = e, l = $lCzvA.useRef(null), u = $lCzvA.useRef(null), [d, f] = (0, $0d3099c8ce39feb9$export$6f32135080cb4c3)({
        prop: a,
        defaultProp: o ?? !1,
        onChange: s,
        caller: $7c802bd2b31dc149$var$v
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($7c802bd2b31dc149$var$x, {
        scope: t,
        triggerRef: l,
        contentRef: u,
        contentId: (0, $2505f25f517c82fa$export$f680877a34711e37)(),
        titleId: (0, $2505f25f517c82fa$export$f680877a34711e37)(),
        descriptionId: (0, $2505f25f517c82fa$export$f680877a34711e37)(),
        open: d,
        onOpenChange: f,
        onOpenToggle: $lCzvA.useCallback(()=>f((e)=>!e), [
            f
        ]),
        modal: c,
        children: n
    });
};
$7c802bd2b31dc149$export$3ddf2d174ce01153.displayName = $7c802bd2b31dc149$var$v;
var $7c802bd2b31dc149$var$w = "DialogTrigger", $7c802bd2b31dc149$export$2e1e1122cf0cba88 = $lCzvA.forwardRef((n, r)=>{
    let { __scopeDialog: i, ...a } = n, s = $7c802bd2b31dc149$var$S($7c802bd2b31dc149$var$w, i), c = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(r, s.triggerRef);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": s.open,
        "aria-controls": s.open ? s.contentId : void 0,
        "data-state": $7c802bd2b31dc149$var$G(s.open),
        ...a,
        ref: c,
        onClick: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onClick, s.onOpenToggle)
    });
});
$7c802bd2b31dc149$export$2e1e1122cf0cba88.displayName = $7c802bd2b31dc149$var$w;
var $7c802bd2b31dc149$var$E = "DialogPortal", [$7c802bd2b31dc149$var$D, $7c802bd2b31dc149$var$O] = $7c802bd2b31dc149$var$y($7c802bd2b31dc149$var$E, {
    forceMount: void 0
}), $7c802bd2b31dc149$export$dad7c95542bacce0 = (e)=>{
    let { __scopeDialog: t, forceMount: n, children: r, container: i } = e, a = $7c802bd2b31dc149$var$S($7c802bd2b31dc149$var$E, t);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($7c802bd2b31dc149$var$D, {
        scope: t,
        forceMount: n,
        children: $lCzvA.Children.map(r, (e)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0682faac15a06e68$export$99c2b779aa4e8b8b), {
                present: n || a.open,
                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9bc4a16530321c60$export$602eac185826482c), {
                    asChild: !0,
                    container: i,
                    children: e
                })
            }))
    });
};
$7c802bd2b31dc149$export$dad7c95542bacce0.displayName = $7c802bd2b31dc149$var$E;
var $7c802bd2b31dc149$var$A = "DialogOverlay", $7c802bd2b31dc149$export$bd1d06c79be19e17 = $lCzvA.forwardRef((e, t)=>{
    let n = $7c802bd2b31dc149$var$O($7c802bd2b31dc149$var$A, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = $7c802bd2b31dc149$var$S($7c802bd2b31dc149$var$A, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0682faac15a06e68$export$99c2b779aa4e8b8b), {
        present: r || a.open,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($7c802bd2b31dc149$var$N, {
            ...i,
            ref: t
        })
    }) : null;
});
$7c802bd2b31dc149$export$bd1d06c79be19e17.displayName = $7c802bd2b31dc149$var$A;
var $7c802bd2b31dc149$var$M = (0, $09f52881d5dae1cd$export$e88b45bda5c13eb9)("DialogOverlay.RemoveScroll"), $7c802bd2b31dc149$var$N = $lCzvA.forwardRef((e, n)=>{
    let { __scopeDialog: r, ...i } = e, a = $7c802bd2b31dc149$var$S($7c802bd2b31dc149$var$A, r), s = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(n, (0, $fb04d4ce1fe91315$export$210785236bdfcb27)());
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0a8b5b0a247b3b3f$export$2e2bcd8739ae039), {
        as: $7c802bd2b31dc149$var$M,
        allowPinchZoom: !0,
        shards: [
            a.contentRef
        ],
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).div, {
            "data-state": $7c802bd2b31dc149$var$G(a.open),
            ...i,
            ref: s,
            style: {
                pointerEvents: "auto",
                ...i.style
            }
        })
    });
}), $7c802bd2b31dc149$var$P = "DialogContent", $7c802bd2b31dc149$export$7c6e2c02157bb7d2 = $lCzvA.forwardRef((e, t)=>{
    let n = $7c802bd2b31dc149$var$O($7c802bd2b31dc149$var$P, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = $7c802bd2b31dc149$var$S($7c802bd2b31dc149$var$P, e.__scopeDialog);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0682faac15a06e68$export$99c2b779aa4e8b8b), {
        present: r || a.open,
        children: a.modal ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($7c802bd2b31dc149$var$I, {
            ...i,
            ref: t
        }) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($7c802bd2b31dc149$var$L, {
            ...i,
            ref: t
        })
    });
});
$7c802bd2b31dc149$export$7c6e2c02157bb7d2.displayName = $7c802bd2b31dc149$var$P;
var $7c802bd2b31dc149$var$I = $lCzvA.forwardRef((n, r)=>{
    let i = $7c802bd2b31dc149$var$S($7c802bd2b31dc149$var$P, n.__scopeDialog), a = $lCzvA.useRef(null), o = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(r, i.contentRef, a);
    return $lCzvA.useEffect(()=>{
        let e = a.current;
        if (e) return (0, $ff254d9dfc477fd4$export$6e33d16126ed003c)(e);
    }, []), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($7c802bd2b31dc149$var$R, {
        ...n,
        ref: o,
        trapFocus: i.open,
        disableOutsidePointerEvents: i.open,
        onCloseAutoFocus: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onCloseAutoFocus, (e)=>{
            e.preventDefault(), i.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onPointerDownOutside, (e)=>{
            let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
            (t.button === 2 || n) && e.preventDefault();
        }),
        onFocusOutside: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onFocusOutside, (e)=>e.preventDefault())
    });
}), $7c802bd2b31dc149$var$L = $lCzvA.forwardRef((e, t)=>{
    let n = $7c802bd2b31dc149$var$S($7c802bd2b31dc149$var$P, e.__scopeDialog), r = $lCzvA.useRef(!1), i = $lCzvA.useRef(!1);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($7c802bd2b31dc149$var$R, {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (t)=>{
            e.onCloseAutoFocus?.(t), t.defaultPrevented || (r.current || n.triggerRef.current?.focus(), t.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (t)=>{
            e.onInteractOutside?.(t), t.defaultPrevented || (r.current = !0, t.detail.originalEvent.type === "pointerdown" && (i.current = !0));
            let a = t.target;
            n.triggerRef.current?.contains(a) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && i.current && t.preventDefault();
        }
    });
}), $7c802bd2b31dc149$var$R = $lCzvA.forwardRef((e, t)=>{
    let { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...o } = e, c = $7c802bd2b31dc149$var$S($7c802bd2b31dc149$var$P, n);
    return (0, $2e5466663c5a0617$export$b7ece24a22aeda8c)(), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a89c400092b04111$export$20e40289641fbbb6), {
            asChild: !0,
            loop: !0,
            trapped: r,
            onMountAutoFocus: i,
            onUnmountAutoFocus: a,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fb04d4ce1fe91315$export$177fb62ff3ec1f22), {
                role: "dialog",
                id: c.contentId,
                "aria-describedby": c.descriptionId,
                "aria-labelledby": c.titleId,
                "data-state": $7c802bd2b31dc149$var$G(c.open),
                ...o,
                ref: t,
                deferPointerDownOutside: !0,
                onDismiss: ()=>c.onOpenChange(!1)
            })
        })
    });
}), $7c802bd2b31dc149$var$z = "DialogTitle", $7c802bd2b31dc149$export$16f7638e4a34b909 = $lCzvA.forwardRef((e, t)=>{
    let { __scopeDialog: n, ...r } = e, i = $7c802bd2b31dc149$var$S($7c802bd2b31dc149$var$z, n);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).h2, {
        id: i.titleId,
        ...r,
        ref: t
    });
});
$7c802bd2b31dc149$export$16f7638e4a34b909.displayName = $7c802bd2b31dc149$var$z;
var $7c802bd2b31dc149$var$V = "DialogDescription", $7c802bd2b31dc149$export$393edc798c47379d = $lCzvA.forwardRef((e, t)=>{
    let { __scopeDialog: n, ...r } = e, i = $7c802bd2b31dc149$var$S($7c802bd2b31dc149$var$V, n);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).p, {
        id: i.descriptionId,
        ...r,
        ref: t
    });
});
$7c802bd2b31dc149$export$393edc798c47379d.displayName = $7c802bd2b31dc149$var$V;
var $7c802bd2b31dc149$var$U = "DialogClose", $7c802bd2b31dc149$export$f39c2d165cd861fe = $lCzvA.forwardRef((t, n)=>{
    let { __scopeDialog: r, ...i } = t, a = $7c802bd2b31dc149$var$S($7c802bd2b31dc149$var$U, r);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).button, {
        type: "button",
        ...i,
        ref: n,
        onClick: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(t.onClick, ()=>a.onOpenChange(!1))
    });
});
$7c802bd2b31dc149$export$f39c2d165cd861fe.displayName = $7c802bd2b31dc149$var$U;
function $7c802bd2b31dc149$var$G(e) {
    return e ? "open" : "closed";
}





//#region src/components/Modal/Close/index.jsx
var $4ae9b029bb4151af$export$2e2bcd8739ae039 = ({ children: r, className: i, ...a })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7c802bd2b31dc149$export$f39c2d165cd861fe), {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-ModalClose": !0,
            [i]: i
        }),
        ...a,
        children: r
    });
$4ae9b029bb4151af$export$2e2bcd8739ae039.displayName = "ModalClose";



"use client";
//#region src/components/Modal/index.jsx
var $9dad852e7e98f87b$export$2e2bcd8739ae039 = ({ children: c, className: l, backdropClass: u, backdropOpacity: d = 80, closeButtonClass: f, showInDom: p = !1, showClose: m = !0, width: h = "600px", effect: g = "fade-in", fullScreen: _, description: v, onWheel: y, onTouchMove: b, ...x })=>{
    let S = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Modal fixed bg-white z-40 grid grid-rows-[auto_1fr_auto] data-[state=closed]:hidden": !0,
        "data-[state=open]:animate-fade-in": g === "fade-in",
        "data-[state=open]:animate-slide-up": g === "slide-up",
        "data-[state=open]:animate-slide-down": g === "slide-down",
        "data-[state=open]:animate-scale-up": g === "scale-up",
        "data-[state=open]:animate-scale-down": g === "scale-down",
        "inset-0": _,
        "left-1/2 top-1/2 -translate-1/2 max-w-8/10 max-h-[80vh] rounded-sm": !_,
        [l]: l
    }), C = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-ModalOverlay [&:has(+[data-state=closed])]:hidden inset-0 fixed z-39": !0,
        [u]: u
    }), w = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "absolute right-2 top-2 flex h-12 w-12 items-center justify-center text-4xl/none font-light no-underline!": !0,
        [f]: f
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $7c802bd2b31dc149$export$dad7c95542bacce0), {
        forceMount: p,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: C,
                style: {
                    backgroundColor: `rgba(0,0,0,${d * .01})`
                }
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $7c802bd2b31dc149$export$7c6e2c02157bb7d2), {
                ...!v && {
                    "aria-describedby": void 0
                },
                className: S,
                style: {
                    width: _ ? void 0 : h
                },
                onWheel: (e)=>{
                    e.stopPropagation(), y?.(e);
                },
                onTouchMove: (e)=>{
                    e.stopPropagation(), b?.(e);
                },
                ...x,
                children: [
                    v && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7c802bd2b31dc149$export$393edc798c47379d), {
                        className: "sr-only",
                        children: v
                    }),
                    c,
                    m && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4ae9b029bb4151af$export$2e2bcd8739ae039), {
                        className: w,
                        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                            name: "close"
                        })
                    })
                ]
            })
        ]
    });
};



//#region src/components/Modal/Content/index.jsx
var $21eb14e493d0e28b$export$2e2bcd8739ae039 = ({ children: n, className: r, ...i })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-ModalContent flex-1 overflow-auto p-8": !0,
            [r]: r
        }),
        "data-testid": "sash-modal-content",
        ...i,
        children: n
    });
$21eb14e493d0e28b$export$2e2bcd8739ae039.displayName = "ModalContent";




//#region src/components/Modal/Header/index.jsx
var $9761f0447406a76c$export$2e2bcd8739ae039 = ({ children: r, className: i, renderAs: a = "h3" })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7c802bd2b31dc149$export$16f7638e4a34b909), {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-ModalHeader flex-none pl-8 py-4 border-b border-b-neutral-100 pr-10": !0,
            [i]: i
        }),
        asChild: !0,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(a, {
            className: "m-0 text-2xl font-semibold text-black",
            children: r
        })
    });
$9761f0447406a76c$export$2e2bcd8739ae039.displayName = "ModalHeader";



"use client";
//#region src/components/Modal/Root/index.jsx
var $4d41d17efc15da0f$export$2e2bcd8739ae039 = ({ children: n, defaultOpen: r, open: i, onOpenChange: a, ...o })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7c802bd2b31dc149$export$3ddf2d174ce01153), {
        modal: !1,
        open: i,
        defaultOpen: r,
        onOpenChange: a,
        ...o,
        children: n
    });
$4d41d17efc15da0f$export$2e2bcd8739ae039.displayName = "ModalRoot";









//#region src/components/Label/index.jsx
var $fbac12b06efda731$export$2e2bcd8739ae039 = ({ error: n, htmlFor: r, hide: i, children: a, className: o, renderAs: s = "label", ...c })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(s, {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-Label block text-sm/tight font-semibold": !0,
            "text-black": !n,
            "text-red-700": n,
            "sr-only": i,
            [o]: o
        }),
        "data-testid": "sash-label",
        htmlFor: r,
        ...c,
        children: a
    });



"use client";
//#region src/components/@helpers/FormFieldTop/index.jsx
var $353df793a3a1d2b7$export$2e2bcd8739ae039 = ({ labelText: s, hideLabel: c, required: l, id: u, className: d, assistiveText: f, error: p, helpText: m, tooltipContent: h, tooltipPosition: g = "bottom", renderAs: _ = "label", ...v })=>(_ === "label" && !u && console.error("\"id\" prop is required for form fields to correctly attach to labels."), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-FormFieldTop relative": !0,
            "mb-2": !c && !f,
            [d]: d
        }),
        "data-testid": "sash-input-top",
        ...v,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbac12b06efda731$export$2e2bcd8739ae039), {
                htmlFor: u,
                className: l ? "text-required" : "",
                hide: c,
                error: p,
                renderAs: _,
                children: s
            }),
            (f || m) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: "sash-FormFieldTop-help mt-1 mb-2 space-x-0.5 leading-none",
                children: [
                    f && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                        className: "inline text-xs text-neutral-600",
                        children: f
                    }),
                    m && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4894604720ca08c8$export$2e2bcd8739ae039), {
                        className: "inline",
                        children: [
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $159cb66f654a3a1c$export$2e2bcd8739ae039), {
                                className: "text-blue inline-block text-xs/tight hover:underline",
                                children: m
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $833f5a446a1fbfcc$export$2e2bcd8739ae039), {
                                position: g,
                                align: "start",
                                className: "text-caption z-2 max-w-[40ch] border border-black p-2 shadow-md",
                                children: h
                            })
                        ]
                    })
                ]
            })
        ]
    }));



var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/Select/index.jsx
var $c7e1b2c0ded2c83a$export$2e2bcd8739ae039 = (0, $lCzvA.forwardRef)(({ labelText: i, id: c, hideLabel: l, children: u, className: d, containerClass: f, assistiveText: p, required: m, error: h, helpText: g, tooltipContent: _, tooltipPosition: v = "bottom", ...y }, b)=>{
    let x = (0, $lCzvA.Children)?.toArray(u)?.length === 1, S = (0, $lCzvA.useRef)(null), C = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-FormGroup sash-FormGroupSelect relative mb-4": !0,
        [f]: f
    }), w = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Select sash-input appearance-none pr-10": !0,
        "pointer-events-none bg-transparent": x,
        "border-red-700": h,
        [d]: d
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        ref: S,
        className: C,
        "data-testid": "sash-select",
        children: [
            (i || g || p) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $353df793a3a1d2b7$export$2e2bcd8739ae039), {
                id: c,
                labelText: i,
                hideLabel: l,
                required: m,
                error: !!h,
                assistiveText: p,
                helpText: g,
                tooltipContent: _,
                tooltipPosition: v
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: "sash-SelectWrapper relative",
                "data-testid": "sash-select-wrapper",
                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("select", {
                    id: c,
                    name: c,
                    className: w,
                    required: m,
                    ref: b,
                    ...y,
                    children: u
                })
            }),
            typeof h == "string" && !!h && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $71efe153e5175f41$export$2e2bcd8739ae039), {
                type: "error",
                className: "mt-2",
                message: h,
                inline: !0
            })
        ]
    });
});
$c7e1b2c0ded2c83a$export$2e2bcd8739ae039.displayName = "Select";




const $69cb03e609be8e5e$export$a002182e51710d39 = {
    AppName: 'Equipment Action Portal',
    PostLogoutRoute: '/'
};
const $69cb03e609be8e5e$export$2c9aa90e6f9262f3 = {
    issuer: window.REACT_APP_OKTA_ISSUER ?? undefined ?? '',
    clientId: window.REACT_APP_OKTA_CLIENTID ?? undefined ?? '',
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: [
        'openid',
        'profile',
        'email',
        'offline_access',
        'ApiGw.account',
        'ApiGw.thrive',
        'ApiGw.appl-user',
        'ApiGw.app-analytics',
        'ApiGw.teammembers',
        'ApiGw.org-management',
        'ApiGw.inv-mgmt'
    ],
    pkce: true,
    disableHttpsCheck: window.OKTA_TESTING_DISABLEHTTPSCHECK || false,
    postLogoutRedirectUri: `${window.location.origin}/logout`
};
const $69cb03e609be8e5e$export$219078e38253958 = new (0, $dbbfea4bd9ff1bad$exports.OktaAuth)($69cb03e609be8e5e$export$2c9aa90e6f9262f3);
const $69cb03e609be8e5e$export$367ea9b952380ab7 = [
    {
        name: 'DEV',
        instanceID: 'EBSDEV'
    },
    {
        name: 'DEV2',
        instanceID: 'EBSDEV2'
    },
    {
        name: 'DEV3',
        instanceID: 'EBSDEV3'
    },
    {
        name: 'DEV4',
        instanceID: 'EBSDEV4'
    },
    {
        name: 'DEV5',
        instanceID: 'EBSDEV5'
    },
    {
        name: 'DEV6',
        instanceID: 'EBSDEV6'
    }
];
const $69cb03e609be8e5e$export$40edfb7eeb78c4e8 = window.REACT_APP_API_URL?.includes('apidev');


/**
 * Developer Tools Modal Component
 * Provides a modal for developers to manage EBS instance settings.
 * @param {object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {() => void} props.onClose - Callback function when modal is closed
 * @returns {import("react").ReactElement} Developer tools modal component
 */ const $53545f34f1933400$var$DevTools = ({ isOpen: isOpen, onClose: onClose })=>{
    const { setSelectedEBSInstance: setSelectedEBSInstance, selectedEBSInstance: selectedEBSInstance } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const handleInstanceChange = (e)=>{
        setSelectedEBSInstance(e.target.value);
    };
    return(// @ts-ignore
    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
        open: isOpen,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
            "data-testid": `devtools-modal-open:${isOpen}`,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                    children: "Developer Tools"
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                        id: "ebs-instance-select",
                        labelText: "Select EBS Instance",
                        onChange: handleInstanceChange,
                        value: selectedEBSInstance,
                        "data-testid": "ebs-instance-select",
                        children: (0, $69cb03e609be8e5e$export$367ea9b952380ab7).map(({ instanceID: instanceID, name: name })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                value: instanceID,
                                children: name
                            }, instanceID))
                    })
                })
            ]
        })
    }));
};
var $53545f34f1933400$export$2e2bcd8739ae039 = $53545f34f1933400$var$DevTools;







var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");
var $5a25ac255e225a02$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $5a25ac255e225a02$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $c972871b9716db27$var$e = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function $c972871b9716db27$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($5a25ac255e225a02$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($c972871b9716db27$var$e), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var l = c[1].trim(), o = [
                l,
                ""
            ];
            l.indexOf("=") > -1 && (o = l.split("=")), r.attrs[o[0]] = o[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $c972871b9716db27$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $c972871b9716db27$var$i = /^\s*$/, $c972871b9716db27$var$s = Object.create(null);
function $c972871b9716db27$var$a(t, e) {
    switch(e.type){
        case "text":
            return t + e.content;
        case "tag":
            return t += "<" + e.name + (e.attrs ? function(t) {
                var e = [];
                for(var n in t)e.push(n + '="' + t[n] + '"');
                return e.length ? " " + e.join(" ") : "";
            }(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? t : t + e.children.reduce($c972871b9716db27$var$a, "") + "</" + e.name + ">";
        case "comment":
            return t + "\x3c!--" + e.comment + "--\x3e";
    }
}
var $c972871b9716db27$var$c = {
    parse: function(t, e) {
        e || (e = {}), e.components || (e.components = $c972871b9716db27$var$s);
        var a, c = [], l = [], o = -1, u = !1;
        if (0 !== t.indexOf("<")) {
            var h = t.indexOf("<");
            c.push({
                type: "text",
                content: -1 === h ? t : t.substring(0, h)
            });
        }
        for(var v, f = []; v = $c972871b9716db27$var$r.exec(t);)f.push(v);
        return f.forEach(function(t, e) {
            var n = t[0];
            if (n && !n.startsWith("\x3c!--")) {
                for(var r = 0, i = 0, s = -1, a = null, c = 0; c < n.length; c++){
                    var l = n.charAt(c);
                    a ? l === a && (a = null) : '"' === l || "'" === l ? a = l : "<" === l ? 2 == ++r && (s = c) : ">" === l && i++;
                }
                var o = s > -1 && /[a-zA-Z0-9\-!/]/.test(n.charAt(s + 1));
                if (r > i && o) {
                    var u = n.substring(0, s), h = n.substring(u.length);
                    f[e][0] = h, f[e].index += u.length;
                }
            }
        }), f.forEach(function(r, s) {
            var h = r[0];
            if (h) {
                var v = r.index;
                if (u) {
                    if (h !== "</" + a.name + ">") return;
                    u = !1;
                }
                var m, d, p = "/" !== h.charAt(1), x = h.startsWith("\x3c!--"), g = v + h.length, y = t.charAt(g), E = f[s + 1];
                if ("<" === y && E) {
                    var A = t.substring(g, E.index);
                    m = A.split("<").length > A.split(">").length;
                }
                if (x) {
                    var b = $c972871b9716db27$var$n(h);
                    if (o < 0) return c.push(b), c;
                    (d = l[o]).children.push(b);
                    var O = t.slice(g, E ? E.index : void 0);
                    return O.length > 0 && d.children.push({
                        type: "text",
                        content: O
                    }), c;
                }
                if (p && (o++, "tag" === (a = $c972871b9716db27$var$n(h)).type && e.components[a.name] && (a.type = "component", u = !0), a.voidElement || u || !y || "<" === y || a.children.push({
                    type: "text",
                    content: t.slice(g, E ? E.index : void 0)
                }), 0 === o && c.push(a), (d = l[o - 1]) && d.children.push(a), l[o] = a), (!p || a.voidElement) && (o > -1 && (a.voidElement || a.name === h.slice(2, -1)) && (o--, a = -1 === o ? c : l[o]), !u && ("<" !== y || m) && y)) {
                    d = -1 === o ? c : l[o].children;
                    var W = E ? E.index : -1, j = t.slice(g, -1 === W ? void 0 : W);
                    $c972871b9716db27$var$i.test(j) && (j = " "), (W > -1 && o + d.length >= 0 || " " !== j) && d.push({
                        type: "text",
                        content: j
                    });
                }
            }
        }), c;
    },
    stringify: function(t) {
        return t.reduce(function(t, e) {
            return t + $c972871b9716db27$var$a("", e);
        }, "");
    }
};
var $c972871b9716db27$export$2e2bcd8739ae039 = $c972871b9716db27$var$c;


const $5ca8e25cb064ac1d$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($5ca8e25cb064ac1d$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $5ca8e25cb064ac1d$var$alreadyWarned = {};
const $5ca8e25cb064ac1d$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($5ca8e25cb064ac1d$export$844ec244b1367d54(msg) && $5ca8e25cb064ac1d$var$alreadyWarned[msg]) return;
    if ($5ca8e25cb064ac1d$export$844ec244b1367d54(msg)) $5ca8e25cb064ac1d$var$alreadyWarned[msg] = new Date();
    $5ca8e25cb064ac1d$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $5ca8e25cb064ac1d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $5ca8e25cb064ac1d$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $5ca8e25cb064ac1d$var$loadedClb(i18n, cb));
};
const $5ca8e25cb064ac1d$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($5ca8e25cb064ac1d$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $5ca8e25cb064ac1d$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $5ca8e25cb064ac1d$var$loadedClb(i18n, cb));
};
const $5ca8e25cb064ac1d$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $5ca8e25cb064ac1d$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $5ca8e25cb064ac1d$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($5ca8e25cb064ac1d$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $5ca8e25cb064ac1d$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $5ca8e25cb064ac1d$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $68acb5501fe87bd8$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $68acb5501fe87bd8$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $68acb5501fe87bd8$var$unescapeHtmlEntity = (m)=>$68acb5501fe87bd8$var$htmlEntities[m];
const $68acb5501fe87bd8$export$e8bacd2802a88316 = (text)=>text.replace($68acb5501fe87bd8$var$matchHtmlEntity, $68acb5501fe87bd8$var$unescapeHtmlEntity);


let $3ef6801f74b91218$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $68acb5501fe87bd8$export$e8bacd2802a88316
};
const $3ef6801f74b91218$export$2e2366488d12e20d = (options = {})=>{
    $3ef6801f74b91218$var$defaultOptions = {
        ...$3ef6801f74b91218$var$defaultOptions,
        ...options
    };
};
const $3ef6801f74b91218$export$212bb2fc580a90a8 = ()=>$3ef6801f74b91218$var$defaultOptions;


let $641195b8c300ff96$var$i18nInstance;
const $641195b8c300ff96$export$a039134f2fc7e0 = (instance)=>{
    $641195b8c300ff96$var$i18nInstance = instance;
};
const $641195b8c300ff96$export$64af334f494c2f47 = ()=>$641195b8c300ff96$var$i18nInstance;


const $03c67d786717b9c9$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $03c67d786717b9c9$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $03c67d786717b9c9$var$getAsArray(children) : children;
};
const $03c67d786717b9c9$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $lCzvA.isValidElement));
const $03c67d786717b9c9$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $03c67d786717b9c9$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $03c67d786717b9c9$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $03c67d786717b9c9$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $5ca8e25cb064ac1d$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $lCzvA.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $5ca8e25cb064ac1d$export$844ec244b1367d54)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $03c67d786717b9c9$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $5ca8e25cb064ac1d$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $5ca8e25cb064ac1d$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $5ca8e25cb064ac1d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $5ca8e25cb064ac1d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $03c67d786717b9c9$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $03c67d786717b9c9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $5ca8e25cb064ac1d$export$844ec244b1367d54)(child)) return;
            if ($03c67d786717b9c9$var$hasChildren(child)) getData($03c67d786717b9c9$var$getChildren(child));
            else if ((0, $5ca8e25cb064ac1d$export$a6cdc56e425d0d0a)(child) && !(0, $lCzvA.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $c972871b9716db27$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $03c67d786717b9c9$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $03c67d786717b9c9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $lCzvA.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $lCzvA.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $lCzvA.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.props.ref ?? c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $03c67d786717b9c9$var$getAsArray(reactNode);
        const astNodes = $03c67d786717b9c9$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $03c67d786717b9c9$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $lCzvA.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $03c67d786717b9c9$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $5ca8e25cb064ac1d$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $5ca8e25cb064ac1d$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $5ca8e25cb064ac1d$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($03c67d786717b9c9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $lCzvA.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $lCzvA.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $5ca8e25cb064ac1d$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $lCzvA.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $03c67d786717b9c9$var$getAsArray(children || []));
    return $03c67d786717b9c9$var$getChildren(result[0]);
};
const $03c67d786717b9c9$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $lCzvA.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $lCzvA.createElement)((0, $lCzvA.Fragment), null, comp);
    }
    return (0, $lCzvA.createElement)(Componentized, {
        key: componentKey
    });
};
const $03c67d786717b9c9$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$03c67d786717b9c9$var$fixComponentProps(c, index, translation));
const $03c67d786717b9c9$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $03c67d786717b9c9$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $03c67d786717b9c9$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $03c67d786717b9c9$var$generateArrayComponents(components, translation);
    if ((0, $5ca8e25cb064ac1d$export$a6cdc56e425d0d0a)(components)) return $03c67d786717b9c9$var$generateObjectComponents(components, translation);
    (0, $5ca8e25cb064ac1d$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $03c67d786717b9c9$var$isComponentsMap = (object)=>{
    if (!(0, $5ca8e25cb064ac1d$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $03c67d786717b9c9$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $641195b8c300ff96$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $5ca8e25cb064ac1d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $3ef6801f74b91218$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $5ca8e25cb064ac1d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $03c67d786717b9c9$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const generatedComponents = $03c67d786717b9c9$var$generateComponents(components, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($03c67d786717b9c9$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $03c67d786717b9c9$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $lCzvA.createElement)(useAsParent, additionalProps, content) : content;
}



var $lCzvA = parcelRequire("lCzvA");




const $9044861fa4d3684d$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $3ef6801f74b91218$export$2e2366488d12e20d)(instance.options.react);
        (0, $641195b8c300ff96$export$a039134f2fc7e0)(instance);
    }
};


const $486c9d11df3e9d99$export$5603ab5ced17ce64 = (0, $lCzvA.createContext)();
class $486c9d11df3e9d99$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $486c9d11df3e9d99$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $486c9d11df3e9d99$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $486c9d11df3e9d99$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $641195b8c300ff96$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $5e00724294f8db91$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $lCzvA.useContext)((0, $486c9d11df3e9d99$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $641195b8c300ff96$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $03c67d786717b9c9$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $lCzvA = parcelRequire("lCzvA");


const $8216e3af17948d6d$var$usePrevious = (value, ignore)=>{
    const ref = (0, $lCzvA.useRef)();
    (0, $lCzvA.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $8216e3af17948d6d$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $8216e3af17948d6d$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $lCzvA.useCallback)($8216e3af17948d6d$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $8216e3af17948d6d$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $lCzvA.useContext)((0, $486c9d11df3e9d99$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $641195b8c300ff96$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $486c9d11df3e9d99$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $5ca8e25cb064ac1d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $5ca8e25cb064ac1d$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $5ca8e25cb064ac1d$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $5ca8e25cb064ac1d$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react?.wait) (0, $5ca8e25cb064ac1d$export$5b28268982f175ba)(i18n, 'DEPRECATED_OPTION', 'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $3ef6801f74b91218$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options?.defaultNS;
    namespaces = (0, $5ca8e25cb064ac1d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    i18n.reportNamespaces.addUsedNamespaces?.(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $5ca8e25cb064ac1d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $8216e3af17948d6d$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$8216e3af17948d6d$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $lCzvA.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $8216e3af17948d6d$var$usePrevious(joinedNS);
    const isMounted = (0, $lCzvA.useRef)(true);
    (0, $lCzvA.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $5ca8e25cb064ac1d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $5ca8e25cb064ac1d$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n) i18n?.on(bindI18n, boundReset);
        if (bindI18nStore) i18n?.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (i18n && bindI18n) bindI18n?.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $lCzvA.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $5ca8e25cb064ac1d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $5ca8e25cb064ac1d$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};



var $lCzvA = parcelRequire("lCzvA");


const $f2fa05c5c4f62cae$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $8216e3af17948d6d$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $lCzvA.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $5ca8e25cb064ac1d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $lCzvA.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $lCzvA.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $6bab16eaf42bb768$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $8216e3af17948d6d$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};



var $lCzvA = parcelRequire("lCzvA");

function $4de3c1cf98001c88$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $lCzvA.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $lCzvA.createElement)((0, $486c9d11df3e9d99$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");

const $146b0233a595bca9$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $lCzvA.useContext)((0, $486c9d11df3e9d99$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $641195b8c300ff96$export$64af334f494c2f47)();
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $61c46843aa0ab139$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $146b0233a595bca9$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $lCzvA.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $486c9d11df3e9d99$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $5ca8e25cb064ac1d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $d2b5fb95f6f1b6db$export$324d90190a8b822a = ()=>'';
const $d2b5fb95f6f1b6db$export$2da9be4cfdb689b1 = ()=>'';
const $d2b5fb95f6f1b6db$export$98e628dec113755e = ()=>'';
const $d2b5fb95f6f1b6db$export$2e6c959c16ff56b8 = ()=>'';
const $d2b5fb95f6f1b6db$export$4e35d5c922a95490 = ()=>'';
const $d2b5fb95f6f1b6db$export$720a3b9db04b7a0f = ()=>'';


/**
 * Language Selector Modal Component
 * Provides a modal for users to change the application language.
 * @param {object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {() => void} props.onClose - Callback function when modal is closed
 * @returns {import("react").ReactElement} Language selector modal component
 */ const $5fcdb208aa598d82$var$LanguageSelector = ({ isOpen: isOpen, onClose: onClose })=>{
    const { i18n: i18n } = (0, $8216e3af17948d6d$export$9fc83ad70ead8663)();
    const handleLanguageChange = (e)=>{
        i18n.changeLanguage(e.target.value);
    };
    return(// @ts-ignore
    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
        open: isOpen,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                    children: "Select Language"
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                        id: "language-select",
                        labelText: "Language",
                        onChange: handleLanguageChange,
                        value: i18n.language,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                value: "en",
                                children: "English"
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                value: "es",
                                children: "Spanish"
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
var $5fcdb208aa598d82$export$2e2bcd8739ae039 = $5fcdb208aa598d82$var$LanguageSelector;






var $lCzvA = parcelRequire("lCzvA");



//#region src/components/Modal/Footer/index.jsx
var $861af07899c9769a$export$2e2bcd8739ae039 = ({ children: n, className: r, ...i })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-ModalFooter flex justify-end flex-none py-4 px-8 border-t border-t-neutral-100 shadow-[0_-2px_15px_rgba(0,0,0,0.05)]": !0,
            [r]: r
        }),
        "data-testid": "sash-modal-footer",
        ...i,
        children: n
    });
$861af07899c9769a$export$2e2bcd8739ae039.displayName = "ModalFooter";






var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/react-number-format/dist/react-number-format.es.js
function $4bbf7ba23c3835e3$var$o(e, t) {
    var n = {};
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (e != null && typeof Object.getOwnPropertySymbols == "function") for(var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
    return n;
}
var $4bbf7ba23c3835e3$var$s;
(function(e) {
    e.event = "event", e.props = "prop";
})($4bbf7ba23c3835e3$var$s ||= {});
function $4bbf7ba23c3835e3$var$c() {}
function $4bbf7ba23c3835e3$var$l(e) {
    var t, n = void 0;
    return function() {
        for(var r = [], i = arguments.length; i--;)r[i] = arguments[i];
        return t && r.length === t.length && r.every(function(e, n) {
            return e === t[n];
        }) ? n : (t = r, n = e.apply(void 0, r), n);
    };
}
function $4bbf7ba23c3835e3$var$u(e) {
    return !!(e || "").match(/\d/);
}
function $4bbf7ba23c3835e3$var$d(e) {
    return e == null;
}
function $4bbf7ba23c3835e3$var$f(e) {
    return typeof e == "number" && isNaN(e);
}
function $4bbf7ba23c3835e3$var$p(e) {
    return $4bbf7ba23c3835e3$var$d(e) || $4bbf7ba23c3835e3$var$f(e) || typeof e == "number" && !isFinite(e);
}
function $4bbf7ba23c3835e3$var$m(e) {
    var t = (0, $lCzvA.useRef)(e);
    return t.current = e, (0, $lCzvA.useRef)(function() {
        for(var e = [], n = arguments.length; n--;)e[n] = arguments[n];
        return t.current.apply(t, e);
    }).current;
}
function $4bbf7ba23c3835e3$var$h(e, t) {
    return Array(t + 1).join(e);
}
function $4bbf7ba23c3835e3$var$g(e) {
    var t = e + "", n = t[0] === "-" ? "-" : "";
    n && (t = t.substring(1));
    var r = t.split(/[eE]/g), i = r[0], a = r[1];
    if (a = Number(a), !a) return n + i;
    i = i.replace(".", "");
    var o = 1 + a, s = i.length;
    return o < 0 ? i = "0." + $4bbf7ba23c3835e3$var$h("0", Math.abs(o)) + i : o >= s ? i += $4bbf7ba23c3835e3$var$h("0", o - s) : i = (i.substring(0, o) || "0") + "." + i.substring(o), n + i;
}
function $4bbf7ba23c3835e3$var$_(e, t) {
    if (e.value = e.value, e !== null) {
        if (e.createTextRange) {
            var n = e.createTextRange();
            return n.move("character", t), n.select(), !0;
        }
        return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(t, t), !0) : (e.focus(), !1);
    }
}
var $4bbf7ba23c3835e3$var$v = $4bbf7ba23c3835e3$var$l(function(e, t) {
    for(var n = 0, r = 0, i = e.length, a = t.length; e[n] === t[n] && n < i;)n++;
    for(; e[i - 1 - r] === t[a - 1 - r] && a - r > n && i - r > n;)r++;
    return {
        from: {
            start: n,
            end: i - r
        },
        to: {
            start: n,
            end: a - r
        }
    };
}), $4bbf7ba23c3835e3$var$y = function(e, t) {
    var n = Math.min(e.selectionStart, t);
    return {
        from: {
            start: n,
            end: e.selectionEnd
        },
        to: {
            start: n,
            end: t
        }
    };
};
function $4bbf7ba23c3835e3$var$b(e, t, n) {
    return Math.min(Math.max(e, t), n);
}
function $4bbf7ba23c3835e3$var$x(e) {
    return Math.max(e.selectionStart, e.selectionEnd);
}
function $4bbf7ba23c3835e3$var$S() {
    return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function $4bbf7ba23c3835e3$var$C(e) {
    return {
        from: {
            start: 0,
            end: 0
        },
        to: {
            start: 0,
            end: e.length
        },
        lastValue: ""
    };
}
function $4bbf7ba23c3835e3$var$w(e, t) {
    return e === void 0 && (e = " "), typeof e == "string" ? e : e[t] || " ";
}
function $4bbf7ba23c3835e3$var$T(e) {
    var t = e.currentValue, n = e.formattedValue, r = e.currentValueIndex, i = e.formattedValueIndex;
    return t[r] === n[i];
}
function $4bbf7ba23c3835e3$var$ee(e, t, n, r, i, a, o) {
    o === void 0 && (o = $4bbf7ba23c3835e3$var$T);
    var s = i.findIndex(function(e) {
        return e;
    }), c = e.slice(0, s);
    !t && !n.startsWith(c) && (t = c, n = c + n, r += c.length);
    for(var l = n.length, u = e.length, d = {}, f = Array(l), p = 0; p < l; p++){
        f[p] = -1;
        for(var m = 0, h = u; m < h; m++)if (o({
            currentValue: n,
            lastValue: t,
            formattedValue: e,
            currentValueIndex: p,
            formattedValueIndex: m
        }) && d[m] !== !0) {
            f[p] = m, d[m] = !0;
            break;
        }
    }
    for(var g = r; g < l && (f[g] === -1 || !a(n[g]));)g++;
    var _ = g === l || f[g] === -1 ? u : f[g];
    for(g = r - 1; g > 0 && f[g] === -1;)g--;
    var v = g === -1 || f[g] === -1 ? 0 : f[g] + 1;
    return v > _ ? _ : r - v < _ - r ? v : _;
}
function $4bbf7ba23c3835e3$var$E(e, t, n, r) {
    var i = e.length;
    if (t = $4bbf7ba23c3835e3$var$b(t, 0, i), r === "left") {
        for(; t >= 0 && !n[t];)t--;
        t === -1 && (t = n.indexOf(!0));
    } else {
        for(; t <= i && !n[t];)t++;
        t > i && (t = n.lastIndexOf(!0));
    }
    return t === -1 && (t = i), t;
}
function $4bbf7ba23c3835e3$var$te(e) {
    for(var t = Array.from({
        length: e.length + 1
    }).map(function() {
        return !0;
    }), n = 0, r = t.length; n < r; n++)t[n] = !!($4bbf7ba23c3835e3$var$u(e[n]) || $4bbf7ba23c3835e3$var$u(e[n - 1]));
    return t;
}
function $4bbf7ba23c3835e3$var$ne(e, n, i, o, l, u) {
    u === void 0 && (u = $4bbf7ba23c3835e3$var$c);
    var f = $4bbf7ba23c3835e3$var$m(function(e, t) {
        var n, r;
        return $4bbf7ba23c3835e3$var$p(e) ? (r = "", n = "") : typeof e == "number" || t ? (r = typeof e == "number" ? $4bbf7ba23c3835e3$var$g(e) : e, n = o(r)) : (r = l(e, void 0), n = o(r)), {
            formattedValue: n,
            numAsString: r
        };
    }), h = (0, $lCzvA.useState)(function() {
        return f($4bbf7ba23c3835e3$var$d(e) ? n : e, i);
    }), _ = h[0], v = h[1], y = $4bbf7ba23c3835e3$var$m(function(e, t) {
        e.formattedValue !== _.formattedValue && v({
            formattedValue: e.formattedValue,
            numAsString: e.value
        }), u(e, t);
    }), b = e, x = i;
    $4bbf7ba23c3835e3$var$d(e) && (b = _.numAsString, x = !0);
    var S = f(b, x);
    return (0, $lCzvA.useMemo)(function() {
        v(S);
    }, [
        S.formattedValue
    ]), (0, $lCzvA.useEffect)(function() {
        if (!$4bbf7ba23c3835e3$var$d(n) && $4bbf7ba23c3835e3$var$d(e) && _.formattedValue !== "") {
            var t = parseFloat(_.numAsString);
            y({
                formattedValue: _.formattedValue,
                value: _.numAsString,
                floatValue: isNaN(t) ? void 0 : t
            }, {
                event: void 0,
                source: $4bbf7ba23c3835e3$var$s.props
            });
        }
    }, []), [
        _,
        y
    ];
}
function $4bbf7ba23c3835e3$var$D(e) {
    return e.replace(/[^0-9]/g, "");
}
function $4bbf7ba23c3835e3$var$re(e) {
    return e;
}
function $4bbf7ba23c3835e3$export$dd1caf9b8ccbc158(r) {
    var l = r.type;
    l === void 0 && (l = "text");
    var d = r.displayType;
    d === void 0 && (d = "input");
    var f = r.customInput, p = r.renderText, m = r.getInputRef, h = r.format;
    h === void 0 && (h = $4bbf7ba23c3835e3$var$re);
    var g = r.removeFormatting;
    g === void 0 && (g = $4bbf7ba23c3835e3$var$D);
    var b = r.defaultValue, C = r.valueIsNumericString, w = r.onValueChange, T = r.isAllowed, O = r.onChange;
    O === void 0 && (O = $4bbf7ba23c3835e3$var$c);
    var k = r.onKeyDown;
    k === void 0 && (k = $4bbf7ba23c3835e3$var$c);
    var A = r.onMouseUp;
    A === void 0 && (A = $4bbf7ba23c3835e3$var$c);
    var j = r.onFocus;
    j === void 0 && (j = $4bbf7ba23c3835e3$var$c);
    var M = r.onBlur;
    M === void 0 && (M = $4bbf7ba23c3835e3$var$c);
    var N = r.value, P = r.getCaretBoundary;
    P === void 0 && (P = $4bbf7ba23c3835e3$var$te);
    var F = r.isValidInputCharacter;
    F === void 0 && (F = $4bbf7ba23c3835e3$var$u);
    var ie = r.isCharacterSame, I = $4bbf7ba23c3835e3$var$o(r, [
        "type",
        "displayType",
        "customInput",
        "renderText",
        "getInputRef",
        "format",
        "removeFormatting",
        "defaultValue",
        "valueIsNumericString",
        "onValueChange",
        "isAllowed",
        "onChange",
        "onKeyDown",
        "onMouseUp",
        "onFocus",
        "onBlur",
        "value",
        "getCaretBoundary",
        "isValidInputCharacter",
        "isCharacterSame"
    ]), L = $4bbf7ba23c3835e3$var$ne(N, b, !!C, h, g, w), R = L[0], z = R.formattedValue, B = R.numAsString, V = L[1], H = (0, $lCzvA.useRef)(), U = (0, $lCzvA.useRef)({
        formattedValue: z,
        numAsString: B
    }), W = function(e, t) {
        U.current = {
            formattedValue: e.formattedValue,
            numAsString: e.value
        }, V(e, t);
    }, G = (0, $lCzvA.useState)(!1), ae = G[0], oe = G[1], K = (0, $lCzvA.useRef)(null), q = (0, $lCzvA.useRef)({
        setCaretTimeout: null,
        focusTimeout: null
    });
    (0, $lCzvA.useEffect)(function() {
        return oe(!0), function() {
            clearTimeout(q.current.setCaretTimeout), clearTimeout(q.current.focusTimeout);
        };
    }, []);
    var se = h, J = function(e, t) {
        var n = parseFloat(t);
        return {
            formattedValue: e,
            value: t,
            floatValue: isNaN(n) ? void 0 : n
        };
    }, Y = function(e, t, n) {
        e.selectionStart === 0 && e.selectionEnd === e.value.length || ($4bbf7ba23c3835e3$var$_(e, t), q.current.setCaretTimeout = setTimeout(function() {
            e.value === n && e.selectionStart !== t && $4bbf7ba23c3835e3$var$_(e, t);
        }, 0));
    }, X = function(e, t, n) {
        return $4bbf7ba23c3835e3$var$E(e, t, P(e), n);
    }, Z = function(e, t, n) {
        var r = P(t), i = $4bbf7ba23c3835e3$var$ee(t, z, e, n, r, F, ie);
        return i = $4bbf7ba23c3835e3$var$E(t, i, r), i;
    }, ce = function(e) {
        var t = e.formattedValue;
        t === void 0 && (t = "");
        var n = e.input, r = e.source, i = e.event, a = e.numAsString, o;
        if (n) {
            var s = e.inputValue || n.value, c = $4bbf7ba23c3835e3$var$x(n);
            n.value = t, o = Z(s, t, c), o !== void 0 && Y(n, o, t);
        }
        t !== z && W(J(t, a), {
            event: i,
            source: r
        });
    };
    (0, $lCzvA.useEffect)(function() {
        var e = U.current, t = e.formattedValue, n = e.numAsString;
        (z !== t || B !== n) && W(J(z, B), {
            event: void 0,
            source: $4bbf7ba23c3835e3$var$s.props
        });
    }, [
        z,
        B
    ]);
    var le = K.current ? $4bbf7ba23c3835e3$var$x(K.current) : void 0;
    (typeof window < "u" ? (0, $lCzvA.useLayoutEffect) : (0, $lCzvA.useEffect))(function() {
        var e = K.current;
        if (z !== U.current.formattedValue && e) {
            var t = Z(U.current.formattedValue, z, le);
            e.value = z, Y(e, t, z);
        }
    }, [
        z
    ]);
    var ue = function(e, t, n) {
        var r = t.target, i = H.current ? $4bbf7ba23c3835e3$var$y(H.current, r.selectionEnd) : $4bbf7ba23c3835e3$var$v(z, e), a = Object.assign(Object.assign({}, i), {
            lastValue: z
        }), o = g(e, a), s = se(o);
        if (o = g(s, void 0), T && !T(J(s, o))) {
            var c = t.target, l = Z(e, z, $4bbf7ba23c3835e3$var$x(c));
            return c.value = z, Y(c, l, z), !1;
        }
        return ce({
            formattedValue: s,
            numAsString: o,
            inputValue: e,
            event: t,
            source: n,
            input: t.target
        }), !0;
    }, Q = function(e, t) {
        t === void 0 && (t = 0), H.current = {
            selectionStart: e.selectionStart,
            selectionEnd: e.selectionEnd + t
        };
    }, de = function(e) {
        var t = e.target.value;
        ue(t, e, $4bbf7ba23c3835e3$var$s.event) && O(e), H.current = void 0;
    }, fe = function(e) {
        var t = e.target, n = e.key, r = t.selectionStart, i = t.selectionEnd, a = t.value;
        a === void 0 && (a = "");
        var o;
        n === "ArrowLeft" || n === "Backspace" ? o = Math.max(r - 1, 0) : n === "ArrowRight" ? o = Math.min(r + 1, a.length) : n === "Delete" && (o = r);
        var s = 0;
        n === "Delete" && r === i && (s = 1);
        var c = n === "ArrowLeft" || n === "ArrowRight";
        if (o === void 0 || r !== i && !c) {
            k(e), Q(t, s);
            return;
        }
        var l = o;
        c ? (l = X(a, o, n === "ArrowLeft" ? "left" : "right"), l !== o && e.preventDefault()) : n === "Delete" && !F(a[o]) ? l = X(a, o, "right") : n === "Backspace" && !F(a[o]) && (l = X(a, o, "left")), l !== o && Y(t, l, a), k(e), Q(t, s);
    }, pe = function(e) {
        var t = e.target, n = function() {
            var e = t.selectionStart, n = t.selectionEnd, r = t.value;
            if (r === void 0 && (r = ""), e === n) {
                var i = X(r, e);
                i !== e && Y(t, i, r);
            }
        };
        n(), requestAnimationFrame(function() {
            n();
        }), A(e), Q(t);
    }, me = function(e) {
        e.persist && e.persist();
        var t = e.target, n = e.currentTarget;
        K.current = t, q.current.focusTimeout = setTimeout(function() {
            var r = t.selectionStart, i = t.selectionEnd, a = t.value;
            a === void 0 && (a = "");
            var o = X(a, r);
            o !== r && !(r === 0 && i === a.length) && Y(t, o, a), j(Object.assign(Object.assign({}, e), {
                currentTarget: n
            }));
        }, 0);
    }, he = function(e) {
        K.current = null, clearTimeout(q.current.focusTimeout), clearTimeout(q.current.setCaretTimeout), M(e);
    }, ge = ae && $4bbf7ba23c3835e3$var$S() ? "numeric" : void 0, $ = Object.assign({
        inputMode: ge
    }, I, {
        type: l,
        value: z,
        onChange: de,
        onKeyDown: fe,
        onMouseUp: pe,
        onFocus: me,
        onBlur: he
    });
    if (d === "text") return p ? (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).Fragment, null, p(z, I) || null) : (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("span", Object.assign({}, I, {
        ref: m
    }), z);
    if (f) {
        var _e = f;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement(_e, Object.assign({}, $, {
            ref: m
        }));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("input", Object.assign({}, $, {
        ref: m
    }));
}
function $4bbf7ba23c3835e3$export$4b8d05d749baae10(e, t) {
    var n = t.format, r = t.allowEmptyFormatting, i = t.mask, a = t.patternChar;
    if (a === void 0 && (a = "#"), e === "" && !r) return "";
    for(var o = 0, s = n.split(""), c = 0, l = n.length; c < l; c++)n[c] === a && (s[c] = e[o] || $4bbf7ba23c3835e3$var$w(i, o), o += 1);
    return s.join("");
}
function $4bbf7ba23c3835e3$export$63600a84c223a8ea(e, t, n) {
    t === void 0 && (t = $4bbf7ba23c3835e3$var$C(e));
    var r = n.format, i = n.patternChar;
    i === void 0 && (i = "#");
    var a = t.from, o = t.to, s = t.lastValue;
    s === void 0 && (s = "");
    var c = function(e) {
        return r[e] === i;
    }, l = function(e, t) {
        for(var n = "", r = 0; r < e.length; r++)c(t + r) && $4bbf7ba23c3835e3$var$u(e[r]) && (n += e[r]);
        return n;
    }, d = function(e) {
        return e.replace(/[^0-9]/g, "");
    };
    if (!r.match(/\d/)) return d(e);
    if ((s === "" || a.end - a.start === s.length) && e.length === r.length) {
        for(var f = "", p = 0; p < e.length; p++)if (c(p)) $4bbf7ba23c3835e3$var$u(e[p]) && (f += e[p]);
        else if (e[p] !== r[p]) return d(e);
        return f;
    }
    var m = s.substring(0, a.start), h = e.substring(o.start, o.end), g = s.substring(a.end);
    return "" + l(m, 0) + d(h) + l(g, a.end);
}
function $4bbf7ba23c3835e3$export$cbab503a3360c264(e, t) {
    var n = t.format, r = t.mask, i = t.patternChar;
    i === void 0 && (i = "#");
    var a = Array.from({
        length: e.length + 1
    }).map(function() {
        return !0;
    }), o = 0, s = -1, c = {};
    n.split("").forEach(function(t, n) {
        var a = void 0;
        t === i && (o++, a = $4bbf7ba23c3835e3$var$w(r, o - 1), s === -1 && e[n] === a && (s = n)), c[n] = a;
    });
    for(var l = function(t) {
        return n[t] === i && e[t] !== c[t];
    }, u = 0, d = a.length; u < d; u++)a[u] = u === s || l(u) || l(u - 1);
    return a[n.indexOf(i)] = !0, a;
}
function $4bbf7ba23c3835e3$var$M(e) {
    var t = e.mask;
    if (t && (t === "string" ? t : t.toString()).match(/\d/g)) throw Error("Mask " + t + " should not contain numeric character;");
}
function $4bbf7ba23c3835e3$var$N(e, t) {
    return e === "" || !t?.match(/\d/) && typeof e == "string" && (!!e.match(/^\d+$/) || e === "");
}
function $4bbf7ba23c3835e3$export$1290cfe2185b28c0(e) {
    e.mask, e.allowEmptyFormatting;
    var t = e.format, n = e.inputMode;
    n === void 0 && (n = "numeric");
    var r = e.onKeyDown;
    r === void 0 && (r = $4bbf7ba23c3835e3$var$c);
    var i = e.patternChar;
    i === void 0 && (i = "#");
    var a = e.value, s = e.defaultValue, l = e.valueIsNumericString, u = $4bbf7ba23c3835e3$var$o(e, [
        "mask",
        "allowEmptyFormatting",
        "format",
        "inputMode",
        "onKeyDown",
        "patternChar",
        "value",
        "defaultValue",
        "valueIsNumericString"
    ]);
    $4bbf7ba23c3835e3$var$M(e);
    var f = function(t) {
        return $4bbf7ba23c3835e3$export$cbab503a3360c264(t, e);
    }, p = function(e) {
        var n = e.key, a = e.target, o = a.selectionStart, s = a.selectionEnd, c = a.value;
        if (o !== s) {
            r(e);
            return;
        }
        var l = o;
        if (n === "Backspace" || n === "Delete") {
            var u = "right";
            if (n === "Backspace") {
                for(; l > 0 && t[l - 1] !== i;)l--;
                u = "left";
            } else {
                for(var d = t.length; l < d && t[l] !== i;)l++;
                u = "right";
            }
            l = $4bbf7ba23c3835e3$var$E(c, l, f(c), u);
        } else t[l] !== i && n !== "ArrowLeft" && n !== "ArrowRight" && (l = $4bbf7ba23c3835e3$var$E(c, l + 1, f(c), "right"));
        l !== o && $4bbf7ba23c3835e3$var$_(a, l), r(e);
    }, m = $4bbf7ba23c3835e3$var$d(a) ? s : a, h = l ?? $4bbf7ba23c3835e3$var$N(m, t), g = Object.assign(Object.assign({}, e), {
        valueIsNumericString: h
    });
    return Object.assign(Object.assign({}, u), {
        value: a,
        defaultValue: s,
        valueIsNumericString: h,
        inputMode: n,
        format: function(e) {
            return $4bbf7ba23c3835e3$export$4b8d05d749baae10(e, g);
        },
        removeFormatting: function(e, t) {
            return $4bbf7ba23c3835e3$export$63600a84c223a8ea(e, t, g);
        },
        getCaretBoundary: f,
        onKeyDown: p
    });
}
function $4bbf7ba23c3835e3$export$9e8c774149e1782b(t) {
    var n = $4bbf7ba23c3835e3$export$1290cfe2185b28c0(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($4bbf7ba23c3835e3$export$dd1caf9b8ccbc158, Object.assign({}, n));
}




var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/TextInput/index.jsx
var $67004894d25c93a4$export$2e2bcd8739ae039 = (0, $lCzvA.forwardRef)(function({ labelText: o, hideLabel: d, type: f = "text", id: p, className: m, containerClass: h, assistiveText: g, iconLeft: _, iconRight: v, error: y, helpText: b, tooltipContent: x, tooltipPosition: S = "bottom", ...C }, w) {
    let T = (0, $lCzvA.useRef)(null), [E, D] = (0, $49d3c8472e20c2b5$export$cbe85ee05b554577)(!0), O = {
        ...C
    }, k = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-FormGroup relative mb-4": !0,
        [h]: h
    }), A = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-TextInput sash-input": !0,
        "border-red-700": y,
        "pl-11": _,
        "pr-11": v,
        [m]: m
    }), j = (e)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
            type: e,
            id: p,
            name: p,
            className: A,
            ref: w,
            ...C
        });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        ref: T,
        className: k,
        "data-testid": "sash-input",
        children: [
            (o || b || g) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $353df793a3a1d2b7$export$2e2bcd8739ae039), {
                id: p,
                labelText: o,
                hideLabel: d,
                required: O.required,
                error: !!y,
                assistiveText: g,
                helpText: b,
                tooltipContent: x,
                tooltipPosition: S
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: "relative",
                children: [
                    f !== "password" && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                        children: [
                            O.format ? ((e)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4bbf7ba23c3835e3$export$9e8c774149e1782b), {
                                    type: e,
                                    id: p,
                                    name: p,
                                    className: A,
                                    getInputRef: w,
                                    ...C
                                }))(f) : j(f),
                            _ && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                className: "absolute top-0 left-0 flex h-full items-center justify-center px-3 text-sm leading-none text-neutral-700",
                                children: _
                            }),
                            v && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                className: "absolute top-0 right-0 flex h-full items-center justify-center px-3 text-sm leading-none text-neutral-700",
                                children: v
                            })
                        ]
                    }),
                    f === "password" && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                        children: [
                            j(E ? "password" : "text"),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                                type: "button",
                                className: "absolute top-0 right-0 flex h-full cursor-pointer items-center justify-center px-3 leading-none",
                                onClick: D,
                                "aria-label": "Toggle password visibility",
                                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                    name: E ? "visibility_off" : "visibility"
                                })
                            })
                        ]
                    })
                ]
            }),
            typeof y == "string" && !!y && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $71efe153e5175f41$export$2e2bcd8739ae039), {
                type: "error",
                className: "mt-2",
                message: y,
                inline: !0
            })
        ]
    });
});


const $499108432d0848f8$export$585e557b64b9df0e = 'FIXED_BY_SUBMITTER';
const $499108432d0848f8$export$5d789bb7ceeee381 = 'TESTING';
const $499108432d0848f8$export$d46a05f8561f868a = 'OTHER';
const $499108432d0848f8$export$2ee6b98dd67ebc76 = {
    FIXED_BY_SUBMITTER: $499108432d0848f8$export$585e557b64b9df0e,
    TESTING: $499108432d0848f8$export$5d789bb7ceeee381,
    OTHER: $499108432d0848f8$export$d46a05f8561f868a
};
const $499108432d0848f8$var$reasonOptions = [
    {
        value: $499108432d0848f8$export$585e557b64b9df0e,
        labelKey: 'reasonFixedProblem'
    },
    {
        value: $499108432d0848f8$export$5d789bb7ceeee381,
        labelKey: 'reasonTrainingTesting'
    },
    {
        value: $499108432d0848f8$export$d46a05f8561f868a,
        labelKey: 'reasonOther'
    }
];
/**
 * Dialog for selecting a cancellation reason.
 * Allows users to select from predefined reasons and optionally provide additional details.
 * @param {object} props - Component props
 * @param {boolean} props.isOpen - Whether the dialog is open
 * @param {() => void} props.onClose - Callback when dialog is closed
 * @param {(reason: string, details: string) => void} props.onConfirm - Callback when user confirms selection with parameters (reason, details)
 * @returns {import("react").ReactElement} Cancellation reason dialog component
 */ const $499108432d0848f8$var$CancellationReasonDialog = ({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm })=>{
    const { t: t } = (0, $8216e3af17948d6d$export$9fc83ad70ead8663)();
    const [selectedReason, setSelectedReason] = (0, $lCzvA.useState)('');
    const [additionalDetails, setAdditionalDetails] = (0, $lCzvA.useState)('');
    const handleReasonChange = (event)=>{
        const value = event.target.value;
        setSelectedReason(value);
        if (value !== $499108432d0848f8$export$d46a05f8561f868a) setAdditionalDetails('');
    };
    const handleConfirm = ()=>{
        // The OK button is disabled when selectedReason is empty, so the else path
        // is unreachable through normal UI interaction — guard exists for safety.
        /* istanbul ignore else */ if (selectedReason) {
            onConfirm(selectedReason, additionalDetails);
            setSelectedReason('');
            setAdditionalDetails('');
        }
    };
    const handleClose = ()=>{
        onClose();
        setSelectedReason('');
        setAdditionalDetails('');
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
        open: isOpen,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                    children: t('selectClosureReasonTitle')
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                            children: t('selectClosureReasonParagraph')
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            id: "cancellation-reason-select",
                            labelText: t('reasonLabel'),
                            value: selectedReason,
                            onChange: handleReasonChange,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: t('notSelected')
                                }),
                                $499108432d0848f8$var$reasonOptions.map((option)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: option.value,
                                        children: t(option.labelKey)
                                    }, option.value))
                            ]
                        }),
                        selectedReason === $499108432d0848f8$export$d46a05f8561f868a && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                            id: "additional-details",
                            labelText: t('additionalDetails'),
                            value: additionalDetails,
                            onChange: (e)=>setAdditionalDetails(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            size: "sm",
                            color: "secondary",
                            onClick: handleClose,
                            children: t('cancel')
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            size: "sm",
                            color: "primary",
                            onClick: handleConfirm,
                            disabled: !selectedReason,
                            children: t('okButton')
                        })
                    ]
                })
            ]
        })
    });
};
var $499108432d0848f8$export$2e2bcd8739ae039 = $499108432d0848f8$var$CancellationReasonDialog;






var $lCzvA = parcelRequire("lCzvA");
const $374387492e5ecf18$export$2a906a465bc0277e = [
    {
        item: 'setups-reorders-actions',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Attribute\n2 - Bulk Copy\n3 - Manage Attribute Destination Assignments\n4 - Delete the Attribute',
                img: '/images/help/reorder-attributes.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-stations',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Station\n2 - Manage the Reason Filters\n3 - Delete the Station',
                img: '/images/help/reorder-stations.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-users',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the User\n2 - Reset Password\n3 - Manage User Roles\n4 - Delete the User',
                img: '/images/help/reorder-users.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-roles',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Role\n2 - Manage Role Permissions\n3 - Delete the Role',
                img: '/images/help/reorder-roles.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-permissions',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Permission\n2 - Assign Permission to Role\n3 - Remove Permission from Role',
                img: '/images/help/reorder-permissions.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-customers',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Customer\n2 - Manage Customer Groups\n3 - Delete the Customer',
                img: '/images/help/reorder-customers.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-suppliers',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Supplier\n2 - Manage Supplier Products\n3 - Delete the Supplier',
                img: '/images/help/reorder-suppliers.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-products',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Product\n2 - Manage Product Categories\n3 - Delete the Product',
                img: '/images/help/reorder-products.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-orders',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Order\n2 - Manage Order Status\n3 - Delete the Order',
                img: '/images/help/reorder-orders.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-invoices',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Invoice\n2 - Manage Invoice Items\n3 - Delete the Invoice',
                img: '/images/help/reorder-invoices.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-shipments',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Shipment\n2 - Manage Shipment Tracking\n3 - Delete the Shipment',
                img: '/images/help/reorder-shipments.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-payments',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Payment\n2 - Manage Payment Methods\n3 - Delete the Payment',
                img: '/images/help/reorder-payments.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-reports',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Report\n2 - Manage Report Filters\n3 - Delete the Report',
                img: '/images/help/reorder-reports.png',
                access: null
            }
        ]
    },
    {
        item: 'setups-reorders-settings',
        steps: [
            {
                title: 'Actions',
                text: '1 - Edit the Setting\n2 - Manage Setting Values\n3 - Delete the Setting',
                img: '/images/help/reorder-settings.png',
                access: null
            }
        ]
    }
];















var $lCzvA = parcelRequire("lCzvA");

//#region node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
var $7e7d39f444eccb26$export$f23ec2f542b3b173 = Object.freeze({
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal"
}), $7e7d39f444eccb26$var$i = "VisuallyHidden", $7e7d39f444eccb26$export$439d29a4e110a164 = $lCzvA.forwardRef((t, i)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).span, {
        ...t,
        ref: i,
        style: {
            ...$7e7d39f444eccb26$export$f23ec2f542b3b173,
            ...t.style
        }
    }));
$7e7d39f444eccb26$export$439d29a4e110a164.displayName = $7e7d39f444eccb26$var$i;
var $7e7d39f444eccb26$export$be92b6f5f03c0fe9 = $7e7d39f444eccb26$export$439d29a4e110a164;



var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region node_modules/@radix-ui/react-tooltip/dist/index.mjs
var [$aeab8b26fbd44dc7$var$y, $aeab8b26fbd44dc7$var$b] = (0, $0641488beac2d3c3$export$50c7b4e9d9f19c1)("Tooltip", [
    (0, $672ed53bf52c8f1f$export$722aac194ae923)
]), $aeab8b26fbd44dc7$var$x = (0, $672ed53bf52c8f1f$export$722aac194ae923)(), $aeab8b26fbd44dc7$var$S = "TooltipProvider", $aeab8b26fbd44dc7$var$C = 700, $aeab8b26fbd44dc7$var$w = "tooltip.open", [$aeab8b26fbd44dc7$var$T, $aeab8b26fbd44dc7$var$E] = $aeab8b26fbd44dc7$var$y($aeab8b26fbd44dc7$var$S), $aeab8b26fbd44dc7$export$f78649fb9ca566b8 = (e)=>{
    let { __scopeTooltip: t, delayDuration: n = $aeab8b26fbd44dc7$var$C, skipDelayDuration: r = 300, disableHoverableContent: i = !1, children: a } = e, o = $lCzvA.useRef(!0), s = $lCzvA.useRef(!1), c = $lCzvA.useRef(0);
    return $lCzvA.useEffect(()=>{
        let e = c.current;
        return ()=>window.clearTimeout(e);
    }, []), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($aeab8b26fbd44dc7$var$T, {
        scope: t,
        isOpenDelayedRef: o,
        delayDuration: n,
        onOpen: $lCzvA.useCallback(()=>{
            r <= 0 || (window.clearTimeout(c.current), o.current = !1);
        }, [
            r
        ]),
        onClose: $lCzvA.useCallback(()=>{
            r <= 0 || (window.clearTimeout(c.current), c.current = window.setTimeout(()=>o.current = !0, r));
        }, [
            r
        ]),
        isPointerInTransitRef: s,
        onPointerInTransitChange: $lCzvA.useCallback((e)=>{
            s.current = e;
        }, []),
        disableHoverableContent: i,
        children: a
    });
};
$aeab8b26fbd44dc7$export$f78649fb9ca566b8.displayName = $aeab8b26fbd44dc7$var$S;
var $aeab8b26fbd44dc7$var$O = "Tooltip", [$aeab8b26fbd44dc7$var$k, $aeab8b26fbd44dc7$var$A] = $aeab8b26fbd44dc7$var$y($aeab8b26fbd44dc7$var$O), $aeab8b26fbd44dc7$export$28c660c63b792dea = (e)=>{
    let { __scopeTooltip: t, children: n, open: a, defaultOpen: o, onOpenChange: s, disableHoverableContent: c, delayDuration: l } = e, u = $aeab8b26fbd44dc7$var$E($aeab8b26fbd44dc7$var$O, e.__scopeTooltip), d = $aeab8b26fbd44dc7$var$x(t), [f, m] = $lCzvA.useState(null), h = (0, $2505f25f517c82fa$export$f680877a34711e37)(), v = $lCzvA.useRef(0), y = c ?? u.disableHoverableContent, b = l ?? u.delayDuration, S = $lCzvA.useRef(!1), [C, T] = (0, $0d3099c8ce39feb9$export$6f32135080cb4c3)({
        prop: a,
        defaultProp: o ?? !1,
        onChange: (e)=>{
            e ? (u.onOpen(), document.dispatchEvent(new CustomEvent($aeab8b26fbd44dc7$var$w))) : u.onClose(), s?.(e);
        },
        caller: $aeab8b26fbd44dc7$var$O
    }), D = $lCzvA.useMemo(()=>C ? S.current ? "delayed-open" : "instant-open" : "closed", [
        C
    ]), A = $lCzvA.useCallback(()=>{
        window.clearTimeout(v.current), v.current = 0, S.current = !1, T(!0);
    }, [
        T
    ]), j = $lCzvA.useCallback(()=>{
        window.clearTimeout(v.current), v.current = 0, T(!1);
    }, [
        T
    ]), M = $lCzvA.useCallback(()=>{
        window.clearTimeout(v.current), v.current = window.setTimeout(()=>{
            S.current = !0, T(!0), v.current = 0;
        }, b);
    }, [
        b,
        T
    ]);
    return $lCzvA.useEffect(()=>()=>{
            v.current &&= (window.clearTimeout(v.current), 0);
        }, []), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $672ed53bf52c8f1f$export$be92b6f5f03c0fe9), {
        ...d,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($aeab8b26fbd44dc7$var$k, {
            scope: t,
            contentId: h,
            open: C,
            stateAttribute: D,
            trigger: f,
            onTriggerChange: m,
            onTriggerEnter: $lCzvA.useCallback(()=>{
                u.isOpenDelayedRef.current ? M() : A();
            }, [
                u.isOpenDelayedRef,
                M,
                A
            ]),
            onTriggerLeave: $lCzvA.useCallback(()=>{
                y ? j() : (window.clearTimeout(v.current), v.current = 0);
            }, [
                j,
                y
            ]),
            onOpen: A,
            onClose: j,
            disableHoverableContent: y,
            children: n
        })
    });
};
$aeab8b26fbd44dc7$export$28c660c63b792dea.displayName = $aeab8b26fbd44dc7$var$O;
var $aeab8b26fbd44dc7$var$M = "TooltipTrigger", $aeab8b26fbd44dc7$export$8c610744efcf8a1d = $lCzvA.forwardRef((n, r)=>{
    let { __scopeTooltip: i, ...a } = n, s = $aeab8b26fbd44dc7$var$A($aeab8b26fbd44dc7$var$M, i), c = $aeab8b26fbd44dc7$var$E($aeab8b26fbd44dc7$var$M, i), l = $aeab8b26fbd44dc7$var$x(i), d = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(r, $lCzvA.useRef(null), s.onTriggerChange), f = $lCzvA.useRef(!1), p = $lCzvA.useRef(!1), m = $lCzvA.useCallback(()=>f.current = !1, []);
    return $lCzvA.useEffect(()=>()=>document.removeEventListener("pointerup", m), [
        m
    ]), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $672ed53bf52c8f1f$export$b688253958b8dfe7), {
        asChild: !0,
        ...l,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3fe2937b6970d85d$export$250ffa63cdc0d034).button, {
            "aria-describedby": s.open ? s.contentId : void 0,
            "data-state": s.stateAttribute,
            ...a,
            ref: d,
            onPointerMove: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onPointerMove, (e)=>{
                e.pointerType !== "touch" && !p.current && !c.isPointerInTransitRef.current && (s.onTriggerEnter(), p.current = !0);
            }),
            onPointerLeave: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onPointerLeave, ()=>{
                s.onTriggerLeave(), p.current = !1;
            }),
            onPointerDown: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onPointerDown, ()=>{
                s.open && s.onClose(), f.current = !0, document.addEventListener("pointerup", m, {
                    once: !0
                });
            }),
            onFocus: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onFocus, ()=>{
                f.current || s.onOpen();
            }),
            onBlur: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onBlur, s.onClose),
            onClick: (0, $9456f9398283d0f7$export$b9ecd428b558ff10)(n.onClick, s.onClose)
        })
    });
});
$aeab8b26fbd44dc7$export$8c610744efcf8a1d.displayName = $aeab8b26fbd44dc7$var$M;
var $aeab8b26fbd44dc7$var$P = "TooltipPortal", [$aeab8b26fbd44dc7$var$F, $aeab8b26fbd44dc7$var$I] = $aeab8b26fbd44dc7$var$y($aeab8b26fbd44dc7$var$P, {
    forceMount: void 0
}), $aeab8b26fbd44dc7$export$7b36b8f925ab7497 = (e)=>{
    let { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, a = $aeab8b26fbd44dc7$var$A($aeab8b26fbd44dc7$var$P, t);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($aeab8b26fbd44dc7$var$F, {
        scope: t,
        forceMount: n,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0682faac15a06e68$export$99c2b779aa4e8b8b), {
            present: n || a.open,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9bc4a16530321c60$export$602eac185826482c), {
                asChild: !0,
                container: i,
                children: r
            })
        })
    });
};
$aeab8b26fbd44dc7$export$7b36b8f925ab7497.displayName = $aeab8b26fbd44dc7$var$P;
var $aeab8b26fbd44dc7$var$R = "TooltipContent", $aeab8b26fbd44dc7$export$e9003e2be37ec060 = $lCzvA.forwardRef((e, t)=>{
    let n = $aeab8b26fbd44dc7$var$I($aeab8b26fbd44dc7$var$R, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...a } = e, o = $aeab8b26fbd44dc7$var$A($aeab8b26fbd44dc7$var$R, e.__scopeTooltip);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0682faac15a06e68$export$99c2b779aa4e8b8b), {
        present: r || o.open,
        children: o.disableHoverableContent ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($aeab8b26fbd44dc7$var$W, {
            side: i,
            ...a,
            ref: t
        }) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($aeab8b26fbd44dc7$var$B, {
            side: i,
            ...a,
            ref: t
        })
    });
}), $aeab8b26fbd44dc7$var$B = $lCzvA.forwardRef((e, n)=>{
    let r = $aeab8b26fbd44dc7$var$A($aeab8b26fbd44dc7$var$R, e.__scopeTooltip), i = $aeab8b26fbd44dc7$var$E($aeab8b26fbd44dc7$var$R, e.__scopeTooltip), a = $lCzvA.useRef(null), o = (0, $c4d50d88a15d3346$export$c7b2cbe3552a0d05)(n, a), [s, c] = $lCzvA.useState(null), { trigger: l, onClose: u } = r, d = a.current, { onPointerInTransitChange: f } = i, p = $lCzvA.useCallback(()=>{
        c(null), f(!1);
    }, [
        f
    ]), m = $lCzvA.useCallback((e, t)=>{
        let n = e.currentTarget, r = {
            x: e.clientX,
            y: e.clientY
        }, i = $aeab8b26fbd44dc7$var$J(r, $aeab8b26fbd44dc7$var$q(r, n.getBoundingClientRect())), a = $aeab8b26fbd44dc7$var$Y(t.getBoundingClientRect()), o = $aeab8b26fbd44dc7$var$Z([
            ...i,
            ...a
        ]);
        c(o), f(!0);
    }, [
        f
    ]);
    return $lCzvA.useEffect(()=>()=>p(), [
        p
    ]), $lCzvA.useEffect(()=>{
        if (l && d) {
            let e = (e)=>m(e, d), t = (e)=>m(e, l);
            return l.addEventListener("pointerleave", e), d.addEventListener("pointerleave", t), ()=>{
                l.removeEventListener("pointerleave", e), d.removeEventListener("pointerleave", t);
            };
        }
    }, [
        l,
        d,
        m,
        p
    ]), $lCzvA.useEffect(()=>{
        if (s) {
            let e = (e)=>{
                let t = e.target, n = {
                    x: e.clientX,
                    y: e.clientY
                }, r = l?.contains(t) || d?.contains(t), i = !$aeab8b26fbd44dc7$var$X(n, s);
                r ? p() : i && (p(), u());
            };
            return document.addEventListener("pointermove", e), ()=>document.removeEventListener("pointermove", e);
        }
    }, [
        l,
        d,
        s,
        u,
        p
    ]), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($aeab8b26fbd44dc7$var$W, {
        ...e,
        ref: o
    });
}), [$aeab8b26fbd44dc7$var$V, $aeab8b26fbd44dc7$var$H] = $aeab8b26fbd44dc7$var$y($aeab8b26fbd44dc7$var$O, {
    isInside: !1
}), $aeab8b26fbd44dc7$var$U = (0, $09f52881d5dae1cd$export$bf68c29d8281d0f7)("TooltipContent"), $aeab8b26fbd44dc7$var$W = $lCzvA.forwardRef((e, t)=>{
    let { __scopeTooltip: n, children: r, "aria-label": i, onEscapeKeyDown: a, onPointerDownOutside: o, ...c } = e, l = $aeab8b26fbd44dc7$var$A($aeab8b26fbd44dc7$var$R, n), u = $aeab8b26fbd44dc7$var$x(n), { onClose: d } = l;
    return $lCzvA.useEffect(()=>(document.addEventListener($aeab8b26fbd44dc7$var$w, d), ()=>document.removeEventListener($aeab8b26fbd44dc7$var$w, d)), [
        d
    ]), $lCzvA.useEffect(()=>{
        if (l.trigger) {
            let e = (e)=>{
                e.target instanceof Node && e.target.contains(l.trigger) && d();
            };
            return window.addEventListener("scroll", e, {
                capture: !0
            }), ()=>window.removeEventListener("scroll", e, {
                    capture: !0
                });
        }
    }, [
        l.trigger,
        d
    ]), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fb04d4ce1fe91315$export$177fb62ff3ec1f22), {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: o,
        onFocusOutside: (e)=>e.preventDefault(),
        onDismiss: d,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $672ed53bf52c8f1f$export$7c6e2c02157bb7d2), {
            "data-state": l.stateAttribute,
            ...u,
            ...c,
            ref: t,
            style: {
                ...c.style,
                "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
                "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
                "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
                /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($aeab8b26fbd44dc7$var$U, {
                    children: r
                }),
                /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($aeab8b26fbd44dc7$var$V, {
                    scope: n,
                    isInside: !0,
                    children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7e7d39f444eccb26$export$be92b6f5f03c0fe9), {
                        id: l.contentId,
                        role: "tooltip",
                        children: i || r
                    })
                })
            ]
        })
    });
});
$aeab8b26fbd44dc7$export$e9003e2be37ec060.displayName = $aeab8b26fbd44dc7$var$R;
var $aeab8b26fbd44dc7$var$G = "TooltipArrow", $aeab8b26fbd44dc7$export$c27ee0ad710f7559 = $lCzvA.forwardRef((e, t)=>{
    let { __scopeTooltip: n, ...r } = e, i = $aeab8b26fbd44dc7$var$x(n);
    return $aeab8b26fbd44dc7$var$H($aeab8b26fbd44dc7$var$G, n).isInside ? null : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $672ed53bf52c8f1f$export$21b07c8f274aebd5), {
        ...i,
        ...r,
        ref: t
    });
});
$aeab8b26fbd44dc7$export$c27ee0ad710f7559.displayName = $aeab8b26fbd44dc7$var$G;
function $aeab8b26fbd44dc7$var$q(e, t) {
    let n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
    switch(Math.min(n, r, i, a)){
        case a:
            return "left";
        case i:
            return "right";
        case n:
            return "top";
        case r:
            return "bottom";
        default:
            throw Error("unreachable");
    }
}
function $aeab8b26fbd44dc7$var$J(e, t, n = 5) {
    let r = [];
    switch(t){
        case "top":
            r.push({
                x: e.x - n,
                y: e.y + n
            }, {
                x: e.x + n,
                y: e.y + n
            });
            break;
        case "bottom":
            r.push({
                x: e.x - n,
                y: e.y - n
            }, {
                x: e.x + n,
                y: e.y - n
            });
            break;
        case "left":
            r.push({
                x: e.x + n,
                y: e.y - n
            }, {
                x: e.x + n,
                y: e.y + n
            });
            break;
        case "right":
            r.push({
                x: e.x - n,
                y: e.y - n
            }, {
                x: e.x - n,
                y: e.y + n
            });
            break;
    }
    return r;
}
function $aeab8b26fbd44dc7$var$Y(e) {
    let { top: t, right: n, bottom: r, left: i } = e;
    return [
        {
            x: i,
            y: t
        },
        {
            x: n,
            y: t
        },
        {
            x: n,
            y: r
        },
        {
            x: i,
            y: r
        }
    ];
}
function $aeab8b26fbd44dc7$var$X(e, t) {
    let { x: n, y: r } = e, i = !1;
    for(let e = 0, a = t.length - 1; e < t.length; a = e++){
        let o = t[e], s = t[a], c = o.x, l = o.y, u = s.x, d = s.y;
        l > r != d > r && n < (u - c) * (r - l) / (d - l) + c && (i = !i);
    }
    return i;
}
function $aeab8b26fbd44dc7$var$Z(e) {
    let t = e.slice();
    return t.sort((e, t)=>e.x < t.x ? -1 : e.x > t.x ? 1 : e.y < t.y ? -1 : +(e.y > t.y)), $aeab8b26fbd44dc7$var$Q(t);
}
function $aeab8b26fbd44dc7$var$Q(e) {
    if (e.length <= 1) return e.slice();
    let t = [];
    for(let n = 0; n < e.length; n++){
        let r = e[n];
        for(; t.length >= 2;){
            let e = t[t.length - 1], n = t[t.length - 2];
            if ((e.x - n.x) * (r.y - n.y) >= (e.y - n.y) * (r.x - n.x)) t.pop();
            else break;
        }
        t.push(r);
    }
    t.pop();
    let n = [];
    for(let t = e.length - 1; t >= 0; t--){
        let r = e[t];
        for(; n.length >= 2;){
            let e = n[n.length - 1], t = n[n.length - 2];
            if ((e.x - t.x) * (r.y - t.y) >= (e.y - t.y) * (r.x - t.x)) n.pop();
            else break;
        }
        n.push(r);
    }
    return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var $aeab8b26fbd44dc7$export$2881499e37b75b9a = $aeab8b26fbd44dc7$export$f78649fb9ca566b8, $aeab8b26fbd44dc7$export$be92b6f5f03c0fe9 = $aeab8b26fbd44dc7$export$28c660c63b792dea, $aeab8b26fbd44dc7$export$41fb9f06171c75f4 = $aeab8b26fbd44dc7$export$8c610744efcf8a1d, $aeab8b26fbd44dc7$export$602eac185826482c = $aeab8b26fbd44dc7$export$7b36b8f925ab7497, $aeab8b26fbd44dc7$export$7c6e2c02157bb7d2 = $aeab8b26fbd44dc7$export$e9003e2be37ec060;



//#region src/components/Tooltip/index.jsx
var $4f341de42b3721ba$export$2e2bcd8739ae039 = ({ children: r, delay: i = 100, ...a })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $aeab8b26fbd44dc7$export$2881499e37b75b9a), {
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $aeab8b26fbd44dc7$export$be92b6f5f03c0fe9), {
            delayDuration: i,
            ...a,
            children: r
        })
    });




//#region src/components/Tooltip/TooltipContent/index.jsx
var $69ca344c093705ef$export$2e2bcd8739ae039 = ({ children: i, className: a, position: o = "bottom", align: s = "center", offset: c = 5, ...l })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $aeab8b26fbd44dc7$export$602eac185826482c), {
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $aeab8b26fbd44dc7$export$7c6e2c02157bb7d2), {
            className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
                "sash-TooltipContent font-normal text-sm": !0,
                "flex flex-col bg-blue-100 max-w-[224px] max-h-[116px] py-2 px-3 rounded-sm shadow-hover overflow-hidden z-40": !0,
                [a]: a
            }),
            side: o,
            align: s,
            sideOffset: c,
            onPointerDownOutside: (e)=>{
                e.preventDefault();
            },
            ...l,
            children: i
        })
    });
$69ca344c093705ef$export$2e2bcd8739ae039.displayName = "TooltipContent";





//#region src/components/Tooltip/TooltipTrigger/index.jsx
var $147b0a927ae5f067$export$2e2bcd8739ae039 = ({ children: i, className: a, onClick: o, ...s })=>{
    let c = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-TooltipTrigger": !0,
        "flex size-10 items-center justify-center rounded-full text-blue-600 data-[state*=\"open\"]:bg-blue-100": !i,
        [a]: a
    }), l = (e)=>{
        e.preventDefault(), typeof o == "function" && o(e);
    };
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $aeab8b26fbd44dc7$export$41fb9f06171c75f4), {
        className: c,
        onClick: l,
        onPointerDown: l,
        ...s,
        children: i ?? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
            name: "info",
            size: 25
        })
    });
};
$147b0a927ae5f067$export$2e2bcd8739ae039.displayName = "TooltipTrigger";



var $78ff13a2d80870ca$exports = {};

$parcel$export($78ff13a2d80870ca$exports, "closeButton", function () { return $78ff13a2d80870ca$export$efe229eab43a9869; }, function (v) { return $78ff13a2d80870ca$export$efe229eab43a9869 = v; });
$parcel$export($78ff13a2d80870ca$exports, "iconWrapper", function () { return $78ff13a2d80870ca$export$38e6d710c8ae6ec3; }, function (v) { return $78ff13a2d80870ca$export$38e6d710c8ae6ec3 = v; });
$parcel$export($78ff13a2d80870ca$exports, "noSelect", function () { return $78ff13a2d80870ca$export$e5671697bfcd1d76; }, function (v) { return $78ff13a2d80870ca$export$e5671697bfcd1d76 = v; });
$parcel$export($78ff13a2d80870ca$exports, "noSelectOverflow", function () { return $78ff13a2d80870ca$export$e2db8952e085c45f; }, function (v) { return $78ff13a2d80870ca$export$e2db8952e085c45f = v; });
$parcel$export($78ff13a2d80870ca$exports, "stepCounter", function () { return $78ff13a2d80870ca$export$c23c2863738ff86; }, function (v) { return $78ff13a2d80870ca$export$c23c2863738ff86 = v; });
var $78ff13a2d80870ca$export$efe229eab43a9869;
var $78ff13a2d80870ca$export$38e6d710c8ae6ec3;
var $78ff13a2d80870ca$export$e5671697bfcd1d76;
var $78ff13a2d80870ca$export$e2db8952e085c45f;
var $78ff13a2d80870ca$export$c23c2863738ff86;
$78ff13a2d80870ca$export$efe229eab43a9869 = `Otcj3W_closeButton`;
$78ff13a2d80870ca$export$38e6d710c8ae6ec3 = `Otcj3W_iconWrapper`;
$78ff13a2d80870ca$export$e5671697bfcd1d76 = `Otcj3W_noSelect`;
$78ff13a2d80870ca$export$e2db8952e085c45f = `Otcj3W_noSelectOverflow`;
$78ff13a2d80870ca$export$c23c2863738ff86 = `Otcj3W_stepCounter`;


const $e2bb55bcb551b0ee$var$AnyTooltipTrigger = /** @type {import('react').ElementType} */ (0, $147b0a927ae5f067$export$2e2bcd8739ae039);
const $e2bb55bcb551b0ee$var$AnyModalHeader = /** @type {import('react').ElementType} */ (0, $9761f0447406a76c$export$2e2bcd8739ae039);
/**
 * Help component that provides contextual help with multi-step dialogs.
 * Displays help content with navigation between steps and access control.
 * @param {object} props - Component props
 * @param {string} props.item - The help item key to display
 * @param {object} props.access - Access control object for filtering help steps
 * @param {string} props.tip - Tooltip text to display on the help icon
 * @param {string} [props.width] - Dialog width (default: 'md')
 * @returns {import("react").ReactElement} Help component with icon and dialog
 */ const $e2bb55bcb551b0ee$var$Help = (props)=>{
    const { item: item, access: access, tip: tip } = props;
    const [open, setOpen] = (0, $lCzvA.useState)(false);
    const [helpItem, setHelpItem] = (0, $lCzvA.useState)(null);
    const [step, setStep] = (0, $lCzvA.useState)(null);
    const [animation, setAnimation] = (0, $lCzvA.useState)('');
    /**
   * Handle help icon click to open help dialog
   * Filters help content based on access permissions
   * @returns {void}
   */ const handleClick = ()=>{
        const foundItem = (0, $374387492e5ecf18$export$2a906a465bc0277e).find((i)=>i.item === item);
        if (!foundItem) return;
        const filteredSteps = foundItem.steps.filter((i)=>!i.access || access[i.access]);
        const tempItem = {
            ...foundItem,
            steps: filteredSteps
        };
        setHelpItem(tempItem);
        setStep(tempItem?.steps?.length > 0 ? 0 : null);
        setOpen(true);
    };
    /**
   * Handle navigation between help steps with animation
   * @param {string} action - Navigation action ('next' or 'back')
   * @returns {void}
   */ const stepChange = (action)=>{
        setAnimation('');
        let newStep;
        if (action === 'next') newStep = step === helpItem.steps.length - 1 ? 0 : step + 1;
        else newStep = step === 0 ? helpItem.steps.length - 1 : step - 1;
        setTimeout(()=>{
            setStep(newStep);
            setAnimation(action === 'next' ? 'help-in-from-right' : 'help-in-from-left');
        }, 10);
    };
    /**
   * Close the help dialog
   * @returns {void}
   */ const closeHelp = ()=>{
        setAnimation('');
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($78ff13a2d80870ca$exports))).iconWrapper,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f341de42b3721ba$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($e2bb55bcb551b0ee$var$AnyTooltipTrigger, {
                            asChild: true,
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                className: "help-icon",
                                iconLeft: "help",
                                onClick: handleClick
                            })
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $69ca344c093705ef$export$2e2bcd8739ae039), {
                            children: tip
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
                open: open,
                onOpenChange: closeHelp,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
                    showClose: false,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($e2bb55bcb551b0ee$var$AnyModalHeader, {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($78ff13a2d80870ca$exports))).noSelect,
                            children: [
                                helpItem?.steps[step]?.title,
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($78ff13a2d80870ca$exports))).closeButton,
                                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        className: "help-icon",
                                        onClick: closeHelp,
                                        iconLeft: "close"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($78ff13a2d80870ca$exports))).noSelectOverflow,
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: animation,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        children: helpItem?.steps[step]?.text?.split('\n').map((line, i, arr)=>// eslint-disable-next-line react/no-array-index-key
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                                children: [
                                                    line,
                                                    i < arr.length - 1 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("br", {})
                                                ]
                                            }, i))
                                    }),
                                    helpItem?.steps[step]?.img && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        className: "help-step-img",
                                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("img", {
                                            src: helpItem?.steps[step]?.img,
                                            alt: "broken img"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                            children: helpItem?.steps?.length > 1 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($78ff13a2d80870ca$exports))).stepCounter,
                                        children: [
                                            step + 1,
                                            " / ",
                                            helpItem?.steps?.length
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        className: "help-icon",
                                        onClick: ()=>stepChange('back'),
                                        iconLeft: "arrow_back_ios"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        className: "help-icon",
                                        onClick: ()=>stepChange('next'),
                                        iconLeft: "arrow_forward_ios"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $e2bb55bcb551b0ee$export$2e2bcd8739ae039 = $e2bb55bcb551b0ee$var$Help;








var $lCzvA = parcelRequire("lCzvA");



/**
 * Enum Array for the roles
 * @readonly
 * @enum {string}
 */ const $ceef8e61e2b9b160$export$d1cfdc29cbc61821 = {
    ADMINISTRATOR: 'ADMINISTRATOR',
    SUPER_USER: 'SUPER USER',
    USER: 'USER'
};
const $ceef8e61e2b9b160$export$9a2c3bcaa912c766 = {
    TEAM_MEMBER_APP_PREFERENCES: 'teamMemberAppPreferences',
    TEAM_MEMBER_DATA: 'teamMemberData',
    SITES: 'sites',
    SITE_INFO: 'siteInfo',
    INV_MGMT_COST_CENTER: 'invMgmtCostCenter',
    INV_MGMT_DIV_LOCATIONS: 'invMgmtDivLocations',
    INV_MGMT_DIVISIONS: 'invMgmtDivisions',
    INV_MGMT_LOCATIONS: 'invMgmtLocations',
    INV_MGMT_COST_CENTERS: 'invMgmtCostCenters',
    INV_MGMT_ACCOUNTS: 'invMgmtAccounts',
    INV_MGMT_SEGMENTS: 'invMgmtSegments',
    INV_MGMT_INTERCOMPS: 'invMgmtIntercomps',
    INV_MGMT_ORG_ITEMS: 'invMgmtOrgItems',
    INV_MGMT_ORG_ITEM_DETAIL: 'invMgmtOrgItemDetail',
    INV_MGMT_INV_LOCATIONS: 'invMgmtInvLocations',
    THRIVE_SPARE_PARTS: 'thriveSpareParts',
    THRIVE_PROJECTS: 'thriveProjects',
    THRIVE_EQUIPMENT: 'thriveEquipment',
    THRIVE_EMPLOYEE_USER_DEFAULTS: 'thriveEmployeeUserDefaults',
    THRIVE_EMPLOYEE_USER_STATUS: 'thriveEmployeeUserStatus',
    THRIVE_EQUIPMENT_BY_NUMBER: 'thriveEquipmentByNumber',
    MOVE_ORDER_DIST_ACCT_BY_CC: 'moveOrderDistAcctByCC',
    INV_MGMT_MRO_ORGANIZATIONS: 'invMgmtMROOrganizations',
    INV_MGMT_SUB_INVENTORIES: 'invMgmtSubInventories',
    MAINTENANCE_FOLLOW_UP_QUESTIONS: 'maintenanceFollowUpQuestions',
    USER_ANALYTICS_ROWS: 'userAnalyticsRows',
    USER_ANALYTICS_ROWS_COUNT: 'userAnalyticsRowsCount',
    USER_ANALYTICS_FILTER_OPTIONS: 'userAnalyticsFilterOptions',
    USER_ANALYTICS_ENGAGEMENT_SUMMARY: 'userAnalyticsEngagementSummary'
};


const $ac55920ec20a44c0$export$971fa481940b9588 = (cc)=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_COST_CENTER,
            cc
        ],
        // @ts-ignore
        queryFn: ()=>api.invMgmt.getCostCenter({
                cc: cc
            }),
        enabled: apiReady && Boolean(cc),
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        costCenter: data,
        costCenterIsLoading: isLoading,
        costCenterIsSuccess: isSuccess,
        costCenterIsError: isError,
        costCenterError: error
    };
};





const $3d0072a07f3cd4a9$export$34ecc72616849d94 = ()=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_DIVISIONS
        ],
        queryFn: ()=>api.invMgmt.getDivisions(),
        enabled: apiReady,
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        divisions: data,
        divisionsIsLoading: isLoading,
        divisionsIsSuccess: isSuccess,
        divisionsIsError: isError,
        divisionsError: error
    };
};





const $8b14602bb9192143$export$9c77921293a664cb = (divId)=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_DIV_LOCATIONS,
            divId
        ],
        queryFn: ()=>api.invMgmt.getSubInvLocations({
                division: divId
            }),
        enabled: apiReady && Boolean(divId),
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        divisionLocations: data,
        divisionLocationsIsLoading: isLoading,
        divisionLocationsIsSuccess: isSuccess,
        divisionLocationsIsError: isError,
        divisionLocationsError: error
    };
};





const $1f92358e6424da8a$export$813f23c9836d23b9 = (division, location)=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_COST_CENTERS,
            division,
            location
        ],
        queryFn: ()=>api.invMgmt.getCostCenters({
                division: division,
                location: location
            }),
        enabled: apiReady && Boolean(division) && Boolean(location),
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        costCenters: data,
        costCentersIsLoading: isLoading,
        costCentersIsSuccess: isSuccess,
        costCentersIsError: isError,
        costCentersError: error
    };
};





const $8f6704b684c9a5ac$export$c229550bd86eba85 = (division, location, costCenter)=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_ACCOUNTS,
            division,
            location,
            costCenter
        ],
        queryFn: ()=>api.invMgmt.getAccounts({
                division: division,
                location: location,
                costCenter: costCenter
            }),
        enabled: apiReady && Boolean(division) && Boolean(location) && Boolean(costCenter),
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        accounts: data,
        accountsIsLoading: isLoading,
        accountsIsSuccess: isSuccess,
        accountsIsError: isError,
        accountsError: error
    };
};





const $7f2b34b6291926d4$export$35888604389caffd = (division, location, costCenter, account)=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_SEGMENTS,
            division,
            location,
            costCenter,
            account
        ],
        queryFn: ()=>api.invMgmt.getSegments({
                division: division,
                location: location,
                costCenter: costCenter,
                account: account
            }),
        enabled: apiReady && Boolean(division) && Boolean(location) && Boolean(costCenter) && Boolean(account),
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        segments: data,
        segmentsIsLoading: isLoading,
        segmentsIsSuccess: isSuccess,
        segmentsIsError: isError,
        segmentsError: error
    };
};





const $f221e7e1619357d7$export$5fe20135af620e9b = (division, location, costCenter, account, segment)=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_INTERCOMPS,
            division,
            location,
            costCenter,
            account,
            segment
        ],
        queryFn: ()=>api.invMgmt.getInterComp({
                division: division,
                location: location,
                costCenter: costCenter,
                account: account,
                segment: segment
            }),
        enabled: apiReady && Boolean(division) && Boolean(location) && Boolean(costCenter) && Boolean(account) && Boolean(segment),
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        intercomps: data,
        intercompsIsLoading: isLoading,
        intercompsIsSuccess: isSuccess,
        intercompsIsError: isError,
        intercompsError: error
    };
};





const $719ab5841c6e6012$export$24bedf9a427a2503 = ({ orgId: orgId, item: item, descr: descr } = {})=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const numOrgId = Number(orgId);
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_ORG_ITEMS,
            numOrgId,
            item,
            descr
        ],
        queryFn: ()=>api.invMgmt.getInvItemKeyValues(numOrgId, {
                item: item,
                descr: descr
            }),
        enabled: apiReady && Boolean(orgId) && Number.isFinite(numOrgId) && (Boolean(item) || Boolean(descr)),
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        orgItems: data,
        orgItemsIsLoading: isLoading,
        orgItemsIsSuccess: isSuccess,
        orgItemsIsError: isError,
        orgItemsError: error
    };
};





const $f84cccd4c65d3ca8$export$bef1bfdc922bbbd5 = ({ orgId: orgId, itemId: itemId } = {})=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const numOrgId = Number(orgId);
    const numItemId = Number(itemId);
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_ORG_ITEM_DETAIL,
            numOrgId,
            numItemId
        ],
        queryFn: ()=>api.invMgmt.getInvItemDetails({
                orgId: numOrgId,
                itemId: numItemId
            }),
        enabled: apiReady && Boolean(orgId) && Boolean(itemId) && Number.isFinite(numOrgId) && Number.isFinite(numItemId),
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        orgItemDetail: data,
        orgItemDetailIsLoading: isLoading,
        orgItemDetailIsSuccess: isSuccess,
        orgItemDetailIsError: isError,
        orgItemDetailError: error
    };
};





const $2f9c61a9a15aa16d$export$2dad80eff99db31e = ()=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_INV_LOCATIONS
        ],
        queryFn: ()=>api.invMgmt.getOrgInvLocations(),
        enabled: apiReady,
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        invLocations: data,
        invLocationsIsLoading: isLoading,
        invLocationsIsSuccess: isSuccess,
        invLocationsIsError: isError,
        invLocationsError: error
    };
};





const $69b6c5a494e2d20c$export$1c1d2fc183df44cb = (costCenter)=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const fetchDistribution = async ()=>{
        const results = await api.invMgmt.getCostCenterDistribution(costCenter);
        if (!results) throw new Error(`No Distributions found for Cost Center: ${costCenter}`);
        return results;
    };
    const { data: data, error: error, isSuccess: isSuccess, isLoading: isLoading, isFetched: isFetched, isError: isError } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).MOVE_ORDER_DIST_ACCT_BY_CC,
            costCenter
        ],
        queryFn: fetchDistribution,
        enabled: apiReady && Boolean(costCenter),
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        data: data,
        error: error,
        isSuccess: isSuccess,
        isLoading: isLoading,
        isFetched: isFetched,
        isError: isError
    };
};





const $77687606fa35ccbc$export$a407559d686aac7 = ()=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    return (0, $957614eff0380312$export$609860bf8b0084c)({
        // Bypass _statusCheckedRequest so we get the full response body including
        // outBinds.message — cosmos-core throws before we can read the Oracle error detail.
        // @ts-ignore
        mutationFn: async ({ orgId: orgId, body: body })=>{
            const response = await api.invMgmt._api.post(`organizations/${orgId}/moveorders`, body);
            return response.data;
        },
        onError: (error)=>{
            // Only fires on network / HTTP-level failures
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(`Move order request failed: ${error.message}`);
        }
    });
};





const $7a152e40ba979840$export$91f3b828407c7fce = ()=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_MRO_ORGANIZATIONS
        ],
        queryFn: ()=>api.orgManagement.getOrganizations({
                mro: 'Y'
            }),
        enabled: apiReady,
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        mroOrgs: data,
        mroOrgsIsLoading: isLoading,
        mroOrgsIsSuccess: isSuccess,
        mroOrgsIsError: isError,
        mroOrgsError: error
    };
};





const $413d2c4be487de20$export$8ca49f6914a5ed0b = (orgId)=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const numOrgId = Number(orgId);
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).INV_MGMT_SUB_INVENTORIES,
            numOrgId
        ],
        queryFn: ()=>api.orgManagement.getOrgSubInvLocs({
                orgid: numOrgId
            }),
        enabled: apiReady && Boolean(orgId) && Number.isFinite(numOrgId),
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        subInventories: data,
        subInventoriesIsLoading: isLoading,
        subInventoriesIsSuccess: isSuccess,
        subInventoriesIsError: isError,
        subInventoriesError: error
    };
};




var $6204f2fbb7c98386$exports = {};

$parcel$export($6204f2fbb7c98386$exports, "actionButton", function () { return $6204f2fbb7c98386$export$a75c7ea49564edd7; }, function (v) { return $6204f2fbb7c98386$export$a75c7ea49564edd7 = v; });
$parcel$export($6204f2fbb7c98386$exports, "buttonContainer", function () { return $6204f2fbb7c98386$export$dc57ddd528b7443f; }, function (v) { return $6204f2fbb7c98386$export$dc57ddd528b7443f = v; });
$parcel$export($6204f2fbb7c98386$exports, "column", function () { return $6204f2fbb7c98386$export$4e0c71f277ca26b3; }, function (v) { return $6204f2fbb7c98386$export$4e0c71f277ca26b3 = v; });
$parcel$export($6204f2fbb7c98386$exports, "columnLeft", function () { return $6204f2fbb7c98386$export$41ce4293be25bf01; }, function (v) { return $6204f2fbb7c98386$export$41ce4293be25bf01 = v; });
$parcel$export($6204f2fbb7c98386$exports, "commandButton", function () { return $6204f2fbb7c98386$export$74540e56d8cdd242; }, function (v) { return $6204f2fbb7c98386$export$74540e56d8cdd242 = v; });
$parcel$export($6204f2fbb7c98386$exports, "container", function () { return $6204f2fbb7c98386$export$34e0f9847d4c02dd; }, function (v) { return $6204f2fbb7c98386$export$34e0f9847d4c02dd = v; });
$parcel$export($6204f2fbb7c98386$exports, "debugView", function () { return $6204f2fbb7c98386$export$441992c85a59286b; }, function (v) { return $6204f2fbb7c98386$export$441992c85a59286b = v; });
$parcel$export($6204f2fbb7c98386$exports, "details", function () { return $6204f2fbb7c98386$export$41ee12f6f6f05843; }, function (v) { return $6204f2fbb7c98386$export$41ee12f6f6f05843 = v; });
$parcel$export($6204f2fbb7c98386$exports, "disabledInput", function () { return $6204f2fbb7c98386$export$7b46d23156d74840; }, function (v) { return $6204f2fbb7c98386$export$7b46d23156d74840 = v; });
$parcel$export($6204f2fbb7c98386$exports, "fieldWrapper", function () { return $6204f2fbb7c98386$export$75c751978d4a1350; }, function (v) { return $6204f2fbb7c98386$export$75c751978d4a1350 = v; });
$parcel$export($6204f2fbb7c98386$exports, "fieldsContainer", function () { return $6204f2fbb7c98386$export$9ef26016970df748; }, function (v) { return $6204f2fbb7c98386$export$9ef26016970df748 = v; });
$parcel$export($6204f2fbb7c98386$exports, "formSelect", function () { return $6204f2fbb7c98386$export$b99a395818678a86; }, function (v) { return $6204f2fbb7c98386$export$b99a395818678a86 = v; });
$parcel$export($6204f2fbb7c98386$exports, "grayBackground", function () { return $6204f2fbb7c98386$export$5100d0a94c0b29b3; }, function (v) { return $6204f2fbb7c98386$export$5100d0a94c0b29b3 = v; });
$parcel$export($6204f2fbb7c98386$exports, "handIcon", function () { return $6204f2fbb7c98386$export$e571bf33bf7c896c; }, function (v) { return $6204f2fbb7c98386$export$e571bf33bf7c896c = v; });
$parcel$export($6204f2fbb7c98386$exports, "header", function () { return $6204f2fbb7c98386$export$38e42c68cf43b5d4; }, function (v) { return $6204f2fbb7c98386$export$38e42c68cf43b5d4 = v; });
$parcel$export($6204f2fbb7c98386$exports, "headerContent", function () { return $6204f2fbb7c98386$export$838c0e7679321ff3; }, function (v) { return $6204f2fbb7c98386$export$838c0e7679321ff3 = v; });
$parcel$export($6204f2fbb7c98386$exports, "heading", function () { return $6204f2fbb7c98386$export$46e4a324ac90507f; }, function (v) { return $6204f2fbb7c98386$export$46e4a324ac90507f = v; });
$parcel$export($6204f2fbb7c98386$exports, "helper", function () { return $6204f2fbb7c98386$export$4bbbbc0a0e57a7f; }, function (v) { return $6204f2fbb7c98386$export$4bbbbc0a0e57a7f = v; });
$parcel$export($6204f2fbb7c98386$exports, "icon", function () { return $6204f2fbb7c98386$export$1ca1ec8b29a4ce27; }, function (v) { return $6204f2fbb7c98386$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($6204f2fbb7c98386$exports, "input", function () { return $6204f2fbb7c98386$export$b7e3ae3d7c15e42e; }, function (v) { return $6204f2fbb7c98386$export$b7e3ae3d7c15e42e = v; });
$parcel$export($6204f2fbb7c98386$exports, "link", function () { return $6204f2fbb7c98386$export$9c30223ca0a664fb; }, function (v) { return $6204f2fbb7c98386$export$9c30223ca0a664fb = v; });
$parcel$export($6204f2fbb7c98386$exports, "rawInput", function () { return $6204f2fbb7c98386$export$5c0a152c672ac95d; }, function (v) { return $6204f2fbb7c98386$export$5c0a152c672ac95d = v; });
$parcel$export($6204f2fbb7c98386$exports, "responseAction", function () { return $6204f2fbb7c98386$export$24c9bef730311970; }, function (v) { return $6204f2fbb7c98386$export$24c9bef730311970 = v; });
$parcel$export($6204f2fbb7c98386$exports, "responseDiv", function () { return $6204f2fbb7c98386$export$4ea3e83dbae90ff1; }, function (v) { return $6204f2fbb7c98386$export$4ea3e83dbae90ff1 = v; });
$parcel$export($6204f2fbb7c98386$exports, "secondaryHeading", function () { return $6204f2fbb7c98386$export$b22d4c19dfd5506f; }, function (v) { return $6204f2fbb7c98386$export$b22d4c19dfd5506f = v; });
$parcel$export($6204f2fbb7c98386$exports, "topMargin", function () { return $6204f2fbb7c98386$export$d5cd492a56aa2350; }, function (v) { return $6204f2fbb7c98386$export$d5cd492a56aa2350 = v; });
var $6204f2fbb7c98386$export$a75c7ea49564edd7;
var $6204f2fbb7c98386$export$dc57ddd528b7443f;
var $6204f2fbb7c98386$export$4e0c71f277ca26b3;
var $6204f2fbb7c98386$export$41ce4293be25bf01;
var $6204f2fbb7c98386$export$74540e56d8cdd242;
var $6204f2fbb7c98386$export$34e0f9847d4c02dd;
var $6204f2fbb7c98386$export$441992c85a59286b;
var $6204f2fbb7c98386$export$41ee12f6f6f05843;
var $6204f2fbb7c98386$export$7b46d23156d74840;
var $6204f2fbb7c98386$export$75c751978d4a1350;
var $6204f2fbb7c98386$export$9ef26016970df748;
var $6204f2fbb7c98386$export$b99a395818678a86;
var $6204f2fbb7c98386$export$5100d0a94c0b29b3;
var $6204f2fbb7c98386$export$e571bf33bf7c896c;
var $6204f2fbb7c98386$export$38e42c68cf43b5d4;
var $6204f2fbb7c98386$export$838c0e7679321ff3;
var $6204f2fbb7c98386$export$46e4a324ac90507f;
var $6204f2fbb7c98386$export$4bbbbc0a0e57a7f;
var $6204f2fbb7c98386$export$1ca1ec8b29a4ce27;
var $6204f2fbb7c98386$export$b7e3ae3d7c15e42e;
var $6204f2fbb7c98386$export$9c30223ca0a664fb;
var $6204f2fbb7c98386$export$5c0a152c672ac95d;
var $6204f2fbb7c98386$export$24c9bef730311970;
var $6204f2fbb7c98386$export$4ea3e83dbae90ff1;
var $6204f2fbb7c98386$export$b22d4c19dfd5506f;
var $6204f2fbb7c98386$export$d5cd492a56aa2350;
$6204f2fbb7c98386$export$a75c7ea49564edd7 = `Xl9yoG_actionButton`;
$6204f2fbb7c98386$export$dc57ddd528b7443f = `Xl9yoG_buttonContainer`;
$6204f2fbb7c98386$export$4e0c71f277ca26b3 = `Xl9yoG_column`;
$6204f2fbb7c98386$export$41ce4293be25bf01 = `Xl9yoG_columnLeft`;
$6204f2fbb7c98386$export$74540e56d8cdd242 = `Xl9yoG_commandButton`;
$6204f2fbb7c98386$export$34e0f9847d4c02dd = `Xl9yoG_container`;
$6204f2fbb7c98386$export$441992c85a59286b = `Xl9yoG_debugView`;
$6204f2fbb7c98386$export$41ee12f6f6f05843 = `Xl9yoG_details`;
$6204f2fbb7c98386$export$7b46d23156d74840 = `Xl9yoG_disabledInput`;
$6204f2fbb7c98386$export$75c751978d4a1350 = `Xl9yoG_fieldWrapper`;
$6204f2fbb7c98386$export$9ef26016970df748 = `Xl9yoG_fieldsContainer`;
$6204f2fbb7c98386$export$b99a395818678a86 = `Xl9yoG_formSelect`;
$6204f2fbb7c98386$export$5100d0a94c0b29b3 = `Xl9yoG_grayBackground`;
$6204f2fbb7c98386$export$e571bf33bf7c896c = `Xl9yoG_handIcon`;
$6204f2fbb7c98386$export$38e42c68cf43b5d4 = `Xl9yoG_header`;
$6204f2fbb7c98386$export$838c0e7679321ff3 = `Xl9yoG_headerContent`;
$6204f2fbb7c98386$export$46e4a324ac90507f = `Xl9yoG_heading`;
$6204f2fbb7c98386$export$4bbbbc0a0e57a7f = `Xl9yoG_helper`;
$6204f2fbb7c98386$export$1ca1ec8b29a4ce27 = `Xl9yoG_icon`;
$6204f2fbb7c98386$export$b7e3ae3d7c15e42e = `Xl9yoG_input`;
$6204f2fbb7c98386$export$9c30223ca0a664fb = `Xl9yoG_link`;
$6204f2fbb7c98386$export$5c0a152c672ac95d = `Xl9yoG_rawInput`;
$6204f2fbb7c98386$export$24c9bef730311970 = `Xl9yoG_responseAction`;
$6204f2fbb7c98386$export$4ea3e83dbae90ff1 = `Xl9yoG_responseDiv`;
$6204f2fbb7c98386$export$b22d4c19dfd5506f = `Xl9yoG_secondaryHeading`;
$6204f2fbb7c98386$export$d5cd492a56aa2350 = `Xl9yoG_topMargin`;


// istanbul ignore next -- all fields define render; displayField fallback is defensive
const $edda5be83223da94$var$renderOptionLabel = (f, v)=>f.render ? f.render(v) : v[f.displayField];
/**
 * Chart Of Account Selector component that allows users to select a hierarchical
 * chart of accounts by choosing division, location, cost center, account, segment,
 * and inter-company values.
 * @param {object} props - Component props
 * @param {string} [props.defaultDestinationAcct] - Default account value to pre-fill
 * @param {(selectedValue: object) => void} props.selectionOnClick - Callback when selection is confirmed
 * @param {() => void} props.cancelOnClick - Callback when cancel is clicked
 * @returns {import("react").ReactElement} Chart of account selector component
 */ const $edda5be83223da94$var$ChartOfAccountSelector = (props)=>{
    const [selectedFullValue, setSelectedFullValue] = (0, $lCzvA.useState)({});
    const [activeIndex, setActiveIndex] = (0, $lCzvA.useState)(0);
    const defaultDestinationAcct = props.defaultDestinationAcct;
    let defaultAccount = {};
    if (defaultDestinationAcct) defaultAccount = {
        division: defaultDestinationAcct.slice(0, 3),
        location: defaultDestinationAcct.slice(4, 7),
        costCenter: defaultDestinationAcct.slice(8, 14)
    };
    const { divisions: divisions } = (0, $3d0072a07f3cd4a9$export$34ecc72616849d94)();
    const { divisionLocations: divisionLocations } = (0, $8b14602bb9192143$export$9c77921293a664cb)(selectedFullValue.division?.value);
    const { costCenters: costCenters } = (0, $1f92358e6424da8a$export$813f23c9836d23b9)(selectedFullValue.division?.value, selectedFullValue.location?.value);
    const { accounts: accounts } = (0, $8f6704b684c9a5ac$export$c229550bd86eba85)(selectedFullValue.division?.value, selectedFullValue.location?.value, selectedFullValue.costCenter?.value);
    const { segments: segments } = (0, $7f2b34b6291926d4$export$35888604389caffd)(selectedFullValue.division?.value, selectedFullValue.location?.value, selectedFullValue.costCenter?.value, selectedFullValue.account?.value);
    const { intercomps: intercomps } = (0, $f221e7e1619357d7$export$5fe20135af620e9b)(selectedFullValue.division?.value, selectedFullValue.location?.value, selectedFullValue.costCenter?.value, selectedFullValue.account?.value, selectedFullValue.segment?.value);
    // Direct map from field name to query result — replaces inputData state + 6 sync effects
    const dataMap = (0, $lCzvA.useMemo)(()=>({
            division: divisions,
            location: divisionLocations,
            costCenter: costCenters,
            account: accounts,
            segment: segments,
            interCompany: intercomps
        }), [
        divisions,
        divisionLocations,
        costCenters,
        accounts,
        segments,
        intercomps
    ]);
    const fields = (0, $lCzvA.useMemo)(()=>[
            {
                name: 'Select Division',
                static: true,
                displayField: 'description',
                render: (option)=>`(${option.division}) ${option.description}`,
                defaultValue: defaultAccount.division,
                valueField: 'division'
            },
            {
                name: 'Select Location',
                static: false,
                displayField: 'description',
                render: (option)=>`(${option.location}) ${option.description}`,
                defaultValue: defaultAccount.location,
                valueField: 'location'
            },
            {
                name: 'Select Cost Center',
                static: false,
                displayField: 'description',
                render: (option)=>`(${option.costCenter}) ${option.description}`,
                defaultValue: defaultAccount.costCenter,
                valueField: 'costCenter'
            },
            {
                name: 'Select Account',
                static: false,
                displayField: 'description',
                render: (option)=>`(${option.account}) ${option.description}`,
                valueField: 'account'
            },
            {
                name: 'Select Segment',
                static: false,
                displayField: 'description',
                render: (option)=>`(${option.segment}) ${option.description}`,
                valueField: 'segment'
            },
            {
                name: 'Select Inter Company',
                static: false,
                displayField: 'description',
                render: (option)=>`(${option.interCompany}) ${option.description}`,
                valueField: 'interCompany'
            }
        ], [
        defaultAccount.division,
        defaultAccount.location,
        defaultAccount.costCenter
    ]);
    const setFullValue = (0, $lCzvA.useCallback)(({ field: field, label: label, value: value }, index, fullField)=>{
        const downstreamFields = fields.slice(index + 1).map((f)=>f.valueField);
        setSelectedFullValue((prev)=>{
            if (prev[field]?.value === value) return prev;
            const next = {
                ...prev
            };
            for (const f of downstreamFields)delete next[f];
            next[field] = {
                label: label,
                value: value,
                raw: fullField
            };
            return next;
        });
        setActiveIndex(index + 1);
    }, [
        fields
    ]);
    // Auto-select pre-fill values when query data loads (render-time adjustment, one field per render pass)
    for (const [index, f] of fields.entries())if (f.defaultValue && dataMap[f.valueField] && !selectedFullValue[f.valueField]) {
        const match = dataMap[f.valueField].find((v)=>v[f.valueField] === f.defaultValue);
        if (match) {
            setFullValue({
                field: f.valueField,
                value: match[f.valueField],
                label: match[f.displayField]
            }, index, match);
            break;
        }
    }
    const validateSelection = ()=>Boolean(selectedFullValue.division && selectedFullValue.location && selectedFullValue.costCenter && selectedFullValue.account && selectedFullValue.segment && selectedFullValue.interCompany);
    const selectOnClick = ()=>{
        const isValid = validateSelection();
        if (isValid) {
            const selectedValue = `${selectedFullValue.division.value}.${selectedFullValue.location.value}.${selectedFullValue.costCenter.value}.${selectedFullValue.account.value}.${selectedFullValue.segment.value}.${selectedFullValue.interCompany.value}`;
            props.selectionOnClick(selectedValue);
        } else (0, $673b1c81cc441170$export$2e2bcd8739ae039).warning('Current Selection is invalid!');
    };
    const cancelOnClick = ()=>{
        props.cancelOnClick();
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6204f2fbb7c98386$exports))).container,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6204f2fbb7c98386$exports))).header,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6204f2fbb7c98386$exports))).headerContent,
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                        children: "Chart Of Account Selector"
                    })
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6204f2fbb7c98386$exports))).fieldsContainer,
                children: fields.map((f, index)=>// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6204f2fbb7c98386$exports))).fieldWrapper,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            id: `id_${f.name}`,
                            labelText: f.name,
                            value: selectedFullValue[f.valueField]?.value || '',
                            disabled: index > activeIndex || !dataMap[f.valueField],
                            onChange: (e)=>setFullValue({
                                    field: f.valueField,
                                    value: e.target.value,
                                    label: dataMap[f.valueField]?.find((v)=>v[f.valueField] === e.target.value)?.[f.displayField]
                                }, index, dataMap[f.valueField]?.find((v)=>v[f.valueField] === e.target.value)),
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "Choose..."
                                }),
                                dataMap[f.valueField]?.map((v)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: v[f.valueField],
                                        children: $edda5be83223da94$var$renderOptionLabel(f, v)
                                    }, `${f.valueField}_${v[f.valueField]}`))
                            ]
                        })
                    }, `field_${f.valueField}_${index}`))
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6204f2fbb7c98386$exports))).buttonContainer,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        color: "secondary",
                        size: "sm",
                        onClick: cancelOnClick,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        color: "primary",
                        size: "sm",
                        onClick: selectOnClick,
                        children: "Set"
                    })
                ]
            })
        ]
    });
};
var $edda5be83223da94$export$2e2bcd8739ae039 = $edda5be83223da94$var$ChartOfAccountSelector;









var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/TextArea/index.jsx
var $27cc10959d191d67$export$2e2bcd8739ae039 = (0, $lCzvA.forwardRef)(function({ id: r, labelText: s, hideLabel: c, required: l, className: u, containerClass: d, assistiveText: f, error: p, helpText: m, tooltipContent: h, tooltipPosition: g = "bottom", rows: _ = 4, ...v }, y) {
    let b = (0, $lCzvA.useRef)(null), x = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-FormGroup relative mb-4": !0,
        [d]: d
    }), S = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-TextArea sash-input": !0,
        "border-red-700": p,
        [u]: u
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        ref: b,
        className: x,
        "data-testid": "sash-textarea",
        children: [
            (s || m || f) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $353df793a3a1d2b7$export$2e2bcd8739ae039), {
                id: r,
                labelText: s,
                hideLabel: c,
                required: l,
                error: !!p,
                assistiveText: f,
                helpText: m,
                tooltipContent: h,
                tooltipPosition: g
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("textarea", {
                id: r,
                name: r,
                className: S,
                required: l,
                rows: _,
                ref: y,
                ...v
            }),
            typeof p == "string" && !!p && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $71efe153e5175f41$export$2e2bcd8739ae039), {
                type: "error",
                className: "mt-2",
                message: p,
                inline: !0
            })
        ]
    });
});



/**
 * Object representing available answer options.
 * Each key corresponds to a specific answer and its value is of type `SelectedAnswer`.
 * @type {Record<string, import("../../pages/EquipActionPortal/questionTypes").SelectedAnswer>}
 */ const $a7ed3f1def80a908$export$66b13602a3bd73a9 = {
    YES: 'YES',
    NO: 'NO',
    UNSURE: 'UNSURE',
    NONE_SELECTED: 'NONE_SELECTED'
};




var $lCzvA = parcelRequire("lCzvA");
var $9fd6d17730838e00$exports = {};

$parcel$export($9fd6d17730838e00$exports, "answersRow", function () { return $9fd6d17730838e00$export$59dadddc53f0d4e9; }, function (v) { return $9fd6d17730838e00$export$59dadddc53f0d4e9 = v; });
$parcel$export($9fd6d17730838e00$exports, "questionContainer", function () { return $9fd6d17730838e00$export$8d50ce35f85c65f2; }, function (v) { return $9fd6d17730838e00$export$8d50ce35f85c65f2 = v; });
$parcel$export($9fd6d17730838e00$exports, "questionNumber", function () { return $9fd6d17730838e00$export$5b705e2d6aba5b41; }, function (v) { return $9fd6d17730838e00$export$5b705e2d6aba5b41 = v; });
$parcel$export($9fd6d17730838e00$exports, "questionRow", function () { return $9fd6d17730838e00$export$a6de436aaa717324; }, function (v) { return $9fd6d17730838e00$export$a6de436aaa717324 = v; });
$parcel$export($9fd6d17730838e00$exports, "questionText", function () { return $9fd6d17730838e00$export$500776a67ad9cd26; }, function (v) { return $9fd6d17730838e00$export$500776a67ad9cd26 = v; });
$parcel$export($9fd6d17730838e00$exports, "textareaContainer", function () { return $9fd6d17730838e00$export$88b394dd52149273; }, function (v) { return $9fd6d17730838e00$export$88b394dd52149273 = v; });
var $9fd6d17730838e00$export$59dadddc53f0d4e9;
var $9fd6d17730838e00$export$8d50ce35f85c65f2;
var $9fd6d17730838e00$export$5b705e2d6aba5b41;
var $9fd6d17730838e00$export$a6de436aaa717324;
var $9fd6d17730838e00$export$500776a67ad9cd26;
var $9fd6d17730838e00$export$88b394dd52149273;
$9fd6d17730838e00$export$59dadddc53f0d4e9 = `OXxf1G_answersRow`;
$9fd6d17730838e00$export$8d50ce35f85c65f2 = `OXxf1G_questionContainer`;
$9fd6d17730838e00$export$5b705e2d6aba5b41 = `OXxf1G_questionNumber`;
$9fd6d17730838e00$export$a6de436aaa717324 = `OXxf1G_questionRow`;
$9fd6d17730838e00$export$500776a67ad9cd26 = `OXxf1G_questionText`;
$9fd6d17730838e00$export$88b394dd52149273 = `OXxf1G_textareaContainer`;


const $3865473f74196807$var$freeTextVisibilityLevels = {
    NOT_VISIBLE: 0,
    BUTTON_VISIBLE: 1,
    TEXTAREA_VISIBLE: 2
};
/**
 * The follow-up question and answers
 * @param {object} props - The props for the component.
 * @param {number} props.questionNumber - Question number
 * @param {string} props.question - Question text
 * @param {import('../../pages/EquipActionPortal/questionTypes').SelectedAnswer} props.answerSelected - Whether Yes, No or neither is selected
 * @param {(answer: import('../../pages/EquipActionPortal/questionTypes').SelectedAnswer) => void} props.onSelectAnswer - On click the answer button
 * @param {string} props.additionalDetails - Additional details text
 * @param {(e: import('react').ChangeEvent<HTMLTextAreaElement>) => void} props.onChangeAdditionalDetails - On change the additional details text
 */ const $3865473f74196807$var$QuestionAnswers = ({ questionNumber: questionNumber, question: question, answerSelected: answerSelected, onSelectAnswer: onSelectAnswer, additionalDetails: additionalDetails, onChangeAdditionalDetails: onChangeAdditionalDetails })=>{
    const [freeTextVisibilityLevel, setFreeTextVisibilityLevel] = (0, $lCzvA.useState)($3865473f74196807$var$freeTextVisibilityLevels.NOT_VISIBLE);
    /**
   * Sets the visibility level of the free text based on the selected answer.
   * @param {import('../../pages/EquipActionPortal/questionTypes').SelectedAnswer} selectedAnswer - The currently selected answer.
   * @param {import('../../pages/EquipActionPortal/questionTypes').SelectedAnswer} answerClicked - The answer that was clicked.
   * @returns {void}
   */ const setVisibility = (selectedAnswer, answerClicked)=>{
        setFreeTextVisibilityLevel(selectedAnswer === answerClicked ? $3865473f74196807$var$freeTextVisibilityLevels.NOT_VISIBLE : $3865473f74196807$var$freeTextVisibilityLevels.BUTTON_VISIBLE);
    };
    const handleOnSelectAnswerYes = ()=>{
        setVisibility(answerSelected, (0, $a7ed3f1def80a908$export$66b13602a3bd73a9).YES);
        onSelectAnswer((0, $a7ed3f1def80a908$export$66b13602a3bd73a9).YES);
    };
    const handleOnSelectAnswerNo = ()=>{
        setVisibility(answerSelected, (0, $a7ed3f1def80a908$export$66b13602a3bd73a9).NO);
        onSelectAnswer((0, $a7ed3f1def80a908$export$66b13602a3bd73a9).NO);
    };
    const handleOnSelectAnswerUnsure = ()=>{
        setVisibility(answerSelected, (0, $a7ed3f1def80a908$export$66b13602a3bd73a9).UNSURE);
        onSelectAnswer((0, $a7ed3f1def80a908$export$66b13602a3bd73a9).UNSURE);
    };
    const onAddAdditionalDetailsClick = ()=>{
        setFreeTextVisibilityLevel($3865473f74196807$var$freeTextVisibilityLevels.TEXTAREA_VISIBLE);
    };
    const { t: t } = (0, $8216e3af17948d6d$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9fd6d17730838e00$exports))).questionContainer,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9fd6d17730838e00$exports))).questionRow,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9fd6d17730838e00$exports))).questionNumber,
                        children: `${questionNumber}.`
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9fd6d17730838e00$exports))).questionText,
                        children: question
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9fd6d17730838e00$exports))).answersRow,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b385ad19d681861e$export$2e2bcd8739ae039), {
                        isSelected: answerSelected === (0, $a7ed3f1def80a908$export$66b13602a3bd73a9).YES,
                        label: t('yesButton'),
                        onSelectAnswer: handleOnSelectAnswerYes
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b385ad19d681861e$export$2e2bcd8739ae039), {
                        isSelected: answerSelected === (0, $a7ed3f1def80a908$export$66b13602a3bd73a9).NO,
                        label: t('noButton'),
                        onSelectAnswer: handleOnSelectAnswerNo
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b385ad19d681861e$export$2e2bcd8739ae039), {
                        isSelected: answerSelected === (0, $a7ed3f1def80a908$export$66b13602a3bd73a9).UNSURE,
                        label: t('dontKnowButton'),
                        onSelectAnswer: handleOnSelectAnswerUnsure
                    })
                ]
            }),
            freeTextVisibilityLevel === $3865473f74196807$var$freeTextVisibilityLevels.BUTTON_VISIBLE && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                    onClick: onAddAdditionalDetailsClick,
                    size: "sm",
                    color: "secondary",
                    children: t('addAdditionalDetails')
                })
            }),
            freeTextVisibilityLevel === $3865473f74196807$var$freeTextVisibilityLevels.TEXTAREA_VISIBLE && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9fd6d17730838e00$exports))).textareaContainer,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $27cc10959d191d67$export$2e2bcd8739ae039), {
                    id: `additional-details-${questionNumber}`,
                    "data-testid": "additionalDetailsTextArea",
                    labelText: t('additionalDetails'),
                    value: additionalDetails,
                    onChange: onChangeAdditionalDetails
                })
            })
        ]
    });
};
var $3865473f74196807$export$2e2bcd8739ae039 = $3865473f74196807$var$QuestionAnswers;






var $lCzvA = parcelRequire("lCzvA");
function $b0e84097c00f364e$export$2e2bcd8739ae039() {
    return $b0e84097c00f364e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b0e84097c00f364e$export$2e2bcd8739ae039.apply(null, arguments);
}



var $lCzvA = parcelRequire("lCzvA");
var $d2ac6f7a90164e12$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2ac6f7a90164e12$var$ReactIs, $d2ac6f7a90164e12$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$d2ac6f7a90164e12$exports = (parcelRequire("1AISF"))();




var $lCzvA = parcelRequire("lCzvA");
/* eslint-disable */ const $19fcb7f82d9e3d9f$var$_keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function $19fcb7f82d9e3d9f$var$utf8Encode(str) {
    for(let n = 0; n < str.length; n++){
        const c = str.charCodeAt(n);
        if (c >= 128) throw new Error('ASCII only support');
    }
    return str;
}
const $19fcb7f82d9e3d9f$export$c62426fdd000a97e = (input)=>{
    let output = '';
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
    while(i < input.length){
        enc1 = $19fcb7f82d9e3d9f$var$_keyStr.indexOf(input.charAt(i++));
        enc2 = $19fcb7f82d9e3d9f$var$_keyStr.indexOf(input.charAt(i++));
        enc3 = $19fcb7f82d9e3d9f$var$_keyStr.indexOf(input.charAt(i++));
        enc4 = $19fcb7f82d9e3d9f$var$_keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) output = output + String.fromCharCode(chr2);
        if (enc4 != 64) output = output + String.fromCharCode(chr3);
    }
    return output;
};
const $19fcb7f82d9e3d9f$export$e510a73ee562749 = (input)=>{
    let output = '';
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;
    input = $19fcb7f82d9e3d9f$var$utf8Encode(input);
    while(i < input.length){
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) enc3 = enc4 = 64;
        else if (isNaN(chr3)) enc4 = 64;
        output = output + $19fcb7f82d9e3d9f$var$_keyStr.charAt(enc1) + $19fcb7f82d9e3d9f$var$_keyStr.charAt(enc2) + $19fcb7f82d9e3d9f$var$_keyStr.charAt(enc3) + $19fcb7f82d9e3d9f$var$_keyStr.charAt(enc4);
    }
    return output;
};


/* eslint-disable */ // See "precomputation" in notes
const $617ad45eff3b99db$var$k = [];
let $617ad45eff3b99db$var$i = 0;
for(; $617ad45eff3b99db$var$i < 64;)$617ad45eff3b99db$var$k[$617ad45eff3b99db$var$i] = 0 | Math.sin(++$617ad45eff3b99db$var$i % Math.PI) * 4294967296;
function $617ad45eff3b99db$export$a58ec6a60c09ca72(s) {
    const words = [];
    let b, c, d, j = unescape(encodeURI(s)) + '\x80', a = j.length;
    const h = [
        b = 0x67452301,
        c = 0xefcdab89,
        ~b,
        ~c
    ];
    s = --a / 4 + 2 | 15;
    // See "Length bits" in notes
    words[--s] = a * 8;
    for(; ~a;)// a !== -1
    words[a >> 2] |= j.charCodeAt(a) << 8 * a--;
    for($617ad45eff3b99db$var$i = j = 0; $617ad45eff3b99db$var$i < s; $617ad45eff3b99db$var$i += 16){
        a = h;
        for(; j < 64; a = [
            d = a[3],
            b + ((d = a[0] + [
                b & c | ~b & d,
                d & b | ~d & c,
                b ^ c ^ d,
                c ^ (b | ~d)
            ][a = j >> 4] + $617ad45eff3b99db$var$k[j] + ~~words[$617ad45eff3b99db$var$i | [
                j,
                5 * j + 1,
                3 * j + 5,
                7 * j
            ][a] & 15]) << (a = [
                7,
                12,
                17,
                22,
                5,
                9,
                14,
                20,
                4,
                11,
                16,
                23,
                6,
                10,
                15,
                21
            ][4 * a + j++ % 4]) | d >>> -a),
            b,
            c
        ]){
            b = a[1] | 0;
            c = a[2];
        }
        // See "Integer safety" in notes
        for(j = 4; j;)h[--j] += a[j];
    // j === 0
    }
    for(s = ''; j < 32;)s += (h[j >> 3] >> (1 ^ j++) * 4 & 15).toString(16);
    return s;
}


// eslint-disable-next-line @typescript-eslint/naming-convention
let $2b47e3358682e77e$export$4d5a447ae2d3c7bc = /*#__PURE__*/ function(LICENSE_STATUS) {
    LICENSE_STATUS["NotFound"] = "NotFound";
    LICENSE_STATUS["Invalid"] = "Invalid";
    LICENSE_STATUS["ExpiredAnnual"] = "ExpiredAnnual";
    LICENSE_STATUS["ExpiredAnnualGrace"] = "ExpiredAnnualGrace";
    LICENSE_STATUS["ExpiredVersion"] = "ExpiredVersion";
    LICENSE_STATUS["Valid"] = "Valid";
    LICENSE_STATUS["OutOfScope"] = "OutOfScope";
    LICENSE_STATUS["NotAvailableInInitialProPlan"] = "NotAvailableInInitialProPlan";
    return LICENSE_STATUS;
}({});


const $34205d3b5147b26a$export$6fffcc874c4891f0 = [
    'pro',
    'premium'
];
const $34205d3b5147b26a$export$1632eb3abf3dacd4 = [
    'initial',
    'Q3-2024'
];


const $28b81f8e76d6361d$export$dde05de07b040648 = [
    /**
 * A license is outdated if the current version of the software was released after the expiry date of the license.
 * But the license can be used indefinitely with an older version of the software.
 */ 'perpetual',
    /**
 * On development, a license is outdated if the expiry date has been reached
 * On production, a license is outdated if the current version of the software was released after the expiry date of the license (see "perpetual")
 */ 'annual',
    /**
 * Legacy. The previous name for 'annual'.
 * Can be removed once old license keys generated with 'subscription' are no longer supported.
 * To support for a while. We need more years of backward support and we sell multi year licenses.
 */ 'subscription'
];


const $85f6fecf512189c2$var$getDefaultReleaseDate = ()=>{
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};
function $85f6fecf512189c2$export$4c9b7f7dacd07671(releaseDate = $85f6fecf512189c2$var$getDefaultReleaseDate()) {
    return (0, $19fcb7f82d9e3d9f$export$e510a73ee562749)(releaseDate.getTime().toString());
}
function $85f6fecf512189c2$var$isPlanScopeSufficient(packageName, planScope) {
    let acceptedScopes;
    if (packageName.includes('-pro')) acceptedScopes = [
        'pro',
        'premium'
    ];
    else if (packageName.includes('-premium')) acceptedScopes = [
        'premium'
    ];
    else acceptedScopes = [];
    return acceptedScopes.includes(planScope);
}
const $85f6fecf512189c2$var$expiryReg = /^.*EXPIRY=([0-9]+),.*$/;
const $85f6fecf512189c2$var$PRO_PACKAGES_AVAILABLE_IN_INITIAL_PRO_PLAN = [
    'x-data-grid-pro',
    'x-date-pickers-pro'
];
/**
 * Format: ORDER:${orderNumber},EXPIRY=${expiryTimestamp},KEYVERSION=1
 */ const $85f6fecf512189c2$var$decodeLicenseVersion1 = (license)=>{
    let expiryTimestamp;
    try {
        expiryTimestamp = parseInt(license.match($85f6fecf512189c2$var$expiryReg)[1], 10);
        if (!expiryTimestamp || Number.isNaN(expiryTimestamp)) expiryTimestamp = null;
    } catch (err) {
        expiryTimestamp = null;
    }
    return {
        planScope: 'pro',
        licenseModel: 'perpetual',
        expiryTimestamp: expiryTimestamp,
        planVersion: 'initial'
    };
};
/**
 * Format: O=${orderNumber},E=${expiryTimestamp},S=${planScope},LM=${licenseModel},PV=${planVersion},KV=2`;
 */ const $85f6fecf512189c2$var$decodeLicenseVersion2 = (license)=>{
    const licenseInfo = {
        planScope: null,
        licenseModel: null,
        expiryTimestamp: null,
        planVersion: 'initial'
    };
    license.split(',').map((token)=>token.split('=')).filter((el)=>el.length === 2).forEach(([key, value])=>{
        if (key === 'S') licenseInfo.planScope = value;
        if (key === 'LM') licenseInfo.licenseModel = value;
        if (key === 'E') {
            const expiryTimestamp = parseInt(value, 10);
            if (expiryTimestamp && !Number.isNaN(expiryTimestamp)) licenseInfo.expiryTimestamp = expiryTimestamp;
        }
        if (key === 'PV') licenseInfo.planVersion = value;
    });
    return licenseInfo;
};
/**
 * Decode the license based on its key version and return a version-agnostic `MuiLicense` object.
 */ const $85f6fecf512189c2$var$decodeLicense = (encodedLicense)=>{
    const license = (0, $19fcb7f82d9e3d9f$export$c62426fdd000a97e)(encodedLicense);
    if (license.includes('KEYVERSION=1')) return $85f6fecf512189c2$var$decodeLicenseVersion1(license);
    if (license.includes('KV=2')) return $85f6fecf512189c2$var$decodeLicenseVersion2(license);
    return null;
};
function $85f6fecf512189c2$export$65cf4e2e0f5c4c60({ releaseInfo: releaseInfo, licenseKey: licenseKey, packageName: packageName }) {
    if (!releaseInfo) throw new Error('MUI X: The release information is missing. Not able to validate license.');
    if (!licenseKey) return {
        status: (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).NotFound
    };
    const hash = licenseKey.substr(0, 32);
    const encoded = licenseKey.substr(32);
    if (hash !== (0, $617ad45eff3b99db$export$a58ec6a60c09ca72)(encoded)) return {
        status: (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).Invalid
    };
    const license = $85f6fecf512189c2$var$decodeLicense(encoded);
    if (license == null) {
        console.error('MUI X: Error checking license. Key version not found!');
        return {
            status: (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (license.licenseModel == null || !(0, $28b81f8e76d6361d$export$dde05de07b040648).includes(license.licenseModel)) {
        console.error('MUI X: Error checking license. Licensing model not found or invalid!');
        return {
            status: (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (license.expiryTimestamp == null) {
        console.error('MUI X: Error checking license. Expiry timestamp not found or invalid!');
        return {
            status: (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    license.licenseModel;
    {
        const pkgTimestamp = parseInt((0, $19fcb7f82d9e3d9f$export$c62426fdd000a97e)(releaseInfo), 10);
        if (Number.isNaN(pkgTimestamp)) throw new Error('MUI X: The release information is invalid. Not able to validate license.');
        if (license.expiryTimestamp < pkgTimestamp) return {
            status: (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).ExpiredVersion
        };
    }
    if (license.planScope == null || !(0, $34205d3b5147b26a$export$6fffcc874c4891f0).includes(license.planScope)) {
        console.error('MUI X: Error checking license. planScope not found or invalid!');
        return {
            status: (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (!$85f6fecf512189c2$var$isPlanScopeSufficient(packageName, license.planScope)) return {
        status: (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).OutOfScope
    };
    // 'charts-pro' or 'tree-view-pro' can only be used with a newer Pro license
    if (license.planVersion === 'initial' && license.planScope === 'pro' && !$85f6fecf512189c2$var$PRO_PACKAGES_AVAILABLE_IN_INITIAL_PRO_PLAN.includes(packageName)) return {
        status: (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).NotAvailableInInitialProPlan
    };
    return {
        status: (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).Valid
    };
}


/* eslint-disable */ // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $e2f1b8d299efd927$export$2e2bcd8739ae039 = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();


/**
 * @ignore - do not document.
 */ // Store the license information in a global, so it can be shared
// when module duplication occurs. The duplication of the modules can happen
// if using multiple version of MUI X at the same time of the bundler
// decide to duplicate to improve the size of the chunks.
// eslint-disable-next-line no-underscore-dangle
(0, $e2f1b8d299efd927$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__ = (0, $e2f1b8d299efd927$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__ || {
    key: undefined
};
class $acf61fefb9f9f42e$export$2c56d2e2ae515eeb {
    static getLicenseInfo() {
        // eslint-disable-next-line no-underscore-dangle
        return (0, $e2f1b8d299efd927$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__;
    }
    static getLicenseKey() {
        return $acf61fefb9f9f42e$export$2c56d2e2ae515eeb.getLicenseInfo().key;
    }
    static setLicenseKey(key) {
        const licenseInfo = $acf61fefb9f9f42e$export$2c56d2e2ae515eeb.getLicenseInfo();
        licenseInfo.key = key;
    }
}


/**
 * Workaround for the codesadbox preview error.
 *
 * Once these issues are resolved
 * https://github.com/mui/mui-x/issues/15765
 * https://github.com/codesandbox/codesandbox-client/issues/8673
 *
 * `showError` can simply use `console.error` again.
 */ const $228234d116878c9c$var$isCodeSandbox = typeof window !== 'undefined' && window.location.hostname.endsWith('.csb.app');
function $228234d116878c9c$var$showError(message) {
    // eslint-disable-next-line no-console
    const logger = $228234d116878c9c$var$isCodeSandbox ? console.log : console.error;
    logger([
        '*************************************************************',
        '',
        ...message,
        '',
        '*************************************************************'
    ].join('\n'));
}
function $228234d116878c9c$export$e03bc902b0abb5bd() {
    $228234d116878c9c$var$showError([
        'MUI X: Invalid license key.',
        '',
        "Your MUI X license key format isn't valid. It could be because the license key is missing a character or has a typo.",
        '',
        'To solve the issue, you need to double check that `setLicenseKey()` is called with the right argument',
        'Please check the license key installation https://mui.com/r/x-license-key-installation.'
    ]);
}
function $228234d116878c9c$export$d0a8365d54384f87() {
    $228234d116878c9c$var$showError([
        'MUI X: License key plan mismatch.',
        '',
        'Your use of MUI X is not compatible with the plan of your license key. The feature you are trying to use is not included in the plan of your license key. This happens if you try to use Data Grid Premium with a license key for the Pro plan.',
        '',
        'To solve the issue, you can upgrade your plan from Pro to Premium at https://mui.com/r/x-get-license?scope=premium.',
        "Of if you didn't intend to use Premium features, you can replace the import of `@mui/x-data-grid-premium` with `@mui/x-data-grid-pro`."
    ]);
}
function $228234d116878c9c$export$fa76ce5cbafe3dc5() {
    $228234d116878c9c$var$showError([
        'MUI X: Component not included in your license.',
        '',
        'The component you are trying to use is not included in the Pro Plan you purchased.',
        '',
        'Your license is from an old version of the Pro Plan that is only compatible with the `@mui/x-data-grid-pro` and `@mui/x-date-pickers-pro` commercial packages.',
        '',
        'To start using another Pro package, please consider reaching to our sales team to upgrade your license or visit https://mui.com/r/x-get-license to get a new license key.'
    ]);
}
function $228234d116878c9c$export$bfbf7dff305ffa2a({ plan: plan, packageName: packageName }) {
    $228234d116878c9c$var$showError([
        'MUI X: Missing license key.',
        '',
        `The license key is missing. You might not be allowed to use \`${packageName}\` which is part of MUI X ${plan}.`,
        '',
        'To solve the issue, you can check the free trial conditions: https://mui.com/r/x-license-trial.',
        'If you are eligible no actions are required. If you are not eligible to the free trial, you need to purchase a license https://mui.com/r/x-get-license or stop using the software immediately.'
    ]);
}
function $228234d116878c9c$export$242a1b9acf4255b9({ packageName: packageName }) {
    $228234d116878c9c$var$showError([
        'MUI X: Expired package version.',
        '',
        `You have installed a version of \`${packageName}\` that is outside of the maintenance plan of your license key. By default, commercial licenses provide access to new versions released during the first year after the purchase.`,
        '',
        'To solve the issue, you can renew your license https://mui.com/r/x-get-license or install an older version of the npm package that is compatible with your license key.'
    ]);
}
function $228234d116878c9c$export$1ba1f66631f7b541({ plan: plan, licenseKey: licenseKey, expiryTimestamp: expiryTimestamp }) {
    $228234d116878c9c$var$showError([
        'MUI X: Expired license key.',
        '',
        `Your annual license key to use MUI X ${plan} in non-production environments has expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${plan} component (more details in https://mui.com/r/x-license-annual).`,
        '',
        'To solve the problem you can either:',
        '',
        '- Renew your license https://mui.com/r/x-get-license and use the new key',
        `- Stop making changes to code depending directly or indirectly on MUI X ${plan}'s APIs`,
        '',
        'Note that your license is perpetual in production environments with any version released before your license term ends.',
        '',
        `- License key expiry timestamp: ${new Date(expiryTimestamp)}`,
        `- Installed license key: ${licenseKey}`,
        ''
    ]);
}
function $228234d116878c9c$export$89cdc76bbf22084e({ plan: plan, licenseKey: licenseKey, expiryTimestamp: expiryTimestamp }) {
    throw new Error([
        'MUI X: Expired license key.',
        '',
        `Your annual license key to use MUI X ${plan} in non-production environments has expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${plan} component (more details in https://mui.com/r/x-license-annual).`,
        '',
        'To solve the problem you can either:',
        '',
        '- Renew your license https://mui.com/r/x-get-license and use the new key',
        `- Stop making changes to code depending directly or indirectly on MUI X ${plan}'s APIs`,
        '',
        'Note that your license is perpetual in production environments with any version released before your license term ends.',
        '',
        `- License key expiry timestamp: ${new Date(expiryTimestamp)}`,
        `- Installed license key: ${licenseKey}`,
        ''
    ].join('\n'));
}




var $lCzvA = parcelRequire("lCzvA");
'use client';
const $1859ff09c7484d7e$var$MuiLicenseInfoContext = /*#__PURE__*/ $lCzvA.createContext({
    key: undefined
});
var $1859ff09c7484d7e$export$2e2bcd8739ae039 = $1859ff09c7484d7e$var$MuiLicenseInfoContext;


const $c865da14b16314cd$export$dc1f6c076f2a5d88 = {};
function $c865da14b16314cd$export$bd780281ba7bfd9(packageName, releaseInfo) {
    const { key: contextKey } = $lCzvA.useContext((0, $1859ff09c7484d7e$export$2e2bcd8739ae039));
    return $lCzvA.useMemo(()=>{
        const licenseKey = contextKey ?? (0, $acf61fefb9f9f42e$export$2c56d2e2ae515eeb).getLicenseKey();
        // Cache the response to not trigger the error twice.
        if ($c865da14b16314cd$export$dc1f6c076f2a5d88[packageName] && $c865da14b16314cd$export$dc1f6c076f2a5d88[packageName].key === licenseKey) return $c865da14b16314cd$export$dc1f6c076f2a5d88[packageName].licenseVerifier;
        const plan = packageName.includes('premium') ? 'Premium' : 'Pro';
        const licenseStatus = (0, $85f6fecf512189c2$export$65cf4e2e0f5c4c60)({
            releaseInfo: releaseInfo,
            licenseKey: licenseKey,
            packageName: packageName
        });
        const fullPackageName = `@mui/${packageName}`;
        if (licenseStatus.status === (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).Valid) ;
        else if (licenseStatus.status === (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).Invalid) (0, $228234d116878c9c$export$e03bc902b0abb5bd)();
        else if (licenseStatus.status === (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).NotAvailableInInitialProPlan) (0, $228234d116878c9c$export$fa76ce5cbafe3dc5)();
        else if (licenseStatus.status === (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).OutOfScope) (0, $228234d116878c9c$export$d0a8365d54384f87)();
        else if (licenseStatus.status === (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).NotFound) (0, $228234d116878c9c$export$bfbf7dff305ffa2a)({
            plan: plan,
            packageName: fullPackageName
        });
        else if (licenseStatus.status === (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).ExpiredAnnualGrace) (0, $228234d116878c9c$export$1ba1f66631f7b541)((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            plan: plan
        }, licenseStatus.meta));
        else if (licenseStatus.status === (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).ExpiredAnnual) (0, $228234d116878c9c$export$89cdc76bbf22084e)((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            plan: plan
        }, licenseStatus.meta));
        else if (licenseStatus.status === (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).ExpiredVersion) (0, $228234d116878c9c$export$242a1b9acf4255b9)({
            packageName: fullPackageName
        });
        $c865da14b16314cd$export$dc1f6c076f2a5d88[packageName] = {
            key: licenseKey,
            licenseVerifier: licenseStatus
        };
        return licenseStatus;
    }, [
        packageName,
        releaseInfo,
        contextKey
    ]);
}

parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");
const $ea432d6ace412cc5$var$is = Object.is;
function $ea432d6ace412cc5$export$84d14f151b531ccb(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    /* eslint-disable guard-for-in */ for(const key in a){
        aLength += 1;
        if (!$ea432d6ace412cc5$var$is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    /* eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */ for(const _ in b)bLength += 1;
    return aLength === bLength;
}


function $87d1c781e22c5bac$export$fa306e0bc9a9d6b4(component) {
    return /*#__PURE__*/ $lCzvA.memo(component, (0, $ea432d6ace412cc5$export$84d14f151b531ccb));
}





function $5d16e7c1dddc1ca7$var$getLicenseErrorMessage(licenseStatus) {
    switch(licenseStatus){
        case (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).ExpiredAnnualGrace:
        case (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).ExpiredAnnual:
            return 'MUI X Expired license key';
        case (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).ExpiredVersion:
            return 'MUI X Expired package version';
        case (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).Invalid:
            return 'MUI X Invalid license key';
        case (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).OutOfScope:
            return 'MUI X License key plan mismatch';
        case (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).NotAvailableInInitialProPlan:
            return 'MUI X Product not covered by plan';
        case (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).NotFound:
            return 'MUI X Missing license key';
        default:
            throw new Error('Unhandled MUI X license status.');
    }
}
function $5d16e7c1dddc1ca7$var$Watermark(props) {
    const { packageName: packageName, releaseInfo: releaseInfo } = props;
    const licenseStatus = (0, $c865da14b16314cd$export$bd780281ba7bfd9)(packageName, releaseInfo);
    if (licenseStatus.status === (0, $2b47e3358682e77e$export$4d5a447ae2d3c7bc).Valid) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            color: '#8282829e',
            zIndex: 100000,
            width: '100%',
            textAlign: 'center',
            bottom: '50%',
            right: 0,
            letterSpacing: 5,
            fontSize: 24
        },
        children: $5d16e7c1dddc1ca7$var$getLicenseErrorMessage(licenseStatus.status)
    });
}
const $5d16e7c1dddc1ca7$export$e94943a72132ebdf = (0, $87d1c781e22c5bac$export$fa306e0bc9a9d6b4)($5d16e7c1dddc1ca7$var$Watermark);



var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");
'use client';
const $b2d323edd8d815c2$export$70c437c2dab15e52 = /*#__PURE__*/ $lCzvA.createContext(undefined);



var $lCzvA = parcelRequire("lCzvA");
const $83c1dc7f69a15312$export$37099e7a34cbf988 = /*#__PURE__*/ $lCzvA.createContext(undefined);
function $83c1dc7f69a15312$export$e1fd9274eb96ee18() {
    const privateApiRef = $lCzvA.useContext($83c1dc7f69a15312$export$37099e7a34cbf988);
    if (privateApiRef === undefined) throw new Error([
        'MUI X: Could not find the Data Grid private context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return privateApiRef;
}



var $lCzvA = parcelRequire("lCzvA");
'use client';
const $7d5db04bce60c865$export$e00c5fe7e13db7ba = /*#__PURE__*/ $lCzvA.createContext(undefined);



var $lCzvA = parcelRequire("lCzvA");
'use client';
const $8258a8c340722781$export$714d6aa898a12d6c = /*#__PURE__*/ $lCzvA.createContext(undefined);



function $954070ecf847201e$export$4fd26c08a15cabb4({ privateApiRef: privateApiRef, configuration: configuration, props: props, children: children }) {
    const apiRef = $lCzvA.useRef(privateApiRef.current.getPublicApi());
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8258a8c340722781$export$714d6aa898a12d6c).Provider, {
        value: configuration,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7d5db04bce60c865$export$e00c5fe7e13db7ba).Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $83c1dc7f69a15312$export$37099e7a34cbf988).Provider, {
                value: privateApiRef,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b2d323edd8d815c2$export$70c437c2dab15e52).Provider, {
                    value: apiRef,
                    children: children
                })
            })
        })
    });
}


function $56fc265171b273f5$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $lCzvA = parcelRequire("lCzvA");

function $6a02406550477b35$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $6a02406550477b35$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $6a02406550477b35$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $6a02406550477b35$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $6a02406550477b35$export$2e2bcd8739ae039 = $6a02406550477b35$export$4f5d2d50c9deca37;


/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $8b74d405de95a30f$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}


function $c4ab204d748cb214$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $8b74d405de95a30f$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $5d3ef6397055422d$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}


var $lCzvA = parcelRequire("lCzvA");
'use client';
function $78465f04bf272330$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $lCzvA.useRef(undefined);
    const refEffect = $lCzvA.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $lCzvA.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}




var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");
var $82a95d0781eedb1d$export$2e2bcd8739ae039 = parseInt($lCzvA.version, 10);


const $74efa9d8b826b453$export$257a8862b851cb5b = (render)=>{
    if ((0, $82a95d0781eedb1d$export$2e2bcd8739ae039) >= 19) {
        const Component = (props)=>render(props, props.ref ?? null);
        Component.displayName = render.displayName ?? render.name;
        return Component;
    }
    return /*#__PURE__*/ $lCzvA.forwardRef(render);
};




function $c1498e616ceaf7e8$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $c1498e616ceaf7e8$export$2e2bcd8739ae039 = $c1498e616ceaf7e8$var$clamp;


/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $595d4f40c92954a4$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $c1498e616ceaf7e8$export$2e2bcd8739ae039)(value, min, max);
}
function $595d4f40c92954a4$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $595d4f40c92954a4$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $595d4f40c92954a4$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $595d4f40c92954a4$export$677b39864803984e($595d4f40c92954a4$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $8b74d405de95a30f$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $8b74d405de95a30f$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $595d4f40c92954a4$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $595d4f40c92954a4$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $595d4f40c92954a4$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $595d4f40c92954a4$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $595d4f40c92954a4$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $595d4f40c92954a4$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $595d4f40c92954a4$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$595d4f40c92954a4$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $595d4f40c92954a4$export$29fb7152bd3f781a(color) {
    color = $595d4f40c92954a4$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $595d4f40c92954a4$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $595d4f40c92954a4$export$c852d90bf7403b62(color) {
    color = $595d4f40c92954a4$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $595d4f40c92954a4$export$677b39864803984e($595d4f40c92954a4$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $595d4f40c92954a4$export$d061e26956a60b0a(foreground, background) {
    const lumA = $595d4f40c92954a4$export$c852d90bf7403b62(foreground);
    const lumB = $595d4f40c92954a4$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $595d4f40c92954a4$export$58f0f39f63f3cf42(color, value) {
    color = $595d4f40c92954a4$export$677b39864803984e(color);
    value = $595d4f40c92954a4$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $595d4f40c92954a4$export$211a73f2b8c10ce4(color);
}
function $595d4f40c92954a4$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $595d4f40c92954a4$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $595d4f40c92954a4$export$4b073707ff63303(color, coefficient) {
    color = $595d4f40c92954a4$export$677b39864803984e(color);
    coefficient = $595d4f40c92954a4$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $595d4f40c92954a4$export$211a73f2b8c10ce4(color);
}
function $595d4f40c92954a4$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $595d4f40c92954a4$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $595d4f40c92954a4$export$c0816ed86df316af(color, coefficient) {
    color = $595d4f40c92954a4$export$677b39864803984e(color);
    coefficient = $595d4f40c92954a4$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $595d4f40c92954a4$export$211a73f2b8c10ce4(color);
}
function $595d4f40c92954a4$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $595d4f40c92954a4$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $595d4f40c92954a4$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $595d4f40c92954a4$export$c852d90bf7403b62(color) > 0.5 ? $595d4f40c92954a4$export$4b073707ff63303(color, coefficient) : $595d4f40c92954a4$export$c0816ed86df316af(color, coefficient);
}
function $595d4f40c92954a4$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $595d4f40c92954a4$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $595d4f40c92954a4$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $595d4f40c92954a4$export$677b39864803984e(background);
    const overlayColor = $595d4f40c92954a4$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $595d4f40c92954a4$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

/**
 * @mui/styled-engine v6.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 

var $lCzvA = parcelRequire("lCzvA");
var $01e7b441532358ca$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $01e7b441532358ca$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $01e7b441532358ca$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $01e7b441532358ca$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$01e7b441532358ca$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($01e7b441532358ca$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $01e7b441532358ca$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $5a2721b01f78ea3b$export$71ad59f2e432cfe8 = "-ms-";
var $5a2721b01f78ea3b$export$2c0f367103c8d01c = "-moz-";
var $5a2721b01f78ea3b$export$39dfd62a25e0fe93 = "-webkit-";
var $5a2721b01f78ea3b$export$a29989082612d0d9 = "comm";
var $5a2721b01f78ea3b$export$aa3a2e812ca8570d = "rule";
var $5a2721b01f78ea3b$export$527d108ccf083c2b = "decl";
var $5a2721b01f78ea3b$export$d3d35020fa5b54f0 = "@page";
var $5a2721b01f78ea3b$export$500415a86c544f73 = "@media";
var $5a2721b01f78ea3b$export$a763edbf796b780a = "@import";
var $5a2721b01f78ea3b$export$2790aeb8b4e5c826 = "@charset";
var $5a2721b01f78ea3b$export$1cc683e23b84b133 = "@viewport";
var $5a2721b01f78ea3b$export$9447a5efea57e862 = "@supports";
var $5a2721b01f78ea3b$export$ef011b4e114b1fba = "@document";
var $5a2721b01f78ea3b$export$6aad947bda0f3f46 = "@namespace";
var $5a2721b01f78ea3b$export$b44a8529a35fcb60 = "@keyframes";
var $5a2721b01f78ea3b$export$2c16de31893252e6 = "@font-face";
var $5a2721b01f78ea3b$export$3d846dd52e150c6f = "@counter-style";
var $5a2721b01f78ea3b$export$22314bfbb57653fe = "@font-feature-values";
var $5a2721b01f78ea3b$export$d773506282b3cfe6 = "@layer";
var $5a2721b01f78ea3b$export$2335f513bbd82c6d = Math.abs;
var $5a2721b01f78ea3b$export$6788812c4e6611e6 = String.fromCharCode;
var $5a2721b01f78ea3b$export$e6e34fd1f2686227 = Object.assign;
function $5a2721b01f78ea3b$export$d6af199866bfb566(e, r) {
    return $5a2721b01f78ea3b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $5a2721b01f78ea3b$export$a9db5e087081082d(e, 0)) << 2 ^ $5a2721b01f78ea3b$export$a9db5e087081082d(e, 1)) << 2 ^ $5a2721b01f78ea3b$export$a9db5e087081082d(e, 2)) << 2 ^ $5a2721b01f78ea3b$export$a9db5e087081082d(e, 3) : 0;
}
function $5a2721b01f78ea3b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $5a2721b01f78ea3b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $5a2721b01f78ea3b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $5a2721b01f78ea3b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $5a2721b01f78ea3b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $5a2721b01f78ea3b$export$36776f635604f274(e) {
    return e.length;
}
function $5a2721b01f78ea3b$export$f9084667e487ed46(e) {
    return e.length;
}
function $5a2721b01f78ea3b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $5a2721b01f78ea3b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $5a2721b01f78ea3b$export$53f1d5ea8de3d7c = 1;
var $5a2721b01f78ea3b$export$4e0c71f277ca26b3 = 1;
var $5a2721b01f78ea3b$export$f24224f1c91d8156 = 0;
var $5a2721b01f78ea3b$export$5880b8b5730aff45 = 0;
var $5a2721b01f78ea3b$export$c0306caf338ac095 = 0;
var $5a2721b01f78ea3b$export$30a86d91af8ff6e6 = "";
function $5a2721b01f78ea3b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $5a2721b01f78ea3b$export$53f1d5ea8de3d7c,
        column: $5a2721b01f78ea3b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $5a2721b01f78ea3b$export$784d13d8ee351f07(e, r) {
    return $5a2721b01f78ea3b$export$e6e34fd1f2686227($5a2721b01f78ea3b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $5a2721b01f78ea3b$export$eba6f6f03b0a92e7() {
    return $5a2721b01f78ea3b$export$c0306caf338ac095;
}
function $5a2721b01f78ea3b$export$232faf9add678146() {
    $5a2721b01f78ea3b$export$c0306caf338ac095 = $5a2721b01f78ea3b$export$5880b8b5730aff45 > 0 ? $5a2721b01f78ea3b$export$a9db5e087081082d($5a2721b01f78ea3b$export$30a86d91af8ff6e6, --$5a2721b01f78ea3b$export$5880b8b5730aff45) : 0;
    if ($5a2721b01f78ea3b$export$4e0c71f277ca26b3--, $5a2721b01f78ea3b$export$c0306caf338ac095 === 10) $5a2721b01f78ea3b$export$4e0c71f277ca26b3 = 1, $5a2721b01f78ea3b$export$53f1d5ea8de3d7c--;
    return $5a2721b01f78ea3b$export$c0306caf338ac095;
}
function $5a2721b01f78ea3b$export$48cfd1e771a65c4f() {
    $5a2721b01f78ea3b$export$c0306caf338ac095 = $5a2721b01f78ea3b$export$5880b8b5730aff45 < $5a2721b01f78ea3b$export$f24224f1c91d8156 ? $5a2721b01f78ea3b$export$a9db5e087081082d($5a2721b01f78ea3b$export$30a86d91af8ff6e6, $5a2721b01f78ea3b$export$5880b8b5730aff45++) : 0;
    if ($5a2721b01f78ea3b$export$4e0c71f277ca26b3++, $5a2721b01f78ea3b$export$c0306caf338ac095 === 10) $5a2721b01f78ea3b$export$4e0c71f277ca26b3 = 1, $5a2721b01f78ea3b$export$53f1d5ea8de3d7c++;
    return $5a2721b01f78ea3b$export$c0306caf338ac095;
}
function $5a2721b01f78ea3b$export$4d3fb11e950abb9e() {
    return $5a2721b01f78ea3b$export$a9db5e087081082d($5a2721b01f78ea3b$export$30a86d91af8ff6e6, $5a2721b01f78ea3b$export$5880b8b5730aff45);
}
function $5a2721b01f78ea3b$export$e88cb2efb12ae807() {
    return $5a2721b01f78ea3b$export$5880b8b5730aff45;
}
function $5a2721b01f78ea3b$export$58adb3bec8346d0f(e, r) {
    return $5a2721b01f78ea3b$export$2f35ab04d2335697($5a2721b01f78ea3b$export$30a86d91af8ff6e6, e, r);
}
function $5a2721b01f78ea3b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $5a2721b01f78ea3b$export$2de70f21292aac9e(e) {
    return $5a2721b01f78ea3b$export$53f1d5ea8de3d7c = $5a2721b01f78ea3b$export$4e0c71f277ca26b3 = 1, $5a2721b01f78ea3b$export$f24224f1c91d8156 = $5a2721b01f78ea3b$export$36776f635604f274($5a2721b01f78ea3b$export$30a86d91af8ff6e6 = e), $5a2721b01f78ea3b$export$5880b8b5730aff45 = 0, [];
}
function $5a2721b01f78ea3b$export$45918ac1574455b1(e) {
    return $5a2721b01f78ea3b$export$30a86d91af8ff6e6 = "", e;
}
function $5a2721b01f78ea3b$export$410ac95b9ec204b8(e) {
    return $5a2721b01f78ea3b$export$87c2784dc9fc4ab($5a2721b01f78ea3b$export$58adb3bec8346d0f($5a2721b01f78ea3b$export$5880b8b5730aff45 - 1, $5a2721b01f78ea3b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $5a2721b01f78ea3b$export$660b2ee2d4fb4eff(e) {
    return $5a2721b01f78ea3b$export$45918ac1574455b1($5a2721b01f78ea3b$export$5f8c09e3ae6f64e1($5a2721b01f78ea3b$export$2de70f21292aac9e(e)));
}
function $5a2721b01f78ea3b$export$7af1228ff777d175(e) {
    while($5a2721b01f78ea3b$export$c0306caf338ac095 = $5a2721b01f78ea3b$export$4d3fb11e950abb9e())if ($5a2721b01f78ea3b$export$c0306caf338ac095 < 33) $5a2721b01f78ea3b$export$48cfd1e771a65c4f();
    else break;
    return $5a2721b01f78ea3b$export$9e1725a4cfeada27(e) > 2 || $5a2721b01f78ea3b$export$9e1725a4cfeada27($5a2721b01f78ea3b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $5a2721b01f78ea3b$export$5f8c09e3ae6f64e1(e) {
    while($5a2721b01f78ea3b$export$48cfd1e771a65c4f())switch($5a2721b01f78ea3b$export$9e1725a4cfeada27($5a2721b01f78ea3b$export$c0306caf338ac095)){
        case 0:
            $5a2721b01f78ea3b$export$10d8903dec122b9d($5a2721b01f78ea3b$export$c2ab62c7bf24634($5a2721b01f78ea3b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $5a2721b01f78ea3b$export$10d8903dec122b9d($5a2721b01f78ea3b$export$410ac95b9ec204b8($5a2721b01f78ea3b$export$c0306caf338ac095), e);
            break;
        default:
            $5a2721b01f78ea3b$export$10d8903dec122b9d($5a2721b01f78ea3b$export$6788812c4e6611e6($5a2721b01f78ea3b$export$c0306caf338ac095), e);
    }
    return e;
}
function $5a2721b01f78ea3b$export$955ba06d119e085e(e, r) {
    while(--r && $5a2721b01f78ea3b$export$48cfd1e771a65c4f())if ($5a2721b01f78ea3b$export$c0306caf338ac095 < 48 || $5a2721b01f78ea3b$export$c0306caf338ac095 > 102 || $5a2721b01f78ea3b$export$c0306caf338ac095 > 57 && $5a2721b01f78ea3b$export$c0306caf338ac095 < 65 || $5a2721b01f78ea3b$export$c0306caf338ac095 > 70 && $5a2721b01f78ea3b$export$c0306caf338ac095 < 97) break;
    return $5a2721b01f78ea3b$export$58adb3bec8346d0f(e, $5a2721b01f78ea3b$export$e88cb2efb12ae807() + (r < 6 && $5a2721b01f78ea3b$export$4d3fb11e950abb9e() == 32 && $5a2721b01f78ea3b$export$48cfd1e771a65c4f() == 32));
}
function $5a2721b01f78ea3b$export$c889f2fcc19dbf12(e) {
    while($5a2721b01f78ea3b$export$48cfd1e771a65c4f())switch($5a2721b01f78ea3b$export$c0306caf338ac095){
        case e:
            return $5a2721b01f78ea3b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $5a2721b01f78ea3b$export$c889f2fcc19dbf12($5a2721b01f78ea3b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $5a2721b01f78ea3b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $5a2721b01f78ea3b$export$48cfd1e771a65c4f();
            break;
    }
    return $5a2721b01f78ea3b$export$5880b8b5730aff45;
}
function $5a2721b01f78ea3b$export$4254d4e2b3745c4c(e, r) {
    while($5a2721b01f78ea3b$export$48cfd1e771a65c4f())if (e + $5a2721b01f78ea3b$export$c0306caf338ac095 === 57) break;
    else if (e + $5a2721b01f78ea3b$export$c0306caf338ac095 === 84 && $5a2721b01f78ea3b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $5a2721b01f78ea3b$export$58adb3bec8346d0f(r, $5a2721b01f78ea3b$export$5880b8b5730aff45 - 1) + "*" + $5a2721b01f78ea3b$export$6788812c4e6611e6(e === 47 ? e : $5a2721b01f78ea3b$export$48cfd1e771a65c4f());
}
function $5a2721b01f78ea3b$export$c2ab62c7bf24634(e) {
    while(!$5a2721b01f78ea3b$export$9e1725a4cfeada27($5a2721b01f78ea3b$export$4d3fb11e950abb9e()))$5a2721b01f78ea3b$export$48cfd1e771a65c4f();
    return $5a2721b01f78ea3b$export$58adb3bec8346d0f(e, $5a2721b01f78ea3b$export$5880b8b5730aff45);
}
function $5a2721b01f78ea3b$export$ef7acd7185315e22(e) {
    return $5a2721b01f78ea3b$export$45918ac1574455b1($5a2721b01f78ea3b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $5a2721b01f78ea3b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $5a2721b01f78ea3b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $5a2721b01f78ea3b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $5a2721b01f78ea3b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($5a2721b01f78ea3b$export$f8e21b1e77979a08(j += $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed($5a2721b01f78ea3b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $5a2721b01f78ea3b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $5a2721b01f78ea3b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $5a2721b01f78ea3b$export$955ba06d119e085e($5a2721b01f78ea3b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($5a2721b01f78ea3b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $5a2721b01f78ea3b$export$10d8903dec122b9d($5a2721b01f78ea3b$export$4a34f930e789283c($5a2721b01f78ea3b$export$4254d4e2b3745c4c($5a2721b01f78ea3b$export$48cfd1e771a65c4f(), $5a2721b01f78ea3b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $5a2721b01f78ea3b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $5a2721b01f78ea3b$export$36776f635604f274(j) - l) $5a2721b01f78ea3b$export$10d8903dec122b9d(p > 32 ? $5a2721b01f78ea3b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $5a2721b01f78ea3b$export$f8483753829ec8f3($5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $5a2721b01f78ea3b$export$10d8903dec122b9d(y = $5a2721b01f78ea3b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $5a2721b01f78ea3b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $5a2721b01f78ea3b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $5a2721b01f78ea3b$export$98e6a39c04603d36(e, y, y, n && $5a2721b01f78ea3b$export$10d8903dec122b9d($5a2721b01f78ea3b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $5a2721b01f78ea3b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $5a2721b01f78ea3b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $5a2721b01f78ea3b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $5a2721b01f78ea3b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($5a2721b01f78ea3b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($5a2721b01f78ea3b$export$4d3fb11e950abb9e() === 45) j += $5a2721b01f78ea3b$export$410ac95b9ec204b8($5a2721b01f78ea3b$export$48cfd1e771a65c4f());
                    v = $5a2721b01f78ea3b$export$4d3fb11e950abb9e(), o = l = $5a2721b01f78ea3b$export$36776f635604f274(g = j += $5a2721b01f78ea3b$export$c2ab62c7bf24634($5a2721b01f78ea3b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $5a2721b01f78ea3b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $5a2721b01f78ea3b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $5a2721b01f78ea3b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $5a2721b01f78ea3b$export$2f35ab04d2335697(e, v + 1, v = $5a2721b01f78ea3b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $5a2721b01f78ea3b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $5a2721b01f78ea3b$export$35059013cd4a06db(e, r, a, s === 0 ? $5a2721b01f78ea3b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $5a2721b01f78ea3b$export$4a34f930e789283c(e, r, a) {
    return $5a2721b01f78ea3b$export$35059013cd4a06db(e, r, a, $5a2721b01f78ea3b$export$a29989082612d0d9, $5a2721b01f78ea3b$export$6788812c4e6611e6($5a2721b01f78ea3b$export$eba6f6f03b0a92e7()), $5a2721b01f78ea3b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $5a2721b01f78ea3b$export$f8483753829ec8f3(e, r, a, n) {
    return $5a2721b01f78ea3b$export$35059013cd4a06db(e, r, a, $5a2721b01f78ea3b$export$527d108ccf083c2b, $5a2721b01f78ea3b$export$2f35ab04d2335697(e, 0, n), $5a2721b01f78ea3b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $5a2721b01f78ea3b$export$82e9f45cca5ba907(n, c, s) {
    switch($5a2721b01f78ea3b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $5a2721b01f78ea3b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$2c0f367103c8d01c + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($5a2721b01f78ea3b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "box-$1$2" + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + "flex-item-" + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$5a2721b01f78ea3b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + "grid-row-" + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + "flex-line-pack" + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "box-" + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed($5a2721b01f78ea3b$export$77ad94ebf1c2b9ed($5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed($5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "box-pack:$3" + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$5a2721b01f78ea3b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + "grid-column-align" + $5a2721b01f78ea3b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $5a2721b01f78ea3b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$5a2721b01f78ea3b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$5a2721b01f78ea3b$export$f8e21b1e77979a08(s, "span") ? $5a2721b01f78ea3b$export$4659b591c19bdf3d(s, /\d+/) : +$5a2721b01f78ea3b$export$4659b591c19bdf3d(s, /\d+/) - +$5a2721b01f78ea3b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $5a2721b01f78ea3b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed($5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($5a2721b01f78ea3b$export$36776f635604f274(n) - 1 - c > 6) switch($5a2721b01f78ea3b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($5a2721b01f78ea3b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $5a2721b01f78ea3b$export$2c0f367103c8d01c + ($5a2721b01f78ea3b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$5a2721b01f78ea3b$export$f8e21b1e77979a08(n, "stretch") ? $5a2721b01f78ea3b$export$82e9f45cca5ba907($5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($5a2721b01f78ea3b$export$a9db5e087081082d(n, c + 6) === 121) return $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, ":", ":" + $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($5a2721b01f78ea3b$export$a9db5e087081082d(n, $5a2721b01f78ea3b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + ($5a2721b01f78ea3b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, ":", ":" + $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $5a2721b01f78ea3b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $5a2721b01f78ea3b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $5a2721b01f78ea3b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $5a2721b01f78ea3b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $5a2721b01f78ea3b$export$a763edbf796b780a:
        case $5a2721b01f78ea3b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $5a2721b01f78ea3b$export$a29989082612d0d9:
            return "";
        case $5a2721b01f78ea3b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $5a2721b01f78ea3b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $5a2721b01f78ea3b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $5a2721b01f78ea3b$export$36776f635604f274(a = $5a2721b01f78ea3b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $5a2721b01f78ea3b$export$5a7767152ae0305f(e) {
    var r = $5a2721b01f78ea3b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $5a2721b01f78ea3b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $5a2721b01f78ea3b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $5a2721b01f78ea3b$export$527d108ccf083c2b:
                n.return = $5a2721b01f78ea3b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $5a2721b01f78ea3b$export$b44a8529a35fcb60:
                return $5a2721b01f78ea3b$export$dfdc1655ccc5b9cb([
                    $5a2721b01f78ea3b$export$784d13d8ee351f07(n, {
                        value: $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $5a2721b01f78ea3b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $5a2721b01f78ea3b$export$aa3a2e812ca8570d:
                if (n.length) return $5a2721b01f78ea3b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($5a2721b01f78ea3b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $5a2721b01f78ea3b$export$dfdc1655ccc5b9cb([
                                $5a2721b01f78ea3b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $5a2721b01f78ea3b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $5a2721b01f78ea3b$export$dfdc1655ccc5b9cb([
                                $5a2721b01f78ea3b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $5a2721b01f78ea3b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $5a2721b01f78ea3b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $5a2721b01f78ea3b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $5a2721b01f78ea3b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $5a2721b01f78ea3b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $5a2721b01f78ea3b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $5a2721b01f78ea3b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $5a2721b01f78ea3b$export$1be1fc439b849fdf($5a2721b01f78ea3b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($5a2721b01f78ea3b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $5a2721b01f78ea3b$export$2f35ab04d2335697(r, 1, $5a2721b01f78ea3b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $5a2721b01f78ea3b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $5a2721b01f78ea3b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $5a2721b01f78ea3b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $15ae72c21281a04b$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};



var $18d96864162c485e$var$isBrowser = typeof document !== 'undefined';
var $18d96864162c485e$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $5a2721b01f78ea3b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $5a2721b01f78ea3b$export$9e1725a4cfeada27)(character)) break;
        (0, $5a2721b01f78ea3b$export$48cfd1e771a65c4f)();
    }
    return (0, $5a2721b01f78ea3b$export$58adb3bec8346d0f)(begin, (0, $5a2721b01f78ea3b$export$5880b8b5730aff45));
};
var $18d96864162c485e$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $5a2721b01f78ea3b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $5a2721b01f78ea3b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $18d96864162c485e$var$identifierWithPointTracking((0, $5a2721b01f78ea3b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $5a2721b01f78ea3b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $5a2721b01f78ea3b$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $5a2721b01f78ea3b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $5a2721b01f78ea3b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $18d96864162c485e$var$getRules = function getRules(value, points) {
    return (0, $5a2721b01f78ea3b$export$45918ac1574455b1)($18d96864162c485e$var$toRules((0, $5a2721b01f78ea3b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $18d96864162c485e$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $18d96864162c485e$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$18d96864162c485e$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $18d96864162c485e$var$fixedElements.set(element, true);
    var points = [];
    var rules = $18d96864162c485e$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $18d96864162c485e$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $18d96864162c485e$var$prefix(value, length) {
    switch((0, $5a2721b01f78ea3b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$2c0f367103c8d01c) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + 'box-' + (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)((0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)((0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)((0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5a2721b01f78ea3b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5a2721b01f78ea3b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5a2721b01f78ea3b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $5a2721b01f78ea3b$export$2c0f367103c8d01c) + ((0, $5a2721b01f78ea3b$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5a2721b01f78ea3b$export$f8e21b1e77979a08)(value, 'stretch') ? $18d96864162c485e$var$prefix((0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $5a2721b01f78ea3b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $5a2721b01f78ea3b$export$a9db5e087081082d)(value, (0, $5a2721b01f78ea3b$export$36776f635604f274)(value) - 3 - (~(0, $5a2721b01f78ea3b$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + ((0, $5a2721b01f78ea3b$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $5a2721b01f78ea3b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + value + (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $18d96864162c485e$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $5a2721b01f78ea3b$export$527d108ccf083c2b:
                element["return"] = $18d96864162c485e$var$prefix(element.value, element.length);
                break;
            case 0, $5a2721b01f78ea3b$export$b44a8529a35fcb60:
                return (0, $5a2721b01f78ea3b$export$dfdc1655ccc5b9cb)([
                    (0, $5a2721b01f78ea3b$export$784d13d8ee351f07)(element, {
                        value: (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $5a2721b01f78ea3b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5a2721b01f78ea3b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5a2721b01f78ea3b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $5a2721b01f78ea3b$export$dfdc1655ccc5b9cb)([
                                (0, $5a2721b01f78ea3b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $5a2721b01f78ea3b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $5a2721b01f78ea3b$export$dfdc1655ccc5b9cb)([
                                (0, $5a2721b01f78ea3b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $5a2721b01f78ea3b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $5a2721b01f78ea3b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $5a2721b01f78ea3b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $5a2721b01f78ea3b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5a2721b01f78ea3b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $5a2721b01f78ea3b$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $18d96864162c485e$var$getServerStylisCache = $18d96864162c485e$var$isBrowser ? undefined : (0, $15ae72c21281a04b$export$2e2bcd8739ae039)(function() {
    return (0, $8269bd5b276bbb74$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $18d96864162c485e$var$defaultStylisPlugins = [
    $18d96864162c485e$var$prefixer
];
var $18d96864162c485e$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($18d96864162c485e$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $18d96864162c485e$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($18d96864162c485e$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $18d96864162c485e$var$compat,
        $18d96864162c485e$var$removeLabel
    ];
    if (!$18d96864162c485e$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $5a2721b01f78ea3b$export$fac44ee5b035f737),
            (0, $5a2721b01f78ea3b$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $5a2721b01f78ea3b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $5a2721b01f78ea3b$export$dfdc1655ccc5b9cb)((0, $5a2721b01f78ea3b$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $5a2721b01f78ea3b$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $5a2721b01f78ea3b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $5a2721b01f78ea3b$export$dfdc1655ccc5b9cb)((0, $5a2721b01f78ea3b$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $18d96864162c485e$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $01e7b441532358ca$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $4a09f1ca296c8389$exports = {};
'use strict';
var $921927d41e935999$exports = {};
'use strict';

$921927d41e935999$exports = (parcelRequire("8ujjx"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $4a09f1ca296c8389$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $4a09f1ca296c8389$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $4a09f1ca296c8389$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $4a09f1ca296c8389$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $4a09f1ca296c8389$var$TYPE_STATICS = {};
$4a09f1ca296c8389$var$TYPE_STATICS[$921927d41e935999$exports.ForwardRef] = $4a09f1ca296c8389$var$FORWARD_REF_STATICS;
$4a09f1ca296c8389$var$TYPE_STATICS[$921927d41e935999$exports.Memo] = $4a09f1ca296c8389$var$MEMO_STATICS;
function $4a09f1ca296c8389$var$getStatics(component) {
    // React v16.11 and below
    if ($921927d41e935999$exports.isMemo(component)) return $4a09f1ca296c8389$var$MEMO_STATICS;
     // React v16.12 and above
    return $4a09f1ca296c8389$var$TYPE_STATICS[component['$$typeof']] || $4a09f1ca296c8389$var$REACT_STATICS;
}
var $4a09f1ca296c8389$var$defineProperty = Object.defineProperty;
var $4a09f1ca296c8389$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $4a09f1ca296c8389$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4a09f1ca296c8389$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $4a09f1ca296c8389$var$getPrototypeOf = Object.getPrototypeOf;
var $4a09f1ca296c8389$var$objectPrototype = Object.prototype;
function $4a09f1ca296c8389$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($4a09f1ca296c8389$var$objectPrototype) {
            var inheritedComponent = $4a09f1ca296c8389$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $4a09f1ca296c8389$var$objectPrototype) $4a09f1ca296c8389$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $4a09f1ca296c8389$var$getOwnPropertyNames(sourceComponent);
        if ($4a09f1ca296c8389$var$getOwnPropertySymbols) keys = keys.concat($4a09f1ca296c8389$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $4a09f1ca296c8389$var$getStatics(targetComponent);
        var sourceStatics = $4a09f1ca296c8389$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$4a09f1ca296c8389$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $4a09f1ca296c8389$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $4a09f1ca296c8389$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$4a09f1ca296c8389$exports = $4a09f1ca296c8389$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $0a03c06e1994b681$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4a09f1ca296c8389$exports)))(targetComponent, sourceComponent);
};


var $fecc90be9368e5e6$var$isBrowser = typeof document !== 'undefined';
function $fecc90be9368e5e6$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $fecc90be9368e5e6$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $fecc90be9368e5e6$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $fecc90be9368e5e6$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $fecc90be9368e5e6$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$fecc90be9368e5e6$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$fecc90be9368e5e6$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3545a7418c13b163$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $832d6da8c5c7ba4f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $a6e7daf06576f8f9$var$isDevelopment = false;
var $a6e7daf06576f8f9$var$hyphenateRegex = /[A-Z]|^ms/g;
var $a6e7daf06576f8f9$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $a6e7daf06576f8f9$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $a6e7daf06576f8f9$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $a6e7daf06576f8f9$var$processStyleName = /* #__PURE__ */ (0, $8269bd5b276bbb74$export$2e2bcd8739ae039)(function(styleName) {
    return $a6e7daf06576f8f9$var$isCustomProperty(styleName) ? styleName : styleName.replace($a6e7daf06576f8f9$var$hyphenateRegex, '-$&').toLowerCase();
});
var $a6e7daf06576f8f9$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($a6e7daf06576f8f9$var$animationRegex, function(match, p1, p2) {
                $a6e7daf06576f8f9$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $a6e7daf06576f8f9$var$cursor
                };
                return p1;
            });
    }
    if ((0, $832d6da8c5c7ba4f$export$2e2bcd8739ae039)[key] !== 1 && !$a6e7daf06576f8f9$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $a6e7daf06576f8f9$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $a6e7daf06576f8f9$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $a6e7daf06576f8f9$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $a6e7daf06576f8f9$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $a6e7daf06576f8f9$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $a6e7daf06576f8f9$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $a6e7daf06576f8f9$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $a6e7daf06576f8f9$var$cursor;
                var result = interpolation(mergedProps);
                $a6e7daf06576f8f9$var$cursor = previousCursor;
                return $a6e7daf06576f8f9$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $a6e7daf06576f8f9$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $a6e7daf06576f8f9$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($a6e7daf06576f8f9$var$isProcessableValue(asString)) string += $a6e7daf06576f8f9$var$processStyleName(key) + ":" + $a6e7daf06576f8f9$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $a6e7daf06576f8f9$var$isDevelopment) throw new Error($a6e7daf06576f8f9$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($a6e7daf06576f8f9$var$isProcessableValue(value[_i])) string += $a6e7daf06576f8f9$var$processStyleName(key) + ":" + $a6e7daf06576f8f9$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $a6e7daf06576f8f9$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $a6e7daf06576f8f9$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $a6e7daf06576f8f9$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $a6e7daf06576f8f9$var$cursor;
function $a6e7daf06576f8f9$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $a6e7daf06576f8f9$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $a6e7daf06576f8f9$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $a6e7daf06576f8f9$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $a6e7daf06576f8f9$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $a6e7daf06576f8f9$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $3545a7418c13b163$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $a6e7daf06576f8f9$var$cursor
    };
}



var $lCzvA = parcelRequire("lCzvA");
var $1c1a740ac6a8e39c$var$isBrowser = typeof document !== 'undefined';
var $1c1a740ac6a8e39c$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1c1a740ac6a8e39c$var$useInsertionEffect = $lCzvA.useInsertionEffect ? $lCzvA.useInsertionEffect : false;
var $1c1a740ac6a8e39c$export$db21c7ffa21794e7 = !$1c1a740ac6a8e39c$var$isBrowser ? $1c1a740ac6a8e39c$var$syncFallback : $1c1a740ac6a8e39c$var$useInsertionEffect || $1c1a740ac6a8e39c$var$syncFallback;
var $1c1a740ac6a8e39c$export$811a713a7276cb9d = $1c1a740ac6a8e39c$var$useInsertionEffect || $lCzvA.useLayoutEffect;


var $3697f0399be2fa10$export$407448d2b89b1813 = false;
var $3697f0399be2fa10$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $3697f0399be2fa10$var$EmotionCacheContext = /* #__PURE__ */ $lCzvA.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $18d96864162c485e$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $3697f0399be2fa10$export$e7094788287c5e9b = $3697f0399be2fa10$var$EmotionCacheContext.Provider;
var $3697f0399be2fa10$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $lCzvA.useContext)($3697f0399be2fa10$var$EmotionCacheContext);
};
var $3697f0399be2fa10$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $lCzvA.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $lCzvA.useContext)($3697f0399be2fa10$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$3697f0399be2fa10$export$23f2a1d2818174ef) $3697f0399be2fa10$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $lCzvA.useContext)($3697f0399be2fa10$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $18d96864162c485e$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $lCzvA.createElement($3697f0399be2fa10$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $3697f0399be2fa10$export$971d5caa766a69d7 = /* #__PURE__ */ $lCzvA.createContext({});
var $3697f0399be2fa10$export$3b14a55fb2447963 = function useTheme() {
    return $lCzvA.useContext($3697f0399be2fa10$export$971d5caa766a69d7);
};
var $3697f0399be2fa10$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $3697f0399be2fa10$var$createCacheWithTheme = /* #__PURE__ */ (0, $15ae72c21281a04b$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $15ae72c21281a04b$export$2e2bcd8739ae039)(function(theme) {
        return $3697f0399be2fa10$var$getTheme(outerTheme, theme);
    });
});
var $3697f0399be2fa10$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $lCzvA.useContext($3697f0399be2fa10$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $3697f0399be2fa10$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $lCzvA.createElement($3697f0399be2fa10$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $3697f0399be2fa10$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $lCzvA.forwardRef(function render(props, ref) {
        var theme = $lCzvA.useContext($3697f0399be2fa10$export$971d5caa766a69d7);
        return /*#__PURE__*/ $lCzvA.createElement(Component, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $0a03c06e1994b681$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $3697f0399be2fa10$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $3697f0399be2fa10$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $3697f0399be2fa10$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($3697f0399be2fa10$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$3697f0399be2fa10$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $3697f0399be2fa10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fecc90be9368e5e6$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $1c1a740ac6a8e39c$export$db21c7ffa21794e7)(function() {
        return (0, $fecc90be9368e5e6$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$3697f0399be2fa10$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $lCzvA.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $3697f0399be2fa10$var$Emotion = /* #__PURE__ */ $3697f0399be2fa10$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$3697f0399be2fa10$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $fecc90be9368e5e6$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $a6e7daf06576f8f9$export$6321afa313b251b5)(registeredStyles, undefined, $lCzvA.useContext($3697f0399be2fa10$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($3697f0399be2fa10$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $3697f0399be2fa10$var$typePropName && !$3697f0399be2fa10$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $lCzvA.createElement($lCzvA.Fragment, null, /*#__PURE__*/ $lCzvA.createElement($3697f0399be2fa10$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $lCzvA.createElement(WrappedComponent, newProps));
});
var $3697f0399be2fa10$export$a9c23c6ac3fc3eca = $3697f0399be2fa10$var$Emotion;



var $lCzvA = parcelRequire("lCzvA");




var $3fb70257d5ce83ef$exports = {};
function $3fb70257d5ce83ef$var$_extends() {
    return $3fb70257d5ce83ef$exports = $3fb70257d5ce83ef$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3fb70257d5ce83ef$exports.__esModule = true, $3fb70257d5ce83ef$exports["default"] = $3fb70257d5ce83ef$exports, $3fb70257d5ce83ef$var$_extends.apply(null, arguments);
}
$3fb70257d5ce83ef$exports = $3fb70257d5ce83ef$var$_extends, $3fb70257d5ce83ef$exports.__esModule = true, $3fb70257d5ce83ef$exports["default"] = $3fb70257d5ce83ef$exports;





var $02d5075f8320414d$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $3697f0399be2fa10$export$dda1d9f60106f0e9).call(props, 'css')) return $lCzvA.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $3697f0399be2fa10$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $3697f0399be2fa10$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $lCzvA.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($02d5075f8320414d$export$c8a8987d4410bf2d || ($02d5075f8320414d$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $02d5075f8320414d$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $3697f0399be2fa10$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $a6e7daf06576f8f9$export$6321afa313b251b5)([
        styles
    ], undefined, $lCzvA.useContext((0, $3697f0399be2fa10$export$971d5caa766a69d7)));
    if (!(0, $3697f0399be2fa10$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $lCzvA.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $lCzvA.useRef();
    (0, $1c1a740ac6a8e39c$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $1c1a740ac6a8e39c$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $fecc90be9368e5e6$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $02d5075f8320414d$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $a6e7daf06576f8f9$export$6321afa313b251b5)(args);
}
function $02d5075f8320414d$export$d25ddfdf17c3ad3e() {
    var insertable = $02d5075f8320414d$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $02d5075f8320414d$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $02d5075f8320414d$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $fecc90be9368e5e6$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $02d5075f8320414d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $1c1a740ac6a8e39c$export$db21c7ffa21794e7)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $fecc90be9368e5e6$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
            if (!(0, $3697f0399be2fa10$export$23f2a1d2818174ef) && res !== undefined) rules += res;
        }
        if (!(0, $3697f0399be2fa10$export$23f2a1d2818174ef)) return rules;
    });
    if (!(0, $3697f0399be2fa10$export$23f2a1d2818174ef) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $lCzvA.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $02d5075f8320414d$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $3697f0399be2fa10$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $3697f0399be2fa10$export$407448d2b89b1813)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $a6e7daf06576f8f9$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $fecc90be9368e5e6$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $3697f0399be2fa10$export$407448d2b89b1813)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $02d5075f8320414d$var$merge(cache.registered, css, $02d5075f8320414d$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $lCzvA.useContext((0, $3697f0399be2fa10$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $lCzvA.createElement($lCzvA.Fragment, null, /*#__PURE__*/ $lCzvA.createElement($02d5075f8320414d$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});






var $lCzvA = parcelRequire("lCzvA");

var $6b465bf94806cd1f$var$isBrowser = typeof document !== 'undefined';
var $6b465bf94806cd1f$var$isDevelopment = false;
var $6b465bf94806cd1f$var$testOmitPropsOnStringTag = (0, $9d3b363be4fdb0ac$export$2e2bcd8739ae039);
var $6b465bf94806cd1f$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $6b465bf94806cd1f$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $6b465bf94806cd1f$var$testOmitPropsOnStringTag : $6b465bf94806cd1f$var$testOmitPropsOnComponent;
};
var $6b465bf94806cd1f$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $6b465bf94806cd1f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fecc90be9368e5e6$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $1c1a740ac6a8e39c$export$db21c7ffa21794e7)(function() {
        return (0, $fecc90be9368e5e6$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$6b465bf94806cd1f$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $lCzvA.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $6b465bf94806cd1f$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $6b465bf94806cd1f$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $6b465bf94806cd1f$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $3697f0399be2fa10$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $lCzvA.useContext((0, $3697f0399be2fa10$export$971d5caa766a69d7));
            }
            if (typeof props.className === 'string') className = (0, $fecc90be9368e5e6$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $a6e7daf06576f8f9$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $6b465bf94806cd1f$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $lCzvA.createElement($lCzvA.Fragment, null, /*#__PURE__*/ $lCzvA.createElement($6b465bf94806cd1f$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $lCzvA.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $6b465bf94806cd1f$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $6b465bf94806cd1f$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};







parcelRequire("lCzvA");

var $95cb98b8712d0f87$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $95cb98b8712d0f87$export$2e2bcd8739ae039 = (0, $6b465bf94806cd1f$export$2e2bcd8739ae039).bind(null);
$95cb98b8712d0f87$var$tags.forEach(function(tagName) {
    $95cb98b8712d0f87$export$2e2bcd8739ae039[tagName] = $95cb98b8712d0f87$export$2e2bcd8739ae039(tagName);
});





parcelRequire("lCzvA");



'use client';
function $b2b85fe90a717478$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $b2b85fe90a717478$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($b2b85fe90a717478$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $02d5075f8320414d$export$98f03c5d19621d70), {
        styles: globalStyles
    });
}


function $36107f55192c81c9$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $95cb98b8712d0f87$export$2e2bcd8739ae039)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $36107f55192c81c9$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $36107f55192c81c9$var$wrapper = [];
function $36107f55192c81c9$export$13a2d3ef13012b32(styles) {
    $36107f55192c81c9$var$wrapper[0] = styles;
    return (0, $a6e7daf06576f8f9$export$6321afa313b251b5)($36107f55192c81c9$var$wrapper);
}



var $lCzvA = parcelRequire("lCzvA");
var $e82225897c6e8ce9$exports = {};
'use strict';

$e82225897c6e8ce9$exports = (parcelRequire("3Z4cM"));


function $b80cadb21e077670$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $b80cadb21e077670$var$deepClone(source) {
    if (/*#__PURE__*/ $lCzvA.isValidElement(source) || (0, $e82225897c6e8ce9$exports.isValidElementType)(source) || !$b80cadb21e077670$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $b80cadb21e077670$var$deepClone(source[key]);
    });
    return output;
}
function $b80cadb21e077670$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($b80cadb21e077670$export$53b83ca8eaab0383(target) && $b80cadb21e077670$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $lCzvA.isValidElement(source[key]) || (0, $e82225897c6e8ce9$exports.isValidElementType)(source[key])) output[key] = source[key];
        else if ($b80cadb21e077670$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $b80cadb21e077670$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $b80cadb21e077670$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $b80cadb21e077670$export$53b83ca8eaab0383(source[key]) ? $b80cadb21e077670$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}




function $dce6bab64ce19e9c$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $dce6bab64ce19e9c$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $dce6bab64ce19e9c$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $dce6bab64ce19e9c$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $dce6bab64ce19e9c$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $e82225897c6e8ce9$exports.ForwardRef:
            return $dce6bab64ce19e9c$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $e82225897c6e8ce9$exports.Memo:
            return $dce6bab64ce19e9c$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}



// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $bde46e956197d217$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $bde46e956197d217$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $bde46e956197d217$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $bde46e956197d217$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}



function $6abdc446fd43a33d$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $6abdc446fd43a33d$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $6abdc446fd43a33d$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $6abdc446fd43a33d$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $6d4223a1013948e7$var$shape = {
    borderRadius: 4
};
var $6d4223a1013948e7$export$2e2bcd8739ae039 = $6d4223a1013948e7$var$shape;






function $b4c9ac35fe1a6f23$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $b80cadb21e077670$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $b4c9ac35fe1a6f23$export$2e2bcd8739ae039 = $b4c9ac35fe1a6f23$var$merge;



const $b439bd7d3bc95abb$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $b439bd7d3bc95abb$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$b439bd7d3bc95abb$export$68c286be0e7e55b7[key]}px)`
};
const $b439bd7d3bc95abb$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $b439bd7d3bc95abb$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $b439bd7d3bc95abb$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $b439bd7d3bc95abb$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $b439bd7d3bc95abb$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $6abdc446fd43a33d$export$77c7c3e357f440e7)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $6abdc446fd43a33d$export$10a9745dfa00d15)(theme.containerQueries ? theme : $b439bd7d3bc95abb$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $b439bd7d3bc95abb$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $b439bd7d3bc95abb$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $b439bd7d3bc95abb$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $b4c9ac35fe1a6f23$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $b439bd7d3bc95abb$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $b439bd7d3bc95abb$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $b439bd7d3bc95abb$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $b439bd7d3bc95abb$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $b80cadb21e077670$export$2e2bcd8739ae039)(prev, next), {});
    return $b439bd7d3bc95abb$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $b439bd7d3bc95abb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $b439bd7d3bc95abb$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $b439bd7d3bc95abb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $b439bd7d3bc95abb$export$2e2bcd8739ae039 = $b439bd7d3bc95abb$var$breakpoints;





function $e7e4643a54a85b6e$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $e7e4643a54a85b6e$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $e7e4643a54a85b6e$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $e7e4643a54a85b6e$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $e7e4643a54a85b6e$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $e7e4643a54a85b6e$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $e7e4643a54a85b6e$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $c4ab204d748cb214$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $b439bd7d3bc95abb$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $e7e4643a54a85b6e$export$2e2bcd8739ae039 = $e7e4643a54a85b6e$var$style;



function $a2e708ef750a5728$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $dbe25e70fba611ca$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $dbe25e70fba611ca$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $dbe25e70fba611ca$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $dbe25e70fba611ca$var$getCssProperties = (0, $a2e708ef750a5728$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($dbe25e70fba611ca$var$aliases[prop]) prop = $dbe25e70fba611ca$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $dbe25e70fba611ca$var$properties[a];
    const direction = $dbe25e70fba611ca$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $dbe25e70fba611ca$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $dbe25e70fba611ca$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $dbe25e70fba611ca$var$spacingKeys = [
    ...$dbe25e70fba611ca$export$aab52a0dde05ad8a,
    ...$dbe25e70fba611ca$export$f8397d44f03ab6ad
];
function $dbe25e70fba611ca$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $e7e4643a54a85b6e$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $dbe25e70fba611ca$export$1def6f833384e3d1(theme) {
    return $dbe25e70fba611ca$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $dbe25e70fba611ca$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $dbe25e70fba611ca$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $dbe25e70fba611ca$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $dbe25e70fba611ca$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $dbe25e70fba611ca$var$getCssProperties(prop);
    const styleFromPropValue = $dbe25e70fba611ca$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $b439bd7d3bc95abb$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $dbe25e70fba611ca$var$style(props, keys) {
    const transformer = $dbe25e70fba611ca$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$dbe25e70fba611ca$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $b4c9ac35fe1a6f23$export$2e2bcd8739ae039), {});
}
function $dbe25e70fba611ca$export$7ede87f9b603dd3c(props) {
    return $dbe25e70fba611ca$var$style(props, $dbe25e70fba611ca$export$aab52a0dde05ad8a);
}
$dbe25e70fba611ca$export$7ede87f9b603dd3c.propTypes = {};
$dbe25e70fba611ca$export$7ede87f9b603dd3c.filterProps = $dbe25e70fba611ca$export$aab52a0dde05ad8a;
function $dbe25e70fba611ca$export$6f98e8eaf0be1996(props) {
    return $dbe25e70fba611ca$var$style(props, $dbe25e70fba611ca$export$f8397d44f03ab6ad);
}
$dbe25e70fba611ca$export$6f98e8eaf0be1996.propTypes = {};
$dbe25e70fba611ca$export$6f98e8eaf0be1996.filterProps = $dbe25e70fba611ca$export$f8397d44f03ab6ad;
function $dbe25e70fba611ca$var$spacing(props) {
    return $dbe25e70fba611ca$var$style(props, $dbe25e70fba611ca$var$spacingKeys);
}
$dbe25e70fba611ca$var$spacing.propTypes = {};
$dbe25e70fba611ca$var$spacing.filterProps = $dbe25e70fba611ca$var$spacingKeys;
var $dbe25e70fba611ca$export$2e2bcd8739ae039 = $dbe25e70fba611ca$var$spacing;


function $c24c1a5ee4facbc8$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $dbe25e70fba611ca$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}











function $6d6c4621433c4187$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $b4c9ac35fe1a6f23$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $6d6c4621433c4187$export$2e2bcd8739ae039 = $6d6c4621433c4187$var$compose;




function $f4e54a52170619ec$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $f4e54a52170619ec$var$createBorderStyle(prop, transform) {
    return (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $f4e54a52170619ec$export$1edee58a52776cd9 = $f4e54a52170619ec$var$createBorderStyle('border', $f4e54a52170619ec$export$34e2febe53ae29cc);
const $f4e54a52170619ec$export$f9a7b6bd24892946 = $f4e54a52170619ec$var$createBorderStyle('borderTop', $f4e54a52170619ec$export$34e2febe53ae29cc);
const $f4e54a52170619ec$export$5abca33e6be905d2 = $f4e54a52170619ec$var$createBorderStyle('borderRight', $f4e54a52170619ec$export$34e2febe53ae29cc);
const $f4e54a52170619ec$export$e2ce9f12a980a822 = $f4e54a52170619ec$var$createBorderStyle('borderBottom', $f4e54a52170619ec$export$34e2febe53ae29cc);
const $f4e54a52170619ec$export$47658cca1a909427 = $f4e54a52170619ec$var$createBorderStyle('borderLeft', $f4e54a52170619ec$export$34e2febe53ae29cc);
const $f4e54a52170619ec$export$e7fb0694ba2404fc = $f4e54a52170619ec$var$createBorderStyle('borderColor');
const $f4e54a52170619ec$export$126a92c968acdb85 = $f4e54a52170619ec$var$createBorderStyle('borderTopColor');
const $f4e54a52170619ec$export$85cc51cb8fbb8c0e = $f4e54a52170619ec$var$createBorderStyle('borderRightColor');
const $f4e54a52170619ec$export$340b0327727f6d1a = $f4e54a52170619ec$var$createBorderStyle('borderBottomColor');
const $f4e54a52170619ec$export$60beef91a985b4bf = $f4e54a52170619ec$var$createBorderStyle('borderLeftColor');
const $f4e54a52170619ec$export$f9258c55612cbed7 = $f4e54a52170619ec$var$createBorderStyle('outline', $f4e54a52170619ec$export$34e2febe53ae29cc);
const $f4e54a52170619ec$export$621fe586efeb64b9 = $f4e54a52170619ec$var$createBorderStyle('outlineColor');
const $f4e54a52170619ec$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $dbe25e70fba611ca$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $dbe25e70fba611ca$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $b439bd7d3bc95abb$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$f4e54a52170619ec$export$7a57f79000377ca2.propTypes = {};
$f4e54a52170619ec$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $f4e54a52170619ec$var$borders = (0, $6d6c4621433c4187$export$2e2bcd8739ae039)($f4e54a52170619ec$export$1edee58a52776cd9, $f4e54a52170619ec$export$f9a7b6bd24892946, $f4e54a52170619ec$export$5abca33e6be905d2, $f4e54a52170619ec$export$e2ce9f12a980a822, $f4e54a52170619ec$export$47658cca1a909427, $f4e54a52170619ec$export$e7fb0694ba2404fc, $f4e54a52170619ec$export$126a92c968acdb85, $f4e54a52170619ec$export$85cc51cb8fbb8c0e, $f4e54a52170619ec$export$340b0327727f6d1a, $f4e54a52170619ec$export$60beef91a985b4bf, $f4e54a52170619ec$export$7a57f79000377ca2, $f4e54a52170619ec$export$f9258c55612cbed7, $f4e54a52170619ec$export$621fe586efeb64b9);
var $f4e54a52170619ec$export$2e2bcd8739ae039 = $f4e54a52170619ec$var$borders;







const $fcfab58d66000669$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $dbe25e70fba611ca$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $dbe25e70fba611ca$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $b439bd7d3bc95abb$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$fcfab58d66000669$export$5df9adcb0db95e1e.propTypes = {};
$fcfab58d66000669$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $fcfab58d66000669$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $dbe25e70fba611ca$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $dbe25e70fba611ca$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $b439bd7d3bc95abb$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$fcfab58d66000669$export$ec60d70ff941a580.propTypes = {};
$fcfab58d66000669$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $fcfab58d66000669$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $dbe25e70fba611ca$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $dbe25e70fba611ca$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $b439bd7d3bc95abb$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$fcfab58d66000669$export$8a833ffa5f5dbeda.propTypes = {};
$fcfab58d66000669$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $fcfab58d66000669$export$baf44164ca3a34e8 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $fcfab58d66000669$export$8f7213a1cd01e832 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $fcfab58d66000669$export$b0e0abbc49ba668 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $fcfab58d66000669$export$bcd8b929d4b4142 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $fcfab58d66000669$export$e5039a674e14c828 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $fcfab58d66000669$export$42bd9088661ffb03 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $fcfab58d66000669$export$920682ae05b999bc = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $fcfab58d66000669$export$1b88fbdd482fd33a = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $fcfab58d66000669$export$bdb486e40d52d26f = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $fcfab58d66000669$var$grid = (0, $6d6c4621433c4187$export$2e2bcd8739ae039)($fcfab58d66000669$export$5df9adcb0db95e1e, $fcfab58d66000669$export$ec60d70ff941a580, $fcfab58d66000669$export$8a833ffa5f5dbeda, $fcfab58d66000669$export$baf44164ca3a34e8, $fcfab58d66000669$export$8f7213a1cd01e832, $fcfab58d66000669$export$b0e0abbc49ba668, $fcfab58d66000669$export$bcd8b929d4b4142, $fcfab58d66000669$export$e5039a674e14c828, $fcfab58d66000669$export$42bd9088661ffb03, $fcfab58d66000669$export$920682ae05b999bc, $fcfab58d66000669$export$1b88fbdd482fd33a, $fcfab58d66000669$export$bdb486e40d52d26f);
var $fcfab58d66000669$export$2e2bcd8739ae039 = $fcfab58d66000669$var$grid;




function $6391cfa3eed88a94$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $6391cfa3eed88a94$export$35e9368ef982300f = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $6391cfa3eed88a94$export$dbaffd4420ea0ac6
});
const $6391cfa3eed88a94$export$2506f56c10355b33 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $6391cfa3eed88a94$export$dbaffd4420ea0ac6
});
const $6391cfa3eed88a94$export$8c5a050822fd698c = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $6391cfa3eed88a94$export$dbaffd4420ea0ac6
});
const $6391cfa3eed88a94$var$palette = (0, $6d6c4621433c4187$export$2e2bcd8739ae039)($6391cfa3eed88a94$export$35e9368ef982300f, $6391cfa3eed88a94$export$2506f56c10355b33, $6391cfa3eed88a94$export$8c5a050822fd698c);
var $6391cfa3eed88a94$export$2e2bcd8739ae039 = $6391cfa3eed88a94$var$palette;





function $8b7bc8c858cb1995$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $8b7bc8c858cb1995$export$7e3df82ee760448c = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $8b7bc8c858cb1995$export$8afece71750ec241
});
const $8b7bc8c858cb1995$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $b439bd7d3bc95abb$export$68c286be0e7e55b7)[propValue];
            if (!breakpoint) return {
                maxWidth: $8b7bc8c858cb1995$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $b439bd7d3bc95abb$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$8b7bc8c858cb1995$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $8b7bc8c858cb1995$export$ee148fbbe8357dd2 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $8b7bc8c858cb1995$export$8afece71750ec241
});
const $8b7bc8c858cb1995$export$ac607276a8fe9f0a = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $8b7bc8c858cb1995$export$8afece71750ec241
});
const $8b7bc8c858cb1995$export$dc0d8bd0b94f8570 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $8b7bc8c858cb1995$export$8afece71750ec241
});
const $8b7bc8c858cb1995$export$a43cf604e12f3b17 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $8b7bc8c858cb1995$export$8afece71750ec241
});
const $8b7bc8c858cb1995$export$ffed9f14fb65e276 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $8b7bc8c858cb1995$export$8afece71750ec241
});
const $8b7bc8c858cb1995$export$905076ed6620e671 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $8b7bc8c858cb1995$export$8afece71750ec241
});
const $8b7bc8c858cb1995$export$6ccc93f785106a58 = (0, $e7e4643a54a85b6e$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $8b7bc8c858cb1995$var$sizing = (0, $6d6c4621433c4187$export$2e2bcd8739ae039)($8b7bc8c858cb1995$export$7e3df82ee760448c, $8b7bc8c858cb1995$export$488fda99655ff65a, $8b7bc8c858cb1995$export$ee148fbbe8357dd2, $8b7bc8c858cb1995$export$ac607276a8fe9f0a, $8b7bc8c858cb1995$export$dc0d8bd0b94f8570, $8b7bc8c858cb1995$export$a43cf604e12f3b17, $8b7bc8c858cb1995$export$6ccc93f785106a58);
var $8b7bc8c858cb1995$export$2e2bcd8739ae039 = $8b7bc8c858cb1995$var$sizing;


const $bea6c51133faf380$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $f4e54a52170619ec$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $f4e54a52170619ec$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $f4e54a52170619ec$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $f4e54a52170619ec$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $f4e54a52170619ec$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $f4e54a52170619ec$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $f4e54a52170619ec$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $6391cfa3eed88a94$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $6391cfa3eed88a94$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $6391cfa3eed88a94$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $dbe25e70fba611ca$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $dbe25e70fba611ca$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $fcfab58d66000669$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $fcfab58d66000669$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $fcfab58d66000669$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $8b7bc8c858cb1995$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $8b7bc8c858cb1995$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $8b7bc8c858cb1995$export$8afece71750ec241)
    },
    height: {
        transform: (0, $8b7bc8c858cb1995$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $8b7bc8c858cb1995$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $8b7bc8c858cb1995$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $bea6c51133faf380$export$2e2bcd8739ae039 = $bea6c51133faf380$var$defaultSxConfig;


function $6202cd269daefe72$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6202cd269daefe72$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $6202cd269daefe72$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $e7e4643a54a85b6e$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $e7e4643a54a85b6e$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $e7e4643a54a85b6e$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $c4ab204d748cb214$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $b439bd7d3bc95abb$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $bea6c51133faf380$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $b439bd7d3bc95abb$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6202cd269daefe72$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $b4c9ac35fe1a6f23$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $b439bd7d3bc95abb$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6202cd269daefe72$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $b4c9ac35fe1a6f23$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $b4c9ac35fe1a6f23$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $6abdc446fd43a33d$export$456f6c1142f990db)(theme, (0, $b439bd7d3bc95abb$export$8922c90b6e020726)(breakpointsKeys, css))
            };
            return (0, $6abdc446fd43a33d$export$456f6c1142f990db)(theme, (0, $b439bd7d3bc95abb$export$8922c90b6e020726)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6202cd269daefe72$var$styleFunctionSx = $6202cd269daefe72$export$7d53d8bf2911e013();
$6202cd269daefe72$var$styleFunctionSx.filterProps = [
    'sx'
];
var $6202cd269daefe72$export$2e2bcd8739ae039 = $6202cd269daefe72$var$styleFunctionSx;



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $15e0193cf533c91b$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


function $fc4cf8a71374ddb3$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $bde46e956197d217$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $c24c1a5ee4facbc8$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $b80cadb21e077670$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $6d4223a1013948e7$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $6abdc446fd43a33d$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $15e0193cf533c91b$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $b80cadb21e077670$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $bea6c51133faf380$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6202cd269daefe72$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $fc4cf8a71374ddb3$export$2e2bcd8739ae039 = $fc4cf8a71374ddb3$var$createTheme;




function $6440b6423b7c91a1$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $36107f55192c81c9$export$13a2d3ef13012b32)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $36107f55192c81c9$export$13a2d3ef13012b32)(variant.style);
    });
    return result;
}


const $5bf26b75747a8e8c$export$35e57303dbd8a66 = (0, $fc4cf8a71374ddb3$export$2e2bcd8739ae039)();
function $5bf26b75747a8e8c$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $5bf26b75747a8e8c$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $5bf26b75747a8e8c$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $5bf26b75747a8e8c$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $5bf26b75747a8e8c$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $5bf26b75747a8e8c$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$5bf26b75747a8e8c$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $5bf26b75747a8e8c$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $5bf26b75747a8e8c$var$shallowLayer((0, $36107f55192c81c9$export$13a2d3ef13012b32)(otherStyles), layerName) : otherStyles;
        }
        return $5bf26b75747a8e8c$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $5bf26b75747a8e8c$var$shallowLayer((0, $36107f55192c81c9$export$13a2d3ef13012b32)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $5bf26b75747a8e8c$var$shallowLayer((0, $36107f55192c81c9$export$13a2d3ef13012b32)(resolvedStyle), layerName) : resolvedStyle;
}
function $5bf26b75747a8e8c$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $5bf26b75747a8e8c$var$shallowLayer((0, $36107f55192c81c9$export$13a2d3ef13012b32)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $5bf26b75747a8e8c$var$shallowLayer((0, $36107f55192c81c9$export$13a2d3ef13012b32)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $5bf26b75747a8e8c$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $5bf26b75747a8e8c$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $5bf26b75747a8e8c$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $5bf26b75747a8e8c$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $5bf26b75747a8e8c$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $36107f55192c81c9$export$592c7226e4cb0171)(tag, (styles)=>styles.filter((style)=>style !== (0, $6202cd269daefe72$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $5bf26b75747a8e8c$var$defaultOverridesResolver($5bf26b75747a8e8c$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $5bf26b75747a8e8c$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($5bf26b75747a8e8c$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $36107f55192c81c9$export$2e2bcd8739ae039)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $5bf26b75747a8e8c$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $5bf26b75747a8e8c$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $b80cadb21e077670$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $6440b6423b7c91a1$export$2e2bcd8739ae039)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $5bf26b75747a8e8c$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $5bf26b75747a8e8c$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $5bf26b75747a8e8c$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $5bf26b75747a8e8c$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $6202cd269daefe72$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $5bf26b75747a8e8c$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $c4ab204d748cb214$export$2e2bcd8739ae039)(componentSlot || '')}`;
    return `Styled(${(0, $dce6bab64ce19e9c$export$2e2bcd8739ae039)(tag)})`;
}
function $5bf26b75747a8e8c$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $5bf26b75747a8e8c$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $5bf26b75747a8e8c$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $5bf26b75747a8e8c$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}





const $c6b44a2327fc1bea$var$common = {
    black: '#000',
    white: '#fff'
};
var $c6b44a2327fc1bea$export$2e2bcd8739ae039 = $c6b44a2327fc1bea$var$common;


const $fc2d5b1c8cd760bf$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $fc2d5b1c8cd760bf$export$2e2bcd8739ae039 = $fc2d5b1c8cd760bf$var$grey;


const $dbe3f301bda47d81$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $dbe3f301bda47d81$export$2e2bcd8739ae039 = $dbe3f301bda47d81$var$purple;


const $78ccb895eebfddce$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $78ccb895eebfddce$export$2e2bcd8739ae039 = $78ccb895eebfddce$var$red;


const $ce8afbfce1b763fb$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $ce8afbfce1b763fb$export$2e2bcd8739ae039 = $ce8afbfce1b763fb$var$orange;


const $ed7ac30241d1ffe2$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $ed7ac30241d1ffe2$export$2e2bcd8739ae039 = $ed7ac30241d1ffe2$var$blue;


const $35991d8f3ee2ac91$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $35991d8f3ee2ac91$export$2e2bcd8739ae039 = $35991d8f3ee2ac91$var$lightBlue;


const $5deddb8fed6e3742$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $5deddb8fed6e3742$export$2e2bcd8739ae039 = $5deddb8fed6e3742$var$green;


function $c8586a443f57df69$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $c6b44a2327fc1bea$export$2e2bcd8739ae039).white,
            default: (0, $c6b44a2327fc1bea$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $c8586a443f57df69$export$a43af521ac8c3202 = $c8586a443f57df69$var$getLight();
function $c8586a443f57df69$var$getDark() {
    return {
        text: {
            primary: (0, $c6b44a2327fc1bea$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $c6b44a2327fc1bea$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $c8586a443f57df69$export$55ce6f3a06c59543 = $c8586a443f57df69$var$getDark();
function $c8586a443f57df69$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $595d4f40c92954a4$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $595d4f40c92954a4$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $c8586a443f57df69$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ed7ac30241d1ffe2$export$2e2bcd8739ae039)[200],
        light: (0, $ed7ac30241d1ffe2$export$2e2bcd8739ae039)[50],
        dark: (0, $ed7ac30241d1ffe2$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $ed7ac30241d1ffe2$export$2e2bcd8739ae039)[700],
        light: (0, $ed7ac30241d1ffe2$export$2e2bcd8739ae039)[400],
        dark: (0, $ed7ac30241d1ffe2$export$2e2bcd8739ae039)[800]
    };
}
function $c8586a443f57df69$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dbe3f301bda47d81$export$2e2bcd8739ae039)[200],
        light: (0, $dbe3f301bda47d81$export$2e2bcd8739ae039)[50],
        dark: (0, $dbe3f301bda47d81$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $dbe3f301bda47d81$export$2e2bcd8739ae039)[500],
        light: (0, $dbe3f301bda47d81$export$2e2bcd8739ae039)[300],
        dark: (0, $dbe3f301bda47d81$export$2e2bcd8739ae039)[700]
    };
}
function $c8586a443f57df69$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $78ccb895eebfddce$export$2e2bcd8739ae039)[500],
        light: (0, $78ccb895eebfddce$export$2e2bcd8739ae039)[300],
        dark: (0, $78ccb895eebfddce$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $78ccb895eebfddce$export$2e2bcd8739ae039)[700],
        light: (0, $78ccb895eebfddce$export$2e2bcd8739ae039)[400],
        dark: (0, $78ccb895eebfddce$export$2e2bcd8739ae039)[800]
    };
}
function $c8586a443f57df69$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $35991d8f3ee2ac91$export$2e2bcd8739ae039)[400],
        light: (0, $35991d8f3ee2ac91$export$2e2bcd8739ae039)[300],
        dark: (0, $35991d8f3ee2ac91$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $35991d8f3ee2ac91$export$2e2bcd8739ae039)[700],
        light: (0, $35991d8f3ee2ac91$export$2e2bcd8739ae039)[500],
        dark: (0, $35991d8f3ee2ac91$export$2e2bcd8739ae039)[900]
    };
}
function $c8586a443f57df69$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $5deddb8fed6e3742$export$2e2bcd8739ae039)[400],
        light: (0, $5deddb8fed6e3742$export$2e2bcd8739ae039)[300],
        dark: (0, $5deddb8fed6e3742$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $5deddb8fed6e3742$export$2e2bcd8739ae039)[800],
        light: (0, $5deddb8fed6e3742$export$2e2bcd8739ae039)[500],
        dark: (0, $5deddb8fed6e3742$export$2e2bcd8739ae039)[900]
    };
}
function $c8586a443f57df69$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ce8afbfce1b763fb$export$2e2bcd8739ae039)[400],
        light: (0, $ce8afbfce1b763fb$export$2e2bcd8739ae039)[300],
        dark: (0, $ce8afbfce1b763fb$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $ce8afbfce1b763fb$export$2e2bcd8739ae039)[500],
        dark: (0, $ce8afbfce1b763fb$export$2e2bcd8739ae039)[900]
    };
}
function $c8586a443f57df69$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $c8586a443f57df69$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $c8586a443f57df69$var$getDefaultSecondary(mode);
    const error = palette.error || $c8586a443f57df69$var$getDefaultError(mode);
    const info = palette.info || $c8586a443f57df69$var$getDefaultInfo(mode);
    const success = palette.success || $c8586a443f57df69$var$getDefaultSuccess(mode);
    const warning = palette.warning || $c8586a443f57df69$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $595d4f40c92954a4$export$d061e26956a60b0a)(background, $c8586a443f57df69$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $c8586a443f57df69$export$55ce6f3a06c59543.text.primary : $c8586a443f57df69$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $8b74d405de95a30f$export$2e2bcd8739ae039)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $8b74d405de95a30f$export$2e2bcd8739ae039)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $c8586a443f57df69$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $c8586a443f57df69$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $c8586a443f57df69$var$getLight();
    else if (mode === 'dark') modeHydrated = $c8586a443f57df69$var$getDark();
    const paletteOutput = (0, $b80cadb21e077670$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: {
            ...(0, $c6b44a2327fc1bea$export$2e2bcd8739ae039)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $fc2d5b1c8cd760bf$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}




/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $caee814a9fed234f$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}



/* eslint-disable import/prefer-default-export */ function $dca900560568c44b$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}


/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $05eca009436343cf$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $05eca009436343cf$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $05eca009436343cf$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $05eca009436343cf$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $05eca009436343cf$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $05eca009436343cf$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $05eca009436343cf$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $05eca009436343cf$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


function $57d8a1315d1aa3fd$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $05eca009436343cf$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $05eca009436343cf$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $b80cadb21e077670$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $05eca009436343cf$export$2e2bcd8739ae039)(defaultScheme, parserConfig);
        themeVars = (0, $b80cadb21e077670$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $b80cadb21e077670$export$2e2bcd8739ae039)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $57d8a1315d1aa3fd$export$2e2bcd8739ae039 = $57d8a1315d1aa3fd$var$prepareCssVars;

function $2da97b91cc7e114a$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}









function $44098c3bd1393b85$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}




function $0db3d8a130ab37bb$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $0db3d8a130ab37bb$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $0db3d8a130ab37bb$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $0db3d8a130ab37bb$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $0db3d8a130ab37bb$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $0db3d8a130ab37bb$var$defaultFontFamily ? {
                letterSpacing: `${$0db3d8a130ab37bb$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $0db3d8a130ab37bb$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $0db3d8a130ab37bb$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $b80cadb21e077670$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}


const $e96be4f32054ed66$var$shadowKeyUmbraOpacity = 0.2;
const $e96be4f32054ed66$var$shadowKeyPenumbraOpacity = 0.14;
const $e96be4f32054ed66$var$shadowAmbientShadowOpacity = 0.12;
function $e96be4f32054ed66$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e96be4f32054ed66$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e96be4f32054ed66$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e96be4f32054ed66$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e96be4f32054ed66$var$shadows = [
    'none',
    $e96be4f32054ed66$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e96be4f32054ed66$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e96be4f32054ed66$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e96be4f32054ed66$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e96be4f32054ed66$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e96be4f32054ed66$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e96be4f32054ed66$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e96be4f32054ed66$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e96be4f32054ed66$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e96be4f32054ed66$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e96be4f32054ed66$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e96be4f32054ed66$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e96be4f32054ed66$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e96be4f32054ed66$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e96be4f32054ed66$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e96be4f32054ed66$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e96be4f32054ed66$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e96be4f32054ed66$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e96be4f32054ed66$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e96be4f32054ed66$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e96be4f32054ed66$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e96be4f32054ed66$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e96be4f32054ed66$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e96be4f32054ed66$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e96be4f32054ed66$export$2e2bcd8739ae039 = $e96be4f32054ed66$var$shadows;


// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $58c13e275951a383$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $58c13e275951a383$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $58c13e275951a383$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $58c13e275951a383$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $58c13e275951a383$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$58c13e275951a383$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$58c13e275951a383$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $58c13e275951a383$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $58c13e275951a383$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $58c13e275951a383$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $9bb13b010dcb636f$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $9bb13b010dcb636f$export$2e2bcd8739ae039 = $9bb13b010dcb636f$var$zIndex;


/* eslint-disable import/prefer-default-export */ 
function $6c645dc2c19b9308$var$isSerializable(val) {
    return (0, $b80cadb21e077670$export$53b83ca8eaab0383)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $6c645dc2c19b9308$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$6c645dc2c19b9308$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $b80cadb21e077670$export$53b83ca8eaab0383)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}


function $4a75484edc6b78d7$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $8b74d405de95a30f$export$2e2bcd8739ae039)(20));
    const palette = (0, $c8586a443f57df69$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $fc4cf8a71374ddb3$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $b80cadb21e077670$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $44098c3bd1393b85$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $e96be4f32054ed66$export$2e2bcd8739ae039).slice(),
        typography: (0, $0db3d8a130ab37bb$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $58c13e275951a383$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: {
            ...(0, $9bb13b010dcb636f$export$2e2bcd8739ae039)
        }
    });
    muiTheme = (0, $b80cadb21e077670$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $b80cadb21e077670$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $bea6c51133faf380$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6202cd269daefe72$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $6c645dc2c19b9308$export$32c2afa5f91892aa); // for Pigment CSS integration
    return muiTheme;
}
let $4a75484edc6b78d7$var$warnedOnce = false;
function $4a75484edc6b78d7$export$c469355549431d9b(...args) {
    return $4a75484edc6b78d7$var$createThemeNoVars(...args);
}
var $4a75484edc6b78d7$export$2e2bcd8739ae039 = $4a75484edc6b78d7$var$createThemeNoVars;



// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $a9224a1544d87693$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $57246f2b9006cc9f$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $a9224a1544d87693$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $57246f2b9006cc9f$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $57246f2b9006cc9f$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $57246f2b9006cc9f$var$defaultDarkOverlays : [];
}
function $57246f2b9006cc9f$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $c8586a443f57df69$export$2e2bcd8739ae039)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$57246f2b9006cc9f$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $57246f2b9006cc9f$export$dd191566510330d3(palette.mode),
        ...rest
    };
}


function $04319d86c7c65845$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}


/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $9095a03eb4008e24$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $9095a03eb4008e24$export$2e2bcd8739ae039 = $9095a03eb4008e24$var$excludeVariablesFromRoot;


var $2aef278f2b110bf4$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $9095a03eb4008e24$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };



function $6f014c83e524485c$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $6f014c83e524485c$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $6f014c83e524485c$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $595d4f40c92954a4$export$29fb7152bd3f781a)(color);
}
function $6f014c83e524485c$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $595d4f40c92954a4$export$427365fc3db6fc5e)($6f014c83e524485c$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $6f014c83e524485c$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $6f014c83e524485c$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $6f014c83e524485c$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $caee814a9fed234f$export$2e2bcd8739ae039)(cssVarPrefix);
function $6f014c83e524485c$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $57246f2b9006cc9f$export$2e2bcd8739ae039)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $4a75484edc6b78d7$export$2e2bcd8739ae039)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $57246f2b9006cc9f$export$c85e0347fceb69ba)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $57246f2b9006cc9f$export$dd191566510330d3)(mode)
    };
    return muiTheme;
}
function $6f014c83e524485c$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $04319d86c7c65845$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $6f014c83e524485c$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $8b74d405de95a30f$export$2e2bcd8739ae039)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $6f014c83e524485c$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $6f014c83e524485c$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $6f014c83e524485c$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $2da97b91cc7e114a$export$2e2bcd8739ae039)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $6f014c83e524485c$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $6f014c83e524485c$var$setColor(palette.common, 'background', '#fff');
            $6f014c83e524485c$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $6f014c83e524485c$var$setColor(palette.common, 'background', '#000');
            $6f014c83e524485c$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $6f014c83e524485c$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $6f014c83e524485c$var$setColor(palette.Alert, 'errorColor', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.error.light, 0.6));
            $6f014c83e524485c$var$setColor(palette.Alert, 'infoColor', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.info.light, 0.6));
            $6f014c83e524485c$var$setColor(palette.Alert, 'successColor', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.success.light, 0.6));
            $6f014c83e524485c$var$setColor(palette.Alert, 'warningColor', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.warning.light, 0.6));
            $6f014c83e524485c$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'errorFilledColor', $6f014c83e524485c$var$silent(()=>palette.getContrastText(palette.error.main)));
            $6f014c83e524485c$var$setColor(palette.Alert, 'infoFilledColor', $6f014c83e524485c$var$silent(()=>palette.getContrastText(palette.info.main)));
            $6f014c83e524485c$var$setColor(palette.Alert, 'successFilledColor', $6f014c83e524485c$var$silent(()=>palette.getContrastText(palette.success.main)));
            $6f014c83e524485c$var$setColor(palette.Alert, 'warningFilledColor', $6f014c83e524485c$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $6f014c83e524485c$var$setColor(palette.Alert, 'errorStandardBg', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.error.light, 0.9));
            $6f014c83e524485c$var$setColor(palette.Alert, 'infoStandardBg', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.info.light, 0.9));
            $6f014c83e524485c$var$setColor(palette.Alert, 'successStandardBg', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.success.light, 0.9));
            $6f014c83e524485c$var$setColor(palette.Alert, 'warningStandardBg', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.warning.light, 0.9));
            $6f014c83e524485c$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $6f014c83e524485c$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $6f014c83e524485c$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $6f014c83e524485c$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $6f014c83e524485c$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $6f014c83e524485c$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $6f014c83e524485c$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $6f014c83e524485c$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $6f014c83e524485c$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $6f014c83e524485c$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $6f014c83e524485c$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'primaryBg', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.primary.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.secondary.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'errorBg', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.error.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'infoBg', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.info.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'successBg', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.success.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'warningBg', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.warning.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $6f014c83e524485c$var$setColor(palette.Slider, 'primaryTrack', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.primary.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.Slider, 'secondaryTrack', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.secondary.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.Slider, 'errorTrack', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.error.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.Slider, 'infoTrack', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.info.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.Slider, 'successTrack', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.success.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.Slider, 'warningTrack', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $595d4f40c92954a4$export$11bb74ba10c85505)(palette.background.default, 0.8);
            $6f014c83e524485c$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $6f014c83e524485c$var$setColor(palette.SnackbarContent, 'color', $6f014c83e524485c$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $6f014c83e524485c$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $595d4f40c92954a4$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $6f014c83e524485c$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $6f014c83e524485c$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $6f014c83e524485c$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $6f014c83e524485c$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $6f014c83e524485c$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.primary.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.secondary.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.Switch, 'errorDisabledColor', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.error.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.Switch, 'infoDisabledColor', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.info.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.Switch, 'successDisabledColor', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.success.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.Switch, 'warningDisabledColor', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.warning.main, 0.62));
            $6f014c83e524485c$var$setColor(palette.TableCell, 'border', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)((0, $595d4f40c92954a4$export$34109543fc7f43f8)(palette.divider, 1), 0.88));
            $6f014c83e524485c$var$setColor(palette.Tooltip, 'bg', (0, $595d4f40c92954a4$export$34109543fc7f43f8)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $6f014c83e524485c$var$setColor(palette.Alert, 'errorColor', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.error.light, 0.6));
            $6f014c83e524485c$var$setColor(palette.Alert, 'infoColor', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.info.light, 0.6));
            $6f014c83e524485c$var$setColor(palette.Alert, 'successColor', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.success.light, 0.6));
            $6f014c83e524485c$var$setColor(palette.Alert, 'warningColor', (0, $595d4f40c92954a4$export$aeeda94ef1d01275)(palette.warning.light, 0.6));
            $6f014c83e524485c$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'errorFilledColor', $6f014c83e524485c$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $6f014c83e524485c$var$setColor(palette.Alert, 'infoFilledColor', $6f014c83e524485c$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $6f014c83e524485c$var$setColor(palette.Alert, 'successFilledColor', $6f014c83e524485c$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $6f014c83e524485c$var$setColor(palette.Alert, 'warningFilledColor', $6f014c83e524485c$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $6f014c83e524485c$var$setColor(palette.Alert, 'errorStandardBg', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.error.light, 0.9));
            $6f014c83e524485c$var$setColor(palette.Alert, 'infoStandardBg', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.info.light, 0.9));
            $6f014c83e524485c$var$setColor(palette.Alert, 'successStandardBg', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.success.light, 0.9));
            $6f014c83e524485c$var$setColor(palette.Alert, 'warningStandardBg', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.warning.light, 0.9));
            $6f014c83e524485c$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $6f014c83e524485c$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $6f014c83e524485c$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $6f014c83e524485c$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $6f014c83e524485c$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $6f014c83e524485c$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $6f014c83e524485c$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $6f014c83e524485c$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $6f014c83e524485c$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $6f014c83e524485c$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $6f014c83e524485c$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $6f014c83e524485c$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $6f014c83e524485c$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $6f014c83e524485c$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'primaryBg', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.primary.main, 0.5));
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.secondary.main, 0.5));
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'errorBg', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.error.main, 0.5));
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'infoBg', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.info.main, 0.5));
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'successBg', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.success.main, 0.5));
            $6f014c83e524485c$var$setColor(palette.LinearProgress, 'warningBg', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.warning.main, 0.5));
            $6f014c83e524485c$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $6f014c83e524485c$var$setColor(palette.Slider, 'primaryTrack', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.primary.main, 0.5));
            $6f014c83e524485c$var$setColor(palette.Slider, 'secondaryTrack', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.secondary.main, 0.5));
            $6f014c83e524485c$var$setColor(palette.Slider, 'errorTrack', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.error.main, 0.5));
            $6f014c83e524485c$var$setColor(palette.Slider, 'infoTrack', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.info.main, 0.5));
            $6f014c83e524485c$var$setColor(palette.Slider, 'successTrack', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.success.main, 0.5));
            $6f014c83e524485c$var$setColor(palette.Slider, 'warningTrack', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $595d4f40c92954a4$export$11bb74ba10c85505)(palette.background.default, 0.98);
            $6f014c83e524485c$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $6f014c83e524485c$var$setColor(palette.SnackbarContent, 'color', $6f014c83e524485c$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $6f014c83e524485c$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $595d4f40c92954a4$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $6f014c83e524485c$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $6f014c83e524485c$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $6f014c83e524485c$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $6f014c83e524485c$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $6f014c83e524485c$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.primary.main, 0.55));
            $6f014c83e524485c$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.secondary.main, 0.55));
            $6f014c83e524485c$var$setColor(palette.Switch, 'errorDisabledColor', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.error.main, 0.55));
            $6f014c83e524485c$var$setColor(palette.Switch, 'infoDisabledColor', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.info.main, 0.55));
            $6f014c83e524485c$var$setColor(palette.Switch, 'successDisabledColor', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.success.main, 0.55));
            $6f014c83e524485c$var$setColor(palette.Switch, 'warningDisabledColor', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)(palette.warning.main, 0.55));
            $6f014c83e524485c$var$setColor(palette.TableCell, 'border', (0, $595d4f40c92954a4$export$eaaef2dca3e9e512)((0, $595d4f40c92954a4$export$34109543fc7f43f8)(palette.divider, 1), 0.68));
            $6f014c83e524485c$var$setColor(palette.Tooltip, 'bg', (0, $595d4f40c92954a4$export$34109543fc7f43f8)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $6f014c83e524485c$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $6f014c83e524485c$var$setColorChannel(palette.background, 'paper');
        $6f014c83e524485c$var$setColorChannel(palette.common, 'background');
        $6f014c83e524485c$var$setColorChannel(palette.common, 'onBackground');
        $6f014c83e524485c$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $6f014c83e524485c$var$setColor(palette[color], 'mainChannel', (0, $595d4f40c92954a4$export$427365fc3db6fc5e)($6f014c83e524485c$var$toRgb(colors.main)));
                if (colors.light) $6f014c83e524485c$var$setColor(palette[color], 'lightChannel', (0, $595d4f40c92954a4$export$427365fc3db6fc5e)($6f014c83e524485c$var$toRgb(colors.light)));
                if (colors.dark) $6f014c83e524485c$var$setColor(palette[color], 'darkChannel', (0, $595d4f40c92954a4$export$427365fc3db6fc5e)($6f014c83e524485c$var$toRgb(colors.dark)));
                if (colors.contrastText) $6f014c83e524485c$var$setColor(palette[color], 'contrastTextChannel', (0, $595d4f40c92954a4$export$427365fc3db6fc5e)($6f014c83e524485c$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $6f014c83e524485c$var$setColorChannel(palette[color], 'primary');
                    $6f014c83e524485c$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $6f014c83e524485c$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $6f014c83e524485c$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $b80cadb21e077670$export$2e2bcd8739ae039)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $2aef278f2b110bf4$export$2e2bcd8739ae039)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $57d8a1315d1aa3fd$export$2e2bcd8739ae039)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $c24c1a5ee4facbc8$export$2e2bcd8739ae039)(input.spacing, (0, $dbe25e70fba611ca$export$1def6f833384e3d1)(this));
    };
    theme.getColorSchemeSelector = (0, $dca900560568c44b$export$858538ff6c0d421d)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $bea6c51133faf380$export$2e2bcd8739ae039),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $6202cd269daefe72$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $6c645dc2c19b9308$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $d0927e891b7f77c8$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $c8586a443f57df69$export$2e2bcd8739ae039)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $d0927e891b7f77c8$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $4a75484edc6b78d7$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $4a75484edc6b78d7$export$2e2bcd8739ae039)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $d0927e891b7f77c8$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $d0927e891b7f77c8$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $6f014c83e524485c$export$2e2bcd8739ae039)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}


'use client';
const $80760139350deeb4$var$defaultTheme = (0, $d0927e891b7f77c8$export$2e2bcd8739ae039)();
var $80760139350deeb4$export$2e2bcd8739ae039 = $80760139350deeb4$var$defaultTheme;


var $e8b56ec99e409d23$export$2e2bcd8739ae039 = '$$material';


// copied from @mui/system/createStyled
function $b9e766558b887025$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $b9e766558b887025$export$2e2bcd8739ae039 = $b9e766558b887025$var$slotShouldForwardProp;


const $be3f20df888d18ba$var$rootShouldForwardProp = (prop)=>(0, $b9e766558b887025$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $be3f20df888d18ba$export$2e2bcd8739ae039 = $be3f20df888d18ba$var$rootShouldForwardProp;



'use client';
const $e2a5d83e778e073b$var$styled = (0, $5bf26b75747a8e8c$export$2e2bcd8739ae039)({
    themeId: (0, $e8b56ec99e409d23$export$2e2bcd8739ae039),
    defaultTheme: $80760139350deeb4$export$2e2bcd8739ae039,
    rootShouldForwardProp: $be3f20df888d18ba$export$2e2bcd8739ae039
});
var $e2a5d83e778e073b$export$2e2bcd8739ae039 = $e2a5d83e778e073b$var$styled;


const $bfaaee51e25ede3c$var$defaultGenerator = (componentName)=>componentName;
const $bfaaee51e25ede3c$var$createClassNameGenerator = ()=>{
    let generate = $bfaaee51e25ede3c$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $bfaaee51e25ede3c$var$defaultGenerator;
        }
    };
};
const $bfaaee51e25ede3c$var$ClassNameGenerator = $bfaaee51e25ede3c$var$createClassNameGenerator();
var $bfaaee51e25ede3c$export$2e2bcd8739ae039 = $bfaaee51e25ede3c$var$ClassNameGenerator;


const $a95bed8e2ab0687e$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $a95bed8e2ab0687e$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $a95bed8e2ab0687e$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bfaaee51e25ede3c$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $a95bed8e2ab0687e$export$34c0130b1f3e8ae3(slot) {
    return $a95bed8e2ab0687e$export$9d6b9120de57c54[slot] !== undefined;
}


function $59c7de58ecafe5b1$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}


function $786c119d9add6b61$export$a2aa36217b862c23(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiDataGrid', slot);
}
const $786c119d9add6b61$export$2100d54e36406477 = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiDataGrid', [
    'actionsCell',
    'aggregationColumnHeader',
    'aggregationColumnHeader--alignLeft',
    'aggregationColumnHeader--alignCenter',
    'aggregationColumnHeader--alignRight',
    'aggregationColumnHeaderLabel',
    'autoHeight',
    'autosizing',
    'booleanCell',
    'cell--editable',
    'cell--editing',
    'cell--flex',
    'cell--textCenter',
    'cell--textLeft',
    'cell--textRight',
    'cell--rangeTop',
    'cell--rangeBottom',
    'cell--rangeLeft',
    'cell--rangeRight',
    'cell--pinnedLeft',
    'cell--pinnedRight',
    'cell--selectionMode',
    'cell',
    'cellCheckbox',
    'cellEmpty',
    'cellSkeleton',
    'cellOffsetLeft',
    'checkboxInput',
    'columnHeader',
    'columnHeader--alignCenter',
    'columnHeader--alignLeft',
    'columnHeader--alignRight',
    'columnHeader--dragging',
    'columnHeader--moving',
    'columnHeader--numeric',
    'columnHeader--sortable',
    'columnHeader--sorted',
    'columnHeader--filtered',
    'columnHeader--pinnedLeft',
    'columnHeader--pinnedRight',
    'columnHeader--last',
    'columnHeader--lastUnpinned',
    'columnHeader--siblingFocused',
    'columnHeaderCheckbox',
    'columnHeaderDraggableContainer',
    'columnHeaderTitle',
    'columnHeaderTitleContainer',
    'columnHeaderTitleContainerContent',
    'columnHeader--filledGroup',
    'columnHeader--emptyGroup',
    'columnHeaders',
    'columnSeparator--resizable',
    'columnSeparator--resizing',
    'columnSeparator--sideLeft',
    'columnSeparator--sideRight',
    'columnSeparator',
    'columnsManagement',
    'columnsManagementRow',
    'columnsManagementHeader',
    'columnsManagementSearchInput',
    'columnsManagementFooter',
    'container--top',
    'container--bottom',
    'detailPanel',
    'detailPanels',
    'detailPanelToggleCell',
    'detailPanelToggleCell--expanded',
    'footerCell',
    'panel',
    'panelHeader',
    'panelWrapper',
    'panelContent',
    'panelFooter',
    'paper',
    'editBooleanCell',
    'editInputCell',
    'filler',
    'filler--borderBottom',
    'filler--pinnedLeft',
    'filler--pinnedRight',
    'filterForm',
    'filterFormDeleteIcon',
    'filterFormLogicOperatorInput',
    'filterFormColumnInput',
    'filterFormOperatorInput',
    'filterFormValueInput',
    'filterIcon',
    'footerContainer',
    'headerFilterRow',
    'iconButtonContainer',
    'iconSeparator',
    'main',
    'main--hasPinnedRight',
    'main--hasSkeletonLoadingOverlay',
    'menu',
    'menuIcon',
    'menuIconButton',
    'menuOpen',
    'menuList',
    'overlay',
    'overlayWrapper',
    'overlayWrapperInner',
    'root',
    'root--densityStandard',
    'root--densityComfortable',
    'root--densityCompact',
    'root--disableUserSelection',
    'root--noToolbar',
    'row',
    'row--editable',
    'row--editing',
    'row--firstVisible',
    'row--lastVisible',
    'row--dragging',
    'row--dynamicHeight',
    'row--detailPanelExpanded',
    'row--borderBottom',
    'rowReorderCellPlaceholder',
    'rowCount',
    'rowReorderCellContainer',
    'rowReorderCell',
    'rowReorderCell--draggable',
    'rowSkeleton',
    'scrollArea--left',
    'scrollArea--right',
    'scrollArea--up',
    'scrollArea--down',
    'scrollArea',
    'scrollbar',
    'scrollbar--vertical',
    'scrollbar--horizontal',
    'scrollbarFiller',
    'scrollbarFiller--header',
    'scrollbarFiller--borderTop',
    'scrollbarFiller--borderBottom',
    'scrollbarFiller--pinnedRight',
    'selectedRowCount',
    'sortButton',
    'sortIcon',
    'toolbarContainer',
    'toolbarFilterList',
    'virtualScroller',
    'virtualScroller--hasScrollX',
    'virtualScrollerContent',
    'virtualScrollerContent--overflowed',
    'virtualScrollerRenderZone',
    'pinnedColumns',
    'withVerticalBorder',
    'withBorderColor',
    'cell--withRightBorder',
    'cell--withLeftBorder',
    'columnHeader--withRightBorder',
    'columnHeader--withLeftBorder',
    'treeDataGroupingCell',
    'treeDataGroupingCellToggle',
    'treeDataGroupingCellLoadingContainer',
    'groupingCriteriaCell',
    'groupingCriteriaCellToggle',
    'groupingCriteriaCellLoadingContainer',
    'pinnedRows',
    'pinnedRows--top',
    'pinnedRows--bottom',
    'pinnedRowsRenderZone'
]);



var $lCzvA = parcelRequire("lCzvA");


var $cd02143f1792b46c$exports = {};
'use strict';

$cd02143f1792b46c$exports = (parcelRequire("gNaVO"));



var $lCzvA = parcelRequire("lCzvA");
'use client';
const $f8f1fea382a71335$var$UNINITIALIZED = {};
function $f8f1fea382a71335$export$2e2bcd8739ae039(init, initArg) {
    const ref = $lCzvA.useRef($f8f1fea382a71335$var$UNINITIALIZED);
    if (ref.current === $f8f1fea382a71335$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}


function $1e10d601c15466d4$var$isOutputSelector(selector) {
    return selector.acceptsApiRef;
}
// TODO v8: Remove this function
function $1e10d601c15466d4$var$applySelector(apiRef, selector) {
    if ($1e10d601c15466d4$var$isOutputSelector(selector)) return selector(apiRef);
    return selector(apiRef.current.state);
}
// TODO v8: Rename this function to `applySelector`
function $1e10d601c15466d4$var$applySelectorV8(apiRef, selector, args, instanceId) {
    if ($1e10d601c15466d4$var$isOutputSelector(selector)) return selector(apiRef, args);
    return selector(apiRef.current.state, instanceId);
}
const $1e10d601c15466d4$var$defaultCompare = Object.is;
const $1e10d601c15466d4$export$8da4c691e5695191 = (0, $ea432d6ace412cc5$export$84d14f151b531ccb);
const $1e10d601c15466d4$var$arrayShallowCompare = (a, b)=>{
    if (a === b) return true;
    return a.length === b.length && a.every((v, i)=>v === b[i]);
};
const $1e10d601c15466d4$export$5a7c3a25f6dab637 = (prev, curr)=>{
    let fn = Object.is;
    if (curr instanceof Array) fn = $1e10d601c15466d4$var$arrayShallowCompare;
    else if (curr instanceof Object) fn = $1e10d601c15466d4$export$8da4c691e5695191;
    return fn(prev, curr);
};
const $1e10d601c15466d4$var$createRefs = ()=>({
        state: null,
        equals: null,
        selector: null,
        args: undefined
    });
const $1e10d601c15466d4$var$EMPTY = [];
const $1e10d601c15466d4$var$emptyGetSnapshot = ()=>null;
const $1e10d601c15466d4$export$f96fd476863f2e4a = (apiRef, selector, equals = $1e10d601c15466d4$var$defaultCompare)=>{
    const refs = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)($1e10d601c15466d4$var$createRefs);
    const didInit = refs.current.selector !== null;
    const [state, setState] = $lCzvA.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : $1e10d601c15466d4$var$applySelector(apiRef, selector));
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    const subscribe = $lCzvA.useCallback(()=>{
        if (refs.current.subscription) return null;
        refs.current.subscription = apiRef.current.store.subscribe(()=>{
            const newState = $1e10d601c15466d4$var$applySelector(apiRef, refs.current.selector);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
        return null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    $1e10d601c15466d4$var$EMPTY);
    const unsubscribe = $lCzvA.useCallback(()=>{
        return ()=>{
            if (refs.current.subscription) {
                refs.current.subscription();
                refs.current.subscription = undefined;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $1e10d601c15466d4$var$EMPTY);
    (0, $cd02143f1792b46c$exports.useSyncExternalStore)(unsubscribe, subscribe, $1e10d601c15466d4$var$emptyGetSnapshot);
    return state;
};
const $1e10d601c15466d4$export$3b2f72ef07abe101 = (apiRef, selector, args, equals = $1e10d601c15466d4$var$defaultCompare)=>{
    const refs = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)($1e10d601c15466d4$var$createRefs);
    const didInit = refs.current.selector !== null;
    const [state, setState] = $lCzvA.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : $1e10d601c15466d4$var$applySelectorV8(apiRef, selector, args, apiRef.current.instanceId));
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    const prevArgs = refs.current.args;
    refs.current.args = args;
    if (didInit && !$1e10d601c15466d4$export$5a7c3a25f6dab637(prevArgs, args)) {
        const newState = $1e10d601c15466d4$var$applySelectorV8(apiRef, refs.current.selector, refs.current.args, apiRef.current.instanceId);
        if (!refs.current.equals(refs.current.state, newState)) {
            refs.current.state = newState;
            setState(newState);
        }
    }
    const subscribe = $lCzvA.useCallback(()=>{
        if (refs.current.subscription) return null;
        refs.current.subscription = apiRef.current.store.subscribe(()=>{
            const newState = $1e10d601c15466d4$var$applySelectorV8(apiRef, refs.current.selector, refs.current.args, apiRef.current.instanceId);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
        return null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    $1e10d601c15466d4$var$EMPTY);
    const unsubscribe = $lCzvA.useCallback(()=>{
        return ()=>{
            if (refs.current.subscription) {
                refs.current.subscription();
                refs.current.subscription = undefined;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $1e10d601c15466d4$var$EMPTY);
    (0, $cd02143f1792b46c$exports.useSyncExternalStore)(unsubscribe, subscribe, $1e10d601c15466d4$var$emptyGetSnapshot);
    return state;
};



function $64116811ce6fb235$var$getBorderColor(theme) {
    if (theme.vars) return theme.vars.palette.TableCell.border;
    if (theme.palette.mode === 'light') return (0, $595d4f40c92954a4$export$c0816ed86df316af)((0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.divider, 1), 0.88);
    return (0, $595d4f40c92954a4$export$4b073707ff63303)((0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.divider, 1), 0.68);
}
const $64116811ce6fb235$var$columnSeparatorTargetSize = 10;
const $64116811ce6fb235$var$columnSeparatorOffset = -5;
const $64116811ce6fb235$var$focusOutlineWidth = 1;
const $64116811ce6fb235$var$separatorIconDragStyles = {
    width: 3,
    rx: 1.5,
    x: 10.5
};
// Emotion thinks it knows better than us which selector we should use.
// https://github.com/emotion-js/emotion/issues/1105#issuecomment-1722524968
const $64116811ce6fb235$var$ignoreSsrWarning = '/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */';
const $64116811ce6fb235$var$shouldShowBorderTopRightRadiusSelector = (state)=>state.dimensions.hasScrollX && (!state.dimensions.hasScrollY || state.dimensions.scrollbarSize === 0);
const $64116811ce6fb235$export$42458c7ae3a97297 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>[
            // Root overrides
            styles.root,
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477).autoHeight}`]: styles.autoHeight
            },
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477).autosizing}`]: styles.autosizing
            },
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['root--densityStandard']}`]: styles['root--densityStandard']
            },
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['root--densityComfortable']}`]: styles['root--densityComfortable']
            },
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['root--densityCompact']}`]: styles['root--densityCompact']
            },
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['root--disableUserSelection']}`]: styles['root--disableUserSelection']
            },
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['root--noToolbar']}`]: styles['root--noToolbar']
            },
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477).withVerticalBorder}`]: styles.withVerticalBorder
            },
            // Child element overrides
            // - Only declare overrides here for class names that are not applied to `styled` components.
            // - For `styled` components, declare overrides in the component itself.
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).actionsCell}`]: styles.actionsCell
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).booleanCell}`]: styles.booleanCell
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}`]: styles.cell
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--editable']}`]: styles['cell--editable']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--editing']}`]: styles['cell--editing']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--flex']}`]: styles['cell--flex']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--pinnedLeft']}`]: styles['cell--pinnedLeft']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--pinnedRight']}`]: styles['cell--pinnedRight']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--rangeBottom']}`]: styles['cell--rangeBottom']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--rangeLeft']}`]: styles['cell--rangeLeft']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--rangeRight']}`]: styles['cell--rangeRight']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--rangeTop']}`]: styles['cell--rangeTop']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--selectionMode']}`]: styles['cell--selectionMode']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--textCenter']}`]: styles['cell--textCenter']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--textLeft']}`]: styles['cell--textLeft']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--textRight']}`]: styles['cell--textRight']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--withLeftBorder']}`]: styles['cell--withLeftBorder']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--withRightBorder']}`]: styles['cell--withRightBorder']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cellCheckbox}`]: styles.cellCheckbox
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cellEmpty}`]: styles.cellEmpty
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cellOffsetLeft}`]: styles.cellOffsetLeft
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cellSkeleton}`]: styles.cellSkeleton
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).checkboxInput}`]: styles.checkboxInput
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader}`]: styles.columnHeader
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--alignCenter']}`]: styles['columnHeader--alignCenter']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--alignLeft']}`]: styles['columnHeader--alignLeft']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--alignRight']}`]: styles['columnHeader--alignRight']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--dragging']}`]: styles['columnHeader--dragging']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--emptyGroup']}`]: styles['columnHeader--emptyGroup']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--filledGroup']}`]: styles['columnHeader--filledGroup']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--filtered']}`]: styles['columnHeader--filtered']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--last']}`]: styles['columnHeader--last']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--lastUnpinned']}`]: styles['columnHeader--lastUnpinned']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--moving']}`]: styles['columnHeader--moving']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--numeric']}`]: styles['columnHeader--numeric']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--pinnedLeft']}`]: styles['columnHeader--pinnedLeft']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--pinnedRight']}`]: styles['columnHeader--pinnedRight']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--siblingFocused']}`]: styles['columnHeader--siblingFocused']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--sortable']}`]: styles['columnHeader--sortable']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--sorted']}`]: styles['columnHeader--sorted']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--withLeftBorder']}`]: styles['columnHeader--withLeftBorder']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--withRightBorder']}`]: styles['columnHeader--withRightBorder']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderCheckbox}`]: styles.columnHeaderCheckbox
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderDraggableContainer}`]: styles.columnHeaderDraggableContainer
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderTitleContainer}`]: styles.columnHeaderTitleContainer
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderTitleContainerContent}`]: styles.columnHeaderTitleContainerContent
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnSeparator}`]: styles.columnSeparator
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--resizable']}`]: styles['columnSeparator--resizable']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--resizing']}`]: styles['columnSeparator--resizing']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--sideLeft']}`]: styles['columnSeparator--sideLeft']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--sideRight']}`]: styles['columnSeparator--sideRight']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['container--bottom']}`]: styles['container--bottom']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['container--top']}`]: styles['container--top']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).detailPanelToggleCell}`]: styles.detailPanelToggleCell
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['detailPanelToggleCell--expanded']}`]: styles['detailPanelToggleCell--expanded']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).editBooleanCell}`]: styles.editBooleanCell
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).filterIcon}`]: styles.filterIcon
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['filler--borderBottom']}`]: styles['filler--borderBottom']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['filler--pinnedLeft']}`]: styles['filler--pinnedLeft']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['filler--pinnedRight']}`]: styles['filler--pinnedRight']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).groupingCriteriaCell}`]: styles.groupingCriteriaCell
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).groupingCriteriaCellLoadingContainer}`]: styles.groupingCriteriaCellLoadingContainer
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).groupingCriteriaCellToggle}`]: styles.groupingCriteriaCellToggle
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).headerFilterRow}`]: styles.headerFilterRow
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).iconSeparator}`]: styles.iconSeparator
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).menuIcon}`]: styles.menuIcon
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).menuIconButton}`]: styles.menuIconButton
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).menuList}`]: styles.menuList
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).menuOpen}`]: styles.menuOpen
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).overlayWrapperInner}`]: styles.overlayWrapperInner
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).pinnedRows}`]: styles.pinnedRows
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['pinnedRows--bottom']}`]: styles['pinnedRows--bottom']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['pinnedRows--top']}`]: styles['pinnedRows--top']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).row}`]: styles.row
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--borderBottom']}`]: styles['row--borderBottom']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--detailPanelExpanded']}`]: styles['row--detailPanelExpanded']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--dragging']}`]: styles['row--dragging']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--dynamicHeight']}`]: styles['row--dynamicHeight']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--editable']}`]: styles['row--editable']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--editing']}`]: styles['row--editing']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--firstVisible']}`]: styles['row--firstVisible']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--lastVisible']}`]: styles['row--lastVisible']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).rowReorderCell}`]: styles.rowReorderCell
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['rowReorderCell--draggable']}`]: styles['rowReorderCell--draggable']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).rowReorderCellContainer}`]: styles.rowReorderCellContainer
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).rowReorderCellPlaceholder}`]: styles.rowReorderCellPlaceholder
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).rowSkeleton}`]: styles.rowSkeleton
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).scrollbar}`]: styles.scrollbar
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollbar--horizontal']}`]: styles['scrollbar--horizontal']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollbar--vertical']}`]: styles['scrollbar--vertical']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).scrollbarFiller}`]: styles.scrollbarFiller
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollbarFiller--borderBottom']}`]: styles['scrollbarFiller--borderBottom']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollbarFiller--borderTop']}`]: styles['scrollbarFiller--borderTop']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollbarFiller--header']}`]: styles['scrollbarFiller--header']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollbarFiller--pinnedRight']}`]: styles['scrollbarFiller--pinnedRight']
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).sortIcon}`]: styles.sortIcon
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).treeDataGroupingCell}`]: styles.treeDataGroupingCell
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).treeDataGroupingCellLoadingContainer}`]: styles.treeDataGroupingCellLoadingContainer
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).treeDataGroupingCellToggle}`]: styles.treeDataGroupingCellToggle
            },
            {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).withBorderColor}`]: styles.withBorderColor
            }
        ]
})(({ theme: t })=>{
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const shouldShowBorderTopRightRadius = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, $64116811ce6fb235$var$shouldShowBorderTopRightRadiusSelector);
    const borderColor = $64116811ce6fb235$var$getBorderColor(t);
    const radius = t.shape.borderRadius;
    const containerBackground = t.vars ? t.vars.palette.background.default : t.mixins.MuiDataGrid?.containerBackground ?? t.palette.background.default;
    const pinnedBackground = t.mixins.MuiDataGrid?.pinnedBackground ?? containerBackground;
    const overlayBackground = t.vars ? `rgba(${t.vars.palette.background.defaultChannel} / ${t.vars.palette.action.disabledOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(t.palette.background.default, t.palette.action.disabledOpacity);
    const hoverOpacity = (t.vars || t).palette.action.hoverOpacity;
    const hoverColor = (t.vars || t).palette.action.hover;
    const selectedOpacity = (t.vars || t).palette.action.selectedOpacity;
    const selectedHoverOpacity = t.vars ? `calc(${hoverOpacity} + ${selectedOpacity})` // TODO: Improve type
     : hoverOpacity + selectedOpacity;
    const selectedBackground = t.vars ? `rgba(${t.vars.palette.primary.mainChannel} / ${selectedOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(t.palette.primary.main, selectedOpacity);
    const selectedHoverBackground = t.vars ? `rgba(${t.vars.palette.primary.mainChannel} / ${selectedHoverOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(t.palette.primary.main, selectedHoverOpacity);
    const blendFn = t.vars ? $64116811ce6fb235$var$blendCssVars : $64116811ce6fb235$var$blend;
    const getPinnedBackgroundStyles = (backgroundColor)=>({
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--pinnedLeft']}, & .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--pinnedRight']}`]: {
                backgroundColor: backgroundColor,
                '&.Mui-selected': {
                    backgroundColor: blendFn(backgroundColor, selectedBackground, selectedOpacity),
                    '&:hover': {
                        backgroundColor: blendFn(backgroundColor, selectedBackground, selectedHoverOpacity)
                    }
                }
            }
        });
    const pinnedBackgroundColor = blendFn(pinnedBackground, hoverColor, hoverOpacity);
    const pinnedHoverStyles = getPinnedBackgroundStyles(pinnedBackgroundColor);
    const pinnedSelectedBackgroundColor = blendFn(pinnedBackground, selectedBackground, selectedOpacity);
    const pinnedSelectedStyles = getPinnedBackgroundStyles(pinnedSelectedBackgroundColor);
    const pinnedSelectedHoverBackgroundColor = blendFn(pinnedBackground, selectedHoverBackground, selectedHoverOpacity);
    const pinnedSelectedHoverStyles = getPinnedBackgroundStyles(pinnedSelectedHoverBackgroundColor);
    const selectedStyles = {
        backgroundColor: selectedBackground,
        '&:hover': {
            backgroundColor: selectedHoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: selectedBackground
            }
        }
    };
    const gridStyle = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        '--unstable_DataGrid-radius': typeof radius === 'number' ? `${radius}px` : radius,
        '--unstable_DataGrid-headWeight': t.typography.fontWeightMedium,
        '--unstable_DataGrid-overlayBackground': overlayBackground,
        '--DataGrid-containerBackground': containerBackground,
        '--DataGrid-pinnedBackground': pinnedBackground,
        '--DataGrid-rowBorderColor': borderColor,
        '--DataGrid-cellOffsetMultiplier': 2,
        '--DataGrid-width': '0px',
        '--DataGrid-hasScrollX': '0',
        '--DataGrid-hasScrollY': '0',
        '--DataGrid-scrollbarSize': '10px',
        '--DataGrid-rowWidth': '0px',
        '--DataGrid-columnsTotalWidth': '0px',
        '--DataGrid-leftPinnedWidth': '0px',
        '--DataGrid-rightPinnedWidth': '0px',
        '--DataGrid-headerHeight': '0px',
        '--DataGrid-headersTotalHeight': '0px',
        '--DataGrid-topContainerHeight': '0px',
        '--DataGrid-bottomContainerHeight': '0px',
        flex: 1,
        boxSizing: 'border-box',
        position: 'relative',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: borderColor,
        borderRadius: 'var(--unstable_DataGrid-radius)',
        color: (t.vars || t).palette.text.primary
    }, t.typography.body2, {
        outline: 'none',
        height: '100%',
        display: 'flex',
        minWidth: 0,
        // See https://github.com/mui/mui-x/issues/8547
        minHeight: 0,
        flexDirection: 'column',
        overflow: 'hidden',
        overflowAnchor: 'none',
        // Keep the same scrolling position
        transform: 'translate(0, 0)',
        // Create a stacking context to keep scrollbars from showing on top
        [`.${(0, $786c119d9add6b61$export$2100d54e36406477).main} > *:first-child${$64116811ce6fb235$var$ignoreSsrWarning}`]: {
            borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
            borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
        },
        [`&.${(0, $786c119d9add6b61$export$2100d54e36406477).autoHeight}`]: {
            height: 'auto'
        },
        [`&.${(0, $786c119d9add6b61$export$2100d54e36406477).autosizing}`]: {
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderTitleContainerContent} > *`]: {
                overflow: 'visible !important'
            },
            '@media (hover: hover)': {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).menuIcon}`]: {
                    width: '0 !important',
                    visibility: 'hidden !important'
                }
            },
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}`]: {
                overflow: 'visible !important',
                whiteSpace: 'nowrap',
                minWidth: 'max-content !important',
                maxWidth: 'max-content !important'
            },
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).groupingCriteriaCell}`]: {
                width: 'unset'
            },
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).treeDataGroupingCell}`]: {
                width: 'unset'
            }
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader}, & .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}`]: {
            WebkitTapHighlightColor: 'transparent',
            padding: '0 10px',
            boxSizing: 'border-box'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader}:focus-within, & .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}:focus-within`]: {
            outline: `solid ${t.vars ? `rgba(${t.vars.palette.primary.mainChannel} / 0.5)` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(t.palette.primary.main, 0.5)} ${$64116811ce6fb235$var$focusOutlineWidth}px`,
            outlineOffset: $64116811ce6fb235$var$focusOutlineWidth * -1
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader}:focus, & .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}:focus`]: {
            outline: `solid ${t.palette.primary.main} ${$64116811ce6fb235$var$focusOutlineWidth}px`,
            outlineOffset: $64116811ce6fb235$var$focusOutlineWidth * -1
        },
        // Hide the column separator when:
        // - the column is focused and has an outline
        // - the next column is focused and has an outline
        // - the column has a left or right border
        // - the next column is pinned right and has a left border
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader}:focus,
      & .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--withLeftBorder']},
      & .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--withRightBorder']},
      & .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--siblingFocused']},
      & .${(0, $786c119d9add6b61$export$2100d54e36406477)['virtualScroller--hasScrollX']} .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--lastUnpinned']},
      & .${(0, $786c119d9add6b61$export$2100d54e36406477)['virtualScroller--hasScrollX']} .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--last']}
      `]: {
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnSeparator}`]: {
                opacity: 0
            },
            // Show resizable separators at all times on touch devices
            '@media (hover: none)': {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--resizable']}`]: {
                    opacity: 1
                }
            },
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--resizable']}:hover`]: {
                opacity: 1
            }
        },
        [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['root--noToolbar']} [aria-rowindex="1"] [aria-colindex="1"]`]: {
            borderTopLeftRadius: 'calc(var(--unstable_DataGrid-radius) - 1px)'
        },
        [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['root--noToolbar']} [aria-rowindex="1"] .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--last']}`]: {
            borderTopRightRadius: shouldShowBorderTopRightRadius ? 'calc(var(--unstable_DataGrid-radius) - 1px)' : undefined
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderCheckbox}, & .${(0, $786c119d9add6b61$export$2100d54e36406477).cellCheckbox}`]: {
            padding: 0,
            justifyContent: 'center',
            alignItems: 'center'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader}`]: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['virtualScroller--hasScrollX']} .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--last']}`]: {
            overflow: 'hidden'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--sorted']} .${(0, $786c119d9add6b61$export$2100d54e36406477).iconButtonContainer}, & .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--filtered']} .${(0, $786c119d9add6b61$export$2100d54e36406477).iconButtonContainer}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader}:not(.${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--sorted']}) .${(0, $786c119d9add6b61$export$2100d54e36406477).sortButton}`]: {
            opacity: 0,
            transition: t.transitions.create([
                'opacity'
            ], {
                duration: t.transitions.duration.shorter
            })
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            gap: t.spacing(0.25),
            minWidth: 0,
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderTitleContainerContent}`]: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--filledGroup']} .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            boxSizing: 'border-box'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).sortIcon}, & .${(0, $786c119d9add6b61$export$2100d54e36406477).filterIcon}`]: {
            fontSize: 'inherit'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--sortable']}`]: {
            cursor: 'pointer'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--alignCenter']} .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            justifyContent: 'center'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--alignRight']} .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderDraggableContainer}, & .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--alignRight']} .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            flexDirection: 'row-reverse'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--alignCenter']} .${(0, $786c119d9add6b61$export$2100d54e36406477).menuIcon}`]: {
            marginLeft: 'auto'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--alignRight']} .${(0, $786c119d9add6b61$export$2100d54e36406477).menuIcon}`]: {
            marginRight: 'auto',
            marginLeft: -5
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--moving']}`]: {
            backgroundColor: (t.vars || t).palette.action.hover
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--pinnedLeft']}, & .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--pinnedRight']}`]: {
            position: 'sticky',
            zIndex: 40,
            // Should be above the column separator
            background: 'var(--DataGrid-pinnedBackground)'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnSeparator}`]: {
            position: 'absolute',
            overflow: 'hidden',
            zIndex: 30,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: $64116811ce6fb235$var$columnSeparatorTargetSize,
            color: borderColor
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaders}`]: {
            width: 'var(--DataGrid-rowWidth)'
        },
        '@media (hover: hover)': {
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader}:hover`]: {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).menuIcon}`]: {
                    width: 'auto',
                    visibility: 'visible'
                },
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).iconButtonContainer}`]: {
                    visibility: 'visible',
                    width: 'auto'
                }
            },
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader}:not(.${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--sorted']}):hover .${(0, $786c119d9add6b61$export$2100d54e36406477).sortButton}`]: {
                opacity: 0.5
            }
        },
        '@media (hover: none)': {
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader} .${(0, $786c119d9add6b61$export$2100d54e36406477).menuIcon}`]: {
                width: 'auto',
                visibility: 'visible'
            },
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader}:focus,
        & .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--siblingFocused']}`]: {
                [`.${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--resizable']}`]: {
                    color: (t.vars || t).palette.primary.main
                }
            }
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--sideLeft']}`]: {
            left: $64116811ce6fb235$var$columnSeparatorOffset
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--sideRight']}`]: {
            right: $64116811ce6fb235$var$columnSeparatorOffset
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--withRightBorder']} .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--sideLeft']}`]: {
            left: $64116811ce6fb235$var$columnSeparatorOffset - 0.5
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--withRightBorder']} .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--sideRight']}`]: {
            right: $64116811ce6fb235$var$columnSeparatorOffset - 0.5
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--resizable']}`]: {
            cursor: 'col-resize',
            touchAction: 'none',
            [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--resizing']}`]: {
                color: (t.vars || t).palette.primary.main
            },
            // Always appear as draggable on touch devices
            '@media (hover: none)': {
                [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).iconSeparator} rect`]: $64116811ce6fb235$var$separatorIconDragStyles
            },
            '@media (hover: hover)': {
                '&:hover': {
                    color: (t.vars || t).palette.primary.main,
                    [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).iconSeparator} rect`]: $64116811ce6fb235$var$separatorIconDragStyles
                }
            },
            '& svg': {
                pointerEvents: 'none'
            }
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).iconSeparator}`]: {
            color: 'inherit',
            transition: t.transitions.create([
                'color',
                'width'
            ], {
                duration: t.transitions.duration.shortest
            })
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).menuIcon}`]: {
            width: 0,
            visibility: 'hidden',
            fontSize: 20,
            marginRight: -5,
            display: 'flex',
            alignItems: 'center'
        },
        [`.${(0, $786c119d9add6b61$export$2100d54e36406477).menuOpen}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).headerFilterRow}`]: {
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader}`]: {
                boxSizing: 'border-box',
                borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
            }
        },
        /* Bottom border of the top-container */ [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--borderBottom']} .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeader},
      & .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--borderBottom']} .${(0, $786c119d9add6b61$export$2100d54e36406477).filler},
      & .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--borderBottom']} .${(0, $786c119d9add6b61$export$2100d54e36406477).scrollbarFiller}`]: {
            borderBottom: `1px solid var(--DataGrid-rowBorderColor)`
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--borderBottom']} .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}`]: {
            borderBottom: `1px solid var(--rowBorderColor)`
        },
        /* Row styles */ [`.${(0, $786c119d9add6b61$export$2100d54e36406477).row}`]: {
            display: 'flex',
            width: 'var(--DataGrid-rowWidth)',
            breakInside: 'avoid',
            // Avoid the row to be broken in two different print pages.
            '--rowBorderColor': 'var(--DataGrid-rowBorderColor)',
            [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['row--firstVisible']}`]: {
                '--rowBorderColor': 'transparent'
            },
            '&:hover': {
                backgroundColor: (t.vars || t).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${(0, $786c119d9add6b61$export$2100d54e36406477).rowSkeleton}:hover`]: {
                backgroundColor: 'transparent'
            },
            '&.Mui-selected': selectedStyles
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['container--top']}, & .${(0, $786c119d9add6b61$export$2100d54e36406477)['container--bottom']}`]: {
            '[role=row]': {
                background: 'var(--DataGrid-containerBackground)'
            }
        },
        /* Cell styles */ [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}`]: {
            flex: '0 0 auto',
            height: 'var(--height)',
            width: 'var(--width)',
            lineHeight: 'calc(var(--height) - 1px)',
            // -1px for the border
            boxSizing: 'border-box',
            borderTop: `1px solid var(--rowBorderColor)`,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            '&.Mui-selected': selectedStyles
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['virtualScrollerContent--overflowed']} .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--lastVisible']} .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}`]: {
            borderTopColor: 'transparent'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['pinnedRows--top']} :first-of-type`]: {
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}, .${(0, $786c119d9add6b61$export$2100d54e36406477).scrollbarFiller}`]: {
                borderTop: 'none'
            }
        },
        [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['root--disableUserSelection']}`]: {
            userSelect: 'none'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--dynamicHeight']} > .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}`]: {
            whiteSpace: 'initial',
            lineHeight: 'inherit'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cellEmpty}`]: {
            flex: 1,
            padding: 0,
            height: 'unset'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}.${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--selectionMode']}`]: {
            cursor: 'default'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}.${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--editing']}`]: {
            padding: 1,
            display: 'flex',
            boxShadow: t.shadows[2],
            backgroundColor: (t.vars || t).palette.background.paper,
            '&:focus-within': {
                outline: `${$64116811ce6fb235$var$focusOutlineWidth}px solid ${(t.vars || t).palette.primary.main}`,
                outlineOffset: $64116811ce6fb235$var$focusOutlineWidth * -1
            }
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--editing']}`]: {
            boxShadow: t.shadows[2]
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--editing']} .${(0, $786c119d9add6b61$export$2100d54e36406477).cell}`]: {
            boxShadow: t.shadows[0],
            backgroundColor: (t.vars || t).palette.background.paper
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).editBooleanCell}`]: {
            display: 'flex',
            height: '100%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).booleanCell}[data-value="true"]`]: {
            color: (t.vars || t).palette.text.secondary
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).booleanCell}[data-value="false"]`]: {
            color: (t.vars || t).palette.text.disabled
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).actionsCell}`]: {
            display: 'inline-flex',
            alignItems: 'center',
            gridGap: t.spacing(1)
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).rowReorderCell}`]: {
            display: 'inline-flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            opacity: (t.vars || t).palette.action.disabledOpacity
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['rowReorderCell--draggable']}`]: {
            cursor: 'move',
            opacity: 1
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).rowReorderCellContainer}`]: {
            padding: 0,
            display: 'flex',
            alignItems: 'stretch'
        },
        [`.${(0, $786c119d9add6b61$export$2100d54e36406477).withBorderColor}`]: {
            borderColor: borderColor
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--withLeftBorder']}, & .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--withLeftBorder']}`]: {
            borderLeftColor: 'var(--DataGrid-rowBorderColor)',
            borderLeftWidth: '1px',
            borderLeftStyle: 'solid'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--withRightBorder']}, & .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--withRightBorder']}`]: {
            borderRightColor: 'var(--DataGrid-rowBorderColor)',
            borderRightWidth: '1px',
            borderRightStyle: 'solid'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--flex']}`]: {
            display: 'flex',
            alignItems: 'center',
            lineHeight: 'inherit'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--textLeft']}`]: {
            textAlign: 'left',
            justifyContent: 'flex-start'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--textRight']}`]: {
            textAlign: 'right',
            justifyContent: 'flex-end'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--textCenter']}`]: {
            textAlign: 'center',
            justifyContent: 'center'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--pinnedLeft']}, & .${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--pinnedRight']}`]: {
            position: 'sticky',
            zIndex: 30,
            background: 'var(--DataGrid-pinnedBackground)',
            '&.Mui-selected': {
                backgroundColor: pinnedSelectedBackgroundColor
            }
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).virtualScrollerContent} .${(0, $786c119d9add6b61$export$2100d54e36406477).row}`]: {
            '&:hover': pinnedHoverStyles,
            '&.Mui-selected': pinnedSelectedStyles,
            '&.Mui-selected:hover': pinnedSelectedHoverStyles
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cellOffsetLeft}`]: {
            flex: '0 0 auto',
            display: 'inline-block'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).cellSkeleton}`]: {
            flex: '0 0 auto',
            height: '100%',
            display: 'inline-flex',
            alignItems: 'center'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderDraggableContainer}`]: {
            display: 'flex',
            width: '100%',
            height: '100%'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).rowReorderCellPlaceholder}`]: {
            display: 'none'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--dragging']}, & .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--dragging']}`]: {
            background: (t.vars || t).palette.background.paper,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: (t.vars || t).palette.action.disabledOpacity
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['row--dragging']}`]: {
            background: (t.vars || t).palette.background.paper,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: (t.vars || t).palette.action.disabledOpacity,
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).rowReorderCellPlaceholder}`]: {
                display: 'flex'
            }
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).treeDataGroupingCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).treeDataGroupingCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: t.spacing(2)
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).treeDataGroupingCellLoadingContainer}, .${(0, $786c119d9add6b61$export$2100d54e36406477).groupingCriteriaCellLoadingContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).groupingCriteriaCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).groupingCriteriaCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: t.spacing(2)
        },
        /* ScrollbarFiller styles */ [`.${(0, $786c119d9add6b61$export$2100d54e36406477).scrollbarFiller}`]: {
            minWidth: 'calc(var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))',
            alignSelf: 'stretch',
            [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollbarFiller--borderTop']}`]: {
                borderTop: '1px solid var(--DataGrid-rowBorderColor)'
            },
            [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollbarFiller--borderBottom']}`]: {
                borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
            },
            [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollbarFiller--pinnedRight']}`]: {
                backgroundColor: 'var(--DataGrid-pinnedBackground)',
                position: 'sticky',
                right: 0
            }
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).filler}`]: {
            flex: '1 0 auto'
        },
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['filler--borderBottom']}`]: {
            borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
        },
        /* Hide grid rows, row filler, and vertical scrollbar when skeleton overlay is visible */ [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['main--hasSkeletonLoadingOverlay']}`]: {
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).virtualScrollerContent}`]: {
                // We use visibility hidden so that the virtual scroller content retains its height.
                // Position fixed is used to remove the virtual scroller content from the flow.
                // https://github.com/mui/mui-x/issues/14061
                position: 'fixed',
                visibility: 'hidden'
            },
            [`& .${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollbar--vertical']}, & .${(0, $786c119d9add6b61$export$2100d54e36406477).pinnedRows}, & .${(0, $786c119d9add6b61$export$2100d54e36406477).virtualScroller} > .${(0, $786c119d9add6b61$export$2100d54e36406477).filler}`]: {
                display: 'none'
            }
        }
    });
    return gridStyle;
});
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 */ function $64116811ce6fb235$var$blend(background, overlay, opacity, gamma = 1) {
    const f = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = (0, $595d4f40c92954a4$export$677b39864803984e)(background);
    const overlayColor = (0, $595d4f40c92954a4$export$677b39864803984e)(overlay);
    const rgb = [
        f(backgroundColor.values[0], overlayColor.values[0]),
        f(backgroundColor.values[1], overlayColor.values[1]),
        f(backgroundColor.values[2], overlayColor.values[2])
    ];
    return (0, $595d4f40c92954a4$export$211a73f2b8c10ce4)({
        type: 'rgb',
        values: rgb
    });
}
const $64116811ce6fb235$var$removeOpacity = (color)=>`rgb(from ${color} r g b / 1)`;
function $64116811ce6fb235$var$blendCssVars(background, overlay, opacity) {
    return `color-mix(in srgb,${background}, ${$64116811ce6fb235$var$removeOpacity(overlay)} calc(${opacity} * 100%))`;
}





var $lCzvA = parcelRequire("lCzvA");

const $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3 = ()=>{
    const contextValue = $lCzvA.useContext((0, $7d5db04bce60c865$export$e00c5fe7e13db7ba));
    if (!contextValue) throw new Error('MUI X: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.');
    return contextValue;
};



var $deae25339410ed5d$var$__defProp = Object.defineProperty;
var $deae25339410ed5d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $deae25339410ed5d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $deae25339410ed5d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $deae25339410ed5d$var$__defNormalProp = (obj, key, value)=>key in obj ? $deae25339410ed5d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $deae25339410ed5d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($deae25339410ed5d$var$__hasOwnProp.call(b, prop)) $deae25339410ed5d$var$__defNormalProp(a, prop, b[prop]);
    if ($deae25339410ed5d$var$__getOwnPropSymbols) {
        for (var prop of $deae25339410ed5d$var$__getOwnPropSymbols(b))if ($deae25339410ed5d$var$__propIsEnum.call(b, prop)) $deae25339410ed5d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $deae25339410ed5d$var$__publicField = (obj, key, value)=>$deae25339410ed5d$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/devModeChecks/identityFunctionCheck.ts
var $deae25339410ed5d$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $deae25339410ed5d$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $deae25339410ed5d$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $deae25339410ed5d$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($deae25339410ed5d$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $deae25339410ed5d$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $deae25339410ed5d$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $deae25339410ed5d$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $deae25339410ed5d$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $deae25339410ed5d$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $deae25339410ed5d$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $deae25339410ed5d$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $deae25339410ed5d$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $deae25339410ed5d$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $deae25339410ed5d$var$__spreadValues($deae25339410ed5d$var$__spreadValues({}, $deae25339410ed5d$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $deae25339410ed5d$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $deae25339410ed5d$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $deae25339410ed5d$var$$REVISION = 0;
var $deae25339410ed5d$var$CURRENT_TRACKER = null;
var $deae25339410ed5d$var$Cell = class {
    constructor(initialValue, isEqual = $deae25339410ed5d$var$tripleEq){
        $deae25339410ed5d$var$__publicField(this, "revision", $deae25339410ed5d$var$$REVISION);
        $deae25339410ed5d$var$__publicField(this, "_value");
        $deae25339410ed5d$var$__publicField(this, "_lastValue");
        $deae25339410ed5d$var$__publicField(this, "_isEqual", $deae25339410ed5d$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $deae25339410ed5d$var$CURRENT_TRACKER == null || $deae25339410ed5d$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$deae25339410ed5d$var$$REVISION;
    }
};
function $deae25339410ed5d$var$tripleEq(a, b) {
    return a === b;
}
var $deae25339410ed5d$var$TrackingCache = class {
    constructor(fn){
        $deae25339410ed5d$var$__publicField(this, "_cachedValue");
        $deae25339410ed5d$var$__publicField(this, "_cachedRevision", -1);
        $deae25339410ed5d$var$__publicField(this, "_deps", []);
        $deae25339410ed5d$var$__publicField(this, "hits", 0);
        $deae25339410ed5d$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $deae25339410ed5d$var$CURRENT_TRACKER;
            $deae25339410ed5d$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $deae25339410ed5d$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $deae25339410ed5d$var$CURRENT_TRACKER == null || $deae25339410ed5d$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $deae25339410ed5d$var$getValue(cell) {
    if (!(cell instanceof $deae25339410ed5d$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $deae25339410ed5d$var$setValue(storage, value) {
    if (!(storage instanceof $deae25339410ed5d$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $deae25339410ed5d$var$createCell(initialValue, isEqual = $deae25339410ed5d$var$tripleEq) {
    return new $deae25339410ed5d$var$Cell(initialValue, isEqual);
}
function $deae25339410ed5d$var$createCache(fn) {
    $deae25339410ed5d$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $deae25339410ed5d$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $deae25339410ed5d$var$neverEq = (a, b)=>false;
function $deae25339410ed5d$var$createTag() {
    return $deae25339410ed5d$var$createCell(null, $deae25339410ed5d$var$neverEq);
}
function $deae25339410ed5d$var$dirtyTag(tag, value) {
    $deae25339410ed5d$var$setValue(tag, value);
}
var $deae25339410ed5d$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $deae25339410ed5d$var$createTag();
    $deae25339410ed5d$var$getValue(tag);
};
var $deae25339410ed5d$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $deae25339410ed5d$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $deae25339410ed5d$var$nextId = 0;
var $deae25339410ed5d$var$proto = /* @__PURE__ */ Object.getPrototypeOf({});
var $deae25339410ed5d$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $deae25339410ed5d$var$__publicField(this, "proxy", new Proxy(this, $deae25339410ed5d$var$objectProxyHandler));
        $deae25339410ed5d$var$__publicField(this, "tag", $deae25339410ed5d$var$createTag());
        $deae25339410ed5d$var$__publicField(this, "tags", {});
        $deae25339410ed5d$var$__publicField(this, "children", {});
        $deae25339410ed5d$var$__publicField(this, "collectionTag", null);
        $deae25339410ed5d$var$__publicField(this, "id", $deae25339410ed5d$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $deae25339410ed5d$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $deae25339410ed5d$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $deae25339410ed5d$var$createNode(childValue);
                if (childNode.tag) $deae25339410ed5d$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $deae25339410ed5d$var$createTag();
                    tag.value = childValue;
                }
                $deae25339410ed5d$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $deae25339410ed5d$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $deae25339410ed5d$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $deae25339410ed5d$var$__publicField(this, "proxy", new Proxy([
            this
        ], $deae25339410ed5d$var$arrayProxyHandler));
        $deae25339410ed5d$var$__publicField(this, "tag", $deae25339410ed5d$var$createTag());
        $deae25339410ed5d$var$__publicField(this, "tags", {});
        $deae25339410ed5d$var$__publicField(this, "children", {});
        $deae25339410ed5d$var$__publicField(this, "collectionTag", null);
        $deae25339410ed5d$var$__publicField(this, "id", $deae25339410ed5d$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $deae25339410ed5d$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $deae25339410ed5d$var$consumeCollection(node);
        return $deae25339410ed5d$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $deae25339410ed5d$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $deae25339410ed5d$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $deae25339410ed5d$var$objectProxyHandler.has(node, prop);
    }
};
function $deae25339410ed5d$var$createNode(value) {
    if (Array.isArray(value)) return new $deae25339410ed5d$var$ArrayTreeNode(value);
    return new $deae25339410ed5d$var$ObjectTreeNode(value);
}
function $deae25339410ed5d$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $deae25339410ed5d$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $deae25339410ed5d$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $deae25339410ed5d$var$dirtyCollection(node);
            $deae25339410ed5d$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $deae25339410ed5d$var$updateNode(childNode, newChildValue);
        else {
            $deae25339410ed5d$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $deae25339410ed5d$var$deleteNode(node) {
    if (node.tag) $deae25339410ed5d$var$dirtyTag(node.tag, null);
    $deae25339410ed5d$var$dirtyCollection(node);
    for(const key in node.tags)$deae25339410ed5d$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$deae25339410ed5d$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $deae25339410ed5d$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $deae25339410ed5d$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $deae25339410ed5d$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $deae25339410ed5d$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $deae25339410ed5d$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $deae25339410ed5d$export$3f025202a230c6dd = (a, b)=>a === b;
function $deae25339410ed5d$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $deae25339410ed5d$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $deae25339410ed5d$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $deae25339410ed5d$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $deae25339410ed5d$var$createSingletonCache(comparator) : $deae25339410ed5d$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $deae25339410ed5d$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $deae25339410ed5d$export$c8f9cf88d9fdee55(func) {
    const node = $deae25339410ed5d$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $deae25339410ed5d$var$createCacheKeyComparator($deae25339410ed5d$export$3f025202a230c6dd);
    const cache = $deae25339410ed5d$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $deae25339410ed5d$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $deae25339410ed5d$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $deae25339410ed5d$var$getWeakRef = ()=>typeof WeakRef === "undefined" ? $deae25339410ed5d$var$StrongRef : WeakRef;
var $deae25339410ed5d$var$Ref = /* @__PURE__ */ $deae25339410ed5d$var$getWeakRef();
var $deae25339410ed5d$var$UNTERMINATED = 0;
var $deae25339410ed5d$var$TERMINATED = 1;
function $deae25339410ed5d$var$createCacheNode() {
    return {
        s: $deae25339410ed5d$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $deae25339410ed5d$var$maybeDeref(r) {
    if (r instanceof $deae25339410ed5d$var$Ref) return r.deref();
    return r;
}
function $deae25339410ed5d$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $deae25339410ed5d$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $deae25339410ed5d$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $deae25339410ed5d$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $deae25339410ed5d$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = $deae25339410ed5d$var$maybeDeref(lastResult);
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? /* @__PURE__ */ new $deae25339410ed5d$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $deae25339410ed5d$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $deae25339410ed5d$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $deae25339410ed5d$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $deae25339410ed5d$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $deae25339410ed5d$var$__spreadValues($deae25339410ed5d$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $deae25339410ed5d$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [] } = combinedOptions;
        const finalMemoizeOptions = $deae25339410ed5d$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $deae25339410ed5d$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $deae25339410ed5d$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $deae25339410ed5d$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $deae25339410ed5d$export$595d22ed68ca2841 = /* @__PURE__ */ $deae25339410ed5d$export$5943f4447f6ef248($deae25339410ed5d$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $deae25339410ed5d$export$75979cfcd91bf38f = /* @__PURE__ */ Object.assign((inputSelectorsObject, selectorCreator = $deae25339410ed5d$export$595d22ed68ca2841)=>{
    $deae25339410ed5d$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$deae25339410ed5d$export$75979cfcd91bf38f
});




const $f0fef4ed0246c865$var$reselectCreateSelector = (0, $deae25339410ed5d$export$5943f4447f6ef248)({
    memoize: (0, $deae25339410ed5d$export$d8ead1d92249919b),
    memoizeOptions: {
        maxSize: 1,
        equalityCheck: Object.is
    }
});
// TODO v8: Remove this type
// TODO v8: Rename this type to `OutputSelector`
// TODO v8: Remove this type
// TODO v8: Rename this type to `SelectorArgs`
// TODO v8: Remove this type
// TODO v8: Rename this type to `CreateSelectorFunction`
const $f0fef4ed0246c865$var$cache = new WeakMap();
function $f0fef4ed0246c865$var$checkIsAPIRef(value) {
    return 'current' in value && 'instanceId' in value.current;
}
const $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID = {
    id: 'default'
};
const $f0fef4ed0246c865$export$595d22ed68ca2841 = (a, b, c, d, e, f, ...other)=>{
    if (other.length > 0) throw new Error('Unsupported number of selectors');
    let selector;
    // eslint-disable-next-line id-denylist
    if (a && b && c && d && e && f) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        const ve = e(state, instanceId);
        return f(va, vb, vc, vd, ve);
    };
    else if (a && b && c && d && e) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        return e(va, vb, vc, vd);
    };
    else if (a && b && c && d) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        return d(va, vb, vc);
    };
    else if (a && b && c) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        return c(va, vb);
    };
    else if (a && b) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        return b(va);
    };
    else throw new Error('Missing arguments');
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
const $f0fef4ed0246c865$export$89f5fc21559ede9b = (a, b, c, d, e, f, ...other)=>{
    if (other.length > 0) throw new Error('Unsupported number of selectors');
    let selector;
    // eslint-disable-next-line id-denylist
    if (a && b && c && d && e && f) selector = (stateOrApiRef, args, instanceIdParam)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, args, instanceId);
        const vb = b(state, args, instanceId);
        const vc = c(state, args, instanceId);
        const vd = d(state, args, instanceId);
        const ve = e(state, args, instanceId);
        return f(va, vb, vc, vd, ve, args);
    };
    else if (a && b && c && d && e) selector = (stateOrApiRef, args, instanceIdParam)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, args, instanceId);
        const vb = b(state, args, instanceId);
        const vc = c(state, args, instanceId);
        const vd = d(state, args, instanceId);
        return e(va, vb, vc, vd, args);
    };
    else if (a && b && c && d) selector = (stateOrApiRef, args, instanceIdParam)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, args, instanceId);
        const vb = b(state, args, instanceId);
        const vc = c(state, args, instanceId);
        return d(va, vb, vc, args);
    };
    else if (a && b && c) selector = (stateOrApiRef, args, instanceIdParam)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, args, instanceId);
        const vb = b(state, args, instanceId);
        return c(va, vb, args);
    };
    else if (a && b) selector = (stateOrApiRef, args, instanceIdParam)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, args, instanceId);
        return b(va, args);
    };
    else throw new Error('Missing arguments');
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
const $f0fef4ed0246c865$export$2a3ca4704a61d1f4 = (...args)=>{
    const selector = (stateOrApiRef, instanceId)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const cacheKey = isAPIRef ? stateOrApiRef.current.instanceId : instanceId ?? $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const cacheArgsInit = $f0fef4ed0246c865$var$cache.get(cacheKey);
        const cacheArgs = cacheArgsInit ?? new Map();
        const cacheFn = cacheArgs?.get(args);
        if (cacheArgs && cacheFn) // We pass the cache key because the called selector might have as
        // dependency another selector created with this `createSelector`.
        return cacheFn(state, cacheKey);
        const fn = $f0fef4ed0246c865$var$reselectCreateSelector(...args);
        if (!cacheArgsInit) $f0fef4ed0246c865$var$cache.set(cacheKey, cacheArgs);
        cacheArgs.set(args, fn);
        return fn(state, cacheKey);
    };
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
const $f0fef4ed0246c865$export$9da95869caa746c6 = (...args)=>{
    const selector = (stateOrApiRef, selectorArgs, instanceId)=>{
        const isAPIRef = $f0fef4ed0246c865$var$checkIsAPIRef(stateOrApiRef);
        const cacheKey = isAPIRef ? stateOrApiRef.current.instanceId : instanceId ?? $f0fef4ed0246c865$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const cacheArgsInit = $f0fef4ed0246c865$var$cache.get(cacheKey);
        const cacheArgs = cacheArgsInit ?? new Map();
        const cacheFn = cacheArgs?.get(args);
        if (cacheArgs && cacheFn) {
            if (!(0, $1e10d601c15466d4$export$5a7c3a25f6dab637)(cacheFn.selectorArgs, selectorArgs)) {
                const reselectArgs = selectorArgs !== undefined ? [
                    ...args.slice(0, args.length - 1),
                    ()=>selectorArgs,
                    args[args.length - 1]
                ] : args;
                const fn = $f0fef4ed0246c865$var$reselectCreateSelector(...reselectArgs);
                fn.selectorArgs = selectorArgs;
                cacheArgs.set(args, fn);
                return fn(state, selectorArgs, cacheKey);
            }
            // We pass the cache key because the called selector might have as
            // dependency another selector created with this `createSelector`.
            return cacheFn(state, selectorArgs, cacheKey);
        }
        const reselectArgs = selectorArgs !== undefined ? [
            ...args.slice(0, args.length - 1),
            ()=>selectorArgs,
            args[args.length - 1]
        ] : args;
        const fn = $f0fef4ed0246c865$var$reselectCreateSelector(...reselectArgs);
        fn.selectorArgs = selectorArgs;
        if (!cacheArgsInit) $f0fef4ed0246c865$var$cache.set(cacheKey, cacheArgs);
        cacheArgs.set(args, fn);
        return fn(state, selectorArgs, cacheKey);
    };
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};


const $bc5ab296ed04c1c0$export$44e428f429332330 = 0.7;
const $bc5ab296ed04c1c0$export$ff72d9a37c8f7b58 = 1.3;
const $bc5ab296ed04c1c0$var$DENSITY_FACTORS = {
    compact: $bc5ab296ed04c1c0$export$44e428f429332330,
    comfortable: $bc5ab296ed04c1c0$export$ff72d9a37c8f7b58,
    standard: 1
};
const $bc5ab296ed04c1c0$export$806a039ece4425b4 = (state)=>state.density;
const $bc5ab296ed04c1c0$export$c646201fb1d3e7a6 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($bc5ab296ed04c1c0$export$806a039ece4425b4, (density)=>$bc5ab296ed04c1c0$var$DENSITY_FACTORS[density]);



const $484258b08ca5b04f$var$emptySubscribe = ()=>()=>{};
const $484258b08ca5b04f$var$clientSnapshot = ()=>false;
const $484258b08ca5b04f$var$serverSnapshot = ()=>true;
const $484258b08ca5b04f$export$535bd6ca7f90a273 = ()=>(0, $cd02143f1792b46c$exports.useSyncExternalStore)($484258b08ca5b04f$var$emptySubscribe, $484258b08ca5b04f$var$clientSnapshot, $484258b08ca5b04f$var$serverSnapshot);




var $lCzvA = parcelRequire("lCzvA");


parcelRequire("lCzvA");

let $1d134ed1d4a5dbe8$export$64f54b460f67389c = /*#__PURE__*/ function(GridPinnedColumnPosition) {
    GridPinnedColumnPosition["LEFT"] = "left";
    GridPinnedColumnPosition["RIGHT"] = "right";
    return GridPinnedColumnPosition;
}({});
const $1d134ed1d4a5dbe8$export$77439b544edbbd66 = {
    left: [],
    right: []
};


/**
 * Get the theme state
 * @category Core
 */ const $8713a42cc863c762$export$ece6490d69662ba0 = (state)=>state.isRtl;


const $8b99503000dd62d3$export$858d15abb6cddc08 = (state)=>state.columns;
const $8b99503000dd62d3$export$d8a3dfbb129c80db = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($8b99503000dd62d3$export$858d15abb6cddc08, (columnsState)=>columnsState.orderedFields);
const $8b99503000dd62d3$export$8a3a9a6db584d7fd = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($8b99503000dd62d3$export$858d15abb6cddc08, (columnsState)=>columnsState.lookup);
const $8b99503000dd62d3$export$da85f06e3c19f1fd = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8b99503000dd62d3$export$d8a3dfbb129c80db, $8b99503000dd62d3$export$8a3a9a6db584d7fd, (allFields, lookup)=>allFields.map((field)=>lookup[field]));
const $8b99503000dd62d3$export$eb0d33595fe29bb4 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($8b99503000dd62d3$export$858d15abb6cddc08, (columnsState)=>columnsState.columnVisibilityModel);
const $8b99503000dd62d3$export$16a65a9447d3dda9 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8b99503000dd62d3$export$da85f06e3c19f1fd, $8b99503000dd62d3$export$eb0d33595fe29bb4, (columns, columnVisibilityModel)=>columns.filter((column)=>columnVisibilityModel[column.field] !== false));
const $8b99503000dd62d3$export$c9491722e1d6e8d3 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8b99503000dd62d3$export$16a65a9447d3dda9, (visibleColumns)=>visibleColumns.map((column)=>column.field));
const $8b99503000dd62d3$export$1eea0bd4db853467 = (state)=>state.pinnedColumns;
const $8b99503000dd62d3$export$92910475beda795c = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8b99503000dd62d3$export$1eea0bd4db853467, $8b99503000dd62d3$export$d8a3dfbb129c80db, (0, $8713a42cc863c762$export$ece6490d69662ba0), (model, orderedFields, isRtl)=>$8b99503000dd62d3$var$filterMissingColumns(model, orderedFields, isRtl));
const $8b99503000dd62d3$export$297e8079713afa11 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8b99503000dd62d3$export$858d15abb6cddc08, $8b99503000dd62d3$export$1eea0bd4db853467, $8b99503000dd62d3$export$c9491722e1d6e8d3, (0, $8713a42cc863c762$export$ece6490d69662ba0), (columnsState, model, visibleColumnFields, isRtl)=>{
    const visiblePinnedFields = $8b99503000dd62d3$var$filterMissingColumns(model, visibleColumnFields, isRtl);
    const visiblePinnedColumns = {
        left: visiblePinnedFields.left.map((field)=>columnsState.lookup[field]),
        right: visiblePinnedFields.right.map((field)=>columnsState.lookup[field])
    };
    return visiblePinnedColumns;
});
function $8b99503000dd62d3$var$filterMissingColumns(pinnedColumns, columns, invert) {
    if (!Array.isArray(pinnedColumns.left) && !Array.isArray(pinnedColumns.right)) return 0, $1d134ed1d4a5dbe8$export$77439b544edbbd66;
    if (pinnedColumns.left?.length === 0 && pinnedColumns.right?.length === 0) return 0, $1d134ed1d4a5dbe8$export$77439b544edbbd66;
    const filter = (newPinnedColumns, remainingColumns)=>{
        if (!Array.isArray(newPinnedColumns)) return [];
        return newPinnedColumns.filter((field)=>remainingColumns.includes(field));
    };
    const leftPinnedColumns = filter(pinnedColumns.left, columns);
    const columnsWithoutLeftPinnedColumns = columns.filter(// Filter out from the remaining columns those columns already pinned to the left
    (field)=>!leftPinnedColumns.includes(field));
    const rightPinnedColumns = filter(pinnedColumns.right, columnsWithoutLeftPinnedColumns);
    if (invert) return {
        left: rightPinnedColumns,
        right: leftPinnedColumns
    };
    return {
        left: leftPinnedColumns,
        right: rightPinnedColumns
    };
}
const $8b99503000dd62d3$export$fce7d810e48021e3 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8b99503000dd62d3$export$16a65a9447d3dda9, (visibleColumns)=>{
    const positions = [];
    let currentPosition = 0;
    for(let i = 0; i < visibleColumns.length; i += 1){
        positions.push(currentPosition);
        currentPosition += visibleColumns[i].computedWidth;
    }
    return positions;
});
const $8b99503000dd62d3$export$2cad659ba95fed71 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8b99503000dd62d3$export$da85f06e3c19f1fd, (columns)=>columns.filter((col)=>col.filterable));
const $8b99503000dd62d3$export$e84218276cc24419 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8b99503000dd62d3$export$da85f06e3c19f1fd, (columns)=>columns.reduce((acc, col)=>{
        if (col.filterable) acc[col.field] = col;
        return acc;
    }, {}));
const $8b99503000dd62d3$export$7aac81e7227448b4 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8b99503000dd62d3$export$da85f06e3c19f1fd, (columns)=>columns.some((column)=>column.colSpan !== undefined));




const $471c38056db01dd0$export$37e5474577e02878 = (state)=>state.preferencePanel;
const $471c38056db01dd0$export$d19024d6f0cb2c88 = (0, $f0fef4ed0246c865$export$89f5fc21559ede9b)($471c38056db01dd0$export$37e5474577e02878, (panel, labelId)=>{
    if (panel.open && panel.labelId === labelId) return true;
    return false;
});


var $57afc8119b2eb3e6$export$e7e5652452e44b = /*#__PURE__*/ function(GridPreferencePanelsValue) {
    GridPreferencePanelsValue["filters"] = "filters";
    GridPreferencePanelsValue["columns"] = "columns";
    return GridPreferencePanelsValue;
}($57afc8119b2eb3e6$export$e7e5652452e44b || {});



var $lCzvA = parcelRequire("lCzvA");

function $7782d7e95102f01f$export$2d14edd3a7db3bbf() {
    const apiRef = $lCzvA.useContext((0, $b2d323edd8d815c2$export$70c437c2dab15e52));
    if (apiRef === undefined) throw new Error([
        'MUI X: Could not find the Data Grid context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return apiRef;
}




function $6c67743c42bb7678$export$6cff59e5608ce17d() {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const columns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$da85f06e3c19f1fd));
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const preferencePanelState = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $471c38056db01dd0$export$37e5474577e02878));
    const panelContent = apiRef.current.unstable_applyPipeProcessors('preferencePanel', null, preferencePanelState.openedPanelValue ?? (0, $57afc8119b2eb3e6$export$e7e5652452e44b).filters);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.panel, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        as: rootProps.slots.basePopper,
        open: columns.length > 0 && preferencePanelState.open,
        id: preferencePanelState.panelId,
        "aria-labelledby": preferencePanelState.labelId
    }, rootProps.slotProps?.panel, rootProps.slotProps?.basePopper, {
        children: panelContent
    }));
}



function $af2c708e04567b59$export$74ac40502a3200d3() {
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $6c67743c42bb7678$export$6cff59e5608ce17d), {}),
            rootProps.slots.toolbar && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.toolbar, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootProps.slotProps?.toolbar))
        ]
    });
}



parcelRequire("lCzvA");

const $cc43af7a19636335$var$styled = (0, $5bf26b75747a8e8c$export$2e2bcd8739ae039)();
var $cc43af7a19636335$export$2e2bcd8739ae039 = $cc43af7a19636335$var$styled;




const $adc18856c547b659$export$26d8768b83a52ffd = (state)=>state.dimensions;
const $adc18856c547b659$export$ab20f9d33edc7794 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($adc18856c547b659$export$26d8768b83a52ffd, (dimensions)=>dimensions.columnsTotalWidth);
const $adc18856c547b659$export$2ca09da26466c31a = (state)=>state.dimensions.rowHeight;
const $adc18856c547b659$export$83bdaba2ad532c80 = (state)=>state.dimensions.contentSize.height;
const $adc18856c547b659$export$5dfe533d5e873745 = (state)=>state.dimensions.hasScrollX;
const $adc18856c547b659$export$4fe814c21f610df = (state)=>state.dimensions.hasScrollY;
const $adc18856c547b659$export$34d7a8c547584228 = (state)=>state.dimensions.columnsTotalWidth < state.dimensions.viewportOuterSize.width;
const $adc18856c547b659$export$4b70ef0159fef49b = (state)=>state.dimensions.headerHeight;
const $adc18856c547b659$export$f49d78f35ee113b0 = (state)=>state.dimensions.groupHeaderHeight;
const $adc18856c547b659$export$c297d104bfb637f0 = (state)=>state.dimensions.headerFilterHeight;
const $adc18856c547b659$export$6615095b3c921727 = (state)=>state.dimensions.hasScrollY ? state.dimensions.scrollbarSize : 0;
const $adc18856c547b659$export$bfc2d49082e0c9a2 = (state)=>state.dimensions.hasScrollX ? state.dimensions.scrollbarSize : 0;
const $adc18856c547b659$export$98dc8438c286cc21 = (state)=>{
    const height = state.dimensions.hasScrollX ? state.dimensions.scrollbarSize : 0;
    const needsLastRowBorder = state.dimensions.viewportOuterSize.height - state.dimensions.minimumSize.height > 0;
    if (height === 0 && !needsLastRowBorder) return false;
    return true;
};




var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $d30dafbde976b8f5$var$useEnhancedEffect = typeof window !== 'undefined' ? $lCzvA.useLayoutEffect : $lCzvA.useEffect;
var $d30dafbde976b8f5$export$2e2bcd8739ae039 = $d30dafbde976b8f5$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $b30dbf340362d390$var$useEventCallback(fn) {
    const ref = $lCzvA.useRef(fn);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $lCzvA.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $b30dbf340362d390$export$2e2bcd8739ae039 = $b30dbf340362d390$var$useEventCallback;









var $lCzvA = parcelRequire("lCzvA");
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $0592660ecc389e6e$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $0592660ecc389e6e$export$c16cf791cc6bf0c7 {
    constructor(timeout = $0592660ecc389e6e$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.timeouts = new Map();
        this.cleanupTimeout = $0592660ecc389e6e$var$CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === 'function') unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
}


class $ba2b8fb13aa4c80b$export$86b678dc9d8f7603 {
    constructor(){
        this.registry = new FinalizationRegistry((unsubscribe)=>{
            if (typeof unsubscribe === 'function') unsubscribe();
        });
    }
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    // eslint-disable-next-line class-methods-use-this
    reset() {}
}


/**
 * Signal to the underlying logic what version of the public component API
 * of the Data Grid is exposed.
 */ var $ecad0fba09446fc0$export$544be0bdf85b5af1 = /*#__PURE__*/ function(GridSignature) {
    GridSignature["DataGrid"] = "DataGrid";
    GridSignature["DataGridPro"] = "DataGridPro";
    GridSignature["DataGridPremium"] = "DataGridPremium";
    return GridSignature;
}($ecad0fba09446fc0$export$544be0bdf85b5af1 || {});
// We use class to make it easier to detect in heap snapshots by name
class $ecad0fba09446fc0$var$ObjectToBeRetainedByReact {
}
function $ecad0fba09446fc0$export$4c5a9251aa47d2f8(registryContainer) {
    let cleanupTokensCounter = 0;
    return function useGridApiEventHandler(apiRef, eventName, handler, options) {
        if (registryContainer.registry === null) registryContainer.registry = typeof FinalizationRegistry !== 'undefined' ? new (0, $ba2b8fb13aa4c80b$export$86b678dc9d8f7603)() : new (0, $0592660ecc389e6e$export$c16cf791cc6bf0c7)();
        const [objectRetainedByReact] = $lCzvA.useState(new $ecad0fba09446fc0$var$ObjectToBeRetainedByReact());
        const subscription = $lCzvA.useRef(null);
        const handlerRef = $lCzvA.useRef(null);
        handlerRef.current = handler;
        const cleanupTokenRef = $lCzvA.useRef(null);
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event, details)=>{
                // Check for the existence of the event once more to avoid Safari 26 issue
                // https://github.com/mui/mui-x/issues/20159
                if (event && !event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
            };
            subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            cleanupTokensCounter += 1;
            cleanupTokenRef.current = {
                cleanupToken: cleanupTokensCounter
            };
            registryContainer.registry.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
            ()=>{
                subscription.current?.();
                subscription.current = null;
                cleanupTokenRef.current = null;
            }, cleanupTokenRef.current);
        } else if (!handlerRef.current && subscription.current) {
            subscription.current();
            subscription.current = null;
            if (cleanupTokenRef.current) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
        }
        $lCzvA.useEffect(()=>{
            if (!subscription.current && handlerRef.current) {
                const enhancedHandler = (params, event, details)=>{
                    // Check for the existence of the event once more to avoid Safari 26 issue
                    // https://github.com/mui/mui-x/issues/20159
                    if (event && !event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
                };
                subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            }
            if (cleanupTokenRef.current && registryContainer.registry) {
                // If the effect was called, it means that this render was committed
                // so we can trust the cleanup function to remove the listener.
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
            return ()=>{
                subscription.current?.();
                subscription.current = null;
            };
        }, [
            apiRef,
            eventName,
            options
        ]);
    };
}
const $ecad0fba09446fc0$var$registryContainer = {
    registry: null
};
const $ecad0fba09446fc0$export$c5af18cc30c6146f = ()=>{
    $ecad0fba09446fc0$var$registryContainer.registry?.reset();
    $ecad0fba09446fc0$var$registryContainer.registry = null;
};
const $ecad0fba09446fc0$export$223e28bfc0254c87 = $ecad0fba09446fc0$export$4c5a9251aa47d2f8($ecad0fba09446fc0$var$registryContainer);
const $ecad0fba09446fc0$var$optionsSubscriberOptions = {
    isFirst: true
};
function $ecad0fba09446fc0$export$d55ddab8b28954db(apiRef, eventName, handler) {
    $ecad0fba09446fc0$export$223e28bfc0254c87(apiRef, eventName, handler, $ecad0fba09446fc0$var$optionsSubscriberOptions);
}







var $lCzvA = parcelRequire("lCzvA");
'use client';
const $375168188d76048b$var$EMPTY = [];
function $375168188d76048b$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $lCzvA.useEffect(fn, $375168188d76048b$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $62eeccdcf64355bb$export$786b4da70f00938b {
    static create() {
        return new $62eeccdcf64355bb$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $62eeccdcf64355bb$export$2e2bcd8739ae039() {
    const timeout = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)($62eeccdcf64355bb$export$786b4da70f00938b.create).current;
    (0, $375168188d76048b$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}



/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $650cdafe9746b559$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $650cdafe9746b559$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}





var $lCzvA = parcelRequire("lCzvA");





var $lCzvA = parcelRequire("lCzvA");






var $lCzvA = parcelRequire("lCzvA");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $9b0d55c89532c0b3$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

function $a1e3e92d2ab059b6$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $cbe0ef075048c43a$export$2e2bcd8739ae039(node) {
    const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}



'use client';
function $640e33db12803ebc$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $640e33db12803ebc$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $640e33db12803ebc$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $640e33db12803ebc$var$isEmpty(obj) {
    return $640e33db12803ebc$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://v6.mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://v6.mui.com/material-ui/api/textarea-autosize/)
 */ const $640e33db12803ebc$var$TextareaAutosize = /*#__PURE__*/ $lCzvA.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $lCzvA.useRef(value != null);
    const textareaRef = $lCzvA.useRef(null);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $lCzvA.useRef(null);
    const hiddenTextareaRef = $lCzvA.useRef(null);
    const calculateTextareaStyles = $lCzvA.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $cbe0ef075048c43a$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $640e33db12803ebc$var$getStyleValue(computedStyle.paddingBottom) + $640e33db12803ebc$var$getStyleValue(computedStyle.paddingTop);
        const border = $640e33db12803ebc$var$getStyleValue(computedStyle.borderBottomWidth) + $640e33db12803ebc$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $640e33db12803ebc$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $lCzvA.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $640e33db12803ebc$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $lCzvA.useRef(-1);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $9b0d55c89532c0b3$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $cbe0ef075048c43a$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$640e33db12803ebc$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $640e33db12803ebc$export$2e2bcd8739ae039 = $640e33db12803ebc$var$TextareaAutosize;


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $ee580380773bdc68$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $ee580380773bdc68$export$2e2bcd8739ae039 = $ee580380773bdc68$var$isHostComponent;


function $68f7e6835ed8d269$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $lCzvA = parcelRequire("lCzvA");
'use client';
/**
 * @ignore - internal component.
 */ const $d12eac47440c9fb8$var$FormControlContext = /*#__PURE__*/ $lCzvA.createContext(undefined);
var $d12eac47440c9fb8$export$2e2bcd8739ae039 = $d12eac47440c9fb8$var$FormControlContext;



var $lCzvA = parcelRequire("lCzvA");

'use client';
function $a66fe280d54e059b$export$2e2bcd8739ae039() {
    return $lCzvA.useContext((0, $d12eac47440c9fb8$export$2e2bcd8739ae039));
}


parcelRequire("lCzvA");


const $0b50965511eefd52$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $bea6c51133faf380$export$2e2bcd8739ae039);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $0b50965511eefd52$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $0b50965511eefd52$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $b80cadb21e077670$export$53b83ca8eaab0383)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}


parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");

'use client';
function $0fb11f840caf6173$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $0fb11f840caf6173$var$useTheme(defaultTheme = null) {
    const contextTheme = $lCzvA.useContext((0, $3697f0399be2fa10$export$971d5caa766a69d7));
    return !contextTheme || $0fb11f840caf6173$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $0fb11f840caf6173$export$2e2bcd8739ae039 = $0fb11f840caf6173$var$useTheme;


'use client';
const $25e31e085eebfdce$export$35e57303dbd8a66 = (0, $fc4cf8a71374ddb3$export$2e2bcd8739ae039)();
function $25e31e085eebfdce$var$useTheme(defaultTheme = $25e31e085eebfdce$export$35e57303dbd8a66) {
    return (0, $0fb11f840caf6173$export$2e2bcd8739ae039)(defaultTheme);
}
var $25e31e085eebfdce$export$2e2bcd8739ae039 = $25e31e085eebfdce$var$useTheme;




'use client';
function $0282d01cc0b6bcdf$export$2e2bcd8739ae039() {
    const theme = (0, $25e31e085eebfdce$export$2e2bcd8739ae039)((0, $80760139350deeb4$export$2e2bcd8739ae039));
    return theme[0, $e8b56ec99e409d23$export$2e2bcd8739ae039] || theme;
}


parcelRequire("lCzvA");

parcelRequire("lCzvA");




'use client';
function $c0651b057dc1ea3d$var$wrapGlobalLayer(styles) {
    const serialized = (0, $36107f55192c81c9$export$13a2d3ef13012b32)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $c0651b057dc1ea3d$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $25e31e085eebfdce$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $c0651b057dc1ea3d$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $c0651b057dc1ea3d$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $c0651b057dc1ea3d$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b2b85fe90a717478$export$2e2bcd8739ae039), {
        styles: globalStyles
    });
}
var $c0651b057dc1ea3d$export$2e2bcd8739ae039 = $c0651b057dc1ea3d$var$GlobalStyles;





'use client';
function $1fed11e5a9b52129$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c0651b057dc1ea3d$export$2e2bcd8739ae039), {
        ...props,
        defaultTheme: (0, $80760139350deeb4$export$2e2bcd8739ae039),
        themeId: (0, $e8b56ec99e409d23$export$2e2bcd8739ae039)
    });
}
var $1fed11e5a9b52129$export$2e2bcd8739ae039 = $1fed11e5a9b52129$var$GlobalStyles;





function $e25f007abb0d56af$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1fed11e5a9b52129$export$2e2bcd8739ae039), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $e25f007abb0d56af$export$7e7f5719ff4debb1() {
    return 0, $0b50965511eefd52$export$2e2bcd8739ae039;
}



/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $aaea73d7265ea1ae$var$arg = {
    theme: undefined
};
function $aaea73d7265ea1ae$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $aaea73d7265ea1ae$var$arg.theme = props.theme;
            value = (0, $6440b6423b7c91a1$export$2e2bcd8739ae039)(styleFn($aaea73d7265ea1ae$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}


const $512deea6fb7c56fe$var$memoTheme = (0, $aaea73d7265ea1ae$export$2e2bcd8739ae039);
var $512deea6fb7c56fe$export$2e2bcd8739ae039 = $512deea6fb7c56fe$var$memoTheme;


parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");



'use client';
const $1dbf89cce7c2fd43$var$PropsContext = /*#__PURE__*/ $lCzvA.createContext(undefined);
function $1dbf89cce7c2fd43$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($1dbf89cce7c2fd43$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $1dbf89cce7c2fd43$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $650cdafe9746b559$export$2e2bcd8739ae039)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $650cdafe9746b559$export$2e2bcd8739ae039)(config, props);
    return props;
}
function $1dbf89cce7c2fd43$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $lCzvA.useContext($1dbf89cce7c2fd43$var$PropsContext);
    return $1dbf89cce7c2fd43$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $1dbf89cce7c2fd43$export$2e2bcd8739ae039 = $1dbf89cce7c2fd43$var$DefaultPropsProvider;



'use client';
function $b2b9e9140b998a9d$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1dbf89cce7c2fd43$export$2e2bcd8739ae039), {
        ...props
    });
}
var $b2b9e9140b998a9d$export$2e2bcd8739ae039 = $b2b9e9140b998a9d$var$DefaultPropsProvider;
function $b2b9e9140b998a9d$export$2440da353cedad43(params) {
    return (0, $1dbf89cce7c2fd43$export$2440da353cedad43)(params);
}



var $212bca41d578456f$export$2e2bcd8739ae039 = (0, $c4ab204d748cb214$export$2e2bcd8739ae039);



'use client';
var $ade5ac70196d775c$export$2e2bcd8739ae039 = (0, $78465f04bf272330$export$2e2bcd8739ae039);



'use client';
var $1bc2b909266b2e14$export$2e2bcd8739ae039 = (0, $d30dafbde976b8f5$export$2e2bcd8739ae039);


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $0f55f5fc97c01112$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $0f55f5fc97c01112$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($0f55f5fc97c01112$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $0f55f5fc97c01112$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $0f55f5fc97c01112$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




function $4e524ec0ed105543$export$ef57d5c8ca2278f6(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiInputBase', slot);
}
const $4e524ec0ed105543$var$inputBaseClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $4e524ec0ed105543$export$2e2bcd8739ae039 = $4e524ec0ed105543$var$inputBaseClasses;



'use client';
var $92d8fc367f7e2f74$var$_InputGlobalStyles;
const $92d8fc367f7e2f74$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $92d8fc367f7e2f74$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $92d8fc367f7e2f74$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $4e524ec0ed105543$export$ef57d5c8ca2278f6), classes);
};
const $92d8fc367f7e2f74$export$298a043133d72a38 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $92d8fc367f7e2f74$export$965edad20a84fa75
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $92d8fc367f7e2f74$export$ee10465db6ff6017 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $92d8fc367f7e2f74$export$cf507b112810e72d
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $92d8fc367f7e2f74$var$InputGlobalStyles = (0, $e25f007abb0d56af$export$db53682eef82cc11)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $92d8fc367f7e2f74$var$InputBase = /*#__PURE__*/ $lCzvA.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $lCzvA.useRef(value != null);
    const inputRef = $lCzvA.useRef();
    const handleInputRefWarning = $lCzvA.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $ade5ac70196d775c$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $lCzvA.useState(false);
    const muiFormControl = (0, $a66fe280d54e059b$export$2e2bcd8739ae039)();
    const fcs = (0, $68f7e6835ed8d269$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $lCzvA.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $lCzvA.useCallback((obj)=>{
        if ((0, $0f55f5fc97c01112$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $1bc2b909266b2e14$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $8b74d405de95a30f$export$2e2bcd8739ae039)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $lCzvA.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $640e33db12803ebc$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $lCzvA.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $92d8fc367f7e2f74$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $92d8fc367f7e2f74$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $92d8fc367f7e2f74$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $92d8fc367f7e2f74$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($92d8fc367f7e2f74$var$_InputGlobalStyles || ($92d8fc367f7e2f74$var$_InputGlobalStyles = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($92d8fc367f7e2f74$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $ee580380773bdc68$export$2e2bcd8739ae039)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $d12eac47440c9fb8$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $ee580380773bdc68$export$2e2bcd8739ae039)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $92d8fc367f7e2f74$export$2e2bcd8739ae039 = $92d8fc367f7e2f74$var$InputBase;







const $f7ff56551dab4dc6$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "isValidating",
    "debounceMs",
    "isProcessingProps",
    "onValueChange"
];
const $f7ff56551dab4dc6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $f7ff56551dab4dc6$var$GridEditInputCellRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $92d8fc367f7e2f74$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'EditInputCell',
    overridesResolver: (props, styles)=>styles.editInputCell
})(({ theme: theme })=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, theme.typography.body2, {
        padding: '1px 0',
        '& input': {
            padding: '0 16px',
            height: '100%'
        }
    }));
const $f7ff56551dab4dc6$export$cd10ed3250a4d414 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)((props, ref)=>{
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const { id: id, value: value, field: field, colDef: colDef, hasFocus: hasFocus, debounceMs: debounceMs = 200, isProcessingProps: isProcessingProps, onValueChange: onValueChange } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $f7ff56551dab4dc6$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const inputRef = $lCzvA.useRef(null);
    const [valueState, setValueState] = $lCzvA.useState(value);
    const classes = $f7ff56551dab4dc6$var$useUtilityClasses(rootProps);
    const handleChange = $lCzvA.useCallback(async (event)=>{
        const newValue = event.target.value;
        if (onValueChange) await onValueChange(event, newValue);
        const column = apiRef.current.getColumn(field);
        let parsedValue = newValue;
        if (column.valueParser) parsedValue = column.valueParser(newValue, apiRef.current.getRow(id), column, apiRef);
        setValueState(parsedValue);
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: parsedValue,
            debounceMs: debounceMs,
            unstable_skipValueParser: true
        }, event);
    }, [
        apiRef,
        debounceMs,
        field,
        id,
        onValueChange
    ]);
    const meta = apiRef.current.unstable_getEditCellMeta(id, field);
    $lCzvA.useEffect(()=>{
        if (meta?.changeReason !== 'debouncedSetEditCellValue') setValueState(value);
    }, [
        meta,
        value
    ]);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f7ff56551dab4dc6$var$GridEditInputCellRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        inputRef: inputRef,
        className: classes.root,
        ownerState: rootProps,
        fullWidth: true,
        type: colDef.type === 'number' ? colDef.type : 'text',
        value: valueState ?? '',
        onChange: handleChange,
        endAdornment: isProcessingProps ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.loadIcon, {
            fontSize: "small",
            color: "action"
        }) : undefined
    }, other, {
        ref: ref
    }));
});
const $f7ff56551dab4dc6$export$d1015f41e7e48c2e = (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f7ff56551dab4dc6$export$cd10ed3250a4d414, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params));





const $68327dddce1a2c68$var$gridRowsStateSelector = (state)=>state.rows;
const $68327dddce1a2c68$export$1641ef9d08e265ca = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>rows.totalRowCount);
const $68327dddce1a2c68$export$3c966d405f950b08 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>rows.loading);
const $68327dddce1a2c68$export$800ab0a68a9efc4f = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>rows.totalTopLevelRowCount);
const $68327dddce1a2c68$export$37767f9110c99048 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToModelLookup);
const $68327dddce1a2c68$export$451ff98f7dd9f13f = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToIdLookup);
const $68327dddce1a2c68$export$de9a43d646a9821d = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>rows.tree);
const $68327dddce1a2c68$export$6c1cdbc7b5e9a3f4 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>rows.groupsToFetch);
const $68327dddce1a2c68$export$c263d91fb644e7a0 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>rows.groupingName);
const $68327dddce1a2c68$export$eb24598525413286 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>rows.treeDepths);
const $68327dddce1a2c68$export$4cdbe576751dd8e2 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>{
    const entries = Object.entries(rows.treeDepths);
    if (entries.length === 0) return 1;
    return (entries.filter(([, nodeCount])=>nodeCount > 0).map(([depth])=>Number(depth)).sort((a, b)=>b - a)[0] ?? 0) + 1;
});
const $68327dddce1a2c68$export$c7dcaab5e573753 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>rows.dataRowIds);
const $68327dddce1a2c68$export$e8db8ec5e43400fa = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$var$gridRowsStateSelector, (rows)=>rows?.additionalRowGroups);
const $68327dddce1a2c68$export$ffe7071c481e32b0 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($68327dddce1a2c68$export$e8db8ec5e43400fa, (additionalRowGroups)=>{
    const rawPinnedRows = additionalRowGroups?.pinnedRows;
    return {
        bottom: rawPinnedRows?.bottom?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? [],
        top: rawPinnedRows?.top?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? []
    };
});
const $68327dddce1a2c68$export$8e3fb3525d7db988 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($68327dddce1a2c68$export$ffe7071c481e32b0, (pinnedRows)=>{
    return (pinnedRows?.top?.length || 0) + (pinnedRows?.bottom?.length || 0);
});


const $840823b3251897df$export$13eeac5ac15e0be5 = (model, disableMultipleColumnsSorting)=>{
    if (disableMultipleColumnsSorting && model.length > 1) return [
        model[0]
    ];
    return model;
};
const $840823b3251897df$export$3fc28d475ac000c0 = (sortModel, disableMultipleColumnsSorting)=>(state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
            sorting: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.sorting, {
                sortModel: $840823b3251897df$export$13eeac5ac15e0be5(sortModel, disableMultipleColumnsSorting)
            })
        });
const $840823b3251897df$var$isDesc = (direction)=>direction === 'desc';
/**
 * Transform an item of the sorting model into a method comparing two rows.
 * @param {GridSortItem} sortItem The sort item we want to apply.
 * @param {RefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridParsedSortItem | null} The parsed sort item. Returns `null` is the sort item is not valid.
 */ const $840823b3251897df$var$parseSortItem = (sortItem, apiRef)=>{
    const column = apiRef.current.getColumn(sortItem.field);
    if (!column || sortItem.sort === null) return null;
    let comparator;
    if (column.getSortComparator) comparator = column.getSortComparator(sortItem.sort);
    else comparator = $840823b3251897df$var$isDesc(sortItem.sort) ? (...args)=>-1 * column.sortComparator(...args) : column.sortComparator;
    if (!comparator) return null;
    const getSortCellParams = (id)=>({
            id: id,
            field: column.field,
            rowNode: (0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef)[id],
            value: apiRef.current.getCellValue(id, column.field),
            api: apiRef.current
        });
    return {
        getSortCellParams: getSortCellParams,
        comparator: comparator
    };
};
/**
 * Compare two rows according to a list of valid sort items.
 * The `row1Params` and `row2Params` must have the same length as `parsedSortItems`,
 * and each of their index must contain the `GridSortCellParams` of the sort item with the same index.
 * @param {GridParsedSortItem[]} parsedSortItems All the sort items with which we want to compare the rows.
 * @param {GridRowAggregatedSortingParams} row1 The node and params of the 1st row for each sort item.
 * @param {GridRowAggregatedSortingParams} row2 The node and params of the 2nd row for each sort item.
 */ const $840823b3251897df$var$compareRows = (parsedSortItems, row1, row2)=>{
    return parsedSortItems.reduce((res, item, index)=>{
        if (res !== 0) // return the results of the first comparator which distinguish the two rows
        return res;
        const sortCellParams1 = row1.params[index];
        const sortCellParams2 = row2.params[index];
        res = item.comparator(sortCellParams1.value, sortCellParams2.value, sortCellParams1, sortCellParams2);
        return res;
    }, 0);
};
const $840823b3251897df$export$b29e353d1a72dfda = (sortModel, apiRef)=>{
    const comparatorList = sortModel.map((item)=>$840823b3251897df$var$parseSortItem(item, apiRef)).filter((comparator)=>!!comparator);
    if (comparatorList.length === 0) return null;
    return (rowList)=>rowList.map((node)=>({
                node: node,
                params: comparatorList.map((el)=>el.getSortCellParams(node.id))
            })).sort((a, b)=>$840823b3251897df$var$compareRows(comparatorList, a, b)).map((row)=>row.node.id);
};
const $840823b3251897df$export$b3d84351ab2e3580 = (sortingOrder, current)=>{
    const currentIdx = sortingOrder.indexOf(current);
    if (!current || currentIdx === -1 || currentIdx + 1 === sortingOrder.length) return sortingOrder[0];
    return sortingOrder[currentIdx + 1];
};
const $840823b3251897df$var$gridNillComparator = (v1, v2)=>{
    if (v1 == null && v2 != null) return -1;
    if (v2 == null && v1 != null) return 1;
    if (v1 == null && v2 == null) return 0;
    return null;
};
const $840823b3251897df$var$collator = new Intl.Collator();
const $840823b3251897df$export$db324d0b741f4529 = (value1, value2)=>{
    const nillResult = $840823b3251897df$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (typeof value1 === 'string') return $840823b3251897df$var$collator.compare(value1.toString(), value2.toString());
    return value1 - value2;
};
const $840823b3251897df$export$ecfdaa3722003888 = (value1, value2)=>{
    const nillResult = $840823b3251897df$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    return Number(value1) - Number(value2);
};
const $840823b3251897df$export$74e685f55e96d6bc = (value1, value2)=>{
    const nillResult = $840823b3251897df$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (value1 > value2) return 1;
    if (value1 < value2) return -1;
    return 0;
};





var $lCzvA = parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");
'use client';
let $5b02eb5f110ae73e$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $5b02eb5f110ae73e$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $lCzvA.useState(idOverride);
    const id = idOverride || defaultId;
    $lCzvA.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $5b02eb5f110ae73e$var$globalId += 1;
            setDefaultId(`mui-${$5b02eb5f110ae73e$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $5b02eb5f110ae73e$var$safeReact = {
    ...$lCzvA
};
const $5b02eb5f110ae73e$var$maybeReactUseId = $5b02eb5f110ae73e$var$safeReact.useId;
function $5b02eb5f110ae73e$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($5b02eb5f110ae73e$var$maybeReactUseId !== undefined) {
        const reactId = $5b02eb5f110ae73e$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $5b02eb5f110ae73e$var$useGlobalId(idOverride);
}





const $a29e5f5322899b2f$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "disabled",
    "isFilterActive",
    "clearButton",
    "InputProps",
    "variant"
];
function $a29e5f5322899b2f$export$99d1f108a3f21b3(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, tabIndex: tabIndex, disabled: disabled, clearButton: clearButton, InputProps: InputProps, variant: variant = 'standard' } = props, others = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $a29e5f5322899b2f$var$_excluded);
    const filterTimeout = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const [filterValueState, setFilterValueState] = $lCzvA.useState($a29e5f5322899b2f$var$sanitizeFilterItemValue(item.value));
    const [applying, setIsApplying] = $lCzvA.useState(false);
    const id = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const onFilterChange = $lCzvA.useCallback((event)=>{
        const value = $a29e5f5322899b2f$var$sanitizeFilterItemValue(event.target.value);
        setFilterValueState(value);
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const newItem = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, item, {
                value: type === 'number' && !Number.isNaN(Number(value)) ? Number(value) : value,
                fromInput: id
            });
            applyValue(newItem);
            setIsApplying(false);
        });
    }, [
        filterTimeout,
        rootProps.filterDebounceMs,
        item,
        type,
        id,
        applyValue
    ]);
    $lCzvA.useEffect(()=>{
        const itemPlusTag = item;
        if (itemPlusTag.fromInput !== id || item.value == null) setFilterValueState($a29e5f5322899b2f$var$sanitizeFilterItemValue(item.value));
    }, [
        id,
        item
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseTextField, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        id: id,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        value: filterValueState ?? '',
        onChange: onFilterChange,
        variant: variant,
        type: type || 'text',
        InputProps: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled: disabled
        }, InputProps, {
            inputProps: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                tabIndex: tabIndex
            }, InputProps?.inputProps)
        }),
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef
    }, others, rootProps.slotProps?.baseTextField));
}
function $a29e5f5322899b2f$var$sanitizeFilterItemValue(value) {
    if (value == null || value === '') return undefined;
    return String(value);
}


function $ac3bd7253ec0e92a$export$7e4aa119212bc614(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
function $ac3bd7253ec0e92a$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $ac3bd7253ec0e92a$export$a6cdc56e425d0d0a(value) {
    return typeof value === 'object' && value !== null;
}
function $ac3bd7253ec0e92a$export$c43914e0cb16a981() {
    try {
        // Incognito mode might reject access to the localStorage for security reasons.
        // window isn't defined on Node.js
        // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
        const key = '__some_random_key_you_are_not_going_to_use__';
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}
function $ac3bd7253ec0e92a$export$7c57da42ce8e346f(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
const $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(max, value));
function $ac3bd7253ec0e92a$export$d02631cccf789723(from, to) {
    return Array.from({
        length: to - from
    }).map((_, i)=>from + i);
}
function $ac3bd7253ec0e92a$export$78fdc9adc3f30400(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) return false;
        if (Array.isArray(a)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (!$ac3bd7253ec0e92a$export$78fdc9adc3f30400(a[i], b[i])) return false;
            }
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            const entriesA = Array.from(a.entries());
            for(let i = 0; i < entriesA.length; i += 1){
                if (!b.has(entriesA[i][0])) return false;
            }
            for(let i = 0; i < entriesA.length; i += 1){
                const entryA = entriesA[i];
                if (!$ac3bd7253ec0e92a$export$78fdc9adc3f30400(entryA[1], b.get(entryA[0]))) return false;
            }
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            const entries = Array.from(a.entries());
            for(let i = 0; i < entries.length; i += 1){
                if (!b.has(entries[i][0])) return false;
            }
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (a[i] !== b[i]) return false;
            }
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        const length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(let i = 0; i < length; i += 1){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(let i = 0; i < length; i += 1){
            const key = keys[i];
            if (!$ac3bd7253ec0e92a$export$78fdc9adc3f30400(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // eslint-disable-next-line no-self-compare
    return a !== a && b !== b;
}
// Pseudo random number. See https://stackoverflow.com/a/47593316
function $ac3bd7253ec0e92a$var$mulberry32(a) {
    return ()=>{
        /* eslint-disable */ let t = a += 0x6d2b79f5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    /* eslint-enable */ };
}
function $ac3bd7253ec0e92a$export$90ad2d37c2cc187e(seed) {
    const random = $ac3bd7253ec0e92a$var$mulberry32(seed);
    return (min, max)=>min + (max - min) * random();
}
function $ac3bd7253ec0e92a$export$b7d58db314e0ac27(obj) {
    if (typeof structuredClone === 'function') return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
function $ac3bd7253ec0e92a$export$ec5767fa5c351320(_) {}
const $ac3bd7253ec0e92a$export$f546127afff6208d = (condition, fn)=>(params)=>{
        if (condition) fn(params);
    };





var $lCzvA = parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");







var $lCzvA = parcelRequire("lCzvA");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $4df6a81f84d302f6$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


var $lCzvA = parcelRequire("lCzvA");
'use client';
function $9ad601db1fbcc10f$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $lCzvA.useRef(controlled !== undefined);
    const [valueState, setValue] = $lCzvA.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $lCzvA.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


var $lCzvA = parcelRequire("lCzvA");
'use client';
const $45ddf447e8f3ffaf$var$usePreviousProps = (value)=>{
    const ref = $lCzvA.useRef({});
    $lCzvA.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $45ddf447e8f3ffaf$export$2e2bcd8739ae039 = $45ddf447e8f3ffaf$var$usePreviousProps;


'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function $bbbc93862f7737a4$var$stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $bbbc93862f7737a4$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $bbbc93862f7737a4$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $bbbc93862f7737a4$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const $bbbc93862f7737a4$var$defaultFilterOptions = $bbbc93862f7737a4$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $bbbc93862f7737a4$var$pageSize = 5;
const $bbbc93862f7737a4$var$defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && listboxRef.current.parentElement?.contains(document.activeElement);
const $bbbc93862f7737a4$var$MULTIPLE_DEFAULT_VALUE = [];
function $bbbc93862f7737a4$var$getInputValue(value, multiple, getOptionLabel) {
    if (multiple || value == null) return '';
    const optionLabel = getOptionLabel(value);
    return typeof optionLabel === 'string' ? optionLabel : '';
}
function $bbbc93862f7737a4$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $bbbc93862f7737a4$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $bbbc93862f7737a4$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $bbbc93862f7737a4$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>option.label ?? option, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $lCzvA.useRef(false);
    const firstFocus = $lCzvA.useRef(true);
    const inputRef = $lCzvA.useRef(null);
    const listboxRef = $lCzvA.useRef(null);
    const [anchorEl, setAnchorEl] = $lCzvA.useState(null);
    const [focusedTag, setFocusedTag] = $lCzvA.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $lCzvA.useRef(defaultHighlighted);
    // Calculate the initial inputValue on mount only.
    // useRef ensures it doesn't update dynamically with defaultValue or value props.
    const initialInputValue = $lCzvA.useRef($bbbc93862f7737a4$var$getInputValue(defaultValue ?? valueProp, multiple, getOptionLabel)).current;
    const [value, setValueState] = (0, $9ad601db1fbcc10f$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $9ad601db1fbcc10f$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: initialInputValue,
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $lCzvA.useState(false);
    const resetInputValue = $lCzvA.useCallback((event, newValue, reason)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        const newInputValue = $bbbc93862f7737a4$var$getInputValue(newValue, multiple, getOptionLabel);
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $9ad601db1fbcc10f$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $lCzvA.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $45ddf447e8f3ffaf$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $lCzvA.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $lCzvA.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange && [
            'mouse',
            'keyboard',
            'touch'
        ].includes(reason)) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = 'next', reason: reason })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $lCzvA.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((node)=>{
        (0, $4df6a81f84d302f6$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $lCzvA.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $lCzvA.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$bbbc93862f7737a4$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $bbbc93862f7737a4$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>({
                ...other,
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>({
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: handleTagDelete(index)
                }
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionKey?.(option) ?? getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $bbbc93862f7737a4$export$2e2bcd8739ae039 = $bbbc93862f7737a4$var$useAutocomplete;



var $lCzvA = parcelRequire("lCzvA");


'use client';
const $2a711d8e80e02076$var$RtlContext = /*#__PURE__*/ $lCzvA.createContext();
function $2a711d8e80e02076$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($2a711d8e80e02076$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $2a711d8e80e02076$export$b2dd014b6c321cb = ()=>{
    const value = $lCzvA.useContext($2a711d8e80e02076$var$RtlContext);
    return value ?? false;
};
var $2a711d8e80e02076$export$2e2bcd8739ae039 = $2a711d8e80e02076$var$RtlProvider;






var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");

function $f8fe4eaa2963d081$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $b0de5823221de288$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b0de5823221de288$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b0de5823221de288$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $fc24c79d45c62ca8$export$8960430cfd85939f = Math.max;
var $fc24c79d45c62ca8$export$96ec731ed4dcb222 = Math.min;
var $fc24c79d45c62ca8$export$2077e0241d6afd3c = Math.round;



function $5b0bdb40ece240a2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $888d55cd8a65f3d0$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $5b0bdb40ece240a2$export$2e2bcd8739ae039)());
}


function $b45a64e1c8afc904$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b0de5823221de288$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $fc24c79d45c62ca8$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $fc24c79d45c62ca8$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b0de5823221de288$export$45a5e7f76e0caa8d)(element) ? (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $888d55cd8a65f3d0$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $df866cb48126a9d5$export$2e2bcd8739ae039(node) {
    var win = (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $def4b3f3f54344eb$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $f09b5840dd057098$export$2e2bcd8739ae039(node) {
    if (node === (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(node) || !(0, $b0de5823221de288$export$1b3bfaa9684536aa)(node)) return (0, $df866cb48126a9d5$export$2e2bcd8739ae039)(node);
    else return (0, $def4b3f3f54344eb$export$2e2bcd8739ae039)(node);
}


function $7511fa4ff706ee86$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $7b29f635f99ae239$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b0de5823221de288$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e882623b932a014a$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $b45a64e1c8afc904$export$2e2bcd8739ae039)((0, $7b29f635f99ae239$export$2e2bcd8739ae039)(element)).left + (0, $df866cb48126a9d5$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $5efcc266e6a16de5$export$2e2bcd8739ae039(element) {
    return (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $92d52d633b9d3768$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5efcc266e6a16de5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $61a1042b832dad06$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $fc24c79d45c62ca8$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $fc24c79d45c62ca8$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $61a1042b832dad06$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b0de5823221de288$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $b0de5823221de288$export$1b3bfaa9684536aa)(offsetParent) && $61a1042b832dad06$var$isElementScaled(offsetParent);
    var documentElement = (0, $7b29f635f99ae239$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $b45a64e1c8afc904$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $7511fa4ff706ee86$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $92d52d633b9d3768$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $f09b5840dd057098$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $b0de5823221de288$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $b45a64e1c8afc904$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e882623b932a014a$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $526a2135d6b5bab1$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $b45a64e1c8afc904$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $ec13aa62d983f6f3$export$2e2bcd8739ae039(element) {
    if ((0, $7511fa4ff706ee86$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b0de5823221de288$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7b29f635f99ae239$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2db7c253fb3afa20$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $7511fa4ff706ee86$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b0de5823221de288$export$1b3bfaa9684536aa)(node) && (0, $92d52d633b9d3768$export$2e2bcd8739ae039)(node)) return node;
    return $2db7c253fb3afa20$export$2e2bcd8739ae039((0, $ec13aa62d983f6f3$export$2e2bcd8739ae039)(node));
}





function $da342757a2fcba10$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2db7c253fb3afa20$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $92d52d633b9d3768$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($da342757a2fcba10$export$2e2bcd8739ae039((0, $ec13aa62d983f6f3$export$2e2bcd8739ae039)(target)));
}







function $663768ad1f21d742$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $7511fa4ff706ee86$export$2e2bcd8739ae039)(element)) >= 0;
}




function $125679e0aa9f1836$var$getTrueOffsetParent(element) {
    if (!(0, $b0de5823221de288$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5efcc266e6a16de5$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $125679e0aa9f1836$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $5b0bdb40ece240a2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $5b0bdb40ece240a2$export$2e2bcd8739ae039)());
    if (isIE && (0, $b0de5823221de288$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5efcc266e6a16de5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $ec13aa62d983f6f3$export$2e2bcd8739ae039)(element);
    if ((0, $b0de5823221de288$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $b0de5823221de288$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $7511fa4ff706ee86$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $5efcc266e6a16de5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $125679e0aa9f1836$export$2e2bcd8739ae039(element) {
    var window = (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(element);
    var offsetParent = $125679e0aa9f1836$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $663768ad1f21d742$export$2e2bcd8739ae039)(offsetParent) && (0, $5efcc266e6a16de5$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $125679e0aa9f1836$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $7511fa4ff706ee86$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $7511fa4ff706ee86$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $5efcc266e6a16de5$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $125679e0aa9f1836$var$getContainingBlock(element) || window;
}


var $3865c8e28777bda7$export$1e95b668f3b82d = 'top';
var $3865c8e28777bda7$export$40e543e69a8b3fbb = 'bottom';
var $3865c8e28777bda7$export$79ffe56a765070d2 = 'right';
var $3865c8e28777bda7$export$eabcd2c8791e7bf4 = 'left';
var $3865c8e28777bda7$export$dfb5619354ba860 = 'auto';
var $3865c8e28777bda7$export$aec2ce47c367b8c3 = [
    $3865c8e28777bda7$export$1e95b668f3b82d,
    $3865c8e28777bda7$export$40e543e69a8b3fbb,
    $3865c8e28777bda7$export$79ffe56a765070d2,
    $3865c8e28777bda7$export$eabcd2c8791e7bf4
];
var $3865c8e28777bda7$export$b3571188c770cc5a = 'start';
var $3865c8e28777bda7$export$bd5df0f255a350f8 = 'end';
var $3865c8e28777bda7$export$390fd549c5303b4d = 'clippingParents';
var $3865c8e28777bda7$export$d7b7311ec04a3e8f = 'viewport';
var $3865c8e28777bda7$export$ae5ab1c730825774 = 'popper';
var $3865c8e28777bda7$export$ca50aac9f3ba507f = 'reference';
var $3865c8e28777bda7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3865c8e28777bda7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3865c8e28777bda7$export$b3571188c770cc5a,
        placement + "-" + $3865c8e28777bda7$export$bd5df0f255a350f8
    ]);
}, []);
var $3865c8e28777bda7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3865c8e28777bda7$export$aec2ce47c367b8c3, [
    $3865c8e28777bda7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3865c8e28777bda7$export$b3571188c770cc5a,
        placement + "-" + $3865c8e28777bda7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3865c8e28777bda7$export$421679a7c3d56e = 'beforeRead';
var $3865c8e28777bda7$export$aafa59e2e03f2942 = 'read';
var $3865c8e28777bda7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $3865c8e28777bda7$export$c65e99957a05207c = 'beforeMain';
var $3865c8e28777bda7$export$f22da7240b7add18 = 'main';
var $3865c8e28777bda7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3865c8e28777bda7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $3865c8e28777bda7$export$68d8715fc104d294 = 'write';
var $3865c8e28777bda7$export$70a6e5159acce2e6 = 'afterWrite';
var $3865c8e28777bda7$export$d087d3878fdf71d5 = [
    $3865c8e28777bda7$export$421679a7c3d56e,
    $3865c8e28777bda7$export$aafa59e2e03f2942,
    $3865c8e28777bda7$export$6964f6c886723980,
    $3865c8e28777bda7$export$c65e99957a05207c,
    $3865c8e28777bda7$export$f22da7240b7add18,
    $3865c8e28777bda7$export$bab79516f2d662fe,
    $3865c8e28777bda7$export$8d4d2d70e7d46032,
    $3865c8e28777bda7$export$68d8715fc104d294,
    $3865c8e28777bda7$export$70a6e5159acce2e6
];


function $6c6c1bb49a6c6f19$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $6c6c1bb49a6c6f19$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $6c6c1bb49a6c6f19$var$order(modifiers); // order based on phase
    return (0, $3865c8e28777bda7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $75d2a331bd2cf15b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $982f2f83cf2f6fb0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $14e5078e0195b410$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $14e5078e0195b410$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $14e5078e0195b410$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $14e5078e0195b410$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $14e5078e0195b410$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b0de5823221de288$export$45a5e7f76e0caa8d)(reference) ? (0, $da342757a2fcba10$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $da342757a2fcba10$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $da342757a2fcba10$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $6c6c1bb49a6c6f19$export$2e2bcd8739ae039)((0, $982f2f83cf2f6fb0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$14e5078e0195b410$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $61a1042b832dad06$export$2e2bcd8739ae039)(reference, (0, $125679e0aa9f1836$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $526a2135d6b5bab1$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $75d2a331bd2cf15b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$14e5078e0195b410$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $14e5078e0195b410$export$8f7491d57c8f97a9 = /*#__PURE__*/ $14e5078e0195b410$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $d321311c3fd7ed9a$var$passive = {
    passive: true
};
function $d321311c3fd7ed9a$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $d321311c3fd7ed9a$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $d321311c3fd7ed9a$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $d321311c3fd7ed9a$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $d321311c3fd7ed9a$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $d321311c3fd7ed9a$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $d321311c3fd7ed9a$var$effect,
    data: {}
};



function $955b88361c8c04b7$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $34e0c0f7992373bf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $7e49c18464406508$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $c07f509869389d6f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $955b88361c8c04b7$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $34e0c0f7992373bf$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $3865c8e28777bda7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $3865c8e28777bda7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $3865c8e28777bda7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $3865c8e28777bda7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $7e49c18464406508$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $3865c8e28777bda7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $3865c8e28777bda7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $cd0db2726852adee$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c07f509869389d6f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $cd0db2726852adee$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $cd0db2726852adee$var$popperOffsets,
    data: {}
};










var $dde4c3f8a8aa4844$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $dde4c3f8a8aa4844$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $fc24c79d45c62ca8$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $fc24c79d45c62ca8$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $dde4c3f8a8aa4844$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4);
    var sideY = (0, $3865c8e28777bda7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $125679e0aa9f1836$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $7b29f635f99ae239$export$2e2bcd8739ae039)(popper);
            if ((0, $5efcc266e6a16de5$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $3865c8e28777bda7$export$1e95b668f3b82d) || (placement === (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4) || placement === (0, $3865c8e28777bda7$export$79ffe56a765070d2)) && variation === (0, $3865c8e28777bda7$export$bd5df0f255a350f8)) {
            sideY = (0, $3865c8e28777bda7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4) || (placement === (0, $3865c8e28777bda7$export$1e95b668f3b82d) || placement === (0, $3865c8e28777bda7$export$40e543e69a8b3fbb)) && variation === (0, $3865c8e28777bda7$export$bd5df0f255a350f8)) {
            sideX = (0, $3865c8e28777bda7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $dde4c3f8a8aa4844$var$unsetSides);
    var _ref4 = roundOffsets === true ? $dde4c3f8a8aa4844$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $dde4c3f8a8aa4844$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $955b88361c8c04b7$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $34e0c0f7992373bf$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $dde4c3f8a8aa4844$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $dde4c3f8a8aa4844$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dde4c3f8a8aa4844$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $dde4c3f8a8aa4844$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $96494baabfd25425$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $b0de5823221de288$export$1b3bfaa9684536aa)(element) || !(0, $7511fa4ff706ee86$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $96494baabfd25425$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $b0de5823221de288$export$1b3bfaa9684536aa)(element) || !(0, $7511fa4ff706ee86$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $96494baabfd25425$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $96494baabfd25425$var$applyStyles,
    effect: $96494baabfd25425$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $ec76a344fae3b2f7$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $955b88361c8c04b7$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4),
        (0, $3865c8e28777bda7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4),
        (0, $3865c8e28777bda7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ec76a344fae3b2f7$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $3865c8e28777bda7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ec76a344fae3b2f7$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ec76a344fae3b2f7$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ec76a344fae3b2f7$var$offset
};


var $256606d63d8dbd7c$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $256606d63d8dbd7c$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $256606d63d8dbd7c$var$hash[matched];
    });
}



var $9b31baacea4a94e1$var$hash = {
    start: 'end',
    end: 'start'
};
function $9b31baacea4a94e1$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $9b31baacea4a94e1$var$hash[matched];
    });
}







function $ac1b1b38e6406334$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $f8fe4eaa2963d081$export$2e2bcd8739ae039)(element);
    var html = (0, $7b29f635f99ae239$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $888d55cd8a65f3d0$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e882623b932a014a$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a7f14c323e13aeef$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7b29f635f99ae239$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $df866cb48126a9d5$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $fc24c79d45c62ca8$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $fc24c79d45c62ca8$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e882623b932a014a$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5efcc266e6a16de5$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $fc24c79d45c62ca8$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $d6fc9f0a7b938f4f$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b0de5823221de288$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $e7e1717528256f39$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $85f5a73e98b06935$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $b45a64e1c8afc904$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $85f5a73e98b06935$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $3865c8e28777bda7$export$d7b7311ec04a3e8f) ? (0, $e7e1717528256f39$export$2e2bcd8739ae039)((0, $ac1b1b38e6406334$export$2e2bcd8739ae039)(element, strategy)) : (0, $b0de5823221de288$export$45a5e7f76e0caa8d)(clippingParent) ? $85f5a73e98b06935$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e7e1717528256f39$export$2e2bcd8739ae039)((0, $a7f14c323e13aeef$export$2e2bcd8739ae039)((0, $7b29f635f99ae239$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $85f5a73e98b06935$var$getClippingParents(element) {
    var clippingParents = (0, $da342757a2fcba10$export$2e2bcd8739ae039)((0, $ec13aa62d983f6f3$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $5efcc266e6a16de5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b0de5823221de288$export$1b3bfaa9684536aa)(element) ? (0, $125679e0aa9f1836$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $b0de5823221de288$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b0de5823221de288$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d6fc9f0a7b938f4f$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $7511fa4ff706ee86$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $85f5a73e98b06935$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $85f5a73e98b06935$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $85f5a73e98b06935$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $fc24c79d45c62ca8$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $fc24c79d45c62ca8$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $fc24c79d45c62ca8$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $fc24c79d45c62ca8$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $85f5a73e98b06935$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $4da31f1c224789d4$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $7041bb0a1c41f774$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $4da31f1c224789d4$export$2e2bcd8739ae039)(), paddingObject);
}


function $4a14718974d1c5a5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $17c52907185a25f4$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $3865c8e28777bda7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $3865c8e28777bda7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $3865c8e28777bda7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $7041bb0a1c41f774$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4a14718974d1c5a5$export$2e2bcd8739ae039)(padding, (0, $3865c8e28777bda7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $3865c8e28777bda7$export$ae5ab1c730825774) ? (0, $3865c8e28777bda7$export$ca50aac9f3ba507f) : (0, $3865c8e28777bda7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $85f5a73e98b06935$export$2e2bcd8739ae039)((0, $b0de5823221de288$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $7b29f635f99ae239$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $b45a64e1c8afc904$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c07f509869389d6f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $e7e1717528256f39$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $3865c8e28777bda7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $3865c8e28777bda7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $3865c8e28777bda7$export$79ffe56a765070d2),
                (0, $3865c8e28777bda7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $3865c8e28777bda7$export$1e95b668f3b82d),
                (0, $3865c8e28777bda7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $9014fb61db31936e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $3865c8e28777bda7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $34e0c0f7992373bf$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $3865c8e28777bda7$export$368f9a87e87fa4e1) : (0, $3865c8e28777bda7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $34e0c0f7992373bf$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $3865c8e28777bda7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $17c52907185a25f4$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $955b88361c8c04b7$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $e0402a1c72504b9a$var$getExpandedFallbackPlacements(placement) {
    if ((0, $955b88361c8c04b7$export$2e2bcd8739ae039)(placement) === (0, $3865c8e28777bda7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $256606d63d8dbd7c$export$2e2bcd8739ae039)(placement);
    return [
        (0, $9b31baacea4a94e1$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $9b31baacea4a94e1$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $e0402a1c72504b9a$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $955b88361c8c04b7$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $256606d63d8dbd7c$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $e0402a1c72504b9a$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $955b88361c8c04b7$export$2e2bcd8739ae039)(placement) === (0, $3865c8e28777bda7$export$dfb5619354ba860) ? (0, $9014fb61db31936e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $955b88361c8c04b7$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $34e0c0f7992373bf$export$2e2bcd8739ae039)(placement) === (0, $3865c8e28777bda7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $3865c8e28777bda7$export$1e95b668f3b82d),
            (0, $3865c8e28777bda7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $17c52907185a25f4$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $3865c8e28777bda7$export$79ffe56a765070d2) : (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $3865c8e28777bda7$export$40e543e69a8b3fbb) : (0, $3865c8e28777bda7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $256606d63d8dbd7c$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $256606d63d8dbd7c$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $e0402a1c72504b9a$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $e0402a1c72504b9a$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $66fbfdd31569cc43$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $849ea1891f59d3ba$export$f28d906d67a997f3(min, value, max) {
    return (0, $fc24c79d45c62ca8$export$8960430cfd85939f)(min, (0, $fc24c79d45c62ca8$export$96ec731ed4dcb222)(value, max));
}
function $849ea1891f59d3ba$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $849ea1891f59d3ba$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $1380169c00f97764$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $17c52907185a25f4$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $955b88361c8c04b7$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $34e0c0f7992373bf$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $7e49c18464406508$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $66fbfdd31569cc43$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $3865c8e28777bda7$export$1e95b668f3b82d) : (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $3865c8e28777bda7$export$40e543e69a8b3fbb) : (0, $3865c8e28777bda7$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $3865c8e28777bda7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $3865c8e28777bda7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $526a2135d6b5bab1$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $4da31f1c224789d4$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $849ea1891f59d3ba$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $125679e0aa9f1836$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $849ea1891f59d3ba$export$f28d906d67a997f3)(tether ? (0, $fc24c79d45c62ca8$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $fc24c79d45c62ca8$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $3865c8e28777bda7$export$1e95b668f3b82d) : (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $3865c8e28777bda7$export$40e543e69a8b3fbb) : (0, $3865c8e28777bda7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $3865c8e28777bda7$export$1e95b668f3b82d),
            (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $849ea1891f59d3ba$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $849ea1891f59d3ba$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $1380169c00f97764$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $1380169c00f97764$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $52e51b585d700227$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $7041bb0a1c41f774$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4a14718974d1c5a5$export$2e2bcd8739ae039)(padding, (0, $3865c8e28777bda7$export$aec2ce47c367b8c3)));
};
function $52e51b585d700227$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $955b88361c8c04b7$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $7e49c18464406508$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4),
        (0, $3865c8e28777bda7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $52e51b585d700227$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $526a2135d6b5bab1$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $3865c8e28777bda7$export$1e95b668f3b82d) : (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $3865c8e28777bda7$export$40e543e69a8b3fbb) : (0, $3865c8e28777bda7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $125679e0aa9f1836$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $849ea1891f59d3ba$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $52e51b585d700227$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d6fc9f0a7b938f4f$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $52e51b585d700227$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $52e51b585d700227$var$arrow,
    effect: $52e51b585d700227$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $143cf72efcc6425e$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $143cf72efcc6425e$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $3865c8e28777bda7$export$1e95b668f3b82d),
        (0, $3865c8e28777bda7$export$79ffe56a765070d2),
        (0, $3865c8e28777bda7$export$40e543e69a8b3fbb),
        (0, $3865c8e28777bda7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $143cf72efcc6425e$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $17c52907185a25f4$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $17c52907185a25f4$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $143cf72efcc6425e$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $143cf72efcc6425e$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $143cf72efcc6425e$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $143cf72efcc6425e$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $143cf72efcc6425e$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $143cf72efcc6425e$var$hide
};




var $d723fedbf5fe3725$export$d34966752335dd47 = [
    (0, $d321311c3fd7ed9a$export$2e2bcd8739ae039),
    (0, $cd0db2726852adee$export$2e2bcd8739ae039),
    (0, $dde4c3f8a8aa4844$export$2e2bcd8739ae039),
    (0, $96494baabfd25425$export$2e2bcd8739ae039),
    (0, $ec76a344fae3b2f7$export$2e2bcd8739ae039),
    (0, $e0402a1c72504b9a$export$2e2bcd8739ae039),
    (0, $1380169c00f97764$export$2e2bcd8739ae039),
    (0, $52e51b585d700227$export$2e2bcd8739ae039),
    (0, $143cf72efcc6425e$export$2e2bcd8739ae039)
];
var $d723fedbf5fe3725$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $14e5078e0195b410$export$ed5e13716264f202)({
    defaultModifiers: $d723fedbf5fe3725$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules





/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $db6da063dc4439e3$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $db6da063dc4439e3$export$2e2bcd8739ae039 = $db6da063dc4439e3$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $0b37416afca37175$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $db6da063dc4439e3$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $0b37416afca37175$export$2e2bcd8739ae039 = $0b37416afca37175$var$appendOwnerState;



/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $aef0f65b53d2cefd$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $aef0f65b53d2cefd$export$2e2bcd8739ae039 = $aef0f65b53d2cefd$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $cb33f1cc321f61bc$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $cb33f1cc321f61bc$export$2e2bcd8739ae039 = $cb33f1cc321f61bc$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $fb5aa9a8169410bf$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $6a02406550477b35$export$2e2bcd8739ae039)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $aef0f65b53d2cefd$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $cb33f1cc321f61bc$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $cb33f1cc321f61bc$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $6a02406550477b35$export$2e2bcd8739ae039)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $fb5aa9a8169410bf$export$2e2bcd8739ae039 = $fb5aa9a8169410bf$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $f3b39feebb03bdfd$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $f3b39feebb03bdfd$export$2e2bcd8739ae039 = $f3b39feebb03bdfd$var$resolveComponentProps;


'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $b591094cd2f81b7b$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $f3b39feebb03bdfd$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $fb5aa9a8169410bf$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $78465f04bf272330$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $0b37416afca37175$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $b591094cd2f81b7b$export$2e2bcd8739ae039 = $b591094cd2f81b7b$var$useSlotProps;



var $lCzvA = parcelRequire("lCzvA");

var $dAQd3 = parcelRequire("dAQd3");


var $lCzvA = parcelRequire("lCzvA");
function $52e17a1723d23ff7$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($lCzvA.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}


'use client';
function $1dce6bccb63dfb37$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://v6.mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://v6.mui.com/material-ui/api/portal/)
 */ const $1dce6bccb63dfb37$var$Portal = /*#__PURE__*/ $lCzvA.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $lCzvA.useState(null);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(/*#__PURE__*/ $lCzvA.isValidElement(children) ? (0, $52e17a1723d23ff7$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($1dce6bccb63dfb37$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $4df6a81f84d302f6$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $4df6a81f84d302f6$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $lCzvA.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $lCzvA.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $dAQd3.createPortal(children, mountNode) : mountNode;
});
var $1dce6bccb63dfb37$export$2e2bcd8739ae039 = $1dce6bccb63dfb37$var$Portal;




function $80268207eabfd85a$export$1b69b6cd0fa638a1(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiPopper', slot);
}
const $80268207eabfd85a$var$popperClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiPopper', [
    'root'
]);
var $80268207eabfd85a$export$2e2bcd8739ae039 = $80268207eabfd85a$var$popperClasses;



'use client';
function $37cfb6af48c7cb3f$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $37cfb6af48c7cb3f$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $37cfb6af48c7cb3f$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $37cfb6af48c7cb3f$var$isVirtualElement(element) {
    return !$37cfb6af48c7cb3f$var$isHTMLElement(element);
}
const $37cfb6af48c7cb3f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $80268207eabfd85a$export$1b69b6cd0fa638a1), classes);
};
const $37cfb6af48c7cb3f$var$defaultPopperOptions = {};
const $37cfb6af48c7cb3f$var$PopperTooltip = /*#__PURE__*/ $lCzvA.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $lCzvA.useRef(null);
    const ownRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $lCzvA.useRef(null);
    const handlePopperRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $lCzvA.useRef(handlePopperRef);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $lCzvA.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $37cfb6af48c7cb3f$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $lCzvA.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $lCzvA.useState($37cfb6af48c7cb3f$var$resolveAnchorEl(anchorEl));
    $lCzvA.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $lCzvA.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($37cfb6af48c7cb3f$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $d723fedbf5fe3725$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $37cfb6af48c7cb3f$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $b591094cd2f81b7b$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $37cfb6af48c7cb3f$var$Popper = /*#__PURE__*/ $lCzvA.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $37cfb6af48c7cb3f$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $lCzvA.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $37cfb6af48c7cb3f$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $37cfb6af48c7cb3f$var$isHTMLElement(resolvedAnchorEl) ? (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1dce6bccb63dfb37$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($37cfb6af48c7cb3f$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $37cfb6af48c7cb3f$export$2e2bcd8739ae039 = $37cfb6af48c7cb3f$var$Popper;





'use client';
const $b20d485709a84fcd$var$PopperRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $37cfb6af48c7cb3f$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://v6.mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://v6.mui.com/material-ui/react-menu/)
 * - [Popper](https://v6.mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://v6.mui.com/material-ui/api/popper/)
 */ const $b20d485709a84fcd$var$Popper = /*#__PURE__*/ $lCzvA.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($b20d485709a84fcd$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $b20d485709a84fcd$export$2e2bcd8739ae039 = $b20d485709a84fcd$var$Popper;



var $lCzvA = parcelRequire("lCzvA");









function $e5299b3bf6f001e3$export$6816d4fc0981ec7(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiListSubheader', slot);
}
const $e5299b3bf6f001e3$var$listSubheaderClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $e5299b3bf6f001e3$export$2e2bcd8739ae039 = $e5299b3bf6f001e3$var$listSubheaderClasses;



'use client';
const $2c5d98e56112e649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $e5299b3bf6f001e3$export$6816d4fc0981ec7), classes);
};
const $2c5d98e56112e649$var$ListSubheaderRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const $2c5d98e56112e649$var$ListSubheader = /*#__PURE__*/ $lCzvA.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    };
    const classes = $2c5d98e56112e649$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($2c5d98e56112e649$var$ListSubheaderRoot, {
        as: component,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
if ($2c5d98e56112e649$var$ListSubheader) $2c5d98e56112e649$var$ListSubheader.muiSkipListHighlight = true;
var $2c5d98e56112e649$export$2e2bcd8739ae039 = $2c5d98e56112e649$var$ListSubheader;



var $lCzvA = parcelRequire("lCzvA");












function $97c4de58b4b4ddd0$export$29cdb466b9b6f20b(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiPaper', slot);
}
const $97c4de58b4b4ddd0$var$paperClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $97c4de58b4b4ddd0$export$2e2bcd8739ae039 = $97c4de58b4b4ddd0$var$paperClasses;



'use client';
const $0e17783238642a98$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $97c4de58b4b4ddd0$export$29cdb466b9b6f20b), classes);
};
const $0e17783238642a98$var$PaperRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $0e17783238642a98$var$Paper = /*#__PURE__*/ $lCzvA.forwardRef(function Paper(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $0282d01cc0b6bcdf$export$2e2bcd8739ae039)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $0e17783238642a98$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($0e17783238642a98$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $595d4f40c92954a4$export$58f0f39f63f3cf42)('#fff', (0, $a9224a1544d87693$export$2e2bcd8739ae039)(elevation))}, ${(0, $595d4f40c92954a4$export$58f0f39f63f3cf42)('#fff', (0, $a9224a1544d87693$export$2e2bcd8739ae039)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $0e17783238642a98$export$2e2bcd8739ae039 = $0e17783238642a98$var$Paper;



var $lCzvA = parcelRequire("lCzvA");





'use client';
var $aa100cf7db7a0505$export$2e2bcd8739ae039 = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039);





/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $49e84b57c9af64ad$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $49e84b57c9af64ad$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$49e84b57c9af64ad$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $49e84b57c9af64ad$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $49e84b57c9af64ad$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}




var $lCzvA = parcelRequire("lCzvA");





/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $b8633646cfbb63a5$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}






'use client';
var $7df3b3244211e5bc$export$2e2bcd8739ae039 = (0, $b30dbf340362d390$export$2e2bcd8739ae039);



var $lCzvA = parcelRequire("lCzvA");

'use client';
class $4e4b8c3e05048a74$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $4e4b8c3e05048a74$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)($4e4b8c3e05048a74$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $lCzvA.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $lCzvA.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $4e4b8c3e05048a74$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $4e4b8c3e05048a74$export$2e2bcd8739ae039() {
    return $4e4b8c3e05048a74$export$f5de0641c7db4154.use();
}
function $4e4b8c3e05048a74$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $lCzvA = parcelRequire("lCzvA");



function $23abc2a8c3dc4978$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $34513eb7b9a93b9c$export$2e2bcd8739ae039(t, e) {
    return $34513eb7b9a93b9c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $34513eb7b9a93b9c$export$2e2bcd8739ae039(t, e);
}


function $a07b762a1fdd8900$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $34513eb7b9a93b9c$export$2e2bcd8739ae039)(t, o);
}




var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");
var $58eee0317f24e867$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createContext(null);



var $lCzvA = parcelRequire("lCzvA");
function $7eeef276c460f469$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $lCzvA.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $lCzvA.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $7eeef276c460f469$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $7eeef276c460f469$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $7eeef276c460f469$export$fa71e2345c31d7a2(props, onExited) {
    return $7eeef276c460f469$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $lCzvA.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $7eeef276c460f469$var$getProp(child, 'appear', props),
            enter: $7eeef276c460f469$var$getProp(child, 'enter', props),
            exit: $7eeef276c460f469$var$getProp(child, 'exit', props)
        });
    });
}
function $7eeef276c460f469$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $7eeef276c460f469$export$bbc8a025727ea824(nextProps.children);
    var children = $7eeef276c460f469$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $lCzvA.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $lCzvA.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $lCzvA.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $7eeef276c460f469$var$getProp(child, 'exit', nextProps),
            enter: $7eeef276c460f469$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $lCzvA.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $lCzvA.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $lCzvA.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $7eeef276c460f469$var$getProp(child, 'exit', nextProps),
            enter: $7eeef276c460f469$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $133513919fcb73a0$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $133513919fcb73a0$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $133513919fcb73a0$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $a07b762a1fdd8900$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $23abc2a8c3dc4978$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $7eeef276c460f469$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $7eeef276c460f469$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $7eeef276c460f469$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $133513919fcb73a0$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement((0, $58eee0317f24e867$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement((0, $58eee0317f24e867$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).Component);
$133513919fcb73a0$var$TransitionGroup.propTypes = {};
$133513919fcb73a0$var$TransitionGroup.defaultProps = $133513919fcb73a0$var$defaultProps;
var $133513919fcb73a0$export$2e2bcd8739ae039 = $133513919fcb73a0$var$TransitionGroup;







var $lCzvA = parcelRequire("lCzvA");



'use client';
function $18e31f222d06386d$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $lCzvA.useState(false);
    const rippleClassName = (0, $6a02406550477b35$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $lCzvA.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
            className: childClassName
        })
    });
}
var $18e31f222d06386d$export$2e2bcd8739ae039 = $18e31f222d06386d$var$Ripple;




function $034e9e72aa530e3e$export$b464606f735ab902(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiTouchRipple', slot);
}
const $034e9e72aa530e3e$var$touchRippleClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $034e9e72aa530e3e$export$2e2bcd8739ae039 = $034e9e72aa530e3e$var$touchRippleClasses;



'use client';
const $333a3272933edc85$var$DURATION = 550;
const $333a3272933edc85$export$95d0c9356b2231a3 = 80;
const $333a3272933edc85$var$enterKeyframe = (0, $02d5075f8320414d$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $333a3272933edc85$var$exitKeyframe = (0, $02d5075f8320414d$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $333a3272933edc85$var$pulsateKeyframe = (0, $02d5075f8320414d$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $333a3272933edc85$export$f6b7418508c72c25 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $333a3272933edc85$export$676cfe7b12693c4b = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $18e31f222d06386d$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $034e9e72aa530e3e$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$333a3272933edc85$var$enterKeyframe};
    animation-duration: ${$333a3272933edc85$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $034e9e72aa530e3e$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $034e9e72aa530e3e$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $034e9e72aa530e3e$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$333a3272933edc85$var$exitKeyframe};
    animation-duration: ${$333a3272933edc85$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $034e9e72aa530e3e$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$333a3272933edc85$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $333a3272933edc85$var$TouchRipple = /*#__PURE__*/ $lCzvA.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $lCzvA.useState([]);
    const nextKey = $lCzvA.useRef(0);
    const rippleCallback = $lCzvA.useRef(null);
    $lCzvA.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $lCzvA.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $lCzvA.useRef(null);
    const container = $lCzvA.useRef(null);
    const startCommit = $lCzvA.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($333a3272933edc85$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.ripple, (0, $034e9e72aa530e3e$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $034e9e72aa530e3e$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $034e9e72aa530e3e$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.child, (0, $034e9e72aa530e3e$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.childLeaving, (0, $034e9e72aa530e3e$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.childPulsate, (0, $034e9e72aa530e3e$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $333a3272933edc85$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $lCzvA.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($333a3272933edc85$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $lCzvA.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $lCzvA.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $lCzvA.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($333a3272933edc85$export$f6b7418508c72c25, {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)((0, $034e9e72aa530e3e$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $133513919fcb73a0$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $333a3272933edc85$export$2e2bcd8739ae039 = $333a3272933edc85$var$TouchRipple;




function $312c6720d61cc01b$export$fccb0498dcd99783(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiButtonBase', slot);
}
const $312c6720d61cc01b$var$buttonBaseClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $312c6720d61cc01b$export$2e2bcd8739ae039 = $312c6720d61cc01b$var$buttonBaseClasses;



'use client';
const $e04b8c42a017212a$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $312c6720d61cc01b$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $e04b8c42a017212a$export$7ec0dcc5e3cdcd36 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $312c6720d61cc01b$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $e04b8c42a017212a$var$ButtonBase = /*#__PURE__*/ $lCzvA.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $lCzvA.useRef(null);
    const ripple = (0, $4e4b8c3e05048a74$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $ade5ac70196d775c$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $lCzvA.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $lCzvA.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $lCzvA.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $e04b8c42a017212a$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $e04b8c42a017212a$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $e04b8c42a017212a$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $e04b8c42a017212a$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $e04b8c42a017212a$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $e04b8c42a017212a$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $e04b8c42a017212a$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $e04b8c42a017212a$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $e04b8c42a017212a$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $b8633646cfbb63a5$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $7df3b3244211e5bc$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $b8633646cfbb63a5$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $7df3b3244211e5bc$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $7df3b3244211e5bc$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $ade5ac70196d775c$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $e04b8c42a017212a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($e04b8c42a017212a$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $333a3272933edc85$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $e04b8c42a017212a$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $7df3b3244211e5bc$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $e04b8c42a017212a$export$2e2bcd8739ae039 = $e04b8c42a017212a$var$ButtonBase;



var $lCzvA = parcelRequire("lCzvA");











function $3476dfea7279a885$export$29cad1383b3f235d(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiCircularProgress', slot);
}
const $3476dfea7279a885$var$circularProgressClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $3476dfea7279a885$export$2e2bcd8739ae039 = $3476dfea7279a885$var$circularProgressClasses;



'use client';
const $884fc2b3feb01a9d$var$SIZE = 44;
const $884fc2b3feb01a9d$var$circularRotateKeyframe = (0, $02d5075f8320414d$export$d25ddfdf17c3ad3e)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $884fc2b3feb01a9d$var$circularDashKeyframe = (0, $02d5075f8320414d$export$d25ddfdf17c3ad3e)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $884fc2b3feb01a9d$var$rotateAnimation = typeof $884fc2b3feb01a9d$var$circularRotateKeyframe !== 'string' ? (0, $02d5075f8320414d$export$dbf350e5966cf602)`
        animation: ${$884fc2b3feb01a9d$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $884fc2b3feb01a9d$var$dashAnimation = typeof $884fc2b3feb01a9d$var$circularDashKeyframe !== 'string' ? (0, $02d5075f8320414d$export$dbf350e5966cf602)`
        animation: ${$884fc2b3feb01a9d$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $884fc2b3feb01a9d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $212bca41d578456f$export$2e2bcd8739ae039)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $3476dfea7279a885$export$29cad1383b3f235d), classes);
};
const $884fc2b3feb01a9d$var$CircularProgressRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $884fc2b3feb01a9d$var$rotateAnimation || {
                    animation: `${$884fc2b3feb01a9d$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $884fc2b3feb01a9d$var$CircularProgressSVG = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $884fc2b3feb01a9d$var$CircularProgressCircle = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $884fc2b3feb01a9d$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$884fc2b3feb01a9d$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $884fc2b3feb01a9d$var$CircularProgress = /*#__PURE__*/ $lCzvA.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $884fc2b3feb01a9d$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($884fc2b3feb01a9d$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($884fc2b3feb01a9d$var$CircularProgressRoot, {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($884fc2b3feb01a9d$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$884fc2b3feb01a9d$var$SIZE / 2} ${$884fc2b3feb01a9d$var$SIZE / 2} ${$884fc2b3feb01a9d$var$SIZE} ${$884fc2b3feb01a9d$var$SIZE}`,
            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($884fc2b3feb01a9d$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $884fc2b3feb01a9d$var$SIZE,
                cy: $884fc2b3feb01a9d$var$SIZE,
                r: ($884fc2b3feb01a9d$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $884fc2b3feb01a9d$export$2e2bcd8739ae039 = $884fc2b3feb01a9d$var$CircularProgress;





function $03db38fa595f9c91$export$5e8702d71474f093(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiIconButton', slot);
}
const $03db38fa595f9c91$var$iconButtonClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $03db38fa595f9c91$export$2e2bcd8739ae039 = $03db38fa595f9c91$var$iconButtonClasses;



'use client';
const $5da5f49d148860cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $212bca41d578456f$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $03db38fa595f9c91$export$5e8702d71474f093), classes);
};
const $5da5f49d148860cb$var$IconButtonRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $e04b8c42a017212a$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $03db38fa595f9c91$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $03db38fa595f9c91$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    })));
const $5da5f49d148860cb$var$IconButtonLoadingIndicator = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $5da5f49d148860cb$var$IconButton = /*#__PURE__*/ $lCzvA.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $aa100cf7db7a0505$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $884fc2b3feb01a9d$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $5da5f49d148860cb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($5da5f49d148860cb$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($5da5f49d148860cb$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $5da5f49d148860cb$export$2e2bcd8739ae039 = $5da5f49d148860cb$var$IconButton;



var $lCzvA = parcelRequire("lCzvA");




parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");









function $fa238e07df6b88aa$export$c7c50641356bdfa5(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiSvgIcon', slot);
}
const $fa238e07df6b88aa$var$svgIconClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $fa238e07df6b88aa$export$2e2bcd8739ae039 = $fa238e07df6b88aa$var$svgIconClasses;



'use client';
const $a9efb657c75d16f5$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $212bca41d578456f$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $fa238e07df6b88aa$export$c7c50641356bdfa5), classes);
};
const $a9efb657c75d16f5$var$SvgIconRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $a9efb657c75d16f5$var$SvgIcon = /*#__PURE__*/ $lCzvA.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $lCzvA.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $a9efb657c75d16f5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($a9efb657c75d16f5$var$SvgIconRoot, {
        as: component,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$a9efb657c75d16f5$var$SvgIcon.muiName = 'SvgIcon';
var $a9efb657c75d16f5$export$2e2bcd8739ae039 = $a9efb657c75d16f5$var$SvgIcon;



'use client';
function $488bd136de508705$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a9efb657c75d16f5$export$2e2bcd8739ae039), {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $a9efb657c75d16f5$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $lCzvA.memo(/*#__PURE__*/ $lCzvA.forwardRef(Component));
}



'use client';
var $a9dc1471cf638fdd$export$2e2bcd8739ae039 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');












function $45e646734dc837f9$export$31444911e4ee6fdd(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiChip', slot);
}
const $45e646734dc837f9$var$chipClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $45e646734dc837f9$export$2e2bcd8739ae039 = $45e646734dc837f9$var$chipClasses;



'use client';
const $ebde703037fa614e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            `${variant}${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`
        ],
        label: [
            'label',
            `label${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`,
            `avatarColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`,
            `iconColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`,
            `deleteIconColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            `deleteIcon${(0, $212bca41d578456f$export$2e2bcd8739ae039)(variant)}Color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $45e646734dc837f9$export$31444911e4ee6fdd), classes);
};
const $ebde703037fa614e$var$ChipRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(iconColor)}`]
            },
            {
                [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $212bca41d578456f$export$2e2bcd8739ae039)(variant)}Color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`]
            },
            styles.root,
            styles[`size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`],
            styles[`color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $45e646734dc837f9$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].contrastTextChannel} / 0.7)` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${(0, $45e646734dc837f9$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${(0, $45e646734dc837f9$export$2e2bcd8739ae039).focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
                    },
                    [`&.${(0, $45e646734dc837f9$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${(0, $45e646734dc837f9$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${(0, $45e646734dc837f9$export$2e2bcd8739ae039).clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${(0, $45e646734dc837f9$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.7)}`,
                        [`&.${(0, $45e646734dc837f9$export$2e2bcd8739ae039).clickable}:hover`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        },
                        [`&.${(0, $45e646734dc837f9$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.focusOpacity)
                        },
                        [`& .${(0, $45e646734dc837f9$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $ebde703037fa614e$var$ChipLabel = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $ebde703037fa614e$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $ebde703037fa614e$var$Chip = /*#__PURE__*/ $lCzvA.forwardRef(function Chip(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, // TODO v6: Rename to `focusableWhenDisabled`.
    ...other } = props;
    const chipRef = $lCzvA.useRef(null);
    const handleRef = (0, $ade5ac70196d775c$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $ebde703037fa614e$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $ebde703037fa614e$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $e04b8c42a017212a$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $lCzvA.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $ebde703037fa614e$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $e04b8c42a017212a$export$2e2bcd8739ae039) ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $lCzvA.isValidElement(deleteIconProp) ? /*#__PURE__*/ $lCzvA.cloneElement(deleteIconProp, {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a9dc1471cf638fdd$export$2e2bcd8739ae039), {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $lCzvA.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $lCzvA.cloneElement(avatarProp, {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $lCzvA.isValidElement(iconProp)) icon = /*#__PURE__*/ $lCzvA.cloneElement(iconProp, {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($ebde703037fa614e$var$ChipRoot, {
        as: component,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState,
        ...moreProps,
        ...other,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($ebde703037fa614e$var$ChipLabel, {
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    });
});
var $ebde703037fa614e$export$2e2bcd8739ae039 = $ebde703037fa614e$var$Chip;





function $292dbef72fe6adc9$export$cdb270390122322b(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiInput', slot);
}
const $292dbef72fe6adc9$var$inputClasses = {
    ...(0, $4e524ec0ed105543$export$2e2bcd8739ae039),
    ...(0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $292dbef72fe6adc9$export$2e2bcd8739ae039 = $292dbef72fe6adc9$var$inputClasses;






function $5af7f14e2a83efc7$export$89922944c7227687(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiOutlinedInput', slot);
}
const $5af7f14e2a83efc7$var$outlinedInputClasses = {
    ...(0, $4e524ec0ed105543$export$2e2bcd8739ae039),
    ...(0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $5af7f14e2a83efc7$export$2e2bcd8739ae039 = $5af7f14e2a83efc7$var$outlinedInputClasses;





function $3a25d1a7c6322cc0$export$3331e419f1a48437(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiFilledInput', slot);
}
const $3a25d1a7c6322cc0$var$filledInputClasses = {
    ...(0, $4e524ec0ed105543$export$2e2bcd8739ae039),
    ...(0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $3a25d1a7c6322cc0$export$2e2bcd8739ae039 = $3a25d1a7c6322cc0$var$filledInputClasses;


parcelRequire("lCzvA");


'use client';
var $a086c05cd9c39010$export$2e2bcd8739ae039 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');


parcelRequire("lCzvA");


'use client';
var $0da1bfbe8f163ecb$export$2e2bcd8739ae039 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







function $ad7ce409616db483$export$8ee01529667e66d9(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiAutocomplete', slot);
}
const $ad7ce409616db483$var$autocompleteClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $ad7ce409616db483$export$2e2bcd8739ae039 = $ad7ce409616db483$var$autocompleteClasses;







'use client';
function $ff4764e01616a70c$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $f3b39feebb03bdfd$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $fb5aa9a8169410bf$export$2e2bcd8739ae039)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $78465f04bf272330$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $0b37416afca37175$export$2e2bcd8739ae039)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}



'use client';
var $f67deb46fcc775cd$var$_ClearIcon, $f67deb46fcc775cd$var$_ArrowDropDownIcon;
const $f67deb46fcc775cd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $ad7ce409616db483$export$8ee01529667e66d9), classes);
};
const $f67deb46fcc775cd$var$AutocompleteRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).focused} .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $292dbef72fe6adc9$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $292dbef72fe6adc9$export$2e2bcd8739ae039).root}.${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $292dbef72fe6adc9$export$2e2bcd8739ae039).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).root}.${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).root}.${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).root}.${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).root}.${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).hiddenLabel}.${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $f67deb46fcc775cd$var$AutocompleteEndAdornment = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $f67deb46fcc775cd$var$AutocompleteClearIndicator = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $5da5f49d148860cb$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $f67deb46fcc775cd$var$AutocompletePopupIndicator = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $5da5f49d148860cb$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $f67deb46fcc775cd$var$AutocompletePopper = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $b20d485709a84fcd$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const $f67deb46fcc775cd$var$AutocompletePaper = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $0e17783238642a98$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        overflow: 'auto'
    })));
const $f67deb46fcc775cd$var$AutocompleteLoading = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $f67deb46fcc775cd$var$AutocompleteNoOptions = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $f67deb46fcc775cd$var$AutocompleteListbox = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $ad7ce409616db483$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    })));
const $f67deb46fcc775cd$var$AutocompleteGroupLabel = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $2c5d98e56112e649$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const $f67deb46fcc775cd$var$AutocompleteGroupUl = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $ad7ce409616db483$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $f67deb46fcc775cd$var$Autocomplete = /*#__PURE__*/ $lCzvA.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipPropsProp, className: className, clearIcon: clearIcon = $f67deb46fcc775cd$var$_ClearIcon || ($f67deb46fcc775cd$var$_ClearIcon = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a086c05cd9c39010$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue: isOptionEqualToValue, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, limitTags: limitTags = -1, ListboxComponent: ListboxComponentProp, ListboxProps: ListboxPropsProp, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: open, openOnFocus: openOnFocus = false, openText: openText = 'Open', options: options, PaperComponent: PaperComponentProp, PopperComponent: PopperComponentProp, popupIcon: popupIcon = $f67deb46fcc775cd$var$_ArrowDropDownIcon || ($f67deb46fcc775cd$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0da1bfbe8f163ecb$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, value: valueProp, ...other } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $bbbc93862f7737a4$export$2e2bcd8739ae039)({
        ...props,
        componentName: 'Autocomplete'
    });
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: listboxRef, ...otherListboxProps } = getListboxProps();
    const defaultGetOptionLabel = (option)=>option.label ?? option;
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = {
        ...props,
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    };
    const classes = $f67deb46fcc775cd$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            paper: PaperComponentProp,
            popper: PopperComponentProp,
            ...slots
        },
        slotProps: {
            chip: ChipPropsProp,
            listbox: ListboxPropsProp,
            ...componentsProps,
            ...slotProps
        }
    };
    const [ListboxSlot, listboxProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('listbox', {
        elementType: $f67deb46fcc775cd$var$AutocompleteListbox,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.listbox,
        additionalProps: otherListboxProps,
        ref: listboxRef
    });
    const [PaperSlot, paperProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('paper', {
        elementType: (0, $0e17783238642a98$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('popper', {
        elementType: (0, $b20d485709a84fcd$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            role: 'presentation',
            anchorEl: anchorEl,
            open: popupOpen
        }
    });
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>({
                className: classes.tag,
                disabled: disabled,
                ...getTagProps(params)
            });
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const { key: key, ...customTagProps } = getCustomizedTagProps({
                index: index
            });
            return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebde703037fa614e$export$2e2bcd8739ae039), {
                label: getOptionLabel(option),
                size: size,
                ...customTagProps,
                ...externalForwardedProps.slotProps.chip
            }, key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f67deb46fcc775cd$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f67deb46fcc775cd$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key, ...otherProps } = props2;
        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
            ...otherProps,
            children: getOptionLabel(option)
        }, key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption({
            ...optionProps,
            className: classes.option
        }, option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = externalForwardedProps.slotProps.clearIndicator;
    const popupIndicatorSlotProps = externalForwardedProps.slotProps.popupIndicator;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f67deb46fcc775cd$var$AutocompleteRoot, {
                ref: ref,
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
                ownerState: ownerState,
                ...getRootProps(other),
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        },
                        ...(hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($f67deb46fcc775cd$var$AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f67deb46fcc775cd$var$AutocompleteClearIndicator, {
                                        ...getClearProps(),
                                        "aria-label": clearText,
                                        title: clearText,
                                        ownerState: ownerState,
                                        ...clearIndicatorSlotProps,
                                        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.clearIndicator, clearIndicatorSlotProps?.className),
                                        children: clearIcon
                                    }) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f67deb46fcc775cd$var$AutocompletePopupIndicator, {
                                        ...getPopupIndicatorProps(),
                                        disabled: disabled,
                                        "aria-label": popupOpen ? closeText : openText,
                                        title: popupOpen ? closeText : openText,
                                        ownerState: ownerState,
                                        ...popupIndicatorSlotProps,
                                        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.popupIndicator, popupIndicatorSlotProps?.className),
                                        children: popupIcon
                                    }) : null
                                ]
                            })
                        }
                    },
                    inputProps: {
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly,
                        ...getInputProps()
                    }
                })
            }),
            anchorEl ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f67deb46fcc775cd$var$AutocompletePopper, {
                as: PopperSlot,
                ...popperProps,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($f67deb46fcc775cd$var$AutocompletePaper, {
                    as: PaperSlot,
                    ...paperProps,
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f67deb46fcc775cd$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f67deb46fcc775cd$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(ListboxSlot, {
                            as: ListboxComponentProp,
                            ...listboxProps,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        }) : null
                    ]
                })
            }) : null
        ]
    });
});
var $f67deb46fcc775cd$export$2e2bcd8739ae039 = $f67deb46fcc775cd$var$Autocomplete;





const $db0aedd8cebb17e4$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant"
], $db0aedd8cebb17e4$var$_excluded2 = [
    "key"
];
function $db0aedd8cebb17e4$export$fec959c3691e0645(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, color: color, error: error, helperText: helperText, size: size, variant: variant = 'standard' } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $db0aedd8cebb17e4$var$_excluded);
    const TextFieldProps = {
        color: color,
        error: error,
        helperText: helperText,
        size: size,
        variant: variant
    };
    const [filterValueState, setFilterValueState] = $lCzvA.useState(item.value || []);
    const id = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    $lCzvA.useEffect(()=>{
        const itemValue = item.value ?? [];
        setFilterValueState(itemValue.map(String));
    }, [
        item.value
    ]);
    const handleChange = $lCzvA.useCallback((event, value)=>{
        setFilterValueState(value.map(String));
        applyValue((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, item, {
            value: [
                ...value.map((filterItemValue)=>type === 'number' ? Number(filterItemValue) : filterItemValue)
            ]
        }));
    }, [
        applyValue,
        item,
        type
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $f67deb46fcc775cd$export$2e2bcd8739ae039), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        multiple: true,
        freeSolo: true,
        options: [],
        filterOptions: (options, params)=>{
            const { inputValue: inputValue } = params;
            return inputValue == null || inputValue === '' ? [] : [
                inputValue
            ];
        },
        id: id,
        value: filterValueState,
        onChange: handleChange,
        renderTags: (value, getTagProps)=>value.map((option, index)=>{
                const _getTagProps = getTagProps({
                    index: index
                }), { key: key } = _getTagProps, tagProps = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_getTagProps, $db0aedd8cebb17e4$var$_excluded2);
                return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseChip, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                    variant: "outlined",
                    size: "small",
                    label: option
                }, tagProps), key);
            }),
        renderInput: (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseTextField, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params, {
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                InputLabelProps: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: type || 'text'
            }, TextFieldProps, rootProps.slotProps?.baseTextField))
    }, other));
}




/**
 * Filter item definition interface.
 * @demos
 *   - [Custom filter operator](/x/react-data-grid/filtering/customization/#create-a-custom-operator)
 */ var $f78fdfbb86788eda$export$90be184ccbab1c7a = /*#__PURE__*/ function(GridLogicOperator) {
    GridLogicOperator["And"] = "and";
    GridLogicOperator["Or"] = "or";
    return GridLogicOperator;
}($f78fdfbb86788eda$export$90be184ccbab1c7a || {});



const $88b02358d3d53b62$export$f5e27122a659c0c = {
    filteredRowsLookup: {},
    filteredChildrenCountLookup: {},
    filteredDescendantCountLookup: {}
};
const $88b02358d3d53b62$export$7ea23129b8e10cdb = ()=>({
        items: [],
        logicOperator: (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).And,
        quickFilterValues: [],
        quickFilterLogicOperator: (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).And
    }); /**
 * @param {GridRowId} rowId The id of the row we want to filter.
 * @param {(filterItem: GridFilterItem) => boolean} shouldApplyItem An optional callback to allow the filtering engine to only apply some items.
 */  /**
 * Visibility status for each row.
 * A row is visible if it is passing the filters AND if its parents are expanded.
 * If a row is not registered in this lookup, it is visible.
 */ 


function $254a8ad3fba2241c$export$fbb0da9fc679f98a(apiRef) {
    return {
        current: apiRef.current.getPublicApi()
    };
}



let $bb45a78aee581510$var$hasEval;
function $bb45a78aee581510$var$getHasEval() {
    if ($bb45a78aee581510$var$hasEval !== undefined) return $bb45a78aee581510$var$hasEval;
    try {
        $bb45a78aee581510$var$hasEval = new Function('return true')();
    } catch (_) {
        $bb45a78aee581510$var$hasEval = false;
    }
    return $bb45a78aee581510$var$hasEval;
}
const $bb45a78aee581510$export$eb76493d113de092 = (item, apiRef)=>{
    const cleanItem = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, item);
    if (cleanItem.id == null) cleanItem.id = Math.round(Math.random() * 1e5);
    if (cleanItem.operator == null) {
        // Selects a default operator
        // We don't use `apiRef.current.getColumn` because it is not ready during state initialization
        const column = (0, $8b99503000dd62d3$export$8a3a9a6db584d7fd)(apiRef)[cleanItem.field];
        cleanItem.operator = column && column.filterOperators[0].value;
    }
    return cleanItem;
};
const $bb45a78aee581510$export$2a370a0aad2ac7e1 = (model, disableMultipleColumnsFiltering, apiRef)=>{
    const hasSeveralItems = model.items.length > 1;
    let items;
    if (hasSeveralItems && disableMultipleColumnsFiltering) items = [
        model.items[0]
    ];
    else items = model.items;
    const hasItemsWithoutIds = hasSeveralItems && items.some((item)=>item.id == null);
    const hasItemWithoutOperator = items.some((item)=>item.operator == null);
    if (hasItemWithoutOperator || hasItemsWithoutIds) return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, model, {
        items: items.map((item)=>$bb45a78aee581510$export$eb76493d113de092(item, apiRef))
    });
    if (model.items !== items) return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, model, {
        items: items
    });
    return model;
};
const $bb45a78aee581510$export$f4189e6c713e6dd8 = (filterModel, disableMultipleColumnsFiltering, apiRef)=>(filteringState)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filteringState, {
            filterModel: $bb45a78aee581510$export$2a370a0aad2ac7e1(filterModel, disableMultipleColumnsFiltering, apiRef)
        });
const $bb45a78aee581510$export$626da389515c02b3 = (value)=>{
    if (typeof value === 'string') return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return value;
};
const $bb45a78aee581510$var$getFilterCallbackFromItem = (filterItem, apiRef)=>{
    if (!filterItem.field || !filterItem.operator) return null;
    const column = apiRef.current.getColumn(filterItem.field);
    if (!column) return null;
    let parsedValue;
    if (column.valueParser) {
        const parser = column.valueParser;
        parsedValue = Array.isArray(filterItem.value) ? filterItem.value?.map((x)=>parser(x, undefined, column, apiRef)) : parser(filterItem.value, undefined, column, apiRef);
    } else parsedValue = filterItem.value;
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    if (ignoreDiacritics) parsedValue = $bb45a78aee581510$export$626da389515c02b3(parsedValue);
    const newFilterItem = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filterItem, {
        value: parsedValue
    });
    const filterOperators = column.filterOperators;
    if (!filterOperators?.length) throw new Error(`MUI X: No filter operators found for column '${column.field}'.`);
    const filterOperator = filterOperators.find((operator)=>operator.value === newFilterItem.operator);
    if (!filterOperator) throw new Error(`MUI X: No filter operator found for column '${column.field}' and operator value '${newFilterItem.operator}'.`);
    const publicApiRef = (0, $254a8ad3fba2241c$export$fbb0da9fc679f98a)(apiRef);
    const applyFilterOnRow = filterOperator.getApplyFilterFn(newFilterItem, column);
    if (typeof applyFilterOnRow !== 'function') return null;
    return {
        item: newFilterItem,
        fn: (row)=>{
            let value = apiRef.current.getRowValue(row, column);
            if (ignoreDiacritics) value = $bb45a78aee581510$export$626da389515c02b3(value);
            return applyFilterOnRow(value, row, column, publicApiRef);
        }
    };
};
let $bb45a78aee581510$var$filterItemsApplierId = 1;
/**
 * Generates a method to easily check if a row is matching the current filter model.
 * @param {GridFilterModel} filterModel The model with which we want to filter the rows.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $bb45a78aee581510$var$buildAggregatedFilterItemsApplier = (filterModel, apiRef, disableEval)=>{
    const { items: items } = filterModel;
    const appliers = items.map((item)=>$bb45a78aee581510$var$getFilterCallbackFromItem(item, apiRef)).filter((callback)=>!!callback);
    if (appliers.length === 0) return null;
    if (disableEval || !$bb45a78aee581510$var$getHasEval()) // This is the original logic, which is used if `eval()` is not supported (aka prevented by CSP).
    return (row, shouldApplyFilter)=>{
        const resultPerItemId = {};
        for(let i = 0; i < appliers.length; i += 1){
            const applier = appliers[i];
            if (!shouldApplyFilter || shouldApplyFilter(applier.item.field)) resultPerItemId[applier.item.id] = applier.fn(row);
        }
        return resultPerItemId;
    };
    // We generate a new function with `new Function()` to avoid expensive patterns for JS engines
    // such as a dynamic object assignment, for example `{ [dynamicKey]: value }`.
    const filterItemCore = new Function('appliers', 'row', 'shouldApplyFilter', `"use strict";
${appliers.map((applier, i)=>`const shouldApply${i} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(applier.item.field)});`).join('\n')}

const result$$ = {
${appliers.map((applier, i)=>`  ${JSON.stringify(String(applier.item.id))}: !shouldApply${i} ? false : appliers[${i}].fn(row),`).join('\n')}
};

return result$$;`.replaceAll('$$', String($bb45a78aee581510$var$filterItemsApplierId)));
    $bb45a78aee581510$var$filterItemsApplierId += 1;
    // Assign to the arrow function a name to help debugging
    const filterItem = (row, shouldApplyItem)=>filterItemCore(appliers, row, shouldApplyItem);
    return filterItem;
};
const $bb45a78aee581510$export$cabca178b367efe0 = (filterModel)=>{
    return filterModel.quickFilterExcludeHiddenColumns ?? true;
};
/**
 * Generates a method to easily check if a row is matching the current quick filter.
 * @param {any[]} filterModel The model with which we want to filter the rows.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $bb45a78aee581510$var$buildAggregatedQuickFilterApplier = (filterModel, apiRef)=>{
    const quickFilterValues = filterModel.quickFilterValues?.filter(Boolean) ?? [];
    if (quickFilterValues.length === 0) return null;
    const columnFields = $bb45a78aee581510$export$cabca178b367efe0(filterModel) ? (0, $8b99503000dd62d3$export$c9491722e1d6e8d3)(apiRef) : (0, $8b99503000dd62d3$export$d8a3dfbb129c80db)(apiRef);
    const appliersPerField = [];
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    const publicApiRef = (0, $254a8ad3fba2241c$export$fbb0da9fc679f98a)(apiRef);
    columnFields.forEach((field)=>{
        const column = apiRef.current.getColumn(field);
        const getApplyQuickFilterFn = column?.getApplyQuickFilterFn;
        if (getApplyQuickFilterFn) appliersPerField.push({
            column: column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? $bb45a78aee581510$export$626da389515c02b3(quickFilterValue) : quickFilterValue;
                return {
                    fn: getApplyQuickFilterFn(value, column, publicApiRef)
                };
            })
        });
    });
    return function isRowMatchingQuickFilter(row, shouldApplyFilter) {
        const result = {};
        /* eslint-disable no-labels */ outer: for(let v = 0; v < quickFilterValues.length; v += 1){
            const filterValue = quickFilterValues[v];
            for(let i = 0; i < appliersPerField.length; i += 1){
                const { column: column, appliers: appliers } = appliersPerField[i];
                const { field: field } = column;
                if (shouldApplyFilter && !shouldApplyFilter(field)) continue;
                const applier = appliers[v];
                let value = apiRef.current.getRowValue(row, column);
                if (applier.fn === null) continue;
                if (ignoreDiacritics) value = $bb45a78aee581510$export$626da389515c02b3(value);
                const isMatching = applier.fn(value, row, column, publicApiRef);
                if (isMatching) {
                    result[filterValue] = true;
                    continue outer;
                }
            }
            result[filterValue] = false;
        }
        return result;
    };
};
const $bb45a78aee581510$export$1c795c7c9654905e = (filterModel, apiRef, disableEval)=>{
    const isRowMatchingFilterItems = $bb45a78aee581510$var$buildAggregatedFilterItemsApplier(filterModel, apiRef, disableEval);
    const isRowMatchingQuickFilter = $bb45a78aee581510$var$buildAggregatedQuickFilterApplier(filterModel, apiRef);
    return function isRowMatchingFilters(row, shouldApplyFilter, result) {
        result.passingFilterItems = isRowMatchingFilterItems?.(row, shouldApplyFilter) ?? null;
        result.passingQuickFilterValues = isRowMatchingQuickFilter?.(row, shouldApplyFilter) ?? null;
    };
};
const $bb45a78aee581510$var$isNotNull = (result)=>result != null;
const $bb45a78aee581510$var$filterModelItems = (cache, apiRef, items)=>{
    if (!cache.cleanedFilterItems) cache.cleanedFilterItems = items.filter((item)=>$bb45a78aee581510$var$getFilterCallbackFromItem(item, apiRef) !== null);
    return cache.cleanedFilterItems;
};
const $bb45a78aee581510$export$8d82b4490466f182 = (allFilterItemResults, allQuickFilterResults, filterModel, apiRef, cache)=>{
    const cleanedFilterItems = $bb45a78aee581510$var$filterModelItems(cache, apiRef, filterModel.items);
    const cleanedFilterItemResults = allFilterItemResults.filter($bb45a78aee581510$var$isNotNull);
    const cleanedQuickFilterResults = allQuickFilterResults.filter($bb45a78aee581510$var$isNotNull);
    // get result for filter items model
    if (cleanedFilterItemResults.length > 0) {
        // Return true if the item pass with one of the rows
        const filterItemPredicate = (item)=>{
            return cleanedFilterItemResults.some((filterItemResult)=>filterItemResult[item.id]);
        };
        const logicOperator = filterModel.logicOperator ?? (0, $88b02358d3d53b62$export$7ea23129b8e10cdb)().logicOperator;
        if (logicOperator === (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).And) {
            const passesAllFilters = cleanedFilterItems.every(filterItemPredicate);
            if (!passesAllFilters) return false;
        } else {
            const passesSomeFilters = cleanedFilterItems.some(filterItemPredicate);
            if (!passesSomeFilters) return false;
        }
    }
    // get result for quick filter model
    if (cleanedQuickFilterResults.length > 0 && filterModel.quickFilterValues != null) {
        // Return true if the item pass with one of the rows
        const quickFilterValuePredicate = (value)=>{
            return cleanedQuickFilterResults.some((quickFilterValueResult)=>quickFilterValueResult[value]);
        };
        const quickFilterLogicOperator = filterModel.quickFilterLogicOperator ?? (0, $88b02358d3d53b62$export$7ea23129b8e10cdb)().quickFilterLogicOperator;
        if (quickFilterLogicOperator === (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).And) {
            const passesAllQuickFilterValues = filterModel.quickFilterValues.every(quickFilterValuePredicate);
            if (!passesAllQuickFilterValues) return false;
        } else {
            const passesSomeQuickFilterValues = filterModel.quickFilterValues.some(quickFilterValuePredicate);
            if (!passesSomeQuickFilterValues) return false;
        }
    }
    return true;
};


const $41ae14a3922ea4ea$export$4326c0ebf0c2f84b = (value)=>{
    if (!value) return null;
    const filterRegex = new RegExp((0, $ac3bd7253ec0e92a$export$7c57da42ce8e346f)(value), 'i');
    return (_, row, column, apiRef)=>{
        let columnValue = apiRef.current.getRowFormattedValue(row, column);
        if (apiRef.current.ignoreDiacritics) columnValue = (0, $bb45a78aee581510$export$626da389515c02b3)(columnValue);
        return columnValue != null ? filterRegex.test(columnValue.toString()) : false;
    };
};
const $41ae14a3922ea4ea$var$createContainsFilterFn = (disableTrim, negate)=>(filterItem)=>{
        if (!filterItem.value) return null;
        const trimmedValue = disableTrim ? filterItem.value : filterItem.value.trim();
        const filterRegex = new RegExp((0, $ac3bd7253ec0e92a$export$7c57da42ce8e346f)(trimmedValue), 'i');
        return (value)=>{
            if (value == null) return negate;
            const matches = filterRegex.test(String(value));
            return negate ? !matches : matches;
        };
    };
const $41ae14a3922ea4ea$var$createEqualityFilterFn = (disableTrim, negate)=>(filterItem)=>{
        if (!filterItem.value) return null;
        const trimmedValue = disableTrim ? filterItem.value : filterItem.value.trim();
        const collator = new Intl.Collator(undefined, {
            sensitivity: 'base',
            usage: 'search'
        });
        return (value)=>{
            if (value == null) return negate;
            const isEqual = collator.compare(trimmedValue, value.toString()) === 0;
            return negate ? !isEqual : isEqual;
        };
    };
const $41ae14a3922ea4ea$var$createEmptyFilterFn = (negate)=>()=>{
        return (value)=>{
            const isEmpty = value === '' || value == null;
            return negate ? !isEmpty : isEmpty;
        };
    };
const $41ae14a3922ea4ea$export$dff3a5bcde5c5e41 = (disableTrim = false)=>[
        {
            value: 'contains',
            getApplyFilterFn: $41ae14a3922ea4ea$var$createContainsFilterFn(disableTrim, false),
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3)
        },
        {
            value: 'doesNotContain',
            getApplyFilterFn: $41ae14a3922ea4ea$var$createContainsFilterFn(disableTrim, true),
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3)
        },
        {
            value: 'equals',
            getApplyFilterFn: $41ae14a3922ea4ea$var$createEqualityFilterFn(disableTrim, false),
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3)
        },
        {
            value: 'doesNotEqual',
            getApplyFilterFn: $41ae14a3922ea4ea$var$createEqualityFilterFn(disableTrim, true),
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3)
        },
        {
            value: 'startsWith',
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`^${(0, $ac3bd7253ec0e92a$export$7c57da42ce8e346f)(filterItemValue)}.*$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3)
        },
        {
            value: 'endsWith',
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`.*${(0, $ac3bd7253ec0e92a$export$7c57da42ce8e346f)(filterItemValue)}$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3)
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: $41ae14a3922ea4ea$var$createEmptyFilterFn(false),
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: $41ae14a3922ea4ea$var$createEmptyFilterFn(true),
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.map((val)=>val.trim());
                const collator = new Intl.Collator(undefined, {
                    sensitivity: 'base',
                    usage: 'search'
                });
                return (value)=>value != null ? filterItemValue.some((filterValue)=>{
                        return collator.compare(filterValue, value.toString() || '') === 0;
                    }) : false;
            },
            InputComponent: (0, $db0aedd8cebb17e4$export$fec959c3691e0645)
        }
    ];


const $97e794d7f4c0940d$export$db6fa9d0a45573e4 = {
    width: 100,
    minWidth: 50,
    maxWidth: Infinity,
    hideable: true,
    sortable: true,
    resizable: true,
    filterable: true,
    groupable: true,
    pinnable: true,
    // @ts-ignore
    aggregable: true,
    editable: false,
    sortComparator: (0, $840823b3251897df$export$db324d0b741f4529),
    type: 'string',
    align: 'left',
    filterOperators: (0, $41ae14a3922ea4ea$export$dff3a5bcde5c5e41)(),
    renderEditCell: (0, $f7ff56551dab4dc6$export$d1015f41e7e48c2e),
    getApplyQuickFilterFn: (0, $41ae14a3922ea4ea$export$4326c0ebf0c2f84b)
};







const $48484747d51dc856$var$parseNumericValue = (value)=>{
    if (value == null) return null;
    return Number(value);
};
const $48484747d51dc856$export$78c55b2f3096aac8 = (value)=>{
    if (value == null || Number.isNaN(value) || value === '') return null;
    return (columnValue)=>{
        return $48484747d51dc856$var$parseNumericValue(columnValue) === $48484747d51dc856$var$parseNumericValue(value);
    };
};
const $48484747d51dc856$export$37d963e5ee49abc6 = ()=>[
        {
            value: '=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $48484747d51dc856$var$parseNumericValue(value) === filterItem.value;
                };
            },
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '!=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $48484747d51dc856$var$parseNumericValue(value) !== filterItem.value;
                };
            },
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $48484747d51dc856$var$parseNumericValue(value) > filterItem.value;
                };
            },
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $48484747d51dc856$var$parseNumericValue(value) >= filterItem.value;
                };
            },
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $48484747d51dc856$var$parseNumericValue(value) < filterItem.value;
                };
            },
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $48484747d51dc856$var$parseNumericValue(value) <= filterItem.value;
                };
            },
            InputComponent: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                return (value)=>{
                    return value != null && filterItem.value.includes(Number(value));
                };
            },
            InputComponent: (0, $db0aedd8cebb17e4$export$fec959c3691e0645),
            InputComponentProps: {
                type: 'number'
            }
        }
    ];



const $fbfc6247b5d26526$export$ba08f73736670f91 = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4), {
    type: 'number',
    align: 'right',
    headerAlign: 'right',
    sortComparator: (0, $840823b3251897df$export$ecfdaa3722003888),
    valueParser: (value)=>value === '' ? null : Number(value),
    valueFormatter: (value)=>(0, $ac3bd7253ec0e92a$export$7e4aa119212bc614)(value) ? value.toLocaleString() : value || '',
    filterOperators: (0, $48484747d51dc856$export$37d963e5ee49abc6)(),
    getApplyQuickFilterFn: (0, $48484747d51dc856$export$78c55b2f3096aac8)
});







var $lCzvA = parcelRequire("lCzvA");





const $2598061dcf03cb39$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "InputProps",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "disabled"
];
function $2598061dcf03cb39$var$convertFilterItemValueToInputValue(itemValue, inputType) {
    if (itemValue == null) return '';
    const dateCopy = new Date(itemValue);
    if (Number.isNaN(dateCopy.getTime())) return '';
    if (inputType === 'date') return dateCopy.toISOString().substring(0, 10);
    if (inputType === 'datetime-local') {
        // The date picker expects the date to be in the local timezone.
        // But .toISOString() converts it to UTC with zero offset.
        // So we need to subtract the timezone offset.
        dateCopy.setMinutes(dateCopy.getMinutes() - dateCopy.getTimezoneOffset());
        return dateCopy.toISOString().substring(0, 19);
    }
    return dateCopy.toISOString().substring(0, 10);
}
function $2598061dcf03cb39$export$f82b14e11ca0a1b4(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, InputProps: InputProps, clearButton: clearButton, tabIndex: tabIndex, disabled: disabled } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $2598061dcf03cb39$var$_excluded);
    const filterTimeout = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const [filterValueState, setFilterValueState] = $lCzvA.useState(()=>$2598061dcf03cb39$var$convertFilterItemValueToInputValue(item.value, type));
    const [applying, setIsApplying] = $lCzvA.useState(false);
    const id = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const onFilterChange = $lCzvA.useCallback((event)=>{
        filterTimeout.clear();
        const value = event.target.value;
        setFilterValueState(value);
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const date = new Date(value);
            applyValue((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, item, {
                value: Number.isNaN(date.getTime()) ? undefined : date
            }));
            setIsApplying(false);
        });
    }, [
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    $lCzvA.useEffect(()=>{
        const value = $2598061dcf03cb39$var$convertFilterItemValueToInputValue(item.value, type);
        setFilterValueState(value);
    }, [
        item.value,
        type
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseTextField, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        fullWidth: true,
        id: id,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        type: type || 'text',
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef,
        InputProps: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled: disabled
        }, InputProps, {
            inputProps: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                max: type === 'datetime-local' ? '9999-12-31T23:59' : '9999-12-31',
                tabIndex: tabIndex
            }, InputProps?.inputProps)
        })
    }, other, rootProps.slotProps?.baseTextField));
}


function $3acb311e3a5aa24a$var$buildApplyFilterFn(filterItem, compareFn, showTime, keepHours) {
    if (!filterItem.value) return null;
    const date = new Date(filterItem.value);
    if (showTime) date.setSeconds(0, 0);
    else {
        // In GMT-X timezone, the date will be one day behind.
        // For 2022-08-16:
        // GMT+2: Tue Aug 16 2022 02:00:00 GMT+0200
        // GMT-4: Mon Aug 15 2022 20:00:00 GMT-0400
        //
        // We need to add the offset before resetting the hours.
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        date.setHours(0, 0, 0, 0);
    }
    const time = date.getTime();
    return (value)=>{
        if (!value) return false;
        if (keepHours) return compareFn(value.getTime(), time);
        // Make a copy of the date to not reset the hours in the original object
        const dateCopy = new Date(value);
        if (showTime) dateCopy.setSeconds(0, 0);
        else dateCopy.setHours(0, 0, 0, 0);
        return compareFn(dateCopy.getTime(), time);
    };
}
const $3acb311e3a5aa24a$export$2fa54515db89172d = (showTime)=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                return $3acb311e3a5aa24a$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 === value2, showTime);
            },
            InputComponent: (0, $2598061dcf03cb39$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'not',
            getApplyFilterFn: (filterItem)=>{
                return $3acb311e3a5aa24a$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 !== value2, showTime);
            },
            InputComponent: (0, $2598061dcf03cb39$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'after',
            getApplyFilterFn: (filterItem)=>{
                return $3acb311e3a5aa24a$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 > value2, showTime);
            },
            InputComponent: (0, $2598061dcf03cb39$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrAfter',
            getApplyFilterFn: (filterItem)=>{
                return $3acb311e3a5aa24a$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 >= value2, showTime);
            },
            InputComponent: (0, $2598061dcf03cb39$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'before',
            getApplyFilterFn: (filterItem)=>{
                return $3acb311e3a5aa24a$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 < value2, showTime, !showTime);
            },
            InputComponent: (0, $2598061dcf03cb39$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrBefore',
            getApplyFilterFn: (filterItem)=>{
                return $3acb311e3a5aa24a$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 <= value2, showTime);
            },
            InputComponent: (0, $2598061dcf03cb39$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        }
    ];






var $lCzvA = parcelRequire("lCzvA");








const $56968fcf259e6e92$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "inputProps",
    "isValidating",
    "isProcessingProps",
    "onValueChange"
];
const $56968fcf259e6e92$var$StyledInputBase = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $92d8fc367f7e2f74$export$2e2bcd8739ae039))({
    fontSize: 'inherit'
});
const $56968fcf259e6e92$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $56968fcf259e6e92$export$b4fb7433f4444e3f(props) {
    const { id: id, value: valueProp, field: field, colDef: colDef, hasFocus: hasFocus, inputProps: inputProps, onValueChange: onValueChange } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $56968fcf259e6e92$var$_excluded);
    const isDateTime = colDef.type === 'dateTime';
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const inputRef = $lCzvA.useRef(null);
    const valueTransformed = $lCzvA.useMemo(()=>{
        let parsedDate;
        if (valueProp == null) parsedDate = null;
        else if (valueProp instanceof Date) parsedDate = valueProp;
        else parsedDate = new Date((valueProp ?? '').toString());
        let formattedDate;
        if (parsedDate == null || Number.isNaN(parsedDate.getTime())) formattedDate = '';
        else {
            const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
            formattedDate = localDate.toISOString().substr(0, isDateTime ? 16 : 10);
        }
        return {
            parsed: parsedDate,
            formatted: formattedDate
        };
    }, [
        valueProp,
        isDateTime
    ]);
    const [valueState, setValueState] = $lCzvA.useState(valueTransformed);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $56968fcf259e6e92$var$useUtilityClasses(ownerState);
    const parseValueToDate = $lCzvA.useCallback((value)=>{
        if (value === '') return null;
        const [date, time] = value.split('T');
        const [year, month, day] = date.split('-');
        const parsedDate = new Date();
        parsedDate.setFullYear(Number(year), Number(month) - 1, Number(day));
        parsedDate.setHours(0, 0, 0, 0);
        if (time) {
            const [hours, minutes] = time.split(':');
            parsedDate.setHours(Number(hours), Number(minutes), 0, 0);
        }
        return parsedDate;
    }, []);
    const handleChange = $lCzvA.useCallback(async (event)=>{
        const newFormattedDate = event.target.value;
        const newParsedDate = parseValueToDate(newFormattedDate);
        if (onValueChange) await onValueChange(event, newParsedDate);
        setValueState({
            parsed: newParsedDate,
            formatted: newFormattedDate
        });
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: newParsedDate
        }, event);
    }, [
        apiRef,
        field,
        id,
        onValueChange,
        parseValueToDate
    ]);
    $lCzvA.useEffect(()=>{
        setValueState((state)=>{
            if (valueTransformed.parsed !== state.parsed && valueTransformed.parsed?.getTime() !== state.parsed?.getTime()) return valueTransformed;
            return state;
        });
    }, [
        valueTransformed
    ]);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($56968fcf259e6e92$var$StyledInputBase, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        inputRef: inputRef,
        fullWidth: true,
        className: classes.root,
        type: isDateTime ? 'datetime-local' : 'date',
        inputProps: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            max: isDateTime ? '9999-12-31T23:59' : '9999-12-31'
        }, inputProps),
        value: valueState.formatted,
        onChange: handleChange
    }, other));
}
const $56968fcf259e6e92$export$b815d37f7a90225c = (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($56968fcf259e6e92$export$b4fb7433f4444e3f, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params));



const $dc4fe3453cdb0a0a$export$433b924dc2506913 = `auto-generated-group-node-root`;
const $dc4fe3453cdb0a0a$export$e8632b32bb8837db = Symbol('mui.id_autogenerated');
const $dc4fe3453cdb0a0a$export$96a607054e9bfd0c = ()=>({
        type: 'group',
        id: $dc4fe3453cdb0a0a$export$433b924dc2506913,
        depth: -1,
        groupingField: null,
        groupingKey: null,
        isAutoGenerated: true,
        children: [],
        childrenFromPath: {},
        childrenExpanded: true,
        parent: null
    });
function $dc4fe3453cdb0a0a$export$de0419c0281531ca(id, row, detailErrorMessage = 'A row was provided without id in the rows prop:') {
    if (id == null) throw new Error([
        'MUI X: The Data Grid component requires all rows to have a unique `id` property.',
        'Alternatively, you can use the `getRowId` prop to specify a custom id for each row.',
        detailErrorMessage,
        JSON.stringify(row)
    ].join('\n'));
}
const $dc4fe3453cdb0a0a$export$a95fb784d0ca2e72 = (rowModel, getRowId, detailErrorMessage)=>{
    const id = getRowId ? getRowId(rowModel) : rowModel.id;
    $dc4fe3453cdb0a0a$export$de0419c0281531ca(id, rowModel, detailErrorMessage);
    return id;
};
const $dc4fe3453cdb0a0a$export$3496927f169f2d35 = ({ rows: rows, getRowId: getRowId, loading: loading, rowCount: rowCount })=>{
    const updates = {
        type: 'full',
        rows: []
    };
    const dataRowIdToModelLookup = {};
    const dataRowIdToIdLookup = {};
    for(let i = 0; i < rows.length; i += 1){
        const model = rows[i];
        const id = $dc4fe3453cdb0a0a$export$a95fb784d0ca2e72(model, getRowId);
        dataRowIdToModelLookup[id] = model;
        dataRowIdToIdLookup[id] = id;
        updates.rows.push(id);
    }
    return {
        rowsBeforePartialUpdates: rows,
        loadingPropBeforePartialUpdates: loading,
        rowCountPropBeforePartialUpdates: rowCount,
        updates: updates,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        dataRowIdToModelLookup: dataRowIdToModelLookup
    };
};
const $dc4fe3453cdb0a0a$export$e6ee03f0394a9759 = ({ tree: tree, rowCountProp: rowCountProp = 0 })=>{
    const rootGroupNode = tree[$dc4fe3453cdb0a0a$export$433b924dc2506913];
    return Math.max(rowCountProp, rootGroupNode.children.length + (rootGroupNode.footerId == null ? 0 : 1));
};
const $dc4fe3453cdb0a0a$export$4dcb6d8dd06e4f39 = ({ apiRef: apiRef, rowCountProp: rowCountProp = 0, loadingProp: loadingProp, previousTree: previousTree, previousTreeDepths: previousTreeDepths, previousGroupsToFetch: previousGroupsToFetch })=>{
    const cache = apiRef.current.caches.rows;
    // 1. Apply the "rowTreeCreation" family processing.
    const { tree: unProcessedTree, treeDepths: unProcessedTreeDepths, dataRowIds: unProcessedDataRowIds, groupingName: groupingName, groupsToFetch: groupsToFetch = [] } = apiRef.current.applyStrategyProcessor('rowTreeCreation', {
        previousTree: previousTree,
        previousTreeDepths: previousTreeDepths,
        updates: cache.updates,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup,
        previousGroupsToFetch: previousGroupsToFetch
    });
    // 2. Apply the "hydrateRows" pipe-processing.
    const groupingParamsWithHydrateRows = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
        tree: unProcessedTree,
        treeDepths: unProcessedTreeDepths,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIds: unProcessedDataRowIds,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    // 3. Reset the cache updates
    apiRef.current.caches.rows.updates = {
        type: 'partial',
        actions: {
            insert: [],
            modify: [],
            remove: []
        },
        idToActionLookup: {}
    };
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParamsWithHydrateRows, {
        totalRowCount: Math.max(rowCountProp, groupingParamsWithHydrateRows.dataRowIds.length),
        totalTopLevelRowCount: $dc4fe3453cdb0a0a$export$e6ee03f0394a9759({
            tree: groupingParamsWithHydrateRows.tree,
            rowCountProp: rowCountProp
        }),
        groupingName: groupingName,
        loading: loadingProp,
        groupsToFetch: groupsToFetch
    });
};
const $dc4fe3453cdb0a0a$export$fe02ef72917d9a07 = (row)=>$dc4fe3453cdb0a0a$export$e8632b32bb8837db in row;
const $dc4fe3453cdb0a0a$export$5f983e16b1e55860 = (rowNode)=>rowNode.type === 'skeletonRow' || rowNode.type === 'footer' || rowNode.type === 'group' && rowNode.isAutoGenerated || rowNode.type === 'pinnedRow' && rowNode.isAutoGenerated;
const $dc4fe3453cdb0a0a$export$9380f4bcafb87e49 = (tree, parentId, skipAutoGeneratedRows)=>{
    const node = tree[parentId];
    if (node.type !== 'group') return [];
    const validDescendants = [];
    for(let i = 0; i < node.children.length; i += 1){
        const child = node.children[i];
        if (!skipAutoGeneratedRows || !$dc4fe3453cdb0a0a$export$5f983e16b1e55860(tree[child])) validDescendants.push(child);
        const childDescendants = $dc4fe3453cdb0a0a$export$9380f4bcafb87e49(tree, child, skipAutoGeneratedRows);
        for(let j = 0; j < childDescendants.length; j += 1)validDescendants.push(childDescendants[j]);
    }
    if (!skipAutoGeneratedRows && node.footerId != null) validDescendants.push(node.footerId);
    return validDescendants;
};
const $dc4fe3453cdb0a0a$export$b593607f8b00d104 = ({ previousCache: previousCache, getRowId: getRowId, updates: updates, groupKeys: groupKeys })=>{
    if (previousCache.updates.type === 'full') throw new Error('MUI X: Unable to prepare a partial update if a full update is not applied yet.');
    // Remove duplicate updates.
    // A server can batch updates, and send several updates for the same row in one fn call.
    const uniqueUpdates = new Map();
    updates.forEach((update)=>{
        const id = $dc4fe3453cdb0a0a$export$a95fb784d0ca2e72(update, getRowId, 'A row was provided without id when calling updateRows():');
        if (uniqueUpdates.has(id)) uniqueUpdates.set(id, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, uniqueUpdates.get(id), update));
        else uniqueUpdates.set(id, update);
    });
    const partialUpdates = {
        type: 'partial',
        actions: {
            insert: [
                ...previousCache.updates.actions.insert ?? []
            ],
            modify: [
                ...previousCache.updates.actions.modify ?? []
            ],
            remove: [
                ...previousCache.updates.actions.remove ?? []
            ]
        },
        idToActionLookup: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, previousCache.updates.idToActionLookup),
        groupKeys: groupKeys
    };
    const dataRowIdToModelLookup = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, previousCache.dataRowIdToModelLookup);
    const dataRowIdToIdLookup = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, previousCache.dataRowIdToIdLookup);
    const alreadyAppliedActionsToRemove = {
        insert: {},
        modify: {},
        remove: {}
    };
    // Depending on the action already applied to the data row,
    // We might want drop the already-applied-update.
    // For instance:
    // - if you delete then insert, then you don't want to apply the deletion in the tree.
    // - if you insert, then modify, then you just want to apply the insertion in the tree.
    uniqueUpdates.forEach((partialRow, id)=>{
        const actionAlreadyAppliedToRow = partialUpdates.idToActionLookup[id];
        // Action === "delete"
        // eslint-disable-next-line no-underscore-dangle
        if (partialRow._action === 'delete') {
            // If the data row has been removed since the last state update,
            // Then do nothing.
            if (actionAlreadyAppliedToRow === 'remove' || !dataRowIdToModelLookup[id]) return;
            // If the data row has been inserted / modified since the last state update,
            // Then drop this "insert" / "modify" update.
            if (actionAlreadyAppliedToRow != null) alreadyAppliedActionsToRemove[actionAlreadyAppliedToRow][id] = true;
            // Remove the data row from the lookups and add it to the "delete" update.
            partialUpdates.actions.remove.push(id);
            delete dataRowIdToModelLookup[id];
            delete dataRowIdToIdLookup[id];
            return;
        }
        const oldRow = dataRowIdToModelLookup[id];
        // Action === "modify"
        if (oldRow) {
            // If the data row has been removed since the last state update,
            // Then drop this "remove" update and add it to the "modify" update instead.
            if (actionAlreadyAppliedToRow === 'remove') {
                alreadyAppliedActionsToRemove.remove[id] = true;
                partialUpdates.actions.modify.push(id);
            } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.modify.push(id);
            // Update the data row lookups.
            dataRowIdToModelLookup[id] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, oldRow, partialRow);
            return;
        }
        // Action === "insert"
        // If the data row has been removed since the last state update,
        // Then drop the "remove" update and add it to the "insert" update instead.
        if (actionAlreadyAppliedToRow === 'remove') {
            alreadyAppliedActionsToRemove.remove[id] = true;
            partialUpdates.actions.insert.push(id);
        } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.insert.push(id);
        // Update the data row lookups.
        dataRowIdToModelLookup[id] = partialRow;
        dataRowIdToIdLookup[id] = id;
    });
    const actionTypeWithActionsToRemove = Object.keys(alreadyAppliedActionsToRemove);
    for(let i = 0; i < actionTypeWithActionsToRemove.length; i += 1){
        const actionType = actionTypeWithActionsToRemove[i];
        const idsToRemove = alreadyAppliedActionsToRemove[actionType];
        if (Object.keys(idsToRemove).length > 0) partialUpdates.actions[actionType] = partialUpdates.actions[actionType].filter((id)=>!idsToRemove[id]);
    }
    return {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        updates: partialUpdates,
        rowsBeforePartialUpdates: previousCache.rowsBeforePartialUpdates,
        loadingPropBeforePartialUpdates: previousCache.loadingPropBeforePartialUpdates,
        rowCountPropBeforePartialUpdates: previousCache.rowCountPropBeforePartialUpdates
    };
};
const $dc4fe3453cdb0a0a$export$a95780409968416e = 'var(--DataGrid-overlayHeight, calc(var(--height) * 2))';
function $dc4fe3453cdb0a0a$export$1560eaf12ed72130(apiRef, updates, getRowId) {
    const nonPinnedRowsUpdates = [];
    updates.forEach((update)=>{
        const id = $dc4fe3453cdb0a0a$export$a95fb784d0ca2e72(update, getRowId, 'A row was provided without id when calling updateRows():');
        const rowNode = apiRef.current.getRowNode(id);
        if (rowNode?.type === 'pinnedRow') {
            // @ts-ignore because otherwise `release:build` doesn't work
            const pinnedRowsCache = apiRef.current.caches.pinnedRows;
            const prevModel = pinnedRowsCache.idLookup[id];
            if (prevModel) pinnedRowsCache.idLookup[id] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevModel, update);
        } else nonPinnedRowsUpdates.push(update);
    });
    return nonPinnedRowsUpdates;
}
let $dc4fe3453cdb0a0a$var$warnedOnceInvalidRowHeight = false;
const $dc4fe3453cdb0a0a$export$fa15c17c0798a441 = (rowHeightProp, defaultRowHeight, warningMessage)=>{
    if (typeof rowHeightProp === 'number' && rowHeightProp > 0) return rowHeightProp;
    return defaultRowHeight;
};
const $dc4fe3453cdb0a0a$export$abf6a2a1a7dde56b = [
    `MUI X: The \`rowHeight\` prop should be a number greater than 0.`,
    `The default value will be used instead.`
].join('\n');
const $dc4fe3453cdb0a0a$export$b35665e48a78b958 = [
    `MUI X: The \`getRowHeight\` prop should return a number greater than 0 or 'auto'.`,
    `The default value will be used instead.`
].join('\n');


const $c0782207122e35d1$export$5e766ecd73f055ed = (state, row)=>{
    if ((0, $dc4fe3453cdb0a0a$export$e8632b32bb8837db) in row) return row[0, $dc4fe3453cdb0a0a$export$e8632b32bb8837db];
    return state.props.getRowId ? state.props.getRowId(row) : row.id;
};


function $fa325af4626674ec$var$throwIfNotDateObject({ value: value, columnType: columnType, rowId: rowId, field: field }) {
    if (!(value instanceof Date)) throw new Error([
        `MUI X: \`${columnType}\` column type only accepts \`Date\` objects as values.`,
        'Use `valueGetter` to transform the value into a `Date` object.',
        `Row ID: ${rowId}, field: "${field}".`
    ].join('\n'));
}
const $fa325af4626674ec$export$c46cd449e66842a5 = (value, row, column, apiRef)=>{
    if (!value) return '';
    const rowId = (0, $c0782207122e35d1$export$5e766ecd73f055ed)(apiRef.current.state, row);
    $fa325af4626674ec$var$throwIfNotDateObject({
        value: value,
        columnType: 'date',
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleDateString();
};
const $fa325af4626674ec$export$a62990620750ce8c = (value, row, column, apiRef)=>{
    if (!value) return '';
    const rowId = (0, $c0782207122e35d1$export$5e766ecd73f055ed)(apiRef.current.state, row);
    $fa325af4626674ec$var$throwIfNotDateObject({
        value: value,
        columnType: 'dateTime',
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleString();
};
const $fa325af4626674ec$export$4c3b89749ea40e50 = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4), {
    type: 'date',
    sortComparator: (0, $840823b3251897df$export$74e685f55e96d6bc),
    valueFormatter: $fa325af4626674ec$export$c46cd449e66842a5,
    filterOperators: (0, $3acb311e3a5aa24a$export$2fa54515db89172d)(),
    renderEditCell: (0, $56968fcf259e6e92$export$b815d37f7a90225c),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});
const $fa325af4626674ec$export$5bc7079eed6f3d7f = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4), {
    type: 'dateTime',
    sortComparator: (0, $840823b3251897df$export$74e685f55e96d6bc),
    valueFormatter: $fa325af4626674ec$export$a62990620750ce8c,
    filterOperators: (0, $3acb311e3a5aa24a$export$2fa54515db89172d)(true),
    renderEditCell: (0, $56968fcf259e6e92$export$b815d37f7a90225c),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});







var $lCzvA = parcelRequire("lCzvA");








const $3cb6fcdeb46bf88d$export$9cce4aaa860dd90a = '__tree_data_group__';
const $3cb6fcdeb46bf88d$export$bc5b5ba34587442e = '__row_group_by_columns_group__';
const $3cb6fcdeb46bf88d$export$6e5a576305a34719 = '__detail_panel_toggle__';
let $3cb6fcdeb46bf88d$export$f35946017bbd5a24 = /*#__PURE__*/ function(PinnedColumnPosition) {
    PinnedColumnPosition[PinnedColumnPosition["NONE"] = 0] = "NONE";
    PinnedColumnPosition[PinnedColumnPosition["LEFT"] = 1] = "LEFT";
    PinnedColumnPosition[PinnedColumnPosition["RIGHT"] = 2] = "RIGHT";
    PinnedColumnPosition[PinnedColumnPosition["VIRTUAL"] = 3] = "VIRTUAL";
    return PinnedColumnPosition;
}({});



const $76d433d7676d4289$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "hasFocus",
    "tabIndex",
    "hideDescendantCount"
];
const $76d433d7676d4289$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'booleanCell'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $76d433d7676d4289$var$GridBooleanCellRaw(props) {
    const { value: value, rowNode: rowNode } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $76d433d7676d4289$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $76d433d7676d4289$var$useUtilityClasses(ownerState);
    const maxDepth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$4cdbe576751dd8e2));
    const isServerSideRowGroupingRow = // @ts-expect-error - Access tree data prop
    maxDepth > 0 && rowNode.type === 'group' && rootProps.treeData === false;
    const Icon = $lCzvA.useMemo(()=>value ? rootProps.slots.booleanCellTrueIcon : rootProps.slots.booleanCellFalseIcon, [
        rootProps.slots.booleanCellFalseIcon,
        rootProps.slots.booleanCellTrueIcon,
        value
    ]);
    if (isServerSideRowGroupingRow && value === undefined) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Icon, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        fontSize: "small",
        className: classes.root,
        titleAccess: apiRef.current.getLocaleText(value ? 'booleanCellTrueLabel' : 'booleanCellFalseLabel'),
        "data-value": Boolean(value)
    }, other));
}
const $76d433d7676d4289$export$9cc4d0e939884340 = /*#__PURE__*/ $lCzvA.memo($76d433d7676d4289$var$GridBooleanCellRaw);
const $76d433d7676d4289$export$6c5a2392a8d4c6d6 = (params)=>{
    if (params.field !== (0, $3cb6fcdeb46bf88d$export$bc5b5ba34587442e) && (0, $dc4fe3453cdb0a0a$export$5f983e16b1e55860)(params.rowNode)) return '';
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($76d433d7676d4289$export$9cc4d0e939884340, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params));
};





var $lCzvA = parcelRequire("lCzvA");







const $d631ece2095f7ce4$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange"
];
const $d631ece2095f7ce4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editBooleanCell'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $d631ece2095f7ce4$export$22bee653ea92336f(props) {
    const { id: idProp, value: value, field: field, className: className, hasFocus: hasFocus, onValueChange: onValueChange } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $d631ece2095f7ce4$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const inputRef = $lCzvA.useRef(null);
    const id = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const [valueState, setValueState] = $lCzvA.useState(value);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $d631ece2095f7ce4$var$useUtilityClasses(ownerState);
    const handleChange = $lCzvA.useCallback(async (event)=>{
        const newValue = event.target.checked;
        if (onValueChange) await onValueChange(event, newValue);
        setValueState(newValue);
        await apiRef.current.setEditCellValue({
            id: idProp,
            field: field,
            value: newValue
        }, event);
    }, [
        apiRef,
        field,
        idProp,
        onValueChange
    ]);
    $lCzvA.useEffect(()=>{
        setValueState(value);
    }, [
        value
    ]);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("label", (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        htmlFor: id,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseCheckbox, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            id: id,
            inputRef: inputRef,
            checked: Boolean(valueState),
            onChange: handleChange,
            size: "small"
        }, rootProps.slotProps?.baseCheckbox))
    }));
}
const $d631ece2095f7ce4$export$9ef52be99fb661 = (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d631ece2095f7ce4$export$22bee653ea92336f, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params));






var $lCzvA = parcelRequire("lCzvA");





const $2e7152d572a591e3$var$_excluded = [
    "item",
    "applyValue",
    "apiRef",
    "focusElementRef",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "label",
    "variant",
    "InputLabelProps"
];
const $2e7152d572a591e3$export$ed06ceaa973db73f = (value)=>{
    if (String(value).toLowerCase() === 'true') return true;
    if (String(value).toLowerCase() === 'false') return false;
    return undefined;
};
const $2e7152d572a591e3$var$BooleanOperatorContainer = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div')({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    [`& button`]: {
        margin: 'auto 0px 5px 5px'
    }
});
function $2e7152d572a591e3$export$f1030df85ee00af9(props) {
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, clearButton: clearButton, tabIndex: tabIndex, label: labelProp, variant: variant = 'standard' } = props, others = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $2e7152d572a591e3$var$_excluded);
    const [filterValueState, setFilterValueState] = $lCzvA.useState($2e7152d572a591e3$export$ed06ceaa973db73f(item.value));
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const labelId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const selectId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const onFilterChange = $lCzvA.useCallback((event)=>{
        const value = $2e7152d572a591e3$export$ed06ceaa973db73f(event.target.value);
        setFilterValueState(value);
        applyValue((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, item, {
            value: value
        }));
    }, [
        applyValue,
        item
    ]);
    $lCzvA.useEffect(()=>{
        setFilterValueState($2e7152d572a591e3$export$ed06ceaa973db73f(item.value));
    }, [
        item.value
    ]);
    const label = labelProp ?? apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($2e7152d572a591e3$var$BooleanOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(rootProps.slots.baseFormControl, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseInputLabel, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseInputLabel, {
                        id: labelId,
                        shrink: true,
                        variant: variant,
                        children: label
                    })),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(rootProps.slots.baseSelect, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                        labelId: labelId,
                        id: selectId,
                        label: label,
                        value: filterValueState === undefined ? '' : String(filterValueState),
                        onChange: onFilterChange,
                        variant: variant,
                        notched: variant === 'outlined' ? true : undefined,
                        native: isSelectNative,
                        displayEmpty: true,
                        inputProps: {
                            ref: focusElementRef,
                            tabIndex: tabIndex
                        }
                    }, others /* FIXME: typing error */ , baseSelectProps, {
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseSelectOption, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "",
                                children: apiRef.current.getLocaleText('filterValueAny')
                            })),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseSelectOption, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "true",
                                children: apiRef.current.getLocaleText('filterValueTrue')
                            })),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseSelectOption, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "false",
                                children: apiRef.current.getLocaleText('filterValueFalse')
                            }))
                        ]
                    }))
                ]
            }),
            clearButton
        ]
    });
}


const $39b30cf2380c02b5$export$906a46f6c2359ef6 = ()=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                const sanitizedValue = (0, $2e7152d572a591e3$export$ed06ceaa973db73f)(filterItem.value);
                if (sanitizedValue === undefined) return null;
                return (value)=>Boolean(value) === sanitizedValue;
            },
            InputComponent: (0, $2e7152d572a591e3$export$f1030df85ee00af9)
        }
    ];


const $c7df02efbbf7aa77$var$gridBooleanFormatter = (value, row, column, apiRef)=>{
    return value ? apiRef.current.getLocaleText('booleanCellTrueLabel') : apiRef.current.getLocaleText('booleanCellFalseLabel');
};
const $c7df02efbbf7aa77$var$stringToBoolean = (value)=>{
    switch(value.toLowerCase().trim()){
        case 'true':
        case 'yes':
        case '1':
            return true;
        case 'false':
        case 'no':
        case '0':
        case 'null':
        case 'undefined':
            return false;
        default:
            return undefined;
    }
};
const $c7df02efbbf7aa77$export$220b51460e149ea9 = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4), {
    type: 'boolean',
    display: 'flex',
    align: 'center',
    headerAlign: 'center',
    renderCell: (0, $76d433d7676d4289$export$6c5a2392a8d4c6d6),
    renderEditCell: (0, $d631ece2095f7ce4$export$9ef52be99fb661),
    sortComparator: (0, $840823b3251897df$export$ecfdaa3722003888),
    valueFormatter: $c7df02efbbf7aa77$var$gridBooleanFormatter,
    filterOperators: (0, $39b30cf2380c02b5$export$906a46f6c2359ef6)(),
    getApplyQuickFilterFn: undefined,
    // @ts-ignore
    aggregable: false,
    // @ts-ignore
    pastedValueParser: (value)=>$c7df02efbbf7aa77$var$stringToBoolean(value)
});







var $lCzvA = parcelRequire("lCzvA");


/**
 * Params passed to `apiRef.current.setEditCellValue`.
 */ var $623366e440a86fa6$export$66744c3b0d0c6217 = /*#__PURE__*/ function(GridCellEditStartReasons) {
    GridCellEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridCellEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridCellEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    GridCellEditStartReasons["pasteKeyDown"] = "pasteKeyDown";
    return GridCellEditStartReasons;
}($623366e440a86fa6$export$66744c3b0d0c6217 || {});
/**
 * Params passed to the `cellEditStart` event.
 */ var $623366e440a86fa6$export$73fccbaa325472ee = /*#__PURE__*/ function(GridCellEditStopReasons) {
    GridCellEditStopReasons["cellFocusOut"] = "cellFocusOut";
    GridCellEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridCellEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridCellEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridCellEditStopReasons;
}($623366e440a86fa6$export$73fccbaa325472ee || {});



var $a01f6e6f52a2f91e$export$bad6b7a934346f26 = /*#__PURE__*/ function(GridEditModes) {
    GridEditModes["Cell"] = "cell";
    GridEditModes["Row"] = "row";
    return GridEditModes;
}($a01f6e6f52a2f91e$export$bad6b7a934346f26 || {});
var $a01f6e6f52a2f91e$export$84e4fdd8f295ca31 = /*#__PURE__*/ function(GridCellModes) {
    GridCellModes["Edit"] = "edit";
    GridCellModes["View"] = "view";
    return GridCellModes;
}($a01f6e6f52a2f91e$export$84e4fdd8f295ca31 || {});
var $a01f6e6f52a2f91e$export$d98c76b959bb0b5c = /*#__PURE__*/ function(GridRowModes) {
    GridRowModes["Edit"] = "edit";
    GridRowModes["View"] = "view";
    return GridRowModes;
}($a01f6e6f52a2f91e$export$d98c76b959bb0b5c || {});



function $8f437360f253bfb4$export$74006a51f68c6262(colDef) {
    return colDef?.type === 'singleSelect';
}
function $8f437360f253bfb4$export$b871910a1101d890(column, additionalParams) {
    if (!column) return undefined;
    return typeof column.valueOptions === 'function' ? column.valueOptions((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        field: column.field
    }, additionalParams)) : column.valueOptions;
}
function $8f437360f253bfb4$export$b31a7985e33f7505(value, valueOptions, getOptionValue) {
    if (valueOptions === undefined) return undefined;
    const result = valueOptions.find((option)=>{
        const optionValue = getOptionValue(option);
        return String(optionValue) === String(value);
    });
    return getOptionValue(result);
}




const $c67eb3eea8d0854c$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange",
    "initialOpen"
], $c67eb3eea8d0854c$var$_excluded2 = [
    "MenuProps"
];
function $c67eb3eea8d0854c$var$isKeyboardEvent(event) {
    return !!event.key;
}
function $c67eb3eea8d0854c$export$df7446df636ddbed(props) {
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const { id: id, value: valueProp, field: field, row: row, colDef: colDef, hasFocus: hasFocus, error: error, onValueChange: onValueChange, initialOpen: initialOpen = rootProps.editMode === (0, $a01f6e6f52a2f91e$export$bad6b7a934346f26).Cell } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $c67eb3eea8d0854c$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const ref = $lCzvA.useRef(null);
    const inputRef = $lCzvA.useRef(null);
    const [open, setOpen] = $lCzvA.useState(initialOpen);
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    const _ref = rootProps.slotProps?.baseSelect || {}, { MenuProps: MenuProps } = _ref, otherBaseSelectProps = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_ref, $c67eb3eea8d0854c$var$_excluded2);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current?.focus();
    }, [
        hasFocus
    ]);
    if (!(0, $8f437360f253bfb4$export$74006a51f68c6262)(colDef)) return null;
    const valueOptions = (0, $8f437360f253bfb4$export$b871910a1101d890)(colDef, {
        id: id,
        row: row
    });
    if (!valueOptions) return null;
    const getOptionValue = colDef.getOptionValue;
    const getOptionLabel = colDef.getOptionLabel;
    const handleChange = async (event)=>{
        if (!(0, $8f437360f253bfb4$export$74006a51f68c6262)(colDef) || !valueOptions) return;
        setOpen(false);
        const target = event.target;
        // NativeSelect casts the value to a string.
        const formattedTargetValue = (0, $8f437360f253bfb4$export$b31a7985e33f7505)(target.value, valueOptions, getOptionValue);
        if (onValueChange) await onValueChange(event, formattedTargetValue);
        await apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: formattedTargetValue
        }, event);
    };
    const handleClose = (event, reason)=>{
        if (rootProps.editMode === (0, $a01f6e6f52a2f91e$export$bad6b7a934346f26).Row) {
            setOpen(false);
            return;
        }
        if (reason === 'backdropClick' || event.key === 'Escape') {
            const params = apiRef.current.getCellParams(id, field);
            apiRef.current.publishEvent('cellEditStop', (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params, {
                reason: event.key === 'Escape' ? (0, $623366e440a86fa6$export$73fccbaa325472ee).escapeKeyDown : (0, $623366e440a86fa6$export$73fccbaa325472ee).cellFocusOut
            }));
        }
    };
    const handleOpen = (event)=>{
        if ($c67eb3eea8d0854c$var$isKeyboardEvent(event) && event.key === 'Enter') return;
        setOpen(true);
    };
    if (!valueOptions || !colDef) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseSelect, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        ref: ref,
        inputRef: inputRef,
        value: valueProp,
        onChange: handleChange,
        open: open,
        onOpen: handleOpen,
        MenuProps: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            onClose: handleClose
        }, MenuProps),
        error: error,
        native: isSelectNative,
        fullWidth: true
    }, other, otherBaseSelectProps, {
        children: valueOptions.map((valueOption)=>{
            const value = getOptionValue(valueOption);
            return /*#__PURE__*/ (0, $lCzvA.createElement)(rootProps.slots.baseSelectOption, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseSelectOption || {}, {
                native: isSelectNative,
                key: value,
                value: value
            }), getOptionLabel(valueOption));
        })
    }));
}
const $c67eb3eea8d0854c$export$13060fab7d49b7a1 = (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($c67eb3eea8d0854c$export$df7446df636ddbed, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params));





var $lCzvA = parcelRequire("lCzvA");






const $e04d221b2cfecedf$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "placeholder",
    "tabIndex",
    "label",
    "variant",
    "isFilterActive",
    "clearButton",
    "InputLabelProps"
];
const $e04d221b2cfecedf$var$renderSingleSelectOptions = ({ column: column, OptionComponent: OptionComponent, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, isSelectNative: isSelectNative, baseSelectOptionProps: baseSelectOptionProps })=>{
    const iterableColumnValues = [
        '',
        ...(0, $8f437360f253bfb4$export$b871910a1101d890)(column) || []
    ];
    return iterableColumnValues.map((option)=>{
        const value = getOptionValue(option);
        let label = getOptionLabel(option);
        if (label === '') label = "\u2003"; // To force the height of the empty option
        return /*#__PURE__*/ (0, $lCzvA.createElement)(OptionComponent, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
            native: isSelectNative,
            key: value,
            value: value
        }), label);
    });
};
const $e04d221b2cfecedf$var$SingleSelectOperatorContainer = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div')({
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    [`& button`]: {
        margin: 'auto 0px 5px 5px'
    }
});
function $e04d221b2cfecedf$export$760eb819dd95d361(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, placeholder: placeholder, tabIndex: tabIndex, label: labelProp, variant: variant = 'standard', clearButton: clearButton } = props, others = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $e04d221b2cfecedf$var$_excluded);
    const filterValue = item.value ?? '';
    const id = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const labelId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const isSelectNative = rootProps.slotProps?.baseSelect?.native ?? false;
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if ((0, $8f437360f253bfb4$export$74006a51f68c6262)(column)) resolvedColumn = column;
    }
    const getOptionValue = resolvedColumn?.getOptionValue;
    const getOptionLabel = resolvedColumn?.getOptionLabel;
    const currentValueOptions = $lCzvA.useMemo(()=>{
        return (0, $8f437360f253bfb4$export$b871910a1101d890)(resolvedColumn);
    }, [
        resolvedColumn
    ]);
    const onFilterChange = $lCzvA.useCallback((event)=>{
        let value = event.target.value;
        // NativeSelect casts the value to a string.
        value = (0, $8f437360f253bfb4$export$b31a7985e33f7505)(value, currentValueOptions, getOptionValue);
        applyValue((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, item, {
            value: value
        }));
    }, [
        currentValueOptions,
        getOptionValue,
        applyValue,
        item
    ]);
    if (!(0, $8f437360f253bfb4$export$74006a51f68c6262)(resolvedColumn)) return null;
    const label = labelProp ?? apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($e04d221b2cfecedf$var$SingleSelectOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(rootProps.slots.baseFormControl, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseInputLabel, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseInputLabel, {
                        id: labelId,
                        htmlFor: id,
                        shrink: true,
                        variant: variant,
                        children: label
                    })),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseSelect, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                        id: id,
                        label: label,
                        labelId: labelId,
                        value: filterValue,
                        onChange: onFilterChange,
                        variant: variant,
                        type: type || 'text',
                        inputProps: {
                            tabIndex: tabIndex,
                            ref: focusElementRef,
                            placeholder: placeholder ?? apiRef.current.getLocaleText('filterPanelInputPlaceholder')
                        },
                        native: isSelectNative,
                        notched: variant === 'outlined' ? true : undefined
                    }, others /* FIXME: typing error */ , rootProps.slotProps?.baseSelect, {
                        children: $e04d221b2cfecedf$var$renderSingleSelectOptions({
                            column: resolvedColumn,
                            OptionComponent: rootProps.slots.baseSelectOption,
                            getOptionLabel: getOptionLabel,
                            getOptionValue: getOptionValue,
                            isSelectNative: isSelectNative,
                            baseSelectOptionProps: rootProps.slotProps?.baseSelectOption
                        })
                    }))
                ]
            }),
            clearButton
        ]
    });
}





var $lCzvA = parcelRequire("lCzvA");






const $b1ff768bf49bf544$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant"
], $b1ff768bf49bf544$var$_excluded2 = [
    "key"
];
const $b1ff768bf49bf544$var$filter = (0, $bbbc93862f7737a4$export$f76f94b238d946d8)();
function $b1ff768bf49bf544$export$a61be354e4fcf2c5(props) {
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, color: color, error: error, helperText: helperText, size: size, variant: variant = 'standard' } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $b1ff768bf49bf544$var$_excluded);
    const TextFieldProps = {
        color: color,
        error: error,
        helperText: helperText,
        size: size,
        variant: variant
    };
    const id = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if ((0, $8f437360f253bfb4$export$74006a51f68c6262)(column)) resolvedColumn = column;
    }
    const getOptionValue = resolvedColumn?.getOptionValue;
    const getOptionLabel = resolvedColumn?.getOptionLabel;
    const isOptionEqualToValue = $lCzvA.useCallback((option, value)=>getOptionValue(option) === getOptionValue(value), [
        getOptionValue
    ]);
    const resolvedValueOptions = $lCzvA.useMemo(()=>{
        return (0, $8f437360f253bfb4$export$b871910a1101d890)(resolvedColumn) || [];
    }, [
        resolvedColumn
    ]);
    // The value is computed from the item.value and used directly
    // If it was done by a useEffect/useState, the Autocomplete could receive incoherent value and options
    const filteredValues = $lCzvA.useMemo(()=>{
        if (!Array.isArray(item.value)) return [];
        return item.value.reduce((acc, value)=>{
            const resolvedValue = resolvedValueOptions.find((v)=>getOptionValue(v) === value);
            if (resolvedValue != null) acc.push(resolvedValue);
            return acc;
        }, []);
    }, [
        getOptionValue,
        item.value,
        resolvedValueOptions
    ]);
    const handleChange = $lCzvA.useCallback((event, value)=>{
        applyValue((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, item, {
            value: value.map(getOptionValue)
        }));
    }, [
        applyValue,
        item,
        getOptionValue
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $f67deb46fcc775cd$export$2e2bcd8739ae039), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        multiple: true,
        options: resolvedValueOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        filterOptions: $b1ff768bf49bf544$var$filter,
        id: id,
        value: filteredValues,
        onChange: handleChange,
        getOptionLabel: getOptionLabel,
        renderTags: (value, getTagProps)=>value.map((option, index)=>{
                const _getTagProps = getTagProps({
                    index: index
                }), { key: key } = _getTagProps, tagProps = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_getTagProps, $b1ff768bf49bf544$var$_excluded2);
                return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseChip, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                    variant: "outlined",
                    size: "small",
                    label: getOptionLabel(option)
                }, tagProps), key);
            }),
        renderInput: (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseTextField, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params, {
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                InputLabelProps: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: "singleSelect"
            }, TextFieldProps, rootProps.slotProps?.baseTextField))
    }, other));
}



const $957cdc50b9042c1a$var$parseObjectValue = (value)=>{
    if (value == null || !(0, $ac3bd7253ec0e92a$export$a6cdc56e425d0d0a)(value)) return value;
    return value.value;
};
const $957cdc50b9042c1a$export$fe632a61ba1bdc90 = ()=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$957cdc50b9042c1a$var$parseObjectValue(value) === $957cdc50b9042c1a$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $e04d221b2cfecedf$export$760eb819dd95d361)
        },
        {
            value: 'not',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$957cdc50b9042c1a$var$parseObjectValue(value) !== $957cdc50b9042c1a$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $e04d221b2cfecedf$export$760eb819dd95d361)
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValues = filterItem.value.map($957cdc50b9042c1a$var$parseObjectValue);
                return (value)=>filterItemValues.includes($957cdc50b9042c1a$var$parseObjectValue(value));
            },
            InputComponent: (0, $b1ff768bf49bf544$export$a61be354e4fcf2c5)
        }
    ];





const $5c0707286869d31f$var$isArrayOfObjects = (options)=>{
    return typeof options[0] === 'object';
};
const $5c0707286869d31f$var$defaultGetOptionValue = (value)=>{
    return (0, $ac3bd7253ec0e92a$export$a6cdc56e425d0d0a)(value) ? value.value : value;
};
const $5c0707286869d31f$var$defaultGetOptionLabel = (value)=>{
    return (0, $ac3bd7253ec0e92a$export$a6cdc56e425d0d0a)(value) ? value.label : String(value);
};
const $5c0707286869d31f$export$7acf0d6e5e468a51 = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4), {
    type: 'singleSelect',
    getOptionLabel: $5c0707286869d31f$var$defaultGetOptionLabel,
    getOptionValue: $5c0707286869d31f$var$defaultGetOptionValue,
    valueFormatter (value, row, colDef, apiRef) {
        const rowId = (0, $c0782207122e35d1$export$5e766ecd73f055ed)(apiRef.current.state, row);
        if (!(0, $8f437360f253bfb4$export$74006a51f68c6262)(colDef)) return '';
        const valueOptions = (0, $8f437360f253bfb4$export$b871910a1101d890)(colDef, {
            id: rowId,
            row: row
        });
        if (value == null) return '';
        if (!valueOptions) return value;
        if (!$5c0707286869d31f$var$isArrayOfObjects(valueOptions)) return colDef.getOptionLabel(value);
        const valueOption = valueOptions.find((option)=>colDef.getOptionValue(option) === value);
        return valueOption ? colDef.getOptionLabel(valueOption) : '';
    },
    renderEditCell: (0, $c67eb3eea8d0854c$export$13060fab7d49b7a1),
    filterOperators: (0, $957cdc50b9042c1a$export$fe632a61ba1bdc90)(),
    // @ts-ignore
    pastedValueParser: (value, row, column)=>{
        const colDef = column;
        const valueOptions = (0, $8f437360f253bfb4$export$b871910a1101d890)(colDef) || [];
        const getOptionValue = colDef.getOptionValue;
        const valueOption = valueOptions.find((option)=>{
            if (getOptionValue(option) === value) return true;
            return false;
        });
        if (valueOption) return value;
        // do not paste the value if it is not in the valueOptions
        return undefined;
    }
});







var $lCzvA = parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");



var $a8134958130585e6$export$2e2bcd8739ae039 = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039);



var $lCzvA = parcelRequire("lCzvA");






var $lCzvA = parcelRequire("lCzvA");
'use client';
/**
 * @ignore - internal component.
 */ const $e08a4bc46b69b6f7$var$ListContext = /*#__PURE__*/ $lCzvA.createContext({});
var $e08a4bc46b69b6f7$export$2e2bcd8739ae039 = $e08a4bc46b69b6f7$var$ListContext;




function $599325f889e49f49$export$c6bd6795ed6e3203(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiList', slot);
}
const $599325f889e49f49$var$listClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $599325f889e49f49$export$2e2bcd8739ae039 = $599325f889e49f49$var$listClasses;



'use client';
const $d08c7fcb2c1dca6c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $599325f889e49f49$export$c6bd6795ed6e3203), classes);
};
const $d08c7fcb2c1dca6c$var$ListRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $d08c7fcb2c1dca6c$var$List = /*#__PURE__*/ $lCzvA.forwardRef(function List(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $lCzvA.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $d08c7fcb2c1dca6c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e08a4bc46b69b6f7$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($d08c7fcb2c1dca6c$var$ListRoot, {
            as: component,
            className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $d08c7fcb2c1dca6c$export$2e2bcd8739ae039 = $d08c7fcb2c1dca6c$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $980f2510eb982028$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}


var $171532bc87676815$export$2e2bcd8739ae039 = (0, $980f2510eb982028$export$2e2bcd8739ae039);





var $353a0a174c2b5036$export$2e2bcd8739ae039 = (0, $cbe0ef075048c43a$export$2e2bcd8739ae039);



'use client';
function $e6048ea6ffd35fc1$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $e6048ea6ffd35fc1$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $e6048ea6ffd35fc1$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $e6048ea6ffd35fc1$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$e6048ea6ffd35fc1$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $e6048ea6ffd35fc1$var$MenuList = /*#__PURE__*/ $lCzvA.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $lCzvA.useRef(null);
    const textCriteriaRef = $lCzvA.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $1bc2b909266b2e14$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $lCzvA.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $171532bc87676815$export$2e2bcd8739ae039)((0, $353a0a174c2b5036$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $a8134958130585e6$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $e6048ea6ffd35fc1$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $e6048ea6ffd35fc1$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $e6048ea6ffd35fc1$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $e6048ea6ffd35fc1$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $e6048ea6ffd35fc1$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $e6048ea6ffd35fc1$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $e6048ea6ffd35fc1$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $e6048ea6ffd35fc1$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $e6048ea6ffd35fc1$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $e6048ea6ffd35fc1$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $e6048ea6ffd35fc1$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $ade5ac70196d775c$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $lCzvA.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $lCzvA.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $lCzvA.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $lCzvA.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $d08c7fcb2c1dca6c$export$2e2bcd8739ae039), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $e6048ea6ffd35fc1$export$2e2bcd8739ae039 = $e6048ea6ffd35fc1$var$MenuList;








var $lCzvA = parcelRequire("lCzvA");



var $lCzvA = parcelRequire("lCzvA");



'use client';
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $c30bc19cd053c2b9$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $c30bc19cd053c2b9$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://v6.mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://v6.mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://v6.mui.com/material-ui/api/click-away-listener/)
 */ function $c30bc19cd053c2b9$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $lCzvA.useRef(false);
    const nodeRef = $lCzvA.useRef(null);
    const activatedRef = $lCzvA.useRef(false);
    const syntheticEventRef = $lCzvA.useRef(false);
    $lCzvA.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)((0, $52e17a1723d23ff7$export$2e2bcd8739ae039)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $c30bc19cd053c2b9$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $lCzvA.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $c30bc19cd053c2b9$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $lCzvA.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $c30bc19cd053c2b9$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $lCzvA.cloneElement(children, childrenProps);
}




var $lCzvA = parcelRequire("lCzvA");








var $lCzvA = parcelRequire("lCzvA");

var $dAQd3 = parcelRequire("dAQd3");
var $ebd8f9fed3d30444$export$2e2bcd8739ae039 = {
    disabled: false
};




var $33b15fe49e1185b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $359d74762cf8ebf8$export$bb38bb9a1161268 = 'unmounted';
var $359d74762cf8ebf8$export$84cbff306f539230 = 'exited';
var $359d74762cf8ebf8$export$df38205c966be359 = 'entering';
var $359d74762cf8ebf8$export$78e9e6e3e014d60a = 'entered';
var $359d74762cf8ebf8$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $359d74762cf8ebf8$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $a07b762a1fdd8900$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $359d74762cf8ebf8$export$84cbff306f539230;
                _this.appearStatus = $359d74762cf8ebf8$export$df38205c966be359;
            } else initialStatus = $359d74762cf8ebf8$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $359d74762cf8ebf8$export$bb38bb9a1161268;
        else initialStatus = $359d74762cf8ebf8$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $359d74762cf8ebf8$export$bb38bb9a1161268) return {
            status: $359d74762cf8ebf8$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $359d74762cf8ebf8$export$df38205c966be359 && status !== $359d74762cf8ebf8$export$78e9e6e3e014d60a) nextStatus = $359d74762cf8ebf8$export$df38205c966be359;
            } else if (status === $359d74762cf8ebf8$export$df38205c966be359 || status === $359d74762cf8ebf8$export$78e9e6e3e014d60a) nextStatus = $359d74762cf8ebf8$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $359d74762cf8ebf8$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($dAQd3))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $33b15fe49e1185b7$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $359d74762cf8ebf8$export$84cbff306f539230) this.setState({
            status: $359d74762cf8ebf8$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($dAQd3))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $ebd8f9fed3d30444$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $359d74762cf8ebf8$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $359d74762cf8ebf8$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $359d74762cf8ebf8$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($dAQd3))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $ebd8f9fed3d30444$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $359d74762cf8ebf8$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $359d74762cf8ebf8$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $359d74762cf8ebf8$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($dAQd3))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $359d74762cf8ebf8$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement((0, $58eee0317f24e867$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).Component);
$359d74762cf8ebf8$var$Transition.contextType = (0, $58eee0317f24e867$export$2e2bcd8739ae039);
$359d74762cf8ebf8$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $359d74762cf8ebf8$var$noop() {}
$359d74762cf8ebf8$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $359d74762cf8ebf8$var$noop,
    onEntering: $359d74762cf8ebf8$var$noop,
    onEntered: $359d74762cf8ebf8$var$noop,
    onExit: $359d74762cf8ebf8$var$noop,
    onExiting: $359d74762cf8ebf8$var$noop,
    onExited: $359d74762cf8ebf8$var$noop
};
$359d74762cf8ebf8$var$Transition.UNMOUNTED = $359d74762cf8ebf8$export$bb38bb9a1161268;
$359d74762cf8ebf8$var$Transition.EXITED = $359d74762cf8ebf8$export$84cbff306f539230;
$359d74762cf8ebf8$var$Transition.ENTERING = $359d74762cf8ebf8$export$df38205c966be359;
$359d74762cf8ebf8$var$Transition.ENTERED = $359d74762cf8ebf8$export$78e9e6e3e014d60a;
$359d74762cf8ebf8$var$Transition.EXITING = $359d74762cf8ebf8$export$4aacc83d4d59139f;
var $359d74762cf8ebf8$export$2e2bcd8739ae039 = $359d74762cf8ebf8$var$Transition;



const $b233c2126e177d66$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $b233c2126e177d66$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}




'use client';
function $f7b874c31cbe253c$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $f7b874c31cbe253c$var$styles = {
    entering: {
        opacity: 1,
        transform: $f7b874c31cbe253c$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $f7b874c31cbe253c$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $f7b874c31cbe253c$var$Grow = /*#__PURE__*/ $lCzvA.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $359d74762cf8ebf8$export$2e2bcd8739ae039), ...other } = props;
    const timer = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const autoTimeout = $lCzvA.useRef();
    const theme = (0, $0282d01cc0b6bcdf$export$2e2bcd8739ae039)();
    const nodeRef = $lCzvA.useRef(null);
    const handleRef = (0, $ade5ac70196d775c$export$2e2bcd8739ae039)(nodeRef, (0, $52e17a1723d23ff7$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $b233c2126e177d66$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $b233c2126e177d66$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $f7b874c31cbe253c$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $b233c2126e177d66$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $f7b874c31cbe253c$var$isWebKit154 ? duration : duration * 0.666,
                delay: $f7b874c31cbe253c$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $f7b874c31cbe253c$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $lCzvA.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $f7b874c31cbe253c$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$f7b874c31cbe253c$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($f7b874c31cbe253c$var$Grow) $f7b874c31cbe253c$var$Grow.muiSupportAuto = true;
var $f7b874c31cbe253c$export$2e2bcd8739ae039 = $f7b874c31cbe253c$var$Grow;









const $eff079abbf7a8831$var$_excluded = [
    "open",
    "target",
    "onClose",
    "children",
    "position",
    "className",
    "onExited"
];
const $eff079abbf7a8831$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'menu'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $eff079abbf7a8831$var$GridMenuRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $b20d485709a84fcd$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'Menu',
    overridesResolver: (_, styles)=>styles.menu
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal,
        [`& .${(0, $786c119d9add6b61$export$2100d54e36406477).menuList}`]: {
            outline: 0
        }
    }));
const $eff079abbf7a8831$var$transformOrigin = {
    'bottom-start': 'top left',
    'bottom-end': 'top right'
};
function $eff079abbf7a8831$export$237948c71948075(props) {
    const { open: open, target: target, onClose: onClose, children: children, position: position, className: className, onExited: onExited } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $eff079abbf7a8831$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $eff079abbf7a8831$var$useUtilityClasses(rootProps);
    const savedFocusRef = $lCzvA.useRef(null);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (open) savedFocusRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        else {
            savedFocusRef.current?.focus?.();
            savedFocusRef.current = null;
        }
    }, [
        open
    ]);
    $lCzvA.useEffect(()=>{
        // Emit menuOpen or menuClose events
        const eventName = open ? 'menuOpen' : 'menuClose';
        apiRef.current.publishEvent(eventName, {
            target: target
        });
    }, [
        apiRef,
        open,
        target
    ]);
    const handleExited = (popperOnExited)=>(node)=>{
            if (popperOnExited) popperOnExited();
            if (onExited) onExited(node);
        };
    const handleClickAway = (event)=>{
        if (event.target && (target === event.target || target?.contains(event.target))) return;
        onClose(event);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($eff079abbf7a8831$var$GridMenuRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        as: rootProps.slots.basePopper,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps,
        open: open,
        anchorEl: target,
        transition: true,
        placement: position
    }, other, rootProps.slotProps?.basePopper, {
        children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c30bc19cd053c2b9$export$58385c17fee43f89), {
                onClickAway: handleClickAway,
                mouseEvent: "onMouseDown",
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $f7b874c31cbe253c$export$2e2bcd8739ae039), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, TransitionProps, {
                    style: {
                        transformOrigin: $eff079abbf7a8831$var$transformOrigin[placement]
                    },
                    onExited: handleExited(TransitionProps?.onExited),
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0e17783238642a98$export$2e2bcd8739ae039), {
                        children: children
                    })
                }))
            })
    }));
}





const $569b3fddd4bc20f8$var$_excluded = [
    "api",
    "colDef",
    "id",
    "hasFocus",
    "isEditable",
    "field",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "cellMode",
    "tabIndex",
    "position",
    "focusElementRef"
];
const $569b3fddd4bc20f8$var$hasActions = (colDef)=>typeof colDef.getActions === 'function';
function $569b3fddd4bc20f8$export$e8966cddc2f9f685(props) {
    const { colDef: colDef, id: id, hasFocus: hasFocus, tabIndex: tabIndex, position: position = 'bottom-end', focusElementRef: focusElementRef } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $569b3fddd4bc20f8$var$_excluded);
    const [focusedButtonIndex, setFocusedButtonIndex] = $lCzvA.useState(-1);
    const [open, setOpen] = $lCzvA.useState(false);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootRef = $lCzvA.useRef(null);
    const buttonRef = $lCzvA.useRef(null);
    const ignoreCallToFocus = $lCzvA.useRef(false);
    const touchRippleRefs = $lCzvA.useRef({});
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const menuId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const buttonId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    if (!$569b3fddd4bc20f8$var$hasActions(colDef)) throw new Error('MUI X: Missing the `getActions` property in the `GridColDef`.');
    const options = colDef.getActions(apiRef.current.getRowParams(id));
    const iconButtons = options.filter((option)=>!option.props.showInMenu);
    const menuButtons = options.filter((option)=>option.props.showInMenu);
    const numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
    $lCzvA.useLayoutEffect(()=>{
        if (!hasFocus) Object.entries(touchRippleRefs.current).forEach(([index, ref])=>{
            ref?.stop({}, ()=>{
                delete touchRippleRefs.current[index];
            });
        });
    }, [
        hasFocus
    ]);
    $lCzvA.useEffect(()=>{
        if (focusedButtonIndex < 0 || !rootRef.current) return;
        if (focusedButtonIndex >= rootRef.current.children.length) return;
        const child = rootRef.current.children[focusedButtonIndex];
        child.focus({
            preventScroll: true
        });
    }, [
        focusedButtonIndex
    ]);
    $lCzvA.useEffect(()=>{
        if (!hasFocus) {
            setFocusedButtonIndex(-1);
            ignoreCallToFocus.current = false;
        }
    }, [
        hasFocus
    ]);
    $lCzvA.useImperativeHandle(focusElementRef, ()=>({
            focus () {
                // If ignoreCallToFocus is true, then one of the buttons was clicked and the focus is already set
                if (!ignoreCallToFocus.current) {
                    // find the first focusable button and pass the index to the state
                    const focusableButtonIndex = options.findIndex((o)=>!o.props.disabled);
                    setFocusedButtonIndex(focusableButtonIndex);
                }
            }
        }), [
        options
    ]);
    $lCzvA.useEffect(()=>{
        if (focusedButtonIndex >= numberOfButtons) setFocusedButtonIndex(numberOfButtons - 1);
    }, [
        focusedButtonIndex,
        numberOfButtons
    ]);
    const showMenu = ()=>{
        setOpen(true);
        setFocusedButtonIndex(numberOfButtons - 1);
        ignoreCallToFocus.current = true;
    };
    const hideMenu = ()=>{
        setOpen(false);
    };
    const toggleMenu = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        if (open) hideMenu();
        else showMenu();
    };
    const handleTouchRippleRef = (index)=>(instance)=>{
            touchRippleRefs.current[index] = instance;
        };
    const handleButtonClick = (index, onClick)=>(event)=>{
            setFocusedButtonIndex(index);
            ignoreCallToFocus.current = true;
            if (onClick) onClick(event);
        };
    const handleRootKeyDown = (event)=>{
        if (numberOfButtons <= 1) return;
        const getNewIndex = (index, direction)=>{
            if (index < 0 || index > options.length) return index;
            // for rtl mode we need to reverse the direction
            const rtlMod = isRtl ? -1 : 1;
            const indexMod = (direction === 'left' ? -1 : 1) * rtlMod;
            // if the button that should receive focus is disabled go one more step
            return options[index + indexMod]?.props.disabled ? getNewIndex(index + indexMod, direction) : index + indexMod;
        };
        let newIndex = focusedButtonIndex;
        if (event.key === 'ArrowRight') newIndex = getNewIndex(focusedButtonIndex, 'right');
        else if (event.key === 'ArrowLeft') newIndex = getNewIndex(focusedButtonIndex, 'left');
        if (newIndex < 0 || newIndex >= numberOfButtons) return; // We're already in the first or last item = do nothing and let the grid listen the event
        if (newIndex !== focusedButtonIndex) {
            event.preventDefault(); // Prevent scrolling
            event.stopPropagation(); // Don't stop propagation for other keys, for example ArrowUp
            setFocusedButtonIndex(newIndex);
        }
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if ([
            'Tab',
            'Escape'
        ].includes(event.key)) hideMenu();
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        role: "menu",
        ref: rootRef,
        tabIndex: -1,
        className: (0, $786c119d9add6b61$export$2100d54e36406477).actionsCell,
        onKeyDown: handleRootKeyDown
    }, other, {
        children: [
            iconButtons.map((button, index)=>/*#__PURE__*/ $lCzvA.cloneElement(button, {
                    key: index,
                    touchRippleRef: handleTouchRippleRef(index),
                    onClick: handleButtonClick(index, button.props.onClick),
                    tabIndex: focusedButtonIndex === index ? tabIndex : -1
                })),
            menuButtons.length > 0 && buttonId && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                ref: buttonRef,
                id: buttonId,
                "aria-label": apiRef.current.getLocaleText('actionsCellMore'),
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? menuId : undefined,
                role: "menuitem",
                size: "small",
                onClick: toggleMenu,
                touchRippleRef: handleTouchRippleRef(buttonId),
                tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.moreActionsIcon, {
                    fontSize: "small"
                })
            })),
            menuButtons.length > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $eff079abbf7a8831$export$237948c71948075), {
                open: open,
                target: buttonRef.current,
                position: position,
                onClose: hideMenu,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e6048ea6ffd35fc1$export$2e2bcd8739ae039), {
                    id: menuId,
                    className: (0, $786c119d9add6b61$export$2100d54e36406477).menuList,
                    onKeyDown: handleListKeyDown,
                    "aria-labelledby": buttonId,
                    variant: "menu",
                    autoFocusItem: true,
                    children: menuButtons.map((button, index)=>/*#__PURE__*/ $lCzvA.cloneElement(button, {
                            key: index,
                            closeMenu: hideMenu
                        }))
                })
            })
        ]
    }));
}
const $569b3fddd4bc20f8$export$974043ff7a6a1028 = (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($569b3fddd4bc20f8$export$e8966cddc2f9f685, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params));


const $8af4a53e0f3e9113$export$e2523ab9efeb7465 = 'actions';
const $8af4a53e0f3e9113$export$cc51a5e65f00f971 = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4), {
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    width: 100,
    display: 'flex',
    align: 'center',
    headerAlign: 'center',
    headerName: '',
    disableColumnMenu: true,
    disableExport: true,
    renderCell: (0, $569b3fddd4bc20f8$export$974043ff7a6a1028),
    getApplyQuickFilterFn: undefined
});


const $834e4efb2ede3f38$export$9459349d75dc87fe = 'string';
const $834e4efb2ede3f38$export$625c4e4511cf2d66 = ()=>{
    const nativeColumnTypes = {
        string: (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4),
        number: (0, $fbfc6247b5d26526$export$ba08f73736670f91),
        date: (0, $fa325af4626674ec$export$4c3b89749ea40e50),
        dateTime: (0, $fa325af4626674ec$export$5bc7079eed6f3d7f),
        boolean: (0, $c7df02efbbf7aa77$export$220b51460e149ea9),
        singleSelect: (0, $5c0707286869d31f$export$7acf0d6e5e468a51),
        [(0, $8af4a53e0f3e9113$export$e2523ab9efeb7465)]: (0, $8af4a53e0f3e9113$export$cc51a5e65f00f971),
        custom: (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4)
    };
    return nativeColumnTypes;
};






const $2ea7877c1ac6621b$export$372ceb7d0877dfb4 = (state)=>state.headerFiltering;
const $2ea7877c1ac6621b$export$5e071b12b66f124d = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($2ea7877c1ac6621b$export$372ceb7d0877dfb4, // No initialization in MIT, so we need to default to false to be used by `getTotalHeaderHeight`
(headerFilteringState)=>headerFilteringState?.enabled ?? false);
const $2ea7877c1ac6621b$export$d5104e3dccc7c49d = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($2ea7877c1ac6621b$export$372ceb7d0877dfb4, (headerFilteringState)=>headerFilteringState.editing);
const $2ea7877c1ac6621b$export$c564e60305059ea4 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($2ea7877c1ac6621b$export$372ceb7d0877dfb4, (headerFilteringState)=>headerFilteringState.menuOpen);



const $8590d748d071bb9f$export$6f71a66e6e099ab2 = (state)=>state.columnGrouping;
const $8590d748d071bb9f$export$78f140ad2e1dbc2b = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8590d748d071bb9f$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.unwrappedGroupingModel ?? {});
const $8590d748d071bb9f$export$bdc2ff4432d8b29b = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8590d748d071bb9f$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.lookup ?? {});
const $8590d748d071bb9f$export$8f859ed1f2777746 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($8590d748d071bb9f$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.headerStructure ?? []);
const $8590d748d071bb9f$export$4cf0369c079b29be = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($8590d748d071bb9f$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.maxDepth ?? 0);


const $938d01614caf11f5$export$cd7252624d377ce0 = [
    'maxWidth',
    'minWidth',
    'width',
    'flex'
];
const $938d01614caf11f5$var$COLUMN_TYPES = (0, $834e4efb2ede3f38$export$625c4e4511cf2d66)();
function $938d01614caf11f5$export$1719bda669685455({ initialFreeSpace: initialFreeSpace, totalFlexUnits: totalFlexUnits, flexColumns: flexColumns }) {
    const uniqueFlexColumns = new Set(flexColumns.map((col)=>col.field));
    const flexColumnsLookup = {
        all: {},
        frozenFields: [],
        freeze: (field)=>{
            const value = flexColumnsLookup.all[field];
            if (value && value.frozen !== true) {
                flexColumnsLookup.all[field].frozen = true;
                flexColumnsLookup.frozenFields.push(field);
            }
        }
    };
    // Step 5 of https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
    function loopOverFlexItems() {
        // 5a: If all the flex items on the line are frozen, free space has been distributed.
        if (flexColumnsLookup.frozenFields.length === uniqueFlexColumns.size) return;
        const violationsLookup = {
            min: {},
            max: {}
        };
        let remainingFreeSpace = initialFreeSpace;
        let flexUnits = totalFlexUnits;
        let totalViolation = 0;
        // 5b: Calculate the remaining free space
        flexColumnsLookup.frozenFields.forEach((field)=>{
            remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
            flexUnits -= flexColumnsLookup.all[field].flex;
        });
        for(let i = 0; i < flexColumns.length; i += 1){
            const column = flexColumns[i];
            if (flexColumnsLookup.all[column.field] && flexColumnsLookup.all[column.field].frozen === true) continue;
            // 5c: Distribute remaining free space proportional to the flex factors
            const widthPerFlexUnit = remainingFreeSpace / flexUnits;
            let computedWidth = widthPerFlexUnit * column.flex;
            // 5d: Fix min/max violations
            if (computedWidth < column.minWidth) {
                totalViolation += column.minWidth - computedWidth;
                computedWidth = column.minWidth;
                violationsLookup.min[column.field] = true;
            } else if (computedWidth > column.maxWidth) {
                totalViolation += column.maxWidth - computedWidth;
                computedWidth = column.maxWidth;
                violationsLookup.max[column.field] = true;
            }
            flexColumnsLookup.all[column.field] = {
                frozen: false,
                computedWidth: computedWidth,
                flex: column.flex
            };
        }
        // 5e: Freeze over-flexed items
        if (totalViolation < 0) // Freeze all the items with max violations
        Object.keys(violationsLookup.max).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else if (totalViolation > 0) // Freeze all the items with min violations
        Object.keys(violationsLookup.min).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else // Freeze all items
        flexColumns.forEach(({ field: field })=>{
            flexColumnsLookup.freeze(field);
        });
        // 5f: Return to the start of this loop
        loopOverFlexItems();
    }
    loopOverFlexItems();
    return flexColumnsLookup.all;
}
const $938d01614caf11f5$export$cd8dc1fa232954ad = (rawState, dimensions)=>{
    const columnsLookup = {};
    let totalFlexUnits = 0;
    let widthAllocatedBeforeFlex = 0;
    const flexColumns = [];
    // For the non-flex columns, compute their width
    // For the flex columns, compute their minimum width and how much width must be allocated during the flex allocation
    rawState.orderedFields.forEach((columnField)=>{
        let column = rawState.lookup[columnField];
        let computedWidth = 0;
        let isFlex = false;
        if (rawState.columnVisibilityModel[columnField] !== false) {
            if (column.flex && column.flex > 0) {
                totalFlexUnits += column.flex;
                isFlex = true;
            } else computedWidth = (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(column.width || (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4).width, column.minWidth || (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4).minWidth, column.maxWidth || (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4).maxWidth);
            widthAllocatedBeforeFlex += computedWidth;
        }
        if (column.computedWidth !== computedWidth) column = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, column, {
            computedWidth: computedWidth
        });
        if (isFlex) flexColumns.push(column);
        columnsLookup[columnField] = column;
    });
    const availableWidth = dimensions === undefined ? 0 : dimensions.viewportOuterSize.width - (dimensions.hasScrollY ? dimensions.scrollbarSize : 0);
    const initialFreeSpace = Math.max(availableWidth - widthAllocatedBeforeFlex, 0);
    // Allocate the remaining space to the flex columns
    if (totalFlexUnits > 0 && availableWidth > 0) {
        const computedColumnWidths = $938d01614caf11f5$export$1719bda669685455({
            initialFreeSpace: initialFreeSpace,
            totalFlexUnits: totalFlexUnits,
            flexColumns: flexColumns
        });
        Object.keys(computedColumnWidths).forEach((field)=>{
            columnsLookup[field].computedWidth = computedColumnWidths[field].computedWidth;
        });
    }
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rawState, {
        lookup: columnsLookup
    });
};
const $938d01614caf11f5$export$6e8a0938c76079c7 = (columnsState, initialState)=>{
    if (!initialState) return columnsState;
    const { orderedFields: orderedFields = [], dimensions: dimensions = {} } = initialState;
    const columnsWithUpdatedDimensions = Object.keys(dimensions);
    if (columnsWithUpdatedDimensions.length === 0 && orderedFields.length === 0) return columnsState;
    const orderedFieldsLookup = {};
    const cleanOrderedFields = [];
    for(let i = 0; i < orderedFields.length; i += 1){
        const field = orderedFields[i];
        // Ignores the fields in the initialState that matches no field on the current column state
        if (columnsState.lookup[field]) {
            orderedFieldsLookup[field] = true;
            cleanOrderedFields.push(field);
        }
    }
    const newOrderedFields = cleanOrderedFields.length === 0 ? columnsState.orderedFields : [
        ...cleanOrderedFields,
        ...columnsState.orderedFields.filter((field)=>!orderedFieldsLookup[field])
    ];
    const newColumnLookup = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, columnsState.lookup);
    for(let i = 0; i < columnsWithUpdatedDimensions.length; i += 1){
        const field = columnsWithUpdatedDimensions[i];
        const newColDef = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newColumnLookup[field], {
            hasBeenResized: true
        });
        Object.entries(dimensions[field]).forEach(([key, value])=>{
            newColDef[key] = value === -1 ? Infinity : value;
        });
        newColumnLookup[field] = newColDef;
    }
    const newColumnsState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, columnsState, {
        orderedFields: newOrderedFields,
        lookup: newColumnLookup
    });
    return newColumnsState;
};
function $938d01614caf11f5$var$getDefaultColTypeDef(type) {
    let colDef = $938d01614caf11f5$var$COLUMN_TYPES[0, $834e4efb2ede3f38$export$9459349d75dc87fe];
    if (type && $938d01614caf11f5$var$COLUMN_TYPES[type]) colDef = $938d01614caf11f5$var$COLUMN_TYPES[type];
    return colDef;
}
const $938d01614caf11f5$export$f3ba81d24bd05452 = ({ apiRef: apiRef, columnsToUpsert: columnsToUpsert, initialState: initialState, columnVisibilityModel: columnVisibilityModel = (0, $8b99503000dd62d3$export$eb0d33595fe29bb4)(apiRef), keepOnlyColumnsToUpsert: keepOnlyColumnsToUpsert = false })=>{
    const isInsideStateInitializer = !apiRef.current.state.columns;
    let columnsState;
    if (isInsideStateInitializer) columnsState = {
        orderedFields: [],
        lookup: {},
        columnVisibilityModel: columnVisibilityModel
    };
    else {
        const currentState = (0, $8b99503000dd62d3$export$858d15abb6cddc08)(apiRef.current.state);
        columnsState = {
            orderedFields: keepOnlyColumnsToUpsert ? [] : [
                ...currentState.orderedFields
            ],
            lookup: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, currentState.lookup),
            columnVisibilityModel: // Will be cleaned later if keepOnlyColumnsToUpsert=true
            columnVisibilityModel
        };
    }
    let columnsToKeep = {};
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) columnsToKeep = Object.keys(columnsState.lookup).reduce((acc, key)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, acc, {
            [key]: false
        }), {});
    const columnsToUpsertLookup = {};
    columnsToUpsert.forEach((newColumn)=>{
        const { field: field } = newColumn;
        columnsToUpsertLookup[field] = true;
        columnsToKeep[field] = true;
        let existingState = columnsState.lookup[field];
        if (existingState == null) {
            existingState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, $938d01614caf11f5$var$getDefaultColTypeDef(newColumn.type), {
                field: field,
                hasBeenResized: false
            });
            columnsState.orderedFields.push(field);
        } else if (keepOnlyColumnsToUpsert) columnsState.orderedFields.push(field);
        // If the column type has changed - merge the existing state with the default column type definition
        if (existingState && existingState.type !== newColumn.type) existingState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, $938d01614caf11f5$var$getDefaultColTypeDef(newColumn.type), {
            field: field
        });
        let hasBeenResized = existingState.hasBeenResized;
        $938d01614caf11f5$export$cd7252624d377ce0.forEach((key)=>{
            if (newColumn[key] !== undefined) {
                hasBeenResized = true;
                if (newColumn[key] === -1) newColumn[key] = Infinity;
            }
        });
        columnsState.lookup[field] = (0, $650cdafe9746b559$export$2e2bcd8739ae039)(existingState, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newColumn, {
            hasBeenResized: hasBeenResized
        }));
    });
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) Object.keys(columnsState.lookup).forEach((field)=>{
        if (!columnsToKeep[field]) delete columnsState.lookup[field];
    });
    const columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors('hydrateColumns', columnsState);
    const columnsStateWithPortableColumns = $938d01614caf11f5$export$6e8a0938c76079c7(columnsStateWithPreProcessing, initialState);
    return $938d01614caf11f5$export$cd8dc1fa232954ad(columnsStateWithPortableColumns, apiRef.current.getRootDimensions?.() ?? undefined);
};
function $938d01614caf11f5$export$6143417adb92779f({ firstColumnToRender: firstColumnToRender, apiRef: apiRef, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, visibleRows: visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    let foundStableColumn = false;
    // Keep checking columns until we find one that's not spanned in any visible row
    while(!foundStableColumn){
        foundStableColumn = true;
        for(let i = firstRowToRender; i < lastRowToRender; i += 1){
            const row = visibleRows[i];
            if (row) {
                const rowId = visibleRows[i].id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstNonSpannedColumnToRender);
                if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan && cellColSpanInfo.leftVisibleCellIndex < firstNonSpannedColumnToRender) {
                    firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
                    foundStableColumn = false;
                    break; // Check the new column index against the visible rows, because it might be spanned
                }
            }
        }
    }
    return firstNonSpannedColumnToRender;
}
function $938d01614caf11f5$export$659109c29172602f(apiRef, props) {
    if (props.unstable_listView) return 0;
    const densityFactor = (0, $bc5ab296ed04c1c0$export$c646201fb1d3e7a6)(apiRef);
    const maxDepth = (0, $8590d748d071bb9f$export$4cf0369c079b29be)(apiRef);
    const isHeaderFilteringEnabled = (0, $2ea7877c1ac6621b$export$5e071b12b66f124d)(apiRef);
    const columnHeadersHeight = Math.floor(props.columnHeaderHeight * densityFactor);
    const columnGroupHeadersHeight = Math.floor((props.columnGroupHeaderHeight ?? props.columnHeaderHeight) * densityFactor);
    const filterHeadersHeight = isHeaderFilteringEnabled ? Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * densityFactor) : 0;
    return columnHeadersHeight + columnGroupHeadersHeight * maxDepth + filterHeadersHeight;
}



const $ab89a1ec5ede86ad$export$4f32bfc70efeb4ab = (state)=>state.rowsMeta;



'use client';
const $b1dde8abe2995993$var$CLIFF = 1;
const $b1dde8abe2995993$var$SLOP = 1.5;
const $b1dde8abe2995993$var$useUtilityClasses = (ownerState)=>{
    const { scrollDirection: scrollDirection, classes: classes } = ownerState;
    const slots = {
        root: [
            'scrollArea',
            `scrollArea--${scrollDirection}`
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $b1dde8abe2995993$var$GridScrollAreaRawRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ScrollArea',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollArea--left']}`]: styles['scrollArea--left']
            },
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollArea--right']}`]: styles['scrollArea--right']
            },
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollArea--up']}`]: styles['scrollArea--up']
            },
            {
                [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollArea--down']}`]: styles['scrollArea--down']
            },
            styles.scrollArea
        ]
})(()=>({
        position: 'absolute',
        zIndex: 101,
        // Horizontal scroll areas
        [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollArea--left']}`]: {
            top: 0,
            left: 0,
            width: 20,
            bottom: 0
        },
        [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollArea--right']}`]: {
            top: 0,
            right: 0,
            width: 20,
            bottom: 0
        },
        // Vertical scroll areas
        [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollArea--up']}`]: {
            top: 0,
            left: 0,
            right: 0,
            height: 20
        },
        [`&.${(0, $786c119d9add6b61$export$2100d54e36406477)['scrollArea--down']}`]: {
            bottom: 0,
            left: 0,
            right: 0,
            height: 20
        }
    }));
const $b1dde8abe2995993$var$offsetSelector = (0, $f0fef4ed0246c865$export$89f5fc21559ede9b)((0, $adc18856c547b659$export$26d8768b83a52ffd), (dimensions, direction)=>{
    if (direction === 'left') return dimensions.leftPinnedWidth;
    if (direction === 'right') return dimensions.rightPinnedWidth + (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
    // For vertical scroll areas, we don't need horizontal offset
    return 0;
});
function $b1dde8abe2995993$var$GridScrollAreaWrapper(props) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const [dragDirection, setDragDirection] = $lCzvA.useState('none');
    // Listen for both column and row drag events
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragStart', ()=>setDragDirection('horizontal'));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragEnd', ()=>setDragDirection('none'));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowDragStart', ()=>setDragDirection('vertical'));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowDragEnd', ()=>setDragDirection('none'));
    if (dragDirection === 'none') return null;
    if (dragDirection === 'horizontal') return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($b1dde8abe2995993$var$GridHorizontalScrollAreaContent, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props));
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($b1dde8abe2995993$var$GridVerticalScrollAreaContent, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props));
}
function $b1dde8abe2995993$var$GridHorizontalScrollAreaContent(props) {
    const { scrollDirection: scrollDirection, scrollPosition: scrollPosition } = props;
    const rootRef = $lCzvA.useRef(null);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const timeout = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const densityFactor = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $bc5ab296ed04c1c0$export$c646201fb1d3e7a6));
    const columnsTotalWidth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$ab20f9d33edc7794));
    const sideOffset = (0, $1e10d601c15466d4$export$3b2f72ef07abe101)(apiRef, $b1dde8abe2995993$var$offsetSelector, scrollDirection);
    const getCanScrollMore = ()=>{
        const dimensions = (0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state);
        if (scrollDirection === 'left') // Only render if the user has not reached yet the start of the list
        return scrollPosition.current.left > 0;
        if (scrollDirection === 'right') {
            // Only render if the user has not reached yet the end of the list
            const maxScrollLeft = columnsTotalWidth - dimensions.viewportInnerSize.width;
            return scrollPosition.current.left < maxScrollLeft;
        }
        return false;
    };
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const totalHeaderHeight = (0, $938d01614caf11f5$export$659109c29172602f)(apiRef, rootProps);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
    const style = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        height: headerHeight,
        top: totalHeaderHeight - headerHeight
    }, scrollDirection === 'left' ? {
        left: sideOffset
    } : {}, scrollDirection === 'right' ? {
        right: sideOffset
    } : {});
    const handleDragOver = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'left') offset = event.clientX - rootRef.current.getBoundingClientRect().right;
        else if (scrollDirection === 'right') offset = Math.max(1, event.clientX - rootRef.current.getBoundingClientRect().left);
        else throw new Error('MUI X: Wrong drag direction');
        offset = (offset - $b1dde8abe2995993$var$CLIFF) * $b1dde8abe2995993$var$SLOP + $b1dde8abe2995993$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left + offset,
                top: scrollPosition.current.top
            });
        });
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($b1dde8abe2995993$var$GridScrollAreaContent, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        ref: rootRef,
        getCanScrollMore: getCanScrollMore,
        style: style,
        handleDragOver: handleDragOver
    }));
}
function $b1dde8abe2995993$var$GridVerticalScrollAreaContent(props) {
    const { scrollDirection: scrollDirection, scrollPosition: scrollPosition } = props;
    const rootRef = $lCzvA.useRef(null);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const timeout = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const rowsMeta = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $ab89a1ec5ede86ad$export$4f32bfc70efeb4ab));
    const getCanScrollMore = ()=>{
        const dimensions = (0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state);
        if (scrollDirection === 'up') // Only render if the user has not reached yet the top of the list
        return scrollPosition.current.top > 0;
        if (scrollDirection === 'down') {
            // Only render if the user has not reached yet the bottom of the list
            const totalRowsHeight = rowsMeta.currentPageTotalHeight || 0;
            const maxScrollTop = totalRowsHeight - dimensions.viewportInnerSize.height - dimensions.scrollbarSize;
            return scrollPosition.current.top < maxScrollTop;
        }
        return false;
    };
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const totalHeaderHeight = (0, $938d01614caf11f5$export$659109c29172602f)(apiRef, rootProps);
    const style = {
        top: scrollDirection === 'up' ? totalHeaderHeight : undefined,
        bottom: scrollDirection === 'down' ? 0 : undefined
    };
    const handleDragOver = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'up') offset = event.clientY - rootRef.current.getBoundingClientRect().bottom;
        else if (scrollDirection === 'down') offset = Math.max(1, event.clientY - rootRef.current.getBoundingClientRect().top);
        else throw new Error('MUI X: Wrong drag direction');
        offset = (offset - $b1dde8abe2995993$var$CLIFF) * $b1dde8abe2995993$var$SLOP + $b1dde8abe2995993$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left,
                top: scrollPosition.current.top + offset
            });
        });
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($b1dde8abe2995993$var$GridScrollAreaContent, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        ref: rootRef,
        getCanScrollMore: getCanScrollMore,
        style: style,
        handleDragOver: handleDragOver
    }));
}
const $b1dde8abe2995993$var$GridScrollAreaContent = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridScrollAreaContent(props, ref) {
    const { scrollDirection: scrollDirection, getCanScrollMore: getCanScrollMore, style: style, handleDragOver: handleDragOver } = props;
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const [canScrollMore, setCanScrollMore] = $lCzvA.useState(getCanScrollMore);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootProps, {
        scrollDirection: scrollDirection
    });
    const classes = $b1dde8abe2995993$var$useUtilityClasses(ownerState);
    const handleScrolling = ()=>{
        setCanScrollMore(getCanScrollMore);
    };
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'scrollPositionChange', handleScrolling);
    if (!canScrollMore) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($b1dde8abe2995993$var$GridScrollAreaRawRoot, {
        ref: ref,
        className: classes.root,
        ownerState: ownerState,
        onDragOver: handleDragOver,
        style: style
    });
});
const $b1dde8abe2995993$export$40bcbdb719b20690 = (0, $87d1c781e22c5bac$export$fa306e0bc9a9d6b4)($b1dde8abe2995993$var$GridScrollAreaWrapper);








var $lCzvA = parcelRequire("lCzvA");

var $dAQd3 = parcelRequire("dAQd3");




var $0d3f4dda8899e608$exports = {};
"use strict";
var $dbda49f9ea9a1144$exports = {};

var $8zDbG = parcelRequire("8zDbG");
var $dbda49f9ea9a1144$var$_typeof = $8zDbG.default;
function $dbda49f9ea9a1144$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($dbda49f9ea9a1144$exports = $dbda49f9ea9a1144$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != $dbda49f9ea9a1144$var$_typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, $dbda49f9ea9a1144$exports.__esModule = true, $dbda49f9ea9a1144$exports["default"] = $dbda49f9ea9a1144$exports)(e, t);
}
$dbda49f9ea9a1144$exports = $dbda49f9ea9a1144$var$_interopRequireWildcard, $dbda49f9ea9a1144$exports.__esModule = true, $dbda49f9ea9a1144$exports["default"] = $dbda49f9ea9a1144$exports;


var $0d3f4dda8899e608$require$_interopRequireWildcard = $dbda49f9ea9a1144$exports.default;
Object.defineProperty($0d3f4dda8899e608$exports, "__esModule", {
    value: true
});
$0d3f4dda8899e608$exports.default = void 0;

var $0d3f4dda8899e608$var$React = $0d3f4dda8899e608$require$_interopRequireWildcard((parcelRequire("lCzvA")));
var $0d3f4dda8899e608$var$_default = $0d3f4dda8899e608$exports.default = parseInt($0d3f4dda8899e608$var$React.version, 10);







var $lCzvA = parcelRequire("lCzvA");

const $56ce8aade9e94728$var$noop = ()=>{};
const $56ce8aade9e94728$export$a3576ea6e6df583c = (condition, effect)=>{
    const didRun = $lCzvA.useRef(false);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (didRun.current || !condition) return $56ce8aade9e94728$var$noop;
        didRun.current = true;
        return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        didRun.current || condition
    ]);
};









/**
 * @category Sorting
 * @ignore - do not document.
 */ const $32a7c18be453c9d5$var$gridSortingStateSelector = (state)=>state.sorting;
const $32a7c18be453c9d5$export$e4979ad0a2db8752 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($32a7c18be453c9d5$var$gridSortingStateSelector, (sortingState)=>sortingState.sortedRows);
const $32a7c18be453c9d5$export$8919e81647813e61 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($32a7c18be453c9d5$export$e4979ad0a2db8752, (0, $68327dddce1a2c68$export$37767f9110c99048), (0, $68327dddce1a2c68$export$de9a43d646a9821d), (sortedIds, idRowsLookup, rowTree)=>sortedIds.reduce((acc, id)=>{
        const model = idRowsLookup[id];
        if (model) acc.push({
            id: id,
            model: model
        });
        else {
            const rowNode = rowTree[id];
            if (rowNode && (0, $dc4fe3453cdb0a0a$export$5f983e16b1e55860)(rowNode)) acc.push({
                id: id,
                model: {
                    [(0, $dc4fe3453cdb0a0a$export$e8632b32bb8837db)]: id
                }
            });
        }
        return acc;
    }, []));
const $32a7c18be453c9d5$export$55dcc66b73d9a0f9 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($32a7c18be453c9d5$var$gridSortingStateSelector, (sorting)=>sorting.sortModel);
const $32a7c18be453c9d5$export$4dfdcc434a6c5081 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($32a7c18be453c9d5$export$55dcc66b73d9a0f9, (sortModel)=>{
    const result = sortModel.reduce((res, sortItem, index)=>{
        res[sortItem.field] = {
            sortDirection: sortItem.sort,
            sortIndex: sortModel.length > 1 ? index + 1 : undefined
        };
        return res;
    }, {});
    return result;
});
const $32a7c18be453c9d5$export$d0aac76ef888d9fe = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($32a7c18be453c9d5$export$e4979ad0a2db8752, (sortedIds)=>{
    return sortedIds.reduce((acc, id, index)=>{
        acc[id] = index;
        return acc;
    }, Object.create(null));
});




/**
 * @category Filtering
 */ const $6450fc0917754b27$var$gridFilterStateSelector = (state)=>state.filter;
const $6450fc0917754b27$export$280aedb9454597a5 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($6450fc0917754b27$var$gridFilterStateSelector, (filterState)=>filterState.filterModel);
const $6450fc0917754b27$export$6f9fe133e2c56816 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($6450fc0917754b27$export$280aedb9454597a5, (filterModel)=>filterModel.quickFilterValues);
const $6450fc0917754b27$export$7dcadad908a379a4 = (state)=>state.visibleRowsLookup;
const $6450fc0917754b27$export$6d031b6e8cbaf41c = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($6450fc0917754b27$var$gridFilterStateSelector, (filterState)=>filterState.filteredRowsLookup);
const $6450fc0917754b27$export$5f10eab80a0f79a0 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($6450fc0917754b27$var$gridFilterStateSelector, (filterState)=>filterState.filteredChildrenCountLookup);
const $6450fc0917754b27$export$28e99d5260ff82e7 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($6450fc0917754b27$var$gridFilterStateSelector, (filterState)=>filterState.filteredDescendantCountLookup);
const $6450fc0917754b27$export$2f31562143a3e5d4 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($6450fc0917754b27$export$7dcadad908a379a4, (0, $32a7c18be453c9d5$export$8919e81647813e61), (0, $68327dddce1a2c68$export$4cdbe576751dd8e2), $6450fc0917754b27$export$280aedb9454597a5, $6450fc0917754b27$export$6f9fe133e2c56816, (visibleRowsLookup, sortedRows, maxDepth, filterModel, quickFilterValues)=>{
    if (maxDepth < 2 && !filterModel.items.length && !quickFilterValues?.length) return sortedRows;
    return sortedRows.filter((row)=>visibleRowsLookup[row.id] !== false);
});
const $6450fc0917754b27$export$7a99837e2fd93e42 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($6450fc0917754b27$export$2f31562143a3e5d4, (visibleSortedRowEntries)=>visibleSortedRowEntries.map((row)=>row.id));
const $6450fc0917754b27$export$cd53824a2b232e36 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($6450fc0917754b27$export$6d031b6e8cbaf41c, (0, $32a7c18be453c9d5$export$8919e81647813e61), (filteredRowsLookup, sortedRows)=>sortedRows.filter((row)=>filteredRowsLookup[row.id] !== false));
const $6450fc0917754b27$export$4e2a9d76902d271c = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($6450fc0917754b27$export$cd53824a2b232e36, (filteredSortedRowEntries)=>filteredSortedRowEntries.map((row)=>row.id));
const $6450fc0917754b27$export$a77377d29742e9a9 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($6450fc0917754b27$export$7a99837e2fd93e42, (0, $68327dddce1a2c68$export$de9a43d646a9821d), (visibleSortedRowIds, rowTree)=>{
    const depthPositionCounter = {};
    let lastDepth = 0;
    return visibleSortedRowIds.reduce((acc, rowId)=>{
        const rowNode = rowTree[rowId];
        if (!depthPositionCounter[rowNode.depth]) depthPositionCounter[rowNode.depth] = 0;
        // going deeper in the tree should reset the counter
        // since it might have been used in some other branch at the same level, up in the tree
        // going back up should keep the counter and continue where it left off
        if (rowNode.depth > lastDepth) depthPositionCounter[rowNode.depth] = 0;
        lastDepth = rowNode.depth;
        depthPositionCounter[rowNode.depth] += 1;
        acc[rowId] = depthPositionCounter[rowNode.depth];
        return acc;
    }, {});
});
const $6450fc0917754b27$export$b8a7110d1a4c4623 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($6450fc0917754b27$export$2f31562143a3e5d4, (0, $68327dddce1a2c68$export$de9a43d646a9821d), (0, $68327dddce1a2c68$export$4cdbe576751dd8e2), (visibleSortedRows, rowTree, rowTreeDepth)=>{
    if (rowTreeDepth < 2) return visibleSortedRows;
    return visibleSortedRows.filter((row)=>rowTree[row.id]?.depth === 0);
});
const $6450fc0917754b27$export$96919017bbfaec0d = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($6450fc0917754b27$export$2f31562143a3e5d4, (visibleSortedRows)=>visibleSortedRows.length);
const $6450fc0917754b27$export$f88efd30675963d1 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($6450fc0917754b27$export$b8a7110d1a4c4623, (visibleSortedTopLevelRows)=>visibleSortedTopLevelRows.length);
const $6450fc0917754b27$export$ee3e723e6d15f78c = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($6450fc0917754b27$export$cd53824a2b232e36, (filteredSortedRowEntries)=>filteredSortedRowEntries.length);
const $6450fc0917754b27$export$821b542222c57b39 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($6450fc0917754b27$export$ee3e723e6d15f78c, $6450fc0917754b27$export$f88efd30675963d1, (totalRowCount, topLevelRowCount)=>totalRowCount - topLevelRowCount);
const $6450fc0917754b27$export$c7447bfbd4ecafcc = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($6450fc0917754b27$export$280aedb9454597a5, (0, $8b99503000dd62d3$export$8a3a9a6db584d7fd), (filterModel, columnLookup)=>filterModel.items?.filter((item)=>{
        if (!item.field) return false;
        const column = columnLookup[item.field];
        if (!column?.filterOperators || column?.filterOperators?.length === 0) return false;
        const filterOperator = column.filterOperators.find((operator)=>operator.value === item.operator);
        if (!filterOperator) return false;
        return !filterOperator.InputComponent || item.value != null && item.value?.toString() !== '';
    }));
const $6450fc0917754b27$export$6b2da1ecc84b757a = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($6450fc0917754b27$export$c7447bfbd4ecafcc, (activeFilters)=>{
    const result = activeFilters.reduce((res, filterItem)=>{
        if (!res[filterItem.field]) res[filterItem.field] = [
            filterItem
        ];
        else res[filterItem.field].push(filterItem);
        return res;
    }, {});
    return result;
});




const $2713a9cad4802e96$var$MAX_PAGE_SIZE = 100;
const $2713a9cad4802e96$export$d515e179bb47bd84 = (autoPageSize)=>autoPageSize ? 0 : 100;
const $2713a9cad4802e96$export$b287f0ca5dbff6af = (rowCount, pageSize, page)=>{
    if (pageSize > 0 && rowCount > 0) return Math.ceil(rowCount / pageSize);
    if (rowCount === -1) // With unknown row-count, we can assume a page after the current one
    return page + 2;
    return 0;
};
const $2713a9cad4802e96$export$73aa7e9d0fff5ee4 = (autoPageSize)=>({
        page: 0,
        pageSize: autoPageSize ? 0 : 100
    });
const $2713a9cad4802e96$export$41142e40198ee144 = (page, pageCount = 0)=>{
    if (pageCount === 0) return page;
    return Math.max(Math.min(page, pageCount - 1), 0);
};
const $2713a9cad4802e96$export$d3cf54bfe8b6931 = (pageSize, signatureProp)=>{
    if (signatureProp === (0, $ecad0fba09446fc0$export$544be0bdf85b5af1).DataGrid && pageSize > $2713a9cad4802e96$var$MAX_PAGE_SIZE) throw new Error([
        'MUI X: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.',
        'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
    ].join('\n'));
};


const $017d03038815cc56$var$ALL_RESULTS_PAGE_VALUE = -1;
const $017d03038815cc56$export$24c945ea033ce6cf = (state)=>state.pagination;
const $017d03038815cc56$export$19be8ebb403c941f = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($017d03038815cc56$export$24c945ea033ce6cf, (pagination)=>pagination.enabled && pagination.paginationMode === 'client');
const $017d03038815cc56$export$ccc9f04e59d0d8e6 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($017d03038815cc56$export$24c945ea033ce6cf, (pagination)=>pagination.paginationModel);
const $017d03038815cc56$export$946e4ae85da77ef6 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($017d03038815cc56$export$24c945ea033ce6cf, (pagination)=>pagination.rowCount);
const $017d03038815cc56$export$4dee702a38e33bdb = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($017d03038815cc56$export$24c945ea033ce6cf, (pagination)=>pagination.meta);
const $017d03038815cc56$export$1f7f64fcb62ccdad = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($017d03038815cc56$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.page);
const $017d03038815cc56$export$721a46720a2de097 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($017d03038815cc56$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.pageSize);
const $017d03038815cc56$export$b81026f1aaf843a4 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($017d03038815cc56$export$ccc9f04e59d0d8e6, $017d03038815cc56$export$946e4ae85da77ef6, (paginationModel, rowCount)=>(0, $2713a9cad4802e96$export$b287f0ca5dbff6af)(rowCount, paginationModel.pageSize, paginationModel.page));
const $017d03038815cc56$export$b76c99ac6ae901da = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($017d03038815cc56$export$19be8ebb403c941f, $017d03038815cc56$export$ccc9f04e59d0d8e6, (0, $68327dddce1a2c68$export$de9a43d646a9821d), (0, $68327dddce1a2c68$export$4cdbe576751dd8e2), (0, $6450fc0917754b27$export$2f31562143a3e5d4), (0, $6450fc0917754b27$export$b8a7110d1a4c4623), (clientSidePaginationEnabled, paginationModel, rowTree, rowTreeDepth, visibleSortedRowEntries, visibleSortedTopLevelRowEntries)=>{
    if (!clientSidePaginationEnabled) return null;
    const visibleTopLevelRowCount = visibleSortedTopLevelRowEntries.length;
    const topLevelFirstRowIndex = Math.min(paginationModel.pageSize * paginationModel.page, visibleTopLevelRowCount - 1);
    const topLevelLastRowIndex = paginationModel.pageSize === $017d03038815cc56$var$ALL_RESULTS_PAGE_VALUE ? visibleTopLevelRowCount - 1 : Math.min(topLevelFirstRowIndex + paginationModel.pageSize - 1, visibleTopLevelRowCount - 1);
    // The range contains no element
    if (topLevelFirstRowIndex === -1 || topLevelLastRowIndex === -1) return null;
    // The tree is flat, there is no need to look for children
    if (rowTreeDepth < 2) return {
        firstRowIndex: topLevelFirstRowIndex,
        lastRowIndex: topLevelLastRowIndex
    };
    const topLevelFirstRow = visibleSortedTopLevelRowEntries[topLevelFirstRowIndex];
    const topLevelRowsInCurrentPageCount = topLevelLastRowIndex - topLevelFirstRowIndex + 1;
    const firstRowIndex = visibleSortedRowEntries.findIndex((row)=>row.id === topLevelFirstRow.id);
    let lastRowIndex = firstRowIndex;
    let topLevelRowAdded = 0;
    while(lastRowIndex < visibleSortedRowEntries.length && topLevelRowAdded <= topLevelRowsInCurrentPageCount){
        const row = visibleSortedRowEntries[lastRowIndex];
        const depth = rowTree[row.id]?.depth;
        if (depth === undefined) lastRowIndex += 1;
        else {
            if (topLevelRowAdded < topLevelRowsInCurrentPageCount || depth > 0) lastRowIndex += 1;
            if (depth === 0) topLevelRowAdded += 1;
        }
    }
    return {
        firstRowIndex: firstRowIndex,
        lastRowIndex: lastRowIndex - 1
    };
});
const $017d03038815cc56$export$abcd649e974e3e96 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)((0, $6450fc0917754b27$export$2f31562143a3e5d4), $017d03038815cc56$export$b76c99ac6ae901da, (visibleSortedRowEntries, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowEntries.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const $017d03038815cc56$export$c1f6a976375edd4a = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)((0, $6450fc0917754b27$export$7a99837e2fd93e42), $017d03038815cc56$export$b76c99ac6ae901da, (visibleSortedRowIds, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowIds.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const $017d03038815cc56$export$33f627fc0fc60be4 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($017d03038815cc56$export$19be8ebb403c941f, $017d03038815cc56$export$b76c99ac6ae901da, $017d03038815cc56$export$abcd649e974e3e96, (0, $6450fc0917754b27$export$2f31562143a3e5d4), (clientPaginationEnabled, paginationRowRange, paginationRows, expandedSortedRowEntries)=>{
    if (clientPaginationEnabled) return {
        rows: paginationRows,
        range: paginationRowRange,
        rowToIndexMap: paginationRows.reduce((lookup, row, index)=>{
            lookup.set(row.model, index);
            return lookup;
        }, new Map())
    };
    return {
        rows: expandedSortedRowEntries,
        range: expandedSortedRowEntries.length === 0 ? null : {
            firstRowIndex: 0,
            lastRowIndex: expandedSortedRowEntries.length - 1
        },
        rowToIndexMap: expandedSortedRowEntries.reduce((lookup, row, index)=>{
            lookup.set(row.model, index);
            return lookup;
        }, new Map())
    };
});



const $6b6f708ce7819830$export$79b9fa322a34430b = (apiRef, props)=>{
    return (0, $017d03038815cc56$export$33f627fc0fc60be4)(apiRef);
};
const $6b6f708ce7819830$export$d1914c80ff11e37a = (apiRef, props)=>{
    return (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $017d03038815cc56$export$33f627fc0fc60be4));
};



const $aae24d054890a8b5$var$userAgent = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : 'empty';
const $aae24d054890a8b5$export$b7d78993b74f766d = $aae24d054890a8b5$var$userAgent.includes('firefox');





const $0bfb640e213a706f$export$f663bee74a6091fc = (state)=>state.rowSelection;
const $0bfb640e213a706f$export$2e16a09b9ae82bd3 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($0bfb640e213a706f$export$f663bee74a6091fc, (selection)=>selection.length);
const $0bfb640e213a706f$export$dd53f67f8b4cd8b1 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($0bfb640e213a706f$export$f663bee74a6091fc, (0, $68327dddce1a2c68$export$37767f9110c99048), (selectedRows, rowsLookup)=>new Map(selectedRows.map((id)=>[
            id,
            rowsLookup[id]
        ])));
const $0bfb640e213a706f$export$d5aede24ebfe3c98 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($0bfb640e213a706f$export$f663bee74a6091fc, (selection)=>selection.reduce((lookup, rowId)=>{
        lookup[rowId] = rowId;
        return lookup;
    }, {}));





const $c79669abb772bd0a$export$38fd8a77b05bfddf = (state)=>state.virtualization;
const $c79669abb772bd0a$export$fb3400598da0ae89 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c79669abb772bd0a$export$38fd8a77b05bfddf, (state)=>state.enabled);
const $c79669abb772bd0a$export$ad2aa1e9d465cafa = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c79669abb772bd0a$export$38fd8a77b05bfddf, (state)=>state.enabledForColumns);
const $c79669abb772bd0a$export$896d309ea36b40bd = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c79669abb772bd0a$export$38fd8a77b05bfddf, (state)=>state.enabledForRows);
const $c79669abb772bd0a$export$4cf9f333a030f780 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c79669abb772bd0a$export$38fd8a77b05bfddf, (state)=>state.renderContext);
const $c79669abb772bd0a$export$3a5705edd3d1af7e = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)((state)=>state.virtualization.renderContext.firstColumnIndex, (state)=>state.virtualization.renderContext.lastColumnIndex, (firstColumnIndex, lastColumnIndex)=>({
        firstColumnIndex: firstColumnIndex,
        lastColumnIndex: lastColumnIndex
    }));




var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");

function $05d95cd1fe366fb9$export$739f6b6a65e76d6c(privateApiRef, apiMethods, visibility) {
    const isFirstRender = $lCzvA.useRef(true);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        isFirstRender.current = false;
        privateApiRef.current.register(visibility, apiMethods);
    }, [
        privateApiRef,
        visibility,
        apiMethods
    ]);
    if (isFirstRender.current) privateApiRef.current.register(visibility, apiMethods);
}


const $09cd0e588d664565$export$27eb37bbcd78f450 = {
    firstRowIndex: 0,
    lastRowIndex: 0,
    firstColumnIndex: 0,
    lastColumnIndex: 0
};
const $09cd0e588d664565$export$42963ad70bb69f54 = (state, props)=>{
    const { disableVirtualization: disableVirtualization, autoHeight: autoHeight } = props;
    const virtualization = {
        enabled: !disableVirtualization,
        enabledForColumns: !disableVirtualization,
        enabledForRows: !disableVirtualization && !autoHeight,
        renderContext: $09cd0e588d664565$export$27eb37bbcd78f450
    };
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        virtualization: virtualization
    });
};
function $09cd0e588d664565$export$aa0d6df32cccbd53(apiRef, props) {
    /*
   * API METHODS
   */ const setVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                virtualization: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.virtualization, {
                    enabled: enabled,
                    enabledForColumns: enabled,
                    enabledForRows: enabled && !props.autoHeight
                })
            }));
    };
    const setColumnVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                virtualization: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.virtualization, {
                    enabledForColumns: enabled
                })
            }));
    };
    const api = {
        unstable_setVirtualization: setVirtualization,
        unstable_setColumnVirtualization: setColumnVirtualization
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, api, 'public');
    /*
   * EFFECTS
   */ /* eslint-disable react-hooks/exhaustive-deps */ $lCzvA.useEffect(()=>{
        setVirtualization(!props.disableVirtualization);
    }, [
        props.disableVirtualization,
        props.autoHeight
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }



const $cf3aae06b42627ec$var$gridRowSpanningStateSelector = (state)=>state.rowSpanning;
const $cf3aae06b42627ec$export$229eb2b26df25c76 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($cf3aae06b42627ec$var$gridRowSpanningStateSelector, (rowSpanning)=>rowSpanning.hiddenCells);
const $cf3aae06b42627ec$export$bd3ea60af8c4907f = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($cf3aae06b42627ec$var$gridRowSpanningStateSelector, (rowSpanning)=>rowSpanning.spannedCells);
const $cf3aae06b42627ec$export$e64f0d3660d5db6b = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($cf3aae06b42627ec$var$gridRowSpanningStateSelector, (rowSpanning)=>rowSpanning.hiddenCellOriginMap);


/**
 * Get the list column definition
 * @category List View
 * @ignore - Do not document
 */ const $a014507b13bf83e2$export$aeeda57ada9bc1ee = (state)=>state.listViewColumn;










const $c2be356cc77cce81$export$ce21bef7bd3a9c4e = (state)=>state.focus;
const $c2be356cc77cce81$export$74af8aada6269d3 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c2be356cc77cce81$export$ce21bef7bd3a9c4e, (focusState)=>focusState.cell);
const $c2be356cc77cce81$export$cefd405855792f4a = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c2be356cc77cce81$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeader);
const $c2be356cc77cce81$export$50853df99eaddaf5 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c2be356cc77cce81$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeaderFilter);
const $c2be356cc77cce81$export$3eeedc3f7263df61 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c2be356cc77cce81$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnGroupHeader);
const $c2be356cc77cce81$export$3ab3abde27f70192 = (state)=>state.tabIndex;
const $c2be356cc77cce81$export$2c47652a1f657d56 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c2be356cc77cce81$export$3ab3abde27f70192, (state)=>state.cell);
const $c2be356cc77cce81$export$29da670438604dbd = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c2be356cc77cce81$export$3ab3abde27f70192, (state)=>state.columnHeader);
const $c2be356cc77cce81$export$441ae2090306a1e2 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c2be356cc77cce81$export$3ab3abde27f70192, (state)=>state.columnHeaderFilter);
const $c2be356cc77cce81$export$37a54bd010f498d2 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($c2be356cc77cce81$export$3ab3abde27f70192, (state)=>state.columnGroupHeader);




const $7aa25e5066404ffa$var$gridIsFocusedCellOutOfContext = (0, $deae25339410ed5d$export$595d22ed68ca2841)((0, $c2be356cc77cce81$export$74af8aada6269d3), (0, $c79669abb772bd0a$export$4cf9f333a030f780), (0, $017d03038815cc56$export$33f627fc0fc60be4), (0, $8b99503000dd62d3$export$16a65a9447d3dda9), (0, $68327dddce1a2c68$export$37767f9110c99048), (focusedCell, renderContext, currentPage, visibleColumns, rows)=>{
    if (!focusedCell) return false;
    const row = rows[focusedCell.id];
    if (!row) return false;
    const rowIndex = currentPage.rowToIndexMap.get(row);
    const columnIndex = visibleColumns.slice(renderContext.firstColumnIndex, renderContext.lastColumnIndex).findIndex((column)=>column.field === focusedCell.field);
    const isInRenderContext = rowIndex !== undefined && columnIndex !== -1 && rowIndex >= renderContext.firstRowIndex && rowIndex <= renderContext.lastRowIndex;
    return !isInRenderContext;
});
const $7aa25e5066404ffa$export$6082669fb6748800 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($7aa25e5066404ffa$var$gridIsFocusedCellOutOfContext, (0, $8b99503000dd62d3$export$16a65a9447d3dda9), (0, $017d03038815cc56$export$33f627fc0fc60be4), (0, $68327dddce1a2c68$export$37767f9110c99048), (0, $c2be356cc77cce81$export$74af8aada6269d3), (isFocusedCellOutOfRenderContext, visibleColumns, currentPage, rows, focusedCell)=>{
    if (!isFocusedCellOutOfRenderContext) return null;
    const row = rows[focusedCell.id];
    if (!row) return null;
    const rowIndex = currentPage.rowToIndexMap.get(row);
    if (rowIndex === undefined) return null;
    const columnIndex = visibleColumns.findIndex((column)=>column.field === focusedCell.field);
    if (columnIndex === -1) return null;
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, focusedCell, {
        rowIndex: rowIndex,
        columnIndex: columnIndex
    });
});


function $75a73207cfe0ae7e$export$28cd30446ab5724a(value, decimals) {
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
}


const $9234f987c3e65965$export$c8f880a2d81914c4 = typeof window !== 'undefined' && /jsdom|HappyDOM/.test(window.navigator.userAgent);



const $2b0e72b73973ab3a$var$MINIMUM_COLUMN_WIDTH = 50;
var $2b0e72b73973ab3a$var$ScrollDirection = /*#__PURE__*/ function(ScrollDirection) {
    ScrollDirection[ScrollDirection["NONE"] = 0] = "NONE";
    ScrollDirection[ScrollDirection["UP"] = 1] = "UP";
    ScrollDirection[ScrollDirection["DOWN"] = 2] = "DOWN";
    ScrollDirection[ScrollDirection["LEFT"] = 3] = "LEFT";
    ScrollDirection[ScrollDirection["RIGHT"] = 4] = "RIGHT";
    return ScrollDirection;
}($2b0e72b73973ab3a$var$ScrollDirection || {});
const $2b0e72b73973ab3a$var$EMPTY_SCROLL_POSITION = {
    top: 0,
    left: 0
};
const $2b0e72b73973ab3a$export$68a3509179402d90 = Object.freeze(new Map());
const $2b0e72b73973ab3a$var$createScrollCache = (isRtl, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer)=>({
        direction: $2b0e72b73973ab3a$var$ScrollDirection.NONE,
        buffer: $2b0e72b73973ab3a$var$bufferForDirection(isRtl, $2b0e72b73973ab3a$var$ScrollDirection.NONE, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer)
    });
const $2b0e72b73973ab3a$export$fbe94079134c8d27 = ()=>{
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const { unstable_listView: listView } = rootProps;
    const visibleColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, ()=>listView ? [
            (0, $a014507b13bf83e2$export$aeeda57ada9bc1ee)(apiRef.current.state)
        ] : (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef));
    const enabledForRows = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $c79669abb772bd0a$export$896d309ea36b40bd)) && !(0, $9234f987c3e65965$export$c8f880a2d81914c4);
    const enabledForColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $c79669abb772bd0a$export$ad2aa1e9d465cafa)) && !(0, $9234f987c3e65965$export$c8f880a2d81914c4);
    const pinnedRows = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$ffe7071c481e32b0));
    const pinnedColumnDefinitions = (0, $8b99503000dd62d3$export$297e8079713afa11)(apiRef);
    const pinnedColumns = listView ? (0, $1d134ed1d4a5dbe8$export$77439b544edbbd66) : pinnedColumnDefinitions;
    const hasBottomPinnedRows = pinnedRows.bottom.length > 0;
    const [panels, setPanels] = $lCzvA.useState($2b0e72b73973ab3a$export$68a3509179402d90);
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const selectedRowsLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $0bfb640e213a706f$export$d5aede24ebfe3c98));
    const currentPage = (0, $6b6f708ce7819830$export$d1914c80ff11e37a)(apiRef);
    const mainRef = apiRef.current.mainElementRef;
    const scrollerRef = apiRef.current.virtualScrollerRef;
    const scrollbarVerticalRef = apiRef.current.virtualScrollbarVerticalRef;
    const scrollbarHorizontalRef = apiRef.current.virtualScrollbarHorizontalRef;
    const hasColSpan = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$7aac81e7227448b4));
    const isRenderContextReady = $lCzvA.useRef(false);
    const rowHeight = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$2ca09da26466c31a));
    const contentHeight = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$83bdaba2ad532c80));
    const columnsTotalWidth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$ab20f9d33edc7794));
    const needsHorizontalScrollbar = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, $2b0e72b73973ab3a$var$needsHorizontalScrollbarSelector);
    const verticalScrollbarWidth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$6615095b3c921727));
    const gridHasFiller = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$34d7a8c547584228));
    const previousSize = $lCzvA.useRef(null);
    const mainRefCallback = $lCzvA.useCallback((node)=>{
        mainRef.current = node;
        if (!node) return undefined;
        const initialRect = node.getBoundingClientRect();
        let lastSize = {
            width: (0, $75a73207cfe0ae7e$export$28cd30446ab5724a)(initialRect.width, 1),
            height: (0, $75a73207cfe0ae7e$export$28cd30446ab5724a)(initialRect.height, 1)
        };
        if (!previousSize.current || lastSize.width !== previousSize.current.width && lastSize.height !== previousSize.current.height) {
            previousSize.current = lastSize;
            apiRef.current.publishEvent('resize', lastSize);
        }
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver((entries)=>{
            const entry = entries[0];
            if (!entry) return;
            const newSize = {
                width: (0, $75a73207cfe0ae7e$export$28cd30446ab5724a)(entry.contentRect.width, 1),
                height: (0, $75a73207cfe0ae7e$export$28cd30446ab5724a)(entry.contentRect.height, 1)
            };
            if (newSize.width === lastSize.width && newSize.height === lastSize.height) return;
            apiRef.current.publishEvent('resize', newSize);
            lastSize = newSize;
        });
        observer.observe(node);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0d3f4dda8899e608$exports))) >= 19) return ()=>{
            mainRef.current = null;
            observer.disconnect();
        };
        return undefined;
    }, [
        apiRef,
        mainRef
    ]);
    /*
   * Scroll context logic
   * ====================
   * We only render the cells contained in the `renderContext`. However, when the user starts scrolling the grid
   * in a direction, we want to render as many cells as possible in that direction, as to avoid presenting white
   * areas if the user scrolls too fast/far and the viewport ends up in a region we haven't rendered yet. To render
   * more cells, we store some offsets to add to the viewport in `scrollCache.buffer`. Those offsets make the render
   * context wider in the direction the user is going, but also makes the buffer around the viewport `0` for the
   * dimension (horizontal or vertical) in which the user is not scrolling. So if the normal viewport is 8 columns
   * wide, with a 1 column buffer (10 columns total), then we want it to be exactly 8 columns wide during vertical
   * scroll.
   * However, we don't want the rows in the old context to re-render from e.g. 10 columns to 8 columns, because that's
   * work that's not necessary. Thus we store the context at the start of the scroll in `frozenContext`, and the rows
   * that are part of this old context will keep their same render context as to avoid re-rendering.
   */ const scrollPosition = $lCzvA.useRef(rootProps.initialState?.scroll ?? $2b0e72b73973ab3a$var$EMPTY_SCROLL_POSITION);
    const ignoreNextScrollEvent = $lCzvA.useRef(false);
    const previousContextScrollPosition = $lCzvA.useRef($2b0e72b73973ab3a$var$EMPTY_SCROLL_POSITION);
    const previousRowContext = $lCzvA.useRef((0, $09cd0e588d664565$export$27eb37bbcd78f450));
    const renderContext = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $c79669abb772bd0a$export$4cf9f333a030f780));
    const focusedVirtualCell = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $7aa25e5066404ffa$export$6082669fb6748800));
    const scrollTimeout = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const frozenContext = $lCzvA.useRef(undefined);
    const scrollCache = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)(()=>$2b0e72b73973ab3a$var$createScrollCache(isRtl, rootProps.rowBufferPx, rootProps.columnBufferPx, rowHeight * 15, $2b0e72b73973ab3a$var$MINIMUM_COLUMN_WIDTH * 6)).current;
    const updateRenderContext = $lCzvA.useCallback((nextRenderContext)=>{
        if ($2b0e72b73973ab3a$export$6eb241d16b36f3b8(nextRenderContext, apiRef.current.state.virtualization.renderContext)) return;
        const didRowsIntervalChange = nextRenderContext.firstRowIndex !== previousRowContext.current.firstRowIndex || nextRenderContext.lastRowIndex !== previousRowContext.current.lastRowIndex;
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                virtualization: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.virtualization, {
                    renderContext: nextRenderContext
                })
            });
        });
        // The lazy-loading hook is listening to `renderedRowsIntervalChange`,
        // but only does something if we already have a render context, because
        // otherwise we would call an update directly on mount
        const isReady = (0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state).isReady;
        if (isReady && didRowsIntervalChange) {
            previousRowContext.current = nextRenderContext;
            apiRef.current.publishEvent('renderedRowsIntervalChange', nextRenderContext);
        }
        previousContextScrollPosition.current = scrollPosition.current;
    }, [
        apiRef
    ]);
    const triggerUpdateRenderContext = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(()=>{
        const scroller = scrollerRef.current;
        if (!scroller) return undefined;
        const dimensions = (0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state);
        const maxScrollTop = Math.ceil(dimensions.minimumSize.height - dimensions.viewportOuterSize.height);
        const maxScrollLeft = Math.ceil(dimensions.minimumSize.width - dimensions.viewportInnerSize.width);
        // Clamp the scroll position to the viewport to avoid re-calculating the render context for scroll bounce
        const newScroll = {
            top: (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(scroller.scrollTop, 0, maxScrollTop),
            left: isRtl ? (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(scroller.scrollLeft, -maxScrollLeft, 0) : (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(scroller.scrollLeft, 0, maxScrollLeft)
        };
        const dx = newScroll.left - scrollPosition.current.left;
        const dy = newScroll.top - scrollPosition.current.top;
        const isScrolling = dx !== 0 || dy !== 0;
        scrollPosition.current = newScroll;
        const direction = isScrolling ? $2b0e72b73973ab3a$var$directionForDelta(dx, dy) : $2b0e72b73973ab3a$var$ScrollDirection.NONE;
        // Since previous render, we have scrolled...
        const rowScroll = Math.abs(scrollPosition.current.top - previousContextScrollPosition.current.top);
        const columnScroll = Math.abs(scrollPosition.current.left - previousContextScrollPosition.current.left);
        // PERF: use the computed minimum column width instead of a static one
        const didCrossThreshold = rowScroll >= rowHeight || columnScroll >= $2b0e72b73973ab3a$var$MINIMUM_COLUMN_WIDTH;
        const didChangeDirection = scrollCache.direction !== direction;
        const shouldUpdate = didCrossThreshold || didChangeDirection;
        if (!shouldUpdate) return renderContext;
        // Render a new context
        if (didChangeDirection) switch(direction){
            case $2b0e72b73973ab3a$var$ScrollDirection.NONE:
            case $2b0e72b73973ab3a$var$ScrollDirection.LEFT:
            case $2b0e72b73973ab3a$var$ScrollDirection.RIGHT:
                frozenContext.current = undefined;
                break;
            default:
                frozenContext.current = renderContext;
                break;
        }
        scrollCache.direction = direction;
        scrollCache.buffer = $2b0e72b73973ab3a$var$bufferForDirection(isRtl, direction, rootProps.rowBufferPx, rootProps.columnBufferPx, rowHeight * 15, $2b0e72b73973ab3a$var$MINIMUM_COLUMN_WIDTH * 6);
        const inputs = $2b0e72b73973ab3a$var$inputsSelector(apiRef, rootProps, enabledForRows, enabledForColumns);
        const nextRenderContext = $2b0e72b73973ab3a$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        if (!$2b0e72b73973ab3a$export$6eb241d16b36f3b8(nextRenderContext, renderContext)) {
            // Prevents batching render context changes
            $dAQd3.flushSync(()=>{
                updateRenderContext(nextRenderContext);
            });
            scrollTimeout.start(1000, triggerUpdateRenderContext);
        }
        return nextRenderContext;
    });
    const forceUpdateRenderContext = ()=>{
        // skip update if dimensions are not ready and virtualization is enabled
        if (!(0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state).isReady && (enabledForRows || enabledForColumns)) return;
        const inputs = $2b0e72b73973ab3a$var$inputsSelector(apiRef, rootProps, enabledForRows, enabledForColumns);
        const nextRenderContext = $2b0e72b73973ab3a$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        // Reset the frozen context when the render context changes, see the illustration in https://github.com/mui/mui-x/pull/12353
        frozenContext.current = undefined;
        updateRenderContext(nextRenderContext);
    };
    const handleScroll = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(()=>{
        if (ignoreNextScrollEvent.current) {
            ignoreNextScrollEvent.current = false;
            return;
        }
        const nextRenderContext = triggerUpdateRenderContext();
        apiRef.current.publishEvent('scrollPositionChange', {
            top: scrollPosition.current.top,
            left: scrollPosition.current.left,
            renderContext: nextRenderContext
        });
    });
    const handleWheel = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((event)=>{
        apiRef.current.publishEvent('virtualScrollerWheel', {}, event);
    });
    const handleTouchMove = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((event)=>{
        apiRef.current.publishEvent('virtualScrollerTouchMove', {}, event);
    });
    const getRows = (params = {})=>{
        if (!params.rows && !currentPage.range) return [];
        const rowTree = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef);
        let baseRenderContext = renderContext;
        if (params.renderContext) {
            baseRenderContext = params.renderContext;
            baseRenderContext.firstColumnIndex = renderContext.firstColumnIndex;
            baseRenderContext.lastColumnIndex = renderContext.lastColumnIndex;
        }
        const isLastSection = !hasBottomPinnedRows && params.position === undefined || hasBottomPinnedRows && params.position === 'bottom';
        const isPinnedSection = params.position !== undefined;
        let rowIndexOffset;
        // FIXME: Why is the switch check exhaustiveness not validated with typescript-eslint?
        // eslint-disable-next-line default-case
        switch(params.position){
            case 'top':
                rowIndexOffset = 0;
                break;
            case 'bottom':
                rowIndexOffset = pinnedRows.top.length + currentPage.rows.length;
                break;
            case undefined:
                rowIndexOffset = pinnedRows.top.length;
                break;
        }
        const rowModels = params.rows ?? currentPage.rows;
        const firstRowToRender = baseRenderContext.firstRowIndex;
        const lastRowToRender = Math.min(baseRenderContext.lastRowIndex, rowModels.length);
        const rowIndexes = params.rows ? (0, $ac3bd7253ec0e92a$export$d02631cccf789723)(0, params.rows.length) : (0, $ac3bd7253ec0e92a$export$d02631cccf789723)(firstRowToRender, lastRowToRender);
        let virtualRowIndex = -1;
        if (!isPinnedSection && focusedVirtualCell) {
            if (focusedVirtualCell.rowIndex < firstRowToRender) {
                rowIndexes.unshift(focusedVirtualCell.rowIndex);
                virtualRowIndex = focusedVirtualCell.rowIndex;
            }
            if (focusedVirtualCell.rowIndex > lastRowToRender) {
                rowIndexes.push(focusedVirtualCell.rowIndex);
                virtualRowIndex = focusedVirtualCell.rowIndex;
            }
        }
        const rows = [];
        const rowProps = rootProps.slotProps?.row;
        const columnPositions = (0, $8b99503000dd62d3$export$fce7d810e48021e3)(apiRef);
        rowIndexes.forEach((rowIndexInPage)=>{
            const { id: id, model: model } = rowModels[rowIndexInPage];
            // In certain cases, the state might already be updated and `currentPage.rows` (which sets `rowModels`)
            // contains stale data.
            // In that case, skip any further row processing.
            // See:
            // - https://github.com/mui/mui-x/issues/16638
            // - https://github.com/mui/mui-x/issues/17022
            if (!rowTree[id]) return;
            const rowIndex = (currentPage?.range?.firstRowIndex || 0) + rowIndexOffset + rowIndexInPage;
            // NOTE: This is an expensive feature, the colSpan code could be optimized.
            if (hasColSpan) {
                const minFirstColumn = pinnedColumns.left.length;
                const maxLastColumn = visibleColumns.length - pinnedColumns.right.length;
                apiRef.current.calculateColSpan({
                    rowId: id,
                    minFirstColumn: minFirstColumn,
                    maxLastColumn: maxLastColumn,
                    columns: visibleColumns
                });
                if (pinnedColumns.left.length > 0) apiRef.current.calculateColSpan({
                    rowId: id,
                    minFirstColumn: 0,
                    maxLastColumn: pinnedColumns.left.length,
                    columns: visibleColumns
                });
                if (pinnedColumns.right.length > 0) apiRef.current.calculateColSpan({
                    rowId: id,
                    minFirstColumn: visibleColumns.length - pinnedColumns.right.length,
                    maxLastColumn: visibleColumns.length,
                    columns: visibleColumns
                });
            }
            const baseRowHeight = !apiRef.current.rowHasAutoHeight(id) ? apiRef.current.unstable_getRowHeight(id) : 'auto';
            let isSelected;
            if (selectedRowsLookup[id] == null) isSelected = false;
            else isSelected = apiRef.current.isRowSelectable(id);
            let isFirstVisible = false;
            if (params.position === undefined) isFirstVisible = rowIndexInPage === 0;
            let isLastVisible = false;
            const isLastVisibleInSection = rowIndexInPage === rowModels.length - 1;
            if (isLastSection) {
                if (!isPinnedSection) {
                    const lastIndex = currentPage.rows.length - 1;
                    const isLastVisibleRowIndex = rowIndexInPage === lastIndex;
                    if (isLastVisibleRowIndex) isLastVisible = true;
                } else isLastVisible = isLastVisibleInSection;
            }
            let currentRenderContext = baseRenderContext;
            if (frozenContext.current && rowIndexInPage >= frozenContext.current.firstRowIndex && rowIndexInPage < frozenContext.current.lastRowIndex) currentRenderContext = frozenContext.current;
            const isVirtualFocusRow = rowIndexInPage === virtualRowIndex;
            const isVirtualFocusColumn = focusedVirtualCell?.rowIndex === rowIndex;
            const offsetLeft = $2b0e72b73973ab3a$export$fe1f1566870c3cbc(columnPositions, currentRenderContext, pinnedColumns.left.length);
            const showBottomBorder = isLastVisibleInSection && params.position === 'top';
            const firstColumnIndex = currentRenderContext.firstColumnIndex;
            const lastColumnIndex = currentRenderContext.lastColumnIndex;
            rows.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.row, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                row: model,
                rowId: id,
                index: rowIndex,
                selected: isSelected,
                offsetLeft: offsetLeft,
                columnsTotalWidth: columnsTotalWidth,
                rowHeight: baseRowHeight,
                pinnedColumns: pinnedColumns,
                visibleColumns: visibleColumns,
                firstColumnIndex: firstColumnIndex,
                lastColumnIndex: lastColumnIndex,
                focusedColumnIndex: isVirtualFocusColumn ? focusedVirtualCell.columnIndex : undefined,
                isFirstVisible: isFirstVisible,
                isLastVisible: isLastVisible,
                isNotVisible: isVirtualFocusRow,
                showBottomBorder: showBottomBorder,
                scrollbarWidth: verticalScrollbarWidth,
                gridHasFiller: gridHasFiller
            }, rowProps), id));
            if (isVirtualFocusRow) return;
            const panel = panels.get(id);
            if (panel) rows.push(panel);
            if (params.position === undefined && isLastVisibleInSection) rows.push(apiRef.current.getInfiniteLoadingTriggerElement?.({
                lastRowId: id
            }));
        });
        return rows;
    };
    const scrollerStyle = $lCzvA.useMemo(()=>({
            overflowX: !needsHorizontalScrollbar || listView ? 'hidden' : undefined,
            overflowY: rootProps.autoHeight ? 'hidden' : undefined
        }), [
        needsHorizontalScrollbar,
        rootProps.autoHeight,
        listView
    ]);
    const contentSize = $lCzvA.useMemo(()=>{
        const size = {
            width: needsHorizontalScrollbar ? columnsTotalWidth : 'auto',
            flexBasis: contentHeight,
            flexShrink: 0
        };
        if (size.flexBasis === 0) size.flexBasis = (0, $dc4fe3453cdb0a0a$export$a95780409968416e); // Give room to show the overlay when there no rows.
        return size;
    }, [
        columnsTotalWidth,
        contentHeight,
        needsHorizontalScrollbar
    ]);
    const onContentSizeApplied = $lCzvA.useCallback((node)=>{
        if (!node) return;
        apiRef.current.publishEvent('virtualScrollerContentSizeChange', {
            columnsTotalWidth: columnsTotalWidth,
            contentHeight: contentHeight
        });
    }, [
        apiRef,
        columnsTotalWidth,
        contentHeight
    ]);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (!isRenderContextReady.current) return;
        apiRef.current.updateRenderContext?.();
    }, [
        apiRef,
        enabledForColumns,
        enabledForRows
    ]);
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (listView) scrollerRef.current.scrollLeft = 0;
    }, [
        listView,
        scrollerRef
    ]);
    (0, $56ce8aade9e94728$export$a3576ea6e6df583c)(renderContext !== (0, $09cd0e588d664565$export$27eb37bbcd78f450), ()=>{
        apiRef.current.publishEvent('scrollPositionChange', {
            top: scrollPosition.current.top,
            left: scrollPosition.current.left,
            renderContext: renderContext
        });
        isRenderContextReady.current = true;
        if (rootProps.initialState?.scroll && scrollerRef.current) {
            const scroller = scrollerRef.current;
            const { top: top, left: left } = rootProps.initialState.scroll;
            // On initial mount, if we have columns available, we can restore the horizontal scroll immediately, but we need to skip the resulting scroll event, otherwise we would recalculate the render context at position top=0, left=restoredValue, but the initial render context is already calculated based on the initial value of scrollPosition ref.
            const isScrollRestored = {
                top: !(top > 0),
                left: !(left > 0)
            };
            if (!isScrollRestored.left && columnsTotalWidth) {
                scroller.scrollLeft = left;
                ignoreNextScrollEvent.current = true;
                isScrollRestored.left = true;
            }
            // For the sake of completeness, but I'm not sure if contentHeight is ever available at this point. Maybe when virtualisation is disabled?
            if (!isScrollRestored.top && contentHeight) {
                scroller.scrollTop = top;
                ignoreNextScrollEvent.current = true;
                isScrollRestored.top = true;
            }
            // To restore the vertical scroll, we need to wait until the rows are available in the DOM (otherwise there's nowhere to scroll), but before paint to avoid reflows
            if (!isScrollRestored.top || !isScrollRestored.left) {
                const unsubscribeContentSizeChange = apiRef.current.subscribeEvent('virtualScrollerContentSizeChange', (params)=>{
                    if (!isScrollRestored.left && params.columnsTotalWidth) {
                        scroller.scrollLeft = left;
                        ignoreNextScrollEvent.current = true;
                        isScrollRestored.left = true;
                    }
                    if (!isScrollRestored.top && params.contentHeight) {
                        scroller.scrollTop = top;
                        ignoreNextScrollEvent.current = true;
                        isScrollRestored.top = true;
                    }
                    if (isScrollRestored.left && isScrollRestored.top) unsubscribeContentSizeChange();
                });
                return unsubscribeContentSizeChange;
            }
        }
        return undefined;
    });
    apiRef.current.register('private', {
        updateRenderContext: forceUpdateRenderContext
    });
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'sortedRowsSet', forceUpdateRenderContext);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'paginationModelChange', forceUpdateRenderContext);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'columnsChange', forceUpdateRenderContext);
    return {
        renderContext: renderContext,
        setPanels: setPanels,
        getRows: getRows,
        getContainerProps: ()=>({
                ref: mainRefCallback
            }),
        getScrollerProps: ()=>({
                ref: scrollerRef,
                onScroll: handleScroll,
                onWheel: handleWheel,
                onTouchMove: handleTouchMove,
                style: scrollerStyle,
                role: 'presentation',
                // `tabIndex` shouldn't be used along role=presentation, but it fixes a Firefox bug
                // https://github.com/mui/mui-x/pull/13891#discussion_r1683416024
                tabIndex: $aae24d054890a8b5$export$b7d78993b74f766d ? -1 : undefined
            }),
        getContentProps: ()=>({
                style: contentSize,
                role: 'presentation',
                ref: onContentSizeApplied
            }),
        getRenderZoneProps: ()=>({
                role: 'rowgroup'
            }),
        getScrollbarVerticalProps: ()=>({
                ref: scrollbarVerticalRef,
                scrollPosition: scrollPosition
            }),
        getScrollbarHorizontalProps: ()=>({
                ref: scrollbarHorizontalRef,
                scrollPosition: scrollPosition
            }),
        getScrollAreaProps: ()=>({
                scrollPosition: scrollPosition
            })
    };
};
// dimension selectors
function $2b0e72b73973ab3a$var$needsHorizontalScrollbarSelector(state) {
    return state.dimensions.viewportOuterSize.width > 0 && state.dimensions.columnsTotalWidth > state.dimensions.viewportOuterSize.width;
}
function $2b0e72b73973ab3a$var$inputsSelector(apiRef, rootProps, enabledForRows, enabledForColumns) {
    const dimensions = (0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state);
    const currentPage = (0, $6b6f708ce7819830$export$79b9fa322a34430b)(apiRef, rootProps);
    const visibleColumns = rootProps.unstable_listView ? [
        (0, $a014507b13bf83e2$export$aeeda57ada9bc1ee)(apiRef.current.state)
    ] : (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef);
    const hiddenCellsOriginMap = (0, $cf3aae06b42627ec$export$e64f0d3660d5db6b)(apiRef);
    const lastRowId = apiRef.current.state.rows.dataRowIds.at(-1);
    const lastColumn = visibleColumns.at(-1);
    return {
        enabledForRows: enabledForRows,
        enabledForColumns: enabledForColumns,
        apiRef: apiRef,
        autoHeight: rootProps.autoHeight,
        rowBufferPx: rootProps.rowBufferPx,
        columnBufferPx: rootProps.columnBufferPx,
        leftPinnedWidth: dimensions.leftPinnedWidth,
        columnsTotalWidth: dimensions.columnsTotalWidth,
        viewportInnerWidth: dimensions.viewportInnerSize.width,
        viewportInnerHeight: dimensions.viewportInnerSize.height,
        lastRowHeight: lastRowId !== undefined ? apiRef.current.unstable_getRowHeight(lastRowId) : 0,
        lastColumnWidth: lastColumn?.computedWidth ?? 0,
        rowsMeta: (0, $ab89a1ec5ede86ad$export$4f32bfc70efeb4ab)(apiRef.current.state),
        columnPositions: (0, $8b99503000dd62d3$export$fce7d810e48021e3)(apiRef),
        rows: currentPage.rows,
        range: currentPage.range,
        pinnedColumns: (0, $8b99503000dd62d3$export$297e8079713afa11)(apiRef),
        visibleColumns: visibleColumns,
        hiddenCellsOriginMap: hiddenCellsOriginMap,
        listView: rootProps.unstable_listView ?? false,
        virtualizeColumnsWithAutoRowHeight: rootProps.virtualizeColumnsWithAutoRowHeight
    };
}
function $2b0e72b73973ab3a$var$computeRenderContext(inputs, scrollPosition, scrollCache) {
    const renderContext = {
        firstRowIndex: 0,
        lastRowIndex: inputs.rows.length,
        firstColumnIndex: 0,
        lastColumnIndex: inputs.visibleColumns.length
    };
    const { top: top, left: left } = scrollPosition;
    const realLeft = Math.abs(left) + inputs.leftPinnedWidth;
    if (inputs.enabledForRows) {
        // Clamp the value because the search may return an index out of bounds.
        // In the last index, this is not needed because Array.slice doesn't include it.
        let firstRowIndex = Math.min($2b0e72b73973ab3a$var$getNearestIndexToRender(inputs, top, {
            atStart: true,
            lastPosition: inputs.rowsMeta.positions[inputs.rowsMeta.positions.length - 1] + inputs.lastRowHeight
        }), inputs.rowsMeta.positions.length - 1);
        // If any of the cells in the `firstRowIndex` is hidden due to an extended row span,
        // Make sure the row from where the rowSpan is originated is visible.
        const rowSpanHiddenCellOrigin = inputs.hiddenCellsOriginMap[firstRowIndex];
        if (rowSpanHiddenCellOrigin) {
            const minSpannedRowIndex = Math.min(...Object.values(rowSpanHiddenCellOrigin));
            firstRowIndex = Math.min(firstRowIndex, minSpannedRowIndex);
        }
        const lastRowIndex = inputs.autoHeight ? firstRowIndex + inputs.rows.length : $2b0e72b73973ab3a$var$getNearestIndexToRender(inputs, top + inputs.viewportInnerHeight);
        renderContext.firstRowIndex = firstRowIndex;
        renderContext.lastRowIndex = lastRowIndex;
    }
    if (inputs.listView) return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, renderContext, {
        lastColumnIndex: 1
    });
    if (inputs.enabledForColumns) {
        let firstColumnIndex = 0;
        let lastColumnIndex = inputs.columnPositions.length;
        let hasRowWithAutoHeight = false;
        const [firstRowToRender, lastRowToRender] = $2b0e72b73973ab3a$var$getIndexesToRender({
            firstIndex: renderContext.firstRowIndex,
            lastIndex: renderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: inputs.rows.length,
            bufferBefore: scrollCache.buffer.rowBefore,
            bufferAfter: scrollCache.buffer.rowAfter,
            positions: inputs.rowsMeta.positions,
            lastSize: inputs.lastRowHeight
        });
        if (!inputs.virtualizeColumnsWithAutoRowHeight) for(let i = firstRowToRender; i < lastRowToRender && !hasRowWithAutoHeight; i += 1){
            const row = inputs.rows[i];
            hasRowWithAutoHeight = inputs.apiRef.current.rowHasAutoHeight(row.id);
        }
        if (!hasRowWithAutoHeight || inputs.virtualizeColumnsWithAutoRowHeight) {
            firstColumnIndex = $2b0e72b73973ab3a$var$binarySearch(realLeft, inputs.columnPositions, {
                atStart: true,
                lastPosition: inputs.columnsTotalWidth
            });
            lastColumnIndex = $2b0e72b73973ab3a$var$binarySearch(realLeft + inputs.viewportInnerWidth, inputs.columnPositions);
        }
        renderContext.firstColumnIndex = firstColumnIndex;
        renderContext.lastColumnIndex = lastColumnIndex;
    }
    const actualRenderContext = $2b0e72b73973ab3a$var$deriveRenderContext(inputs, renderContext, scrollCache);
    return actualRenderContext;
}
function $2b0e72b73973ab3a$var$getNearestIndexToRender(inputs, offset, options) {
    const lastMeasuredIndexRelativeToAllRows = inputs.apiRef.current.getLastMeasuredRowIndex();
    let allRowsMeasured = lastMeasuredIndexRelativeToAllRows === Infinity;
    if (inputs.range?.lastRowIndex && !allRowsMeasured) // Check if all rows in this page are already measured
    allRowsMeasured = lastMeasuredIndexRelativeToAllRows >= inputs.range.lastRowIndex;
    const lastMeasuredIndexRelativeToCurrentPage = (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(lastMeasuredIndexRelativeToAllRows - (inputs.range?.firstRowIndex || 0), 0, inputs.rowsMeta.positions.length);
    if (allRowsMeasured || inputs.rowsMeta.positions[lastMeasuredIndexRelativeToCurrentPage] >= offset) // If all rows were measured (when no row has "auto" as height) or all rows before the offset
    // were measured, then use a binary search because it's faster.
    return $2b0e72b73973ab3a$var$binarySearch(offset, inputs.rowsMeta.positions, options);
    // Otherwise, use an exponential search.
    // If rows have "auto" as height, their positions will be based on estimated heights.
    // In this case, we can skip several steps until we find a position higher than the offset.
    // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    return $2b0e72b73973ab3a$var$exponentialSearch(offset, inputs.rowsMeta.positions, lastMeasuredIndexRelativeToCurrentPage, options);
}
/**
 * Accepts as input a raw render context (the area visible in the viewport) and adds
 * computes the actual render context based on pinned elements, buffer dimensions and
 * spanning.
 */ function $2b0e72b73973ab3a$var$deriveRenderContext(inputs, nextRenderContext, scrollCache) {
    const [firstRowToRender, lastRowToRender] = $2b0e72b73973ab3a$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstRowIndex,
        lastIndex: nextRenderContext.lastRowIndex,
        minFirstIndex: 0,
        maxLastIndex: inputs.rows.length,
        bufferBefore: scrollCache.buffer.rowBefore,
        bufferAfter: scrollCache.buffer.rowAfter,
        positions: inputs.rowsMeta.positions,
        lastSize: inputs.lastRowHeight
    });
    const [initialFirstColumnToRender, lastColumnToRender] = $2b0e72b73973ab3a$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstColumnIndex,
        lastIndex: nextRenderContext.lastColumnIndex,
        minFirstIndex: inputs.pinnedColumns.left.length,
        maxLastIndex: inputs.visibleColumns.length - inputs.pinnedColumns.right.length,
        bufferBefore: scrollCache.buffer.columnBefore,
        bufferAfter: scrollCache.buffer.columnAfter,
        positions: inputs.columnPositions,
        lastSize: inputs.lastColumnWidth
    });
    const firstColumnToRender = (0, $938d01614caf11f5$export$6143417adb92779f)({
        firstColumnToRender: initialFirstColumnToRender,
        apiRef: inputs.apiRef,
        firstRowToRender: firstRowToRender,
        lastRowToRender: lastRowToRender,
        visibleRows: inputs.rows
    });
    return {
        firstRowIndex: firstRowToRender,
        lastRowIndex: lastRowToRender,
        firstColumnIndex: firstColumnToRender,
        lastColumnIndex: lastColumnToRender
    };
}
/**
 * Use binary search to avoid looping through all possible positions.
 * The `options.atStart` provides the possibility to match for the first element that
 * intersects the screen, even if said element's start position is before `offset`. In
 * other words, we search for `offset + width`.
 */ function $2b0e72b73973ab3a$var$binarySearch(offset, positions, options, sliceStart = 0, sliceEnd = positions.length) {
    if (positions.length <= 0) return -1;
    if (sliceStart >= sliceEnd) return sliceStart;
    const pivot = sliceStart + Math.floor((sliceEnd - sliceStart) / 2);
    const position = positions[pivot];
    let isBefore;
    if (options?.atStart) {
        const width = (pivot === positions.length - 1 ? options.lastPosition : positions[pivot + 1]) - position;
        isBefore = offset - width < position;
    } else isBefore = offset <= position;
    return isBefore ? $2b0e72b73973ab3a$var$binarySearch(offset, positions, options, sliceStart, pivot) : $2b0e72b73973ab3a$var$binarySearch(offset, positions, options, pivot + 1, sliceEnd);
}
function $2b0e72b73973ab3a$var$exponentialSearch(offset, positions, index, options) {
    let interval = 1;
    while(index < positions.length && Math.abs(positions[index]) < offset){
        index += interval;
        interval *= 2;
    }
    return $2b0e72b73973ab3a$var$binarySearch(offset, positions, options, Math.floor(index / 2), Math.min(index, positions.length));
}
function $2b0e72b73973ab3a$var$getIndexesToRender({ firstIndex: firstIndex, lastIndex: lastIndex, bufferBefore: bufferBefore, bufferAfter: bufferAfter, minFirstIndex: minFirstIndex, maxLastIndex: maxLastIndex, positions: positions, lastSize: lastSize }) {
    const firstPosition = positions[firstIndex] - bufferBefore;
    const lastPosition = positions[lastIndex] + bufferAfter;
    const firstIndexPadded = $2b0e72b73973ab3a$var$binarySearch(firstPosition, positions, {
        atStart: true,
        lastPosition: positions[positions.length - 1] + lastSize
    });
    const lastIndexPadded = $2b0e72b73973ab3a$var$binarySearch(lastPosition, positions);
    return [
        (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(firstIndexPadded, minFirstIndex, maxLastIndex),
        (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(lastIndexPadded, minFirstIndex, maxLastIndex)
    ];
}
function $2b0e72b73973ab3a$export$6eb241d16b36f3b8(context1, context2) {
    if (context1 === context2) return true;
    return context1.firstRowIndex === context2.firstRowIndex && context1.lastRowIndex === context2.lastRowIndex && context1.firstColumnIndex === context2.firstColumnIndex && context1.lastColumnIndex === context2.lastColumnIndex;
}
function $2b0e72b73973ab3a$export$fe1f1566870c3cbc(columnPositions, renderContext, pinnedLeftLength) {
    const left = (columnPositions[renderContext.firstColumnIndex] ?? 0) - (columnPositions[pinnedLeftLength] ?? 0);
    return Math.abs(left);
}
function $2b0e72b73973ab3a$var$directionForDelta(dx, dy) {
    if (dx === 0 && dy === 0) return $2b0e72b73973ab3a$var$ScrollDirection.NONE;
    /* eslint-disable */ if (Math.abs(dy) >= Math.abs(dx)) {
        if (dy > 0) return $2b0e72b73973ab3a$var$ScrollDirection.DOWN;
        else return $2b0e72b73973ab3a$var$ScrollDirection.UP;
    } else {
        if (dx > 0) return $2b0e72b73973ab3a$var$ScrollDirection.RIGHT;
        else return $2b0e72b73973ab3a$var$ScrollDirection.LEFT;
    }
/* eslint-enable */ }
function $2b0e72b73973ab3a$var$bufferForDirection(isRtl, direction, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer) {
    if (isRtl) switch(direction){
        case $2b0e72b73973ab3a$var$ScrollDirection.LEFT:
            direction = $2b0e72b73973ab3a$var$ScrollDirection.RIGHT;
            break;
        case $2b0e72b73973ab3a$var$ScrollDirection.RIGHT:
            direction = $2b0e72b73973ab3a$var$ScrollDirection.LEFT;
            break;
        default:
    }
    switch(direction){
        case $2b0e72b73973ab3a$var$ScrollDirection.NONE:
            return {
                rowAfter: rowBufferPx,
                rowBefore: rowBufferPx,
                columnAfter: columnBufferPx,
                columnBefore: columnBufferPx
            };
        case $2b0e72b73973ab3a$var$ScrollDirection.LEFT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: horizontalBuffer
            };
        case $2b0e72b73973ab3a$var$ScrollDirection.RIGHT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: horizontalBuffer,
                columnBefore: 0
            };
        case $2b0e72b73973ab3a$var$ScrollDirection.UP:
            return {
                rowAfter: 0,
                rowBefore: verticalBuffer,
                columnAfter: 0,
                columnBefore: 0
            };
        case $2b0e72b73973ab3a$var$ScrollDirection.DOWN:
            return {
                rowAfter: verticalBuffer,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: 0
            };
        default:
            // eslint unable to figure out enum exhaustiveness
            throw new Error('unreachable');
    }
}








const $85d67e030a7683cb$export$ba0092e600a72afc = ()=>{
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const totalRowCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$1641ef9d08e265ca));
    const visibleRowCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$96919017bbfaec0d));
    const pinnedRowsCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$8e3fb3525d7db988));
    const noRows = totalRowCount === 0 && pinnedRowsCount === 0;
    const loading = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$3c966d405f950b08));
    const showNoRowsOverlay = !loading && noRows;
    const showNoResultsOverlay = !loading && totalRowCount > 0 && visibleRowCount === 0;
    let overlayType = null;
    let loadingOverlayVariant = null;
    if (showNoRowsOverlay) overlayType = 'noRowsOverlay';
    if (showNoResultsOverlay) overlayType = 'noResultsOverlay';
    if (loading) {
        overlayType = 'loadingOverlay';
        loadingOverlayVariant = rootProps.slotProps?.loadingOverlay?.[noRows ? 'noRowsVariant' : 'variant'] || null;
    }
    return {
        overlayType: overlayType,
        loadingOverlayVariant: loadingOverlayVariant
    };
};



parcelRequire("lCzvA");











const $44e80526c752b8a4$var$GridOverlayWrapperRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapper',
    shouldForwardProp: (prop)=>prop !== 'overlayType' && prop !== 'loadingOverlayVariant',
    overridesResolver: (props, styles)=>styles.overlayWrapper
})(({ overlayType: overlayType, loadingOverlayVariant: loadingOverlayVariant })=>// Skeleton overlay should flow with the scroll container and not be sticky
    loadingOverlayVariant !== 'skeleton' ? {
        position: 'sticky',
        // To stay in place while scrolling
        top: 'var(--DataGrid-headersTotalHeight)',
        // TODO: take pinned rows into account
        left: 0,
        width: 0,
        // To stay above the content instead of shifting it down
        height: 0,
        // To stay above the content instead of shifting it down
        zIndex: overlayType === 'loadingOverlay' ? 5 // Should be above pinned columns, pinned rows, and detail panel
         : 4 // Should be above pinned columns and detail panel
    } : {});
const $44e80526c752b8a4$var$GridOverlayWrapperInner = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapperInner',
    shouldForwardProp: (prop)=>prop !== 'overlayType' && prop !== 'loadingOverlayVariant',
    overridesResolver: (props, styles)=>styles.overlayWrapperInner
})({});
const $44e80526c752b8a4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlayWrapper'
        ],
        inner: [
            'overlayWrapperInner'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $44e80526c752b8a4$var$GridOverlayWrapper(props) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const dimensions = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$26d8768b83a52ffd));
    let height = Math.max(dimensions.viewportOuterSize.height - dimensions.topContainerHeight - dimensions.bottomContainerHeight - (dimensions.hasScrollX ? dimensions.scrollbarSize : 0), 0);
    if (height === 0) height = (0, $dc4fe3453cdb0a0a$export$a95780409968416e);
    const classes = $44e80526c752b8a4$var$useUtilityClasses((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes
    }));
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($44e80526c752b8a4$var$GridOverlayWrapperRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root)
    }, props, {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($44e80526c752b8a4$var$GridOverlayWrapperInner, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.inner),
            style: {
                height: height,
                width: dimensions.viewportOuterSize.width
            }
        }, props))
    }));
}
function $44e80526c752b8a4$export$867f5fc44327bee5(props) {
    const { overlayType: overlayType } = props;
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    if (!overlayType) return null;
    const Overlay = rootProps.slots?.[overlayType];
    const overlayProps = rootProps.slotProps?.[overlayType];
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($44e80526c752b8a4$var$GridOverlayWrapper, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Overlay, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, overlayProps))
    }));
}



parcelRequire("lCzvA");









const $21666b905e7d3be4$export$5479c2fb8e9fd070 = (state)=>state.columnMenu;



function $bc8889dde8bba34b$var$GridHeaders() {
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$16a65a9447d3dda9));
    const filterColumnLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$6b2da1ecc84b757a));
    const sortColumnLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $32a7c18be453c9d5$export$4dfdcc434a6c5081));
    const columnHeaderTabIndexState = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $c2be356cc77cce81$export$29da670438604dbd));
    const hasNoCellTabIndexState = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, ()=>(0, $c2be356cc77cce81$export$2c47652a1f657d56)(apiRef) === null);
    const columnGroupHeaderTabIndexState = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $c2be356cc77cce81$export$37a54bd010f498d2));
    const columnHeaderFocus = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $c2be356cc77cce81$export$cefd405855792f4a));
    const columnGroupHeaderFocus = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $c2be356cc77cce81$export$3eeedc3f7263df61));
    const headerGroupingMaxDepth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8590d748d071bb9f$export$4cf0369c079b29be));
    const columnMenuState = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $21666b905e7d3be4$export$5479c2fb8e9fd070));
    const columnVisibility = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$eb0d33595fe29bb4));
    const columnGroupsHeaderStructure = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8590d748d071bb9f$export$8f859ed1f2777746));
    const hasOtherElementInTabSequence = !(columnGroupHeaderTabIndexState === null && columnHeaderTabIndexState === null && hasNoCellTabIndexState);
    const columnsContainerRef = apiRef.current.columnHeadersContainerRef;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnHeaders, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        ref: columnsContainerRef,
        visibleColumns: visibleColumns,
        filterColumnLookup: filterColumnLookup,
        sortColumnLookup: sortColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    }, rootProps.slotProps?.columnHeaders));
}
const $bc8889dde8bba34b$export$151397d1f4bb9231 = (0, $87d1c781e22c5bac$export$fa306e0bc9a9d6b4)($bc8889dde8bba34b$var$GridHeaders);



parcelRequire("lCzvA");




var $lCzvA = parcelRequire("lCzvA");

const $3d57cecbb08c0946$export$9fe1679701f06bb7 = ()=>{
    const configuration = $lCzvA.useContext((0, $8258a8c340722781$export$714d6aa898a12d6c));
    if (configuration === undefined) throw new Error([
        'MUI X: Could not find the Data Grid configuration context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return configuration;
};



const $6e60ea4aedc41944$var$GridPanelAnchor = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div')({
    position: 'absolute',
    top: `var(--DataGrid-headersTotalHeight)`,
    left: 0,
    width: 'calc(100% - (var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize)))'
});
const $6e60ea4aedc41944$var$Element = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'Main',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.main,
            ownerState.hasPinnedRight && styles['main--hasPinnedRight'],
            ownerState.loadingOverlayVariant === 'skeleton' && styles['main--hasSkeletonLoadingOverlay']
        ];
    }
})({
    flexGrow: 1,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
});
const $6e60ea4aedc41944$export$74039dccf215bc2a = (0, $74efa9d8b826b453$export$257a8862b851cb5b)((props, ref)=>{
    const { ownerState: ownerState } = props;
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const configuration = (0, $3d57cecbb08c0946$export$9fe1679701f06bb7)();
    const ariaAttributes = configuration.hooks.useGridAriaAttributes();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($6e60ea4aedc41944$var$Element, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        ownerState: ownerState,
        className: props.className,
        tabIndex: -1
    }, ariaAttributes, rootProps.slotProps?.main, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6e60ea4aedc41944$var$GridPanelAnchor, {
                role: "presentation",
                "data-id": "gridPanelAnchor"
            }),
            props.children
        ]
    }));
});



parcelRequire("lCzvA");





const $c27c3e7c0ed46413$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'topContainer'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), {});
};
const $c27c3e7c0ed46413$var$Element = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div')({
    position: 'sticky',
    zIndex: 40,
    top: 0
});
function $c27c3e7c0ed46413$export$820d93aabd2ee77d(props) {
    const classes = $c27c3e7c0ed46413$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($c27c3e7c0ed46413$var$Element, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, (0, $786c119d9add6b61$export$2100d54e36406477)['container--top']),
        role: "presentation"
    }));
}



parcelRequire("lCzvA");





const $a1cae516548e1351$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'bottomContainer'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), {});
};
const $a1cae516548e1351$var$Element = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div')({
    position: 'sticky',
    zIndex: 40,
    bottom: 'calc(var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))'
});
function $a1cae516548e1351$export$7b1aa135d0232b20(props) {
    const classes = $a1cae516548e1351$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a1cae516548e1351$var$Element, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, (0, $786c119d9add6b61$export$2100d54e36406477)['container--bottom']),
        role: "presentation"
    }));
}



parcelRequire("lCzvA");







const $fd97011bc034ee9f$var$useUtilityClasses = (props, overflowedContent)=>{
    const { classes: classes } = props;
    const slots = {
        root: [
            'virtualScrollerContent',
            overflowedContent && 'virtualScrollerContent--overflowed'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $fd97011bc034ee9f$var$VirtualScrollerContentRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerContent',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.virtualScrollerContent,
            ownerState.overflowedContent && styles['virtualScrollerContent--overflowed']
        ];
    }
})({});
const $fd97011bc034ee9f$export$97d48eb8ba00afb8 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridVirtualScrollerContent(props, ref) {
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const overflowedContent = !rootProps.autoHeight && props.style?.minHeight === 'auto';
    const classes = $fd97011bc034ee9f$var$useUtilityClasses(rootProps, overflowedContent);
    const ownerState = {
        classes: rootProps.classes,
        overflowedContent: overflowedContent
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($fd97011bc034ee9f$var$VirtualScrollerContentRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        ownerState: ownerState,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, props.className),
        ref: ref
    }));
});


parcelRequire("lCzvA");







const $69f44f57fbdbf45b$var$Filler = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div')({
    display: 'flex',
    flexDirection: 'row',
    width: 'var(--DataGrid-rowWidth)',
    boxSizing: 'border-box'
});
const $69f44f57fbdbf45b$var$Pinned = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div')({
    position: 'sticky',
    height: '100%',
    boxSizing: 'border-box',
    borderTop: '1px solid var(--rowBorderColor)',
    backgroundColor: 'var(--DataGrid-pinnedBackground)'
});
const $69f44f57fbdbf45b$var$PinnedLeft = (0, $cc43af7a19636335$export$2e2bcd8739ae039)($69f44f57fbdbf45b$var$Pinned)({
    left: 0,
    borderRight: '1px solid var(--rowBorderColor)'
});
const $69f44f57fbdbf45b$var$PinnedRight = (0, $cc43af7a19636335$export$2e2bcd8739ae039)($69f44f57fbdbf45b$var$Pinned)({
    right: 0,
    borderLeft: '1px solid var(--rowBorderColor)'
});
const $69f44f57fbdbf45b$var$Main = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div')({
    flexGrow: 1,
    borderTop: '1px solid var(--rowBorderColor)'
});
function $69f44f57fbdbf45b$var$GridVirtualScrollerFiller({ rowsLength: rowsLength }) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const { viewportOuterSize: viewportOuterSize, minimumSize: minimumSize, hasScrollX: hasScrollX, hasScrollY: hasScrollY, scrollbarSize: scrollbarSize, leftPinnedWidth: leftPinnedWidth, rightPinnedWidth: rightPinnedWidth } = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$26d8768b83a52ffd));
    const height = hasScrollX ? scrollbarSize : 0;
    const needsLastRowBorder = viewportOuterSize.height - minimumSize.height > 0;
    if (height === 0 && !needsLastRowBorder) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($69f44f57fbdbf45b$var$Filler, {
        className: (0, $786c119d9add6b61$export$2100d54e36406477).filler,
        role: "presentation",
        style: {
            height: height,
            '--rowBorderColor': rowsLength === 0 ? 'transparent' : 'var(--DataGrid-rowBorderColor)'
        },
        children: [
            leftPinnedWidth > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($69f44f57fbdbf45b$var$PinnedLeft, {
                className: (0, $786c119d9add6b61$export$2100d54e36406477)['filler--pinnedLeft'],
                style: {
                    width: leftPinnedWidth
                }
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($69f44f57fbdbf45b$var$Main, {}),
            rightPinnedWidth > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($69f44f57fbdbf45b$var$PinnedRight, {
                className: (0, $786c119d9add6b61$export$2100d54e36406477)['filler--pinnedRight'],
                style: {
                    width: rightPinnedWidth + (hasScrollY ? scrollbarSize : 0)
                }
            })
        ]
    });
}
const $69f44f57fbdbf45b$export$832a8b454433e1c8 = (0, $87d1c781e22c5bac$export$fa306e0bc9a9d6b4)($69f44f57fbdbf45b$var$GridVirtualScrollerFiller);




parcelRequire("lCzvA");











const $96accd3ed0666584$var$_excluded = [
    "className"
];
const $96accd3ed0666584$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'virtualScrollerRenderZone'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $96accd3ed0666584$var$VirtualScrollerRenderZoneRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerRenderZone',
    overridesResolver: (props, styles)=>styles.virtualScrollerRenderZone
})({
    position: 'absolute',
    display: 'flex',
    // Prevents margin collapsing when using `getRowSpacing`
    flexDirection: 'column'
});
const $96accd3ed0666584$export$95930d31e6a9269f = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridVirtualScrollerRenderZone(props, ref) {
    const { className: className } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $96accd3ed0666584$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $96accd3ed0666584$var$useUtilityClasses(rootProps);
    const offsetTop = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, ()=>{
        const renderContext = (0, $c79669abb772bd0a$export$4cf9f333a030f780)(apiRef);
        const rowsMeta = (0, $ab89a1ec5ede86ad$export$4f32bfc70efeb4ab)(apiRef.current.state);
        return rowsMeta.positions[renderContext.firstRowIndex] ?? 0;
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($96accd3ed0666584$var$VirtualScrollerRenderZoneRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps,
        style: {
            transform: `translate3d(0, ${offsetTop}px, 0)`
        }
    }, other, {
        ref: ref
    }));
});



var $lCzvA = parcelRequire("lCzvA");









const $1a8fcf5d20f5cd25$var$useUtilityClasses = (ownerState, position)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'scrollbar',
            `scrollbar--${position}`
        ],
        content: [
            'scrollbarContent'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $1a8fcf5d20f5cd25$var$Scrollbar = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div')({
    position: 'absolute',
    display: 'inline-block',
    zIndex: 60,
    '&:hover': {
        zIndex: 70
    },
    // In macOS Safari and Gnome Web, scrollbars are overlaid and don't affect the layout. So we consider
    // their size to be 0px throughout all the calculations, but the floating scrollbar container does need
    // to appear and have a real size. We set it to 14px because it seems like an acceptable value and we
    // don't have a method to find the required size for scrollbars on those platforms.
    '--size': 'calc(max(var(--DataGrid-scrollbarSize), 14px))'
});
const $1a8fcf5d20f5cd25$var$ScrollbarVertical = (0, $cc43af7a19636335$export$2e2bcd8739ae039)($1a8fcf5d20f5cd25$var$Scrollbar)({
    width: 'var(--size)',
    height: 'calc(var(--DataGrid-hasScrollY) * (100% - var(--DataGrid-topContainerHeight) - var(--DataGrid-bottomContainerHeight) - var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize)))',
    overflowY: 'auto',
    overflowX: 'hidden',
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    '& > div': {
        width: 'var(--size)'
    },
    top: 'var(--DataGrid-topContainerHeight)',
    right: '0px'
});
const $1a8fcf5d20f5cd25$var$ScrollbarHorizontal = (0, $cc43af7a19636335$export$2e2bcd8739ae039)($1a8fcf5d20f5cd25$var$Scrollbar)({
    width: '100%',
    height: 'var(--size)',
    overflowY: 'hidden',
    overflowX: 'auto',
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    '& > div': {
        height: 'var(--size)'
    },
    bottom: '0px'
});
const $1a8fcf5d20f5cd25$export$96aeae8bf32b76b8 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridVirtualScrollbar(props, ref) {
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const isLocked = $lCzvA.useRef(false);
    const lastPosition = $lCzvA.useRef(0);
    const scrollbarRef = $lCzvA.useRef(null);
    const contentRef = $lCzvA.useRef(null);
    const classes = $1a8fcf5d20f5cd25$var$useUtilityClasses(rootProps, props.position);
    const dimensions = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$26d8768b83a52ffd));
    const propertyDimension = props.position === 'vertical' ? 'height' : 'width';
    const propertyScroll = props.position === 'vertical' ? 'scrollTop' : 'scrollLeft';
    const propertyScrollPosition = props.position === 'vertical' ? 'top' : 'left';
    const hasScroll = props.position === 'vertical' ? dimensions.hasScrollX : dimensions.hasScrollY;
    const contentSize = dimensions.minimumSize[propertyDimension] + (hasScroll ? dimensions.scrollbarSize : 0);
    const scrollbarSize = props.position === 'vertical' ? dimensions.viewportInnerSize.height : dimensions.viewportOuterSize.width;
    const scrollbarInnerSize = scrollbarSize * (contentSize / dimensions.viewportOuterSize[propertyDimension]);
    const onScrollerScroll = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(()=>{
        const scrollbar = scrollbarRef.current;
        const scrollPosition = props.scrollPosition.current;
        if (!scrollbar) return;
        if (scrollPosition[propertyScrollPosition] === lastPosition.current) return;
        lastPosition.current = scrollPosition[propertyScrollPosition];
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        const value = scrollPosition[propertyScrollPosition] / contentSize;
        scrollbar[propertyScroll] = value * scrollbarInnerSize;
    });
    const onScrollbarScroll = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        if (!scrollbar) return;
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        const value = scrollbar[propertyScroll] / scrollbarInnerSize;
        scroller[propertyScroll] = value * contentSize;
    });
    (0, $375168188d76048b$export$2e2bcd8739ae039)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        const options = {
            passive: true
        };
        scroller.addEventListener('scroll', onScrollerScroll, options);
        scrollbar.addEventListener('scroll', onScrollbarScroll, options);
        return ()=>{
            scroller.removeEventListener('scroll', onScrollerScroll, options);
            scrollbar.removeEventListener('scroll', onScrollbarScroll, options);
        };
    });
    $lCzvA.useEffect(()=>{
        const content = contentRef.current;
        content.style.setProperty(propertyDimension, `${scrollbarInnerSize}px`);
    }, [
        scrollbarInnerSize,
        propertyDimension
    ]);
    const Container = props.position === 'vertical' ? $1a8fcf5d20f5cd25$var$ScrollbarVertical : $1a8fcf5d20f5cd25$var$ScrollbarHorizontal;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Container, {
        ref: (0, $78465f04bf272330$export$2e2bcd8739ae039)(ref, scrollbarRef),
        className: classes.root,
        style: props.position === 'vertical' && rootProps.unstable_listView ? {
            height: '100%',
            top: 0
        } : undefined,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: (event)=>{
            event.target.blur();
        },
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
            ref: contentRef,
            className: classes.content
        })
    });
});



const $bea8b799ec8c7785$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, hasScrollX: hasScrollX, hasPinnedRight: hasPinnedRight, loadingOverlayVariant: loadingOverlayVariant } = ownerState;
    const slots = {
        root: [
            'main',
            hasPinnedRight && 'main--hasPinnedRight',
            loadingOverlayVariant === 'skeleton' && 'main--hasSkeletonLoadingOverlay'
        ],
        scroller: [
            'virtualScroller',
            hasScrollX && 'virtualScroller--hasScrollX'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $bea8b799ec8c7785$var$Scroller = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.virtualScroller,
            ownerState.hasScrollX && styles['virtualScroller--hasScrollX']
        ];
    }
})({
    position: 'relative',
    height: '100%',
    flexGrow: 1,
    overflow: 'scroll',
    scrollbarWidth: 'none' /* Firefox */ ,
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
        display: 'none' /* Safari and Chrome */ 
    },
    '@media print': {
        overflow: 'hidden'
    },
    // See https://github.com/mui/mui-x/issues/10547
    zIndex: 0
});
const $bea8b799ec8c7785$var$hasPinnedRightSelector = (state)=>state.dimensions.rightPinnedWidth > 0;
function $bea8b799ec8c7785$export$febd8ae712031b27(props) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const hasScrollY = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$4fe814c21f610df));
    const hasScrollX = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$5dfe533d5e873745));
    const hasPinnedRight = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, $bea8b799ec8c7785$var$hasPinnedRightSelector);
    const hasBottomFiller = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$98dc8438c286cc21));
    const overlaysProps = (0, $85d67e030a7683cb$export$ba0092e600a72afc)();
    const ownerState = {
        classes: rootProps.classes,
        hasScrollX: hasScrollX,
        hasPinnedRight: hasPinnedRight,
        loadingOverlayVariant: overlaysProps.loadingOverlayVariant
    };
    const classes = $bea8b799ec8c7785$var$useUtilityClasses(ownerState);
    const virtualScroller = (0, $2b0e72b73973ab3a$export$fbe94079134c8d27)();
    const { getContainerProps: getContainerProps, getScrollerProps: getScrollerProps, getContentProps: getContentProps, getRenderZoneProps: getRenderZoneProps, getScrollbarVerticalProps: getScrollbarVerticalProps, getScrollbarHorizontalProps: getScrollbarHorizontalProps, getRows: getRows, getScrollAreaProps: getScrollAreaProps } = virtualScroller;
    const rows = getRows();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $6e60ea4aedc41944$export$74039dccf215bc2a), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: classes.root
    }, getContainerProps(), {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b1dde8abe2995993$export$40bcbdb719b20690), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                scrollDirection: "left"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b1dde8abe2995993$export$40bcbdb719b20690), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                scrollDirection: "right"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b1dde8abe2995993$export$40bcbdb719b20690), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                scrollDirection: "up"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b1dde8abe2995993$export$40bcbdb719b20690), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                scrollDirection: "down"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($bea8b799ec8c7785$var$Scroller, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                className: classes.scroller
            }, getScrollerProps(), {
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c27c3e7c0ed46413$export$820d93aabd2ee77d), {
                        children: [
                            !rootProps.unstable_listView && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $bc8889dde8bba34b$export$151397d1f4bb9231), {}),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.pinnedRows, {
                                position: "top",
                                virtualScroller: virtualScroller
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $44e80526c752b8a4$export$867f5fc44327bee5), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, overlaysProps)),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fd97011bc034ee9f$export$97d48eb8ba00afb8), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, getContentProps(), {
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $96accd3ed0666584$export$95930d31e6a9269f), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, getRenderZoneProps(), {
                            children: [
                                rows,
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.detailPanels, {
                                    virtualScroller: virtualScroller
                                })
                            ]
                        }))
                    })),
                    hasBottomFiller && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $69f44f57fbdbf45b$export$832a8b454433e1c8), {
                        rowsLength: rows.length
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a1cae516548e1351$export$7b1aa135d0232b20), {
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.pinnedRows, {
                            position: "bottom",
                            virtualScroller: virtualScroller
                        })
                    })
                ]
            })),
            hasScrollX && !rootProps.unstable_listView && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1a8fcf5d20f5cd25$export$96aeae8bf32b76b8), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                position: "horizontal"
            }, getScrollbarHorizontalProps())),
            hasScrollY && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1a8fcf5d20f5cd25$export$96aeae8bf32b76b8), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                position: "vertical"
            }, getScrollbarVerticalProps())),
            props.children
        ]
    }));
}


parcelRequire("lCzvA");


function $19519f3ffc0cbdc6$export$6d80c98441abb3ab() {
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    if (rootProps.hideFooter) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.footer, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootProps.slotProps?.footer /* FIXME: typing error */ ));
}



const $186d5a33b9a640d9$var$_excluded = [
    "className",
    "children"
];
const $186d5a33b9a640d9$var$useUtilityClasses = (ownerState, density)=>{
    const { autoHeight: autoHeight, classes: classes, showCellVerticalBorder: showCellVerticalBorder } = ownerState;
    const slots = {
        root: [
            'root',
            autoHeight && 'autoHeight',
            `root--density${(0, $c4ab204d748cb214$export$2e2bcd8739ae039)(density)}`,
            ownerState.slots.toolbar === null && 'root--noToolbar',
            'withBorderColor',
            showCellVerticalBorder && 'withVerticalBorder'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $186d5a33b9a640d9$var$GridRoot = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridRoot(props, ref) {
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const { className: className, children: children } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $186d5a33b9a640d9$var$_excluded);
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const density = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $bc5ab296ed04c1c0$export$806a039ece4425b4));
    const rootElementRef = apiRef.current.rootElementRef;
    const rootMountCallback = $lCzvA.useCallback((node)=>{
        if (node === null) return;
        apiRef.current.publishEvent('rootMount', node);
    }, [
        apiRef
    ]);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(rootElementRef, ref, rootMountCallback);
    const ownerState = rootProps;
    const classes = $186d5a33b9a640d9$var$useUtilityClasses(ownerState, density);
    const isSSR = (0, $484258b08ca5b04f$export$535bd6ca7f90a273)();
    if (isSSR) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $64116811ce6fb235$export$42458c7ae3a97297), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: handleRef,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $af2c708e04567b59$export$74ac40502a3200d3), {}),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $bea8b799ec8c7785$export$febd8ae712031b27), {
                children: children
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $19519f3ffc0cbdc6$export$6d80c98441abb3ab), {})
        ]
    }));
});
const $186d5a33b9a640d9$export$8cdbcd3b320d39bf = (0, $87d1c781e22c5bac$export$fa306e0bc9a9d6b4)($186d5a33b9a640d9$var$GridRoot);







var $lCzvA = parcelRequire("lCzvA");
function $2578df2a6840adc5$export$e132ced8f644a612(node) {
    return node.field !== undefined;
} /**
 * A function used to process headerClassName params.
 */  /**
 * The union type representing the [[GridColDef]] column header class type.
 */ 






// This is the recurrence function that help writing `unwrapGroupingColumnModel()`
const $3d84571ebf402992$var$recurrentUnwrapGroupingColumnModel = (columnGroupNode, parents, unwrappedGroupingModelToComplete)=>{
    if ((0, $2578df2a6840adc5$export$e132ced8f644a612)(columnGroupNode)) {
        if (unwrappedGroupingModelToComplete[columnGroupNode.field] !== undefined) throw new Error([
            `MUI X: columnGroupingModel contains duplicated field`,
            `column field ${columnGroupNode.field} occurs two times in the grouping model:`,
            `- ${unwrappedGroupingModelToComplete[columnGroupNode.field].join(' > ')}`,
            `- ${parents.join(' > ')}`
        ].join('\n'));
        unwrappedGroupingModelToComplete[columnGroupNode.field] = parents;
        return;
    }
    const { groupId: groupId, children: children } = columnGroupNode;
    children.forEach((child)=>{
        $3d84571ebf402992$var$recurrentUnwrapGroupingColumnModel(child, [
            ...parents,
            groupId
        ], unwrappedGroupingModelToComplete);
    });
};
const $3d84571ebf402992$export$ea425f87fd536c4d = (columnGroupingModel)=>{
    if (!columnGroupingModel) return {};
    const unwrappedSubTree = {};
    columnGroupingModel.forEach((columnGroupNode)=>{
        $3d84571ebf402992$var$recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
    });
    return unwrappedSubTree;
};
const $3d84571ebf402992$export$c41225ff45feeb0e = (orderedColumns, unwrappedGroupingModel, pinnedFields)=>{
    const getParents = (field)=>unwrappedGroupingModel[field] ?? [];
    const groupingHeaderStructure = [];
    const maxDepth = Math.max(...orderedColumns.map((field)=>getParents(field).length));
    const haveSameParents = (field1, field2, depth)=>(0, $ac3bd7253ec0e92a$export$78fdc9adc3f30400)(getParents(field1).slice(0, depth + 1), getParents(field2).slice(0, depth + 1));
    const haveDifferentContainers = (field1, field2)=>{
        if (pinnedFields?.left && pinnedFields.left.includes(field1) && !pinnedFields.left.includes(field2)) return true;
        if (pinnedFields?.right && !pinnedFields.right.includes(field1) && pinnedFields.right.includes(field2)) return true;
        return false;
    };
    for(let depth = 0; depth < maxDepth; depth += 1){
        const depthStructure = orderedColumns.reduce((structure, newField)=>{
            const groupId = getParents(newField)[depth] ?? null;
            if (structure.length === 0) return [
                {
                    columnFields: [
                        newField
                    ],
                    groupId: groupId
                }
            ];
            const lastGroup = structure[structure.length - 1];
            const prevField = lastGroup.columnFields[lastGroup.columnFields.length - 1];
            const prevGroupId = lastGroup.groupId;
            if (prevGroupId !== groupId || !haveSameParents(prevField, newField, depth) || // Fix for https://github.com/mui/mui-x/issues/7041
            haveDifferentContainers(prevField, newField)) // It's a new group
            return [
                ...structure,
                {
                    columnFields: [
                        newField
                    ],
                    groupId: groupId
                }
            ];
            // It extends the previous group
            return [
                ...structure.slice(0, structure.length - 1),
                {
                    columnFields: [
                        ...lastGroup.columnFields,
                        newField
                    ],
                    groupId: groupId
                }
            ];
        }, []);
        groupingHeaderStructure.push(depthStructure);
    }
    return groupingHeaderStructure;
};




const $aad4fc540ae297b2$var$_excluded = [
    "groupId",
    "children"
];
const $aad4fc540ae297b2$var$createGroupLookup = (columnGroupingModel)=>{
    let groupLookup = {};
    columnGroupingModel.forEach((node)=>{
        if ((0, $2578df2a6840adc5$export$e132ced8f644a612)(node)) return;
        const { groupId: groupId, children: children } = node, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(node, $aad4fc540ae297b2$var$_excluded);
        if (!groupId) throw new Error('MUI X: An element of the columnGroupingModel does not have either `field` or `groupId`.');
        const groupParam = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, other, {
            groupId: groupId
        });
        const subTreeLookup = $aad4fc540ae297b2$var$createGroupLookup(children);
        if (subTreeLookup[groupId] !== undefined || groupLookup[groupId] !== undefined) throw new Error(`MUI X: The groupId ${groupId} is used multiple times in the columnGroupingModel.`);
        groupLookup = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupLookup, subTreeLookup, {
            [groupId]: groupParam
        });
    });
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupLookup);
};
const $aad4fc540ae297b2$export$21c841dc431b3cd0 = (state, props, apiRef)=>{
    if (!props.columnGroupingModel) return state;
    const columnFields = (0, $8b99503000dd62d3$export$d8a3dfbb129c80db)(apiRef);
    const visibleColumnFields = (0, $8b99503000dd62d3$export$c9491722e1d6e8d3)(apiRef);
    const groupLookup = $aad4fc540ae297b2$var$createGroupLookup(props.columnGroupingModel ?? []);
    const unwrappedGroupingModel = (0, $3d84571ebf402992$export$ea425f87fd536c4d)(props.columnGroupingModel ?? []);
    const columnGroupsHeaderStructure = (0, $3d84571ebf402992$export$c41225ff45feeb0e)(columnFields, unwrappedGroupingModel, apiRef.current.state.pinnedColumns ?? {});
    const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        columnGrouping: {
            lookup: groupLookup,
            unwrappedGroupingModel: unwrappedGroupingModel,
            headerStructure: columnGroupsHeaderStructure,
            maxDepth: maxDepth
        }
    });
};
const $aad4fc540ae297b2$export$510984a37e2e33f3 = (apiRef, props)=>{
    /**
   * API METHODS
   */ const getColumnGroupPath = $lCzvA.useCallback((field)=>{
        const unwrappedGroupingModel = (0, $8590d748d071bb9f$export$78f140ad2e1dbc2b)(apiRef);
        return unwrappedGroupingModel[field] ?? [];
    }, [
        apiRef
    ]);
    const getAllGroupDetails = $lCzvA.useCallback(()=>{
        const columnGroupLookup = (0, $8590d748d071bb9f$export$bdc2ff4432d8b29b)(apiRef);
        return columnGroupLookup;
    }, [
        apiRef
    ]);
    const columnGroupingApi = {
        getColumnGroupPath: getColumnGroupPath,
        getAllGroupDetails: getAllGroupDetails
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, columnGroupingApi, 'public');
    const handleColumnIndexChange = $lCzvA.useCallback(()=>{
        const unwrappedGroupingModel = (0, $3d84571ebf402992$export$ea425f87fd536c4d)(props.columnGroupingModel ?? []);
        apiRef.current.setState((state)=>{
            const orderedFields = state.columns?.orderedFields ?? [];
            const pinnedColumns = state.pinnedColumns ?? {};
            const columnGroupsHeaderStructure = (0, $3d84571ebf402992$export$c41225ff45feeb0e)(orderedFields, unwrappedGroupingModel, pinnedColumns);
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                columnGrouping: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.columnGrouping, {
                    headerStructure: columnGroupsHeaderStructure
                })
            });
        });
    }, [
        apiRef,
        props.columnGroupingModel
    ]);
    const updateColumnGroupingState = $lCzvA.useCallback((columnGroupingModel)=>{
        // @ts-expect-error Move this logic to `Pro` package
        const pinnedColumns = apiRef.current.getPinnedColumns?.() ?? {};
        const columnFields = (0, $8b99503000dd62d3$export$d8a3dfbb129c80db)(apiRef);
        const visibleColumnFields = (0, $8b99503000dd62d3$export$c9491722e1d6e8d3)(apiRef);
        const groupLookup = $aad4fc540ae297b2$var$createGroupLookup(columnGroupingModel ?? []);
        const unwrappedGroupingModel = (0, $3d84571ebf402992$export$ea425f87fd536c4d)(columnGroupingModel ?? []);
        const columnGroupsHeaderStructure = (0, $3d84571ebf402992$export$c41225ff45feeb0e)(columnFields, unwrappedGroupingModel, pinnedColumns);
        const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                columnGrouping: {
                    lookup: groupLookup,
                    unwrappedGroupingModel: unwrappedGroupingModel,
                    headerStructure: columnGroupsHeaderStructure,
                    maxDepth: maxDepth
                }
            });
        });
    }, [
        apiRef
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnIndexChange', handleColumnIndexChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnsChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnVisibilityModelChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    /**
   * EFFECTS
   */ $lCzvA.useEffect(()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    }, [
        updateColumnGroupingState,
        props.columnGroupingModel
    ]);
};



var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");
function $658b5ea949d27628$export$eb512164890e58f0(privateApiRef, name) {
    const logger = $lCzvA.useRef(null);
    if (logger.current) return logger.current;
    const newLogger = privateApiRef.current.getLogger(name);
    logger.current = newLogger;
    return newLogger;
}




const $01de41b14b792d22$export$8574ffe06bf26347 = (state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        columnMenu: {
            open: false
        }
    });
const $01de41b14b792d22$export$1fc2975c9a725449 = (apiRef)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridColumnMenu');
    /**
   * API METHODS
   */ const showColumnMenu = $lCzvA.useCallback((field)=>{
        const columnMenuState = (0, $21666b905e7d3be4$export$5479c2fb8e9fd070)(apiRef.current.state);
        const newState = {
            open: true,
            field: field
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) {
            apiRef.current.setState((state)=>{
                if (state.columnMenu.open && state.columnMenu.field === field) return state;
                logger.debug('Opening Column Menu');
                return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                    columnMenu: {
                        open: true,
                        field: field
                    }
                });
            });
            apiRef.current.hidePreferences();
        }
    }, [
        apiRef,
        logger
    ]);
    const hideColumnMenu = $lCzvA.useCallback(()=>{
        const columnMenuState = (0, $21666b905e7d3be4$export$5479c2fb8e9fd070)(apiRef.current.state);
        if (columnMenuState.field) {
            const columnLookup = (0, $8b99503000dd62d3$export$8a3a9a6db584d7fd)(apiRef);
            const columnVisibilityModel = (0, $8b99503000dd62d3$export$eb0d33595fe29bb4)(apiRef);
            const orderedFields = (0, $8b99503000dd62d3$export$d8a3dfbb129c80db)(apiRef);
            let fieldToFocus = columnMenuState.field;
            // If the column was removed from the grid, we need to find the closest visible field
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            // If the field to focus is hidden, we need to find the closest visible field
            if (columnVisibilityModel[fieldToFocus] === false) {
                // contains visible column fields + the field that was just hidden
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return columnVisibilityModel[field] !== false;
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setColumnHeaderFocus(fieldToFocus);
        }
        const newState = {
            open: false,
            field: undefined
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) apiRef.current.setState((state)=>{
            logger.debug('Hiding Column Menu');
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                columnMenu: newState
            });
        });
    }, [
        apiRef,
        logger
    ]);
    const toggleColumnMenu = $lCzvA.useCallback((field)=>{
        logger.debug('Toggle Column Menu');
        const columnMenu = (0, $21666b905e7d3be4$export$5479c2fb8e9fd070)(apiRef.current.state);
        if (!columnMenu.open || columnMenu.field !== field) showColumnMenu(field);
        else hideColumnMenu();
    }, [
        apiRef,
        logger,
        showColumnMenu,
        hideColumnMenu
    ]);
    const columnMenuApi = {
        showColumnMenu: showColumnMenu,
        hideColumnMenu: hideColumnMenu,
        toggleColumnMenu: toggleColumnMenu
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, columnMenuApi, 'public');
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnResizeStart', hideColumnMenu);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'virtualScrollerWheel', apiRef.current.hideColumnMenu);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'virtualScrollerTouchMove', apiRef.current.hideColumnMenu);
};



var $lCzvA = parcelRequire("lCzvA");




function $e6e8e5e948b588ba$export$c8be9a8325efa7ee(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
function $e6e8e5e948b588ba$export$2a63f1401414fc1a(elem, className) {
    return elem.closest(`.${className}`);
}
function $e6e8e5e948b588ba$export$77eab2954df72e62(operand) {
    return operand.replace(/["\\]/g, '\\$&');
}
function $e6e8e5e948b588ba$export$94318ffb75913a0b(root, field) {
    return root.querySelector(`[role="columnheader"][data-field="${$e6e8e5e948b588ba$export$77eab2954df72e62(field)}"]`);
}
function $e6e8e5e948b588ba$var$getGridRowElementSelector(id) {
    return `.${(0, $786c119d9add6b61$export$2100d54e36406477).row}[data-id="${$e6e8e5e948b588ba$export$77eab2954df72e62(String(id))}"]`;
}
function $e6e8e5e948b588ba$export$9bc8bb868a922a5f(root, id) {
    return root.querySelector($e6e8e5e948b588ba$var$getGridRowElementSelector(id));
}
function $e6e8e5e948b588ba$export$44827662627a59(root, { id: id, field: field }) {
    const rowSelector = $e6e8e5e948b588ba$var$getGridRowElementSelector(id);
    const cellSelector = `.${(0, $786c119d9add6b61$export$2100d54e36406477).cell}[data-field="${$e6e8e5e948b588ba$export$77eab2954df72e62(field)}"]`;
    const selector = `${rowSelector} ${cellSelector}`;
    return root.querySelector(selector);
}
const $e6e8e5e948b588ba$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $e6e8e5e948b588ba$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
function $e6e8e5e948b588ba$export$8ce496ad3bfbe3a6(event) {
    if (// The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) return true;
    return false;
}
function $e6e8e5e948b588ba$export$2c4260a98d98f894(colCellEl) {
    return colCellEl.getAttribute('data-field');
}
function $e6e8e5e948b588ba$export$a2d3aec9ff63900b(elem, field) {
    return elem.querySelector(`[data-field="${$e6e8e5e948b588ba$export$77eab2954df72e62(field)}"]`);
}
function $e6e8e5e948b588ba$export$5d6880d172f0ecbb(colCellEl) {
    return colCellEl.getAttribute('data-fields').slice(2, -2).split('-|-');
}
function $e6e8e5e948b588ba$export$1e5569d10c3ebc8b(elem, field) {
    return Array.from(elem.querySelectorAll(`[data-fields*="|-${$e6e8e5e948b588ba$export$77eab2954df72e62(field)}-|"]`) ?? []);
}
function $e6e8e5e948b588ba$export$53d8041b57f0055(col, api) {
    const root = $e6e8e5e948b588ba$export$2a63f1401414fc1a(col, (0, $786c119d9add6b61$export$2100d54e36406477).root);
    if (!root) throw new Error('MUI X: The root element is not found.');
    const ariaColIndex = col.getAttribute('aria-colindex');
    if (!ariaColIndex) return [];
    const colIndex = Number(ariaColIndex) - 1;
    const cells = [];
    if (!api.virtualScrollerRef?.current) return [];
    $e6e8e5e948b588ba$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute('data-id');
        if (!rowId) return;
        let columnIndex = colIndex;
        const cellColSpanInfo = api.unstable_getCellColSpanInfo(rowId, colIndex);
        if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) columnIndex = cellColSpanInfo.leftVisibleCellIndex;
        const cell = rowElement.querySelector(`[data-colindex="${columnIndex}"]`);
        if (cell) cells.push(cell);
    });
    return cells;
}
function $e6e8e5e948b588ba$export$c16d6f1be06f3423(api, klass) {
    return api.rootElementRef.current.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477)[klass]}`);
}
const $e6e8e5e948b588ba$var$findPinnedCells = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (colIndex === null) return [];
    const cells = [];
    $e6e8e5e948b588ba$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute('data-id');
        if (!rowId) return;
        rowElement.querySelectorAll(`.${(0, $786c119d9add6b61$export$2100d54e36406477)[position === 'left' ? 'cell--pinnedLeft' : 'cell--pinnedRight']}`).forEach((cell)=>{
            const currentColIndex = $e6e8e5e948b588ba$var$parseCellColIndex(cell);
            if (currentColIndex !== null && filterFn(currentColIndex)) cells.push(cell);
        });
    });
    return cells;
};
function $e6e8e5e948b588ba$export$71cc5934f05ca0a1(api, col, isRtl) {
    const colIndex = $e6e8e5e948b588ba$var$parseCellColIndex(col);
    return $e6e8e5e948b588ba$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: isRtl ? 'right' : 'left',
        filterFn: (index)=>isRtl ? index < colIndex : index > colIndex
    });
}
function $e6e8e5e948b588ba$export$2eb3bec73fd25ab(api, col, isRtl) {
    const colIndex = $e6e8e5e948b588ba$var$parseCellColIndex(col);
    return $e6e8e5e948b588ba$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: isRtl ? 'left' : 'right',
        filterFn: (index)=>isRtl ? index > colIndex : index < colIndex
    });
}
const $e6e8e5e948b588ba$var$findPinnedHeaders = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (!api.columnHeadersContainerRef?.current) return [];
    if (colIndex === null) return [];
    const elements = [];
    api.columnHeadersContainerRef.current.querySelectorAll(`.${(0, $786c119d9add6b61$export$2100d54e36406477)[position === 'left' ? 'columnHeader--pinnedLeft' : 'columnHeader--pinnedRight']}`).forEach((element)=>{
        const currentColIndex = $e6e8e5e948b588ba$var$parseCellColIndex(element);
        if (currentColIndex !== null && filterFn(currentColIndex, element)) elements.push(element);
    });
    return elements;
};
function $e6e8e5e948b588ba$export$18b98bbb853bc2c4(api, col, isRtl) {
    const colIndex = $e6e8e5e948b588ba$var$parseCellColIndex(col);
    return $e6e8e5e948b588ba$var$findPinnedHeaders({
        api: api,
        position: isRtl ? 'right' : 'left',
        colIndex: colIndex,
        filterFn: (index)=>isRtl ? index < colIndex : index > colIndex
    });
}
function $e6e8e5e948b588ba$export$a2731c8163776b73(api, col, isRtl) {
    const colIndex = $e6e8e5e948b588ba$var$parseCellColIndex(col);
    return $e6e8e5e948b588ba$var$findPinnedHeaders({
        api: api,
        position: isRtl ? 'left' : 'right',
        colIndex: colIndex,
        filterFn: (index, element)=>{
            if (element.classList.contains((0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--last'])) return false;
            return isRtl ? index > colIndex : index < colIndex;
        }
    });
}
function $e6e8e5e948b588ba$export$5c4f873e8f18904d(api, field) {
    const headers = api.columnHeadersContainerRef.current;
    return headers.querySelector(`:scope > div > [data-field="${$e6e8e5e948b588ba$export$77eab2954df72e62(field)}"][role="columnheader"]`);
}
function $e6e8e5e948b588ba$export$ee9bd404f74f7c9(api, field) {
    const container = api.virtualScrollerRef.current;
    return Array.from(container.querySelectorAll(`:scope > div > div > div > [data-field="${$e6e8e5e948b588ba$export$77eab2954df72e62(field)}"][role="gridcell"]`));
}
function $e6e8e5e948b588ba$var$queryRows(api) {
    return api.virtualScrollerRef.current.querySelectorAll(// Use > to ignore rows from nested Data Grids (for example in detail panel)
    `:scope > div > div > .${(0, $786c119d9add6b61$export$2100d54e36406477).row}`);
}
function $e6e8e5e948b588ba$var$parseCellColIndex(col) {
    const ariaColIndex = col.getAttribute('aria-colindex');
    if (!ariaColIndex) return null;
    return Number(ariaColIndex) - 1;
}


const $02124252b8ac9adb$export$9707fe779d390182 = {
    includeHeaders: true,
    includeOutliers: false,
    outliersFactor: 1.5,
    expand: false,
    disableColumnVirtualization: true
}; /**
 * The Resize API interface that is available in the grid `apiRef`.
 */ 





const $7e0caf0e9aa4df92$export$265f4c39182036e = (apiRef, ref, eventName, handler, options)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useNativeEventListener');
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'rootMount', ()=>{
        const targetElement = typeof ref === 'function' ? ref() : ref.current;
        if (!targetElement || !eventName || !handler) return undefined;
        logger.debug(`Binding native ${eventName} event`);
        targetElement.addEventListener(eventName, handler, options);
        return ()=>{
            logger.debug(`Clearing native ${eventName} event`);
            targetElement.removeEventListener(eventName, handler, options);
        };
    });
};



function $9619aa0711b45424$export$7e10cfd0168dec8f() {
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    promise.resolve = resolve;
    promise.reject = reject;
    return promise;
}






function $735562a08be471d6$var$trackFinger(event, currentTouchId) {
    if (currentTouchId !== undefined && event.changedTouches) {
        for(let i = 0; i < event.changedTouches.length; i += 1){
            const touch = event.changedTouches[i];
            if (touch.identifier === currentTouchId) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $735562a08be471d6$var$computeNewWidth(initialOffsetToSeparator, clickX, columnBounds, resizeDirection) {
    let newWidth = initialOffsetToSeparator;
    if (resizeDirection === 'Right') newWidth += clickX - columnBounds.left;
    else newWidth += columnBounds.right - clickX;
    return newWidth;
}
function $735562a08be471d6$var$computeOffsetToSeparator(clickX, columnBounds, resizeDirection) {
    if (resizeDirection === 'Left') return clickX - columnBounds.left;
    return columnBounds.right - clickX;
}
function $735562a08be471d6$var$flipResizeDirection(side) {
    if (side === 'Right') return 'Left';
    return 'Right';
}
function $735562a08be471d6$var$getResizeDirection(separator, isRtl) {
    const side = separator.classList.contains((0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--sideRight']) ? 'Right' : 'Left';
    if (isRtl) // Resizing logic should be mirrored in the RTL case
    return $735562a08be471d6$var$flipResizeDirection(side);
    return side;
}
function $735562a08be471d6$var$preventClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}
/**
 * Checker that returns a promise that resolves when the column virtualization
 * is disabled.
 */ function $735562a08be471d6$var$useColumnVirtualizationDisabled(apiRef) {
    const promise = $lCzvA.useRef(undefined);
    const selector = ()=>(0, $c79669abb772bd0a$export$ad2aa1e9d465cafa)(apiRef);
    const value = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, selector);
    $lCzvA.useEffect(()=>{
        if (promise.current && value === false) {
            promise.current.resolve();
            promise.current = undefined;
        }
    });
    const asyncCheck = ()=>{
        if (!promise.current) {
            if (selector() === false) return Promise.resolve();
            promise.current = (0, $9619aa0711b45424$export$7e10cfd0168dec8f)();
        }
        return promise.current;
    };
    return asyncCheck;
}
/**
 * Basic statistical outlier detection, checks if the value is `F * IQR` away from
 * the Q1 and Q3 boundaries. IQR: interquartile range.
 */ function $735562a08be471d6$var$excludeOutliers(inputValues, factor) {
    if (inputValues.length < 4) return inputValues;
    const values = inputValues.slice();
    values.sort((a, b)=>a - b);
    const q1 = values[Math.floor(values.length * 0.25)];
    const q3 = values[Math.floor(values.length * 0.75) - 1];
    const iqr = q3 - q1;
    // We make a small adjustment if `iqr < 5` for the cases where the IQR is
    // very small (for example zero) due to very close by values in the input data.
    // Otherwise, with an IQR of `0`, anything outside that would be considered
    // an outlier, but it makes more sense visually to allow for this 5px variance
    // rather than showing a cropped cell.
    const deviation = iqr < 5 ? 5 : iqr * factor;
    return values.filter((v)=>v > q1 - deviation && v < q3 + deviation);
}
function $735562a08be471d6$var$extractColumnWidths(apiRef, options, columns) {
    const widthByField = {};
    const root = apiRef.current.rootElementRef.current;
    root.classList.add((0, $786c119d9add6b61$export$2100d54e36406477).autosizing);
    columns.forEach((column)=>{
        const cells = (0, $e6e8e5e948b588ba$export$ee9bd404f74f7c9)(apiRef.current, column.field);
        const widths = cells.map((cell)=>{
            return cell.getBoundingClientRect().width ?? 0;
        });
        const filteredWidths = options.includeOutliers ? widths : $735562a08be471d6$var$excludeOutliers(widths, options.outliersFactor);
        if (options.includeHeaders) {
            const header = (0, $e6e8e5e948b588ba$export$5c4f873e8f18904d)(apiRef.current, column.field);
            if (header) {
                const title = header.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderTitle}`);
                const content = header.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderTitleContainerContent}`);
                const iconContainer = header.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477).iconButtonContainer}`);
                const menuContainer = header.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477).menuIcon}`);
                const element = title ?? content;
                const style = window.getComputedStyle(header, null);
                const paddingWidth = parseInt(style.paddingLeft, 10) + parseInt(style.paddingRight, 10);
                const contentWidth = element.scrollWidth + 1;
                const width = contentWidth + paddingWidth + (iconContainer?.clientWidth ?? 0) + (menuContainer?.clientWidth ?? 0);
                filteredWidths.push(width);
            }
        }
        const hasColumnMin = column.minWidth !== -Infinity && column.minWidth !== undefined;
        const hasColumnMax = column.maxWidth !== Infinity && column.maxWidth !== undefined;
        const min = hasColumnMin ? column.minWidth : 0;
        const max = hasColumnMax ? column.maxWidth : Infinity;
        const maxContent = filteredWidths.length === 0 ? 0 : Math.max(...filteredWidths);
        widthByField[column.field] = (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(maxContent, min, max);
    });
    root.classList.remove((0, $786c119d9add6b61$export$2100d54e36406477).autosizing);
    return widthByField;
}
const $735562a08be471d6$export$ac6ed2ccd52f643f = (state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        columnResize: {
            resizingColumnField: ''
        }
    });
function $735562a08be471d6$var$createResizeRefs() {
    return {
        colDef: undefined,
        initialColWidth: 0,
        initialTotalWidth: 0,
        previousMouseClickEvent: undefined,
        columnHeaderElement: undefined,
        headerFilterElement: undefined,
        groupHeaderElements: [],
        cellElements: [],
        leftPinnedCellsAfter: [],
        rightPinnedCellsBefore: [],
        fillerLeft: undefined,
        fillerRight: undefined,
        leftPinnedHeadersAfter: [],
        rightPinnedHeadersBefore: []
    };
}
const $735562a08be471d6$export$6761a7afeb3daa64 = (apiRef, props)=>{
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridColumnResize');
    const refs = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)($735562a08be471d6$var$createResizeRefs).current;
    // To improve accessibility, the separator has padding on both sides.
    // Clicking inside the padding area should be treated as a click in the separator.
    // This ref stores the offset between the click and the separator.
    const initialOffsetToSeparator = $lCzvA.useRef(null);
    const resizeDirection = $lCzvA.useRef(null);
    const stopResizeEventTimeout = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const touchId = $lCzvA.useRef(undefined);
    const updateWidth = (newWidth)=>{
        logger.debug(`Updating width to ${newWidth} for col ${refs.colDef.field}`);
        const prevWidth = refs.columnHeaderElement.offsetWidth;
        const widthDiff = newWidth - prevWidth;
        const columnWidthDiff = newWidth - refs.initialColWidth;
        if (columnWidthDiff > 0) {
            const newTotalWidth = refs.initialTotalWidth + columnWidthDiff;
            apiRef.current.rootElementRef?.current?.style.setProperty('--DataGrid-rowWidth', `${newTotalWidth}px`);
        }
        refs.colDef.computedWidth = newWidth;
        refs.colDef.width = newWidth;
        refs.colDef.flex = 0;
        refs.columnHeaderElement.style.width = `${newWidth}px`;
        const headerFilterElement = refs.headerFilterElement;
        if (headerFilterElement) headerFilterElement.style.width = `${newWidth}px`;
        refs.groupHeaderElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute('aria-colspan') === '1') finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.width = finalWidth;
        });
        refs.cellElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute('aria-colspan') === '1') finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.setProperty('--width', finalWidth);
        });
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors('isColumnPinned', false, refs.colDef.field);
        if (pinnedPosition === (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).LEFT) {
            $735562a08be471d6$var$updateProperty(refs.fillerLeft, 'width', widthDiff);
            refs.leftPinnedCellsAfter.forEach((cell)=>{
                $735562a08be471d6$var$updateProperty(cell, 'left', widthDiff);
            });
            refs.leftPinnedHeadersAfter.forEach((header)=>{
                $735562a08be471d6$var$updateProperty(header, 'left', widthDiff);
            });
        }
        if (pinnedPosition === (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT) {
            $735562a08be471d6$var$updateProperty(refs.fillerRight, 'width', widthDiff);
            refs.rightPinnedCellsBefore.forEach((cell)=>{
                $735562a08be471d6$var$updateProperty(cell, 'right', widthDiff);
            });
            refs.rightPinnedHeadersBefore.forEach((header)=>{
                $735562a08be471d6$var$updateProperty(header, 'right', widthDiff);
            });
        }
    };
    const finishResize = (nativeEvent)=>{
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
        // Prevent double-clicks from being interpreted as two separate clicks
        if (refs.previousMouseClickEvent) {
            const prevEvent = refs.previousMouseClickEvent;
            const prevTimeStamp = prevEvent.timeStamp;
            const prevClientX = prevEvent.clientX;
            const prevClientY = prevEvent.clientY;
            // Check if the current event is part of a double-click
            if (nativeEvent.timeStamp - prevTimeStamp < 300 && nativeEvent.clientX === prevClientX && nativeEvent.clientY === prevClientY) {
                refs.previousMouseClickEvent = undefined;
                apiRef.current.publishEvent('columnResizeStop', null, nativeEvent);
                return;
            }
        }
        if (refs.colDef) {
            apiRef.current.setColumnWidth(refs.colDef.field, refs.colDef.width);
            logger.debug(`Updating col ${refs.colDef.field} with new width: ${refs.colDef.width}`);
            // Since during resizing we update the columns width outside of React, React is unable to
            // reapply the right style properties. We need to sync the state manually.
            // So we reapply the same logic as in https://github.com/mui/mui-x/blob/0511bf65543ca05d2602a5a3e0a6156f2fc8e759/packages/x-data-grid/src/hooks/features/columnHeaders/useGridColumnHeaders.tsx#L405
            const columnsState = (0, $8b99503000dd62d3$export$858d15abb6cddc08)(apiRef.current.state);
            refs.groupHeaderElements.forEach((element)=>{
                const fields = (0, $e6e8e5e948b588ba$export$5d6880d172f0ecbb)(element);
                const div = element;
                const newWidth = fields.reduce((acc, field)=>{
                    if (columnsState.columnVisibilityModel[field] !== false) return acc + columnsState.lookup[field].computedWidth;
                    return acc;
                }, 0);
                const finalWidth = `${newWidth}px`;
                div.style.width = finalWidth;
            });
        }
        stopResizeEventTimeout.start(0, ()=>{
            apiRef.current.publishEvent('columnResizeStop', null, nativeEvent);
        });
    };
    const storeReferences = (colDef, separator, xStart)=>{
        const root = apiRef.current.rootElementRef.current;
        refs.initialColWidth = colDef.computedWidth;
        refs.initialTotalWidth = apiRef.current.getRootDimensions().rowWidth;
        refs.colDef = colDef;
        refs.columnHeaderElement = (0, $e6e8e5e948b588ba$export$a2d3aec9ff63900b)(apiRef.current.columnHeadersContainerRef.current, colDef.field);
        const headerFilterElement = root.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477).headerFilterRow} [data-field="${(0, $e6e8e5e948b588ba$export$77eab2954df72e62)(colDef.field)}"]`);
        if (headerFilterElement) refs.headerFilterElement = headerFilterElement;
        refs.groupHeaderElements = (0, $e6e8e5e948b588ba$export$1e5569d10c3ebc8b)(apiRef.current.columnHeadersContainerRef?.current, colDef.field);
        refs.cellElements = (0, $e6e8e5e948b588ba$export$53d8041b57f0055)(refs.columnHeaderElement, apiRef.current);
        refs.fillerLeft = (0, $e6e8e5e948b588ba$export$c16d6f1be06f3423)(apiRef.current, isRtl ? 'filler--pinnedRight' : 'filler--pinnedLeft');
        refs.fillerRight = (0, $e6e8e5e948b588ba$export$c16d6f1be06f3423)(apiRef.current, isRtl ? 'filler--pinnedLeft' : 'filler--pinnedRight');
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors('isColumnPinned', false, refs.colDef.field);
        refs.leftPinnedCellsAfter = pinnedPosition !== (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).LEFT ? [] : (0, $e6e8e5e948b588ba$export$71cc5934f05ca0a1)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.rightPinnedCellsBefore = pinnedPosition !== (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT ? [] : (0, $e6e8e5e948b588ba$export$2eb3bec73fd25ab)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.leftPinnedHeadersAfter = pinnedPosition !== (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).LEFT ? [] : (0, $e6e8e5e948b588ba$export$18b98bbb853bc2c4)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.rightPinnedHeadersBefore = pinnedPosition !== (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT ? [] : (0, $e6e8e5e948b588ba$export$a2731c8163776b73)(apiRef.current, refs.columnHeaderElement, isRtl);
        resizeDirection.current = $735562a08be471d6$var$getResizeDirection(separator, isRtl);
        initialOffsetToSeparator.current = $735562a08be471d6$var$computeOffsetToSeparator(xStart, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
    };
    const handleResizeMouseUp = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(finishResize);
    const handleResizeMouseMove = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((nativeEvent)=>{
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        if (nativeEvent.buttons === 0) {
            handleResizeMouseUp(nativeEvent);
            return;
        }
        let newWidth = $735562a08be471d6$var$computeNewWidth(initialOffsetToSeparator.current, nativeEvent.clientX, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchEnd = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $735562a08be471d6$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        finishResize(nativeEvent);
    });
    const handleTouchMove = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $735562a08be471d6$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        // Cancel move in case some other element consumed a touchmove event and it was not fired.
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            handleTouchEnd(nativeEvent);
            return;
        }
        let newWidth = $735562a08be471d6$var$computeNewWidth(initialOffsetToSeparator.current, finger.x, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchStart = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((event)=>{
        const cellSeparator = (0, $e6e8e5e948b588ba$export$2a63f1401414fc1a)(event.target, (0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--resizable']);
        // Let the event bubble if the target is not a col separator
        if (!cellSeparator) return;
        const touch = event.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const columnHeaderElement = (0, $e6e8e5e948b588ba$export$2a63f1401414fc1a)(event.target, (0, $786c119d9add6b61$export$2100d54e36406477).columnHeader);
        const field = (0, $e6e8e5e948b588ba$export$2c4260a98d98f894)(columnHeaderElement);
        const colDef = apiRef.current.getColumn(field);
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: field
        }, event);
        storeReferences(colDef, cellSeparator, touch.clientX);
        const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(event.currentTarget);
        doc.addEventListener('touchmove', handleTouchMove);
        doc.addEventListener('touchend', handleTouchEnd);
    });
    const stopListening = $lCzvA.useCallback(()=>{
        const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.body.style.removeProperty('cursor');
        doc.removeEventListener('mousemove', handleResizeMouseMove);
        doc.removeEventListener('mouseup', handleResizeMouseUp);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
        // The click event runs right after the mouseup event, we want to wait until it
        // has been canceled before removing our handler.
        setTimeout(()=>{
            doc.removeEventListener('click', $735562a08be471d6$var$preventClick, true);
        }, 100);
        if (refs.columnHeaderElement) refs.columnHeaderElement.style.pointerEvents = 'unset';
    }, [
        apiRef,
        refs,
        handleResizeMouseMove,
        handleResizeMouseUp,
        handleTouchMove,
        handleTouchEnd
    ]);
    const handleResizeStart = $lCzvA.useCallback(({ field: field })=>{
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                columnResize: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.columnResize, {
                    resizingColumnField: field
                })
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const handleResizeStop = $lCzvA.useCallback(()=>{
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                columnResize: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.columnResize, {
                    resizingColumnField: ''
                })
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const handleColumnResizeMouseDown = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(({ colDef: colDef }, event)=>{
        // Only handle left clicks
        if (event.button !== 0) return;
        // Skip if the column isn't resizable
        if (!event.currentTarget.classList.contains((0, $786c119d9add6b61$export$2100d54e36406477)['columnSeparator--resizable'])) return;
        // Avoid text selection
        event.preventDefault();
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: colDef.field
        }, event);
        storeReferences(colDef, event.currentTarget, event.clientX);
        const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.body.style.cursor = 'col-resize';
        refs.previousMouseClickEvent = event.nativeEvent;
        doc.addEventListener('mousemove', handleResizeMouseMove);
        doc.addEventListener('mouseup', handleResizeMouseUp);
        // Prevent the click event if we have resized the column.
        // Fixes https://github.com/mui/mui-x/issues/4777
        doc.addEventListener('click', $735562a08be471d6$var$preventClick, true);
    });
    const handleColumnSeparatorDoubleClick = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((params, event)=>{
        if (props.disableAutosize) return;
        // Only handle left clicks
        if (event.button !== 0) return;
        const column = apiRef.current.state.columns.lookup[params.field];
        if (column.resizable === false) return;
        apiRef.current.autosizeColumns((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props.autosizeOptions, {
            disableColumnVirtualization: false,
            columns: [
                column.field
            ]
        }));
    });
    /**
   * API METHODS
   */ const columnVirtualizationDisabled = $735562a08be471d6$var$useColumnVirtualizationDisabled(apiRef);
    const isAutosizingRef = $lCzvA.useRef(false);
    const autosizeColumns = $lCzvA.useCallback(async (userOptions)=>{
        const root = apiRef.current.rootElementRef?.current;
        if (!root) return;
        if (isAutosizingRef.current) return;
        isAutosizingRef.current = true;
        const state = (0, $8b99503000dd62d3$export$858d15abb6cddc08)(apiRef.current.state);
        const options = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $02124252b8ac9adb$export$9707fe779d390182), userOptions, {
            columns: userOptions?.columns ?? state.orderedFields
        });
        options.columns = options.columns.filter((c)=>state.columnVisibilityModel[c] !== false);
        const columns = options.columns.map((c)=>apiRef.current.state.columns.lookup[c]);
        try {
            if (!props.disableVirtualization && options.disableColumnVirtualization) {
                apiRef.current.unstable_setColumnVirtualization(false);
                await columnVirtualizationDisabled();
            }
            const widthByField = $735562a08be471d6$var$extractColumnWidths(apiRef, options, columns);
            const newColumns = columns.map((column)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, column, {
                    width: widthByField[column.field],
                    computedWidth: widthByField[column.field],
                    flex: 0
                }));
            if (options.expand) {
                const visibleColumns = state.orderedFields.map((field)=>state.lookup[field]).filter((c)=>state.columnVisibilityModel[c.field] !== false);
                const totalWidth = visibleColumns.reduce((total, column)=>total + (widthByField[column.field] ?? column.computedWidth ?? column.width), 0);
                const dimensions = apiRef.current.getRootDimensions();
                const availableWidth = dimensions.viewportInnerSize.width;
                const remainingWidth = availableWidth - totalWidth;
                if (remainingWidth > 0) {
                    const widthPerColumn = remainingWidth / (newColumns.length || 1);
                    newColumns.forEach((column)=>{
                        column.width += widthPerColumn;
                        column.computedWidth += widthPerColumn;
                    });
                }
            }
            apiRef.current.updateColumns(newColumns);
            newColumns.forEach((newColumn, index)=>{
                if (newColumn.width !== columns[index].width) {
                    const width = newColumn.width;
                    apiRef.current.publishEvent('columnWidthChange', {
                        element: apiRef.current.getColumnHeaderElement(newColumn.field),
                        colDef: newColumn,
                        width: width
                    });
                }
            });
        } finally{
            if (!props.disableVirtualization) apiRef.current.unstable_setColumnVirtualization(true);
            isAutosizingRef.current = false;
        }
    }, [
        apiRef,
        columnVirtualizationDisabled,
        props.disableVirtualization
    ]);
    /**
   * EFFECTS
   */ $lCzvA.useEffect(()=>stopListening, [
        stopListening
    ]);
    (0, $375168188d76048b$export$2e2bcd8739ae039)(()=>{
        if (props.autosizeOnMount) Promise.resolve().then(()=>{
            apiRef.current.autosizeColumns(props.autosizeOptions);
        });
    });
    (0, $7e0caf0e9aa4df92$export$265f4c39182036e)(apiRef, ()=>apiRef.current.columnHeadersContainerRef?.current, 'touchstart', handleTouchStart, {
        passive: true
    });
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, {
        autosizeColumns: autosizeColumns
    }, 'public');
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnResizeStop', handleResizeStop);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnResizeStart', handleResizeStart);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnSeparatorMouseDown', handleColumnResizeMouseDown);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnSeparatorDoubleClick', handleColumnSeparatorDoubleClick);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'columnResize', props.onColumnResize);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'columnWidthChange', props.onColumnWidthChange);
};
function $735562a08be471d6$var$updateProperty(element, property, delta) {
    if (!element) return;
    element.style[property] = `${parseInt(element.style[property], 10) + delta}px`;
}



var $lCzvA = parcelRequire("lCzvA");





var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");
const $9ebf8f53803465ea$export$c5623aa1c38918b6 = (callback)=>{
    const isFirstRender = $lCzvA.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        callback();
    }
};


const $f145dfe2f05bbf41$export$98b68054bf03cb4 = (apiRef, group, callback)=>{
    const cleanup = $lCzvA.useRef(null);
    const id = $lCzvA.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $lCzvA.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeApplier(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $9ebf8f53803465ea$export$c5623aa1c38918b6)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};


var $lCzvA = parcelRequire("lCzvA");

const $dfc17f0d90704ebe$export$faa98381ad228894 = (apiRef, group, callback, enabled = true)=>{
    const cleanup = $lCzvA.useRef(null);
    const id = $lCzvA.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $lCzvA.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeProcessor(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $9ebf8f53803465ea$export$c5623aa1c38918b6)(()=>{
        if (enabled) registerPreProcessor();
    });
    const isFirstRender = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else if (enabled) registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor,
        enabled
    ]);
};






const $742cc9978dd17236$export$8dcda879a58a8f96 = (state, props, apiRef)=>{
    const columnsState = (0, $938d01614caf11f5$export$f3ba81d24bd05452)({
        apiRef: apiRef,
        columnsToUpsert: props.columns,
        initialState: props.initialState?.columns,
        columnVisibilityModel: props.columnVisibilityModel ?? props.initialState?.columns?.columnVisibilityModel ?? {},
        keepOnlyColumnsToUpsert: true
    });
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        columns: columnsState,
        // In pro/premium, this part of the state is defined. We give it an empty but defined value
        // for the community version.
        pinnedColumns: state.pinnedColumns ?? (0, $1d134ed1d4a5dbe8$export$77439b544edbbd66)
    });
};
function $742cc9978dd17236$export$fe9b9b8b4620abff(apiRef, props) {
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridColumns');
    const previousColumnsProp = $lCzvA.useRef(props.columns);
    apiRef.current.registerControlState({
        stateId: 'visibleColumns',
        propModel: props.columnVisibilityModel,
        propOnChange: props.onColumnVisibilityModelChange,
        stateSelector: (0, $8b99503000dd62d3$export$eb0d33595fe29bb4),
        changeEvent: 'columnVisibilityModelChange'
    });
    const setGridColumnsState = $lCzvA.useCallback((columnsState)=>{
        logger.debug('Updating columns state.');
        apiRef.current.setState($742cc9978dd17236$var$mergeColumnsState(columnsState));
        apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
    }, [
        logger,
        apiRef
    ]);
    /**
   * API METHODS
   */ const getColumn = $lCzvA.useCallback((field)=>(0, $8b99503000dd62d3$export$8a3a9a6db584d7fd)(apiRef)[field], [
        apiRef
    ]);
    const getAllColumns = $lCzvA.useCallback(()=>(0, $8b99503000dd62d3$export$da85f06e3c19f1fd)(apiRef), [
        apiRef
    ]);
    const getVisibleColumns = $lCzvA.useCallback(()=>(0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef), [
        apiRef
    ]);
    const getColumnIndex = $lCzvA.useCallback((field, useVisibleColumns = true)=>{
        const columns = useVisibleColumns ? (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef) : (0, $8b99503000dd62d3$export$da85f06e3c19f1fd)(apiRef);
        return columns.findIndex((col)=>col.field === field);
    }, [
        apiRef
    ]);
    const getColumnPosition = $lCzvA.useCallback((field)=>{
        const index = getColumnIndex(field);
        return (0, $8b99503000dd62d3$export$fce7d810e48021e3)(apiRef)[index];
    }, [
        apiRef,
        getColumnIndex
    ]);
    const setColumnVisibilityModel = $lCzvA.useCallback((model)=>{
        const currentModel = (0, $8b99503000dd62d3$export$eb0d33595fe29bb4)(apiRef);
        if (currentModel !== model) {
            apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                    columns: (0, $938d01614caf11f5$export$f3ba81d24bd05452)({
                        apiRef: apiRef,
                        columnsToUpsert: [],
                        initialState: undefined,
                        columnVisibilityModel: model,
                        keepOnlyColumnsToUpsert: false
                    })
                }));
            apiRef.current.updateRenderContext?.();
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef
    ]);
    const updateColumns = $lCzvA.useCallback((columns)=>{
        const columnsState = (0, $938d01614caf11f5$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnsToUpsert: columns,
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        setGridColumnsState
    ]);
    const setColumnVisibility = $lCzvA.useCallback((field, isVisible)=>{
        const columnVisibilityModel = (0, $8b99503000dd62d3$export$eb0d33595fe29bb4)(apiRef);
        const isCurrentlyVisible = columnVisibilityModel[field] ?? true;
        if (isVisible !== isCurrentlyVisible) {
            const newModel = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, columnVisibilityModel, {
                [field]: isVisible
            });
            apiRef.current.setColumnVisibilityModel(newModel);
        }
    }, [
        apiRef
    ]);
    const getColumnIndexRelativeToVisibleColumns = $lCzvA.useCallback((field)=>{
        const allColumns = (0, $8b99503000dd62d3$export$d8a3dfbb129c80db)(apiRef);
        return allColumns.findIndex((col)=>col === field);
    }, [
        apiRef
    ]);
    const setColumnIndex = $lCzvA.useCallback((field, targetIndexPosition)=>{
        const allColumns = (0, $8b99503000dd62d3$export$d8a3dfbb129c80db)(apiRef);
        const oldIndexPosition = getColumnIndexRelativeToVisibleColumns(field);
        if (oldIndexPosition === targetIndexPosition) return;
        logger.debug(`Moving column ${field} to index ${targetIndexPosition}`);
        const updatedColumns = [
            ...allColumns
        ];
        const fieldRemoved = updatedColumns.splice(oldIndexPosition, 1)[0];
        updatedColumns.splice(targetIndexPosition, 0, fieldRemoved);
        setGridColumnsState((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $8b99503000dd62d3$export$858d15abb6cddc08)(apiRef.current.state), {
            orderedFields: updatedColumns
        }));
        const params = {
            column: apiRef.current.getColumn(field),
            targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(field),
            oldIndex: oldIndexPosition
        };
        apiRef.current.publishEvent('columnIndexChange', params);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        getColumnIndexRelativeToVisibleColumns
    ]);
    const setColumnWidth = $lCzvA.useCallback((field, width)=>{
        logger.debug(`Updating column ${field} width to ${width}`);
        const columnsState = (0, $8b99503000dd62d3$export$858d15abb6cddc08)(apiRef.current.state);
        const column = columnsState.lookup[field];
        const newColumn = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, column, {
            width: width,
            hasBeenResized: true
        });
        setGridColumnsState((0, $938d01614caf11f5$export$cd8dc1fa232954ad)((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, columnsState, {
            lookup: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, columnsState.lookup, {
                [field]: newColumn
            })
        }), apiRef.current.getRootDimensions()));
        apiRef.current.publishEvent('columnWidthChange', {
            element: apiRef.current.getColumnHeaderElement(field),
            colDef: newColumn,
            width: width
        });
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    const columnApi = {
        getColumn: getColumn,
        getAllColumns: getAllColumns,
        getColumnIndex: getColumnIndex,
        getColumnPosition: getColumnPosition,
        getVisibleColumns: getVisibleColumns,
        getColumnIndexRelativeToVisibleColumns: getColumnIndexRelativeToVisibleColumns,
        updateColumns: updateColumns,
        setColumnVisibilityModel: setColumnVisibilityModel,
        setColumnVisibility: setColumnVisibility,
        setColumnWidth: setColumnWidth
    };
    const columnReorderApi = {
        setColumnIndex: setColumnIndex
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, columnApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, columnReorderApi, props.signature === (0, $ecad0fba09446fc0$export$544be0bdf85b5af1).DataGrid ? 'private' : 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $lCzvA.useCallback((prevState, context)=>{
        const columnsStateToExport = {};
        const columnVisibilityModelToExport = (0, $8b99503000dd62d3$export$eb0d33595fe29bb4)(apiRef);
        const shouldExportColumnVisibilityModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.columnVisibilityModel != null || // Always export if the model has been initialized
        // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
        Object.keys(props.initialState?.columns?.columnVisibilityModel ?? {}).length > 0 || // Always export if the model is not empty
        Object.keys(columnVisibilityModelToExport).length > 0;
        if (shouldExportColumnVisibilityModel) columnsStateToExport.columnVisibilityModel = columnVisibilityModelToExport;
        columnsStateToExport.orderedFields = (0, $8b99503000dd62d3$export$d8a3dfbb129c80db)(apiRef);
        const columns = (0, $8b99503000dd62d3$export$da85f06e3c19f1fd)(apiRef);
        const dimensions = {};
        columns.forEach((colDef)=>{
            if (colDef.hasBeenResized) {
                const colDefDimensions = {};
                (0, $938d01614caf11f5$export$cd7252624d377ce0).forEach((propertyName)=>{
                    let propertyValue = colDef[propertyName];
                    if (propertyValue === Infinity) propertyValue = -1;
                    colDefDimensions[propertyName] = propertyValue;
                });
                dimensions[colDef.field] = colDefDimensions;
            }
        });
        if (Object.keys(dimensions).length > 0) columnsStateToExport.dimensions = dimensions;
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState, {
            columns: columnsStateToExport
        });
    }, [
        apiRef,
        props.columnVisibilityModel,
        props.initialState?.columns
    ]);
    const stateRestorePreProcessing = $lCzvA.useCallback((params, context)=>{
        const columnVisibilityModelToImport = context.stateToRestore.columns?.columnVisibilityModel;
        const initialState = context.stateToRestore.columns;
        if (columnVisibilityModelToImport == null && initialState == null) return params;
        const columnsState = (0, $938d01614caf11f5$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: initialState,
            columnVisibilityModel: columnVisibilityModelToImport,
            keepOnlyColumnsToUpsert: false
        });
        apiRef.current.setState($742cc9978dd17236$var$mergeColumnsState(columnsState));
        if (initialState != null) apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
        return params;
    }, [
        apiRef
    ]);
    const preferencePanelPreProcessing = $lCzvA.useCallback((initialValue, value)=>{
        if (value === (0, $57afc8119b2eb3e6$export$e7e5652452e44b).columns) {
            const ColumnsPanel = props.slots.columnsPanel;
            return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(ColumnsPanel, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props.slotProps?.columnsPanel));
        }
        return initialValue;
    }, [
        props.slots.columnsPanel,
        props.slotProps?.columnsPanel
    ]);
    const addColumnMenuItems = $lCzvA.useCallback((columnMenuItems)=>{
        if (props.disableColumnSelector) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuColumnsItem'
        ];
    }, [
        props.disableColumnSelector
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'columnMenu', addColumnMenuItems);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    /*
   * EVENTS
   */ const prevInnerWidth = $lCzvA.useRef(null);
    const handleGridSizeChange = (size)=>{
        if (prevInnerWidth.current !== size.width) {
            prevInnerWidth.current = size.width;
            const hasFlexColumns = (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef).some((col)=>col.flex && col.flex > 0);
            if (!hasFlexColumns) return;
            setGridColumnsState((0, $938d01614caf11f5$export$cd8dc1fa232954ad)((0, $8b99503000dd62d3$export$858d15abb6cddc08)(apiRef.current.state), apiRef.current.getRootDimensions()));
        }
    };
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    /**
   * APPLIERS
   */ const hydrateColumns = $lCzvA.useCallback(()=>{
        logger.info(`Columns pipe processing have changed, regenerating the columns`);
        const columnsState = (0, $938d01614caf11f5$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    (0, $f145dfe2f05bbf41$export$98b68054bf03cb4)(apiRef, 'hydrateColumns', hydrateColumns);
    /*
   * EFFECTS
   */ // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridColumns`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        logger.info(`GridColumns have changed, new length ${props.columns.length}`);
        if (previousColumnsProp.current === props.columns) return;
        const columnsState = (0, $938d01614caf11f5$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            initialState: undefined,
            // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
            columnsToUpsert: props.columns,
            keepOnlyColumnsToUpsert: true
        });
        previousColumnsProp.current = props.columns;
        setGridColumnsState(columnsState);
    }, [
        logger,
        apiRef,
        setGridColumnsState,
        props.columns
    ]);
    $lCzvA.useEffect(()=>{
        if (props.columnVisibilityModel !== undefined) apiRef.current.setColumnVisibilityModel(props.columnVisibilityModel);
    }, [
        apiRef,
        logger,
        props.columnVisibilityModel
    ]);
}
function $742cc9978dd17236$var$mergeColumnsState(columnsState) {
    return (state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
            columns: columnsState
        });
}



var $lCzvA = parcelRequire("lCzvA");





const $f10296779b31302e$export$d6d71dbaaa6fec72 = (state, props)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        density: props.initialState?.density ?? props.density ?? 'standard'
    });
const $f10296779b31302e$export$836c4be63cf7a42d = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useDensity');
    apiRef.current.registerControlState({
        stateId: 'density',
        propModel: props.density,
        propOnChange: props.onDensityChange,
        stateSelector: (0, $bc5ab296ed04c1c0$export$806a039ece4425b4),
        changeEvent: 'densityChange'
    });
    const setDensity = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((newDensity)=>{
        const currentDensity = (0, $bc5ab296ed04c1c0$export$806a039ece4425b4)(apiRef.current.state);
        if (currentDensity === newDensity) return;
        logger.debug(`Set grid density to ${newDensity}`);
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                density: newDensity
            }));
    });
    const densityApi = {
        setDensity: setDensity
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, densityApi, 'public');
    const stateExportPreProcessing = $lCzvA.useCallback((prevState, context)=>{
        const exportedDensity = (0, $bc5ab296ed04c1c0$export$806a039ece4425b4)(apiRef.current.state);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `density` is controlled
        props.density != null || // Always export if the `density` has been initialized
        props.initialState?.density != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState, {
            density: exportedDensity
        });
    }, [
        apiRef,
        props.density,
        props.initialState?.density
    ]);
    const stateRestorePreProcessing = $lCzvA.useCallback((params, context)=>{
        const restoredDensity = context.stateToRestore?.density ? context.stateToRestore.density : (0, $bc5ab296ed04c1c0$export$806a039ece4425b4)(apiRef.current.state);
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                density: restoredDensity
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    $lCzvA.useEffect(()=>{
        if (props.density) apiRef.current.setDensity(props.density);
    }, [
        apiRef,
        props.density
    ]);
};



var $lCzvA = parcelRequire("lCzvA");

function $eab0dd2cbd28c6c1$export$de363e709c412c8a(func, wait = 166) {
    let timeout;
    let lastArgs;
    const later = ()=>{
        timeout = undefined;
        func(...lastArgs);
    };
    function throttled(...args) {
        lastArgs = args;
        if (timeout === undefined) timeout = setTimeout(later, wait);
    }
    throttled.clear = ()=>{
        clearTimeout(timeout);
        timeout = undefined;
    };
    return throttled;
}
















const $270da21e92ce0d1d$export$2733e0e1a1d288e7 = {
    autoHeight: false,
    autoPageSize: false,
    autosizeOnMount: false,
    checkboxSelection: false,
    checkboxSelectionVisibleOnly: false,
    clipboardCopyCellDelimiter: '\t',
    columnBufferPx: 150,
    columnHeaderHeight: 56,
    disableAutosize: false,
    disableColumnFilter: false,
    disableColumnMenu: false,
    disableColumnReorder: false,
    disableColumnResize: false,
    disableColumnSelector: false,
    disableColumnSorting: false,
    disableDensitySelector: false,
    disableEval: false,
    disableMultipleColumnsFiltering: false,
    disableMultipleColumnsSorting: false,
    disableMultipleRowSelection: false,
    disableRowSelectionOnClick: false,
    disableVirtualization: false,
    editMode: (0, $a01f6e6f52a2f91e$export$bad6b7a934346f26).Cell,
    filterDebounceMs: 150,
    filterMode: 'client',
    hideFooter: false,
    hideFooterPagination: false,
    hideFooterRowCount: false,
    hideFooterSelectedRowCount: false,
    ignoreDiacritics: false,
    ignoreValueFormatterDuringExport: false,
    // TODO v8: Update to 'select'
    indeterminateCheckboxAction: 'deselect',
    keepColumnPositionIfDraggedOutside: false,
    keepNonExistentRowsSelected: false,
    loading: false,
    logger: console,
    logLevel: 'error',
    pageSizeOptions: [
        25,
        50,
        100
    ],
    pagination: false,
    paginationMode: 'client',
    resetPageOnSortFilter: false,
    resizeThrottleMs: 60,
    rowBufferPx: 150,
    rowHeight: 52,
    rowPositionsDebounceMs: 166,
    rows: [],
    rowSelection: true,
    rowSpacingType: 'margin',
    showCellVerticalBorder: false,
    showColumnVerticalBorder: false,
    sortingMode: 'client',
    sortingOrder: [
        'asc',
        'desc',
        null
    ],
    throttleRowsMs: 0,
    unstable_rowSpanning: false,
    virtualizeColumnsWithAutoRowHeight: false
};





const $ecd24dbdbaa9f7cf$var$EMPTY_SIZE = {
    width: 0,
    height: 0
};
const $ecd24dbdbaa9f7cf$var$EMPTY_DIMENSIONS = {
    isReady: false,
    root: $ecd24dbdbaa9f7cf$var$EMPTY_SIZE,
    viewportOuterSize: $ecd24dbdbaa9f7cf$var$EMPTY_SIZE,
    viewportInnerSize: $ecd24dbdbaa9f7cf$var$EMPTY_SIZE,
    contentSize: $ecd24dbdbaa9f7cf$var$EMPTY_SIZE,
    minimumSize: $ecd24dbdbaa9f7cf$var$EMPTY_SIZE,
    hasScrollX: false,
    hasScrollY: false,
    scrollbarSize: 0,
    headerHeight: 0,
    groupHeaderHeight: 0,
    headerFilterHeight: 0,
    rowWidth: 0,
    rowHeight: 0,
    columnsTotalWidth: 0,
    leftPinnedWidth: 0,
    rightPinnedWidth: 0,
    headersTotalHeight: 0,
    topContainerHeight: 0,
    bottomContainerHeight: 0
};
const $ecd24dbdbaa9f7cf$export$c29f872c616fae5b = (state, props, apiRef)=>{
    const dimensions = $ecd24dbdbaa9f7cf$var$EMPTY_DIMENSIONS;
    const density = (0, $bc5ab296ed04c1c0$export$c646201fb1d3e7a6)(apiRef);
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        dimensions: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, dimensions, $ecd24dbdbaa9f7cf$var$getStaticDimensions(props, apiRef, density, (0, $8b99503000dd62d3$export$297e8079713afa11)(apiRef)))
    });
};
const $ecd24dbdbaa9f7cf$var$columnsTotalWidthSelector = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)((0, $8b99503000dd62d3$export$16a65a9447d3dda9), (0, $8b99503000dd62d3$export$fce7d810e48021e3), (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return (0, $75a73207cfe0ae7e$export$28cd30446ab5724a)(positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth, 1);
});
function $ecd24dbdbaa9f7cf$export$b8364994f9eec67d(apiRef, props) {
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useResizeContainer');
    const errorShown = $lCzvA.useRef(false);
    const rootDimensionsRef = $lCzvA.useRef($ecd24dbdbaa9f7cf$var$EMPTY_SIZE);
    const pinnedColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$297e8079713afa11));
    const densityFactor = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $bc5ab296ed04c1c0$export$c646201fb1d3e7a6));
    const columnsTotalWidth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, $ecd24dbdbaa9f7cf$var$columnsTotalWidthSelector);
    const isFirstSizing = $lCzvA.useRef(true);
    // Vertical scrollbar oscillation detector.
    // Counts consecutive hasScrollY flips that happen with no row-height change.
    // After 2 flips it is certainly a layout feedback loop, so every further flip
    // is forced to false (no scrollbar). The counter resets when row heights change.
    // Only vertical scrollbar can oscillate because column widths are never 'auto'.
    // https://github.com/mui/mui-x/issues/20539
    const scrollYOscillation = $lCzvA.useRef({
        counter: 0,
        heights: {
            content: 0,
            pinnedTop: 0,
            pinnedBottom: 0
        }
    });
    const { rowHeight: rowHeight, headerHeight: headerHeight, groupHeaderHeight: groupHeaderHeight, headerFilterHeight: headerFilterHeight, headersTotalHeight: headersTotalHeight, leftPinnedWidth: leftPinnedWidth, rightPinnedWidth: rightPinnedWidth } = $ecd24dbdbaa9f7cf$var$getStaticDimensions(props, apiRef, densityFactor, pinnedColumns);
    const previousSize = $lCzvA.useRef(undefined);
    const getRootDimensions = $lCzvA.useCallback(()=>(0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state), [
        apiRef
    ]);
    const setDimensions = $lCzvA.useCallback((dimensions)=>{
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                dimensions: dimensions
            }));
        if (apiRef.current.rootElementRef.current) $ecd24dbdbaa9f7cf$var$setCSSVariables(apiRef.current.rootElementRef.current, (0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state));
    }, [
        apiRef
    ]);
    const resize = $lCzvA.useCallback(()=>{
        const element = apiRef.current.mainElementRef.current;
        if (!element) return;
        const computedStyle = (0, $cbe0ef075048c43a$export$2e2bcd8739ae039)(element).getComputedStyle(element);
        const newSize = {
            width: parseFloat(computedStyle.width) || 0,
            height: parseFloat(computedStyle.height) || 0
        };
        if (!previousSize.current || !$ecd24dbdbaa9f7cf$var$areElementSizesEqual(previousSize.current, newSize)) {
            apiRef.current.publishEvent('resize', newSize);
            previousSize.current = newSize;
        }
    }, [
        apiRef
    ]);
    const getViewportPageSize = $lCzvA.useCallback(()=>{
        const dimensions = (0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state);
        if (!dimensions.isReady) return 0;
        const currentPage = (0, $6b6f708ce7819830$export$79b9fa322a34430b)(apiRef);
        // TODO: Use a combination of scrollTop, dimensions.viewportInnerSize.height and rowsMeta.possitions
        // to find out the maximum number of rows that can fit in the visible part of the grid
        if (props.getRowHeight) {
            const renderContext = (0, $c79669abb772bd0a$export$4cf9f333a030f780)(apiRef);
            const viewportPageSize = renderContext.lastRowIndex - renderContext.firstRowIndex;
            return Math.min(viewportPageSize - 1, currentPage.rows.length);
        }
        const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / rowHeight);
        return Math.min(maximumPageSizeWithoutScrollBar, currentPage.rows.length);
    }, [
        apiRef,
        props.getRowHeight,
        rowHeight
    ]);
    const updateDimensions = $lCzvA.useCallback(()=>{
        if (isFirstSizing.current) return;
        // All the floating point dimensions should be rounded to .1 decimal places to avoid subpixel rendering issues
        // https://github.com/mui/mui-x/issues/9550#issuecomment-1619020477
        // https://github.com/mui/mui-x/issues/15721
        const scrollbarSize = $ecd24dbdbaa9f7cf$var$measureScrollbarSize(apiRef.current.mainElementRef.current, props.scrollbarSize);
        const rowsMeta = (0, $ab89a1ec5ede86ad$export$4f32bfc70efeb4ab)(apiRef.current.state);
        const topContainerHeight = headersTotalHeight + rowsMeta.pinnedTopRowsTotalHeight;
        const bottomContainerHeight = rowsMeta.pinnedBottomRowsTotalHeight;
        const nonPinnedColumnsTotalWidth = columnsTotalWidth - leftPinnedWidth - rightPinnedWidth;
        const contentSize = {
            width: nonPinnedColumnsTotalWidth,
            height: (0, $75a73207cfe0ae7e$export$28cd30446ab5724a)(rowsMeta.currentPageTotalHeight, 1)
        };
        const prevDimensions = apiRef.current.state.dimensions;
        let viewportOuterSize;
        let viewportInnerSize;
        let hasScrollX = false;
        let hasScrollY = false;
        if (props.autoHeight) {
            hasScrollY = false;
            hasScrollX = Math.round(columnsTotalWidth) > Math.round(rootDimensionsRef.current.width);
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: topContainerHeight + bottomContainerHeight + contentSize.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width - (hasScrollY ? scrollbarSize : 0)),
                height: Math.max(0, viewportOuterSize.height - (hasScrollX ? scrollbarSize : 0))
            };
        } else {
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: rootDimensionsRef.current.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width - leftPinnedWidth - rightPinnedWidth),
                height: Math.max(0, viewportOuterSize.height - topContainerHeight - bottomContainerHeight)
            };
            const content = contentSize;
            const container = viewportInnerSize;
            const hasScrollXIfNoYScrollBar = content.width > container.width;
            const hasScrollYIfNoXScrollBar = content.height > container.height;
            if (hasScrollXIfNoYScrollBar || hasScrollYIfNoXScrollBar) {
                hasScrollY = hasScrollYIfNoXScrollBar;
                hasScrollX = content.width + (hasScrollY ? scrollbarSize : 0) > container.width;
                // We recalculate the scroll y to consider the size of the x scrollbar.
                if (hasScrollX) hasScrollY = content.height + scrollbarSize > container.height;
            }
            // Detect vertical scrollbar oscillation.
            // Track consecutive hasScrollY flips with no row-height change.
            // Once confirmed (≥ 2 flips), force hasScrollY off — the scrollbar is
            // not genuinely needed, it is a layout feedback loop caused by stale
            // rootSize or the horizontal scrollbar's height cascading.
            {
                const osc = scrollYOscillation.current;
                const heightsChanged = rowsMeta.currentPageTotalHeight !== osc.heights.content || rowsMeta.pinnedTopRowsTotalHeight !== osc.heights.pinnedTop || rowsMeta.pinnedBottomRowsTotalHeight !== osc.heights.pinnedBottom;
                if (heightsChanged) {
                    osc.counter = 0;
                    osc.heights = {
                        content: rowsMeta.currentPageTotalHeight,
                        pinnedTop: rowsMeta.pinnedTopRowsTotalHeight,
                        pinnedBottom: rowsMeta.pinnedBottomRowsTotalHeight
                    };
                }
                if (prevDimensions.isReady && hasScrollY !== prevDimensions.hasScrollY) {
                    if (!heightsChanged) osc.counter += 1;
                    if (osc.counter >= 2) {
                        hasScrollY = false;
                        // Recompute hasScrollX without the vertical scrollbar's width impact,
                        // otherwise the cascade (hasScrollY → narrower viewport → hasScrollX)
                        // keeps the horizontal scrollbar/filler alive and the root keeps resizing.
                        hasScrollX = hasScrollXIfNoYScrollBar;
                    }
                }
            }
            if (hasScrollY) viewportInnerSize.width -= scrollbarSize;
            if (hasScrollX) viewportInnerSize.height -= scrollbarSize;
        }
        const rowWidth = Math.max(viewportOuterSize.width, columnsTotalWidth + (hasScrollY ? scrollbarSize : 0));
        const minimumSize = {
            width: columnsTotalWidth,
            height: topContainerHeight + contentSize.height + bottomContainerHeight
        };
        const newDimensions = {
            isReady: true,
            root: rootDimensionsRef.current,
            viewportOuterSize: viewportOuterSize,
            viewportInnerSize: viewportInnerSize,
            contentSize: contentSize,
            minimumSize: minimumSize,
            hasScrollX: hasScrollX,
            hasScrollY: hasScrollY,
            scrollbarSize: scrollbarSize,
            headerHeight: headerHeight,
            groupHeaderHeight: groupHeaderHeight,
            headerFilterHeight: headerFilterHeight,
            rowWidth: rowWidth,
            rowHeight: rowHeight,
            columnsTotalWidth: columnsTotalWidth,
            leftPinnedWidth: leftPinnedWidth,
            rightPinnedWidth: rightPinnedWidth,
            headersTotalHeight: headersTotalHeight,
            topContainerHeight: topContainerHeight,
            bottomContainerHeight: bottomContainerHeight
        };
        if ((0, $ac3bd7253ec0e92a$export$78fdc9adc3f30400)(prevDimensions, newDimensions)) return;
        setDimensions(newDimensions);
        if (!$ecd24dbdbaa9f7cf$var$areElementSizesEqual(newDimensions.viewportInnerSize, prevDimensions.viewportInnerSize)) apiRef.current.publishEvent('viewportInnerSizeChange', newDimensions.viewportInnerSize);
        apiRef.current.updateRenderContext?.();
    }, [
        apiRef,
        setDimensions,
        props.scrollbarSize,
        props.autoHeight,
        rowHeight,
        headerHeight,
        groupHeaderHeight,
        headerFilterHeight,
        columnsTotalWidth,
        headersTotalHeight,
        leftPinnedWidth,
        rightPinnedWidth
    ]);
    const updateDimensionCallback = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(updateDimensions);
    const debouncedUpdateDimensions = $lCzvA.useMemo(()=>props.resizeThrottleMs > 0 ? (0, $eab0dd2cbd28c6c1$export$de363e709c412c8a)(()=>{
            updateDimensionCallback();
            apiRef.current.publishEvent('debouncedResize', rootDimensionsRef.current);
        }, props.resizeThrottleMs) : undefined, [
        apiRef,
        props.resizeThrottleMs,
        updateDimensionCallback
    ]);
    $lCzvA.useEffect(()=>debouncedUpdateDimensions?.clear, [
        debouncedUpdateDimensions
    ]);
    const apiPublic = {
        resize: resize,
        getRootDimensions: getRootDimensions
    };
    const apiPrivate = {
        updateDimensions: updateDimensions,
        getViewportPageSize: getViewportPageSize
    };
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(updateDimensions, [
        updateDimensions
    ]);
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, apiPublic, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, apiPrivate, 'private');
    const handleRootMount = $lCzvA.useCallback((root)=>{
        $ecd24dbdbaa9f7cf$var$setCSSVariables(root, (0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state));
    }, [
        apiRef
    ]);
    const handleResize = $lCzvA.useCallback((size)=>{
        rootDimensionsRef.current = size;
        if (size.height === 0 && !errorShown.current && !props.autoHeight && !(0, $9234f987c3e65965$export$c8f880a2d81914c4)) {
            logger.error([
                'The parent DOM element of the Data Grid has an empty height.',
                'Please make sure that this element has an intrinsic height.',
                'The grid displays with a height of 0px.',
                '',
                'More details: https://mui.com/r/x-data-grid-no-dimensions.'
            ].join('\n'));
            errorShown.current = true;
        }
        if (size.width === 0 && !errorShown.current && !(0, $9234f987c3e65965$export$c8f880a2d81914c4)) {
            logger.error([
                'The parent DOM element of the Data Grid has an empty width.',
                'Please make sure that this element has an intrinsic width.',
                'The grid displays with a width of 0px.',
                '',
                'More details: https://mui.com/r/x-data-grid-no-dimensions.'
            ].join('\n'));
            errorShown.current = true;
        }
        if (isFirstSizing.current || !debouncedUpdateDimensions) {
            // We want to initialize the grid dimensions as soon as possible to avoid flickering
            isFirstSizing.current = false;
            updateDimensions();
            return;
        }
        debouncedUpdateDimensions();
    }, [
        updateDimensions,
        props.autoHeight,
        debouncedUpdateDimensions,
        logger
    ]);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'rootMount', handleRootMount);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'resize', handleResize);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'debouncedResize', props.onResize);
}
function $ecd24dbdbaa9f7cf$var$setCSSVariables(root, dimensions) {
    const set = (k, v)=>root.style.setProperty(k, v);
    set('--DataGrid-hasScrollX', `${Number(dimensions.hasScrollX)}`);
    set('--DataGrid-hasScrollY', `${Number(dimensions.hasScrollY)}`);
    set('--DataGrid-scrollbarSize', `${dimensions.scrollbarSize}px`);
    set('--DataGrid-rowWidth', `${dimensions.rowWidth}px`);
    set('--DataGrid-columnsTotalWidth', `${dimensions.columnsTotalWidth}px`);
    set('--DataGrid-leftPinnedWidth', `${dimensions.leftPinnedWidth}px`);
    set('--DataGrid-rightPinnedWidth', `${dimensions.rightPinnedWidth}px`);
    set('--DataGrid-headerHeight', `${dimensions.headerHeight}px`);
    set('--DataGrid-headersTotalHeight', `${dimensions.headersTotalHeight}px`);
    set('--DataGrid-topContainerHeight', `${dimensions.topContainerHeight}px`);
    set('--DataGrid-bottomContainerHeight', `${dimensions.bottomContainerHeight}px`);
    set('--height', `${dimensions.rowHeight}px`);
}
function $ecd24dbdbaa9f7cf$var$getStaticDimensions(props, apiRef, density, pinnedColumnns) {
    const validRowHeight = (0, $dc4fe3453cdb0a0a$export$fa15c17c0798a441)(props.rowHeight, (0, $270da21e92ce0d1d$export$2733e0e1a1d288e7).rowHeight, (0, $dc4fe3453cdb0a0a$export$abf6a2a1a7dde56b));
    return {
        rowHeight: Math.floor(validRowHeight * density),
        headerHeight: Math.floor(props.columnHeaderHeight * density),
        groupHeaderHeight: Math.floor((props.columnGroupHeaderHeight ?? props.columnHeaderHeight) * density),
        headerFilterHeight: Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * density),
        columnsTotalWidth: $ecd24dbdbaa9f7cf$var$columnsTotalWidthSelector(apiRef),
        headersTotalHeight: (0, $938d01614caf11f5$export$659109c29172602f)(apiRef, props),
        leftPinnedWidth: pinnedColumnns.left.reduce((w, col)=>w + col.computedWidth, 0),
        rightPinnedWidth: pinnedColumnns.right.reduce((w, col)=>w + col.computedWidth, 0)
    };
}
const $ecd24dbdbaa9f7cf$var$scrollbarSizeCache = new WeakMap();
function $ecd24dbdbaa9f7cf$var$measureScrollbarSize(element, scrollbarSize) {
    if (scrollbarSize !== undefined) return scrollbarSize;
    if (element === null) return 0;
    const cachedSize = $ecd24dbdbaa9f7cf$var$scrollbarSizeCache.get(element);
    if (cachedSize !== undefined) return cachedSize;
    const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(element);
    const scrollDiv = doc.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.className = 'scrollDiv';
    element.appendChild(scrollDiv);
    const size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    element.removeChild(scrollDiv);
    $ecd24dbdbaa9f7cf$var$scrollbarSizeCache.set(element, size);
    return size;
}
function $ecd24dbdbaa9f7cf$var$areElementSizesEqual(a, b) {
    return a.width === b.width && a.height === b.height;
}



var $lCzvA = parcelRequire("lCzvA");


function $8410ced365fa20bf$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8410ced365fa20bf$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8410ced365fa20bf$export$2e2bcd8739ae039(o);
}



function $792af9029e3bf7fe$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8410ced365fa20bf$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8410ced365fa20bf$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $bb90ae25267601e8$export$2e2bcd8739ae039(t) {
    var i = (0, $792af9029e3bf7fe$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $8410ced365fa20bf$export$2e2bcd8739ae039)(i) ? i : i + "";
}




var $lCzvA = parcelRequire("lCzvA");







const $5396c90484690c1e$export$91ed78b95c9e6636 = (state)=>state.editRows;
const $5396c90484690c1e$export$3ca6aabd7600f0b3 = (0, $f0fef4ed0246c865$export$89f5fc21559ede9b)($5396c90484690c1e$export$91ed78b95c9e6636, (editRows, { rowId: rowId, editMode: editMode })=>editMode === (0, $a01f6e6f52a2f91e$export$bad6b7a934346f26).Row && Boolean(editRows[rowId]));
const $5396c90484690c1e$export$e6f93ce5e9b42cd9 = (0, $f0fef4ed0246c865$export$89f5fc21559ede9b)($5396c90484690c1e$export$91ed78b95c9e6636, (editRows, { rowId: rowId, field: field })=>editRows[rowId]?.[field] ?? null);


// Non printable keys have a name, for example "ArrowRight", see the whole list:
// https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
// So event.key.length === 1 is often enough.
//
// However, we also need to ignore shortcuts, for example: select all:
// - Windows: Ctrl+A, event.ctrlKey is true
// - macOS: ⌘ Command+A, event.metaKey is true
function $23fd0e5066a0f9a3$export$b3f2c64190cf8c4(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
const $23fd0e5066a0f9a3$export$b7d709ba679d3811 = [
    'Meta',
    'Control',
    'Shift'
];
const $23fd0e5066a0f9a3$export$cb76cac5e13767b3 = [
    'Enter',
    'Escape',
    'Tab'
];
const $23fd0e5066a0f9a3$export$88516d667267d515 = [
    'Enter',
    'Tab'
];
const $23fd0e5066a0f9a3$export$6ac2fcffa1f825f7 = (key)=>$23fd0e5066a0f9a3$export$b7d709ba679d3811.indexOf(key) > -1;
const $23fd0e5066a0f9a3$export$a8f5f024431d9642 = (event)=>$23fd0e5066a0f9a3$export$b3f2c64190cf8c4(event) || event.key === 'Enter' || event.key === 'Backspace' || event.key === 'Delete';
const $23fd0e5066a0f9a3$export$f6a96f75820f81fd = (key)=>$23fd0e5066a0f9a3$export$cb76cac5e13767b3.indexOf(key) > -1;
const $23fd0e5066a0f9a3$export$d3e9cf1edead7ecb = (key)=>$23fd0e5066a0f9a3$export$88516d667267d515.indexOf(key) > -1;
const $23fd0e5066a0f9a3$export$e13d96c38a470518 = (key)=>key.indexOf('Arrow') === 0 || key.indexOf('Page') === 0 || key === ' ' || key === 'Home' || key === 'End';
const $23fd0e5066a0f9a3$export$130b789831072f4c = (event)=>!!event.key;
const $23fd0e5066a0f9a3$export$81301abbcd0c8143 = (key)=>key === 'Tab' || key === 'Escape';
function $23fd0e5066a0f9a3$export$dc044e3b830c7edc(event) {
    return (event.ctrlKey || event.metaKey) && // We can't use event.code === 'KeyV' as event.code assumes a QWERTY keyboard layout,
    // for example, it would be another letter on a Dvorak physical keyboard.
    // We can't use event.key === 'v' as event.key is not stable with key modifiers and keyboard layouts,
    // for example, it would be ה on a Hebrew keyboard layout.
    // https://github.com/w3c/uievents/issues/377 could be a long-term solution
    String.fromCharCode(event.keyCode) === 'V' && !event.shiftKey && !event.altKey;
}
function $23fd0e5066a0f9a3$export$b3bab6a2e94206d4(event) {
    return (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'C' && !event.shiftKey && !event.altKey;
}





const $bb15dfa6a6852322$export$311bd602ebd44399 = (colDef)=>{
    switch(colDef.type){
        case 'boolean':
            return false;
        case 'date':
        case 'dateTime':
        case 'number':
            return undefined;
        case 'singleSelect':
            return null;
        case 'string':
        default:
            return '';
    }
};


const $195b683637b129da$var$_excluded = [
    "id",
    "field"
], $195b683637b129da$var$_excluded2 = [
    "id",
    "field"
];
const $195b683637b129da$export$2c9a271ac5d3f446 = (apiRef, props)=>{
    const [cellModesModel, setCellModesModel] = $lCzvA.useState({});
    const cellModesModelRef = $lCzvA.useRef(cellModesModel);
    const prevCellModesModel = $lCzvA.useRef({});
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, cellModesModel: cellModesModelProp, onCellModesModelChange: onCellModesModelChange } = props;
    const runIfEditModeIsCell = (callback)=>(...args)=>{
            if (props.editMode === (0, $a01f6e6f52a2f91e$export$bad6b7a934346f26).Cell) callback(...args);
        };
    const throwIfNotEditable = $lCzvA.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $lCzvA.useCallback((id, field, mode)=>{
        if (apiRef.current.getCellMode(id, field) !== mode) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $lCzvA.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (params.cellMode === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit) return;
        const newParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params, {
            reason: (0, $623366e440a86fa6$export$66744c3b0d0c6217).cellDoubleClick
        });
        apiRef.current.publishEvent('cellEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusOut = $lCzvA.useCallback((params, event)=>{
        if (params.cellMode === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).View) return;
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).View) return;
        const newParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params, {
            reason: (0, $623366e440a86fa6$export$73fccbaa325472ee).cellFocusOut
        });
        apiRef.current.publishEvent('cellEditStop', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $lCzvA.useCallback((params, event)=>{
        if (params.cellMode === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: to replace at one point. See https://github.com/mui/material-ui/pull/39713#discussion_r1381678957.
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = (0, $623366e440a86fa6$export$73fccbaa325472ee).escapeKeyDown;
            else if (event.key === 'Enter') reason = (0, $623366e440a86fa6$export$73fccbaa325472ee).enterKeyDown;
            else if (event.key === 'Tab') {
                reason = event.shiftKey ? (0, $623366e440a86fa6$export$73fccbaa325472ee).shiftTabKeyDown : (0, $623366e440a86fa6$export$73fccbaa325472ee).tabKeyDown;
                event.preventDefault(); // Prevent going to the next element in the tab sequence
            }
            if (reason) {
                const newParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params, {
                    reason: reason
                });
                apiRef.current.publishEvent('cellEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'cell'
            });
            if (!canStartEditing) return;
            if ((0, $23fd0e5066a0f9a3$export$b3f2c64190cf8c4)(event)) reason = (0, $623366e440a86fa6$export$66744c3b0d0c6217).printableKeyDown;
            else if ((0, $23fd0e5066a0f9a3$export$dc044e3b830c7edc)(event)) reason = (0, $623366e440a86fa6$export$66744c3b0d0c6217).pasteKeyDown;
            else if (event.key === 'Enter') reason = (0, $623366e440a86fa6$export$66744c3b0d0c6217).enterKeyDown;
            else if (event.key === 'Backspace' || event.key === 'Delete') reason = (0, $623366e440a86fa6$export$66744c3b0d0c6217).deleteKeyDown;
            if (reason) {
                const newParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params, {
                    reason: reason,
                    key: event.key
                });
                apiRef.current.publishEvent('cellEditStart', newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleCellEditStart = $lCzvA.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startCellEditModeParams = {
            id: id,
            field: field
        };
        if (reason === (0, $623366e440a86fa6$export$66744c3b0d0c6217).printableKeyDown || reason === (0, $623366e440a86fa6$export$66744c3b0d0c6217).deleteKeyDown || reason === (0, $623366e440a86fa6$export$66744c3b0d0c6217).pasteKeyDown) startCellEditModeParams.deleteValue = true;
        apiRef.current.startCellEditMode(startCellEditModeParams);
    }, [
        apiRef
    ]);
    const handleCellEditStop = $lCzvA.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        apiRef.current.runPendingEditCellValueMutation(id, field);
        let cellToFocusAfter;
        if (reason === (0, $623366e440a86fa6$export$73fccbaa325472ee).enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === (0, $623366e440a86fa6$export$73fccbaa325472ee).tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === (0, $623366e440a86fa6$export$73fccbaa325472ee).shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopCellEditMode({
            id: id,
            field: field,
            ignoreModifications: ignoreModifications,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    const runIfNoFieldErrors = (callback)=>async (...args)=>{
            if (callback) {
                const { id: id, field: field } = args[0];
                const editRowsState = apiRef.current.state.editRows;
                const hasFieldErrors = editRowsState[id][field]?.error;
                if (!hasFieldErrors) callback(...args);
            }
        };
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellDoubleClick', runIfEditModeIsCell(handleCellDoubleClick));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellFocusOut', runIfEditModeIsCell(handleCellFocusOut));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', runIfEditModeIsCell(handleCellKeyDown));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellEditStart', runIfEditModeIsCell(handleCellEditStart));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellEditStop', runIfEditModeIsCell(handleCellEditStop));
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'cellEditStart', props.onCellEditStart);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'cellEditStop', runIfNoFieldErrors(props.onCellEditStop));
    const getCellMode = $lCzvA.useCallback((id, field)=>{
        const editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        const isEditing = editingState[id] && editingState[id][field];
        return isEditing ? (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit : (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).View;
    }, [
        apiRef
    ]);
    const updateCellModesModel = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.cellModesModel;
        if (onCellModesModelChange && isNewModelDifferentFromProp) onCellModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.cellModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setCellModesModel(newModel);
        cellModesModelRef.current = newModel;
        apiRef.current.publishEvent('cellModesModelChange', newModel);
    });
    const updateFieldInCellModesModel = $lCzvA.useCallback((id, field, newProps)=>{
        // We use the ref because it always contain the up-to-date value, different from the state
        // that needs a rerender to reflect the new value
        const newModel = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, cellModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newModel[id], {
            [field]: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newProps)
        });
        else {
            const _newModel$id = newModel[id], otherFields = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_newModel$id, [
                field
            ].map((0, $bb90ae25267601e8$export$2e2bcd8739ae039))); // Ensure that we have a new object, not a reference
            newModel[id] = otherFields;
            if (Object.keys(newModel[id]).length === 0) delete newModel[id];
        }
        updateCellModesModel(newModel);
    }, [
        updateCellModesModel
    ]);
    const updateOrDeleteFieldState = $lCzvA.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newEditingState[id], {
                [field]: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startCellEditMode = $lCzvA.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(params, $195b683637b129da$var$_excluded);
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).View);
        updateFieldInCellModesModel(id, field, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            mode: (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit
        }, other));
    }, [
        throwIfNotEditable,
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStartCellEditMode = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(async (params)=>{
        const { id: id, field: field, deleteValue: deleteValue, initialValue: initialValue } = params;
        const value = apiRef.current.getCellValue(id, field);
        let newValue = value;
        if (deleteValue) newValue = (0, $bb15dfa6a6852322$export$311bd602ebd44399)(apiRef.current.getColumn(field));
        else if (initialValue) newValue = initialValue;
        const column = apiRef.current.getColumn(field);
        const shouldProcessEditCellProps = !!column.preProcessEditCellProps && deleteValue;
        let newProps = {
            value: newValue,
            error: false,
            isProcessingProps: shouldProcessEditCellProps
        };
        updateOrDeleteFieldState(id, field, newProps);
        apiRef.current.setCellFocus(id, field);
        if (shouldProcessEditCellProps) {
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: apiRef.current.getRow(id),
                props: newProps,
                hasChanged: newValue !== value
            }));
            // Check if still in edit mode before updating
            if (apiRef.current.getCellMode(id, field) === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit) {
                const editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
                updateOrDeleteFieldState(id, field, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newProps, {
                    value: editingState[id][field].value,
                    isProcessingProps: false
                }));
            }
        }
    });
    const stopCellEditMode = $lCzvA.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(params, $195b683637b129da$var$_excluded2);
        throwIfNotInMode(id, field, (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit);
        updateFieldInCellModesModel(id, field, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            mode: (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).View
        }, other));
    }, [
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStopCellEditMode = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(async (params)=>{
        const { id: id, field: field, ignoreModifications: ignoreModifications, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        throwIfNotInMode(id, field, (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit);
        apiRef.current.runPendingEditCellValueMutation(id, field);
        const finishCellEditMode = ()=>{
            updateOrDeleteFieldState(id, field, null);
            updateFieldInCellModesModel(id, field, null);
            if (cellToFocusAfter !== 'none') apiRef.current.moveFocusToRelativeCell(id, field, cellToFocusAfter);
        };
        if (ignoreModifications) {
            finishCellEditMode();
            return;
        }
        const editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        const { error: error, isProcessingProps: isProcessingProps } = editingState[id][field];
        if (error || isProcessingProps) {
            // Attempt to change cell mode to "view" was not successful
            // Update previous mode to allow another attempt
            prevCellModesModel.current[id][field].mode = (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit;
            // Revert the mode in the cellModesModel prop back to "edit"
            updateFieldInCellModesModel(id, field, {
                mode: (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevCellModesModel.current[id][field].mode = (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit;
                // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
            };
            try {
                const row = apiRef.current.getRow(id);
                Promise.resolve(processRowUpdate(rowUpdate, row, {
                    rowId: id
                })).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishCellEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishCellEditMode();
        }
    });
    const setCellEditingEditCellValue = $lCzvA.useCallback(async (params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        let newProps = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (column.preProcessEditCellProps) {
            const hasChanged = value !== editingState[id][field].value;
            newProps = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newProps, {
                isProcessingProps: true
            });
            updateOrDeleteFieldState(id, field, newProps);
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps,
                hasChanged: hasChanged
            }));
        }
        // Check again if the cell is in edit mode because the user may have
        // discarded the changes while the props were being processed.
        if (apiRef.current.getCellMode(id, field) === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).View) return false;
        editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        newProps = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newProps, {
            isProcessingProps: false
        });
        // We don't update the value with the one coming from the props pre-processing
        // because when the promise resolves it may be already outdated. The only
        // exception to this rule is when there's no pre-processing.
        newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
        updateOrDeleteFieldState(id, field, newProps);
        editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        return !editingState[id]?.[field]?.error;
    }, [
        apiRef,
        throwIfNotEditable,
        throwIfNotInMode,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromCellEditing = $lCzvA.useCallback((id, field)=>{
        const column = apiRef.current.getColumn(field);
        const editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id] || !editingState[id][field]) return apiRef.current.getRow(id);
        const { value: value } = editingState[id][field];
        return column.valueSetter ? column.valueSetter(value, row, column, apiRef) : (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, row, {
            [field]: value
        });
    }, [
        apiRef
    ]);
    const editingApi = {
        getCellMode: getCellMode,
        startCellEditMode: startCellEditMode,
        stopCellEditMode: stopCellEditMode
    };
    const editingPrivateApi = {
        setCellEditingEditCellValue: setCellEditingEditCellValue,
        getRowWithUpdatedValuesFromCellEditing: getRowWithUpdatedValuesFromCellEditing
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, editingApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, editingPrivateApi, 'private');
    $lCzvA.useEffect(()=>{
        if (cellModesModelProp) updateCellModesModel(cellModesModelProp);
    }, [
        cellModesModelProp,
        updateCellModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        const rowsLookup = (0, $68327dddce1a2c68$export$37767f9110c99048)(apiRef);
        // Update the ref here because updateStateToStopCellEditMode may change it later
        const copyOfPrevCellModes = prevCellModesModel.current;
        prevCellModesModel.current = (0, $ac3bd7253ec0e92a$export$b7d58db314e0ac27)(cellModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(cellModesModel).forEach(([id, fields])=>{
            Object.entries(fields).forEach(([field, params])=>{
                const prevMode = copyOfPrevCellModes[id]?.[field]?.mode || (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).View;
                const originalId = rowsLookup[id] ? apiRef.current.getRowId(rowsLookup[id]) : id;
                if (params.mode === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit && prevMode === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).View) updateStateToStartCellEditMode((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                    id: originalId,
                    field: field
                }, params));
                else if (params.mode === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).View && prevMode === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit) updateStateToStopCellEditMode((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                    id: originalId,
                    field: field
                }, params));
            });
        });
    }, [
        apiRef,
        cellModesModel,
        updateStateToStartCellEditMode,
        updateStateToStopCellEditMode
    ]);
};







var $lCzvA = parcelRequire("lCzvA");










/**
 * Object passed as parameter in the row callbacks.
 * @demos
 *   - [Master detail](/x/react-data-grid/master-detail/)
 */ /**
 * Object passed as parameter in the row `getRowClassName` callback prop.
 * @demos
 *   - [Styling rows](/x/react-data-grid/style/#styling-rows)
 */ /**
 * Object passed as parameter in the row `getRowHeight` callback prop.
 */ /**
 * The getRowHeight return value.
 */ var $180ecf9a0a3f1009$export$535533732d8f5c0a = /*#__PURE__*/ function(GridRowEditStartReasons) {
    GridRowEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridRowEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridRowEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    return GridRowEditStartReasons;
}($180ecf9a0a3f1009$export$535533732d8f5c0a || {});
/**
 * Params passed to the `rowEditStart` event.
 */ var $180ecf9a0a3f1009$export$723957c53726785f = /*#__PURE__*/ function(GridRowEditStopReasons) {
    GridRowEditStopReasons["rowFocusOut"] = "rowFocusOut";
    GridRowEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridRowEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridRowEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridRowEditStopReasons;
}($180ecf9a0a3f1009$export$723957c53726785f || {});




const $40c9af4565c6778b$var$_excluded = [
    "id"
], $40c9af4565c6778b$var$_excluded2 = [
    "id"
];
const $40c9af4565c6778b$export$a43bf4f64ed7f919 = (apiRef, props)=>{
    const [rowModesModel, setRowModesModel] = $lCzvA.useState({});
    const rowModesModelRef = $lCzvA.useRef(rowModesModel);
    const prevRowModesModel = $lCzvA.useRef({});
    const prevRowValuesLookup = $lCzvA.useRef({});
    const focusTimeout = $lCzvA.useRef(undefined);
    const nextFocusedCell = $lCzvA.useRef(null);
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, rowModesModel: rowModesModelProp, onRowModesModelChange: onRowModesModelChange } = props;
    const runIfEditModeIsRow = (callback)=>(...args)=>{
            if (props.editMode === (0, $a01f6e6f52a2f91e$export$bad6b7a934346f26).Row) callback(...args);
        };
    const throwIfNotEditable = $lCzvA.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $lCzvA.useCallback((id, mode)=>{
        if (apiRef.current.getRowMode(id) !== mode) throw new Error(`MUI X: The row with id=${id} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const hasFieldsWithErrors = $lCzvA.useCallback((rowId)=>{
        const editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        return Object.values(editingState[rowId]).some((fieldProps)=>fieldProps.error);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $lCzvA.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit) return;
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rowParams, {
            field: params.field,
            reason: (0, $180ecf9a0a3f1009$export$535533732d8f5c0a).cellDoubleClick
        });
        apiRef.current.publishEvent('rowEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusIn = $lCzvA.useCallback((params)=>{
        nextFocusedCell.current = params;
    }, []);
    const handleCellFocusOut = $lCzvA.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).View) return;
        // The mechanism to detect if we can stop editing a row is different from
        // the cell editing. Instead of triggering it when clicking outside a cell,
        // we must check if another cell in the same row was not clicked. To achieve
        // that, first we keep track of all cells that gained focus. When a cell loses
        // focus we check if the next cell that received focus is from a different row.
        nextFocusedCell.current = null;
        focusTimeout.current = setTimeout(()=>{
            if (nextFocusedCell.current?.id !== params.id) {
                // The row might have been deleted during the click
                if (!apiRef.current.getRow(params.id)) return;
                // The row may already changed its mode
                if (apiRef.current.getRowMode(params.id) === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).View) return;
                if (hasFieldsWithErrors(params.id)) return;
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rowParams, {
                    field: params.field,
                    reason: (0, $180ecf9a0a3f1009$export$723957c53726785f).rowFocusOut
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        });
    }, [
        apiRef,
        hasFieldsWithErrors
    ]);
    $lCzvA.useEffect(()=>{
        return ()=>{
            clearTimeout(focusTimeout.current);
        };
    }, []);
    const handleCellKeyDown = $lCzvA.useCallback((params, event)=>{
        if (params.cellMode === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: to replace at one point. See https://github.com/mui/material-ui/pull/39713#discussion_r1381678957.
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = (0, $180ecf9a0a3f1009$export$723957c53726785f).escapeKeyDown;
            else if (event.key === 'Enter') reason = (0, $180ecf9a0a3f1009$export$723957c53726785f).enterKeyDown;
            else if (event.key === 'Tab') {
                const columnFields = (0, $8b99503000dd62d3$export$c9491722e1d6e8d3)(apiRef).filter((field)=>{
                    const column = apiRef.current.getColumn(field);
                    if (column.type === (0, $8af4a53e0f3e9113$export$e2523ab9efeb7465)) return true;
                    return apiRef.current.isCellEditable(apiRef.current.getCellParams(params.id, field));
                });
                if (event.shiftKey) {
                    if (params.field === columnFields[0]) // Exit if user pressed Shift+Tab on the first field
                    reason = (0, $180ecf9a0a3f1009$export$723957c53726785f).shiftTabKeyDown;
                } else if (params.field === columnFields[columnFields.length - 1]) // Exit if user pressed Tab on the last field
                reason = (0, $180ecf9a0a3f1009$export$723957c53726785f).tabKeyDown;
                // Always prevent going to the next element in the tab sequence because the focus is
                // handled manually to support edit components rendered inside Portals
                event.preventDefault();
                if (!reason) {
                    const index = columnFields.findIndex((field)=>field === params.field);
                    const nextFieldToFocus = columnFields[event.shiftKey ? index - 1 : index + 1];
                    apiRef.current.setCellFocus(params.id, nextFieldToFocus);
                }
            }
            if (reason) {
                if (reason !== (0, $180ecf9a0a3f1009$export$723957c53726785f).escapeKeyDown && hasFieldsWithErrors(params.id)) return;
                const newParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, apiRef.current.getRowParams(params.id), {
                    reason: reason,
                    field: params.field
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'row'
            });
            if (!canStartEditing) return;
            if ((0, $23fd0e5066a0f9a3$export$b3f2c64190cf8c4)(event)) reason = (0, $180ecf9a0a3f1009$export$535533732d8f5c0a).printableKeyDown;
            else if ((0, $23fd0e5066a0f9a3$export$dc044e3b830c7edc)(event)) reason = (0, $180ecf9a0a3f1009$export$535533732d8f5c0a).printableKeyDown;
            else if (event.key === 'Enter') reason = (0, $180ecf9a0a3f1009$export$535533732d8f5c0a).enterKeyDown;
            else if (event.key === 'Backspace' || event.key === 'Delete') reason = (0, $180ecf9a0a3f1009$export$535533732d8f5c0a).deleteKeyDown;
            if (reason) {
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rowParams, {
                    field: params.field,
                    reason: reason
                });
                apiRef.current.publishEvent('rowEditStart', newParams, event);
            }
        }
    }, [
        apiRef,
        hasFieldsWithErrors
    ]);
    const handleRowEditStart = $lCzvA.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startRowEditModeParams = {
            id: id,
            fieldToFocus: field
        };
        if (reason === (0, $180ecf9a0a3f1009$export$535533732d8f5c0a).printableKeyDown || reason === (0, $180ecf9a0a3f1009$export$535533732d8f5c0a).deleteKeyDown) startRowEditModeParams.deleteValue = !!field;
        apiRef.current.startRowEditMode(startRowEditModeParams);
    }, [
        apiRef
    ]);
    const handleRowEditStop = $lCzvA.useCallback((params)=>{
        const { id: id, reason: reason, field: field } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        let cellToFocusAfter;
        if (reason === (0, $180ecf9a0a3f1009$export$723957c53726785f).enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === (0, $180ecf9a0a3f1009$export$723957c53726785f).tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === (0, $180ecf9a0a3f1009$export$723957c53726785f).shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopRowEditMode({
            id: id,
            ignoreModifications: ignoreModifications,
            field: field,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellDoubleClick', runIfEditModeIsRow(handleCellDoubleClick));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellFocusIn', runIfEditModeIsRow(handleCellFocusIn));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellFocusOut', runIfEditModeIsRow(handleCellFocusOut));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', runIfEditModeIsRow(handleCellKeyDown));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowEditStart', runIfEditModeIsRow(handleRowEditStart));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowEditStop', runIfEditModeIsRow(handleRowEditStop));
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'rowEditStart', props.onRowEditStart);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'rowEditStop', props.onRowEditStop);
    const getRowMode = $lCzvA.useCallback((id)=>{
        const isEditing = (0, $5396c90484690c1e$export$3ca6aabd7600f0b3)(apiRef, {
            rowId: id,
            editMode: props.editMode
        });
        return isEditing ? (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit : (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).View;
    }, [
        apiRef,
        props.editMode
    ]);
    const updateRowModesModel = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.rowModesModel;
        if (onRowModesModelChange && isNewModelDifferentFromProp) onRowModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.rowModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setRowModesModel(newModel);
        rowModesModelRef.current = newModel;
        apiRef.current.publishEvent('rowModesModelChange', newModel);
    });
    const updateRowInRowModesModel = $lCzvA.useCallback((id, newProps)=>{
        const newModel = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rowModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newProps);
        else delete newModel[id];
        updateRowModesModel(newModel);
    }, [
        updateRowModesModel
    ]);
    const updateOrDeleteRowState = $lCzvA.useCallback((id, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = newProps;
            else delete newEditingState[id];
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const updateOrDeleteFieldState = $lCzvA.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newEditingState[id], {
                [field]: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startRowEditMode = $lCzvA.useCallback((params)=>{
        const { id: id } = params, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(params, $40c9af4565c6778b$var$_excluded);
        throwIfNotInMode(id, (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).View);
        updateRowInRowModesModel(id, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            mode: (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStartRowEditMode = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((params)=>{
        const { id: id, fieldToFocus: fieldToFocus, deleteValue: deleteValue, initialValue: initialValue } = params;
        const row = apiRef.current.getRow(id);
        const columns = (0, $8b99503000dd62d3$export$da85f06e3c19f1fd)(apiRef);
        const newProps = columns.reduce((acc, col)=>{
            const field = col.field;
            const cellParams = apiRef.current.getCellParams(id, field);
            if (!cellParams.isEditable) return acc;
            const column = apiRef.current.getColumn(field);
            let newValue = apiRef.current.getCellValue(id, field);
            if (fieldToFocus === field && (deleteValue || initialValue)) {
                if (deleteValue) newValue = (0, $bb15dfa6a6852322$export$311bd602ebd44399)(column);
                else if (initialValue) newValue = initialValue;
            }
            acc[field] = {
                value: newValue,
                error: false,
                isProcessingProps: column.editable && !!column.preProcessEditCellProps && deleteValue
            };
            return acc;
        }, {});
        prevRowValuesLookup.current[id] = row;
        updateOrDeleteRowState(id, newProps);
        if (fieldToFocus) apiRef.current.setCellFocus(id, fieldToFocus);
        columns.filter((column)=>{
            const isCellEditable = apiRef.current.getCellParams(id, column.field).isEditable;
            return isCellEditable && column.editable && !!column.preProcessEditCellProps && deleteValue;
        }).forEach((column)=>{
            const field = column.field;
            const value = apiRef.current.getCellValue(id, field);
            const newValue = deleteValue ? (0, $bb15dfa6a6852322$export$311bd602ebd44399)(column) : initialValue ?? value;
            Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps[field],
                hasChanged: newValue !== value
            })).then((processedProps)=>{
                // Check if still in edit mode before updating
                if (apiRef.current.getRowMode(id) === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit) {
                    const editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
                    updateOrDeleteFieldState(id, field, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, processedProps, {
                        value: editingState[id][field].value,
                        isProcessingProps: false
                    }));
                }
            });
        });
    });
    const stopRowEditMode = $lCzvA.useCallback((params)=>{
        const { id: id } = params, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(params, $40c9af4565c6778b$var$_excluded2);
        throwIfNotInMode(id, (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit);
        updateRowInRowModesModel(id, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            mode: (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).View
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStopRowEditMode = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((params)=>{
        const { id: id, ignoreModifications: ignoreModifications, field: focusedField, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        const finishRowEditMode = ()=>{
            if (cellToFocusAfter !== 'none' && focusedField) apiRef.current.moveFocusToRelativeCell(id, focusedField, cellToFocusAfter);
            updateOrDeleteRowState(id, null);
            updateRowInRowModesModel(id, null);
            delete prevRowValuesLookup.current[id];
        };
        if (ignoreModifications) {
            finishRowEditMode();
            return;
        }
        const editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        const row = prevRowValuesLookup.current[id];
        const isSomeFieldProcessingProps = Object.values(editingState[id]).some((fieldProps)=>fieldProps.isProcessingProps);
        if (isSomeFieldProcessingProps) {
            prevRowModesModel.current[id].mode = (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit;
            return;
        }
        if (hasFieldsWithErrors(id)) {
            prevRowModesModel.current[id].mode = (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit;
            // Revert the mode in the rowModesModel prop back to "edit"
            updateRowInRowModesModel(id, {
                mode: (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                // The row might have been deleted
                if (prevRowModesModel.current[id]) {
                    prevRowModesModel.current[id].mode = (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit;
                    // Revert the mode in the rowModesModel prop back to "edit"
                    updateRowInRowModesModel(id, {
                        mode: (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit
                    });
                }
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row, {
                    rowId: id
                })).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishRowEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishRowEditMode();
        }
    });
    const setRowEditingEditCellValue = $lCzvA.useCallback((params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        let newProps = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (!column.preProcessEditCellProps) updateOrDeleteFieldState(id, field, newProps);
        return new Promise((resolve)=>{
            const promises = [];
            if (column.preProcessEditCellProps) {
                const hasChanged = newProps.value !== editingState[id][field].value;
                newProps = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, field, newProps);
                const _editingState$id = editingState[id], otherFieldsProps = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_editingState$id, [
                    field
                ].map((0, $bb90ae25267601e8$export$2e2bcd8739ae039)));
                const promise = Promise.resolve(column.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: newProps,
                    hasChanged: hasChanged,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).View) {
                        resolve(false);
                        return;
                    }
                    editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
                    processedProps = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, processedProps, {
                        isProcessingProps: false
                    });
                    // We don't reuse the value from the props pre-processing because when the
                    // promise resolves it may be already outdated. The only exception to this rule
                    // is when there's no pre-processing.
                    processedProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
                    updateOrDeleteFieldState(id, field, processedProps);
                });
                promises.push(promise);
            }
            Object.entries(editingState[id]).forEach(([thisField, fieldProps])=>{
                if (thisField === field) return;
                const fieldColumn = apiRef.current.getColumn(thisField);
                if (!fieldColumn.preProcessEditCellProps) return;
                fieldProps = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, fieldProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, thisField, fieldProps);
                editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
                const _editingState$id2 = editingState[id], otherFieldsProps = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_editingState$id2, [
                    thisField
                ].map((0, $bb90ae25267601e8$export$2e2bcd8739ae039)));
                const promise = Promise.resolve(fieldColumn.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: fieldProps,
                    hasChanged: false,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).View) {
                        resolve(false);
                        return;
                    }
                    processedProps = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, processedProps, {
                        isProcessingProps: false
                    });
                    updateOrDeleteFieldState(id, thisField, processedProps);
                });
                promises.push(promise);
            });
            Promise.all(promises).then(()=>{
                if (apiRef.current.getRowMode(id) === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit) {
                    editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
                    resolve(!editingState[id][field].error);
                } else resolve(false);
            });
        });
    }, [
        apiRef,
        throwIfNotEditable,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromRowEditing = $lCzvA.useCallback((id)=>{
        const editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id]) return apiRef.current.getRow(id);
        let rowUpdate = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevRowValuesLookup.current[id], row);
        Object.entries(editingState[id]).forEach(([field, fieldProps])=>{
            const column = apiRef.current.getColumn(field);
            // Column might have been removed
            // see https://github.com/mui/mui-x/pull/16888
            if (column?.valueSetter) rowUpdate = column.valueSetter(fieldProps.value, rowUpdate, column, apiRef);
            else rowUpdate[field] = fieldProps.value;
        });
        return rowUpdate;
    }, [
        apiRef
    ]);
    const editingApi = {
        getRowMode: getRowMode,
        startRowEditMode: startRowEditMode,
        stopRowEditMode: stopRowEditMode
    };
    const editingPrivateApi = {
        setRowEditingEditCellValue: setRowEditingEditCellValue,
        getRowWithUpdatedValuesFromRowEditing: getRowWithUpdatedValuesFromRowEditing
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, editingApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, editingPrivateApi, 'private');
    $lCzvA.useEffect(()=>{
        if (rowModesModelProp) updateRowModesModel(rowModesModelProp);
    }, [
        rowModesModelProp,
        updateRowModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        const rowsLookup = (0, $68327dddce1a2c68$export$37767f9110c99048)(apiRef);
        // Update the ref here because updateStateToStopRowEditMode may change it later
        const copyOfPrevRowModesModel = prevRowModesModel.current;
        prevRowModesModel.current = (0, $ac3bd7253ec0e92a$export$b7d58db314e0ac27)(rowModesModel); // Do a deep-clone because the attributes might be changed later
        const ids = new Set([
            ...Object.keys(rowModesModel),
            ...Object.keys(copyOfPrevRowModesModel)
        ]);
        Array.from(ids).forEach((id)=>{
            const params = rowModesModel[id] ?? {
                mode: (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).View
            };
            const prevMode = copyOfPrevRowModesModel[id]?.mode || (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).View;
            const originalId = rowsLookup[id] ? apiRef.current.getRowId(rowsLookup[id]) : id;
            if (params.mode === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit && prevMode === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).View) updateStateToStartRowEditMode((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                id: originalId
            }, params));
            else if (params.mode === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).View && prevMode === (0, $a01f6e6f52a2f91e$export$d98c76b959bb0b5c).Edit) updateStateToStopRowEditMode((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                id: originalId
            }, params));
        });
    }, [
        apiRef,
        rowModesModel,
        updateStateToStartRowEditMode,
        updateStateToStopRowEditMode
    ]);
};




const $953627351a4701cd$export$1094a2c822d71ffd = (state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        editRows: {}
    });
const $953627351a4701cd$export$3a0db16b152b4c54 = (apiRef, props)=>{
    (0, $195b683637b129da$export$2c9a271ac5d3f446)(apiRef, props);
    (0, $40c9af4565c6778b$export$a43bf4f64ed7f919)(apiRef, props);
    const debounceMap = $lCzvA.useRef({});
    const { isCellEditable: isCellEditableProp } = props;
    const isCellEditable = $lCzvA.useCallback((params)=>{
        if ((0, $dc4fe3453cdb0a0a$export$5f983e16b1e55860)(params.rowNode)) return false;
        if (!params.colDef.editable) return false;
        if (!params.colDef.renderEditCell) return false;
        if (isCellEditableProp) return isCellEditableProp(params);
        return true;
    }, [
        isCellEditableProp
    ]);
    const maybeDebounce = (id, field, debounceMs, callback)=>{
        if (!debounceMs) {
            callback();
            return;
        }
        if (!debounceMap.current[id]) debounceMap.current[id] = {};
        if (debounceMap.current[id][field]) {
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
        }
        // To run the callback immediately without waiting the timeout
        const runImmediately = ()=>{
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
            callback();
            delete debounceMap.current[id][field];
        };
        const timeout = setTimeout(()=>{
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout,
            runImmediately
        ];
    };
    $lCzvA.useEffect(()=>{
        const debounces = debounceMap.current;
        return ()=>{
            Object.entries(debounces).forEach(([id, fields])=>{
                Object.keys(fields).forEach((field)=>{
                    const [timeout] = debounces[id][field];
                    clearTimeout(timeout);
                    delete debounces[id][field];
                });
            });
        };
    }, []);
    const runPendingEditCellValueMutation = $lCzvA.useCallback((id, field)=>{
        if (!debounceMap.current[id]) return;
        if (!field) Object.keys(debounceMap.current[id]).forEach((debouncedField)=>{
            const [, runCallback] = debounceMap.current[id][debouncedField];
            runCallback();
        });
        else if (debounceMap.current[id][field]) {
            const [, runCallback] = debounceMap.current[id][field];
            runCallback();
        }
    }, []);
    const setEditCellValue = $lCzvA.useCallback((params)=>{
        const { id: id, field: field, debounceMs: debounceMs } = params;
        return new Promise((resolve)=>{
            maybeDebounce(id, field, debounceMs, async ()=>{
                const setEditCellValueToCall = props.editMode === (0, $a01f6e6f52a2f91e$export$bad6b7a934346f26).Row ? apiRef.current.setRowEditingEditCellValue : apiRef.current.setCellEditingEditCellValue;
                // Check if the cell is in edit mode
                // By the time this callback runs the user may have cancelled the editing
                if (apiRef.current.getCellMode(id, field) === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit) {
                    const result = await setEditCellValueToCall(params);
                    resolve(result);
                }
            });
        });
    }, [
        apiRef,
        props.editMode
    ]);
    const getRowWithUpdatedValues = $lCzvA.useCallback((id, field)=>{
        return props.editMode === (0, $a01f6e6f52a2f91e$export$bad6b7a934346f26).Cell ? apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
    }, [
        apiRef,
        props.editMode
    ]);
    const getEditCellMeta = $lCzvA.useCallback((id, field)=>{
        const editingState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        return editingState[id]?.[field] ?? null;
    }, [
        apiRef
    ]);
    const editingSharedApi = {
        isCellEditable: isCellEditable,
        setEditCellValue: setEditCellValue,
        getRowWithUpdatedValues: getRowWithUpdatedValues,
        unstable_getEditCellMeta: getEditCellMeta
    };
    const editingSharedPrivateApi = {
        runPendingEditCellValueMutation: runPendingEditCellValueMutation
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, editingSharedApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, editingSharedPrivateApi, 'private');
};



var $lCzvA = parcelRequire("lCzvA");
















var $lCzvA = parcelRequire("lCzvA");

const $8de9ab907b1743d2$export$84214fbf04c4094 = 'none';
const $8de9ab907b1743d2$export$8c4aa1977ad5d106 = {
    rowTreeCreation: 'rowTree',
    filtering: 'rowTree',
    sorting: 'rowTree',
    visibleRowsLookupCreation: 'rowTree'
};
const $8de9ab907b1743d2$export$594711f8e5fa9b04 = (apiRef)=>{
    const availableStrategies = $lCzvA.useRef(new Map());
    const strategiesCache = $lCzvA.useRef({});
    const registerStrategyProcessor = $lCzvA.useCallback((strategyName, processorName, processor)=>{
        const cleanup = ()=>{
            const _ref = strategiesCache.current[processorName], otherProcessors = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_ref, [
                strategyName
            ].map((0, $bb90ae25267601e8$export$2e2bcd8739ae039)));
            strategiesCache.current[processorName] = otherProcessors;
        };
        if (!strategiesCache.current[processorName]) strategiesCache.current[processorName] = {};
        const groupPreProcessors = strategiesCache.current[processorName];
        const previousProcessor = groupPreProcessors[strategyName];
        groupPreProcessors[strategyName] = processor;
        if (!previousProcessor || previousProcessor === processor) return cleanup;
        if (strategyName === apiRef.current.getActiveStrategy($8de9ab907b1743d2$export$8c4aa1977ad5d106[processorName])) apiRef.current.publishEvent('activeStrategyProcessorChange', processorName);
        return cleanup;
    }, [
        apiRef
    ]);
    const applyStrategyProcessor = $lCzvA.useCallback((processorName, params)=>{
        const activeStrategy = apiRef.current.getActiveStrategy($8de9ab907b1743d2$export$8c4aa1977ad5d106[processorName]);
        if (activeStrategy == null) throw new Error("Can't apply a strategy processor before defining an active strategy");
        const groupCache = strategiesCache.current[processorName];
        if (!groupCache || !groupCache[activeStrategy]) throw new Error(`No processor found for processor "${processorName}" on strategy "${activeStrategy}"`);
        const processor = groupCache[activeStrategy];
        return processor(params);
    }, [
        apiRef
    ]);
    const getActiveStrategy = $lCzvA.useCallback((strategyGroup)=>{
        const strategyEntries = Array.from(availableStrategies.current.entries());
        const availableStrategyEntry = strategyEntries.find(([, strategy])=>{
            if (strategy.group !== strategyGroup) return false;
            return strategy.isAvailable();
        });
        return availableStrategyEntry?.[0] ?? $8de9ab907b1743d2$export$84214fbf04c4094;
    }, []);
    const setStrategyAvailability = $lCzvA.useCallback((strategyGroup, strategyName, isAvailable)=>{
        availableStrategies.current.set(strategyName, {
            group: strategyGroup,
            isAvailable: isAvailable
        });
        apiRef.current.publishEvent('strategyAvailabilityChange');
    }, [
        apiRef
    ]);
    const strategyProcessingApi = {
        registerStrategyProcessor: registerStrategyProcessor,
        applyStrategyProcessor: applyStrategyProcessor,
        getActiveStrategy: getActiveStrategy,
        setStrategyAvailability: setStrategyAvailability
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, strategyProcessingApi, 'private');
};


var $lCzvA = parcelRequire("lCzvA");

const $32c4bba1d412ab01$export$102a3f5a042c47c4 = (apiRef, strategyName, group, processor)=>{
    const registerPreProcessor = $lCzvA.useCallback(()=>{
        apiRef.current.registerStrategyProcessor(strategyName, group, processor);
    }, [
        apiRef,
        processor,
        group,
        strategyName
    ]);
    (0, $9ebf8f53803465ea$export$c5623aa1c38918b6)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
    }, [
        registerPreProcessor
    ]);
};





const $cf681cc58557b459$export$a3e5a984fe72a5db = (state, props, apiRef)=>{
    const filterModel = props.filterModel ?? props.initialState?.filter?.filterModel ?? (0, $88b02358d3d53b62$export$7ea23129b8e10cdb)();
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        filter: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            filterModel: (0, $bb45a78aee581510$export$2a370a0aad2ac7e1)(filterModel, props.disableMultipleColumnsFiltering, apiRef)
        }, (0, $88b02358d3d53b62$export$f5e27122a659c0c)),
        visibleRowsLookup: {}
    });
};
const $cf681cc58557b459$var$getVisibleRowsLookup = (params)=>{
    // For flat tree, the `visibleRowsLookup` and the `filteredRowsLookup` are equals since no row is collapsed.
    return params.filteredRowsLookup;
};
function $cf681cc58557b459$var$getVisibleRowsLookupState(apiRef, state) {
    return apiRef.current.applyStrategyProcessor('visibleRowsLookupCreation', {
        tree: state.rows.tree,
        filteredRowsLookup: state.filter.filteredRowsLookup
    });
}
function $cf681cc58557b459$var$createMemoizedValues() {
    return (0, $deae25339410ed5d$export$d8ead1d92249919b)(Object.values);
}
const $cf681cc58557b459$export$42838275cbf666c4 = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridFilter');
    apiRef.current.registerControlState({
        stateId: 'filter',
        propModel: props.filterModel,
        propOnChange: props.onFilterModelChange,
        stateSelector: (0, $6450fc0917754b27$export$280aedb9454597a5),
        changeEvent: 'filterModelChange'
    });
    const updateFilteredRows = $lCzvA.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const filterModel = (0, $6450fc0917754b27$export$280aedb9454597a5)(state, apiRef.current.instanceId);
            const filterState = apiRef.current.getFilterState(filterModel);
            const newState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                filter: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.filter, filterState)
            });
            const visibleRowsLookupState = $cf681cc58557b459$var$getVisibleRowsLookupState(apiRef, newState);
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, newState, {
                visibleRowsLookup: visibleRowsLookupState
            });
        });
        apiRef.current.publishEvent('filteredRowsSet');
    }, [
        apiRef
    ]);
    const addColumnMenuItem = $lCzvA.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.filterable === false || props.disableColumnFilter) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuFilterItem'
        ];
    }, [
        props.disableColumnFilter
    ]);
    /**
   * API METHODS
   */ const applyFilters = $lCzvA.useCallback(()=>{
        updateFilteredRows();
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        updateFilteredRows
    ]);
    const upsertFilterItem = $lCzvA.useCallback((item)=>{
        const filterModel = (0, $6450fc0917754b27$export$280aedb9454597a5)(apiRef);
        const items = [
            ...filterModel.items
        ];
        const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
        if (itemIndex === -1) items.push(item);
        else items[itemIndex] = item;
        apiRef.current.setFilterModel((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filterModel, {
            items: items
        }), 'upsertFilterItem');
    }, [
        apiRef
    ]);
    const upsertFilterItems = $lCzvA.useCallback((items)=>{
        const filterModel = (0, $6450fc0917754b27$export$280aedb9454597a5)(apiRef);
        const existingItems = [
            ...filterModel.items
        ];
        items.forEach((item)=>{
            const itemIndex = existingItems.findIndex((filterItem)=>filterItem.id === item.id);
            if (itemIndex === -1) existingItems.push(item);
            else existingItems[itemIndex] = item;
        });
        apiRef.current.setFilterModel((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filterModel, {
            items: existingItems
        }), 'upsertFilterItems');
    }, [
        apiRef
    ]);
    const deleteFilterItem = $lCzvA.useCallback((itemToDelete)=>{
        const filterModel = (0, $6450fc0917754b27$export$280aedb9454597a5)(apiRef);
        const items = filterModel.items.filter((item)=>item.id !== itemToDelete.id);
        if (items.length === filterModel.items.length) return;
        apiRef.current.setFilterModel((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filterModel, {
            items: items
        }), 'deleteFilterItem');
    }, [
        apiRef
    ]);
    const showFilterPanel = $lCzvA.useCallback((targetColumnField, panelId, labelId)=>{
        logger.debug('Displaying filter panel');
        if (targetColumnField) {
            const filterModel = (0, $6450fc0917754b27$export$280aedb9454597a5)(apiRef);
            const filterItemsWithValue = filterModel.items.filter((item)=>{
                if (item.value !== undefined) {
                    // Some filters like `isAnyOf` support array as `item.value`.
                    // If array is empty, we want to remove it from the filter model.
                    if (Array.isArray(item.value) && item.value.length === 0) return false;
                    return true;
                }
                const column = apiRef.current.getColumn(item.field);
                const filterOperator = column.filterOperators?.find((operator)=>operator.value === item.operator);
                const requiresFilterValue = typeof filterOperator?.requiresFilterValue === 'undefined' ? true : filterOperator?.requiresFilterValue;
                // Operators like `isEmpty` don't have and don't require `item.value`.
                // So we don't want to remove them from the filter model if `item.value === undefined`.
                // See https://github.com/mui/mui-x/issues/5402
                if (requiresFilterValue) return false;
                return true;
            });
            let newFilterItems;
            const filterItemOnTarget = filterItemsWithValue.find((item)=>item.field === targetColumnField);
            const targetColumn = apiRef.current.getColumn(targetColumnField);
            if (filterItemOnTarget) newFilterItems = filterItemsWithValue;
            else if (props.disableMultipleColumnsFiltering) newFilterItems = [
                (0, $bb45a78aee581510$export$eb76493d113de092)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            else newFilterItems = [
                ...filterItemsWithValue,
                (0, $bb45a78aee581510$export$eb76493d113de092)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            apiRef.current.setFilterModel((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filterModel, {
                items: newFilterItems
            }));
        }
        apiRef.current.showPreferences((0, $57afc8119b2eb3e6$export$e7e5652452e44b).filters, panelId, labelId);
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const hideFilterPanel = $lCzvA.useCallback(()=>{
        logger.debug('Hiding filter panel');
        apiRef.current.hidePreferences();
    }, [
        apiRef,
        logger
    ]);
    const setFilterLogicOperator = $lCzvA.useCallback((logicOperator)=>{
        const filterModel = (0, $6450fc0917754b27$export$280aedb9454597a5)(apiRef);
        if (filterModel.logicOperator === logicOperator) return;
        apiRef.current.setFilterModel((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filterModel, {
            logicOperator: logicOperator
        }), 'changeLogicOperator');
    }, [
        apiRef
    ]);
    const setQuickFilterValues = $lCzvA.useCallback((values)=>{
        const filterModel = (0, $6450fc0917754b27$export$280aedb9454597a5)(apiRef);
        if ((0, $ac3bd7253ec0e92a$export$78fdc9adc3f30400)(filterModel.quickFilterValues, values)) return;
        apiRef.current.setFilterModel((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filterModel, {
            quickFilterValues: [
                ...values
            ]
        }));
    }, [
        apiRef
    ]);
    const setFilterModel = $lCzvA.useCallback((model, reason)=>{
        const currentModel = (0, $6450fc0917754b27$export$280aedb9454597a5)(apiRef);
        if (currentModel !== model) {
            logger.debug('Setting filter model');
            apiRef.current.updateControlState('filter', (0, $bb45a78aee581510$export$f4189e6c713e6dd8)(model, props.disableMultipleColumnsFiltering, apiRef), reason);
            apiRef.current.unstable_applyFilters();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const getFilterState = $lCzvA.useCallback((inputFilterModel)=>{
        const filterModel = (0, $bb45a78aee581510$export$2a370a0aad2ac7e1)(inputFilterModel, props.disableMultipleColumnsFiltering, apiRef);
        const isRowMatchingFilters = props.filterMode === 'client' ? (0, $bb45a78aee581510$export$1c795c7c9654905e)(filterModel, apiRef, props.disableEval) : null;
        const filterResult = apiRef.current.applyStrategyProcessor('filtering', {
            isRowMatchingFilters: isRowMatchingFilters,
            filterModel: filterModel ?? (0, $88b02358d3d53b62$export$7ea23129b8e10cdb)()
        });
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filterResult, {
            filterModel: filterModel
        });
    }, [
        props.disableMultipleColumnsFiltering,
        props.filterMode,
        props.disableEval,
        apiRef
    ]);
    const filterApi = {
        setFilterLogicOperator: setFilterLogicOperator,
        unstable_applyFilters: applyFilters,
        deleteFilterItem: deleteFilterItem,
        upsertFilterItem: upsertFilterItem,
        upsertFilterItems: upsertFilterItems,
        setFilterModel: setFilterModel,
        showFilterPanel: showFilterPanel,
        hideFilterPanel: hideFilterPanel,
        setQuickFilterValues: setQuickFilterValues,
        ignoreDiacritics: props.ignoreDiacritics,
        getFilterState: getFilterState
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, filterApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $lCzvA.useCallback((prevState, context)=>{
        const filterModelToExport = (0, $6450fc0917754b27$export$280aedb9454597a5)(apiRef);
        // Remove the additional `fromInput` property from the filter model
        filterModelToExport.items.forEach((item)=>{
            delete item.fromInput;
        });
        const shouldExportFilterModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.filterModel != null || // Always export if the model has been initialized
        props.initialState?.filter?.filterModel != null || // Export if the model is not equal to the default value
        !(0, $ac3bd7253ec0e92a$export$78fdc9adc3f30400)(filterModelToExport, (0, $88b02358d3d53b62$export$7ea23129b8e10cdb)());
        if (!shouldExportFilterModel) return prevState;
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState, {
            filter: {
                filterModel: filterModelToExport
            }
        });
    }, [
        apiRef,
        props.filterModel,
        props.initialState?.filter?.filterModel
    ]);
    const stateRestorePreProcessing = $lCzvA.useCallback((params, context)=>{
        const filterModel = context.stateToRestore.filter?.filterModel;
        if (filterModel == null) return params;
        apiRef.current.updateControlState('filter', (0, $bb45a78aee581510$export$f4189e6c713e6dd8)(filterModel, props.disableMultipleColumnsFiltering, apiRef), 'restoreState');
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.unstable_applyFilters
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsFiltering
    ]);
    const preferencePanelPreProcessing = $lCzvA.useCallback((initialValue, value)=>{
        if (value === (0, $57afc8119b2eb3e6$export$e7e5652452e44b).filters) {
            const FilterPanel = props.slots.filterPanel;
            return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(FilterPanel, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props.slotProps?.filterPanel));
        }
        return initialValue;
    }, [
        props.slots.filterPanel,
        props.slotProps?.filterPanel
    ]);
    const { getRowId: getRowId } = props;
    const getRowsRef = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)($cf681cc58557b459$var$createMemoizedValues);
    const flatFilteringMethod = $lCzvA.useCallback((params)=>{
        if (props.filterMode !== 'client' || !params.isRowMatchingFilters || !params.filterModel.items.length && !params.filterModel.quickFilterValues?.length) return 0, $88b02358d3d53b62$export$f5e27122a659c0c;
        const dataRowIdToModelLookup = (0, $68327dddce1a2c68$export$37767f9110c99048)(apiRef);
        const filteredRowsLookup = {};
        const { isRowMatchingFilters: isRowMatchingFilters } = params;
        const filterCache = {};
        const result = {
            passingFilterItems: null,
            passingQuickFilterValues: null
        };
        const rows = getRowsRef.current(apiRef.current.state.rows.dataRowIdToModelLookup);
        for(let i = 0; i < rows.length; i += 1){
            const row = rows[i];
            const id = getRowId ? getRowId(row) : row.id;
            isRowMatchingFilters(row, undefined, result);
            const isRowPassing = (0, $bb45a78aee581510$export$8d82b4490466f182)([
                result.passingFilterItems
            ], [
                result.passingQuickFilterValues
            ], params.filterModel, apiRef, filterCache);
            filteredRowsLookup[id] = isRowPassing;
        }
        const footerId = 'auto-generated-group-footer-root';
        const footer = dataRowIdToModelLookup[footerId];
        if (footer) filteredRowsLookup[footerId] = true;
        return {
            filteredRowsLookup: filteredRowsLookup,
            filteredChildrenCountLookup: {},
            filteredDescendantCountLookup: {}
        };
    }, [
        apiRef,
        props.filterMode,
        getRowId,
        getRowsRef
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(apiRef, (0, $8de9ab907b1743d2$export$84214fbf04c4094), 'filtering', flatFilteringMethod);
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(apiRef, (0, $8de9ab907b1743d2$export$84214fbf04c4094), 'visibleRowsLookupCreation', $cf681cc58557b459$var$getVisibleRowsLookup);
    /**
   * EVENTS
   */ const handleColumnsChange = $lCzvA.useCallback(()=>{
        logger.debug('onColUpdated - GridColumns changed, applying filters');
        const filterModel = (0, $6450fc0917754b27$export$280aedb9454597a5)(apiRef);
        const columnsLookup = (0, $8b99503000dd62d3$export$8a3a9a6db584d7fd)(apiRef);
        const newFilterItems = filterModel.items.filter((item)=>item.field && columnsLookup[item.field]);
        if (newFilterItems.length < filterModel.items.length) apiRef.current.setFilterModel((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filterModel, {
            items: newFilterItems
        }));
    }, [
        apiRef,
        logger
    ]);
    const handleStrategyProcessorChange = $lCzvA.useCallback((methodName)=>{
        if (methodName === 'filtering') apiRef.current.unstable_applyFilters();
    }, [
        apiRef
    ]);
    const updateVisibleRowsLookupState = $lCzvA.useCallback(()=>{
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                visibleRowsLookup: $cf681cc58557b459$var$getVisibleRowsLookupState(apiRef, state)
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    // Do not call `apiRef.current.forceUpdate` to avoid re-render before updating the sorted rows.
    // Otherwise, the state is not consistent during the render
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowsSet', updateFilteredRows);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowExpansionChange', updateVisibleRowsLookupState);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnVisibilityModelChange', ()=>{
        const filterModel = (0, $6450fc0917754b27$export$280aedb9454597a5)(apiRef);
        if (filterModel.quickFilterValues && (0, $bb45a78aee581510$export$cabca178b367efe0)(filterModel)) // re-apply filters because the quick filter results may have changed
        apiRef.current.unstable_applyFilters();
    });
    /**
   * 1ST RENDER
   */ (0, $9ebf8f53803465ea$export$c5623aa1c38918b6)(()=>{
        apiRef.current.unstable_applyFilters();
    });
    /**
   * EFFECTS
   */ (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (props.filterModel !== undefined) apiRef.current.setFilterModel(props.filterModel);
    }, [
        apiRef,
        logger,
        props.filterModel
    ]);
};



var $lCzvA = parcelRequire("lCzvA");











const $73b6c50554d238e2$export$bfde38b067fac467 = (state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        focus: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        },
        tabIndex: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        }
    });
const $73b6c50554d238e2$export$8b69791fef06a777 = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridFocus');
    const lastClickedCell = $lCzvA.useRef(null);
    const hasRootReference = apiRef.current.rootElementRef.current !== null;
    const publishCellFocusOut = $lCzvA.useCallback((cell, event)=>{
        if (cell) // The row might have been deleted
        {
            if (apiRef.current.getRow(cell.id)) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        }
    }, [
        apiRef
    ]);
    const setCellFocus = $lCzvA.useCallback((id, field)=>{
        const focusedCell = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
        if (focusedCell?.id === id && focusedCell?.field === field) return;
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on cell with id=${id} and field=${field}`);
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                tabIndex: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                },
                focus: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
        // The row might have been deleted
        if (!apiRef.current.getRow(id)) return;
        if (focusedCell) // There's a focused cell but another cell was clicked
        // Publishes an event to notify that the focus was lost
        publishCellFocusOut(focusedCell, {});
        apiRef.current.publishEvent('cellFocusIn', apiRef.current.getCellParams(id, field));
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFocus = $lCzvA.useCallback((field, event = {})=>{
        const cell = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header with colIndex=${field}`);
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                tabIndex: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFilterFocus = $lCzvA.useCallback((field, event = {})=>{
        const cell = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header filter with colIndex=${field}`);
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                tabIndex: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnGroupHeaderFocus = $lCzvA.useCallback((field, depth, event = {})=>{
        const cell = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
        if (cell) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                tabIndex: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                },
                focus: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const getColumnGroupHeaderFocus = $lCzvA.useCallback(()=>(0, $c2be356cc77cce81$export$3eeedc3f7263df61)(apiRef), [
        apiRef
    ]);
    const moveFocusToRelativeCell = $lCzvA.useCallback((id, field, direction)=>{
        let columnIndexToFocus = apiRef.current.getColumnIndex(field);
        const visibleColumns = (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef);
        const currentPage = (0, $6b6f708ce7819830$export$79b9fa322a34430b)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const pinnedRows = (0, $68327dddce1a2c68$export$ffe7071c481e32b0)(apiRef);
        // Include pinned rows as well
        const currentPageRows = [].concat(pinnedRows.top || [], currentPage.rows, pinnedRows.bottom || []);
        let rowIndexToFocus = currentPageRows.findIndex((row)=>row.id === id);
        if (direction === 'right') columnIndexToFocus += 1;
        else if (direction === 'left') columnIndexToFocus -= 1;
        else rowIndexToFocus += 1;
        if (columnIndexToFocus >= visibleColumns.length) {
            // Go to next row if we are after the last column
            rowIndexToFocus += 1;
            if (rowIndexToFocus < currentPageRows.length) // Go to first column of the next row if there's one more row
            columnIndexToFocus = 0;
        } else if (columnIndexToFocus < 0) {
            // Go to previous row if we are before the first column
            rowIndexToFocus -= 1;
            if (rowIndexToFocus >= 0) // Go to last column of the previous if there's one more row
            columnIndexToFocus = visibleColumns.length - 1;
        }
        rowIndexToFocus = (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(rowIndexToFocus, 0, currentPageRows.length - 1);
        const rowToFocus = currentPageRows[rowIndexToFocus];
        if (!rowToFocus) return;
        const colSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowToFocus.id, columnIndexToFocus);
        if (colSpanInfo && colSpanInfo.spannedByColSpan) {
            if (direction === 'left' || direction === 'below') columnIndexToFocus = colSpanInfo.leftVisibleCellIndex;
            else if (direction === 'right') columnIndexToFocus = colSpanInfo.rightVisibleCellIndex;
        }
        columnIndexToFocus = (0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(columnIndexToFocus, 0, visibleColumns.length - 1);
        const columnToFocus = visibleColumns[columnIndexToFocus];
        apiRef.current.setCellFocus(rowToFocus.id, columnToFocus.field);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellDoubleClick = $lCzvA.useCallback(({ id: id, field: field })=>{
        apiRef.current.setCellFocus(id, field);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $lCzvA.useCallback((params, event)=>{
        // GRID_CELL_NAVIGATION_KEY_DOWN handles the focus on Enter, Tab and navigation keys
        if (event.key === 'Enter' || event.key === 'Tab' || event.key === 'Shift' || (0, $23fd0e5066a0f9a3$export$e13d96c38a470518)(event.key)) return;
        apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleColumnHeaderFocus = $lCzvA.useCallback(({ field: field }, event)=>{
        if (event.target !== event.currentTarget) return;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef
    ]);
    const handleColumnGroupHeaderFocus = $lCzvA.useCallback(({ fields: fields, depth: depth }, event)=>{
        if (event.target !== event.currentTarget) return;
        const focusedColumnGroup = (0, $c2be356cc77cce81$export$3eeedc3f7263df61)(apiRef);
        if (focusedColumnGroup !== null && focusedColumnGroup.depth === depth && fields.includes(focusedColumnGroup.field)) // This group cell has already been focused
        return;
        apiRef.current.setColumnGroupHeaderFocus(fields[0], depth, event);
    }, [
        apiRef
    ]);
    const handleBlur = $lCzvA.useCallback((_, event)=>{
        if (event.relatedTarget?.getAttribute('class')?.includes((0, $786c119d9add6b61$export$2100d54e36406477).columnHeader)) return;
        logger.debug(`Clearing focus`);
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        logger,
        apiRef
    ]);
    const handleCellMouseDown = $lCzvA.useCallback((params)=>{
        lastClickedCell.current = params;
    }, []);
    const handleDocumentClick = $lCzvA.useCallback((event)=>{
        const cellParams = lastClickedCell.current;
        lastClickedCell.current = null;
        const focusedCell = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        if (!focusedCell) {
            if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
            return;
        }
        if (cellParams?.id === focusedCell.id && cellParams?.field === focusedCell.field) return;
        const cellElement = apiRef.current.getCellElement(focusedCell.id, focusedCell.field);
        if (cellElement?.contains(event.target)) return;
        if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
        else {
            apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                    focus: {
                        cell: null,
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
            apiRef.current.forceUpdate();
            // There's a focused cell but another element (not a cell) was clicked
            // Publishes an event to notify that the focus was lost
            publishCellFocusOut(focusedCell, event);
        }
    }, [
        apiRef,
        publishCellFocusOut
    ]);
    const handleCellModeChange = $lCzvA.useCallback((params)=>{
        if (params.cellMode === 'view') return;
        const cell = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
        if (cell?.id !== params.id || cell?.field !== params.field) apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleRowSet = $lCzvA.useCallback(()=>{
        const cell = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
        // If the focused cell is in a row which does not exist anymore,
        // focus previous row or remove the focus
        if (cell && !apiRef.current.getRow(cell.id)) {
            const lastFocusedRowId = cell.id;
            let nextRowId = null;
            if (typeof lastFocusedRowId !== 'undefined') {
                const rowEl = apiRef.current.getRowElement(lastFocusedRowId);
                const lastFocusedRowIndex = rowEl?.dataset.rowindex ? Number(rowEl?.dataset.rowindex) : 0;
                const currentPage = (0, $6b6f708ce7819830$export$79b9fa322a34430b)(apiRef, {
                    pagination: props.pagination,
                    paginationMode: props.paginationMode
                });
                const nextRow = currentPage.rows[(0, $ac3bd7253ec0e92a$export$7d15b64cf5a3a4c4)(lastFocusedRowIndex, 0, currentPage.rows.length - 1)];
                nextRowId = nextRow?.id ?? null;
            }
            apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                    focus: {
                        cell: nextRowId === null ? null : {
                            id: nextRowId,
                            field: cell.field
                        },
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
        }
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handlePaginationModelChange = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(()=>{
        const currentFocusedCell = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
        if (!currentFocusedCell) return;
        const currentPage = (0, $6b6f708ce7819830$export$79b9fa322a34430b)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const rowIsInCurrentPage = currentPage.rows.find((row)=>row.id === currentFocusedCell.id);
        if (rowIsInCurrentPage) return;
        const visibleColumns = (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef);
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                tabIndex: {
                    cell: {
                        id: currentPage.rows[0].id,
                        field: visibleColumns[0].field
                    },
                    columnGroupHeader: null,
                    columnHeader: null,
                    columnHeaderFilter: null
                }
            });
        });
    });
    const focusApi = {
        setCellFocus: setCellFocus,
        setColumnHeaderFocus: setColumnHeaderFocus,
        setColumnHeaderFilterFocus: setColumnHeaderFilterFocus
    };
    const focusPrivateApi = {
        moveFocusToRelativeCell: moveFocusToRelativeCell,
        setColumnGroupHeaderFocus: setColumnGroupHeaderFocus,
        getColumnGroupHeaderFocus: getColumnGroupHeaderFocus
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, focusApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, focusPrivateApi, 'private');
    $lCzvA.useEffect(()=>{
        const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.addEventListener('mouseup', handleDocumentClick);
        return ()=>{
            doc.removeEventListener('mouseup', handleDocumentClick);
        };
    }, [
        apiRef,
        hasRootReference,
        handleDocumentClick
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderBlur', handleBlur);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellDoubleClick', handleCellDoubleClick);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellMouseDown', handleCellMouseDown);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', handleCellKeyDown);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellModeChange', handleCellModeChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderFocus', handleColumnHeaderFocus);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnGroupHeaderFocus', handleColumnGroupHeaderFocus);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowsSet', handleRowSet);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'paginationModelChange', handlePaginationModelChange);
};



var $lCzvA = parcelRequire("lCzvA");



const $1bfbb38b8132c751$export$e29505bd53a069c8 = (state, props)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        headerFiltering: {
            enabled: props.headerFilters ?? false,
            editing: null,
            menuOpen: null
        }
    });
const $1bfbb38b8132c751$export$8ee3ddc1b48b5da9 = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridHeaderFiltering');
    const setHeaderFilterState = $lCzvA.useCallback((headerFilterState)=>{
        apiRef.current.setState((state)=>{
            // Safety check to avoid MIT users from using it
            // This hook should ultimately be moved to the Pro package
            if (props.signature === 'DataGrid') return state;
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                headerFiltering: {
                    enabled: props.headerFilters ?? false,
                    editing: headerFilterState.editing ?? null,
                    menuOpen: headerFilterState.menuOpen ?? null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.signature,
        props.headerFilters
    ]);
    const startHeaderFilterEditMode = $lCzvA.useCallback((field)=>{
        logger.debug(`Starting edit mode on header filter for field: ${field}`);
        apiRef.current.setHeaderFilterState({
            editing: field
        });
    }, [
        apiRef,
        logger
    ]);
    const stopHeaderFilterEditMode = $lCzvA.useCallback(()=>{
        logger.debug(`Stopping edit mode on header filter`);
        apiRef.current.setHeaderFilterState({
            editing: null
        });
    }, [
        apiRef,
        logger
    ]);
    const showHeaderFilterMenu = $lCzvA.useCallback((field)=>{
        logger.debug(`Opening header filter menu for field: ${field}`);
        apiRef.current.setHeaderFilterState({
            menuOpen: field
        });
    }, [
        apiRef,
        logger
    ]);
    const hideHeaderFilterMenu = $lCzvA.useCallback(()=>{
        logger.debug(`Hiding header filter menu for active field`);
        let fieldToFocus = apiRef.current.state.headerFiltering.menuOpen;
        if (fieldToFocus) {
            const columnLookup = (0, $8b99503000dd62d3$export$8a3a9a6db584d7fd)(apiRef);
            const columnVisibilityModel = (0, $8b99503000dd62d3$export$eb0d33595fe29bb4)(apiRef);
            const orderedFields = (0, $8b99503000dd62d3$export$d8a3dfbb129c80db)(apiRef);
            // If the column was removed from the grid, we need to find the closest visible field
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            // If the field to focus is hidden, we need to find the closest visible field
            if (columnVisibilityModel[fieldToFocus] === false) {
                // contains visible column fields + the field that was just hidden
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return columnVisibilityModel[field] !== false;
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setHeaderFilterState({
                menuOpen: null
            });
            apiRef.current.setColumnHeaderFilterFocus(fieldToFocus);
        }
    }, [
        apiRef,
        logger
    ]);
    const headerFilterPrivateApi = {
        setHeaderFilterState: setHeaderFilterState
    };
    const headerFilterApi = {
        startHeaderFilterEditMode: startHeaderFilterEditMode,
        stopHeaderFilterEditMode: stopHeaderFilterEditMode,
        showHeaderFilterMenu: showHeaderFilterMenu,
        hideHeaderFilterMenu: hideHeaderFilterMenu
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, headerFilterApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, headerFilterPrivateApi, 'private');
    /*
   * EFFECTS
   */ const isFirstRender = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else apiRef.current.setHeaderFilterState({
            enabled: props.headerFilters ?? false
        });
    }, [
        apiRef,
        props.headerFilters
    ]);
};



var $lCzvA = parcelRequire("lCzvA");

const $66a5243f9a0593e1$var$warnedOnceCache = new Set();
function $66a5243f9a0593e1$export$5b28268982f175ba(message, gravity = 'warning') {
    return;
}
function $66a5243f9a0593e1$export$f090597298dd5ce2() {
    $66a5243f9a0593e1$var$warnedOnceCache.clear();
}




const $41fab1063a7fd4d9$export$5505a327712c37f5 = (state, props, apiRef)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        listViewColumn: props.unstable_listColumn ? (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props.unstable_listColumn, {
            computedWidth: $41fab1063a7fd4d9$var$getListColumnWidth(apiRef)
        }) : undefined
    });
function $41fab1063a7fd4d9$export$5ab13dce76367dce(apiRef, props) {
    /*
   * EVENTS
   */ const updateListColumnWidth = ()=>{
        apiRef.current.setState((state)=>{
            if (!state.listViewColumn) return state;
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                listViewColumn: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.listViewColumn, {
                    computedWidth: $41fab1063a7fd4d9$var$getListColumnWidth(apiRef)
                })
            });
        });
    };
    const prevInnerWidth = $lCzvA.useRef(null);
    const handleGridSizeChange = (viewportInnerSize)=>{
        if (prevInnerWidth.current !== viewportInnerSize.width) {
            prevInnerWidth.current = viewportInnerSize.width;
            updateListColumnWidth();
        }
    };
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnVisibilityModelChange', updateListColumnWidth);
    /*
   * EFFECTS
   */ (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        const listColumn = props.unstable_listColumn;
        if (listColumn) apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                listViewColumn: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, listColumn, {
                    computedWidth: $41fab1063a7fd4d9$var$getListColumnWidth(apiRef)
                })
            });
        });
    }, [
        apiRef,
        props.unstable_listColumn
    ]);
    $lCzvA.useEffect(()=>{
        if (props.unstable_listView && !props.unstable_listColumn) (0, $66a5243f9a0593e1$export$5b28268982f175ba)([
            'MUI X: The `unstable_listColumn` prop must be set if `unstable_listView` is enabled.',
            'To fix, pass a column definition to the `unstable_listColumn` prop, e.g. `{ field: "example", renderCell: (params) => <div>{params.row.id}</div> }`.',
            'For more details, see https://mui.com/x/react-data-grid/list-view/'
        ]);
    }, [
        props.unstable_listView,
        props.unstable_listColumn
    ]);
}
function $41fab1063a7fd4d9$var$getListColumnWidth(apiRef) {
    return (0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state).viewportInnerSize.width;
}





var $lCzvA = parcelRequire("lCzvA");







const $ced94ef585e1afa1$export$16d1dc8477d07e4 = (paginationState, signature, paginationModelProp)=>{
    let paginationModel = paginationState.paginationModel;
    const rowCount = paginationState.rowCount;
    const pageSize = paginationModelProp?.pageSize ?? paginationModel.pageSize;
    const page = paginationModelProp?.page ?? paginationModel.page;
    const pageCount = (0, $2713a9cad4802e96$export$b287f0ca5dbff6af)(rowCount, pageSize, page);
    if (paginationModelProp && (paginationModelProp?.page !== paginationModel.page || paginationModelProp?.pageSize !== paginationModel.pageSize)) paginationModel = paginationModelProp;
    const validPage = pageSize === -1 ? 0 : (0, $2713a9cad4802e96$export$41142e40198ee144)(paginationModel.page, pageCount);
    if (validPage !== paginationModel.page) paginationModel = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, paginationModel, {
        page: validPage
    });
    (0, $2713a9cad4802e96$export$d3cf54bfe8b6931)(paginationModel.pageSize, signature);
    return paginationModel;
};
const $ced94ef585e1afa1$export$fb13b4a85293b054 = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridPaginationModel');
    const densityFactor = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $bc5ab296ed04c1c0$export$c646201fb1d3e7a6));
    const previousFilterModel = $lCzvA.useRef((0, $6450fc0917754b27$export$280aedb9454597a5)(apiRef));
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    apiRef.current.registerControlState({
        stateId: 'paginationModel',
        propModel: props.paginationModel,
        propOnChange: props.onPaginationModelChange,
        stateSelector: (0, $017d03038815cc56$export$ccc9f04e59d0d8e6),
        changeEvent: 'paginationModelChange'
    });
    /**
   * API METHODS
   */ const setPage = $lCzvA.useCallback((page)=>{
        const currentModel = (0, $017d03038815cc56$export$ccc9f04e59d0d8e6)(apiRef);
        if (page === currentModel.page) return;
        logger.debug(`Setting page to ${page}`);
        apiRef.current.setPaginationModel({
            page: page,
            pageSize: currentModel.pageSize
        });
    }, [
        apiRef,
        logger
    ]);
    const setPageSize = $lCzvA.useCallback((pageSize)=>{
        const currentModel = (0, $017d03038815cc56$export$ccc9f04e59d0d8e6)(apiRef);
        if (pageSize === currentModel.pageSize) return;
        logger.debug(`Setting page size to ${pageSize}`);
        apiRef.current.setPaginationModel({
            pageSize: pageSize,
            page: currentModel.page
        });
    }, [
        apiRef,
        logger
    ]);
    const setPaginationModel = $lCzvA.useCallback((paginationModel)=>{
        const currentModel = (0, $017d03038815cc56$export$ccc9f04e59d0d8e6)(apiRef);
        if (paginationModel === currentModel) return;
        logger.debug("Setting 'paginationModel' to", paginationModel);
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.pagination, {
                    paginationModel: $ced94ef585e1afa1$export$16d1dc8477d07e4(state.pagination, props.signature, paginationModel)
                })
            }), 'setPaginationModel');
    }, [
        apiRef,
        logger,
        props.signature
    ]);
    const paginationModelApi = {
        setPage: setPage,
        setPageSize: setPageSize,
        setPaginationModel: setPaginationModel
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, paginationModelApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $lCzvA.useCallback((prevState, context)=>{
        const paginationModel = (0, $017d03038815cc56$export$ccc9f04e59d0d8e6)(apiRef);
        const shouldExportPaginationModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
        props.paginationModel != null || // Always export if the `paginationModel` has been initialized
        props.initialState?.pagination?.paginationModel != null || // Export if `page` or `pageSize` is not equal to the default value
        paginationModel.page !== 0 && paginationModel.pageSize !== (0, $2713a9cad4802e96$export$d515e179bb47bd84)(props.autoPageSize);
        if (!shouldExportPaginationModel) return prevState;
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState, {
            pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState.pagination, {
                paginationModel: paginationModel
            })
        });
    }, [
        apiRef,
        props.paginationModel,
        props.initialState?.pagination?.paginationModel,
        props.autoPageSize
    ]);
    const stateRestorePreProcessing = $lCzvA.useCallback((params, context)=>{
        const paginationModel = context.stateToRestore.pagination?.paginationModel ? (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $2713a9cad4802e96$export$73aa7e9d0fff5ee4)(props.autoPageSize), context.stateToRestore.pagination?.paginationModel) : (0, $017d03038815cc56$export$ccc9f04e59d0d8e6)(apiRef);
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.pagination, {
                    paginationModel: $ced94ef585e1afa1$export$16d1dc8477d07e4(state.pagination, props.signature, paginationModel)
                })
            }), 'stateRestorePreProcessing');
        return params;
    }, [
        apiRef,
        props.autoPageSize,
        props.signature
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = ()=>{
        const paginationModel = (0, $017d03038815cc56$export$ccc9f04e59d0d8e6)(apiRef);
        if (apiRef.current.virtualScrollerRef?.current) apiRef.current.scrollToIndexes({
            rowIndex: paginationModel.page * paginationModel.pageSize
        });
    };
    const handleUpdateAutoPageSize = $lCzvA.useCallback(()=>{
        if (!props.autoPageSize) return;
        const dimensions = apiRef.current.getRootDimensions();
        const maximumPageSizeWithoutScrollBar = Math.max(1, Math.floor(dimensions.viewportInnerSize.height / rowHeight));
        apiRef.current.setPageSize(maximumPageSizeWithoutScrollBar);
    }, [
        apiRef,
        props.autoPageSize,
        rowHeight
    ]);
    const handleRowCountChange = $lCzvA.useCallback((newRowCount)=>{
        if (newRowCount == null) return;
        const paginationModel = (0, $017d03038815cc56$export$ccc9f04e59d0d8e6)(apiRef);
        if (paginationModel.page === 0) return;
        const pageCount = (0, $017d03038815cc56$export$b81026f1aaf843a4)(apiRef);
        if (paginationModel.page > pageCount - 1) apiRef.current.setPage(Math.max(0, pageCount - 1));
    }, [
        apiRef
    ]);
    /**
   * Goes to the first row of the grid
   */ const navigateToStart = $lCzvA.useCallback(()=>{
        const paginationModel = (0, $017d03038815cc56$export$ccc9f04e59d0d8e6)(apiRef);
        if (paginationModel.page !== 0) apiRef.current.setPage(0);
        // If the page was not changed it might be needed to scroll to the top
        const scrollPosition = apiRef.current.getScrollPosition();
        if (scrollPosition.top !== 0) apiRef.current.scroll({
            top: 0
        });
    }, [
        apiRef
    ]);
    /**
   * Resets the page only if the active items or quick filter has changed from the last time.
   * This is to avoid resetting the page when the filter model is changed
   * because of and update of the operator from an item that does not have the value
   * or reseting when the filter panel is just opened
   */ const handleFilterModelChange = $lCzvA.useCallback((filterModel)=>{
        const currentActiveFilters = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filterModel, {
            // replace items with the active items
            items: (0, $6450fc0917754b27$export$c7447bfbd4ecafcc)(apiRef)
        });
        if ((0, $ac3bd7253ec0e92a$export$78fdc9adc3f30400)(currentActiveFilters, previousFilterModel.current)) return;
        previousFilterModel.current = currentActiveFilters;
        navigateToStart();
    }, [
        apiRef,
        navigateToStart
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'viewportInnerSizeChange', handleUpdateAutoPageSize);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowCountChange', handleRowCountChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'sortModelChange', (0, $ac3bd7253ec0e92a$export$f546127afff6208d)(props.resetPageOnSortFilter, navigateToStart));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'filterModelChange', (0, $ac3bd7253ec0e92a$export$f546127afff6208d)(props.resetPageOnSortFilter, handleFilterModelChange));
    /**
   * EFFECTS
   */ const isFirstRender = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!props.pagination) return;
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.pagination, {
                    paginationModel: $ced94ef585e1afa1$export$16d1dc8477d07e4(state.pagination, props.signature, props.paginationModel)
                })
            }));
    }, [
        apiRef,
        props.paginationModel,
        props.signature,
        props.pagination
    ]);
    $lCzvA.useEffect(()=>{
        apiRef.current.setState((state)=>{
            const isEnabled = props.pagination === true;
            if (state.pagination.paginationMode === props.paginationMode || state.pagination.enabled === isEnabled) return state;
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.pagination, {
                    paginationMode: props.paginationMode,
                    enabled: props.pagination === true
                })
            });
        });
    }, [
        apiRef,
        props.paginationMode,
        props.pagination
    ]);
    $lCzvA.useEffect(handleUpdateAutoPageSize, [
        handleUpdateAutoPageSize
    ]);
};




var $lCzvA = parcelRequire("lCzvA");





const $e06f508e4460b575$export$229d07cf557fa73f = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridRowCount');
    const visibleTopLevelRowCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$f88efd30675963d1));
    const rowCountState = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $017d03038815cc56$export$946e4ae85da77ef6));
    const paginationMeta = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $017d03038815cc56$export$4dee702a38e33bdb));
    const paginationModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $017d03038815cc56$export$ccc9f04e59d0d8e6));
    const previousPageSize = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)(()=>(0, $017d03038815cc56$export$ccc9f04e59d0d8e6)(apiRef).pageSize);
    apiRef.current.registerControlState({
        stateId: 'paginationRowCount',
        propModel: props.rowCount,
        propOnChange: props.onRowCountChange,
        stateSelector: (0, $017d03038815cc56$export$946e4ae85da77ef6),
        changeEvent: 'rowCountChange'
    });
    /**
   * API METHODS
   */ const setRowCount = $lCzvA.useCallback((newRowCount)=>{
        if (rowCountState === newRowCount) return;
        logger.debug("Setting 'rowCount' to", newRowCount);
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.pagination, {
                    rowCount: newRowCount
                })
            }));
    }, [
        apiRef,
        logger,
        rowCountState
    ]);
    const paginationRowCountApi = {
        setRowCount: setRowCount
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, paginationRowCountApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $lCzvA.useCallback((prevState, context)=>{
        const exportedRowCount = (0, $017d03038815cc56$export$946e4ae85da77ef6)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `rowCount` is controlled
        props.rowCount != null || // Always export if the `rowCount` has been initialized
        props.initialState?.pagination?.rowCount != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState, {
            pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState.pagination, {
                rowCount: exportedRowCount
            })
        });
    }, [
        apiRef,
        props.rowCount,
        props.initialState?.pagination?.rowCount
    ]);
    const stateRestorePreProcessing = $lCzvA.useCallback((params, context)=>{
        const restoredRowCount = context.stateToRestore.pagination?.rowCount ? context.stateToRestore.pagination.rowCount : (0, $017d03038815cc56$export$946e4ae85da77ef6)(apiRef);
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.pagination, {
                    rowCount: restoredRowCount
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = $lCzvA.useCallback((model)=>{
        if (props.paginationMode === 'client' || !previousPageSize.current) return;
        if (model.pageSize !== previousPageSize.current) {
            previousPageSize.current = model.pageSize;
            if (rowCountState === -1) // Row count unknown and page size changed, reset the page
            apiRef.current.setPage(0);
        }
    }, [
        props.paginationMode,
        previousPageSize,
        rowCountState,
        apiRef
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    /**
   * EFFECTS
   */ $lCzvA.useEffect(()=>{
        if (props.paginationMode === 'client') apiRef.current.setRowCount(visibleTopLevelRowCount);
        else if (props.rowCount != null) apiRef.current.setRowCount(props.rowCount);
    }, [
        apiRef,
        props.paginationMode,
        visibleTopLevelRowCount,
        props.rowCount
    ]);
    const isLastPage = paginationMeta.hasNextPage === false;
    $lCzvA.useEffect(()=>{
        if (isLastPage && rowCountState === -1) apiRef.current.setRowCount(paginationModel.pageSize * paginationModel.page + visibleTopLevelRowCount);
    }, [
        apiRef,
        visibleTopLevelRowCount,
        isLastPage,
        rowCountState,
        paginationModel
    ]);
};




var $lCzvA = parcelRequire("lCzvA");



const $5b4ad5f552c75357$export$3e4f856d83dbf104 = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridPaginationMeta');
    const paginationMeta = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $017d03038815cc56$export$4dee702a38e33bdb));
    apiRef.current.registerControlState({
        stateId: 'paginationMeta',
        propModel: props.paginationMeta,
        propOnChange: props.onPaginationMetaChange,
        stateSelector: (0, $017d03038815cc56$export$4dee702a38e33bdb),
        changeEvent: 'paginationMetaChange'
    });
    /**
   * API METHODS
   */ const setPaginationMeta = $lCzvA.useCallback((newPaginationMeta)=>{
        if (paginationMeta === newPaginationMeta) return;
        logger.debug("Setting 'paginationMeta' to", newPaginationMeta);
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.pagination, {
                    meta: newPaginationMeta
                })
            }));
    }, [
        apiRef,
        logger,
        paginationMeta
    ]);
    const paginationMetaApi = {
        setPaginationMeta: setPaginationMeta
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, paginationMetaApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $lCzvA.useCallback((prevState, context)=>{
        const exportedPaginationMeta = (0, $017d03038815cc56$export$4dee702a38e33bdb)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationMeta` is controlled
        props.paginationMeta != null || // Always export if the `paginationMeta` has been initialized
        props.initialState?.pagination?.meta != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState, {
            pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState.pagination, {
                meta: exportedPaginationMeta
            })
        });
    }, [
        apiRef,
        props.paginationMeta,
        props.initialState?.pagination?.meta
    ]);
    const stateRestorePreProcessing = $lCzvA.useCallback((params, context)=>{
        const restoredPaginationMeta = context.stateToRestore.pagination?.meta ? context.stateToRestore.pagination.meta : (0, $017d03038815cc56$export$4dee702a38e33bdb)(apiRef);
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.pagination, {
                    meta: restoredPaginationMeta
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EFFECTS
   */ $lCzvA.useEffect(()=>{
        if (props.paginationMeta) apiRef.current.setPaginationMeta(props.paginationMeta);
    }, [
        apiRef,
        props.paginationMeta
    ]);
};


const $d389ae55b1b23cd7$export$951a05deca7e869f = (state, props)=>{
    const paginationModel = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $2713a9cad4802e96$export$73aa7e9d0fff5ee4)(props.autoPageSize), props.paginationModel ?? props.initialState?.pagination?.paginationModel);
    (0, $2713a9cad4802e96$export$d3cf54bfe8b6931)(paginationModel.pageSize, props.signature);
    const rowCount = props.rowCount ?? props.initialState?.pagination?.rowCount ?? (props.paginationMode === 'client' ? state.rows?.totalRowCount : undefined);
    const meta = props.paginationMeta ?? props.initialState?.pagination?.meta ?? {};
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.pagination, {
            paginationModel: paginationModel,
            rowCount: rowCount,
            meta: meta,
            enabled: props.pagination === true,
            paginationMode: props.paginationMode
        })
    });
};
const $d389ae55b1b23cd7$export$f1c8f1c02d202e22 = (apiRef, props)=>{
    (0, $5b4ad5f552c75357$export$3e4f856d83dbf104)(apiRef, props);
    (0, $ced94ef585e1afa1$export$fb13b4a85293b054)(apiRef, props);
    (0, $e06f508e4460b575$export$229d07cf557fa73f)(apiRef, props);
};



var $lCzvA = parcelRequire("lCzvA");




const $baace636788947e1$export$a9f45f767b8ade48 = (state, props)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        preferencePanel: props.initialState?.preferencePanel ?? {
            open: false
        }
    });
const $baace636788947e1$export$343dd9a605dbb75b = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridPreferencesPanel');
    /**
   * API METHODS
   */ const hidePreferences = $lCzvA.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (!state.preferencePanel.open) return state;
            logger.debug('Hiding Preferences Panel');
            const preferencePanelState = (0, $471c38056db01dd0$export$37e5474577e02878)(state);
            apiRef.current.publishEvent('preferencePanelClose', {
                openedPanelValue: preferencePanelState.openedPanelValue
            });
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                preferencePanel: {
                    open: false
                }
            });
        });
    }, [
        apiRef,
        logger
    ]);
    const showPreferences = $lCzvA.useCallback((newValue, panelId, labelId)=>{
        logger.debug('Opening Preferences Panel');
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                preferencePanel: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.preferencePanel, {
                    open: true,
                    openedPanelValue: newValue,
                    panelId: panelId,
                    labelId: labelId
                })
            }));
        apiRef.current.publishEvent('preferencePanelOpen', {
            openedPanelValue: newValue
        });
    }, [
        logger,
        apiRef
    ]);
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, {
        showPreferences: showPreferences,
        hidePreferences: hidePreferences
    }, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $lCzvA.useCallback((prevState, context)=>{
        const preferencePanelToExport = (0, $471c38056db01dd0$export$37e5474577e02878)(apiRef.current.state);
        const shouldExportPreferencePanel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the panel was initialized
        props.initialState?.preferencePanel != null || // Always export if the panel is opened
        preferencePanelToExport.open;
        if (!shouldExportPreferencePanel) return prevState;
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState, {
            preferencePanel: preferencePanelToExport
        });
    }, [
        apiRef,
        props.initialState?.preferencePanel
    ]);
    const stateRestorePreProcessing = $lCzvA.useCallback((params, context)=>{
        const preferencePanel = context.stateToRestore.preferencePanel;
        if (preferencePanel != null) apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                preferencePanel: preferencePanel
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
};



var $lCzvA = parcelRequire("lCzvA");
const $94bdb7e9d13ae4d8$export$eb04177a3403979f = (state, props)=>{
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        props: {
            getRowId: props.getRowId
        }
    });
};
const $94bdb7e9d13ae4d8$export$38bbfdfacac6e6c2 = (apiRef, props)=>{
    $lCzvA.useEffect(()=>{
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                props: {
                    getRowId: props.getRowId
                }
            }));
    }, [
        apiRef,
        props.getRowId
    ]);
};



var $lCzvA = parcelRequire("lCzvA");











parcelRequire("lCzvA");



var $lCzvA = parcelRequire("lCzvA");














const $a66aee8d09f3916c$export$aec8936a41d479a2 = {
    parents: false,
    descendants: false
};
function $a66aee8d09f3916c$var$getGridRowGroupSelectableDescendants(apiRef, groupId) {
    const rowTree = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef);
    const sortedRowIds = (0, $32a7c18be453c9d5$export$e4979ad0a2db8752)(apiRef);
    const filteredRowsLookup = (0, $6450fc0917754b27$export$6d031b6e8cbaf41c)(apiRef);
    const groupNode = rowTree[groupId];
    if (!groupNode || groupNode.type !== 'group') return [];
    const descendants = [];
    const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
    for(let index = startIndex; index < sortedRowIds.length && rowTree[sortedRowIds[index]]?.depth > groupNode.depth; index += 1){
        const id = sortedRowIds[index];
        if (filteredRowsLookup[id] !== false && apiRef.current.isRowSelectable(id)) descendants.push(id);
    }
    return descendants;
}
function $a66aee8d09f3916c$export$7fbd0b5bf52ca533(groupId, autoSelectParents) {
    return (0, $f0fef4ed0246c865$export$595d22ed68ca2841)((0, $68327dddce1a2c68$export$de9a43d646a9821d), (0, $32a7c18be453c9d5$export$e4979ad0a2db8752), (0, $6450fc0917754b27$export$6d031b6e8cbaf41c), (0, $0bfb640e213a706f$export$d5aede24ebfe3c98), (rowTree, sortedRowIds, filteredRowsLookup, rowSelectionLookup)=>{
        const groupNode = rowTree[groupId];
        if (!groupNode || groupNode.type !== 'group') return {
            isIndeterminate: false,
            isChecked: rowSelectionLookup[groupId] === groupId
        };
        if (rowSelectionLookup[groupId] === groupId) return {
            isIndeterminate: false,
            isChecked: true
        };
        let selectableDescendantsCount = 0;
        let selectedDescendantsCount = 0;
        const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
        for(let index = startIndex; index < sortedRowIds.length && rowTree[sortedRowIds[index]]?.depth > groupNode.depth; index += 1){
            const id = sortedRowIds[index];
            if (filteredRowsLookup[id] !== false) {
                selectableDescendantsCount += 1;
                if (rowSelectionLookup[id] !== undefined) selectedDescendantsCount += 1;
            }
        }
        return {
            isIndeterminate: selectedDescendantsCount > 0 && (selectedDescendantsCount < selectableDescendantsCount || rowSelectionLookup[groupId] === undefined),
            isChecked: autoSelectParents ? selectedDescendantsCount > 0 : rowSelectionLookup[groupId] === groupId
        };
    });
}
function $a66aee8d09f3916c$export$cfcdc2e1121f7851(props) {
    if (props.signature === (0, $ecad0fba09446fc0$export$544be0bdf85b5af1).DataGrid) // DataGrid Community has multiple row selection enabled only if checkbox selection is enabled.
    return props.checkboxSelection && props.disableMultipleRowSelection !== true;
    return !props.disableMultipleRowSelection;
}
const $a66aee8d09f3916c$var$getRowNodeParents = (tree, id)=>{
    const parents = [];
    let parent = id;
    while(parent != null && parent !== (0, $dc4fe3453cdb0a0a$export$433b924dc2506913)){
        const node = tree[parent];
        if (!node) return parents;
        parents.push(parent);
        parent = node.parent;
    }
    return parents;
};
const $a66aee8d09f3916c$var$getFilteredRowNodeSiblings = (tree, filteredRows, id)=>{
    const node = tree[id];
    if (!node) return [];
    const parent = node.parent;
    if (parent == null) return [];
    const parentNode = tree[parent];
    return parentNode.children.filter((childId)=>childId !== id && filteredRows[childId] !== false);
};
const $a66aee8d09f3916c$export$a8171774e887a9d0 = (apiRef, tree, selectedRow, autoSelectDescendants, autoSelectParents, addRow, selectedIds = new Set((0, $0bfb640e213a706f$export$f663bee74a6091fc)(apiRef.current.state)))=>{
    const filteredRows = (0, $6450fc0917754b27$export$6d031b6e8cbaf41c)(apiRef);
    const selectedDescendants = new Set([]);
    if (!autoSelectDescendants && !autoSelectParents || filteredRows[selectedRow] === false) return;
    if (autoSelectDescendants) {
        const rowNode = tree[selectedRow];
        if (rowNode?.type === 'group') {
            const descendants = $a66aee8d09f3916c$var$getGridRowGroupSelectableDescendants(apiRef, selectedRow);
            descendants.forEach((rowId)=>{
                addRow(rowId);
                selectedDescendants.add(rowId);
            });
        }
    }
    if (autoSelectParents) {
        const checkAllDescendantsSelected = (rowId)=>{
            if (!selectedIds.has(rowId) && !selectedDescendants.has(rowId)) return false;
            const node = tree[rowId];
            if (!node) return false;
            if (node.type !== 'group') return true;
            return node.children.every(checkAllDescendantsSelected);
        };
        const traverseParents = (rowId)=>{
            const siblings = $a66aee8d09f3916c$var$getFilteredRowNodeSiblings(tree, filteredRows, rowId);
            if (siblings.length === 0 || siblings.every(checkAllDescendantsSelected)) {
                const rowNode = tree[rowId];
                const parent = rowNode?.parent;
                if (parent != null && parent !== (0, $dc4fe3453cdb0a0a$export$433b924dc2506913) && apiRef.current.isRowSelectable(parent)) {
                    addRow(parent);
                    selectedDescendants.add(parent);
                    traverseParents(parent);
                }
            }
        };
        traverseParents(selectedRow);
    }
};
const $a66aee8d09f3916c$export$dbbc58cbb95afec2 = (apiRef, tree, deselectedRow, autoSelectDescendants, autoSelectParents, removeRow)=>{
    const selectedIdsLookup = (0, $0bfb640e213a706f$export$d5aede24ebfe3c98)(apiRef);
    if (!autoSelectParents && !autoSelectDescendants) return;
    if (autoSelectParents) {
        const allParents = $a66aee8d09f3916c$var$getRowNodeParents(tree, deselectedRow);
        allParents.forEach((parent)=>{
            const isSelected = selectedIdsLookup[parent] === parent;
            if (isSelected) removeRow(parent);
        });
    }
    if (autoSelectDescendants) {
        const rowNode = tree[deselectedRow];
        if (rowNode?.type === 'group') {
            const descendants = $a66aee8d09f3916c$var$getGridRowGroupSelectableDescendants(apiRef, deselectedRow);
            descendants.forEach((descendant)=>{
                removeRow(descendant);
            });
        }
    }
};



const $d00d6f03c65f6a60$var$_excluded = [
    "field",
    "id",
    "formattedValue",
    "row",
    "rowNode",
    "colDef",
    "isEditable",
    "cellMode",
    "hasFocus",
    "tabIndex",
    "api"
];
const $d00d6f03c65f6a60$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $d00d6f03c65f6a60$export$de9fc2d8e98d780 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridCellCheckboxRenderer(props, ref) {
    const { field: field, id: id, rowNode: rowNode, hasFocus: hasFocus, tabIndex: tabIndex } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $d00d6f03c65f6a60$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $d00d6f03c65f6a60$var$useUtilityClasses(ownerState);
    const checkboxElement = $lCzvA.useRef(null);
    const rippleRef = $lCzvA.useRef(null);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(checkboxElement, ref);
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked,
            id: id
        };
        apiRef.current.publishEvent('rowSelectionCheckboxChange', params, event);
    };
    $lCzvA.useLayoutEffect(()=>{
        if (tabIndex === 0) {
            const element = apiRef.current.getCellElement(id, field);
            if (element) element.tabIndex = -1;
        }
    }, [
        apiRef,
        tabIndex,
        id,
        field
    ]);
    $lCzvA.useEffect(()=>{
        if (hasFocus) {
            const input = checkboxElement.current?.querySelector('input');
            input?.focus({
                preventScroll: true
            });
        } else if (rippleRef.current) // Only available in @mui/material v5.4.1 or later
        rippleRef.current.stop({});
    }, [
        hasFocus
    ]);
    const handleKeyDown = $lCzvA.useCallback((event)=>{
        if (event.key === ' ') // We call event.stopPropagation to avoid selecting the row and also scrolling to bottom
        // TODO: Remove and add a check inside useGridKeyboardNavigation
        event.stopPropagation();
    }, []);
    const isSelectable = apiRef.current.isRowSelectable(id);
    const checkboxPropsSelector = (0, $a66aee8d09f3916c$export$7fbd0b5bf52ca533)(id, rootProps.rowSelectionPropagation?.parents ?? false);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, checkboxPropsSelector, (0, $1e10d601c15466d4$export$8da4c691e5695191));
    if (rowNode.type === 'footer' || rowNode.type === 'pinnedRow') return null;
    const checked = rootProps.indeterminateCheckboxAction === 'select' ? isChecked && !isIndeterminate : isChecked;
    const label = apiRef.current.getLocaleText(checked ? 'checkboxSelectionUnselectRow' : 'checkboxSelectionSelectRow');
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseCheckbox, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        tabIndex: tabIndex,
        checked: checked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            'aria-label': label,
            name: 'select_row'
        },
        onKeyDown: handleKeyDown,
        indeterminate: isIndeterminate,
        disabled: !isSelectable,
        touchRippleRef: rippleRef /* FIXME: typing error */ 
    }, rootProps.slotProps?.baseCheckbox, other, {
        ref: handleRef
    }));
});
const $d00d6f03c65f6a60$export$6df0a29182db5ff8 = $d00d6f03c65f6a60$export$de9fc2d8e98d780;





var $lCzvA = parcelRequire("lCzvA");













const $498999273ac3d788$var$_excluded = [
    "field",
    "colDef"
];
const $498999273ac3d788$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $498999273ac3d788$export$22c0c31c5dd8f5aa = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridHeaderCheckbox(props, ref) {
    const other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $498999273ac3d788$var$_excluded);
    const [, forceUpdate] = $lCzvA.useState(false);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $498999273ac3d788$var$useUtilityClasses(ownerState);
    const tabIndexState = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $c2be356cc77cce81$export$29da670438604dbd));
    const selection = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $0bfb640e213a706f$export$f663bee74a6091fc));
    const visibleRowIds = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$7a99837e2fd93e42));
    const paginatedVisibleRowIds = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $017d03038815cc56$export$c1f6a976375edd4a));
    const filteredSelection = $lCzvA.useMemo(()=>{
        if (typeof rootProps.isRowSelectable !== 'function') return selection;
        return selection.filter((id)=>{
            if (rootProps.keepNonExistentRowsSelected) return true;
            // The row might have been deleted
            if (!apiRef.current.getRow(id)) return false;
            return rootProps.isRowSelectable(apiRef.current.getRowParams(id));
        });
    }, [
        apiRef,
        rootProps.isRowSelectable,
        selection,
        rootProps.keepNonExistentRowsSelected
    ]);
    // All the rows that could be selected / unselected by toggling this checkbox
    const selectionCandidates = $lCzvA.useMemo(()=>{
        const rowIds = !rootProps.pagination || !rootProps.checkboxSelectionVisibleOnly || rootProps.paginationMode === 'server' ? visibleRowIds : paginatedVisibleRowIds;
        // Convert to an object to make O(1) checking if a row exists or not
        // TODO create selector that returns visibleRowIds/paginatedVisibleRowIds as an object
        return rowIds.reduce((acc, id)=>{
            acc[id] = true;
            return acc;
        }, {});
    }, [
        rootProps.pagination,
        rootProps.paginationMode,
        rootProps.checkboxSelectionVisibleOnly,
        paginatedVisibleRowIds,
        visibleRowIds
    ]);
    // Amount of rows selected and that are visible in the current page
    const currentSelectionSize = $lCzvA.useMemo(()=>filteredSelection.filter((id)=>selectionCandidates[id]).length, [
        filteredSelection,
        selectionCandidates
    ]);
    const isIndeterminate = currentSelectionSize > 0 && currentSelectionSize < Object.keys(selectionCandidates).length;
    const isChecked = currentSelectionSize > 0;
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked
        };
        apiRef.current.publishEvent('headerSelectionCheckboxChange', params);
    };
    const tabIndex = tabIndexState !== null && tabIndexState.field === props.field ? 0 : -1;
    $lCzvA.useLayoutEffect(()=>{
        const element = apiRef.current.getColumnHeaderElement(props.field);
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        tabIndex,
        apiRef,
        props.field
    ]);
    const handleKeyDown = $lCzvA.useCallback((event)=>{
        if (event.key === ' ') // imperative toggle the checkbox because Space is disable by some preventDefault
        apiRef.current.publishEvent('headerSelectionCheckboxChange', {
            value: !isChecked
        });
    }, [
        apiRef,
        isChecked
    ]);
    const handleSelectionChange = $lCzvA.useCallback(()=>{
        forceUpdate((p)=>!p);
    }, []);
    $lCzvA.useEffect(()=>{
        return apiRef.current.subscribeEvent('rowSelectionChange', handleSelectionChange);
    }, [
        apiRef,
        handleSelectionChange
    ]);
    const checked = rootProps.indeterminateCheckboxAction === 'select' ? isChecked && !isIndeterminate : isChecked;
    const label = apiRef.current.getLocaleText(checked ? 'checkboxSelectionUnselectAllRows' : 'checkboxSelectionSelectAllRows');
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseCheckbox, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        indeterminate: isIndeterminate,
        checked: checked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            'aria-label': label,
            name: 'select_all_rows'
        },
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown,
        disabled: !(0, $a66aee8d09f3916c$export$cfcdc2e1121f7851)(rootProps)
    }, rootProps.slotProps?.baseCheckbox, other, {
        ref: ref
    }));
});






const $145aea3d0e493d77$export$322dfed7a1df1b02 = '__check__';
const $145aea3d0e493d77$export$b2e9ab6103a664ad = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $c7df02efbbf7aa77$export$220b51460e149ea9), {
    type: 'custom',
    field: $145aea3d0e493d77$export$322dfed7a1df1b02,
    width: 50,
    resizable: false,
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    getApplyQuickFilterFn: undefined,
    display: 'flex',
    valueGetter: (value, row, column, apiRef)=>{
        const selectionLookup = (0, $0bfb640e213a706f$export$d5aede24ebfe3c98)(apiRef);
        const rowId = (0, $c0782207122e35d1$export$5e766ecd73f055ed)(apiRef.current.state, row);
        return selectionLookup[rowId] !== undefined;
    },
    renderHeader: (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $498999273ac3d788$export$22c0c31c5dd8f5aa), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params)),
    renderCell: (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $d00d6f03c65f6a60$export$6df0a29182db5ff8), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params))
});









const $43310e1ea3af1013$var$getSelectionModelPropValue = (selectionModelProp, prevSelectionModel)=>{
    if (selectionModelProp == null) return selectionModelProp;
    if (Array.isArray(selectionModelProp)) return selectionModelProp;
    if (prevSelectionModel && prevSelectionModel[0] === selectionModelProp) return prevSelectionModel;
    return [
        selectionModelProp
    ];
};
const $43310e1ea3af1013$export$73be1d69367eeb5b = (state, props)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        rowSelection: props.rowSelection ? $43310e1ea3af1013$var$getSelectionModelPropValue(props.rowSelectionModel) ?? [] : []
    });
const $43310e1ea3af1013$export$3e2b6b991d9d83f0 = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridSelection');
    const runIfRowSelectionIsEnabled = $lCzvA.useCallback((callback)=>(...args)=>{
            if (props.rowSelection) callback(...args);
        }, [
        props.rowSelection
    ]);
    const applyAutoSelection = props.signature !== (0, $ecad0fba09446fc0$export$544be0bdf85b5af1).DataGrid && (props.rowSelectionPropagation?.parents || props.rowSelectionPropagation?.descendants);
    const propRowSelectionModel = $lCzvA.useMemo(()=>{
        return $43310e1ea3af1013$var$getSelectionModelPropValue(props.rowSelectionModel, (0, $0bfb640e213a706f$export$f663bee74a6091fc)(apiRef.current.state));
    }, [
        apiRef,
        props.rowSelectionModel
    ]);
    const lastRowToggled = $lCzvA.useRef(null);
    apiRef.current.registerControlState({
        stateId: 'rowSelection',
        propModel: propRowSelectionModel,
        propOnChange: props.onRowSelectionModelChange,
        stateSelector: (0, $0bfb640e213a706f$export$f663bee74a6091fc),
        changeEvent: 'rowSelectionChange'
    });
    const { checkboxSelection: checkboxSelection, disableRowSelectionOnClick: disableRowSelectionOnClick, isRowSelectable: propIsRowSelectable } = props;
    const canHaveMultipleSelection = (0, $a66aee8d09f3916c$export$cfcdc2e1121f7851)(props);
    const tree = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$de9a43d646a9821d));
    const isNestedData = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$4cdbe576751dd8e2)) > 1;
    const expandMouseRowRangeSelection = $lCzvA.useCallback((id)=>{
        let endId = id;
        const startId = lastRowToggled.current ?? id;
        const isSelected = apiRef.current.isRowSelected(id);
        if (isSelected) {
            const visibleRowIds = (0, $6450fc0917754b27$export$7a99837e2fd93e42)(apiRef);
            const startIndex = visibleRowIds.findIndex((rowId)=>rowId === startId);
            const endIndex = visibleRowIds.findIndex((rowId)=>rowId === endId);
            if (startIndex === endIndex) return;
            if (startIndex > endIndex) endId = visibleRowIds[endIndex + 1];
            else endId = visibleRowIds[endIndex - 1];
        }
        lastRowToggled.current = id;
        apiRef.current.selectRowRange({
            startId: startId,
            endId: endId
        }, !isSelected);
    }, [
        apiRef
    ]);
    /*
   * API METHODS
   */ const setRowSelectionModel = $lCzvA.useCallback((model)=>{
        if (props.signature === (0, $ecad0fba09446fc0$export$544be0bdf85b5af1).DataGrid && !canHaveMultipleSelection && Array.isArray(model) && model.length > 1) throw new Error([
            'MUI X: `rowSelectionModel` can only contain 1 item in DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection.'
        ].join('\n'));
        const currentModel = (0, $0bfb640e213a706f$export$f663bee74a6091fc)(apiRef.current.state);
        if (currentModel !== model) {
            logger.debug(`Setting selection model`);
            apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                    rowSelection: props.rowSelection ? model : []
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger,
        props.rowSelection,
        props.signature,
        canHaveMultipleSelection
    ]);
    const isRowSelected = $lCzvA.useCallback((id)=>(0, $0bfb640e213a706f$export$f663bee74a6091fc)(apiRef.current.state).includes(id), [
        apiRef
    ]);
    const isRowSelectable = $lCzvA.useCallback((id)=>{
        if (props.rowSelection === false) return false;
        if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) return false;
        const rowNode = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef)[id];
        if (rowNode?.type === 'footer' || rowNode?.type === 'pinnedRow') return false;
        return true;
    }, [
        apiRef,
        props.rowSelection,
        propIsRowSelectable
    ]);
    const getSelectedRows = $lCzvA.useCallback(()=>(0, $0bfb640e213a706f$export$dd53f67f8b4cd8b1)(apiRef), [
        apiRef
    ]);
    const selectRow = $lCzvA.useCallback((id, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.isRowSelectable(id)) return;
        lastRowToggled.current = id;
        if (resetSelection) {
            logger.debug(`Setting selection for row ${id}`);
            const newSelection = [];
            const addRow = (rowId)=>{
                newSelection.push(rowId);
            };
            if (isSelected) {
                addRow(id);
                if (applyAutoSelection) (0, $a66aee8d09f3916c$export$a8171774e887a9d0)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            }
            apiRef.current.setRowSelectionModel(newSelection);
        } else {
            logger.debug(`Toggling selection for row ${id}`);
            const selection = (0, $0bfb640e213a706f$export$f663bee74a6091fc)(apiRef.current.state);
            const newSelection = new Set(selection);
            newSelection.delete(id);
            const addRow = (rowId)=>{
                newSelection.add(rowId);
            };
            const removeRow = (rowId)=>{
                newSelection.delete(rowId);
            };
            if (isSelected) {
                addRow(id);
                if (applyAutoSelection) (0, $a66aee8d09f3916c$export$a8171774e887a9d0)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            } else if (applyAutoSelection) (0, $a66aee8d09f3916c$export$dbbc58cbb95afec2)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, removeRow);
            const isSelectionValid = newSelection.size < 2 || canHaveMultipleSelection;
            if (isSelectionValid) apiRef.current.setRowSelectionModel(Array.from(newSelection));
        }
    }, [
        apiRef,
        logger,
        applyAutoSelection,
        tree,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        canHaveMultipleSelection
    ]);
    const selectRows = $lCzvA.useCallback((ids, isSelected = true, resetSelection = false)=>{
        logger.debug(`Setting selection for several rows`);
        const selectableIds = ids.filter((id)=>apiRef.current.isRowSelectable(id));
        let newSelection;
        if (resetSelection) {
            if (isSelected) {
                newSelection = new Set(selectableIds);
                if (applyAutoSelection) {
                    const addRow = (rowId)=>{
                        newSelection.add(rowId);
                    };
                    selectableIds.forEach((id)=>{
                        (0, $a66aee8d09f3916c$export$a8171774e887a9d0)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
                    });
                }
            } else newSelection = new Set();
            const currentLookup = (0, $0bfb640e213a706f$export$d5aede24ebfe3c98)(apiRef);
            if (newSelection.size === Object.keys(currentLookup).length && Array.from(newSelection).every((id)=>currentLookup[id] === id)) return;
        } else {
            newSelection = new Set(Object.values((0, $0bfb640e213a706f$export$d5aede24ebfe3c98)(apiRef)));
            const addRow = (rowId)=>{
                newSelection.add(rowId);
            };
            const removeRow = (rowId)=>{
                newSelection.delete(rowId);
            };
            selectableIds.forEach((id)=>{
                if (isSelected) {
                    newSelection.add(id);
                    if (applyAutoSelection) (0, $a66aee8d09f3916c$export$a8171774e887a9d0)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
                } else {
                    removeRow(id);
                    if (applyAutoSelection) (0, $a66aee8d09f3916c$export$dbbc58cbb95afec2)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, removeRow);
                }
            });
        }
        const isSelectionValid = newSelection.size < 2 || canHaveMultipleSelection;
        if (isSelectionValid) apiRef.current.setRowSelectionModel(Array.from(newSelection));
    }, [
        logger,
        applyAutoSelection,
        canHaveMultipleSelection,
        apiRef,
        tree,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents
    ]);
    const getPropagatedRowSelectionModel = $lCzvA.useCallback((inputSelectionModel)=>{
        if (!isNestedData || !applyAutoSelection || inputSelectionModel.length === 0) return inputSelectionModel;
        const propagatedSelectionModel = new Set(inputSelectionModel);
        const addRow = (rowId)=>{
            propagatedSelectionModel.add(rowId);
        };
        for (const id of inputSelectionModel)(0, $a66aee8d09f3916c$export$a8171774e887a9d0)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow, propagatedSelectionModel);
        return Array.from(propagatedSelectionModel);
    }, [
        apiRef,
        tree,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        isNestedData,
        applyAutoSelection
    ]);
    const selectRowRange = $lCzvA.useCallback(({ startId: startId, endId: endId }, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) return;
        logger.debug(`Expanding selection from row ${startId} to row ${endId}`);
        // Using rows from all pages allow to select a range across several pages
        const allPagesRowIds = (0, $6450fc0917754b27$export$7a99837e2fd93e42)(apiRef);
        const startIndex = allPagesRowIds.indexOf(startId);
        const endIndex = allPagesRowIds.indexOf(endId);
        const [start, end] = startIndex > endIndex ? [
            endIndex,
            startIndex
        ] : [
            startIndex,
            endIndex
        ];
        const rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
    }, [
        apiRef,
        logger
    ]);
    const selectionPublicApi = {
        selectRow: selectRow,
        setRowSelectionModel: setRowSelectionModel,
        getSelectedRows: getSelectedRows,
        isRowSelected: isRowSelected,
        isRowSelectable: isRowSelectable
    };
    const selectionPrivateApi = {
        selectRows: selectRows,
        selectRowRange: selectRowRange,
        getPropagatedRowSelectionModel: getPropagatedRowSelectionModel
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, selectionPublicApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, selectionPrivateApi, props.signature === (0, $ecad0fba09446fc0$export$544be0bdf85b5af1).DataGrid ? 'private' : 'public');
    /*
   * EVENTS
   */ const isFirstRender = $lCzvA.useRef(true);
    const removeOutdatedSelection = $lCzvA.useCallback((sortModelUpdated = false)=>{
        if (isFirstRender.current) return;
        const currentSelection = (0, $0bfb640e213a706f$export$f663bee74a6091fc)(apiRef.current.state);
        const rowsLookup = (0, $68327dddce1a2c68$export$37767f9110c99048)(apiRef);
        const filteredRowsLookup = (0, $6450fc0917754b27$export$6d031b6e8cbaf41c)(apiRef);
        // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
        const selectionLookup = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $0bfb640e213a706f$export$d5aede24ebfe3c98)(apiRef));
        const isNonExistent = (id)=>{
            if (props.filterMode === 'server') return !rowsLookup[id];
            return !rowsLookup[id] || filteredRowsLookup[id] === false;
        };
        let hasChanged = false;
        currentSelection.forEach((id)=>{
            if (isNonExistent(id)) {
                if (props.keepNonExistentRowsSelected) return;
                delete selectionLookup[id];
                hasChanged = true;
                return;
            }
            if (!props.rowSelectionPropagation?.parents) return;
            const node = tree[id];
            if (node.type === 'group') {
                const isAutoGenerated = node.isAutoGenerated;
                if (isAutoGenerated) {
                    delete selectionLookup[id];
                    hasChanged = true;
                    return;
                }
                // Keep previously selected tree data parents selected if all their children are filtered out
                if (!node.children.every((childId)=>filteredRowsLookup[childId] === false)) {
                    delete selectionLookup[id];
                    hasChanged = true;
                }
            }
        });
        // For nested data, on row tree updation (filtering, adding rows, etc.) when the selection is
        // not empty, we need to re-run scanning of the tree to propagate the selection changes
        // Example: A parent whose de-selected children are filtered out should now be selected
        const shouldReapplyPropagation = isNestedData && props.rowSelectionPropagation?.parents && Object.keys(selectionLookup).length > 0;
        if (hasChanged || shouldReapplyPropagation && !sortModelUpdated) {
            const newSelection = Object.values(selectionLookup);
            if (shouldReapplyPropagation) apiRef.current.selectRows(newSelection, true, true);
            else apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        isNestedData,
        props.rowSelectionPropagation?.parents,
        props.keepNonExistentRowsSelected,
        props.filterMode,
        tree
    ]);
    const handleSingleRowSelection = $lCzvA.useCallback((id, event)=>{
        const hasCtrlKey = event.metaKey || event.ctrlKey;
        // multiple selection is only allowed if:
        // - it is a checkboxSelection
        // - it is a keyboard selection
        // - Ctrl is pressed
        const isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !(0, $23fd0e5066a0f9a3$export$130b789831072f4c)(event);
        const resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
        const isSelected = apiRef.current.isRowSelected(id);
        if (resetSelection) apiRef.current.selectRow(id, !isMultipleSelectionDisabled ? !isSelected : true, true);
        else apiRef.current.selectRow(id, !isSelected, false);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection
    ]);
    const handleRowClick = $lCzvA.useCallback((params, event)=>{
        if (disableRowSelectionOnClick) return;
        const field = event.target.closest(`.${(0, $786c119d9add6b61$export$2100d54e36406477).cell}`)?.getAttribute('data-field');
        if (field === (0, $145aea3d0e493d77$export$b2e9ab6103a664ad).field) // click on checkbox should not trigger row selection
        return;
        if (field === (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719)) // click to open the detail panel should not select the row
        return;
        if (field) {
            const column = apiRef.current.getColumn(field);
            if (column?.type === (0, $8af4a53e0f3e9113$export$e2523ab9efeb7465)) return;
        }
        const rowNode = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef)[params.id];
        if (rowNode.type === 'pinnedRow') return;
        if (event.shiftKey && canHaveMultipleSelection) expandMouseRowRangeSelection(params.id);
        else handleSingleRowSelection(params.id, event);
    }, [
        disableRowSelectionOnClick,
        canHaveMultipleSelection,
        apiRef,
        expandMouseRowRangeSelection,
        handleSingleRowSelection
    ]);
    const preventSelectionOnShift = $lCzvA.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.shiftKey) window.getSelection()?.removeAllRanges();
    }, [
        canHaveMultipleSelection
    ]);
    const handleRowSelectionCheckboxChange = $lCzvA.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.nativeEvent.shiftKey) expandMouseRowRangeSelection(params.id);
        else apiRef.current.selectRow(params.id, params.value, !canHaveMultipleSelection);
    }, [
        apiRef,
        expandMouseRowRangeSelection,
        canHaveMultipleSelection
    ]);
    const handleHeaderSelectionCheckboxChange = $lCzvA.useCallback((params)=>{
        const rowsToBeSelected = props.pagination && props.checkboxSelectionVisibleOnly && props.paginationMode === 'client' ? (0, $017d03038815cc56$export$c1f6a976375edd4a)(apiRef) : (0, $6450fc0917754b27$export$7a99837e2fd93e42)(apiRef);
        apiRef.current.selectRows(rowsToBeSelected, params.value);
    }, [
        apiRef,
        props.checkboxSelectionVisibleOnly,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellKeyDown = $lCzvA.useCallback((params, event)=>{
        // Get the most recent cell mode because it may have been changed by another listener
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit) return;
        // Ignore portal
        // Do not apply shortcuts if the focus is not on the cell root component
        if ((0, $e6e8e5e948b588ba$export$8ce496ad3bfbe3a6)(event)) return;
        if ((0, $23fd0e5066a0f9a3$export$e13d96c38a470518)(event.key) && event.shiftKey) {
            // The cell that has focus after the keyboard navigation
            const focusCell = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
            if (focusCell && focusCell.id !== params.id) {
                event.preventDefault();
                const isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
                if (!canHaveMultipleSelection) {
                    apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
                    return;
                }
                const newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
                const previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
                let start;
                let end;
                if (newRowIndex > previousRowIndex) {
                    if (isNextRowSelected) {
                        // We are navigating to the bottom of the page and adding selected rows
                        start = previousRowIndex;
                        end = newRowIndex - 1;
                    } else {
                        // We are navigating to the bottom of the page and removing selected rows
                        start = previousRowIndex;
                        end = newRowIndex;
                    }
                } else // eslint-disable-next-line no-lonely-if
                if (isNextRowSelected) {
                    // We are navigating to the top of the page and removing selected rows
                    start = newRowIndex + 1;
                    end = previousRowIndex;
                } else {
                    // We are navigating to the top of the page and adding selected rows
                    start = newRowIndex;
                    end = previousRowIndex;
                }
                const visibleRows = (0, $6b6f708ce7819830$export$79b9fa322a34430b)(apiRef);
                const rowsBetweenStartAndEnd = visibleRows.rows.slice(start, end + 1).map((row)=>row.id);
                apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
                return;
            }
        }
        if (event.key === ' ' && event.shiftKey) {
            event.preventDefault();
            handleSingleRowSelection(params.id, event);
            return;
        }
        if (String.fromCharCode(event.keyCode) === 'A' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            selectRows(apiRef.current.getAllRowIds(), true);
        }
    }, [
        apiRef,
        handleSingleRowSelection,
        selectRows,
        canHaveMultipleSelection
    ]);
    const syncControlledState = (0, $7df3b3244211e5bc$export$2e2bcd8739ae039)(()=>{
        if (!props.rowSelection) {
            apiRef.current.setRowSelectionModel([]);
            return;
        }
        if (propRowSelectionModel === undefined) return;
        if (!applyAutoSelection || !isNestedData || propRowSelectionModel.length === 0) {
            apiRef.current.setRowSelectionModel(propRowSelectionModel);
            return;
        }
        const newSelectionModel = apiRef.current.getPropagatedRowSelectionModel(propRowSelectionModel);
        if (newSelectionModel.length !== propRowSelectionModel.length || !newSelectionModel.every((id)=>propRowSelectionModel.includes(id))) {
            apiRef.current.setRowSelectionModel(newSelectionModel);
            return;
        }
        apiRef.current.setRowSelectionModel(propRowSelectionModel);
    });
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'sortedRowsSet', runIfRowSelectionIsEnabled(()=>removeOutdatedSelection(true)));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'filteredRowsSet', runIfRowSelectionIsEnabled(()=>removeOutdatedSelection()));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowClick', runIfRowSelectionIsEnabled(handleRowClick));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowSelectionCheckboxChange', runIfRowSelectionIsEnabled(handleRowSelectionCheckboxChange));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'headerSelectionCheckboxChange', handleHeaderSelectionCheckboxChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellMouseDown', runIfRowSelectionIsEnabled(preventSelectionOnShift));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', runIfRowSelectionIsEnabled(handleCellKeyDown));
    /*
   * EFFECTS
   */ $lCzvA.useEffect(()=>{
        syncControlledState();
    }, [
        apiRef,
        propRowSelectionModel,
        props.rowSelection,
        syncControlledState
    ]);
    const isStateControlled = propRowSelectionModel != null;
    $lCzvA.useEffect(()=>{
        if (isStateControlled || !props.rowSelection) return;
        // props.isRowSelectable changed
        const currentSelection = (0, $0bfb640e213a706f$export$f663bee74a6091fc)(apiRef.current.state);
        if (isRowSelectable) {
            const newSelection = currentSelection.filter((id)=>isRowSelectable(id));
            if (newSelection.length < currentSelection.length) apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        isRowSelectable,
        isStateControlled,
        props.rowSelection
    ]);
    $lCzvA.useEffect(()=>{
        if (!props.rowSelection || isStateControlled) return;
        const currentSelection = (0, $0bfb640e213a706f$export$f663bee74a6091fc)(apiRef.current.state);
        if (!canHaveMultipleSelection && currentSelection.length > 1) // See https://github.com/mui/mui-x/issues/8455
        apiRef.current.setRowSelectionModel([]);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection,
        isStateControlled,
        props.rowSelection
    ]);
    $lCzvA.useEffect(()=>{
        runIfRowSelectionIsEnabled(removeOutdatedSelection);
    }, [
        removeOutdatedSelection,
        runIfRowSelectionIsEnabled
    ]);
    $lCzvA.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
    }, []);
};



var $lCzvA = parcelRequire("lCzvA");


/* eslint-disable */ /**
 * HACK: Minimal shim to get jsdom to work.
 */ const $f9f93ae90aa602d6$export$9caf76241ca21a11 = typeof globalThis.ResizeObserver !== 'undefined' ? globalThis.ResizeObserver : class ResizeObserver {
    observe() {}
    unobserve() {}
    disconnect() {}
};













const $d34fcc65bc9a26dd$export$4224c70cd0329965 = (state, props, apiRef)=>{
    apiRef.current.caches.rowsMeta = {
        heights: new Map()
    };
    const baseRowHeight = (0, $adc18856c547b659$export$2ca09da26466c31a)(apiRef.current.state);
    const dataRowCount = (0, $68327dddce1a2c68$export$1641ef9d08e265ca)(apiRef);
    const pagination = (0, $017d03038815cc56$export$24c945ea033ce6cf)(apiRef.current.state);
    const rowCount = Math.min(pagination.enabled ? pagination.paginationModel.pageSize : dataRowCount, dataRowCount);
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        rowsMeta: {
            currentPageTotalHeight: rowCount * baseRowHeight,
            positions: Array.from({
                length: rowCount
            }, (_, i)=>i * baseRowHeight),
            pinnedTopRowsTotalHeight: 0,
            pinnedBottomRowsTotalHeight: 0
        }
    });
};
const $d34fcc65bc9a26dd$export$8a4468671da3a64f = (apiRef, props)=>{
    const { getRowHeight: getRowHeightProp, getRowSpacing: getRowSpacing, getEstimatedRowHeight: getEstimatedRowHeight } = props;
    const heightCache = apiRef.current.caches.rowsMeta.heights;
    const lastMeasuredRowIndex = $lCzvA.useRef(-1);
    const hasRowWithAutoHeight = $lCzvA.useRef(false);
    const isHeightMetaValid = $lCzvA.useRef(false);
    const densityFactor = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $bc5ab296ed04c1c0$export$c646201fb1d3e7a6));
    const currentPage = (0, $6b6f708ce7819830$export$d1914c80ff11e37a)(apiRef, props);
    const pinnedRows = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$ffe7071c481e32b0));
    const rowHeight = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$2ca09da26466c31a));
    const getRowHeightEntry = (rowId)=>{
        let entry = heightCache.get(rowId);
        if (entry === undefined) {
            entry = {
                content: rowHeight,
                spacingTop: 0,
                spacingBottom: 0,
                detail: 0,
                autoHeight: false,
                needsFirstMeasurement: true
            };
            heightCache.set(rowId, entry);
        }
        return entry;
    };
    const processHeightEntry = $lCzvA.useCallback((row)=>{
        // HACK: rowHeight trails behind the most up-to-date value just enough to
        // mess the initial rowsMeta hydration :/
        const baseRowHeight = (0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state).rowHeight;
        (0, $ac3bd7253ec0e92a$export$ec5767fa5c351320)(rowHeight);
        const entry = apiRef.current.getRowHeightEntry(row.id);
        if (!getRowHeightProp) {
            entry.content = baseRowHeight;
            entry.needsFirstMeasurement = false;
        } else {
            const rowHeightFromUser = getRowHeightProp((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, row, {
                densityFactor: densityFactor
            }));
            if (rowHeightFromUser === 'auto') {
                if (entry.needsFirstMeasurement) {
                    const estimatedRowHeight = getEstimatedRowHeight ? getEstimatedRowHeight((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, row, {
                        densityFactor: densityFactor
                    })) : baseRowHeight;
                    // If the row was not measured yet use the estimated row height
                    entry.content = estimatedRowHeight ?? baseRowHeight;
                }
                hasRowWithAutoHeight.current = true;
                entry.autoHeight = true;
            } else {
                // Default back to base rowHeight if getRowHeight returns invalid value.
                entry.content = (0, $dc4fe3453cdb0a0a$export$fa15c17c0798a441)(rowHeightFromUser, baseRowHeight, (0, $dc4fe3453cdb0a0a$export$b35665e48a78b958));
                entry.needsFirstMeasurement = false;
                entry.autoHeight = false;
            }
        }
        if (getRowSpacing) {
            const indexRelativeToCurrentPage = apiRef.current.getRowIndexRelativeToVisibleRows(row.id);
            const spacing = getRowSpacing((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, row, {
                isFirstVisible: indexRelativeToCurrentPage === 0,
                isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
                indexRelativeToCurrentPage: indexRelativeToCurrentPage
            }));
            entry.spacingTop = spacing.top ?? 0;
            entry.spacingBottom = spacing.bottom ?? 0;
        } else {
            entry.spacingTop = 0;
            entry.spacingBottom = 0;
        }
        apiRef.current.unstable_applyPipeProcessors('rowHeight', entry, row);
        return entry;
    }, [
        apiRef,
        currentPage.rows,
        getRowHeightProp,
        getEstimatedRowHeight,
        rowHeight,
        getRowSpacing,
        densityFactor
    ]);
    const hydrateRowsMeta = $lCzvA.useCallback(()=>{
        hasRowWithAutoHeight.current = false;
        const pinnedTopRowsTotalHeight = pinnedRows.top.reduce((acc, row)=>{
            const entry = processHeightEntry(row);
            return acc + entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
        }, 0);
        const pinnedBottomRowsTotalHeight = pinnedRows.bottom.reduce((acc, row)=>{
            const entry = processHeightEntry(row);
            return acc + entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
        }, 0);
        const positions = [];
        const currentPageTotalHeight = currentPage.rows.reduce((acc, row)=>{
            positions.push(acc);
            const entry = processHeightEntry(row);
            const total = entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
            return acc + total;
        }, 0);
        if (!hasRowWithAutoHeight.current) // No row has height=auto, so all rows are already measured
        lastMeasuredRowIndex.current = Infinity;
        const didHeightsChange = pinnedTopRowsTotalHeight !== apiRef.current.state.rowsMeta.pinnedTopRowsTotalHeight || pinnedBottomRowsTotalHeight !== apiRef.current.state.rowsMeta.pinnedBottomRowsTotalHeight || currentPageTotalHeight !== apiRef.current.state.rowsMeta.currentPageTotalHeight;
        const rowsMeta = {
            currentPageTotalHeight: currentPageTotalHeight,
            positions: positions,
            pinnedTopRowsTotalHeight: pinnedTopRowsTotalHeight,
            pinnedBottomRowsTotalHeight: pinnedBottomRowsTotalHeight
        };
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                rowsMeta: rowsMeta
            });
        });
        if (didHeightsChange) apiRef.current.updateDimensions();
        isHeightMetaValid.current = true;
    }, [
        apiRef,
        pinnedRows,
        currentPage.rows,
        processHeightEntry
    ]);
    const getRowHeight = (rowId)=>{
        return heightCache.get(rowId)?.content ?? rowHeight;
    };
    const storeRowHeightMeasurement = (id, height)=>{
        const entry = apiRef.current.getRowHeightEntry(id);
        const didChange = entry.content !== height;
        entry.needsFirstMeasurement = false;
        entry.content = height;
        isHeightMetaValid.current &&= !didChange;
    };
    const rowHasAutoHeight = (id)=>{
        return heightCache.get(id)?.autoHeight ?? false;
    };
    const getLastMeasuredRowIndex = ()=>{
        return lastMeasuredRowIndex.current;
    };
    const setLastMeasuredRowIndex = (index)=>{
        if (hasRowWithAutoHeight.current && index > lastMeasuredRowIndex.current) lastMeasuredRowIndex.current = index;
    };
    const resetRowHeights = ()=>{
        heightCache.clear();
        hydrateRowsMeta();
    };
    const resizeObserver = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)(()=>new (0, $f9f93ae90aa602d6$export$9caf76241ca21a11)((entries)=>{
            for(let i = 0; i < entries.length; i += 1){
                const entry = entries[i];
                const height = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
                const rowId = entry.target.__mui_id;
                const focusedVirtualRowId = (0, $7aa25e5066404ffa$export$6082669fb6748800)(apiRef)?.id;
                if (focusedVirtualRowId === rowId && height === 0) // Focused virtual row has 0 height.
                // We don't want to store it to avoid scroll jumping.
                // https://github.com/mui/mui-x/issues/14726
                return;
                apiRef.current.unstable_storeRowHeightMeasurement(rowId, height);
            }
            if (!isHeightMetaValid.current) // Avoids "ResizeObserver loop completed with undelivered notifications" error
            requestAnimationFrame(()=>{
                apiRef.current.requestPipeProcessorsApplication('rowHeight');
            });
        })).current;
    const observeRowHeight = (element, rowId)=>{
        element.__mui_id = rowId;
        resizeObserver.observe(element);
        return ()=>resizeObserver.unobserve(element);
    };
    (0, $f145dfe2f05bbf41$export$98b68054bf03cb4)(apiRef, 'rowHeight', hydrateRowsMeta);
    // The effect is used to build the rows meta data - currentPageTotalHeight and positions.
    // Because of variable row height this is needed for the virtualization
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    const rowsMetaApi = {
        unstable_getRowHeight: getRowHeight,
        unstable_setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        unstable_storeRowHeightMeasurement: storeRowHeightMeasurement,
        resetRowHeights: resetRowHeights
    };
    const rowsMetaPrivateApi = {
        hydrateRowsMeta: hydrateRowsMeta,
        observeRowHeight: observeRowHeight,
        rowHasAutoHeight: rowHasAutoHeight,
        getRowHeightEntry: getRowHeightEntry,
        getLastMeasuredRowIndex: getLastMeasuredRowIndex
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, rowsMetaApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, rowsMetaPrivateApi, 'private');
};



var $lCzvA = parcelRequire("lCzvA");





function $3a7cb20bccd7b314$export$dfe82022b99d331c(testRange, processedRange) {
    if (testRange.firstRowIndex >= processedRange.firstRowIndex && testRange.lastRowIndex <= processedRange.lastRowIndex) return null;
    // Overflowing at the end
    // Example: testRange={ firstRowIndex: 10, lastRowIndex: 20 }, processedRange={ firstRowIndex: 0, lastRowIndex: 15 }
    // Unprocessed Range={ firstRowIndex: 16, lastRowIndex: 20 }
    if (testRange.firstRowIndex >= processedRange.firstRowIndex && testRange.lastRowIndex > processedRange.lastRowIndex) return {
        firstRowIndex: processedRange.lastRowIndex,
        lastRowIndex: testRange.lastRowIndex
    };
    // Overflowing at the beginning
    // Example: testRange={ firstRowIndex: 0, lastRowIndex: 20 }, processedRange={ firstRowIndex: 16, lastRowIndex: 30 }
    // Unprocessed Range={ firstRowIndex: 0, lastRowIndex: 15 }
    if (testRange.firstRowIndex < processedRange.firstRowIndex && testRange.lastRowIndex <= processedRange.lastRowIndex) return {
        firstRowIndex: testRange.firstRowIndex,
        lastRowIndex: processedRange.firstRowIndex - 1
    };
    // TODO: Should return two ranges handle overflowing at both ends ?
    return testRange;
}
function $3a7cb20bccd7b314$export$55e910ce057d7a27(renderContext) {
    return renderContext.firstRowIndex !== 0 || renderContext.lastRowIndex !== 0;
}
function $3a7cb20bccd7b314$export$23d54c9043f34b98(range1, range2) {
    return range1.firstRowIndex !== range2.firstRowIndex || range1.lastRowIndex !== range2.lastRowIndex;
}
const $3a7cb20bccd7b314$export$b1f6fa0c5f374def = (row, colDef, apiRef)=>{
    if (!row) return null;
    let cellValue = row[colDef.field];
    const valueGetter = colDef.rowSpanValueGetter ?? colDef.valueGetter;
    if (valueGetter) cellValue = valueGetter(cellValue, row, colDef, apiRef);
    return cellValue;
};







const $ede0e3e90bccd35d$var$EMPTY_STATE = {
    spannedCells: {},
    hiddenCells: {},
    hiddenCellOriginMap: {}
};
const $ede0e3e90bccd35d$var$EMPTY_RANGE = {
    firstRowIndex: 0,
    lastRowIndex: 0
};
const $ede0e3e90bccd35d$var$skippedFields = new Set([
    (0, $145aea3d0e493d77$export$322dfed7a1df1b02),
    '__reorder__',
    (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719)
]);
/**
 * Default number of rows to process during state initialization to avoid flickering.
 * Number `20` is arbitrarily chosen to be large enough to cover most of the cases without
 * compromising performance.
 */ const $ede0e3e90bccd35d$var$DEFAULT_ROWS_TO_PROCESS = 20;
const $ede0e3e90bccd35d$var$computeRowSpanningState = (apiRef, colDefs, visibleRows, range, rangeToProcess, resetState, processedRange)=>{
    const spannedCells = resetState ? {} : (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, apiRef.current.state.rowSpanning.spannedCells);
    const hiddenCells = resetState ? {} : (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, apiRef.current.state.rowSpanning.hiddenCells);
    const hiddenCellOriginMap = resetState ? {} : (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, apiRef.current.state.rowSpanning.hiddenCellOriginMap);
    if (resetState) processedRange = $ede0e3e90bccd35d$var$EMPTY_RANGE;
    colDefs.forEach((colDef)=>{
        if ($ede0e3e90bccd35d$var$skippedFields.has(colDef.field)) return;
        for(let index = rangeToProcess.firstRowIndex; index < rangeToProcess.lastRowIndex; index += 1){
            const row = visibleRows[index];
            if (hiddenCells[row.id]?.[colDef.field]) continue;
            const cellValue = (0, $3a7cb20bccd7b314$export$b1f6fa0c5f374def)(row.model, colDef, apiRef);
            if (cellValue == null) continue;
            let spannedRowId = row.id;
            let spannedRowIndex = index;
            let rowSpan = 0;
            // For first index, also scan in the previous rows to handle the reset state case e.g by sorting
            const backwardsHiddenCells = [];
            if (index === rangeToProcess.firstRowIndex) {
                let prevIndex = index - 1;
                let prevRowEntry = visibleRows[prevIndex];
                while(prevIndex >= range.firstRowIndex && prevRowEntry && (0, $3a7cb20bccd7b314$export$b1f6fa0c5f374def)(prevRowEntry.model, colDef, apiRef) === cellValue){
                    const currentRow = visibleRows[prevIndex + 1];
                    if (hiddenCells[currentRow.id]) hiddenCells[currentRow.id][colDef.field] = true;
                    else hiddenCells[currentRow.id] = {
                        [colDef.field]: true
                    };
                    backwardsHiddenCells.push(index);
                    rowSpan += 1;
                    spannedRowId = prevRowEntry.id;
                    spannedRowIndex = prevIndex;
                    prevIndex -= 1;
                    prevRowEntry = visibleRows[prevIndex];
                }
            }
            backwardsHiddenCells.forEach((hiddenCellIndex)=>{
                if (hiddenCellOriginMap[hiddenCellIndex]) hiddenCellOriginMap[hiddenCellIndex][colDef.field] = spannedRowIndex;
                else hiddenCellOriginMap[hiddenCellIndex] = {
                    [colDef.field]: spannedRowIndex
                };
            });
            // Scan the next rows
            let relativeIndex = index + 1;
            while(relativeIndex <= range.lastRowIndex && visibleRows[relativeIndex] && (0, $3a7cb20bccd7b314$export$b1f6fa0c5f374def)(visibleRows[relativeIndex].model, colDef, apiRef) === cellValue){
                const currentRow = visibleRows[relativeIndex];
                if (hiddenCells[currentRow.id]) hiddenCells[currentRow.id][colDef.field] = true;
                else hiddenCells[currentRow.id] = {
                    [colDef.field]: true
                };
                if (hiddenCellOriginMap[relativeIndex]) hiddenCellOriginMap[relativeIndex][colDef.field] = spannedRowIndex;
                else hiddenCellOriginMap[relativeIndex] = {
                    [colDef.field]: spannedRowIndex
                };
                relativeIndex += 1;
                rowSpan += 1;
            }
            if (rowSpan > 0) {
                if (spannedCells[spannedRowId]) spannedCells[spannedRowId][colDef.field] = rowSpan + 1;
                else spannedCells[spannedRowId] = {
                    [colDef.field]: rowSpan + 1
                };
            }
        }
        processedRange = {
            firstRowIndex: Math.min(processedRange.firstRowIndex, rangeToProcess.firstRowIndex),
            lastRowIndex: Math.max(processedRange.lastRowIndex, rangeToProcess.lastRowIndex)
        };
    });
    return {
        spannedCells: spannedCells,
        hiddenCells: hiddenCells,
        hiddenCellOriginMap: hiddenCellOriginMap,
        processedRange: processedRange
    };
};
const $ede0e3e90bccd35d$var$getInitialRangeToProcess = (props, apiRef)=>{
    const rowCount = (0, $68327dddce1a2c68$export$c7dcaab5e573753)(apiRef).length;
    if (props.pagination) {
        const pageSize = (0, $017d03038815cc56$export$721a46720a2de097)(apiRef);
        let paginationLastRowIndex = $ede0e3e90bccd35d$var$DEFAULT_ROWS_TO_PROCESS;
        if (pageSize > 0) paginationLastRowIndex = pageSize - 1;
        return {
            firstRowIndex: 0,
            lastRowIndex: Math.min(paginationLastRowIndex, rowCount)
        };
    }
    return {
        firstRowIndex: 0,
        lastRowIndex: Math.min($ede0e3e90bccd35d$var$DEFAULT_ROWS_TO_PROCESS, rowCount)
    };
};
const $ede0e3e90bccd35d$export$1fc0574395a3c13e = (state, props, apiRef)=>{
    if (!props.unstable_rowSpanning) return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        rowSpanning: $ede0e3e90bccd35d$var$EMPTY_STATE
    });
    const rowIds = state.rows.dataRowIds || [];
    const orderedFields = state.columns.orderedFields || [];
    const dataRowIdToModelLookup = state.rows.dataRowIdToModelLookup;
    const columnsLookup = state.columns.lookup;
    const isFilteringPending = Boolean(state.filter.filterModel.items.length) || Boolean(state.filter.filterModel.quickFilterValues?.length);
    if (!rowIds.length || !orderedFields.length || !dataRowIdToModelLookup || !columnsLookup || isFilteringPending) return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        rowSpanning: $ede0e3e90bccd35d$var$EMPTY_STATE
    });
    const rangeToProcess = $ede0e3e90bccd35d$var$getInitialRangeToProcess(props, apiRef);
    const rows = rowIds.map((id)=>({
            id: id,
            model: dataRowIdToModelLookup[id]
        }));
    const colDefs = orderedFields.map((field)=>columnsLookup[field]);
    const { spannedCells: spannedCells, hiddenCells: hiddenCells, hiddenCellOriginMap: hiddenCellOriginMap } = $ede0e3e90bccd35d$var$computeRowSpanningState(apiRef, colDefs, rows, rangeToProcess, rangeToProcess, true, $ede0e3e90bccd35d$var$EMPTY_RANGE);
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        rowSpanning: {
            spannedCells: spannedCells,
            hiddenCells: hiddenCells,
            hiddenCellOriginMap: hiddenCellOriginMap
        }
    });
};
const $ede0e3e90bccd35d$export$bd58ae04485aa5f5 = (apiRef, props)=>{
    const processedRange = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)(()=>{
        return apiRef.current.state.rowSpanning !== $ede0e3e90bccd35d$var$EMPTY_STATE ? $ede0e3e90bccd35d$var$getInitialRangeToProcess(props, apiRef) : $ede0e3e90bccd35d$var$EMPTY_RANGE;
    });
    const updateRowSpanningState = $lCzvA.useCallback((renderContext, resetState = false)=>{
        const { range: range, rows: visibleRows } = (0, $6b6f708ce7819830$export$79b9fa322a34430b)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        if (range === null || !(0, $3a7cb20bccd7b314$export$55e910ce057d7a27)(renderContext)) return;
        if (resetState) processedRange.current = $ede0e3e90bccd35d$var$EMPTY_RANGE;
        const rangeToProcess = (0, $3a7cb20bccd7b314$export$dfe82022b99d331c)({
            firstRowIndex: renderContext.firstRowIndex,
            lastRowIndex: Math.min(renderContext.lastRowIndex, range.lastRowIndex + 1)
        }, processedRange.current);
        if (rangeToProcess === null) return;
        const colDefs = (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef);
        const { spannedCells: spannedCells, hiddenCells: hiddenCells, hiddenCellOriginMap: hiddenCellOriginMap, processedRange: newProcessedRange } = $ede0e3e90bccd35d$var$computeRowSpanningState(apiRef, colDefs, visibleRows, range, rangeToProcess, resetState, processedRange.current);
        processedRange.current = newProcessedRange;
        const newSpannedCellsCount = Object.keys(spannedCells).length;
        const newHiddenCellsCount = Object.keys(hiddenCells).length;
        const currentSpannedCellsCount = Object.keys(apiRef.current.state.rowSpanning.spannedCells).length;
        const currentHiddenCellsCount = Object.keys(apiRef.current.state.rowSpanning.hiddenCells).length;
        const shouldUpdateState = resetState || newSpannedCellsCount !== currentSpannedCellsCount || newHiddenCellsCount !== currentHiddenCellsCount;
        const hasNoSpannedCells = newSpannedCellsCount === 0 && currentSpannedCellsCount === 0;
        if (!shouldUpdateState || hasNoSpannedCells) return;
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                rowSpanning: {
                    spannedCells: spannedCells,
                    hiddenCells: hiddenCells,
                    hiddenCellOriginMap: hiddenCellOriginMap
                }
            });
        });
    }, [
        apiRef,
        processedRange,
        props.pagination,
        props.paginationMode
    ]);
    // Reset events trigger a full re-computation of the row spanning state:
    // - The `unstable_rowSpanning` prop is updated (feature flag)
    // - The filtering is applied
    // - The sorting is applied
    // - The `paginationModel` is updated
    // - The rows are updated
    const resetRowSpanningState = $lCzvA.useCallback(()=>{
        const renderContext = (0, $c79669abb772bd0a$export$4cf9f333a030f780)(apiRef);
        if (!(0, $3a7cb20bccd7b314$export$55e910ce057d7a27)(renderContext)) return;
        updateRowSpanningState(renderContext, true);
    }, [
        apiRef,
        updateRowSpanningState
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'renderedRowsIntervalChange', (0, $ac3bd7253ec0e92a$export$f546127afff6208d)(props.unstable_rowSpanning, updateRowSpanningState));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'sortedRowsSet', (0, $ac3bd7253ec0e92a$export$f546127afff6208d)(props.unstable_rowSpanning, resetRowSpanningState));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'paginationModelChange', (0, $ac3bd7253ec0e92a$export$f546127afff6208d)(props.unstable_rowSpanning, resetRowSpanningState));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'filteredRowsSet', (0, $ac3bd7253ec0e92a$export$f546127afff6208d)(props.unstable_rowSpanning, resetRowSpanningState));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnsChange', (0, $ac3bd7253ec0e92a$export$f546127afff6208d)(props.unstable_rowSpanning, resetRowSpanningState));
    $lCzvA.useEffect(()=>{
        if (!props.unstable_rowSpanning) {
            if (apiRef.current.state.rowSpanning !== $ede0e3e90bccd35d$var$EMPTY_STATE) apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                    rowSpanning: $ede0e3e90bccd35d$var$EMPTY_STATE
                }));
        } else if (apiRef.current.state.rowSpanning === $ede0e3e90bccd35d$var$EMPTY_STATE) resetRowSpanningState();
    }, [
        apiRef,
        resetRowSpanningState,
        props.unstable_rowSpanning
    ]);
};



var $lCzvA = parcelRequire("lCzvA");












const $a663ef9e6ca2a05f$export$1a6bb5bb341eadaa = (state, props, apiRef)=>{
    const isDataSourceAvailable = !!props.unstable_dataSource;
    apiRef.current.caches.rows = (0, $dc4fe3453cdb0a0a$export$3496927f169f2d35)({
        rows: isDataSourceAvailable ? [] : props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
    });
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        rows: (0, $dc4fe3453cdb0a0a$export$4dcb6d8dd06e4f39)({
            apiRef: apiRef,
            rowCountProp: props.rowCount,
            loadingProp: isDataSourceAvailable ? true : props.loading,
            previousTree: null,
            previousTreeDepths: null
        })
    });
};
const $a663ef9e6ca2a05f$export$dd1a4469bbd9394e = (apiRef, props)=>{
    var error;
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridRows');
    const lastUpdateMs = $lCzvA.useRef(Date.now());
    const lastRowCount = $lCzvA.useRef(props.rowCount);
    const timeout = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const getRow = $lCzvA.useCallback((id)=>{
        const model = (0, $68327dddce1a2c68$export$37767f9110c99048)(apiRef)[id];
        if (model) return model;
        const node = apiRef.current.getRowNode(id);
        if (node && (0, $dc4fe3453cdb0a0a$export$5f983e16b1e55860)(node)) return {
            [(0, $dc4fe3453cdb0a0a$export$e8632b32bb8837db)]: id
        };
        return null;
    }, [
        apiRef
    ]);
    const getRowId = $lCzvA.useCallback((row)=>(0, $c0782207122e35d1$export$5e766ecd73f055ed)(apiRef.current.state, row), [
        apiRef
    ]);
    const throttledRowsChange = $lCzvA.useCallback(({ cache: cache, throttle: throttle })=>{
        const run = ()=>{
            lastUpdateMs.current = Date.now();
            apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                    rows: (0, $dc4fe3453cdb0a0a$export$4dcb6d8dd06e4f39)({
                        apiRef: apiRef,
                        rowCountProp: props.rowCount,
                        loadingProp: props.loading,
                        previousTree: (0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef),
                        previousTreeDepths: (0, $68327dddce1a2c68$export$eb24598525413286)(apiRef),
                        previousGroupsToFetch: (0, $68327dddce1a2c68$export$6c1cdbc7b5e9a3f4)(apiRef)
                    })
                }));
            apiRef.current.publishEvent('rowsSet');
            apiRef.current.forceUpdate();
        };
        timeout.clear();
        apiRef.current.caches.rows = cache;
        if (!throttle) {
            run();
            return;
        }
        const throttleRemainingTimeMs = props.throttleRowsMs - (Date.now() - lastUpdateMs.current);
        if (throttleRemainingTimeMs > 0) {
            timeout.start(throttleRemainingTimeMs, run);
            return;
        }
        run();
    }, [
        props.throttleRowsMs,
        props.rowCount,
        props.loading,
        apiRef,
        timeout
    ]);
    /**
   * API METHODS
   */ const setRows = $lCzvA.useCallback((rows)=>{
        logger.debug(`Updating all rows, new length ${rows.length}`);
        const cache = (0, $dc4fe3453cdb0a0a$export$3496927f169f2d35)({
            rows: rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        const prevCache = apiRef.current.caches.rows;
        cache.rowsBeforePartialUpdates = prevCache.rowsBeforePartialUpdates;
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        logger,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange,
        apiRef
    ]);
    const updateRows = $lCzvA.useCallback((updates)=>{
        if (props.signature === (0, $ecad0fba09446fc0$export$544be0bdf85b5af1).DataGrid && updates.length > 1) throw new Error([
            'MUI X: You cannot update several rows at once in `apiRef.current.updateRows` on the DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        const nonPinnedRowsUpdates = (0, $dc4fe3453cdb0a0a$export$1560eaf12ed72130)(apiRef, updates, props.getRowId);
        const cache = (0, $dc4fe3453cdb0a0a$export$b593607f8b00d104)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows
        });
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        props.signature,
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const updateServerRows = $lCzvA.useCallback((updates, groupKeys)=>{
        const nonPinnedRowsUpdates = (0, $dc4fe3453cdb0a0a$export$1560eaf12ed72130)(apiRef, updates, props.getRowId);
        const cache = (0, $dc4fe3453cdb0a0a$export$b593607f8b00d104)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows,
            groupKeys: groupKeys ?? []
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const setLoading = $lCzvA.useCallback((loading)=>{
        if (loading === props.loading) return;
        logger.debug(`Setting loading to ${loading}`);
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.rows, {
                    loading: loading
                })
            }));
        apiRef.current.caches.rows.loadingPropBeforePartialUpdates = loading;
    }, [
        props.loading,
        apiRef,
        logger
    ]);
    const getRowModels = $lCzvA.useCallback(()=>{
        const dataRows = (0, $68327dddce1a2c68$export$c7dcaab5e573753)(apiRef);
        const idRowsLookup = (0, $68327dddce1a2c68$export$37767f9110c99048)(apiRef);
        return new Map(dataRows.map((id)=>[
                id,
                idRowsLookup[id] ?? {}
            ]));
    }, [
        apiRef
    ]);
    const getRowsCount = $lCzvA.useCallback(()=>(0, $68327dddce1a2c68$export$1641ef9d08e265ca)(apiRef), [
        apiRef
    ]);
    const getAllRowIds = $lCzvA.useCallback(()=>(0, $68327dddce1a2c68$export$c7dcaab5e573753)(apiRef), [
        apiRef
    ]);
    const getRowIndexRelativeToVisibleRows = $lCzvA.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        const { rowToIndexMap: rowToIndexMap } = (0, $6b6f708ce7819830$export$79b9fa322a34430b)(apiRef);
        return rowToIndexMap.get(row);
    }, [
        apiRef
    ]);
    const setRowChildrenExpansion = $lCzvA.useCallback((id, isExpanded)=>{
        const currentNode = apiRef.current.getRowNode(id);
        if (!currentNode) throw new Error(`MUI X: No row with id #${id} found.`);
        if (currentNode.type !== 'group') throw new Error('MUI X: Only group nodes can be expanded or collapsed.');
        const newNode = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, currentNode, {
            childrenExpanded: isExpanded
        });
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.rows, {
                    tree: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.rows.tree, {
                        [id]: newNode
                    })
                })
            });
        });
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent('rowExpansionChange', newNode);
    }, [
        apiRef
    ]);
    const getRowNode = $lCzvA.useCallback((id)=>(0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef)[id] ?? null, [
        apiRef
    ]);
    const getRowGroupChildren = $lCzvA.useCallback(({ skipAutoGeneratedRows: skipAutoGeneratedRows = true, groupId: groupId, applySorting: applySorting, applyFiltering: applyFiltering })=>{
        const tree = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef);
        let children;
        if (applySorting) {
            const groupNode = tree[groupId];
            if (!groupNode) return [];
            const sortedRowIds = (0, $32a7c18be453c9d5$export$e4979ad0a2db8752)(apiRef);
            children = [];
            const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
            for(let index = startIndex; index < sortedRowIds.length && tree[sortedRowIds[index]].depth > groupNode.depth; index += 1){
                const id = sortedRowIds[index];
                if (!skipAutoGeneratedRows || !(0, $dc4fe3453cdb0a0a$export$5f983e16b1e55860)(tree[id])) children.push(id);
            }
        } else children = (0, $dc4fe3453cdb0a0a$export$9380f4bcafb87e49)(tree, groupId, skipAutoGeneratedRows);
        if (applyFiltering) {
            const filteredRowsLookup = (0, $6450fc0917754b27$export$6d031b6e8cbaf41c)(apiRef);
            children = children.filter((childId)=>filteredRowsLookup[childId] !== false);
        }
        return children;
    }, [
        apiRef
    ]);
    const setRowIndex = $lCzvA.useCallback((rowId, targetIndex)=>{
        const node = apiRef.current.getRowNode(rowId);
        if (!node) throw new Error(`MUI X: No row with id #${rowId} found.`);
        if (node.parent !== (0, $dc4fe3453cdb0a0a$export$433b924dc2506913)) throw new Error(`MUI X: The row reordering do not support reordering of grouped rows yet.`);
        if (node.type !== 'leaf') throw new Error(`MUI X: The row reordering do not support reordering of footer or grouping rows.`);
        apiRef.current.setState((state)=>{
            const group = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(state, apiRef.current.instanceId)[0, $dc4fe3453cdb0a0a$export$433b924dc2506913];
            const allRows = group.children;
            const oldIndex = allRows.findIndex((row)=>row === rowId);
            if (oldIndex === -1 || oldIndex === targetIndex) return state;
            logger.debug(`Moving row ${rowId} to index ${targetIndex}`);
            const updatedRows = [
                ...allRows
            ];
            updatedRows.splice(targetIndex, 0, updatedRows.splice(oldIndex, 1)[0]);
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.rows, {
                    tree: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.rows.tree, {
                        [(0, $dc4fe3453cdb0a0a$export$433b924dc2506913)]: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, group, {
                            children: updatedRows
                        })
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        logger
    ]);
    const replaceRows = $lCzvA.useCallback((firstRowToRender, newRows)=>{
        if (props.signature === (0, $ecad0fba09446fc0$export$544be0bdf85b5af1).DataGrid && newRows.length > 1) throw new Error([
            'MUI X: You cannot replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        if (newRows.length === 0) return;
        const treeDepth = (0, $68327dddce1a2c68$export$4cdbe576751dd8e2)(apiRef);
        if (treeDepth > 1) throw new Error('`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping');
        const tree = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef));
        const dataRowIdToModelLookup = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $68327dddce1a2c68$export$37767f9110c99048)(apiRef));
        const dataRowIdToIdLookup = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $68327dddce1a2c68$export$451ff98f7dd9f13f)(apiRef));
        const rootGroup = tree[0, $dc4fe3453cdb0a0a$export$433b924dc2506913];
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        const seenIds = new Set();
        for(let i = 0; i < newRows.length; i += 1){
            const rowModel = newRows[i];
            const rowId = (0, $dc4fe3453cdb0a0a$export$a95fb784d0ca2e72)(rowModel, props.getRowId, 'A row was provided without id when calling replaceRows().');
            const [removedRowId] = rootGroupChildren.splice(firstRowToRender + i, 1, rowId);
            if (!seenIds.has(removedRowId)) {
                delete dataRowIdToModelLookup[removedRowId];
                delete dataRowIdToIdLookup[removedRowId];
                delete tree[removedRowId];
            }
            const rowTreeNodeConfig = {
                id: rowId,
                depth: 0,
                parent: (0, $dc4fe3453cdb0a0a$export$433b924dc2506913),
                type: 'leaf',
                groupingKey: null
            };
            dataRowIdToModelLookup[rowId] = rowModel;
            dataRowIdToIdLookup[rowId] = rowId;
            tree[rowId] = rowTreeNodeConfig;
            seenIds.add(rowId);
        }
        tree[0, $dc4fe3453cdb0a0a$export$433b924dc2506913] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootGroup, {
            children: rootGroupChildren
        });
        // Removes potential remaining skeleton rows from the dataRowIds.
        const dataRowIds = rootGroupChildren.filter((childId)=>tree[childId]?.type === 'leaf');
        apiRef.current.caches.rows.dataRowIdToModelLookup = dataRowIdToModelLookup;
        apiRef.current.caches.rows.dataRowIdToIdLookup = dataRowIdToIdLookup;
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.rows, {
                    dataRowIdToModelLookup: dataRowIdToModelLookup,
                    dataRowIdToIdLookup: dataRowIdToIdLookup,
                    dataRowIds: dataRowIds,
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        props.signature,
        props.getRowId
    ]);
    const rowApi = {
        getRow: getRow,
        setLoading: setLoading,
        getRowId: getRowId,
        getRowModels: getRowModels,
        getRowsCount: getRowsCount,
        getAllRowIds: getAllRowIds,
        setRows: setRows,
        updateRows: updateRows,
        getRowNode: getRowNode,
        getRowIndexRelativeToVisibleRows: getRowIndexRelativeToVisibleRows,
        unstable_replaceRows: replaceRows
    };
    const rowProApi = {
        setRowIndex: setRowIndex,
        setRowChildrenExpansion: setRowChildrenExpansion,
        getRowGroupChildren: getRowGroupChildren
    };
    const rowProPrivateApi = {
        updateServerRows: updateServerRows
    };
    /**
   * EVENTS
   */ const groupRows = $lCzvA.useCallback(()=>{
        logger.info(`Row grouping pre-processing have changed, regenerating the row tree`);
        let cache;
        if (apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows) // The `props.rows` did not change since the last row grouping
        // We can use the current rows cache which contains the partial updates done recently.
        cache = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, apiRef.current.caches.rows, {
            updates: {
                type: 'full',
                rows: (0, $68327dddce1a2c68$export$c7dcaab5e573753)(apiRef)
            }
        });
        else // The `props.rows` has changed since the last row grouping
        // We must use the new `props.rows` on the new grouping
        // This occurs because this event is triggered before the `useEffect` on the rows when both the grouping pre-processing and the rows changes on the same render
        cache = (0, $dc4fe3453cdb0a0a$export$3496927f169f2d35)({
            rows: props.rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        logger,
        apiRef,
        props.rows,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange
    ]);
    const previousDataSource = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)(()=>props.unstable_dataSource);
    const handleStrategyProcessorChange = $lCzvA.useCallback((methodName)=>{
        if (props.unstable_dataSource && props.unstable_dataSource !== previousDataSource.current) {
            previousDataSource.current = props.unstable_dataSource;
            return;
        }
        if (methodName === 'rowTreeCreation') groupRows();
    }, [
        groupRows,
        previousDataSource,
        props.unstable_dataSource
    ]);
    const handleStrategyActivityChange = $lCzvA.useCallback(()=>{
        // `rowTreeCreation` is the only processor ran when `strategyAvailabilityChange` is fired.
        // All the other processors listen to `rowsSet` which will be published by the `groupRows` method below.
        if (apiRef.current.getActiveStrategy('rowTree') !== (0, $68327dddce1a2c68$export$c263d91fb644e7a0)(apiRef)) groupRows();
    }, [
        apiRef,
        groupRows
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'strategyAvailabilityChange', handleStrategyActivityChange);
    /**
   * APPLIERS
   */ const applyHydrateRowsProcessor = $lCzvA.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const response = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
                tree: (0, $68327dddce1a2c68$export$de9a43d646a9821d)(state, apiRef.current.instanceId),
                treeDepths: (0, $68327dddce1a2c68$export$eb24598525413286)(state, apiRef.current.instanceId),
                dataRowIds: (0, $68327dddce1a2c68$export$c7dcaab5e573753)(state, apiRef.current.instanceId),
                dataRowIdToModelLookup: (0, $68327dddce1a2c68$export$37767f9110c99048)(state, apiRef.current.instanceId),
                dataRowIdToIdLookup: (0, $68327dddce1a2c68$export$451ff98f7dd9f13f)(state, apiRef.current.instanceId)
            });
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.rows, response, {
                    totalTopLevelRowCount: (0, $dc4fe3453cdb0a0a$export$e6ee03f0394a9759)({
                        tree: response.tree,
                        rowCountProp: props.rowCount
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.rowCount
    ]);
    (0, $f145dfe2f05bbf41$export$98b68054bf03cb4)(apiRef, 'hydrateRows', applyHydrateRowsProcessor);
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, rowApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, rowProApi, props.signature === (0, $ecad0fba09446fc0$export$544be0bdf85b5af1).DataGrid ? 'private' : 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, rowProPrivateApi, 'private');
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridRows`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        let isRowCountPropUpdated = false;
        if (props.rowCount !== lastRowCount.current) {
            isRowCountPropUpdated = true;
            lastRowCount.current = props.rowCount;
        }
        const areNewRowsAlreadyInState = apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows;
        const isNewLoadingAlreadyInState = apiRef.current.caches.rows.loadingPropBeforePartialUpdates === props.loading;
        const isNewRowCountAlreadyInState = apiRef.current.caches.rows.rowCountPropBeforePartialUpdates === props.rowCount;
        // The new rows have already been applied (most likely in the `'rowGroupsPreProcessingChange'` listener)
        if (areNewRowsAlreadyInState) {
            // If the loading prop has changed, we need to update its value in the state because it won't be done by `throttledRowsChange`
            if (!isNewLoadingAlreadyInState) {
                apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                        rows: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.rows, {
                            loading: props.loading
                        })
                    }));
                apiRef.current.caches.rows.loadingPropBeforePartialUpdates = props.loading;
                apiRef.current.forceUpdate();
            }
            if (!isNewRowCountAlreadyInState) {
                apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                        rows: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.rows, {
                            totalRowCount: Math.max(props.rowCount || 0, state.rows.totalRowCount),
                            totalTopLevelRowCount: Math.max(props.rowCount || 0, state.rows.totalTopLevelRowCount)
                        })
                    }));
                apiRef.current.caches.rows.rowCountPropBeforePartialUpdates = props.rowCount;
                apiRef.current.forceUpdate();
            }
            if (!isRowCountPropUpdated) return;
        }
        logger.debug(`Updating all rows, new length ${props.rows?.length}`);
        throttledRowsChange({
            cache: (0, $dc4fe3453cdb0a0a$export$3496927f169f2d35)({
                rows: props.rows,
                getRowId: props.getRowId,
                loading: props.loading,
                rowCount: props.rowCount
            }),
            throttle: false
        });
    }, [
        props.rows,
        props.rowCount,
        props.getRowId,
        props.loading,
        logger,
        throttledRowsChange,
        apiRef
    ]);
};



var $lCzvA = parcelRequire("lCzvA");












const $457e65bc2ecc239e$export$996e35c2eef351ae = (state, props)=>{
    const sortModel = props.sortModel ?? props.initialState?.sorting?.sortModel ?? [];
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        sorting: {
            sortModel: (0, $840823b3251897df$export$13eeac5ac15e0be5)(sortModel, props.disableMultipleColumnsSorting),
            sortedRows: []
        }
    });
};
const $457e65bc2ecc239e$export$951287757eb5d93c = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridSorting');
    apiRef.current.registerControlState({
        stateId: 'sortModel',
        propModel: props.sortModel,
        propOnChange: props.onSortModelChange,
        stateSelector: (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9),
        changeEvent: 'sortModelChange'
    });
    const upsertSortModel = $lCzvA.useCallback((field, sortItem)=>{
        const sortModel = (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9)(apiRef);
        const existingIdx = sortModel.findIndex((c)=>c.field === field);
        let newSortModel = [
            ...sortModel
        ];
        if (existingIdx > -1) {
            if (sortItem?.sort == null) newSortModel.splice(existingIdx, 1);
            else newSortModel.splice(existingIdx, 1, sortItem);
        } else newSortModel = [
            ...sortModel,
            sortItem
        ];
        return newSortModel;
    }, [
        apiRef
    ]);
    const createSortItem = $lCzvA.useCallback((col, directionOverride)=>{
        const sortModel = (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9)(apiRef);
        const existing = sortModel.find((c)=>c.field === col.field);
        if (existing) {
            const nextSort = directionOverride === undefined ? (0, $840823b3251897df$export$b3d84351ab2e3580)(col.sortingOrder ?? props.sortingOrder, existing.sort) : directionOverride;
            return nextSort === undefined ? undefined : (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, existing, {
                sort: nextSort
            });
        }
        return {
            field: col.field,
            sort: directionOverride === undefined ? (0, $840823b3251897df$export$b3d84351ab2e3580)(col.sortingOrder ?? props.sortingOrder) : directionOverride
        };
    }, [
        apiRef,
        props.sortingOrder
    ]);
    const addColumnMenuItem = $lCzvA.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.sortable === false || props.disableColumnSorting) return columnMenuItems;
        const sortingOrder = colDef.sortingOrder || props.sortingOrder;
        if (sortingOrder.some((item)=>!!item)) return [
            ...columnMenuItems,
            'columnMenuSortItem'
        ];
        return columnMenuItems;
    }, [
        props.sortingOrder,
        props.disableColumnSorting
    ]);
    /**
   * API METHODS
   */ const applySorting = $lCzvA.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (props.sortingMode === 'server') {
                logger.debug('Skipping sorting rows as sortingMode = server');
                return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                    sorting: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.sorting, {
                        sortedRows: (0, $dc4fe3453cdb0a0a$export$9380f4bcafb87e49)((0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef), (0, $dc4fe3453cdb0a0a$export$433b924dc2506913), false)
                    })
                });
            }
            const sortModel = (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9)(state, apiRef.current.instanceId);
            const sortRowList = (0, $840823b3251897df$export$b29e353d1a72dfda)(sortModel, apiRef);
            const sortedRows = apiRef.current.applyStrategyProcessor('sorting', {
                sortRowList: sortRowList
            });
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                sorting: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.sorting, {
                    sortedRows: sortedRows
                })
            });
        });
        apiRef.current.publishEvent('sortedRowsSet');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        props.sortingMode
    ]);
    const setSortModel = $lCzvA.useCallback((model)=>{
        const currentModel = (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting sort model`);
            apiRef.current.setState((0, $840823b3251897df$export$3fc28d475ac000c0)(model, props.disableMultipleColumnsSorting));
            apiRef.current.forceUpdate();
            apiRef.current.applySorting();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsSorting
    ]);
    const sortColumn = $lCzvA.useCallback((field, direction, allowMultipleSorting)=>{
        const column = apiRef.current.getColumn(field);
        const sortItem = createSortItem(column, direction);
        let sortModel;
        if (!allowMultipleSorting || props.disableMultipleColumnsSorting) sortModel = sortItem?.sort == null ? [] : [
            sortItem
        ];
        else sortModel = upsertSortModel(column.field, sortItem);
        apiRef.current.setSortModel(sortModel);
    }, [
        apiRef,
        upsertSortModel,
        createSortItem,
        props.disableMultipleColumnsSorting
    ]);
    const getSortModel = $lCzvA.useCallback(()=>(0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9)(apiRef), [
        apiRef
    ]);
    const getSortedRows = $lCzvA.useCallback(()=>{
        const sortedRows = (0, $32a7c18be453c9d5$export$8919e81647813e61)(apiRef);
        return sortedRows.map((row)=>row.model);
    }, [
        apiRef
    ]);
    const getSortedRowIds = $lCzvA.useCallback(()=>(0, $32a7c18be453c9d5$export$e4979ad0a2db8752)(apiRef), [
        apiRef
    ]);
    const getRowIdFromRowIndex = $lCzvA.useCallback((index)=>apiRef.current.getSortedRowIds()[index], [
        apiRef
    ]);
    const sortApi = {
        getSortModel: getSortModel,
        getSortedRows: getSortedRows,
        getSortedRowIds: getSortedRowIds,
        getRowIdFromRowIndex: getRowIdFromRowIndex,
        setSortModel: setSortModel,
        sortColumn: sortColumn,
        applySorting: applySorting
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, sortApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $lCzvA.useCallback((prevState, context)=>{
        const sortModelToExport = (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9)(apiRef);
        const shouldExportSortModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.sortModel != null || // Always export if the model has been initialized
        props.initialState?.sorting?.sortModel != null || // Export if the model is not empty
        sortModelToExport.length > 0;
        if (!shouldExportSortModel) return prevState;
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState, {
            sorting: {
                sortModel: sortModelToExport
            }
        });
    }, [
        apiRef,
        props.sortModel,
        props.initialState?.sorting?.sortModel
    ]);
    const stateRestorePreProcessing = $lCzvA.useCallback((params, context)=>{
        const sortModel = context.stateToRestore.sorting?.sortModel;
        if (sortModel == null) return params;
        apiRef.current.setState((0, $840823b3251897df$export$3fc28d475ac000c0)(sortModel, props.disableMultipleColumnsSorting));
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.applySorting
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsSorting
    ]);
    const flatSortingMethod = $lCzvA.useCallback((params)=>{
        const rowTree = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef);
        const rootGroupNode = rowTree[0, $dc4fe3453cdb0a0a$export$433b924dc2506913];
        const sortedChildren = params.sortRowList ? params.sortRowList(rootGroupNode.children.map((childId)=>rowTree[childId])) : [
            ...rootGroupNode.children
        ];
        if (rootGroupNode.footerId != null) sortedChildren.push(rootGroupNode.footerId);
        return sortedChildren;
    }, [
        apiRef
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(apiRef, (0, $8de9ab907b1743d2$export$84214fbf04c4094), 'sorting', flatSortingMethod);
    /**
   * EVENTS
   */ const handleColumnHeaderClick = $lCzvA.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        const allowMultipleSorting = event.shiftKey || event.metaKey || event.ctrlKey;
        sortColumn(field, undefined, allowMultipleSorting);
    }, [
        sortColumn,
        props.disableColumnSorting
    ]);
    const handleColumnHeaderKeyDown = $lCzvA.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        // Ctrl + Enter opens the column menu
        if (event.key === 'Enter' && !event.ctrlKey && !event.metaKey) sortColumn(field, undefined, event.shiftKey);
    }, [
        sortColumn,
        props.disableColumnSorting
    ]);
    const handleColumnsChange = $lCzvA.useCallback(()=>{
        // When the columns change we check that the sorted columns are still part of the dataset
        const sortModel = (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9)(apiRef);
        const latestColumns = (0, $8b99503000dd62d3$export$8a3a9a6db584d7fd)(apiRef);
        if (sortModel.length > 0) {
            const newModel = sortModel.filter((sortItem)=>latestColumns[sortItem.field]);
            if (newModel.length < sortModel.length) apiRef.current.setSortModel(newModel);
        }
    }, [
        apiRef
    ]);
    const handleStrategyProcessorChange = $lCzvA.useCallback((methodName)=>{
        if (methodName === 'sorting') apiRef.current.applySorting();
    }, [
        apiRef
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderClick', handleColumnHeaderClick);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowsSet', apiRef.current.applySorting);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    /**
   * 1ST RENDER
   */ (0, $9ebf8f53803465ea$export$c5623aa1c38918b6)(()=>{
        apiRef.current.applySorting();
    });
    /**
   * EFFECTS
   */ (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (props.sortModel !== undefined) apiRef.current.setSortModel(props.sortModel);
    }, [
        apiRef,
        props.sortModel
    ]);
};


var $lCzvA = parcelRequire("lCzvA");




function $19d987c51db7b6e0$var$sanitizeCellValue(value, csvOptions) {
    if (value === null || value === undefined) return '';
    const valueStr = typeof value === 'string' ? value : `${value}`;
    if (csvOptions.shouldAppendQuotes || csvOptions.escapeFormulas) {
        const escapedValue = valueStr.replace(/"/g, '""');
        if (csvOptions.escapeFormulas) {
            // See https://owasp.org/www-community/attacks/CSV_Injection
            if ([
                '=',
                '+',
                '-',
                '@',
                '\t',
                '\r'
            ].includes(escapedValue[0])) return `"'${escapedValue}"`;
        }
        // Make sure value containing delimiter or line break won't be split into multiple cells
        if ([
            csvOptions.delimiter,
            '\n',
            '\r',
            '"'
        ].some((delimiter)=>valueStr.includes(delimiter))) return `"${escapedValue}"`;
        return escapedValue;
    }
    return valueStr;
}
const $19d987c51db7b6e0$export$edda57d2a460473d = (cellParams, options)=>{
    const { csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter } = options;
    let value;
    if (ignoreValueFormatter) {
        const columnType = cellParams.colDef.type;
        if (columnType === 'number') value = String(cellParams.value);
        else if (columnType === 'date' || columnType === 'dateTime') value = cellParams.value?.toISOString();
        else if (typeof cellParams.value?.toString === 'function') value = cellParams.value.toString();
        else value = cellParams.value;
    } else value = cellParams.formattedValue;
    return $19d987c51db7b6e0$var$sanitizeCellValue(value, csvOptions);
};
class $19d987c51db7b6e0$var$CSVRow {
    constructor(options){
        this.options = void 0;
        this.rowString = '';
        this.isEmpty = true;
        this.options = options;
    }
    addValue(value) {
        if (!this.isEmpty) this.rowString += this.options.csvOptions.delimiter;
        if (typeof this.options.sanitizeCellValue === 'function') this.rowString += this.options.sanitizeCellValue(value, this.options.csvOptions);
        else this.rowString += value;
        this.isEmpty = false;
    }
    getRowString() {
        return this.rowString;
    }
}
const $19d987c51db7b6e0$var$serializeRow = ({ id: id, columns: columns, getCellParams: getCellParams, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter })=>{
    const row = new $19d987c51db7b6e0$var$CSVRow({
        csvOptions: csvOptions
    });
    columns.forEach((column)=>{
        const cellParams = getCellParams(id, column.field);
        row.addValue($19d987c51db7b6e0$export$edda57d2a460473d(cellParams, {
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        }));
    });
    return row.getRowString();
};
function $19d987c51db7b6e0$export$8bfbf32dccc29440(options) {
    const { columns: columns, rowIds: rowIds, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter, apiRef: apiRef } = options;
    const CSVBody = rowIds.reduce((acc, id)=>`${acc}${$19d987c51db7b6e0$var$serializeRow({
            id: id,
            columns: columns,
            getCellParams: apiRef.current.getCellParams,
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        })}\r\n`, '').trim();
    if (!csvOptions.includeHeaders) return CSVBody;
    const filteredColumns = columns.filter((column)=>column.field !== (0, $145aea3d0e493d77$export$b2e9ab6103a664ad).field);
    const headerRows = [];
    if (csvOptions.includeColumnGroupsHeaders) {
        const columnGroupLookup = apiRef.current.getAllGroupDetails();
        let maxColumnGroupsDepth = 0;
        const columnGroupPathsLookup = filteredColumns.reduce((acc, column)=>{
            const columnGroupPath = apiRef.current.getColumnGroupPath(column.field);
            acc[column.field] = columnGroupPath;
            maxColumnGroupsDepth = Math.max(maxColumnGroupsDepth, columnGroupPath.length);
            return acc;
        }, {});
        for(let i = 0; i < maxColumnGroupsDepth; i += 1){
            const headerGroupRow = new $19d987c51db7b6e0$var$CSVRow({
                csvOptions: csvOptions,
                sanitizeCellValue: $19d987c51db7b6e0$var$sanitizeCellValue
            });
            headerRows.push(headerGroupRow);
            filteredColumns.forEach((column)=>{
                const columnGroupId = (columnGroupPathsLookup[column.field] || [])[i];
                const columnGroup = columnGroupLookup[columnGroupId];
                headerGroupRow.addValue(columnGroup ? columnGroup.headerName || columnGroup.groupId : '');
            });
        }
    }
    const mainHeaderRow = new $19d987c51db7b6e0$var$CSVRow({
        csvOptions: csvOptions,
        sanitizeCellValue: $19d987c51db7b6e0$var$sanitizeCellValue
    });
    filteredColumns.forEach((column)=>{
        mainHeaderRow.addValue(column.headerName || column.field);
    });
    headerRows.push(mainHeaderRow);
    const CSVHead = `${headerRows.map((row)=>row.getRowString()).join('\r\n')}\r\n`;
    return `${CSVHead}${CSVBody}`.trim();
}



function $e3cc0dcfdf8bd711$var$writeToClipboardPolyfill(data) {
    const span = document.createElement('span');
    span.style.whiteSpace = 'pre';
    span.style.userSelect = 'all';
    span.style.opacity = '0px';
    span.textContent = data;
    document.body.appendChild(span);
    const range = document.createRange();
    range.selectNode(span);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    try {
        document.execCommand('copy');
    } finally{
        document.body.removeChild(span);
    }
}
function $e3cc0dcfdf8bd711$var$copyToClipboard(data) {
    if (navigator.clipboard) navigator.clipboard.writeText(data).catch(()=>{
        $e3cc0dcfdf8bd711$var$writeToClipboardPolyfill(data);
    });
    else $e3cc0dcfdf8bd711$var$writeToClipboardPolyfill(data);
}
function $e3cc0dcfdf8bd711$var$hasNativeSelection(element) {
    // When getSelection is called on an <iframe> that is not displayed Firefox will return null.
    if (window.getSelection()?.toString()) return true;
    // window.getSelection() returns an empty string in Firefox for selections inside a form element.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=85686.
    // Instead, we can use element.selectionStart that is only defined on form elements.
    if (element && (element.selectionEnd || 0) - (element.selectionStart || 0) > 0) return true;
    return false;
}
const $e3cc0dcfdf8bd711$export$a44b2f69ac6aef73 = (apiRef, props)=>{
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp?.clipboardExport : ignoreValueFormatterProp) || false;
    const clipboardCopyCellDelimiter = props.clipboardCopyCellDelimiter;
    const handleCopy = $lCzvA.useCallback((event)=>{
        if (!(0, $23fd0e5066a0f9a3$export$b3bab6a2e94206d4)(event)) return;
        // Do nothing if there's a native selection
        if ($e3cc0dcfdf8bd711$var$hasNativeSelection(event.target)) return;
        let textToCopy = '';
        const selectedRows = apiRef.current.getSelectedRows();
        if (selectedRows.size > 0) textToCopy = apiRef.current.getDataAsCsv({
            includeHeaders: false,
            delimiter: clipboardCopyCellDelimiter,
            shouldAppendQuotes: false,
            escapeFormulas: false
        });
        else {
            const focusedCell = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
            if (focusedCell) {
                const cellParams = apiRef.current.getCellParams(focusedCell.id, focusedCell.field);
                textToCopy = (0, $19d987c51db7b6e0$export$edda57d2a460473d)(cellParams, {
                    csvOptions: {
                        delimiter: clipboardCopyCellDelimiter,
                        shouldAppendQuotes: false,
                        escapeFormulas: false
                    },
                    ignoreValueFormatter: ignoreValueFormatter
                });
            }
        }
        textToCopy = apiRef.current.unstable_applyPipeProcessors('clipboardCopy', textToCopy);
        if (textToCopy) {
            $e3cc0dcfdf8bd711$var$copyToClipboard(textToCopy);
            apiRef.current.publishEvent('clipboardCopy', textToCopy);
        }
    }, [
        apiRef,
        ignoreValueFormatter,
        clipboardCopyCellDelimiter
    ]);
    (0, $7e0caf0e9aa4df92$export$265f4c39182036e)(apiRef, ()=>apiRef.current.rootElementRef.current, 'keydown', handleCopy);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'clipboardCopy', props.onClipboardCopy);
};


var $lCzvA = parcelRequire("lCzvA");


const $2a3a4a92424bde2f$export$ce7ce4871097b52e = (apiRef)=>{
    const lookup = $lCzvA.useRef({});
    const getCellColSpanInfo = (rowId, columnIndex)=>{
        return lookup.current[rowId]?.[columnIndex];
    };
    const resetColSpan = ()=>{
        lookup.current = {};
    };
    // Calculate `colSpan` for each cell in the row
    const calculateColSpan = $lCzvA.useCallback(({ rowId: rowId, minFirstColumn: minFirstColumn, maxLastColumn: maxLastColumn, columns: columns })=>{
        for(let i = minFirstColumn; i < maxLastColumn; i += 1){
            const cellProps = $2a3a4a92424bde2f$var$calculateCellColSpan({
                apiRef: apiRef,
                lookup: lookup.current,
                columnIndex: i,
                rowId: rowId,
                minFirstColumnIndex: minFirstColumn,
                maxLastColumnIndex: maxLastColumn,
                columns: columns
            });
            if (cellProps.colSpan > 1) i += cellProps.colSpan - 1;
        }
    }, [
        apiRef
    ]);
    const columnSpanningPublicApi = {
        unstable_getCellColSpanInfo: getCellColSpanInfo
    };
    const columnSpanningPrivateApi = {
        resetColSpan: resetColSpan,
        calculateColSpan: calculateColSpan
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, columnSpanningPublicApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, columnSpanningPrivateApi, 'private');
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnOrderChange', resetColSpan);
};
function $2a3a4a92424bde2f$var$calculateCellColSpan(params) {
    const { apiRef: apiRef, lookup: lookup, columnIndex: columnIndex, rowId: rowId, minFirstColumnIndex: minFirstColumnIndex, maxLastColumnIndex: maxLastColumnIndex, columns: columns } = params;
    const columnsLength = columns.length;
    const column = columns[columnIndex];
    const row = apiRef.current.getRow(rowId);
    const value = apiRef.current.getRowValue(row, column);
    const colSpan = typeof column.colSpan === 'function' ? column.colSpan(value, row, column, apiRef) : column.colSpan;
    if (!colSpan || colSpan === 1) {
        $2a3a4a92424bde2f$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: 1,
                width: column.computedWidth
            }
        });
        return {
            colSpan: 1
        };
    }
    let width = column.computedWidth;
    for(let j = 1; j < colSpan; j += 1){
        const nextColumnIndex = columnIndex + j;
        // Cells should be spanned only within their column section (left-pinned, right-pinned and unpinned).
        if (nextColumnIndex >= minFirstColumnIndex && nextColumnIndex < maxLastColumnIndex) {
            const nextColumn = columns[nextColumnIndex];
            width += nextColumn.computedWidth;
            $2a3a4a92424bde2f$var$setCellColSpanInfo(lookup, rowId, columnIndex + j, {
                spannedByColSpan: true,
                rightVisibleCellIndex: Math.min(columnIndex + colSpan, columnsLength - 1),
                leftVisibleCellIndex: columnIndex
            });
        }
        $2a3a4a92424bde2f$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: colSpan,
                width: width
            }
        });
    }
    return {
        colSpan: colSpan
    };
}
function $2a3a4a92424bde2f$var$setCellColSpanInfo(lookup, rowId, columnIndex, cellColSpanInfo) {
    if (!lookup[rowId]) lookup[rowId] = {};
    lookup[rowId][columnIndex] = cellColSpanInfo;
}


var $lCzvA = parcelRequire("lCzvA");


/**
 * I have hesitated to use https://github.com/eligrey/FileSaver.js.
 * If we get bug reports that this project solves, we should consider using it.
 *
 * Related resources.
 * https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
 * https://github.com/mbrn/filefy/blob/ec4ed0b7415d93be7158c23029f2ea1fa0b8e2d9/src/core/BaseBuilder.ts
 * https://unpkg.com/browse/@progress/kendo-file-saver@1.0.7/dist/es/save-as.js
 * https://github.com/ag-grid/ag-grid/blob/9565c219b6210aa85fa833c929d0728f9d163a91/community-modules/csv-export/src/csvExport/downloader.ts
 */ function $b1f70dbcc39a6087$export$f95aebe89510930(blob, extension = 'csv', filename = document.title || 'untitled') {
    const fullName = `${filename}.${extension}`;
    // Test download attribute first
    // https://github.com/eligrey/FileSaver.js/issues/193
    if ('download' in HTMLAnchorElement.prototype) {
        // Create an object URL for the blob object
        const url = URL.createObjectURL(blob);
        // Create a new anchor element
        const a = document.createElement('a');
        a.href = url;
        a.download = fullName;
        // Programmatically trigger a click on the anchor element
        // Useful if you want the download to happen automatically
        // Without attaching the anchor element to the DOM
        a.click();
        // https://github.com/eligrey/FileSaver.js/issues/205
        setTimeout(()=>{
            URL.revokeObjectURL(url);
        });
        return;
    }
    throw new Error('MUI X: exportAs not supported.');
}






const $aead2171337889e5$export$c5c7f3bb5f79a15d = ({ apiRef: apiRef, options: options })=>{
    const columns = (0, $8b99503000dd62d3$export$da85f06e3c19f1fd)(apiRef);
    if (options.fields) return options.fields.reduce((currentColumns, field)=>{
        const column = columns.find((col)=>col.field === field);
        if (column) currentColumns.push(column);
        return currentColumns;
    }, []);
    const validColumns = options.allColumns ? columns : (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef);
    return validColumns.filter((column)=>!column.disableExport);
};
const $aead2171337889e5$export$99156d1572dee776 = ({ apiRef: apiRef })=>{
    const filteredSortedRowIds = (0, $6450fc0917754b27$export$4e2a9d76902d271c)(apiRef);
    const rowTree = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef);
    const selectedRows = apiRef.current.getSelectedRows();
    const bodyRows = filteredSortedRowIds.filter((id)=>rowTree[id].type !== 'footer');
    const pinnedRows = (0, $68327dddce1a2c68$export$ffe7071c481e32b0)(apiRef);
    const topPinnedRowsIds = pinnedRows?.top?.map((row)=>row.id) || [];
    const bottomPinnedRowsIds = pinnedRows?.bottom?.map((row)=>row.id) || [];
    bodyRows.unshift(...topPinnedRowsIds);
    bodyRows.push(...bottomPinnedRowsIds);
    if (selectedRows.size > 0) return bodyRows.filter((id)=>selectedRows.has(id));
    return bodyRows;
};






var $lCzvA = parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");














function $28107da7c34c37f3$export$46f01d01378ec5a2(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiDivider', slot);
}
const $28107da7c34c37f3$var$dividerClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $28107da7c34c37f3$export$2e2bcd8739ae039 = $28107da7c34c37f3$var$dividerClasses;




function $e508314fa311b36a$export$81478e24460c57f2(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiListItemIcon', slot);
}
const $e508314fa311b36a$var$listItemIconClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $e508314fa311b36a$export$2e2bcd8739ae039 = $e508314fa311b36a$var$listItemIconClasses;




function $2417c763e8493ffe$export$1061006a0db3aeb5(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiListItemText', slot);
}
const $2417c763e8493ffe$var$listItemTextClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $2417c763e8493ffe$export$2e2bcd8739ae039 = $2417c763e8493ffe$var$listItemTextClasses;




function $9b71c1f0eeffec96$export$515f8c67b5305377(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiMenuItem', slot);
}
const $9b71c1f0eeffec96$var$menuItemClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $9b71c1f0eeffec96$export$2e2bcd8739ae039 = $9b71c1f0eeffec96$var$menuItemClasses;



'use client';
const $4f588ce7a0f72144$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $4f588ce7a0f72144$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $9b71c1f0eeffec96$export$515f8c67b5305377), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $4f588ce7a0f72144$var$MenuItemRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $e04b8c42a017212a$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $be3f20df888d18ba$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $4f588ce7a0f72144$export$4334bb34c76fef24
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $9b71c1f0eeffec96$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $9b71c1f0eeffec96$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $9b71c1f0eeffec96$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $9b71c1f0eeffec96$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $9b71c1f0eeffec96$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $28107da7c34c37f3$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $28107da7c34c37f3$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $2417c763e8493ffe$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $2417c763e8493ffe$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $e508314fa311b36a$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $e508314fa311b36a$export$2e2bcd8739ae039).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $4f588ce7a0f72144$var$MenuItem = /*#__PURE__*/ $lCzvA.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $lCzvA.useContext((0, $e08a4bc46b69b6f7$export$2e2bcd8739ae039));
    const childContext = $lCzvA.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $lCzvA.useRef(null);
    (0, $1bc2b909266b2e14$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $4f588ce7a0f72144$var$useUtilityClasses(props);
    const handleRef = (0, $ade5ac70196d775c$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e08a4bc46b69b6f7$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($4f588ce7a0f72144$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $4f588ce7a0f72144$export$2e2bcd8739ae039 = $4f588ce7a0f72144$var$MenuItem;






var $lCzvA = parcelRequire("lCzvA");










const $40e2756f612be392$export$9c3c7dbe6f1101cf = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridToolbarExportContainer(props, ref) {
    const { children: children, slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const exportButtonId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const exportMenuId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const [open, setOpen] = $lCzvA.useState(false);
    const buttonRef = $lCzvA.useRef(null);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(ref, buttonRef);
    const handleMenuOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        buttonProps.onClick?.(event);
    };
    const handleMenuClose = ()=>setOpen(false);
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if ((0, $23fd0e5066a0f9a3$export$81301abbcd0c8143)(event.key)) handleMenuClose();
    };
    if (children == null) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseTooltip, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                title: apiRef.current.getLocaleText('toolbarExportLabel'),
                enterDelay: 1000
            }, rootProps.slotProps?.baseTooltip, tooltipProps, {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                    size: "small",
                    startIcon: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.exportIcon, {}),
                    "aria-expanded": open,
                    "aria-label": apiRef.current.getLocaleText('toolbarExportLabel'),
                    "aria-haspopup": "menu",
                    "aria-controls": open ? exportMenuId : undefined,
                    id: exportButtonId
                }, rootProps.slotProps?.baseButton, buttonProps, {
                    onClick: handleMenuOpen,
                    ref: handleRef,
                    children: apiRef.current.getLocaleText('toolbarExport')
                }))
            })),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $eff079abbf7a8831$export$237948c71948075), {
                open: open,
                target: buttonRef.current,
                onClose: handleMenuClose,
                position: "bottom-start",
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e6048ea6ffd35fc1$export$2e2bcd8739ae039), {
                    id: exportMenuId,
                    className: (0, $786c119d9add6b61$export$2100d54e36406477).menuList,
                    "aria-labelledby": exportButtonId,
                    onKeyDown: handleListKeyDown,
                    autoFocusItem: open,
                    children: $lCzvA.Children.map(children, (child)=>{
                        if (!/*#__PURE__*/ $lCzvA.isValidElement(child)) return child;
                        return /*#__PURE__*/ $lCzvA.cloneElement(child, {
                            hideMenu: handleMenuClose
                        });
                    })
                })
            })
        ]
    });
});



const $e0adf91930b83273$var$_excluded = [
    "hideMenu",
    "options"
], $e0adf91930b83273$var$_excluded2 = [
    "hideMenu",
    "options"
], $e0adf91930b83273$var$_excluded3 = [
    "csvOptions",
    "printOptions",
    "excelOptions"
];
function $e0adf91930b83273$export$c0e66088a5c9ffbf(props) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $e0adf91930b83273$var$_excluded);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        onClick: ()=>{
            apiRef.current.exportDataAsCsv(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportCSV')
    }));
}
function $e0adf91930b83273$export$a6cd094b30f69b92(props) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $e0adf91930b83273$var$_excluded2);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        onClick: ()=>{
            apiRef.current.exportDataAsPrint(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportPrint')
    }));
}
const $e0adf91930b83273$export$ef68b449b329deb5 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridToolbarExport(props, ref) {
    const _ref = props, { csvOptions: csvOptions = {}, printOptions: printOptions = {}, excelOptions: excelOptions } = _ref, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_ref, $e0adf91930b83273$var$_excluded3);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors('exportMenu', [], {
        excelOptions: excelOptions,
        csvOptions: csvOptions,
        printOptions: printOptions
    }).sort((a, b)=>a.componentName > b.componentName ? 1 : -1);
    if (preProcessedButtons.length === 0) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $40e2756f612be392$export$9c3c7dbe6f1101cf), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, other, {
        ref: ref,
        children: preProcessedButtons.map((button, index)=>/*#__PURE__*/ $lCzvA.cloneElement(button.component, {
                key: index
            }))
    }));
});



const $70c425efce79965d$export$6178dbab26611702 = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridCsvExport');
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp?.csvExport : ignoreValueFormatterProp) || false;
    const getDataAsCsv = $lCzvA.useCallback((options = {})=>{
        logger.debug(`Get data as CSV`);
        const exportedColumns = (0, $aead2171337889e5$export$c5c7f3bb5f79a15d)({
            apiRef: apiRef,
            options: options
        });
        const getRowsToExport = options.getRowsToExport ?? (0, $aead2171337889e5$export$99156d1572dee776);
        const exportedRowIds = getRowsToExport({
            apiRef: apiRef
        });
        return (0, $19d987c51db7b6e0$export$8bfbf32dccc29440)({
            columns: exportedColumns,
            rowIds: exportedRowIds,
            csvOptions: {
                delimiter: options.delimiter || ',',
                shouldAppendQuotes: options.shouldAppendQuotes ?? true,
                includeHeaders: options.includeHeaders ?? true,
                includeColumnGroupsHeaders: options.includeColumnGroupsHeaders ?? true,
                escapeFormulas: options.escapeFormulas ?? true
            },
            ignoreValueFormatter: ignoreValueFormatter,
            apiRef: apiRef
        });
    }, [
        logger,
        apiRef,
        ignoreValueFormatter
    ]);
    const exportDataAsCsv = $lCzvA.useCallback((options)=>{
        logger.debug(`Export data as CSV`);
        const csv = getDataAsCsv(options);
        const blob = new Blob([
            options?.utf8WithBom ? new Uint8Array([
                0xef,
                0xbb,
                0xbf
            ]) : '',
            csv
        ], {
            type: 'text/csv'
        });
        (0, $b1f70dbcc39a6087$export$f95aebe89510930)(blob, 'csv', options?.fileName);
    }, [
        logger,
        getDataAsCsv
    ]);
    const csvExportApi = {
        getDataAsCsv: getDataAsCsv,
        exportDataAsCsv: exportDataAsCsv
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, csvExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $lCzvA.useCallback((initialValue, options)=>{
        if (options.csvOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e0adf91930b83273$export$c0e66088a5c9ffbf), {
                    options: options.csvOptions
                }),
                componentName: 'csvExport'
            }
        ];
    }, []);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'exportMenu', addExportMenuButtons);
};


function $cea9d2b318bcdc99$export$8456f443918812d4(apiRef, props) {
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'columnHeaderClick', props.onColumnHeaderClick);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'columnHeaderContextMenu', props.onColumnHeaderContextMenu);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'columnHeaderDoubleClick', props.onColumnHeaderDoubleClick);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'columnHeaderOver', props.onColumnHeaderOver);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'columnHeaderOut', props.onColumnHeaderOut);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'columnHeaderEnter', props.onColumnHeaderEnter);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'columnHeaderLeave', props.onColumnHeaderLeave);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'cellClick', props.onCellClick);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'cellDoubleClick', props.onCellDoubleClick);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'cellKeyDown', props.onCellKeyDown);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'preferencePanelClose', props.onPreferencePanelClose);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'preferencePanelOpen', props.onPreferencePanelOpen);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'menuOpen', props.onMenuOpen);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'menuClose', props.onMenuClose);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'rowDoubleClick', props.onRowDoubleClick);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'rowClick', props.onRowClick);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'stateChange', props.onStateChange);
}


var $lCzvA = parcelRequire("lCzvA");
const $8596a450ef471806$export$9f7c27985c4a3681 = (apiRef)=>{
    const rootElementRef = $lCzvA.useRef(null);
    const mainElementRef = $lCzvA.useRef(null);
    const virtualScrollerRef = $lCzvA.useRef(null);
    const virtualScrollbarVerticalRef = $lCzvA.useRef(null);
    const virtualScrollbarHorizontalRef = $lCzvA.useRef(null);
    const columnHeadersContainerRef = $lCzvA.useRef(null);
    apiRef.current.register('public', {
        rootElementRef: rootElementRef
    });
    apiRef.current.register('private', {
        mainElementRef: mainElementRef,
        virtualScrollerRef: virtualScrollerRef,
        virtualScrollbarVerticalRef: virtualScrollbarVerticalRef,
        virtualScrollbarHorizontalRef: virtualScrollbarHorizontalRef,
        columnHeadersContainerRef: columnHeadersContainerRef
    });
};




var $lCzvA = parcelRequire("lCzvA");

const $e63df6b519058298$export$f9172a9d6b7b2acd = (apiRef)=>{
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    if (apiRef.current.state.isRtl === undefined) apiRef.current.state.isRtl = isRtl;
    const isFirstEffect = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (isFirstEffect.current) isFirstEffect.current = false;
        else apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                isRtl: isRtl
            }));
    }, [
        apiRef,
        isRtl
    ]);
};



var $lCzvA = parcelRequire("lCzvA");


const $26a59b3d5ed41705$var$forceDebug = (0, $ac3bd7253ec0e92a$export$c43914e0cb16a981)() && window.localStorage.getItem('DEBUG') != null;
const $26a59b3d5ed41705$var$noop = ()=>{};
const $26a59b3d5ed41705$var$noopLogger = {
    debug: $26a59b3d5ed41705$var$noop,
    info: $26a59b3d5ed41705$var$noop,
    warn: $26a59b3d5ed41705$var$noop,
    error: $26a59b3d5ed41705$var$noop
};
const $26a59b3d5ed41705$var$LOG_LEVELS = [
    'debug',
    'info',
    'warn',
    'error'
];
function $26a59b3d5ed41705$var$getAppender(name, logLevel, appender = console) {
    const minLogLevelIdx = $26a59b3d5ed41705$var$LOG_LEVELS.indexOf(logLevel);
    if (minLogLevelIdx === -1) throw new Error(`MUI X: Log level ${logLevel} not recognized.`);
    const logger = $26a59b3d5ed41705$var$LOG_LEVELS.reduce((loggerObj, method, idx)=>{
        if (idx >= minLogLevelIdx) loggerObj[method] = (...args)=>{
            const [message, ...other] = args;
            appender[method](`MUI X: ${name} - ${message}`, ...other);
        };
        else loggerObj[method] = $26a59b3d5ed41705$var$noop;
        return loggerObj;
    }, {});
    return logger;
}
const $26a59b3d5ed41705$export$db6c72f4003d67df = (apiRef, props)=>{
    const getLogger = $lCzvA.useCallback((name)=>{
        if ($26a59b3d5ed41705$var$forceDebug) return $26a59b3d5ed41705$var$getAppender(name, 'debug', props.logger);
        if (!props.logLevel) return $26a59b3d5ed41705$var$noopLogger;
        return $26a59b3d5ed41705$var$getAppender(name, props.logLevel.toString(), props.logger);
    }, [
        props.logLevel,
        props.logger
    ]);
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, {
        getLogger: getLogger
    }, 'private');
};



var $lCzvA = parcelRequire("lCzvA");
// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $d25095c5b0131205$export$cc74486daaaef499 {
    constructor(){
        this.maxListeners = 20;
        this.warnOnce = false;
        this.events = {};
    }
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}


class $33d03eb7ba7838a2$export$390f32400eaf98c9 {
    static create(value) {
        return new $33d03eb7ba7838a2$export$390f32400eaf98c9(value);
    }
    constructor(_value){
        this.value = void 0;
        this.listeners = void 0;
        this.subscribe = (fn)=>{
            this.listeners.add(fn);
            return ()=>{
                this.listeners.delete(fn);
            };
        };
        this.getSnapshot = ()=>{
            return this.value;
        };
        this.update = (value)=>{
            this.value = value;
            this.listeners.forEach((l)=>l(value));
        };
        this.value = _value;
        this.listeners = new Set();
    }
}




const $ceaa7364a602ee91$var$SYMBOL_API_PRIVATE = Symbol('mui.api_private');
const $ceaa7364a602ee91$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
function $ceaa7364a602ee91$export$37686f243ec62a21(publicApi) {
    return publicApi[$ceaa7364a602ee91$var$SYMBOL_API_PRIVATE];
}
let $ceaa7364a602ee91$var$globalId = 0;
function $ceaa7364a602ee91$var$createPrivateAPI(publicApiRef) {
    const existingPrivateApi = publicApiRef.current?.[$ceaa7364a602ee91$var$SYMBOL_API_PRIVATE];
    if (existingPrivateApi) return existingPrivateApi;
    const state = {};
    const privateApi = {
        state: state,
        store: (0, $33d03eb7ba7838a2$export$390f32400eaf98c9).create(state),
        instanceId: {
            id: $ceaa7364a602ee91$var$globalId
        }
    };
    $ceaa7364a602ee91$var$globalId += 1;
    privateApi.getPublicApi = ()=>publicApiRef.current;
    privateApi.register = (visibility, methods)=>{
        Object.keys(methods).forEach((methodName)=>{
            const method = methods[methodName];
            const currentPrivateMethod = privateApi[methodName];
            if (currentPrivateMethod?.spying === true) currentPrivateMethod.target = method;
            else privateApi[methodName] = method;
            if (visibility === 'public') {
                const publicApi = publicApiRef.current;
                const currentPublicMethod = publicApi[methodName];
                if (currentPublicMethod?.spying === true) currentPublicMethod.target = method;
                else publicApi[methodName] = method;
            }
        });
    };
    privateApi.register('private', {
        caches: {},
        eventManager: new (0, $d25095c5b0131205$export$cc74486daaaef499)()
    });
    return privateApi;
}
function $ceaa7364a602ee91$var$createPublicAPI(privateApiRef) {
    const publicApi = {
        get state () {
            return privateApiRef.current.state;
        },
        get store () {
            return privateApiRef.current.store;
        },
        get instanceId () {
            return privateApiRef.current.instanceId;
        },
        [$ceaa7364a602ee91$var$SYMBOL_API_PRIVATE]: privateApiRef.current
    };
    return publicApi;
}
function $ceaa7364a602ee91$export$72d4a6c5ec1a4b32(inputApiRef, props) {
    const publicApiRef = $lCzvA.useRef(null);
    const privateApiRef = $lCzvA.useRef(null);
    if (!privateApiRef.current) privateApiRef.current = $ceaa7364a602ee91$var$createPrivateAPI(publicApiRef);
    if (!publicApiRef.current) publicApiRef.current = $ceaa7364a602ee91$var$createPublicAPI(privateApiRef);
    const publishEvent = $lCzvA.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($ceaa7364a602ee91$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        const details = props.signature === (0, $ecad0fba09446fc0$export$544be0bdf85b5af1).DataGridPro || props.signature === (0, $ecad0fba09446fc0$export$544be0bdf85b5af1).DataGridPremium ? {
            api: privateApiRef.current.getPublicApi()
        } : {};
        privateApiRef.current.eventManager.emit(name, params, event, details);
    }, [
        privateApiRef,
        props.signature
    ]);
    const subscribeEvent = $lCzvA.useCallback((event, handler, options)=>{
        privateApiRef.current.eventManager.on(event, handler, options);
        const api = privateApiRef.current;
        return ()=>{
            api.eventManager.removeListener(event, handler);
        };
    }, [
        privateApiRef
    ]);
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(privateApiRef, {
        subscribeEvent: subscribeEvent,
        publishEvent: publishEvent
    }, 'public');
    if (inputApiRef && !inputApiRef.current?.state) inputApiRef.current = publicApiRef.current;
    $lCzvA.useImperativeHandle(inputApiRef, ()=>publicApiRef.current, [
        publicApiRef
    ]);
    $lCzvA.useEffect(()=>{
        const api = privateApiRef.current;
        return ()=>{
            api.publishEvent('unmount');
        };
    }, [
        privateApiRef
    ]);
    return privateApiRef;
}



var $lCzvA = parcelRequire("lCzvA");
const $79826a5571d0e704$export$9943f2ed4ddf85bf = (apiRef, props)=>{
    const getLocaleText = $lCzvA.useCallback((key)=>{
        if (props.localeText[key] == null) throw new Error(`Missing translation for key ${key}.`);
        return props.localeText[key];
    }, [
        props.localeText
    ]);
    apiRef.current.register('public', {
        getLocaleText: getLocaleText
    });
};





var $lCzvA = parcelRequire("lCzvA");

const $f997fc47a570ef45$export$1c5794e7ed1dc58f = (apiRef)=>{
    const cache = $lCzvA.useRef({});
    const isRunning = $lCzvA.useRef(false);
    const runAppliers = $lCzvA.useCallback((groupCache)=>{
        if (isRunning.current || !groupCache) return;
        isRunning.current = true;
        Object.values(groupCache.appliers).forEach((callback)=>{
            callback();
        });
        isRunning.current = false;
    }, []);
    const registerPipeProcessor = $lCzvA.useCallback((group, id, processor)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {}
        };
        const groupCache = cache.current[group];
        const oldProcessor = groupCache.processors.get(id);
        if (oldProcessor !== processor) {
            groupCache.processors.set(id, processor);
            groupCache.processorsAsArray = Array.from(cache.current[group].processors.values()).filter((processorValue)=>processorValue !== null);
            runAppliers(groupCache);
        }
        return ()=>{
            cache.current[group].processors.set(id, null);
            cache.current[group].processorsAsArray = Array.from(cache.current[group].processors.values()).filter((processorValue)=>processorValue !== null);
        };
    }, [
        runAppliers
    ]);
    const registerPipeApplier = $lCzvA.useCallback((group, id, applier)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {}
        };
        cache.current[group].appliers[id] = applier;
        return ()=>{
            const _appliers = cache.current[group].appliers, otherAppliers = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_appliers, [
                id
            ].map((0, $bb90ae25267601e8$export$2e2bcd8739ae039)));
            cache.current[group].appliers = otherAppliers;
        };
    }, []);
    const requestPipeProcessorsApplication = $lCzvA.useCallback((group)=>{
        runAppliers(cache.current[group]);
    }, [
        runAppliers
    ]);
    const applyPipeProcessors = $lCzvA.useCallback((...args)=>{
        const [group, value, context] = args;
        if (!cache.current[group]) return value;
        const processors = cache.current[group].processorsAsArray;
        let result = value;
        for(let i = 0; i < processors.length; i += 1)result = processors[i](result, context);
        return result;
    }, []);
    const preProcessingPrivateApi = {
        registerPipeProcessor: registerPipeProcessor,
        registerPipeApplier: registerPipeApplier,
        requestPipeProcessorsApplication: requestPipeProcessorsApplication
    };
    const preProcessingPublicApi = {
        unstable_applyPipeProcessors: applyPipeProcessors
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, preProcessingPrivateApi, 'private');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, preProcessingPublicApi, 'public');
};





var $lCzvA = parcelRequire("lCzvA");


const $930e9b7817e56523$export$53c7ec825c1e4d3f = (apiRef)=>{
    const controlStateMapRef = $lCzvA.useRef({});
    const registerControlState = $lCzvA.useCallback((controlStateItem)=>{
        controlStateMapRef.current[controlStateItem.stateId] = controlStateItem;
    }, []);
    const setState = $lCzvA.useCallback((state, reason)=>{
        let newState;
        if ((0, $ac3bd7253ec0e92a$export$f6e2535fb5126e54)(state)) newState = state(apiRef.current.state);
        else newState = state;
        if (apiRef.current.state === newState) return false;
        let ignoreSetState = false;
        // Apply the control state constraints
        const updatedControlStateIds = [];
        Object.keys(controlStateMapRef.current).forEach((stateId)=>{
            const controlState = controlStateMapRef.current[stateId];
            const oldSubState = controlState.stateSelector(apiRef.current.state, apiRef.current.instanceId);
            const newSubState = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (newSubState === oldSubState) return;
            updatedControlStateIds.push({
                stateId: controlState.stateId,
                hasPropChanged: newSubState !== controlState.propModel
            });
            // The state is controlled, the prop should always win
            if (controlState.propModel !== undefined && newSubState !== controlState.propModel) ignoreSetState = true;
        });
        if (updatedControlStateIds.length > 1) // Each hook modify its own state, and it should not leak
        // Events are here to forward to other hooks and apply changes.
        // You are trying to update several states in a no isolated way.
        throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${updatedControlStateIds[0].stateId}, therefore, you're not allowed to update ${updatedControlStateIds.map((el)=>el.stateId).join(', ')} in the same transaction.`);
        if (!ignoreSetState) {
            // We always assign it as we mutate rows for perf reason.
            apiRef.current.state = newState;
            apiRef.current.publishEvent('stateChange', newState);
            apiRef.current.store.update(newState);
        }
        if (updatedControlStateIds.length === 1) {
            const { stateId: stateId, hasPropChanged: hasPropChanged } = updatedControlStateIds[0];
            const controlState = controlStateMapRef.current[stateId];
            const model = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (controlState.propOnChange && hasPropChanged) controlState.propOnChange(model, {
                reason: reason,
                api: apiRef.current
            });
            if (!ignoreSetState) apiRef.current.publishEvent(controlState.changeEvent, model, {
                reason: reason
            });
        }
        return !ignoreSetState;
    }, [
        apiRef
    ]);
    const updateControlState = $lCzvA.useCallback((key, state, reason)=>{
        return apiRef.current.setState((previousState)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, previousState, {
                [key]: state(previousState[key])
            });
        }, reason);
    }, [
        apiRef
    ]);
    const forceUpdate = $lCzvA.useCallback(()=>{
    // @deprecated - do nothing
    }, []);
    const publicStateApi = {
        setState: setState,
        forceUpdate: forceUpdate
    };
    const privateStateApi = {
        updateControlState: updateControlState,
        registerControlState: registerControlState
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, publicStateApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, privateStateApi, 'private');
};



const $a4a05b7ba93b75de$export$b77462c86b28bbf0 = (inputApiRef, props)=>{
    const privateApiRef = (0, $ceaa7364a602ee91$export$72d4a6c5ec1a4b32)(inputApiRef, props);
    (0, $8596a450ef471806$export$9f7c27985c4a3681)(privateApiRef);
    (0, $94bdb7e9d13ae4d8$export$38bbfdfacac6e6c2)(privateApiRef, props);
    (0, $e63df6b519058298$export$f9172a9d6b7b2acd)(privateApiRef);
    (0, $26a59b3d5ed41705$export$db6c72f4003d67df)(privateApiRef, props);
    (0, $930e9b7817e56523$export$53c7ec825c1e4d3f)(privateApiRef);
    (0, $f997fc47a570ef45$export$1c5794e7ed1dc58f)(privateApiRef);
    (0, $8de9ab907b1743d2$export$594711f8e5fa9b04)(privateApiRef);
    (0, $79826a5571d0e704$export$9943f2ed4ddf85bf)(privateApiRef, props);
    privateApiRef.current.register('private', {
        rootProps: props
    });
    return privateApiRef;
};


var $lCzvA = parcelRequire("lCzvA");
const $de64e767ade13fa3$export$f9587d613f2caeec = (initializer, privateApiRef, props)=>{
    const isInitialized = $lCzvA.useRef(false);
    if (!isInitialized.current) {
        privateApiRef.current.state = initializer(privateApiRef.current.state, props, privateApiRef);
        isInitialized.current = true;
    }
};


var $lCzvA = parcelRequire("lCzvA");



const $d8d5f51ee5caf0c3$export$2c704fed6d7c53ee = (groupingColDefField)=>{
    const match = groupingColDefField.match(/^__row_group_by_columns_group_(.*)__$/);
    if (!match) return null;
    return match[1];
};
const $d8d5f51ee5caf0c3$export$452ffe3c6554619d = (field)=>field === (0, $3cb6fcdeb46bf88d$export$bc5b5ba34587442e) || $d8d5f51ee5caf0c3$export$2c704fed6d7c53ee(field) !== null;

















const $c40c5cb5d52ee6a6$export$7c625e86ddfff1ed = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, isRtl: isRtl })=>{
    if (isRtl) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    } else if (!isRtl) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    }
    return null;
};
const $c40c5cb5d52ee6a6$export$21527d4fb6084929 = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, isRtl: isRtl })=>{
    if (isRtl) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    } else if (!isRtl) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    }
    return null;
};
function $c40c5cb5d52ee6a6$export$d48a7b476a2f0ae5(apiRef, rowId, field, rowSpanScanDirection) {
    const rowSpanHiddenCells = (0, $cf3aae06b42627ec$export$229eb2b26df25c76)(apiRef);
    if (!rowSpanHiddenCells[rowId]?.[field]) return rowId;
    const filteredSortedRowIds = (0, $6450fc0917754b27$export$4e2a9d76902d271c)(apiRef);
    // find closest non row spanned cell in the given `rowSpanScanDirection`
    let nextRowIndex = filteredSortedRowIds.indexOf(rowId) + (rowSpanScanDirection === 'down' ? 1 : -1);
    while(nextRowIndex >= 0 && nextRowIndex < filteredSortedRowIds.length){
        const nextRowId = filteredSortedRowIds[nextRowIndex];
        if (!rowSpanHiddenCells[nextRowId]?.[field]) return nextRowId;
        nextRowIndex += rowSpanScanDirection === 'down' ? 1 : -1;
    }
    return rowId;
}






const $29324abe0b682926$var$gridVisibleRowsWithPinnedRowsSelector = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)((0, $017d03038815cc56$export$33f627fc0fc60be4), (0, $68327dddce1a2c68$export$ffe7071c481e32b0), (visibleRows, pinnedRows)=>{
    return (pinnedRows.top || []).concat(visibleRows.rows, pinnedRows.bottom || []);
});
const $29324abe0b682926$export$142b8bb1fe6da473 = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridKeyboardNavigation');
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const listView = props.unstable_listView;
    const getCurrentPageRows = $lCzvA.useCallback(()=>{
        return $29324abe0b682926$var$gridVisibleRowsWithPinnedRowsSelector(apiRef);
    }, [
        apiRef
    ]);
    const headerFilteringEnabled = props.signature !== 'DataGrid' && props.headerFilters;
    /**
   * @param {number} colIndex Index of the column to focus
   * @param {GridRowId} rowId index of the row to focus
   * @param {string} closestColumnToUse Which closest column cell to use when the cell is spanned by `colSpan`.
   * @param {string} rowSpanScanDirection Which direction to search to find the next cell not hidden by `rowSpan`.
   * TODO replace with apiRef.current.moveFocusToRelativeCell()
   */ const goToCell = $lCzvA.useCallback((colIndex, rowId, closestColumnToUse = 'left', rowSpanScanDirection = 'up')=>{
        const visibleSortedRows = (0, $6450fc0917754b27$export$2f31562143a3e5d4)(apiRef);
        const nextCellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, colIndex);
        if (nextCellColSpanInfo && nextCellColSpanInfo.spannedByColSpan) {
            if (closestColumnToUse === 'left') colIndex = nextCellColSpanInfo.leftVisibleCellIndex;
            else if (closestColumnToUse === 'right') colIndex = nextCellColSpanInfo.rightVisibleCellIndex;
        }
        const field = listView ? (0, $a014507b13bf83e2$export$aeeda57ada9bc1ee)(apiRef.current.state).field : (0, $8b99503000dd62d3$export$c9491722e1d6e8d3)(apiRef)[colIndex];
        const nonRowSpannedRowId = (0, $c40c5cb5d52ee6a6$export$d48a7b476a2f0ae5)(apiRef, rowId, field, rowSpanScanDirection);
        // `scrollToIndexes` requires a rowIndex relative to all visible rows.
        // Those rows do not include pinned rows, but pinned rows do not need scroll anyway.
        const rowIndexRelativeToAllRows = visibleSortedRows.findIndex((row)=>row.id === nonRowSpannedRowId);
        logger.debug(`Navigating to cell row ${rowIndexRelativeToAllRows}, col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex,
            rowIndex: rowIndexRelativeToAllRows
        });
        apiRef.current.setCellFocus(nonRowSpannedRowId, field);
    }, [
        apiRef,
        logger,
        listView
    ]);
    const goToHeader = $lCzvA.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToHeaderFilter = $lCzvA.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header filter col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFilterFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToGroupHeader = $lCzvA.useCallback((colIndex, depth, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const { field: field } = apiRef.current.getVisibleColumns()[colIndex];
        apiRef.current.setColumnGroupHeaderFocus(field, depth, event);
    }, [
        apiRef,
        logger
    ]);
    const getRowIdFromIndex = $lCzvA.useCallback((rowIndex)=>{
        return getCurrentPageRows()[rowIndex]?.id;
    }, [
        getCurrentPageRows
    ]);
    const handleColumnHeaderKeyDown = $lCzvA.useCallback((params, event)=>{
        const headerTitleNode = event.currentTarget.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477).columnHeaderTitleContainerContent}`);
        const isFromInsideContent = !!headerTitleNode && headerTitleNode.contains(event.target);
        if (isFromInsideContent && params.field !== (0, $145aea3d0e493d77$export$b2e9ab6103a664ad).field) // When focus is on a nested input, keyboard events have no effect to avoid conflicts with native events.
        // There is one exception for the checkBoxHeader
        return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef).length - 1;
        const columnGroupMaxDepth = (0, $8590d748d071bb9f$export$4cf0369c079b29be)(apiRef);
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else if (firstRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $c40c5cb5d52ee6a6$export$21527d4fb6084929)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToHeader(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $c40c5cb5d52ee6a6$export$7c625e86ddfff1ed)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToHeader(leftColIndex, event);
                    break;
                }
            case 'ArrowUp':
                if (columnGroupMaxDepth > 0) goToGroupHeader(colIndexBefore, columnGroupMaxDepth - 1, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeader(firstColIndex, event);
                break;
            case 'End':
                goToHeader(lastColIndex, event);
                break;
            case 'Enter':
                if (event.ctrlKey || event.metaKey) apiRef.current.toggleColumnMenu(params.field);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToCell,
        getRowIdFromIndex,
        isRtl,
        goToHeader,
        goToGroupHeader
    ]);
    const handleHeaderFilterKeyDown = $lCzvA.useCallback((params, event)=>{
        const isEditing = (0, $2ea7877c1ac6621b$export$d5104e3dccc7c49d)(apiRef) === params.field;
        const isHeaderMenuOpen = (0, $2ea7877c1ac6621b$export$c564e60305059ea4)(apiRef) === params.field;
        if (isEditing || isHeaderMenuOpen || !(0, $23fd0e5066a0f9a3$export$e13d96c38a470518)(event.key)) return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                {
                    const rowId = getRowIdFromIndex(firstRowIndexInPage);
                    if (firstRowIndexInPage !== null && rowId != null) goToCell(colIndexBefore, rowId);
                    break;
                }
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $c40c5cb5d52ee6a6$export$21527d4fb6084929)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToHeaderFilter(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $c40c5cb5d52ee6a6$export$7c625e86ddfff1ed)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToHeaderFilter(leftColIndex, event);
                    else apiRef.current.setColumnHeaderFilterFocus(params.field, event);
                    break;
                }
            case 'ArrowUp':
                goToHeader(colIndexBefore, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeaderFilter(firstColIndex, event);
                break;
            case 'End':
                goToHeaderFilter(lastColIndex, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        goToHeaderFilter,
        isRtl,
        goToHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleColumnGroupHeaderKeyDown = $lCzvA.useCallback((params, event)=>{
        const focusedColumnGroup = (0, $c2be356cc77cce81$export$3eeedc3f7263df61)(apiRef);
        if (focusedColumnGroup === null) return;
        const { field: currentField, depth: currentDepth } = focusedColumnGroup;
        const { fields: fields, depth: depth, maxDepth: maxDepth } = params;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const currentColIndex = apiRef.current.getColumnIndex(currentField);
        const colIndexBefore = currentField ? apiRef.current.getColumnIndex(currentField) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (depth === maxDepth - 1) goToHeader(currentColIndex, event);
                else goToGroupHeader(currentColIndex, currentDepth + 1, event);
                break;
            case 'ArrowUp':
                if (depth > 0) goToGroupHeader(currentColIndex, currentDepth - 1, event);
                break;
            case 'ArrowRight':
                {
                    const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
                    if (currentColIndex + remainingRightColumns + 1 <= lastColIndex) goToGroupHeader(currentColIndex + remainingRightColumns + 1, currentDepth, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const remainingLeftColumns = fields.indexOf(currentField);
                    if (currentColIndex - remainingLeftColumns - 1 >= firstColIndex) goToGroupHeader(currentColIndex - remainingLeftColumns - 1, currentDepth, event);
                    break;
                }
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToGroupHeader(firstColIndex, currentDepth, event);
                break;
            case 'End':
                goToGroupHeader(lastColIndex, currentDepth, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        goToHeader,
        goToGroupHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleCellKeyDown = $lCzvA.useCallback((params, event)=>{
        // Ignore portal
        if ((0, $e6e8e5e948b588ba$export$8ce496ad3bfbe3a6)(event)) return;
        // Get the most recent params because the cell mode may have changed by another listener
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.cellMode === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit || !(0, $23fd0e5066a0f9a3$export$e13d96c38a470518)(event.key)) return;
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        const currentPageRows = getCurrentPageRows();
        if (currentPageRows.length === 0) return;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const getColumnIndexFn = listView ? ()=>0 : apiRef.current.getColumnIndex;
        const colIndexBefore = params.field ? getColumnIndexFn(params.field) : 0;
        const rowIndexBefore = currentPageRows.findIndex((row)=>row.id === params.id);
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const visibleColumns = listView ? [
            (0, $a014507b13bf83e2$export$aeeda57ada9bc1ee)(apiRef.current.state)
        ] : (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef);
        const lastColIndex = visibleColumns.length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                // "Enter" is only triggered by the row / cell editing feature
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore + 1), isRtl ? 'right' : 'left', 'down');
                break;
            case 'ArrowUp':
                if (rowIndexBefore > firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore - 1));
                else if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else goToHeader(colIndexBefore, event);
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $c40c5cb5d52ee6a6$export$21527d4fb6084929)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToCell(rightColIndex, getRowIdFromIndex(rowIndexBefore), isRtl ? 'left' : 'right');
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $c40c5cb5d52ee6a6$export$7c625e86ddfff1ed)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToCell(leftColIndex, getRowIdFromIndex(rowIndexBefore), isRtl ? 'right' : 'left');
                    break;
                }
            case 'Tab':
                // "Tab" is only triggered by the row / cell editing feature
                if (event.shiftKey && colIndexBefore > firstColIndex) goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore), 'left');
                else if (!event.shiftKey && colIndexBefore < lastColIndex) goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), 'right');
                break;
            case ' ':
                {
                    const field = params.field;
                    if (field === (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719)) break;
                    const colDef = params.colDef;
                    if (colDef && (colDef.field === (0, $3cb6fcdeb46bf88d$export$9cce4aaa860dd90a) || (0, $d8d5f51ee5caf0c3$export$452ffe3c6554619d)(colDef.field))) break;
                    if (!event.shiftKey && rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                    break;
                }
            case 'PageDown':
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'PageUp':
                {
                    // Go to the first row before going to header
                    const nextRowIndex = Math.max(rowIndexBefore - viewportPageSize, firstRowIndexInPage);
                    if (nextRowIndex !== rowIndexBefore && nextRowIndex >= firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(nextRowIndex));
                    else goToHeader(colIndexBefore, event);
                    break;
                }
            case 'Home':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                else goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            case 'End':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(lastColIndex, getRowIdFromIndex(lastRowIndexInPage));
                else goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        isRtl,
        goToCell,
        getRowIdFromIndex,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToHeader,
        listView
    ]);
    const checkIfCanStartEditing = $lCzvA.useCallback((initialValue, { event: event })=>{
        if (event.key === ' ') // Space scrolls to the last row
        return false;
        return initialValue;
    }, []);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'canStartEditing', checkIfCanStartEditing);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'headerFilterKeyDown', handleHeaderFilterKeyDown);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnGroupHeaderKeyDown', handleColumnGroupHeaderKeyDown);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', handleCellKeyDown);
};


var $lCzvA = parcelRequire("lCzvA");




class $4a7997ea0cc9ccd9$export$f6bd549412d13610 extends Error {
}
function $4a7997ea0cc9ccd9$export$d5da41ef394db9ef(apiRef, props) {
    const getColumnHeaderParams = $lCzvA.useCallback((field)=>({
            field: field,
            colDef: apiRef.current.getColumn(field)
        }), [
        apiRef
    ]);
    const getRowParams = $lCzvA.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        if (!row) throw new $4a7997ea0cc9ccd9$export$f6bd549412d13610(`No row with id #${id} found`);
        const params = {
            id: id,
            columns: apiRef.current.getAllColumns(),
            row: row
        };
        return params;
    }, [
        apiRef
    ]);
    const getCellParamsForRow = $lCzvA.useCallback((id, field, row, { cellMode: cellMode, colDef: colDef, hasFocus: hasFocus, rowNode: rowNode, tabIndex: tabIndex })=>{
        const rawValue = row[field];
        const value = colDef?.valueGetter ? colDef.valueGetter(rawValue, row, colDef, apiRef) : rawValue;
        const params = {
            id: id,
            field: field,
            row: row,
            rowNode: rowNode,
            colDef: colDef,
            cellMode: cellMode,
            hasFocus: hasFocus,
            tabIndex: tabIndex,
            value: value,
            formattedValue: value,
            isEditable: false,
            api: apiRef.current
        };
        if (colDef && colDef.valueFormatter) params.formattedValue = colDef.valueFormatter(value, row, colDef, apiRef);
        params.isEditable = colDef && apiRef.current.isCellEditable(params);
        return params;
    }, [
        apiRef
    ]);
    const getCellParams = $lCzvA.useCallback((id, field)=>{
        const row = apiRef.current.getRow(id);
        const rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) throw new $4a7997ea0cc9ccd9$export$f6bd549412d13610(`No row with id #${id} found`);
        const cellFocus = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
        const cellTabIndex = (0, $c2be356cc77cce81$export$2c47652a1f657d56)(apiRef);
        const cellMode = apiRef.current.getCellMode(id, field);
        return apiRef.current.getCellParamsForRow(id, field, row, {
            colDef: props.unstable_listView && props.unstable_listColumn?.field === field ? (0, $a014507b13bf83e2$export$aeeda57ada9bc1ee)(apiRef.current.state) : apiRef.current.getColumn(field),
            rowNode: rowNode,
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
            cellMode: cellMode
        });
    }, [
        apiRef,
        props.unstable_listView,
        props.unstable_listColumn?.field
    ]);
    const getCellValue = $lCzvA.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        if (!row) throw new $4a7997ea0cc9ccd9$export$f6bd549412d13610(`No row with id #${id} found`);
        if (!colDef || !colDef.valueGetter) return row[field];
        return colDef.valueGetter(row[colDef.field], row, colDef, apiRef);
    }, [
        apiRef
    ]);
    const getRowValue = $lCzvA.useCallback((row, colDef)=>{
        const field = colDef.field;
        if (!colDef || !colDef.valueGetter) return row[field];
        const value = row[colDef.field];
        return colDef.valueGetter(value, row, colDef, apiRef);
    }, [
        apiRef
    ]);
    const getRowFormattedValue = $lCzvA.useCallback((row, colDef)=>{
        const value = getRowValue(row, colDef);
        if (!colDef || !colDef.valueFormatter) return value;
        return colDef.valueFormatter(value, row, colDef, apiRef);
    }, [
        apiRef,
        getRowValue
    ]);
    const getColumnHeaderElement = $lCzvA.useCallback((field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $e6e8e5e948b588ba$export$94318ffb75913a0b)(apiRef.current.rootElementRef.current, field);
    }, [
        apiRef
    ]);
    const getRowElement = $lCzvA.useCallback((id)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $e6e8e5e948b588ba$export$9bc8bb868a922a5f)(apiRef.current.rootElementRef.current, id);
    }, [
        apiRef
    ]);
    const getCellElement = $lCzvA.useCallback((id, field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $e6e8e5e948b588ba$export$44827662627a59)(apiRef.current.rootElementRef.current, {
            id: id,
            field: field
        });
    }, [
        apiRef
    ]);
    const paramsApi = {
        getCellValue: getCellValue,
        getCellParams: getCellParams,
        getCellElement: getCellElement,
        getRowValue: getRowValue,
        getRowFormattedValue: getRowFormattedValue,
        getRowParams: getRowParams,
        getRowElement: getRowElement,
        getColumnHeaderParams: getColumnHeaderParams,
        getColumnHeaderElement: getColumnHeaderElement
    };
    const paramsPrivateApi = {
        getCellParamsForRow: getCellParamsForRow
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, paramsApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, paramsPrivateApi, 'private');
}



var $lCzvA = parcelRequire("lCzvA");















function $13a09b1d69c4e28f$var$raf() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
function $13a09b1d69c4e28f$var$buildPrintWindow(title) {
    const iframeEl = document.createElement('iframe');
    iframeEl.style.position = 'absolute';
    iframeEl.style.width = '0px';
    iframeEl.style.height = '0px';
    iframeEl.title = title || document.title;
    return iframeEl;
}
const $13a09b1d69c4e28f$export$41205b2521d4edd4 = (apiRef, props)=>{
    const hasRootReference = apiRef.current.rootElementRef.current !== null;
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridPrintExport');
    const doc = $lCzvA.useRef(null);
    const previousGridState = $lCzvA.useRef(null);
    const previousColumnVisibility = $lCzvA.useRef({});
    const previousRows = $lCzvA.useRef([]);
    const previousVirtualizationState = $lCzvA.useRef(null);
    $lCzvA.useEffect(()=>{
        doc.current = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
    }, [
        apiRef,
        hasRootReference
    ]);
    // Returns a promise because updateColumns triggers state update and
    // the new state needs to be in place before the grid can be sized correctly
    const updateGridColumnsForPrint = $lCzvA.useCallback((fields, allColumns, includeCheckboxes)=>new Promise((resolve)=>{
            const exportedColumnFields = (0, $aead2171337889e5$export$c5c7f3bb5f79a15d)({
                apiRef: apiRef,
                options: {
                    fields: fields,
                    allColumns: allColumns
                }
            }).map((column)=>column.field);
            const columns = (0, $8b99503000dd62d3$export$da85f06e3c19f1fd)(apiRef);
            const newColumnVisibilityModel = {};
            columns.forEach((column)=>{
                newColumnVisibilityModel[column.field] = exportedColumnFields.includes(column.field);
            });
            if (includeCheckboxes) newColumnVisibilityModel[(0, $145aea3d0e493d77$export$b2e9ab6103a664ad).field] = true;
            apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
            resolve();
        }), [
        apiRef
    ]);
    const updateGridRowsForPrint = $lCzvA.useCallback((getRowsToExport)=>{
        const rowsToExportIds = getRowsToExport({
            apiRef: apiRef
        });
        const newRows = rowsToExportIds.reduce((acc, id)=>{
            const row = apiRef.current.getRow(id);
            if (!row[0, $dc4fe3453cdb0a0a$export$e8632b32bb8837db]) acc.push(row);
            return acc;
        }, []);
        apiRef.current.setRows(newRows);
    }, [
        apiRef
    ]);
    const handlePrintWindowLoad = $lCzvA.useCallback((printWindow, options)=>{
        const normalizeOptions = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            copyStyles: true,
            hideToolbar: false,
            hideFooter: false,
            includeCheckboxes: false
        }, options);
        const printDoc = printWindow.contentDocument;
        if (!printDoc) return;
        const rowsMeta = (0, $ab89a1ec5ede86ad$export$4f32bfc70efeb4ab)(apiRef.current.state);
        const gridRootElement = apiRef.current.rootElementRef.current;
        const gridClone = gridRootElement.cloneNode(true);
        // Allow to overflow to not hide the border of the last row
        const gridMain = gridClone.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477).main}`);
        gridMain.style.overflow = 'visible';
        // See https://support.google.com/chrome/thread/191619088?hl=en&msgid=193009642
        gridClone.style.contain = 'size';
        let gridToolbarElementHeight = gridRootElement.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477).toolbarContainer}`)?.offsetHeight || 0;
        let gridFooterElementHeight = gridRootElement.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477).footerContainer}`)?.offsetHeight || 0;
        const gridFooterElement = gridClone.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477).footerContainer}`);
        if (normalizeOptions.hideToolbar) {
            gridClone.querySelector(`.${(0, $786c119d9add6b61$export$2100d54e36406477).toolbarContainer}`)?.remove();
            gridToolbarElementHeight = 0;
        }
        if (normalizeOptions.hideFooter && gridFooterElement) {
            gridFooterElement.remove();
            gridFooterElementHeight = 0;
        }
        // Expand container height to accommodate all rows
        const computedTotalHeight = rowsMeta.currentPageTotalHeight + (0, $938d01614caf11f5$export$659109c29172602f)(apiRef, props) + gridToolbarElementHeight + gridFooterElementHeight;
        gridClone.style.height = `${computedTotalHeight}px`;
        // The height above does not include grid border width, so we need to exclude it
        gridClone.style.boxSizing = 'content-box';
        if (!normalizeOptions.hideFooter && gridFooterElement) {
            // the footer is always being placed at the bottom of the page as if all rows are exported
            // so if getRowsToExport is being used to only export a subset of rows then we need to
            // adjust the footer position to be correctly placed at the bottom of the grid
            gridFooterElement.style.position = 'absolute';
            gridFooterElement.style.width = '100%';
            gridFooterElement.style.top = `${computedTotalHeight - gridFooterElementHeight}px`;
        }
        // printDoc.body.appendChild(gridClone); should be enough but a clone isolation bug in Safari
        // prevents us to do it
        const container = document.createElement('div');
        container.appendChild(gridClone);
        // To avoid an empty page in start on Chromium based browsers
        printDoc.body.style.marginTop = '0px';
        printDoc.body.innerHTML = container.innerHTML;
        const defaultPageStyle = typeof normalizeOptions.pageStyle === 'function' ? normalizeOptions.pageStyle() : normalizeOptions.pageStyle;
        if (typeof defaultPageStyle === 'string') {
            // TODO custom styles should always win
            const styleElement = printDoc.createElement('style');
            styleElement.appendChild(printDoc.createTextNode(defaultPageStyle));
            printDoc.head.appendChild(styleElement);
        }
        if (normalizeOptions.bodyClassName) printDoc.body.classList.add(...normalizeOptions.bodyClassName.split(' '));
        const stylesheetLoadPromises = [];
        if (normalizeOptions.copyStyles) {
            const rootCandidate = gridRootElement.getRootNode();
            const root = rootCandidate.constructor.name === 'ShadowRoot' ? rootCandidate : doc.current;
            const headStyleElements = root.querySelectorAll("style, link[rel='stylesheet']");
            for(let i = 0; i < headStyleElements.length; i += 1){
                const node = headStyleElements[i];
                if (node.tagName === 'STYLE') {
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    const sheet = node.sheet;
                    if (sheet) {
                        let styleCSS = '';
                        // NOTE: for-of is not supported by IE
                        for(let j = 0; j < sheet.cssRules.length; j += 1)if (typeof sheet.cssRules[j].cssText === 'string') styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
                        newHeadStyleElements.appendChild(printDoc.createTextNode(styleCSS));
                        printDoc.head.appendChild(newHeadStyleElements);
                    }
                } else if (node.getAttribute('href')) {
                    // If `href` tag is empty, avoid loading these links
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    for(let j = 0; j < node.attributes.length; j += 1){
                        const attr = node.attributes[j];
                        if (attr) newHeadStyleElements.setAttribute(attr.nodeName, attr.nodeValue || '');
                    }
                    stylesheetLoadPromises.push(new Promise((resolve)=>{
                        newHeadStyleElements.addEventListener('load', ()=>resolve());
                    }));
                    printDoc.head.appendChild(newHeadStyleElements);
                }
            }
        }
        // wait for remote stylesheets to load
        Promise.all(stylesheetLoadPromises).then(()=>{
            printWindow.contentWindow.print();
        });
    }, [
        apiRef,
        doc,
        props
    ]);
    const handlePrintWindowAfterPrint = $lCzvA.useCallback((printWindow)=>{
        // Remove the print iframe
        doc.current.body.removeChild(printWindow);
        // Revert grid to previous state
        apiRef.current.restoreState(previousGridState.current || {});
        if (!previousGridState.current?.columns?.columnVisibilityModel) // if the apiRef.current.exportState(); did not export the column visibility, we update it
        apiRef.current.setColumnVisibilityModel(previousColumnVisibility.current);
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                virtualization: previousVirtualizationState.current
            }));
        apiRef.current.setRows(previousRows.current);
        // Clear local state
        previousGridState.current = null;
        previousColumnVisibility.current = {};
        previousRows.current = [];
    }, [
        apiRef
    ]);
    const exportDataAsPrint = $lCzvA.useCallback(async (options)=>{
        logger.debug(`Export data as Print`);
        if (!apiRef.current.rootElementRef.current) throw new Error('MUI X: No grid root element available.');
        previousGridState.current = apiRef.current.exportState();
        // It appends that the visibility model is not exported, especially if columnVisibility is not controlled
        previousColumnVisibility.current = (0, $8b99503000dd62d3$export$eb0d33595fe29bb4)(apiRef);
        previousRows.current = apiRef.current.getSortedRows().filter((row)=>!row[0, $dc4fe3453cdb0a0a$export$e8632b32bb8837db]);
        if (props.pagination) {
            const visibleRowCount = (0, $6450fc0917754b27$export$96919017bbfaec0d)(apiRef);
            const paginationModel = {
                page: 0,
                pageSize: visibleRowCount
            };
            apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                    pagination: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.pagination, {
                        paginationModel: (0, $ced94ef585e1afa1$export$16d1dc8477d07e4)(state.pagination, // Using signature `DataGridPro` to allow more than 100 rows in the print export
                        'DataGridPro', paginationModel)
                    })
                }));
        }
        previousVirtualizationState.current = apiRef.current.state.virtualization;
        apiRef.current.unstable_setVirtualization(false);
        await updateGridColumnsForPrint(options?.fields, options?.allColumns, options?.includeCheckboxes);
        updateGridRowsForPrint(options?.getRowsToExport ?? (0, $aead2171337889e5$export$99156d1572dee776));
        await $13a09b1d69c4e28f$var$raf(); // wait for the state changes to take action
        const printWindow = $13a09b1d69c4e28f$var$buildPrintWindow(options?.fileName);
        printWindow.onload = ()=>{
            handlePrintWindowLoad(printWindow, options);
            const mediaQueryList = printWindow.contentWindow.matchMedia('print');
            mediaQueryList.addEventListener('change', (mql)=>{
                const isAfterPrint = mql.matches === false;
                if (isAfterPrint) handlePrintWindowAfterPrint(printWindow);
            });
        };
        doc.current.body.appendChild(printWindow);
    }, [
        props,
        logger,
        apiRef,
        handlePrintWindowLoad,
        handlePrintWindowAfterPrint,
        updateGridColumnsForPrint,
        updateGridRowsForPrint
    ]);
    const printExportApi = {
        exportDataAsPrint: exportDataAsPrint
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, printExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $lCzvA.useCallback((initialValue, options)=>{
        if (options.printOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e0adf91930b83273$export$a6cd094b30f69b92), {
                    options: options.printOptions
                }),
                componentName: 'printExport'
            }
        ];
    }, []);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'exportMenu', addExportMenuButtons);
};



var $lCzvA = parcelRequire("lCzvA");




const $78aa136d03a13d7e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $lCzvA.useMemo(()=>{
        const slots = {
            cellCheckbox: [
                'cellCheckbox'
            ],
            columnHeaderCheckbox: [
                'columnHeaderCheckbox'
            ]
        };
        return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
    }, [
        classes
    ]);
};
const $78aa136d03a13d7e$export$fa1d7b0897c018ea = (apiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = $78aa136d03a13d7e$var$useUtilityClasses(ownerState);
    const updateSelectionColumn = $lCzvA.useCallback((columnsState)=>{
        const selectionColumn = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $145aea3d0e493d77$export$b2e9ab6103a664ad), {
            cellClassName: classes.cellCheckbox,
            headerClassName: classes.columnHeaderCheckbox,
            headerName: apiRef.current.getLocaleText('checkboxSelectionHeaderName')
        });
        const shouldHaveSelectionColumn = props.checkboxSelection;
        const hasSelectionColumn = columnsState.lookup[0, $145aea3d0e493d77$export$322dfed7a1df1b02] != null;
        if (shouldHaveSelectionColumn && !hasSelectionColumn) {
            columnsState.lookup[0, $145aea3d0e493d77$export$322dfed7a1df1b02] = selectionColumn;
            columnsState.orderedFields = [
                (0, $145aea3d0e493d77$export$322dfed7a1df1b02),
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveSelectionColumn && hasSelectionColumn) {
            delete columnsState.lookup[0, $145aea3d0e493d77$export$322dfed7a1df1b02];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== (0, $145aea3d0e493d77$export$322dfed7a1df1b02));
        } else if (shouldHaveSelectionColumn && hasSelectionColumn) {
            columnsState.lookup[0, $145aea3d0e493d77$export$322dfed7a1df1b02] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, selectionColumn, columnsState.lookup[0, $145aea3d0e493d77$export$322dfed7a1df1b02]);
            // If the column is not in the columns array (not a custom selection column), move it to the beginning of the column order
            if (!props.columns.some((col)=>col.field === (0, $145aea3d0e493d77$export$322dfed7a1df1b02))) columnsState.orderedFields = [
                (0, $145aea3d0e493d77$export$322dfed7a1df1b02),
                ...columnsState.orderedFields.filter((field)=>field !== (0, $145aea3d0e493d77$export$322dfed7a1df1b02))
            ];
        }
        return columnsState;
    }, [
        apiRef,
        classes,
        props.columns,
        props.checkboxSelection
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'hydrateColumns', updateSelectionColumn);
};




const $16d5e19196154261$var$createFlatRowTree = (rows)=>{
    const tree = {
        [(0, $dc4fe3453cdb0a0a$export$433b924dc2506913)]: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $dc4fe3453cdb0a0a$export$96a607054e9bfd0c)(), {
            children: rows
        })
    };
    for(let i = 0; i < rows.length; i += 1){
        const rowId = rows[i];
        tree[rowId] = {
            id: rowId,
            depth: 0,
            parent: (0, $dc4fe3453cdb0a0a$export$433b924dc2506913),
            type: 'leaf',
            groupingKey: null
        };
    }
    return {
        groupingName: (0, $8de9ab907b1743d2$export$84214fbf04c4094),
        tree: tree,
        treeDepths: {
            0: rows.length
        },
        dataRowIds: rows
    };
};
const $16d5e19196154261$var$updateFlatRowTree = ({ previousTree: previousTree, actions: actions })=>{
    const tree = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, previousTree);
    const idsToRemoveFromRootGroup = {};
    for(let i = 0; i < actions.remove.length; i += 1){
        const idToDelete = actions.remove[i];
        idsToRemoveFromRootGroup[idToDelete] = true;
        delete tree[idToDelete];
    }
    for(let i = 0; i < actions.insert.length; i += 1){
        const idToInsert = actions.insert[i];
        tree[idToInsert] = {
            id: idToInsert,
            depth: 0,
            parent: (0, $dc4fe3453cdb0a0a$export$433b924dc2506913),
            type: 'leaf',
            groupingKey: null
        };
    }
    // TODO rows v6: Support row unpinning
    const rootGroup = tree[0, $dc4fe3453cdb0a0a$export$433b924dc2506913];
    let rootGroupChildren = [
        ...rootGroup.children,
        ...actions.insert
    ];
    if (Object.values(idsToRemoveFromRootGroup).length) rootGroupChildren = rootGroupChildren.filter((id)=>!idsToRemoveFromRootGroup[id]);
    tree[0, $dc4fe3453cdb0a0a$export$433b924dc2506913] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootGroup, {
        children: rootGroupChildren
    });
    return {
        groupingName: (0, $8de9ab907b1743d2$export$84214fbf04c4094),
        tree: tree,
        treeDepths: {
            0: rootGroupChildren.length
        },
        dataRowIds: rootGroupChildren
    };
};
const $16d5e19196154261$var$flatRowTreeCreationMethod = (params)=>{
    if (params.updates.type === 'full') return $16d5e19196154261$var$createFlatRowTree(params.updates.rows);
    return $16d5e19196154261$var$updateFlatRowTree({
        previousTree: params.previousTree,
        actions: params.updates.actions
    });
};
const $16d5e19196154261$export$cc1daa683bbe5702 = (apiRef)=>{
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(apiRef, (0, $8de9ab907b1743d2$export$84214fbf04c4094), 'rowTreeCreation', $16d5e19196154261$var$flatRowTreeCreationMethod);
};


var $lCzvA = parcelRequire("lCzvA");











// Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
// Similar to https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
function $bfc05419669f10ba$var$scrollIntoView(dimensions) {
    const { containerSize: containerSize, scrollPosition: scrollPosition, elementSize: elementSize, elementOffset: elementOffset } = dimensions;
    const elementEnd = elementOffset + elementSize;
    // Always scroll to top when cell is higher than viewport to avoid scroll jump
    // See https://github.com/mui/mui-x/issues/4513 and https://github.com/mui/mui-x/issues/4514
    if (elementSize > containerSize) return elementOffset;
    if (elementEnd - containerSize > scrollPosition) return elementEnd - containerSize;
    if (elementOffset < scrollPosition) return elementOffset;
    return undefined;
}
const $bfc05419669f10ba$export$d3441dc29db31b8c = (apiRef, props)=>{
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridScroll');
    const colRef = apiRef.current.columnHeadersContainerRef;
    const virtualScrollerRef = apiRef.current.virtualScrollerRef;
    const visibleSortedRows = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$2f31562143a3e5d4));
    const scrollToIndexes = $lCzvA.useCallback((params)=>{
        const dimensions = (0, $adc18856c547b659$export$26d8768b83a52ffd)(apiRef.current.state);
        const totalRowCount = (0, $68327dddce1a2c68$export$1641ef9d08e265ca)(apiRef);
        const visibleColumns = props.unstable_listView ? [
            (0, $a014507b13bf83e2$export$aeeda57ada9bc1ee)(apiRef.current.state)
        ] : (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef);
        const scrollToHeader = params.rowIndex == null;
        if (!scrollToHeader && totalRowCount === 0 || visibleColumns.length === 0) return false;
        logger.debug(`Scrolling to cell at row ${params.rowIndex}, col: ${params.colIndex} `);
        let scrollCoordinates = {};
        if (params.colIndex !== undefined) {
            const columnPositions = (0, $8b99503000dd62d3$export$fce7d810e48021e3)(apiRef);
            let cellWidth;
            if (typeof params.rowIndex !== 'undefined') {
                const rowId = visibleSortedRows[params.rowIndex]?.id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, params.colIndex);
                if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) cellWidth = cellColSpanInfo.cellProps.width;
            }
            if (typeof cellWidth === 'undefined') cellWidth = visibleColumns[params.colIndex].computedWidth;
            // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
            scrollCoordinates.left = $bfc05419669f10ba$var$scrollIntoView({
                containerSize: dimensions.viewportOuterSize.width,
                scrollPosition: Math.abs(virtualScrollerRef.current.scrollLeft),
                elementSize: cellWidth,
                elementOffset: columnPositions[params.colIndex]
            });
        }
        if (params.rowIndex !== undefined) {
            const rowsMeta = (0, $ab89a1ec5ede86ad$export$4f32bfc70efeb4ab)(apiRef.current.state);
            const page = (0, $017d03038815cc56$export$1f7f64fcb62ccdad)(apiRef);
            const pageSize = (0, $017d03038815cc56$export$721a46720a2de097)(apiRef);
            const elementIndex = !props.pagination ? params.rowIndex : params.rowIndex - page * pageSize;
            const targetOffsetHeight = rowsMeta.positions[elementIndex + 1] ? rowsMeta.positions[elementIndex + 1] - rowsMeta.positions[elementIndex] : rowsMeta.currentPageTotalHeight - rowsMeta.positions[elementIndex];
            scrollCoordinates.top = $bfc05419669f10ba$var$scrollIntoView({
                containerSize: dimensions.viewportInnerSize.height,
                scrollPosition: virtualScrollerRef.current.scrollTop,
                elementSize: targetOffsetHeight,
                elementOffset: rowsMeta.positions[elementIndex]
            });
        }
        scrollCoordinates = apiRef.current.unstable_applyPipeProcessors('scrollToIndexes', scrollCoordinates, params);
        scrollCoordinates.left;
        apiRef.current.scroll(scrollCoordinates);
        return true;
        return false;
    }, [
        logger,
        apiRef,
        virtualScrollerRef,
        props.pagination,
        visibleSortedRows,
        props.unstable_listView
    ]);
    const scroll = $lCzvA.useCallback((params)=>{
        if (virtualScrollerRef.current && params.left !== undefined && colRef.current) {
            const direction = isRtl ? -1 : 1;
            colRef.current.scrollLeft = params.left;
            virtualScrollerRef.current.scrollLeft = direction * params.left;
            logger.debug(`Scrolling left: ${params.left}`);
        }
        if (virtualScrollerRef.current && params.top !== undefined) {
            virtualScrollerRef.current.scrollTop = params.top;
            logger.debug(`Scrolling top: ${params.top}`);
        }
        logger.debug(`Scrolling, updating container, and viewport`);
    }, [
        virtualScrollerRef,
        isRtl,
        colRef,
        logger
    ]);
    const getScrollPosition = $lCzvA.useCallback(()=>{
        if (!virtualScrollerRef?.current) return {
            top: 0,
            left: 0
        };
        return {
            top: virtualScrollerRef.current.scrollTop,
            left: virtualScrollerRef.current.scrollLeft
        };
    }, [
        virtualScrollerRef
    ]);
    const scrollApi = {
        scroll: scroll,
        scrollToIndexes: scrollToIndexes,
        getScrollPosition: getScrollPosition
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, scrollApi, 'public');
};


var $lCzvA = parcelRequire("lCzvA");

const $b74a5c3db1daeb6b$export$971de86bde7f86a1 = (apiRef)=>{
    const exportState = $lCzvA.useCallback((params = {})=>{
        const stateToExport = apiRef.current.unstable_applyPipeProcessors('exportState', {}, params);
        return stateToExport;
    }, [
        apiRef
    ]);
    const restoreState = $lCzvA.useCallback((stateToRestore)=>{
        const response = apiRef.current.unstable_applyPipeProcessors('restoreState', {
            callbacks: []
        }, {
            stateToRestore: stateToRestore
        });
        response.callbacks.forEach((callback)=>{
            callback();
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const statePersistenceApi = {
        exportState: exportState,
        restoreState: restoreState
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, statePersistenceApi, 'public');
};



var $lCzvA = parcelRequire("lCzvA");





const $ec06e7a1aece4114$var$InfiniteLoadingTriggerElement = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div')({
    position: 'sticky',
    left: 0,
    width: 0,
    height: 0
});
const $ec06e7a1aece4114$export$ffcbb8895be5a582 = (apiRef, props)=>{
    const isReady = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$26d8768b83a52ffd)).isReady;
    const visibleColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$16a65a9447d3dda9));
    const currentPage = (0, $6b6f708ce7819830$export$d1914c80ff11e37a)(apiRef, props);
    const observer = $lCzvA.useRef(null);
    const updateTargetTimeout = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const triggerElement = $lCzvA.useRef(null);
    const isEnabled = props.rowsLoadingMode === 'client' && !!props.onRowsScrollEnd;
    const handleLoadMoreRows = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(([entry])=>{
        const currentRatio = entry.intersectionRatio;
        const isIntersecting = entry.isIntersecting;
        if (isIntersecting && currentRatio === 1) {
            const viewportPageSize = apiRef.current.getViewportPageSize();
            const rowScrollEndParams = {
                visibleColumns: visibleColumns,
                viewportPageSize: viewportPageSize,
                visibleRowsCount: currentPage.rows.length
            };
            apiRef.current.publishEvent('rowsScrollEnd', rowScrollEndParams);
            observer.current?.disconnect();
            // do not observe this node anymore
            triggerElement.current = null;
        }
    });
    $lCzvA.useEffect(()=>{
        const virtualScroller = apiRef.current.virtualScrollerRef.current;
        if (!isEnabled || !isReady || !virtualScroller) return;
        observer.current?.disconnect();
        const horizontalScrollbarHeight = (0, $adc18856c547b659$export$bfc2d49082e0c9a2)(apiRef.current.state);
        const marginBottom = props.scrollEndThreshold - horizontalScrollbarHeight;
        observer.current = new IntersectionObserver(handleLoadMoreRows, {
            threshold: 1,
            root: virtualScroller,
            rootMargin: `0px 0px ${marginBottom}px 0px`
        });
        if (triggerElement.current) observer.current.observe(triggerElement.current);
    }, [
        apiRef,
        isReady,
        handleLoadMoreRows,
        isEnabled,
        props.scrollEndThreshold
    ]);
    const updateTarget = (node)=>{
        if (triggerElement.current !== node) {
            observer.current?.disconnect();
            triggerElement.current = node;
            if (triggerElement.current) observer.current?.observe(triggerElement.current);
        }
    };
    const triggerRef = $lCzvA.useCallback((node)=>{
        // Prevent the infite loading working in combination with lazy loading
        if (!isEnabled) return;
        // If the user scrolls through the grid too fast it might happen that the observer is connected to the trigger element
        // that will be intersecting the root inside the same render cycle (but not intersecting at the time of the connection).
        // This will cause the observer to not call the callback with `isIntersecting` set to `true`.
        // https://www.w3.org/TR/intersection-observer/#event-loop
        // Delaying the connection to the next cycle helps since the observer will always call the callback the first time it is connected.
        // https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/observe
        // Related to
        // https://github.com/mui/mui-x/issues/14116
        updateTargetTimeout.start(0, ()=>updateTarget(node));
    }, [
        isEnabled,
        updateTargetTimeout
    ]);
    const getInfiniteLoadingTriggerElement = $lCzvA.useCallback(({ lastRowId: lastRowId })=>{
        if (!isEnabled) return null;
        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($ec06e7a1aece4114$var$InfiniteLoadingTriggerElement, {
            ref: triggerRef,
            role: "presentation"
        }, `trigger-${lastRowId}`);
    }, [
        isEnabled,
        triggerRef
    ]);
    const infiniteLoaderPrivateApi = {
        getInfiniteLoadingTriggerElement: getInfiniteLoadingTriggerElement
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, infiniteLoaderPrivateApi, 'private');
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'rowsScrollEnd', props.onRowsScrollEnd);
};




var $lCzvA = parcelRequire("lCzvA");




const $bdcbdcb1173dfe90$export$72ac47d6066a8a99 = (state)=>state.columnReorder;
const $bdcbdcb1173dfe90$export$78d24cc7373bc611 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($bdcbdcb1173dfe90$export$72ac47d6066a8a99, (columnReorder)=>columnReorder.dragCol);


const $94fef3cf6d71bade$var$CURSOR_MOVE_DIRECTION_LEFT = 'left';
const $94fef3cf6d71bade$var$CURSOR_MOVE_DIRECTION_RIGHT = 'right';
const $94fef3cf6d71bade$var$getCursorMoveDirectionX = (currentCoordinates, nextCoordinates)=>{
    return currentCoordinates.x <= nextCoordinates.x ? $94fef3cf6d71bade$var$CURSOR_MOVE_DIRECTION_RIGHT : $94fef3cf6d71bade$var$CURSOR_MOVE_DIRECTION_LEFT;
};
const $94fef3cf6d71bade$var$hasCursorPositionChanged = (currentCoordinates, nextCoordinates)=>currentCoordinates.x !== nextCoordinates.x || currentCoordinates.y !== nextCoordinates.y;
const $94fef3cf6d71bade$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        columnHeaderDragging: [
            'columnHeader--dragging'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $94fef3cf6d71bade$export$c111e737ab642862 = (state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        columnReorder: {
            dragCol: ''
        }
    });
const $94fef3cf6d71bade$export$e060c7667a4364d2 = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridColumnReorder');
    const dragColNode = $lCzvA.useRef(null);
    const cursorPosition = $lCzvA.useRef({
        x: 0,
        y: 0
    });
    const originColumnIndex = $lCzvA.useRef(null);
    const forbiddenIndexes = $lCzvA.useRef({});
    const removeDnDStylesTimeout = $lCzvA.useRef(undefined);
    const ownerState = {
        classes: props.classes
    };
    const classes = $94fef3cf6d71bade$var$useUtilityClasses(ownerState);
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    $lCzvA.useEffect(()=>{
        return ()=>{
            clearTimeout(removeDnDStylesTimeout.current);
        };
    }, []);
    const handleDragStart = $lCzvA.useCallback((params, event)=>{
        if (props.disableColumnReorder || params.colDef.disableReorder) return;
        logger.debug(`Start dragging col ${params.field}`);
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        dragColNode.current = event.currentTarget;
        dragColNode.current.classList.add(classes.columnHeaderDragging);
        if (event.dataTransfer) event.dataTransfer.effectAllowed = 'move';
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                columnReorder: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.columnReorder, {
                    dragCol: params.field
                })
            }));
        apiRef.current.forceUpdate();
        removeDnDStylesTimeout.current = setTimeout(()=>{
            dragColNode.current.classList.remove(classes.columnHeaderDragging);
        });
        originColumnIndex.current = apiRef.current.getColumnIndex(params.field, false);
        const draggingColumnGroupPath = apiRef.current.getColumnGroupPath(params.field);
        const columnIndex = originColumnIndex.current;
        const allColumns = apiRef.current.getAllColumns();
        const groupsLookup = apiRef.current.getAllGroupDetails();
        const getGroupPathFromColumnIndex = (colIndex)=>{
            const field = allColumns[colIndex].field;
            return apiRef.current.getColumnGroupPath(field);
        };
        // The limitingGroupId is the id of the group from which the dragged column should not escape
        let limitingGroupId = null;
        draggingColumnGroupPath.forEach((groupId)=>{
            if (!groupsLookup[groupId]?.freeReordering) {
                // Only consider group that are made of more than one column
                if (columnIndex > 0 && getGroupPathFromColumnIndex(columnIndex - 1).includes(groupId)) limitingGroupId = groupId;
                else if (columnIndex + 1 < allColumns.length && getGroupPathFromColumnIndex(columnIndex + 1).includes(groupId)) limitingGroupId = groupId;
            }
        });
        forbiddenIndexes.current = {};
        for(let indexToForbid = 0; indexToForbid < allColumns.length; indexToForbid += 1){
            const leftIndex = indexToForbid <= columnIndex ? indexToForbid - 1 : indexToForbid;
            const rightIndex = indexToForbid < columnIndex ? indexToForbid : indexToForbid + 1;
            if (limitingGroupId !== null) {
                // verify this indexToForbid will be linked to the limiting group. Otherwise forbid it
                let allowIndex = false;
                if (leftIndex >= 0 && getGroupPathFromColumnIndex(leftIndex).includes(limitingGroupId)) allowIndex = true;
                else if (rightIndex < allColumns.length && getGroupPathFromColumnIndex(rightIndex).includes(limitingGroupId)) allowIndex = true;
                if (!allowIndex) forbiddenIndexes.current[indexToForbid] = true;
            }
            // Verify we are not splitting another group
            if (leftIndex >= 0 && rightIndex < allColumns.length) getGroupPathFromColumnIndex(rightIndex).forEach((groupId)=>{
                if (getGroupPathFromColumnIndex(leftIndex).includes(groupId)) {
                    if (!draggingColumnGroupPath.includes(groupId)) // moving here split the group groupId in two distincts chunks
                    {
                        if (!groupsLookup[groupId]?.freeReordering) forbiddenIndexes.current[indexToForbid] = true;
                    }
                }
            });
        }
    }, [
        props.disableColumnReorder,
        classes.columnHeaderDragging,
        logger,
        apiRef
    ]);
    const handleDragEnter = $lCzvA.useCallback((params, event)=>{
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
    }, []);
    const handleDragOver = $lCzvA.useCallback((params, event)=>{
        const dragColField = (0, $bdcbdcb1173dfe90$export$78d24cc7373bc611)(apiRef);
        if (!dragColField) return;
        logger.debug(`Dragging over col ${params.field}`);
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        const coordinates = {
            x: event.clientX,
            y: event.clientY
        };
        if (params.field !== dragColField && $94fef3cf6d71bade$var$hasCursorPositionChanged(cursorPosition.current, coordinates)) {
            const targetColIndex = apiRef.current.getColumnIndex(params.field, false);
            const targetColVisibleIndex = apiRef.current.getColumnIndex(params.field, true);
            const targetCol = apiRef.current.getColumn(params.field);
            const dragColIndex = apiRef.current.getColumnIndex(dragColField, false);
            const visibleColumns = apiRef.current.getVisibleColumns();
            const allColumns = apiRef.current.getAllColumns();
            const cursorMoveDirectionX = $94fef3cf6d71bade$var$getCursorMoveDirectionX(cursorPosition.current, coordinates);
            const hasMovedLeft = cursorMoveDirectionX === $94fef3cf6d71bade$var$CURSOR_MOVE_DIRECTION_LEFT && (isRtl ? dragColIndex < targetColIndex : targetColIndex < dragColIndex);
            const hasMovedRight = cursorMoveDirectionX === $94fef3cf6d71bade$var$CURSOR_MOVE_DIRECTION_RIGHT && (isRtl ? targetColIndex < dragColIndex : dragColIndex < targetColIndex);
            if (hasMovedLeft || hasMovedRight) {
                let canBeReordered;
                let indexOffsetInHiddenColumns = 0;
                if (!targetCol.disableReorder) canBeReordered = true;
                else if (hasMovedLeft) canBeReordered = targetColVisibleIndex > 0 && !visibleColumns[targetColVisibleIndex - 1].disableReorder;
                else canBeReordered = targetColVisibleIndex < visibleColumns.length - 1 && !visibleColumns[targetColVisibleIndex + 1].disableReorder;
                if (forbiddenIndexes.current[targetColIndex]) {
                    let nextVisibleColumnField;
                    let indexWithOffset = targetColIndex + indexOffsetInHiddenColumns;
                    if (hasMovedLeft) {
                        nextVisibleColumnField = targetColVisibleIndex > 0 ? visibleColumns[targetColVisibleIndex - 1].field : null;
                        while(indexWithOffset > 0 && allColumns[indexWithOffset].field !== nextVisibleColumnField && forbiddenIndexes.current[indexWithOffset]){
                            indexOffsetInHiddenColumns -= 1;
                            indexWithOffset = targetColIndex + indexOffsetInHiddenColumns;
                        }
                    } else {
                        nextVisibleColumnField = targetColVisibleIndex + 1 < visibleColumns.length ? visibleColumns[targetColVisibleIndex + 1].field : null;
                        while(indexWithOffset < allColumns.length - 1 && allColumns[indexWithOffset].field !== nextVisibleColumnField && forbiddenIndexes.current[indexWithOffset]){
                            indexOffsetInHiddenColumns += 1;
                            indexWithOffset = targetColIndex + indexOffsetInHiddenColumns;
                        }
                    }
                    if (forbiddenIndexes.current[indexWithOffset] || allColumns[indexWithOffset].field === nextVisibleColumnField) // If we ended up on a visible column, or a forbidden one, we cannot do the reorder
                    canBeReordered = false;
                }
                const canBeReorderedProcessed = apiRef.current.unstable_applyPipeProcessors('canBeReordered', canBeReordered, {
                    targetIndex: targetColVisibleIndex
                });
                if (canBeReorderedProcessed) apiRef.current.setColumnIndex(dragColField, targetColIndex + indexOffsetInHiddenColumns);
            }
            cursorPosition.current = coordinates;
        }
    }, [
        apiRef,
        logger,
        isRtl
    ]);
    const handleDragEnd = $lCzvA.useCallback((params, event)=>{
        const dragColField = (0, $bdcbdcb1173dfe90$export$78d24cc7373bc611)(apiRef);
        if (props.disableColumnReorder || !dragColField) return;
        logger.debug('End dragging col');
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        clearTimeout(removeDnDStylesTimeout.current);
        // For more information check here https://github.com/mui/mui-x/issues/14678
        if (dragColNode.current.classList.contains(classes.columnHeaderDragging)) dragColNode.current.classList.remove(classes.columnHeaderDragging);
        dragColNode.current = null;
        // Check if the column was dropped outside the grid.
        if (event.dataTransfer.dropEffect === 'none' && !props.keepColumnPositionIfDraggedOutside) {
            // Accessing params.field may contain the wrong field as header elements are reused
            apiRef.current.setColumnIndex(dragColField, originColumnIndex.current);
            originColumnIndex.current = null;
        } else {
            // Emit the columnOrderChange event only once when the reordering stops.
            const columnOrderChangeParams = {
                column: apiRef.current.getColumn(dragColField),
                targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(dragColField),
                oldIndex: originColumnIndex.current
            };
            apiRef.current.publishEvent('columnOrderChange', columnOrderChangeParams);
        }
        apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                columnReorder: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.columnReorder, {
                    dragCol: ''
                })
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.disableColumnReorder,
        props.keepColumnPositionIfDraggedOutside,
        logger,
        classes.columnHeaderDragging
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragStart', handleDragStart);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragEnter', handleDragEnter);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragOver', handleDragOver);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragEnd', handleDragEnd);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellDragEnter', handleDragEnter);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellDragOver', handleDragOver);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'columnOrderChange', props.onColumnOrderChange);
};



var $lCzvA = parcelRequire("lCzvA");




const $2870559ec8ca294f$export$eed79627d7deb3a5 = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4), {
    type: 'custom',
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    disableReorder: true,
    align: 'left',
    width: 200,
    valueGetter: (value, row, column, apiRef)=>{
        const rowId = (0, $c0782207122e35d1$export$5e766ecd73f055ed)(apiRef.current.state, row);
        const rowNode = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(apiRef)[rowId];
        return rowNode?.type === 'group' || rowNode?.type === 'leaf' ? rowNode.groupingKey : undefined;
    }
});
const $2870559ec8ca294f$export$1a0175c947f58fd3 = {
    field: (0, $3cb6fcdeb46bf88d$export$9cce4aaa860dd90a),
    editable: false,
    groupable: false
};


const $9fff98019ad208b0$export$15cdd24474e74350 = (apiRef, props)=>{
    /**
   * EVENTS
   */ const handleCellKeyDown = $lCzvA.useCallback((params, event)=>{
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.colDef.field === (0, $3cb6fcdeb46bf88d$export$9cce4aaa860dd90a) && (event.key === ' ' || event.key === 'Enter') && !event.shiftKey) {
            if (params.rowNode.type !== 'group') return;
            if (props.unstable_dataSource && !params.rowNode.childrenExpanded) {
                apiRef.current.unstable_dataSource.fetchRows(params.id);
                return;
            }
            apiRef.current.setRowChildrenExpansion(params.id, !params.rowNode.childrenExpanded);
        }
    }, [
        apiRef,
        props.unstable_dataSource
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', handleCellKeyDown);
};





var $lCzvA = parcelRequire("lCzvA");




let $b73ac5b7bdbb5681$export$8421a4723b13126c = /*#__PURE__*/ function(TreeDataStrategy) {
    TreeDataStrategy["Default"] = "tree-data";
    TreeDataStrategy["DataSource"] = "tree-data-source";
    return TreeDataStrategy;
}({});
const $b73ac5b7bdbb5681$export$d431177e37819461 = (params)=>{
    const { apiRef: apiRef, rowTree: rowTree, disableChildrenFiltering: disableChildrenFiltering, isRowMatchingFilters: isRowMatchingFilters } = params;
    const filteredRowsLookup = {};
    const filteredChildrenCountLookup = {};
    const filteredDescendantCountLookup = {};
    const filterCache = {};
    const filterResults = {
        passingFilterItems: null,
        passingQuickFilterValues: null
    };
    const filterTreeNode = (node, isParentMatchingFilters, areAncestorsExpanded)=>{
        const shouldSkipFilters = disableChildrenFiltering && node.depth > 0;
        let isMatchingFilters;
        if (shouldSkipFilters) isMatchingFilters = null;
        else if (!isRowMatchingFilters || node.type === 'footer') isMatchingFilters = true;
        else {
            const row = apiRef.current.getRow(node.id);
            isRowMatchingFilters(row, undefined, filterResults);
            isMatchingFilters = (0, $bb45a78aee581510$export$8d82b4490466f182)([
                filterResults.passingFilterItems
            ], [
                filterResults.passingQuickFilterValues
            ], params.filterModel, params.apiRef, filterCache);
        }
        let filteredChildrenCount = 0;
        let filteredDescendantCount = 0;
        if (node.type === 'group') node.children.forEach((childId)=>{
            const childNode = rowTree[childId];
            const childSubTreeSize = filterTreeNode(childNode, isMatchingFilters ?? isParentMatchingFilters, areAncestorsExpanded && !!node.childrenExpanded);
            filteredDescendantCount += childSubTreeSize;
            if (childSubTreeSize > 0) filteredChildrenCount += 1;
        });
        let shouldPassFilters;
        switch(isMatchingFilters){
            case true:
                shouldPassFilters = true;
                break;
            case false:
                shouldPassFilters = filteredDescendantCount > 0;
                break;
            default:
                shouldPassFilters = isParentMatchingFilters;
                break;
        }
        filteredRowsLookup[node.id] = shouldPassFilters;
        if (!shouldPassFilters) return 0;
        filteredChildrenCountLookup[node.id] = filteredChildrenCount;
        filteredDescendantCountLookup[node.id] = filteredDescendantCount;
        if (node.type === 'footer') return filteredDescendantCount;
        return filteredDescendantCount + 1;
    };
    const nodes = Object.values(rowTree);
    for(let i = 0; i < nodes.length; i += 1){
        const node = nodes[i];
        if (node.depth === 0) filterTreeNode(node, true, true);
    }
    return {
        filteredRowsLookup: filteredRowsLookup,
        filteredChildrenCountLookup: filteredChildrenCountLookup,
        filteredDescendantCountLookup: filteredDescendantCountLookup
    };
};



parcelRequire("lCzvA");



var $lCzvA = parcelRequire("lCzvA");





'use client';
function $07f74744152b3a72$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $36107f55192c81c9$export$2e2bcd8739ae039)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $6202cd269daefe72$export$2e2bcd8739ae039));
    const Box = /*#__PURE__*/ $lCzvA.forwardRef(function Box(inProps, ref) {
        const theme = (0, $25e31e085eebfdce$export$2e2bcd8739ae039)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $0b50965511eefd52$export$2e2bcd8739ae039)(inProps);
        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}







const $aa81f746261298bc$var$boxClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiBox', [
    'root'
]);
var $aa81f746261298bc$export$2e2bcd8739ae039 = $aa81f746261298bc$var$boxClasses;


'use client';
const $0f60498376c5ed81$var$defaultTheme = (0, $d0927e891b7f77c8$export$2e2bcd8739ae039)();
const $0f60498376c5ed81$var$Box = (0, $07f74744152b3a72$export$2e2bcd8739ae039)({
    themeId: (0, $e8b56ec99e409d23$export$2e2bcd8739ae039),
    defaultTheme: $0f60498376c5ed81$var$defaultTheme,
    defaultClassName: (0, $aa81f746261298bc$export$2e2bcd8739ae039).root,
    generateClassName: (0, $bfaaee51e25ede3c$export$2e2bcd8739ae039).generate
});
var $0f60498376c5ed81$export$2e2bcd8739ae039 = $0f60498376c5ed81$var$Box;




const $f77ecd984229db9c$export$8b0f8e71b71b7ed3 = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3);



const $921f9bb18367670e$export$2d14edd3a7db3bbf = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf);



const $493370c1acd2a2ca$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'treeDataGroupingCell'
        ],
        toggle: [
            'treeDataGroupingCellToggle'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $493370c1acd2a2ca$export$27e53dafb413f7b(props) {
    const { id: id, field: field, formattedValue: formattedValue, rowNode: rowNode, hideDescendantCount: hideDescendantCount, offsetMultiplier: offsetMultiplier = 2 } = props;
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $921f9bb18367670e$export$2d14edd3a7db3bbf)();
    const classes = $493370c1acd2a2ca$var$useUtilityClasses(rootProps);
    const filteredDescendantCountLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$28e99d5260ff82e7));
    const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;
    const Icon = rowNode.childrenExpanded ? rootProps.slots.treeDataCollapseIcon : rootProps.slots.treeDataExpandIcon;
    const handleClick = (event)=>{
        apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
        apiRef.current.setCellFocus(id, field);
        event.stopPropagation(); // TODO remove event.stopPropagation
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $0f60498376c5ed81$export$2e2bcd8739ae039), {
        className: classes.root,
        sx: {
            ml: rowNode.depth * offsetMultiplier
        },
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: classes.toggle,
                children: filteredDescendantCount > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                    size: "small",
                    onClick: handleClick,
                    tabIndex: -1,
                    "aria-label": rowNode.childrenExpanded ? apiRef.current.getLocaleText('treeDataCollapse') : apiRef.current.getLocaleText('treeDataExpand')
                }, rootProps?.slotProps?.baseIconButton, {
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Icon, {
                        fontSize: "inherit"
                    })
                }))
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                children: [
                    formattedValue === undefined ? rowNode.groupingKey : formattedValue,
                    !hideDescendantCount && filteredDescendantCount > 0 ? ` (${filteredDescendantCount})` : ''
                ]
            })
        ]
    });
}







const $ded28721040d07ec$export$d5e283255c81e0fd = (path)=>{
    const pathStr = path.map((groupingCriteria)=>`${groupingCriteria.field}/${groupingCriteria.key}`).join('-');
    return `auto-generated-row-${pathStr}`;
};
const $ded28721040d07ec$export$abc1fabe591b697e = ({ id: id, tree: tree })=>{
    const path = [];
    let node = tree[id];
    while(node.id !== (0, $dc4fe3453cdb0a0a$export$433b924dc2506913)){
        path.push({
            field: node.type === 'leaf' ? null : node.groupingField,
            key: node.groupingKey
        });
        node = tree[node.parent];
    }
    path.reverse();
    return path;
};
const $ded28721040d07ec$export$ae2bc3372e741cd4 = (node, defaultGroupingExpansionDepth, isGroupExpandedByDefault)=>{
    let childrenExpanded;
    if (node.id === (0, $dc4fe3453cdb0a0a$export$433b924dc2506913)) childrenExpanded = true;
    else if (isGroupExpandedByDefault) childrenExpanded = isGroupExpandedByDefault(node);
    else childrenExpanded = defaultGroupingExpansionDepth === -1 || defaultGroupingExpansionDepth > node.depth;
    return childrenExpanded;
};
const $ded28721040d07ec$export$5ba8ca32800e0e56 = (node, defaultGroupingExpansionDepth, isGroupExpandedByDefault)=>{
    const childrenExpanded = $ded28721040d07ec$export$ae2bc3372e741cd4(node, defaultGroupingExpansionDepth, isGroupExpandedByDefault);
    node.childrenExpanded = childrenExpanded;
    return node;
};
const $ded28721040d07ec$export$e179dd88ba706b74 = (node, tree, treeDepths, previousTree)=>{
    // 1. Insert node in the tree.
    tree[node.id] = node;
    // 2. Increment the `treeDepths` object for the node's depth.
    treeDepths[node.depth] = (treeDepths[node.depth] ?? 0) + 1;
    // 3. Register the new node in its parent.
    const parentNode = tree[node.parent];
    if (node.type === 'group' || node.type === 'leaf') {
        // For groups and leaves,
        // Register the node from its parents `children` and `childrenFromPath` properties.
        const groupingFieldName = node.groupingField ?? '__no_field__';
        const groupingKeyName = node.groupingKey ?? '__no_key__';
        const groupingField = parentNode.childrenFromPath?.[groupingFieldName];
        if (previousTree !== null && previousTree[parentNode.id] === tree[parentNode.id]) parentNode.children = [
            ...parentNode.children,
            node.id
        ];
        else parentNode.children.push(node.id);
        if (groupingField == null) parentNode.childrenFromPath[groupingFieldName] = {
            [groupingKeyName.toString()]: node.id
        };
        else groupingField[groupingKeyName.toString()] = node.id;
    } else if (node.type === 'footer') // For footers,
    // Register the node from its parent `footerId` property.
    parentNode.footerId = node.id;
};
const $ded28721040d07ec$export$a0e1f1bcb4742ea5 = ({ node: node, tree: tree, treeDepths: treeDepths })=>{
    // 1. Remove node from the tree.
    delete tree[node.id];
    // 2. Decrement the `treeDepths` object for the node's depth.
    const nodeDepth = node.depth;
    const currentNodeCount = treeDepths[nodeDepth];
    if (currentNodeCount === 1) delete treeDepths[nodeDepth];
    else treeDepths[nodeDepth] = currentNodeCount - 1;
    // 3. Unregister the new node in its parent.
    const parentNode = tree[node.parent];
    // For footers,
    // Unregister the node from its parent `footerId` property.
    if (node.type === 'footer') tree[parentNode.id] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, parentNode, {
        footerId: null
    });
    else {
        const groupingField = node.groupingField ?? '__no_field__';
        const groupingKey = node.groupingKey ?? '__no_key__';
        // TODO rows v6: Can we avoid this linear complexity ?
        const children = parentNode.children.filter((childId)=>childId !== node.id);
        const childrenFromPath = parentNode.childrenFromPath;
        delete childrenFromPath[groupingField][groupingKey.toString()];
        tree[parentNode.id] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, parentNode, {
            children: children,
            childrenFromPath: childrenFromPath
        });
    }
};
const $ded28721040d07ec$export$8401d879c7fe4ac0 = ({ node: node, updatedNode: updatedNode, previousTree: previousTree, tree: tree, treeDepths: treeDepths })=>{
    // 1. Set the new parent for all children from the old group
    node.children.forEach((childId)=>{
        tree[childId] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, tree[childId], {
            parent: updatedNode.id
        });
    });
    // 2. Remove the old group from the tree
    $ded28721040d07ec$export$a0e1f1bcb4742ea5({
        node: node,
        tree: tree,
        treeDepths: treeDepths
    });
    // 3. Add the new group in the tree
    const groupNode = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, node, updatedNode);
    $ded28721040d07ec$export$e179dd88ba706b74(groupNode, tree, treeDepths, previousTree);
};
const $ded28721040d07ec$export$3978044dae9c217d = ()=>({
        value: {},
        addAction (groupId, action) {
            if (!this.value[groupId]) this.value[groupId] = {};
            this.value[groupId][action] = true;
        }
    });
const $ded28721040d07ec$export$9cf22cc325f95ed4 = ({ tree: tree, filteredRowsLookup: filteredRowsLookup })=>{
    if (!filteredRowsLookup) return {};
    const visibleRowsLookup = {};
    const handleTreeNode = (node, areAncestorsExpanded)=>{
        const isPassingFiltering = filteredRowsLookup[node.id] !== false;
        if (node.type === 'group') node.children.forEach((childId)=>{
            const childNode = tree[childId];
            handleTreeNode(childNode, areAncestorsExpanded && !!node.childrenExpanded);
        });
        visibleRowsLookup[node.id] = isPassingFiltering && areAncestorsExpanded;
        // TODO rows v6: Should we keep storing the visibility status of footer independently or rely on the group visibility in the selector ?
        if (node.type === 'group' && node.footerId != null) visibleRowsLookup[node.footerId] = isPassingFiltering && areAncestorsExpanded && !!node.childrenExpanded;
    };
    const nodes = Object.values(tree);
    for(let i = 0; i < nodes.length; i += 1){
        const node = nodes[i];
        if (node.depth === 0) handleTreeNode(node, true);
    }
    return visibleRowsLookup;
};


const $628ba5ad6926b6a7$export$8234f639803f3161 = ({ id: id, path: path, updatedGroupsManager: updatedGroupsManager, previousTree: previousTree, tree: tree, treeDepths: treeDepths, onDuplicatePath: onDuplicatePath, isGroupExpandedByDefault: isGroupExpandedByDefault, defaultGroupingExpansionDepth: defaultGroupingExpansionDepth, serverChildrenCount: serverChildrenCount, groupsToFetch: groupsToFetch })=>{
    let parentNodeId = (0, $dc4fe3453cdb0a0a$export$433b924dc2506913);
    for(let depth = 0; depth < path.length; depth += 1){
        const { key: key, field: field } = path[depth];
        const fieldWithDefaultValue = field ?? '__no_field__';
        const keyWithDefaultValue = key ?? '__no_key__';
        const existingNodeIdWithPartialPath = tree[parentNodeId].childrenFromPath?.[fieldWithDefaultValue]?.[keyWithDefaultValue.toString()];
        // When we reach the last step of the path,
        // We need to create a node for the row passed to `insertNodeInTree`
        if (depth === path.length - 1) {
            // If no node matches the full path,
            // We create a leaf node for the data row.
            if (existingNodeIdWithPartialPath == null) {
                let node;
                if (serverChildrenCount !== undefined && serverChildrenCount !== 0) {
                    node = {
                        type: 'group',
                        id: id,
                        parent: parentNodeId,
                        path: path.map((step)=>step.key),
                        depth: depth,
                        isAutoGenerated: false,
                        groupingKey: key,
                        groupingField: field,
                        children: [],
                        childrenFromPath: {},
                        childrenExpanded: false,
                        serverChildrenCount: serverChildrenCount
                    };
                    const shouldFetchChildren = (0, $ded28721040d07ec$export$ae2bc3372e741cd4)(node, defaultGroupingExpansionDepth, isGroupExpandedByDefault);
                    if (shouldFetchChildren) groupsToFetch?.add(id);
                } else node = {
                    type: 'leaf',
                    id: id,
                    depth: depth,
                    parent: parentNodeId,
                    groupingKey: key
                };
                updatedGroupsManager?.addAction(parentNodeId, 'insertChildren');
                (0, $ded28721040d07ec$export$e179dd88ba706b74)(node, tree, treeDepths, previousTree);
            } else {
                const existingNodeWithPartialPath = tree[existingNodeIdWithPartialPath];
                // If we already have an auto-generated group matching the partial path,
                // We replace it with the node from of data row passed to `insertNodeInTree`
                if (existingNodeWithPartialPath.type === 'group' && existingNodeWithPartialPath.isAutoGenerated) {
                    updatedGroupsManager?.addAction(parentNodeId, 'removeChildren');
                    updatedGroupsManager?.addAction(parentNodeId, 'insertChildren');
                    (0, $ded28721040d07ec$export$8401d879c7fe4ac0)({
                        tree: tree,
                        previousTree: previousTree,
                        treeDepths: treeDepths,
                        node: existingNodeWithPartialPath,
                        updatedNode: {
                            id: id,
                            isAutoGenerated: false
                        }
                    });
                } else // If we have another row matching the partial path, then there is a duplicate in the dataset.
                // We warn the user and skip the current row.
                onDuplicatePath?.(existingNodeIdWithPartialPath, id, path);
            }
        } else if (existingNodeIdWithPartialPath == null) {
            const nodeId = (0, $ded28721040d07ec$export$d5e283255c81e0fd)(path.slice(0, depth + 1));
            const autoGeneratedGroupNode = {
                type: 'group',
                id: nodeId,
                parent: parentNodeId,
                depth: depth,
                isAutoGenerated: true,
                groupingKey: key,
                groupingField: field,
                children: [],
                childrenFromPath: {},
                childrenExpanded: false
            };
            updatedGroupsManager?.addAction(parentNodeId, 'insertChildren');
            (0, $ded28721040d07ec$export$e179dd88ba706b74)((0, $ded28721040d07ec$export$5ba8ca32800e0e56)(autoGeneratedGroupNode, defaultGroupingExpansionDepth, isGroupExpandedByDefault), tree, treeDepths, previousTree);
            parentNodeId = nodeId;
        } else {
            const currentGroupNode = tree[existingNodeIdWithPartialPath];
            // If the node matching the partial path is not a group, we turn it into a group
            if (currentGroupNode.type !== 'group') {
                const groupNode = {
                    type: 'group',
                    id: currentGroupNode.id,
                    parent: currentGroupNode.parent,
                    depth: currentGroupNode.depth,
                    isAutoGenerated: false,
                    groupingKey: key,
                    groupingField: field,
                    children: [],
                    childrenFromPath: {},
                    childrenExpanded: false
                };
                tree[existingNodeIdWithPartialPath] = (0, $ded28721040d07ec$export$5ba8ca32800e0e56)(groupNode, defaultGroupingExpansionDepth, isGroupExpandedByDefault);
            }
            parentNodeId = currentGroupNode.id;
        }
    }
};


const $cb7435717e6a3616$export$230dd60fadcbc35b = (params)=>{
    const dataRowIds = [];
    const tree = {
        [(0, $dc4fe3453cdb0a0a$export$433b924dc2506913)]: (0, $dc4fe3453cdb0a0a$export$96a607054e9bfd0c)()
    };
    const treeDepths = {};
    const groupsToFetch = new Set();
    for(let i = 0; i < params.nodes.length; i += 1){
        const node = params.nodes[i];
        dataRowIds.push(node.id);
        (0, $628ba5ad6926b6a7$export$8234f639803f3161)({
            tree: tree,
            previousTree: params.previousTree,
            id: node.id,
            path: node.path,
            serverChildrenCount: node.serverChildrenCount,
            onDuplicatePath: params.onDuplicatePath,
            treeDepths: treeDepths,
            isGroupExpandedByDefault: params.isGroupExpandedByDefault,
            defaultGroupingExpansionDepth: params.defaultGroupingExpansionDepth,
            groupsToFetch: groupsToFetch
        });
    }
    return {
        tree: tree,
        treeDepths: treeDepths,
        groupingName: params.groupingName,
        dataRowIds: dataRowIds,
        groupsToFetch: Array.from(groupsToFetch)
    };
};



// Single-linked list node
class $0e592747a1481ca8$var$Node {
    constructor(data, next){
        this.next = void 0;
        this.data = void 0;
        this.next = next;
        this.data = data;
    }
    insertAfter(list) {
        if (!list.first || !list.last) return;
        const next = this.next;
        this.next = list.first;
        list.last.next = next;
    }
}
// Single-linked list container
class $0e592747a1481ca8$var$List {
    constructor(first, last){
        this.first = void 0;
        this.last = void 0;
        this.first = first;
        this.last = last;
    }
    data() {
        const array = [];
        this.forEach((node)=>{
            array.push(node.data);
        });
        return array;
    }
    forEach(fn) {
        let current = this.first;
        while(current !== null){
            fn(current);
            current = current.next;
        }
    }
    static from(array) {
        if (array.length === 0) return new $0e592747a1481ca8$var$List(null, null);
        let index = 0;
        const first = new $0e592747a1481ca8$var$Node(array[index], null);
        let current = first;
        while(index + 1 < array.length){
            index += 1;
            const node = new $0e592747a1481ca8$var$Node(array[index], null);
            current.next = node;
            current = node;
        }
        return new $0e592747a1481ca8$var$List(first, current);
    }
}
const $0e592747a1481ca8$export$3da49b8141c52d70 = (params)=>{
    const { rowTree: rowTree, disableChildrenSorting: disableChildrenSorting, sortRowList: sortRowList, shouldRenderGroupBelowLeaves: shouldRenderGroupBelowLeaves } = params;
    const sortedGroupedByParentRows = new Map();
    const sortGroup = (node)=>{
        const shouldSortGroup = !!sortRowList && (!disableChildrenSorting || node.depth === -1);
        let sortedRowIds;
        if (shouldSortGroup) {
            for(let i = 0; i < node.children.length; i += 1){
                const childNode = rowTree[node.children[i]];
                if (childNode.type === 'group') sortGroup(childNode);
            }
            sortedRowIds = sortRowList(node.children.map((childId)=>rowTree[childId]));
        } else if (shouldRenderGroupBelowLeaves) {
            const childrenLeaves = [];
            const childrenGroups = [];
            for(let i = 0; i < node.children.length; i += 1){
                const childId = node.children[i];
                const childNode = rowTree[childId];
                if (childNode.type === 'group') {
                    sortGroup(childNode);
                    childrenGroups.push(childId);
                } else if (childNode.type === 'leaf') childrenLeaves.push(childId);
            }
            sortedRowIds = [
                ...childrenLeaves,
                ...childrenGroups
            ];
        } else {
            for(let i = 0; i < node.children.length; i += 1){
                const childNode = rowTree[node.children[i]];
                if (childNode.type === 'group') sortGroup(childNode);
            }
            sortedRowIds = [
                ...node.children
            ];
        }
        if (node.footerId != null) sortedRowIds.push(node.footerId);
        sortedGroupedByParentRows.set(node.id, sortedRowIds);
    };
    sortGroup(rowTree[0, $dc4fe3453cdb0a0a$export$433b924dc2506913]);
    const rootList = $0e592747a1481ca8$var$List.from(sortedGroupedByParentRows.get((0, $dc4fe3453cdb0a0a$export$433b924dc2506913)));
    rootList.forEach((node)=>{
        const children = sortedGroupedByParentRows.get(node.data);
        if (children?.length) node.insertAfter($0e592747a1481ca8$var$List.from(children));
    });
    return rootList.data();
};








const $09da1af83f3ad7f2$var$removeNodeAndCleanParent = ({ node: node, tree: tree, treeDepths: treeDepths, updatedGroupsManager: updatedGroupsManager })=>{
    (0, $ded28721040d07ec$export$a0e1f1bcb4742ea5)({
        node: node,
        tree: tree,
        treeDepths: treeDepths
    });
    if (node.type === 'group' && node.footerId != null) (0, $ded28721040d07ec$export$a0e1f1bcb4742ea5)({
        node: tree[node.footerId],
        tree: tree,
        treeDepths: treeDepths
    });
    const parentNode = tree[node.parent];
    updatedGroupsManager?.addAction(parentNode.id, 'removeChildren');
    const shouldDeleteGroup = parentNode.id !== (0, $dc4fe3453cdb0a0a$export$433b924dc2506913) && parentNode.children.length === 0;
    if (shouldDeleteGroup) {
        if (parentNode.isAutoGenerated) $09da1af83f3ad7f2$var$removeNodeAndCleanParent({
            node: parentNode,
            tree: tree,
            treeDepths: treeDepths
        });
        else tree[parentNode.id] = {
            type: 'leaf',
            id: parentNode.id,
            depth: parentNode.depth,
            parent: parentNode.parent,
            groupingKey: parentNode.groupingKey
        };
    }
};
const $09da1af83f3ad7f2$var$replaceDataGroupWithAutoGeneratedGroup = ({ node: node, tree: tree, treeDepths: treeDepths, updatedGroupsManager: updatedGroupsManager })=>{
    updatedGroupsManager?.addAction(node.parent, 'removeChildren');
    updatedGroupsManager?.addAction(node.parent, 'insertChildren');
    (0, $ded28721040d07ec$export$8401d879c7fe4ac0)({
        previousTree: null,
        tree: tree,
        treeDepths: treeDepths,
        node: node,
        updatedNode: {
            id: (0, $ded28721040d07ec$export$d5e283255c81e0fd)((0, $ded28721040d07ec$export$abc1fabe591b697e)({
                id: node.id,
                tree: tree
            })),
            isAutoGenerated: true
        }
    });
};
const $09da1af83f3ad7f2$export$cf388a54c0cc8532 = ({ id: id, tree: tree, treeDepths: treeDepths, updatedGroupsManager: updatedGroupsManager })=>{
    const node = tree[id];
    if (node.type === 'group' && node.children.length > 0) $09da1af83f3ad7f2$var$replaceDataGroupWithAutoGeneratedGroup({
        node: node,
        tree: tree,
        treeDepths: treeDepths,
        updatedGroupsManager: updatedGroupsManager
    });
    else $09da1af83f3ad7f2$var$removeNodeAndCleanParent({
        node: node,
        tree: tree,
        treeDepths: treeDepths,
        updatedGroupsManager: updatedGroupsManager
    });
};



const $2642ce5a10a7208d$export$95db6bdce2927ab = (params)=>{
    const tree = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params.previousTree);
    const treeDepths = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params.previousTreeDepth);
    const updatedGroupsManager = (0, $ded28721040d07ec$export$3978044dae9c217d)();
    const groupsToFetch = params.previousGroupsToFetch ? new Set([
        ...params.previousGroupsToFetch
    ]) : new Set([]);
    for(let i = 0; i < params.nodes.inserted.length; i += 1){
        const { id: id, path: path, serverChildrenCount: serverChildrenCount } = params.nodes.inserted[i];
        (0, $628ba5ad6926b6a7$export$8234f639803f3161)({
            previousTree: params.previousTree,
            tree: tree,
            treeDepths: treeDepths,
            updatedGroupsManager: updatedGroupsManager,
            id: id,
            path: path,
            serverChildrenCount: serverChildrenCount,
            onDuplicatePath: params.onDuplicatePath,
            isGroupExpandedByDefault: params.isGroupExpandedByDefault,
            defaultGroupingExpansionDepth: params.defaultGroupingExpansionDepth,
            groupsToFetch: groupsToFetch
        });
    }
    for(let i = 0; i < params.nodes.removed.length; i += 1){
        const nodeId = params.nodes.removed[i];
        (0, $09da1af83f3ad7f2$export$cf388a54c0cc8532)({
            tree: tree,
            treeDepths: treeDepths,
            updatedGroupsManager: updatedGroupsManager,
            id: nodeId
        });
    }
    for(let i = 0; i < params.nodes.modified.length; i += 1){
        const { id: id, path: path, serverChildrenCount: serverChildrenCount } = params.nodes.modified[i];
        const pathInPreviousTree = (0, $ded28721040d07ec$export$abc1fabe591b697e)({
            tree: tree,
            id: id
        });
        const isInSameGroup = (0, $ac3bd7253ec0e92a$export$78fdc9adc3f30400)(pathInPreviousTree, path);
        if (!isInSameGroup) {
            (0, $09da1af83f3ad7f2$export$cf388a54c0cc8532)({
                tree: tree,
                treeDepths: treeDepths,
                updatedGroupsManager: updatedGroupsManager,
                id: id
            });
            (0, $628ba5ad6926b6a7$export$8234f639803f3161)({
                previousTree: params.previousTree,
                tree: tree,
                treeDepths: treeDepths,
                updatedGroupsManager: updatedGroupsManager,
                id: id,
                path: path,
                serverChildrenCount: serverChildrenCount,
                onDuplicatePath: params.onDuplicatePath,
                isGroupExpandedByDefault: params.isGroupExpandedByDefault,
                defaultGroupingExpansionDepth: params.defaultGroupingExpansionDepth,
                groupsToFetch: groupsToFetch
            });
        } else updatedGroupsManager?.addAction(tree[id].parent, 'modifyChildren');
    }
    // TODO rows v6: Avoid walking the whole tree, we should be able to generate the new list only using slices.
    const dataRowIds = (0, $dc4fe3453cdb0a0a$export$9380f4bcafb87e49)(tree, (0, $dc4fe3453cdb0a0a$export$433b924dc2506913), true);
    return {
        tree: tree,
        treeDepths: treeDepths,
        groupingName: params.groupingName,
        dataRowIds: dataRowIds,
        updatedGroupsManager: updatedGroupsManager,
        groupsToFetch: Array.from(groupsToFetch)
    };
};




const $f039f7d30e484b6e$var$_excluded = [
    "hideDescendantCount"
];
const $f039f7d30e484b6e$export$7e966b04a1d3262a = (privateApiRef, props)=>{
    const setStrategyAvailability = $lCzvA.useCallback(()=>{
        privateApiRef.current.setStrategyAvailability('rowTree', (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).Default, props.treeData && !props.unstable_dataSource ? ()=>true : ()=>false);
    }, [
        privateApiRef,
        props.treeData,
        props.unstable_dataSource
    ]);
    const getGroupingColDef = $lCzvA.useCallback(()=>{
        const groupingColDefProp = props.groupingColDef;
        let colDefOverride;
        if (typeof groupingColDefProp === 'function') {
            const params = {
                groupingName: (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).Default,
                fields: []
            };
            colDefOverride = groupingColDefProp(params);
        } else colDefOverride = groupingColDefProp;
        const _ref = colDefOverride ?? {}, { hideDescendantCount: hideDescendantCount } = _ref, colDefOverrideProperties = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_ref, $f039f7d30e484b6e$var$_excluded);
        const commonProperties = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $2870559ec8ca294f$export$eed79627d7deb3a5), {
            renderCell: (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $493370c1acd2a2ca$export$27e53dafb413f7b), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params, {
                    hideDescendantCount: hideDescendantCount
                })),
            headerName: privateApiRef.current.getLocaleText('treeDataGroupingHeaderName')
        });
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, commonProperties, colDefOverrideProperties, (0, $2870559ec8ca294f$export$1a0175c947f58fd3));
    }, [
        privateApiRef,
        props.groupingColDef
    ]);
    const updateGroupingColumn = $lCzvA.useCallback((columnsState)=>{
        if (props.unstable_dataSource) return columnsState;
        const groupingColDefField = (0, $2870559ec8ca294f$export$1a0175c947f58fd3).field;
        const shouldHaveGroupingColumn = props.treeData;
        const prevGroupingColumn = columnsState.lookup[groupingColDefField];
        if (shouldHaveGroupingColumn) {
            const newGroupingColumn = getGroupingColDef();
            if (prevGroupingColumn) {
                newGroupingColumn.width = prevGroupingColumn.width;
                newGroupingColumn.flex = prevGroupingColumn.flex;
            }
            columnsState.lookup[groupingColDefField] = newGroupingColumn;
            if (prevGroupingColumn == null) columnsState.orderedFields = [
                groupingColDefField,
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveGroupingColumn && prevGroupingColumn) {
            delete columnsState.lookup[groupingColDefField];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== groupingColDefField);
        }
        return columnsState;
    }, [
        props.treeData,
        props.unstable_dataSource,
        getGroupingColDef
    ]);
    const createRowTreeForTreeData = $lCzvA.useCallback((params)=>{
        if (!props.getTreeDataPath) throw new Error('MUI X: No getTreeDataPath given.');
        const getRowTreeBuilderNode = (rowId)=>({
                id: rowId,
                path: props.getTreeDataPath(params.dataRowIdToModelLookup[rowId]).map((key)=>({
                        key: key,
                        field: null
                    }))
            });
        const onDuplicatePath = (firstId, secondId, path)=>{
            throw new Error([
                'MUI X: The path returned by `getTreeDataPath` should be unique.',
                `The rows with id #${firstId} and #${secondId} have the same.`,
                `Path: ${JSON.stringify(path.map((step)=>step.key))}.`
            ].join('\n'));
        };
        if (params.updates.type === 'full') return (0, $cb7435717e6a3616$export$230dd60fadcbc35b)({
            previousTree: params.previousTree,
            nodes: params.updates.rows.map(getRowTreeBuilderNode),
            defaultGroupingExpansionDepth: props.defaultGroupingExpansionDepth,
            isGroupExpandedByDefault: props.isGroupExpandedByDefault,
            groupingName: (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).Default,
            onDuplicatePath: onDuplicatePath
        });
        return (0, $2642ce5a10a7208d$export$95db6bdce2927ab)({
            nodes: {
                inserted: params.updates.actions.insert.map(getRowTreeBuilderNode),
                modified: params.updates.actions.modify.map(getRowTreeBuilderNode),
                removed: params.updates.actions.remove
            },
            previousTree: params.previousTree,
            previousTreeDepth: params.previousTreeDepths,
            defaultGroupingExpansionDepth: props.defaultGroupingExpansionDepth,
            isGroupExpandedByDefault: props.isGroupExpandedByDefault,
            groupingName: (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).Default
        });
    }, [
        props.getTreeDataPath,
        props.defaultGroupingExpansionDepth,
        props.isGroupExpandedByDefault
    ]);
    const filterRows = $lCzvA.useCallback((params)=>{
        const rowTree = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(privateApiRef);
        return (0, $b73ac5b7bdbb5681$export$d431177e37819461)({
            rowTree: rowTree,
            isRowMatchingFilters: params.isRowMatchingFilters,
            disableChildrenFiltering: props.disableChildrenFiltering,
            filterModel: params.filterModel,
            apiRef: privateApiRef
        });
    }, [
        privateApiRef,
        props.disableChildrenFiltering
    ]);
    const sortRows = $lCzvA.useCallback((params)=>{
        const rowTree = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(privateApiRef);
        return (0, $0e592747a1481ca8$export$3da49b8141c52d70)({
            rowTree: rowTree,
            sortRowList: params.sortRowList,
            disableChildrenSorting: props.disableChildrenSorting,
            shouldRenderGroupBelowLeaves: false
        });
    }, [
        privateApiRef,
        props.disableChildrenSorting
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(privateApiRef, 'hydrateColumns', updateGroupingColumn);
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(privateApiRef, (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).Default, 'rowTreeCreation', createRowTreeForTreeData);
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(privateApiRef, (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).Default, 'filtering', filterRows);
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(privateApiRef, (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).Default, 'sorting', sortRows);
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(privateApiRef, (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).Default, 'visibleRowsLookupCreation', (0, $ded28721040d07ec$export$9cf22cc325f95ed4));
    /**
   * 1ST RENDER
   */ (0, $9ebf8f53803465ea$export$c5623aa1c38918b6)(()=>{
        setStrategyAvailability();
    });
    /**
   * EFFECTS
   */ const isFirstRender = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (!isFirstRender.current) setStrategyAvailability();
        else isFirstRender.current = false;
    }, [
        setStrategyAvailability
    ]);
};





var $lCzvA = parcelRequire("lCzvA");





function $efdee3b4a42b2677$export$dd82b2d5f43ae0b4(rowTree) {
    const filteredRowsLookup = {};
    const filteredChildrenCountLookup = {};
    const nodes = Object.values(rowTree);
    for(let i = 0; i < nodes.length; i += 1){
        const node = nodes[i];
        filteredRowsLookup[node.id] = true;
        filteredChildrenCountLookup[node.id] = node.serverChildrenCount ?? 0;
    }
    return {
        filteredRowsLookup: filteredRowsLookup,
        filteredChildrenCountLookup: filteredChildrenCountLookup,
        filteredDescendantCountLookup: (0, $88b02358d3d53b62$export$f5e27122a659c0c).filteredDescendantCountLookup
    };
}
function $efdee3b4a42b2677$export$f2f2fee19447200b(rowTree) {
    return (0, $dc4fe3453cdb0a0a$export$9380f4bcafb87e49)(rowTree, (0, $dc4fe3453cdb0a0a$export$433b924dc2506913), false);
}



parcelRequire("lCzvA");







const $63cda09cd66be3ca$export$e1fd9274eb96ee18 = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18);





const $60c6fa93e6a0b804$var$computeStartEnd = (paginationModel)=>{
    const start = paginationModel.page * paginationModel.pageSize;
    const end = start + paginationModel.pageSize - 1;
    return {
        start: start,
        end: end
    };
};
const $60c6fa93e6a0b804$export$85108be54a256312 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)((0, $6450fc0917754b27$export$280aedb9454597a5), (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9), (0, $017d03038815cc56$export$ccc9f04e59d0d8e6), (filterModel, sortModel, paginationModel)=>{
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        groupKeys: [],
        paginationModel: paginationModel,
        sortModel: sortModel,
        filterModel: filterModel
    }, $60c6fa93e6a0b804$var$computeStartEnd(paginationModel));
});
const $60c6fa93e6a0b804$export$8acf891410e42570 = (state)=>state.dataSource;
const $60c6fa93e6a0b804$export$9ab554c3337a5b6f = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($60c6fa93e6a0b804$export$8acf891410e42570, (dataSource)=>dataSource.loading);
const $60c6fa93e6a0b804$export$ad6a4f370f8ee517 = (0, $f0fef4ed0246c865$export$89f5fc21559ede9b)($60c6fa93e6a0b804$export$8acf891410e42570, (dataSource, id)=>dataSource.loading[id] ?? false);
const $60c6fa93e6a0b804$export$5e89877f96467ba0 = (0, $f0fef4ed0246c865$export$595d22ed68ca2841)($60c6fa93e6a0b804$export$8acf891410e42570, (dataSource)=>dataSource.errors);
const $60c6fa93e6a0b804$export$da86a1c514cddc51 = (0, $f0fef4ed0246c865$export$89f5fc21559ede9b)($60c6fa93e6a0b804$export$8acf891410e42570, (dataSource, id)=>dataSource.errors[id]);



const $0c2eeca17652ed65$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'treeDataGroupingCell'
        ],
        toggle: [
            'treeDataGroupingCellToggle'
        ],
        loadingContainer: [
            'treeDataGroupingCellLoadingContainer'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $0c2eeca17652ed65$var$GridTreeDataGroupingCellIcon(props) {
    const apiRef = (0, $63cda09cd66be3ca$export$e1fd9274eb96ee18)();
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const classes = $0c2eeca17652ed65$var$useUtilityClasses(rootProps);
    const { rowNode: rowNode, id: id, field: field, descendantCount: descendantCount } = props;
    const isDataLoading = (0, $1e10d601c15466d4$export$3b2f72ef07abe101)(apiRef, (0, $60c6fa93e6a0b804$export$ad6a4f370f8ee517), id);
    const error = (0, $1e10d601c15466d4$export$3b2f72ef07abe101)(apiRef, (0, $60c6fa93e6a0b804$export$da86a1c514cddc51), id);
    const handleClick = (event)=>{
        if (!rowNode.childrenExpanded) // always fetch/get from cache the children when the node is expanded
        apiRef.current.unstable_dataSource.fetchRows(id);
        else apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
        apiRef.current.setCellFocus(id, field);
        event.stopPropagation(); // TODO remove event.stopPropagation
    };
    const Icon = rowNode.childrenExpanded ? rootProps.slots.treeDataCollapseIcon : rootProps.slots.treeDataExpandIcon;
    if (isDataLoading) return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: classes.loadingContainer,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $884fc2b3feb01a9d$export$2e2bcd8739ae039), {
            size: "1rem",
            color: "inherit"
        })
    });
    return descendantCount === -1 || descendantCount > 0 ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        size: "small",
        onClick: handleClick,
        tabIndex: -1,
        "aria-label": rowNode.childrenExpanded ? apiRef.current.getLocaleText('treeDataCollapse') : apiRef.current.getLocaleText('treeDataExpand')
    }, rootProps?.slotProps?.baseIconButton, {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseTooltip, {
            title: error?.message ?? null,
            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseBadge, {
                variant: "dot",
                color: "error",
                invisible: !error,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Icon, {
                    fontSize: "inherit"
                })
            })
        })
    })) : null;
}
function $0c2eeca17652ed65$export$a45e560664ff83b8(props) {
    const { id: id, field: field, formattedValue: formattedValue, rowNode: rowNode, hideDescendantCount: hideDescendantCount, offsetMultiplier: offsetMultiplier = 2 } = props;
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $63cda09cd66be3ca$export$e1fd9274eb96ee18)();
    const rowSelector = (state)=>state.rows.dataRowIdToModelLookup[id];
    const row = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, rowSelector);
    const classes = $0c2eeca17652ed65$var$useUtilityClasses(rootProps);
    let descendantCount = 0;
    if (row) descendantCount = rootProps.unstable_dataSource?.getChildrenCount?.(row) ?? 0;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $0f60498376c5ed81$export$2e2bcd8739ae039), {
        className: classes.root,
        sx: {
            ml: rowNode.depth * offsetMultiplier
        },
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: classes.toggle,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($0c2eeca17652ed65$var$GridTreeDataGroupingCellIcon, {
                    id: id,
                    field: field,
                    rowNode: rowNode,
                    row: row,
                    descendantCount: descendantCount
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                children: [
                    formattedValue === undefined ? rowNode.groupingKey : formattedValue,
                    !hideDescendantCount && descendantCount > 0 ? ` (${descendantCount})` : ''
                ]
            })
        ]
    });
}







const $aba567714f9b3c0c$var$_excluded = [
    "hideDescendantCount"
];
const $aba567714f9b3c0c$export$88440965063d297f = (privateApiRef, props)=>{
    const setStrategyAvailability = $lCzvA.useCallback(()=>{
        privateApiRef.current.setStrategyAvailability('rowTree', (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).DataSource, props.treeData && props.unstable_dataSource ? ()=>true : ()=>false);
    }, [
        privateApiRef,
        props.treeData,
        props.unstable_dataSource
    ]);
    const getGroupingColDef = $lCzvA.useCallback(()=>{
        const groupingColDefProp = props.groupingColDef;
        let colDefOverride;
        if (typeof groupingColDefProp === 'function') {
            const params = {
                groupingName: (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).DataSource,
                fields: []
            };
            colDefOverride = groupingColDefProp(params);
        } else colDefOverride = groupingColDefProp;
        const _ref = colDefOverride ?? {}, { hideDescendantCount: hideDescendantCount } = _ref, colDefOverrideProperties = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_ref, $aba567714f9b3c0c$var$_excluded);
        const commonProperties = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $2870559ec8ca294f$export$eed79627d7deb3a5), {
            renderCell: (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0c2eeca17652ed65$export$a45e560664ff83b8), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params, {
                    hideDescendantCount: hideDescendantCount
                })),
            headerName: privateApiRef.current.getLocaleText('treeDataGroupingHeaderName')
        });
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, commonProperties, colDefOverrideProperties, (0, $2870559ec8ca294f$export$1a0175c947f58fd3));
    }, [
        privateApiRef,
        props.groupingColDef
    ]);
    const updateGroupingColumn = $lCzvA.useCallback((columnsState)=>{
        if (!props.unstable_dataSource) return columnsState;
        const groupingColDefField = (0, $2870559ec8ca294f$export$1a0175c947f58fd3).field;
        const shouldHaveGroupingColumn = props.treeData;
        const prevGroupingColumn = columnsState.lookup[groupingColDefField];
        if (shouldHaveGroupingColumn) {
            const newGroupingColumn = getGroupingColDef();
            if (prevGroupingColumn) {
                newGroupingColumn.width = prevGroupingColumn.width;
                newGroupingColumn.flex = prevGroupingColumn.flex;
            }
            columnsState.lookup[groupingColDefField] = newGroupingColumn;
            if (prevGroupingColumn == null) columnsState.orderedFields = [
                groupingColDefField,
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveGroupingColumn && prevGroupingColumn) {
            delete columnsState.lookup[groupingColDefField];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== groupingColDefField);
        }
        return columnsState;
    }, [
        props.treeData,
        props.unstable_dataSource,
        getGroupingColDef
    ]);
    const createRowTreeForTreeData = $lCzvA.useCallback((params)=>{
        const getGroupKey = props.unstable_dataSource?.getGroupKey;
        if (!getGroupKey) throw new Error('MUI X: No `getGroupKey` method provided with the dataSource.');
        const getChildrenCount = props.unstable_dataSource?.getChildrenCount;
        if (!getChildrenCount) throw new Error('MUI X: No `getChildrenCount` method provided with the dataSource.');
        const parentPath = params.updates.groupKeys ?? [];
        const getRowTreeBuilderNode = (rowId)=>{
            const count = getChildrenCount(params.dataRowIdToModelLookup[rowId]);
            return {
                id: rowId,
                path: [
                    ...parentPath,
                    getGroupKey(params.dataRowIdToModelLookup[rowId])
                ].map((key)=>({
                        key: key,
                        field: null
                    })),
                serverChildrenCount: count
            };
        };
        const onDuplicatePath = (firstId, secondId, path)=>{
            throw new Error([
                'MUI X: The values returned by `getGroupKey` for all the sibling rows should be unique.',
                `The rows with id #${firstId} and #${secondId} have the same.`,
                `Path: ${JSON.stringify(path.map((step)=>step.key))}.`
            ].join('\n'));
        };
        if (params.updates.type === 'full') return (0, $cb7435717e6a3616$export$230dd60fadcbc35b)({
            previousTree: params.previousTree,
            nodes: params.updates.rows.map(getRowTreeBuilderNode),
            defaultGroupingExpansionDepth: props.defaultGroupingExpansionDepth,
            isGroupExpandedByDefault: props.isGroupExpandedByDefault,
            groupingName: (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).DataSource,
            onDuplicatePath: onDuplicatePath
        });
        return (0, $2642ce5a10a7208d$export$95db6bdce2927ab)({
            nodes: {
                inserted: params.updates.actions.insert.map(getRowTreeBuilderNode),
                modified: params.updates.actions.modify.map(getRowTreeBuilderNode),
                removed: params.updates.actions.remove
            },
            previousTree: params.previousTree,
            previousGroupsToFetch: params.previousGroupsToFetch,
            previousTreeDepth: params.previousTreeDepths,
            defaultGroupingExpansionDepth: props.defaultGroupingExpansionDepth,
            isGroupExpandedByDefault: props.isGroupExpandedByDefault,
            groupingName: (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).DataSource
        });
    }, [
        props.unstable_dataSource,
        props.defaultGroupingExpansionDepth,
        props.isGroupExpandedByDefault
    ]);
    const filterRows = $lCzvA.useCallback(()=>{
        const rowTree = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(privateApiRef);
        return (0, $efdee3b4a42b2677$export$dd82b2d5f43ae0b4)(rowTree);
    }, [
        privateApiRef
    ]);
    const sortRows = $lCzvA.useCallback(()=>{
        const rowTree = (0, $68327dddce1a2c68$export$de9a43d646a9821d)(privateApiRef);
        return (0, $efdee3b4a42b2677$export$f2f2fee19447200b)(rowTree);
    }, [
        privateApiRef
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(privateApiRef, 'hydrateColumns', updateGroupingColumn);
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(privateApiRef, (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).DataSource, 'rowTreeCreation', createRowTreeForTreeData);
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(privateApiRef, (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).DataSource, 'filtering', filterRows);
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(privateApiRef, (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).DataSource, 'sorting', sortRows);
    (0, $32c4bba1d412ab01$export$102a3f5a042c47c4)(privateApiRef, (0, $b73ac5b7bdbb5681$export$8421a4723b13126c).DataSource, 'visibleRowsLookupCreation', (0, $ded28721040d07ec$export$9cf22cc325f95ed4));
    /**
   * 1ST RENDER
   */ (0, $9ebf8f53803465ea$export$c5623aa1c38918b6)(()=>{
        setStrategyAvailability();
    });
    /**
   * EFFECTS
   */ const isFirstRender = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (!isFirstRender.current) setStrategyAvailability();
        else isFirstRender.current = false;
    }, [
        setStrategyAvailability
    ]);
};




var $lCzvA = parcelRequire("lCzvA");


const $0561e29a2854e03f$export$5fee0234a63f3519 = (state, props, apiRef)=>{
    apiRef.current.caches.columnPinning = {
        orderedFieldsBeforePinningColumns: null
    };
    let model;
    if (props.pinnedColumns) model = props.pinnedColumns;
    else if (props.initialState?.pinnedColumns) model = props.initialState.pinnedColumns;
    else model = {};
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        pinnedColumns: model
    });
};
const $0561e29a2854e03f$export$2534ab700dd48c29 = (apiRef, props)=>{
    const pinnedColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$1eea0bd4db853467));
    /**
   * PRE-PROCESSING
   */ const calculateScrollLeft = $lCzvA.useCallback((initialValue, params)=>{
        const visiblePinnedColumns = (0, $8b99503000dd62d3$export$297e8079713afa11)(apiRef);
        if (!params.colIndex || visiblePinnedColumns.left.length === 0 && visiblePinnedColumns.right.length === 0) return initialValue;
        const visibleColumns = (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef);
        const columnsTotalWidth = (0, $adc18856c547b659$export$ab20f9d33edc7794)(apiRef);
        const columnPositions = (0, $8b99503000dd62d3$export$fce7d810e48021e3)(apiRef);
        const clientWidth = apiRef.current.virtualScrollerRef.current.clientWidth;
        // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
        const scrollLeft = Math.abs(apiRef.current.virtualScrollerRef.current.scrollLeft);
        const offsetWidth = visibleColumns[params.colIndex].computedWidth;
        const offsetLeft = columnPositions[params.colIndex];
        const leftPinnedColumnsWidth = columnPositions[visiblePinnedColumns.left.length];
        const rightPinnedColumnsWidth = columnsTotalWidth - columnPositions[columnPositions.length - visiblePinnedColumns.right.length];
        const elementBottom = offsetLeft + offsetWidth;
        if (elementBottom - (clientWidth - rightPinnedColumnsWidth) > scrollLeft) {
            const left = elementBottom - (clientWidth - rightPinnedColumnsWidth);
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, initialValue, {
                left: left
            });
        }
        if (offsetLeft < scrollLeft + leftPinnedColumnsWidth) {
            const left = offsetLeft - leftPinnedColumnsWidth;
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, initialValue, {
                left: left
            });
        }
        return initialValue;
    }, [
        apiRef
    ]);
    const addColumnMenuItems = $lCzvA.useCallback((columnMenuItems, colDef)=>{
        if (props.disableColumnPinning) return columnMenuItems;
        if (colDef.pinnable === false) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuPinningItem'
        ];
    }, [
        props.disableColumnPinning
    ]);
    const checkIfCanBeReordered = $lCzvA.useCallback((initialValue, { targetIndex: targetIndex })=>{
        const visiblePinnedColumns = (0, $8b99503000dd62d3$export$297e8079713afa11)(apiRef);
        if (visiblePinnedColumns.left.length === 0 && visiblePinnedColumns.right.length === 0) return initialValue;
        if (visiblePinnedColumns.left.length > 0 && targetIndex < visiblePinnedColumns.left.length) return false;
        if (visiblePinnedColumns.right.length > 0) {
            const visibleColumns = (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef);
            const firstRightPinnedColumnIndex = visibleColumns.length - visiblePinnedColumns.right.length;
            return targetIndex >= firstRightPinnedColumnIndex ? false : initialValue;
        }
        return initialValue;
    }, [
        apiRef
    ]);
    const stateExportPreProcessing = $lCzvA.useCallback((prevState, context)=>{
        const pinnedColumnsToExport = (0, $8b99503000dd62d3$export$1eea0bd4db853467)(apiRef.current.state);
        const shouldExportPinnedColumns = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.pinnedColumns != null || // Always export if the model has been initialized
        props.initialState?.pinnedColumns != null || // Export if the model is not empty
        (pinnedColumnsToExport.left ?? []).length > 0 || (pinnedColumnsToExport.right ?? []).length > 0;
        if (!shouldExportPinnedColumns) return prevState;
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, prevState, {
            pinnedColumns: pinnedColumnsToExport
        });
    }, [
        apiRef,
        props.pinnedColumns,
        props.initialState?.pinnedColumns
    ]);
    const stateRestorePreProcessing = $lCzvA.useCallback((params, context)=>{
        const newPinnedColumns = context.stateToRestore.pinnedColumns;
        if (newPinnedColumns != null) $0561e29a2854e03f$var$setState(apiRef, newPinnedColumns);
        return params;
    }, [
        apiRef
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'scrollToIndexes', calculateScrollLeft);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'columnMenu', addColumnMenuItems);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'canBeReordered', checkIfCanBeReordered);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    apiRef.current.registerControlState({
        stateId: 'pinnedColumns',
        propModel: props.pinnedColumns,
        propOnChange: props.onPinnedColumnsChange,
        stateSelector: (0, $8b99503000dd62d3$export$1eea0bd4db853467),
        changeEvent: 'pinnedColumnsChange'
    });
    const pinColumn = $lCzvA.useCallback((field, side)=>{
        if (apiRef.current.isColumnPinned(field) === side) return;
        const otherSide = side === (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT ? (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).LEFT : (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT;
        const newPinnedColumns = {
            [side]: [
                ...pinnedColumns[side] || [],
                field
            ],
            [otherSide]: (pinnedColumns[otherSide] || []).filter((column)=>column !== field)
        };
        apiRef.current.setPinnedColumns(newPinnedColumns);
    }, [
        apiRef,
        pinnedColumns
    ]);
    const unpinColumn = $lCzvA.useCallback((field)=>{
        apiRef.current.setPinnedColumns({
            left: (pinnedColumns.left || []).filter((column)=>column !== field),
            right: (pinnedColumns.right || []).filter((column)=>column !== field)
        });
    }, [
        apiRef,
        pinnedColumns.left,
        pinnedColumns.right
    ]);
    const getPinnedColumns = $lCzvA.useCallback(()=>{
        return (0, $8b99503000dd62d3$export$1eea0bd4db853467)(apiRef.current.state);
    }, [
        apiRef
    ]);
    const setPinnedColumns = $lCzvA.useCallback((newPinnedColumns)=>{
        $0561e29a2854e03f$var$setState(apiRef, newPinnedColumns);
        apiRef.current.requestPipeProcessorsApplication('hydrateColumns');
    }, [
        apiRef
    ]);
    const isColumnPinned = $lCzvA.useCallback((field)=>{
        const leftPinnedColumns = pinnedColumns.left || [];
        if (leftPinnedColumns.includes(field)) return (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).LEFT;
        const rightPinnedColumns = pinnedColumns.right || [];
        if (rightPinnedColumns.includes(field)) return (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT;
        return false;
    }, [
        pinnedColumns.left,
        pinnedColumns.right
    ]);
    const columnPinningApi = {
        pinColumn: pinColumn,
        unpinColumn: unpinColumn,
        getPinnedColumns: getPinnedColumns,
        setPinnedColumns: setPinnedColumns,
        isColumnPinned: isColumnPinned
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, columnPinningApi, 'public');
    const handleColumnOrderChange = (params)=>{
        if (!apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns) return;
        const { column: column, targetIndex: targetIndex, oldIndex: oldIndex } = params;
        const delta = targetIndex > oldIndex ? 1 : -1;
        const latestColumnFields = (0, $8b99503000dd62d3$export$d8a3dfbb129c80db)(apiRef);
        /**
     * When a column X is reordered to somewhere else, the position where this column X is dropped
     * on must be moved to left or right to make room for it. The ^^^ below represents the column
     * which gave space to receive X.
     *
     * | X | B | C | D | -> | B | C | D | X | (for example X moved to after D, so delta=1)
     *              ^^^              ^^^
     *
     * | A | B | C | X | -> | X | A | B | C | (for example X moved before A, so delta=-1)
     *  ^^^                      ^^^
     *
     * If column P is pinned, it will not move to provide space. However, it will jump to the next
     * non-pinned column.
     *
     * | X | B | P | D | -> | B | D | P | X | (for example X moved to after D, with P pinned)
     *              ^^^          ^^^
     */ const siblingField = latestColumnFields[targetIndex - delta];
        const newOrderedFieldsBeforePinningColumns = [
            ...apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns
        ];
        // The index to start swapping fields
        let i = newOrderedFieldsBeforePinningColumns.findIndex((currentColumn)=>currentColumn === column.field);
        // The index of the field to swap with
        let j = i + delta;
        // When to stop swapping fields.
        // We stop one field before because the swap is done with i + 1 (if delta=1)
        const stop = newOrderedFieldsBeforePinningColumns.findIndex((currentColumn)=>currentColumn === siblingField);
        while(delta > 0 ? i < stop : i > stop){
            // If the field to swap with is a pinned column, jump to the next
            while(apiRef.current.isColumnPinned(newOrderedFieldsBeforePinningColumns[j]))j += delta;
            const temp = newOrderedFieldsBeforePinningColumns[i];
            newOrderedFieldsBeforePinningColumns[i] = newOrderedFieldsBeforePinningColumns[j];
            newOrderedFieldsBeforePinningColumns[j] = temp;
            i = j;
            j = i + delta;
        }
        apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns = newOrderedFieldsBeforePinningColumns;
    };
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnOrderChange', handleColumnOrderChange);
    $lCzvA.useEffect(()=>{
        if (props.pinnedColumns) apiRef.current.setPinnedColumns(props.pinnedColumns);
    }, [
        apiRef,
        props.pinnedColumns
    ]);
};
function $0561e29a2854e03f$var$setState(apiRef, model) {
    apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
            pinnedColumns: model
        }));
}




var $lCzvA = parcelRequire("lCzvA");

const $aa025e80e2d82a71$export$47a2167ef2ac089d = (apiRef, props)=>{
    const { disableColumnPinning: disableColumnPinning } = props;
    const prevAllPinnedColumns = $lCzvA.useRef([]);
    const reorderPinnedColumns = $lCzvA.useCallback((columnsState)=>{
        if (columnsState.orderedFields.length === 0 || disableColumnPinning) return columnsState;
        // HACK: This is a hack needed because the pipe processors aren't pure enough. What
        // they should be is `gridState -> gridState` transformers, but they only transform a slice
        // of the state, not the full state. So if they need access to other parts of the state (like
        // the `state.columns.orderedFields` in this case), they might lag behind because the selectors
        // are selecting the old state in `apiRef`, not the state being computed in the current pipe processor.
        const savedState = apiRef.current.state;
        apiRef.current.state = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, savedState, {
            columns: columnsState
        });
        const pinnedColumns = (0, $8b99503000dd62d3$export$92910475beda795c)(apiRef);
        apiRef.current.state = savedState;
        // HACK: Ends here //
        const leftPinnedColumns = pinnedColumns.left;
        const rightPinnedColumns = pinnedColumns.right;
        let newOrderedFields;
        const allPinnedColumns = [
            ...leftPinnedColumns,
            ...rightPinnedColumns
        ];
        const { orderedFieldsBeforePinningColumns: orderedFieldsBeforePinningColumns } = apiRef.current.caches.columnPinning;
        if (orderedFieldsBeforePinningColumns) {
            newOrderedFields = new Array(columnsState.orderedFields.length).fill(null);
            const newOrderedFieldsBeforePinningColumns = [
                ...newOrderedFields
            ];
            // Contains the fields not added to the orderedFields array yet
            const remainingFields = [
                ...columnsState.orderedFields
            ];
            // First, we check if the column was unpinned since the last processing.
            // If yes and it still exists, we move it back to the same position it was before pinning
            prevAllPinnedColumns.current.forEach((field)=>{
                if (!allPinnedColumns.includes(field) && columnsState.lookup[field]) {
                    // Get the position before pinning
                    const index = orderedFieldsBeforePinningColumns.indexOf(field);
                    newOrderedFields[index] = field;
                    newOrderedFieldsBeforePinningColumns[index] = field;
                    // This field was already consumed so we prevent from being added again
                    remainingFields.splice(remainingFields.indexOf(field), 1);
                }
            });
            // For columns still pinned, we keep stored their original positions
            allPinnedColumns.forEach((field)=>{
                let index = orderedFieldsBeforePinningColumns.indexOf(field);
                // If index = -1, the pinned field didn't exist in the last processing, it's possibly being added now
                // If index >= newOrderedFieldsBeforePinningColumns.length, then one or more columns were removed
                // In both cases, use the position from the columns array
                // TODO: detect removed columns and decrease the positions after it
                if (index === -1 || index >= newOrderedFieldsBeforePinningColumns.length) index = columnsState.orderedFields.indexOf(field);
                // The fallback above may make the column to be inserted in a position already occupied
                // In this case, put it in any empty slot available
                if (newOrderedFieldsBeforePinningColumns[index] !== null) {
                    index = 0;
                    while(newOrderedFieldsBeforePinningColumns[index] !== null)index += 1;
                }
                newOrderedFields[index] = field;
                newOrderedFieldsBeforePinningColumns[index] = field;
                // This field was already consumed so we prevent from being added again
                remainingFields.splice(remainingFields.indexOf(field), 1);
            });
            // The fields remaining are those that're neither pinnned nor were unpinned
            // For these, we spread them across both arrays making sure to not override existing values
            let i = 0;
            remainingFields.forEach((field)=>{
                while(newOrderedFieldsBeforePinningColumns[i] !== null)i += 1;
                newOrderedFieldsBeforePinningColumns[i] = field;
                newOrderedFields[i] = field;
            });
            apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns = newOrderedFieldsBeforePinningColumns;
        } else {
            newOrderedFields = [
                ...columnsState.orderedFields
            ];
            apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns = [
                ...columnsState.orderedFields
            ];
        }
        prevAllPinnedColumns.current = allPinnedColumns;
        const centerColumns = newOrderedFields.filter((field)=>{
            return !leftPinnedColumns.includes(field) && !rightPinnedColumns.includes(field);
        });
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, columnsState, {
            orderedFields: [
                ...leftPinnedColumns,
                ...centerColumns,
                ...rightPinnedColumns
            ]
        });
    }, [
        apiRef,
        disableColumnPinning
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'hydrateColumns', reorderPinnedColumns);
    const isColumnPinned = $lCzvA.useCallback((initialValue, field)=>apiRef.current.isColumnPinned(field), [
        apiRef
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'isColumnPinned', isColumnPinned);
};




var $lCzvA = parcelRequire("lCzvA");



parcelRequire("lCzvA");




var $lCzvA = parcelRequire("lCzvA");







const $05ba1f7c9f586710$export$2e51858b6eeff6ad = (state)=>state.detailPanel.expandedRowIds;
const $05ba1f7c9f586710$export$16fba932632c70f0 = (state)=>state.detailPanel.contentCache;
const $05ba1f7c9f586710$export$3a5feeef4c4a2bdc = (state)=>state.detailPanel.heightCache;
const $05ba1f7c9f586710$export$f8466bb36c8b9813 = (0, $f0fef4ed0246c865$export$2a3ca4704a61d1f4)($05ba1f7c9f586710$export$3a5feeef4c4a2bdc, (heightCache)=>Object.entries(heightCache).reduce((acc, [id, { height: height }])=>{
        acc[id] = height || 0;
        return acc;
    }, {}));



const $f99466b0295638dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isExpanded: isExpanded } = ownerState;
    const slots = {
        root: [
            'detailPanelToggleCell',
            isExpanded && 'detailPanelToggleCell--expanded'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $f99466b0295638dd$var$isExpandedSelector = (0, $f0fef4ed0246c865$export$89f5fc21559ede9b)((0, $05ba1f7c9f586710$export$2e51858b6eeff6ad), (expandedRowIds, rowId)=>{
    return expandedRowIds.includes(rowId);
});
function $f99466b0295638dd$export$817e5e2e8d6c93c(props) {
    const { id: id, row: row, api: api } = props;
    const rowId = api.getRowId(row);
    const isExpanded = (0, $1e10d601c15466d4$export$3b2f72ef07abe101)({
        current: api
    }, $f99466b0295638dd$var$isExpandedSelector, rowId);
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $921f9bb18367670e$export$2d14edd3a7db3bbf)();
    const ownerState = {
        classes: rootProps.classes,
        isExpanded: isExpanded
    };
    const classes = $f99466b0295638dd$var$useUtilityClasses(ownerState);
    const contentCache = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $05ba1f7c9f586710$export$16fba932632c70f0));
    const hasContent = /*#__PURE__*/ $lCzvA.isValidElement(contentCache[id]);
    const Icon = isExpanded ? rootProps.slots.detailPanelCollapseIcon : rootProps.slots.detailPanelExpandIcon;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        size: "small",
        tabIndex: -1,
        disabled: !hasContent,
        className: classes.root,
        "aria-expanded": isExpanded,
        "aria-label": isExpanded ? apiRef.current.getLocaleText('collapseDetailPanel') : apiRef.current.getLocaleText('expandDetailPanel')
    }, rootProps.slotProps?.baseIconButton, {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Icon, {
            fontSize: "inherit"
        })
    }));
}




const $36af50bebc849811$export$cea0a90b26fb973d = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4), {
    type: 'custom',
    field: (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719),
    editable: false,
    sortable: false,
    filterable: false,
    resizable: false,
    // @ts-ignore
    aggregable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    align: 'left',
    width: 40,
    valueGetter: (value, row, column, apiRef)=>{
        const rowId = (0, $c0782207122e35d1$export$5e766ecd73f055ed)(apiRef.current.state, row);
        const expandedRowIds = (0, $05ba1f7c9f586710$export$2e51858b6eeff6ad)(apiRef.current.state);
        return expandedRowIds.includes(rowId);
    },
    renderCell: (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $f99466b0295638dd$export$817e5e2e8d6c93c), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params)),
    renderHeader: ({ colDef: colDef })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
            "aria-label": colDef.headerName
        })
});



const $9f75fdb66e01126e$export$c6a1049ecc0f594c = (state, props)=>{
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        detailPanel: {
            heightCache: {},
            expandedRowIds: props.detailPanelExpandedRowIds ?? props.initialState?.detailPanel?.expandedRowIds ?? []
        }
    });
};
function $9f75fdb66e01126e$var$cacheContentAndHeight(apiRef, getDetailPanelContent, getDetailPanelHeight, previousHeightCache) {
    if (typeof getDetailPanelContent !== 'function') return {};
    // TODO change to lazy approach using a Proxy
    // only call getDetailPanelContent when asked for an id
    const rowIds = (0, $68327dddce1a2c68$export$c7dcaab5e573753)(apiRef);
    const contentCache = rowIds.reduce((acc, id)=>{
        const params = apiRef.current.getRowParams(id);
        acc[id] = getDetailPanelContent(params);
        return acc;
    }, {});
    const heightCache = rowIds.reduce((acc, id)=>{
        if (contentCache[id] == null) return acc;
        const params = apiRef.current.getRowParams(id);
        const height = getDetailPanelHeight(params);
        const autoHeight = height === 'auto';
        acc[id] = {
            autoHeight: autoHeight,
            height: autoHeight ? previousHeightCache[id]?.height : height
        };
        return acc;
    }, {});
    return {
        contentCache: contentCache,
        heightCache: heightCache
    };
}
const $9f75fdb66e01126e$export$b71d7525fdd57704 = (apiRef, props)=>{
    const contentCache = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $05ba1f7c9f586710$export$16fba932632c70f0));
    const handleCellClick = $lCzvA.useCallback((params, event)=>{
        if (params.field !== (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719) || props.getDetailPanelContent == null) return;
        const content = contentCache[params.id];
        if (!/*#__PURE__*/ $lCzvA.isValidElement(content)) return;
        // Ignore if the user didn't click specifically in the "i" button
        if (event.target === event.currentTarget) return;
        apiRef.current.toggleDetailPanel(params.id);
    }, [
        apiRef,
        contentCache,
        props.getDetailPanelContent
    ]);
    const handleCellKeyDown = $lCzvA.useCallback((params, event)=>{
        if (props.getDetailPanelContent == null) return;
        if (params.field === (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719) && event.key === ' ') apiRef.current.toggleDetailPanel(params.id);
    }, [
        apiRef,
        props.getDetailPanelContent
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellClick', handleCellClick);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', handleCellKeyDown);
    apiRef.current.registerControlState({
        stateId: 'detailPanels',
        propModel: props.detailPanelExpandedRowIds,
        propOnChange: props.onDetailPanelExpandedRowIdsChange,
        stateSelector: (0, $05ba1f7c9f586710$export$2e51858b6eeff6ad),
        changeEvent: 'detailPanelsExpandedRowIdsChange'
    });
    const toggleDetailPanel = $lCzvA.useCallback((id)=>{
        if (props.getDetailPanelContent == null) return;
        const content = contentCache[id];
        if (!/*#__PURE__*/ $lCzvA.isValidElement(content)) return;
        const ids = apiRef.current.getExpandedDetailPanels();
        apiRef.current.setExpandedDetailPanels(ids.includes(id) ? ids.filter((rowId)=>rowId !== id) : [
            ...ids,
            id
        ]);
    }, [
        apiRef,
        contentCache,
        props.getDetailPanelContent
    ]);
    const getExpandedDetailPanels = $lCzvA.useCallback(()=>(0, $05ba1f7c9f586710$export$2e51858b6eeff6ad)(apiRef.current.state), [
        apiRef
    ]);
    const setExpandedDetailPanels = $lCzvA.useCallback((ids)=>{
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                detailPanel: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.detailPanel, {
                    expandedRowIds: ids
                })
            });
        });
        apiRef.current.requestPipeProcessorsApplication('rowHeight');
    }, [
        apiRef
    ]);
    const storeDetailPanelHeight = $lCzvA.useCallback((id, height)=>{
        const heightCache = (0, $05ba1f7c9f586710$export$3a5feeef4c4a2bdc)(apiRef.current.state);
        if (!heightCache[id] || heightCache[id].height === height) return;
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                detailPanel: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.detailPanel, {
                    heightCache: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, heightCache, {
                        [id]: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, heightCache[id], {
                            height: height
                        })
                    })
                })
            });
        });
        apiRef.current.requestPipeProcessorsApplication('rowHeight');
    }, [
        apiRef
    ]);
    const detailPanelHasAutoHeight = $lCzvA.useCallback((id)=>{
        const heightCache = (0, $05ba1f7c9f586710$export$3a5feeef4c4a2bdc)(apiRef.current.state);
        return heightCache[id] ? heightCache[id].autoHeight : false;
    }, [
        apiRef
    ]);
    const detailPanelPubicApi = {
        toggleDetailPanel: toggleDetailPanel,
        getExpandedDetailPanels: getExpandedDetailPanels,
        setExpandedDetailPanels: setExpandedDetailPanels
    };
    const detailPanelPrivateApi = {
        storeDetailPanelHeight: storeDetailPanelHeight,
        detailPanelHasAutoHeight: detailPanelHasAutoHeight
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, detailPanelPubicApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, detailPanelPrivateApi, 'private');
    $lCzvA.useEffect(()=>{
        if (props.detailPanelExpandedRowIds) {
            const currentModel = (0, $05ba1f7c9f586710$export$2e51858b6eeff6ad)(apiRef.current.state);
            if (currentModel !== props.detailPanelExpandedRowIds) apiRef.current.setExpandedDetailPanels(props.detailPanelExpandedRowIds);
        }
    }, [
        apiRef,
        props.detailPanelExpandedRowIds
    ]);
    const updateCachesAndForceUpdate = $lCzvA.useCallback(()=>{
        if (!props.getDetailPanelContent) return;
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                detailPanel: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.detailPanel, $9f75fdb66e01126e$var$cacheContentAndHeight(apiRef, props.getDetailPanelContent, props.getDetailPanelHeight, state.detailPanel.heightCache))
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.getDetailPanelContent,
        props.getDetailPanelHeight
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'sortedRowsSet', updateCachesAndForceUpdate);
    const previousGetDetailPanelContentProp = $lCzvA.useRef(undefined);
    const previousGetDetailPanelHeightProp = $lCzvA.useRef(undefined);
    const updateCachesIfNeeded = $lCzvA.useCallback(()=>{
        if (props.getDetailPanelContent === previousGetDetailPanelContentProp.current && props.getDetailPanelHeight === previousGetDetailPanelHeightProp.current) return;
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                detailPanel: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.detailPanel, $9f75fdb66e01126e$var$cacheContentAndHeight(apiRef, props.getDetailPanelContent, props.getDetailPanelHeight, state.detailPanel.heightCache))
            });
        });
        previousGetDetailPanelContentProp.current = props.getDetailPanelContent;
        previousGetDetailPanelHeightProp.current = props.getDetailPanelHeight;
    }, [
        apiRef,
        props.getDetailPanelContent,
        props.getDetailPanelHeight
    ]);
    const addDetailHeight = $lCzvA.useCallback((initialValue, row)=>{
        const expandedRowIds = (0, $05ba1f7c9f586710$export$2e51858b6eeff6ad)(apiRef.current.state);
        if (!expandedRowIds || expandedRowIds.length === 0 || !expandedRowIds.includes(row.id)) {
            initialValue.detail = 0;
            return initialValue;
        }
        updateCachesIfNeeded();
        const heightCache = (0, $05ba1f7c9f586710$export$f8466bb36c8b9813)(apiRef);
        initialValue.detail = heightCache[row.id] ?? 0; // Fallback to zero because the cache might not be ready yet (for example page was changed)
        return initialValue;
    }, [
        apiRef,
        updateCachesIfNeeded
    ]);
    const enabled = props.getDetailPanelContent !== undefined;
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'rowHeight', addDetailHeight, enabled);
    const isFirstRender = $lCzvA.useRef(true);
    if (isFirstRender.current) updateCachesIfNeeded();
    $lCzvA.useEffect(()=>{
        if (!isFirstRender.current) updateCachesIfNeeded();
        isFirstRender.current = false;
    }, [
        apiRef,
        updateCachesIfNeeded
    ]);
};




var $lCzvA = parcelRequire("lCzvA");




const $bcd4bc19c3b174cb$export$77f589f94558bf61 = (privateApiRef, props)=>{
    const addToggleColumn = $lCzvA.useCallback((columnsState)=>{
        const detailPanelToggleColumn = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $36af50bebc849811$export$cea0a90b26fb973d), {
            headerName: privateApiRef.current.getLocaleText('detailPanelToggle')
        });
        const shouldHaveToggleColumn = !!props.getDetailPanelContent;
        const hasToggleColumn = columnsState.lookup[0, $3cb6fcdeb46bf88d$export$6e5a576305a34719] != null;
        if (shouldHaveToggleColumn && !hasToggleColumn) {
            columnsState.lookup[0, $3cb6fcdeb46bf88d$export$6e5a576305a34719] = detailPanelToggleColumn;
            columnsState.orderedFields = [
                (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719),
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveToggleColumn && hasToggleColumn) {
            delete columnsState.lookup[0, $3cb6fcdeb46bf88d$export$6e5a576305a34719];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719));
        } else if (shouldHaveToggleColumn && hasToggleColumn) {
            columnsState.lookup[0, $3cb6fcdeb46bf88d$export$6e5a576305a34719] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, detailPanelToggleColumn, columnsState.lookup[0, $3cb6fcdeb46bf88d$export$6e5a576305a34719]);
            // If the column is not in the columns array (not a custom detail panel toggle column), move it to the beginning of the column order
            if (!props.columns.some((col)=>col.field === (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719))) columnsState.orderedFields = [
                (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719),
                ...columnsState.orderedFields.filter((field)=>field !== (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719))
            ];
        }
        return columnsState;
    }, [
        privateApiRef,
        props.columns,
        props.getDetailPanelContent
    ]);
    const addExpandedClassToRow = $lCzvA.useCallback((classes, id)=>{
        if (props.getDetailPanelContent == null) return classes;
        const expandedRowIds = (0, $05ba1f7c9f586710$export$2e51858b6eeff6ad)(privateApiRef.current.state);
        if (!expandedRowIds.includes(id)) return classes;
        return [
            ...classes,
            (0, $786c119d9add6b61$export$2100d54e36406477)['row--detailPanelExpanded']
        ];
    }, [
        privateApiRef,
        props.getDetailPanelContent
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(privateApiRef, 'hydrateColumns', addToggleColumn);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(privateApiRef, 'rowClassName', addExpandedClassToRow);
};



var $lCzvA = parcelRequire("lCzvA");







var $lCzvA = parcelRequire("lCzvA");






const $81a30d055ddb4a1d$var$useUtilityClasses = (ownerState)=>{
    const { isDraggable: isDraggable, classes: classes } = ownerState;
    const slots = {
        root: [
            'rowReorderCell',
            isDraggable && 'rowReorderCell--draggable'
        ],
        placeholder: [
            'rowReorderCellPlaceholder'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $81a30d055ddb4a1d$export$5e56cf9b6277d9e5(params) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const sortModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9));
    const treeDepth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$4cdbe576751dd8e2));
    const editRowsState = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $5396c90484690c1e$export$91ed78b95c9e6636));
    // eslint-disable-next-line no-underscore-dangle
    const cellValue = params.row.__reorder__ || params.id;
    // TODO: remove sortModel and treeDepth checks once row reorder is compatible
    const isDraggable = $lCzvA.useMemo(()=>!!rootProps.rowReordering && !sortModel.length && treeDepth === 1 && Object.keys(editRowsState).length === 0, [
        rootProps.rowReordering,
        sortModel,
        treeDepth,
        editRowsState
    ]);
    const ownerState = {
        isDraggable: isDraggable,
        classes: rootProps.classes
    };
    const classes = $81a30d055ddb4a1d$var$useUtilityClasses(ownerState);
    const publish = $lCzvA.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if ((0, $e6e8e5e948b588ba$export$8ce496ad3bfbe3a6)(event)) return;
            // The row might have been deleted
            if (!apiRef.current.getRow(params.id)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(params.id), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        params.id
    ]);
    const handleMouseDown = $lCzvA.useCallback(()=>{
        // Prevent text selection as it will block all the drag events. More context: https://github.com/mui/mui-x/issues/16303
        apiRef.current.rootElementRef?.current?.classList.add((0, $786c119d9add6b61$export$2100d54e36406477)['root--disableUserSelection']);
    }, [
        apiRef
    ]);
    const handleMouseUp = $lCzvA.useCallback(()=>{
        apiRef.current.rootElementRef?.current?.classList.remove((0, $786c119d9add6b61$export$2100d54e36406477)['root--disableUserSelection']);
    }, [
        apiRef
    ]);
    const handleDragEnd = $lCzvA.useCallback((event)=>{
        handleMouseUp();
        publish('rowDragEnd')(event);
    }, [
        publish,
        handleMouseUp
    ]);
    const draggableEventHandlers = isDraggable ? {
        onDragStart: publish('rowDragStart'),
        onDragOver: publish('rowDragOver'),
        onDragEnd: handleDragEnd,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp
    } : null;
    if (params.rowNode.type === 'footer') return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: classes.root,
        draggable: isDraggable
    }, draggableEventHandlers, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.rowReorderIcon, {}),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: classes.placeholder,
                children: cellValue
            })
        ]
    }));
}
const $81a30d055ddb4a1d$export$1346ab9a2305631 = (params)=>{
    if (params.rowNode.type === 'footer' || params.rowNode.type === 'pinnedRow') return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($81a30d055ddb4a1d$export$5e56cf9b6277d9e5, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, params));
};


const $2b76f655c0610081$export$778666d70e672a78 = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $97e794d7f4c0940d$export$db6fa9d0a45573e4), {
    type: 'custom',
    field: '__reorder__',
    sortable: false,
    filterable: false,
    width: 50,
    align: 'center',
    headerAlign: 'center',
    disableColumnMenu: true,
    disableExport: true,
    disableReorder: true,
    resizable: false,
    // @ts-ignore
    aggregable: false,
    renderHeader: ()=>' ',
    renderCell: (0, $81a30d055ddb4a1d$export$1346ab9a2305631)
});


var $a54f184c0ce3b4c6$var$Direction = /*#__PURE__*/ function(Direction) {
    Direction[Direction["UP"] = 0] = "UP";
    Direction[Direction["DOWN"] = 1] = "DOWN";
    return Direction;
}($a54f184c0ce3b4c6$var$Direction || {});
let $a54f184c0ce3b4c6$var$previousMousePosition = null;
let $a54f184c0ce3b4c6$var$previousReorderState = {
    previousTargetId: null,
    dragDirection: null
};
const $a54f184c0ce3b4c6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        rowDragging: [
            'row--dragging'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $a54f184c0ce3b4c6$export$628fe35635cfd286 = (apiRef, props)=>{
    const logger = (0, $658b5ea949d27628$export$eb512164890e58f0)(apiRef, 'useGridRowReorder');
    const sortModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9));
    const treeDepth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$4cdbe576751dd8e2));
    const dragRowNode = $lCzvA.useRef(null);
    const originRowIndex = $lCzvA.useRef(null);
    const removeDnDStylesTimeout = $lCzvA.useRef(undefined);
    const ownerState = {
        classes: props.classes
    };
    const classes = $a54f184c0ce3b4c6$var$useUtilityClasses(ownerState);
    const [dragRowId, setDragRowId] = $lCzvA.useState('');
    const sortedRowIndexLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $32a7c18be453c9d5$export$d0aac76ef888d9fe));
    $lCzvA.useEffect(()=>{
        return ()=>{
            clearTimeout(removeDnDStylesTimeout.current);
        };
    }, []);
    // TODO: remove sortModel check once row reorder is sorting compatible
    // remove treeDepth once row reorder is tree compatible
    const isRowReorderDisabled = $lCzvA.useMemo(()=>{
        return !props.rowReordering || !!sortModel.length || treeDepth !== 1;
    }, [
        props.rowReordering,
        sortModel,
        treeDepth
    ]);
    const handleDragStart = $lCzvA.useCallback((params, event)=>{
        // Call the gridEditRowsStateSelector directly to avoid infnite loop
        const editRowsState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        if (isRowReorderDisabled || Object.keys(editRowsState).length !== 0) return;
        logger.debug(`Start dragging row ${params.id}`);
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        dragRowNode.current = event.currentTarget;
        dragRowNode.current.classList.add(classes.rowDragging);
        setDragRowId(params.id);
        removeDnDStylesTimeout.current = setTimeout(()=>{
            dragRowNode.current.classList.remove(classes.rowDragging);
        });
        originRowIndex.current = sortedRowIndexLookup[params.id];
        apiRef.current.setCellFocus(params.id, (0, $2b76f655c0610081$export$778666d70e672a78).field);
    }, [
        apiRef,
        isRowReorderDisabled,
        logger,
        classes.rowDragging,
        sortedRowIndexLookup
    ]);
    const handleDragOver = $lCzvA.useCallback((params, event)=>{
        if (dragRowId === '') return;
        const rowNode = apiRef.current.getRowNode(params.id);
        if (!rowNode || rowNode.type === 'footer' || rowNode.type === 'pinnedRow') return;
        logger.debug(`Dragging over row ${params.id}`);
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        const mouseMovementDiff = $a54f184c0ce3b4c6$var$previousMousePosition ? $a54f184c0ce3b4c6$var$previousMousePosition.y - event.clientY : event.clientY;
        if (params.id !== dragRowId) {
            const targetRowIndex = sortedRowIndexLookup[params.id];
            const dragDirection = mouseMovementDiff > 0 ? $a54f184c0ce3b4c6$var$Direction.DOWN : $a54f184c0ce3b4c6$var$Direction.UP;
            const currentReorderState = {
                dragDirection: dragDirection,
                previousTargetId: params.id
            };
            const isStateChanged = currentReorderState.dragDirection !== $a54f184c0ce3b4c6$var$previousReorderState.dragDirection || currentReorderState.previousTargetId !== $a54f184c0ce3b4c6$var$previousReorderState.previousTargetId;
            if ($a54f184c0ce3b4c6$var$previousReorderState.dragDirection === null || Math.abs(mouseMovementDiff) >= 1 && isStateChanged) {
                apiRef.current.setRowIndex(dragRowId, targetRowIndex);
                $a54f184c0ce3b4c6$var$previousReorderState = currentReorderState;
            }
        }
        $a54f184c0ce3b4c6$var$previousMousePosition = {
            x: event.clientX,
            y: event.clientY
        };
    }, [
        dragRowId,
        apiRef,
        logger,
        sortedRowIndexLookup
    ]);
    const handleDragEnd = $lCzvA.useCallback((params, event)=>{
        // Call the gridEditRowsStateSelector directly to avoid infnite loop
        const editRowsState = (0, $5396c90484690c1e$export$91ed78b95c9e6636)(apiRef.current.state);
        if (dragRowId === '' || isRowReorderDisabled || Object.keys(editRowsState).length !== 0) return;
        logger.debug('End dragging row');
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        clearTimeout(removeDnDStylesTimeout.current);
        dragRowNode.current = null;
        $a54f184c0ce3b4c6$var$previousReorderState.dragDirection = null;
        // Check if the row was dropped outside the grid.
        if (event.dataTransfer.dropEffect === 'none') {
            // Accessing params.field may contain the wrong field as header elements are reused
            apiRef.current.setRowIndex(dragRowId, originRowIndex.current);
            originRowIndex.current = null;
        } else {
            // Emit the rowOrderChange event only once when the reordering stops.
            const rowOrderChangeParams = {
                row: apiRef.current.getRow(dragRowId),
                targetIndex: sortedRowIndexLookup[params.id],
                oldIndex: originRowIndex.current
            };
            apiRef.current.publishEvent('rowOrderChange', rowOrderChangeParams);
        }
        setDragRowId('');
    }, [
        apiRef,
        dragRowId,
        isRowReorderDisabled,
        logger,
        sortedRowIndexLookup
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowDragStart', handleDragStart);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowDragOver', handleDragOver);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'rowDragEnd', handleDragEnd);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'cellDragOver', handleDragOver);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(apiRef, 'rowOrderChange', props.onRowOrderChange);
};




var $lCzvA = parcelRequire("lCzvA");




const $2cef9f0ce52872fd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $lCzvA.useMemo(()=>{
        const slots = {
            rowReorderCellContainer: [
                'rowReorderCellContainer'
            ],
            columnHeaderReorder: [
                'columnHeaderReorder'
            ]
        };
        return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
    }, [
        classes
    ]);
};
const $2cef9f0ce52872fd$export$55f18eb0ec5c02d1 = (privateApiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = $2cef9f0ce52872fd$var$useUtilityClasses(ownerState);
    const updateReorderColumn = $lCzvA.useCallback((columnsState)=>{
        const reorderColumn = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $2b76f655c0610081$export$778666d70e672a78), {
            cellClassName: classes.rowReorderCellContainer,
            headerClassName: classes.columnHeaderReorder,
            headerName: privateApiRef.current.getLocaleText('rowReorderingHeaderName')
        });
        const shouldHaveReorderColumn = props.rowReordering;
        const hasReorderColumn = columnsState.lookup[reorderColumn.field] != null;
        if (shouldHaveReorderColumn && !hasReorderColumn) {
            columnsState.lookup[reorderColumn.field] = reorderColumn;
            columnsState.orderedFields = [
                reorderColumn.field,
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveReorderColumn && hasReorderColumn) {
            delete columnsState.lookup[reorderColumn.field];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== reorderColumn.field);
        } else if (shouldHaveReorderColumn && hasReorderColumn) {
            columnsState.lookup[reorderColumn.field] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, reorderColumn, columnsState.lookup[reorderColumn.field]);
            // If the column is not in the columns array (not a custom reorder column), move it to the beginning of the column order
            if (!props.columns.some((col)=>col.field === (0, $2b76f655c0610081$export$778666d70e672a78).field)) columnsState.orderedFields = [
                reorderColumn.field,
                ...columnsState.orderedFields.filter((field)=>field !== reorderColumn.field)
            ];
        }
        return columnsState;
    }, [
        privateApiRef,
        classes,
        props.columns,
        props.rowReordering
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(privateApiRef, 'hydrateColumns', updateReorderColumn);
};



var $lCzvA = parcelRequire("lCzvA");


function $9346718683ec3fc9$var$findSkeletonRowsSection({ apiRef: apiRef, visibleRows: visibleRows, range: range }) {
    let { firstRowIndex: firstRowIndex, lastRowIndex: lastRowIndex } = range;
    const visibleRowsSection = visibleRows.slice(range.firstRowIndex, range.lastRowIndex);
    let startIndex = 0;
    let endIndex = visibleRowsSection.length - 1;
    let isSkeletonSectionFound = false;
    while(!isSkeletonSectionFound && firstRowIndex < lastRowIndex){
        const isStartingWithASkeletonRow = apiRef.current.getRowNode(visibleRowsSection[startIndex].id)?.type === 'skeletonRow';
        const isEndingWithASkeletonRow = apiRef.current.getRowNode(visibleRowsSection[endIndex].id)?.type === 'skeletonRow';
        if (isStartingWithASkeletonRow && isEndingWithASkeletonRow) isSkeletonSectionFound = true;
        if (!isStartingWithASkeletonRow) {
            startIndex += 1;
            firstRowIndex += 1;
        }
        if (!isEndingWithASkeletonRow) {
            endIndex -= 1;
            lastRowIndex -= 1;
        }
    }
    return isSkeletonSectionFound ? {
        firstRowIndex: firstRowIndex,
        lastRowIndex: lastRowIndex
    } : undefined;
}
const $9346718683ec3fc9$export$c805ba869d6a5 = (privateApiRef, props)=>{
    const sortModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(privateApiRef, (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9));
    const filterModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(privateApiRef, (0, $6450fc0917754b27$export$280aedb9454597a5));
    const renderedRowsIntervalCache = $lCzvA.useRef({
        firstRowToRender: 0,
        lastRowToRender: 0
    });
    const isDisabled = props.rowsLoadingMode !== 'server';
    const handleRenderedRowsIntervalChange = $lCzvA.useCallback((params)=>{
        if (isDisabled) return;
        const fetchRowsParams = {
            firstRowToRender: params.firstRowIndex,
            lastRowToRender: params.lastRowIndex,
            sortModel: sortModel,
            filterModel: filterModel
        };
        if (renderedRowsIntervalCache.current.firstRowToRender === params.firstRowIndex && renderedRowsIntervalCache.current.lastRowToRender === params.lastRowIndex) return;
        renderedRowsIntervalCache.current = {
            firstRowToRender: params.firstRowIndex,
            lastRowToRender: params.lastRowIndex
        };
        if (sortModel.length === 0 && filterModel.items.length === 0) {
            const currentVisibleRows = (0, $6b6f708ce7819830$export$79b9fa322a34430b)(privateApiRef, {
                pagination: props.pagination,
                paginationMode: props.paginationMode
            });
            const skeletonRowsSection = $9346718683ec3fc9$var$findSkeletonRowsSection({
                apiRef: privateApiRef,
                visibleRows: currentVisibleRows.rows,
                range: {
                    firstRowIndex: params.firstRowIndex,
                    lastRowIndex: params.lastRowIndex
                }
            });
            if (!skeletonRowsSection) return;
            fetchRowsParams.firstRowToRender = skeletonRowsSection.firstRowIndex;
            fetchRowsParams.lastRowToRender = skeletonRowsSection.lastRowIndex;
        }
        privateApiRef.current.publishEvent('fetchRows', fetchRowsParams);
    }, [
        privateApiRef,
        isDisabled,
        props.pagination,
        props.paginationMode,
        sortModel,
        filterModel
    ]);
    const handleGridSortModelChange = $lCzvA.useCallback((newSortModel)=>{
        if (isDisabled) return;
        privateApiRef.current.requestPipeProcessorsApplication('hydrateRows');
        const renderContext = (0, $c79669abb772bd0a$export$4cf9f333a030f780)(privateApiRef);
        const fetchRowsParams = {
            firstRowToRender: renderContext.firstRowIndex,
            lastRowToRender: renderContext.lastRowIndex,
            sortModel: newSortModel,
            filterModel: filterModel
        };
        privateApiRef.current.publishEvent('fetchRows', fetchRowsParams);
    }, [
        privateApiRef,
        isDisabled,
        filterModel
    ]);
    const handleGridFilterModelChange = $lCzvA.useCallback((newFilterModel)=>{
        if (isDisabled) return;
        privateApiRef.current.requestPipeProcessorsApplication('hydrateRows');
        const renderContext = (0, $c79669abb772bd0a$export$4cf9f333a030f780)(privateApiRef);
        const fetchRowsParams = {
            firstRowToRender: renderContext.firstRowIndex,
            lastRowToRender: renderContext.lastRowIndex,
            sortModel: sortModel,
            filterModel: newFilterModel
        };
        privateApiRef.current.publishEvent('fetchRows', fetchRowsParams);
    }, [
        privateApiRef,
        isDisabled,
        sortModel
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(privateApiRef, 'renderedRowsIntervalChange', handleRenderedRowsIntervalChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(privateApiRef, 'sortModelChange', handleGridSortModelChange);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(privateApiRef, 'filterModelChange', handleGridFilterModelChange);
    (0, $ecad0fba09446fc0$export$d55ddab8b28954db)(privateApiRef, 'fetchRows', props.onFetchRows);
};




var $lCzvA = parcelRequire("lCzvA");


const $c01682eb208399d5$export$4fd3c65dfc13fe4b = 'auto-generated-skeleton-row-root';
const $c01682eb208399d5$var$getSkeletonRowId = (index)=>`${$c01682eb208399d5$export$4fd3c65dfc13fe4b}-${index}`;
const $c01682eb208399d5$export$220f673c81926201 = (privateApiRef, props)=>{
    const addSkeletonRows = $lCzvA.useCallback((groupingParams)=>{
        const rootGroup = groupingParams.tree[0, $dc4fe3453cdb0a0a$export$433b924dc2506913];
        if (props.rowsLoadingMode !== 'server' || !props.rowCount || rootGroup.children.length >= props.rowCount) return groupingParams;
        const tree = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParams.tree);
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        for(let i = 0; i < props.rowCount - rootGroup.children.length; i += 1){
            const skeletonId = $c01682eb208399d5$var$getSkeletonRowId(i);
            rootGroupChildren.push(skeletonId);
            const skeletonRowNode = {
                type: 'skeletonRow',
                id: skeletonId,
                parent: (0, $dc4fe3453cdb0a0a$export$433b924dc2506913),
                depth: 0
            };
            tree[skeletonId] = skeletonRowNode;
        }
        tree[0, $dc4fe3453cdb0a0a$export$433b924dc2506913] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootGroup, {
            children: rootGroupChildren
        });
        return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParams, {
            tree: tree
        });
    }, [
        props.rowCount,
        props.rowsLoadingMode
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(privateApiRef, 'hydrateRows', addSkeletonRows);
};




var $lCzvA = parcelRequire("lCzvA");


function $e6fb1945fac08045$var$createPinnedRowsInternalCache(pinnedRows, getRowId) {
    const cache = {
        topIds: [],
        bottomIds: [],
        idLookup: {}
    };
    pinnedRows?.top?.forEach((rowModel)=>{
        const id = (0, $dc4fe3453cdb0a0a$export$a95fb784d0ca2e72)(rowModel, getRowId);
        cache.topIds.push(id);
        cache.idLookup[id] = rowModel;
    });
    pinnedRows?.bottom?.forEach((rowModel)=>{
        const id = (0, $dc4fe3453cdb0a0a$export$a95fb784d0ca2e72)(rowModel, getRowId);
        cache.bottomIds.push(id);
        cache.idLookup[id] = rowModel;
    });
    return cache;
}
const $e6fb1945fac08045$export$68e0b9853cc25422 = (state, props, apiRef)=>{
    apiRef.current.caches.pinnedRows = $e6fb1945fac08045$var$createPinnedRowsInternalCache(props.pinnedRows, props.getRowId);
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        rows: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.rows, {
            additionalRowGroups: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.rows?.additionalRowGroups, {
                pinnedRows: {
                    top: [],
                    bottom: []
                }
            })
        })
    });
};
const $e6fb1945fac08045$export$d37ff411a3231397 = (apiRef, props)=>{
    const setPinnedRows = $lCzvA.useCallback((newPinnedRows)=>{
        apiRef.current.caches.pinnedRows = $e6fb1945fac08045$var$createPinnedRowsInternalCache(newPinnedRows, props.getRowId);
        apiRef.current.requestPipeProcessorsApplication('hydrateRows');
    }, [
        apiRef,
        props.getRowId
    ]);
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, {
        unstable_setPinnedRows: setPinnedRows
    }, 'public');
    const isFirstRender = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        apiRef.current.unstable_setPinnedRows(props.pinnedRows);
    }, [
        apiRef,
        props.pinnedRows
    ]);
};




var $lCzvA = parcelRequire("lCzvA");



function $345a2141ac0375d7$export$a9980a60d1e4cd4d({ groupingParams: groupingParams, rowModel: rowModel, rowId: rowId, position: position, apiRef: apiRef, isAutoGenerated: isAutoGenerated }) {
    const dataRowIdToModelLookup = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParams.dataRowIdToModelLookup);
    const dataRowIdToIdLookup = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParams.dataRowIdToIdLookup);
    const tree = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParams.tree);
    const treeDepths = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParams.treeDepths);
    // TODO: warn if id is already present in `props.rows`
    const node = {
        type: 'pinnedRow',
        id: rowId,
        depth: 0,
        parent: (0, $dc4fe3453cdb0a0a$export$433b924dc2506913),
        isAutoGenerated: isAutoGenerated
    };
    (0, $ded28721040d07ec$export$e179dd88ba706b74)(node, tree, treeDepths, null);
    if (!isAutoGenerated) {
        dataRowIdToModelLookup[rowId] = rowModel;
        dataRowIdToIdLookup[rowId] = rowId;
    }
    // Do not push it to ids list so that pagination is not affected by pinned rows
    apiRef.current.caches.rows.dataRowIdToModelLookup[rowId] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rowModel);
    apiRef.current.caches.rows.dataRowIdToIdLookup[rowId] = rowId;
    const previousPinnedRows = groupingParams.additionalRowGroups?.pinnedRows || {};
    const newPinnedRow = {
        id: rowId,
        model: rowModel
    };
    if (groupingParams.additionalRowGroups?.pinnedRows?.[position]?.includes(newPinnedRow)) return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParams, {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        tree: tree,
        treeDepths: treeDepths
    });
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParams, {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        tree: tree,
        treeDepths: treeDepths,
        additionalRowGroups: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParams.additionalRowGroups, {
            pinnedRows: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, previousPinnedRows, {
                [position]: [
                    ...previousPinnedRows[position] || [],
                    newPinnedRow
                ]
            })
        })
    });
}
const $345a2141ac0375d7$export$e392353a5909a7ad = (apiRef)=>{
    const prevPinnedRowsCacheRef = $lCzvA.useRef(null);
    const addPinnedRows = $lCzvA.useCallback((groupingParams)=>{
        const pinnedRowsCache = apiRef.current.caches.pinnedRows || {};
        const prevPinnedRowsCache = prevPinnedRowsCacheRef.current;
        prevPinnedRowsCacheRef.current = pinnedRowsCache;
        let newGroupingParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParams, {
            additionalRowGroups: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupingParams.additionalRowGroups, {
                // reset pinned rows state
                pinnedRows: {}
            })
        });
        if (prevPinnedRowsCache) {
            const pinnedRowCleanup = (rowId)=>{
                const node = newGroupingParams.tree[rowId];
                if (node?.type === 'pinnedRow') {
                    delete newGroupingParams.tree[rowId];
                    delete newGroupingParams.dataRowIdToModelLookup[rowId];
                    delete newGroupingParams.dataRowIdToIdLookup[rowId];
                    delete apiRef.current.caches.rows.dataRowIdToIdLookup[rowId];
                    delete apiRef.current.caches.rows.dataRowIdToModelLookup[rowId];
                }
            };
            prevPinnedRowsCache.topIds?.forEach(pinnedRowCleanup);
            prevPinnedRowsCache.bottomIds?.forEach(pinnedRowCleanup);
        }
        pinnedRowsCache.topIds?.forEach((rowId)=>{
            newGroupingParams = $345a2141ac0375d7$export$a9980a60d1e4cd4d({
                groupingParams: newGroupingParams,
                rowModel: pinnedRowsCache.idLookup[rowId],
                rowId: rowId,
                position: 'top',
                apiRef: apiRef,
                isAutoGenerated: false
            });
        });
        pinnedRowsCache.bottomIds?.forEach((rowId)=>{
            newGroupingParams = $345a2141ac0375d7$export$a9980a60d1e4cd4d({
                groupingParams: newGroupingParams,
                rowModel: pinnedRowsCache.idLookup[rowId],
                rowId: rowId,
                position: 'bottom',
                apiRef: apiRef,
                isAutoGenerated: false
            });
        });
        // If row with the same `id` is present both in `rows` and `pinnedRows` - remove it from the root group children
        if (pinnedRowsCache.bottomIds?.length || pinnedRowsCache.topIds?.length) {
            const shouldKeepRow = (rowId)=>{
                if (newGroupingParams.tree[rowId] && newGroupingParams.tree[rowId].type === 'pinnedRow') return false;
                return true;
            };
            const rootGroupNode = newGroupingParams.tree[0, $dc4fe3453cdb0a0a$export$433b924dc2506913];
            newGroupingParams.tree[0, $dc4fe3453cdb0a0a$export$433b924dc2506913] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootGroupNode, {
                children: rootGroupNode.children.filter(shouldKeepRow)
            });
            newGroupingParams.dataRowIds = newGroupingParams.dataRowIds.filter(shouldKeepRow);
        }
        return newGroupingParams;
    }, [
        apiRef
    ]);
    (0, $dfc17f0d90704ebe$export$faa98381ad228894)(apiRef, 'hydrateRows', addPinnedRows);
};




var $lCzvA = parcelRequire("lCzvA");






const $1e71fab90acc5418$var$MAX_CONCURRENT_REQUESTS = Infinity;
const $1e71fab90acc5418$export$318db8a2ee87ded0 = (modeProp, fn)=>()=>{
        if (modeProp === 'server') fn();
    };
let $1e71fab90acc5418$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus[RequestStatus["QUEUED"] = 0] = "QUEUED";
    RequestStatus[RequestStatus["PENDING"] = 1] = "PENDING";
    RequestStatus[RequestStatus["SETTLED"] = 2] = "SETTLED";
    RequestStatus[RequestStatus["UNKNOWN"] = 3] = "UNKNOWN";
    return RequestStatus;
}({});
class $1e71fab90acc5418$export$24c8f8bb2776cd57 {
    constructor(privateApiRef, maxConcurrentRequests = $1e71fab90acc5418$var$MAX_CONCURRENT_REQUESTS){
        this.pendingRequests = new Set();
        this.queuedRequests = new Set();
        this.settledRequests = new Set();
        this.api = void 0;
        this.maxConcurrentRequests = void 0;
        this.processQueue = async ()=>{
            if (this.queuedRequests.size === 0 || this.pendingRequests.size >= this.maxConcurrentRequests) return;
            const loopLength = Math.min(this.maxConcurrentRequests - this.pendingRequests.size, this.queuedRequests.size);
            if (loopLength === 0) return;
            const fetchQueue = Array.from(this.queuedRequests);
            for(let i = 0; i < loopLength; i += 1){
                const id = fetchQueue[i];
                this.queuedRequests.delete(id);
                this.pendingRequests.add(id);
                this.api.fetchRowChildren(id);
            }
        };
        this.queue = async (ids)=>{
            const loadingIds = {};
            ids.forEach((id)=>{
                this.queuedRequests.add(id);
                loadingIds[id] = true;
            });
            this.api.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                    dataSource: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.dataSource, {
                        loading: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.dataSource.loading, loadingIds)
                    })
                }));
            this.processQueue();
        };
        this.setRequestSettled = (id)=>{
            this.pendingRequests.delete(id);
            this.settledRequests.add(id);
            this.processQueue();
        };
        this.clear = ()=>{
            this.queuedRequests.clear();
            Array.from(this.pendingRequests).forEach((id)=>this.clearPendingRequest(id));
        };
        this.clearPendingRequest = (id)=>{
            this.api.unstable_dataSource.setChildrenLoading(id, false);
            this.pendingRequests.delete(id);
            this.processQueue();
        };
        this.getRequestStatus = (id)=>{
            if (this.pendingRequests.has(id)) return $1e71fab90acc5418$export$600e7c1f9e0414e1.PENDING;
            if (this.queuedRequests.has(id)) return $1e71fab90acc5418$export$600e7c1f9e0414e1.QUEUED;
            if (this.settledRequests.has(id)) return $1e71fab90acc5418$export$600e7c1f9e0414e1.SETTLED;
            return $1e71fab90acc5418$export$600e7c1f9e0414e1.UNKNOWN;
        };
        this.getActiveRequestsCount = ()=>this.pendingRequests.size + this.queuedRequests.size;
        this.api = privateApiRef.current;
        this.maxConcurrentRequests = maxConcurrentRequests;
    }
}


function $87e02227357ed821$export$a47fb462a08de82f(params) {
    return JSON.stringify([
        params.paginationModel,
        params.filterModel,
        params.sortModel,
        params.groupKeys,
        params.groupFields
    ]);
}
class $87e02227357ed821$export$116641d28fa9a089 {
    constructor({ ttl: ttl = 300000 }){
        this.cache = void 0;
        this.ttl = void 0;
        this.cache = {};
        this.ttl = ttl;
    }
    set(key, value) {
        const keyString = $87e02227357ed821$export$a47fb462a08de82f(key);
        const expiry = Date.now() + this.ttl;
        this.cache[keyString] = {
            value: value,
            expiry: expiry
        };
    }
    get(key) {
        const keyString = $87e02227357ed821$export$a47fb462a08de82f(key);
        const entry = this.cache[keyString];
        if (!entry) return undefined;
        if (Date.now() > entry.expiry) {
            delete this.cache[keyString];
            return undefined;
        }
        return entry.value;
    }
    clear() {
        this.cache = {};
    }
}


const $ceb2e5599f74fe2a$var$INITIAL_STATE = {
    loading: {},
    errors: {}
};
const $ceb2e5599f74fe2a$var$noopCache = {
    clear: ()=>{},
    get: ()=>undefined,
    set: ()=>{}
};
function $ceb2e5599f74fe2a$var$getCache(cacheProp) {
    if (cacheProp === null) return $ceb2e5599f74fe2a$var$noopCache;
    return cacheProp ?? new (0, $87e02227357ed821$export$116641d28fa9a089)({});
}
const $ceb2e5599f74fe2a$export$c26bbee6e465409c = (state)=>{
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
        dataSource: $ceb2e5599f74fe2a$var$INITIAL_STATE
    });
};
const $ceb2e5599f74fe2a$export$eb01c6fd4adcb288 = (apiRef, props)=>{
    const nestedDataManager = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)(()=>new (0, $1e71fab90acc5418$export$24c8f8bb2776cd57)(apiRef)).current;
    const groupsToAutoFetch = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$6c1cdbc7b5e9a3f4));
    const scheduledGroups = $lCzvA.useRef(0);
    const onError = props.unstable_onDataSourceError;
    const [cache, setCache] = $lCzvA.useState(()=>$ceb2e5599f74fe2a$var$getCache(props.unstable_dataSourceCache));
    const fetchRows = $lCzvA.useCallback(async (parentId)=>{
        const getRows = props.unstable_dataSource?.getRows;
        if (!getRows) return;
        if (parentId) {
            nestedDataManager.queue([
                parentId
            ]);
            return;
        }
        nestedDataManager.clear();
        scheduledGroups.current = 0;
        const dataSourceState = apiRef.current.state.dataSource;
        if (dataSourceState !== $ceb2e5599f74fe2a$var$INITIAL_STATE) apiRef.current.resetDataSourceState();
        const fetchParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $60c6fa93e6a0b804$export$85108be54a256312)(apiRef), apiRef.current.unstable_applyPipeProcessors('getRowsParams', {}));
        const cachedData = apiRef.current.unstable_dataSource.cache.get(fetchParams);
        if (cachedData !== undefined) {
            const rows = cachedData.rows;
            apiRef.current.setRows(rows);
            if (cachedData.rowCount !== undefined) apiRef.current.setRowCount(cachedData.rowCount);
            return;
        }
        const isLoading = (0, $68327dddce1a2c68$export$3c966d405f950b08)(apiRef);
        if (!isLoading) apiRef.current.setLoading(true);
        try {
            const getRowsResponse = await getRows(fetchParams);
            apiRef.current.unstable_dataSource.cache.set(fetchParams, getRowsResponse);
            if (getRowsResponse.rowCount !== undefined) apiRef.current.setRowCount(getRowsResponse.rowCount);
            apiRef.current.setRows(getRowsResponse.rows);
            apiRef.current.setLoading(false);
        } catch (error) {
            apiRef.current.setRows([]);
            apiRef.current.setLoading(false);
            onError?.(error, fetchParams);
        }
    }, [
        nestedDataManager,
        apiRef,
        props.unstable_dataSource?.getRows,
        onError
    ]);
    const fetchRowChildren = $lCzvA.useCallback(async (id)=>{
        const pipedParams = apiRef.current.unstable_applyPipeProcessors('getRowsParams', {});
        if (!props.treeData && (pipedParams.groupFields?.length ?? 0) === 0) {
            nestedDataManager.clearPendingRequest(id);
            return;
        }
        const getRows = props.unstable_dataSource?.getRows;
        if (!getRows) {
            nestedDataManager.clearPendingRequest(id);
            return;
        }
        const rowNode = apiRef.current.getRowNode(id);
        if (!rowNode) {
            nestedDataManager.clearPendingRequest(id);
            return;
        }
        const fetchParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $60c6fa93e6a0b804$export$85108be54a256312)(apiRef), pipedParams, {
            groupKeys: rowNode.path
        });
        const cachedData = apiRef.current.unstable_dataSource.cache.get(fetchParams);
        if (cachedData !== undefined) {
            const rows = cachedData.rows;
            nestedDataManager.setRequestSettled(id);
            apiRef.current.updateServerRows(rows, rowNode.path);
            if (cachedData.rowCount) apiRef.current.setRowCount(cachedData.rowCount);
            apiRef.current.setRowChildrenExpansion(id, true);
            apiRef.current.unstable_dataSource.setChildrenLoading(id, false);
            return;
        }
        const existingError = (0, $60c6fa93e6a0b804$export$5e89877f96467ba0)(apiRef)[id] ?? null;
        if (existingError) apiRef.current.unstable_dataSource.setChildrenFetchError(id, null);
        try {
            const getRowsResponse = await getRows(fetchParams);
            if (!apiRef.current.getRowNode(id)) {
                // The row has been removed from the grid
                nestedDataManager.clearPendingRequest(id);
                return;
            }
            if (nestedDataManager.getRequestStatus(id) === (0, $1e71fab90acc5418$export$600e7c1f9e0414e1).UNKNOWN) {
                apiRef.current.unstable_dataSource.setChildrenLoading(id, false);
                return;
            }
            nestedDataManager.setRequestSettled(id);
            apiRef.current.unstable_dataSource.cache.set(fetchParams, getRowsResponse);
            if (getRowsResponse.rowCount) apiRef.current.setRowCount(getRowsResponse.rowCount);
            apiRef.current.updateServerRows(getRowsResponse.rows, rowNode.path);
            apiRef.current.setRowChildrenExpansion(id, true);
        } catch (error) {
            const childrenFetchError = error;
            apiRef.current.unstable_dataSource.setChildrenFetchError(id, childrenFetchError);
            onError?.(childrenFetchError, fetchParams);
        } finally{
            apiRef.current.unstable_dataSource.setChildrenLoading(id, false);
            nestedDataManager.setRequestSettled(id);
        }
    }, [
        nestedDataManager,
        onError,
        apiRef,
        props.treeData,
        props.unstable_dataSource?.getRows
    ]);
    const setChildrenLoading = $lCzvA.useCallback((parentId, isLoading)=>{
        apiRef.current.setState((state)=>{
            if (!state.dataSource.loading[parentId] && isLoading === false) return state;
            const newLoadingState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.dataSource.loading);
            if (isLoading === false) delete newLoadingState[parentId];
            else newLoadingState[parentId] = isLoading;
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                dataSource: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.dataSource, {
                    loading: newLoadingState
                })
            });
        });
    }, [
        apiRef
    ]);
    const setChildrenFetchError = $lCzvA.useCallback((parentId, error)=>{
        apiRef.current.setState((state)=>{
            const newErrorsState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.dataSource.errors);
            if (error === null && newErrorsState[parentId] !== undefined) delete newErrorsState[parentId];
            else newErrorsState[parentId] = error;
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                dataSource: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state.dataSource, {
                    errors: newErrorsState
                })
            });
        });
    }, [
        apiRef
    ]);
    const resetDataSourceState = $lCzvA.useCallback(()=>{
        apiRef.current.setState((state)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                dataSource: $ceb2e5599f74fe2a$var$INITIAL_STATE
            });
        });
    }, [
        apiRef
    ]);
    const debouncedFetchRows = $lCzvA.useMemo(()=>(0, $9b0d55c89532c0b3$export$2e2bcd8739ae039)(fetchRows, 0), [
        fetchRows
    ]);
    const dataSourceApi = {
        unstable_dataSource: {
            setChildrenLoading: setChildrenLoading,
            setChildrenFetchError: setChildrenFetchError,
            fetchRows: fetchRows,
            cache: cache
        }
    };
    const dataSourcePrivateApi = {
        fetchRowChildren: fetchRowChildren,
        resetDataSourceState: resetDataSourceState
    };
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, dataSourceApi, 'public');
    (0, $05d95cd1fe366fb9$export$739f6b6a65e76d6c)(apiRef, dataSourcePrivateApi, 'private');
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'sortModelChange', (0, $1e71fab90acc5418$export$318db8a2ee87ded0)(props.sortingMode, debouncedFetchRows));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'filterModelChange', (0, $1e71fab90acc5418$export$318db8a2ee87ded0)(props.filterMode, debouncedFetchRows));
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'paginationModelChange', (0, $1e71fab90acc5418$export$318db8a2ee87ded0)(props.paginationMode, debouncedFetchRows));
    const isFirstRender = $lCzvA.useRef(true);
    $lCzvA.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const newCache = $ceb2e5599f74fe2a$var$getCache(props.unstable_dataSourceCache);
        setCache((prevCache)=>prevCache !== newCache ? newCache : prevCache);
    }, [
        props.unstable_dataSourceCache
    ]);
    $lCzvA.useEffect(()=>{
        if (props.unstable_dataSource) {
            apiRef.current.unstable_dataSource.cache.clear();
            apiRef.current.unstable_dataSource.fetchRows();
        }
    }, [
        apiRef,
        props.unstable_dataSource
    ]);
    $lCzvA.useEffect(()=>{
        if (groupsToAutoFetch && groupsToAutoFetch.length && scheduledGroups.current < groupsToAutoFetch.length) {
            const groupsToSchedule = groupsToAutoFetch.slice(scheduledGroups.current);
            nestedDataManager.queue(groupsToSchedule);
            scheduledGroups.current = groupsToAutoFetch.length;
        }
    }, [
        apiRef,
        nestedDataManager,
        groupsToAutoFetch
    ]);
};


const $c44a5aa9bb3097e6$export$ae01925210967ff3 = (inputApiRef, props)=>{
    const apiRef = (0, $a4a05b7ba93b75de$export$b77462c86b28bbf0)(inputApiRef, props);
    /**
   * Register all pre-processors called during state initialization here.
   * Some pre-processors are changing the same part of the state (like the order of the columns).
   * Order them in descending order of priority.
   * For example, left pinned columns should always render first from the left, so the `hydrateColumns` pre-processor from `useGridColumnPinningPreProcessors` should be called last (after all other `hydrateColumns` pre-processors).
   * Similarly, the `hydrateColumns` pre-processor from `useGridRowSelectionPreProcessors` should be called after `useGridTreeDataPreProcessors` because the selection checkboxes should appear before the tree data.
   * Desired autogenerated columns order is:
   * left pinned columns -> row reordering column -> checkbox column -> tree data column -> master detail column -> rest of the columns
   */ (0, $bcd4bc19c3b174cb$export$77f589f94558bf61)(apiRef, props);
    (0, $f039f7d30e484b6e$export$7e966b04a1d3262a)(apiRef, props);
    (0, $aba567714f9b3c0c$export$88440965063d297f)(apiRef, props);
    (0, $78aa136d03a13d7e$export$fa1d7b0897c018ea)(apiRef, props);
    (0, $c01682eb208399d5$export$220f673c81926201)(apiRef, props);
    (0, $345a2141ac0375d7$export$e392353a5909a7ad)(apiRef);
    (0, $2cef9f0ce52872fd$export$55f18eb0ec5c02d1)(apiRef, props);
    (0, $aa025e80e2d82a71$export$47a2167ef2ac089d)(apiRef, props);
    (0, $16d5e19196154261$export$cc1daa683bbe5702)(apiRef);
    /**
   * Register all state initializers here.
   */ (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $94bdb7e9d13ae4d8$export$eb04177a3403979f), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $1bfbb38b8132c751$export$e29505bd53a069c8), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $43310e1ea3af1013$export$73be1d69367eeb5b), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $9f75fdb66e01126e$export$c6a1049ecc0f594c), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $0561e29a2854e03f$export$5fee0234a63f3519), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $742cc9978dd17236$export$8dcda879a58a8f96), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $e6fb1945fac08045$export$68e0b9853cc25422), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $a663ef9e6ca2a05f$export$1a6bb5bb341eadaa), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $d389ae55b1b23cd7$export$951a05deca7e869f), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $953627351a4701cd$export$1094a2c822d71ffd), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $73b6c50554d238e2$export$bfde38b067fac467), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $457e65bc2ecc239e$export$996e35c2eef351ae), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $baace636788947e1$export$a9f45f767b8ade48), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $cf681cc58557b459$export$a3e5a984fe72a5db), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $ede0e3e90bccd35d$export$1fc0574395a3c13e), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $f10296779b31302e$export$d6d71dbaaa6fec72), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $94fef3cf6d71bade$export$c111e737ab642862), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $735562a08be471d6$export$ac6ed2ccd52f643f), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $01de41b14b792d22$export$8574ffe06bf26347), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $aad4fc540ae297b2$export$21c841dc431b3cd0), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $09cd0e588d664565$export$42963ad70bb69f54), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $ceb2e5599f74fe2a$export$c26bbee6e465409c), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $ecd24dbdbaa9f7cf$export$c29f872c616fae5b), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $d34fcc65bc9a26dd$export$4224c70cd0329965), apiRef, props);
    (0, $de64e767ade13fa3$export$f9587d613f2caeec)((0, $41fab1063a7fd4d9$export$5505a327712c37f5), apiRef, props);
    (0, $1bfbb38b8132c751$export$8ee3ddc1b48b5da9)(apiRef, props);
    (0, $9fff98019ad208b0$export$15cdd24474e74350)(apiRef, props);
    (0, $29324abe0b682926$export$142b8bb1fe6da473)(apiRef, props);
    (0, $43310e1ea3af1013$export$3e2b6b991d9d83f0)(apiRef, props);
    (0, $0561e29a2854e03f$export$2534ab700dd48c29)(apiRef, props);
    (0, $e6fb1945fac08045$export$d37ff411a3231397)(apiRef, props);
    (0, $742cc9978dd17236$export$fe9b9b8b4620abff)(apiRef, props);
    (0, $a663ef9e6ca2a05f$export$dd1a4469bbd9394e)(apiRef, props);
    (0, $ede0e3e90bccd35d$export$bd58ae04485aa5f5)(apiRef, props);
    (0, $4a7997ea0cc9ccd9$export$d5da41ef394db9ef)(apiRef, props);
    (0, $9f75fdb66e01126e$export$b71d7525fdd57704)(apiRef, props);
    (0, $2a3a4a92424bde2f$export$ce7ce4871097b52e)(apiRef);
    (0, $aad4fc540ae297b2$export$510984a37e2e33f3)(apiRef, props);
    (0, $953627351a4701cd$export$3a0db16b152b4c54)(apiRef, props);
    (0, $73b6c50554d238e2$export$8b69791fef06a777)(apiRef, props);
    (0, $baace636788947e1$export$343dd9a605dbb75b)(apiRef, props);
    (0, $cf681cc58557b459$export$42838275cbf666c4)(apiRef, props);
    (0, $457e65bc2ecc239e$export$951287757eb5d93c)(apiRef, props);
    (0, $f10296779b31302e$export$836c4be63cf7a42d)(apiRef, props);
    (0, $94fef3cf6d71bade$export$e060c7667a4364d2)(apiRef, props);
    (0, $735562a08be471d6$export$6761a7afeb3daa64)(apiRef, props);
    (0, $d389ae55b1b23cd7$export$f1c8f1c02d202e22)(apiRef, props);
    (0, $d34fcc65bc9a26dd$export$8a4468671da3a64f)(apiRef, props);
    (0, $a54f184c0ce3b4c6$export$628fe35635cfd286)(apiRef, props);
    (0, $bfc05419669f10ba$export$d3441dc29db31b8c)(apiRef, props);
    (0, $ec06e7a1aece4114$export$ffcbb8895be5a582)(apiRef, props);
    (0, $9346718683ec3fc9$export$c805ba869d6a5)(apiRef, props);
    (0, $01de41b14b792d22$export$1fc2975c9a725449)(apiRef);
    (0, $70c425efce79965d$export$6178dbab26611702)(apiRef, props);
    (0, $13a09b1d69c4e28f$export$41205b2521d4edd4)(apiRef, props);
    (0, $e3cc0dcfdf8bd711$export$a44b2f69ac6aef73)(apiRef, props);
    (0, $ecd24dbdbaa9f7cf$export$b8364994f9eec67d)(apiRef, props);
    (0, $cea9d2b318bcdc99$export$8456f443918812d4)(apiRef, props);
    (0, $b74a5c3db1daeb6b$export$971de86bde7f86a1)(apiRef);
    (0, $09cd0e588d664565$export$aa0d6df32cccbd53)(apiRef, props);
    (0, $ceb2e5599f74fe2a$export$eb01c6fd4adcb288)(apiRef, props);
    (0, $41fab1063a7fd4d9$export$5ab13dce76367dce)(apiRef, props);
    return apiRef;
};




var $lCzvA = parcelRequire("lCzvA");


function $56b13c9b7d49b307$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $650cdafe9746b559$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}


const $5128c3fdbbfd0415$export$d217cc4e11b3c706 = {
    // Root
    noRowsLabel: 'No rows',
    noResultsOverlayLabel: 'No results found.',
    // Density selector toolbar button text
    toolbarDensity: 'Density',
    toolbarDensityLabel: 'Density',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Comfortable',
    // Columns selector toolbar button text
    toolbarColumns: 'Columns',
    toolbarColumnsLabel: 'Select columns',
    // Filters toolbar button text
    toolbarFilters: 'Filters',
    toolbarFiltersLabel: 'Show filters',
    toolbarFiltersTooltipHide: 'Hide filters',
    toolbarFiltersTooltipShow: 'Show filters',
    toolbarFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: "Search\u2026",
    toolbarQuickFilterLabel: 'Search',
    toolbarQuickFilterDeleteIconLabel: 'Clear',
    // Export selector toolbar button text
    toolbarExport: 'Export',
    toolbarExportLabel: 'Export',
    toolbarExportCSV: 'Download as CSV',
    toolbarExportPrint: 'Print',
    toolbarExportExcel: 'Download as Excel',
    // Columns management text
    columnsManagementSearchTitle: 'Search',
    columnsManagementNoColumns: 'No columns',
    columnsManagementShowHideAllText: 'Show/Hide All',
    columnsManagementReset: 'Reset',
    columnsManagementDeleteIconLabel: 'Clear',
    // Filter panel text
    filterPanelAddFilter: 'Add filter',
    filterPanelRemoveAll: 'Remove all',
    filterPanelDeleteIconLabel: 'Delete',
    filterPanelLogicOperator: 'Logic operator',
    filterPanelOperator: 'Operator',
    filterPanelOperatorAnd: 'And',
    filterPanelOperatorOr: 'Or',
    filterPanelColumns: 'Columns',
    filterPanelInputLabel: 'Value',
    filterPanelInputPlaceholder: 'Filter value',
    // Filter operators text
    filterOperatorContains: 'contains',
    filterOperatorDoesNotContain: 'does not contain',
    filterOperatorEquals: 'equals',
    filterOperatorDoesNotEqual: 'does not equal',
    filterOperatorStartsWith: 'starts with',
    filterOperatorEndsWith: 'ends with',
    filterOperatorIs: 'is',
    filterOperatorNot: 'is not',
    filterOperatorAfter: 'is after',
    filterOperatorOnOrAfter: 'is on or after',
    filterOperatorBefore: 'is before',
    filterOperatorOnOrBefore: 'is on or before',
    filterOperatorIsEmpty: 'is empty',
    filterOperatorIsNotEmpty: 'is not empty',
    filterOperatorIsAnyOf: 'is any of',
    'filterOperator=': '=',
    'filterOperator!=': '!=',
    'filterOperator>': '>',
    'filterOperator>=': '>=',
    'filterOperator<': '<',
    'filterOperator<=': '<=',
    // Header filter operators text
    headerFilterOperatorContains: 'Contains',
    headerFilterOperatorDoesNotContain: 'Does not contain',
    headerFilterOperatorEquals: 'Equals',
    headerFilterOperatorDoesNotEqual: 'Does not equal',
    headerFilterOperatorStartsWith: 'Starts with',
    headerFilterOperatorEndsWith: 'Ends with',
    headerFilterOperatorIs: 'Is',
    headerFilterOperatorNot: 'Is not',
    headerFilterOperatorAfter: 'Is after',
    headerFilterOperatorOnOrAfter: 'Is on or after',
    headerFilterOperatorBefore: 'Is before',
    headerFilterOperatorOnOrBefore: 'Is on or before',
    headerFilterOperatorIsEmpty: 'Is empty',
    headerFilterOperatorIsNotEmpty: 'Is not empty',
    headerFilterOperatorIsAnyOf: 'Is any of',
    'headerFilterOperator=': 'Equals',
    'headerFilterOperator!=': 'Not equals',
    'headerFilterOperator>': 'Greater than',
    'headerFilterOperator>=': 'Greater than or equal to',
    'headerFilterOperator<': 'Less than',
    'headerFilterOperator<=': 'Less than or equal to',
    // Filter values text
    filterValueAny: 'any',
    filterValueTrue: 'true',
    filterValueFalse: 'false',
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuAriaLabel: (columnName)=>`${columnName} column menu`,
    columnMenuShowColumns: 'Show columns',
    columnMenuManageColumns: 'Manage columns',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Hide column',
    columnMenuUnsort: 'Unsort',
    columnMenuSortAsc: 'Sort by ASC',
    columnMenuSortDesc: 'Sort by DESC',
    // Column header text
    columnHeaderFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    columnHeaderFiltersLabel: 'Show filters',
    columnHeaderSortIconLabel: 'Sort',
    // Rows selected footer text
    footerRowSelected: (count)=>count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
    // Total row amount footer text
    footerTotalRows: 'Total Rows:',
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount)=>`${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
    // Checkbox selection text
    checkboxSelectionHeaderName: 'Checkbox selection',
    checkboxSelectionSelectAllRows: 'Select all rows',
    checkboxSelectionUnselectAllRows: 'Unselect all rows',
    checkboxSelectionSelectRow: 'Select row',
    checkboxSelectionUnselectRow: 'Unselect row',
    // Boolean cell text
    booleanCellTrueLabel: 'yes',
    booleanCellFalseLabel: 'no',
    // Actions cell more text
    actionsCellMore: 'more',
    // Column pinning text
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    unpin: 'Unpin',
    // Tree Data
    treeDataGroupingHeaderName: 'Group',
    treeDataExpand: 'see children',
    treeDataCollapse: 'hide children',
    // Grouping columns
    groupingColumnHeaderName: 'Group',
    groupColumn: (name)=>`Group by ${name}`,
    unGroupColumn: (name)=>`Stop grouping by ${name}`,
    // Master/detail
    detailPanelToggle: 'Detail panel toggle',
    expandDetailPanel: 'Expand',
    collapseDetailPanel: 'Collapse',
    // Used core components translation keys
    MuiTablePagination: {},
    // Row reordering text
    rowReorderingHeaderName: 'Row reordering',
    // Aggregation
    aggregationMenuItemHeader: 'Aggregation',
    aggregationFunctionLabelSum: 'sum',
    aggregationFunctionLabelAvg: 'avg',
    aggregationFunctionLabelMin: 'min',
    aggregationFunctionLabelMax: 'max',
    aggregationFunctionLabelSize: 'size'
};



function $4d469ca6d8b0c2a7$export$247af54f7c54fca({ defaultSlots: defaultSlots, slots: slots }) {
    const overrides = slots;
    if (!overrides || Object.keys(overrides).length === 0) return defaultSlots;
    const result = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, defaultSlots);
    Object.keys(overrides).forEach((key)=>{
        const k = key;
        if (overrides[k] !== undefined) result[k] = overrides[k];
    });
    return result;
}


var $lCzvA = parcelRequire("lCzvA");
/** Gathers props for the root element into a single `.forwardedProps` field */ function $50a5a4041c3966d9$var$groupForwardedProps(props) {
    if (props.slotProps?.root) return props;
    const keys = Object.keys(props);
    if (!keys.some((key)=>key.startsWith('aria-') || key.startsWith('data-'))) return props;
    const newProps = {};
    const forwardedProps = props.forwardedProps ?? {};
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        if (key.startsWith('aria-') || key.startsWith('data-')) forwardedProps[key] = props[key];
        else newProps[key] = props[key];
    }
    newProps.forwardedProps = forwardedProps;
    return newProps;
}
function $50a5a4041c3966d9$export$1f264be2c424fccf(allProps) {
    return $lCzvA.useMemo(()=>$50a5a4041c3966d9$var$groupForwardedProps(allProps), [
        allProps
    ]);
}






var $lCzvA = parcelRequire("lCzvA");










parcelRequire("lCzvA");







const $6abf58300eaaa433$var$_excluded = [
    "className"
];
const $6abf58300eaaa433$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'iconButtonContainer'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $6abf58300eaaa433$var$GridIconButtonContainerRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'IconButtonContainer',
    overridesResolver: (props, styles)=>styles.iconButtonContainer
})(()=>({
        display: 'flex',
        visibility: 'hidden',
        width: 0
    }));
const $6abf58300eaaa433$export$e67562d5b709404c = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridIconButtonContainer(props, ref) {
    const { className: className } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $6abf58300eaaa433$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $6abf58300eaaa433$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6abf58300eaaa433$var$GridIconButtonContainerRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});



const $6d6fd6931d33b865$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        icon: [
            'filterIcon'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $6d6fd6931d33b865$export$35b5c67d267fafd7(props) {
    if (!props.counter) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6d6fd6931d33b865$var$GridColumnHeaderFilterIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props));
}
function $6d6fd6931d33b865$var$GridColumnHeaderFilterIconButton(props) {
    const { counter: counter, field: field, onClick: onClick } = props;
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes
    });
    const classes = $6d6fd6931d33b865$var$useUtilityClasses(ownerState);
    const labelId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const isOpen = (0, $1e10d601c15466d4$export$3b2f72ef07abe101)(apiRef, (0, $471c38056db01dd0$export$d19024d6f0cb2c88), labelId);
    const panelId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const toggleFilter = $lCzvA.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        const { open: open, openedPanelValue: openedPanelValue } = (0, $471c38056db01dd0$export$37e5474577e02878)(apiRef.current.state);
        if (open && openedPanelValue === (0, $57afc8119b2eb3e6$export$e7e5652452e44b).filters) apiRef.current.hideFilterPanel();
        else apiRef.current.showFilterPanel(undefined, panelId, labelId);
        if (onClick) onClick(apiRef.current.getColumnHeaderParams(field), event);
    }, [
        apiRef,
        field,
        onClick,
        panelId,
        labelId
    ]);
    if (!counter) return null;
    const iconButton = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        id: labelId,
        onClick: toggleFilter,
        color: "default",
        "aria-label": apiRef.current.getLocaleText('columnHeaderFiltersLabel'),
        size: "small",
        tabIndex: -1,
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        "aria-controls": isOpen ? panelId : undefined
    }, rootProps.slotProps?.baseIconButton, {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnFilteredIcon, {
            className: classes.icon,
            fontSize: "small"
        })
    }));
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseTooltip, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        title: apiRef.current.getLocaleText('columnHeaderFiltersTooltipActive')(counter),
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $6abf58300eaaa433$export$e67562d5b709404c), {
            children: [
                counter > 1 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseBadge, {
                    badgeContent: counter,
                    color: "default",
                    children: iconButton
                }),
                counter === 1 && iconButton
            ]
        })
    }));
}




var $lCzvA = parcelRequire("lCzvA");








const $874feb4a30eb6825$var$_excluded = [
    "direction",
    "index",
    "sortingOrder",
    "disabled",
    "className"
];
const $874feb4a30eb6825$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'sortButton'
        ],
        icon: [
            'sortIcon'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $874feb4a30eb6825$var$getIcon(icons, direction, className, sortingOrder) {
    let Icon;
    const iconProps = {};
    if (direction === 'asc') Icon = icons.columnSortedAscendingIcon;
    else if (direction === 'desc') Icon = icons.columnSortedDescendingIcon;
    else {
        Icon = icons.columnUnsortedIcon;
        iconProps.sortingOrder = sortingOrder;
    }
    return Icon ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Icon, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        fontSize: "small",
        className: className
    }, iconProps)) : null;
}
function $874feb4a30eb6825$var$GridColumnHeaderSortIconRaw(props) {
    const { direction: direction, index: index, sortingOrder: sortingOrder, disabled: disabled, className: className } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $874feb4a30eb6825$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes
    });
    const classes = $874feb4a30eb6825$var$useUtilityClasses(ownerState);
    const iconElement = $874feb4a30eb6825$var$getIcon(rootProps.slots, direction, classes.icon, sortingOrder);
    if (!iconElement) return null;
    const iconButton = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        tabIndex: -1,
        "aria-label": apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        title: apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        size: "small",
        disabled: disabled,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className)
    }, rootProps.slotProps?.baseIconButton, other, {
        children: iconElement
    }));
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $6abf58300eaaa433$export$e67562d5b709404c), {
        children: [
            index != null && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseBadge, {
                badgeContent: index,
                color: "default",
                overlap: "circular",
                children: iconButton
            }),
            index == null && iconButton
        ]
    });
}
const $874feb4a30eb6825$export$80cd75c5dceceac6 = /*#__PURE__*/ $lCzvA.memo($874feb4a30eb6825$var$GridColumnHeaderSortIconRaw);



var $lCzvA = parcelRequire("lCzvA");



var $lCzvA = parcelRequire("lCzvA");









var $lCzvA = parcelRequire("lCzvA");










function $cfa7807fac58cfaf$export$24c1f8f60cbac79e(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiTypography', slot);
}
const $cfa7807fac58cfaf$var$typographyClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $cfa7807fac58cfaf$export$2e2bcd8739ae039 = $cfa7807fac58cfaf$var$typographyClasses;



'use client';
const $52e1ac97c40de237$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $52e1ac97c40de237$var$extendSxProp = (0, $e25f007abb0d56af$export$7e7f5719ff4debb1)();
const $52e1ac97c40de237$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $212bca41d578456f$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $cfa7807fac58cfaf$export$24c1f8f60cbac79e), classes);
};
const $52e1ac97c40de237$export$140e2f5526d3cad8 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $52e1ac97c40de237$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $52e1ac97c40de237$var$Typography = /*#__PURE__*/ $lCzvA.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$52e1ac97c40de237$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $52e1ac97c40de237$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $52e1ac97c40de237$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $52e1ac97c40de237$var$defaultVariantMapping[variant]) || 'span';
    const classes = $52e1ac97c40de237$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52e1ac97c40de237$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $52e1ac97c40de237$export$2e2bcd8739ae039 = $52e1ac97c40de237$var$Typography;





function $c7819293a7ea96ea$export$717666c39ec07e12(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiFormControlLabel', slot);
}
const $c7819293a7ea96ea$var$formControlLabelClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $c7819293a7ea96ea$export$2e2bcd8739ae039 = $c7819293a7ea96ea$var$formControlLabelClasses;





'use client';
const $5aeae6e59293cfb6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $212bca41d578456f$export$2e2bcd8739ae039)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $c7819293a7ea96ea$export$717666c39ec07e12), classes);
};
const $5aeae6e59293cfb6$export$1b479270917a5676 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c7819293a7ea96ea$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $c7819293a7ea96ea$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $c7819293a7ea96ea$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $c7819293a7ea96ea$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $5aeae6e59293cfb6$var$AsteriskComponent = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $c7819293a7ea96ea$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $5aeae6e59293cfb6$var$FormControlLabel = /*#__PURE__*/ $lCzvA.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $a66fe280d54e059b$export$2e2bcd8739ae039)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $68f7e6835ed8d269$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $5aeae6e59293cfb6$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('typography', {
        elementType: (0, $52e1ac97c40de237$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $52e1ac97c40de237$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($5aeae6e59293cfb6$export$1b479270917a5676, {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $lCzvA.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($5aeae6e59293cfb6$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $5aeae6e59293cfb6$export$2e2bcd8739ae039 = $5aeae6e59293cfb6$var$FormControlLabel;




var $lCzvA = parcelRequire("lCzvA");








var $lCzvA = parcelRequire("lCzvA");













'use client';
const $5fb6dfeb1eaede71$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $292dbef72fe6adc9$export$cdb270390122322b), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $5fb6dfeb1eaede71$var$InputRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $92d8fc367f7e2f74$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $be3f20df888d18ba$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $92d8fc367f7e2f74$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $292dbef72fe6adc9$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $292dbef72fe6adc9$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $292dbef72fe6adc9$export$2e2bcd8739ae039).disabled}, .${(0, $292dbef72fe6adc9$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $292dbef72fe6adc9$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $5fb6dfeb1eaede71$var$InputInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $92d8fc367f7e2f74$export$ee10465db6ff6017), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $92d8fc367f7e2f74$export$cf507b112810e72d)
})({});
const $5fb6dfeb1eaede71$var$Input = /*#__PURE__*/ $lCzvA.forwardRef(function Input(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $5fb6dfeb1eaede71$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $b80cadb21e077670$export$2e2bcd8739ae039)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $5fb6dfeb1eaede71$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $5fb6dfeb1eaede71$var$InputInput;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $92d8fc367f7e2f74$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$5fb6dfeb1eaede71$var$Input.muiName = 'Input';
var $5fb6dfeb1eaede71$export$2e2bcd8739ae039 = $5fb6dfeb1eaede71$var$Input;



var $lCzvA = parcelRequire("lCzvA");














'use client';
const $dfa3a50b968b9dd6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $3a25d1a7c6322cc0$export$3331e419f1a48437), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $dfa3a50b968b9dd6$var$FilledInputRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $92d8fc367f7e2f74$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $be3f20df888d18ba$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $92d8fc367f7e2f74$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).disabled}, .${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $3a25d1a7c6322cc0$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $dfa3a50b968b9dd6$var$FilledInputInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $92d8fc367f7e2f74$export$ee10465db6ff6017), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $92d8fc367f7e2f74$export$cf507b112810e72d)
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $dfa3a50b968b9dd6$var$FilledInput = /*#__PURE__*/ $lCzvA.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $dfa3a50b968b9dd6$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $b80cadb21e077670$export$2e2bcd8739ae039)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $dfa3a50b968b9dd6$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $dfa3a50b968b9dd6$var$FilledInputInput;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $92d8fc367f7e2f74$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$dfa3a50b968b9dd6$var$FilledInput.muiName = 'Input';
var $dfa3a50b968b9dd6$export$2e2bcd8739ae039 = $dfa3a50b968b9dd6$var$FilledInput;



var $lCzvA = parcelRequire("lCzvA");



parcelRequire("lCzvA");





'use client';
var $fcc152064e7b476a$var$_span;
const $fcc152064e7b476a$var$NotchedOutlineRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $be3f20df888d18ba$export$2e2bcd8739ae039)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $fcc152064e7b476a$var$NotchedOutlineLegend = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $be3f20df888d18ba$export$2e2bcd8739ae039)
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $fcc152064e7b476a$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($fcc152064e7b476a$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($fcc152064e7b476a$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                children: label
            }) : $fcc152064e7b476a$var$_span || ($fcc152064e7b476a$var$_span = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}













'use client';
const $6a32367e5d39315f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $5af7f14e2a83efc7$export$89922944c7227687), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $6a32367e5d39315f$var$OutlinedInputRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $92d8fc367f7e2f74$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $be3f20df888d18ba$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $92d8fc367f7e2f74$export$965edad20a84fa75)
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).focused} .${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).focused} .${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).error} .${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).disabled} .${(0, $5af7f14e2a83efc7$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $6a32367e5d39315f$var$NotchedOutlineRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $fcc152064e7b476a$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const $6a32367e5d39315f$var$OutlinedInputInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $92d8fc367f7e2f74$export$ee10465db6ff6017), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $92d8fc367f7e2f74$export$cf507b112810e72d)
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $6a32367e5d39315f$var$OutlinedInput = /*#__PURE__*/ $lCzvA.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $6a32367e5d39315f$var$useUtilityClasses(props);
    const muiFormControl = (0, $a66fe280d54e059b$export$2e2bcd8739ae039)();
    const fcs = (0, $68f7e6835ed8d269$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $6a32367e5d39315f$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $6a32367e5d39315f$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('notchedOutline', {
        elementType: $6a32367e5d39315f$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $92d8fc367f7e2f74$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$6a32367e5d39315f$var$OutlinedInput.muiName = 'Input';
var $6a32367e5d39315f$export$2e2bcd8739ae039 = $6a32367e5d39315f$var$OutlinedInput;



var $lCzvA = parcelRequire("lCzvA");






var $lCzvA = parcelRequire("lCzvA");












function $3bf76a4d91119aee$export$f7d501e40371cd17(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiFormLabel', slot);
}
const $3bf76a4d91119aee$var$formLabelClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $3bf76a4d91119aee$export$2e2bcd8739ae039 = $3bf76a4d91119aee$var$formLabelClasses;



'use client';
const $a12119ccbfd5e1cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $3bf76a4d91119aee$export$f7d501e40371cd17), classes);
};
const $a12119ccbfd5e1cb$export$aa5bc7f8a4705b27 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $3bf76a4d91119aee$export$2e2bcd8739ae039).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $3bf76a4d91119aee$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $3bf76a4d91119aee$export$2e2bcd8739ae039).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $a12119ccbfd5e1cb$var$AsteriskComponent = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $3bf76a4d91119aee$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $a12119ccbfd5e1cb$var$FormLabel = /*#__PURE__*/ $lCzvA.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $a66fe280d54e059b$export$2e2bcd8739ae039)();
    const fcs = (0, $68f7e6835ed8d269$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $a12119ccbfd5e1cb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($a12119ccbfd5e1cb$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($a12119ccbfd5e1cb$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $a12119ccbfd5e1cb$export$2e2bcd8739ae039 = $a12119ccbfd5e1cb$var$FormLabel;









function $c81a024a918d8c71$export$c1c4b4545ad2ea5f(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiInputLabel', slot);
}
const $c81a024a918d8c71$var$inputLabelClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $c81a024a918d8c71$export$2e2bcd8739ae039 = $c81a024a918d8c71$var$inputLabelClasses;



'use client';
const $460e9c37f39d8a56$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $c81a024a918d8c71$export$c1c4b4545ad2ea5f), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $460e9c37f39d8a56$var$InputLabelRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $a12119ccbfd5e1cb$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $be3f20df888d18ba$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $3bf76a4d91119aee$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $460e9c37f39d8a56$var$InputLabel = /*#__PURE__*/ $lCzvA.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $a66fe280d54e059b$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $68f7e6835ed8d269$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $460e9c37f39d8a56$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($460e9c37f39d8a56$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $460e9c37f39d8a56$export$2e2bcd8739ae039 = $460e9c37f39d8a56$var$InputLabel;



var $lCzvA = parcelRequire("lCzvA");








var $lCzvA = parcelRequire("lCzvA");
function $921f4167a9493b53$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $lCzvA.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}


var $ccf3b9da3a71d526$export$2e2bcd8739ae039 = (0, $921f4167a9493b53$export$2e2bcd8739ae039);





function $6a84565421f49e2d$export$149c8b8bab2289d1(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiFormControl', slot);
}
const $6a84565421f49e2d$var$formControlClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $6a84565421f49e2d$export$2e2bcd8739ae039 = $6a84565421f49e2d$var$formControlClasses;



'use client';
const $8419414d64eb4ced$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $212bca41d578456f$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $6a84565421f49e2d$export$149c8b8bab2289d1), classes);
};
const $8419414d64eb4ced$var$FormControlRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $8419414d64eb4ced$var$FormControl = /*#__PURE__*/ $lCzvA.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $8419414d64eb4ced$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $lCzvA.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $lCzvA.Children.forEach(children, (child)=>{
            if (!(0, $ccf3b9da3a71d526$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $ccf3b9da3a71d526$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $0f55f5fc97c01112$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $lCzvA.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $lCzvA.Children.forEach(children, (child)=>{
            if (!(0, $ccf3b9da3a71d526$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $0f55f5fc97c01112$export$d652b828d7fdeff8)(child.props, true) || (0, $0f55f5fc97c01112$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $lCzvA.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $lCzvA.useRef(false);
    const onFilled = $lCzvA.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $lCzvA.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $lCzvA.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $d12eac47440c9fb8$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($8419414d64eb4ced$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $8419414d64eb4ced$export$2e2bcd8739ae039 = $8419414d64eb4ced$var$FormControl;



var $lCzvA = parcelRequire("lCzvA");











function $84971482f1587cb3$export$a394fa61b1d583a9(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiFormHelperText', slot);
}
const $84971482f1587cb3$var$formHelperTextClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $84971482f1587cb3$export$2e2bcd8739ae039 = $84971482f1587cb3$var$formHelperTextClasses;



'use client';
var $a056520c9bc88f96$var$_span;
const $a056520c9bc88f96$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $84971482f1587cb3$export$a394fa61b1d583a9), classes);
};
const $a056520c9bc88f96$var$FormHelperTextRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $84971482f1587cb3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $84971482f1587cb3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $a056520c9bc88f96$var$FormHelperText = /*#__PURE__*/ $lCzvA.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $a66fe280d54e059b$export$2e2bcd8739ae039)();
    const fcs = (0, $68f7e6835ed8d269$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $a056520c9bc88f96$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a056520c9bc88f96$var$FormHelperTextRoot, {
        as: component,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $a056520c9bc88f96$var$_span || ($a056520c9bc88f96$var$_span = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $a056520c9bc88f96$export$2e2bcd8739ae039 = $a056520c9bc88f96$var$FormHelperText;



var $lCzvA = parcelRequire("lCzvA");







var $lCzvA = parcelRequire("lCzvA");









var $lCzvA = parcelRequire("lCzvA");









var $lCzvA = parcelRequire("lCzvA");












var $d456647219e4a366$export$2e2bcd8739ae039 = (0, $9b0d55c89532c0b3$export$2e2bcd8739ae039);






var $lCzvA = parcelRequire("lCzvA");






var $lCzvA = parcelRequire("lCzvA");



'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $2f4f9aa634b5842f$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $2f4f9aa634b5842f$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $2f4f9aa634b5842f$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $2f4f9aa634b5842f$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $2f4f9aa634b5842f$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $2f4f9aa634b5842f$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($2f4f9aa634b5842f$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $2f4f9aa634b5842f$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$2f4f9aa634b5842f$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $2f4f9aa634b5842f$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $2f4f9aa634b5842f$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $2f4f9aa634b5842f$var$defaultGetTabbable, isEnabled: isEnabled = $2f4f9aa634b5842f$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $lCzvA.useRef(false);
    const sentinelStart = $lCzvA.useRef(null);
    const sentinelEnd = $lCzvA.useRef(null);
    const nodeToRestore = $lCzvA.useRef(null);
    const reactFocusEventTarget = $lCzvA.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $lCzvA.useRef(false);
    const rootRef = $lCzvA.useRef(null);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)((0, $52e17a1723d23ff7$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $lCzvA.useRef(null);
    $lCzvA.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $lCzvA.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $lCzvA.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $lCzvA.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $2f4f9aa634b5842f$export$2e2bcd8739ae039 = $2f4f9aa634b5842f$var$FocusTrap;







var $lCzvA = parcelRequire("lCzvA");







var $lCzvA = parcelRequire("lCzvA");








'use client';
const $214c9e562c1f6c39$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $214c9e562c1f6c39$var$Fade = /*#__PURE__*/ $lCzvA.forwardRef(function Fade(props, ref) {
    const theme = (0, $0282d01cc0b6bcdf$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $359d74762cf8ebf8$export$2e2bcd8739ae039), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $lCzvA.useRef(null);
    const handleRef = (0, $ade5ac70196d775c$export$2e2bcd8739ae039)(nodeRef, (0, $52e17a1723d23ff7$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $b233c2126e177d66$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $b233c2126e177d66$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $b233c2126e177d66$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $lCzvA.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$214c9e562c1f6c39$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $214c9e562c1f6c39$export$2e2bcd8739ae039 = $214c9e562c1f6c39$var$Fade;




function $21a61d825670fc87$export$9927a91fd93152bd(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiBackdrop', slot);
}
const $21a61d825670fc87$var$backdropClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $21a61d825670fc87$export$2e2bcd8739ae039 = $21a61d825670fc87$var$backdropClasses;



'use client';
const $0e1552c3ee6b47a9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $21a61d825670fc87$export$9927a91fd93152bd), classes);
};
const $0e1552c3ee6b47a9$var$BackdropRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $0e1552c3ee6b47a9$var$Backdrop = /*#__PURE__*/ $lCzvA.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $0e1552c3ee6b47a9$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('root', {
        elementType: $0e1552c3ee6b47a9$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $214c9e562c1f6c39$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $0e1552c3ee6b47a9$export$2e2bcd8739ae039 = $0e1552c3ee6b47a9$var$Backdrop;



var $lCzvA = parcelRequire("lCzvA");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $bdf0d752befe2825$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $16db6b35a92f6b31$var$isOverflowing(container) {
    const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $cbe0ef075048c43a$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $16db6b35a92f6b31$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $16db6b35a92f6b31$var$getPaddingRight(element) {
    return parseInt((0, $cbe0ef075048c43a$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $16db6b35a92f6b31$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $16db6b35a92f6b31$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$16db6b35a92f6b31$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $16db6b35a92f6b31$export$e1bd0c6150f13d96(element, hide);
    });
}
function $16db6b35a92f6b31$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $16db6b35a92f6b31$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($16db6b35a92f6b31$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $980f2510eb982028$export$2e2bcd8739ae039)((0, $cbe0ef075048c43a$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$16db6b35a92f6b31$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$16db6b35a92f6b31$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $cbe0ef075048c43a$export$2e2bcd8739ae039)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $16db6b35a92f6b31$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $16db6b35a92f6b31$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $16db6b35a92f6b31$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $16db6b35a92f6b31$var$getHiddenSiblings(container);
        $16db6b35a92f6b31$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $16db6b35a92f6b31$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $16db6b35a92f6b31$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $16db6b35a92f6b31$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $16db6b35a92f6b31$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $16db6b35a92f6b31$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $16db6b35a92f6b31$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $16db6b35a92f6b31$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $679d2f7fb69b192d$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $679d2f7fb69b192d$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $679d2f7fb69b192d$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $679d2f7fb69b192d$var$manager = new (0, $16db6b35a92f6b31$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $679d2f7fb69b192d$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $lCzvA.useRef({});
    const mountNodeRef = $lCzvA.useRef(null);
    const modalRef = $lCzvA.useRef(null);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $lCzvA.useState(!open);
    const hasTransition = $679d2f7fb69b192d$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $679d2f7fb69b192d$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $b30dbf340362d390$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $679d2f7fb69b192d$var$getContainer(container) || getDoc().body;
        $679d2f7fb69b192d$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$679d2f7fb69b192d$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $16db6b35a92f6b31$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $lCzvA.useCallback(()=>{
        $679d2f7fb69b192d$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $lCzvA.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $lCzvA.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $aef0f65b53d2cefd$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $bdf0d752befe2825$export$2e2bcd8739ae039)(handleEnter, children?.props.onEnter ?? $679d2f7fb69b192d$var$noop),
            onExited: (0, $bdf0d752befe2825$export$2e2bcd8739ae039)(handleExited, children?.props.onExited ?? $679d2f7fb69b192d$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $679d2f7fb69b192d$export$2e2bcd8739ae039 = $679d2f7fb69b192d$var$useModal;




function $aa6fe0f3dba0bd71$export$67960e22b12a638d(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiModal', slot);
}
const $aa6fe0f3dba0bd71$var$modalClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $aa6fe0f3dba0bd71$export$2e2bcd8739ae039 = $aa6fe0f3dba0bd71$var$modalClasses;




'use client';
const $4176c97a070e3cbd$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $aa6fe0f3dba0bd71$export$67960e22b12a638d), classes);
};
const $4176c97a070e3cbd$var$ModalRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $4176c97a070e3cbd$var$ModalBackdrop = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $0e1552c3ee6b47a9$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $4176c97a070e3cbd$var$Modal = /*#__PURE__*/ $lCzvA.forwardRef(function Modal(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $4176c97a070e3cbd$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $679d2f7fb69b192d$export$2e2bcd8739ae039)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $4176c97a070e3cbd$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $4176c97a070e3cbd$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (onBackdropClick) onBackdropClick(event);
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1dce6bccb63dfb37$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $2f4f9aa634b5842f$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $lCzvA.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $4176c97a070e3cbd$export$2e2bcd8739ae039 = $4176c97a070e3cbd$var$Modal;





function $0500fb087755b094$export$88f455dd56c95edb(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiPopover', slot);
}
const $0500fb087755b094$var$popoverClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiPopover', [
    'root',
    'paper'
]);
var $0500fb087755b094$export$2e2bcd8739ae039 = $0500fb087755b094$var$popoverClasses;




function $fdb3ae459e44e4b5$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $6a02406550477b35$export$2e2bcd8739ae039)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const className = (0, $6a02406550477b35$export$2e2bcd8739ae039)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}



'use client';
function $975f11bddbbbb8d0$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $975f11bddbbbb8d0$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $975f11bddbbbb8d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $975f11bddbbbb8d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $975f11bddbbbb8d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $0500fb087755b094$export$88f455dd56c95edb), classes);
};
const $975f11bddbbbb8d0$export$bcce13685275fc99 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $4176c97a070e3cbd$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $975f11bddbbbb8d0$export$821346c38a2d9390 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $0e17783238642a98$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $975f11bddbbbb8d0$var$Popover = /*#__PURE__*/ $lCzvA.forwardRef(function Popover(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $lCzvA.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $975f11bddbbbb8d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $lCzvA.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $975f11bddbbbb8d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $a8134958130585e6$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $975f11bddbbbb8d0$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $975f11bddbbbb8d0$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $lCzvA.useCallback((elemRect)=>{
        return {
            vertical: $975f11bddbbbb8d0$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $975f11bddbbbb8d0$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $lCzvA.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $975f11bddbbbb8d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $353a0a174c2b5036$export$2e2bcd8739ae039)($975f11bddbbbb8d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $975f11bddbbbb8d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $lCzvA.useState(open);
    const setPositioningStyles = $lCzvA.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $lCzvA.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $lCzvA.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $lCzvA.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $lCzvA.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $d456647219e4a366$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $353a0a174c2b5036$export$2e2bcd8739ae039)($975f11bddbbbb8d0$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $f7b874c31cbe253c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $a8134958130585e6$export$2e2bcd8739ae039)($975f11bddbbbb8d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $975f11bddbbbb8d0$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $fdb3ae459e44e4b5$export$2e2bcd8739ae039)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $975f11bddbbbb8d0$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $ee580380773bdc68$export$2e2bcd8739ae039)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $975f11bddbbbb8d0$export$2e2bcd8739ae039 = $975f11bddbbbb8d0$var$Popover;







function $7d14e875b30b652d$export$2cf86a63a84fe23d(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiMenu', slot);
}
const $7d14e875b30b652d$var$menuClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $7d14e875b30b652d$export$2e2bcd8739ae039 = $7d14e875b30b652d$var$menuClasses;




'use client';
const $daa212327dd1966f$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $daa212327dd1966f$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $daa212327dd1966f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $7d14e875b30b652d$export$2cf86a63a84fe23d), classes);
};
const $daa212327dd1966f$var$MenuRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $975f11bddbbbb8d0$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $be3f20df888d18ba$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $daa212327dd1966f$export$4f7c51a5920c9f33 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $975f11bddbbbb8d0$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $daa212327dd1966f$var$MenuMenuList = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $e6048ea6ffd35fc1$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $daa212327dd1966f$var$Menu = /*#__PURE__*/ $lCzvA.forwardRef(function Menu(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $daa212327dd1966f$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $lCzvA.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $lCzvA.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $lCzvA.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $b591094cd2f81b7b$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('paper', {
        className: classes.paper,
        elementType: $daa212327dd1966f$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('list', {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.list, MenuListProps.className),
        elementType: $daa212327dd1966f$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($daa212327dd1966f$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $daa212327dd1966f$var$RTL_ORIGIN : $daa212327dd1966f$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $daa212327dd1966f$export$2e2bcd8739ae039 = $daa212327dd1966f$var$Menu;



var $lCzvA = parcelRequire("lCzvA");







function $8bfc2998580d4cfb$export$1ee13051fd9e2ab5(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiNativeSelect', slot);
}
const $8bfc2998580d4cfb$var$nativeSelectClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $8bfc2998580d4cfb$export$2e2bcd8739ae039 = $8bfc2998580d4cfb$var$nativeSelectClasses;





'use client';
const $a165d0fd7d5b45f2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $212bca41d578456f$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $8bfc2998580d4cfb$export$1ee13051fd9e2ab5), classes);
};
const $a165d0fd7d5b45f2$export$50b3545a8ccd87af = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $8bfc2998580d4cfb$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $a165d0fd7d5b45f2$var$NativeSelectSelect = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)($a165d0fd7d5b45f2$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $be3f20df888d18ba$export$2e2bcd8739ae039),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $8bfc2998580d4cfb$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $a165d0fd7d5b45f2$export$7dd4d92f143902e3 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $8bfc2998580d4cfb$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $a165d0fd7d5b45f2$var$NativeSelectIcon = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)($a165d0fd7d5b45f2$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $a165d0fd7d5b45f2$var$NativeSelectInput = /*#__PURE__*/ $lCzvA.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $a165d0fd7d5b45f2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a165d0fd7d5b45f2$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a165d0fd7d5b45f2$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $a165d0fd7d5b45f2$export$2e2bcd8739ae039 = $a165d0fd7d5b45f2$var$NativeSelectInput;







'use client';
var $b445d520651a750d$export$2e2bcd8739ae039 = (0, $9ad601db1fbcc10f$export$2e2bcd8739ae039);




function $f9c46b3760e94271$export$2c0c1ee5a3392e(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiSelect', slot);
}
const $f9c46b3760e94271$var$selectClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $f9c46b3760e94271$export$2e2bcd8739ae039 = $f9c46b3760e94271$var$selectClasses;



'use client';
var $6356ae6e62f2eea7$var$_span;
const $6356ae6e62f2eea7$var$SelectSelect = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $a165d0fd7d5b45f2$export$50b3545a8ccd87af), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $f9c46b3760e94271$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $f9c46b3760e94271$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $f9c46b3760e94271$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $f9c46b3760e94271$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $f9c46b3760e94271$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $6356ae6e62f2eea7$var$SelectIcon = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $a165d0fd7d5b45f2$export$7dd4d92f143902e3), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $6356ae6e62f2eea7$var$SelectNativeInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (prop)=>(0, $b9e766558b887025$export$2e2bcd8739ae039)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $6356ae6e62f2eea7$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $6356ae6e62f2eea7$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $6356ae6e62f2eea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $212bca41d578456f$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $f9c46b3760e94271$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $6356ae6e62f2eea7$var$SelectInput = /*#__PURE__*/ $lCzvA.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $b445d520651a750d$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $b445d520651a750d$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $lCzvA.useRef(null);
    const displayRef = $lCzvA.useRef(null);
    const [displayNode, setDisplayNode] = $lCzvA.useState(null);
    const { current: isOpenControlled } = $lCzvA.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $lCzvA.useState();
    const handleRef = (0, $ade5ac70196d775c$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $lCzvA.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $lCzvA.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $lCzvA.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $lCzvA.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $lCzvA.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $a8134958130585e6$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $lCzvA.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $0f55f5fc97c01112$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $lCzvA.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $8b74d405de95a30f$export$2e2bcd8739ae039)(2));
            selected = value.some((v)=>$6356ae6e62f2eea7$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $6356ae6e62f2eea7$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $lCzvA.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $6356ae6e62f2eea7$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6356ae6e62f2eea7$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $6356ae6e62f2eea7$var$isEmpty(display) ? $6356ae6e62f2eea7$var$_span || ($6356ae6e62f2eea7$var$_span = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6356ae6e62f2eea7$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6356ae6e62f2eea7$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $daa212327dd1966f$export$2e2bcd8739ae039), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...MenuProps.MenuListProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $6356ae6e62f2eea7$export$2e2bcd8739ae039 = $6356ae6e62f2eea7$var$SelectInput;















'use client';
const $ae616a845ede45cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $f9c46b3760e94271$export$2c0c1ee5a3392e), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $ae616a845ede45cb$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $be3f20df888d18ba$export$2e2bcd8739ae039)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $ae616a845ede45cb$var$StyledInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $5fb6dfeb1eaede71$export$2e2bcd8739ae039), $ae616a845ede45cb$var$styledRootConfig)('');
const $ae616a845ede45cb$var$StyledOutlinedInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $6a32367e5d39315f$export$2e2bcd8739ae039), $ae616a845ede45cb$var$styledRootConfig)('');
const $ae616a845ede45cb$var$StyledFilledInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $dfa3a50b968b9dd6$export$2e2bcd8739ae039), $ae616a845ede45cb$var$styledRootConfig)('');
const $ae616a845ede45cb$var$Select = /*#__PURE__*/ $lCzvA.forwardRef(function Select(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $0da1bfbe8f163ecb$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $a165d0fd7d5b45f2$export$2e2bcd8739ae039) : (0, $6356ae6e62f2eea7$export$2e2bcd8739ae039);
    const muiFormControl = (0, $a66fe280d54e059b$export$2e2bcd8739ae039)();
    const fcs = (0, $68f7e6835ed8d269$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $ae616a845ede45cb$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($ae616a845ede45cb$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($ae616a845ede45cb$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($ae616a845ede45cb$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $ade5ac70196d775c$export$2e2bcd8739ae039)(ref, (0, $52e17a1723d23ff7$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($lCzvA.Fragment, {
        children: /*#__PURE__*/ $lCzvA.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $b80cadb21e077670$export$2e2bcd8739ae039)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$ae616a845ede45cb$var$Select.muiName = 'Select';
var $ae616a845ede45cb$export$2e2bcd8739ae039 = $ae616a845ede45cb$var$Select;




function $42182dc1dc4f59fe$export$c1bdcbaf0596aeda(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiTextField', slot);
}
const $42182dc1dc4f59fe$var$textFieldClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiTextField', [
    'root'
]);
var $42182dc1dc4f59fe$export$2e2bcd8739ae039 = $42182dc1dc4f59fe$var$textFieldClasses;




'use client';
const $892075b999ff9f5a$var$variantComponent = {
    standard: (0, $5fb6dfeb1eaede71$export$2e2bcd8739ae039),
    filled: (0, $dfa3a50b968b9dd6$export$2e2bcd8739ae039),
    outlined: (0, $6a32367e5d39315f$export$2e2bcd8739ae039)
};
const $892075b999ff9f5a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $42182dc1dc4f59fe$export$c1bdcbaf0596aeda), classes);
};
const $892075b999ff9f5a$var$TextFieldRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $8419414d64eb4ced$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $892075b999ff9f5a$var$TextField = /*#__PURE__*/ $lCzvA.forwardRef(function TextField(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $892075b999ff9f5a$var$useUtilityClasses(ownerState);
    const id = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $892075b999ff9f5a$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('root', {
        elementType: $892075b999ff9f5a$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('inputLabel', {
        elementType: (0, $460e9c37f39d8a56$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('formHelperText', {
        elementType: (0, $a056520c9bc88f96$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('select', {
        elementType: (0, $ae616a845ede45cb$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $892075b999ff9f5a$export$2e2bcd8739ae039 = $892075b999ff9f5a$var$TextField;









const $91587b17a611dde0$export$bfa7dd6f7574dd6b = (a, b)=>{
    // Filter `false` values only, as `true` and not having a key are the same
    const aFalseValues = new Set(Object.keys(a).filter((key)=>a[key] === false));
    const bFalseValues = new Set(Object.keys(b).filter((key)=>b[key] === false));
    if (aFalseValues.size !== bFalseValues.size) return false;
    let result = true;
    aFalseValues.forEach((key)=>{
        if (!bFalseValues.has(key)) result = false;
    });
    return result;
};
const $91587b17a611dde0$export$cbdfd8d51f352d2a = (column, searchValue)=>(column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;



const $d2f4164420df3c93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnsManagement'
        ],
        header: [
            'columnsManagementHeader'
        ],
        searchInput: [
            'columnsManagementSearchInput'
        ],
        footer: [
            'columnsManagementFooter'
        ],
        row: [
            'columnsManagementRow'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $d2f4164420df3c93$var$collator = new Intl.Collator();
function $d2f4164420df3c93$export$3710e0bb3d9954d(props) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const searchInputRef = $lCzvA.useRef(null);
    const columns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$da85f06e3c19f1fd));
    const initialColumnVisibilityModel = (0, $f8f1fea382a71335$export$2e2bcd8739ae039)(()=>(0, $8b99503000dd62d3$export$eb0d33595fe29bb4)(apiRef)).current;
    const columnVisibilityModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$eb0d33595fe29bb4));
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const [searchValue, setSearchValue] = $lCzvA.useState('');
    const classes = $d2f4164420df3c93$var$useUtilityClasses(rootProps);
    const { sort: sort, searchPredicate: searchPredicate = (0, $91587b17a611dde0$export$cbdfd8d51f352d2a), autoFocusSearchField: autoFocusSearchField = true, disableShowHideToggle: disableShowHideToggle = false, disableResetButton: disableResetButton = false, toggleAllMode: toggleAllMode = 'all', getTogglableColumns: getTogglableColumns, searchInputProps: searchInputProps } = props;
    const isResetDisabled = $lCzvA.useMemo(()=>(0, $91587b17a611dde0$export$bfa7dd6f7574dd6b)(columnVisibilityModel, initialColumnVisibilityModel), [
        columnVisibilityModel,
        initialColumnVisibilityModel
    ]);
    const sortedColumns = $lCzvA.useMemo(()=>{
        switch(sort){
            case 'asc':
                return [
                    ...columns
                ].sort((a, b)=>$d2f4164420df3c93$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            case 'desc':
                return [
                    ...columns
                ].sort((a, b)=>-$d2f4164420df3c93$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            default:
                return columns;
        }
    }, [
        columns,
        sort
    ]);
    const toggleColumn = (event)=>{
        const { name: field } = event.target;
        apiRef.current.setColumnVisibility(field, columnVisibilityModel[field] === false);
    };
    const currentColumns = $lCzvA.useMemo(()=>{
        const togglableColumns = getTogglableColumns ? getTogglableColumns(sortedColumns) : null;
        const togglableSortedColumns = togglableColumns ? sortedColumns.filter(({ field: field })=>togglableColumns.includes(field)) : sortedColumns;
        if (!searchValue) return togglableSortedColumns;
        return togglableSortedColumns.filter((column)=>searchPredicate(column, searchValue.toLowerCase()));
    }, [
        sortedColumns,
        searchValue,
        searchPredicate,
        getTogglableColumns
    ]);
    const toggleAllColumns = $lCzvA.useCallback((isVisible)=>{
        const currentModel = (0, $8b99503000dd62d3$export$eb0d33595fe29bb4)(apiRef);
        const newModel = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, currentModel);
        const togglableColumns = getTogglableColumns ? getTogglableColumns(columns) : null;
        (toggleAllMode === 'filteredOnly' ? currentColumns : columns).forEach((col)=>{
            if (col.hideable && (togglableColumns == null || togglableColumns.includes(col.field))) {
                if (isVisible) // delete the key from the model instead of setting it to `true`
                delete newModel[col.field];
                else newModel[col.field] = false;
            }
        });
        return apiRef.current.setColumnVisibilityModel(newModel);
    }, [
        apiRef,
        columns,
        getTogglableColumns,
        toggleAllMode,
        currentColumns
    ]);
    const handleSearchValueChange = $lCzvA.useCallback((event)=>{
        setSearchValue(event.target.value);
    }, []);
    const hideableColumns = $lCzvA.useMemo(()=>currentColumns.filter((col)=>col.hideable), [
        currentColumns
    ]);
    const allHideableColumnsVisible = $lCzvA.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] == null || columnVisibilityModel[column.field] !== false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const allHideableColumnsHidden = $lCzvA.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] === false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const firstSwitchRef = $lCzvA.useRef(null);
    $lCzvA.useEffect(()=>{
        if (autoFocusSearchField) searchInputRef.current.focus();
        else if (firstSwitchRef.current && typeof firstSwitchRef.current.focus === 'function') firstSwitchRef.current.focus();
    }, [
        autoFocusSearchField
    ]);
    let firstHideableColumnFound = false;
    const isFirstHideableColumn = (column)=>{
        if (firstHideableColumnFound === false && column.hideable !== false) {
            firstHideableColumnFound = true;
            return true;
        }
        return false;
    };
    const handleSearchReset = $lCzvA.useCallback(()=>{
        setSearchValue('');
        searchInputRef.current.focus();
    }, []);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d2f4164420df3c93$var$GridColumnsManagementHeader, {
                className: classes.header,
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d2f4164420df3c93$var$SearchInput, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                    as: rootProps.slots.baseTextField,
                    ownerState: rootProps,
                    placeholder: apiRef.current.getLocaleText('columnsManagementSearchTitle'),
                    inputRef: searchInputRef,
                    className: classes.searchInput,
                    value: searchValue,
                    onChange: handleSearchValueChange,
                    variant: "outlined",
                    size: "small",
                    type: "search",
                    InputProps: {
                        startAdornment: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseInputAdornment, {
                            position: "start",
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.quickFilterIcon, {})
                        }),
                        endAdornment: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                            "aria-label": apiRef.current.getLocaleText('columnsManagementDeleteIconLabel'),
                            size: "small",
                            sx: [
                                searchValue ? {
                                    visibility: 'visible'
                                } : {
                                    visibility: 'hidden'
                                }
                            ],
                            tabIndex: -1,
                            onClick: handleSearchReset
                        }, rootProps.slotProps?.baseIconButton, {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.quickFilterClearIcon, {
                                fontSize: "small"
                            })
                        }))
                    },
                    inputProps: {
                        'aria-label': apiRef.current.getLocaleText('columnsManagementSearchTitle')
                    },
                    autoComplete: "off",
                    fullWidth: true
                }, rootProps.slotProps?.baseTextField, searchInputProps))
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($d2f4164420df3c93$var$GridColumnsManagementBody, {
                className: classes.root,
                ownerState: rootProps,
                children: [
                    currentColumns.map((column)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $5aeae6e59293cfb6$export$2e2bcd8739ae039), {
                            className: classes.row,
                            control: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseCheckbox, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                                disabled: column.hideable === false,
                                checked: columnVisibilityModel[column.field] !== false,
                                onClick: toggleColumn,
                                name: column.field,
                                sx: {
                                    p: 0.5
                                },
                                inputRef: isFirstHideableColumn(column) ? firstSwitchRef : undefined
                            }, rootProps.slotProps?.baseCheckbox)),
                            label: column.headerName || column.field
                        }, column.field)),
                    currentColumns.length === 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d2f4164420df3c93$var$GridColumnsManagementEmptyText, {
                        ownerState: rootProps,
                        children: apiRef.current.getLocaleText('columnsManagementNoColumns')
                    })
                ]
            }),
            (!disableShowHideToggle || !disableResetButton) && currentColumns.length > 0 ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($d2f4164420df3c93$var$GridColumnsManagementFooter, {
                ownerState: rootProps,
                className: classes.footer,
                children: [
                    !disableShowHideToggle ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $5aeae6e59293cfb6$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseCheckbox, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                            disabled: hideableColumns.length === 0,
                            checked: allHideableColumnsVisible,
                            indeterminate: !allHideableColumnsVisible && !allHideableColumnsHidden,
                            onClick: ()=>toggleAllColumns(!allHideableColumnsVisible),
                            name: apiRef.current.getLocaleText('columnsManagementShowHideAllText'),
                            sx: {
                                p: 0.5
                            }
                        }, rootProps.slotProps?.baseCheckbox)),
                        label: apiRef.current.getLocaleText('columnsManagementShowHideAllText')
                    }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {}),
                    !disableResetButton ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                        onClick: ()=>apiRef.current.setColumnVisibilityModel(initialColumnVisibilityModel),
                        disabled: isResetDisabled
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('columnsManagementReset')
                    })) : null
                ]
            }) : null
        ]
    });
}
const $d2f4164420df3c93$var$GridColumnsManagementBody = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagement',
    overridesResolver: (props, styles)=>styles.columnsManagement
})(({ theme: theme })=>({
        padding: theme.spacing(0, 3, 1.5),
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        flex: '1 1',
        maxHeight: 400,
        alignItems: 'flex-start'
    }));
const $d2f4164420df3c93$var$GridColumnsManagementHeader = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementHeader',
    overridesResolver: (props, styles)=>styles.columnsManagementHeader
})(({ theme: theme })=>({
        padding: theme.spacing(1.5, 3)
    }));
const $d2f4164420df3c93$var$SearchInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $892075b999ff9f5a$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementSearchInput',
    overridesResolver: (props, styles)=>styles.columnsManagementSearchInput
})(({ theme: theme })=>({
        [`& .${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).root}`]: {
            padding: theme.spacing(0, 1.5, 0, 1.5)
        },
        [`& .${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).input}::-webkit-search-decoration,
  & .${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).input}::-webkit-search-cancel-button,
  & .${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).input}::-webkit-search-results-button,
  & .${(0, $4e524ec0ed105543$export$2e2bcd8739ae039).input}::-webkit-search-results-decoration`]: {
            /* clears the 'X' icon from Chrome */ display: 'none'
        }
    }));
const $d2f4164420df3c93$var$GridColumnsManagementFooter = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementFooter',
    overridesResolver: (props, styles)=>styles.columnsManagementFooter
})(({ theme: theme })=>({
        padding: theme.spacing(0.5, 1, 0.5, 3),
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: `1px solid ${theme.palette.divider}`
    }));
const $d2f4164420df3c93$var$GridColumnsManagementEmptyText = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div')(({ theme: theme })=>({
        padding: theme.spacing(0.5, 0),
        color: theme.palette.grey[500]
    }));


parcelRequire("lCzvA");



parcelRequire("lCzvA");









const $4c003885ee5c7201$var$_excluded = [
    "className",
    "slotProps"
];
const $4c003885ee5c7201$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelWrapper'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $4c003885ee5c7201$var$GridPanelWrapperRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelWrapper',
    overridesResolver: (props, styles)=>styles.panelWrapper
})({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '&:focus': {
        outline: 0
    }
});
const $4c003885ee5c7201$var$isEnabled = ()=>true;
const $4c003885ee5c7201$export$6a36e1ca07bd502c = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridPanelWrapper(props, ref) {
    const { className: className, slotProps: slotProps = {} } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $4c003885ee5c7201$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $4c003885ee5c7201$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $2f4f9aa634b5842f$export$2e2bcd8739ae039), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        open: true,
        disableEnforceFocus: true,
        isEnabled: $4c003885ee5c7201$var$isEnabled
    }, slotProps.TrapFocus, {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($4c003885ee5c7201$var$GridPanelWrapperRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            tabIndex: -1,
            className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
            ownerState: rootProps
        }, other, {
            ref: ref
        }))
    }));
});




function $965ffdbf820dbe98$export$39d43456ec96cf57(props) {
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4c003885ee5c7201$export$6a36e1ca07bd502c), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnsManagement, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootProps.slotProps?.columnsManagement))
    }));
}




var $lCzvA = parcelRequire("lCzvA");






parcelRequire("lCzvA");







const $df76b82e824c964b$var$_excluded = [
    "className"
];
const $df76b82e824c964b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelContent'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $df76b82e824c964b$var$GridPanelContentRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelContent',
    overridesResolver: (props, styles)=>styles.panelContent
})({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flex: '1 1',
    maxHeight: 400
});
function $df76b82e824c964b$export$1b4102a66373332b(props) {
    const { className: className } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $df76b82e824c964b$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $df76b82e824c964b$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($df76b82e824c964b$var$GridPanelContentRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other));
}




parcelRequire("lCzvA");







const $16fd2cced5f89e08$var$_excluded = [
    "className"
];
const $16fd2cced5f89e08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelFooter'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $16fd2cced5f89e08$var$GridPanelFooterRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelFooter',
    overridesResolver: (props, styles)=>styles.panelFooter
})(({ theme: theme })=>({
        padding: theme.spacing(0.5),
        display: 'flex',
        justifyContent: 'space-between'
    }));
function $16fd2cced5f89e08$export$18e44097a2744a(props) {
    const { className: className } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $16fd2cced5f89e08$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $16fd2cced5f89e08$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($16fd2cced5f89e08$var$GridPanelFooterRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other));
}






var $lCzvA = parcelRequire("lCzvA");














const $d5885ac2afd95451$var$_excluded = [
    "item",
    "hasMultipleFilters",
    "deleteFilter",
    "applyFilterChanges",
    "showMultiFilterOperators",
    "disableMultiFilterOperator",
    "applyMultiFilterOperatorChanges",
    "focusElementRef",
    "logicOperators",
    "columnsSort",
    "filterColumns",
    "deleteIconProps",
    "logicOperatorInputProps",
    "operatorInputProps",
    "columnInputProps",
    "valueInputProps",
    "readOnly",
    "children"
], $d5885ac2afd95451$var$_excluded2 = [
    "InputComponentProps"
];
const $d5885ac2afd95451$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'filterForm'
        ],
        deleteIcon: [
            'filterFormDeleteIcon'
        ],
        logicOperatorInput: [
            'filterFormLogicOperatorInput'
        ],
        columnInput: [
            'filterFormColumnInput'
        ],
        operatorInput: [
            'filterFormOperatorInput'
        ],
        valueInput: [
            'filterFormValueInput'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $d5885ac2afd95451$var$GridFilterFormRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterForm',
    overridesResolver: (props, styles)=>styles.filterForm
})(({ theme: theme })=>({
        display: 'flex',
        padding: theme.spacing(1)
    }));
const $d5885ac2afd95451$var$FilterFormDeleteIcon = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormDeleteIcon',
    overridesResolver: (_, styles)=>styles.filterFormDeleteIcon
})(({ theme: theme })=>({
        flexShrink: 0,
        justifyContent: 'flex-end',
        marginRight: theme.spacing(0.5),
        marginBottom: theme.spacing(0.2)
    }));
const $d5885ac2afd95451$var$FilterFormLogicOperatorInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormLogicOperatorInput',
    overridesResolver: (_, styles)=>styles.filterFormLogicOperatorInput
})({
    minWidth: 55,
    marginRight: 5,
    justifyContent: 'end'
});
const $d5885ac2afd95451$var$FilterFormColumnInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormColumnInput',
    overridesResolver: (_, styles)=>styles.filterFormColumnInput
})({
    width: 150
});
const $d5885ac2afd95451$var$FilterFormOperatorInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormOperatorInput',
    overridesResolver: (_, styles)=>styles.filterFormOperatorInput
})({
    width: 150
});
const $d5885ac2afd95451$var$FilterFormValueInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormValueInput',
    overridesResolver: (_, styles)=>styles.filterFormValueInput
})({
    width: 190
});
const $d5885ac2afd95451$var$getLogicOperatorLocaleKey = (logicOperator)=>{
    switch(logicOperator){
        case (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).And:
            return 'filterPanelOperatorAnd';
        case (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).Or:
            return 'filterPanelOperatorOr';
        default:
            throw new Error('MUI X: Invalid `logicOperator` property in the `GridFilterPanel`.');
    }
};
const $d5885ac2afd95451$var$getColumnLabel = (col)=>col.headerName || col.field;
const $d5885ac2afd95451$var$collator = new Intl.Collator();
const $d5885ac2afd95451$export$4c95feba7016dbe7 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridFilterForm(props, ref) {
    const { item: item, hasMultipleFilters: hasMultipleFilters, deleteFilter: deleteFilter, applyFilterChanges: applyFilterChanges, showMultiFilterOperators: showMultiFilterOperators, disableMultiFilterOperator: disableMultiFilterOperator, applyMultiFilterOperatorChanges: applyMultiFilterOperatorChanges, focusElementRef: focusElementRef, logicOperators: logicOperators = [
        (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).And,
        (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).Or
    ], columnsSort: columnsSort, filterColumns: filterColumns, deleteIconProps: deleteIconProps = {}, logicOperatorInputProps: logicOperatorInputProps = {}, operatorInputProps: operatorInputProps = {}, columnInputProps: columnInputProps = {}, valueInputProps: valueInputProps = {}, readOnly: readOnly } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $d5885ac2afd95451$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const columnLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$8a3a9a6db584d7fd));
    const filterableColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$2cad659ba95fed71));
    const filterModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$280aedb9454597a5));
    const columnSelectId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const columnSelectLabelId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const operatorSelectId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const operatorSelectLabelId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $d5885ac2afd95451$var$useUtilityClasses(rootProps);
    const valueRef = $lCzvA.useRef(null);
    const filterSelectorRef = $lCzvA.useRef(null);
    const multiFilterOperator = filterModel.logicOperator ?? (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).And;
    const hasLogicOperatorColumn = hasMultipleFilters && logicOperators.length > 0;
    const baseFormControlProps = rootProps.slotProps?.baseFormControl || {};
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isBaseSelectNative = baseSelectProps.native ?? false;
    const baseInputLabelProps = rootProps.slotProps?.baseInputLabel || {};
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const { InputComponentProps: InputComponentProps } = valueInputProps, valueInputPropsOther = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(valueInputProps, $d5885ac2afd95451$var$_excluded2);
    const { filteredColumns: filteredColumns, selectedField: selectedField } = $lCzvA.useMemo(()=>{
        let itemField = item.field;
        // Yields a valid value if the current filter belongs to a column that is not filterable
        const selectedNonFilterableColumn = columnLookup[item.field].filterable === false ? columnLookup[item.field] : null;
        if (selectedNonFilterableColumn) return {
            filteredColumns: [
                selectedNonFilterableColumn
            ],
            selectedField: itemField
        };
        if (filterColumns === undefined || typeof filterColumns !== 'function') return {
            filteredColumns: filterableColumns,
            selectedField: itemField
        };
        const filteredFields = filterColumns({
            field: item.field,
            columns: filterableColumns,
            currentFilters: filterModel?.items || []
        });
        return {
            filteredColumns: filterableColumns.filter((column)=>{
                const isFieldIncluded = filteredFields.includes(column.field);
                if (column.field === item.field && !isFieldIncluded) itemField = undefined;
                return isFieldIncluded;
            }),
            selectedField: itemField
        };
    }, [
        filterColumns,
        filterModel?.items,
        filterableColumns,
        item.field,
        columnLookup
    ]);
    const sortedFilteredColumns = $lCzvA.useMemo(()=>{
        switch(columnsSort){
            case 'asc':
                return filteredColumns.sort((a, b)=>$d5885ac2afd95451$var$collator.compare($d5885ac2afd95451$var$getColumnLabel(a), $d5885ac2afd95451$var$getColumnLabel(b)));
            case 'desc':
                return filteredColumns.sort((a, b)=>-$d5885ac2afd95451$var$collator.compare($d5885ac2afd95451$var$getColumnLabel(a), $d5885ac2afd95451$var$getColumnLabel(b)));
            default:
                return filteredColumns;
        }
    }, [
        filteredColumns,
        columnsSort
    ]);
    const currentColumn = item.field ? apiRef.current.getColumn(item.field) : null;
    const currentOperator = $lCzvA.useMemo(()=>{
        if (!item.operator || !currentColumn) return null;
        return currentColumn.filterOperators?.find((operator)=>operator.value === item.operator);
    }, [
        item,
        currentColumn
    ]);
    const changeColumn = $lCzvA.useCallback((event)=>{
        const field = event.target.value;
        const column = apiRef.current.getColumn(field);
        if (column.field === currentColumn.field) // column did not change
        return;
        // try to keep the same operator when column change
        const newOperator = column.filterOperators.find((operator)=>operator.value === item.operator) || column.filterOperators[0];
        // Erase filter value if the input component or filtered column type is modified
        const eraseFilterValue = !newOperator.InputComponent || newOperator.InputComponent !== currentOperator?.InputComponent || column.type !== currentColumn.type;
        let filterValue = eraseFilterValue ? undefined : item.value;
        // Check filter value against the new valueOptions
        if (column.type === 'singleSelect' && filterValue !== undefined) {
            const colDef = column;
            const valueOptions = (0, $8f437360f253bfb4$export$b871910a1101d890)(colDef);
            if (Array.isArray(filterValue)) filterValue = filterValue.filter((val)=>{
                return(// Only keep values that are in the new value options
                (0, $8f437360f253bfb4$export$b31a7985e33f7505)(val, valueOptions, colDef?.getOptionValue) !== undefined);
            });
            else if ((0, $8f437360f253bfb4$export$b31a7985e33f7505)(item.value, valueOptions, colDef?.getOptionValue) === undefined) // Reset the filter value if it is not in the new value options
            filterValue = undefined;
        }
        applyFilterChanges((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, item, {
            field: field,
            operator: newOperator.value,
            value: filterValue
        }));
    }, [
        apiRef,
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeOperator = $lCzvA.useCallback((event)=>{
        const operator = event.target.value;
        const newOperator = currentColumn?.filterOperators.find((op)=>op.value === operator);
        const eraseItemValue = !newOperator?.InputComponent || newOperator?.InputComponent !== currentOperator?.InputComponent;
        applyFilterChanges((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, item, {
            operator: operator,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeLogicOperator = $lCzvA.useCallback((event)=>{
        const logicOperator = event.target.value === (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).And.toString() ? (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).And : (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).Or;
        applyMultiFilterOperatorChanges(logicOperator);
    }, [
        applyMultiFilterOperatorChanges
    ]);
    const handleDeleteFilter = ()=>{
        deleteFilter(item);
    };
    $lCzvA.useImperativeHandle(focusElementRef, ()=>({
            focus: ()=>{
                if (currentOperator?.InputComponent) valueRef?.current?.focus();
                else filterSelectorRef.current.focus();
            }
        }), [
        currentOperator
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($d5885ac2afd95451$var$GridFilterFormRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: classes.root,
        "data-id": item.id,
        ownerState: rootProps
    }, other, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d5885ac2afd95451$var$FilterFormDeleteIcon, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, deleteIconProps, {
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.deleteIcon, baseFormControlProps.className, deleteIconProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                    "aria-label": apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    title: apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    onClick: handleDeleteFilter,
                    size: "small",
                    disabled: readOnly
                }, rootProps.slotProps?.baseIconButton, {
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.filterPanelDeleteIcon, {
                        fontSize: "small"
                    })
                }))
            })),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d5885ac2afd95451$var$FilterFormLogicOperatorInput, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, logicOperatorInputProps, {
                sx: [
                    hasLogicOperatorColumn ? {
                        display: 'flex'
                    } : {
                        display: 'none'
                    },
                    showMultiFilterOperators ? {
                        visibility: 'visible'
                    } : {
                        visibility: 'hidden'
                    },
                    baseFormControlProps.sx,
                    logicOperatorInputProps.sx
                ],
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.logicOperatorInput, baseFormControlProps.className, logicOperatorInputProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseSelect, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                    inputProps: {
                        'aria-label': apiRef.current.getLocaleText('filterPanelLogicOperator')
                    },
                    value: multiFilterOperator ?? '',
                    onChange: changeLogicOperator,
                    disabled: !!disableMultiFilterOperator || logicOperators.length === 1,
                    native: isBaseSelectNative
                }, rootProps.slotProps?.baseSelect, {
                    children: logicOperators.map((logicOperator)=>/*#__PURE__*/ (0, $lCzvA.createElement)(rootProps.slots.baseSelectOption, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                            native: isBaseSelectNative,
                            key: logicOperator.toString(),
                            value: logicOperator.toString()
                        }), apiRef.current.getLocaleText($d5885ac2afd95451$var$getLogicOperatorLocaleKey(logicOperator))))
                }))
            })),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($d5885ac2afd95451$var$FilterFormColumnInput, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, columnInputProps, {
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.columnInput, baseFormControlProps.className, columnInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseInputLabel, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, baseInputLabelProps, {
                        htmlFor: columnSelectId,
                        id: columnSelectLabelId,
                        children: apiRef.current.getLocaleText('filterPanelColumns')
                    })),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseSelect, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                        labelId: columnSelectLabelId,
                        id: columnSelectId,
                        label: apiRef.current.getLocaleText('filterPanelColumns'),
                        value: selectedField ?? '',
                        onChange: changeColumn,
                        native: isBaseSelectNative,
                        disabled: readOnly
                    }, rootProps.slotProps?.baseSelect, {
                        children: sortedFilteredColumns.map((col)=>/*#__PURE__*/ (0, $lCzvA.createElement)(rootProps.slots.baseSelectOption, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: col.field,
                                value: col.field
                            }), $d5885ac2afd95451$var$getColumnLabel(col)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($d5885ac2afd95451$var$FilterFormOperatorInput, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, operatorInputProps, {
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.operatorInput, baseFormControlProps.className, operatorInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseInputLabel, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, baseInputLabelProps, {
                        htmlFor: operatorSelectId,
                        id: operatorSelectLabelId,
                        children: apiRef.current.getLocaleText('filterPanelOperator')
                    })),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseSelect, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                        labelId: operatorSelectLabelId,
                        label: apiRef.current.getLocaleText('filterPanelOperator'),
                        id: operatorSelectId,
                        value: item.operator,
                        onChange: changeOperator,
                        native: isBaseSelectNative,
                        inputRef: filterSelectorRef,
                        disabled: readOnly
                    }, rootProps.slotProps?.baseSelect, {
                        children: currentColumn?.filterOperators?.map((operator)=>/*#__PURE__*/ (0, $lCzvA.createElement)(rootProps.slots.baseSelectOption, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: operator.value,
                                value: operator.value
                            }), operator.label || apiRef.current.getLocaleText(`filterOperator${(0, $c4ab204d748cb214$export$2e2bcd8739ae039)(operator.value)}`)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d5885ac2afd95451$var$FilterFormValueInput, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, valueInputPropsOther, {
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.valueInput, baseFormControlProps.className, valueInputPropsOther.className),
                ownerState: rootProps,
                children: currentOperator?.InputComponent ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(currentOperator.InputComponent, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                    apiRef: apiRef,
                    item: item,
                    applyValue: applyFilterChanges,
                    focusElementRef: valueRef,
                    disabled: readOnly
                }, currentOperator.InputComponentProps, InputComponentProps), item.field) : null
            }))
        ]
    }));
});







const $420914b7d10dd808$var$_excluded = [
    "logicOperators",
    "columnsSort",
    "filterFormProps",
    "getColumnForNewFilter",
    "children",
    "disableAddFilterButton",
    "disableRemoveAllButton"
];
const $420914b7d10dd808$export$7530149911670467 = (col)=>({
        field: col.field,
        operator: col.filterOperators[0].value,
        id: Math.round(Math.random() * 1e5)
    });
const $420914b7d10dd808$export$32c6e72be8ad862c = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridFilterPanel(props, ref) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const filterModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$280aedb9454597a5));
    const filterableColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$2cad659ba95fed71));
    const filterableColumnsLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$e84218276cc24419));
    const lastFilterRef = $lCzvA.useRef(null);
    const placeholderFilter = $lCzvA.useRef(null);
    const { logicOperators: logicOperators = [
        (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).And,
        (0, $f78fdfbb86788eda$export$90be184ccbab1c7a).Or
    ], columnsSort: columnsSort, filterFormProps: filterFormProps, getColumnForNewFilter: getColumnForNewFilter, disableAddFilterButton: disableAddFilterButton = false, disableRemoveAllButton: disableRemoveAllButton = false } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $420914b7d10dd808$var$_excluded);
    const applyFilter = apiRef.current.upsertFilterItem;
    const applyFilterLogicOperator = $lCzvA.useCallback((operator)=>{
        apiRef.current.setFilterLogicOperator(operator);
    }, [
        apiRef
    ]);
    const getDefaultFilter = $lCzvA.useCallback(()=>{
        let nextColumnWithOperator;
        if (getColumnForNewFilter && typeof getColumnForNewFilter === 'function') {
            // To allow override the column for default (first) filter
            const nextFieldName = getColumnForNewFilter({
                currentFilters: filterModel?.items || [],
                columns: filterableColumns
            });
            if (nextFieldName === null) return null;
            nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextFieldName);
        } else nextColumnWithOperator = filterableColumns.find((colDef)=>colDef.filterOperators?.length);
        if (!nextColumnWithOperator) return null;
        return $420914b7d10dd808$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel?.items,
        filterableColumns,
        getColumnForNewFilter
    ]);
    const getNewFilter = $lCzvA.useCallback(()=>{
        if (getColumnForNewFilter === undefined || typeof getColumnForNewFilter !== 'function') return getDefaultFilter();
        const currentFilters = filterModel.items.length ? filterModel.items : [
            getDefaultFilter()
        ].filter(Boolean);
        // If no items are there in filterModel, we have to pass defaultFilter
        const nextColumnFieldName = getColumnForNewFilter({
            currentFilters: currentFilters,
            columns: filterableColumns
        });
        if (nextColumnFieldName === null) return null;
        const nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextColumnFieldName);
        if (!nextColumnWithOperator) return null;
        return $420914b7d10dd808$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel.items,
        filterableColumns,
        getColumnForNewFilter,
        getDefaultFilter
    ]);
    const items = $lCzvA.useMemo(()=>{
        if (filterModel.items.length) return filterModel.items;
        if (!placeholderFilter.current) placeholderFilter.current = getDefaultFilter();
        return placeholderFilter.current ? [
            placeholderFilter.current
        ] : [];
    }, [
        filterModel.items,
        getDefaultFilter
    ]);
    const hasMultipleFilters = items.length > 1;
    const { readOnlyFilters: readOnlyFilters, validFilters: validFilters } = $lCzvA.useMemo(()=>items.reduce((acc, item)=>{
            if (filterableColumnsLookup[item.field]) acc.validFilters.push(item);
            else acc.readOnlyFilters.push(item);
            return acc;
        }, {
            readOnlyFilters: [],
            validFilters: []
        }), [
        items,
        filterableColumnsLookup
    ]);
    const addNewFilter = $lCzvA.useCallback(()=>{
        const newFilter = getNewFilter();
        if (!newFilter) return;
        apiRef.current.upsertFilterItems([
            ...items,
            newFilter
        ]);
    }, [
        apiRef,
        getNewFilter,
        items
    ]);
    const deleteFilter = $lCzvA.useCallback((item)=>{
        const shouldCloseFilterPanel = validFilters.length === 1;
        apiRef.current.deleteFilterItem(item);
        if (shouldCloseFilterPanel) apiRef.current.hideFilterPanel();
    }, [
        apiRef,
        validFilters.length
    ]);
    const handleRemoveAll = $lCzvA.useCallback(()=>{
        if (validFilters.length === 1 && validFilters[0].value === undefined) {
            apiRef.current.deleteFilterItem(validFilters[0]);
            return apiRef.current.hideFilterPanel();
        }
        return apiRef.current.setFilterModel((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, filterModel, {
            items: readOnlyFilters
        }), 'removeAllFilterItems');
    }, [
        apiRef,
        readOnlyFilters,
        filterModel,
        validFilters
    ]);
    $lCzvA.useEffect(()=>{
        if (logicOperators.length > 0 && filterModel.logicOperator && !logicOperators.includes(filterModel.logicOperator)) applyFilterLogicOperator(logicOperators[0]);
    }, [
        logicOperators,
        applyFilterLogicOperator,
        filterModel.logicOperator
    ]);
    $lCzvA.useEffect(()=>{
        if (validFilters.length > 0) lastFilterRef.current.focus();
    }, [
        validFilters.length
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4c003885ee5c7201$export$6a36e1ca07bd502c), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, other, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $df76b82e824c964b$export$1b4102a66373332b), {
                children: [
                    readOnlyFilters.map((item, index)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $d5885ac2afd95451$export$4c95feba7016dbe7), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: index > 0,
                            disableMultiFilterOperator: index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: null,
                            readOnly: true,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index : item.id)),
                    validFilters.map((item, index)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $d5885ac2afd95451$export$4c95feba7016dbe7), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: readOnlyFilters.length + index > 0,
                            disableMultiFilterOperator: readOnlyFilters.length + index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: index === validFilters.length - 1 ? lastFilterRef : null,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index + readOnlyFilters.length : item.id))
                ]
            }),
            !rootProps.disableMultipleColumnsFiltering && !(disableAddFilterButton && disableRemoveAllButton) ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $16fd2cced5f89e08$export$18e44097a2744a), {
                children: [
                    !disableAddFilterButton ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                        onClick: addNewFilter,
                        startIcon: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.filterPanelAddIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelAddFilter')
                    })) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {}),
                    !disableRemoveAllButton && validFilters.length > 0 ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                        onClick: handleRemoveAll,
                        startIcon: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.filterPanelRemoveAllIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelRemoveAll')
                    })) : null
                ]
            }) : null
        ]
    }));
});


parcelRequire("lCzvA");









parcelRequire("lCzvA");









const $db6eba5ec4f8deeb$var$_excluded = [
    "className",
    "selectedRowCount"
];
const $db6eba5ec4f8deeb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'selectedRowCount'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $db6eba5ec4f8deeb$var$GridSelectedRowCountRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'SelectedRowCount',
    overridesResolver: (props, styles)=>styles.selectedRowCount
})(({ theme: theme })=>({
        alignItems: 'center',
        display: 'flex',
        margin: theme.spacing(0, 2),
        visibility: 'hidden',
        width: 0,
        height: 0,
        [theme.breakpoints.up('sm')]: {
            visibility: 'visible',
            width: 'auto',
            height: 'auto'
        }
    }));
const $db6eba5ec4f8deeb$export$e4c9f87515ca4b49 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridSelectedRowCount(props, ref) {
    const { className: className, selectedRowCount: selectedRowCount } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $db6eba5ec4f8deeb$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const ownerState = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $db6eba5ec4f8deeb$var$useUtilityClasses(ownerState);
    const rowSelectedText = apiRef.current.getLocaleText('footerRowSelected')(selectedRowCount);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($db6eba5ec4f8deeb$var$GridSelectedRowCountRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: ref,
        children: rowSelectedText
    }));
});




parcelRequire("lCzvA");








const $090f433f5ecd4301$var$_excluded = [
    "className"
];
const $090f433f5ecd4301$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'footerContainer',
            'withBorderColor'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $090f433f5ecd4301$var$GridFooterContainerRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FooterContainer',
    overridesResolver: (props, styles)=>styles.footerContainer
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 52,
    borderTop: '1px solid'
});
const $090f433f5ecd4301$export$dc81d5e0847a9805 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridFooterContainer(props, ref) {
    const { className: className } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $090f433f5ecd4301$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $090f433f5ecd4301$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($090f433f5ecd4301$var$GridFooterContainerRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});




const $beae9ef751a574e0$export$6ef0bfefb022d11e = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridFooter(props, ref) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const totalTopLevelRowCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$800ab0a68a9efc4f));
    const selectedRowCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $0bfb640e213a706f$export$2e16a09b9ae82bd3));
    const visibleTopLevelRowCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$f88efd30675963d1));
    const selectedRowCountElement = !rootProps.hideFooterSelectedRowCount && selectedRowCount > 0 ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $db6eba5ec4f8deeb$export$e4c9f87515ca4b49), {
        selectedRowCount: selectedRowCount
    }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {});
    const rowCountElement = !rootProps.hideFooterRowCount && !rootProps.pagination ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.footerRowCount, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootProps.slotProps?.footerRowCount, {
        rowCount: totalTopLevelRowCount,
        visibleRowCount: visibleTopLevelRowCount
    })) : null;
    const paginationElement = rootProps.pagination && !rootProps.hideFooterPagination && rootProps.slots.pagination && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.pagination, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootProps.slotProps?.pagination));
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $090f433f5ecd4301$export$dc81d5e0847a9805), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        children: [
            selectedRowCountElement,
            rowCountElement,
            paginationElement
        ]
    }));
});



parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");












function $65337984a45bc8f8$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiLinearProgress', slot);
}
const $65337984a45bc8f8$var$linearProgressClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $65337984a45bc8f8$export$2e2bcd8739ae039 = $65337984a45bc8f8$var$linearProgressClasses;



'use client';
const $9e85f2a6789e3722$var$TRANSITION_DURATION = 4; // seconds
const $9e85f2a6789e3722$var$indeterminate1Keyframe = (0, $02d5075f8320414d$export$d25ddfdf17c3ad3e)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $9e85f2a6789e3722$var$indeterminate1Animation = typeof $9e85f2a6789e3722$var$indeterminate1Keyframe !== 'string' ? (0, $02d5075f8320414d$export$dbf350e5966cf602)`
        animation: ${$9e85f2a6789e3722$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $9e85f2a6789e3722$var$indeterminate2Keyframe = (0, $02d5075f8320414d$export$d25ddfdf17c3ad3e)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $9e85f2a6789e3722$var$indeterminate2Animation = typeof $9e85f2a6789e3722$var$indeterminate2Keyframe !== 'string' ? (0, $02d5075f8320414d$export$dbf350e5966cf602)`
        animation: ${$9e85f2a6789e3722$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $9e85f2a6789e3722$var$bufferKeyframe = (0, $02d5075f8320414d$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $9e85f2a6789e3722$var$bufferAnimation = typeof $9e85f2a6789e3722$var$bufferKeyframe !== 'string' ? (0, $02d5075f8320414d$export$dbf350e5966cf602)`
        animation: ${$9e85f2a6789e3722$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $9e85f2a6789e3722$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            variant === 'buffer' && `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $65337984a45bc8f8$export$bc8a6ea1eb17d7c6), classes);
};
const $9e85f2a6789e3722$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? (0, $595d4f40c92954a4$export$c0816ed86df316af)(theme.palette[color].main, 0.62) : (0, $595d4f40c92954a4$export$4b073707ff63303)(theme.palette[color].main, 0.5);
};
const $9e85f2a6789e3722$var$LinearProgressRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $9e85f2a6789e3722$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $9e85f2a6789e3722$var$LinearProgressDashed = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>{
                const backgroundColor = $9e85f2a6789e3722$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $9e85f2a6789e3722$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$9e85f2a6789e3722$var$bufferKeyframe} 3s infinite linear`
});
const $9e85f2a6789e3722$var$LinearProgressBar1 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${$9e85f2a6789e3722$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$9e85f2a6789e3722$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $9e85f2a6789e3722$var$indeterminate1Animation || {
                    animation: `${$9e85f2a6789e3722$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $9e85f2a6789e3722$var$LinearProgressBar2 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $9e85f2a6789e3722$var$getColorShade(theme, color),
                        transition: `transform .${$9e85f2a6789e3722$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $9e85f2a6789e3722$var$indeterminate2Animation || {
                    animation: `${$9e85f2a6789e3722$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $9e85f2a6789e3722$var$LinearProgress = /*#__PURE__*/ $lCzvA.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $9e85f2a6789e3722$var$useUtilityClasses(ownerState);
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($9e85f2a6789e3722$var$LinearProgressRoot, {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($9e85f2a6789e3722$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($9e85f2a6789e3722$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($9e85f2a6789e3722$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $9e85f2a6789e3722$export$2e2bcd8739ae039 = $9e85f2a6789e3722$var$LinearProgress;






parcelRequire("lCzvA");








const $4acad5925f2ed490$var$_excluded = [
    "className"
];
const $4acad5925f2ed490$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlay'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $4acad5925f2ed490$var$GridOverlayRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'Overlay',
    overridesResolver: (_, styles)=>styles.overlay
})({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--unstable_DataGrid-overlayBackground)'
});
const $4acad5925f2ed490$export$1c41ff9dbe11e487 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridOverlay(props, ref) {
    const { className: className } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $4acad5925f2ed490$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $4acad5925f2ed490$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($4acad5925f2ed490$var$GridOverlayRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});




var $lCzvA = parcelRequire("lCzvA");













const $d40dc8280276419b$export$29949f0e748b68b8 = (pinnedPosition, computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth)=>{
    let pinnedOffset;
    switch(pinnedPosition){
        case (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT:
            pinnedOffset = columnPositions[columnIndex];
            break;
        case (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT:
            pinnedOffset = columnsTotalWidth - columnPositions[columnIndex] - computedWidth + scrollbarWidth;
            break;
        default:
            pinnedOffset = undefined;
            break;
    }
    return pinnedOffset;
};



const $aefb3468131f4e39$export$646c95cff4790794 = (pinnedPosition, indexInSection, sectionLength, showCellVerticalBorderRootProp, gridHasFiller)=>{
    const isSectionLastCell = indexInSection === sectionLength - 1;
    if (pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT && isSectionLastCell) return true;
    if (showCellVerticalBorderRootProp) {
        if (pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT) return true;
        if (pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT) return !isSectionLastCell;
        // pinnedPosition === undefined, middle section
        return !isSectionLastCell || gridHasFiller;
    }
    return false;
};
const $aefb3468131f4e39$export$c01fd18a9a3d03b3 = (pinnedPosition, indexInSection)=>{
    return pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT && indexInSection === 0;
};



parcelRequire("lCzvA");



const $228dc5ac6a21c951$var$classes = {
    root: (0, $786c119d9add6b61$export$2100d54e36406477).scrollbarFiller,
    header: (0, $786c119d9add6b61$export$2100d54e36406477)['scrollbarFiller--header'],
    borderTop: (0, $786c119d9add6b61$export$2100d54e36406477)['scrollbarFiller--borderTop'],
    borderBottom: (0, $786c119d9add6b61$export$2100d54e36406477)['scrollbarFiller--borderBottom'],
    pinnedRight: (0, $786c119d9add6b61$export$2100d54e36406477)['scrollbarFiller--pinnedRight']
};
function $228dc5ac6a21c951$export$69d401a304b172b5({ header: header, borderTop: borderTop = true, borderBottom: borderBottom, pinnedRight: pinnedRight }) {
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        role: "presentation",
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)($228dc5ac6a21c951$var$classes.root, header && $228dc5ac6a21c951$var$classes.header, borderTop && $228dc5ac6a21c951$var$classes.borderTop, borderBottom && $228dc5ac6a21c951$var$classes.borderBottom, pinnedRight && $228dc5ac6a21c951$var$classes.pinnedRight)
    });
}



const $8df4315ce90fcd4c$export$5859c8b8d085a0c0 = (position, isRtl)=>{
    if (!position) return undefined;
    if (!isRtl) {
        if (position === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT) return 'left';
        if (position === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT) return 'right';
    } else {
        if (position === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT) return 'right';
        if (position === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT) return 'left';
    }
    return undefined;
};



function $39179d3e4e328cf6$export$175ada5333288b48(style, isRtl, pinnedPosition, pinnedOffset) {
    const side = (0, $8df4315ce90fcd4c$export$5859c8b8d085a0c0)(pinnedPosition, isRtl);
    if (!side || pinnedOffset === undefined) return style;
    style[side] = pinnedOffset;
    return style;
}



const $9c4508508dc143c0$var$SkeletonOverlay = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'SkeletonLoadingOverlay',
    overridesResolver: (props, styles)=>styles.skeletonLoadingOverlay
})({
    minWidth: '100%',
    width: 'max-content',
    // prevents overflow: clip; cutting off the x axis
    height: '100%',
    overflow: 'clip' // y axis is hidden while the x axis is allowed to overflow
});
const $9c4508508dc143c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'skeletonLoadingOverlay'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $9c4508508dc143c0$var$getColIndex = (el)=>parseInt(el.getAttribute('data-colindex'), 10);
const $9c4508508dc143c0$export$123bd4ede2d9ef98 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridSkeletonLoadingOverlay(props, forwardedRef) {
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const { slots: slots } = rootProps;
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const classes = $9c4508508dc143c0$var$useUtilityClasses({
        classes: rootProps.classes
    });
    const ref = $lCzvA.useRef(null);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(ref, forwardedRef);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const dimensions = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$26d8768b83a52ffd));
    const viewportHeight = dimensions?.viewportInnerSize.height ?? 0;
    const skeletonRowsCount = Math.ceil(viewportHeight / dimensions.rowHeight);
    const totalWidth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$ab20f9d33edc7794));
    const positions = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$fce7d810e48021e3));
    const inViewportCount = $lCzvA.useMemo(()=>positions.filter((value)=>value <= totalWidth).length, [
        totalWidth,
        positions
    ]);
    const allVisibleColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$16a65a9447d3dda9));
    const columns = $lCzvA.useMemo(()=>allVisibleColumns.slice(0, inViewportCount), [
        allVisibleColumns,
        inViewportCount
    ]);
    const pinnedColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$297e8079713afa11));
    const getPinnedPosition = $lCzvA.useCallback((field)=>{
        if (pinnedColumns.left.findIndex((col)=>col.field === field) !== -1) return (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT;
        if (pinnedColumns.right.findIndex((col)=>col.field === field) !== -1) return (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT;
        return undefined;
    }, [
        pinnedColumns.left,
        pinnedColumns.right
    ]);
    const children = $lCzvA.useMemo(()=>{
        const array = [];
        for(let i = 0; i < skeletonRowsCount; i += 1){
            const rowCells = [];
            for(let colIndex = 0; colIndex < columns.length; colIndex += 1){
                const column = columns[colIndex];
                const pinnedPosition = getPinnedPosition(column.field);
                const isPinnedLeft = pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT;
                const isPinnedRight = pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT;
                const pinnedSide = (0, $8df4315ce90fcd4c$export$5859c8b8d085a0c0)(pinnedPosition, isRtl);
                const sectionLength = pinnedSide ? pinnedColumns[pinnedSide].length // pinned section
                 : columns.length - pinnedColumns.left.length - pinnedColumns.right.length; // middle section
                const sectionIndex = pinnedSide ? pinnedColumns[pinnedSide].findIndex((col)=>col.field === column.field) // pinned section
                 : colIndex - pinnedColumns.left.length; // middle section
                const scrollbarWidth = dimensions.hasScrollY ? dimensions.scrollbarSize : 0;
                const pinnedStyle = (0, $39179d3e4e328cf6$export$175ada5333288b48)({}, isRtl, pinnedPosition, (0, $d40dc8280276419b$export$29949f0e748b68b8)(pinnedPosition, column.computedWidth, colIndex, positions, dimensions.columnsTotalWidth, scrollbarWidth));
                const gridHasFiller = dimensions.columnsTotalWidth < dimensions.viewportOuterSize.width;
                const showRightBorder = (0, $aefb3468131f4e39$export$646c95cff4790794)(pinnedPosition, sectionIndex, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller);
                const showLeftBorder = (0, $aefb3468131f4e39$export$c01fd18a9a3d03b3)(pinnedPosition, sectionIndex);
                const isLastColumn = colIndex === columns.length - 1;
                const isFirstPinnedRight = isPinnedRight && sectionIndex === 0;
                const hasFillerBefore = isFirstPinnedRight && gridHasFiller;
                const hasFillerAfter = isLastColumn && !isFirstPinnedRight && gridHasFiller;
                const expandedWidth = dimensions.viewportOuterSize.width - dimensions.columnsTotalWidth;
                const emptyCellWidth = Math.max(0, expandedWidth);
                const emptyCell = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(slots.skeletonCell, {
                    width: emptyCellWidth,
                    empty: true
                }, `skeleton-filler-column-${i}`);
                const hasScrollbarFiller = isLastColumn && scrollbarWidth !== 0;
                if (hasFillerBefore) rowCells.push(emptyCell);
                rowCells.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(slots.skeletonCell, {
                    field: column.field,
                    type: column.type,
                    align: column.align,
                    width: "var(--width)",
                    height: dimensions.rowHeight,
                    "data-colindex": colIndex,
                    className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(isPinnedLeft && (0, $786c119d9add6b61$export$2100d54e36406477)['cell--pinnedLeft'], isPinnedRight && (0, $786c119d9add6b61$export$2100d54e36406477)['cell--pinnedRight'], showRightBorder && (0, $786c119d9add6b61$export$2100d54e36406477)['cell--withRightBorder'], showLeftBorder && (0, $786c119d9add6b61$export$2100d54e36406477)['cell--withLeftBorder']),
                    style: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                        '--width': `${column.computedWidth}px`
                    }, pinnedStyle)
                }, `skeleton-column-${i}-${column.field}`));
                if (hasFillerAfter) rowCells.push(emptyCell);
                if (hasScrollbarFiller) rowCells.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $228dc5ac6a21c951$export$69d401a304b172b5), {
                    pinnedRight: pinnedColumns.right.length > 0
                }, `skeleton-scrollbar-filler-${i}`));
            }
            array.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)((0, $786c119d9add6b61$export$2100d54e36406477).row, (0, $786c119d9add6b61$export$2100d54e36406477).rowSkeleton, i === 0 && (0, $786c119d9add6b61$export$2100d54e36406477)['row--firstVisible']),
                children: rowCells
            }, `skeleton-row-${i}`));
        }
        return array;
    }, [
        slots,
        columns,
        pinnedColumns,
        skeletonRowsCount,
        rootProps.showCellVerticalBorder,
        dimensions,
        positions,
        getPinnedPosition,
        isRtl
    ]);
    // Sync the column resize of the overlay columns with the grid
    const handleColumnResize = (params)=>{
        const { colDef: colDef, width: width } = params;
        const cells = ref.current?.querySelectorAll(`[data-field="${(0, $e6e8e5e948b588ba$export$77eab2954df72e62)(colDef.field)}"]`);
        if (!cells) throw new Error('MUI X: Expected skeleton cells to be defined with `data-field` attribute.');
        const resizedColIndex = columns.findIndex((col)=>col.field === colDef.field);
        const pinnedPosition = getPinnedPosition(colDef.field);
        const isPinnedLeft = pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT;
        const isPinnedRight = pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT;
        const currentWidth = getComputedStyle(cells[0]).getPropertyValue('--width');
        const delta = parseInt(currentWidth, 10) - width;
        if (cells) cells.forEach((element)=>{
            element.style.setProperty('--width', `${width}px`);
        });
        if (isPinnedLeft) {
            const pinnedCells = ref.current?.querySelectorAll(`.${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--pinnedLeft']}`);
            pinnedCells?.forEach((element)=>{
                const colIndex = $9c4508508dc143c0$var$getColIndex(element);
                if (colIndex > resizedColIndex) element.style.left = `${parseInt(getComputedStyle(element).left, 10) - delta}px`;
            });
        }
        if (isPinnedRight) {
            const pinnedCells = ref.current?.querySelectorAll(`.${(0, $786c119d9add6b61$export$2100d54e36406477)['cell--pinnedRight']}`);
            pinnedCells?.forEach((element)=>{
                const colIndex = $9c4508508dc143c0$var$getColIndex(element);
                if (colIndex < resizedColIndex) element.style.right = `${parseInt(getComputedStyle(element).right, 10) + delta}px`;
            });
        }
    };
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnResize', handleColumnResize);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($9c4508508dc143c0$var$SkeletonOverlay, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: classes.root
    }, props, {
        ref: handleRef,
        children: children
    }));
});





const $55c38ffb599809ce$var$_excluded = [
    "variant",
    "noRowsVariant",
    "style"
];
const $55c38ffb599809ce$var$LOADING_VARIANTS = {
    'circular-progress': {
        component: (0, $884fc2b3feb01a9d$export$2e2bcd8739ae039),
        style: {}
    },
    'linear-progress': {
        component: (0, $9e85f2a6789e3722$export$2e2bcd8739ae039),
        style: {
            display: 'block'
        }
    },
    skeleton: {
        component: (0, $9c4508508dc143c0$export$123bd4ede2d9ef98),
        style: {
            display: 'block'
        }
    }
};
const $55c38ffb599809ce$export$69e47a4ea5ffa191 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridLoadingOverlay(props, ref) {
    const { variant: variant = 'circular-progress', noRowsVariant: noRowsVariant = 'circular-progress', style: style } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $55c38ffb599809ce$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rowsCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$1641ef9d08e265ca));
    const activeVariant = $55c38ffb599809ce$var$LOADING_VARIANTS[rowsCount === 0 ? noRowsVariant : variant];
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4acad5925f2ed490$export$1c41ff9dbe11e487), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        style: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, activeVariant.style, style)
    }, other, {
        ref: ref,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(activeVariant.component, {})
    }));
});


parcelRequire("lCzvA");





const $7e7026931e18de86$export$a25f04494ce53510 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridNoRowsOverlay(props, ref) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const noRowsLabel = apiRef.current.getLocaleText('noRowsLabel');
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4acad5925f2ed490$export$1c41ff9dbe11e487), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        children: noRowsLabel
    }));
});



var $lCzvA = parcelRequire("lCzvA");



var $lCzvA = parcelRequire("lCzvA");












var $lCzvA = parcelRequire("lCzvA");






var $lCzvA = parcelRequire("lCzvA");
'use client';
/**
 * @ignore - internal component.
 */ const $1d25c3944e982fb6$var$TableContext = /*#__PURE__*/ $lCzvA.createContext();
var $1d25c3944e982fb6$export$2e2bcd8739ae039 = $1d25c3944e982fb6$var$TableContext;



var $lCzvA = parcelRequire("lCzvA");
'use client';
/**
 * @ignore - internal component.
 */ const $434d36982541a41e$var$Tablelvl2Context = /*#__PURE__*/ $lCzvA.createContext();
var $434d36982541a41e$export$2e2bcd8739ae039 = $434d36982541a41e$var$Tablelvl2Context;







function $1a80801afec05694$export$33a0f07a16a10b1b(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiTableCell', slot);
}
const $1a80801afec05694$var$tableCellClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $1a80801afec05694$export$2e2bcd8739ae039 = $1a80801afec05694$var$tableCellClasses;



'use client';
const $dc2d3beb1596de25$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $212bca41d578456f$export$2e2bcd8739ae039)(align)}`,
            padding !== 'normal' && `padding${(0, $212bca41d578456f$export$2e2bcd8739ae039)(padding)}`,
            `size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $1a80801afec05694$export$33a0f07a16a10b1b), classes);
};
const $dc2d3beb1596de25$var$TableCellRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $595d4f40c92954a4$export$c0816ed86df316af)((0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.divider, 1), 0.88) : (0, $595d4f40c92954a4$export$4b073707ff63303)((0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16,
        variants: [
            {
                props: {
                    variant: 'head'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary,
                    lineHeight: theme.typography.pxToRem(24),
                    fontWeight: theme.typography.fontWeightMedium
                }
            },
            {
                props: {
                    variant: 'body'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            },
            {
                props: {
                    variant: 'footer'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    lineHeight: theme.typography.pxToRem(21),
                    fontSize: theme.typography.pxToRem(12)
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '6px 16px',
                    [`&.${(0, $1a80801afec05694$export$2e2bcd8739ae039).paddingCheckbox}`]: {
                        width: 24,
                        // prevent the checkbox column from growing
                        padding: '0 12px 0 16px',
                        '& > *': {
                            padding: 0
                        }
                    }
                }
            },
            {
                props: {
                    padding: 'checkbox'
                },
                style: {
                    width: 48,
                    // prevent the checkbox column from growing
                    padding: '0 0 0 4px'
                }
            },
            {
                props: {
                    padding: 'none'
                },
                style: {
                    padding: 0
                }
            },
            {
                props: {
                    align: 'left'
                },
                style: {
                    textAlign: 'left'
                }
            },
            {
                props: {
                    align: 'center'
                },
                style: {
                    textAlign: 'center'
                }
            },
            {
                props: {
                    align: 'right'
                },
                style: {
                    textAlign: 'right',
                    flexDirection: 'row-reverse'
                }
            },
            {
                props: {
                    align: 'justify'
                },
                style: {
                    textAlign: 'justify'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: (theme.vars || theme).palette.background.default
                }
            }
        ]
    })));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $dc2d3beb1596de25$var$TableCell = /*#__PURE__*/ $lCzvA.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp, ...other } = props;
    const table = $lCzvA.useContext((0, $1d25c3944e982fb6$export$2e2bcd8739ae039));
    const tablelvl2 = $lCzvA.useContext((0, $434d36982541a41e$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = {
        ...props,
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    };
    const classes = $dc2d3beb1596de25$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($dc2d3beb1596de25$var$TableCellRoot, {
        as: component,
        ref: ref,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState,
        ...other
    });
});
var $dc2d3beb1596de25$export$2e2bcd8739ae039 = $dc2d3beb1596de25$var$TableCell;



var $lCzvA = parcelRequire("lCzvA");








function $7306ee56fead9b72$export$b12cb262231eef32(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiToolbar', slot);
}
const $7306ee56fead9b72$var$toolbarClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $7306ee56fead9b72$export$2e2bcd8739ae039 = $7306ee56fead9b72$var$toolbarClasses;



'use client';
const $de4c57e5794296a0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $7306ee56fead9b72$export$b12cb262231eef32), classes);
};
const $de4c57e5794296a0$var$ToolbarRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $de4c57e5794296a0$var$Toolbar = /*#__PURE__*/ $lCzvA.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $de4c57e5794296a0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($de4c57e5794296a0$var$ToolbarRoot, {
        as: component,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $de4c57e5794296a0$export$2e2bcd8739ae039 = $de4c57e5794296a0$var$Toolbar;



var $lCzvA = parcelRequire("lCzvA");


parcelRequire("lCzvA");


'use client';
var $6ff55e00ec6f376e$export$2e2bcd8739ae039 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("lCzvA");


'use client';
var $9b45a9f65412a5b9$export$2e2bcd8739ae039 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');



parcelRequire("lCzvA");


'use client';
var $e33b62c45cbdb4d0$export$2e2bcd8739ae039 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


parcelRequire("lCzvA");


'use client';
var $8516bbacd7c960c4$export$2e2bcd8739ae039 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');



'use client';
const $1a9f9fa0b5dd9ec2$var$TablePaginationActions = /*#__PURE__*/ $lCzvA.forwardRef(function TablePaginationActions(props, ref) {
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = slots.firstButton ?? (0, $5da5f49d148860cb$export$2e2bcd8739ae039);
    const LastButton = slots.lastButton ?? (0, $5da5f49d148860cb$export$2e2bcd8739ae039);
    const NextButton = slots.nextButton ?? (0, $5da5f49d148860cb$export$2e2bcd8739ae039);
    const PreviousButton = slots.previousButton ?? (0, $5da5f49d148860cb$export$2e2bcd8739ae039);
    const FirstButtonIcon = slots.firstButtonIcon ?? (0, $8516bbacd7c960c4$export$2e2bcd8739ae039);
    const LastButtonIcon = slots.lastButtonIcon ?? (0, $e33b62c45cbdb4d0$export$2e2bcd8739ae039);
    const NextButtonIcon = slots.nextButtonIcon ?? (0, $9b45a9f65412a5b9$export$2e2bcd8739ae039);
    const PreviousButtonIcon = slots.previousButtonIcon ?? (0, $6ff55e00ec6f376e$export$2e2bcd8739ae039);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        ref: ref,
        ...other,
        children: [
            showFirstButton && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(FirstButtonSlot, {
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page),
                ...firstButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(PreviousButtonSlot, {
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page),
                ...previousButtonSlotProps ?? backIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(NextButtonSlot, {
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page),
                ...nextButtonSlotProps ?? nextIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                })
            }),
            showLastButton && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(LastButtonSlot, {
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page),
                ...lastButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                })
            })
        ]
    });
});
var $1a9f9fa0b5dd9ec2$export$2e2bcd8739ae039 = $1a9f9fa0b5dd9ec2$var$TablePaginationActions;





function $2b4d25f32907b734$export$909e637b22246f4c(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiTablePagination', slot);
}
const $2b4d25f32907b734$var$tablePaginationClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $2b4d25f32907b734$export$2e2bcd8739ae039 = $2b4d25f32907b734$var$tablePaginationClasses;




'use client';
var $d7caeccd761561b7$var$_InputBase;
const $d7caeccd761561b7$var$TablePaginationRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $dc2d3beb1596de25$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    })));
const $d7caeccd761561b7$var$TablePaginationToolbar = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $de4c57e5794296a0$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>({
            [`& .${(0, $2b4d25f32907b734$export$2e2bcd8739ae039).actions}`]: styles.actions,
            ...styles.toolbar
        })
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $2b4d25f32907b734$export$2e2bcd8739ae039).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    })));
const $d7caeccd761561b7$var$TablePaginationSpacer = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: '1 1 100%'
});
const $d7caeccd761561b7$var$TablePaginationSelectLabel = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel',
    overridesResolver: (props, styles)=>styles.selectLabel
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
const $d7caeccd761561b7$var$TablePaginationSelect = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $ae616a845ede45cb$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>({
            [`& .${(0, $2b4d25f32907b734$export$2e2bcd8739ae039).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $2b4d25f32907b734$export$2e2bcd8739ae039).select}`]: styles.select,
            ...styles.input,
            ...styles.selectRoot
        })
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $2b4d25f32907b734$export$2e2bcd8739ae039).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $d7caeccd761561b7$var$TablePaginationMenuItem = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'MenuItem',
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $d7caeccd761561b7$var$TablePaginationDisplayedRows = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows',
    overridesResolver: (props, styles)=>styles.displayedRows
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
function $d7caeccd761561b7$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $d7caeccd761561b7$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $d7caeccd761561b7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $2b4d25f32907b734$export$909e637b22246f4c), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $d7caeccd761561b7$var$TablePagination = /*#__PURE__*/ $lCzvA.forwardRef(function TablePagination(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $1a9f9fa0b5dd9ec2$export$2e2bcd8739ae039), backIconButtonProps: backIconButtonProps, colSpan: colSpanProp, component: component = (0, $dc2d3beb1596de25$export$2e2bcd8739ae039), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $d7caeccd761561b7$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $d7caeccd761561b7$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const ownerState = props;
    const classes = $d7caeccd761561b7$var$useUtilityClasses(ownerState);
    const selectProps = slotProps?.select ?? SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $d7caeccd761561b7$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $dc2d3beb1596de25$export$2e2bcd8739ae039) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $aa100cf7db7a0505$export$2e2bcd8739ae039)(selectProps.id);
    const labelId = (0, $aa100cf7db7a0505$export$2e2bcd8739ae039)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: classes.root,
        elementType: $d7caeccd761561b7$var$TablePaginationRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: component,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            colSpan: colSpan
        }
    });
    const [ToolbarSlot, toolbarSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('toolbar', {
        className: classes.toolbar,
        elementType: $d7caeccd761561b7$var$TablePaginationToolbar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SpacerSlot, spacerSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('spacer', {
        className: classes.spacer,
        elementType: $d7caeccd761561b7$var$TablePaginationSpacer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectLabelSlot, selectLabelSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('selectLabel', {
        className: classes.selectLabel,
        elementType: $d7caeccd761561b7$var$TablePaginationSelectLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            id: labelId
        }
    });
    const [SelectSlot, selectSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('select', {
        className: classes.select,
        elementType: $d7caeccd761561b7$var$TablePaginationSelect,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MenuItemSlot, menuItemSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('menuItem', {
        className: classes.menuItem,
        elementType: MenuItemComponent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DisplayedRows, displayedRowsProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('displayedRows', {
        className: classes.displayedRows,
        elementType: $d7caeccd761561b7$var$TablePaginationDisplayedRows,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(ToolbarSlot, {
            ...toolbarSlotProps,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(SpacerSlot, {
                    ...spacerSlotProps
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(SelectLabelSlot, {
                    ...selectLabelSlotProps,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(SelectSlot, {
                    variant: "standard",
                    ...!selectProps.variant && {
                        input: $d7caeccd761561b7$var$_InputBase || ($d7caeccd761561b7$var$_InputBase = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $92d8fc367f7e2f74$export$2e2bcd8739ae039), {}))
                    },
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId,
                    ...selectProps,
                    classes: {
                        ...selectProps.classes,
                        // TODO v5 remove `classes.input`
                        root: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.selectIcon, (selectProps.classes || {}).icon)
                    },
                    disabled: disabled,
                    ...selectSlotProps,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $lCzvA.createElement)(MenuItemSlot, {
                            ...menuItemSlotProps,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(DisplayedRows, {
                    ...displayedRowsProps,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    });
});
var $d7caeccd761561b7$export$2e2bcd8739ae039 = $d7caeccd761561b7$var$TablePagination;








const $d17e74de2202907e$var$GridPaginationRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $d7caeccd761561b7$export$2e2bcd8739ae039))(({ theme: theme })=>({
        maxHeight: 'calc(100% + 1px)',
        // border width
        flexGrow: 1,
        [`& .${(0, $2b4d25f32907b734$export$2e2bcd8739ae039).selectLabel}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block'
            }
        },
        [`& .${(0, $2b4d25f32907b734$export$2e2bcd8739ae039).input}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'inline-flex'
            }
        }
    }));
const $d17e74de2202907e$var$wrapLabelDisplayedRows = (labelDisplayedRows, estimated)=>{
    return ({ from: from, to: to, count: count, page: page })=>labelDisplayedRows({
            from: from,
            to: to,
            count: count,
            page: page,
            estimated: estimated
        });
};
const $d17e74de2202907e$var$defaultLabelDisplayedRows = ({ from: from, to: to, count: count, estimated: estimated })=>{
    if (!estimated) return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${estimated > to ? estimated : to}`}`;
};
// A mutable version of a readonly array.
const $d17e74de2202907e$export$fa9a503101f8d472 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridPagination(props, ref) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const paginationModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $017d03038815cc56$export$ccc9f04e59d0d8e6));
    const rowCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $017d03038815cc56$export$946e4ae85da77ef6));
    const pageCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $017d03038815cc56$export$b81026f1aaf843a4));
    const { paginationMode: paginationMode, loading: loading, estimatedRowCount: estimatedRowCount } = rootProps;
    const computedProps = $lCzvA.useMemo(()=>{
        if (rowCount === -1 && paginationMode === 'server' && loading) return {
            backIconButtonProps: {
                disabled: true
            },
            nextIconButtonProps: {
                disabled: true
            }
        };
        return {};
    }, [
        loading,
        paginationMode,
        rowCount
    ]);
    const lastPage = $lCzvA.useMemo(()=>Math.max(0, pageCount - 1), [
        pageCount
    ]);
    const computedPage = $lCzvA.useMemo(()=>{
        if (rowCount === -1) return paginationModel.page;
        return paginationModel.page <= lastPage ? paginationModel.page : lastPage;
    }, [
        lastPage,
        paginationModel.page,
        rowCount
    ]);
    const handlePageSizeChange = $lCzvA.useCallback((event)=>{
        const pageSize = Number(event.target.value);
        apiRef.current.setPageSize(pageSize);
    }, [
        apiRef
    ]);
    const handlePageChange = $lCzvA.useCallback((_, page)=>{
        apiRef.current.setPage(page);
    }, [
        apiRef
    ]);
    const isPageSizeIncludedInPageSizeOptions = (pageSize)=>{
        for(let i = 0; i < rootProps.pageSizeOptions.length; i += 1){
            const option = rootProps.pageSizeOptions[i];
            if (typeof option === 'number') {
                if (option === pageSize) return true;
            } else if (option.value === pageSize) return true;
        }
        return false;
    };
    const pageSizeOptions = isPageSizeIncludedInPageSizeOptions(paginationModel.pageSize) ? rootProps.pageSizeOptions : [];
    const locales = apiRef.current.getLocaleText('MuiTablePagination');
    const wrappedLabelDisplayedRows = $d17e74de2202907e$var$wrapLabelDisplayedRows(locales.labelDisplayedRows || $d17e74de2202907e$var$defaultLabelDisplayedRows, estimatedRowCount);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d17e74de2202907e$var$GridPaginationRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        component: "div",
        count: rowCount,
        page: computedPage,
        rowsPerPageOptions: pageSizeOptions,
        rowsPerPage: paginationModel.pageSize,
        onPageChange: handlePageChange,
        onRowsPerPageChange: handlePageSizeChange
    }, computedProps, locales, {
        labelDisplayedRows: wrappedLabelDisplayedRows
    }, props, {
        ref: ref
    }));
});




var $lCzvA = parcelRequire("lCzvA");











const $f462924829924eb0$var$_excluded = [
    "children",
    "className",
    "classes"
];
const $f462924829924eb0$export$e95ad8c1c287de86 = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiDataGrid', [
    'panel',
    'paper'
]);
const $f462924829924eb0$var$GridPanelRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $b20d485709a84fcd$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'Panel',
    overridesResolver: (props, styles)=>styles.panel
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $f462924829924eb0$var$GridPaperRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $0e17783238642a98$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        minWidth: 300,
        maxHeight: 450,
        display: 'flex',
        maxWidth: `calc(100vw - ${theme.spacing(0.5)})`,
        overflow: 'auto'
    }));
const $f462924829924eb0$export$cf917897ad2588b = (0, $74efa9d8b826b453$export$257a8862b851cb5b)((props, ref)=>{
    const { children: children, className: className } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $f462924829924eb0$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $f462924829924eb0$export$e95ad8c1c287de86;
    const [isPlaced, setIsPlaced] = $lCzvA.useState(false);
    const handleClickAway = $lCzvA.useCallback(()=>{
        apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const handleKeyDown = $lCzvA.useCallback((event)=>{
        if (event.key === 'Escape') apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const modifiers = $lCzvA.useMemo(()=>[
            {
                name: 'flip',
                enabled: true,
                options: {
                    rootBoundary: 'document'
                }
            },
            {
                name: 'isPlaced',
                enabled: true,
                phase: 'main',
                fn: ()=>{
                    setIsPlaced(true);
                },
                effect: ()=>()=>{
                        setIsPlaced(false);
                    }
            }
        ], []);
    const [anchorEl, setAnchorEl] = $lCzvA.useState(null);
    $lCzvA.useEffect(()=>{
        const panelAnchor = apiRef.current.rootElementRef?.current?.querySelector('[data-id="gridPanelAnchor"]');
        if (panelAnchor) setAnchorEl(panelAnchor);
    }, [
        apiRef
    ]);
    if (!anchorEl) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f462924829924eb0$var$GridPanelRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        placement: "bottom-start",
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.panel, className),
        ownerState: rootProps,
        anchorEl: anchorEl,
        modifiers: modifiers
    }, other, {
        ref: ref,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c30bc19cd053c2b9$export$58385c17fee43f89), {
            mouseEvent: "onPointerUp",
            touchEvent: false,
            onClickAway: handleClickAway,
            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f462924829924eb0$var$GridPaperRoot, {
                className: classes.paper,
                ownerState: rootProps,
                elevation: 8,
                onKeyDown: handleKeyDown,
                children: isPlaced && children
            })
        })
    }));
});




var $lCzvA = parcelRequire("lCzvA");





function $06f80ef0b6baa894$export$23cfe696632d10f4(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}






function $6e91e30167aec419$export$4631f4813a5310ce(classes, slots) {
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
}




















'use client';
const $82bdb9ae845c8d90$var$_excluded = [
    "selected",
    "rowId",
    "row",
    "index",
    "style",
    "rowHeight",
    "className",
    "visibleColumns",
    "pinnedColumns",
    "offsetLeft",
    "columnsTotalWidth",
    "firstColumnIndex",
    "lastColumnIndex",
    "focusedColumnIndex",
    "isFirstVisible",
    "isLastVisible",
    "isNotVisible",
    "showBottomBorder",
    "scrollbarWidth",
    "gridHasFiller",
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver"
];
const $82bdb9ae845c8d90$var$isRowReorderingEnabledSelector = (0, $f0fef4ed0246c865$export$89f5fc21559ede9b)((0, $5396c90484690c1e$export$91ed78b95c9e6636), (editRows, rowReordering)=>{
    if (!rowReordering) return false;
    const isEditingRows = !(0, $06f80ef0b6baa894$export$23cfe696632d10f4)(editRows);
    return !isEditingRows;
});
const $82bdb9ae845c8d90$var$GridRow = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridRow(props, refProp) {
    const { selected: selected, rowId: rowId, row: row, index: index, style: styleProp, rowHeight: rowHeight, className: className, visibleColumns: visibleColumns, pinnedColumns: pinnedColumns, offsetLeft: offsetLeft, columnsTotalWidth: columnsTotalWidth, firstColumnIndex: firstColumnIndex, lastColumnIndex: lastColumnIndex, focusedColumnIndex: focusedColumnIndex, isFirstVisible: isFirstVisible, isLastVisible: isLastVisible, isNotVisible: isNotVisible, showBottomBorder: showBottomBorder, scrollbarWidth: scrollbarWidth, gridHasFiller: gridHasFiller, onClick: onClick, onDoubleClick: onDoubleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseOut: onMouseOut, onMouseOver: onMouseOver } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $82bdb9ae845c8d90$var$_excluded);
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const configuration = (0, $3d57cecbb08c0946$export$9fe1679701f06bb7)();
    const ref = $lCzvA.useRef(null);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const currentPage = (0, $6b6f708ce7819830$export$d1914c80ff11e37a)(apiRef, rootProps);
    const sortModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9));
    const treeDepth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$4cdbe576751dd8e2));
    const columnPositions = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$fce7d810e48021e3));
    const rowReordering = rootProps.rowReordering;
    const isRowReorderingEnabled = (0, $1e10d601c15466d4$export$3b2f72ef07abe101)(apiRef, $82bdb9ae845c8d90$var$isRowReorderingEnabledSelector, rowReordering);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(ref, refProp);
    const rowNode = apiRef.current.getRowNode(rowId);
    const editing = (0, $1e10d601c15466d4$export$3b2f72ef07abe101)(apiRef, (0, $5396c90484690c1e$export$3ca6aabd7600f0b3), {
        rowId: rowId,
        editMode: rootProps.editMode
    });
    const editable = rootProps.editMode === (0, $a01f6e6f52a2f91e$export$bad6b7a934346f26).Row;
    const hasFocusCell = focusedColumnIndex !== undefined;
    const hasVirtualFocusCellLeft = hasFocusCell && focusedColumnIndex >= pinnedColumns.left.length && focusedColumnIndex < firstColumnIndex;
    const hasVirtualFocusCellRight = hasFocusCell && focusedColumnIndex < visibleColumns.length - pinnedColumns.right.length && focusedColumnIndex >= lastColumnIndex;
    const classes = (0, $6e91e30167aec419$export$4631f4813a5310ce)(rootProps.classes, {
        root: [
            'row',
            selected && 'selected',
            editable && 'row--editable',
            editing && 'row--editing',
            isFirstVisible && 'row--firstVisible',
            isLastVisible && 'row--lastVisible',
            showBottomBorder && 'row--borderBottom',
            rowHeight === 'auto' && 'row--dynamicHeight'
        ]
    });
    const getRowAriaAttributes = configuration.hooks.useGridRowAriaAttributes();
    $lCzvA.useLayoutEffect(()=>{
        if (currentPage.range) {
            const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
            // Pinned rows are not part of the visible rows
            if (rowIndex !== undefined) apiRef.current.unstable_setLastMeasuredRowIndex(rowIndex);
        }
        if (ref.current && rowHeight === 'auto') return apiRef.current.observeRowHeight(ref.current, rowId);
        return undefined;
    }, [
        apiRef,
        currentPage.range,
        rowHeight,
        rowId
    ]);
    const publish = $lCzvA.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if ((0, $e6e8e5e948b588ba$export$8ce496ad3bfbe3a6)(event)) return;
            // The row might have been deleted
            if (!apiRef.current.getRow(rowId)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(rowId), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        rowId
    ]);
    const publishClick = $lCzvA.useCallback((event)=>{
        const cell = (0, $e6e8e5e948b588ba$export$2a63f1401414fc1a)(event.target, (0, $786c119d9add6b61$export$2100d54e36406477).cell);
        const field = cell?.getAttribute('data-field');
        // Check if the field is available because the cell that fills the empty
        // space of the row has no field.
        if (field) {
            // User clicked in the checkbox added by checkboxSelection
            if (field === (0, $145aea3d0e493d77$export$b2e9ab6103a664ad).field) return;
            // User opened a detail panel
            if (field === (0, $3cb6fcdeb46bf88d$export$6e5a576305a34719)) return;
            // User reorders a row
            if (field === '__reorder__') return;
            // User is editing a cell
            if (apiRef.current.getCellMode(rowId, field) === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit) return;
            // User clicked a button from the "actions" column type
            const column = apiRef.current.getColumn(field);
            if (column?.type === (0, $8af4a53e0f3e9113$export$e2523ab9efeb7465)) return;
        }
        publish('rowClick', onClick)(event);
    }, [
        apiRef,
        onClick,
        publish,
        rowId
    ]);
    const { slots: slots, slotProps: slotProps, disableColumnReorder: disableColumnReorder } = rootProps;
    const heightEntry = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, ()=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, apiRef.current.getRowHeightEntry(rowId)), (0, $1e10d601c15466d4$export$8da4c691e5695191));
    const style = $lCzvA.useMemo(()=>{
        if (isNotVisible) return {
            opacity: 0,
            width: 0,
            height: 0
        };
        const rowStyle = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, styleProp, {
            maxHeight: rowHeight === 'auto' ? 'none' : rowHeight,
            // max-height doesn't support "auto"
            minHeight: rowHeight,
            '--height': typeof rowHeight === 'number' ? `${rowHeight}px` : rowHeight
        });
        if (heightEntry.spacingTop) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderTopWidth' : 'marginTop';
            rowStyle[property] = heightEntry.spacingTop;
        }
        if (heightEntry.spacingBottom) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderBottomWidth' : 'marginBottom';
            let propertyValue = rowStyle[property];
            // avoid overriding existing value
            if (typeof propertyValue !== 'number') propertyValue = parseInt(propertyValue || '0', 10);
            propertyValue += heightEntry.spacingBottom;
            rowStyle[property] = propertyValue;
        }
        return rowStyle;
    }, [
        isNotVisible,
        rowHeight,
        styleProp,
        heightEntry,
        rootProps.rowSpacingType
    ]);
    const rowClassNames = apiRef.current.unstable_applyPipeProcessors('rowClassName', [], rowId);
    const ariaAttributes = getRowAriaAttributes(rowNode, index);
    if (typeof rootProps.getRowClassName === 'function') {
        const indexRelativeToCurrentPage = index - (currentPage.range?.firstRowIndex || 0);
        const rowParams = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, apiRef.current.getRowParams(rowId), {
            isFirstVisible: indexRelativeToCurrentPage === 0,
            isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
            indexRelativeToCurrentPage: indexRelativeToCurrentPage
        });
        rowClassNames.push(rootProps.getRowClassName(rowParams));
    }
    const getCell = (column, indexInSection, indexRelativeToAllColumns, sectionLength, pinnedPosition = (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).NONE)=>{
        const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, indexRelativeToAllColumns);
        if (cellColSpanInfo?.spannedByColSpan) return null;
        const width = cellColSpanInfo?.cellProps.width ?? column.computedWidth;
        const colSpan = cellColSpanInfo?.cellProps.colSpan ?? 1;
        const pinnedOffset = (0, $d40dc8280276419b$export$29949f0e748b68b8)(pinnedPosition, column.computedWidth, indexRelativeToAllColumns, columnPositions, columnsTotalWidth, scrollbarWidth);
        if (rowNode.type === 'skeletonRow') return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(slots.skeletonCell, {
            type: column.type,
            width: width,
            height: rowHeight,
            field: column.field,
            align: column.align
        }, column.field);
        // when the cell is a reorder cell we are not allowing to reorder the col
        // fixes https://github.com/mui/mui-x/issues/11126
        const isReorderCell = column.field === '__reorder__';
        const canReorderColumn = !(disableColumnReorder || column.disableReorder);
        const canReorderRow = isRowReorderingEnabled && !sortModel.length && treeDepth <= 1;
        const disableDragEvents = !(canReorderColumn || isReorderCell && canReorderRow);
        const cellIsNotVisible = pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).VIRTUAL;
        const showLeftBorder = (0, $aefb3468131f4e39$export$c01fd18a9a3d03b3)(pinnedPosition, indexInSection);
        const showRightBorder = (0, $aefb3468131f4e39$export$646c95cff4790794)(pinnedPosition, indexInSection, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller);
        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(slots.cell, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            column: column,
            width: width,
            rowId: rowId,
            align: column.align || 'left',
            colIndex: indexRelativeToAllColumns,
            colSpan: colSpan,
            disableDragEvents: disableDragEvents,
            isNotVisible: cellIsNotVisible,
            pinnedOffset: pinnedOffset,
            pinnedPosition: pinnedPosition,
            showLeftBorder: showLeftBorder,
            showRightBorder: showRightBorder,
            row: row,
            rowNode: rowNode
        }, slotProps?.cell), column.field);
    };
    const leftCells = pinnedColumns.left.map((column, i)=>{
        const indexRelativeToAllColumns = i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.left.length, (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT);
    });
    const rightCells = pinnedColumns.right.map((column, i)=>{
        const indexRelativeToAllColumns = visibleColumns.length - pinnedColumns.right.length + i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.right.length, (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT);
    });
    const middleColumnsLength = visibleColumns.length - pinnedColumns.left.length - pinnedColumns.right.length;
    const cells = [];
    if (hasVirtualFocusCellLeft) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).VIRTUAL));
    for(let i = firstColumnIndex; i < lastColumnIndex; i += 1){
        const column = visibleColumns[i];
        const indexInSection = i - pinnedColumns.left.length;
        if (!column) continue;
        cells.push(getCell(column, indexInSection, i, middleColumnsLength));
    }
    if (hasVirtualFocusCellRight) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).VIRTUAL));
    const eventHandlers = row ? {
        onClick: publishClick,
        onDoubleClick: publish('rowDoubleClick', onDoubleClick),
        onMouseEnter: publish('rowMouseEnter', onMouseEnter),
        onMouseLeave: publish('rowMouseLeave', onMouseLeave),
        onMouseOut: publish('rowMouseOut', onMouseOut),
        onMouseOver: publish('rowMouseOver', onMouseOver)
    } : null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        "data-id": rowId,
        "data-rowindex": index,
        role: "row",
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(...rowClassNames, classes.root, className),
        style: style
    }, ariaAttributes, eventHandlers, other, {
        ref: handleRef,
        children: [
            leftCells,
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                role: "presentation",
                className: (0, $786c119d9add6b61$export$2100d54e36406477).cellOffsetLeft,
                style: {
                    width: offsetLeft
                }
            }),
            cells,
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                role: "presentation",
                className: (0, $6a02406550477b35$export$2e2bcd8739ae039)((0, $786c119d9add6b61$export$2100d54e36406477).cell, (0, $786c119d9add6b61$export$2100d54e36406477).cellEmpty)
            }),
            rightCells,
            scrollbarWidth !== 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $228dc5ac6a21c951$export$69d401a304b172b5), {
                pinnedRight: pinnedColumns.right.length > 0,
                borderTop: !isFirstVisible
            })
        ]
    }));
});
const $82bdb9ae845c8d90$export$1fc5a7f035870658 = (0, $87d1c781e22c5bac$export$fa306e0bc9a9d6b4)($82bdb9ae845c8d90$var$GridRow);



parcelRequire("lCzvA");









const $2c3ed91ea8119e7b$var$_excluded = [
    "className",
    "rowCount",
    "visibleRowCount"
];
const $2c3ed91ea8119e7b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'rowCount'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $2c3ed91ea8119e7b$var$GridRowCountRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'RowCount',
    overridesResolver: (props, styles)=>styles.rowCount
})(({ theme: theme })=>({
        alignItems: 'center',
        display: 'flex',
        margin: theme.spacing(0, 2)
    }));
const $2c3ed91ea8119e7b$export$b92875c9af3e0a77 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridRowCount(props, ref) {
    const { className: className, rowCount: rowCount, visibleRowCount: visibleRowCount } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $2c3ed91ea8119e7b$var$_excluded);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const ownerState = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $2c3ed91ea8119e7b$var$useUtilityClasses(ownerState);
    if (rowCount === 0) return null;
    const text = visibleRowCount < rowCount ? apiRef.current.getLocaleText('footerTotalVisibleRows')(visibleRowCount, rowCount) : rowCount.toLocaleString();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($2c3ed91ea8119e7b$var$GridRowCountRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: ref,
        children: [
            apiRef.current.getLocaleText('footerTotalRows'),
            " ",
            text
        ]
    }));
});




var $lCzvA = parcelRequire("lCzvA");



var $lCzvA = parcelRequire("lCzvA");



function $2d8eb60c12326cb2$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $2d8eb60c12326cb2$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $2d8eb60c12326cb2$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $2d8eb60c12326cb2$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $2d8eb60c12326cb2$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $2d8eb60c12326cb2$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $2d8eb60c12326cb2$export$8af1d214c6c2f0f1(length) * $2d8eb60c12326cb2$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $2d8eb60c12326cb2$export$8af1d214c6c2f0f1(length) * $2d8eb60c12326cb2$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $2d8eb60c12326cb2$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $2d8eb60c12326cb2$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $2d8eb60c12326cb2$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $2d8eb60c12326cb2$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $2d8eb60c12326cb2$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}







function $83af92d1cb6d751d$export$c987db9fc844f86(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiSkeleton', slot);
}
const $83af92d1cb6d751d$var$skeletonClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $83af92d1cb6d751d$export$2e2bcd8739ae039 = $83af92d1cb6d751d$var$skeletonClasses;



'use client';
const $c8f336134efe54c5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $83af92d1cb6d751d$export$c987db9fc844f86), classes);
};
const $c8f336134efe54c5$var$pulseKeyframe = (0, $02d5075f8320414d$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const $c8f336134efe54c5$var$waveKeyframe = (0, $02d5075f8320414d$export$d25ddfdf17c3ad3e)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $c8f336134efe54c5$var$pulseAnimation = typeof $c8f336134efe54c5$var$pulseKeyframe !== 'string' ? (0, $02d5075f8320414d$export$dbf350e5966cf602)`
        animation: ${$c8f336134efe54c5$var$pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const $c8f336134efe54c5$var$waveAnimation = typeof $c8f336134efe54c5$var$waveKeyframe !== 'string' ? (0, $02d5075f8320414d$export$dbf350e5966cf602)`
        &::after {
          animation: ${$c8f336134efe54c5$var$waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const $c8f336134efe54c5$var$SkeletonRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const radiusUnit = (0, $2d8eb60c12326cb2$export$65f2564e9a9b9222)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $2d8eb60c12326cb2$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return {
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em',
        variants: [
            {
                props: {
                    variant: 'text'
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 'auto',
                    transformOrigin: '0 55%',
                    transform: 'scale(1, 0.60)',
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    '&:empty:before': {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: 'circular'
                },
                style: {
                    borderRadius: '50%'
                }
            },
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren,
                style: {
                    '& > *': {
                        visibility: 'hidden'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: 'fit-content'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: 'auto'
                }
            },
            {
                props: {
                    animation: 'pulse'
                },
                style: $c8f336134efe54c5$var$pulseAnimation || {
                    animation: `${$c8f336134efe54c5$var$pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: {
                    position: 'relative',
                    overflow: 'hidden',
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                    '&::after': {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: 'absolute',
                        transform: 'translateX(-100%)' /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: $c8f336134efe54c5$var$waveAnimation || {
                    '&::after': {
                        animation: `${$c8f336134efe54c5$var$waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            }
        ]
    };
}));
const $c8f336134efe54c5$var$Skeleton = /*#__PURE__*/ $lCzvA.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width, ...other } = props;
    const ownerState = {
        ...props,
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    };
    const classes = $c8f336134efe54c5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($c8f336134efe54c5$var$SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width: width,
            height: height,
            ...style
        }
    });
});
var $c8f336134efe54c5$export$2e2bcd8739ae039 = $c8f336134efe54c5$var$Skeleton;








const $9071b8f014cda45f$var$_excluded = [
    "field",
    "type",
    "align",
    "width",
    "height",
    "empty",
    "style",
    "className"
];
const $9071b8f014cda45f$var$CIRCULAR_CONTENT_SIZE = '1.3em';
const $9071b8f014cda45f$var$CONTENT_HEIGHT = '1.2em';
const $9071b8f014cda45f$var$DEFAULT_CONTENT_WIDTH_RANGE = [
    40,
    80
];
const $9071b8f014cda45f$var$CONTENT_WIDTH_RANGE_BY_TYPE = {
    number: [
        40,
        60
    ],
    string: [
        40,
        80
    ],
    date: [
        40,
        60
    ],
    dateTime: [
        60,
        80
    ],
    singleSelect: [
        40,
        80
    ]
};
const $9071b8f014cda45f$var$useUtilityClasses = (ownerState)=>{
    const { align: align, classes: classes, empty: empty } = ownerState;
    const slots = {
        root: [
            'cell',
            'cellSkeleton',
            `cell--text${align ? (0, $c4ab204d748cb214$export$2e2bcd8739ae039)(align) : 'Left'}`,
            empty && 'cellEmpty'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $9071b8f014cda45f$var$randomNumberGenerator = (0, $ac3bd7253ec0e92a$export$90ad2d37c2cc187e)(12345);
function $9071b8f014cda45f$var$GridSkeletonCell(props) {
    const { field: field, type: type, align: align, width: width, height: height, empty: empty = false, style: style, className: className } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $9071b8f014cda45f$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes,
        align: align,
        empty: empty
    };
    const classes = $9071b8f014cda45f$var$useUtilityClasses(ownerState);
    // Memo prevents the non-circular skeleton widths changing to random widths on every render
    const skeletonProps = $lCzvA.useMemo(()=>{
        const isCircularContent = type === 'boolean' || type === 'actions';
        if (isCircularContent) return {
            variant: 'circular',
            width: $9071b8f014cda45f$var$CIRCULAR_CONTENT_SIZE,
            height: $9071b8f014cda45f$var$CIRCULAR_CONTENT_SIZE
        };
        // The width of the skeleton is a random number between the min and max values
        // The min and max values are determined by the type of the column
        const [min, max] = type ? $9071b8f014cda45f$var$CONTENT_WIDTH_RANGE_BY_TYPE[type] ?? $9071b8f014cda45f$var$DEFAULT_CONTENT_WIDTH_RANGE : $9071b8f014cda45f$var$DEFAULT_CONTENT_WIDTH_RANGE;
        return {
            variant: 'text',
            width: `${Math.round($9071b8f014cda45f$var$randomNumberGenerator(min, max))}%`,
            height: $9071b8f014cda45f$var$CONTENT_HEIGHT
        };
    }, [
        type
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        "data-field": field,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        style: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            height: height,
            maxWidth: width,
            minWidth: width
        }, style)
    }, other, {
        children: !empty && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c8f336134efe54c5$export$2e2bcd8739ae039), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, skeletonProps))
    }));
}
const $9071b8f014cda45f$export$d922c88d466d9c21 = (0, $87d1c781e22c5bac$export$fa306e0bc9a9d6b4)($9071b8f014cda45f$var$GridSkeletonCell);





var $lCzvA = parcelRequire("lCzvA");






// Based on https://stackoverflow.com/a/59518678
let $1cd81cc8ae6a19af$var$cachedSupportsPreventScroll;
function $1cd81cc8ae6a19af$export$ed1f8daf96fc68fb() {
    if ($1cd81cc8ae6a19af$var$cachedSupportsPreventScroll === undefined) document.createElement('div').focus({
        get preventScroll () {
            $1cd81cc8ae6a19af$var$cachedSupportsPreventScroll = true;
            return false;
        }
    });
    return $1cd81cc8ae6a19af$var$cachedSupportsPreventScroll;
}















const $c1db5f460d5608e7$var$_excluded = [
    "column",
    "row",
    "rowId",
    "rowNode",
    "align",
    "children",
    "colIndex",
    "width",
    "className",
    "style",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "pinnedOffset",
    "pinnedPosition",
    "showRightBorder",
    "showLeftBorder",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver"
], $c1db5f460d5608e7$var$_excluded2 = [
    "changeReason",
    "unstable_updateValueOnRender"
];
const $c1db5f460d5608e7$export$e4b557c91de463d4 = {
    [(0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT]: (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).LEFT,
    [(0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT]: (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT,
    [(0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).NONE]: undefined,
    [(0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).VIRTUAL]: undefined
};
const $c1db5f460d5608e7$var$useUtilityClasses = (ownerState)=>{
    const { align: align, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, pinnedPosition: pinnedPosition, isEditable: isEditable, isSelected: isSelected, isSelectionMode: isSelectionMode, classes: classes } = ownerState;
    const slots = {
        root: [
            'cell',
            `cell--text${(0, $c4ab204d748cb214$export$2e2bcd8739ae039)(align)}`,
            isSelected && 'selected',
            isEditable && 'cell--editable',
            showLeftBorder && 'cell--withLeftBorder',
            showRightBorder && 'cell--withRightBorder',
            pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT && 'cell--pinnedLeft',
            pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT && 'cell--pinnedRight',
            isSelectionMode && !isEditable && 'cell--selectionMode'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
let $c1db5f460d5608e7$var$warnedOnce = false;
// TODO(v7): Removing the wrapper will break the docs performance visualization demo.
const $c1db5f460d5608e7$var$GridCell = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridCell(props, ref) {
    const { column: column, row: row, rowId: rowId, rowNode: rowNode, align: align, colIndex: colIndex, width: width, className: className, style: styleProp, colSpan: colSpan, disableDragEvents: disableDragEvents, isNotVisible: isNotVisible, pinnedOffset: pinnedOffset, pinnedPosition: pinnedPosition, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, onClick: onClick, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onDragEnter: onDragEnter, onDragOver: onDragOver } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $c1db5f460d5608e7$var$_excluded);
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const field = column.field;
    const editCellState = (0, $1e10d601c15466d4$export$3b2f72ef07abe101)(apiRef, (0, $5396c90484690c1e$export$e6f93ce5e9b42cd9), {
        rowId: rowId,
        field: field
    });
    const config = (0, $3d57cecbb08c0946$export$9fe1679701f06bb7)();
    const cellAggregationResult = config.hooks.useCellAggregationResult(rowId, field);
    const cellMode = editCellState ? (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit : (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).View;
    const cellParams = apiRef.current.getCellParamsForRow(rowId, field, row, {
        colDef: column,
        cellMode: cellMode,
        rowNode: rowNode,
        tabIndex: (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, ()=>{
            const cellTabIndex = (0, $c2be356cc77cce81$export$2c47652a1f657d56)(apiRef);
            return cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === rowId ? 0 : -1;
        }),
        hasFocus: (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, ()=>{
            const focus = (0, $c2be356cc77cce81$export$74af8aada6269d3)(apiRef);
            return focus?.id === rowId && focus.field === field;
        })
    });
    cellParams.api = apiRef.current;
    if (cellAggregationResult) {
        cellParams.value = cellAggregationResult.value;
        cellParams.formattedValue = column.valueFormatter ? column.valueFormatter(cellParams.value, row, column, apiRef) : cellParams.value;
    }
    const isSelected = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
            id: rowId,
            field: field
        }));
    const hiddenCells = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $cf3aae06b42627ec$export$229eb2b26df25c76));
    const spannedCells = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $cf3aae06b42627ec$export$bd3ea60af8c4907f));
    const { hasFocus: hasFocus, isEditable: isEditable = false, value: value } = cellParams;
    const canManageOwnFocus = column.type === 'actions' && column.getActions?.(apiRef.current.getRowParams(rowId)).some((action)=>!action.props.disabled);
    const tabIndex = (cellMode === 'view' || !isEditable) && !canManageOwnFocus ? cellParams.tabIndex : -1;
    const { classes: rootClasses, getCellClassName: getCellClassName } = rootProps;
    // There is a hidden grid state access in `applyPipeProcessor('cellClassName', ...)`
    const pipesClassName = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
            id: rowId,
            field: field
        }).filter(Boolean).join(' '));
    const classNames = [
        pipesClassName
    ];
    if (column.cellClassName) classNames.push(typeof column.cellClassName === 'function' ? column.cellClassName(cellParams) : column.cellClassName);
    if (column.display === 'flex') classNames.push((0, $786c119d9add6b61$export$2100d54e36406477)['cell--flex']);
    if (getCellClassName) classNames.push(getCellClassName(cellParams));
    const valueToRender = cellParams.formattedValue ?? value;
    const cellRef = $lCzvA.useRef(null);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(ref, cellRef);
    const focusElementRef = $lCzvA.useRef(null);
    const isSelectionMode = rootProps.cellSelection ?? false;
    const ownerState = {
        align: align,
        showLeftBorder: showLeftBorder,
        showRightBorder: showRightBorder,
        isEditable: isEditable,
        classes: rootProps.classes,
        pinnedPosition: pinnedPosition,
        isSelected: isSelected,
        isSelectionMode: isSelectionMode
    };
    const classes = $c1db5f460d5608e7$var$useUtilityClasses(ownerState);
    const publishMouseUp = $lCzvA.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = $lCzvA.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = $lCzvA.useCallback((eventName, propHandler)=>(event)=>{
            // The row might have been deleted during the click
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const isCellRowSpanned = hiddenCells[rowId]?.[field] ?? false;
    const rowSpan = spannedCells[rowId]?.[field] ?? 1;
    const style = $lCzvA.useMemo(()=>{
        if (isNotVisible) return {
            padding: 0,
            opacity: 0,
            width: 0,
            height: 0,
            border: 0
        };
        const cellStyle = (0, $39179d3e4e328cf6$export$175ada5333288b48)((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            '--width': `${width}px`
        }, styleProp), isRtl, pinnedPosition, pinnedOffset);
        const isLeftPinned = pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT;
        const isRightPinned = pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT;
        if (rowSpan > 1) {
            cellStyle.height = `calc(var(--height) * ${rowSpan})`;
            cellStyle.zIndex = 10;
            if (isLeftPinned || isRightPinned) cellStyle.zIndex = 40;
        }
        return cellStyle;
    }, [
        width,
        isNotVisible,
        styleProp,
        pinnedOffset,
        pinnedPosition,
        isRtl,
        rowSpan
    ]);
    $lCzvA.useEffect(()=>{
        if (!hasFocus || cellMode === (0, $a01f6e6f52a2f91e$export$84e4fdd8f295ca31).Edit) return;
        const doc = (0, $a1e3e92d2ab059b6$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
            if ((0, $1cd81cc8ae6a19af$export$ed1f8daf96fc68fb)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    if (isCellRowSpanned) return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        "data-colindex": colIndex,
        role: "presentation",
        style: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            width: 'var(--width)'
        }, style)
    });
    let handleFocus = other.onFocus;
    var event;
    let children;
    let title;
    if (editCellState === null && column.renderCell) children = column.renderCell(cellParams);
    if (editCellState !== null && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const editCellStateRest = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(editCellState, $c1db5f460d5608e7$var$_excluded2);
        const formattedValue = column.valueFormatter ? column.valueFormatter(editCellState.value, updatedRow, column, apiRef) : cellParams.formattedValue;
        const params = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, cellParams, {
            row: updatedRow,
            formattedValue: formattedValue
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push((0, $786c119d9add6b61$export$2100d54e36406477)['cell--editing']);
        classNames.push(rootClasses?.['cell--editing']);
    }
    if (children === undefined) {
        const valueString = valueToRender?.toString();
        children = valueString;
        title = valueString;
    }
    if (/*#__PURE__*/ $lCzvA.isValidElement(children) && canManageOwnFocus) children = /*#__PURE__*/ $lCzvA.cloneElement(children, {
        focusElementRef: focusElementRef
    });
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish('cellDragEnter', onDragEnter),
        onDragOver: publish('cellDragOver', onDragOver)
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, classNames, className),
        role: "gridcell",
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        "aria-rowspan": rowSpan,
        style: style,
        title: title,
        tabIndex: tabIndex,
        onClick: publish('cellClick', onClick),
        onDoubleClick: publish('cellDoubleClick', onDoubleClick),
        onMouseOver: publish('cellMouseOver', onMouseOver),
        onMouseDown: publishMouseDown('cellMouseDown'),
        onMouseUp: publishMouseUp('cellMouseUp'),
        onKeyDown: publish('cellKeyDown', onKeyDown),
        onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        ref: handleRef,
        children: children
    }));
});
const $c1db5f460d5608e7$export$1ce951ee41d30605 = (0, $87d1c781e22c5bac$export$fa306e0bc9a9d6b4)($c1db5f460d5608e7$var$GridCell);




parcelRequire("lCzvA");





var $lCzvA = parcelRequire("lCzvA");








var $lCzvA = parcelRequire("lCzvA");









var $lCzvA = parcelRequire("lCzvA");





const $0fd0e10eb1660c9c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open } = ownerState;
    const slots = {
        root: [
            'menuIcon',
            open && 'menuOpen'
        ],
        button: [
            'menuIconButton'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $0fd0e10eb1660c9c$export$941072bb8af39847 = /*#__PURE__*/ $lCzvA.memo((props)=>{
    const { colDef: colDef, open: open, columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, iconButtonRef: iconButtonRef } = props;
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes
    });
    const classes = $0fd0e10eb1660c9c$var$useUtilityClasses(ownerState);
    const handleMenuIconClick = $lCzvA.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        apiRef.current.toggleColumnMenu(colDef.field);
    }, [
        apiRef,
        colDef.field
    ]);
    const columnName = colDef.headerName ?? colDef.field;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseTooltip, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            title: apiRef.current.getLocaleText('columnMenuLabel'),
            enterDelay: 1000
        }, rootProps.slotProps?.baseTooltip, {
            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                ref: iconButtonRef,
                tabIndex: -1,
                className: classes.button,
                "aria-label": apiRef.current.getLocaleText('columnMenuAriaLabel')(columnName),
                size: "small",
                onClick: handleMenuIconClick,
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? columnMenuId : undefined,
                id: columnMenuButtonId
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnMenuIcon, {
                    fontSize: "inherit"
                })
            }))
        }))
    });
});



parcelRequire("lCzvA");





function $83cd9cd5fce68688$export$c096196819b00a09({ columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, ContentComponent: ContentComponent, contentComponentProps: contentComponentProps, field: field, open: open, target: target, onExited: onExited }) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const colDef = apiRef.current.getColumn(field);
    const hideMenu = (0, $b30dbf340362d390$export$2e2bcd8739ae039)((event)=>{
        if (event) {
            // Prevent triggering the sorting
            event.stopPropagation();
            if (target?.contains(event.target)) return;
        }
        apiRef.current.hideColumnMenu();
    });
    if (!target || !colDef) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $eff079abbf7a8831$export$237948c71948075), {
        placement: `bottom-${colDef.align === 'right' ? 'start' : 'end'}`,
        open: open,
        target: target,
        onClose: hideMenu,
        onExited: onExited,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(ContentComponent, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            colDef: colDef,
            hideMenu: hideMenu,
            open: open,
            id: columnMenuId,
            labelledby: columnMenuButtonId
        }, contentComponentProps))
    });
}







var $lCzvA = parcelRequire("lCzvA");






var $lCzvA = parcelRequire("lCzvA");









const $27a4dae478e121d3$var$_excluded = [
    "className",
    "aria-label"
];
const $27a4dae478e121d3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaderTitle'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $27a4dae478e121d3$var$GridColumnHeaderTitleRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderTitle',
    overridesResolver: (props, styles)=>styles.columnHeaderTitle
})({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'var(--unstable_DataGrid-headWeight)',
    lineHeight: 'normal'
});
const $27a4dae478e121d3$var$ColumnHeaderInnerTitle = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function ColumnHeaderInnerTitle(props, ref) {
    // Tooltip adds aria-label to the props, which is not needed since the children prop is a string
    // See https://github.com/mui/mui-x/pull/14482
    const { className: className } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $27a4dae478e121d3$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $27a4dae478e121d3$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($27a4dae478e121d3$var$GridColumnHeaderTitleRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});
// No React.memo here as if we display the sort icon, we need to recalculate the isOver
function $27a4dae478e121d3$export$926bb04b6af55e42(props) {
    const { label: label, description: description } = props;
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const titleRef = $lCzvA.useRef(null);
    const [tooltip, setTooltip] = $lCzvA.useState('');
    const handleMouseOver = $lCzvA.useCallback(()=>{
        if (!description && titleRef?.current) {
            const isOver = (0, $e6e8e5e948b588ba$export$c8be9a8325efa7ee)(titleRef.current);
            if (isOver) setTooltip(label);
            else setTooltip('');
        }
    }, [
        description,
        label
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseTooltip, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        title: description || tooltip
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($27a4dae478e121d3$var$ColumnHeaderInnerTitle, {
            onMouseOver: handleMouseOver,
            ref: titleRef,
            children: label
        })
    }));
}





var $lCzvA = parcelRequire("lCzvA");





const $f10109af503056a8$var$_excluded = [
    "resizable",
    "resizing",
    "height",
    "side"
];
var $f10109af503056a8$export$71ed79b4ccf06d60 = /*#__PURE__*/ function(GridColumnHeaderSeparatorSides) {
    GridColumnHeaderSeparatorSides["Left"] = "left";
    GridColumnHeaderSeparatorSides["Right"] = "right";
    return GridColumnHeaderSeparatorSides;
}($f10109af503056a8$export$71ed79b4ccf06d60 || {});
const $f10109af503056a8$var$useUtilityClasses = (ownerState)=>{
    const { resizable: resizable, resizing: resizing, classes: classes, side: side } = ownerState;
    const slots = {
        root: [
            'columnSeparator',
            resizable && 'columnSeparator--resizable',
            resizing && 'columnSeparator--resizing',
            side && `columnSeparator--side${(0, $c4ab204d748cb214$export$2e2bcd8739ae039)(side)}`
        ],
        icon: [
            'iconSeparator'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $f10109af503056a8$var$GridColumnHeaderSeparatorRaw(props) {
    const { height: height, side: side = $f10109af503056a8$export$71ed79b4ccf06d60.Right } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $f10109af503056a8$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        side: side,
        classes: rootProps.classes
    });
    const classes = $f10109af503056a8$var$useUtilityClasses(ownerState);
    const stopClick = $lCzvA.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: classes.root,
        style: {
            minHeight: height
        }
    }, other, {
        onClick: stopClick,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnResizeIcon, {
            className: classes.icon
        })
    })));
}
const $f10109af503056a8$export$a264529bdbb7adb7 = /*#__PURE__*/ $lCzvA.memo($f10109af503056a8$var$GridColumnHeaderSeparatorRaw);




const $c0a31c4ee357f584$var$_excluded = [
    "classes",
    "columnMenuOpen",
    "colIndex",
    "height",
    "isResizing",
    "sortDirection",
    "hasFocus",
    "tabIndex",
    "separatorSide",
    "isDraggable",
    "headerComponent",
    "description",
    "elementId",
    "width",
    "columnMenuIconButton",
    "columnMenu",
    "columnTitleIconButtons",
    "headerClassName",
    "label",
    "resizable",
    "draggableContainerProps",
    "columnHeaderSeparatorProps",
    "style"
];
const $c0a31c4ee357f584$export$fd75c0d5b714072b = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridGenericColumnHeaderItem(props, ref) {
    const { classes: classes, colIndex: colIndex, height: height, isResizing: isResizing, sortDirection: sortDirection, tabIndex: tabIndex, separatorSide: separatorSide, isDraggable: isDraggable, headerComponent: headerComponent, description: description, width: width, columnMenuIconButton: columnMenuIconButton = null, columnMenu: columnMenu = null, columnTitleIconButtons: columnTitleIconButtons = null, headerClassName: headerClassName, label: label, resizable: resizable, draggableContainerProps: draggableContainerProps, columnHeaderSeparatorProps: columnHeaderSeparatorProps, style: style } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $c0a31c4ee357f584$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const headerCellRef = $lCzvA.useRef(null);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(headerCellRef, ref);
    let ariaSort = 'none';
    if (sortDirection != null) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, headerClassName),
        style: (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, style, {
            height: height,
            width: width
        }),
        role: "columnheader",
        tabIndex: tabIndex,
        "aria-colindex": colIndex + 1,
        "aria-sort": ariaSort
    }, other, {
        ref: handleRef,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                className: classes.draggableContainer,
                draggable: isDraggable,
                role: "presentation"
            }, draggableContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: classes.titleContainer,
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                className: classes.titleContainerContent,
                                children: headerComponent !== undefined ? headerComponent : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $27a4dae478e121d3$export$926bb04b6af55e42), {
                                    label: label,
                                    description: description,
                                    columnWidth: width
                                })
                            }),
                            columnTitleIconButtons
                        ]
                    }),
                    columnMenuIconButton
                ]
            })),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $f10109af503056a8$export$a264529bdbb7adb7), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                resizable: !rootProps.disableColumnResize && !!resizable,
                resizing: isResizing,
                height: height,
                side: separatorSide
            }, columnHeaderSeparatorProps)),
            columnMenu
        ]
    }));
});






const $cb23168786d17c9a$var$useUtilityClasses = (ownerState)=>{
    const { colDef: colDef, classes: classes, isDragging: isDragging, sortDirection: sortDirection, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, filterItemsCounter: filterItemsCounter, pinnedPosition: pinnedPosition, isLastUnpinned: isLastUnpinned, isSiblingFocused: isSiblingFocused } = ownerState;
    const isColumnSorted = sortDirection != null;
    const isColumnFiltered = filterItemsCounter != null && filterItemsCounter > 0;
    // todo refactor to a prop on col isNumeric or ?? ie: coltype===price wont work
    const isColumnNumeric = colDef.type === 'number';
    const slots = {
        root: [
            'columnHeader',
            colDef.headerAlign === 'left' && 'columnHeader--alignLeft',
            colDef.headerAlign === 'center' && 'columnHeader--alignCenter',
            colDef.headerAlign === 'right' && 'columnHeader--alignRight',
            colDef.sortable && 'columnHeader--sortable',
            isDragging && 'columnHeader--moving',
            isColumnSorted && 'columnHeader--sorted',
            isColumnFiltered && 'columnHeader--filtered',
            isColumnNumeric && 'columnHeader--numeric',
            'withBorderColor',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT && 'columnHeader--pinnedRight',
            // TODO: Remove classes below and restore `:has` selectors when they are supported in jsdom
            // See https://github.com/mui/mui-x/pull/14559
            isLastUnpinned && 'columnHeader--lastUnpinned',
            isSiblingFocused && 'columnHeader--siblingFocused'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $cb23168786d17c9a$var$GridColumnHeaderItem(props) {
    const { colDef: colDef, columnMenuOpen: columnMenuOpen, colIndex: colIndex, headerHeight: headerHeight, isResizing: isResizing, isLast: isLast, sortDirection: sortDirection, sortIndex: sortIndex, filterItemsCounter: filterItemsCounter, hasFocus: hasFocus, tabIndex: tabIndex, disableReorder: disableReorder, separatorSide: separatorSide, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, pinnedPosition: pinnedPosition, pinnedOffset: pinnedOffset } = props;
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const headerCellRef = $lCzvA.useRef(null);
    const columnMenuId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const columnMenuButtonId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const iconButtonRef = $lCzvA.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = $lCzvA.useState(columnMenuOpen);
    const isDraggable = $lCzvA.useMemo(()=>!rootProps.disableColumnReorder && !disableReorder && !colDef.disableReorder, [
        rootProps.disableColumnReorder,
        disableReorder,
        colDef.disableReorder
    ]);
    let headerComponent;
    if (colDef.renderHeader) headerComponent = colDef.renderHeader(apiRef.current.getColumnHeaderParams(colDef.field));
    const ownerState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes,
        showRightBorder: showRightBorder,
        showLeftBorder: showLeftBorder
    });
    const classes = $cb23168786d17c9a$var$useUtilityClasses(ownerState);
    const publish = $lCzvA.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $e6e8e5e948b588ba$export$8ce496ad3bfbe3a6)(event)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
        }, [
        apiRef,
        colDef.field
    ]);
    const mouseEventsHandlers = $lCzvA.useMemo(()=>({
            onClick: publish('columnHeaderClick'),
            onContextMenu: publish('columnHeaderContextMenu'),
            onDoubleClick: publish('columnHeaderDoubleClick'),
            onMouseOver: publish('columnHeaderOver'),
            // TODO remove as it's not used
            onMouseOut: publish('columnHeaderOut'),
            // TODO remove as it's not used
            onMouseEnter: publish('columnHeaderEnter'),
            // TODO remove as it's not used
            onMouseLeave: publish('columnHeaderLeave'),
            // TODO remove as it's not used
            onKeyDown: publish('columnHeaderKeyDown'),
            onFocus: publish('columnHeaderFocus'),
            onBlur: publish('columnHeaderBlur')
        }), [
        publish
    ]);
    const draggableEventHandlers = $lCzvA.useMemo(()=>isDraggable ? {
            onDragStart: publish('columnHeaderDragStart'),
            onDragEnter: publish('columnHeaderDragEnter'),
            onDragOver: publish('columnHeaderDragOver'),
            onDragEnd: publish('columnHeaderDragEnd')
        } : {}, [
        isDraggable,
        publish
    ]);
    const columnHeaderSeparatorProps = $lCzvA.useMemo(()=>({
            onMouseDown: publish('columnSeparatorMouseDown'),
            onDoubleClick: publish('columnSeparatorDoubleClick')
        }), [
        publish
    ]);
    $lCzvA.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    const handleExited = $lCzvA.useCallback(()=>{
        setShowColumnMenuIcon(false);
    }, []);
    const columnMenuIconButton = !rootProps.disableColumnMenu && !colDef.disableColumnMenu && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0fd0e10eb1660c9c$export$941072bb8af39847), {
        colDef: colDef,
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        open: showColumnMenuIcon,
        iconButtonRef: iconButtonRef
    });
    const columnMenu = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $83cd9cd5fce68688$export$c096196819b00a09), {
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        field: colDef.field,
        open: columnMenuOpen,
        target: iconButtonRef.current,
        ContentComponent: rootProps.slots.columnMenu,
        contentComponentProps: rootProps.slotProps?.columnMenu,
        onExited: handleExited
    });
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const showSortIcon = (colDef.sortable || sortDirection != null) && !colDef.hideSortIcons && !rootProps.disableColumnSorting;
    const columnTitleIconButtons = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnHeaderFilterIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                field: colDef.field,
                counter: filterItemsCounter
            }, rootProps.slotProps?.columnHeaderFilterIconButton)),
            showSortIcon && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnHeaderSortIcon, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                field: colDef.field,
                direction: sortDirection,
                index: sortIndex,
                sortingOrder: sortingOrder,
                disabled: !colDef.sortable
            }, rootProps.slotProps?.columnHeaderSortIcon))
        ]
    });
    $lCzvA.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            if (!elementToFocus) return;
            if ((0, $1cd81cc8ae6a19af$export$ed1f8daf96fc68fb)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const headerClassName = typeof colDef.headerClassName === 'function' ? colDef.headerClassName({
        field: colDef.field,
        colDef: colDef
    }) : colDef.headerClassName;
    const label = colDef.headerName ?? colDef.field;
    const style = $lCzvA.useMemo(()=>(0, $39179d3e4e328cf6$export$175ada5333288b48)((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props.style), isRtl, pinnedPosition, pinnedOffset), [
        pinnedPosition,
        pinnedOffset,
        props.style,
        isRtl
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c0a31c4ee357f584$export$fd75c0d5b714072b), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: columnMenuOpen,
        colIndex: colIndex,
        height: headerHeight,
        isResizing: isResizing,
        sortDirection: sortDirection,
        hasFocus: hasFocus,
        tabIndex: tabIndex,
        separatorSide: separatorSide,
        isDraggable: isDraggable,
        headerComponent: headerComponent,
        description: colDef.description,
        elementId: colDef.field,
        width: colDef.computedWidth,
        columnMenuIconButton: columnMenuIconButton,
        columnTitleIconButtons: columnTitleIconButtons,
        headerClassName: (0, $6a02406550477b35$export$2e2bcd8739ae039)(headerClassName, isLast && (0, $786c119d9add6b61$export$2100d54e36406477)['columnHeader--last']),
        label: label,
        resizable: !rootProps.disableColumnResize && !!colDef.resizable,
        "data-field": colDef.field,
        columnMenu: columnMenu,
        draggableContainerProps: draggableEventHandlers,
        columnHeaderSeparatorProps: columnHeaderSeparatorProps,
        style: style
    }, mouseEventsHandlers));
}
const $cb23168786d17c9a$export$10f6faff2f47edd = (0, $87d1c781e22c5bac$export$fa306e0bc9a9d6b4)($cb23168786d17c9a$var$GridColumnHeaderItem);







var $lCzvA = parcelRequire("lCzvA");













const $23415d21371360c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, headerAlign: headerAlign, isDragging: isDragging, isLastColumn: isLastColumn, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, groupId: groupId, pinnedPosition: pinnedPosition } = ownerState;
    const slots = {
        root: [
            'columnHeader',
            headerAlign === 'left' && 'columnHeader--alignLeft',
            headerAlign === 'center' && 'columnHeader--alignCenter',
            headerAlign === 'right' && 'columnHeader--alignRight',
            isDragging && 'columnHeader--moving',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            'withBorderColor',
            groupId === null ? 'columnHeader--emptyGroup' : 'columnHeader--filledGroup',
            pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT && 'columnHeader--pinnedRight',
            isLastColumn && 'columnHeader--last'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer',
            'withBorderColor'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
function $23415d21371360c0$export$ff426d40d02e21be(props) {
    const { groupId: groupId, width: width, depth: depth, maxDepth: maxDepth, fields: fields, height: height, colIndex: colIndex, hasFocus: hasFocus, tabIndex: tabIndex, isLastColumn: isLastColumn, pinnedPosition: pinnedPosition, pinnedOffset: pinnedOffset } = props;
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const headerCellRef = $lCzvA.useRef(null);
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const columnGroupsLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8590d748d071bb9f$export$bdc2ff4432d8b29b));
    const group = groupId ? columnGroupsLookup[groupId] : {};
    const { headerName: headerName = groupId ?? '', description: description = '', headerAlign: headerAlign } = group;
    let headerComponent;
    const render = groupId && columnGroupsLookup[groupId]?.renderHeaderGroup;
    const renderParams = $lCzvA.useMemo(()=>({
            groupId: groupId,
            headerName: headerName,
            description: description,
            depth: depth,
            maxDepth: maxDepth,
            fields: fields,
            colIndex: colIndex,
            isLastColumn: isLastColumn
        }), [
        groupId,
        headerName,
        description,
        depth,
        maxDepth,
        fields,
        colIndex,
        isLastColumn
    ]);
    if (groupId && render) headerComponent = render(renderParams);
    const ownerState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes,
        headerAlign: headerAlign,
        depth: depth,
        isDragging: false
    });
    const label = headerName ?? groupId;
    const id = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const elementId = groupId === null ? `empty-group-cell-${id}` : groupId;
    const classes = $23415d21371360c0$var$useUtilityClasses(ownerState);
    $lCzvA.useLayoutEffect(()=>{
        if (hasFocus) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            if (!elementToFocus) return;
            if ((0, $1cd81cc8ae6a19af$export$ed1f8daf96fc68fb)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const publish = $lCzvA.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $e6e8e5e948b588ba$export$8ce496ad3bfbe3a6)(event)) return;
            apiRef.current.publishEvent(eventName, renderParams, event);
        }, // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [
        apiRef,
        renderParams
    ]);
    const mouseEventsHandlers = $lCzvA.useMemo(()=>({
            onKeyDown: publish('columnGroupHeaderKeyDown'),
            onFocus: publish('columnGroupHeaderFocus'),
            onBlur: publish('columnGroupHeaderBlur')
        }), [
        publish
    ]);
    const headerClassName = typeof group.headerClassName === 'function' ? group.headerClassName(renderParams) : group.headerClassName;
    const style = $lCzvA.useMemo(()=>(0, $39179d3e4e328cf6$export$175ada5333288b48)((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props.style), isRtl, pinnedPosition, pinnedOffset), [
        pinnedPosition,
        pinnedOffset,
        props.style,
        isRtl
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c0a31c4ee357f584$export$fd75c0d5b714072b), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: false,
        colIndex: colIndex,
        height: height,
        isResizing: false,
        sortDirection: null,
        hasFocus: false,
        tabIndex: tabIndex,
        isDraggable: false,
        headerComponent: headerComponent,
        headerClassName: headerClassName,
        description: description,
        elementId: elementId,
        width: width,
        columnMenuIconButton: null,
        columnTitleIconButtons: null,
        resizable: false,
        label: label,
        "aria-colspan": fields.length,
        "data-fields": `|-${fields.join('-|-')}-|`,
        style: style
    }, mouseEventsHandlers));
}











const $23867169d133afda$export$7b391e1fd04597c4 = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderRow',
    overridesResolver: (_, styles)=>styles.columnHeaderRow
})({
    display: 'flex'
});
const $23867169d133afda$export$dd7dbc7d3ee10272 = (props)=>{
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props;
    const [dragCol, setDragCol] = $lCzvA.useState('');
    const [resizeCol, setResizeCol] = $lCzvA.useState('');
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const columnGroupsModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8590d748d071bb9f$export$78f140ad2e1dbc2b));
    const columnPositions = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$fce7d810e48021e3));
    const renderContext = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $c79669abb772bd0a$export$3a5705edd3d1af7e));
    const pinnedColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$297e8079713afa11));
    const columnsLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$8a3a9a6db584d7fd));
    const offsetLeft = (0, $2b0e72b73973ab3a$export$fe1f1566870c3cbc)(columnPositions, renderContext, pinnedColumns.left.length);
    const columnsTotalWidth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$ab20f9d33edc7794));
    const gridHasFiller = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$34d7a8c547584228));
    const headerHeight = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$4b70ef0159fef49b));
    const groupHeaderHeight = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$f49d78f35ee113b0));
    const scrollbarWidth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$6615095b3c921727));
    const handleColumnResizeStart = $lCzvA.useCallback((params)=>setResizeCol(params.field), []);
    const handleColumnResizeStop = $lCzvA.useCallback(()=>setResizeCol(''), []);
    const handleColumnReorderStart = $lCzvA.useCallback((params)=>setDragCol(params.field), []);
    const handleColumnReorderStop = $lCzvA.useCallback(()=>setDragCol(''), []);
    const leftRenderContext = $lCzvA.useMemo(()=>{
        return pinnedColumns.left.length ? {
            firstColumnIndex: 0,
            lastColumnIndex: pinnedColumns.left.length
        } : null;
    }, [
        pinnedColumns.left.length
    ]);
    const rightRenderContext = $lCzvA.useMemo(()=>{
        return pinnedColumns.right.length ? {
            firstColumnIndex: visibleColumns.length - pinnedColumns.right.length,
            lastColumnIndex: visibleColumns.length
        } : null;
    }, [
        pinnedColumns.right.length,
        visibleColumns.length
    ]);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnResizeStart', handleColumnResizeStart);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnResizeStop', handleColumnResizeStop);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragStart', handleColumnReorderStart);
    (0, $ecad0fba09446fc0$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragEnd', handleColumnReorderStop);
    // Helper for computation common between getColumnHeaders and getColumnGroupHeaders
    const getColumnsToRender = (params)=>{
        const { renderContext: currentContext = renderContext } = params || {};
        const firstColumnToRender = currentContext.firstColumnIndex;
        const lastColumnToRender = currentContext.lastColumnIndex;
        const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        return {
            renderedColumns: renderedColumns,
            firstColumnToRender: firstColumnToRender,
            lastColumnToRender: lastColumnToRender
        };
    };
    const getFillers = (params, children, leftOverflow, borderBottom = false)=>{
        const isPinnedRight = params?.position === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT;
        const isNotPinned = params?.position === undefined;
        const hasScrollbarFiller = pinnedColumns.right.length > 0 && isPinnedRight || pinnedColumns.right.length === 0 && isNotPinned;
        const leftOffsetWidth = offsetLeft - leftOverflow;
        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
            children: [
                isNotPinned && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    role: "presentation",
                    style: {
                        width: leftOffsetWidth
                    }
                }),
                children,
                isNotPinned && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    role: "presentation",
                    className: (0, $6a02406550477b35$export$2e2bcd8739ae039)((0, $786c119d9add6b61$export$2100d54e36406477).filler, borderBottom && (0, $786c119d9add6b61$export$2100d54e36406477)['filler--borderBottom'])
                }),
                hasScrollbarFiller && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $228dc5ac6a21c951$export$69d401a304b172b5), {
                    header: true,
                    pinnedRight: isPinnedRight,
                    borderBottom: borderBottom,
                    borderTop: false
                })
            ]
        });
    };
    const getColumnHeaders = (params, other = {})=>{
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender } = getColumnsToRender(params);
        const columns = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const isFirstColumn = columnIndex === 0;
            const tabIndex = columnHeaderTabIndexState !== null && columnHeaderTabIndexState.field === colDef.field || isFirstColumn && !hasOtherElementInTabSequence ? 0 : -1;
            const hasFocus = columnHeaderFocus !== null && columnHeaderFocus.field === colDef.field;
            const open = columnMenuState.open && columnMenuState.field === colDef.field;
            const pinnedPosition = params?.position;
            const pinnedOffset = (0, $d40dc8280276419b$export$29949f0e748b68b8)(pinnedPosition, colDef.computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            const siblingWithBorderingSeparator = pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT ? renderedColumns[i - 1] : renderedColumns[i + 1];
            const isSiblingFocused = siblingWithBorderingSeparator ? columnHeaderFocus !== null && columnHeaderFocus.field === siblingWithBorderingSeparator.field : false;
            const isLastUnpinned = columnIndex + 1 === columnPositions.length - pinnedColumns.right.length;
            const indexInSection = i;
            const sectionLength = renderedColumns.length;
            const showLeftBorder = (0, $aefb3468131f4e39$export$c01fd18a9a3d03b3)(pinnedPosition, indexInSection);
            const showRightBorder = (0, $aefb3468131f4e39$export$646c95cff4790794)(pinnedPosition, indexInSection, sectionLength, rootProps.showColumnVerticalBorder, gridHasFiller);
            columns.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $cb23168786d17c9a$export$10f6faff2f47edd), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, sortColumnLookup[colDef.field], {
                columnMenuOpen: open,
                filterItemsCounter: filterColumnLookup[colDef.field] && filterColumnLookup[colDef.field].length,
                headerHeight: headerHeight,
                isDragging: colDef.field === dragCol,
                colDef: colDef,
                colIndex: columnIndex,
                isResizing: resizeCol === colDef.field,
                isLast: columnIndex === columnPositions.length - 1,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                isLastUnpinned: isLastUnpinned,
                isSiblingFocused: isSiblingFocused,
                showLeftBorder: showLeftBorder,
                showRightBorder: showRightBorder
            }, other), colDef.field));
        }
        return getFillers(params, columns, 0);
    };
    const getColumnHeadersRow = ()=>{
        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($23867169d133afda$export$7b391e1fd04597c4, {
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 1,
            ownerState: rootProps,
            className: (0, $786c119d9add6b61$export$2100d54e36406477)['row--borderBottom'],
            children: [
                leftRenderContext && getColumnHeaders({
                    position: (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT,
                    renderContext: leftRenderContext
                }, {
                    disableReorder: true
                }),
                getColumnHeaders({
                    renderContext: renderContext
                }),
                rightRenderContext && getColumnHeaders({
                    position: (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT,
                    renderContext: rightRenderContext
                }, {
                    disableReorder: true,
                    separatorSide: (0, $f10109af503056a8$export$71ed79b4ccf06d60).Left
                })
            ]
        });
    };
    const getColumnGroupHeaders = ({ depth: depth, params: params })=>{
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender.renderedColumns.length === 0) return null;
        const { firstColumnToRender: firstColumnToRender, lastColumnToRender: lastColumnToRender } = columnsToRender;
        const rowStructure = columnGroupsHeaderStructure[depth];
        const firstColumnFieldToRender = visibleColumns[firstColumnToRender].field;
        const firstGroupToRender = columnGroupsModel[firstColumnFieldToRender]?.[depth] ?? null;
        const firstGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === firstGroupToRender && columnFields.includes(firstColumnFieldToRender));
        const lastColumnFieldToRender = visibleColumns[lastColumnToRender - 1].field;
        const lastGroupToRender = columnGroupsModel[lastColumnFieldToRender]?.[depth] ?? null;
        const lastGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === lastGroupToRender && columnFields.includes(lastColumnFieldToRender));
        const visibleColumnGroupHeader = rowStructure.slice(firstGroupIndex, lastGroupIndex + 1).map((groupStructure)=>{
            return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, groupStructure, {
                columnFields: groupStructure.columnFields.filter((field)=>columnVisibility[field] !== false)
            });
        }).filter((groupStructure)=>groupStructure.columnFields.length > 0);
        const firstVisibleColumnIndex = visibleColumnGroupHeader[0].columnFields.indexOf(firstColumnFieldToRender);
        const hiddenGroupColumns = visibleColumnGroupHeader[0].columnFields.slice(0, firstVisibleColumnIndex);
        const leftOverflow = hiddenGroupColumns.reduce((acc, field)=>{
            const column = columnsLookup[field];
            return acc + (column.computedWidth ?? 0);
        }, 0);
        let columnIndex = firstColumnToRender;
        const children = visibleColumnGroupHeader.map(({ groupId: groupId, columnFields: columnFields }, index)=>{
            const hasFocus = columnGroupHeaderFocus !== null && columnGroupHeaderFocus.depth === depth && columnFields.includes(columnGroupHeaderFocus.field);
            const tabIndex = columnGroupHeaderTabIndexState !== null && columnGroupHeaderTabIndexState.depth === depth && columnFields.includes(columnGroupHeaderTabIndexState.field) ? 0 : -1;
            const headerInfo = {
                groupId: groupId,
                width: columnFields.reduce((acc, field)=>acc + columnsLookup[field].computedWidth, 0),
                fields: columnFields,
                colIndex: columnIndex,
                hasFocus: hasFocus,
                tabIndex: tabIndex
            };
            const pinnedPosition = params.position;
            const pinnedOffset = (0, $d40dc8280276419b$export$29949f0e748b68b8)(pinnedPosition, headerInfo.width, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            columnIndex += columnFields.length;
            let indexInSection = index;
            if (pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT) // Group headers can expand to multiple columns, we need to adjust the index
            indexInSection = columnIndex - 1;
            return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $23415d21371360c0$export$ff426d40d02e21be), {
                groupId: groupId,
                width: headerInfo.width,
                fields: headerInfo.fields,
                colIndex: headerInfo.colIndex,
                depth: depth,
                isLastColumn: index === visibleColumnGroupHeader.length - 1,
                maxDepth: headerGroupingMaxDepth,
                height: groupHeaderHeight,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                showLeftBorder: (0, $aefb3468131f4e39$export$c01fd18a9a3d03b3)(pinnedPosition, indexInSection),
                showRightBorder: (0, $aefb3468131f4e39$export$646c95cff4790794)(pinnedPosition, indexInSection, visibleColumnGroupHeader.length, rootProps.showColumnVerticalBorder, gridHasFiller)
            }, index);
        });
        return getFillers(params, children, leftOverflow);
    };
    const getColumnGroupHeadersRows = ()=>{
        if (headerGroupingMaxDepth === 0) return null;
        const headerRows = [];
        for(let depth = 0; depth < headerGroupingMaxDepth; depth += 1)headerRows.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($23867169d133afda$export$7b391e1fd04597c4, {
            role: "row",
            "aria-rowindex": depth + 1,
            ownerState: rootProps,
            children: [
                leftRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT,
                        renderContext: leftRenderContext,
                        maxLastColumn: leftRenderContext.lastColumnIndex
                    }
                }),
                getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        renderContext: renderContext
                    }
                }),
                rightRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT,
                        renderContext: rightRenderContext,
                        maxLastColumn: rightRenderContext.lastColumnIndex
                    }
                })
            ]
        }, depth));
        return headerRows;
    };
    return {
        renderContext: renderContext,
        leftRenderContext: leftRenderContext,
        rightRenderContext: rightRenderContext,
        pinnedColumns: pinnedColumns,
        visibleColumns: visibleColumns,
        columnPositions: columnPositions,
        getFillers: getFillers,
        getColumnHeadersRow: getColumnHeadersRow,
        getColumnsToRender: getColumnsToRender,
        getColumnGroupHeadersRows: getColumnGroupHeadersRows,
        getPinnedCellOffset: $d40dc8280276419b$export$29949f0e748b68b8,
        isDragging: !!dragCol,
        getInnerProps: ()=>({
                role: 'rowgroup'
            })
    };
};




parcelRequire("lCzvA");







const $643961e54ef714d1$var$_excluded = [
    "className"
];
const $643961e54ef714d1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaders'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $643961e54ef714d1$var$GridColumnHeadersRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaders',
    overridesResolver: (props, styles)=>styles.columnHeaders
})({
    display: 'flex',
    flexDirection: 'column',
    borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
    borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
});
const $643961e54ef714d1$export$de91f7b8bf842ed8 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridColumnHeaders(props, ref) {
    const { className: className } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $643961e54ef714d1$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $643961e54ef714d1$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($643961e54ef714d1$var$GridColumnHeadersRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        role: "presentation",
        ref: ref
    }));
});



const $62c7bfd9da1a99a3$var$_excluded = [
    "className",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence"
];
const $62c7bfd9da1a99a3$var$GridColumnHeaders = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridColumnHeaders(props, ref) {
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $62c7bfd9da1a99a3$var$_excluded);
    const { getInnerProps: getInnerProps, getColumnHeadersRow: getColumnHeadersRow, getColumnGroupHeadersRows: getColumnGroupHeadersRows } = (0, $23867169d133afda$export$dd7dbc7d3ee10272)({
        visibleColumns: visibleColumns,
        sortColumnLookup: sortColumnLookup,
        filterColumnLookup: filterColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $643961e54ef714d1$export$de91f7b8bf842ed8), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, other, getInnerProps(), {
        ref: ref,
        children: [
            getColumnGroupHeadersRows(),
            getColumnHeadersRow()
        ]
    }));
});
const $62c7bfd9da1a99a3$export$4a3a74c44d0a6c04 = (0, $87d1c781e22c5bac$export$fa306e0bc9a9d6b4)($62c7bfd9da1a99a3$var$GridColumnHeaders);




parcelRequire("lCzvA");





var $lCzvA = parcelRequire("lCzvA");


const $80e77b411ba96d98$var$_excluded = [
    "displayOrder"
];
const $80e77b411ba96d98$export$2ba37d64bee4cf68 = (props)=>{
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots = {}, slotProps: slotProps = {}, hideMenu: hideMenu, colDef: colDef, addDividers: addDividers = true } = props;
    const processedComponents = $lCzvA.useMemo(()=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, defaultSlots, slots), [
        defaultSlots,
        slots
    ]);
    const processedSlotProps = $lCzvA.useMemo(()=>{
        if (!slotProps || Object.keys(slotProps).length === 0) return defaultSlotProps;
        const mergedProps = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, slotProps);
        Object.entries(defaultSlotProps).forEach(([key, currentSlotProps])=>{
            mergedProps[key] = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, currentSlotProps, slotProps[key] || {});
        });
        return mergedProps;
    }, [
        defaultSlotProps,
        slotProps
    ]);
    const defaultItems = apiRef.current.unstable_applyPipeProcessors('columnMenu', [], props.colDef);
    const userItems = $lCzvA.useMemo(()=>{
        const defaultComponentKeys = Object.keys(defaultSlots);
        return Object.keys(slots).filter((key)=>!defaultComponentKeys.includes(key));
    }, [
        slots,
        defaultSlots
    ]);
    return $lCzvA.useMemo(()=>{
        const uniqueItems = Array.from(new Set([
            ...defaultItems,
            ...userItems
        ]));
        const cleansedItems = uniqueItems.filter((key)=>processedComponents[key] != null);
        const sorted = cleansedItems.sort((a, b)=>{
            const leftItemProps = processedSlotProps[a];
            const rightItemProps = processedSlotProps[b];
            const leftDisplayOrder = Number.isFinite(leftItemProps?.displayOrder) ? leftItemProps.displayOrder : 100;
            const rightDisplayOrder = Number.isFinite(rightItemProps?.displayOrder) ? rightItemProps.displayOrder : 100;
            return leftDisplayOrder - rightDisplayOrder;
        });
        return sorted.reduce((acc, key, index)=>{
            let itemProps = {
                colDef: colDef,
                onClick: hideMenu
            };
            const processedComponentProps = processedSlotProps[key];
            if (processedComponentProps) {
                const customProps = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(processedComponentProps, $80e77b411ba96d98$var$_excluded);
                itemProps = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, itemProps, customProps);
            }
            return addDividers && index !== sorted.length - 1 ? [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ],
                [
                    rootProps.slots.baseDivider,
                    {}
                ]
            ] : [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ]
            ];
        }, []);
    }, [
        addDividers,
        colDef,
        defaultItems,
        hideMenu,
        processedComponents,
        processedSlotProps,
        userItems,
        rootProps.slots.baseDivider
    ]);
};







var $lCzvA = parcelRequire("lCzvA");






const $e56eaed30221b9f2$var$_excluded = [
    "hideMenu",
    "colDef",
    "id",
    "labelledby",
    "className",
    "children",
    "open"
];
const $e56eaed30221b9f2$var$StyledMenuList = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $e6048ea6ffd35fc1$export$2e2bcd8739ae039))(()=>({
        minWidth: 248
    }));
const $e56eaed30221b9f2$export$595ece458604adc3 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridColumnMenuContainer(props, ref) {
    const { hideMenu: hideMenu, id: id, labelledby: labelledby, className: className, children: children, open: open } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $e56eaed30221b9f2$var$_excluded);
    const handleListKeyDown = $lCzvA.useCallback((event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if ((0, $23fd0e5066a0f9a3$export$81301abbcd0c8143)(event.key)) hideMenu(event);
    }, [
        hideMenu
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($e56eaed30221b9f2$var$StyledMenuList, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        id: id,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)((0, $786c119d9add6b61$export$2100d54e36406477).menuList, className),
        "aria-labelledby": labelledby,
        onKeyDown: handleListKeyDown,
        autoFocus: open
    }, other, {
        ref: ref,
        children: children
    }));
});




var $lCzvA = parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");



var $lCzvA = parcelRequire("lCzvA");









'use client';
const $192b85e1e48317c4$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $e508314fa311b36a$export$81478e24460c57f2), classes);
};
const $192b85e1e48317c4$var$ListItemIconRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $192b85e1e48317c4$var$ListItemIcon = /*#__PURE__*/ $lCzvA.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $lCzvA.useContext((0, $e08a4bc46b69b6f7$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $192b85e1e48317c4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($192b85e1e48317c4$var$ListItemIconRoot, {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $192b85e1e48317c4$export$2e2bcd8739ae039 = $192b85e1e48317c4$var$ListItemIcon;



var $lCzvA = parcelRequire("lCzvA");










'use client';
const $39ad7f5d852bd5b0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $2417c763e8493ffe$export$1061006a0db3aeb5), classes);
};
const $39ad7f5d852bd5b0$var$ListItemTextRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $2417c763e8493ffe$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $2417c763e8493ffe$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $cfa7807fac58cfaf$export$2e2bcd8739ae039).root}:where(& .${(0, $2417c763e8493ffe$export$2e2bcd8739ae039).primary})`]: {
        display: 'block'
    },
    [`.${(0, $cfa7807fac58cfaf$export$2e2bcd8739ae039).root}:where(& .${(0, $2417c763e8493ffe$export$2e2bcd8739ae039).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $39ad7f5d852bd5b0$var$ListItemText = /*#__PURE__*/ $lCzvA.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $lCzvA.useContext((0, $e08a4bc46b69b6f7$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $39ad7f5d852bd5b0$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('root', {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $39ad7f5d852bd5b0$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('primary', {
        className: classes.primary,
        elementType: (0, $52e1ac97c40de237$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('secondary', {
        className: classes.secondary,
        elementType: (0, $52e1ac97c40de237$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $52e1ac97c40de237$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $52e1ac97c40de237$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var $39ad7f5d852bd5b0$export$2e2bcd8739ae039 = $39ad7f5d852bd5b0$var$ListItemText;






function $268b17d8c42b9eeb$export$43421c0d197b(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $8b99503000dd62d3$export$16a65a9447d3dda9)(apiRef);
    const columnsWithMenu = visibleColumns.filter((col)=>col.disableColumnMenu !== true);
    // do not allow to hide the last column with menu
    const disabled = columnsWithMenu.length === 1;
    const toggleColumn = $lCzvA.useCallback((event)=>{
        /**
     * Disabled `MenuItem` would trigger `click` event
     * after imperative `.click()` call on HTML element.
     * Also, click is triggered in testing environment as well.
     */ if (disabled) return;
        apiRef.current.setColumnVisibility(colDef.field, false);
        onClick(event);
    }, [
        apiRef,
        colDef.field,
        onClick,
        disabled
    ]);
    if (rootProps.disableColumnSelector) return null;
    if (colDef.hideable === false) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
        onClick: toggleColumn,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $192b85e1e48317c4$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnMenuHideIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $39ad7f5d852bd5b0$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText('columnMenuHideColumn')
            })
        ]
    });
}



var $lCzvA = parcelRequire("lCzvA");








function $08b7287617c8f72c$export$dfc5e58327b7921f(props) {
    const { onClick: onClick } = props;
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const showColumns = $lCzvA.useCallback((event)=>{
        onClick(event); // hide column menu
        apiRef.current.showPreferences((0, $57afc8119b2eb3e6$export$e7e5652452e44b).columns);
    }, [
        apiRef,
        onClick
    ]);
    if (rootProps.disableColumnSelector) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
        onClick: showColumns,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $192b85e1e48317c4$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnMenuManageColumnsIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $39ad7f5d852bd5b0$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText('columnMenuManageColumns')
            })
        ]
    });
}



function $3b5331482f477a26$export$fee567ee855db2cc(props) {
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $268b17d8c42b9eeb$export$43421c0d197b), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props)),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $08b7287617c8f72c$export$dfc5e58327b7921f), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props))
        ]
    });
}



var $lCzvA = parcelRequire("lCzvA");







function $f6c360563eb25492$export$a4dd856446268ffe(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const showFilter = $lCzvA.useCallback((event)=>{
        onClick(event);
        apiRef.current.showFilterPanel(colDef.field);
    }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    if (rootProps.disableColumnFilter || !colDef.filterable) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
        onClick: showFilter,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $192b85e1e48317c4$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnMenuFilterIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $39ad7f5d852bd5b0$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText('columnMenuFilter')
            })
        ]
    });
}



var $lCzvA = parcelRequire("lCzvA");









function $ca38352f230d76b6$export$e58710c52f856e65(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const sortModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $32a7c18be453c9d5$export$55dcc66b73d9a0f9));
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const sortDirection = $lCzvA.useMemo(()=>{
        if (!colDef) return null;
        const sortItem = sortModel.find((item)=>item.field === colDef.field);
        return sortItem?.sort;
    }, [
        colDef,
        sortModel
    ]);
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const onSortMenuItemClick = $lCzvA.useCallback((event)=>{
        onClick(event);
        const direction = event.currentTarget.getAttribute('data-value') || null;
        apiRef.current.sortColumn(colDef.field, direction === sortDirection ? null : direction);
    }, [
        apiRef,
        colDef,
        onClick,
        sortDirection
    ]);
    if (rootProps.disableColumnSorting || !colDef || !colDef.sortable || !sortingOrder.some((item)=>!!item)) return null;
    const getLabel = (key)=>{
        const label = apiRef.current.getLocaleText(key);
        return typeof label === 'function' ? label(colDef) : label;
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            sortingOrder.includes('asc') && sortDirection !== 'asc' ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
                onClick: onSortMenuItemClick,
                "data-value": "asc",
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $192b85e1e48317c4$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnMenuSortAscendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $39ad7f5d852bd5b0$export$2e2bcd8739ae039), {
                        children: getLabel('columnMenuSortAsc')
                    })
                ]
            }) : null,
            sortingOrder.includes('desc') && sortDirection !== 'desc' ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
                onClick: onSortMenuItemClick,
                "data-value": "desc",
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $192b85e1e48317c4$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnMenuSortDescendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $39ad7f5d852bd5b0$export$2e2bcd8739ae039), {
                        children: getLabel('columnMenuSortDesc')
                    })
                ]
            }) : null,
            sortingOrder.includes(null) && sortDirection != null ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
                onClick: onSortMenuItemClick,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $192b85e1e48317c4$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $39ad7f5d852bd5b0$export$2e2bcd8739ae039), {
                        children: apiRef.current.getLocaleText('columnMenuUnsort')
                    })
                ]
            }) : null
        ]
    });
}



const $496e29ed8fef4a42$var$_excluded = [
    "defaultSlots",
    "defaultSlotProps",
    "slots",
    "slotProps"
];
const $496e29ed8fef4a42$export$5983f95fe9d3e659 = {
    columnMenuSortItem: (0, $ca38352f230d76b6$export$e58710c52f856e65),
    columnMenuFilterItem: (0, $f6c360563eb25492$export$a4dd856446268ffe),
    columnMenuColumnsItem: (0, $3b5331482f477a26$export$fee567ee855db2cc)
};
const $496e29ed8fef4a42$export$c107bd4c779cece6 = {
    columnMenuSortItem: {
        displayOrder: 10
    },
    columnMenuFilterItem: {
        displayOrder: 20
    },
    columnMenuColumnsItem: {
        displayOrder: 30
    }
};
const $496e29ed8fef4a42$export$61ffa20907ac4a8e = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridGenericColumnMenu(props, ref) {
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots, slotProps: slotProps } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $496e29ed8fef4a42$var$_excluded);
    const orderedSlots = (0, $80e77b411ba96d98$export$2ba37d64bee4cf68)((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, other, {
        defaultSlots: defaultSlots,
        defaultSlotProps: defaultSlotProps,
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e56eaed30221b9f2$export$595ece458604adc3), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, other, {
        ref: ref,
        children: orderedSlots.map(([Component, otherProps], index)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Component, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, otherProps), index))
    }));
});
const $496e29ed8fef4a42$export$53fbb13480dfeb67 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridColumnMenu(props, ref) {
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($496e29ed8fef4a42$export$61ffa20907ac4a8e, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        defaultSlots: $496e29ed8fef4a42$export$5983f95fe9d3e659,
        defaultSlotProps: $496e29ed8fef4a42$export$c107bd4c779cece6
    }));
});


function $fd16c06c6308fca4$export$aa888f5144097c35(_) {
    return null;
}


function $83a42f4a70a9b00b$export$58309d5251e10b9e(_) {
    return null;
}



parcelRequire("lCzvA");




const $73ab09af2d4d0883$export$82fb990ffc125278 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridNoResultsOverlay(props, ref) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const noResultsOverlayLabel = apiRef.current.getLocaleText('noResultsOverlayLabel');
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4acad5925f2ed490$export$1c41ff9dbe11e487), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        children: noResultsOverlayLabel
    }));
});




var $lCzvA = parcelRequire("lCzvA");





'use client';
/**
 *
 * Demos:
 *
 * - [Badge](https://mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */ function $953892cb67a6d7a9$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $45ddf447e8f3ffaf$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $953892cb67a6d7a9$export$2e2bcd8739ae039 = $953892cb67a6d7a9$var$useBadge;









function $ad5c4e762e6f0361$export$aaccef17e6dab084(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiBadge', slot);
}
const $ad5c4e762e6f0361$var$badgeClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $ad5c4e762e6f0361$export$2e2bcd8739ae039 = $ad5c4e762e6f0361$var$badgeClasses;




'use client';
const $fd45a17195ac96ef$var$RADIUS_STANDARD = 10;
const $fd45a17195ac96ef$var$RADIUS_DOT = 4;
const $fd45a17195ac96ef$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $212bca41d578456f$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $212bca41d578456f$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $212bca41d578456f$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $212bca41d578456f$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}${(0, $212bca41d578456f$export$2e2bcd8739ae039)(overlap)}`,
            `overlap${(0, $212bca41d578456f$export$2e2bcd8739ae039)(overlap)}`,
            color !== 'default' && `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $ad5c4e762e6f0361$export$aaccef17e6dab084), classes);
};
const $fd45a17195ac96ef$var$BadgeRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $fd45a17195ac96ef$var$BadgeBadge = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.anchorOrigin.vertical)}${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.anchorOrigin.horizontal)}${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $fd45a17195ac96ef$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $fd45a17195ac96ef$var$RADIUS_STANDARD * 2,
        borderRadius: $fd45a17195ac96ef$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $fd45a17195ac96ef$var$RADIUS_DOT,
                    height: $fd45a17195ac96ef$var$RADIUS_DOT * 2,
                    minWidth: $fd45a17195ac96ef$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $ad5c4e762e6f0361$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $ad5c4e762e6f0361$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $ad5c4e762e6f0361$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $ad5c4e762e6f0361$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $ad5c4e762e6f0361$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $ad5c4e762e6f0361$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $ad5c4e762e6f0361$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $ad5c4e762e6f0361$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    })));
function $fd45a17195ac96ef$var$getAnchorOrigin(anchorOrigin) {
    return {
        vertical: anchorOrigin?.vertical ?? 'top',
        horizontal: anchorOrigin?.horizontal ?? 'right'
    };
}
const $fd45a17195ac96ef$var$Badge = /*#__PURE__*/ $lCzvA.forwardRef(function Badge(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp, className: className, classes: classesProp, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard', ...other } = props;
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $953892cb67a6d7a9$export$2e2bcd8739ae039)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $45ddf447e8f3ffaf$export$2e2bcd8739ae039)({
        anchorOrigin: $fd45a17195ac96ef$var$getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = $fd45a17195ac96ef$var$getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    };
    const classes = $fd45a17195ac96ef$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const externalForwardedProps = {
        slots: {
            root: slots?.root ?? components.Root,
            badge: slots?.badge ?? components.Badge
        },
        slotProps: {
            root: slotProps?.root ?? componentsProps.root,
            badge: slotProps?.badge ?? componentsProps.badge
        }
    };
    const [RootSlot, rootProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('root', {
        elementType: $fd45a17195ac96ef$var$BadgeRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        additionalProps: {
            as: component
        }
    });
    const [BadgeSlot, badgeProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('badge', {
        elementType: $fd45a17195ac96ef$var$BadgeBadge,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.badge
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
var $fd45a17195ac96ef$export$2e2bcd8739ae039 = $fd45a17195ac96ef$var$Badge;



var $lCzvA = parcelRequire("lCzvA");





var $lCzvA = parcelRequire("lCzvA");











function $b65d0b9a821d7f51$export$baa0faa0c7ad8085(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('PrivateSwitchBase', slot);
}
const $b65d0b9a821d7f51$var$switchBaseClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $b65d0b9a821d7f51$export$2e2bcd8739ae039 = $b65d0b9a821d7f51$var$switchBaseClasses;




'use client';
const $b4841ed42c663202$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $212bca41d578456f$export$2e2bcd8739ae039)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $b65d0b9a821d7f51$export$baa0faa0c7ad8085), classes);
};
const $b4841ed42c663202$var$SwitchBaseRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $e04b8c42a017212a$export$2e2bcd8739ae039), {
    name: 'MuiSwitchBase'
})({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $b4841ed42c663202$var$SwitchBaseInput = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $be3f20df888d18ba$export$2e2bcd8739ae039)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $b4841ed42c663202$var$SwitchBase = /*#__PURE__*/ $lCzvA.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $b445d520651a750d$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $a66fe280d54e059b$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $b4841ed42c663202$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $b4841ed42c663202$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('input', {
        ref: inputRef,
        elementType: $b4841ed42c663202$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $b4841ed42c663202$export$2e2bcd8739ae039 = $b4841ed42c663202$var$SwitchBase;


parcelRequire("lCzvA");


'use client';
var $7e8129fb365a860e$export$2e2bcd8739ae039 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("lCzvA");


'use client';
var $eea5fc1ff032cdf4$export$2e2bcd8739ae039 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("lCzvA");


'use client';
var $8eba571feaf99557$export$2e2bcd8739ae039 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');






function $78ac0ac01f60f1ca$export$6c57c6e16b4063b(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiCheckbox', slot);
}
const $78ac0ac01f60f1ca$var$checkboxClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $78ac0ac01f60f1ca$export$2e2bcd8739ae039 = $78ac0ac01f60f1ca$var$checkboxClasses;









'use client';
const $10f255e39baa960a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $78ac0ac01f60f1ca$export$6c57c6e16b4063b), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $10f255e39baa960a$var$CheckboxRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $b4841ed42c663202$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $be3f20df888d18ba$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $78ac0ac01f60f1ca$export$2e2bcd8739ae039).checked}, &.${(0, $78ac0ac01f60f1ca$export$2e2bcd8739ae039).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $78ac0ac01f60f1ca$export$2e2bcd8739ae039).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $10f255e39baa960a$var$defaultCheckedIcon = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $eea5fc1ff032cdf4$export$2e2bcd8739ae039), {});
const $10f255e39baa960a$var$defaultIcon = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7e8129fb365a860e$export$2e2bcd8739ae039), {});
const $10f255e39baa960a$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8eba571feaf99557$export$2e2bcd8739ae039), {});
const $10f255e39baa960a$var$Checkbox = /*#__PURE__*/ $lCzvA.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $10f255e39baa960a$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $10f255e39baa960a$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $10f255e39baa960a$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $10f255e39baa960a$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $10f255e39baa960a$var$CheckboxRoot,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $lCzvA.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $lCzvA.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $fdb3ae459e44e4b5$export$2e2bcd8739ae039)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $10f255e39baa960a$export$2e2bcd8739ae039 = $10f255e39baa960a$var$Checkbox;



var $lCzvA = parcelRequire("lCzvA");









'use client';
const $95fad1ae25ee76fe$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $28107da7c34c37f3$export$46f01d01378ec5a2), classes);
};
const $95fad1ae25ee76fe$var$DividerRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $95fad1ae25ee76fe$var$DividerWrapper = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $95fad1ae25ee76fe$var$Divider = /*#__PURE__*/ $lCzvA.forwardRef(function Divider(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $95fad1ae25ee76fe$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($95fad1ae25ee76fe$var$DividerRoot, {
        as: component,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($95fad1ae25ee76fe$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($95fad1ae25ee76fe$var$Divider) $95fad1ae25ee76fe$var$Divider.muiSkipListHighlight = true;
var $95fad1ae25ee76fe$export$2e2bcd8739ae039 = $95fad1ae25ee76fe$var$Divider;






var $lCzvA = parcelRequire("lCzvA");
















function $f2a31385cfb1bc91$export$5a6f9035944c8119(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiButton', slot);
}
const $f2a31385cfb1bc91$var$buttonClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $f2a31385cfb1bc91$export$2e2bcd8739ae039 = $f2a31385cfb1bc91$var$buttonClasses;



var $lCzvA = parcelRequire("lCzvA");
'use client';
/**
 * @ignore - internal component.
 */ const $128988a956093c88$var$ButtonGroupContext = /*#__PURE__*/ $lCzvA.createContext({});
var $128988a956093c88$export$2e2bcd8739ae039 = $128988a956093c88$var$ButtonGroupContext;



var $lCzvA = parcelRequire("lCzvA");
'use client';
/**
 * @ignore - internal component.
 */ const $b5abc90a247f4a8f$var$ButtonGroupButtonContext = /*#__PURE__*/ $lCzvA.createContext(undefined);
var $b5abc90a247f4a8f$export$2e2bcd8739ae039 = $b5abc90a247f4a8f$var$ButtonGroupButtonContext;



'use client';
const $77d4857b04eaaf88$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $212bca41d578456f$export$2e2bcd8739ae039)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $212bca41d578456f$export$2e2bcd8739ae039)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $f2a31385cfb1bc91$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $77d4857b04eaaf88$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $77d4857b04eaaf88$var$ButtonRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $e04b8c42a017212a$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $be3f20df888d18ba$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $f2a31385cfb1bc91$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $f2a31385cfb1bc91$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $f2a31385cfb1bc91$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $f2a31385cfb1bc91$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $49e84b57c9af64ad$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $f2a31385cfb1bc91$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $f2a31385cfb1bc91$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $f2a31385cfb1bc91$export$2e2bcd8739ae039).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $77d4857b04eaaf88$var$ButtonStartIcon = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$77d4857b04eaaf88$var$commonIconStyles
        ]
    }));
const $77d4857b04eaaf88$var$ButtonEndIcon = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$77d4857b04eaaf88$var$commonIconStyles
        ]
    }));
const $77d4857b04eaaf88$var$ButtonLoadingIndicator = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $77d4857b04eaaf88$var$ButtonLoadingIconPlaceholder = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder',
    overridesResolver: (props, styles)=>styles.loadingIconPlaceholder
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $77d4857b04eaaf88$var$Button = /*#__PURE__*/ $lCzvA.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $lCzvA.useContext((0, $128988a956093c88$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $lCzvA.useContext((0, $b5abc90a247f4a8f$export$2e2bcd8739ae039));
    const resolvedProps = (0, $650cdafe9746b559$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $aa100cf7db7a0505$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $884fc2b3feb01a9d$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $77d4857b04eaaf88$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($77d4857b04eaaf88$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($77d4857b04eaaf88$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($77d4857b04eaaf88$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($77d4857b04eaaf88$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($77d4857b04eaaf88$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($77d4857b04eaaf88$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $77d4857b04eaaf88$export$2e2bcd8739ae039 = $77d4857b04eaaf88$var$Button;




var $lCzvA = parcelRequire("lCzvA");












function $970d7bd739f87df8$export$4b135a4b3a6c4550(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiInputAdornment', slot);
}
const $970d7bd739f87df8$var$inputAdornmentClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $970d7bd739f87df8$export$2e2bcd8739ae039 = $970d7bd739f87df8$var$inputAdornmentClasses;



'use client';
var $b4899c847cbf406d$var$_span;
const $b4899c847cbf406d$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $b4899c847cbf406d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $212bca41d578456f$export$2e2bcd8739ae039)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $212bca41d578456f$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $970d7bd739f87df8$export$4b135a4b3a6c4550), classes);
};
const $b4899c847cbf406d$var$InputAdornmentRoot = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $b4899c847cbf406d$var$overridesResolver
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${(0, $970d7bd739f87df8$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $970d7bd739f87df8$export$2e2bcd8739ae039).hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $b4899c847cbf406d$var$InputAdornment = /*#__PURE__*/ $lCzvA.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, $a66fe280d54e059b$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    };
    const classes = $b4899c847cbf406d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $d12eac47440c9fb8$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($b4899c847cbf406d$var$InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $52e1ac97c40de237$export$2e2bcd8739ae039), {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $b4899c847cbf406d$var$_span || ($b4899c847cbf406d$var$_span = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var $b4899c847cbf406d$export$2e2bcd8739ae039 = $b4899c847cbf406d$var$InputAdornment;



var $lCzvA = parcelRequire("lCzvA");






















function $598aa9bf4c68188b$export$837848f5f6cee923(slot) {
    return (0, $a95bed8e2ab0687e$export$2e2bcd8739ae039)('MuiTooltip', slot);
}
const $598aa9bf4c68188b$var$tooltipClasses = (0, $59c7de58ecafe5b1$export$2e2bcd8739ae039)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $598aa9bf4c68188b$export$2e2bcd8739ae039 = $598aa9bf4c68188b$var$tooltipClasses;



'use client';
function $3e121856ff0550a2$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $3e121856ff0550a2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $212bca41d578456f$export$2e2bcd8739ae039)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $598aa9bf4c68188b$export$837848f5f6cee923), classes);
};
const $3e121856ff0550a2$var$TooltipPopper = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)((0, $b20d485709a84fcd$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $3e121856ff0550a2$var$TooltipTooltip = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $212bca41d578456f$export$2e2bcd8739ae039)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$3e121856ff0550a2$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $598aa9bf4c68188b$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $3e121856ff0550a2$var$TooltipArrow = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})((0, $512deea6fb7c56fe$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $595d4f40c92954a4$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $3e121856ff0550a2$var$hystersisOpen = false;
const $3e121856ff0550a2$var$hystersisTimer = new (0, $62eeccdcf64355bb$export$786b4da70f00938b)();
let $3e121856ff0550a2$var$cursorPosition = {
    x: 0,
    y: 0
};
function $3e121856ff0550a2$export$b9ee5a7ace0541f8() {
    $3e121856ff0550a2$var$hystersisOpen = false;
    $3e121856ff0550a2$var$hystersisTimer.clear();
}
function $3e121856ff0550a2$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $3e121856ff0550a2$var$Tooltip = /*#__PURE__*/ $lCzvA.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $b2b9e9140b998a9d$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $lCzvA.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $0282d01cc0b6bcdf$export$2e2bcd8739ae039)();
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $lCzvA.useState();
    const [arrowRef, setArrowRef] = $lCzvA.useState(null);
    const ignoreNonTouchEvents = $lCzvA.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const enterTimer = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const touchTimer = (0, $62eeccdcf64355bb$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $b445d520651a750d$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $aa100cf7db7a0505$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $lCzvA.useRef();
    const stopTouchInteraction = (0, $7df3b3244211e5bc$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $lCzvA.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $3e121856ff0550a2$var$hystersisTimer.clear();
        $3e121856ff0550a2$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $7df3b3244211e5bc$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $3e121856ff0550a2$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $3e121856ff0550a2$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $3e121856ff0550a2$var$hystersisOpen && enterNextDelay) enterTimer.start($3e121856ff0550a2$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $lCzvA.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $b8633646cfbb63a5$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $b8633646cfbb63a5$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $lCzvA.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $ade5ac70196d775c$export$2e2bcd8739ae039)((0, $52e17a1723d23ff7$export$2e2bcd8739ae039)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $lCzvA.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $3e121856ff0550a2$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $3e121856ff0550a2$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $3e121856ff0550a2$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $3e121856ff0550a2$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $3e121856ff0550a2$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $lCzvA.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $3e121856ff0550a2$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('popper', {
        elementType: $3e121856ff0550a2$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $f7b874c31cbe253c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('tooltip', {
        elementType: $3e121856ff0550a2$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $ff4764e01616a70c$export$2e2bcd8739ae039)('arrow', {
        elementType: $3e121856ff0550a2$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            /*#__PURE__*/ $lCzvA.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $b20d485709a84fcd$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $3e121856ff0550a2$var$cursorPosition.y,
                            left: $3e121856ff0550a2$var$cursorPosition.x,
                            right: $3e121856ff0550a2$var$cursorPosition.x,
                            bottom: $3e121856ff0550a2$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $3e121856ff0550a2$export$2e2bcd8739ae039 = $3e121856ff0550a2$var$Tooltip;








var $lCzvA = parcelRequire("lCzvA");


const $c65ce8e0115fb675$var$_excluded = [
    "sortingOrder"
];
const $c65ce8e0115fb675$export$9e3e7f6bf3b8c7a7 = /*#__PURE__*/ $lCzvA.memo(function GridColumnHeaderSortIcon(props) {
    const { sortingOrder: sortingOrder } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $c65ce8e0115fb675$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const [nextSortDirection] = sortingOrder;
    const Icon = nextSortDirection === 'asc' ? rootProps.slots.columnSortedAscendingIcon : rootProps.slots.columnSortedDescendingIcon;
    return Icon ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Icon, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, other)) : null;
});


parcelRequire("lCzvA");


const $804785949305e6d4$export$6de472a3df735882 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
const $804785949305e6d4$export$1f2d4db4a79871d4 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');
const $804785949305e6d4$export$8da6370d9999894a = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
const $804785949305e6d4$export$5b6f85a3ddabf4ca = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
const $804785949305e6d4$export$cb1a577169e125de = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterList');
const $804785949305e6d4$export$4f4f59585ffe8deb = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAlt');
const $804785949305e6d4$export$d33e6ad54b379a5d = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');
const $804785949305e6d4$export$3c3b03774b2ed8ce = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
const $804785949305e6d4$export$7a7700ab3e9c7e95 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');
const $804785949305e6d4$export$10a5a2f68ff67c50 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), 'ColumnIcon');
const $804785949305e6d4$export$e918bd395b324de6 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
    width: "1",
    height: "24",
    x: "11.5",
    rx: "0.5"
}), 'Separator');
const $804785949305e6d4$export$3bcf566f7053b242 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), 'ViewHeadline');
const $804785949305e6d4$export$adcade5d1a52a335 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), 'TableRows');
const $804785949305e6d4$export$60a4c153d2d7b084 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), 'ViewStream');
const $804785949305e6d4$export$2fbf0de7557957a8 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'TripleDotsVertical');
const $804785949305e6d4$export$cbefef3cfb8e2783 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
const $804785949305e6d4$export$e483c1441c7fca0b = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
const $804785949305e6d4$export$d8fa92cc66e4dec8 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M19 13H5v-2h14v2z"
}), 'Remove');
const $804785949305e6d4$export$52992a9d5fa53c3c = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), 'Load');
const $804785949305e6d4$export$305773dd821bb81d = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'Drag');
const $804785949305e6d4$export$78df866ac12db1bd = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), 'SaveAlt');
const $804785949305e6d4$export$1f9ec58b2f66f46d = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
const $804785949305e6d4$export$6eaba7fcfbaac527 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');
const $804785949305e6d4$export$9267feb6a6149971 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');
const $804785949305e6d4$export$109d60d29e96616d = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
        d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
    })
}), 'ViewColumn');
const $804785949305e6d4$export$ab03f96923842ba7 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');
const $804785949305e6d4$export$4830297c7288dee4 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const $804785949305e6d4$export$fc6ef585bd0ee189 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');




parcelRequire("lCzvA");


const $6331df5b530952d0$var$_excluded = [
    "native"
];
function $6331df5b530952d0$export$2e2bcd8739ae039(_ref) {
    let { native: native } = _ref, props = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_ref, $6331df5b530952d0$var$_excluded);
    if (native) return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props));
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props));
}


const $24497f310e197927$var$iconSlots = {
    booleanCellTrueIcon: (0, $804785949305e6d4$export$1f9ec58b2f66f46d),
    booleanCellFalseIcon: (0, $804785949305e6d4$export$cbefef3cfb8e2783),
    columnMenuIcon: (0, $804785949305e6d4$export$2fbf0de7557957a8),
    openFilterButtonIcon: (0, $804785949305e6d4$export$cb1a577169e125de),
    filterPanelDeleteIcon: (0, $804785949305e6d4$export$cbefef3cfb8e2783),
    columnFilteredIcon: (0, $804785949305e6d4$export$4f4f59585ffe8deb),
    columnSelectorIcon: (0, $804785949305e6d4$export$10a5a2f68ff67c50),
    columnUnsortedIcon: (0, $c65ce8e0115fb675$export$9e3e7f6bf3b8c7a7),
    columnSortedAscendingIcon: (0, $804785949305e6d4$export$6de472a3df735882),
    columnSortedDescendingIcon: (0, $804785949305e6d4$export$1f2d4db4a79871d4),
    columnResizeIcon: (0, $804785949305e6d4$export$e918bd395b324de6),
    densityCompactIcon: (0, $804785949305e6d4$export$3bcf566f7053b242),
    densityStandardIcon: (0, $804785949305e6d4$export$adcade5d1a52a335),
    densityComfortableIcon: (0, $804785949305e6d4$export$60a4c153d2d7b084),
    exportIcon: (0, $804785949305e6d4$export$78df866ac12db1bd),
    moreActionsIcon: (0, $804785949305e6d4$export$6eaba7fcfbaac527),
    treeDataCollapseIcon: (0, $804785949305e6d4$export$5b6f85a3ddabf4ca),
    treeDataExpandIcon: (0, $804785949305e6d4$export$8da6370d9999894a),
    groupingCriteriaCollapseIcon: (0, $804785949305e6d4$export$5b6f85a3ddabf4ca),
    groupingCriteriaExpandIcon: (0, $804785949305e6d4$export$8da6370d9999894a),
    detailPanelExpandIcon: (0, $804785949305e6d4$export$e483c1441c7fca0b),
    detailPanelCollapseIcon: (0, $804785949305e6d4$export$d8fa92cc66e4dec8),
    rowReorderIcon: (0, $804785949305e6d4$export$305773dd821bb81d),
    quickFilterIcon: (0, $804785949305e6d4$export$d33e6ad54b379a5d),
    quickFilterClearIcon: (0, $804785949305e6d4$export$cbefef3cfb8e2783),
    columnMenuHideIcon: (0, $804785949305e6d4$export$9267feb6a6149971),
    columnMenuSortAscendingIcon: (0, $804785949305e6d4$export$6de472a3df735882),
    columnMenuSortDescendingIcon: (0, $804785949305e6d4$export$1f2d4db4a79871d4),
    columnMenuFilterIcon: (0, $804785949305e6d4$export$4f4f59585ffe8deb),
    columnMenuManageColumnsIcon: (0, $804785949305e6d4$export$109d60d29e96616d),
    columnMenuClearIcon: (0, $804785949305e6d4$export$ab03f96923842ba7),
    loadIcon: (0, $804785949305e6d4$export$52992a9d5fa53c3c),
    filterPanelAddIcon: (0, $804785949305e6d4$export$e483c1441c7fca0b),
    filterPanelRemoveAllIcon: (0, $804785949305e6d4$export$fc6ef585bd0ee189),
    columnReorderIcon: (0, $804785949305e6d4$export$305773dd821bb81d)
};
const $24497f310e197927$var$materialSlots = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, $24497f310e197927$var$iconSlots, {
    baseBadge: (0, $fd45a17195ac96ef$export$2e2bcd8739ae039),
    baseCheckbox: (0, $10f255e39baa960a$export$2e2bcd8739ae039),
    baseDivider: (0, $95fad1ae25ee76fe$export$2e2bcd8739ae039),
    baseTextField: (0, $892075b999ff9f5a$export$2e2bcd8739ae039),
    baseFormControl: (0, $8419414d64eb4ced$export$2e2bcd8739ae039),
    baseSelect: (0, $ae616a845ede45cb$export$2e2bcd8739ae039),
    baseButton: (0, $77d4857b04eaaf88$export$2e2bcd8739ae039),
    baseIconButton: (0, $5da5f49d148860cb$export$2e2bcd8739ae039),
    baseInputAdornment: (0, $b4899c847cbf406d$export$2e2bcd8739ae039),
    baseTooltip: (0, $3e121856ff0550a2$export$2e2bcd8739ae039),
    basePopper: (0, $b20d485709a84fcd$export$2e2bcd8739ae039),
    baseInputLabel: (0, $460e9c37f39d8a56$export$2e2bcd8739ae039),
    baseSelectOption: (0, $6331df5b530952d0$export$2e2bcd8739ae039),
    baseChip: (0, $ebde703037fa614e$export$2e2bcd8739ae039)
});
var $24497f310e197927$export$2e2bcd8739ae039 = $24497f310e197927$var$materialSlots;


const $508f9784cdf07f3d$export$8a57bda01657743f = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $24497f310e197927$export$2e2bcd8739ae039), {
    cell: (0, $c1db5f460d5608e7$export$1ce951ee41d30605),
    skeletonCell: (0, $9071b8f014cda45f$export$d922c88d466d9c21),
    columnHeaderFilterIconButton: (0, $6d6fd6931d33b865$export$35b5c67d267fafd7),
    columnHeaderSortIcon: (0, $874feb4a30eb6825$export$80cd75c5dceceac6),
    columnMenu: (0, $496e29ed8fef4a42$export$53fbb13480dfeb67),
    columnHeaders: (0, $62c7bfd9da1a99a3$export$4a3a74c44d0a6c04),
    detailPanels: (0, $fd16c06c6308fca4$export$aa888f5144097c35),
    footer: (0, $beae9ef751a574e0$export$6ef0bfefb022d11e),
    footerRowCount: (0, $2c3ed91ea8119e7b$export$b92875c9af3e0a77),
    toolbar: null,
    pinnedRows: (0, $83a42f4a70a9b00b$export$58309d5251e10b9e),
    loadingOverlay: (0, $55c38ffb599809ce$export$69e47a4ea5ffa191),
    noResultsOverlay: (0, $73ab09af2d4d0883$export$82fb990ffc125278),
    noRowsOverlay: (0, $7e7026931e18de86$export$a25f04494ce53510),
    pagination: (0, $d17e74de2202907e$export$fa9a503101f8d472),
    filterPanel: (0, $420914b7d10dd808$export$32c6e72be8ad862c),
    columnsPanel: (0, $965ffdbf820dbe98$export$39d43456ec96cf57),
    columnsManagement: (0, $d2f4164420df3c93$export$3710e0bb3d9954d),
    panel: (0, $f462924829924eb0$export$cf917897ad2588b),
    row: (0, $82bdb9ae845c8d90$export$1fc5a7f035870658)
});



parcelRequire("lCzvA");



var $lCzvA = parcelRequire("lCzvA");









function $b53912c4f5e2b074$export$aaeeda42354cd97c(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $921f9bb18367670e$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const pinColumn = $lCzvA.useCallback((side)=>(event)=>{
            apiRef.current.pinColumn(colDef.field, side);
            onClick(event);
        }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    const unpinColumn = (event)=>{
        apiRef.current.unpinColumn(colDef.field);
        onClick(event);
    };
    const pinToLeftMenuItem = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
        onClick: pinColumn((0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).LEFT),
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $192b85e1e48317c4$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnMenuPinLeftIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $39ad7f5d852bd5b0$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText('pinToLeft')
            })
        ]
    });
    const pinToRightMenuItem = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
        onClick: pinColumn((0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT),
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $192b85e1e48317c4$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnMenuPinRightIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $39ad7f5d852bd5b0$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText('pinToRight')
            })
        ]
    });
    if (!colDef) return null;
    const side = apiRef.current.isColumnPinned(colDef.field);
    if (side) {
        const otherSide = side === (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT ? (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).LEFT : (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT;
        const label = otherSide === (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT ? 'pinToRight' : 'pinToLeft';
        const Icon = side === (0, $1d134ed1d4a5dbe8$export$64f54b460f67389c).RIGHT ? rootProps.slots.columnMenuPinLeftIcon : rootProps.slots.columnMenuPinRightIcon;
        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
                    onClick: pinColumn(otherSide),
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $192b85e1e48317c4$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Icon, {
                                fontSize: "small"
                            })
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $39ad7f5d852bd5b0$export$2e2bcd8739ae039), {
                            children: apiRef.current.getLocaleText(label)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
                    onClick: unpinColumn,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $192b85e1e48317c4$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $39ad7f5d852bd5b0$export$2e2bcd8739ae039), {
                            children: apiRef.current.getLocaleText('unpin')
                        })
                    ]
                })
            ]
        });
    }
    if (isRtl) return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            pinToRightMenuItem,
            pinToLeftMenuItem
        ]
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            pinToLeftMenuItem,
            pinToRightMenuItem
        ]
    });
}



const $df5fc223ebd884e5$export$cd6960cce13e3545 = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $496e29ed8fef4a42$export$5983f95fe9d3e659), {
    columnMenuPinningItem: (0, $b53912c4f5e2b074$export$aaeeda42354cd97c)
});
const $df5fc223ebd884e5$export$6e9c8ed52623938a = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $496e29ed8fef4a42$export$c107bd4c779cece6), {
    columnMenuPinningItem: {
        displayOrder: 15
    }
});
const $df5fc223ebd884e5$export$49bc76a234ac21c2 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridProColumnMenu(props, ref) {
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $496e29ed8fef4a42$export$61ffa20907ac4a8e), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        defaultSlots: $df5fc223ebd884e5$export$cd6960cce13e3545,
        defaultSlotProps: $df5fc223ebd884e5$export$6e9c8ed52623938a,
        ref: ref
    }));
});




parcelRequire("lCzvA");







var $lCzvA = parcelRequire("lCzvA");





const $28bd269b1292b390$var$_excluded = [
    "getColumnsToRender",
    "getPinnedCellOffset",
    "renderContext",
    "leftRenderContext",
    "rightRenderContext",
    "pinnedColumns",
    "visibleColumns",
    "columnPositions"
];
const $28bd269b1292b390$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $lCzvA.useMemo(()=>{
        const slots = {
            headerFilterRow: [
                'headerFilterRow'
            ]
        };
        return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
    }, [
        classes
    ]);
};
const $28bd269b1292b390$var$filterItemsCache = Object.create(null);
const $28bd269b1292b390$export$dd7dbc7d3ee10272 = (props)=>{
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const { headerGroupingMaxDepth: headerGroupingMaxDepth, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props;
    const columnHeaderFilterTabIndexState = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $c2be356cc77cce81$export$441ae2090306a1e2));
    const _useGridColumnHeaders = (0, $23867169d133afda$export$dd7dbc7d3ee10272)((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        hasOtherElementInTabSequence: hasOtherElementInTabSequence || columnHeaderFilterTabIndexState !== null
    })), { getColumnsToRender: getColumnsToRender, getPinnedCellOffset: getPinnedCellOffset, renderContext: renderContext, leftRenderContext: leftRenderContext, rightRenderContext: rightRenderContext, pinnedColumns: pinnedColumns, visibleColumns: visibleColumns, columnPositions: columnPositions } = _useGridColumnHeaders, otherProps = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(_useGridColumnHeaders, $28bd269b1292b390$var$_excluded);
    const headerFiltersRef = $lCzvA.useRef(null);
    apiRef.current.register('private', {
        headerFiltersElementRef: headerFiltersRef
    });
    const headerFilterMenuRef = $lCzvA.useRef(null);
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const classes = $28bd269b1292b390$var$useUtilityClasses(rootProps);
    const disableHeaderFiltering = !rootProps.headerFilters;
    const filterModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$280aedb9454597a5));
    const columnsTotalWidth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$ab20f9d33edc7794));
    const gridHasFiller = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$34d7a8c547584228));
    const headerFilterHeight = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$c297d104bfb637f0));
    const scrollbarWidth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $adc18856c547b659$export$6615095b3c921727));
    const columnHeaderFilterFocus = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $c2be356cc77cce81$export$50853df99eaddaf5));
    const getFilterItem = $lCzvA.useCallback((colDef)=>{
        const filterModelItem = filterModel?.items.find((it)=>it.field === colDef.field && it.operator !== 'isAnyOf');
        if (filterModelItem != null) // there's a valid `filterModelItem` for this column
        return filterModelItem;
        const defaultCachedItem = $28bd269b1292b390$var$filterItemsCache[colDef.field];
        if (defaultCachedItem != null) // there's a cached `defaultItem` for this column
        return defaultCachedItem;
        // there's no cached `defaultItem` for this column, let's generate one and cache it
        const defaultItem = (0, $420914b7d10dd808$export$7530149911670467)(colDef);
        $28bd269b1292b390$var$filterItemsCache[colDef.field] = defaultItem;
        return defaultItem;
    }, [
        filterModel
    ]);
    const getColumnFilters = (params)=>{
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender } = getColumnsToRender(params);
        const filters = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const hasFocus = columnHeaderFilterFocus?.field === colDef.field;
            const isFirstColumn = columnIndex === 0;
            const tabIndexField = columnHeaderFilterTabIndexState?.field;
            const tabIndex = tabIndexField === colDef.field || isFirstColumn && !props.hasOtherElementInTabSequence ? 0 : -1;
            const headerClassName = typeof colDef.headerClassName === 'function' ? colDef.headerClassName({
                field: colDef.field,
                colDef: colDef
            }) : colDef.headerClassName;
            const item = getFilterItem(colDef);
            const pinnedPosition = params?.position;
            const pinnedOffset = getPinnedCellOffset(pinnedPosition, colDef.computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            const indexInSection = i;
            const sectionLength = renderedColumns.length;
            const showLeftBorder = (0, $aefb3468131f4e39$export$c01fd18a9a3d03b3)(pinnedPosition, indexInSection);
            const showRightBorder = (0, $aefb3468131f4e39$export$646c95cff4790794)(pinnedPosition, indexInSection, sectionLength, rootProps.showColumnVerticalBorder, gridHasFiller);
            filters.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.headerFilterCell, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                colIndex: columnIndex,
                height: headerFilterHeight,
                width: colDef.computedWidth,
                colDef: colDef,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                headerFilterMenuRef: headerFilterMenuRef,
                headerClassName: headerClassName,
                "data-field": colDef.field,
                item: item,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                showLeftBorder: showLeftBorder,
                showRightBorder: showRightBorder
            }, rootProps.slotProps?.headerFilterCell), `${colDef.field}-filter`));
        }
        return otherProps.getFillers(params, filters, 0, true);
    };
    const getColumnFiltersRow = ()=>{
        if (disableHeaderFiltering) return null;
        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $23867169d133afda$export$7b391e1fd04597c4), {
            ref: headerFiltersRef,
            className: classes.headerFilterRow,
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 2,
            ownerState: rootProps,
            children: [
                leftRenderContext && getColumnFilters({
                    position: (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT,
                    renderContext: leftRenderContext,
                    maxLastColumn: leftRenderContext.lastColumnIndex
                }),
                getColumnFilters({
                    renderContext: renderContext,
                    maxLastColumn: visibleColumns.length - pinnedColumns.right.length
                }),
                rightRenderContext && getColumnFilters({
                    position: (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT,
                    renderContext: rightRenderContext,
                    maxLastColumn: rightRenderContext.lastColumnIndex
                })
            ]
        });
    };
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, otherProps, {
        getColumnFiltersRow: getColumnFiltersRow
    });
};



const $ccc7b6fce3774a3e$var$_excluded = [
    "style",
    "className",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence"
];
const $ccc7b6fce3774a3e$var$Filler = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div')({
    flex: 1,
    backgroundColor: 'var(--DataGrid-containerBackground)'
});
const $ccc7b6fce3774a3e$export$4a3a74c44d0a6c04 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridColumnHeaders(props, ref) {
    const { className: className, visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $ccc7b6fce3774a3e$var$_excluded);
    const { getInnerProps: getInnerProps, getColumnHeadersRow: getColumnHeadersRow, getColumnFiltersRow: getColumnFiltersRow, getColumnGroupHeadersRows: getColumnGroupHeadersRows } = (0, $28bd269b1292b390$export$dd7dbc7d3ee10272)({
        visibleColumns: visibleColumns,
        sortColumnLookup: sortColumnLookup,
        filterColumnLookup: filterColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $643961e54ef714d1$export$de91f7b8bf842ed8), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: className
    }, other, getInnerProps(), {
        ref: ref,
        children: [
            getColumnGroupHeadersRows(),
            getColumnHeadersRow(),
            getColumnFiltersRow(),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($ccc7b6fce3774a3e$var$Filler, {})
        ]
    }));
});




var $lCzvA = parcelRequire("lCzvA");






function $a4eb13e7860c59bd$export$5d70bc2c3a60b060({ open: open, field: field, target: target, applyFilterChanges: applyFilterChanges, operators: operators, item: item, id: id, labelledBy: labelledBy }) {
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const hideMenu = $lCzvA.useCallback(()=>{
        apiRef.current.hideHeaderFilterMenu();
    }, [
        apiRef
    ]);
    const handleListKeyDown = $lCzvA.useCallback((event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if (event.key === 'Escape' || event.key === 'Tab') hideMenu();
    }, [
        hideMenu
    ]);
    if (!target) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $eff079abbf7a8831$export$237948c71948075), {
        placement: "bottom-end",
        open: open,
        target: target,
        onClose: hideMenu,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e6048ea6ffd35fc1$export$2e2bcd8739ae039), {
            "aria-labelledby": labelledBy,
            id: id,
            onKeyDown: handleListKeyDown,
            children: operators.map((op, i)=>{
                const label = op?.headerLabel ?? apiRef.current.getLocaleText(`headerFilterOperator${(0, $c4ab204d748cb214$export$2e2bcd8739ae039)(op.value)}`);
                return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        applyFilterChanges((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, item, {
                            operator: op.value
                        }));
                        hideMenu();
                    },
                    autoFocus: i === 0 ? open : false,
                    selected: op.value === item.operator,
                    children: label
                }, `${field}-${op.value}`);
            })
        })
    });
}





var $lCzvA = parcelRequire("lCzvA");












var $lCzvA = parcelRequire("lCzvA");






const $24befb43311a61ff$var$_excluded = [
    "operators",
    "item",
    "field",
    "buttonRef",
    "headerFilterMenuRef",
    "disabled"
];
const $24befb43311a61ff$var$sx = {
    width: 22,
    height: 22,
    margin: 'auto 0 10px 5px'
};
function $24befb43311a61ff$export$9b7bd6eff38238f5(props) {
    const { operators: operators, item: item, field: field, buttonRef: buttonRef, headerFilterMenuRef: headerFilterMenuRef, disabled: disabled = false } = props, others = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $24befb43311a61ff$var$_excluded);
    const buttonId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const menuId = (0, $5b02eb5f110ae73e$export$2e2bcd8739ae039)();
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $7782d7e95102f01f$export$2d14edd3a7db3bbf)();
    const menuOpenField = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $2ea7877c1ac6621b$export$c564e60305059ea4));
    const open = Boolean(menuOpenField === field && headerFilterMenuRef.current);
    const handleClick = (event)=>{
        headerFilterMenuRef.current = event.currentTarget;
        apiRef.current.showHeaderFilterMenu(field);
    };
    if (!rootProps.slots.headerFilterMenu) return null;
    const label = apiRef.current.getLocaleText('filterPanelOperator');
    const labelString = label ? String(label) : undefined;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                id: buttonId,
                ref: buttonRef,
                "aria-label": labelString,
                title: labelString,
                "aria-controls": menuId,
                "aria-expanded": open ? 'true' : undefined,
                "aria-haspopup": "true",
                tabIndex: -1,
                size: "small",
                onClick: handleClick,
                sx: $24befb43311a61ff$var$sx,
                disabled: disabled
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.openFilterButtonIcon, {
                    fontSize: "small"
                })
            })),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.headerFilterMenu, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                field: field,
                open: open,
                item: item,
                target: headerFilterMenuRef.current,
                operators: operators,
                labelledBy: buttonId,
                id: menuId
            }, others))
        ]
    });
}



parcelRequire("lCzvA");


const $828b755d84f74e0a$var$sx = {
    padding: '2px'
};
function $828b755d84f74e0a$export$a92783e4bfd82db8(props) {
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        tabIndex: -1,
        "aria-label": "Clear filter",
        size: "small",
        sx: $828b755d84f74e0a$var$sx
    }, props, rootProps.slotProps?.baseIconButton, {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.columnMenuClearIcon, {
            fontSize: "inherit"
        })
    }));
}



const $1aef3e6c622ba0e2$var$_excluded = [
    "colIndex",
    "height",
    "hasFocus",
    "width",
    "headerClassName",
    "colDef",
    "item",
    "headerFilterMenuRef",
    "InputComponentProps",
    "showClearIcon",
    "pinnedPosition",
    "pinnedOffset",
    "style",
    "showLeftBorder",
    "showRightBorder"
];
const $1aef3e6c622ba0e2$var$useUtilityClasses = (ownerState)=>{
    const { colDef: colDef, classes: classes, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, pinnedPosition: pinnedPosition } = ownerState;
    const slots = {
        root: [
            'columnHeader',
            colDef.headerAlign === 'left' && 'columnHeader--alignLeft',
            colDef.headerAlign === 'center' && 'columnHeader--alignCenter',
            colDef.headerAlign === 'right' && 'columnHeader--alignRight',
            'withBorderColor',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === (0, $3cb6fcdeb46bf88d$export$f35946017bbd5a24).RIGHT && 'columnHeader--pinnedRight'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $1aef3e6c622ba0e2$var$emptyFieldSx = {
    [`& input[value=""]:not(:focus)`]: {
        color: 'transparent'
    }
};
const $1aef3e6c622ba0e2$var$defaultInputComponents = {
    string: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3),
    number: (0, $a29e5f5322899b2f$export$99d1f108a3f21b3),
    date: (0, $2598061dcf03cb39$export$f82b14e11ca0a1b4),
    dateTime: (0, $2598061dcf03cb39$export$f82b14e11ca0a1b4),
    boolean: (0, $2e7152d572a591e3$export$f1030df85ee00af9),
    singleSelect: (0, $e04d221b2cfecedf$export$760eb819dd95d361),
    actions: null,
    custom: null
};
const $1aef3e6c622ba0e2$var$GridHeaderFilterCell = (0, $74efa9d8b826b453$export$257a8862b851cb5b)((props, ref)=>{
    const { colIndex: colIndex, height: height, hasFocus: hasFocus, width: width, headerClassName: headerClassName, colDef: colDef, item: item, headerFilterMenuRef: headerFilterMenuRef, InputComponentProps: InputComponentProps, showClearIcon: showClearIcon = true, pinnedPosition: pinnedPosition, pinnedOffset: pinnedOffset, style: styleProp, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $1aef3e6c622ba0e2$var$_excluded);
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const isRtl = (0, $2a711d8e80e02076$export$b2dd014b6c321cb)();
    const columnFields = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$c9491722e1d6e8d3));
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const cellRef = $lCzvA.useRef(null);
    const handleRef = (0, $78465f04bf272330$export$2e2bcd8739ae039)(ref, cellRef);
    const inputRef = $lCzvA.useRef(null);
    const buttonRef = $lCzvA.useRef(null);
    const editingField = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $2ea7877c1ac6621b$export$d5104e3dccc7c49d));
    const isEditing = editingField === colDef.field;
    const menuOpenField = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $2ea7877c1ac6621b$export$c564e60305059ea4));
    const isMenuOpen = menuOpenField === colDef.field;
    // TODO: Support for `isAnyOf` operator
    const filterOperators = $lCzvA.useMemo(()=>{
        if (!colDef.filterOperators) return [];
        return colDef.filterOperators.filter((operator)=>operator.value !== 'isAnyOf');
    }, [
        colDef.filterOperators
    ]);
    const filterModel = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$280aedb9454597a5));
    const filterableColumnsLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$e84218276cc24419));
    const isFilterReadOnly = $lCzvA.useMemo(()=>{
        if (!filterModel?.items.length) return false;
        const filterModelItem = filterModel.items.find((it)=>it.field === colDef.field);
        return filterModelItem ? !filterableColumnsLookup[filterModelItem.field] : false;
    }, [
        colDef.field,
        filterModel,
        filterableColumnsLookup
    ]);
    const currentOperator = $lCzvA.useMemo(()=>filterOperators.find((operator)=>operator.value === item.operator) ?? filterOperators[0], [
        item.operator,
        filterOperators
    ]);
    const InputComponent = colDef.filterable || isFilterReadOnly ? currentOperator.InputComponent ?? $1aef3e6c622ba0e2$var$defaultInputComponents[colDef.type] : null;
    const clearFilterItem = $lCzvA.useCallback(()=>{
        apiRef.current.deleteFilterItem(item);
    }, [
        apiRef,
        item
    ]);
    let headerFilterComponent;
    if (colDef.renderHeaderFilter) headerFilterComponent = colDef.renderHeaderFilter((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, props, {
        inputRef: inputRef
    }));
    $lCzvA.useLayoutEffect(()=>{
        if (hasFocus && !isMenuOpen) {
            let focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            if (isEditing && InputComponent) focusableElement = inputRef.current;
            const elementToFocus = focusableElement || cellRef.current;
            const scrollPosition = apiRef.current.getScrollPosition();
            elementToFocus?.focus();
            apiRef.current.scroll(scrollPosition);
        }
    }, [
        InputComponent,
        apiRef,
        hasFocus,
        isEditing,
        isMenuOpen
    ]);
    const onKeyDown = $lCzvA.useCallback((event)=>{
        if (isMenuOpen || (0, $23fd0e5066a0f9a3$export$e13d96c38a470518)(event.key) || isFilterReadOnly) return;
        switch(event.key){
            case 'Escape':
                if (isEditing) apiRef.current.stopHeaderFilterEditMode();
                break;
            case 'Enter':
                if (isEditing) {
                    if (!event.defaultPrevented) {
                        apiRef.current.stopHeaderFilterEditMode();
                        break;
                    }
                }
                if (event.metaKey || event.ctrlKey) {
                    headerFilterMenuRef.current = buttonRef.current;
                    apiRef.current.showHeaderFilterMenu(colDef.field);
                    break;
                }
                apiRef.current.startHeaderFilterEditMode(colDef.field);
                break;
            case 'Tab':
                if (isEditing) {
                    const fieldToFocus = columnFields[colIndex + (event.shiftKey ? -1 : 1)] ?? null;
                    if (fieldToFocus) {
                        apiRef.current.startHeaderFilterEditMode(fieldToFocus);
                        apiRef.current.setColumnHeaderFilterFocus(fieldToFocus, event);
                    }
                }
                break;
            default:
                if (isEditing || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) break;
                apiRef.current.startHeaderFilterEditMode(colDef.field);
                break;
        }
    }, [
        apiRef,
        colDef.field,
        colIndex,
        columnFields,
        headerFilterMenuRef,
        isEditing,
        isFilterReadOnly,
        isMenuOpen
    ]);
    const publish = $lCzvA.useCallback((eventName, propHandler)=>(event)=>{
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        colDef.field
    ]);
    const onMouseDown = $lCzvA.useCallback((event)=>{
        if (!hasFocus) {
            if (inputRef.current?.contains?.(event.target)) inputRef.current.focus();
            apiRef.current.setColumnHeaderFilterFocus(colDef.field, event);
        }
    }, [
        apiRef,
        colDef.field,
        hasFocus
    ]);
    const mouseEventsHandlers = $lCzvA.useMemo(()=>({
            onKeyDown: publish('headerFilterKeyDown', onKeyDown),
            onClick: publish('headerFilterClick'),
            onMouseDown: publish('headerFilterMouseDown', onMouseDown),
            onBlur: publish('headerFilterBlur')
        }), [
        onMouseDown,
        onKeyDown,
        publish
    ]);
    const ownerState = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, rootProps, {
        pinnedPosition: pinnedPosition,
        colDef: colDef,
        showLeftBorder: showLeftBorder,
        showRightBorder: showRightBorder
    });
    const classes = $1aef3e6c622ba0e2$var$useUtilityClasses(ownerState);
    const isNoInputOperator = currentOperator.requiresFilterValue === false;
    const isApplied = item?.value !== undefined || isNoInputOperator;
    const label = currentOperator.headerLabel ?? apiRef.current.getLocaleText(`headerFilterOperator${(0, $c4ab204d748cb214$export$2e2bcd8739ae039)(item.operator)}`);
    const isFilterActive = isApplied || hasFocus;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, headerClassName),
        style: (0, $39179d3e4e328cf6$export$175ada5333288b48)((0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            height: height,
            width: width
        }, styleProp), isRtl, pinnedPosition, pinnedOffset),
        role: "columnheader",
        "aria-colindex": colIndex + 1,
        "aria-label": headerFilterComponent == null ? colDef.headerName ?? colDef.field : undefined
    }, other, mouseEventsHandlers, {
        ref: handleRef,
        children: [
            headerFilterComponent,
            InputComponent && headerFilterComponent === undefined ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($lCzvA.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(InputComponent, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
                        apiRef: apiRef,
                        item: item,
                        inputRef: inputRef,
                        applyValue: apiRef.current.upsertFilterItem,
                        onFocus: ()=>apiRef.current.startHeaderFilterEditMode(colDef.field),
                        onBlur: (event)=>{
                            apiRef.current.stopHeaderFilterEditMode();
                            // Blurring an input element should reset focus state only if `relatedTarget` is not the header filter cell
                            if (!event.relatedTarget?.className.includes('columnHeader')) apiRef.current.setState((state)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, state, {
                                    focus: {
                                        cell: null,
                                        columnHeader: null,
                                        columnHeaderFilter: null,
                                        columnGroupHeader: null
                                    }
                                }));
                        },
                        label: (0, $c4ab204d748cb214$export$2e2bcd8739ae039)(label),
                        placeholder: "",
                        isFilterActive: isFilterActive,
                        clearButton: showClearIcon && isApplied ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $828b755d84f74e0a$export$a92783e4bfd82db8), {
                            onClick: clearFilterItem,
                            disabled: isFilterReadOnly
                        }) : null,
                        disabled: isFilterReadOnly || isNoInputOperator,
                        tabIndex: -1,
                        InputLabelProps: null,
                        sx: colDef.type === 'date' || colDef.type === 'dateTime' || colDef.type === 'number' ? $1aef3e6c622ba0e2$var$emptyFieldSx : undefined
                    }, isNoInputOperator ? {
                        value: ''
                    } : {}, currentOperator?.InputComponentProps, InputComponentProps)),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $24befb43311a61ff$export$9b7bd6eff38238f5), {
                        operators: filterOperators,
                        item: item,
                        field: colDef.field,
                        disabled: isFilterReadOnly,
                        applyFilterChanges: apiRef.current.upsertFilterItem,
                        headerFilterMenuRef: headerFilterMenuRef,
                        buttonRef: buttonRef
                    })
                ]
            }) : null
        ]
    }));
});
const $1aef3e6c622ba0e2$export$16e397805e5e4138 = (0, $87d1c781e22c5bac$export$fa306e0bc9a9d6b4)($1aef3e6c622ba0e2$var$GridHeaderFilterCell);



var $lCzvA = parcelRequire("lCzvA");







var $lCzvA = parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");

const $a11916447ae978e6$var$isDevEnvironment = false;
const $a11916447ae978e6$var$noop = ()=>{};
function $a11916447ae978e6$export$683480f191c0e3ea(ref, fn, enabled) {
    const fnRef = $lCzvA.useRef(null);
    fnRef.current = fn;
    (0, $d30dafbde976b8f5$export$2e2bcd8739ae039)(()=>{
        if (enabled === false || typeof ResizeObserver === 'undefined') return $a11916447ae978e6$var$noop;
        let frameID = 0;
        const target = ref.current;
        const observer = new ResizeObserver((entries)=>{
            // See https://github.com/mui/mui-x/issues/8733
            // In dev, we avoid the React warning by moving the task to the next frame.
            // In prod, we want the task to run in the same frame as to avoid tear.
            if ($a11916447ae978e6$var$isDevEnvironment) frameID = requestAnimationFrame(()=>{
                fnRef.current(entries);
            });
            else fnRef.current(entries);
        });
        if (target) observer.observe(target);
        return ()=>{
            if (frameID) cancelAnimationFrame(frameID);
            observer.disconnect();
        };
    }, [
        ref,
        enabled
    ]);
}





'use client';
const $7cf5188adf2946d5$var$DetailPanel = (0, $e2a5d83e778e073b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'DetailPanel',
    overridesResolver: (props, styles)=>styles.detailPanel
})(({ theme: theme })=>({
        width: 'calc(var(--DataGrid-rowWidth) - var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))',
        backgroundColor: (theme.vars || theme).palette.background.default,
        overflow: 'auto'
    }));
function $7cf5188adf2946d5$export$904faaa9b81e46ab(props) {
    const { rowId: rowId, height: height, className: className, children: children } = props;
    const apiRef = (0, $63cda09cd66be3ca$export$e1fd9274eb96ee18)();
    const ref = $lCzvA.useRef(null);
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const ownerState = rootProps;
    const hasAutoHeight = height === 'auto';
    $lCzvA.useLayoutEffect(()=>{
        if (hasAutoHeight && typeof ResizeObserver === 'undefined') // Fallback for IE
        apiRef.current.storeDetailPanelHeight(rowId, ref.current.clientHeight);
    }, [
        apiRef,
        hasAutoHeight,
        rowId
    ]);
    (0, $a11916447ae978e6$export$683480f191c0e3ea)(ref, (entries)=>{
        const [entry] = entries;
        const observedHeight = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
        apiRef.current.storeDetailPanelHeight(rowId, observedHeight);
    }, hasAutoHeight);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($7cf5188adf2946d5$var$DetailPanel, {
        ref: ref,
        ownerState: ownerState,
        role: "presentation",
        style: {
            height: height
        },
        className: className,
        children: children
    });
}



'use client';
const $3c314c111aecd137$var$useUtilityClasses = ()=>{
    const slots = {
        detailPanel: [
            'detailPanel'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), {});
};
function $3c314c111aecd137$export$aa888f5144097c35(props) {
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    if (!rootProps.getDetailPanelContent) return null;
    return /*#__PURE__*/ $lCzvA.createElement($3c314c111aecd137$var$GridDetailPanelsImpl, props);
}
function $3c314c111aecd137$var$GridDetailPanelsImpl({ virtualScroller: virtualScroller }) {
    const apiRef = (0, $63cda09cd66be3ca$export$e1fd9274eb96ee18)();
    const classes = $3c314c111aecd137$var$useUtilityClasses();
    const { setPanels: setPanels } = virtualScroller;
    const expandedRowIds = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $05ba1f7c9f586710$export$2e51858b6eeff6ad));
    const detailPanelsContent = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $05ba1f7c9f586710$export$16fba932632c70f0));
    const detailPanelsHeights = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $05ba1f7c9f586710$export$f8466bb36c8b9813));
    const getDetailPanel = $lCzvA.useCallback((rowId)=>{
        const content = detailPanelsContent[rowId];
        // Check if the id exists in the current page
        const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
        const exists = rowIndex !== undefined;
        if (!/*#__PURE__*/ $lCzvA.isValidElement(content) || !exists) return null;
        const hasAutoHeight = apiRef.current.detailPanelHasAutoHeight(rowId);
        const height = hasAutoHeight ? 'auto' : detailPanelsHeights[rowId];
        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7cf5188adf2946d5$export$904faaa9b81e46ab), {
            rowId: rowId,
            height: height,
            className: classes.detailPanel,
            children: content
        }, `panel-${rowId}`);
    }, [
        apiRef,
        classes.detailPanel,
        detailPanelsHeights,
        detailPanelsContent
    ]);
    $lCzvA.useEffect(()=>{
        if (expandedRowIds.length === 0) setPanels((0, $2b0e72b73973ab3a$export$68a3509179402d90));
        else setPanels(new Map(expandedRowIds.map((rowId)=>[
                rowId,
                getDetailPanel(rowId)
            ])));
    }, [
        expandedRowIds,
        setPanels,
        getDetailPanel
    ]);
    return null;
}



var $lCzvA = parcelRequire("lCzvA");





const $a13d82e9c86e4664$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'pinnedRows'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), {});
};
function $a13d82e9c86e4664$export$58309d5251e10b9e({ position: position, virtualScroller: virtualScroller }) {
    const classes = $a13d82e9c86e4664$var$useUtilityClasses();
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const pinnedRowsData = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$ffe7071c481e32b0));
    const rows = pinnedRowsData[position];
    const pinnedRenderContext = $lCzvA.useMemo(()=>({
            firstRowIndex: 0,
            lastRowIndex: rows.length,
            firstColumnIndex: -1,
            lastColumnIndex: -1
        }), [
        rows
    ]);
    if (rows.length === 0) return null;
    const pinnedRows = virtualScroller.getRows({
        position: position,
        rows: rows,
        renderContext: pinnedRenderContext
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, (0, $786c119d9add6b61$export$2100d54e36406477)[`pinnedRows--${position}`]),
        role: "presentation",
        children: pinnedRows
    });
}



parcelRequire("lCzvA");


const $d96d94c48d1cf5fe$export$8bcde6e7c950b7bb = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
    transform: "rotate(-30 15 10)",
    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
        d: "M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z",
        fillRule: "evenodd"
    })
}), 'PushPinRight');
const $d96d94c48d1cf5fe$export$934f0393007cf804 = (0, $488bd136de508705$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
    transform: "rotate(30 8 12)",
    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
        d: "M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z",
        fillRule: "evenodd"
    })
}), 'PushPinLeft');


const $41a9a4ea8e30301a$var$iconSlots = {
    columnMenuPinRightIcon: (0, $d96d94c48d1cf5fe$export$8bcde6e7c950b7bb),
    columnMenuPinLeftIcon: (0, $d96d94c48d1cf5fe$export$934f0393007cf804)
};
const $41a9a4ea8e30301a$var$materialSlots = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, $41a9a4ea8e30301a$var$iconSlots);
var $41a9a4ea8e30301a$export$2e2bcd8739ae039 = $41a9a4ea8e30301a$var$materialSlots;


const $1bdf1d5359289610$export$c14e35b3658b0aa7 = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $508f9784cdf07f3d$export$8a57bda01657743f), (0, $41a9a4ea8e30301a$export$2e2bcd8739ae039), {
    columnMenu: (0, $df5fc223ebd884e5$export$49bc76a234ac21c2),
    columnHeaders: (0, $ccc7b6fce3774a3e$export$4a3a74c44d0a6c04),
    detailPanels: (0, $3c314c111aecd137$export$aa888f5144097c35),
    headerFilterCell: (0, $1aef3e6c622ba0e2$export$16e397805e5e4138),
    headerFilterMenu: (0, $a4eb13e7860c59bd$export$5d70bc2c3a60b060),
    pinnedRows: (0, $a13d82e9c86e4664$export$58309d5251e10b9e)
});


const $766d6c001ee687f4$var$getDataGridProForcedProps = (themedProps)=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        signature: 'DataGridPro'
    }, themedProps.unstable_dataSource ? {
        filterMode: 'server',
        sortingMode: 'server',
        paginationMode: 'server'
    } : {});
const $766d6c001ee687f4$export$ebb4682394199754 = (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $270da21e92ce0d1d$export$2733e0e1a1d288e7), {
    autosizeOnMount: false,
    defaultGroupingExpansionDepth: 0,
    disableAutosize: false,
    disableChildrenFiltering: false,
    disableChildrenSorting: false,
    disableColumnPinning: false,
    getDetailPanelHeight: ()=>500,
    headerFilters: false,
    keepColumnPositionIfDraggedOutside: false,
    rowSelectionPropagation: (0, $a66aee8d09f3916c$export$aec8936a41d479a2),
    rowReordering: false,
    rowsLoadingMode: 'client',
    scrollEndThreshold: 80,
    treeData: false,
    unstable_listView: false
});
const $766d6c001ee687f4$var$defaultSlots = (0, $1bdf1d5359289610$export$c14e35b3658b0aa7);
const $766d6c001ee687f4$export$decfffa8129564f4 = (inProps)=>{
    const theme = (0, $0282d01cc0b6bcdf$export$2e2bcd8739ae039)();
    const themedProps = (0, $50a5a4041c3966d9$export$1f264be2c424fccf)($lCzvA.useMemo(()=>(0, $56b13c9b7d49b307$export$2e2bcd8739ae039)({
            props: inProps,
            theme: theme,
            name: 'MuiDataGrid'
        }), [
        theme,
        inProps
    ]));
    const localeText = $lCzvA.useMemo(()=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, (0, $5128c3fdbbfd0415$export$d217cc4e11b3c706), themedProps.localeText), [
        themedProps.localeText
    ]);
    const slots = $lCzvA.useMemo(()=>(0, $4d469ca6d8b0c2a7$export$247af54f7c54fca)({
            defaultSlots: $766d6c001ee687f4$var$defaultSlots,
            slots: themedProps.slots
        }), [
        themedProps.slots
    ]);
    return $lCzvA.useMemo(()=>(0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, $766d6c001ee687f4$export$ebb4682394199754, themedProps, {
            localeText: localeText,
            slots: slots
        }, $766d6c001ee687f4$var$getDataGridProForcedProps(themedProps)), [
        themedProps,
        localeText,
        slots
    ]);
};



const $83e067d9acb5bf94$export$edcd7d0b4c3818f = ()=>{
    const releaseInfo = "MTc3NzMyNzIwMDAwMA==";
    return releaseInfo;
};












const $438f72d1b1f0e432$export$89716d1110d32214 = ()=>{
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8b99503000dd62d3$export$16a65a9447d3dda9));
    const accessibleRowCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$96919017bbfaec0d));
    const headerGroupingMaxDepth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8590d748d071bb9f$export$4cf0369c079b29be));
    const pinnedRowsCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $68327dddce1a2c68$export$8e3fb3525d7db988));
    return {
        role: 'grid',
        'aria-colcount': visibleColumns.length,
        'aria-rowcount': headerGroupingMaxDepth + 1 + pinnedRowsCount + accessibleRowCount,
        'aria-multiselectable': (0, $a66aee8d09f3916c$export$cfcdc2e1121f7851)(rootProps)
    };
};



const $a2477c157c531124$export$89716d1110d32214 = ()=>{
    const ariaAttributesCommunity = (0, $438f72d1b1f0e432$export$89716d1110d32214)();
    const rootProps = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const ariaAttributesPro = rootProps.treeData ? {
        role: 'treegrid'
    } : {};
    return (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({}, ariaAttributesCommunity, ariaAttributesPro);
};



var $lCzvA = parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");




const $85b40222b5a28a07$export$c27cdb450c323320 = ()=>{
    const apiRef = (0, $83c1dc7f69a15312$export$e1fd9274eb96ee18)();
    const selectedIdsLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $0bfb640e213a706f$export$d5aede24ebfe3c98));
    const headerGroupingMaxDepth = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $8590d748d071bb9f$export$4cf0369c079b29be));
    return $lCzvA.useCallback((rowNode, index)=>{
        const ariaAttributes = {};
        const ariaRowIndex = index + headerGroupingMaxDepth + 2; // 1 for the header row and 1 as it's 1-based
        ariaAttributes['aria-rowindex'] = ariaRowIndex;
        if (apiRef.current.isRowSelectable(rowNode.id)) ariaAttributes['aria-selected'] = selectedIdsLookup[rowNode.id] !== undefined;
        return ariaAttributes;
    }, [
        apiRef,
        selectedIdsLookup,
        headerGroupingMaxDepth
    ]);
};




const $6b8e344d13c38d9f$export$c27cdb450c323320 = (addTreeDataAttributes)=>{
    const apiRef = (0, $63cda09cd66be3ca$export$e1fd9274eb96ee18)();
    const props = (0, $f77ecd984229db9c$export$8b0f8e71b71b7ed3)();
    const getRowAriaAttributesCommunity = (0, $85b40222b5a28a07$export$c27cdb450c323320)();
    const filteredTopLevelRowCount = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$f88efd30675963d1));
    const filteredChildrenCountLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$5f10eab80a0f79a0));
    const sortedVisibleRowPositionsLookup = (0, $1e10d601c15466d4$export$f96fd476863f2e4a)(apiRef, (0, $6450fc0917754b27$export$a77377d29742e9a9));
    return $lCzvA.useCallback((rowNode, index)=>{
        const ariaAttributes = getRowAriaAttributesCommunity(rowNode, index);
        if (rowNode === null || !(props.treeData || addTreeDataAttributes)) return ariaAttributes;
        // pinned and footer rows are not part of the rowgroup and should not get the set specific aria attributes
        if (rowNode.type === 'footer' || rowNode.type === 'pinnedRow') return ariaAttributes;
        ariaAttributes['aria-level'] = rowNode.depth + 1;
        const filteredChildrenCount = filteredChildrenCountLookup[rowNode.id] ?? 0;
        // aria-expanded should only be added to the rows that contain children
        if (rowNode.type === 'group' && filteredChildrenCount > 0) ariaAttributes['aria-expanded'] = Boolean(rowNode.childrenExpanded);
        // if the parent is null, set size and position cannot be determined
        if (rowNode.parent !== null) {
            ariaAttributes['aria-setsize'] = rowNode.parent === (0, $dc4fe3453cdb0a0a$export$433b924dc2506913) ? filteredTopLevelRowCount : filteredChildrenCountLookup[rowNode.parent];
            ariaAttributes['aria-posinset'] = sortedVisibleRowPositionsLookup[rowNode.id];
        }
        return ariaAttributes;
    }, [
        props.treeData,
        addTreeDataAttributes,
        filteredTopLevelRowCount,
        filteredChildrenCountLookup,
        sortedVisibleRowPositionsLookup,
        getRowAriaAttributesCommunity
    ]);
};



'use client';
const $3b503324b5e9400d$var$configuration = {
    hooks: {
        useGridAriaAttributes: $a2477c157c531124$export$89716d1110d32214,
        useGridRowAriaAttributes: $6b8e344d13c38d9f$export$c27cdb450c323320,
        useCellAggregationResult: ()=>null
    }
};
const $3b503324b5e9400d$var$releaseInfo = (0, $83e067d9acb5bf94$export$edcd7d0b4c3818f)();
const $3b503324b5e9400d$var$watermark = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $5d16e7c1dddc1ca7$export$e94943a72132ebdf), {
    packageName: "x-data-grid-pro",
    releaseInfo: $3b503324b5e9400d$var$releaseInfo
});
const $3b503324b5e9400d$var$DataGridProRaw = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function DataGridPro(inProps, ref) {
    const props = (0, $766d6c001ee687f4$export$decfffa8129564f4)(inProps);
    const privateApiRef = (0, $c44a5aa9bb3097e6$export$ae01925210967ff3)(props.apiRef, props);
    (0, $c865da14b16314cd$export$bd780281ba7bfd9)('x-data-grid-pro', $3b503324b5e9400d$var$releaseInfo);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $954070ecf847201e$export$4fd26c08a15cabb4), {
        privateApiRef: privateApiRef,
        configuration: $3b503324b5e9400d$var$configuration,
        props: props,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $186d5a33b9a640d9$export$8cdbcd3b320d39bf), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            className: props.className,
            style: props.style,
            sx: props.sx
        }, props.forwardedProps, props.slotProps?.root, {
            ref: ref,
            children: $3b503324b5e9400d$var$watermark
        }))
    });
});
const $3b503324b5e9400d$export$97fd8aadf70de81f = /*#__PURE__*/ $lCzvA.memo($3b503324b5e9400d$var$DataGridProRaw);
$3b503324b5e9400d$var$DataGridProRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The ref object that allows grid manipulation. Can be instantiated with `useGridApiRef()`.
   */ apiRef: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object.isRequired
    }),
    /**
   * The label of the Data Grid.
   */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string,
    /**
   * The id of the element containing a label for the Data Grid.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string,
    /**
   * If `true`, the Data Grid height is dynamic and follows the number of rows in the Data Grid.
   * @default false
   * @deprecated Use flex parent container instead: https://mui.com/x/react-data-grid/layout/#flex-parent-container
   * @example
   * <div style={{ display: 'flex', flexDirection: 'column' }}>
   *   <DataGrid />
   * </div>
   */ autoHeight: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */ autoPageSize: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, columns are autosized after the datagrid is mounted.
   * @default false
   */ autosizeOnMount: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * The options for autosize when user-initiated.
   */ autosizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string),
        disableColumnVirtualization: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
        expand: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
        includeHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
        includeOutliers: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
        outliersFactor: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number
    }),
    /**
   * Controls the modes of the cells.
   */ cellModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
    /**
   * If `true`, the Data Grid will display an extra column with checkboxes for selecting rows.
   * @default false
   */ checkboxSelection: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the "Select All" header checkbox selects only the rows on the current page. To be used in combination with `checkboxSelection`.
   * It only works if the pagination is enabled.
   * @default false
   */ checkboxSelectionVisibleOnly: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
    /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */ clipboardCopyCellDelimiter: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string,
    /**
   * Column region in pixels to render before/after the viewport
   * @default 150
   */ columnBufferPx: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * Sets the height in pixels of the column group headers in the Data Grid.
   * Inherits the `columnHeaderHeight` value if not set.
   */ columnGroupHeaderHeight: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    columnGroupingModel: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object),
    /**
   * Sets the height in pixel of the column headers in the Data Grid.
   * @default 56
   */ columnHeaderHeight: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * Set of columns of type [[GridColDef]][].
   */ columns: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object).isRequired,
    /**
   * Set the column visibility model of the Data Grid.
   * If defined, the Data Grid will ignore the `hide` property in [[GridColDef]].
   */ columnVisibilityModel: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
    /**
   * If above 0, the row children will be expanded up to this depth.
   * If equal to -1, all the row children will be expanded.
   * @default 0
   */ defaultGroupingExpansionDepth: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * Set the density of the Data Grid.
   * @default "standard"
   */ density: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
        'comfortable',
        'compact',
        'standard'
    ]),
    /**
   * The row ids to show the detail panel.
   */ detailPanelExpandedRowIds: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string
    ]).isRequired),
    /**
   * If `true`, column autosizing on header separator double-click is disabled.
   * @default false
   */ disableAutosize: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the filtering will only be applied to the top level rows when grouping rows with the `treeData` prop.
   * @default false
   */ disableChildrenFiltering: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the sorting will only be applied to the top level rows when grouping rows with the `treeData` prop.
   * @default false
   */ disableChildrenSorting: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, column filters are disabled.
   * @default false
   */ disableColumnFilter: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the column menu is disabled.
   * @default false
   */ disableColumnMenu: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the column pinning is disabled.
   * @default false
   */ disableColumnPinning: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, reordering columns is disabled.
   * @default false
   */ disableColumnReorder: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, resizing columns is disabled.
   * @default false
   */ disableColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */ disableColumnSelector: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the column sorting feature will be disabled.
   * @default false
   */ disableColumnSorting: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the density selector is disabled.
   * @default false
   */ disableDensitySelector: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   */ disableEval: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, filtering with multiple columns is disabled.
   * @default false
   */ disableMultipleColumnsFiltering: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the sorting with multiple columns is disabled.
   * @default false
   */ disableMultipleColumnsSorting: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, multiple selection using the Ctrl/CMD or Shift key is disabled.
   * The MIT DataGrid will ignore this prop, unless `checkboxSelection` is enabled.
   * @default false (`!props.checkboxSelection` for MIT Data Grid)
   */ disableMultipleRowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */ disableRowSelectionOnClick: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the virtualization is disabled.
   * @default false
   */ disableVirtualization: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */ editMode: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
        'cell',
        'row'
    ]),
    /**
   * Use if the actual rowCount is not known upfront, but an estimation is available.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Applicable only with `paginationMode="server"` and when `rowCount="-1"`
   */ estimatedRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */ experimentalFeatures: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        warnIfFocusStateIsNotSynced: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool
    }),
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */ filterDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */ filterMode: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
        'client',
        'server'
    ]),
    /**
   * Set the filter model of the Data Grid.
   */ filterModel: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        items: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
            field: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string
            ]),
            operator: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).any
        })).isRequired,
        logicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
            'and',
            'or'
        ]),
        quickFilterExcludeHiddenColumns: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
        quickFilterLogicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
            'and',
            'or'
        ]),
        quickFilterValues: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).array
    }),
    /**
   * Forwarded props for the Data Grid root element.
   * @ignore - do not document.
   */ forwardedProps: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
    /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */ getCellClassName: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */ getDetailPanelContent: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Function that returns the height of the row detail panel.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {number | string} The height in pixels or "auto" to use the content height.
   * @default "() => 500"
   */ getDetailPanelHeight: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */ getEstimatedRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */ getRowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */ getRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Return the id of a given [[GridRowModel]].
   * Ensure the reference of this prop is stable to avoid performance implications.
   * It could be done by either defining the prop outside of the component or by memoizing it.
   */ getRowId: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */ getRowSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Determines the path of a row in the tree data.
   * For instance, a row with the path ["A", "B"] is the child of the row with the path ["A"].
   * Note that all paths must contain at least one element.
   * @template R
   * @param {R} row The row from which we want the path.
   * @returns {string[]} The path to the row.
   */ getTreeDataPath: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * The grouping column used by the tree data.
   */ groupingColDef: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object
    ]),
    /**
   * Override the height of the header filters.
   */ headerFilterHeight: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * If `true`, the header filters feature is enabled.
   * @default false
   */ headerFilters: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the footer component is hidden.
   * @default false
   */ hideFooter: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */ hideFooterPagination: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the row count in the footer is hidden.
   * It has no effect if the pagination is enabled.
   * @default false
   */ hideFooterRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */ hideFooterSelectedRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the diacritics (accents) are ignored when filtering or quick filtering.
   * E.g. when filter value is `cafe`, the rows with `café` will be visible.
   * @default false
   */ ignoreDiacritics: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the Data Grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */ ignoreValueFormatterDuringExport: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
            clipboardExport: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
            csvExport: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool
    ]),
    /**
   * If `select`, a group header checkbox in indeterminate state (like "Select All" checkbox)
   * will select all the rows under it.
   * If `deselect`, it will deselect all the rows under it.
   * Works only if `checkboxSelection` is enabled.
   * @default "deselect"
   * @deprecated `select` will be the default behavior from v8 onwards
   */ indeterminateCheckboxAction: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
        'deselect',
        'select'
    ]),
    /**
   * The initial state of the DataGridPro.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */ initialState: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
    /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */ isCellEditable: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Determines if a group should be expanded after its creation.
   * This prop takes priority over the `defaultGroupingExpansionDepth` prop.
   * @param {GridGroupNode} node The node of the group to test.
   * @returns {boolean} A boolean indicating if the group is expanded.
   */ isGroupExpandedByDefault: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the row is selectable.
   */ isRowSelectable: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * If `true`, moving the mouse pointer outside the grid before releasing the mouse button
   * in a column re-order action will not cause the column to jump back to its original position.
   * @default false
   */ keepColumnPositionIfDraggedOutside: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */ keepNonExistentRowsSelected: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, a loading overlay is displayed.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * Set the locale text of the Data Grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
    /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */ logger: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        debug: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func.isRequired,
        error: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func.isRequired,
        info: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func.isRequired,
        warn: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func.isRequired
    }),
    /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */ logLevel: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
        'debug',
        'error',
        'info',
        'warn',
        false
    ]),
    /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */ nonce: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string,
    /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellClick: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onCellEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onCellEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */ onClipboardCopy: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderClick: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a contextmenu event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   */ onColumnHeaderContextMenu: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderEnter: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderLeave: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOut: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOver: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnOrderChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired while a column is being resized.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnVisibilityModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the width of a column is changed.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnWidthChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the density changes.
   * @param {GridDensity} density New density value.
   */ onDensityChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the detail panel of a row is opened or closed.
   * @param {GridRowId[]} ids The ids of the rows which have the detail panel open.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onDetailPanelExpandedRowIdsChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when rowCount is set and the next batch of virtualized rows is rendered.
   * @param {GridFetchRowsParams} params With all properties from [[GridFetchRowsParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFetchRows: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFilterModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuClose: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the pagination meta has changed.
   * @param {GridPaginationMeta} paginationMeta Updated pagination meta.
   */ onPaginationMetaChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPaginationModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the pinned columns have changed.
   * @param {GridPinnedColumnFields} pinnedColumns The changed pinned columns.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPinnedColumnsChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelClose: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelOpen: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback called when `processRowUpdate` throws an error or rejects.
   * @param {any} error The error thrown.
   */ onProcessRowUpdateError: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the Data Grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onResize: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowClick: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the row count has changed.
   * @param {number} count Updated row count.
   */ onRowCountChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onRowEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onRowEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when a row is being reordered.
   * @param {GridRowOrderChangeParams} params With all properties from [[GridRowOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowOrderChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowSelectionModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when scrolling to the bottom of the grid viewport.
   * @param {GridRowScrollEndParams} params With all properties from [[GridRowScrollEndParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowsScrollEnd: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onSortModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Callback fired when the state of the Data Grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */ onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */ pageSizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number.isRequired
        })
    ]).isRequired),
    /**
   * If `true`, pagination is enabled.
   * @default false
   */ pagination: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * The extra information about the pagination state of the Data Grid.
   * Only applicable with `paginationMode="server"`.
   */ paginationMeta: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        hasNextPage: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool
    }),
    /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */ paginationMode: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
        'client',
        'server'
    ]),
    /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */ paginationModel: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        page: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number.isRequired,
        pageSize: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number.isRequired
    }),
    /**
   * The column fields to display pinned to left or right.
   */ pinnedColumns: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
    /**
   * Rows data to pin on top or bottom.
   */ pinnedRows: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object),
        top: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object)
    }),
    /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @param {{ rowId: GridRowId }} params Additional parameters.
   * @returns {Promise<R> | R} The final values to update the row.
   */ processRowUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * If `true`, the page is set to 0 after each sorting or filtering.
   * This prop will be removed in the next major version and resetting the page will become the default behavior.
   * @default false
   */ resetPageOnSortFilter: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * The milliseconds throttle delay for resizing the grid.
   * @default 60
   */ resizeThrottleMs: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * Row region in pixels to render before/after the viewport
   * @default 150
   */ rowBufferPx: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Only works with `paginationMode="server"`, ignored when `paginationMode="client"`.
   */ rowCount: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * Sets the height in pixel of a row in the Data Grid.
   * @default 52
   */ rowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * Controls the modes of the rows.
   */ rowModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
    /**
   * The milliseconds delay to wait after measuring the row height before recalculating row positions.
   * Setting it to a lower value could be useful when using dynamic row height,
   * but might reduce performance when displaying a large number of rows.
   * @default 166
   * @deprecated
   */ rowPositionsDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * If `true`, the reordering of rows is enabled.
   * @default false
   */ rowReordering: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * Set of rows of type [[GridRowsProp]].
   * @default []
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object),
    /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */ rowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * Sets the row selection model of the Data Grid.
   */ rowSelectionModel: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string
        ]).isRequired),
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string
    ]),
    /**
   * When `rowSelectionPropagation.descendants` is set to `true`.
   * - Selecting a parent selects all its filtered descendants automatically.
   * - Deselecting a parent row deselects all its filtered descendants automatically.
   *
   * When `rowSelectionPropagation.parents` is set to `true`
   * - Selecting all the filtered descendants of a parent selects the parent automatically.
   * - Deselecting a descendant of a selected parent deselects the parent automatically.
   *
   * Works with tree data and row grouping on the client-side only.
   * @default { parents: false, descendants: false }
   */ rowSelectionPropagation: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        descendants: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
        parents: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool
    }),
    /**
   * Loading rows can be processed on the server or client-side.
   * Set it to 'client' if you would like enable infnite loading.
   * Set it to 'server' if you would like to enable lazy loading.
   * * @default "client"
   */ rowsLoadingMode: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
        'client',
        'server'
    ]),
    /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */ rowSpacingType: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
        'border',
        'margin'
    ]),
    /**
   * Override the height/width of the Data Grid inner scrollbar.
   */ scrollbarSize: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * Set the area in `px` at the bottom of the grid viewport where onRowsScrollEnd is called.
   * @default 80
   */ scrollEndThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * If `true`, vertical borders will be displayed between cells.
   * @default false
   */ showCellVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, vertical borders will be displayed between column header items.
   * @default false
   */ showColumnVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * Overridable components props dynamically passed to the component at rendering.
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
    /**
   * Overridable components.
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
    /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */ sortingMode: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
        'client',
        'server'
    ]),
    /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */ sortingOrder: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
        'asc',
        'desc'
    ])),
    /**
   * Set the sort model of the Data Grid.
   */ sortModel: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        field: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string.isRequired,
        sort: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
            'asc',
            'desc'
        ])
    })),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object
    ]),
    /**
   * If positive, the Data Grid will throttle updates coming from `apiRef.current.updateRows` and `apiRef.current.setRows`.
   * It can be useful if you have a high update rate but do not want to do heavy work like filtering / sorting or rendering on each  individual update.
   * @default 0
   */ throttleRowsMs: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    /**
   * If `true`, the rows will be gathered in a tree structure according to the `getTreeDataPath` prop.
   * @default false
   */ treeData: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    unstable_dataSource: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        getChildrenCount: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
        getGroupKey: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
        getRows: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func.isRequired,
        updateRow: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func
    }),
    unstable_dataSourceCache: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        clear: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func.isRequired,
        get: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func.isRequired,
        set: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func.isRequired
    }),
    /**
   * Definition of the column rendered when the `unstable_listView` prop is enabled.
   */ unstable_listColumn: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).shape({
        align: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
            'center',
            'left',
            'right'
        ]),
        cellClassName: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string
        ]),
        display: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOf([
            'flex',
            'text'
        ]),
        field: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string.isRequired,
        renderCell: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func
    }),
    /**
   * If `true`, displays the data in a list view.
   * Use in combination with `unstable_listColumn`.
   */ unstable_listView: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    unstable_onDataSourceError: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).func,
    /**
   * If `true`, the Data Grid will auto span the cells over the rows having the same value.
   * @default false
   */ unstable_rowSpanning: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool,
    /**
   * If `true`, the Data Grid enables column virtualization when `getRowHeight` is set to `() => 'auto'`.
   * By default, column virtualization is disabled when dynamic row height is enabled to measure the row height correctly.
   * For datasets with a large number of columns, this can cause performance issues.
   * The downside of enabling this prop is that the row height will be estimated based the cells that are currently rendered, which can cause row height change when scrolling horizontally.
   * @default false
   */ virtualizeColumnsWithAutoRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).bool
};




var $lCzvA = parcelRequire("lCzvA");






const $fbf636d4a1762899$var$_excluded = [
    "label",
    "icon",
    "showInMenu",
    "onClick"
], $fbf636d4a1762899$var$_excluded2 = [
    "label",
    "icon",
    "showInMenu",
    "onClick",
    "closeMenuOnClick",
    "closeMenu"
];
const $fbf636d4a1762899$export$fb2763d3c7f5c686 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)((props, ref)=>{
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    if (!props.showInMenu) {
        const { label: label, icon: icon, onClick: onClick } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $fbf636d4a1762899$var$_excluded);
        const handleClick = (event)=>{
            onClick?.(event);
        };
        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(rootProps.slots.baseIconButton, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
            size: "small",
            role: "menuitem",
            "aria-label": label
        }, other, {
            onClick: handleClick
        }, rootProps.slotProps?.baseIconButton, {
            ref: ref,
            children: /*#__PURE__*/ $lCzvA.cloneElement(icon, {
                fontSize: 'small'
            })
        }));
    }
    const { label: label, icon: icon, onClick: onClick, closeMenuOnClick: closeMenuOnClick = true, closeMenu: closeMenu } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $fbf636d4a1762899$var$_excluded2);
    const handleClick = (event)=>{
        onClick?.(event);
        if (closeMenuOnClick) closeMenu?.();
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f588ce7a0f72144$export$2e2bcd8739ae039), (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        ref: ref
    }, other, {
        onClick: handleClick,
        children: [
            icon && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $192b85e1e48317c4$export$2e2bcd8739ae039), {
                children: icon
            }),
            label
        ]
    }));
});



parcelRequire("lCzvA");








const $885d792a922521a4$var$_excluded = [
    "className",
    "children"
];
const $885d792a922521a4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbarContainer'
        ]
    };
    return (0, $5d3ef6397055422d$export$2e2bcd8739ae039)(slots, (0, $786c119d9add6b61$export$a2aa36217b862c23), classes);
};
const $885d792a922521a4$var$GridToolbarContainerRoot = (0, $cc43af7a19636335$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ToolbarContainer',
    overridesResolver: (_, styles)=>styles.toolbarContainer
})(({ theme: theme })=>({
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        padding: theme.spacing(0.5, 0.5, 0)
    }));
const $885d792a922521a4$export$276ebf2f43e1afe0 = (0, $74efa9d8b826b453$export$257a8862b851cb5b)(function GridToolbarContainer(props, ref) {
    const { className: className, children: children } = props, other = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(props, $885d792a922521a4$var$_excluded);
    const rootProps = (0, $ec4aeff4c86146e4$export$8b0f8e71b71b7ed3)();
    const classes = $885d792a922521a4$var$useUtilityClasses(rootProps);
    if (!children) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($885d792a922521a4$var$GridToolbarContainerRoot, (0, $b0e84097c00f364e$export$2e2bcd8739ae039)({
        className: (0, $6a02406550477b35$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref,
        children: children
    }));
});



var $27535f4039b315f6$exports = {};

$parcel$export($27535f4039b315f6$exports, "detailPanelContent", function () { return $27535f4039b315f6$export$a4e67647138dbd85; }, function (v) { return $27535f4039b315f6$export$a4e67647138dbd85 = v; });
$parcel$export($27535f4039b315f6$exports, "fullWidth", function () { return $27535f4039b315f6$export$f59aa6be2711b90; }, function (v) { return $27535f4039b315f6$export$f59aa6be2711b90 = v; });
$parcel$export($27535f4039b315f6$exports, "hidden", function () { return $27535f4039b315f6$export$73920f18ca706874; }, function (v) { return $27535f4039b315f6$export$73920f18ca706874 = v; });
$parcel$export($27535f4039b315f6$exports, "quickSearchToolbar", function () { return $27535f4039b315f6$export$fc18691eb7734b66; }, function (v) { return $27535f4039b315f6$export$fc18691eb7734b66 = v; });
$parcel$export($27535f4039b315f6$exports, "visible", function () { return $27535f4039b315f6$export$664c6d24e3175067; }, function (v) { return $27535f4039b315f6$export$664c6d24e3175067 = v; });
var $27535f4039b315f6$export$a4e67647138dbd85;
var $27535f4039b315f6$export$f59aa6be2711b90;
var $27535f4039b315f6$export$73920f18ca706874;
var $27535f4039b315f6$export$fc18691eb7734b66;
var $27535f4039b315f6$export$664c6d24e3175067;
$27535f4039b315f6$export$a4e67647138dbd85 = `PGbGQa_detailPanelContent`;
$27535f4039b315f6$export$f59aa6be2711b90 = `PGbGQa_fullWidth`;
$27535f4039b315f6$export$73920f18ca706874 = `PGbGQa_hidden`;
$27535f4039b315f6$export$fc18691eb7734b66 = `PGbGQa_quickSearchToolbar`;
$27535f4039b315f6$export$664c6d24e3175067 = `PGbGQa_visible`;





var $lCzvA = parcelRequire("lCzvA");

/**
 * Fetches ContentStack data from the provided URL
 * @param {string} url - The ContentStack data URL
 * @returns {Promise<Response>} The fetch promise
 */ const $99d7053f0c3be9ff$export$ca1ec041d433a03e = (url)=>fetch(url, {
        headers: {
            // eslint-disable-next-line camelcase
            api_key: String(undefined),
            // eslint-disable-next-line camelcase
            access_token: String(undefined)
        }
    });
const $99d7053f0c3be9ff$export$b1a3fc28179a5492 = (array, columns)=>{
    let result;
    const columnDelimiter = ',';
    const lineDelimiter = '\n';
    const headerName = [];
    const headerSelector = [];
    for (const item of columns){
        headerName.push(item.name);
        headerSelector.push(item.selector);
    }
    result = '';
    result += headerName.join(columnDelimiter);
    result += lineDelimiter;
    for (const item of array){
        let ctr = 0;
        for (const key of headerSelector){
            if (ctr > 0) result += columnDelimiter;
            // Navigate through nested object using key path
            let value = item;
            for (const keyPart of key.split('.'))value = value[keyPart];
            result += value;
            ctr++;
        }
        result += lineDelimiter;
    }
    return result;
};
const $99d7053f0c3be9ff$export$d6e674a4deb375c5 = (res)=>{
    const status = res.data?.status || res.data?.Status;
    const response = res.data?.response || res.data?.Response;
    if (status && response) {
        if (status === 500) throw new Error('Error');
        return response;
    }
    return res.data;
};
const $99d7053f0c3be9ff$export$887549afc07359ed = (res)=>{
    if (Array.isArray(res) && res.length > 0) {
        if (res[0].id) return res;
        return res.map((item, index)=>({
                ...item,
                id: index
            }));
    }
    return res;
};
const $99d7053f0c3be9ff$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(()=>{
            func(...args);
            timeout = null;
        }, wait);
    };
};
const $99d7053f0c3be9ff$export$3ae94a2503e890a1 = (date, format)=>{
    let newDate;
    let dateOptions;
    if (date) switch(format){
        case 'date':
            dateOptions = {
                year: 'numeric',
                day: 'numeric',
                month: 'numeric',
                timeZone: 'CST'
            };
            // @ts-ignore
            newDate = new Date(date).toLocaleDateString('en-US', dateOptions);
            break;
        case 'time':
            dateOptions = {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                timeZone: 'CST'
            };
            // @ts-ignore
            newDate = new Date(date).toLocaleTimeString('en-US', dateOptions);
            break;
        case 'dateTime':
            dateOptions = {
                year: 'numeric',
                day: 'numeric',
                month: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'CST'
            };
            // @ts-ignore
            newDate = new Date(date).toLocaleTimeString('en-US', dateOptions);
            break;
    }
    else newDate = null;
    return newDate;
};
const $99d7053f0c3be9ff$export$5d49d615ad5ea2b0 = (arr, fromIndex, toIndex)=>{
    if (!fromIndex || !toIndex) return;
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
};



var $d821c0fdbdccf7d4$exports = {};

$parcel$export($d821c0fdbdccf7d4$exports, "fieldCell", function () { return $d821c0fdbdccf7d4$export$d22f8a98e87aee77; }, function (v) { return $d821c0fdbdccf7d4$export$d22f8a98e87aee77 = v; });
$parcel$export($d821c0fdbdccf7d4$exports, "fieldsGrid", function () { return $d821c0fdbdccf7d4$export$14cad9a9a28e6c20; }, function (v) { return $d821c0fdbdccf7d4$export$14cad9a9a28e6c20 = v; });
$parcel$export($d821c0fdbdccf7d4$exports, "fullScreenHeader", function () { return $d821c0fdbdccf7d4$export$818936abf7fc3bf; }, function (v) { return $d821c0fdbdccf7d4$export$818936abf7fc3bf = v; });
$parcel$export($d821c0fdbdccf7d4$exports, "fullWidth", function () { return $d821c0fdbdccf7d4$export$f59aa6be2711b90; }, function (v) { return $d821c0fdbdccf7d4$export$f59aa6be2711b90 = v; });
$parcel$export($d821c0fdbdccf7d4$exports, "headerButton", function () { return $d821c0fdbdccf7d4$export$9e9706b9843a7198; }, function (v) { return $d821c0fdbdccf7d4$export$9e9706b9843a7198 = v; });
$parcel$export($d821c0fdbdccf7d4$exports, "modalHeader", function () { return $d821c0fdbdccf7d4$export$3099d0daead893d3; }, function (v) { return $d821c0fdbdccf7d4$export$3099d0daead893d3 = v; });
$parcel$export($d821c0fdbdccf7d4$exports, "roAttbsGreenButt", function () { return $d821c0fdbdccf7d4$export$25bdfa2f843bda52; }, function (v) { return $d821c0fdbdccf7d4$export$25bdfa2f843bda52 = v; });
$parcel$export($d821c0fdbdccf7d4$exports, "roAttbsRedButt", function () { return $d821c0fdbdccf7d4$export$43faaa2b1445d29a; }, function (v) { return $d821c0fdbdccf7d4$export$43faaa2b1445d29a = v; });
var $d821c0fdbdccf7d4$export$d22f8a98e87aee77;
var $d821c0fdbdccf7d4$export$14cad9a9a28e6c20;
var $d821c0fdbdccf7d4$export$818936abf7fc3bf;
var $d821c0fdbdccf7d4$export$f59aa6be2711b90;
var $d821c0fdbdccf7d4$export$9e9706b9843a7198;
var $d821c0fdbdccf7d4$export$3099d0daead893d3;
var $d821c0fdbdccf7d4$export$25bdfa2f843bda52;
var $d821c0fdbdccf7d4$export$43faaa2b1445d29a;
$d821c0fdbdccf7d4$export$d22f8a98e87aee77 = `qClZ3G_fieldCell`;
$d821c0fdbdccf7d4$export$14cad9a9a28e6c20 = `qClZ3G_fieldsGrid`;
$d821c0fdbdccf7d4$export$818936abf7fc3bf = `qClZ3G_fullScreenHeader`;
$d821c0fdbdccf7d4$export$f59aa6be2711b90 = `qClZ3G_fullWidth`;
$d821c0fdbdccf7d4$export$9e9706b9843a7198 = `qClZ3G_headerButton`;
$d821c0fdbdccf7d4$export$3099d0daead893d3 = `qClZ3G_modalHeader`;
$d821c0fdbdccf7d4$export$25bdfa2f843bda52 = `qClZ3G_roAttbsGreenButt`;
$d821c0fdbdccf7d4$export$43faaa2b1445d29a = `qClZ3G_roAttbsRedButt`;


const $8a90ff6fee6f3f1a$var$sizeMap = {
    sm: '600px',
    md: '900px',
    lg: '1200px',
    xl: '1536px'
};
/**
 * Handles tab key insertion in multi-line text areas.
 * @param {import('react').KeyboardEvent} e - The keyboard event.
 * @param {boolean} enabled - Whether tab insertion is enabled.
 */ const $8a90ff6fee6f3f1a$var$handleMultiLineTab = (e, enabled)=>{
    if (!enabled || e.key !== 'Tab') return;
    e.preventDefault();
    const target = /** @type {HTMLTextAreaElement} */ e.target;
    const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = target;
    const tab = '\t';
    const newValue = value.slice(0, Math.max(0, selectionStart)) + tab + value.slice(Math.max(0, selectionEnd));
    const newCursorPos = selectionStart + 1;
    // Use nativeInputValueSetter to trigger React's onChange
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value')?.set;
    nativeInputValueSetter?.call(target, newValue);
    target.dispatchEvent(new Event('input', {
        bubbles: true
    }));
    requestAnimationFrame(()=>{
        target.selectionStart = newCursorPos;
        target.selectionEnd = newCursorPos;
    });
};
/**
 * Modal form component for adding or editing a DataGrid row.
 * @param {object} props - Component props
 * @param {boolean} props.open - Whether the dialog is open
 * @param {() => void} props.toggleDialog - Callback to open/close the dialog
 * @param {(values: object) => void} props.setInputValues - Callback to update form values
 * @param {object} props.inputValues - Current form field values
 * @param {object} props.oldTableData - Original row data before edits
 * @param {Array} props.columns - Column definitions
 * @param {boolean} props.isEdit - Whether in edit mode
 * @param {boolean} props.isCopy - Whether in copy mode
 * @param {string} [props.title] - Dialog title
 * @param {boolean} [props.fullScreen] - Whether the dialog is full screen
 * @param {string} [props.dialogSize] - Dialog size key (sm/md/lg/xl)
 * @param {() => void} props.addUpdateRecord - Callback to submit the form
 * @param {object} [props.errors] - External validation errors by field
 * @param {(inputValues: object, field: string) => boolean | undefined} [props.fieldValidation] - Function to hide fields dynamically
 * @param {() => import('react').ReactNode} [props.headerButtons] - Render function for custom header buttons
 * @param {object} [props.secondaryTable] - Nested table configuration
 * @param {boolean} [props.disableNested] - Whether to hide the nested table
 * @param {Array} [props.rows] - All rows data
 * @param {object} [props.helper] - Helper utilities passed through from DataGrid
 */ const $8a90ff6fee6f3f1a$var$InputForm = (props)=>{
    const { open: open, toggleDialog: toggleDialog, setInputValues: setInputValues, inputValues: inputValues, oldTableData: oldTableData, columns: columns, isEdit: isEdit, isCopy: isCopy, title: title, fullScreen: fullScreen, dialogSize: dialogSize, addUpdateRecord: addUpdateRecord, errors: errors = {}, fieldValidation: fieldValidation, headerButtons: headerButtons, secondaryTable: secondaryTable, disableNested: disableNested, rows: rows } = props;
    const [nestedTableOverride, setNestedTableOverride] = (0, $lCzvA.useState)(null);
    const [formFieldErrors, setFormFieldErrors] = (0, $lCzvA.useState)({});
    const [showSecondaryTable, setShowSecondaryTable] = (0, $lCzvA.useState)(true);
    // Track previous values of open/isEdit/isCopy to reset form errors on change
    const [prevFormKey, setPrevFormKey] = (0, $lCzvA.useState)({
        open: open,
        isEdit: isEdit,
        isCopy: isCopy
    });
    if (prevFormKey.open !== open || prevFormKey.isEdit !== isEdit || prevFormKey.isCopy !== isCopy) {
        setPrevFormKey({
            open: open,
            isEdit: isEdit,
            isCopy: isCopy
        });
        setFormFieldErrors({});
        if (!isEdit && !isCopy) {
            const temp = {};
            for (const c of columns)temp[c.field] = c.defaultValue;
            setInputValues(temp);
        }
    }
    const secondaryTableData = (0, $lCzvA.useMemo)(()=>{
        if (nestedTableOverride) return nestedTableOverride;
        const dataField = String(secondaryTable?.dataField);
        const data = oldTableData[dataField];
        return data ? (0, $99d7053f0c3be9ff$export$887549afc07359ed)(data) : [];
    }, [
        oldTableData,
        secondaryTable?.dataField,
        nestedTableOverride
    ]);
    // Reset override when oldTableData changes so derived value takes over again
    const [prevOldTableData, setPrevOldTableData] = (0, $lCzvA.useState)(oldTableData);
    if (prevOldTableData !== oldTableData) {
        setPrevOldTableData(oldTableData);
        if (nestedTableOverride !== null) setNestedTableOverride(null);
    }
    const setUserInput = (field, value)=>setInputValues({
            ...inputValues,
            [field]: value
        });
    const closeDialog = ()=>{
        toggleDialog();
    };
    // Small hack to refresh nested data tables.
    const resetNestedTable = ()=>{
        const dataField = String(secondaryTable?.dataField);
        const tempData = inputValues[dataField];
        setShowSecondaryTable(false);
        setTimeout(()=>{
            setNestedTableOverride(structuredClone(tempData));
            setShowSecondaryTable((show)=>!show);
        }, 500);
    };
    const formCheck = ()=>{
        let hasError = false;
        const fieldValidationErrors = {};
        for (const column of columns)if (column?.required && !inputValues[column.field] && inputValues[column.field] !== 0) {
            hasError = true;
            fieldValidationErrors[column.field] = 'This field is required';
        }
        setFormFieldErrors(fieldValidationErrors);
        return hasError;
    };
    const submitInputForm = ()=>{
        if (formCheck()) return;
        addUpdateRecord();
    };
    const filterFields = (c)=>{
        if (!isEdit && c.editable === 'never' || c.editable === false) return false;
        if (c.readonly) return true;
        return c.hide !== true;
    };
    const checkSelectedValue = (column, value)=>{
        if (column.setValue) column.setValue(value);
        setUserInput(column.field, value);
    };
    const modalWidth = $8a90ff6fee6f3f1a$var$sizeMap[dialogSize] || '900px';
    const AnyModalHeader = /** @type {import('react').ElementType} */ (0, $9761f0447406a76c$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: closeDialog,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
            fullScreen: fullScreen === true,
            width: modalWidth,
            showClose: false,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(AnyModalHeader, {
                    className: fullScreen ? `${(0, (/*@__PURE__*/$parcel$interopDefault($d821c0fdbdccf7d4$exports))).modalHeader} ${(0, (/*@__PURE__*/$parcel$interopDefault($d821c0fdbdccf7d4$exports))).fullScreenHeader}` : (0, (/*@__PURE__*/$parcel$interopDefault($d821c0fdbdccf7d4$exports))).modalHeader,
                    children: [
                        title,
                        fullScreen && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    size: "sm",
                                    color: "secondary",
                                    onClick: closeDialog,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d821c0fdbdccf7d4$exports))).headerButton,
                                    iconLeft: "close",
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    size: "sm",
                                    color: "primary",
                                    onClick: submitInputForm,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d821c0fdbdccf7d4$exports))).headerButton,
                                    iconLeft: "save",
                                    children: isEdit ? 'Update' : 'Create'
                                })
                            ]
                        }),
                        headerButtons ? headerButtons() : null
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d821c0fdbdccf7d4$exports))).fieldsGrid,
                            children: columns?.filter((c)=>filterFields(c)).map((col, index)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d821c0fdbdccf7d4$exports))).fieldCell,
                                    hidden: fieldValidation ? fieldValidation(inputValues, col.field) : undefined,
                                    children: [
                                        !col.valueOptions && !col.multiLine && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                                            disabled: col.editable === 'never' || col.editable === 'onAdd' && isEdit || col.readonly === true,
                                            error: formFieldErrors[col.field] || errors[col.field] || (col.required && !inputValues[col.field] ? 'This field is required' : '') || undefined,
                                            id: `input_${index}_${col.field}`,
                                            labelText: col.headerName,
                                            type: col.type === 'numeric' ? 'number' : 'text',
                                            value: inputValues[col.field] || '',
                                            onChange: (e)=>setUserInput(col.field, e.target.value),
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d821c0fdbdccf7d4$exports))).fullWidth,
                                            required: col.required,
                                            ...col.inputProps || {}
                                        }),
                                        !col.valueOptions && col.multiLine && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $27cc10959d191d67$export$2e2bcd8739ae039), {
                                            disabled: col.editable === 'never' || col.editable === 'onAdd' && isEdit || col.readonly === true,
                                            error: formFieldErrors[col.field] || errors[col.field] || (col.required && !inputValues[col.field] ? 'This field is required' : '') || undefined,
                                            id: `input_${index}_${col.field}`,
                                            labelText: col.headerName,
                                            value: inputValues[col.field] || '',
                                            onChange: (e)=>setUserInput(col.field, e.target.value),
                                            onKeyDown: (e)=>$8a90ff6fee6f3f1a$var$handleMultiLineTab(e, col.multiLine),
                                            required: col.required
                                        }),
                                        col.valueOptions && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                            id: `${index}_${col.field}`,
                                            labelText: col.headerName,
                                            disabled: col.editable === 'never' || col.editable === 'onAdd' && isEdit || col.readonly === true,
                                            required: col.required,
                                            error: formFieldErrors[col.field] || errors[col.field] || (col.required && !inputValues[col.field] ? 'This field is required' : '') || undefined,
                                            value: inputValues[col.field] !== undefined ? inputValues[col.field] : '',
                                            onChange: (e)=>checkSelectedValue(col, e.target.value),
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d821c0fdbdccf7d4$exports))).fullWidth,
                                            children: (typeof col.valueOptions === 'function' ? col.valueOptions(rows) : col.valueOptions).map((val)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                                    value: val.value !== undefined ? val.value : val,
                                                    children: val.label || val
                                                }, `${col.field}_${val.value !== undefined ? val.value : val}`))
                                        })
                                    ]
                                }, col.field))
                        }),
                        !isCopy && secondaryTable && disableNested === false && showSecondaryTable && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $bb8cae2cae6f2fbe$export$2e2bcd8739ae039), {
                                rows: secondaryTableData,
                                parentId: oldTableData[String(secondaryTable?.parentIdField)],
                                resetValues: resetNestedTable,
                                ...secondaryTable
                            })
                        })
                    ]
                }),
                !fullScreen && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            size: "sm",
                            color: "secondary",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d821c0fdbdccf7d4$exports))).roAttbsRedButt,
                            onClick: closeDialog,
                            iconLeft: "close",
                            children: "Close"
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            size: "sm",
                            color: "primary",
                            onClick: submitInputForm,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d821c0fdbdccf7d4$exports))).roAttbsGreenButt,
                            iconLeft: "check_circle",
                            children: isEdit ? 'Update' : 'Create'
                        })
                    ]
                })
            ]
        })
    });
};
var $8a90ff6fee6f3f1a$export$2e2bcd8739ae039 = $8a90ff6fee6f3f1a$var$InputForm;




var $lCzvA = parcelRequire("lCzvA");

/**
 * Inline cell editor component for the DataGrid.
 * Renders either a Select or TextInput depending on field configuration.
 * @param {object} props - Component props
 * @param {string} props.id - Row ID
 * @param {unknown} props.value - Current cell value
 * @param {string} props.field - Column field name
 * @param {object} props.fullFiled - Full column definition object
 * @param {object} props.api - DataGrid API object
 * @param {object} props.row - Current row data
 * @param {string} props.parentId - Parent row ID
 * @param {() => void} [props.resetValues] - Optional callback to reset form values
 * @param {Array} [props.rows] - All rows data (used for computed valueOptions)
 */ const $91a60648839e179b$var$EditComponent = (props)=>{
    const { id: id, value: value, field: field, fullFiled: fullFiled, api: api, row: row, parentId: parentId, resetValues: resetValues, rows: rows } = props;
    const [newValue, setNewValue] = (0, $lCzvA.useState)(value);
    const saveUpdatedValue = async ()=>{
        api.setEditCellValue({
            id: id,
            field: field,
            value: newValue
        });
        const temp = {
            ...row,
            [field]: newValue,
            parentId: parentId
        };
        await fullFiled.onRowUpdateModal(temp);
        if (typeof resetValues === 'function') resetValues();
    };
    const setInputValues = (e)=>{
        setNewValue(e.target.value);
    };
    const checkEnterPress = (e)=>{
        if (e.key === 'Enter') saveUpdatedValue();
    };
    const options = typeof fullFiled.valueOptions === 'function' ? fullFiled.valueOptions(rows) : fullFiled.valueOptions;
    return fullFiled.valueOptions ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
        id: `edit-${fullFiled.field}`,
        labelText: fullFiled.headerName || fullFiled.field,
        value: newValue || '',
        onChange: setInputValues,
        onBlur: saveUpdatedValue,
        children: options.map((o)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                value: o.value !== undefined ? o.value : o,
                children: o.label || o
            }, `${fullFiled.field}_${o.label || o}`))
    }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
        id: `edit-${fullFiled.field}`,
        labelText: fullFiled.headerName || fullFiled.field,
        type: fullFiled.type === 'numeric' ? 'number' : 'text',
        value: newValue || '',
        onChange: setInputValues,
        onKeyDown: checkEnterPress,
        onBlur: saveUpdatedValue
    });
};
var $91a60648839e179b$export$2e2bcd8739ae039 = $91a60648839e179b$var$EditComponent;



const $a330dcae3c698a40$export$17c145fff2d7b849 = '<div class="sweet_loader"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div>';
const $a330dcae3c698a40$export$56525cbb1fcd885c = ()=>{
    // Note: showLoading is not available in toast. Consider using a loading component instead.
    // eslint-disable-next-line no-console
    console.warn('showLoader is deprecated. Please use a loading component instead.');
};
const $a330dcae3c698a40$export$de026b00723010c1 = ({ title: title, text: text, type: type, _button: _button })=>{
    const message = text ? `${title}: ${text}` : title;
    const toastType = type || 'success';
    // Call the appropriate toast method based on type
    switch(toastType){
        case 'error':
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(message || '');
            break;
        case 'warning':
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).warning(message || '');
            break;
        case 'info':
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).info(message || '');
            break;
        case 'success':
        default:
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success(message || '');
            break;
    }
};



/**
 * Escapes special regex characters in a string for safe use in a RegExp.
 * @param {string} value - The string to escape.
 * @returns {string} The escaped string.
 */ const $bb8cae2cae6f2fbe$var$escapeRegExp = (value)=>value.replaceAll(/[-[\]{}()*+?.,\\^$|#\s]/gu, '\\$&');
/**
 * Returns whether a column should be included in the DataGrid display.
 * @param {object} c - The column definition object.
 * @returns {boolean} True if the column should be shown.
 */ const $bb8cae2cae6f2fbe$var$filterFields = (c)=>{
    if (c.hideColumn) return false;
    return c.hide !== true;
};
const $bb8cae2cae6f2fbe$var$CustomDetailPanelToggle = (props)=>{
    const { value: isExpanded } = props;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
        size: "sm",
        color: "secondary",
        iconLeft: isExpanded ? 'expand_less' : 'expand_more',
        "aria-label": isExpanded ? 'Close' : 'Open'
    });
};
const $bb8cae2cae6f2fbe$var$QuickSearchToolbar = (props)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($27535f4039b315f6$exports))).quickSearchToolbar,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                id: "datagrid-quick-search",
                labelText: "",
                value: props.value,
                onChange: props.onChange,
                placeholder: "Search\u2026"
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                iconLeft: "clear",
                "aria-label": "Clear",
                size: "sm",
                color: "secondary",
                className: props.value ? (0, (/*@__PURE__*/$parcel$interopDefault($27535f4039b315f6$exports))).visible : (0, (/*@__PURE__*/$parcel$interopDefault($27535f4039b315f6$exports))).hidden,
                onClick: props.clearSearch
            })
        ]
    });
const $bb8cae2cae6f2fbe$var$EditToolbarComponent = ({ title: toolbarTitle, editable: toolbarEditable, extraOption: toolbarExtraOption, ...props })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $885d792a922521a4$export$276ebf2f43e1afe0), {
                className: "httpCallTitle",
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $885d792a922521a4$export$276ebf2f43e1afe0), {
                className: "httpCallActionDiv",
                children: [
                    toolbarEditable?.addNewRow && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        color: "secondary",
                        size: "sm",
                        onClick: props.newRecord,
                        iconLeft: "add",
                        children: "Add"
                    }),
                    toolbarExtraOption?.filter((e)=>e.isFreeAction === true)?.map((e)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "secondary",
                            size: "sm",
                            onClick: (c)=>e.onClick(c, props),
                            id: `extra-option-${e.tooltip}`,
                            iconLeft: e.icon,
                            children: e.tooltip
                        }, `${e.tooltip}-${e.icon}`)),
                    props?.quickFilter && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($bb8cae2cae6f2fbe$var$QuickSearchToolbar, {
                        ...props
                    })
                ]
            })
        ]
    });
// Column order and visibility changes are intentionally not persisted in this implementation
const $bb8cae2cae6f2fbe$var$handleOrderChange = ()=>{
/* no-op */ };
const $bb8cae2cae6f2fbe$var$handleColumnVisibility = ()=>{
/* no-op */ };
const $bb8cae2cae6f2fbe$var$AnyTooltipTrigger = /** @type {import('react').ElementType} */ (0, $147b0a927ae5f067$export$2e2bcd8739ae039);
/**
 * Full-featured DataGrid panel with editing, filtering, and optional nested tables.
 * @param {object} props - Component props
 * @param {boolean} [props.checkboxSelection] - Enable row selection checkboxes
 * @param {boolean} [props.checkResponse] - Whether to validate the response status after add/update
 * @param {Array<object>} props.columns - Column definitions
 * @param {boolean} [props.copy] - Enable row copy action
 * @param {string} [props.density] - Row density setting
 * @param {object} [props.detailPanel] - Detail panel configuration
 * @param {boolean} [props.dynamicHeight] - Use dynamic height for grid
 * @param {object} [props.editable] - Edit configuration
 * @param {Array<object>} [props.extraOption] - Extra action options
 * @param {(params: object) => string} [props.getRowClassName] - Callback to get row class name
 * @param {object} [props.helper] - Helper utilities
 * @param {(selectionModel: unknown) => void} [props.onSelectionModelChange] - Callback for selection changes
 * @param {number} [props.pageSize] - Default page size
 * @param {string|number} [props.parentId] - Parent ID for records
 * @param {boolean} [props.quickFilter] - Enable quick search filter
 * @param {object} [props.remember] - Remember settings configuration
 * @param {() => void} [props.resetValues] - Callback to reset values
 * @param {Array<object>} props.rows - Row data
 * @param {Array<string|number>} [props.selectionModel] - Selected row IDs
 * @param {boolean} [props.skipDeleteConfirm] - Skip delete confirmation
 * @param {string} [props.title] - Grid title
 * @param {string} [props.validateDelete] - Field to validate on delete
 */ const $bb8cae2cae6f2fbe$var$DataGridPanel = ({ checkboxSelection: checkboxSelection, checkResponse: checkResponse, columns: propsColumns, copy: copy, density: density, detailPanel: detailPanel, dynamicHeight: propsDynamicHeight, editable: editable, extraOption: extraOption, getRowClassName: getRowClassName, helper: helper, onSelectionModelChange: onSelectionModelChange, pageSize: propsPageSize, parentId: parentId, quickFilter: quickFilter, remember: remember, resetValues: resetValues, rows: propsRows, selectionModel: selectionModel, skipDeleteConfirm: skipDeleteConfirm, title: title, validateDelete: validateDelete })=>{
    const [pinned, setPinned] = (0, $lCzvA.useState)(()=>{
        if (remember) {
            const pins = window.sessionStorage.getItem(`pinned_${remember.table}`);
            if (pins) return JSON.parse(pins);
        }
        return {
            left: [],
            right: []
        };
    });
    const [pageSize, setPageSize] = (0, $lCzvA.useState)(propsPageSize || 20);
    const [errors, setErrors] = (0, $lCzvA.useState)({});
    const [isEdit, setIsEdit] = (0, $lCzvA.useState)(false);
    const [isCopy, setIsCopy] = (0, $lCzvA.useState)(false);
    const [open, setOpen] = (0, $lCzvA.useState)(false);
    const [inputValues, setInputValues] = (0, $lCzvA.useState)({});
    const [disableNested, setDisableNested] = (0, $lCzvA.useState)(false);
    const [oldTableData, setOldTableData] = (0, $lCzvA.useState)({});
    const [tableConfig, setTableConfig] = (0, $lCzvA.useState)(()=>{
        if (remember) {
            const config = window.sessionStorage.getItem(remember.table || '');
            if (typeof config === 'string') return JSON.parse(config);
        }
        return {};
    });
    const [searchText, setSearchText] = (0, $lCzvA.useState)('');
    const [dynamicHeight, setDynamicHeight] = (0, $lCzvA.useState)(window.innerHeight - 160);
    const [pendingDeleteId, setPendingDeleteId] = (0, $lCzvA.useState)(null);
    const [deleteInputValue, setDeleteInputValue] = (0, $lCzvA.useState)('');
    (0, $lCzvA.useEffect)(()=>{
        const handleResize = ()=>{
            setDynamicHeight(window.innerHeight - 160);
        };
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    const rows = (0, $lCzvA.useMemo)(()=>{
        if (!searchText) return propsRows;
        const searchRegex = new RegExp($bb8cae2cae6f2fbe$var$escapeRegExp(searchText), 'iu');
        return propsRows.filter((row)=>Object.keys(row).some((field)=>searchRegex.test(row[field]?.toString())));
    }, [
        propsRows,
        searchText
    ]);
    const getDetailPanelContent = (0, $lCzvA.useCallback)(({ row: row })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($27535f4039b315f6$exports))).detailPanelContent,
            children: `Order #${row.id}`
        }), []);
    const toggleDialog = (disNested = false)=>{
        if (open) setTimeout(()=>{
            setErrors({});
            setInputValues({});
            setDisableNested(disNested);
        }, 500);
        else {
            setErrors({});
            setInputValues({});
            setDisableNested(disNested);
        }
        setIsCopy(false);
        setOpen(!open);
    };
    const editRecord = (id)=>{
        const record = propsRows.find((r)=>r.id === id);
        toggleDialog();
        setInputValues(record);
        setIsEdit(true);
        setOldTableData({
            ...record
        });
    };
    const newRecord = ()=>{
        setIsEdit(false);
        toggleDialog(true);
    };
    const getRowData = (id, callBack)=>{
        const record = propsRows.find((r)=>r.id === id);
        callBack(record);
    };
    const deleteRecord = (id)=>{
        setPendingDeleteId(id);
        setDeleteInputValue('');
    };
    const handleDeleteConfirm = ()=>{
        const id = pendingDeleteId;
        setPendingDeleteId(null);
        const record = propsRows.find((r)=>r.id === id);
        if (parentId) record.parentId = parentId;
        if (validateDelete) {
            if (deleteInputValue === record[validateDelete]) editable?.onRowDelete(record).then(()=>{
                if (!skipDeleteConfirm) (0, $a330dcae3c698a40$export$de026b00723010c1)({
                    title: 'Done!',
                    text: '',
                    type: 'success'
                });
                if (resetValues) resetValues();
                return undefined;
            }).catch(()=>{
                (0, $a330dcae3c698a40$export$de026b00723010c1)({
                    title: 'Failed to delete.',
                    text: '',
                    type: 'error'
                });
            });
            else (0, $a330dcae3c698a40$export$de026b00723010c1)({
                title: 'Failed to delete.',
                text: '',
                type: 'error'
            });
        } else editable?.onRowDelete(record).then(()=>{
            if (!skipDeleteConfirm) (0, $a330dcae3c698a40$export$de026b00723010c1)({
                title: 'Done!',
                text: '',
                type: 'success'
            });
            if (resetValues) resetValues();
            return undefined;
        }).catch(()=>{
            if (!skipDeleteConfirm) (0, $a330dcae3c698a40$export$de026b00723010c1)({
                title: 'Failed to delete.',
                text: '',
                type: 'error'
            });
        });
    };
    const copyRow = (id)=>{
        toggleDialog();
        let record = propsRows.find((r)=>r.id === id);
        record = {
            ...record
        };
        setIsEdit(false);
        setIsCopy(true);
        setInputValues(record);
    };
    const getActionIcons = (id)=>{
        const actions = [];
        if (editable?.onRowUpdateModal) actions.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbf636d4a1762899$export$fb2763d3c7f5c686), {
            icon: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: "edit"
            }),
            label: "Edit",
            className: "textPrimary",
            onClick: ()=>{
                editRecord(id);
            },
            color: "inherit"
        }));
        if (copy) actions.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbf636d4a1762899$export$fb2763d3c7f5c686), {
            icon: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: "content_copy"
            }),
            label: "Copy",
            className: "textPrimary",
            onClick: ()=>{
                copyRow(id);
            },
            color: "inherit"
        }));
        const extraOptions = extraOption?.filter((e)=>e.isFreeAction !== true) ?? [];
        for (const e of extraOptions)actions.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbf636d4a1762899$export$fb2763d3c7f5c686), {
            icon: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: e.icon
            }),
            label: e.tooltip,
            onClick: ()=>getRowData(id, e.onClick)
        }));
        if (editable?.onRowDelete) actions.push(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbf636d4a1762899$export$fb2763d3c7f5c686), {
            icon: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: "delete"
            }),
            label: "Delete",
            onClick: ()=>deleteRecord(id),
            color: "inherit"
        }));
        return actions;
    };
    const columns = (0, $lCzvA.useMemo)(()=>{
        const cols = [];
        if (detailPanel) cols.push({
            ...(0, $36af50bebc849811$export$cea0a90b26fb973d),
            renderCell: (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($bb8cae2cae6f2fbe$var$CustomDetailPanelToggle, {
                    ...params
                })
        });
        const actionIcons = getActionIcons(1);
        const headerName = helper ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e2bb55bcb551b0ee$export$2e2bcd8739ae039), {
            item: helper?.item,
            access: helper?.access ?? {},
            tip: helper?.tip
        }) : '';
        if (actionIcons.length) cols.push({
            headerName: headerName,
            field: 'actions',
            type: 'actions',
            cellClassName: 'actions',
            width: 40 * actionIcons.length,
            getActions: ({ id: id })=>getActionIcons(id)
        });
        const existingColumns = propsColumns.filter((c)=>$bb8cae2cae6f2fbe$var$filterFields(c)).map((col)=>{
            const c = {
                ...col
            };
            if (!c.renderCell && c.valueOptions) c.renderCell = (params)=>{
                const valueOptions = typeof c.valueOptions === 'function' ? c.valueOptions(propsRows) : c.valueOptions;
                const option = valueOptions?.find((rl)=>{
                    if (typeof rl === 'object') return rl.value?.toString() === params.row[c.field]?.toString();
                    return rl?.toString() === params.row[c.field]?.toString();
                });
                const value = option?.label || option || '';
                return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4f341de42b3721ba$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($bb8cae2cae6f2fbe$var$AnyTooltipTrigger, {
                            asChild: true,
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                children: value
                            })
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $69ca344c093705ef$export$2e2bcd8739ae039), {
                            children: value
                        })
                    ]
                });
            };
            if (c.editable) c.renderEditCell = (params)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $91a60648839e179b$export$2e2bcd8739ae039), {
                    ...params,
                    fullFiled: c,
                    parentId: parentId,
                    resetValues: resetValues
                });
            return {
                ...tableConfig[c.field],
                ...c
            };
        });
        return [
            ...cols,
            ...existingColumns
        ];
    // getActionIcons references editable, copy, extraOption (props) and editRecord/copyRow/getRowData/deleteRecord (internal fns).
    // We intentionally depend on propsColumns and tableConfig as the primary triggers, matching the original effect's deps.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        propsColumns,
        tableConfig,
        detailPanel,
        helper,
        parentId,
        resetValues,
        editable,
        copy,
        extraOption,
        propsRows
    ]);
    const addUpdateRecord = ()=>{
        if (editable?.addNewRow || editable?.onRowUpdateModal) {
            const f = isEdit ? editable.onRowUpdateModal : editable.addNewRow;
            const submitValues = parentId ? {
                ...inputValues,
                parentId: parentId
            } : inputValues;
            f(submitValues, oldTableData).then((result)=>{
                setErrors({});
                toggleDialog();
                if (checkResponse) {
                    if (result?.status?.toString() === '201' || result?.status?.toString() === '200') (0, $a330dcae3c698a40$export$de026b00723010c1)({
                        title: 'Done!',
                        text: '',
                        type: 'success'
                    });
                    else (0, $a330dcae3c698a40$export$de026b00723010c1)({
                        title: result?.message,
                        text: '',
                        type: 'error'
                    });
                } else (0, $a330dcae3c698a40$export$de026b00723010c1)({
                    title: 'Done!',
                    text: '',
                    type: 'success'
                });
                if (resetValues) resetValues();
                return result;
            }).catch((error)=>{
                if (typeof error !== 'string') {
                    const errorFields = {};
                    for (const e of error?.response?.data?.errors ?? [])errorFields[e.param] = e.msg;
                    setErrors(errorFields);
                } else (0, $a330dcae3c698a40$export$de026b00723010c1)({
                    title: error || 'Something went wrong',
                    text: '',
                    type: 'warning'
                });
            });
        }
    };
    const setConfigValue = (column, setting, value)=>{
        const config = {
            ...tableConfig
        };
        config[column] = config[column] || {};
        config[column][setting] = value;
        setTableConfig({
            ...config
        });
        window.sessionStorage.setItem(remember.table, JSON.stringify(config));
    };
    const handleColumnWidthChange = ({ colDef: colDef })=>{
        if (remember) setConfigValue(colDef.field, 'width', colDef.computedWidth);
    };
    const handlePinnedColumns = (data)=>{
        window.sessionStorage.setItem(`pinned_${remember.table}`, JSON.stringify(data));
        setPinned(data);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: "delinquent-orders dataGrid",
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($27535f4039b315f6$exports))).fullWidth,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3b503324b5e9400d$export$97fd8aadf70de81f), {
                    className: "data-grid-pro-margin-0",
                    sx: {
                        m: 2
                    },
                    density: density || 'compact',
                    rows: rows,
                    columns: columns,
                    rowThreshold: 0,
                    getDetailPanelContent: detailPanel ? getDetailPanelContent : undefined,
                    pageSize: pageSize,
                    onPageSizeChange: (newPageSize)=>setPageSize(newPageSize),
                    rowsPerPageOptions: [
                        5,
                        10,
                        20,
                        50,
                        100
                    ],
                    pagination: !propsDynamicHeight,
                    style: {
                        height: propsDynamicHeight ? dynamicHeight : ''
                    },
                    autoHeight: !propsDynamicHeight,
                    components: {
                        Toolbar: $bb8cae2cae6f2fbe$var$EditToolbarComponent
                    },
                    componentsProps: {
                        toolbar: {
                            title: title,
                            value: searchText,
                            onChange: (event)=>setSearchText(event.target.value),
                            clearSearch: ()=>setSearchText(''),
                            quickFilter: quickFilter,
                            editable: editable,
                            extraOption: extraOption,
                            newRecord: newRecord,
                            parentId: parentId,
                            resetValues: resetValues
                        }
                    },
                    onColumnWidthChange: handleColumnWidthChange,
                    onPinnedColumnsChange: handlePinnedColumns,
                    pinnedColumns: pinned,
                    onColumnOrderChange: $bb8cae2cae6f2fbe$var$handleOrderChange,
                    onColumnVisibilityModelChange: $bb8cae2cae6f2fbe$var$handleColumnVisibility,
                    getRowClassName: getRowClassName,
                    checkboxSelection: checkboxSelection,
                    onSelectionModelChange: onSelectionModelChange,
                    selectionModel: selectionModel
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8a90ff6fee6f3f1a$export$2e2bcd8739ae039), {
                open: open,
                isEdit: isEdit,
                isCopy: isCopy,
                title: title,
                toggleDialog: toggleDialog,
                addUpdateRecord: addUpdateRecord,
                setInputValues: setInputValues,
                inputValues: inputValues,
                oldTableData: oldTableData,
                columns: propsColumns,
                errors: errors,
                disableNested: disableNested,
                helper: helper
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
                open: pendingDeleteId !== null,
                onOpenChange: (isOpen)=>{
                    if (!isOpen) setPendingDeleteId(null);
                },
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
                    showClose: false,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                            children: "Are you sure?"
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                    children: validateDelete ? 'Confirm deletion by typing the name' : "You won't be able to revert this!"
                                }),
                                validateDelete && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                                    id: "delete-confirm-input",
                                    labelText: "Confirm name",
                                    value: deleteInputValue,
                                    onChange: (e)=>setDeleteInputValue(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    size: "sm",
                                    color: "secondary",
                                    onClick: ()=>setPendingDeleteId(null),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    size: "sm",
                                    color: "primary",
                                    onClick: handleDeleteConfirm,
                                    children: validateDelete ? 'Confirm' : 'Yes, delete it!'
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $bb8cae2cae6f2fbe$export$2e2bcd8739ae039 = $bb8cae2cae6f2fbe$var$DataGridPanel;






var $lCzvA = parcelRequire("lCzvA");

function $1db915e27b88517f$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $c3ad8372d88286e6$export$2e2bcd8739ae039(value) {
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $8410ced365fa20bf$export$2e2bcd8739ae039)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}




function $74f9dca938597185$export$2e2bcd8739ae039(argument) {
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $8410ced365fa20bf$export$2e2bcd8739ae039)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $28d4c96bde8f233e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $c3ad8372d88286e6$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $74f9dca938597185$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $6650722b7068ae8f$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $2f0bca53c237dab9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $74f9dca938597185$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $6650722b7068ae8f$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $32d15ab0bed6814b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $6650722b7068ae8f$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $2f0bca53c237dab9$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $a14981b7ec3a760a$var$MILLISECONDS_IN_DAY = 86400000;
function $a14981b7ec3a760a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $74f9dca938597185$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $a14981b7ec3a760a$var$MILLISECONDS_IN_DAY) + 1;
}





function $9297205e179fdd96$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $74f9dca938597185$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $e90f85c5badb6286$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $74f9dca938597185$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $9297205e179fdd96$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $9297205e179fdd96$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $5779f52c97fb13ad$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $e90f85c5badb6286$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $9297205e179fdd96$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $85307a29ce12e345$var$MILLISECONDS_IN_WEEK = 604800000;
function $85307a29ce12e345$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $74f9dca938597185$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $9297205e179fdd96$export$2e2bcd8739ae039)(date).getTime() - (0, $5779f52c97fb13ad$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $85307a29ce12e345$var$MILLISECONDS_IN_WEEK) + 1;
}







var $e19150f502eef51c$var$defaultOptions = {};
function $e19150f502eef51c$export$430a3269e24b912e() {
    return $e19150f502eef51c$var$defaultOptions;
}
function $e19150f502eef51c$export$95365be1b0704abc(newOptions) {
    $e19150f502eef51c$var$defaultOptions = newOptions;
}


function $c2403f7642600225$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $e19150f502eef51c$export$430a3269e24b912e)();
    var weekStartsOn = (0, $6650722b7068ae8f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $74f9dca938597185$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $9bc9b7fd3e7f5f4a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $74f9dca938597185$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $e19150f502eef51c$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $6650722b7068ae8f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $c2403f7642600225$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $c2403f7642600225$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $7f72118e21a24953$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $e19150f502eef51c$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $6650722b7068ae8f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $9bc9b7fd3e7f5f4a$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $c2403f7642600225$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $ff535de6baa9c11a$var$MILLISECONDS_IN_WEEK = 604800000;
function $ff535de6baa9c11a$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $74f9dca938597185$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $c2403f7642600225$export$2e2bcd8739ae039)(date, options).getTime() - (0, $7f72118e21a24953$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $ff535de6baa9c11a$var$MILLISECONDS_IN_WEEK) + 1;
}



function $348552753289d341$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $2548641fb3151307$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $348552753289d341$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $348552753289d341$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $348552753289d341$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $348552753289d341$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $348552753289d341$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $348552753289d341$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $348552753289d341$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $348552753289d341$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $2548641fb3151307$export$2e2bcd8739ae039 = $2548641fb3151307$var$formatters;


var $fc48ff6281d88e3c$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $fc48ff6281d88e3c$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $2548641fb3151307$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $9bc9b7fd3e7f5f4a$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $348552753289d341$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $348552753289d341$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $e90f85c5badb6286$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $348552753289d341$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $348552753289d341$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $348552753289d341$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $348552753289d341$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $2548641fb3151307$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $348552753289d341$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $ff535de6baa9c11a$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $348552753289d341$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $85307a29ce12e345$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $348552753289d341$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $2548641fb3151307$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $a14981b7ec3a760a$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $348552753289d341$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $348552753289d341$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $348552753289d341$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $348552753289d341$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $fc48ff6281d88e3c$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $fc48ff6281d88e3c$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $fc48ff6281d88e3c$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $fc48ff6281d88e3c$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $fc48ff6281d88e3c$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $fc48ff6281d88e3c$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $2548641fb3151307$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $2548641fb3151307$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $348552753289d341$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $348552753289d341$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $2548641fb3151307$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $2548641fb3151307$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $2548641fb3151307$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $fc48ff6281d88e3c$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $fc48ff6281d88e3c$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $fc48ff6281d88e3c$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $fc48ff6281d88e3c$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $fc48ff6281d88e3c$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $fc48ff6281d88e3c$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $fc48ff6281d88e3c$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $fc48ff6281d88e3c$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $fc48ff6281d88e3c$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $fc48ff6281d88e3c$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $348552753289d341$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $348552753289d341$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $fc48ff6281d88e3c$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $348552753289d341$export$2e2bcd8739ae039)(minutes, 2);
}
function $fc48ff6281d88e3c$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $348552753289d341$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $fc48ff6281d88e3c$var$formatTimezone(offset, dirtyDelimiter);
}
function $fc48ff6281d88e3c$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $348552753289d341$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $348552753289d341$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $fc48ff6281d88e3c$export$2e2bcd8739ae039 = $fc48ff6281d88e3c$var$formatters;


var $333bfdbfbcef01d5$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $333bfdbfbcef01d5$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $333bfdbfbcef01d5$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $333bfdbfbcef01d5$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $333bfdbfbcef01d5$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $333bfdbfbcef01d5$var$timeLongFormatter(timePattern, formatLong));
};
var $333bfdbfbcef01d5$var$longFormatters = {
    p: $333bfdbfbcef01d5$var$timeLongFormatter,
    P: $333bfdbfbcef01d5$var$dateTimeLongFormatter
};
var $333bfdbfbcef01d5$export$2e2bcd8739ae039 = $333bfdbfbcef01d5$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $02d65064b5e7ac64$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $08d51059a622f3b3$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $08d51059a622f3b3$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $08d51059a622f3b3$export$c6cc36aa33304772(token) {
    return $08d51059a622f3b3$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $08d51059a622f3b3$export$c6b49d6dceb604a1(token) {
    return $08d51059a622f3b3$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $08d51059a622f3b3$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $8f722a6e33a91f29$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $8f722a6e33a91f29$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8f722a6e33a91f29$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $8f722a6e33a91f29$export$2e2bcd8739ae039 = $8f722a6e33a91f29$var$formatDistance;


function $a2c60837ee08d10e$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $d0f3297f217f9df7$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $d0f3297f217f9df7$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $d0f3297f217f9df7$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $d0f3297f217f9df7$var$formatLong = {
    date: (0, $a2c60837ee08d10e$export$2e2bcd8739ae039)({
        formats: $d0f3297f217f9df7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $a2c60837ee08d10e$export$2e2bcd8739ae039)({
        formats: $d0f3297f217f9df7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $a2c60837ee08d10e$export$2e2bcd8739ae039)({
        formats: $d0f3297f217f9df7$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d0f3297f217f9df7$export$2e2bcd8739ae039 = $d0f3297f217f9df7$var$formatLong;


var $1e3da001809e3073$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $1e3da001809e3073$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $1e3da001809e3073$var$formatRelativeLocale[token];
};
var $1e3da001809e3073$export$2e2bcd8739ae039 = $1e3da001809e3073$var$formatRelative;


function $46c4a742d3c0d934$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $bf2af30df12ee520$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $bf2af30df12ee520$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $bf2af30df12ee520$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $bf2af30df12ee520$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $bf2af30df12ee520$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $bf2af30df12ee520$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $bf2af30df12ee520$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $bf2af30df12ee520$var$localize = {
    ordinalNumber: $bf2af30df12ee520$var$ordinalNumber,
    era: (0, $46c4a742d3c0d934$export$2e2bcd8739ae039)({
        values: $bf2af30df12ee520$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $46c4a742d3c0d934$export$2e2bcd8739ae039)({
        values: $bf2af30df12ee520$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $46c4a742d3c0d934$export$2e2bcd8739ae039)({
        values: $bf2af30df12ee520$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $46c4a742d3c0d934$export$2e2bcd8739ae039)({
        values: $bf2af30df12ee520$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $46c4a742d3c0d934$export$2e2bcd8739ae039)({
        values: $bf2af30df12ee520$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $bf2af30df12ee520$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $bf2af30df12ee520$export$2e2bcd8739ae039 = $bf2af30df12ee520$var$localize;


function $f1e77230b76218cf$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f1e77230b76218cf$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f1e77230b76218cf$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f1e77230b76218cf$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f1e77230b76218cf$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $20dd9cc5e1f582c1$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $26146e6f7c7a8326$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $26146e6f7c7a8326$var$parseOrdinalNumberPattern = /\d+/i;
var $26146e6f7c7a8326$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $26146e6f7c7a8326$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $26146e6f7c7a8326$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $26146e6f7c7a8326$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $26146e6f7c7a8326$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $26146e6f7c7a8326$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $26146e6f7c7a8326$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $26146e6f7c7a8326$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $26146e6f7c7a8326$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $26146e6f7c7a8326$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $26146e6f7c7a8326$var$match = {
    ordinalNumber: (0, $20dd9cc5e1f582c1$export$2e2bcd8739ae039)({
        matchPattern: $26146e6f7c7a8326$var$matchOrdinalNumberPattern,
        parsePattern: $26146e6f7c7a8326$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $f1e77230b76218cf$export$2e2bcd8739ae039)({
        matchPatterns: $26146e6f7c7a8326$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26146e6f7c7a8326$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $f1e77230b76218cf$export$2e2bcd8739ae039)({
        matchPatterns: $26146e6f7c7a8326$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26146e6f7c7a8326$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $f1e77230b76218cf$export$2e2bcd8739ae039)({
        matchPatterns: $26146e6f7c7a8326$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26146e6f7c7a8326$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $f1e77230b76218cf$export$2e2bcd8739ae039)({
        matchPatterns: $26146e6f7c7a8326$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26146e6f7c7a8326$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $f1e77230b76218cf$export$2e2bcd8739ae039)({
        matchPatterns: $26146e6f7c7a8326$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $26146e6f7c7a8326$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $26146e6f7c7a8326$export$2e2bcd8739ae039 = $26146e6f7c7a8326$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $b89cccdb5f3a64a0$var$locale = {
    code: 'en-US',
    formatDistance: (0, $8f722a6e33a91f29$export$2e2bcd8739ae039),
    formatLong: (0, $d0f3297f217f9df7$export$2e2bcd8739ae039),
    formatRelative: (0, $1e3da001809e3073$export$2e2bcd8739ae039),
    localize: (0, $bf2af30df12ee520$export$2e2bcd8739ae039),
    match: (0, $26146e6f7c7a8326$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b89cccdb5f3a64a0$export$2e2bcd8739ae039 = $b89cccdb5f3a64a0$var$locale;


var $8b002a28e5105849$export$2e2bcd8739ae039 = (0, $b89cccdb5f3a64a0$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $60bff58474b1dc6b$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $60bff58474b1dc6b$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $60bff58474b1dc6b$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $60bff58474b1dc6b$var$doubleQuoteRegExp = /''/g;
var $60bff58474b1dc6b$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $60bff58474b1dc6b$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $1db915e27b88517f$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $e19150f502eef51c$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8b002a28e5105849$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $6650722b7068ae8f$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $6650722b7068ae8f$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $74f9dca938597185$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $28d4c96bde8f233e$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $02d65064b5e7ac64$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $32d15ab0bed6814b$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($60bff58474b1dc6b$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $333bfdbfbcef01d5$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($60bff58474b1dc6b$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $60bff58474b1dc6b$var$cleanEscapedString(substring);
        var formatter = (0, $fc48ff6281d88e3c$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $08d51059a622f3b3$export$c6b49d6dceb604a1)(substring)) (0, $08d51059a622f3b3$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $08d51059a622f3b3$export$c6cc36aa33304772)(substring)) (0, $08d51059a622f3b3$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($60bff58474b1dc6b$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $60bff58474b1dc6b$var$cleanEscapedString(input) {
    var matched = input.match($60bff58474b1dc6b$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($60bff58474b1dc6b$var$doubleQuoteRegExp, "'");
}





var $lCzvA = parcelRequire("lCzvA");

//#region src/components/Menu/index.jsx
var $36411d1c16b6a683$export$2e2bcd8739ae039 = ({ children: a, className: o, unstyled: s, ...c })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("nav", {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-Menu": !0,
            "p-2 border border-neutral-100 bg-white shadow-hover": !s,
            [o]: o
        }),
        "data-testid": "sash-menu",
        ...c,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c169cb583646f905$export$2e2bcd8739ae039), {
            bullets: "none",
            children: (0, $lCzvA.Children)?.toArray(a)?.map((e)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                    children: (0, $lCzvA.cloneElement)(e)
                }, e.key))
        })
    });




//#region src/components/Menu/Item/index.jsx
var $c5b58a39033989d7$export$2e2bcd8739ae039 = ({ iconLeft: i, iconRight: a, renderAs: o, className: s, children: c, ...l })=>{
    let u = l.onClick && !l.href || o === "button", d = l.href || o === "a", f = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-MenuItem flex gap-x-2 p-2 text-base text-neutral-850 font-normal w-full text-left": !0,
        "no-underline hover:text-black focus:text-black active:text-black hover:bg-black-05 focus:bg-black-05 active:bg-neutral-200": d || u || l.to || o,
        [s]: s
    }), p;
    return p = o || (l.href ? "a" : l.onClick ? "button" : "div"), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(p, {
        className: f,
        "data-testid": "sash-menu-item",
        rel: d ? "noopener noreferrer" : void 0,
        type: u ? "button" : void 0,
        ...l,
        children: [
            i && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: i
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: "flex-1",
                children: c
            }),
            a && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: a
            })
        ]
    });
};
$c5b58a39033989d7$export$2e2bcd8739ae039.displayName = "MenuItem";



var $lCzvA = parcelRequire("lCzvA");








const $812b6cdca7c5740d$export$85a5dac2e3e4abe9 = 260;
const $812b6cdca7c5740d$export$8b90b663d08de585 = {
    AppName: 'equipment-action-portal',
    AppDisplayName: 'Equipment Action Portal',
    AppDescription: 'Web App to initiate and manage equipment action requests',
    Scopes: [
        'openid',
        'profile',
        'email',
        'offline_access',
        'ApiGw.account',
        'ApiGw.thrive',
        'ApiGw.appl-user',
        'ApiGw.app-analytics',
        'ApiGw.teammembers',
        'ApiGw.org-management',
        'ApiGw.inv-mgmt'
    ],
    WhatsNewFeatureKey: 31
};
const $812b6cdca7c5740d$export$33f6caeb800830ab = {
    LoginButtonText: 'Login'
};
const $812b6cdca7c5740d$export$305c559ace941473 = [
    {
        name: 'DEV',
        instanceID: 'EBSDEV'
    },
    {
        name: 'DEV2',
        instanceID: 'EBSDEV2'
    },
    {
        name: 'DEV3',
        instanceID: 'EBSDEV3'
    },
    {
        name: 'DEV4',
        instanceID: 'EBSDEV4'
    },
    {
        name: 'DEV5',
        instanceID: 'EBSDEV5'
    },
    {
        name: 'DEV6',
        instanceID: 'EBSDEV6'
    }
];
const $812b6cdca7c5740d$export$7d91b78b47a2a176 = ()=>{
    const apiUrl = window.REACT_APP_API_URL || '';
    if (apiUrl.includes('apidev')) return 'EBSDEV3';
    else if (apiUrl.includes('apiqa')) return 'EBSQA';
    return 'EBSPROD';
};
const $812b6cdca7c5740d$export$c05553602b8efb2 = {
    issuer: window.REACT_APP_OKTA_ISSUER ?? undefined,
    clientId: window.REACT_APP_OKTA_CLIENTID ?? undefined,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: [
        'openid',
        'profile',
        'email',
        'offline_access',
        'ApiGw.account',
        'ApiGw.thrive',
        'ApiGw.appl-user',
        'ApiGw.app-analytics',
        'ApiGw.teammembers',
        'ApiGw.org-management',
        'ApiGw.inv-mgmt'
    ],
    pkce: true,
    disableHttpsCheck: window.OKTA_TESTING_DISABLEHTTPSCHECK || false,
    postLogoutRedirectUri: window.REACT_POST_LOGOUT_URL ?? undefined
};
const $812b6cdca7c5740d$export$4930ad0f31af2a99 = {
    show: true
};
const $812b6cdca7c5740d$export$99755cdd489d7548 = {
    show: false
};
const $812b6cdca7c5740d$export$b51facfa5144170b = {
    show: true
};
const $812b6cdca7c5740d$export$cc0d9093ba5d2a7 = true; // used in Work Order Edit page to auto assign next wo if desired
const $812b6cdca7c5740d$export$cf8d2d886ddb164f = true; // can use this to turn off teams messages for testing



// The production hostname branch cannot be covered in a jsdom test environment.
/* istanbul ignore next */ const $d2aa929a4a4e56ef$var$leanTechApiUrl = window.location.hostname === 'equipment-action-portal.pella.com' ? 'https://thriveapi.pella.com' : 'https://thrivetestapi.pella.com';
/* istanbul ignore next */ const $d2aa929a4a4e56ef$var$leanTechFetch = async (url, options = {})=>{
    const instanceName = (0, $812b6cdca7c5740d$export$7d91b78b47a2a176)();
    const headers = {
        'Content-Type': 'application/json',
        scopeID: instanceName === 'EBSPROD' ? '952a653a-8152-43e3-8bde-1f5bd991630c' : '3809414a-644a-4f20-b073-c80a1b4c7b5d',
        tenantID: instanceName === 'EBSPROD' ? '1F773DFE-0668-49F6-B8B0-E711CF4BDC2B' : '2AE38024-DCFD-41EA-B76E-54C8D41D3C22'
    };
    const response = await fetch(url, {
        headers: headers,
        ...options
    });
    const data = await response.json();
    return {
        status: response.status,
        data: data
    };
};
const $d2aa929a4a4e56ef$export$2a9d0c043f4d93d8 = (equipNum)=>{
    const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).THRIVE_EQUIPMENT_BY_NUMBER,
            equipNum
        ],
        queryFn: async ()=>{
            const { data: json } = await $d2aa929a4a4e56ef$var$leanTechFetch(`${$d2aa929a4a4e56ef$var$leanTechApiUrl}/api/CSTM_Equipment/EquipNum/${equipNum}`);
            const result = (0, $99d7053f0c3be9ff$export$d6e674a4deb375c5)({
                data: json
            });
            if (!result) throw new Error('Equipment not found');
            return result;
        },
        enabled: Boolean(equipNum),
        staleTime: Number.POSITIVE_INFINITY
    });
    return {
        equipment: data,
        equipmentIsLoading: isLoading,
        equipmentIsSuccess: isSuccess,
        equipmentIsError: isError,
        equipmentError: error
    };
};
const $d2aa929a4a4e56ef$export$df393d9d9ad30fde = ()=>{
    const { mutateAsync: mutateAsync, isPending: isPending } = (0, $957614eff0380312$export$609860bf8b0084c)({
        mutationFn: async (event)=>{
            try {
                const response = await $d2aa929a4a4e56ef$var$leanTechFetch(`${$d2aa929a4a4e56ef$var$leanTechApiUrl}/api/CSTM_StartDowntimeEvent`, {
                    method: 'POST',
                    body: JSON.stringify(event)
                });
                if (response.status === 201 && response.data) return {
                    ...response,
                    data: {
                        nextTech: response.data.NextTech,
                        id: response.data.ID,
                        projNum: response.data.PROJNUM,
                        projTypeId: response.data.PROJTYPEID,
                        taskTypeId: response.data.TASKTYPEID,
                        requestedBy: response.data.REQUESTEDBY,
                        requestedByFN: response.data.REQUESTEDBYFN,
                        requestedByLN: response.data.REQUESTEDBYLN,
                        siteId: response.data.SITEID,
                        description: response.data.DESCRIPTION,
                        comments: response.data.COMMENTS,
                        dateRequest: response.data.DATEREQUEST,
                        timeRequest: response.data.TIMEREQUEST,
                        dateDue: response.data.DATEDUE,
                        priority: response.data.PRIORITY,
                        status: response.data.STATUS,
                        unplanned: response.data.UNPLANNED,
                        approvedBy: response.data.APPROVEDBY,
                        appByFirstName: response.data.APPBYFIRSTNAME,
                        appByLastName: response.data.APPBYLASTNAME,
                        isRequest: response.data.ISREQUEST,
                        deleted: response.data.DELETED,
                        pctComplete: response.data.PCTCOMPLETE,
                        pickList06: response.data.PickList06,
                        isDowntime: response.data.IsDowntime,
                        dateRequestUTC: response.data.DateRequestUTC
                    }
                };
                return response;
            } catch (error) {
                return error.response;
            }
        }
    });
    return {
        startDowntimeEvent: mutateAsync,
        isStartingDowntimeEvent: isPending
    };
};
const $d2aa929a4a4e56ef$export$1e5456b5c8005e7b = ()=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    /**
   * Fetch spare parts for a given work order / equipment
   * @param {SparePartsParams} params
   * @returns {object} Query result with spare parts list
   */ // @ts-ignore
    const useSpareParts = ({ equipnumber: equipnumber, partnum: partnum = null, projNum: projNum = null, sparecode: sparecode = null } = {})=>{
        const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
            queryKey: [
                (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).THRIVE_SPARE_PARTS,
                equipnumber,
                partnum,
                projNum,
                sparecode
            ],
            // @ts-ignore
            queryFn: ()=>api.thrive.getSpareParts({
                    equipnumber: equipnumber,
                    partnum: partnum,
                    projNum: projNum,
                    sparecode: sparecode
                }),
            enabled: apiReady && Boolean(equipnumber),
            staleTime: Number.POSITIVE_INFINITY
        });
        return {
            spareParts: data,
            sparePartsIsLoading: isLoading,
            sparePartsIsSuccess: isSuccess,
            sparePartsIsError: isError,
            sparePartsError: error
        };
    };
    /**
   * Fetch a list of projects, optionally filtered by assignment or project number
   * @param {ProjectsParams} params
   * @returns {object} Query result with projects list
   */ const useProjects = ({ assignedTo: assignedTo, projNum: projNum, projid: projid } = {})=>{
        const enabled = apiReady && (Boolean(assignedTo) || Boolean(projNum) || Boolean(projid));
        const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
            queryKey: [
                (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).THRIVE_PROJECTS,
                assignedTo,
                projNum,
                projid
            ],
            // @ts-ignore
            queryFn: ()=>api.thrive.getProjects({
                    assignedTo: assignedTo,
                    projNum: projNum,
                    projid: projid
                }),
            enabled: enabled,
            staleTime: Number.POSITIVE_INFINITY
        });
        return {
            projects: data,
            projectsIsLoading: isLoading,
            projectsIsSuccess: isSuccess,
            projectsIsError: isError,
            projectsError: error
        };
    };
    /**
   * Fetch all equipment for a given site
   * @param {string} siteId - The site ID
   * @returns {object} Query result with equipment list
   */ const useEquipment = (siteId)=>{
        const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
            queryKey: [
                (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).THRIVE_EQUIPMENT,
                siteId
            ],
            // @ts-ignore
            queryFn: ()=>api.thrive.getEquipment({
                    siteId: siteId
                }),
            enabled: apiReady && Boolean(siteId),
            staleTime: Number.POSITIVE_INFINITY
        });
        return {
            equipment: data,
            equipmentIsLoading: isLoading,
            equipmentIsSuccess: isSuccess,
            equipmentIsError: isError,
            equipmentError: error
        };
    };
    /**
   * Fetch user default preferences for an employee (site, department, display name)
   * @param {string} employeeId - The employee user ID
   * @returns {object} Query result with user defaults
   */ const useEmployeeUserDefaults = (employeeId)=>{
        const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
            queryKey: [
                (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).THRIVE_EMPLOYEE_USER_DEFAULTS,
                employeeId
            ],
            // @ts-ignore
            queryFn: ()=>api.thrive.getEmployeeUserDefaults({
                    employeeId: employeeId
                }),
            enabled: apiReady && Boolean(employeeId),
            staleTime: Number.POSITIVE_INFINITY
        });
        return {
            userDefaults: data,
            userDefaultsIsLoading: isLoading,
            userDefaultsIsSuccess: isSuccess,
            userDefaultsIsError: isError,
            userDefaultsError: error
        };
    };
    /**
   * Fetch the current user status for an employee
   * @param {string} employeeId - The employee user ID
   * @returns {object} Query result with user status
   */ const useEmployeeUserStatus = (employeeId)=>{
        const { data: data, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
            queryKey: [
                (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).THRIVE_EMPLOYEE_USER_STATUS,
                employeeId
            ],
            // @ts-ignore
            queryFn: ()=>api.thrive.getEmployeeUserStatus({
                    employeeId: employeeId
                }),
            enabled: apiReady && Boolean(employeeId),
            staleTime: Number.POSITIVE_INFINITY
        });
        return {
            userStatus: data,
            userStatusIsLoading: isLoading,
            userStatusIsSuccess: isSuccess,
            userStatusIsError: isError,
            userStatusError: error
        };
    };
    /**
   * Mutation to add a project assignment for the current user.
   * Shows a toast on success or failure.
   * @returns {object}
   */ const useAddAssignment = ()=>(0, $957614eff0380312$export$609860bf8b0084c)({
            // @ts-ignore
            mutationFn: (/** @type {AddAssignmentParams} */ params)=>api.thrive.addProjectAssignment(params),
            onSuccess: ()=>{
                (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Assignment added successfully.');
            },
            onError: (error)=>{
                (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(`Failed to add assignment: ${error.message}`);
            }
        });
    return {
        useSpareParts: useSpareParts,
        useProjects: useProjects,
        useEquipment: useEquipment,
        useEquipmentByNumber: $d2aa929a4a4e56ef$export$2a9d0c043f4d93d8,
        useStartDowntimeEvent: $d2aa929a4a4e56ef$export$df393d9d9ad30fde,
        useEmployeeUserDefaults: useEmployeeUserDefaults,
        useEmployeeUserStatus: useEmployeeUserStatus,
        useAddAssignment: useAddAssignment
    };
};




/**
 * Parses the equipment ID from a scanner URL.
 * @param {string} url - The scanned URL string containing query parameters.
 * @returns {string | null} The extracted equipment ID value, or null if not present.
 */ const $ec4f796dd860a46e$var$parseURL = (url)=>{
    try {
        return new URL(url).searchParams.get('equip-id');
    } catch  {
        return null;
    }
};
const $ec4f796dd860a46e$export$5bd44676153f462 = ()=>{
    const [searchParams, setSearchParams] = (0, $c3aca08c2a74646e$export$f1a78c17382fe22a)();
    const { startCamera: startCamera } = (0, $78b54bd991d76db4$export$91d88843bfb219ae)();
    const { t: t } = (0, $8216e3af17948d6d$export$9fc83ad70ead8663)();
    const { useEquipmentByNumber: useEquipmentByNumber } = (0, $d2aa929a4a4e56ef$export$1e5456b5c8005e7b)();
    const queryStringEquipID = searchParams.get('equip-id');
    const { equipment: fetchedEquipment, equipmentIsError: equipmentIsError } = useEquipmentByNumber(queryStringEquipID);
    const selectedEquipment = fetchedEquipment ?? null;
    const scanAgainVisible = !selectedEquipment;
    // Toast on query error — legitimate effect (side-effect synced to external toast system)
    const prevIsErrorRef = (0, $lCzvA.useRef)(false);
    (0, $lCzvA.useEffect)(()=>{
        if (equipmentIsError && !prevIsErrorRef.current) (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(t('equipmentNotFoundContent'));
        prevIsErrorRef.current = equipmentIsError;
    }, [
        equipmentIsError,
        t
    ]);
    const writeEquipId = (equipNum)=>{
        setSearchParams((prev)=>{
            const next = new URLSearchParams(prev);
            if (equipNum === null) next.delete('equip-id');
            else next.set('equip-id', equipNum);
            return next;
        }, {
            replace: true
        });
    };
    const handleScannerRead = (value)=>{
        const equipNum = $ec4f796dd860a46e$var$parseURL(value);
        writeEquipId(equipNum);
        (0, $673b1c81cc441170$export$2e2bcd8739ae039).info(`${t('scannedValue')}: ${equipNum}`);
    };
    const handleScanAgain = ()=>startCamera(handleScannerRead);
    const reset = ()=>{
        writeEquipId(null);
    };
    return {
        selectedEquipment: selectedEquipment,
        scanAgainVisible: scanAgainVisible,
        handleScanAgain: handleScanAgain,
        reset: reset
    };
};



var $lCzvA = parcelRequire("lCzvA");







const $65d40bec8f7be834$export$66d9a42514250712 = ()=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    return (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).SITES
        ],
        queryFn: ()=>api.teamMemberData.getAllSites(),
        staleTime: Number.POSITIVE_INFINITY,
        enabled: Boolean(apiReady)
    });
};


const $3d7d116b7d981267$export$ea83d22a52a72eef = (badgeNumber)=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { data: sites } = (0, $65d40bec8f7be834$export$66d9a42514250712)();
    const { data: data, isLoading: isLoading, isError: isError, error: error } = (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).TEAM_MEMBER_DATA,
            badgeNumber
        ],
        queryFn: async ()=>{
            const result = await api.teamMember.getTeamMemberByBadgeNumber(String(badgeNumber));
            if (!result) throw new Error('Team Member not found');
            return result;
        },
        enabled: Boolean(apiReady) && Boolean(badgeNumber),
        staleTime: 300000
    });
    // Add site data to team member when data is available
    const matchedSite = Array.isArray(sites) ? sites.find((item)=>item.OIMSiteID === data?.location_code) : undefined;
    const teamMember = data ? {
        ...data,
        ...matchedSite !== undefined ? {
            site: matchedSite
        } : {}
    } : data;
    return {
        data: teamMember,
        isLoading: isLoading,
        isError: isError,
        error: error
    };
};


const $393626fa4b1ec120$export$c1b2e214b3d5d559 = ()=>{
    const [empNumber, setEmpNumber] = (0, $lCzvA.useState)('');
    const [queryEmpNumber, setQueryEmpNumber] = (0, $lCzvA.useState)('');
    const debouncedSetRef = (0, $lCzvA.useRef)((0, $99d7053f0c3be9ff$export$61fc7d43ac8f84b0)(setQueryEmpNumber, 2000));
    const { data: employeeDetails } = (0, $3d7d116b7d981267$export$ea83d22a52a72eef)(queryEmpNumber);
    const empNumberChangeHandler = (e)=>{
        const val = e.target.value;
        setEmpNumber(val);
        debouncedSetRef.current(val);
    };
    const reset = ()=>{
        setEmpNumber('');
        setQueryEmpNumber('');
    };
    return {
        empNumber: empNumber,
        employeeDetails: employeeDetails,
        empNumberChangeHandler: empNumberChangeHandler,
        reset: reset
    };
};



var $lCzvA = parcelRequire("lCzvA");
const $64799e446cc92935$export$d9e43d3a234a39e4 = [
    {
        serviceArea: 'Maintenance',
        enabled: true,
        i18nTranslationKey: 'maintenance'
    },
    {
        serviceArea: 'Quality',
        enabled: false,
        i18nTranslationKey: 'quality'
    },
    {
        serviceArea: 'Department Manager',
        enabled: false,
        i18nTranslationKey: 'departmentManager'
    }
];
const $64799e446cc92935$export$28fa3e6ad37f096b = [
    {
        serviceArea: 'Maintenance',
        item: 'Line Down',
        itemValue: 'Line Down',
        enabled: true,
        i18nTranslationKey: 'lineDown'
    },
    {
        serviceArea: 'Maintenance',
        item: 'Machine Down',
        itemValue: 'Machine Down',
        enabled: true,
        i18nTranslationKey: 'machineDown'
    },
    {
        serviceArea: 'Maintenance',
        item: 'Planned Repair (<5 hrs)',
        itemValue: 'Planned Repair',
        enabled: true,
        i18nTranslationKey: 'plannedRepair'
    },
    {
        serviceArea: 'Quality',
        item: 'Default',
        itemValue: 'Default',
        enabled: true,
        i18nTranslationKey: 'default'
    },
    {
        serviceArea: 'Department Manager',
        item: 'Default',
        itemValue: 'Default',
        enabled: true,
        i18nTranslationKey: 'default'
    }
];


const $9fac1313a4174d74$export$96a5b910ec03cb55 = ()=>{
    const [serviceAreaSelected, setServiceAreaSelected] = (0, $lCzvA.useState)({
        serviceArea: '',
        enabled: true
    });
    const [serviceActionSelected, setServiceActionSelected] = (0, $lCzvA.useState)({
        serviceArea: '',
        item: '',
        itemValue: '',
        enabled: true
    });
    const filteredServiceAreas = (0, $64799e446cc92935$export$d9e43d3a234a39e4).filter((item)=>item.enabled === true);
    const filteredServiceActions = (0, $64799e446cc92935$export$28fa3e6ad37f096b).filter((item)=>item.serviceArea === serviceAreaSelected.serviceArea && item.enabled === true);
    const handleServiceAreaChange = (event)=>{
        setServiceAreaSelected(event);
        setServiceActionSelected({
            serviceArea: '',
            item: '',
            itemValue: '',
            enabled: true
        });
    };
    const handleServiceActionChange = (event)=>{
        setServiceActionSelected(event);
    };
    const reset = ()=>{
        setServiceAreaSelected({
            serviceArea: '',
            enabled: true
        });
        setServiceActionSelected({
            serviceArea: '',
            item: '',
            itemValue: '',
            enabled: true
        });
    };
    return {
        serviceAreaSelected: serviceAreaSelected,
        serviceActionSelected: serviceActionSelected,
        filteredServiceAreas: filteredServiceAreas,
        filteredServiceActions: filteredServiceActions,
        handleServiceAreaChange: handleServiceAreaChange,
        handleServiceActionChange: handleServiceActionChange,
        reset: reset
    };
};



var $lCzvA = parcelRequire("lCzvA");




const $817ca2e0f8ec1527$var$postToTeams = (url, body)=>{
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    }).catch((error)=>{
        // eslint-disable-next-line no-console
        console.error(error);
    });
};
const $817ca2e0f8ec1527$export$bae683cb2df54a88 = (body)=>{
    const apiVersion = '2020-05-01-preview';
    const sp = '%2Ftriggers%2Fmanual%2Frun';
    const sv = '1.0';
    const sig = 't58e9nwmYASTftlw8fafVzeR4_0SRWLv4iAjtEA59ng';
    $817ca2e0f8ec1527$var$postToTeams(`https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsChat/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};
const $817ca2e0f8ec1527$export$50185c234a159a5c = (body)=>{
    const apiVersion = '2020-05-01-preview';
    const sp = '%2Ftriggers%2Fmanual%2Frun';
    const sv = '1.0';
    const sig = 't58e9nwmYASTftlw8fafVzeR4_0SRWLv4iAjtEA59ng';
    $817ca2e0f8ec1527$var$postToTeams(`https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsChat/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};
const $817ca2e0f8ec1527$export$382846bb93b4cfe7 = (body)=>{
    const apiVersion = '2022-05-01';
    const sp = '%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun';
    const sv = '1.0';
    const sig = 'nyJnvCTXl4HWuvmUfS4oW3VpWiSjgXD5SN2Un25VJVg';
    $817ca2e0f8ec1527$var$postToTeams(`https://thrive.azurewebsites.net/api/TeamsChat/triggers/When_a_HTTP_request_is_received/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};
const $817ca2e0f8ec1527$export$f72ff302e9e9265c = (body)=>{
    const apiVersion = '2020-05-01-preview';
    const sp = '%2Ftriggers%2Fmanual%2Frun';
    const sv = '1.0';
    const sig = 'H6g8CugT_NbHMiplBk0FddNRO_AHFRrimbcqWHQmMso';
    $817ca2e0f8ec1527$var$postToTeams(`https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsChannel/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};
const $817ca2e0f8ec1527$export$18f9ea83ceaa7c1d = (body)=>{
    const apiVersion = '2020-05-01-preview';
    const sp = '%2Ftriggers%2Fmanual%2Frun';
    const sv = '1.0';
    const sig = 'H6g8CugT_NbHMiplBk0FddNRO_AHFRrimbcqWHQmMso';
    $817ca2e0f8ec1527$var$postToTeams(`https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsChannel/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};
const $817ca2e0f8ec1527$export$6b197867394738f7 = (body)=>{
    const apiVersion = '2022-05-01';
    const sp = '%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun';
    const sv = '1.0';
    const sig = 'qEv63et0tCFaDvTs5uJNDxnF2IABcQbuRavj922NhLw';
    $817ca2e0f8ec1527$var$postToTeams(`https://thrive.azurewebsites.net/api/TeamsChannel/triggers/When_a_HTTP_request_is_received/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};
const $817ca2e0f8ec1527$export$f6327b3db2cbbddd = (body)=>{
    const apiVersion = '2020-05-01-preview';
    const sp = '%2Ftriggers%2Fmanual%2Frun';
    const sv = '1.0';
    const sig = 'QmT_uLx_gg9NRTn-9DAZVpYpnxYhGOfSd52RSXAO4u4';
    $817ca2e0f8ec1527$var$postToTeams(`https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsCardChat/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};
const $817ca2e0f8ec1527$export$dcd8a0b9f350682e = (body)=>{
    const apiVersion = '2020-05-01-preview';
    const sp = '%2Ftriggers%2Fmanual%2Frun';
    const sv = '1.0';
    const sig = 'QmT_uLx_gg9NRTn-9DAZVpYpnxYhGOfSd52RSXAO4u4';
    $817ca2e0f8ec1527$var$postToTeams(`https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsCardChat/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};
const $817ca2e0f8ec1527$export$aaeb15b9eb33e625 = (body)=>{
    const apiVersion = '2022-05-01';
    const sp = '%2Ftriggers%2FWhen_a_HTTP_request_is_received';
    const sv = '1.0';
    const sig = '7bn9v2akjdUO2yihZtGX-teCEbo_tJza7Y3qcviz-M8';
    $817ca2e0f8ec1527$var$postToTeams(`https://thrive.azurewebsites.net/api/TeamsCardChat/triggers/When_a_HTTP_request_is_received/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};
const $817ca2e0f8ec1527$export$794aed5ddf43700a = (body)=>{
    const apiVersion = '2020-05-01-preview';
    const sp = '%2Ftriggers%2Fmanual%2Frun';
    const sv = '1.0';
    const sig = 'MoS_ScSFCHp_qXoY6-GdLfQ1MNcj2X32ebriyH2Z0KE';
    $817ca2e0f8ec1527$var$postToTeams(`https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsCardChannel/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};
const $817ca2e0f8ec1527$export$f03ffa152cce707e = (body)=>{
    const apiVersion = '2016-06-01';
    const sp = '%2Ftriggers%2Fmanual%2Frun';
    const sv = '1.0';
    const sig = '8dH5t2a1l3rdxHMwc3b471TEE_rG7ypLrDrvvRJUlRk';
    $817ca2e0f8ec1527$var$postToTeams(`https://prod-48.westus.logic.azure.com:443/workflows/e7063009e5094c379383aa8f171e3f0d/triggers/manual/paths/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};
const $817ca2e0f8ec1527$export$226ce7b10b163718 = (body)=>{
    const apiVersion = '2022-05-01';
    const sp = '%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun';
    const sv = '1.0';
    const sig = 'x2WCWUg7Nb6Zp0lUJha7ZiNl9aXAtHg3P096FmMujEo';
    $817ca2e0f8ec1527$var$postToTeams(`https://thrive.azurewebsites.net/api/TeamsCardChannel/triggers/When_a_HTTP_request_is_received/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`, body);
};


const $5c4434a63a55cfd2$var$siteDetails = [
    {
        siteId: 'Carroll',
        departmentId: null,
        teamsConfig: {
            quality: {
                teamsAddress: '7400b9af-3834-474e-ba1e-ced3fc5e54d7',
                channelId: '19:ef6872f0c2e84cb0a0471dd653d2c5eb@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'a4fc1cf1-a170-4d00-bca2-01bd2bef2276',
                channelId: '19:277aaddfcdac4a6f9fb6bf8f4127ed2a@thread.skype'
            }
        }
    },
    {
        siteId: 'Macomb',
        departmentId: null,
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:4c18e42e8806499796d8819858305bce@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:79116e6ba2024bc5a49cb29fcca3acef@thread.tacv2'
            }
        }
    },
    {
        siteId: 'Murray',
        departmentId: null,
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:014d0149edcd4b74b3d397dcd9fb0c52@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:ba51bb8bf3c04022b36cd09bd7960c91@thread.tacv2'
            }
        }
    },
    {
        siteId: 'Shenandoah',
        departmentId: null,
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:eae35f841d0b4f23b7f4192463b99219@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:a828d41bde6e4efa9f9125cd45121d27@thread.tacv2'
            }
        }
    },
    {
        siteId: 'Sioux Center',
        departmentId: null,
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:072ec97eaf6d4707adf84961fb318367@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:83832e6f38f7486b90863d200ae47f46@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaMfg',
        departmentId: 'Accessory',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:bdcca5c386fe440aa269e6568020ce93@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:af77fc49b3094d2787becd6fb2573673@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaMfg',
        departmentId: 'Service Parts',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:4f37a131ad8f457f823103f4e010b03b@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:f534c5a16ad64e3a863f49fe567d324f@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaMfg',
        departmentId: 'Windows',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:17b060be102b41bda0bc453892d3f570@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:427dd867324340e385cfc0708b92f82a@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaMfg',
        departmentId: 'Door',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:79ef27f6fa6345a7916fb4f0ee117144@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:caf637347f9e4345ab6e51415f5dd397@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaMfg',
        departmentId: 'Metal',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:26a4e8215b3a43258c4d0ed17c694793@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:30f51d60635a423a8b3caa9f067b581f@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaMfg',
        departmentId: 'Lumber',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:2e4e329a47cf4d41b9f3a79a4c60f618@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:cc26ba2164cd49d1b17d6797cf6ff184@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaMfg',
        departmentId: 'DVA',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:e3dd95ce29dc4cd4bcfc51de608c93b6@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:ce1c6224477f4e92a030c4d4e568d97d@thread.tacv2'
            }
        }
    },
    {
        siteId: 'Reidsville',
        departmentId: null,
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:4055034adb97449f9f87f0bc85f195a1@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:4cd265d2c8e540088072de19e04f2229@thread.tacv2'
            }
        }
    },
    {
        siteId: 'Gettysburg',
        departmentId: null,
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:21124c1a5e714445b551ecc0424a5257@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:f70c9f142a984c18ac258bee00e03c2f@thread.tacv2'
            }
        }
    },
    {
        siteId: 'Portland',
        departmentId: null,
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:8a94473b0c0745a7aa7962521ad5eefc@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:c2d5c53652494c63a3a10934f88d04d4@thread.tacv2'
            }
        }
    },
    {
        siteId: 'Troy',
        departmentId: null,
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:e186e3a5d17242f98e1237f3bc5dcd1f@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:3bd16826c4cf47fa83b6ee9c110a8d87@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaPltSrv',
        departmentId: 'Central/Sawdust',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:c7379c5e8a554b4ba3efdf08e3803076@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaPltSrv',
        departmentId: 'Custodial',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:993e3179aa9947488c778541ed77c82d@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:993e3179aa9947488c778541ed77c82d@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaPltSrv',
        departmentId: 'Facilities',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:837c742a78da42f89018014e4a9afbc6@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaPltSrv',
        departmentId: 'Grounds',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:10fc667145a04b2a94f3b25c1f73e3d4@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaPltSrv',
        departmentId: 'HVAC',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:20307edf4255410c876586e6580a072f@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaPltSrv',
        departmentId: 'MES Maintenance',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:d8dc7a57c87646df984ffcb07e065926@thread.tacv2'
            }
        }
    },
    {
        siteId: 'PellaPltSrv',
        departmentId: 'Truck Shop',
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:28d076deef764c239c32f0ba071e2bbc@thread.tacv2'
            }
        }
    },
    {
        siteId: 'Burris',
        departmentId: null,
        teamsConfig: {
            quality: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:0dfbfb0b327c4ae79c0a55530344ade2@thread.tacv2'
            },
            maintenance: {
                teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
                channelId: '19:deeaecedb68b491fa3f2e1a16e68655b@thread.tacv2'
            }
        }
    },
    {
        siteId: 'CWS',
        departmentId: 'CWOCA',
        teamsConfig: {
            quality: {
                teamsAddress: null,
                channelId: null
            },
            maintenance: {
                teamsAddress: 'b6814d50-0b7e-4ab0-9d7e-69a702cda22e',
                channelId: '19:33750e540e0c4fb5b4f8933e0fc7134f@thread.tacv2'
            }
        }
    },
    {
        siteId: 'CWS',
        departmentId: 'CWJAC',
        teamsConfig: {
            quality: {
                teamsAddress: null,
                channelId: null
            },
            maintenance: {
                teamsAddress: 'b6814d50-0b7e-4ab0-9d7e-69a702cda22e',
                channelId: '19:3341cf4c5e934aa59c04d811f9841733@thread.tacv2'
            }
        }
    },
    {
        siteId: 'Medley',
        departmentId: null,
        teamsConfig: {
            quality: {
                teamsAddress: null,
                channelId: null
            },
            maintenance: {
                teamsAddress: 'b6814d50-0b7e-4ab0-9d7e-69a702cda22e',
                channelId: '19:a10b3d496b5b4d018b7fb2744d491533@thread.tacv2'
            }
        }
    },
    {
        siteId: 'Avanti',
        departmentId: 'AVAZM',
        teamsConfig: {
            quality: {
                teamsAddress: null,
                channelId: null
            },
            maintenance: {
                teamsAddress: '282477d1-38bd-4d73-aba3-8ad31b6e8e0c',
                channelId: '19:vHFhrcHrcMFPpNuX898KvDGzilrDBSoxQ_oUQwAJ1IA1@thread.tacv2'
            }
        }
    }
];
var $5c4434a63a55cfd2$export$2e2bcd8739ae039 = $5c4434a63a55cfd2$var$siteDetails;






const $e00dd12a20730d24$var$ANALYTICS_STORAGE_KEY = 'equipment-action-portal.analytics.rows';
const $e00dd12a20730d24$var$normalizeAnalyticsRow = (row, index = 0)=>{
    if (!row || typeof row !== 'object') return null;
    return {
        id: String(row.id ?? row._id ?? `analytics-row-${index}`),
        lastEntryAt: row.lastEntryAt ?? row.updatedAt ?? row.createdAt ?? null,
        userId: row.userId ?? '',
        userEmail: row.userEmail ?? '',
        empNumber: row.empNumber ?? row.employeeId ?? row.employeeNumber ?? '',
        equipmentNumber: row.equipmentNumber ?? '',
        siteId: row.siteId ?? '',
        serviceArea: row.serviceArea ?? '',
        serviceAction: row.serviceAction ?? '',
        comment: row.comment ?? '',
        outcome: row.outcome ?? '',
        arrivedAt: row.arrivedAt ?? null,
        questionAnswers: Array.isArray(row.questionAnswers) ? row.questionAnswers : [],
        cancellationReason: row.cancellationReason ?? '',
        cancellationReasonDetails: row.cancellationReasonDetails ?? '',
        qaEngagement: row.qaEngagement ?? null
    };
};
const $e00dd12a20730d24$export$b9d435f665881d3c = (rows)=>{
    let candidateRows = [];
    const payload = rows && typeof rows === 'object' ? /** @type {{rows?: unknown, items?: unknown, data?: unknown}} */ rows : null;
    if (Array.isArray(rows)) candidateRows = rows;
    else if (Array.isArray(payload?.rows)) candidateRows = payload.rows;
    else if (Array.isArray(payload?.items)) candidateRows = payload.items;
    else if (Array.isArray(payload?.data)) candidateRows = payload.data;
    return candidateRows.map((row, index)=>$e00dd12a20730d24$var$normalizeAnalyticsRow(row, index)).filter(Boolean);
};
const $e00dd12a20730d24$var$safeParseRows = (rawRows)=>{
    if (!rawRows) return [];
    try {
        return JSON.parse(rawRows);
    } catch  {
        return [];
    }
};
const $e00dd12a20730d24$export$6dc079a833fdd05 = ()=>{
    if (typeof window === 'undefined' || !window.localStorage) return [];
    return $e00dd12a20730d24$export$b9d435f665881d3c($e00dd12a20730d24$var$safeParseRows(window.localStorage.getItem($e00dd12a20730d24$var$ANALYTICS_STORAGE_KEY)));
};
const $e00dd12a20730d24$export$f58144b5fd7110e5 = (row)=>{
    if (typeof window === 'undefined' || !window.localStorage) return;
    const existingRows = $e00dd12a20730d24$export$6dc079a833fdd05();
    const nextRows = [
        $e00dd12a20730d24$var$normalizeAnalyticsRow(row),
        ...existingRows
    ].filter(Boolean);
    window.localStorage.setItem($e00dd12a20730d24$var$ANALYTICS_STORAGE_KEY, JSON.stringify(nextRows));
};
const $e00dd12a20730d24$export$b2955d0dd45f8344 = (row)=>{
    if (typeof window === 'undefined' || !window.localStorage) return;
    const existingRows = $e00dd12a20730d24$export$6dc079a833fdd05();
    const normalizedRow = $e00dd12a20730d24$var$normalizeAnalyticsRow(row);
    if (!normalizedRow) return;
    const index = existingRows.findIndex((existingRow)=>existingRow.id === normalizedRow.id);
    if (index === -1) {
        window.localStorage.setItem($e00dd12a20730d24$var$ANALYTICS_STORAGE_KEY, JSON.stringify([
            normalizedRow,
            ...existingRows
        ]));
        return;
    }
    const nextRows = [
        ...existingRows
    ];
    nextRows[index] = {
        ...nextRows[index],
        ...normalizedRow
    };
    window.localStorage.setItem($e00dd12a20730d24$var$ANALYTICS_STORAGE_KEY, JSON.stringify(nextRows));
};
const $e00dd12a20730d24$export$3eeb6730bd05246e = $e00dd12a20730d24$var$ANALYTICS_STORAGE_KEY;


const $fd8a60a16d73d8a8$var$createUserAnalyticsMutation = `
  mutation createUserAnalytics($input: CreateUserAnalyticsInput!) {
    createUserAnalytics(input: $input) {
      id
      success
    }
  }
`;
const $fd8a60a16d73d8a8$var$userAnalyticsRowsQuery = `
  query userAnalyticsRows($limit: Int = 500, $offset: Int = 0, $filters: UserAnalyticsRowsFilters) {
    userAnalyticsRows(limit: $limit, offset: $offset, filters: $filters) {
      id
      lastEntryAt
      userId
      userEmail
      empNumber
      equipmentNumber
      siteId
      serviceArea
      serviceAction
      comment
      outcome
      arrivedAt
      questionAnswers {
        question
        answer
        additionalDetails
        answeredAt
      }
      cancellationReason
      cancellationReasonDetails
      qaEngagement
    }
  }
`;
const $fd8a60a16d73d8a8$var$userAnalyticsRowsCountQuery = `
  query userAnalyticsRowsCount($filters: UserAnalyticsRowsFilters) {
    userAnalyticsRowsCount(filters: $filters)
  }
`;
const $fd8a60a16d73d8a8$var$userAnalyticsFilterOptionsQuery = `
  query userAnalyticsFilterOptions($filters: UserAnalyticsRowsFilters) {
    userAnalyticsFilterOptions(filters: $filters) {
      siteIds
      serviceAreas
      serviceActions
      outcomes
      cancellationReasons
    }
  }
`;
const $fd8a60a16d73d8a8$var$userAnalyticsEngagementSummaryQuery = `
  query userAnalyticsEngagementSummary($filters: UserAnalyticsRowsFilters) {
    userAnalyticsEngagementSummary(filters: $filters) {
      sessionsStarted
      reachedOutcome
      submittedCount
      cancelledCount
      submittedWithQaCount
      highQualitySubmittedCount
      qaAssessedCount
      qaSpentTimeCount
      dailyTrend {
        day
        sessionsCount
        highQualityCount
      }
    }
  }
`;
const $fd8a60a16d73d8a8$var$userAnalyticsExportQuery = `
  query userAnalyticsExport($filters: UserAnalyticsRowsFilters) {
    userAnalyticsExport(filters: $filters) {
      filename
      csv
    }
  }
`;
const $fd8a60a16d73d8a8$var$sanitizeString = (value)=>{
    if (typeof value !== 'string') return undefined;
    const trimmed = value.trim();
    return trimmed || undefined;
};
const $fd8a60a16d73d8a8$var$sanitizeAnalyticsFilters = (filters = {})=>{
    const normalizedFilters = {
        siteId: $fd8a60a16d73d8a8$var$sanitizeString(filters.siteId),
        serviceArea: $fd8a60a16d73d8a8$var$sanitizeString(filters.serviceArea),
        serviceAction: $fd8a60a16d73d8a8$var$sanitizeString(filters.serviceAction),
        outcome: $fd8a60a16d73d8a8$var$sanitizeString(filters.outcome),
        cancellationReason: $fd8a60a16d73d8a8$var$sanitizeString(filters.cancellationReason),
        userId: $fd8a60a16d73d8a8$var$sanitizeString(filters.userId),
        userEmail: $fd8a60a16d73d8a8$var$sanitizeString(filters.userEmail),
        empNumber: $fd8a60a16d73d8a8$var$sanitizeString(filters.empNumber),
        equipmentNumber: $fd8a60a16d73d8a8$var$sanitizeString(filters.equipmentNumber),
        fromLastEntryAt: $fd8a60a16d73d8a8$var$sanitizeString(filters.fromLastEntryAt),
        toLastEntryAt: $fd8a60a16d73d8a8$var$sanitizeString(filters.toLastEntryAt),
        search: $fd8a60a16d73d8a8$var$sanitizeString(filters.search)
    };
    const activeFilterEntries = Object.entries(normalizedFilters).filter(([, value])=>value !== undefined);
    return activeFilterEntries[0] ? Object.fromEntries(activeFilterEntries) : undefined;
};
const $fd8a60a16d73d8a8$export$54183b3c3960b967 = ({ conversationId: conversationId, userLanguage: userLanguage } = {}, options = {})=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    return (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).MAINTENANCE_FOLLOW_UP_QUESTIONS,
            conversationId,
            userLanguage
        ],
        queryFn: ()=>api.maintenanceCopilot.getMaintenanceFollowUpQuestions({
                conversationId: /* istanbul ignore next -- query disabled when conversationId is falsy */ conversationId ?? '',
                userLanguage: userLanguage
            }),
        enabled: apiReady && Boolean(conversationId),
        staleTime: 0,
        ...options
    });
};
const $fd8a60a16d73d8a8$export$56232c8e32e88255 = (options = {})=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const mutationFn = (input)=>api.maintenanceCopilot.getWorkOrderSummary(input);
    return /** @type {import('@tanstack/react-query').UseMutationResult<unknown, Error, unknown>} */ (0, $957614eff0380312$export$609860bf8b0084c)({
        ...options,
        mutationFn: mutationFn
    });
};
const $fd8a60a16d73d8a8$export$aa9d1b129fa147e7 = (options = {})=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const mutationFn = (input)=>api.maintenanceCopilot.createConversation(input);
    return /** @type {import('@tanstack/react-query').UseMutationResult<unknown, Error, unknown>} */ (0, $957614eff0380312$export$609860bf8b0084c)({
        ...options,
        mutationFn: mutationFn
    });
};
const $fd8a60a16d73d8a8$export$3f0a139d1a6afa42 = (options = {})=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const mutationFn = (input)=>api.maintenanceCopilot.createWorkOrderTracking(input);
    return /** @type {import('@tanstack/react-query').UseMutationResult<unknown, Error, unknown>} */ (0, $957614eff0380312$export$609860bf8b0084c)({
        ...options,
        mutationFn: mutationFn
    });
};
const $fd8a60a16d73d8a8$export$d1c6a65964ebeaf8 = (options = {})=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const mutationFn = (input)=>api.maintenanceCopilot._graphqlRequest($fd8a60a16d73d8a8$var$createUserAnalyticsMutation, {
            input: input
        });
    return /** @type {import('@tanstack/react-query').UseMutationResult<unknown, Error, unknown>} */ (0, $957614eff0380312$export$609860bf8b0084c)({
        ...options,
        mutationFn: mutationFn
    });
};
const $fd8a60a16d73d8a8$export$92ff0b970b43cf29 = ({ limit: limit = 500, offset: offset = 0, filters: filters = {} } = {}, options = {})=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const safeFilters = $fd8a60a16d73d8a8$var$sanitizeAnalyticsFilters(filters);
    return (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).USER_ANALYTICS_ROWS,
            limit,
            offset,
            safeFilters
        ],
        queryFn: ()=>{
            const requestedLimit = Number.isFinite(limit) ? Math.trunc(limit) : 500;
            const requestedOffset = Number.isFinite(offset) ? Math.trunc(offset) : 0;
            const safeLimit = Math.max(requestedLimit, 1);
            const safeOffset = Math.min(Math.max(requestedOffset, 0), 1000000);
            return api.maintenanceCopilot._graphqlRequest($fd8a60a16d73d8a8$var$userAnalyticsRowsQuery, {
                limit: safeLimit,
                offset: safeOffset,
                filters: safeFilters
            }).then((rows)=>(0, $e00dd12a20730d24$export$b9d435f665881d3c)(rows).slice(0, safeLimit));
        },
        enabled: true,
        staleTime: 0,
        ...options
    });
};
const $fd8a60a16d73d8a8$export$527b3425616c6e9 = ({ filters: filters = {} } = {}, options = {})=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const safeFilters = $fd8a60a16d73d8a8$var$sanitizeAnalyticsFilters(filters);
    return (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).USER_ANALYTICS_ROWS_COUNT,
            safeFilters
        ],
        queryFn: ()=>api.maintenanceCopilot._graphqlRequest($fd8a60a16d73d8a8$var$userAnalyticsRowsCountQuery, {
                filters: safeFilters
            }).then((count)=>{
                if (Number.isFinite(count)) return Math.max(0, Math.trunc(count));
                const wrappedCount = count && typeof count === 'object' ? /** @type {{ userAnalyticsRowsCount?: unknown }} */ count : null;
                const candidate = Number(wrappedCount?.userAnalyticsRowsCount ?? 0);
                return Number.isFinite(candidate) ? Math.max(0, Math.trunc(candidate)) : 0;
            }),
        enabled: true,
        staleTime: 0,
        ...options
    });
};
const $fd8a60a16d73d8a8$export$4413da5bad6edd97 = ({ filters: filters = {} } = {}, options = {})=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const safeFilters = $fd8a60a16d73d8a8$var$sanitizeAnalyticsFilters(filters);
    return (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).USER_ANALYTICS_FILTER_OPTIONS,
            safeFilters
        ],
        queryFn: ()=>api.maintenanceCopilot._graphqlRequest($fd8a60a16d73d8a8$var$userAnalyticsFilterOptionsQuery, {
                filters: safeFilters
            }).then((data)=>{
                const fallback = {
                    siteIds: [],
                    serviceAreas: [],
                    serviceActions: [],
                    outcomes: [],
                    cancellationReasons: []
                };
                const response = data && typeof data === 'object' ? /** @type {{ userAnalyticsFilterOptions?: object }} */ data : null;
                const optionsPayload = response?.userAnalyticsFilterOptions || data;
                if (!optionsPayload || typeof optionsPayload !== 'object') return fallback;
                return {
                    siteIds: Array.isArray(optionsPayload.siteIds) ? optionsPayload.siteIds : [],
                    serviceAreas: Array.isArray(optionsPayload.serviceAreas) ? optionsPayload.serviceAreas : [],
                    serviceActions: Array.isArray(optionsPayload.serviceActions) ? optionsPayload.serviceActions : [],
                    outcomes: Array.isArray(optionsPayload.outcomes) ? optionsPayload.outcomes : [],
                    cancellationReasons: Array.isArray(optionsPayload.cancellationReasons) ? optionsPayload.cancellationReasons : []
                };
            }),
        enabled: true,
        staleTime: 0,
        ...options
    });
};
const $fd8a60a16d73d8a8$var$EMPTY_ENGAGEMENT_SUMMARY = {
    sessionsStarted: 0,
    reachedOutcome: 0,
    submittedCount: 0,
    cancelledCount: 0,
    submittedWithQaCount: 0,
    highQualitySubmittedCount: 0,
    qaAssessedCount: 0,
    qaSpentTimeCount: 0,
    dailyTrend: []
};
const $fd8a60a16d73d8a8$export$49de258418cceb8f = ({ filters: filters = {} } = {}, options = {})=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const safeFilters = $fd8a60a16d73d8a8$var$sanitizeAnalyticsFilters(filters);
    return (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).USER_ANALYTICS_ENGAGEMENT_SUMMARY,
            safeFilters
        ],
        queryFn: ()=>api.maintenanceCopilot._graphqlRequest($fd8a60a16d73d8a8$var$userAnalyticsEngagementSummaryQuery, {
                filters: safeFilters
            }).then((data)=>{
                const summary = data && typeof data === 'object' ? /** @type {{ userAnalyticsEngagementSummary?: object }} */ data : null;
                const payload = summary?.userAnalyticsEngagementSummary || data;
                if (!payload || typeof payload !== 'object') return $fd8a60a16d73d8a8$var$EMPTY_ENGAGEMENT_SUMMARY;
                const typedPayload = /** @type {typeof EMPTY_ENGAGEMENT_SUMMARY} */ payload;
                return {
                    sessionsStarted: typedPayload.sessionsStarted ?? 0,
                    reachedOutcome: typedPayload.reachedOutcome ?? 0,
                    submittedCount: typedPayload.submittedCount ?? 0,
                    cancelledCount: typedPayload.cancelledCount ?? 0,
                    submittedWithQaCount: typedPayload.submittedWithQaCount ?? 0,
                    highQualitySubmittedCount: typedPayload.highQualitySubmittedCount ?? 0,
                    qaAssessedCount: typedPayload.qaAssessedCount ?? 0,
                    qaSpentTimeCount: typedPayload.qaSpentTimeCount ?? 0,
                    dailyTrend: Array.isArray(typedPayload.dailyTrend) ? typedPayload.dailyTrend : []
                };
            }),
        enabled: true,
        staleTime: 0,
        ...options
    });
};
const $fd8a60a16d73d8a8$export$e19b51e79f0cef08 = (options = {})=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const mutationFn = (filters)=>{
        const safeFilters = $fd8a60a16d73d8a8$var$sanitizeAnalyticsFilters(filters);
        return api.maintenanceCopilot._graphqlRequest($fd8a60a16d73d8a8$var$userAnalyticsExportQuery, {
            filters: safeFilters
        }).then((data)=>{
            const response = data && typeof data === 'object' ? /** @type {{ userAnalyticsExport?: object }} */ data : null;
            const payload = response?.userAnalyticsExport || data;
            return {
                filename: typeof payload?.filename === 'string' ? payload.filename : 'user-analytics-export.csv',
                csv: typeof payload?.csv === 'string' ? payload.csv : ''
            };
        });
    };
    return /** @type {import('@tanstack/react-query').UseMutationResult<{ filename: string, csv: string }, Error, object>} */ (0, $957614eff0380312$export$609860bf8b0084c)({
        ...options,
        mutationFn: mutationFn
    });
};
const $fd8a60a16d73d8a8$export$3cfc7f34f0485f35 = (options = {})=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const mutationFn = (input)=>api.maintenanceCopilot.getTranslation(input);
    return /** @type {import('@tanstack/react-query').UseMutationResult<unknown, Error, unknown>} */ (0, $957614eff0380312$export$609860bf8b0084c)({
        ...options,
        mutationFn: mutationFn
    });
};





const $22c30186782c8364$export$3ae94a2503e890a1 = (date, format)=>{
    let newDate;
    let dateOptions;
    if (date) {
        if (format === 'date') {
            dateOptions = {
                year: 'numeric',
                day: 'numeric',
                month: 'numeric'
            };
            // @ts-ignore
            newDate = new Date(date).toLocaleDateString('en-US', dateOptions);
        } else if (format === 'dateTime') {
            dateOptions = {
                year: 'numeric',
                day: 'numeric',
                month: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'UTC'
            };
            // @ts-ignore
            newDate = new Date(date).toLocaleString('en-US', dateOptions);
        }
    } else newDate = null;
    return newDate;
};
const $22c30186782c8364$export$dd412b56f1e4d8aa = (date, days)=>{
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    // @ts-ignore
    result = $22c30186782c8364$export$3ae94a2503e890a1(result, 'dateTime');
    // @ts-ignore
    return result.replace(',', '');
};
const $22c30186782c8364$export$8f6ba218ec818063 = (date, days)=>{
    let result = new Date(date);
    result.setDate(result.getDate() - days);
    // @ts-ignore
    result = $22c30186782c8364$export$3ae94a2503e890a1(result, 'dateTime');
    // @ts-ignore
    return result.replace(',', '');
};
const $22c30186782c8364$export$4a4306ad4fa0e5e6 = (date, hours)=>{
    let result = new Date(date);
    result.setHours(result.getHours() + hours);
    // @ts-ignore
    result = $22c30186782c8364$export$3ae94a2503e890a1(result, 'dateTime');
    // @ts-ignore
    return result.replace(',', '');
};
const $22c30186782c8364$export$ecf541e09a511845 = (name)=>{
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
};
const $22c30186782c8364$export$260ce70ca30cd65 = (name, value)=>{
    const params = new URLSearchParams(window.location.search);
    params.set(name, value);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState(null, '', newUrl);
};
const $22c30186782c8364$export$962cb8e7aa1c82a = (followUpQuestions)=>followUpQuestions.filter((question)=>question.selectedAnswer !== (0, $a7ed3f1def80a908$export$66b13602a3bd73a9).NONE_SELECTED).map((question)=>({
            id: question.id,
            selectedAnswer: question.selectedAnswer,
            freeTextAnswer: question.additionalDetails
        }));


// The production hostname branch cannot be covered in a jsdom test environment.
/* istanbul ignore next */ const $fee88389624349c9$var$LeanTechAppUrl = window.location.hostname === 'equipment-action-portal.pella.com' ? 'https://thrive.pella.com' : 'https://thrivetest.pella.com';
const $fee88389624349c9$var$getReadableError = (error)=>{
    if (!error) return 'Unknown error';
    if (typeof error === 'string') return error;
    if (error instanceof Error) return error.message || 'Unknown error';
    if (typeof error === 'object') {
        const typedError = /** @type {{ message?: unknown, error?: unknown, data?: unknown }} */ error;
        if (typeof typedError.message === 'string' && typedError.message.trim()) return typedError.message;
        if (typeof typedError.error === 'string' && typedError.error.trim()) return typedError.error;
        if (typedError.data) return $fee88389624349c9$var$getReadableError(typedError.data);
        try {
            return JSON.stringify(error);
        } catch  {
            return 'Unknown error';
        }
    }
    return String(error);
};
const $fee88389624349c9$export$3f408042e593475c = ({ selectedEquipment: selectedEquipment, serviceAreaSelected: serviceAreaSelected, serviceActionSelected: serviceActionSelected, employeeDetails: employeeDetails, comment: comment, isMaintenanceCopilotFlagEnabled: isMaintenanceCopilotFlagEnabled, onSuccess: onSuccess, onConversationCreated: onConversationCreated })=>{
    const { t: t, i18n: i18n } = (0, $8216e3af17948d6d$export$9fc83ad70ead8663)();
    const userLanguage = i18n.language?.slice(0, 2);
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const [isSubmitting, setIsSubmitting] = (0, $lCzvA.useState)(false);
    const [conversationId, setConversationId] = (0, $lCzvA.useState)('');
    const [summaryText, setSummaryText] = (0, $lCzvA.useState)('');
    const [, setSummaryGenerationError] = (0, $lCzvA.useState)(false);
    const [followUpQuestions, setFollowUpQuestions] = (0, $lCzvA.useState)([]);
    const [downtimeStartTime, setDowntimeStartTime] = (0, $lCzvA.useState)(null);
    const [retryDialogOpen, setRetryDialogOpen] = (0, $lCzvA.useState)(false);
    const [retryDialogMessage, setRetryDialogMessage] = (0, $lCzvA.useState)('');
    const { useStartDowntimeEvent: useStartDowntimeEvent } = (0, $d2aa929a4a4e56ef$export$1e5456b5c8005e7b)();
    const { startDowntimeEvent: startDowntimeEvent } = useStartDowntimeEvent();
    const { mutate: createConversation, isPending: loadingCreateConversation } = (0, $fd8a60a16d73d8a8$export$aa9d1b129fa147e7)({
        onSuccess: (data)=>{
            // Loading bar hidden by TanStack Query GlobalLoading
            setConversationId(data?.id);
            onConversationCreated?.(data?.problemDescription);
        },
        onError: (err)=>{
            // Loading bar hidden by TanStack Query GlobalLoading
            setRetryDialogMessage(t('conversationErrorContent', {
                error: err?.message
            }));
            setRetryDialogOpen(true);
        }
    });
    const { mutateAsync: getTranslation } = (0, $fd8a60a16d73d8a8$export$3cfc7f34f0485f35)();
    const { mutate: createTracking } = (0, $fd8a60a16d73d8a8$export$3f0a139d1a6afa42)();
    const sendTeamsResponseToTech = (wo, tech)=>{
        if (!(0, $812b6cdca7c5740d$export$cf8d2d886ddb164f)) return;
        const maintTechUserCard = {
            type: 'AdaptiveCard',
            version: '1.3',
            sendTo: `${tech.usr_login}@pella.com`,
            title: 'Downtime Response Event',
            body: [
                {
                    type: 'Container',
                    items: [
                        {
                            type: 'TextBlock',
                            text: `Maintenance ${serviceActionSelected.item} Event`,
                            size: 'medium',
                            weight: 'bolder',
                            wrap: 'true'
                        },
                        {
                            type: 'TextBlock',
                            spacing: 'none',
                            weight: 'lighter',
                            text: `_Created ${new Date().toLocaleString()}_`,
                            isSubtle: 'true',
                            wrap: 'true'
                        },
                        {
                            type: 'TextBlock',
                            text: `Assigned To: ${tech.first_name}${tech.preferred_name ? `(${tech.preferred_name})` : ''} ${tech.last_name}`,
                            spacing: 'none',
                            wrap: 'true'
                        },
                        {
                            type: 'TextBlock',
                            text: `Submitted by: ${employeeDetails.first_name}${employeeDetails.preferred_name ? `(${employeeDetails.preferred_name})` : ''} ${employeeDetails.last_name}`,
                            wrap: 'true'
                        },
                        {
                            type: 'TextBlock',
                            spacing: 'none',
                            text: `WO: ${wo?.projNum}`,
                            wrap: 'true'
                        },
                        {
                            type: 'TextBlock',
                            spacing: 'none',
                            text: `Dept: ${selectedEquipment?.departmentId}`,
                            wrap: 'true'
                        },
                        {
                            type: 'TextBlock',
                            spacing: 'none',
                            text: `Location: ${selectedEquipment?.location}`,
                            wrap: 'true'
                        },
                        {
                            type: 'TextBlock',
                            spacing: 'none',
                            text: `Equipment#: ${selectedEquipment?.equipNum}`,
                            wrap: 'true'
                        },
                        {
                            type: 'TextBlock',
                            spacing: 'none',
                            text: `Description: ${selectedEquipment?.description}`,
                            wrap: 'true'
                        },
                        {
                            type: 'TextBlock',
                            spacing: 'none',
                            text: `Reason For Outage: ${serviceActionSelected.item}`,
                            wrap: 'true'
                        },
                        {
                            type: 'TextBlock',
                            spacing: 'none',
                            text: `Comment: ${comment}`,
                            wrap: 'true'
                        }
                    ]
                }
            ],
            actions: [
                {
                    type: 'Action.OpenUrl',
                    title: 'Go to Thrive Work Orders',
                    url: `${$fee88389624349c9$var$LeanTechAppUrl}/3/CSTM/MT/Mobile?tbl_id=${wo.id}`
                },
                {
                    type: 'Action.OpenUrl',
                    title: 'Go to Thrive RTS Dashboard',
                    url: `${$fee88389624349c9$var$LeanTechAppUrl}/3/CSTM/MT/Dashboard2?retries=1`
                }
            ]
        };
        if (wo.siteId === 'CWS') (0, $817ca2e0f8ec1527$export$dcd8a0b9f350682e)(maintTechUserCard);
        else if (wo.siteId === 'Avanti') (0, $817ca2e0f8ec1527$export$aaeb15b9eb33e625)(maintTechUserCard);
        else (0, $817ca2e0f8ec1527$export$f6327b3db2cbbddd)(maintTechUserCard);
    };
    const sendTeamsResponseToAuthor = (wo)=>{
        if (!employeeDetails || !selectedEquipment || !(0, $812b6cdca7c5740d$export$cf8d2d886ddb164f)) return;
        /* istanbul ignore else -- only called from addWorkOrder which gates on Maintenance */ if (serviceAreaSelected.serviceArea === 'Maintenance') {
            const maintChatMsg = {
                chatInfo: {
                    sendTo: `${employeeDetails.usr_login}@pella.com`,
                    title: `${serviceAreaSelected.serviceArea} ${serviceActionSelected.item} Event Created`,
                    message: `Created ${new Date().toLocaleString()}</br>Equipment#: ${selectedEquipment?.equipNum} Description: ${selectedEquipment?.description}</br>WO #: ${wo?.projNum}`
                }
            };
            if (wo.siteId === 'CWS' || wo.siteId === 'Medley') ;
            else if (wo.siteId === 'Avanti') ;
            else (0, $817ca2e0f8ec1527$export$bae683cb2df54a88)(maintChatMsg);
        }
        // Quality author message — only reachable when serviceArea is 'Quality', but sendTeamsResponseToAuthor
        // is only called from addWorkOrder which gates on serviceArea === 'Maintenance'.
        /* istanbul ignore next */ if (serviceAreaSelected.serviceArea === 'Quality') {
            const qualityChatMsg = {
                chatInfo: {
                    sendTo: `${employeeDetails.usr_login}@pella.com`,
                    title: 'Quality Downtime Event Created',
                    message: `Created ${new Date().toLocaleString()}</br>Equipment#: ${selectedEquipment?.equipNum} Description: ${selectedEquipment?.description}`
                }
            };
            if (wo.siteId === 'CWS' || wo.siteId === 'Medley') ;
            else (0, $817ca2e0f8ec1527$export$bae683cb2df54a88)(qualityChatMsg);
        }
    };
    const sendTeamsMessage = (wo)=>{
        if (!(0, $812b6cdca7c5740d$export$cf8d2d886ddb164f)) return;
        const siteTeamsInfo = (0, $5c4434a63a55cfd2$export$2e2bcd8739ae039).find((e)=>e.departmentId ? e.siteId.toUpperCase() === wo.siteId.toUpperCase() && e.departmentId.toUpperCase() === selectedEquipment.departmentId.toUpperCase() : e.siteId.toUpperCase() === wo.siteId.toUpperCase());
        if (!siteTeamsInfo) {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).warning(`Teams notification not sent: no configuration found for site "${wo.siteId}"${selectedEquipment.departmentId ? ` / department "${selectedEquipment.departmentId}"` : ''}.`);
            return;
        }
        /* istanbul ignore else -- only called from addWorkOrder which gates on Maintenance */ if (serviceAreaSelected.serviceArea === 'Maintenance') {
            const maintCardChannelMsg = {
                type: 'AdaptiveCard',
                version: '1.3',
                sendTo: {
                    team: siteTeamsInfo.teamsConfig.maintenance.teamsAddress,
                    channel: siteTeamsInfo.teamsConfig.maintenance.channelId
                },
                title: 'Maintenance Event',
                body: [
                    {
                        type: 'Container',
                        items: [
                            {
                                type: 'TextBlock',
                                text: `Maintenance ${serviceActionSelected.item} Event`,
                                size: 'medium',
                                weight: 'bolder',
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                weight: 'lighter',
                                text: `_Created ${new Date().toLocaleString()}_`,
                                isSubtle: 'true',
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                text: `Submitted by: ${employeeDetails.first_name}${employeeDetails.preferred_name ? `(${employeeDetails.preferred_name})` : ''} ${employeeDetails.last_name}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `WO: ${wo?.projNum}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `Dept: ${selectedEquipment?.departmentId}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `Location: ${selectedEquipment?.location}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `Equipment#: ${selectedEquipment?.equipNum}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `Description: ${selectedEquipment?.description}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `Reason For Outage: ${serviceActionSelected.item}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `Comment: ${comment}`,
                                wrap: 'true'
                            }
                        ]
                    }
                ],
                actions: [
                    {
                        type: 'Action.OpenUrl',
                        title: 'Go to Thrive Work Orders',
                        url: `${$fee88389624349c9$var$LeanTechAppUrl}/3/CSTM/MT/Mobile?tbl_id=${wo.id}`
                    },
                    {
                        type: 'Action.OpenUrl',
                        title: 'Go to Thrive RTS Dashboard',
                        url: `${$fee88389624349c9$var$LeanTechAppUrl}/3/CSTM/MT/Dashboard2?retries=1`
                    }
                ]
            };
            if (wo.siteId === 'CWS' || wo.siteId === 'Medley') (0, $817ca2e0f8ec1527$export$f03ffa152cce707e)(maintCardChannelMsg);
            else if (wo.siteId === 'Avanti') (0, $817ca2e0f8ec1527$export$226ce7b10b163718)(maintCardChannelMsg);
            else (0, $817ca2e0f8ec1527$export$794aed5ddf43700a)(maintCardChannelMsg);
        }
        // Quality channel card — only reachable when serviceArea is 'Quality', but sendTeamsMessage
        // with a valid wo is only called from addWorkOrder which gates on serviceArea === 'Maintenance'.
        /* istanbul ignore next */ if (serviceAreaSelected.serviceArea === 'Quality') {
            const qualityCardChannelMsg = {
                type: 'AdaptiveCard',
                version: '1.3',
                sendTo: {
                    team: siteTeamsInfo.teamsConfig.quality.teamsAddress,
                    channel: siteTeamsInfo.teamsConfig.quality.channelId
                },
                title: 'Quality Downtime Event',
                body: [
                    {
                        type: 'Container',
                        items: [
                            {
                                type: 'TextBlock',
                                text: 'Quality Downtime Event',
                                size: 'medium',
                                weight: 'bolder',
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                weight: 'lighter',
                                text: `_Created ${new Date().toLocaleString()}_`,
                                isSubtle: 'true',
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                text: `Submitted by: ${employeeDetails.first_name}${employeeDetails.preferred_name ? `(${employeeDetails.preferred_name})` : ''} ${employeeDetails.last_name}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `Location: ${selectedEquipment?.departmentId}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `Equipment#: ${selectedEquipment?.equipNum}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `Description: ${selectedEquipment?.description}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `Reason For Outage: ${serviceActionSelected.item}`,
                                wrap: 'true'
                            },
                            {
                                type: 'TextBlock',
                                spacing: 'none',
                                text: `Comment: ${comment}`,
                                wrap: 'true'
                            }
                        ]
                    }
                ]
            };
            if (wo.siteId === 'CWS' || wo.siteId === 'Medley') (0, $817ca2e0f8ec1527$export$f03ffa152cce707e)(qualityCardChannelMsg);
            else (0, $817ca2e0f8ec1527$export$794aed5ddf43700a)(qualityCardChannelMsg);
        }
    };
    // summaryOverride defaults to current state only for the non-AI path where no explicit value is passed.
    // On that path summaryText is '' so memo03 is blank and tracking is skipped — correct behavior.
    const addWorkOrder = async (summaryOverride = summaryText)=>{
        let commentTranslated;
        if (!isMaintenanceCopilotFlagEnabled && userLanguage === 'es') {
            const translationResult = await getTranslation([
                {
                    sourceLanguage: 'SPANISH',
                    targetLanguage: 'ENGLISH',
                    textToTranslate: [
                        {
                            id: 1,
                            text: comment
                        }
                    ]
                }
            ]);
            commentTranslated = translationResult?.[0]?.text;
        }
        const downtimeRequest = {
            Data: {
                callSource: 'Thrive-Downtime Event',
                equipNum: selectedEquipment.equipNum,
                requestedBy: employeeDetails?.usr_emp_no || 'Downtime Event',
                downtimeReason: serviceActionSelected.itemValue,
                taskTypeId: serviceActionSelected.itemValue === 'Planned Repair' ? 'Repair' : 'Breakdown',
                status: 'Executing',
                pickList06: serviceActionSelected.itemValue === 'Planned Repair' ? '' : 'Initiated',
                isDownTime: serviceActionSelected.itemValue === 'Planned Repair' ? 'N' : '1',
                comments: commentTranslated || comment,
                memo03: summaryOverride,
                utcOffset: new Date().getTimezoneOffset(),
                jsonInput: '',
                projectId: '',
                jsonOutput: ''
            }
        };
        try {
            const results = await startDowntimeEvent(downtimeRequest);
            if (results?.status === 201) {
                (0, $673b1c81cc441170$export$2e2bcd8739ae039).success(t('downtimeEventStartedContent', {
                    serviceArea: t(serviceAreaSelected.i18nTranslationKey),
                    serviceAction: t(serviceActionSelected.i18nTranslationKey)
                }));
                if (results.data.nextTech) {
                    const tech = await api.teamMember.getTeamMemberByBadgeNumber(String(results.data.nextTech));
                    if (tech) sendTeamsResponseToTech(results.data, tech);
                }
                sendTeamsResponseToAuthor(results.data);
                sendTeamsMessage(results.data);
                if (isMaintenanceCopilotFlagEnabled && summaryOverride) createTracking({
                    workOrderId: results.data.id,
                    workOrderNumber: results.data.projNum,
                    generatedSummary: summaryOverride,
                    isRequestOpen: true,
                    conversationId: conversationId,
                    questionAnswers: (0, $22c30186782c8364$export$962cb8e7aa1c82a)(followUpQuestions),
                    equipmentNumber: selectedEquipment.equipNum,
                    siteId: selectedEquipment.siteId,
                    downtimeStartTime: downtimeStartTime
                });
                onSuccess?.();
            } else (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(t('downtimeStartErrorContent', {
                error: $fee88389624349c9$var$getReadableError(results?.data || results)
            }));
        } catch (error) {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(t('downtimeStartErrorContent', {
                error: $fee88389624349c9$var$getReadableError(error)
            }));
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleSubmit = async (e, summaryOverride)=>{
        e?.preventDefault();
        if (serviceAreaSelected && serviceActionSelected) {
            if (selectedEquipment && selectedEquipment !== '') {
                setIsSubmitting(true);
                if (serviceAreaSelected.serviceArea === 'Maintenance') await addWorkOrder(summaryOverride);
                if (serviceAreaSelected.serviceArea === 'Quality') {
                    sendTeamsMessage();
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).info(t('qualityEventSentContent'));
                    onSuccess?.();
                    setIsSubmitting(false);
                }
                if (serviceAreaSelected.serviceArea === 'DeptManager') {
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).info(t('deptManagerSelectedContent'));
                    onSuccess?.();
                }
            } else (0, $673b1c81cc441170$export$2e2bcd8739ae039).warning(t('equipmentMustBeSelectedContent'));
        } else (0, $673b1c81cc441170$export$2e2bcd8739ae039).warning(t('downtimeEventMustBeSelectedContent'));
    };
    /**
   * Called when AI summary generation succeeds. Sets summary text and triggers submit
   * with the fresh text value directly — avoids async state read timing issue.
   * @param {string} text - The generated summary text
   */ const handleSummaryReady = (text)=>{
        if (!text) return;
        setSummaryText(text);
        handleSubmit(undefined, text);
    };
    /**
   * Called when AI summary generation fails and the user dismisses the error.
   * Clears summary state and submits without a summary.
   */ const handleSummaryError = ()=>{
        setSummaryText('');
        handleSubmit();
    };
    const handleCreateConversation = ()=>{
        // Loading bar shown by TanStack Query GlobalLoading
        setDowntimeStartTime(Date.now());
        createConversation({
            equipmentNumber: selectedEquipment.equipNum,
            problemDescription: comment,
            userLanguage: userLanguage
        });
    };
    const handleRetryDialogClose = (shouldRetry)=>{
        setRetryDialogOpen(false);
        if (shouldRetry) handleSubmit();
    };
    const reset = ()=>{
        setSummaryText('');
        setConversationId('');
        setDowntimeStartTime(null);
        setFollowUpQuestions([]);
        setSummaryGenerationError(false);
        setIsSubmitting(false);
        setRetryDialogOpen(false);
        setRetryDialogMessage('');
    };
    return {
        handleSubmit: handleSubmit,
        handleCreateConversation: handleCreateConversation,
        loadingCreateConversation: loadingCreateConversation,
        isSubmitting: isSubmitting,
        conversationId: conversationId,
        summaryText: summaryText,
        handleSummaryReady: handleSummaryReady,
        handleSummaryError: handleSummaryError,
        followUpQuestions: followUpQuestions,
        setFollowUpQuestions: setFollowUpQuestions,
        downtimeStartTime: downtimeStartTime,
        retryDialogOpen: retryDialogOpen,
        retryDialogMessage: retryDialogMessage,
        handleRetryDialogClose: handleRetryDialogClose,
        reset: reset
    };
};








const $4a9c7604cece1590$export$86320881a5972bfc = ()=>{
    const { api: api } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const { userid: userid, appPreferences: appPreferences } = (0, $c5f28fecad6357c0$export$23bbbc4533528f03)();
    const queryClient = (0, $427d8fa9df978c82$export$22e77b9572c4fded)();
    const preparePreference = ({ preference: preference, prefId: prefId })=>{
        let newPreference = structuredClone(appPreferences);
        // check if the user has any preferences or the right structure
        // if not, create a new preference object
        if (!newPreference?.preferences) {
            newPreference = {
                preferences: [
                    {
                        prefId: prefId,
                        preference: preference
                    }
                ]
            };
            return newPreference;
        }
        // check if the user has the preference already and if we are adding or updating an existing preference
        const foundElement = newPreference.preferences.find((item)=>item.prefId === prefId);
        if (foundElement) foundElement.preference = preference;
        else newPreference.preferences.push({
            prefId: prefId,
            preference: preference
        });
        return newPreference;
    };
    /**
   * Function to handle the Team Member Preferences mutation
   * @param {AddTeamMemberAppPrefHandlerParams} preference
   */ const addTeamMemberAppPrefHandler = async ({ preference: preference, prefId: prefId })=>{
        const updatedPreference = preparePreference({
            preference: preference,
            prefId: prefId
        });
        await api.applUser.addTeamMemberAppPreferences(userid, updatedPreference);
        return updatedPreference;
    };
    /**
   * Mutation to add new Team Member Preference Note
   * @see https://react-query.tanstack.com/guides/mutations
   */ const addTeamMemberAppPref = (0, $957614eff0380312$export$609860bf8b0084c)({
        mutationFn: addTeamMemberAppPrefHandler,
        onSuccess: (preferences)=>{
            queryClient.setQueryData([
                (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).TEAM_MEMBER_APP_PREFERENCES,
                userid
            ], preferences);
        },
        onError: (error)=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(`Table settings save error: ${error.message}`);
        }
    });
    return {
        addTeamMemberAppPref: addTeamMemberAppPref
    };
};






const $32345e46e1a65f5d$export$c06969164bbcede4 = (userid)=>{
    const { api: api, apiReady: apiReady } = (0, $1dff1e305d0081d2$export$67a65489846e51f3)();
    const queriesEnabled = Boolean(userid && apiReady);
    return (0, $4237593f4ee1eaed$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ceef8e61e2b9b160$export$9a2c3bcaa912c766).TEAM_MEMBER_DATA,
            userid
        ],
        queryFn: ()=>api.teamMember.getTeamMemberByUserId(String(userid)),
        enabled: queriesEnabled,
        staleTime: 300000
    });
};




var $lCzvA = parcelRequire("lCzvA");
/**
 * Returns a debounced version of the value that only updates after the delay has passed.
 * @template T
 * @param {T} value - The value to debounce
 * @param {number} delay - Delay in milliseconds
 * @returns {T} The debounced value
 */ const $03fcdd5123f454ac$export$21805fee57372823 = (value, delay)=>{
    const [debouncedValue, setDebouncedValue] = (0, $lCzvA.useState)(value);
    (0, $lCzvA.useEffect)(()=>{
        const timer = setTimeout(()=>setDebouncedValue(value), delay);
        return ()=>clearTimeout(timer);
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};




var $ee2f123cf3cc05c9$exports = {};

$parcel$export($ee2f123cf3cc05c9$exports, "actionButton", function () { return $ee2f123cf3cc05c9$export$a75c7ea49564edd7; }, function (v) { return $ee2f123cf3cc05c9$export$a75c7ea49564edd7 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "badge", function () { return $ee2f123cf3cc05c9$export$4aebd143f31d0c0d; }, function (v) { return $ee2f123cf3cc05c9$export$4aebd143f31d0c0d = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "column", function () { return $ee2f123cf3cc05c9$export$4e0c71f277ca26b3; }, function (v) { return $ee2f123cf3cc05c9$export$4e0c71f277ca26b3 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "columnLeft", function () { return $ee2f123cf3cc05c9$export$41ce4293be25bf01; }, function (v) { return $ee2f123cf3cc05c9$export$41ce4293be25bf01 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "commandButton", function () { return $ee2f123cf3cc05c9$export$74540e56d8cdd242; }, function (v) { return $ee2f123cf3cc05c9$export$74540e56d8cdd242 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "container", function () { return $ee2f123cf3cc05c9$export$34e0f9847d4c02dd; }, function (v) { return $ee2f123cf3cc05c9$export$34e0f9847d4c02dd = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "debugView", function () { return $ee2f123cf3cc05c9$export$441992c85a59286b; }, function (v) { return $ee2f123cf3cc05c9$export$441992c85a59286b = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "details", function () { return $ee2f123cf3cc05c9$export$41ee12f6f6f05843; }, function (v) { return $ee2f123cf3cc05c9$export$41ee12f6f6f05843 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "disabledInput", function () { return $ee2f123cf3cc05c9$export$7b46d23156d74840; }, function (v) { return $ee2f123cf3cc05c9$export$7b46d23156d74840 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "formGroup", function () { return $ee2f123cf3cc05c9$export$d2297815c52203ee; }, function (v) { return $ee2f123cf3cc05c9$export$d2297815c52203ee = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "formLabel", function () { return $ee2f123cf3cc05c9$export$bcb34b28dae666b3; }, function (v) { return $ee2f123cf3cc05c9$export$bcb34b28dae666b3 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "formSelect", function () { return $ee2f123cf3cc05c9$export$b99a395818678a86; }, function (v) { return $ee2f123cf3cc05c9$export$b99a395818678a86 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "grayBackground", function () { return $ee2f123cf3cc05c9$export$5100d0a94c0b29b3; }, function (v) { return $ee2f123cf3cc05c9$export$5100d0a94c0b29b3 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "handIcon", function () { return $ee2f123cf3cc05c9$export$e571bf33bf7c896c; }, function (v) { return $ee2f123cf3cc05c9$export$e571bf33bf7c896c = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "header", function () { return $ee2f123cf3cc05c9$export$38e42c68cf43b5d4; }, function (v) { return $ee2f123cf3cc05c9$export$38e42c68cf43b5d4 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "headerContent", function () { return $ee2f123cf3cc05c9$export$838c0e7679321ff3; }, function (v) { return $ee2f123cf3cc05c9$export$838c0e7679321ff3 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "heading", function () { return $ee2f123cf3cc05c9$export$46e4a324ac90507f; }, function (v) { return $ee2f123cf3cc05c9$export$46e4a324ac90507f = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "helper", function () { return $ee2f123cf3cc05c9$export$4bbbbc0a0e57a7f; }, function (v) { return $ee2f123cf3cc05c9$export$4bbbbc0a0e57a7f = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "icon", function () { return $ee2f123cf3cc05c9$export$1ca1ec8b29a4ce27; }, function (v) { return $ee2f123cf3cc05c9$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "input", function () { return $ee2f123cf3cc05c9$export$b7e3ae3d7c15e42e; }, function (v) { return $ee2f123cf3cc05c9$export$b7e3ae3d7c15e42e = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "inputWrapper", function () { return $ee2f123cf3cc05c9$export$248a47518f3a0001; }, function (v) { return $ee2f123cf3cc05c9$export$248a47518f3a0001 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "link", function () { return $ee2f123cf3cc05c9$export$9c30223ca0a664fb; }, function (v) { return $ee2f123cf3cc05c9$export$9c30223ca0a664fb = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "popover", function () { return $ee2f123cf3cc05c9$export$899efff2d0433d49; }, function (v) { return $ee2f123cf3cc05c9$export$899efff2d0433d49 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "rawInput", function () { return $ee2f123cf3cc05c9$export$5c0a152c672ac95d; }, function (v) { return $ee2f123cf3cc05c9$export$5c0a152c672ac95d = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "responseAction", function () { return $ee2f123cf3cc05c9$export$24c9bef730311970; }, function (v) { return $ee2f123cf3cc05c9$export$24c9bef730311970 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "responseDiv", function () { return $ee2f123cf3cc05c9$export$4ea3e83dbae90ff1; }, function (v) { return $ee2f123cf3cc05c9$export$4ea3e83dbae90ff1 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "secondaryHeading", function () { return $ee2f123cf3cc05c9$export$b22d4c19dfd5506f; }, function (v) { return $ee2f123cf3cc05c9$export$b22d4c19dfd5506f = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "selectInput", function () { return $ee2f123cf3cc05c9$export$4f502711de93d534; }, function (v) { return $ee2f123cf3cc05c9$export$4f502711de93d534 = v; });
$parcel$export($ee2f123cf3cc05c9$exports, "topMargin", function () { return $ee2f123cf3cc05c9$export$d5cd492a56aa2350; }, function (v) { return $ee2f123cf3cc05c9$export$d5cd492a56aa2350 = v; });
var $ee2f123cf3cc05c9$export$a75c7ea49564edd7;
var $ee2f123cf3cc05c9$export$4aebd143f31d0c0d;
var $ee2f123cf3cc05c9$export$4e0c71f277ca26b3;
var $ee2f123cf3cc05c9$export$41ce4293be25bf01;
var $ee2f123cf3cc05c9$export$74540e56d8cdd242;
var $ee2f123cf3cc05c9$export$34e0f9847d4c02dd;
var $ee2f123cf3cc05c9$export$441992c85a59286b;
var $ee2f123cf3cc05c9$export$41ee12f6f6f05843;
var $ee2f123cf3cc05c9$export$7b46d23156d74840;
var $ee2f123cf3cc05c9$export$d2297815c52203ee;
var $ee2f123cf3cc05c9$export$bcb34b28dae666b3;
var $ee2f123cf3cc05c9$export$b99a395818678a86;
var $ee2f123cf3cc05c9$export$5100d0a94c0b29b3;
var $ee2f123cf3cc05c9$export$e571bf33bf7c896c;
var $ee2f123cf3cc05c9$export$38e42c68cf43b5d4;
var $ee2f123cf3cc05c9$export$838c0e7679321ff3;
var $ee2f123cf3cc05c9$export$46e4a324ac90507f;
var $ee2f123cf3cc05c9$export$4bbbbc0a0e57a7f;
var $ee2f123cf3cc05c9$export$1ca1ec8b29a4ce27;
var $ee2f123cf3cc05c9$export$b7e3ae3d7c15e42e;
var $ee2f123cf3cc05c9$export$248a47518f3a0001;
var $ee2f123cf3cc05c9$export$9c30223ca0a664fb;
var $ee2f123cf3cc05c9$export$899efff2d0433d49;
var $ee2f123cf3cc05c9$export$5c0a152c672ac95d;
var $ee2f123cf3cc05c9$export$24c9bef730311970;
var $ee2f123cf3cc05c9$export$4ea3e83dbae90ff1;
var $ee2f123cf3cc05c9$export$b22d4c19dfd5506f;
var $ee2f123cf3cc05c9$export$4f502711de93d534;
var $ee2f123cf3cc05c9$export$d5cd492a56aa2350;
$ee2f123cf3cc05c9$export$a75c7ea49564edd7 = `Ej9lnG_actionButton`;
$ee2f123cf3cc05c9$export$4aebd143f31d0c0d = `Ej9lnG_badge`;
$ee2f123cf3cc05c9$export$4e0c71f277ca26b3 = `Ej9lnG_column`;
$ee2f123cf3cc05c9$export$41ce4293be25bf01 = `Ej9lnG_columnLeft`;
$ee2f123cf3cc05c9$export$74540e56d8cdd242 = `Ej9lnG_commandButton`;
$ee2f123cf3cc05c9$export$34e0f9847d4c02dd = `Ej9lnG_container`;
$ee2f123cf3cc05c9$export$441992c85a59286b = `Ej9lnG_debugView`;
$ee2f123cf3cc05c9$export$41ee12f6f6f05843 = `Ej9lnG_details`;
$ee2f123cf3cc05c9$export$7b46d23156d74840 = `Ej9lnG_disabledInput`;
$ee2f123cf3cc05c9$export$d2297815c52203ee = `Ej9lnG_formGroup`;
$ee2f123cf3cc05c9$export$bcb34b28dae666b3 = `Ej9lnG_formLabel`;
$ee2f123cf3cc05c9$export$b99a395818678a86 = `Ej9lnG_formSelect`;
$ee2f123cf3cc05c9$export$5100d0a94c0b29b3 = `Ej9lnG_grayBackground`;
$ee2f123cf3cc05c9$export$e571bf33bf7c896c = `Ej9lnG_handIcon`;
$ee2f123cf3cc05c9$export$38e42c68cf43b5d4 = `Ej9lnG_header`;
$ee2f123cf3cc05c9$export$838c0e7679321ff3 = `Ej9lnG_headerContent`;
$ee2f123cf3cc05c9$export$46e4a324ac90507f = `Ej9lnG_heading`;
$ee2f123cf3cc05c9$export$4bbbbc0a0e57a7f = `Ej9lnG_helper`;
$ee2f123cf3cc05c9$export$1ca1ec8b29a4ce27 = `Ej9lnG_icon`;
$ee2f123cf3cc05c9$export$b7e3ae3d7c15e42e = `Ej9lnG_input`;
$ee2f123cf3cc05c9$export$248a47518f3a0001 = `Ej9lnG_inputWrapper`;
$ee2f123cf3cc05c9$export$9c30223ca0a664fb = `Ej9lnG_link`;
$ee2f123cf3cc05c9$export$899efff2d0433d49 = `Ej9lnG_popover`;
$ee2f123cf3cc05c9$export$5c0a152c672ac95d = `Ej9lnG_rawInput`;
$ee2f123cf3cc05c9$export$24c9bef730311970 = `Ej9lnG_responseAction`;
$ee2f123cf3cc05c9$export$4ea3e83dbae90ff1 = `Ej9lnG_responseDiv`;
$ee2f123cf3cc05c9$export$b22d4c19dfd5506f = `Ej9lnG_secondaryHeading`;
$ee2f123cf3cc05c9$export$4f502711de93d534 = `Ej9lnG_selectInput`;
$ee2f123cf3cc05c9$export$d5cd492a56aa2350 = `Ej9lnG_topMargin`;


/**
 * SparePartSelector — typeahead combo-box for selecting a spare part on a work order.
 * @param {object} props
 * @param {(part: object | null) => void} props.sparePartOnChange Called with the selected part, or null when the input is cleared.
 * @param {boolean} props.showTitle Whether to render the title/badge block above the input.
 * @param {string} [props.title] Title text shown when showTitle is true.
 * @param {object} [props.workOrder] Work order whose equipNum drives the useSpareParts query.
 * @returns {import('react').ReactElement}
 */ const $0853625c592a457d$var$SparePartSelector = (props)=>{
    const { workOrder: workOrder, showTitle: showTitle, title: title, sparePartOnChange: onSparePartChange } = props;
    const { spareParts: spareParts } = (0, $d2aa929a4a4e56ef$export$1e5456b5c8005e7b)().useSpareParts({
        equipnumber: workOrder?.equipNum
    });
    const [searchTerm, setSearchTerm] = (0, $lCzvA.useState)('');
    const [open, setOpen] = (0, $lCzvA.useState)(false);
    const sortedSparePartsList = (0, $lCzvA.useMemo)(()=>{
        if (!spareParts?.length) return [];
        return [
            ...spareParts
        ].toSorted((a, b)=>{
            const dateA = (0, $60bff58474b1dc6b$export$2e2bcd8739ae039)(new Date(a?.dateUsed), 'yyyy-MM-dd');
            const dateB = (0, $60bff58474b1dc6b$export$2e2bcd8739ae039)(new Date(b?.dateUsed), 'yyyy-MM-dd');
            return dateB.localeCompare(dateA);
        });
    }, [
        spareParts
    ]);
    const filtered = (0, $lCzvA.useMemo)(()=>{
        const needle = searchTerm.toLowerCase();
        return sortedSparePartsList.filter((part)=>`(${part?.partNum ?? ''}) ${part?.description ?? ''}`.toLowerCase().includes(needle));
    }, [
        sortedSparePartsList,
        searchTerm
    ]);
    const handleInputChange = (e)=>{
        const next = e.target.value;
        setSearchTerm(next);
        setOpen(true);
        if (next === '') onSparePartChange(null);
    };
    const handleSelect = (part)=>{
        setSearchTerm(`(${part?.partNum ?? ''}) ${part?.description ?? ''}`);
        setOpen(false);
        onSparePartChange(part);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ee2f123cf3cc05c9$exports))).container,
        children: [
            showTitle ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ee2f123cf3cc05c9$exports))).header,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ee2f123cf3cc05c9$exports))).headerContent,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                            children: title || 'Select Item'
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ee2f123cf3cc05c9$exports))).badge,
                            children: spareParts?.length ?? 0
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4894604720ca08c8$export$2e2bcd8739ae039), {
                defaultOpen: open,
                onOpenChange: setOpen,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $159cb66f654a3a1c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                            id: "spare-part-combo",
                            labelText: "Select Part",
                            placeholder: "Choose a part...",
                            value: searchTerm,
                            onChange: handleInputChange,
                            onFocus: ()=>setOpen(true),
                            containerClass: (0, (/*@__PURE__*/$parcel$interopDefault($ee2f123cf3cc05c9$exports))).inputWrapper,
                            autoComplete: "off",
                            required: true,
                            "aria-required": "true"
                        })
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $833f5a446a1fbfcc$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ee2f123cf3cc05c9$exports))).popover,
                        align: "start",
                        offset: 0,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e007c3baa5a03cf7$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $36411d1c16b6a683$export$2e2bcd8739ae039), {
                                unstyled: true,
                                children: !filtered.length ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c5b58a39033989d7$export$2e2bcd8739ae039), {
                                    children: "No matching parts"
                                }) : filtered.map((part, idx)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c5b58a39033989d7$export$2e2bcd8739ae039), {
                                        onClick: ()=>handleSelect(part),
                                        children: [
                                            "(",
                                            part?.partNum ?? '',
                                            ") ",
                                            part?.description ?? ''
                                        ]
                                    }, part?.partNum ?? idx))
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $0853625c592a457d$export$2e2bcd8739ae039 = $0853625c592a457d$var$SparePartSelector;






var $lCzvA = parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/Accordion/index.jsx
var $8fedcf22c00c4cdd$export$2e2bcd8739ae039 = ({ allowMultiple: a = !0, className: o, variant: s = "list", enableAnimation: c = !0, children: l, ...u })=>{
    let d = (0, $lCzvA.useId)();
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-Accordion my-6 block": !0,
            "sash-Accordion--list": s === "list",
            "sash-Accordion--box": s === "box",
            "sash-Accordion--animated": c,
            [o]: o
        }),
        "data-testid": "sash-accordion",
        ...u,
        children: (0, $lCzvA.Children)?.toArray(l)?.map((e)=>(0, $lCzvA.cloneElement)(e, {
                allowMultiple: a,
                id: `${d}sash-accordion`
            }))
    });
};



//#region src/components/Accordion/AccordionContent/index.jsx
var $d9ac194a6f540d5b$export$2e2bcd8739ae039 = ({ className: n, children: r, ...i })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-AccordionContent px-2 pt-2 pb-4": !0,
            [n]: n
        }),
        "data-testid": "sash-accordion-content",
        ...i,
        children: r
    });
$d9ac194a6f540d5b$export$2e2bcd8739ae039.displayName = "AccordionContent";



"use client";
//#region src/components/Accordion/AccordionItem/index.jsx
var $9e4c7ade3285342d$export$2e2bcd8739ae039 = ({ className: n, defaultOpen: r, allowMultiple: i, id: a, children: o, ...s })=>{
    let c = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-AccordionItem block": !0,
        [n]: n
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("details", {
        name: i ? void 0 : a,
        className: c,
        "data-testid": "sash-accordion-item",
        open: r,
        ...s,
        children: o
    });
};
$9e4c7ade3285342d$export$2e2bcd8739ae039.displayName = "AccordionItem";



//#region src/components/Accordion/AccordionTrigger/index.jsx
var $dffdfe16b69939eb$export$2e2bcd8739ae039 = ({ className: r, activeIcon: i = "remove", inactiveIcon: a = "add", renderAs: o = "span", children: s, textClass: c, ...l })=>{
    let u = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-AccordionTrigger gap-x-4 relative flex w-full items-center py-4 px-2 text-left cursor-pointer": !0,
        [r]: r
    }), d = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "text-neutral-750 m-0! flex-1 text-base/tight font-semibold": !0,
        [c]: c
    }), f = o;
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("summary", {
        className: u,
        "data-testid": "sash-accordion-trigger",
        ...l,
        children: [
            i && a && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                className: "sash-AccordionTrigger-icon flex items-center justify-center text-center leading-none",
                "data-testid": "sash-accordion-icon",
                "data-active-icon": i,
                "data-inactive-icon": a
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(f, {
                "data-testid": "sash-accordion-trigger-text",
                className: d,
                children: s
            })
        ]
    });
};
$dffdfe16b69939eb$export$2e2bcd8739ae039.displayName = "AccordionTrigger";




//#region src/components/Badge/index.jsx
var $906889f993373872$export$2e2bcd8739ae039 = ({ color: i = "conversion", variant: a = "rounded", size: o = "sm", className: s, renderAs: c = "span", iconRight: l, iconLeft: u, children: d, darkMode: f, ...p })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(c, {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-Badge inline-flex items-center gap-x-1 text-sm font-semibold": !0,
            "py-1 px-2": o,
            "bg-conversion text-black": i === "conversion",
            "bg-red-200 text-red-800": i === "error" && !f,
            "bg-amber-200 text-amber-800": i === "warning" && !f,
            "bg-blue-200 text-blue-800": i === "info" && !f,
            "bg-green-200 text-green-700": i === "success" && !f,
            "bg-neutral-100 text-black": i === "neutral" && !f,
            "bg-black text-conversion": i === "conversion" && f,
            "bg-red-800 text-neutral-25": i === "error" && f,
            "bg-amber-800 text-neutral-25": i === "warning" && f,
            "bg-blue-600 text-white": i === "info" && f,
            "bg-green-600 text-white": i === "success" && f,
            "bg-neutral-800 text-white": i === "neutral" && f,
            "bg-neutral-50": i === "light-gray",
            "bg-neutral-100 text-neutral-700": i === "gray",
            "bg-neutral-700 text-white": i === "dark-gray",
            "bg-black text-white": i === "black",
            "bg-white text-neutral-900": i === "white",
            "rounded-sm": a === "rounded",
            "rounded-full": a === "pill",
            [s]: s
        }),
        "data-color": i,
        "data-mode": f ? "dark" : "light",
        ...p,
        children: [
            u && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: u,
                className: "text-current",
                size: 20
            }),
            d,
            l && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: l,
                className: "text-current",
                size: 20
            })
        ]
    });






var $46fee8dd2e90c791$exports = {};

$parcel$export($46fee8dd2e90c791$exports, "accordionTriggerContent", function () { return $46fee8dd2e90c791$export$f46e44a29f5696f; }, function (v) { return $46fee8dd2e90c791$export$f46e44a29f5696f = v; });
$parcel$export($46fee8dd2e90c791$exports, "actionButton", function () { return $46fee8dd2e90c791$export$a75c7ea49564edd7; }, function (v) { return $46fee8dd2e90c791$export$a75c7ea49564edd7 = v; });
$parcel$export($46fee8dd2e90c791$exports, "column", function () { return $46fee8dd2e90c791$export$4e0c71f277ca26b3; }, function (v) { return $46fee8dd2e90c791$export$4e0c71f277ca26b3 = v; });
$parcel$export($46fee8dd2e90c791$exports, "columnLeft", function () { return $46fee8dd2e90c791$export$41ce4293be25bf01; }, function (v) { return $46fee8dd2e90c791$export$41ce4293be25bf01 = v; });
$parcel$export($46fee8dd2e90c791$exports, "commandButton", function () { return $46fee8dd2e90c791$export$74540e56d8cdd242; }, function (v) { return $46fee8dd2e90c791$export$74540e56d8cdd242 = v; });
$parcel$export($46fee8dd2e90c791$exports, "debugView", function () { return $46fee8dd2e90c791$export$441992c85a59286b; }, function (v) { return $46fee8dd2e90c791$export$441992c85a59286b = v; });
$parcel$export($46fee8dd2e90c791$exports, "destAcctFlex", function () { return $46fee8dd2e90c791$export$b7ced823af02274d; }, function (v) { return $46fee8dd2e90c791$export$b7ced823af02274d = v; });
$parcel$export($46fee8dd2e90c791$exports, "destAcctRow", function () { return $46fee8dd2e90c791$export$e1f171128e21cf80; }, function (v) { return $46fee8dd2e90c791$export$e1f171128e21cf80 = v; });
$parcel$export($46fee8dd2e90c791$exports, "details", function () { return $46fee8dd2e90c791$export$41ee12f6f6f05843; }, function (v) { return $46fee8dd2e90c791$export$41ee12f6f6f05843 = v; });
$parcel$export($46fee8dd2e90c791$exports, "disabledInput", function () { return $46fee8dd2e90c791$export$7b46d23156d74840; }, function (v) { return $46fee8dd2e90c791$export$7b46d23156d74840 = v; });
$parcel$export($46fee8dd2e90c791$exports, "formSelect", function () { return $46fee8dd2e90c791$export$b99a395818678a86; }, function (v) { return $46fee8dd2e90c791$export$b99a395818678a86 = v; });
$parcel$export($46fee8dd2e90c791$exports, "grayBackground", function () { return $46fee8dd2e90c791$export$5100d0a94c0b29b3; }, function (v) { return $46fee8dd2e90c791$export$5100d0a94c0b29b3 = v; });
$parcel$export($46fee8dd2e90c791$exports, "handIcon", function () { return $46fee8dd2e90c791$export$e571bf33bf7c896c; }, function (v) { return $46fee8dd2e90c791$export$e571bf33bf7c896c = v; });
$parcel$export($46fee8dd2e90c791$exports, "heading", function () { return $46fee8dd2e90c791$export$46e4a324ac90507f; }, function (v) { return $46fee8dd2e90c791$export$46e4a324ac90507f = v; });
$parcel$export($46fee8dd2e90c791$exports, "helper", function () { return $46fee8dd2e90c791$export$4bbbbc0a0e57a7f; }, function (v) { return $46fee8dd2e90c791$export$4bbbbc0a0e57a7f = v; });
$parcel$export($46fee8dd2e90c791$exports, "icon", function () { return $46fee8dd2e90c791$export$1ca1ec8b29a4ce27; }, function (v) { return $46fee8dd2e90c791$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($46fee8dd2e90c791$exports, "input", function () { return $46fee8dd2e90c791$export$b7e3ae3d7c15e42e; }, function (v) { return $46fee8dd2e90c791$export$b7e3ae3d7c15e42e = v; });
$parcel$export($46fee8dd2e90c791$exports, "link", function () { return $46fee8dd2e90c791$export$9c30223ca0a664fb; }, function (v) { return $46fee8dd2e90c791$export$9c30223ca0a664fb = v; });
$parcel$export($46fee8dd2e90c791$exports, "noteText", function () { return $46fee8dd2e90c791$export$9329abe70f8a78fc; }, function (v) { return $46fee8dd2e90c791$export$9329abe70f8a78fc = v; });
$parcel$export($46fee8dd2e90c791$exports, "rawInput", function () { return $46fee8dd2e90c791$export$5c0a152c672ac95d; }, function (v) { return $46fee8dd2e90c791$export$5c0a152c672ac95d = v; });
$parcel$export($46fee8dd2e90c791$exports, "responseAction", function () { return $46fee8dd2e90c791$export$24c9bef730311970; }, function (v) { return $46fee8dd2e90c791$export$24c9bef730311970 = v; });
$parcel$export($46fee8dd2e90c791$exports, "responseDiv", function () { return $46fee8dd2e90c791$export$4ea3e83dbae90ff1; }, function (v) { return $46fee8dd2e90c791$export$4ea3e83dbae90ff1 = v; });
$parcel$export($46fee8dd2e90c791$exports, "savePrefButton", function () { return $46fee8dd2e90c791$export$cc3540740e66e027; }, function (v) { return $46fee8dd2e90c791$export$cc3540740e66e027 = v; });
$parcel$export($46fee8dd2e90c791$exports, "secondaryHeading", function () { return $46fee8dd2e90c791$export$b22d4c19dfd5506f; }, function (v) { return $46fee8dd2e90c791$export$b22d4c19dfd5506f = v; });
$parcel$export($46fee8dd2e90c791$exports, "topMargin", function () { return $46fee8dd2e90c791$export$d5cd492a56aa2350; }, function (v) { return $46fee8dd2e90c791$export$d5cd492a56aa2350 = v; });
var $46fee8dd2e90c791$export$f46e44a29f5696f;
var $46fee8dd2e90c791$export$a75c7ea49564edd7;
var $46fee8dd2e90c791$export$4e0c71f277ca26b3;
var $46fee8dd2e90c791$export$41ce4293be25bf01;
var $46fee8dd2e90c791$export$74540e56d8cdd242;
var $46fee8dd2e90c791$export$441992c85a59286b;
var $46fee8dd2e90c791$export$b7ced823af02274d;
var $46fee8dd2e90c791$export$e1f171128e21cf80;
var $46fee8dd2e90c791$export$41ee12f6f6f05843;
var $46fee8dd2e90c791$export$7b46d23156d74840;
var $46fee8dd2e90c791$export$b99a395818678a86;
var $46fee8dd2e90c791$export$5100d0a94c0b29b3;
var $46fee8dd2e90c791$export$e571bf33bf7c896c;
var $46fee8dd2e90c791$export$46e4a324ac90507f;
var $46fee8dd2e90c791$export$4bbbbc0a0e57a7f;
var $46fee8dd2e90c791$export$1ca1ec8b29a4ce27;
var $46fee8dd2e90c791$export$b7e3ae3d7c15e42e;
var $46fee8dd2e90c791$export$9c30223ca0a664fb;
var $46fee8dd2e90c791$export$9329abe70f8a78fc;
var $46fee8dd2e90c791$export$5c0a152c672ac95d;
var $46fee8dd2e90c791$export$24c9bef730311970;
var $46fee8dd2e90c791$export$4ea3e83dbae90ff1;
var $46fee8dd2e90c791$export$cc3540740e66e027;
var $46fee8dd2e90c791$export$b22d4c19dfd5506f;
var $46fee8dd2e90c791$export$d5cd492a56aa2350;
$46fee8dd2e90c791$export$f46e44a29f5696f = `_32_NCa_accordionTriggerContent`;
$46fee8dd2e90c791$export$a75c7ea49564edd7 = `_32_NCa_actionButton`;
$46fee8dd2e90c791$export$4e0c71f277ca26b3 = `_32_NCa_column`;
$46fee8dd2e90c791$export$41ce4293be25bf01 = `_32_NCa_columnLeft`;
$46fee8dd2e90c791$export$74540e56d8cdd242 = `_32_NCa_commandButton`;
$46fee8dd2e90c791$export$441992c85a59286b = `_32_NCa_debugView`;
$46fee8dd2e90c791$export$b7ced823af02274d = `_32_NCa_destAcctFlex`;
$46fee8dd2e90c791$export$e1f171128e21cf80 = `_32_NCa_destAcctRow`;
$46fee8dd2e90c791$export$41ee12f6f6f05843 = `_32_NCa_details`;
$46fee8dd2e90c791$export$7b46d23156d74840 = `_32_NCa_disabledInput`;
$46fee8dd2e90c791$export$b99a395818678a86 = `_32_NCa_formSelect`;
$46fee8dd2e90c791$export$5100d0a94c0b29b3 = `_32_NCa_grayBackground`;
$46fee8dd2e90c791$export$e571bf33bf7c896c = `_32_NCa_handIcon`;
$46fee8dd2e90c791$export$46e4a324ac90507f = `_32_NCa_heading`;
$46fee8dd2e90c791$export$4bbbbc0a0e57a7f = `_32_NCa_helper`;
$46fee8dd2e90c791$export$1ca1ec8b29a4ce27 = `_32_NCa_icon`;
$46fee8dd2e90c791$export$b7e3ae3d7c15e42e = `_32_NCa_input`;
$46fee8dd2e90c791$export$9c30223ca0a664fb = `_32_NCa_link`;
$46fee8dd2e90c791$export$9329abe70f8a78fc = `_32_NCa_noteText`;
$46fee8dd2e90c791$export$5c0a152c672ac95d = `_32_NCa_rawInput`;
$46fee8dd2e90c791$export$24c9bef730311970 = `_32_NCa_responseAction`;
$46fee8dd2e90c791$export$4ea3e83dbae90ff1 = `_32_NCa_responseDiv`;
$46fee8dd2e90c791$export$cc3540740e66e027 = `_32_NCa_savePrefButton`;
$46fee8dd2e90c791$export$b22d4c19dfd5506f = `_32_NCa_secondaryHeading`;
$46fee8dd2e90c791$export$d5cd492a56aa2350 = `_32_NCa_topMargin`;


/**
 * PlantMROSubInvSelector component for selecting Plant, MRO Sub Inventory, and destination account.
 * @param {object} root0 - Component props
 * @param {string} [root0.defaultDestinationAcct] - Default destination account value
 * @param {(value: { settings: object, distributionAccount: string | undefined, distributionAccountId: string | undefined, validated: boolean }) => void} root0.selectedValueOnChange - Callback fired when any selection changes
 * @param {(active: boolean) => void} root0.COALLookupActive - Callback fired when COA lookup dialog state changes
 * @param {boolean} [root0.showSavePreferences] - Whether to show save preferences button
 * @param {boolean} [root0.defaultExpanded] - Whether the accordion is expanded by default
 * @returns {import('react').ReactElement} The PlantMROSubInvSelector component
 */ const $9e65d9cd95f8360c$var$PlantMROSubInvSelector = ({ defaultDestinationAcct: defaultDestinationAcct, selectedValueOnChange: selectedValueOnChange, COALLookupActive: COALLookupActive, showSavePreferences: showSavePreferences = true, defaultExpanded: defaultExpanded = false })=>{
    const { appPreferences: appPreferences } = (0, $c5f28fecad6357c0$export$23bbbc4533528f03)();
    const { addTeamMemberAppPref: addTeamMemberAppPref } = (0, $4a9c7604cece1590$export$86320881a5972bfc)();
    const [selectedOrgId, setSelectedOrgId] = (0, $lCzvA.useState)('');
    const [selectedSubInvCode, setSelectedSubInvCode] = (0, $lCzvA.useState)('');
    const [selectedLocationId, setSelectedLocationId] = (0, $lCzvA.useState)('');
    const [destinationAcct, setDestinationAcct] = (0, $lCzvA.useState)('');
    const [validationTrigger, setValidationTrigger] = (0, $lCzvA.useState)('');
    const [destAcctIsValidated, setDestAcctIsValidated] = (0, $lCzvA.useState)(false);
    const [distributionAccount, setDistributionAccount] = (0, $lCzvA.useState)(null);
    const [showCOALookup, setShowCOALookup] = (0, $lCzvA.useState)(false);
    // Pre-fill tracking — state (not refs) so they can be read during render
    const [orgPrefApplied, setOrgPrefApplied] = (0, $lCzvA.useState)(false);
    const [subInvPrefApplied, setSubInvPrefApplied] = (0, $lCzvA.useState)(false);
    const [locationPrefApplied, setLocationPrefApplied] = (0, $lCzvA.useState)(false);
    const [destAcctPrefApplied, setDestAcctPrefApplied] = (0, $lCzvA.useState)(false);
    // Track previous org for sub-inv clear logic
    const [prevOrgId, setPrevOrgId] = (0, $lCzvA.useState)('');
    // Track previous dist acct query results for validation logic
    const [prevDistAcctKey, setPrevDistAcctKey] = (0, $lCzvA.useState)(null);
    // Stable ref for selectedValueOnChange — updated synchronously after each render so the effect
    // always calls the latest prop without listing it in the dep array (prop identity changes every parent render)
    const selectedValueOnChangeRef = (0, $lCzvA.useRef)(selectedValueOnChange);
    (0, $lCzvA.useLayoutEffect)(()=>{
        selectedValueOnChangeRef.current = selectedValueOnChange;
    }, [
        selectedValueOnChange
    ]);
    const { mroOrgs: mroOrgs, mroOrgsIsLoading: mroOrgsIsLoading } = (0, $7a152e40ba979840$export$91f3b828407c7fce)();
    const { subInventories: subInventories, subInventoriesIsLoading: subInventoriesIsLoading } = (0, $413d2c4be487de20$export$8ca49f6914a5ed0b)(selectedOrgId);
    const { invLocations: invLocations } = (0, $2f9c61a9a15aa16d$export$2dad80eff99db31e)();
    const { data: distAcctData, isFetched: distAcctFetched } = (0, $69b6c5a494e2d20c$export$1c1d2fc183df44cb)(validationTrigger);
    const moveOrderPrefs = (0, $lCzvA.useMemo)(()=>appPreferences?.preferences?.find((p)=>p.prefId === 'MoveOrder')?.preference?.apps ?? null, [
        appPreferences
    ]);
    // --- Render-time state adjustments (replaces pre-fill and sync effects) ---
    // Pre-fill org once mroOrgs data is available
    if (!orgPrefApplied && moveOrderPrefs?.MoveOrderMROOrg && mroOrgs?.length) {
        setOrgPrefApplied(true);
        const orgId = String(moveOrderPrefs.MoveOrderMROOrg);
        setSelectedOrgId(orgId);
        setPrevOrgId(orgId); // prevent sub-inv clear for pre-fill
    }
    // Pre-fill sub-inv once subInventories data is available for the pre-filled org
    if (!subInvPrefApplied && moveOrderPrefs?.MoveOrderSubInvLoc && subInventories?.length && selectedOrgId === String(moveOrderPrefs?.MoveOrderMROOrg ?? '')) {
        setSubInvPrefApplied(true);
        setSelectedSubInvCode(String(moveOrderPrefs.MoveOrderSubInvLoc));
    }
    // Pre-fill ship-to location once invLocations data is available
    if (!locationPrefApplied && moveOrderPrefs?.MoveOrderShipToLoc && invLocations?.length) {
        setLocationPrefApplied(true);
        setSelectedLocationId(String(moveOrderPrefs.MoveOrderShipToLoc));
    }
    // Pre-fill destination account
    if (!destAcctPrefApplied) {
        const acct = moveOrderPrefs?.MoveOrderDestinationAcct || defaultDestinationAcct;
        if (acct) {
            setDestAcctPrefApplied(true);
            setDestinationAcct(acct);
            setValidationTrigger(acct);
        }
    }
    // Clear sub-inventory when org changes (user-driven, not pre-fill)
    if (selectedOrgId !== prevOrgId) {
        setPrevOrgId(selectedOrgId);
        if (orgPrefApplied) setSelectedSubInvCode('');
    }
    // Derive validation state from dist acct query results
    const distAcctKey = distAcctFetched && validationTrigger ? validationTrigger : null;
    if (distAcctKey && distAcctKey !== prevDistAcctKey) {
        setPrevDistAcctKey(distAcctKey);
        if (distAcctData && distAcctData.length > 0) {
            setDistributionAccount(distAcctData[0]);
            setDestAcctIsValidated(true);
        } else {
            setDistributionAccount(null);
            setDestAcctIsValidated(false);
        }
    }
    // Toast for failed validation (side effect, requires effect)
    (0, $lCzvA.useEffect)(()=>{
        if (distAcctFetched && validationTrigger && (!distAcctData || distAcctData.length === 0)) (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Current Destination Account was not found!');
    }, [
        distAcctFetched,
        validationTrigger,
        distAcctData
    ]);
    const formIsValid = (0, $lCzvA.useMemo)(()=>Boolean(selectedOrgId && selectedSubInvCode && selectedLocationId && (!destinationAcct || destAcctIsValidated)), [
        selectedOrgId,
        selectedSubInvCode,
        selectedLocationId,
        destinationAcct,
        destAcctIsValidated
    ]);
    // Emit full value to parent on any change — uses ref so prop identity changes don't require a disable
    (0, $lCzvA.useEffect)(()=>{
        selectedValueOnChangeRef.current({
            settings: {
                MoveOrderMROOrg: selectedOrgId,
                MoveOrderSubInvLoc: selectedSubInvCode,
                MoveOrderShipToLoc: selectedLocationId,
                MoveOrderDestinationAcct: destinationAcct
            },
            distributionAccount: distributionAccount?.distributionAccount,
            distributionAccountId: distributionAccount?.distributionAccountId,
            validated: formIsValid
        });
    }, [
        selectedOrgId,
        selectedSubInvCode,
        selectedLocationId,
        destinationAcct,
        distributionAccount,
        formIsValid
    ]);
    // Call COALLookupActive directly in handlers rather than watching showCOALookup via effect.
    // Defined before handleCOASelection and handleClearAcct which reference closeCOALookup.
    const openCOALookup = ()=>{
        setShowCOALookup(true);
        COALLookupActive(true);
    };
    const closeCOALookup = ()=>{
        setShowCOALookup(false);
        COALLookupActive(false);
    };
    const handleClearAcct = ()=>{
        setDestinationAcct('');
        setDestAcctIsValidated(false);
        setDistributionAccount(null);
        setValidationTrigger('');
    };
    const handleCOASelection = (value)=>{
        setDestinationAcct(value);
        setDestAcctIsValidated(false);
        setDistributionAccount(null);
        closeCOALookup();
        if (value.length === 32) setValidationTrigger(value);
    };
    const handleSavePreferences = async ()=>{
        try {
            await addTeamMemberAppPref.mutateAsync({
                preference: {
                    apps: {
                        MoveOrderMROOrg: selectedOrgId,
                        MoveOrderSubInvLoc: selectedSubInvCode,
                        MoveOrderShipToLoc: selectedLocationId,
                        MoveOrderDestinationAcct: destinationAcct || null
                    }
                },
                prefId: 'MoveOrder'
            });
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Preferences saved!');
        } catch  {
        // error toast handled by useUserMutation onError
        }
    };
    if (showCOALookup) return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $edda5be83223da94$export$2e2bcd8739ae039), {
        selectionOnClick: handleCOASelection,
        cancelOnClick: closeCOALookup,
        defaultDestinationAcct: destinationAcct
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8fedcf22c00c4cdd$export$2e2bcd8739ae039), {
        variant: "box",
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9e4c7ade3285342d$export$2e2bcd8739ae039), {
            defaultOpen: defaultExpanded,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $dffdfe16b69939eb$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($46fee8dd2e90c791$exports))).accordionTriggerContent,
                        children: [
                            "MRO Settings",
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $906889f993373872$export$2e2bcd8739ae039), {
                                color: formIsValid ? 'success' : 'error',
                                children: formIsValid ? 'Valid' : 'Invalid'
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $d9ac194a6f540d5b$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            id: "mro-org",
                            labelText: "MRO Organization",
                            value: selectedOrgId,
                            disabled: mroOrgsIsLoading,
                            onChange: (e)=>setSelectedOrgId(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "Choose organization..."
                                }),
                                (mroOrgs ?? []).map((org)=>{
                                    const anyOrg = /** @type {{organizationId: string, description: string}} */ org;
                                    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("option", {
                                        value: anyOrg.organizationId,
                                        children: [
                                            "(",
                                            anyOrg.organizationId,
                                            ") ",
                                            anyOrg.description
                                        ]
                                    }, anyOrg.organizationId);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            id: "sub-inv",
                            labelText: "Sub Inventory Location",
                            value: selectedSubInvCode,
                            disabled: !selectedOrgId || subInventoriesIsLoading,
                            onChange: (e)=>setSelectedSubInvCode(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "Choose sub-inventory..."
                                }),
                                (subInventories ?? []).map((sub)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("option", {
                                        value: sub.subinventoryCode,
                                        children: [
                                            "(",
                                            sub.subinventoryCode,
                                            ") ",
                                            sub.description
                                        ]
                                    }, sub.subinventoryCode))
                            ]
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            id: "ship-to",
                            labelText: "Ship To Location",
                            value: selectedLocationId,
                            onChange: (e)=>setSelectedLocationId(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "Choose ship-to location..."
                                }),
                                (invLocations ?? []).map((loc)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("option", {
                                        value: loc.locationId,
                                        children: [
                                            "(",
                                            loc.locationId,
                                            ") ",
                                            loc.description
                                        ]
                                    }, loc.locationId))
                            ]
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($46fee8dd2e90c791$exports))).destAcctRow,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($46fee8dd2e90c791$exports))).destAcctFlex,
                                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                                        id: "dest-acct",
                                        labelText: "Destination Account",
                                        value: destinationAcct,
                                        readOnly: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    "aria-label": "clear",
                                    iconLeft: "clear",
                                    onClick: handleClearAcct
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    "aria-label": "lookup",
                                    iconLeft: "search",
                                    onClick: openCOALookup
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($46fee8dd2e90c791$exports))).noteText,
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbac12b06efda731$export$2e2bcd8739ae039), {
                                children: "**Clear (X) Destination Account to allow Equipment Cost Center to be utilized in Move Order"
                            })
                        }),
                        showSavePreferences && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($46fee8dd2e90c791$exports))).savePrefButton,
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                size: "sm",
                                color: "secondary",
                                disabled: !formIsValid || addTeamMemberAppPref.isPending,
                                onClick: handleSavePreferences,
                                children: "Save as my preferences"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $9e65d9cd95f8360c$export$2e2bcd8739ae039 = $9e65d9cd95f8360c$var$PlantMROSubInvSelector;






var $lCzvA = parcelRequire("lCzvA");

// THIS FILE IS AUTO GENERATED
var $3a17ce406f805418$export$a0f7048edafc45cd = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];



var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");
var $e497452d4ed910a4$export$4a4ef469214f8641 = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var $e497452d4ed910a4$export$a49f528ae1a4d0ed = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createContext && (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createContext($e497452d4ed910a4$export$4a4ef469214f8641);


var $2d1e07c4ca826c9b$var$__assign = undefined && undefined.__assign || function() {
    $2d1e07c4ca826c9b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2d1e07c4ca826c9b$var$__assign.apply(this, arguments);
};
var $2d1e07c4ca826c9b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $2d1e07c4ca826c9b$var$Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement(node.tag, $2d1e07c4ca826c9b$var$__assign({
            key: i
        }, node.attr), $2d1e07c4ca826c9b$var$Tree2Element(node.child));
    });
}
function $2d1e07c4ca826c9b$export$6fce6cce1e9a936d(data) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($2d1e07c4ca826c9b$export$a188ecdd443fe91a, $2d1e07c4ca826c9b$var$__assign({
            attr: $2d1e07c4ca826c9b$var$__assign({}, data.attr)
        }, props), $2d1e07c4ca826c9b$var$Tree2Element(data.child));
    };
}
function $2d1e07c4ca826c9b$export$a188ecdd443fe91a(props) {
    var elem = function(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = $2d1e07c4ca826c9b$var$__rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("svg", $2d1e07c4ca826c9b$var$__assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: $2d1e07c4ca826c9b$var$__assign($2d1e07c4ca826c9b$var$__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("title", null, title), props.children);
    };
    return (0, $e497452d4ed910a4$export$a49f528ae1a4d0ed) !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement((0, $e497452d4ed910a4$export$a49f528ae1a4d0ed).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, $e497452d4ed910a4$export$4a4ef469214f8641));
}





function $993a3b303229c91b$export$cc77b23e32317e46(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9.226l-8-6.21-8 6.21v-2.532l8-6.21 8 6.21zM14 9v6h-4v-4h-4v4h-4v-6l6-4.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7b73eb729a4c77fe(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0.5l-8 8 1.5 1.5 1.5-1.5v6.5h4v-3h2v3h4v-6.5l1.5 1.5 1.5-1.5-8-8zM8 7c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$35642f1f751d5ea6(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9.5l-3-3v-4.5h-2v2.5l-3-3-8 8v0.5h2v5h5v-3h2v3h5v-5h2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6c90baccb0a3fbdf(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 16h8v-16h-8v16zM5 2h2v2h-2v-2zM5 6h2v2h-2v-2zM5 10h2v2h-2v-2zM1 2h2v2h-2v-2zM1 6h2v2h-2v-2zM1 10h2v2h-2v-2zM9 5h7v1h-7zM9 16h2v-4h3v4h2v-9h-7z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$269cdb53afd56de6(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4v-2h-14v11c0 0.552 0.448 1 1 1h13.5c0.828 0 1.5-0.672 1.5-1.5v-8.5h-2zM13 13h-12v-10h12v10zM2 5h10v1h-10zM8 7h4v1h-4zM8 9h4v1h-4zM8 11h3v1h-3zM2 7h5v5h-5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$dc53ae80ee7b62e4(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 0c1.381 0 2.5 1.119 2.5 2.5 0 0.563-0.186 1.082-0.5 1.5l-1 1-3.5-3.5 1-1c0.418-0.314 0.937-0.5 1.5-0.5zM1 11.5l-1 4.5 4.5-1 9.25-9.25-3.5-3.5-9.25 9.25zM11.181 5.681l-7 7-0.862-0.862 7-7 0.862 0.862z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a30cf46c6ec38d33(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10l2-1 7-7-1-1-7 7-1 2zM4.52 13.548c-0.494-1.043-1.026-1.574-2.069-2.069l1.548-4.262 2-1.217 6-6h-3l-6 6-3 10 10-3 6-6v-3l-6 6-1.217 2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$bcdbc5c4331e30de(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 16c2-6 7.234-16 16-16-4.109 3.297-6 11-9 11s-3 0-3 0l-3 5h-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$920a1a5efdefb8cf(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.909 4.561l-4.47-4.47c-0.146-0.146-0.338-0.113-0.427 0.073l-0.599 1.248 4.175 4.175 1.248-0.599c0.186-0.089 0.219-0.282 0.073-0.427z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.615 2.115l-4.115 0.343c-0.273 0.034-0.501 0.092-0.58 0.449-0 0-0 0.001-0 0.001-1.116 5.36-4.92 10.591-4.92 10.591l0.896 0.896 4.25-4.25c-0.094-0.196-0.146-0.415-0.146-0.647 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5c-0.232 0-0.451-0.053-0.647-0.146l-4.25 4.25 0.896 0.896c0 0 5.231-3.804 10.591-4.92 0-0 0.001-0 0.001-0 0.357-0.078 0.415-0.306 0.449-0.58l0.343-4.115-4.269-4.269z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3f8e314975c78607(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0v1.5c1.148 0 2.261 0.225 3.308 0.667 1.012 0.428 1.921 1.041 2.702 1.822s1.394 1.69 1.822 2.702c0.443 1.047 0.667 2.16 0.667 3.308h1.5c0-5.523-4.477-10-10-10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v1.5c1.469 0 2.85 0.572 3.889 1.611s1.611 2.42 1.611 3.889h1.5c0-3.866-3.134-7-7-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 6l-1 1-3.5 1-3 6.5 0.396 0.396 3.638-3.638c-0.022-0.083-0.034-0.169-0.034-0.259 0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1c-0.090 0-0.176-0.012-0.259-0.034l-3.638 3.638 0.396 0.396 6.5-3 1-3.5 1-1-2.5-2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f870ada9aea23e37(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.414 0.586c-0.781-0.781-2.047-0.781-2.828 0l-2.689 2.689-1.896-1.896-2.121 2.121 1.663 1.663-7.377 7.377c-0.126 0.126-0.179 0.296-0.161 0.46h-0.004v2.5c0 0.276 0.224 0.5 0.5 0.5h2.5c0 0 0.042 0 0.063 0 0.144 0 0.288-0.055 0.398-0.165l7.377-7.377 1.663 1.663 2.121-2.121-1.896-1.896 2.689-2.689c0.781-0.781 0.781-2.047 0-2.828zM2.705 15h-1.705v-1.705l7.337-7.337 1.704 1.704-7.337 7.337z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ab0a211b1a65ce02(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.51 7.393c-1.027-2.866-3.205-5.44-5.51-7.393-2.305 1.953-4.482 4.527-5.51 7.393-0.635 1.772-0.698 3.696 0.197 5.397 1.029 1.955 3.104 3.21 5.313 3.21s4.284-1.255 5.313-3.21c0.895-1.701 0.832-3.624 0.197-5.397zM11.543 11.859c-0.684 1.301-2.075 2.141-3.543 2.141-0.861 0-1.696-0.29-2.377-0.791 0.207 0.027 0.416 0.041 0.627 0.041 1.835 0 3.573-1.050 4.428-2.676 0.701-1.333 0.64-2.716 0.373-3.818 0.227 0.44 0.42 0.878 0.576 1.311 0.353 0.985 0.625 2.443-0.084 3.791z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1fc8671b2b841918(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9v-6h-3v-1c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-1h2v4h-9v2h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-0.5v-1h9zM12 3h-11v-1h11v1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2fe6b4611a623850(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.998 2c0.001 0.001 0.001 0.001 0.002 0.002v11.996c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996zM15 1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13h-12v-2l3.5-6 4 5h1l3.5-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$58ccf2936c424e73(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2h-1v-1c0-0.55-0.45-1-1-1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h1v1c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1zM2 3v10h-0.998c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-12c-0.55 0-1 0.45-1 1v0zM17 14.998c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996c0.001 0.001 0.001 0.001 0.002 0.002v11.996z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14h-12v-2l3.5-6 4 5h1l3.5-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2f0c6da1f012eb3b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.75 9.5c0 1.795 1.455 3.25 3.25 3.25s3.25-1.455 3.25-3.25-1.455-3.25-3.25-3.25-3.25 1.455-3.25 3.25zM15 4h-3.5c-0.25-1-0.5-2-1.5-2h-4c-1 0-1.25 1-1.5 2h-3.5c-0.55 0-1 0.45-1 1v9c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM8 13.938c-2.451 0-4.438-1.987-4.438-4.438s1.987-4.438 4.438-4.438c2.451 0 4.438 1.987 4.438 4.438s-1.987 4.438-4.438 4.438zM15 7h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$70a4f0ea4d861658(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 9h-1v7h1c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h1v-7h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 0.96 0.169 1.88 0.479 2.732-0.304 0.519-0.479 1.123-0.479 1.768 0 1.763 1.304 3.222 3 3.464v-6.928c-0.499 0.071-0.963 0.248-1.371 0.506-0.084-0.417-0.129-0.849-0.129-1.292 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 0.442-0.044 0.874-0.128 1.292-0.408-0.259-0.873-0.435-1.372-0.507v6.929c1.696-0.243 3-1.701 3-3.464 0-0.645-0.175-1.249-0.479-1.768 0.31-0.853 0.479-1.773 0.479-2.732z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$72c08791d59ab2e2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0h1v11.5c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-5.751l-8 1.778v7.722c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-9.751l9-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f97cb7fabbef6ceb(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.331 2.502c-2.244-0.323-4.724-0.502-7.331-0.502s-5.087 0.179-7.331 0.502c-0.43 1.683-0.669 3.543-0.669 5.498s0.239 3.815 0.669 5.498c2.244 0.323 4.724 0.502 7.331 0.502s5.087-0.179 7.331-0.502c0.43-1.683 0.669-3.543 0.669-5.498s-0.239-3.815-0.669-5.498zM6 11v-6l5 3-5 3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b6af3cd08ab8a2f5(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2v12h16v-12h-16zM3 13h-2v-2h2v2zM3 9h-2v-2h2v2zM3 5h-2v-2h2v2zM12 13h-8v-10h8v10zM15 13h-2v-2h2v2zM15 9h-2v-2h2v2zM15 5h-2v-2h2v2zM6 5v6l4-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e58606b0cef7a7d2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5zM0 4.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5zM12 9.5v-1.5c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h10c0.55 0 1-0.45 1-1v-1.5l4 2.5v-7l-4 2.5zM10 12h-8v-3h8v3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$87be9b4cf589731f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3h-8c-1.375 0-2.5 1.125-2.5 2.5v8c0 1.375 1.125 2.5 2.5 2.5h8c1.375 0 2.5-1.125 2.5-2.5v-8c0-1.375-1.125-2.5-2.5-2.5zM6.5 14c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM6.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM9.5 11c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.5 14c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.949 2c-0.233-1.138-1.245-2-2.449-2h-8c-1.375 0-2.5 1.125-2.5 2.5v8c0 1.204 0.862 2.216 2 2.449v-9.949c0-0.55 0.45-1 1-1h9.949z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8f8fdb0fad278348(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.074 2.794c-1.467-1.71-3.644-2.794-6.074-2.794-4.418 0-8 3.582-8 8s3.582 8 8 8c2.43 0 4.607-1.084 6.074-2.794l-5.074-5.206 5.074-5.206zM11 1.884c0.616 0 1.116 0.499 1.116 1.116s-0.499 1.116-1.116 1.116-1.116-0.499-1.116-1.116c0-0.616 0.499-1.116 1.116-1.116z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$99a5ab84281032c3(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.775 5.44c-3.024-2.248-4.067-4.047-4.774-5.44v0c-0 0-0-0-0-0v0c-0.708 1.393-1.75 3.192-4.774 5.44-5.157 3.833-0.303 9.182 3.965 6.238-0.278 1.827-1.227 3.159-2.191 3.733v0.59h6v-0.59c-0.964-0.574-1.913-1.906-2.191-3.733 4.268 2.944 9.122-2.405 3.965-6.238z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$565f3dfbc21d5891(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.294 6.137c-0.922 0-1.751 0.384-2.341 1.011-0.25 0.265-0.684 0.58-1.153 0.856 0.22-0.842 0.917-1.902 1.4-2.367 0.619-0.596 1-1.435 1-2.367 0-1.795-1.429-3.252-3.2-3.271-1.771 0.019-3.2 1.475-3.2 3.271 0 0.932 0.38 1.771 1 2.367 0.484 0.465 1.18 1.525 1.4 2.367-0.469-0.277-0.903-0.591-1.153-0.856-0.59-0.627-1.419-1.011-2.341-1.011-1.787 0-3.236 1.463-3.236 3.271s1.448 3.271 3.236 3.271c0.923 0 1.751-0.396 2.341-1.023 0.263-0.279 0.726-0.627 1.223-0.916-0.047 2.308-1.149 4.003-2.271 4.67v0.59h6v-0.59c-1.122-0.668-2.224-2.363-2.271-4.67 0.498 0.289 0.961 0.637 1.223 0.916 0.59 0.626 1.419 1.023 2.341 1.023 1.787 0 3.236-1.464 3.236-3.271s-1.448-3.271-3.236-3.271z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f9ef3d45a1a17ea0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0l-5 8 5 8 5-8z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c32ba6af747f147b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.707c0-3.139-0.919-5.687-2.054-5.707 0.005-0 0.009-0 0.014-0h-1.296c0 0-3.044 2.287-7.425 3.184-0.134 0.708-0.219 1.551-0.219 2.523s0.085 1.816 0.219 2.523c4.382 0.897 7.425 3.184 7.425 3.184h1.296c-0.005 0-0.009-0-0.014-0.001 1.136-0.020 2.054-2.567 2.054-5.707zM13.513 11.551c-0.147 0-0.305-0.152-0.387-0.243-0.197-0.22-0.387-0.562-0.55-0.989-0.363-0.957-0.564-2.239-0.564-3.611s0.2-2.655 0.564-3.611c0.162-0.428 0.353-0.77 0.55-0.99 0.081-0.091 0.24-0.243 0.387-0.243s0.305 0.152 0.387 0.243c0.197 0.22 0.387 0.562 0.55 0.99 0.363 0.957 0.564 2.239 0.564 3.611s-0.2 2.655-0.564 3.611c-0.162 0.428-0.353 0.77-0.55 0.989-0.081 0.091-0.24 0.243-0.387 0.243zM3.935 6.707c0-0.812 0.060-1.6 0.173-2.33-0.74 0.102-1.39 0.161-2.193 0.161-1.048 0-1.048 0-1.048 0l-0.867 1.479v1.378l0.867 1.479c0 0 0 0 1.048 0 0.803 0 1.453 0.059 2.193 0.161-0.113-0.729-0.173-1.518-0.173-2.33zM5.752 10.034l-2-0.383 1.279 5.024c0.066 0.26 0.324 0.391 0.573 0.291l1.852-0.741c0.249-0.1 0.349-0.374 0.222-0.611l-1.926-3.581zM13.513 8.574c-0.057 0-0.118-0.059-0.149-0.094-0.076-0.085-0.149-0.217-0.212-0.381-0.14-0.369-0.217-0.863-0.217-1.392s0.077-1.023 0.217-1.392c0.063-0.165 0.136-0.297 0.212-0.381 0.031-0.035 0.092-0.094 0.149-0.094s0.118 0.059 0.149 0.094c0.076 0.085 0.149 0.217 0.212 0.381 0.14 0.369 0.217 0.863 0.217 1.392s-0.077 1.023-0.217 1.392c-0.063 0.165-0.136 0.297-0.212 0.381-0.031 0.035-0.092 0.094-0.149 0.094z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3b203924a8b2d1b1(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 20 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9c1.654 0 3.154 0.673 4.241 1.759l-1.414 1.414c-0.724-0.724-1.724-1.173-2.827-1.173s-2.103 0.449-2.827 1.173l-1.414-1.414c1.086-1.086 2.586-1.759 4.241-1.759zM2.929 7.929c1.889-1.889 4.4-2.929 7.071-2.929s5.182 1.040 7.071 2.929l-1.414 1.414c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343l-1.414-1.414zM15.45 2.101c1.667 0.705 3.164 1.715 4.45 3v0l-1.414 1.414c-2.267-2.266-5.28-3.515-8.485-3.515s-6.219 1.248-8.485 3.515l-1.414-1.414c1.285-1.285 2.783-2.295 4.45-3 1.727-0.73 3.56-1.101 5.45-1.101s3.723 0.37 5.45 1.101zM9 14c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d204f0d5423b67d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 3.438 2.169 6.37 5.214 7.501l-0.214 0.499h6l-0.214-0.499c3.045-1.131 5.214-4.063 5.214-7.501zM7.606 9.919c-0.356-0.153-0.606-0.507-0.606-0.919 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.412-0.25 0.766-0.606 0.919l-0.394-0.919-0.394 0.919zM8.41 9.958c0.908-0.189 1.59-0.994 1.59-1.958 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.964 0.682 1.768 1.59 1.957l-1.166 2.721c-1.425-0.612-2.424-2.028-2.424-3.677 0-2.209 1.791-4.188 4-4.188s4 1.978 4 4.188c0 1.649-0.999 3.066-2.424 3.677l-1.166-2.72zM10.757 15.433l-1.155-2.695c1.976-0.668 3.398-2.537 3.398-4.738 0-2.761-2.239-5-5-5s-5 2.239-5 5c0 2.201 1.422 4.070 3.398 4.738l-1.155 2.695c-2.494-1.070-4.24-3.547-4.24-6.433 0-3.865 3.133-7.185 6.997-7.185s6.997 3.32 6.997 7.185c0 2.886-1.747 5.363-4.24 6.433z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ce398bfd005f1091(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10.38 3.602c1.56 0.846 2.62 2.498 2.62 4.398s-1.059 3.552-2.62 4.398c0.689-1.096 1.12-2.66 1.12-4.398s-0.431-3.302-1.12-4.398zM4.5 8c0 1.738 0.431 3.302 1.12 4.398-1.56-0.846-2.62-2.498-2.62-4.398s1.059-3.552 2.62-4.398c-0.689 1.096-1.12 2.66-1.12 4.398zM1.5 8c0 2.686 0.85 5.097 2.198 6.746-2.223-1.421-3.698-3.911-3.698-6.746s1.474-5.325 3.698-6.746c-1.348 1.649-2.198 4.060-2.198 6.746zM12.302 1.254c2.223 1.421 3.698 3.911 3.698 6.746s-1.474 5.325-3.698 6.746c1.348-1.649 2.198-4.060 2.198-6.746s-0.85-5.097-2.198-6.746z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2268ee201d253f79(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 11c1.381 0 2.5-1.119 2.5-2.5v-6c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v6c0 1.381 1.119 2.5 2.5 2.5zM11 7v1.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5v-1.5h-1v1.5c0 2.316 1.75 4.223 4 4.472v2.028h-2v1h5v-1h-2v-2.028c2.25-0.249 4-2.156 4-4.472v-1.5h-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d1423bed3d85fa15(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v13h-10.5c-0.829 0-1.5-0.672-1.5-1.5s0.671-1.5 1.5-1.5h9.5v-12h-10c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12v-14h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.501 13v0c-0 0-0.001 0-0.001 0-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0 0 0.001-0 0.001-0v0h9.498v-1h-9.498z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e644d34c326df74a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM3 5h-2v-1h2v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM8 5h-2v-1h2v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.954 2.773l-2.679 1.35c-0.246 0.124-0.345 0.426-0.222 0.671l4.5 8.93c0.124 0.246 0.426 0.345 0.671 0.222l2.679-1.35c0.246-0.124 0.345-0.426 0.222-0.671l-4.5-8.93c-0.124-0.246-0.426-0.345-0.671-0.222z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$af4e7317d5cdb874(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 17 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15v-1h-1v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-1v1h-1v1h17v-1h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0h1l8 5v1h-17v-1l8-5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4d18db7a74aa4e85(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 0h-12c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13 14h-11v-12h11v12zM4 7h7v1h-7zM4 9h7v1h-7zM4 11h7v1h-7zM4 5h7v1h-7z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$40c73cf65e60b7f8(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 0h-12c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13 14h-11v-12h11v12zM4 9h7v1h-7zM4 11h7v1h-7zM5 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM7.5 6h-2c-0.825 0-1.5 0.45-1.5 1v1h5v-1c0-0.55-0.675-1-1.5-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3f3cc9ad61c28e0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f2b20f29fcdaae97(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 5.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.689 0.561 1.25 1.25 1.25h9.5c0.689 0 1.25-0.561 1.25-1.25v-7.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 4.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-9.5c-0.136 0-0.25-0.114-0.25-0.25v-11.5c0-0.135 0.114-0.25 0.25-0.25 0 0 5.749-0 5.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v7.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.421 0.659c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.604 0.43 1.109 1 1.225v-12.725c0-0.135 0.115-0.25 0.25-0.25h7.607c-0.151-0.124-0.297-0.238-0.437-0.341z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ca6f716f151a30ed(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 13h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 11h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d2342ce56f60cf91(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14h-10v-2l3-5 4.109 5 2.891-2v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$93f5e3d023ec2333(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.817 6.113c-0.116-0.095-0.268-0.133-0.415-0.104l-5 1c-0.234 0.047-0.402 0.252-0.402 0.49v3.701c-0.294-0.128-0.636-0.201-1-0.201-1.105 0-2 0.672-2 1.5s0.895 1.5 2 1.5 2-0.672 2-1.5v-3.59l4-0.8v2.091c-0.294-0.128-0.636-0.201-1-0.201-1.105 0-2 0.672-2 1.5s0.895 1.5 2 1.5 2-0.672 2-1.5v-5c0-0.15-0.067-0.292-0.183-0.387z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6baefdab5d2fa8d2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6l5 3.5-5 3.5v-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8caecd45b9960e92(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h5v5h-5v-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10l3-2v5l-3-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4d8afc63af38194(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13.25c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-1.25v-1h-2v4.25zM7 12v1h-2v-1h2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$adbc817e9d6c7652(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4v-4h-7l-3 3v9h6v4h10v-12h-6zM3 1.414v1.586h-1.586l1.586-1.586zM1 11v-7h3v-3h5v3l-3 3v4h-5zM9 5.414v1.586h-1.586l1.586-1.586zM15 15h-8v-7h3v-3h5v10z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4b7ae2f0e2894c3a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h-2v-1c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v1h-2v2h8v-2zM8 2h-2v-0.998c0.001-0.001 0.001-0.001 0.002-0.002h1.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998zM13 5v-2.5c0-0.275-0.225-0.5-0.5-0.5h-1v1h0.5v2h-3l-3 3v4h-4v-9h0.5v-1h-1c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.275 0.225 0.5 0.5 0.5h4.5v3h10v-11h-3zM9 6.414v1.586h-1.586l1.586-1.586zM15 15h-8v-6h3v-3h5v9z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ffc467442221ea73(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5l-8-4-8 4 8 4 8-4zM8 2.328l5.345 2.672-5.345 2.672-5.345-2.672 5.345-2.672zM14.398 7.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199zM14.398 10.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$dc6cc9eb43cf5a2f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2l2 2h7v11h-16v-13z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8c59ba35b5929ddf(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15l3-8h-13l-3 8zM2 6l-2 9v-13h4.5l2 2h6.5v2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$366ab59929f98c7b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM11 11h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$430c05448e8df6f2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM11 11h-6v-2h6v2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8e570e750609a5d3(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM8 13.5l-3.5-3.5h2.5v-4h2v4h2.5l-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a24c780f03af3fbd(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM8 7.5l3.5 3.5h-2.5v4h-2v-4h-2.5l3.5-3.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3dda39865eb1e172(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.338-0.75-0.75-0.75zM11.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1f18db10f1697c18(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 20 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.337-0.75-0.75-0.75zM15.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8.5l8.5-8.5h-1.25c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l0.47-0.47-6.5-6.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$cbe466ef14c9aefd(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2h2v10h-2zM3 2h1v10h-1zM5 2h1v10h-1zM8 2h1v10h-1zM12 2h1v10h-1zM15 2h1v10h-1zM10 2h0.5v10h-0.5zM7 2h0.5v10h-0.5zM13.5 2h0.5v10h-0.5zM0 13h1v1h-1zM3 13h1v1h-1zM5 13h1v1h-1zM10 13h1v1h-1zM15 13h1v1h-1zM12 13h2v1h-2zM7 13h2v1h-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3254c3391ef3d669(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 1h-4v4h4v-4zM6 0v0 6h-6v-6h6zM2 2h2v2h-2zM15 1h-4v4h4v-4zM16 0v0 6h-6v-6h6zM12 2h2v2h-2zM5 11h-4v4h4v-4zM6 10v0 6h-6v-6h6zM2 12h2v2h-2zM7 0h1v1h-1zM8 1h1v1h-1zM7 2h1v1h-1zM8 3h1v1h-1zM7 4h1v1h-1zM8 5h1v1h-1zM7 6h1v1h-1zM7 8h1v1h-1zM8 9h1v1h-1zM7 10h1v1h-1zM8 11h1v1h-1zM7 12h1v1h-1zM8 13h1v1h-1zM7 14h1v1h-1zM8 15h1v1h-1zM15 8h1v1h-1zM1 8h1v1h-1zM2 7h1v1h-1zM0 7h1v1h-1zM4 7h1v1h-1zM5 8h1v1h-1zM6 7h1v1h-1zM9 8h1v1h-1zM10 7h1v1h-1zM11 8h1v1h-1zM12 7h1v1h-1zM13 8h1v1h-1zM14 7h1v1h-1zM15 10h1v1h-1zM9 10h1v1h-1zM10 9h1v1h-1zM11 10h1v1h-1zM13 10h1v1h-1zM14 9h1v1h-1zM15 12h1v1h-1zM9 12h1v1h-1zM10 11h1v1h-1zM12 11h1v1h-1zM13 12h1v1h-1zM14 11h1v1h-1zM15 14h1v1h-1zM10 13h1v1h-1zM11 14h1v1h-1zM12 13h1v1h-1zM13 14h1v1h-1zM10 15h1v1h-1zM12 15h1v1h-1zM14 15h1v1h-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2eaa148b27f20bc9(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5l2 2-4 4-2-2zM15.649 4.649l-1.149-1.149-0.5 0.5c-0.256 0.256-0.61 0.414-1 0.414-0.781 0-1.414-0.633-1.414-1.414 0-0.391 0.158-0.744 0.415-1l0.5-0.5-1.149-1.149c-0.468-0.468-1.235-0.468-1.703 0l-9.297 9.297c-0.468 0.468-0.468 1.235 0 1.703l1.149 1.149 0.499-0.499c0.256-0.256 0.61-0.415 1.001-0.415 0.781 0 1.414 0.633 1.414 1.414 0 0.391-0.158 0.744-0.415 1l-0.5 0.5 1.149 1.149c0.468 0.468 1.234 0.468 1.703 0l9.297-9.297c0.468-0.468 0.468-1.235 0-1.703zM7 13l-4-4 6-6 4 4-6 6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$18ad1082fe899264(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v-6h-12c0-0.552-0.448-1-1-1h-3v1h2l0.751 6.438c-0.458 0.367-0.751 0.93-0.751 1.562 0 1.105 0.895 2 2 2h12v-1h-12c-0.552 0-1-0.448-1-1 0-0.003 0-0.007 0-0.010l13-1.99z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$40a9ccbf12caead3(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM8 8v-2h2v-1h-2v-1h-1v1h-2v4h2v2h-2v1h2v1h1v-1h2l-0-4h-2zM7 8h-1v-2h1v2zM9 11h-1v-2h1v2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d021ead7ed69d5d3(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.482 10.068c-0.239-0.139-0.545-0.058-0.684 0.181-0.27 0.463-0.767 0.751-1.298 0.751h-2c-0.652 0-1.208-0.418-1.414-1h2.414c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5v-1h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.414c0.206-0.582 0.762-1 1.414-1h2c0.531 0 1.028 0.288 1.298 0.751 0.139 0.239 0.445 0.32 0.684 0.181s0.32-0.445 0.181-0.684c-0.448-0.77-1.277-1.249-2.162-1.249h-2c-1.207 0-2.217 0.86-2.45 2h-0.55c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v1h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.55c0.232 1.14 1.242 2 2.45 2h2c0.886 0 1.714-0.478 2.162-1.249 0.139-0.239 0.058-0.545-0.181-0.684z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5d04f6c812c6eb46(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 11h-3.5v-2h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-0.5c0-0.827 0.673-1.5 1.5-1.5 0.534 0 1.032 0.288 1.3 0.75 0.138 0.239 0.444 0.321 0.683 0.182s0.321-0.444 0.182-0.683c-0.446-0.771-1.276-1.25-2.165-1.25-1.378 0-2.5 1.122-2.5 2.5v0.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v3h4.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$68876a2487e598df(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 9c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.066l1.482-2.223c0.153-0.23 0.091-0.54-0.139-0.693s-0.54-0.091-0.693 0.139l-1.584 2.376-1.584-2.376c-0.153-0.23-0.464-0.292-0.693-0.139s-0.292 0.464-0.139 0.693l1.482 2.223h-1.066c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-1h1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$710c49a4c86f1b76(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM1.5 3h13c0.271 0 0.5 0.229 0.5 0.5v1.5h-14v-1.5c0-0.271 0.229-0.5 0.5-0.5zM14.5 13h-13c-0.271 0-0.5-0.229-0.5-0.5v-4.5h14v4.5c0 0.271-0.229 0.5-0.5 0.5zM2 10h1v2h-1zM4 10h1v2h-1zM6 10h1v2h-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f82fe4a3c27f4cc8(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 1h-5c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM6 5h-5v-1h5v1zM14 1h-5c-0.55 0-1 0.45-1 1v13c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-13c0-0.55-0.45-1-1-1zM14 10h-5v-1h5v1zM14 7h-5v-1h5v1zM6 9h-5c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM6 13h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a7bceee1db6e313c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 8c0-1.657 1.343-3 3-3s3 1.343 3 3-1.343 3-3 3-3-1.343-3-3zM14.468 10.679v0l-2.772-1.148c0.196-0.472 0.304-0.989 0.304-1.531s-0.108-1.059-0.304-1.531l2.772-1.148c0.342 0.825 0.532 1.73 0.532 2.679s-0.189 1.854-0.532 2.679v0zM10.679 1.532v0 0l-1.148 2.772c-0.472-0.196-0.989-0.304-1.531-0.304s-1.059 0.108-1.531 0.304l-1.148-2.772c0.825-0.342 1.73-0.532 2.679-0.532s1.854 0.189 2.679 0.532zM1.532 5.321l2.772 1.148c-0.196 0.472-0.304 0.989-0.304 1.531s0.108 1.059 0.304 1.531l-2.772 1.148c-0.342-0.825-0.532-1.73-0.532-2.679s0.189-1.854 0.532-2.679zM5.321 14.468l1.148-2.772c0.472 0.196 0.989 0.304 1.531 0.304s1.059-0.108 1.531-0.304l1.148 2.772c-0.825 0.342-1.73 0.532-2.679 0.532s-1.854-0.189-2.679-0.532z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3f2ecd179073d472(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8aae37c0be86d80c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.897 9c0.125 0.867 0.207 2.053-0.182 2.507-0.643 0.751-4.714 0.751-4.714-0.751 0-0.756 0.67-1.252 0.027-2.003-0.632-0.738-1.766-0.75-3.027-0.751s-2.394 0.012-3.027 0.751c-0.643 0.751 0.027 1.247 0.027 2.003 0 1.501-4.071 1.501-4.714 0.751-0.389-0.454-0.307-1.64-0.182-2.507 0.096-0.579 0.339-1.203 1.118-2 0-0 0-0 0-0 1.168-1.090 2.935-1.98 6.716-2v-0c0.021 0 0.042 0 0.063 0s0.041-0 0.063-0v0c3.781 0.019 5.548 0.91 6.716 2 0 0 0 0 0 0 0.778 0.797 1.022 1.421 1.118 2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d094b718860da2f9(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0v16h12v-16h-12zM9 4.005c1.102 0 1.995 0.893 1.995 1.995s-0.893 1.995-1.995 1.995-1.995-0.893-1.995-1.995 0.893-1.995 1.995-1.995v0zM12 12h-6v-1c0-1.105 0.895-2 2-2v0h2c1.105 0 2 0.895 2 2v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 1h1.5v3h-1.5v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5h1.5v3h-1.5v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9h1.5v3h-1.5v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13h1.5v3h-1.5v-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$eef5b5ad412ebd4e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v10c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-10c0-0.825-0.675-1.5-1.5-1.5zM6.23 8.6l-4.23 3.295v-7.838l4.23 4.543zM2.756 4h10.488l-5.244 3.938-5.244-3.938zM6.395 8.777l1.605 1.723 1.605-1.723 3.29 4.223h-9.79l3.29-4.223zM9.77 8.6l4.23-4.543v7.838l-4.23-3.295z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f122231538aace77(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 0l-1.5 1.5 1.5 1.5-3.5 4h-3.5l2.75 2.75-4.25 5.635v0.615h0.615l5.635-4.25 2.75 2.75v-3.5l4-3.5 1.5 1.5 1.5-1.5-7.5-7.5zM7 8.5l-1-1 3.5-3.5 1 1-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$10c55ac7e511b02f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2292c6d23581c1c7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8.063c-1.691 0-3.063-1.371-3.063-3.063s1.371-3.063 3.063-3.063 3.063 1.371 3.063 3.063-1.371 3.063-3.063 3.063zM6.063 5c0-1.070 0.867-1.938 1.938-1.938s1.938 0.867 1.938 1.938c0 1.070-0.867 1.938-1.938 1.938s-1.938-0.867-1.938-1.938z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9f99951d47f53b85(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 16c-0.036 0-0.072-0.004-0.108-0.012-0.229-0.051-0.392-0.254-0.392-0.488v-7.5h-7.5c-0.234 0-0.437-0.163-0.488-0.392s0.064-0.462 0.277-0.561l15-7c0.191-0.089 0.416-0.049 0.565 0.1s0.188 0.374 0.1 0.565l-7 15c-0.083 0.179-0.262 0.289-0.453 0.289zM2.754 7h5.746c0.276 0 0.5 0.224 0.5 0.5v5.746l5.465-11.712-11.712 5.465z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$317f9ca50075075a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5 1.712 0 3.269 0.662 4.43 1.744l-6.43 2.756-2.756 6.43c-1.082-1.161-1.744-2.718-1.744-4.43zM9.143 9.143l-4.001 1.715 1.715-4.001 2.286 2.286zM8 14.5c-1.712 0-3.269-0.662-4.43-1.744l6.43-2.756 2.756-6.43c1.082 1.161 1.744 2.718 1.744 4.43 0 3.59-2.91 6.5-6.5 6.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a4a37768567fd055(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3l5-2v12l-5 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0.5l5 3v11.5l-5-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.5l4-3v12l-4 3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$943175a2bc10f22f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 3l-5-2-5.5 2v12l5.5-2 5 2 5.5-2v-12l-5.5 2zM6 2.277l4 1.6v9.846l-4-1.6v-9.846zM1 3.7l4-1.455v9.872l-4 1.454v-9.872zM15 12.3l-4 1.455v-9.872l4-1.455v9.872z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4e88716434a0889f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 17 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 1c3.866 0 7 3.134 7 7s-3.134 7-7 7v-1.5c1.469 0 2.85-0.572 3.889-1.611s1.611-2.42 1.611-3.889c0-1.469-0.572-2.85-1.611-3.889s-2.42-1.611-3.889-1.611c-1.469 0-2.85 0.572-3.889 1.611-0.799 0.799-1.322 1.801-1.52 2.889h2.909l-3.5 4-3.5-4h2.571c0.485-3.392 3.402-6 6.929-6zM13 7v2h-4v-5h2v3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a8eebf6841418ba7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.293 11.707l-3.293-3.293v-4.414h2v3.586l2.707 2.707zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$af375054c2e983b1(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM10.293 11.707l-3.293-3.293v-4.414h2v3.586l2.707 2.707-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5750e5eefab17c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM8 14.625c-3.107 0-5.625-2.518-5.625-5.625s2.518-5.625 5.625-5.625c3.107 0 5.625 2.518 5.625 5.625s-2.518 5.625-5.625 5.625zM14.606 4.487c0.251-0.438 0.394-0.946 0.394-1.487 0-1.657-1.343-3-3-3-0.966 0-1.825 0.457-2.374 1.166 2.061 0.426 3.831 1.644 4.98 3.322v0zM6.374 1.166c-0.549-0.709-1.408-1.166-2.374-1.166-1.657 0-3 1.343-3 3 0 0.541 0.143 1.049 0.394 1.487 1.148-1.678 2.919-2.896 4.98-3.322z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9v-4h-1v5h4v-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2dd2f3014e2f7e55(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.023 12.5c0-4.5-4-3.5-4-7 0-0.29-0.028-0.538-0.079-0.749-0.263-1.766-1.44-3.183-2.965-3.615 0.014-0.062 0.021-0.125 0.021-0.191 0-0.52-0.45-0.945-1-0.945s-1 0.425-1 0.945c0 0.065 0.007 0.129 0.021 0.191-1.71 0.484-2.983 2.208-3.020 4.273-0.001 0.030-0.001 0.060-0.001 0.091 0 3.5-4 2.5-4 7 0 1.191 2.665 2.187 6.234 2.439 0.336 0.631 1.001 1.061 1.766 1.061s1.43-0.43 1.766-1.061c3.568-0.251 6.234-1.248 6.234-2.439 0-0.004-0-0.007-0-0.011l0.024 0.011zM12.91 13.345c-0.847 0.226-1.846 0.389-2.918 0.479-0.089-1.022-0.947-1.824-1.992-1.824s-1.903 0.802-1.992 1.824c-1.072-0.090-2.071-0.253-2.918-0.479-1.166-0.311-1.724-0.659-1.928-0.845 0.204-0.186 0.762-0.534 1.928-0.845 1.356-0.362 3.1-0.561 4.91-0.561s3.554 0.199 4.91 0.561c1.166 0.311 1.724 0.659 1.928 0.845-0.204 0.186-0.762 0.534-1.928 0.845z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7994d4b2db6cdb65(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3.019v-1.019h2v-1c0-0.552-0.448-1-1-1h-3c-0.552 0-1 0.448-1 1v1h2v1.019c-3.356 0.255-6 3.059-6 6.481 0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5c0-3.422-2.644-6.226-6-6.481zM11.036 13.036c-0.944 0.944-2.2 1.464-3.536 1.464s-2.591-0.52-3.536-1.464c-0.944-0.944-1.464-2.2-1.464-3.536s0.52-2.591 1.464-3.536c0.907-0.907 2.101-1.422 3.377-1.462l-0.339 4.907c-0.029 0.411 0.195 0.591 0.497 0.591s0.527-0.18 0.497-0.591l-0.339-4.907c1.276 0.040 2.47 0.555 3.377 1.462 0.944 0.944 1.464 2.2 1.464 3.536s-0.52 2.591-1.464 3.536z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ff7546ed4e55dfe3(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h2v2h-2zM8 6h2v2h-2zM11 6h2v2h-2zM2 12h2v2h-2zM5 12h2v2h-2zM8 12h2v2h-2zM5 9h2v2h-2zM8 9h2v2h-2zM11 9h2v2h-2zM2 9h2v2h-2zM13 0v1h-2v-1h-7v1h-2v-1h-2v16h15v-16h-2zM14 15h-13v-11h13v11z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$40968365cde705b6(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1h8v2h-8v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4h-14c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h3v4h8v-4h3c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM2 7c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM11 14h-6v-5h6v5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3adae755fce765d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2h-16c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h16c0.55 0 1-0.45 1-1v-10c0-0.55-0.45-1-1-1zM10 4h2v2h-2v-2zM13 7v2h-2v-2h2zM7 4h2v2h-2v-2zM10 7v2h-2v-2h2zM4 4h2v2h-2v-2zM7 7v2h-2v-2h2zM2 4h1v2h-1v-2zM2 7h2v2h-2v-2zM3 12h-1v-2h1v2zM12 12h-8v-2h8v2zM16 12h-3v-2h3v2zM16 9h-2v-2h2v2zM16 6h-3v-2h3v2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5a1f5eb189d9173e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1v10h16v-10h-16zM15 10h-14v-8h14v8zM10.5 12h-5l-0.5 2-1 1h8l-1-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$18009a84bf47c36e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11v-8c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v8h-2v3h16v-3h-2zM10 13h-4v-1h4v1zM13 11h-10v-7.998c0.001-0.001 0.001-0.001 0.002-0.002h9.996c0.001 0.001 0.001 0.001 0.002 0.002v7.998z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b91ab7c941064376(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 0h-7c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h7c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 0.75h4v0.5h-4v-0.5zM8 15c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM12 12h-8v-10h8v10z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5db6fea9555af477(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0h-9c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM7.5 15.278c-0.43 0-0.778-0.348-0.778-0.778s0.348-0.778 0.778-0.778 0.778 0.348 0.778 0.778-0.348 0.778-0.778 0.778zM12 13h-9v-11h9v11z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$31255dc24cf38d4b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 0h-10c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h10c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM7.5 15.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM12 14h-9v-12h9v12z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$46af652a8a36c6e0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.331 4.502c-1.388-0.199-2.865-0.344-4.407-0.425l2.576-2.576-1-1-3.509 3.509c-0.328-0.006-0.659-0.009-0.991-0.009v0l-4-4-1 1 3.034 3.034c-1.889 0.066-3.693 0.227-5.365 0.467-0.43 1.683-0.669 3.543-0.669 5.498s0.239 3.815 0.669 5.498c2.244 0.323 4.724 0.502 7.331 0.502s5.087-0.179 7.331-0.502c0.43-1.683 0.669-3.543 0.669-5.498s-0.239-3.815-0.669-5.498zM13.498 13.666c-1.683 0.215-3.543 0.334-5.498 0.334s-3.815-0.119-5.498-0.334c-0.323-1.122-0.502-2.362-0.502-3.666s0.179-2.543 0.502-3.666c1.683-0.215 3.543-0.334 5.498-0.334s3.815 0.119 5.498 0.334c0.323 1.122 0.502 2.362 0.502 3.666s-0.179 2.543-0.502 3.666z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$28de354d17a07f60(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.89 10.188l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188h-7c-0.152 0-0.296 0.069-0.39 0.188l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312zM15 11h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.74-4.675h6.519l3.74 4.675v0.325z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 8h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 10h-9c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h9c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b55e5f1e0e4db823(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.89 10.188l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188h-7c-0.152 0-0.296 0.069-0.39 0.188l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312zM15 11h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.74-4.675h6.519l3.74 4.675v0.325z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c8fdfe52f241075(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1h-10l-3 3v10.5c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-10.5l-3-3zM8 13l-5-4h3v-3h4v3h3l-5 4zM2.414 3l1-1h9.172l1 1h-11.172z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$277e8b380b6ffab4(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1h-10l-3 3v10.5c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-10.5l-3-3zM10 10v3h-4v-3h-3l5-4 5 4h-3zM2.414 3l1-1h9.171l1 1h-11.171z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c20cd054a9a36ef2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9l4-4h-3v-4h-2v4h-3zM11.636 7.364l-1.121 1.121 4.064 1.515-6.579 2.453-6.579-2.453 4.064-1.515-1.121-1.121-4.364 1.636v4l8 3 8-3v-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4eb2526ed9477ff(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h2v-4h3l-4-4-4 4h3zM10 6.75v1.542l4.579 1.708-6.579 2.453-6.579-2.453 4.579-1.708v-1.542l-6 2.25v4l8 3 8-3v-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$14d63ab51339b6c0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-14v16h16v-14l-2-2zM8 2h2v4h-2v-4zM14 14h-12v-12h1v5h9v-5h1.172l0.828 0.828v11.172z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$67c5bddfc23df626(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h10c1.657 0 3-1.343 3-3h-16c0 1.657 1.343 3 3 3zM13 12h1v1h-1v-1zM15 2h-14l-1 8h16z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$479a9ac121a70a47(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 1.119-8 2.5v2c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-2c0-1.381-3.582-2.5-8-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8.5c-4.418 0-8-1.119-8-2.5v3c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-3c0 1.381-3.582 2.5-8 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13c-4.418 0-8-1.119-8-2.5v3c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-3c0 1.381-3.582 2.5-8 2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$83ca20fff58fab2e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c-2.209 0-4.209 0.896-5.657 2.343l-2.343-2.343v6h6l-2.243-2.243c1.086-1.086 2.586-1.757 4.243-1.757 3.314 0 6 2.686 6 6 0 1.792-0.786 3.401-2.032 4.5l1.323 1.5c1.661-1.466 2.709-3.611 2.709-6 0-4.418-3.582-8-8-8z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$91dfd8e3fc44674d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 9c0 2.389 1.048 4.534 2.709 6l1.323-1.5c-1.246-1.099-2.031-2.708-2.031-4.5 0-3.314 2.686-6 6-6 1.657 0 3.157 0.672 4.243 1.757l-2.243 2.243h6v-6l-2.343 2.343c-1.448-1.448-3.448-2.343-5.657-2.343-4.418 0-8 3.582-8 8z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e82b2095c9c7af5f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.904 16c1.777-3.219 2.076-8.13-4.904-7.966v3.966l-6-6 6-6v3.881c8.359-0.218 9.29 7.378 4.904 12.119z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$11913e4313cc142b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3.881v-3.881l6 6-6 6v-3.966c-6.98-0.164-6.681 4.747-4.904 7.966-4.386-4.741-3.455-12.337 4.904-12.119z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4a7a8191d1222019(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.096 0c-1.777 3.219-2.076 8.13 4.904 7.966v-3.966l6 6-6 6v-3.881c-8.359 0.218-9.29-7.378-4.904-12.119z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ac6b193939a0de40(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12.119v3.881l-6-6 6-6v3.966c6.98 0.164 6.681-4.747 4.904-7.966 4.386 4.741 3.455 12.337-4.904 12.119z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2672224476b7d58a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8d4f90c96e67bf9d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14.081c0 0.711 0.407 1.327 1 1.628v0.249c-0.166 0.023-0.335 0.035-0.508 0.035-1.063 0-2.021-0.446-2.699-1.16-0.41 0.109-0.844 0.168-1.293 0.168-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4c2.485 0 4.5 1.791 4.5 4 0 0.865-0.309 1.665-0.834 2.32-0.107 0.232-0.166 0.489-0.166 0.761zM8 0c4.351 0 7.89 2.822 7.997 6.336-0.768-0.343-1.619-0.524-2.497-0.524-1.493 0-2.903 0.523-3.971 1.472-1.107 0.984-1.717 2.304-1.717 3.716 0 0.698 0.149 1.373 0.433 1.997-0.082 0.002-0.164 0.003-0.246 0.003-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$62b4d0b20a88e85c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 0v0c4.142 0 7.5 2.717 7.5 6.069s-3.358 6.069-7.5 6.069c-0.398 0-0.788-0.025-1.169-0.074-1.611 1.605-3.471 1.892-5.331 1.935v-0.393c1.004-0.49 1.813-1.382 1.813-2.402 0-0.142-0.011-0.282-0.032-0.419-1.696-1.113-2.781-2.812-2.781-4.717 0-3.352 3.358-6.069 7.5-6.069zM15.563 13.604c0 0.874 0.567 1.639 1.438 2.059v0.337c-1.611-0.036-3.090-0.283-4.487-1.658-0.33 0.041-0.669 0.063-1.013 0.063-1.492 0-2.866-0.402-3.963-1.079 2.261-0.008 4.395-0.732 6.013-2.042 0.816-0.66 1.459-1.435 1.913-2.302 0.481-0.92 0.724-1.9 0.724-2.913 0-0.163-0.007-0.326-0.020-0.487 1.134 0.936 1.832 2.213 1.832 3.62 0 1.633-0.94 3.089-2.41 4.043-0.018 0.117-0.027 0.237-0.027 0.359z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$14a06deeb21fd68b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3c-0.858 0-1.687 0.135-2.464 0.402-0.73 0.251-1.38 0.605-1.932 1.054-1.035 0.841-1.604 1.922-1.604 3.044 0 0.63 0.175 1.24 0.52 1.815 0.356 0.592 0.89 1.134 1.547 1.566 0.474 0.312 0.793 0.812 0.878 1.373 0.028 0.187 0.046 0.376 0.053 0.564 0.117-0.097 0.23-0.201 0.342-0.312 0.377-0.377 0.887-0.586 1.414-0.586 0.084 0 0.168 0.005 0.252 0.016 0.328 0.042 0.662 0.063 0.995 0.063 0.858 0 1.687-0.135 2.464-0.402 0.73-0.251 1.38-0.605 1.932-1.054 1.035-0.841 1.604-1.922 1.604-3.044s-0.57-2.203-1.604-3.044c-0.552-0.448-1.202-0.803-1.932-1.054-0.777-0.267-1.606-0.402-2.464-0.402zM8 1v0c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$dc6d73482c96262b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14.081c0 0.711 0.407 1.327 1 1.628v0.249c-0.166 0.023-0.335 0.035-0.508 0.035-1.063 0-2.021-0.446-2.699-1.16-0.41 0.109-0.844 0.168-1.293 0.168-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4c2.485 0 4.5 1.791 4.5 4 0 0.865-0.309 1.665-0.834 2.32-0.107 0.232-0.166 0.489-0.166 0.761zM3.604 3.456c-1.035 0.841-1.604 1.922-1.604 3.044 0 0.63 0.175 1.24 0.52 1.815 0.356 0.592 0.89 1.134 1.547 1.566 0.474 0.312 0.793 0.812 0.878 1.373 0.028 0.187 0.046 0.376 0.053 0.564 0.117-0.097 0.23-0.201 0.342-0.312 0.377-0.377 0.887-0.586 1.414-0.586 0.084 0 0.168 0.005 0.252 0.016 0.327 0.042 0.662 0.063 0.994 0.063v2c-0.424-0-0.84-0.027-1.246-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5 4.351 0 7.89 2.822 7.997 6.336-0.642-0.286-1.341-0.46-2.067-0.509-0.18-0.876-0.709-1.7-1.535-2.371-0.552-0.448-1.202-0.803-1.932-1.054-0.777-0.267-1.606-0.402-2.464-0.402s-1.687 0.135-2.464 0.402c-0.73 0.251-1.38 0.605-1.932 1.054z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f68641e47393bbe(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 2c-0.792 0-1.556 0.124-2.272 0.369-0.671 0.23-1.267 0.554-1.773 0.963-0.938 0.759-1.455 1.731-1.455 2.737 0 0.562 0.157 1.109 0.467 1.623 0.323 0.537 0.811 1.028 1.41 1.421 0.476 0.312 0.796 0.812 0.881 1.374 0.014 0.094 0.025 0.188 0.034 0.282 0.043-0.039 0.085-0.080 0.127-0.122 0.377-0.376 0.886-0.583 1.411-0.583 0.084 0 0.167 0.005 0.251 0.016 0.303 0.038 0.611 0.058 0.918 0.058 0.792 0 1.556-0.124 2.272-0.369 0.671-0.23 1.267-0.554 1.774-0.963 0.938-0.759 1.455-1.731 1.455-2.737s-0.517-1.978-1.455-2.737c-0.506-0.41-1.103-0.734-1.774-0.963-0.716-0.245-1.48-0.369-2.272-0.369zM7.5 0v0c4.142 0 7.5 2.717 7.5 6.069s-3.358 6.069-7.5 6.069c-0.398 0-0.788-0.025-1.169-0.074-1.611 1.605-3.471 1.892-5.331 1.935v-0.393c1.004-0.49 1.813-1.382 1.813-2.402 0-0.142-0.011-0.282-0.032-0.419-1.696-1.113-2.781-2.812-2.781-4.717 0-3.352 3.358-6.069 7.5-6.069zM15.563 13.604c0 0.874 0.567 1.639 1.438 2.059v0.337c-1.611-0.036-3.090-0.283-4.487-1.658-0.33 0.041-0.669 0.063-1.013 0.063-1.492 0-2.866-0.402-3.963-1.079 2.261-0.008 4.395-0.732 6.013-2.042 0.816-0.66 1.459-1.435 1.913-2.302 0.481-0.92 0.724-1.9 0.724-2.913 0-0.163-0.007-0.326-0.020-0.487 1.134 0.936 1.832 2.213 1.832 3.62 0 1.633-0.94 3.089-2.41 4.043-0.018 0.117-0.027 0.237-0.027 0.359z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f38b250caee552b1(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6a82586665f66da0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.112 12.427c0.864-0.565 1.939-0.994 3.122-1.256-0.235-0.278-0.449-0.588-0.633-0.922-0.475-0.863-0.726-1.813-0.726-2.748 0-1.344 0-2.614 0.478-3.653 0.464-1.008 1.299-1.633 2.488-1.867-0.264-1.195-0.968-1.98-2.841-1.98-3 0-3 2.015-3 4.5 0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h4.359c0.227-0.202 0.478-0.393 0.753-0.573z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$248e30147c253d71(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM14 12h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$affdc64a2d70855(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM14 12h-5v-1h5v1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$831591c799b36dc2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.5l-4.5 4.5-1.5-1.5-1 1 2.5 2.5 5.5-5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h5v-1.799c-1.050-0.613-2.442-1.033-4-1.16v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h7v-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$95a73a89a1df691d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3zM12.001 7h-0.553l-3.111 6.316 1.163-5.816-1.5-1.5-1.5 1.5 1.163 5.816-3.111-6.316h-0.554c-1.999 0-1.999 1.344-1.999 3v5h12v-5c0-1.656 0-3-1.999-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$db282baebaa21c0a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.548-0.043zM12.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.549-0.043z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a93891b88f7e6f2b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 10c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5l0.016 0.5c0 3.866-3.134 7-7 7v-2c1.336 0 2.591-0.52 3.536-1.464 0.182-0.182 0.348-0.375 0.497-0.578-0.179 0.028-0.362 0.043-0.549 0.043zM3.5 10c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5l0.016 0.5c0 3.866-3.134 7-7 7v-2c1.336 0 2.591-0.52 3.536-1.464 0.182-0.182 0.348-0.375 0.497-0.578-0.179 0.028-0.362 0.043-0.549 0.043z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a66f6ada53dc5b6a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.39 8c2.152-1.365 3.61-3.988 3.61-7 0-0.339-0.019-0.672-0.054-1h-13.891c-0.036 0.328-0.054 0.661-0.054 1 0 3.012 1.457 5.635 3.609 7-2.152 1.365-3.609 3.988-3.609 7 0 0.339 0.019 0.672 0.054 1h13.891c0.036-0.328 0.054-0.661 0.054-1 0-3.012-1.457-5.635-3.609-7zM2.5 15c0-2.921 1.253-5.397 3.5-6.214v-1.572c-2.247-0.817-3.5-3.294-3.5-6.214v0h11c0 2.921-1.253 5.397-3.5 6.214v1.572c2.247 0.817 3.5 3.294 3.5 6.214h-11zM9.682 10.462c-1.12-0.635-1.181-1.459-1.182-1.959v-1.004c0-0.5 0.059-1.327 1.184-1.963 0.602-0.349 1.122-0.88 1.516-1.537h-6.4c0.395 0.657 0.916 1.188 1.518 1.538 1.12 0.635 1.181 1.459 1.182 1.959v1.004c0 0.5-0.059 1.327-1.184 1.963-1.135 0.659-1.98 1.964-2.236 3.537h7.839c-0.256-1.574-1.102-2.879-2.238-3.538z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$478089eedc9dcc41(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10.243 3.757c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM13 8c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.243 12.243c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM7 14c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM2.757 12.243c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM2.257 3.757c0 0 0 0 0 0 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM0.875 8c0-0.621 0.504-1.125 1.125-1.125s1.125 0.504 1.125 1.125c0 0.621-0.504 1.125-1.125 1.125s-1.125-0.504-1.125-1.125z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$82f768d8c80101f0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c-0.020-1.045-0.247-2.086-0.665-3.038-0.417-0.953-1.023-1.817-1.766-2.53s-1.624-1.278-2.578-1.651c-0.953-0.374-1.978-0.552-2.991-0.531-1.013 0.020-2.021 0.24-2.943 0.646-0.923 0.405-1.758 0.992-2.449 1.712s-1.237 1.574-1.597 2.497c-0.361 0.923-0.533 1.914-0.512 2.895 0.020 0.981 0.234 1.955 0.627 2.847 0.392 0.892 0.961 1.7 1.658 2.368s1.523 1.195 2.416 1.543c0.892 0.348 1.851 0.514 2.799 0.493 0.949-0.020 1.89-0.227 2.751-0.608 0.862-0.379 1.642-0.929 2.287-1.604s1.154-1.472 1.488-2.335c0.204-0.523 0.342-1.069 0.415-1.622 0.019 0.001 0.039 0.002 0.059 0.002 0.552 0 1-0.448 1-1 0-0.028-0.001-0.056-0.004-0.083h0.004zM14.411 10.655c-0.367 0.831-0.898 1.584-1.55 2.206s-1.422 1.112-2.254 1.434c-0.832 0.323-1.723 0.476-2.608 0.454-0.884-0.020-1.759-0.215-2.56-0.57-0.801-0.354-1.526-0.867-2.125-1.495s-1.071-1.371-1.38-2.173c-0.31-0.801-0.457-1.66-0.435-2.512s0.208-1.694 0.551-2.464c0.342-0.77 0.836-1.468 1.441-2.044s1.321-1.029 2.092-1.326c0.771-0.298 1.596-0.438 2.416-0.416s1.629 0.202 2.368 0.532c0.74 0.329 1.41 0.805 1.963 1.387s0.988 1.27 1.272 2.011c0.285 0.74 0.418 1.532 0.397 2.32h0.004c-0.002 0.027-0.004 0.055-0.004 0.083 0 0.516 0.39 0.94 0.892 0.994-0.097 0.544-0.258 1.075-0.481 1.578z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9de4aca22f1e1ca(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.736c-0.515 0-0.933-0.418-0.933-0.933v-2.798c0-0.515 0.418-0.933 0.933-0.933s0.933 0.418 0.933 0.933v2.798c0 0.515-0.418 0.933-0.933 0.933z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15.577c-0.322 0-0.583-0.261-0.583-0.583v-2.798c0-0.322 0.261-0.583 0.583-0.583s0.583 0.261 0.583 0.583v2.798c0 0.322-0.261 0.583-0.583 0.583z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.902 5.24c-0.302 0-0.596-0.157-0.758-0.437l-1.399-2.423c-0.241-0.418-0.098-0.953 0.32-1.194s0.953-0.098 1.194 0.32l1.399 2.423c0.241 0.418 0.098 0.953-0.32 1.194-0.138 0.079-0.288 0.117-0.436 0.117z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.498 14.582c-0.181 0-0.358-0.094-0.455-0.262l-1.399-2.423c-0.145-0.251-0.059-0.572 0.192-0.717s0.572-0.059 0.717 0.192l1.399 2.423c0.145 0.251 0.059 0.572-0.192 0.717-0.083 0.048-0.173 0.070-0.262 0.070z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.365 6.718c-0.138 0-0.279-0.035-0.407-0.109l-2.423-1.399c-0.39-0.225-0.524-0.724-0.299-1.115s0.724-0.524 1.115-0.299l2.423 1.399c0.39 0.225 0.524 0.724 0.299 1.115-0.151 0.262-0.425 0.408-0.707 0.408z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.057 11.964c-0.079 0-0.159-0.020-0.233-0.063l-2.423-1.399c-0.223-0.129-0.299-0.414-0.171-0.637s0.414-0.299 0.637-0.171l2.423 1.399c0.223 0.129 0.299 0.414 0.171 0.637-0.086 0.15-0.243 0.233-0.404 0.233z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.803 8.758h-2.798c-0.418 0-0.758-0.339-0.758-0.758s0.339-0.758 0.758-0.758h2.798c0.419 0 0.758 0.339 0.758 0.758s-0.339 0.758-0.758 0.758z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.995 8.466c-0 0 0 0 0 0h-2.798c-0.258-0-0.466-0.209-0.466-0.466s0.209-0.466 0.466-0.466c0 0 0 0 0 0h2.798c0.258 0 0.466 0.209 0.466 0.466s-0.209 0.466-0.466 0.466z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.943 12.197c-0.242 0-0.477-0.125-0.606-0.35-0.193-0.335-0.079-0.762 0.256-0.955l2.423-1.399c0.335-0.193 0.762-0.079 0.955 0.256s0.079 0.762-0.256 0.955l-2.423 1.399c-0.11 0.064-0.23 0.094-0.349 0.094z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.635 6.368c-0.161 0-0.318-0.084-0.404-0.233-0.129-0.223-0.052-0.508 0.171-0.637l2.423-1.399c0.223-0.129 0.508-0.052 0.637 0.171s0.052 0.508-0.171 0.637l-2.423 1.399c-0.073 0.042-0.154 0.063-0.233 0.063z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.502 14.699c-0.109 0-0.219-0.028-0.32-0.086-0.307-0.177-0.412-0.569-0.235-0.876l1.399-2.423c0.177-0.307 0.569-0.412 0.876-0.235s0.412 0.569 0.235 0.876l-1.399 2.423c-0.119 0.206-0.334 0.321-0.556 0.321z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.098 4.832c-0.079 0-0.159-0.020-0.233-0.063-0.223-0.129-0.299-0.414-0.171-0.637l1.399-2.423c0.129-0.223 0.414-0.299 0.637-0.171s0.299 0.414 0.171 0.637l-1.399 2.423c-0.086 0.15-0.243 0.233-0.404 0.233z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c5a65ca13e682471(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8c0-0.19 0.011-0.378 0.032-0.563l-2.89-0.939c-0.092 0.487-0.141 0.989-0.141 1.502 0 2.3 0.971 4.374 2.526 5.833l1.786-2.458c-0.814-0.889-1.312-2.074-1.312-3.375zM13 8c0 1.301-0.497 2.486-1.312 3.375l1.786 2.458c1.555-1.459 2.526-3.533 2.526-5.833 0-0.513-0.049-1.015-0.141-1.502l-2.89 0.939c0.021 0.185 0.032 0.373 0.032 0.563zM9 3.1c1.436 0.292 2.649 1.199 3.351 2.435l2.89-0.939c-1.144-2.428-3.473-4.188-6.241-4.534v3.038zM3.649 5.535c0.702-1.236 1.914-2.143 3.351-2.435v-3.038c-2.769 0.345-5.097 2.105-6.241 4.534l2.89 0.939zM10.071 12.552c-0.631 0.288-1.332 0.448-2.071 0.448s-1.44-0.16-2.071-0.448l-1.786 2.458c1.144 0.631 2.458 0.99 3.857 0.99s2.713-0.359 3.857-0.99l-1.786-2.458z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a0e4a76c825f54f0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 4c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4zM12.773 12.773c-1.275 1.275-2.97 1.977-4.773 1.977s-3.498-0.702-4.773-1.977-1.977-2.97-1.977-4.773c0-1.803 0.702-3.498 1.977-4.773l1.061 1.061c0 0 0 0 0 0-2.047 2.047-2.047 5.378 0 7.425 0.992 0.992 2.31 1.538 3.712 1.538s2.721-0.546 3.712-1.538c2.047-2.047 2.047-5.378 0-7.425l1.061-1.061c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2ab4b75c612bd3c1(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM12.359 8c0 0 0 0 0 0 0-0.906 0.735-1.641 1.641-1.641s1.641 0.735 1.641 1.641c0 0 0 0 0 0 0 0.906-0.735 1.641-1.641 1.641s-1.641-0.735-1.641-1.641zM10.757 12.243c0-0.821 0.665-1.486 1.486-1.486s1.486 0.665 1.486 1.486c0 0.821-0.665 1.486-1.486 1.486s-1.486-0.665-1.486-1.486zM6.654 14c0-0.743 0.603-1.346 1.346-1.346s1.346 0.603 1.346 1.346c0 0.743-0.603 1.346-1.346 1.346s-1.346-0.603-1.346-1.346zM2.538 12.243c0-0.673 0.546-1.219 1.219-1.219s1.219 0.546 1.219 1.219c0 0.673-0.546 1.219-1.219 1.219s-1.219-0.546-1.219-1.219zM0.896 8c0-0.61 0.494-1.104 1.104-1.104s1.104 0.494 1.104 1.104c0 0.61-0.494 1.104-1.104 1.104s-1.104-0.494-1.104-1.104zM2.757 3.757c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM14.054 3.757c0 1-0.811 1.811-1.812 1.811s-1.812-0.811-1.812-1.811c0-1.001 0.811-1.811 1.812-1.811s1.812 0.811 1.812 1.811z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9c922f530d16bea(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM0 8c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM13 8c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM1.904 3.404c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM11.096 12.596c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM1.904 12.596c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM11.096 3.404c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$262c20f37c2b1384(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c-2.137 0-4.146-0.832-5.657-2.343s-2.343-3.52-2.343-5.657c0-1.513 0.425-2.986 1.228-4.261 0.781-1.239 1.885-2.24 3.193-2.895l0.672 1.341c-1.063 0.533-1.961 1.347-2.596 2.354-0.652 1.034-0.997 2.231-0.997 3.461 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-1.23-0.345-2.426-0.997-3.461-0.635-1.008-1.533-1.822-2.596-2.354l0.672-1.341c1.308 0.655 2.412 1.656 3.193 2.895 0.803 1.274 1.228 2.748 1.228 4.261 0 2.137-0.832 4.146-2.343 5.657s-3.52 2.343-5.657 2.343z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9289597c98fcf795(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.355 0-7.898 3.481-7.998 7.812 0.092-3.779 2.966-6.812 6.498-6.812 3.59 0 6.5 3.134 6.5 7 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-4.418-3.582-8-8-8zM8 16c4.355 0 7.898-3.481 7.998-7.812-0.092 3.779-2.966 6.812-6.498 6.812-3.59 0-6.5-3.134-6.5-7 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 4.418 3.582 8 8 8z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$419e599b83badcff(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.001 8.025l-0 0c0 0 0 0.001 0 0.003 0.002 0.061 0.009 0.12 0.021 0.177 0.003 0.027 0.007 0.057 0.011 0.090 0.003 0.029 0.007 0.061 0.011 0.095 0.006 0.040 0.012 0.083 0.019 0.128 0.013 0.090 0.028 0.189 0.045 0.296 0.021 0.101 0.044 0.21 0.068 0.326 0.011 0.058 0.028 0.117 0.044 0.178s0.032 0.123 0.049 0.188c0.009 0.032 0.016 0.065 0.027 0.097s0.021 0.065 0.031 0.098 0.043 0.134 0.065 0.203c0.006 0.017 0.011 0.035 0.017 0.052s0.013 0.034 0.019 0.052 0.026 0.070 0.039 0.105c0.027 0.070 0.053 0.142 0.081 0.215 0.031 0.071 0.062 0.144 0.094 0.218 0.016 0.037 0.032 0.074 0.048 0.111s0.035 0.073 0.053 0.111 0.073 0.148 0.11 0.224c0.039 0.075 0.081 0.149 0.123 0.224 0.021 0.037 0.042 0.075 0.063 0.113s0.045 0.074 0.068 0.112 0.093 0.149 0.14 0.224c0.198 0.295 0.417 0.587 0.66 0.864 0.245 0.275 0.511 0.535 0.792 0.775 0.284 0.236 0.582 0.452 0.886 0.642 0.306 0.188 0.619 0.349 0.928 0.487 0.078 0.032 0.156 0.063 0.232 0.095 0.038 0.015 0.076 0.032 0.115 0.046s0.077 0.027 0.115 0.041 0.151 0.054 0.226 0.078c0.075 0.022 0.15 0.044 0.224 0.066 0.037 0.011 0.073 0.022 0.109 0.031s0.073 0.018 0.109 0.027 0.143 0.035 0.213 0.052c0.070 0.014 0.139 0.027 0.207 0.040 0.034 0.006 0.067 0.013 0.101 0.019 0.017 0.003 0.033 0.006 0.049 0.009s0.033 0.005 0.049 0.007c0.066 0.009 0.13 0.018 0.192 0.027 0.031 0.004 0.062 0.009 0.093 0.013s0.061 0.006 0.091 0.009 0.118 0.010 0.174 0.015c0.056 0.005 0.111 0.011 0.164 0.012 0.004 0 0.007 0 0.011 0 0.010 0.544 0.453 0.982 1 0.982 0.008 0 0.017-0 0.025-0.001v0c0 0 0.001-0 0.004-0 0.061-0.002 0.12-0.009 0.177-0.021 0.027-0.003 0.057-0.007 0.090-0.011 0.029-0.003 0.061-0.007 0.095-0.011 0.040-0.006 0.083-0.012 0.128-0.019 0.090-0.013 0.189-0.028 0.296-0.045 0.101-0.021 0.21-0.044 0.326-0.068 0.058-0.011 0.117-0.028 0.178-0.044s0.123-0.033 0.188-0.049c0.032-0.009 0.065-0.016 0.097-0.027s0.065-0.021 0.098-0.031 0.134-0.043 0.203-0.065c0.017-0.006 0.035-0.011 0.052-0.017s0.034-0.013 0.052-0.019 0.070-0.026 0.105-0.039c0.070-0.027 0.142-0.053 0.215-0.081 0.071-0.031 0.144-0.062 0.218-0.094 0.037-0.016 0.074-0.032 0.111-0.048s0.073-0.035 0.111-0.053 0.148-0.073 0.224-0.11c0.075-0.039 0.149-0.081 0.224-0.123 0.037-0.021 0.075-0.042 0.113-0.063s0.074-0.045 0.112-0.068 0.149-0.093 0.224-0.14c0.295-0.197 0.587-0.417 0.864-0.66 0.275-0.245 0.535-0.511 0.775-0.792 0.236-0.284 0.452-0.582 0.642-0.886 0.188-0.306 0.349-0.619 0.487-0.928 0.032-0.078 0.063-0.156 0.095-0.232 0.015-0.038 0.032-0.076 0.046-0.115s0.027-0.077 0.040-0.115 0.054-0.151 0.078-0.226c0.022-0.075 0.044-0.15 0.066-0.224 0.011-0.037 0.022-0.073 0.031-0.109s0.018-0.073 0.027-0.109 0.035-0.143 0.052-0.213c0.014-0.070 0.027-0.139 0.040-0.207 0.006-0.034 0.013-0.067 0.019-0.101 0.003-0.017 0.006-0.033 0.009-0.049s0.005-0.033 0.007-0.050c0.009-0.065 0.018-0.13 0.027-0.192 0.004-0.031 0.009-0.062 0.013-0.093s0.006-0.061 0.009-0.091 0.010-0.118 0.015-0.174c0.005-0.056 0.011-0.111 0.012-0.165 0-0.008 0.001-0.016 0.001-0.025 0.55-0.002 0.996-0.449 0.996-1 0-0.008-0-0.017-0.001-0.025h0c0 0-0-0.001-0-0.003-0.002-0.061-0.009-0.12-0.021-0.177-0.003-0.027-0.007-0.057-0.011-0.090-0.003-0.029-0.007-0.061-0.011-0.095-0.006-0.040-0.012-0.083-0.019-0.128-0.013-0.090-0.028-0.189-0.045-0.296-0.021-0.101-0.044-0.21-0.068-0.326-0.011-0.058-0.028-0.117-0.044-0.178s-0.032-0.123-0.049-0.188c-0.009-0.032-0.016-0.065-0.027-0.097s-0.021-0.065-0.031-0.098-0.043-0.134-0.065-0.203c-0.005-0.017-0.011-0.035-0.017-0.052s-0.013-0.034-0.019-0.052-0.026-0.070-0.039-0.105c-0.027-0.070-0.053-0.142-0.081-0.215-0.031-0.071-0.062-0.144-0.094-0.218-0.016-0.037-0.032-0.074-0.048-0.111s-0.035-0.073-0.053-0.111-0.073-0.148-0.11-0.224c-0.039-0.075-0.081-0.149-0.123-0.224-0.021-0.037-0.042-0.075-0.063-0.113s-0.045-0.074-0.068-0.112-0.093-0.149-0.14-0.224c-0.197-0.295-0.417-0.587-0.66-0.864-0.245-0.275-0.511-0.535-0.792-0.775-0.284-0.236-0.582-0.452-0.886-0.642-0.306-0.188-0.619-0.349-0.928-0.487-0.078-0.032-0.156-0.063-0.232-0.095-0.038-0.015-0.076-0.032-0.115-0.046s-0.077-0.027-0.115-0.040-0.151-0.054-0.226-0.078c-0.075-0.022-0.15-0.044-0.224-0.066-0.037-0.010-0.073-0.022-0.109-0.031s-0.073-0.018-0.109-0.027-0.143-0.035-0.213-0.052c-0.070-0.014-0.139-0.027-0.207-0.040-0.034-0.006-0.067-0.013-0.101-0.019-0.017-0.003-0.033-0.006-0.049-0.009s-0.033-0.005-0.049-0.007c-0.066-0.009-0.13-0.018-0.192-0.027-0.031-0.004-0.062-0.009-0.093-0.013s-0.061-0.006-0.091-0.009-0.118-0.010-0.174-0.015c-0.056-0.005-0.111-0.011-0.164-0.012-0.013-0-0.026-0.001-0.039-0.001-0.010-0.543-0.454-0.981-0.999-0.981-0.008 0-0.017 0-0.025 0.001l-0-0c0 0-0.001 0-0.003 0-0.061 0.002-0.12 0.009-0.177 0.021-0.027 0.003-0.057 0.007-0.090 0.011-0.029 0.003-0.061 0.007-0.095 0.011-0.040 0.006-0.083 0.012-0.128 0.019-0.090 0.013-0.189 0.028-0.296 0.045-0.101 0.021-0.21 0.044-0.326 0.068-0.058 0.011-0.117 0.028-0.178 0.044s-0.123 0.033-0.188 0.049c-0.032 0.009-0.065 0.016-0.097 0.027s-0.065 0.021-0.098 0.031-0.134 0.043-0.203 0.065c-0.017 0.006-0.035 0.011-0.052 0.017s-0.034 0.013-0.052 0.019-0.070 0.026-0.105 0.039c-0.070 0.027-0.142 0.053-0.215 0.081-0.071 0.031-0.144 0.062-0.218 0.094-0.037 0.016-0.074 0.032-0.111 0.048s-0.073 0.035-0.111 0.053-0.148 0.073-0.224 0.11c-0.075 0.039-0.149 0.081-0.224 0.123-0.037 0.021-0.075 0.042-0.113 0.063s-0.074 0.045-0.112 0.068-0.149 0.093-0.224 0.14c-0.295 0.198-0.587 0.417-0.864 0.66-0.275 0.245-0.535 0.511-0.775 0.792-0.236 0.284-0.452 0.582-0.642 0.886-0.188 0.306-0.349 0.619-0.487 0.928-0.032 0.078-0.063 0.156-0.095 0.232-0.015 0.038-0.032 0.076-0.046 0.115s-0.027 0.077-0.040 0.115-0.054 0.151-0.078 0.226c-0.022 0.075-0.044 0.15-0.066 0.224-0.011 0.037-0.022 0.073-0.032 0.109s-0.018 0.073-0.027 0.109-0.035 0.143-0.052 0.213c-0.014 0.070-0.027 0.139-0.040 0.207-0.006 0.034-0.013 0.067-0.019 0.101-0.003 0.017-0.006 0.033-0.009 0.049s-0.005 0.033-0.007 0.050c-0.009 0.065-0.018 0.13-0.027 0.192-0.004 0.031-0.009 0.062-0.013 0.093s-0.006 0.061-0.009 0.091-0.010 0.118-0.015 0.174c-0.005 0.056-0.011 0.111-0.012 0.165-0 0.009-0.001 0.017-0.001 0.025-0.537 0.017-0.967 0.458-0.967 0.999 0 0.008 0 0.017 0.001 0.025zM1.149 7.011c0.001-0.003 0.001-0.006 0.002-0.009 0.010-0.051 0.026-0.102 0.040-0.155s0.030-0.107 0.045-0.163c0.008-0.028 0.015-0.056 0.024-0.084s0.019-0.057 0.028-0.086 0.038-0.116 0.058-0.176c0.005-0.015 0.010-0.030 0.015-0.045s0.012-0.030 0.017-0.045 0.023-0.060 0.035-0.091 0.048-0.123 0.073-0.186c0.028-0.062 0.056-0.125 0.084-0.189 0.014-0.032 0.028-0.064 0.043-0.096s0.032-0.064 0.048-0.096 0.065-0.128 0.098-0.194c0.034-0.065 0.073-0.128 0.109-0.194 0.018-0.032 0.037-0.065 0.056-0.098s0.040-0.064 0.061-0.096c0.041-0.064 0.082-0.129 0.124-0.194 0.176-0.255 0.369-0.506 0.583-0.744 0.217-0.236 0.451-0.459 0.697-0.665 0.25-0.202 0.511-0.385 0.776-0.547 0.268-0.159 0.541-0.294 0.808-0.41 0.068-0.027 0.135-0.053 0.202-0.079 0.033-0.013 0.066-0.027 0.099-0.038s0.067-0.022 0.1-0.033 0.131-0.045 0.196-0.065c0.065-0.018 0.13-0.036 0.194-0.054 0.032-0.009 0.063-0.019 0.095-0.026s0.063-0.014 0.094-0.021 0.123-0.028 0.184-0.042c0.061-0.011 0.12-0.021 0.179-0.032 0.029-0.005 0.058-0.010 0.087-0.015 0.014-0.003 0.029-0.005 0.043-0.008s0.029-0.003 0.043-0.005c0.056-0.007 0.112-0.014 0.166-0.020 0.027-0.003 0.053-0.007 0.080-0.010s0.053-0.004 0.078-0.006 0.102-0.007 0.15-0.011c0.049-0.003 0.095-0.008 0.142-0.008 0.091-0.002 0.177-0.004 0.256-0.006 0.073 0.003 0.14 0.005 0.2 0.007 0.030 0.001 0.058 0.002 0.085 0.002 0.033 0.002 0.064 0.004 0.093 0.006 0.033 0.002 0.063 0.004 0.091 0.006 0.051 0.008 0.103 0.012 0.156 0.012 0.007 0 0.015-0 0.022-0.001 0.002 0 0.004 0 0.004 0v-0c0.487-0.012 0.887-0.372 0.962-0.84 0.008 0.002 0.017 0.004 0.025 0.006 0.051 0.010 0.102 0.026 0.155 0.040s0.107 0.030 0.163 0.045c0.028 0.008 0.056 0.015 0.084 0.024s0.057 0.019 0.086 0.028 0.116 0.038 0.176 0.058c0.015 0.005 0.030 0.010 0.045 0.015s0.030 0.012 0.045 0.017 0.060 0.023 0.091 0.035 0.123 0.048 0.186 0.073c0.062 0.028 0.125 0.056 0.189 0.084 0.032 0.014 0.064 0.028 0.096 0.043s0.064 0.032 0.096 0.048 0.128 0.065 0.194 0.098c0.065 0.034 0.129 0.073 0.194 0.109 0.032 0.018 0.065 0.037 0.098 0.056s0.064 0.040 0.096 0.061 0.129 0.082 0.194 0.124c0.255 0.176 0.506 0.369 0.744 0.583 0.236 0.217 0.459 0.451 0.665 0.697 0.202 0.25 0.385 0.511 0.547 0.776 0.159 0.268 0.294 0.541 0.41 0.808 0.027 0.068 0.053 0.135 0.079 0.202 0.013 0.033 0.027 0.066 0.038 0.099s0.022 0.067 0.033 0.1 0.045 0.131 0.065 0.196c0.018 0.065 0.036 0.13 0.054 0.194 0.009 0.032 0.019 0.063 0.026 0.095s0.014 0.063 0.021 0.094 0.028 0.123 0.042 0.184c0.011 0.061 0.021 0.12 0.032 0.179 0.005 0.029 0.010 0.058 0.015 0.087 0.003 0.014 0.005 0.029 0.008 0.043s0.003 0.029 0.005 0.043c0.007 0.056 0.014 0.112 0.020 0.166 0.003 0.027 0.007 0.053 0.010 0.080s0.004 0.053 0.006 0.078 0.007 0.102 0.011 0.15c0.003 0.049 0.008 0.095 0.008 0.142 0.002 0.091 0.004 0.177 0.006 0.256-0.003 0.073-0.005 0.14-0.007 0.2-0.001 0.030-0.002 0.058-0.002 0.085-0.002 0.033-0.004 0.064-0.006 0.093-0.002 0.033-0.004 0.063-0.006 0.091-0.008 0.051-0.012 0.103-0.012 0.156 0 0.007 0 0.015 0.001 0.022-0 0.002-0 0.004-0 0.004h0c0.012 0.481 0.363 0.877 0.823 0.959-0.001 0.005-0.002 0.009-0.003 0.014-0.010 0.051-0.025 0.102-0.040 0.155s-0.030 0.107-0.045 0.163c-0.008 0.028-0.015 0.056-0.024 0.084s-0.019 0.057-0.028 0.086-0.039 0.116-0.058 0.176c-0.005 0.015-0.010 0.030-0.015 0.045s-0.012 0.030-0.017 0.045-0.023 0.060-0.035 0.091-0.048 0.123-0.073 0.186c-0.028 0.062-0.056 0.125-0.084 0.189-0.014 0.032-0.028 0.064-0.043 0.096s-0.032 0.064-0.048 0.096-0.065 0.128-0.098 0.194c-0.034 0.065-0.073 0.129-0.109 0.194-0.018 0.032-0.037 0.065-0.056 0.098s-0.040 0.064-0.061 0.096-0.082 0.129-0.124 0.194c-0.176 0.255-0.369 0.506-0.583 0.744-0.217 0.236-0.451 0.459-0.697 0.665-0.25 0.202-0.511 0.385-0.776 0.547-0.268 0.159-0.541 0.294-0.808 0.41-0.068 0.027-0.135 0.053-0.202 0.079-0.033 0.013-0.066 0.027-0.099 0.038s-0.067 0.022-0.1 0.033-0.131 0.045-0.196 0.065c-0.065 0.018-0.13 0.036-0.194 0.054-0.032 0.009-0.063 0.019-0.095 0.026s-0.063 0.014-0.094 0.021-0.123 0.028-0.184 0.042c-0.061 0.011-0.12 0.021-0.179 0.032-0.029 0.005-0.058 0.010-0.087 0.015-0.014 0.003-0.028 0.005-0.043 0.008s-0.029 0.003-0.043 0.005c-0.056 0.007-0.112 0.014-0.166 0.020-0.027 0.003-0.053 0.007-0.080 0.010s-0.053 0.004-0.078 0.006-0.102 0.007-0.15 0.011c-0.049 0.003-0.095 0.008-0.142 0.008-0.091 0.002-0.177 0.004-0.256 0.006-0.073-0.003-0.14-0.005-0.2-0.007-0.030-0.001-0.058-0.002-0.085-0.002-0.033-0.002-0.064-0.004-0.093-0.006-0.033-0.002-0.063-0.004-0.091-0.006-0.051-0.008-0.103-0.012-0.156-0.012-0.007 0-0.015 0-0.022 0.001-0.002-0-0.003-0-0.003-0v0c-0.484 0.012-0.883 0.369-0.961 0.834-0.050-0.010-0.101-0.025-0.153-0.039s-0.107-0.030-0.163-0.045c-0.028-0.008-0.056-0.015-0.084-0.024s-0.057-0.019-0.086-0.028-0.116-0.039-0.176-0.058c-0.015-0.005-0.030-0.010-0.045-0.015s-0.030-0.012-0.045-0.017-0.060-0.023-0.091-0.035-0.123-0.048-0.186-0.073c-0.062-0.028-0.125-0.056-0.189-0.084-0.032-0.014-0.064-0.028-0.096-0.043s-0.064-0.032-0.096-0.048-0.128-0.065-0.194-0.098c-0.065-0.034-0.129-0.073-0.194-0.109-0.032-0.018-0.065-0.037-0.098-0.056s-0.064-0.040-0.096-0.061c-0.064-0.041-0.129-0.082-0.194-0.124-0.255-0.175-0.506-0.369-0.744-0.583-0.236-0.217-0.459-0.451-0.665-0.697-0.202-0.25-0.385-0.511-0.547-0.776-0.159-0.268-0.294-0.541-0.41-0.808-0.027-0.068-0.053-0.135-0.079-0.202-0.013-0.033-0.027-0.066-0.038-0.099s-0.022-0.067-0.033-0.1-0.045-0.131-0.065-0.196c-0.018-0.065-0.036-0.13-0.054-0.194-0.009-0.032-0.019-0.063-0.026-0.095s-0.014-0.063-0.021-0.094-0.028-0.123-0.042-0.184c-0.011-0.061-0.021-0.12-0.032-0.179-0.005-0.029-0.010-0.058-0.015-0.087-0.003-0.014-0.005-0.028-0.008-0.043s-0.003-0.029-0.005-0.043c-0.007-0.056-0.014-0.112-0.020-0.166-0.003-0.027-0.007-0.053-0.010-0.080s-0.004-0.053-0.006-0.078-0.007-0.101-0.011-0.15c-0.003-0.049-0.008-0.095-0.008-0.142-0.002-0.091-0.004-0.177-0.006-0.256 0.003-0.073 0.005-0.14 0.007-0.2 0.001-0.030 0.002-0.058 0.002-0.085 0.002-0.033 0.004-0.064 0.006-0.093 0.002-0.033 0.004-0.063 0.006-0.091 0.008-0.051 0.012-0.103 0.012-0.156 0-0.007-0-0.015-0.001-0.022 0-0.002 0-0.003 0-0.003h-0c-0.012-0.49-0.377-0.893-0.851-0.964z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$29ed61ee005ced5b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6h-6l2.243-2.243c-1.133-1.133-2.64-1.757-4.243-1.757s-3.109 0.624-4.243 1.757c-1.133 1.133-1.757 2.64-1.757 4.243s0.624 3.109 1.757 4.243c1.133 1.133 2.64 1.757 4.243 1.757s3.109-0.624 4.243-1.757c0.095-0.095 0.185-0.192 0.273-0.292l1.505 1.317c-1.466 1.674-3.62 2.732-6.020 2.732-4.418 0-8-3.582-8-8s3.582-8 8-8c2.209 0 4.209 0.896 5.656 2.344l2.343-2.344v6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e6a3d260b105b417(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 0h6v1h-6zM9 0h6v1h-6zM14.875 5h-0.875v-4h-4v4h-4v-4h-4v4h-0.875c-0.619 0-1.125 0.506-1.125 1.125v8.75c0 0.619 0.506 1.125 1.125 1.125h4.75c0.619 0 1.125-0.506 1.125-1.125v-5.875h2v5.875c0 0.619 0.506 1.125 1.125 1.125h4.75c0.619 0 1.125-0.506 1.125-1.125v-8.75c0-0.619-0.506-1.125-1.125-1.125zM5.438 15h-3.875c-0.309 0-0.563-0.225-0.563-0.5s0.253-0.5 0.563-0.5h3.875c0.309 0 0.563 0.225 0.563 0.5s-0.253 0.5-0.563 0.5zM8.5 8h-1c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h1c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5zM14.438 15h-3.875c-0.309 0-0.563-0.225-0.563-0.5s0.253-0.5 0.563-0.5h3.875c0.309 0 0.563 0.225 0.563 0.5s-0.253 0.5-0.563 0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$590b2c9f278074f4(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3e9f47508ccb71e7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM7 3h-2v2h-2v2h2v2h2v-2h2v-2h-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6066a837777ecfca(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM3 5h6v2h-6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$98180b2c84ce612c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 0h-6.5l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16v-6.5l-2.5 2.5-3-3-1.5 1.5 3 3-2.5 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 16h6.5l-2.5-2.5 3-3-1.5-1.5-3 3-2.5-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v6.5l2.5-2.5 3 3 1.5-1.5-3-3 2.5-2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$10cf4db96b69f275(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7h6.5l-2.5-2.5 3-3-1.5-1.5-3 3-2.5-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9v6.5l2.5-2.5 3 3 1.5-1.5-3-3 2.5-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h-6.5l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7v-6.5l-2.5 2.5-3-3-1.5 1.5 3 3-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$27d05c015ce30c66(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 0v6.5l-2.5-2.5-3 3-1.5-1.5 3-3-2.5-2.5zM7 10.5l-3 3 2.5 2.5h-6.5v-6.5l2.5 2.5 3-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$894ef6f9f4561237(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9v6.5l-2.5-2.5-3 3-1.5-1.5 3-3-2.5-2.5zM16 1.5l-3 3 2.5 2.5h-6.5v-6.5l2.5 2.5 3-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$247452bc3b796748(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 0c-2.761 0-5 2.239-5 5 0 0.313 0.029 0.619 0.084 0.916l-6.084 6.084v3c0 0.552 0.448 1 1 1h1v-1h2v-2h2v-2h2l1.298-1.298c0.531 0.192 1.105 0.298 1.702 0.298 2.761 0 5-2.239 5-5s-2.239-5-5-5zM12.498 5.002c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7e01efbde044aa56(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.658 4.91l-1.58-1.58c-0.387-0.387-1.021-1.021-1.409-1.409l-1.58-1.58c-0.387-0.387-1.077-0.456-1.533-0.152l-4.319 2.88c-0.456 0.304-0.628 0.954-0.383 1.444l1.101 2.203c0.034 0.067 0.073 0.139 0.115 0.213l-5.571 5.571-0.5 3.5h3v-1h2v-2h2v-2h2v-1.112c0.1 0.060 0.196 0.113 0.284 0.157l2.203 1.101c0.49 0.245 1.14 0.072 1.444-0.383l2.88-4.319c0.304-0.456 0.236-1.146-0.152-1.533zM2.354 13.354l-0.707-0.707 4.868-4.868 0.707 0.707-4.868 4.868zM14.328 6.621l-0.707 0.707c-0.194 0.194-0.513 0.194-0.707 0l-4.243-4.243c-0.194-0.194-0.194-0.513 0-0.707l0.707-0.707c0.194-0.194 0.513-0.194 0.707 0l4.243 4.243c0.194 0.194 0.194 0.513 0 0.707z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d11014839463ab93(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.25 7h-0.25v-3c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v7.5c0 0.412 0.338 0.75 0.75 0.75h8.5c0.412 0 0.75-0.338 0.75-0.75v-7.5c0-0.412-0.338-0.75-0.75-0.75zM3 4c0-0.551 0.449-1 1-1h2c0.551 0 1 0.449 1 1v3h-4v-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d31f392018544492(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1c1.654 0 3 1.346 3 3v3h-2v-3c0-0.551-0.449-1-1-1h-2c-0.551 0-1 0.449-1 1v3h0.25c0.412 0 0.75 0.338 0.75 0.75v7.5c0 0.412-0.338 0.75-0.75 0.75h-8.5c-0.412 0-0.75-0.338-0.75-0.75v-7.5c0-0.412 0.338-0.75 0.75-0.75h6.25v-3c0-1.654 1.346-3 3-3h2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$33d29fe3b8de873a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.671 12.779l-7.196-6.168c0.335-0.63 0.525-1.348 0.525-2.111 0-2.485-2.015-4.5-4.5-4.5-0.455 0-0.893 0.068-1.307 0.193l2.6 2.6c0.389 0.389 0.389 1.025 0 1.414l-1.586 1.586c-0.389 0.389-1.025 0.389-1.414 0l-2.6-2.6c-0.125 0.414-0.193 0.852-0.193 1.307 0 2.485 2.015 4.5 4.5 4.5 0.763 0 1.482-0.19 2.111-0.525l6.168 7.196c0.358 0.418 0.969 0.441 1.358 0.052l1.586-1.586c0.389-0.389 0.365-1-0.052-1.358z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$579bf8b0f2646c0b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2v-0.25c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.413 0-0.75 0.337-0.75 0.75v0.25h-3v2h3v0.25c0 0.412 0.337 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h9v-2h-9zM4 4v-2h2v2h-2zM13 6.75c0-0.412-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.338-0.75 0.75v0.25h-9v2h9v0.25c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h3v-2h-3v-0.25zM10 9v-2h2v2h-2zM7 11.75c0-0.412-0.338-0.75-0.75-0.75h-2.5c-0.413 0-0.75 0.338-0.75 0.75v0.25h-3v2h3v0.25c0 0.412 0.337 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h9v-2h-9v-0.25zM4 14v-2h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a76d769df022e38e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v9h2v-9zM12 4h2v2h-2v-2zM9.25 13c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-9h-2v9h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v3h2v-3h0.25zM7 10h2v2h-2v-2zM4.25 7c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.413 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.337 0.75 0.75 0.75h0.25v9h2v-9h0.25zM2 4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6eefcc51c81233eb(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 9.535c-0.839-1.454-0.335-3.317 1.127-4.164l-1.572-2.723c-0.449 0.263-0.972 0.414-1.529 0.414-1.68 0-3.042-1.371-3.042-3.062h-3.145c0.004 0.522-0.126 1.051-0.406 1.535-0.839 1.454-2.706 1.948-4.17 1.106l-1.572 2.723c0.453 0.257 0.845 0.634 1.123 1.117 0.838 1.452 0.336 3.311-1.12 4.16l1.572 2.723c0.448-0.261 0.967-0.41 1.522-0.41 1.675 0 3.033 1.362 3.042 3.046h3.145c-0.001-0.517 0.129-1.040 0.406-1.519 0.838-1.452 2.7-1.947 4.163-1.11l1.572-2.723c-0.45-0.257-0.839-0.633-1.116-1.113zM8 11.24c-1.789 0-3.24-1.45-3.24-3.24s1.45-3.24 3.24-3.24c1.789 0 3.24 1.45 3.24 3.24s-1.45 3.24-3.24 3.24z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$dfaa3466723a7c01(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.683 11.282l0.645-0.903-0.707-0.707-0.903 0.645c-0.168-0.094-0.347-0.168-0.535-0.222l-0.183-1.095h-1l-0.183 1.095c-0.188 0.053-0.368 0.128-0.535 0.222l-0.903-0.645-0.707 0.707 0.645 0.903c-0.094 0.168-0.168 0.347-0.222 0.535l-1.095 0.183v1l1.095 0.183c0.053 0.188 0.128 0.368 0.222 0.535l-0.645 0.903 0.707 0.707 0.903-0.645c0.168 0.094 0.347 0.168 0.535 0.222l0.183 1.095h1l0.183-1.095c0.188-0.053 0.368-0.128 0.535-0.222l0.903 0.645 0.707-0.707-0.645-0.903c0.094-0.168 0.168-0.347 0.222-0.535l1.095-0.182v-1l-1.095-0.183c-0.053-0.188-0.128-0.368-0.222-0.535zM3.5 13.5c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM16 6v-1l-1.053-0.191c-0.019-0.126-0.044-0.25-0.074-0.372l0.899-0.58-0.383-0.924-1.046 0.226c-0.066-0.108-0.136-0.213-0.211-0.315l0.609-0.88-0.707-0.707-0.88 0.609c-0.102-0.074-0.207-0.145-0.315-0.211l0.226-1.046-0.924-0.383-0.58 0.899c-0.122-0.030-0.246-0.054-0.372-0.074l-0.191-1.053h-1l-0.191 1.053c-0.126 0.019-0.25 0.044-0.372 0.074l-0.58-0.899-0.924 0.383 0.226 1.046c-0.108 0.066-0.213 0.136-0.315 0.211l-0.88-0.609-0.707 0.707 0.609 0.88c-0.074 0.102-0.145 0.207-0.211 0.315l-1.046-0.226-0.383 0.924 0.899 0.58c-0.030 0.122-0.054 0.246-0.074 0.372l-1.053 0.191v1l1.053 0.191c0.019 0.126 0.044 0.25 0.074 0.372l-0.899 0.58 0.383 0.924 1.046-0.226c0.066 0.108 0.136 0.213 0.211 0.315l-0.609 0.88 0.707 0.707 0.88-0.609c0.102 0.074 0.207 0.145 0.315 0.211l-0.226 1.046 0.924 0.383 0.58-0.899c0.122 0.030 0.246 0.054 0.372 0.074l0.191 1.053h1l0.191-1.053c0.126-0.019 0.25-0.044 0.372-0.074l0.58 0.899 0.924-0.383-0.226-1.046c0.108-0.066 0.213-0.136 0.315-0.211l0.88 0.609 0.707-0.707-0.609-0.88c0.074-0.102 0.145-0.207 0.211-0.315l1.046 0.226 0.383-0.924-0.899-0.58c0.030-0.122 0.054-0.246 0.074-0.372l1.053-0.191zM10.5 7.675c-1.201 0-2.175-0.974-2.175-2.175s0.974-2.175 2.175-2.175 2.175 0.974 2.175 2.175c0 1.201-0.974 2.175-2.175 2.175z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b779529184b71fd6(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.781 12.953l-4.712-4.712c-0.292-0.292-0.769-0.292-1.061 0l-0.354 0.354-2.875-2.875 4.72-4.72h-5l-2.22 2.22-0.22-0.22h-1.061v1.061l0.22 0.22-3.22 3.22 2.5 2.5 3.22-3.22 2.875 2.875-0.354 0.354c-0.292 0.292-0.292 0.769 0 1.061l4.712 4.712c0.292 0.292 0.769 0.292 1.061 0l1.768-1.768c0.292-0.292 0.292-0.769 0-1.061z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$de3d94f71bb56b61(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3l-2-2h-1v1l2 2zM5 0h1v2h-1zM9 5h2v1h-2zM10 2v-1h-1l-2 2 1 1zM0 5h2v1h-2zM5 9h1v2h-1zM1 9v1h1l2-2-1-1zM15.781 13.781l-9.939-9.939c-0.292-0.292-0.769-0.292-1.061 0l-0.939 0.939c-0.292 0.292-0.292 0.769 0 1.061l9.939 9.939c0.292 0.292 0.769 0.292 1.061 0l0.939-0.939c0.292-0.292 0.292-0.769 0-1.061zM7.5 8.5l-3-3 1-1 3 3-1 1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6fb6bf341b09a979(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4h-3v-2c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v2h-3c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-8c0-1.1-0.9-2-2-2zM6 2h4v2h-4v-2zM12 11h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6497dc99cd682520(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9v-1h-3.020c-0.092-1.136-0.497-2.172-1.12-3.004h2.53l1.095-4.379-0.97-0.243-0.905 3.621h-2.729c-0.014-0.011-0.028-0.021-0.042-0.032 0.105-0.305 0.162-0.632 0.162-0.972 0-1.653-1.343-2.992-3-2.992s-3 1.34-3 2.992c0 0.34 0.057 0.667 0.162 0.972-0.014 0.011-0.028 0.021-0.042 0.032h-2.729l-0.905-3.621-0.97 0.243 1.095 4.379h2.53c-0.623 0.832-1.028 1.868-1.12 3.004h-3.020v1h3.021c0.059 0.713 0.242 1.388 0.526 1.996h-1.937l-1.095 4.379 0.97 0.243 0.905-3.621h1.756c0.917 1.219 2.303 1.996 3.854 1.996s2.937-0.777 3.854-1.996h1.756l0.905 3.621 0.97-0.243-1.095-4.379h-1.937c0.283-0.608 0.466-1.283 0.526-1.996h3.021z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7018b33e68ace84b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9v-7c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7c0-1.126-0.266-2.189-0.738-3.131l-6.262 3.131zM14.262 3.869c-1.149-2.294-3.521-3.869-6.262-3.869v7l6.262-3.131z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7335f52e4ed08602(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h14v2h-16v-16h2zM4.5 13c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.044 0 0.088 0.002 0.131 0.006l1.612-2.687c-0.154-0.235-0.243-0.517-0.243-0.819 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.302-0.090 0.583-0.243 0.819l1.612 2.687c0.043-0.004 0.087-0.006 0.131-0.006 0.033 0 0.066 0.001 0.099 0.004l2.662-4.658c-0.165-0.241-0.261-0.532-0.261-0.845 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5-0.033 0-0.066-0.001-0.099-0.004l-2.662 4.658c0.165 0.241 0.261 0.532 0.261 0.845 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.302 0.090-0.583 0.243-0.819l-1.612-2.687c-0.043 0.004-0.087 0.006-0.131 0.006s-0.088-0.002-0.131-0.006l-1.612 2.687c0.154 0.235 0.243 0.517 0.243 0.819 0 0.828-0.672 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ba0ccc0ef887706e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 13h16v2h-16zM2 9h2v3h-2zM5 5h2v7h-2zM8 8h2v4h-2zM11 2h2v10h-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4868cef997828f54(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 6h-3c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM4.5 15h-3v-4h3v4zM9.5 4h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM9.5 15h-3v-5h3v5zM14.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5zM14.5 15h-3v-6h3v6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7c835c8301ac084e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3v-2h-10v2h-3v2c0 1.657 1.343 3 3 3 0.314 0 0.616-0.048 0.9-0.138 0.721 1.031 1.822 1.778 3.1 2.037v3.1h-1c-1.105 0-2 0.895-2 2h8c0-1.105-0.895-2-2-2h-1v-3.1c1.278-0.259 2.378-1.006 3.1-2.037 0.284 0.089 0.587 0.138 0.9 0.138 1.657 0 3-1.343 3-3v-2h-3zM3 6.813c-0.999 0-1.813-0.813-1.813-1.813v-1h1.813v1c0 0.628 0.116 1.229 0.327 1.782-0.106 0.019-0.216 0.030-0.327 0.030zM14.813 5c0 0.999-0.813 1.813-1.813 1.813-0.112 0-0.221-0.011-0.327-0.030 0.211-0.554 0.327-1.154 0.327-1.782v-1h1.813v1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$47f006321ac08d00(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.055 5c0.283-0.201 0.555-0.425 0.804-0.674 0.522-0.522 0.871-1.164 0.983-1.808 0.123-0.706-0.057-1.362-0.494-1.798-0.348-0.348-0.82-0.533-1.365-0.533-0.775 0-1.593 0.372-2.242 1.021-1.039 1.039-1.644 2.472-1.97 3.496-0.241-1.028-0.722-2.416-1.657-3.351-0.501-0.501-1.142-0.759-1.748-0.759-0.495 0-0.965 0.172-1.317 0.523-0.781 0.781-0.675 2.153 0.236 3.064 0.325 0.325 0.705 0.595 1.105 0.819h-3.391v4h1v7h12v-7h1v-4h-2.945zM10.536 2.003c0.433-0.433 0.974-0.692 1.446-0.692 0.167 0 0.402 0.035 0.57 0.203 0.407 0.407 0.178 1.349-0.489 2.016-0.687 0.687-1.61 1.159-2.413 1.47h-0.792c0.29-0.899 0.813-2.132 1.678-2.997zM3.655 2.514c-0.011-0.143-0.001-0.41 0.191-0.601 0.16-0.16 0.372-0.194 0.521-0.194v0c0.332 0 0.679 0.157 0.952 0.429 0.529 0.529 0.965 1.371 1.26 2.436 0.008 0.029 0.016 0.057 0.023 0.086-0.028-0.008-0.057-0.015-0.086-0.023-1.064-0.295-1.906-0.731-2.436-1.26-0.247-0.247-0.403-0.565-0.426-0.872zM7 15h-4v-6.5h4v6.5zM7 8h-5v-2h5v2zM13 15h-4v-6.5h4v6.5zM14 8h-5v-2h5v2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$52ffc4ba4f0559a2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.153 0.263c-0.087-0.162-0.256-0.263-0.44-0.263h-7.425c-0.184 0-0.353 0.101-0.44 0.263-0.554 1.032-0.847 2.237-0.847 3.487 0 1.647 0.506 3.2 1.424 4.374 0.71 0.907 1.601 1.508 2.576 1.753v5.123h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.123c0.975-0.244 1.866-0.846 2.576-1.753 0.918-1.174 1.424-2.727 1.424-4.374 0-1.249-0.293-2.455-0.847-3.487zM4.595 1h6.809c0.39 0.827 0.595 1.771 0.595 2.75 0 0.084-0.002 0.167-0.005 0.25h-7.991c-0.003-0.083-0.005-0.166-0.005-0.25-0-0.979 0.205-1.923 0.595-2.75z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b9d74fc025f38c5b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.893 2.809c0.118-0.151 0.14-0.355 0.057-0.527s-0.258-0.281-0.45-0.281h-11c-0.191 0-0.366 0.109-0.45 0.281s-0.062 0.377 0.057 0.527l4.893 6.228v5.963h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.963l4.893-6.228zM12.471 3l-1.571 2h-5.8l-1.571-2h8.943z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7ca04dd6af6e8225(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5h-3v-1.5c0-1.381-2.686-2.5-6-2.5s-6 1.119-6 2.5v10c0 1.381 2.686 2.5 6 2.5s6-1.119 6-2.5v-1.5h3c0.552 0 1-0.448 1-1v-5c0-0.552-0.448-1-1-1zM2.751 4.037c-0.578-0.19-0.928-0.394-1.116-0.537 0.188-0.143 0.538-0.347 1.116-0.537 0.905-0.298 2.059-0.463 3.249-0.463s2.344 0.164 3.249 0.463c0.578 0.19 0.928 0.394 1.116 0.537-0.188 0.143-0.538 0.347-1.116 0.537-0.905 0.298-2.059 0.463-3.249 0.463s-2.344-0.164-3.249-0.463zM14 10h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7cd566df0658fdf3(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0c-1.657 0-3 1.567-3 3.5 0 1.655 0.985 3.042 2.308 3.406l-0.497 8.096c-0.034 0.549 0.389 0.998 0.939 0.998h0.5c0.55 0 0.972-0.449 0.939-0.998l-0.497-8.096c1.323-0.365 2.308-1.751 2.308-3.406 0-1.933-1.343-3.5-3-3.5zM13.583 0l-0.833 5h-0.625l-0.417-5h-0.417l-0.417 5h-0.625l-0.833-5h-0.417v6.5c0 0.276 0.224 0.5 0.5 0.5h1.302l-0.491 8.002c-0.034 0.549 0.389 0.998 0.939 0.998h0.5c0.55 0 0.972-0.449 0.939-0.998l-0.491-8.002h1.302c0.276 0 0.5-0.224 0.5-0.5v-6.5h-0.417z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3c8df52da4451f5c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.802 2.102c-1.73-1.311-4.393-2.094-7.124-2.094-3.377 0-6.129 1.179-7.549 3.235-0.667 0.965-1.036 2.109-1.097 3.398-0.054 1.148 0.139 2.418 0.573 3.784 1.482-4.444 5.622-7.923 10.395-7.923 0 0-4.466 1.175-7.274 4.816-0.002 0.002-0.039 0.048-0.103 0.136-0.564 0.754-1.055 1.612-1.423 2.583-0.623 1.482-1.2 3.515-1.2 5.965h2c0 0-0.304-1.91 0.224-4.106 0.873 0.118 1.654 0.177 2.357 0.177 1.839 0 3.146-0.398 4.115-1.252 0.868-0.765 1.347-1.794 1.854-2.882 0.774-1.663 1.651-3.547 4.198-5.002 0.146-0.083 0.24-0.234 0.251-0.402s-0.063-0.329-0.197-0.431z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c694e80cf2c1c733(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1l-5 5h-3l-3 4c0 0 3.178-0.885 5.032-0.47l-5.032 6.47 6.592-5.127c0.919 2.104-0.592 5.127-0.592 5.127l4-3v-3l5-5 1-5-5 1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$cf993f1af1188f3d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c4.418 0 8 3.582 8 8 0 3.012-1.665 5.635-4.125 7h-7.75c-2.46-1.365-4.125-3.988-4.125-7 0-4.418 3.582-8 8-8zM12.53 13.53c1.21-1.21 1.876-2.819 1.876-4.53h-1.406v-1h1.329c-0.11-0.703-0.334-1.377-0.665-2h-1.664v-1h1.004c-0.147-0.184-0.306-0.361-0.475-0.53-0.722-0.722-1.587-1.251-2.53-1.559v1.089h-1v-1.329c-0.328-0.051-0.662-0.078-1-0.078s-0.672 0.026-1 0.078v1.329h-1v-1.089c-0.943 0.309-1.808 0.837-2.53 1.559-0.169 0.169-0.327 0.346-0.475 0.53h1.004v1h-1.664c-0.331 0.623-0.555 1.297-0.665 2h1.329v1h-1.406c0 1.711 0.666 3.32 1.876 4.53 0.167 0.167 0.343 0.324 0.524 0.47h3.006l0.571-8h0.857l0.571 8h3.006c0.182-0.146 0.357-0.303 0.524-0.47z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$81e92daf05ffdfe4(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4.732 13.034c0.174-0.479 0.268-0.995 0.268-1.534 0-1.943-1.231-3.598-2.956-4.228 0.16-1.327 0.754-2.555 1.714-3.514 1.133-1.133 2.64-1.757 4.243-1.757s3.109 0.624 4.243 1.757c0.96 0.96 1.554 2.188 1.714 3.514-1.725 0.63-2.956 2.285-2.956 4.228 0 0.539 0.095 1.055 0.268 1.534-0.964 0.629-2.090 0.966-3.268 0.966s-2.304-0.338-3.268-0.966zM8.621 10.016c0.217 0.055 0.379 0.251 0.379 0.484v1c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1c0-0.233 0.162-0.43 0.379-0.484l0.371-7.016h0.5l0.371 7.016z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4cf41ac10473219b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.784 14.309l-8.572-7.804 0.399-0.4c0.326-0.327 0.503-0.75 0.53-1.181 0.016-0.007 0.031-0.014 0.046-0.023l1.609-1.006c0.218-0.256 0.202-0.66-0.036-0.898l-2.799-2.806c-0.237-0.238-0.641-0.254-0.896-0.036l-1.004 1.614c-0.008 0.015-0.015 0.031-0.022 0.046-0.43 0.027-0.852 0.204-1.178 0.531l-1.522 1.527c-0.327 0.327-0.503 0.75-0.53 1.181-0.016 0.007-0.031 0.014-0.046 0.023l-1.609 1.006c-0.218 0.256-0.202 0.66 0.036 0.898l2.799 2.806c0.237 0.238 0.641 0.254 0.896 0.036l1.004-1.614c0.008-0.015 0.015-0.031 0.023-0.046 0.43-0.027 0.852-0.204 1.178-0.531l0.442-0.443 7.783 8.596c0.226 0.249 0.573 0.289 0.773 0.089l0.787-0.789c0.199-0.2 0.159-0.549-0.089-0.775z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d4cc777c1611c2c4(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.016 16c-1.066-2.219-0.498-3.49 0.321-4.688 0.897-1.312 1.129-2.61 1.129-2.61s0.706 0.917 0.423 2.352c1.246-1.387 1.482-3.598 1.293-4.445 2.817 1.969 4.021 6.232 2.399 9.392 8.631-4.883 2.147-12.19 1.018-13.013 0.376 0.823 0.448 2.216-0.313 2.893-1.287-4.879-4.468-5.879-4.468-5.879 0.376 2.516-1.364 5.268-3.042 7.324-0.059-1.003-0.122-1.696-0.649-2.656-0.118 1.823-1.511 3.309-1.889 5.135-0.511 2.473 0.383 4.284 3.777 6.197z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$132af0adf60adf7c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.942 12.57l-4.942-8.235v-3.335h0.5c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5h0.5v3.335l-4.942 8.235c-1.132 1.886-0.258 3.43 1.942 3.43h10c2.2 0 3.074-1.543 1.942-3.43zM3.766 10l3.234-5.39v-3.61h2v3.61l3.234 5.39h-8.468z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8d4fc206362d93f0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-4l1 9c0 1.657-1.343 3-3 3s-3-1.343-3-3l1-9h-4l-1 9c0 3.866 3.134 7 7 7s7-3.134 7-7l-1-9zM12.154 13.154c-1.11 1.11-2.585 1.721-4.154 1.721s-3.045-0.611-4.154-1.721c-1.096-1.096-1.705-2.548-1.72-4.095l0.564-5.075h1.736l-0.55 4.953v0.062c0 1.102 0.429 2.138 1.208 2.917s1.815 1.208 2.917 1.208 2.138-0.429 2.917-1.208c0.779-0.779 1.208-1.815 1.208-2.917v-0.062l-0.007-0.062-0.543-4.891h1.736l0.564 5.075c-0.015 1.547-0.625 2.999-1.72 4.095z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8861d3fa0ac410d3(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5v10c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-10h-11zM5 14h-1v-7h1v7zM7 14h-1v-7h1v7zM9 14h-1v-7h1v7zM11 14h-1v-7h1v7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.25 2h-3.25v-1.25c0-0.412-0.338-0.75-0.75-0.75h-3.5c-0.412 0-0.75 0.338-0.75 0.75v1.25h-3.25c-0.413 0-0.75 0.337-0.75 0.75v1.25h13v-1.25c0-0.413-0.338-0.75-0.75-0.75zM9 2h-3v-0.987h3v0.987z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1419e1b98fd50d15(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h10l1-11h-12zM10 2v-2h-4v2h-5v3l1-1h12l1 1v-3h-5zM9 2h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7594f92b54128d24(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4h-4v-1c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v1h-4c-0.55 0-1 0.45-1 1v9c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM6 3.002c0.001-0.001 0.001-0.001 0.002-0.002h3.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-4v-0.998zM15 8h-2v1.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h-6v1.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h-2v-1h14v1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$24e2e243ce98edcd(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9.999l-2.857-2.857 6.857-5.143-2-2-8.571 3.429-2.698-2.699c-0.778-0.778-1.864-0.964-2.414-0.414s-0.364 1.636 0.414 2.414l2.698 2.698-3.429 8.572 2 2 5.144-6.857 2.857 2.857v4h2l1-3 3-1v-2l-4 0z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a9ec656065be05ec(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9l-2-4h-3v-2c0-0.55-0.45-1-1-1h-9c-0.55 0-1 0.45-1 1v8l1 1h1.268c-0.17 0.294-0.268 0.636-0.268 1 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.364-0.098-0.706-0.268-1h5.536c-0.17 0.294-0.268 0.636-0.268 1 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.364-0.098-0.706-0.268-1h1.268v-3zM11 9v-3h2.073l1.5 3h-3.573z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4ab1faf64d35ebae(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h5l-4-16h-3l0.5 4h-3l0.5-4h-3l-4 16h5l0.5-4h5l0.5 4zM5.75 10l0.5-4h3.5l0.5 4h-4.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$928d1d5cbeb647a3(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5l5.15-2.221-0.371-0.929-6.279 2.15h-1l-6.279-2.15-0.371 0.929 5.15 2.221v4l-2.051 6.634 0.935 0.355 2.902-6.489h0.429l2.902 6.489 0.935-0.355-2.051-6.634z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1341e223cb134d36(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h-1.577c-0.432-2.785-2.638-4.991-5.423-5.423v-1.577h-2v1.577c-2.785 0.432-4.991 2.638-5.423 5.423h-1.577v2h1.577c0.432 2.785 2.638 4.991 5.423 5.423v1.577h2v-1.577c2.785-0.432 4.991-2.638 5.423-5.423h1.577v-2zM12.388 7h-1.559c-0.301-0.852-0.977-1.528-1.829-1.829v-1.559c1.68 0.383 3.005 1.708 3.388 3.388zM8 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM7 3.612v1.559c-0.852 0.301-1.528 0.977-1.829 1.829h-1.559c0.383-1.68 1.708-3.005 3.388-3.388zM3.612 9h1.559c0.301 0.852 0.977 1.528 1.829 1.829v1.559c-1.68-0.383-3.005-1.708-3.388-3.388zM9 12.388v-1.559c0.852-0.301 1.528-0.977 1.829-1.829h1.559c-0.383 1.68-1.708 3.005-3.388 3.388z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$70b7d3dfbbd47bca(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0l-7 2-7-2c0 0-0.070 0.808 0 2l7 2.189 7-2.189c0.070-1.192 0-2 0-2zM1.128 3.049c0.375 3.917 1.773 10.504 6.872 12.951 5.099-2.448 6.497-9.034 6.872-12.951l-6.872 2.584-6.872-2.584z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$28b7f5c4c500a356(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0l-6 8h6l-4 8 14-10h-8l6-6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$63dc7a17dbec9e1c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2.29v2.124c0.566 0.247 1.086 0.6 1.536 1.050 0.944 0.944 1.464 2.2 1.464 3.536s-0.52 2.591-1.464 3.536c-0.944 0.944-2.2 1.464-3.536 1.464s-2.591-0.52-3.536-1.464c-0.944-0.944-1.464-2.2-1.464-3.536s0.52-2.591 1.464-3.536c0.45-0.45 0.97-0.803 1.536-1.050v-2.124c-2.891 0.861-5 3.539-5 6.71 0 3.866 3.134 7 7 7s7-3.134 7-7c0-3.171-2.109-5.849-5-6.71zM7 0h2v8h-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ad38c60d0794e01(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4.414l-1.414-1.414-2.793 2.793-1.586-1.586 2.793-2.793-1.414-1.414-2.793 2.793-1.793-1.793-1.354 1.353 8 8 1.354-1.353-1.793-1.793 2.793-2.793z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.407 10.528l-6.935-6.935c-1.497 1.795-3.196 4.57-2.022 6.957l-2.066 2.066c-0.486 0.486-0.486 1.282 0 1.768l0.232 0.232c0.486 0.486 1.282 0.486 1.768 0l2.066-2.066c2.387 1.174 5.161-0.524 6.957-2.022z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$27b7a29a33eaa647(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2h-4.5c0-1.105-0.895-2-2-2s-2 0.895-2 2h-4.5c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-13c0-0.276-0.224-0.5-0.5-0.5zM8 1c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1zM14 15h-12v-12h2v1.5c0 0.276 0.224 0.5 0.5 0.5h7c0.276 0 0.5-0.224 0.5-0.5v-1.5h2v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13.414l-3.207-3.707 0.914-0.914 2.293 1.793 4.293-3.793 0.914 0.914z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d18baaac02932d0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13h10v2h-10zM6 7h10v2h-10zM6 1h10v2h-10zM3 0v4h-1v-3h-1v-1zM2 8.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM4 11v5h-3v-1h2v-1h-2v-1h2v-1h-2v-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c9470a0246dc1608(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0h4v4h-4zM6 1h10v2h-10zM0 6h4v4h-4zM6 7h10v2h-10zM0 12h4v4h-4zM6 13h10v2h-10z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b6ffcefc8af418aa(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 1h10v2h-10v-2zM6 7h10v2h-10v-2zM6 13h10v2h-10v-2zM0 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 14c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$139fb7e1e42761b9(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.25 12h-0.25v-3.25c0-0.965-0.785-1.75-1.75-1.75h-4.25v-2h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v2h-4.25c-0.965 0-1.75 0.785-1.75 1.75v3.25h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.413 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.337-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75zM3 15h-2v-2h2v2zM9 15h-2v-2h2v2zM7 4v-2h2v2h-2zM15 15h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2140b178b55a332f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3h14v3h-14zM1 7h14v3h-14zM1 11h14v3h-14z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9d49f0175ae4a69e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 22 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 9l3 3 3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5 8l-3-3-3 3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e84aa6ae91ac78b0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 22 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 7l3 3 3-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$691072f12974da4b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 22 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 10l3-3 3 3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$30b970b0a03a0127(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10.274c0-1.283-0.886-2.358-2.078-2.648-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029s1.355 3.029 3.027 3.029l10.254-0c1.502-0.003 2.719-1.222 2.719-2.726z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$efc9141af83f2166(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.922 5.626c-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029s1.355 3.029 3.027 3.029h1.434l3.539 3.664 3.539-3.664 1.742-0c1.502-0.003 2.719-1.222 2.719-2.726 0-1.283-0.886-2.358-2.078-2.648zM8 13l-3-3h2v-3h2v3h2l-3 3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3fd45074d86da8e5(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.942 6.039c0.038-0.174 0.058-0.354 0.058-0.539 0-1.381-1.119-2.5-2.5-2.5-0.222 0-0.438 0.029-0.643 0.084-0.387-1.209-1.52-2.084-2.857-2.084-1.365 0-2.516 0.911-2.88 2.159-0.355-0.103-0.731-0.159-1.12-0.159-2.209 0-4 1.791-4 4s1.791 4 4 4h2v3h4v-3h3.5c1.381 0 2.5-1.119 2.5-2.5 0-1.23-0.888-2.253-2.058-2.461zM9 10v3h-2v-3h-2.5l3.5-3.5 3.5 3.5h-2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d50e7ceccb5dea8d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.942 8.039c0.038-0.174 0.058-0.354 0.058-0.539 0-1.381-1.119-2.5-2.5-2.5-0.222 0-0.438 0.029-0.643 0.084-0.387-1.209-1.52-2.084-2.857-2.084-1.365 0-2.516 0.911-2.88 2.159-0.355-0.103-0.731-0.159-1.12-0.159-2.209 0-4 1.791-4 4s1.791 4 4 4h9.5c1.381 0 2.5-1.119 2.5-2.5 0-1.23-0.888-2.252-2.058-2.461zM6.5 12l-2.5-2.5 1-1 1.5 1.5 3.5-3.5 1 1-4.5 4.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a0de3e4e7fc9460(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h-2.5l-3.5 3.5-3.5-3.5h-2.5l-2 4v1h16v-1l-2-4zM0 14h16v1h-16v-1zM9 5v-4h-2v4h-3.5l4.5 4.5 4.5-4.5h-3.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7d9bf6e55e8f2f63(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 14h16v1h-16zM16 12v1h-16v-1l2-4h4v2h4v-2h4zM3.5 5l4.5-4.5 4.5 4.5h-3.5v4h-2v-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$fdefc24aa638deb6(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7l-4 4-4-4h2.5v-6h3v6zM7.5 11h-7.5v4h15v-4h-7.5zM14 13h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e5b136d4035c3d89(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 11h-7.5v4h15v-4h-7.5zM14 13h-2v-1h2v1zM3.5 5l4-4 4 4h-2.5v5h-3v-5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$857adcb8074f1f7c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM11.744 11c0.134-0.632 0.219-1.303 0.246-2h1.991c-0.052 0.691-0.213 1.361-0.479 2h-1.758zM3.256 6c-0.134 0.632-0.219 1.303-0.246 2h-1.991c0.052-0.691 0.213-1.361 0.479-2h1.758zM10.719 6c0.15 0.64 0.241 1.31 0.27 2h-2.989v-2h2.719zM8 5v-2.927c0.228 0.066 0.454 0.178 0.675 0.334 0.415 0.293 0.813 0.744 1.149 1.304 0.233 0.388 0.434 0.819 0.601 1.289h-2.426zM5.176 3.711c0.336-0.561 0.734-1.012 1.149-1.304 0.222-0.156 0.447-0.268 0.675-0.334v2.927h-2.426c0.168-0.47 0.369-0.901 0.601-1.289zM7 6v2h-2.989c0.029-0.69 0.12-1.36 0.27-2h2.719zM1.498 11c-0.266-0.639-0.427-1.309-0.479-2h1.991c0.028 0.697 0.112 1.368 0.246 2h-1.758zM4.011 9h2.989v2h-2.719c-0.15-0.64-0.241-1.31-0.27-2zM7 12v2.927c-0.228-0.066-0.454-0.178-0.675-0.334-0.415-0.293-0.813-0.744-1.149-1.304-0.233-0.388-0.434-0.819-0.602-1.289h2.426zM9.825 13.289c-0.336 0.561-0.734 1.012-1.149 1.304-0.222 0.156-0.447 0.268-0.675 0.334v-2.927h2.426c-0.168 0.47-0.369 0.901-0.602 1.289zM8 11v-2h2.989c-0.029 0.69-0.12 1.36-0.27 2h-2.719zM11.99 8c-0.028-0.697-0.112-1.368-0.246-2h1.758c0.267 0.639 0.427 1.309 0.479 2h-1.991zM12.979 5h-1.498c-0.291-0.918-0.693-1.723-1.177-2.366 0.665 0.318 1.267 0.744 1.792 1.27 0.336 0.336 0.631 0.702 0.883 1.096zM2.904 3.904c0.526-0.526 1.128-0.952 1.792-1.27-0.483 0.643-0.886 1.448-1.177 2.366h-1.498c0.252-0.394 0.547-0.761 0.883-1.096zM2.021 12h1.498c0.291 0.918 0.693 1.723 1.177 2.366-0.665-0.318-1.267-0.744-1.792-1.27-0.336-0.336-0.631-0.702-0.883-1.096zM12.096 13.096c-0.526 0.526-1.128 0.952-1.792 1.27 0.483-0.643 0.886-1.448 1.177-2.366h1.498c-0.252 0.394-0.547 0.761-0.883 1.096z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9313a98a28a06e3a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 15c-0.984 0-1.92-0.203-2.769-0.57l3.643-4.098c0.081-0.092 0.126-0.21 0.126-0.332v-1.5c0-0.276-0.224-0.5-0.5-0.5-1.765 0-3.628-1.835-3.646-1.854-0.094-0.094-0.221-0.146-0.354-0.146h-2c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.189 0.107 0.363 0.276 0.447l1.724 0.862v2.936c-1.813-1.265-3-3.366-3-5.745 0-1.074 0.242-2.091 0.674-3h1.826c0.133 0 0.26-0.053 0.354-0.146l2-2c0.094-0.094 0.146-0.221 0.146-0.354v-1.21c0.634-0.189 1.305-0.29 2-0.29 1.1 0 2.141 0.254 3.067 0.706-0.065 0.055-0.128 0.112-0.188 0.172-0.567 0.567-0.879 1.32-0.879 2.121s0.312 1.555 0.879 2.121c0.569 0.569 1.332 0.879 2.119 0.879 0.049 0 0.099-0.001 0.149-0.004 0.216 0.809 0.605 2.917-0.131 5.818-0.007 0.027-0.011 0.055-0.013 0.082-1.271 1.298-3.042 2.104-5.002 2.104z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3dde7ad0bb5a5de0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.879 9.934c-0.208 0-0.416-0.079-0.575-0.238-1.486-1.486-1.486-3.905 0-5.392l3-3c0.72-0.72 1.678-1.117 2.696-1.117s1.976 0.397 2.696 1.117c1.486 1.487 1.486 3.905 0 5.392l-1.371 1.371c-0.317 0.317-0.832 0.317-1.149 0s-0.317-0.832 0-1.149l1.371-1.371c0.853-0.853 0.853-2.241 0-3.094-0.413-0.413-0.963-0.641-1.547-0.641s-1.134 0.228-1.547 0.641l-3 3c-0.853 0.853-0.853 2.241 0 3.094 0.317 0.317 0.317 0.832 0 1.149-0.159 0.159-0.367 0.238-0.575 0.238z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15.813c-1.018 0-1.976-0.397-2.696-1.117-1.486-1.486-1.486-3.905 0-5.392l1.371-1.371c0.317-0.317 0.832-0.317 1.149 0s0.317 0.832 0 1.149l-1.371 1.371c-0.853 0.853-0.853 2.241 0 3.094 0.413 0.413 0.962 0.641 1.547 0.641s1.134-0.228 1.547-0.641l3-3c0.853-0.853 0.853-2.241 0-3.094-0.317-0.317-0.317-0.832 0-1.149s0.832-0.317 1.149 0c1.486 1.486 1.486 3.905 0 5.392l-3 3c-0.72 0.72-1.678 1.117-2.696 1.117z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c2f1b75397a40f39(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0h2v16h-2v-16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10.047c1.291 0 2.415-0.312 3-0.773v-8c-0.585 0.461-1.709 0.773-3 0.773s-2.415-0.312-3-0.773v8c0.585 0.461 1.709 0.773 3 0.773z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0.508c-0.733-0.312-1.805-0.508-3-0.508-1.506 0-2.818 0.312-3.5 0.773v8c0.682-0.461 1.994-0.773 3.5-0.773 1.195 0 2.267 0.197 3 0.508v-8z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f73a0bc6a68d16cb(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.404 5.11l-1.015-1.014-5.075 5.074c-0.841 0.841-0.841 2.204 0 3.044s2.204 0.841 3.045 0l6.090-6.089c1.402-1.401 1.402-3.673 0-5.074s-3.674-1.402-5.075 0l-6.394 6.393c-0.005 0.005-0.010 0.009-0.014 0.013-1.955 1.955-1.955 5.123 0 7.077s5.123 1.954 7.078 0c0.004-0.004 0.008-0.009 0.013-0.014l0.001 0.001 4.365-4.364-1.015-1.014-4.365 4.363c-0.005 0.004-0.009 0.009-0.013 0.013-1.392 1.392-3.656 1.392-5.048 0s-1.392-3.655 0-5.047c0.005-0.005 0.009-0.009 0.014-0.013l-0.001-0.001 6.395-6.393c0.839-0.84 2.205-0.84 3.045 0s0.839 2.205 0 3.044l-6.090 6.089c-0.28 0.28-0.735 0.28-1.015 0s-0.28-0.735 0-1.014l5.075-5.075z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$38aa4755c303bbb5(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3c-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-1.486-2.968-4.511-5-8-5zM11.945 5.652c0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.737-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114v0zM8 6.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c54cd96deb7601b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2h-2v-2h-2v2h-2v2h2v2h2v-2h2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.498 6.969c0.288 0.32 0.55 0.665 0.782 1.031-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.736-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.011-0-0.022-0-0.032-1.708-0.44-2.973-1.979-2.999-3.817-0.329-0.037-0.662-0.057-1.001-0.057-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-0.276-0.55-0.604-1.069-0.979-1.548-0.457 0.268-0.973 0.449-1.523 0.517zM6.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1d53d229f277795e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2h6v2h-6v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.599 5h-4.599v-1.944c-0.328-0.037-0.662-0.056-1-0.056-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-0.584-1.167-1.407-2.189-2.401-3zM6.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM11.944 10.348c-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.736-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114 0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ca5cce7e38589fc2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.78 0.22c-0.293-0.293-0.768-0.293-1.061 0l-3.159 3.159c-0.812-0.246-1.671-0.378-2.561-0.378-3.489 0-6.514 2.032-8 5 0.643 1.283 1.573 2.391 2.703 3.236l-2.484 2.484c-0.293 0.293-0.293 0.768 0 1.061 0.146 0.146 0.338 0.22 0.53 0.22s0.384-0.073 0.53-0.22l13.5-13.5c0.293-0.293 0.293-0.768 0-1.061zM6.5 5c0.66 0 1.22 0.426 1.421 1.019l-1.902 1.902c-0.592-0.201-1.019-0.761-1.019-1.421 0-0.828 0.672-1.5 1.5-1.5zM1.721 8c0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 0.858 0.27 1.652 0.73 2.303l-0.952 0.952c-0.819-0.576-1.519-1.311-2.057-2.162z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.906c0-0.424-0.066-0.833-0.189-1.217l-5.028 5.028c0.384 0.123 0.793 0.189 1.217 0.189 2.209 0 4-1.791 4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.969 4.531l-1.084 1.084c0.020 0.012 0.040 0.024 0.059 0.037 0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152-0.604 0-1.202-0.074-1.781-0.219l-1.201 1.201c0.933 0.335 1.937 0.518 2.982 0.518 3.489 0 6.514-2.032 8-5-0.703-1.405-1.752-2.6-3.031-3.469z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$98e7cdc94dadf321(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0v16l5-5 5 5v-16z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b618ab1cd84c82b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v14l5-5 5 5v-14zM12 0h-10v14l1-1v-12h9z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2a68b64752197df2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1zM15 7c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1zM3 8c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1zM12.95 11.536l0.707 0.707c0.39 0.39 0.39 1.024 0 1.414s-1.024 0.39-1.414 0l-0.707-0.707c-0.39-0.39-0.39-1.024 0-1.414s1.024-0.39 1.414 0zM3.050 4.464l-0.707-0.707c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l0.707 0.707c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0zM12.95 4.464c-0.39 0.391-1.024 0.391-1.414 0s-0.39-1.024 0-1.414l0.707-0.707c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-0.707 0.707zM3.050 11.536c0.39-0.39 1.024-0.39 1.414 0s0.391 1.024 0 1.414l-0.707 0.707c-0.391 0.39-1.024 0.39-1.414 0s-0.391-1.024 0-1.414l0.707-0.707z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM8 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8eea95a7cdced9a9(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM2 8c0-3.314 2.686-6 6-6v12c-3.314 0-6-2.686-6-6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7c0c612db9cb41ce(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4zM8 10.5v-5c1.379 0 2.5 1.122 2.5 2.5s-1.121 2.5-2.5 2.5zM8 13c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1zM15 7c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1zM3 8c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1zM12.95 11.536l0.707 0.707c0.39 0.39 0.39 1.024 0 1.414s-1.024 0.39-1.414 0l-0.707-0.707c-0.39-0.39-0.39-1.024 0-1.414s1.024-0.39 1.414 0zM3.050 4.464l-0.707-0.707c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l0.707 0.707c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0zM12.95 4.464c-0.39 0.391-1.024 0.391-1.414 0s-0.39-1.024 0-1.414l0.707-0.707c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-0.707 0.707zM3.050 11.536c0.39-0.39 1.024-0.39 1.414 0s0.391 1.024 0 1.414l-0.707 0.707c-0.391 0.39-1.024 0.39-1.414 0s-0.391-1.024 0-1.414l0.707-0.707z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d1d0556f5ed4c65a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-3.492 1.836 0.667-3.888-2.825-2.753 3.904-0.567 1.746-3.537 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8449fea8bddcd0cb(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-0.015 0.008 0.015-8.918 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$cd03a3fd31a89d40(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f178623fc3ef1ef(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8 1c-1.682 0-3.129 1.368-3.799 2.797-0.671-1.429-2.118-2.797-3.8-2.797-2.318 0-4.2 1.882-4.2 4.2 0 4.716 4.758 5.953 8 10.616 3.065-4.634 8-6.050 8-10.616 0-2.319-1.882-4.2-4.2-4.2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9f515d41a1ebdccf(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8 1c2.318 0 4.2 1.882 4.2 4.2 0 4.566-4.935 5.982-8 10.616-3.243-4.663-8-5.9-8-10.616 0-2.319 1.882-4.2 4.2-4.2 0.943 0 1.812 0.43 2.512 1.060l-1.213 1.94 3.5 2-2 5 5.5-6-3.5-2 0.967-1.451c0.553-0.34 1.175-0.549 1.833-0.549z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$642c91dd19985384(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4h-3c-0.552 0-1 0.448-1 1v5h1v6h1.25v-6h0.5v6h1.25v-6h1v-5c0-0.552-0.448-1-1-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$219e01032d5ca099(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.234 8l0.766-0.555-2.083-3.221c-0.092-0.14-0.249-0.225-0.417-0.225h-4c-0.168 0-0.325 0.084-0.417 0.225l-2.083 3.221 0.766 0.555 1.729-2.244 0.601 1.402-2.095 3.841h1.917l0.333 5h1v-5h0.5v5h1l0.333-5h1.917l-2.095-3.842 0.601-1.402 1.729 2.244z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e2cc43b849552ef3(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h-3c-0.552 0-1 0.448-1 1v5h1v6h1.25v-6h0.5v6h1.25v-6h1v-5c0-0.552-0.448-1-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.234 8l0.766-0.555-2.083-3.221c-0.092-0.14-0.249-0.225-0.417-0.225h-4c-0.168 0-0.325 0.084-0.417 0.225l-2.083 3.221 0.766 0.555 1.729-2.244 0.601 1.402-2.095 3.841h1.917l0.333 5h1v-5h0.5v5h1l0.333-5h1.917l-2.095-3.842 0.601-1.402 1.729 2.244z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9ec52ef3f344346(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM8 9.356c1.812 0 3.535-0.481 5-1.327-0.228 2.788-2.393 4.971-5 4.971s-4.772-2.186-5-4.973c1.465 0.845 3.188 1.329 5 1.329zM4 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2c41626f112af035(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM5 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM8 14c-2.607 0-4.772-2.186-5-4.973 1.465 0.846 3.188 1.329 5 1.329s3.535-0.481 5-1.327c-0.228 2.788-2.393 4.971-5 4.971z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$57c38105120f493f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.002 9.801l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427s-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$414f2883cd24f43(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM8 13c-1.82 0-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5decacedd80625da(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM12 9v1h-1v1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h-4v-1h8z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5549871ea9067c9c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM12 10h-1v1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h-4v-1h8v1zM11 6c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$19cf0d69550d2ab2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM4.998 12.199l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.413 0.973 4.288 2.427l-1.286 0.772c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$90300023781c1b1e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$cab41809cf233634(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM8.48 11.11c2.191-0.433 3.892-1.43 4.507-2.759-0.338 2.624-2.524 4.649-5.17 4.649-1.863 0-3.498-1.004-4.42-2.515 1.1 0.86 3.040 1.028 5.083 0.625zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM5.5 5.805c-0.653 0-1.208 0.245-1.414 0.586-0.055-0.092-0.086-0.503-0.086-0.605 0-0.485 0.672-0.879 1.5-0.879s1.5 0.394 1.5 0.879c0 0.103-0.030 0.514-0.086 0.605-0.206-0.341-0.761-0.586-1.414-0.586z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7d041cf0deb49950(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM5.5 4.876c0.932 0 1.594 0.349 1.594 0.895 0 0.116 0.060 0.672-0.003 0.775-0.232-0.384-0.856-0.659-1.591-0.659s-1.359 0.275-1.591 0.659c-0.062-0.103-0.003-0.659-0.003-0.775 0-0.546 0.662-0.895 1.594-0.895zM7.818 13c-1.863 0-3.498-1.004-4.42-2.515 1.1 0.86 3.040 1.028 5.083 0.625 2.191-0.433 3.892-1.43 4.507-2.759-0.338 2.624-2.524 4.649-5.17 4.649z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$465f396029443116(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM3 8v1c0 2.2 1.8 4 4 4h2c2.2 0 4-1.8 4-4v-1h-10zM6 11.828c-0.415-0.148-0.796-0.388-1.118-0.71-0.569-0.569-0.882-1.321-0.882-2.118h2v2.828zM9 12h-2v-3h2v3zM11.118 11.118c-0.322 0.322-0.703 0.562-1.118 0.71v-2.828h2c0 0.797-0.313 1.549-0.882 2.118zM3.521 6c0 0 0 0 0 0 0.153 0 0.283-0.11 0.308-0.261 0.096-0.573 0.589-0.989 1.171-0.989s1.074 0.416 1.171 0.989c0.025 0.151 0.156 0.261 0.308 0.261s0.283-0.11 0.308-0.261c0.017-0.101 0.025-0.202 0.025-0.302 0-0.999-0.813-1.813-1.813-1.813s-1.813 0.813-1.813 1.813c0 0.1 0.009 0.201 0.025 0.302 0.025 0.151 0.156 0.261 0.308 0.261zM9.521 6c0 0 0 0 0 0 0.153 0 0.283-0.11 0.308-0.261 0.096-0.573 0.589-0.989 1.171-0.989s1.074 0.416 1.171 0.989c0.025 0.151 0.156 0.261 0.308 0.261s0.283-0.11 0.308-0.261c0.017-0.101 0.025-0.202 0.025-0.302 0-0.999-0.813-1.813-1.813-1.813s-1.813 0.813-1.813 1.813c0 0.1 0.008 0.201 0.025 0.302 0.025 0.151 0.156 0.261 0.308 0.261z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$343ffe0d155e22dd(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 3.688c0.999 0 1.813 0.813 1.813 1.813 0 0.1-0.009 0.201-0.025 0.302-0.025 0.151-0.156 0.261-0.308 0.261s-0.283-0.11-0.308-0.261c-0.096-0.573-0.589-0.833-1.171-0.833s-1.074 0.26-1.171 0.833c-0.025 0.151-0.156 0.261-0.308 0.261-0 0 0 0-0 0-0.153 0-0.283-0.11-0.308-0.261-0.017-0.101-0.025-0.202-0.025-0.302 0-0.999 0.813-1.813 1.813-1.813zM5 3.688c0.999 0 1.813 0.813 1.813 1.813 0 0.1-0.009 0.201-0.025 0.302-0.025 0.151-0.156 0.261-0.308 0.261s-0.283-0.11-0.308-0.261c-0.096-0.573-0.589-0.833-1.171-0.833s-1.074 0.26-1.171 0.833c-0.025 0.151-0.156 0.261-0.308 0.261 0 0 0 0 0 0-0.153 0-0.283-0.11-0.308-0.261-0.017-0.101-0.025-0.202-0.025-0.302 0-0.999 0.813-1.813 1.813-1.813zM3 9h3v3.873c-1.72-0.447-3-2.018-3-3.873zM7 13v-4h2v4h-2zM10 12.873v-3.873h3c0 1.855-1.28 3.426-3 3.873z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$757604ef761889f1(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM12.5 4c0.275 0 0.5 0.225 0.5 0.5v1.5c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1h-2c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v0.5h2v-0.5c0-0.275 0.225-0.5 0.5-0.5h3zM8 12c1.456 0 2.731-0.778 3.43-1.942l0.857 0.515c-0.874 1.454-2.467 2.427-4.288 2.427-0.757 0-1.475-0.169-2.118-0.47l0.518-0.864c0.49 0.214 1.031 0.334 1.6 0.334z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$bab907dafc22baac(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM8 13c-0.757 0-1.475-0.169-2.118-0.47l0.518-0.864c0.49 0.214 1.031 0.334 1.6 0.334 1.456 0 2.731-0.778 3.43-1.942l0.858 0.515c-0.874 1.454-2.467 2.427-4.288 2.427zM13 6c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1h-2c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v0.5h2v-0.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$28d526f5b602a6ad(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772zM11.985 4.379c0.067 0.268-0.096 0.539-0.364 0.606-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054 0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7c5d409512f14a5a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9.001 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d6893b43e332c840(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7c-0.552 0-1-0.448-1-1 0-0.018 0.001-0.036 0.002-0.054 0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1zM4.379 4.985c-0.268-0.067-0.431-0.338-0.364-0.606s0.338-0.431 0.606-0.364c0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334zM8 11.5c1.274 0 2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427s-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699zM16 1c0-0.711-0.149-1.387-0.416-2-0.525 1.201-1.507 2.155-2.726 2.643-1.347-1.031-3.030-1.643-4.857-1.643s-3.51 0.613-4.857 1.643c-1.22-0.488-2.202-1.443-2.726-2.643-0.268 0.613-0.416 1.289-0.416 2 0 1.15 0.388 2.208 1.040 3.053-0.662 1.165-1.040 2.512-1.040 3.947 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.436-0.378-2.783-1.040-3.947 0.652-0.845 1.040-1.903 1.040-3.053zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4d613893cf178fbb(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1c0-0.711-0.149-1.387-0.416-2-0.525 1.201-1.507 2.155-2.726 2.643-1.347-1.031-3.030-1.643-4.857-1.643s-3.51 0.613-4.857 1.643c-1.22-0.488-2.202-1.443-2.726-2.643-0.268 0.613-0.416 1.289-0.416 2 0 1.15 0.388 2.208 1.040 3.053-0.662 1.165-1.040 2.512-1.040 3.947 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.436-0.378-2.783-1.040-3.947 0.652-0.845 1.040-1.903 1.040-3.053zM9.001 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM8 13c-1.82 0-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1f9d8d9d56116bec(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM6 11c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM4 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$abb37e0a29e043c5(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 7c-0.552 0-1-0.672-1-1.5s0.448-1.5 1-1.5 1 0.672 1 1.5-0.448 1.5-1 1.5zM8 13c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2zM11 7c-0.552 0-1-0.672-1-1.5s0.448-1.5 1-1.5 1 0.672 1 1.5-0.448 1.5-1 1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$da46b6f930b1301f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM5.5 4c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM10.5 4c-1.379 0-2.5 1.122-2.5 2.5s1.121 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.121-2.5-2.5-2.5v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11h4v1h-4v-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$19c84bba8dcc2506(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4 6.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5zM10 12h-4v-1h4v1zM10.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$27df86feadf58a79(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.345 10h1.014c0.144 1.133-0.507 2.258-1.624 2.665-1.295 0.472-2.733-0.199-3.204-1.494-0.283-0.777-1.145-1.179-1.923-0.896-0.712 0.259-1.109 1.005-0.953 1.725h-1.013c-0.144-1.133 0.507-2.258 1.624-2.665 1.295-0.472 2.733 0.199 3.204 1.494 0.283 0.777 1.145 1.179 1.923 0.896 0.712-0.259 1.109-1.005 0.953-1.725z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$22daf4d6354417d9(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM10.735 12.665c-1.295 0.472-2.733-0.199-3.204-1.494-0.283-0.777-1.145-1.179-1.923-0.896-0.712 0.259-1.109 1.005-0.953 1.725h-1.013c-0.144-1.133 0.507-2.258 1.624-2.665 1.295-0.472 2.733 0.199 3.204 1.494 0.283 0.777 1.145 1.179 1.923 0.896 0.712-0.259 1.109-1.005 0.953-1.725h1.014c0.144 1.133-0.507 2.258-1.624 2.665z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3e2d29b9cd926f00(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1-1 0.448-1 1zM10 5c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1-1 0.448-1 1zM6 11h4v1h-4v-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1e136ad81655f23b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM10 12h-4v-1h4v1zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5103b1a2549d28ac(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.561 8.439c-0.586-0.586-1.536-0.586-2.121 0s-0.586 1.536 0 2.121c0.019 0.019 0.038 0.037 0.058 0.055 1.352 1.227 4.503-0.029 4.503-1.615-0.969 0.625-1.726 0.153-2.439-0.561z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.439 8.439c0.586-0.586 1.536-0.586 2.121 0s0.586 1.536 0 2.121c-0.019 0.019-0.038 0.037-0.058 0.055-1.352 1.227-4.503-0.029-4.503-1.615 0.969 0.625 1.726 0.153 2.439-0.561z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$73fddc8782ad1a53(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM8.497 10.615c-0.020-0.018-0.039-0.036-0.058-0.055-0.293-0.293-0.439-0.677-0.439-1.060-0 0.384-0.146 0.768-0.439 1.060-0.019 0.019-0.038 0.037-0.058 0.055-1.352 1.227-4.503-0.029-4.503-1.615 0.969 0.625 1.726 0.153 2.439-0.561 0.586-0.586 1.536-0.586 2.121 0 0.293 0.293 0.439 0.677 0.439 1.060 0-0.384 0.146-0.768 0.439-1.060 0.586-0.586 1.536-0.586 2.121 0 0.713 0.714 1.471 1.186 2.439 0.561 0 1.586-3.151 2.842-4.503 1.615z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$df2eb038dcbb10bc(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11.652 9.4l0.351 1.2-6.828 2-0.351-1.2zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6f385ad692df86a6(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM5.176 12.6l-0.351-1.2 6.828-2 0.351 1.2-6.828 2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$389e2e1d661ce0fc(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.5c0 1.381-0.895 2.5-2 2.5s-2-1.119-2-2.5c0-1.381 0.895-2.5 2-2.5s2 1.119 2 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 5.313c-0.128 0-0.256-0.049-0.354-0.146-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 5.313c-0.128 0-0.256-0.049-0.354-0.146-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$53b4cebed3ba953(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4.854 5.166c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.302-0.302-0.991-0.302-1.293 0zM8 13c-1.105 0-2-1.119-2-2.5s0.895-2.5 2-2.5 2 1.119 2 2.5-0.895 2.5-2 2.5zM11.854 5.166c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$cc5685b9dc9186f7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.724 4.428c-0.543-0.271-1.080-0.407-1.102-0.413-0.268-0.067-0.539 0.096-0.606 0.364s0.096 0.539 0.364 0.606c0.275 0.070 0.602 0.189 0.89 0.334-0.166 0.179-0.268 0.418-0.268 0.681 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.018-0.001-0.036-0.002-0.054-0.032-0.741-0.706-1.234-1.275-1.518z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM3.695 12.87c0.167 0.083 0.356 0.13 0.555 0.13h7.5c0.199 0 0.387-0.047 0.555-0.13-1.147 1.014-2.654 1.63-4.305 1.63s-3.158-0.616-4.305-1.63zM4 11.75v-1.5c0-0.136 0.114-0.25 0.25-0.25h1.75v2h-1.75c-0.136 0-0.25-0.114-0.25-0.25zM7 12v-2h2v2h-2zM10 12v-2h1.75c0.136 0 0.25 0.114 0.25 0.25v1.5c0 0.136-0.114 0.25-0.25 0.25h-1.75zM12.87 12.305c0.083-0.167 0.13-0.356 0.13-0.555v-1.5c0-0.689-0.561-1.25-1.25-1.25h-7.5c-0.689 0-1.25 0.561-1.25 1.25v1.5c0 0.199 0.047 0.387 0.13 0.555-1.014-1.147-1.63-2.654-1.63-4.305 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 1.651-0.616 3.158-1.63 4.305z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.379 4.015c-0.023 0.006-0.559 0.141-1.102 0.413-0.568 0.284-1.243 0.776-1.275 1.518-0.001 0.018-0.002 0.036-0.002 0.054 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.263-0.102-0.503-0.268-0.681 0.288-0.144 0.614-0.264 0.89-0.334 0.268-0.067 0.431-0.338 0.364-0.606s-0.338-0.431-0.606-0.364z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4c5b593487898723(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.25v1.5c0 0.136 0.114 0.25 0.25 0.25h1.75v-2h-1.75c-0.136 0-0.25 0.114-0.25 0.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h2v2h-2v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.75 10h-1.75v2h1.75c0.136 0 0.25-0.114 0.25-0.25v-1.5c0-0.136-0.114-0.25-0.25-0.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9.002 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM13 11.75c0 0.689-0.561 1.25-1.25 1.25h-7.5c-0.689 0-1.25-0.561-1.25-1.25v-1.5c0-0.689 0.561-1.25 1.25-1.25h7.5c0.689 0 1.25 0.561 1.25 1.25v1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4df530b60f21248e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 13.375c-0.128 0-0.256-0.049-0.354-0.146-0.072-0.072-0.46-0.229-1.146-0.229s-1.075 0.157-1.146 0.229c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.471-0.471 1.453-0.521 1.854-0.521s1.383 0.051 1.854 0.521c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 9c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$481ae5a1e257876b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM5 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM5.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM9.854 13.229c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.072-0.072-0.46-0.229-1.146-0.229s-1.075 0.157-1.146 0.229c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.471-0.471 1.453-0.521 1.854-0.521s1.383 0.051 1.854 0.521c0.195 0.195 0.195 0.512 0 0.707zM12 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM12 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM12.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e8bfb586dbccbd96(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.5v-2.5c0-0.827-0.673-1.5-1.5-1.5-0.267 0-0.518 0.070-0.736 0.193-0.267-0.417-0.734-0.693-1.264-0.693-0.384 0-0.734 0.145-1 0.383-0.266-0.238-0.616-0.383-1-0.383-0.175 0-0.344 0.030-0.5 0.086v-3.586c0-0.827-0.673-1.5-1.5-1.5s-1.5 0.673-1.5 1.5v6.167l-2.75-1.466c-0.227-0.131-0.486-0.201-0.75-0.201-0.827 0-1.5 0.673-1.5 1.5 0 0.412 0.164 0.796 0.461 1.082 0.004 0.004 0.008 0.007 0.012 0.011l3.737 3.407h-0.71c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h10c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-0.691l1.138-2.276c0.035-0.069 0.053-0.146 0.053-0.224zM14 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5zM14 9.382l-1.309 2.618h-5.997l-4.544-4.143c-0.097-0.095-0.15-0.221-0.15-0.357 0-0.276 0.224-0.5 0.5-0.5 0.085 0 0.166 0.020 0.239 0.061 0.008 0.005 0.017 0.010 0.025 0.014l3.5 1.866c0.155 0.083 0.342 0.078 0.492-0.012s0.243-0.253 0.243-0.429v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2.382z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$105700f006551212(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15h2.5c0.827 0 1.5-0.673 1.5-1.5 0-0.267-0.070-0.518-0.193-0.736 0.417-0.267 0.693-0.734 0.693-1.264 0-0.384-0.145-0.734-0.383-1 0.238-0.266 0.383-0.616 0.383-1 0-0.175-0.030-0.344-0.086-0.5h3.586c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5h-6.167l1.466-2.75c0.131-0.227 0.201-0.486 0.201-0.75 0-0.827-0.673-1.5-1.5-1.5-0.412 0-0.796 0.164-1.082 0.461-0.004 0.004-0.007 0.008-0.011 0.012l-3.407 3.737v-0.71c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-0.691l2.276 1.138c0.069 0.035 0.146 0.053 0.224 0.053zM2.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM6.618 14l-2.618-1.309v-5.997l4.143-4.544c0.095-0.097 0.221-0.15 0.357-0.15 0.276 0 0.5 0.224 0.5 0.5 0 0.085-0.020 0.166-0.061 0.239-0.005 0.008-0.010 0.017-0.014 0.025l-1.866 3.5c-0.083 0.155-0.078 0.342 0.013 0.492s0.253 0.243 0.429 0.243h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2.382z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a6bc050dfa3fb584(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6.5v2.5c0 0.827-0.673 1.5-1.5 1.5-0.267 0-0.518-0.070-0.736-0.193-0.267 0.417-0.734 0.693-1.264 0.693-0.384 0-0.734-0.145-1-0.383-0.266 0.238-0.616 0.383-1 0.383-0.175 0-0.344-0.030-0.5-0.086v3.586c0 0.827-0.673 1.5-1.5 1.5s-1.5-0.673-1.5-1.5v-6.167l-2.75 1.466c-0.227 0.131-0.486 0.201-0.75 0.201-0.827 0-1.5-0.673-1.5-1.5 0-0.412 0.164-0.796 0.461-1.082 0.004-0.004 0.008-0.007 0.012-0.011l3.737-3.407h-0.71c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5h10c0.276 0 0.5 0.224 0.5 0.5v3c0 0.276-0.224 0.5-0.5 0.5h-0.691l1.138 2.276c0.035 0.069 0.053 0.146 0.053 0.224zM14 2.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5 0.5-0.224 0.5-0.5zM14 6.618l-1.309-2.618h-5.997l-4.544 4.143c-0.097 0.095-0.15 0.221-0.15 0.357 0 0.276 0.224 0.5 0.5 0.5 0.085 0 0.166-0.020 0.239-0.061 0.008-0.005 0.017-0.010 0.025-0.014l3.5-1.866c0.155-0.083 0.342-0.078 0.492 0.013s0.243 0.253 0.243 0.429v7c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.382z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7cc825b10469839e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 15h-2.5c-0.827 0-1.5-0.673-1.5-1.5 0-0.267 0.070-0.518 0.193-0.736-0.417-0.267-0.693-0.734-0.693-1.264 0-0.384 0.145-0.734 0.383-1-0.238-0.266-0.383-0.616-0.383-1 0-0.175 0.030-0.344 0.086-0.5h-3.586c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5h6.167l-1.466-2.75c-0.131-0.227-0.201-0.486-0.201-0.75 0-0.827 0.673-1.5 1.5-1.5 0.412 0 0.796 0.164 1.082 0.461 0.004 0.004 0.007 0.008 0.011 0.012l3.407 3.737v-0.71c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v10c0 0.276-0.224 0.5-0.5 0.5h-3c-0.276 0-0.5-0.224-0.5-0.5v-0.691l-2.276 1.138c-0.069 0.035-0.146 0.053-0.224 0.053zM13.5 14c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5zM9.382 14l2.618-1.309v-5.997l-4.143-4.544c-0.095-0.097-0.221-0.15-0.357-0.15-0.276 0-0.5 0.224-0.5 0.5 0 0.085 0.020 0.166 0.061 0.239 0.005 0.008 0.010 0.017 0.014 0.025l1.866 3.5c0.083 0.155 0.078 0.342-0.012 0.492s-0.253 0.243-0.429 0.243h-7c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.382z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6eedceaba597d1ac(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.45l6.705 13.363h-13.409l6.705-13.363zM8 0c-0.345 0-0.69 0.233-0.951 0.698l-6.829 13.611c-0.523 0.93-0.078 1.691 0.989 1.691h13.583c1.067 0 1.512-0.761 0.989-1.691h0l-6.829-13.611c-0.262-0.465-0.606-0.698-0.951-0.698v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11c-0.552 0-1-0.448-1-1v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v3c0 0.552-0.448 1-1 1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$fe9ca3eaa9ec5a64(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.5c-1.736 0-3.369 0.676-4.596 1.904s-1.904 2.86-1.904 4.596c0 1.736 0.676 3.369 1.904 4.596s2.86 1.904 4.596 1.904c1.736 0 3.369-0.676 4.596-1.904s1.904-2.86 1.904-4.596c0-1.736-0.676-3.369-1.904-4.596s-2.86-1.904-4.596-1.904zM8 0v0c4.418 0 8 3.582 8 8s-3.582 8-8 8c-4.418 0-8-3.582-8-8s3.582-8 8-8zM7 11h2v2h-2zM7 3h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2566b9bc42b09bb7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h2v2h-2zM11 4c0.552 0 1 0.448 1 1v3l-3 2h-2v-1l3-2v-1h-5v-2h6zM8 1.5c-1.736 0-3.369 0.676-4.596 1.904s-1.904 2.86-1.904 4.596c0 1.736 0.676 3.369 1.904 4.596s2.86 1.904 4.596 1.904c1.736 0 3.369-0.676 4.596-1.904s1.904-2.86 1.904-4.596c0-1.736-0.676-3.369-1.904-4.596s-2.86-1.904-4.596-1.904zM8 0v0c4.418 0 8 3.582 8 8s-3.582 8-8 8c-4.418 0-8-3.582-8-8s3.582-8 8-8z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e3f0d7f71f02aded(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 6h-5.5v-5.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v5.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h5.5v5.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-5.5h5.5c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$cf0638d49314b4b5(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6.5v3c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-15c-0.276 0-0.5 0.224-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2fe6b6ba87cfc58(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12h-4v-1h1v-3h-1v-1h3v4h1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7964bcc7ab6ef406(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 4l-2.5 2.5-2.5-2.5-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 2.5-2.5 2.5 2.5 1.5-1.5-2.5-2.5 2.5-2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$26283e24bb66ecbc(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.657 2.343c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343c-1.511 1.511-2.343 3.52-2.343 5.657s0.832 4.146 2.343 5.657c1.511 1.511 3.52 2.343 5.657 2.343s4.146-0.832 5.657-2.343c1.511-1.511 2.343-3.52 2.343-5.657s-0.832-4.146-2.343-5.657zM14 8c0 1.294-0.412 2.494-1.111 3.475l-8.364-8.364c0.981-0.699 2.181-1.111 3.475-1.111 3.308 0 6 2.692 6 6zM2 8c0-1.294 0.412-2.494 1.111-3.475l8.364 8.364c-0.981 0.699-2.181 1.111-3.475 1.111-3.308 0-6-2.692-6-6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$589a90bd90e48f2a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.854 12.854c-0-0-0-0-0-0l-4.854-4.854 4.854-4.854c0-0 0-0 0-0 0.052-0.052 0.090-0.113 0.114-0.178 0.066-0.178 0.028-0.386-0.114-0.529l-2.293-2.293c-0.143-0.143-0.351-0.181-0.529-0.114-0.065 0.024-0.126 0.062-0.178 0.114 0 0-0 0-0 0l-4.854 4.854-4.854-4.854c-0-0-0-0-0-0-0.052-0.052-0.113-0.090-0.178-0.114-0.178-0.066-0.386-0.029-0.529 0.114l-2.293 2.293c-0.143 0.143-0.181 0.351-0.114 0.529 0.024 0.065 0.062 0.126 0.114 0.178 0 0 0 0 0 0l4.854 4.854-4.854 4.854c-0 0-0 0-0 0-0.052 0.052-0.090 0.113-0.114 0.178-0.066 0.178-0.029 0.386 0.114 0.529l2.293 2.293c0.143 0.143 0.351 0.181 0.529 0.114 0.065-0.024 0.126-0.062 0.178-0.114 0-0 0-0 0-0l4.854-4.854 4.854 4.854c0 0 0 0 0 0 0.052 0.052 0.113 0.090 0.178 0.114 0.178 0.066 0.386 0.029 0.529-0.114l2.293-2.293c0.143-0.143 0.181-0.351 0.114-0.529-0.024-0.065-0.062-0.126-0.114-0.178z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f38b120b64bff574(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 2l-7.5 7.5-3.5-3.5-2.5 2.5 6 6 10-10z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$abbc44b2b1d0c872(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.21 14.339l-6.217-6.119 3.084-3.035 3.133 3.083 6.713-6.607 3.084 3.035-9.797 9.643zM1.686 8.22l4.524 4.453 8.104-7.976-1.391-1.369-6.713 6.607-3.133-3.083-1.391 1.369z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ed03ac00a5d4f73b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4h2v3h1v-6c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v6h1v-3zM2 1h2v2h-2v-2zM15 1v-1h-3c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h3v-1h-3v-5h3zM10 2.5v-1.5c0-0.55-0.45-1-1-1h-3v7h3c0.55 0 1-0.45 1-1v-1.5c0-0.55-0.137-1-0.688-1 0.55 0 0.688-0.45 0.688-1zM9 6h-2v-2h2v2zM9 3h-2v-2h2v2zM13 9l-6.5 7-3.5-4.5 1.281-1.094 2.219 2.313 5.5-4.719z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$97730275b2c25325(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h-5v-2h5v-2l3 3-3 3zM16 0v13l-6 3v-3h-6v-4h1v3h5v-9l4-2h-9v4h-1v-5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$412dabea8e78c1ef(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10v-2h-5v-2h5v-2l3 3zM11 9v4h-5v3l-6-3v-13h11v5h-1v-4h-8l4 2v9h4v-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$75796dfe9ce18ebf(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM6 4.5l6 3.5-6 3.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$504398bc72a79f08(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h2v6h-2zM9 5h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$97f23df930ffe9a7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h6v6h-6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f7231b82f51fc9ef(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8l4-3v6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v6h-2v-6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d79ee7c37afe3137(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zM8 14.5c3.59 0 6.5-2.91 6.5-6.5s-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5 2.91 6.5 6.5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8l-4-3v6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5h-2v6h2v-6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d9dad66d0bb881c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11 10.5l-3.5-2.5 3.5-2.5zM7 10.5l-3.5-2.5 3.5-2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$673943e8c49ddafc(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5.5l3.5 2.5-3.5 2.5zM9 5.5l3.5 2.5-3.5 2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$57a63a44564fceca(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2l10 6-10 6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$84caf31dffaf8413(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h5v12h-5zM9 2h5v12h-5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$732acb11d82897f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h12v12h-12z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$fd33b4117f214a3f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2.5v5l5-5v11l-5-5v5l-5.5-5.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$85648603c312aa69(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13.5v-5l-5 5v-11l5 5v-5l5.5 5.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a2e76db229af018(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14v-12h2v5.5l5-5v5l5-5v11l-5-5v5l-5-5v5.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5cd68f9931a1f48a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v12h-2v-5.5l-5 5v-5l-5 5v-11l5 5v-5l5 5v-5.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1311c68d4660d558(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14v-12h2v5.5l5-5v11l-5-5v5.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$129c31fc852a134a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v12h-2v-5.5l-5 5v-11l5 5v-5.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$aca96a10d427a888(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12h16v2h-16zM8 2l8 8h-16z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2be4e82ed89df992(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 17 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.907 14.407c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.369-1.369 2.123-3.19 2.123-5.127s-0.754-3.757-2.123-5.127c-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.653 1.653 2.563 3.85 2.563 6.187s-0.91 4.534-2.563 6.187c-0.146 0.146-0.338 0.22-0.53 0.22zM11.243 12.993c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 2.047-2.047 2.047-5.378 0-7.425-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773c-0.146 0.146-0.338 0.22-0.53 0.22v0zM8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a4baea4c70bc5a1e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.243 12.993c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 2.047-2.047 2.047-5.378 0-7.425-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773c-0.146 0.146-0.338 0.22-0.53 0.22v0zM8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6b03d024a0528666(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$291c59c7c805b01d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e878cab140db9136(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.674v1.326h-1.326l-1.674-1.674-1.674 1.674h-1.326v-1.326l1.674-1.674-1.674-1.674v-1.326h1.326l1.674 1.674 1.674-1.674h1.326v1.326l-1.674 1.674 1.674 1.674z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d202593371afa9bf(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7d28af66969d371b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h8v2h-8v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$bc1cc234ff5db0b8(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5h10v3l4-4-4-4v3h-12v6h2zM14 11h-10v-3l-4 4 4 4v-3h12v-6h-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3d9a0ea86d299e34(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.901 2.599c-1.463-1.597-3.565-2.599-5.901-2.599-4.418 0-8 3.582-8 8h1.5c0-3.59 2.91-6.5 6.5-6.5 1.922 0 3.649 0.835 4.839 2.161l-2.339 2.339h5.5v-5.5l-2.099 2.099z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 8c0 3.59-2.91 6.5-6.5 6.5-1.922 0-3.649-0.835-4.839-2.161l2.339-2.339h-5.5v5.5l2.099-2.099c1.463 1.597 3.565 2.599 5.901 2.599 4.418 0 8-3.582 8-8h-1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e92bb61118de62f0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.25 11.75c-1.002 0-1.943-0.39-2.652-1.098l-1.598-1.598-1.598 1.598c-0.708 0.708-1.65 1.098-2.652 1.098s-1.944-0.39-2.652-1.098c-0.708-0.708-1.098-1.65-1.098-2.652s0.39-1.943 1.098-2.652c0.708-0.708 1.65-1.098 2.652-1.098s1.943 0.39 2.652 1.098l1.598 1.598 1.598-1.598c0.708-0.708 1.65-1.098 2.652-1.098s1.944 0.39 2.652 1.098c0.708 0.708 1.098 1.65 1.098 2.652s-0.39 1.943-1.098 2.652c-0.708 0.708-1.65 1.098-2.652 1.098zM10.652 9.598c0.427 0.427 0.994 0.662 1.598 0.662s1.171-0.235 1.598-0.662c0.427-0.427 0.662-0.994 0.662-1.598s-0.235-1.171-0.662-1.598c-0.427-0.427-0.994-0.662-1.598-0.662s-1.171 0.235-1.598 0.662l-1.598 1.598 1.598 1.598zM3.75 5.74c-0.604 0-1.171 0.235-1.598 0.662s-0.662 0.994-0.662 1.598c0 0.604 0.235 1.171 0.662 1.598s0.994 0.662 1.598 0.662c0.604 0 1.171-0.235 1.598-0.662l1.598-1.598-1.598-1.598c-0.427-0.427-0.994-0.662-1.598-0.662v0z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1cf216680fc570f7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11h-1.586l-2.5-2.5 2.5-2.5h1.586v2.5l3.5-3.5-3.5-3.5v2.5h-2c-0.265 0-0.52 0.105-0.707 0.293l-2.793 2.793-2.793-2.793c-0.188-0.188-0.442-0.293-0.707-0.293h-3v2h2.586l2.5 2.5-2.5 2.5h-2.586v2h3c0.265 0 0.52-0.105 0.707-0.293l2.793-2.793 2.793 2.793c0.188 0.188 0.442 0.293 0.707 0.293h2v2.5l3.5-3.5-3.5-3.5v2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b1f8f4a4fb86dfa2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 11.5l4-4 8.5 8.5 3.5-3.5-8.5-8.5 4-4h-11.5v11.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8f7a4f168cb5e996(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0.5l-7.5 7.5h4.5v8h6v-8h4.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$64c5b51f1883c1bf(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 0l4 4-8.5 8.5 3.5 3.5 8.5-8.5 4 4v-11.5h-11.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3d4c636348b5e41f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 8l-7.5-7.5v4.5h-8v6h8v4.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f54144ac5d2cedd0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4.5l-4 4-8.5-8.5-3.5 3.5 8.5 8.5-4 4h11.5v-11.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$872f3b83fc9d1aed(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15.5l7.5-7.5h-4.5v-8h-6v8h-4.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a8bfdb7d76aeea0a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 16l-4-4 8.5-8.5-3.5-3.5-8.5 8.5-4-4v11.5h11.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8358b553276a14f8(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.5 8l7.5 7.5v-4.5h8v-6h-8v-4.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f1b70ccd8b802d28(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 12.293l-8.293-8.293h3.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-6c-0.404 0-0.769 0.244-0.924 0.617-0.051 0.124-0.076 0.254-0.076 0.383h-0.001v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-3.586l8.293 8.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.39 0.391-1.024 0-1.414z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f3810c5b6d47bd28(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 6.293l-5-5c-0.39-0.391-1.024-0.391-1.414 0l-5 5c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l3.293-3.293v9.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-9.586l3.293 3.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.391 0.391-1.024 0-1.414z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$24e12c8c690087d8(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.707 13.707l8.293-8.293v3.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.404-0.244-0.769-0.617-0.924-0.124-0.051-0.254-0.076-0.383-0.076v-0.001h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h3.586l-8.293 8.293c-0.195 0.195-0.293 0.451-0.293 0.707s0.098 0.512 0.293 0.707c0.39 0.391 1.024 0.391 1.414 0z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9fd723aef10e0db7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707l5-5c0.391-0.39 0.391-1.024 0-1.414l-5-5c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l3.293 3.293h-9.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h9.586l-3.293 3.293c-0.195 0.195-0.293 0.451-0.293 0.707s0.098 0.512 0.293 0.707c0.391 0.391 1.024 0.391 1.414 0z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b8725b1b56a92e8f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.293 3.707l8.293 8.293h-3.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h6c0.404 0 0.769-0.244 0.924-0.617 0.051-0.124 0.076-0.254 0.076-0.383h0.001v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v3.586l-8.293-8.293c-0.195-0.195-0.451-0.293-0.707-0.293s-0.512 0.098-0.707 0.293c-0.391 0.39-0.391 1.024 0 1.414z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a0fe7519466001db(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 9.707l-5 5c-0.39 0.391-1.024 0.391-1.414 0l-5-5c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l3.293 3.293v-9.586c0-0.552 0.448-1 1-1s1 0.448 1 1v9.586l3.293-3.293c0.195-0.195 0.451-0.293 0.707-0.293s0.512 0.098 0.707 0.293c0.391 0.391 0.391 1.024 0 1.414z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f72745e2cb35b186(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.293 2.293l-8.293 8.293v-3.586c0-0.552-0.448-1-1-1s-1 0.448-1 1v6c0 0.404 0.244 0.769 0.617 0.924 0.124 0.051 0.254 0.076 0.383 0.076v0.001l6-0c0.552 0 1-0.448 1-1s-0.448-1-1-1h-3.586l8.293-8.293c0.195-0.195 0.293-0.451 0.293-0.707s-0.098-0.512-0.293-0.707c-0.39-0.391-1.024-0.391-1.414 0v0z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5c52d1f564a178cb(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.293 13.707l-5-5c-0.391-0.39-0.391-1.024 0-1.414l5-5c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-3.293 3.293h9.586c0.552 0 1 0.448 1 1s-0.448 1-1 1h-9.586l3.293 3.293c0.195 0.195 0.293 0.451 0.293 0.707s-0.098 0.512-0.293 0.707c-0.391 0.391-1.024 0.391-1.414 0z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a334aeb67c111d7f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zM14.5 8c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.043 10.457l1.414-1.414-4.457-4.457-4.457 4.457 1.414 1.414 3.043-3.043z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a5c1fbc33370bcff(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.543 11.043l1.414 1.414 4.457-4.457-4.457-4.457-1.414 1.414 3.043 3.043z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$fdc77a934edd78ab(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8 3.582 8 8 8 8-3.582 8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.957 5.543l-1.414 1.414 4.457 4.457 4.457-4.457-1.414-1.414-3.043 3.043z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$cd314ffd6725c017(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.457 4.957l-1.414-1.414-4.457 4.457 4.457 4.457 1.414-1.414-3.043-3.043z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$11747b38353b58d0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0h1v8h-1v-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8h1v8h-1v-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h11v2h-11v2.5l-3.5-3.5 3.5-3.5v2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5h-11v-2h11v-2.5l3.5 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$fc2a4e90f670c3ca(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8v6h1v-6h2.5l-3-3-3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6.5h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 7h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 7h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 4.5h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11v3h-3v-3h3zM6 10h-5v5h5v-5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$244feac4d9c68565(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11v-6h-1v6h-2.5l3 3 3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4v3h-3v-3h3zM6 3h-5v5h5v-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 10h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13.5h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 14h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 14h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11.5h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12h1v1.5h-1v-1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ad1145b970cde6cc(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 16h-4c-0.184 0-0.354-0.101-0.441-0.264s-0.077-0.36 0.025-0.513l3.482-5.223h-3.066c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.184 0 0.354 0.101 0.441 0.264s0.077 0.36-0.025 0.513l-3.482 5.223h3.066c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.947 6.276l-3-6c-0.085-0.169-0.258-0.276-0.447-0.276s-0.363 0.107-0.447 0.276l-3 6c-0.123 0.247-0.023 0.547 0.224 0.671 0.072 0.036 0.148 0.053 0.223 0.053 0.183 0 0.36-0.101 0.448-0.277l0.862-1.724h3.382l0.862 1.724c0.123 0.247 0.424 0.347 0.671 0.224s0.347-0.424 0.224-0.671zM11.309 4l1.191-2.382 1.191 2.382h-2.382z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a62f23cbbab05e5d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 7h-4c-0.184 0-0.354-0.101-0.441-0.264s-0.077-0.36 0.025-0.513l3.482-5.223h-3.066c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.184 0 0.354 0.102 0.441 0.264s0.077 0.36-0.025 0.513l-3.482 5.223h3.066c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.947 15.276l-3-6c-0.085-0.169-0.258-0.276-0.447-0.276s-0.363 0.107-0.447 0.276l-3 6c-0.123 0.247-0.023 0.547 0.224 0.671 0.072 0.036 0.148 0.053 0.223 0.053 0.183 0 0.36-0.101 0.448-0.277l0.862-1.724h3.382l0.862 1.724c0.123 0.247 0.424 0.347 0.671 0.224s0.347-0.424 0.224-0.671zM11.309 13l1.191-2.382 1.191 2.382h-2.382z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$fce257bf423de1ef(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 7c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v6c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 9h-3c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2.5v2h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM12 10h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3228848ad7131b2c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 16c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v6c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-3c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2.5v2h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM12 1h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ce2a0ad12f7222a4(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h9v2h-9v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h7v2h-7v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3h5v2h-5v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 0h3v2h-3v-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ab0833ed3b310b61(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 0h9v2h-9v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3h7v2h-7v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h5v2h-5v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h3v2h-3v-2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$23cb5a87d5d53a49(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 14c-1.379 0-2.5-1.121-2.5-2.5v-1.5h-2v1.5c0 1.379-1.122 2.5-2.5 2.5s-2.5-1.121-2.5-2.5 1.122-2.5 2.5-2.5h1.5v-2h-1.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5v1.5h2v-1.5c0-1.378 1.121-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5h-1.5v2h1.5c1.379 0 2.5 1.121 2.5 2.5s-1.121 2.5-2.5 2.5zM10 10v1.5c0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5-0.673-1.5-1.5-1.5h-1.5zM4.5 10c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5v-1.5h-1.5zM7 9h2v-2h-2v2zM10 6h1.5c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5-1.5 0.673-1.5 1.5v1.5zM4.5 3c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5h1.5v-1.5c0-0.827-0.673-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e75c97eea0733538(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 14h-5c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-2c-0.202 0-0.385-0.122-0.462-0.309s-0.035-0.402 0.108-0.545l5-5c0.195-0.195 0.512-0.195 0.707 0l5 5c0.143 0.143 0.186 0.358 0.108 0.545s-0.26 0.309-0.462 0.309h-2v5.5c0 0.276-0.224 0.5-0.5 0.5zM6 13h4v-5.5c0-0.276 0.224-0.5 0.5-0.5h1.293l-3.793-3.793-3.793 3.793h1.293c0.276 0 0.5 0.224 0.5 0.5v5.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c591921bc57cccf0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7c-0.139 0-0.278-0.058-0.377-0.171l-3.124-3.57-3.124 3.57c-0.182 0.208-0.498 0.229-0.706 0.047s-0.229-0.498-0.047-0.706l3.5-4c0.095-0.108 0.232-0.171 0.376-0.171s0.281 0.062 0.376 0.171l3.5 4c0.182 0.208 0.161 0.524-0.047 0.706-0.095 0.083-0.212 0.124-0.329 0.124z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$726d36eb1da50f04(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 13h-4c-0.198 0-0.377-0.116-0.457-0.297l-3.868-8.703h-4.675c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.198 0 0.377 0.116 0.457 0.297l3.868 8.703h3.675c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 4h-5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$865b1c9a6c4fa149(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM7 12.414l-3.707-3.707 1.414-1.414 2.293 2.293 4.793-4.793 1.414 1.414-6.207 6.207z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e051eed3d9531a8a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM14 14h-12v-12h12v12z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$289f64670ab039d9(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM5 8c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$169afeb214e5e972(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 10c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ff65aa50df41ef9d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1573cf087b71c4a9(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4l3-3-1-1-3 3h-7v-3h-2v3h-3v2h3v8h8v3h2v-3h3v-2h-3v-7zM5 5h5l-5 5v-5zM6 11l5-5v5h-5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3368f2e4a51d3c81(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1zM11 3h2v2h-2v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM5 13h-2v-2h2v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h-1c-1.336 0-2.591-0.52-3.536-1.464s-1.464-2.2-1.464-3.536v-1c0-1.1-0.9-2-2-2h-4c-1.1 0-2 0.9-2 2v4c0 1.1 0.9 2 2 2h1c1.336 0 2.591 0.52 3.536 1.464s1.464 2.2 1.464 3.536v1c0 1.1 0.9 2 2 2h4c1.1 0 2-0.9 2-2v-4c0-1.1-0.9-2-2-2zM15 14c0 0.265-0.105 0.515-0.295 0.705s-0.44 0.295-0.705 0.295h-4c-0.265 0-0.515-0.105-0.705-0.295s-0.295-0.44-0.295-0.705v-1c0-3.314-2.686-6-6-6h-1c-0.265 0-0.515-0.105-0.705-0.295s-0.295-0.441-0.295-0.705v-4c0-0.265 0.105-0.515 0.295-0.705s0.44-0.295 0.705-0.295h4c0.265 0 0.515 0.105 0.705 0.295s0.295 0.44 0.295 0.705v1c0 3.314 2.686 6 6 6h1c0.265 0 0.515 0.105 0.705 0.295s0.295 0.44 0.295 0.705v4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$298d76adc8e3d6eb(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.413 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.337-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.412 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.338-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.413 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.337-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.412 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.338-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.251 2.5l1.749-1.749v-0.751h-0.751l-1.749 1.749-1.749-1.749h-0.751v0.751l1.749 1.749-1.749 1.749v0.751h0.751l1.749-1.749 1.749 1.749h0.751v-0.751z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 9h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 15h2v1h-2v-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5ed74863527a472b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.279 10.62c-1.042-1.628-2.829-2.345-3.992-1.601-0.1 0.064-0.193 0.138-0.277 0.218l-1.241-1.942 2.867-4.5c0.235-0.433 0.321-0.949 0.207-1.468-0.109-0.496-0.383-0.913-0.752-1.207l-0.192-0.122-3.398 5.314-3.398-5.314-0.192 0.122c-0.369 0.294-0.643 0.711-0.752 1.207-0.114 0.519-0.027 1.035 0.207 1.468l2.867 4.5-1.241 1.942c-0.085-0.081-0.177-0.154-0.277-0.218-1.163-0.744-2.95-0.028-3.992 1.601s-0.944 3.551 0.219 4.296c1.163 0.744 2.95 0.028 3.992-1.601l2.567-4.029 2.567 4.029c1.042 1.628 2.829 2.345 3.992 1.601s1.261-2.667 0.219-4.296zM3.67 12.507c-0.469 0.733-1.071 1.089-1.478 1.179-0 0-0 0-0 0-0.133 0.029-0.317 0.047-0.443-0.033-0.139-0.089-0.231-0.324-0.247-0.629-0.025-0.494 0.151-1.076 0.483-1.594 0.469-0.733 1.071-1.089 1.478-1.179 0.133-0.029 0.317-0.047 0.443 0.033 0.139 0.089 0.231 0.324 0.247 0.629 0.025 0.495-0.151 1.076-0.483 1.594zM7.5 8c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM13.498 13.023c-0.016 0.305-0.108 0.54-0.247 0.629-0.125 0.080-0.31 0.062-0.443 0.033 0 0 0 0-0 0-0.407-0.089-1.009-0.446-1.478-1.179-0.332-0.519-0.508-1.1-0.483-1.594 0.016-0.305 0.108-0.54 0.247-0.629 0.125-0.080 0.31-0.062 0.443-0.033 0.407 0.089 1.009 0.446 1.478 1.179 0.332 0.519 0.508 1.1 0.483 1.594z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e55db30f0979ff77(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 1.119-8 2.5v1.5l6 6v5c0 0.552 0.895 1 2 1s2-0.448 2-1v-5l6-6v-1.5c0-1.381-3.582-2.5-8-2.5zM1.475 2.169c0.374-0.213 0.9-0.416 1.52-0.586 1.374-0.376 3.152-0.583 5.005-0.583s3.631 0.207 5.005 0.583c0.62 0.17 1.146 0.372 1.52 0.586 0.247 0.141 0.38 0.26 0.442 0.331-0.062 0.071-0.195 0.19-0.442 0.331-0.374 0.213-0.9 0.416-1.52 0.586-1.374 0.376-3.152 0.583-5.005 0.583s-3.631-0.207-5.005-0.583c-0.62-0.17-1.146-0.372-1.52-0.586-0.247-0.141-0.38-0.26-0.442-0.331 0.062-0.071 0.195-0.19 0.442-0.331z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$56613b048fb122f2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.494 0.253c-1.414 0-2.322-0.253-3.779-0.253-4.708 0-6.903 2.681-6.903 5.404 0 1.604 0.76 2.132 2.259 2.132-0.106-0.232-0.296-0.486-0.296-1.626 0-3.188 1.203-4.117 2.744-4.18 0 0-1.264 12.396-4.934 13.883v0.385h4.947l1.688-8h3.091l0.689-2h-3.358l0.812-3.847c0.929 0.19 1.837 0.38 2.618 0.38 0.971 0 1.858-0.296 2.343-2.533-0.591 0.19-1.224 0.253-1.921 0.253z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2e345d2c388d82a9(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.622c0-0.001 0-0.001 0-0.002l-0.005-6.821-1.992 0.097h-3.936v-0.336c0-1.274 0.091-2.546 0.269-3.042 0.123-0.343 0.353-0.652 0.683-0.919 0.322-0.261 0.643-0.393 0.955-0.393 0.262 0 0.48 0.045 0.647 0.134 0.235 0.134 0.464 0.359 0.682 0.669 0.577 0.82 0.812 1.038 0.939 1.131 0.216 0.158 0.477 0.238 0.776 0.238 0.292 0 0.546-0.109 0.757-0.324 0.209-0.213 0.315-0.479 0.315-0.792 0-0.335-0.139-0.691-0.414-1.057-0.268-0.358-0.683-0.652-1.232-0.875-0.536-0.218-1.14-0.329-1.793-0.329-0.949 0-1.813 0.228-2.568 0.678-0.757 0.451-1.337 1.077-1.725 1.863-0.359 0.728-0.333 2.105-0.355 3.355h-1.965v1.116h1.962v5.073c0 1.12-0.342 1.422-0.472 1.583-0.179 0.222-0.509 0.455-0.944 0.455h-0.604v0.878h6.021v-0.878h-0.105c-1.424 0-1.828-0.154-1.828-1.888 0-0 0-0.001 0-0.001l-0.001-5.222h2.191c1.163 0 1.43 0.054 1.491 0.077 0.074 0.028 0.169 0.075 0.204 0.143 0.014 0.026 0.081 0.391 0.081 1.296v3.917c0 0.913-0.111 1.217-0.179 1.319-0.145 0.222-0.319 0.345-0.854 0.358v0.879h4.588v-0.873c-1.431 0-1.588-0.153-1.588-1.505z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d4accc3ecb362ea2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.364 14.335c-0.183 0-1.307-0.206-1.375-0.458-0.161-0.619-0.183-1.284-0.183-2.040v-8.453c0-1.261 0.252-1.994 0.252-1.994-0.023-0.115-0.138-0.367-0.275-0.367h-0.069c-0.069 0-0.871 0.504-1.605 0.504-0.596-0-0.967-0.527-1.655-0.527-2.892 0-4.249 2.349-4.249 5.672v0.173c0 0.069-0.046 0.138-0.115 0.138h-0.94c-0.115 0-0.344 0.642-0.344 0.94 0 0.092 0.023 0.137 0.069 0.137h1.215c0.069 0 0.115 0.092 0.115 0.16 0 2.040-0.023 4.052-0.023 4.052 0 0.321-0.023 1.031-0.16 1.605-0.069 0.252-1.123 0.458-1.398 0.458-0.115 0-0.115 0.55 0 0.665 0.94-0.046 1.559-0.115 2.499-0.115 0.871 0 1.536 0.069 2.453 0.115 0.046-0.138 0.046-0.665-0.069-0.665-0.183 0-1.307-0.206-1.375-0.458-0.16-0.619-0.16-1.284-0.183-2.040v-3.639c0-0.069 0.069-0.138 0.138-0.138h2.361c0.16-0.321 0.275-0.711 0.275-0.917 0-0.138 0-0.16-0.115-0.16h-2.544c-0.046 0-0.115-0.069-0.115-0.115v-0.825c0-2.040 0.836-3.837 2.234-3.837 0.99 0 1.854 0.642 1.854 3.093 0 0 0 0 0 0 0.003 0.063 0.005 0.114 0.005 0.148v6.825c0 0.321-0.023 1.031-0.16 1.605-0.069 0.252-1.123 0.458-1.398 0.458-0.115 0-0.115 0.55 0 0.665 0.94-0.046 1.559-0.115 2.499-0.115 0.871 0 1.536 0.069 2.453 0.115 0.046-0.137 0.046-0.665-0.069-0.665z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$12e0a5c61be63dd5(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12h2l-2.5 3-2.5-3h2v-8h-2l2.5-3 2.5 3h-2zM10 1v4l-1-2h-3v11h2v1h-6v-1h2v-11h-3l-1 2v-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$907e55ef614793b8(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14v2l-3-2.5 3-2.5v2h8v-2l3 2.5-3 2.5v-2zM13 1v4l-1-2h-3v7h2v1h-6v-1h2v-7h-3l-1 2v-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5df180e59b594bff(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8h6v2h-2v6h-2v-6h-2zM15 4h-3.934v12h-2.133v-12h-3.934v-2h10z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ab75f61ff38b258d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.061 7.573c0.586-0.696 0.939-1.594 0.939-2.573 0-2.206-1.794-4-4-4h-5v14h6c2.206 0 4-1.794 4-4 0-1.452-0.778-2.726-1.939-3.427zM6 3h1.586c0.874 0 1.586 0.897 1.586 2s-0.711 2-1.586 2h-1.586v-4zM8.484 13h-2.484v-4h2.484c0.913 0 1.656 0.897 1.656 2s-0.743 2-1.656 2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$bb6d364eb8d87ed7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1h2v6.5c0 2.485-2.239 4.5-5 4.5s-5-2.015-5-4.5v-6.5h2v6.5c0 0.628 0.285 1.23 0.802 1.695 0.577 0.519 1.357 0.805 2.198 0.805s1.621-0.286 2.198-0.805c0.517-0.466 0.802-1.068 0.802-1.695v-6.5zM3 13h10v2h-10z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a1671b6e3e683931(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1v1h-2l-5 12h2v1h-7v-1h2l5-12h-2v-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c0f93cd664a78cca(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v1h-3.664c0.43 0.602 0.664 1.292 0.664 2 0 1.107-0.573 2.172-1.572 2.921-0.927 0.696-2.145 1.079-3.428 1.079s-2.501-0.383-3.428-1.079c-0.999-0.749-1.572-1.814-1.572-2.921h2c0 1.084 1.374 2 3 2s3-0.916 3-2c0-1.084-1.374-2-3-2h-8v-1h4.68c-0.037-0.026-0.073-0.052-0.108-0.079-0.999-0.749-1.572-1.814-1.572-2.921s0.573-2.172 1.572-2.921c0.927-0.696 2.145-1.079 3.428-1.079s2.501 0.383 3.428 1.079c0.999 0.749 1.572 1.814 1.572 2.921h-2c0-1.084-1.374-2-3-2s-3 0.916-3 2c0 1.084 1.374 2 3 2 1.234 0 2.407 0.354 3.32 1h4.68z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$db7bf3962a401bac(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h4l1-2v4h-6v-3.347c2.049-0.883 3.5-3.081 3.5-5.653 0-3.35-2.462-5.973-5.5-5.973s-5.5 2.622-5.5 5.973c0 2.572 1.451 4.77 3.5 5.653v3.347h-6v-4l1 2h4v-0.509c-2.932-1.038-5-3.553-5-6.491 0-3.866 3.582-7 8-7s8 3.134 8 7c0 2.938-2.068 5.452-5 6.491v0.509z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5eaa4afeb49b718a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.713 11.48l0.694-1.48h0.594l-1 6h-15v-1.16l5.18-6.113-5.18-5.18v-3.547h15.313l0.688 4h-0.537l-0.293-0.607c-0.552-1.146-0.967-1.393-2.17-1.393h-10.344l5.517 5.516-4.647 5.483h8.474c1.813 0 2.291-0.65 2.713-1.52z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$913022dab8010908(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8h2v1h-2zM3 8h3v1h-3zM7 8h2v1h-2zM10 8h3v1h-3zM14 8h2v1h-2zM13.75 0l0.25 7h-12l0.25-7h0.5l0.25 6h10l0.25-6zM2.25 16l-0.25-6h12l-0.25 6h-0.5l-0.25-5h-10l-0.25 5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4755523a996461dd(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM10.563 4h-2.125l-2.938 2.938-2.938-2.938h-2.125l4 4-4 4h2.125l2.938-2.938 2.938 2.938h2.125l-4-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$24c6eeb69cb472f2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM10.563 4h-2.125l-2.938 2.938-2.938-2.938h-2.125l4 4-4 4h2.125l2.938-2.938 2.938 2.938h2.125l-4-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4af858d938072ea7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM5.432 5h1.137l0.9 3h-2.937l0.9-3zM11 13l2.5-4 2.5 4h-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 2h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.827 0-1.5 0.673-1.5 1.5 0 0.384 0.145 0.734 0.383 1 0.275 0.307 0.674 0.5 1.117 0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.827 0 1.5-0.673 1.5-1.5 0-0.384-0.145-0.734-0.383-1-0.275-0.307-0.674-0.5-1.117-0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$bdcc2427a87a4937(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM5.432 5h1.137l0.9 3h-2.937l0.9-3zM16 3l-2.5 4-2.5-4h5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 13h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.827 0-1.5 0.673-1.5 1.5 0 0.384 0.145 0.734 0.383 1 0.275 0.307 0.674 0.5 1.117 0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.827 0 1.5-0.673 1.5-1.5 0-0.384-0.145-0.734-0.383-1-0.275-0.307-0.674-0.5-1.117-0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5b5fbaf8b135f6ad(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM7.432 5h1.137l0.9 3h-2.937l0.9-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2594ea5079797378(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6v-6h12v6h-1v-5h-10v5zM16 9v7h-12v-7h1v6h10v-6zM8 7h2v1h-2zM5 7h2v1h-2zM11 7h2v1h-2zM14 7h2v1h-2zM0 4.5l3 3-3 3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$48bcf561800c511a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 14h9v2h-9zM14 2h-4.727l-2.871 11h-2.067l2.871-11h-4.205v-2h11zM14.528 16l-2.028-2.028-2.028 2.028-0.972-0.972 2.028-2.028-2.028-2.028 0.972-0.972 2.028 2.028 2.028-2.028 0.972 0.972-2.028 2.028 2.028 2.028z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9b493477a0840a3e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3v11h16v-11h-16zM6 10v-2h4v2h-4zM10 11v2h-4v-2h4zM10 5v2h-4v-2h4zM5 5v2h-4v-2h4zM1 8h4v2h-4v-2zM11 8h4v2h-4v-2zM11 7v-2h4v2h-4zM1 11h4v2h-4v-2zM11 13v-2h4v2h-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$53441b1368332b20(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1v14h16v-14h-16zM6 10v-3h4v3h-4zM10 11v3h-4v-3h4zM10 3v3h-4v-3h4zM5 3v3h-4v-3h4zM1 7h4v3h-4v-3zM11 7h4v3h-4v-3zM11 6v-3h4v3h-4zM1 11h4v3h-4v-3zM11 14v-3h4v3h-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$32b06cf0d47a877a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3h2v1h-2zM9 3h2v1h-2zM14 3v4h-3v-1h2v-2h-1v-1zM5 6h2v1h-2zM8 6h2v1h-2zM3 4v2h1v1h-2v-4h3v1zM6 9h2v1h-2zM9 9h2v1h-2zM14 9v4h-3v-1h2v-2h-1v-1zM5 12h2v1h-2zM8 12h2v1h-2zM3 10v2h1v1h-2v-4h3v1zM15 1h-14v14h14v-14zM16 0v0 16h-16v-16h16z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5bb11ae06243ef27(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0h8v2h-2v14h-2v-14h-2v14h-2v-8c-2.209 0-4-1.791-4-4s1.791-4 4-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6f61f3712ab2f6a0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-2.209 0-4 1.791-4 4s1.791 4 4 4v8h2v-14h2v14h2v-14h2v-2h-8zM0 11l4-4-4-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$fb12711f972e9742(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0c-2.209 0-4 1.791-4 4s1.791 4 4 4v8h2v-14h2v14h2v-14h2v-2h-8zM16 3l-4 4 4 4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b434ffc621fa30a2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.749 16c-0.771 0-1.424-0.225-1.939-0.669-0.519-0.447-0.782-0.969-0.782-1.552 0-0.283 0.103-0.527 0.307-0.726 0.207-0.202 0.465-0.309 0.748-0.309 0.281 0 0.534 0.1 0.732 0.29 0.195 0.187 0.294 0.435 0.294 0.736 0 0.177-0.029 0.372-0.086 0.58-0.056 0.206-0.068 0.312-0.068 0.364 0 0.058 0.014 0.126 0.121 0.199 0.199 0.138 0.439 0.204 0.732 0.204 0.353 0 0.667-0.123 0.962-0.375 0.29-0.249 0.431-0.505 0.431-0.782 0-0.308-0.082-0.575-0.252-0.816-0.287-0.402-0.826-0.874-1.603-1.401-1.248-0.835-2.079-1.559-2.54-2.211-0.358-0.511-0.539-1.061-0.539-1.636 0-0.579 0.19-1.155 0.564-1.713 0.32-0.477 0.794-0.908 1.41-1.283-0.33-0.355-0.577-0.689-0.736-0.995-0.201-0.387-0.303-0.787-0.303-1.189 0-0.747 0.295-1.393 0.878-1.92s1.31-0.795 2.161-0.795c0.783 0 1.441 0.22 1.956 0.654 0.521 0.439 0.785 0.952 0.785 1.524 0 0.292-0.109 0.553-0.324 0.776l-0.004 0.004c-0.125 0.124-0.353 0.271-0.735 0.271-0.299 0-0.561-0.098-0.758-0.283-0.196-0.184-0.296-0.405-0.296-0.656 0-0.108 0.027-0.272 0.084-0.515 0.028-0.115 0.042-0.221 0.042-0.316 0-0.162-0.058-0.285-0.183-0.39-0.129-0.108-0.314-0.161-0.565-0.161-0.389 0-0.708 0.118-0.975 0.361s-0.399 0.533-0.399 0.883c0 0.315 0.071 0.574 0.212 0.771 0.267 0.374 0.731 0.778 1.378 1.201 1.315 0.853 2.233 1.636 2.727 2.325 0.365 0.518 0.549 1.068 0.549 1.637 0 0.572-0.186 1.148-0.552 1.714-0.316 0.487-0.793 0.926-1.42 1.308 0.347 0.367 0.591 0.688 0.743 0.977 0.189 0.359 0.284 0.751 0.284 1.165 0 0.776-0.296 1.435-0.879 1.96s-1.31 0.79-2.161 0.79zM6.975 5.568c-0.753 0.452-1.12 0.972-1.12 1.583 0 0.356 0.102 0.674 0.31 0.973 0.311 0.436 0.926 0.97 1.825 1.583 0.381 0.259 0.724 0.511 1.025 0.751 0.767-0.461 1.14-0.974 1.14-1.565 0-0.322-0.127-0.668-0.378-1.030-0.263-0.378-0.826-0.872-1.674-1.467-0.443-0.306-0.821-0.583-1.128-0.827z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1f2d5c5bbe31764d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM0 4h10v2h-10zM0 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2e96ff72b95fbb97(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM3 4h10v2h-10zM3 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$edcf1723833ff6e5(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b2b44be13bf285e6(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM0 4h16v2h-16zM0 7h16v2h-16zM0 10h16v2h-16zM0 13h16v2h-16z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e7c13500f876d631(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 7h10v2h-10zM6 10h10v2h-10zM0 13h16v2h-16zM0 11v-6l4 3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$64c6eb3a28d0de2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 7h10v2h-10zM6 10h10v2h-10zM0 13h16v2h-16zM4 5v6l-4-3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$46c9db7e26019909(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10c0 0 0.919-3 6-3v3l6-4-6-4v3c-4 0-6 2.495-6 5zM11 12h-9v-6h1.967c0.158-0.186 0.327-0.365 0.508-0.534 0.687-0.644 1.509-1.135 2.439-1.466h-6.914v10h13v-4.197l-2 1.333v0.864z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d7f5753c46f32213(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 1v12h12v-12h-12zM14 12h-10v-10h10v10zM2 14v-10.5l-1-1v12.5h12.5l-1-1h-10.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5v-6.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ff246678ade8f124(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3358a1651a0cc4c2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 20 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.958 2.352l1.085 0.296-3 11-1.085-0.296 3-11z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c41dde5332f7e2e1(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1v14h16v-14h-16zM15 14h-14v-12h14v12zM14 3h-12v10h12v-10zM7 8h-1v1h-1v1h-1v-1h1v-1h1v-1h-1v-1h-1v-1h1v1h1v1h1v1zM11 10h-3v-1h3v1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9f88818dab6ceca5(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 11c-0.706 0-1.342 0.293-1.797 0.763l-6.734-3.367c0.021-0.129 0.032-0.261 0.032-0.396s-0.011-0.267-0.032-0.396l6.734-3.367c0.455 0.47 1.091 0.763 1.797 0.763 1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5-2.5 1.119-2.5 2.5c0 0.135 0.011 0.267 0.031 0.396l-6.734 3.367c-0.455-0.47-1.091-0.763-1.797-0.763-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5c0.706 0 1.343-0.293 1.797-0.763l6.734 3.367c-0.021 0.129-0.031 0.261-0.031 0.396 0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5c0-1.381-1.119-2.5-2.5-2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3e16a98f29d4ffdb(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.467 1.2 2.667 2.667 2.667h10.666c1.468 0 2.667-1.2 2.667-2.667v-10.666c0-1.467-1.199-2.667-2.667-2.667zM4 4h8c0.143 0 0.281 0.031 0.409 0.088l-4.409 5.143-4.409-5.143c0.127-0.058 0.266-0.088 0.409-0.088zM3 11v-6c0-0.021 0.001-0.042 0.002-0.063l2.932 3.421-2.9 2.9c-0.023-0.083-0.034-0.17-0.034-0.258zM12 12h-8c-0.088 0-0.175-0.012-0.258-0.034l2.846-2.846 1.413 1.648 1.413-1.648 2.846 2.846c-0.083 0.023-0.17 0.034-0.258 0.034zM13 11c0 0.088-0.012 0.175-0.034 0.258l-2.9-2.9 2.932-3.421c0.001 0.021 0.002 0.042 0.002 0.063v6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$82af9819fd2934be(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.468 1.2 2.667 2.667 2.667h10.666c1.467 0 2.667-1.199 2.667-2.667v-10.666c0-1.467-1.2-2.667-2.667-2.667zM13.333 2c0.125 0 0.243 0.036 0.344 0.099l-5.678 4.694-5.677-4.694c0.101-0.063 0.219-0.099 0.344-0.099h10.666zM2.667 14c-0.030 0-0.060-0.002-0.089-0.006l3.525-4.89-0.457-0.457-3.646 3.646v-9.549l6 7.256 6-7.256v9.549l-3.646-3.646-0.457 0.457 3.525 4.89c-0.029 0.004-0.059 0.006-0.088 0.006h-10.666z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3407078776845922(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.468 1.2 2.667 2.667 2.667h10.666c1.467 0 2.667-1.199 2.667-2.667v-10.666c0-1.467-1.2-2.667-2.667-2.667zM2.854 13.854l-1.207-1.207 4-4 0.457 0.457-3.25 4.75zM2.396 3.104l0.457-0.457 5.146 4.146 5.146-4.146 0.457 0.457-5.604 6.604-5.604-6.604zM13.146 13.854l-3.25-4.75 0.457-0.457 4 4-1.207 1.207z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5ebaa4982d8c1876(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4 4h8c0.143 0 0.281 0.031 0.409 0.088l-4.409 5.143-4.409-5.143c0.127-0.058 0.266-0.088 0.409-0.088zM3 11v-6c0-0.021 0.001-0.042 0.002-0.063l2.932 3.421-2.9 2.9c-0.023-0.083-0.034-0.17-0.034-0.258zM12 12h-8c-0.088 0-0.175-0.012-0.258-0.034l2.846-2.846 1.413 1.648 1.413-1.648 2.846 2.846c-0.083 0.023-0.17 0.034-0.258 0.034zM13 11c0 0.088-0.012 0.175-0.034 0.258l-2.9-2.9 2.932-3.421c0.001 0.021 0.002 0.042 0.002 0.063v6z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$520c2acd34350c9(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.463 13.831c-1.753 1.294-4.291 1.981-6.478 1.981-3.066 0-5.825-1.131-7.912-3.019-0.163-0.147-0.019-0.35 0.178-0.234 2.253 1.313 5.041 2.1 7.919 2.1 1.941 0 4.075-0.403 6.041-1.238 0.294-0.125 0.544 0.197 0.253 0.409z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.191 13c-0.225-0.287-1.481-0.137-2.047-0.069-0.172 0.019-0.197-0.128-0.044-0.238 1.003-0.703 2.647-0.5 2.838-0.266 0.194 0.238-0.050 1.884-0.991 2.672-0.144 0.122-0.281 0.056-0.219-0.103 0.216-0.528 0.688-1.709 0.463-1.997z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.053 11.838l0.003 0.003c0.387-0.341 1.084-0.95 1.478-1.278 0.156-0.125 0.128-0.334 0.006-0.509-0.353-0.488-0.728-0.884-0.728-1.784v-3c0-1.272 0.088-2.438-0.847-3.313-0.738-0.706-1.963-0.956-2.9-0.956-1.831 0-3.875 0.684-4.303 2.947-0.047 0.241 0.131 0.369 0.287 0.403l1.866 0.203c0.175-0.009 0.3-0.181 0.334-0.356 0.159-0.778 0.813-1.156 1.547-1.156 0.397 0 0.847 0.144 1.081 0.5 0.269 0.397 0.234 0.938 0.234 1.397v0.25c-1.116 0.125-2.575 0.206-3.619 0.666-1.206 0.522-2.053 1.584-2.053 3.147 0 2 1.259 3 2.881 3 1.369 0 2.116-0.322 3.172-1.403 0.35 0.506 0.463 0.753 1.103 1.284 0.147 0.078 0.328 0.072 0.456-0.044zM9.113 7.144c0 0.75 0.019 1.375-0.359 2.041-0.306 0.544-0.791 0.875-1.331 0.875-0.737 0-1.169-0.563-1.169-1.394 0-1.641 1.472-1.938 2.863-1.938v0.416z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f551dc8279320aee(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.159 6.856v2.744h4.537c-0.184 1.178-1.372 3.45-4.537 3.45-2.731 0-4.959-2.262-4.959-5.050s2.228-5.050 4.959-5.050c1.553 0 2.594 0.663 3.188 1.234l2.172-2.091c-1.394-1.306-3.2-2.094-5.359-2.094-4.422 0-8 3.578-8 8s3.578 8 8 8c4.616 0 7.681-3.247 7.681-7.816 0-0.525-0.056-0.925-0.125-1.325l-7.556-0.003z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b354464be7eb2231(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975 0.591 4.019 1.569l-1.628 1.569c-0.447-0.428-1.225-0.925-2.391-0.925-2.050 0-3.719 1.697-3.719 3.787s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588h-3.403v-2.056h5.666c0.050 0.3 0.094 0.6 0.094 0.994 0.003 3.428-2.294 5.863-5.759 5.863z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$982f0851f16c952a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975 0.591 4.019 1.569l-1.628 1.569c-0.447-0.428-1.225-0.925-2.391-0.925-2.050 0-3.719 1.697-3.719 3.787s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588h-3.403v-2.056h5.666c0.050 0.3 0.094 0.6 0.094 0.994 0.003 3.428-2.294 5.863-5.759 5.863z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6c72b0aeec8f37bc(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.091 7.147v1.747h2.888c-0.116 0.75-0.872 2.197-2.888 2.197-1.737 0-3.156-1.441-3.156-3.216s1.419-3.216 3.156-3.216c0.991 0 1.65 0.422 2.028 0.784l1.381-1.331c-0.888-0.828-2.037-1.331-3.409-1.331-2.816 0.003-5.091 2.278-5.091 5.094s2.275 5.091 5.091 5.091c2.937 0 4.888-2.066 4.888-4.975 0-0.334-0.037-0.591-0.081-0.844h-4.806z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h-1.5v-1.5h-1.5v1.5h-1.5v1.5h1.5v1.5h1.5v-1.5h1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$cdac5131631c1674(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984 0.394 2.681 1.047l-1.088 1.044c-0.297-0.284-0.816-0.616-1.594-0.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725h-2.269v-1.372h3.778c0.034 0.2 0.063 0.4 0.063 0.663 0 2.287-1.531 3.909-3.841 3.909zM14 8h-1v1h-1v-1h-1v-1h1v-1h1v1h1v1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$c04c741c19843f0c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984 0.394 2.681 1.047l-1.088 1.044c-0.297-0.284-0.816-0.616-1.594-0.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725h-2.269v-1.372h3.778c0.034 0.2 0.063 0.4 0.063 0.663 0 2.287-1.531 3.909-3.841 3.909zM13 8v1h-1v-1h-1v-1h1v-1h1v1h1v1h-1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$434d3e551e590af0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.997 0c-3.816 0-6.909 3.094-6.909 6.909 0 3.616 3.294 6.547 6.909 6.547v2.544c4.197-2.128 6.916-5.556 6.916-9.091 0-3.816-3.1-6.909-6.916-6.909zM7 8c0 0.828-0.447 1.5-1 1.5v-1.5h-2v-3h3v3zM12 8c0 0.828-0.447 1.5-1 1.5v-1.5h-2v-3h3v3z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$76cfd41985a5e23e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.844 10l-2.884 5h9.072l2.884-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.506 9l-4.619-8h-5.775l4.619 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.534 2l-4.534 7.856 2.888 5 4.534-7.856z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$51a48ef9fd86a280(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 3h2.5v-3h-2.5c-1.93 0-3.5 1.57-3.5 3.5v1.5h-2v3h2v8h3v-8h2.5l0.5-3h-3v-1.5c0-0.271 0.229-0.5 0.5-0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4e0f3269f77a9a13(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h6.5v-7h-2v-2h2v-1c0-1.653 1.347-3 3-3h2v2h-2c-0.55 0-1 0.45-1 1v1h3l-0.5 2h-2.5v7h4.5c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7db69eb2630b7359(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11 2.5c0-0.275 0.225-0.5 0.5-0.5h2c0.275 0 0.5 0.225 0.5 0.5v2c0 0.275-0.225 0.5-0.5 0.5h-2c-0.275 0-0.5-0.225-0.5-0.5v-2zM8 5c1.656 0 3 1.344 3 3s-1.344 3-3 3c-1.656 0-3-1.344-3-3s1.344-3 3-3zM14 13.5v0c0 0.275-0.225 0.5-0.5 0.5h-11c-0.275 0-0.5-0.225-0.5-0.5v0-6.5h1.1c-0.066 0.322-0.1 0.656-0.1 1 0 2.762 2.237 5 5 5s5-2.238 5-5c0-0.344-0.034-0.678-0.1-1h1.1v6.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$60236dc19ba7539d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.641 2.325c-1.497-1.5-3.488-2.325-5.609-2.325-4.369 0-7.925 3.556-7.925 7.928 0 1.397 0.366 2.763 1.059 3.963l-1.125 4.109 4.203-1.103c1.159 0.631 2.463 0.966 3.787 0.966h0.003c0 0 0 0 0 0 4.369 0 7.928-3.556 7.928-7.928 0-2.119-0.825-4.109-2.322-5.609zM8.034 14.525v0c-1.184 0-2.344-0.319-3.356-0.919l-0.241-0.144-2.494 0.653 0.666-2.431-0.156-0.25c-0.663-1.047-1.009-2.259-1.009-3.506 0-3.634 2.956-6.591 6.594-6.591 1.759 0 3.416 0.688 4.659 1.931 1.244 1.247 1.928 2.9 1.928 4.662-0.003 3.637-2.959 6.594-6.591 6.594zM11.647 9.588c-0.197-0.1-1.172-0.578-1.353-0.644s-0.313-0.1-0.447 0.1c-0.131 0.197-0.512 0.644-0.628 0.778-0.116 0.131-0.231 0.15-0.428 0.050s-0.838-0.309-1.594-0.984c-0.588-0.525-0.987-1.175-1.103-1.372s-0.013-0.306 0.088-0.403c0.091-0.088 0.197-0.231 0.297-0.347s0.131-0.197 0.197-0.331c0.066-0.131 0.034-0.247-0.016-0.347s-0.447-1.075-0.609-1.472c-0.159-0.388-0.325-0.334-0.447-0.341-0.116-0.006-0.247-0.006-0.378-0.006s-0.347 0.050-0.528 0.247c-0.181 0.197-0.694 0.678-0.694 1.653s0.709 1.916 0.809 2.050c0.1 0.131 1.397 2.134 3.384 2.991 0.472 0.203 0.841 0.325 1.128 0.419 0.475 0.15 0.906 0.128 1.247 0.078 0.381-0.056 1.172-0.478 1.338-0.941s0.166-0.859 0.116-0.941c-0.047-0.088-0.178-0.137-0.378-0.238z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6dfdcd1d246c7468(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.559-8-8-8zM11.681 11.559c-0.159 0.241-0.441 0.319-0.681 0.159-1.881-1.159-4.241-1.4-7.041-0.759-0.281 0.081-0.519-0.119-0.6-0.359-0.081-0.281 0.119-0.519 0.359-0.6 3.041-0.681 5.681-0.4 7.759 0.881 0.281 0.119 0.322 0.438 0.203 0.678zM12.641 9.359c-0.2 0.281-0.559 0.4-0.841 0.2-2.159-1.319-5.441-1.719-7.959-0.919-0.319 0.081-0.681-0.081-0.759-0.4-0.081-0.319 0.081-0.681 0.4-0.759 2.919-0.881 6.519-0.441 9 1.081 0.238 0.119 0.359 0.519 0.159 0.797zM12.719 7.119c-2.559-1.519-6.841-1.681-9.281-0.919-0.4 0.119-0.8-0.119-0.919-0.481-0.119-0.4 0.119-0.8 0.481-0.919 2.841-0.841 7.519-0.681 10.481 1.081 0.359 0.2 0.481 0.681 0.281 1.041-0.203 0.278-0.681 0.397-1.044 0.197z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$f6f96bc0b9b71af8(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM11.931 5.484l-1.313 6.184c-0.091 0.441-0.356 0.544-0.725 0.341l-2-1.478-0.959 0.934c-0.112 0.109-0.2 0.2-0.4 0.2-0.259 0-0.216-0.097-0.303-0.344l-0.681-2.237-1.978-0.616c-0.428-0.131-0.431-0.425 0.097-0.634l7.706-2.975c0.35-0.159 0.691 0.084 0.556 0.625z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b09d5f257beeda11(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3.538c-0.588 0.263-1.222 0.438-1.884 0.516 0.678-0.406 1.197-1.050 1.444-1.816-0.634 0.375-1.338 0.65-2.084 0.797-0.6-0.638-1.453-1.034-2.397-1.034-1.813 0-3.281 1.469-3.281 3.281 0 0.256 0.028 0.506 0.084 0.747-2.728-0.138-5.147-1.444-6.766-3.431-0.281 0.484-0.444 1.050-0.444 1.65 0 1.138 0.578 2.144 1.459 2.731-0.538-0.016-1.044-0.166-1.488-0.409 0 0.013 0 0.028 0 0.041 0 1.591 1.131 2.919 2.634 3.219-0.275 0.075-0.566 0.116-0.866 0.116-0.212 0-0.416-0.022-0.619-0.059 0.419 1.303 1.631 2.253 3.066 2.281-1.125 0.881-2.538 1.406-4.078 1.406-0.266 0-0.525-0.016-0.784-0.047 1.456 0.934 3.181 1.475 5.034 1.475 6.037 0 9.341-5.003 9.341-9.341 0-0.144-0.003-0.284-0.009-0.425 0.641-0.459 1.197-1.038 1.637-1.697z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7a6266a2ae99b840(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.012 7.953c-0.412 0.094-0.809 0.137-1.169 0.137-2.019 0-3.572-1.409-3.572-3.862 0-1.203 0.466-1.825 1.122-1.825 0.625 0 1.041 0.559 1.041 1.697 0 0.647-0.172 1.356-0.3 1.775 0 0 0.622 1.084 2.322 0.753 0.363-0.803 0.556-1.841 0.556-2.75 0-2.45-1.25-3.878-3.541-3.878-2.356 0-3.734 1.809-3.734 4.197 0 2.366 1.106 4.394 2.928 5.319-0.766 1.534-1.741 2.884-2.759 3.903-1.844-2.231-3.513-5.206-4.197-11.016h-2.722c1.259 9.675 5.006 12.756 6 13.347 0.559 0.337 1.044 0.322 1.556 0.031 0.806-0.456 3.222-2.875 4.563-5.703 0.563 0 1.238-0.066 1.909-0.219v-1.906z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4439cd9244f434bc(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM12.959 11.2l-1.463 0.022c0 0-0.316 0.063-0.728-0.222-0.547-0.375-1.063-1.353-1.466-1.225-0.406 0.128-0.394 1.006-0.394 1.006s0.003 0.188-0.091 0.287c-0.1 0.109-0.3 0.131-0.3 0.131h-0.653c0 0-1.444 0.088-2.716-1.238-1.388-1.444-2.612-4.309-2.612-4.309s-0.072-0.188 0.006-0.278c0.087-0.103 0.322-0.109 0.322-0.109l1.566-0.009c0 0 0.147 0.025 0.253 0.103 0.088 0.063 0.134 0.184 0.134 0.184s0.253 0.641 0.588 1.219c0.653 1.128 0.959 1.375 1.181 1.256 0.322-0.175 0.225-1.597 0.225-1.597s0.006-0.516-0.162-0.744c-0.131-0.178-0.378-0.231-0.484-0.244-0.088-0.013 0.056-0.216 0.244-0.309 0.281-0.138 0.778-0.147 1.366-0.141 0.456 0.003 0.591 0.034 0.769 0.075 0.541 0.131 0.356 0.634 0.356 1.841 0 0.388-0.069 0.931 0.209 1.109 0.119 0.078 0.412 0.012 1.147-1.234 0.347-0.591 0.609-1.284 0.609-1.284s0.056-0.125 0.144-0.178c0.091-0.053 0.213-0.037 0.213-0.037l1.647-0.009c0 0 0.494-0.059 0.575 0.166 0.084 0.234-0.184 0.781-0.856 1.678-1.103 1.472-1.228 1.334-0.309 2.184 0.875 0.813 1.056 1.209 1.088 1.259 0.356 0.6-0.406 0.647-0.406 0.647z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$48c81409980cee5e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.644 0.166c-3.769 0.634-6.644 3.913-6.644 7.862 0 1.963 0.713 3.759 1.887 5.15 2.791-1.35 4.744-4.406 4.756-7.966v-5.047z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.356 0.166c3.769 0.634 6.644 3.913 6.644 7.862 0 1.963-0.713 3.759-1.887 5.15-2.791-1.35-4.744-4.406-4.756-7.966v-5.047z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.972 10.041c-0.497 2.056-1.981 3.813-3.828 4.981 1.138 0.622 2.441 0.978 3.828 0.978s2.691-0.356 3.828-0.978c-1.847-1.169-3.331-2.925-3.828-4.981z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ff779831a0bc6704(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.722 14.031c-2.65 0.262-4.938-0.938-5.109-2.675-0.172-1.741 1.837-3.359 4.484-3.622 2.65-0.263 4.938 0.938 5.106 2.675 0.175 1.741-1.834 3.362-4.481 3.622zM12.019 8.259c-0.225-0.069-0.381-0.113-0.262-0.409 0.256-0.644 0.281-1.197 0.003-1.594-0.519-0.741-1.941-0.703-3.569-0.019 0 0-0.513 0.222-0.381-0.181 0.25-0.806 0.213-1.478-0.178-1.869-0.884-0.884-3.234 0.034-5.25 2.050-1.506 1.503-2.381 3.106-2.381 4.491 0 2.644 3.394 4.253 6.713 4.253 4.35 0 7.247-2.528 7.247-4.534 0-1.216-1.022-1.903-1.941-2.188z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.909 3.416c-1.050-1.166-2.6-1.609-4.031-1.306v0c-0.331 0.072-0.541 0.397-0.469 0.725 0.072 0.331 0.394 0.541 0.725 0.469 1.019-0.216 2.119 0.1 2.866 0.928s0.95 1.956 0.628 2.944v0c-0.103 0.322 0.072 0.666 0.394 0.772 0.322 0.103 0.666-0.072 0.772-0.394v-0.003c0.45-1.381 0.166-2.969-0.884-4.134z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.294 4.875c-0.512-0.569-1.269-0.784-1.963-0.634-0.284 0.059-0.466 0.344-0.406 0.628 0.063 0.284 0.344 0.466 0.625 0.403v0c0.341-0.072 0.709 0.034 0.959 0.309 0.25 0.278 0.319 0.656 0.209 0.987v0c-0.088 0.275 0.063 0.575 0.341 0.666 0.278 0.088 0.575-0.063 0.666-0.341 0.219-0.678 0.081-1.453-0.431-2.019z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.869 10.884c-0.094 0.159-0.297 0.234-0.456 0.169-0.159-0.063-0.206-0.244-0.116-0.397 0.094-0.153 0.291-0.228 0.447-0.169 0.156 0.056 0.213 0.234 0.125 0.397zM6.022 11.966c-0.256 0.409-0.806 0.588-1.219 0.4-0.406-0.184-0.528-0.659-0.272-1.059 0.253-0.397 0.784-0.575 1.194-0.403 0.416 0.178 0.55 0.65 0.297 1.063zM6.984 9.072c-1.259-0.328-2.684 0.3-3.231 1.409-0.559 1.131-0.019 2.391 1.253 2.803 1.319 0.425 2.875-0.228 3.416-1.447 0.534-1.197-0.131-2.425-1.438-2.766z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9d5d5b62493fa748(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.13 11.733c-1.175 0-2.13 0.958-2.13 2.126 0 1.174 0.955 2.122 2.13 2.122 1.179 0 2.133-0.948 2.133-2.122-0-1.168-0.954-2.126-2.133-2.126zM0.002 5.436v3.067c1.997 0 3.874 0.781 5.288 2.196 1.412 1.411 2.192 3.297 2.192 5.302h3.080c-0-5.825-4.739-10.564-10.56-10.564zM0.006 0v3.068c7.122 0 12.918 5.802 12.918 12.932h3.076c0-8.82-7.176-16-15.994-16z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$63138a70013cac09(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.359 12.988c-0.75 0-1.359-0.603-1.359-1.353 0-0.744 0.609-1.356 1.359-1.356 0.753 0 1.359 0.613 1.359 1.356 0 0.75-0.609 1.353-1.359 1.353zM7.772 13c0-1.278-0.497-2.481-1.397-3.381-0.903-0.903-2.1-1.4-3.375-1.4v-1.956c3.713 0 6.738 3.022 6.738 6.737h-1.966zM11.244 13c0-4.547-3.697-8.25-8.241-8.25v-1.956c5.625 0 10.203 4.581 10.203 10.206h-1.963z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$670e5223388fa00d(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.841 4.8c0 0-0.156-1.103-0.637-1.587-0.609-0.637-1.291-0.641-1.603-0.678-2.237-0.163-5.597-0.163-5.597-0.163h-0.006c0 0-3.359 0-5.597 0.163-0.313 0.038-0.994 0.041-1.603 0.678-0.481 0.484-0.634 1.587-0.634 1.587s-0.159 1.294-0.159 2.591v1.213c0 1.294 0.159 2.591 0.159 2.591s0.156 1.103 0.634 1.588c0.609 0.637 1.409 0.616 1.766 0.684 1.281 0.122 5.441 0.159 5.441 0.159s3.363-0.006 5.6-0.166c0.313-0.037 0.994-0.041 1.603-0.678 0.481-0.484 0.637-1.588 0.637-1.588s0.159-1.294 0.159-2.591v-1.213c-0.003-1.294-0.162-2.591-0.162-2.591zM6.347 10.075v-4.497l4.322 2.256-4.322 2.241z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ba7bdceb09bf199e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 40 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.375 2.647c0.003-0.014 0.005-0.023 0.006-0.028l0.016-0.118-0.74-0.004c-0.668-0.004-0.873 0-0.891 0.017-0.009 0.008-0.24 0.885-0.651 2.473-0.196 0.758-0.361 1.363-0.367 1.345s-0.24-0.883-0.522-1.922c-0.281-1.039-0.517-1.894-0.524-1.901-0.010-0.010-0.906-0.014-1.632-0.008-0.105 0.001-0.164-0.205 0.938 3.299 0.152 0.485 0.381 1.172 0.507 1.526 0.146 0.408 0.25 0.724 0.321 0.987 0.126 0.501 0.13 0.815 0.103 1.182-0.032 0.423-0.036 3.413-0.005 3.463 0.024 0.038 1.425 0.056 1.558 0.020 0.021-0.006 0.035-0.026 0.045-0.139 0.033-0.097 0.036-0.484 0.036-2.090v-2.051l0.090-0.283c0.059-0.185 0.206-0.672 0.328-1.082s0.269-0.9 0.327-1.090c0.529-1.724 1.033-3.419 1.047-3.516l0.011-0.079z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.221 5.135l-0 0.107-0.017 0-0.009 2.953-0.009 2.863-0.229 0.233c-0.257 0.261-0.462 0.361-0.648 0.314-0.203-0.051-0.197 0.028-0.214-3.356l-0.016-3.115h-1.474v0.107h-0.017v3.38c0 3.621-0 3.619 0.184 3.982 0.146 0.29 0.36 0.431 0.725 0.479h0c0.481 0.064 1-0.154 1.481-0.622l0.209-0.203v0.351c0 0.303 0.009 0.353 0.064 0.368 0.090 0.025 1.206 0.027 1.326 0.002l0.1-0.021v-0.104l0.017-0.003v-7.736l-1.472 0.020z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.483 6.661c-0.14-0.599-0.401-1.002-0.832-1.28-0.676-0.437-1.449-0.484-2.165-0.13-0.522 0.258-0.859 0.686-1.032 1.314-0.021 0.075-0.036 0.138-0.047 0.231-0.044 0.222-0.049 0.552-0.061 2.093-0.018 2.374 0.010 2.656 0.307 3.195 0.292 0.529 0.897 0.917 1.556 0.997 0.198 0.024 0.6-0.013 0.832-0.078 0.525-0.146 1.029-0.561 1.252-1.032 0.096-0.204 0.154-0.345 0.189-0.604 0.065-0.353 0.070-0.925 0.070-2.381-0-1.857-0.006-2.060-0.068-2.326zM7.802 11.5c-0.124 0.094-0.34 0.135-0.515 0.098-0.135-0.029-0.318-0.241-0.374-0.434-0.070-0.241-0.075-3.594-0.015-4.251 0.1-0.329 0.378-0.501 0.682-0.419 0.237 0.064 0.358 0.212 0.427 0.523 0.051 0.231 0.057 0.518 0.046 2.207-0.007 1.12-0.011 1.668-0.048 1.962-0.037 0.185-0.099 0.235-0.203 0.315z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M35.944 8.346h0.712l-0.011-0.645c-0.011-0.592-0.020-0.659-0.099-0.82-0.125-0.253-0.309-0.366-0.601-0.366-0.351 0-0.573 0.17-0.678 0.518-0.045 0.148-0.092 1.167-0.058 1.255 0.019 0.049 0.121 0.058 0.735 0.058z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M31.184 6.879c-0.095-0.191-0.272-0.286-0.477-0.278-0.16 0.006-0.337 0.073-0.508 0.203l-0.127 0.097v4.634l0.127 0.097c0.288 0.22 0.604 0.266 0.822 0.12 0.086-0.058 0.142-0.137 0.186-0.263 0.057-0.164 0.062-0.375 0.055-2.325-0.008-2.032-0.012-2.152-0.078-2.285z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M40.014 4.791c-0.142-1.701-0.255-2.253-0.605-2.962-0.465-0.939-1.136-1.434-2.092-1.543-0.739-0.084-3.521-0.203-6.094-0.26-4.456-0.099-11.782 0.092-12.718 0.331-0.432 0.111-0.757 0.299-1.094 0.634-0.591 0.588-0.944 1.432-1.085 2.6-0.323 2.666-0.33 5.886-0.019 8.649 0.134 1.188 0.41 1.96 0.928 2.596 0.323 0.397 0.881 0.734 1.379 0.835 0.35 0.071 2.1 0.169 4.65 0.26 0.38 0.014 1.385 0.037 2.235 0.052 1.77 0.031 5.025 0.013 6.886-0.039 1.252-0.035 3.534-0.128 3.961-0.161 0.12-0.009 0.398-0.027 0.618-0.039 0.739-0.042 1.209-0.196 1.65-0.543 0.571-0.449 1.013-1.278 1.2-2.251 0.177-0.92 0.295-2.559 0.319-4.42 0.020-1.555-0.007-2.393-0.119-3.741zM22.27 4.175l-0.828 0.010-0.036 8.83-0.718 0.009c-0.555 0.008-0.724-0.001-0.737-0.036-0.010-0.025-0.021-2.016-0.026-4.424l-0.009-4.379-1.617-0.020v-1.38l4.779 0.019 0.020 1.36-0.828 0.010zM27.347 9.236v3.797h-1.308v-0.4c0-0.301-0.011-0.4-0.047-0.4-0.026 0-0.144 0.099-0.263 0.22-0.259 0.263-0.565 0.474-0.827 0.572-0.542 0.203-1.056 0.084-1.275-0.293-0.201-0.345-0.204-0.423-0.204-4.005v-3.29h1.307l0.010 3.098c0.010 3.044 0.011 3.1 0.084 3.224 0.097 0.164 0.244 0.209 0.478 0.144 0.138-0.038 0.232-0.105 0.455-0.327l0.282-0.28v-5.859h1.308v3.797zM32.449 12.491c-0.115 0.257-0.372 0.508-0.583 0.57-0.549 0.162-0.99 0.030-1.499-0.449-0.158-0.149-0.305-0.269-0.327-0.269-0.027 0-0.041 0.116-0.041 0.345v0.345h-1.308v-10.248h1.308v1.672c0 0.919 0.012 1.672 0.027 1.672s0.153-0.122 0.307-0.27c0.354-0.341 0.649-0.491 1.024-0.519 0.669-0.051 1.068 0.294 1.25 1.080 0.057 0.245 0.062 0.525 0.062 2.798-0 2.768-0 2.78-0.221 3.273zM37.984 10.971c-0.012 0.285-0.046 0.612-0.077 0.727-0.182 0.674-0.666 1.152-1.366 1.348-0.942 0.264-1.98-0.168-2.394-0.997-0.232-0.465-0.241-0.558-0.241-2.831 0-1.853 0.007-2.081 0.066-2.334 0.168-0.715 0.584-1.178 1.289-1.435 0.204-0.074 0.417-0.113 0.63-0.117 0.761-0.016 1.515 0.393 1.832 1.059 0.213 0.449 0.24 0.642 0.261 1.908l0.019 1.136-2.789 0.019-0.010 0.763c-0.015 1.077 0.058 1.408 0.349 1.603 0.244 0.165 0.62 0.152 0.824-0.027 0.192-0.168 0.246-0.349 0.265-0.877l0.017-0.463h1.347l-0.022 0.518z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b6f80027aa507fc7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0l-1.5 2.5v11.5h4v2h2l2-2h2.5l4.5-4.5v-9.5h-13.5zM13 8.5l-2.5 2.5h-2.5l-2 2v-2h-3v-9h10v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 4h1.5v4h-1.5v-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 4h1.5v4h-1.5v-4z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a4c2f5f3714496cd(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.994 4.281c-0.072 1.556-1.159 3.691-3.263 6.397-2.175 2.825-4.016 4.241-5.522 4.241-0.931 0-1.722-0.859-2.366-2.581-0.431-1.578-0.859-3.156-1.291-4.734-0.478-1.722-0.991-2.581-1.541-2.581-0.119 0-0.538 0.253-1.256 0.753l-0.753-0.969c0.791-0.694 1.569-1.388 2.334-2.081 1.053-0.909 1.844-1.387 2.372-1.438 1.244-0.119 2.013 0.731 2.3 2.553 0.309 1.966 0.525 3.188 0.647 3.666 0.359 1.631 0.753 2.447 1.184 2.447 0.334 0 0.838-0.528 1.509-1.588 0.669-1.056 1.028-1.862 1.078-2.416 0.097-0.912-0.262-1.372-1.078-1.372-0.384 0-0.778 0.088-1.184 0.263 0.787-2.575 2.287-3.825 4.506-3.753 1.641 0.044 2.416 1.109 2.322 3.194z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$bd0a21e3f8e58fdc(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13.463 5.313c-0.050 1.125-0.838 2.666-2.359 4.622-1.572 2.044-2.903 3.066-3.991 3.066-0.675 0-1.244-0.622-1.709-1.866-0.313-1.141-0.622-2.281-0.934-3.422-0.344-1.244-0.716-1.866-1.112-1.866-0.087 0-0.391 0.181-0.906 0.544l-0.544-0.7c0.572-0.5 1.134-1.003 1.687-1.503 0.763-0.656 1.331-1.003 1.712-1.038 0.9-0.087 1.453 0.528 1.662 1.844 0.225 1.422 0.381 2.303 0.469 2.65 0.259 1.178 0.544 1.766 0.856 1.766 0.241 0 0.606-0.381 1.091-1.147s0.744-1.347 0.778-1.747c0.069-0.659-0.191-0.991-0.778-0.991-0.278 0-0.563 0.063-0.856 0.191 0.569-1.859 1.653-2.766 3.256-2.712 1.188 0.034 1.747 0.803 1.678 2.309z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ef39340e3920d85f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM12.85 12.012l-5.444 1.781c-1.244 0.406-1.369 0.341-1.931-1.4l-1.375-4.259c-0.328-1.009-1.328-3.728-1.497-4.25-0.313-0.969-0.313-1.022 1.516-1.616 1.431-0.469 1.491-0.453 2.009 1.163 0.419 1.3 0.688 2.35 1.119 3.678l1.172 3.625 3.744-1.225c0.738-0.244 0.984-0.231 1.194 0.678l0.15 0.688c0.175 0.797-0.228 1-0.656 1.137z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8bb6e07daca8744c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5zM9 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$12698bd9954ee528(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.5c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12.5 5v0c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5c0-1.933 1.567-3.5 3.5-3.5zM0 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9abb6288a51deb8c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5zM11.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$85e73425b9565458(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.606-8 8.055s3.582 8.055 8 8.055 8-3.606 8-8.055-3.582-8.055-8-8.055zM4.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5zM11.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$fce3afc9a107dcc3(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c-4.412 0-8-3.588-8-8s3.587-8 8-8c4.412 0 8 3.587 8 8s-3.588 8-8 8v0zM14.747 9.094c-0.234-0.075-2.116-0.634-4.256-0.291 0.894 2.456 1.256 4.456 1.328 4.872 1.531-1.037 2.625-2.678 2.928-4.581v0zM10.669 14.3c-0.103-0.6-0.497-2.688-1.456-5.181-0.016 0.006-0.031 0.009-0.044 0.016-3.856 1.344-5.241 4.016-5.362 4.266 1.159 0.903 2.616 1.444 4.194 1.444 0.947 0 1.85-0.194 2.669-0.544v0zM2.922 12.578c0.156-0.266 2.031-3.369 5.553-4.509 0.088-0.028 0.178-0.056 0.269-0.081-0.172-0.388-0.359-0.778-0.553-1.159-3.409 1.022-6.722 0.978-7.022 0.975-0.003 0.069-0.003 0.138-0.003 0.209 0 1.753 0.666 3.356 1.756 4.566v0zM1.313 6.609c0.306 0.003 3.122 0.016 6.319-0.831-1.131-2.013-2.353-3.706-2.534-3.953-1.913 0.903-3.344 2.666-3.784 4.784v0zM6.4 1.366c0.188 0.253 1.431 1.944 2.55 4 2.431-0.909 3.459-2.294 3.581-2.469-1.206-1.072-2.794-1.722-4.531-1.722-0.55 0.003-1.088 0.069-1.6 0.191v0zM13.291 3.691c-0.144 0.194-1.291 1.663-3.816 2.694 0.159 0.325 0.313 0.656 0.453 0.991 0.050 0.119 0.1 0.234 0.147 0.353 2.275-0.284 4.534 0.172 4.759 0.219-0.016-1.612-0.594-3.094-1.544-4.256v0z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3a7ed815bbee26b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.641 3.206c0.472 0 0.897 0.041 1.284 0.125 0.388 0.081 0.716 0.219 0.994 0.406 0.275 0.188 0.487 0.438 0.644 0.75 0.15 0.309 0.225 0.697 0.225 1.156 0 0.497-0.112 0.909-0.338 1.241-0.228 0.331-0.559 0.6-1.003 0.813 0.606 0.175 1.053 0.481 1.353 0.916 0.3 0.438 0.444 0.963 0.444 1.581 0 0.5-0.097 0.928-0.287 1.291-0.194 0.366-0.456 0.662-0.778 0.891-0.325 0.231-0.7 0.4-1.119 0.509-0.416 0.109-0.844 0.166-1.287 0.166h-4.772v-9.844h4.641zM4.359 7.181c0.384 0 0.703-0.091 0.953-0.275 0.25-0.181 0.369-0.481 0.369-0.894 0-0.228-0.041-0.419-0.122-0.566-0.084-0.147-0.194-0.263-0.334-0.344-0.138-0.084-0.294-0.141-0.478-0.172-0.178-0.034-0.366-0.050-0.556-0.050h-2.025v2.3h2.194zM4.478 11.372c0.213 0 0.416-0.019 0.606-0.063 0.194-0.044 0.366-0.109 0.509-0.209 0.144-0.097 0.266-0.225 0.353-0.394 0.088-0.166 0.128-0.378 0.128-0.637 0-0.506-0.144-0.869-0.428-1.088-0.284-0.216-0.662-0.322-1.131-0.322h-2.35v2.709h2.313z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.331 11.338c0.294 0.287 0.716 0.431 1.266 0.431 0.394 0 0.738-0.1 1.022-0.3s0.456-0.412 0.522-0.631h1.725c-0.278 0.859-0.697 1.469-1.272 1.838-0.566 0.369-1.259 0.556-2.063 0.556-0.563 0-1.066-0.091-1.519-0.269-0.453-0.181-0.831-0.434-1.15-0.766-0.309-0.331-0.553-0.725-0.725-1.188-0.169-0.459-0.256-0.969-0.256-1.519 0-0.534 0.088-1.031 0.262-1.491 0.178-0.463 0.422-0.859 0.747-1.194s0.706-0.6 1.156-0.794c0.447-0.194 0.941-0.291 1.488-0.291 0.603 0 1.131 0.116 1.584 0.353 0.45 0.234 0.822 0.55 1.113 0.944s0.497 0.847 0.625 1.353c0.128 0.506 0.172 1.034 0.137 1.588h-5.147c0 0.559 0.188 1.094 0.484 1.378zM13.578 7.594c-0.231-0.256-0.628-0.397-1.106-0.397-0.313 0-0.572 0.053-0.778 0.159-0.203 0.106-0.369 0.237-0.497 0.394-0.125 0.156-0.213 0.325-0.262 0.503-0.050 0.172-0.081 0.331-0.091 0.469h3.188c-0.047-0.5-0.219-0.869-0.453-1.128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.444 4h3.991v0.972h-3.991v-0.972z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6a7edbdd1d86eed5(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.316 7.009c0.203-0.147 0.3-0.391 0.3-0.728 0-0.188-0.031-0.341-0.097-0.459-0.069-0.119-0.156-0.213-0.272-0.278-0.112-0.069-0.241-0.116-0.388-0.141-0.144-0.028-0.297-0.041-0.453-0.041h-1.647v1.869h1.781c0.313 0.003 0.572-0.072 0.775-0.222z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.594 8.697c-0.231-0.175-0.537-0.262-0.919-0.262h-1.916v2.203h1.878c0.175 0 0.338-0.016 0.494-0.050s0.297-0.088 0.416-0.169c0.119-0.078 0.216-0.184 0.287-0.319s0.106-0.309 0.106-0.519c0-0.412-0.116-0.706-0.347-0.884z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM10.488 4.209h3.241v0.791h-3.241v-0.791zM8.463 10.725c-0.156 0.297-0.369 0.537-0.631 0.725-0.266 0.188-0.569 0.325-0.909 0.416-0.338 0.091-0.688 0.134-1.044 0.134h-3.878v-7.997h3.769c0.381 0 0.728 0.034 1.044 0.1 0.313 0.066 0.581 0.178 0.806 0.331 0.222 0.153 0.397 0.356 0.522 0.609 0.122 0.25 0.184 0.566 0.184 0.938 0 0.403-0.091 0.737-0.275 1.006s-0.453 0.487-0.816 0.659c0.494 0.141 0.856 0.391 1.097 0.744 0.244 0.356 0.363 0.784 0.363 1.284 0.003 0.409-0.075 0.759-0.231 1.050zM14.991 9.488h-4.178c0 0.456 0.156 0.891 0.394 1.125 0.238 0.231 0.581 0.35 1.028 0.35 0.322 0 0.597-0.081 0.831-0.244 0.231-0.162 0.372-0.334 0.425-0.512h1.4c-0.225 0.697-0.566 1.194-1.031 1.494-0.459 0.3-1.022 0.45-1.675 0.45-0.456 0-0.866-0.075-1.234-0.219-0.369-0.147-0.675-0.353-0.934-0.622-0.253-0.269-0.447-0.591-0.588-0.966-0.137-0.372-0.209-0.787-0.209-1.234 0-0.434 0.072-0.838 0.213-1.213 0.144-0.375 0.344-0.7 0.606-0.969 0.262-0.272 0.575-0.487 0.938-0.647 0.363-0.156 0.762-0.234 1.206-0.234 0.491 0 0.919 0.094 1.287 0.287 0.366 0.191 0.666 0.447 0.903 0.769s0.403 0.688 0.509 1.1c0.103 0.406 0.137 0.834 0.109 1.284z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.134 7.247c-0.253 0-0.466 0.044-0.631 0.131s-0.3 0.194-0.403 0.319c-0.103 0.128-0.172 0.263-0.213 0.409-0.041 0.141-0.066 0.269-0.072 0.381h2.588c-0.037-0.406-0.178-0.706-0.366-0.916-0.194-0.213-0.512-0.325-0.903-0.325z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$3fdf84463fe1e3ae(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.953 2.909v-2.909h-2.909l-0.291 0.294-1.375 2.616-0.431 0.291h-4.9v3.994h2.694l0.241 0.291-2.934 5.606v2.909h2.909l0.291-0.294 1.375-2.616 0.431-0.291h4.9v-3.994h-2.694l-0.241-0.294z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6d81c43ecd6443f7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.953 10.512c0.003 0.009 0.088 0.238 0.134 0.353 0.263 0.622 0.641 1.184 1.122 1.666s1.041 0.859 1.666 1.122c0.647 0.272 1.331 0.412 2.037 0.412s1.394-0.137 2.037-0.412c0.625-0.262 1.184-0.641 1.666-1.122s0.859-1.041 1.122-1.666c0.272-0.647 0.412-1.331 0.412-2.037s-0.137-1.394-0.412-2.037c-0.262-0.625-0.641-1.184-1.122-1.666s-1.041-0.859-1.666-1.122c-0.647-0.272-1.331-0.413-2.037-0.413-0.716 0-1.431 0.144-2.066 0.413-0.509 0.216-1.372 0.769-1.875 1.291l-0.003 0.003v-4.313h7.241c0.262-0.003 0.262-0.372 0.262-0.491 0-0.122 0-0.487-0.266-0.491h-7.828c-0.213 0-0.344 0.178-0.344 0.341v6.066c0 0.197 0.244 0.338 0.472 0.384 0.444 0.094 0.544-0.047 0.653-0.197l0.016-0.019c0.166-0.247 0.681-0.766 0.688-0.772 0.806-0.806 1.884-1.25 3.037-1.25 1.147 0 2.222 0.444 3.028 1.25 0.809 0.809 1.256 1.881 1.256 3.019 0 1.141-0.444 2.216-1.25 3.019-0.794 0.794-1.906 1.25-3.047 1.25-0.772 0-1.519-0.206-2.159-0.597l0.003-3.688c0-0.491 0.213-1.028 0.572-1.431 0.409-0.463 0.972-0.716 1.588-0.716 0.594 0 1.15 0.225 1.566 0.634 0.409 0.406 0.637 0.95 0.637 1.528 0 1.231-0.969 2.197-2.206 2.197-0.238 0-0.672-0.106-0.691-0.109-0.25-0.075-0.356 0.272-0.391 0.387-0.134 0.441 0.069 0.528 0.109 0.541 0.397 0.125 0.659 0.147 1.003 0.147 1.747 0 3.169-1.422 3.169-3.169 0-1.734-1.422-3.144-3.166-3.144-0.856 0-1.659 0.328-2.263 0.919-0.575 0.566-0.903 1.319-0.903 2.069v0.019c-0.003 0.094-0.003 2.306-0.006 3.031l-0.003-0.003c-0.328-0.363-0.653-0.919-0.869-1.488-0.084-0.222-0.275-0.184-0.534-0.103-0.125 0.034-0.469 0.141-0.391 0.394v0zM7.675 9.647c0 0.106 0.097 0.2 0.156 0.253l0.019 0.019c0.1 0.097 0.194 0.147 0.281 0.147 0.072 0 0.116-0.034 0.131-0.050 0.044-0.041 0.537-0.544 0.588-0.591l0.553 0.55c0.050 0.056 0.106 0.088 0.172 0.088 0.088 0 0.184-0.053 0.284-0.156 0.238-0.244 0.119-0.375 0.063-0.438l-0.559-0.559 0.584-0.588c0.128-0.137 0.016-0.284-0.097-0.397-0.162-0.162-0.322-0.206-0.422-0.112l-0.581 0.581-0.588-0.588c-0.031-0.031-0.072-0.047-0.113-0.047-0.078 0-0.172 0.053-0.275 0.156-0.181 0.181-0.219 0.306-0.125 0.406l0.588 0.584-0.584 0.584c-0.053 0.050-0.078 0.103-0.075 0.156zM8.953 1.716c-0.938 0-1.938 0.191-2.669 0.506-0.078 0.031-0.125 0.094-0.134 0.181-0.009 0.084 0.013 0.194 0.069 0.337 0.047 0.116 0.166 0.425 0.4 0.334 0.75-0.288 1.581-0.444 2.334-0.444 0.856 0 1.688 0.169 2.469 0.497 0.622 0.263 1.206 0.644 1.844 1.194 0.047 0.041 0.097 0.059 0.147 0.059 0.125 0 0.244-0.122 0.347-0.237 0.169-0.191 0.287-0.35 0.119-0.509-0.609-0.575-1.275-1.006-2.1-1.356-0.894-0.372-1.847-0.563-2.825-0.563zM14.006 13.3v0c-0.113-0.113-0.209-0.178-0.294-0.203s-0.162-0.006-0.222 0.053l-0.056 0.056c-0.581 0.581-1.259 1.037-2.012 1.356-0.781 0.331-1.609 0.497-2.463 0.497-0.856 0-1.684-0.169-2.463-0.497-0.753-0.319-1.431-0.775-2.013-1.356-0.606-0.606-1.063-1.284-1.356-2.012-0.288-0.713-0.381-1.247-0.413-1.422-0.003-0.016-0.006-0.028-0.006-0.037-0.041-0.206-0.231-0.222-0.503-0.178-0.112 0.019-0.459 0.072-0.428 0.319v0.006c0.091 0.578 0.253 1.144 0.481 1.681 0.366 0.866 0.891 1.644 1.559 2.313s1.447 1.191 2.313 1.559c0.897 0.378 1.85 0.572 2.831 0.572s1.934-0.194 2.831-0.572c0.866-0.366 1.644-0.891 2.313-1.559 0 0 0.037-0.037 0.059-0.059 0.069-0.084 0.134-0.225-0.159-0.516z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$4ef239b26687bf3e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM14.975 2.025c-1.367-1.367-3.583-1.367-4.95 0-0.556 0.556-0.886 1.252-0.989 1.975v0l-3.198 4.847c-0.43 0.022-0.856 0.132-1.249 0.328l-2.467-1.928c-0.571-0.446-1.396-0.345-1.842 0.226s-0.345 1.396 0.226 1.842l2.436 1.905c-0.265 1.043 0.010 2.196 0.827 3.012 1.233 1.233 3.232 1.233 4.465 0 0.757-0.757 1.049-1.804 0.876-2.784l3.891-3.484c0.723-0.104 1.419-0.434 1.975-0.989 1.367-1.367 1.367-3.583 0-4.95zM6 14.105c-1.162 0-2.105-0.942-2.105-2.105 0-0.011 0.001-0.022 0.001-0.033l1.046 0.817c0.24 0.188 0.525 0.278 0.807 0.278 0.39 0 0.776-0.173 1.035-0.504 0.446-0.571 0.345-1.396-0.226-1.842l-0.992-0.776c0.14-0.029 0.285-0.045 0.434-0.045 1.162 0 2.105 0.942 2.105 2.105s-0.942 2.105-2.105 2.105zM12.5 7c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$73ccb2df17789b82(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.749 13.063c0.424 0 0.84-0.205 1.093-0.585 0.402-0.603 0.239-1.418-0.364-1.82l-1.032-0.688c0.177-0.048 0.362-0.074 0.554-0.074 1.162 0 2.105 0.942 2.105 2.105s-0.942 2.105-2.105 2.105c-1.131 0-2.054-0.893-2.102-2.012l1.124 0.749c0.224 0.149 0.477 0.221 0.727 0.221zM13.333 0c1.467 0 2.667 1.2 2.667 2.667v10.666c0 1.468-1.2 2.667-2.667 2.667h-10.666c-1.467 0-2.667-1.199-2.667-2.667v-3.172l1.896 1.264c-0.182 0.987 0.108 2.044 0.872 2.808 1.233 1.233 3.232 1.233 4.465 0 0.757-0.757 1.049-1.804 0.876-2.784l3.892-3.484c0.723-0.104 1.419-0.433 1.975-0.989 1.367-1.367 1.367-3.583 0-4.95s-3.583-1.367-4.95 0c-0.556 0.556-0.886 1.252-0.989 1.975v0l-3.198 4.847c-0.498 0.025-0.99 0.168-1.433 0.428l-3.404-2.269v-4.339c0-1.467 1.2-2.667 2.667-2.667h10.666zM14 4.5c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5 1.119 2.5 2.5 2.5 2.5-1.119 2.5-2.5zM10 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$53cdf7d7e6547fba(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 0.5l-3.5 3 4.5 3 3.5-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3.5l-3.5-3-4.5 3 3.5 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.5l3.5 3-4.5 2.5-3.5-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9l-4.5-2.5-3.5 3 4.5 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.377 13.212l-3.377-2.895-3.377 2.895-2.123-1.179v1.467l5.5 2.5 5.5-2.5v-1.467z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a961771c102a63f5(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.482 12.944c-0.942-0.235-1.466-0.984-1.468-2.095-0-0.355 0.025-0.525 0.114-0.754 0.217-0.56 0.793-0.982 1.55-1.138 0.377-0.077 0.493-0.16 0.493-0.353 0-0.060 0.045-0.24 0.1-0.399 0.249-0.724 0.71-1.327 1.202-1.573 0.515-0.258 0.776-0.316 1.399-0.313 0.886 0.005 1.327 0.197 1.945 0.846l0.34 0.357 0.304-0.105c1.473-0.51 2.942 0.358 3.061 1.809l0.032 0.397 0.29 0.104c0.829 0.297 1.218 0.92 1.148 1.837-0.046 0.599-0.326 1.078-0.77 1.315l-0.209 0.112-4.638 0.009c-3.564 0.007-4.697-0.006-4.893-0.055v0zM1.613 12.281c-0.565-0.142-1.164-0.67-1.445-1.273-0.159-0.342-0.168-0.393-0.168-0.998 0-0.576 0.014-0.668 0.14-0.954 0.267-0.603 0.78-1.038 1.422-1.21 0.136-0.036 0.263-0.094 0.283-0.128s0.043-0.221 0.050-0.415c0.045-1.206 0.794-2.269 1.839-2.61 0.565-0.184 1.306-0.202 1.92 0.058 0.195 0.082 0.173 0.1 0.585-0.471 0.244-0.338 0.705-0.695 1.108-0.909 0.435-0.231 0.887-0.337 1.428-0.336 1.512 0.004 2.815 1.003 3.297 2.529 0.154 0.487 0.146 0.624-0.035 0.628-0.079 0.002-0.306 0.048-0.505 0.102l-0.361 0.099-0.329-0.348c-0.928-0.98-2.441-1.192-3.728-0.522-0.514 0.268-0.927 0.652-1.239 1.153-0.222 0.357-0.506 1.024-0.506 1.189 0 0.117-0.090 0.176-0.474 0.309-1.189 0.412-1.883 1.364-1.882 2.582 0 0.443 0.108 0.986 0.258 1.296 0.057 0.117 0.088 0.228 0.070 0.247-0.046 0.049-1.525 0.032-1.73-0.019v0z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9fa673bfb456e6d7(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0.198c-4.418 0-8 3.582-8 8 0 3.535 2.292 6.533 5.471 7.591 0.4 0.074 0.547-0.174 0.547-0.385 0-0.191-0.008-0.821-0.011-1.489-2.226 0.484-2.695-0.944-2.695-0.944-0.364-0.925-0.888-1.171-0.888-1.171-0.726-0.497 0.055-0.486 0.055-0.486 0.803 0.056 1.226 0.824 1.226 0.824 0.714 1.223 1.872 0.869 2.328 0.665 0.072-0.517 0.279-0.87 0.508-1.070-1.777-0.202-3.645-0.888-3.645-3.954 0-0.873 0.313-1.587 0.824-2.147-0.083-0.202-0.357-1.015 0.077-2.117 0 0 0.672-0.215 2.201 0.82 0.638-0.177 1.322-0.266 2.002-0.269 0.68 0.003 1.365 0.092 2.004 0.269 1.527-1.035 2.198-0.82 2.198-0.82 0.435 1.102 0.162 1.916 0.079 2.117 0.513 0.56 0.823 1.274 0.823 2.147 0 3.073-1.872 3.749-3.653 3.947 0.287 0.248 0.543 0.735 0.543 1.481 0 1.070-0.009 1.932-0.009 2.195 0 0.213 0.144 0.462 0.55 0.384 3.177-1.059 5.466-4.057 5.466-7.59 0-4.418-3.582-8-8-8z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$34f80311daac07c9(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v16h16v-16h-16zM13 13h-2v-8h-3v8h-5v-10h10v10z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$cee8ab84d17c9c81(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.666c-2.919 0-5.169 2.444-6.444 4.838-0.719 1.347-1.222 2.822-1.453 4.331-0.025 0.172-0.050 0.344-0.069 0.519-0.009 0.094-0.019 0.188-0.025 0.281-0.009 0.119-0.003 0.156 0.059 0.256 0.187 0.303 0.409 0.584 0.659 0.838 0.512 0.525 1.134 0.928 1.794 1.241 1.503 0.709 3.2 0.966 4.85 1.022 1.703 0.056 3.453-0.084 5.081-0.616 1.391-0.453 2.731-1.244 3.503-2.522 0.084-0.137 0.025-0.341 0.009-0.5-0.019-0.191-0.044-0.378-0.075-0.566-0.056-0.369-0.131-0.731-0.222-1.094-0.181-0.738-0.428-1.463-0.728-2.159-1.088-2.525-3.1-5.219-5.963-5.775-0.322-0.063-0.65-0.094-0.978-0.094zM8.1 13.909c-1.784 0-3.728-0.159-5.334-1.019-0.625-0.334-1.262-0.819-1.563-1.484-0.087-0.194-0.056-0.269-0.016-0.497 0.028-0.147 0.041-0.291 0.106-0.428 0.091-0.191 0.184-0.378 0.281-0.566 0.328-0.634 0.681-1.262 1.091-1.853 0.203-0.291 0.419-0.578 0.669-0.828 0.175-0.175 0.388-0.362 0.634-0.422 0.756-0.181 1.334 0.694 1.794 1.134 0.222 0.213 0.519 0.453 0.85 0.412 0.228-0.028 0.431-0.206 0.594-0.353 0.553-0.497 0.997-1.112 1.456-1.691 0.228-0.284 0.453-0.572 0.7-0.844 0.166-0.184 0.347-0.394 0.569-0.513 0.397-0.216 0.903 0.228 1.178 0.456 0.469 0.391 0.884 0.847 1.281 1.309 0.378 0.441 0.744 0.888 1.066 1.372 0.497 0.75 0.928 1.55 1.322 2.359 0.084 0.175 0.113 0.294 0.144 0.488 0.019 0.106 0.059 0.228 0.044 0.338-0.022 0.153-0.128 0.319-0.206 0.444-0.188 0.297-0.441 0.553-0.719 0.769-1.166 0.903-2.744 1.203-4.178 1.338-0.588 0.056-1.175 0.078-1.762 0.078z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$45cd0eb5da5fd907(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM7 12c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-8c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v8zM13 9c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-5c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e093811d12e9071(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8c0 2.313 1.38 4.312 3.382 5.259l-2.862-7.637c-0.333 0.727-0.52 1.531-0.52 2.378zM12.050 7.705c0-0.722-0.266-1.222-0.495-1.612-0.304-0.482-0.589-0.889-0.589-1.371 0-0.537 0.418-1.037 1.008-1.037 0.027 0 0.052 0.003 0.078 0.005-1.067-0.953-2.49-1.534-4.052-1.534-2.096 0-3.94 1.048-5.013 2.634 0.141 0.004 0.274 0.007 0.386 0.007 0.627 0 1.599-0.074 1.599-0.074 0.323-0.018 0.361 0.444 0.038 0.482 0 0-0.325 0.037-0.687 0.055l2.185 6.33 1.313-3.835-0.935-2.495c-0.323-0.019-0.629-0.055-0.629-0.055-0.323-0.019-0.285-0.5 0.038-0.482 0 0 0.991 0.074 1.58 0.074 0.627 0 1.599-0.074 1.599-0.074 0.323-0.018 0.362 0.444 0.038 0.482 0 0-0.326 0.037-0.687 0.055l2.168 6.282 0.599-1.947c0.259-0.809 0.457-1.389 0.457-1.889zM8.105 8.511l-1.8 5.095c0.538 0.154 1.106 0.238 1.695 0.238 0.699 0 1.369-0.117 1.992-0.331-0.016-0.025-0.031-0.052-0.043-0.081l-1.844-4.921zM13.265 5.196c0.026 0.186 0.040 0.386 0.040 0.601 0 0.593-0.114 1.259-0.456 2.093l-1.833 5.16c1.784-1.013 2.983-2.895 2.983-5.051 0-1.016-0.267-1.971-0.735-2.803zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 15c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$176d40013d473f5f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.156 4.323c0.513-0.513 1.344-0.513 1.856-0l0.122 0.123 1.58-1.581-0.123-0.123c-0.9-0.902-2.164-1.217-3.319-0.946-0.166-1.018-1.048-1.796-2.112-1.796-1.182 0-2.14 0.96-2.14 2.143 0 1.021 0.712 1.875 1.667 2.091-0.362 1.21-0.066 2.576 0.888 3.531l3.56 3.561 1.578-1.581-3.56-3.561c-0.511-0.511-0.512-1.346 0.003-1.861zM15.98 2.143c0-1.184-0.958-2.143-2.14-2.143-1.082 0-1.976 0.804-2.12 1.847-1.204-0.354-2.559-0.055-3.51 0.897l-3.56 3.561 1.58 1.581 3.559-3.56c0.515-0.515 1.344-0.514 1.854-0.003 0.512 0.513 0.512 1.346-0.001 1.859l-0.122 0.122 1.578 1.582 0.123-0.124c0.945-0.946 1.245-2.293 0.9-3.494 1.049-0.138 1.858-1.037 1.858-2.125zM14.16 11.735c0.283-1.163-0.031-2.443-0.939-3.352l-3.555-3.562-1.58 1.58 3.555 3.563c0.515 0.516 0.514 1.345 0.003 1.857-0.513 0.513-1.344 0.513-1.857-0l-0.121-0.122-1.578 1.582 0.121 0.121c0.961 0.962 2.338 1.257 3.553 0.883 0.197 0.979 1.061 1.716 2.098 1.716 1.181 0 2.14-0.959 2.14-2.143 0-1.081-0.8-1.976-1.84-2.122zM9.568 8.261l-3.555 3.562c-0.511 0.512-1.344 0.513-1.859-0.002-0.513-0.514-0.513-1.345-0.001-1.859l0.122-0.121-1.579-1.58-0.121 0.12c-0.918 0.919-1.228 2.216-0.929 3.39-0.944 0.223-1.646 1.072-1.646 2.086-0 1.184 0.958 2.143 2.14 2.143 1.017-0.001 1.869-0.71 2.087-1.662 1.167 0.29 2.453-0.020 3.365-0.934l3.555-3.562-1.578-1.582z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ade5ae12e2685799(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM12.885 9.212c-0.575 2.23-2.584 3.788-4.885 3.788s-4.31-1.558-4.885-3.788c-0.097-0.377 0.131-0.764 0.508-0.861 0.058-0.015 0.118-0.023 0.177-0.023 0.322 0 0.604 0.218 0.684 0.531 0.414 1.605 1.86 2.727 3.516 2.727s3.102-1.121 3.516-2.727c0.081-0.313 0.362-0.531 0.684-0.531 0.060 0 0.12 0.008 0.178 0.023 0.183 0.047 0.336 0.163 0.432 0.326s0.123 0.353 0.075 0.536z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$34cc077b97cfecdf(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.966 6h-0.897c-0.549 0-1.031-0.465-1.069-1v0c0-2.854-2.301-5-5.175-5h-2.622c-2.872 0-5.201 2.313-5.203 5.167v5.669c0 2.854 2.331 5.165 5.203 5.165h5.6c2.874 0 5.197-2.311 5.197-5.165v-3.662c0-0.57-0.46-1.173-1.034-1.173zM5 4h3c0.55 0 1 0.45 1 1s-0.45 1-1 1h-3c-0.55 0-1-0.45-1-1s0.45-1 1-1zM11 12h-6c-0.55 0-1-0.45-1-1s0.45-1 1-1h6c0.55 0 1 0.45 1 1s-0.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$728fcbf44fe51083(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM14 10.125c0 2.141-1.741 3.875-3.897 3.875h-4.2c-2.156 0-3.903-1.734-3.903-3.875v-4.25c0-2.141 1.747-3.875 3.903-3.875h1.966c2.156 0 3.881 1.609 3.881 3.75 0.028 0.4 0.391 0.75 0.8 0.75h0.672c0.431 0 0.775 0.453 0.775 0.881v2.744z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10c0 0.55-0.45 1-1 1h-4c-0.55 0-1-0.45-1-1v0c0-0.55 0.45-1 1-1h4c0.55 0 1 0.45 1 1v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v0c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v0z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6c3c7e4f97b17aad(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.001 7l-0 3.659c0 0.928-0.012 1.463 0.086 1.727 0.098 0.262 0.342 0.534 0.609 0.691 0.354 0.212 0.758 0.318 1.214 0.318 0.81 0 1.289-0.107 2.090-0.633v2.405c-0.683 0.321-1.279 0.509-1.833 0.639-0.555 0.129-1.154 0.194-1.798 0.194-0.732 0-1.163-0.092-1.725-0.276-0.562-0.185-1.042-0.45-1.438-0.79-0.398-0.343-0.672-0.706-0.826-1.091s-0.23-0.944-0.23-1.676v-5.611h-2.147v-2.266c0.628-0.204 1.331-0.497 1.778-0.877 0.449-0.382 0.809-0.839 1.080-1.374 0.272-0.534 0.459-1.214 0.561-2.039h2.579l-0 4h3.999v3h-3.999z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9d83c8e3472593f0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11.434 12.884c-0.472 0.222-0.9 0.378-1.281 0.469-0.381 0.088-0.797 0.134-1.241 0.134-0.506 0-0.803-0.063-1.191-0.191s-0.719-0.309-0.994-0.544c-0.275-0.238-0.463-0.488-0.569-0.753s-0.159-0.65-0.159-1.156v-3.872h-1.5v-1.563c0.434-0.141 0.938-0.344 1.244-0.606 0.309-0.263 0.559-0.578 0.744-0.947 0.188-0.369 0.316-0.837 0.388-1.406h1.569v2.55h2.556v1.972h-2.553v2.831c0 0.641-0.009 1.009 0.059 1.191s0.238 0.369 0.422 0.475c0.244 0.147 0.525 0.219 0.838 0.219 0.559 0 1.116-0.181 1.669-0.544v1.741z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$33d1f9fd6ec7e0f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.878 9.203v0c1.759-3.088 4.666-8.125 5.463-9.203-0.35 0.234-0.887 0.353-1.381 0.466l-0.747-0.466c-0.6 1.119-2.813 4.734-4.222 7.050-1.428-2.366-3.119-5.097-4.222-7.050-0.875 0.188-1.237 0.197-2.109 0v0 0c0 0 0 0 0 0v0c1.731 2.606 4.503 7.572 5.447 9.203v0l-0.128 6.797 1.013-0.466v-0.012l1.012 0.478-0.125-6.797z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9d080375b9701483(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.019 1.087c-2.828 0-5.5-0.372-8.019-1.087 0 5.653 0 14.581 0 16 2.522-0.716 5.194-1.088 8.019-1.088 2.794 0 5.459 0.363 7.981 1.088 0-5.444 0-10.153 0-16-2.522 0.725-5.184 1.087-7.981 1.087zM12.45 2.453l-0.097 0.153c-0.091 0.144-0.172 0.266-0.284 0.438-0.15 0.225-0.431 0.672-0.769 1.247-0.094 0.159-0.209 0.35-0.328 0.556-0.228 0.384-0.484 0.819-0.688 1.162-0.084 0.147-0.169 0.297-0.256 0.447-0.225 0.391-0.456 0.794-0.678 1.181-0.228 0.403-0.453 0.8-0.678 1.194v0.397c0 0.55 0.012 1.15 0.031 1.684 0.009 0.244 0.019 0.678 0.031 1.137 0.012 0.547 0.025 1.113 0.041 1.4l0.003 0.088v0.009l-0.094-0.025c-0.037-0.009-0.072-0.019-0.109-0.028-0.113-0.025-0.234-0.044-0.353-0.056-0.072-0.006-0.147-0.009-0.222-0.009 0 0 0 0 0 0s0 0 0 0c-0.075 0-0.15 0.003-0.222 0.009-0.119 0.012-0.241 0.031-0.353 0.056-0.037 0.009-0.075 0.019-0.109 0.028l-0.094 0.025v-0.009l0.003-0.088c0.013-0.284 0.028-0.853 0.041-1.4 0.009-0.459 0.022-0.894 0.031-1.137 0.022-0.537 0.031-1.134 0.031-1.684v-0.397c-0.225-0.397-0.45-0.791-0.678-1.194-0.222-0.391-0.453-0.791-0.675-1.181-0.088-0.15-0.172-0.3-0.256-0.447-0.2-0.347-0.459-0.781-0.688-1.162-0.122-0.203-0.237-0.397-0.328-0.556-0.338-0.575-0.619-1.019-0.769-1.247-0.112-0.172-0.194-0.294-0.284-0.438l-0.097-0.153 0.175 0.050c0.222 0.063 0.45 0.094 0.694 0.094s0.478-0.031 0.697-0.094l0.053-0.016 0.028 0.047c0.431 0.778 1.591 2.684 2.284 3.825 0.237 0.394 0.428 0.703 0.522 0.862 0 0 0 0 0-0.003 0 0 0 0 0 0.003 0.094-0.156 0.284-0.469 0.522-0.862 0.694-1.138 1.853-3.044 2.284-3.825l0.028-0.047 0.053 0.016c0.219 0.063 0.453 0.094 0.697 0.094s0.472-0.031 0.694-0.094l0.166-0.050z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$802a5f47e34f65dd(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.87 11.514c-1.28 0.596-2.471 0.589-3.271 0.532-0.954-0.069-1.721-0.33-2.058-0.558-0.208-0.141-0.49-0.086-0.631 0.122s-0.086 0.49 0.122 0.631c0.542 0.367 1.501 0.64 2.503 0.712 0.17 0.012 0.356 0.020 0.557 0.020 0.872 0 1.979-0.083 3.163-0.634 0.228-0.106 0.326-0.376 0.22-0.604s-0.376-0.326-0.604-0.22zM13.921 10.841c0.044-3.948 0.449-11.409-7.109-10.806-7.463 0.601-5.484 8.484-5.595 11.124-0.099 1.397-0.562 3.104-1.217 4.841h2.017c0.207-0.736 0.36-1.464 0.425-2.159 0.122 0.085 0.252 0.167 0.391 0.245 0.226 0.133 0.42 0.31 0.626 0.497 0.48 0.438 1.025 0.934 2.089 0.996 0.071 0.004 0.143 0.006 0.214 0.006 1.077 0 1.813-0.471 2.404-0.85 0.283-0.181 0.528-0.338 0.759-0.413 0.655-0.205 1.227-0.536 1.655-0.957 0.067-0.066 0.129-0.133 0.187-0.202 0.238 0.873 0.564 1.856 0.926 2.836h4.307c-1.034-1.597-2.101-3.162-2.079-5.159zM1.939 8.693c0-0 0-0-0-0.001-0.074-1.288 0.542-2.372 1.377-2.421s1.571 0.957 1.645 2.245c0 0 0 0 0 0.001 0.004 0.069 0.006 0.138 0.006 0.206-0.264 0.066-0.503 0.163-0.717 0.275-0.001-0.010-0.001-0.019-0.002-0.029 0-0 0-0 0-0-0.071-0.731-0.462-1.284-0.873-1.234s-0.686 0.684-0.614 1.415c0 0 0 0 0 0 0.031 0.319 0.123 0.604 0.251 0.819-0.032 0.025-0.122 0.091-0.225 0.166-0.078 0.057-0.172 0.126-0.286 0.21-0.311-0.408-0.524-0.993-0.562-1.655zM10.395 11.878c-0.030 0.681-0.92 1.322-1.743 1.579l-0.005 0.002c-0.342 0.111-0.647 0.306-0.97 0.513-0.543 0.347-1.104 0.706-1.914 0.706-0.053 0-0.108-0.002-0.161-0.005-0.742-0.043-1.090-0.36-1.529-0.761-0.232-0.211-0.472-0.43-0.781-0.611l-0.007-0.004c-0.667-0.377-1.081-0.845-1.108-1.253-0.013-0.203 0.077-0.378 0.268-0.522 0.416-0.312 0.695-0.516 0.879-0.651 0.205-0.15 0.267-0.195 0.313-0.239 0.033-0.031 0.068-0.065 0.106-0.103 0.382-0.371 1.021-0.993 2.002-0.993 0.6 0 1.264 0.231 1.971 0.686 0.333 0.217 0.623 0.317 0.99 0.444 0.252 0.087 0.539 0.186 0.922 0.35l0.006 0.003c0.357 0.147 0.78 0.415 0.76 0.858zM10.198 10.278c-0.069-0.035-0.14-0.068-0.215-0.098-0.345-0.148-0.622-0.248-0.852-0.328 0.127-0.248 0.206-0.558 0.213-0.894 0-0 0-0 0-0 0.018-0.818-0.395-1.483-0.922-1.484s-0.968 0.661-0.986 1.479c0 0 0 0 0 0-0.001 0.027-0.001 0.053-0 0.080-0.324-0.149-0.643-0.258-0.956-0.324-0.001-0.031-0.003-0.061-0.004-0.092 0-0 0-0.001 0-0.001-0.030-1.491 0.884-2.725 2.043-2.756s2.122 1.152 2.153 2.642c0 0 0 0.001 0 0.001 0.014 0.674-0.167 1.295-0.475 1.776z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$cab1dc5b26d78280(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.367 8.501c-0.020-2.026 1.652-2.998 1.727-3.046-0.94-1.375-2.404-1.564-2.926-1.585-1.246-0.126-2.431 0.734-3.064 0.734-0.631 0-1.607-0.715-2.64-0.696-1.358 0.020-2.61 0.79-3.31 2.006-1.411 2.448-0.361 6.076 1.014 8.061 0.672 0.972 1.473 2.064 2.525 2.025 1.013-0.040 1.396-0.656 2.621-0.656s1.569 0.656 2.641 0.635c1.090-0.020 1.781-0.991 2.448-1.966 0.772-1.128 1.089-2.219 1.108-2.275-0.024-0.011-2.126-0.816-2.147-3.236zM10.353 2.555c0.558-0.677 0.935-1.617 0.832-2.555-0.804 0.033-1.779 0.536-2.356 1.212-0.518 0.6-0.971 1.557-0.85 2.476 0.898 0.070 1.815-0.456 2.373-1.132z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e707d9fbc4981a2c(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.894 12.16c-0-0.001-0-0.001-0-0.002 0 0.001 0 0.001 0 0.002z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.916 12.727c-0-0.004-0-0.007-0.001-0.011 0 0.004 0 0.007 0.001 0.011z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.903 12.442c-0-0.003-0-0.006-0-0.008 0 0.003 0 0.006 0 0.008z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0h-14c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h7.716c0.001 0 0.001 0 0.002 0s0.001-0 0.002-0h6.28c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM3 3.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1zM15 15h-5.86c-0.105-0.658-0.17-1.336-0.209-1.994 0 0.002 0 0.004 0 0.005-0.308 0.034-0.618 0.051-0.931 0.051-2.088 0-4.1-0.76-5.664-2.141-0.233-0.206-0.255-0.561-0.050-0.794s0.561-0.255 0.794-0.050c1.358 1.199 3.105 1.859 4.919 1.859 0.298 0 0.595-0.018 0.888-0.053-0.034-1.847 0.107-3.311 0.11-3.334 0.014-0.141-0.032-0.28-0.127-0.385s-0.229-0.164-0.371-0.164h-1.487c0.022-0.541 0.079-1.466 0.234-2.503 0.295-1.981 0.812-3.528 1.502-4.497h6.251v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 5c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.445 13.050c-0.057 0.003-0.114 0.005-0.171 0.007 0.057-0.002 0.114-0.004 0.171-0.007z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13.063c0.073 0 0.146-0.001 0.22-0.003-0.073 0.002-0.146 0.003-0.22 0.003z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.423 11.925c0.012-0.001 0.024-0.001 0.037-0.002-0.012 0.001-0.024 0.001-0.037 0.002z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.204 11.934c0.017-0 0.034-0.001 0.050-0.002-0.017 0.001-0.034 0.001-0.050 0.002z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.713 10.128c-0.206-0.233-0.561-0.255-0.794-0.050-1.135 1.002-2.542 1.627-4.032 1.806 0.007 0.364 0.020 0.742 0.043 1.127 1.749-0.191 3.403-0.916 4.733-2.090 0.233-0.206 0.255-0.561 0.050-0.794z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.93 13.012c-0.072 0.008-0.144 0.015-0.216 0.021 0.072-0.006 0.144-0.013 0.216-0.021z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.68 13.035c-0.061 0.005-0.122 0.009-0.183 0.013 0.061-0.004 0.122-0.008 0.183-0.013z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b0561c07db9f5708(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-0.55-0.45-1-1-1zM2 6c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-0.55-0.45-1-1-1zM3.5 11.5c0 0.828 0.672 1.5 1.5 1.5v0 2c0 0.55 0.45 1 1 1s1-0.45 1-1v-2h2v2c0 0.55 0.45 1 1 1s1-0.45 1-1v-2c0.828 0 1.5-0.672 1.5-1.5v-5.5h-9v5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.472 5c-0.152-1.373-0.922-2.559-2.025-3.276l0.5-1.001c0.123-0.247 0.023-0.547-0.224-0.671s-0.547-0.023-0.671 0.224l-0.502 1.004-0.13-0.052c-0.446-0.148-0.924-0.229-1.42-0.229s-0.974 0.081-1.42 0.229l-0.13 0.052-0.502-1.004c-0.123-0.247-0.424-0.347-0.671-0.224s-0.347 0.424-0.224 0.671l0.5 1.001c-1.103 0.716-1.873 1.903-2.025 3.276v0.5h8.972v-0.5h-0.028zM6.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.223-0.499 0.499-0.5c0 0 0.001 0 0.001 0s0.001-0 0.001-0c0.276 0.001 0.499 0.224 0.499 0.5s-0.224 0.5-0.5 0.5zM9.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.223-0.499 0.499-0.5c0 0 0.001 0 0.001 0s0.001-0 0.002-0c0.276 0.001 0.499 0.224 0.499 0.5s-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$6835546d36e1dbeb(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.441 7.999c-0.745-0.383-1.47-0.577-2.154-0.577-0.093 0-0.187 0.003-0.28 0.011-0.873 0.072-1.671 0.303-2.184 0.482-0.136 0.050-0.276 0.103-0.419 0.161l-1.403 4.866c0.964-0.357 1.817-0.53 2.598-0.53 1.263 0 2.18 0.472 2.937 0.958 0.359-1.217 1.219-4.158 1.476-5.036-0.187-0.114-0.376-0.228-0.571-0.333zM8.255 9.235l-1.413 4.909c0.419 0.24 1.83 1.001 2.91 1.001 0.872 0 1.848-0.223 2.982-0.684l1.349-4.718c-0.916 0.296-1.795 0.446-2.617 0.446-1.499 0-2.549-0.486-3.211-0.952zM4.575 5.762c1.205 0.012 2.096 0.472 2.835 0.945l1.449-4.958c-0.305-0.175-1.106-0.611-1.685-0.759-0.381-0.089-0.782-0.135-1.206-0.135-0.809 0.015-1.694 0.218-2.701 0.622l-1.382 4.853c1.013-0.382 1.885-0.568 2.689-0.568 0.001 0 0.002 0 0.002 0zM16 3.096c-0.919 0.357-1.816 0.539-2.672 0.539-1.433 0-2.489-0.497-3.173-0.974l-1.437 4.972c0.965 0.62 2.005 0.936 3.096 0.936 0.89 0 1.812-0.214 2.742-0.636l-0.003-0.035 0.058-0.014 1.39-4.788z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$415f5aecc13c29be(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.005 8l-0.005-4.876 6-0.815v5.691zM7 2.164l7.998-1.164v7h-7.998zM15 9l-0.002 7-7.998-1.125v-5.875zM6 14.747l-5.995-0.822-0-4.926h5.995z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d32896e716b8868b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.937 8.034c-0.283 0-0.552 0.055-0.798 0.154-0.164-1.787-1.723-3.188-3.625-3.188-0.465 0-0.917 0.088-1.317 0.237-0.156 0.058-0.197 0.117-0.197 0.233v6.292c0 0.121 0.098 0.222 0.221 0.234 0.005 0.001 5.68 0.003 5.717 0.003 1.139 0 2.062-0.888 2.062-1.983s-0.924-1.983-2.063-1.983zM6.25 12h0.5l0.25-3.503-0.25-3.497h-0.5l-0.25 3.497zM4.75 12h-0.5l-0.25-2.543 0.25-2.457h0.5l0.25 2.5zM2.25 12h0.5l0.25-2-0.25-2h-0.5l-0.25 2zM0.25 11h0.5l0.25-1-0.25-1h-0.5l-0.25 1z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2a5cc9d1bf7b54d4(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM2.75 11h-0.5l-0.25-1.5 0.25-1.5h0.5l0.25 1.5-0.25 1.5zM4.75 11h-0.5l-0.25-2 0.25-2h0.5l0.25 2-0.25 2zM6.75 11h-0.5l-0.25-3 0.25-3h0.5l0.25 3-0.25 3zM12.894 11c-0.031 0-4.706-0.003-4.709-0.003-0.1-0.009-0.181-0.097-0.184-0.2v-5.394c0-0.1 0.034-0.15 0.162-0.2 0.331-0.128 0.703-0.203 1.088-0.203 1.566 0 2.85 1.2 2.987 2.734 0.203-0.084 0.425-0.131 0.656-0.131 0.938 0 1.7 0.762 1.7 1.7s-0.762 1.697-1.7 1.697z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b4751d866288c882(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.65 0.584c-0.025-0.016-0.053-0.028-0.078-0.041-0.028 0.006-0.053 0.009-0.081 0.016l0.159 0.025z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0.575 6.578c-0.006 0.028-0.009 0.056-0.012 0.081 0.016 0.025 0.025 0.050 0.041 0.075l-0.028-0.156z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.419 9.416c0.006-0.028 0.009-0.056 0.016-0.084-0.016-0.025-0.025-0.050-0.041-0.075l0.025 0.159z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.25 15.359c0.025 0.016 0.053 0.028 0.078 0.041 0.028-0.006 0.056-0.009 0.084-0.012l-0.162-0.028z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.434 9.331c-0.006 0.028-0.009 0.056-0.016 0.084l-0.028-0.162c0.016 0.028 0.028 0.053 0.044 0.078 0.081-0.45 0.125-0.909 0.125-1.369 0-1.019-0.2-2.009-0.594-2.941-0.381-0.9-0.925-1.709-1.619-2.403s-1.503-1.238-2.4-1.619c-0.931-0.394-1.922-0.594-2.941-0.594-0.481 0-0.963 0.044-1.431 0.134 0 0-0.003 0-0.003 0 0.025 0.012 0.053 0.025 0.078 0.041l-0.159-0.025c0.028-0.006 0.053-0.009 0.081-0.016-0.644-0.341-1.366-0.525-2.097-0.525-1.194 0-2.319 0.466-3.163 1.309s-1.309 1.969-1.309 3.163c0 0.759 0.197 1.509 0.563 2.169 0.006-0.028 0.009-0.056 0.012-0.081l0.028 0.159c-0.016-0.025-0.028-0.050-0.041-0.075-0.075 0.428-0.112 0.866-0.112 1.303 0 1.019 0.2 2.009 0.594 2.941 0.381 0.9 0.925 1.706 1.619 2.4s1.503 1.238 2.403 1.619c0.931 0.394 1.922 0.594 2.941 0.594 0.444 0 0.887-0.041 1.322-0.119-0.025-0.016-0.050-0.028-0.078-0.041l0.162 0.028c-0.028 0.006-0.056 0.009-0.084 0.012 0.669 0.378 1.428 0.581 2.2 0.581 1.194 0 2.319-0.466 3.162-1.309s1.309-1.969 1.309-3.162c-0.003-0.759-0.2-1.509-0.569-2.175zM8.034 12.591c-2.684 0-3.884-1.319-3.884-2.309 0-0.506 0.375-0.863 0.891-0.863 1.15 0 0.85 1.65 2.994 1.65 1.097 0 1.703-0.597 1.703-1.206 0-0.366-0.181-0.772-0.903-0.95l-2.388-0.597c-1.922-0.481-2.272-1.522-2.272-2.5 0-2.028 1.909-2.791 3.703-2.791 1.653 0 3.6 0.913 3.6 2.131 0 0.522-0.453 0.825-0.969 0.825-0.981 0-0.8-1.356-2.775-1.356-0.981 0-1.522 0.444-1.522 1.078s0.775 0.838 1.447 0.991l1.769 0.394c1.934 0.431 2.425 1.563 2.425 2.625 0 1.647-1.266 2.878-3.819 2.878z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e2856e4c95018e5b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 10c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10.049 12.137c0.258-0.203 0.631-0.159 0.834 0.099s0.159 0.631-0.099 0.834c-0.717 0.565-1.81 0.93-2.783 0.93s-2.066-0.365-2.784-0.93c-0.258-0.203-0.302-0.576-0.099-0.834s0.576-0.302 0.834-0.099c0.413 0.325 1.23 0.675 2.049 0.675s1.636-0.35 2.049-0.675zM16 8c0-1.105-0.895-2-2-2-0.752 0-1.406 0.415-1.748 1.028-1.028-0.562-2.28-0.926-3.645-1.010l1.193-2.68 2.284 0.659c0.206 0.583 0.761 1.002 1.415 1.002 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5c-0.571 0-1.068 0.319-1.321 0.789l-2.545-0.735c-0.285-0.082-0.587 0.058-0.707 0.329l-1.621 3.641c-1.33 0.094-2.551 0.453-3.557 1.004-0.342-0.613-0.996-1.028-1.748-1.028-1.105 0-2 0.895-2 2 0 0.817 0.491 1.52 1.193 1.83-0.126 0.375-0.193 0.767-0.193 1.17 0 2.761 3.134 5 7 5s7-2.239 7-5c0-0.403-0.067-0.795-0.193-1.17 0.703-0.31 1.193-1.013 1.193-1.83zM13.5 2.938c0.311 0 0.563 0.252 0.563 0.563s-0.252 0.563-0.563 0.563-0.563-0.252-0.563-0.563 0.252-0.563 0.563-0.563zM1 8c0-0.551 0.449-1 1-1 0.399 0 0.743 0.234 0.904 0.573-0.523 0.396-0.956 0.854-1.276 1.355-0.368-0.148-0.628-0.508-0.628-0.928zM8 14.813c-3.21 0-5.813-1.707-5.813-3.813s2.602-3.813 5.813-3.813c3.21 0 5.813 1.707 5.813 3.813s-2.602 3.813-5.813 3.813zM14.372 8.928c-0.32-0.502-0.753-0.959-1.276-1.355 0.161-0.338 0.505-0.573 0.904-0.573 0.551 0 1 0.449 1 1 0 0.42-0.26 0.78-0.628 0.928z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$44b36e2b4b261512(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v16h16v-16h-16zM8.5 9.125v3.375h-1v-3.375l-2.734-5.125h1.134l2.1 3.938 2.1-3.938h1.134l-2.734 5.125z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8405b1ef55e2b7b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.106 3.65c0 0.050-0.016 0.097-0.047 0.141-0.031 0.041-0.066 0.063-0.106 0.063-0.313 0.031-0.569 0.131-0.766 0.3-0.2 0.169-0.403 0.497-0.613 0.975l-3.225 7.272c-0.022 0.069-0.081 0.1-0.178 0.1-0.075 0-0.134-0.034-0.178-0.1l-1.809-3.781-2.081 3.781c-0.044 0.069-0.1 0.1-0.178 0.1-0.094 0-0.153-0.034-0.184-0.1l-3.166-7.269c-0.197-0.45-0.406-0.766-0.625-0.944s-0.525-0.291-0.916-0.331c-0.034 0-0.066-0.019-0.094-0.053-0.031-0.034-0.044-0.075-0.044-0.122 0-0.119 0.034-0.178 0.1-0.178 0.281 0 0.578 0.013 0.888 0.038 0.288 0.025 0.556 0.038 0.809 0.038 0.256 0 0.563-0.013 0.913-0.038 0.366-0.025 0.691-0.038 0.975-0.038 0.069 0 0.1 0.059 0.1 0.178s-0.022 0.175-0.063 0.175c-0.281 0.022-0.506 0.094-0.669 0.216s-0.244 0.281-0.244 0.481c0 0.1 0.034 0.228 0.1 0.378l2.616 5.912 1.487-2.806-1.384-2.903c-0.25-0.519-0.453-0.853-0.612-1.003s-0.403-0.241-0.728-0.275c-0.031 0-0.056-0.019-0.084-0.053s-0.041-0.075-0.041-0.122c0-0.119 0.028-0.178 0.088-0.178 0.281 0 0.541 0.013 0.778 0.038 0.228 0.025 0.469 0.038 0.728 0.038 0.253 0 0.519-0.013 0.803-0.038 0.291-0.025 0.578-0.038 0.859-0.038 0.069 0 0.1 0.059 0.1 0.178s-0.019 0.175-0.063 0.175c-0.566 0.038-0.847 0.2-0.847 0.481 0 0.125 0.066 0.322 0.197 0.588l0.916 1.859 0.912-1.7c0.125-0.241 0.191-0.444 0.191-0.606 0-0.388-0.281-0.594-0.847-0.619-0.050 0-0.075-0.059-0.075-0.175 0-0.044 0.012-0.081 0.037-0.119s0.050-0.056 0.075-0.056c0.203 0 0.45 0.013 0.747 0.038 0.281 0.025 0.516 0.038 0.697 0.038 0.131 0 0.322-0.013 0.575-0.031 0.319-0.028 0.588-0.044 0.803-0.044 0.050 0 0.075 0.050 0.075 0.15 0 0.134-0.047 0.203-0.137 0.203-0.328 0.034-0.594 0.125-0.794 0.272s-0.45 0.481-0.75 1.006l-1.222 2.237 1.644 3.35 2.428-5.647c0.084-0.206 0.125-0.397 0.125-0.569 0-0.412-0.281-0.631-0.847-0.659-0.050 0-0.075-0.059-0.075-0.175 0-0.119 0.037-0.178 0.113-0.178 0.206 0 0.45 0.013 0.734 0.038 0.262 0.025 0.481 0.038 0.656 0.038 0.188 0 0.4-0.013 0.644-0.038 0.253-0.025 0.481-0.038 0.684-0.038 0.063 0 0.094 0.050 0.094 0.15z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d8f7ab793d9cb73f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 13h-2v-7h2v7zM5 5c-0.553 0-1-0.447-1-1s0.447-1 1-1c0.553 0 1 0.447 1 1s-0.447 1-1 1zM13 13h-2v-4c0-0.553-0.447-1-1-1s-1 0.447-1 1v4h-2v-7h2v1.241c0.412-0.566 1.044-1.241 1.75-1.241 1.244 0 2.25 1.119 2.25 2.5v4.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$45ddb69571048a30(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h2.767v1.418h0.040c0.385-0.691 1.327-1.418 2.732-1.418 2.921 0 3.461 1.818 3.461 4.183v4.817h-2.885v-4.27c0-1.018-0.021-2.329-1.5-2.329-1.502 0-1.732 1.109-1.732 2.255v4.344h-2.883v-9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6h3v9h-3v-9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$da2d6bb10ddd8d6e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.056 11.972l-0.588-1.594c0 0-0.953 1.063-2.381 1.063-1.266 0-2.163-1.1-2.163-2.859 0-2.253 1.137-3.059 2.253-3.059 1.612 0 2.125 1.044 2.566 2.381l0.588 1.831c0.588 1.778 1.688 3.206 4.856 3.206 2.272 0 3.813-0.697 3.813-2.528 0-1.484-0.844-2.253-2.419-2.622l-1.172-0.256c-0.806-0.184-1.044-0.513-1.044-1.063 0-0.622 0.494-0.991 1.3-0.991 0.881 0 1.356 0.331 1.428 1.119l1.831-0.219c-0.147-1.65-1.284-2.328-3.153-2.328-1.65 0-3.262 0.622-3.262 2.622 0 1.247 0.606 2.034 2.125 2.4l1.247 0.294c0.934 0.219 1.247 0.606 1.247 1.137 0 0.678-0.659 0.953-1.906 0.953-1.85 0-2.622-0.972-3.059-2.309l-0.606-1.831c-0.766-2.384-1.994-3.263-4.431-3.263-2.694 0-4.125 1.703-4.125 4.6 0 2.784 1.428 4.287 3.997 4.287 2.069 0 3.059-0.972 3.059-0.972v0z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e197fd956b26aff6(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11.666 11.887c-2.775 0-3.737-1.25-4.25-2.806l-0.513-1.603c-0.384-1.172-0.834-2.084-2.244-2.084-0.978 0-1.972 0.706-1.972 2.678 0 1.541 0.784 2.503 1.894 2.503 1.25 0 2.084-0.931 2.084-0.931l0.513 1.394c0 0-0.866 0.85-2.678 0.85-2.25 0-3.5-1.313-3.5-3.75 0-2.534 1.25-4.025 3.609-4.025 2.134 0 3.206 0.769 3.881 2.853l0.528 1.603c0.384 1.172 1.059 2.022 2.678 2.022 1.091 0 1.669-0.241 1.669-0.834 0-0.466-0.272-0.803-1.091-0.994l-1.091-0.256c-1.331-0.322-1.859-1.009-1.859-2.1 0-1.747 1.412-2.294 2.853-2.294 1.634 0 2.631 0.594 2.759 2.038l-1.603 0.194c-0.066-0.691-0.481-0.978-1.25-0.978-0.706 0-1.137 0.322-1.137 0.866 0 0.481 0.209 0.769 0.912 0.931l1.025 0.225c1.378 0.322 2.116 0.994 2.116 2.294 0 1.597-1.347 2.206-3.334 2.206z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$64a7c32e26fa52c3(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v16h16v-16h-16zM8 15v-7h-7v-7h7v7h7v7h-7z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b3b794c4fc9ee535(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5c-0.55 0-1 0.45-1 1v4c0 1.653-1.347 3-3 3s-3-1.347-3-3v-2h2v2c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-1.653 1.347-3 3-3s3 1.347 3 2.781v0.969l-1.281 0.375-0.719-0.375v-0.969c0-0.331-0.45-0.781-1-0.781z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10c0 1.653-1.347 3-3 3s-3-1.347-3-3.219v-1.938l0.719 0.375 1.281-0.375v1.938c0 0.769 0.45 1.219 1 1.219s1-0.45 1-1v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$99c5f2f0f9141c2a(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.313 0h-10.625c-1.478 0-2.688 1.209-2.688 2.688v10.625c0 1.478 1.209 2.688 2.688 2.688h10.625c1.478 0 2.688-1.209 2.688-2.688v-10.625c0-1.478-1.209-2.688-2.688-2.688zM8 5c-0.551 0-1 0.449-1 1v4c0 1.654-1.346 3-3 3s-3-1.346-3-3v-2h2v2c0 0.551 0.449 1 1 1s1-0.449 1-1v-4c0-1.654 1.346-3 3-3s3 1.346 3 2.781v0.969l-1.281 0.375-0.719-0.375v-0.969c0-0.333-0.449-0.781-1-0.781zM15 10c0 1.654-1.346 3-3 3s-3-1.346-3-3.219v-1.938l0.719 0.375 1.281-0.375v1.938c0 0.77 0.449 1.219 1 1.219s1-0.449 1-1v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$223ef17a843793c0(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10v6h-16v-6h2v4h12v-4zM3 11h10v2h-10zM3.237 8.835l0.433-1.953 9.763 2.164-0.433 1.953zM4.37 4.821l0.845-1.813 9.063 4.226-0.845 1.813zM15.496 5.648l-1.218 1.587-7.934-6.088 0.88-1.147h0.91z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$be843ad4a21cf431(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.069c-3.828 0-6.931 3.103-6.931 6.931 0 2.938 1.828 5.444 4.406 6.453-0.059-0.547-0.116-1.391 0.025-1.988 0.125-0.541 0.813-3.444 0.813-3.444s-0.206-0.416-0.206-1.028c0-0.963 0.559-1.684 1.253-1.684 0.591 0 0.878 0.444 0.878 0.975 0 0.594-0.378 1.484-0.575 2.306-0.166 0.691 0.344 1.253 1.025 1.253 1.231 0 2.178-1.3 2.178-3.175 0-1.659-1.194-2.819-2.894-2.819-1.972 0-3.128 1.478-3.128 3.009 0 0.597 0.228 1.234 0.516 1.581 0.056 0.069 0.066 0.128 0.047 0.2-0.053 0.219-0.169 0.691-0.194 0.787-0.031 0.128-0.1 0.153-0.231 0.094-0.866-0.403-1.406-1.669-1.406-2.684 0-2.188 1.587-4.194 4.578-4.194 2.403 0 4.272 1.712 4.272 4.003 0 2.388-1.506 4.313-3.597 4.313-0.703 0-1.362-0.366-1.588-0.797 0 0-0.347 1.322-0.431 1.647-0.156 0.603-0.578 1.356-0.862 1.816 0.65 0.2 1.337 0.309 2.053 0.309 3.828 0 6.931-3.103 6.931-6.931 0-3.831-3.103-6.934-6.931-6.934z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d8e6f3780312e4b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.412 0-8 3.587-8 8s3.587 8 8 8 8-3.588 8-8-3.588-8-8-8zM8 14.931c-0.716 0-1.403-0.109-2.053-0.309 0.281-0.459 0.706-1.216 0.862-1.816 0.084-0.325 0.431-1.647 0.431-1.647 0.225 0.431 0.888 0.797 1.587 0.797 2.091 0 3.597-1.922 3.597-4.313 0-2.291-1.869-4.003-4.272-4.003-2.991 0-4.578 2.009-4.578 4.194 0 1.016 0.541 2.281 1.406 2.684 0.131 0.063 0.2 0.034 0.231-0.094 0.022-0.097 0.141-0.566 0.194-0.787 0.016-0.069 0.009-0.131-0.047-0.2-0.287-0.347-0.516-0.988-0.516-1.581 0-1.528 1.156-3.009 3.128-3.009 1.703 0 2.894 1.159 2.894 2.819 0 1.875-0.947 3.175-2.178 3.175-0.681 0-1.191-0.563-1.025-1.253 0.197-0.825 0.575-1.713 0.575-2.306 0-0.531-0.284-0.975-0.878-0.975-0.697 0-1.253 0.719-1.253 1.684 0 0.612 0.206 1.028 0.206 1.028s-0.688 2.903-0.813 3.444c-0.141 0.6-0.084 1.441-0.025 1.988-2.578-1.006-4.406-3.512-4.406-6.45 0-3.828 3.103-6.931 6.931-6.931s6.931 3.103 6.931 6.931c0 3.828-3.103 6.931-6.931 6.931z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$ab9dd82b4e051676(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.884 10.406h-1.728c-0.103 0-0.181-0.047-0.225-0.119-0.047-0.075-0.047-0.169 0-0.266l1.838-3.244c0.003-0.003 0.003-0.006 0-0.009l-1.169-2.025c-0.047-0.097-0.056-0.191-0.009-0.266 0.044-0.072 0.131-0.109 0.237-0.109h1.731c0.266 0 0.397 0.172 0.481 0.325 0 0 1.181 2.063 1.191 2.075-0.069 0.125-1.869 3.303-1.869 3.303-0.094 0.162-0.219 0.334-0.478 0.334zM13.069 2.378l-3.831 6.775c-0.003 0.003-0.003 0.009 0 0.012l2.441 4.456c0.047 0.097 0.050 0.194 0.003 0.269-0.044 0.072-0.125 0.109-0.231 0.109h-1.728c-0.266 0-0.397-0.175-0.484-0.328 0 0-2.453-4.5-2.459-4.512 0.122-0.216 3.85-6.828 3.85-6.828 0.094-0.166 0.206-0.328 0.463-0.328h1.753c0.103 0 0.188 0.041 0.231 0.109 0.044 0.072 0.044 0.169-0.006 0.266z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$804bb87e838b8e2e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.431 3.159c-0.138 0-0.256 0.050-0.316 0.144-0.059 0.1-0.050 0.225 0.013 0.353l1.559 2.7c0.003 0.006 0.003 0.009 0 0.013l-2.45 4.331c-0.063 0.128-0.059 0.256 0 0.353 0.059 0.094 0.163 0.156 0.3 0.156h2.306c0.344 0 0.513-0.234 0.628-0.447 0 0 2.397-4.241 2.491-4.406-0.009-0.016-1.588-2.766-1.588-2.766-0.116-0.203-0.287-0.431-0.644-0.431h-2.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.125 0c-0.344 0-0.494 0.216-0.619 0.441 0 0-4.972 8.816-5.134 9.106 0.009 0.016 3.278 6.016 3.278 6.016 0.116 0.203 0.291 0.441 0.644 0.441h2.306c0.137 0 0.247-0.053 0.306-0.147 0.063-0.1 0.059-0.228-0.006-0.356l-3.25-5.947c-0.003-0.006-0.003-0.009 0-0.016l5.109-9.034c0.063-0.128 0.066-0.256 0.006-0.356-0.059-0.094-0.169-0.147-0.306-0.147h-2.334z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d12f7384b9848d58(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.743 0c-3.802 0-5.743 2.19-5.743 6.279v0 8.579l3.725-3.729v-4.358c0-1.694 0.449-2.772 1.955-3.014v0c0.526-0.103 1.621-0.067 2.317-0.067v0 2.587c0 0.024 0.003 0.066 0.009 0.087v0c0.029 0.105 0.124 0.181 0.236 0.182v0c0.063 0 0.123-0.033 0.184-0.093v0l6.455-6.453-9.139-0.001zM12.275 4.871v4.358c0 1.694-0.449 2.772-1.955 3.014v0c-0.526 0.103-1.621 0.067-2.317 0.067v0-2.587c0-0.023-0.003-0.066-0.009-0.087v0c-0.029-0.105-0.124-0.182-0.236-0.182v0c-0.064-0-0.123 0.033-0.184 0.093v0l-6.455 6.453 9.139 0.001c3.802 0 5.743-2.19 5.743-6.279v0-8.579l-3.725 3.729z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e7cae96b485c9e48(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.306 1.408c-0.188-0.256-0.488-0.408-0.806-0.408h-9.5c-0.552 0-1 0.448-1 1v12c0 0.404 0.244 0.769 0.617 0.924 0.124 0.051 0.254 0.076 0.382 0.076 0.26 0 0.516-0.102 0.707-0.293l3.707-3.707h2.586c0.437 0 0.824-0.284 0.954-0.702l2.5-8c0.095-0.304 0.040-0.634-0.149-0.891zM10.515 5h-3.515c-0.552 0-1 0.448-1 1s0.448 1 1 1h2.89l-0.625 2h-2.265c-0.265 0-0.52 0.105-0.707 0.293l-2.293 2.293v-8.586h7.14l-0.625 2z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9064234b6724caaf(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.514 10.21c-0.27 0.272-0.042 0.768-0.042 0.768l2.033 3.394c0 0 0.334 0.447 0.623 0.447 0.29 0 0.577-0.239 0.577-0.239l1.607-2.297c0 0 0.162-0.29 0.166-0.544 0.006-0.361-0.538-0.46-0.538-0.46l-3.805-1.222c-0 0-0.373-0.099-0.621 0.152zM9.321 8.5c0.195 0.33 0.732 0.234 0.732 0.234l3.796-1.109c0 0 0.517-0.21 0.591-0.491 0.072-0.281-0.085-0.619-0.085-0.619l-1.814-2.137c0 0-0.157-0.27-0.483-0.297-0.36-0.031-0.581 0.405-0.581 0.405l-2.145 3.375c0 0-0.19 0.336-0.010 0.64zM7.527 7.184c0.447-0.11 0.518-0.759 0.518-0.759l-0.030-5.404c0 0-0.067-0.667-0.367-0.847-0.47-0.285-0.609-0.136-0.744-0.116l-3.151 1.171c0 0-0.309 0.102-0.469 0.36-0.23 0.365 0.233 0.899 0.233 0.899l3.276 4.465c0 0 0.323 0.334 0.735 0.233zM6.749 9.371c0.011-0.417-0.5-0.667-0.5-0.667l-3.387-1.711c0 0-0.502-0.207-0.746-0.063-0.187 0.11-0.352 0.31-0.368 0.486l-0.221 2.716c0 0-0.033 0.471 0.089 0.685 0.173 0.304 0.741 0.092 0.741 0.092l3.955-0.874c0.154-0.103 0.423-0.113 0.438-0.664zM7.732 10.837c-0.339-0.174-0.746 0.187-0.746 0.187l-2.648 2.915c0 0-0.33 0.446-0.246 0.72 0.079 0.257 0.21 0.384 0.396 0.474l2.659 0.839c0 0 0.322 0.067 0.567-0.004 0.347-0.1 0.283-0.643 0.283-0.643l0.060-3.947c-0 0-0.014-0.38-0.324-0.541z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a30fb3e356f26f75(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.531 4.822c-0.747 3.316-3.053 5.066-6.688 5.066h-1.209l-0.841 5.338h-1.013l-0.053 0.344c-0.034 0.228 0.141 0.431 0.369 0.431h2.588c0.306 0 0.566-0.222 0.616-0.525l0.025-0.131 0.488-3.091 0.031-0.169c0.047-0.303 0.309-0.525 0.616-0.525h0.384c2.506 0 4.469-1.019 5.044-3.963 0.216-1.119 0.134-2.069-0.356-2.775z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.984 1.206c-0.741-0.844-2.081-1.206-3.794-1.206h-4.972c-0.35 0-0.65 0.253-0.703 0.6l-2.072 13.131c-0.041 0.259 0.159 0.494 0.422 0.494h3.072l0.772-4.891-0.025 0.153c0.053-0.347 0.35-0.6 0.7-0.6h1.459c2.866 0 5.109-1.162 5.766-4.531 0.019-0.1 0.037-0.197 0.050-0.291 0.194-1.244 0-2.094-0.675-2.859z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$447b1ae99f8c717(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.036 6.977l-2.29-3.966c1.466-1.835 3.722-3.012 6.254-3.012 2.929 0 5.489 1.574 6.883 3.922h-6.528c-0.117-0.010-0.236-0.016-0.356-0.016-1.904 0-3.509 1.307-3.964 3.071zM10.864 5.078h4.585c0.355 0.905 0.551 1.891 0.551 2.922 0 4.388-3.533 7.95-7.909 7.999l3.272-5.667c0.461-0.662 0.731-1.466 0.731-2.332 0-1.143-0.471-2.178-1.23-2.922zM5.094 8c0-1.603 1.304-2.906 2.906-2.906s2.906 1.304 2.906 2.906c0 1.602-1.304 2.906-2.906 2.906s-2.906-1.304-2.906-2.906zM9.097 11.944l-2.29 3.967c-3.852-0.576-6.806-3.899-6.806-7.911 0-1.425 0.373-2.763 1.026-3.922l3.266 5.657c0.654 1.392 2.070 2.359 3.707 2.359 0.38 0 0.747-0.052 1.097-0.149z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$b108c1d932aabca8(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.977 5.221l-0.185 1.189c0 0-0.265-2.201-0.59-3.024-0.498-1.261-0.719-1.251-0.72-1.249 0.333 0.847 0.273 1.302 0.273 1.302s-0.591-1.609-2.152-2.121c-1.729-0.567-2.665-0.412-2.773-0.383-0.016-0-0.032-0-0.047-0 0.013 0.001 0.025 0.002 0.038 0.003-0.001 0-0.001 0.001-0.001 0.001 0.007 0.009 1.911 0.333 2.249 0.797 0 0-0.809 0-1.614 0.232-0.036 0.010 2.961 0.374 3.574 3.37 0 0-0.329-0.686-0.735-0.802 0.267 0.813 0.199 2.356-0.056 3.123-0.033 0.099-0.066-0.426-0.568-0.652 0.161 1.151-0.010 2.976-0.808 3.479-0.062 0.039 0.5-1.802 0.113-1.090-2.23 3.419-4.866 1.578-6.051 0.767 0.607 0.132 1.76-0.021 2.271-0.4 0.001-0 0.001-0.001 0.002-0.001 0.554-0.379 0.882-0.656 1.177-0.59s0.491-0.23 0.262-0.493c-0.229-0.263-0.786-0.625-1.539-0.428-0.531 0.139-1.19 0.727-2.194 0.132-0.771-0.457-0.844-0.837-0.851-1.1 0.019-0.093 0.043-0.18 0.072-0.26 0.089-0.248 0.358-0.323 0.508-0.382 0.254 0.044 0.473 0.123 0.703 0.241 0.003-0.076 0.004-0.178-0-0.293 0.022-0.044 0.008-0.176-0.027-0.337-0.020-0.161-0.053-0.328-0.106-0.48 0-0 0-0 0-0s0.002-0.001 0.002-0.001c0.001-0.001 0.002-0.002 0.003-0.003s0-0.001 0.001-0.001c0.001-0.002 0.002-0.004 0.003-0.007 0.016-0.072 0.188-0.211 0.402-0.361 0.192-0.134 0.417-0.277 0.595-0.387 0.157-0.098 0.277-0.17 0.302-0.189 0.010-0.007 0.021-0.016 0.034-0.026 0.002-0.002 0.005-0.004 0.007-0.006s0.003-0.002 0.004-0.004c0.085-0.067 0.211-0.194 0.237-0.462 0-0.001 0-0.001 0-0.002 0.001-0.008 0.001-0.016 0.002-0.024 0-0.006 0.001-0.011 0.001-0.017 0-0.004 0-0.009 0.001-0.013 0-0.011 0.001-0.021 0.001-0.032 0-0.001 0-0.001 0-0.002 0-0.026-0-0.053-0.002-0.081-0.001-0.016-0.002-0.030-0.005-0.043-0-0.001-0-0.001-0-0.002s-0.001-0.003-0.001-0.004-0.001-0.005-0.002-0.007c-0-0-0-0-0-0.001-0.001-0.003-0.002-0.005-0.003-0.007-0-0-0-0-0-0-0.027-0.064-0.13-0.088-0.554-0.096-0-0-0.001-0-0.001-0v0c-0.173-0.003-0.399-0.003-0.695-0.002-0.52 0.002-0.807-0.508-0.898-0.705 0.126-0.695 0.489-1.19 1.085-1.525 0.011-0.006 0.009-0.012-0.004-0.015 0.117-0.071-1.41-0.002-2.112 0.891-0.623-0.155-1.166-0.144-1.635-0.035-0.090-0.003-0.202-0.014-0.335-0.041-0.311-0.282-0.757-0.803-0.781-1.425 0 0-0.001 0.001-0.004 0.003-0-0.006-0.001-0.012-0.001-0.018 0 0-0.949 0.729-0.807 2.717-0 0.032-0.001 0.062-0.002 0.092-0.257 0.348-0.384 0.641-0.394 0.706-0.228 0.463-0.458 1.16-0.646 2.218 0 0 0.131-0.417 0.395-0.889-0.194 0.594-0.346 1.518-0.257 2.904 0 0 0.024-0.307 0.107-0.75 0.065 0.86 0.352 1.921 1.076 3.169 1.39 2.396 3.526 3.605 5.887 3.791 0.419 0.035 0.845 0.035 1.272 0.003 0.039-0.003 0.079-0.006 0.118-0.009 0.484-0.034 0.971-0.107 1.457-0.224 6.643-1.606 5.921-9.628 5.921-9.628z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$e05053e2330d79d2(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.472 9.825h3.688c0.028-0.256 0.040-0.517 0.040-0.784 0-1.253-0.336-2.429-0.924-3.442 0.607-1.614 0.586-2.984-0.227-3.803-0.773-0.77-2.848-0.645-5.194 0.394-0.174-0.013-0.349-0.020-0.526-0.020-3.22 0-5.921 2.216-6.667 5.201 1.010-1.293 2.072-2.231 3.492-2.913-0.129 0.121-0.882 0.87-1.009 0.996-3.743 3.742-4.923 8.63-3.653 9.9 0.965 0.965 2.715 0.802 4.725-0.182 0.934 0.476 1.992 0.744 3.113 0.744 3.018 0 5.575-1.942 6.501-4.648h-3.717c-0.511 0.943-1.512 1.586-2.66 1.586s-2.148-0.642-2.66-1.586c-0.227-0.426-0.358-0.915-0.358-1.432v-0.011h6.035zM5.442 8.013c0.085-1.517 1.347-2.728 2.887-2.728s2.802 1.21 2.887 2.728h-5.774zM14.015 2.559c0.524 0.529 0.511 1.503 0.063 2.719-0.768-1.17-1.883-2.093-3.2-2.619 1.408-0.604 2.553-0.684 3.137-0.1zM1.461 15.113c-0.668-0.669-0.467-2.072 0.394-3.763 0.536 1.504 1.581 2.767 2.927 3.581-1.491 0.677-2.712 0.792-3.321 0.182z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d320025a328d12f4(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.241 7.103c0.469-3.7 2.994-7.056 7.519-7.103 2.731 0.053 4.978 1.291 6.316 3.65 0.672 1.231 0.881 2.525 0.925 3.953v1.678h-10.041c0.047 4.141 6.094 4 8.697 2.175v3.372c-1.525 0.916-4.984 1.734-7.662 0.681-2.281-0.856-3.906-3.244-3.897-5.541-0.075-2.978 1.481-4.95 3.897-6.072-0.513 0.634-0.903 1.334-1.106 2.547h5.669c0 0 0.331-3.388-3.209-3.388-3.338 0.116-5.744 2.056-7.106 4.047v0z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$89579a4d63c553d8(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM14.975 7.388l-0.016-0.166c0.003 0.056 0.009 0.109 0.016 0.166zM13.881 4.2l-0.113-0.169c0.037 0.056 0.075 0.112 0.113 0.169zM13.447 3.603l-0.069-0.084c0.025 0.028 0.047 0.056 0.069 0.084zM12.478 2.619l-0.084-0.069c0.031 0.025 0.056 0.047 0.084 0.069zM11.969 2.231l-0.169-0.112c0.056 0.038 0.113 0.075 0.169 0.112zM8.778 1.044l-0.169-0.016c0.056 0.003 0.113 0.009 0.169 0.016zM7.388 1.025l-0.169 0.016c0.056-0.003 0.112-0.009 0.169-0.016zM4.2 2.119l-0.169 0.112c0.056-0.038 0.112-0.075 0.169-0.112zM3.603 2.553l-0.081 0.066c0.028-0.022 0.053-0.044 0.081-0.066zM2.619 3.522l-0.069 0.084c0.025-0.028 0.047-0.056 0.069-0.084zM2.231 4.031l-0.112 0.169c0.038-0.056 0.075-0.112 0.112-0.169zM1.044 7.222l-0.016 0.169c0.003-0.056 0.009-0.112 0.016-0.169zM1.025 8.613l0.016 0.169c-0.003-0.056-0.009-0.113-0.016-0.169zM2.119 11.797l0.112 0.169c-0.038-0.053-0.075-0.109-0.112-0.169zM2.25 11.994l1.247-0.834-0.138-0.209-1.247 0.834c-0.566-0.878-0.938-1.887-1.063-2.975l0.747-0.075-0.025-0.25-0.747 0.075c-0.012-0.144-0.019-0.291-0.022-0.438h1.5v-0.25h-1.5c0.003-0.147 0.009-0.291 0.022-0.438l0.747 0.072 0.025-0.25-0.747-0.072c0.125-1.088 0.5-2.097 1.066-2.975l1.247 0.834 0.138-0.209-1.25-0.828c0.084-0.119 0.169-0.237 0.259-0.35l0.578 0.475 0.159-0.194-0.578-0.475c0.094-0.112 0.194-0.219 0.294-0.325l1.059 1.059 0.178-0.178-1.059-1.059c0.106-0.1 0.212-0.2 0.322-0.294l0.475 0.581 0.194-0.159-0.475-0.578c0.116-0.091 0.231-0.178 0.35-0.263l0.834 1.247 0.209-0.138-0.834-1.247c0.878-0.566 1.888-0.938 2.975-1.063l0.075 0.747 0.25-0.025-0.075-0.747c0.144-0.012 0.291-0.019 0.438-0.022v1.5h0.25v-1.5c0.147 0.003 0.291 0.009 0.438 0.022l-0.072 0.747 0.25 0.025 0.072-0.747c1.088 0.125 2.097 0.5 2.975 1.066l-0.834 1.247 0.209 0.138 0.834-1.247c0.119 0.084 0.238 0.169 0.35 0.259l-0.475 0.578 0.194 0.159 0.475-0.578c0.113 0.094 0.219 0.194 0.325 0.294l-0.4 0.391-5.469 3.647-3.647 5.469-0.391 0.391c-0.1-0.106-0.2-0.213-0.294-0.322l0.578-0.475-0.159-0.194-0.578 0.475c-0.091-0.113-0.175-0.231-0.259-0.35zM2.619 12.478c-0.022-0.028-0.044-0.053-0.066-0.081l0.066 0.081zM3.522 13.381l0.081 0.066c-0.028-0.022-0.053-0.044-0.081-0.066zM4.031 13.766l0.169 0.113c-0.056-0.034-0.112-0.072-0.169-0.113zM7.222 14.956l0.169 0.016c-0.056-0.003-0.112-0.009-0.169-0.016zM8.613 14.975l0.166-0.016c-0.056 0.003-0.109 0.009-0.166 0.016zM11.8 13.881l0.169-0.113c-0.056 0.037-0.113 0.075-0.169 0.113zM12.397 13.447l0.084-0.069c-0.028 0.025-0.056 0.047-0.084 0.069zM12.944 12.956l0.012-0.012c-0.003 0.003-0.009 0.009-0.012 0.012zM13.381 12.478l0.069-0.084c-0.025 0.028-0.047 0.056-0.069 0.084zM13.491 12.344l-0.578-0.475-0.159 0.194 0.578 0.475c-0.094 0.113-0.194 0.219-0.294 0.325l-1.059-1.059-0.178 0.178 1.059 1.059c-0.106 0.1-0.213 0.2-0.322 0.294l-0.475-0.581-0.194 0.159 0.475 0.578c-0.116 0.091-0.231 0.178-0.35 0.262l-0.834-1.247-0.209 0.137 0.834 1.247c-0.878 0.566-1.887 0.938-2.975 1.063l-0.075-0.747-0.25 0.025 0.075 0.747c-0.144 0.012-0.291 0.019-0.438 0.022v-1.5h-0.25v1.5c-0.147-0.003-0.291-0.009-0.438-0.022l0.072-0.747-0.25-0.025-0.072 0.747c-1.088-0.125-2.097-0.5-2.975-1.066l0.834-1.247-0.209-0.137-0.828 1.247c-0.119-0.084-0.237-0.169-0.35-0.259l0.475-0.578-0.194-0.159-0.475 0.578c-0.112-0.094-0.219-0.194-0.325-0.294l0.394-0.391 5.469-3.647 3.647-5.469 0.391-0.391c0.1 0.106 0.2 0.212 0.294 0.322l-0.578 0.475 0.159 0.194 0.578-0.475c0.091 0.116 0.178 0.231 0.262 0.35l-1.247 0.834 0.137 0.209 1.247-0.834c0.566 0.878 0.938 1.888 1.063 2.975l-0.747 0.075 0.025 0.25 0.747-0.075c0.012 0.144 0.019 0.291 0.022 0.438h-1.5v0.25h1.5c-0.003 0.147-0.009 0.291-0.022 0.438l-0.747-0.072-0.025 0.25 0.747 0.072c-0.125 1.088-0.5 2.097-1.066 2.975l-1.247-0.834-0.137 0.209 1.247 0.834c-0.081 0.113-0.169 0.228-0.259 0.344zM14.975 8.609c-0.006 0.056-0.009 0.113-0.016 0.169l0.016-0.169zM13.881 11.8c-0.037 0.056-0.075 0.113-0.113 0.169l0.113-0.169z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.758 1.111l0.293 1.471-0.245 0.049-0.293-1.471 0.245-0.049z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.245 14.89l-0.293-1.471 0.245-0.049 0.293 1.471-0.245 0.049z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.088 1.264l0.218 0.718-0.239 0.073-0.218-0.718 0.239-0.073z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.913 14.733l-0.218-0.718 0.239-0.073 0.218 0.718-0.239 0.073z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.438 1.486l0.574 1.386-0.231 0.096-0.574-1.386 0.231-0.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.564 14.515l-0.574-1.386 0.231-0.096 0.574 1.386-0.231 0.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.588 1.885l0.22-0.118 0.354 0.661-0.22 0.118-0.354-0.661z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.408 14.114l-0.22 0.118-0.354-0.661 0.22-0.118 0.354 0.661z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.884 4.591l0.662 0.353-0.118 0.221-0.661-0.353 0.118-0.221z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.113 11.409l-0.662-0.353 0.118-0.22 0.662 0.353-0.118 0.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.872 6.010l-1.386-0.574 0.096-0.231 1.386 0.574-0.096 0.231z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.13 9.989l1.386 0.574-0.096 0.231-1.386-0.574 0.096-0.231z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.337 5.85l0.718 0.218-0.073 0.239-0.718-0.218 0.073-0.239z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.661 10.151l-0.718-0.218 0.073-0.239 0.718 0.218-0.073 0.239z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.157 6.512l1.471 0.293-0.049 0.245-1.471-0.293 0.049-0.245z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.84 9.488l-1.471-0.293 0.049-0.245 1.471 0.293-0.049 0.245z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.109 9.243l1.471-0.293 0.049 0.245-1.471 0.293-0.049-0.245z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.888 6.757l-1.471 0.293-0.049-0.245 1.471-0.293 0.049 0.245z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.265 9.914l0.718-0.218 0.073 0.239-0.718 0.218-0.073-0.239z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.734 6.089l-0.718 0.218-0.073-0.239 0.718-0.218 0.073 0.239z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.58 10.796l-0.096-0.231 1.386-0.574 0.096 0.231-1.386 0.574z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.419 5.207l0.096 0.231-1.386 0.574-0.096-0.231 1.386-0.574z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.888 11.41l-0.118-0.22 0.661-0.354 0.118 0.22-0.661 0.354z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.116 4.59l0.118 0.22-0.661 0.354-0.118-0.22 0.661-0.354z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.811 14.232l-0.22-0.118 0.354-0.661 0.22 0.118-0.354 0.661z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.189 1.767l0.22 0.118-0.353 0.661-0.22-0.118 0.353-0.661z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.207 14.419l0.574-1.386 0.231 0.096-0.574 1.386-0.231-0.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.795 1.58l-0.574 1.386-0.231-0.096 0.574-1.386 0.231 0.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.088 14.735l-0.239-0.073 0.218-0.718 0.239 0.073-0.218 0.718z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.912 1.264l0.239 0.073-0.218 0.718-0.239-0.073 0.218-0.718z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.757 14.888l-0.245-0.049 0.293-1.471 0.245 0.049-0.293 1.471z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.243 1.109l0.245 0.049-0.293 1.471-0.245-0.049 0.293-1.471z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$d9fb59f67aa5a963(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v0 0c0 2.369-1.031 4.5-2.669 5.963-2.053 1-3.966 0.3-4.597-0.137 2.016-0.441 3.537-2.878 3.537-5.825s-1.522-5.384-3.537-5.828c0.634-0.438 2.547-1.137 4.597-0.138 1.637 1.466 2.669 3.597 2.669 5.966v0 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.366 3.491c-0.884 1.044-1.456 2.587-1.494 4.322 0 0.003 0 0.372 0 0.378 0.038 1.731 0.613 3.275 1.497 4.319 1.147 1.491 2.853 2.434 4.759 2.434 1.172 0 2.269-0.356 3.206-0.978-1.419 1.266-3.287 2.034-5.334 2.034-0.128 0-0.256-0.003-0.381-0.009-4.241-0.2-7.619-3.7-7.619-7.991 0-4.419 3.581-8 8-8 0.009 0 0.019 0 0.031 0 2.037 0.006 3.894 0.775 5.303 2.038-0.938-0.622-2.034-0.981-3.206-0.981-1.906 0-3.612 0.944-4.763 2.434z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$a4b02325ac70fbed(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.156 9.211c-0.213-0.21-0.686-0.321-1.406-0.331-0.487-0.005-1.073 0.038-1.69 0.124-0.276-0.159-0.561-0.333-0.784-0.542-0.601-0.561-1.103-1.34-1.415-2.197 0.020-0.080 0.038-0.15 0.054-0.222 0 0 0.339-1.923 0.249-2.573-0.012-0.089-0.020-0.115-0.044-0.184l-0.029-0.076c-0.092-0.212-0.273-0.437-0.556-0.425l-0.171-0.005c-0.316 0-0.573 0.161-0.64 0.403-0.205 0.757 0.007 1.889 0.39 3.355l-0.098 0.239c-0.275 0.67-0.619 1.345-0.923 1.94l-0.040 0.077c-0.32 0.626-0.61 1.157-0.873 1.607l-0.271 0.144c-0.020 0.010-0.485 0.257-0.594 0.323-0.926 0.553-1.539 1.18-1.641 1.678-0.032 0.159-0.008 0.362 0.156 0.456l0.263 0.132c0.114 0.057 0.234 0.086 0.357 0.086 0.659 0 1.425-0.821 2.48-2.662 1.218-0.396 2.604-0.726 3.819-0.908 0.926 0.521 2.065 0.883 2.783 0.883 0.128 0 0.238-0.012 0.327-0.036 0.138-0.037 0.254-0.115 0.325-0.222 0.139-0.21 0.168-0.499 0.13-0.795-0.011-0.088-0.081-0.196-0.157-0.271zM3.307 12.72c0.12-0.329 0.596-0.979 1.3-1.556 0.044-0.036 0.153-0.138 0.253-0.233-0.736 1.174-1.229 1.642-1.553 1.788zM7.476 3.12c0.212 0 0.333 0.534 0.343 1.035s-0.107 0.853-0.252 1.113c-0.12-0.385-0.179-0.992-0.179-1.389 0 0-0.009-0.759 0.088-0.759v0zM6.232 9.961c0.148-0.264 0.301-0.543 0.458-0.839 0.383-0.724 0.624-1.29 0.804-1.755 0.358 0.651 0.804 1.205 1.328 1.649 0.065 0.055 0.135 0.111 0.207 0.166-1.066 0.211-1.987 0.467-2.798 0.779v0zM12.952 9.901c-0.065 0.041-0.251 0.064-0.37 0.064-0.386 0-0.864-0.176-1.533-0.464 0.257-0.019 0.493-0.029 0.705-0.029 0.387 0 0.502-0.002 0.88 0.095s0.383 0.293 0.318 0.333v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$dd0df19ea1de6e81(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.785 7.37c-0.948-0.448-2.156-0.538-3.044 0.095 1.080-0.103 2.265 0.076 3.049 0.893 0.75-0.861 1.939-1.022 3.015-0.933-0.898-0.596-2.082-0.516-3.019-0.054v0zM10.401 9.465c-1.068-0.025-2.101 0.362-2.986 0.939-1.675-0.712-3.793-0.58-5.219 0.609 0.411-0.015 0.813-0.116 1.22-0.169 1.487-0.148 3.072 0.221 4.196 1.247 0.465-0.68 1.119-1.223 1.87-1.561 0.986-0.477 2.096-0.526 3.169-0.539-0.651-0.448-1.478-0.531-2.249-0.526z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$8fce5f1bdd171b1b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.997 7.436h0.691l-0.797 3.534-1.036-4.969h-1.665l-1.205 4.969-0.903-4.969h-1.741l1.767 7.998h1.701l1.192-4.73 1.066 4.73h1.568l2.025-7.998h-2.663v1.435z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$2abc6f6ae894b55e(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.61 6h-2.114l-1.496 2.204-1.496-2.204h-2.114l2.534 3.788-2.859 4.212h3.935v-1.431h-0.784l0.784-1.172 1.741 2.603h2.194l-2.859-4.212 2.534-3.788z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$9700a2605dab9220(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.354 0.354c-0.194-0.194-0.579-0.354-0.854-0.354h-6c-0.275 0-0.5 0.225-0.5 0.5v15c0 0.275 0.225 0.5 0.5 0.5h12c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.159-0.659-0.354-0.854l-5.293-5.293zM13 15h-11v-14h5.487c0.046 0.008 0.131 0.043 0.169 0.070l5.274 5.274c0.027 0.038 0.062 0.123 0.070 0.169v8.487zM13.5 0h-3c-0.275 0-0.341 0.159-0.146 0.354l3.293 3.293c0.194 0.194 0.354 0.129 0.354-0.146v-3c0-0.275-0.225-0.5-0.5-0.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$bea3beda38d2f29f(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.946 0l1.284 14.4 5.762 1.6 5.777-1.602 1.286-14.398h-14.108zM12.26 4.71h-6.758l0.161 1.809h6.437l-0.485 5.422-3.623 1.004-3.618-1.004-0.247-2.774h1.773l0.126 1.41 1.967 0.53 0.004-0.001 1.968-0.531 0.204-2.29h-6.121l-0.476-5.341h8.847l-0.158 1.766z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$cd4589600c977531(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.946 0l1.284 14.4 5.762 1.6 5.777-1.602 1.286-14.398h-14.108zM12.668 13.482l-4.644 1.287v0.007l-0.012-0.004-0.012 0.004v-0.007l-4.644-1.287-1.098-12.304h11.508l-1.098 12.304zM10.168 8.284l-0.204 2.29-1.972 0.532-1.967-0.53-0.126-1.41h-1.773l0.247 2.774 3.626 1.003 3.615-1.003 0.485-5.422h-6.437l-0.161-1.809h6.758l0.158-1.766h-8.847l0.477 5.341z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$1d9c6cd7896facf5(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.381 0.758l-0.537 2.686h10.934l-0.342 1.735h-10.94l-0.53 2.686h10.933l-0.61 3.063-4.406 1.46-3.819-1.46 0.261-1.329h-2.686l-0.639 3.224 6.316 2.417 7.281-2.417 2.403-12.066z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$7bc239cf9887d17b(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.698 7.287l-6.986-6.986c-0.402-0.402-1.055-0.402-1.457 0l-1.623 1.623 1.221 1.221c0.196-0.094 0.415-0.146 0.647-0.146 0.828 0 1.5 0.672 1.5 1.5 0 0.232-0.053 0.451-0.146 0.647l2 2c0.196-0.094 0.415-0.146 0.647-0.146 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5c0-0.232 0.053-0.451 0.146-0.647l-2-2c-0.048 0.023-0.097 0.043-0.147 0.061v4.171c0.583 0.206 1 0.761 1 1.414 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.653 0.417-1.208 1-1.414v-4.171c-0.583-0.206-1-0.761-1-1.414 0-0.232 0.053-0.451 0.146-0.647l-1.221-1.221-4.623 4.623c-0.402 0.403-0.402 1.055 0 1.458l6.986 6.986c0.402 0.402 1.054 0.402 1.457 0l6.953-6.953c0.402-0.403 0.402-1.055-0-1.458z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$5313c7a7b3e14d31(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.777 5.751l-7-4.667c-0.168-0.112-0.387-0.112-0.555 0l-7 4.667c-0.139 0.093-0.223 0.249-0.223 0.416v4.667c0 0.167 0.084 0.323 0.223 0.416l7 4.667c0.084 0.056 0.181 0.084 0.277 0.084s0.193-0.028 0.277-0.084l7-4.667c0.139-0.093 0.223-0.249 0.223-0.416v-4.667c0-0.167-0.084-0.323-0.223-0.416zM7.5 10.232l-2.599-1.732 2.599-1.732 2.599 1.732-2.599 1.732zM8 5.899v-3.465l5.599 3.732-2.599 1.732-3-2zM7 5.899l-3 2-2.599-1.732 5.599-3.732v3.465zM3.099 8.5l-2.099 1.399v-2.798l2.099 1.399zM4 9.101l3 2v3.465l-5.599-3.732 2.599-1.732zM8 11.101l3-2 2.599 1.732-5.599 3.732v-3.465zM11.901 8.5l2.099-1.399v2.798l-2.099-1.399z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$846c56bb7dae3e96(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 6.5c-0.444 0-0.843 0.193-1.118 0.5h-2.968l2.099-2.099c0.411 0.023 0.83-0.123 1.144-0.437 0.586-0.586 0.586-1.536 0-2.121s-1.536-0.586-2.121 0c-0.314 0.314-0.46 0.733-0.437 1.144l-2.099 2.099v-2.968c0.307-0.275 0.5-0.674 0.5-1.118 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.444 0.193 0.843 0.5 1.118v2.968l-2.099-2.099c0.023-0.411-0.123-0.83-0.437-1.144-0.586-0.586-1.536-0.586-2.121 0s-0.586 1.536 0 2.121c0.314 0.314 0.733 0.46 1.144 0.437l2.099 2.099h-2.968c-0.275-0.307-0.674-0.5-1.118-0.5-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.444 0 0.843-0.193 1.118-0.5h2.968l-2.099 2.099c-0.411-0.023-0.83 0.123-1.144 0.437-0.586 0.586-0.586 1.536 0 2.121s1.536 0.586 2.121 0c0.314-0.314 0.46-0.733 0.437-1.144l2.099-2.099v2.968c-0.307 0.275-0.5 0.674-0.5 1.118 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.444-0.193-0.843-0.5-1.118v-2.968l2.099 2.099c-0.023 0.411 0.123 0.83 0.437 1.144 0.586 0.586 1.536 0.586 2.121 0s0.586-1.536 0-2.121c-0.314-0.314-0.733-0.46-1.144-0.437l-2.099-2.099h2.968c0.275 0.307 0.674 0.5 1.118 0.5 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $993a3b303229c91b$export$446e601f4b8494eb(props) {
    return (0, $2d1e07c4ca826c9b$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.055 8c0-1.022 0.829-1.851 1.851-1.851s1.851 0.829 1.851 1.851c0 1.022-0.829 1.851-1.851 1.851s-1.851-0.829-1.851-1.851zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM5.928 14.989c-2.406-1.4-4.023-4.005-4.023-6.989s1.617-5.589 4.023-6.989c2.406 1.399 4.025 4.005 4.025 6.989s-1.618 5.589-4.025 6.989z"
                }
            }
        ]
    })(props);
}




var $73c0a704f4fb4345$exports = {};

$parcel$export($73c0a704f4fb4345$exports, "actionButton", function () { return $73c0a704f4fb4345$export$a75c7ea49564edd7; }, function (v) { return $73c0a704f4fb4345$export$a75c7ea49564edd7 = v; });
$parcel$export($73c0a704f4fb4345$exports, "badge", function () { return $73c0a704f4fb4345$export$4aebd143f31d0c0d; }, function (v) { return $73c0a704f4fb4345$export$4aebd143f31d0c0d = v; });
$parcel$export($73c0a704f4fb4345$exports, "column", function () { return $73c0a704f4fb4345$export$4e0c71f277ca26b3; }, function (v) { return $73c0a704f4fb4345$export$4e0c71f277ca26b3 = v; });
$parcel$export($73c0a704f4fb4345$exports, "columnLeft", function () { return $73c0a704f4fb4345$export$41ce4293be25bf01; }, function (v) { return $73c0a704f4fb4345$export$41ce4293be25bf01 = v; });
$parcel$export($73c0a704f4fb4345$exports, "commandButton", function () { return $73c0a704f4fb4345$export$74540e56d8cdd242; }, function (v) { return $73c0a704f4fb4345$export$74540e56d8cdd242 = v; });
$parcel$export($73c0a704f4fb4345$exports, "container", function () { return $73c0a704f4fb4345$export$34e0f9847d4c02dd; }, function (v) { return $73c0a704f4fb4345$export$34e0f9847d4c02dd = v; });
$parcel$export($73c0a704f4fb4345$exports, "debugView", function () { return $73c0a704f4fb4345$export$441992c85a59286b; }, function (v) { return $73c0a704f4fb4345$export$441992c85a59286b = v; });
$parcel$export($73c0a704f4fb4345$exports, "details", function () { return $73c0a704f4fb4345$export$41ee12f6f6f05843; }, function (v) { return $73c0a704f4fb4345$export$41ee12f6f6f05843 = v; });
$parcel$export($73c0a704f4fb4345$exports, "disabledInput", function () { return $73c0a704f4fb4345$export$7b46d23156d74840; }, function (v) { return $73c0a704f4fb4345$export$7b46d23156d74840 = v; });
$parcel$export($73c0a704f4fb4345$exports, "formColumn", function () { return $73c0a704f4fb4345$export$95362b939235aa01; }, function (v) { return $73c0a704f4fb4345$export$95362b939235aa01 = v; });
$parcel$export($73c0a704f4fb4345$exports, "formGroup", function () { return $73c0a704f4fb4345$export$d2297815c52203ee; }, function (v) { return $73c0a704f4fb4345$export$d2297815c52203ee = v; });
$parcel$export($73c0a704f4fb4345$exports, "formInput", function () { return $73c0a704f4fb4345$export$326bce2259f858eb; }, function (v) { return $73c0a704f4fb4345$export$326bce2259f858eb = v; });
$parcel$export($73c0a704f4fb4345$exports, "formLabel", function () { return $73c0a704f4fb4345$export$bcb34b28dae666b3; }, function (v) { return $73c0a704f4fb4345$export$bcb34b28dae666b3 = v; });
$parcel$export($73c0a704f4fb4345$exports, "formRow", function () { return $73c0a704f4fb4345$export$76df1c0434c5b653; }, function (v) { return $73c0a704f4fb4345$export$76df1c0434c5b653 = v; });
$parcel$export($73c0a704f4fb4345$exports, "formSelect", function () { return $73c0a704f4fb4345$export$b99a395818678a86; }, function (v) { return $73c0a704f4fb4345$export$b99a395818678a86 = v; });
$parcel$export($73c0a704f4fb4345$exports, "grayBackground", function () { return $73c0a704f4fb4345$export$5100d0a94c0b29b3; }, function (v) { return $73c0a704f4fb4345$export$5100d0a94c0b29b3 = v; });
$parcel$export($73c0a704f4fb4345$exports, "handIcon", function () { return $73c0a704f4fb4345$export$e571bf33bf7c896c; }, function (v) { return $73c0a704f4fb4345$export$e571bf33bf7c896c = v; });
$parcel$export($73c0a704f4fb4345$exports, "header", function () { return $73c0a704f4fb4345$export$38e42c68cf43b5d4; }, function (v) { return $73c0a704f4fb4345$export$38e42c68cf43b5d4 = v; });
$parcel$export($73c0a704f4fb4345$exports, "headerContent", function () { return $73c0a704f4fb4345$export$838c0e7679321ff3; }, function (v) { return $73c0a704f4fb4345$export$838c0e7679321ff3 = v; });
$parcel$export($73c0a704f4fb4345$exports, "heading", function () { return $73c0a704f4fb4345$export$46e4a324ac90507f; }, function (v) { return $73c0a704f4fb4345$export$46e4a324ac90507f = v; });
$parcel$export($73c0a704f4fb4345$exports, "helper", function () { return $73c0a704f4fb4345$export$4bbbbc0a0e57a7f; }, function (v) { return $73c0a704f4fb4345$export$4bbbbc0a0e57a7f = v; });
$parcel$export($73c0a704f4fb4345$exports, "icon", function () { return $73c0a704f4fb4345$export$1ca1ec8b29a4ce27; }, function (v) { return $73c0a704f4fb4345$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($73c0a704f4fb4345$exports, "iconButton", function () { return $73c0a704f4fb4345$export$60bb6c1f29b8a8cc; }, function (v) { return $73c0a704f4fb4345$export$60bb6c1f29b8a8cc = v; });
$parcel$export($73c0a704f4fb4345$exports, "input", function () { return $73c0a704f4fb4345$export$b7e3ae3d7c15e42e; }, function (v) { return $73c0a704f4fb4345$export$b7e3ae3d7c15e42e = v; });
$parcel$export($73c0a704f4fb4345$exports, "inputWithButton", function () { return $73c0a704f4fb4345$export$1106bad33904d2d4; }, function (v) { return $73c0a704f4fb4345$export$1106bad33904d2d4 = v; });
$parcel$export($73c0a704f4fb4345$exports, "link", function () { return $73c0a704f4fb4345$export$9c30223ca0a664fb; }, function (v) { return $73c0a704f4fb4345$export$9c30223ca0a664fb = v; });
$parcel$export($73c0a704f4fb4345$exports, "rawInput", function () { return $73c0a704f4fb4345$export$5c0a152c672ac95d; }, function (v) { return $73c0a704f4fb4345$export$5c0a152c672ac95d = v; });
$parcel$export($73c0a704f4fb4345$exports, "responseAction", function () { return $73c0a704f4fb4345$export$24c9bef730311970; }, function (v) { return $73c0a704f4fb4345$export$24c9bef730311970 = v; });
$parcel$export($73c0a704f4fb4345$exports, "responseDiv", function () { return $73c0a704f4fb4345$export$4ea3e83dbae90ff1; }, function (v) { return $73c0a704f4fb4345$export$4ea3e83dbae90ff1 = v; });
$parcel$export($73c0a704f4fb4345$exports, "secondaryHeading", function () { return $73c0a704f4fb4345$export$b22d4c19dfd5506f; }, function (v) { return $73c0a704f4fb4345$export$b22d4c19dfd5506f = v; });
$parcel$export($73c0a704f4fb4345$exports, "selectInput", function () { return $73c0a704f4fb4345$export$4f502711de93d534; }, function (v) { return $73c0a704f4fb4345$export$4f502711de93d534 = v; });
$parcel$export($73c0a704f4fb4345$exports, "topMargin", function () { return $73c0a704f4fb4345$export$d5cd492a56aa2350; }, function (v) { return $73c0a704f4fb4345$export$d5cd492a56aa2350 = v; });
var $73c0a704f4fb4345$export$a75c7ea49564edd7;
var $73c0a704f4fb4345$export$4aebd143f31d0c0d;
var $73c0a704f4fb4345$export$4e0c71f277ca26b3;
var $73c0a704f4fb4345$export$41ce4293be25bf01;
var $73c0a704f4fb4345$export$74540e56d8cdd242;
var $73c0a704f4fb4345$export$34e0f9847d4c02dd;
var $73c0a704f4fb4345$export$441992c85a59286b;
var $73c0a704f4fb4345$export$41ee12f6f6f05843;
var $73c0a704f4fb4345$export$7b46d23156d74840;
var $73c0a704f4fb4345$export$95362b939235aa01;
var $73c0a704f4fb4345$export$d2297815c52203ee;
var $73c0a704f4fb4345$export$326bce2259f858eb;
var $73c0a704f4fb4345$export$bcb34b28dae666b3;
var $73c0a704f4fb4345$export$76df1c0434c5b653;
var $73c0a704f4fb4345$export$b99a395818678a86;
var $73c0a704f4fb4345$export$5100d0a94c0b29b3;
var $73c0a704f4fb4345$export$e571bf33bf7c896c;
var $73c0a704f4fb4345$export$38e42c68cf43b5d4;
var $73c0a704f4fb4345$export$838c0e7679321ff3;
var $73c0a704f4fb4345$export$46e4a324ac90507f;
var $73c0a704f4fb4345$export$4bbbbc0a0e57a7f;
var $73c0a704f4fb4345$export$1ca1ec8b29a4ce27;
var $73c0a704f4fb4345$export$60bb6c1f29b8a8cc;
var $73c0a704f4fb4345$export$b7e3ae3d7c15e42e;
var $73c0a704f4fb4345$export$1106bad33904d2d4;
var $73c0a704f4fb4345$export$9c30223ca0a664fb;
var $73c0a704f4fb4345$export$5c0a152c672ac95d;
var $73c0a704f4fb4345$export$24c9bef730311970;
var $73c0a704f4fb4345$export$4ea3e83dbae90ff1;
var $73c0a704f4fb4345$export$b22d4c19dfd5506f;
var $73c0a704f4fb4345$export$4f502711de93d534;
var $73c0a704f4fb4345$export$d5cd492a56aa2350;
$73c0a704f4fb4345$export$a75c7ea49564edd7 = `r9CYoG_actionButton`;
$73c0a704f4fb4345$export$4aebd143f31d0c0d = `r9CYoG_badge`;
$73c0a704f4fb4345$export$4e0c71f277ca26b3 = `r9CYoG_column`;
$73c0a704f4fb4345$export$41ce4293be25bf01 = `r9CYoG_columnLeft`;
$73c0a704f4fb4345$export$74540e56d8cdd242 = `r9CYoG_commandButton`;
$73c0a704f4fb4345$export$34e0f9847d4c02dd = `r9CYoG_container`;
$73c0a704f4fb4345$export$441992c85a59286b = `r9CYoG_debugView`;
$73c0a704f4fb4345$export$41ee12f6f6f05843 = `r9CYoG_details`;
$73c0a704f4fb4345$export$7b46d23156d74840 = `r9CYoG_disabledInput`;
$73c0a704f4fb4345$export$95362b939235aa01 = `r9CYoG_formColumn`;
$73c0a704f4fb4345$export$d2297815c52203ee = `r9CYoG_formGroup`;
$73c0a704f4fb4345$export$326bce2259f858eb = `r9CYoG_formInput`;
$73c0a704f4fb4345$export$bcb34b28dae666b3 = `r9CYoG_formLabel`;
$73c0a704f4fb4345$export$76df1c0434c5b653 = `r9CYoG_formRow`;
$73c0a704f4fb4345$export$b99a395818678a86 = `r9CYoG_formSelect`;
$73c0a704f4fb4345$export$5100d0a94c0b29b3 = `r9CYoG_grayBackground`;
$73c0a704f4fb4345$export$e571bf33bf7c896c = `r9CYoG_handIcon`;
$73c0a704f4fb4345$export$38e42c68cf43b5d4 = `r9CYoG_header`;
$73c0a704f4fb4345$export$838c0e7679321ff3 = `r9CYoG_headerContent`;
$73c0a704f4fb4345$export$46e4a324ac90507f = `r9CYoG_heading`;
$73c0a704f4fb4345$export$4bbbbc0a0e57a7f = `r9CYoG_helper`;
$73c0a704f4fb4345$export$1ca1ec8b29a4ce27 = `r9CYoG_icon`;
$73c0a704f4fb4345$export$60bb6c1f29b8a8cc = `r9CYoG_iconButton`;
$73c0a704f4fb4345$export$b7e3ae3d7c15e42e = `r9CYoG_input`;
$73c0a704f4fb4345$export$1106bad33904d2d4 = `r9CYoG_inputWithButton`;
$73c0a704f4fb4345$export$9c30223ca0a664fb = `r9CYoG_link`;
$73c0a704f4fb4345$export$5c0a152c672ac95d = `r9CYoG_rawInput`;
$73c0a704f4fb4345$export$24c9bef730311970 = `r9CYoG_responseAction`;
$73c0a704f4fb4345$export$4ea3e83dbae90ff1 = `r9CYoG_responseDiv`;
$73c0a704f4fb4345$export$b22d4c19dfd5506f = `r9CYoG_secondaryHeading`;
$73c0a704f4fb4345$export$4f502711de93d534 = `r9CYoG_selectInput`;
$73c0a704f4fb4345$export$d5cd492a56aa2350 = `r9CYoG_topMargin`;


/**
 * FullInvPartSelector component for selecting inventory parts
 * @param {object} props - Component props
 * @param {(part: object) => void} props.partOnChange - Callback when part is selected
 * @param {string} props.selectedOrg - Selected organization ID
 * @param {boolean} props.showTitle - Whether to show the title
 * @param {string} props.title - Title text to display
 * @returns {import("react").ReactElement}
 */ const $aa779ec2c5c5a324$var$FullInvPartSelector = (props)=>{
    const { startCamera: startCamera } = (0, $78b54bd991d76db4$export$91d88843bfb219ae)();
    const selectedOrg = props?.selectedOrg;
    const [selectedPart, setSelectedPart] = (0, $lCzvA.useState)(null);
    const [selectedItem, setSelectedItem] = (0, $lCzvA.useState)('');
    const [selectedDescription, setSelectedDescription] = (0, $lCzvA.useState)('');
    const debouncedItem = (0, $03fcdd5123f454ac$export$21805fee57372823)(selectedItem, 2000);
    const debouncedDescription = (0, $03fcdd5123f454ac$export$21805fee57372823)(selectedDescription, 2000);
    const { orgItems: orgItems } = (0, $719ab5841c6e6012$export$24bedf9a427a2503)({
        orgId: selectedOrg,
        item: debouncedItem,
        descr: debouncedDescription
    });
    const sortedPartsList = (0, $lCzvA.useMemo)(()=>{
        if (!orgItems?.length) return [];
        return [
            ...orgItems
        ].toSorted((a, b)=>{
            if (a.item < b.item) return -1;
            if (a.item > b.item) return 1;
            return 0;
        });
    }, [
        orgItems
    ]);
    // If selectedPart is no longer in the current results (org/filters changed), treat it as unset
    const resolvedPart = (0, $lCzvA.useMemo)(()=>sortedPartsList.find((p)=>p.item === selectedPart?.item) ?? null, [
        selectedPart,
        sortedPartsList
    ]);
    const partOnChange = (e)=>{
        setSelectedPart(e);
        props.partOnChange(e);
    };
    const handleScannerRead = (value)=>{
        setSelectedItem(value);
    };
    const handleScannerOpen = ()=>{
        startCamera(handleScannerRead);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).container,
        children: [
            props.showTitle ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).header,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).headerContent,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                            children: props.title || 'Select Item'
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).badge,
                            children: orgItems?.length ?? 0
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).formRow,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).formColumn,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("label", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).formLabel,
                                children: "Item"
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).inputWithButton,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                                        id: "full-inv-item-input",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).formInput,
                                        type: "text",
                                        value: selectedItem,
                                        onChange: (e)=>{
                                            setSelectedItem(e.target.value);
                                            setSelectedPart(null);
                                        },
                                        placeholder: "Enter item number"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                                        type: "button",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).iconButton,
                                        onClick: handleScannerOpen,
                                        title: "Scan QR code",
                                        "aria-label": "scanner",
                                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $993a3b303229c91b$export$3254c3391ef3d669), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).formColumn,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("label", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).formLabel,
                                children: "Description"
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                                id: "full-inv-desc-input",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).formInput,
                                type: "text",
                                value: selectedDescription,
                                onChange: (e)=>{
                                    setSelectedDescription(e.target.value);
                                    setSelectedPart(null);
                                },
                                placeholder: "Enter description"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).formGroup,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("label", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).formLabel,
                        children: "Select Part*"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("select", {
                        id: "full-inv-part-select",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($73c0a704f4fb4345$exports))).selectInput,
                        value: resolvedPart ? JSON.stringify(resolvedPart) : '',
                        onChange: (e)=>{
                            if (e.target.value) {
                                const part = sortedPartsList.find((p)=>JSON.stringify(p) === e.target.value);
                                partOnChange(part);
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                value: "",
                                children: "Choose a part..."
                            }),
                            sortedPartsList.map((part)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("option", {
                                    value: JSON.stringify(part),
                                    children: [
                                        "(",
                                        part?.item,
                                        ") ",
                                        part?.description
                                    ]
                                }, part?.item ?? JSON.stringify(part)))
                        ]
                    })
                ]
            })
        ]
    });
};
var $aa779ec2c5c5a324$export$2e2bcd8739ae039 = $aa779ec2c5c5a324$var$FullInvPartSelector;






var $lCzvA = parcelRequire("lCzvA");


var $7c35ba86e04c7603$exports = {};

$parcel$export($7c35ba86e04c7603$exports, "avatar", function () { return $7c35ba86e04c7603$export$345c5736c8054f22; }, function (v) { return $7c35ba86e04c7603$export$345c5736c8054f22 = v; });
$parcel$export($7c35ba86e04c7603$exports, "bottomMargin", function () { return $7c35ba86e04c7603$export$9bc944d69a487e1b; }, function (v) { return $7c35ba86e04c7603$export$9bc944d69a487e1b = v; });
$parcel$export($7c35ba86e04c7603$exports, "card", function () { return $7c35ba86e04c7603$export$aa3e815946b80764; }, function (v) { return $7c35ba86e04c7603$export$aa3e815946b80764 = v; });
$parcel$export($7c35ba86e04c7603$exports, "form", function () { return $7c35ba86e04c7603$export$6210fa4921d2a466; }, function (v) { return $7c35ba86e04c7603$export$6210fa4921d2a466 = v; });
$parcel$export($7c35ba86e04c7603$exports, "iconSelector", function () { return $7c35ba86e04c7603$export$d7ec610668901f3f; }, function (v) { return $7c35ba86e04c7603$export$d7ec610668901f3f = v; });
$parcel$export($7c35ba86e04c7603$exports, "laborListing", function () { return $7c35ba86e04c7603$export$b37dbe1193c6bc80; }, function (v) { return $7c35ba86e04c7603$export$b37dbe1193c6bc80 = v; });
$parcel$export($7c35ba86e04c7603$exports, "paper", function () { return $7c35ba86e04c7603$export$914772be44022da8; }, function (v) { return $7c35ba86e04c7603$export$914772be44022da8 = v; });
$parcel$export($7c35ba86e04c7603$exports, "root", function () { return $7c35ba86e04c7603$export$e8e78c978b129247; }, function (v) { return $7c35ba86e04c7603$export$e8e78c978b129247 = v; });
$parcel$export($7c35ba86e04c7603$exports, "statusError", function () { return $7c35ba86e04c7603$export$9e724ff9908695f3; }, function (v) { return $7c35ba86e04c7603$export$9e724ff9908695f3 = v; });
$parcel$export($7c35ba86e04c7603$exports, "statusNew", function () { return $7c35ba86e04c7603$export$fd9eadd0f403af9a; }, function (v) { return $7c35ba86e04c7603$export$fd9eadd0f403af9a = v; });
$parcel$export($7c35ba86e04c7603$exports, "submit", function () { return $7c35ba86e04c7603$export$853c27de4ce0f746; }, function (v) { return $7c35ba86e04c7603$export$853c27de4ce0f746 = v; });
$parcel$export($7c35ba86e04c7603$exports, "topMargin", function () { return $7c35ba86e04c7603$export$d5cd492a56aa2350; }, function (v) { return $7c35ba86e04c7603$export$d5cd492a56aa2350 = v; });
var $7c35ba86e04c7603$export$345c5736c8054f22;
var $7c35ba86e04c7603$export$9bc944d69a487e1b;
var $7c35ba86e04c7603$export$aa3e815946b80764;
var $7c35ba86e04c7603$export$6210fa4921d2a466;
var $7c35ba86e04c7603$export$d7ec610668901f3f;
var $7c35ba86e04c7603$export$b37dbe1193c6bc80;
var $7c35ba86e04c7603$export$914772be44022da8;
var $7c35ba86e04c7603$export$e8e78c978b129247;
var $7c35ba86e04c7603$export$9e724ff9908695f3;
var $7c35ba86e04c7603$export$fd9eadd0f403af9a;
var $7c35ba86e04c7603$export$853c27de4ce0f746;
var $7c35ba86e04c7603$export$d5cd492a56aa2350;
$7c35ba86e04c7603$export$345c5736c8054f22 = `O2Iu0G_avatar`;
$7c35ba86e04c7603$export$9bc944d69a487e1b = `O2Iu0G_bottomMargin`;
$7c35ba86e04c7603$export$aa3e815946b80764 = `O2Iu0G_card`;
$7c35ba86e04c7603$export$6210fa4921d2a466 = `O2Iu0G_form`;
$7c35ba86e04c7603$export$d7ec610668901f3f = `O2Iu0G_iconSelector`;
$7c35ba86e04c7603$export$b37dbe1193c6bc80 = `O2Iu0G_laborListing`;
$7c35ba86e04c7603$export$914772be44022da8 = `O2Iu0G_paper`;
$7c35ba86e04c7603$export$e8e78c978b129247 = `O2Iu0G_root`;
$7c35ba86e04c7603$export$9e724ff9908695f3 = `O2Iu0G_statusError`;
$7c35ba86e04c7603$export$fd9eadd0f403af9a = `O2Iu0G_statusNew`;
$7c35ba86e04c7603$export$853c27de4ce0f746 = `O2Iu0G_submit`;
$7c35ba86e04c7603$export$d5cd492a56aa2350 = `O2Iu0G_topMargin`;


/**
 * MoveOrderItemsListing component displays the current move order transactions in a data grid.
 * @param {object} props - Component props
 * @returns {import('react').ReactElement} The MoveOrderItemsListing component
 */ const $baece2db01264858$var$MoveOrderItemsListing = (props)=>{
    const tableData = (0, $lCzvA.useMemo)(()=>(0, $99d7053f0c3be9ff$export$887549afc07359ed)(props.moveOrderItemsList), [
        props.moveOrderItemsList
    ]);
    const moveOrderItemTables = {
        moveOrderTransactions: [
            {
                headerName: 'Item',
                field: 'item',
                editable: false
            },
            {
                headerName: 'Description',
                field: 'itemDescription',
                editable: false
            },
            {
                headerName: 'UOM',
                field: 'transactionUom',
                editable: false
            },
            {
                headerName: 'Qty',
                field: 'transactionQuantity',
                editable: true
            },
            {
                headerName: 'Status',
                field: 'result',
                render: (rowData)=>{
                    if (rowData.result === '') return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7c35ba86e04c7603$exports))).statusNew,
                        children: "New"
                    });
                    else if (rowData.result === 200) return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7c35ba86e04c7603$exports))).statusNew,
                        children: "Okay"
                    });
                    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7c35ba86e04c7603$exports))).statusError,
                        children: "Error"
                    });
                },
                editable: false
            }
        ]
    };
    ///////////////////////////////////////////////////////////////////////////////////
    const editable = {
        onRowUpdate: (_newValue, _oldValue, _rowData, _columnDef)=>{
            props.updateRecord(_newValue, _oldValue);
            return Promise.resolve(true);
        },
        onRowDelete: (oldValue, _rowData, _columnDef)=>{
            props.deleteRecord(oldValue, _rowData);
            return Promise.resolve(true);
        }
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7c35ba86e04c7603$exports))).root,
        children: tableData?.length > 0 ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($7c35ba86e04c7603$exports))).topMargin} ${(0, (/*@__PURE__*/$parcel$interopDefault($7c35ba86e04c7603$exports))).bottomMargin}`,
            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $bb8cae2cae6f2fbe$export$2e2bcd8739ae039), {
                copy: false,
                title: "Current Move Order Items",
                density: "compact",
                pageSize: 5,
                columns: moveOrderItemTables.moveOrderTransactions,
                rows: tableData,
                editable: editable
            })
        }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
            children: "No transactions currently added!"
        })
    });
};
var $baece2db01264858$export$2e2bcd8739ae039 = $baece2db01264858$var$MoveOrderItemsListing;







var $ec51516fb3ec66b6$exports = {};

$parcel$export($ec51516fb3ec66b6$exports, "detailItem", function () { return $ec51516fb3ec66b6$export$ed1a34ab90421697; }, function (v) { return $ec51516fb3ec66b6$export$ed1a34ab90421697 = v; });
$parcel$export($ec51516fb3ec66b6$exports, "detailLabel", function () { return $ec51516fb3ec66b6$export$914104b4709683c0; }, function (v) { return $ec51516fb3ec66b6$export$914104b4709683c0 = v; });
$parcel$export($ec51516fb3ec66b6$exports, "detailValue", function () { return $ec51516fb3ec66b6$export$773e0470ffdada72; }, function (v) { return $ec51516fb3ec66b6$export$773e0470ffdada72 = v; });
$parcel$export($ec51516fb3ec66b6$exports, "divider", function () { return $ec51516fb3ec66b6$export$e8c9778bf415dd08; }, function (v) { return $ec51516fb3ec66b6$export$e8c9778bf415dd08 = v; });
$parcel$export($ec51516fb3ec66b6$exports, "equipmentDetails", function () { return $ec51516fb3ec66b6$export$8ad5b8606abb7ce7; }, function (v) { return $ec51516fb3ec66b6$export$8ad5b8606abb7ce7 = v; });
$parcel$export($ec51516fb3ec66b6$exports, "header", function () { return $ec51516fb3ec66b6$export$38e42c68cf43b5d4; }, function (v) { return $ec51516fb3ec66b6$export$38e42c68cf43b5d4 = v; });
$parcel$export($ec51516fb3ec66b6$exports, "headerTitle", function () { return $ec51516fb3ec66b6$export$15c60d712917cee6; }, function (v) { return $ec51516fb3ec66b6$export$15c60d712917cee6 = v; });
$parcel$export($ec51516fb3ec66b6$exports, "infoItem", function () { return $ec51516fb3ec66b6$export$e9205afa0ff1255b; }, function (v) { return $ec51516fb3ec66b6$export$e9205afa0ff1255b = v; });
$parcel$export($ec51516fb3ec66b6$exports, "infoLabel", function () { return $ec51516fb3ec66b6$export$143a635659e84f43; }, function (v) { return $ec51516fb3ec66b6$export$143a635659e84f43 = v; });
$parcel$export($ec51516fb3ec66b6$exports, "infoRow", function () { return $ec51516fb3ec66b6$export$2ca4ee022283be41; }, function (v) { return $ec51516fb3ec66b6$export$2ca4ee022283be41 = v; });
$parcel$export($ec51516fb3ec66b6$exports, "infoValue", function () { return $ec51516fb3ec66b6$export$686affbf436a599a; }, function (v) { return $ec51516fb3ec66b6$export$686affbf436a599a = v; });
var $ec51516fb3ec66b6$export$ed1a34ab90421697;
var $ec51516fb3ec66b6$export$914104b4709683c0;
var $ec51516fb3ec66b6$export$773e0470ffdada72;
var $ec51516fb3ec66b6$export$e8c9778bf415dd08;
var $ec51516fb3ec66b6$export$8ad5b8606abb7ce7;
var $ec51516fb3ec66b6$export$38e42c68cf43b5d4;
var $ec51516fb3ec66b6$export$15c60d712917cee6;
var $ec51516fb3ec66b6$export$e9205afa0ff1255b;
var $ec51516fb3ec66b6$export$143a635659e84f43;
var $ec51516fb3ec66b6$export$2ca4ee022283be41;
var $ec51516fb3ec66b6$export$686affbf436a599a;
$ec51516fb3ec66b6$export$ed1a34ab90421697 = `OWJhaW_detailItem`;
$ec51516fb3ec66b6$export$914104b4709683c0 = `OWJhaW_detailLabel`;
$ec51516fb3ec66b6$export$773e0470ffdada72 = `OWJhaW_detailValue`;
$ec51516fb3ec66b6$export$e8c9778bf415dd08 = `OWJhaW_divider`;
$ec51516fb3ec66b6$export$8ad5b8606abb7ce7 = `OWJhaW_equipmentDetails`;
$ec51516fb3ec66b6$export$38e42c68cf43b5d4 = `OWJhaW_header`;
$ec51516fb3ec66b6$export$15c60d712917cee6 = `OWJhaW_headerTitle`;
$ec51516fb3ec66b6$export$e9205afa0ff1255b = `OWJhaW_infoItem`;
$ec51516fb3ec66b6$export$143a635659e84f43 = `OWJhaW_infoLabel`;
$ec51516fb3ec66b6$export$2ca4ee022283be41 = `OWJhaW_infoRow`;
$ec51516fb3ec66b6$export$686affbf436a599a = `OWJhaW_infoValue`;


/**
 * Displays equipment information such as site, department, and equipment details.
 * @param {object} root0 - Component props
 * @param {object} [root0.selectedEquipment] - The currently selected equipment object
 * @param {boolean} [root0.scanAgainVisible] - Whether the scan again button should be visible
 * @param {() => void} [root0.handleScanAgain] - Handler for the scan again button click
 * @returns {import('react').ReactElement} The EquipmentInfoSection component
 */ const $8ccb25c8231cf70d$var$EquipmentInfoSection = ({ selectedEquipment: selectedEquipment, scanAgainVisible: scanAgainVisible, handleScanAgain: handleScanAgain })=>{
    const { t: t } = (0, $8216e3af17948d6d$export$9fc83ad70ead8663)();
    const notSelectedText = t('notSelected');
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).header,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h2", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).headerTitle,
                    children: t('equipmentActionPortalTitle')
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).divider
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).infoRow,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).infoItem,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).infoLabel,
                                children: [
                                    t('site'),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).infoValue,
                                children: selectedEquipment?.siteId ?? notSelectedText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).infoItem,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).infoLabel,
                                children: [
                                    t('department'),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).infoValue,
                                children: selectedEquipment?.location ?? notSelectedText
                            })
                        ]
                    }),
                    scanAgainVisible && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).infoItem,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            size: "sm",
                            color: "primary",
                            onClick: handleScanAgain,
                            children: t('scanQRCode')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).divider
            }),
            selectedEquipment && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8fedcf22c00c4cdd$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9e4c7ade3285342d$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $dffdfe16b69939eb$export$2e2bcd8739ae039), {
                            children: `${t('equipmentNumber')}: ${selectedEquipment.equipNum} - ${t('description')}: ${selectedEquipment.description}`
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $d9ac194a6f540d5b$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).equipmentDetails,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).detailItem,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).detailLabel,
                                                children: [
                                                    t('department'),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).detailValue,
                                                children: selectedEquipment?.departmentId
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).detailItem,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).detailLabel,
                                                children: [
                                                    t('location'),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).detailValue,
                                                children: selectedEquipment?.location
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).detailItem,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).detailLabel,
                                                children: [
                                                    t('costCenter'),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec51516fb3ec66b6$exports))).detailValue,
                                                children: selectedEquipment?.costcenterId
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $8ccb25c8231cf70d$export$2e2bcd8739ae039 = $8ccb25c8231cf70d$var$EquipmentInfoSection;








var $lCzvA = parcelRequire("lCzvA");






var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");
var $fda7e4dd83174a6e$var$l = function() {
    return $fda7e4dd83174a6e$var$l = Object.assign || function(t) {
        for(var n, e = 1, r = arguments.length; e < r; e++)for(var i in n = arguments[e])Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
        return t;
    }, $fda7e4dd83174a6e$var$l.apply(this, arguments);
}, $fda7e4dd83174a6e$var$c = new (function() {
    function t() {
        this.e = {};
    }
    return t.prototype.generateCallbackId = function() {
        return Math.random().toString(36).substring(7);
    }, t.prototype.on = function(t, n, e) {
        var r = this, i = this.e || (this.e = {}), o = this.generateCallbackId(), a = {
            id: o,
            fn: n,
            ctx: e
        };
        (i[t] || (i[t] = [])).push(a);
        return (function() {
            r.off(t, o);
        }).bind(this);
    }, t.prototype.once = function(t, n, e) {
        var r = this, i = this.generateCallbackId();
        function o() {
            for(var o = [], a = 0; a < arguments.length; a++)o[a] = arguments[a];
            r.off(t, i), n.apply(e, o);
        }
        return o._ = n, this.on(t, o, e);
    }, t.prototype.emit = function(t) {
        for(var n = [], e = 1; e < arguments.length; e++)n[e - 1] = arguments[e];
        for(var r = ((this.e || (this.e = {}))[t] || []).slice(), i = r.length, o = 0; o < i; o++)r[o].fn.apply(r[o].ctx, n);
        return this;
    }, t.prototype.off = function(t, n, e) {
        var r = this.e || (this.e = {}), i = r[t], o = [];
        if (i && n) for(var a = 0, u = i.length; a < u; a++)("function" == typeof n && i[a].fn !== n || "string" == typeof n && i[a].id !== n) && o.push(i[a]);
        return o.length ? r[t] = o : delete r[t], this;
    }, t;
}()), $fda7e4dd83174a6e$export$d20ba6ba2e7f6098 = (0, $lCzvA.createContext)(null), $fda7e4dd83174a6e$export$248fcaff50e7b757 = function(n) {
    var r = n.flagsmith, i = n.options, o = n.serverState, a = n.children, u = (0, $lCzvA.useRef)(!0);
    return r && !(null == r ? void 0 : r._trigger) && (r._trigger = function() {
        null == r || r.log("React - trigger event received"), $fda7e4dd83174a6e$var$c.emit("event");
    }), r && !(null == r ? void 0 : r._triggerLoadingState) && (r._triggerLoadingState = function() {
        $fda7e4dd83174a6e$var$c.emit("loading_event");
    }), o && !r.initialised && r.setState(o), u.current && (u.current = !1, i && r.init($fda7e4dd83174a6e$var$l($fda7e4dd83174a6e$var$l({}, i), {
        state: i.state || o,
        onChange: function() {
            for(var t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n];
            i.onChange && i.onChange.apply(i, t);
        }
    })).catch(function(t) {
        null == r || r.log("React - Failed to initialize flagsmith", t), $fda7e4dd83174a6e$var$c.emit("event");
    })), (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($fda7e4dd83174a6e$export$d20ba6ba2e7f6098.Provider, {
        value: r
    }, a);
}, $fda7e4dd83174a6e$var$g = function(t) {
    var n = (0, $lCzvA.useRef)(t);
    return n.current || (n.current = t), n.current;
}, $fda7e4dd83174a6e$var$h = function(t) {
    if ("string" == typeof t) return [
        t
    ];
    if ("object" == typeof t && t.hasOwnProperty("length")) return t;
    throw new Error("Flagsmith: please supply an array of strings or a single string of flag keys to useFlags");
}, $fda7e4dd83174a6e$var$v = function(t, n, e) {
    return void 0 === e && (e = []), n.map(function(n) {
        return "".concat(t.getValue(n)).concat(t.hasFeature(n));
    }).concat(e.map(function(n) {
        return "".concat(t.getTrait(n));
    })).join(",");
};
function $fda7e4dd83174a6e$export$c3c6a5389a9d7973() {
    var t = (0, $lCzvA.useContext)($fda7e4dd83174a6e$export$d20ba6ba2e7f6098), n = (0, $lCzvA.useState)(null == t ? void 0 : t.loadingState), u = n[0], l = n[1], s = (0, $lCzvA.useState)(!1), g = s[0], h = s[1], v = (0, $lCzvA.useRef)(g), p = (0, $lCzvA.useCallback)(function() {
        l(null == t ? void 0 : t.loadingState);
    }, [
        t
    ]);
    return v.current || ($fda7e4dd83174a6e$var$c.on("loading_event", p), v.current = !0), (0, $lCzvA.useEffect)(function() {
        return !g && (null == t ? void 0 : t.initialised) && ($fda7e4dd83174a6e$var$c.on("loading_event", p), h(!0)), function() {
            g && $fda7e4dd83174a6e$var$c.off("loading_event", p);
        };
    }, [
        t,
        g,
        p
    ]), u;
}
function $fda7e4dd83174a6e$export$2879604e6aec4ab(t, n) {
    void 0 === n && (n = []);
    var l = (0, $lCzvA.useRef)(!0), s = $fda7e4dd83174a6e$var$g($fda7e4dd83174a6e$var$h(t)), p = $fda7e4dd83174a6e$var$g($fda7e4dd83174a6e$var$h(n)), d = (0, $lCzvA.useContext)($fda7e4dd83174a6e$export$d20ba6ba2e7f6098), y = (0, $lCzvA.useState)($fda7e4dd83174a6e$var$v(d, s, p)), m = y[0], b = y[1], _ = (0, $lCzvA.useCallback)(function() {
        var t = $fda7e4dd83174a6e$var$v(d, s, p);
        t !== m && (null == d || d.log("React - useFlags flags and traits have changed"), b(t));
    }, [
        m
    ]), w = (0, $lCzvA.useRef)($fda7e4dd83174a6e$var$c.once("event", _));
    return l.current && (l.current = !1, null == d || d.log("React - Initialising event listeners")), (0, $lCzvA.useEffect)(function() {
        return function() {
            var t;
            null === (t = w.current) || void 0 === t || t.call(w);
        };
    }, []), (0, $lCzvA.useMemo)(function() {
        var t = {};
        return s.map(function(n) {
            t[n] = {
                enabled: d.hasFeature(n),
                value: d.getValue(n)
            };
        }).concat(null == p ? void 0 : p.map(function(n) {
            t[n] = d.getTrait(n);
        })), t;
    }, [
        m
    ]);
}
function $fda7e4dd83174a6e$export$b05eccb4cbfc7ed7() {
    var t = (0, $lCzvA.useContext)($fda7e4dd83174a6e$export$d20ba6ba2e7f6098);
    if (!t) throw new Error("useFlagsmith must be used with in a FlagsmithProvider");
    return t;
}





var $lCzvA = parcelRequire("lCzvA");







var $4cdc1fbc18f0a98d$exports = {};

$parcel$export($4cdc1fbc18f0a98d$exports, "column", function () { return $4cdc1fbc18f0a98d$export$4e0c71f277ca26b3; }, function (v) { return $4cdc1fbc18f0a98d$export$4e0c71f277ca26b3 = v; });
$parcel$export($4cdc1fbc18f0a98d$exports, "loadingBox", function () { return $4cdc1fbc18f0a98d$export$3bcf18f7e1b94062; }, function (v) { return $4cdc1fbc18f0a98d$export$3bcf18f7e1b94062 = v; });
$parcel$export($4cdc1fbc18f0a98d$exports, "marginY", function () { return $4cdc1fbc18f0a98d$export$6836597bb670ec38; }, function (v) { return $4cdc1fbc18f0a98d$export$6836597bb670ec38 = v; });
$parcel$export($4cdc1fbc18f0a98d$exports, "questionsContainer", function () { return $4cdc1fbc18f0a98d$export$9fa05c150e6cc632; }, function (v) { return $4cdc1fbc18f0a98d$export$9fa05c150e6cc632 = v; });
$parcel$export($4cdc1fbc18f0a98d$exports, "stickyGrid", function () { return $4cdc1fbc18f0a98d$export$a008934d5c76b02d; }, function (v) { return $4cdc1fbc18f0a98d$export$a008934d5c76b02d = v; });
var $4cdc1fbc18f0a98d$export$4e0c71f277ca26b3;
var $4cdc1fbc18f0a98d$export$3bcf18f7e1b94062;
var $4cdc1fbc18f0a98d$export$6836597bb670ec38;
var $4cdc1fbc18f0a98d$export$9fa05c150e6cc632;
var $4cdc1fbc18f0a98d$export$a008934d5c76b02d;
$4cdc1fbc18f0a98d$export$4e0c71f277ca26b3 = `giRl7G_column`;
$4cdc1fbc18f0a98d$export$3bcf18f7e1b94062 = `giRl7G_loadingBox`;
$4cdc1fbc18f0a98d$export$6836597bb670ec38 = `giRl7G_marginY`;
$4cdc1fbc18f0a98d$export$9fa05c150e6cc632 = `giRl7G_questionsContainer`;
$4cdc1fbc18f0a98d$export$a008934d5c76b02d = `giRl7G_stickyGrid`;


const $36c4b870735c5953$var$AnyQuestionAnswers = /** @type {import('react').ElementType} */ (0, $3865473f74196807$export$2e2bcd8739ae039);
const $36c4b870735c5953$var$getCurrentTimestamp = ()=>Date.now();
/**
 * The screen with follow-up questions
 * @param {object} props - The props for the component.
 * @param {string} props.conversationId - Id of the conversation
 * @param {string} props.equipmentNumber - Equipment number
 * @param {string} props.siteId - Site ID
 * @param {(summaryText: string) => void} props.setSummaryText - On getting the summary text
 * @param {() => void} props.onCloseSummaryGenerationErrorModal - called when the summary generation error modal is closed
 * @param {() => void} props.onCloseRequestCompleted - Called when request is successfully closed
 * @param {import('../../pages/EquipActionPortal/questionTypes').FollowUpQuestion[]} props.followUpQuestions - The questions which appear that user can answer for additional details
 * @param {(followUpQuestions: import('../../pages/EquipActionPortal/questionTypes').FollowUpQuestion[]) => void} props.setFollowUpQuestions - Setting/updating the follow-up questions
 * @param {() => void} props.handleSubmitWorkOrder - Called to submit the work order directly
 * @param {number | null} props.downtimeStartTime - Epoch time when Continue button was clicked
 * @param {(data: {outcome: string, followUpQuestions: Array, arrivedAt: number, cancellationReason?: string, cancellationReasonDetails?: string}) => void} [props.onRecordAnalytics] - Called when the user submits or cancels to capture analytics
 * @returns {import('react').ReactElement} The DescribeProblem component
 */ const $36c4b870735c5953$var$DescribeProblem = ({ conversationId: conversationId, equipmentNumber: equipmentNumber, siteId: siteId, setSummaryText: setSummaryText, onCloseSummaryGenerationErrorModal: onCloseSummaryGenerationErrorModal, onCloseRequestCompleted: onCloseRequestCompleted, followUpQuestions: followUpQuestions, setFollowUpQuestions: setFollowUpQuestions, handleSubmitWorkOrder: handleSubmitWorkOrder, downtimeStartTime: downtimeStartTime, onRecordAnalytics: onRecordAnalytics })=>{
    const [isCancellationReasonDialogOpen, setIsCancellationReasonDialogOpen] = (0, $lCzvA.useState)(false);
    const arrivedAtRef = (0, $lCzvA.useRef)(0);
    const prevFollowUpQuestionsDataRef = (0, $lCzvA.useRef)(undefined);
    const { t: t, i18n: i18n } = (0, $8216e3af17948d6d$export$9fc83ad70ead8663)();
    const userLanguage = /** @type {"en" | "es"} */ i18n.language?.slice(0, 2);
    const { data: followUpQuestionsData, isLoading: loadingFollowUpQuestions, error: followUpQuestionsError, refetch: refetchFollowUpQuestions } = (0, $fd8a60a16d73d8a8$export$54183b3c3960b967)({
        conversationId: conversationId,
        userLanguage: userLanguage
    });
    (0, $lCzvA.useEffect)(()=>{
        arrivedAtRef.current = $36c4b870735c5953$var$getCurrentTimestamp();
    }, []);
    (0, $lCzvA.useEffect)(()=>{
        if (followUpQuestionsError) (0, $673b1c81cc441170$export$2e2bcd8739ae039).warning(t('followUpQuestionsErrorContent', {
            error: followUpQuestionsError?.message
        }));
    }, [
        followUpQuestionsError,
        t
    ]);
    const { mutate: fetchWorkOrderSummary, isPending: loadingWorkOrderSummary } = (0, $fd8a60a16d73d8a8$export$56232c8e32e88255)({
        onSuccess: (data)=>{
            // Loading bar hidden by TanStack Query GlobalLoading
            setSummaryText(data?.summaryText);
        },
        onError: (err)=>{
            // Loading bar hidden by TanStack Query GlobalLoading
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(t('aiSummaryErrorContent', {
                error: err?.message
            }));
            onCloseSummaryGenerationErrorModal();
        }
    });
    const { mutate: createTracking, isPending: loadingCreateTracking } = (0, $fd8a60a16d73d8a8$export$3f0a139d1a6afa42)({
        onSuccess: ()=>{
            // Loading bar hidden by TanStack Query GlobalLoading
            onCloseRequestCompleted();
        },
        onError: (err)=>{
            // Loading bar hidden by TanStack Query GlobalLoading
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(t('closeRequestErrorContent', {
                error: err?.message
            }));
        }
    });
    const allQuestionsAnswered = followUpQuestions.every((question)=>question.selectedAnswer !== (0, $a7ed3f1def80a908$export$66b13602a3bd73a9).NONE_SELECTED);
    const disabledCloseButton = loadingWorkOrderSummary || loadingCreateTracking || loadingFollowUpQuestions;
    const disabledSubmitButton = disabledCloseButton || !allQuestionsAnswered;
    (0, $lCzvA.useEffect)(()=>{
        const payload = /** @type {{questions?: Record<string, unknown>[]}} */ followUpQuestionsData;
        const questions = Array.isArray(payload?.questions) ? /** @type {Record<string, unknown>[]} */ payload.questions : undefined;
        if (!questions || followUpQuestionsData === prevFollowUpQuestionsDataRef.current) return;
        prevFollowUpQuestionsDataRef.current = followUpQuestionsData;
        const setQuestions = /** @type {import('react').Dispatch<import('react').SetStateAction<any[]>>} */ setFollowUpQuestions;
        setQuestions((prevFollowUpQuestions)=>questions.map((question)=>({
                    ...question,
                    selectedAnswer: prevFollowUpQuestions?.find((prevFollowUpQuestion)=>prevFollowUpQuestion.id === question.id)?.selectedAnswer ?? (0, $a7ed3f1def80a908$export$66b13602a3bd73a9).NONE_SELECTED,
                    additionalDetails: ''
                })));
    }, [
        followUpQuestionsData,
        setFollowUpQuestions
    ]);
    const handleOnSelectAnswer = (selectedAnswer, questionId)=>{
        const answeredAt = $36c4b870735c5953$var$getCurrentTimestamp();
        setFollowUpQuestions(followUpQuestions.map((question)=>question.id === questionId ? {
                ...question,
                selectedAnswer: question.selectedAnswer === selectedAnswer ? (0, $a7ed3f1def80a908$export$66b13602a3bd73a9).NONE_SELECTED : selectedAnswer,
                additionalDetails: '',
                answeredAt: question.selectedAnswer === selectedAnswer ? null : answeredAt
            } : question));
    };
    const handleOnChangeAdditionalDetails = (event, questionId)=>{
        setFollowUpQuestions(followUpQuestions.map((question)=>question.id === questionId ? {
                ...question,
                additionalDetails: event?.target?.value
            } : question));
    };
    const handleOnSubmitWorkOrder = ()=>{
        onRecordAnalytics?.({
            outcome: 'submitted',
            followUpQuestions: followUpQuestions,
            arrivedAt: arrivedAtRef.current
        });
        const answeredQuestions = (0, $22c30186782c8364$export$962cb8e7aa1c82a)(followUpQuestions);
        // Skip AI summary generation if no questions were answered
        if (!answeredQuestions.length) {
            // Call the parent component's handleSubmitWorkOrder function directly
            handleSubmitWorkOrder();
            return;
        }
        // Otherwise, proceed with AI summary generation as before
        // Loading bar shown by TanStack Query GlobalLoading
        fetchWorkOrderSummary({
            conversationId: conversationId,
            questionAnswers: answeredQuestions,
            userLanguage: userLanguage
        });
    };
    const handleOnCloseRequest = ()=>{
        setIsCancellationReasonDialogOpen(true);
    };
    const handleRefetchFollowUpQuestions = ()=>{
        refetchFollowUpQuestions();
    };
    const onCloseCancellationReasonDialog = ()=>{
        setIsCancellationReasonDialogOpen(false);
    };
    /**
   * Called when cancellation reason dialog is submitted
   * @param {string} selectedReason - The selected cancellation reason.
   * @param {string} additionalDetails - Additional details provided for the cancellation reason.
   */ const onConfirmCancellationReasonDialog = (selectedReason, additionalDetails)=>{
        if (!selectedReason) return;
        onRecordAnalytics?.({
            outcome: 'cancelled',
            followUpQuestions: followUpQuestions,
            arrivedAt: arrivedAtRef.current,
            cancellationReason: selectedReason,
            cancellationReasonDetails: additionalDetails
        });
        // Loading bar shown by TanStack Query GlobalLoading
        createTracking({
            isRequestOpen: false,
            conversationId: conversationId,
            questionAnswers: (0, $22c30186782c8364$export$962cb8e7aa1c82a)(followUpQuestions),
            equipmentNumber: equipmentNumber,
            siteId: siteId,
            closureReason: selectedReason,
            closureReasonDetails: additionalDetails,
            downtimeStartTime: downtimeStartTime,
            userLanguage: userLanguage
        });
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cdc1fbc18f0a98d$exports))).column,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h6", {
                                children: t('describeProblem')
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $5e00724294f8db91$export$8d6a9236f2e3f2ce), {
                                    i18nKey: "describeProblemInstructions",
                                    components: {
                                        b: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {})
                                    }
                                })
                            }),
                            followUpQuestionsError && !loadingFollowUpQuestions && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cdc1fbc18f0a98d$exports))).marginY,
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    "data-testid": "refetchFollowUpQuestionsButton",
                                    color: "secondary",
                                    size: "sm",
                                    onClick: handleRefetchFollowUpQuestions,
                                    children: t('refetchQuestions')
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4cdc1fbc18f0a98d$exports))).questionsContainer,
                        children: loadingFollowUpQuestions ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4cdc1fbc18f0a98d$exports))).loadingBox
                        }) : followUpQuestions?.map(({ id: id, text: text, selectedAnswer: selectedAnswer, additionalDetails: additionalDetails })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($36c4b870735c5953$var$AnyQuestionAnswers, {
                                question: text,
                                questionNumber: id,
                                answerSelected: selectedAnswer,
                                onSelectAnswer: (answer)=>handleOnSelectAnswer(answer, id),
                                additionalDetails: additionalDetails,
                                onChangeAdditionalDetails: (e)=>handleOnChangeAdditionalDetails(e, id)
                            }, id))
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4cdc1fbc18f0a98d$exports))).stickyGrid,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    color: "secondary",
                                    size: "sm",
                                    disabled: disabledSubmitButton,
                                    onClick: handleOnSubmitWorkOrder,
                                    children: t('submitWorkOrder')
                                })
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    color: "primary-alt",
                                    size: "sm",
                                    disabled: disabledCloseButton,
                                    onClick: handleOnCloseRequest,
                                    children: loadingCreateTracking ? `${t('loading')}...` : t('closeRequest')
                                })
                            }),
                            loadingCreateTracking && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cdc1fbc18f0a98d$exports))).loadingBox
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $499108432d0848f8$export$2e2bcd8739ae039), {
                isOpen: isCancellationReasonDialogOpen,
                onClose: onCloseCancellationReasonDialog,
                onConfirm: onConfirmCancellationReasonDialog
            })
        ]
    });
};
var $36c4b870735c5953$export$2e2bcd8739ae039 = $36c4b870735c5953$var$DescribeProblem;








var $47c998ca7d0648ef$exports = {};

$parcel$export($47c998ca7d0648ef$exports, "buttonContainer", function () { return $47c998ca7d0648ef$export$dc57ddd528b7443f; }, function (v) { return $47c998ca7d0648ef$export$dc57ddd528b7443f = v; });
$parcel$export($47c998ca7d0648ef$exports, "formContainer", function () { return $47c998ca7d0648ef$export$231ba5fc42c01d86; }, function (v) { return $47c998ca7d0648ef$export$231ba5fc42c01d86 = v; });
$parcel$export($47c998ca7d0648ef$exports, "formGroup", function () { return $47c998ca7d0648ef$export$d2297815c52203ee; }, function (v) { return $47c998ca7d0648ef$export$d2297815c52203ee = v; });
$parcel$export($47c998ca7d0648ef$exports, "formInput", function () { return $47c998ca7d0648ef$export$326bce2259f858eb; }, function (v) { return $47c998ca7d0648ef$export$326bce2259f858eb = v; });
$parcel$export($47c998ca7d0648ef$exports, "formLabel", function () { return $47c998ca7d0648ef$export$bcb34b28dae666b3; }, function (v) { return $47c998ca7d0648ef$export$bcb34b28dae666b3 = v; });
$parcel$export($47c998ca7d0648ef$exports, "formRow", function () { return $47c998ca7d0648ef$export$76df1c0434c5b653; }, function (v) { return $47c998ca7d0648ef$export$76df1c0434c5b653 = v; });
$parcel$export($47c998ca7d0648ef$exports, "narrowField", function () { return $47c998ca7d0648ef$export$56ddd00e8a53b11f; }, function (v) { return $47c998ca7d0648ef$export$56ddd00e8a53b11f = v; });
$parcel$export($47c998ca7d0648ef$exports, "selectInput", function () { return $47c998ca7d0648ef$export$4f502711de93d534; }, function (v) { return $47c998ca7d0648ef$export$4f502711de93d534 = v; });
var $47c998ca7d0648ef$export$dc57ddd528b7443f;
var $47c998ca7d0648ef$export$231ba5fc42c01d86;
var $47c998ca7d0648ef$export$d2297815c52203ee;
var $47c998ca7d0648ef$export$326bce2259f858eb;
var $47c998ca7d0648ef$export$bcb34b28dae666b3;
var $47c998ca7d0648ef$export$76df1c0434c5b653;
var $47c998ca7d0648ef$export$56ddd00e8a53b11f;
var $47c998ca7d0648ef$export$4f502711de93d534;
$47c998ca7d0648ef$export$dc57ddd528b7443f = `_5IgfSq_buttonContainer`;
$47c998ca7d0648ef$export$231ba5fc42c01d86 = `_5IgfSq_formContainer`;
$47c998ca7d0648ef$export$d2297815c52203ee = `_5IgfSq_formGroup`;
$47c998ca7d0648ef$export$326bce2259f858eb = `_5IgfSq_formInput`;
$47c998ca7d0648ef$export$bcb34b28dae666b3 = `_5IgfSq_formLabel`;
$47c998ca7d0648ef$export$76df1c0434c5b653 = `_5IgfSq_formRow`;
$47c998ca7d0648ef$export$56ddd00e8a53b11f = `_5IgfSq_narrowField`;
$47c998ca7d0648ef$export$4f502711de93d534 = `_5IgfSq_selectInput`;


/**
 * Form component for equipment actions
 * @param {object} root0 - Component props
 * @param {string} root0.comment - Comment text
 * @param {(e: import('react').ChangeEvent<HTMLTextAreaElement>) => void} root0.onCommentChange - Callback for comment changes
 * @param {string} root0.empNumber - Employee number
 * @param {(e: import('react').ChangeEvent<HTMLInputElement>) => void} root0.onEmpNumberChange - Callback for employee number changes
 * @param {object} root0.serviceAreaSelected - Selected service area
 * @param {object} root0.serviceActionSelected - Selected service action
 * @param {Array<object>} root0.filteredServiceAreas - Filtered service areas list
 * @param {Array<object>} root0.filteredServiceActions - Filtered service actions list
 * @param {(area: object) => void} root0.onServiceAreaChange - Callback for service area changes
 * @param {(action: object) => void} root0.onServiceActionChange - Callback for service action changes
 * @param {object} root0.selectedEquipment - Selected equipment object
 * @param {boolean} root0.isSubmitting - Whether form is currently submitting
 * @param {boolean} root0.loadingCreateConversation - Whether conversation creation is loading
 * @param {boolean} root0.isMaintenanceCopilotFlagEnabled - Whether maintenance copilot is enabled
 * @param {(event: import('react').FormEvent) => void} root0.onSubmit - Form submission handler
 * @param {() => void} root0.onCancel - Cancel handler
 * @param {() => void} root0.onCreateConversation - Create conversation handler
 * @returns {import('react').ReactElement} The EquipActionForm component
 */ const $9a09de79f8300ba3$var$EquipActionForm = ({ comment: comment, onCommentChange: onCommentChange, empNumber: empNumber, onEmpNumberChange: onEmpNumberChange, serviceAreaSelected: serviceAreaSelected, serviceActionSelected: serviceActionSelected, filteredServiceAreas: filteredServiceAreas, filteredServiceActions: filteredServiceActions, onServiceAreaChange: onServiceAreaChange, onServiceActionChange: onServiceActionChange, selectedEquipment: selectedEquipment, isSubmitting: isSubmitting, loadingCreateConversation: loadingCreateConversation, isMaintenanceCopilotFlagEnabled: isMaintenanceCopilotFlagEnabled, onSubmit: onSubmit, onCancel: onCancel, onCreateConversation: onCreateConversation })=>{
    const { t: t } = (0, $8216e3af17948d6d$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("form", {
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formContainer,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formGroup,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("label", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formLabel,
                            children: [
                                t('employeeNumber'),
                                "*"
                            ]
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                            id: "emp-num",
                            name: "emp-num",
                            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formInput} ${(0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).narrowField}`,
                            type: "text",
                            value: empNumber,
                            onChange: onEmpNumberChange,
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formRow,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formGroup,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("label", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formLabel,
                                    children: [
                                        t('selectServiceArea'),
                                        "*"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("select", {
                                    id: "combo-box-service-area",
                                    name: "serviceArea",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).selectInput,
                                    value: serviceAreaSelected?.serviceArea || '',
                                    onChange: (e)=>onServiceAreaChange({
                                            ...serviceAreaSelected,
                                            serviceArea: e.target.value
                                        }),
                                    required: true,
                                    children: [
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: "",
                                            children: t('notSelected')
                                        }),
                                        filteredServiceAreas.map((area)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                                value: area.serviceArea,
                                                children: t(area.i18nTranslationKey)
                                            }, area.serviceArea))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formGroup,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("label", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formLabel,
                                    children: [
                                        t('selectServiceAction'),
                                        "*"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("select", {
                                    id: "combo-box-service-action",
                                    name: "serviceAction",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).selectInput,
                                    value: serviceActionSelected?.itemValue || '',
                                    onChange: (e)=>{
                                        const selected = filteredServiceActions.find((a)=>a.itemValue === e.target.value);
                                        onServiceActionChange(selected || {});
                                    },
                                    required: true,
                                    children: [
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: "",
                                            children: t('notSelected')
                                        }),
                                        filteredServiceActions.map((action)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                                value: action.itemValue,
                                                children: t(action.i18nTranslationKey)
                                            }, action.itemValue))
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formGroup,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("label", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formLabel,
                            children: [
                                t('comment'),
                                "*"
                            ]
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("textarea", {
                            id: "comment",
                            name: "comment",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).formInput,
                            required: true,
                            rows: 3,
                            value: comment,
                            onChange: onCommentChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($47c998ca7d0648ef$exports))).buttonContainer,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "secondary",
                            size: "sm",
                            onClick: onCancel,
                            children: t('cancel')
                        }),
                        isMaintenanceCopilotFlagEnabled ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            type: "button",
                            color: "primary",
                            size: "sm",
                            disabled: !selectedEquipment || !empNumber?.trim() || !serviceAreaSelected?.serviceArea || !serviceActionSelected?.itemValue || !comment?.trim() || loadingCreateConversation || isSubmitting,
                            onClick: onCreateConversation,
                            children: loadingCreateConversation || isSubmitting ? `${t('loading')}...` : t('continue')
                        }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "primary",
                            size: "sm",
                            type: "submit",
                            disabled: !selectedEquipment || !empNumber?.trim() || !serviceAreaSelected?.serviceArea || !serviceActionSelected?.itemValue || !comment?.trim() || isSubmitting,
                            children: isSubmitting ? `${t('saving')}...` : t('submit')
                        })
                    ]
                })
            ]
        })
    });
};
var $9a09de79f8300ba3$export$2e2bcd8739ae039 = $9a09de79f8300ba3$var$EquipActionForm;




var $6ffbf027c2cc8b9d$exports = {};

$parcel$export($6ffbf027c2cc8b9d$exports, "container", function () { return $6ffbf027c2cc8b9d$export$34e0f9847d4c02dd; }, function (v) { return $6ffbf027c2cc8b9d$export$34e0f9847d4c02dd = v; });
var $6ffbf027c2cc8b9d$export$34e0f9847d4c02dd;
$6ffbf027c2cc8b9d$export$34e0f9847d4c02dd = `fdUIZG_container`;






const $6581aa26ea4c3bd5$var$createAnalyticsRowId = ()=>{
    if (typeof globalThis.crypto?.randomUUID === 'function') return globalThis.crypto.randomUUID();
    // Fallback to a UUID v4-shaped value in environments without crypto.randomUUID.
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replaceAll(/[xy]/gu, (char)=>{
        const random = Math.floor(Math.random() * 16);
        const value = char === 'x' ? random : random % 4 + 8;
        return value.toString(16);
    });
};
const $6581aa26ea4c3bd5$var$formatTimeOnly = (timestamp)=>{
    if (!timestamp) return null;
    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
};
/**
 * Equipment Action Portal page component
 * Allows users to report equipment actions such as line downtime, machine down, or scheduled work
 * @returns {import('react').ReactElement} The EquipActionPortal component
 */ const $6581aa26ea4c3bd5$var$EquipActionPortal = ()=>{
    const [comment, setComment] = (0, $lCzvA.useState)('');
    const [userNumber, setUserNumber] = (0, $lCzvA.useState)('');
    const clearFormRef = (0, $lCzvA.useRef)(null);
    const analyticsWorkOrderIdRef = (0, $lCzvA.useRef)('');
    const { t: t } = (0, $8216e3af17948d6d$export$9fc83ad70ead8663)();
    const flags = (0, $fda7e4dd83174a6e$export$2879604e6aec4ab)([
        'maintenance-copilot'
    ]);
    const isMaintenanceCopilotFlagEnabled = flags['maintenance-copilot']?.enabled;
    const equipment = (0, $ec4f796dd860a46e$export$5bd44676153f462)();
    const user = (0, $c5f28fecad6357c0$export$23bbbc4533528f03)();
    const { userid: userid, email: rawUserEmail } = user ?? {};
    const { data: employeeDetails } = (0, $32345e46e1a65f5d$export$c06969164bbcede4)(userid);
    const serviceOptions = (0, $9fac1313a4174d74$export$96a5b910ec03cb55)();
    const { mutate: upsertUserAnalytics } = (0, $fd8a60a16d73d8a8$export$d1c6a65964ebeaf8)();
    const userEmail = rawUserEmail || '';
    const selectedEquipment = equipment.selectedEquipment;
    const analyticsIdentity = /** @type {{email?: string, usr_login?: string, usr_emp_no?: string}} */ employeeDetails ?? {};
    const { scanAgainVisible: scanAgainVisible, handleScanAgain: handleScanAgain } = equipment;
    const { serviceAreaSelected: serviceAreaSelected, serviceActionSelected: serviceActionSelected, filteredServiceAreas: filteredServiceAreas, filteredServiceActions: filteredServiceActions, handleServiceAreaChange: handleServiceAreaChange, handleServiceActionChange: handleServiceActionChange } = serviceOptions;
    const workOrder = (0, $fee88389624349c9$export$3f408042e593475c)({
        selectedEquipment: selectedEquipment,
        serviceAreaSelected: serviceAreaSelected,
        serviceActionSelected: serviceActionSelected,
        employeeDetails: employeeDetails,
        comment: comment,
        isMaintenanceCopilotFlagEnabled: isMaintenanceCopilotFlagEnabled,
        onSuccess: ()=>clearFormRef.current?.(),
        onConversationCreated: (desc)=>setComment(desc)
    });
    const { conversationId: conversationId, handleSummaryReady: handleSummaryReady, followUpQuestions: followUpQuestions, setFollowUpQuestions: setFollowUpQuestions, handleSummaryError: handleSummaryError, downtimeStartTime: downtimeStartTime, isSubmitting: isSubmitting, loadingCreateConversation: loadingCreateConversation, handleSubmit: handleSubmit, handleCreateConversation: createConversation, retryDialogOpen: retryDialogOpen, retryDialogMessage: retryDialogMessage, handleRetryDialogClose: handleRetryDialogClose } = workOrder;
    // Sync employee number at render time when data loads (replaces effect)
    const [prevEmpNo, setPrevEmpNo] = (0, $lCzvA.useState)(undefined);
    if (analyticsIdentity.usr_emp_no && analyticsIdentity.usr_emp_no !== prevEmpNo) {
        setPrevEmpNo(analyticsIdentity.usr_emp_no);
        setUserNumber(analyticsIdentity.usr_emp_no);
    }
    const clearForm = (0, $lCzvA.useCallback)(()=>{
        setComment('');
        setUserNumber(analyticsIdentity.usr_emp_no ?? '');
        analyticsWorkOrderIdRef.current = '';
        equipment.reset();
        serviceOptions.reset();
        workOrder.reset();
    }, [
        analyticsIdentity.usr_emp_no,
        equipment,
        serviceOptions,
        workOrder
    ]);
    (0, $lCzvA.useEffect)(()=>{
        clearFormRef.current = clearForm;
    }, [
        clearForm
    ]);
    const handleCreateConversation = ()=>{
        const lastEntryAt = Date.now();
        const analyticsWorkOrderId = $6581aa26ea4c3bd5$var$createAnalyticsRowId();
        const derivedEmail = analyticsIdentity.email || (analyticsIdentity.usr_login ? `${analyticsIdentity.usr_login}@pella.com` : '') || userEmail || '';
        analyticsWorkOrderIdRef.current = analyticsWorkOrderId;
        upsertUserAnalytics({
            id: analyticsWorkOrderId,
            lastEntryAt: lastEntryAt,
            userId: userid || '',
            userEmail: String(derivedEmail).toLowerCase(),
            empNumber: userNumber,
            equipmentNumber: selectedEquipment?.equipNum || '',
            siteId: selectedEquipment?.siteId || '',
            serviceArea: serviceAreaSelected?.serviceArea || '',
            serviceAction: serviceActionSelected?.itemValue || serviceActionSelected?.item || '',
            comment: comment
        });
        createConversation();
    };
    /**
   * Persist analytics collected from the DescribeProblem flow.
   * @param {{ outcome: string, followUpQuestions: Array, arrivedAt: number, cancellationReason?: string, cancellationReasonDetails?: string }} data
   */ const handleDescribeProblemAnalytics = (data)=>{
        const { outcome: outcome, followUpQuestions: questions, arrivedAt: arrivedAt, cancellationReason: cancellationReason, cancellationReasonDetails: cancellationReasonDetails } = data;
        const lastEntryAt = Date.now();
        const analyticsWorkOrderId = analyticsWorkOrderIdRef.current || $6581aa26ea4c3bd5$var$createAnalyticsRowId();
        const derivedEmail = analyticsIdentity.email || (analyticsIdentity.usr_login ? `${analyticsIdentity.usr_login}@pella.com` : '') || userEmail || '';
        upsertUserAnalytics({
            id: analyticsWorkOrderId,
            lastEntryAt: lastEntryAt,
            userId: userid || '',
            userEmail: String(derivedEmail).toLowerCase(),
            empNumber: userNumber,
            equipmentNumber: selectedEquipment?.equipNum || '',
            siteId: selectedEquipment?.siteId || '',
            serviceArea: serviceAreaSelected?.serviceArea || '',
            serviceAction: serviceActionSelected?.itemValue || serviceActionSelected?.item || '',
            comment: comment,
            outcome: outcome,
            cancellationReason: cancellationReason || '',
            cancellationReasonDetails: cancellationReasonDetails || '',
            arrivedAt: $6581aa26ea4c3bd5$var$formatTimeOnly(arrivedAt),
            questionAnswers: (questions || []).map((q)=>({
                    question: q.text,
                    answer: q.selectedAnswer,
                    additionalDetails: q.additionalDetails || '',
                    answeredAt: $6581aa26ea4c3bd5$var$formatTimeOnly(q.answeredAt)
                }))
        });
    };
    if (conversationId) return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $36c4b870735c5953$export$2e2bcd8739ae039), {
        conversationId: conversationId,
        equipmentNumber: selectedEquipment.equipNum,
        siteId: selectedEquipment.siteId,
        setSummaryText: handleSummaryReady,
        onCloseRequestCompleted: clearForm,
        followUpQuestions: followUpQuestions,
        setFollowUpQuestions: setFollowUpQuestions,
        onCloseSummaryGenerationErrorModal: handleSummaryError,
        handleSubmitWorkOrder: handleSubmit,
        downtimeStartTime: downtimeStartTime,
        onRecordAnalytics: handleDescribeProblemAnalytics
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6ffbf027c2cc8b9d$exports))).container,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8ccb25c8231cf70d$export$2e2bcd8739ae039), {
                selectedEquipment: selectedEquipment,
                scanAgainVisible: scanAgainVisible,
                handleScanAgain: handleScanAgain
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9a09de79f8300ba3$export$2e2bcd8739ae039), {
                comment: comment,
                onCommentChange: (e)=>setComment(e.target.value),
                empNumber: userNumber,
                onEmpNumberChange: (e)=>setUserNumber(e.target.value),
                serviceAreaSelected: serviceAreaSelected,
                serviceActionSelected: serviceActionSelected,
                filteredServiceAreas: filteredServiceAreas,
                filteredServiceActions: filteredServiceActions,
                onServiceAreaChange: handleServiceAreaChange,
                onServiceActionChange: handleServiceActionChange,
                selectedEquipment: selectedEquipment,
                isSubmitting: isSubmitting,
                loadingCreateConversation: loadingCreateConversation,
                isMaintenanceCopilotFlagEnabled: isMaintenanceCopilotFlagEnabled,
                onSubmit: handleSubmit,
                onCancel: clearForm,
                onCreateConversation: handleCreateConversation
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
                open: retryDialogOpen,
                onOpenChange: (isOpen)=>{
                    if (!isOpen) handleRetryDialogClose(false);
                },
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
                    showClose: false,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                            children: t('error')
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                children: retryDialogMessage
                            })
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    size: "sm",
                                    color: "secondary",
                                    onClick: ()=>handleRetryDialogClose(false),
                                    children: t('cancel')
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    size: "sm",
                                    color: "primary",
                                    onClick: ()=>handleRetryDialogClose(true),
                                    children: t('submitWorkOrder')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $6581aa26ea4c3bd5$export$2e2bcd8739ae039 = $6581aa26ea4c3bd5$var$EquipActionPortal;




var $lCzvA = parcelRequire("lCzvA");



//#region src/components/Container/index.jsx
var $439af80902af3e20$export$2e2bcd8739ae039 = ({ fluid: n, width: r, noPadding: i, children: a, className: o, style: s, spacing: c = "comfortable", ...l })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
            "sash-Container w-full mx-auto max-w-(--container-width)": !0,
            "px-6 md:px-8 xl:px-16": c === "comfortable" && !i,
            "px-4 md:px-6 xl:px-8": c === "compact" && !i,
            [o]: o
        }),
        style: {
            maxWidth: (()=>{
                if (n) return "100%";
                if (r) {
                    let e;
                    return e = i || c === "snug" ? 0 : c === "compact" ? 64 : 128, `${Number(r) + Number(e)}px`;
                }
            })(),
            ...s
        },
        "data-testid": "sash-container",
        ...l,
        children: a
    });




var $a6096b41f9c91d3c$exports = {};

$parcel$export($a6096b41f9c91d3c$exports, "actionButtons", function () { return $a6096b41f9c91d3c$export$b6fb1741c7f64881; }, function (v) { return $a6096b41f9c91d3c$export$b6fb1741c7f64881 = v; });
$parcel$export($a6096b41f9c91d3c$exports, "buttonGroup", function () { return $a6096b41f9c91d3c$export$9c686a975407e95c; }, function (v) { return $a6096b41f9c91d3c$export$9c686a975407e95c = v; });
var $a6096b41f9c91d3c$export$b6fb1741c7f64881;
var $a6096b41f9c91d3c$export$9c686a975407e95c;
$a6096b41f9c91d3c$export$b6fb1741c7f64881 = `QF8JDq_actionButtons`;
$a6096b41f9c91d3c$export$9c686a975407e95c = `QF8JDq_buttonGroup`;


const $f497bc8067bd9d95$var$AnyPlantMROSubInvSelector = /** @type {import('react').ElementType} */ (0, $9e65d9cd95f8360c$export$2e2bcd8739ae039);
/**
 * Preferences page component for managing user Move Order preferences.
 * @returns {import('react').ReactElement} The Preferences component
 */ const $f497bc8067bd9d95$var$Preferences = ()=>{
    const { addTeamMemberAppPref: addTeamMemberAppPref } = (0, $4a9c7604cece1590$export$86320881a5972bfc)();
    const navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    const [showCOALookup, setShowCOALookup] = (0, $lCzvA.useState)(false);
    const [selectorValue, setSelectorValue] = (0, $lCzvA.useState)(null);
    const updatePrefOnClick = async ()=>{
        const updatedPref = {
            preference: {
                apps: {
                    MoveOrderSubInvLoc: selectorValue.settings.MoveOrderSubInvLoc,
                    MoveOrderShipToLoc: selectorValue.settings.MoveOrderShipToLoc,
                    MoveOrderMROOrg: selectorValue.settings.MoveOrderMROOrg,
                    MoveOrderDestinationAcct: selectorValue.settings.MoveOrderDestinationAcct || null
                }
            }
        };
        if (selectorValue.validated) try {
            await addTeamMemberAppPref.mutateAsync({
                preference: updatedPref.preference,
                prefId: 'MoveOrder'
            });
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Preferences Updated Successfully!');
        } catch  {
        // error toast handled by useUserMutation onError
        }
        else (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Selected values are not valid. Please review your selections.');
    };
    const selectedValueOnChange = (e)=>{
        setSelectorValue(e);
    };
    const UpdateShowCOALookup = (e)=>{
        setShowCOALookup(e);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $439af80902af3e20$export$2e2bcd8739ae039), {
                children: [
                    "Preferences",
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $439af80902af3e20$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f497bc8067bd9d95$var$AnyPlantMROSubInvSelector, {
                            selectedValueOnChange: selectedValueOnChange,
                            COALLookupActive: UpdateShowCOALookup,
                            showSavePreferences: false,
                            defaultExpanded: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6096b41f9c91d3c$exports))).actionButtons,
                children: !showCOALookup ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6096b41f9c91d3c$exports))).buttonGroup,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "secondary",
                            size: "sm",
                            onClick: ()=>navigate(-1),
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            disabled: !selectorValue?.validated,
                            color: "primary",
                            size: "sm",
                            onClick: updatePrefOnClick,
                            children: "Update Preferences"
                        })
                    ]
                }) : null
            })
        ]
    });
};
var $f497bc8067bd9d95$export$2e2bcd8739ae039 = $f497bc8067bd9d95$var$Preferences;






var $lCzvA = parcelRequire("lCzvA");



var $lCzvA = parcelRequire("lCzvA");
const $80b77aecebb89dcc$var$MoveOrderContext = /*#__PURE__*/ (0, $lCzvA.createContext)(null);
const $80b77aecebb89dcc$export$beeb152867b52d97 = ({ children: children })=>{
    const [dropDownSelected, setDropDownSelected] = (0, $lCzvA.useState)({});
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($80b77aecebb89dcc$var$MoveOrderContext.Provider, {
        value: {
            dropDownSelected: dropDownSelected,
            setDropDownSelected: setDropDownSelected
        },
        children: children
    });
};
const $80b77aecebb89dcc$var$noop = ()=>undefined;
const $80b77aecebb89dcc$var$EMPTY_CONTEXT = {
    dropDownSelected: {},
    setDropDownSelected: $80b77aecebb89dcc$var$noop
};
const $80b77aecebb89dcc$export$dcaf75b38dfc9e70 = ()=>(0, $lCzvA.useContext)($80b77aecebb89dcc$var$MoveOrderContext) ?? $80b77aecebb89dcc$var$EMPTY_CONTEXT;









var $0def554e855af510$exports = {};

$parcel$export($0def554e855af510$exports, "bottomSection", function () { return $0def554e855af510$export$73c8881daacf619b; }, function (v) { return $0def554e855af510$export$73c8881daacf619b = v; });
$parcel$export($0def554e855af510$exports, "buttonRow", function () { return $0def554e855af510$export$a5121a49a1f63d8a; }, function (v) { return $0def554e855af510$export$a5121a49a1f63d8a = v; });
$parcel$export($0def554e855af510$exports, "contentStack", function () { return $0def554e855af510$export$c9c7e603943c4ccc; }, function (v) { return $0def554e855af510$export$c9c7e603943c4ccc = v; });
$parcel$export($0def554e855af510$exports, "detailField", function () { return $0def554e855af510$export$f660f3bcefbefb2e; }, function (v) { return $0def554e855af510$export$f660f3bcefbefb2e = v; });
$parcel$export($0def554e855af510$exports, "detailInput", function () { return $0def554e855af510$export$34bccd25a4305c49; }, function (v) { return $0def554e855af510$export$34bccd25a4305c49 = v; });
$parcel$export($0def554e855af510$exports, "detailLabel", function () { return $0def554e855af510$export$914104b4709683c0; }, function (v) { return $0def554e855af510$export$914104b4709683c0 = v; });
$parcel$export($0def554e855af510$exports, "detailList", function () { return $0def554e855af510$export$d46ce559a7abcb51; }, function (v) { return $0def554e855af510$export$d46ce559a7abcb51 = v; });
$parcel$export($0def554e855af510$exports, "dialogButtonRow", function () { return $0def554e855af510$export$485eb0232809cd1; }, function (v) { return $0def554e855af510$export$485eb0232809cd1 = v; });
$parcel$export($0def554e855af510$exports, "missingParamCard", function () { return $0def554e855af510$export$ffdb68334af647d7; }, function (v) { return $0def554e855af510$export$ffdb68334af647d7 = v; });
$parcel$export($0def554e855af510$exports, "modalButtonRow", function () { return $0def554e855af510$export$2733f4c7e2012118; }, function (v) { return $0def554e855af510$export$2733f4c7e2012118 = v; });
$parcel$export($0def554e855af510$exports, "pageCard", function () { return $0def554e855af510$export$6bc6b1770b1aa2e3; }, function (v) { return $0def554e855af510$export$6bc6b1770b1aa2e3 = v; });
$parcel$export($0def554e855af510$exports, "pageHeader", function () { return $0def554e855af510$export$4cf1388ef83aed25; }, function (v) { return $0def554e855af510$export$4cf1388ef83aed25 = v; });
$parcel$export($0def554e855af510$exports, "pageHeaderFlex", function () { return $0def554e855af510$export$2e51f21da4b3b981; }, function (v) { return $0def554e855af510$export$2e51f21da4b3b981 = v; });
$parcel$export($0def554e855af510$exports, "pageHeaderTitle", function () { return $0def554e855af510$export$35753e4ad5b75da0; }, function (v) { return $0def554e855af510$export$35753e4ad5b75da0 = v; });
$parcel$export($0def554e855af510$exports, "qtyInput", function () { return $0def554e855af510$export$75f9612560faed81; }, function (v) { return $0def554e855af510$export$75f9612560faed81 = v; });
$parcel$export($0def554e855af510$exports, "successBanner", function () { return $0def554e855af510$export$35027e133133855c; }, function (v) { return $0def554e855af510$export$35027e133133855c = v; });
var $0def554e855af510$export$73c8881daacf619b;
var $0def554e855af510$export$a5121a49a1f63d8a;
var $0def554e855af510$export$c9c7e603943c4ccc;
var $0def554e855af510$export$f660f3bcefbefb2e;
var $0def554e855af510$export$34bccd25a4305c49;
var $0def554e855af510$export$914104b4709683c0;
var $0def554e855af510$export$d46ce559a7abcb51;
var $0def554e855af510$export$485eb0232809cd1;
var $0def554e855af510$export$ffdb68334af647d7;
var $0def554e855af510$export$2733f4c7e2012118;
var $0def554e855af510$export$6bc6b1770b1aa2e3;
var $0def554e855af510$export$4cf1388ef83aed25;
var $0def554e855af510$export$2e51f21da4b3b981;
var $0def554e855af510$export$35753e4ad5b75da0;
var $0def554e855af510$export$75f9612560faed81;
var $0def554e855af510$export$35027e133133855c;
$0def554e855af510$export$73c8881daacf619b = `L5yBFG_bottomSection`;
$0def554e855af510$export$a5121a49a1f63d8a = `L5yBFG_buttonRow`;
$0def554e855af510$export$c9c7e603943c4ccc = `L5yBFG_contentStack`;
$0def554e855af510$export$f660f3bcefbefb2e = `L5yBFG_detailField`;
$0def554e855af510$export$34bccd25a4305c49 = `L5yBFG_detailInput`;
$0def554e855af510$export$914104b4709683c0 = `L5yBFG_detailLabel`;
$0def554e855af510$export$d46ce559a7abcb51 = `L5yBFG_detailList`;
$0def554e855af510$export$485eb0232809cd1 = `L5yBFG_dialogButtonRow`;
$0def554e855af510$export$ffdb68334af647d7 = `L5yBFG_missingParamCard`;
$0def554e855af510$export$2733f4c7e2012118 = `L5yBFG_modalButtonRow`;
$0def554e855af510$export$6bc6b1770b1aa2e3 = `L5yBFG_pageCard`;
$0def554e855af510$export$4cf1388ef83aed25 = `L5yBFG_pageHeader`;
$0def554e855af510$export$2e51f21da4b3b981 = `L5yBFG_pageHeaderFlex`;
$0def554e855af510$export$35753e4ad5b75da0 = `L5yBFG_pageHeaderTitle`;
$0def554e855af510$export$75f9612560faed81 = `L5yBFG_qtyInput`;
$0def554e855af510$export$35027e133133855c = `L5yBFG_successBanner`;


const $22cf9b62ef34cea1$var$createSourceHeaderId = ()=>Math.floor(Math.random() * 1000) + 1;
const $22cf9b62ef34cea1$var$SelectedItemDetailsModal = (props)=>{
    const { onClose: onClose, selectedValue: selectedValue, open: open } = props;
    const [selectedQty, setSelectedQty] = (0, $lCzvA.useState)(1);
    const [prevOpen, setPrevOpen] = (0, $lCzvA.useState)(open);
    if (open !== prevOpen) {
        setPrevOpen(open);
        setSelectedQty(1);
    }
    const handleClose = (action)=>{
        onClose(action, selectedQty);
    };
    return(//Parts Details Modal
    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                    children: "Part Details"
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).detailList,
                        children: [
                            [
                                {
                                    label: 'Item ID',
                                    value: selectedValue.inventoryItemId
                                },
                                {
                                    label: 'Item',
                                    value: selectedValue.item
                                },
                                {
                                    label: 'Description',
                                    value: selectedValue.description
                                },
                                {
                                    label: 'UOM',
                                    value: `${selectedValue.primaryUomCode ?? ''} ${selectedValue.primaryUnitOfMeasure ?? ''}`.trim()
                                },
                                {
                                    label: 'Quantity On Hand',
                                    value: selectedValue.qoh
                                }
                            ].map(({ label: label, value: value })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).detailField,
                                    children: [
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("label", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).detailLabel,
                                            children: label
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                                            type: "text",
                                            disabled: true,
                                            value: value ?? '',
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).detailInput
                                        })
                                    ]
                                }, label)),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).detailField,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("label", {
                                        htmlFor: "selected-qty",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).detailLabel,
                                        children: "Qty*"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                                        id: "selected-qty",
                                        type: "number",
                                        value: selectedQty,
                                        onChange: (e)=>setSelectedQty(e.target.value),
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).qtyInput
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).modalButtonRow,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        color: "secondary",
                                        onClick: ()=>handleClose('cancel'),
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        color: "primary",
                                        onClick: ()=>handleClose('add'),
                                        children: "Add"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
const $22cf9b62ef34cea1$var$DuplicateItemDialog = ({ open: open, onClose: onClose })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                    children: "Item Already in List"
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                        children: "This item is already in the transaction list. Would you like to add to the existing quantity?"
                    })
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).dialogButtonRow,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            size: "sm",
                            color: "secondary",
                            onClick: ()=>onClose('cancel'),
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            size: "sm",
                            color: "primary",
                            onClick: ()=>onClose('addToQuantity'),
                            children: "Add to Quantity"
                        })
                    ]
                })
            ]
        })
    });
const $22cf9b62ef34cea1$var$AssignmentConfirmModal = ({ open: open, onClose: onClose, currentlyAssignedList: currentlyAssignedList })=>{
    const handleOpenChange = (isOpen)=>{
        if (!isOpen) onClose('no');
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: handleOpenChange,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
            showClose: false,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                    children: "You are not currently assigned to this Work Order"
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                    children: currentlyAssignedList.length ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("p", {
                        children: [
                            currentlyAssignedList.join(', '),
                            " is/are currently assigned to this Work Order. Would you like to be added?"
                        ]
                    }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                        children: "Would you like to be added?"
                    })
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).dialogButtonRow,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            size: "sm",
                            color: "secondary",
                            onClick: ()=>onClose('no'),
                            children: "No"
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            size: "sm",
                            color: "primary",
                            onClick: ()=>onClose('yes'),
                            children: "Yes"
                        })
                    ]
                })
            ]
        })
    });
};
/**
 * Validates a move order item has all required fields.
 * @param {object} item - The item to validate
 * @returns {boolean} Whether the item is valid
 */ const $22cf9b62ef34cea1$var$validateItem = (item)=>Boolean(item.sourceHeaderId && item.organizationId && item.transactionTypeId && item.transactionSourceTypeId && item.transactionQuantity && item.sourceLineId && item.transactionUom && item.moveOrderType && item.inventoryItemId && item.distributionAccountId && item.transferOrganization && item.shipToLocationId && item.workOrderNumber && item.fromSubinventoryCode && item.fromSubinventoryCode !== '');
/**
 * No-op callback for COA lookup state changes (this component doesn't consume the value).
 * @param {boolean} _active - ignored
 */ const $22cf9b62ef34cea1$var$handleCOALookupActive = (_active)=>{
// intentional no-op — MoveOrderAdd does not need to react to COA lookup visibility
};
/**
 * Parses the JSON response from the move order API.
 * @param {object} results - The raw results object with a message property
 * @returns {object | undefined} The parsed JSON response or undefined
 */ const $22cf9b62ef34cea1$var$convertResultsToJSON = (results)=>{
    if (results) {
        const parsedMessage = results.message.replaceAll(/(\r\n|\n|\r)/gmu, '');
        return JSON.parse(parsedMessage);
    }
    return undefined;
};
/**
 * MoveOrderAdd page component for creating a new move order.
 * @returns {import('react').ReactElement} The MoveOrderAdd component
 */ const $22cf9b62ef34cea1$var$MoveOrderAdd = ()=>{
    const { userid: userid } = (0, $c5f28fecad6357c0$export$23bbbc4533528f03)();
    const { data: teamMemberInfo } = (0, $32345e46e1a65f5d$export$c06969164bbcede4)(userid);
    const [searchParams] = (0, $c3aca08c2a74646e$export$f1a78c17382fe22a)();
    const { useAddAssignment: useAddAssignment, useProjects: useProjects } = (0, $d2aa929a4a4e56ef$export$1e5456b5c8005e7b)();
    const { mutateAsync: addAssignmentMutation } = useAddAssignment();
    const { mutateAsync: createMoveOrderMutation } = (0, $77687606fa35ccbc$export$a407559d686aac7)();
    const [orgItemsParams, setOrgItemsParams] = (0, $lCzvA.useState)(null);
    const [orgItemDetailParams, setOrgItemDetailParams] = (0, $lCzvA.useState)(null);
    const { orgItems: orgItems } = (0, $719ab5841c6e6012$export$24bedf9a427a2503)(orgItemsParams ?? {});
    const { orgItemDetail: orgItemDetail } = (0, $f84cccd4c65d3ca8$export$bef1bfdc922bbbd5)(orgItemDetailParams ?? {});
    const defaultMoveOrderTransaction = (0, $lCzvA.useMemo)(()=>({
            debug: 1,
            username: teamMemberInfo?.ebs_login || teamMemberInfo?.usr_login,
            transactions: []
        }), [
        teamMemberInfo
    ]);
    const [invItemDetails, setInvItemDetails] = (0, $lCzvA.useState)([]);
    const [openDetailsModal, setOpenDetailsModal] = (0, $lCzvA.useState)(false);
    const [transactionComplete, setTransactionComplete] = (0, $lCzvA.useState)(false);
    const [openAlertDialog, setOpenAlertDialog] = (0, $lCzvA.useState)(false);
    const [selectedWorkOrder, setSelectedWorkOrder] = (0, $lCzvA.useState)(null);
    const [tempAddItem, setTempAddItem] = (0, $lCzvA.useState)({});
    const [moveOrderTransaction, setMoveOrderTransaction] = (0, $lCzvA.useState)({
        debug: 0,
        username: undefined,
        transactions: []
    });
    const [plantMROSubInvValue, setPlantMROSubInvValue] = (0, $lCzvA.useState)({});
    const [showFullPartLookup, setShowFullPartLookup] = (0, $lCzvA.useState)(false);
    const [sourceHeaderID] = (0, $lCzvA.useState)($22cf9b62ef34cea1$var$createSourceHeaderId);
    const [assignmentModalOpen, setAssignmentModalOpen] = (0, $lCzvA.useState)(false);
    const [pendingAssignmentData, setPendingAssignmentData] = (0, $lCzvA.useState)(null);
    const projNum = searchParams.get('proj-num');
    const projId = searchParams.get('proj-id');
    const projectSearchParams = (0, $lCzvA.useMemo)(()=>{
        if (projNum) return {
            projNum: projNum
        };
        if (projId) return {
            projid: projId
        };
        return {};
    }, [
        projNum,
        projId
    ]);
    const { projects: projects, projectsIsSuccess: projectsIsSuccess, projectsIsError: projectsIsError } = useProjects(projectSearchParams);
    // --- Render-time state adjustments (replaces effects that sync props/query data → state) ---
    const [pendingToasts, setPendingToasts] = (0, $lCzvA.useState)([]);
    // Sync moveOrderTransaction when defaultMoveOrderTransaction changes (teamMemberInfo loaded)
    const [prevDefaultMOT, setPrevDefaultMOT] = (0, $lCzvA.useState)(defaultMoveOrderTransaction);
    if (defaultMoveOrderTransaction !== prevDefaultMOT) {
        setPrevDefaultMOT(defaultMoveOrderTransaction);
        setMoveOrderTransaction(defaultMoveOrderTransaction);
    }
    // React to org items query result: derive orgItemDetailParams when orgItems arrives
    const [prevOrgItems, setPrevOrgItems] = (0, $lCzvA.useState)(orgItems);
    if (orgItems !== prevOrgItems) {
        setPrevOrgItems(orgItems);
        if (orgItemsParams && orgItems !== undefined) {
            if (orgItems && orgItems.length === 1) setOrgItemDetailParams({
                orgId: orgItemsParams.orgId,
                itemId: orgItems[0]?.inventoryItemId
            });
            else if (orgItems && orgItems.length > 1) setPendingToasts((current)=>[
                    ...current,
                    {
                        level: 'error',
                        msg: 'Too many values returned! Please contact support!'
                    }
                ]);
            else setPendingToasts((current)=>[
                    ...current,
                    {
                        level: 'error',
                        msg: 'No Oracle Part found for the current selection! Item can not be added to Move Order.'
                    }
                ]);
        }
    }
    // React to org item detail query result: derive invItemDetails + openDetailsModal
    const [prevOrgItemDetail, setPrevOrgItemDetail] = (0, $lCzvA.useState)(orgItemDetail);
    if (orgItemDetail !== prevOrgItemDetail) {
        setPrevOrgItemDetail(orgItemDetail);
        if (orgItemDetailParams && orgItemDetail !== undefined) {
            const detail = Array.isArray(orgItemDetail) ? orgItemDetail[0] : orgItemDetail;
            if (detail) {
                setInvItemDetails(detail);
                setOpenDetailsModal(true);
            } else setInvItemDetails({});
            setOrgItemDetailParams(null);
        }
    }
    // React to projects query completing: set selectedWorkOrder or open assignment modal.
    // Trackers initialize to `undefined` so the very first render always evaluates the
    // branch — otherwise a react-query cache hit (both queries already success on mount)
    // would look unchanged and selectedWorkOrder would never get set. teamMemberInfo is
    // tracked as a boolean so late arrival re-triggers processing, but cache refetches
    // that swap the object reference without changing presence don't.
    const hasTeamMemberInfo = Boolean(teamMemberInfo);
    const [prevProjectsIsSuccess, setPrevProjectsIsSuccess] = (0, $lCzvA.useState)(/** @type {boolean | undefined} */ undefined);
    const [prevProjectsIsError, setPrevProjectsIsError] = (0, $lCzvA.useState)(/** @type {boolean | undefined} */ undefined);
    const [prevHasTeamMemberInfo, setPrevHasTeamMemberInfo] = (0, $lCzvA.useState)(/** @type {boolean | undefined} */ undefined);
    if (projectsIsSuccess !== prevProjectsIsSuccess || projectsIsError !== prevProjectsIsError || hasTeamMemberInfo !== prevHasTeamMemberInfo) {
        setPrevProjectsIsSuccess(projectsIsSuccess);
        setPrevProjectsIsError(projectsIsError);
        setPrevHasTeamMemberInfo(hasTeamMemberInfo);
        if (!selectedWorkOrder && (projectsIsSuccess || projectsIsError) && teamMemberInfo) {
            if (projectsIsError || !projects || projects.length === 0) setPendingToasts((current)=>[
                    ...current,
                    {
                        level: 'error',
                        msg: 'No Work Order was found with that Work Order #'
                    }
                ]);
            else {
                const woList = projects;
                const assignedWOs = woList.filter((e)=>e.assignedTo !== null && e.assignedTo !== undefined);
                const currentlyAssignedList = assignedWOs.map((e)=>`${e.atFirstName} ${e.atLastName}`);
                const currentUserAssignment = assignedWOs.find((e)=>e.assignedTo !== null && e.assignedTo !== undefined && e.assignedTo?.toUpperCase() === teamMemberInfo?.usr_emp_no?.toUpperCase());
                if (currentUserAssignment) setSelectedWorkOrder(currentUserAssignment);
                else if (assignedWOs.length) {
                    setPendingAssignmentData({
                        woList: woList,
                        currentlyAssignedList: currentlyAssignedList
                    });
                    setAssignmentModalOpen(true);
                } else {
                    setPendingAssignmentData({
                        woList: woList,
                        currentlyAssignedList: []
                    });
                    setAssignmentModalOpen(true);
                }
            }
        }
    }
    // Flush queued toasts after render (side effects cannot run during render)
    (0, $lCzvA.useEffect)(()=>{
        if (!pendingToasts.length) return;
        for (const { level: level, msg: msg } of pendingToasts)(0, $673b1c81cc441170$export$2e2bcd8739ae039)[level](msg);
        setPendingToasts([]);
    }, [
        pendingToasts
    ]);
    const handleClose = ()=>{
        setMoveOrderTransaction(defaultMoveOrderTransaction);
        setShowFullPartLookup(false);
    };
    if (!projNum && !projId) return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).missingParamCard,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
            children: "A Work Order number or ID is required to continue."
        })
    });
    const handleAssignmentModalClose = async (action)=>{
        /* istanbul ignore next -- defensive guard; modal only opens when pendingAssignmentData is set */ if (!pendingAssignmentData) return;
        setAssignmentModalOpen(false);
        if (action === 'yes') try {
            await addAssignmentMutation({
                typeCode: 'P',
                refId: pendingAssignmentData.woList[0].projectId,
                employeeId: teamMemberInfo?.usr_emp_no,
                assignedTo: teamMemberInfo?.usr_emp_no,
                entryDate: new Date().toISOString(),
                status: 'Open',
                viewed: 'N'
            });
            setSelectedWorkOrder(pendingAssignmentData.woList[0]);
        } catch  {
        // error toast handled by useAddAssignment onError
        }
        else (0, $673b1c81cc441170$export$2e2bcd8739ae039).info('You chose not to add an Assignment!');
        setPendingAssignmentData(null);
    };
    const clearCurrentMoveOrderTransAction = ()=>{
        setMoveOrderTransaction(defaultMoveOrderTransaction);
    };
    const plantMROSubInvValueOnChange = (e)=>{
        clearCurrentMoveOrderTransAction();
        setPlantMROSubInvValue(e);
    };
    const sparePartsOnChange = (e)=>{
        if (!e?.partNum) {
            setInvItemDetails([]);
            setOpenDetailsModal(false);
            return;
        }
        const orgId = plantMROSubInvValue?.settings?.MoveOrderMROOrg;
        if (!orgId) {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Please select an MRO Organization before selecting a part.');
            return;
        }
        setOrgItemsParams({
            orgId: orgId,
            item: e.partNum,
            descr: null
        });
    };
    const fullPartsOnChange = (e)=>{
        const orgId = plantMROSubInvValue?.settings?.MoveOrderMROOrg;
        if (e?.inventoryItemId && orgId) setOrgItemDetailParams({
            orgId: orgId,
            itemId: e.inventoryItemId
        });
        else (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('No Oracle Part found for the current selection! Item can not be added to Move Order.');
    };
    const checkIfItemIsInList = (item)=>{
        const inListItem = moveOrderTransaction.transactions.find((e)=>e.inventoryItemId === item.inventoryItemId);
        if (inListItem) return true;
        return false;
    };
    const addMoveOrderItem = (item)=>{
        const itemIsValid = $22cf9b62ef34cea1$var$validateItem(item);
        if (itemIsValid) {
            const updatedMoveOrderTransaction = {
                ...moveOrderTransaction
            };
            updatedMoveOrderTransaction.transactions = [
                ...updatedMoveOrderTransaction.transactions,
                item
            ];
            setMoveOrderTransaction(updatedMoveOrderTransaction);
        } else (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Item is invalid!');
    };
    const processMoveOrderAddItem = (qty)=>{
        const addItem = {
            sourceHeaderId: sourceHeaderID,
            organizationId: plantMROSubInvValue?.settings.MoveOrderMROOrg,
            transactionTypeId: 63,
            transactionSourceTypeId: 4,
            transactionQuantity: qty,
            sourceLineId: 1,
            transactionUom: invItemDetails?.primaryUomCode,
            moveOrderType: 1,
            inventoryItemId: invItemDetails?.inventoryItemId,
            distributionAccountId: plantMROSubInvValue?.distributionAccountId,
            transferOrganization: plantMROSubInvValue?.settings.MoveOrderMROOrg,
            shipToLocationId: plantMROSubInvValue?.settings.MoveOrderShipToLoc,
            workOrderNumber: selectedWorkOrder?.projNum,
            fromSubinventoryCode: plantMROSubInvValue?.settings.MoveOrderSubInvLoc,
            itemDescription: invItemDetails?.description,
            item: invItemDetails?.item,
            result: ''
        };
        const itemInList = checkIfItemIsInList(addItem);
        if (itemInList) {
            setTempAddItem(addItem);
            setOpenAlertDialog(true);
            return;
        }
        addMoveOrderItem(addItem);
    };
    const handlePartDetailModalClose = (action, value)=>{
        switch(action){
            case 'add':
                if (value > 0) {
                    processMoveOrderAddItem(value);
                    setOpenDetailsModal(false);
                } else (0, $673b1c81cc441170$export$2e2bcd8739ae039).info('Quantity has to be greater than 0!');
                break;
            case 'cancel':
                setOpenDetailsModal(false);
                break;
            default:
        }
    };
    ////Move Order Actions///////////////////////////
    const handleSuccess = ()=>{
        clearCurrentMoveOrderTransAction();
        setPlantMROSubInvValue({});
        setInvItemDetails([]);
        setOpenDetailsModal(false);
        setShowFullPartLookup(false);
        setTransactionComplete(true);
    };
    const processResults = (results)=>{
        /* istanbul ignore next -- processResults is only called on success path with a valid jsonResponse */ if (results) {
            const moveOrderTransactionsUpdated = moveOrderTransaction.transactions.map((e)=>{
                const updatedItem = results.transactions.find((innerItem)=>Number(innerItem.sourceLineId) === Number(e.sourceLineId));
                return {
                    ...e,
                    result: updatedItem.status
                };
            });
            const updatedMoveOrderTransaction = {
                ...moveOrderTransaction,
                transactions: moveOrderTransactionsUpdated
            };
            setMoveOrderTransaction(updatedMoveOrderTransaction);
        }
    };
    const submitMoveOrder = async ()=>{
        if (!moveOrderTransaction.transactions.length) {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).warning('Transaction has no line items! It will not be submitted!');
            return;
        }
        const bodyTransactions = moveOrderTransaction.transactions.map((t, idx)=>({
                ...t,
                sourceLineId: idx + 1
            }));
        const moveOrderBody = {
            ...moveOrderTransaction,
            transactions: bodyTransactions
        };
        try {
            // mutationFn returns the full response body: { status, message, response: { outBinds } }
            // @ts-ignore
            const data = await createMoveOrderMutation({
                orgId: plantMROSubInvValue?.settings?.MoveOrderMROOrg,
                body: moveOrderBody
            });
            const outerStatus = Number.parseInt(/** @type {{status?: string}} */ data?.status ?? '0');
            const jsonResponse = $22cf9b62ef34cea1$var$convertResultsToJSON(/** @type {{response?: {outBinds?: unknown}}} */ data?.response?.outBinds);
            const innerStatus = Number.parseInt(jsonResponse?.status ?? '0');
            const moveOrderNum = jsonResponse?.moveordernumber ?? 'N/A';
            if (outerStatus >= 200 && outerStatus <= 201 && (innerStatus === 200 || innerStatus === 201)) {
                (0, $673b1c81cc441170$export$2e2bcd8739ae039).success(`Move Order added successfully! (MoveOrder #${moveOrderNum})`);
                processResults(jsonResponse);
                handleSuccess();
            } else {
                // Surface the Oracle inner message when available, fall back to outer message
                const innerMsg = jsonResponse?.message?.trim() || /** @type {{message?: string}} */ data?.message || 'Unknown error';
                (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(`Move Order not accepted (MoveOrder #${moveOrderNum}): ${innerMsg}`);
            }
        } catch  {
        // Network / HTTP-level errors — toast already shown by useCreateMoveOrder onError
        }
    };
    const handleDuplicateDialogClose = (action)=>{
        const updatedMoveOrderTransaction = {
            ...moveOrderTransaction
        };
        const duplicateTran = moveOrderTransaction.transactions.find((e)=>e.inventoryItemId === tempAddItem.inventoryItemId);
        const diffTrans = moveOrderTransaction.transactions.filter((e)=>e.inventoryItemId !== tempAddItem.inventoryItemId);
        switch(action){
            case 'addToQuantity':
                {
                    const newQty = Number(tempAddItem.transactionQuantity) + Number(duplicateTran.transactionQuantity);
                    const updated = {
                        ...duplicateTran,
                        transactionQuantity: newQty
                    };
                    updatedMoveOrderTransaction.transactions = [
                        ...diffTrans,
                        updated
                    ].toSorted(/* istanbul ignore next -- sort comparator branch depends on engine call order */ (a, b)=>a.item < b.item ? -1 : 1);
                    setMoveOrderTransaction(updatedMoveOrderTransaction);
                    setOpenAlertDialog(false);
                    break;
                }
            case 'cancel':
                setOpenAlertDialog(false);
                break;
            default:
        }
        setTempAddItem({});
    };
    const deleteMoveOrderListItem = (oldValue, _rowData)=>{
        const clonedOrder = {
            ...moveOrderTransaction
        };
        const clonedTransactions = [
            ...clonedOrder.transactions
        ];
        const newTransactions = clonedTransactions.filter((e)=>e.item !== oldValue.item).map((filteredItem)=>filteredItem);
        clonedOrder.transactions = [
            ...newTransactions
        ];
        setMoveOrderTransaction(clonedOrder);
    };
    const updateMoveOrderListItem = (newValue, oldValue)=>{
        const clonedOrder = {
            ...moveOrderTransaction
        };
        const clonedTransactions = [
            ...clonedOrder.transactions
        ];
        const transactionIndex = clonedTransactions.findIndex((e)=>e.item === oldValue.item);
        if (transactionIndex !== -1) {
            clonedTransactions[transactionIndex] = {
                ...clonedTransactions[transactionIndex],
                transactionQuantity: newValue.transactionQuantity
            };
            clonedOrder.transactions = [
                ...clonedTransactions
            ];
            setMoveOrderTransaction(clonedOrder);
        }
    };
    const submitDisabled = ()=>moveOrderTransaction.transactions?.length === 0;
    //////////////////////////////////////////////////
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $80b77aecebb89dcc$export$beeb152867b52d97), {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).pageCard,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).pageHeader,
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).pageHeaderFlex,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h6", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).pageHeaderTitle,
                            children: "Add Move Order"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).contentStack,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9e65d9cd95f8360c$export$2e2bcd8739ae039), {
                                selectedValueOnChange: plantMROSubInvValueOnChange,
                                defaultDestinationAcct: selectedWorkOrder ? `${selectedWorkOrder.costcenterId}.302101.00000.0000` : undefined,
                                COALLookupActive: $22cf9b62ef34cea1$var$handleCOALookupActive
                            })
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            children: selectedWorkOrder ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0853625c592a457d$export$2e2bcd8739ae039), {
                                sparePartOnChange: sparePartsOnChange,
                                showTitle: true,
                                title: "Available Spare Parts",
                                workOrder: selectedWorkOrder
                            }) : null
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                size: "sm",
                                color: "secondary",
                                onClick: ()=>setShowFullPartLookup(!showFullPartLookup),
                                children: "Full Items Selector"
                            })
                        }),
                        showFullPartLookup && selectedWorkOrder ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $aa779ec2c5c5a324$export$2e2bcd8739ae039), {
                            partOnChange: fullPartsOnChange,
                            selectedOrg: plantMROSubInvValue?.settings?.MoveOrderMROOrg,
                            showTitle: true,
                            title: "Full Parts Lookup (enter Item or Desc)"
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).bottomSection,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("hr", {})
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $baece2db01264858$export$2e2bcd8739ae039), {
                                moveOrderItemsList: moveOrderTransaction.transactions,
                                deleteRecord: deleteMoveOrderListItem,
                                updateRecord: updateMoveOrderListItem
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).buttonRow,
                    children: [
                        !transactionComplete ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "secondary",
                            size: "sm",
                            onClick: handleClose,
                            children: "Cancel"
                        }) : null,
                        !transactionComplete ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            size: "sm",
                            disabled: submitDisabled(),
                            color: "primary",
                            onClick: submitMoveOrder,
                            children: "Submit"
                        }) : null,
                        transactionComplete ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($0def554e855af510$exports))).successBanner,
                            children: "Transaction Complete"
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($22cf9b62ef34cea1$var$SelectedItemDetailsModal, {
                    selectedValue: invItemDetails,
                    open: openDetailsModal,
                    onClose: handlePartDetailModalClose
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($22cf9b62ef34cea1$var$DuplicateItemDialog, {
                    open: openAlertDialog,
                    onClose: handleDuplicateDialogClose
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($22cf9b62ef34cea1$var$AssignmentConfirmModal, {
                    open: assignmentModalOpen,
                    onClose: handleAssignmentModalClose,
                    currentlyAssignedList: pendingAssignmentData?.currentlyAssignedList ?? []
                })
            ]
        })
    });
};
var $22cf9b62ef34cea1$export$2e2bcd8739ae039 = $22cf9b62ef34cea1$var$MoveOrderAdd;






var $lCzvA = parcelRequire("lCzvA");



var $b879052b31eb8b5d$exports = {};

$parcel$export($b879052b31eb8b5d$exports, "continueRow", function () { return $b879052b31eb8b5d$export$31eafd18d9fb3799; }, function (v) { return $b879052b31eb8b5d$export$31eafd18d9fb3799 = v; });
$parcel$export($b879052b31eb8b5d$exports, "dateFilterGroup", function () { return $b879052b31eb8b5d$export$65ab6fbfe3c59cf6; }, function (v) { return $b879052b31eb8b5d$export$65ab6fbfe3c59cf6 = v; });
$parcel$export($b879052b31eb8b5d$exports, "dateFilterInput", function () { return $b879052b31eb8b5d$export$f33c49c10fc115c; }, function (v) { return $b879052b31eb8b5d$export$f33c49c10fc115c = v; });
$parcel$export($b879052b31eb8b5d$exports, "dateFilterLabel", function () { return $b879052b31eb8b5d$export$923e3a9e7318c4c3; }, function (v) { return $b879052b31eb8b5d$export$923e3a9e7318c4c3 = v; });
$parcel$export($b879052b31eb8b5d$exports, "emptyMessage", function () { return $b879052b31eb8b5d$export$25e67b218624b576; }, function (v) { return $b879052b31eb8b5d$export$25e67b218624b576 = v; });
$parcel$export($b879052b31eb8b5d$exports, "filterDropdown", function () { return $b879052b31eb8b5d$export$dff3e9efbc6ba32c; }, function (v) { return $b879052b31eb8b5d$export$dff3e9efbc6ba32c = v; });
$parcel$export($b879052b31eb8b5d$exports, "filterDropdownNoOptions", function () { return $b879052b31eb8b5d$export$ace8688560bff1ef; }, function (v) { return $b879052b31eb8b5d$export$ace8688560bff1ef = v; });
$parcel$export($b879052b31eb8b5d$exports, "filterDropdownOption", function () { return $b879052b31eb8b5d$export$7e36e67c3c246543; }, function (v) { return $b879052b31eb8b5d$export$7e36e67c3c246543 = v; });
$parcel$export($b879052b31eb8b5d$exports, "filterDropdownPanel", function () { return $b879052b31eb8b5d$export$b547056c89124b8d; }, function (v) { return $b879052b31eb8b5d$export$b547056c89124b8d = v; });
$parcel$export($b879052b31eb8b5d$exports, "filterDropdownSearch", function () { return $b879052b31eb8b5d$export$8969d53285b8c5e0; }, function (v) { return $b879052b31eb8b5d$export$8969d53285b8c5e0 = v; });
$parcel$export($b879052b31eb8b5d$exports, "filterDropdownSummary", function () { return $b879052b31eb8b5d$export$349be7f2b368d3df; }, function (v) { return $b879052b31eb8b5d$export$349be7f2b368d3df = v; });
$parcel$export($b879052b31eb8b5d$exports, "filterInfo", function () { return $b879052b31eb8b5d$export$fa82680f88ffae57; }, function (v) { return $b879052b31eb8b5d$export$fa82680f88ffae57 = v; });
$parcel$export($b879052b31eb8b5d$exports, "filterRow", function () { return $b879052b31eb8b5d$export$58c9fd6b8a6e3f69; }, function (v) { return $b879052b31eb8b5d$export$58c9fd6b8a6e3f69 = v; });
$parcel$export($b879052b31eb8b5d$exports, "filterSelect", function () { return $b879052b31eb8b5d$export$3fd87dc5a8e4b986; }, function (v) { return $b879052b31eb8b5d$export$3fd87dc5a8e4b986 = v; });
$parcel$export($b879052b31eb8b5d$exports, "filterTextInput", function () { return $b879052b31eb8b5d$export$45b0bd4c45229548; }, function (v) { return $b879052b31eb8b5d$export$45b0bd4c45229548 = v; });
$parcel$export($b879052b31eb8b5d$exports, "funnelBarFill", function () { return $b879052b31eb8b5d$export$b9e42761aceff405; }, function (v) { return $b879052b31eb8b5d$export$b9e42761aceff405 = v; });
$parcel$export($b879052b31eb8b5d$exports, "funnelBarTrack", function () { return $b879052b31eb8b5d$export$96a08ab731b3de06; }, function (v) { return $b879052b31eb8b5d$export$96a08ab731b3de06 = v; });
$parcel$export($b879052b31eb8b5d$exports, "funnelItemMeta", function () { return $b879052b31eb8b5d$export$ea96e04d1efa3c51; }, function (v) { return $b879052b31eb8b5d$export$ea96e04d1efa3c51 = v; });
$parcel$export($b879052b31eb8b5d$exports, "funnelList", function () { return $b879052b31eb8b5d$export$5b83befcd6bf3dd1; }, function (v) { return $b879052b31eb8b5d$export$5b83befcd6bf3dd1 = v; });
$parcel$export($b879052b31eb8b5d$exports, "headerRow", function () { return $b879052b31eb8b5d$export$faed4863136ce212; }, function (v) { return $b879052b31eb8b5d$export$faed4863136ce212 = v; });
$parcel$export($b879052b31eb8b5d$exports, "heuristicNote", function () { return $b879052b31eb8b5d$export$8c0393dd33667917; }, function (v) { return $b879052b31eb8b5d$export$8c0393dd33667917 = v; });
$parcel$export($b879052b31eb8b5d$exports, "lineChartAxis", function () { return $b879052b31eb8b5d$export$d5e46013125b024; }, function (v) { return $b879052b31eb8b5d$export$d5e46013125b024 = v; });
$parcel$export($b879052b31eb8b5d$exports, "lineChartDateLabel", function () { return $b879052b31eb8b5d$export$a745471c88278931; }, function (v) { return $b879052b31eb8b5d$export$a745471c88278931 = v; });
$parcel$export($b879052b31eb8b5d$exports, "lineChartFootnote", function () { return $b879052b31eb8b5d$export$de084f99ce5e9db7; }, function (v) { return $b879052b31eb8b5d$export$de084f99ce5e9db7 = v; });
$parcel$export($b879052b31eb8b5d$exports, "lineChartGridline", function () { return $b879052b31eb8b5d$export$2db441dc7dc43a23; }, function (v) { return $b879052b31eb8b5d$export$2db441dc7dc43a23 = v; });
$parcel$export($b879052b31eb8b5d$exports, "lineChartHoverValue", function () { return $b879052b31eb8b5d$export$ea30ed5ac8e16036; }, function (v) { return $b879052b31eb8b5d$export$ea30ed5ac8e16036 = v; });
$parcel$export($b879052b31eb8b5d$exports, "lineChartPath", function () { return $b879052b31eb8b5d$export$20611909e5db2d95; }, function (v) { return $b879052b31eb8b5d$export$20611909e5db2d95 = v; });
$parcel$export($b879052b31eb8b5d$exports, "lineChartPoint", function () { return $b879052b31eb8b5d$export$883b780bd8d15eb5; }, function (v) { return $b879052b31eb8b5d$export$883b780bd8d15eb5 = v; });
$parcel$export($b879052b31eb8b5d$exports, "lineChartPointActive", function () { return $b879052b31eb8b5d$export$62392af97f206a77; }, function (v) { return $b879052b31eb8b5d$export$62392af97f206a77 = v; });
$parcel$export($b879052b31eb8b5d$exports, "lineChartSvg", function () { return $b879052b31eb8b5d$export$96785ce6d3a14ac3; }, function (v) { return $b879052b31eb8b5d$export$96785ce6d3a14ac3 = v; });
$parcel$export($b879052b31eb8b5d$exports, "lineChartTickLabel", function () { return $b879052b31eb8b5d$export$53530e1c18a17620; }, function (v) { return $b879052b31eb8b5d$export$53530e1c18a17620 = v; });
$parcel$export($b879052b31eb8b5d$exports, "lineChartWrapper", function () { return $b879052b31eb8b5d$export$9713ba9d0c72fb11; }, function (v) { return $b879052b31eb8b5d$export$9713ba9d0c72fb11 = v; });
$parcel$export($b879052b31eb8b5d$exports, "metricCard", function () { return $b879052b31eb8b5d$export$daae893090f199a8; }, function (v) { return $b879052b31eb8b5d$export$daae893090f199a8 = v; });
$parcel$export($b879052b31eb8b5d$exports, "metricHint", function () { return $b879052b31eb8b5d$export$842414c6acff8471; }, function (v) { return $b879052b31eb8b5d$export$842414c6acff8471 = v; });
$parcel$export($b879052b31eb8b5d$exports, "metricNegative", function () { return $b879052b31eb8b5d$export$f38304b6d9936bbb; }, function (v) { return $b879052b31eb8b5d$export$f38304b6d9936bbb = v; });
$parcel$export($b879052b31eb8b5d$exports, "metricPositive", function () { return $b879052b31eb8b5d$export$e5fd0b86c0f31251; }, function (v) { return $b879052b31eb8b5d$export$e5fd0b86c0f31251 = v; });
$parcel$export($b879052b31eb8b5d$exports, "metricRatio", function () { return $b879052b31eb8b5d$export$4a58d38930bcd01a; }, function (v) { return $b879052b31eb8b5d$export$4a58d38930bcd01a = v; });
$parcel$export($b879052b31eb8b5d$exports, "metricTitle", function () { return $b879052b31eb8b5d$export$4533bbca15276c3f; }, function (v) { return $b879052b31eb8b5d$export$4533bbca15276c3f = v; });
$parcel$export($b879052b31eb8b5d$exports, "metricsGrid", function () { return $b879052b31eb8b5d$export$ff8f16205cd2dd01; }, function (v) { return $b879052b31eb8b5d$export$ff8f16205cd2dd01 = v; });
$parcel$export($b879052b31eb8b5d$exports, "outcomeRow", function () { return $b879052b31eb8b5d$export$c272084e274e2ca0; }, function (v) { return $b879052b31eb8b5d$export$c272084e274e2ca0 = v; });
$parcel$export($b879052b31eb8b5d$exports, "paginationControls", function () { return $b879052b31eb8b5d$export$e302d0a27c6cead8; }, function (v) { return $b879052b31eb8b5d$export$e302d0a27c6cead8 = v; });
$parcel$export($b879052b31eb8b5d$exports, "paginationLabel", function () { return $b879052b31eb8b5d$export$a941b4b1b0ba7fbd; }, function (v) { return $b879052b31eb8b5d$export$a941b4b1b0ba7fbd = v; });
$parcel$export($b879052b31eb8b5d$exports, "paginationSummary", function () { return $b879052b31eb8b5d$export$600ae1a9bcef33ec; }, function (v) { return $b879052b31eb8b5d$export$600ae1a9bcef33ec = v; });
$parcel$export($b879052b31eb8b5d$exports, "qaActionRow", function () { return $b879052b31eb8b5d$export$61e842ba68703603; }, function (v) { return $b879052b31eb8b5d$export$61e842ba68703603 = v; });
$parcel$export($b879052b31eb8b5d$exports, "qaAssessmentPartial", function () { return $b879052b31eb8b5d$export$2c9f0e9b98c36908; }, function (v) { return $b879052b31eb8b5d$export$2c9f0e9b98c36908 = v; });
$parcel$export($b879052b31eb8b5d$exports, "qaAssessmentQuick", function () { return $b879052b31eb8b5d$export$c9ecf250bf315ae8; }, function (v) { return $b879052b31eb8b5d$export$c9ecf250bf315ae8 = v; });
$parcel$export($b879052b31eb8b5d$exports, "qaAssessmentSpent", function () { return $b879052b31eb8b5d$export$82bde8e5fa17ddb1; }, function (v) { return $b879052b31eb8b5d$export$82bde8e5fa17ddb1 = v; });
$parcel$export($b879052b31eb8b5d$exports, "qaCard", function () { return $b879052b31eb8b5d$export$ea6dedf84df11b79; }, function (v) { return $b879052b31eb8b5d$export$ea6dedf84df11b79 = v; });
$parcel$export($b879052b31eb8b5d$exports, "qaCardHeader", function () { return $b879052b31eb8b5d$export$a151fe78da6d5fc2; }, function (v) { return $b879052b31eb8b5d$export$a151fe78da6d5fc2 = v; });
$parcel$export($b879052b31eb8b5d$exports, "qaCell", function () { return $b879052b31eb8b5d$export$7152de534de47642; }, function (v) { return $b879052b31eb8b5d$export$7152de534de47642 = v; });
$parcel$export($b879052b31eb8b5d$exports, "qaList", function () { return $b879052b31eb8b5d$export$8b9ef87f28ec3424; }, function (v) { return $b879052b31eb8b5d$export$8b9ef87f28ec3424 = v; });
$parcel$export($b879052b31eb8b5d$exports, "qaModalContent", function () { return $b879052b31eb8b5d$export$2eef791f8f8adb64; }, function (v) { return $b879052b31eb8b5d$export$2eef791f8f8adb64 = v; });
$parcel$export($b879052b31eb8b5d$exports, "qaModalMeta", function () { return $b879052b31eb8b5d$export$2629bf976b289e12; }, function (v) { return $b879052b31eb8b5d$export$2629bf976b289e12 = v; });
$parcel$export($b879052b31eb8b5d$exports, "qaQuestion", function () { return $b879052b31eb8b5d$export$823fd9745b9ee8fd; }, function (v) { return $b879052b31eb8b5d$export$823fd9745b9ee8fd = v; });
$parcel$export($b879052b31eb8b5d$exports, "table", function () { return $b879052b31eb8b5d$export$9852986a3ec5f6a0; }, function (v) { return $b879052b31eb8b5d$export$9852986a3ec5f6a0 = v; });
$parcel$export($b879052b31eb8b5d$exports, "tableWrapper", function () { return $b879052b31eb8b5d$export$e7d47881ec916f76; }, function (v) { return $b879052b31eb8b5d$export$e7d47881ec916f76 = v; });
$parcel$export($b879052b31eb8b5d$exports, "trendBarFill", function () { return $b879052b31eb8b5d$export$537072a14c9bdf37; }, function (v) { return $b879052b31eb8b5d$export$537072a14c9bdf37 = v; });
$parcel$export($b879052b31eb8b5d$exports, "trendBarTrack", function () { return $b879052b31eb8b5d$export$5f207b6a035d4b83; }, function (v) { return $b879052b31eb8b5d$export$5f207b6a035d4b83 = v; });
$parcel$export($b879052b31eb8b5d$exports, "trendItem", function () { return $b879052b31eb8b5d$export$95878321c65cd9ac; }, function (v) { return $b879052b31eb8b5d$export$95878321c65cd9ac = v; });
$parcel$export($b879052b31eb8b5d$exports, "trendLabel", function () { return $b879052b31eb8b5d$export$912cb7f9e8b18ea4; }, function (v) { return $b879052b31eb8b5d$export$912cb7f9e8b18ea4 = v; });
$parcel$export($b879052b31eb8b5d$exports, "trendList", function () { return $b879052b31eb8b5d$export$cac4d4e1642be7e8; }, function (v) { return $b879052b31eb8b5d$export$cac4d4e1642be7e8 = v; });
$parcel$export($b879052b31eb8b5d$exports, "trendValue", function () { return $b879052b31eb8b5d$export$192be294599aba9d; }, function (v) { return $b879052b31eb8b5d$export$192be294599aba9d = v; });
$parcel$export($b879052b31eb8b5d$exports, "usageCard", function () { return $b879052b31eb8b5d$export$801203881b62929b; }, function (v) { return $b879052b31eb8b5d$export$801203881b62929b = v; });
$parcel$export($b879052b31eb8b5d$exports, "usageEmpty", function () { return $b879052b31eb8b5d$export$b271db6f1c24cedc; }, function (v) { return $b879052b31eb8b5d$export$b271db6f1c24cedc = v; });
$parcel$export($b879052b31eb8b5d$exports, "usageSection", function () { return $b879052b31eb8b5d$export$3db294afd674d644; }, function (v) { return $b879052b31eb8b5d$export$3db294afd674d644 = v; });
var $b879052b31eb8b5d$export$31eafd18d9fb3799;
var $b879052b31eb8b5d$export$65ab6fbfe3c59cf6;
var $b879052b31eb8b5d$export$f33c49c10fc115c;
var $b879052b31eb8b5d$export$923e3a9e7318c4c3;
var $b879052b31eb8b5d$export$25e67b218624b576;
var $b879052b31eb8b5d$export$dff3e9efbc6ba32c;
var $b879052b31eb8b5d$export$ace8688560bff1ef;
var $b879052b31eb8b5d$export$7e36e67c3c246543;
var $b879052b31eb8b5d$export$b547056c89124b8d;
var $b879052b31eb8b5d$export$8969d53285b8c5e0;
var $b879052b31eb8b5d$export$349be7f2b368d3df;
var $b879052b31eb8b5d$export$fa82680f88ffae57;
var $b879052b31eb8b5d$export$58c9fd6b8a6e3f69;
var $b879052b31eb8b5d$export$3fd87dc5a8e4b986;
var $b879052b31eb8b5d$export$45b0bd4c45229548;
var $b879052b31eb8b5d$export$b9e42761aceff405;
var $b879052b31eb8b5d$export$96a08ab731b3de06;
var $b879052b31eb8b5d$export$ea96e04d1efa3c51;
var $b879052b31eb8b5d$export$5b83befcd6bf3dd1;
var $b879052b31eb8b5d$export$faed4863136ce212;
var $b879052b31eb8b5d$export$8c0393dd33667917;
var $b879052b31eb8b5d$export$d5e46013125b024;
var $b879052b31eb8b5d$export$a745471c88278931;
var $b879052b31eb8b5d$export$de084f99ce5e9db7;
var $b879052b31eb8b5d$export$2db441dc7dc43a23;
var $b879052b31eb8b5d$export$ea30ed5ac8e16036;
var $b879052b31eb8b5d$export$20611909e5db2d95;
var $b879052b31eb8b5d$export$883b780bd8d15eb5;
var $b879052b31eb8b5d$export$62392af97f206a77;
var $b879052b31eb8b5d$export$96785ce6d3a14ac3;
var $b879052b31eb8b5d$export$53530e1c18a17620;
var $b879052b31eb8b5d$export$9713ba9d0c72fb11;
var $b879052b31eb8b5d$export$daae893090f199a8;
var $b879052b31eb8b5d$export$842414c6acff8471;
var $b879052b31eb8b5d$export$f38304b6d9936bbb;
var $b879052b31eb8b5d$export$e5fd0b86c0f31251;
var $b879052b31eb8b5d$export$4a58d38930bcd01a;
var $b879052b31eb8b5d$export$4533bbca15276c3f;
var $b879052b31eb8b5d$export$ff8f16205cd2dd01;
var $b879052b31eb8b5d$export$c272084e274e2ca0;
var $b879052b31eb8b5d$export$e302d0a27c6cead8;
var $b879052b31eb8b5d$export$a941b4b1b0ba7fbd;
var $b879052b31eb8b5d$export$600ae1a9bcef33ec;
var $b879052b31eb8b5d$export$61e842ba68703603;
var $b879052b31eb8b5d$export$2c9f0e9b98c36908;
var $b879052b31eb8b5d$export$c9ecf250bf315ae8;
var $b879052b31eb8b5d$export$82bde8e5fa17ddb1;
var $b879052b31eb8b5d$export$ea6dedf84df11b79;
var $b879052b31eb8b5d$export$a151fe78da6d5fc2;
var $b879052b31eb8b5d$export$7152de534de47642;
var $b879052b31eb8b5d$export$8b9ef87f28ec3424;
var $b879052b31eb8b5d$export$2eef791f8f8adb64;
var $b879052b31eb8b5d$export$2629bf976b289e12;
var $b879052b31eb8b5d$export$823fd9745b9ee8fd;
var $b879052b31eb8b5d$export$9852986a3ec5f6a0;
var $b879052b31eb8b5d$export$e7d47881ec916f76;
var $b879052b31eb8b5d$export$537072a14c9bdf37;
var $b879052b31eb8b5d$export$5f207b6a035d4b83;
var $b879052b31eb8b5d$export$95878321c65cd9ac;
var $b879052b31eb8b5d$export$912cb7f9e8b18ea4;
var $b879052b31eb8b5d$export$cac4d4e1642be7e8;
var $b879052b31eb8b5d$export$192be294599aba9d;
var $b879052b31eb8b5d$export$801203881b62929b;
var $b879052b31eb8b5d$export$b271db6f1c24cedc;
var $b879052b31eb8b5d$export$3db294afd674d644;
$b879052b31eb8b5d$export$31eafd18d9fb3799 = `I4zTMa_continueRow`;
$b879052b31eb8b5d$export$65ab6fbfe3c59cf6 = `I4zTMa_dateFilterGroup`;
$b879052b31eb8b5d$export$f33c49c10fc115c = `I4zTMa_dateFilterInput`;
$b879052b31eb8b5d$export$923e3a9e7318c4c3 = `I4zTMa_dateFilterLabel`;
$b879052b31eb8b5d$export$25e67b218624b576 = `I4zTMa_emptyMessage`;
$b879052b31eb8b5d$export$dff3e9efbc6ba32c = `I4zTMa_filterDropdown`;
$b879052b31eb8b5d$export$ace8688560bff1ef = `I4zTMa_filterDropdownNoOptions`;
$b879052b31eb8b5d$export$7e36e67c3c246543 = `I4zTMa_filterDropdownOption`;
$b879052b31eb8b5d$export$b547056c89124b8d = `I4zTMa_filterDropdownPanel`;
$b879052b31eb8b5d$export$8969d53285b8c5e0 = `I4zTMa_filterDropdownSearch`;
$b879052b31eb8b5d$export$349be7f2b368d3df = `I4zTMa_filterDropdownSummary`;
$b879052b31eb8b5d$export$fa82680f88ffae57 = `I4zTMa_filterInfo`;
$b879052b31eb8b5d$export$58c9fd6b8a6e3f69 = `I4zTMa_filterRow`;
$b879052b31eb8b5d$export$3fd87dc5a8e4b986 = `I4zTMa_filterSelect`;
$b879052b31eb8b5d$export$45b0bd4c45229548 = `I4zTMa_filterTextInput`;
$b879052b31eb8b5d$export$b9e42761aceff405 = `I4zTMa_funnelBarFill`;
$b879052b31eb8b5d$export$96a08ab731b3de06 = `I4zTMa_funnelBarTrack`;
$b879052b31eb8b5d$export$ea96e04d1efa3c51 = `I4zTMa_funnelItemMeta`;
$b879052b31eb8b5d$export$5b83befcd6bf3dd1 = `I4zTMa_funnelList`;
$b879052b31eb8b5d$export$faed4863136ce212 = `I4zTMa_headerRow`;
$b879052b31eb8b5d$export$8c0393dd33667917 = `I4zTMa_heuristicNote`;
$b879052b31eb8b5d$export$d5e46013125b024 = `I4zTMa_lineChartAxis`;
$b879052b31eb8b5d$export$a745471c88278931 = `I4zTMa_lineChartDateLabel`;
$b879052b31eb8b5d$export$de084f99ce5e9db7 = `I4zTMa_lineChartFootnote`;
$b879052b31eb8b5d$export$2db441dc7dc43a23 = `I4zTMa_lineChartGridline`;
$b879052b31eb8b5d$export$ea30ed5ac8e16036 = `I4zTMa_lineChartHoverValue`;
$b879052b31eb8b5d$export$20611909e5db2d95 = `I4zTMa_lineChartPath`;
$b879052b31eb8b5d$export$883b780bd8d15eb5 = `I4zTMa_lineChartPoint`;
$b879052b31eb8b5d$export$62392af97f206a77 = `I4zTMa_lineChartPointActive`;
$b879052b31eb8b5d$export$96785ce6d3a14ac3 = `I4zTMa_lineChartSvg`;
$b879052b31eb8b5d$export$53530e1c18a17620 = `I4zTMa_lineChartTickLabel`;
$b879052b31eb8b5d$export$9713ba9d0c72fb11 = `I4zTMa_lineChartWrapper`;
$b879052b31eb8b5d$export$daae893090f199a8 = `I4zTMa_metricCard`;
$b879052b31eb8b5d$export$842414c6acff8471 = `I4zTMa_metricHint`;
$b879052b31eb8b5d$export$f38304b6d9936bbb = `I4zTMa_metricNegative`;
$b879052b31eb8b5d$export$e5fd0b86c0f31251 = `I4zTMa_metricPositive`;
$b879052b31eb8b5d$export$4a58d38930bcd01a = `I4zTMa_metricRatio`;
$b879052b31eb8b5d$export$4533bbca15276c3f = `I4zTMa_metricTitle`;
$b879052b31eb8b5d$export$ff8f16205cd2dd01 = `I4zTMa_metricsGrid`;
$b879052b31eb8b5d$export$c272084e274e2ca0 = `I4zTMa_outcomeRow`;
$b879052b31eb8b5d$export$e302d0a27c6cead8 = `I4zTMa_paginationControls`;
$b879052b31eb8b5d$export$a941b4b1b0ba7fbd = `I4zTMa_paginationLabel`;
$b879052b31eb8b5d$export$600ae1a9bcef33ec = `I4zTMa_paginationSummary`;
$b879052b31eb8b5d$export$61e842ba68703603 = `I4zTMa_qaActionRow`;
$b879052b31eb8b5d$export$2c9f0e9b98c36908 = `I4zTMa_qaAssessmentPartial`;
$b879052b31eb8b5d$export$c9ecf250bf315ae8 = `I4zTMa_qaAssessmentQuick`;
$b879052b31eb8b5d$export$82bde8e5fa17ddb1 = `I4zTMa_qaAssessmentSpent`;
$b879052b31eb8b5d$export$ea6dedf84df11b79 = `I4zTMa_qaCard`;
$b879052b31eb8b5d$export$a151fe78da6d5fc2 = `I4zTMa_qaCardHeader`;
$b879052b31eb8b5d$export$7152de534de47642 = `I4zTMa_qaCell`;
$b879052b31eb8b5d$export$8b9ef87f28ec3424 = `I4zTMa_qaList`;
$b879052b31eb8b5d$export$2eef791f8f8adb64 = `I4zTMa_qaModalContent`;
$b879052b31eb8b5d$export$2629bf976b289e12 = `I4zTMa_qaModalMeta`;
$b879052b31eb8b5d$export$823fd9745b9ee8fd = `I4zTMa_qaQuestion`;
$b879052b31eb8b5d$export$9852986a3ec5f6a0 = `I4zTMa_table`;
$b879052b31eb8b5d$export$e7d47881ec916f76 = `I4zTMa_tableWrapper`;
$b879052b31eb8b5d$export$537072a14c9bdf37 = `I4zTMa_trendBarFill`;
$b879052b31eb8b5d$export$5f207b6a035d4b83 = `I4zTMa_trendBarTrack`;
$b879052b31eb8b5d$export$95878321c65cd9ac = `I4zTMa_trendItem`;
$b879052b31eb8b5d$export$912cb7f9e8b18ea4 = `I4zTMa_trendLabel`;
$b879052b31eb8b5d$export$cac4d4e1642be7e8 = `I4zTMa_trendList`;
$b879052b31eb8b5d$export$192be294599aba9d = `I4zTMa_trendValue`;
$b879052b31eb8b5d$export$801203881b62929b = `I4zTMa_usageCard`;
$b879052b31eb8b5d$export$b271db6f1c24cedc = `I4zTMa_usageEmpty`;
$b879052b31eb8b5d$export$3db294afd674d644 = `I4zTMa_usageSection`;


const $eb727c06eea1b8de$var$PAGE_SIZE = 100;
const $eb727c06eea1b8de$var$USAGE_LINE_CHART_WIDTH = 560;
const $eb727c06eea1b8de$var$USAGE_LINE_CHART_HEIGHT = 220;
const $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING = {
    top: 20,
    right: 20,
    bottom: 36,
    left: 44
};
const $eb727c06eea1b8de$var$formatDateTime = (timestamp)=>{
    if (!timestamp) return 'N/A';
    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) return 'N/A';
    return date.toLocaleString();
};
const $eb727c06eea1b8de$var$formatTime = (timestamp)=>{
    if (!timestamp) return '';
    if (typeof timestamp === 'string') return timestamp;
    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
};
const $eb727c06eea1b8de$var$QA_ENGAGEMENT_DISPLAY = {
    SPENT_TIME: {
        label: 'Spent time*',
        toneClassName: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).qaAssessmentSpent
    },
    PARTIAL: {
        label: 'Partial*',
        toneClassName: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).qaAssessmentPartial
    },
    QUICK_PASS: {
        label: 'Quick pass*',
        toneClassName: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).qaAssessmentQuick
    }
};
const $eb727c06eea1b8de$var$getQaEngagementAssessment = (row)=>$eb727c06eea1b8de$var$QA_ENGAGEMENT_DISPLAY[row.qaEngagement] || null;
const $eb727c06eea1b8de$var$getDayStart = (value)=>{
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    date.setHours(0, 0, 0, 0);
    return date;
};
const $eb727c06eea1b8de$var$formatShortDate = (value)=>{
    if (!(value instanceof Date)) return '';
    return value.toLocaleDateString([], {
        month: 'short',
        day: 'numeric'
    });
};
const $eb727c06eea1b8de$var$getDaysBetween = (startDate, endDate)=>{
    if (!(startDate instanceof Date) || !(endDate instanceof Date) || startDate > endDate) return [];
    const startTime = startDate.getTime();
    const endTime = endDate.getTime();
    const dayMs = 86400000;
    const dayCount = Math.floor((endTime - startTime) / dayMs) + 1;
    return Array.from({
        length: dayCount
    }, (_, index)=>new Date(startTime + index * dayMs));
};
const $eb727c06eea1b8de$var$normalizeFilterOptions = (values = [], selectedValue = '')=>{
    const normalizedValues = Array.isArray(values) ? values.map((value)=>typeof value === 'string' ? value.trim() : '').filter(Boolean) : [];
    const uniqueValues = [
        ...new Set(normalizedValues)
    ].toSorted((a, b)=>a.localeCompare(b));
    const normalizedSelected = typeof selectedValue === 'string' ? selectedValue.trim() : '';
    if (normalizedSelected && !uniqueValues.includes(normalizedSelected)) return [
        normalizedSelected,
        ...uniqueValues
    ];
    return uniqueValues;
};
const $eb727c06eea1b8de$var$buildUsageLinePath = (points)=>{
    if (!points.length) return '';
    return points.map((point, index)=>`${index === 0 ? 'M' : 'L'} ${point.x} ${point.y}`).join(' ');
};
const $eb727c06eea1b8de$var$normalizeDateInput = (value)=>{
    if (typeof value !== 'string') return undefined;
    const trimmedValue = value.trim();
    return /^\d{4}-\d{2}-\d{2}$/u.test(trimmedValue) ? trimmedValue : undefined;
};
const $eb727c06eea1b8de$var$downloadBlobAsFile = (blob, filename)=>{
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.append(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};
const $eb727c06eea1b8de$var$FilterChecklistDropdown = ({ label: label, allLabel: allLabel, options: options, selectedValue: selectedValue, onChange: onChange })=>{
    const [searchTerm, setSearchTerm] = (0, $lCzvA.useState)('');
    const filteredOptions = (0, $lCzvA.useMemo)(()=>{
        const needle = searchTerm.trim().toLowerCase();
        if (!needle) return options;
        return options.filter((option)=>option.toLowerCase().includes(needle));
    }, [
        options,
        searchTerm
    ]);
    const summaryLabel = selectedValue || allLabel;
    const searchable = options.length > 7;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("details", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).filterDropdown,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("summary", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).filterDropdownSummary,
                "aria-label": label,
                children: summaryLabel
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).filterDropdownPanel,
                children: [
                    searchable ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                        type: "text",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).filterDropdownSearch,
                        placeholder: "Search",
                        value: searchTerm,
                        onChange: (e)=>setSearchTerm(e.target.value)
                    }) : null,
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("label", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).filterDropdownOption,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                                type: "checkbox",
                                checked: !selectedValue,
                                onChange: ()=>onChange('')
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                children: allLabel
                            })
                        ]
                    }),
                    filteredOptions.length ? filteredOptions.map((option)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("label", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).filterDropdownOption,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: selectedValue === option,
                                    onChange: ()=>onChange(option)
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                    children: option
                                })
                            ]
                        }, option)) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).filterDropdownNoOptions,
                        children: "No matches"
                    })
                ]
            })
        ]
    });
};
/**
 * Display analytics rows and derived usage summaries.
 * @returns {import('react').ReactElement} The analytics page.
 */ const $eb727c06eea1b8de$var$Analytics = ()=>{
    const [selectedQaRow, setSelectedQaRow] = (0, $lCzvA.useState)(null);
    const [currentPage, setCurrentPage] = (0, $lCzvA.useState)(0);
    const [employeeFilter, setEmployeeFilter] = (0, $lCzvA.useState)('');
    const [siteFilter, setSiteFilter] = (0, $lCzvA.useState)('');
    const [serviceAreaFilter, setServiceAreaFilter] = (0, $lCzvA.useState)('');
    const [serviceActionFilter, setServiceActionFilter] = (0, $lCzvA.useState)('');
    const [outcomeFilter, setOutcomeFilter] = (0, $lCzvA.useState)('');
    const [startDateFilter, setStartDateFilter] = (0, $lCzvA.useState)('');
    const [endDateFilter, setEndDateFilter] = (0, $lCzvA.useState)('');
    const [appliedStartDateFilter, setAppliedStartDateFilter] = (0, $lCzvA.useState)('');
    const [appliedEndDateFilter, setAppliedEndDateFilter] = (0, $lCzvA.useState)('');
    const [dateInputResetToken, setDateInputResetToken] = (0, $lCzvA.useState)(0);
    const [hoveredUsagePoint, setHoveredUsagePoint] = (0, $lCzvA.useState)(null);
    const [appliedFilters, setAppliedFilters] = (0, $lCzvA.useState)({});
    const { data: analyticsRows, isError: isRowsError, isFetching: isRowsFetching, refetch: refetchRows } = (0, $fd8a60a16d73d8a8$export$92ff0b970b43cf29)({
        limit: $eb727c06eea1b8de$var$PAGE_SIZE,
        offset: currentPage * $eb727c06eea1b8de$var$PAGE_SIZE,
        filters: appliedFilters
    });
    const { data: totalCountRaw = 0, isError: isCountError, isFetching: isCountFetching, refetch: refetchCount } = (0, $fd8a60a16d73d8a8$export$527b3425616c6e9)({
        filters: appliedFilters
    });
    const totalCount = typeof totalCountRaw === 'number' ? totalCountRaw : 0;
    const { data: engagementSummary, isError: isEngagementSummaryError, isFetching: isEngagementSummaryFetching, refetch: refetchEngagementSummary } = (0, $fd8a60a16d73d8a8$export$49de258418cceb8f)({
        filters: appliedFilters
    });
    const { mutateAsync: exportUserAnalyticsRows, isPending: isExporting } = (0, $fd8a60a16d73d8a8$export$e19b51e79f0cef08)();
    const { data: filterOptionsRaw = {}, isError: isFilterOptionsError, isFetching: isFilterOptionsFetching, refetch: refetchFilterOptions } = (0, $fd8a60a16d73d8a8$export$4413da5bad6edd97)({
        filters: appliedFilters
    });
    const filterOptions = /** @type {{siteIds?: string[], serviceAreas?: string[], serviceActions?: string[], outcomes?: string[], cancellationReasons?: string[]}} */ filterOptionsRaw && typeof filterOptionsRaw === 'object' ? filterOptionsRaw : {};
    const rows = isRowsError ? [] : (0, $e00dd12a20730d24$export$b9d435f665881d3c)(analyticsRows);
    const isError = isRowsError || isCountError || isFilterOptionsError || isEngagementSummaryError;
    const isRefreshing = isRowsFetching || isEngagementSummaryFetching || isCountFetching || isFilterOptionsFetching;
    const totalPages = Math.max(1, Math.ceil(totalCount / $eb727c06eea1b8de$var$PAGE_SIZE));
    const showingStart = !totalCount ? 0 : currentPage * $eb727c06eea1b8de$var$PAGE_SIZE + 1;
    const showingEnd = Math.min(totalCount, currentPage * $eb727c06eea1b8de$var$PAGE_SIZE + rows.length);
    const siteOptions = $eb727c06eea1b8de$var$normalizeFilterOptions(filterOptions.siteIds, siteFilter);
    const serviceAreaOptions = $eb727c06eea1b8de$var$normalizeFilterOptions(filterOptions.serviceAreas, serviceAreaFilter);
    const serviceActionOptions = $eb727c06eea1b8de$var$normalizeFilterOptions(filterOptions.serviceActions, serviceActionFilter);
    const outcomeOptions = $eb727c06eea1b8de$var$normalizeFilterOptions(filterOptions.outcomes, outcomeFilter);
    const reloadPage = ()=>{
        setStartDateFilter('');
        setEndDateFilter('');
        setAppliedStartDateFilter('');
        setAppliedEndDateFilter('');
        setDateInputResetToken((value)=>value + 1);
        setAppliedFilters((currentFilters)=>{
            const nextFilters = {
                ...currentFilters
            };
            delete nextFilters.fromLastEntryAt;
            delete nextFilters.toLastEntryAt;
            return nextFilters;
        });
        refetchRows();
        refetchEngagementSummary();
        refetchCount();
        refetchFilterOptions();
    };
    const buildFiltersFromInputs = ()=>{
        const normalizeText = (value)=>{
            const normalizedValue = typeof value === 'string' ? value.trim() : '';
            return normalizedValue || undefined;
        };
        const normalizedStartDateFilter = $eb727c06eea1b8de$var$normalizeDateInput(startDateFilter);
        const normalizedEndDateFilter = $eb727c06eea1b8de$var$normalizeDateInput(endDateFilter);
        const fromLastEntryAt = normalizedStartDateFilter ? `${normalizedStartDateFilter}T00:00:00.000Z` : undefined;
        const toLastEntryAt = normalizedEndDateFilter ? `${normalizedEndDateFilter}T23:59:59.999Z` : undefined;
        return {
            empNumber: normalizeText(employeeFilter),
            siteId: normalizeText(siteFilter),
            serviceArea: normalizeText(serviceAreaFilter),
            serviceAction: normalizeText(serviceActionFilter),
            outcome: normalizeText(outcomeFilter),
            fromLastEntryAt: fromLastEntryAt,
            toLastEntryAt: toLastEntryAt
        };
    };
    const applyFilters = ()=>{
        const normalizedStartDateFilter = $eb727c06eea1b8de$var$normalizeDateInput(startDateFilter);
        const normalizedEndDateFilter = $eb727c06eea1b8de$var$normalizeDateInput(endDateFilter);
        const hasInvalidDateInput = startDateFilter && !normalizedStartDateFilter || endDateFilter && !normalizedEndDateFilter;
        const hasInvalidDateRange = normalizedStartDateFilter && normalizedEndDateFilter && new Date(normalizedStartDateFilter).getTime() > new Date(normalizedEndDateFilter).getTime();
        if (hasInvalidDateInput || hasInvalidDateRange) return;
        setCurrentPage(0);
        setAppliedFilters(buildFiltersFromInputs());
        setAppliedStartDateFilter(normalizedStartDateFilter || '');
        setAppliedEndDateFilter(normalizedEndDateFilter || '');
    };
    const resetFilters = ()=>{
        setEmployeeFilter('');
        setSiteFilter('');
        setServiceAreaFilter('');
        setServiceActionFilter('');
        setOutcomeFilter('');
        setStartDateFilter('');
        setEndDateFilter('');
        setAppliedStartDateFilter('');
        setAppliedEndDateFilter('');
        setDateInputResetToken((value)=>value + 1);
        setCurrentPage(0);
        setAppliedFilters({});
    };
    const exportFilteredRows = async ()=>{
        try {
            const { filename: filename, csv: csv } = await exportUserAnalyticsRows(appliedFilters);
            const blob = new Blob([
                csv
            ], {
                type: 'text/csv;charset=utf-8;'
            });
            $eb727c06eea1b8de$var$downloadBlobAsFile(blob, filename);
        } catch  {
        // Export failures surface via isExporting returning to false; the user can retry.
        }
    };
    const closeQaModal = ()=>{
        setSelectedQaRow(null);
    };
    const analyticsSummary = (0, $lCzvA.useMemo)(()=>{
        const summary = /** @type {{ sessionsStarted?: number, reachedOutcome?: number, submittedCount?: number, cancelledCount?: number, submittedWithQaCount?: number, highQualitySubmittedCount?: number, qaAssessedCount?: number, qaSpentTimeCount?: number, dailyTrend?: Array<{ day: string, sessionsCount: number, highQualityCount: number }> }} */ engagementSummary && typeof engagementSummary === 'object' ? engagementSummary : {};
        const sessionsStarted = summary.sessionsStarted ?? 0;
        const reachedOutcome = summary.reachedOutcome ?? 0;
        const submittedCount = summary.submittedCount ?? 0;
        const cancelledCount = summary.cancelledCount ?? 0;
        const submittedWithQaCount = summary.submittedWithQaCount ?? 0;
        const highQualitySubmittedCount = summary.highQualitySubmittedCount ?? 0;
        const qaAssessedCount = summary.qaAssessedCount ?? 0;
        const qaSpentTimeCount = summary.qaSpentTimeCount ?? 0;
        const dailyTrend = Array.isArray(summary.dailyTrend) ? summary.dailyTrend : [];
        const spentTimeRate = qaAssessedCount ? Math.round(qaSpentTimeCount / qaAssessedCount * 100) : null;
        const qualityTrendData = dailyTrend.slice(-12).map((entry)=>{
            const dayStart = new Date(`${entry.day}T00:00:00`);
            return {
                dayStart: dayStart,
                sessions: entry.sessionsCount,
                highQuality: entry.highQualityCount,
                rate: entry.sessionsCount > 0 ? Math.round(entry.highQualityCount / entry.sessionsCount * 100) : 0,
                label: $eb727c06eea1b8de$var$formatShortDate(dayStart)
            };
        });
        return {
            submittedCount: submittedCount,
            cancelledCount: cancelledCount,
            spentTimeRate: spentTimeRate,
            funnelSteps: [
                {
                    label: 'Sessions Started',
                    count: sessionsStarted
                },
                {
                    label: 'Reached Outcome',
                    count: reachedOutcome
                },
                {
                    label: 'Submitted',
                    count: submittedCount
                },
                {
                    label: 'Submitted + Q&A',
                    count: submittedWithQaCount
                },
                {
                    label: 'High-Quality (Spent Time)',
                    count: highQualitySubmittedCount
                }
            ],
            qualityTrendData: qualityTrendData
        };
    }, [
        engagementSummary
    ]);
    const usageTrend = (0, $lCzvA.useMemo)(()=>{
        const summary = /** @type {{ dailyTrend?: Array<{ day: string, sessionsCount: number, highQualityCount: number }> }} */ engagementSummary && typeof engagementSummary === 'object' ? engagementSummary : {};
        const dayUsageCounts = {};
        const dailyTrend = Array.isArray(summary.dailyTrend) ? summary.dailyTrend : [];
        for (const entry of dailyTrend){
            const dayStart = new Date(`${entry.day}T00:00:00`);
            if (Number.isNaN(dayStart.getTime())) continue;
            dayUsageCounts[dayStart.toISOString()] = entry.sessionsCount;
        }
        const normalizedStartDateFilter = $eb727c06eea1b8de$var$normalizeDateInput(appliedStartDateFilter);
        const normalizedEndDateFilter = $eb727c06eea1b8de$var$normalizeDateInput(appliedEndDateFilter);
        const startBoundaryDate = normalizedStartDateFilter ? $eb727c06eea1b8de$var$getDayStart(`${normalizedStartDateFilter}T00:00:00`) : null;
        const endBoundaryDate = normalizedEndDateFilter ? $eb727c06eea1b8de$var$getDayStart(`${normalizedEndDateFilter}T00:00:00`) : null;
        const usageDatesFromRows = Object.keys(dayUsageCounts).map((dayKey)=>$eb727c06eea1b8de$var$getDayStart(dayKey)).filter((value)=>value !== null).toSorted((a, b)=>a.getTime() - b.getTime());
        const inferredStartDate = startBoundaryDate || usageDatesFromRows[0] || null;
        const inferredEndDate = endBoundaryDate || usageDatesFromRows.at(-1) || null;
        const rangeStart = inferredStartDate && inferredEndDate && inferredStartDate > inferredEndDate ? inferredEndDate : inferredStartDate;
        const rangeEnd = inferredStartDate && inferredEndDate && inferredStartDate > inferredEndDate ? inferredStartDate : inferredEndDate;
        const maxUsageWindowDays = 366;
        let usageDays = rangeStart && rangeEnd ? $eb727c06eea1b8de$var$getDaysBetween(rangeStart, rangeEnd) : [];
        if (rangeEnd && usageDays.length > maxUsageWindowDays) {
            const chartWindowStart = new Date(rangeEnd.getTime() - (maxUsageWindowDays - 1) * 86400000);
            usageDays = $eb727c06eea1b8de$var$getDaysBetween(chartWindowStart, rangeEnd);
        }
        const usageTrendData = usageDays.map((dayStart)=>{
            const dayKey = dayStart.toISOString();
            return {
                dayStart: dayStart,
                usage: dayUsageCounts[dayKey] || 0,
                label: $eb727c06eea1b8de$var$formatShortDate(dayStart)
            };
        }).slice(-maxUsageWindowDays);
        const lineChartInnerWidth = $eb727c06eea1b8de$var$USAGE_LINE_CHART_WIDTH - $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.left - $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.right;
        const lineChartInnerHeight = $eb727c06eea1b8de$var$USAGE_LINE_CHART_HEIGHT - $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.top - $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.bottom;
        const maxUsage = Math.max(1, ...usageTrendData.map((entry)=>entry.usage));
        const usagePoints = usageTrendData.map((entry, index)=>{
            const x = usageTrendData.length <= 1 ? $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.left + lineChartInnerWidth / 2 : $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.left + index / (usageTrendData.length - 1) * lineChartInnerWidth;
            const y = $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.top + lineChartInnerHeight - entry.usage / maxUsage * lineChartInnerHeight;
            return {
                ...entry,
                x: x,
                y: y
            };
        });
        return {
            usageTrendData: usageTrendData,
            usagePoints: usagePoints,
            usageLinePath: $eb727c06eea1b8de$var$buildUsageLinePath(usagePoints),
            lineChartInnerWidth: lineChartInnerWidth,
            lineChartInnerHeight: lineChartInnerHeight,
            maxUsage: maxUsage
        };
    }, [
        engagementSummary,
        appliedStartDateFilter,
        appliedEndDateFilter
    ]);
    const hoveredUsageMessage = hoveredUsagePoint ? `${hoveredUsagePoint.label}: ${hoveredUsagePoint.usage}` : 'Hover a point to view count.';
    let modalOutcomeLabel = 'N/A';
    if (selectedQaRow?.outcome === 'submitted') modalOutcomeLabel = 'Submitted';
    else if (selectedQaRow?.outcome === 'cancelled') modalOutcomeLabel = 'Cancelled';
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $439af80902af3e20$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).headerRow,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h2", {
                        children: "User Analytics"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).filterRow,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("label", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).dateFilterLabel,
                                children: [
                                    "Employee #",
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                                        value: employeeFilter,
                                        onChange: (e)=>setEmployeeFilter(e.target.value),
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).filterTextInput,
                                        placeholder: "e.g. 012345"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).dateFilterLabel,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        children: "SiteID"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($eb727c06eea1b8de$var$FilterChecklistDropdown, {
                                        label: "SiteID",
                                        allLabel: "All Sites",
                                        options: siteOptions,
                                        selectedValue: siteFilter,
                                        onChange: setSiteFilter
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).dateFilterLabel,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        children: "Service Area"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($eb727c06eea1b8de$var$FilterChecklistDropdown, {
                                        label: "Service Area",
                                        allLabel: "All Areas",
                                        options: serviceAreaOptions,
                                        selectedValue: serviceAreaFilter,
                                        onChange: setServiceAreaFilter
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).dateFilterLabel,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        children: "Service Action"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($eb727c06eea1b8de$var$FilterChecklistDropdown, {
                                        label: "Service Action",
                                        allLabel: "All Actions",
                                        options: serviceActionOptions,
                                        selectedValue: serviceActionFilter,
                                        onChange: setServiceActionFilter
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).dateFilterLabel,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        children: "Outcome"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($eb727c06eea1b8de$var$FilterChecklistDropdown, {
                                        label: "Outcome",
                                        allLabel: "All Outcomes",
                                        options: outcomeOptions,
                                        selectedValue: outcomeFilter,
                                        onChange: setOutcomeFilter
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).dateFilterGroup,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("label", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).dateFilterLabel,
                                        children: [
                                            "Start",
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                                                type: "date",
                                                value: startDateFilter,
                                                onChange: (e)=>setStartDateFilter(e.target.value),
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).dateFilterInput
                                            }, `start-date-${dateInputResetToken}`)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("label", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).dateFilterLabel,
                                        children: [
                                            "End",
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                                                type: "date",
                                                value: endDateFilter,
                                                onChange: (e)=>setEndDateFilter(e.target.value),
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).dateFilterInput
                                            }, `end-date-${dateInputResetToken}`)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                size: "sm",
                                color: "primary",
                                onClick: applyFilters,
                                children: "Apply Filters"
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                size: "sm",
                                color: "secondary",
                                onClick: resetFilters,
                                children: "Reset"
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                size: "sm",
                                color: "secondary",
                                onClick: reloadPage,
                                children: isRefreshing ? 'Refreshing...' : 'Refresh'
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                size: "sm",
                                color: "secondary",
                                onClick: exportFilteredRows,
                                disabled: !totalCount || isRefreshing || isExporting,
                                children: isExporting ? 'Exporting...' : 'Export CSV'
                            })
                        ]
                    })
                ]
            }),
            isError ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).filterInfo,
                children: "Unable to load analytics data. Try refreshing the page."
            }) : null,
            !totalCount && !rows.length ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                children: "No analytics rows have been captured yet."
            }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).tableWrapper,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).metricsGrid,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("article", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).metricCard,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).metricTitle,
                                        children: "Completion : Cancellation"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).metricRatio,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).metricPositive,
                                                children: analyticsSummary.submittedCount
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                children: " : "
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).metricNegative,
                                                children: analyticsSummary.cancelledCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).metricHint,
                                        children: "Based on all filtered rows"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("article", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).metricCard,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).metricTitle,
                                        children: "Spent Time Rate"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).metricRatio,
                                        children: analyticsSummary.spentTimeRate === null ? 'N/A' : `${analyticsSummary.spentTimeRate}%`
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).metricHint,
                                        children: "From all filtered rows with Q&A engagement data"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("section", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).usageSection,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("article", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).usageCard,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                                        children: "Quality Usage Funnel"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).funnelList,
                                        children: analyticsSummary.funnelSteps.map((step, index)=>{
                                            const previousStepCount = index === 0 ? analyticsSummary.funnelSteps[0].count : analyticsSummary.funnelSteps[index - 1].count;
                                            const conversionRate = previousStepCount > 0 ? Math.round(step.count / previousStepCount * 100) : 0;
                                            return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).funnelItem,
                                                children: [
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).funnelItemMeta,
                                                        children: [
                                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                                children: step.label
                                                            }),
                                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                                                children: [
                                                                    step.count,
                                                                    " ",
                                                                    index === 0 ? '' : `(${conversionRate}%)`
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).funnelBarTrack,
                                                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).funnelBarFill,
                                                            style: {
                                                                width: `${analyticsSummary.funnelSteps[0].count > 0 ? Math.round(step.count / analyticsSummary.funnelSteps[0].count * 100) : 0}%`
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, step.label);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("article", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).usageCard,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                                        children: "High-Quality Usage Rate Trend"
                                    }),
                                    !analyticsSummary.qualityTrendData.length ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).usageEmpty,
                                        children: "No trend data in selected filters."
                                    }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).trendList,
                                        children: analyticsSummary.qualityTrendData.map((item)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).trendItem,
                                                children: [
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).trendLabel,
                                                        children: item.label
                                                    }),
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).trendBarTrack,
                                                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).trendBarFill,
                                                            style: {
                                                                width: `${item.rate}%`
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).trendValue,
                                                        children: [
                                                            item.rate,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }, item.dayStart.toISOString()))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("article", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).usageCard,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                                        children: "Daily Usage Trend"
                                    }),
                                    !usageTrend.usageTrendData.length ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).usageEmpty,
                                        children: "No usage data in selected date range."
                                    }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartWrapper,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartHoverValue,
                                                children: [
                                                    "Usage ",
                                                    hoveredUsageMessage
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
                                                viewBox: `0 0 ${$eb727c06eea1b8de$var$USAGE_LINE_CHART_WIDTH} ${$eb727c06eea1b8de$var$USAGE_LINE_CHART_HEIGHT}`,
                                                role: "img",
                                                "aria-label": "Daily usage trend",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartSvg,
                                                children: [
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("line", {
                                                        x1: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.left,
                                                        y1: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.top + usageTrend.lineChartInnerHeight,
                                                        x2: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.left + usageTrend.lineChartInnerWidth,
                                                        y2: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.top + usageTrend.lineChartInnerHeight,
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartAxis
                                                    }),
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("line", {
                                                        x1: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.left,
                                                        y1: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.top,
                                                        x2: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.left,
                                                        y2: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.top + usageTrend.lineChartInnerHeight,
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartAxis
                                                    }),
                                                    [
                                                        ...new Set([
                                                            0,
                                                            Math.ceil(usageTrend.maxUsage / 2),
                                                            usageTrend.maxUsage
                                                        ].map((tickValue)=>tickValue))
                                                    ].map((tickValue)=>{
                                                        const y = $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.top + usageTrend.lineChartInnerHeight - tickValue / usageTrend.maxUsage * usageTrend.lineChartInnerHeight;
                                                        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("line", {
                                                                    x1: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.left,
                                                                    y1: y,
                                                                    x2: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.left + usageTrend.lineChartInnerWidth,
                                                                    y2: y,
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartGridline
                                                                }),
                                                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("text", {
                                                                    x: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.left - 8,
                                                                    y: y + 4,
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartTickLabel,
                                                                    children: tickValue
                                                                })
                                                            ]
                                                        }, `tick-${tickValue}`);
                                                    }),
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                                        d: usageTrend.usageLinePath,
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartPath
                                                    }),
                                                    usageTrend.usagePoints.map((point, index)=>{
                                                        const shouldLabel = usageTrend.usagePoints.length <= 4 || index === 0 || index === usageTrend.usagePoints.length - 1 || index % 4 === 0;
                                                        return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                                                                    cx: point.x,
                                                                    cy: point.y,
                                                                    r: "4.5",
                                                                    "aria-label": `Usage point ${point.label}: ${point.usage}`,
                                                                    className: `${(0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartPoint} ${hoveredUsagePoint?.dayKey === point.dayStart.toISOString() ? (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartPointActive : ''}`,
                                                                    tabIndex: "0",
                                                                    onMouseEnter: ()=>setHoveredUsagePoint({
                                                                            dayKey: point.dayStart.toISOString(),
                                                                            label: point.label,
                                                                            usage: point.usage
                                                                        }),
                                                                    onMouseLeave: ()=>setHoveredUsagePoint(null),
                                                                    onFocus: ()=>setHoveredUsagePoint({
                                                                            dayKey: point.dayStart.toISOString(),
                                                                            label: point.label,
                                                                            usage: point.usage
                                                                        }),
                                                                    onBlur: ()=>setHoveredUsagePoint(null),
                                                                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("title", {
                                                                        children: [
                                                                            point.label,
                                                                            ": ",
                                                                            point.usage
                                                                        ]
                                                                    })
                                                                }),
                                                                shouldLabel ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("text", {
                                                                    x: point.x,
                                                                    y: $eb727c06eea1b8de$var$USAGE_LINE_CHART_PADDING.top + usageTrend.lineChartInnerHeight + 16,
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartDateLabel,
                                                                    children: point.label
                                                                }) : null
                                                            ]
                                                        }, point.dayStart.toISOString());
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).lineChartFootnote,
                                                children: "Counts per day for rows in the selected date range."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).heuristicNote,
                        children: "* Q&A engagement is marked as Spent time when additional text is typed, when total page time reaches 75 seconds, or when answered questions span at least 20 seconds or total at least 35 seconds. It is marked as Partial when there is at least one quick response and one long pause between answers. Otherwise it is marked as Quick pass."
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).paginationSummary,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).filterInfo,
                                children: [
                                    "Showing ",
                                    showingStart,
                                    "-",
                                    showingEnd,
                                    " of ",
                                    totalCount,
                                    " filtered entries"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).paginationControls,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        color: "secondary",
                                        onClick: ()=>setCurrentPage((prev)=>Math.max(0, prev - 1)),
                                        disabled: currentPage === 0 || isRefreshing,
                                        children: "Previous"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).paginationLabel,
                                        children: [
                                            "Page ",
                                            Math.min(currentPage + 1, totalPages),
                                            " of ",
                                            totalPages
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        color: "secondary",
                                        onClick: ()=>setCurrentPage((prev)=>prev + 1 < totalPages ? prev + 1 : prev),
                                        disabled: currentPage + 1 >= totalPages || isRefreshing,
                                        children: "Next"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("table", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).table,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("th", {
                                            children: "Timestamp"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("th", {
                                            children: "Employee #"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("th", {
                                            children: "Equipment #"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("th", {
                                            children: "Site"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("th", {
                                            children: "Service Area"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("th", {
                                            children: "Service Action"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("th", {
                                            children: "Comment"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("th", {
                                            children: "Outcome"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("th", {
                                            children: "Questions & Answers"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("th", {
                                            children: "Cancellation Reason"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("tbody", {
                                children: !rows.length ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("td", {
                                        colSpan: "10",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).emptyMessage,
                                        children: "No results match the selected filter."
                                    })
                                }) : rows.map((row, index)=>{
                                    const isOutcomeRow = Boolean(row.outcome);
                                    const qaAssessment = $eb727c06eea1b8de$var$getQaEngagementAssessment(row);
                                    let outcomeLabel = "\u2014";
                                    if (isOutcomeRow) outcomeLabel = row.outcome === 'submitted' ? 'Submitted' : 'Cancelled';
                                    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("tr", {
                                        className: isOutcomeRow ? (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).outcomeRow : (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).continueRow,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("td", {
                                                children: $eb727c06eea1b8de$var$formatDateTime(row.lastEntryAt)
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("td", {
                                                children: row.empNumber || 'N/A'
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("td", {
                                                children: row.equipmentNumber || 'N/A'
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("td", {
                                                children: row.siteId || 'N/A'
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("td", {
                                                children: row.serviceArea || 'N/A'
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("td", {
                                                children: row.serviceAction || 'N/A'
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("td", {
                                                children: row.comment || 'N/A'
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("td", {
                                                children: outcomeLabel
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("td", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).qaCell,
                                                children: isOutcomeRow && Array.isArray(row.questionAnswers) && row.questionAnswers.length > 0 ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).qaActionRow,
                                                    children: [
                                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                                            size: "sm",
                                                            color: "secondary",
                                                            onClick: ()=>setSelectedQaRow(row),
                                                            children: "View"
                                                        }),
                                                        qaAssessment ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                            className: qaAssessment.toneClassName,
                                                            children: qaAssessment.label
                                                        }) : null
                                                    ]
                                                }) : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("td", {
                                                children: isOutcomeRow ? row.cancellationReason || "\u2014" : "\u2014"
                                            })
                                        ]
                                    }, row.id || `analytics-row-${row.lastEntryAt || row.empNumber || index}`);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
                open: Boolean(selectedQaRow),
                onOpenChange: (isOpen)=>!isOpen && closeQaModal(),
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                            children: "Questions & Answers"
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                            children: selectedQaRow ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).qaModalContent,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).qaModalMeta,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("strong", {
                                                        children: "Employee #:"
                                                    }),
                                                    " ",
                                                    selectedQaRow.empNumber || 'N/A'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("strong", {
                                                        children: "Equipment #:"
                                                    }),
                                                    " ",
                                                    selectedQaRow.equipmentNumber || 'N/A'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("strong", {
                                                        children: "Outcome:"
                                                    }),
                                                    " ",
                                                    modalOutcomeLabel
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("strong", {
                                                        children: "Arrived at page:"
                                                    }),
                                                    " ",
                                                    $eb727c06eea1b8de$var$formatTime(selectedQaRow.arrivedAt) || 'N/A'
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).qaList,
                                        children: selectedQaRow.questionAnswers.map((qa, index)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("section", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).qaCard,
                                                children: [
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).qaCardHeader,
                                                        children: [
                                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("h3", {
                                                                children: [
                                                                    "Question ",
                                                                    index + 1
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                                children: qa.answeredAt ? $eb727c06eea1b8de$var$formatTime(qa.answeredAt) : 'Time not captured'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b879052b31eb8b5d$exports))).qaQuestion,
                                                        children: qa.question || 'Question unavailable'
                                                    }),
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("strong", {
                                                                children: "Answer:"
                                                            }),
                                                            " ",
                                                            qa.answer || 'N/A'
                                                        ]
                                                    }),
                                                    qa.additionalDetails ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("strong", {
                                                                children: "Additional details:"
                                                            }),
                                                            " ",
                                                            qa.additionalDetails
                                                        ]
                                                    }) : null
                                                ]
                                            }, `${selectedQaRow.id}-${qa.question || 'question'}-${qa.answeredAt || index}`))
                                    })
                                ]
                            }) : null
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                size: "sm",
                                color: "secondary",
                                onClick: closeQaModal,
                                children: "Close"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $eb727c06eea1b8de$export$2e2bcd8739ae039 = $eb727c06eea1b8de$var$Analytics;




const $3d8fd0c604c29e1b$export$66b32f6f30eb4b4 = [
    {
        path: 'equip-action-portal',
        title: 'Equip Action Portal',
        icon: 'handyman',
        isPublic: false,
        element: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $6581aa26ea4c3bd5$export$2e2bcd8739ae039), {}),
        roles: [
            'ADMINISTRATOR',
            'SUPER USER',
            'USER'
        ],
        hidden: false
    },
    {
        path: 'move-order-add',
        title: 'Move Order',
        icon: 'order_approve',
        isPublic: false,
        element: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $22cf9b62ef34cea1$export$2e2bcd8739ae039), {}),
        roles: [
            'ADMINISTRATOR',
            'SUPER USER',
            'USER'
        ],
        hidden: false
    },
    {
        path: 'preferences',
        title: 'Preferences',
        icon: 'settings_heart',
        isPublic: false,
        element: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $f497bc8067bd9d95$export$2e2bcd8739ae039), {}),
        roles: [
            'ADMINISTRATOR',
            'SUPER USER',
            'USER'
        ],
        hidden: false
    },
    {
        path: 'analytics',
        title: 'Analytics',
        icon: 'query_stats',
        isPublic: false,
        element: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $eb727c06eea1b8de$export$2e2bcd8739ae039), {}),
        roles: [
            'ADMINISTRATOR',
            'SUPER USER',
            'USER'
        ],
        hidden: false
    }
];



const $7a02df305370e935$var$ANALYTICS_EMAIL_ALLOWLIST = new Set([
    'misraa1@pella.com',
    'wiltdt@pella.com',
    'jewatters@pella.com',
    'kawebb@pella.com',
    'heuerji@pella.com'
]);
/**
 * The default layout structured with a top navbar, breadcrumb navigation, and page title.
 * Also includes a global loading indicator when any react-query queries are fetching
 */ const $7a02df305370e935$var$MainLayout = ()=>{
    const [devToolsModalOpen, setDevTools] = (0, $lCzvA.useState)(false);
    const [languageSelectorOpen, setLanguageSelector] = (0, $lCzvA.useState)(false);
    const user = (0, $c5f28fecad6357c0$export$23bbbc4533528f03)();
    const toggleDevTools = ()=>setDevTools((prev)=>!prev);
    const toggleLanguageSelector = ()=>setLanguageSelector((prev)=>!prev);
    const languageOption = {
        text: 'Change Language',
        icon: 'language',
        onClick: toggleLanguageSelector
    };
    const devTools = {
        text: 'Dev Tools',
        icon: 'service_toolbox',
        onClick: toggleDevTools
    };
    const avatarOptions = [
        ...(0, $69cb03e609be8e5e$export$40edfb7eeb78c4e8) ? [
            devTools
        ] : [],
        languageOption
    ];
    let roleValues = [];
    if (Array.isArray(user?.roles)) roleValues = user.roles;
    else if (typeof user?.roles === 'string') roleValues = [
        user.roles
    ];
    const isAdmin = roleValues.some((role)=>String(role).toUpperCase() === 'ADMINISTRATOR');
    const userEmail = String(user?.email || '').toLowerCase();
    const hasAnalyticsAccess = isAdmin || $7a02df305370e935$var$ANALYTICS_EMAIL_ALLOWLIST.has(userEmail);
    const routesForUser = (0, $3d8fd0c604c29e1b$export$66b32f6f30eb4b4).filter((route)=>route.path === 'analytics' ? hasAnalyticsAccess : true);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c5f28fecad6357c0$export$c84671f46d6a1ca), {
                hideBreadcrumbs: false,
                appName: (0, $69cb03e609be8e5e$export$a002182e51710d39).AppName,
                routes: routesForUser,
                avatarOptions: avatarOptions
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $53545f34f1933400$export$2e2bcd8739ae039), {
                isOpen: devToolsModalOpen,
                onClose: toggleDevTools
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $5fcdb208aa598d82$export$2e2bcd8739ae039), {
                isOpen: languageSelectorOpen,
                onClose: toggleLanguageSelector
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $88478e1cba2f5c35$export$2e2bcd8739ae039), {})
        ]
    });
};
var $7a02df305370e935$export$2e2bcd8739ae039 = $7a02df305370e935$var$MainLayout;














var $3abeb720825c68d9$exports = {};
!function(t, e) {
    e($3abeb720825c68d9$exports);
}($3abeb720825c68d9$exports, function(t) {
    "use strict";
    var e = {
        getItemSync: function(t) {
            try {
                return localStorage.getItem(t) || null;
            } catch (t) {
                return null;
            }
        },
        getItem: function(t, e) {
            var n = this;
            return new Promise(function(i, a) {
                try {
                    var o = n.getItemSync(t);
                    null == e || e(null, o), i(o);
                } catch (t) {
                    e && e(t, null), a(t);
                }
            });
        },
        setItem: function(t, e, n) {
            return new Promise(function(i, a) {
                try {
                    localStorage.setItem(t, e), n && n(null, e), i(e);
                } catch (t) {
                    n && n(t, null), a(t);
                }
            });
        }
    }, n = function() {
        return n = Object.assign || function(t) {
            for(var e, n = 1, i = arguments.length; n < i; n++)for(var a in e = arguments[n])Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
            return t;
        }, n.apply(this, arguments);
    };
    function i(t, e, n, i) {
        return new (n || (n = Promise))(function(a, o) {
            function r(t) {
                try {
                    l(i.next(t));
                } catch (t) {
                    o(t);
                }
            }
            function s(t) {
                try {
                    l(i.throw(t));
                } catch (t) {
                    o(t);
                }
            }
            function l(t) {
                var e;
                t.done ? a(t.value) : (e = t.value, e instanceof n ? e : new n(function(t) {
                    t(e);
                })).then(r, s);
            }
            l((i = i.apply(t, e || [])).next());
        });
    }
    function a(t, e) {
        var n, i, a, o, r = {
            label: 0,
            sent: function() {
                if (1 & a[0]) throw a[1];
                return a[1];
            },
            trys: [],
            ops: []
        };
        return o = {
            next: s(0),
            throw: s(1),
            return: s(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
            return this;
        }), o;
        function s(o) {
            return function(s) {
                return function(o) {
                    if (n) throw new TypeError("Generator is already executing.");
                    for(; r;)try {
                        if (n = 1, i && (a = 2 & o[0] ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
                        switch(i = 0, a && (o = [
                            2 & o[0],
                            a.value
                        ]), o[0]){
                            case 0:
                            case 1:
                                a = o;
                                break;
                            case 4:
                                return r.label++, {
                                    value: o[1],
                                    done: !1
                                };
                            case 5:
                                r.label++, i = o[1], o = [
                                    0
                                ];
                                continue;
                            case 7:
                                o = r.ops.pop(), r.trys.pop();
                                continue;
                            default:
                                if (!(a = r.trys, (a = a.length > 0 && a[a.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                    r = 0;
                                    continue;
                                }
                                if (3 === o[0] && (!a || o[1] > a[0] && o[1] < a[3])) {
                                    r.label = o[1];
                                    break;
                                }
                                if (6 === o[0] && r.label < a[1]) {
                                    r.label = a[1], a = o;
                                    break;
                                }
                                if (a && r.label < a[2]) {
                                    r.label = a[2], r.ops.push(o);
                                    break;
                                }
                                a[2] && r.ops.pop(), r.trys.pop();
                                continue;
                        }
                        o = e.call(t, r);
                    } catch (t) {
                        o = [
                            6,
                            t
                        ], i = 0;
                    } finally{
                        n = a = 0;
                    }
                    if (5 & o[0]) throw o[1];
                    return {
                        value: o[0] ? o[1] : void 0,
                        done: !0
                    };
                }([
                    o,
                    s
                ]);
            };
        }
    }
    function o(t, e, n) {
        if (n || 2 === arguments.length) for(var i, a = 0, o = e.length; a < o; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
        return t.concat(i || Array.prototype.slice.call(e));
    }
    var r = function t(e, n) {
        if (e === n) return !0;
        if (e && n && "object" == typeof e && "object" == typeof n) {
            if (e.constructor !== n.constructor) return !1;
            var i, a, o;
            if (Array.isArray(e)) {
                if ((i = e.length) != n.length) return !1;
                for(a = i; 0 != a--;)if (!t(e[a], n[a])) return !1;
                return !0;
            }
            if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
            if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
            if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
            if ((i = (o = Object.keys(e)).length) !== Object.keys(n).length) return !1;
            for(a = i; 0 != a--;)if (!Object.prototype.hasOwnProperty.call(n, o[a])) return !1;
            for(a = i; 0 != a--;){
                var r = o[a];
                if (!t(e[r], n[r])) return !1;
            }
            return !0;
        }
        return e != e && n != n;
    };
    function s(t, e) {
        var n = Object.keys(e || {}).filter(function(n) {
            var i = null == t ? void 0 : t[n], a = null == e ? void 0 : e[n];
            return !r(i, a);
        });
        return Object.keys(t || {}).filter(function(t) {
            Object.keys(e || {}).includes(t) || n.push(t);
        }), Object.keys(n).length ? n : null;
    }
    function l(t, e, n) {
        var i = "shortString", a = !0;
        "number" == typeof n && (i = "javaDouble", a = !1), t[i] = t[i] || {}, t[i][e] = a ? n + "" : n;
    }
    function u(t) {
        return !!t && "object" == typeof t && void 0 !== t.value;
    }
    function c(t) {
        return Object.fromEntries(Object.entries(t).map(function(t) {
            var e = t[0], n = t[1];
            return [
                e,
                u(n) ? n : {
                    value: n
                }
            ];
        }));
    }
    function d(t) {
        return n(n({}, t), {
            identity: t.identity ? n(n({}, t.identity), {
                traits: c(t.identity.traits || {})
            }) : void 0
        });
    }
    var h, v;
    t.FlagSource = void 0, (h = t.FlagSource || (t.FlagSource = {})).NONE = "NONE", h.DEFAULT_FLAGS = "DEFAULT_FLAGS", h.CACHE = "CACHE", h.SERVER = "SERVER";
    var g, f = null, p = "FLAGSMITH_EVENT", y = p, m = "https://edge.api.flagsmith.com/api/v1/", S = "flagsmith_value_", C = "flagsmith_enabled_", _ = "flagsmith_trait_", b = function() {
        function e(e) {
            var i = this;
            this._trigger = null, this._triggerLoadingState = null, this.timestamp = null, this.isLoading = !1, this.eventSource = null, this.getFlags = function() {
                var e = i, a = e.api, o = e.evaluationContext;
                i.log("Get Flags"), i.isLoading = !0, i.loadingState.isFetching || i.setLoadingState(n(n({}, i.loadingState), {
                    isFetching: !0
                }));
                var r = "".concat(i.getContext().identity), u = function(e) {
                    var a, o, u, c;
                    if (e && r === "".concat(i.getContext().identity)) {
                        var d = e.flags, h = e.traits, v = e.identifier;
                        i.isLoading = !1;
                        var g = {}, f = {};
                        h = h || [], (d = d || []).forEach(function(t) {
                            g[t.feature.name.toLowerCase().replace(/ /g, "_")] = {
                                id: t.feature.id,
                                enabled: t.enabled,
                                value: t.feature_state_value
                            };
                        }), h.forEach(function(t) {
                            f[t.trait_key.toLowerCase().replace(/ /g, "_")] = {
                                transient: t.transient,
                                value: t.trait_value
                            };
                        }), i.oldFlags = n({}, i.flags);
                        var p = s(i.oldFlags, g), y = s(null === (a = i.evaluationContext.identity) || void 0 === a ? void 0 : a.traits, f);
                        if ((v || Object.keys(f).length) && (i.evaluationContext.identity = n(n({}, i.evaluationContext.identity), {
                            traits: f
                        }), v && (i.evaluationContext.identity.identifier = v, i.identity = v)), i.flags = g, i.updateStorage(), i._onChange(i.oldFlags, {
                            isFromServer: !0,
                            flagsChanged: p,
                            traitsChanged: y
                        }, i._loadedState(null, t.FlagSource.SERVER)), i.datadogRum) try {
                            if (i.datadogRum.trackTraits) {
                                var m = {};
                                Object.keys((null === (o = i.evaluationContext.identity) || void 0 === o ? void 0 : o.traits) || {}).map(function(t) {
                                    m[_ + t] = i.getTrait(t);
                                });
                                var b = n(n(n({}, i.datadogRum.client.getUser()), {
                                    id: i.datadogRum.client.getUser().id || (null === (u = i.evaluationContext.identity) || void 0 === u ? void 0 : u.identifier)
                                }), m);
                                i.log("Setting Datadog user", b), i.datadogRum.client.setUser(b);
                            }
                        } catch (t) {
                            console.error(t);
                        }
                        if (i.dtrum) try {
                            var E = {
                                javaDouble: {},
                                date: {},
                                shortString: {},
                                javaLongOrObject: {}
                            };
                            Object.keys(i.flags).map(function(t) {
                                l(E, S + t, i.getValue(t, {
                                    skipAnalytics: !0
                                })), l(E, C + t, i.hasFeature(t, {
                                    skipAnalytics: !0
                                }));
                            }), Object.keys((null === (c = i.evaluationContext.identity) || void 0 === c ? void 0 : c.traits) || {}).map(function(t) {
                                l(E, _ + t, i.getTrait(t));
                            }), i.log("Sending javaLongOrObject traits to dynatrace", E.javaLongOrObject), i.log("Sending date traits to dynatrace", E.date), i.log("Sending shortString traits to dynatrace", E.shortString), i.log("Sending javaDouble to dynatrace", E.javaDouble), i.dtrum.sendSessionProperties(E.javaLongOrObject, E.date, E.shortString, E.javaDouble);
                        } catch (t) {
                            console.error(t);
                        }
                    }
                };
                return o.identity ? Promise.all([
                    o.identity.traits && Object.keys(o.identity.traits).length || !o.identity.identifier ? i.getJSON(a + "identities/", "POST", JSON.stringify({
                        identifier: o.identity.identifier,
                        transient: o.identity.transient,
                        traits: Object.entries(o.identity.traits).map(function(t) {
                            var e = t[0], n = t[1];
                            return {
                                trait_key: e,
                                trait_value: null == n ? void 0 : n.value,
                                transient: null == n ? void 0 : n.transient
                            };
                        }).filter(function(t) {
                            return void 0 !== t.trait_value || (i.log("Warning - attempted to set an undefined trait value for key", t.trait_key), !1);
                        })
                    })) : i.getJSON(a + "identities/?identifier=" + encodeURIComponent(o.identity.identifier) + (o.identity.transient ? "&transient=true" : ""))
                ]).then(function(t) {
                    return i.evaluationContext.identity = n(n({}, i.evaluationContext.identity), {
                        traits: {}
                    }), u(null == t ? void 0 : t[0]);
                }).catch(function(t) {
                    var e = t.message, n = new Error(e);
                    return Promise.reject(n);
                }) : i.getJSON(a + "flags/").then(function(t) {
                    return u({
                        flags: t,
                        traits: void 0
                    });
                });
            }, this.analyticsFlags = function() {
                var t = i.api;
                if (i.evaluationEvent && i.evaluationContext.environment && i.evaluationEvent[i.evaluationContext.environment.apiKey]) return i.evaluationEvent && 0 !== Object.getOwnPropertyNames(i.evaluationEvent).length && 0 !== Object.getOwnPropertyNames(i.evaluationEvent[i.evaluationContext.environment.apiKey]).length ? i.getJSON(t + "analytics/flags/", "POST", JSON.stringify(i.evaluationEvent[i.evaluationContext.environment.apiKey])).then(function(t) {
                    if (i.evaluationContext.environment) {
                        var e = i.getState();
                        i.evaluationEvent || (i.evaluationEvent = {}), i.evaluationEvent[i.evaluationContext.environment.apiKey] = {}, i.setState(n(n({}, e), {
                            evaluationEvent: i.evaluationEvent
                        })), i.updateEventStorage();
                    }
                }).catch(function(t) {
                    i.log("Exception fetching evaluationEvent", t);
                }) : void 0;
            }, this.datadogRum = null, this.loadingState = {
                isLoading: !0,
                isFetching: !0,
                error: null,
                source: t.FlagSource.NONE
            }, this.canUseStorage = !1, this.analyticsInterval = null, this.api = null, this.cacheFlags = !1, this.enableAnalytics = !1, this.enableLogs = !1, this.evaluationContext = {}, this.evaluationEvent = null, this.flags = null, this.getFlagInterval = null, this.headers = null, this.identity = null, this.initialised = !1, this.oldFlags = null, this.onChange = null, this.onError = null, this.ticks = null, this.timer = null, this.dtrum = null, this.sentryClient = null, this.withTraits = null, this.cacheOptions = {
                ttl: 0,
                skipAPI: !1,
                loadStale: !1,
                storageKey: void 0
            }, this.getValue = function(t, e, n) {
                var a = i.flags && i.flags[t.toLowerCase().replace(/ /g, "_")], o = null;
                if (a && (o = a.value), (null == e ? void 0 : e.skipAnalytics) || n || i.evaluateFlag(t, "VALUE"), null === o && void 0 !== (null == e ? void 0 : e.fallback)) return e.fallback;
                if (null == e ? void 0 : e.json) try {
                    return null === o ? (i.log("Tried to parse null flag as JSON: " + t), null) : JSON.parse(o);
                } catch (t) {
                    return e.fallback;
                }
                return o;
            }, this.getTrait = function(t) {
                var e, n;
                return (null === (e = i.evaluationContext.identity) || void 0 === e ? void 0 : e.traits) && (null === (n = i.evaluationContext.identity.traits[t.toLowerCase().replace(/ /g, "_")]) || void 0 === n ? void 0 : n.value);
            }, this.getAllTraits = function() {
                var t;
                return Object.fromEntries(Object.entries((null === (t = i.evaluationContext.identity) || void 0 === t ? void 0 : t.traits) || {}).map(function(t) {
                    var e = t[0], n = t[1];
                    return [
                        e,
                        null == n ? void 0 : n.value
                    ];
                }));
            }, this.setContext = function(t) {
                var e, a, o = d(t);
                return i.evaluationContext = n(n({}, o), {
                    environment: o.environment || i.evaluationContext.environment
                }), i.identity = null === (a = null === (e = i.getContext()) || void 0 === e ? void 0 : e.identity) || void 0 === a ? void 0 : a.identifier, i.initialised ? i.getFlags() : Promise.resolve();
            }, this.getContext = function() {
                return i.evaluationContext;
            }, this.updateContext = function(t) {
                return i.setContext(n(n({}, i.getContext()), t));
            }, this.setTrait = function(t, e) {
                var a;
                if (i.api) return i.setContext(n(n({}, i.evaluationContext), {
                    identity: n(n({}, i.evaluationContext.identity), {
                        traits: n(n({}, null === (a = i.evaluationContext.identity) || void 0 === a ? void 0 : a.traits), c(Object.fromEntries([
                            [
                                t,
                                e
                            ]
                        ])))
                    })
                }));
            }, this.setTraits = function(t) {
                var e;
                if (i.api) return i.setContext(n(n({}, i.evaluationContext), {
                    identity: n(n({}, i.evaluationContext.identity), {
                        traits: n(n({}, null === (e = i.evaluationContext.identity) || void 0 === e ? void 0 : e.traits), Object.fromEntries(Object.entries(t).map(function(t) {
                            var e = t[0], n = t[1];
                            return [
                                e,
                                u(n) ? n : {
                                    value: n
                                }
                            ];
                        })))
                    })
                }));
                console.error("Attempted to setTraits a user before calling flagsmith.init. Call flagsmith.init first, if you wish to prevent it sending a request for flags, call init with preventFetch:true.");
            }, this.hasFeature = function(t, e) {
                var n, a, o = "object" == typeof e, r = i.flags && i.flags[t.toLowerCase().replace(/ /g, "_")], s = !1;
                if (!r && o && void 0 !== e.fallback ? s = null == e ? void 0 : e.fallback : r && r.enabled && (s = !0), (o && !e.skipAnalytics || !e) && i.evaluateFlag(t, "ENABLED"), i.sentryClient) try {
                    null === (a = null === (n = i.sentryClient.getIntegrationByName("FeatureFlags")) || void 0 === n ? void 0 : n.addFeatureFlag) || void 0 === a || a.call(n, t, s);
                } catch (t) {
                    console.error(t);
                }
                return s;
            }, this.getStorageKey = function() {
                var t, e;
                return (null === (t = i.cacheOptions) || void 0 === t ? void 0 : t.storageKey) || "FLAGSMITH_DB_" + (null === (e = i.evaluationContext.environment) || void 0 === e ? void 0 : e.apiKey);
            }, this.getJSON = function(t, e, n) {
                var a, o, r, s = i.headers, l = {
                    method: e || "GET",
                    body: n,
                    cache: "no-cache",
                    headers: {}
                };
                i.evaluationContext.environment && (l.headers["X-Environment-Key"] = i.evaluationContext.environment.apiKey), e && "GET" !== e && (l.headers["Content-Type"] = "application/json; charset=utf-8"), (null === (a = i.applicationMetadata) || void 0 === a ? void 0 : a.name) && (l.headers["Flagsmith-Application-Name"] = i.applicationMetadata.name), (null === (o = i.applicationMetadata) || void 0 === o ? void 0 : o.version) && (l.headers["Flagsmith-Application-Version"] = i.applicationMetadata.version), l.headers["Flagsmith-SDK-User-Agent"] = "flagsmith-js-sdk/".concat("10.0.0"), s && Object.assign(l.headers, s), v || console.error("Flagsmith: fetch is undefined, please specify a fetch implementation into flagsmith.init to support SSR.");
                var u = "".concat(null === (r = i.evaluationContext.identity) || void 0 === r ? void 0 : r.identifier);
                return v(t, l).then(function(n) {
                    var a, o, r = "".concat(null === (a = i.evaluationContext.identity) || void 0 === a ? void 0 : a.identifier);
                    if (u === r) {
                        var s = null === (o = n.headers) || void 0 === o ? void 0 : o.get("x-flagsmith-document-updated-at");
                        if (s) try {
                            var l = parseFloat(s);
                            if (isNaN(l)) return Promise.reject("Failed to parse x-flagsmith-document-updated-at");
                            i.timestamp = l;
                        } catch (t) {
                            i.log(t, "Failed to parse x-flagsmith-document-updated-at", s);
                        }
                        return i.log("Fetch response: " + n.status + " " + (e || "GET") + 0 + t), n.text().then(function(t) {
                            var e = t;
                            try {
                                e = JSON.parse(t);
                            } catch (t) {}
                            return !e && n.status && (e = "API Response: ".concat(n.status)), n.status && n.status >= 200 && n.status < 300 ? e : Promise.reject(new Error(e));
                        });
                    }
                    i.log("Received response with identity mismatch, ignoring response. Requested: ".concat(u, ", Current: ").concat(r));
                });
            }, this.evaluateFlag = function(t, e) {
                if (i.datadogRum && (i.datadogRum.client.addFeatureFlagEvaluation ? "VALUE" === e ? i.datadogRum.client.addFeatureFlagEvaluation(S + t, i.getValue(t, {}, !0)) : i.datadogRum.client.addFeatureFlagEvaluation(C + t, i.hasFeature(t, !0)) : console.error("Flagsmith: Your datadog RUM client does not support the function addFeatureFlagEvaluation, please update it.")), i.enableAnalytics) {
                    if (!i.evaluationEvent || !i.evaluationContext.environment) return;
                    i.evaluationEvent[i.evaluationContext.environment.apiKey] || (i.evaluationEvent[i.evaluationContext.environment.apiKey] = {}), void 0 === i.evaluationEvent[i.evaluationContext.environment.apiKey][t] && (i.evaluationEvent[i.evaluationContext.environment.apiKey][t] = 0), i.evaluationEvent[i.evaluationContext.environment.apiKey][t] += 1;
                }
                i.updateEventStorage();
            }, this._onChange = function(t, e, n) {
                var a, o;
                i.setLoadingState(n), null === (a = i.onChange) || void 0 === a || a.call(i, t, e, i.loadingState), null === (o = i._trigger) || void 0 === o || o.call(i);
            }, v = e.fetch ? e.fetch : "undefined" != typeof fetch ? fetch : null === $parcel$global || void 0 === $parcel$global ? void 0 : $parcel$global.fetch, this.canUseStorage = "undefined" != typeof window || !!e.browserlessStorage, this.applicationMetadata = e.applicationMetadata, this.log("Constructing flagsmith instance " + e), e.eventSource && (g = e.eventSource), e.AsyncStorage && (f = e.AsyncStorage);
        }
        return e.prototype.init = function(e) {
            var o, r, l, u;
            return i(this, void 0, void 0, function() {
                var c, h, g, p, S, C, _, b, E, x, O, F, w, I, j, L, A, k, T, N, P, R, K, D, U, G, J, M, H, V, q, B, W, X, Y, $ = this;
                return a(this, function(z) {
                    switch(z.label){
                        case 0:
                            c = d(e.evaluationContext || this.evaluationContext), z.label = 1;
                        case 1:
                            if (z.trys.push([
                                1,
                                13,
                                ,
                                14
                            ]), h = e.AsyncStorage, g = e._trigger, p = e._triggerLoadingState, S = e.angularHttpClient, C = e.api, _ = void 0 === C ? m : C, b = e.applicationMetadata, E = e.cacheFlags, x = e.cacheOptions, O = e.datadogRum, F = e.defaultFlags, w = e.enableAnalytics, I = e.enableDynatrace, j = e.enableLogs, L = e.environmentID, A = e.eventSourceUrl, k = void 0 === A ? "https://realtime.flagsmith.com/" : A, T = e.fetch, N = e.headers, P = e.identity, R = e.onChange, K = e.onError, D = e.preventFetch, U = e.realtime, G = e.sentryClient, J = e.state, M = e.traits, c.environment = L ? {
                                apiKey: L
                            } : c.environment, !c.environment || !c.environment.apiKey) throw new Error("Please provide `evaluationContext.environment` with non-empty `apiKey`");
                            if (c.identity = P || M ? {
                                identifier: P,
                                traits: M ? Object.fromEntries(Object.entries(M).map(function(t) {
                                    return [
                                        t[0],
                                        {
                                            value: t[1]
                                        }
                                    ];
                                })) : {}
                            } : c.identity, this.evaluationContext = c, this.api = (Q = _).endsWith("/") ? Q : Q + "/", this.headers = N, this.getFlagInterval = null, this.analyticsInterval = null, this.onChange = R, H = "Wrong Flagsmith Configuration: preventFetch is true and no defaulFlags provided", this._trigger = g || this._trigger, this._triggerLoadingState = p || this._triggerLoadingState, this.onError = function(t) {
                                $.setLoadingState(n(n({}, $.loadingState), {
                                    isFetching: !1,
                                    isLoading: !1,
                                    error: t
                                })), null == K || K(t);
                            }, this.enableLogs = j || !1, this.cacheOptions = x ? {
                                skipAPI: !!x.skipAPI,
                                ttl: x.ttl || 0,
                                storageKey: x.storageKey,
                                loadStale: !!x.loadStale
                            } : this.cacheOptions, !this.cacheOptions.ttl && this.cacheOptions.skipAPI && console.warn("Flagsmith: you have set a cache ttl of 0 and are skipping API calls, this means the API will not be hit unless you clear local storage."), T && (v = T), this.enableAnalytics = w || !1, this.flags = Object.assign({}, F) || {}, this.datadogRum = O || null, this.initialised = !0, this.ticks = 1e4, this.timer = this.enableLogs ? (new Date).valueOf() : null, this.cacheFlags = void 0 !== f && !!E, this.applicationMetadata = b, y = "FLAGSMITH_EVENT_" + c.environment.apiKey, h && (f = h), U && "undefined" != typeof window && this.setupRealtime(k, c.environment.apiKey), Object.keys(this.flags).length && (this.loadingState = n(n({}, this.loadingState), {
                                isLoading: !1,
                                source: t.FlagSource.DEFAULT_FLAGS
                            })), this.setState(J), this.log("Initialising with properties", e, this), I && ("undefined" == typeof dtrum ? console.error("You have attempted to enable dynatrace but dtrum is undefined, please check you have the Dynatrace RUM JavaScript API installed.") : this.dtrum = dtrum), G && (this.sentryClient = G), S && (v = function(t) {
                                return function(e, n) {
                                    var i = n.headers, a = n.method, o = n.body, r = {
                                        headers: i,
                                        observe: "response",
                                        responseType: "text"
                                    }, s = function(t, e) {
                                        var n = t.status, i = t.headers, a = t.body, o = t.error, r = t.message;
                                        return {
                                            status: null != n ? n : e ? 200 : 500,
                                            ok: e,
                                            headers: {
                                                get: function(t) {
                                                    var e, n;
                                                    return null !== (n = null === (e = null == i ? void 0 : i.get) || void 0 === e ? void 0 : e.call(i, t)) && void 0 !== n ? n : null;
                                                }
                                            },
                                            text: function() {
                                                var t, e, n = null !== (e = null !== (t = null != a ? a : o) && void 0 !== t ? t : r) && void 0 !== e ? e : "";
                                                return Promise.resolve("string" != typeof n ? JSON.stringify(n) : n);
                                            }
                                        };
                                    };
                                    return new Promise(function(n) {
                                        var i = function(t) {
                                            return n(s(t, !t.status || t.status >= 200 && t.status < 300));
                                        }, l = function(t) {
                                            return n(s(t, !1));
                                        };
                                        switch(a){
                                            case "GET":
                                                return t.get(e, r).subscribe(i, l);
                                            case "POST":
                                            case "PUT":
                                                return t.post(e, null != o ? o : "", r).subscribe(i, l);
                                            default:
                                                return l({
                                                    status: 405,
                                                    message: "Unsupported method: ".concat(a)
                                                });
                                        }
                                    });
                                };
                            }(S)), f && this.canUseStorage && f.getItem(y).then(function(t) {
                                try {
                                    $.evaluationEvent = JSON.parse(t) || {};
                                } catch (t) {
                                    $.evaluationEvent = {};
                                }
                                $.analyticsInterval = setInterval($.analyticsFlags, $.ticks);
                            }), this.enableAnalytics && (this.analyticsInterval && clearInterval(this.analyticsInterval), f && this.canUseStorage && f.getItem(y, function(t, e) {
                                if (e && $.evaluationContext.environment) {
                                    var i = JSON.parse(e);
                                    if (i[$.evaluationContext.environment.apiKey]) {
                                        var a = $.getState();
                                        $.log("Retrieved events from cache", e), $.setState(n(n({}, a), {
                                            evaluationEvent: i[$.evaluationContext.environment.apiKey]
                                        }));
                                    }
                                }
                            })), !E) return [
                                3,
                                9
                            ];
                            if (!f || !this.canUseStorage) return [
                                3,
                                8
                            ];
                            V = function(e, o) {
                                return i($, void 0, void 0, function() {
                                    var e, i, r, l, u, c, h, v, g, f, p, y, m, S, C, _, b, E, x, O = this;
                                    return a(this, function(a) {
                                        switch(a.label){
                                            case 0:
                                                if (!o) return [
                                                    3,
                                                    7
                                                ];
                                                e = null, i = null, a.label = 1;
                                            case 1:
                                                return a.trys.push([
                                                    1,
                                                    5,
                                                    ,
                                                    6
                                                ]), r = JSON.parse(o), l = !1, u = !1, r && r.api === this.api && (null === (f = null === (g = r.evaluationContext) || void 0 === g ? void 0 : g.environment) || void 0 === f ? void 0 : f.apiKey) === (null === (p = this.evaluationContext.environment) || void 0 === p ? void 0 : p.apiKey) && (c = !0, this.evaluationContext.identity && (null === (m = null === (y = r.evaluationContext) || void 0 === y ? void 0 : y.identity) || void 0 === m ? void 0 : m.identifier) !== this.evaluationContext.identity.identifier && (this.log("Ignoring cache, identity has changed from " + (null === (C = null === (S = r.evaluationContext) || void 0 === S ? void 0 : S.identity) || void 0 === C ? void 0 : C.identifier) + " to " + this.evaluationContext.identity.identifier), c = !1), this.cacheOptions.ttl && (!r.ts || (new Date).valueOf() - r.ts > this.cacheOptions.ttl) && (r.ts && !this.cacheOptions.loadStale ? (this.log("Ignoring cache, timestamp is too old ts:" + r.ts + " ttl: " + this.cacheOptions.ttl + " time elapsed since cache: " + ((new Date).valueOf() - r.ts) + "ms"), c = !1) : r.ts && this.cacheOptions.loadStale && (this.log("Loading stale cache, timestamp ts:" + r.ts + " ttl: " + this.cacheOptions.ttl + " time elapsed since cache: " + ((new Date).valueOf() - r.ts) + "ms"), u = !0, c = !0)), c && (l = !0, e = s(this.flags, r.flags), this.setState(n(n({}, r), {
                                                    evaluationContext: d(n(n({}, r.evaluationContext), {
                                                        identity: (null === (_ = r.evaluationContext) || void 0 === _ ? void 0 : _.identity) ? n(n({}, null === (b = r.evaluationContext) || void 0 === b ? void 0 : b.identity), {
                                                            traits: n({}, M || {})
                                                        }) : void 0
                                                    }))
                                                })), this.log("Retrieved flags from cache", r))), l ? (h = !D && (!this.cacheOptions.skipAPI || u), this._onChange(null, {
                                                    isFromServer: !1,
                                                    flagsChanged: e,
                                                    traitsChanged: i
                                                }, this._loadedState(null, t.FlagSource.CACHE, h)), this.oldFlags = this.flags, this.cacheOptions.skipAPI && l && !u && this.log("Skipping API, using cache"), h && this.getFlags().catch(function(t) {
                                                    var e;
                                                    null === (e = O.onError) || void 0 === e || e.call(O, t);
                                                }), [
                                                    3,
                                                    4
                                                ]) : [
                                                    3,
                                                    2
                                                ];
                                            case 2:
                                                return D ? [
                                                    3,
                                                    4
                                                ] : [
                                                    4,
                                                    this.getFlags()
                                                ];
                                            case 3:
                                                a.sent(), a.label = 4;
                                            case 4:
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 5:
                                                throw v = a.sent(), this.log("Exception fetching cached logs", v), v;
                                            case 6:
                                                return [
                                                    3,
                                                    10
                                                ];
                                            case 7:
                                                return D ? [
                                                    3,
                                                    9
                                                ] : [
                                                    4,
                                                    this.getFlags()
                                                ];
                                            case 8:
                                                return a.sent(), [
                                                    3,
                                                    10
                                                ];
                                            case 9:
                                                if (F) this._onChange(null, {
                                                    isFromServer: !1,
                                                    flagsChanged: s({}, this.flags),
                                                    traitsChanged: s({}, null === (E = this.evaluationContext.identity) || void 0 === E ? void 0 : E.traits)
                                                }, this._loadedState(null, t.FlagSource.DEFAULT_FLAGS));
                                                else {
                                                    if (!this.flags) throw new Error(H);
                                                    this._onChange(null, {
                                                        isFromServer: !1,
                                                        flagsChanged: s({}, this.flags),
                                                        traitsChanged: s({}, null === (x = this.evaluationContext.identity) || void 0 === x ? void 0 : x.traits)
                                                    }, this._loadedState(null, t.FlagSource.DEFAULT_FLAGS));
                                                }
                                                a.label = 10;
                                            case 10:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, z.label = 2;
                        case 2:
                            return z.trys.push([
                                2,
                                7,
                                ,
                                8
                            ]), f.getItemSync ? (q = f.getItemSync(this.getStorageKey()), [
                                3,
                                5
                            ]) : [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                4,
                                f.getItem(this.getStorageKey())
                            ];
                        case 4:
                            q = z.sent(), z.label = 5;
                        case 5:
                            return [
                                4,
                                V(null, q)
                            ];
                        case 6:
                            return z.sent(), [
                                3,
                                8
                            ];
                        case 7:
                            if (B = z.sent(), !this.flags || 0 === Object.keys(this.flags).length) throw B;
                            return Y = B instanceof Error ? B : new Error("".concat(B)), null === (o = this.onError) || void 0 === o || o.call(this, Y), [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                3,
                                12
                            ];
                        case 9:
                            return D ? [
                                3,
                                11
                            ] : [
                                4,
                                this.getFlags()
                            ];
                        case 10:
                            return z.sent(), [
                                3,
                                12
                            ];
                        case 11:
                            if (F) this._onChange(null, {
                                isFromServer: !1,
                                flagsChanged: s({}, F),
                                traitsChanged: s({}, null === (r = c.identity) || void 0 === r ? void 0 : r.traits)
                            }, this._loadedState(null, t.FlagSource.DEFAULT_FLAGS));
                            else if (this.flags && (W = null, 0 === Object.keys(this.flags).length && (W = H), this._onChange(null, {
                                isFromServer: !1,
                                flagsChanged: s({}, this.flags),
                                traitsChanged: s({}, null === (l = c.identity) || void 0 === l ? void 0 : l.traits)
                            }, this._loadedState(W, t.FlagSource.DEFAULT_FLAGS)), W)) throw new Error(W);
                            z.label = 12;
                        case 12:
                            return [
                                3,
                                14
                            ];
                        case 13:
                            throw X = z.sent(), this.log("Error during initialisation ", X), Y = X instanceof Error ? X : new Error("".concat(X)), null === (u = this.onError) || void 0 === u || u.call(this, Y), X;
                        case 14:
                            return [
                                2
                            ];
                    }
                    var Q;
                });
            });
        }, e.prototype.getAllFlags = function() {
            return this.flags;
        }, e.prototype.identify = function(t, e, n) {
            return this.identity = t, this.evaluationContext.identity = {
                identifier: t,
                transient: n,
                traits: this.evaluationContext.identity && this.evaluationContext.identity.identifier == t ? this.evaluationContext.identity.traits : {}
            }, this.evaluationContext.identity.identifier = t, this.log("Identify: " + this.evaluationContext.identity.identifier), e && (this.evaluationContext.identity.traits = Object.fromEntries(Object.entries(e).map(function(t) {
                var e = t[0], n = t[1];
                return [
                    e,
                    u(n) ? n : {
                        value: n
                    }
                ];
            }))), this.initialised ? this.getFlags() : Promise.resolve();
        }, e.prototype.getState = function() {
            return {
                api: this.api,
                flags: this.flags,
                ts: this.ts,
                evaluationContext: this.evaluationContext,
                identity: this.identity,
                evaluationEvent: this.evaluationEvent
            };
        }, e.prototype.setState = function(t) {
            var e, n;
            t && (this.initialised = !0, this.api = t.api || this.api || m, this.flags = t.flags || this.flags, this.evaluationContext = t.evaluationContext || this.evaluationContext, this.evaluationEvent = t.evaluationEvent || this.evaluationEvent, this.identity = null === (n = null === (e = this.getContext()) || void 0 === e ? void 0 : e.identity) || void 0 === n ? void 0 : n.identifier, this.log("setState called", this));
        }, e.prototype.logout = function() {
            return this.identity = null, this.evaluationContext.identity = null, this.initialised ? this.getFlags() : Promise.resolve();
        }, e.prototype.startListening = function(t) {
            void 0 === t && (t = 1e3), this.getFlagInterval && clearInterval(this.getFlagInterval), this.getFlagInterval = setInterval(this.getFlags, t);
        }, e.prototype.stopListening = function() {
            this.getFlagInterval && (clearInterval(this.getFlagInterval), this.getFlagInterval = null);
        }, e.prototype._loadedState = function(t, e, n) {
            return void 0 === t && (t = null), void 0 === n && (n = !1), {
                error: t,
                isFetching: n,
                isLoading: !1,
                source: e
            };
        }, e.prototype.log = function() {
            for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
            this.enableLogs && console.log.apply(this, o([
                "FLAGSMITH:",
                (new Date).valueOf() - (this.timer || 0),
                "ms"
            ], t, !0));
        }, e.prototype.updateStorage = function() {
            if (this.cacheFlags) {
                this.ts = (new Date).valueOf();
                var t = JSON.stringify(this.getState());
                this.log("Setting storage", t), f.setItem(this.getStorageKey(), t);
            }
        }, e.prototype.updateEventStorage = function() {
            if (this.enableAnalytics) {
                var t = JSON.stringify(this.getState().evaluationEvent);
                f.setItem(y, t).catch(function(t) {
                    return console.error("Flagsmith: Error setting item in async storage", t);
                });
            }
        }, e.prototype.setLoadingState = function(t) {
            var e;
            r(t, this.loadingState) || (this.loadingState = n({}, t), this.log("Loading state changed", t), null === (e = this._triggerLoadingState) || void 0 === e || e.call(this));
        }, e.prototype.setupRealtime = function(t, e) {
            var n = this, i = t + "sse/environments/" + e + "/stream";
            g ? this.eventSource || (this.log("Creating event source with url " + i), this.eventSource = new g(i), this.eventSource.addEventListener("environment_updated", function(t) {
                var e;
                try {
                    e = JSON.parse(t.data).updated_at;
                } catch (t) {
                    n.log("Could not parse sse event", t);
                }
                e ? !n.timestamp || e > n.timestamp ? n.isLoading ? n.log("updated_at is new, but flags are loading", t.data, n.timestamp) : (n.log("updated_at is new, fetching flags", t.data, n.timestamp), n.getFlags()) : n.log("updated_at is outdated, skipping get flags", t.data, n.timestamp) : n.log("No updated_at received, fetching flags", t);
            })) : this.log("Error, EventSource is undefined");
        }, e;
    }();
    function E(t) {
        var e = t.fetch, n = t.AsyncStorage, i = t.eventSource;
        return new b({
            fetch: e,
            AsyncStorage: n,
            eventSource: i
        });
    }
    var x, O = (x = function(t, e) {
        return x = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }, x(t, e);
    }, function(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
        function n() {
            this.constructor = t;
        }
        x(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
    }), F = function(t) {
        var e = "function" == typeof Symbol && Symbol.iterator, n = e && t[e], i = 0;
        if (n) return n.call(t);
        if (t && "number" == typeof t.length) return {
            next: function() {
                return t && i >= t.length && (t = void 0), {
                    value: t && t[i++],
                    done: !t
                };
            }
        };
        throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }, w = function(t, e) {
        var n = "function" == typeof Symbol && t[Symbol.iterator];
        if (!n) return t;
        var i, a, o = n.call(t), r = [];
        try {
            for(; (void 0 === e || e-- > 0) && !(i = o.next()).done;)r.push(i.value);
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (n = o.return) && n.call(o);
            } finally{
                if (a) throw a.error;
            }
        }
        return r;
    }, I = function(t, e, n) {
        if (n || 2 === arguments.length) for(var i, a = 0, o = e.length; a < o; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
        return t.concat(i || Array.prototype.slice.call(e));
    }, j = function(t) {
        function e() {
            return t.call(this, "EventSource not available.\nConsider loading an EventSource polyfill and making it available globally as EventSource, or passing one in as eventSourceClass to the ReconnectingEventSource constructor.") || this;
        }
        return O(e, t), e;
    }(Error), L = function() {
        function t(t, e) {
            var n = this;
            if (this.CONNECTING = 0, this.OPEN = 1, this.CLOSED = 2, this._configuration = null != e ? Object.assign({}, e) : void 0, this.withCredentials = !1, this._eventSource = null, this._lastEventId = null, this._timer = null, this._listeners = {
                open: [],
                error: [],
                message: []
            }, this.url = t.toString(), this.readyState = this.CONNECTING, this.max_retry_time = 3e3, this.eventSourceClass = globalThis.FlagsmithEventSource, null != this._configuration && (this._configuration.lastEventId && (this._lastEventId = this._configuration.lastEventId, delete this._configuration.lastEventId), this._configuration.max_retry_time && (this.max_retry_time = this._configuration.max_retry_time, delete this._configuration.max_retry_time), this._configuration.eventSourceClass && (this.eventSourceClass = this._configuration.eventSourceClass, delete this._configuration.eventSourceClass)), null == this.eventSourceClass || "function" != typeof this.eventSourceClass) throw new j;
            this._onevent_wrapped = function(t) {
                n._onevent(t);
            }, this._start();
        }
        return t.prototype.dispatchEvent = function(t) {
            throw new Error("Method not implemented.");
        }, t.prototype._start = function() {
            var t, e, n = this, i = this.url;
            this._lastEventId && (-1 === i.indexOf("?") ? i += "?" : i += "&", i += "lastEventId=" + encodeURIComponent(this._lastEventId)), this._eventSource = new this.eventSourceClass(i, this._configuration), this._eventSource.onopen = function(t) {
                n._onopen(t);
            }, this._eventSource.onerror = function(t) {
                n._onerror(t);
            }, this._eventSource.onmessage = function(t) {
                n.onmessage(t);
            };
            try {
                for(var a = F(Object.keys(this._listeners)), o = a.next(); !o.done; o = a.next()){
                    var r = o.value;
                    this._eventSource.addEventListener(r, this._onevent_wrapped);
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    o && !o.done && (e = a.return) && e.call(a);
                } finally{
                    if (t) throw t.error;
                }
            }
        }, t.prototype._onopen = function(t) {
            0 === this.readyState && (this.readyState = 1, this.onopen(t));
        }, t.prototype._onerror = function(t) {
            var e = this;
            if (1 === this.readyState && (this.readyState = 0, this.onerror(t)), this._eventSource) {
                this._eventSource.close(), this._eventSource = null;
                var n = Math.round(this.max_retry_time * Math.random());
                this._timer = setTimeout(function() {
                    return e._start();
                }, n);
            }
        }, t.prototype._onevent = function(t) {
            var e, n;
            t && t.lastEventId && (this._lastEventId = t.lastEventId);
            var i = this._listeners[t.type];
            if (null != i) try {
                for(var a = F(I([], w(i), !1)), o = a.next(); !o.done; o = a.next())o.value.call(this, t);
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    o && !o.done && (n = a.return) && n.call(a);
                } finally{
                    if (e) throw e.error;
                }
            }
            "message" === t.type && this.onmessage(t);
        }, t.prototype.onopen = function(t) {}, t.prototype.onerror = function(t) {}, t.prototype.onmessage = function(t) {}, t.prototype.close = function() {
            this._timer && (clearTimeout(this._timer), this._timer = null), this._eventSource && (this._eventSource.close(), this._eventSource = null), this.readyState = 2;
        }, t.prototype.addEventListener = function(t, e, n) {
            null == this._listeners[t] && (this._listeners[t] = [], null != this._eventSource && this._eventSource.addEventListener(t, this._onevent_wrapped));
            var i = this._listeners[t];
            i.includes(e) || (this._listeners[t] = I(I([], w(i), !1), [
                e
            ], !1));
        }, t.prototype.removeEventListener = function(t, e, n) {
            var i = this._listeners[t];
            this._listeners[t] = i.filter(function(t) {
                return t !== e;
            });
        }, t;
    }();
    globalThis.FlagsmithEventSource = "undefined" != typeof EventSource ? EventSource : null;
    var A = function(t, e) {
        return e = e || {}, new Promise(function(n, i) {
            var a = new XMLHttpRequest, o = [], r = [], s = {}, l = function() {
                return {
                    ok: 2 == (a.status / 100 | 0),
                    statusText: a.statusText,
                    status: a.status,
                    url: a.responseURL,
                    text: function() {
                        return Promise.resolve(a.responseText);
                    },
                    json: function() {
                        return Promise.resolve(a.responseText).then(JSON.parse);
                    },
                    blob: function() {
                        return Promise.resolve(new Blob([
                            a.response
                        ]));
                    },
                    clone: l,
                    headers: {
                        keys: function() {
                            return o;
                        },
                        entries: function() {
                            return r;
                        },
                        get: function(t) {
                            return s[t.toLowerCase()];
                        },
                        has: function(t) {
                            return t.toLowerCase() in s;
                        }
                    }
                };
            };
            for(var u in a.open(e.method || "get", t, !0), a.onload = function() {
                a.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(t, e, n) {
                    o.push(e = e.toLowerCase()), r.push([
                        e,
                        n
                    ]), s[e] = s[e] ? s[e] + "," + n : n;
                }), n(l());
            }, a.onerror = i, a.withCredentials = "include" == e.credentials, e.headers)a.setRequestHeader(u, e.headers[u]);
            a.send(e.body || null);
        });
    }, k = E({
        AsyncStorage: e,
        fetch: A,
        eventSource: L
    });
    "undefined" != typeof window && (window.flagsmith = k);
    t.createFlagsmithInstance = function() {
        return E({
            AsyncStorage: e,
            fetch: A,
            eventSource: L
        });
    }, t.default = k, Object.defineProperty(t, "__esModule", {
        value: !0
    });
});



const $c7286da115ac44e3$var$isString = (obj)=>typeof obj === 'string';
const $c7286da115ac44e3$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $c7286da115ac44e3$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $c7286da115ac44e3$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $c7286da115ac44e3$var$lastOfPathSeparatorRegExp = /###/g;
const $c7286da115ac44e3$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($c7286da115ac44e3$var$lastOfPathSeparatorRegExp, '.') : key;
const $c7286da115ac44e3$var$canNotTraverseDeeper = (object)=>!object || $c7286da115ac44e3$var$isString(object);
const $c7286da115ac44e3$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$c7286da115ac44e3$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($c7286da115ac44e3$var$canNotTraverseDeeper(object)) return {};
        const key = $c7286da115ac44e3$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($c7286da115ac44e3$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $c7286da115ac44e3$var$cleanKey(stack[stackIndex])
    };
};
const $c7286da115ac44e3$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $c7286da115ac44e3$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $c7286da115ac44e3$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $c7286da115ac44e3$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $c7286da115ac44e3$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $c7286da115ac44e3$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $c7286da115ac44e3$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $c7286da115ac44e3$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $c7286da115ac44e3$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $c7286da115ac44e3$var$getPath(data, key);
    if (value !== undefined) return value;
    return $c7286da115ac44e3$var$getPath(defaultData, key);
};
const $c7286da115ac44e3$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($c7286da115ac44e3$var$isString(target[prop]) || target[prop] instanceof String || $c7286da115ac44e3$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $c7286da115ac44e3$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $c7286da115ac44e3$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $c7286da115ac44e3$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $c7286da115ac44e3$var$escape = (data)=>{
    if ($c7286da115ac44e3$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$c7286da115ac44e3$var$_entityMap[s]);
    return data;
};
class $c7286da115ac44e3$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $c7286da115ac44e3$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $c7286da115ac44e3$var$looksLikeObjectPathRegExpCache = new $c7286da115ac44e3$var$RegExpCache(20);
const $c7286da115ac44e3$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $c7286da115ac44e3$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $c7286da115ac44e3$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $c7286da115ac44e3$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $c7286da115ac44e3$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $c7286da115ac44e3$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $c7286da115ac44e3$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $c7286da115ac44e3$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($c7286da115ac44e3$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $c7286da115ac44e3$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $c7286da115ac44e3$var$Logger(this.logger, options);
    }
}
var $c7286da115ac44e3$var$baseLogger = new $c7286da115ac44e3$var$Logger();
class $c7286da115ac44e3$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $c7286da115ac44e3$var$ResourceStore extends $c7286da115ac44e3$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($c7286da115ac44e3$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $c7286da115ac44e3$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$c7286da115ac44e3$var$isString(key)) return result;
        return $c7286da115ac44e3$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $c7286da115ac44e3$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if ($c7286da115ac44e3$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $c7286da115ac44e3$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $c7286da115ac44e3$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $c7286da115ac44e3$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $c7286da115ac44e3$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $c7286da115ac44e3$var$checkedLoadedFor = {};
const $c7286da115ac44e3$var$shouldHandleAsObject = (res)=>!$c7286da115ac44e3$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $c7286da115ac44e3$var$Translator extends $c7286da115ac44e3$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $c7286da115ac44e3$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $c7286da115ac44e3$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key == null) return false;
        const resolved = this.resolve(key, options);
        return resolved?.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$c7286da115ac44e3$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $c7286da115ac44e3$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $c7286da115ac44e3$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys == null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = options.count !== undefined && !$c7286da115ac44e3$var$isString(options.count);
        const hasDefaultValue = $c7286da115ac44e3$var$Translator.hasDefaultValue(options);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
        const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $c7286da115ac44e3$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($c7286da115ac44e3$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...options,
                        defaultValue: $c7286da115ac44e3$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $c7286da115ac44e3$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = $c7286da115ac44e3$var$isString(res) && (options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && !$c7286da115ac44e3$var$isString(options.replace) ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey?.[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = $c7286da115ac44e3$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && options.applyPostProcessor !== false) res = $c7286da115ac44e3$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($c7286da115ac44e3$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && !$c7286da115ac44e3$var$isString(options.count);
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
            const needsContextHandling = options.context !== undefined && ($c7286da115ac44e3$var$isString(options.context) || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$c7286da115ac44e3$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $c7286da115ac44e3$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$c7286da115ac44e3$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $c7286da115ac44e3$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $c7286da115ac44e3$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $c7286da115ac44e3$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $c7286da115ac44e3$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($c7286da115ac44e3$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($c7286da115ac44e3$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($c7286da115ac44e3$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($c7286da115ac44e3$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $c7286da115ac44e3$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $c7286da115ac44e3$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $c7286da115ac44e3$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $c7286da115ac44e3$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const cleanedCode = $c7286da115ac44e3$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $c7286da115ac44e3$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $c7286da115ac44e3$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$c7286da115ac44e3$var$suffixesOrder[pluralCategory1] - $c7286da115ac44e3$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $c7286da115ac44e3$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $c7286da115ac44e3$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $c7286da115ac44e3$var$isString(key)) {
        path = $c7286da115ac44e3$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $c7286da115ac44e3$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $c7286da115ac44e3$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $c7286da115ac44e3$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $c7286da115ac44e3$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $c7286da115ac44e3$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $c7286da115ac44e3$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $c7286da115ac44e3$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $c7286da115ac44e3$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $c7286da115ac44e3$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $c7286da115ac44e3$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $c7286da115ac44e3$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $c7286da115ac44e3$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($c7286da115ac44e3$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$c7286da115ac44e3$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $c7286da115ac44e3$var$regexSafe(this.escape(val)) : $c7286da115ac44e3$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $c7286da115ac44e3$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$c7286da115ac44e3$var$isString(value) && !this.useRawValueToEscape) value = $c7286da115ac44e3$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$c7286da115ac44e3$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$c7286da115ac44e3$var$isString(value)) return value;
            if (!$c7286da115ac44e3$var$isString(value)) value = $c7286da115ac44e3$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $c7286da115ac44e3$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $c7286da115ac44e3$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($c7286da115ac44e3$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $c7286da115ac44e3$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $c7286da115ac44e3$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $c7286da115ac44e3$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $c7286da115ac44e3$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $c7286da115ac44e3$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $c7286da115ac44e3$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $c7286da115ac44e3$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options.interpolation.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $c7286da115ac44e3$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $c7286da115ac44e3$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $c7286da115ac44e3$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $c7286da115ac44e3$var$Connector extends $c7286da115ac44e3$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $c7286da115ac44e3$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $c7286da115ac44e3$var$pushPath(q.loaded, [
                lng
            ], ns);
            $c7286da115ac44e3$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($c7286da115ac44e3$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($c7286da115ac44e3$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $c7286da115ac44e3$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($c7286da115ac44e3$var$isString(args[1])) ret.defaultValue = args[1];
            if ($c7286da115ac44e3$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $c7286da115ac44e3$var$transformOptions = (options)=>{
    if ($c7286da115ac44e3$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($c7286da115ac44e3$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($c7286da115ac44e3$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $c7286da115ac44e3$var$noop = ()=>{};
const $c7286da115ac44e3$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $c7286da115ac44e3$var$I18n extends $c7286da115ac44e3$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $c7286da115ac44e3$var$transformOptions(options);
        this.services = {};
        this.logger = $c7286da115ac44e3$var$baseLogger;
        this.modules = {
            external: []
        };
        $c7286da115ac44e3$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($c7286da115ac44e3$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $c7286da115ac44e3$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$c7286da115ac44e3$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $c7286da115ac44e3$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $c7286da115ac44e3$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $c7286da115ac44e3$var$Formatter;
            const lu = new $c7286da115ac44e3$var$LanguageUtil(this.options);
            this.store = new $c7286da115ac44e3$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $c7286da115ac44e3$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $c7286da115ac44e3$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $c7286da115ac44e3$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $c7286da115ac44e3$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $c7286da115ac44e3$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $c7286da115ac44e3$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $c7286da115ac44e3$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c7286da115ac44e3$var$noop;
        let usedCallback = callback;
        const usedLng = $c7286da115ac44e3$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $c7286da115ac44e3$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $c7286da115ac44e3$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $c7286da115ac44e3$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $c7286da115ac44e3$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = $c7286da115ac44e3$var$isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if ($c7286da115ac44e3$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.translator?.translate(...args);
    }
    exists() {
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $c7286da115ac44e3$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($c7286da115ac44e3$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $c7286da115ac44e3$var$defer();
        if ($c7286da115ac44e3$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $c7286da115ac44e3$var$LanguageUtil($c7286da115ac44e3$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $c7286da115ac44e3$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c7286da115ac44e3$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $c7286da115ac44e3$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                return Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, {});
            }, {});
            clone.store = new $c7286da115ac44e3$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $c7286da115ac44e3$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $c7286da115ac44e3$export$2e2bcd8739ae039 = $c7286da115ac44e3$var$I18n.createInstance();
$c7286da115ac44e3$export$2e2bcd8739ae039.createInstance = $c7286da115ac44e3$var$I18n.createInstance;
const $c7286da115ac44e3$export$99152e8d49ca4e7d = $c7286da115ac44e3$export$2e2bcd8739ae039.createInstance;
const $c7286da115ac44e3$export$147ec2801e896265 = $c7286da115ac44e3$export$2e2bcd8739ae039.dir;
const $c7286da115ac44e3$export$2cd8252107eb640b = $c7286da115ac44e3$export$2e2bcd8739ae039.init;
const $c7286da115ac44e3$export$d3d08d944062d7e = $c7286da115ac44e3$export$2e2bcd8739ae039.loadResources;
const $c7286da115ac44e3$export$a5d9bf5d83fcab09 = $c7286da115ac44e3$export$2e2bcd8739ae039.reloadResources;
const $c7286da115ac44e3$export$1f96ae73734a86cc = $c7286da115ac44e3$export$2e2bcd8739ae039.use;
const $c7286da115ac44e3$export$61465194746e7fd2 = $c7286da115ac44e3$export$2e2bcd8739ae039.changeLanguage;
const $c7286da115ac44e3$export$f90d180fc7da3b3b = $c7286da115ac44e3$export$2e2bcd8739ae039.getFixedT;
const $c7286da115ac44e3$export$625550452a3fa3ec = $c7286da115ac44e3$export$2e2bcd8739ae039.t;
const $c7286da115ac44e3$export$f7e9f41ea797a17 = $c7286da115ac44e3$export$2e2bcd8739ae039.exists;
const $c7286da115ac44e3$export$2b4b218e406d2d00 = $c7286da115ac44e3$export$2e2bcd8739ae039.setDefaultNamespace;
const $c7286da115ac44e3$export$93d9ee97c1ad3f31 = $c7286da115ac44e3$export$2e2bcd8739ae039.hasLoadedNamespace;
const $c7286da115ac44e3$export$83be934b53fff43b = $c7286da115ac44e3$export$2e2bcd8739ae039.loadNamespaces;
const $c7286da115ac44e3$export$8cd7e7a54fa865bc = $c7286da115ac44e3$export$2e2bcd8739ae039.loadLanguages;



const { slice: $9b442ad94df98020$var$slice, forEach: $9b442ad94df98020$var$forEach } = [];
function $9b442ad94df98020$var$defaults(obj) {
    $9b442ad94df98020$var$forEach.call($9b442ad94df98020$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $9b442ad94df98020$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $9b442ad94df98020$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $9b442ad94df98020$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$9b442ad94df98020$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$9b442ad94df98020$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $9b442ad94df98020$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $9b442ad94df98020$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $9b442ad94df98020$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $9b442ad94df98020$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $9b442ad94df98020$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $9b442ad94df98020$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $9b442ad94df98020$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return language[index]?.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $9b442ad94df98020$var$hasLocalStorageSupport = null;
const $9b442ad94df98020$var$localStorageAvailable = ()=>{
    if ($9b442ad94df98020$var$hasLocalStorageSupport !== null) return $9b442ad94df98020$var$hasLocalStorageSupport;
    try {
        $9b442ad94df98020$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$9b442ad94df98020$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $9b442ad94df98020$var$hasLocalStorageSupport = false;
    }
    return $9b442ad94df98020$var$hasLocalStorageSupport;
};
var $9b442ad94df98020$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $9b442ad94df98020$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $9b442ad94df98020$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $9b442ad94df98020$var$hasSessionStorageSupport = null;
const $9b442ad94df98020$var$sessionStorageAvailable = ()=>{
    if ($9b442ad94df98020$var$hasSessionStorageSupport !== null) return $9b442ad94df98020$var$hasSessionStorageSupport;
    try {
        $9b442ad94df98020$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$9b442ad94df98020$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $9b442ad94df98020$var$hasSessionStorageSupport = false;
    }
    return $9b442ad94df98020$var$hasSessionStorageSupport;
};
var $9b442ad94df98020$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $9b442ad94df98020$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $9b442ad94df98020$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $9b442ad94df98020$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $9b442ad94df98020$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $9b442ad94df98020$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $9b442ad94df98020$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $9b442ad94df98020$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $9b442ad94df98020$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $9b442ad94df98020$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$9b442ad94df98020$var$canCookies) $9b442ad94df98020$var$order.splice(1, 1);
const $9b442ad94df98020$var$getDefaults = ()=>({
        order: $9b442ad94df98020$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $9b442ad94df98020$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $9b442ad94df98020$var$defaults(options, this.options || {}, $9b442ad94df98020$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($9b442ad94df98020$var$cookie$1);
        this.addDetector($9b442ad94df98020$var$querystring);
        this.addDetector($9b442ad94df98020$var$localStorage);
        this.addDetector($9b442ad94df98020$var$sessionStorage);
        this.addDetector($9b442ad94df98020$var$navigator$1);
        this.addDetector($9b442ad94df98020$var$htmlTag);
        this.addDetector($9b442ad94df98020$var$path);
        this.addDetector($9b442ad94df98020$var$subdomain);
        this.addDetector($9b442ad94df98020$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$9b442ad94df98020$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$9b442ad94df98020$export$2e2bcd8739ae039.type = 'languageDetector';


const $039cbe47c989266c$var$resources = {
    en: {
        translation: {
            equipmentActionPortalTitle: 'Equipment Action Portal',
            site: 'Site',
            department: 'Department',
            scanQRCode: 'SCAN QR CODE',
            equipmentNumber: 'Equipment Number',
            description: 'Description',
            employeeNumber: 'Employee Number',
            selectServiceArea: 'Select Service Area',
            selectServiceAction: 'Select Service Action',
            comment: 'Comment',
            cancel: 'CANCEL',
            continue: 'CONTINUE',
            submit: 'SUBMIT',
            notSelected: 'Not Selected',
            successTitle: 'Success!',
            scannedValue: 'Scanned value',
            okButton: 'OK',
            maintenance: 'Maintenance',
            quality: 'Quality',
            departmentManager: 'Department Manager',
            machineDown: 'Machine Down',
            lineDown: 'Line Down',
            plannedRepair: 'Planned Repair (<5 hrs)',
            default: 'Default',
            describeProblem: 'Describe Problem',
            describeProblemInstructions: 'Responding to the questions below is <b>required</b>. They help us to generate better diagnosis and troubleshooting suggestions.',
            yesButton: 'Yes',
            noButton: 'No',
            dontKnowButton: "I Don't Know",
            submitWorkOrder: 'Submit Work Order',
            closeRequest: 'Close Request',
            additionalDetails: 'Additional Details',
            refetchQuestions: 'Refetch Questions',
            selectClosureReasonTitle: 'Select Closure Reason',
            selectClosureReasonParagraph: 'Please select a reason for closing this request.',
            reasonLabel: 'Reason',
            reasonFixedProblem: 'I fixed the problem',
            reasonTrainingTesting: 'I was training/testing',
            reasonOther: 'Other',
            location: 'Location',
            costCenter: 'Cost Center',
            errorTitle: 'Error!',
            warningTitle: 'Warning!',
            followUpQuestionsErrorContent: 'An error occurred fetching follow-up questions. You can still submit a work order by clicking "Submit Work Order" or you can try fetching questions again by clicking "Refetch Questions". Error details: {{error}}',
            aiSummaryErrorContent: 'An error occurred creating the AI-generated work order summary. Click OK to submit the work order without the AI-generated summary. Error details: "{{error}}"',
            closeRequestErrorContent: 'An error occurred closing the request: {{error}}',
            conversationErrorContent: 'An error occurred generating follow-up questions. You can still submit your work order directly, or cancel to try again. Error details: {{error}}',
            equipmentNotFoundContent: 'Equipment Not Found!',
            downtimeEventStartedContent: '{{serviceArea}} {{serviceAction}} Event was started!',
            downtimeStartErrorContent: 'An error occurred starting Downtime Event! {{error}}',
            equipmentMustBeSelectedContent: 'Equipment Must be Selected!',
            downtimeEventMustBeSelectedContent: 'Downtime Event must be selected!',
            qualityEventSentContent: 'Quality Downtime Event was sent!',
            deptManagerSelectedContent: 'Dept Manager Selected!',
            infoTitle: 'Info!',
            // Menu bar translations
            selectLanguage: 'Select Language',
            provideFeedback: 'Provide Feedback',
            requestAccess: 'Request Access',
            thriveStatus: 'Thrive Status',
            myProfile: 'My Profile',
            // Language modal translations
            selectDesiredLanguage: 'Select Desired Language',
            closeButton: 'Close',
            savePreferences: 'Save Preferences',
            languageEnglish: 'ENGLISH',
            languageSpanish: 'SPANISH',
            loading: 'Loading',
            saving: 'Saving',
            addAdditionalDetails: 'Add Additional Details'
        }
    },
    es: {
        translation: {
            equipmentActionPortalTitle: 'Portal de Acciones de Equipos',
            site: 'Sitio',
            department: 'Departamento',
            scanQRCode: "ESCANEAR C\xd3DIGO QR",
            equipmentNumber: "N\xfamero de equipo",
            description: "Descripci\xf3n",
            employeeNumber: "N\xfamero de empleado",
            selectServiceArea: "Seleccione \xe1rea de servicio",
            selectServiceAction: "Seleccione acci\xf3n de servicio",
            comment: 'Comentario',
            cancel: 'CANCELAR',
            continue: 'CONTINUAR',
            submit: 'ENVIAR',
            notSelected: 'No Seleccionado',
            successTitle: "\xa1\xc9xito!",
            scannedValue: 'Valor escaneado',
            okButton: 'ACEPTAR',
            maintenance: 'Mantenimiento',
            quality: 'Calidad',
            departmentManager: 'Gerente de Departamento',
            machineDown: "M\xe1quina Parada",
            lineDown: "L\xednea Parada",
            plannedRepair: "Reparaci\xf3n Planificada (<5 h)",
            default: 'Por defecto',
            describeProblem: 'Describa el problema',
            describeProblemInstructions: "Responder a las preguntas a continuaci\xf3n es <b>obligatorio</b>. Nos ayudan a generar mejores diagn\xf3sticos y sugerencias para la resoluci\xf3n de problemas.",
            yesButton: "S\xed",
            noButton: 'No',
            dontKnowButton: "No lo s\xe9",
            submitWorkOrder: 'Enviar Orden de Trabajo',
            closeRequest: 'Cerrar Solicitud',
            additionalDetails: 'Detalles adicionales',
            refetchQuestions: 'Recargar preguntas',
            selectClosureReasonTitle: 'Seleccionar motivo de cierre',
            selectClosureReasonParagraph: 'Seleccione un motivo para cerrar esta solicitud.',
            reasonLabel: 'Motivo',
            reasonFixedProblem: 'He solucionado el problema',
            reasonTrainingTesting: 'Estaba en entrenamiento/pruebas',
            reasonOther: 'Otro',
            location: "Ubicaci\xf3n",
            costCenter: 'Centro de Costos',
            errorTitle: "\xa1Error!",
            warningTitle: "\xa1Advertencia!",
            followUpQuestionsErrorContent: 'Ocurri\xf3 un error al obtener las preguntas de seguimiento. A\xfan puede enviar la orden de trabajo haciendo clic en "Enviar Orden de Trabajo" o puede intentar recargar las preguntas haciendo clic en "Recargar preguntas". Detalles del error: {{error}}',
            aiSummaryErrorContent: 'Ocurri\xf3 un error al crear el resumen de la orden de trabajo generado por IA. Haga clic en Aceptar para enviar la orden de trabajo sin el resumen generado por IA. Detalles del error: "{{error}}"',
            closeRequestErrorContent: "Ocurri\xf3 un error al cerrar la solicitud: {{error}}",
            conversationErrorContent: "Ocurri\xf3 un error al generar las preguntas de seguimiento. A\xfan puede enviar la orden de trabajo directamente, o cancelar para intentarlo de nuevo. Detalles del error: {{error}}",
            equipmentNotFoundContent: "\xa1Equipo no encontrado!",
            downtimeEventStartedContent: "\xa1El evento de {{serviceArea}} {{serviceAction}} ha sido iniciado!",
            downtimeStartErrorContent: "Ocurri\xf3 un error al iniciar el evento de inactividad! {{error}}",
            equipmentMustBeSelectedContent: "\xa1El equipo debe seleccionarse!",
            downtimeEventMustBeSelectedContent: "\xa1El evento de inactividad debe seleccionarse!",
            qualityEventSentContent: "\xa1El evento de inactividad de Calidad fue enviado!",
            deptManagerSelectedContent: "\xa1Gerente de Departamento seleccionado!",
            infoTitle: "\xa1Informaci\xf3n!",
            // Menu bar translations
            selectLanguage: 'Seleccionar Idioma',
            provideFeedback: 'Proporcionar Comentarios',
            requestAccess: 'Solicitar Acceso',
            thriveStatus: 'Estado Thrive',
            myProfile: 'Mi Perfil',
            // Language modal translations
            selectDesiredLanguage: 'Seleccionar Idioma Deseado',
            closeButton: 'Cerrar',
            savePreferences: 'Guardar Preferencias',
            languageEnglish: "INGL\xc9S",
            languageSpanish: "ESPA\xd1OL",
            loading: 'Cargando',
            saving: 'Guardando',
            addAdditionalDetails: "A\xf1adir Detalles Adicionales"
        }
    }
};
(0, $c7286da115ac44e3$export$1f96ae73734a86cc)((0, $9b442ad94df98020$export$2e2bcd8739ae039));
(0, $c7286da115ac44e3$export$1f96ae73734a86cc)((0, $9044861fa4d3684d$export$ae7e14d40d89f296));
(0, $c7286da115ac44e3$export$2cd8252107eb640b)({
    resources: $039cbe47c989266c$var$resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
        escapeValue: false
    },
    detection: {
        order: [
            'sessionStorage',
            'navigator'
        ],
        lookupSessionStorage: 'i18nextLng',
        caches: [
            'sessionStorage'
        ]
    }
});
var // eslint-disable-next-line unicorn/prefer-export-from
$039cbe47c989266c$export$2e2bcd8739ae039 = (0, $c7286da115ac44e3$export$2e2bcd8739ae039);



// Initialize the MUI license key for the DataGrid component
(0, $acf61fefb9f9f42e$export$2c56d2e2ae515eeb).setLicenseKey(globalThis.REACT_APP_DATAGRID_KEY);
const $72d27130f067ddd4$var$queryClient = new (0, $86b52fa644445c39$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            retry: 0
        }
    },
    queryCache: new (0, $506bf7d9ee50a8df$export$5dde0cd941da8468)({
        onError: (error)=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(error.message);
        }
    }),
    mutationCache: new (0, $154bcf165b6632e7$export$1fcfd9a244434844)({
        onError: (error)=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(error.message);
        }
    })
});
/**
 * Structure taken straight from the Okta React React Router v6 sample
 * https://github.com/okta/okta-react/blob/master/samples/routing/react-router-dom-v6/src/App.tsx
 */ const $72d27130f067ddd4$var$App = ()=>{
    const navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    const restoreOriginalUri = (_oktaAuth, originalUri)=>{
        navigate((0, $dbbfea4bd9ff1bad$exports.toRelativeUrl)(originalUri || '/', window.location.origin));
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $954b04773eb0508c$export$9fb697de7778c436), {
        oktaAuth: (0, $69cb03e609be8e5e$export$219078e38253958),
        restoreOriginalUri: restoreOriginalUri,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fda7e4dd83174a6e$export$248fcaff50e7b757), {
            options: {
                evaluationContext: {
                    environment: {
                        apiKey: window.REACT_APP_FLAGSMITH_ENVIRONMENT_API_KEY
                    }
                }
            },
            flagsmith: (0, (/*@__PURE__*/$parcel$interopDefault($3abeb720825c68d9$exports))),
            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4de3c1cf98001c88$export$1325e8699caa160f), {
                i18n: (0, $039cbe47c989266c$export$2e2bcd8739ae039),
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $427d8fa9df978c82$export$45604f0cc8ae667b), {
                    client: $72d27130f067ddd4$var$queryClient,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1dff1e305d0081d2$export$434374b2a40d237), {
                            appName: (0, $69cb03e609be8e5e$export$a002182e51710d39).AppName,
                            baseURL: window.REACT_APP_API_URL,
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $78b54bd991d76db4$export$52bd0fb4a235289d), {
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7a02df305370e935$export$2e2bcd8739ae039), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3cb117183d17b3f1$export$fd1469cb3147d866), {
                            initialIsOpen: false
                        })
                    ]
                })
            })
        })
    });
};
var $72d27130f067ddd4$export$2e2bcd8739ae039 = $72d27130f067ddd4$var$App;




var $lCzvA = parcelRequire("lCzvA");
const $97103e9802631cd9$var$container = document.querySelector('#app');
// @ts-ignore - This is a workaround for TypeScript not recognizing the `#app` element
const $97103e9802631cd9$var$root = (0, $2aa82faa573d5f31$exports.createRoot)($97103e9802631cd9$var$container);
$97103e9802631cd9$var$root.render(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $lCzvA.StrictMode), {
    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c3aca08c2a74646e$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $72d27130f067ddd4$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=app.462a9f60.js.map
